/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1550);
	__webpack_require__(1068);
	module.exports = __webpack_require__(1435);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(206);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2075)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(681));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var Stylis = _interopDefault(__webpack_require__(2539));
	var _insertRulePlugin = _interopDefault(__webpack_require__(2538));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var hoistStatics = _interopDefault(__webpack_require__(2537));
	var reactIs = __webpack_require__(291);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var a = args[0];
	  var b = [];
	  var c = void 0;
	
	  for (c = 1; c < args.length; c += 1) {
	    b.push(args[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      interpolations[_key2 - 1] = arguments[_key2];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	
	var objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
	    return hyphenate(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
	      return ruleSet;
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      ruleSet.push('.' + chunk.styledComponentId);
	      return ruleSet;
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      if (executionContext) {
	        var nextChunk = chunk(executionContext);
	        /* Throw if a React Element was given styles */
	        if (React__default.isValidElement(nextChunk)) {
	          var elementName = chunk.displayName || chunk.name;
	          throw new StyledComponentsError(11, elementName);
	        }
	        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
	      } else ruleSet.push(chunk);
	
	      return ruleSet;
	    }
	
	    /* Handle objects */
	    ruleSet.push(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
	
	    return ruleSet;
	  }, []);
	};
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	stylis.use([parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	// 
	
	function isStyledComponent(target) /* : %checks */{
	  return (
	    // $FlowFixMe TODO: flow for styledComponentId
	    typeof target === 'function' && typeof target.styledComponentId === 'string'
	  );
	}
	
	// 
	
	/* This function is DEPRECATED and will be removed on the next major version release.
	 * It was needed to rehydrate all style blocks prepended to chunks before React
	 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
	 * the use of streamed style tags and will perform the rehydration earlier when needed
	 * this function will not be needed anymore */
	function consolidateStreamedStyles() {
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
	  }
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	};
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	
	var css = (function (styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (typeof styles === 'function' || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	});
	
	// 
	
	
	var SC_ATTR = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_AC_TKN":"f218eb621f0c68f1c7e01ba9c48691bff09ec7b9","REACT_APP_API_URL":"https://be-production-itb.marketgames.io/api/","REACT_APP_GOOGLE_MERCHANT_ID":"1231232131","REACT_APP_HIDE_NOT_FINISHED_PART":"true"}).SC_ATTR || 'data-styled-components';
	var SC_STREAM_ATTR = 'data-styled-streamed';
	var CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || ("production") !== 'production';
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = document.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = document.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var el = document.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(document.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker);
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(id) {
	  return document.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTagInternal(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeServerTag = function makeServerTag() {
	  return makeServerTagInternal();
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	/* wraps a given tag so that rehydration is performed once when necessary */
	var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
	  /* rehydration function that adds all rules to the new tag */
	  var rehydrate = once(function () {
	    /* add all extracted components to the new tag */
	    for (var i = 0, len = extracted.length; i < len; i += 1) {
	      var _extracted$i = extracted[i],
	          componentId = _extracted$i.componentId,
	          cssFromDOM = _extracted$i.cssFromDOM;
	
	      var cssRules = splitByRules(cssFromDOM);
	      tag.insertRules(componentId, cssRules);
	    }
	
	    /* remove old HTMLStyleElements, since they have been rehydrated */
	    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	      var el = els[_i];
	      if (el.parentNode) {
	        el.parentNode.removeChild(el);
	      }
	    }
	  });
	
	  if (immediateRehydration) rehydrate();
	
	  return _extends({}, tag, {
	    /* add rehydration hook to insertion methods */
	    insertMarker: function insertMarker(id) {
	      rehydrate();
	      return tag.insertMarker(id);
	    },
	    insertRules: function insertRules(id, cssRules, name) {
	      rehydrate();
	      return tag.insertRules(id, cssRules, name);
	    }
	  });
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	  /* a map from ids to tags */
	  /* deferred rules for a given id */
	  /* this is used for not reinjecting rules via hasNameForId() */
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	  /* a list of tags belonging to this StyleSheet */
	  /* a tag for import rules */
	  /* current capacity until a new tag must be created */
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate() {
	    if (!IS_BROWSER || this.forceServer) {
	      return this;
	    }
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (nodesSize === 0) {
	      return this;
	    }
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      // $FlowFixMe: We can trust that all elements in this query are style elements
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0; j < elNamesSize; j += 1) {
	        var name = elNames[j];
	        /* add rehydrated name to sheet to avoid readding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (extractedSize === 0) {
	      return this;
	    }
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(rehydrationTag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = rehydrationTag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for injectGlobal to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	var _StyleSheetManager$ch;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    classCallCheck(this, StyleSheetManager);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
	  };
	
	  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.sheet) {
	      this.sheetInstance = this.props.sheet;
	    } else if (this.props.target) {
	      this.sheetInstance = new StyleSheet(this.props.target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return React__default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.closed = false;
	  }
	
	  ServerStyleSheet.prototype.complete = function complete() {
	    if (!this.closed) {
	      /* Remove closed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.closed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.complete();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.complete();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        /* prepend style html to chunk */
	        this.push(html + chunk);
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.complete();
	    });
	    readableStream.on('error', function (err) {
	      _this.complete();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	
	// 
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	
	// 
	
	function generateDisplayName(target) {
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	// 
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 * */
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var validAttr = (function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	});
	
	// 
	
	function hasInInheritanceChain(child, parent) {
	  var target = child;
	
	  while (target) {
	    target = Object.getPrototypeOf(target);
	
	    if (target && target === parent) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// 
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var listener = listeners[key];
	      if (listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	var _contextShape, _ThemeProvider$contex;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = PropTypes.shape({
	  getTheme: PropTypes.func,
	  subscribe: PropTypes.func,
	  unsubscribe: PropTypes.func
	});
	
	var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = PropTypes.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	
	        if (_this2.broadcast !== undefined) {
	          _this2.publish(_this2.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _babelHelpers$extends;
	
	    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _babelHelpers$extends));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.publish = function publish(theme) {
	    this.broadcast.publish(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextShape;
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	var _babelHelpers$extends;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	};
	
	var warnExtendDeprecated = function warnExtendDeprecated() {};
	if (false) {
	  warnExtendDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
	  });
	}
	
	// $FlowFixMe
	
	var BaseStyledComponent = function (_Component) {
	  inherits(BaseStyledComponent, _Component);
	
	  function BaseStyledComponent() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, BaseStyledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	      theme: null,
	      generatedClassName: ''
	    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	    if (this.unsubscribeId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	    }
	  };
	
	  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	    var attrs = this.constructor.attrs;
	
	    var context = _extends({}, props, { theme: theme });
	    if (attrs === undefined) {
	      return context;
	    }
	
	    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	      var attr = attrs[key];
	
	      // eslint-disable-next-line no-param-reassign
	      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, React.Component) ? attr(context) : attr;
	      return acc;
	    }, {});
	
	    return _extends({}, context, this.attrs);
	  };
	
	  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _constructor = this.constructor,
	        attrs = _constructor.attrs,
	        componentStyle = _constructor.componentStyle,
	        warnTooManyClasses = _constructor.warnTooManyClasses;
	
	    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	    if (componentStyle.isStatic && attrs === undefined) {
	      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	    } else {
	      var executionContext = this.buildExecutionContext(theme, props);
	      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	      if (false) {
	        warnTooManyClasses(className);
	      }
	
	      return className;
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var componentStyle = this.constructor.componentStyle;
	
	    var styledContext = this.context[CHANNEL_NEXT];
	
	    // If this is a statically-styled component, we don't need to the theme
	    // to generate or build styles.
	    if (componentStyle.isStatic) {
	      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	      this.setState({ generatedClassName: generatedClassName });
	      // If there is a theme in the context, subscribe to the event emitter. This
	      // is necessary due to pure components blocking context updates, this circumvents
	      // that by updating when an event is emitted
	    } else if (styledContext !== undefined) {
	      var subscribe = styledContext.subscribe;
	
	      this.unsubscribeId = subscribe(function (nextTheme) {
	        // This will be called once immediately
	        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
	
	        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	      });
	    } else {
	      // eslint-disable-next-line react/prop-types
	      var theme = this.props.theme || EMPTY_OBJECT;
	      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
	      this.setState({ theme: theme, generatedClassName: _generatedClassName });
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    // If this is a statically-styled component, we don't need to listen to
	    // props changes to update styles
	    var componentStyle = this.constructor.componentStyle;
	
	    if (componentStyle.isStatic) {
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
	      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	      return { theme: theme, generatedClassName: generatedClassName };
	    });
	  };
	
	  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribeFromContext();
	  };
	
	  BaseStyledComponent.prototype.render = function render() {
	    // eslint-disable-next-line react/prop-types
	    var innerRef = this.props.innerRef;
	    var generatedClassName = this.state.generatedClassName;
	    var _constructor2 = this.constructor,
	        styledComponentId = _constructor2.styledComponentId,
	        target = _constructor2.target;
	
	
	    var isTargetTag = isTag(target);
	
	    var className = [
	    // eslint-disable-next-line react/prop-types
	    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	    var baseProps = _extends({}, this.attrs, {
	      className: className
	    });
	
	    if (isStyledComponent(target)) {
	      baseProps.innerRef = innerRef;
	    } else {
	      baseProps.ref = innerRef;
	    }
	
	    var propsForElement = baseProps;
	    var key = void 0;
	
	    for (key in this.props) {
	      // Don't pass through non HTML tags through to HTML elements
	      // always omit innerRef
	      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
	        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
	      }
	    }
	
	    return React.createElement(target, propsForElement);
	  };
	
	  return BaseStyledComponent;
	}(React.Component);
	
	var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _options$isClass = options.isClass,
	        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
	        _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        classCallCheck(this, StyledComponent);
	        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get$$1() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);
	
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          warnExtendDeprecated();
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.contextTypes = modifiedContextShape;
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.target = target;
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	    }
	
	    if (isClass) {
	      hoistStatics(StyledComponent, target, {
	        // all SC-specific things should not be hoisted
	        attrs: true,
	        componentStyle: true,
	        displayName: true,
	        extend: true,
	        styledComponentId: true,
	        target: true,
	        warnTooManyClasses: true,
	        withComponent: true
	      });
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	});
	
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(str) {
	  var l = str.length | 0,
	      h = l | 0,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	// 
	
	var areStylesCacheable = IS_BROWSER;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0, len = rules.length; i < len; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      if (typeof attrs[key] === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHMREnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
	  /* combines hashStr (murmurhash) and nameGenerator for convenience */
	  var generateRuleHash = function generateRuleHash(str) {
	    return nameGenerator(murmurhash(str));
	  };
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	
	      if (!StyleSheet.master.hasId(componentId)) {
	        var placeholder =  false ? ['.' + componentId + ' {}'] : [];
	
	        StyleSheet.master.deferredInject(componentId, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          componentId = this.componentId,
	          lastClassName = this.lastClassName;
	
	      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var name = generateRuleHash(this.componentId + flatCSS.join(''));
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
	      }
	
	      this.lastClassName = name;
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return generateRuleHash(str);
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	});
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var _styled = (function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  domElements.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	});
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	var _keyframes = (function (nameGenerator, stringifyRules, css) {
	  return function () {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	    var id = 'sc-keyframes-' + name;
	
	    if (!styleSheet.hasNameForId(id, name)) {
	      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
	    }
	
	    return name;
	  };
	});
	
	// 
	
	var _injectGlobal = (function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal() {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var hash = murmurhash(JSON.stringify(rules));
	    var id = 'sc-global-' + hash;
	
	    if (!styleSheet.hasId(id)) {
	      styleSheet.inject(id, stringifyRules(rules));
	    }
	  };
	
	  return injectGlobal;
	});
	
	// 
	
	var _constructWithOptions = (function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	    if (!reactIs.isValidElementType(tag)) {
	      throw new StyledComponentsError(1, String(tag));
	    }
	
	    /* This is callable directly as a template function */
	    // $FlowFixMe: Not typed to avoid destructuring arguments
	    var templateFunction = function templateFunction() {
	      return componentConstructor(tag, options, css.apply(undefined, arguments));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	});
	
	// 
	
	var withTheme = (function (Component) {
	  var isStatelessFunctionalComponent = typeof Component === 'function' &&
	  // $FlowFixMe TODO: flow for prototype
	  !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  // NOTE: We can't pass a ref to a stateless functional component
	  var shouldSetInnerRef = isStyledComponent(Component) || isStatelessFunctionalComponent;
	
	  var WithTheme = function (_React$Component) {
	    inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	      var themeProp = determineTheme(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      var props = _extends({
	        theme: this.state.theme
	      }, this.props);
	
	      if (!shouldSetInnerRef) {
	        props.ref = props.innerRef;
	        delete props.innerRef;
	      }
	
	      return React__default.createElement(Component, props);
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.contextTypes = contextShape;
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	  WithTheme.styledComponentId = 'withTheme';
	
	
	  return hoistStatics(WithTheme, Component);
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	/* Instantiate singletons */
	var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
	var constructWithOptions = _constructWithOptions(css);
	var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
	var injectGlobal = _injectGlobal(stringifyRules, css);
	var styled = _styled(StyledComponent, constructWithOptions);
	
	exports.default = styled;
	exports.css = css;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.isStyledComponent = isStyledComponent;
	exports.consolidateStreamedStyles = consolidateStreamedStyles;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetManager = StyleSheetManager;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236), __webpack_require__(136)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.allowAutoplay = exports.deleteRequest = exports.patchRequest = exports.putRequest = exports.loginRequest = exports.postRequest = exports.batchRequest = exports.downloadRequest = exports.getRequest = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _superagent = __webpack_require__(298);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactjsLocalstorage = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ApiService = function () {
	  function ApiService() {
	    _classCallCheck(this, ApiService);
	  }
	
	  _createClass(ApiService, [{
	    key: "allowAutoplay",
	    value: function allowAutoplay() {
	      if (ApiService.isFirstLogin !== null) {
	        return ApiService.isFirstLogin;
	      }
	
	      var is_first_login = _reactjsLocalstorage.reactLocalStorage.get("isFirstLogin", false);
	
	      if (is_first_login === false) {
	        _reactjsLocalstorage.reactLocalStorage.set("isFirstLogin", true);
	      }
	
	      if (ApiService.isFirstLogin === null) {
	        ApiService.isFirstLogin = !is_first_login;
	      }
	
	      return ApiService.isFirstLogin;
	    }
	  }, {
	    key: "getRequest",
	    value: function getRequest(url, okCallback) {
	      var token = _Auth2.default.getToken();
	
	      var r = _superagent2.default.get(url).set("Accept", "application/json");
	
	      if (token) {
	        r = r.set("Authorization", "Token " + token);
	      }
	
	      if (okCallback) {
	        r = r.ok(okCallback);
	      }
	
	      return r;
	    }
	  }, {
	    key: "downloadRequest",
	    value: function downloadRequest(url, contentType) {
	      return fetch(url, {
	        headers: {
	          'Content-Type': contentType
	        }
	      });
	    }
	  }, {
	    key: "batchRequest",
	    value: function batchRequest(urls) {
	      return Promise.all(urls.map(function (url) {
	        return ApiService.prototype.getRequest(url);
	      }));
	    }
	  }, {
	    key: "postRequest",
	    value: function postRequest(url) {
	      var token = _Auth2.default.getToken();
	
	      var r = _superagent2.default.post(url).set("Accept", "application/json");
	
	      if (token) {
	        r = r.set("Authorization", "Token " + token);
	      }
	
	      return r;
	    }
	  }, {
	    key: "loginRequest",
	    value: function loginRequest(data) {
	      return _superagent2.default.post(("https://be-production-itb.marketgames.io/api/") + "api-token-auth/").set("Accept", "application/json").send(data);
	    }
	  }, {
	    key: "putRequest",
	    value: function putRequest(url) {
	      var token = _Auth2.default.getToken();
	
	      var r = _superagent2.default.put(url).set("Accept", "application/json").set("Authorization", "Token " + token);
	
	      return r;
	    }
	  }, {
	    key: "patchRequest",
	    value: function patchRequest(url) {
	      var token = _Auth2.default.getToken();
	
	      var r = _superagent2.default.patch(url).set("Accept", "application/json").set("Authorization", "Token " + token);
	
	      return r;
	    }
	  }, {
	    key: "deleteRequest",
	    value: function deleteRequest(url) {
	      var token = _Auth2.default.getToken();
	
	      var r = _superagent2.default.del(url).set("Accept", "application/json").set("Authorization", "Token " + token);
	
	      return r;
	    }
	  }]);
	
	  return ApiService;
	}();
	
	ApiService.isFirstLogin = null;
	
	var getRequest = exports.getRequest = ApiService.prototype.getRequest;
	var downloadRequest = exports.downloadRequest = ApiService.prototype.downloadRequest;
	var batchRequest = exports.batchRequest = ApiService.prototype.batchRequest;
	var postRequest = exports.postRequest = ApiService.prototype.postRequest;
	var loginRequest = exports.loginRequest = ApiService.prototype.loginRequest;
	var putRequest = exports.putRequest = ApiService.prototype.putRequest;
	var patchRequest = exports.patchRequest = ApiService.prototype.patchRequest;
	var deleteRequest = exports.deleteRequest = ApiService.prototype.deleteRequest;
	var allowAutoplay = exports.allowAutoplay = ApiService.prototype.allowAutoplay;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(2065)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Auth = function () {
	  function Auth() {
	    _classCallCheck(this, Auth);
	  }
	
	  _createClass(Auth, null, [{
	    key: "authenticateUser",
	
	
	    /**
	     * Authenticate a user. Save a token string in Local Storage
	     *
	     * @param {string} token
	     */
	    value: function authenticateUser(token, user_id, position, game_id, course_id) {
	      sessionStorage.setItem("token", token);
	      sessionStorage.setItem("user_id", user_id);
	      sessionStorage.setItem("position", position);
	      sessionStorage.setItem("game_id", game_id);
	      sessionStorage.setItem("course_id", course_id);
	
	      if (window && window.Appcues && Auth._appcuesIdentified === false) {
	        window.Appcues.identify(user_id);
	        Auth._appcuesIdentified = true;
	      }
	    }
	
	    /**
	     * Check if a user is authenticated - check if a token is saved in Local Storage
	     *
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isUserAuthenticated",
	    value: function isUserAuthenticated() {
	      return sessionStorage.getItem("token") !== null && sessionStorage.getItem("user_id") !== null && sessionStorage.getItem("position") !== null && sessionStorage.getItem("game_id") !== null && sessionStorage.getItem("course_id") !== null && localStorage.getItem("players_data") !== null && localStorage.getItem("teams_data") !== null;
	    }
	  }, {
	    key: "setPlayerRoles",
	    value: function setPlayerRoles(roles) {
	      sessionStorage.setItem("player_roles", JSON.stringify(roles));
	    }
	  }, {
	    key: "getPlayerRoles",
	    value: function getPlayerRoles(roles) {
	      return JSON.parse(sessionStorage.getItem("player_roles", "[]"));
	    }
	
	    /**
	     * Deauthenticate a user. Remove a token from Local Storage.
	     */
	
	  }, {
	    key: "deauthenticateUser",
	    value: function deauthenticateUser() {
	      if (Auth.isAnyInstructor()) {
	        sessionStorage.removeItem("team_id");
	      }
	      sessionStorage.removeItem("token");
	      sessionStorage.removeItem("user_id");
	      sessionStorage.removeItem("position");
	      sessionStorage.removeItem("game_id");
	      sessionStorage.removeItem("course_id");
	      sessionStorage.removeItem("player_roles");
	      localStorage.removeItem("finance-unaccepted-decisions");
	      localStorage.removeItem("development-unaccepted-decisions");
	      localStorage.removeItem("marketing-unaccepted-decisions");
	      localStorage.removeItem("operations-unaccepted-decisions");
	      localStorage.removeItem("players_data");
	      localStorage.removeItem("teams_data");
	      Auth._user = null;
	      Auth._appcuesIdentified = false;
	      (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	    }
	
	    /**
	     * Get menu state
	     *
	     * @return {bool}
	     */
	
	  }, {
	    key: "getMenuState",
	    value: function getMenuState() {
	      var menuState = localStorage.getItem('menu_state');
	      if (typeof menuState === 'string') {
	        if (menuState === 'true') {
	          menuState = true;
	        } else if (menuState === 'false') {
	          menuState = false;
	        } else {
	          menuState = null;
	        }
	      }
	
	      return menuState === null || typeof menuState === 'undefined' ? true : menuState;
	    }
	
	    /**
	     * Set menu state
	     */
	
	  }, {
	    key: "setMenuState",
	    value: function setMenuState(value) {
	      localStorage.setItem('menu_state', value);
	    }
	
	    /**
	     * Get a token value.
	     *
	     * @return {string}
	     */
	
	  }, {
	    key: "getToken",
	    value: function getToken() {
	      return sessionStorage.getItem("token");
	    }
	
	    /**
	     * Set a token value.
	     */
	
	  }, {
	    key: "setToken",
	    value: function setToken(value) {
	      sessionStorage.setItem("token", value);
	    }
	
	    /**
	     * Get a user_id value.
	     *
	     * @return {integer}
	     */
	
	  }, {
	    key: "getUserId",
	    value: function getUserId() {
	      return sessionStorage.getItem("user_id");
	    }
	
	    /**
	     * Set a user_id value.
	     */
	
	  }, {
	    key: "setUserId",
	    value: function setUserId(value) {
	      sessionStorage.setItem("user_id", value);
	
	      if (window && window.Appcues && Auth._appcuesIdentified === false) {
	        window.Appcues.identify(value);
	        Auth._appcuesIdentified = true;
	      }
	    }
	
	    /**
	     * Get user role.
	     *
	     * @return {string}
	     */
	
	  }, {
	    key: "getRole",
	    value: function getRole() {
	      var playerRoles = Auth.getPlayerRoles();
	      var userId = Number(Auth.getUserId());
	      var player = playerRoles ? playerRoles.find(function (i) {
	        return Number(i.user.id) === userId;
	      }) : null;
	
	      return player ? player.role.toUpperCase() : Auth._user ? Auth._user.role : '';
	    }
	
	    /**
	     * Set temporary user
	     */
	
	  }, {
	    key: "setTemporaryUser",
	    value: function setTemporaryUser(data) {
	      sessionStorage.setItem("temporary_user", JSON.stringify(data));
	    }
	
	    /**
	     * Get temporary user
	     *
	     * @return {object|null}
	     */
	
	  }, {
	    key: "getTemporaryUser",
	    value: function getTemporaryUser() {
	      try {
	        return JSON.parse(sessionStorage.getItem("temporary_user"));
	      } catch (err) {
	        return null;
	      }
	    }
	
	    /**
	     * Get user team.
	     *
	     * @return {integer}
	     */
	
	  }, {
	    key: "getTeamId",
	    value: function getTeamId() {
	      var teamId = Auth._user ? Auth._user.team : null;
	      var teamId2 = parseInt(sessionStorage.getItem("team_id"), 10);
	
	      return teamId ? teamId : isNaN(teamId2) ? 0 : teamId2;
	    }
	
	    /**
	     * Set a team id value.
	     */
	
	  }, {
	    key: "setTeamId",
	    value: function setTeamId(value) {
	      sessionStorage.setItem("team_id", value);
	    }
	
	    /**
	     * Get a position of the user
	     *
	     * @return {string}
	     */
	
	  }, {
	    key: "getPosition",
	    value: function getPosition() {
	      return sessionStorage.getItem("position");
	    }
	
	    /**
	     * Set a position value.
	     */
	
	  }, {
	    key: "setPosition",
	    value: function setPosition(value) {
	      sessionStorage.setItem("position", value);
	    }
	
	    /**
	     * True when the logged-in user is a Co-Instructor (INS2). BE returns
	     * the position string "Co-Instructor" verbatim. Co-Instructors have
	     * most instructor writes, scoped to their own sections for deletes
	     * and badge batch actions.
	     */
	
	  }, {
	    key: "isCoInstructor",
	    value: function isCoInstructor() {
	      return Auth.getPosition() === "Co-Instructor";
	    }
	
	    /**
	     * True when the logged-in user is an Instructor Assistant (IAS).
	     * BE returns the position string "Instructor Assistant" verbatim.
	     * IAS is view-only everywhere except PATCH /v2/games/teamplayers/.
	     */
	
	  }, {
	    key: "isInstructorAssistant",
	    value: function isInstructorAssistant() {
	      return Auth.getPosition() === "Instructor Assistant";
	    }
	
	    /**
	     * True for any of the three instructor-side positions
	     * (Instructor, Co-Instructor, Instructor Assistant). Use this to
	     * gate UI that all instructor roles can view — nav shell, read-only
	     * data fetches, team_id query filters on team-scoped endpoints.
	     * Reserve getPosition() === "Instructor" for write-only paths that
	     * only the course-lead Instructor can perform.
	     */
	
	  }, {
	    key: "isAnyInstructor",
	    value: function isAnyInstructor() {
	      var p = Auth.getPosition();
	      return p === "Instructor" || p === "Co-Instructor" || p === "Instructor Assistant";
	    }
	
	    /**
	     * True for Co-Instructor OR Instructor Assistant — the two
	     * non-lead instructor roles that we treat as view-only across
	     * Game Admin and most instructor pages. Reserve
	     * isInstructorAssistant() alone for the few places where IAS
	     * differs from INS2 (e.g. career-readiness badge issuance,
	     * which INS2 can do but IAS cannot).
	     */
	
	  }, {
	    key: "isAssistantOrCoInstructor",
	    value: function isAssistantOrCoInstructor() {
	      var p = Auth.getPosition();
	      return p === "Co-Instructor" || p === "Instructor Assistant";
	    }
	
	    /**
	     * Get current game id
	     *
	     * @return {integer}
	     */
	
	  }, {
	    key: "getGameId",
	    value: function getGameId() {
	      var game_id = parseInt(sessionStorage.getItem("game_id"), 10);
	
	      return isNaN(game_id) ? 0 : game_id;
	    }
	
	    /**
	     * Set a game id value.
	     */
	
	  }, {
	    key: "setGameId",
	    value: function setGameId(value) {
	      sessionStorage.setItem("game_id", value);
	    }
	
	    /**
	     * Get current course id
	     *
	     * @return {integer}
	     */
	
	  }, {
	    key: "getCourseId",
	    value: function getCourseId() {
	      var course_id = parseInt(sessionStorage.getItem("course_id"), 10);
	
	      return isNaN(course_id) ? 0 : course_id;
	    }
	
	    /**
	     * Set a course_id value.
	     */
	
	  }, {
	    key: "setCourseId",
	    value: function setCourseId(value) {
	      sessionStorage.setItem("course_id", value);
	    }
	
	    /**
	     * Check is current user was paid
	     *
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isPaid",
	    value: function isPaid() {
	      return Auth._user ? Auth._user.is_paid : false;
	    }
	
	    /**
	     * Get current user data
	     *
	     * @return {object}
	     */
	
	  }, {
	    key: "getUser",
	    value: function getUser() {
	      return Auth._user;
	    }
	
	    /**
	     * Get correct role path
	     *
	     * @return {string}
	     */
	
	  }, {
	    key: "getRolePath",
	    value: function getRolePath() {
	      var current_role = Auth.getRole().toLowerCase();
	
	      if (current_role === "fi") {
	        current_role = "fn";
	      }
	
	      if (current_role !== "ceo" && current_role !== "pd" && current_role !== "pm" && current_role !== "op" && current_role !== "fn") {
	        current_role = "ceo";
	      }
	
	      return current_role;
	    }
	  }, {
	    key: "getUserDataRequest",
	    value: function getUserDataRequest() {
	      var user_id = Auth.getUserId();
	
	      if (!user_id) {
	        return null;
	      }
	
	      return ("https://be-production-itb.marketgames.io/api/") + "users/" + user_id + "/get_info/";
	    }
	  }, {
	    key: "setUserData",
	    value: function setUserData(data) {
	      Auth._user = data;
	    }
	  }]);
	
	  return Auth;
	}();
	
	Auth._user = null;
	Auth._appcuesIdentified = false;
	exports.default = Auth;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var core = __webpack_require__(117);
	var hide = __webpack_require__(96);
	var redefine = __webpack_require__(97);
	var ctx = __webpack_require__(118);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Types = exports.Loader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = exports.Loader = function (_Component) {
	  _inherits(Loader, _Component);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	  }
	
	  _createClass(Loader, [{
	    key: 'renderDiv',
	    value: function renderDiv(n) {
	      var styles = this.props.styles || {};
	      if (this.props.color) {
	        styles.backgroundColor = this.props.color;
	      }
	      return _react2.default.createElement('div', { key: n, style: styles });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var nDivs = range(Types[this.props.type]);
	      var classes = (0, _classnames3.default)((_classnames = {
	        loader: true
	      }, _defineProperty(_classnames, 'loader-' + this.props.size, this.props.size !== 'md'), _defineProperty(_classnames, 'loader-active', this.props.active), _defineProperty(_classnames, 'loader-hidden', !this.props.active), _classnames), this.props.className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'loader-inner ' + this.props.type },
	          nDivs.map(this.renderDiv.bind(this))
	        )
	      );
	    }
	  }], [{
	    key: 'removeType',
	    value: function removeType(type) {
	      delete Types[key];
	    }
	  }, {
	    key: 'addType',
	    value: function addType(key, nDivs) {
	      return Types[key] = nDivs;
	    }
	  }]);
	
	  return Loader;
	}(_react.Component);
	
	Loader.propTypes = {
	  type: _propTypes2.default.string,
	  size: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  color: _propTypes2.default.string
	};
	Loader.defaultProps = {
	  type: 'ball-pulse',
	  size: 'md',
	  active: true
	};
	exports.default = Loader;
	var Types = exports.Types = {
	  "ball-pulse": 3,
	  "ball-grid-pulse": 9,
	  "ball-clip-rotate": 1,
	  "ball-clip-rotate-pulse": 2,
	  "square-spin": 1,
	  "ball-clip-rotate-multiple": 2,
	  "ball-pulse-rise": 5,
	  "ball-rotate": 1,
	  "cube-transition": 2,
	  "ball-zig-zag": 2,
	  "ball-zig-zag-deflect": 2,
	  "ball-triangle-path": 3,
	  "ball-scale": 1,
	  "line-scale": 5,
	  "line-scale-party": 4,
	  "ball-scale-multiple": 3,
	  "ball-pulse-sync": 3,
	  "ball-beat": 3,
	  "line-scale-pulse-out": 5,
	  "line-scale-pulse-out-rapid": 5,
	  "ball-scale-ripple": 1,
	  "ball-scale-ripple-multiple": 3,
	  "ball-spin-fade-loader": 8,
	  "line-spin-fade-loader": 8,
	  "triangle-skew-spin": 1,
	  "pacman": 5,
	  "ball-grid-beat": 9,
	  "semi-circle-spin": 1
	};
	
	function range(x) {
	  var i = -1,
	      arr = [];
	  while (++i < x) {
	    arr.push(i);
	  }
	  return arr;
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(2);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(7);
	
	/***/ })
	/******/ ]);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teamsEndpoint = exports.colorForTeamId = exports.persistTeamColorIndexMap = exports.getTeamColorIndexMap = exports.computeTeamColorIndexMap = exports.sortTeamsById = exports.UNMET_DEMAND_COLOR = exports.COMPETITIVE_COLORS = exports.EQUITY_COLORS = exports.DEBTS_COLORS = exports.CAPITAL_EXPENDITURES_COLORS = exports.PRODUCT_COSTS_COLORS = exports.DISTRIBUTORS_COLORS = exports.DIRECT_SALES_COLORS = exports.DIGITAL_MARKETING_COLORS = exports.TRADITIONAL_MARKETING_COLORS = exports.TEAM_COLORS = exports.COLORS_LEVEL1 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactjsLocalstorage = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var COLORS_LEVEL1 = exports.COLORS_LEVEL1 = ["#8dd9de", "#4dc8ff", "#fcefd6", "#f3eefe", "#f9bcbc", "#b0e1b1", "#f9dec7", "#c6eef9", "#aef5f0", "#f2f3ad"];
	var COLORS_LEVEL2 = ["#7ad2d8", "#33c0ff", "#fae6bf", "#e2d5fe", "#f6a5a5", "#9dda9f", "#f7d1b0", "#afe7f6", "#98f2ec", "#eff096"];
	var COLORS_LEVEL3 = ["#52c5cd", "#00b0ff", "#f7d48f", "#bfa4fc", "#f27676", "#78cc7b", "#f2b682", "#81d9f1", "#81efe8", "#ebed80"];
	var COLORS_LEVEL4 = ["#35afb7", "#008dcc", "#f4c25f", "#9c73fa", "#ee4747", "#53be57", "#ed9b54", "#53cbec", "#54e9e0", "#e4e753"];
	var COLORS_LEVEL0 = ["#2f9ca3", "#007bb3", "#f2b948", "#8b5afa", "#eb3030", "#44b448", "#eb8e3d", "#3cc4e9", "#3de6dc", "#e0e43d"];
	
	var TEAM_COLORS = exports.TEAM_COLORS = COLORS_LEVEL3;
	var RESOLUTION_COLORS = COLORS_LEVEL1;
	var SENSITIVITY_COLORS = COLORS_LEVEL2;
	var POWER_COLORS = COLORS_LEVEL3;
	var TEMPERATURE_COLORS = COLORS_LEVEL4;
	var TRADITIONAL_MARKETING_COLORS = exports.TRADITIONAL_MARKETING_COLORS = COLORS_LEVEL0;
	var DIGITAL_MARKETING_COLORS = exports.DIGITAL_MARKETING_COLORS = COLORS_LEVEL4;
	var DIRECT_SALES_COLORS = exports.DIRECT_SALES_COLORS = COLORS_LEVEL3;
	var DISTRIBUTORS_COLORS = exports.DISTRIBUTORS_COLORS = COLORS_LEVEL2;
	var PRODUCT_COSTS_COLORS = exports.PRODUCT_COSTS_COLORS = {
	  "Material Costs": COLORS_LEVEL0,
	  "Labor Costs": COLORS_LEVEL3,
	  "Overhead Costs": COLORS_LEVEL4
	};
	var CAPITAL_EXPENDITURES_COLORS = exports.CAPITAL_EXPENDITURES_COLORS = {
	  "Production Line 4": COLORS_LEVEL0,
	  "Production Line 3": COLORS_LEVEL4,
	  "Production Line 2": COLORS_LEVEL3,
	  "Production Line 1": COLORS_LEVEL2,
	  "Production Facility": COLORS_LEVEL0,
	  Factory: COLORS_LEVEL0
	};
	var DEBTS_COLORS = exports.DEBTS_COLORS = [[COLORS_LEVEL2[0], COLORS_LEVEL3[0], COLORS_LEVEL4[0]], [COLORS_LEVEL2[1], COLORS_LEVEL3[1], COLORS_LEVEL4[1]], [COLORS_LEVEL2[2], COLORS_LEVEL3[2], COLORS_LEVEL4[2]], [COLORS_LEVEL2[3], COLORS_LEVEL3[3], COLORS_LEVEL4[3]], [COLORS_LEVEL2[4], COLORS_LEVEL3[4], COLORS_LEVEL4[4]], [COLORS_LEVEL2[5], COLORS_LEVEL3[5], COLORS_LEVEL4[5]], [COLORS_LEVEL2[6], COLORS_LEVEL3[6], COLORS_LEVEL4[6]], [COLORS_LEVEL2[7], COLORS_LEVEL3[7], COLORS_LEVEL4[7]], [COLORS_LEVEL2[8], COLORS_LEVEL3[8], COLORS_LEVEL4[8]], [COLORS_LEVEL2[9], COLORS_LEVEL3[9], COLORS_LEVEL4[9]]];
	var EQUITY_COLORS = exports.EQUITY_COLORS = COLORS_LEVEL0;
	var COMPETITIVE_COLORS = exports.COMPETITIVE_COLORS = COLORS_LEVEL3;
	var UNSOLD_COLORS = COLORS_LEVEL1;
	var UNMET_DEMAND_COLOR = exports.UNMET_DEMAND_COLOR = "#36454f";
	
	// Team color assignment lives in a single competition-level map:
	//   { [teamId]: paletteIndex }
	// The map is computed ONCE from the user's competition teams (sorted by
	// id ascending) and persisted to localStorage. Every consumer — topbar
	// avatar, every chart, every table — resolves colors through the same
	// map, so the same team always renders the same color regardless of
	// which endpoint's teams array the caller happens to hold.
	//
	// The palettes in this file all have 10 slots and a competition holds
	// at most 7 teams, so every team inside the competition gets a distinct
	// slot with room to spare.
	
	var TEAM_COLOR_INDEX_MAP_KEY = "team_color_index_map";
	
	var sortTeamsById = exports.sortTeamsById = function sortTeamsById(teams) {
	  return [].concat(_toConsumableArray(teams || [])).sort(function (a, b) {
	    return Number(a.id) - Number(b.id);
	  });
	};
	
	var computeTeamColorIndexMap = exports.computeTeamColorIndexMap = function computeTeamColorIndexMap(teams) {
	  var map = {};
	  sortTeamsById(teams).forEach(function (t, idx) {
	    if (t && t.id != null) {
	      map[String(t.id)] = idx;
	    }
	  });
	  return map;
	};
	
	// Read the persisted competition color-index map. Returns {} if missing
	// so callers can treat the return value like a normal object.
	var getTeamColorIndexMap = exports.getTeamColorIndexMap = function getTeamColorIndexMap() {
	  var obj = _reactjsLocalstorage.reactLocalStorage.getObject(TEAM_COLOR_INDEX_MAP_KEY);
	  return obj && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" ? obj : {};
	};
	
	// Overwrite the persisted competition color-index map. Skips the write
	// when the caller has nothing to persist so we don't blow away an
	// already-good map with an empty object during a race condition (e.g.
	// a fetch that returned zero rows for the current round).
	var persistTeamColorIndexMap = exports.persistTeamColorIndexMap = function persistTeamColorIndexMap(teams) {
	  if (!teams || teams.length === 0) return;
	  var map = computeTeamColorIndexMap(teams);
	  if (Object.keys(map).length > 0) {
	    _reactjsLocalstorage.reactLocalStorage.setObject(TEAM_COLOR_INDEX_MAP_KEY, map);
	  }
	};
	
	var colorForTeamId = exports.colorForTeamId = function colorForTeamId(teams, teamId) {
	  var palette = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : COMPETITIVE_COLORS;
	
	  if (teamId == null) return "";
	  // Prefer Teams.teams() (localStorage teams_data filtered by the
	  // user's competition) so every student-facing consumer — topbar
	  // avatar, every chart, every table — computes against the exact same
	  // list and resolves the same team to the same color. Instructors
	  // don't have a "current team", so Teams.teams() returns [] for them —
	  // fall back to the caller's `teams` argument in that case so
	  // instructor charts (performance-feedback pages, dashboards) still
	  // get colored bars instead of the default black.
	  var currentTeams = Teams.teams();
	  var source = currentTeams.length > 0 ? currentTeams : teams || [];
	  var map = computeTeamColorIndexMap(source);
	  var idx = map[String(teamId)];
	  if (idx == null) return "";
	  return palette[idx % palette.length];
	};
	
	// Every /api/teams/ caller should route through this helper so the
	// request is scoped to the current game only (Auth.getGameId() was set
	// at login to the highest-id game in the user's latest course). Without
	// the ?game filter the BE returns teams for every game the user has
	// access to, which pollutes downstream charts + roster views on
	// multi-game instructor accounts.
	var teamsEndpoint = exports.teamsEndpoint = function teamsEndpoint() {
	  var gameId = _Auth2.default.getGameId();
	  var base = ("https://be-production-itb.marketgames.io/api/") + "teams/";
	  return gameId ? base + "?game=" + gameId : base;
	};
	
	var Teams = function () {
	  function Teams() {
	    _classCallCheck(this, Teams);
	  }
	
	  _createClass(Teams, null, [{
	    key: "requests",
	    value: function requests() {
	      var team_id = _Auth2.default.getTeamId();
	
	      return [("https://be-production-itb.marketgames.io/api/") + "teams/" + team_id + "/players/", teamsEndpoint()];
	    }
	  }, {
	    key: "setData",
	    value: function setData(teams_data) {
	      if (teams_data[0].status !== 200 || teams_data[1].status !== 200) {
	        var game_is_not_started = false;
	        teams_data.forEach(function (team_data) {
	          if (team_data.status === 403 && "detail" in team_data.data && team_data.data.detail === "Game is not started") {
	            game_is_not_started = true;
	          }
	        });
	
	        if (game_is_not_started === true) {
	          Teams.setEmptyData();
	          return "Game is not started";
	        } else {
	          return "Error";
	        }
	      }
	
	      _reactjsLocalstorage.reactLocalStorage.setObject("players_data", teams_data[0].data.filter(function (player) {
	        return "user" in player;
	      }));
	      _reactjsLocalstorage.reactLocalStorage.setObject("teams_data", teams_data[1].data);
	
	      // Seed the competition color-index map so the topbar and any page
	      // that renders before Analysis loads (e.g. decision pages) share
	      // the same per-team palette assignment. Filter to the user's
	      // competition first so palette slots are packed contiguously
	      // starting at 0 for the ≤7 teams the user will actually see.
	      var teamId = _Auth2.default.getTeamId();
	      var allTeams = teams_data[1].data || [];
	      var self = allTeams.find(function (t) {
	        return Number(t.id) === Number(teamId);
	      });
	      var competitionTeams = self ? allTeams.filter(function (t) {
	        return t.competition === self.competition;
	      }) : allTeams;
	      persistTeamColorIndexMap(competitionTeams);
	
	      return "Success";
	    }
	  }, {
	    key: "setEmptyData",
	    value: function setEmptyData() {
	      _reactjsLocalstorage.reactLocalStorage.setObject("players_data", []);
	      _reactjsLocalstorage.reactLocalStorage.setObject("teams_data", []);
	      _reactjsLocalstorage.reactLocalStorage.setObject(TEAM_COLOR_INDEX_MAP_KEY, {});
	    }
	  }, {
	    key: "getObject",
	    value: function getObject(key) {
	      var obj = _reactjsLocalstorage.reactLocalStorage.getObject(key);
	
	      if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && Object.keys(obj).length === 0) {
	        return [];
	      }
	
	      return obj;
	    }
	  }, {
	    key: "players",
	    value: function players() {
	      return Teams.getObject("players_data");
	    }
	  }, {
	    key: "currentPlayer",
	    value: function currentPlayer() {
	      return Teams.players().find(function (i) {
	        return "user" in i && i.user.id === Number(_Auth2.default.getUserId());
	      });
	    }
	  }, {
	    key: "currentTeam",
	    value: function currentTeam() {
	      var team_id = _Auth2.default.getTeamId();
	
	      if (!team_id) {
	        return null;
	      }
	
	      return Teams.getObject("teams_data").find(function (i) {
	        return i.id === team_id;
	      });
	    }
	  }, {
	    key: "currentTeamIndex",
	    value: function currentTeamIndex() {
	      var team_id = _Auth2.default.getTeamId();
	
	      if (!team_id) {
	        return -1;
	      }
	
	      // Compute the color-index map directly from Teams.teams() every
	      // time so this method and colorForTeamId are always looking at the
	      // exact same list. See colorForTeamId at the top of this file for
	      // the full rationale.
	      var map = computeTeamColorIndexMap(Teams.teams());
	      var idx = map[String(team_id)];
	      return idx == null ? -1 : idx;
	    }
	  }, {
	    key: "currentTeamColor",
	    value: function currentTeamColor() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return TEAM_COLORS[index % TEAM_COLORS.length];
	    }
	  }, {
	    key: "currentTeamColorLevel1",
	    value: function currentTeamColorLevel1() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return COLORS_LEVEL1[index % COLORS_LEVEL1.length];
	    }
	  }, {
	    key: "currentTeamColorLevel3",
	    value: function currentTeamColorLevel3() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return COLORS_LEVEL3[index % COLORS_LEVEL3.length];
	    }
	  }, {
	    key: "teams",
	    value: function teams() {
	      var team = Teams.currentTeam();
	
	      if (!team) {
	        return [];
	      }
	
	      return Teams.getObject("teams_data").filter(function (i) {
	        return i.competition === team.competition;
	      });
	    }
	  }, {
	    key: "productDevelopmentColor",
	    value: function productDevelopmentColor(type) {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      if (type === "bg-resolution") {
	        return RESOLUTION_COLORS[index % RESOLUTION_COLORS.length];
	      } else if (type === "bg-sensitivity") {
	        return SENSITIVITY_COLORS[index % SENSITIVITY_COLORS.length];
	      } else if (type === "bg-power") {
	        return POWER_COLORS[index % POWER_COLORS.length];
	      } else if (type === "bg-temperature") {
	        return TEMPERATURE_COLORS[index % TEMPERATURE_COLORS.length];
	      }
	
	      return "";
	    }
	  }, {
	    key: "traditionalMarketingColor",
	    value: function traditionalMarketingColor() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return TRADITIONAL_MARKETING_COLORS[index % TRADITIONAL_MARKETING_COLORS.length];
	    }
	  }, {
	    key: "digitalMarketingColor",
	    value: function digitalMarketingColor() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return DIGITAL_MARKETING_COLORS[index % DIGITAL_MARKETING_COLORS.length];
	    }
	  }, {
	    key: "directSalesColor",
	    value: function directSalesColor() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return DIRECT_SALES_COLORS[index % DIRECT_SALES_COLORS.length];
	    }
	  }, {
	    key: "distributorsColor",
	    value: function distributorsColor() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return DISTRIBUTORS_COLORS[index % DISTRIBUTORS_COLORS.length];
	    }
	  }, {
	    key: "capitalExpendituresColor",
	    value: function capitalExpendituresColor(key) {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      if (key in CAPITAL_EXPENDITURES_COLORS) {
	        var colors = CAPITAL_EXPENDITURES_COLORS[key];
	
	        return colors[index % colors.length];
	      }
	
	      return "";
	    }
	  }, {
	    key: "productCostsColor",
	    value: function productCostsColor(key) {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      if (key in PRODUCT_COSTS_COLORS) {
	        var colors = PRODUCT_COSTS_COLORS[key];
	
	        return colors[index % colors.length];
	      }
	
	      return "";
	    }
	  }, {
	    key: "debtsColors",
	    value: function debtsColors() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return ["", "", ""];
	      }
	
	      return DEBTS_COLORS[index % DEBTS_COLORS.length];
	    }
	  }, {
	    key: "equityColor",
	    value: function equityColor() {
	      var index = Teams.currentTeamIndex();
	
	      if (index < 0) {
	        return "";
	      }
	
	      return EQUITY_COLORS[index % EQUITY_COLORS.length];
	    }
	  }, {
	    key: "competitiveColors",
	    value: function competitiveColors() {
	      var teams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var currentTeams = teams && _Auth2.default.getPosition() !== "Student" ? teams : Teams.teams();
	      // Preserve the caller's team order in the returned array (so it
	      // maps 1:1 with the input) but pick each team's color from the
	      // sorted-by-id position so the same team always resolves to the
	      // same color regardless of how the caller sorted its list.
	      return currentTeams.map(function (team) {
	        return colorForTeamId(currentTeams, team.id, COMPETITIVE_COLORS);
	      });
	    }
	  }, {
	    key: "unsoldColors",
	    value: function unsoldColors() {
	      var teams = Teams.teams();
	      return teams.map(function (team) {
	        return colorForTeamId(teams, team.id, UNSOLD_COLORS);
	      });
	    }
	  }]);
	
	  return Teams;
	}();
	
	exports.default = Teams;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	if (true) {
	  var React = __webpack_require__(1);
	}
	
	var Fragment = React.Fragment ||
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(_Fragment, _React$Component);
	
	  function _Fragment(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this.refFn = _this.refFn.bind(_assertThisInitialized(_this));
	    _this.orphans = [];
	    _this.focusedDescendantElement = null;
	    _this.parentNode = null;
	    return _this;
	  }
	
	  var _proto = _Fragment.prototype;
	
	  _proto.refFn = function refFn(div) {
	    this.div = div;
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.unwrapChildren();
	    this.div.style.display = 'none';
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this.unwrapChildren();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.rewrapChildren();
	  };
	
	  _proto.unwrapChildren = function unwrapChildren() {
	    var _this2 = this;
	
	    // defer first to style calculation to ensure CSS transitions can happen:
	    // https://stackoverflow.com/a/24195559/4956731
	    this.unwrapTimeout = setTimeout(function () {
	      // plain js rocks!
	      // https://plainjs.com/javascript/manipulation/unwrap-a-dom-element-35/
	      if (!_this2.div.parentNode) {
	        return;
	      }
	
	      _this2.saveFocusedDescendantElement(_this2.div);
	
	      _this2.orphans = [];
	
	      while (_this2.div.firstChild) {
	        _this2.orphans.push(_this2.div.firstChild);
	
	        _this2.div.parentNode.insertBefore(_this2.div.firstChild, _this2.div);
	      }
	
	      _this2.parentNode = _this2.div.parentNode;
	
	      if (_this2.orphans.length) {
	        // it's only safe to remove the wrapper div
	        // if the fragment has some child dom elements,
	        // since otherwise we have no way to remember
	        // our position among the sibling elements.
	        _this2.parentNode.removeChild(_this2.div);
	      }
	
	      _this2.restoreFocusedDescendantElement();
	    });
	  };
	
	  _proto.rewrapChildren = function rewrapChildren() {
	    clearTimeout(this.unwrapTimeout);
	
	    if (!(this.div && this.parentNode && this.parentNode.parentNode)) {
	      return;
	    }
	
	    if (this.orphans.length) {
	      this.parentNode.insertBefore(this.div, this.orphans[0]);
	      this.saveFocusedDescendantElement(this.orphans[0].parentNode);
	      var orphan;
	
	      while (orphan = this.orphans.shift()) {
	        this.div.appendChild(orphan);
	      }
	    }
	  };
	
	  _proto.saveFocusedDescendantElement = function saveFocusedDescendantElement(ancestorElement) {
	    if (ancestorElement.contains(document.activeElement)) {
	      this.focusedDescendantElement = document.activeElement;
	    }
	  };
	
	  _proto.restoreFocusedDescendantElement = function restoreFocusedDescendantElement() {
	    if (this.focusedDescendantElement) {
	      this.focusedDescendantElement.focus();
	      this.focusedDescendantElement = null;
	    }
	  };
	
	  _proto.render = function render() {
	    // sorry for the side effects! 😭
	    this.rewrapChildren();
	    return React.createElement('div', {
	      ref: this.refFn
	    }, this.props.children);
	  };
	
	  return _Fragment;
	}(React.Component);
	
	if (typeof module !== 'undefined' && module) {
	  module.exports = Fragment;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1553);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1552);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(411);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(411);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(614);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Composes a variable number of CSS helper functions.
	 * Returns a function that accepts all the original arguments
	 * of the functions it composed. If the original function
	 * accepted multiple arguments, they must be passed as
	 * an array.
	 * @example
	 * const translateXandRotateY = compose(translateX, rotateY);
	 * const cssValue = translateXandRotateY('-5px', '30deg');
	 */
	var compose = exports.compose = function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, styleArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      styleArgs[_key2] = arguments[_key2];
	    }
	
	    var result = funcs.reduce(function (acc, func, i) {
	      var arg = styleArgs[i];
	      return acc + ' ' + (Array.isArray(arg) ? func.apply(undefined, _toConsumableArray(arg)) : func(arg));
	    }, '');
	    return result.trim();
	  };
	};
	var cubicBezier = exports.cubicBezier = function cubicBezier(a, b, c, d) {
	  return 'cubic-bezier(' + a + ', ' + b + ', ' + c + ', ' + d + ')';
	};
	
	var translate3d = exports.translate3d = function translate3d(a, b, c) {
	  return 'translate3d(' + a + ', ' + b + ', ' + c + ')';
	};
	
	var translateX = exports.translateX = function translateX(a) {
	  return 'translateX(' + a + ')';
	};
	
	var scale3d = exports.scale3d = function scale3d(a, b, c) {
	  return 'scale3d(' + a + ', ' + b + ', ' + c + ')';
	};
	
	var scale = exports.scale = function scale(a) {
	  return 'scale(' + a + ')';
	};
	
	var skewX = exports.skewX = function skewX(deg) {
	  return 'skewX(' + deg + 'deg)';
	};
	
	var skewY = exports.skewY = function skewY(deg) {
	  return 'skewY(' + deg + 'deg)';
	};
	
	var skewXY = exports.skewXY = function skewXY(x, y) {
	  return skewX(x) + ' ' + skewY(y);
	};
	
	var rotateY = exports.rotateY = function rotateY(a) {
	  return 'rotateY(' + a + ')';
	};
	
	var rotate3d = exports.rotate3d = function rotate3d(a, b, c, d) {
	  return 'rotate3d(' + a + ', ' + b + ', ' + c + ', ' + d + 'deg)';
	};
	
	var perspective = exports.perspective = function perspective(a) {
	  return 'perspective(' + a + ')';
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDevelopment = exports.isAccepted = exports.isGetStartedShown = exports.setGetStartedShown = exports.getFirstRoundId = exports.roleToUrlFull = exports.roleToUrl = exports.getLogoStyle = exports.resolveFirstName = exports.detectMobile = exports.hideNotFinishedParts = undefined;
	exports.validateEmail = validateEmail;
	exports.numericSuffix = numericSuffix;
	exports.decimalsRound = decimalsRound;
	exports.ucfirst = ucfirst;
	exports.addUserSpecificParams = addUserSpecificParams;
	exports.hexToRgba = hexToRgba;
	exports.logError = logError;
	exports.getDateInCurrentTimezone = getDateInCurrentTimezone;
	exports.showFlashingDot = showFlashingDot;
	
	var _jstz = __webpack_require__(276);
	
	var _jstz2 = _interopRequireDefault(_jstz);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _ravenJs = __webpack_require__(893);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _lodash = __webpack_require__(21);
	
	var _reactjsLocalstorage = __webpack_require__(173);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var hideNotFinishedParts = exports.hideNotFinishedParts = function hideNotFinishedParts() {
	  return ("true") && ("true").toLowerCase() === "true" ? true : false;
	};
	
	var detectMobile = exports.detectMobile = function detectMobile() {
	  return window.MobileDetect.phone() ? true : false;
	};
	
	// Resolve the "display" first name from a raw `first_name` string.
	// Collapse whitespace, then decide by token count:
	//   - 1 token  → use it
	//   - 2 tokens → use only the 1st (2nd is treated as a middle name)
	//   - 3+ tokens → keep the first two (true two-word first name like
	//                 "James Karl"; everything from token 3 on is middle names)
	// Returns "" when the input is missing/blank.
	var resolveFirstName = exports.resolveFirstName = function resolveFirstName(raw) {
	  if (!raw) return "";
	  var normalized = String(raw).replace(/\s+/g, " ").trim();
	  if (!normalized) return "";
	  var tokens = normalized.split(" ");
	  if (tokens.length >= 3) return tokens[0] + " " + tokens[1];
	  return tokens[0];
	};
	
	var getLogoStyle = exports.getLogoStyle = function getLogoStyle(isMobile) {
	  return isMobile ? {
	    width: "100%",
	    maxWidth: 400,
	    marginTop: "-5vh"
	  } : {
	    height: 250
	  };
	};
	
	function validateEmail(email) {
	  // eslint-disable-next-line
	  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	  return re.test(String(email).toLowerCase());
	}
	
	function numericSuffix(num) {
	  var j = num % 10;
	  var k = num % 100;
	
	  if (j === 1 && k !== 11) {
	    return num + "st";
	  } else if (j === 2 && k !== 12) {
	    return num + "nd";
	  } else if (j === 3 && k !== 13) {
	    return num + "rd";
	  }
	
	  return num + "th";
	}
	
	function decimalsRound(value, decimals) {
	  return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals).toFixed(decimals);
	}
	
	function ucfirst(str) {
	  var firstPart = str.charAt(0).toUpperCase();
	  var secondPart = str.substr(1, str.length - 1);
	
	  return firstPart + secondPart;
	}
	
	function addUserSpecificParams(url) {
	  var user = _Auth2.default.getUser();
	  var user_id = user ? user.id : 0;
	  var username = user ? user.username : "";
	
	  if (user_id > 0 && username !== "") {
	    return url + "?user_id=" + user_id + "&name=" + username;
	  }
	
	  return url;
	}
	
	function hexToRgba(hex, alpha) {
	  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
	    var c = hex.substring(1).split("");
	
	    if (c.length === 3) {
	      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
	    }
	
	    var rgb = Number("0x" + c.join(""));
	    var r = rgb >> 16 & 255;
	    var g = rgb >> 8 & 255;
	    var b = rgb & 255;
	
	    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
	  }
	
	  return hex;
	}
	
	function logError(err, classname, method) {
	  _ravenJs2.default.captureException(err, {
	    logger: classname,
	    extra: {
	      body: err.response && err.response.body,
	      method: method
	    }
	  });
	}
	
	function getDateInCurrentTimezone(value) {
	  var utc = _momentTimezone2.default.utc(value);
	  var timezone = _jstz2.default.determine();
	  return (0, _momentTimezone2.default)(utc).tz(timezone.name()).valueOf();
	}
	
	function showFlashingDot(rounds, current_round, round_in_url) {
	  var has_access = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (has_access === false) {
	    return false;
	  }
	
	  var round_number = current_round;
	  if (round_in_url !== null && round_in_url !== current_round) {
	    round_number = round_in_url;
	  }
	
	  var round = rounds.find(function (i) {
	    return i.number === round_number;
	  });
	  if (round) {
	    return !round.is_finished;
	  }
	
	  return false;
	}
	
	var roleToUrl = exports.roleToUrl = function roleToUrl(role) {
	  return {
	    CEO: "ceo",
	    PD: "pd",
	    PM: "pm",
	    FI: "fn",
	    OP: "op"
	  }[role] || "";
	};
	
	var roleToUrlFull = exports.roleToUrlFull = function roleToUrlFull(role) {
	  return {
	    CEO: "ceo",
	    PD: "product-development",
	    PM: "product-marketing",
	    FI: "finance",
	    OP: "operations"
	  }[role] || "";
	};
	
	var getFirstRoundId = exports.getFirstRoundId = function getFirstRoundId() {
	  return new Promise(function (resolve, reject) {
	    (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "game/rounds/").then(function (res) {
	      var round = (0, _lodash.find)(res.body, function (r) {
	        return Number(r.number) === 1;
	      });
	
	      if (round) {
	        resolve(round.id);
	      } else {
	        reject("Cannot find first round object");
	      }
	      resolve(null);
	    });
	  });
	};
	
	var setGetStartedShown = exports.setGetStartedShown = function setGetStartedShown() {
	  var shown = JSON.parse(_reactjsLocalstorage.reactLocalStorage.get("get-started-shown", "[]"));
	
	  return new Promise(function (resolve, reject) {
	    getFirstRoundId().then(function (firstRoundId) {
	      _reactjsLocalstorage.reactLocalStorage.set("get-started-shown", JSON.stringify([].concat(_toConsumableArray(shown), [{ firstRoundId: firstRoundId, userId: _Auth2.default.getUserId() }])));
	
	      resolve(true);
	    });
	  });
	};
	
	var isGetStartedShown = exports.isGetStartedShown = function isGetStartedShown() {
	  var shown = JSON.parse(_reactjsLocalstorage.reactLocalStorage.get("get-started-shown", "[]"));
	
	  return new Promise(function (resolve, reject) {
	    getFirstRoundId().then(function (firstRoundId) {
	      var found = (0, _lodash.find)(shown, function (i) {
	        return i.firstRoundId === firstRoundId && i.userId === _Auth2.default.getUserId();
	      });
	
	      resolve(found ? true : false);
	    });
	  });
	};
	
	var isAccepted = exports.isAccepted = function isAccepted(items) {
	  return (0, _lodash.some)(items, function (item) {
	    return item.accepted;
	  });
	};
	
	var isDevelopment = exports.isDevelopment = function isDevelopment() {
	  return !("production") || ("production") === "development";
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(615);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2.default)(false, 'A `bsClass` prop is required for this component') : (0, _invariant2.default)(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2.default.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2.default.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = existing;
	  propType._values = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2.default.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.ToggleButtonGroup = exports.ToggleButton = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.CloseButton = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(2236);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(2237);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(2238);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(2239);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(932);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(171);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(511);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(2240);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(2241);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(933);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(2243);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(2244);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _CloseButton2 = __webpack_require__(512);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _ControlLabel2 = __webpack_require__(2246);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(2245);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(513);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(363);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(2247);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(364);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(2249);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(2250);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(2253);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(514);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(935);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(2254);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(2255);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(2256);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(2259);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(2260);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(2261);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(936);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(365);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(2268);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(937);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(938);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(939);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(940);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(941);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(942);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(2271);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(944);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(2270);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(943);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(945);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(2275);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(2276);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(2277);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(2278);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(2279);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(947);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(2280);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(948);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(2281);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(2282);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(2283);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(2284);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(2285);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(135);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(2286);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(2288);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(515);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(516);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(2289);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(949);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(2290);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(2291);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _ToggleButton2 = __webpack_require__(950);
	
	var _ToggleButton3 = _interopRequireDefault(_ToggleButton2);
	
	var _ToggleButtonGroup2 = __webpack_require__(2292);
	
	var _ToggleButtonGroup3 = _interopRequireDefault(_ToggleButtonGroup2);
	
	var _Tooltip2 = __webpack_require__(2293);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(2294);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(66);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Accordion = _Accordion3.default;
	exports.Alert = _Alert3.default;
	exports.Badge = _Badge3.default;
	exports.Breadcrumb = _Breadcrumb3.default;
	exports.BreadcrumbItem = _BreadcrumbItem3.default;
	exports.Button = _Button3.default;
	exports.ButtonGroup = _ButtonGroup3.default;
	exports.ButtonToolbar = _ButtonToolbar3.default;
	exports.Carousel = _Carousel3.default;
	exports.CarouselItem = _CarouselItem3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Clearfix = _Clearfix3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.ControlLabel = _ControlLabel3.default;
	exports.Col = _Col3.default;
	exports.Collapse = _Collapse3.default;
	exports.Dropdown = _Dropdown3.default;
	exports.DropdownButton = _DropdownButton3.default;
	exports.Fade = _Fade3.default;
	exports.Form = _Form3.default;
	exports.FormControl = _FormControl3.default;
	exports.FormGroup = _FormGroup3.default;
	exports.Glyphicon = _Glyphicon3.default;
	exports.Grid = _Grid3.default;
	exports.HelpBlock = _HelpBlock3.default;
	exports.Image = _Image3.default;
	exports.InputGroup = _InputGroup3.default;
	exports.Jumbotron = _Jumbotron3.default;
	exports.Label = _Label3.default;
	exports.ListGroup = _ListGroup3.default;
	exports.ListGroupItem = _ListGroupItem3.default;
	exports.Media = _Media3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.Modal = _Modal3.default;
	exports.ModalBody = _ModalBody3.default;
	exports.ModalFooter = _ModalFooter3.default;
	exports.ModalHeader = _ModalHeader3.default;
	exports.ModalTitle = _ModalTitle3.default;
	exports.Nav = _Nav3.default;
	exports.Navbar = _Navbar3.default;
	exports.NavbarBrand = _NavbarBrand3.default;
	exports.NavDropdown = _NavDropdown3.default;
	exports.NavItem = _NavItem3.default;
	exports.Overlay = _Overlay3.default;
	exports.OverlayTrigger = _OverlayTrigger3.default;
	exports.PageHeader = _PageHeader3.default;
	exports.PageItem = _PageItem3.default;
	exports.Pager = _Pager3.default;
	exports.Pagination = _Pagination3.default;
	exports.PaginationButton = _PaginationButton3.default;
	exports.Panel = _Panel3.default;
	exports.PanelGroup = _PanelGroup3.default;
	exports.Popover = _Popover3.default;
	exports.ProgressBar = _ProgressBar3.default;
	exports.Radio = _Radio3.default;
	exports.ResponsiveEmbed = _ResponsiveEmbed3.default;
	exports.Row = _Row3.default;
	exports.SafeAnchor = _SafeAnchor3.default;
	exports.SplitButton = _SplitButton3.default;
	exports.Tab = _Tab3.default;
	exports.TabContainer = _TabContainer3.default;
	exports.TabContent = _TabContent3.default;
	exports.Table = _Table3.default;
	exports.TabPane = _TabPane3.default;
	exports.Tabs = _Tabs3.default;
	exports.Thumbnail = _Thumbnail3.default;
	exports.ToggleButton = _ToggleButton3.default;
	exports.ToggleButtonGroup = _ToggleButtonGroup3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.Well = _Well3.default;
	exports.utils = _utils;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(136)(module)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _wolfy87Eventemitter = __webpack_require__(2686);
	
	var _wolfy87Eventemitter2 = _interopRequireDefault(_wolfy87Eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EE = function () {
	  function EE() {
	    _classCallCheck(this, EE);
	  }
	
	  _createClass(EE, null, [{
	    key: "getInstance",
	    value: function getInstance() {
	      if (EE._instance === null) {
	        EE._instance = new _wolfy87Eventemitter2.default();
	      }
	
	      return EE._instance;
	    }
	  }]);
	
	  return EE;
	}();
	
	EE._instance = null;
	exports.default = EE;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.goBack = exports.changeLocation = undefined;
	
	var _reactRouter = __webpack_require__(24);
	
	var isIEBrowser = function isIEBrowser() {
	  var isIE = false;
	
	  if (window && window.navigator) {
	    isIE = window.navigator.userAgent.indexOf("MSIE ") > 0 ? true : false;
	  }
	
	  return isIE;
	};
	
	var changeLocation = exports.changeLocation = function changeLocation(url) {
	  if (isIEBrowser() === true) {
	    window.location.href = url;
	  } else {
	    _reactRouter.browserHistory.push(url);
	  }
	};
	
	var goBack = exports.goBack = function goBack() {
	  if (isIEBrowser() === true) {
	    window.history.go(-1);
	  } else {
	    _reactRouter.browserHistory.goBack();
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(172);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(537);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(243);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(2392);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(989);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(2388);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(2403);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(2389);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(2390);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(991);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(2391);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(538);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(2401);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(996);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(2394);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(2395);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(2399);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(993);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Text = function Text(_ref) {
	  var children = _ref.children,
	      style = _ref.style,
	      mt = _ref.mt,
	      marginTop = _ref.marginTop;
	  return _react2.default.createElement(
	    "p",
	    {
	      style: Object.assign({
	        fontSize: "18px",
	        fontFamily: _styles.fontFamily,
	        color: "#000000",
	        marginTop: marginTop ? marginTop : mt ? "4em" : "0",
	        marginBottom: "2em"
	      }, style)
	    },
	    children
	  );
	};
	
	exports.default = Text;

/***/ },
/* 26 */
[2687, 33],
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Surface", {
	  enumerable: true,
	  get: function get() {
	    return _Surface2["default"];
	  }
	});
	Object.defineProperty(exports, "Layer", {
	  enumerable: true,
	  get: function get() {
	    return _Layer2["default"];
	  }
	});
	Object.defineProperty(exports, "Legend", {
	  enumerable: true,
	  get: function get() {
	    return _Legend2["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip2["default"];
	  }
	});
	Object.defineProperty(exports, "ResponsiveContainer", {
	  enumerable: true,
	  get: function get() {
	    return _ResponsiveContainer2["default"];
	  }
	});
	Object.defineProperty(exports, "Cell", {
	  enumerable: true,
	  get: function get() {
	    return _Cell2["default"];
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function get() {
	    return _Text2["default"];
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label2["default"];
	  }
	});
	Object.defineProperty(exports, "LabelList", {
	  enumerable: true,
	  get: function get() {
	    return _LabelList2["default"];
	  }
	});
	Object.defineProperty(exports, "Customized", {
	  enumerable: true,
	  get: function get() {
	    return _Customized2["default"];
	  }
	});
	Object.defineProperty(exports, "Sector", {
	  enumerable: true,
	  get: function get() {
	    return _Sector2["default"];
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function get() {
	    return _Curve2["default"];
	  }
	});
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _Rectangle2["default"];
	  }
	});
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _Polygon2["default"];
	  }
	});
	Object.defineProperty(exports, "Dot", {
	  enumerable: true,
	  get: function get() {
	    return _Dot2["default"];
	  }
	});
	Object.defineProperty(exports, "Cross", {
	  enumerable: true,
	  get: function get() {
	    return _Cross2["default"];
	  }
	});
	Object.defineProperty(exports, "Symbols", {
	  enumerable: true,
	  get: function get() {
	    return _Symbols2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarGrid", {
	  enumerable: true,
	  get: function get() {
	    return _PolarGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarRadiusAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarRadiusAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarAngleAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarAngleAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "Pie", {
	  enumerable: true,
	  get: function get() {
	    return _Pie2["default"];
	  }
	});
	Object.defineProperty(exports, "Radar", {
	  enumerable: true,
	  get: function get() {
	    return _Radar2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBar", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBar2["default"];
	  }
	});
	Object.defineProperty(exports, "Brush", {
	  enumerable: true,
	  get: function get() {
	    return _Brush2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceLine", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceLine2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceDot", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceDot2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceArea", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceArea2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianAxis", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianGrid", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _Line2["default"];
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function get() {
	    return _Area2["default"];
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function get() {
	    return _Bar2["default"];
	  }
	});
	Object.defineProperty(exports, "Scatter", {
	  enumerable: true,
	  get: function get() {
	    return _Scatter2["default"];
	  }
	});
	Object.defineProperty(exports, "XAxis", {
	  enumerable: true,
	  get: function get() {
	    return _XAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "YAxis", {
	  enumerable: true,
	  get: function get() {
	    return _YAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ZAxis", {
	  enumerable: true,
	  get: function get() {
	    return _ZAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorBar2["default"];
	  }
	});
	Object.defineProperty(exports, "LineChart", {
	  enumerable: true,
	  get: function get() {
	    return _LineChart2["default"];
	  }
	});
	Object.defineProperty(exports, "BarChart", {
	  enumerable: true,
	  get: function get() {
	    return _BarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "PieChart", {
	  enumerable: true,
	  get: function get() {
	    return _PieChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Treemap", {
	  enumerable: true,
	  get: function get() {
	    return _Treemap2["default"];
	  }
	});
	Object.defineProperty(exports, "Sankey", {
	  enumerable: true,
	  get: function get() {
	    return _Sankey2["default"];
	  }
	});
	Object.defineProperty(exports, "RadarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ScatterChart", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterChart2["default"];
	  }
	});
	Object.defineProperty(exports, "AreaChart", {
	  enumerable: true,
	  get: function get() {
	    return _AreaChart2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ComposedChart", {
	  enumerable: true,
	  get: function get() {
	    return _ComposedChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Funnel", {
	  enumerable: true,
	  get: function get() {
	    return _Funnel2["default"];
	  }
	});
	Object.defineProperty(exports, "FunnelChart", {
	  enumerable: true,
	  get: function get() {
	    return _FunnelChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Trapezoid", {
	  enumerable: true,
	  get: function get() {
	    return _Trapezoid2["default"];
	  }
	});
	
	__webpack_require__(2445);
	
	var _Surface2 = _interopRequireDefault(__webpack_require__(295));
	
	var _Layer2 = _interopRequireDefault(__webpack_require__(54));
	
	var _Legend2 = _interopRequireDefault(__webpack_require__(543));
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(377));
	
	var _ResponsiveContainer2 = _interopRequireDefault(__webpack_require__(2443));
	
	var _Cell2 = _interopRequireDefault(__webpack_require__(248));
	
	var _Text2 = _interopRequireDefault(__webpack_require__(207));
	
	var _Label2 = _interopRequireDefault(__webpack_require__(174));
	
	var _LabelList2 = _interopRequireDefault(__webpack_require__(150));
	
	var _Customized2 = _interopRequireDefault(__webpack_require__(2440));
	
	var _Sector2 = _interopRequireDefault(__webpack_require__(381));
	
	var _Curve2 = _interopRequireDefault(__webpack_require__(249));
	
	var _Rectangle2 = _interopRequireDefault(__webpack_require__(250));
	
	var _Polygon2 = _interopRequireDefault(__webpack_require__(380));
	
	var _Dot2 = _interopRequireDefault(__webpack_require__(208));
	
	var _Cross2 = _interopRequireDefault(__webpack_require__(1018));
	
	var _Symbols2 = _interopRequireDefault(__webpack_require__(544));
	
	var _PolarGrid2 = _interopRequireDefault(__webpack_require__(2444));
	
	var _PolarRadiusAxis2 = _interopRequireDefault(__webpack_require__(379));
	
	var _PolarAngleAxis2 = _interopRequireDefault(__webpack_require__(378));
	
	var _Pie2 = _interopRequireDefault(__webpack_require__(1015));
	
	var _Radar2 = _interopRequireDefault(__webpack_require__(1016));
	
	var _RadialBar2 = _interopRequireDefault(__webpack_require__(1017));
	
	var _Brush2 = _interopRequireDefault(__webpack_require__(1009));
	
	var _ReferenceLine2 = _interopRequireDefault(__webpack_require__(1013));
	
	var _ReferenceDot2 = _interopRequireDefault(__webpack_require__(1012));
	
	var _ReferenceArea2 = _interopRequireDefault(__webpack_require__(1011));
	
	var _CartesianAxis2 = _interopRequireDefault(__webpack_require__(1010));
	
	var _CartesianGrid2 = _interopRequireDefault(__webpack_require__(2428));
	
	var _Line2 = _interopRequireDefault(__webpack_require__(541));
	
	var _Area2 = _interopRequireDefault(__webpack_require__(539));
	
	var _Bar2 = _interopRequireDefault(__webpack_require__(540));
	
	var _Scatter2 = _interopRequireDefault(__webpack_require__(542));
	
	var _XAxis2 = _interopRequireDefault(__webpack_require__(246));
	
	var _YAxis2 = _interopRequireDefault(__webpack_require__(247));
	
	var _ZAxis2 = _interopRequireDefault(__webpack_require__(376));
	
	var _ErrorBar2 = _interopRequireDefault(__webpack_require__(294));
	
	var _LineChart2 = _interopRequireDefault(__webpack_require__(2433));
	
	var _BarChart2 = _interopRequireDefault(__webpack_require__(2430));
	
	var _PieChart2 = _interopRequireDefault(__webpack_require__(2434));
	
	var _Treemap2 = _interopRequireDefault(__webpack_require__(2439));
	
	var _Sankey2 = _interopRequireDefault(__webpack_require__(2437));
	
	var _RadarChart2 = _interopRequireDefault(__webpack_require__(2435));
	
	var _ScatterChart2 = _interopRequireDefault(__webpack_require__(2438));
	
	var _AreaChart2 = _interopRequireDefault(__webpack_require__(2429));
	
	var _RadialBarChart2 = _interopRequireDefault(__webpack_require__(2436));
	
	var _ComposedChart2 = _interopRequireDefault(__webpack_require__(2431));
	
	var _Funnel2 = _interopRequireDefault(__webpack_require__(1014));
	
	var _FunnelChart2 = _interopRequireDefault(__webpack_require__(2432));
	
	var _Trapezoid2 = _interopRequireDefault(__webpack_require__(1019));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.TOOLTIP_TYPES = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(348));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ShallowEqual = __webpack_require__(384);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = {
	  'aria-current': _propTypes["default"].string,
	  // state
	  'aria-details': _propTypes["default"].any,
	  'aria-disabled': _propTypes["default"].any,
	  // state
	  'aria-hidden': _propTypes["default"].any,
	  // state
	  'aria-invalid': _propTypes["default"].any,
	  // state
	  'aria-keyshortcuts': _propTypes["default"].any,
	  'aria-label': _propTypes["default"].any,
	  'aria-roledescription': _propTypes["default"].any,
	  // Widget Attributes
	  'aria-autocomplete': _propTypes["default"].any,
	  'aria-checked': _propTypes["default"].any,
	  'aria-expanded': _propTypes["default"].any,
	  'aria-haspopup': _propTypes["default"].any,
	  'aria-level': _propTypes["default"].any,
	  'aria-modal': _propTypes["default"].any,
	  'aria-multiline': _propTypes["default"].any,
	  'aria-multiselectable': _propTypes["default"].any,
	  'aria-orientation': _propTypes["default"].any,
	  'aria-placeholder': _propTypes["default"].any,
	  'aria-pressed': _propTypes["default"].any,
	  'aria-readonly': _propTypes["default"].any,
	  'aria-required': _propTypes["default"].any,
	  'aria-selected': _propTypes["default"].any,
	  'aria-sort': _propTypes["default"].any,
	  'aria-valuemax': _propTypes["default"].any,
	  'aria-valuemin': _propTypes["default"].any,
	  'aria-valuenow': _propTypes["default"].any,
	  'aria-valuetext': _propTypes["default"].any,
	  // Live Region Attributes
	  'aria-atomic': _propTypes["default"].any,
	  'aria-busy': _propTypes["default"].any,
	  'aria-live': _propTypes["default"].any,
	  'aria-relevant': _propTypes["default"].any,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': _propTypes["default"].any,
	  'aria-grabbed': _propTypes["default"].any,
	  // Relationship Attributes
	  'aria-activedescendant': _propTypes["default"].any,
	  'aria-colcount': _propTypes["default"].any,
	  'aria-colindex': _propTypes["default"].any,
	  'aria-colspan': _propTypes["default"].any,
	  'aria-controls': _propTypes["default"].any,
	  'aria-describedby': _propTypes["default"].any,
	  'aria-errormessage': _propTypes["default"].any,
	  'aria-flowto': _propTypes["default"].any,
	  'aria-labelledby': _propTypes["default"].any,
	  'aria-owns': _propTypes["default"].any,
	  'aria-posinset': _propTypes["default"].any,
	  'aria-rowcount': _propTypes["default"].any,
	  'aria-rowindex': _propTypes["default"].any,
	  'aria-rowspan': _propTypes["default"].any,
	  'aria-setsize': _propTypes["default"].any,
	  alignmentBaseline: _propTypes["default"].string,
	  angle: _propTypes["default"].number,
	  baselineShift: _propTypes["default"].string,
	  clip: _propTypes["default"].string,
	  clipPath: _propTypes["default"].string,
	  clipRule: _propTypes["default"].string,
	  color: _propTypes["default"].string,
	  colorInterpolation: _propTypes["default"].string,
	  colorInterpolationFilters: _propTypes["default"].string,
	  colorProfile: _propTypes["default"].string,
	  colorRendering: _propTypes["default"].string,
	  cursor: _propTypes["default"].string,
	  direction: _propTypes["default"].oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes["default"].string,
	  dominantBaseline: _propTypes["default"].string,
	  enableBackground: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  fillOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fillRule: _propTypes["default"].oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes["default"].string,
	  floodColor: _propTypes["default"].string,
	  floodOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  font: _propTypes["default"].string,
	  fontFamily: _propTypes["default"].string,
	  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontSizeAdjust: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontStretch: _propTypes["default"].oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes["default"].oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes["default"].oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes["default"].oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes["default"].string,
	  glyphOrientationVertical: _propTypes["default"].string,
	  imageRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  letterSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  lightingColor: _propTypes["default"].string,
	  lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  markerEnd: _propTypes["default"].string,
	  markerMid: _propTypes["default"].string,
	  markerStart: _propTypes["default"].string,
	  mask: _propTypes["default"].string,
	  opacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  overflow: _propTypes["default"].oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes["default"].oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes["default"].string,
	  stopOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  stroke: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeDasharray: _propTypes["default"].string,
	  strokeDashoffset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeLinecap: _propTypes["default"].oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes["default"].oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes["default"].oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes["default"].oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes["default"].oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  writingMode: _propTypes["default"].oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes["default"].string,
	  role: _propTypes["default"].string,
	  focusable: _propTypes["default"].string,
	  tabIndex: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  dx: _propTypes["default"].number,
	  dy: _propTypes["default"].number,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  r: _propTypes["default"].number,
	  // The radius of Rectangle
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	};
	exports.PRESENTATION_ATTRIBUTES = PRESENTATION_ATTRIBUTES;
	var EVENT_ATTRIBUTES = {
	  onClick: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  onMouseOut: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onTouchEnd: _propTypes["default"].func,
	  onTouchMove: _propTypes["default"].func,
	  onTouchStart: _propTypes["default"].func,
	  onTouchCancel: _propTypes["default"].func
	};
	exports.EVENT_ATTRIBUTES = EVENT_ATTRIBUTES;
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
	exports.SCALE_TYPES = SCALE_TYPES;
	var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	exports.LEGEND_TYPES = LEGEND_TYPES;
	var TOOLTIP_TYPES = ['none'];
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	
	exports.TOOLTIP_TYPES = TOOLTIP_TYPES;
	
	var getDisplayName = function getDisplayName(Comp) {
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	
	  if (!Comp) {
	    return '';
	  }
	
	  return Comp.displayName || Comp.name || 'Component';
	};
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	
	
	exports.getDisplayName = getDisplayName;
	
	var findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	
	
	exports.findAllByType = findAllByType;
	
	var findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	  return result && result[0];
	};
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	
	
	exports.findChildByType = findChildByType;
	
	var withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types;
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	
	
	exports.withoutType = withoutType;
	
	var getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	
	  return out;
	};
	
	exports.getPresentationAttributes = getPresentationAttributes;
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	
	
	var filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	
	  return out;
	};
	
	exports.filterEventAttributes = filterEventAttributes;
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	    return null;
	  };
	};
	
	var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction2["default"])(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	
	  return out;
	};
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	
	
	exports.filterEventsOfChild = filterEventsOfChild;
	
	var validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	exports.validateWidthHeight = validateWidthHeight;
	
	var isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	exports.isSsr = isSsr;
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString2["default"])(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	
	
	var filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react["default"].Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString2["default"])(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	exports.filterSvgElements = filterSvgElements;
	
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil2["default"])(nextChild) && (0, _isNil2["default"])(prevChild)) {
	    return true;
	  }
	
	  if (!(0, _isNil2["default"])(nextChild) && !(0, _isNil2["default"])(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ["children"]);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ["children"]);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    }
	
	    if (!nextChildren && !prevChildren) {
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	
	
	exports.isSingleChildEqual = isSingleChildEqual;
	
	var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray2["default"])(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray2["default"])(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var _i = 0; _i < count; _i++) {
	    var nextChild = nextChildren[_i];
	    var prevChild = prevChildren[_i];
	
	    if ((0, _isArray2["default"])(nextChild) || (0, _isArray2["default"])(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	exports.isChildrenEqual = isChildrenEqual;
	
	var renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray2["default"])(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	exports.renderByOrder = renderByOrder;
	
	var getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	exports.getReactEventByType = getReactEventByType;
	
	var parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};
	
	exports.parseChildIndex = parseChildIndex;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 30 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _wrapper = __webpack_require__(595);
	
	var _pretitle = __webpack_require__(593);
	
	var _pretitle2 = _interopRequireDefault(_pretitle);
	
	var _subtitle = __webpack_require__(1292);
	
	var _subtitle2 = _interopRequireDefault(_subtitle);
	
	var _paragraph = __webpack_require__(592);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _alert = __webpack_require__(1289);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _visual = __webpack_require__(594);
	
	var _visual2 = _interopRequireDefault(_visual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAlertNumber = function getAlertNumber(previousShownErrors) {
	  var num = Number(previousShownErrors);
	  if (isNaN(num)) {
	    num = 0;
	  }
	
	  return 1 + num;
	}; /* eslint-disable jsx-a11y/anchor-is-valid */
	
	
	var BannerLayout = function BannerLayout(_ref) {
	  var section = _ref.section,
	      subSection = _ref.subSection,
	      previousShownErrors = _ref.previousShownErrors,
	      alertText = _ref.alertText,
	      subTitle = _ref.subTitle,
	      paragraph1 = _ref.paragraph1,
	      paragraph2 = _ref.paragraph2,
	      visual = _ref.visual,
	      _ref$visualProps = _ref.visualProps,
	      visualProps = _ref$visualProps === undefined ? {} : _ref$visualProps,
	      _ref$hideAlert = _ref.hideAlert,
	      hideAlert = _ref$hideAlert === undefined ? false : _ref$hideAlert;
	  return _react2.default.createElement(
	    _wrapper.Wrapper,
	    null,
	    _react2.default.createElement(
	      _pretitle2.default,
	      null,
	      section,
	      subSection ? ' | ' + subSection : ''
	    ),
	    !hideAlert && _react2.default.createElement(
	      _alert2.default,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        getAlertNumber(previousShownErrors)
	      ),
	      ' ',
	      alertText
	    ),
	    _react2.default.createElement(
	      _subtitle2.default,
	      null,
	      subTitle
	    ),
	    paragraph1 && _react2.default.createElement(
	      _paragraph2.default,
	      null,
	      paragraph1
	    ),
	    _react2.default.createElement(_visual2.default, Object.assign({ data: visual }, visualProps)),
	    paragraph2 && _react2.default.createElement(
	      _paragraph2.default,
	      null,
	      paragraph2
	    )
	  );
	};
	
	exports.default = BannerLayout;

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 35 */
[2754, 92, 550, 1021, 2457, 546, 2456, 1028],
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(18);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IFRAME_REF = "typeform-iframe";
	var SHARE_DOC_LINK = "https://docs.google.com/a/marketgames.io/document/d/1n48v17MARTi5nXgGYUga1RJzD19iWzp-WvIUuAaSLFo/edit?usp=sharing";
	
	var HelpIconButtonWithTooltipAndTypeformModal = function (_Component) {
	  _inherits(HelpIconButtonWithTooltipAndTypeformModal, _Component);
	
	  function HelpIconButtonWithTooltipAndTypeformModal(props) {
	    _classCallCheck(this, HelpIconButtonWithTooltipAndTypeformModal);
	
	    var _this = _possibleConstructorReturn(this, (HelpIconButtonWithTooltipAndTypeformModal.__proto__ || Object.getPrototypeOf(HelpIconButtonWithTooltipAndTypeformModal)).call(this, props));
	
	    _this.showTypeformModal = function (e) {
	      e.preventDefault();
	      _this.setState({
	        shouldShowTypeformModal: true
	      });
	    };
	
	    _this.hideTypeformModal = function () {
	      _this.setState({ shouldShowTypeformModal: false });
	    };
	
	    _this.onModalEntered = function () {
	      // Focus the iframe after the modal transitions in
	      _reactDom2.default.findDOMNode(_this.refs[IFRAME_REF]).focus();
	    };
	
	    _this.state = {
	      shouldShowTypeformModal: false
	    };
	    return _this;
	  }
	
	  _createClass(HelpIconButtonWithTooltipAndTypeformModal, [{
	    key: "getTooltipContent",
	    value: function getTooltipContent() {
	      var _props = this.props,
	          learnMoreAbout = _props.learnMoreAbout,
	          mgAbout = _props.mgAbout,
	          mgSection = _props.mgSection;
	
	
	      var learnMoreButton = _react2.default.createElement(
	        "a",
	        { className: "pointer", href: "/#", onClick: this.showTypeformModal },
	        "Learn More"
	      );
	
	      var learnMoreContent = _react2.default.createElement(
	        "span",
	        null,
	        "To learn more about ",
	        learnMoreAbout,
	        ", please click on ",
	        learnMoreButton
	      );
	
	      var mgBusinessCaseButton = _react2.default.createElement(
	        "a",
	        { className: "pointer", href: SHARE_DOC_LINK, target: "_blank", rel: "noreferrer" },
	        "MG Business Case"
	      );
	
	      var mgContent = _react2.default.createElement(
	        "span",
	        null,
	        "To learn more about ",
	        mgAbout,
	        ", please read the ",
	        mgSection,
	        " section of the ",
	        mgBusinessCaseButton,
	        "."
	      );
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        this.props.description,
	        learnMoreAbout && learnMoreContent,
	        mgAbout && mgSection && mgContent
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	          category: this.category,
	          tooltipContent: this.getTooltipContent(),
	          iconSize: this.props.iconSize
	        }),
	        this.props.typeformUrl && _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            backdrop: true,
	            dialogClassName: "typeform-modal",
	            show: this.state.shouldShowTypeformModal,
	            onEntered: this.onModalEntered,
	            onHide: this.hideTypeformModal
	          },
	          _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement("iframe", {
	              ref: IFRAME_REF,
	              src: (0, _utils.addUserSpecificParams)(this.props.typeformUrl),
	              style: { width: "100%", height: "500px" },
	              title: "Typeform"
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "category",
	    get: function get() {
	      var _props2 = this.props,
	          learnMoreAbout = _props2.learnMoreAbout,
	          mgAbout = _props2.mgAbout,
	          mgSection = _props2.mgSection;
	
	
	      if (learnMoreAbout) {
	        return learnMoreAbout;
	      }
	
	      if (mgSection && mgAbout) {
	        return mgSection + " - " + mgAbout;
	      }
	
	      return null;
	    }
	  }]);
	
	  return HelpIconButtonWithTooltipAndTypeformModal;
	}(_react.Component);
	
	HelpIconButtonWithTooltipAndTypeformModal.propTypes = {
	  description: _propTypes2.default.string.isRequired,
	  iconSize: _propTypes2.default.oneOf(["xs", "sm"])
	};
	
	exports.default = HelpIconButtonWithTooltipAndTypeformModal;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    isObject = __webpack_require__(101);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(133));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(346));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(347));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(348));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	exports.mathSign = mathSign;
	
	var isPercent = function isPercent(value) {
	  return (0, _isString2["default"])(value) && value.indexOf('%') === value.length - 1;
	};
	
	exports.isPercent = isPercent;
	
	var isNumber = function isNumber(value) {
	  return (0, _isNumber2["default"])(value) && !(0, _isNaN2["default"])(value);
	};
	
	exports.isNumber = isNumber;
	
	var isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString2["default"])(value);
	};
	
	exports.isNumOrStr = isNumOrStr;
	var idCounter = 0;
	
	var uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	  return "".concat(prefix || '').concat(id);
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	
	
	exports.uniqueId = uniqueId;
	
	var getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString2["default"])(percent)) {
	    return defaultValue;
	  }
	
	  var value;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN2["default"])(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	exports.getPercentValue = getPercentValue;
	
	var getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	exports.getAnyElementOfObject = getAnyElementOfObject;
	
	var hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray2["default"])(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	exports.hasDuplicate = hasDuplicate;
	
	var interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	exports.interpolateNumber = interpolateNumber;
	
	var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _get2["default"])(entry, specifiedKey)) === specifiedValue;
	  });
	};
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	
	
	exports.findEntryInArray = findEntryInArray;
	
	var getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};
	
	exports.getLinearRegression = getLinearRegression;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(132);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(291);
	
	var _createChainableTypeChecker = __webpack_require__(352);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TypeformContent = {
	  ACCOUNT_PAYABLE: {
	    description: "You have to decide when to pay your suppliers. Your supplier provides the materials you use to produce your products. You can decide to pay your suppliers in 0, 30, 60, or 90 days from when the purchase occurred. This decision impacts Working Capital.",
	    learnMoreAbout: "Working Capital",
	    typeformUrl: _TypeformUrls2.default.WORKING_CAPITAL
	  },
	  ACCOUNT_RECEIVABLE: {
	    description: "You have to decide when a customer has to pay you. You have the option of offering the customers to pay you in 0, 30, 60, or 90 days from when the sale occurred. This decision impacts Working Capital.",
	    learnMoreAbout: "Working Capital",
	    typeformUrl: _TypeformUrls2.default.WORKING_CAPITAL
	  },
	  BALANCE_SHEET: {
	    description: "Balance Sheet reports the net balances of all of your activities since inception of your business. Assets, Liabilities, and Equities are the 3 key accounts within the Balance Sheet. All your team decisions are reflected in these 3 accounts.",
	    learnMoreAbout: "the Balance Sheet",
	    typeformUrl: _TypeformUrls2.default.BALANCE_SHEET
	  },
	  BUSINESS_VALUATION: {
	    description: "This is the value of your business. Investors use different valuation methods at different stages (i.e. rounds) of the game.",
	    learnMoreAbout: "how your business valued in this game",
	    typeformUrl: _TypeformUrls2.default.BUSINESS_VALUATION
	  },
	  CAPITAL_STRUCTURE: {
	    description: "This is the funding structure of your business. It is the different sources of capital (i.e. funds) that a business uses for their operation. For example, a business might raise $100 for their operations by issuing $80 in equity ( i.e. gave up some ownership) and $20 in debt (i.e. borrowing money). Therefore, their capital structure would be 80% equity 20% debt. Capital Structure metrics can also signal to investors the risks and value of a business.",
	    learnMoreAbout: "Capital Structure",
	    typeformUrl: _TypeformUrls2.default.CAPITAL_STRUCTURE
	  },
	  CASH_BALANCE: {
	    description: "This breaks down your current cash balance by giving you a detail breakdown of your cash activities. It provides your cash balance at the beginning of the year and then adjust that balance with the spending budgets from your departments (i.e. Product Development, Product Marketing, and Operations). The balance is then further adjusted by any money raised by your department. You want to make sure that this balance is not low or negative.",
	    learnMoreAbout: "the Cash Balance",
	    typeformUrl: _TypeformUrls2.default.CASH_FLOWS
	  },
	  CASH_FLOWS: {
	    description: "Cash Flows reports a detailed breakdown of your cash activities within the year. It helps you better understand how cash is being used within your organization.",
	    learnMoreAbout: "Cash Flows",
	    typeformUrl: _TypeformUrls2.default.CASH_FLOWS
	  },
	  COMPETITIVE_ANALYSIS: {
	    description: "This section provides data on your competitors.",
	    learnMoreAbout: "Competitive Analysis",
	    typeformUrl: _TypeformUrls2.default.COMPETITIVE_ANALYSIS
	  },
	  COST_OF_CAPITAL: {
	    description: "It is the cost of raising funds for your business. It is the combined cost of raising debt and equity to fund your business. Managers use the cost of capital metric to evaluate the cost-benefit of a project and investors use the cost of capital to assess the risks and overall value of your business (i.e. your stock price).",
	    learnMoreAbout: "Cost of Capital",
	    typeformUrl: _TypeformUrls2.default.COST_OF_CAPITAL
	  },
	  DEBT_TO_CAPITAL: {
	    description: "Debt to Capital is the % of the capital of your business that is financed by debt. The higher your debt to capital ratio, the higher your financing costs.",
	    learnMoreAbout: "Debt to Capital",
	    typeformUrl: _TypeformUrls2.default.DEBT_TO_CAPITAL
	  },
	  DEBT_VS_EQUITY: {
	    description: "As Head of Finance, you have to decide if you will raise debt capital to finance your business. Debt is money borrowed that has to be repaid at a specific date. Also, you are obligated to make annual payments of interests each year until the loan is repaid.",
	    learnMoreAbout: "debt",
	    typeformUrl: _TypeformUrls2.default.DEBT_VS_EQUITY
	  },
	  DISCOUNT_RATE: {
	    description: "Discount rate has many meanings. In this game, the discount rate is the rate that you use to discount future cash flows to determine those cash flows present value. For capital investment decisions (i.e. buying machine decisions), the discount rate = cost of capital.",
	    learnMoreAbout: "the discount rates",
	    typeformUrl: _TypeformUrls2.default.DISCOUNT_RATE
	  },
	  EARNINGS_PER_SHARE: {
	    description: "Earnings Per Share is a ratio that investors use to assess the attractiveness of your your business. The formula is Profits divided by total shares outstanding.",
	    learnMoreAbout: "Earnings Per Share",
	    typeformUrl: _TypeformUrls2.default.EARNINGS_PER_SHARE
	  },
	  EARNINGS_YIELD: {
	    description: "Earnings Yield tells investors how much profits a company earned given the company’s value. It is a ratio that takes your Net Profits and divide it by your business’s value.",
	    learnMoreAbout: "Earnings Yield",
	    typeformUrl: _TypeformUrls2.default.EARNINGS_YIELD
	  },
	  EQUITY_OFFERING: {
	    description: "As Head of Finance, you need to raise equity capital (i.e. give up some ownership of your business in exchange for money). Equity capital is raised by issuing shares, which represent an ownership stake of your business.",
	    learnMoreAbout: "Issuing Shares",
	    typeformUrl: _TypeformUrls2.default.EQUITY_OFFERING
	  },
	  FINANCIAL_ANALYSIS: {
	    description: "This section compares your projections (i.e. plans) with your actual performance.",
	    learnMoreAbout: "financial analysis",
	    typeformUrl: _TypeformUrls2.default.FINANCIAL_ANALYSIS
	  },
	  FINANCIAL_PLANNING_ANALYSIS: {
	    description: "This page compares your team’s financial projections (i.e. expectations) with your actual performance. Essentially, it assesses how well your team met expectations. The accuracy in your prediction could have a positive impact on your stock price.",
	    learnMoreAbout: "financial, planning, and analysis",
	    typeformUrl: _TypeformUrls2.default.FINANCIAL_ANALYSIS
	  },
	  FINANCIALS: {
	    description: "Financials are reports that translate your team decisions into financial results. Income Statement, Cash Flows, and the Balance Sheet are the key financials that you should review each round. Your 4 KPIs are mainly derived from your financials.",
	    learnMoreAbout: "financial statements",
	    typeformUrl: _TypeformUrls2.default.FINANCIALS
	  },
	  GROSS_PROFITS: {
	    description: "This is your revenues (income earned) less the direct costs you incurred to earn those revenues. Revenues - Cost of Sales = Gross Profits.",
	    learnMoreAbout: "Profits",
	    typeformUrl: _TypeformUrls2.default.PROFITABILITY
	  },
	  INCOME_STATEMENT: {
	    description: "Income Statement reports your profits earned during the year. It breaks down your profits by income earned (i.e. revenues) and cost incurred (i.e. expenses) during the year.",
	    learnMoreAbout: "Income Statements",
	    typeformUrl: _TypeformUrls2.default.INCOME_STATEMENT
	  },
	  INVESTOR_DATA: {
	    description: "This section has the data that your investors care about.",
	    learnMoreAbout: "investment analysis",
	    typeformUrl: _TypeformUrls2.default.INVESTOR_DATA
	  },
	  IRR: {
	    description: "Internal Rate of Return is a metric used in capital investments decisions (e.g. buying machines decision). It measures the return that you have to make on an investment to cover the costs of that investment.",
	    learnMoreAbout: "IRR",
	    typeformUrl: _TypeformUrls2.default.IRR
	  },
	  KPI: {
	    description: "KPIs (i.e. Key Performance Indicators) are ratios that management/investors use to measure a business ability to reach their targets/goals (i.e. measure success). Your grade is based on these 4 KPIs.",
	    learnMoreAbout: "KPIs",
	    typeformUrl: _TypeformUrls2.default.KPI
	  },
	  MARKET_ANALYSIS: {
	    description: "This section has customer information.",
	    learnMoreAbout: "Market Analysis",
	    typeformUrl: _TypeformUrls2.default.MARKET_ANALYSIS
	  },
	  MARKET_CAP: {
	    description: "Your market capitalization is one of the key metrics used in determining your grades.",
	    learnMoreAbout: "Market Capitalization",
	    typeformUrl: _TypeformUrls2.default.MARKET_CAP
	  },
	  NET_PROFITS: {
	    description: "This is your Profits before taxes less income taxes. It’s also known as net income or net earnings.",
	    learnMoreAbout: "Profits",
	    typeformUrl: _TypeformUrls2.default.PROFITABILITY
	  },
	  NPV_ANALYSIS: {
	    description: "As Head of Operations, you have to make a decision on which machine(s) to buy to produce your products. Conducting a cost-benefit analysis (i.e. NPV analysis) can help you in this decision. Essentially, you are evaluating the costs of buying machines with the benefits those machines offer (i.e. producing units that you can sell for income).",
	    learnMoreAbout: "NPV Analysis",
	    typeformUrl: _TypeformUrls2.default.NPV_ANALYSIS
	  },
	  PRICE_EARNINGS_RATIO: {
	    description: "This is a ratio that investors use to assess if a company is under or overvalued. Investors use this metrics to make a comparison with asimilar businesses.",
	    learnMoreAbout: "Valuation Multiples",
	    typeformUrl: _TypeformUrls2.default.BUSINESS_VALUATION
	  },
	  PRICE_SALES_RATIO: {
	    description: "This is a ratio that investors use for a variety of reasons, which include using the ratio to value your business or comparable businesses.",
	    learnMoreAbout: "Valuation Multiples",
	    typeformUrl: _TypeformUrls2.default.BUSINESS_VALUATION
	  },
	  PRICE_TO_BOOK_RATIO: {
	    description: "This is a ratio that investors use for a variety of reasons, which include using the ratio to value your business or comparable businesses.",
	    learnMoreAbout: "Valuation Multiples",
	    typeformUrl: _TypeformUrls2.default.BUSINESS_VALUATION
	  },
	  PERCEPTUAL_MAP: {
	    description: "This section displays where your product features are in relation to your competitors’ and to what customers are demanded.",
	    learnMoreAbout: "Perceptual Map",
	    typeformUrl: _TypeformUrls2.default.PERCEPTUAL_MAP
	  },
	  PRICING: {
	    description: "This section displays the weighted average price of all your products in relation to your competitors’.",
	    learnMoreAbout: "Pricing",
	    typeformUrl: _TypeformUrls2.default.PRICING
	  },
	  PRODUCT_AWARENESS: {
	    description: "This section displays the % of customers that are aware of all your products.",
	    learnMoreAbout: "Marketing",
	    typeformUrl: _TypeformUrls2.default.PRODUCT_AWARENESS
	  },
	  PRODUCT_COSTS: {
	    description: "Cost per unit of a product is also known as the product’s costs. This costs is made up of 3 key components - Material Costs, Labor Costs, and Overhead Costs.",
	    learnMoreAbout: "product costs",
	    typeformUrl: _TypeformUrls2.default.PRODUCT_COSTS
	  },
	  PROFITS: {
	    description: "Your cumulative profits is one of the key metrics used in determining your grades.",
	    learnMoreAbout: "Profits",
	    typeformUrl: _TypeformUrls2.default.PROFITABILITY
	  },
	  PROJECTIONS: {
	    description: "This is where you predict what profits you plan to make over the next 3 years. In this module, you input your expected revenues, cost of sales, and other expenses. Your predictions are required to raise capital. Also, your stock price is impacted by the accuracy of your predictions.",
	    learnMoreAbout: "management projections",
	    typeformUrl: _TypeformUrls2.default.FINANCIAL_PROJECTIONS
	  },
	  ROIC: {
	    description: "Your ROIC (i.e. Return on Invested Capital) is one of the key metrics used in determining your grades.",
	    learnMoreAbout: "ROIC",
	    typeformUrl: _TypeformUrls2.default.ROIC
	  },
	  ROIC_KPI: {
	    description: "Return on Invested Capital (i.e. ROIC) is a ratio that takes a business’s Net Profits and divide it by the total capital raised. Investors use this ratio to assess the return a business has generated from the capital raised.",
	    learnMoreAbout: "ROIC",
	    typeformUrl: _TypeformUrls2.default.ROIC
	  },
	  RNOA: {
	    description: "Your RNOA (i.e. Return on Net Operating Assets) is one of the key metrics used in determining your grades.",
	    learnMoreAbout: "RNOA",
	    typeformUrl: _TypeformUrls2.default.RNOA
	  },
	  RNOA_KPI: {
	    description: "Return on Net Operating Assets (i.e. RNOA) is a ratio that takes a business’s Net Profits and divide it by total operating assets. Investors use this ratio to assess how much income they earned with the assets they own.",
	    learnMoreAbout: "RNOA",
	    typeformUrl: _TypeformUrls2.default.RNOA
	  },
	  SHARES_OUTSTANDING: {
	    description: "The number of shares issued to investors less any buybacks.",
	    learnMoreAbout: "Shares Outstanding",
	    typeformUrl: _TypeformUrls2.default.SHARES_OUTSTANDING
	  },
	  STOCK_PRICE: {
	    description: "Stock Price is a ratio that takes your business’s value and divide it by total outstanding shares. Investors use this ratio to assess the attractiveness of a business.",
	    learnMoreAbout: "Stock Price",
	    typeformUrl: _TypeformUrls2.default.STOCK_PRICE
	  },
	  STOCK_RETURN: {
	    description: "",
	    learnMoreAbout: "Stock Return",
	    typeformUrl: _TypeformUrls2.default.STOCK_RETURN
	  },
	  TIME_VALUE_OF_MONEY: {
	    description: "It is the value taking future cash flows and adjusting those cash flows to the present time. For example, if you are expecting to receive $100 a year from now, the present value (i.e. current value) will be different due to the time value of money.",
	    learnMoreAbout: "Time Value of Money",
	    typeformUrl: _TypeformUrls2.default.TIME_VALUE_OF_MONEY
	  },
	  UTILIZATION: {
	    description: "It is how often your machines are operating and employees working over a 24hr period throughout the year. 100% utilization for machines means that your machines were operating 24hrs per day 7 days per week for the entire year. 100% machine and/or human utilization can be costly.",
	    learnMoreAbout: "Utilization",
	    typeformUrl: _TypeformUrls2.default.UTILIZATION
	  }
	};
	
	exports.default = TypeformContent;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _lodash = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ONE_MILLION = 1000000;
	
	/**
	 * The raw data, which is 50,000 should be formatted in the following form 0.05M
	 * with the following steps:
	 * - divided by 1,000,000
	 * - presented in 2 decimal places
	 * - have the letter "M" after the last digit
	 */
	
	var AbbreviatedMillionNumberFormat = function (_Component) {
	  _inherits(AbbreviatedMillionNumberFormat, _Component);
	
	  function AbbreviatedMillionNumberFormat() {
	    _classCallCheck(this, AbbreviatedMillionNumberFormat);
	
	    return _possibleConstructorReturn(this, (AbbreviatedMillionNumberFormat.__proto__ || Object.getPrototypeOf(AbbreviatedMillionNumberFormat)).apply(this, arguments));
	  }
	
	  _createClass(AbbreviatedMillionNumberFormat, [{
	    key: "render",
	    value: function render() {
	      var value = this.props.value;
	      var prefix = this.props.prefix || "";
	      var negativeClass = this.props.negativeClass || "";
	      var className = value < 0 ? negativeClass : "";
	      var suffix = this.props.suffix || "";
	      var forceConvert = this.props.forceConvert || false;
	      var hideZero = this.props.hideZero || false;
	      var decimalPrecision = (0, _lodash.isNil)(this.props.decimalPrecision) ? 0 : this.props.decimalPrecision;
	      var addSpaceBeforeSuffix = this.props.addSpaceBeforeSuffix || false;
	      var space = addSpaceBeforeSuffix ? " " : "";
	      var floatCount = this.props.floatCount || 3;
	
	      if (value >= ONE_MILLION || value <= ONE_MILLION * -1 || forceConvert === true) {
	        var negative = value < 0 ? "-" : "";
	        value = (Math.abs(value) / ONE_MILLION).toFixed(floatCount);
	
	        if (hideZero === true && Number(value) === 0) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            "\xA0"
	          );
	        }
	
	        return _react2.default.createElement(
	          "span",
	          {
	            className: className
	          },
	          "" + negative + prefix + value + space + "M" + suffix
	        );
	      }
	
	      if (hideZero === true && value === 0) {
	        return _react2.default.createElement(
	          "span",
	          null,
	          "\xA0"
	        );
	      }
	
	      return _react2.default.createElement(
	        "span",
	        { className: className },
	        _react2.default.createElement(_reactNumberFormat2.default, {
	          value: value,
	          prefix: prefix,
	          suffix: suffix,
	          displayType: "text",
	          thousandSeparator: ",",
	          decimalPrecision: decimalPrecision
	        })
	      );
	    }
	  }]);
	
	  return AbbreviatedMillionNumberFormat;
	}(_react.Component);
	
	exports.default = AbbreviatedMillionNumberFormat;

/***/ },
/* 44 */
[2729, 272, 196, 30],
/* 45 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(88);
	
	var _visual = __webpack_require__(609);
	
	var _visual2 = _interopRequireDefault(_visual);
	
	var _teamSelectorWrapper = __webpack_require__(1473);
	
	var _teamSelectorWrapper2 = _interopRequireDefault(_teamSelectorWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var getAlertNumber = function getAlertNumber(previousShownErrors) {
	  var num = Number(previousShownErrors);
	  if (isNaN(num)) {
	    num = 0;
	  }
	
	  return 1 + num;
	};
	
	var BannerLayout = function BannerLayout(_ref) {
	  var section = _ref.section,
	      subSection = _ref.subSection,
	      previousShownErrors = _ref.previousShownErrors,
	      alertText = _ref.alertText,
	      subTitle = _ref.subTitle,
	      paragraph1 = _ref.paragraph1,
	      paragraph2 = _ref.paragraph2,
	      visual = _ref.visual,
	      _ref$visualProps = _ref.visualProps,
	      visualProps = _ref$visualProps === undefined ? {} : _ref$visualProps,
	      _ref$hideAlert = _ref.hideAlert,
	      hideAlert = _ref$hideAlert === undefined ? false : _ref$hideAlert,
	      _ref$selectorOptions = _ref.selectorOptions,
	      selectorOptions = _ref$selectorOptions === undefined ? null : _ref$selectorOptions,
	      onSelectorChange = _ref.onSelectorChange,
	      selectorSelectedOptionId = _ref.selectorSelectedOptionId;
	
	  return _react2.default.createElement(
	    _ui.Wrapper,
	    null,
	    _react2.default.createElement(
	      _ui.PreTitle,
	      null,
	      section,
	      subSection ? ' | ' + subSection : ''
	    ),
	    !hideAlert && _react2.default.createElement(
	      _ui.Alert,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        getAlertNumber(previousShownErrors)
	      ),
	      ' ',
	      alertText
	    ),
	    _react2.default.createElement(
	      _ui.SubTitle,
	      null,
	      subTitle
	    ),
	    paragraph1 && _react2.default.createElement(
	      _ui.Text,
	      null,
	      paragraph1
	    ),
	    selectorOptions && _react2.default.createElement(_teamSelectorWrapper2.default, {
	      label: 'View',
	      selectorOptions: selectorOptions,
	      onSelectorChange: onSelectorChange,
	      selectorSelectedOptionId: selectorSelectedOptionId
	    }),
	    _react2.default.createElement(_visual2.default, Object.assign({ data: visual }, visualProps)),
	    paragraph2 && _react2.default.createElement(
	      _ui.Text,
	      null,
	      paragraph2
	    )
	  );
	};
	
	exports.default = BannerLayout;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2531);


/***/ },
/* 48 */
[2724, 120],
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2327);


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentContainerWithBackground = exports.Charts = exports.ContentContainer = exports.Text = exports.Title = exports.PreTitle = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n  margin-bottom: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n  margin-bottom: 24px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n'], ['\n  margin-top: 12px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    background: #fff;\n    width: 100%;\n    position: relative;\n    z-index: 1;\n    padding: 0 5px;\n\n    ', '\n  '], ['\n    background: #fff;\n    width: 100%;\n    position: relative;\n    z-index: 1;\n    padding: 0 5px;\n\n    ', '\n  ']),
	    _templateObject7 = _taggedTemplateLiteral(['\n      display: flex;\n      padding: 24px 15px 20px;\n      color: #36507e;\n      font-weight: 600;\n      font-size: 15px;\n    '], ['\n      display: flex;\n      padding: 24px 15px 20px;\n      color: #36507e;\n      font-weight: 600;\n      font-size: 15px;\n    ']),
	    _templateObject8 = _taggedTemplateLiteral(['\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n\n      ', '\n    '], ['\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n\n      ', '\n    ']),
	    _templateObject9 = _taggedTemplateLiteral(['\n      height: 10px;\n      width: 40px;\n      margin-right: 10px;\n\n      ', '\n    '], ['\n      height: 10px;\n      width: 40px;\n      margin-right: 10px;\n\n      ', '\n    ']),
	    _templateObject10 = _taggedTemplateLiteral(['\n      font-size: 14px;\n      color: #36507e;\n    '], ['\n      font-size: 14px;\n      color: #36507e;\n    ']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #D5D9DD;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n'], ['\n  margin-top: 12px;\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #D5D9DD;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PreTitle = exports.PreTitle = _styledComponents2.default.div(_templateObject2);
	
	var Title = exports.Title = _styledComponents2.default.div(_templateObject3);
	
	var Text = exports.Text = _styledComponents2.default.div(_templateObject4);
	
	var ContentContainer = exports.ContentContainer = _styledComponents2.default.div(_templateObject5);
	
	// charts components
	var Charts = exports.Charts = {
	  Wrapper: _styledComponents2.default.div(_templateObject6, function (p) {
	    return p.setMaxHeight && '\n      max-height: 450px;\n    ';
	  }),
	  Teams: {
	    Wrapper: _styledComponents2.default.div(_templateObject7),
	    Row: _styledComponents2.default.div(_templateObject8, function (p) {
	      return p.margin && '\n        margin: ' + p.margin + ';\n      ';
	    }),
	    TeamColor: _styledComponents2.default.div(_templateObject9, function (p) {
	      return p.background && '\n        background: ' + p.background + ';\n      ';
	    }),
	    TeamName: _styledComponents2.default.div(_templateObject10)
	  },
	  Chart: _styledComponents2.default.div(_templateObject11)
	};
	
	var ContentContainerWithBackground = exports.ContentContainerWithBackground = _styledComponents2.default.div(_templateObject12);

/***/ },
/* 51 */
[2692, 31],
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkJournal = exports.decrementUnacceptedDecisions = exports.incrementUnacceptedDecisions = exports.handleSubmission = exports.getSubmissionRequest = exports.getSubmissionData = exports.submitDecisions = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _jstz = __webpack_require__(276);
	
	var _jstz2 = _interopRequireDefault(_jstz);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _utils = __webpack_require__(18);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactjsLocalstorage = __webpack_require__(173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AUTHORIZATION_ERROR = "You do not have authorization to submit %ROLE% decisions.";
	
	var SubmitDecisions = function () {
	  function SubmitDecisions() {
	    _classCallCheck(this, SubmitDecisions);
	  }
	
	  _createClass(SubmitDecisions, [{
	    key: "submitDecisionsRequest",
	    value: function submitDecisionsRequest(type) {
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "teams/submit_" + type + "/");
	    }
	  }, {
	    key: "getUnacceptedDecisionsRequest",
	    value: function getUnacceptedDecisionsRequest() {
	      var temporaryUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var apiURL = ("https://be-production-itb.marketgames.io/api/") + "teams/unaccepted_decisions/";
	      if (temporaryUser) {
	        apiURL = apiURL + "?team_id=" + temporaryUser.team_id;
	      }
	
	      return apiURL;
	    }
	  }, {
	    key: "getSubmissionDateRequest",
	    value: function getSubmissionDateRequest(type) {
	      var round_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var is_round_finished = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var temporaryUser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var game_id = temporaryUser ? temporaryUser.game_id : _Auth2.default.getGameId();
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/journal/";
	      var literal = is_round_finished ? temporaryUser ? "&" : "?" : "&";
	      var additionalQuery = is_round_finished ? temporaryUser ? "?team_id=" + temporaryUser.team_id : "" : temporaryUser ? "&team_id=" + temporaryUser.team_id : "";
	
	      var result_url = is_round_finished === true ? ("https://be-production-itb.marketgames.io/api/") + "teams/submit_" + type + "/" + additionalQuery : base_url + "?path=/api/teams/submit_" + type + "/" + additionalQuery + literal + "only_last=true";
	      if (round_number !== null && round_number !== false) {
	        result_url = is_round_finished === true ? "" + result_url + literal + "round_number=" + round_number : result_url + "&round_number=" + round_number;
	      }
	
	      return result_url;
	    }
	  }, {
	    key: "getSubmissionRequest",
	    value: function getSubmissionRequest(types) {
	      var round_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var is_round_finished = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var temporaryUser = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var requests = [
	      // eslint-disable-next-line
	      getUnacceptedDecisionsRequest(temporaryUser)];
	
	      types.forEach(function (type) {
	        var param = "";
	        if (type === "pd") {
	          param = "development";
	        } else if (type === "pm") {
	          param = "marketing";
	        } else if (type === "op") {
	          param = "operations";
	        } else if (type === "fn") {
	          param = "finance";
	        }
	
	        if (param !== "") {
	          requests.push(
	          // eslint-disable-next-line
	          getSubmissionDateRequest(param, round_number, is_round_finished, temporaryUser));
	        }
	      });
	
	      return requests;
	    }
	  }, {
	    key: "handleSubmission",
	    value: function handleSubmission(types, res) {
	      var is_round_finished = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var data = {};
	
	      types.forEach(function (type) {
	        data[type] = {
	          unaccepted: 0,
	          date: "N/A"
	        };
	      });
	
	      res.forEach(function (r, i) {
	        if (i === 0) {
	          Object.keys(r).forEach(function (field) {
	            if (types.includes(field.toLowerCase())) {
	              data[field.toLowerCase()].unaccepted = r[field];
	            }
	          });
	        } else {
	          var timezone = _jstz2.default.determine();
	
	          if (is_round_finished === true) {
	            var type = types[i - 1];
	
	            data[type].date = r.length > 0 ? (0, _momentTimezone2.default)().tz(timezone.name()).format("MM/DD hh:mmA") : "N/A";
	            data[type].unaccepted = 0;
	          } else {
	            var date = "";
	
	            if (!r[0] || r[0].requested_at === null) {
	              date = "N/A";
	            } else {
	              date = (0, _momentTimezone2.default)(r[0].requested_at).tz(timezone.name()).format("MM/DD hh:mmA");
	            }
	
	            var _type = types[i - 1];
	            data[_type].date = date;
	          }
	        }
	      });
	
	      return data;
	    }
	  }, {
	    key: "getSubmissionData",
	    value: function getSubmissionData(types) {
	      var temporaryUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var requests = [
	      // eslint-disable-next-line
	      getUnacceptedDecisionsRequest(temporaryUser)];
	
	      types.forEach(function (type) {
	        var param = "";
	        if (type === "pd") {
	          param = "development";
	        } else if (type === "pm") {
	          param = "marketing";
	        } else if (type === "op") {
	          param = "operations";
	        } else if (type === "fn") {
	          param = "finance";
	        }
	
	        if (param !== "") {
	          requests.push(
	          // eslint-disable-next-line
	          getSubmissionDateRequest(param, null, undefined, temporaryUser));
	        }
	      });
	
	      var joinRequest = (0, _ApiService.batchRequest)(requests);
	
	      return joinRequest.then(function (res) {
	        var data = {};
	
	        types.forEach(function (type) {
	          data[type] = {
	            unaccepted: 0,
	            date: "N/A"
	          };
	        });
	
	        res.forEach(function (r, i) {
	          var rq = r.body;
	
	          if (i === 0) {
	            Object.keys(rq).forEach(function (field) {
	              if (types.includes(field.toLowerCase())) {
	                data[field.toLowerCase()].unaccepted = rq[field];
	              }
	            });
	          } else {
	            var date = "";
	
	            if (!rq[0] || rq[0].requested_at === null) {
	              date = "N/A";
	            } else {
	              var timezone = _jstz2.default.determine();
	              date = (0, _momentTimezone2.default)(rq[0].requested_at).tz(timezone.name()).format("MM/DD hh:mmA");
	            }
	
	            var type = types[i - 1];
	            data[type].date = date;
	          }
	        });
	
	        return new Promise(function (resolve, reject) {
	          resolve(data);
	
	          return null;
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "SubmitDecisions", "getSubmissionData");
	      });
	    }
	  }, {
	    key: "incrementUnacceptedDecisions",
	    value: function incrementUnacceptedDecisions(type) {
	      var value = Number(_reactjsLocalstorage.reactLocalStorage.get(type + "-unaccepted-decisions", "0")) + 1;
	      if (value === 0) {
	        value = 1;
	      }
	
	      _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", value);
	    }
	  }, {
	    key: "decrementUnacceptedDecisions",
	    value: function decrementUnacceptedDecisions(type) {
	      var value = Number(_reactjsLocalstorage.reactLocalStorage.get(type + "-unaccepted-decisions", "0")) - 1;
	      if (value === 0) {
	        value = -1;
	      }
	
	      _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", value);
	    }
	  }, {
	    key: "checkJournal",
	    value: function checkJournal(type, eventemitter, unaccepted_types, roundNumber, callback) {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + _Auth2.default.getGameId() + "/journal/?round_number=" + roundNumber).then(function (res) {
	        if (type === 'development') {
	          var history = res.body.filter(function (i) {
	            return i.round_number === roundNumber && (i.path.startsWith('/api/team/products/') || i.path.startsWith('/api/teams/submit_development/'));
	          });
	
	          history.sort(function (a, b) {
	            var dateA = new Date(a.requested_at);
	            var dateB = new Date(b.requested_at);
	
	            return dateB - dateA;
	          });
	
	          if (history.length > 0 && history[0].path === '/api/teams/submit_development/' && (history[0].status_code === 200 || history[0].status_code === 201)) {
	            eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	              "div",
	              null,
	              "Your decisions were successfully submitted. Your financials have been updated."
	            )]);
	
	            if (unaccepted_types.includes(type)) {
	              _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", 0);
	            }
	          }
	        } else if (type === 'marketing') {
	          var _history = res.body.filter(function (i) {
	            return i.round_number === roundNumber && (i.path.startsWith('/api/team/price_forecasts/') || i.path.startsWith('/api/team/promos/') || i.path.startsWith('/api/team/sales/'));
	          });
	
	          if (_history.length > 0) {
	            eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	              "div",
	              null,
	              "Your decisions were successfully submitted. Your financials have been updated."
	            )]);
	
	            if (unaccepted_types.includes(type)) {
	              _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", 0);
	            }
	          } else {
	            eventemitter.trigger("submit-decisions-event", ["info", _react2.default.createElement(
	              "div",
	              null,
	              "You haven't made a marketing decision this round therefore there's no decision to post."
	            )]);
	          }
	        } else if (type === 'operations') {
	          var _history2 = res.body.filter(function (i) {
	            return i.round_number === roundNumber && (i.path.startsWith('/api/team/factories/') || i.path.startsWith('/api/team/machines/') || i.path.startsWith('/api/team/product_manufactures/') || i.path.startsWith('/api/teams/submit_operations/'));
	          });
	          _history2 = _history2.sort(function (a, b) {
	            var dateA = new Date(a.requested_at);
	            var dateB = new Date(b.requested_at);
	
	            return dateB - dateA;
	          });
	
	          if (_history2.length > 0 && _history2[0].path === '/api/teams/submit_operations/' && (_history2[0].status_code === 200 || _history2[0].status_code === 201)) {
	            eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	              "div",
	              null,
	              "Your decisions were successfully submitted. Your financials have been updated."
	            )]);
	
	            if (unaccepted_types.includes(type)) {
	              _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", 0);
	            }
	          } else {
	            eventemitter.trigger("submit-decisions-event", ["info", _react2.default.createElement(
	              "div",
	              null,
	              "You haven't made an operation decision this round therefore there's no decision to post."
	            )]);
	          }
	        } else if (type === 'finance') {
	          var _history3 = res.body.filter(function (i) {
	            return i.round_number === roundNumber && (i.path.startsWith('/api/team/equities/') || i.path.startsWith('/api/team/debts/') || i.path.startsWith('/api/team/debt_repayments/') || i.path.startsWith('/api/team/dividends_payment/') || i.path.startsWith('/api/team/stock_repurchased/'));
	          });
	
	          if (_history3.length > 0) {
	            eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	              "div",
	              null,
	              "Your decisions were successfully submitted. Your financials have been updated."
	            )]);
	
	            if (unaccepted_types.includes(type)) {
	              _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", 0);
	            }
	          } else {
	            eventemitter.trigger("submit-decisions-event", ["info", _react2.default.createElement(
	              "div",
	              null,
	              "You haven't made a finance decision this round therefore there's no decision to post."
	            )]);
	          }
	        }
	
	        if (callback) {
	          callback();
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "handleSubmittedRequest",
	    value: function handleSubmittedRequest(success, type, eventemitter, unaccepted_types, roundNumber, callback, errorMessage) {
	      if (success === false) {
	        // The backend uses a stable sentinel string when Finance hasn't
	        // been posted yet — switch the user-facing message so they don't
	        // assume it's a cash-balance problem.
	        var isFinanceFirstError = typeof errorMessage === 'string' && errorMessage.toLowerCase().includes('finance decisions first');
	
	        var message = isFinanceFirstError ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "Submit Finance Decision First"
	          ),
	          _react2.default.createElement("br", null),
	          "Your Head of Finance or CEO needs to post/submit finance decisions before you can post any other decisons."
	        ) : _react2.default.createElement(
	          "div",
	          null,
	          "You don't have enough cash to post these decisions. If your Finance manager recently raised capital, have them post their Finance decisions first so that cash counts toward your balance."
	        );
	
	        eventemitter.trigger("submit-decisions-event", ["error", message]);
	
	        if (callback) {
	          callback();
	        }
	
	        return;
	      }
	
	      if (unaccepted_types.includes(type)) {
	        _reactjsLocalstorage.reactLocalStorage.set(type + "-unaccepted-decisions", 0);
	      }
	
	      // Refresh data first, then show validation warnings using fresh team-decisions data
	      if (callback) {
	        callback(function showWarnings(decisionsData, meta) {
	          var allPosted = !!(meta && meta.allPosted);
	
	          // Copy used when this submit finished the round's decisions.
	          // Kept in one place so every branch below (no-data path, per-type
	          // warning path, plain success path) can swap it in when the
	          // caller signals all four roles are posted with nothing pending.
	          var allPostedMessage = _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { style: {
	                  fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                  fontSize: 18,
	                  lineHeight: '26px',
	                  fontWeight: 700,
	                  color: 'rgba(0, 27, 59, 0.94)',
	                  marginBottom: 12
	                } },
	              "You're all set for this round."
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: {
	                  fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                  fontSize: 16,
	                  lineHeight: '24px',
	                  fontWeight: 400,
	                  color: 'rgba(0, 27, 59, 0.75)'
	                } },
	              "All four department decisions are posted. Sit tight while the round runs and results come in.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "b",
	                { style: { color: '#DC2626' } },
	                "Heads up:"
	              ),
	              " if anyone on the team edits a decision after this, that department flips back to unposted and the CEO will need to repost it before the deadline."
	            )
	          );
	
	          // Emits with 3rd arg = size. App.js passes it to DecisionsAlert,
	          // which renders the celebratory large variant instead of the
	          // routine toast.
	          var emitAllPosted = function emitAllPosted() {
	            return eventemitter.trigger("submit-decisions-event", ["success", allPostedMessage, "lg"]);
	          };
	
	          if (!decisionsData) {
	            if (allPosted) {
	              emitAllPosted();
	            } else {
	              eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	                "div",
	                null,
	                "Your decisions were successfully submitted. Your financials have been updated."
	              )]);
	            }
	            return;
	          }
	
	          if (type === 'development') {
	            var products = decisionsData.products || [];
	            var months_available = products.reduce(function (prev, curr) {
	              return prev + (curr.months_available_to_produce || 0);
	            }, 0);
	            if (months_available === 0) {
	              eventemitter.trigger("submit-decisions-event", ["warning", _react2.default.createElement(
	                "div",
	                null,
	                "Your financials have been updated, but there's a warning.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "b",
	                  { style: { color: '#ffb940' } },
	                  "Warning"
	                ),
	                ": You do not have at least 1 product that is set to be released this year. Will this impact your performance?"
	              )]);
	              return;
	            }
	          } else if (type === 'marketing') {
	            var priceForecast = decisionsData.price_forecasts || [];
	            var promos = decisionsData.promos || [];
	            var sales = decisionsData.sales || [];
	            var hasPrice0 = priceForecast.filter(function (i) {
	              return i.price === 0;
	            }).length > 0;
	            var spend = promos.reduce(function (prev, curr) {
	              return prev + curr.spend;
	            }, 0);
	            var total = sales.reduce(function (prev, curr) {
	              return prev + curr.total;
	            }, 0);
	
	            if (hasPrice0 || spend === 0 || total === 0) {
	              eventemitter.trigger("submit-decisions-event", ["warning", _react2.default.createElement(
	                "div",
	                null,
	                "Your financials have been updated, but there's a warning.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "b",
	                  { style: { color: '#ffb940' } },
	                  "Warning"
	                ),
	                ": You haven't made all of your decisions. Please make sure you've made pricing, promo, and sales channel decisions."
	              )]);
	              return;
	            }
	          } else if (type === 'operations') {
	            var inventoryBalances = decisionsData.inventory_balances || [];
	            // Skip the warning if the caller's role doesn't include
	            // inventory_balances in the response. e.g., the CEO page
	            // refreshes with role='ceo' after any submit, and that
	            // payload omits inventory_balances — treating that as
	            // "empty inventory" would fire a false-positive low-inventory
	            // warning even when the OP page shows plenty of units.
	            if (inventoryBalances.length === 0) {
	              if (allPosted) {
	                emitAllPosted();
	              } else {
	                eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	                  "div",
	                  null,
	                  "Your decisions were successfully submitted. Your financials have been updated."
	                )]);
	              }
	              return;
	            }
	            var available_for_sale = inventoryBalances.reduce(function (prev, curr) {
	              return prev + (curr.available_for_sale || 0);
	            }, 0);
	
	            if (available_for_sale <= 100000) {
	              eventemitter.trigger("submit-decisions-event", ["warning", _react2.default.createElement(
	                "div",
	                null,
	                "Your financials have been updated, but there's a warning.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "b",
	                  { style: { color: '#ffb940' } },
	                  "Warning"
	                ),
	                ": You have low inventory. Please consider producing more units."
	              )]);
	              return;
	            }
	          }
	
	          // No warnings — show success (celebration variant if this was
	          // the final of four posts, plain toast otherwise).
	          if (allPosted) {
	            emitAllPosted();
	          } else {
	            eventemitter.trigger("submit-decisions-event", ["success", _react2.default.createElement(
	              "div",
	              null,
	              "Your decisions were successfully submitted. Your financials have been updated."
	            )]);
	          }
	        });
	      }
	    }
	  }, {
	    key: "submitDecisions",
	    value: function submitDecisions(type, roundNumber, callback) {
	      var eventemitter = _eventEmitter2.default.getInstance();
	      var role = _Auth2.default.getRole();
	
	      if (type === "development" && role !== "CEO" && role !== "PD") {
	        eventemitter.trigger("app-show-error", [AUTHORIZATION_ERROR.replace("%ROLE%", "product development")]);
	        callback();
	        return;
	      }
	
	      if (type === "marketing" && role !== "CEO" && role !== "PM") {
	        eventemitter.trigger("app-show-error", [AUTHORIZATION_ERROR.replace("%ROLE%", "product marketing")]);
	        callback();
	        return;
	      }
	
	      if (type === "operations" && role !== "CEO" && role !== "OP") {
	        eventemitter.trigger("app-show-error", [AUTHORIZATION_ERROR.replace("%ROLE%", "operations")]);
	        callback();
	        return;
	      }
	
	      if (type === "finance" && role !== "CEO" && role !== "FI") {
	        eventemitter.trigger("app-show-error", [AUTHORIZATION_ERROR.replace("%ROLE%", "finance")]);
	        callback();
	        return;
	      }
	
	      var unaccepted_types = ["development", "marketing", "finance", "operations"];
	
	      // eslint-disable-next-line
	      submitDecisionsRequest(type).then(function (res) {
	        var body = res.body || {};
	        var success = body.success;
	
	        handleSubmittedRequest(success, type, eventemitter, unaccepted_types, roundNumber, callback, body.error);
	      }).catch(function (err) {
	        if (err.response && err.response.status === 400) {
	          // The 400 body carries `{ success: false, error: "..." }` —
	          // grab the error string so we can swap in the Finance-first
	          // alert when that's what the backend reported.
	          var body = err.response && err.response.body || {};
	          handleSubmittedRequest(false, type, eventemitter, unaccepted_types, roundNumber, callback, body.error);
	        } else {
	          (0, _utils.logError)(err, "SubmitDecisions", "submitDecisions");
	        }
	      });
	    }
	  }]);
	
	  return SubmitDecisions;
	}();
	
	var submitDecisionsRequest = SubmitDecisions.prototype.submitDecisionsRequest;
	var getUnacceptedDecisionsRequest = SubmitDecisions.prototype.getUnacceptedDecisionsRequest;
	var getSubmissionDateRequest = SubmitDecisions.prototype.getSubmissionDateRequest;
	var handleSubmittedRequest = SubmitDecisions.prototype.handleSubmittedRequest;
	
	var submitDecisions = exports.submitDecisions = SubmitDecisions.prototype.submitDecisions;
	var getSubmissionData = exports.getSubmissionData = SubmitDecisions.prototype.getSubmissionData;
	var getSubmissionRequest = exports.getSubmissionRequest = SubmitDecisions.prototype.getSubmissionRequest;
	var handleSubmission = exports.handleSubmission = SubmitDecisions.prototype.handleSubmission;
	var incrementUnacceptedDecisions = exports.incrementUnacceptedDecisions = SubmitDecisions.prototype.incrementUnacceptedDecisions;
	var decrementUnacceptedDecisions = exports.decrementUnacceptedDecisions = SubmitDecisions.prototype.decrementUnacceptedDecisions;
	var checkJournal = exports.checkJournal = SubmitDecisions.prototype.checkJournal;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCompetitionTeams = exports.getField = exports.teamColors = exports.teamColor = exports.pickMillions = exports.pickPercent = exports.pickValue = exports.getTeam = exports.getPerformanceValues = exports.getInstructorsDashboardPerformanceColors = undefined;
	
	var _lodash = __webpack_require__(21);
	
	var _Teams = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TOP_COLOR = "#52C5CD";
	var BOTTOM_COLOR = "#FF5252";
	
	var getInstructorsDashboardPerformanceColors = exports.getInstructorsDashboardPerformanceColors = function getInstructorsDashboardPerformanceColors(count) {
	  var result = ["top", "top", "bottom", "bottom"].slice(0, count);
	
	  for (var i = 0, length = count - 4; i < length; i++) {
	    result.push(i % 2 === 0 ? "top" : "bottom");
	  }
	
	  result.sort(function (a, b) {
	    if (a === b) {
	      return 0;
	    }
	
	    if (a === "top" && b === "bottom") {
	      return -1;
	    }
	
	    return 1;
	  });
	
	  return result.map(function (i) {
	    return i === "top" ? TOP_COLOR : BOTTOM_COLOR;
	  });
	};
	
	var getPerformanceValues = exports.getPerformanceValues = function getPerformanceValues(values) {
	  var entities = (0, _lodash.orderBy)(values, ["value"], ["desc"]);
	  var result = [];
	
	  if (entities.length > 0) {
	    result.push(entities.shift());
	  }
	
	  if (entities.length > 0) {
	    result.push(entities.shift());
	  }
	
	  if (entities.length > 0) {
	    result.push(entities.pop());
	  }
	
	  if (entities.length > 0) {
	    result.push(entities.pop());
	  }
	
	  var isTop = true;
	  while (entities.length > 0) {
	    if (isTop === true) {
	      result.push(entities.shift());
	      isTop = false;
	    } else {
	      result.push(entities.pop());
	      isTop = true;
	    }
	  }
	
	  result = (0, _lodash.orderBy)(result, ["value"], ["desc"]);
	  if (result.length > 10) {
	    result = [].concat(_toConsumableArray(result.slice(0, 5)), _toConsumableArray(result.slice(-5)));
	  }
	
	  return result;
	};
	
	var getTeam = exports.getTeam = function getTeam(teamId, competitiveAnalysis) {
	  return (0, _lodash.find)(competitiveAnalysis, function (team) {
	    return team["team"] === teamId;
	  }) || {};
	};
	
	var pickValue = exports.pickValue = function pickValue(teams, metrics, field) {
	  var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "name";
	  return (0, _lodash.map)(metrics, function (metric) {
	    var _ref;
	
	    return _ref = {
	      id: ((0, _lodash.find)(teams, function (team) {
	        return team.id === metric.team;
	      }) || {}).id
	    }, _defineProperty(_ref, key, ((0, _lodash.find)(teams, function (team) {
	      return team.id === metric.team;
	    }) || {}).name), _defineProperty(_ref, "value", metric && metric[field] ? metric[field] : 0), _ref;
	  });
	};
	
	var pickPercent = exports.pickPercent = function pickPercent(teams, metrics, field) {
	  return (0, _lodash.map)(pickValue(teams, metrics, field), function (metric) {
	    return Object.assign({}, metric, {
	      value: metric.value * 100
	    });
	  });
	};
	
	var pickMillions = exports.pickMillions = function pickMillions(teams, metrics, field) {
	  return (0, _lodash.map)(pickValue(teams, metrics, field), function (metric) {
	    return Object.assign({}, metric, {
	      value: metric.value / 1e6
	    });
	  });
	};
	
	var teamColor = exports.teamColor = function teamColor(teams, teamId) {
	  return (0, _Teams.colorForTeamId)(teams, teamId);
	};
	
	var teamColors = exports.teamColors = function teamColors(teams, data) {
	  return (0, _lodash.map)(data, function (row) {
	    return teamColor(teams, row.team);
	  });
	};
	
	var getField = exports.getField = function getField(field, fieldMatch, products, id) {
	  var product = (0, _lodash.find)(products, function (product) {
	    return product[fieldMatch] === id;
	  });
	  if ((0, _lodash.isNil)(product)) {
	    return id;
	  }
	
	  return product[field];
	};
	
	var getCompetitionTeams = exports.getCompetitionTeams = function getCompetitionTeams(teams, teamId) {
	  var myTeam = (0, _lodash.find)(teams, function (team) {
	    return team.id === teamId;
	  });
	  return (0, _lodash.filter)(teams, function (team) {
	    return team.competition === myTeam.competition;
	  });
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ["children", "className"]);
	
	  var layerClass = (0, _classnames["default"])('recharts-layer', className);
	  return _react["default"].createElement("g", _extends({
	    className: layerClass
	  }, others), children);
	}
	
	Layer.propTypes = propTypes;
	var _default = Layer;
	exports["default"] = _default;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var _extends = _interopDefault(__webpack_require__(568));
	var shallowEqual = _interopDefault(__webpack_require__(332));
	var _inheritsLoose = _interopDefault(__webpack_require__(1069));
	var reactLifecyclesCompat = __webpack_require__(534);
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(1070));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(2527));
	var changeEmitter = __webpack_require__(1558);
	var $$observable = _interopDefault(__webpack_require__(2552));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + "(" + getDisplayName(BaseComponent) + ")";
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	
	    return MapProps;
	  };
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          computedProps: propsMapper(_this.props),
	          prevProps: _this.props
	        };
	        return _this;
	      }
	
	      WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	        if (shouldMap(prevState.prevProps, nextProps)) {
	          return {
	            computedProps: propsMapper(nextProps),
	            prevProps: nextProps
	          };
	        }
	
	        return {
	          prevProps: nextProps
	        };
	      };
	
	      var _proto = WithPropsOnChange.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    reactLifecyclesCompat.polyfill(WithPropsOnChange);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	
	
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.handlers = mapValues(typeof handlers === 'function' ? handlers(_this.props) : handlers, function (createHandler) {
	          return function () {
	            var handler = createHandler(_this.props);
	
	            if (false) {
	              console.error( // eslint-disable-line no-console
	              'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	            }
	
	            return handler.apply(void 0, arguments);
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	
	    DefaultProps.defaultProps = props;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = _extends({}, obj);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _extends2;
	
	    return _extends({}, omit(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var keys = Object.keys;
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithState, _Component);
	
	      function WithState() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        };
	
	        _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithState.prototype;
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.state = typeof initialState === 'function' ? initialState(_this.props) : initialState;
	        _this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	          return function (mayBeEvent) {
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            // Having that functional form of setState can be called async
	            // we need to persist SyntheticEvent
	            if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	              mayBeEvent.persist();
	            }
	
	            _this.setState(function (state, props) {
	              return handler(state, props).apply(void 0, [mayBeEvent].concat(args));
	            });
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithStateHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	
	    return WithStateHandlers;
	  };
	};
	
	var noop = function noop() {};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithReducer, _Component);
	
	      function WithReducer() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: _this.initializeStateValue()
	        };
	
	        _this.dispatch = function (action, callback) {
	          if (callback === void 0) {
	            callback = noop;
	          }
	
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          }, function () {
	            return callback(_this.state.stateValue);
	          });
	        };
	
	        return _this;
	      }
	
	      var _proto = WithReducer.prototype;
	
	      _proto.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	
	        return reducer(undefined, {
	          type: '@@recompose/INIT'
	        });
	      };
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left, right) {
	  if (right === void 0) {
	    right = identity;
	  }
	
	  return function (BaseComponent) {
	    var leftFactory;
	    var rightFactory;
	
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = React.createFactory(Component);
	
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
	    }
	
	    return RenderComponent;
	  };
	};
	
	var Nothing =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Nothing, _Component);
	
	  function Nothing() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Nothing.prototype;
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = ShouldUpdate.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ("component with display name \"" + getDisplayName(BaseComponent) + "\"."));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContext, _Component);
	
	      function WithContext() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	
	        _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContext.prototype;
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	
	    return GetContext;
	  };
	};
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(Lifecycle, _Component);
	
	      function Lifecycle() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = Lifecycle.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  var _class, _temp;
	
	  return isClassComponent(baseComponent) ? baseComponent : (_temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(ToClass, _Component);
	
	    function ToClass() {
	      return _Component.apply(this, arguments) || this;
	    }
	
	    var _proto = ToClass.prototype;
	
	    _proto.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component), _class.displayName = getDisplayName(baseComponent), _class.propTypes = baseComponent.propTypes, _class.contextTypes = baseComponent.contextTypes, _class.defaultProps = baseComponent.defaultProps, _temp);
	};
	
	function toRenderProps(hoc) {
	  var RenderPropsComponent = function RenderPropsComponent(props) {
	    return props.children(props);
	  };
	
	  return hoc(RenderPropsComponent);
	}
	
	var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
	  if (renderPropName === void 0) {
	    renderPropName = 'children';
	  }
	
	  return function (BaseComponent) {
	    var baseFactory = React__default.createFactory(BaseComponent);
	    var renderPropsFactory = React__default.createFactory(RenderPropsComponent);
	
	    var FromRenderProps = function FromRenderProps(ownerProps) {
	      var _renderPropsFactory;
	
	      return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
	        return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
	      }, _renderPropsFactory));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'fromRenderProps'))(FromRenderProps);
	    }
	
	    return FromRenderProps;
	  };
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	var compose = function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  }, function (arg) {
	    return arg;
	  });
	};
	
	var createSink = function createSink(callback) {
	  var Sink =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Sink, _Component);
	
	    function Sink() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.state = {};
	      return _this;
	    }
	
	    Sink.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	      callback(nextProps);
	      return null;
	    };
	
	    var _proto = Sink.prototype;
	
	    _proto.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	
	  reactLifecyclesCompat.polyfill(Sink);
	  return Sink;
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	
	  Component.displayName = "componentFromProp(" + propName + ")";
	  return Component;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	
	  var Nest = function Nest(_ref) {
	    var children = _ref.children,
	        props = _objectWithoutPropertiesLoose(_ref, ["children"]);
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = "nest(" + displayNames.join(', ') + ")";
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent, blacklist) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent, blacklist);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return (
	      /*#__PURE__*/
	      function (_Component) {
	        _inheritsLoose(ComponentFromStream, _Component);
	
	        function ComponentFromStream() {
	          var _config$fromESObserva;
	
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	          _this.state = {
	            vdom: null
	          };
	          _this.propsEmitter = changeEmitter.createChangeEmitter();
	          _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	            subscribe: function subscribe(observer) {
	              var unsubscribe = _this.propsEmitter.listen(function (props) {
	                if (props) {
	                  observer.next(props);
	                } else {
	                  observer.complete();
	                }
	              });
	
	              return {
	                unsubscribe: unsubscribe
	              };
	            }
	          }, _config$fromESObserva[$$observable] = function () {
	            return this;
	          }, _config$fromESObserva));
	          _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$));
	          return _this;
	        }
	
	        var _proto = ComponentFromStream.prototype;
	
	        _proto.componentWillMount = function componentWillMount() {
	          var _this2 = this;
	
	          // Subscribe to child prop changes so we know when to re-render
	          this.subscription = this.vdom$.subscribe({
	            next: function next(vdom) {
	              _this2.setState({
	                vdom: vdom
	              });
	            }
	          });
	          this.propsEmitter.emit(this.props);
	        };
	
	        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	          // Receive new props from the owner
	          this.propsEmitter.emit(nextProps);
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	          return nextState.vdom !== this.state.vdom;
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          // Call without arguments to complete stream
	          this.propsEmitter.emit(); // Clean-up subscription before un-mounting
	
	          this.subscription.unsubscribe();
	        };
	
	        _proto.render = function render() {
	          return this.state.vdom;
	        };
	
	        return ComponentFromStream;
	      }(React.Component)
	    );
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream$$1 = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	      return componentFromStream$$1(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.toRenderProps = toRenderProps;
	exports.fromRenderProps = fromRenderProps;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSurveyStarted = exports.isSurveyFinished = undefined;
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isSurveyFinished = exports.isSurveyFinished = function isSurveyFinished(survey) {
	  var surveyEndDate = (0, _moment2.default)(survey.end);
	  var currentDate = _moment2.default.utc();
	
	  return currentDate.isAfter(surveyEndDate);
	};
	
	var isSurveyStarted = exports.isSurveyStarted = function isSurveyStarted(survey) {
	  var surveyStartDate = (0, _moment2.default)(survey.start);
	  var currentDate = _moment2.default.utc();
	
	  return currentDate.isAfter(surveyStartDate);
	};

/***/ },
/* 57 */
[2708, 26, 637, 131, 51],
/* 58 */
[2758, 357],
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var DOMProperty = __webpack_require__(241);
	var ReactDOMComponentFlags = __webpack_require__(960);
	
	var invariant = __webpack_require__(29);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function noop() {}
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
	
	function removeLeadingZero(numStr) {
	  //remove leading zeros
	  return numStr.replace(/^0+/, '') || '0';
	}
	
	/**
	 * limit decimal numbers to given precision
	 * Not used .fixedTo because that will break with big numbers
	 */
	function limitToPrecision(numStr, precision) {
	  var str = '';
	  for (var i = 0; i <= precision - 1; i++) {
	    str += numStr[i] || '0';
	  }
	  return str;
	}
	
	/**
	 * This method is required to round prop value to given precision.
	 * Not used .round or .fixedTo because that will break with big numbers
	 */
	function roundToPrecision(numStr, precision) {
	  var numberParts = numStr.split('.');
	  var roundedDecimalParts = parseFloat('0.' + (numberParts[1] || '0')).toFixed(precision).split('.');
	  var intPart = numberParts[0].split('').reverse().reduce(function (roundedStr, current, idx) {
	    if (roundedStr.length > idx) {
	      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
	    }
	    return current + roundedStr;
	  }, roundedDecimalParts[0]);
	
	  var decimalPart = roundedDecimalParts[1];
	
	  return intPart + (decimalPart ? '.' + decimalPart : '');
	}
	
	function omit(obj, keyMaps) {
	  var filteredObj = {};
	  Object.keys(obj).forEach(function (key) {
	    if (!keyMaps[key]) filteredObj[key] = obj[key];
	  });
	  return filteredObj;
	}
	
	var propTypes = {
	  thousandSeparator: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([true])]),
	  decimalSeparator: _propTypes2.default.string,
	  decimalPrecision: _propTypes2.default.number,
	  displayType: _propTypes2.default.oneOf(['input', 'text']),
	  prefix: _propTypes2.default.string,
	  suffix: _propTypes2.default.string,
	  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  mask: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  customInput: _propTypes2.default.func,
	  allowNegative: _propTypes2.default.bool,
	  onKeyDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf(['text', 'tel']),
	  isAllowed: _propTypes2.default.func
	};
	
	var defaultProps = {
	  displayType: 'input',
	  decimalSeparator: '.',
	  prefix: '',
	  suffix: '',
	  allowNegative: true,
	  type: 'text',
	  onChange: noop,
	  onKeyDown: noop,
	  onMouseUp: noop,
	  isAllowed: function isAllowed() {
	    return true;
	  }
	};
	
	var NumberFormat = function (_React$Component) {
	  _inherits(NumberFormat, _React$Component);
	
	  function NumberFormat(props) {
	    _classCallCheck(this, NumberFormat);
	
	    var _this = _possibleConstructorReturn(this, (NumberFormat.__proto__ || Object.getPrototypeOf(NumberFormat)).call(this, props));
	
	    var value = _this.optimizeValueProp(props);
	    _this.state = {
	      value: _this.formatInput(value).formattedValue
	    };
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(NumberFormat, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.updateValueIfRequired(prevProps, prevState);
	    }
	  }, {
	    key: 'updateValueIfRequired',
	    value: function updateValueIfRequired(prevProps) {
	      var props = this.props,
	          state = this.state;
	
	
	      if (prevProps !== props) {
	        var stateValue = state.value;
	
	        var value = this.optimizeValueProp(props);
	        if (value === undefined) value = stateValue;
	
	        var _formatInput = this.formatInput(value),
	            formattedValue = _formatInput.formattedValue;
	
	        if (formattedValue !== stateValue) {
	          this.setState({
	            value: formattedValue
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getFloatString',
	    value: function getFloatString(num, props) {
	      props = props || this.props;
	
	      var _getSeparators = this.getSeparators(props),
	          decimalSeparator = _getSeparators.decimalSeparator,
	          thousandSeparator = _getSeparators.thousandSeparator;
	
	      return (num || '').replace(new RegExp(escapeRegExp(thousandSeparator || ''), 'g'), '').replace(decimalSeparator, '.');
	    }
	  }, {
	    key: 'getFloatValue',
	    value: function getFloatValue(num, props) {
	      props = props || this.props;
	      return parseFloat(this.getFloatString(num, props)) || 0;
	    }
	  }, {
	    key: 'optimizeValueProp',
	    value: function optimizeValueProp(props) {
	      var _getSeparators2 = this.getSeparators(props),
	          decimalSeparator = _getSeparators2.decimalSeparator;
	
	      var decimalPrecision = props.decimalPrecision,
	          format = props.format;
	      var value = props.value;
	
	
	      if (format || !(value || value === 0)) return value;
	
	      var isNumber = typeof value === 'number';
	
	      if (isNumber) value = value.toString();
	
	      value = this.removePrefixAndSuffix(isNumber ? value : this.getFloatString(value, props), props);
	
	      //round off value
	      if (typeof decimalPrecision === 'number') value = roundToPrecision(value, decimalPrecision);
	
	      //correct decimal separator
	      if (decimalSeparator) {
	        value = value.replace('.', decimalSeparator);
	      }
	
	      //throw error if value has two decimal seperators
	      if (value.split(decimalSeparator).length > 2) {
	        throw new Error('\n          Wrong input for value props.\n\n          More than one decimalSeparator found\n       ');
	      }
	
	      //if decimalPrecision is 0 remove decimalNumbers
	      if (decimalPrecision === 0) return value.split(decimalSeparator)[0];
	
	      return value;
	    }
	  }, {
	    key: 'removePrefixAndSuffix',
	    value: function removePrefixAndSuffix(val, props) {
	      var format = props.format,
	          prefix = props.prefix,
	          suffix = props.suffix;
	
	      //remove prefix and suffix
	
	      if (!format && val) {
	        var isNegative = val[0] === '-';
	
	        //remove negation sign
	        if (isNegative) val = val.substring(1, val.length);
	
	        //remove prefix
	        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;
	
	        //remove suffix
	        var suffixLastIndex = val.lastIndexOf(suffix);
	        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;
	
	        //add negation sign back
	        if (isNegative) val = '-' + val;
	      }
	
	      return val;
	    }
	  }, {
	    key: 'getSeparators',
	    value: function getSeparators(props) {
	      props = props || this.props;
	
	      var _props = props,
	          decimalSeparator = _props.decimalSeparator;
	      var _props2 = props,
	          thousandSeparator = _props2.thousandSeparator;
	
	
	      if (thousandSeparator === true) {
	        thousandSeparator = ',';
	      }
	
	      if (decimalSeparator === thousandSeparator) {
	        throw new Error('\n          Decimal separator can\'t be same as thousand separator.\n\n          thousandSeparator: ' + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + ' (default value for decimalSeparator is .)\n       ');
	      }
	
	      return {
	        decimalSeparator: decimalSeparator,
	        thousandSeparator: thousandSeparator
	      };
	    }
	  }, {
	    key: 'getNumberRegex',
	    value: function getNumberRegex(g, ignoreDecimalSeparator) {
	      var _props3 = this.props,
	          format = _props3.format,
	          decimalPrecision = _props3.decimalPrecision;
	
	      var _getSeparators3 = this.getSeparators(),
	          decimalSeparator = _getSeparators3.decimalSeparator;
	
	      return new RegExp('\\d' + (decimalSeparator && decimalPrecision !== 0 && !ignoreDecimalSeparator && !format ? '|' + escapeRegExp(decimalSeparator) : ''), g ? 'g' : undefined);
	    }
	  }, {
	    key: 'setCaretPosition',
	    value: function setCaretPosition(el, caretPos) {
	      el.value = el.value;
	      // ^ this is used to not only get "focus", but
	      // to make sure we don't have it everything -selected-
	      // (it causes an issue in chrome, and having it doesn't hurt any other browser)
	      if (el !== null) {
	        if (el.createTextRange) {
	          var range = el.createTextRange();
	          range.move('character', caretPos);
	          range.select();
	          return true;
	        }
	        // (el.selectionStart === 0 added for Firefox bug)
	        if (el.selectionStart || el.selectionStart === 0) {
	          el.focus();
	          el.setSelectionRange(caretPos, caretPos);
	          return true;
	        }
	
	        // fail city, fortunately this never happens (as far as I've tested) :)
	        el.focus();
	        return false;
	      }
	    }
	  }, {
	    key: 'setPatchedCaretPosition',
	    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
	      var _this2 = this;
	
	      /*
	      setting caret position within timeout of 0ms is required for mobile chrome,
	      otherwise browser resets the caret position after we set it
	      We are also setting it without timeout so that in normal browser we don't see the flickering
	      */
	      this.setCaretPosition(el, caretPos);
	      setTimeout(function () {
	        if (el.value === currentValue) _this2.setCaretPosition(el, caretPos);
	      }, 0);
	    }
	
	    /* This keeps the caret within typing area so people can't type in between prefix or suffix */
	
	  }, {
	    key: 'correctCaretPosition',
	    value: function correctCaretPosition(value, caretPos) {
	      var _props4 = this.props,
	          prefix = _props4.prefix,
	          suffix = _props4.suffix;
	
	      return Math.min(Math.max(caretPos, prefix.length), value.length - suffix.length);
	    }
	  }, {
	    key: 'formatWithPattern',
	    value: function formatWithPattern(str) {
	      var _props5 = this.props,
	          format = _props5.format,
	          mask = _props5.mask;
	
	      if (!format) return str;
	      var hashCount = format.split('#').length - 1;
	      var hashIdx = 0;
	      var frmtdStr = format;
	
	      for (var i = 0, ln = str.length; i < ln; i++) {
	        if (i < hashCount) {
	          hashIdx = frmtdStr.indexOf('#');
	          frmtdStr = frmtdStr.replace('#', str[i]);
	        }
	      }
	
	      var lastIdx = frmtdStr.lastIndexOf('#');
	
	      if (mask) {
	        return frmtdStr.replace(/#/g, mask);
	      }
	      return frmtdStr.substring(0, hashIdx + 1) + (lastIdx !== -1 ? frmtdStr.substring(lastIdx + 1, frmtdStr.length) : '');
	    }
	  }, {
	    key: 'formatInput',
	    value: function formatInput(val) {
	      var props = this.props,
	          removePrefixAndSuffix = this.removePrefixAndSuffix;
	      var prefix = props.prefix,
	          suffix = props.suffix,
	          mask = props.mask,
	          format = props.format,
	          allowNegative = props.allowNegative,
	          decimalPrecision = props.decimalPrecision;
	
	      var _getSeparators4 = this.getSeparators(),
	          thousandSeparator = _getSeparators4.thousandSeparator,
	          decimalSeparator = _getSeparators4.decimalSeparator;
	
	      var maskPattern = format && typeof format == 'string' && !!mask;
	      var numRegex = this.getNumberRegex(true);
	      var hasNegative = void 0,
	          removeNegative = void 0;
	
	      //change val to string if its number
	      if (typeof val === 'number') val = val + '';
	
	      var negativeRegex = new RegExp('(-)');
	      var doubleNegativeRegex = new RegExp('(-)(.)*(-)');
	
	      //check if it has negative numbers
	      if (allowNegative && !format) {
	        // Check number has '-' value
	        hasNegative = negativeRegex.test(val);
	        // Check number has 2 or more '-' values
	        removeNegative = doubleNegativeRegex.test(val);
	      }
	
	      //remove prefix and suffix
	      val = removePrefixAndSuffix(val, props);
	
	      var valMatch = val && val.match(numRegex);
	
	      if (!valMatch && removeNegative) {
	        return { value: '', formattedValue: '' };
	      } else if (!valMatch && hasNegative) {
	        return { value: '', formattedValue: '-' };
	      } else if (!valMatch) {
	        return { value: '', formattedValue: maskPattern ? '' : '' };
	      }
	
	      var num = val.match(numRegex).join('');
	
	      var formattedValue = num;
	
	      if (format) {
	        if (typeof format == 'string') {
	          formattedValue = this.formatWithPattern(formattedValue);
	        } else if (typeof format == 'function') {
	          formattedValue = format(formattedValue);
	        }
	      } else {
	        var hasDecimalSeparator = formattedValue.indexOf(decimalSeparator) !== -1 || decimalPrecision;
	
	        var parts = formattedValue.split(decimalSeparator);
	        var beforeDecimal = parts[0];
	        var afterDecimal = parts[1] || '';
	
	        //remove leading zeros from number before decimal
	        beforeDecimal = removeLeadingZero(beforeDecimal);
	
	        //apply decimal precision if its defined
	        if (decimalPrecision !== undefined) afterDecimal = limitToPrecision(afterDecimal, decimalPrecision);
	
	        if (thousandSeparator) {
	          beforeDecimal = beforeDecimal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator);
	        }
	
	        //add prefix and suffix
	        if (prefix) beforeDecimal = prefix + beforeDecimal;
	        if (suffix) afterDecimal = afterDecimal + suffix;
	
	        if (hasNegative && !removeNegative) beforeDecimal = '-' + beforeDecimal;
	
	        formattedValue = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
	      }
	
	      return {
	        value: (hasNegative && !removeNegative ? '-' : '') + removePrefixAndSuffix(formattedValue, props).match(numRegex).join(''),
	        formattedValue: formattedValue
	      };
	    }
	  }, {
	    key: 'getCaretPosition',
	    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
	      var numRegex = this.getNumberRegex(true);
	      var inputNumber = (inputValue.match(numRegex) || []).join('');
	      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
	      var j = void 0,
	          i = void 0;
	
	      j = 0;
	
	      for (i = 0; i < caretPos; i++) {
	        var currentInputChar = inputValue[i];
	        var currentFormatChar = formattedValue[j] || '';
	        //no need to increase new cursor position if formatted value does not have those characters
	        //case inputValue = 1a23 and formattedValue =  123
	        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue;
	
	        //When we are striping out leading zeros maintain the new cursor position
	        //Case inputValue = 00023 and formattedValue = 23;
	        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue;
	
	        //we are not using currentFormatChar because j can change here
	        while (currentInputChar !== formattedValue[j] && !(formattedValue[j] || '').match(numRegex) && j < formattedValue.length) {
	          j++;
	        }j++;
	      }
	
	      //correct caret position if its outsize of editable area
	      j = this.correctCaretPosition(formattedValue, j);
	
	      return j;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      e.persist();
	      var el = e.target;
	      var inputValue = el.value;
	      var state = this.state,
	          props = this.props;
	      var isAllowed = props.isAllowed;
	
	      var lastValue = state.value;
	
	      var _formatInput2 = this.formatInput(inputValue),
	          formattedValue = _formatInput2.formattedValue,
	          value = _formatInput2.value; // eslint-disable-line prefer-const
	
	      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
	
	
	      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);
	
	      var valueObj = {
	        formattedValue: formattedValue,
	        value: value,
	        floatValue: this.getFloatValue(value)
	      };
	
	      if (!isAllowed(valueObj)) {
	        formattedValue = lastValue;
	      }
	
	      //set the value imperatively, this is required for IE fix
	      el.value = formattedValue;
	
	      //get the caret position
	      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
	
	      //set caret position
	      this.setPatchedCaretPosition(el, caretPos, formattedValue);
	
	      //change the state
	      if (formattedValue !== lastValue) {
	        this.setState({ value: formattedValue }, function () {
	          props.onChange(e, valueObj);
	        });
	      }
	
	      return value;
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      var el = e.target;
	      var selectionEnd = el.selectionEnd,
	          value = el.value;
	      var selectionStart = el.selectionStart;
	      var _props6 = this.props,
	          decimalPrecision = _props6.decimalPrecision,
	          prefix = _props6.prefix,
	          suffix = _props6.suffix;
	      var key = e.key;
	
	      var numRegex = this.getNumberRegex(false, decimalPrecision !== undefined);
	      var negativeRegex = new RegExp('-');
	
	      //Handle backspace and delete against non numerical/decimal characters
	      if (selectionStart === selectionEnd) {
	        var newCaretPosition = selectionStart;
	
	        if (key === 'ArrowLeft' || key === 'ArrowRight') {
	          selectionStart += key === 'ArrowLeft' ? -1 : +1;
	          newCaretPosition = this.correctCaretPosition(value, selectionStart);
	        } else if (key === 'Delete' && !numRegex.test(value[selectionStart]) && !negativeRegex.test(value[selectionStart])) {
	          while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < value.length - suffix.length) {
	            newCaretPosition++;
	          }
	        } else if (key === 'Backspace' && !numRegex.test(value[selectionStart - 1]) && !negativeRegex.test(value[selectionStart - 1])) {
	          while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > prefix.length) {
	            newCaretPosition--;
	          }
	        }
	
	        if (newCaretPosition !== selectionStart) {
	          e.preventDefault();
	          this.setPatchedCaretPosition(el, newCaretPosition, value);
	        }
	      }
	
	      this.props.onKeyDown(e);
	    }
	  }, {
	    key: 'onMouseUp',
	    value: function onMouseUp(e) {
	      var el = e.target;
	      var selectionStart = el.selectionStart,
	          selectionEnd = el.selectionEnd,
	          value = el.value;
	
	
	      if (selectionStart === selectionEnd) {
	        var caretPostion = this.correctCaretPosition(value, selectionStart);
	        if (caretPostion !== selectionStart) {
	          this.setPatchedCaretPosition(el, caretPostion, value);
	        }
	      }
	
	      this.props.onMouseUp(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = omit(this.props, propTypes);
	
	      var inputProps = _extends({}, props, {
	        type: this.props.type,
	        value: this.state.value,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onMouseUp: this.onMouseUp
	      });
	
	      if (this.props.displayType === 'text') {
	        return _react2.default.createElement(
	          'span',
	          props,
	          this.state.value
	        );
	      } else if (this.props.customInput) {
	        var CustomInput = this.props.customInput;
	        return _react2.default.createElement(CustomInput, inputProps);
	      }
	
	      return _react2.default.createElement('input', inputProps);
	    }
	  }]);
	
	  return NumberFormat;
	}(_react2.default.Component);
	
	NumberFormat.propTypes = propTypes;
	NumberFormat.defaultProps = defaultProps;
	
	module.exports = NumberFormat;


/***/ },
/* 61 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearMetricsCache = clearMetricsCache;
	exports.fetchCompetitionMetrics = fetchCompetitionMetrics;
	exports.fetchTeamMetrics = fetchTeamMetrics;
	exports.mapToCompetitiveAnalysis = mapToCompetitiveAnalysis;
	exports.fetchCompetitiveAnalysis = fetchCompetitiveAnalysis;
	
	var _ApiService = __webpack_require__(4);
	
	var API_URL = ("https://be-production-itb.marketgames.io/api/");
	
	// In-memory cache keyed by "competitionId-roundId"
	// Stores resolved data AND pending promises to avoid duplicate in-flight requests
	var _cache = {};
	var _pending = {};
	
	// Field name mapping: CAReport field -> MetricsReport field
	var CA_FIELD_MAP = {
	  average_selling_price_auto: "avg_revenues_per_unit_auto",
	  average_selling_price_mobile: "avg_revenues_per_unit_mobile",
	  direct_sales_spend: "salesrep",
	  average_unit_cost: "average_unit_costs",
	  human_utilization: "weighted_labor_utilization_rate",
	  machine_utilization: "weighted_machine_utilization_rate",
	  market_capitalization: "total_market_capital",
	  digital_marketing_spend: "digital_marketing",
	  traditional_marketing_spend: "traditional_marketing",
	  cost_of_capital: "capm"
	};
	
	/**
	 * Clear the cache. Call this when round changes or data is submitted.
	 */
	function clearMetricsCache() {
	  _cache = {};
	  _pending = {};
	}
	
	/**
	 * Fetch all MetricsReport data for a competition + round.
	 * Returns a promise that resolves to an array of MetricsReport objects.
	 * Results are cached in memory so repeated calls don't hit the API.
	 *
	 * @param {number} competitionId
	 * @param {number} roundId - round ID (not round number)
	 * @returns {Promise<Array>}
	 */
	function fetchCompetitionMetrics(competitionId, roundId, options) {
	  // `include` becomes part of the cache key so responses with promos
	  // (from include=product_awareness) don't overwrite the base response
	  // and vice versa. Callers that need promos must opt in explicitly.
	  var include = options && options.include || null;
	  var key = (competitionId || "all") + "-" + roundId + "-" + (include || "");
	  if (_cache[key]) {
	    return Promise.resolve(_cache[key]);
	  }
	  if (_pending[key]) {
	    return _pending[key];
	  }
	
	  var url = API_URL + "v2/finance/metricsreports/";
	  var sep = "?";
	  if (competitionId) {
	    url += sep + "competition=" + competitionId;
	    sep = "&";
	  }
	  if (roundId) {
	    url += sep + "round=" + roundId;
	    sep = "&";
	  }
	  if (include) {
	    url += sep + "include=" + include;
	  }
	
	  _pending[key] = (0, _ApiService.getRequest)(url).then(function (res) {
	    var results = res.body.results || res.body;
	    _cache[key] = results;
	    delete _pending[key];
	    return results;
	  });
	
	  return _pending[key];
	}
	
	/**
	 * Fetch MetricsReport data for a single team.
	 * Uses the competition cache if available, otherwise fetches by team.
	 *
	 * @param {number} teamId
	 * @param {number} roundId - round ID (not round number)
	 * @returns {Promise<Array>}
	 */
	function fetchTeamMetrics(teamId, roundId) {
	  // Check if any cached competition data contains this team
	  var cacheKeys = Object.keys(_cache);
	  for (var i = 0; i < cacheKeys.length; i++) {
	    var cached = _cache[cacheKeys[i]];
	    var match = cached.filter(function (item) {
	      return Number(item.team) === Number(teamId) && Number(item.round) === Number(roundId);
	    });
	    if (match.length > 0) {
	      return Promise.resolve(match);
	    }
	  }
	
	  // Check if there's a pending competition request that might contain this team
	  var pendingKeys = Object.keys(_pending);
	  if (pendingKeys.length > 0) {
	    return _pending[pendingKeys[0]].then(function (results) {
	      var match = results.filter(function (item) {
	        return Number(item.team) === Number(teamId) && Number(item.round) === Number(roundId);
	      });
	      if (match.length > 0) {
	        return match;
	      }
	      // Fallback: fetch by team directly
	      var url = API_URL + "v2/finance/metricsreports/?team=" + teamId;
	      if (roundId) {
	        url += "&round=" + roundId;
	      }
	      return (0, _ApiService.getRequest)(url).then(function (res) {
	        return res.body.results || res.body;
	      });
	    });
	  }
	
	  // Fallback: fetch by team directly
	  var url = API_URL + "v2/finance/metricsreports/?team=" + teamId;
	  if (roundId) {
	    url += "&round=" + roundId;
	  }
	
	  return (0, _ApiService.getRequest)(url).then(function (res) {
	    return res.body.results || res.body;
	  });
	}
	
	/**
	 * Map MetricsReport data to CAReport-compatible field names.
	 * Use this when replacing competition/competitive_analysis/ calls.
	 *
	 * @param {Object} metricsReport - single MetricsReport object
	 * @returns {Object} - object with CAReport-compatible field names added
	 */
	function mapToCompetitiveAnalysis(metricsReport) {
	  var mapped = Object.assign({}, metricsReport);
	  var caFields = Object.keys(CA_FIELD_MAP);
	  for (var i = 0; i < caFields.length; i++) {
	    var caField = caFields[i];
	    var metricsField = CA_FIELD_MAP[caField];
	    if (mapped[metricsField] !== undefined) {
	      mapped[caField] = mapped[metricsField];
	    }
	  }
	  // market_demand = sum of auto + mobile
	  mapped.market_demand = (mapped.market_demand_auto || 0) + (mapped.market_demand_mobile || 0);
	  return mapped;
	}
	
	/**
	 * Fetch competition metrics and map to CAReport-compatible format.
	 * Drop-in replacement for competition/competitive_analysis/ calls.
	 *
	 * @param {number} competitionId
	 * @param {number} roundId
	 * @returns {Promise<Array>}
	 */
	function fetchCompetitiveAnalysis(competitionId, roundId) {
	  return fetchCompetitionMetrics(competitionId, roundId).then(function (results) {
	    return results.map(mapToCompetitiveAnalysis);
	  });
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numberFormatM = exports.numberFormat = exports.moneyFormatM = exports.moneyFormatCents = exports.moneyFormat = undefined;
	
	var _lodash = __webpack_require__(21);
	
	var _numeral = __webpack_require__(2067);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moneyFormat = exports.moneyFormat = function moneyFormat(number) {
	  return (0, _lodash.isNil)(number) ? "?" : (0, _numeral2.default)(number).format("$0,0");
	};
	var moneyFormatCents = exports.moneyFormatCents = function moneyFormatCents(number) {
	  return (0, _lodash.isNil)(number) ? "?" : (0, _numeral2.default)(number).format("$0,0.00");
	};
	var moneyFormatM = exports.moneyFormatM = function moneyFormatM(number) {
	  return (0, _numeral2.default)(number / 1e6).format("$0.000") + " M";
	};
	var numberFormat = exports.numberFormat = function numberFormat(number) {
	  return (0, _numeral2.default)(number).format("0,0");
	};
	var numberFormatM = exports.numberFormatM = function numberFormatM(number) {
	  return (0, _numeral2.default)(number / 1e6).format("0.000") + "M";
	};

/***/ },
/* 64 */
[2725, 129],
/* 65 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(19);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(70);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(91);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3.default;
	exports.ValidComponentChildren = _ValidComponentChildren3.default;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var fontFamily = exports.fontFamily = "Lato";
	var dFlex = exports.dFlex = { display: "flex", flexDirection: "row" };
	var dFlexC = exports.dFlexC = { display: "flex", flexDirection: "column" };
	var flex1 = exports.flex1 = { flex: "1" };
	var division = exports.division = Object.assign({}, dFlex, {
	  flexDirection: "column",
	  alignItems: "center",
	  marginLeft: "1ch",
	  textAlign: "center"
	});
	var tableStyle = exports.tableStyle = {
	  width: "auto",
	  whiteSpace: "nowrap",
	  color: "#3A3A3A",
	  marginBottom: "0.5em",
	  marginRight: "0",
	  marginLeft: "0",
	  fontSize: "14px",
	  textAlign: "right",
	  fontWeight: "600",
	  fontFamily: fontFamily
	};
	var tableLabelStyle = exports.tableLabelStyle = {
	  whiteSpace: "normal",
	  fontFamily: fontFamily,
	  fontSize: "20px",
	  fontWeight: "bold",
	  color: "#2F9CA3",
	  textAlign: "left"
	};
	var panelHeaderStyle = exports.panelHeaderStyle = {
	  fontSize: "20px",
	  fontFamily: fontFamily,
	  color: "#424242"
	};
	var formulaStyle = exports.formulaStyle = function formulaStyle(sm) {
	  return {
	    fontSize: sm ? "14px" : "16px",
	    color: "#8F8F8F"
	  };
	};
	var w100 = exports.w100 = {
	  width: "100%"
	};
	var blueHeader = exports.blueHeader = {
	  fontFamily: fontFamily,
	  fontStyle: "normal",
	  fontWeight: "bold",
	  lineHeight: "normal",
	  fontSize: "24px",
	  textAlign: "center",
	  color: "#2F9CA3"
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPageLogo = __webpack_require__(392);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsTwoColumnsLayout(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$left_content = _ref.left_content,
	      left_content = _ref$left_content === undefined ? null : _ref$left_content,
	      _ref$right_content = _ref.right_content,
	      right_content = _ref$right_content === undefined ? null : _ref$right_content;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "team-reports-layout team-reports-one-column clearfix" },
	    _react2.default.createElement(
	      "div",
	      { className: "left" },
	      _react2.default.createElement(
	        "div",
	        { className: "team-reports-logo without-border" },
	        _react2.default.createElement("img", { src: _LandingPageLogo2.default, alt: "logo" }),
	        _react2.default.createElement("div", { className: "orange-line" }),
	        _react2.default.createElement("div", { className: "green-line" })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "title" },
	        title
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "one-column-inner-content" },
	        left_content
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "right" },
	      right_content
	    )
	  );
	}
	
	exports.default = TeamReportsTwoColumnsLayout;

/***/ },
/* 70 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports.default = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _horizontalBar = __webpack_require__(1120);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	var _verticalBar = __webpack_require__(397);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _styles = __webpack_require__(68);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TeamLegend = __webpack_require__(571);
	
	var _TeamLegend2 = _interopRequireDefault(_TeamLegend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OnePanelChart = function OnePanelChart(_ref) {
	  var title = _ref.title,
	      _ref$vertical = _ref.vertical,
	      vertical = _ref$vertical === undefined ? false : _ref$vertical,
	      chartTitle = _ref.chartTitle,
	      children = _ref.children,
	      data = _ref.data,
	      _ref$suffix = _ref.suffix,
	      suffix = _ref$suffix === undefined ? "" : _ref$suffix,
	      _ref$prefix = _ref.prefix,
	      prefix = _ref$prefix === undefined ? "" : _ref$prefix,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? 2 : _ref$precision,
	      _ref$format = _ref.format,
	      format = _ref$format === undefined ? null : _ref$format,
	      _ref$customChart = _ref.customChart,
	      customChart = _ref$customChart === undefined ? null : _ref$customChart,
	      _ref$customColors = _ref.customColors,
	      customColors = _ref$customColors === undefined ? null : _ref$customColors,
	      _ref$showCategoryLabe = _ref.showCategoryLabels,
	      showCategoryLabels = _ref$showCategoryLabe === undefined ? false : _ref$showCategoryLabe,
	      _ref$instructorData = _ref.instructorData,
	      instructorData = _ref$instructorData === undefined ? null : _ref$instructorData,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? null : _ref$teams,
	      _ref$yaxisFormatter = _ref.yaxisFormatter,
	      yaxisFormatter = _ref$yaxisFormatter === undefined ? null : _ref$yaxisFormatter;
	  return _react2.default.createElement(
	    "div",
	    { style: _styles.dFlex },
	    _react2.default.createElement(
	      _OnePanel2.default,
	      { title: title, style: _styles.flex1 },
	      children
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        style: Object.assign({}, _styles.flex1, _styles.dFlexC, {
	          maxWidth: "65%",
	          alignItems: "center",
	          justifyContent: "center"
	        })
	      },
	      customChart !== null ? customChart : vertical ? _react2.default.createElement(_verticalBar2.default, {
	        data: data,
	        prefix: prefix,
	        suffix: suffix,
	        precision: precision,
	        customColors: customColors,
	        showCategoryLabels: showCategoryLabels,
	        instructorData: instructorData,
	        teams: teams
	      }) : _react2.default.createElement(_horizontalBar2.default, {
	        data: data,
	        prefix: prefix,
	        suffix: suffix,
	        precision: precision,
	        format: format,
	        customColors: customColors,
	        showCategoryLabels: showCategoryLabels,
	        instructorData: instructorData,
	        teams: teams,
	        yaxisFormatter: yaxisFormatter
	      }),
	      _react2.default.createElement(
	        _Text2.default,
	        { marginTop: "15px" },
	        chartTitle || title
	      ),
	      _react2.default.createElement(_TeamLegend2.default, { teams: teams, customColors: customColors })
	    )
	  );
	};
	
	exports.default = OnePanelChart;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatMillionsValue = exports.arrayUniqueFilter = exports.handleSelectChange = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSelectChange = exports.handleSelectChange = function handleSelectChange(value, onSelectChange) {
	  _Auth2.default.setTeamId(value);
	
	  onSelectChange();
	};
	
	var arrayUniqueFilter = exports.arrayUniqueFilter = function arrayUniqueFilter(value, index, self) {
	  return self.indexOf(value) === index;
	};
	
	var formatMillionsValue = exports.formatMillionsValue = function formatMillionsValue(value) {
	  var formattedValue = value.toLocaleString('en-US', {
	    style: 'currency',
	    currency: 'USD',
	    maximumFractionDigits: 0
	  });
	  return value < 0 ? _react2.default.createElement(
	    'b',
	    null,
	    formattedValue
	  ) : formattedValue;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(664);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 75 */
[2758, 1024],
/* 76 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var baseUrl = "https://torsor.typeform.com/to";
	
	var TypeformUrls = {
	  GRADING: baseUrl + "/K4rFEY",
	  MARKET_ANALYSIS: baseUrl + "/GdmXlw",
	  COMPETITIVE_ANALYSIS: baseUrl + "/IBoTy3",
	  KPI: baseUrl + "/xrWv1Z",
	  PROFITABILITY: baseUrl + "/iR33sd",
	  INCOME_STATEMENT: baseUrl + "/iR33sd",
	  MARKET_CAP: baseUrl + "/A9VqgW",
	  FINANCIAL_METRICS: baseUrl + "/IA9X0X",
	  IRR: baseUrl + "/nSXrb2",
	  INVESTOR_DATA: baseUrl + "/CnDGqv",
	  STOCK_RETURN: baseUrl + "/CnDGqv",
	  PRODUCT_COSTS: baseUrl + "/CnDGqv",
	  COST_OF_CAPITAL: baseUrl + "/bIZtZr",
	  DIVIDEND_YIELD: baseUrl + "/b8Bc9v",
	  PRICING: baseUrl + "/QSDsia",
	  DISCOUNT_RATE: baseUrl + "/QSDsia",
	  // TODO(austin) fill this in when perceptual map is added
	  PERCEPTUAL_MAP: baseUrl + "/",
	  PRODUCT_AWARENESS: baseUrl + "/PL0Bl2",
	  MARKETING_FUNNEL: baseUrl + "/PL0Bl2",
	  FINANCIAL_ANALYSIS: baseUrl + "/I32NLf",
	  FINANCIAL_PROJECTIONS: baseUrl + "/MQSxRX",
	  FINANCIALS: baseUrl + "/qdecks",
	  WORKING_CAPITAL: baseUrl + "/QMjn4K",
	  INSIGHTS_ROUND_1: baseUrl + "/QMjn4K",
	  INSIGHTS_ROUND_2: baseUrl + "/PL0Bl2",
	  INSIGHTS_ROUND_3: baseUrl + "/IgO7SI",
	  UTILIZATION: baseUrl + "/XGCjhJ",
	  BUSINESS_VALUATION: baseUrl + "/HtpMPG",
	  CASH_FLOWS: baseUrl + "/Kd9bWe",
	  BALANCE_SHEET: baseUrl + "/GjCzBN",
	  EARNINGS_PER_SHARE: baseUrl + "/sgcoG7",
	  STOCK_PRICE: baseUrl + "/EOhRTG",
	  ROIC: baseUrl + "/Dla8KA",
	  RNOA: baseUrl + "/KT6MRo",
	  EARNINGS_YIELD: baseUrl + "/KXG2q9",
	  CAPITAL_BUDGETING: baseUrl + "/j2WTCP",
	  CAPITAL_STRUCTURE: baseUrl + "/EBfTba",
	  DEBT_TO_CAPITAL: baseUrl + "/HmI55z",
	  EQUITY_OFFERING: baseUrl + "/Oub4Pw",
	  DEBT_VS_EQUITY: baseUrl + "/Oub4Pw",
	  MARKETING_MIX: baseUrl + "/cwEiGE",
	  PRODUCT_MARKET_FIT: baseUrl + "/OTctgx",
	  PRODUCT_LIFECYCLE: baseUrl + "/hB8tb0",
	  TIME_VALUE_OF_MONEY: baseUrl + "/BcltG5",
	  NPV_ANALYSIS: baseUrl + "/j2WTCP",
	  SHARES_OUTSTANDING: baseUrl + "/LA9Aeu",
	  STP: baseUrl + "/MWFcog"
	};
	
	exports.default = TypeformUrls;

/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getProductNameColor = exports.getProductNameColor = function getProductNameColor(index) {
	  if (index % 3 === 0) {
	    return '#fdd38a';
	  }
	
	  if (index % 3 === 1) {
	    return '#92dbe1';
	  }
	
	  return '#fd9595';
	};
	
	var getProductRowColor = exports.getProductRowColor = function getProductRowColor(index) {
	  if (index % 3 === 0) {
	    return '#fbedd5';
	  }
	
	  if (index % 3 === 1) {
	    return '#d7f0f2';
	  }
	
	  return '#fbd8d8';
	};
	
	var formatNumber = exports.formatNumber = function formatNumber(value) {
	  var fixedValue = Math.abs(value).toFixed(2);
	  var isNegative = Number(value) < 0;
	
	  return (isNegative ? '-' : '') + '$' + fixedValue;
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: #fafafa;\n  padding: 24px 36px 16px;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"], ["\n  background: #fafafa;\n  padding: 24px 36px 16px;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0 2;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0 2;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 29px;\n  color: #000;\n  padding-right: 20px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 29px;\n  color: #000;\n  padding-right: 20px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 23px;\n  width: 148px;\n  line-height: 23px;\n  text-align: center;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n\n  .fa-spinner,\n  .fa-check {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  display: inline-block;\n  height: 23px;\n  width: 148px;\n  line-height: 23px;\n  text-align: center;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n\n  .fa-spinner,\n  .fa-check {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 0 2px;\n"], ["\n  padding: 0 2px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  display: block;\n  padding: 0 20px !important;\n  min-width: auto !important;\n  border-color: transparent !important;\n  min-width: 156px !important;\n  height: 43px !important;\n  line-height: 43px !important;\n  background-color: #2a4169 !important;\n  font-family: Lato !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #fff !important;\n  border-radius: 4px !important;\n  transition: background-color 0.5s ease;\n\n  ", "\n\n  &:hover {\n    background-color: #0da6ad !important;\n  }\n\n  &:disabled {\n    background-color: #cccccc !important;\n  }\n\n  &.active {\n    background-color: #0da6ad !important;\n  }\n"], ["\n  display: block;\n  padding: 0 20px !important;\n  min-width: auto !important;\n  border-color: transparent !important;\n  min-width: 156px !important;\n  height: 43px !important;\n  line-height: 43px !important;\n  background-color: #2a4169 !important;\n  font-family: Lato !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #fff !important;\n  border-radius: 4px !important;\n  transition: background-color 0.5s ease;\n\n  ", "\n\n  &:hover {\n    background-color: #0da6ad !important;\n  }\n\n  &:disabled {\n    background-color: #cccccc !important;\n  }\n\n  &.active {\n    background-color: #0da6ad !important;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  margin-right: 20px;\n"], ["\n  margin-left: 20px;\n  margin-right: 20px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  margin-top: 30px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin-top: 30px;\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 29px;\n  color: #000;\n  padding-right: 15px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 29px;\n  color: #000;\n  padding-right: 15px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  background: #fff;\n  width: 100%;\n  margin-top: 22px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  max-width: 800px;\n  padding: 25px 40px 60px;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n"], ["\n  background: #fff;\n  width: 100%;\n  margin-top: 22px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  max-width: 800px;\n  padding: 25px 40px 60px;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"], ["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  margin-left: 4px;\n  cursor: pointer;\n  vertical-align: middle;\n"], ["\n  width: 12px;\n  height: 12px;\n  margin-left: 4px;\n  cursor: pointer;\n  vertical-align: middle;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: '';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: '';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n"], ["\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n"], ["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 34px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 34px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral([""], [""]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  padding-left: 40px;\n"], ["\n  padding-left: 40px;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n  display: flex;\n  align-items: center;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n  display: flex;\n  align-items: center;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  padding-top: 15px;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  color: #000;\n  text-align: center;\n  display: none;\n\n  ", "\n\n  ", "\n"], ["\n  padding-top: 15px;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  color: #000;\n  text-align: center;\n  display: none;\n\n  ", "\n\n  ", "\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  position: relative;\n  z-index: 1;\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  position: relative;\n  z-index: 1;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  flex: 0 0 408px;\n"], ["\n  flex: 0 0 408px;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  margin-top: -10px;\n"], ["\n  margin-top: -10px;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000000;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000000;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n\n  ", "\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  width: 15px;\n  height: 15px;\n  ", ";\n  margin-right: 13px;\n  content: \"\";\n  border-radius: 15px;\n"], ["\n  width: 15px;\n  height: 15px;\n  ", ";\n  margin-right: 13px;\n  content: \"\";\n  border-radius: 15px;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-top: 4px;\n  margin-bottom: 12px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-top: 4px;\n  margin-bottom: 12px;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: 12px;\n  margin-bottom: 16px;\n  max-width: 1300px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: 12px;\n  margin-bottom: 16px;\n  max-width: 1300px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 8px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 84px;\n"], ["\n  background: #fff;\n  border-radius: 8px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 84px;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  display: flex;\n  align-items: center;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-top: 6px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  align-self: flex-start;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  margin-top: 6px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  align-self: flex-start;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 8px;\n  padding: 18px 22px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  margin-bottom: 16px;\n  max-width: 1300px;\n"], ["\n  background: #fff;\n  border-radius: 8px;\n  padding: 18px 22px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  margin-bottom: 16px;\n  max-width: 1300px;\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  width: 100%;\n  margin-top: 4px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  width: 100%;\n  margin-top: 4px;\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject43 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 32px;\n\n  @media (max-width: 700px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 32px;\n\n  @media (max-width: 700px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n"]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  width: 160px;\n  height: 160px;\n  flex-shrink: 0;\n  position: relative;\n"], ["\n  width: 160px;\n  height: 160px;\n  flex-shrink: 0;\n  position: relative;\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: nowrap;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: nowrap;\n"]),
	    _templateObject48 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"]),
	    _templateObject49 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"]),
	    _templateObject50 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"]),
	    _templateObject51 = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: ", ";\n"], ["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: ", ";\n"]),
	    _templateObject52 = _taggedTemplateLiteral(["\n  flex: 1;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  flex: 1;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject53 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  width: 40px;\n  text-align: right;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  width: 40px;\n  text-align: right;\n"]),
	    _templateObject54 = _taggedTemplateLiteral(["\n  height: 4px;\n  background: #F0F0F0;\n  border-radius: 2px;\n  overflow: hidden;\n"], ["\n  height: 4px;\n  background: #F0F0F0;\n  border-radius: 2px;\n  overflow: hidden;\n"]),
	    _templateObject55 = _taggedTemplateLiteral(["\n  height: 100%;\n  background: ", ";\n  width: ", "%;\n"], ["\n  height: 100%;\n  background: ", ";\n  width: ", "%;\n"]),
	    _templateObject56 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"]),
	    _templateObject57 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #ECEDEF;\n"], ["\n  border-bottom: 1px solid #ECEDEF;\n"]),
	    _templateObject58 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 8px 14px 4px 0;\n  text-align: ", ";\n\n  &:last-child {\n    padding-right: 0;\n  }\n"], ["\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 8px 14px 4px 0;\n  text-align: ", ";\n\n  &:last-child {\n    padding-right: 0;\n  }\n"]),
	    _templateObject59 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #F5F6F7;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"], ["\n  border-bottom: 1px solid #F5F6F7;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"]),
	    _templateObject60 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  padding: 8px 14px 8px 0;\n  text-align: ", ";\n\n  &:last-child {\n    padding-right: 0;\n  }\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  padding: 8px 14px 8px 0;\n  text-align: ", ";\n\n  &:last-child {\n    padding-right: 0;\n  }\n"]),
	    _templateObject61 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: baseline;\n  font-variant-numeric: tabular-nums;\n"], ["\n  display: inline-flex;\n  align-items: baseline;\n  font-variant-numeric: tabular-nums;\n"]),
	    _templateObject62 = _taggedTemplateLiteral(["\n  margin-right: 2px;\n"], ["\n  margin-right: 2px;\n"]),
	    _templateObject63 = _taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: 9ch;\n  text-align: right;\n"], ["\n  display: inline-block;\n  min-width: 9ch;\n  text-align: right;\n"]),
	    _templateObject64 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  margin-top: 6px;\n  border-top: 1px solid #ECEDEF;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  margin-top: 6px;\n  border-top: 1px solid #ECEDEF;\n"]),
	    _templateObject65 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject66 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #2A4169;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #2A4169;\n"]),
	    _templateObject67 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n"]),
	    _templateObject68 = _taggedTemplateLiteral(["\n  text-align: right;\n"], ["\n  text-align: right;\n"]),
	    _templateObject69 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject70 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #2A4169;\n  margin-top: 2px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #2A4169;\n  margin-top: 2px;\n"]),
	    _templateObject71 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #F5F6F7;\n  z-index: 1500;\n  overflow-y: auto;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n\n  /* Every per-page decision-page CloseButton uses aria-label=\"Close\".\n     Style them uniformly from the shared overlay so the \"x\" reads\n     as an actual clickable button (white circle around it) at a\n     consistent size across all pages (20% larger than the original\n     naked 24px glyph). */\n  button[aria-label=\"Close\"] {\n    background: #3a507b;\n    border: 1px solid #3a507b;\n    border-radius: 50%;\n    width: 44px;\n    height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 29px;\n    line-height: 1;\n    color: #FFFFFF;\n    cursor: pointer;\n    padding: 0;\n    transition: background 0.15s ease, border-color 0.15s ease;\n\n    &:hover {\n      background: #2a4169;\n      border-color: #2a4169;\n    }\n\n    &:focus-visible {\n      outline: 2px solid #2563EB;\n      outline-offset: 2px;\n    }\n  }\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #F5F6F7;\n  z-index: 1500;\n  overflow-y: auto;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n\n  /* Every per-page decision-page CloseButton uses aria-label=\"Close\".\n     Style them uniformly from the shared overlay so the \"x\" reads\n     as an actual clickable button (white circle around it) at a\n     consistent size across all pages (20% larger than the original\n     naked 24px glyph). */\n  button[aria-label=\"Close\"] {\n    background: #3a507b;\n    border: 1px solid #3a507b;\n    border-radius: 50%;\n    width: 44px;\n    height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 29px;\n    line-height: 1;\n    color: #FFFFFF;\n    cursor: pointer;\n    padding: 0;\n    transition: background 0.15s ease, border-color 0.15s ease;\n\n    &:hover {\n      background: #2a4169;\n      border-color: #2a4169;\n    }\n\n    &:focus-visible {\n      outline: 2px solid #2563EB;\n      outline-offset: 2px;\n    }\n  }\n"]),
	    _templateObject72 = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 32px 48px 12px;\n  text-align: center;\n"], ["\n  position: relative;\n  padding: 32px 48px 12px;\n  text-align: center;\n"]),
	    _templateObject73 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 34px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 34px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject74 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n"]),
	    _templateObject75 = _taggedTemplateLiteral(["\n  /* Positioning only. Visual styling (white circle + sized \"x\")\n     comes from the shared button[aria-label=\"Close\"] rule on\n     Styled.LenderOverlay so every decision page's close button\n     looks and sizes the same. */\n  position: absolute;\n  top: 24px;\n  right: 24px;\n"], ["\n  /* Positioning only. Visual styling (white circle + sized \"x\")\n     comes from the shared button[aria-label=\"Close\"] rule on\n     Styled.LenderOverlay so every decision page's close button\n     looks and sizes the same. */\n  position: absolute;\n  top: 24px;\n  right: 24px;\n"]),
	    _templateObject76 = _taggedTemplateLiteral(["\n  margin: 16px 150px 24px;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px 28px;\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n"], ["\n  margin: 16px 150px 24px;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px 28px;\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n"]),
	    _templateObject77 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 24px;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  gap: 24px;\n  flex-shrink: 0;\n"]),
	    _templateObject78 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 24px;\n  border-right: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 24px;\n  border-right: ", ";\n"]),
	    _templateObject79 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"], ["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"]),
	    _templateObject80 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject81 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  position: relative;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  position: relative;\n"]),
	    _templateObject82 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n"], ["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n"]),
	    _templateObject83 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  transform: translateX(-50%);\n  white-space: nowrap;\n"], ["\n  position: absolute;\n  top: 0;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  transform: translateX(-50%);\n  white-space: nowrap;\n"]),
	    _templateObject84 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 6px;\n  border-radius: 3px;\n  background: #DEE0E3;\n  overflow: visible;\n  display: flex;\n"], ["\n  position: relative;\n  height: 6px;\n  border-radius: 3px;\n  background: #DEE0E3;\n  overflow: visible;\n  display: flex;\n"]),
	    _templateObject85 = _taggedTemplateLiteral(["\n  height: 100%;\n  background: ", ";\n  width: ", "%;\n  position: relative;\n\n  &:first-child {\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n  }\n"], ["\n  height: 100%;\n  background: ", ";\n  width: ", "%;\n  position: relative;\n\n  &:first-child {\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n  }\n"]),
	    _templateObject86 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n  transform: translateX(-50%);\n  left: ", "%;\n"], ["\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n  transform: translateX(-50%);\n  left: ", "%;\n"]),
	    _templateObject87 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -3px;\n  right: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.94);\n  border: 2px solid #fff;\n  transform: translateX(-50%);\n"], ["\n  position: absolute;\n  top: -3px;\n  right: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.94);\n  border: 2px solid #fff;\n  transform: translateX(-50%);\n"]),
	    _templateObject88 = _taggedTemplateLiteral(["\n  padding: 0 150px 48px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  padding: 0 150px 48px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject89 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  @keyframes fadeInLender {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"], ["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  @keyframes fadeInLender {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"]),
	    _templateObject90 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  margin-bottom: 14px;\n"], ["\n  display: flex;\n  gap: 12px;\n  margin-bottom: 14px;\n"]),
	    _templateObject91 = _taggedTemplateLiteral(["\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  background: #fff;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  background: #fff;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]),
	    _templateObject92 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"]),
	    _templateObject93 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject94 = _taggedTemplateLiteral(["\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject95 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  background: ", ";\n  color: ", ";\n  align-self: flex-start;\n\n  &::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  background: ", ";\n  color: ", ";\n  align-self: flex-start;\n\n  &::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"]),
	    _templateObject96 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 0 0 14px;\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 0 0 14px;\n"]),
	    _templateObject97 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 5px;\n  padding: 14px 16px;\n  margin: 0 0 12px;\n"], ["\n  background: #fff;\n  border-radius: 5px;\n  padding: 14px 16px;\n  margin: 0 0 12px;\n"]),
	    _templateObject98 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  color: rgba(0, 27, 59, 0.94);\n  text-transform: uppercase;\n  margin-bottom: 10px;\n"], ["\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  color: rgba(0, 27, 59, 0.94);\n  text-transform: uppercase;\n  margin-bottom: 10px;\n"]),
	    _templateObject99 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n\n  /* Center-align label + value in the Interest Rate and D/C Limit\n     columns (cols 2 and 3) so the value sits directly under its\n     header. Max Loan (col 1) stays left-aligned. */\n  > div:nth-child(2),\n  > div:nth-child(3) {\n    text-align: center;\n\n    > div:first-child {\n      justify-content: center;\n    }\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n\n  /* Center-align label + value in the Interest Rate and D/C Limit\n     columns (cols 2 and 3) so the value sits directly under its\n     header. Max Loan (col 1) stays left-aligned. */\n  > div:nth-child(2),\n  > div:nth-child(3) {\n    text-align: center;\n\n    > div:first-child {\n      justify-content: center;\n    }\n  }\n"]),
	    _templateObject100 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 14px;\n  letter-spacing: 0.4px;\n  color: rgba(0, 27, 59, 0.6);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"], ["\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 14px;\n  letter-spacing: 0.4px;\n  color: rgba(0, 27, 59, 0.6);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"]),
	    _templateObject101 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: ", ";\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: ", ";\n"]),
	    _templateObject102 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 26px;\n  color: ", ";\n  margin-bottom: 12px;\n"], ["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 26px;\n  color: ", ";\n  margin-bottom: 12px;\n"]),
	    _templateObject103 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n"]),
	    _templateObject104 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject105 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: ", ";\n"]),
	    _templateObject106 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: 12px 48px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  margin-top: auto;\n  align-self: center;\n  text-transform: uppercase;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  background: #fff;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: 12px 48px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  margin-top: auto;\n  align-self: center;\n  text-transform: uppercase;\n\n  &:hover {\n    background: ", ";\n  }\n"]),
	    _templateObject107 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.4);\n  font-size: 9px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: help;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.4);\n  font-size: 9px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: help;\n"]),
	    _templateObject108 = _taggedTemplateLiteral(["\n  padding: 0 150px 48px;\n  display: grid;\n  grid-template-columns: 375px 1fr;\n  gap: 40px;\n  align-items: start;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  padding: 0 150px 48px;\n  display: grid;\n  grid-template-columns: 375px 1fr;\n  gap: 40px;\n  align-items: start;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject109 = _taggedTemplateLiteral(["\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n  pointer-events: none;\n  height: 0;\n  overflow: hidden;\n"], ["\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.4s ease, transform 0.4s ease;\n  pointer-events: none;\n  height: 0;\n  overflow: hidden;\n"]),
	    _templateObject110 = _taggedTemplateLiteral(["\n  animation: selectedSlideIn 0.5s ease forwards;\n\n  @keyframes selectedSlideIn {\n    from {\n      transform: translateX(80px);\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n"], ["\n  animation: selectedSlideIn 0.5s ease forwards;\n\n  @keyframes selectedSlideIn {\n    from {\n      transform: translateX(80px);\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n"]),
	    _templateObject111 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n"]),
	    _templateObject112 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid rgba(45, 165, 72, 0.2);\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.75);\n  cursor: pointer;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    background: #F5F6F7;\n  }\n"], ["\n  background: #fff;\n  border: 1px solid rgba(45, 165, 72, 0.2);\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.75);\n  cursor: pointer;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    background: #F5F6F7;\n  }\n"]),
	    _templateObject113 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 20px;\n  padding: 32px 36px;\n  opacity: 0;\n  animation: managePanelFadeIn 0.5s ease forwards;\n  animation-delay: 0.4s;\n\n  @keyframes managePanelFadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"], ["\n  background: #fff;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 20px;\n  padding: 32px 36px;\n  opacity: 0;\n  animation: managePanelFadeIn 0.5s ease forwards;\n  animation-delay: 0.4s;\n\n  @keyframes managePanelFadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"]),
	    _templateObject114 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 6px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 6px;\n"]),
	    _templateObject115 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  color: #001B3B;\n  margin-bottom: 20px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  color: #001B3B;\n  margin-bottom: 20px;\n"]),
	    _templateObject116 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 20px;\n  padding: 22px 28px;\n  margin-bottom: 16px;\n"], ["\n  background: ", ";\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 20px;\n  padding: 22px 28px;\n  margin-bottom: 16px;\n"]),
	    _templateObject117 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n"]),
	    _templateObject118 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin: 6px 0 16px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin: 6px 0 16px;\n"]),
	    _templateObject119 = _taggedTemplateLiteral(["\n  flex: 1;\n  background: #fff;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 10px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  gap: 6px;\n"], ["\n  flex: 1;\n  background: #fff;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 10px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  gap: 6px;\n"]),
	    _templateObject120 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.38);\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.38);\n"]),
	    _templateObject121 = _taggedTemplateLiteral(["\n  flex: 1;\n  border: none;\n  outline: none;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: #001B3B;\n  background: transparent;\n  width: 100%;\n\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.25);\n  }\n"], ["\n  flex: 1;\n  border: none;\n  outline: none;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: #001B3B;\n  background: transparent;\n  width: 100%;\n\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.25);\n  }\n"]),
	    _templateObject122 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 5px;\n  padding: 0 18px;\n  height: 32px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.4px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    filter: brightness(0.95);\n  }\n\n  &:disabled {\n    background: #BFC4CC;\n    cursor: not-allowed;\n  }\n"], ["\n  background: ", ";\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 5px;\n  padding: 0 18px;\n  height: 32px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.4px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    filter: brightness(0.95);\n  }\n\n  &:disabled {\n    background: #BFC4CC;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject123 = _taggedTemplateLiteral(["\n  background: #2A4169;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 5px;\n  padding: 0 18px;\n  height: 32px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.4px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    filter: brightness(0.95);\n  }\n\n  &:disabled {\n    background: #BFC4CC;\n    color: #fff;\n    cursor: not-allowed;\n  }\n"], ["\n  background: #2A4169;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 5px;\n  padding: 0 18px;\n  height: 32px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.4px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    filter: brightness(0.95);\n  }\n\n  &:disabled {\n    background: #BFC4CC;\n    color: #fff;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject124 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: 8px;\n  margin-top: 12px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  gap: 8px;\n  margin-top: 12px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"]),
	    _templateObject125 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.5);\n"], ["\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.5);\n"]),
	    _templateObject126 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 16px;\n  color: #001B3B;\n"], ["\n  font-weight: 700;\n  font-size: 16px;\n  color: #001B3B;\n"]),
	    _templateObject127 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]),
	    _templateObject128 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"], ["\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"]),
	    _templateObject129 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n"]),
	    _templateObject130 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0 0 24px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0 0 24px;\n"]),
	    _templateObject131 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"]),
	    _templateObject132 = _taggedTemplateLiteral(["\n  background: #2A4169;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: #1f3050;\n  }\n"], ["\n  background: #2A4169;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: #1f3050;\n  }\n"]),
	    _templateObject133 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.7);\n  cursor: pointer;\n\n  &:hover {\n    background: #F5F6F7;\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: #fff;\n  border: 1px solid #CBD5E1;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.7);\n  cursor: pointer;\n\n  &:hover {\n    background: #F5F6F7;\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject134 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  row-gap: 8px;\n  column-gap: 16px;\n  margin: 4px 0 24px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  row-gap: 8px;\n  column-gap: 16px;\n  margin: 4px 0 24px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject135 = _taggedTemplateLiteral(["\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 500;\n"], ["\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 500;\n"]),
	    _templateObject136 = _taggedTemplateLiteral(["\n  font-weight: 700;\n"], ["\n  font-weight: 700;\n"]),
	    _templateObject137 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 24px;\n  border-right: 1px solid #DEE0E3;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 24px;\n  border-right: 1px solid #DEE0E3;\n"]),
	    _templateObject138 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"]),
	    _templateObject139 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject140 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n"]),
	    _templateObject141 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n"]),
	    _templateObject142 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"], ["\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"]),
	    _templateObject143 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject144 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 20px;\n  padding: 24px 22px;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  @keyframes fadeInEquity {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"], ["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 20px;\n  padding: 24px 22px;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  @keyframes fadeInEquity {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"]),
	    _templateObject145 = _taggedTemplateLiteral(["\n  width: 84px;\n  height: 84px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid rgba(169, 141, 246, 0.2);\n  flex-shrink: 0;\n"], ["\n  width: 84px;\n  height: 84px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid rgba(169, 141, 246, 0.2);\n  flex-shrink: 0;\n"]),
	    _templateObject146 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject147 = _taggedTemplateLiteral(["\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: #4A4A4A;\n"], ["\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: #4A4A4A;\n"]),
	    _templateObject148 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  padding: 3px 14px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 20px;\n  background: ", ";\n  color: ", ";\n  align-self: flex-start;\n\n  &::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  padding: 3px 14px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 20px;\n  background: ", ";\n  color: ", ";\n  align-self: flex-start;\n\n  &::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"]),
	    _templateObject149 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #001B3B;\n  margin: 0 0 14px;\n  min-height: 60px;\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #001B3B;\n  margin: 0 0 14px;\n  min-height: 60px;\n"]),
	    _templateObject150 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid rgba(169, 141, 246, 0.2);\n  border-radius: 10px;\n  padding: 16px 18px;\n  margin-bottom: 12px;\n"], ["\n  background: #fff;\n  border: 1px solid rgba(169, 141, 246, 0.2);\n  border-radius: 10px;\n  padding: 16px 18px;\n  margin-bottom: 12px;\n"]),
	    _templateObject151 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.5);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"], ["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.5);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"]),
	    _templateObject152 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin-bottom: 10px;\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin-bottom: 10px;\n"]),
	    _templateObject153 = _taggedTemplateLiteral(["\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 24px;\n  color: ", ";\n"], ["\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 24px;\n  color: ", ";\n"]),
	    _templateObject154 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 12px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 12px;\n"]),
	    _templateObject155 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 20px;\n  color: rgba(107, 114, 128, 0.8);\n  text-transform: uppercase;\n"], ["\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 20px;\n  color: rgba(107, 114, 128, 0.8);\n  text-transform: uppercase;\n"]),
	    _templateObject156 = _taggedTemplateLiteral(["\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 22px;\n  color: ", ";\n"], ["\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 22px;\n  color: ", ";\n"]),
	    _templateObject157 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid rgba(169, 141, 246, 0.2);\n  border-radius: 10px;\n  padding: 11px 24px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.75);\n  cursor: pointer;\n  margin-top: auto;\n  align-self: center;\n  text-transform: uppercase;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  background: #fff;\n  border: 1px solid rgba(169, 141, 246, 0.2);\n  border-radius: 10px;\n  padding: 11px 24px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.75);\n  cursor: pointer;\n  margin-top: auto;\n  align-self: center;\n  text-transform: uppercase;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\n\n  &:hover {\n    background: ", ";\n  }\n"]),
	    _templateObject158 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]),
	    _templateObject159 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: #001B3B;\n  text-align: center;\n  margin: 0 0 16px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: #001B3B;\n  text-align: center;\n  margin: 0 0 16px;\n"]),
	    _templateObject160 = _taggedTemplateLiteral(["\n  background: rgba(0, 27, 59, 0.05);\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 10px;\n  padding: 8px;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 663px;\n"], ["\n  background: rgba(0, 27, 59, 0.05);\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 10px;\n  padding: 8px;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 663px;\n"]),
	    _templateObject161 = _taggedTemplateLiteral(["\n  flex: 1;\n  background: ", ";\n  border: ", ";\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #001B3B;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  flex: 1;\n  background: ", ";\n  border: ", ";\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #001B3B;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n"]),
	    _templateObject162 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 20px;\n  padding: 24px 36px 32px;\n  width: 100%;\n"], ["\n  background: ", ";\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 20px;\n  padding: 24px 36px 32px;\n  width: 100%;\n"]),
	    _templateObject163 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject164 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin-top: 6px;\n  margin-bottom: 24px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin-top: 6px;\n  margin-bottom: 24px;\n"]),
	    _templateObject165 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n"]),
	    _templateObject166 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject167 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n"]),
	    _templateObject168 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 10px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 0 14px;\n"], ["\n  background: #fff;\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 10px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 0 14px;\n"]),
	    _templateObject169 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.38);\n  margin-right: 6px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.38);\n  margin-right: 6px;\n"]),
	    _templateObject170 = _taggedTemplateLiteral(["\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: #001B3B;\n  min-width: 0;\n  padding-right: ", ";\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.25);\n  }\n"], ["\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: #001B3B;\n  min-width: 0;\n  padding-right: ", ";\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.25);\n  }\n"]),
	    _templateObject171 = _taggedTemplateLiteral(["\n  flex: 1;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: #001B3B;\n"], ["\n  flex: 1;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  color: #001B3B;\n"]),
	    _templateObject172 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 27, 59, 0.94);\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 5px;\n  height: 25px;\n  padding: 0 18px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  color: #fff;\n  letter-spacing: 0.4px;\n  cursor: pointer;\n\n  &:hover { filter: brightness(0.85); }\n  &:disabled {\n    background: #BFC4CC;\n    cursor: not-allowed;\n  }\n"], ["\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 27, 59, 0.94);\n  border: 1px solid rgba(42, 65, 105, 0.2);\n  border-radius: 5px;\n  height: 25px;\n  padding: 0 18px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  color: #fff;\n  letter-spacing: 0.4px;\n  cursor: pointer;\n\n  &:hover { filter: brightness(0.85); }\n  &:disabled {\n    background: #BFC4CC;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject173 = _taggedTemplateLiteral(["\n  background: #2A4169;\n  &:disabled {\n    background: #BFC4CC;\n    color: #fff;\n    cursor: not-allowed;\n  }\n"], ["\n  background: #2A4169;\n  &:disabled {\n    background: #BFC4CC;\n    color: #fff;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject174 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  align-items: baseline;\n  margin-top: 16px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"], ["\n  display: flex;\n  gap: 8px;\n  align-items: baseline;\n  margin-top: 16px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"]),
	    _templateObject175 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n  max-width: 1200px;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n  max-width: 1200px;\n"]),
	    _templateObject176 = _taggedTemplateLiteral(["\n  background: #2A4169;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 24px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:hover {\n    background: #36507e;\n  }\n\n  &:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n  }\n"], ["\n  background: #2A4169;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 24px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:hover {\n    background: #36507e;\n  }\n\n  &:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject177 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]),
	    _templateObject178 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 28px 32px;\n  max-width: 520px;\n  width: 90%;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"], ["\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 28px 32px;\n  max-width: 520px;\n  width: 90%;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"]),
	    _templateObject179 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 8px;\n"], ["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 8px;\n"]),
	    _templateObject180 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 0 0 24px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 0 0 24px;\n"]),
	    _templateObject181 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n"]),
	    _templateObject182 = _taggedTemplateLiteral(["\n  grid-column: 1 / -1;\n  font-weight: 600;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n  margin-bottom: -4px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"], ["\n  grid-column: 1 / -1;\n  font-weight: 600;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n  margin-bottom: -4px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"]),
	    _templateObject183 = _taggedTemplateLiteral(["\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  padding: 14px 18px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background: #EBF2FF;\n    border-color: #5C91F5;\n  }\n\n  &:disabled {\n    background: #F5F6F7;\n    border-color: #D5D9DD;\n    color: rgba(0, 27, 59, 0.4);\n    cursor: not-allowed;\n  }\n"], ["\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  padding: 14px 18px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background: #EBF2FF;\n    border-color: #5C91F5;\n  }\n\n  &:disabled {\n    background: #F5F6F7;\n    border-color: #D5D9DD;\n    color: rgba(0, 27, 59, 0.4);\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject184 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n\n  > button {\n    width: 100%;\n  }\n\n  &:hover > span {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: flex;\n\n  > button {\n    width: 100%;\n  }\n\n  &:hover > span {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject185 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject186 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n"]),
	    _templateObject187 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 18px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n"], ["\n  background: transparent;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 18px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n"]),
	    _templateObject188 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  max-width: 1300px;\n  margin-bottom: 16px;\n\n  @media (max-width: 1000px) {\n    grid-template-columns: 1fr;\n  }\n\n  > div {\n    margin-bottom: 0;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  max-width: 1300px;\n  margin-bottom: 16px;\n\n  @media (max-width: 1000px) {\n    grid-template-columns: 1fr;\n  }\n\n  > div {\n    margin-bottom: 0;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBootstrap = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Styled = {};
	
	Styled.BodyWrapper = _styledComponents2.default.div(_templateObject);
	
	Styled.TitleWrapper = _styledComponents2.default.div(_templateObject2);
	
	Styled.Title = _styledComponents2.default.div(_templateObject3);
	
	Styled.SubmitDecisionButton = _styledComponents2.default.div(_templateObject4, function (_ref) {
	  var submitted = _ref.submitted;
	  return submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)";
	});
	
	Styled.ButtonsWrapper = _styledComponents2.default.div(_templateObject5);
	
	Styled.ButtonsWrapperFlex = _styledComponents2.default.div(_templateObject6);
	
	Styled.UIButton = (0, _styledComponents2.default)(function (_ref2) {
	  var isSmaller = _ref2.isSmaller,
	      props = _objectWithoutProperties(_ref2, ["isSmaller"]);
	
	  return _react2.default.createElement(_reactBootstrap.Button, props);
	})(_templateObject7, function (p) {
	  return p.isSmaller && "\n    font-size: 18px !important;\n    width: 139px !important;\n    height: 30px !important;\n    line-height: 30px !important;\n  ";
	});
	
	Styled.Arrow = _styledComponents2.default.div(_templateObject8);
	
	Styled.CashBalanceRow = _styledComponents2.default.div(_templateObject9);
	
	Styled.CashBalanceTitle = _styledComponents2.default.div(_templateObject10);
	
	Styled.WhiteBlock = _styledComponents2.default.div(_templateObject11);
	
	Styled.Title1 = _styledComponents2.default.div(_templateObject12);
	
	Styled.Title2 = _styledComponents2.default.div(_templateObject13);
	
	Styled.HelpIcon = _styledComponents2.default.img(_templateObject14);
	
	Styled.HelpIconInline = _styledComponents2.default.img(_templateObject15);
	
	Styled.ModalVideoWrapper = _styledComponents2.default.div(_templateObject16);
	
	Styled.PlayPauseButton = _styledComponents2.default.button(_templateObject17);
	
	Styled.CloseModalVideoButton = _styledComponents2.default.button(_templateObject18);
	
	Styled.AmountsRow = _styledComponents2.default.div(_templateObject19);
	
	Styled.AmountsColumn1 = _styledComponents2.default.div(_templateObject20);
	Styled.AmountsColumn2 = _styledComponents2.default.div(_templateObject21);
	
	Styled.Title3 = _styledComponents2.default.div(_templateObject22);
	
	Styled.Title4 = _styledComponents2.default.div(_templateObject23);
	
	Styled.Amount = _styledComponents2.default.div(_templateObject24, function (p) {
	  return p.shown && "\n    display: block;\n  ";
	}, function (p) {
	  return p.negative && "\n    color: #ff4d4f;\n  ";
	});
	
	Styled.Chart = {};
	
	Styled.Chart.Wrapper = _styledComponents2.default.div(_templateObject25);
	
	Styled.Chart.Chart = _styledComponents2.default.div(_templateObject26);
	
	Styled.Chart.Legend = _styledComponents2.default.div(_templateObject27);
	
	Styled.Chart.LegendItem = _styledComponents2.default.div(_templateObject28, function (p) {
	  return p.bold && "\n    font-weight: bold;\n  ";
	});
	
	Styled.Chart.LegendItemCircle = _styledComponents2.default.div(_templateObject29, function (p) {
	  return p.color && "\n    background: " + p.color + ";\n  ";
	});
	
	/* ----- Redesign: subtitle, KPI cards, capital structure, summary tables ----- */
	
	Styled.Subtitle = _styledComponents2.default.div(_templateObject30);
	
	Styled.KpiRow = _styledComponents2.default.div(_templateObject31, function (p) {
	  return p.cardCount === 3 ? 'repeat(3, 1fr)' : '1fr 1fr 1fr 0.7fr 1fr';
	});
	
	Styled.KpiCard = _styledComponents2.default.div(_templateObject32);
	
	Styled.KpiLabel = _styledComponents2.default.div(_templateObject33);
	
	Styled.KpiValue = _styledComponents2.default.div(_templateObject34);
	
	Styled.HealthBadge = _styledComponents2.default.span(_templateObject35, function (p) {
	  return p.status === 'Healthy' && "\n    color: #2DA548;\n    background: #E8F5EC;\n  ";
	}, function (p) {
	  return p.status === 'Moderate' && "\n    color: #B25F00;\n    background: #FFF1DD;\n  ";
	}, function (p) {
	  return p.status === 'High' && "\n    color: #C62828;\n    background: #FDECEA;\n  ";
	}, function (p) {
	  return p.status === 'Very High' && "\n    color: #ffffff;\n    background: #8E1A1A;\n  ";
	});
	
	Styled.SectionCard = _styledComponents2.default.div(_templateObject36);
	
	Styled.SectionHeader = _styledComponents2.default.div(_templateObject37);
	
	Styled.SectionTitle = _styledComponents2.default.h2(_templateObject38);
	
	Styled.SectionSubtitle = _styledComponents2.default.div(_templateObject39);
	
	Styled.SectionSubtitleRow = _styledComponents2.default.div(_templateObject40);
	
	Styled.SectionSubtitleRow_Inner = _styledComponents2.default.div(_templateObject41);
	
	Styled.SectionSubtitleValue = _styledComponents2.default.div(_templateObject42);
	
	Styled.DonutWrapper = _styledComponents2.default.div(_templateObject43);
	
	Styled.DonutChart = _styledComponents2.default.div(_templateObject44);
	
	Styled.DonutCenter = _styledComponents2.default.div(_templateObject45);
	
	Styled.DonutCenterLabel = _styledComponents2.default.div(_templateObject46);
	
	Styled.DonutCenterValue = _styledComponents2.default.div(_templateObject47);
	
	Styled.DonutLegend = _styledComponents2.default.div(_templateObject48);
	
	Styled.LegendRow = _styledComponents2.default.div(_templateObject49);
	
	Styled.LegendRowTop = _styledComponents2.default.div(_templateObject50);
	
	Styled.LegendDot = _styledComponents2.default.div(_templateObject51, function (p) {
	  return p.color || '#000';
	});
	
	Styled.LegendLabel = _styledComponents2.default.div(_templateObject52);
	
	Styled.LegendValue = _styledComponents2.default.div(_templateObject42);
	
	Styled.LegendPercent = _styledComponents2.default.div(_templateObject53);
	
	Styled.LegendBar = _styledComponents2.default.div(_templateObject54);
	
	Styled.LegendBarFill = _styledComponents2.default.div(_templateObject55, function (p) {
	  return p.color || '#000';
	}, function (p) {
	  return p.percentage || 0;
	});
	
	Styled.SummaryTable = _styledComponents2.default.table(_templateObject56);
	
	Styled.SummaryHeadRow = _styledComponents2.default.tr(_templateObject57);
	
	Styled.SummaryHeadCell = _styledComponents2.default.th(_templateObject58, function (p) {
	  return p.align || 'left';
	});
	
	Styled.SummaryRow = _styledComponents2.default.tr(_templateObject59);
	
	Styled.SummaryCell = _styledComponents2.default.td(_templateObject60, function (p) {
	  return p.align || 'left';
	});
	
	// Money-with-aligned-$ pair: lays out a dollar sign on the left and a
	// fixed-width amount slot on the right so the $ stays at the same x
	// across rows even when number magnitudes differ.
	Styled.MoneyAligned = _styledComponents2.default.span(_templateObject61);
	
	Styled.MoneyPrefix = _styledComponents2.default.span(_templateObject62);
	
	Styled.MoneyAmount = _styledComponents2.default.span(_templateObject63);
	
	Styled.SummaryFooter = _styledComponents2.default.div(_templateObject64);
	
	Styled.SummaryFooterLabel = _styledComponents2.default.div(_templateObject65);
	
	Styled.SummaryFooterValue = _styledComponents2.default.div(_templateObject66);
	
	Styled.SectionHeaderRow = _styledComponents2.default.div(_templateObject67);
	
	Styled.SectionHeaderRight = _styledComponents2.default.div(_templateObject68);
	
	Styled.SectionHeaderRightLabel = _styledComponents2.default.div(_templateObject69);
	
	Styled.SectionHeaderRightValue = _styledComponents2.default.div(_templateObject70);
	
	/* ----- Choose Your Lender (Debt Decisions) modal ----- */
	
	Styled.LenderOverlay = _styledComponents2.default.div(_templateObject71);
	
	Styled.LenderModalHeader = _styledComponents2.default.div(_templateObject72);
	
	Styled.LenderModalTitle = _styledComponents2.default.h2(_templateObject73);
	
	Styled.LenderModalSubtitle = _styledComponents2.default.div(_templateObject74);
	
	Styled.LenderModalClose = _styledComponents2.default.button(_templateObject75);
	
	Styled.LenderStatusBar = _styledComponents2.default.div(_templateObject76);
	
	Styled.LenderStatusLeft = _styledComponents2.default.div(_templateObject77);
	
	Styled.LenderStatusItem = _styledComponents2.default.div(_templateObject78, function (p) {
	  return p.divider ? '1px solid #DEE0E3' : 'none';
	});
	
	Styled.LenderStatusLabel = _styledComponents2.default.div(_templateObject79);
	
	Styled.LenderStatusValue = _styledComponents2.default.div(_templateObject80);
	
	Styled.LenderStatusRight = _styledComponents2.default.div(_templateObject81);
	
	Styled.LenderStatusRightLabel = _styledComponents2.default.div(_templateObject82);
	
	Styled.LenderStatusRightCurrent = _styledComponents2.default.div(_templateObject83);
	
	Styled.LenderRatioBar = _styledComponents2.default.div(_templateObject84);
	
	Styled.LenderRatioSegment = _styledComponents2.default.div(_templateObject85, function (p) {
	  return p.color;
	}, function (p) {
	  return p.width;
	});
	
	Styled.LenderRatioMarker = _styledComponents2.default.div(_templateObject86, function (p) {
	  return p.color;
	}, function (p) {
	  return p.position;
	});
	
	Styled.LenderRatioDot = _styledComponents2.default.div(_templateObject87);
	
	Styled.LenderGrid = _styledComponents2.default.div(_templateObject88);
	
	var cardThemes = {
	  green: { border: '#2DA548', bg: '#EAF3EC', accent: '#2DA548', innerBg: '#FFFFFF', badgeBg: '#D1E9D6' },
	  yellow: { border: '#F9C151', bg: '#FFF8EB', accent: '#D69100', innerBg: '#FFFFFF', badgeBg: '#FBEDD5' },
	  red: { border: '#FF5252', bg: '#FAEDED', accent: '#C62828', innerBg: '#FFFFFF', badgeBg: '#FBD8D8' }
	};
	
	Styled.LenderCard = _styledComponents2.default.div(_templateObject89, function (p) {
	  return cardThemes[p.theme || 'green'].bg;
	}, function (p) {
	  return cardThemes[p.theme || 'green'].border;
	}, function (p) {
	  return p.noAnimation ? "opacity: 1;" : "\n      opacity: 0;\n      animation: fadeInLender 0.5s ease forwards;\n      animation-delay: " + (p.index || 0) * 500 + "ms;\n    ";
	});
	
	Styled.LenderCardTop = _styledComponents2.default.div(_templateObject90);
	
	Styled.LenderLogo = _styledComponents2.default.div(_templateObject91);
	
	Styled.LenderTitleArea = _styledComponents2.default.div(_templateObject92);
	
	Styled.LenderName = _styledComponents2.default.div(_templateObject93);
	
	Styled.LenderTagline = _styledComponents2.default.div(_templateObject94);
	
	Styled.LenderRiskBadge = _styledComponents2.default.span(_templateObject95, function (p) {
	  return cardThemes[p.theme || 'green'].badgeBg;
	}, function (p) {
	  return cardThemes[p.theme || 'green'].accent;
	}, function (p) {
	  return cardThemes[p.theme || 'green'].accent;
	});
	
	Styled.LenderDescription = _styledComponents2.default.p(_templateObject96);
	
	Styled.LenderInnerCard = _styledComponents2.default.div(_templateObject97);
	
	Styled.LenderInnerLabel = _styledComponents2.default.div(_templateObject98);
	
	Styled.LenderOfferRow = _styledComponents2.default.div(_templateObject99);
	
	Styled.LenderOfferCol = _styledComponents2.default.div(_templateObject92);
	
	Styled.LenderOfferLabel = _styledComponents2.default.div(_templateObject100);
	
	Styled.LenderOfferValue = _styledComponents2.default.div(_templateObject101, function (p) {
	  return cardThemes[p.theme || 'green'].accent;
	});
	
	Styled.LenderBalanceBig = _styledComponents2.default.div(_templateObject102, function (p) {
	  return cardThemes[p.theme || 'green'].accent;
	});
	
	Styled.LenderBalanceSplit = _styledComponents2.default.div(_templateObject103);
	
	Styled.LenderBalanceSplitCol = _styledComponents2.default.div(_templateObject92);
	
	Styled.LenderBalanceSplitLabel = _styledComponents2.default.div(_templateObject104);
	
	Styled.LenderBalanceSplitValue = _styledComponents2.default.div(_templateObject105, function (p) {
	  return cardThemes[p.theme || 'green'].accent;
	});
	
	Styled.LenderSelectButton = _styledComponents2.default.button(_templateObject106, function (p) {
	  return cardThemes[p.theme || 'green'].border;
	}, function (p) {
	  return cardThemes[p.theme || 'green'].bg;
	});
	
	Styled.LenderCardInfoIcon = _styledComponents2.default.span(_templateObject107);
	
	/* ----- Lender selected state: 2-col layout + Manage Your Loan ----- */
	
	Styled.LenderSplit = _styledComponents2.default.div(_templateObject108);
	
	Styled.FadeOutCard = _styledComponents2.default.div(_templateObject109);
	
	Styled.SelectedLenderWrapper = _styledComponents2.default.div(_templateObject110);
	
	Styled.ChooseDifferentLenderRow = _styledComponents2.default.div(_templateObject111);
	
	Styled.ChooseDifferentLenderButton = _styledComponents2.default.button(_templateObject112);
	
	Styled.ManageLoanPanel = _styledComponents2.default.div(_templateObject113);
	
	Styled.ManageLoanTitle = _styledComponents2.default.h3(_templateObject114);
	
	Styled.ManageLoanSubtitle = _styledComponents2.default.div(_templateObject115);
	
	Styled.ManageLoanSection = _styledComponents2.default.div(_templateObject116, function (p) {
	  return cardThemes[p.theme || 'green'].bg;
	});
	
	Styled.ManageSectionTitle = _styledComponents2.default.div(_templateObject117);
	
	Styled.ManageSectionDescription = _styledComponents2.default.p(_templateObject118);
	
	Styled.ManageInputRow = _styledComponents2.default.div(_templateObject50);
	
	Styled.ManageAmountField = _styledComponents2.default.div(_templateObject119);
	
	Styled.ManageAmountPrefix = _styledComponents2.default.span(_templateObject120);
	
	Styled.ManageAmountInput = _styledComponents2.default.input(_templateObject121);
	
	Styled.ManagePostButton = _styledComponents2.default.button(_templateObject122, function (p) {
	  return cardThemes[p.theme || 'green'].accent;
	});
	
	Styled.ManageUpdateButton = _styledComponents2.default.button(_templateObject123);
	
	Styled.ManageMetaRow = _styledComponents2.default.div(_templateObject124);
	
	Styled.ManageMetaLabel = _styledComponents2.default.span(_templateObject125);
	
	Styled.ManageMetaValue = _styledComponents2.default.span(_templateObject126);
	
	/* Confirm/notice modal reused inside Choose Your Lender */
	
	Styled.LenderNoticeOverlay = _styledComponents2.default.div(_templateObject127);
	
	Styled.LenderNoticeModal = _styledComponents2.default.div(_templateObject128);
	
	Styled.LenderNoticeTitle = _styledComponents2.default.h3(_templateObject129);
	
	Styled.LenderNoticeMessage = _styledComponents2.default.p(_templateObject130);
	
	Styled.LenderNoticeActions = _styledComponents2.default.div(_templateObject131);
	
	Styled.LenderNoticeButton = _styledComponents2.default.button(_templateObject132);
	
	Styled.LenderNoticeCancelButton = _styledComponents2.default.button(_templateObject133);
	
	Styled.LenderNoticeTermsList = _styledComponents2.default.div(_templateObject134);
	
	Styled.LenderNoticeTermLabel = _styledComponents2.default.div(_templateObject135);
	
	Styled.LenderNoticeTermValue = _styledComponents2.default.div(_templateObject136);
	
	/* ----- Choose Your Equity Investor (Equity Decisions) modal ----- */
	
	var equityTheme = {
	  border: '#A98DF6',
	  accent: '#A98DF6',
	  accentBold: '#AC86FF',
	  badgeBg: '#EAE4F9',
	  bgLight: 'rgba(169, 141, 246, 0.08)',
	  bgMid: 'rgba(169, 141, 246, 0.12)',
	  bgDark: 'rgba(169, 141, 246, 0.16)'
	};
	
	Styled.EquityStatusBar = _styledComponents2.default.div(_templateObject76);
	
	Styled.EquityStatusValuation = _styledComponents2.default.div(_templateObject137);
	
	Styled.EquityStatusSharePrice = _styledComponents2.default.div(_templateObject78, function (p) {
	  return p.last ? 'none' : '1px solid #DEE0E3';
	});
	
	Styled.EquityStatusLabel = _styledComponents2.default.div(_templateObject79);
	
	Styled.EquityStatusValueBig = _styledComponents2.default.div(_templateObject80);
	
	Styled.EquityStatusSharesGroup = _styledComponents2.default.div(_templateObject138);
	
	Styled.EquityStatusSharesHeader = _styledComponents2.default.div(_templateObject139);
	
	Styled.EquityStatusSharesHeaderLabel = _styledComponents2.default.div(_templateObject79);
	
	Styled.EquityStatusSharesRow = _styledComponents2.default.div(_templateObject140);
	
	Styled.EquityStatusShareItem = _styledComponents2.default.div(_templateObject141);
	
	Styled.EquityStatusShareItemLabel = _styledComponents2.default.div(_templateObject142);
	
	Styled.EquityStatusShareItemValue = _styledComponents2.default.div(_templateObject143);
	
	Styled.EquityCard = _styledComponents2.default.div(_templateObject144, function (p) {
	  return p.shade === 'mid' ? equityTheme.bgMid : p.shade === 'dark' ? equityTheme.bgDark : equityTheme.bgLight;
	}, equityTheme.border, function (p) {
	  return p.noAnimation ? "opacity: 1;" : "\n      opacity: 0;\n      animation: fadeInEquity 0.5s ease forwards;\n      animation-delay: " + (p.index || 0) * 500 + "ms;\n    ";
	});
	
	Styled.EquityCardTop = _styledComponents2.default.div(_templateObject90);
	
	Styled.EquityLogo = _styledComponents2.default.div(_templateObject145);
	
	Styled.EquityTitleArea = _styledComponents2.default.div(_templateObject49);
	
	Styled.EquityName = _styledComponents2.default.div(_templateObject146);
	
	Styled.EquityTagline = _styledComponents2.default.div(_templateObject147);
	
	Styled.EquityStageBadge = _styledComponents2.default.span(_templateObject148, equityTheme.badgeBg, equityTheme.accent, equityTheme.accent);
	
	Styled.EquityDescription = _styledComponents2.default.p(_templateObject149);
	
	Styled.EquityInnerCard = _styledComponents2.default.div(_templateObject150);
	
	Styled.EquityInnerLabel = _styledComponents2.default.div(_templateObject151);
	
	Styled.EquityInnerDescription = _styledComponents2.default.div(_templateObject152);
	
	Styled.EquityInnerBigValue = _styledComponents2.default.div(_templateObject153, equityTheme.accent);
	
	Styled.EquityExistingRow = _styledComponents2.default.div(_templateObject154);
	
	Styled.EquityExistingCol = _styledComponents2.default.div(_templateObject92);
	
	Styled.EquityExistingLabel = _styledComponents2.default.div(_templateObject155);
	
	Styled.EquityExistingValue = _styledComponents2.default.div(_templateObject156, equityTheme.accentBold);
	
	Styled.EquitySelectButton = _styledComponents2.default.button(_templateObject157, equityTheme.bgLight);
	
	/* === Decision Options panel (Issue / Buyback / Dividends) === */
	
	Styled.DecisionOptionsWrap = _styledComponents2.default.div(_templateObject158);
	
	Styled.DecisionOptionsTitle = _styledComponents2.default.h2(_templateObject159);
	
	Styled.DecisionTabBar = _styledComponents2.default.div(_templateObject160);
	
	Styled.DecisionTab = _styledComponents2.default.button(_templateObject161, function (p) {
	  return p.active ? '#fff' : 'transparent';
	}, function (p) {
	  return p.active ? '1px solid rgba(42, 65, 105, 0.2)' : '1px solid transparent';
	}, function (p) {
	  return p.active ? '#fff' : 'rgba(255, 255, 255, 0.5)';
	});
	
	Styled.DecisionPanel = _styledComponents2.default.div(_templateObject162, equityTheme.bgLight);
	
	Styled.DecisionPanelTitle = _styledComponents2.default.div(_templateObject163);
	
	Styled.DecisionPanelSubtitle = _styledComponents2.default.div(_templateObject164);
	
	Styled.DecisionInputsRow = _styledComponents2.default.div(_templateObject165);
	
	Styled.DecisionInputGroup = _styledComponents2.default.div(_templateObject166);
	
	Styled.DecisionInputLabel = _styledComponents2.default.div(_templateObject167);
	
	Styled.DecisionAmountField = _styledComponents2.default.div(_templateObject168);
	
	Styled.DecisionAmountPrefix = _styledComponents2.default.span(_templateObject169);
	
	Styled.DecisionAmountInput = _styledComponents2.default.input(_templateObject170, function (p) {
	  return p.hasButton ? '96px' : '0';
	});
	
	Styled.DecisionAmountStatic = _styledComponents2.default.div(_templateObject171);
	
	Styled.DecisionPostButton = _styledComponents2.default.button(_templateObject172);
	
	Styled.DecisionUpdateButton = (0, _styledComponents2.default)(Styled.DecisionPostButton)(_templateObject173);
	
	Styled.DecisionFooterRow = _styledComponents2.default.div(_templateObject174);
	
	Styled.DecisionFooterLabel = _styledComponents2.default.span(_templateObject125);
	
	Styled.DecisionFooterValue = _styledComponents2.default.span(_templateObject126);
	
	Styled.ManageButtonBar = _styledComponents2.default.div(_templateObject175);
	
	Styled.ManageButton = _styledComponents2.default.button(_templateObject176);
	
	Styled.ManageOverlay = _styledComponents2.default.div(_templateObject177);
	
	Styled.ManageModal = _styledComponents2.default.div(_templateObject178);
	
	Styled.ManageModalTitle = _styledComponents2.default.h3(_templateObject179);
	
	Styled.ManageModalSubtitle = _styledComponents2.default.p(_templateObject180);
	
	Styled.ManageGrid = _styledComponents2.default.div(_templateObject181);
	
	Styled.ManageGroupLabel = _styledComponents2.default.div(_templateObject182);
	
	Styled.ManageOption = _styledComponents2.default.button(_templateObject183);
	
	Styled.ManageOptionWrapper = _styledComponents2.default.div(_templateObject184);
	
	Styled.ManageOptionTooltip = _styledComponents2.default.span(_templateObject185);
	
	Styled.ManageCloseRow = _styledComponents2.default.div(_templateObject186);
	
	Styled.ManageCloseButton = _styledComponents2.default.button(_templateObject187);
	
	Styled.TwoColumnSection = _styledComponents2.default.div(_templateObject188);
	
	exports.default = Styled;

/***/ },
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 80 */
65,
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var observerUtil = __webpack_require__(1072);
	var reactPlatform_cjs = __webpack_require__(1073);
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	function _superPropBase(object, property) {
	  while (!Object.prototype.hasOwnProperty.call(object, property)) {
	    object = _getPrototypeOf(object);
	    if (object === null) break;
	  }
	
	  return object;
	}
	
	function _get(target, property, receiver) {
	  if (typeof Reflect !== "undefined" && Reflect.get) {
	    _get = Reflect.get;
	  } else {
	    _get = function _get(target, property, receiver) {
	      var base = _superPropBase(target, property);
	
	      if (!base) return;
	      var desc = Object.getOwnPropertyDescriptor(base, property);
	
	      if (desc.get) {
	        return desc.get.call(receiver);
	      }
	
	      return desc.value;
	    };
	  }
	
	  return _get(target, property, receiver || target);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
	    return;
	  }
	
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}
	
	// it is window in the DOM and global in NodeJS and React Native
	
	var isDOM = typeof window !== 'undefined';
	var isNative = typeof global !== 'undefined';
	var globalObj = isDOM ? window : isNative ? global : undefined;
	var hasHooks = typeof react.useState === 'function';
	
	var isInsideFunctionComponent = false;
	var isInsideClassComponentRender = false;
	var isInsideFunctionComponentWithoutHooks = false;
	var COMPONENT = Symbol('owner component');
	
	function mapStateToStores(state) {
	  // find store properties and map them to their none observable raw value
	  // to do not trigger none static this.setState calls
	  // from the static getDerivedStateFromProps lifecycle method
	  var component = state[COMPONENT];
	  return Object.keys(component).map(function (key) {
	    return component[key];
	  }).filter(observerUtil.isObservable).map(observerUtil.raw);
	}
	
	function view(Comp) {
	  var isStatelessComp = !(Comp.prototype && Comp.prototype.isReactComponent);
	  var ReactiveComp;
	
	  if (isStatelessComp && hasHooks) {
	    // use a hook based reactive wrapper when we can
	    ReactiveComp = function ReactiveComp(props) {
	      // use a dummy setState to update the component
	      var _useState = react.useState(),
	          _useState2 = _slicedToArray(_useState, 2),
	          setState = _useState2[1]; // create a memoized reactive wrapper of the original component (render)
	      // at the very first run of the component function
	
	
	      var render = react.useMemo(function () {
	        return observerUtil.observe(Comp, {
	          scheduler: function scheduler() {
	            return setState({});
	          },
	          lazy: true
	        });
	      }, // Adding the original Comp here is necessary to make React Hot Reload work
	      // it does not affect behavior otherwise
	      [Comp]); // cleanup the reactive connections after the very last render of the component
	
	      react.useEffect(function () {
	        return function () {
	          return observerUtil.unobserve(render);
	        };
	      }, []); // the isInsideFunctionComponent flag is used to toggle `store` behavior
	      // based on where it was called from
	
	      isInsideFunctionComponent = true;
	
	      try {
	        // run the reactive render instead of the original one
	        return render(props);
	      } finally {
	        isInsideFunctionComponent = false;
	      }
	    };
	  } else {
	    var BaseComp = isStatelessComp ? react.Component : Comp; // a HOC which overwrites render, shouldComponentUpdate and componentWillUnmount
	    // it decides when to run the new reactive methods and when to proxy to the original methods
	
	    var ReactiveClassComp = /*#__PURE__*/function (_BaseComp) {
	      _inherits(ReactiveClassComp, _BaseComp);
	
	      function ReactiveClassComp(props, context) {
	        var _this;
	
	        _classCallCheck(this, ReactiveClassComp);
	
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactiveClassComp).call(this, props, context));
	        _this.state = _this.state || {};
	        _this.state[COMPONENT] = _assertThisInitialized(_this); // create a reactive render for the component
	
	        _this.render = observerUtil.observe(_this.render, {
	          scheduler: function scheduler() {
	            return _this.setState({});
	          },
	          lazy: true
	        });
	        return _this;
	      }
	
	      _createClass(ReactiveClassComp, [{
	        key: "render",
	        value: function render() {
	          isInsideClassComponentRender = !isStatelessComp;
	          isInsideFunctionComponentWithoutHooks = isStatelessComp;
	
	          try {
	            return isStatelessComp ? Comp(this.props, this.context) : _get(_getPrototypeOf(ReactiveClassComp.prototype), "render", this).call(this);
	          } finally {
	            isInsideClassComponentRender = false;
	            isInsideFunctionComponentWithoutHooks = false;
	          }
	        } // react should trigger updates on prop changes, while easyState handles store changes
	
	      }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          var props = this.props,
	              state = this.state; // respect the case when the user defines a shouldComponentUpdate
	
	          if (_get(_getPrototypeOf(ReactiveClassComp.prototype), "shouldComponentUpdate", this)) {
	            return _get(_getPrototypeOf(ReactiveClassComp.prototype), "shouldComponentUpdate", this).call(this, nextProps, nextState);
	          } // return true if it is a reactive render or state changes
	
	
	          if (state !== nextState) {
	            return true;
	          } // the component should update if any of its props shallowly changed value
	
	
	          var keys = Object.keys(props);
	          var nextKeys = Object.keys(nextProps);
	          return nextKeys.length !== keys.length || nextKeys.some(function (key) {
	            return props[key] !== nextProps[key];
	          });
	        } // add a custom deriveStoresFromProps lifecyle method
	
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          // call user defined componentWillUnmount
	          if (_get(_getPrototypeOf(ReactiveClassComp.prototype), "componentWillUnmount", this)) {
	            _get(_getPrototypeOf(ReactiveClassComp.prototype), "componentWillUnmount", this).call(this);
	          } // clean up memory used by Easy State
	
	
	          observerUtil.unobserve(this.render);
	        }
	      }], [{
	        key: "getDerivedStateFromProps",
	        value: function getDerivedStateFromProps(props, state) {
	          if (_get(_getPrototypeOf(ReactiveClassComp), "deriveStoresFromProps", this)) {
	            var _get2;
	
	            // inject all local stores and let the user mutate them directly
	            var stores = mapStateToStores(state);
	
	            (_get2 = _get(_getPrototypeOf(ReactiveClassComp), "deriveStoresFromProps", this)).call.apply(_get2, [this, props].concat(_toConsumableArray(stores)));
	          } // respect user defined getDerivedStateFromProps
	
	
	          if (_get(_getPrototypeOf(ReactiveClassComp), "getDerivedStateFromProps", this)) {
	            return _get(_getPrototypeOf(ReactiveClassComp), "getDerivedStateFromProps", this).call(this, props, state);
	          }
	
	          return null;
	        }
	      }]);
	
	      return ReactiveClassComp;
	    }(BaseComp);
	
	    ReactiveComp = ReactiveClassComp;
	  }
	
	  ReactiveComp.displayName = Comp.displayName || Comp.name; // static props are inherited by class components,
	  // but have to be copied for function components
	
	  if (isStatelessComp) {
	    Object.keys(Comp).forEach(function (key) {
	      ReactiveComp[key] = Comp[key];
	    });
	  }
	
	  return isStatelessComp && hasHooks ? react.memo(ReactiveComp) : ReactiveComp;
	}
	
	var taskQueue = new Set();
	var scheduler = {
	  isOn: false,
	  add: function add(task) {
	    if (scheduler.isOn) {
	      taskQueue.add(task);
	    } else {
	      task();
	    }
	  },
	  flush: function flush() {
	    taskQueue.forEach(function (task) {
	      return task();
	    });
	    taskQueue.clear();
	  },
	  on: function on() {
	    scheduler.isOn = true;
	  },
	  off: function off() {
	    scheduler.isOn = false;
	  }
	};
	
	// until the function is finished running
	// react renders are batched by unstable_batchedUpdates
	// autoEffects and other custom reactions are batched by our scheduler
	
	function batch(fn, ctx, args) {
	  // do not apply scheduler logic if it is already applied from a parent function
	  // it would flush in the middle of the parent's batch
	  if (scheduler.isOn) {
	    return reactPlatform_cjs.unstable_batchedUpdates(function () {
	      return fn.apply(ctx, args);
	    });
	  }
	
	  try {
	    scheduler.on();
	    return reactPlatform_cjs.unstable_batchedUpdates(function () {
	      return fn.apply(ctx, args);
	    });
	  } finally {
	    scheduler.flush();
	    scheduler.off();
	  }
	} // this creates and returns a batched version of the passed function
	// the cache is necessary to always map the same thing to the same function
	// which makes sure that addEventListener/removeEventListener pairs don't break
	
	var cache = new WeakMap();
	
	function batchFn(fn) {
	  if (typeof fn !== 'function') {
	    return fn;
	  }
	
	  var batched = cache.get(fn);
	
	  if (!batched) {
	    batched = new Proxy(fn, {
	      apply: function apply(target, thisArg, args) {
	        return batch(target, thisArg, args);
	      }
	    });
	    cache.set(fn, batched);
	  }
	
	  return batched;
	}
	
	function batchMethodCallbacks(obj, method) {
	  var descriptor = Object.getOwnPropertyDescriptor(obj, method);
	
	  if (descriptor && descriptor.writable && typeof descriptor.value === 'function') {
	    obj[method] = new Proxy(descriptor.value, {
	      apply: function apply(target, ctx, args) {
	        return Reflect.apply(target, ctx, args.map(batchFn));
	      }
	    });
	  }
	} // batched obj.addEventListener(cb) like callbacks
	
	
	function batchMethodsCallbacks(obj, methods) {
	  methods.forEach(function (method) {
	    return batchMethodCallbacks(obj, method);
	  });
	}
	
	function batchMethod(obj, method) {
	  var descriptor = Object.getOwnPropertyDescriptor(obj, method);
	
	  if (!descriptor) {
	    return;
	  }
	
	  var value = descriptor.value,
	      writable = descriptor.writable,
	      set = descriptor.set,
	      configurable = descriptor.configurable;
	
	  if (configurable && typeof set === 'function') {
	    Object.defineProperty(obj, method, _objectSpread2({}, descriptor, {
	      set: batchFn(set)
	    }));
	  } else if (writable && typeof value === 'function') {
	    obj[method] = batchFn(value);
	  }
	} // batches obj.onevent = fn like calls and store methods
	
	
	function batchMethods(obj, methods) {
	  methods = methods || Object.getOwnPropertyNames(obj);
	  methods.forEach(function (method) {
	    return batchMethod(obj, method);
	  });
	  return obj;
	} // do a sync batching for the most common task sources
	// this should be removed when React's own batching is improved in the future
	// batch timer functions
	
	batchMethodsCallbacks(globalObj, ['setTimeout', 'setInterval', 'requestAnimationFrame', 'requestIdleCallback']);
	
	if (globalObj.Promise) {
	  batchMethodsCallbacks(Promise.prototype, ['then', 'catch']);
	} // Event listener batching causes an input caret jumping bug:
	// https://github.com/RisingStack/react-easy-state/issues/92.
	// This part has to be commented out to prevent that bug.
	// React batches setStates in its event listeners anyways
	// so this commenting this part out is not a huge issue.
	// batch addEventListener calls
	
	/* if (globalObj.EventTarget) {
	  batchMethodsCallbacks(EventTarget.prototype, [
	    'addEventListener',
	    'removeEventListener',
	  ]);
	} */
	// this batches websocket event handlers
	
	
	if (globalObj.WebSocket) {
	  batchMethods(WebSocket.prototype, ['onopen', 'onmessage', 'onerror', 'onclose']);
	} // HTTP event handlers are usually wrapped by Promises, which is covered above
	
	function createStore(obj) {
	  return batchMethods(observerUtil.observable(typeof obj === 'function' ? obj() : obj));
	}
	
	function store(obj) {
	  // do not create new versions of the store on every render
	  // if it is a local store in a function component
	  // create a memoized store at the first call instead
	  if (isInsideFunctionComponent) {
	    // useMemo is not a semantic guarantee
	    // In the future, React may choose to “forget” some previously memoized values and recalculate them on next render
	    // see this docs for more explanation: https://reactjs.org/docs/hooks-reference.html#usememo
	    return react.useMemo(function () {
	      return createStore(obj);
	    }, []);
	  }
	
	  if (isInsideFunctionComponentWithoutHooks) {
	    throw new Error('You cannot use state inside a function component with a pre-hooks version of React. Please update your React version to at least v16.8.0 to use this feature.');
	  }
	
	  if (isInsideClassComponentRender) {
	    throw new Error('You cannot use state inside a render of a class component. Please create your store outside of the render function.');
	  }
	
	  return createStore(obj);
	}
	
	function autoEffect(fn) {
	  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (isInsideFunctionComponent) {
	    return react.useEffect(function () {
	      var observer = observerUtil.observe(fn, {
	        scheduler: function scheduler$1() {
	          return scheduler.add(observer);
	        }
	      });
	      return function () {
	        return observerUtil.unobserve(observer);
	      };
	    }, deps);
	  }
	
	  if (isInsideFunctionComponentWithoutHooks) {
	    throw new Error('You cannot use autoEffect inside a function component with a pre-hooks version of React. Please update your React version to at least v16.8.0 to use this feature.');
	  }
	
	  if (isInsideClassComponentRender) {
	    throw new Error('You cannot use autoEffect inside a render of a class component. Please use it in the constructor or lifecycle methods instead.');
	  }
	
	  var observer = observerUtil.observe(fn, {
	    scheduler: function scheduler$1() {
	      return scheduler.add(observer);
	    }
	  });
	  return observer;
	}
	
	Object.defineProperty(exports, 'clearEffect', {
	  enumerable: true,
	  get: function () {
	    return observerUtil.unobserve;
	  }
	});
	exports.autoEffect = autoEffect;
	exports.batch = batch;
	exports.store = store;
	exports.view = view;
	//# sourceMappingURL=cjs.es5.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 1001;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 1001;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  width: 100%;\n  max-width: 400px;\n  position: fixed;\n  z-index: 1002;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 32px 32px 24px;\n'], ['\n  background: #ffffff;\n  width: 100%;\n  max-width: 400px;\n  position: fixed;\n  z-index: 1002;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 32px 32px 24px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: flex-start;\n  justify-content: flex-start;\n'], ['\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: flex-start;\n  justify-content: flex-start;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n'], ['\n  flex: 1;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  background: #5c91f5;\n  border-radius: 4px;\n  color: #ffffff;\n  border: 1.5px solid #5c91f5;\n  display: inline-block;\n  float: right;\n  margin-top: 24px;\n  padding: 6px 14px;\n  cursor: pointer;\n\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n'], ['\n  background: #5c91f5;\n  border-radius: 4px;\n  color: #ffffff;\n  border: 1.5px solid #5c91f5;\n  display: inline-block;\n  float: right;\n  margin-top: 24px;\n  padding: 6px 14px;\n  cursor: pointer;\n\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _errorIcon = __webpack_require__(2577);
	
	var _errorIcon2 = _interopRequireDefault(_errorIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AlertOverlay = _styledComponents2.default.div(_templateObject);
	
	var AlertWrapper = _styledComponents2.default.div(_templateObject2);
	
	var AlertBody = _styledComponents2.default.div(_templateObject3);
	
	var FullWidth = _styledComponents2.default.div(_templateObject4);
	
	var AlertTitle = _styledComponents2.default.div(_templateObject5);
	
	var AlertMessage = _styledComponents2.default.div(_templateObject6);
	
	var AlertButton = _styledComponents2.default.div(_templateObject7);
	
	var ErrorAlert = function ErrorAlert(_ref) {
	  var title = _ref.title,
	      message = _ref.message,
	      onHide = _ref.onHide;
	  return _react2.default.createElement(
	    _reactDotFragment2.default,
	    null,
	    _react2.default.createElement(AlertOverlay, null),
	    _react2.default.createElement(
	      AlertWrapper,
	      null,
	      _react2.default.createElement(
	        AlertBody,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: _errorIcon2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          FullWidth,
	          null,
	          _react2.default.createElement(
	            AlertTitle,
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            AlertMessage,
	            null,
	            message
	          ),
	          _react2.default.createElement(
	            AlertButton,
	            { onClick: onHide },
	            'Got it'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ErrorAlert;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	var _Paper = __webpack_require__(304);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OnePanel = function OnePanel(_ref) {
	  var title = _ref.title,
	      style = _ref.style,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _Paper2.default,
	    { style: Object.assign({ width: "100%" }, style) },
	    _react2.default.createElement(
	      "h1",
	      {
	        style: Object.assign({}, _styles.panelHeaderStyle, { marginBottom: "3em", fontWeight: "bold" })
	      },
	      title
	    ),
	    children
	  );
	};
	
	exports.default = OnePanel;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IFRAME_REF = "typeform-iframe";
	
	var TypeformLink = function (_PureComponent) {
	  _inherits(TypeformLink, _PureComponent);
	
	  function TypeformLink(props) {
	    _classCallCheck(this, TypeformLink);
	
	    var _this = _possibleConstructorReturn(this, (TypeformLink.__proto__ || Object.getPrototypeOf(TypeformLink)).call(this, props));
	
	    _this.show = function (e) {
	      e.preventDefault();
	
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.hide = function () {
	      _this.setState({ show: false });
	    };
	
	    _this.entered = function () {
	      _reactDom2.default.findDOMNode(_this.refs[IFRAME_REF]).focus();
	    };
	
	    _this.state = {
	      show: false
	    };
	    return _this;
	  }
	
	  _createClass(TypeformLink, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          url = _props.url,
	          className = _props.className;
	      var show = this.state.show;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "/#", className: className, onClick: this.show },
	          title
	        ),
	        url && _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            backdrop: true,
	            dialogClassName: "typeform-modal",
	            show: show,
	            onEntered: this.entered,
	            onHide: this.hide
	          },
	          _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement("iframe", {
	              ref: IFRAME_REF,
	              src: (0, _utils.addUserSpecificParams)(url),
	              style: { width: "100%", height: "500px" },
	              title: "Typeform"
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TypeformLink;
	}(_react.PureComponent);
	
	exports.default = TypeformLink;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserAnswer = exports.Assessments = exports.Charts = exports.ChartAxisLabel = exports.ExtraDetails = exports.ChartDataLabel = exports.ContentRightColumn = exports.ContentFlexColumns = exports.ContentTitle = exports.ContentContainer = exports.Image = exports.Text = exports.Title = exports.PreTitle = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n  margin-bottom: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n  margin-bottom: 24px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    color: rgba(0, 27, 59, 0.9);\n    text-decoration: underline;\n  }\n'], ['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    color: rgba(0, 27, 59, 0.9);\n    text-decoration: underline;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  background: #FFFFFF;\n  border: 1px solid rgba(0, 27, 59, 0.15);\n  border-radius: 8px;\n  padding: 20px;\n  font-family: \'Mukta Vaani\';\n  position: relative;\n\n  ', '\n\n  ', '\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #CCCCCC; \n  }\n\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-horizontal line:first-child,\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-horizontal line:last-child,\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-vertical line:first-child,\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-vertical line:last-child {\n    stroke-opacity: 0;\n  }\n'], ['\n  margin-top: 24px;\n  background: #FFFFFF;\n  border: 1px solid rgba(0, 27, 59, 0.15);\n  border-radius: 8px;\n  padding: 20px;\n  font-family: \'Mukta Vaani\';\n  position: relative;\n\n  ', '\n\n  ', '\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #CCCCCC; \n  }\n\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-horizontal line:first-child,\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-horizontal line:last-child,\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-vertical line:first-child,\n  .scatter-chart-container .recharts-wrapper .recharts-cartesian-grid-vertical line:last-child {\n    stroke-opacity: 0;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n  margin-bottom: 16px;\n\n  ', '\n'], ['\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n  margin-bottom: 16px;\n\n  ', '\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  \n  ', '\n  \n  ', '\n'], ['\n  display: flex;\n  align-items: center;\n  \n  ', '\n  \n  ', '\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-left: 25px;\n'], ['\n  margin-left: 25px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2F4166;\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  cursor: pointer;\n\n  ', '\n\n  &:before {\n    content: \'\';\n    display: block;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    margin-right: 8px;\n    background-color: #81c991;\n  }\n\n  &:nth-child(2):before {\n    background-color: #ccedd1;\n  }\n\n  &:nth-child(3):before {\n    background-color: #fd9595;\n  }\n\n  ', '\n'], ['\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2F4166;\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  cursor: pointer;\n\n  ', '\n\n  &:before {\n    content: \'\';\n    display: block;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    margin-right: 8px;\n    background-color: #81c991;\n  }\n\n  &:nth-child(2):before {\n    background-color: #ccedd1;\n  }\n\n  &:nth-child(3):before {\n    background-color: #fd9595;\n  }\n\n  ', '\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  padding: 32px 0 48px 32px;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  position: absolute;\n  right: -8px;\n  top: -12px;\n  bottom: -12px;\n  width: 39%;\n  display: flex;\n  column-gap: 19px;\n\n  ', '\n  \n  &:before {\n    display: block;\n    content: \'\';\n    width: 30px;\n    height: 30px;\n    padding: 15px;\n    background: #FD9595;\n    border-radius: 50%;\n  }\n\n  ', '\n'], ['\n  padding: 32px 0 48px 32px;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  position: absolute;\n  right: -8px;\n  top: -12px;\n  bottom: -12px;\n  width: 39%;\n  display: flex;\n  column-gap: 19px;\n\n  ', '\n  \n  &:before {\n    display: block;\n    content: \'\';\n    width: 30px;\n    height: 30px;\n    padding: 15px;\n    background: #FD9595;\n    border-radius: 50%;\n  }\n\n  ', '\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 8px;\n  padding-right: 32px\n'], ['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 8px;\n  padding-right: 32px\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n'], ['\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  padding-left: 20px;\n  padding-right: 32px;\n  overflow-y: auto;\n  max-height: 100%;\n  margin-bottom: 0;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    height: 50xp;\n    background: rgba(127, 127, 127, 0.65);\n    border-radius: 100px;\n  }\n'], ['\n  padding-left: 20px;\n  padding-right: 32px;\n  overflow-y: auto;\n  max-height: 100%;\n  margin-bottom: 0;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    height: 50xp;\n    background: rgba(127, 127, 127, 0.65);\n    border-radius: 100px;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  list-style-type: decimal;\n'], ['\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  list-style-type: decimal;\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n\n  ', '\n'], ['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n\n  ', '\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n\n  ', '\n'], ['\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n\n  ', '\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-bottom: 35px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n  gap: 60px;\n'], ['\n  display: flex;\n  margin-bottom: 35px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n  gap: 60px;\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ', '\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ', '\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  height: 16px;\n  width: 64px;\n  margin-right: 8px;\n\n  ', '\n'], ['\n  height: 16px;\n  width: 64px;\n  margin-right: 8px;\n\n  ', '\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 30px;\n  margin-top: 10px;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  gap: 30px;\n  margin-top: 10px;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.38);\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 15px;\n    height: 5px;\n    background: #52C5CD;\n    margin-right: 15px;\n  }\n\n  &:nth-child(2):before {\n    background: rgba(0, 27, 59, 0.6);\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.38);\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 15px;\n    height: 5px;\n    background: #52C5CD;\n    margin-right: 15px;\n  }\n\n  &:nth-child(2):before {\n    background: rgba(0, 27, 59, 0.6);\n  }\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 20px;\n  margin-top: 7px;\n  margin-bottom: 35px;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  gap: 20px;\n  margin-top: 7px;\n  margin-bottom: 35px;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.38);\n  font-weight: 700;\n'], ['\n  font-size: 14px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.38);\n  font-weight: 700;\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-bottom: 12px;\n'], ['\n  display: flex;\n  margin-bottom: 12px;\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n  width: 85px;\n  margin-right: 7px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  width: 85px;\n  margin-right: 7px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  width: 49px;\n  height: 49px;\n  background: #fff;\n  margin-bottom: 8px;\n  border-radius: 50%;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n'], ['\n  width: 49px;\n  height: 49px;\n  background: #fff;\n  margin-bottom: 8px;\n  border-radius: 50%;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  white-space: nowrap;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n'], ['\n  white-space: nowrap;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  border: 1px solid #CCCCCC;\n  padding: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.9);\n  width: calc(100% - 100px);\n  background: #fff;\n  position: relative;\n\n  &:before {\n    content: \'\';\n    display: inline-block;\n    background: url(', ') no-repeat center center;\n    background-size: 12.5px 20px;\n    width: 12.5px;\n    height: 20px;\n    position: absolute;\n    right: 100%;\n    top: 16px;\n  }\n\n  ', ':nth-child(2n-1) & {\n    background: rgba(249, 193, 81, 0.5);\n\n    &:before {\n      background-image: url(', ');\n    }\n  }\n'], ['\n  border: 1px solid #CCCCCC;\n  padding: 16px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.9);\n  width: calc(100% - 100px);\n  background: #fff;\n  position: relative;\n\n  &:before {\n    content: \'\';\n    display: inline-block;\n    background: url(', ') no-repeat center center;\n    background-size: 12.5px 20px;\n    width: 12.5px;\n    height: 20px;\n    position: absolute;\n    right: 100%;\n    top: 16px;\n  }\n\n  ', ':nth-child(2n-1) & {\n    background: rgba(249, 193, 81, 0.5);\n\n    &:before {\n      background-image: url(', ');\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _borderedTriangleLeftWhite = __webpack_require__(1840);
	
	var _borderedTriangleLeftWhite2 = _interopRequireDefault(_borderedTriangleLeftWhite);
	
	var _borderedTriangleLeftYellow = __webpack_require__(1841);
	
	var _borderedTriangleLeftYellow2 = _interopRequireDefault(_borderedTriangleLeftYellow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PreTitle = exports.PreTitle = _styledComponents2.default.div(_templateObject2);
	
	var Title = exports.Title = _styledComponents2.default.div(_templateObject3);
	
	var Text = exports.Text = _styledComponents2.default.div(_templateObject4);
	
	var Image = exports.Image = _styledComponents2.default.img(_templateObject5);
	
	var ContentContainer = exports.ContentContainer = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.transparent && '\n    background: transparent;\n    border: none;\n    padding: 0;\n  ';
	}, function (p) {
	  return p.maxHeight && '\n    max-height: ' + p.maxHeight + ';\n    overflow-y: auto;\n  ';
	});
	
	var ContentTitle = exports.ContentTitle = _styledComponents2.default.h3(_templateObject7, function (p) {
	  return p.big && '\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 28px;\n    color: rgba(0, 27, 59, 0.6);\n  ';
	});
	
	var ContentFlexColumns = exports.ContentFlexColumns = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.withFloatinDetailsBlock && '\n    width: calc(61% + 8px);\n  ';
	}, function (p) {
	  return p.withPadding && '\n    padding-right: 15px;\n  ';
	});
	
	var ContentRightColumn = exports.ContentRightColumn = _styledComponents2.default.div(_templateObject9);
	
	var ChartDataLabel = exports.ChartDataLabel = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.disabled && '\n    pointer-events: none;\n  ';
	}, function (p) {
	  return p.color && ':before {\n      background-color: ' + p.color + ' !important;\n    }\n  ';
	});
	
	var ExtraDetails = exports.ExtraDetails = {};
	
	ExtraDetails.Block = _styledComponents2.default.div(_templateObject11, function (p) {
	  return p.centered && '\n    top: 50%;\n    bottom: auto;\n    transform: translateY(-50%);\n    height: 256px;\n  ';
	}, function (p) {
	  return p.color && ':before {\n    background-color: ' + p.color + ';\n  }\n';
	});
	
	ExtraDetails.Title = _styledComponents2.default.h3(_templateObject12);
	
	ExtraDetails.ListContainer = _styledComponents2.default.div(_templateObject13);
	
	ExtraDetails.List = _styledComponents2.default.ul(_templateObject14);
	
	ExtraDetails.ListItem = _styledComponents2.default.li(_templateObject15);
	
	var ChartAxisLabel = exports.ChartAxisLabel = _styledComponents2.default.h4(_templateObject16, function (p) {
	  return p.rotated && '\n    transform: rotate(-90deg);\n    position: absolute;\n    top: 50%;\n    left: -10px;\n    margin: 0;\n  ';
	});
	
	var Charts = exports.Charts = {};
	
	Charts.Wrapper = _styledComponents2.default.div(_templateObject17, function (p) {
	  return p.setMaxHeight && '\n    max-height: 450px;\n  ';
	});
	
	Charts.Teams = {};
	
	Charts.Teams.Wrapper = _styledComponents2.default.div(_templateObject18);
	
	Charts.Teams.Row = _styledComponents2.default.div(_templateObject19, function (p) {
	  return p.margin && '\n    margin: ' + p.margin + ';\n  ';
	});
	
	Charts.Teams.TeamColor = _styledComponents2.default.div(_templateObject20, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	});
	
	Charts.Teams.TeamName = _styledComponents2.default.div(_templateObject21);
	
	Charts.Chart = _styledComponents2.default.div(_templateObject5);
	
	var Assessments = exports.Assessments = {};
	
	Assessments.Legends = _styledComponents2.default.div(_templateObject22);
	
	Assessments.Legend = _styledComponents2.default.div(_templateObject23);
	
	Assessments.Marks = _styledComponents2.default.div(_templateObject24);
	
	Assessments.Mark = _styledComponents2.default.div(_templateObject25);
	
	var UserAnswer = exports.UserAnswer = {};
	
	UserAnswer.Item = _styledComponents2.default.div(_templateObject26);
	
	UserAnswer.Profile = _styledComponents2.default.div(_templateObject27);
	
	UserAnswer.AvatarWrapper = _styledComponents2.default.div(_templateObject28);
	
	UserAnswer.Username = _styledComponents2.default.p(_templateObject29);
	
	UserAnswer.Text = _styledComponents2.default.div(_templateObject30, _borderedTriangleLeftWhite2.default, UserAnswer.Item, _borderedTriangleLeftYellow2.default);

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(235));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(346));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(348));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _max2 = _interopRequireDefault(__webpack_require__(736));
	
	var _min2 = _interopRequireDefault(__webpack_require__(738));
	
	var _flatMap2 = _interopRequireDefault(__webpack_require__(2036));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _get2 = _interopRequireDefault(__webpack_require__(133));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _rechartsScale = __webpack_require__(2426);
	
	var d3Scales = _interopRequireWildcard(__webpack_require__(1044));
	
	var _d3Shape = __webpack_require__(556);
	
	var _DataUtils = __webpack_require__(38);
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(294));
	
	var _Legend = _interopRequireDefault(__webpack_require__(543));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil2["default"])(obj) || (0, _isNil2["default"])(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get2["default"])(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction2["default"])(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	
	
	exports.getValueByDataKey = getValueByDataKey;
	
	var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap2["default"])(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(function (entry) {
	      return (0, _DataUtils.isNumber)(entry) || parseFloat(entry, 10);
	    });
	    return domain.length ? [(0, _min2["default"])(domain), (0, _max2["default"])(domain)] : [Infinity, -Infinity];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  }) : flattenData;
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	exports.getDomainOfDataByKey = getDomainOfDataByKey;
	
	var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range; // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	
	
	exports.calculateActiveTickIndex = calculateActiveTickIndex;
	
	var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var _item$props = item.props,
	      stroke = _item$props.stroke,
	      fill = _item$props.fill;
	  var result;
	
	  switch (displayName) {
	    case 'Line':
	      result = stroke;
	      break;
	
	    case 'Area':
	    case 'Radar':
	      result = stroke && stroke !== 'none' ? stroke : fill;
	      break;
	
	    default:
	      result = fill;
	      break;
	  }
	
	  return result;
	};
	
	exports.getMainColorOfGraphicItem = getMainColorOfGraphicItem;
	
	var getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData;
	
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	      var data = props.sectors || props.data || [];
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props2 = item.props,
	          dataKey = _item$props2.dataKey,
	          name = _item$props2.name,
	          legendType = _item$props2.legendType,
	          hide = _item$props2.hide;
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _objectSpread({}, legendItem.props, {}, _Legend["default"].getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	
	
	exports.getLegendProps = getLegendProps;
	
	var getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil2["default"])(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	
	
	exports.getBarSizeList = getBarSizeList;
	
	var getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	  var len = sizeList.length;
	  if (len < 1) return null;
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result; // whether or not is barSize setted by user
	
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = {
	      offset: offset - realBarGap,
	      size: 0
	    };
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: prev
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: newRes[newRes.length - 1].position
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	exports.getBarPosition = getBarPosition;
	
	var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({
	    children: children,
	    items: items,
	    legendWidth: legendWidth,
	    legendHeight: legendHeight
	  });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	exports.appendOffsetOfLegend = appendOffsetOfLegend;
	
	var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	    return (0, _isNil2["default"])(direction) || (0, _isNil2["default"])(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray2["default"])(entryValue) ? [(0, _min2["default"])(entryValue), (0, _max2["default"])(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[1] : errorValue);
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	
	exports.getDomainOfErrorBars = getDomainOfErrorBars;
	
	var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	
	
	exports.parseErrorBarsOfAxis = parseErrorBarsOfAxis;
	
	var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {}; // Get the union set of category axis
	
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	        result.push(entry[i]);
	      }
	    }
	
	    return result;
	  }, []);
	};
	
	exports.getDomainOfItemsWithSameAxis = getDomainOfItemsWithSameAxis;
	
	var isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	
	
	exports.isCategorialAxis = isCategorialAxis;
	
	var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin, hasMax;
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	
	
	exports.getCoordinatesOfGrid = getCoordinatesOfGrid;
	
	var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
	
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return {
	        coordinate: scale(entry) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  } // When axis has duplicated text, serial numbers are used to generate scale
	
	
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	
	
	exports.getTicksOfAxis = getTicksOfAxis;
	
	var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler;
	
	  if ((0, _isFunction2["default"])(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction2["default"])(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction2["default"])(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction2["default"])(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction2["default"])(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	
	
	exports.combineEventHandlers = combineEventHandlers;
	
	var parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    if (layout === 'radial' && axisType === 'angleAxis') {
	      return {
	        scale: d3Scales.scaleLinear(),
	        realScaleType: 'linear'
	      };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return {
	        scale: d3Scales.scalePoint(),
	        realScaleType: 'point'
	      };
	    }
	
	    if (type === 'category') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    return {
	      scale: d3Scales.scaleLinear(),
	      realScaleType: 'linear'
	    };
	  }
	
	  if ((0, _isString2["default"])(scale)) {
	    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction2["default"])(scale) ? {
	    scale: scale
	  } : {
	    scale: d3Scales.scalePoint(),
	    realScaleType: 'point'
	  };
	};
	
	exports.parseScale = parseScale;
	var EPS = 1e-4;
	
	var checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	exports.checkDomainOfScale = checkDomainOfScale;
	
	var findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	exports.findPositionOfBar = findPositionOfBar;
	
	var truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	  var result = [value[0], value[1]];
	
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	/* eslint no-param-reassign: 0 */
	
	
	exports.truncateByDomain = truncateByDomain;
	
	var offsetSign = function offsetSign(series) {
	  var n = series.length;
	
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN2["default"])(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	      /* eslint-disable prefer-destructuring */
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	      /* eslint-enable prefer-destructuring */
	
	    }
	  }
	};
	
	exports.offsetSign = offsetSign;
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	  return stack(data);
	};
	
	exports.getStackedData = getStackedData;
	
	var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  } // reversing items to affect render order (for layering)
	
	
	  var items = reverseStackOrder ? _items.reverse() : _items;
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props3 = item.props,
	        stackId = _item$props3.stackId,
	        hide = _item$props3.hide;
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || {
	      hasStack: false,
	      stackGroups: {}
	    };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: []
	      };
	      childGroup.items.push(item);
	      parentGroup.hasStack = true;
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: [item]
	      };
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	        return _objectSpread({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	
	
	exports.getStackGroupsByAxisId = getStackGroupsByAxisId;
	
	var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [(0, _min2["default"])(ticks), (0, _max2["default"])(ticks)];
	  }
	
	  return ticks;
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	
	
	exports.calculateDomainOfTicks = calculateDomainOfTicks;
	
	var getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	
	    if (!domain.length) {
	      return null;
	    }
	
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	    return {
	      niceTicks: tickValues
	    };
	  }
	
	  if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return {
	      niceTicks: _tickValues
	    };
	  }
	
	  return null;
	};
	
	exports.getTicksOfScale = getTicksOfScale;
	
	var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index,
	      dataKey = _ref6.dataKey;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil2["default"])(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, !(0, _isNil2["default"])(dataKey) ? dataKey : axis.dataKey);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) : null;
	};
	
	exports.getCateCoordinateOfLine = getCateCoordinateOfLine;
	
	var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	exports.getCateCoordinateOfBar = getCateCoordinateOfBar;
	
	var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	exports.getBaseValueOfBar = getBaseValueOfBar;
	
	var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	exports.getStackedDataOfItem = getStackedDataOfItem;
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [(0, _min2["default"])(entry.concat([result[0]]).filter(_DataUtils.isNumber)), (0, _max2["default"])(entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	exports.getDomainOfStackGroups = getDomainOfStackGroups;
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MIN_VALUE_REG = MIN_VALUE_REG;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MAX_VALUE_REG = MAX_VALUE_REG;
	
	var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray2["default"])(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	  /* eslint-disable prefer-destructuring */
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	  /* eslint-enable prefer-destructuring */
	
	
	  return domain;
	};
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	
	
	exports.parseSpecifiedDomain = parseSpecifiedDomain;
	
	var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy2["default"])(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	
	
	exports.getBandSizeOfAxis = getBandSizeOfAxis;
	
	var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual2["default"])(specifiedDomain, (0, _get2["default"])(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};
	
	exports.parseDomainOfCategoryAxis = parseDomainOfCategoryAxis;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormulaValue = exports.FormulaName = exports.ChartData = exports.ChartTitle = exports.ChartWrapper = exports.Cell = exports.Row = exports.Table = exports.SubTitle = exports.Alert = exports.Text = exports.Title = exports.PreTitle = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n  margin-bottom: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n  margin-bottom: 24px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\nfont-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\nfont-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    font-weight: 700;\n  }\n'], ['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    font-weight: 700;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  background: #fbedd5;\n  border: 1px solid #f9c151;\n  border-radius: 4px;\n  padding: 22px 20px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n\n  span {\n    display: flex;\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    background: #2196f3;\n    border-radius: 28px;\n    color: #fbedd5;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n'], ['\n  margin-top: 24px;\n  background: #fbedd5;\n  border: 1px solid #f9c151;\n  border-radius: 4px;\n  padding: 22px 20px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n\n  span {\n    display: flex;\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    background: #2196f3;\n    border-radius: 28px;\n    color: #fbedd5;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #ffffff;\n  margin-top: 12px;\n  overflow: hidden;\n'], ['\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #ffffff;\n  margin-top: 12px;\n  overflow: hidden;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  width: auto;\n\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: auto;\n\n  ', '\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 9px 16px;\n  display: flex;\n  align-items: center;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  flex: 1;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 9px 16px;\n  display: flex;\n  align-items: center;\n\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  padding: 20px;\n'], ['\n  padding: 20px;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 20px;\n  ', '\n  img {\n    display: inline-block;\n    width: 14px !important;\n    height: 14px;\n    position: relative;\n    top: -1px;\n    margin-left: 5px;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 20px;\n  ', '\n  img {\n    display: inline-block;\n    width: 14px !important;\n    height: 14px;\n    position: relative;\n    top: -1px;\n    margin-left: 5px;\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  max-width: 65%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  max-width: 65%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  padding: 16px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #ffffff;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  padding: 16px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #ffffff;\n\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  ', '\n\n  span.divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n\n  b, .negative-value {\n    color: #EC5E59;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  ', '\n\n  span.divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n\n  b, .negative-value {\n    color: #EC5E59;\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PreTitle = exports.PreTitle = _styledComponents2.default.div(_templateObject2);
	
	var Title = exports.Title = _styledComponents2.default.div(_templateObject3);
	
	var Text = exports.Text = _styledComponents2.default.div(_templateObject4);
	
	var Alert = exports.Alert = _styledComponents2.default.div(_templateObject5);
	
	var SubTitle = exports.SubTitle = _styledComponents2.default.div(_templateObject6);
	
	var Table = exports.Table = _styledComponents2.default.div(_templateObject7);
	
	var Row = exports.Row = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	});
	
	var Cell = exports.Cell = _styledComponents2.default.div(_templateObject9, function (p) {
	  return p.color && '\n    color: ' + p.color + ';\n  ';
	}, function (p) {
	  return p.fontWeight && '\n    font-weight: ' + p.fontWeight + ';\n  ';
	}, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	});
	
	var ChartWrapper = exports.ChartWrapper = _styledComponents2.default.div(_templateObject10);
	
	var ChartTitle = exports.ChartTitle = _styledComponents2.default.div(_templateObject11, function (p) {
	  return p.isFlex && '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  ';
	});
	
	var ChartData = exports.ChartData = _styledComponents2.default.div(_templateObject12);
	
	var FormulaName = exports.FormulaName = _styledComponents2.default.div(_templateObject13, function (p) {
	  return p.background && '\n    background-color: ' + p.background + ';\n  ';
	}, function (p) {
	  return p.padding && '\n    padding: ' + p.padding + ';\n  ';
	}, function (p) {
	  return p.color && '\n    color: ' + p.color + ';\n  ';
	});
	
	var FormulaValue = exports.FormulaValue = _styledComponents2.default.div(_templateObject14, function (p) {
	  return p.fontSize && '\n    font-size: ' + p.fontSize + ';\n  ';
	}, function (p) {
	  return p.isNegative && '\n    color: #EC5E59;\n  ';
	});

/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 90 */
[2766, 903],
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = void 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports.default = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 92 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
	  return it && it.Math == Math && it;
	};
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	module.exports =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof global == 'object' && global) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchAppGeneralInfo = fetchAppGeneralInfo;
	exports.clearAppGeneralInfoCache = clearAppGeneralInfoCache;
	exports.pickCourseAndGame = pickCourseAndGame;
	
	var _ApiService = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _cachedData = null;
	var _cacheTime = 0;
	var _cacheKey = null;
	// In-flight promise + key. Second (and third, ...) callers with the
	// same key while a request is still in flight get the same promise
	// instead of firing another network request. Prevents the "3x general-
	// info" bursts we saw on page refresh when App.js, the onboarding
	// gate, and round-admin all fired at once.
	var _inflight = null;
	var _inflightKey = null;
	var CACHE_TTL = 5 * 60 * 1000; // 5 minutes
	
	// The backend has two different general-info responses keyed by
	// `position=instructor` vs `position=student`. Always pass the
	// caller's position so we hit the right handler.
	//
	// `scope` is an optional payload-trim hint honored by BE (e.g.
	// `scope=dashboard` returns the minimal field set needed by the
	// instructor dashboard). Scope is part of the cache key so a trimmed
	// dashboard call and an untrimmed call from another page don't
	// collide.
	function fetchAppGeneralInfo(gameId, position, scope) {
	  var now = Date.now();
	  var key = (position || "") + "|" + (gameId || 0) + "|" + (scope || "");
	  if (_cachedData && _cacheKey === key && now - _cacheTime < CACHE_TTL) {
	    return Promise.resolve(_cachedData);
	  }
	  if (_inflight && _inflightKey === key) {
	    return _inflight;
	  }
	
	  var base = ("https://be-production-itb.marketgames.io/api/") + "app/general-info/";
	  var params = [];
	  if (position) params.push("position=" + position);
	  if (gameId) params.push("game_id=" + gameId);
	  if (scope) params.push("scope=" + scope);
	  var url = params.length ? base + "?" + params.join('&') : base;
	
	  _inflightKey = key;
	  _inflight = (0, _ApiService.getRequest)(url).then(function (_ref) {
	    var body = _ref.body;
	
	    _cachedData = body;
	    _cacheTime = now;
	    _cacheKey = key;
	    _inflight = null;
	    _inflightKey = null;
	    return body;
	  }).catch(function (err) {
	    // Clear in-flight on failure so retries aren't stuck on a
	    // permanently-rejected promise.
	    _inflight = null;
	    _inflightKey = null;
	    throw err;
	  });
	  return _inflight;
	}
	
	function clearAppGeneralInfoCache() {
	  _cachedData = null;
	  _cacheTime = 0;
	  _cacheKey = null;
	  _inflight = null;
	  _inflightKey = null;
	}
	
	// Deterministic active-course/active-game picker. Multi-course users
	// have arrays of courses and games in every general-info / login
	// payload. Rule: pick the highest-id course, then pick the highest-id
	// game whose game.course matches the picked course. This prevents the
	// "highest-id game across all games" fallback from silently promoting
	// a foreign course's game (the leak that motivated adding this).
	function pickCourseAndGame(courses, games) {
	  var courseList = Array.isArray(courses) ? courses : [];
	  var gameList = Array.isArray(games) ? games : [];
	  if (courseList.length === 0) {
	    return { course: null, game: null };
	  }
	  var pickedCourse = [].concat(_toConsumableArray(courseList)).sort(function (a, b) {
	    return b.id - a.id;
	  })[0];
	  var gamesInCourse = gameList.filter(function (g) {
	    return Number(g.course) === Number(pickedCourse.id);
	  });
	  var pickedGame = gamesInCourse.length > 0 ? [].concat(_toConsumableArray(gamesInCourse)).sort(function (a, b) {
	    return b.id - a.id;
	  })[0] : null;
	  return { course: pickedCourse, game: pickedGame };
	}

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #eaf3ec;\n  color: #222;\n  border: 1px solid #2da548;\n  border-radius: 4px;\n  margin-top: 20px;\n  width: 100%;\n  max-width: 800px;\n  padding: 9px 16px;\n\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n\n  ', '\n\n  ', '\n'], ['\n  background: #eaf3ec;\n  color: #222;\n  border: 1px solid #2da548;\n  border-radius: 4px;\n  margin-top: 20px;\n  width: 100%;\n  max-width: 800px;\n  padding: 9px 16px;\n\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n\n  ', '\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _successIcon = __webpack_require__(2674);
	
	var _successIcon2 = _interopRequireDefault(_successIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AlertWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.marginTop && '\n    margin-top: ' + p.marginTop + 'px;\n  ';
	}, function (p) {
	  return p.marginBottom && '\n    margin-bottom: ' + p.marginBottom + 'px;\n  ';
	});
	
	var SuccessAlert = function SuccessAlert(_ref) {
	  var message = _ref.message,
	      marginTop = _ref.marginTop,
	      marginBottom = _ref.marginBottom;
	  return _react2.default.createElement(
	    AlertWrapper,
	    { marginTop: marginTop, marginBottom: marginBottom },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _successIcon2.default, alt: '' })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      message
	    )
	  );
	};
	
	exports.default = SuccessAlert;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomModal = exports.Exhibit = exports.LineBreak = undefined;
	
	var _templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 1.5em;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  color: #424242;\n"], ["\n  margin-bottom: 1.5em;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  color: #424242;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 1.5em;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  color: #424242;\n"], ["\n  margin-bottom: 1.5em;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  color: #424242;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 1em;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 16px;\n  color: #666666;\n"], ["\n  margin-bottom: 1em;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 16px;\n  color: #666666;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  color: #073763;\n"], ["\n  color: #073763;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  max-width: ", "\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  ", "\n"], ["\n  max-width: ", "\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 18px;\n  color: #424242;\n  text-align: center;\n  margin-bottom: 1em;\n"], ["\n  font-family: Lato;\n  font-size: 18px;\n  color: #424242;\n  text-align: center;\n  margin-bottom: 1em;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  list-style-type: disc;\n\n  li {\n    padding-bottom: 1.5em;\n  }\n"], ["\n  list-style-type: disc;\n\n  li {\n    padding-bottom: 1.5em;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  margin-top: 3em;\n  border-top: 1px solid #424242;\n  font-size: 14px;\n  padding-top: 1em;\n"], ["\n  margin-top: 3em;\n  border-top: 1px solid #424242;\n  font-size: 14px;\n  padding-top: 1em;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  .custom-modal {\n    width: 90vw;\n    max-width: 1000px;\n\n    .modal-content {\n      font-size: 16px;\n      color: #424242;\n    }\n  }\n"], ["\n  .custom-modal {\n    width: 90vw;\n    max-width: 1000px;\n\n    .modal-content {\n      font-size: 16px;\n      color: #424242;\n    }\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-collapse: collapse;\n\n  th,\n  td {\n    border: 1px solid #000;\n    color: #000;\n    text-align: center;\n    padding: 5px 10px;\n\n    &:first-child {\n      text-align: left;\n    }\n  }\n\n  th {\n    text-align: left;\n    background-color: #990000;\n    color: #fff;\n    font-weight: bold !important;\n  }\n\n  tr.avg {\n    td {\n      background-color: #f1c232;\n    }\n  }\n\n  tr.grey {\n    td {\n      background-color: #efefef;\n      font-weight: bold;\n      color: #1c3b6d;\n    }\n  }\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n\n  th,\n  td {\n    border: 1px solid #000;\n    color: #000;\n    text-align: center;\n    padding: 5px 10px;\n\n    &:first-child {\n      text-align: left;\n    }\n  }\n\n  th {\n    text-align: left;\n    background-color: #990000;\n    color: #fff;\n    font-weight: bold !important;\n  }\n\n  tr.avg {\n    td {\n      background-color: #f1c232;\n    }\n  }\n\n  tr.grey {\n    td {\n      background-color: #efefef;\n      font-weight: bold;\n      color: #1c3b6d;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactBootstrap = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Styled = {};
	
	Styled.Title = _styledComponents2.default.h1(_templateObject);
	
	Styled.Subtitle = _styledComponents2.default.h2(_templateObject2);
	
	Styled.GreyBold = _styledComponents2.default.h3(_templateObject3);
	
	Styled.Bold = _styledComponents2.default.b(_templateObject4);
	
	Styled.ResponsiveImage = _styledComponents2.default.img(_templateObject5, function (p) {
	  return p.maxWidth ? p.maxWidth : "100%";
	}, function (p) {
	  return p.align && "\n    float: " + p.align + ";\n  ";
	});
	
	Styled.ImageDescription = _styledComponents2.default.div(_templateObject6);
	
	Styled.UnmarkedList = _styledComponents2.default.ol(_templateObject7);
	
	Styled.SupDescription = _styledComponents2.default.div(_templateObject8);
	
	Styled.CustomModal = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject9);
	
	Styled.ModalTable = _styledComponents2.default.table(_templateObject10);
	
	var LineBreak = exports.LineBreak = function LineBreak(_ref) {
	  var _ref$count = _ref.count,
	      count = _ref$count === undefined ? 2 : _ref$count;
	  return _react2.default.createElement(
	    _reactDotFragment2.default,
	    null,
	    [].concat(_toConsumableArray(Array(count).keys())).map(function (i) {
	      return _react2.default.createElement("br", { key: i });
	    })
	  );
	};
	
	var Exhibit = exports.Exhibit = function Exhibit(_ref2) {
	  var number = _ref2.number,
	      round = _ref2.round;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: "/analysis/bcase/modal-exhibit" + number + "?round=" + round },
	    "Exhibit ",
	    number
	  );
	};
	
	var CustomModal = exports.CustomModal = function CustomModal(_ref3) {
	  var children = _ref3.children,
	      goBack = _ref3.goBack;
	  return _react2.default.createElement(
	    Styled.CustomModal,
	    {
	      dialogClassName: "custom-modal",
	      show: true,
	      onHide: goBack
	    },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      children
	    )
	  );
	};
	
	exports.default = Styled;

/***/ },
/* 96 */
[2695, 57, 192, 51],
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var hide = __webpack_require__(96);
	var has = __webpack_require__(104);
	var SRC = __webpack_require__(196)('src');
	var $toString = __webpack_require__(1609);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(117).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var fails = __webpack_require__(31);
	var defined = __webpack_require__(129);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1953),
	    baseMatchesProperty = __webpack_require__(1954),
	    identity = __webpack_require__(232),
	    isArray = __webpack_require__(40),
	    property = __webpack_require__(2051);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 102 */
92,
/* 103 */
[2766, 1023],
/* 104 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 105 */
[2710, 271, 192, 107, 131, 104, 637, 51],
/* 106 */
[2713, 104, 64, 443],
/* 107 */
[2723, 270, 129],
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(722);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(472);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 110 */
[2754, 102, 911, 355, 902, 497, 2201, 2210],
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "configBezier", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configBezier;
	  }
	});
	Object.defineProperty(exports, "configSpring", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configSpring;
	  }
	});
	Object.defineProperty(exports, "translateStyle", {
	  enumerable: true,
	  get: function get() {
	    return _util.translateStyle;
	  }
	});
	Object.defineProperty(exports, "AnimateGroup", {
	  enumerable: true,
	  get: function get() {
	    return _AnimateGroup.default;
	  }
	});
	exports.default = void 0;
	
	var _Animate = _interopRequireDefault(__webpack_require__(997));
	
	var _easing = __webpack_require__(998);
	
	var _util = __webpack_require__(375);
	
	var _AnimateGroup = _interopRequireDefault(__webpack_require__(2404));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Animate.default;
	exports.default = _default;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.fetchTeamDecisions = fetchTeamDecisions;
	exports.fetchTeamStatus = fetchTeamStatus;
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _jstz = __webpack_require__(276);
	
	var _jstz2 = _interopRequireDefault(_jstz);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// In-flight promise dedup, keyed by the fully-built URL. When two
	// callers fire the same request in the same tick (typical example:
	// a child component's onDecisionMade callback hitting the parent's
	// fetchData at the same time the child does its own refresh), they
	// share one promise and one network request. Cleared when the
	// request resolves or rejects so subsequent calls re-hit the wire.
	var _inflight = new Map();
	var _shape = function _shape(body) {
	  return {
	    decisions: body.decisions,
	    operations_decisions: body.operations_decisions,
	    financial_decisions: body.financial_decisions,
	    products: body.products,
	    product_manufactures: body.product_manufactures,
	    team_machines: body.team_machines,
	    factories: body.factories,
	    hours: body.hours,
	    distributionCenter: body.distribution_centers,
	    distributionCentersInfo: body.distribution_centers_info,
	    distributionCenterPPE: body.ppes,
	    teamDebts: body.debts,
	    interest_payments: body.interest_payments,
	    balanceSheet: body.balance_sheet,
	    price_forecasts: body.price_forecasts,
	    sales: body.sales,
	    promos: body.promos,
	    inventory_balances: body.inventory_balances,
	    inventory_allocations: body.inventory_allocations,
	    dc_lease_schedules: body.dc_lease_schedules,
	    equities: body.equities,
	    stock_repurchased: body.stock_repurchased,
	    repurchased_shares: body.repurchased_shares,
	    dividends_payments: body.dividends_payments,
	    dividends_payment: body.dividends_payment,
	    dividend_payments: body.dividend_payments,
	    pre_moneys: body.pre_moneys,
	    pre_money: body.pre_money,
	    post_moneys: body.post_moneys,
	    performance_moneys: body.performance_moneys,
	    equity_cumulative: body.equity_cumulative,
	    constants: body.constants,
	    equity_clients: body.equity_clients,
	    unit_sales: body.unit_sales,
	    manufacture_costs: body.manufacture_costs,
	    machine_depreciations: body.machine_depreciations,
	    selling_price_factors: body.selling_price_factors,
	    max_allowed_matrix: body.max_allowed_matrix,
	    shipping_batch_size: body.shipping_batch_size,
	    metrics_report: body.metrics_report,
	    marketing_clients: body.marketing_clients,
	    sales_clients: body.sales_clients
	  };
	};
	
	/**
	 * Fetches all team decision data from the consolidated endpoint.
	 * Replaces individual calls to team/page/ceo, team/page/operations,
	 * team/page/financials, team/products, team/debts, etc.
	 */
	function fetchTeamDecisions(roundNumber, role, teamId, extraParams) {
	  var base = ("https://be-production-itb.marketgames.io/api/") + "app/team-decisions/";
	  var temporaryUser = _Auth2.default.getTemporaryUser();
	  var params = [];
	  if (roundNumber != null) params.push("round_number=" + roundNumber);
	  if (role) params.push("role=" + role);
	  if (teamId) params.push("team_id=" + teamId);else if (temporaryUser) params.push("team_id=" + temporaryUser.team_id);
	  if (extraParams && (typeof extraParams === "undefined" ? "undefined" : _typeof(extraParams)) === 'object') {
	    Object.keys(extraParams).forEach(function (k) {
	      if (extraParams[k] != null) {
	        params.push(k + "=" + extraParams[k]);
	      }
	    });
	  }
	  var url = params.length > 0 ? base + "?" + params.join('&') : base;
	
	  if (_inflight.has(url)) {
	    return _inflight.get(url);
	  }
	
	  var promise = (0, _ApiService.getRequest)(url).then(function (_ref) {
	    var body = _ref.body;
	
	    _inflight.delete(url);
	    return _shape(body);
	  }).catch(function (err) {
	    _inflight.delete(url);
	    throw err;
	  });
	  _inflight.set(url, promise);
	  return promise;
	}
	
	/**
	 * Fetches team status data (journal, submissions, unaccepted decisions)
	 * from the consolidated endpoint.
	 * Replaces individual calls to journal, unaccepted_decisions,
	 * and the 4 submit_* journal queries.
	 */
	function fetchTeamStatus(roundNumber) {
	  var base = ("https://be-production-itb.marketgames.io/api/") + "app/team-status/";
	  var temporaryUser = _Auth2.default.getTemporaryUser();
	  var url = roundNumber != null ? base + "?round_number=" + roundNumber : base;
	  if (temporaryUser) {
	    url += (roundNumber != null ? '&' : '?') + "team_id=" + temporaryUser.team_id;
	  }
	
	  return (0, _ApiService.getRequest)(url).then(function (_ref2) {
	    var body = _ref2.body;
	
	    var timezone = _jstz2.default.determine();
	
	    var submission_data = {
	      pd: { unaccepted: body.unaccepted_decisions.PD || 0, date: 'N/A' },
	      pm: { unaccepted: body.unaccepted_decisions.PM || 0, date: 'N/A' },
	      op: { unaccepted: body.unaccepted_decisions.OP || 0, date: 'N/A' },
	      fn: { unaccepted: body.unaccepted_decisions.FI || 0, date: 'N/A' }
	    };
	
	    var submissionMap = {
	      '/api/teams/submit_development/': 'pd',
	      '/api/teams/submit_marketing/': 'pm',
	      '/api/teams/submit_operations/': 'op',
	      '/api/teams/submit_finance/': 'fn'
	    };
	
	    Object.keys(body.last_submissions).forEach(function (path) {
	      var entry = body.last_submissions[path];
	      var type = submissionMap[path];
	      if (type && entry && entry.requested_at) {
	        submission_data[type].date = (0, _momentTimezone2.default)(entry.requested_at).tz(timezone.name()).format('MM/DD hh:mmA');
	      }
	    });
	
	    return {
	      journal: body.journal,
	      unaccepted_decisions: body.unaccepted_decisions,
	      last_submissions: body.last_submissions,
	      submission_data: submission_data
	    };
	  });
	}

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 12px;\n  color: rgba(0, 27, 59, 0.94);\n  text-transform: capitalize;\n  text-align: center;\n"], ["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 12px;\n  color: rgba(0, 27, 59, 0.94);\n  text-transform: capitalize;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  height: 40px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 100px;\n  padding: 4px 4.5px;\n  margin: 20px 21px 10.5px;\n  position: relative;\n"], ["\n  display: flex;\n  height: 40px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 100px;\n  padding: 4px 4.5px;\n  margin: 20px 21px 10.5px;\n  position: relative;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  background: #52C5CD;\n  border-radius: 100px;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n"], ["\n  width: 32px;\n  height: 32px;\n  background: #52C5CD;\n  border-radius: 100px;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 6px 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 6px 20px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 72px;\n\n  img {\n    margin-bottom: 4.5px;\n    width: 25px;\n    height: 25px;\n  }\n\n  p {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 23px;\n    color: rgba(0, 27, 59, 0.38);\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 72px;\n\n  img {\n    margin-bottom: 4.5px;\n    width: 25px;\n    height: 25px;\n  }\n\n  p {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 23px;\n    color: rgba(0, 27, 59, 0.38);\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0 6px;\n\n  b {\n    color: #EC5E59;\n  }\n"], ["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0 6px;\n\n  b {\n    color: #EC5E59;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 1;\n      width: calc(", "%);\n      background: linear-gradient(270deg, #92DBE1 -51.2%, #D7F0F2 99.88%);\n      border-radius: 100px;\n\n      &:after {\n        display: block;\n        content: '", "';\n        opacity: 0;\n        text-align: center;\n        position: absolute;\n        right: 0;\n        transform: translateX(50%);\n        top: -30px;\n        z-index: 1;\n        transition: opacity .15s ease-in-out;\n        padding: 3px 10px;\n        border: 1px solid #D5D9DD;\n        background: #fff;\n      }\n\n      &:hover:after {\n        opacity: 1;\n      }\n    "], ["\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 1;\n      width: calc(", "%);\n      background: linear-gradient(270deg, #92DBE1 -51.2%, #D7F0F2 99.88%);\n      border-radius: 100px;\n\n      &:after {\n        display: block;\n        content: '", "';\n        opacity: 0;\n        text-align: center;\n        position: absolute;\n        right: 0;\n        transform: translateX(50%);\n        top: -30px;\n        z-index: 1;\n        transition: opacity .15s ease-in-out;\n        padding: 3px 10px;\n        border: 1px solid #D5D9DD;\n        background: #fff;\n      }\n\n      &:hover:after {\n        opacity: 1;\n      }\n    "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _barsEmojiStronglyDisagree = __webpack_require__(684);
	
	var _barsEmojiStronglyDisagree2 = _interopRequireDefault(_barsEmojiStronglyDisagree);
	
	var _barsEmojiNeutral = __webpack_require__(682);
	
	var _barsEmojiNeutral2 = _interopRequireDefault(_barsEmojiNeutral);
	
	var _barsEmojiStronglyAgree = __webpack_require__(683);
	
	var _barsEmojiStronglyAgree2 = _interopRequireDefault(_barsEmojiStronglyAgree);
	
	var _ui = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ProgressTitle = _styledComponents2.default.h2(_templateObject);
	
	var ProgressLineContainer = _styledComponents2.default.div(_templateObject2);
	
	var RatingItems = _styledComponents2.default.div(_templateObject3);
	
	var RatingItem = _styledComponents2.default.div(_templateObject4);
	
	var EmotionsContainer = _styledComponents2.default.div(_templateObject5);
	
	var EmotionItem = _styledComponents2.default.div(_templateObject6);
	
	var ChartLabel = _styledComponents2.default.p(_templateObject7);
	
	var rating = Array.from({ length: 5 }, function (_, i) {
	  return i + 1;
	});
	
	var SkillsProgress = function (_Component) {
	  _inherits(SkillsProgress, _Component);
	
	  function SkillsProgress() {
	    _classCallCheck(this, SkillsProgress);
	
	    return _possibleConstructorReturn(this, (SkillsProgress.__proto__ || Object.getPrototypeOf(SkillsProgress)).apply(this, arguments));
	  }
	
	  _createClass(SkillsProgress, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          progressValue = _props.progressValue;
	
	
	      var percentageWidth = (progressValue - 1) / 4 * 100;
	
	      var Progress = _styledComponents2.default.div(_templateObject8, percentageWidth, progressValue);
	
	      return _react2.default.createElement(
	        _ui.ContentContainerWithBackground,
	        null,
	        _react2.default.createElement(
	          ProgressTitle,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          ProgressLineContainer,
	          null,
	          _react2.default.createElement(Progress, null),
	          _react2.default.createElement(
	            RatingItems,
	            null,
	            rating.map(function (item) {
	              return _react2.default.createElement(
	                RatingItem,
	                {
	                  key: item
	                },
	                item
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          EmotionsContainer,
	          null,
	          _react2.default.createElement(
	            EmotionItem,
	            null,
	            _react2.default.createElement("img", { src: _barsEmojiStronglyDisagree2.default, alt: "Strongly Disagree" }),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Needs work"
	            )
	          ),
	          _react2.default.createElement(
	            EmotionItem,
	            null,
	            _react2.default.createElement("img", { src: _barsEmojiNeutral2.default, alt: "Strongly Neutral" }),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Great!"
	            )
	          ),
	          _react2.default.createElement(
	            EmotionItem,
	            null,
	            _react2.default.createElement("img", { src: _barsEmojiStronglyAgree2.default, alt: "Strongly Agree" }),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Amazing!"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ChartLabel,
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "*"
	          ),
	          " A rating of 3 or higher = 100% "
	        )
	      );
	    }
	  }]);
	
	  return SkillsProgress;
	}(_react.Component);
	
	exports.default = SkillsProgress;

/***/ },
/* 115 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 116 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 117 */
115,
/* 118 */
[2691, 86],
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(31);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 120 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-table-help.3113ebc8.svg";

/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 124 */
[2797, 102, 507, 202, 920, 918, 921],
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var CallbackQueue = __webpack_require__(958);
	var PooledClass = __webpack_require__(204);
	var ReactFeatureFlags = __webpack_require__(966);
	var ReactReconciler = __webpack_require__(205);
	var Transaction = __webpack_require__(371);
	
	var invariant = __webpack_require__(29);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RADIAN = Math.PI / 180;
	exports.RADIAN = RADIAN;
	
	var degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	exports.degreeToRadian = degreeToRadian;
	
	var radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	exports.radianToDegree = radianToDegree;
	
	var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	exports.polarToCartesian = polarToCartesian;
	
	var getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	
	
	exports.getMaxRadius = getMaxRadius;
	
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	    var range;
	
	    if ((0, _isNil2["default"])(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      var _range = range;
	
	      var _range2 = _slicedToArray(_range, 2);
	
	      startAngle = _range2[0];
	      endAngle = _range2[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType,
	      scale: scale,
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	exports.distanceBetweenPoints = distanceBetweenPoints;
	
	var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	  var radius = distanceBetweenPoints({
	    x: x,
	    y: y
	  }, {
	    x: cx,
	    y: cy
	  });
	
	  if (radius <= 0) {
	    return {
	      radius: radius
	    };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return {
	    radius: radius,
	    angle: radianToDegree(angleInRadian),
	    angleInRadian: angleInRadian
	  };
	};
	
	exports.getAngleOfPoint = getAngleOfPoint;
	
	var formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	exports.formatAngleOfSector = formatAngleOfSector;
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return angle + min * 360;
	};
	
	var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({
	    x: x,
	    y: y
	  }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _objectSpread({}, sector, {
	      radius: radius,
	      angle: reverseFormatAngleOfSetor(formatAngle, sector)
	    });
	  }
	
	  return null;
	};
	
	exports.inRangeOfSector = inRangeOfSector;

/***/ },
/* 127 */
[2729, 420, 313, 160],
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(118);
	var IObject = __webpack_require__(270);
	var toObject = __webpack_require__(64);
	var toLength = __webpack_require__(48);
	var asc = __webpack_require__(427);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 129 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8);
	var core = __webpack_require__(117);
	var fails = __webpack_require__(31);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 131 */
[2726, 33],
/* 132 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(339);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 134 */
[2751, 65],
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3.default)(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        onKeyDown = _props2.onKeyDown,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled', 'onKeyDown']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction2.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports.default = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFinancialStatements = fetchFinancialStatements;
	
	var _ApiService = __webpack_require__(4);
	
	/**
	 * Fetches consolidated financial statements from /api/app/financial-statements/
	 *
	 * @param {Object} params
	 * @param {number} [params.roundNumber] - specific round
	 * @param {number} [params.roundLte] - all rounds up to this number
	 * @param {number} [params.teamId] - team ID (instructor view)
	 * @returns {Promise<{ incomeStatement, balanceSheet, cashflow, projections, financialAnalysis }>}
	 */
	function fetchFinancialStatements() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      roundNumber = _ref.roundNumber,
	      roundLte = _ref.roundLte,
	      teamId = _ref.teamId;
	
	  var url = ("https://be-production-itb.marketgames.io/api/") + "app/financial-statements/";
	  var params = [];
	  if (roundLte != null) {
	    params.push("round_lte=" + roundLte);
	  } else if (roundNumber != null) {
	    params.push("round_number=" + roundNumber);
	  }
	  if (teamId != null) {
	    params.push("team_id=" + teamId);
	  }
	  if (params.length > 0) {
	    url += "?" + params.join('&');
	  }
	
	  return (0, _ApiService.getRequest)(url).then(function (_ref2) {
	    var body = _ref2.body;
	    return {
	      incomeStatement: body.income_statement || [],
	      balanceSheet: body.balance_sheet || [],
	      cashflow: body.cashflow || [],
	      projections: body.projections || [],
	      financialAnalysis: body.financial_analysis || []
	    };
	  });
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 1001;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 1001;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  width: 100%;\n  max-width: ', 'px;\n  position: fixed;\n  z-index: 1002;\n  top: 300px;\n  left: 50%;\n  margin-left: ', 'px;\n  padding: 32px 32px 24px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n'], ['\n  background: #ffffff;\n  width: 100%;\n  max-width: ', 'px;\n  position: fixed;\n  z-index: 1002;\n  top: 300px;\n  left: 50%;\n  margin-left: ', 'px;\n  padding: 32px 32px 24px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: flex-start;\n  justify-content: flex-start;\n'], ['\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: flex-start;\n  justify-content: flex-start;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n'], ['\n  flex: 1;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n  float: right;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n'], ['\n  margin-top: 20px;\n  float: right;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  background: #5c91f5;\n  border: 1.5px solid #5c91f5;\n  border-radius: 4px;\n  color: #ffffff;\n  display: block;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n\n  ', '\n'], ['\n  background: #5c91f5;\n  border: 1.5px solid #5c91f5;\n  border-radius: 4px;\n  color: #ffffff;\n  display: block;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _warningIcon = __webpack_require__(2683);
	
	var _warningIcon2 = _interopRequireDefault(_warningIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AlertOverlay = _styledComponents2.default.div(_templateObject);
	
	var AlertWrapper = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.maxWidth || 400;
	}, function (p) {
	  return -((p.maxWidth || 400) / 2);
	});
	
	var AlertBody = _styledComponents2.default.div(_templateObject3);
	
	var FullWidth = _styledComponents2.default.div(_templateObject4);
	
	var AlertTitle = _styledComponents2.default.div(_templateObject5);
	
	var AlertMessage = _styledComponents2.default.div(_templateObject6);
	
	var AlertButtons = _styledComponents2.default.div(_templateObject7);
	
	var AlertButton = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.isWhite && '\n    background: #fff;\n    border-color: #d5d9dd;\n    color: rgba(0, 27, 59, 0.94);\n  ';
	});
	
	var WarningAlert = function WarningAlert(_ref) {
	  var title = _ref.title,
	      message = _ref.message,
	      onCancel = _ref.onCancel,
	      _ref$showCancel = _ref.showCancel,
	      showCancel = _ref$showCancel === undefined ? true : _ref$showCancel,
	      onSuccess = _ref.onSuccess,
	      _ref$successButtonTex = _ref.successButtonText,
	      successButtonText = _ref$successButtonTex === undefined ? 'Yes' : _ref$successButtonTex,
	      maxWidth = _ref.maxWidth;
	  return _react2.default.createElement(
	    _reactDotFragment2.default,
	    null,
	    _react2.default.createElement(AlertOverlay, null),
	    _react2.default.createElement(
	      AlertWrapper,
	      { maxWidth: maxWidth },
	      _react2.default.createElement(
	        AlertBody,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: _warningIcon2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          FullWidth,
	          null,
	          _react2.default.createElement(
	            AlertTitle,
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            AlertMessage,
	            null,
	            message
	          ),
	          _react2.default.createElement(
	            AlertButtons,
	            null,
	            showCancel && _react2.default.createElement(
	              AlertButton,
	              { onClick: onCancel, isWhite: true },
	              'No'
	            ),
	            _react2.default.createElement(
	              AlertButton,
	              { onClick: onSuccess },
	              successButtonText
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = WarningAlert;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	/**
	 * Price in millions.
	 */
	/**
	 *
	 * FNAnalysisFNStatementsIncomeStatement
	 *
	 */
	
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName,
	      _ref$isPerformanceFee = _ref.isPerformanceFeedback,
	      isPerformanceFeedback = _ref$isPerformanceFee === undefined ? false : _ref$isPerformanceFee;
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName, style: isPerformanceFeedback ? { color: '#000' } : null },
	      "n/a"
	    );
	  }
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(2) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: "red " + baseClassName },
	      "-$" + newPrice + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(2);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName, style: isPerformanceFeedback ? { color: '#000' } : null },
	      "$" + newPrice + "M"
	    );
	  }
	};
	
	/**
	 * Table row contents
	 */
	
	var TableHead = function TableHead(_ref2) {
	  var current_year = _ref2.current_year;
	  return _react2.default.createElement(
	    "thead",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "th",
	        { className: "table-title text-center" },
	        _react2.default.createElement("span", null)
	      ),
	      _react2.default.createElement(
	        "th",
	        { className: "table-title title-gray text-center" },
	        "YEAR ",
	        current_year
	      )
	    )
	  );
	};
	
	/**
	 * Table row contents
	 */
	
	var TableRowContents = function TableRowContents(_ref3) {
	  var incomeStatement = _ref3.incomeStatement,
	      name = _ref3.name,
	      isPerformanceFeedback = _ref3.isPerformanceFeedback,
	      preColumn = _ref3.preColumn,
	      _ref3$rowSpan = _ref3.rowSpan,
	      rowSpan = _ref3$rowSpan === undefined ? 1 : _ref3$rowSpan;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    preColumn && _react2.default.createElement(
	      "th",
	      { className: "description bold-font", rowSpan: rowSpan, style: isPerformanceFeedback ? { border: 'none', color: _Teams2.default.currentTeamColor(), textAlign: 'left', verticalAlign: 'middle' } : null },
	      preColumn
	    ),
	    _react2.default.createElement(
	      "th",
	      { className: "description", style: isPerformanceFeedback ? { border: 'none', color: '#000', textAlign: 'right' } : null },
	      name ? name : incomeStatement.name
	    ),
	    _react2.default.createElement(
	      "td",
	      { style: isPerformanceFeedback ? { border: 'none', textAlign: 'left' } : null },
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: incomeStatement.data.value,
	        isPerformanceFeedback: isPerformanceFeedback
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents with gray background color.
	 */
	
	var TableRowContentsFooter = function TableRowContentsFooter(_ref4) {
	  var incomeStatement = _ref4.incomeStatement,
	      isPerformanceFeedback = _ref4.isPerformanceFeedback;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description", style: isPerformanceFeedback ? {
	          border: 'none',
	          color: '#000',
	          textAlign: 'right',
	          backgroundColor: _Teams2.default.currentTeamColor(),
	          borderTopLeftRadius: '100px',
	          borderBottomLeftRadius: '100px'
	        } : null },
	      _react2.default.createElement(
	        "strong",
	        null,
	        incomeStatement.name,
	        incomeStatement.name === "Gross Profit" && !isPerformanceFeedback && _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	          iconSize: "sm"
	        }, _TypeformContent2.default.GROSS_PROFITS))
	      )
	    ),
	    _react2.default.createElement(
	      "td",
	      { style: isPerformanceFeedback ? { border: 'none', textAlign: 'left', backgroundColor: _Teams2.default.currentTeamColor() } : null },
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: incomeStatement.data.value,
	        isPerformanceFeedback: isPerformanceFeedback
	      })
	    )
	  );
	};
	
	/**
	 * Table row total content
	 */
	
	var TotalComponent = function TotalComponent(_ref5) {
	  var incomeStatement = _ref5.incomeStatement,
	      title = _ref5.title,
	      isPerformanceFeedback = _ref5.isPerformanceFeedback;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description", style: isPerformanceFeedback ? {
	          border: 'none',
	          color: '#000',
	          textAlign: 'right',
	          backgroundColor: _Teams2.default.currentTeamColor(),
	          borderTopLeftRadius: '100px',
	          borderBottomLeftRadius: '100px'
	        } : null },
	      _react2.default.createElement(
	        "strong",
	        null,
	        title ? title : incomeStatement.name,
	        title === "Net Profits" && !isPerformanceFeedback && _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	          iconSize: "sm"
	        }, _TypeformContent2.default.NET_PROFITS))
	      )
	    ),
	    _react2.default.createElement(
	      "td",
	      { style: isPerformanceFeedback ? { border: 'none', textAlign: 'left', backgroundColor: _Teams2.default.currentTeamColor() } : null },
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: incomeStatement.data.value,
	        isPerformanceFeedback: isPerformanceFeedback
	      })
	    )
	  );
	};
	
	/**
	 * Table row operating profit
	 */
	
	var OperatingProfitComponent = function OperatingProfitComponent(_ref6) {
	  var totalOperatingExpenses = _ref6.totalOperatingExpenses,
	      grossProfits = _ref6.grossProfits,
	      isPerformanceFeedback = _ref6.isPerformanceFeedback;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description", style: isPerformanceFeedback ? {
	          border: 'none',
	          color: '#000',
	          textAlign: 'right',
	          backgroundColor: _Teams2.default.currentTeamColor(),
	          borderTopLeftRadius: '100px',
	          borderBottomLeftRadius: '100px'
	        } : null },
	      _react2.default.createElement(
	        "strong",
	        null,
	        isPerformanceFeedback ? 'Operating Profit' : 'Operation Profits'
	      )
	    ),
	    _react2.default.createElement(
	      "td",
	      { style: isPerformanceFeedback ? { border: 'none', textAlign: 'left', backgroundColor: _Teams2.default.currentTeamColor() } : null },
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: totalOperatingExpenses.data.value + grossProfits.data.value,
	        isPerformanceFeedback: isPerformanceFeedback
	      })
	    )
	  );
	};
	
	/**
	 * Table row title.
	 */
	
	var TotalTitleHeader = function TotalTitleHeader(_ref7) {
	  var title = _ref7.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title title-sky-blue" },
	      title
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row flex" },
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" })
	      )
	    )
	  );
	};
	
	/**
	 *
	 * FNAnalysisFNStatementsIncomeStatement
	 *
	 */
	function IncomeStatementWidget(_ref8) {
	  var incomeStatement = _ref8.incomeStatement,
	      current_year = _ref8.current_year,
	      _ref8$className = _ref8.className,
	      className = _ref8$className === undefined ? "team-reports-with-scroll" : _ref8$className,
	      _ref8$isPerformanceFe = _ref8.isPerformanceFeedback,
	      isPerformanceFeedback = _ref8$isPerformanceFe === undefined ? false : _ref8$isPerformanceFe;
	  var costOfSales = incomeStatement.costOfSales,
	      revenues = incomeStatement.revenues,
	      grossProfits = incomeStatement.grossProfits,
	      RnDCosts = incomeStatement.RnDCosts,
	      holdingCosts = incomeStatement.holdingCosts,
	      promotionCosts = incomeStatement.promotionCosts,
	      sellingCosts = incomeStatement.sellingCosts,
	      gnACosts = incomeStatement.gnACosts,
	      incomingBeforeTaxes = incomeStatement.incomingBeforeTaxes,
	      taxes = incomeStatement.taxes,
	      totalNonOperatingCost = incomeStatement.totalNonOperatingCost,
	      interestExpense = incomeStatement.interestExpense,
	      totalOperatingExpenses = incomeStatement.totalOperatingExpenses,
	      gainOrLossoFSales = incomeStatement.gainOrLossoFSales,
	      otherNonOperatingCosts = incomeStatement.otherNonOperatingCosts,
	      netIncome = incomeStatement.netIncome;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "panel-dashboard-white-full " + className },
	    _react2.default.createElement(
	      "h5",
	      { className: "title-sky-blue" },
	      "Income Statement",
	      _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	        iconSize: "sm"
	      }, _TypeformContent2.default.INCOME_STATEMENT))
	    ),
	    isPerformanceFeedback && _react2.default.createElement(
	      "h5",
	      { className: "title-sky-blue visible-title" },
	      "Income Statement"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table-responsive fn-results-table", style: isPerformanceFeedback ? { paddingBottom: '20px' } : null },
	      _react2.default.createElement(
	        "table",
	        { className: "table border-analysis mb-20" },
	        !isPerformanceFeedback && _react2.default.createElement(TableHead, { current_year: current_year }),
	        Object.keys(costOfSales.data).length > 0 || Object.keys(revenues.data).length > 0 || Object.keys(grossProfits.data).length > 0 ? _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(TableRowContents, { incomeStatement: revenues, isPerformanceFeedback: isPerformanceFeedback, rowSpan: 3, preColumn: isPerformanceFeedback ? 'Gross Profits' : null }),
	          _react2.default.createElement(TableRowContents, { incomeStatement: costOfSales, isPerformanceFeedback: isPerformanceFeedback }),
	          _react2.default.createElement(TableRowContentsFooter, { incomeStatement: grossProfits, isPerformanceFeedback: isPerformanceFeedback }),
	          !isPerformanceFeedback && _react2.default.createElement(TotalTitleHeader, { title: "Operating Expenses" }),
	          _react2.default.createElement(TableRowContents, { incomeStatement: RnDCosts, isPerformanceFeedback: isPerformanceFeedback, rowSpan: 6, preColumn: isPerformanceFeedback ? 'Operating Profit' : null }),
	          _react2.default.createElement(TableRowContents, { incomeStatement: holdingCosts, isPerformanceFeedback: isPerformanceFeedback }),
	          _react2.default.createElement(TableRowContents, { incomeStatement: promotionCosts, isPerformanceFeedback: isPerformanceFeedback }),
	          _react2.default.createElement(TableRowContents, { incomeStatement: sellingCosts, isPerformanceFeedback: isPerformanceFeedback }),
	          _react2.default.createElement(TableRowContents, {
	            incomeStatement: gnACosts,
	            name: "Other G&A Costs",
	            isPerformanceFeedback: isPerformanceFeedback
	          }),
	          !isPerformanceFeedback && _react2.default.createElement(TableRowContentsFooter, {
	            incomeStatement: totalOperatingExpenses
	          }),
	          _react2.default.createElement(OperatingProfitComponent, {
	            totalOperatingExpenses: totalOperatingExpenses,
	            grossProfits: grossProfits,
	            isPerformanceFeedback: isPerformanceFeedback
	          }),
	          !isPerformanceFeedback && _react2.default.createElement(TotalTitleHeader, { title: "Non-Operating Costs" }),
	          _react2.default.createElement(TableRowContents, { incomeStatement: interestExpense, isPerformanceFeedback: isPerformanceFeedback, rowSpan: 2, preColumn: isPerformanceFeedback ? 'Net Profits' : null }),
	          !isPerformanceFeedback && _react2.default.createElement(TableRowContents, { incomeStatement: gainOrLossoFSales }),
	          !isPerformanceFeedback && _react2.default.createElement(TableRowContents, { incomeStatement: otherNonOperatingCosts }),
	          !isPerformanceFeedback && _react2.default.createElement(TotalComponent, { incomeStatement: totalNonOperatingCost }),
	          !isPerformanceFeedback && _react2.default.createElement(TotalTitleHeader, { title: "Profits" }),
	          !isPerformanceFeedback && _react2.default.createElement(TableRowContents, { incomeStatement: incomingBeforeTaxes }),
	          !isPerformanceFeedback && _react2.default.createElement(TableRowContents, { incomeStatement: taxes }),
	          _react2.default.createElement(TotalComponent, { incomeStatement: netIncome, title: "Net Profits", isPerformanceFeedback: isPerformanceFeedback })
	        ) : _react2.default.createElement("tbody", { className: "empty-table" })
	      )
	    )
	  );
	}
	
	exports.default = IncomeStatementWidget;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(659);
	var $export = __webpack_require__(8);
	var shared = __webpack_require__(272)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(663))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(51)) {
	  var LIBRARY = __webpack_require__(162);
	  var global = __webpack_require__(30);
	  var fails = __webpack_require__(31);
	  var $export = __webpack_require__(8);
	  var $typed = __webpack_require__(326);
	  var $buffer = __webpack_require__(448);
	  var ctx = __webpack_require__(118);
	  var anInstance = __webpack_require__(187);
	  var propertyDesc = __webpack_require__(192);
	  var hide = __webpack_require__(96);
	  var redefineAll = __webpack_require__(193);
	  var toInteger = __webpack_require__(120);
	  var toLength = __webpack_require__(48);
	  var toIndex = __webpack_require__(657);
	  var toAbsoluteIndex = __webpack_require__(195);
	  var toPrimitive = __webpack_require__(131);
	  var has = __webpack_require__(104);
	  var classof = __webpack_require__(222);
	  var isObject = __webpack_require__(33);
	  var toObject = __webpack_require__(64);
	  var isArrayIter = __webpack_require__(434);
	  var create = __webpack_require__(189);
	  var getPrototypeOf = __webpack_require__(106);
	  var gOPN = __webpack_require__(190).f;
	  var getIterFn = __webpack_require__(450);
	  var uid = __webpack_require__(196);
	  var wks = __webpack_require__(44);
	  var createArrayMethod = __webpack_require__(128);
	  var createArrayIncludes = __webpack_require__(314);
	  var speciesConstructor = __webpack_require__(273);
	  var ArrayIterators = __webpack_require__(451);
	  var Iterators = __webpack_require__(223);
	  var $iterDetect = __webpack_require__(319);
	  var setSpecies = __webpack_require__(194);
	  var arrayFill = __webpack_require__(426);
	  var arrayCopyWithin = __webpack_require__(629);
	  var $DP = __webpack_require__(57);
	  var $GOPD = __webpack_require__(105);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PropTypes = __webpack_require__(2);
	var React = global.React || __webpack_require__(1);
	var createReactClass = __webpack_require__(73);
	var Formsy = {};
	var validationRules = __webpack_require__(1876);
	var formDataToObject = __webpack_require__(1865);
	var utils = __webpack_require__(696);
	var Mixin = __webpack_require__(459);
	var HOC = __webpack_require__(1875);
	var Decorator = __webpack_require__(1874);
	var options = {};
	var emptyArray = [];
	
	Formsy.Mixin = Mixin;
	Formsy.HOC = HOC;
	Formsy.Decorator = Decorator;
	
	Formsy.defaults = function (passedOptions) {
	  options = passedOptions;
	};
	
	Formsy.addValidationRule = function (name, func) {
	  validationRules[name] = func;
	};
	
	Formsy.Form = createReactClass({
	  displayName: 'Formsy',
	  getInitialState: function getInitialState() {
	    return {
	      isValid: true,
	      isSubmitting: false,
	      canChange: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSuccess: function onSuccess() {},
	      onError: function onError() {},
	      onSubmit: function onSubmit() {},
	      onValidSubmit: function onValidSubmit() {},
	      onInvalidSubmit: function onInvalidSubmit() {},
	      onValid: function onValid() {},
	      onInvalid: function onInvalid() {},
	      onChange: function onChange() {},
	      validationErrors: null,
	      preventExternalInvalidation: false
	    };
	  },
	
	  childContextTypes: {
	    formsy: PropTypes.object
	  },
	  getChildContext: function getChildContext() {
	    var _this = this;
	
	    return {
	      formsy: {
	        attachToForm: this.attachToForm,
	        detachFromForm: this.detachFromForm,
	        validate: this.validate,
	        isFormDisabled: this.isFormDisabled,
	        isValidValue: function isValidValue(component, value) {
	          return _this.runValidation(component, value).isValid;
	        }
	      }
	    };
	  },
	
	  // Add a map to store the inputs of the form, a model to store
	  // the values of the form and register child inputs
	  componentWillMount: function componentWillMount() {
	    this.inputs = [];
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.validateForm();
	  },
	
	  componentWillUpdate: function componentWillUpdate() {
	    // Keep a reference to input names before form updates,
	    // to check if inputs has changed after render
	    this.prevInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	
	    if (this.props.validationErrors && _typeof(this.props.validationErrors) === 'object' && Object.keys(this.props.validationErrors).length > 0) {
	      this.setInputValidationErrors(this.props.validationErrors);
	    }
	
	    var newInputNames = this.inputs.map(function (component) {
	      return component.props.name;
	    });
	    if (utils.arraysDiffer(this.prevInputNames, newInputNames)) {
	      this.validateForm();
	    }
	  },
	
	  // Allow resetting to specified data
	  reset: function reset(data) {
	    this.setFormPristine(true);
	    this.resetModel(data);
	  },
	
	  // Update model, submit to url prop and send the model
	  submit: function submit(event) {
	
	    event && event.preventDefault();
	
	    // Trigger form as not pristine.
	    // If any inputs have not been touched yet this will make them dirty
	    // so validation becomes visible (if based on isPristine)
	    this.setFormPristine(false);
	    var model = this.getModel();
	    this.props.onSubmit(model, this.resetModel, this.updateInputsWithError);
	    this.state.isValid ? this.props.onValidSubmit(model, this.resetModel, this.updateInputsWithError) : this.props.onInvalidSubmit(model, this.resetModel, this.updateInputsWithError);
	  },
	
	  mapModel: function mapModel(model) {
	
	    if (this.props.mapping) {
	      return this.props.mapping(model);
	    } else {
	      return formDataToObject.toObj(Object.keys(model).reduce(function (mappedModel, key) {
	
	        var keyArray = key.split('.');
	        var base = mappedModel;
	        while (keyArray.length) {
	          var currentKey = keyArray.shift();
	          base = base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key];
	        }
	
	        return mappedModel;
	      }, {}));
	    }
	  },
	
	  getModel: function getModel() {
	    var currentValues = this.getCurrentValues();
	    return this.mapModel(currentValues);
	  },
	
	  // Reset each key in the model to the original / initial / specified value
	  resetModel: function resetModel(data) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      if (data && data.hasOwnProperty(name)) {
	        component.setValue(data[name]);
	      } else {
	        component.resetValue();
	      }
	    });
	    this.validateForm();
	  },
	
	  setInputValidationErrors: function setInputValidationErrors(errors) {
	    this.inputs.forEach(function (component) {
	      var name = component.props.name;
	      var args = [{
	        _isValid: !(name in errors),
	        _validationError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },
	
	  // Checks if the values have changed from their initial value
	  isChanged: function isChanged() {
	    return !utils.isSame(this.getPristineValues(), this.getCurrentValues());
	  },
	
	  getPristineValues: function getPristineValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.props.value;
	      return data;
	    }, {});
	  },
	
	  // Go through errors from server and grab the components
	  // stored in the inputs map. Change their state to invalid
	  // and set the serverError message
	  updateInputsWithError: function updateInputsWithError(errors) {
	    var _this2 = this;
	
	    Object.keys(errors).forEach(function (name, index) {
	      var component = utils.find(_this2.inputs, function (component) {
	        return component.props.name === name;
	      });
	      if (!component) {
	        throw new Error('You are trying to update an input that does not exist. ' + 'Verify errors object with input names. ' + JSON.stringify(errors));
	      }
	      var args = [{
	        _isValid: _this2.props.preventExternalInvalidation || false,
	        _externalError: typeof errors[name] === 'string' ? [errors[name]] : errors[name]
	      }];
	      component.setState.apply(component, args);
	    });
	  },
	
	  isFormDisabled: function isFormDisabled() {
	    return this.props.disabled;
	  },
	
	  getCurrentValues: function getCurrentValues() {
	    return this.inputs.reduce(function (data, component) {
	      var name = component.props.name;
	      data[name] = component.state._value;
	      return data;
	    }, {});
	  },
	
	  setFormPristine: function setFormPristine(isPristine) {
	    this.setState({
	      _formSubmitted: !isPristine
	    });
	
	    // Iterate through each component and set it as pristine
	    // or "dirty".
	    this.inputs.forEach(function (component, index) {
	      component.setState({
	        _formSubmitted: !isPristine,
	        _isPristine: isPristine
	      });
	    });
	  },
	
	  // Use the binded values and the actual input value to
	  // validate the input and set its state. Then check the
	  // state of the form itself
	  validate: function validate(component) {
	
	    // Trigger onChange
	    if (this.state.canChange) {
	      this.props.onChange(this.getCurrentValues(), this.isChanged());
	    }
	
	    var validation = this.runValidation(component);
	    // Run through the validations, split them up and call
	    // the validator IF there is a value or it is required
	    component.setState({
	      _isValid: validation.isValid,
	      _isRequired: validation.isRequired,
	      _validationError: validation.error,
	      _externalError: null
	    }, this.validateForm);
	  },
	
	  // Checks validation on current value or a passed value
	  runValidation: function runValidation(component, value) {
	
	    var currentValues = this.getCurrentValues();
	    var validationErrors = component.props.validationErrors;
	    var validationError = component.props.validationError;
	    value = arguments.length === 2 ? value : component.state._value;
	
	    var validationResults = this.runRules(value, currentValues, component._validations);
	    var requiredResults = this.runRules(value, currentValues, component._requiredValidations);
	
	    // the component defines an explicit validate function
	    if (typeof component.validate === "function") {
	      validationResults.failed = component.validate() ? [] : ['failed'];
	    }
	
	    var isRequired = Object.keys(component._requiredValidations).length ? !!requiredResults.success.length : false;
	    var isValid = !validationResults.failed.length && !(this.props.validationErrors && this.props.validationErrors[component.props.name]);
	
	    return {
	      isRequired: isRequired,
	      isValid: isRequired ? false : isValid,
	      error: function () {
	
	        if (isValid && !isRequired) {
	          return emptyArray;
	        }
	
	        if (validationResults.errors.length) {
	          return validationResults.errors;
	        }
	
	        if (this.props.validationErrors && this.props.validationErrors[component.props.name]) {
	          return typeof this.props.validationErrors[component.props.name] === 'string' ? [this.props.validationErrors[component.props.name]] : this.props.validationErrors[component.props.name];
	        }
	
	        if (isRequired) {
	          var error = validationErrors[requiredResults.success[0]];
	          return error ? [error] : null;
	        }
	
	        if (validationResults.failed.length) {
	          return validationResults.failed.map(function (failed) {
	            return validationErrors[failed] ? validationErrors[failed] : validationError;
	          }).filter(function (x, pos, arr) {
	            // Remove duplicates
	            return arr.indexOf(x) === pos;
	          });
	        }
	      }.call(this)
	    };
	  },
	
	  runRules: function runRules(value, currentValues, validations) {
	
	    var results = {
	      errors: [],
	      failed: [],
	      success: []
	    };
	    if (Object.keys(validations).length) {
	      Object.keys(validations).forEach(function (validationMethod) {
	
	        if (validationRules[validationMethod] && typeof validations[validationMethod] === 'function') {
	          throw new Error('Formsy does not allow you to override default validations: ' + validationMethod);
	        }
	
	        if (!validationRules[validationMethod] && typeof validations[validationMethod] !== 'function') {
	          throw new Error('Formsy does not have the validation rule: ' + validationMethod);
	        }
	
	        if (typeof validations[validationMethod] === 'function') {
	          var validation = validations[validationMethod](currentValues, value);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          }
	          return;
	        } else if (typeof validations[validationMethod] !== 'function') {
	          var validation = validationRules[validationMethod](currentValues, value, validations[validationMethod]);
	          if (typeof validation === 'string') {
	            results.errors.push(validation);
	            results.failed.push(validationMethod);
	          } else if (!validation) {
	            results.failed.push(validationMethod);
	          } else {
	            results.success.push(validationMethod);
	          }
	          return;
	        }
	
	        return results.success.push(validationMethod);
	      });
	    }
	
	    return results;
	  },
	
	  // Validate the form by going through all child input components
	  // and check their state
	  validateForm: function validateForm() {
	    var _this3 = this;
	
	    // We need a callback as we are validating all inputs again. This will
	    // run when the last component has set its state
	    var onValidationComplete = function () {
	      var allIsValid = this.inputs.every(function (component) {
	        return component.state._isValid;
	      });
	
	      this.setState({
	        isValid: allIsValid
	      });
	
	      if (allIsValid) {
	        this.props.onValid();
	      } else {
	        this.props.onInvalid();
	      }
	
	      // Tell the form that it can start to trigger change events
	      this.setState({
	        canChange: true
	      });
	    }.bind(this);
	
	    // Run validation again in case affected by other inputs. The
	    // last component validated will run the onValidationComplete callback
	    this.inputs.forEach(function (component, index) {
	      var validation = _this3.runValidation(component);
	      if (validation.isValid && component.state._externalError) {
	        validation.isValid = false;
	      }
	      component.setState({
	        _isValid: validation.isValid,
	        _isRequired: validation.isRequired,
	        _validationError: validation.error,
	        _externalError: !validation.isValid && component.state._externalError ? component.state._externalError : null
	      }, index === _this3.inputs.length - 1 ? onValidationComplete : null);
	    });
	
	    // If there are no inputs, set state where form is ready to trigger
	    // change event. New inputs might be added later
	    if (!this.inputs.length) {
	      this.setState({
	        canChange: true
	      });
	    }
	  },
	
	  // Method put on each input component to register
	  // itself to the form
	  attachToForm: function attachToForm(component) {
	
	    if (this.inputs.indexOf(component) === -1) {
	      this.inputs.push(component);
	    }
	
	    this.validate(component);
	  },
	
	  // Method put on each input component to unregister
	  // itself from the form
	  detachFromForm: function detachFromForm(component) {
	    var componentPos = this.inputs.indexOf(component);
	
	    if (componentPos !== -1) {
	      this.inputs = this.inputs.slice(0, componentPos).concat(this.inputs.slice(componentPos + 1));
	    }
	
	    this.validateForm();
	  },
	  render: function render() {
	    var _props = this.props,
	        mapping = _props.mapping,
	        validationErrors = _props.validationErrors,
	        onSubmit = _props.onSubmit,
	        onValid = _props.onValid,
	        onValidSubmit = _props.onValidSubmit,
	        onInvalid = _props.onInvalid,
	        onInvalidSubmit = _props.onInvalidSubmit,
	        onChange = _props.onChange,
	        reset = _props.reset,
	        preventExternalInvalidation = _props.preventExternalInvalidation,
	        onSuccess = _props.onSuccess,
	        onError = _props.onError,
	        nonFormsyProps = _objectWithoutProperties(_props, ['mapping', 'validationErrors', 'onSubmit', 'onValid', 'onValidSubmit', 'onInvalid', 'onInvalidSubmit', 'onChange', 'reset', 'preventExternalInvalidation', 'onSuccess', 'onError']);
	
	    return React.createElement(
	      'form',
	      _extends({}, nonFormsyProps, { onSubmit: this.submit }),
	      this.props.children
	    );
	  }
	});
	
	if (!global.exports && !global.module && (!global.define || !global.define.amd)) {
	  global.Formsy = Formsy;
	}
	
	module.exports = Formsy;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(2064);
	moment.tz.load(__webpack_require__(1916));


/***/ },
/* 144 */
[2743, 145],
/* 145 */
[2768, 90, 903],
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var PooledClass = __webpack_require__(204);
	
	var emptyFunction = __webpack_require__(132);
	var warning = __webpack_require__(39);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A React component for the font-awesome icon library.
	 *
	 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
	 * @param {Boolean} [border=false] Whether or not to show a border radius
	 * @param {String} [className] An extra set of CSS classes to add to the component
	 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
	 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
	 * @param {String} [flip=false] Flip the icon's orientation.
	 * @param {Boolean} [inverse=false] Inverse the icon's color
	 * @param {String} [name] Name of the icon to use
	 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
	 * @param {Number} [rotate] The degress to rotate the icon by
	 * @param {String} [size] The icon scaling size
	 * @param {Boolean} [spin=false] Spin the icon
	 * @param {String} [stack] Stack an icon on top of another. Arguments specify z-index such as '1x' See documentation for example http://fontawesome.io/examples/#stacked
	 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
	 * @module FontAwesome
	 * @type {ReactClass}
	 */
	var FontAwesome = function (_React$Component) {
	  _inherits(FontAwesome, _React$Component);
	
	  function FontAwesome() {
	    _classCallCheck(this, FontAwesome);
	
	    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));
	
	    _this.displayName = 'FontAwesome';
	    return _this;
	  }
	
	  _createClass(FontAwesome, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          border = _props.border,
	          cssModule = _props.cssModule,
	          className = _props.className,
	          fixedWidth = _props.fixedWidth,
	          flip = _props.flip,
	          inverse = _props.inverse,
	          name = _props.name,
	          pulse = _props.pulse,
	          rotate = _props.rotate,
	          size = _props.size,
	          spin = _props.spin,
	          stack = _props.stack,
	          _props$tag = _props.tag,
	          tag = _props$tag === undefined ? 'span' : _props$tag,
	          ariaLabel = _props.ariaLabel,
	          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);
	
	      var ariaProps = ariaLabel ? { 'aria-label': ariaLabel } : { 'aria-hidden': true };
	      var classNames = [];
	
	      if (cssModule) {
	        classNames.push(cssModule['fa']);
	        classNames.push(cssModule['fa-' + name]);
	        size && classNames.push(cssModule['fa-' + size]);
	        spin && classNames.push(cssModule['fa-spin']);
	        pulse && classNames.push(cssModule['fa-pulse']);
	        border && classNames.push(cssModule['fa-border']);
	        fixedWidth && classNames.push(cssModule['fa-fw']);
	        inverse && classNames.push(cssModule['fa-inverse']);
	        flip && classNames.push(cssModule['fa-flip-' + flip]);
	        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
	        stack && classNames.push(cssModule['fa-stack-' + stack]);
	      } else {
	        classNames.push('fa');
	        classNames.push('fa-' + name);
	        size && classNames.push('fa-' + size);
	        spin && classNames.push('fa-spin');
	        pulse && classNames.push('fa-pulse');
	        border && classNames.push('fa-border');
	        fixedWidth && classNames.push('fa-fw');
	        inverse && classNames.push('fa-inverse');
	        flip && classNames.push('fa-flip-' + flip);
	        rotate && classNames.push('fa-rotate-' + rotate);
	        stack && classNames.push('fa-stack-' + stack);
	      }
	
	      // Add any custom class names at the end.
	      className && classNames.push(className);
	      return _react2.default.createElement(tag, _extends({}, props, ariaProps, {
	        className: classNames.join(' ')
	      }));
	    }
	  }]);
	
	  return FontAwesome;
	}(_react2.default.Component);
	
	FontAwesome.propTypes = {
	  ariaLabel: _propTypes2.default.string,
	  border: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  cssModule: _propTypes2.default.object,
	  fixedWidth: _propTypes2.default.bool,
	  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  inverse: _propTypes2.default.bool,
	  name: _propTypes2.default.string.isRequired,
	  pulse: _propTypes2.default.bool,
	  rotate: _propTypes2.default.oneOf([90, 180, 270]),
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  spin: _propTypes2.default.bool,
	  stack: _propTypes2.default.oneOf(['1x', '2x']),
	  tag: _propTypes2.default.string
	};
	
	exports.default = FontAwesome;
	module.exports = exports.default;

/***/ },
/* 148 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(733));
	
	var _find2 = _interopRequireDefault(__webpack_require__(2034));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(235));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _range2 = _interopRequireDefault(__webpack_require__(487));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(2056));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Surface = _interopRequireDefault(__webpack_require__(295));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(377));
	
	var _Legend = _interopRequireDefault(__webpack_require__(543));
	
	var _Curve = _interopRequireDefault(__webpack_require__(249));
	
	var _Cross = _interopRequireDefault(__webpack_require__(1018));
	
	var _Sector = _interopRequireDefault(__webpack_require__(381));
	
	var _Dot = _interopRequireDefault(__webpack_require__(208));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(250));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _CartesianAxis = _interopRequireDefault(__webpack_require__(1010));
	
	var _Brush = _interopRequireDefault(__webpack_require__(1009));
	
	var _DOMUtils = __webpack_require__(382);
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	var _DetectReferenceElementsDomain = __webpack_require__(2448);
	
	var _PolarUtils = __webpack_require__(126);
	
	var _ShallowEqual = __webpack_require__(384);
	
	var _Events = __webpack_require__(2449);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	var originCoordinate = {
	  x: 0,
	  y: 0
	};
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	
	  var CategoricalChartWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	    function CategoricalChartWrapper(_props) {
	      var _this;
	
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex,
	              updateId = _this$state.updateId;
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex,
	            updateId: updateId
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	        var updateId = _this.state.updateId;
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	          if (!(0, _isNil2["default"])(data.dataStartIndex) || !(0, _isNil2["default"])(data.dataEndIndex)) {
	            _this.setState(_objectSpread({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex,
	              updateId: updateId
	            })));
	          } else if (!(0, _isNil2["default"])(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	
	            var viewBox = _objectSpread({}, offset, {
	              x: offset.left,
	              y: offset.top
	            }); // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	
	
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_objectSpread({}, data, {
	              activeLabel: activeLabel,
	              activeCoordinate: activeCoordinate,
	              activePayload: activePayload
	            }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref2) {
	        var startIndex = _ref2.startIndex,
	            endIndex = _ref2.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          var updateId = _this.state.updateId;
	
	          _this.setState(function () {
	            return _objectSpread({
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex,
	              updateId: updateId
	            }));
	          });
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _objectSpread({}, mouse, {
	            isTooltipActive: true
	          });
	
	          _this.setState(nextState);
	
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction2["default"])(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	
	        var nextState = mouse ? _objectSpread({}, mouse, {
	          isTooltipActive: true
	        }) : {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleItemMouseEnter = function (el) {
	        _this.setState(function () {
	          return {
	            isTooltipActive: true,
	            activeItem: el,
	            activePayload: el.tooltipPayload,
	            activeCoordinate: el.tooltipPosition || {
	              x: el.cx,
	              y: el.cy
	            }
	          };
	        });
	      };
	
	      _this.handleItemMouseLeave = function () {
	        _this.setState(function () {
	          return {
	            isTooltipActive: false
	          };
	        });
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction2["default"])(e.persist)) {
	          e.persist();
	        }
	
	        _this.triggeredAfterMouseMove(e);
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	        var nextState = {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleOuterEvent = function (e) {
	        var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	        if (eventName && (0, _isFunction2["default"])(_this.props[eventName])) {
	          var mouse = _this.getMouseInfo(e);
	
	          var handler = _this.props[eventName];
	          handler(mouse, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	        if ((0, _isFunction2["default"])(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	        if ((0, _isFunction2["default"])(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	        if ((0, _isFunction2["default"])(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchStart = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseDown(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchEnd = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseUp(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref3) {
	        var xAxis = _ref3.xAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, xAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref4) {
	        var yAxis = _ref4.yAxis,
	            width = _ref4.width,
	            height = _ref4.height,
	            offset = _ref4.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, yAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (axisMap) {
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy2["default"])(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis,
	          tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	        };
	      };
	
	      _this.renderCursor = function (element) {
	        var _this$state3 = _this.state,
	            isTooltipActive = _this$state3.isTooltipActive,
	            activeCoordinate = _this$state3.activeCoordinate,
	            activePayload = _this$state3.activePayload,
	            offset = _this$state3.offset;
	
	        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	          return null;
	        }
	
	        var layout = _this.props.layout;
	        var restProps;
	        var cursorComp = _Curve["default"];
	
	        if (chartName === 'ScatterChart') {
	          restProps = activeCoordinate;
	          cursorComp = _Cross["default"];
	        } else if (chartName === 'BarChart') {
	          restProps = _this.getCursorRectangle();
	          cursorComp = _Rectangle["default"];
	        } else if (layout === 'radial') {
	          var _this$getCursorPoints = _this.getCursorPoints(),
	              cx = _this$getCursorPoints.cx,
	              cy = _this$getCursorPoints.cy,
	              radius = _this$getCursorPoints.radius,
	              startAngle = _this$getCursorPoints.startAngle,
	              endAngle = _this$getCursorPoints.endAngle;
	
	          restProps = {
	            cx: cx,
	            cy: cy,
	            startAngle: startAngle,
	            endAngle: endAngle,
	            innerRadius: radius,
	            outerRadius: radius
	          };
	          cursorComp = _Sector["default"];
	        } else {
	          restProps = {
	            points: _this.getCursorPoints()
	          };
	          cursorComp = _Curve["default"];
	        }
	
	        var key = element.key || '_recharts-cursor';
	
	        var cursorProps = _objectSpread({
	          stroke: '#ccc',
	          pointerEvents: 'none'
	        }, offset, {}, restProps, {}, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	          payload: activePayload,
	          key: key,
	          className: 'recharts-tooltip-cursor'
	        });
	
	        return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	      };
	
	      _this.renderPolarAxis = function (element, displayName, index) {
	        var axisType = element.type.axisType;
	
	        var axisMap = _this.state["".concat(axisType, "Map")];
	
	        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
	        return (0, _react.cloneElement)(element, _objectSpread({}, axisOption, {
	          className: axisType,
	          key: element.key || "".concat(displayName, "-").concat(index),
	          ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	        }));
	      };
	
	      _this.renderXAxis = function (element, displayName, index) {
	        var xAxisMap = _this.state.xAxisMap;
	        var axisObj = xAxisMap[element.props.xAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderYAxis = function (element, displayName, index) {
	        var yAxisMap = _this.state.yAxisMap;
	        var axisObj = yAxisMap[element.props.yAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderGrid = function (element) {
	        var _this$state4 = _this.state,
	            xAxisMap = _this$state4.xAxisMap,
	            yAxisMap = _this$state4.yAxisMap,
	            offset = _this$state4.offset;
	        var _this$props2 = _this.props,
	            width = _this$props2.width,
	            height = _this$props2.height;
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxisWithFiniteDomain = (0, _find2["default"])(yAxisMap, function (axis) {
	          return (0, _every2["default"])(axis.domain, Number.isFinite);
	        });
	        var yAxis = yAxisWithFiniteDomain || (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	        var props = element.props || {};
	        return (0, _react.cloneElement)(element, {
	          key: element.key || 'grid',
	          x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	          width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	          height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
	        });
	      };
	
	      _this.renderPolarGrid = function (element) {
	        var _this$state5 = _this.state,
	            radiusAxisMap = _this$state5.radiusAxisMap,
	            angleAxisMap = _this$state5.angleAxisMap;
	        var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	        var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	        var cx = angleAxis.cx,
	            cy = angleAxis.cy,
	            innerRadius = angleAxis.innerRadius,
	            outerRadius = angleAxis.outerRadius;
	        return (0, _react.cloneElement)(element, {
	          polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          key: element.key || 'polar-grid'
	        });
	      };
	
	      _this.renderBrush = function (element) {
	        var _this$props3 = _this.props,
	            margin = _this$props3.margin,
	            data = _this$props3.data;
	        var _this$state6 = _this.state,
	            offset = _this$state6.offset,
	            dataStartIndex = _this$state6.dataStartIndex,
	            dataEndIndex = _this$state6.dataEndIndex,
	            updateId = _this$state6.updateId; // TODO: update brush when children update
	
	        return (0, _react.cloneElement)(element, {
	          key: element.key || '_recharts-brush',
	          onChange: (0, _ChartUtils.combineEventHandlers)(_this.handleBrushChange, null, element.props.onChange),
	          data: data,
	          x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: "brush-".concat(updateId)
	        });
	      };
	
	      _this.renderReferenceElement = function (element, displayName, index) {
	        if (!element) {
	          return null;
	        }
	
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            clipPathId = _assertThisInitialize.clipPathId;
	
	        var _this$state7 = _this.state,
	            xAxisMap = _this$state7.xAxisMap,
	            yAxisMap = _this$state7.yAxisMap,
	            offset = _this$state7.offset;
	        var _element$props = element.props,
	            xAxisId = _element$props.xAxisId,
	            yAxisId = _element$props.yAxisId;
	        return (0, _react.cloneElement)(element, {
	          key: element.key || "".concat(displayName, "-").concat(index),
	          xAxis: xAxisMap[xAxisId],
	          yAxis: yAxisMap[yAxisId],
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          },
	          clipPathId: clipPathId
	        });
	      };
	
	      _this.renderGraphicChild = function (element, displayName, index) {
	        var item = _this.filterFormatItem(element, displayName, index);
	
	        if (!item) {
	          return null;
	        }
	
	        var graphicalItem = (0, _react.cloneElement)(element, item.props);
	        var _this$state8 = _this.state,
	            isTooltipActive = _this$state8.isTooltipActive,
	            tooltipAxis = _this$state8.tooltipAxis,
	            activeTooltipIndex = _this$state8.activeTooltipIndex,
	            activeLabel = _this$state8.activeLabel;
	        var children = _this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var _item$props = item.props,
	            points = _item$props.points,
	            isRange = _item$props.isRange,
	            baseLine = _item$props.baseLine;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            hide = _item$item$props.hide;
	        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	        function findWithPayload(entry) {
	          return tooltipAxis.dataKey(entry.payload);
	        }
	
	        if (hasActive) {
	          var activePoint, basePoint;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey);
	            activePoint = (0, _DataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
	            basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
	          } else {
	            activePoint = points[activeTooltipIndex];
	            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	          }
	
	          if (!(0, _isNil2["default"])(activePoint)) {
	            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
	              item: item,
	              activePoint: activePoint,
	              basePoint: basePoint,
	              childIndex: activeTooltipIndex,
	              isRange: isRange
	            })));
	          }
	        }
	
	        if (isRange) {
	          return [graphicalItem, null, null];
	        }
	
	        return [graphicalItem, null];
	      };
	
	      _this.renderCustomized = function (element) {
	        return (0, _react.cloneElement)(element, _objectSpread({}, _this.props, {}, _this.state));
	      };
	
	      var defaultState = _this.constructor.createDefaultState(_props);
	
	      var _updateId = 0;
	      _this.state = _objectSpread({}, defaultState, {
	        updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	        props: _props
	      }, defaultState, {
	        updateId: _updateId
	      })));
	      _this.uniqueChartId = (0, _isNil2["default"])(_props.id) ? (0, _DataUtils.uniqueId)('recharts') : _props.id;
	      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
	
	      if (_props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle2["default"])(_this.triggeredAfterMouseMove, _props.throttleDelay);
	      }
	
	      return _this;
	    }
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.addListener();
	        }
	      } // eslint-disable-next-line camelcase
	
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var _this$props4 = this.props,
	            data = _this$props4.data,
	            children = _this$props4.children,
	            width = _this$props4.width,
	            height = _this$props4.height,
	            layout = _this$props4.layout,
	            stackOffset = _this$props4.stackOffset,
	            margin = _this$props4.margin;
	        var updateId = this.state.updateId;
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(function (oldState) {
	            return _objectSpread({}, defaultState, {
	              updateId: updateId + 1,
	              chartX: oldState.chartX,
	              chartY: oldState.chartY
	            }, _this2.getTooltipData(), {
	              isTooltipActive: oldState.isTooltipActive
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, defaultState, {
	              updateId: updateId + 1
	            })));
	          });
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil2["default"])(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          this.setState(function (prevState) {
	            return _objectSpread({
	              updateId: newUpdateId
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, prevState, {
	              updateId: newUpdateId
	            })));
	          });
	        } // add syncId
	
	
	        if ((0, _isNil2["default"])(this.props.syncId) && !(0, _isNil2["default"])(nextProps.syncId)) {
	          this.addListener();
	        } // remove syncId
	
	
	        if (!(0, _isNil2["default"])(this.props.syncId) && (0, _isNil2["default"])(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.removeListener();
	        }
	
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: "getAxisMap",
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
	            AxisComp = _ref5.AxisComp,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
	
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, {
	            axes: axes,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: "getAxisMapByAxes",
	      value: function getAxisMapByAxes(props, _ref6) {
	        var _this3 = this;
	
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType); // Eliminate duplicated axes
	
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	          var axisId = child.props[axisIdKey];
	
	          var displayedData = _this3.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain, duplicateDomain, categoricalDomain;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
	
	                  domain = (0, _range2["default"])(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil2["default"])(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil2["default"])(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: "getAxisMapByItems",
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1; // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain;
	
	            if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	    }, {
	      key: "getActiveCoordinate",
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return {
	              x: entry.coordinate,
	              y: rangeObj.y
	            };
	          }
	
	          if (layout === 'vertical') {
	            return {
	              x: rangeObj.x,
	              y: entry.coordinate
	            };
	          }
	
	          if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	            return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle,
	              radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	          return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle,
	            radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: "getMouseInfo",
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _this$state9 = this.state,
	            xAxisMap = _this$state9.xAxisMap,
	            yAxisMap = _this$state9.yAxisMap;
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	          return _objectSpread({}, e, {
	            xValue: xValue,
	            yValue: yValue
	          });
	        }
	
	        var toolTipData = this.getTooltipData(rangeObj);
	
	        if (toolTipData) {
	          return _objectSpread({}, e, {}, toolTipData);
	        }
	
	        return null;
	      }
	      /**
	       * Returns tooltip data based on a mouse position (as a parameter or in state)
	       * @param  {Object} rangeObj  { x, y } coordinates
	       * @return {Object}           Tooltip data data
	       */
	
	    }, {
	      key: "getTooltipData",
	      value: function getTooltipData(rangeObj) {
	        var rangeData = rangeObj || {
	          x: this.state.chartX,
	          y: this.state.chartY
	        };
	        var pos = this.calculateTooltipPos(rangeData);
	        var _this$state10 = this.state,
	            ticks = _this$state10.orderedTooltipTicks,
	            axis = _this$state10.tooltipAxis,
	            tooltipTicks = _this$state10.tooltipTicks;
	
	        if (!ticks) {
	          return null;
	        }
	
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeData);
	          return {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          };
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: "getTooltipContent",
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _this$state11 = this.state,
	            graphicalItems = _this$state11.graphicalItems,
	            tooltipAxis = _this$state11.tooltipAxis;
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        } // get data by activeIndex when the axis don't allow duplicated category
	
	
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data,
	              tooltipType = _child$props2.tooltipType;
	          var payload;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = data && data[activeIndex] || displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	
	          return [].concat(_toConsumableArray(result), [_objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey,
	            unit: unit,
	            formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            type: tooltipType,
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: "getFormatItems",
	      value: function getFormatItems(props, currentState) {
	        var _this4 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get.numericAxisName,
	            cateAxisName = _this$constructor$get.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({
	          barSize: barSize,
	          stackGroups: stackGroups
	        });
	        var formatedItems = [];
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this4.constructor.getDisplayedData(props, {
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, item);
	
	          var _item$props2 = item.props,
	              dataKey = _item$props2.dataKey,
	              childMaxBarSize = _item$props2.maxBarSize;
	          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
	          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _objectSpread4;
	
	            var axisMap = currentState["".concat(entry.axisType, "Map")];
	            var id = item.props["".concat(entry.axisType, "Id")];
	            var axis = axisMap && axisMap[id];
	            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), (0, _ChartUtils.getTicksOfAxis)(axis)), _objectSpread4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil2["default"])(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap,
	            barCategoryGap: barCategoryGap,
	            bandSize: bandSize,
	            sizeList: sizeList[cateAxisId],
	            maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _objectSpread5;
	
	            formatedItems.push({
	              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
	                displayedData: displayedData,
	                props: props,
	                dataKey: dataKey,
	                item: item,
	                bandSize: bandSize,
	                barPosition: barPosition,
	                offset: offset,
	                stackedData: stackedData,
	                layout: layout,
	                dataStartIndex: dataStartIndex,
	                dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_objectSpread5 = {
	                key: item.key || "item-".concat(index)
	              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	        return formatedItems;
	      }
	    }, {
	      key: "getCursorRectangle",
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _this$state12 = this.state,
	            activeCoordinate = _this$state12.activeCoordinate,
	            offset = _this$state12.offset,
	            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
	        var halfSize = tooltipAxisBandSize / 2;
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: "getCursorPoints",
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _this$state13 = this.state,
	            activeCoordinate = _this$state13.activeCoordinate,
	            offset = _this$state13.offset;
	        var x1, y1, x2, y2;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil2["default"])(activeCoordinate.cx) || !(0, _isNil2["default"])(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx,
	              cy: _cy,
	              radius: radius,
	              startAngle: startAngle,
	              endAngle: endAngle
	            };
	          }
	        }
	
	        return [{
	          x: x1,
	          y: y1
	        }, {
	          x: x2,
	          y: y2
	        }];
	      }
	    }, {
	      key: "calculateTooltipPos",
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: "inRange",
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	          return isInRange ? {
	            x: x,
	            y: y
	          } : null;
	        }
	
	        var _this$state14 = this.state,
	            angleAxisMap = _this$state14.angleAxisMap,
	            radiusAxisMap = _this$state14.radiusAxisMap;
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	          return (0, _PolarUtils.inRangeOfSector)({
	            x: x,
	            y: y
	          }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: "parseEventsOfWrapper",
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	        return _objectSpread({}, outerEvents, {}, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: "updateStateOfAxisMapsOffsetAndStackGroups",
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var _this5 = this;
	
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex,
	            updateId = _ref8.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({
	          props: props
	        })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get2.numericAxisName,
	            cateAxisName = _this$constructor$get2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = "".concat(entry.axisType, "Map");
	          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
	          props: props,
	          graphicalItems: graphicalItems
	        }));
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex,
	          updateId: updateId,
	          graphicalItems: graphicalItems,
	          stackGroups: stackGroups,
	          offset: offset
	        }));
	        return _objectSpread({
	          formatedGraphicalItems: formatedGraphicalItems,
	          graphicalItems: graphicalItems,
	          offset: offset,
	          stackGroups: stackGroups
	        }, ticksObj, {}, axisObj);
	      }
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: "addListener",
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: "removeListener",
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: "calculateOffset",
	      value: function calculateOffset(_ref9) {
	        var props = _ref9.props,
	            graphicalItems = _ref9.graphicalItems,
	            _ref9$xAxisMap = _ref9.xAxisMap,
	            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
	            _ref9$yAxisMap = _ref9.yAxisMap,
	            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, {
	          left: margin.left || 0,
	          right: margin.right || 0
	        });
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, {
	          top: margin.top || 0,
	          bottom: margin.bottom || 0
	        });
	
	        var offset = _objectSpread({}, offsetV, {}, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush["default"].defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _objectSpread({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	    }, {
	      key: "triggerSyncEvent",
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	        if (!(0, _isNil2["default"])(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: "filterFormatItem",
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: "renderAxis",
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height;
	        return _react["default"].createElement(_CartesianAxis["default"], _extends({}, axisOptions, {
	          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
	          key: element.key || "".concat(displayName, "-").concat(index),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: "renderLegend",
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this6 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _this$props6 = this.props,
	            children = _this$props6.children,
	            width = _this$props6.width,
	            height = _this$props6.height;
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children,
	          formatedGraphicalItems: formatedGraphicalItems,
	          legendWidth: legendWidth,
	          legendHeight: legendHeight,
	          legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ["item"]);
	
	        return (0, _react.cloneElement)(item, _objectSpread({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this6.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: "renderTooltip",
	      value: function renderTooltip() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _this$state15 = this.state,
	            isTooltipActive = _this$state15.isTooltipActive,
	            activeCoordinate = _this$state15.activeCoordinate,
	            activePayload = _this$state15.activePayload,
	            activeLabel = _this$state15.activeLabel,
	            offset = _this$state15.offset;
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _objectSpread({}, offset, {
	            x: offset.left,
	            y: offset.top
	          }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: "renderActivePoints",
	      value: function renderActivePoints(_ref10) {
	        var item = _ref10.item,
	            activePoint = _ref10.activePoint,
	            basePoint = _ref10.basePoint,
	            childIndex = _ref10.childIndex,
	            isRange = _ref10.isRange;
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props2 = item.item.props,
	            activeDot = _item$item$props2.activeDot,
	            dataKey = _item$item$props2.dataKey;
	
	        var dotProps = _objectSpread({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: "".concat(key, "-activePoint-").concat(childIndex)
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), {}, (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: "".concat(key, "-basePoint-").concat(childIndex)
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: "renderClipPath",
	      value: function renderClipPath() {
	        var clipPathId = this.clipPathId;
	        var _this$state$offset = this.state.offset,
	            left = _this$state$offset.left,
	            top = _this$state$offset.top,
	            height = _this$state$offset.height,
	            width = _this$state$offset.width;
	        return _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: clipPathId
	        }, _react["default"].createElement("rect", {
	          x: left,
	          y: top,
	          height: height,
	          width: width
	        })));
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this7 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _this$props7 = this.props,
	            children = _this$props7.children,
	            className = _this$props7.className,
	            width = _this$props7.width,
	            height = _this$props7.height,
	            style = _this$props7.style,
	            compact = _this$props7.compact,
	            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: {
	            handler: this.renderGrid,
	            once: true
	          },
	          ReferenceArea: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceLine: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceDot: {
	            handler: this.renderReferenceElement
	          },
	          XAxis: {
	            handler: this.renderXAxis
	          },
	          YAxis: {
	            handler: this.renderYAxis
	          },
	          Brush: {
	            handler: this.renderBrush,
	            once: true
	          },
	          Bar: {
	            handler: this.renderGraphicChild
	          },
	          Line: {
	            handler: this.renderGraphicChild
	          },
	          Area: {
	            handler: this.renderGraphicChild
	          },
	          Radar: {
	            handler: this.renderGraphicChild
	          },
	          RadialBar: {
	            handler: this.renderGraphicChild
	          },
	          Scatter: {
	            handler: this.renderGraphicChild
	          },
	          Pie: {
	            handler: this.renderGraphicChild
	          },
	          Funnel: {
	            handler: this.renderGraphicChild
	          },
	          Tooltip: {
	            handler: this.renderCursor,
	            once: true
	          },
	          PolarGrid: {
	            handler: this.renderPolarGrid,
	            once: true
	          },
	          PolarAngleAxis: {
	            handler: this.renderPolarAxis
	          },
	          PolarRadiusAxis: {
	            handler: this.renderPolarAxis
	          },
	          Customized: {
	            handler: this.renderCustomized
	          }
	        }; // The "compact" mode is mainly used as the panorama within Brush
	
	        if (compact) {
	          return _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	            width: width,
	            height: height
	          }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map));
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react["default"].createElement("div", _extends({
	          className: (0, _classnames["default"])('recharts-wrapper', className),
	          style: _objectSpread({
	            position: 'relative',
	            cursor: 'default',
	            width: width,
	            height: height
	          }, style)
	        }, events, {
	          ref: function ref(node) {
	            _this7.container = node;
	          }
	        }), _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	          width: width,
	          height: height
	        }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map)), this.renderLegend(), this.renderTooltip());
	      }
	    }], [{
	      key: "getAxisNameByLayout",
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return {
	            numericAxisName: 'yAxis',
	            cateAxisName: 'xAxis'
	          };
	        }
	
	        if (layout === 'vertical') {
	          return {
	            numericAxisName: 'xAxis',
	            cateAxisName: 'yAxis'
	          };
	        }
	
	        if (layout === 'centric') {
	          return {
	            numericAxisName: 'radiusAxis',
	            cateAxisName: 'angleAxis'
	          };
	        }
	
	        return {
	          numericAxisName: 'angleAxis',
	          cateAxisName: 'radiusAxis'
	        };
	      }
	    }, {
	      key: "renderActiveDot",
	      value: function renderActiveDot(option, props) {
	        var dot;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction2["default"])(option)) {
	          dot = option(props);
	        } else {
	          dot = _react["default"].createElement(_Dot["default"], props);
	        }
	
	        return _react["default"].createElement(_Layer["default"], {
	          className: "recharts-active-dot",
	          key: props.key
	        }, dot);
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component);
	
	  CategoricalChartWrapper.displayName = chartName;
	  CategoricalChartWrapper.propTypes = _objectSpread({
	    syncId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	    compact: _propTypes["default"].bool,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes["default"].oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes["default"].number,
	    margin: _propTypes["default"].shape({
	      top: _propTypes["default"].number,
	      right: _propTypes["default"].number,
	      bottom: _propTypes["default"].number,
	      left: _propTypes["default"].number
	    }),
	    barCategoryGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    maxBarSize: _propTypes["default"].number,
	    style: _propTypes["default"].object,
	    className: _propTypes["default"].string,
	    children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	    defaultShowTooltip: _propTypes["default"].bool,
	    onClick: _propTypes["default"].func,
	    onMouseLeave: _propTypes["default"].func,
	    onMouseEnter: _propTypes["default"].func,
	    onMouseMove: _propTypes["default"].func,
	    onMouseDown: _propTypes["default"].func,
	    onMouseUp: _propTypes["default"].func,
	    reverseStackOrder: _propTypes["default"].bool,
	    id: _propTypes["default"].string
	  }, propTypes);
	  CategoricalChartWrapper.defaultProps = _objectSpread({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: {
	      top: 5,
	      right: 5,
	      bottom: 5,
	      left: 5
	    },
	    reverseStackOrder: false
	  }, defaultProps);
	
	  CategoricalChartWrapper.createDefaultState = function (props) {
	    var children = props.children,
	        defaultShowTooltip = props.defaultShowTooltip;
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: !(0, _isNil2["default"])(defaultShowTooltip) ? defaultShowTooltip : false
	    };
	  };
	
	  CategoricalChartWrapper.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	      return name && name.indexOf('Bar') >= 0;
	    });
	  };
	
	  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
	    var graphicalItems = _ref11.graphicalItems,
	        dataStartIndex = _ref11.dataStartIndex,
	        dataEndIndex = _ref11.dataEndIndex;
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  };
	
	  return CategoricalChartWrapper;
	};
	
	var _default = generateCategoricalChart;
	exports["default"] = _default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _last2 = _interopRequireDefault(__webpack_require__(735));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  id: _propTypes["default"].string,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  valueAccessor: _propTypes["default"].func,
	  clockWise: _propTypes["default"].bool,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func])
	};
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray2["default"])(entry.value) ? (0, _last2["default"])(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-label-list"
	  }, data.map(function (entry, index) {
	    var value = (0, _isNil2["default"])(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	    var idProps = (0, _isNil2["default"])(id) ? {} : {
	      id: "".concat(id, "-").concat(index)
	    };
	    return _react["default"].createElement(_Label["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	      index: index,
	      value: value,
	      viewBox: _Label["default"].parseViewBox((0, _isNil2["default"])(clockWise) ? entry : _objectSpread({}, entry, {
	        clockWise: clockWise
	      })),
	      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
	
	    }));
	  }));
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data
	    });
	  }
	
	  if (_react["default"].isValidElement(label) || (0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data,
	      content: label
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(LabelList, _extends({
	      data: data
	    }, label, {
	      key: "labelList-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: "labelList-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	var _default = LabelList;
	exports["default"] = _default;

/***/ },
/* 151 */
[2761, 75, 2484],
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 2001;\n\n  ', '\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 2001;\n\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  width: 100%;\n  max-width: ', ';\n  position: fixed;\n  z-index: 2002;\n  top: ', ';\n  left: 50%;\n  margin-left: ', ';\n\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: ', ';\n  padding: ', ';\n\n  /* Subtle celebration accent for the lg variant so the last-of-four\n     post message reads differently from a routine success toast. */\n  ', '\n\n  ', '\n'], ['\n  background: #ffffff;\n  width: 100%;\n  max-width: ', ';\n  position: fixed;\n  z-index: 2002;\n  top: ', ';\n  left: 50%;\n  margin-left: ', ';\n\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: ', ';\n  padding: ', ';\n\n  /* Subtle celebration accent for the lg variant so the last-of-four\n     post message reads differently from a routine success toast. */\n  ', '\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: ', ';\n  line-height: ', ';\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: ', ';\n  line-height: ', ';\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n\n  ul {\n    list-style: disc;\n    padding-left: 30px;\n  }\n  \n  ul li {\n    font-size: 16px !important;\n    line-height: 24px !important;\n    margin-top: 3px;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n\n  ul {\n    list-style: disc;\n    padding-left: 30px;\n  }\n  \n  ul li {\n    font-size: 16px !important;\n    line-height: 24px !important;\n    margin-top: 3px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: #5c91f5;\n  display: inline-block;\n  float: right;\n  cursor: pointer;\n  margin-top: 24px;\n  border: 1.5px solid #5c91f5;\n  padding: 6px 14px;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  align-self: flex-end;\n\n  ', '\n'], ['\n  background: #5c91f5;\n  display: inline-block;\n  float: right;\n  cursor: pointer;\n  margin-top: 24px;\n  border: 1.5px solid #5c91f5;\n  padding: 6px 14px;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  align-self: flex-end;\n\n  ', '\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  gap: ', ';\n  align-items: flex-start;\n  justify-content: flex-start;\n'], ['\n  display: flex;\n  flex-direction: row;\n  gap: ', ';\n  align-items: flex-start;\n  justify-content: flex-start;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  flex-shrink: 0;\n\n  img {\n    ', '\n  }\n'], ['\n  flex-shrink: 0;\n\n  img {\n    ', '\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n'], ['\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  padding: 10px 22px;\n  font-size: 15px;\n  line-height: 22px;\n  margin-top: 32px;\n'], ['\n  padding: 10px 22px;\n  font-size: 15px;\n  line-height: 22px;\n  margin-top: 32px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _infoAlert = __webpack_require__(2582);
	
	var _infoAlert2 = _interopRequireDefault(_infoAlert);
	
	var _successAlert = __webpack_require__(2673);
	
	var _successAlert2 = _interopRequireDefault(_successAlert);
	
	var _errorAlert = __webpack_require__(2575);
	
	var _errorAlert2 = _interopRequireDefault(_errorAlert);
	
	var _warningIcon = __webpack_require__(2682);
	
	var _warningIcon2 = _interopRequireDefault(_warningIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AlertOverlay = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.overlayStylings && '\n    ' + p.overlayStylings + '\n  ';
	});
	
	var AlertWrapper = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.size === 'lg' ? '800px' : '400px';
	}, function (p) {
	  return p.size === 'lg' ? '180px' : '300px';
	}, function (p) {
	  return p.size === 'lg' ? '-400px' : '-200px';
	}, function (p) {
	  return p.size === 'lg' ? '16px' : '8px';
	}, function (p) {
	  return p.size === 'lg' ? '56px 56px 40px' : '32px 32px 24px';
	}, function (p) {
	  return p.size === 'lg' && '\n    background:\n      radial-gradient(120% 60% at 50% 0%, rgba(82, 197, 205, 0.14) 0%, rgba(82, 197, 205, 0) 60%),\n      #ffffff;\n    border: 1px solid rgba(82, 197, 205, 0.35);\n  ';
	}, function (p) {
	  return p.modalStylings && '\n    ' + p.modalStylings + '\n  ';
	});
	
	var AlertTitle = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.size === 'lg' ? '20px' : '18px';
	}, function (p) {
	  return p.size === 'lg' ? '28px' : '24px';
	});
	
	var AlertMessage = _styledComponents2.default.div(_templateObject4);
	
	var AlertButton = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.alignCenter && '\n    align-self: center;\n  ';
	});
	
	var AlertBody = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.size === 'lg' ? '24px' : '16px';
	});
	
	var IconSlot = _styledComponents2.default.div(_templateObject7, function (p) {
	  return p.size === 'lg' && '\n      width: 56px;\n      height: 56px;\n    ';
	});
	
	var FullWidth = _styledComponents2.default.div(_templateObject8);
	
	var LargeButton = (0, _styledComponents2.default)(AlertButton)(_templateObject9);
	
	var DecisionsAlert = function DecisionsAlert(_ref) {
	  var title = _ref.title,
	      message = _ref.message,
	      onHide = _ref.onHide,
	      type = _ref.type,
	      _ref$buttonText = _ref.buttonText,
	      buttonText = _ref$buttonText === undefined ? 'Got it' : _ref$buttonText,
	      _ref$buttonCenterAlig = _ref.buttonCenterAlign,
	      buttonCenterAlign = _ref$buttonCenterAlig === undefined ? false : _ref$buttonCenterAlig,
	      _ref$overlayStylings = _ref.overlayStylings,
	      overlayStylings = _ref$overlayStylings === undefined ? null : _ref$overlayStylings,
	      _ref$modalStylings = _ref.modalStylings,
	      modalStylings = _ref$modalStylings === undefined ? null : _ref$modalStylings,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 'md' : _ref$size;
	
	  var ButtonComponent = size === 'lg' ? LargeButton : AlertButton;
	  return _react2.default.createElement(
	    _reactDotFragment2.default,
	    null,
	    _react2.default.createElement(AlertOverlay, { overlayStylings: overlayStylings }),
	    _react2.default.createElement(
	      AlertWrapper,
	      { size: size, modalStylings: modalStylings },
	      _react2.default.createElement(
	        AlertBody,
	        { size: size },
	        type === 'info' && _react2.default.createElement(
	          IconSlot,
	          { size: size },
	          _react2.default.createElement('img', { src: _infoAlert2.default, alt: '' })
	        ),
	        type === 'success' && _react2.default.createElement(
	          IconSlot,
	          { size: size },
	          _react2.default.createElement('img', { src: _successAlert2.default, alt: '' })
	        ),
	        type === 'error' && _react2.default.createElement(
	          IconSlot,
	          { size: size },
	          _react2.default.createElement('img', { src: _errorAlert2.default, alt: '' })
	        ),
	        type === 'warning' && _react2.default.createElement(
	          IconSlot,
	          { size: size },
	          _react2.default.createElement('img', { src: _warningIcon2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          FullWidth,
	          null,
	          _react2.default.createElement(
	            AlertTitle,
	            { size: size },
	            title
	          ),
	          _react2.default.createElement(
	            AlertMessage,
	            null,
	            message
	          ),
	          _react2.default.createElement(
	            ButtonComponent,
	            { onClick: onHide, alignCenter: buttonCenterAlign },
	            buttonText
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = DecisionsAlert;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _customLabel = __webpack_require__(213);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	var _tooltipContent = __webpack_require__(398);
	
	var _tooltipContent2 = _interopRequireDefault(_tooltipContent);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VerticalBar(_ref) {
	  var _ref$prefix = _ref.prefix,
	      prefix = _ref$prefix === undefined ? "" : _ref$prefix,
	      _ref$suffix = _ref.suffix,
	      suffix = _ref$suffix === undefined ? "" : _ref$suffix,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? 2 : _ref$precision,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data;
	
	  var min = Math.min.apply(null, _lodash2.default.map(data, "value"));
	  var max = Math.max.apply(null, _lodash2.default.map(data, "value"));
	
	  if (min === 0 && max === 0) {
	    min = -10;
	    max = 10;
	  } else {
	    min = max = Math.max(Math.abs(min), Math.abs(max));
	    min *= -1.8;
	    max *= 1.8;
	  }
	
	  var domain = [min, max];
	  var colors = _Teams2.default.competitiveColors();
	
	  return _react2.default.createElement(
	    _recharts.ResponsiveContainer,
	    { width: "100%", height: 200 },
	    _react2.default.createElement(
	      _recharts.BarChart,
	      { data: data, barSize: 18, layout: "vertical" },
	      _react2.default.createElement(_recharts.XAxis, {
	        type: "number",
	        dataKey: "value",
	        domain: domain,
	        axisLine: false,
	        tickLine: false,
	        tick: false
	      }),
	      _react2.default.createElement(_recharts.YAxis, { type: "category", dataKey: "name", hide: true }),
	      _react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(_tooltipContent2.default, { prefix: prefix, suffix: suffix }) }),
	      _react2.default.createElement(
	        _recharts.Bar,
	        {
	          dataKey: "value",
	          minPointSize: 5,
	          label: _react2.default.createElement(_customLabel2.default, {
	            prefix: prefix,
	            precision: precision,
	            suffix: suffix,
	            layout: "vertical"
	          })
	        },
	        colors.map(function (color, i) {
	          return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	        })
	      )
	    )
	  );
	}
	
	exports.default = VerticalBar;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cell = exports.Row = exports.Table = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #ffffff;\n  margin-top: 12px;\n  overflow: hidden;\n'], ['\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #ffffff;\n  margin-top: 12px;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  width: auto;\n\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: auto;\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 13px 16px;\n  align-self: center;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  flex: 1;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 13px 16px;\n  align-self: center;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Table = exports.Table = _styledComponents2.default.div(_templateObject);
	
	var Row = exports.Row = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	});
	
	var Cell = exports.Cell = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.color && '\n    color: ' + p.color + ';\n  ';
	}, function (p) {
	  return p.fontWeight && '\n    font-weight: ' + p.fontWeight + ';\n  ';
	}, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	}, function (p) {
	  return p.percentageWidth && '\n    flex-basis: ' + p.percentageWidth + '%;\n  ';
	}, function (p) {
	  return p.textAlign && '\n    text-align: ' + p.textAlign + ';\n  ';
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPageLogo = __webpack_require__(1049);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsWelcomeLayout(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$left_content = _ref.left_content,
	      left_content = _ref$left_content === undefined ? "" : _ref$left_content,
	      _ref$right_content = _ref.right_content,
	      right_content = _ref$right_content === undefined ? "" : _ref$right_content;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "team-reports-layout team-reports-layout-welcome" },
	    _react2.default.createElement(
	      "div",
	      { className: "team-reports-logo" },
	      _react2.default.createElement("img", { src: _LandingPageLogo2.default, alt: "logo" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "welcome-inner-content clearfix" },
	      _react2.default.createElement(
	        "div",
	        { className: "left" },
	        left_content
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "right" },
	        right_content
	      )
	    )
	  );
	}
	
	exports.default = TeamReportsWelcomeLayout;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OVERLAY_TRIGGER_REF = "overlay-trigger";
	
	var HelpIconButtonWithTooltip = function (_Component) {
	  _inherits(HelpIconButtonWithTooltip, _Component);
	
	  function HelpIconButtonWithTooltip(props) {
	    _classCallCheck(this, HelpIconButtonWithTooltip);
	
	    var _this = _possibleConstructorReturn(this, (HelpIconButtonWithTooltip.__proto__ || Object.getPrototypeOf(HelpIconButtonWithTooltip)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(HelpIconButtonWithTooltip, [{
	    key: "onClick",
	    value: function onClick(evt) {
	      if (!evt) {
	        return;
	      }
	
	      var tagName = evt.target.tagName;
	      // If it is a button or link, close the modal.
	      if (tagName === "A" || tagName === "BUTTON") {
	        this.refs[OVERLAY_TRIGGER_REF].hide();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var tooltip = _react2.default.createElement(
	        _reactBootstrap.Tooltip,
	        { id: "help-icon-tooltip", onClick: this.onClick },
	        this.props.tooltipContent
	      );
	
	      return _react2.default.createElement(
	        _reactBootstrap.OverlayTrigger,
	        {
	          ref: OVERLAY_TRIGGER_REF,
	          trigger: "click",
	          placement: "bottom",
	          overlay: tooltip,
	          rootClose: true
	        },
	        _react2.default.createElement(_reactFontawesome2.default, {
	          className: "question-mark pointer" + (this.props.iconSize ? " question-mark-" + this.props.iconSize : ""),
	          style: { textDecoration: "none" },
	          name: "question-circle"
	        })
	      );
	    }
	  }]);
	
	  return HelpIconButtonWithTooltip;
	}(_react.Component);
	
	HelpIconButtonWithTooltip.propTypes = {
	  tooltipContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
	  iconSize: _propTypes2.default.oneOf(["xs", "sm"])
	};
	
	exports.default = HelpIconButtonWithTooltip;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(88);
	
	var _visual = __webpack_require__(609);
	
	var _visual2 = _interopRequireDefault(_visual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OneVisualLayout = function OneVisualLayout(_ref) {
	  var section = _ref.section,
	      subSection = _ref.subSection,
	      title = _ref.title,
	      paragraph1 = _ref.paragraph1,
	      paragraph2 = _ref.paragraph2,
	      visual = _ref.visual,
	      _ref$visualProps = _ref.visualProps,
	      visualProps = _ref$visualProps === undefined ? {} : _ref$visualProps;
	  return _react2.default.createElement(
	    _ui.Wrapper,
	    null,
	    (section || subSection) && _react2.default.createElement(
	      _ui.PreTitle,
	      null,
	      section,
	      subSection ? ' | ' + subSection : ''
	    ),
	    _react2.default.createElement(
	      _ui.Title,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      _ui.Text,
	      null,
	      paragraph1
	    ),
	    _react2.default.createElement(_visual2.default, Object.assign({ data: visual }, visualProps)),
	    paragraph2 && _react2.default.createElement(
	      _ui.Text,
	      null,
	      paragraph2
	    )
	  );
	}; /* eslint-disable jsx-a11y/anchor-is-valid */
	exports.default = OneVisualLayout;

/***/ },
/* 158 */
[2692, 264],
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(160);
	var core = __webpack_require__(115);
	var ctx = __webpack_require__(413);
	var hide = __webpack_require__(220);
	var has = __webpack_require__(184);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 160 */
30,
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(44)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(96)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 163 */
[2705, 196, 33, 104, 57, 31],
/* 164 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = {
	
	    propTypes: {
	        layout: React.PropTypes.string,
	        validatePristine: React.PropTypes.bool,
	        validateOnSubmit: React.PropTypes.bool,
	        rowClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        labelClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        elementWrapperClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object])
	    },
	
	    contextTypes: {
	        layout: React.PropTypes.string,
	        validatePristine: React.PropTypes.bool,
	        validateOnSubmit: React.PropTypes.bool,
	        rowClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        labelClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        elementWrapperClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object])
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            disabled: false,
	            validatePristine: false,
	            validateOnSubmit: false,
	            onChange: function onChange() {},
	            onFocus: function onFocus() {},
	            onBlur: function onBlur() {}
	        };
	    },
	
	    /**
	     * Accessors for "special" properties.
	     *
	     * The following methods are used to merge master default properties that
	     * are optionally set on the parent form. This to to allow customising these
	     * properties 'as a whole' for the form, while retaining the ability to
	     * override the properties on a component basis.
	     *
	     * Also see the parent-context mixin.
	     */
	    getLayout: function getLayout() {
	        var defaultProperty = this.context.layout || 'horizontal';
	        return this.props.layout ? this.props.layout : defaultProperty;
	    },
	
	    getValidatePristine: function getValidatePristine() {
	        var defaultProperty = this.context.validatePristine || false;
	        return this.props.validatePristine ? this.props.validatePristine : defaultProperty;
	    },
	
	    getValidateOnSubmit: function getValidateOnSubmit() {
	        var defaultProperty = this.context.validateOnSubmit || false;
	        return this.props.validateOnSubmit ? this.props.validateOnSubmit : defaultProperty;
	    },
	
	    getRowClassName: function getRowClassName() {
	        return [this.context.rowClassName, this.props.rowClassName];
	    },
	
	    getLabelClassName: function getLabelClassName() {
	        return [this.context.labelClassName, this.props.labelClassName];
	    },
	
	    getElementWrapperClassName: function getElementWrapperClassName() {
	        return [this.context.elementWrapperClassName, this.props.elementWrapperClassName];
	    },
	
	    getRowProperties: function getRowProperties() {
	        return {
	            label: this.props.label,
	            rowClassName: this.getRowClassName(),
	            labelClassName: this.getLabelClassName(),
	            elementWrapperClassName: this.getElementWrapperClassName(),
	            layout: this.getLayout(),
	            required: this.isRequired(),
	            hasErrors: this.showErrors()
	        };
	    },
	
	    hashString: function hashString(string) {
	        var hash = 0;
	        for (var i = 0; i < string.length; i++) {
	            hash = (hash << 5) - hash + string.charCodeAt(i) & 0xFFFFFFFF;
	        }
	        return hash;
	    },
	
	    /**
	     * getId
	     *
	     * The ID is used as an attribute on the form control, and is used to allow
	     * associating the label element with the form control.
	     *
	     * If we don't explicitly pass an `id` prop, we generate one based on the
	     * `name` and `label` properties.
	     */
	    getId: function getId() {
	        if (this.props.id) {
	            return this.props.id;
	        }
	        var label = typeof this.props.label === 'undefined' ? '' : this.props.label;
	        return ['frc', this.props.name.split('[').join('_').replace(']', ''), this.hashString(JSON.stringify(label))].join('-');
	    },
	
	    renderHelp: function renderHelp() {
	        if (!this.props.help) {
	            return null;
	        }
	        return React.createElement(
	            'span',
	            { className: 'help-block' },
	            this.props.help
	        );
	    },
	
	    renderErrorMessage: function renderErrorMessage() {
	        if (!this.showErrors()) {
	            return null;
	        }
	        var errorMessages = this.getErrorMessages() || [];
	        return errorMessages.map(function (message, key) {
	            return React.createElement(
	                'span',
	                { key: key, className: 'help-block validation-message' },
	                message
	            );
	        });
	    },
	
	    showErrors: function showErrors() {
	        if (this.isPristine() && !this.getValidatePristine()) {
	            return false;
	        }
	        if (this.getValidateOnSubmit() && !this.isFormSubmitted()) {
	            return false;
	        }
	        return !this.isValid();
	    }
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(1560);
	
	var Row = React.createClass({
	    displayName: 'Row',
	
	
	    propTypes: {
	        label: React.PropTypes.node,
	        children: React.PropTypes.node,
	        rowClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        labelClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        elementWrapperClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        required: React.PropTypes.bool,
	        hasErrors: React.PropTypes.bool,
	        fakeLabel: React.PropTypes.bool,
	        layout: React.PropTypes.oneOf(['horizontal', 'vertical', 'elementOnly']),
	        htmlFor: React.PropTypes.string
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            label: '',
	            rowClassName: '',
	            labelClassName: '',
	            elementWrapperClassName: '',
	            required: false,
	            hasErrors: false,
	            fakeLabel: false
	        };
	    },
	
	    renderRequiredSymbol: function renderRequiredSymbol() {
	        if (this.props.required === false) {
	            return null;
	        }
	        return React.createElement(
	            'span',
	            { className: 'required-symbol' },
	            ' *'
	        );
	    },
	
	    renderLabel: function renderLabel() {
	
	        if (this.props.layout === 'elementOnly') {
	            return null;
	        }
	
	        var labelClassNames = [];
	        labelClassNames.push('control-label');
	
	        if (this.props.layout === 'horizontal') {
	            labelClassNames.push('col-sm-3');
	        }
	
	        labelClassNames.push(this.props.labelClassName);
	
	        if (this.props.fakeLabel) {
	            return React.createElement(
	                'div',
	                {
	                    className: classNames(labelClassNames),
	                    'data-required': this.props.required
	                },
	                React.createElement(
	                    'strong',
	                    null,
	                    this.props.label,
	                    this.renderRequiredSymbol()
	                )
	            );
	        }
	
	        return React.createElement(
	            'label',
	            {
	                className: classNames(labelClassNames),
	                'data-required': this.props.required,
	                htmlFor: this.props.htmlFor
	            },
	            this.props.label,
	            this.renderRequiredSymbol()
	        );
	    },
	
	    render: function render() {
	
	        if (this.props.layout === 'elementOnly') {
	            return React.createElement(
	                'span',
	                null,
	                this.props.children
	            );
	        }
	
	        var cssClasses = {
	            row: ['form-group'],
	            elementWrapper: []
	        };
	
	        if (this.props.hasErrors) {
	            cssClasses.row.push('has-error');
	            cssClasses.row.push('has-feedback');
	        }
	
	        var element = this.props.children;
	        if (this.props.layout === 'horizontal') {
	
	            // Horizontal layout needs a 'row' class for Bootstrap 4
	            cssClasses.row.push('row');
	
	            cssClasses.elementWrapper.push('col-sm-9');
	            cssClasses.elementWrapper.push(this.props.elementWrapperClassName);
	
	            element = React.createElement(
	                'div',
	                { className: classNames(cssClasses.elementWrapper) },
	                this.props.children
	            );
	        }
	
	        cssClasses.row.push(this.props.rowClassName);
	        return React.createElement(
	            'div',
	            { className: classNames(cssClasses.row) },
	            this.renderLabel(),
	            element
	        );
	    }
	
	});
	
	module.exports = Row;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(230),
	    getRawTag = __webpack_require__(1991),
	    objectToString = __webpack_require__(2019);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(924);
	
	__webpack_require__(925);
	
	__webpack_require__(2230);
	
	__webpack_require__(926);
	
	__webpack_require__(2231);
	
	__webpack_require__(927);
	
	__webpack_require__(928);
	
	__webpack_require__(362);
	
	__webpack_require__(2235);
	
	__webpack_require__(931);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetch = fetch;
	exports.fetchJSONP = fetchJSONP;
	exports.getRandomColor = getRandomColor;
	exports.parseSize = parseSize;
	exports.getImageSize = getImageSize;
	exports.defaultInitials = defaultInitials;
	exports.setGroupedTimeout = setGroupedTimeout;
	exports.defaultColors = void 0;
	
	var _isRetina = _interopRequireDefault(__webpack_require__(1915));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var IS_RETINA = (0, _isRetina.default)();
	
	function fetch(url, successCb, errorCb) {
	  var request = new XMLHttpRequest();
	
	  request.onreadystatechange = function () {
	    if (request.readyState === 4) {
	      if (request.status === 200) {
	        var data = JSON.parse(request.responseText);
	        successCb(data);
	      } else {
	        errorCb(request.status);
	      }
	    }
	  };
	
	  request.open('GET', url, true);
	  request.send();
	}
	
	function fetchJSONP(url, successCb, errorCb) {
	  var callbackName = 'jsonp_cb_' + Math.round(100000 * Math.random());
	  var script = document.createElement('script');
	  script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
	  document.body.appendChild(script);
	
	  script.onerror = function () {
	    errorCb();
	  };
	
	  window[callbackName] = function (data) {
	    delete window[callbackName];
	    document.body.removeChild(script);
	    successCb(data);
	  };
	}
	
	var defaultColors = ['#d73d32', '#7e3794', '#4285f4', '#67ae3f', '#d61a7f', '#ff4080']; // https://regex101.com/r/YEsPER/1
	// https://developer.mozilla.org/en-US/docs/Web/CSS/length
	
	exports.defaultColors = defaultColors;
	var reSize = /^([-+]?(?:\d+(?:\.\d+)?|\.\d+))([a-z]{2,4}|%)?$/; // https://en.wikipedia.org/wiki/Linear_congruential_generator
	
	function _stringAsciiPRNG(value, m) {
	  // Xn+1 = (a * Xn + c) % m
	  // 0 < a < m
	  // 0 <= c < m
	  // 0 <= X0 < m
	  var charCodes = _toConsumableArray(value).map(function (letter) {
	    return letter.charCodeAt(0);
	  });
	
	  var len = charCodes.length;
	  var a = len % (m - 1) + 1;
	  var c = charCodes.reduce(function (current, next) {
	    return current + next;
	  }) % m;
	  var random = charCodes[0] % m;
	
	  for (var i = 0; i < len; i++) {
	    random = (a * random + c) % m;
	  }
	
	  return random;
	}
	
	function getRandomColor(value) {
	  var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultColors;
	  // if no value is passed, always return transparent color otherwise
	  // a rerender would show a new color which would will
	  // give strange effects when an interface is loading
	  // and gets rerendered a few consequent times
	  if (!value) return 'transparent'; // value based random color index
	  // the reason we don't just use a random number is to make sure that
	  // a certain value will always get the same color assigned given
	  // a fixed set of colors
	
	  var colorIndex = _stringAsciiPRNG(value, colors.length);
	
	  return colors[colorIndex];
	}
	
	function parseSize(size) {
	  size = '' + size;
	
	  var _ref = reSize.exec(size) || [],
	      _ref2 = _slicedToArray(_ref, 3),
	      _ref2$ = _ref2[1],
	      value = _ref2$ === void 0 ? 0 : _ref2$,
	      _ref2$2 = _ref2[2],
	      unit = _ref2$2 === void 0 ? 'px' : _ref2$2;
	
	  return {
	    value: parseFloat(value),
	    str: value + unit,
	    unit: unit
	  };
	}
	/**
	 * Calculate absolute size in pixels we want for the images
	 * that get requested from the various sources. They don't
	 * understand relative sizes like `em` or `vww`.  We select
	 * a fixed size of 512px when we can't detect the true pixel size.
	 */
	
	
	function getImageSize(size) {
	  size = parseSize(size);
	  if (isNaN(size.value)) // invalid size, use fallback
	    size = 512;else if (size.unit === 'px') // px are good, use them
	    size = size.value;else if (size.value === 0) // relative 0 === absolute 0
	    size = 0;else // anything else is unknown, use fallback
	    size = 512;
	  if (IS_RETINA) size = size * 2;
	  return size;
	}
	
	function defaultInitials(name, _ref3) {
	  var maxInitials = _ref3.maxInitials;
	  return name.split(/\s/).map(function (part) {
	    return part.substring(0, 1).toUpperCase();
	  }).filter(function (v) {
	    return !!v;
	  }).slice(0, maxInitials).join('').toUpperCase();
	}
	/**
	 * Grouped timeouts reduce the amount of timeouts trigged
	 * by grouping multiple handlers into a single setTimeout call.
	 *
	 * This reduces accuracy of the timeout but will be less expensive
	 * when multiple avatar have been loaded into view.
	 */
	
	
	var timeoutGroups = {};
	
	function setGroupedTimeout(fn, ttl) {
	  if (timeoutGroups[ttl]) {
	    timeoutGroups[ttl].push(fn);
	    return;
	  }
	
	  var callbacks = timeoutGroups[ttl] = [fn];
	  setTimeout(function () {
	    delete timeoutGroups[ttl];
	    callbacks.forEach(function (cb) {
	      return cb();
	    });
	  }, ttl);
	}

/***/ },
/* 170 */
[2756, 357],
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(218);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  block: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  componentClass: _elementType2.default,
	  href: _propTypes2.default.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3.default)(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2.default.createElement(_SafeAnchor2.default, (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3.default)(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 173 */
/***/ function(module, exports) {

	exports.reactLocalStorage = {
	    set: function(key, value) {
	        localStorage[key] = value;
	        return localStorage[key];
	    },
	    get: function(key, defaultValue) {
	        return localStorage[key] || defaultValue;
	    },
	    setObject: function(key, value) {
	        localStorage[key] = JSON.stringify(value);
	        return localStorage[key];
	    },
	    getObject: function(key, value) {
	        return JSON.parse(localStorage[key] || '{}');
	    },
	    clear: function() {
	        return localStorage.clear();
	    }
	}


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Text = _interopRequireDefault(__webpack_require__(207));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	var _PolarUtils = __webpack_require__(126);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var cartesianViewBoxShape = _propTypes["default"].shape({
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number
	});
	
	var polarViewBoxShape = _propTypes["default"].shape({
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number
	});
	
	var propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes["default"].func,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  offset: _propTypes["default"].number,
	  position: _propTypes["default"].oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  className: _propTypes["default"].string,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
	});
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	  var label = (0, _isNil2["default"])(props.children) ? value : props.children;
	
	  if ((0, _isFunction2["default"])(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle, direction;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
	  var id = (0, _isNil2["default"])(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	  return _react["default"].createElement("text", _extends({}, attrs, {
	    dominantBaseline: "central",
	    className: (0, _classnames["default"])('recharts-radial-bar-label', className)
	  }), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
	    id: id,
	    d: path
	  })), _react["default"].createElement("textPath", {
	    xlinkHref: "#".concat(id)
	  }, label));
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'centerTop') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'centerBottom') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: sign > 0 ? 'end' : 'start'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject2["default"])(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === void 0 ? '' : _props$className;
	
	  if (!viewBox || (0, _isNil2["default"])(value) && (0, _isNil2["default"])(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction2["default"])(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label;
	
	  if ((0, _isFunction2["default"])(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	  var events = (0, _ReactUtils.filterEventAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	  return _react["default"].createElement(_Text["default"], _extends({
	    className: (0, _classnames["default"])('recharts-label', className)
	  }, attrs, positionAttrs, events), label);
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	
	    if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return {
	        x: top,
	        y: left,
	        width: width,
	        height: height
	      };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return {
	      x: x,
	      y: y,
	      width: 0,
	      height: 0
	    };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx,
	      cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox,
	      value: label
	    });
	  }
	
	  if ((0, _react.isValidElement)(label)) {
	    if (label.type === Label) {
	      return (0, _react.cloneElement)(label, {
	        key: 'label-implicit',
	        viewBox: viewBox
	      });
	    }
	
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(Label, _extends({
	      viewBox: viewBox
	    }, label, {
	      key: "label-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var parentViewBox = parseViewBox(parentProps);
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: "label-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	var _default = Label;
	exports["default"] = _default;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabeledScaleHelper = exports.ScaleHelper = exports.rectWithCoords = exports.rectWithPoints = exports.formatAxisMap = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(733));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(2046));
	
	var _ChartUtils = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === void 0 ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
	    var range, x, y, needSpace;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      realScaleType: realScaleType,
	      x: x,
	      y: y,
	      scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var rectWithPoints = function rectWithPoints(_ref, _ref2) {
	  var x1 = _ref.x,
	      y1 = _ref.y;
	  var x2 = _ref2.x,
	      y2 = _ref2.y;
	  return {
	    x: Math.min(x1, x2),
	    y: Math.min(y1, y2),
	    width: Math.abs(x2 - x1),
	    height: Math.abs(y2 - y1)
	  };
	};
	/**
	 * Compute the x, y, width, and height of a box from two reference points.
	 * @param  {Object} coords     x1, x2, y1, and y2
	 * @return {Object} object
	 */
	
	
	exports.rectWithPoints = rectWithPoints;
	
	var rectWithCoords = function rectWithCoords(_ref3) {
	  var x1 = _ref3.x1,
	      y1 = _ref3.y1,
	      x2 = _ref3.x2,
	      y2 = _ref3.y2;
	  return rectWithPoints({
	    x: x1,
	    y: y1
	  }, {
	    x: x2,
	    y: y2
	  });
	};
	
	exports.rectWithCoords = rectWithCoords;
	
	var ScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(ScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new ScaleHelper(obj);
	    }
	  }]);
	
	  function ScaleHelper(scale) {
	    _classCallCheck(this, ScaleHelper);
	
	    this.scale = scale;
	  }
	
	  _createClass(ScaleHelper, [{
	    key: "apply",
	    value: function apply(value) {
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref4.bandAware,
	          position = _ref4.position;
	
	      if (value === undefined) {
	        return undefined;
	      }
	
	      if (position) {
	        switch (position) {
	          case 'start':
	            {
	              return this.scale(value);
	            }
	
	          case 'middle':
	            {
	              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
	              return this.scale(value) + offset;
	            }
	
	          case 'end':
	            {
	              var _offset = this.bandwidth ? this.bandwidth() : 0;
	
	              return this.scale(value) + _offset;
	            }
	
	          default:
	            {
	              return this.scale(value);
	            }
	        }
	      }
	
	      if (bandAware) {
	        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
	
	        return this.scale(value) + _offset2;
	      }
	
	      return this.scale(value);
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(value) {
	      var range = this.range();
	      var first = range[0];
	      var last = range[range.length - 1];
	      return first <= last ? value >= first && value <= last : value >= last && value <= first;
	    }
	  }, {
	    key: "domain",
	    get: function get() {
	      return this.scale.domain;
	    }
	  }, {
	    key: "range",
	    get: function get() {
	      return this.scale.range;
	    }
	  }, {
	    key: "rangeMin",
	    get: function get() {
	      return this.range()[0];
	    }
	  }, {
	    key: "rangeMax",
	    get: function get() {
	      return this.range()[1];
	    }
	  }, {
	    key: "bandwidth",
	    get: function get() {
	      return this.scale.bandwidth;
	    }
	  }]);
	
	  return ScaleHelper;
	}();
	
	exports.ScaleHelper = ScaleHelper;
	ScaleHelper.EPS = 1e-4;
	
	var LabeledScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(LabeledScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new this(obj);
	    }
	  }]);
	
	  function LabeledScaleHelper(scales) {
	    _classCallCheck(this, LabeledScaleHelper);
	
	    this.scales = (0, _mapValues2["default"])(scales, ScaleHelper.create);
	    Object.assign(this, this.scales);
	  }
	
	  _createClass(LabeledScaleHelper, [{
	    key: "apply",
	    value: function apply(coords) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref5.bandAware;
	
	      var scales = this.scales;
	      return (0, _mapValues2["default"])(coords, function (value, label) {
	        return scales[label].apply(value, {
	          bandAware: bandAware
	        });
	      });
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(coords) {
	      var scales = this.scales;
	      return (0, _every2["default"])(coords, function (value, label) {
	        return scales[label].isInRange(value);
	      });
	    }
	  }]);
	
	  return LabeledScaleHelper;
	}();
	
	exports.LabeledScaleHelper = LabeledScaleHelper;

/***/ },
/* 176 */
[2751, 80],
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof window === 'undefined') {
	  module.exports = function () {
	    return null;
	  };
	} else {
	  module.exports = __webpack_require__(2544); // eslint-disable-line global-require
	}

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchAllStaticData = fetchAllStaticData;
	
	var _ApiService = __webpack_require__(4);
	
	var KEY_MAP = {
	  sales_clients: "salesClients",
	  demand_growth_rate: "demandGrowthRate",
	  accounts_receivable: "accountsReceivable",
	  customer_preferences: "customerPreferences",
	  features: "features",
	  factories: "factories",
	  ratings: "ratings",
	  initial_demand: "initialDemand",
	  prime_rates: "primeRates",
	  machines: "machines",
	  accounts_payable: "accountsPayable",
	  total_demand: "totalDemand",
	  marketing_clients: "marketingClients",
	  constants: "constants",
	  debt_clients: "debtClients",
	  utilizations: "utilizations",
	  comparable_companies: "comparableCompanies",
	  equity_clients: "equityClients",
	  customer_demand: "customerDemand",
	  // Scalars returned by the business-case scope only. Camelcased for
	  // consistency with the rest of KEY_MAP.
	  bcase_price_floor: "bcasePriceFloor",
	  bcase_price_ceiling: "bcasePriceCeiling",
	  bcase_revenue_estimate: "bcaseRevenueEstimate"
	};
	
	// `scope` is an optional string ("business-case" is currently the only
	// value the BE honors) that swaps the endpoint into a trimmed payload
	// tuned for a single consumer. Without it, behavior is unchanged.
	function fetchAllStaticData(roundNumber, scope) {
	  var base = ("https://be-production-itb.marketgames.io/api/") + "static/all/";
	  var params = [];
	  if (roundNumber != null) params.push("round_number=" + roundNumber);
	  if (scope) params.push("scope=" + encodeURIComponent(scope));
	  var url = params.length > 0 ? base + "?" + params.join("&") : base;
	
	  return (0, _ApiService.getRequest)(url).then(function (_ref) {
	    var body = _ref.body;
	
	    var mapped = {};
	    Object.keys(body).forEach(function (key) {
	      var camelKey = KEY_MAP[key] || key;
	      mapped[camelKey] = body[key];
	    });
	    return mapped;
	  });
	}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	var _Paper = __webpack_require__(304);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _OnePanel = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwoPanels = function TwoPanels(_ref) {
	  var title1 = _ref.title1,
	      title2 = _ref.title2,
	      children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { style: _styles.dFlex },
	    _react2.default.createElement(
	      _Paper2.default,
	      { style: Object.assign({}, _styles.flex1, { marginRight: "20px" }) },
	      _react2.default.createElement(
	        "h1",
	        { style: Object.assign({}, _OnePanel.panelHeaderStyle, { marginBottom: "3em" }) },
	        title1
	      ),
	      children[0]
	    ),
	    _react2.default.createElement(
	      _Paper2.default,
	      { style: _styles.flex1 },
	      _react2.default.createElement(
	        "h1",
	        { style: _OnePanel.panelHeaderStyle },
	        title2
	      ),
	      children[1]
	    )
	  );
	};
	
	exports.default = TwoPanels;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(573);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _styles = __webpack_require__(95);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paperStyle = function paperStyle(style) {
	  return Object.assign({
	    width: "100%",
	    fontFamily: "Lato",
	    fontSize: "16px"
	  }, style);
	};
	
	var OnePanel = function OnePanel(_ref) {
	  var title = _ref.title,
	      style = _ref.style,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _Paper2.default,
	    { style: paperStyle(style) },
	    _react2.default.createElement(
	      _styles2.default.Title,
	      null,
	      title
	    ),
	    children
	  );
	};
	
	exports.default = OnePanel;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _wrapper = __webpack_require__(595);
	
	var _pretitle = __webpack_require__(593);
	
	var _pretitle2 = _interopRequireDefault(_pretitle);
	
	var _title = __webpack_require__(1293);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _paragraph = __webpack_require__(592);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _visual = __webpack_require__(594);
	
	var _visual2 = _interopRequireDefault(_visual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var OneVisualLayout = function OneVisualLayout(_ref) {
	  var section = _ref.section,
	      subSection = _ref.subSection,
	      title = _ref.title,
	      paragraph1 = _ref.paragraph1,
	      paragraph2 = _ref.paragraph2,
	      visual = _ref.visual,
	      _ref$visualProps = _ref.visualProps,
	      visualProps = _ref$visualProps === undefined ? {} : _ref$visualProps;
	  return _react2.default.createElement(
	    _wrapper.Wrapper,
	    null,
	    _react2.default.createElement(
	      _pretitle2.default,
	      null,
	      section,
	      subSection ? ' | ' + subSection : ''
	    ),
	    _react2.default.createElement(
	      _title2.default,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      _paragraph2.default,
	      null,
	      paragraph1
	    ),
	    _react2.default.createElement(_visual2.default, Object.assign({ data: visual }, visualProps)),
	    paragraph2 && _react2.default.createElement(
	      _paragraph2.default,
	      null,
	      paragraph2
	    )
	  );
	};
	
	exports.default = OneVisualLayout;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _formsyReact = __webpack_require__(142);
	
	var _formsyReact2 = _interopRequireDefault(_formsyReact);
	
	var _FormsyControlledInput = __webpack_require__(1408);
	
	var _FormsyControlledInput2 = _interopRequireDefault(_FormsyControlledInput);
	
	var _CustomNumberFormat = __webpack_require__(1407);
	
	var _CustomNumberFormat2 = _interopRequireDefault(_CustomNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_formsyReact2.default.addValidationRule("maxAmountValidation", function (values, value, max_amount) {
	  max_amount = parseInt(max_amount, 10);
	  if (isNaN(max_amount)) {
	    max_amount = 0;
	  }
	
	  value = parseInt(value.replace(/,/g, "").replace("$", ""), 10);
	  if (isNaN(value)) {
	    value = 0;
	  }
	
	  if (value > max_amount) {
	    return "Value cannot exceed " + max_amount;
	  }
	
	  return true;
	});
	
	_formsyReact2.default.addValidationRule("isNumericCustom", function (values, value) {
	  value = parseInt(value.replace(/,/g, "").replace("$", ""), 10);
	
	  if (isNaN(value)) {
	    return false;
	  }
	
	  if (typeof value === "number") {
	    return true;
	  }
	
	  return !(value !== null && value !== undefined) || value === "" || /^[-+]?(?:\d*[.])?\d+$/.test(value);
	});
	
	var AbbreviateNumber = function (_Component) {
	  _inherits(AbbreviateNumber, _Component);
	
	  function AbbreviateNumber(props) {
	    _classCallCheck(this, AbbreviateNumber);
	
	    var _this = _possibleConstructorReturn(this, (AbbreviateNumber.__proto__ || Object.getPrototypeOf(AbbreviateNumber)).call(this, props));
	
	    _this.state = {
	      onChangeCallback: props.onChange,
	      maxAmount: props.maxAmount || null
	    };
	    return _this;
	  }
	
	  _createClass(AbbreviateNumber, [{
	    key: "abbreviateNum",
	    value: function abbreviateNum(number) {
	      return number > 99999 ? (number / 1000000).toFixed(2) + "M" : number;
	    }
	  }, {
	    key: "abbreviateNegativeNum",
	    value: function abbreviateNegativeNum(number) {
	      return number < 99999 ? (number / 1000000 * -1).toFixed(2) + "M" : number;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        maxAmount: nextProps.maxAmount || null
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var type = this.props.type || "text";
	      var value = this.props.value;
	      var name = this.props.name || "sampleName";
	      var prexfixFromProp = this.props.prefix;
	      var prefix = prexfixFromProp === "" ? "" : "$";
	      if (typeof this.props.prefix !== "undefined") {
	        prefix = this.props.prefix;
	      }
	
	      var suffix = '';
	      if (typeof this.props.suffix !== "undefined") {
	        suffix = this.props.suffix;
	      }
	      var disabled = this.props.disabled;
	
	      if (value < 99999 && type === "input") {
	        if (this.state.onChangeCallback) {
	          if (typeof this.props.maxAmount !== "undefined" && this.props.maxAmount >= 0) {
	            return _react2.default.createElement(_CustomNumberFormat2.default, {
	              customInput: _FormsyControlledInput2.default,
	              name: name,
	              value: value,
	              type: "text",
	              validations: {
	                isNumericCustom: true,
	                maxAmountValidation: this.state.maxAmount
	              },
	              validationErrors: {
	                isNumericCustom: "Only numeric values supported"
	              },
	              labelClassName: [{ "col-sm-3": false }, "hidden"],
	              elementWrapperClassName: ["col-sm-9", "custom-error-size"],
	              validateOnSubmit: true,
	              prefix: prefix,
	              suffix: suffix,
	              thousandSeparator: ",",
	              onChange: this.state.onChangeCallback
	            });
	          } else {
	            return _react2.default.createElement(_reactNumberFormat2.default, {
	              value: value,
	              displayType: type,
	              prefix: prefix,
	              suffix: suffix,
	              thousandSeparator: ",",
	              onChange: this.state.onChangeCallback,
	              disabled: disabled
	            });
	          }
	        } else {
	          if (typeof this.props.maxAmount !== "undefined" && this.props.maxAmount >= 0) {
	            return _react2.default.createElement(_CustomNumberFormat2.default, {
	              customInput: _FormsyControlledInput2.default,
	              name: name,
	              value: value,
	              type: "text",
	              validations: {
	                isNumericCustom: true,
	                maxAmountValidation: this.state.maxAmount
	              },
	              validationErrors: {
	                isNumericCustom: "Only numeric values supported"
	              },
	              labelClassName: [{ "col-sm-3": false }, "hidden"],
	              elementWrapperClassName: ["col-sm-9", "custom-error-size"],
	              validateOnSubmit: true,
	              prefix: prefix,
	              thousandSeparator: ","
	            });
	          } else {
	            return _react2.default.createElement(_reactNumberFormat2.default, {
	              value: value,
	              displayType: type,
	              prefix: prefix,
	              thousandSeparator: ","
	            });
	          }
	        }
	      }
	
	      if (value < 99999 && type === "text") {
	        return _react2.default.createElement(
	          "span",
	          null,
	          "-$",
	          this.abbreviateNegativeNum(value)
	        );
	      }
	
	      if (type === "text" && value > 99999) {
	        return _react2.default.createElement(
	          "span",
	          null,
	          "$",
	          this.abbreviateNum(value)
	        );
	      }
	
	      if (this.state.onChangeCallback) {
	        if (typeof this.props.maxAmount !== "undefined" && this.props.maxAmount >= 0) {
	          return _react2.default.createElement(_CustomNumberFormat2.default, {
	            customInput: _FormsyControlledInput2.default,
	            name: name,
	            value: value,
	            type: "text",
	            validations: {
	              isNumericCustom: true,
	              maxAmountValidation: this.state.maxAmount
	            },
	            validationErrors: {
	              isNumericCustom: "Only numeric values supported"
	            },
	            labelClassName: [{ "col-sm-3": false }, "hidden"],
	            elementWrapperClassName: ["col-sm-9", "custom-error-size"],
	            validateOnSubmit: true,
	            prefix: prefix,
	            thousandSeparator: ",",
	            onChange: this.state.onChangeCallback
	          });
	        } else {
	          return _react2.default.createElement(_reactNumberFormat2.default, {
	            value: value,
	            displayType: type,
	            prefix: prefix,
	            thousandSeparator: ",",
	            onChange: this.state.onChangeCallback
	          });
	        }
	      } else {
	        if (typeof this.props.maxAmount !== "undefined" && this.props.maxAmount >= 0) {
	          return _react2.default.createElement(_CustomNumberFormat2.default, {
	            customInput: _FormsyControlledInput2.default,
	            name: name,
	            value: value,
	            type: "text",
	            validations: {
	              isNumericCustom: true,
	              maxAmountValidation: this.state.maxAmount
	            },
	            validationErrors: {
	              isNumericCustom: "Only numeric values supported"
	            },
	            labelClassName: [{ "col-sm-3": false }, "hidden"],
	            elementWrapperClassName: ["col-sm-9", "custom-error-size"],
	            validateOnSubmit: true,
	            prefix: prefix,
	            thousandSeparator: ","
	          });
	        } else {
	          return _react2.default.createElement(_reactNumberFormat2.default, {
	            value: value,
	            displayType: type,
	            prefix: prefix,
	            thousandSeparator: ","
	          });
	        }
	      }
	    }
	  }]);
	
	  return AbbreviateNumber;
	}(_react.Component);
	
	exports.default = AbbreviateNumber;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resolveOnboardingEntry = exports.fetchOnboardingSetup = exports.clearOnboardingSetupCache = exports.getNextOnboardingStep = exports.ONBOARDING_STEPS = undefined;
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Shared onboarding routing rules.
	//
	// Full flow (user.onboard === 0):
	//   intro -> path-choice -> simulation-selection -> team-evaluation-survey -> welcome
	//
	// Partial flow (user.onboard === 1 AND the course is missing a game
	// or a survey decision): same steps, but skip 'path-choice' (the
	// "review a demo" page) since the instructor has already seen it.
	//
	// In BOTH flows we also skip:
	//   - simulation-selection if a game already exists for the current course
	//   - team-evaluation-survey if the course has `survey_included` set to
	//     "yes" or "no" (instructor already decided; null means undecided).
	// This prevents re-prompting an instructor who already said "No" to
	// peer evaluation, which was the leak in the old survey-row count.
	
	var ONBOARDING_STEPS = exports.ONBOARDING_STEPS = ['intro', 'path-choice', 'simulation-selection', 'team-evaluation-survey'];
	
	// Compute the URL for the next step given the current step and the
	// per-course setup flags. Returns '/instructor/welcome' when nothing
	// remains. currentStep=null means "starting fresh, pick the first step."
	var getNextOnboardingStep = exports.getNextOnboardingStep = function getNextOnboardingStep(currentStep, _ref) {
	  var hasGame = _ref.hasGame,
	      hasSurvey = _ref.hasSurvey,
	      onboardComplete = _ref.onboardComplete;
	
	  var skipPathChoice = onboardComplete;
	  var skipSimSelection = hasGame;
	  var skipSurvey = hasSurvey;
	
	  var isSkipped = function isSkipped(step) {
	    return step === 'path-choice' && skipPathChoice || step === 'simulation-selection' && skipSimSelection || step === 'team-evaluation-survey' && skipSurvey;
	  };
	
	  var currentIdx = currentStep ? ONBOARDING_STEPS.indexOf(currentStep) : -1;
	  var next = ONBOARDING_STEPS.find(function (step, idx) {
	    return idx > currentIdx && !isSkipped(step);
	  });
	
	  var resultUrl = !next ? '/instructor/welcome' : '/instructor/onboarding/' + next;
	  console.log('[MG:onboarding] getNextOnboardingStep:', {
	    currentStep: currentStep, hasGame: hasGame, hasSurvey: hasSurvey, onboardComplete: onboardComplete,
	    skipPathChoice: skipPathChoice, skipSimSelection: skipSimSelection, skipSurvey: skipSurvey,
	    next: next, resultUrl: resultUrl
	  });
	  return resultUrl;
	};
	
	// Kept as a no-op export so TeamEvaluationSurvey can still call it
	// without breaking. The old session cache went away when survey_row
	// counting was replaced with course.survey_included.
	var clearOnboardingSetupCache = exports.clearOnboardingSetupCache = function clearOnboardingSetupCache() {};
	
	// Fetch { hasGame, hasSurvey } for the current course. Both are
	// derived from general-info's cached payload:
	//   - hasGame   : any game in data.games tied to the current course
	//   - hasSurvey : the course's survey_included is "yes" or "no"
	//                 (null means instructor hasn't decided yet, so the
	//                 team-evaluation-survey step should still fire).
	//
	// Rejects when the network call fails. Do not swallow and fabricate
	// { hasGame: false, hasSurvey: false } here — resolveOnboardingEntry
	// treats that shape as "course has nothing set up" and would wrongly
	// redirect an already-onboarded instructor to the onboarding flow on
	// a transient failure (e.g. brief WiFi drop).
	var fetchOnboardingSetup = exports.fetchOnboardingSetup = function fetchOnboardingSetup() {
	  var courseId = Number(_Auth2.default.getCourseId());
	  var gameId = Number(_Auth2.default.getGameId());
	
	  return (0, _AppGeneralInfoService.fetchAppGeneralInfo)(gameId, 'instructor').then(function (data) {
	    var games = data && data.games || [];
	    var courses = data && data.courses || [];
	    var hasGame = games.some(function (g) {
	      return Number(g.course) === courseId;
	    });
	    var course = courses.find(function (c) {
	      return Number(c.id) === courseId;
	    });
	    var decision = course ? course.survey_included : null;
	    var hasSurvey = decision === 'yes' || decision === 'no';
	    return { hasGame: hasGame, hasSurvey: hasSurvey };
	  });
	};
	
	// Entry-point decision used by /start (start.js). Returns the URL
	// the instructor should be sent to, or null when they don't need
	// onboarding at all (fall through to existing welcome routing).
	var resolveOnboardingEntry = exports.resolveOnboardingEntry = function resolveOnboardingEntry() {
	  var user = _Auth2.default.getUser();
	  if (!user) return Promise.resolve(null);
	  var onboardComplete = user.onboard !== 0;
	
	  return fetchOnboardingSetup().then(function (_ref2) {
	    var hasGame = _ref2.hasGame,
	        hasSurvey = _ref2.hasSurvey;
	
	    if (!onboardComplete) {
	      // Bypass the full flow (intro + path-choice) when the course
	      // is already fully set up. Return null so start.js's
	      // continueInstructorRouting handles the landing, and so
	      // App.js's per-navigation gate doesn't yank the user back to
	      // /instructor/welcome on every left-nav click (that's what
	      // returning a URL here would do, since the App.js caller fires
	      // on every non-onboarding location change).
	      if (hasGame && hasSurvey) {
	        return null;
	      }
	      return getNextOnboardingStep(null, { hasGame: hasGame, hasSurvey: hasSurvey, onboardComplete: false });
	    }
	    if (!hasGame || !hasSurvey) {
	      return getNextOnboardingStep(null, { hasGame: hasGame, hasSurvey: hasSurvey, onboardComplete: true });
	    }
	    return null;
	  })
	  // Network / fetch failure: don't redirect. Returning null keeps
	  // the instructor on their current page instead of bouncing them
	  // into onboarding based on fabricated "nothing is set up" data.
	  // The next successful fetch (on the next navigation) will route
	  // correctly.
	  .catch(function () {
	    return null;
	  });
	};

/***/ },
/* 184 */
104,
/* 185 */
[2708, 219, 618, 422, 158],
/* 186 */
[2723, 619, 414],
/* 187 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(118);
	var call = __webpack_require__(640);
	var isArrayIter = __webpack_require__(434);
	var anObject = __webpack_require__(26);
	var toLength = __webpack_require__(48);
	var getIterFn = __webpack_require__(450);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 189 */
[2707, 26, 646, 430, 443, 429, 432],
/* 190 */
[2712, 648, 430],
/* 191 */
[2715, 648, 430],
/* 192 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(97);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(30);
	var dP = __webpack_require__(57);
	var DESCRIPTORS = __webpack_require__(51);
	var SPECIES = __webpack_require__(44)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 195 */
[2722, 120],
/* 196 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1948),
	    getValue = __webpack_require__(1992);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(37),
	    isLength = __webpack_require__(484);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(717),
	    isArray = __webpack_require__(40);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 201 */
[2745, 58],
/* 202 */
[2761, 58, 203],
/* 203 */
[2788, 286],
/* 204 */
[2798, 34],
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(2347);
	var ReactInstrumentation = __webpack_require__(111);
	
	var warning = __webpack_require__(39);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactBaseClasses = __webpack_require__(1003);
	var ReactChildren = __webpack_require__(2415);
	var ReactDOMFactories = __webpack_require__(2416);
	var ReactElement = __webpack_require__(245);
	var ReactPropTypes = __webpack_require__(2417);
	var ReactVersion = __webpack_require__(2418);
	
	var createReactClass = __webpack_require__(2419);
	var onlyChild = __webpack_require__(2423);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reduceCssCalc = _interopRequireDefault(__webpack_require__(2528));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DOMUtils = __webpack_require__(382);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return {
	        word: word,
	        width: (0, _DOMUtils.getStringSize)(word, props.style).width
	      };
	    });
	    var spaceWidth = (0, _DOMUtils.getStringSize)("\xA0", props.style).width;
	    return {
	      wordsWithComputedWidth: wordsWithComputedWidth,
	      spaceWidth: spaceWidth
	    };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text(_props) {
	    var _this;
	
	    _classCallCheck(this, Text);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, _props));
	
	    _this.getWordsWithoutCalculate = function (props) {
	      var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      return [{
	        words: words
	      }];
	    };
	
	    _this.state = {
	      wordsByLines: _this.getWordsByLines(_props, true)
	    };
	    return _this;
	  }
	
	  _createClass(Text, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.width !== this.props.width || prevProps.scaleToFit !== this.props.scaleToFit || prevProps.children !== this.props.children || prevProps.style !== this.props.style) {
	        var needCalculate = this.props.children !== prevProps.children || this.props.style !== prevProps.style;
	        this.updateWordsByLines(this.props, needCalculate);
	      }
	    }
	  }, {
	    key: "updateWordsByLines",
	    value: function updateWordsByLines(props, needCalculate) {
	      this.setState({
	        wordsByLines: this.getWordsByLines(props, needCalculate)
	      });
	    }
	  }, {
	    key: "getWordsByLines",
	    value: function getWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            return this.getWordsWithoutCalculate(props);
	          }
	        }
	
	        return this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	      }
	
	      return this.getWordsWithoutCalculate(props);
	    }
	  }, {
	    key: "calculateWordsByLines",
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
	        var word = _ref.word,
	            width = _ref.width;
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = {
	            words: [word],
	            width: width
	          };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          dx = _this$props.dx,
	          dy = _this$props.dy,
	          textAnchor = _this$props.textAnchor,
	          verticalAnchor = _this$props.verticalAnchor,
	          scaleToFit = _this$props.scaleToFit,
	          angle = _this$props.angle,
	          lineHeight = _this$props.lineHeight,
	          capHeight = _this$props.capHeight,
	          className = _this$props.className,
	          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);
	
	      var wordsByLines = this.state.wordsByLines;
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	      var startDy;
	
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(capHeight, ")"));
	          break;
	
	        case 'middle':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
	          break;
	
	        default:
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
	          break;
	      }
	
	      var transforms = [];
	
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
	      }
	
	      if (angle) {
	        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
	      }
	
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react["default"].createElement("text", _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), (0, _ReactUtils.filterEventAttributes)(textProps), {
	        x: x,
	        y: y,
	        className: (0, _classnames["default"])('recharts-text', className),
	        textAnchor: textAnchor
	      }), wordsByLines.map(function (line, index) {
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement("tspan", {
	            x: x,
	            dy: index === 0 ? startDy : lineHeight,
	            key: index
	          }, line.words.join(' '))
	        );
	      }));
	    }
	  }]);
	
	  return Text;
	}(_react.Component);
	
	Text.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes["default"].bool,
	  angle: _propTypes["default"].number,
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end']),
	  style: _propTypes["default"].object
	});
	Text.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em',
	  // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	
	};
	var _default = Text;
	exports["default"] = _default;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Dot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Dot, _PureComponent);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          r = _this$props.r,
	          className = _this$props.className;
	      var layerClass = (0, _classnames["default"])('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react["default"].createElement("circle", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.PureComponent);
	
	Dot.displayName = 'Dot';
	Dot.propTypes = {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  r: _propTypes["default"].number
	};
	var _default = Dot;
	exports["default"] = _default;

/***/ },
/* 209 */
[2768, 103, 1023],
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/LandingPageLogo.b04b44ef.png";

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DivFormula = function DivFormula(_ref) {
	  var name1 = _ref.name1,
	      name2 = _ref.name2,
	      name3 = _ref.name3,
	      _ref$sm = _ref.sm,
	      sm = _ref$sm === undefined ? false : _ref$sm;
	  return _react2.default.createElement(
	    "div",
	    { style: Object.assign({}, _styles.dFlex, (0, _styles.formulaStyle)(sm), { alignItems: "center" }) },
	    name1,
	    " =",
	    _react2.default.createElement(
	      "div",
	      { style: _styles.division },
	      name2,
	      _react2.default.createElement("hr", {
	        style: { height: "1px", backgroundColor: "#8F8F8F", width: "100%" }
	      }),
	      name3
	    )
	  );
	};
	
	exports.default = DivFormula;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Footnote = exports.Pill = exports.Table = exports.SectionTitle = exports.Section = exports.ExplainerList = exports.ExplainerBody = exports.ExplainerTitle = exports.ExplainerCard = exports.Subtitle = exports.Title = exports.Header = exports.Container = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 4px 8px;\n  color: #1F2937;\n  font-family: \'Mukta Vaani\', \'Inter\', sans-serif;\n'], ['\n  padding: 4px 8px;\n  color: #1F2937;\n  font-family: \'Mukta Vaani\', \'Inter\', sans-serif;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding-bottom: 20px;\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 24px;\n'], ['\n  padding-bottom: 20px;\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 24px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.01em;\n'], ['\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.01em;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-size: 16px;\n  color: #6B7280;\n  line-height: 1.5;\n'], ['\n  margin: 0;\n  font-size: 16px;\n  color: #6B7280;\n  line-height: 1.5;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: #EEF2FF;\n  border: 1px solid #C7D2FE;\n  border-radius: 12px;\n  padding: 18px 22px;\n  margin-bottom: 28px;\n'], ['\n  background: #EEF2FF;\n  border: 1px solid #C7D2FE;\n  border-radius: 12px;\n  padding: 18px 22px;\n  margin-bottom: 28px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: 700;\n  color: #3730A3;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n'], ['\n  font-size: 14px;\n  font-weight: 700;\n  color: #3730A3;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 1.6;\n  color: #1F2937;\n\n  code {\n    background: rgba(79, 70, 229, 0.12);\n    color: #3730A3;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 15px;\n    font-family: ui-monospace, \'SF Mono\', monospace;\n    font-weight: 600;\n  }\n'], ['\n  font-size: 16px;\n  line-height: 1.6;\n  color: #1F2937;\n\n  code {\n    background: rgba(79, 70, 229, 0.12);\n    color: #3730A3;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 15px;\n    font-family: ui-monospace, \'SF Mono\', monospace;\n    font-weight: 600;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  margin: 10px 0 0;\n  padding-left: 20px;\n  font-size: 16px;\n  line-height: 1.7;\n  color: #1F2937;\n'], ['\n  margin: 10px 0 0;\n  padding-left: 20px;\n  font-size: 16px;\n  line-height: 1.7;\n  color: #1F2937;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-bottom: 28px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  margin-bottom: 28px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  margin: 0 0 12px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.005em;\n'], ['\n  margin: 0 0 12px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.005em;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  overflow: hidden;\n  font-size: 16px;\n\n  thead {\n    background: #F9FAFB;\n  }\n\n  th, td {\n    padding: 12px 16px;\n    border-bottom: 1px solid #F3F4F6;\n    text-align: left;\n    color: #1F2937;\n    vertical-align: middle;\n  }\n\n  th {\n    font-size: 13.5px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #6B7280;\n  }\n\n  tbody tr:last-child td {\n    border-bottom: none;\n  }\n\n  tbody tr:hover {\n    background: #F9FAFB;\n  }\n\n  tbody tr.highlight {\n    background: #FEF3C7;\n    font-weight: 600;\n  }\n\n  tbody tr.highlight:hover {\n    background: #FEF3C7;\n  }\n\n  tbody td.numeric {\n    font-variant-numeric: tabular-nums;\n    font-weight: 500;\n  }\n'], ['\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  overflow: hidden;\n  font-size: 16px;\n\n  thead {\n    background: #F9FAFB;\n  }\n\n  th, td {\n    padding: 12px 16px;\n    border-bottom: 1px solid #F3F4F6;\n    text-align: left;\n    color: #1F2937;\n    vertical-align: middle;\n  }\n\n  th {\n    font-size: 13.5px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #6B7280;\n  }\n\n  tbody tr:last-child td {\n    border-bottom: none;\n  }\n\n  tbody tr:hover {\n    background: #F9FAFB;\n  }\n\n  tbody tr.highlight {\n    background: #FEF3C7;\n    font-weight: 600;\n  }\n\n  tbody tr.highlight:hover {\n    background: #FEF3C7;\n  }\n\n  tbody td.numeric {\n    font-variant-numeric: tabular-nums;\n    font-weight: 500;\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  background: ', ';\n  color: ', ';\n'], ['\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  background: ', ';\n  color: ', ';\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  margin: 12px 4px 0;\n  font-size: 14.5px;\n  color: #6B7280;\n  line-height: 1.5;\n'], ['\n  margin: 12px 4px 0;\n  font-size: 14.5px;\n  color: #6B7280;\n  line-height: 1.5;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = exports.Container = _styledComponents2.default.div(_templateObject);
	
	var Header = exports.Header = _styledComponents2.default.div(_templateObject2);
	
	var Title = exports.Title = _styledComponents2.default.h2(_templateObject3);
	
	var Subtitle = exports.Subtitle = _styledComponents2.default.p(_templateObject4);
	
	var ExplainerCard = exports.ExplainerCard = _styledComponents2.default.div(_templateObject5);
	
	var ExplainerTitle = exports.ExplainerTitle = _styledComponents2.default.div(_templateObject6);
	
	var ExplainerBody = exports.ExplainerBody = _styledComponents2.default.div(_templateObject7);
	
	var ExplainerList = exports.ExplainerList = _styledComponents2.default.ul(_templateObject8);
	
	var Section = exports.Section = _styledComponents2.default.div(_templateObject9);
	
	var SectionTitle = exports.SectionTitle = _styledComponents2.default.h3(_templateObject10);
	
	var Table = exports.Table = _styledComponents2.default.table(_templateObject11);
	
	var Pill = exports.Pill = _styledComponents2.default.span(_templateObject12, function (p) {
	  return p.variant === 'investment' ? '#ECFDF5' : p.variant === 'high-yield' ? '#FEF3C7' : '#EEF2FF';
	}, function (p) {
	  return p.variant === 'investment' ? '#047857' : p.variant === 'high-yield' ? '#92400E' : '#3730A3';
	});
	
	var Footnote = exports.Footnote = _styledComponents2.default.p(_templateObject13);

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatNumber(val, precision) {
	  return val.toFixed(precision);
	}
	
	function CustomLabel(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      value = _ref.value,
	      prefix = _ref.prefix,
	      suffix = _ref.suffix,
	      precision = _ref.precision,
	      _ref$layout = _ref.layout,
	      layout = _ref$layout === undefined ? "horizontal" : _ref$layout,
	      _ref$xOffset = _ref.xOffset,
	      xOffset = _ref$xOffset === undefined ? 30 : _ref$xOffset,
	      _ref$hideZero = _ref.hideZero,
	      hideZero = _ref$hideZero === undefined ? false : _ref$hideZero,
	      _ref$showIntegerLabel = _ref.showIntegerLabel,
	      showIntegerLabel = _ref$showIntegerLabel === undefined ? false : _ref$showIntegerLabel;
	
	  var xxOffset = layout === "horizontal" ? x + width / 2 : value < 0 ? x + width - xOffset : x + width + xOffset;
	  var yOffset = layout === "vertical" ? y + height / 2 : value < 0 ? y + 10 : y - 10;
	  var className = value < 0 ? "red" : null;
	  var val = hideZero === true && value === 0 ? "n/a" : showIntegerLabel ? Math.round(value) : "" + prefix + formatNumber(value, precision) + suffix;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: xxOffset,
	      y: yOffset,
	      className: className,
	      textAnchor: "middle",
	      dominantBaseline: "middle"
	    },
	    val
	  );
	}
	
	exports.default = CustomLabel;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _customLabel = __webpack_require__(213);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	var _tooltipContent = __webpack_require__(398);
	
	var _tooltipContent2 = _interopRequireDefault(_tooltipContent);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HorizontalBar(_ref) {
	  var _ref$prefix = _ref.prefix,
	      prefix = _ref$prefix === undefined ? "" : _ref$prefix,
	      _ref$suffix = _ref.suffix,
	      suffix = _ref$suffix === undefined ? "" : _ref$suffix,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? 2 : _ref$precision,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data,
	      _ref$barSize = _ref.barSize,
	      barSize = _ref$barSize === undefined ? 18 : _ref$barSize;
	
	  var colors = _Teams2.default.competitiveColors();
	
	  return _react2.default.createElement(
	    _recharts.ResponsiveContainer,
	    { width: "100%", height: 200 },
	    _react2.default.createElement(
	      _recharts.BarChart,
	      { data: data, barSize: barSize },
	      _react2.default.createElement(_recharts.XAxis, { dataKey: "name", tickLine: false, tick: false }),
	      _react2.default.createElement(_recharts.YAxis, { domain: [function (dataMin) {
	          return 0;
	        }, function (dataMax) {
	          return dataMax * 1.5;
	        }], hide: true }),
	      _react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(_tooltipContent2.default, { prefix: prefix, suffix: suffix }) }),
	      _react2.default.createElement(
	        _recharts.Bar,
	        {
	          dataKey: "value",
	          minPointSize: 5,
	          label: _react2.default.createElement(_customLabel2.default, {
	            prefix: prefix,
	            suffix: suffix,
	            precision: precision
	          })
	        },
	        colors.map(function (color, i) {
	          return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	        })
	      )
	    )
	  );
	}
	
	exports.default = HorizontalBar;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Goal = function Goal(_ref) {
	  var name = _ref.name,
	      checked = _ref.checked;
	  return _react2.default.createElement(
	    "label",
	    { className: "team-decision-label" },
	    _react2.default.createElement("span", {
	      className: (0, _classnames2.default)("status", {
	        status_complete: checked,
	        status_incomplete: !checked
	      })
	    }),
	    _react2.default.createElement(
	      "p",
	      null,
	      name
	    )
	  );
	};
	
	exports.default = Goal;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 16px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #ffffff;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  padding: 16px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #ffffff;\n\n  ', '\n\n  ', '\n\n  ', '\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FormulaName = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.background && '\n    background-color: ' + p.background + ';\n  ';
	}, function (p) {
	  return p.padding && '\n    padding: ' + p.padding + ';\n  ';
	}, function (p) {
	  return p.color && '\n    color: ' + p.color + ';\n  ';
	});
	
	exports.default = FormulaName;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  span.divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n\n  b, .negative-value {\n    color: #EC5E59;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  span.divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n\n  b, .negative-value {\n    color: #EC5E59;\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FormulaValue = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.fontSize && '\n    font-size: ' + p.fontSize + ';\n  ';
	});
	
	exports.default = FormulaValue;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1568), __esModule: true };

/***/ },
/* 219 */
[2687, 221],
/* 220 */
[2695, 185, 268, 158],
/* 221 */
33,
/* 222 */
[2689, 116, 44],
/* 223 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 224 */
[2718, 57, 104, 44],
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var defined = __webpack_require__(129);
	var fails = __webpack_require__(31);
	var spaces = __webpack_require__(446);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(164));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(167);
	
	var _Actions = __webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(108);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(708),
	    baseKeys = __webpack_require__(1951),
	    isArrayLike = __webpack_require__(199);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(471),
	    baseOrderBy = __webpack_require__(717),
	    baseRest = __webpack_require__(718),
	    isIterateeCall = __webpack_require__(343);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 236 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 237 */
[2770, 509],
/* 238 */
[2772, 134, 907, 922, 144, 510],
/* 239 */
[2785, 284, 286],
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(518);
	var setInnerHTML = __webpack_require__(373);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(526);
	var setTextContent = __webpack_require__(981);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(227);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactCurrentOwner = __webpack_require__(148);
	
	var warning = __webpack_require__(39);
	var canDefineProperty = __webpack_require__(1007);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(1005);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var XAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(XAxis, _PureComponent);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.PureComponent);
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes["default"].number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['top', 'bottom']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  padding: _propTypes["default"].shape({
	    left: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	XAxis.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: {
	    left: 0,
	    right: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	};
	var _default = XAxis;
	exports["default"] = _default;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var YAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(YAxis, _PureComponent);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.PureComponent);
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes["default"].number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['left', 'right']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    bottom: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	YAxis.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: {
	    top: 0,
	    bottom: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	};
	var _default = YAxis;
	exports["default"] = _default;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ReactUtils = __webpack_require__(28);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	var _default = Cell;
	exports["default"] = _default;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _d3Shape = __webpack_require__(556);
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed,
	  curveBasisOpen: _d3Shape.curveBasisOpen,
	  curveBasis: _d3Shape.curveBasis,
	  curveLinearClosed: _d3Shape.curveLinearClosed,
	  curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX,
	  curveMonotoneY: _d3Shape.curveMonotoneY,
	  curveNatural: _d3Shape.curveNatural,
	  curveStep: _d3Shape.curveStep,
	  curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	
	var getX = function getX(p) {
	  return p.x;
	};
	
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction2["default"])(type)) {
	    return type;
	  }
	
	  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
	  }
	
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Curve, _PureComponent);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine,
	          layout = _this$props.layout,
	          connectNulls = _this$props.connectNulls;
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction;
	
	      if ((0, _isArray2["default"])(baseLine)) {
	        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
	          return defined(base);
	        }) : baseLine;
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _objectSpread({}, entry, {
	            base: formatBaseLine[index]
	          });
	        });
	
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	
	        lineFunction.defined(defined).curve(curveFactory);
	        return lineFunction(areaPoints);
	      }
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          points = _this$props2.points,
	          path = _this$props2.path,
	          pathRef = _this$props2.pathRef;
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames["default"])('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.PureComponent);
	
	Curve.displayName = 'Curve';
	Curve.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  connectNulls: _propTypes["default"].bool,
	  path: _propTypes["default"].string,
	  pathRef: _propTypes["default"].func
	});
	Curve.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	};
	var _default = Curve;
	exports["default"] = _default;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var ySign = height >= 0 ? 1 : -1;
	  var xSign = width >= 0 ? 1 : -1;
	  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
	  var path;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
	    }
	
	    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
	
	    if (newRadius[1] > 0) {
	      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
	    }
	
	    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
	    }
	
	    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
	
	    if (newRadius[3] > 0) {
	      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
	    }
	
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
	  } else {
	    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
	  }
	
	  return path;
	};
	
	var Rectangle =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Rectangle, _PureComponent);
	
	  function Rectangle() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Rectangle, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          radius = _this$props.radius,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isAnimationActive = _this$props2.isAnimationActive,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currWidth = _ref.width,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Rectangle;
	}(_react.PureComponent);
	
	Rectangle.displayName = 'Rectangle';
	Rectangle.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Rectangle.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Rectangle;
	exports["default"] = _default;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = void 0;
	
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 252 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgB5ZA9DkAwGIbfT2MwcAAkrsFsZXVRjuAUFolwAgmLhKpFpNV25UmaJm3e5/sBfkKU5eJIcLThMC0BqgDmyb5JGyan4HVqTG1jJzAIqwWG4RP5DshdxL1v7yNymPR1HnoEydlfCT8izGNnJ7gknYlELXhKgnjlkt5OcJeAbWK073EABPEq2TmEBXQAAAAASUVORK5CYII="

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n'], ['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n'], ['\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 3000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 3000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  background: #FFFFFF;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 32px 28px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: ', ';\n  color: #0F172A;\n  animation: ', ' 250ms ease both;\n  text-align: left;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  position: relative;\n  background: #FFFFFF;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 32px 28px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: ', ';\n  color: #0F172A;\n  animation: ', ' 250ms ease both;\n  text-align: left;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  background: transparent;\n  border: 0;\n  padding: 4px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n'], ['\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  background: transparent;\n  border: 0;\n  padding: 4px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #DCFCE7;\n  color: #15803D;\n  font-size: 22px;\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #DCFCE7;\n  color: #15803D;\n  font-size: 22px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-family: ', ';\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n'], ['\n  margin: 0;\n  font-family: ', ';\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin: 0 0 24px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n'], ['\n  margin: 0 0 24px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  padding: 12px 22px;\n  border: 0;\n  border-radius: 10px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-family: ', ';\n  font-weight: 700;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 150ms ease;\n\n  &:hover {\n    background: #1D4ED8;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  padding: 12px 22px;\n  border: 0;\n  border-radius: 10px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-family: ', ';\n  font-weight: 700;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 150ms ease;\n\n  &:hover {\n    background: #1D4ED8;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Shared celebratory modal shown after a student makes a role's first
	// decision (Round 1 only). Reinforces that more decisions are needed
	// and offers a primary CTA that jumps them to the next action.
	//
	// Consumers own the trigger logic (i.e. deciding it's Round 1 + no
	// prior decision) — this component just renders when `open` is true
	// and calls back on CTA / dismiss.
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	var fadeIn = (0, _styledComponents.keyframes)(_templateObject);
	
	var fadeUp = (0, _styledComponents.keyframes)(_templateObject2);
	
	var Styled = {};
	
	Styled.Backdrop = _styledComponents2.default.div(_templateObject3, fadeIn);
	
	Styled.Card = _styledComponents2.default.div(_templateObject4, FONT, fadeUp);
	
	Styled.CloseButton = _styledComponents2.default.button(_templateObject5);
	
	Styled.IconRow = _styledComponents2.default.div(_templateObject6);
	
	Styled.CelebrateIcon = _styledComponents2.default.span(_templateObject7);
	
	Styled.Title = _styledComponents2.default.h2(_templateObject8, FONT);
	
	Styled.Body = _styledComponents2.default.p(_templateObject9);
	
	Styled.ActionRow = _styledComponents2.default.div(_templateObject10);
	
	Styled.CtaButton = _styledComponents2.default.button(_templateObject11, FONT);
	
	var FirstDecisionModal = function (_PureComponent) {
	  _inherits(FirstDecisionModal, _PureComponent);
	
	  function FirstDecisionModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FirstDecisionModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirstDecisionModal.__proto__ || Object.getPrototypeOf(FirstDecisionModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeydown = function (e) {
	      if (e.key === 'Escape' && _this.props.open) {
	        _this.handleClose();
	      }
	    }, _this.handleBackdropClick = function () {
	      _this.handleClose();
	    }, _this.handleCardClick = function (e) {
	      e.stopPropagation();
	    }, _this.handleClose = function () {
	      if (_this.props.onClose) _this.props.onClose();
	    }, _this.handleCta = function () {
	      if (_this.props.onCta) _this.props.onCta();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FirstDecisionModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof window !== 'undefined') {
	        window.addEventListener('keydown', this.handleKeydown);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('keydown', this.handleKeydown);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          title = _props.title,
	          body = _props.body,
	          ctaLabel = _props.ctaLabel;
	
	      if (!open) return null;
	      return _react2.default.createElement(
	        Styled.Backdrop,
	        {
	          role: 'dialog',
	          'aria-modal': 'true',
	          onClick: this.handleBackdropClick
	        },
	        _react2.default.createElement(
	          Styled.Card,
	          { onClick: this.handleCardClick },
	          _react2.default.createElement(
	            Styled.CloseButton,
	            {
	              type: 'button',
	              onClick: this.handleClose,
	              'aria-label': 'Close'
	            },
	            '\xD7'
	          ),
	          title ? _react2.default.createElement(
	            Styled.IconRow,
	            null,
	            _react2.default.createElement(
	              Styled.CelebrateIcon,
	              { 'aria-hidden': 'true' },
	              '\uD83C\uDF89'
	            ),
	            _react2.default.createElement(
	              Styled.Title,
	              null,
	              title
	            )
	          ) : _react2.default.createElement(
	            Styled.IconRow,
	            null,
	            _react2.default.createElement(
	              Styled.CelebrateIcon,
	              { 'aria-hidden': 'true' },
	              '\uD83C\uDF89'
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Body,
	            null,
	            body
	          ),
	          _react2.default.createElement(
	            Styled.ActionRow,
	            null,
	            _react2.default.createElement(
	              Styled.CtaButton,
	              { type: 'button', onClick: this.handleCta },
	              ctaLabel
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FirstDecisionModal;
	}(_react.PureComponent);
	
	exports.default = FirstDecisionModal;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LastStepModal = function (_PureComponent) {
	  _inherits(LastStepModal, _PureComponent);
	
	  function LastStepModal() {
	    _classCallCheck(this, LastStepModal);
	
	    return _possibleConstructorReturn(this, (LastStepModal.__proto__ || Object.getPrototypeOf(LastStepModal)).apply(this, arguments));
	  }
	
	  _createClass(LastStepModal, [{
	    key: "render",
	    value: function render() {
	      var isMobile = (0, _utils.detectMobile)();
	      var _props = this.props,
	          location = _props.location,
	          router = _props.router,
	          url = _props.url;
	
	      var isShown = location.query.from === 'get-started' || false;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: isShown,
	          onHide: function onHide() {},
	          dialogClassName: "getStarterModal getStartedModalSmall feedback-modal",
	          backdrop: "static",
	          backdropClassName: "feedback-backdrop"
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "p",
	            { className: "steps__text" },
	            "This is the page where you\u2019ll make your decisions for this round."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "steps__text" },
	            "To get started on this exercise, please click on the red \u201CExplainer\u201D button after you\u2019ve clicked on the Close\u201D button below."
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "feedback-button" },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: "primary",
	                bsSize: isMobile === true ? "md" : "lg",
	                onClick: function onClick() {
	                  router.push(url);
	                }
	              },
	              "Close",
	              _react2.default.createElement("span", null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LastStepModal;
	}(_react.PureComponent);
	
	exports.default = LastStepModal;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: #fafafa;\n  padding: 40px 40px 0;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"], ["\n  background: #fafafa;\n  padding: 40px 40px 0;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  padding-right: 20px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  padding-right: 20px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-top: 4px;\n  margin-bottom: 12px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-top: 4px;\n  margin-bottom: 12px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 23px;\n  width: 148px;\n  line-height: 23px;\n  text-align: center;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n\n  .fa-spinner,\n  .fa-check {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  display: inline-block;\n  height: 23px;\n  width: 148px;\n  line-height: 23px;\n  text-align: center;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n\n  .fa-spinner,\n  .fa-check {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  margin-top: 40px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 20px;\n  max-width: 1200px;\n"], ["\n  margin-top: 40px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 20px;\n  max-width: 1200px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-bottom: 1px solid #d5d9dd;\n  position: relative;\n\n  img {\n    width: 100%;\n  }\n"], ["\n  width: 100%;\n  border-bottom: 1px solid #d5d9dd;\n  position: relative;\n\n  img {\n    width: 100%;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n  background: #ffffff;\n  border: 1.5px solid #5c91f5;\n  border-radius: 100px;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 10px;\n  color: #5c91f5;\n  cursor: default;\n\n  ", "\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  // x/y anchor the CENTER of the dot (not its top-left corner). This\n  // matches the intuition of \"the dot sits at this point on the map\".\n  transform: translate(-50%, -50%);\n\n  ", "\n\n  ", "\n  \n  ", "\n\n  ", "\n"], ["\n  width: 20px;\n  height: 20px;\n  background: #ffffff;\n  border: 1.5px solid #5c91f5;\n  border-radius: 100px;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 10px;\n  color: #5c91f5;\n  cursor: default;\n\n  ", "\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  // x/y anchor the CENTER of the dot (not its top-left corner). This\n  // matches the intuition of \"the dot sits at this point on the map\".\n  transform: translate(-50%, -50%);\n\n  ", "\n\n  ", "\n  \n  ", "\n\n  ", "\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 7px;\n\n  margin-top: 4px;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 7px;\n\n  margin-top: 4px;\n\n  ", "\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  flex: 1;\n  background: rgba(0, 27, 43, 0.02);\n  border-radius: 2px;\n  padding: 2px;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ", "\n"], ["\n  flex: 1;\n  background: rgba(0, 27, 43, 0.02);\n  border-radius: 2px;\n  padding: 2px;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ", "\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"], ["\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  height: 40px;\n  outline: none;\n  cursor: pointer;\n  border: 1.5px solid #5C91F5;\n  border-radius: 4px;\n  text-align: center;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 40px;\n  color: #5c91f5;\n"], ["\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  height: 40px;\n  outline: none;\n  cursor: pointer;\n  border: 1.5px solid #5C91F5;\n  border-radius: 4px;\n  text-align: center;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 40px;\n  color: #5c91f5;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  height: 40px;\n  outline: none;\n  cursor: pointer;\n  background: #5c91f5;\n  border-radius: 4px;\n  text-align: center;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 40px;\n  color: #ffffff;\n\n  &:disabled, &[disabled] {\n    background: #d5d9dd;\n    cursor: pointer;\n  }\n"], ["\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  height: 40px;\n  outline: none;\n  cursor: pointer;\n  background: #5c91f5;\n  border-radius: 4px;\n  text-align: center;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 40px;\n  color: #ffffff;\n\n  &:disabled, &[disabled] {\n    background: #d5d9dd;\n    cursor: pointer;\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n\n  margin-top: 10px;\n\n  span {\n    color: red;\n  }\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n\n  margin-top: 10px;\n\n  span {\n    color: red;\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 240px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08), 0px 6px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 4px;\n  display: none;\n  z-index: 100;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  width: 240px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08), 0px 6px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 4px;\n  display: none;\n  z-index: 100;\n\n  ", "\n\n  ", "\n\n  ", "\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  img {\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n  }\n\n  span {\n    width: 24px;\n    height: 24px;\n    background: #5c91f5;\n    border-radius: 100px;\n    display: inline-block;\n    margin-right: 4px;\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 11px;\n    line-height: 24px;\n    color: #ffffff;\n  }\n\n  padding: 8px 0;\n\n  ", "\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  img {\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n  }\n\n  span {\n    width: 24px;\n    height: 24px;\n    background: #5c91f5;\n    border-radius: 100px;\n    display: inline-block;\n    margin-right: 4px;\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 11px;\n    line-height: 24px;\n    color: #ffffff;\n  }\n\n  padding: 8px 0;\n\n  ", "\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  padding: 8px 16px;\n\n  span {\n    color: #5c91f5;\n  }\n\n  ", "\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  padding: 8px 16px;\n\n  span {\n    color: #5c91f5;\n  }\n\n  ", "\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  img {\n    width: 100%;\n  }\n"], ["\n  img {\n    width: 100%;\n  }\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  padding: 8px 16px 16px;\n"], ["\n  padding: 8px 16px 16px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  text-align: center;\n  height: 32px;\n  border-radius: 4px;\n  background: #2a4169;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 32px;\n  color: #ffffff;\n"], ["\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  text-align: center;\n  height: 32px;\n  border-radius: 4px;\n  background: #2a4169;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 32px;\n  color: #ffffff;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  cursor: default;\n\n  img {\n    width: 30px;\n    height: 30px;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  width: 30px;\n  height: 30px;\n  cursor: default;\n\n  img {\n    width: 30px;\n    height: 30px;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 8px;\n"], ["\n    width: 100%;\n    height: 8px;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 36px;\n  background: #fafafa;\n  border-bottom: 1px solid #d5d9dd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #5c91f5;\n"], ["\n  width: 100%;\n  height: 36px;\n  background: #fafafa;\n  border-bottom: 1px solid #d5d9dd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #5c91f5;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  max-width: 880px;\n  margin-top: 20px;\n  margin-bottom: -10px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  max-width: 880px;\n  margin-top: 20px;\n  margin-bottom: -10px;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  padding: 20px;\n\n  ", "\n"], ["\n  padding: 20px;\n\n  ", "\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 16px;\n\n  img {\n    // margin-left: 8px;\n    position: relative;\n    top: -1px;\n  }\n\n  ", "\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 16px;\n\n  img {\n    // margin-left: 8px;\n    position: relative;\n    top: -1px;\n  }\n\n  ", "\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  margin-right: 8px;\n  width: 18px;\n  height: 18px;\n"], ["\n  margin-right: 8px;\n  width: 18px;\n  height: 18px;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"], ["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  flex: 1;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 4px;\n  flex: 0 0 50%;\n  width: 50%;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  flex: 1;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 4px;\n  flex: 0 0 50%;\n  width: 50%;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  display: block;\n  padding: 7px 10px !important;\n  min-width: auto !important;\n  border-color: transparent !important;\n  width: auto !important;\n  height: auto !important;\n  line-height: 27px !important;\n  background-color: #2f4066 !important;\n  font-family: 'Mukta Vaani' !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  color: #ffffff !important;\n  border-radius: 2px !important;\n  transition: background-color 0.5s ease;\n  letter-spacing: 0.02em !important;\n\n  &:hover {\n    background-color: #55b4bc !important;\n  }\n\n  &:disabled {\n    background-color: #dadada !important;\n    color: #969696 !important;\n  }\n\n  &.active {\n    background-color: #55b4bc !important;\n  }\n"], ["\n  display: block;\n  padding: 7px 10px !important;\n  min-width: auto !important;\n  border-color: transparent !important;\n  width: auto !important;\n  height: auto !important;\n  line-height: 27px !important;\n  background-color: #2f4066 !important;\n  font-family: 'Mukta Vaani' !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  color: #ffffff !important;\n  border-radius: 2px !important;\n  transition: background-color 0.5s ease;\n  letter-spacing: 0.02em !important;\n\n  &:hover {\n    background-color: #55b4bc !important;\n  }\n\n  &:disabled {\n    background-color: #dadada !important;\n    color: #969696 !important;\n  }\n\n  &.active {\n    background-color: #55b4bc !important;\n  }\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  margin-right: 20px;\n"], ["\n  margin-left: 20px;\n  margin-right: 20px;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding-right: 12px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding-right: 12px;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  background: #5c91f5;\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #ffffff;\n"], ["\n  background: #5c91f5;\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #ffffff;\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  background: ", ";\n"], ["\n  background: ", ";\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  margin-top: 35px;\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #000;\n  width: 100%;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n\n  ", "\n"], ["\n  margin-top: 35px;\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #000;\n  width: 100%;\n\n  .fa {\n    font-size: 16px !important;\n    color: #8894a7 !important;\n  }\n\n  ", "\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  flex: 0 0 340px;\n  margin-top: 10px;\n"], ["\n  flex: 0 0 340px;\n  margin-top: 10px;\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  padding-left: 20px;\n"], ["\n  padding-left: 20px;\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #000000;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #000000;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n"]),
	    _templateObject43 = _taggedTemplateLiteral(["\n  width: 15px;\n  height: 15px;\n  flex: 0 0 15px;\n  ", ";\n  margin-right: 13px;\n  content: \"\";\n  border-radius: 15px;\n"], ["\n  width: 15px;\n  height: 15px;\n  flex: 0 0 15px;\n  ", ";\n  margin-right: 13px;\n  content: \"\";\n  border-radius: 15px;\n"]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  margin-top: 35px;\n"], ["\n  margin-top: 35px;\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 17px;\n  color: #000;\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  table {\n    width: 100%;\n    border: 0;\n    border-collapse: separate;\n\n    thead {\n      border: 0;\n\n      tr {\n        th {\n          padding: 12px 13px;\n          font-family: Lato;\n          font-size: 14px;\n          line-height: 17px;\n          text-align: center;\n          color: #74abec;\n          border-bottom: 1px solid #626262;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-top: 9px solid #fff;\n          font-family: Lato;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 17px;\n          color: #000000;\n          text-align: center;\n          padding: 2px 0;\n\n          ", "\n          .remove-operation {\n            line-height: 25px;\n            top: 0;\n          }\n        }\n\n        &:first-child {\n          td {\n            border-top: 12px solid #fff;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  table {\n    width: 100%;\n    border: 0;\n    border-collapse: separate;\n\n    thead {\n      border: 0;\n\n      tr {\n        th {\n          padding: 12px 13px;\n          font-family: Lato;\n          font-size: 14px;\n          line-height: 17px;\n          text-align: center;\n          color: #74abec;\n          border-bottom: 1px solid #626262;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-top: 9px solid #fff;\n          font-family: Lato;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 17px;\n          color: #000000;\n          text-align: center;\n          padding: 2px 0;\n\n          ", "\n          .remove-operation {\n            line-height: 25px;\n            top: 0;\n          }\n        }\n\n        &:first-child {\n          td {\n            border-top: 12px solid #fff;\n          }\n        }\n      }\n    }\n  }\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  margin-top: 15px;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  color: #000;\n  text-align: center;\n  max-width: 120px;\n"], ["\n  margin-top: 15px;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  color: #000;\n  text-align: center;\n  max-width: 120px;\n"]),
	    _templateObject48 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  cursor: crosshair;\n  background: rgba(255, 0, 0, 0.04);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  cursor: crosshair;\n  background: rgba(255, 0, 0, 0.04);\n"]),
	    _templateObject49 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  z-index: 1001;\n  background: #d34c4c;\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 11px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  z-index: 1001;\n  background: #d34c4c;\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 11px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  pointer-events: none;\n"]),
	    _templateObject50 = _taggedTemplateLiteral(["\n  position: absolute;\n  background: #000;\n  color: #fff;\n  padding: 2px 6px;\n  font-family: monospace;\n  font-size: 11px;\n  border-radius: 3px;\n  pointer-events: none;\n  white-space: nowrap;\n  top: ", "px;\n  left: ", "px;\n"], ["\n  position: absolute;\n  background: #000;\n  color: #fff;\n  padding: 2px 6px;\n  font-family: monospace;\n  font-size: 11px;\n  border-radius: 3px;\n  pointer-events: none;\n  white-space: nowrap;\n  top: ", "px;\n  left: ", "px;\n"]),
	    _templateObject51 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin-bottom: 16px;\n"], ["\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin-bottom: 16px;\n"]),
	    _templateObject52 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.35);\n  flex-shrink: 0;\n  padding: 0 4px;\n  user-select: none;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.35);\n  flex-shrink: 0;\n  padding: 0 4px;\n  user-select: none;\n"]),
	    _templateObject53 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1;\n  display: flex;\n\n  > button {\n    width: 100%;\n  }\n\n  &:hover > span {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  flex: 1;\n  display: flex;\n\n  > button {\n    width: 100%;\n  }\n\n  &:hover > span {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject54 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject55 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 18px;\n  color: ", ";\n  margin-top: 2px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 18px;\n  color: ", ";\n  margin-top: 2px;\n"]),
	    _templateObject56 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  max-width: 1300px;\n  margin-bottom: 16px;\n  align-items: start;\n\n  @media (max-width: 1000px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  max-width: 1300px;\n  margin-bottom: 16px;\n  align-items: start;\n\n  @media (max-width: 1000px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject57 = _taggedTemplateLiteral(["\n  grid-column: 1;\n  grid-row: span 2;\n\n  @media (max-width: 1000px) {\n    grid-row: auto;\n  }\n"], ["\n  grid-column: 1;\n  grid-row: span 2;\n\n  @media (max-width: 1000px) {\n    grid-row: auto;\n  }\n"]),
	    _templateObject58 = _taggedTemplateLiteral(["\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n\n  ", "\n\n  @media (max-width: 1000px) {\n    grid-column: 1;\n  }\n\n  > div {\n    margin-bottom: 0;\n  }\n"], ["\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n\n  ", "\n\n  @media (max-width: 1000px) {\n    grid-column: 1;\n  }\n\n  > div {\n    margin-bottom: 0;\n  }\n"]),
	    _templateObject59 = _taggedTemplateLiteral(["\n  0%   { transform: translate(-50%, -50%) scale(1); opacity: 0.85; }\n  100% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }\n"], ["\n  0%   { transform: translate(-50%, -50%) scale(1); opacity: 0.85; }\n  100% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }\n"]),
	    _templateObject60 = _taggedTemplateLiteral(["\n  0%, 100% { box-shadow: 0 0 12px 4px rgba(92, 145, 245, 0.7), 0 0 26px 10px rgba(92, 145, 245, 0.35); }\n  50%      { box-shadow: 0 0 24px 10px rgba(92, 145, 245, 1), 0 0 40px 18px rgba(92, 145, 245, 0.5); }\n"], ["\n  0%, 100% { box-shadow: 0 0 12px 4px rgba(92, 145, 245, 0.7), 0 0 26px 10px rgba(92, 145, 245, 0.35); }\n  50%      { box-shadow: 0 0 24px 10px rgba(92, 145, 245, 1), 0 0 40px 18px rgba(92, 145, 245, 0.5); }\n"]),
	    _templateObject61 = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-6px); }\n"], ["\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-6px); }\n"]),
	    _templateObject62 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  border-radius: 50%;\n  animation: ", " 1.4s ease-in-out infinite, ", " 1.8s ease-in-out infinite;\n\n  ", "\n  ", "\n\n  /* Expanding \"sonar\" ring so the marker is legible even without motion. */\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: 3px solid rgba(92, 145, 245, 0.9);\n    transform: translate(-50%, -50%) scale(1);\n    animation: ", " 1.8s ease-out infinite;\n    pointer-events: none;\n  }\n\n  &::after {\n    animation-delay: 0.9s;\n  }\n\n  &:hover {\n    animation: none;\n    transform: scale(1.3);\n    box-shadow: 0 0 26px 12px rgba(92, 145, 245, 1), 0 0 46px 20px rgba(92, 145, 245, 0.55);\n\n    &::before,\n    &::after {\n      animation-play-state: paused;\n      opacity: 0;\n    }\n  }\n\n  img {\n    display: block;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    position: relative;\n    z-index: 1;\n  }\n"], ["\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  border-radius: 50%;\n  animation: ", " 1.4s ease-in-out infinite, ", " 1.8s ease-in-out infinite;\n\n  ", "\n  ", "\n\n  /* Expanding \"sonar\" ring so the marker is legible even without motion. */\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: 3px solid rgba(92, 145, 245, 0.9);\n    transform: translate(-50%, -50%) scale(1);\n    animation: ", " 1.8s ease-out infinite;\n    pointer-events: none;\n  }\n\n  &::after {\n    animation-delay: 0.9s;\n  }\n\n  &:hover {\n    animation: none;\n    transform: scale(1.3);\n    box-shadow: 0 0 26px 12px rgba(92, 145, 245, 1), 0 0 46px 20px rgba(92, 145, 245, 0.55);\n\n    &::before,\n    &::after {\n      animation-play-state: paused;\n      opacity: 0;\n    }\n  }\n\n  img {\n    display: block;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    position: relative;\n    z-index: 1;\n  }\n"]),
	    _templateObject63 = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateX(-50%) translateY(0); }\n  50%      { transform: translateX(-50%) translateY(-4px); }\n"], ["\n  0%, 100% { transform: translateX(-50%) translateY(0); }\n  50%      { transform: translateX(-50%) translateY(-4px); }\n"]),
	    _templateObject64 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 10px 20px;\n  border-radius: 999px;\n  background: #2F4166;\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);\n  z-index: 5;\n  pointer-events: none;\n  animation: ", " 1.8s ease-in-out infinite;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #5C91F5;\n    box-shadow: 0 0 0 4px rgba(92, 145, 245, 0.35);\n  }\n"], ["\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 10px 20px;\n  border-radius: 999px;\n  background: #2F4166;\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: 0.2px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);\n  z-index: 5;\n  pointer-events: none;\n  animation: ", " 1.8s ease-in-out infinite;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #5C91F5;\n    box-shadow: 0 0 0 4px rgba(92, 145, 245, 0.35);\n  }\n"]),
	    _templateObject65 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-top: 8px;\n\n  p {\n    margin: 0 0 14px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-top: 8px;\n\n  p {\n    margin: 0 0 14px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"]),
	    _templateObject66 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  background: transparent;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  padding: 4px 8px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  background: transparent;\n  border: none;\n  font-size: 22px;\n  line-height: 1;\n  padding: 4px 8px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _uiButton = __webpack_require__(1241);
	
	var _uiButton2 = _interopRequireDefault(_uiButton);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Styled = {};
	
	Styled.BodyWrapper = _styledComponents2.default.div(_templateObject);
	
	Styled.TitleWrapper = _styledComponents2.default.div(_templateObject2);
	
	Styled.Title = _styledComponents2.default.div(_templateObject3);
	
	Styled.Subtitle = _styledComponents2.default.div(_templateObject4);
	
	Styled.SubmitDecisionButton = _styledComponents2.default.div(_templateObject5, function (_ref) {
	  var submitted = _ref.submitted;
	  return submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)";
	});
	
	Styled.BlocksRow = _styledComponents2.default.div(_templateObject6);
	
	Styled.GoogleMap = _styledComponents2.default.div(_templateObject7);
	
	Styled.MapDot = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.onMouseEnter && "\n    cursor: pointer;\n\n    &:hover {\n      background: #5c91f5;\n      border-color: #5c91f5;\n      color: #ffffff;\n    }\n  ";
	}, function (p) {
	  return p.y && "\n    top: " + p.y + "px;\n  ";
	}, function (p) {
	  return p.x && "\n    left: " + p.x + "px;\n  ";
	}, function (p) {
	  return p.yPercentage && "\n    top: " + p.yPercentage + "%;\n  ";
	}, function (p) {
	  return p.xPercentage && "\n    left: " + p.xPercentage + "%;\n  ";
	});
	
	Styled.DistributionTableRow = _styledComponents2.default.div(_templateObject9, function (p) {
	  return p.marginTop && "\n    margin-top: " + p.marginTop + "px;\n  ";
	});
	
	Styled.DistributionTableCell = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.isHeader && "\n    font-weight: 700;\n    background: none;\n\n    span {\n      font-weight: 400;\n    }\n  ";
	});
	
	Styled.DistributionButtons = _styledComponents2.default.div(_templateObject11);
	
	Styled.DistributionCancelButton = _styledComponents2.default.div(_templateObject12);
	
	Styled.DistributionSubmitButton = _styledComponents2.default.div(_templateObject13);
	
	Styled.DistributionInfo = _styledComponents2.default.div(_templateObject14);
	
	Styled.Tooltip1 = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.top && "\n    top: " + p.top + "px;\n  ";
	}, function (p) {
	  return p.left && "\n    left: " + p.left + "px;\n  ";
	}, function (p) {
	  return p.show && "\n    display: block;\n  ";
	});
	
	Styled.TooltipTitle = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Styled.TooltipCost = _styledComponents2.default.div(_templateObject17, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Styled.TooltipImage = _styledComponents2.default.div(_templateObject18);
	
	Styled.TooltipButtonRow = _styledComponents2.default.div(_templateObject19);
	
	Styled.TooltipButton = _styledComponents2.default.button(_templateObject20);
	
	Styled.MapIcon = _styledComponents2.default.div(_templateObject21, function (p) {
	  return p.width && "\n    width: " + p.width + "px;\n\n    img {\n      width: " + p.width + "px;\n    }\n  ";
	}, function (p) {
	  return p.height && "\n    height: " + p.height + "px;\n\n    img {\n      height: " + p.height + "px;\n    }\n  ";
	}, function (p) {
	  return p.isFixed && "\n    position: fixed;\n    z-index: 2002;\n  ";
	}, function (p) {
	  return p.isFixed && p.y && "\n    top: " + (p.y + 230) + "px;\n  ";
	}, function (p) {
	  return p.isFixed && p.x && "\n    left: " + (p.x + 250) + "px;\n  ";
	}, function (p) {
	  return !p.isFixed && "\n    position: absolute;\n  ";
	}, function (p) {
	  return !p.isFixed && p.y && "\n    top: " + p.y + "px;\n  ";
	}, function (p) {
	  return !p.isFixed && p.x && "\n    left: " + p.x + "px;\n  ";
	}, function (p) {
	  return p.onClick && "\n    cursor: pointer;\n  ";
	}, function (p) {
	  return p.onMouseEnter && "\n    cursor: pointer;\n  ";
	});
	
	Styled.TooltipSpace = _styledComponents2.default.div(_templateObject22);
	
	Styled.TopBanner = _styledComponents2.default.div(_templateObject23);
	
	Styled.PreDescription = _styledComponents2.default.div(_templateObject24);
	
	Styled.MapDetails = _styledComponents2.default.div(_templateObject25, function (p) {
	  return p.hide && "\n    display: none;\n  ";
	});
	
	Styled.MapDetailsTitle = _styledComponents2.default.div(_templateObject26, function (p) {
	  return p.margin && "\n    margin: " + p.margin + ";\n  ";
	});
	
	Styled.MapDetailsTitleCheckbox = _styledComponents2.default.img(_templateObject27);
	
	Styled.HelpIcon = _styledComponents2.default.img(_templateObject28);
	
	Styled.WhiteBlock = _styledComponents2.default.div(_templateObject29, function (p) {
	  return p.width && "\n    flex: 0 0 " + p.width + ";\n    width: " + p.width + ";\n  ";
	}, function (p) {
	  return p.autoWidth && "\n    flex: 0 0 calc(100vw - 810px);\n    width: calc(100vw - 810px);\n    max-width: 590px;\n  ";
	}, function (p) {
	  return p.padding && "\n    padding: " + p.padding + ";\n  ";
	}, function (p) {
	  return p.mapOverlay && "\n    position: fixed;\n    z-index: 2001;\n  ";
	});
	
	Styled.DistributionTitle = _styledComponents2.default.div(_templateObject30);
	
	Styled.ButtonsWrapper = _styledComponents2.default.div(_templateObject31);
	
	Styled.ButtonsWrapperFlex = _styledComponents2.default.div(_templateObject2);
	
	Styled.UIButton = (0, _styledComponents2.default)(_uiButton2.default)(_templateObject32);
	
	Styled.Arrow = _styledComponents2.default.div(_templateObject33);
	
	Styled.Chart = {};
	
	Styled.Chart.TitleRow = _styledComponents2.default.div(_templateObject2);
	
	Styled.Chart.Title = _styledComponents2.default.div(_templateObject34);
	
	Styled.Chart.TitleAmount = _styledComponents2.default.div(_templateObject35);
	
	Styled.Chart.TitleAmountTeam = Styled.Chart.TitleAmount.extend(_templateObject36, _Teams2.default.currentTeamColor);
	
	Styled.FullWidthRow = _styledComponents2.default.div(_templateObject37);
	
	Styled.Chart.Row = _styledComponents2.default.div(_templateObject38, function (p) {
	  return p.width && "\n    width: " + p.width + ";\n  ";
	});
	
	Styled.Chart.Wrapper = _styledComponents2.default.div(_templateObject39);
	
	Styled.Chart.Chart = _styledComponents2.default.div(_templateObject40);
	
	Styled.Chart.Legend = _styledComponents2.default.div(_templateObject41);
	
	Styled.Chart.LegendItem = _styledComponents2.default.div(_templateObject42);
	
	Styled.Chart.LegendItemCircle = _styledComponents2.default.div(_templateObject43, function (p) {
	  return p.color && "\n    background: " + p.color + ";\n  ";
	});
	
	Styled.Table = {};
	
	Styled.Table.Wrapper = _styledComponents2.default.div(_templateObject44);
	
	Styled.Table.Title = _styledComponents2.default.div(_templateObject45);
	
	Styled.Table.Table = _styledComponents2.default.div(_templateObject46, function (p) {
	  return p.rowColor && "\n            background: " + p.rowColor + ";\n          ";
	});
	
	Styled.PercentAmount = _styledComponents2.default.div(_templateObject47);
	
	// Dev-only: transparent overlay on top of the map that captures clicks
	// and logs the click x/y to the console. Activated by `?devmap=1` URL
	// query param so it's not visible to normal users.
	Styled.DevMapOverlay = _styledComponents2.default.div(_templateObject48);
	
	Styled.DevMapBanner = _styledComponents2.default.div(_templateObject49);
	
	Styled.DevMapCoord = _styledComponents2.default.div(_templateObject50, function (p) {
	  return p.top + 8;
	}, function (p) {
	  return p.left + 8;
	});
	
	// Horizontal row that lays out the three Make Decisions options with
	// arrow separators between them, signaling the intended order:
	// machines → manufacture → distribution.
	Styled.DecisionFlowRow = _styledComponents2.default.div(_templateObject51);
	
	Styled.DecisionFlowArrow = _styledComponents2.default.div(_templateObject52);
	
	// Mirrors FinanceStyled.ManageOptionWrapper but flex:1 so siblings
	// inside a DecisionFlowRow size equally.
	Styled.DecisionOptionWrapper = _styledComponents2.default.div(_templateObject53);
	
	// Wrapping variant of FinanceStyled.ManageOptionTooltip — fixed width
	// so longer explanatory copy breaks onto multiple lines.
	Styled.DecisionOptionTooltip = _styledComponents2.default.span(_templateObject54);
	
	// Round-over-round delta line shown under a KPI value (e.g. Cost Per
	// Unit). negative=true (cost went up) renders red with an up arrow;
	// otherwise green with a down arrow.
	Styled.KpiDelta = _styledComponents2.default.div(_templateObject55, function (p) {
	  return p.negative ? '#C62828' : '#2DA548';
	});
	
	// 2-column grid where the left "Market Information" block spans both
	// rows on the right (Inventory Management + Supply Chain Assets stack).
	Styled.OpsLeadGrid = _styledComponents2.default.div(_templateObject56);
	
	Styled.OpsLeadGridMarket = _styledComponents2.default.div(_templateObject57);
	
	Styled.OpsLeadGridRight = _styledComponents2.default.div(_templateObject58, function (p) {
	  return p.fillHeight && "\n    grid-row: span 2;\n  ";
	});
	
	// Persistent, expanding halo ring around the DC markers when the
	// Manage Distribution panel is open — makes the interactive markers
	// impossible to miss even at a glance.
	var dcRing = (0, _styledComponents.keyframes)(_templateObject59);
	
	// Secondary pulsing halo directly on the icon so there is always a
	// visible glow even when the ring is between pulses.
	var dcGlow = (0, _styledComponents.keyframes)(_templateObject60);
	
	// Gentle vertical bob so the marker appears to be lifting off the map,
	// matching the "Select a Distribution Center" callout above.
	var dcBob = (0, _styledComponents.keyframes)(_templateObject61);
	
	Styled.GlowingMapIcon = _styledComponents2.default.div(_templateObject62, dcGlow, dcBob, function (p) {
	  return p.y && "top: " + p.y + "px;";
	}, function (p) {
	  return p.x && "left: " + p.x + "px;";
	}, dcRing);
	
	// Floating callout that instructs the student to pick one of the
	// glowing distribution-center markers on the map.
	var dcCalloutPulse = (0, _styledComponents.keyframes)(_templateObject63);
	
	Styled.SelectDcCallout = _styledComponents2.default.div(_templateObject64, dcCalloutPulse);
	
	// Body paragraph styling for the Manage Distribution side panel.
	Styled.ManageDistributionBody = _styledComponents2.default.div(_templateObject65);
	
	Styled.ManageDistributionClose = _styledComponents2.default.button(_templateObject66);
	
	exports.default = Styled;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon_close = __webpack_require__(1859);
	
	var _icon_close2 = _interopRequireDefault(_icon_close);
	
	var _marketButton = __webpack_require__(307);
	
	var _marketButton2 = _interopRequireDefault(_marketButton);
	
	var _progressBarItem = __webpack_require__(1254);
	
	var _progressBarItem2 = _interopRequireDefault(_progressBarItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PeerEvaluationModal = function (_Component) {
	  _inherits(PeerEvaluationModal, _Component);
	
	  function PeerEvaluationModal() {
	    _classCallCheck(this, PeerEvaluationModal);
	
	    return _possibleConstructorReturn(this, (PeerEvaluationModal.__proto__ || Object.getPrototypeOf(PeerEvaluationModal)).apply(this, arguments));
	  }
	
	  _createClass(PeerEvaluationModal, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var show = this.props.show;
	
	      /* Hide background scrollbar */
	
	      if (show) {
	        document.body.style.overflow = "hidden";
	      } else {
	        document.body.style.overflow = "";
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          show = _props.show,
	          progressBar = _props.progressBar,
	          onHide = _props.onHide,
	          onSubmit = _props.onSubmit,
	          submitButtonText = _props.submitButtonText,
	          surveyId = _props.surveyId,
	          currentPage = _props.currentPage,
	          countOfPages = _props.countOfPages,
	          goNext = _props.goNext,
	          goPrev = _props.goPrev,
	          canSubmit = _props.canSubmit,
	          isFinalScreen = _props.isFinalScreen,
	          readonlyMode = _props.readonlyMode,
	          _props$linearExtraId = _props.linearExtraId,
	          linearExtraId = _props$linearExtraId === undefined ? '' : _props$linearExtraId,
	          _props$isInstructorMo = _props.isInstructorMode,
	          isInstructorMode = _props$isInstructorMo === undefined ? false : _props$isInstructorMo,
	          isIntroScreen = _props.isIntroScreen;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("peerModal", { peerModal_show: show }) },
	        _react2.default.createElement(
	          "div",
	          { className: "modalWrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "modalHeader" },
	            _react2.default.createElement(
	              "div",
	              { className: "progressBarWrapper" },
	              progressBar.map(function (item) {
	                return _react2.default.createElement(_progressBarItem2.default, {
	                  key: item.id,
	                  id: item.id,
	                  surveyId: surveyId,
	                  title: item.title,
	                  progress: item.progress,
	                  isDisabled: item.isDisabled,
	                  linearExtraId: linearExtraId
	                });
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "modalHeader__close",
	                onClick: onHide ? onHide : null
	              },
	              _react2.default.createElement("img", { alt: "Close modal window", src: _icon_close2.default })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "modalContent" },
	            children,
	            !isFinalScreen && !readonlyMode && _react2.default.createElement(
	              _marketButton2.default,
	              {
	                variant: "error",
	                type: "solid",
	                className: "submitButton",
	                onClick: onSubmit,
	                disabled: !canSubmit
	              },
	              submitButtonText
	            ),
	            isFinalScreen && _react2.default.createElement(
	              _marketButton2.default,
	              {
	                variant: "error",
	                type: "outlined",
	                className: "closeButton",
	                onClick: function onClick() {
	                  return onHide();
	                }
	              },
	              "Close"
	            )
	          ),
	          (currentPage > 0 || readonlyMode === true) && countOfPages > 0 && _react2.default.createElement(
	            "div",
	            { className: "surveyPaginationWrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "surveyPagination" },
	              isInstructorMode !== true && currentPage > 1 && _react2.default.createElement(
	                _marketButton2.default,
	                {
	                  type: "solid",
	                  className: "surveyPaginationButton surveyPaginationLast",
	                  onClick: goPrev,
	                  disabled: !canSubmit
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "<"
	                ),
	                "Prev"
	              ),
	              isInstructorMode !== true && currentPage < countOfPages && _react2.default.createElement(
	                _marketButton2.default,
	                {
	                  type: "solid",
	                  className: "surveyPaginationButton surveyPaginationNext",
	                  onClick: goNext,
	                  disabled: !canSubmit
	                },
	                "Next",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  ">"
	                )
	              ),
	              isInstructorMode === true && isIntroScreen === false && _react2.default.createElement(
	                _marketButton2.default,
	                {
	                  type: "solid",
	                  className: "surveyPaginationButton surveyPaginationLast",
	                  onClick: goPrev,
	                  disabled: !canSubmit
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "<"
	                ),
	                "Prev"
	              ),
	              isInstructorMode === true && isFinalScreen === false && _react2.default.createElement(
	                _marketButton2.default,
	                {
	                  type: "solid",
	                  className: "surveyPaginationButton surveyPaginationNext",
	                  onClick: goNext,
	                  disabled: !canSubmit
	                },
	                "Next",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  ">"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PeerEvaluationModal;
	}(_react.Component);
	
	exports.default = PeerEvaluationModal;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: #e5e5e5;\n  padding: 56px 56px 0;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"], ["\n  background: #e5e5e5;\n  padding: 56px 56px 0;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 29px;\n  color: #000;\n  padding-right: 20px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 29px;\n  color: #000;\n  padding-right: 20px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 23px;\n  width: 148px;\n  line-height: 23px;\n  text-align: center;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n\n  .fa-spinner,\n  .fa-check {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  display: inline-block;\n  height: 23px;\n  width: 148px;\n  line-height: 23px;\n  text-align: center;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 14px;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n\n  .fa-spinner,\n  .fa-check {\n    margin-right: 10px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 0 15px;\n"], ["\n  padding: 0 15px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  display: block;\n  padding: 0 !important;\n  min-width: auto !important;\n  border-color: transparent !important;\n  width: 156px !important;\n  height: 43px !important;\n  line-height: 43px !important;\n  background-color: #2a4169 !important;\n  font-family: Lato !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #fff !important;\n  border-radius: 4px !important;\n  transition: background-color 0.5s ease;\n\n  &:hover {\n    background-color: #0da6ad !important;\n  }\n\n  &:disabled {\n    background-color: #cccccc !important;\n  }\n"], ["\n  display: block;\n  padding: 0 !important;\n  min-width: auto !important;\n  border-color: transparent !important;\n  width: 156px !important;\n  height: 43px !important;\n  line-height: 43px !important;\n  background-color: #2a4169 !important;\n  font-family: Lato !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #fff !important;\n  border-radius: 4px !important;\n  transition: background-color 0.5s ease;\n\n  &:hover {\n    background-color: #0da6ad !important;\n  }\n\n  &:disabled {\n    background-color: #cccccc !important;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  margin-right: 20px;\n"], ["\n  margin-left: 20px;\n  margin-right: 20px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: #fff;\n  width: 100%;\n  margin-top: 32px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  max-width: 800px;\n  padding: 25px;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n"], ["\n  background: #fff;\n  width: 100%;\n  margin-top: 32px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  max-width: 800px;\n  padding: 25px;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  flex: 0 0 345px;\n  position: relative;\n\n  ", "\n"], ["\n  flex: 0 0 345px;\n  position: relative;\n\n  ", "\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 12px;\n  color: #fff;\n  background: #494949;\n  width: 52px;\n  height: 52px;\n  border-radius: 26px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 79px;\n  left: 42px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 12px;\n  color: #fff;\n  background: #494949;\n  width: 52px;\n  height: 52px;\n  border-radius: 26px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 79px;\n  left: 42px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  .recharts-legend-wrapper {\n    font-family: Lato;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n\n    svg {\n      width: 9px;\n      height: 9px;\n      position: relative;\n      top: -1px;\n    }\n\n    .recharts-default-legend {\n      position: relative;\n      top: 15px;\n      left: 15px;\n    }\n  }\n"], ["\n  .recharts-legend-wrapper {\n    font-family: Lato;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n\n    svg {\n      width: 9px;\n      height: 9px;\n      position: relative;\n      top: -1px;\n    }\n\n    .recharts-default-legend {\n      position: relative;\n      top: 15px;\n      left: 15px;\n    }\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  table {\n    width: 100%;\n    border: 0;\n    border-collapse: separate;\n\n    thead {\n      border: 0;\n\n      tr {\n        th {\n          padding: 12px 13px;\n          font-family: Lato;\n          font-size: 14px;\n          line-height: 17px;\n          text-align: center;\n          color: #74abec;\n          border-bottom: 1px solid #626262;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-top: 9px solid #fff;\n          font-family: Lato;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 17px;\n          color: #000000;\n          text-align: center;\n          padding: 2px 0;\n\n          ", "\n\n          .remove-operation {\n            line-height: 25px;\n            top: 0;\n          }\n        }\n\n        &:first-child {\n          td {\n            border-top: 12px solid #fff;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  table {\n    width: 100%;\n    border: 0;\n    border-collapse: separate;\n\n    thead {\n      border: 0;\n\n      tr {\n        th {\n          padding: 12px 13px;\n          font-family: Lato;\n          font-size: 14px;\n          line-height: 17px;\n          text-align: center;\n          color: #74abec;\n          border-bottom: 1px solid #626262;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-top: 9px solid #fff;\n          font-family: Lato;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 17px;\n          color: #000000;\n          text-align: center;\n          padding: 2px 0;\n\n          ", "\n\n          .remove-operation {\n            line-height: 25px;\n            top: 0;\n          }\n        }\n\n        &:first-child {\n          td {\n            border-top: 12px solid #fff;\n          }\n        }\n      }\n    }\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  .recharts-legend-wrapper {\n    font-family: Lato;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n\n    svg {\n      width: 9px;\n      height: 9px;\n      position: relative;\n      top: -1px;\n    }\n\n    .recharts-default-legend {\n      position: relative;\n      top: 45px;\n      left: -10px;\n    }\n  }\n"], ["\n  .recharts-legend-wrapper {\n    font-family: Lato;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n\n    svg {\n      width: 9px;\n      height: 9px;\n      position: relative;\n      top: -1px;\n    }\n\n    .recharts-default-legend {\n      position: relative;\n      top: 45px;\n      left: -10px;\n    }\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  margin-top: 30px;\n\n  table {\n    width: 100%;\n    border: 0;\n    border-collapse: separate;\n\n    thead {\n      border: 0;\n\n      tr {\n        th {\n          padding: 12px 13px;\n          font-family: Lato;\n          font-size: 14px;\n          line-height: 17px;\n          text-align: center;\n          color: #74abec;\n          border-bottom: 1px solid #626262;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-top: 9px solid #fff;\n          font-family: Lato;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 17px;\n          color: #000000;\n          text-align: center;\n          padding: 2px 0;\n\n          ", "\n\n          .remove-operation {\n            line-height: 25px;\n            top: 0;\n          }\n        }\n\n        &:first-child {\n          td {\n            border-top: 12px solid #fff;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  margin-top: 30px;\n\n  table {\n    width: 100%;\n    border: 0;\n    border-collapse: separate;\n\n    thead {\n      border: 0;\n\n      tr {\n        th {\n          padding: 12px 13px;\n          font-family: Lato;\n          font-size: 14px;\n          line-height: 17px;\n          text-align: center;\n          color: #74abec;\n          border-bottom: 1px solid #626262;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          border-top: 9px solid #fff;\n          font-family: Lato;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 17px;\n          color: #000000;\n          text-align: center;\n          padding: 2px 0;\n\n          ", "\n\n          .remove-operation {\n            line-height: 25px;\n            top: 0;\n          }\n        }\n\n        &:first-child {\n          td {\n            border-top: 12px solid #fff;\n          }\n        }\n      }\n    }\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  .recharts-legend-wrapper {\n    font-family: Lato;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n\n    svg {\n      width: 9px;\n      height: 9px;\n      position: relative;\n      top: -1px;\n    }\n\n    .recharts-default-legend {\n      position: relative;\n      top: 45px;\n      left: -70px;\n    }\n  }\n"], ["\n  .recharts-legend-wrapper {\n    font-family: Lato;\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n\n    svg {\n      width: 9px;\n      height: 9px;\n      position: relative;\n      top: -1px;\n    }\n\n    .recharts-default-legend {\n      position: relative;\n      top: 45px;\n      left: -70px;\n    }\n  }\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"], ["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _uiButton = __webpack_require__(1342);
	
	var _uiButton2 = _interopRequireDefault(_uiButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Styled = {};
	
	Styled.BodyWrapper = _styledComponents2.default.div(_templateObject);
	
	Styled.TitleWrapper = _styledComponents2.default.div(_templateObject2);
	
	Styled.Title = _styledComponents2.default.div(_templateObject3);
	
	Styled.SubmitDecisionButton = _styledComponents2.default.div(_templateObject4, function (_ref) {
	  var submitted = _ref.submitted;
	  return submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)";
	});
	
	Styled.ButtonsWrapper = _styledComponents2.default.div(_templateObject5);
	
	Styled.ButtonsWrapperFlex = _styledComponents2.default.div(_templateObject6);
	
	Styled.UIButton = (0, _styledComponents2.default)(_uiButton2.default)(_templateObject7);
	
	Styled.Arrow = _styledComponents2.default.div(_templateObject8);
	
	Styled.WhiteBlock = _styledComponents2.default.div(_templateObject9);
	
	Styled.WhiteBlockColumn = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.width && "\n    flex: 0 0 " + p.width + ";\n  ";
	});
	
	// current marketing spend
	Styled.CMS = {};
	
	Styled.CMS.Title = _styledComponents2.default.div(_templateObject11);
	
	Styled.CMS.Amount = _styledComponents2.default.div(_templateObject12);
	
	Styled.CMS.Chart = _styledComponents2.default.div(_templateObject13);
	
	// revenue forecast
	Styled.RF = {};
	
	Styled.RF.Title = _styledComponents2.default.div(_templateObject11);
	
	Styled.RF.Table = _styledComponents2.default.div(_templateObject14, function (p) {
	  return p.rowColor && "\n            background: " + p.rowColor + ";\n          ";
	});
	
	// promotional spend
	Styled.PS = {};
	
	Styled.PS.Title = _styledComponents2.default.div(_templateObject11);
	
	Styled.PS.Amount = _styledComponents2.default.div(_templateObject12);
	
	Styled.PS.Chart = _styledComponents2.default.div(_templateObject15);
	
	Styled.PS.Table = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.rowColor && "\n            background: " + p.rowColor + ";\n          ";
	});
	
	// placement
	Styled.P = {};
	
	Styled.P.Title = _styledComponents2.default.div(_templateObject11);
	
	Styled.P.Amount = _styledComponents2.default.div(_templateObject12);
	
	Styled.P.Chart = _styledComponents2.default.div(_templateObject17);
	
	Styled.P.Table = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.rowColor && "\n            background: " + p.rowColor + ";\n          ";
	});
	
	Styled.TextWithButton = _styledComponents2.default.span(_templateObject18);
	
	Styled.HelpIcon = _styledComponents2.default.img(_templateObject19);
	
	exports.default = Styled;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _howToVideo = __webpack_require__(1405);
	
	var _howToVideo2 = _interopRequireDefault(_howToVideo);
	
	var _videosLinks = __webpack_require__(1434);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getVideoLink(type) {
	  var url = "";
	
	  switch (type) {
	    case "ceo":
	      url = _videosLinks.CEO_DECISIONS_VIDEO;
	      break;
	    case "product_development":
	      url = _videosLinks.PRODUCT_DEVELOPMENT_DECISIONS_VIDEO;
	      break;
	    case "product_marketing":
	      url = _videosLinks.PRODUCT_MARKETING_DECISIONS_VIDEO;
	      break;
	    case "operations":
	      url = _videosLinks.OPERATIONS_DECISIONS_VIDEO;
	      break;
	    case "finance":
	      url = _videosLinks.FINANCE_DECISIONS_VIDEO;
	      break;
	    default:
	    // do nothing
	  }
	
	  return url;
	}
	
	function RoleButtons(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === undefined ? "" : _ref$type;
	
	  var url = getVideoLink(type);
	  var isMobile = (0, _utils.detectMobile)();
	  var divClass = isMobile ? "row" : "role-buttons-container";
	
	  return _react2.default.createElement(
	    "div",
	    { className: divClass },
	    _react2.default.createElement(_howToVideo2.default, { url: url })
	  );
	}
	
	exports.default = RoleButtons;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  min-width: 0;\n  background: #FAFBFD;\n  min-height: calc(100vh - 59px);\n  margin: 0 -40px -40px;\n  padding: 32px;\n  font-family: ', ';\n  color: #0F172A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  flex: 1 1 auto;\n  min-width: 0;\n  background: #FAFBFD;\n  min-height: calc(100vh - 59px);\n  margin: 0 -40px -40px;\n  padding: 32px;\n  font-family: ', ';\n  color: #0F172A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 48px 40px;\n  background: #FFFFFF;\n  border: 1px solid #E2E8F0;\n  border-radius: 20px;\n  text-align: center;\n'], ['\n  width: 100%;\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 48px 40px;\n  background: #FFFFFF;\n  border: 1px solid #E2E8F0;\n  border-radius: 20px;\n  text-align: center;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0 0 12px;\n  font-family: ', ';\n  font-size: 28px;\n  font-weight: 800;\n  color: #0F172A;\n'], ['\n  margin: 0 0 12px;\n  font-family: ', ';\n  font-size: 28px;\n  font-weight: 800;\n  color: #0F172A;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 auto 24px;\n  max-width: 480px;\n  font-size: 18px;\n  line-height: 1.55;\n  color: #475569;\n'], ['\n  margin: 0 auto 24px;\n  max-width: 480px;\n  font-size: 18px;\n  line-height: 1.55;\n  color: #475569;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font-family: ', ';\n  font-size: 18px;\n  font-weight: 700;\n  color: #2563EB;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n'], ['\n  background: transparent;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font-family: ', ';\n  font-size: 18px;\n  font-weight: 700;\n  color: #2563EB;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 32px 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n'], ['\n  margin: 32px 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin: 0 auto;\n  border-collapse: collapse;\n  font-size: 16px;\n\n  th, td {\n    padding: 8px 16px;\n    text-align: left;\n    border-bottom: 1px solid #E2E8F0;\n  }\n\n  th {\n    font-weight: 700;\n    color: #475569;\n  }\n\n  td {\n    color: #0F172A;\n  }\n'], ['\n  margin: 0 auto;\n  border-collapse: collapse;\n  font-size: 16px;\n\n  th, td {\n    padding: 8px 16px;\n    text-align: left;\n    border-bottom: 1px solid #E2E8F0;\n  }\n\n  th {\n    font-weight: 700;\n    color: #475569;\n  }\n\n  td {\n    color: #0F172A;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  margin: 24px 0 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #475569;\n'], ['\n  margin: 24px 0 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #475569;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin: 24px 0 0;\n  font-size: 16px;\n  color: #64748B;\n'], ['\n  margin: 24px 0 0;\n  font-size: 16px;\n  color: #64748B;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Full-page "round hasn't started" state, rendered in place of the
	// normal decision page content for a student when the game has been
	// reset but the instructor hasn't set up rounds yet (rounds array
	// empty on the backend). Clicking "View round deadlines" fetches
	// game/rounds/ live so the message reflects the current state of the
	// backend rather than the stale FE snapshot.
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	var Styled = {};
	
	// Fills the available viewport (minus the fixed 59px topbar) and
	// centers the card both horizontally and vertically. The parent
	// (.app-wrapper) is a flex row, so we need flex:1 to actually span
	// the remaining width next to the fixed sidebar — otherwise the
	// section collapses to its content width and the card lands left-
	// of-center. Negative margins cancel any parent padding.
	Styled.Root = _styledComponents2.default.section(_templateObject, FONT);
	
	Styled.Card = _styledComponents2.default.div(_templateObject2);
	
	Styled.Title = _styledComponents2.default.h1(_templateObject3, FONT);
	
	Styled.Message = _styledComponents2.default.p(_templateObject4);
	
	Styled.LinkButton = _styledComponents2.default.button(_templateObject5, FONT);
	
	Styled.DeadlinesTitle = _styledComponents2.default.h2(_templateObject6);
	
	Styled.DeadlinesTable = _styledComponents2.default.table(_templateObject7);
	
	Styled.EmptyState = _styledComponents2.default.p(_templateObject8);
	
	Styled.LoadingState = _styledComponents2.default.p(_templateObject9);
	
	var formatDate = function formatDate(raw) {
	  if (!raw) return '—';
	  var m = (0, _moment2.default)(raw);
	  return m.isValid() ? m.format('MMM D, YYYY, h:mm A') : '—';
	};
	
	var roundLabel = function roundLabel(round) {
	  if (!round) return '';
	  if (round.practice === 'Yes' || round.practice === true) return 'Practice';
	  if (round.number != null) return 'Round ' + round.number;
	  return '—';
	};
	
	var RoundNotStartedGate = function (_PureComponent) {
	  _inherits(RoundNotStartedGate, _PureComponent);
	
	  function RoundNotStartedGate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoundNotStartedGate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoundNotStartedGate.__proto__ || Object.getPrototypeOf(RoundNotStartedGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // 'idle' | 'loading' | 'loaded' | 'error'
	      status: 'idle',
	      rounds: []
	    }, _this.fetchDeadlines = function () {
	      if (_this.state.status === 'loading') return;
	      _this.setState({ status: 'loading' });
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'game/rounds/').then(function (res) {
	        var body = res && res.body || {};
	        var rounds = Array.isArray(body) ? body : Array.isArray(body.results) ? body.results : [];
	        _this.setState({ status: 'loaded', rounds: rounds });
	      }).catch(function () {
	        _this.setState({ status: 'error' });
	      });
	    }, _this.renderDeadlinesResult = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          rounds = _this$state.rounds;
	
	      if (status === 'idle') return null;
	      if (status === 'loading') {
	        return _react2.default.createElement(
	          Styled.LoadingState,
	          null,
	          'Loading round deadlines\u2026'
	        );
	      }
	      if (status === 'error') {
	        return _react2.default.createElement(
	          Styled.EmptyState,
	          null,
	          'Couldn\'t load round deadlines. Please try again.'
	        );
	      }
	      if (status === 'loaded' && rounds.length === 0) {
	        return _react2.default.createElement(
	          Styled.EmptyState,
	          null,
	          'Your instructor hasn\'t set up rounds yet.'
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          Styled.DeadlinesTitle,
	          null,
	          'Round Deadlines'
	        ),
	        _react2.default.createElement(
	          Styled.DeadlinesTable,
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Round'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Start'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'End'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            rounds.map(function (r, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: r.id || i },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  roundLabel(r)
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  formatDate(r.start_date)
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  formatDate(r.end_date)
	                )
	              );
	            })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoundNotStartedGate, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Styled.Root,
	        null,
	        _react2.default.createElement(
	          Styled.Card,
	          null,
	          _react2.default.createElement(
	            Styled.Title,
	            null,
	            'This round hasn\'t started yet'
	          ),
	          _react2.default.createElement(
	            Styled.Message,
	            null,
	            'Once your instructor kicks off the round, you\'ll be able to make and post decisions here.'
	          ),
	          _react2.default.createElement(
	            Styled.LinkButton,
	            { type: 'button', onClick: this.fetchDeadlines },
	            'View round deadlines'
	          ),
	          this.renderDeadlinesResult()
	        )
	      );
	    }
	  }]);
	
	  return RoundNotStartedGate;
	}(_react.PureComponent);
	
	exports.default = RoundNotStartedGate;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPageLogo = __webpack_require__(392);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsOneColumnLayout(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$content = _ref.content,
	      content = _ref$content === undefined ? "" : _ref$content;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "team-reports-layout team-reports-one-column" },
	    _react2.default.createElement(
	      "div",
	      { className: "team-reports-logo without-border" },
	      _react2.default.createElement("img", { src: _LandingPageLogo2.default, alt: "logo" }),
	      _react2.default.createElement("div", { className: "orange-line" }),
	      _react2.default.createElement("div", { className: "green-line" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "one-column-inner-content" },
	      content
	    )
	  );
	}
	
	exports.default = TeamReportsOneColumnLayout;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 24px;\n  text-align: center;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n  margin-right: 15px;\n  text-transform: uppercase;\n"], ["\n  display: inline-block;\n  height: 24px;\n  text-align: center;\n  color: #fff;\n  background-color: ", ";\n  border-radius: 5px;\n  margin-right: 15px;\n  text-transform: uppercase;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _recompose = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var tooltip = function tooltip(submission_date) {
	  return _react2.default.createElement(
	    _reactBootstrap.Tooltip,
	    { id: "tooltip" },
	    "Last submission: ",
	    submission_date
	  );
	};
	
	var Button = _styledComponents2.default.button(_templateObject, function (_ref) {
	  var submitted = _ref.submitted;
	  return submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.5)";
	});
	
	var SubmitDecisionsButton = (0, _recompose.pure)(function (props) {
	  var id = props.id,
	      tooltipPlacement = props.tooltipPlacement,
	      data = props.data,
	      isLoading = props.isLoading,
	      isActive = props.isActive,
	      financial_decisions = props.financial_decisions,
	      unaccepted_decisions = props.unaccepted_decisions,
	      onClick = props.onClick,
	      buttonComponent = props.buttonComponent,
	      isPreChecked = props.isPreChecked,
	      isRoundEnded = props.isRoundEnded;
	
	  var tooltip_content = tooltip(data.date);
	  var submittedLabel = _react2.default.createElement(
	    "fragment",
	    null,
	    _react2.default.createElement("span", { className: "fa fa-check" }),
	    _react2.default.createElement(
	      "span",
	      null,
	      "Posted"
	    )
	  );
	  var loadingLabel = _react2.default.createElement(
	    "fragment",
	    null,
	    _react2.default.createElement("span", { className: "fa fa-spinner fa-spin" }),
	    _react2.default.createElement(
	      "span",
	      null,
	      "Posting"
	    )
	  );
	  var status = "";
	  var label = "Post Decision";
	
	  if (isLoading) {
	    status = '';
	    label = loadingLabel;
	  } else if (!isPreChecked) {
	    status = '';
	    label = 'Post Decision';
	  } else if (typeof data.success !== 'undefined') {
	    status = data.success === true ? 'posted' : '';
	
	    if (status === 'posted') {
	      label = submittedLabel;
	    }
	  } else if (unaccepted_decisions && unaccepted_decisions.FI !== 0) {
	    status = "";
	    label = "Post Decision";
	  } else if (isRoundEnded && financial_decisions && financial_decisions.team) {
	    // Closed-round only: rely on ending_cash to resolve Posted state.
	    // For active rounds, skip this branch and fall through so the
	    // fallback (data.unaccepted) drives the decision instead.
	    status = financial_decisions.team.ending_cash >= 0 ? "posted" : "";
	    label = financial_decisions.team.ending_cash >= 0 ? submittedLabel : "Post Decision";
	  } else {
	    status = data.unaccepted === 0 ? "posted" : "";
	
	    if (status === "posted") {
	      label = submittedLabel;
	    }
	  }
	
	  var isDisabled = isLoading;
	  if (isActive === false) {
	    isDisabled = true;
	  }
	
	  var ButtonComponent = buttonComponent ? buttonComponent : Button;
	
	  return _react2.default.createElement(
	    _reactBootstrap.OverlayTrigger,
	    { placement: tooltipPlacement, overlay: tooltip_content },
	    _react2.default.createElement(
	      ButtonComponent,
	      {
	        id: id,
	        submitted: status === "posted",
	        onClick: onClick,
	        disabled: isDisabled
	      },
	      label
	    )
	  );
	});
	
	exports.default = SubmitDecisionsButton;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectorLabel = exports.Wrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 12px;\n  margin-bottom: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 12px;\n  margin-bottom: 12px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  margin-right: 8px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  margin-right: 8px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _selector = __webpack_require__(607);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var SelectorLabel = exports.SelectorLabel = _styledComponents2.default.span(_templateObject2);
	
	var SelectorWrapper = function (_PureComponent) {
	  _inherits(SelectorWrapper, _PureComponent);
	
	  function SelectorWrapper() {
	    _classCallCheck(this, SelectorWrapper);
	
	    return _possibleConstructorReturn(this, (SelectorWrapper.__proto__ || Object.getPrototypeOf(SelectorWrapper)).apply(this, arguments));
	  }
	
	  _createClass(SelectorWrapper, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          options = _props.options,
	          onSelectorChange = _props.onSelectorChange,
	          _props$selectedOption = _props.selectedOptionId,
	          selectedOptionId = _props$selectedOption === undefined ? null : _props$selectedOption;
	
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          SelectorLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(_selector2.default, {
	          options: options,
	          onSelectorChange: onSelectorChange,
	          selectedOptionId: selectedOptionId
	        })
	      );
	    }
	  }]);
	
	  return SelectorWrapper;
	}(_react.PureComponent);
	
	exports.default = SelectorWrapper;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchTracks = fetchTracks;
	exports.invalidateTracks = invalidateTracks;
	
	var _ApiService = __webpack_require__(4);
	
	var TTL_MS = 30000;
	
	// Module-scoped Map: key → { promise, resolvedAt | null }
	// `resolvedAt = null` while a request is in flight; set to Date.now()
	// once the network call settles. On rejection, the entry is removed so
	// the next caller retries instead of latching onto a stale error.
	// Shared in-flight + TTL cache for the engagement-tracks GET endpoint.
	//
	// Three different callers (App.js, NextSteps, analytics-send) all fetch
	// the same `/v2/engagement/tracks/?game=…&course=…&user=…&round_number=…`
	// URL on certain page loads. Each previously had its own ad-hoc cache
	// (instance field, window global), but none of them shared state, so
	// the three concurrent on-mount calls all hit the network independently.
	//
	// This module exposes a single in-process cache:
	//   - `fetchTracks(...)` returns a cached Promise when a request for
	//     the same (game, course, user, round) tuple is in-flight or was
	//     resolved within TTL_MS. Multiple concurrent callers receive the
	//     same Promise reference, so the network sees one round trip.
	//   - `invalidateTracks()` clears the cache. POST sites that record a
	//     new page view call this so the next read picks up the new entry.
	//
	// TTL is intentionally short — long enough to dedupe concurrent mount
	// fetches and rapid re-fetches, short enough that drift between client
	// and server stays bounded. Any mutation (POST) invalidates immediately.
	
	var cache = new Map();
	
	function buildKey(gameId, courseId, userId, roundNumber) {
	  var round = roundNumber == null ? 'all' : roundNumber;
	  return gameId + '-' + courseId + '-' + userId + '-' + round;
	}
	
	function buildUrl(gameId, courseId, userId, roundNumber) {
	  var base = ("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/?game=' + gameId + '&course=' + courseId + '&user=' + userId;
	  return roundNumber == null ? base : base + '&round_number=' + roundNumber;
	}
	
	function fetchTracks(_ref) {
	  var gameId = _ref.gameId,
	      courseId = _ref.courseId,
	      userId = _ref.userId,
	      roundNumber = _ref.roundNumber;
	
	  var key = buildKey(gameId, courseId, userId, roundNumber);
	  var entry = cache.get(key);
	  var now = Date.now();
	
	  if (entry) {
	    var inFlight = entry.resolvedAt == null;
	    var fresh = entry.resolvedAt != null && now - entry.resolvedAt < TTL_MS;
	    if (inFlight || fresh) {
	      return entry.promise;
	    }
	  }
	
	  var promise = (0, _ApiService.getRequest)(buildUrl(gameId, courseId, userId, roundNumber)).then(function (res) {
	    var current = cache.get(key);
	    if (current && current.promise === promise) {
	      current.resolvedAt = Date.now();
	    }
	    return res;
	  }).catch(function (err) {
	    var current = cache.get(key);
	    if (current && current.promise === promise) {
	      cache.delete(key);
	    }
	    throw err;
	  });
	
	  cache.set(key, { promise: promise, resolvedAt: null });
	  return promise;
	}
	
	// Clear the entire tracks cache. Called by any code path that POSTs a
	// new tracks entry — the next fetch must hit the network so the new
	// page view is reflected in the result set.
	function invalidateTracks() {
	  cache.clear();
	}

/***/ },
/* 264 */
31,
/* 265 */
223,
/* 266 */
[2715, 623, 415],
/* 267 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 268 */
192,
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(26);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 270 */
[2698, 116],
/* 271 */
267,
/* 272 */
[2720, 117, 30, 162],
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(26);
	var aFunction = __webpack_require__(86);
	var SPECIES = __webpack_require__(44)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon_collapse.a5dc0359.svg";

/***/ },
/* 275 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Removes component props that shouldn't be set on the form control.
	var cleanProps = function cleanProps(props) {
	    var mapping = props.mapping,
	        validationErrors = props.validationErrors,
	        onSubmit = props.onSubmit,
	        onValid = props.onValid,
	        onValidSubmit = props.onValidSubmit,
	        onInvalid = props.onInvalid,
	        onInvalidSubmit = props.onInvalidSubmit,
	        onChange = props.onChange,
	        reset = props.reset,
	        preventExternalInvalidation = props.preventExternalInvalidation,
	        onSuccess = props.onSuccess,
	        onError = props.onError,
	        validationError = props.validationError,
	        validations = props.validations,
	        addonAfter = props.addonAfter,
	        addonBefore = props.addonBefore,
	        buttonAfter = props.buttonAfter,
	        buttonBefore = props.buttonBefore,
	        elementWrapperClassName = props.elementWrapperClassName,
	        help = props.help,
	        label = props.label,
	        options = props.options,
	        labelClassName = props.labelClassName,
	        layout = props.layout,
	        rowClassName = props.rowClassName,
	        rowLabel = props.rowLabel,
	        validatePristine = props.validatePristine,
	        validateOnSubmit = props.validateOnSubmit,
	        rest = _objectWithoutProperties(props, ["mapping", "validationErrors", "onSubmit", "onValid", "onValidSubmit", "onInvalid", "onInvalidSubmit", "onChange", "reset", "preventExternalInvalidation", "onSuccess", "onError", "validationError", "validations", "addonAfter", "addonBefore", "buttonAfter", "buttonBefore", "elementWrapperClassName", "help", "label", "options", "labelClassName", "layout", "rowClassName", "rowLabel", "validatePristine", "validateOnSubmit"]);
	
	    return rest;
	};
	
	exports.cleanProps = cleanProps;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1920);


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(720);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(712),
	    createBaseEach = __webpack_require__(1980);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 279 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(710),
	    baseAssignValue = __webpack_require__(277);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(233);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(923);
	
	__webpack_require__(362);
	
	__webpack_require__(930);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createRedirectSource;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function createRedirectSource(network, property) {
	  var _class, _temp;
	
	  return _temp = _class = function AvatarRedirectSource(props) {
	    var _this = this;
	
	    _classCallCheck(this, AvatarRedirectSource);
	
	    _defineProperty(this, "props", null);
	
	    _defineProperty(this, "isCompatible", function () {
	      return !!_this.props.avatarRedirectUrl && !!_this.props[property];
	    });
	
	    _defineProperty(this, "get", function (setState) {
	      var avatarRedirectUrl = _this.props.avatarRedirectUrl;
	      var size = (0, _utils.getImageSize)(_this.props.size);
	      var baseUrl = avatarRedirectUrl.replace(/\/*$/, '/');
	      var id = _this.props[property];
	      var query = size ? "size=".concat(size) : '';
	      var src = "".concat(baseUrl).concat(network, "/").concat(id, "?").concat(query);
	      setState({
	        source: 'network',
	        src: src
	      });
	    });
	
	    this.props = props;
	  }, _defineProperty(_class, "propTypes", _defineProperty({}, property, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))), _temp;
	}

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(65);
	
	module.exports = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call -- required for testing
	    method.call(null, argument || function () { return 1; }, 1);
	  });
	};


/***/ },
/* 284 */
[2763, 58, 65, 201],
/* 285 */
/***/ function(module, exports) {

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	module.exports = function (it) {
	  return it === null || it === undefined;
	};


/***/ },
/* 286 */
[2779, 285],
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var EventPluginRegistry = __webpack_require__(519);
	var EventPluginUtils = __webpack_require__(520);
	var ReactErrorUtils = __webpack_require__(524);
	
	var accumulateInto = __webpack_require__(975);
	var forEachAccumulated = __webpack_require__(976);
	var invariant = __webpack_require__(29);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(287);
	var EventPluginUtils = __webpack_require__(520);
	
	var accumulateInto = __webpack_require__(975);
	var forEachAccumulated = __webpack_require__(976);
	var warning = __webpack_require__(39);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 289 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(146);
	
	var getEventTarget = __webpack_require__(529);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2375);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(2);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 293 */
34,
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ErrorBar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: "renderErrorBars",
	    value: function renderErrorBars() {
	      var _this$props = this.props,
	          offset = _this$props.offset,
	          layout = _this$props.layout,
	          width = _this$props.width,
	          dataKey = _this$props.dataKey,
	          data = _this$props.data,
	          dataPointFormatter = _this$props.dataPointFormatter,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis,
	          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;
	
	        if (Array.isArray(errorVal)) {
	          var _errorVal = _slicedToArray(errorVal, 2);
	
	          lowBound = _errorVal[0];
	          highBound = _errorVal[1];
	        } else {
	          lowBound = highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = {
	            x1: xMax,
	            y1: yMin,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMin,
	            y1: yMid,
	            x2: xMax,
	            y2: yMid
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMin,
	            y2: yMax
	          };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = {
	            x1: xMin,
	            y1: yMax,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMid,
	            y1: yMin,
	            x2: xMid,
	            y2: yMax
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMax,
	            y2: yMin
	          };
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            className: "recharts-errorBar",
	            key: "bar-".concat(i)
	          }, props), _react["default"].createElement("line", coordsTop), _react["default"].createElement("line", coordsMid), _react["default"].createElement("line", coordsBot))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-errorBars"
	      }, this.renderErrorBars());
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component);
	
	ErrorBar.propTypes = {
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  data: _propTypes["default"].array,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  layout: _propTypes["default"].string,
	  dataPointFormatter: _propTypes["default"].func,
	  stroke: _propTypes["default"].string,
	  strokeWidth: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  offset: _propTypes["default"].number
	};
	ErrorBar.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	};
	var _default = ErrorBar;
	exports["default"] = _default;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  width: _propTypes["default"].number.isRequired,
	  height: _propTypes["default"].number.isRequired,
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  className: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);
	
	  var svgView = viewBox || {
	    width: width,
	    height: height,
	    x: 0,
	    y: 0
	  };
	  var layerClass = (0, _classnames["default"])('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	  return _react["default"].createElement("svg", _extends({}, attrs, {
	    className: layerClass,
	    width: width,
	    height: height,
	    style: style,
	    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
	    version: "1.1"
	  }), children);
	}
	
	Surface.propTypes = propTypes;
	var _default = Surface;
	exports["default"] = _default;

/***/ },
/* 296 */
[2772, 176, 1027, 2487, 545, 1041],
/* 297 */
[2786, 1034],
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(1561);
	var RequestBase = __webpack_require__(2541);
	var isObject = __webpack_require__(1047);
	var ResponseBase = __webpack_require__(2542);
	var Agent = __webpack_require__(2540);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only version of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	request.serializeObject = serialize;
	
	/**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'text/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	request.serialize = {
	  'application/x-www-form-urlencoded': serialize,
	  'application/json': JSON.stringify
	};
	
	/**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    if (index === -1) { // could be empty line, just skip it
	      continue;
	    }
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  // should match /json or +json
	  // but not /json-seq
	  return /[\/+]json($|[^-\w])/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req) {
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str) {
	  var parse = request.parse[this.type];
	  if (this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	      }
	    } catch(custom_err) {
	      new_err = custom_err; // ok() callback can throw
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      new_err.original = err;
	      new_err.response = res;
	      new_err.status = res.status;
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} [pass] optional in case of using 'bearer' as type
	 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (1 === arguments.length) pass = '';
	  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
	    options = pass;
	    pass = '';
	  }
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    };
	  }
	
	  var encoder = function(string) {
	    if ('function' === typeof btoa) {
	      return btoa(string);
	    }
	    throw new Error('Cannot use basic auth, btoa is not a function');
	  };
	
	  return this._auth(user, pass, options, encoder);
	};
	
	/**
	 * Add query-string `val`.
	 *
	 * Examples:
	 *
	 *   request.get('/shoes')
	 *     .query('size=10')
	 *     .query({ color: 'blue' })
	 *
	 * @param {Object|String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (file) {
	    if (this._data) {
	      throw Error("superagent can't mix .send() and .attach()");
	    }
	
	    this._getFormData().append(field, file, options || file.name);
	  }
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  if (this._shouldRetry(err, res)) {
	    return this._retry();
	  }
	
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    if (this._maxRetries) err.retries = this._retries - 1;
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // querystring
	  this._finalizeQueryString();
	
	  return this._end();
	};
	
	Request.prototype._end = function() {
	  var self = this;
	  var xhr = (this.xhr = request.getXHR());
	  var data = this._formData || this._data;
	
	  this._setTimeouts();
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	
	    if (this.header.hasOwnProperty(field))
	      xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	request.agent = function() {
	  return new Agent();
	};
	
	["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
	  Agent.prototype[method.toLowerCase()] = function(url, fn) {
	    var req = new request.Request(method, url);
	    this._setDefaults(req);
	    if (fn) {
	      req.end(fn);
	    }
	    return req;
	  };
	});
	
	Agent.prototype.del = Agent.prototype['delete'];
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn) {
	  var req = request('GET', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn) {
	  var req = request('HEAD', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn) {
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, data, fn) {
	  var req = request('DELETE', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	}
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn) {
	  var req = request('PATCH', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn) {
	  var req = request('POST', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn) {
	  var req = request('PUT', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var hasClass = function hasClass(elem, className) {
	  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
	};
	
	var addClass = function addClass(elem, className) {
	  if (!hasClass(elem, className)) {
	    elem.className += ' ' + className;
	  }
	};
	
	var removeClass = function removeClass(elem, className) {
	  var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
	  if (hasClass(elem, className)) {
	    while (newClass.indexOf(' ' + className + ' ') >= 0) {
	      newClass = newClass.replace(' ' + className + ' ', ' ');
	    }
	    elem.className = newClass.replace(/^\s+|\s+$/g, '');
	  }
	};
	
	var escapeHtml = function escapeHtml(str) {
	  var div = document.createElement('div');
	  div.appendChild(document.createTextNode(str));
	  return div.innerHTML;
	};
	
	var _show = function _show(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'block';
	};
	
	var show = function show(elems) {
	  if (elems && !elems.length) {
	    return _show(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _show(elems[i]);
	  }
	};
	
	var _hide = function _hide(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'none';
	};
	
	var hide = function hide(elems) {
	  if (elems && !elems.length) {
	    return _hide(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _hide(elems[i]);
	  }
	};
	
	var isDescendant = function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node !== null) {
	    if (node === parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	};
	
	var getTopMargin = function getTopMargin(elem) {
	  elem.style.left = '-9999px';
	  elem.style.display = 'block';
	
	  var height = elem.clientHeight,
	      padding;
	  if (typeof getComputedStyle !== 'undefined') {
	    // IE 8
	    padding = parseInt(getComputedStyle(elem).getPropertyValue('padding-top'), 10);
	  } else {
	    padding = parseInt(elem.currentStyle.padding);
	  }
	
	  elem.style.left = '';
	  elem.style.display = 'none';
	  return '-' + parseInt((height + padding) / 2) + 'px';
	};
	
	var fadeIn = function fadeIn(elem, interval) {
	  if (+elem.style.opacity < 1) {
	    interval = interval || 16;
	    elem.style.opacity = 0;
	    elem.style.display = 'block';
	    var last = +new Date();
	    var tick = (function (_tick) {
	      function tick() {
	        return _tick.apply(this, arguments);
	      }
	
	      tick.toString = function () {
	        return _tick.toString();
	      };
	
	      return tick;
	    })(function () {
	      elem.style.opacity = +elem.style.opacity + (new Date() - last) / 100;
	      last = +new Date();
	
	      if (+elem.style.opacity < 1) {
	        setTimeout(tick, interval);
	      }
	    });
	    tick();
	  }
	  elem.style.display = 'block'; //fallback IE8
	};
	
	var fadeOut = function fadeOut(elem, interval) {
	  interval = interval || 16;
	  elem.style.opacity = 1;
	  var last = +new Date();
	  var tick = (function (_tick2) {
	    function tick() {
	      return _tick2.apply(this, arguments);
	    }
	
	    tick.toString = function () {
	      return _tick2.toString();
	    };
	
	    return tick;
	  })(function () {
	    elem.style.opacity = +elem.style.opacity - (new Date() - last) / 100;
	    last = +new Date();
	
	    if (+elem.style.opacity > 0) {
	      setTimeout(tick, interval);
	    } else {
	      elem.style.display = 'none';
	    }
	  });
	  tick();
	};
	
	var fireClick = function fireClick(node) {
	  // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
	  // Then fixed for today's Chrome browser.
	  if (typeof MouseEvent === 'function') {
	    // Up-to-date approach
	    var mevt = new MouseEvent('click', {
	      view: window,
	      bubbles: false,
	      cancelable: true
	    });
	    node.dispatchEvent(mevt);
	  } else if (document.createEvent) {
	    // Fallback
	    var evt = document.createEvent('MouseEvents');
	    evt.initEvent('click', false, false);
	    node.dispatchEvent(evt);
	  } else if (document.createEventObject) {
	    node.fireEvent('onclick');
	  } else if (typeof node.onclick === 'function') {
	    node.onclick();
	  }
	};
	
	var stopEventPropagation = function stopEventPropagation(e) {
	  // In particular, make sure the space bar doesn't scroll the main window.
	  if (typeof e.stopPropagation === 'function') {
	    e.stopPropagation();
	    e.preventDefault();
	  } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
	    window.event.cancelBubble = true;
	  }
	};
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.escapeHtml = escapeHtml;
	exports._show = _show;
	exports.show = show;
	exports._hide = _hide;
	exports.hide = hide;
	exports.isDescendant = isDescendant;
	exports.getTopMargin = getTopMargin;
	exports.fadeIn = fadeIn;
	exports.fadeOut = fadeOut;
	exports.fireClick = fireClick;
	exports.stopEventPropagation = stopEventPropagation;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(2557);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAH9SURBVHgBpVVLbhNBEH3dM3bMJvIRJjtk4Whyg3iBGFjBkliAc4L4BpgTkJxgHIG9JatoEIvkBoxIlC1zA7zCJnFPUeVfEmd+jp80I/XvqfpV9SuFHNR6z10LlksxHBkrjcjAhFfNH2HWOZU06fi71c1K5YAMtaFUNeVspCx9qId/j8P980Eu8bMv3i5H5Qs/iiHi2+xfvgvOU4m3+94HInTxCCiF1q+94PgB8SzSM6wBjrwxj1zLTzSdXX8tCIfLXAvizdKTFoprmgVnbFfaC2JSdLDKaYIK5doc48nymtJqwqVqPtdp2fqJ4ogsjcZoBJTK+J20get8RzOpi9XwKXwbREyanmhjuXr+oh5A0cnNNbYoVkfzKQIdXTSD7nb/5Wdk5EQrODptkYV/bdtw7PGww6NIvsvm93a957WIqI0c2PL20xY5Ed9GqOxo6DdlHQ+e+p7D0x+Rg5gQ2ebahKxzyhaqljbgX+ydNmRU73tnrIeTRwzLhJOXV//64k+G2Ujhd1iaahEJGBHnYWtax3SboMS4Y3QKknJ8U64JsT0eHQLpWq+ASP8bdhfE4qdifVgTwjH35kW5zVzp0eTG3Pfke3UsxT/1gJVkEaNvXL0PuncnE1uTWN9NaaOl1cRQnEQ6ooEkXfJTqDUto9Z7xc00XmqmmpvpaWYz/Q/F4slkV5CRAAAAAABJRU5ErkJggg=="

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #faeded;\n  border: 1px solid #ec5e59;\n  border-radius: 4px;\n  width: calc(100% - 40px);\n  margin-bottom: 10px;\n  max-width: 800px;\n  padding: 9px 16px 15px 9px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  ', '\n\n  ', '\n'], ['\n  background: #faeded;\n  border: 1px solid #ec5e59;\n  border-radius: 4px;\n  width: calc(100% - 40px);\n  margin-bottom: 10px;\n  max-width: 800px;\n  padding: 9px 16px 15px 9px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  ', '\n\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: flex-start;\n  justify-content: flex-start;\n'], ['\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: flex-start;\n  justify-content: flex-start;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n'], ['\n  flex: 1;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _errorIconSmall = __webpack_require__(2576);
	
	var _errorIconSmall2 = _interopRequireDefault(_errorIconSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AlertWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.marginTop && '\n    margin-top: ' + p.marginTop + 'px;\n  ';
	}, function (p) {
	  return p.marginBottom && '\n    margin-bottom: ' + p.marginBottom + 'px;\n  ';
	});
	
	var AlertBody = _styledComponents2.default.div(_templateObject2);
	
	var FullWidth = _styledComponents2.default.div(_templateObject3);
	
	var ErrorInlineAlert = function ErrorInlineAlert(_ref) {
	  var title = _ref.title,
	      message = _ref.message,
	      marginTop = _ref.marginTop,
	      marginBottom = _ref.marginBottom;
	  return _react2.default.createElement(
	    AlertWrapper,
	    { marginTop: marginTop, marginBottom: marginBottom, className: 'inline-error' },
	    _react2.default.createElement(
	      AlertBody,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _errorIconSmall2.default, alt: '' })
	      ),
	      _react2.default.createElement(
	        FullWidth,
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          title
	        ),
	        _react2.default.createElement('br', null),
	        message
	      )
	    )
	  );
	};
	
	exports.default = ErrorInlineAlert;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormulaTable = function FormulaTable(_ref) {
	  var items = _ref.items;
	  return _react2.default.createElement(
	    "table",
	    {
	      style: {
	        width: "100%",
	        fontFamily: _styles.fontFamily,
	        fontSize: "16px"
	      }
	    },
	    _react2.default.createElement(
	      "tbody",
	      null,
	      _react2.default.createElement(
	        "tr",
	        {
	          style: {
	            color: "#2F9CA3",
	            fontWeight: "800",
	            fontSize: "18px",
	            textAlign: "center"
	          }
	        },
	        (0, _lodash.map)(items, function (item, key) {
	          return _react2.default.createElement(
	            "td",
	            { key: key, style: item.highlighted ? {} : { color: "#000000" } },
	            item.name
	          );
	        })
	      ),
	      _react2.default.createElement("tr", { style: { height: "1em" } }),
	      _react2.default.createElement(
	        "tr",
	        { style: { textAlign: "center" } },
	        (0, _lodash.map)(items, function (item, key) {
	          return _react2.default.createElement(
	            "td",
	            { key: key },
	            item.value
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = FormulaTable;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Paper = function Paper(_ref) {
	  var style = _ref.style,
	      children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    {
	      style: Object.assign({
	        backgroundColor: "#FFFFFF",
	        padding: "2em",
	        boxShadow: "0 4px 8px rgba(0, 0, 0, .15)",
	        fontFamily: _styles.fontFamily
	      }, style)
	    },
	    children
	  );
	};
	
	exports.default = Paper;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseFeedback = __webpack_require__(1253);
	
	var _parseFeedback2 = _interopRequireDefault(_parseFeedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeerEvaluationFeedback = function PeerEvaluationFeedback(props) {
	  var question = props.question,
	      showError = props.showError,
	      self_assessment_count = props.self_assessment_count,
	      answers = props.answers,
	      peer_rating_count = props.peer_rating_count,
	      onChange = props.onChange,
	      teamList = props.teamList,
	      currentUserId = props.currentUserId,
	      feedbacks = props.feedbacks,
	      previousAnswers = props.previousAnswers,
	      readonlyMode = props.readonlyMode,
	      adjustedScore = props.adjustedScore;
	
	
	  return (0, _parseFeedback2.default)({
	    question: question,
	    answers: answers,
	    showError: showError,
	    self_assessment_count: self_assessment_count,
	    peer_rating_count: peer_rating_count,
	    onChange: onChange,
	    teamList: teamList,
	    currentUserId: currentUserId,
	    feedbacks: feedbacks,
	    previousAnswers: previousAnswers,
	    readonlyMode: readonlyMode,
	    adjustedScore: adjustedScore
	  });
	};
	
	exports.default = PeerEvaluationFeedback;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n"], ["\n  display: block;\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  position: absolute;\n\n  img {\n    width: 36px;\n    height: 36px;\n    filter: grayscale(1);\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  position: absolute;\n\n  img {\n    width: 36px;\n    height: 36px;\n    filter: grayscale(1);\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n\n  img {\n    width: 36px;\n    height: 36px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n\n  img {\n    width: 36px;\n    height: 36px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _emojiStronglyDisagree = __webpack_require__(457);
	
	var _emojiStronglyDisagree2 = _interopRequireDefault(_emojiStronglyDisagree);
	
	var _emojiDisagree = __webpack_require__(454);
	
	var _emojiDisagree2 = _interopRequireDefault(_emojiDisagree);
	
	var _emojiNeutral = __webpack_require__(455);
	
	var _emojiNeutral2 = _interopRequireDefault(_emojiNeutral);
	
	var _emojiAgree = __webpack_require__(453);
	
	var _emojiAgree2 = _interopRequireDefault(_emojiAgree);
	
	var _emojiStronglyAgree = __webpack_require__(456);
	
	var _emojiStronglyAgree2 = _interopRequireDefault(_emojiStronglyAgree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Emojies = [_emojiStronglyDisagree2.default, _emojiDisagree2.default, _emojiNeutral2.default, _emojiAgree2.default, _emojiStronglyAgree2.default];
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var EmojiGrayscaled = _styledComponents2.default.div(_templateObject2);
	
	var Emoji = _styledComponents2.default.div(_templateObject3);
	
	var calculateWidth = function calculateWidth(value) {
	  return Math.round(value / 5 * 10000) / 100;
	};
	
	var Rating = function Rating(_ref) {
	  var value = _ref.value;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      EmojiGrayscaled,
	      null,
	      Emojies.map(function (emoji, index) {
	        return _react2.default.createElement("img", {
	          key: "rating-emoji-" + index,
	          src: emoji,
	          alt: "emoji"
	        });
	      })
	    ),
	    _react2.default.createElement(
	      Emoji,
	      { style: { width: calculateWidth(value) + "%" } },
	      Emojies.map(function (emoji, index) {
	        return _react2.default.createElement("img", {
	          key: "rating-emoji-" + index,
	          src: emoji,
	          alt: "emoji"
	        });
	      })
	    )
	  );
	};
	
	Rating.propTypes = {
	  value: _propTypes2.default.number
	};
	
	exports.default = Rating;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MarketButton = function MarketButton(props) {
	  var children = props.children,
	      href = props.href,
	      variant = props.variant,
	      disabled = props.disabled,
	      type = props.type,
	      size = props.size,
	      className = props.className,
	      rest = _objectWithoutProperties(props, ["children", "href", "variant", "disabled", "type", "size", "className"]);
	
	  return _react2.default.createElement(href ? "a" : "button", Object.assign({}, rest, {
	    disabled: disabled,
	    className: (0, _classnames2.default)(className, "market-button", "market-button_" + size, "market-button_" + type + "_" + variant),
	    href: href
	  }), children);
	};
	
	MarketButton.defaultProps = {
	  variant: "info",
	  type: "outlined",
	  size: "medium",
	  disabled: false
	};
	
	MarketButton.propTypes = {
	  /* Supplement as needed */
	  variant: _propTypes2.default.oneOf(["info", "primary", "error"]),
	  type: _propTypes2.default.oneOf(["outlined", "solid"]),
	  size: _propTypes2.default.oneOf(["medium"]),
	  disabled: _propTypes2.default.bool,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	exports.default = MarketButton;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(146.31deg, #2A4169 51.4%, rgba(255, 255, 255, 0.9) 99%);\n  overflow: auto;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(146.31deg, #2A4169 51.4%, rgba(255, 255, 255, 0.9) 99%);\n  overflow: auto;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background: #FFFFFF;\n  border-bottom: 2px solid #D5D9DD;\n  display: flex;\n  align-items: center;\n  padding: 0 32px;\n  z-index: 2;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background: #FFFFFF;\n  border-bottom: 2px solid #D5D9DD;\n  display: flex;\n  align-items: center;\n  padding: 0 32px;\n  z-index: 2;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  height: 32px;\n  width: auto;\n'], ['\n  height: 32px;\n  width: auto;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  box-sizing: border-box;\n'], ['\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  box-sizing: border-box;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 772px;\n  margin-bottom: 24px;\n'], ['\n  width: 100%;\n  max-width: 772px;\n  margin-bottom: 24px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', \'Inter\', sans-serif;\n  font-weight: 400;\n  font-size: 20px;\n  color: #FFFFFF;\n  margin-bottom: 12px;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', \'Inter\', sans-serif;\n  font-weight: 400;\n  font-size: 20px;\n  color: #FFFFFF;\n  margin-bottom: 12px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.2);\n  overflow: hidden;\n'], ['\n  width: 100%;\n  height: 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.2);\n  overflow: hidden;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  height: 100%;\n  border-radius: 10px;\n  background: #FFFFFF;\n  width: ', '%;\n  transition: width 240ms ease-out;\n'], ['\n  height: 100%;\n  border-radius: 10px;\n  background: #FFFFFF;\n  width: ', '%;\n  transition: width 240ms ease-out;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: ', 'px;\n  background: ', ';\n  border-radius: 10px;\n  padding: ', ';\n  box-sizing: border-box;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n'], ['\n  width: 100%;\n  max-width: ', 'px;\n  background: ', ';\n  border-radius: 10px;\n  padding: ', ';\n  box-sizing: border-box;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  color: #FFFFFF;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', \'Inter\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  background: linear-gradient(122.687deg, #FF5252 2.88%, rgba(112, 161, 255, 0.9) 100%);\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  transition: opacity 200ms ease;\n\n  &:hover { opacity: 0.94; }\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n'], ['\n  display: block;\n  width: 100%;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  color: #FFFFFF;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', \'Inter\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  background: linear-gradient(122.687deg, #FF5252 2.88%, rgba(112, 161, 255, 0.9) 100%);\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  transition: opacity 200ms ease;\n\n  &:hover { opacity: 0.94; }\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  margin-top: 24px;\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: rgba(0, 27, 59, 0.38);\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', \'Inter\', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover { color: rgba(0, 27, 59, 0.7); }\n'], ['\n  display: block;\n  width: 100%;\n  margin-top: 24px;\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: rgba(0, 27, 59, 0.38);\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', \'Inter\', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover { color: rgba(0, 27, 59, 0.7); }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _LandingPageLogo = __webpack_require__(210);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Shared chrome for the instructor first-login onboarding flow.
	// Full-viewport takeover, no leftbar or dashboard header.
	// Design tokens from Figma (Guided Tours file):
	//   bg gradient  linear-gradient(146.31deg, #2A4169 51%, rgba(255,255,255,0.9) 99%)
	//   card         white or #EBF2FF depending on page
	//   fonts        Mukta Mahee + Mukta Vaani (Bold/Medium/Regular)
	//   button       linear-gradient(122.687deg, #FF5252, rgba(112,161,255,0.9)) - red -> blue
	//   primary/blue heading/label color #2F4166
	//   navy border  #2A4169 on header
	//   outline      #D5D9DD tag borders + header bottom border
	
	var PageBackground = _styledComponents2.default.div(_templateObject);
	
	var Header = _styledComponents2.default.div(_templateObject2);
	
	var HeaderLogo = _styledComponents2.default.img(_templateObject3);
	
	var Content = _styledComponents2.default.div(_templateObject4);
	
	var ProgressWrap = _styledComponents2.default.div(_templateObject5);
	
	var ProgressLabels = _styledComponents2.default.div(_templateObject6);
	
	var ProgressTrack = _styledComponents2.default.div(_templateObject7);
	
	var ProgressFill = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.percent;
	});
	
	var Card = _styledComponents2.default.div(_templateObject9, function (p) {
	  return p.maxWidth || 772;
	}, function (p) {
	  return p.background || '#EBF2FF';
	}, function (p) {
	  return p.padding || '32px 67px 40px';
	});
	
	var PrimaryButton = _styledComponents2.default.button(_templateObject10);
	
	var BackLink = _styledComponents2.default.button(_templateObject11);
	
	var OnboardingLayout = function (_Component) {
	  _inherits(OnboardingLayout, _Component);
	
	  function OnboardingLayout() {
	    _classCallCheck(this, OnboardingLayout);
	
	    return _possibleConstructorReturn(this, (OnboardingLayout.__proto__ || Object.getPrototypeOf(OnboardingLayout)).apply(this, arguments));
	  }
	
	  _createClass(OnboardingLayout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          progressStep = _props.progressStep,
	          progressTotal = _props.progressTotal,
	          buttonLabel = _props.buttonLabel,
	          onButtonClick = _props.onButtonClick,
	          buttonDisabled = _props.buttonDisabled,
	          onBack = _props.onBack,
	          cardMaxWidth = _props.cardMaxWidth,
	          cardPadding = _props.cardPadding,
	          cardBackground = _props.cardBackground;
	
	
	      var showProgress = progressTotal > 0;
	      var percent = showProgress ? Math.max(0, Math.min(100, progressStep / progressTotal * 100)) : 0;
	
	      return _react2.default.createElement(
	        PageBackground,
	        null,
	        _react2.default.createElement(
	          Header,
	          null,
	          _react2.default.createElement(HeaderLogo, { src: _LandingPageLogo2.default, alt: 'Market Games' })
	        ),
	        _react2.default.createElement(
	          Content,
	          { hasProgress: showProgress },
	          showProgress && _react2.default.createElement(
	            ProgressWrap,
	            null,
	            _react2.default.createElement(
	              ProgressLabels,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Progress'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                progressStep,
	                ' of ',
	                progressTotal
	              )
	            ),
	            _react2.default.createElement(
	              ProgressTrack,
	              null,
	              _react2.default.createElement(ProgressFill, { percent: percent })
	            )
	          ),
	          _react2.default.createElement(
	            Card,
	            {
	              maxWidth: cardMaxWidth,
	              padding: cardPadding,
	              background: cardBackground
	            },
	            children,
	            buttonLabel && _react2.default.createElement(
	              PrimaryButton,
	              {
	                onClick: onButtonClick,
	                disabled: !!buttonDisabled
	              },
	              buttonLabel
	            ),
	            onBack && _react2.default.createElement(
	              BackLink,
	              { onClick: onBack },
	              'Back'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OnboardingLayout;
	}(_react.Component);
	
	exports.default = OnboardingLayout;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataDetails = function DataDetails(_ref) {
	  var title = _ref.title,
	      color = _ref.color,
	      data = _ref.data,
	      _ref$centered = _ref.centered,
	      centered = _ref$centered === undefined ? false : _ref$centered;
	  return _react2.default.createElement(
	    _ui.ExtraDetails.Block,
	    { color: color, centered: centered },
	    _react2.default.createElement(
	      _ui.ExtraDetails.ListContainer,
	      null,
	      _react2.default.createElement(
	        _ui.ExtraDetails.Title,
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        _ui.ExtraDetails.List,
	        null,
	        data.map(function (item, index) {
	          return _react2.default.createElement(
	            _ui.ExtraDetails.ListItem,
	            { key: index },
	            item
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = DataDetails;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropDownListItem = exports.DropDownList = exports.DropDownListContainer = exports.DropDownHeaderArrow = exports.DropDownHeader = exports.DropDownContainer = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 auto;\n'], ['\n  margin: 0 auto;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: block;\n  width: 180px;\n  height: 32px;\n  background: #fff;\n  border: 2px solid #5c91f5;\n  border-radius: 4px;\n  text-align: left;\n  line-height: 30px;\n  padding: 0 16px 0 16px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: #5c91f5;\n\n  cursor: pointer;\n  position: relative;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  display: block;\n  width: 180px;\n  height: 32px;\n  background: #fff;\n  border: 2px solid #5c91f5;\n  border-radius: 4px;\n  text-align: left;\n  line-height: 30px;\n  padding: 0 16px 0 16px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: #5c91f5;\n\n  cursor: pointer;\n  position: relative;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 32px;\n  height: 32px;\n  background: #5c91f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 32px;\n  height: 32px;\n  background: #5c91f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  z-index: 2;\n  padding-top: 4px;\n'], ['\n  position: relative;\n  z-index: 2;\n  padding-top: 4px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  border: 2px solid #d5d9dd;\n  background: #fff;\n  width: 180px;\n  max-height: 196px;\n  overflow-y: auto !important;\n  margin: 0;\n  padding: 10px 0;\n  display: block;\n  border-radius: 4px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n'], ['\n  border: 2px solid #d5d9dd;\n  background: #fff;\n  width: 180px;\n  max-height: 196px;\n  overflow-y: auto !important;\n  margin: 0;\n  padding: 10px 0;\n  display: block;\n  border-radius: 4px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  list-style: none;\n  display: block;\n  margin: 0;\n  padding: 10px 20px;\n  min-height: 36px;\n  line-height: 1.2;\n  cursor: pointer;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &:hover {\n    background-color: rgba(0, 27, 59, 0.04);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  ', '\n'], ['\n  list-style: none;\n  display: block;\n  margin: 0;\n  padding: 10px 20px;\n  min-height: 36px;\n  line-height: 1.2;\n  cursor: pointer;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &:hover {\n    background-color: rgba(0, 27, 59, 0.04);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  ', '\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  background: #F5F7FB;\n  padding: 40px 40px 70px;\n  min-height: calc(100vh - 59px);\n\n  .loader {\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n'], ['\n  width: 100%;\n  background: #F5F7FB;\n  padding: 40px 40px 70px;\n  min-height: calc(100vh - 59px);\n\n  .loader {\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 300px;\n'], ['\n  width: 300px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  position: absolute;\n'], ['\n  position: absolute;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 23px;\n    text-decoration: underline;\n    color: #5C91F5;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n'], ['\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 23px;\n    text-decoration: underline;\n    color: #5C91F5;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n\n  ', '\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: 15px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: 15px;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n\n  span {\n    color: rgb(100, 116, 135);\n  }\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n\n  span {\n    color: rgb(100, 116, 135);\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 20px;\n  max-width: 1300px;\n\n  > div:first-child {\n    flex: 1 1 540px;\n    min-width: 0;\n  }\n\n  > div:nth-child(2) {\n    flex: 1 1 540px;\n    min-width: 0;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    align-items: start;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 20px;\n  max-width: 1300px;\n\n  > div:first-child {\n    flex: 1 1 540px;\n    min-width: 0;\n  }\n\n  > div:nth-child(2) {\n    flex: 1 1 540px;\n    min-width: 0;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    align-items: start;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 20px;\n  flex-wrap: wrap;\n'], ['\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 20px;\n  flex-wrap: wrap;\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  width: 370px;\n  height: 280px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  width: 370px;\n  height: 280px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  width: 100%;\n  min-height: 48px;\n  padding: 10px 16px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-bottom: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 8px 8px 0 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  gap: 12px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  width: 100%;\n  min-height: 48px;\n  padding: 10px 16px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-bottom: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 8px 8px 0 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  gap: 12px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  position: relative;\n'], ['\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  position: relative;\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  overflow: auto !important;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #2a4169;\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n  overflow: auto !important;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #2a4169;\n  }\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 12px;\n  left: 10px;\n\n  font-family: \'Roboto\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n'], ['\n  position: absolute;\n  top: 12px;\n  left: 10px;\n\n  font-family: \'Roboto\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 8px;\n  left: 130px;\n\n  display: flex;\n  width: 50px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 4px;\n  border: 1.5px solid #d5d9dd;\n  background: #fafafa;\n\n  font-family: Mukta Vaani;\n  font-size: 11.5px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n'], ['\n  position: absolute;\n  top: 8px;\n  left: 130px;\n\n  display: flex;\n  width: 50px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 4px;\n  border: 1.5px solid #d5d9dd;\n  background: #fafafa;\n\n  font-family: Mukta Vaani;\n  font-size: 11.5px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 158px;\n  height: 32px;\n  background: #5c91f5;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    background-color: #7ca6f7;\n  }\n  \n  &:disabled {\n    border: 1.5px solid #D5D9DD;\n    background: #fff;\n    color: #001B3B61;\n\n    &:hover {\n      background: #fff;\n    }\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 158px;\n  height: 32px;\n  background: #5c91f5;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    background-color: #7ca6f7;\n  }\n  \n  &:disabled {\n    border: 1.5px solid #D5D9DD;\n    background: #fff;\n    color: #001B3B61;\n\n    &:hover {\n      background: #fff;\n    }\n  }\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  position: relative;\n\n  .inline-error {\n    width: 396px;\n    position: absolute;\n    bottom: 0;\n  }\n'], ['\n  position: relative;\n\n  .inline-error {\n    width: 396px;\n    position: absolute;\n    bottom: 0;\n  }\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2f4166;\n  padding: 50px 0 0 19px;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2f4166;\n  padding: 50px 0 0 19px;\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  gap: 71px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  gap: 71px;\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.7);\n\n  b {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n  }\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.7);\n\n  b {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n  }\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n  margin-bottom: 10px;\n  width: 165px;\n  margin-left: -38px;\n'], ['\n  margin-bottom: 10px;\n  width: 165px;\n  margin-left: -38px;\n']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  width: 165px;\n'], ['\n  width: 165px;\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  padding: 50px 0 0 19px;\n  max-width: 160px;\n'], ['\n  padding: 50px 0 0 19px;\n  max-width: 160px;\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n']),
	    _templateObject31 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 54px;\n  line-height: 100%;\n  color: #ec5e59;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 54px;\n  line-height: 100%;\n  color: #ec5e59;\n']),
	    _templateObject32 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 100%;\n  color: rgba(236, 94, 89, 0.72);\n  padding: 19px 0 0 10px;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 100%;\n  color: rgba(236, 94, 89, 0.72);\n  padding: 19px 0 0 10px;\n']),
	    _templateObject33 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2f4166;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2f4166;\n']),
	    _templateObject34 = _taggedTemplateLiteral(['\n  width: 127px;\n  padding-top: 10px;\n'], ['\n  width: 127px;\n  padding-top: 10px;\n']),
	    _templateObject35 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 4px;\n  left: 12px;\n  z-index: 1;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  position: absolute;\n  top: 4px;\n  left: 12px;\n  z-index: 1;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject36 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 127px;\n  height: 48px;\n  overflow: hidden;\n\n  .recharts-responsive-container {\n    margin-top: -6px;\n  }\n\n  .recharts-label-list {\n    display: none;\n  }\n\n  ', '\n'], ['\n  position: relative;\n  width: 127px;\n  height: 48px;\n  overflow: hidden;\n\n  .recharts-responsive-container {\n    margin-top: -6px;\n  }\n\n  .recharts-label-list {\n    display: none;\n  }\n\n  ', '\n']),
	    _templateObject37 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 70px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 70px;\n']),
	    _templateObject38 = _taggedTemplateLiteral(['\n  padding: 50px 0 0 20px;\n'], ['\n  padding: 50px 0 0 20px;\n']),
	    _templateObject39 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 54px;\n  line-height: 100%;\n  color: #72c4cb;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 54px;\n  line-height: 100%;\n  color: #72c4cb;\n']),
	    _templateObject40 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2f4166;\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #2f4166;\n\n  ', '\n']),
	    _templateObject41 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 140%;\n  color: #72c4cb;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 140%;\n  color: #72c4cb;\n']),
	    _templateObject42 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 47px;\n  margin-top: 16px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 47px;\n  margin-top: 16px;\n']),
	    _templateObject43 = _taggedTemplateLiteral(['\n  padding-top: 25.5px;\n'], ['\n  padding-top: 25.5px;\n']),
	    _templateObject44 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 140%;\n  color: #2f4166;\n  text-align: center;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 140%;\n  color: #2f4166;\n  text-align: center;\n']),
	    _templateObject45 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 8px;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 8px;\n  margin-top: 8px;\n']),
	    _templateObject46 = _taggedTemplateLiteral(['\n  display: block;\n  width: 120px;\n  height: 32px;\n  background: #fff;\n  border: 1.5px solid #2a4169;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 32px;\n  color: #2a4169;\n  text-align: center;\n  white-space: nowrap;\n\n  &:disabled {\n    border-color: #ccc;\n    color: #ccc;\n    cursor: not-allowed;\n    pointer-events: all !important;\n  }\n'], ['\n  display: block;\n  width: 120px;\n  height: 32px;\n  background: #fff;\n  border: 1.5px solid #2a4169;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 32px;\n  color: #2a4169;\n  text-align: center;\n  white-space: nowrap;\n\n  &:disabled {\n    border-color: #ccc;\n    color: #ccc;\n    cursor: not-allowed;\n    pointer-events: all !important;\n  }\n']),
	    _templateObject47 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.9);\n  padding-top: 99px;\n  padding-left: 37px;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.9);\n  padding-top: 99px;\n  padding-left: 37px;\n']),
	    _templateObject48 = _taggedTemplateLiteral(['\n  display: inline-block;\n\n  width: auto;\n  height: 32px;\n  background: #5c91f5;\n  border-radius: 4px;\n  padding: 0 6px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 32px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-align: center;\n\n  &:hover {\n    background-color: #7ca6f7;\n  }\n'], ['\n  display: inline-block;\n\n  width: auto;\n  height: 32px;\n  background: #5c91f5;\n  border-radius: 4px;\n  padding: 0 6px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 32px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-align: center;\n\n  &:hover {\n    background-color: #7ca6f7;\n  }\n']),
	    _templateObject49 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-left: 10px;\n  position: relative;\n  top: -2px;\n\n  width: 50px;\n  height: 20px;\n  background: #5c91f5;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 20px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-align: center;\n\n  &:hover {\n    background-color: #7ca6f7;\n  }\n'], ['\n  display: inline-block;\n  margin-left: 10px;\n  position: relative;\n  top: -2px;\n\n  width: 50px;\n  height: 20px;\n  background: #5c91f5;\n  border-radius: 4px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 20px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-align: center;\n\n  &:hover {\n    background-color: #7ca6f7;\n  }\n']),
	    _templateObject50 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 25px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 25px;\n']),
	    _templateObject51 = _taggedTemplateLiteral(['\n  padding: 8px 0 0 16px;\n'], ['\n  padding: 8px 0 0 16px;\n']),
	    _templateObject52 = _taggedTemplateLiteral(['\n  margin-top: 43px;\n'], ['\n  margin-top: 43px;\n']),
	    _templateObject53 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px;\n  border-right: 1px solid rgba(0, 27, 59, 0.15);\n  padding-right: 30px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px;\n  border-right: 1px solid rgba(0, 27, 59, 0.15);\n  padding-right: 30px;\n']),
	    _templateObject54 = _taggedTemplateLiteral(['\n  font-family: Mukta Vaani;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  color: #2a4169;\n  padding-bottom: 11px;\n'], ['\n  font-family: Mukta Vaani;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  color: #2a4169;\n  padding-bottom: 11px;\n']),
	    _templateObject55 = _taggedTemplateLiteral(['\n  font-family: Mukta Vaani;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  color: #2a4169;\n  text-align: center;\n  padding-top: 88px;\n'], ['\n  font-family: Mukta Vaani;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  color: #2a4169;\n  text-align: center;\n  padding-top: 88px;\n']),
	    _templateObject56 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n']),
	    _templateObject57 = _taggedTemplateLiteral(['\n  display: block;\n\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    color: #2f4166;\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  display: block;\n\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    color: #2f4166;\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject58 = _taggedTemplateLiteral(['\n  display: block;\n  width: 16px;\n  height: 16px;\n  border-radius: 100px;\n\n  ', '\n'], ['\n  display: block;\n  width: 16px;\n  height: 16px;\n  border-radius: 100px;\n\n  ', '\n']),
	    _templateObject59 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n']),
	    _templateObject60 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  cursor: zoom-in;\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  cursor: zoom-in;\n']),
	    _templateObject61 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  pointer-events: none;\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  pointer-events: none;\n']),
	    _templateObject62 = _taggedTemplateLiteral(['\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  padding: 36px 48px 40px;\n  width: 900px;\n  max-width: 92vw;\n  pointer-events: auto;\n  font-family: \'Mukta Vaani\', sans-serif;\n'], ['\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  padding: 36px 48px 40px;\n  width: 900px;\n  max-width: 92vw;\n  pointer-events: auto;\n  font-family: \'Mukta Vaani\', sans-serif;\n']),
	    _templateObject63 = _taggedTemplateLiteral(['\n  font-size: 22px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 4px;\n'], ['\n  font-size: 22px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 4px;\n']),
	    _templateObject64 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-bottom: 20px;\n'], ['\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-bottom: 20px;\n']),
	    _templateObject65 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n  align-items: start;\n'], ['\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n  align-items: start;\n']),
	    _templateObject66 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
	    _templateObject67 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n'], ['\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n']),
	    _templateObject68 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n  margin-bottom: 14px;\n'], ['\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n  margin-bottom: 14px;\n']),
	    _templateObject69 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: relative;\n  width: 100%;\n  height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject70 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n  pointer-events: none;\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n  pointer-events: none;\n']),
	    _templateObject71 = _taggedTemplateLiteral(['\n  font-size: 28px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  line-height: 1;\n'], ['\n  font-size: 28px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  line-height: 1;\n']),
	    _templateObject72 = _taggedTemplateLiteral(['\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin-top: 4px;\n'], ['\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin-top: 4px;\n']),
	    _templateObject73 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 11px;\n  color: #EC5E59;\n  text-align: center;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 11px;\n  color: #EC5E59;\n  text-align: center;\n']),
	    _templateObject74 = _taggedTemplateLiteral(['\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 16px;\n'], ['\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 16px;\n']),
	    _templateObject75 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.78);\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.78);\n']),
	    _templateObject76 = _taggedTemplateLiteral(['\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: ', ';\n'], ['\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: ', ';\n']),
	    _templateObject77 = _taggedTemplateLiteral(['\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
	    _templateObject78 = _taggedTemplateLiteral(['\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject79 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  padding: 6px 12px 0;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  padding: 6px 12px 0;\n']),
	    _templateObject80 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  padding: 6px 16px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 6px;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  padding: 6px 16px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 6px;\n']),
	    _templateObject81 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  text-decoration: none;\n  ', '\n  ', '\n  &:hover { text-decoration: underline; }\n'], ['\n  cursor: pointer;\n  text-decoration: none;\n  ', '\n  ', '\n  &:hover { text-decoration: underline; }\n']),
	    _templateObject82 = _taggedTemplateLiteral(['\n  color: rgba(0, 27, 59, 0.40);\n'], ['\n  color: rgba(0, 27, 59, 0.40);\n']),
	    _templateObject83 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  padding: 8px 12px 6px;\n  align-items: baseline;\n'], ['\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  padding: 8px 12px 6px;\n  align-items: baseline;\n']),
	    _templateObject84 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 12px;\n  line-height: 14px;\n  cursor: pointer;\n  text-decoration: none;\n\n  ', '\n  ', '\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 12px;\n  line-height: 14px;\n  cursor: pointer;\n  text-decoration: none;\n\n  ', '\n  ', '\n\n  &:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject85 = _taggedTemplateLiteral(['\n  position: relative;\n  flex: 1;\n  min-height: 140px;\n  padding: 6px 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-evenly;\n'], ['\n  position: relative;\n  flex: 1;\n  min-height: 140px;\n  padding: 6px 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-evenly;\n']),
	    _templateObject86 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n']),
	    _templateObject87 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ', '\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ', '\n']),
	    _templateObject88 = _taggedTemplateLiteral(['\n  margin-top: 6px;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n  width: ', ';\n'], ['\n  margin-top: 6px;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n  width: ', ';\n']),
	    _templateObject89 = _taggedTemplateLiteral(['\n  font-size: 10px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.88);\n  line-height: 12px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n'], ['\n  font-size: 10px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.88);\n  line-height: 12px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n']),
	    _templateObject90 = _taggedTemplateLiteral(['\n  font-size: 9px;\n  color: rgba(0, 27, 59, 0.55);\n  line-height: 11px;\n  margin-top: 2px;\n  white-space: nowrap;\n'], ['\n  font-size: 9px;\n  color: rgba(0, 27, 59, 0.55);\n  line-height: 11px;\n  margin-top: 2px;\n  white-space: nowrap;\n']),
	    _templateObject91 = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 13px;\n  padding: 4px;\n  box-sizing: border-box;\n  cursor: default;\n  flex-shrink: 0;\n\n  ', '\n'], ['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 13px;\n  padding: 4px;\n  box-sizing: border-box;\n  cursor: default;\n  flex-shrink: 0;\n\n  ', '\n']),
	    _templateObject92 = _taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  text-align: center;\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  ', '\n'], ['\n  display: block;\n  width: 100%;\n  text-align: center;\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  ', '\n']),
	    _templateObject93 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: 12px;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n\n  // .recharts-polar-radius-axis .recharts-polar-radius-axis-ticks .recharts-polar-radius-axis-tick:last-child {\n  //   display: none;\n  // }\n'], ['\n  display: flex;\n  padding: 12px;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n\n  // .recharts-polar-radius-axis .recharts-polar-radius-axis-ticks .recharts-polar-radius-axis-tick:last-child {\n  //   display: none;\n  // }\n']),
	    _templateObject94 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 21.5px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 21.5px;\n']),
	    _templateObject95 = _taggedTemplateLiteral(['\n  padding: 36.5px 0 0 25px;\n\n  .g-recharts-radar-circle {\n    text {\n      font-family: \'Mukta Vaani\', sans-serif;\n      font-weight: 500;\n      font-size: 13.5px;\n      fill: #fff;\n    }\n  }\n'], ['\n  padding: 36.5px 0 0 25px;\n\n  .g-recharts-radar-circle {\n    text {\n      font-family: \'Mukta Vaani\', sans-serif;\n      font-weight: 500;\n      font-size: 13.5px;\n      fill: #fff;\n    }\n  }\n']),
	    _templateObject96 = _taggedTemplateLiteral(['\n  padding-top: 57px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px;\n'], ['\n  padding-top: 57px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px;\n']),
	    _templateObject97 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n']),
	    _templateObject98 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2f4166;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2f4166;\n']),
	    _templateObject99 = _taggedTemplateLiteral(['\n  width: 18px;\n  height: 18px;\n  background: #667689;\n  border-radius: 100px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13.5px;\n  line-height: 18px;\n  text-align: center;\n  color: #fff;\n\n  ', '\n'], ['\n  width: 18px;\n  height: 18px;\n  background: #667689;\n  border-radius: 100px;\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13.5px;\n  line-height: 18px;\n  text-align: center;\n  color: #fff;\n\n  ', '\n']),
	    _templateObject100 = _taggedTemplateLiteral(['\n  display: flex;\n  position: absolute;\n  top: 12px;\n  right: 10px;\n  font-family: \'Roboto\';\n  font-weight: 500;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n  font-size: 11px;\n  line-height: 13px;\n'], ['\n  display: flex;\n  position: absolute;\n  top: 12px;\n  right: 10px;\n  font-family: \'Roboto\';\n  font-weight: 500;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n  font-size: 11px;\n  line-height: 13px;\n']),
	    _templateObject101 = _taggedTemplateLiteral(['\n  padding: 0;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  ', '\n'], ['\n  padding: 0;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  ', '\n']),
	    _templateObject102 = _taggedTemplateLiteral(['\n  padding: 0 6px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  padding: 0 6px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject103 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 362px;\n  margin: 20px auto 0;\n\n  ', '\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 362px;\n  margin: 20px auto 0;\n\n  ', '\n']),
	    _templateObject104 = _taggedTemplateLiteral(['\n  height: 54px;\n  width: 362px;\n  border-top: 1px solid rgba(0, 27, 59, 0.08);\n  background: #fff;\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n\n  &:nth-child(1), &:nth-child(2) {\n    border-top: none;\n  }\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  height: 54px;\n  width: 362px;\n  border-top: 1px solid rgba(0, 27, 59, 0.08);\n  background: #fff;\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n\n  &:nth-child(1), &:nth-child(2) {\n    border-top: none;\n  }\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject105 = _taggedTemplateLiteral(['\n  padding: 30px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  padding: 30px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject106 = _taggedTemplateLiteral(['\n  display: inline;\n  font-size: 12px;\n  margin-left: 3px;\n'], ['\n  display: inline;\n  font-size: 12px;\n  margin-left: 3px;\n']),
	    _templateObject107 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #fff;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #fff;\n']),
	    _templateObject108 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  ', '\n\n  span {\n    display: inline-block;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 54px;\n\n  a:active,\n  a:visited,\n  a:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  &:nth-child(1) {\n    flex-basis: 64px;\n    box-shadow: none;\n  }\n\n  &:nth-child(2) {\n    flex-basis: 128px;\n  }\n\n  &:nth-child(3) {\n    flex-basis: 90px;\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  &:nth-child(4) {\n    flex-basis: 119px;\n  }\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  ', '\n\n  span {\n    display: inline-block;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 54px;\n\n  a:active,\n  a:visited,\n  a:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  &:nth-child(1) {\n    flex-basis: 64px;\n    box-shadow: none;\n  }\n\n  &:nth-child(2) {\n    flex-basis: 128px;\n  }\n\n  &:nth-child(3) {\n    flex-basis: 90px;\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  &:nth-child(4) {\n    flex-basis: 119px;\n  }\n']),
	    _templateObject109 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n']),
	    _templateObject110 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject111 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject112 = _taggedTemplateLiteral(['\n  padding: 16px 20px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n'], ['\n  padding: 16px 20px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n']),
	    _templateObject113 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 24px;\n  flex: 1;\n  min-height: 0;\n  align-items: stretch;\n'], ['\n  display: flex;\n  gap: 24px;\n  flex: 1;\n  min-height: 0;\n  align-items: stretch;\n']),
	    _templateObject114 = _taggedTemplateLiteral(['\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 0;\n  border-left: 1px solid rgba(0, 27, 59, 0.08);\n  padding: 8px 4px 8px 20px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.82);\n  overflow-y: auto;\n\n  /* Subtle custom scrollbar so the list/detail split stays clean. */\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 27, 59, 0.25);\n    border-radius: 3px;\n  }\n'], ['\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 0;\n  border-left: 1px solid rgba(0, 27, 59, 0.08);\n  padding: 8px 4px 8px 20px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.82);\n  overflow-y: auto;\n\n  /* Subtle custom scrollbar so the list/detail split stays clean. */\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 27, 59, 0.25);\n    border-radius: 3px;\n  }\n']),
	    _templateObject115 = _taggedTemplateLiteral(['\n  font-style: italic;\n  color: rgba(0, 27, 59, 0.4);\n'], ['\n  font-style: italic;\n  color: rgba(0, 27, 59, 0.4);\n']),
	    _templateObject116 = _taggedTemplateLiteral(['\n  width: 280px;\n  max-width: 100%;\n  padding: 7px 12px;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 8px;\n  background: #F5F7FB;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.94);\n  outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.45);\n  }\n\n  &:focus {\n    border-color: #5C91F5;\n    background: #FFFFFF;\n  }\n'], ['\n  width: 280px;\n  max-width: 100%;\n  padding: 7px 12px;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 8px;\n  background: #F5F7FB;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.94);\n  outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.45);\n  }\n\n  &:focus {\n    border-color: #5C91F5;\n    background: #FFFFFF;\n  }\n']),
	    _templateObject117 = _taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  flex: 1 1 0;\n  min-width: 0;\n'], ['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  flex: 1 1 0;\n  min-width: 0;\n']),
	    _templateObject118 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  align-items: baseline;\n  gap: 8px;\n  padding: 6px 6px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.06);\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &:last-child { border-bottom: none; }\n'], ['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  align-items: baseline;\n  gap: 8px;\n  padding: 6px 6px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.06);\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &:last-child { border-bottom: none; }\n']),
	    _templateObject119 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.5);\n'], ['\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.5);\n']),
	    _templateObject120 = _taggedTemplateLiteral(['\n  padding: 16px 6px 8px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: #DC2626;\n'], ['\n  padding: 16px 6px 8px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: #DC2626;\n']),
	    _templateObject121 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n\n  &:hover .pf-tooltip {\n    visibility: visible;\n    opacity: 1;\n    transform: translateY(0);\n  }\n'], ['\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n\n  &:hover .pf-tooltip {\n    visibility: visible;\n    opacity: 1;\n    transform: translateY(0);\n  }\n']),
	    _templateObject122 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.12);\n  color: rgba(0, 27, 59, 0.7);\n  font-size: 10px;\n  font-weight: 700;\n  font-style: italic;\n  cursor: help;\n  flex-shrink: 0;\n  user-select: none;\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.12);\n  color: rgba(0, 27, 59, 0.7);\n  font-size: 10px;\n  font-weight: 700;\n  font-style: italic;\n  cursor: help;\n  flex-shrink: 0;\n  user-select: none;\n']),
	    _templateObject123 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: -8px;\n  z-index: 20;\n\n  width: 320px;\n  max-width: 320px;\n  padding: 10px 14px;\n  background: rgba(0, 27, 59, 0.96);\n  color: #ffffff;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 12.5px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0;\n  text-transform: none;\n  border-radius: 6px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n  white-space: normal;\n\n  visibility: hidden;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n\n  &::after {\n    content: "";\n    position: absolute;\n    top: 100%;\n    left: 18px;\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.96);\n  }\n'], ['\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: -8px;\n  z-index: 20;\n\n  width: 320px;\n  max-width: 320px;\n  padding: 10px 14px;\n  background: rgba(0, 27, 59, 0.96);\n  color: #ffffff;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 12.5px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0;\n  text-transform: none;\n  border-radius: 6px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n  white-space: normal;\n\n  visibility: hidden;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n\n  &::after {\n    content: "";\n    position: absolute;\n    top: 100%;\n    left: 18px;\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.96);\n  }\n']),
	    _templateObject124 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-top: 20px;\n  margin-bottom: 4px;\n  max-width: 1300px;\n\n  @media (max-width: 1280px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-top: 20px;\n  margin-bottom: 4px;\n  max-width: 1300px;\n\n  @media (max-width: 1280px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 640px) {\n    grid-template-columns: 1fr;\n  }\n']),
	    _templateObject125 = _taggedTemplateLiteral(['\n  background: #fff;\n  border-radius: 8px;\n  padding: 16px 18px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-height: 96px;\n'], ['\n  background: #fff;\n  border-radius: 8px;\n  padding: 16px 18px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-height: 96px;\n']),
	    _templateObject126 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject127 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n'], ['\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n']),
	    _templateObject128 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: baseline;\n  gap: 18px;\n  flex-wrap: wrap;\n'], ['\n  display: flex;\n  align-items: baseline;\n  gap: 18px;\n  flex-wrap: wrap;\n']),
	    _templateObject129 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject130 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 8px;\n']),
	    _templateObject131 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 14px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 14px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n']),
	    _templateObject132 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject133 = _taggedTemplateLiteral(['\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 18px;\n    text-decoration: underline;\n    color: #5C91F5;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n'], ['\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\', sans-serif;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 18px;\n    text-decoration: underline;\n    color: #5C91F5;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n']),
	    _templateObject134 = _taggedTemplateLiteral(['\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.12s ease;\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 10;\n  background: rgba(0, 27, 59, 0.94);\n  color: #ffffff;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n'], ['\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.12s ease;\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 10;\n  background: rgba(0, 27, 59, 0.94);\n  color: #ffffff;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n']),
	    _templateObject135 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n\n  &:hover ', ' {\n    visibility: visible;\n    opacity: 1;\n  }\n'], ['\n  position: relative;\n  display: inline-block;\n\n  &:hover ', ' {\n    visibility: visible;\n    opacity: 1;\n  }\n']),
	    _templateObject136 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  text-decoration: underline;\n  color: rgba(0, 27, 59, 0.35);\n  cursor: not-allowed;\n  white-space: nowrap;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  text-decoration: underline;\n  color: rgba(0, 27, 59, 0.35);\n  cursor: not-allowed;\n  white-space: nowrap;\n']),
	    _templateObject137 = _taggedTemplateLiteral(['\n  width: 100%;\n  min-height: 580px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 18px 18px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n'], ['\n  width: 100%;\n  min-height: 580px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 18px 18px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n']),
	    _templateObject138 = _taggedTemplateLiteral(['\n  width: 100%;\n  min-height: 580px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 18px 18px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  grid-column: 1 / -1;\n'], ['\n  width: 100%;\n  min-height: 580px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  padding: 18px 18px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  grid-column: 1 / -1;\n']),
	    _templateObject139 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject140 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  flex-wrap: wrap;\n  min-width: 0;\n'], ['\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  flex-wrap: wrap;\n  min-width: 0;\n']),
	    _templateObject141 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  line-height: 19px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-top: -4px;\n  max-width: 720px;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  line-height: 19px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-top: -4px;\n  max-width: 720px;\n']),
	    _templateObject142 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 1fr 1px 1fr;\n  gap: 24px;\n  align-items: start;\n  flex: 1;\n  min-height: 0;\n'], ['\n  display: grid;\n  grid-template-columns: 1fr 1px 1fr;\n  gap: 24px;\n  align-items: start;\n  flex: 1;\n  min-height: 0;\n']),
	    _templateObject143 = _taggedTemplateLiteral(['\n  background: rgba(0, 27, 59, 0.10);\n  width: 1px;\n  align-self: stretch;\n'], ['\n  background: rgba(0, 27, 59, 0.10);\n  width: 1px;\n  align-self: stretch;\n']),
	    _templateObject144 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n']),
	    _templateObject145 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.04em;\n  color: rgba(0, 27, 59, 0.78);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.04em;\n  color: rgba(0, 27, 59, 0.78);\n  text-transform: uppercase;\n']),
	    _templateObject146 = _taggedTemplateLiteral(['\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 24px;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n'], ['\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 24px;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n']),
	    _templateObject147 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.65);\n  max-width: 460px;\n'], ['\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.65);\n  max-width: 460px;\n']),
	    _templateObject148 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n  padding: 12px 28px;\n  background: #3258F5;\n  color: #fff;\n  border: 0;\n  border-radius: 28px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover { background: #2545cc; }\n\n  &:disabled {\n    background: rgba(0, 27, 59, 0.18);\n    color: rgba(0, 27, 59, 0.55);\n    cursor: not-allowed;\n  }\n  &:disabled:hover { background: rgba(0, 27, 59, 0.18); }\n'], ['\n  margin-top: 20px;\n  padding: 12px 28px;\n  background: #3258F5;\n  color: #fff;\n  border: 0;\n  border-radius: 28px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover { background: #2545cc; }\n\n  &:disabled {\n    background: rgba(0, 27, 59, 0.18);\n    color: rgba(0, 27, 59, 0.55);\n    cursor: not-allowed;\n  }\n  &:disabled:hover { background: rgba(0, 27, 59, 0.18); }\n']),
	    _templateObject149 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n  padding: 12px 18px;\n  background: #DBEAFE;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 19px;\n  color: #1D4ED8;\n  font-weight: 500;\n  max-width: 480px;\n'], ['\n  margin-top: 20px;\n  padding: 12px 18px;\n  background: #DBEAFE;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 19px;\n  color: #1D4ED8;\n  font-weight: 500;\n  max-width: 480px;\n']),
	    _templateObject150 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 41, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n  font-family: \'Mukta Vaani\', sans-serif;\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 41, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n  font-family: \'Mukta Vaani\', sans-serif;\n']),
	    _templateObject151 = _taggedTemplateLiteral(['\n  width: 440px;\n  max-width: 92vw;\n  background: #fff;\n  border-radius: 14px;\n  padding: 28px 28px 22px;\n  box-shadow: 0 24px 70px rgba(15, 23, 41, 0.28);\n'], ['\n  width: 440px;\n  max-width: 92vw;\n  background: #fff;\n  border-radius: 14px;\n  padding: 28px 28px 22px;\n  box-shadow: 0 24px 70px rgba(15, 23, 41, 0.28);\n']),
	    _templateObject152 = _taggedTemplateLiteral(['\n  font-size: 19px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 10px;\n'], ['\n  font-size: 19px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 10px;\n']),
	    _templateObject153 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.78);\n  margin-bottom: 22px;\n'], ['\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.78);\n  margin-bottom: 22px;\n']),
	    _templateObject154 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n']),
	    _templateObject155 = _taggedTemplateLiteral(['\n  padding: 10px 18px;\n  background: #fff;\n  color: rgba(0, 27, 59, 0.78);\n  border: 1px solid #E5E9F0;\n  border-radius: 22px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  &:hover { background: #F8FAFD; color: rgba(0, 27, 59, 0.94); }\n'], ['\n  padding: 10px 18px;\n  background: #fff;\n  color: rgba(0, 27, 59, 0.78);\n  border: 1px solid #E5E9F0;\n  border-radius: 22px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  &:hover { background: #F8FAFD; color: rgba(0, 27, 59, 0.94); }\n']),
	    _templateObject156 = _taggedTemplateLiteral(['\n  padding: 10px 20px;\n  background: #3258F5;\n  color: #fff;\n  border: 0;\n  border-radius: 22px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  &:hover { background: #2545cc; }\n'], ['\n  padding: 10px 20px;\n  background: #3258F5;\n  color: #fff;\n  border: 0;\n  border-radius: 22px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  &:hover { background: #2545cc; }\n']),
	    _templateObject157 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n']),
	    _templateObject158 = _taggedTemplateLiteral(['\n  font-family: \'Roboto\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n'], ['\n  font-family: \'Roboto\', sans-serif;\n  font-weight: 500;\n  font-size: 11.5px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  color: rgba(0, 27, 59, 0.38);\n']),
	    _templateObject159 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 44px 60px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 6px 2px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.08);\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n'], ['\n  display: grid;\n  grid-template-columns: 44px 60px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 6px 2px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.08);\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n']),
	    _templateObject160 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 44px 60px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 2px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.04);\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &:last-child {\n    border-bottom: none;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 44px 60px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 2px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.04);\n\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &:last-child {\n    border-bottom: none;\n  }\n']),
	    _templateObject161 = _taggedTemplateLiteral(['\n  width: 52px;\n  height: 24px;\n  border-radius: 6px;\n  background: #F3F4F6;\n  border: 1px solid #E5E7EB;\n  color: #374151;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n'], ['\n  width: 52px;\n  height: 24px;\n  border-radius: 6px;\n  background: #F3F4F6;\n  border: 1px solid #E5E7EB;\n  color: #374151;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n']),
	    _templateObject162 = _taggedTemplateLiteral(['\n  position: relative;\n  flex-shrink: 0;\n'], ['\n  position: relative;\n  flex-shrink: 0;\n']),
	    _templateObject163 = _taggedTemplateLiteral(['\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.18);\n  border-radius: 8px;\n  padding: 8px 36px 8px 14px;\n  min-width: 220px;\n  text-align: left;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: ', ';\n  cursor: pointer;\n  position: relative;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.35);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: #3A507B;\n    box-shadow: 0 0 0 3px rgba(58, 80, 123, 0.14);\n  }\n'], ['\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.18);\n  border-radius: 8px;\n  padding: 8px 36px 8px 14px;\n  min-width: 220px;\n  text-align: left;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: ', ';\n  cursor: pointer;\n  position: relative;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.35);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: #3A507B;\n    box-shadow: 0 0 0 3px rgba(58, 80, 123, 0.14);\n  }\n']),
	    _templateObject164 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  width: 8px;\n  height: 8px;\n  border-right: 1.5px solid rgba(0, 27, 59, 0.4);\n  border-bottom: 1.5px solid rgba(0, 27, 59, 0.4);\n  transform: translateY(-70%) rotate(45deg);\n  pointer-events: none;\n'], ['\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  width: 8px;\n  height: 8px;\n  border-right: 1.5px solid rgba(0, 27, 59, 0.4);\n  border-bottom: 1.5px solid rgba(0, 27, 59, 0.4);\n  transform: translateY(-70%) rotate(45deg);\n  pointer-events: none;\n']),
	    _templateObject165 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 240px;\n  max-height: 280px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.14);\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(0, 27, 59, 0.14);\n  z-index: 50;\n  padding: 6px 0;\n'], ['\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 240px;\n  max-height: 280px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.14);\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(0, 27, 59, 0.14);\n  z-index: 50;\n  padding: 6px 0;\n']),
	    _templateObject166 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(58, 80, 123, 0.06);\n  }\n\n  input {\n    margin: 0;\n    cursor: pointer;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(58, 80, 123, 0.06);\n  }\n\n  input {\n    margin: 0;\n    cursor: pointer;\n  }\n']),
	    _templateObject167 = _taggedTemplateLiteral(['\n  padding: 10px 14px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.5);\n'], ['\n  padding: 10px 14px;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.5);\n']),
	    _templateObject168 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 10px 4px;\n  border-top: 1px solid rgba(0, 27, 59, 0.08);\n  margin-top: 4px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 10px 4px;\n  border-top: 1px solid rgba(0, 27, 59, 0.08);\n  margin-top: 4px;\n']),
	    _templateObject169 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 6px;\n\n  &:hover:not(:disabled) {\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n'], ['\n  background: none;\n  border: none;\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 6px;\n\n  &:hover:not(:disabled) {\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n']),
	    _templateObject170 = _taggedTemplateLiteral(['\n  overflow-y: auto;\n  max-height: 460px;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 27, 59, 0.25);\n    border-radius: 3px;\n  }\n'], ['\n  overflow-y: auto;\n  max-height: 460px;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 27, 59, 0.25);\n    border-radius: 3px;\n  }\n']),
	    _templateObject171 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-left: 6px;\n'], ['\n  font-family: \'Mukta Vaani\', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-left: 6px;\n']),
	    _templateObject172 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
	    _templateObject173 = _taggedTemplateLiteral(['\n  margin-left: 6px;\n  color: rgba(50, 88, 245, 0.85);\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n'], ['\n  margin-left: 6px;\n  color: rgba(50, 88, 245, 0.85);\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n']),
	    _templateObject174 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Above every other dashboard overlay (TeamLookup 1200,\n     SpotlightConfirm 1300, badges tour/review 1500-1900) so the\n     Insights popup for a Least Valuable teammate can\'t get covered\n     by the Student Spotlight card behind it. Same layer as the\n     Skills Badge popup (2000) since they\'re triggered from adjacent\n     rows in the same card. */\n  z-index: 2000;\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Above every other dashboard overlay (TeamLookup 1200,\n     SpotlightConfirm 1300, badges tour/review 1500-1900) so the\n     Insights popup for a Least Valuable teammate can\'t get covered\n     by the Student Spotlight card behind it. Same layer as the\n     Skills Badge popup (2000) since they\'re triggered from adjacent\n     rows in the same card. */\n  z-index: 2000;\n']),
	    _templateObject175 = _taggedTemplateLiteral(['\n  background: #fff;\n  border-radius: 14px;\n  width: 680px;\n  max-width: 92vw;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);\n  font-family: \'Mukta Vaani\', sans-serif;\n  position: relative;\n'], ['\n  background: #fff;\n  border-radius: 14px;\n  width: 680px;\n  max-width: 92vw;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);\n  font-family: \'Mukta Vaani\', sans-serif;\n  position: relative;\n']),
	    _templateObject176 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  z-index: 5;\n  background: none;\n  border: 0;\n  color: rgba(0, 27, 59, 0.55);\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  &:hover { color: rgba(0, 27, 59, 0.94); }\n'], ['\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  z-index: 5;\n  background: none;\n  border: 0;\n  color: rgba(0, 27, 59, 0.55);\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  &:hover { color: rgba(0, 27, 59, 0.94); }\n']),
	    _templateObject177 = _taggedTemplateLiteral(['\n  padding: 28px 36px 0;\n'], ['\n  padding: 28px 36px 0;\n']),
	    _templateObject178 = _taggedTemplateLiteral(['\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #EC5E59;\n'], ['\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #EC5E59;\n']),
	    _templateObject179 = _taggedTemplateLiteral(['\n  margin-top: 6px;\n  font-size: 24px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  margin-top: 6px;\n  font-size: 24px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject180 = _taggedTemplateLiteral(['\n  margin-top: 4px;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n'], ['\n  margin-top: 4px;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n']),
	    _templateObject181 = _taggedTemplateLiteral(['\n  padding: 22px 36px 32px;\n  overflow-y: auto;\n'], ['\n  padding: 22px 36px 32px;\n  overflow-y: auto;\n']),
	    _templateObject182 = _taggedTemplateLiteral(['\n  margin-top: 18px;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  &:first-child { margin-top: 0; }\n'], ['\n  margin-top: 18px;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  &:first-child { margin-top: 0; }\n']),
	    _templateObject183 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.78);\n'], ['\n  font-size: 14px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.78);\n']),
	    _templateObject184 = _taggedTemplateLiteral(['\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n'], ['\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n']),
	    _templateObject185 = _taggedTemplateLiteral(['\n  padding-left: 14px;\n  border-left: 4px solid #EC5E59;\n  font-size: 14px;\n  line-height: 22px;\n  font-style: italic;\n  color: rgba(0, 27, 59, 0.78);\n'], ['\n  padding-left: 14px;\n  border-left: 4px solid #EC5E59;\n  font-size: 14px;\n  line-height: 22px;\n  font-style: italic;\n  color: rgba(0, 27, 59, 0.78);\n']),
	    _templateObject186 = _taggedTemplateLiteral(['\n  font-style: normal;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.65);\n  margin-top: 4px;\n  font-size: 12px;\n'], ['\n  font-style: normal;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.65);\n  margin-top: 4px;\n  font-size: 12px;\n']),
	    _templateObject187 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n  font-style: italic;\n'], ['\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n  font-style: italic;\n']),
	    _templateObject188 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  padding: 18px 20px;\n  background: #fff;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  font-family: \'Mukta Vaani\', sans-serif;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.10);\n    border-color: rgba(37, 99, 235, 0.45);\n  }\n  &:focus {\n    outline: 2px solid rgba(37, 99, 235, 0.45);\n    outline-offset: 2px;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  padding: 18px 20px;\n  background: #fff;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  font-family: \'Mukta Vaani\', sans-serif;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.10);\n    border-color: rgba(37, 99, 235, 0.45);\n  }\n  &:focus {\n    outline: 2px solid rgba(37, 99, 235, 0.45);\n    outline-offset: 2px;\n  }\n']),
	    _templateObject189 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F1729;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F1729;\n']),
	    _templateObject190 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  background: #DBEAFE;\n  color: #2563EB;\n  font-size: 12px;\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  background: #DBEAFE;\n  color: #2563EB;\n  font-size: 12px;\n']),
	    _templateObject191 = _taggedTemplateLiteral(['\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid #E5E9F0;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4B5563;\n  background: #F8FAFD;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n'], ['\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid #E5E9F0;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4B5563;\n  background: #F8FAFD;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n']),
	    _templateObject192 = _taggedTemplateLiteral(['\n  padding: 9px 12px;\n  border: 1px solid #E5E9F0;\n  border-radius: 8px;\n  background: #F8FAFD;\n  font-size: 13px;\n  color: rgba(15, 23, 41, 0.42);\n'], ['\n  padding: 9px 12px;\n  border: 1px solid #E5E9F0;\n  border-radius: 8px;\n  background: #F8FAFD;\n  font-size: 13px;\n  color: rgba(15, 23, 41, 0.42);\n']),
	    _templateObject193 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  color: #4B5563;\n'], ['\n  font-size: 12px;\n  color: #4B5563;\n']),
	    _templateObject194 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 41, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  z-index: 1200;\n  padding-top: 80px;\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 41, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  z-index: 1200;\n  padding-top: 80px;\n']),
	    _templateObject195 = _taggedTemplateLiteral(['\n  width: 580px;\n  max-width: 92vw;\n  max-height: 76vh;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 24px 70px rgba(15, 23, 41, 0.28);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: \'Mukta Vaani\', sans-serif;\n  color: #0F1729;\n\n  @media (max-width: 600px) {\n    width: 96vw;\n  }\n'], ['\n  width: 580px;\n  max-width: 92vw;\n  max-height: 76vh;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 24px 70px rgba(15, 23, 41, 0.28);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: \'Mukta Vaani\', sans-serif;\n  color: #0F1729;\n\n  @media (max-width: 600px) {\n    width: 96vw;\n  }\n']),
	    _templateObject196 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #E5E9F0;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #E5E9F0;\n']),
	    _templateObject197 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  color: #4B5563;\n'], ['\n  font-size: 16px;\n  color: #4B5563;\n']),
	    _templateObject198 = _taggedTemplateLiteral(['\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font: inherit;\n  font-size: 16px;\n  color: #0F1729;\n  &::placeholder { color: rgba(15, 23, 41, 0.45); }\n'], ['\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font: inherit;\n  font-size: 16px;\n  color: #0F1729;\n  &::placeholder { color: rgba(15, 23, 41, 0.45); }\n']),
	    _templateObject199 = _taggedTemplateLiteral(['\n  border: 0;\n  background: none;\n  font-size: 22px;\n  line-height: 1;\n  color: #4B5563;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  &:hover { background: #F1F4FA; color: #0F1729; }\n'], ['\n  border: 0;\n  background: none;\n  font-size: 22px;\n  line-height: 1;\n  color: #4B5563;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  &:hover { background: #F1F4FA; color: #0F1729; }\n']),
	    _templateObject200 = _taggedTemplateLiteral(['\n  flex: 1;\n  overflow-y: auto;\n  padding: 6px;\n'], ['\n  flex: 1;\n  overflow-y: auto;\n  padding: 6px;\n']),
	    _templateObject201 = _taggedTemplateLiteral(['\n  padding: 14px 14px 8px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: rgba(15, 23, 41, 0.45);\n'], ['\n  padding: 14px 14px 8px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: rgba(15, 23, 41, 0.45);\n']),
	    _templateObject202 = _taggedTemplateLiteral(['\n  color: rgba(15, 23, 41, 0.78);\n'], ['\n  color: rgba(15, 23, 41, 0.78);\n']),
	    _templateObject203 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 36px 1fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  ', '\n  &:hover { background: #DBEAFE; }\n'], ['\n  display: grid;\n  grid-template-columns: 36px 1fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  ', '\n  &:hover { background: #DBEAFE; }\n']),
	    _templateObject204 = _taggedTemplateLiteral(['\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%);\n  color: #1D4ED8;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%);\n  color: #1D4ED8;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject205 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n']),
	    _templateObject206 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F1729;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F1729;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
	    _templateObject207 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-family: \'Mukta Vaani\', sans-serif;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-family: \'Mukta Vaani\', sans-serif;\n']),
	    _templateObject208 = _taggedTemplateLiteral(['\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1;\n  color: ', ';\n'], ['\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1;\n  color: ', ';\n']),
	    _templateObject209 = _taggedTemplateLiteral(['\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: rgba(15, 23, 41, 0.45);\n'], ['\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: rgba(15, 23, 41, 0.45);\n']),
	    _templateObject210 = _taggedTemplateLiteral(['\n  padding: 28px 16px;\n  text-align: center;\n  color: #4B5563;\n  font-size: 13px;\n'], ['\n  padding: 28px 16px;\n  text-align: center;\n  color: #4B5563;\n  font-size: 13px;\n']),
	    _templateObject211 = _taggedTemplateLiteral(['\n  padding: 10px 16px;\n  border-top: 1px solid #E5E9F0;\n  display: flex;\n  justify-content: space-between;\n  font-size: 11.5px;\n  color: #4B5563;\n'], ['\n  padding: 10px 16px;\n  border-top: 1px solid #E5E9F0;\n  display: flex;\n  justify-content: space-between;\n  font-size: 11.5px;\n  color: #4B5563;\n']),
	    _templateObject212 = _taggedTemplateLiteral(['\n  padding: 1px 6px;\n  border: 1px solid #E5E9F0;\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11px;\n  color: #4B5563;\n  background: #F8FAFD;\n  margin-right: 4px;\n'], ['\n  padding: 1px 6px;\n  border: 1px solid #E5E9F0;\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11px;\n  color: #4B5563;\n  background: #F8FAFD;\n  margin-right: 4px;\n']),
	    _templateObject213 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid #E5E9F0;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid #E5E9F0;\n']),
	    _templateObject214 = _taggedTemplateLiteral(['\n  margin-left: auto;\n  background: none;\n  border: 1px solid #E5E9F0;\n  border-radius: 8px;\n  padding: 6px 12px;\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #4B5563;\n  cursor: pointer;\n  &:hover { background: #F1F4FA; color: #0F1729; }\n'], ['\n  margin-left: auto;\n  background: none;\n  border: 1px solid #E5E9F0;\n  border-radius: 8px;\n  padding: 6px 12px;\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #4B5563;\n  cursor: pointer;\n  &:hover { background: #F1F4FA; color: #0F1729; }\n']),
	    _templateObject215 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 18px;\n\n  @media (max-width: 600px) {\n    grid-template-columns: 1fr;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 18px;\n\n  @media (max-width: 600px) {\n    grid-template-columns: 1fr;\n  }\n']),
	    _templateObject216 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 18px;\n  border-radius: 10px;\n  border: 1.5px solid transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n\n  ', '\n  ', '\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(15, 23, 41, 0.10);\n    ', '\n    ', '\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 18px;\n  border-radius: 10px;\n  border: 1.5px solid transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n\n  ', '\n  ', '\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(15, 23, 41, 0.10);\n    ', '\n    ', '\n  }\n']),
	    _templateObject217 = _taggedTemplateLiteral(['\n  font-size: 15px;\n  font-weight: 800;\n'], ['\n  font-size: 15px;\n  font-weight: 800;\n']),
	    _templateObject218 = _taggedTemplateLiteral(['\n  font-size: 12.5px;\n  line-height: 18px;\n  color: rgba(15, 23, 41, 0.65);\n'], ['\n  font-size: 12.5px;\n  line-height: 18px;\n  color: rgba(15, 23, 41, 0.65);\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DropDownContainer = exports.DropDownContainer = _styledComponents2.default.div(_templateObject);
	
	var DropDownHeader = exports.DropDownHeader = _styledComponents2.default.div(_templateObject2);
	
	var DropDownHeaderArrow = exports.DropDownHeaderArrow = _styledComponents2.default.div(_templateObject3);
	
	var DropDownListContainer = exports.DropDownListContainer = _styledComponents2.default.div(_templateObject4);
	
	var DropDownList = exports.DropDownList = _styledComponents2.default.ul(_templateObject5);
	
	var DropDownListItem = exports.DropDownListItem = _styledComponents2.default.li(_templateObject6, function (p) {
	  return p.isSelected && '\n    color: #fff;\n    background-color: #5c91f5;\n  ';
	});
	
	var Styled = {};
	
	Styled.Body = _styledComponents2.default.div(_templateObject7);
	
	Styled.SurveyDropDown = (0, _styledComponents2.default)(DropDownHeader)(_templateObject8);
	
	Styled.SurveyDropDownList = (0, _styledComponents2.default)(DropDownList)(_templateObject8);
	
	Styled.AbsoluteListContainer = (0, _styledComponents2.default)(DropDownListContainer)(_templateObject9);
	
	Styled.DownloadLink = _styledComponents2.default.a(_templateObject10);
	
	Styled.Title = _styledComponents2.default.div(_templateObject11, function (p) {
	  return p.marginTop && '\n    margin-top: ' + p.marginTop + ';\n  ';
	});
	
	Styled.Description = _styledComponents2.default.div(_templateObject12);
	
	Styled.DescriptionText = _styledComponents2.default.div(_templateObject13);
	
	// Two columns: the left column stacks Engagement + Team Insights; the
	// right column is a 1fr 1fr grid so Top Performers and Bottom
	// Performers sit side-by-side. Both halves of the row share width
	// fairly evenly so the right side has room for two compact Performers
	// cards. Wraps on narrow viewports.
	Styled.Flex = _styledComponents2.default.div(_templateObject14);
	
	Styled.Row = _styledComponents2.default.div(_templateObject15);
	
	Styled.Block = _styledComponents2.default.div(_templateObject16, function (p) {
	  return !p.isMenuExpanded && '\n    width: 418px;\n  ';
	}, function (p) {
	  return p.twoRowsLength && '\n    height: 580px;\n  ';
	}, function (p) {
	  return p.twoColumnsLength && p.isMenuExpanded && '\n    width: 760px;\n  ';
	}, function (p) {
	  return p.twoColumnsLength && !p.isMenuExpanded && '\n    width: 856px;\n  ';
	}, function (p) {
	  return p.fullWidth && '\n    width: 100%;\n  ';
	});
	
	// Modern card look (mirrors decisions/product-marketing): single white
	// surface with a soft shadow, no dark-blue header bar. The title row
	// becomes a flush header inside the card with a thin divider below.
	// min-height instead of a fixed height so the Performance Feedback
	// block can fit a stacked title + subtitle alongside a search bar
	// without clipping.
	Styled.BlockTitle = _styledComponents2.default.div(_templateObject17);
	
	Styled.BlockContent = _styledComponents2.default.div(_templateObject18);
	
	Styled.BlockScroll = _styledComponents2.default.div(_templateObject19);
	
	Styled.BlockHint = _styledComponents2.default.div(_templateObject20);
	
	Styled.BlockHintStatus = _styledComponents2.default.div(_templateObject21);
	
	Styled.StudentStatsButton = _styledComponents2.default.button(_templateObject22);
	
	Styled.StudentsErrorContainer = _styledComponents2.default.div(_templateObject23);
	
	Styled.Label = _styledComponents2.default.p(_templateObject24);
	
	Styled.Engagement = {};
	
	Styled.Engagement.Columns = _styledComponents2.default.div(_templateObject25);
	
	Styled.Engagement.Title = _styledComponents2.default.div(_templateObject26);
	
	Styled.Engagement.Dropdown = _styledComponents2.default.div(_templateObject27);
	
	Styled.Engagement.DropDownHeader = (0, _styledComponents2.default)(DropDownHeader)(_templateObject28);
	
	Styled.Engagement.DropDownList = (0, _styledComponents2.default)(DropDownList)(_templateObject28);
	
	Styled.Engagement.LeftColumn = _styledComponents2.default.div(_templateObject29);
	
	Styled.Engagement.PercentAmount = _styledComponents2.default.div(_templateObject30);
	
	Styled.Engagement.PercentAmountValue = _styledComponents2.default.div(_templateObject31);
	
	Styled.Engagement.PercentAmountPercent = _styledComponents2.default.div(_templateObject32);
	
	Styled.Engagement.Description = _styledComponents2.default.div(_templateObject33);
	
	Styled.Engagement.RightColumn = _styledComponents2.default.div(_templateObject34);
	
	Styled.Engagement.ChartTitle = _styledComponents2.default.div(_templateObject35);
	
	Styled.Engagement.Chart = _styledComponents2.default.div(_templateObject36, function (p) {
	  return p.marginTop && '\n    margin-top: ' + p.marginTop + ';\n  ';
	});
	
	Styled.Performance = {};
	
	Styled.Performance.Columns = _styledComponents2.default.div(_templateObject37);
	
	Styled.Performance.LeftColumn = _styledComponents2.default.div(_templateObject38);
	
	Styled.Performance.BigPercentValue = _styledComponents2.default.div(_templateObject39);
	
	Styled.Performance.PercentLabel = _styledComponents2.default.div(_templateObject40, function (p) {
	  return p.marginTop && '\n    margin-top: ' + p.marginTop + ';\n  ';
	});
	
	Styled.Performance.SmallPercentValue = _styledComponents2.default.div(_templateObject41);
	
	Styled.Performance.PercentGroup = _styledComponents2.default.div(_templateObject42);
	
	Styled.Performance.RightColumn = _styledComponents2.default.div(_templateObject43);
	
	Styled.Performance.RightTitle = _styledComponents2.default.div(_templateObject44);
	
	Styled.Performance.ButtonsGroup = _styledComponents2.default.div(_templateObject45);
	
	Styled.Performance.Button = _styledComponents2.default.button(_templateObject46);
	
	Styled.TeamDynamics = {};
	
	Styled.TeamDynamics.WhiteOverlay = _styledComponents2.default.div(_templateObject47);
	
	Styled.TeamDynamics.ProcessButton = _styledComponents2.default.div(_templateObject48);
	
	Styled.TeamDynamics.UpdateButton = _styledComponents2.default.div(_templateObject49);
	
	Styled.TeamDynamics.Columns = _styledComponents2.default.div(_templateObject50);
	
	Styled.TeamDynamics.LeftColumn = _styledComponents2.default.div(_templateObject51);
	
	Styled.TeamDynamics.RightColumn = _styledComponents2.default.div(_templateObject52);
	
	Styled.TeamDynamics.BorderedRight = _styledComponents2.default.div(_templateObject53);
	
	Styled.TeamDynamics.LabelsTitle = _styledComponents2.default.div(_templateObject54);
	
	Styled.TeamDynamics.LabelCentered = _styledComponents2.default.div(_templateObject55);
	
	Styled.TeamDynamics.LabelWrapper = _styledComponents2.default.div(_templateObject56);
	
	Styled.TeamDynamics.Label = _styledComponents2.default.a(_templateObject57);
	
	Styled.TeamDynamics.LabelIcon = _styledComponents2.default.div(_templateObject58, function (p) {
	  return p.color && '\n    background: ' + p.color + ';\n  ';
	});
	
	Styled.TeamDynamics.BubblePanel = _styledComponents2.default.div(_templateObject59);
	
	// Wrap the in-block chart area so we can attach the hover handler
	// to the charts only (not the header where Update/Search/Download
	// live).
	Styled.TeamDynamics.ChartHoverArea = _styledComponents2.default.div(_templateObject60);
	
	// Hover-popup overlay (full-size design view). Fixed to the
	// viewport, dimmed backdrop, centered card.
	Styled.TeamDynamics.PopupBackdrop = _styledComponents2.default.div(_templateObject61);
	
	Styled.TeamDynamics.PopupCard = _styledComponents2.default.div(_templateObject62);
	
	Styled.TeamDynamics.PopupTitle = _styledComponents2.default.div(_templateObject63);
	
	Styled.TeamDynamics.PopupSubtitle = _styledComponents2.default.div(_templateObject64);
	
	Styled.TeamDynamics.PopupColumns = _styledComponents2.default.div(_templateObject65);
	
	Styled.TeamDynamics.PopupSection = _styledComponents2.default.div(_templateObject66);
	
	Styled.TeamDynamics.PopupSectionLabel = _styledComponents2.default.div(_templateObject67);
	
	Styled.TeamDynamics.PopupSectionHint = _styledComponents2.default.div(_templateObject68);
	
	Styled.TeamDynamics.PopupChartFrame = _styledComponents2.default.div(_templateObject69);
	
	Styled.TeamDynamics.DonutCenter = _styledComponents2.default.div(_templateObject70);
	
	Styled.TeamDynamics.DonutCenterNumber = _styledComponents2.default.div(_templateObject71);
	
	Styled.TeamDynamics.DonutCenterLabel = _styledComponents2.default.div(_templateObject72);
	
	// Center label rendered inside the donut hole (e.g. "Did Not Work
	// Well" stacked across two short lines).
	Styled.TeamDynamics.DonutCenterStackedLabel = _styledComponents2.default.div(_templateObject73);
	
	Styled.TeamDynamics.LegendList = _styledComponents2.default.div(_templateObject74);
	
	Styled.TeamDynamics.LegendItem = _styledComponents2.default.div(_templateObject75);
	
	Styled.TeamDynamics.LegendDot = _styledComponents2.default.div(_templateObject76, function (p) {
	  return p.color || '#ccc';
	});
	
	Styled.TeamDynamics.LegendName = _styledComponents2.default.div(_templateObject77);
	
	Styled.TeamDynamics.LegendValue = _styledComponents2.default.div(_templateObject78);
	
	Styled.TeamDynamics.BubbleSectionHeader = _styledComponents2.default.div(_templateObject79);
	
	// "Eval: Initial, Final" toggle sitting above the donut, on the same
	// horizontal baseline as BubbleSectionHeader.
	Styled.TeamDynamics.EvalToggleRow = _styledComponents2.default.div(_templateObject80);
	
	Styled.TeamDynamics.EvalToggleOption = _styledComponents2.default.a(_templateObject81, function (p) {
	  return p.active && '\n    color: #2f4166;\n  ';
	}, function (p) {
	  return !p.active && '\n    color: rgba(0, 27, 59, 0.40);\n  ';
	});
	
	Styled.TeamDynamics.EvalToggleSeparator = _styledComponents2.default.span(_templateObject82);
	
	Styled.TeamDynamics.BubbleTabs = _styledComponents2.default.div(_templateObject83);
	
	Styled.TeamDynamics.BubbleTab = _styledComponents2.default.a(_templateObject84, function (p) {
	  return p.active && '\n    font-weight: 700;\n    color: #2f4166;\n  ';
	}, function (p) {
	  return !p.active && '\n    font-weight: 500;\n    color: #7c8aa3;\n  ';
	});
	
	Styled.TeamDynamics.BubbleArea = _styledComponents2.default.div(_templateObject85);
	
	// Wrapper that stacks a bubble + its caption. Sits as a flex item
	// inside BubbleArea so space-evenly takes care of even gaps.
	Styled.TeamDynamics.BubbleSlot = _styledComponents2.default.div(_templateObject86);
	
	// Fixed-height frame around each bubble. By making every slot's
	// frame the same height (= MAX_SIZE) and centering the bubble inside,
	// bubbles of varying diameters share the same vertical center line.
	Styled.TeamDynamics.BubbleFrame = _styledComponents2.default.div(_templateObject87, function (p) {
	  return 'height: ' + p.height + 'px;';
	});
	
	Styled.TeamDynamics.BubbleCaption = _styledComponents2.default.div(_templateObject88, function (p) {
	  return p.captionWidth || '70px';
	});
	
	Styled.TeamDynamics.BubbleCaptionName = _styledComponents2.default.div(_templateObject89);
	
	Styled.TeamDynamics.BubbleCaptionCount = _styledComponents2.default.div(_templateObject90);
	
	Styled.TeamDynamics.Bubble = _styledComponents2.default.div(_templateObject91, function (p) {
	  return '\n    width: ' + p.size + 'px;\n    height: ' + p.size + 'px;\n    background: ' + p.color + ';\n    border: 2px solid ' + (p.borderColor || p.color) + ';\n    color: ' + (p.textColor || p.borderColor || '#2f4166') + ';\n  ';
	});
	
	Styled.TeamDynamics.BubbleLabel = _styledComponents2.default.span(_templateObject92, function (p) {
	  return p.fontSize && '\n    font-size: ' + p.fontSize + 'px;\n    line-height: ' + Math.max(p.fontSize + 1, 10) + 'px;\n  ';
	});
	
	Styled.SkillSets = {};
	
	Styled.SkillSets.Container = _styledComponents2.default.div(_templateObject93);
	
	Styled.SkillSets.Columns = _styledComponents2.default.div(_templateObject94);
	
	Styled.SkillSets.LeftColumn = _styledComponents2.default.div(_templateObject95);
	
	Styled.SkillSets.RightColumn = _styledComponents2.default.div(_templateObject96);
	
	Styled.SkillSets.SkillItem = _styledComponents2.default.div(_templateObject97);
	
	Styled.SkillSets.Label = _styledComponents2.default.div(_templateObject98);
	
	Styled.SkillSets.NumCircle = _styledComponents2.default.div(_templateObject99, function (p) {
	  return p.isActive && '\n    background: #eca427;\n  ';
	});
	
	Styled.SkillSets.Switcher = _styledComponents2.default.div(_templateObject100);
	
	Styled.SkillSets.SwitcherItem = _styledComponents2.default.button(_templateObject101, function (p) {
	  return p.isActive && '\n    cursor: default;\n    pointer-events: none;\n    color: rgba(0, 27, 59, 0.94);\n  ';
	});
	
	Styled.SkillSets.SwitcherItemDivider = _styledComponents2.default.span(_templateObject102);
	
	Styled.Leaderboard = {};
	
	Styled.Leaderboard.Table = _styledComponents2.default.div(_templateObject103, function (p) {
	  return !p.isMenuExpanded && '\n    width: 410px;\n  ';
	});
	
	Styled.Leaderboard.Row = _styledComponents2.default.div(_templateObject104, function (p) {
	  return !p.isMenuExpanded && '\n    width: 410px;\n  ';
	}, function (p) {
	  return p.isIndex1 && '\n    background-color: #fdd38a;\n  ';
	}, function (p) {
	  return p.isIndex2 && '\n    background-color: #fce0b0;\n  ';
	}, function (p) {
	  return p.isIndex3 && '\n    background-color: #fbedd5;\n  ';
	});
	
	Styled.Leaderboard.Loader = _styledComponents2.default.div(_templateObject105);
	
	Styled.Leaderboard.SortChar = _styledComponents2.default.div(_templateObject106);
	
	Styled.LoadingData = _styledComponents2.default.div(_templateObject107);
	
	Styled.Leaderboard.Column = _styledComponents2.default.div(_templateObject108, function (p) {
	  return p.hasShadow && '\n    box-shadow: -18px 0px 0px -17px rgba(0, 0, 0, 0.06);\n  ';
	}, function (p) {
	  return p.hasSort && '\n    cursor: pointer;\n  ';
	});
	
	// ---------- Performance Feedback block (repurposed Engagement) ----------
	
	// Title row + subtitle stacked inside the existing Styled.BlockTitle
	// so the modern card header reads "Performance Feedback / Why Teams
	// Didn't Hit Their Targets".
	Styled.PerfFeedbackTitleWrap = _styledComponents2.default.div(_templateObject109);
	
	Styled.PerfFeedbackTitle = _styledComponents2.default.div(_templateObject110);
	
	Styled.PerfFeedbackSubtitle = _styledComponents2.default.div(_templateObject111);
	
	// Body owns the remaining vertical space inside BlockContent. min-height:
	// 0 (combined with flex: 1) lets it shrink below its intrinsic content
	// size so the long hover text in the detail column doesn't push the
	// whole card past its allotted height.
	Styled.PerfFeedbackBody = _styledComponents2.default.div(_templateObject112);
	
	// Two-column body: numbered list on the left, hovered/clicked detail
	// text on the right. Flex layout (not grid) so each column shares
	// the body's height as a hard constraint and the detail column's
	// overflow-y: auto can render an actual scrollbar when the hover
	// text exceeds the available height.
	Styled.PerfFeedbackSplit = _styledComponents2.default.div(_templateObject113);
	
	Styled.PerfFeedbackDetailColumn = _styledComponents2.default.div(_templateObject114);
	
	Styled.PerfFeedbackDetailPlaceholder = _styledComponents2.default.div(_templateObject115);
	
	// Search bar lets the instructor type a student or team name to scope
	// the feedback list down to that team's reasons. Sized to sit on the
	// right side of the BlockTitle header row alongside the title text.
	Styled.PerfFeedbackSearch = _styledComponents2.default.input(_templateObject116);
	
	Styled.PerfFeedbackList = _styledComponents2.default.ol(_templateObject117);
	
	Styled.PerfFeedbackItem = _styledComponents2.default.li(_templateObject118);
	
	Styled.PerfFeedbackNumber = _styledComponents2.default.span(_templateObject119);
	
	// Inline error shown when the instructor submits a team-name search
	// that doesn't match any team in the round.
	Styled.PerfFeedbackNotFound = _styledComponents2.default.div(_templateObject120);
	
	// Tooltip used to surface the long-form hovering popup message on
	// each Performance Feedback list row. CSS-only — the parent wrapper
	// uses :hover to toggle visibility, so no JS state needed.
	Styled.PerfFeedbackTooltipWrap = _styledComponents2.default.span(_templateObject121);
	
	Styled.PerfFeedbackInfoIcon = _styledComponents2.default.span(_templateObject122);
	
	Styled.PerfFeedbackTooltip = _styledComponents2.default.span.attrs({ className: 'pf-tooltip' })(_templateObject123);
	
	// ---------- Modern KPI tiles (mirror /decisions/product-marketing) ----------
	
	// Top-of-dashboard row of small KPI cards. Three equal columns; wraps
	// to a 2-column grid on narrow viewports so it never overflows the
	// dashboard width.
	Styled.KpiRow = _styledComponents2.default.div(_templateObject124);
	
	Styled.KpiCard = _styledComponents2.default.div(_templateObject125);
	
	Styled.KpiLabel = _styledComponents2.default.div(_templateObject126);
	
	// Header row that holds the KPI label on the left and a small "view
	// details" link on the right, on the same baseline. Used at the top
	// of each KpiCard so the link no longer needs its own bottom row.
	Styled.KpiHeader = _styledComponents2.default.div(_templateObject127);
	
	Styled.KpiValueRow = _styledComponents2.default.div(_templateObject128);
	
	Styled.KpiValue = _styledComponents2.default.div(_templateObject129);
	
	// Smaller label+value pair used inside the Team Scores tile. Label and
	// value sit on the same row (label left, value right) with a small gap.
	Styled.KpiMicroPair = _styledComponents2.default.div(_templateObject130);
	
	Styled.KpiMicroLabel = _styledComponents2.default.div(_templateObject131);
	
	Styled.KpiMicroValue = _styledComponents2.default.div(_templateObject132);
	
	Styled.KpiLink = _styledComponents2.default.a(_templateObject133);
	
	// Disabled variant of KpiLink used when the target page has nothing
	// to show yet (e.g. Team Scores before any round has finished). The
	// wrapper hosts a hover tooltip so the instructor knows why the link
	// isn't clickable.
	Styled.KpiLinkDisabledTip = _styledComponents2.default.span(_templateObject134);
	
	Styled.KpiLinkDisabledWrap = _styledComponents2.default.span(_templateObject135, Styled.KpiLinkDisabledTip);
	
	Styled.KpiLinkDisabled = _styledComponents2.default.span(_templateObject136);
	
	// ---------- Top / Bottom Performers compact cards ----------
	//
	// A single white card per block (no separated header strip). The
	// title sits at the top of the body, followed by the column headers
	// and rows. Two of these stack vertically in the right column next
	// to the Engagement + Team Insights stack on the left.
	
	// Min-height matches the left column's stacked Engagement (280px) +
	// Row gap (20px) + Team Insights (280px) = 580px so the bottoms of
	// both columns align at the same y-position.
	Styled.PerformersBlock = _styledComponents2.default.div(_templateObject137);
	
	// ---- Student Spotlight (combined Top + Bottom Performers) ----
	Styled.SpotlightBlock = _styledComponents2.default.div(_templateObject138);
	
	Styled.SpotlightHeader = _styledComponents2.default.div(_templateObject139);
	
	Styled.SpotlightHeaderLeft = _styledComponents2.default.div(_templateObject140);
	
	Styled.SpotlightDescription = _styledComponents2.default.div(_templateObject141);
	
	Styled.SpotlightColumns = _styledComponents2.default.div(_templateObject142);
	
	Styled.SpotlightDivider = _styledComponents2.default.div(_templateObject143);
	
	Styled.SpotlightColumn = _styledComponents2.default.div(_templateObject144);
	
	Styled.SpotlightSubheader = _styledComponents2.default.div(_templateObject145);
	
	// Centered empty/state element that spans both Spotlight columns
	// (used for the "no peer evaluation" message and the Generate
	// Insights button).
	Styled.SpotlightEmptyState = _styledComponents2.default.div(_templateObject146);
	
	Styled.SpotlightEmptyMessage = _styledComponents2.default.div(_templateObject147);
	
	Styled.SpotlightGenerateButton = _styledComponents2.default.button(_templateObject148);
	
	Styled.SpotlightNotice = _styledComponents2.default.div(_templateObject149);
	
	// ---- Generate-insights confirmation popup ----
	Styled.SpotlightConfirm = {};
	
	Styled.SpotlightConfirm.Backdrop = _styledComponents2.default.div(_templateObject150);
	
	Styled.SpotlightConfirm.Card = _styledComponents2.default.div(_templateObject151);
	
	Styled.SpotlightConfirm.Title = _styledComponents2.default.div(_templateObject152);
	
	Styled.SpotlightConfirm.Body = _styledComponents2.default.div(_templateObject153);
	
	Styled.SpotlightConfirm.Actions = _styledComponents2.default.div(_templateObject154);
	
	Styled.SpotlightConfirm.CancelButton = _styledComponents2.default.button(_templateObject155);
	
	Styled.SpotlightConfirm.ConfirmButton = _styledComponents2.default.button(_templateObject156);
	
	Styled.PerformersTitle = _styledComponents2.default.div(_templateObject157);
	
	Styled.PerformersRoundHint = _styledComponents2.default.div(_templateObject158);
	
	Styled.PerformersHeaderRow = _styledComponents2.default.div(_templateObject159);
	
	Styled.PerformersBodyRow = _styledComponents2.default.div(_templateObject160);
	
	// Chip rendered in the Team column of the Student Spotlight rows.
	// Shows the full team name (e.g. "AA02", "FA06") so instructors can
	// tell apart different teams that share a section prefix. Width is
	// sized for the current <section><number> convention (4 chars) with
	// a bit of breathing room; longer names are truncated with ellipsis
	// and the full value stays reachable via the parent cell's title.
	Styled.SpotlightTeamBadge = _styledComponents2.default.div(_templateObject161);
	
	// Filter-by-team control in the Student Spotlight header. Behaves
	// like a text-input shell that opens a floating multi-select menu
	// on click. Teams listed are the ones present in the current MVP+LVP
	// data, which is already section-scoped by the backend.
	Styled.SpotlightFilter = {};
	
	Styled.SpotlightFilter.Wrap = _styledComponents2.default.div(_templateObject162);
	
	Styled.SpotlightFilter.Button = _styledComponents2.default.button(_templateObject163, function (p) {
	  return p.hasSelection ? 'rgba(0, 27, 59, 0.94)' : 'rgba(0, 27, 59, 0.5)';
	});
	
	Styled.SpotlightFilter.Chevron = _styledComponents2.default.span(_templateObject164);
	
	Styled.SpotlightFilter.Dropdown = _styledComponents2.default.div(_templateObject165);
	
	Styled.SpotlightFilter.Option = _styledComponents2.default.label(_templateObject166);
	
	Styled.SpotlightFilter.Empty = _styledComponents2.default.div(_templateObject167);
	
	Styled.SpotlightFilter.Footer = _styledComponents2.default.div(_templateObject168);
	
	Styled.SpotlightFilter.Clear = _styledComponents2.default.button(_templateObject169);
	
	// Scrollable list container for the Performers blocks. Caps the
	// visible rows so that lists longer than 10 entries surface a
	// vertical scrollbar inside the block instead of stretching the
	// card itself.
	Styled.PerformersScroll = _styledComponents2.default.div(_templateObject170);
	
	// Inline tagline next to the Performers block title (e.g.
	// "Top Performers (most valuable players)").
	Styled.PerformersSubtitle = _styledComponents2.default.span(_templateObject171);
	
	Styled.PerformersCell = _styledComponents2.default.div(_templateObject172);
	
	// "(Skills Certificate)" link next to each Top Performer name.
	Styled.SkillsCertificateLink = _styledComponents2.default.a(_templateObject173);
	
	// =================================================================
	// Areas of Improvement (Insights) popup — Bottom Performer rows
	// =================================================================
	
	Styled.Insights = {};
	
	Styled.Insights.Backdrop = _styledComponents2.default.div(_templateObject174);
	
	Styled.Insights.Card = _styledComponents2.default.div(_templateObject175);
	
	Styled.Insights.CloseButton = _styledComponents2.default.button(_templateObject176);
	
	Styled.Insights.Header = _styledComponents2.default.div(_templateObject177);
	
	Styled.Insights.Eyebrow = _styledComponents2.default.div(_templateObject178);
	
	Styled.Insights.Title = _styledComponents2.default.div(_templateObject179);
	
	Styled.Insights.Subtitle = _styledComponents2.default.div(_templateObject180);
	
	Styled.Insights.Body = _styledComponents2.default.div(_templateObject181);
	
	Styled.Insights.SectionLabel = _styledComponents2.default.div(_templateObject182);
	
	Styled.Insights.Paragraph = _styledComponents2.default.div(_templateObject183);
	
	Styled.Insights.EvidenceList = _styledComponents2.default.div(_templateObject184);
	
	Styled.Insights.EvidenceItem = _styledComponents2.default.div(_templateObject185);
	
	Styled.Insights.EvidenceSkill = _styledComponents2.default.div(_templateObject186);
	
	Styled.Insights.Empty = _styledComponents2.default.div(_templateObject187);
	
	// =================================================================
	// Team Lookup — KPI-row "Look up a team" card + modal
	// =================================================================
	
	Styled.TeamLookup = {};
	
	// ---- Card (sits on the KPI row alongside Team Scores / Count) ----
	Styled.TeamLookup.Card = _styledComponents2.default.button(_templateObject188);
	
	Styled.TeamLookup.CardHeader = _styledComponents2.default.div(_templateObject189);
	
	Styled.TeamLookup.CardIcon = _styledComponents2.default.span(_templateObject190);
	
	Styled.TeamLookup.CardShortcut = _styledComponents2.default.span(_templateObject191);
	
	Styled.TeamLookup.CardInputMock = _styledComponents2.default.div(_templateObject192);
	
	Styled.TeamLookup.CardHelper = _styledComponents2.default.div(_templateObject193);
	
	// ---- Modal ----
	Styled.TeamLookup.Backdrop = _styledComponents2.default.div(_templateObject194);
	
	Styled.TeamLookup.Card2 = _styledComponents2.default.div(_templateObject195);
	
	Styled.TeamLookup.SearchRow = _styledComponents2.default.div(_templateObject196);
	
	Styled.TeamLookup.SearchIcon = _styledComponents2.default.span(_templateObject197);
	
	Styled.TeamLookup.SearchInput = _styledComponents2.default.input(_templateObject198);
	
	Styled.TeamLookup.CloseIcon = _styledComponents2.default.button(_templateObject199);
	
	Styled.TeamLookup.List = _styledComponents2.default.div(_templateObject200);
	
	Styled.TeamLookup.SectionHeader = _styledComponents2.default.div(_templateObject201);
	
	Styled.TeamLookup.SectionHeaderCount = _styledComponents2.default.span(_templateObject202);
	
	Styled.TeamLookup.Row = _styledComponents2.default.div(_templateObject203, function (p) {
	  return p.highlighted && '\n    background: #DBEAFE;\n  ';
	});
	
	Styled.TeamLookup.Avatar = _styledComponents2.default.div(_templateObject204);
	
	Styled.TeamLookup.RowText = _styledComponents2.default.div(_templateObject205);
	
	Styled.TeamLookup.RowName = _styledComponents2.default.div(_templateObject206);
	
	Styled.TeamLookup.RowMeta = _styledComponents2.default.div(_templateObject193);
	
	Styled.TeamLookup.RowScore = _styledComponents2.default.div(_templateObject207);
	
	Styled.TeamLookup.RowScoreValue = _styledComponents2.default.div(_templateObject208, function (p) {
	  return p.value == null ? '#9CA3AF' : '#0F1729';
	});
	
	Styled.TeamLookup.RowScoreLabel = _styledComponents2.default.div(_templateObject209);
	
	Styled.TeamLookup.Empty = _styledComponents2.default.div(_templateObject210);
	
	Styled.TeamLookup.Footer = _styledComponents2.default.div(_templateObject211);
	
	Styled.TeamLookup.HintKey = _styledComponents2.default.span(_templateObject212);
	
	// ---- Step 2 (action sheet) ----
	Styled.TeamLookup.SelectedBanner = _styledComponents2.default.div(_templateObject213);
	
	Styled.TeamLookup.ChangeTeamButton = _styledComponents2.default.button(_templateObject214);
	
	Styled.TeamLookup.ActionsGrid = _styledComponents2.default.div(_templateObject215);
	
	Styled.TeamLookup.ActionButton = _styledComponents2.default.button(_templateObject216, function (p) {
	  return p.variant === "audit" && '\n    background: #EDE9FE;\n    border-color: rgba(124, 58, 237, 0.25);\n    color: #5B21B6;\n  ';
	}, function (p) {
	  return p.variant === "report" && '\n    background: #D1FAE5;\n    border-color: rgba(5, 150, 105, 0.25);\n    color: #065F46;\n  ';
	}, function (p) {
	  return p.variant === "audit" && 'border-color: #7C3AED;';
	}, function (p) {
	  return p.variant === "report" && 'border-color: #059669;';
	});
	
	Styled.TeamLookup.ActionTitle = _styledComponents2.default.div(_templateObject217);
	
	Styled.TeamLookup.ActionBlurb = _styledComponents2.default.div(_templateObject218);
	
	exports.default = Styled;

/***/ },
/* 311 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 312 */
[2725, 414],
/* 313 */
196,
/* 314 */
[2688, 107, 48, 195],
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(30);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(97);
	var redefineAll = __webpack_require__(193);
	var meta = __webpack_require__(163);
	var forOf = __webpack_require__(188);
	var anInstance = __webpack_require__(187);
	var isObject = __webpack_require__(33);
	var fails = __webpack_require__(31);
	var $iterDetect = __webpack_require__(319);
	var setToStringTag = __webpack_require__(224);
	var inheritIfRequired = __webpack_require__(433);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(660);
	var redefine = __webpack_require__(97);
	var hide = __webpack_require__(96);
	var fails = __webpack_require__(31);
	var defined = __webpack_require__(129);
	var wks = __webpack_require__(44);
	var regexpExec = __webpack_require__(441);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 317 */
[2700, 116],
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(33);
	var cof = __webpack_require__(116);
	var MATCH = __webpack_require__(44)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 319 */
[2704, 44],
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(162) || !__webpack_require__(31)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(30)[K];
	});


/***/ },
/* 321 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(222);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(86);
	var ctx = __webpack_require__(118);
	var forOf = __webpack_require__(188);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 325 */
[2721, 120, 129],
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var hide = __webpack_require__(96);
	var uid = __webpack_require__(196);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(164));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 329 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(675));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1819));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1814));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(1815));
	
	var _properties = __webpack_require__(674);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(1816));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-lock.5d6f1c0f.svg";

/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 335 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(2005),
	    listCacheDelete = __webpack_require__(2006),
	    listCacheGet = __webpack_require__(2007),
	    listCacheHas = __webpack_require__(2008),
	    listCacheSet = __webpack_require__(2009);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(345);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(233);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(340),
	    toKey = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isKey = __webpack_require__(478),
	    stringToPath = __webpack_require__(2030),
	    toString = __webpack_require__(743);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(2003);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1924),
	    Map = __webpack_require__(466),
	    Promise = __webpack_require__(1926),
	    Set = __webpack_require__(703),
	    WeakMap = __webpack_require__(1927),
	    baseGetTag = __webpack_require__(168),
	    toSource = __webpack_require__(731);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(345),
	    isArrayLike = __webpack_require__(199),
	    isIndex = __webpack_require__(477),
	    isObject = __webpack_require__(101);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(347);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    isArray = __webpack_require__(40),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(352);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(352);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(2207);
	var uncurryThis = __webpack_require__(58);
	var IndexedObject = __webpack_require__(284);
	var toObject = __webpack_require__(203);
	var lengthOfArrayLike = __webpack_require__(237);
	var arraySpeciesCreate = __webpack_require__(900);
	
	var push = uncurryThis([].push);
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_REJECT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var boundFunction = bind(callbackfn, that);
	    var length = lengthOfArrayLike(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(65);
	var wellKnownSymbol = __webpack_require__(124);
	var V8_VERSION = __webpack_require__(356);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};


/***/ },
/* 355 */
[2748, 134, 238, 495],
/* 356 */
[2753, 102, 2206],
/* 357 */
[2755, 65],
/* 358 */
[2759, 102, 90],
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
	/* eslint-disable regexp/no-useless-quantifier -- testing */
	var call = __webpack_require__(170);
	var uncurryThis = __webpack_require__(58);
	var toString = __webpack_require__(361);
	var regexpFlags = __webpack_require__(2222);
	var stickyHelpers = __webpack_require__(916);
	var shared = __webpack_require__(507);
	var create = __webpack_require__(2216);
	var getInternalState = __webpack_require__(909).get;
	var UNSUPPORTED_DOT_ALL = __webpack_require__(2223);
	var UNSUPPORTED_NCG = __webpack_require__(2224);
	
	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var nativeExec = RegExp.prototype.exec;
	var patchedExec = nativeExec;
	var charAt = uncurryThis(''.charAt);
	var indexOf = uncurryThis(''.indexOf);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  call(nativeExec, re1, 'a');
	  call(nativeExec, re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	})();
	
	var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
	
	if (PATCH) {
	  patchedExec = function exec(string) {
	    var re = this;
	    var state = getInternalState(re);
	    var str = toString(string);
	    var raw = state.raw;
	    var result, reCopy, lastIndex, match, i, object, group;
	
	    if (raw) {
	      raw.lastIndex = re.lastIndex;
	      result = call(patchedExec, raw, str);
	      re.lastIndex = raw.lastIndex;
	      return result;
	    }
	
	    var groups = state.groups;
	    var sticky = UNSUPPORTED_Y && re.sticky;
	    var flags = call(regexpFlags, re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;
	
	    if (sticky) {
	      flags = replace(flags, 'y', '');
	      if (indexOf(flags, 'g') === -1) {
	        flags += 'g';
	      }
	
	      strCopy = stringSlice(str, re.lastIndex);
	      // Support anchored sticky behavior.
	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      }
	      // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.
	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
	
	    match = call(nativeExec, sticky ? reCopy : re, strCopy);
	
	    if (sticky) {
	      if (match) {
	        match.input = stringSlice(match.input, charsAdded);
	        match[0] = stringSlice(match[0], charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
	      call(nativeReplace, match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    if (match && groups) {
	      match.groups = object = create(null);
	      for (i = 0; i < groups.length; i++) {
	        group = groups[i];
	        object[group[0]] = match[group[1]];
	      }
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 360 */
[2786, 2214],
/* 361 */
[2792, 901],
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var exec = __webpack_require__(359);
	
	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
	  exec: exec
	});


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(668);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(228);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(465);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(349);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(351);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(300);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(511);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(2248);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(934);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(2295);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2.default.defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2.default.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  componentClass: _elementType2.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2.default.bool,
	
	  defaultOpen: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2.default
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2.default)(_reactDom2.default.findDOMNode(this.menu), (0, _activeElement2.default)(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu let's return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2.default.findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this2 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['id', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this2.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2.default)(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, function (key, event) {
	        return _this2.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this3 = this;
	
	    var ref = function ref(c) {
	      _this3.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2.default)(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2.default)(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2.default;
	UncontrolledDropdown.Menu = _DropdownMenu2.default;
	
	exports.default = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(986);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3.default)(this, Fade);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, this.props, {
	      className: (0, _classnames2.default)(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(2262);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(2263);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(2264);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(2265);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(2266);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(2267);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3.default)(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3.default)(this, Media);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2.default.Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2.default;
	Media.Body = _MediaBody2.default;
	Media.Left = _MediaLeft2.default;
	Media.Right = _MediaRight2.default;
	Media.List = _MediaList2.default;
	Media.ListItem = _MediaListItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(615);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.default = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Chart", {
	  enumerable: true,
	  get: function get() {
	    return _chart["default"];
	  }
	});
	exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _chart = _interopRequireDefault(__webpack_require__(1559));
	
	var _isEqual = _interopRequireDefault(__webpack_require__(109));
	
	var _keyBy = _interopRequireDefault(__webpack_require__(2044));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NODE_ENV = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_AC_TKN":"f218eb621f0c68f1c7e01ba9c48691bff09ec7b9","REACT_APP_API_URL":"https://be-production-itb.marketgames.io/api/","REACT_APP_GOOGLE_MERCHANT_ID":"1231232131","REACT_APP_HIDE_NOT_FINISHED_PART":"true"}) && ("production");
	
	var ChartComponent = /*#__PURE__*/function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  var _super = _createSuper(ChartComponent);
	
	  function ChartComponent() {
	    var _this;
	
	    _classCallCheck(this, ChartComponent);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
	      var instance = _this.chartInstance;
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
	      _this.element = element;
	    });
	
	    _this.chartInstance = undefined;
	    return _this;
	  }
	
	  _createClass(ChartComponent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderChart();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.redraw) {
	        this.destroyChart();
	        this.renderChart();
	        return;
	      }
	
	      this.updateChart();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this$props2 = this.props,
	          redraw = _this$props2.redraw,
	          type = _this$props2.type,
	          options = _this$props2.options,
	          plugins = _this$props2.plugins,
	          legend = _this$props2.legend,
	          height = _this$props2.height,
	          width = _this$props2.width;
	
	      if (nextProps.redraw === true) {
	        return true;
	      }
	
	      if (height !== nextProps.height || width !== nextProps.width) {
	        return true;
	      }
	
	      if (type !== nextProps.type) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(options, nextProps.options)) {
	        return true;
	      }
	
	      var nextData = this.transformDataProp(nextProps);
	
	      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
	        return true;
	      }
	
	      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyChart();
	    }
	  }, {
	    key: "transformDataProp",
	    value: function transformDataProp(props) {
	      var data = props.data;
	
	      if (typeof data == 'function') {
	        var node = this.element;
	        return data(node);
	      } else {
	        return data;
	      }
	    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	    // this makes impossible to compare the current and next data changes
	    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	  }, {
	    key: "memoizeDataProps",
	    value: function memoizeDataProps() {
	      if (!this.props.data) {
	        return;
	      }
	
	      var data = this.transformDataProp(this.props);
	      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
	        datasets: data.datasets && data.datasets.map(function (set) {
	          return _objectSpread({}, set);
	        })
	      });
	      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
	
	      return data;
	    }
	  }, {
	    key: "checkDatasets",
	    value: function checkDatasets(datasets) {
	      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
	      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
	      var multipleDatasets = datasets.length > 1;
	
	      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
	        var shouldWarn = false;
	        datasets.forEach(function (dataset) {
	          if (!dataset.label) {
	            shouldWarn = true;
	          }
	        });
	
	        if (shouldWarn) {
	          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
	        }
	      }
	    }
	  }, {
	    key: "getCurrentDatasets",
	    value: function getCurrentDatasets() {
	      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
	    }
	  }, {
	    key: "saveCurrentDatasets",
	    value: function saveCurrentDatasets() {
	      var _this2 = this;
	
	      this.datasets = this.datasets || {};
	      var currentDatasets = this.getCurrentDatasets();
	      currentDatasets.forEach(function (d) {
	        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
	      });
	    }
	  }, {
	    key: "updateChart",
	    value: function updateChart() {
	      var _this3 = this;
	
	      var options = this.props.options;
	      var data = this.memoizeDataProps(this.props);
	      if (!this.chartInstance) return;
	
	      if (options) {
	        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
	      } // Pipe datasets to chart instance datasets enabling
	      // seamless transitions
	
	
	      var currentDatasets = this.getCurrentDatasets();
	      var nextDatasets = data.datasets || [];
	      this.checkDatasets(currentDatasets);
	      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
	      // on each dataset.
	
	      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
	        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
	
	        if (current && current.type === next.type && next.data) {
	          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
	          // The data array must be edited in place. As chart.js adds listeners to it.
	          current.data.splice(next.data.length);
	          next.data.forEach(function (point, pid) {
	            current.data[pid] = next.data[pid];
	          });
	
	          var _data = next.data,
	              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
	          // from next, it will be retained by current and never disappears.
	          // Workaround is to set value to null or undefined in next.
	
	
	          return _objectSpread(_objectSpread({}, current), otherProps);
	        } else {
	          return next;
	        }
	      });
	
	      var datasets = data.datasets,
	          rest = _objectWithoutProperties(data, ["datasets"]);
	
	      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
	      this.chartInstance.update();
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$props3 = this.props,
	          options = _this$props3.options,
	          legend = _this$props3.legend,
	          type = _this$props3.type,
	          plugins = _this$props3.plugins;
	      var node = this.element;
	      var data = this.memoizeDataProps();
	
	      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
	        options.legend = legend;
	      }
	
	      this.chartInstance = new _chart["default"](node, {
	        type: type,
	        data: data,
	        options: options,
	        plugins: plugins
	      });
	    }
	  }, {
	    key: "destroyChart",
	    value: function destroyChart() {
	      if (!this.chartInstance) {
	        return;
	      } // Put all of the datasets that have existed in the chart back on the chart
	      // so that the metadata associated with this chart get destroyed.
	      // This allows the datasets to be used in another chart. This can happen,
	      // for example, in a tabbed UI where the chart gets created each time the
	      // tab gets switched to the chart and uses the same data).
	
	
	      this.saveCurrentDatasets();
	      var datasets = Object.values(this.datasets);
	      this.chartInstance.config.data.datasets = datasets;
	      this.chartInstance.destroy();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          height = _this$props4.height,
	          width = _this$props4.width,
	          id = _this$props4.id;
	      return /*#__PURE__*/_react["default"].createElement("canvas", {
	        ref: this.ref,
	        height: height,
	        width: width,
	        id: id,
	        onClick: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ChartComponent;
	}(_react["default"].Component);
	
	_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
	  return d.label;
	});
	
	_defineProperty(ChartComponent, "propTypes", {
	  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
	  getDatasetAtEvent: _propTypes["default"].func,
	  getElementAtEvent: _propTypes["default"].func,
	  getElementsAtEvent: _propTypes["default"].func,
	  height: _propTypes["default"].number,
	  legend: _propTypes["default"].object,
	  onElementsClick: _propTypes["default"].func,
	  options: _propTypes["default"].object,
	  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  redraw: _propTypes["default"].bool,
	  type: function type(props, propName, componentName) {
	    if (!_chart["default"].controllers[props[propName]]) {
	      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
	    }
	  },
	  width: _propTypes["default"].number,
	  datasetKeyProvider: _propTypes["default"].func
	});
	
	_defineProperty(ChartComponent, "defaultProps", {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {},
	  datasetKeyProvider: ChartComponent.getLabelAsKey
	});
	
	var _default = ChartComponent;
	exports["default"] = _default;
	
	var Doughnut = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  var _super2 = _createSuper(Doughnut);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Doughnut, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref) {
	          return _this4.chartInstance = _ref && _ref.chartInstance;
	        },
	        type: "doughnut"
	      }));
	    }
	  }]);
	
	  return Doughnut;
	}(_react["default"].Component);
	
	exports.Doughnut = Doughnut;
	
	var Pie = /*#__PURE__*/function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  var _super3 = _createSuper(Pie);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _super3.apply(this, arguments);
	  }
	
	  _createClass(Pie, [{
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref2) {
	          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
	        },
	        type: "pie"
	      }));
	    }
	  }]);
	
	  return Pie;
	}(_react["default"].Component);
	
	exports.Pie = Pie;
	
	var Line = /*#__PURE__*/function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  var _super4 = _createSuper(Line);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _super4.apply(this, arguments);
	  }
	
	  _createClass(Line, [{
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref3) {
	          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
	        },
	        type: "line"
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react["default"].Component);
	
	exports.Line = Line;
	
	var Bar = /*#__PURE__*/function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  var _super5 = _createSuper(Bar);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _super5.apply(this, arguments);
	  }
	
	  _createClass(Bar, [{
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref4) {
	          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
	        },
	        type: "bar"
	      }));
	    }
	  }]);
	
	  return Bar;
	}(_react["default"].Component);
	
	exports.Bar = Bar;
	
	var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  var _super6 = _createSuper(HorizontalBar);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _super6.apply(this, arguments);
	  }
	
	  _createClass(HorizontalBar, [{
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref5) {
	          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
	        },
	        type: "horizontalBar"
	      }));
	    }
	  }]);
	
	  return HorizontalBar;
	}(_react["default"].Component);
	
	exports.HorizontalBar = HorizontalBar;
	
	var Radar = /*#__PURE__*/function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  var _super7 = _createSuper(Radar);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _super7.apply(this, arguments);
	  }
	
	  _createClass(Radar, [{
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref6) {
	          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
	        },
	        type: "radar"
	      }));
	    }
	  }]);
	
	  return Radar;
	}(_react["default"].Component);
	
	exports.Radar = Radar;
	
	var Polar = /*#__PURE__*/function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  var _super8 = _createSuper(Polar);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _super8.apply(this, arguments);
	  }
	
	  _createClass(Polar, [{
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref7) {
	          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
	        },
	        type: "polarArea"
	      }));
	    }
	  }]);
	
	  return Polar;
	}(_react["default"].Component);
	
	exports.Polar = Polar;
	
	var Bubble = /*#__PURE__*/function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  var _super9 = _createSuper(Bubble);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _super9.apply(this, arguments);
	  }
	
	  _createClass(Bubble, [{
	    key: "render",
	    value: function render() {
	      var _this11 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref8) {
	          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
	        },
	        type: "bubble"
	      }));
	    }
	  }]);
	
	  return Bubble;
	}(_react["default"].Component);
	
	exports.Bubble = Bubble;
	
	var Scatter = /*#__PURE__*/function (_React$Component10) {
	  _inherits(Scatter, _React$Component10);
	
	  var _super10 = _createSuper(Scatter);
	
	  function Scatter() {
	    _classCallCheck(this, Scatter);
	
	    return _super10.apply(this, arguments);
	  }
	
	  _createClass(Scatter, [{
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref9) {
	          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
	        },
	        type: "scatter"
	      }));
	    }
	  }]);
	
	  return Scatter;
	}(_react["default"].Component);
	
	exports.Scatter = Scatter;
	var defaults = _chart["default"].defaults;
	exports.defaults = defaults;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(956),
		PropTypes = __webpack_require__(2),
		createClass = __webpack_require__(73),
		moment = __webpack_require__(5),
		React = __webpack_require__(1),
		CalendarContainer = __webpack_require__(2309),
		onClickOutside = __webpack_require__(2376).default
		;
	
	var viewModes = Object.freeze({
		YEARS: 'years',
		MONTHS: 'months',
		DAYS: 'days',
		TIME: 'time',
	});
	
	var TYPES = PropTypes;
	var Datetime = createClass({
		displayName: 'DateTime',
		propTypes: {
			// value: TYPES.object | TYPES.string,
			// defaultValue: TYPES.object | TYPES.string,
			// viewDate: TYPES.object | TYPES.string,
			onFocus: TYPES.func,
			onBlur: TYPES.func,
			onChange: TYPES.func,
			onViewModeChange: TYPES.func,
			onNavigateBack: TYPES.func,
			onNavigateForward: TYPES.func,
			locale: TYPES.string,
			utc: TYPES.bool,
			displayTimeZone: TYPES.string,
			input: TYPES.bool,
			// dateFormat: TYPES.string | TYPES.bool,
			// timeFormat: TYPES.string | TYPES.bool,
			inputProps: TYPES.object,
			timeConstraints: TYPES.object,
			viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
			isValidDate: TYPES.func,
			open: TYPES.bool,
			strictParsing: TYPES.bool,
			closeOnSelect: TYPES.bool,
			closeOnTab: TYPES.bool
		},
	
		getInitialState: function() {
			this.checkTZ( this.props );
			
			var state = this.getStateFromProps( this.props );
	
			if ( state.open === undefined )
				state.open = !this.props.input;
	
			state.currentView = this.props.dateFormat ?
				(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;
	
			return state;
		},
	
		parseDate: function (date, formats) {
			var parsedDate;
	
			if (date && typeof date === 'string')
				parsedDate = this.localMoment(date, formats.datetime);
			else if (date)
				parsedDate = this.localMoment(date);
	
			if (parsedDate && !parsedDate.isValid())
				parsedDate = null;
	
			return parsedDate;
		},
	
		getStateFromProps: function( props ) {
			var formats = this.getFormats( props ),
				date = props.value || props.defaultValue,
				selectedDate, viewDate, updateOn, inputValue
				;
	
			selectedDate = this.parseDate(date, formats);
	
			viewDate = this.parseDate(props.viewDate, formats);
	
			viewDate = selectedDate ?
				selectedDate.clone().startOf('month') :
				viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');
	
			updateOn = this.getUpdateOn(formats);
	
			if ( selectedDate )
				inputValue = selectedDate.format(formats.datetime);
			else if ( date.isValid && !date.isValid() )
				inputValue = '';
			else
				inputValue = date || '';
	
			return {
				updateOn: updateOn,
				inputFormat: formats.datetime,
				viewDate: viewDate,
				selectedDate: selectedDate,
				inputValue: inputValue,
				open: props.open
			};
		},
	
		getUpdateOn: function( formats ) {
			if ( formats.date.match(/[lLD]/) ) {
				return viewModes.DAYS;
			} else if ( formats.date.indexOf('M') !== -1 ) {
				return viewModes.MONTHS;
			} else if ( formats.date.indexOf('Y') !== -1 ) {
				return viewModes.YEARS;
			}
	
			return viewModes.DAYS;
		},
	
		getFormats: function( props ) {
			var formats = {
					date: props.dateFormat || '',
					time: props.timeFormat || ''
				},
				locale = this.localMoment( props.date, null, props ).localeData()
				;
	
			if ( formats.date === true ) {
				formats.date = locale.longDateFormat('L');
			}
			else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
				formats.time = '';
			}
	
			if ( formats.time === true ) {
				formats.time = locale.longDateFormat('LT');
			}
	
			formats.datetime = formats.date && formats.time ?
				formats.date + ' ' + formats.time :
				formats.date || formats.time
			;
	
			return formats;
		},
	
		componentWillReceiveProps: function( nextProps ) {
			var formats = this.getFormats( nextProps ),
				updatedState = {}
			;
	
			if ( nextProps.value !== this.props.value ||
				formats.datetime !== this.getFormats( this.props ).datetime ) {
				updatedState = this.getStateFromProps( nextProps );
			}
	
			if ( updatedState.open === undefined ) {
				if ( typeof nextProps.open !== 'undefined' ) {
					updatedState.open = nextProps.open;
				} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
					updatedState.open = false;
				} else {
					updatedState.open = this.state.open;
				}
			}
	
			if ( nextProps.viewMode !== this.props.viewMode ) {
				updatedState.currentView = nextProps.viewMode;
			}
	
			if ( nextProps.locale !== this.props.locale ) {
				if ( this.state.viewDate ) {
					var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
					updatedState.viewDate = updatedViewDate;
				}
				if ( this.state.selectedDate ) {
					var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
					updatedState.selectedDate = updatedSelectedDate;
					updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
				}
			}
	
			if ( nextProps.utc !== this.props.utc || nextProps.displayTimeZone !== this.props.displayTimeZone ) {
				if ( nextProps.utc ) {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().utc();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().utc();
						updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
					}
				} else if ( nextProps.displayTimeZone ) {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().tz(nextProps.displayTimeZone);
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().tz(nextProps.displayTimeZone);
						updatedState.inputValue = updatedState.selectedDate.tz(nextProps.displayTimeZone).format( formats.datetime );
					}
				} else {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().local();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().local();
						updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
					}
				}
			}
	
			if ( nextProps.viewDate !== this.props.viewDate ) {
				updatedState.viewDate = moment(nextProps.viewDate);
			}
	
			this.checkTZ( nextProps );
	
			this.setState( updatedState );
		},
	
		onInputChange: function( e ) {
			var value = e.target === null ? e : e.target.value,
				localMoment = this.localMoment( value, this.state.inputFormat ),
				update = { inputValue: value }
				;
	
			if ( localMoment.isValid() && !this.props.value ) {
				update.selectedDate = localMoment;
				update.viewDate = localMoment.clone().startOf('month');
			} else {
				update.selectedDate = null;
			}
	
			return this.setState( update, function() {
				return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
			});
		},
	
		onInputKey: function( e ) {
			if ( e.which === 9 && this.props.closeOnTab ) {
				this.closeCalendar();
			}
		},
	
		showView: function( view ) {
			var me = this;
			return function() {
				me.state.currentView !== view && me.props.onViewModeChange( view );
				me.setState({ currentView: view });
			};
		},
	
		setDate: function( type ) {
			var me = this,
				nextViews = {
					month: viewModes.DAYS,
					year: viewModes.MONTHS,
				}
			;
			return function( e ) {
				me.setState({
					viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
					currentView: nextViews[ type ]
				});
				me.props.onViewModeChange( nextViews[ type ] );
			};
		},
	
		subtractTime: function( amount, type, toSelected ) {
			var me = this;
			return function() {
				me.props.onNavigateBack( amount, type );
				me.updateTime( 'subtract', amount, type, toSelected );
			};
		},
	
		addTime: function( amount, type, toSelected ) {
			var me = this;
			return function() {
				me.props.onNavigateForward( amount, type );
				me.updateTime( 'add', amount, type, toSelected );
			};
		},
	
		updateTime: function( op, amount, type, toSelected ) {
			var update = {},
				date = toSelected ? 'selectedDate' : 'viewDate';
	
			update[ date ] = this.state[ date ].clone()[ op ]( amount, type );
	
			this.setState( update );
		},
	
		allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
		setTime: function( type, value ) {
			var index = this.allowedSetTime.indexOf( type ) + 1,
				state = this.state,
				date = (state.selectedDate || state.viewDate).clone(),
				nextType
				;
	
			// It is needed to set all the time properties
			// to not to reset the time
			date[ type ]( value );
			for (; index < this.allowedSetTime.length; index++) {
				nextType = this.allowedSetTime[index];
				date[ nextType ]( date[nextType]() );
			}
	
			if ( !this.props.value ) {
				this.setState({
					selectedDate: date,
					inputValue: date.format( state.inputFormat )
				});
			}
			this.props.onChange( date );
		},
	
		updateSelectedDate: function( e, close ) {
			var target = e.currentTarget,
				modifier = 0,
				viewDate = this.state.viewDate,
				currentDate = this.state.selectedDate || viewDate,
				date
				;
	
			if (target.className.indexOf('rdtDay') !== -1) {
				if (target.className.indexOf('rdtNew') !== -1)
					modifier = 1;
				else if (target.className.indexOf('rdtOld') !== -1)
					modifier = -1;
	
				date = viewDate.clone()
					.month( viewDate.month() + modifier )
					.date( parseInt( target.getAttribute('data-value'), 10 ) );
			} else if (target.className.indexOf('rdtMonth') !== -1) {
				date = viewDate.clone()
					.month( parseInt( target.getAttribute('data-value'), 10 ) )
					.date( currentDate.date() );
			} else if (target.className.indexOf('rdtYear') !== -1) {
				date = viewDate.clone()
					.month( currentDate.month() )
					.date( currentDate.date() )
					.year( parseInt( target.getAttribute('data-value'), 10 ) );
			}
	
			date.hours( currentDate.hours() )
				.minutes( currentDate.minutes() )
				.seconds( currentDate.seconds() )
				.milliseconds( currentDate.milliseconds() );
	
			if ( !this.props.value ) {
				var open = !( this.props.closeOnSelect && close );
				if ( !open ) {
					this.props.onBlur( date );
				}
	
				this.setState({
					selectedDate: date,
					viewDate: date.clone().startOf('month'),
					inputValue: date.format( this.state.inputFormat ),
					open: open
				});
			} else {
				if ( this.props.closeOnSelect && close ) {
					this.closeCalendar();
				}
			}
	
			this.props.onChange( date );
		},
	
		openCalendar: function( e ) {
			if ( !this.state.open ) {
				this.setState({ open: true }, function() {
					this.props.onFocus( e );
				});
			}
		},
	
		closeCalendar: function() {
			this.setState({ open: false }, function () {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		},
	
		handleClickOutside: function() {
			if ( this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside ) {
				this.setState({ open: false }, function() {
					this.props.onBlur( this.state.selectedDate || this.state.inputValue );
				});
			}
		},
	
		localMoment: function( date, format, props ) {
			props = props || this.props;
			var m = null;
	
			if (props.utc) {
				m = moment.utc(date, format, props.strictParsing);
			} else if (props.displayTimeZone) {
				m = moment.tz(date, format, props.displayTimeZone);
			} else {
				m = moment(date, format, props.strictParsing);
			}
	
			if ( props.locale )
				m.locale( props.locale );
			return m;
		},
	
		checkTZ: function( props ) {
			var con = console;
	
			if ( props.displayTimeZone && !this.tzWarning && !moment.tz ) {
				this.tzWarning = true;
				con && con.error('react-datetime: displayTimeZone prop with value "' + props.displayTimeZone +  '" is used but moment.js timezone is not loaded.');
			}
		},
	
		componentProps: {
			fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
			fromState: ['viewDate', 'selectedDate', 'updateOn'],
			fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
		},
	
		getComponentProps: function() {
			var me = this,
				formats = this.getFormats( this.props ),
				props = {dateFormat: formats.date, timeFormat: formats.time}
				;
	
			this.componentProps.fromProps.forEach( function( name ) {
				props[ name ] = me.props[ name ];
			});
			this.componentProps.fromState.forEach( function( name ) {
				props[ name ] = me.state[ name ];
			});
			this.componentProps.fromThis.forEach( function( name ) {
				props[ name ] = me[ name ];
			});
	
			return props;
		},
	
		overrideEvent: function( handler, action ) {
			if ( !this.overridenEvents ) {
				this.overridenEvents = {};
			}
	
			if ( !this.overridenEvents[handler] ) {
				var me = this;
				this.overridenEvents[handler] = function( e ) {
					var result;
					if ( me.props.inputProps && me.props.inputProps[handler] ) {
						result = me.props.inputProps[handler]( e );
					}
					if ( result !== false ) {
						action( e );
					}
				};
			}
	
			return this.overridenEvents[handler];
		},
	
		render: function() {
			// TODO: Make a function or clean up this code,
			// logic right now is really hard to follow
			var className = 'rdt' + (this.props.className ?
										( Array.isArray( this.props.className ) ?
										' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
				children = [];
	
			if ( this.props.input ) {
				var finalInputProps = assign(
					{ type: 'text', className: 'form-control', value: this.state.inputValue },
					this.props.inputProps,
					{
						onClick: this.overrideEvent( 'onClick', this.openCalendar ),
						onFocus: this.overrideEvent( 'onFocus', this.openCalendar ),
						onChange: this.overrideEvent( 'onChange', this.onInputChange ),
						onKeyDown: this.overrideEvent( 'onKeyDown', this.onInputKey ),
					}
				);
	
				if ( this.props.renderInput ) {
					children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
				} else {
					children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
				}
			} else {
				className += ' rdtStatic';
			}
	
			if ( this.props.open || (this.props.open === undefined && this.state.open ) )
				className += ' rdtOpen';
	
			return React.createElement( ClickableWrapper, {className: className, onClickOut: this.handleClickOutside}, children.concat(
				React.createElement( 'div',
					{ key: 'dt', className: 'rdtPicker' },
					React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
				)
			));
		}
	});
	
	var ClickableWrapper = onClickOutside( createClass({
		render: function() {
			return React.createElement( 'div', { className: this.props.className }, this.props.children );
		},
		handleClickOutside: function( e ) {
			this.props.onClickOut( e );
		}
	}));
	
	Datetime.defaultProps = {
		className: '',
		defaultValue: '',
		inputProps: {},
		input: true,
		onFocus: function() {},
		onBlur: function() {},
		onChange: function() {},
		onViewModeChange: function() {},
		onNavigateBack: function() {},
		onNavigateForward: function() {},
		timeFormat: true,
		timeConstraints: {},
		dateFormat: true,
		strictParsing: true,
		closeOnSelect: false,
		closeOnTab: true,
		utc: false
	};
	
	// Make moment accessible through the Datetime class
	Datetime.moment = moment;
	
	module.exports = Datetime;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var EventPluginRegistry = __webpack_require__(519);
	var ReactEventEmitterMixin = __webpack_require__(2340);
	var ViewportMetrics = __webpack_require__(974);
	
	var getVendorPrefixedEventName = __webpack_require__(2371);
	var isEventSupported = __webpack_require__(531);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(290);
	var ViewportMetrics = __webpack_require__(974);
	
	var getEventModifierState = __webpack_require__(528);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	var DOMNamespaces = __webpack_require__(518);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(526);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = void 0;
	
	var _intersection2 = _interopRequireDefault(__webpack_require__(2040));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection2.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	exports.getIntersectionKeys = getIntersectionKeys;
	
	var identity = function identity(param) {
	  return param;
	};
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	
	
	exports.identity = identity;
	
	var getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return "-".concat(v.toLowerCase());
	  });
	};
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	
	
	exports.getDashCase = getDashCase;
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;
	
	var log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	
	
	exports.log = log;
	
	var debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	    return item;
	  };
	};
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	
	
	exports.debug = debug;
	
	var debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(void 0, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
	    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
	    return res;
	  };
	};
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	
	
	exports.debugf = debugf;
	
	var mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	
	
	exports.mapObject = mapObject;
	
	var translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	exports.translateStyle = translateStyle;
	
	var compose = function compose() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
	  }).join(',');
	};
	
	exports.getTransitionVal = getTransitionVal;
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ZAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ZAxis, _PureComponent);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.PureComponent);
	
	ZAxis.displayName = 'ZAxis';
	ZAxis.propTypes = {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The range of axis
	  range: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func])
	};
	ZAxis.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	};
	var _default = ZAxis;
	exports["default"] = _default;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(744));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = __webpack_require__(112);
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _DefaultTooltipContent = _interopRequireDefault(__webpack_require__(2442));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CLS_PREFIX = 'recharts-tooltip-wrapper';
	var EPS = 1;
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.dataKey;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var propTypes = {
	  allowEscapeViewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].bool,
	    y: _propTypes["default"].bool
	  }),
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  active: _propTypes["default"].bool,
	  separator: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  offset: _propTypes["default"].number,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  wrapperStyle: _propTypes["default"].object,
	  contentStyle: _propTypes["default"].object,
	  cursor: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].element, _propTypes["default"].object]),
	  coordinate: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  position: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  isAnimationActive: _propTypes["default"].bool,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes["default"].func,
	  filterNull: _propTypes["default"].bool,
	  useTranslate3d: _propTypes["default"].bool
	};
	var defaultProps = {
	  active: false,
	  allowEscapeViewBox: {
	    x: false,
	    y: false
	  },
	  offset: 10,
	  viewBox: {
	    x1: 0,
	    x2: 0,
	    y1: 0,
	    y2: 0
	  },
	  coordinate: {
	    x: 0,
	    y: 0
	  },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultTooltipContent["default"], props);
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	
	    _this.getTranslate = function (_ref) {
	      var key = _ref.key,
	          tooltipDimension = _ref.tooltipDimension,
	          viewBoxDimension = _ref.viewBoxDimension;
	      var _this$props = _this.props,
	          allowEscapeViewBox = _this$props.allowEscapeViewBox,
	          coordinate = _this$props.coordinate,
	          offset = _this$props.offset,
	          position = _this$props.position,
	          viewBox = _this$props.viewBox;
	
	      if (position && (0, _DataUtils.isNumber)(position[key])) {
	        return position[key];
	      }
	
	      var restricted = coordinate[key] - tooltipDimension - offset;
	      var unrestricted = coordinate[key] + offset;
	
	      if (allowEscapeViewBox[key]) {
	        return unrestricted;
	      }
	
	      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
	      var viewBoxBoundary = viewBox[key] + viewBoxDimension;
	
	      if (tooltipBoundary > viewBoxBoundary) {
	        return Math.max(restricted, viewBox[key]);
	      }
	
	      return Math.max(unrestricted, viewBox[key]);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          filterNull = _this$props2.filterNull,
	          paylodUniqBy = _this$props2.paylodUniqBy;
	      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil2["default"])(entry.value);
	      }) : payload);
	      var hasPayload = finalPayload && finalPayload.length;
	      var _this$props3 = this.props,
	          content = _this$props3.content,
	          viewBox = _this$props3.viewBox,
	          coordinate = _this$props3.coordinate,
	          position = _this$props3.position,
	          active = _this$props3.active,
	          wrapperStyle = _this$props3.wrapperStyle;
	
	      var outerStyle = _objectSpread({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	
	      var translateX, translateY;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _this$state2 = this.state,
	            boxWidth = _this$state2.boxWidth,
	            boxHeight = _this$state2.boxHeight;
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = this.getTranslate({
	            key: 'x',
	            tooltipDimension: boxWidth,
	            viewBoxDimension: viewBox.width
	          });
	          translateY = this.getTranslate({
	            key: 'y',
	            tooltipDimension: boxHeight,
	            viewBoxDimension: viewBox.height
	          });
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
	      }), {}, outerStyle);
	
	      if (isAnimationActive && active) {
	        outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
	        }), {}, outerStyle);
	      }
	
	      var cls = (0, _classnames["default"])(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _classNames));
	      return _react["default"].createElement("div", {
	        className: cls,
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: finalPayload
	      })));
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.displayName = 'Tooltip';
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports["default"] = _default;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _Dot = _interopRequireDefault(__webpack_require__(208));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(380));
	
	var _Text = _interopRequireDefault(__webpack_require__(207));
	
	var _PolarUtils = __webpack_require__(126);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarAngleAxis, _PureComponent);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: "getTickLineCoord",
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          radius = _this$props.radius,
	          orientation = _this$props.orientation,
	          tickLine = _this$props.tickLine;
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	      return {
	        x1: p1.x,
	        y1: p1.y,
	        x2: p2.x,
	        y2: p2.y
	      };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          radius = _this$props2.radius,
	          axisLine = _this$props2.axisLine,
	          axisLineType = _this$props2.axisLineType;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react["default"].createElement(_Dot["default"], _extends({
	          className: "recharts-polar-angle-axis-line"
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	
	      var ticks = this.props.ticks;
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	      return _react["default"].createElement(_Polygon["default"], _extends({
	        className: "recharts-polar-angle-axis-line"
	      }, props, {
	        points: points
	      }));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props3 = this.props,
	          ticks = _this$props3.ticks,
	          tick = _this$props3.tick,
	          tickLine = _this$props3.tickLine,
	          tickFormatter = _this$props3.tickFormatter,
	          stroke = _this$props3.stroke;
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this.getTickLineCoord(entry);
	
	        var textAnchor = _this.getTickTextAnchor(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i,
	          payload: entry,
	          x: lineCoord.x2,
	          y: lineCoord.y2
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-angle-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-polar-angle-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          radius = _this$props4.radius,
	          axisLine = _this$props4.axisLine;
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis"
	      }, axisLine && this.renderAxisLine(), this.renderTicks());
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-angle-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.PureComponent);
	
	PolarAngleAxis.displayName = 'PolarAngleAxis';
	PolarAngleAxis.axisType = 'angleAxis';
	PolarAngleAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  hide: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  axisLineType: _propTypes["default"].oneOf(['polygon', 'circle']),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  stroke: _propTypes["default"].string,
	  orientation: _propTypes["default"].oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes["default"].func,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarAngleAxis.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	};
	var _default = PolarAngleAxis;
	exports["default"] = _default;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _minBy2 = _interopRequireDefault(__webpack_require__(2048));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(737));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Text = _interopRequireDefault(__webpack_require__(207));
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _PolarUtils = __webpack_require__(126);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarRadiusAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarRadiusAxis, _PureComponent);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: "getTickValueCoord",
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _this$props = this.props,
	          angle = _this$props.angle,
	          cx = _this$props.cx,
	          cy = _this$props.cy;
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	
	        case 'right':
	          textAnchor = 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getViewBox",
	    value: function getViewBox() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          angle = _this$props2.angle,
	          ticks = _this$props2.ticks;
	      var maxRadiusTick = (0, _maxBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      return {
	        cx: cx,
	        cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy,
	          angle = _this$props3.angle,
	          ticks = _this$props3.ticks,
	          axisLine = _this$props3.axisLine,
	          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-polar-radius-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          tick = _this$props4.tick,
	          angle = _this$props4.angle,
	          tickFormatter = _this$props4.tickFormatter,
	          stroke = _this$props4.stroke,
	          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var items = ticks.map(function (entry, i) {
	        var coord = _this.getTickValueCoord(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-radius-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          ticks = _this$props5.ticks,
	          axisLine = _this$props5.axisLine,
	          tick = _this$props5.tick;
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis"
	      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), _Label["default"].renderCallByParent(this.props, this.getViewBox()));
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-radius-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.PureComponent);
	
	PolarRadiusAxis.displayName = 'PolarRadiusAxis';
	PolarRadiusAxis.axisType = 'radiusAxis';
	PolarRadiusAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  angle: _propTypes["default"].number,
	  tickCount: _propTypes["default"].number,
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  orientation: _propTypes["default"].oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  allowDataOverflow: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarRadiusAxis.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	};
	var _default = PolarRadiusAxis;
	exports["default"] = _default;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Polygon, _PureComponent);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          points = _this$props.points,
	          className = _this$props.className;
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-polygon', className);
	      return _react["default"].createElement("polygon", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.PureComponent);
	
	Polygon.displayName = 'Polygon';
	Polygon.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }))
	});
	var _default = Polygon;
	exports["default"] = _default;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _PolarUtils = __webpack_require__(126);
	
	var _DataUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius,
	      cornerIsExternal = _ref.cornerIsExternal;
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	
	  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
	
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
	
	  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), lineTangencyAngle);
	  return {
	    center: center,
	    circleTangency: circleTangency,
	    lineTangency: lineTangency,
	    theta: theta
	  };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
	
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
	  } else {
	    path += "L ".concat(cx, ",").concat(cy, " Z");
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      forceCornerRadius = _ref3.forceCornerRadius,
	      cornerIsExternal = _ref3.cornerIsExternal,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: startAngle,
	    sign: sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: endAngle,
	    sign: -sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    if (forceCornerRadius) {
	      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
	    }
	
	    return getSectorPath({
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	  }
	
	  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: startAngle,
	      sign: sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: endAngle,
	      sign: -sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
	    }
	
	    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
	  } else {
	    path += "L".concat(cx, ",").concat(cy, "Z");
	  }
	
	  return path;
	};
	
	var Sector =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sector, _PureComponent);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          innerRadius = _this$props.innerRadius,
	          outerRadius = _this$props.outerRadius,
	          cornerRadius = _this$props.cornerRadius,
	          forceCornerRadius = _this$props.forceCornerRadius,
	          cornerIsExternal = _this$props.cornerIsExternal,
	          startAngle = _this$props.startAngle,
	          endAngle = _this$props.endAngle,
	          className = _this$props.className;
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          forceCornerRadius: forceCornerRadius,
	          cornerIsExternal: cornerIsExternal,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.PureComponent);
	
	Sector.displayName = 'Sector';
	Sector.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool
	});
	Sector.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0,
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	var _default = Sector;
	exports["default"] = _default;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = void 0;
	
	var _ReactUtils = __webpack_require__(28);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return "".concat(value, "px");
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	  return formatStrs.join('');
	}
	
	var getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
	  }, '');
	};
	
	exports.getStyleString = getStyleString;
	
	var getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	
	  var str = "".concat(text);
	  var styleString = getStyleString(style);
	  var cacheKey = "".concat(str, "-").concat(styleString);
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	
	
	    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, {}, style);
	
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	    measurementSpan.textContent = str;
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = {
	      width: rect.width,
	      height: rect.height
	    };
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	};
	
	exports.getStringSize = getStringSize;
	
	var getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = {
	    top: 0,
	    left: 0
	  }; // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	
	
	exports.getOffset = getOffset;
	
	var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};
	
	exports.calculateChartCoordinate = calculateChartCoordinate;

/***/ },
/* 383 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ifOverflowMatches = void 0;
	
	var ifOverflowMatches = function ifOverflowMatches(props, value) {
	  var alwaysShow = props.alwaysShow;
	  var ifOverflow = props.ifOverflow;
	
	  if (alwaysShow) {
	    ifOverflow = 'extendDomain';
	  }
	
	  return ifOverflow === value;
	};
	
	exports.ifOverflowMatches = ifOverflowMatches;

/***/ },
/* 384 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 385 */
/***/ function(module, exports) {

	// eslint-disable-next-line es/no-math-expm1 -- safe
	var $expm1 = Math.expm1;
	var exp = Math.exp;
	
	// `Math.expm1` method implementation
	// https://tc39.es/ecma262/#sec-math.expm1
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  var n = +x;
	  return n == 0 ? n : n > -1e-6 && n < 1e-6 ? n + n * n / 2 : exp(n) - 1;
	} : $expm1;


/***/ },
/* 386 */
[2779, 1030],
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(75);
	
	// `thisNumberValue` abstract operation
	// https://tc39.es/ecma262/#sec-thisnumbervalue
	module.exports = uncurryThis(1.0.valueOf);


/***/ },
/* 388 */
[2792, 2455],
/* 389 */
[2797, 92, 1037, 151, 1042, 1039, 1043],
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _hexToRgb = __webpack_require__(391);
	
	var _removeClass$getTopMargin$fadeIn$show$addClass = __webpack_require__(299);
	
	var _defaultParams = __webpack_require__(1048);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	/*
	 * Add modal + overlay to DOM
	 */
	
	var _injectedHTML = __webpack_require__(2549);
	
	var _injectedHTML2 = _interopRequireWildcard(_injectedHTML);
	
	var modalClass = '.sweet-alert';
	var overlayClass = '.sweet-overlay';
	
	var sweetAlertInitialize = function sweetAlertInitialize() {
	  var sweetWrap = document.createElement('div');
	  sweetWrap.innerHTML = _injectedHTML2['default'];
	
	  // Append elements to body
	  while (sweetWrap.firstChild) {
	    document.body.appendChild(sweetWrap.firstChild);
	  }
	};
	
	/*
	 * Get DOM element of modal
	 */
	var getModal = (function (_getModal) {
	  function getModal() {
	    return _getModal.apply(this, arguments);
	  }
	
	  getModal.toString = function () {
	    return _getModal.toString();
	  };
	
	  return getModal;
	})(function () {
	  var $modal = document.querySelector(modalClass);
	
	  if (!$modal) {
	    sweetAlertInitialize();
	    $modal = getModal();
	  }
	
	  return $modal;
	});
	
	/*
	 * Get DOM element of input (in modal)
	 */
	var getInput = function getInput() {
	  var $modal = getModal();
	  if ($modal) {
	    return $modal.querySelector('input');
	  }
	};
	
	/*
	 * Get DOM element of overlay
	 */
	var getOverlay = function getOverlay() {
	  return document.querySelector(overlayClass);
	};
	
	/*
	 * Add box-shadow style to button (depending on its chosen bg-color)
	 */
	var setFocusStyle = function setFocusStyle($button, bgColor) {
	  var rgbColor = _hexToRgb.hexToRgb(bgColor);
	  $button.style.boxShadow = '0 0 2px rgba(' + rgbColor + ', 0.8), inset 0 0 0 1px rgba(0, 0, 0, 0.05)';
	};
	
	/*
	 * Animation when opening modal
	 */
	var openModal = function openModal(callback) {
	  var $modal = getModal();
	  _removeClass$getTopMargin$fadeIn$show$addClass.fadeIn(getOverlay(), 10);
	  _removeClass$getTopMargin$fadeIn$show$addClass.show($modal);
	  _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'showSweetAlert');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'hideSweetAlert');
	
	  window.previousActiveElement = document.activeElement;
	  var $okButton = $modal.querySelector('button.confirm');
	  $okButton.focus();
	
	  setTimeout(function () {
	    _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'visible');
	  }, 500);
	
	  var timer = $modal.getAttribute('data-timer');
	
	  if (timer !== 'null' && timer !== '') {
	    var timerCallback = callback;
	    $modal.timeout = setTimeout(function () {
	      var doneFunctionExists = (timerCallback || null) && $modal.getAttribute('data-has-done-function') === 'true';
	      if (doneFunctionExists) {
	        timerCallback(null);
	      } else {
	        sweetAlert.close();
	      }
	    }, timer);
	  }
	};
	
	/*
	 * Reset the styling of the input
	 * (for example if errors have been shown)
	 */
	var resetInput = function resetInput() {
	  var $modal = getModal();
	  var $input = getInput();
	
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'show-input');
	  $input.value = _defaultParams2['default'].inputValue;
	  $input.setAttribute('type', _defaultParams2['default'].inputType);
	  $input.setAttribute('placeholder', _defaultParams2['default'].inputPlaceholder);
	
	  resetInputError();
	};
	
	var resetInputError = function resetInputError(event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Set "margin-top"-property on modal based on its computed height
	 */
	var fixVerticalPosition = function fixVerticalPosition() {
	  var $modal = getModal();
	  $modal.style.marginTop = _removeClass$getTopMargin$fadeIn$show$addClass.getTopMargin(getModal());
	};
	
	exports.sweetAlertInitialize = sweetAlertInitialize;
	exports.getModal = getModal;
	exports.getOverlay = getOverlay;
	exports.getInput = getInput;
	exports.setFocusStyle = setFocusStyle;
	exports.openModal = openModal;
	exports.resetInput = resetInput;
	exports.resetInputError = resetInputError;
	exports.fixVerticalPosition = fixVerticalPosition;

/***/ },
/* 391 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	/*
	 * Allow user to pass their own params
	 */
	var extend = function extend(a, b) {
	  for (var key in b) {
	    if (b.hasOwnProperty(key)) {
	      a[key] = b[key];
	    }
	  }
	  return a;
	};
	
	/*
	 * Convert HEX codes to RGB values (#000000 -> rgb(0,0,0))
	 */
	var hexToRgb = function hexToRgb(hex) {
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) : null;
	};
	
	/*
	 * Check if the user is using Internet Explorer 8 (for fallbacks)
	 */
	var isIE8 = function isIE8() {
	  return window.attachEvent && !window.addEventListener;
	};
	
	/*
	 * IE compatible logging for developers
	 */
	var logStr = function logStr(string) {
	  if (window.console) {
	    // IE...
	    window.console.log('SweetAlert: ' + string);
	  }
	};
	
	/*
	 * Set hover, active and focus-states for buttons 
	 * (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	 */
	var colorLuminance = function colorLuminance(hex, lum) {
	  // Validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  lum = lum || 0;
	
	  // Convert to decimal and change luminosity
	  var rgb = '#';
	  var c;
	  var i;
	
	  for (i = 0; i < 3; i++) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};
	
	exports.extend = extend;
	exports.hexToRgb = hexToRgb;
	exports.isIE8 = isIE8;
	exports.logStr = logStr;
	exports.colorLuminance = colorLuminance;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/LandingPageLogo3.9aaae3f0.png";

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dedupedGet = dedupedGet;
	
	var _ApiService = __webpack_require__(4);
	
	// In-flight GET deduplication keyed by URL. Concurrent calls to the
	// same URL share one network request and resolve with the same
	// response. Cache clears the moment the request resolves (or
	// rejects) — subsequent calls fire a fresh request.
	//
	// Intended for pages where multiple components independently fetch
	// the same resource during their mount cycles (e.g. the student
	// peer-review page where PeerReview, each <PeerEvaluation> child,
	// and StudentResultsNotifications all GET /v2/forms/feedbacks/,
	// /v2/forms/surveys/?course=, and /team/players/?team= on their own).
	//
	// Not a cache for repeated navigation — only dedupes while a request
	// is in flight. For a time-based cache see AppGeneralInfoService.js.
	
	var _inflight = new Map();
	
	function dedupedGet(url) {
	  var existing = _inflight.get(url);
	  if (existing) return existing;
	  var promise = new Promise(function (resolve, reject) {
	    (0, _ApiService.getRequest)(url).then(function (res) {
	      _inflight.delete(url);
	      resolve(res);
	    }).catch(function (err) {
	      _inflight.delete(url);
	      reject(err);
	    });
	  });
	  _inflight.set(url, promise);
	  return promise;
	}

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenericTable = function GenericTable(_ref) {
	  var header = _ref.header,
	      rows = _ref.rows;
	  return _react2.default.createElement(
	    "div",
	    { style: { marginBottom: "1.5em" } },
	    _react2.default.createElement(
	      "table",
	      {
	        style: {
	          width: "100%",
	          fontFamily: _styles.fontFamily,
	          fontSize: "16px"
	        }
	      },
	      _react2.default.createElement(
	        "tbody",
	        null,
	        _react2.default.createElement(
	          "tr",
	          {
	            style: {
	              color: "#2F9CA3",
	              fontWeight: "800",
	              fontSize: "18px",
	              textAlign: "center"
	            }
	          },
	          (0, _lodash.map)(header, function (item, idx) {
	            return _react2.default.createElement(
	              "td",
	              { key: idx, style: item.highlighted ? {} : { color: "#000000" } },
	              item.name
	            );
	          })
	        ),
	        (0, _lodash.map)(rows, function (row, idx) {
	          return _react2.default.createElement(
	            "tr",
	            { style: { textAlign: "center" }, key: idx },
	            (0, _lodash.map)(row, function (item, itemIdx) {
	              return _react2.default.createElement(
	                "td",
	                { key: itemIdx },
	                item
	              );
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = GenericTable;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IncomeStatementPanel = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _MoneyTable = __webpack_require__(396);
	
	var _MoneyTable2 = _interopRequireDefault(_MoneyTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var incomeStatementKeys = [{
	  group: "Gross Profits",
	  rows: [{ label: "Net Revenues" }, { label: "Cost of Goods Sold", key: "Cost of Sales" }, { label: "Gross Profit" }]
	}, {
	  group: "Operating Profit",
	  rows: [{ label: "R&D", key: "R&D Costs" }, { label: "Holding Expenses", key: "Holding Costs" }, { label: "Promotion", key: "Promotion Costs" }, { label: "Selling", key: "Selling Costs" }, {
	    label: "Other G&A",
	    key: "Other G&A Costs",
	    fn: function fn(sheet) {
	      return sheet["Other G&A Costs"] + sheet["Depreciation Expense"];
	    }
	  }, {
	    label: "Operating Profit",
	    fn: function fn(sheet) {
	      return sheet["Gross Profit"] + sheet["Total Operating Costs"];
	    }
	  }]
	}, {
	  group: "Net Profits",
	  rows: [{ label: "Interest Expense" }, { label: "Gain or Losses", key: "Gain or Loss of Sales" }, { label: "Taxes" }, { label: "Net Profits", key: "Net Income" }]
	}];
	
	var IncomeStatementPanel = exports.IncomeStatementPanel = function IncomeStatementPanel(_ref) {
	  var sheet = _ref.sheet;
	  return _react2.default.createElement(_MoneyTable2.default, { keys: (0, _MoneyTable.populateKeys)(incomeStatementKeys, sheet) });
	};
	
	var IncomeStatement = function IncomeStatement(_ref2) {
	  var incomeStatement = _ref2.incomeStatement,
	      round = _ref2.round,
	      rounds = _ref2.rounds;
	
	  var roundObj = rounds.find(function (i) {
	    return Number(i.number) === round;
	  });
	  var isRoundLive = roundObj ? roundObj.is_started === true && roundObj.is_finished === false && roundObj.should_be_finished === false : false;
	
	  var incomeStatementText = isRoundLive ? 'This is the current state of your income statement based on product, marketing, operations, and finance expenses. Your revenues and cost of goods sold (i.e. gross profit information) will appear after the round ends.' : "Your team generated revenues of" + " " + (0, _format.moneyFormat)(incomeStatement["Net Revenues"]) + " and net profits of" + " " + (0, _format.moneyFormat)(incomeStatement["Net Income"]) + ".";
	
	  return _react2.default.createElement(
	    _TwoPanels2.default,
	    { title1: "Income Statement", title2: "Income Statement" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      incomeStatementText
	    ),
	    _react2.default.createElement(IncomeStatementPanel, { sheet: incomeStatement })
	  );
	};
	
	exports.default = IncomeStatement;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.populateKeys = undefined;
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  letter-spacing: 0;\n  text-transform: none;\n  width: 260px;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  letter-spacing: 0;\n  text-transform: none;\n  width: 260px;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.4);\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n  margin-left: 6px;\n  vertical-align: middle;\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.4);\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n  margin-left: 6px;\n  vertical-align: middle;\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(21);
	
	var _styles = __webpack_require__(68);
	
	var _format = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var InfoTooltip = _styledComponents2.default.span(_templateObject);
	
	var InfoIcon = _styledComponents2.default.span(_templateObject2, InfoTooltip);
	
	var populateKeys = exports.populateKeys = function populateKeys(groups, values) {
	  return (0, _lodash.map)(groups, function (group) {
	    return Object.assign({}, group, {
	      rows: (0, _lodash.filter)((0, _lodash.map)(group.rows, function (el) {
	        return Object.assign({}, el, {
	          value: el.fn ? el.fn(values) : values[el.key || el.label]
	        });
	      }), function (_ref, index, rows) {
	        var value = _ref.value;
	        return value !== 0 || index === rows.length - 1;
	      })
	    });
	  });
	};
	
	var formatSpecific = function formatSpecific(value, label) {
	  if (label === "Holding Expenses" && value >= -1 && value <= 1) {
	    return value < 0 ? "-$0.000 M" : "$0.000 M";
	  }
	
	  var shortValue = Math.abs(Number((value / 1e6).toFixed(3)));
	  if (shortValue === 0) {
	    return value < 0 ? "-$0.000 M" : "$0.000 M";
	  }
	
	  return (0, _format.moneyFormatM)(value);
	};
	
	var MoneyTable = function MoneyTable(_ref2) {
	  var keys = _ref2.keys;
	  return _react2.default.createElement(
	    "table",
	    { style: _styles.tableStyle },
	    _react2.default.createElement(
	      "tbody",
	      null,
	      (0, _lodash.flatten)((0, _lodash.map)(keys, function (_ref3) {
	        var group = _ref3.group,
	            rows = _ref3.rows;
	        return (0, _lodash.map)(rows, function (_ref4, index) {
	          var label = _ref4.label,
	              key = _ref4.key,
	              value = _ref4.value,
	              withoutValue = _ref4.withoutValue,
	              tooltip = _ref4.tooltip;
	          return [_react2.default.createElement(
	            "tr",
	            {
	              style: {
	                height: "2.2em"
	              },
	              key: label
	            },
	            index === 0 ? _react2.default.createElement(
	              "td",
	              { rowSpan: rows.length, style: _styles.tableLabelStyle },
	              group
	            ) : null,
	            _react2.default.createElement(
	              "td",
	              {
	                style: Object.assign({
	                  width: "100%",
	                  paddingRight: "2ch",
	                  borderRadius: "1.1em 0 0 1.1em"
	                }, index === rows.length - 1 ? { backgroundColor: "#8DD9DE" } : {}, {
	                  textDecoration: withoutValue ? "underline" : "none",
	                  paddingTop: withoutValue ? "15px" : "0",
	                  paddingBottom: withoutValue ? "5px" : "0"
	                })
	              },
	              label,
	              tooltip && _react2.default.createElement(
	                InfoIcon,
	                null,
	                "?",
	                _react2.default.createElement(
	                  InfoTooltip,
	                  null,
	                  tooltip
	                )
	              )
	            ),
	            !withoutValue && _react2.default.createElement(
	              "td",
	              {
	                style: Object.assign({
	                  textAlign: "center",
	                  color: value < 0 ? "#FF0000" : "#3A3A3A",
	                  fontSize: "16px",
	                  paddingRight: "1ch"
	                }, index === rows.length - 1 ? { backgroundColor: "#8DD9DE", fontWeight: "bold" } : { fontWeight: "normal" })
	              },
	              formatSpecific(value, label)
	            )
	          ), index === rows.length - 1 ? _react2.default.createElement(
	            "tr",
	            { style: { height: "1em" } },
	            _react2.default.createElement("td", null),
	            _react2.default.createElement("td", null),
	            _react2.default.createElement("td", null)
	          ) : null];
	        });
	      }))
	    )
	  );
	};
	
	exports.default = MoneyTable;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _lodash = __webpack_require__(21);
	
	var _recompose = __webpack_require__(55);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _customLabel = __webpack_require__(1119);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	var _tooltipContent = __webpack_require__(1121);
	
	var _tooltipContent2 = _interopRequireDefault(_tooltipContent);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCurrentToken = function getCurrentToken() {
	  return _Auth2.default.getToken();
	};
	
	var getCurrentCourseId = function getCurrentCourseId() {
	  return _Auth2.default.getCourseId();
	};
	
	var getCurrentUserId = function getCurrentUserId() {
	  return _Auth2.default.getUserId();
	};
	
	var tickFormatter = (0, _lodash.memoize)(function (suffix, precision) {
	  return function (value) {
	    return "" + value.toFixed(precision) + suffix;
	  };
	});
	
	var customLabel = function customLabel(props) {
	  var value = props.value,
	      x = props.x,
	      y = props.y,
	      height = props.height;
	
	  var obj = JSON.parse(value);
	  return obj.value >= 0 ? _react2.default.createElement(
	    "text",
	    {
	      x: x - 5,
	      y: y + height / 2,
	      fill: "#000",
	      dominantBaseline: "middle",
	      textAnchor: "end"
	    },
	    obj.name
	  ) : _react2.default.createElement(
	    "text",
	    {
	      x: x + 5,
	      y: y + height / 2,
	      fill: "#000",
	      dominantBaseline: "middle",
	      textAnchor: "start"
	    },
	    obj.name
	  );
	};
	
	//FIXME make proper ticks (not used for now as x ticks are hidden)
	var getTicks = function getTicks(min, max) {
	  return min <= 0 && max >= 0 ? { ticks: [-1, 0, 1], tickPrecision: 0 } : { ticks: [0, 1, 2], tickPrecision: 0 };
	};
	
	var CustomXAxisLabel = function (_PureComponent) {
	  _inherits(CustomXAxisLabel, _PureComponent);
	
	  function CustomXAxisLabel() {
	    _classCallCheck(this, CustomXAxisLabel);
	
	    return _possibleConstructorReturn(this, (CustomXAxisLabel.__proto__ || Object.getPrototypeOf(CustomXAxisLabel)).apply(this, arguments));
	  }
	
	  _createClass(CustomXAxisLabel, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          value = _props.value,
	          height = _props.height,
	          instructorData = _props.instructorData;
	
	      var payload = JSON.parse(value);
	      var additionalOffset = payload.name.length - 1;
	      if (additionalOffset < 0) {
	        additionalOffset = 0;
	      }
	
	      return _react2.default.createElement(
	        "g",
	        { transform: "translate(" + (x - 5) + "," + (y + height / 2) + ")" },
	        _react2.default.createElement(
	          "text",
	          {
	            x: 0,
	            y: 0,
	            dx: payload.value >= 0 ? 0 : 10,
	            textAnchor: payload.value >= 0 ? "end" : "start",
	            dominantBaseline: "middle",
	            fill: "#666"
	          },
	          payload.name
	        ),
	        _react2.default.createElement(
	          "a",
	          {
	            href: "/analysis/team-reports/grades-ranks/" + instructorData.type + "?team_id=" + payload.id + "&round_number=" + instructorData.roundNumber + "&game_id=" + instructorData.currentGame + "&_token=" + getCurrentToken() + "&_userid=" + getCurrentUserId() + "&_courseid=" + getCurrentCourseId() + "&_target=blank",
	            target: "_blank",
	            rel: "noreferrer"
	          },
	          _react2.default.createElement(
	            "text",
	            {
	              x: 0,
	              y: 0,
	              dx: payload.value >= 0 ? -15 - additionalOffset * 5 : 25 + additionalOffset * 5,
	              textAnchor: payload.value >= 0 ? "end" : "start",
	              dominantBaseline: "middle",
	              fill: "#666"
	            },
	            "View"
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomXAxisLabel;
	}(_react.PureComponent);
	
	var VerticalBar = (0, _recompose.pure)(function (_ref) {
	  var _ref$prefix = _ref.prefix,
	      prefix = _ref$prefix === undefined ? "" : _ref$prefix,
	      _ref$suffix = _ref.suffix,
	      suffix = _ref$suffix === undefined ? "" : _ref$suffix,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? 2 : _ref$precision,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data,
	      _ref$hideNames = _ref.hideNames,
	      hideNames = _ref$hideNames === undefined ? false : _ref$hideNames,
	      _ref$xAxisLine = _ref.xAxisLine,
	      xAxisLine = _ref$xAxisLine === undefined ? true : _ref$xAxisLine,
	      _ref$yAxisLine = _ref.yAxisLine,
	      yAxisLine = _ref$yAxisLine === undefined ? true : _ref$yAxisLine,
	      _ref$xTick = _ref.xTick,
	      xTick = _ref$xTick === undefined ? true : _ref$xTick,
	      _ref$yTick = _ref.yTick,
	      yTick = _ref$yTick === undefined ? true : _ref$yTick,
	      _ref$xTickLine = _ref.xTickLine,
	      xTickLine = _ref$xTickLine === undefined ? true : _ref$xTickLine,
	      _ref$yTickLine = _ref.yTickLine,
	      yTickLine = _ref$yTickLine === undefined ? false : _ref$yTickLine,
	      _ref$customColors = _ref.customColors,
	      customColors = _ref$customColors === undefined ? null : _ref$customColors,
	      _ref$showCategoryLabe = _ref.showCategoryLabels,
	      showCategoryLabels = _ref$showCategoryLabe === undefined ? false : _ref$showCategoryLabe,
	      _ref$instructorData = _ref.instructorData,
	      instructorData = _ref$instructorData === undefined ? null : _ref$instructorData,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? null : _ref$teams;
	
	  var dataModded = (0, _lodash.map)(data, function (item) {
	    return Object.assign({}, item, {
	      all: JSON.stringify(item)
	    });
	  });
	  var min = Math.min.apply(null, (0, _lodash.map)(data, "value"));
	  var max = Math.max.apply(null, (0, _lodash.map)(data, "value"));
	
	  if (min === 0 && max === 0) {
	    min = -10;
	    max = 10;
	  } else {
	    min = min < 0 ? min : 0;
	  }
	
	  var span = max - min;
	  var delta = span * 0.5;
	  var domain = [min - delta / 2, max + delta / 2];
	  var colors = customColors ? customColors : _Teams2.default.competitiveColors(teams);
	
	  var _getTicks = getTicks(domain[0], domain[1]),
	      ticks = _getTicks.ticks,
	      tickPrecision = _getTicks.tickPrecision;
	
	  return _react2.default.createElement(
	    _recharts.ResponsiveContainer,
	    { width: "100%", height: 200 },
	    _react2.default.createElement(
	      _recharts.BarChart,
	      { data: dataModded, barSize: 18, layout: "vertical" },
	      _react2.default.createElement(_recharts.XAxis, {
	        type: "number",
	        dataKey: "value",
	        domain: domain,
	        axisLine: xAxisLine,
	        tick: xTick,
	        tickLine: xTickLine,
	        tickFormatter: tickFormatter(suffix, tickPrecision),
	        ticks: ticks,
	        hide: true
	      }),
	      _react2.default.createElement(_recharts.YAxis, {
	        type: "category",
	        dataKey: "name",
	        hide: true,
	        axisLine: yAxisLine,
	        tick: yTick,
	        tickLine: yTickLine
	      }),
	      _react2.default.createElement(_recharts.Tooltip, {
	        content: _react2.default.createElement(_tooltipContent2.default, { prefix: prefix, suffix: suffix })
	      }),
	      _react2.default.createElement(_recharts.ReferenceLine, { x: 0, stroke: "#000" }),
	      _react2.default.createElement(
	        _recharts.Bar,
	        {
	          dataKey: "value",
	          minPointSize: 5,
	          isAnimationActive: !showCategoryLabels,
	          label: _react2.default.createElement(_customLabel2.default, {
	            prefix: prefix,
	            precision: precision,
	            suffix: suffix,
	            layout: "vertical"
	          })
	        },
	        _react2.default.createElement(_recharts.LabelList, {
	          dataKey: "all",
	          content: instructorData ? _react2.default.createElement(CustomXAxisLabel, { instructorData: instructorData }) : customLabel
	        }),
	        colors.map(function (color, i) {
	          return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	        })
	      )
	    )
	  );
	});
	
	exports.default = VerticalBar;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TooltipContent(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      label = _ref.label,
	      prefix = _ref.prefix,
	      suffix = _ref.suffix,
	      _ref$showNewLine = _ref.showNewLine,
	      showNewLine = _ref$showNewLine === undefined ? false : _ref$showNewLine,
	      _ref$showColon = _ref.showColon,
	      showColon = _ref$showColon === undefined ? true : _ref$showColon,
	      _ref$prefixFirst = _ref.prefixFirst,
	      prefixFirst = _ref$prefixFirst === undefined ? false : _ref$prefixFirst;
	
	  var tooltipStyle = {
	    margin: 0,
	    padding: 10,
	    backgroundColor: "#fff",
	    border: "1px solid #ccc",
	    whiteSpace: "nowrap"
	  };
	
	  if (active) {
	    var value = "";
	    var style = {};
	
	    if (payload && payload.length > 0) {
	      value = payload[0].value.toFixed(2);
	      if (payload[0].value < 0) {
	        style = {
	          color: "red"
	        };
	      }
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "recharts-default-tooltip", style: tooltipStyle },
	      prefixFirst && prefix,
	      label,
	      showColon && ":",
	      " ",
	      _react2.default.createElement(
	        "span",
	        { style: style },
	        !prefixFirst && prefix,
	        showNewLine && _react2.default.createElement("br", null),
	        value,
	        suffix
	      )
	    );
	  }
	
	  return null;
	}
	
	exports.default = TooltipContent;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 20px;\n\n  ", "\n"], ["\n  padding: 20px;\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _responsiveTable = __webpack_require__(403);
	
	var _responsiveTable2 = _interopRequireDefault(_responsiveTable);
	
	var _row = __webpack_require__(404);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _tbody = __webpack_require__(405);
	
	var _tbody2 = _interopRequireDefault(_tbody);
	
	var _headCell = __webpack_require__(402);
	
	var _headCell2 = _interopRequireDefault(_headCell);
	
	var _bodyCell = __webpack_require__(401);
	
	var _bodyCell2 = _interopRequireDefault(_bodyCell);
	
	var _utils = __webpack_require__(18);
	
	var _marketButton = __webpack_require__(307);
	
	var _marketButton2 = _interopRequireDefault(_marketButton);
	
	var _thead = __webpack_require__(406);
	
	var _thead2 = _interopRequireDefault(_thead);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var getBackgroundVariant = function getBackgroundVariant(value, itemRound, currentRound) {
	  if (itemRound === currentRound && value > 0) {
	    return "highlighted";
	  } else if (value <= 0) {
	    return "disabled";
	  } else {
	    return "default";
	  }
	};
	
	var TableWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.padding && "\n    padding: " + p.padding + ";\n  ";
	});
	
	var TableHeaderText = _styledComponents2.default.div(_templateObject2);
	
	var FinancialTargets = function FinancialTargets(props) {
	  var round = props.round,
	      financialTargets = props.financialTargets,
	      showTableOnly = props.showTableOnly,
	      showFullTable = props.showFullTable,
	      hideTitle = props.hideTitle,
	      padding = props.padding,
	      _onHelpIconClick = props.onHelpIconClick;
	
	
	  var businessUrl = "analysis/bcase?round=" + round;
	  var analysisUrl = "ceo/analysis/market?round=" + round;
	
	  return !showTableOnly ? _react2.default.createElement(
	    "div",
	    { className: "financial-targets" },
	    _react2.default.createElement(
	      "div",
	      { className: "financial-targets__col" },
	      _react2.default.createElement(
	        "h3",
	        { className: "financial-targets__title" },
	        "Financial Targets"
	      ),
	      _react2.default.createElement(
	        _responsiveTable2.default,
	        null,
	        _react2.default.createElement(
	          _thead2.default,
	          null,
	          _react2.default.createElement(
	            _row2.default,
	            null,
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "sorter", cellSize: "small" },
	              "Year"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "Market Share"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "Revenues"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "Gross Margins"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "Share Price"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "ROE"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "ROA"
	            ),
	            _react2.default.createElement(
	              _headCell2.default,
	              { iconType: "help" },
	              "EPS"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _tbody2.default,
	          null,
	          financialTargets.map(function (item, index) {
	            return _react2.default.createElement(
	              _row2.default,
	              { key: "financial-targets-row-" + index, isBody: true },
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  alignText: "center",
	                  cellSize: "small",
	                  backgroundVariant: getBackgroundVariant(item.round_number, item.round_number, round)
	                },
	                item.round_number
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.market_share, item.round_number, round)
	                },
	                item.market_share > 0 ? (0, _utils.decimalsRound)(item.market_share * 100, 2) + "%" : "--"
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.net_revenues, item.round_number, round)
	                },
	                item.net_revenues > 0 ? "$" + (0, _utils.decimalsRound)(item.net_revenues / 1000000, 2) + "M" : "--"
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.gross_margin, item.round_number, round)
	                },
	                item.gross_margin > 0 ? (0, _utils.decimalsRound)(item.gross_margin * 100, 2) + "%" : "--"
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.stock_price, item.round_number, round)
	                },
	                item.stock_price > 0 ? "$" + (0, _utils.decimalsRound)(item.stock_price, 2) : "--"
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.roe, item.round_number, round)
	                },
	                item.roe > 0 ? (0, _utils.decimalsRound)(item.roe * 100, 2) + "%" : "--"
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.roa, item.round_number, round)
	                },
	                item.roa > 0 ? (0, _utils.decimalsRound)(item.roa * 100, 2) + "%" : "--"
	              ),
	              _react2.default.createElement(
	                _bodyCell2.default,
	                {
	                  backgroundVariant: getBackgroundVariant(item.earnings_per_share, item.round_number, round)
	                },
	                item.earnings_per_share > 0 ? "$" + (0, _utils.decimalsRound)(item.earnings_per_share, 2) : "--"
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)("financial-targets__info", "financial-targets__col") },
	      _react2.default.createElement(
	        "h3",
	        { className: "financial-targets__title" },
	        "Market Research"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "financial-targets__text" },
	        "Once you understand the Financial Targets, you\u2019ll need to review the Business Case and the Customer Analysis to determine which customer(s) you want to serve to help you meet your Financial Targets."
	      ),
	      _react2.default.createElement(
	        _marketButton2.default,
	        {
	          size: "medium",
	          variant: "info",
	          type: "outlined",
	          href: businessUrl
	        },
	        "Read Business Case"
	      ),
	      _react2.default.createElement(
	        _marketButton2.default,
	        {
	          size: "medium",
	          variant: "info",
	          type: "outlined",
	          href: analysisUrl
	        },
	        "View Customer Analysis"
	      )
	    )
	  ) : _react2.default.createElement(
	    TableWrapper,
	    { padding: padding },
	    !hideTitle && _react2.default.createElement(
	      TableHeaderText,
	      null,
	      "Financial Metrics & Targets"
	    ),
	    _react2.default.createElement(
	      _responsiveTable2.default,
	      null,
	      _react2.default.createElement(
	        _thead2.default,
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "sort", cellSize: "small" },
	            "Year"
	          ),
	          _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Market Share");
	              } },
	            "Market Share"
	          ),
	          _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Revenues");
	              } },
	            "Revenues"
	          ),
	          _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Gross Margins");
	              } },
	            "Gross Margins"
	          ),
	          _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Share Price");
	              } },
	            "Share Price"
	          ),
	          showFullTable && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("ROE");
	              } },
	            "ROE"
	          ),
	          showFullTable && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("ROA");
	              } },
	            "ROA"
	          ),
	          showFullTable && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("EPS");
	              } },
	            "EPS"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _tbody2.default,
	        null,
	        financialTargets.map(function (item, index) {
	          return _react2.default.createElement(
	            _row2.default,
	            { key: "financial-targets-row-" + index, isBody: true },
	            _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                alignText: "center",
	                cellSize: "small",
	                backgroundVariant: "default"
	              },
	              item.round_number
	            ),
	            _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.market_share, item.round_number, round)
	              },
	              item.market_share > 0 ? (0, _utils.decimalsRound)(item.market_share * 100, 2) + "%" : "--"
	            ),
	            _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.net_revenues, item.round_number, round)
	              },
	              item.net_revenues > 0 ? "$" + (0, _utils.decimalsRound)(item.net_revenues / 1000000, 2) + "M" : "--"
	            ),
	            _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.gross_margin, item.round_number, round)
	              },
	              item.gross_margin > 0 ? (0, _utils.decimalsRound)(item.gross_margin * 100, 2) + "%" : "--"
	            ),
	            _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.stock_price, item.round_number, round)
	              },
	              item.stock_price > 0 ? "$" + (0, _utils.decimalsRound)(item.stock_price, 2) : "--"
	            ),
	            showFullTable && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.roe, item.round_number, round)
	              },
	              item.roe > 0 ? (0, _utils.decimalsRound)(item.roe * 100, 2) + "%" : "--"
	            ),
	            showFullTable && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.roa, item.round_number, round)
	              },
	              item.roa > 0 ? (0, _utils.decimalsRound)(item.roa * 100, 2) + "%" : "--"
	            ),
	            showFullTable && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.earnings_per_share, item.round_number, round)
	              },
	              item.earnings_per_share > 0 ? "$" + (0, _utils.decimalsRound)(item.earnings_per_share, 2) : "--"
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = FinancialTargets;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The raw data, which is 50,000 should be formatted in the following form $0.05M
	 * with the following steps:
	 * - divided by 1,000,000
	 * - presented in 2 decimal places
	 * - have the letter "M" after the last digit
	 * - prefixed with $ symbol in front of the first digit
	 */
	var PromoSpendTextMasking = function (_Component) {
	  _inherits(PromoSpendTextMasking, _Component);
	
	  function PromoSpendTextMasking() {
	    _classCallCheck(this, PromoSpendTextMasking);
	
	    return _possibleConstructorReturn(this, (PromoSpendTextMasking.__proto__ || Object.getPrototypeOf(PromoSpendTextMasking)).apply(this, arguments));
	  }
	
	  _createClass(PromoSpendTextMasking, [{
	    key: "render",
	    value: function render() {
	      var value = this.props.value;
	      value = (value / 1000000).toFixed(2);
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "$" + value + "M"
	      );
	    }
	  }]);
	
	  return PromoSpendTextMasking;
	}(_react.Component);
	
	exports.default = PromoSpendTextMasking;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BodyCell = function BodyCell(props) {
	  var cellSize = props.cellSize,
	      backgroundVariant = props.backgroundVariant,
	      alignText = props.alignText,
	      children = props.children,
	      className = props.className;
	
	
	  var teamColor1 = _Teams2.default.currentTeamColorLevel1();
	  var disabledColor = "hsla(202, 100%, 8%, 0.02)";
	  var defaultHighlightedColor = "rgb(141, 217, 222)";
	
	  var backgroundColor = backgroundVariant === "default" ? "$color-white" : backgroundVariant === "disabled" ? disabledColor : teamColor1 ? teamColor1 : defaultHighlightedColor;
	
	  return _react2.default.createElement(
	    "td",
	    { className: className },
	    _react2.default.createElement(
	      "div",
	      {
	        className: (0, _classnames2.default)("responsive-table__cell", "responsive-table__cell_" + alignText, "responsive-table__cell_" + cellSize),
	        style: { backgroundColor: backgroundColor }
	      },
	      " ",
	      children
	    )
	  );
	};
	
	BodyCell.defaultProps = {
	  alignText: "center",
	  isGrow: true,
	  backgroundVariant: "default",
	  cellSize: "medium"
	};
	
	BodyCell.propsType = {
	  alignText: _propTypes2.default.oneOf(["left", "right", "center"]),
	  backgroundVariant: _propTypes2.default.oneOf(["default", "highlighted", "disabled"]),
	  cellSize: _propTypes2.default.oneOf(["small", "medium"]),
	  isGrow: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	exports.default = BodyCell;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _iconTableSorter = __webpack_require__(1851);
	
	var _iconTableSorter2 = _interopRequireDefault(_iconTableSorter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeadCell = function HeadCell(props) {
	  var cellSize = props.cellSize,
	      iconType = props.iconType,
	      alignText = props.alignText,
	      children = props.children,
	      className = props.className,
	      onHelpIconClick = props.onHelpIconClick;
	
	
	  return _react2.default.createElement(
	    "th",
	    { className: className },
	    _react2.default.createElement(
	      "div",
	      {
	        className: (0, _classnames2.default)("responsive-table__cell", "responsive-table__cell_" + alignText, "responsive-table__cell_" + cellSize)
	      },
	      children,
	      iconType === "sorter" && _react2.default.createElement("img", { alt: "table icon sorter", src: _iconTableSorter2.default, width: "12px", height: "40px" }),
	      iconType === "help" && _react2.default.createElement("img", { alt: "table icon help", src: _iconTableHelp2.default, onClick: onHelpIconClick, width: "14px", height: "14px" })
	    )
	  );
	};
	
	HeadCell.defaultProps = {
	  alignText: "center",
	  iconType: null,
	  isGrow: true,
	  isHighlighted: false,
	  highlightColor: "",
	  cellSize: "medium"
	};
	
	HeadCell.propsType = {
	  iconType: _propTypes2.default.oneOf(["help", "sort"]),
	  alignText: _propTypes2.default.oneOf(["left", "right", "center"]),
	  cellSize: _propTypes2.default.oneOf(["small", "medium"]),
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  onHelpIconClick: _propTypes2.default.func
	};
	
	exports.default = HeadCell;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveTable = function ResponsiveTable(props) {
	  var children = props.children,
	      className = props.className;
	
	  // return <div className={cn("responsive-table", className)}>{children}</div>;
	
	  return _react2.default.createElement(
	    "table",
	    { className: (0, _classnames2.default)(className, "responsive-table") },
	    children
	  );
	};
	
	ResponsiveTable.propsType = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	exports.default = ResponsiveTable;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = function Row(props) {
	  var children = props.children,
	      className = props.className;
	
	
	  return (
	    // <div className={cn("responsive-table__row", className)}>{children}</div>
	    _react2.default.createElement(
	      "tr",
	      { className: (0, _classnames2.default)("responsive-table__row", className) },
	      children
	    )
	  );
	};
	
	Row.propsType = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	exports.default = Row;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TBody = function TBody(props) {
	  var children = props.children,
	      className = props.className;
	
	
	  return (
	    // <div
	    //   className={cn(
	    //     "responsive-table__tbody",
	    //     className
	    //   )}
	    // >
	    //   {children}
	    // </div>
	    _react2.default.createElement(
	      "tbody",
	      { className: (0, _classnames2.default)("responsive-table__tbody", className) },
	      children
	    )
	  );
	};
	
	TBody.propsType = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	exports.default = TBody;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THead = function THead(props) {
	  var children = props.children,
	      className = props.className;
	
	
	  return (
	    // <div
	    //   className={cn(
	    //     "responsive-table__tbody",
	    //     className
	    //   )}
	    // >
	    //   {children}
	    // </div>
	    _react2.default.createElement(
	      "thead",
	      { className: (0, _classnames2.default)(className, 'responsive-table__thead') },
	      children
	    )
	  );
	};
	
	THead.propsType = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	exports.default = THead;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dropdownArrow = __webpack_require__(685);
	
	var _dropdownArrow2 = _interopRequireDefault(_dropdownArrow);
	
	var _isArray = __webpack_require__(40);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _dashboard = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardSelect = function (_PureComponent) {
	  _inherits(DashboardSelect, _PureComponent);
	
	  function DashboardSelect(props) {
	    _classCallCheck(this, DashboardSelect);
	
	    var _this = _possibleConstructorReturn(this, (DashboardSelect.__proto__ || Object.getPrototypeOf(DashboardSelect)).call(this, props));
	
	    _this.toggling = function () {
	      var isOpen = _this.state.isOpen;
	
	
	      _this.setState({
	        isOpen: !isOpen
	      });
	    };
	
	    _this.onOptionClicked = function (value, callback) {
	      return function () {
	        _this.setState({
	          selectedOption: value,
	          isOpen: false
	        }, function () {
	          if (callback) {
	            callback(value);
	          }
	        });
	      };
	    };
	
	    _this.handleClickOutside = function (e) {
	      var isOpen = _this.state.isOpen;
	
	
	      if (isOpen && _this.wrapperRef && !_this.wrapperRef.contains(e.target)) {
	        _this.setState({
	          isOpen: false
	        });
	      }
	    };
	
	    _this.state = {
	      isOpen: false,
	      selectedOption: null
	    };
	
	    _this.wrapperRef = null;
	    return _this;
	  }
	
	  _createClass(DashboardSelect, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      document.addEventListener("mousedown", this.handleClickOutside);
	
	      if (this.props.setValueCallback) {
	        var dummyCallback = function dummyCallback() {};
	        var onChange = this.props.onChange || dummyCallback;
	
	        this.props.setValueCallback(function (value) {
	          _this2.onOptionClicked(value, onChange)();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener("mousedown", this.handleClickOutside);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isOpen = _state.isOpen,
	          selectedOption = _state.selectedOption;
	      var _props = this.props,
	          options = _props.options,
	          placeholder = _props.placeholder,
	          customId = _props.customId,
	          customName = _props.customName;
	
	      var DropDownContainerComponent = this.props.DropDownContainer || _dashboard.DropDownContainer;
	      var DropDownHeaderComponent = this.props.DropDownHeader || _dashboard.DropDownHeader;
	      var DropDownListContainerComponent = this.props.DropDownListContainer || _dashboard.DropDownListContainer;
	      var DropDownListComponent = this.props.DropDownList || _dashboard.DropDownList;
	      var DropDownHeaderArrowComponent = this.props.DropDownHeaderArrow || _dashboard.DropDownHeaderArrow;
	      var ArrowIconComponent = this.props.ArrowIcon || _dropdownArrow2.default;
	      var dummyCallback = function dummyCallback() {};
	      var onChange = this.props.onChange || dummyCallback;
	      var customRender = customId && customName ? true : false;
	
	      return _react2.default.createElement(
	        DropDownContainerComponent,
	        {
	          innerRef: function innerRef(wrapperRef) {
	            _this3.wrapperRef = wrapperRef;
	          }
	        },
	        _react2.default.createElement(
	          DropDownHeaderComponent,
	          {
	            onClick: this.toggling,
	            title: selectedOption || placeholder
	          },
	          this.title,
	          _react2.default.createElement(
	            DropDownHeaderArrowComponent,
	            null,
	            _react2.default.createElement("img", { src: ArrowIconComponent, alt: "" })
	          )
	        ),
	        isOpen && _react2.default.createElement(
	          DropDownListContainerComponent,
	          null,
	          _react2.default.createElement(
	            DropDownListComponent,
	            null,
	            (0, _isArray2.default)(options) && !customRender && options.map(function (option, i) {
	              return _react2.default.createElement(
	                _dashboard.DropDownListItem,
	                {
	                  key: i,
	                  onClick: _this3.onOptionClicked(option, onChange),
	                  isSelected: selectedOption === option ? true : false
	                },
	                option
	              );
	            }),
	            (0, _isArray2.default)(options) && customRender && options.map(function (option, i) {
	              return _react2.default.createElement(
	                _dashboard.DropDownListItem,
	                {
	                  key: i,
	                  onClick: _this3.onOptionClicked(option[customId], onChange),
	                  isSelected: selectedOption === option[customId] ? true : false
	                },
	                option[customName]
	              );
	            }),
	            !(0, _isArray2.default)(options) && Object.keys(options).map(function (id) {
	              return _react2.default.createElement(
	                _dashboard.DropDownListItem,
	                {
	                  key: id,
	                  onClick: _this3.onOptionClicked(id, onChange),
	                  isSelected: selectedOption === id ? true : false
	                },
	                options[id]
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      var selectedOption = this.state.selectedOption;
	      var _props2 = this.props,
	          placeholder = _props2.placeholder,
	          options = _props2.options,
	          customId = _props2.customId,
	          customName = _props2.customName;
	
	
	      if (selectedOption) {
	        if (customId && customName) {
	          var selected = options.find(function (i) {
	            return i[customId] === selectedOption;
	          });
	
	          return selected ? selected[customName] : placeholder;
	        }
	
	        return (0, _isArray2.default)(options) ? selectedOption : options[selectedOption];
	      }
	
	      return placeholder;
	    }
	  }]);
	
	  return DashboardSelect;
	}(_react.PureComponent);
	
	exports.default = DashboardSelect;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImageContainer = exports.NAItem = exports.TableCell = exports.HeaderColumn = exports.Button = exports.ButtonRow = exports.Input = exports.InputWrapper = exports.FormulaValue = exports.FormulaName = exports.FormulaContainer = exports.DataTitle = exports.DataColumn = exports.FourColumnsRow = exports.ColumnsRow = exports.DataContainerTitle = exports.DataContainer = exports.Text = exports.Title = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    color: rgba(0, 27, 59, 0.9);\n    text-decoration: underline;\n  }\n'], ['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    color: #EC5E59;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  ul li {\n    font-size: 16px !important;\n  }\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    color: rgba(0, 27, 59, 0.9);\n    text-decoration: underline;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n  padding: 20px;\n  background: #FFFFFF;\n  border-radius: 4px;\n  font-family: \'Mukta Vaani\';\n'], ['\n  margin-top: 20px;\n  padding: 20px;\n  background: #FFFFFF;\n  border-radius: 4px;\n  font-family: \'Mukta Vaani\';\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  font-weight: 700;\n  margin-bottom: 20px;\n'], ['\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  font-weight: 700;\n  margin-bottom: 20px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  column-gap: 10px;\n'], ['\n  display: flex;\n  column-gap: 10px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  column-gap: 40px;\n'], ['\n  display: flex;\n  column-gap: 40px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  flex: 1;\n'], ['\n  flex: 1;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n'], ['\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  background: #FBEDD5;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 50px 30px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  max-width: 700px;\n\n  ', '\n\n  > * {\n    flex: 1;\n  }\n'], ['\n  background: #FBEDD5;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 50px 30px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  max-width: 700px;\n\n  ', '\n\n  > * {\n    flex: 1;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  padding: 16px 20px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  background-color: #FEC665;\n  white-space: nowrap;\n'], ['\n  padding: 16px 20px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  background-color: #FEC665;\n  white-space: nowrap;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 1.333333;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  white-space: nowrap;\n\n  ', '\n\n  ', '\n\n  span {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 1.333333;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  white-space: nowrap;\n\n  ', '\n\n  ', '\n\n  span {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  position: relative;\n  margin-top: 4px;\n\n  &:after {\n    display: block;\n    content: \'%\';\n    color: rgba(0, 27, 59, 0.38);\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    position: absolute;\n    right: 11.5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n'], ['\n  position: relative;\n  margin-top: 4px;\n\n  &:after {\n    display: block;\n    content: \'%\';\n    color: rgba(0, 27, 59, 0.38);\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    position: absolute;\n    right: 11.5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  border: 1px solid #5C91F5;\n  border-radius: 2px;\n  padding: 4.2px 25px 4.2px 12px;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  line-height: 22px;\n\n  ', '\n  \n  ', '\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type=number] {\n    -moz-appearance: textfield;\n  }\n\n  &:active, &:focus {\n    outline: none;\n  }\n\n  &:disabled {\n    color: rgba(0, 27, 59, 0.38);\n    border-color: #BDC0CC;\n  }\n'], ['\n  border: 1px solid #5C91F5;\n  border-radius: 2px;\n  padding: 4.2px 25px 4.2px 12px;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  line-height: 22px;\n\n  ', '\n  \n  ', '\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type=number] {\n    -moz-appearance: textfield;\n  }\n\n  &:active, &:focus {\n    outline: none;\n  }\n\n  &:disabled {\n    color: rgba(0, 27, 59, 0.38);\n    border-color: #BDC0CC;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  background: #5C91F5;\n  border-radius: 4px;\n  padding: 6.5px 9.5px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #FFFFFF;\n\n  &:disabled {\n    background: #F5F6F7;\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n\n  @media (max-width: 1420px) {\n    font-size: 14px;\n    padding: 6px 7px;\n  }\n'], ['\n  background: #5C91F5;\n  border-radius: 4px;\n  padding: 6.5px 9.5px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #FFFFFF;\n\n  &:disabled {\n    background: #F5F6F7;\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n\n  @media (max-width: 1420px) {\n    font-size: 14px;\n    padding: 6px 7px;\n  }\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500 !important;\n  padding: 27px 14px;\n  position: relative;\n  border-bottom: 1px solid #F0F0F0;\n\n  &:first-child {\n    padding: 27px 11px;\n  }\n\n  @media (max-width: 1260px) {\n    padding: 20px 10px;\n  }\n\n  &:before {\n    display: block;\n    content: \'\';\n    height: 40px;\n    width: 1px;\n    background: #F0F0F0;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n'], ['\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500 !important;\n  padding: 27px 14px;\n  position: relative;\n  border-bottom: 1px solid #F0F0F0;\n\n  &:first-child {\n    padding: 27px 11px;\n  }\n\n  @media (max-width: 1260px) {\n    padding: 20px 10px;\n  }\n\n  &:before {\n    display: block;\n    content: \'\';\n    height: 40px;\n    width: 1px;\n    background: #F0F0F0;\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  padding: 0 8px;\n\n  ', '\n\n  @media (max-width: 1420px) {\n    padding: 0 4px;\n    font-size: 12px;\n  }\n\n  input {\n    padding: 5px 12px;\n    border: 1px solid #5C91F5;\n    border-radius: 2px;\n    font-family: \'Roboto\';\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: rgba(0, 0, 0, 0.85);\n    width: 91px;\n    text-align: center;\n    background: #ffffff;\n    transition: background 150ms ease, border-color 150ms ease,\n                font-weight 150ms ease, color 150ms ease, box-shadow 150ms ease;\n\n    &:active, &:focus {\n      outline: none;\n    }\n\n    &:disabled {\n      color: rgba(0,27,59,0.38);\n      border-color: #BDC0CC;\n    }\n\n    @media (max-width: 1700px) {\n      width: 80px;\n      padding: 5px 8px;\n    }\n\n    @media (max-width: 1420px) {\n      width: 60px;\n      padding: 5px;\n      font-size: 12px;\n      line-height: 20px;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  }\n\n  /* "Active" cells are the targets the instructor has set a value\n     for on this round. We amplify them so it\'s obvious at a glance\n     which metrics this round is grading on. */\n  ', '\n'], ['\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  padding: 0 8px;\n\n  ', '\n\n  @media (max-width: 1420px) {\n    padding: 0 4px;\n    font-size: 12px;\n  }\n\n  input {\n    padding: 5px 12px;\n    border: 1px solid #5C91F5;\n    border-radius: 2px;\n    font-family: \'Roboto\';\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: rgba(0, 0, 0, 0.85);\n    width: 91px;\n    text-align: center;\n    background: #ffffff;\n    transition: background 150ms ease, border-color 150ms ease,\n                font-weight 150ms ease, color 150ms ease, box-shadow 150ms ease;\n\n    &:active, &:focus {\n      outline: none;\n    }\n\n    &:disabled {\n      color: rgba(0,27,59,0.38);\n      border-color: #BDC0CC;\n    }\n\n    @media (max-width: 1700px) {\n      width: 80px;\n      padding: 5px 8px;\n    }\n\n    @media (max-width: 1420px) {\n      width: 60px;\n      padding: 5px;\n      font-size: 12px;\n      line-height: 20px;\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  }\n\n  /* "Active" cells are the targets the instructor has set a value\n     for on this round. We amplify them so it\'s obvious at a glance\n     which metrics this round is grading on. */\n  ', '\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  padding: 17px 16px;\n  background: rgba(0, 27, 43, 0.02);\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.38);\n  border-bottom: 1px solid #F0F0F0;\n  margin: 0 auto;\n  min-width: 55px;\n  max-width: 92px;\n\n  @media (max-width: 1420px) {\n    padding: 12px;\n    min-width: auto;\n  }\n'], ['\n  padding: 17px 16px;\n  background: rgba(0, 27, 43, 0.02);\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.38);\n  border-bottom: 1px solid #F0F0F0;\n  margin: 0 auto;\n  min-width: 55px;\n  max-width: 92px;\n\n  @media (max-width: 1420px) {\n    padding: 12px;\n    min-width: auto;\n  }\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  margin-top: 34px;\n'], ['\n  margin-top: 34px;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = exports.Title = _styledComponents2.default.div(_templateObject2);
	
	var Text = exports.Text = _styledComponents2.default.div(_templateObject3);
	
	var DataContainer = exports.DataContainer = _styledComponents2.default.div(_templateObject4);
	
	var DataContainerTitle = exports.DataContainerTitle = _styledComponents2.default.h3(_templateObject5);
	
	var ColumnsRow = exports.ColumnsRow = _styledComponents2.default.div(_templateObject6);
	
	var FourColumnsRow = exports.FourColumnsRow = _styledComponents2.default.div(_templateObject7);
	
	var DataColumn = exports.DataColumn = _styledComponents2.default.div(_templateObject8);
	
	var DataTitle = exports.DataTitle = _styledComponents2.default.h4(_templateObject9);
	
	var FormulaContainer = exports.FormulaContainer = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.maxWidth && '\n    max-width: ' + p.maxWidth + 'px;\n  ';
	});
	
	var FormulaName = exports.FormulaName = _styledComponents2.default.div(_templateObject11);
	
	var FormulaValue = exports.FormulaValue = _styledComponents2.default.div(_templateObject12, function (p) {
	  return p.fontSize && '\n    font-size: ' + p.fontSize + ';\n  ';
	}, function (p) {
	  return p.lineHeight && '\n    line-height: ' + p.lineHeight + 'px;\n  ';
	});
	
	var InputWrapper = exports.InputWrapper = _styledComponents2.default.div(_templateObject13);
	
	var Input = exports.Input = _styledComponents2.default.input(_templateObject14, function (p) {
	  return p.equalPadding && '\n    padding: 4.2px 12px;\n  ';
	}, function (p) {
	  return p.minWidth && '\n    min-width: ' + p.minWidth + 'px;\n  ';
	});
	
	var ButtonRow = exports.ButtonRow = _styledComponents2.default.div(_templateObject15);
	
	var Button = exports.Button = _styledComponents2.default.button(_templateObject16, function (p) {
	  return p.isActiveDefault && '\n    background: #FF5252;\n  ';
	});
	
	var HeaderColumn = exports.HeaderColumn = _styledComponents2.default.th(_templateObject17);
	
	var TableCell = exports.TableCell = _styledComponents2.default.td(_templateObject18, function (p) {
	  return p.verticalPadding && '\n    padding: 8px;\n  ';
	}, function (p) {
	  return p.active && '\n    input {\n      border: 2px solid #2563EB;\n      padding: 4px 11px;\n      background: #EFF6FF;\n      color: #0F172A;\n      box-shadow: 0 2px 6px rgba(37, 99, 235, 0.12);\n    }\n  ';
	});
	
	var NAItem = exports.NAItem = _styledComponents2.default.div(_templateObject19);
	
	var ImageContainer = exports.ImageContainer = _styledComponents2.default.div(_templateObject20);

/***/ },
/* 409 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var answersRowsPerPage = exports.answersRowsPerPage = [{ id: 0, name: 15 }, { id: 1, name: 25 }, { id: 2, name: 50 }];

/***/ },
/* 410 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var teamPlayerRoles = exports.teamPlayerRoles = {
	  CEO: 'CEO',
	  PD: 'Product',
	  PM: 'Marketing',
	  OP: 'Operations',
	  FI: 'Finance'
	};
	
	var teamPlayerRowsPerPage = exports.teamPlayerRowsPerPage = {
	  25: 25,
	  50: 50,
	  75: 75,
	  100: 100
	};

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1555);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1554);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 412 */
116,
/* 413 */
[2691, 1571],
/* 414 */
129,
/* 415 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 416 */
[2707, 219, 1586, 415, 419, 617, 1577],
/* 417 */
321,
/* 418 */
[2718, 185, 184, 127],
/* 419 */
[2719, 420, 313],
/* 420 */
[2720, 115, 160, 311],
/* 421 */
120,
/* 422 */
[2726, 221],
/* 423 */
[2727, 160, 115, 311, 424, 185],
/* 424 */
[2728, 127],
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(325)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(64);
	var toAbsoluteIndex = __webpack_require__(195);
	var toLength = __webpack_require__(48);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1605);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 428 */
[2690, 57, 192],
/* 429 */
[2693, 33, 30],
/* 430 */
415,
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(44)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 432 */
[2696, 30],
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33);
	var setPrototypeOf = __webpack_require__(442).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 434 */
[2699, 223, 44],
/* 435 */
[2702, 189, 192, 224, 96, 44],
/* 436 */
[2703, 162, 8, 97, 96, 223, 435, 224, 106, 44],
/* 437 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 438 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var macrotask = __webpack_require__(447).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(116)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(86);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(269);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 442 */
[2717, 33, 26, 118, 105],
/* 443 */
[2719, 272, 196],
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(318);
	var defined = __webpack_require__(129);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(120);
	var defined = __webpack_require__(129);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(118);
	var invoke = __webpack_require__(638);
	var html = __webpack_require__(432);
	var cel = __webpack_require__(429);
	var global = __webpack_require__(30);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(116)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(30);
	var DESCRIPTORS = __webpack_require__(51);
	var LIBRARY = __webpack_require__(162);
	var $typed = __webpack_require__(326);
	var hide = __webpack_require__(96);
	var redefineAll = __webpack_require__(193);
	var fails = __webpack_require__(31);
	var anInstance = __webpack_require__(187);
	var toInteger = __webpack_require__(120);
	var toLength = __webpack_require__(48);
	var toIndex = __webpack_require__(657);
	var gOPN = __webpack_require__(190).f;
	var dP = __webpack_require__(57).f;
	var arrayFill = __webpack_require__(426);
	var setToStringTag = __webpack_require__(224);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 449 */
[2727, 30, 117, 162, 658, 57],
/* 450 */
[2730, 222, 44, 223, 117],
/* 451 */
[2732, 161, 641, 223, 107, 436],
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(164));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/emoji-agree.ee98a5c0.svg";

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/emoji-disagree.76c03c2f.svg";

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/emoji-neutral.cd025c9c.svg";

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/emoji-strongly-agree.20128627.svg";

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/emoji-strongly-disagree.a60b5739.svg";

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(props) {
	    var classNames = ['glyphicon', 'glyphicon-' + props.symbol];
	    if (props.className) {
	        classNames.push(props.className);
	    }
	    return _react2.default.createElement('span', { className: classNames.join(' '), 'aria-hidden': 'true' });
	};
	
	Icon.propTypes = {
	    symbol: _react.PropTypes.string.isRequired,
	    className: _react.PropTypes.string
	};
	
	module.exports = Icon;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var PropTypes = __webpack_require__(2);
	var utils = __webpack_require__(696);
	var React = global.React || __webpack_require__(1);
	
	var convertValidationsToObject = function convertValidationsToObject(validations) {
	
	  if (typeof validations === 'string') {
	
	    return validations.split(/\,(?![^{\[]*[}\]])/g).reduce(function (validations, validation) {
	      var args = validation.split(':');
	      var validateMethod = args.shift();
	
	      args = args.map(function (arg) {
	        try {
	          return JSON.parse(arg);
	        } catch (e) {
	          return arg; // It is a string if it can not parse it
	        }
	      });
	
	      if (args.length > 1) {
	        throw new Error('Formsy does not support multiple args on string validations. Use object format of validations instead.');
	      }
	
	      validations[validateMethod] = args.length ? args[0] : true;
	      return validations;
	    }, {});
	  }
	
	  return validations || {};
	};
	
	module.exports = {
	  getInitialState: function getInitialState() {
	    return {
	      _value: this.props.value,
	      _isRequired: false,
	      _isValid: true,
	      _isPristine: true,
	      _pristineValue: this.props.value,
	      _validationError: [],
	      _externalError: null,
	      _formSubmitted: false
	    };
	  },
	  contextTypes: {
	    formsy: PropTypes.object // What about required?
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      validationError: '',
	      validationErrors: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var configure = function () {
	      this.setValidations(this.props.validations, this.props.required);
	
	      // Pass a function instead?
	      this.context.formsy.attachToForm(this);
	      //this.props._attachToForm(this);
	    }.bind(this);
	
	    if (!this.props.name) {
	      throw new Error('Form Input requires a name property when used');
	    }
	
	    /*
	    if (!this.props._attachToForm) {
	      return setTimeout(function () {
	        if (!this.isMounted()) return;
	        if (!this.props._attachToForm) {
	          throw new Error('Form Mixin requires component to be nested in a Form');
	        }
	        configure();
	      }.bind(this), 0);
	    }
	    */
	    configure();
	  },
	
	  // We have to make the validate method is kept when new props are added
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setValidations(nextProps.validations, nextProps.required);
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	
	    // If the value passed has changed, set it. If value is not passed it will
	    // internally update, and this will never run
	    if (!utils.isSame(this.props.value, prevProps.value)) {
	      this.setValue(this.props.value);
	    }
	
	    // If validations or required is changed, run a new validation
	    if (!utils.isSame(this.props.validations, prevProps.validations) || !utils.isSame(this.props.required, prevProps.required)) {
	      this.context.formsy.validate(this);
	    }
	  },
	
	  // Detach it when component unmounts
	  componentWillUnmount: function componentWillUnmount() {
	    this.context.formsy.detachFromForm(this);
	    //this.props._detachFromForm(this);
	  },
	
	  setValidations: function setValidations(validations, required) {
	
	    // Add validations to the store itself as the props object can not be modified
	    this._validations = convertValidationsToObject(validations) || {};
	    this._requiredValidations = required === true ? { isDefaultRequiredValue: true } : convertValidationsToObject(required);
	  },
	
	  // We validate after the value has been set
	  setValue: function setValue(value) {
	    this.setState({
	      _value: value,
	      _isPristine: false
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    }.bind(this));
	  },
	  resetValue: function resetValue() {
	    this.setState({
	      _value: this.state._pristineValue,
	      _isPristine: true
	    }, function () {
	      this.context.formsy.validate(this);
	      //this.props._validate(this);
	    });
	  },
	  getValue: function getValue() {
	    return this.state._value;
	  },
	  hasValue: function hasValue() {
	    return this.state._value !== '';
	  },
	  getErrorMessage: function getErrorMessage() {
	    var messages = this.getErrorMessages();
	    return messages.length ? messages[0] : null;
	  },
	  getErrorMessages: function getErrorMessages() {
	    return !this.isValid() || this.showRequired() ? this.state._externalError || this.state._validationError || [] : [];
	  },
	  isFormDisabled: function isFormDisabled() {
	    return this.context.formsy.isFormDisabled();
	    //return this.props._isFormDisabled();
	  },
	  isValid: function isValid() {
	    return this.state._isValid;
	  },
	  isPristine: function isPristine() {
	    return this.state._isPristine;
	  },
	  isFormSubmitted: function isFormSubmitted() {
	    return this.state._formSubmitted;
	  },
	  isRequired: function isRequired() {
	    return !!this.props.required;
	  },
	  showRequired: function showRequired() {
	    return this.state._isRequired;
	  },
	  showError: function showError() {
	    return !this.showRequired() && !this.isValid();
	  },
	  isValidValue: function isValidValue(value) {
	    return this.context.formsy.isValidValue.call(null, this, value);
	    //return this.props._isValidValue.call(null, this, value);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(229);
	
	var _DOMUtils = __webpack_require__(335);
	
	var _DOMStateStorage = __webpack_require__(697);
	
	var _PathUtils = __webpack_require__(167);
	
	var _ExecutionEnvironment = __webpack_require__(461);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 461 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1877);
	
	var _PathUtils = __webpack_require__(167);
	
	var _runTransitionHook = __webpack_require__(463);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(334);
	
	var _LocationUtils = __webpack_require__(229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 464 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 465 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198),
	    root = __webpack_require__(108);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(2010),
	    mapCacheDelete = __webpack_require__(2011),
	    mapCacheGet = __webpack_require__(2012),
	    mapCacheHas = __webpack_require__(2013),
	    mapCacheSet = __webpack_require__(2014);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(467),
	    setCacheAdd = __webpack_require__(2021),
	    setCacheHas = __webpack_require__(2022);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(336),
	    stackClear = __webpack_require__(2024),
	    stackDelete = __webpack_require__(2025),
	    stackGet = __webpack_require__(2026),
	    stackHas = __webpack_require__(2027),
	    stackSet = __webpack_require__(2028);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(470),
	    isFlattenable = __webpack_require__(2002);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1944),
	    isObjectLike = __webpack_require__(123);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 473 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(704);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(728);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(705),
	    stubArray = __webpack_require__(740);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 477 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(233);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 479 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(722);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 481 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1943),
	    isObjectLike = __webpack_require__(123);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(108),
	    stubFalse = __webpack_require__(2054);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 484 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    getPrototype = __webpack_require__(475),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(708),
	    baseKeysIn = __webpack_require__(1952),
	    isArrayLike = __webpack_require__(199);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1983);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1965),
	    isObject = __webpack_require__(101),
	    isSymbol = __webpack_require__(233);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cssRuleSetToString;
	
	var _appendPxIfNeeded = __webpack_require__(883);
	
	var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
	var _camelCasePropsToDashCase = __webpack_require__(884);
	
	var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);
	
	var _mapObject = __webpack_require__(890);
	
	var _mapObject2 = _interopRequireDefault(_mapObject);
	
	var _prefixer = __webpack_require__(490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMarkupForStyles(style) {
	  return Object.keys(style).map(function (property) {
	    return property + ': ' + style[property] + ';';
	  }).join('\n');
	}
	
	function cssRuleSetToString(selector, rules, userAgent) {
	  if (!rules) {
	    return '';
	  }
	
	  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
	    return (0, _appendPxIfNeeded2.default)(key, value);
	  });
	  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
	  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
	  var serializedRules = createMarkupForStyles(cssPrefixedRules);
	  return selector + '{' + serializedRules + '}';
	}

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Based on https://github.com/jsstyles/css-vendor, but without having to
	                                                                                                                                                                                                                                                                               * convert between different cases all the time.
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * 
	                                                                                                                                                                                                                                                                               */
	
	exports.getPrefixedKeyframes = getPrefixedKeyframes;
	exports.getPrefixedStyle = getPrefixedStyle;
	
	var _createPrefixer = __webpack_require__(1898);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(1885);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _exenv = __webpack_require__(677);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _static = __webpack_require__(2098);
	
	var _static2 = _interopRequireDefault(_static);
	
	var _dynamic = __webpack_require__(2097);
	
	var _dynamic2 = _interopRequireDefault(_dynamic);
	
	var _camelCasePropsToDashCase = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixAll = (0, _createPrefixer2.default)(_static2.default);
	var InlineStylePrefixer = (0, _createPrefixer4.default)(_dynamic2.default, prefixAll);
	
	function transformValues(style) {
	  return Object.keys(style).reduce(function (newStyle, key) {
	    var value = style[key];
	    if (Array.isArray(value)) {
	      value = value.join(';' + key + ':');
	    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
	      value = value.toString();
	    }
	
	    newStyle[key] = value;
	    return newStyle;
	  }, {});
	}
	
	// Flatten prefixed values that are arrays to strings.
	//
	// We get prefixed styles back in the form of:
	// - `display: "flex"` OR
	// - `display: "-webkit-flex"` OR
	// - `display: [/* ... */, "-webkit-flex", "flex"]
	//
	// The last form is problematic for eventual use in the browser and server
	// render. More confusingly, we have to do **different** things on the
	// browser and server (noted inline below).
	//
	// https://github.com/FormidableLabs/radium/issues/958
	function flattenStyleValues(style) {
	  return Object.keys(style).reduce(function (newStyle, key) {
	    var val = style[key];
	    if (Array.isArray(val)) {
	      if (_exenv2.default.canUseDOM) {
	        // For the **browser**, when faced with multiple values, we just take
	        // the **last** one, which is the original passed in value before
	        // prefixing. This _should_ work, because `inline-style-prefixer`
	        // we're just passing through what would happen without ISP.
	
	        val = val[val.length - 1].toString();
	      } else {
	        // For the **server**, we just concatenate things together and convert
	        // the style object values into a hacked-up string of like `display:
	        // "-webkit-flex;display:flex"` that will SSR render correctly to like
	        // `"display:-webkit-flex;display:flex"` but would otherwise be
	        // totally invalid values.
	
	        // We convert keys to dash-case only for the serialize values and
	        // leave the real key camel-cased so it's as expected to React and
	        // other parts of the processing chain.
	        val = val.join(';' + (0, _camelCasePropsToDashCase.camelCaseToDashCase)(key) + ':');
	      }
	    }
	
	    newStyle[key] = val;
	    return newStyle;
	  }, {});
	}
	
	var _hasWarnedAboutUserAgent = false;
	var _lastUserAgent = void 0;
	var _cachedPrefixer = void 0;
	
	function getPrefixer(userAgent) {
	  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;
	
	  if (false) {
	    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
	      /* eslint-disable no-console */
	      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
	      /* eslint-enable no-console */
	      _hasWarnedAboutUserAgent = true;
	    }
	  }
	
	  if (("production") === 'test' || !_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
	    if (actualUserAgent === 'all') {
	      _cachedPrefixer = {
	        prefix: prefixAll,
	        prefixedKeyframes: 'keyframes'
	      };
	    } else {
	      _cachedPrefixer = new InlineStylePrefixer({ userAgent: actualUserAgent });
	    }
	    _lastUserAgent = actualUserAgent;
	  }
	
	  return _cachedPrefixer;
	}
	
	function getPrefixedKeyframes(userAgent) {
	  return getPrefixer(userAgent).prefixedKeyframes || 'keyframes';
	}
	
	// Returns a new style object with vendor prefixes added to property names and
	// values.
	function getPrefixedStyle(style, userAgent) {
	  var styleWithFallbacks = transformValues(style);
	  var prefixer = getPrefixer(userAgent);
	  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
	  var flattenedStyle = flattenStyleValues(prefixedStyle);
	  return flattenedStyle;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 491 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleKeeper = function () {
	  function StyleKeeper(userAgent) {
	    _classCallCheck(this, StyleKeeper);
	
	    this._userAgent = userAgent;
	    this._listeners = [];
	    this._cssSet = {};
	  }
	
	  _createClass(StyleKeeper, [{
	    key: 'subscribe',
	    value: function subscribe(listener) {
	      var _this = this;
	
	      if (this._listeners.indexOf(listener) === -1) {
	        this._listeners.push(listener);
	      }
	
	      return {
	        // Must be fat arrow to capture `this`
	        remove: function remove() {
	          var listenerIndex = _this._listeners.indexOf(listener);
	          if (listenerIndex > -1) {
	            _this._listeners.splice(listenerIndex, 1);
	          }
	        }
	      };
	    }
	  }, {
	    key: 'addCSS',
	    value: function addCSS(css) {
	      var _this2 = this;
	
	      if (!this._cssSet[css]) {
	        this._cssSet[css] = true;
	        this._emitChange();
	      }
	
	      return {
	        // Must be fat arrow to capture `this`
	        remove: function remove() {
	          delete _this2._cssSet[css];
	          _this2._emitChange();
	        }
	      };
	    }
	  }, {
	    key: 'getCSS',
	    value: function getCSS() {
	      return Object.keys(this._cssSet).join('\n');
	    }
	  }, {
	    key: '_emitChange',
	    value: function _emitChange() {
	      this._listeners.forEach(function (listener) {
	        return listener();
	      });
	    }
	  }]);
	
	  return StyleKeeper;
	}();
	
	exports.default = StyleKeeper;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2068)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(894);
	
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined'
	      ? global
	      : typeof self !== 'undefined'
	        ? self
	        : {};
	
	function isObject(what) {
	  return typeof what === 'object' && what !== null;
	}
	
	// Yanked from https://git.io/vS8DV re-used under CC0
	// with some tiny modifications
	function isError(value) {
	  switch (Object.prototype.toString.call(value)) {
	    case '[object Error]':
	      return true;
	    case '[object Exception]':
	      return true;
	    case '[object DOMException]':
	      return true;
	    default:
	      return value instanceof Error;
	  }
	}
	
	function isErrorEvent(value) {
	  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
	}
	
	function isDOMError(value) {
	  return Object.prototype.toString.call(value) === '[object DOMError]';
	}
	
	function isDOMException(value) {
	  return Object.prototype.toString.call(value) === '[object DOMException]';
	}
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function isPlainObject(what) {
	  return Object.prototype.toString.call(what) === '[object Object]';
	}
	
	function isString(what) {
	  return Object.prototype.toString.call(what) === '[object String]';
	}
	
	function isArray(what) {
	  return Object.prototype.toString.call(what) === '[object Array]';
	}
	
	function isEmptyObject(what) {
	  if (!isPlainObject(what)) return false;
	
	  for (var _ in what) {
	    if (what.hasOwnProperty(_)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function supportsErrorEvent() {
	  try {
	    new ErrorEvent(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsDOMError() {
	  try {
	    new DOMError(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsDOMException() {
	  try {
	    new DOMException(''); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsFetch() {
	  if (!('fetch' in _window)) return false;
	
	  try {
	    new Headers(); // eslint-disable-line no-new
	    new Request(''); // eslint-disable-line no-new
	    new Response(); // eslint-disable-line no-new
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	// https://caniuse.com/#feat=referrer-policy
	// It doesn't. And it throw exception instead of ignoring this parameter...
	// REF: https://github.com/getsentry/raven-js/issues/1233
	function supportsReferrerPolicy() {
	  if (!supportsFetch()) return false;
	
	  try {
	    // eslint-disable-next-line no-new
	    new Request('pickleRick', {
	      referrerPolicy: 'origin'
	    });
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function supportsPromiseRejectionEvent() {
	  return typeof PromiseRejectionEvent === 'function';
	}
	
	function wrappedCallback(callback) {
	  function dataCallback(data, original) {
	    var normalizedData = callback(data) || data;
	    if (original) {
	      return original(normalizedData) || normalizedData;
	    }
	    return normalizedData;
	  }
	
	  return dataCallback;
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	function objectMerge(obj1, obj2) {
	  if (!obj2) {
	    return obj1;
	  }
	  each(obj2, function(key, value) {
	    obj1[key] = value;
	  });
	  return obj1;
	}
	
	/**
	 * This function is only used for react-native.
	 * react-native freezes object that have already been sent over the
	 * js bridge. We need this function in order to check if the object is frozen.
	 * So it's ok that objectFrozen returns false if Object.isFrozen is not
	 * supported because it's not relevant for other "platforms". See related issue:
	 * https://github.com/getsentry/react-native-sentry/issues/57
	 */
	function objectFrozen(obj) {
	  if (!Object.isFrozen) {
	    return false;
	  }
	  return Object.isFrozen(obj);
	}
	
	function truncate(str, max) {
	  if (typeof max !== 'number') {
	    throw new Error('2nd argument to `truncate` function should be a number');
	  }
	  if (typeof str !== 'string' || max === 0) {
	    return str;
	  }
	  return str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	  // Combine an array of regular expressions and strings into one large regexp
	  // Be mad.
	  var sources = [],
	    i = 0,
	    len = patterns.length,
	    pattern;
	
	  for (; i < len; i++) {
	    pattern = patterns[i];
	    if (isString(pattern)) {
	      // If it's a string, we need to escape it
	      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	    } else if (pattern && pattern.source) {
	      // If it's a regexp already, we want to extract the source
	      sources.push(pattern.source);
	    }
	    // Intentionally skip other cases
	  }
	  return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	  var pairs = [];
	  each(o, function(key, value) {
	    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	  });
	  return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	  if (typeof url !== 'string') return {};
	  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	
	  // coerce to undefined values to empty string so we don't get 'undefined'
	  var query = match[6] || '';
	  var fragment = match[8] || '';
	  return {
	    protocol: match[2],
	    host: match[4],
	    path: match[5],
	    relative: match[5] + query + fragment // everything minus origin
	  };
	}
	function uuid4() {
	  var crypto = _window.crypto || _window.msCrypto;
	
	  if (!isUndefined(crypto) && crypto.getRandomValues) {
	    // Use window.crypto API if available
	    // eslint-disable-next-line no-undef
	    var arr = new Uint16Array(8);
	    crypto.getRandomValues(arr);
	
	    // set 4 in byte 7
	    arr[3] = (arr[3] & 0xfff) | 0x4000;
	    // set 2 most significant bits of byte 9 to '10'
	    arr[4] = (arr[4] & 0x3fff) | 0x8000;
	
	    var pad = function(num) {
	      var v = num.toString(16);
	      while (v.length < 4) {
	        v = '0' + v;
	      }
	      return v;
	    };
	
	    return (
	      pad(arr[0]) +
	      pad(arr[1]) +
	      pad(arr[2]) +
	      pad(arr[3]) +
	      pad(arr[4]) +
	      pad(arr[5]) +
	      pad(arr[6]) +
	      pad(arr[7])
	    );
	  } else {
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	      var r = (Math.random() * 16) | 0,
	        v = c === 'x' ? r : (r & 0x3) | 0x8;
	      return v.toString(16);
	    });
	  }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	  /* eslint no-extra-parens:0*/
	  var MAX_TRAVERSE_HEIGHT = 5,
	    MAX_OUTPUT_LEN = 80,
	    out = [],
	    height = 0,
	    len = 0,
	    separator = ' > ',
	    sepLength = separator.length,
	    nextStr;
	
	  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	    nextStr = htmlElementAsString(elem);
	    // bail out if
	    // - nextStr is the 'html' element
	    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	    //   (ignore this limit if we are on the first iteration)
	    if (
	      nextStr === 'html' ||
	      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
	    ) {
	      break;
	    }
	
	    out.push(nextStr);
	
	    len += nextStr.length;
	    elem = elem.parentNode;
	  }
	
	  return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	  var out = [],
	    className,
	    classes,
	    key,
	    attr,
	    i;
	
	  if (!elem || !elem.tagName) {
	    return '';
	  }
	
	  out.push(elem.tagName.toLowerCase());
	  if (elem.id) {
	    out.push('#' + elem.id);
	  }
	
	  className = elem.className;
	  if (className && isString(className)) {
	    classes = className.split(/\s+/);
	    for (i = 0; i < classes.length; i++) {
	      out.push('.' + classes[i]);
	    }
	  }
	  var attrWhitelist = ['type', 'name', 'title', 'alt'];
	  for (i = 0; i < attrWhitelist.length; i++) {
	    key = attrWhitelist[i];
	    attr = elem.getAttribute(key);
	    if (attr) {
	      out.push('[' + key + '="' + attr + '"]');
	    }
	  }
	  return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	  return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if both parameters are undefined
	 */
	function isBothUndefined(a, b) {
	  return isUndefined(a) && isUndefined(b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	  if (isOnlyOneTruthy(ex1, ex2)) return false;
	
	  ex1 = ex1.values[0];
	  ex2 = ex2.values[0];
	
	  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;
	
	  // in case both stacktraces are undefined, we can't decide so default to false
	  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;
	
	  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	  if (isOnlyOneTruthy(stack1, stack2)) return false;
	
	  var frames1 = stack1.frames;
	  var frames2 = stack2.frames;
	
	  // Exit early if stacktrace is malformed
	  if (frames1 === undefined || frames2 === undefined) return false;
	
	  // Exit early if frame count differs
	  if (frames1.length !== frames2.length) return false;
	
	  // Iterate through every frame; bail out if anything differs
	  var a, b;
	  for (var i = 0; i < frames1.length; i++) {
	    a = frames1[i];
	    b = frames2[i];
	    if (
	      a.filename !== b.filename ||
	      a.lineno !== b.lineno ||
	      a.colno !== b.colno ||
	      a['function'] !== b['function']
	    )
	      return false;
	  }
	  return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  if (obj == null) return;
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  obj[name].__raven__ = true;
	  obj[name].__orig__ = orig;
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns {string}
	 */
	function safeJoin(input, delimiter) {
	  if (!isArray(input)) return '';
	
	  var output = [];
	
	  for (var i = 0; i < input.length; i++) {
	    try {
	      output.push(String(input[i]));
	    } catch (e) {
	      output.push('[value cannot be serialized]');
	    }
	  }
	
	  return output.join(delimiter);
	}
	
	// Default Node.js REPL depth
	var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
	// 50kB, as 100kB is max payload size, so half sounds reasonable
	var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
	var MAX_SERIALIZE_KEYS_LENGTH = 40;
	
	function utf8Length(value) {
	  return ~-encodeURI(value).split(/%..|./).length;
	}
	
	function jsonSize(value) {
	  return utf8Length(JSON.stringify(value));
	}
	
	function serializeValue(value) {
	  if (typeof value === 'string') {
	    var maxLength = 40;
	    return truncate(value, maxLength);
	  } else if (
	    typeof value === 'number' ||
	    typeof value === 'boolean' ||
	    typeof value === 'undefined'
	  ) {
	    return value;
	  }
	
	  var type = Object.prototype.toString.call(value);
	
	  // Node.js REPL notation
	  if (type === '[object Object]') return '[Object]';
	  if (type === '[object Array]') return '[Array]';
	  if (type === '[object Function]')
	    return value.name ? '[Function: ' + value.name + ']' : '[Function]';
	
	  return value;
	}
	
	function serializeObject(value, depth) {
	  if (depth === 0) return serializeValue(value);
	
	  if (isPlainObject(value)) {
	    return Object.keys(value).reduce(function(acc, key) {
	      acc[key] = serializeObject(value[key], depth - 1);
	      return acc;
	    }, {});
	  } else if (Array.isArray(value)) {
	    return value.map(function(val) {
	      return serializeObject(val, depth - 1);
	    });
	  }
	
	  return serializeValue(value);
	}
	
	function serializeException(ex, depth, maxSize) {
	  if (!isPlainObject(ex)) return ex;
	
	  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
	  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;
	
	  var serialized = serializeObject(ex, depth);
	
	  if (jsonSize(stringify(serialized)) > maxSize) {
	    return serializeException(ex, depth - 1);
	  }
	
	  return serialized;
	}
	
	function serializeKeysForMessage(keys, maxLength) {
	  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
	  if (!Array.isArray(keys)) return '';
	
	  keys = keys.filter(function(key) {
	    return typeof key === 'string';
	  });
	  if (keys.length === 0) return '[object has no keys]';
	
	  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
	  if (keys[0].length >= maxLength) return keys[0];
	
	  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
	    var serialized = keys.slice(0, usedKeys).join(', ');
	    if (serialized.length > maxLength) continue;
	    if (usedKeys === keys.length) return serialized;
	    return serialized + '\u2026';
	  }
	
	  return '';
	}
	
	function sanitize(input, sanitizeKeys) {
	  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
	    return input;
	
	  var sanitizeRegExp = joinRegExp(sanitizeKeys);
	  var sanitizeMask = '********';
	  var safeInput;
	
	  try {
	    safeInput = JSON.parse(stringify(input));
	  } catch (o_O) {
	    return input;
	  }
	
	  function sanitizeWorker(workerInput) {
	    if (isArray(workerInput)) {
	      return workerInput.map(function(val) {
	        return sanitizeWorker(val);
	      });
	    }
	
	    if (isPlainObject(workerInput)) {
	      return Object.keys(workerInput).reduce(function(acc, k) {
	        if (sanitizeRegExp.test(k)) {
	          acc[k] = sanitizeMask;
	        } else {
	          acc[k] = sanitizeWorker(workerInput[k]);
	        }
	        return acc;
	      }, {});
	    }
	
	    return workerInput;
	  }
	
	  return sanitizeWorker(safeInput);
	}
	
	module.exports = {
	  isObject: isObject,
	  isError: isError,
	  isErrorEvent: isErrorEvent,
	  isDOMError: isDOMError,
	  isDOMException: isDOMException,
	  isUndefined: isUndefined,
	  isFunction: isFunction,
	  isPlainObject: isPlainObject,
	  isString: isString,
	  isArray: isArray,
	  isEmptyObject: isEmptyObject,
	  supportsErrorEvent: supportsErrorEvent,
	  supportsDOMError: supportsDOMError,
	  supportsDOMException: supportsDOMException,
	  supportsFetch: supportsFetch,
	  supportsReferrerPolicy: supportsReferrerPolicy,
	  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
	  wrappedCallback: wrappedCallback,
	  each: each,
	  objectMerge: objectMerge,
	  truncate: truncate,
	  objectFrozen: objectFrozen,
	  hasKey: hasKey,
	  joinRegExp: joinRegExp,
	  urlencode: urlencode,
	  uuid4: uuid4,
	  htmlTreeAsString: htmlTreeAsString,
	  htmlElementAsString: htmlElementAsString,
	  isSameException: isSameException,
	  isSameStacktrace: isSameStacktrace,
	  parseUrl: parseUrl,
	  fill: fill,
	  safeJoin: safeJoin,
	  serializeException: serializeException,
	  serializeKeysForMessage: serializeKeysForMessage,
	  sanitize: sanitize
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 494 */
[2742, 90, 919],
/* 495 */
192,
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toPropertyKey = __webpack_require__(510);
	var definePropertyModule = __webpack_require__(238);
	var createPropertyDescriptor = __webpack_require__(495);
	
	module.exports = function (object, key, value) {
	  var propertyKey = toPropertyKey(key);
	  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
	  else object[propertyKey] = value;
	};


/***/ },
/* 497 */
[2750, 102],
/* 498 */
[2752, 102, 145],
/* 499 */
/***/ function(module, exports) {

	// IE8- don't enum bug keys
	module.exports = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var classofRaw = __webpack_require__(201);
	var uncurryThis = __webpack_require__(58);
	
	module.exports = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
	};


/***/ },
/* 501 */
[2760, 494, 285],
/* 502 */
223,
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(201);
	
	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	module.exports = Array.isArray || function isArray(argument) {
	  return classof(argument) == 'Array';
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(58);
	var fails = __webpack_require__(65);
	var isCallable = __webpack_require__(90);
	var classof = __webpack_require__(901);
	var getBuiltIn = __webpack_require__(358);
	var inspectSource = __webpack_require__(908);
	
	var noop = function () { /* empty */ };
	var empty = [];
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = uncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
	
	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  try {
	    construct(noop, empty, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};
	
	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};
	
	isConstructorLegacy.sham = true;
	
	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	module.exports = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var internalObjectKeys = __webpack_require__(913);
	var enumBugKeys = __webpack_require__(499);
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	module.exports = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};


/***/ },
/* 506 */
[2781, 102, 497],
/* 507 */
[2782, 2211, 506],
/* 508 */
[2784, 360],
/* 509 */
[2787, 360],
/* 510 */
[2790, 2227, 910],
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(349);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  vertical: _propTypes2.default.bool,
	  justified: _propTypes2.default.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3.default)(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2.default.defaultProps, 'block')] = block, _extends2));
	
	    return _react2.default.createElement('div', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2.default.Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3.default)(this, CloseButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onClick
	      },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	
	exports.default = CloseButton;
	module.exports = exports['default'];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(330);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(986);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(951);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2.default)(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2.default)(elem, margins[0]), 10) + parseInt((0, _style2.default)(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['height', 'width']), _propTypes2.default.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2.default.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3.default)(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3.default)(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2.default)(dimension)] + 'px';
	  };
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2.default)(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2.default)(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2.default)(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2.default)(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2.default)(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, props, {
	      'aria-expanded': props.role ? props.in : null,
	      className: (0, _classnames2.default)(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2.default.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports.default = Collapse;
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2.default.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3.default)(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3.default)(this, Glyphicon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2.default.createElement('span', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2.default.Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(300);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3.default)(this, TabContainer);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports.default = (0, _uncontrollable2.default)(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3.default)(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(240);
	var Danger = __webpack_require__(2319);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(111);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(526);
	var setInnerHTML = __webpack_require__(373);
	var setTextContent = __webpack_require__(981);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 518 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var ReactErrorUtils = __webpack_require__(524);
	
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 521 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var ReactPropTypesSecret = __webpack_require__(2345);
	var propTypesFactory = __webpack_require__(881);
	
	var React = __webpack_require__(206);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var ReactCurrentOwner = __webpack_require__(148);
	var ReactInstanceMap = __webpack_require__(289);
	var ReactInstrumentation = __webpack_require__(111);
	var ReactUpdates = __webpack_require__(125);
	
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 526 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 527 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 528 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 529 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var ReactCompositeComponent = __webpack_require__(2326);
	var ReactEmptyComponent = __webpack_require__(965);
	var ReactHostComponent = __webpack_require__(967);
	
	var getNextDebugID = __webpack_require__(2421);
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 532 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var emptyFunction = __webpack_require__(132);
	var warning = __webpack_require__(39);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 534 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 535 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(291);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _getRouteParams = __webpack_require__(2398);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(536);
	
	var _RouteUtils = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(346));
	
	var _max2 = _interopRequireDefault(__webpack_require__(736));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _get2 = _interopRequireDefault(__webpack_require__(133));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _Curve = _interopRequireDefault(__webpack_require__(249));
	
	var _Dot = _interopRequireDefault(__webpack_require__(208));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Area =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Area, _PureComponent);
	
	  function Area() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-area-');
	
	    _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Area, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (isAnimationActive && !isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          points = _this$props2.points,
	          dataKey = _this$props2.dataKey;
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, areaProps, {}, customDotProps, {}, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-area-dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderHorizontalRect",
	    value: function renderHorizontalRect(alpha) {
	      var _this$props3 = this.props,
	          baseLine = _this$props3.baseLine,
	          points = _this$props3.points,
	          strokeWidth = _this$props3.strokeWidth;
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = (0, _max2["default"])(points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxY = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react["default"].createElement("rect", {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: parseInt(maxY + (strokeWidth || 1), 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderVerticalRect",
	    value: function renderVerticalRect(alpha) {
	      var _this$props4 = this.props,
	          baseLine = _this$props4.baseLine,
	          points = _this$props4.points,
	          strokeWidth = _this$props4.strokeWidth;
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = (0, _max2["default"])(points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxX = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react["default"].createElement("rect", {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: parseInt(height, 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderClipRect",
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: "renderAreaStatically",
	    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
	      var _this$props5 = this.props,
	          layout = _this$props5.layout,
	          type = _this$props5.type,
	          stroke = _this$props5.stroke,
	          connectNulls = _this$props5.connectNulls,
	          isRange = _this$props5.isRange;
	      return _react["default"].createElement(_Layer["default"], {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, _react["default"].createElement(_Curve["default"], _extends({}, this.props, {
	        points: points,
	        baseLine: baseLine,
	        stroke: "none",
	        className: "recharts-area-area"
	      })), stroke !== 'none' && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: points
	      })), stroke !== 'none' && isRange && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: baseLine
	      })));
	    }
	  }, {
	    key: "renderAreaWithAnimation",
	    value: function renderAreaWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          baseLine = _this$props6.baseLine,
	          isAnimationActive = _this$props6.isAnimationActive,
	          animationBegin = _this$props6.animationBegin,
	          animationDuration = _this$props6.animationDuration,
	          animationEasing = _this$props6.animationEasing,
	          animationId = _this$props6.animationId;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "area-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
	
	          var stepPoints = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            }
	
	            return entry;
	          });
	          var stepBaseLine;
	
	          if ((0, _DataUtils.isNumber)(baseLine)) {
	            var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	            stepBaseLine = interpolator(t);
	          } else if ((0, _isNil2["default"])(baseLine) || (0, _isNaN2["default"])(baseLine)) {
	            var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	
	            stepBaseLine = _interpolator(t);
	          } else {
	            stepBaseLine = baseLine.map(function (entry, index) {
	              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	              if (prevBaseLine[prevPointIndex]) {
	                var prev = prevBaseLine[prevPointIndex];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	                return _objectSpread({}, entry, {
	                  x: interpolatorX(t),
	                  y: interpolatorY(t)
	                });
	              }
	
	              return entry;
	            });
	          }
	
	          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
	        }
	
	        return _react["default"].createElement(_Layer["default"], null, _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: "animationClipPath-".concat(clipPathId)
	        }, _this3.renderClipRect(t))), _react["default"].createElement(_Layer["default"], {
	          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
	        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
	      });
	    }
	  }, {
	    key: "renderArea",
	    value: function renderArea(needClip, clipPathId) {
	      var _this$props7 = this.props,
	          points = _this$props7.points,
	          baseLine = _this$props7.baseLine,
	          isAnimationActive = _this$props7.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          prevBaseLine = _this$state2.prevBaseLine,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points) || !(0, _isEqual2["default"])(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props8 = this.props,
	          hide = _this$props8.hide,
	          dot = _this$props8.dot,
	          points = _this$props8.points,
	          className = _this$props8.className,
	          top = _this$props8.top,
	          left = _this$props8.left,
	          xAxis = _this$props8.xAxis,
	          yAxis = _this$props8.yAxis,
	          width = _this$props8.width,
	          height = _this$props8.height,
	          isAnimationActive = _this$props8.isAnimationActive,
	          id = _this$props8.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: parseInt(height, 10)
	      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }]);
	
	  return Area;
	}(_react.PureComponent);
	
	Area.displayName = 'Area';
	Area.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  connectNulls: _propTypes["default"].bool,
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // dot configuration
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  hide: _propTypes["default"].bool,
	  // have curve configuration
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isRange: _propTypes["default"].bool,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Area.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Area.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	Area.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	  var points = displayedData.map(function (entry, index) {
	    var value;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  var baseLine;
	
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      if (layout === 'horizontal') {
	        return {
	          x: entry.x,
	          y: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? yAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null
	        };
	      }
	
	      return {
	        x: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? xAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null,
	        y: entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _objectSpread({
	    points: points,
	    baseLine: baseLine,
	    layout: layout,
	    isRange: isRange
	  }, offset);
	};
	
	Area.renderDotItem = function (option, props) {
	  var dotItem;
	
	  if (_react["default"].isValidElement(option)) {
	    dotItem = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	      className: "recharts-area-dot"
	    }));
	  }
	
	  return dotItem;
	};
	
	var _default = Area;
	exports["default"] = _default;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(250));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(294));
	
	var _Cell = _interopRequireDefault(__webpack_require__(248));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Bar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Bar, _PureComponent);
	
	  function Bar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-bar-');
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Bar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "renderRectanglesStatically",
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return data && data.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {}, entry, {
	          index: i
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-bar-rectangle"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderRectangle(shape, props));
	      });
	    }
	  }, {
	    key: "renderRectanglesWithAnimation",
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          data = _this$props2.data,
	          layout = _this$props2.layout,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "bar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	            var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	            var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	            return _objectSpread({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t),
	              width: interpolatorWidth(t),
	              height: interpolatorHeight(t)
	            });
	          }
	
	          if (layout === 'horizontal') {
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	
	            var h = _interpolatorHeight(t);
	
	            return _objectSpread({}, entry, {
	              y: entry.y + entry.height - h,
	              height: h
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	          var w = interpolator(t);
	          return _objectSpread({}, entry, {
	            width: w
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderRectanglesStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderRectangles",
	    value: function renderRectangles() {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this4 = this;
	
	      var data = this.props.data;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({}, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "background-bar-".concat(i),
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.constructor.renderRectangle(_this4.props.background, props);
	      });
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          layout = _this$props4.layout,
	          children = _this$props4.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: "error-bar-".concat(i),
	          // eslint-disable-line react/no-array-index-key
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          hide = _this$props5.hide,
	          data = _this$props5.data,
	          className = _this$props5.className,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          left = _this$props5.left,
	          top = _this$props5.top,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          isAnimationActive = _this$props5.isAnimationActive,
	          background = _this$props5.background,
	          id = _this$props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, _react["default"].createElement(_Layer["default"], {
	        className: "recharts-bar-rectangles",
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, data));
	    }
	  }], [{
	    key: "renderRectangle",
	    value: function renderRectangle(option, props) {
	      var rectangle;
	
	      if (_react["default"].isValidElement(option)) {
	        rectangle = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react["default"].createElement(_Rectangle["default"], props);
	      }
	
	      return rectangle;
	    }
	  }]);
	
	  return Bar;
	}(_react.PureComponent);
	
	Bar.displayName = 'Bar';
	Bar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  layout: _propTypes["default"].oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  barSize: _propTypes["default"].number,
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Bar.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Bar.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      item = _ref2.item,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var rects = displayedData.map(function (entry, index) {
	    var value, x, y, width, height, background;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = {
	        x: x,
	        y: yAxis.y,
	        width: width,
	        height: yAxis.height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = {
	        x: xAxis.x,
	        y: y,
	        width: xAxis.width,
	        height: height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	
	        width += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {
	      x: x,
	      y: y,
	      width: width,
	      height: height,
	      value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    data: rects,
	    layout: layout
	  }, offset);
	};
	
	var _default = Bar;
	exports["default"] = _default;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Curve = _interopRequireDefault(__webpack_require__(249));
	
	var _Dot = _interopRequireDefault(__webpack_require__(208));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(294));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Line =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Line, _PureComponent);
	
	  function Line() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-line-');
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({
	        totalLength: totalLength
	      });
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "getTotalLength",
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: "getStrokeDasharray",
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	      var remainLines = [];
	
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	      return [].concat(_toConsumableArray(this.constructor.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return "".concat(line, "px");
	      }).join(', ');
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          points = _this$props2.points,
	          xAxis = _this$props2.xAxis,
	          yAxis = _this$props2.yAxis,
	          layout = _this$props2.layout,
	          children = _this$props2.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          dot = _this$props3.dot,
	          points = _this$props3.points,
	          dataKey = _this$props3.dataKey;
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, lineProps, {}, customDotProps, {}, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-line-dots",
	        key: "dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderCurveStatically",
	    value: function renderCurveStatically(points, needClip, clipPathId, props) {
	      var _this$props4 = this.props,
	          type = _this$props4.type,
	          layout = _this$props4.layout,
	          connectNulls = _this$props4.connectNulls;
	
	      var curveProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
	        points: points
	      }, props, {
	        type: type,
	        layout: layout,
	        connectNulls: connectNulls
	      });
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, curveProps, {
	        pathRef: this.pathRef
	      }));
	    }
	  }, {
	    key: "renderCurveWithAnimation",
	    value: function renderCurveWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          strokeDasharray = _this$props5.strokeDasharray,
	          isAnimationActive = _this$props5.isAnimationActive,
	          animationBegin = _this$props5.animationBegin,
	          animationDuration = _this$props5.animationDuration,
	          animationEasing = _this$props5.animationEasing,
	          animationId = _this$props5.animationId,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          totalLength = _this$state.totalLength;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "line-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length;
	          var stepData = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            } // magic number of faking previous x and y location
	
	
	            if (_this3.animateNewValues) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	
	              return _objectSpread({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            return _objectSpread({}, entry, {
	              x: entry.x,
	              y: entry.y
	            });
	          });
	          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
	        }
	
	        var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	        var curLength = interpolator(t);
	        var currentStrokeDasharray;
	
	        if (strokeDasharray) {
	          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	            return parseFloat(num);
	          });
	          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	        } else {
	          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
	        }
	
	        return _this3.renderCurveStatically(points, needClip, clipPathId, {
	          strokeDasharray: currentStrokeDasharray
	        });
	      });
	    }
	  }, {
	    key: "renderCurve",
	    value: function renderCurve(needClip, clipPathId) {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderCurveStatically(points, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          dot = _this$props7.dot,
	          points = _this$props7.points,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          top = _this$props7.top,
	          left = _this$props7.left,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          isAnimationActive = _this$props7.isAnimationActive,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "repeat",
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames["default"])('recharts-line-dot', option ? option.className : '');
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: className
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Line;
	}(_react.PureComponent);
	
	Line.displayName = 'Line';
	Line.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // whether have dot in line
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animateNewValues: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes["default"].number,
	  id: _propTypes["default"].string
	});
	Line.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animateNewValues: true,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Line.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  return _objectSpread({
	    points: points,
	    layout: layout
	  }, offset);
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(376));
	
	var _Curve = _interopRequireDefault(__webpack_require__(249));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(544));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(294));
	
	var _Cell = _interopRequireDefault(__webpack_require__(248));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Scatter =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Scatter, _PureComponent);
	
	  function Scatter() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevPoints = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-');
	    return _this;
	  }
	
	  _createClass(Scatter, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: "renderSymbolsStatically",
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          shape = _this$props2.shape,
	          activeShape = _this$props2.activeShape,
	          activeIndex = _this$props2.activeIndex;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return points.map(function (entry, i) {
	        var props = _objectSpread({
	          key: "symbol-".concat(i)
	        }, baseProps, {}, entry);
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-scatter-symbol"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
	      });
	    }
	  }, {
	    key: "renderSymbolsWithAnimation",
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          points = _this$props3.points,
	          isAnimationActive = _this$props3.isAnimationActive,
	          animationBegin = _this$props3.animationBegin,
	          animationDuration = _this$props3.animationDuration,
	          animationEasing = _this$props3.animationEasing,
	          animationId = _this$props3.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[index];
	
	          if (prev) {
	            var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	            var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	            var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	            return _objectSpread({}, entry, {
	              cx: interpolatorCx(t),
	              cy: interpolatorCy(t),
	              size: interpolatorSize(t)
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	          return _objectSpread({}, entry, {
	            size: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSymbolsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSymbols",
	    value: function renderSymbols() {
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          children = _this$props5.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: "renderLine",
	    value: function renderLine() {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          line = _this$props6.line,
	          lineType = _this$props6.lineType,
	          lineJointType = _this$props6.lineJointType;
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints, lineItem;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return {
	            x: entry.cx,
	            y: entry.cy
	          };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	
	        linePoints = [{
	          x: xmin,
	          y: linearExp(xmin)
	        }, {
	          x: xmax,
	          y: linearExp(xmax)
	        }];
	      }
	
	      var lineProps = _objectSpread({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react["default"].isValidElement(line)) {
	        lineItem = _react["default"].cloneElement(line, lineProps);
	      } else if ((0, _isFunction2["default"])(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react["default"].createElement(_Curve["default"], _extends({}, lineProps, {
	          type: lineJointType
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-scatter-line",
	        key: "recharts-scatter-line"
	      }, lineItem);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          points = _this$props7.points,
	          line = _this$props7.line,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          left = _this$props7.left,
	          top = _this$props7.top,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isAnimationActive = _this$state.isAnimationActive,
	          isAnimationFinished = _this$state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, line && this.renderLine(), this.renderErrorBar(), _react["default"].createElement(_Layer["default"], {
	        key: "recharts-scatter-symbols"
	      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderSymbolItem",
	    value: function renderSymbolItem(option, props) {
	      var symbol;
	
	      if (_react["default"].isValidElement(option)) {
	        symbol = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react["default"].createElement(_Symbols["default"], _extends({}, props, {
	          type: option
	        }));
	      }
	
	      return symbol;
	    }
	  }]);
	
	  return Scatter;
	}(_react.PureComponent);
	
	Scatter.displayName = 'Scatter';
	Scatter.propTypes = _objectSpread({}, _ReactUtils.EVENT_ATTRIBUTES, {}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  line: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  lineType: _propTypes["default"].oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  className: _propTypes["default"].string,
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  activeIndex: _propTypes["default"].number,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes["default"].element, _propTypes["default"].func]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    size: _propTypes["default"].number,
	    node: _propTypes["default"].shape({
	      x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      z: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	    }),
	    payload: _propTypes["default"].any
	  })),
	  hide: _propTypes["default"].bool,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Scatter.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	};
	
	Scatter.getComposedData = function (_ref2) {
	  var xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      zAxis = _ref2.zAxis,
	      item = _ref2.item,
	      displayedData = _ref2.displayedData,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter,
	      offset = _ref2.offset,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks;
	  var tooltipType = item.props.tooltipType;
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell["default"]);
	  var xAxisDataKey = (0, _isNil2["default"])(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil2["default"])(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis["default"].defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil2["default"])(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{
	      name: xAxis.name || xAxis.dataKey,
	      unit: xAxis.unit || '',
	      value: x,
	      payload: entry,
	      dataKey: xAxisDataKey,
	      type: tooltipType
	    }, {
	      name: yAxis.name || yAxis.dataKey,
	      unit: yAxis.unit || '',
	      value: y,
	      payload: entry,
	      dataKey: yAxisDataKey,
	      type: tooltipType
	    }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey,
	        unit: zAxis.unit || '',
	        value: z,
	        payload: entry,
	        dataKey: zAxisDataKey,
	        type: tooltipType
	      });
	    }
	
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis,
	      ticks: xAxisTicks,
	      bandSize: xBandSize,
	      entry: entry,
	      index: index,
	      dataKey: xAxisDataKey
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis,
	      ticks: yAxisTicks,
	      bandSize: yBandSize,
	      entry: entry,
	      index: index,
	      dataKey: yAxisDataKey
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	    return _objectSpread({}, entry, {
	      cx: cx,
	      cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis,
	      yAxis: yAxis,
	      zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: {
	        x: x,
	        y: y,
	        z: z
	      },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: {
	        x: cx,
	        y: cy
	      },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	};
	
	var _default = Scatter;
	exports["default"] = _default;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(744));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _DefaultLegendContent = _interopRequireDefault(__webpack_require__(2441));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ReactUtils = __webpack_require__(28);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.value;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultLegendContent["default"], props);
	};
	
	var EPS = 1;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Legend, _PureComponent);
	
	  function Legend() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	    return _this;
	  }
	
	  _createClass(Legend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "getBBox",
	    value: function getBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return {
	          width: boxWidth,
	          height: boxHeight
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: "getDefaultPosition",
	    value: function getDefaultPosition(style) {
	      var _this$props = this.props,
	          layout = _this$props.layout,
	          align = _this$props.align,
	          verticalAlign = _this$props.verticalAlign,
	          margin = _this$props.margin,
	          chartWidth = _this$props.chartWidth,
	          chartHeight = _this$props.chartHeight;
	      var hPos, vPos;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || {
	            width: 0
	          };
	          hPos = {
	            left: ((chartWidth || 0) - box.width) / 2
	          };
	        } else {
	          hPos = align === 'right' ? {
	            right: margin && margin.right || 0
	          } : {
	            left: margin && margin.left || 0
	          };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || {
	            height: 0
	          };
	
	          vPos = {
	            top: ((chartHeight || 0) - _box.height) / 2
	          };
	        } else {
	          vPos = verticalAlign === 'bottom' ? {
	            bottom: margin && margin.bottom || 0
	          } : {
	            top: margin && margin.top || 0
	          };
	        }
	      }
	
	      return _objectSpread({}, hPos, {}, vPos);
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state2 = this.state,
	          boxWidth = _this$state2.boxWidth,
	          boxHeight = _this$state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          content = _this$props2.content,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          wrapperStyle = _this$props2.wrapperStyle,
	          paylodUniqBy = _this$props2.paylodUniqBy,
	          payload = _this$props2.payload;
	
	      var outerStyle = _objectSpread({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), {}, wrapperStyle);
	
	      return _react["default"].createElement("div", {
	        className: "recharts-legend-wrapper",
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: getUniqPaylod(paylodUniqBy, payload)
	      })));
	    }
	  }], [{
	    key: "getWithHeight",
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      }
	
	      if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.PureComponent);
	
	Legend.displayName = 'Legend';
	Legend.propTypes = {
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  wrapperStyle: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    left: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  onBBoxUpdate: _propTypes["default"].func
	};
	Legend.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	};
	var _default = Legend;
	exports["default"] = _default;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _d3Shape = __webpack_require__(556);
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle,
	  symbolCross: _d3Shape.symbolCross,
	  symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare,
	  symbolStar: _d3Shape.symbolStar,
	  symbolTriangle: _d3Shape.symbolTriangle,
	  symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	
	    case 'square':
	      return size * size;
	
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Symbols, _PureComponent);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          size = _this$props.size,
	          sizeType = _this$props.sizeType,
	          type = _this$props.type;
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	      return symbol();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          size = _this$props2.size;
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames["default"])('recharts-symbols', className),
	          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.PureComponent);
	
	Symbols.displayName = 'Symbols';
	Symbols.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  size: _propTypes["default"].number,
	  sizeType: _propTypes["default"].oneOf(['area', 'diameter'])
	});
	Symbols.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	};
	var _default = Symbols;
	exports["default"] = _default;

/***/ },
/* 545 */
[2743, 209],
/* 546 */
[2750, 92],
/* 547 */
[2756, 1024],
/* 548 */
[2769, 1025, 103, 1036, 1043],
/* 549 */
/***/ function(module, exports) {

	// `Math.sign` method implementation
	// https://tc39.es/ecma262/#sec-math.sign
	// eslint-disable-next-line es/no-math-sign -- safe
	module.exports = Math.sign || function sign(x) {
	  var n = +x;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return n == 0 || n != n ? n : n < 0 ? -1 : 1;
	};


/***/ },
/* 550 */
[2773, 176, 547, 2476, 1022, 554, 1041, 151, 1027],
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(92);
	
	module.exports = global;


/***/ },
/* 552 */
[2781, 92, 546],
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(75);
	var requireObjectCoercible = __webpack_require__(386);
	var toString = __webpack_require__(388);
	var whitespaces = __webpack_require__(555);
	
	var replace = uncurryThis(''.replace);
	var whitespace = '[' + whitespaces + ']';
	var ltrim = RegExp('^' + whitespace + whitespace + '*');
	var rtrim = RegExp(whitespace + whitespace + '*$');
	
	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod = function (TYPE) {
	  return function ($this) {
	    var string = toString(requireObjectCoercible($this));
	    if (TYPE & 1) string = replace(string, ltrim, '');
	    if (TYPE & 2) string = replace(string, rtrim, '');
	    return string;
	  };
	};
	
	module.exports = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod(3)
	};


/***/ },
/* 554 */
[2785, 2464, 386],
/* 555 */
/***/ function(module, exports) {

	// a string of all valid unicode whitespaces
	module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
	  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.7 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(2525)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$1 = x,
	      y$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$1 = x,
	      y$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$1.apply(this, (argv[0] = s, argv)), +y$1.apply(this, argv), +x$1.apply(this, (argv[0] = t, argv)), +y$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link) : x$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link) : y$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = 0, d[1] = dy;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.areaRadial = areaRadial;
	exports.curveBasis = basis;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBundle = bundle;
	exports.curveCardinal = cardinal;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveLinear = curveLinear;
	exports.curveLinearClosed = linearClosed;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.line = line;
	exports.lineRadial = lineRadial$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkRadial = linkRadial;
	exports.linkVertical = linkVertical;
	exports.pie = pie;
	exports.pointRadial = pointRadial;
	exports.radialArea = areaRadial;
	exports.radialLine = lineRadial$1;
	exports.stack = stack;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.symbol = symbol;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.symbols = symbols;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/New MG Logo (Icon).60aa8509.png";

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-eps.b08fbbe9.mp4";

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-gross-margins.b17365e4.mp4";

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-market-share.3b3f5c78.mp4";

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-revenues.004e48fc.mp4";

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-roa.dec455af.mp4";

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-roe.79000bff.mp4";

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/goals-and-targets-share-price.90d74854.mp4";

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer-feedback-good-luck.fbeab974.png";

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer-feedback-strength-areas-of-development.976e9385.png";

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 568 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jstz = __webpack_require__(276);
	
	var _jstz2 = _interopRequireDefault(_jstz);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactjsLocalstorage = __webpack_require__(173);
	
	var _Location = __webpack_require__(23);
	
	__webpack_require__(1821);
	
	var _reactRouter = __webpack_require__(24);
	
	__webpack_require__(1549);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _welcomePage = __webpack_require__(605);
	
	var _welcomePage2 = _interopRequireDefault(_welcomePage);
	
	var _loginPage = __webpack_require__(601);
	
	var _loginPage2 = _interopRequireDefault(_loginPage);
	
	var _registerPage = __webpack_require__(603);
	
	var _registerPage2 = _interopRequireDefault(_registerPage);
	
	var _joinPage = __webpack_require__(600);
	
	var _joinPage2 = _interopRequireDefault(_joinPage);
	
	var _resetPasswordPage = __webpack_require__(604);
	
	var _resetPasswordPage2 = _interopRequireDefault(_resetPasswordPage);
	
	var _accountVerify = __webpack_require__(612);
	
	var _accountVerify2 = _interopRequireDefault(_accountVerify);
	
	var _resetPassword = __webpack_require__(613);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _promoCode = __webpack_require__(602);
	
	var _promoCode2 = _interopRequireDefault(_promoCode);
	
	var _left = __webpack_require__(1359);
	
	var _left2 = _interopRequireDefault(_left);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _utils = __webpack_require__(18);
	
	var _topbar = __webpack_require__(1212);
	
	var _topbar2 = _interopRequireDefault(_topbar);
	
	var _teamProfilePage = __webpack_require__(1356);
	
	var _teamProfilePage2 = _interopRequireDefault(_teamProfilePage);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _autologout = __webpack_require__(1077);
	
	var _autologout2 = _interopRequireDefault(_autologout);
	
	var _popup = __webpack_require__(1245);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _leftbar = __webpack_require__(1208);
	
	var _leftbar2 = _interopRequireDefault(_leftbar);
	
	var _coachingFeedback = __webpack_require__(1164);
	
	var _coachingFeedback2 = _interopRequireDefault(_coachingFeedback);
	
	var _StudentBadgesFlow = __webpack_require__(1354);
	
	var _StudentBadgesFlow2 = _interopRequireDefault(_StudentBadgesFlow);
	
	var _StudentResultsNotifications = __webpack_require__(1355);
	
	var _StudentResultsNotifications2 = _interopRequireDefault(_StudentResultsNotifications);
	
	var _onboardingRouting = __webpack_require__(183);
	
	var _index = __webpack_require__(1348);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _roundProcessing = __webpack_require__(1353);
	
	var _roundProcessing2 = _interopRequireDefault(_roundProcessing);
	
	var _contactSupport = __webpack_require__(577);
	
	var _contactSupport2 = _interopRequireDefault(_contactSupport);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _analytics = __webpack_require__(1548);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _analyticsSend = __webpack_require__(1547);
	
	var _analyticsSend2 = _interopRequireDefault(_analyticsSend);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TIMER_UPDATE_INTERVAL = 60000; // one minute in ms
	var ROUND_HAS_ENDED_INTERVAL = 10000; // ten seconds in ms
	var CHECK_ROUND_ENDED_INTERVAL = 10000; // one second in ms
	
	var MIN_ROUNDS = 3; // show popup if count of rounds less than current value
	
	var App = function (_PureComponent) {
	  _inherits(App, _PureComponent);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.setMenuState = function (isMenuExpanded) {
	      _this.setState({
	        isMenuExpanded: isMenuExpanded
	      }, function () {
	        _Auth2.default.setMenuState(isMenuExpanded);
	        _this.eventemitter.trigger('activate-submenu');
	      });
	    };
	
	    _this.latestFinishedRound = function (rounds) {
	      // Sort by round number ascending before picking the last element.
	      // The BE returns rounds in insertion / id order, not number order,
	      // so after Activate Main Rounds the array can land as (2, 3, 1)
	      // and `finishedRounds[last]` would be Round 1 instead of the real
	      // latest round — which would silently route users to the wrong
	      // dashboard and feed the wrong round number into child components.
	      var finishedRounds = rounds.filter(function (i) {
	        return i.is_finished === true;
	      }).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	
	      return finishedRounds.length > 0 ? finishedRounds[finishedRounds.length - 1] : null;
	    };
	
	    _this.showCoachingFeedback = function (title, message1, message2, message3) {
	      _this.setState({
	        coachingFeedbackTitle: title,
	        coachingFeedbackMessage1: message1,
	        coachingFeedbackMessage2: message2,
	        coachingFeedbackMessage3: message3
	      }, function () {
	        _this.setState({
	          coachingFeedbackShow: true
	        });
	      });
	    };
	
	    _this.sendAnalyticsEvent = function (location) {
	      if (_this.state.current_round && _Auth2.default.getUserId()) {
	        var activeRound = _this.state.current_round.number;
	        if (_this.state.roundInUrl && _this.state.roundInUrl !== "") {
	          activeRound = _this.state.roundInUrl;
	        }
	
	        if (/^\/ceo\/analysis\/market.*$/.test(location.pathname) === true || /^\/pd\/analysis\/market.*$/.test(location.pathname) === true || /^\/pm\/analysis\/market.*$/.test(location.pathname) === true || /^\/op\/analysis\/market.*$/.test(location.pathname) === true || /^\/fn\/analysis\/market.*$/.test(location.pathname) === true || /^\/analysis\/bcase.*$/.test(location.pathname) === true || /^\/analysis\/team-reports.*$/.test(location.pathname) === true) {
	          _analytics2.default.event(activeRound, window, location.pathname);
	        }
	      }
	    };
	
	    _this.showPerformanceFeedbackAlert = function () {
	      _this.setState({
	        showPerformanceFeedbackAlert: true
	      });
	    };
	
	    _this.hidePerformanceFeedbackAlert = function () {
	      _this.setState({
	        showPerformanceFeedbackAlert: false
	      });
	    };
	
	    _this.updateUserRoles = function (callback) {
	      var joinRequest = (0, _ApiService.batchRequest)([].concat(_toConsumableArray(_Teams2.default.requests()), [("https://be-production-itb.marketgames.io/api/") + "v2/games/teamplayers/?game=" + _Auth2.default.getGameId()]));
	
	      joinRequest.then(function (res) {
	        var teams_data = [{
	          status: res[0].statusCode,
	          data: res[0].body
	        }, {
	          status: res[1].statusCode,
	          data: res[1].body
	        }];
	        var teams_status = _Teams2.default.setData(teams_data);
	        if (teams_status === "Error") {
	          throw teams_status;
	        }
	
	        _Auth2.default.setPlayerRoles(res[2].body.results);
	
	        if (callback) {
	          callback();
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.fetchData = function (callback) {
	      var location = _this.props.location;
	      var showPaymentsPopup = _this.state.showPaymentsPopup;
	
	
	      var queryToken = _lodash2.default.get(location, "query._token", null);
	      var target = _lodash2.default.get(location, "query._target", null);
	      var currentToken = _Auth2.default.getToken();
	
	      if (queryToken && (!currentToken || target === "blank")) {
	        _Auth2.default.setTemporaryUser({
	          token: queryToken,
	          game_id: _lodash2.default.get(location, "query.game_id", null),
	          course_id: _lodash2.default.get(location, "query._courseid", null),
	          user_id: _lodash2.default.get(location, "query._userid", null),
	          team_id: _lodash2.default.get(location, "query.team_id", null)
	        });
	      }
	
	      var temporaryUser = _Auth2.default.getTemporaryUser();
	      if (temporaryUser) {
	        _Auth2.default.setToken(temporaryUser.token);
	        _Auth2.default.setPosition("Instructor");
	        _Auth2.default.setGameId(temporaryUser.game_id);
	        _Auth2.default.setCourseId(temporaryUser.course_id);
	        _Auth2.default.setUserId(temporaryUser.user_id);
	        _Auth2.default.setTeamId(temporaryUser.team_id);
	
	        (0, _Location.changeLocation)(location.pathname + "?round=" + _lodash2.default.get(location, 'query.round', null));
	      }
	
	      var hasToken = _Auth2.default.getToken();
	      if (!hasToken) {
	        _this.setState({
	          showPaymentsPopup: false,
	          loaded: true
	        });
	        _this.detectRoundInUrl();
	        return;
	      }
	
	      var isStudent = _this.isStudent;
	      var auth_game_id = _Auth2.default.getGameId();
	      // Backend has two handlers gated on ?position=instructor|student.
	      var general_info_position = isStudent ? "student" : "instructor";
	      // Ask BE for the trimmed dashboard payload when the instructor is
	      // actively on /instructor/dashboard. Other instructor pages
	      // (round-admin, onboarding, welcome, etc.) call general-info
	      // without the scope hint and keep receiving the full payload.
	      var currentPath = _this.props.location && _this.props.location.pathname || "";
	      var general_info_scope = !isStudent && currentPath.indexOf("/instructor/dashboard") === 0 ? "dashboard" : undefined;
	
	      // Fresh-session detector: Auth.deauthenticateUser clears
	      // sessionStorage.game_id on logout, so an unset auth_game_id
	      // signals we're starting over. Reset the one-shot refetch flag
	      // so the "fire again with game_id" logic below can run for the
	      // new session. Without this, the App instance persists across
	      // logout/login in an SPA and the flag stays true forever after
	      // the first successful refetch.
	      if (!auth_game_id) {
	        _this._gi_refetched = false;
	      }
	
	      (0, _AppGeneralInfoService.fetchAppGeneralInfo)(auth_game_id, general_info_position, general_info_scope).then(function (data) {
	        var user = data.user;
	        if (user) {
	          if (JSON.stringify(user) !== JSON.stringify(_Auth2.default.getUser())) {
	            _Auth2.default.setUserData(user);
	          }
	
	          var userData = {};
	          if (user.first_name !== _this.state.first_name) {
	            userData.first_name = user.first_name;
	          }
	          if (user.last_name !== _this.state.last_name) {
	            userData.last_name = user.last_name;
	          }
	          if (user.username !== _this.state.username) {
	            userData.username = user.username;
	          }
	          if (user.role !== _this.state.userPosition) {
	            userData.userPosition = user.role;
	          }
	          if (user.id !== _this.state.userId) {
	            userData.userId = user.id;
	          }
	
	          if (Object.keys(userData).length > 0) {
	            _this.setState(userData);
	          }
	        }
	
	        if (isStudent === true) {
	          // Intro gate: first-time students must watch the ITB intro
	          // video before any other student page renders (including the
	          // Stripe payment popup). Return unconditionally when intro is
	          // still 0 so downstream gates don't run over the top of it.
	          if (user && user.intro === 0) {
	            if (location.pathname !== "/intro-video") {
	              (0, _Location.changeLocation)("/intro-video");
	            }
	            _this.setState({ loaded: true });
	            return;
	          }
	
	          if (_Auth2.default.isPaid() === false) {
	            if (_this.isMobile === true && location.pathname !== "/promo-code") {
	              (0, _Location.changeLocation)("/promo-code");
	              _this.setState({ loaded: true });
	            } else if (showPaymentsPopup === false) {
	              _this.setState({ showPaymentsPopup: true, loaded: true });
	            }
	            return;
	          }
	        }
	
	        // FE is authoritative on active course/game. Ignore data.game
	        // singular; derive both from the arrays via the picker so the
	        // choice is deterministic across login and general-info: highest-
	        // id course, then highest-id game in that course. Prevents the
	        // "highest-id game across all games" fallback from promoting a
	        // foreign course's game.
	
	        var _pickCourseAndGame = (0, _AppGeneralInfoService.pickCourseAndGame)(data.courses, data.games),
	            pickedCourse = _pickCourseAndGame.course,
	            pickedGame = _pickCourseAndGame.game;
	
	        if (pickedCourse) {
	          _Auth2.default.setCourseId(pickedCourse.id);
	        }
	        var game = pickedGame;
	
	        // Student fallback: general-info's `data.games` isn't
	        // always populated for students, so the picker can return
	        // null even when the student is enrolled in a game. Use
	        // `data.user.game` (authoritative for the logged-in user)
	        // to source the game id in that case — either match against
	        // data.games by id or synthesize a minimal { id } object so
	        // the noGameYet lock doesn't fire incorrectly.
	        if (isStudent && !game && data.user && data.user.game) {
	          var userGameId = Number(data.user.game);
	          var foundGame = (Array.isArray(data.games) ? data.games : []).find(function (g) {
	            return Number(g.id) === userGameId;
	          });
	          // The student general-info payload uses `data.game`
	          // (singular) — an object with round, rounds[], course, etc.
	          // Prefer that over a synthesized {id} stub so downstream
	          // logic (current_round derivation, Countdown, dropdown) has
	          // the full game context.
	          var singularGame = data.game && Number(data.game.id) === userGameId ? data.game : null;
	          game = foundGame || singularGame || { id: userGameId };
	        }
	
	        // Additional student lock rule: even when a game exists,
	        // the instructor may not have set an active round yet.
	        // `data.user.game_round` is the authoritative signal — null
	        // means no active round, so treat it the same as "no game"
	        // and show the locked Welcome screen.
	        //
	        // Which lock message to show depends on whether the instructor
	        // has scheduled any rounds yet:
	        //   - Rounds exist but none is active → "Round Has Not Started
	        //     Yet" (setup is done, just waiting for start).
	        //   - No rounds scheduled at all      → same "Waiting on
	        //     Instructor to set up exercise" message we use for the
	        //     no-game case.
	        var studentLockReason = null;
	        if (isStudent && game) {
	          var gameRound = data.user && data.user.game_round;
	          if (gameRound == null) {
	            var hasScheduledRounds = Array.isArray(data.rounds) && data.rounds.length > 0;
	            studentLockReason = hasScheduledRounds ? 'round_not_started' : 'no_game';
	            game = null;
	          }
	        }
	
	        console.log('[MG:picker] general-info selection:', {
	          pickedCourse: pickedCourse,
	          pickedGame: pickedGame,
	          isStudent: isStudent,
	          userGame: data.user && data.user.game,
	          resolvedGame: game,
	          currentCourseId_after: _Auth2.default.getCourseId()
	        });
	        var rounds = data.rounds || [];
	        var teams = data.teams || [];
	        var teamplayers = data.teamplayers || [];
	
	        if (game) {
	          _Auth2.default.setGameId(game.id);
	
	          // On the very first login the sessionStorage game_id is
	          // unset, so the general-info URL goes out as
	          // `?position=<role>` with no game_id. The backend's
	          // minimal response in that case only includes the user
	          // object — no rounds, teams, teamplayers, or course_members.
	          // Now that we know game.id (from either the picker or the
	          // student fallback at line ~462), refire with it once — the
	          // cache key changes so we get a fresh request that includes
	          // the full payload. Guarded by `_gi_refetched` to prevent a
	          // recursion loop if the backend still doesn't return the
	          // extra fields.
	          //
	          // Signal of the minimal payload: rounds is empty. Fully set-up
	          // games always ship rounds on both student and instructor
	          // responses (including scope=dashboard), so an empty rounds
	          // array means we got the stripped first-login payload and need
	          // to refire with the resolved game_id. We previously used
	          // `teamplayers.length === 0` for the instructor branch, but
	          // scope=dashboard intentionally omits teamplayers now, which
	          // falsely flagged every dashboard load as minimal and caused a
	          // spurious second general-info request.
	          var payloadLooksMinimal = rounds.length === 0;
	          if (!_this._gi_refetched && (!auth_game_id || payloadLooksMinimal) && game.id) {
	            _this._gi_refetched = true;
	            (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	            _Auth2.default.setGameId(game.id);
	            _this.fetchData(callback);
	            return;
	          }
	
	          // Set teams data from consolidated response
	          if (teams.length > 0 || teamplayers.length > 0) {
	            var teams_data = [{ status: 200, data: teamplayers }, { status: 200, data: teams }];
	            _Teams2.default.setData(teams_data);
	          }
	
	          if (teamplayers.length > 0) {
	            _Auth2.default.setPlayerRoles(teamplayers);
	          }
	
	          var players = {};
	          _Teams2.default.players().forEach(function (player) {
	            players[player.role] = {
	              first_name: "user" in player ? player.user.first_name : "",
	              last_name: "user" in player ? player.user.last_name : "",
	              team_id: player.team
	            };
	          });
	
	          var team = _Teams2.default.currentTeam();
	          var team_color = _Teams2.default.currentTeamColor();
	          var team_name = team ? team.name : "";
	
	          var _game = game,
	              round = _game.round;
	          // The instructor-keyed general-info response may omit the
	          // game.rounds id-list (the student response always includes
	          // it). Fall back to all rounds whose `game` field matches —
	          // they're already filtered to the current game by the
	          // backend, so this is effectively a no-op for students.
	
	          var gameRoundIds = Array.isArray(game.rounds) ? game.rounds : null;
	          var current_rounds = gameRoundIds ? rounds.filter(function (i) {
	            return gameRoundIds.includes(i.id);
	          }) : rounds.filter(function (i) {
	            return Number(i.game) === Number(game.id);
	          });
	
	          var current_round = current_rounds.find(function (i) {
	            return i.number === 1;
	          });
	          if (round !== null) {
	            current_round = current_rounds.find(function (i) {
	              return i.id === round;
	            });
	          }
	
	          if (isStudent === true) {
	            var hasRoundEnded = _this.checkIfRoundHasEndedAndSetTimers(current_round, current_rounds);
	            var interval = hasRoundEnded ? ROUND_HAS_ENDED_INTERVAL : TIMER_UPDATE_INTERVAL;
	
	            setTimeout(_this.updateRoundShouldBeFinished, 1000);
	
	            if (_this.rounds_timer) {
	              clearTimeout(_this.rounds_timer);
	            }
	
	            var updateTimer = true;
	
	            var count_of_rounds = current_rounds.length;
	            if (current_round && count_of_rounds > 0 && current_round.number === current_rounds[count_of_rounds - 1].number && hasRoundEnded === true) {
	              updateTimer = false;
	            }
	
	            if (_this.need_to_cancel === true) {
	              updateTimer = false;
	              _this.need_to_cancel = false;
	            }
	
	            // Only auto-refresh when user is on decision pages viewing the active round
	            var isOnDecisionPage = window.location.pathname.includes('/decisions');
	            var activeRoundNumber = current_round ? current_round.number : null;
	            var viewingRound = Number(_lodash2.default.get(_this.props, 'location.query.round', 0));
	            var isViewingActiveRound = viewingRound === activeRoundNumber;
	
	            if (updateTimer === true && isOnDecisionPage && isViewingActiveRound) {
	              _this.rounds_timer = setTimeout(_this.fetchData, interval);
	            }
	
	            var roundData = {};
	            if (JSON.stringify(players) !== JSON.stringify(_this.state.players)) {
	              roundData.players = players;
	            }
	            if (team_color !== _this.state.team_color) {
	              roundData.team_color = team_color;
	            }
	            if (team_name !== _this.state.team_name) {
	              roundData.team_name = team_name;
	            }
	            if (true !== _this.state.has_team_data) {
	              roundData.has_team_data = true;
	            }
	            if (true !== _this.state.rounds_loaded) {
	              roundData.rounds_loaded = true;
	            }
	            if (JSON.stringify(current_rounds) !== JSON.stringify(_this.state.rounds)) {
	              roundData.rounds = current_rounds;
	            }
	            if (JSON.stringify(current_round) !== JSON.stringify(_this.state.current_round)) {
	              roundData.current_round = current_round;
	            }
	            if (false !== _this.state.showPaymentsPopup) {
	              roundData.showPaymentsPopup = false;
	            }
	            if (true !== _this.state.loaded) {
	              roundData.loaded = true;
	            }
	            if (_this.state.noGameYet) {
	              roundData.noGameYet = false;
	            }
	            if (_this.state.studentLockReason != null) {
	              roundData.studentLockReason = null;
	            }
	            roundData.game = game;
	
	            // Student-only: expose viewed_results (drives the
	            // Results-Ready notification popup) and derive the
	            // course_member id (needed to PATCH the viewed flags).
	            // BE currently ships viewed_results inside data.user for
	            // students but there's precedent for a top-level location;
	            // accept either so we're robust to a BE relocation.
	            var viewedResults = data && data.viewed_results || data && data.user && data.user.viewed_results || null;
	            // Course-member id source order:
	            //   1. data.course_members[] (instructor payload shape).
	            //   2. data.teamplayers[].course_member for the self user
	            //      (student payload shape — no top-level course_members).
	            var selfUserId = Number(data.user && data.user.id);
	            var courseMembers = data && data.course_members || [];
	            var selfMember = courseMembers.find(function (cm) {
	              return cm && Number(cm.user) === selfUserId;
	            });
	            var courseMemberId = selfMember ? selfMember.id : null;
	            if (!courseMemberId) {
	              var selfPlayer = (Array.isArray(data.teamplayers) ? data.teamplayers : []).find(function (tp) {
	                return tp && tp.user && Number(tp.user.id) === selfUserId;
	              });
	              if (selfPlayer && selfPlayer.course_member) {
	                courseMemberId = selfPlayer.course_member;
	              }
	            }
	            if (JSON.stringify(viewedResults) !== JSON.stringify(_this.state.viewedResults)) {
	              roundData.viewedResults = viewedResults;
	            }
	            if (courseMemberId !== _this.state.courseMemberId) {
	              roundData.courseMemberId = courseMemberId;
	            }
	
	            if (Object.keys(roundData).length > 0) {
	              _this.setState(roundData, function () {
	                _this.sendAnalyticsEvent(_this.props.location);
	                if (callback) callback();
	              });
	            } else {
	              _this.sendAnalyticsEvent(_this.props.location);
	              if (callback) callback();
	            }
	          } else {
	            // Instructor with team
	            var instructorRounds = current_rounds.filter(function (i) {
	              return Number(i.game) === Number(game.id);
	            });
	
	            _this.setState({
	              game: game,
	              players: players,
	              team_color: team_color,
	              team_name: team_name,
	              has_team_data: true,
	              rounds_loaded: true,
	              rounds: instructorRounds,
	              instructorRounds: instructorRounds,
	              instructorTeams: teams,
	              instructorCourses: data.courses || [],
	              instructorGames: data.games || [],
	              instructorTeamplayers: teamplayers,
	              courseMembers: data.course_members || [],
	              sectionTeamsCount: Number(data.section_teams_count) || 0,
	              current_round: current_round,
	              roundInUrl: _lodash2.default.get(location, 'query.round', null),
	              showPaymentsPopup: false,
	              loaded: true
	            }, function () {
	              if (callback) callback();
	            });
	          }
	        } else {
	          // No game for the picked course. Two flows:
	          //   Student: redirect to /onboarding (Welcome) and render
	          //   the locked "Waiting on Instructor" screen. The intro
	          //   video and is_paid gates above still run first.
	          //   Instructor: unchanged — falls through to the existing
	          //   partial-onboarding path (create game via SimulationSelection).
	          if (isStudent === true) {
	            if (location.pathname !== "/onboarding") {
	              (0, _Location.changeLocation)("/onboarding");
	            }
	            _this.setState({
	              game: null,
	              current_round: null,
	              rounds: [],
	              noGameYet: true,
	              // Default to 'no_game' when studentLockReason wasn't set
	              // upstream (i.e. the picker never resolved a game to begin
	              // with). The 'round_not_started' variant is only set when
	              // a game DID resolve but no round is active yet AND rounds
	              // are already scheduled.
	              studentLockReason: studentLockReason || 'no_game',
	              showPaymentsPopup: false,
	              loaded: true
	            }, function () {
	              if (callback) callback();
	            });
	          } else {
	            _this.setState({
	              game: null,
	              current_round: null,
	              rounds: [],
	              instructorRounds: [],
	              instructorCourses: data.courses || [],
	              instructorGames: data.games || [],
	              instructorTeamplayers: teamplayers,
	              courseMembers: data.course_members || [],
	              sectionTeamsCount: Number(data.section_teams_count) || 0,
	              roundInUrl: _lodash2.default.get(location, 'query.round', null),
	              showPaymentsPopup: false,
	              loaded: true
	            }, function () {
	              if (callback) callback();
	            });
	          }
	        }
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "App", "fetchData");
	      });
	
	      _this.detectRoundInUrl();
	    };
	
	    _this.getNumber = function (str) {
	      var val = parseInt(str, 10);
	      if (isNaN(val)) {
	        return 0;
	      }
	
	      return val;
	    };
	
	    _this.needRedirect = function (current_round) {
	      var isTimesUpShown = _reactjsLocalstorage.reactLocalStorage.get("timesUpModal", "false") === "true";
	      var timesUpInfo = _reactjsLocalstorage.reactLocalStorage.get("timesUpModalRound", "0::0::0::0").split("::");
	      var game_id = _this.getNumber(timesUpInfo[0]);
	      var user_id = _this.getNumber(timesUpInfo[1]);
	      var round_number = _this.getNumber(timesUpInfo[2]);
	      var round_id = _this.getNumber(timesUpInfo[3]);
	      var original_user_id = _this.getNumber(_Auth2.default.getUserId());
	      var original_game_id = _this.getNumber(_Auth2.default.getGameId());
	
	      return isTimesUpShown === false || round_number !== current_round.number || round_id !== current_round.id || user_id !== original_user_id || game_id !== original_game_id;
	    };
	
	    _this.goToDashboard = function (round) {
	      var game_id = _this.getNumber(_Auth2.default.getGameId());
	      var user_id = _this.getNumber(_Auth2.default.getUserId());
	
	      var hash = game_id + "::" + user_id + "::" + round.number + "::" + round.id;
	
	      _this.eventemitter.trigger("disable-team-feedback");
	      _reactjsLocalstorage.reactLocalStorage.set("timesUpModal", true);
	      _reactjsLocalstorage.reactLocalStorage.set("timesUpModalRound", hash);
	      _this.rounds_timer2 = setTimeout(function () {
	        _this.fetchData(function () {
	          _this.updateUserRoles(function () {
	            _this.eventemitter.trigger("reload-data");
	          });
	        });
	      }, 3000);
	      (0, _Location.changeLocation)("/start");
	    };
	
	    _this.checkForRedirect = function (rounds) {
	      var latestFinishedRound = _this.latestFinishedRound(rounds);
	      if (latestFinishedRound && _this.needRedirect(latestFinishedRound) === true && window.location.pathname !== "/get-started") {
	        _this.goToDashboard(latestFinishedRound);
	        return true;
	      }
	
	      return false;
	    };
	
	    _this.detectRoundInUrl = function () {
	      var location = _this.props.location;
	
	      var roundInUrl = null;
	
	      if (location.query.round) {
	        roundInUrl = parseInt(location.query.round, 10);
	
	        if (isNaN(roundInUrl)) {
	          roundInUrl = null;
	        }
	      }
	
	      if (roundInUrl !== _this.state.roundInUrl) {
	        _this.setState({
	          roundInUrl: roundInUrl
	        }, function () {});
	      }
	    };
	
	    _this.updateRoundShouldBeFinished = function () {
	      var current_round = _this.state.current_round;
	
	      var result = false;
	
	      if (current_round) {
	        var end_date = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)(current_round.end_date));
	        var now_date = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)());
	
	        if (now_date > end_date) {
	          result = true;
	        }
	      }
	
	      if (_this.state.roundShouldBeFinished !== result) {
	        _this.setState({
	          roundShouldBeFinished: result
	        }, function () {
	          setTimeout(_this.updateRoundShouldBeFinished, 1000);
	        });
	      } else {
	        setTimeout(_this.updateRoundShouldBeFinished, 1000);
	      }
	    };
	
	    _this.setRoundProcessing = function (callback) {
	      var current_round = _lodash2.default.cloneDeep(_this.state.current_round);
	      current_round.should_be_finished = true;
	
	      _this.setState({
	        current_round: current_round
	      }, function () {
	        callback();
	      });
	    };
	
	    _this.errorAlert = function (errorText) {
	      _this.setState({
	        errorText: errorText
	      }, function () {
	        _this.showErrorAlert();
	      });
	    };
	
	    _this.showErrorAlert = function () {
	      _this.setState({
	        errorAlert: true
	      });
	    };
	
	    _this.hideErrorAlert = function () {
	      _this.setState({
	        errorAlert: false
	      });
	    };
	
	    _this.hideSubmitDecisionsAlert = function () {
	      _this.setState({
	        submitDecisionsAlert: false
	      });
	    };
	
	    _this.showSubmitDecisionsAlert = function () {
	      _this.setState({
	        submitDecisionsAlert: true
	      });
	    };
	
	    _this.submitDecisionsEvent = function (type, text, size) {
	      _this.setState({
	        submitDecisionsType: type,
	        submitDecisionsText: text,
	        submitDecisionsSize: size || "md"
	      }, function () {
	        _this.showSubmitDecisionsAlert();
	      });
	    };
	
	    _this.enableTour = function () {
	      _this.setState({
	        tourMode: true
	      });
	    };
	
	    _this.disableTour = function () {
	      _this.setState({
	        tourMode: false
	      });
	    };
	
	    _this.logout = function () {
	      if (_Auth2.default.isUserAuthenticated()) {
	        _Auth2.default.deauthenticateUser();
	        window.location.reload();
	      }
	    };
	
	    _this.handleLogout = function (e) {
	      var element = e.target;
	
	      if (element.tagName === "A" && element.classList.contains("sweetalert-logout-button")) {
	        e.preventDefault();
	        _this.logout();
	      }
	    };
	
	    _this.closeMobileMenu = function () {
	      if (_this.isMobile) {
	        _this.setState({
	          isMobileMenuOpen: false
	        });
	      }
	    };
	
	    _this.handleMobileMenuState = function (state) {
	      _this.setState({
	        isMobileMenuOpen: state.isOpen
	      });
	    };
	
	    _this.coachingFeedbackOnClose = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this.setState({
	        coachingFeedbackShow: false
	      });
	    };
	
	    _this.state = {
	      loaded: false,
	      rounds: [],
	      current_round: null,
	      roundInUrl: null,
	      team_color: "",
	      tourMode: false,
	      players: {},
	      team_name: "",
	      has_team_data: false,
	      rounds_loaded: false,
	      errorAlert: false,
	      errorText: "",
	      submitDecisionsAlert: false,
	      submitDecisionsText: "",
	      submitDecisionsType: "success",
	      submitDecisionsSize: "md",
	      isMobileMenuOpen: false,
	      showPaymentsPopup: false,
	      first_name: "",
	      last_name: "",
	      username: "",
	      userPosition: "",
	      coachingFeedbackTitle: null,
	      coachingFeedbackMessage1: null,
	      coachingFeedbackMessage2: null,
	      coachingFeedbackMessage3: null,
	      coachingFeedbackShow: false,
	      roundShouldBeFinished: false,
	      instructorRounds: [],
	      instructorTeams: [],
	      instructorCourses: [],
	      instructorGames: [],
	      instructorTeamplayers: [],
	      courseMembers: [],
	      sectionTeamsCount: 0,
	      showPerformanceFeedbackAlert: false,
	      isMenuExpanded: _Auth2.default.getMenuState(),
	      isPerformanceFeedbackVisible: true,
	      game: null,
	      noGameYet: false,
	      studentLockReason: null,
	      // Student-only: fed from general-info.viewed_results. Drives
	      // the Results-Ready notification popup.
	      viewedResults: null,
	      // Student-only: the current student's course_members row id,
	      // derived from data.course_members by matching data.user.id.
	      // Needed to PATCH rd<N>_viewed / <initial|final>_survey_viewed.
	      courseMemberId: null
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.need_to_cancel = false;
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.unlisten = _reactRouter.browserHistory.listen(this.sendAnalyticsEvent);
	
	      this.fetchData();
	
	      this.eventemitter.on("app-show-error", this.errorAlert);
	      this.eventemitter.on("reload-data", this.fetchData);
	      this.eventemitter.on("submit-decisions-event", this.submitDecisionsEvent);
	      this.eventemitter.on("tour-enabled", this.enableTour);
	      this.eventemitter.on("tour-disabled", this.disableTour);
	      this.eventemitter.on("coaching-feedback", this.showCoachingFeedback);
	      this.eventemitter.on("coaching-feedback-hide", this.coachingFeedbackOnClose);
	      this.eventemitter.on("round-switcher-alert", this.showPerformanceFeedbackAlert);
	
	      if (typeof window !== "undefined") {
	        window.addEventListener("click", this.handleLogout, false);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var location = this.props.location;
	
	
	      this.detectRoundInUrl();
	
	      // Instructor onboarding gate: back-button navigation (or any
	      // other cross-app navigation) can otherwise land an instructor
	      // on a non-onboarding page while the flow is incomplete. This
	      // re-runs the routing rule on every location change and pushes
	      // them back to whichever step they still owe. See
	      // onboardingRouting.js for the rules.
	      var prevPath = prevProps && prevProps.location && prevProps.location.pathname;
	      if (_Auth2.default.getPosition() === 'Instructor' && prevPath !== location.pathname && location.pathname.indexOf('/instructor/onboarding') !== 0 && location.pathname !== '/start' && location.pathname !== '/' && location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/promo-code' && location.pathname.indexOf('/reset-password') !== 0 && location.pathname.indexOf('/verify') !== 0) {
	        (0, _onboardingRouting.resolveOnboardingEntry)().then(function (url) {
	          if (url) (0, _Location.changeLocation)(url);
	        }).catch(function () {});
	      }
	
	      if (this.isStudent === true) {
	        // Skip the payment gate while the intro-video flow is still open.
	        // Students with intro === 0 need to finish the video first; the
	        // Stripe popup / promo-code redirect fires only after intro is 1.
	        var user = _Auth2.default.getUser();
	        var introPending = user && user.intro === 0 || location.pathname === "/intro-video";
	        if (introPending) return;
	
	        if (_Auth2.default.isPaid() === false) {
	          if (this.isMobile === true && location.pathname !== "/promo-code") {
	            (0, _Location.changeLocation)("/promo-code");
	          } else if (this.state.showPaymentsPopup !== true) {
	            this.setState({
	              showPaymentsPopup: true
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unlisten();
	
	      if (this.check_timer) {
	        clearTimeout(this.check_timer);
	        this.check_timer = null;
	      }
	
	      if (this.rounds_timer) {
	        clearTimeout(this.rounds_timer);
	        this.rounds_timer = null;
	      }
	
	      if (this.rounds_timer2) {
	        clearTimeout(this.rounds_timer2);
	        this.rounds_timer2 = null;
	      }
	
	      this.eventemitter.off("app-show-error", this.errorAlert);
	      this.eventemitter.off("reload-data", this.fetchData);
	      this.eventemitter.off("submit-decisions-event", this.submitDecisionsEvent);
	      this.eventemitter.off("tour-enabled", this.enableTour);
	      this.eventemitter.off("tour-disabled", this.disableTour);
	      this.eventemitter.off("coaching-feedback", this.showCoachingFeedback);
	      this.eventemitter.off("coaching-feedback-hide", this.coachingFeedbackOnClose);
	      this.eventemitter.on("round-switcher-alert", this.showPerformanceFeedbackAlert);
	
	      if (typeof window !== "undefined") {
	        window.removeEventListener("click", this.handleLogout);
	      }
	    }
	  }, {
	    key: "checkIfRoundHasEndedAndSetTimers",
	    value: function checkIfRoundHasEndedAndSetTimers(current_round, current_rounds) {
	      var _this2 = this;
	
	      if (_Auth2.default.isUserAuthenticated() === false) {
	        return;
	      }
	
	      if (this.check_timer) {
	        clearTimeout(this.check_timer);
	        this.check_timer = null;
	      }
	
	      if (current_round) {
	        var need_redirect = this.checkForRedirect(current_rounds);
	
	        if (need_redirect === true) {
	          if (this.rounds_timer) {
	            clearTimeout(this.rounds_timer);
	            this.rounds_timer = null;
	          }
	
	          this.need_to_cancel = true;
	
	          return false;
	        } else {
	          var end_date = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)(current_round.end_date));
	          var now_date = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)());
	          var time = end_date - now_date;
	
	          var round_has_ended = false;
	
	          if (time <= 0 && current_round.is_finished !== true && this.state.current_round) {
	            if (this.rounds_timer) {
	              clearTimeout(this.rounds_timer);
	              this.rounds_timer = null;
	            }
	
	            this.need_to_cancel = true;
	
	            round_has_ended = true;
	            this.setRoundProcessing(function () {
	              _this2.rounds_timer2 = setTimeout(function () {
	                _this2.fetchData();
	              }, ROUND_HAS_ENDED_INTERVAL);
	            });
	          } else if (current_round.is_finished === true) {
	            round_has_ended = true;
	          } else {
	            this.check_timer = setTimeout(function () {
	              _this2.checkIfRoundHasEndedAndSetTimers(current_round, current_rounds);
	            }, CHECK_ROUND_ENDED_INTERVAL);
	          }
	
	          return round_has_ended;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          rounds = _state.rounds,
	          roundInUrl = _state.roundInUrl,
	          team_color = _state.team_color,
	          tourMode = _state.tourMode,
	          errorAlert = _state.errorAlert,
	          errorText = _state.errorText,
	          submitDecisionsAlert = _state.submitDecisionsAlert,
	          submitDecisionsText = _state.submitDecisionsText,
	          submitDecisionsType = _state.submitDecisionsType,
	          submitDecisionsSize = _state.submitDecisionsSize,
	          showPaymentsPopup = _state.showPaymentsPopup,
	          coachingFeedbackShow = _state.coachingFeedbackShow,
	          coachingFeedbackTitle = _state.coachingFeedbackTitle,
	          coachingFeedbackMessage1 = _state.coachingFeedbackMessage1,
	          coachingFeedbackMessage2 = _state.coachingFeedbackMessage2,
	          coachingFeedbackMessage3 = _state.coachingFeedbackMessage3,
	          first_name = _state.first_name,
	          last_name = _state.last_name,
	          instructorRounds = _state.instructorRounds,
	          roundShouldBeFinished = _state.roundShouldBeFinished,
	          username = _state.username,
	          showPerformanceFeedbackAlert = _state.showPerformanceFeedbackAlert,
	          instructorTeams = _state.instructorTeams,
	          instructorCourses = _state.instructorCourses,
	          instructorGames = _state.instructorGames,
	          instructorTeamplayers = _state.instructorTeamplayers,
	          courseMembers = _state.courseMembers,
	          sectionTeamsCount = _state.sectionTeamsCount,
	          isMenuExpanded = _state.isMenuExpanded,
	          isPerformanceFeedbackVisible = _state.isPerformanceFeedbackVisible,
	          game = _state.game,
	          noGameYet = _state.noGameYet,
	          studentLockReason = _state.studentLockReason;
	
	
	      var currentRound = this.currentRound;
	      var _props = this.props,
	          location = _props.location,
	          children = _props.children,
	          params = _props.params;
	
	      var isStudent = this.isStudent;
	      var latestFinishedRoundNumber = this.latestFinishedRoundNumber;
	      var appWrapperClassName = location.pathname === "/team-reports" ? "app-wrapper team-reports-wrapper" : "app-wrapper";
	
	      // Recompute team_color on every render instead of trusting the
	      // cached state value. The cached value was set from Teams.
	      // currentTeamColor() at fetchData time; if a later flow (e.g.
	      // Analysis.js writing competition-scoped teams_data) changes the
	      // underlying map, the cache goes stale and the topbar avatar
	      // disagrees with the charts. Reading through Teams.currentTeamColor
	      // every render keeps the topbar in sync with the same localStorage
	      // teams_data the charts read from.
	      var liveTeamColor = _Teams2.default.currentTeamColor() || team_color;
	
	      if (loaded === false) {
	        return _react2.default.createElement(
	          "div",
	          { className: "application-loading" },
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        );
	      }
	      if (location.pathname === "/login") {
	        return _react2.default.createElement(_loginPage2.default, { location: location });
	      }
	
	      if (location.pathname === "/welcome") {
	        return _react2.default.createElement(_welcomePage2.default, null);
	      }
	
	      if (location.pathname === "/register") {
	        return _react2.default.createElement(_registerPage2.default, null);
	      }
	
	      if (location.pathname === "/join") {
	        return _react2.default.createElement(_joinPage2.default, null);
	      }
	
	      if (location.pathname === "/reset-password") {
	        return _react2.default.createElement(_resetPasswordPage2.default, null);
	      }
	
	      if (location.pathname === "/forms") {
	        return _react2.default.createElement(_index2.default, { userId: this.state.userId });
	      }
	
	      if (location.pathname === "/promo-code") {
	        return _react2.default.createElement(_promoCode2.default, null);
	      }
	
	      var pathes = location.pathname.split("/").filter(function (i) {
	        return i !== "";
	      });
	      if (pathes.length === 2 && pathes[0] === "verify") {
	        var token = params.token;
	
	        return _react2.default.createElement(_accountVerify2.default, { token: token });
	      }
	
	      if (pathes.length === 3 && pathes[0] === "reset-password") {
	        var token1 = params.token1,
	            token2 = params.token2;
	
	        return _react2.default.createElement(_resetPassword2.default, { token1: token1, token2: token2 });
	      }
	
	      // Full-screen takeovers with no app chrome (no leftbar, no
	      // dashboard header). Instructor first-login onboarding is a
	      // guided flow that owns the entire viewport; /demo is the
	      // placeholder landing for the Demo path.
	      if (location.pathname.indexOf('/instructor/onboarding') === 0 || location.pathname === '/demo') {
	        return children;
	      }
	
	      var fullname = first_name + " " + last_name;
	
	      return _react2.default.createElement(
	        "div",
	        { id: "outer-container" },
	        _react2.default.createElement(_contactSupport2.default, null),
	        isStudent === true && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_sweetalertReact2.default, {
	            show: this.isRound1NotStarted,
	            title: "Round 1 has not started yet!",
	            text: this.round1StartText,
	            confirmButtonText: "Logout",
	            onConfirm: this.logout
	          }),
	          _react2.default.createElement(_sweetalertReact2.default, {
	            show: this.rolesIsEmpty,
	            type: "warning",
	            title: "Warning",
	            text: "This user has not any role. Please add specific role for this user.",
	            confirmButtonText: "Logout",
	            onConfirm: this.logout
	          }),
	          _react2.default.createElement(_roundProcessing2.default, {
	            isRoundProcessing: this.isRoundProcessing,
	            round: this.state.current_round,
	            courseMemberId: this.state.courseMemberId,
	            viewedResults: this.state.viewedResults
	          })
	        ),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: errorAlert,
	          title: "Warning",
	          text: errorText,
	          type: "warning",
	          onConfirm: this.hideErrorAlert
	        }),
	        submitDecisionsAlert && _react2.default.createElement(_decisions2.default, {
	          title: submitDecisionsType === "success" ? "Submission Successful" : submitDecisionsType === "warning" ? "Submission Successful" : submitDecisionsType === "info" ? "Heads Up!" : "Submission Failed",
	          message: submitDecisionsText,
	          type: submitDecisionsType,
	          size: submitDecisionsSize,
	          onHide: this.hideSubmitDecisionsAlert
	        }),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: showPerformanceFeedbackAlert,
	          title: "Warning",
	          text: "You'll need to review your performance feedback before you will be able to navigate to the next round.",
	          type: "warning",
	          onConfirm: this.hidePerformanceFeedbackAlert
	        }),
	        _react2.default.createElement(_coachingFeedback2.default, {
	          team_color: liveTeamColor,
	          title: coachingFeedbackTitle,
	          message1: coachingFeedbackMessage1,
	          message2: coachingFeedbackMessage2,
	          message3: coachingFeedbackMessage3,
	          onClose: this.coachingFeedbackOnClose,
	          show: coachingFeedbackShow
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "flex" },
	          _react2.default.createElement(_topbar2.default, {
	            isStudent: isStudent,
	            team_color: liveTeamColor,
	            location: location,
	            currentRound: currentRound,
	            roundInUrl: roundInUrl,
	            rounds: rounds,
	            latestFinishedRoundNumber: latestFinishedRoundNumber,
	            isMobile: this.isMobile,
	            activeRound: this.activeRound,
	            name: isStudent ? fullname : last_name ? "Professor " + last_name : username,
	            position: this.state.userPosition,
	            instructorTeams: instructorTeams,
	            isMenuExpanded: isMenuExpanded,
	            setMenuState: this.setMenuState
	          }),
	          _react2.default.createElement(
	            "div",
	            { id: "app-wrapper", className: appWrapperClassName },
	            _react2.default.createElement(_leftbar2.default, {
	              latestFinishedRoundNumber: latestFinishedRoundNumber,
	              isStarted: this.isRound1NotStarted,
	              years: { data: rounds },
	              rounds: rounds,
	              currentRound: currentRound,
	              roundInUrl: roundInUrl,
	              gameRound: this.state.game ? this.state.game.round : undefined,
	              location: location,
	              isStudent: isStudent,
	              isRoundsLoaded: this.isRoundsLoaded,
	              closeMobileMenu: this.closeMobileMenu,
	              isMobile: this.isMobile,
	              activeRound: this.activeRound,
	              team_name: this.state.team_name,
	              position: this.state.userPosition,
	              instructorRounds: instructorRounds,
	              isMenuExpanded: isMenuExpanded,
	              isPerformanceFeedbackVisible: isPerformanceFeedbackVisible,
	              noGameYet: noGameYet
	            }),
	            location.pathname === "/team-reports" && this.isMobile === false && _react2.default.createElement(_left2.default, null),
	            isStudent === true && _react2.default.Children.map(children, function (child) {
	              return _react2.default.cloneElement(child, {
	                rounds: rounds,
	                rounds_loaded: _this3.state.rounds_loaded,
	                // Raw `game.round` field from the backend. Null after a
	                // game reset (before rounds are provisioned). We can't
	                // use `current_round` here because App falls back to
	                // "round with number=1" when game.round is null (see
	                // ~line 478), which masks the reset state. Consumers
	                // gate on `gameRound == null` to lock decision pages.
	                gameRound: _this3.state.game ? _this3.state.game.round : undefined,
	                currentRound: currentRound,
	                roundInUrl: roundInUrl,
	                team_color: liveTeamColor,
	                tourMode: tourMode,
	                roundShouldBeFinished: roundShouldBeFinished,
	                noGameYet: noGameYet,
	                studentLockReason: studentLockReason
	              });
	            }),
	            isStudent === false && _react2.default.Children.map(children, function (child) {
	              return _react2.default.cloneElement(child, {
	                rounds: instructorRounds,
	                currentRound: currentRound,
	                roundInUrl: roundInUrl,
	                isMenuExpanded: isMenuExpanded,
	                game: game,
	                teams: instructorTeams,
	                courses: instructorCourses,
	                games: instructorGames,
	                teamplayers: instructorTeamplayers,
	                courseMembers: courseMembers,
	                sectionTeamsCount: sectionTeamsCount
	              });
	            }),
	            isStudent === true && _react2.default.createElement(_teamProfilePage2.default, null),
	            isStudent === true && !noGameYet && !showPaymentsPopup && _react2.default.createElement(_StudentBadgesFlow2.default, null),
	            isStudent === true && !noGameYet && !showPaymentsPopup && this.state.viewedResults && this.state.courseMemberId && _react2.default.createElement(_StudentResultsNotifications2.default, {
	              viewedResults: this.state.viewedResults,
	              courseMemberId: this.state.courseMemberId,
	              currentRound: currentRound,
	              rounds: this.state.rounds,
	              suppress: this.isRoundProcessing
	            }),
	            isStudent === true && (showPaymentsPopup === true || pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'success' || pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'cancel') && _react2.default.createElement(_popup2.default, {
	              isSuccess: pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'success',
	              isCancel: pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'cancel'
	            })
	          ),
	          location.pathname !== "/team-reports"
	        ),
	        _react2.default.createElement(_autologout2.default, null),
	        _react2.default.createElement(_analyticsSend2.default, null)
	      );
	    }
	  }, {
	    key: "latestFinishedRoundNumber",
	    get: function get() {
	      var rounds = this.state.rounds;
	
	      var latestFinishedRound = this.latestFinishedRound(rounds);
	
	      return latestFinishedRound ? latestFinishedRound.number : 0;
	    }
	  }, {
	    key: "isStudent",
	    get: function get() {
	      return _Auth2.default.getPosition() === "Student" ? true : false;
	    }
	  }, {
	    key: "currentRound",
	    get: function get() {
	      var current_round = this.state.current_round;
	
	
	      if (!current_round) {
	        return 1;
	      }
	
	      return current_round.number;
	    }
	  }, {
	    key: "isRoundsEmpty",
	    get: function get() {
	      var _state2 = this.state,
	          rounds = _state2.rounds,
	          rounds_loaded = _state2.rounds_loaded;
	
	
	      return rounds_loaded === true && rounds.length < MIN_ROUNDS;
	    }
	  }, {
	    key: "isRound1NotStarted",
	    get: function get() {
	      var _state3 = this.state,
	          current_round = _state3.current_round,
	          rounds_loaded = _state3.rounds_loaded;
	
	      var game_id = _Auth2.default.getGameId();
	
	      return this.isRoundsEmpty === false && current_round && current_round.is_started === false && this.rolesIsEmpty === false && current_round.number === 1 && rounds_loaded === true || this.isRoundsEmpty === false && this.rolesIsEmpty === false && game_id === 0 && rounds_loaded === true;
	    }
	  }, {
	    key: "isRoundsLoaded",
	    get: function get() {
	      var rounds_loaded = this.state.rounds_loaded;
	
	
	      return this.isRoundsEmpty === false && rounds_loaded === true && this.isRound1NotStarted === false;
	    }
	  }, {
	    key: "rolesIsEmpty",
	    get: function get() {
	      var role = _Auth2.default.getRole();
	
	      if (role !== "CEO" && role !== "PD" && role !== "PM" && role !== "OP" && role !== "FI" && role !== "VI") {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "isRoundProcessing",
	    get: function get() {
	      var _state4 = this.state,
	          current_round = _state4.current_round,
	          roundShouldBeFinished = _state4.roundShouldBeFinished;
	
	      var game_id = _Auth2.default.getGameId();
	
	      return roundShouldBeFinished === true && current_round && current_round.is_finished === false && game_id !== 0;
	    }
	  }, {
	    key: "round1StartText",
	    get: function get() {
	      var current_round = this.state.current_round;
	
	
	      if (!current_round) {
	        return "";
	      }
	
	      var timezone = _jstz2.default.determine();
	      var startDate = (0, _momentTimezone2.default)(current_round.start_date).tz(timezone.name()).format("MM/DD/YYYY hh:mmA");
	      return "Round 1 starts " + startDate;
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var roundInUrl = this.state.roundInUrl;
	
	      var currentRound = this.currentRound;
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return roundInUrl;
	      }
	
	      return currentRound;
	    }
	  }]);
	
	  return App;
	}(_react.PureComponent);
	
	exports.default = (0, _reactEasyState.view)(App);

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Formula = function Formula(_ref) {
	  var children = _ref.children,
	      _ref$sm = _ref.sm,
	      sm = _ref$sm === undefined ? false : _ref$sm;
	  return _react2.default.createElement(
	    _Text2.default,
	    { style: (0, _styles.formulaStyle)(sm) },
	    children
	  );
	};
	
	exports.default = Formula;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  justify-content: center;\n  margin-top: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.75);\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  justify-content: center;\n  margin-top: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.75);\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: ", ";\n"], ["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Shared team-color legend for team-reports bar charts. Renders one
	// row of colored dots + "Team {name}" entries so students can map bar
	// colors back to teams. Same palette resolution as the chart itself:
	// prefers explicit customColors, else Teams.competitiveColors(teams).
	var LegendRow = _styledComponents2.default.div(_templateObject);
	
	var LegendItem = _styledComponents2.default.span(_templateObject2);
	
	var LegendDot = _styledComponents2.default.span(_templateObject3, function (p) {
	  return p.color;
	});
	
	var TeamLegend = function TeamLegend(_ref) {
	  var teams = _ref.teams,
	      _ref$customColors = _ref.customColors,
	      customColors = _ref$customColors === undefined ? null : _ref$customColors;
	
	  if (!teams || teams.length === 0) return null;
	  var colors = customColors || _Teams2.default.competitiveColors(teams);
	  if (!colors || colors.length === 0) return null;
	  return _react2.default.createElement(
	    LegendRow,
	    null,
	    teams.map(function (team, i) {
	      return _react2.default.createElement(
	        LegendItem,
	        { key: team.id || i },
	        _react2.default.createElement(LegendDot, { color: colors[i % colors.length] }),
	        "Team ",
	        team.name
	      );
	    })
	  );
	};
	
	exports.default = TeamLegend;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = function Title(_ref) {
	  var style = _ref.style,
	      children = _ref.children;
	  return _react2.default.createElement(
	    "p",
	    { style: Object.assign({}, _styles.panelHeaderStyle, style) },
	    children
	  );
	};
	
	exports.default = Title;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paperStyle = function paperStyle(style) {
	  return Object.assign({
	    backgroundColor: "#fff",
	    padding: "2em",
	    boxShadow: "0 4px 8px rgba(0, 0, 0, .15)",
	    fontFamily: "Lato",
	    maxHeight: "calc(100vh - 10em)",
	    overflowY: "auto"
	  }, style);
	};
	
	var Paper = function Paper(_ref) {
	  var style = _ref.style,
	      children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { style: paperStyle(style) },
	    children
	  );
	};
	
	exports.default = Paper;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderLabel(props) {
	  var percent = (props.percent * 100).toFixed(0);
	
	  return _react2.default.createElement(
	    _recharts.Text,
	    Object.assign({}, props, {
	      alignmentBaseline: "middle",
	      className: "recharts-pie-label-text"
	    }),
	    percent + "%"
	  );
	}
	
	function formatMillions(val) {
	  var valStr = (val / 1000000).toFixed(2);
	  return valStr + "M";
	}
	
	function MarketCaptureChart(props) {
	  var colors = _Teams2.default.competitiveColors();
	  var unmetDemand = props.totalDemand;
	  var data = props.data.map(function (item) {
	    var team = item.team,
	        value = item.value;
	
	    unmetDemand -= value;
	    return {
	      name: team,
	      value: value
	    };
	  });
	
	  data.push({
	    name: "Unmet Demand",
	    value: unmetDemand
	  });
	
	  var teams_count = data.length - 1;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "donut-chart donut-chart-us" },
	    _react2.default.createElement(
	      _recharts.ResponsiveContainer,
	      { width: "100%", height: 235 },
	      _react2.default.createElement(
	        _recharts.PieChart,
	        null,
	        _react2.default.createElement(
	          _recharts.Pie,
	          {
	            data: data,
	            dataKey: "value",
	            cx: "50%",
	            cy: "50%",
	            innerRadius: 60,
	            outerRadius: 80,
	            fill: "#8884d8",
	            label: renderLabel,
	            labelLine: true
	          },
	          _react2.default.createElement(_recharts.Label, {
	            position: "center",
	            value: "Total Demand: " + formatMillions(props.totalDemand)
	          }),
	          colors.slice(0, teams_count).map(function (color, i) {
	            return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	          }),
	          _react2.default.createElement(_recharts.Cell, { fill: _Teams.UNMET_DEMAND_COLOR })
	        ),
	        _react2.default.createElement(_recharts.Tooltip, { formatter: formatMillions })
	      )
	    )
	  );
	}
	
	exports.default = MarketCaptureChart;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _customLabel = __webpack_require__(213);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AxisLabel = function AxisLabel(_ref) {
	  var axisType = _ref.axisType,
	      x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      stroke = _ref.stroke,
	      children = _ref.children;
	
	  var isVert = axisType === "yAxis";
	  var cx = isVert ? x : x + width / 2;
	  var cy = isVert ? height / 2 + y : y + height + 10;
	  var rot = isVert ? "270 " + cx + " " + cy : 0;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: cx,
	      y: cy,
	      transform: "rotate(" + rot + ")",
	      textAnchor: "middle",
	      stroke: stroke
	    },
	    children
	  );
	};
	
	var PricingChart = function (_PureComponent) {
	  _inherits(PricingChart, _PureComponent);
	
	  function PricingChart() {
	    _classCallCheck(this, PricingChart);
	
	    return _possibleConstructorReturn(this, (PricingChart.__proto__ || Object.getPrototypeOf(PricingChart)).apply(this, arguments));
	  }
	
	  _createClass(PricingChart, [{
	    key: "getColor",
	    value: function getColor(i) {
	      var teams = this.props.teams;
	
	      var baseColors = _Teams2.default.competitiveColors(teams ? teams : null);
	      return baseColors[i % baseColors.length];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          title = _props.title,
	          id = _props.id,
	          hideZero = _props.hideZero;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-center" },
	        _react2.default.createElement(
	          "p",
	          { className: "font-size-10" },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          { id: id, className: "horizontalBar" },
	          _react2.default.createElement(
	            _recharts.BarChart,
	            {
	              layout: "vertical",
	              width: 220,
	              height: 230,
	              data: this.dataValues,
	              margin: this.margin
	            },
	            _react2.default.createElement(_recharts.YAxis, { type: "category", dataKey: "team", tick: false }),
	            _react2.default.createElement(_recharts.XAxis, {
	              type: "number",
	              label: _react2.default.createElement(
	                AxisLabel,
	                {
	                  axisType: "xAxis",
	                  x: 140,
	                  y: 220,
	                  width: 0,
	                  height: 0
	                },
	                "Average unit Price ($)"
	              ),
	              domain: [function (dataMin) {
	                return 0;
	              }, function (dataMax) {
	                return Math.ceil(dataMax * 1.6);
	              }]
	            }),
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(
	              _recharts.Bar,
	              {
	                dataKey: "Average unit Price ($)",
	                barSize: 18,
	                stackId: "a",
	                minPointSize: 5,
	                label: _react2.default.createElement(_customLabel2.default, {
	                  hideZero: hideZero,
	                  prefix: "$",
	                  precision: 2,
	                  suffix: "",
	                  layout: "vertical"
	                })
	              },
	              this.dataValues.map(function (value, i) {
	                return _react2.default.createElement(_recharts.Cell, { key: i, fill: _this2.getColor(i) });
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "dataValues",
	    get: function get() {
	      var data = [];
	
	      this.props.data.forEach(function (item) {
	        var team = item.team,
	            value = item.value;
	
	
	        data.push({
	          team: team,
	          "Average unit Price ($)": value
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "margin",
	    get: function get() {
	      return {
	        top: 20,
	        left: 0,
	        right: 0,
	        bottom: 0
	      };
	    }
	  }]);
	
	  return PricingChart;
	}(_react.PureComponent);
	
	exports.default = PricingChart;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _customLabel = __webpack_require__(213);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AxisLabel = function AxisLabel(_ref) {
	  var axisType = _ref.axisType,
	      x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      stroke = _ref.stroke,
	      children = _ref.children;
	
	  var isVert = axisType === "yAxis";
	  var cx = isVert ? x : x + width / 2;
	  var cy = isVert ? height / 2 + y : y + height + 10;
	  var rot = isVert ? "270 0 0" : 0;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: cx,
	      y: cy,
	      transform: "rotate(" + rot + ")",
	      textAnchor: "middle",
	      stroke: stroke
	    },
	    children
	  );
	};
	
	var ProductCostsChart = function (_PureComponent) {
	  _inherits(ProductCostsChart, _PureComponent);
	
	  function ProductCostsChart() {
	    _classCallCheck(this, ProductCostsChart);
	
	    return _possibleConstructorReturn(this, (ProductCostsChart.__proto__ || Object.getPrototypeOf(ProductCostsChart)).apply(this, arguments));
	  }
	
	  _createClass(ProductCostsChart, [{
	    key: "getColor",
	    value: function getColor(i) {
	      var baseColors = _Teams2.default.competitiveColors();
	      return baseColors[i % baseColors.length];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-center" },
	        _react2.default.createElement(
	          "div",
	          { id: "chartHorizontalBarProductCosts", className: "horizontalBar" },
	          _react2.default.createElement(
	            _recharts.BarChart,
	            {
	              layout: "vertical",
	              width: 220,
	              height: 230,
	              data: this.dataValues,
	              margin: this.margin
	            },
	            _react2.default.createElement(_recharts.YAxis, {
	              type: "category",
	              dataKey: "team",
	              label: _react2.default.createElement(
	                AxisLabel,
	                { axisType: "yAxis", x: -110, y: 40, height: 0 },
	                "Team"
	              ),
	              tick: false
	            }),
	            _react2.default.createElement(_recharts.XAxis, {
	              type: "number",
	              label: _react2.default.createElement(
	                AxisLabel,
	                {
	                  axisType: "xAxis",
	                  x: 140,
	                  y: 220,
	                  width: 0,
	                  height: 0
	                },
	                "Average unit Costs ($)"
	              ),
	              domain: [function (dataMin) {
	                return 0;
	              }, function (dataMax) {
	                return Math.ceil(dataMax * 1.6);
	              }]
	            }),
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(
	              _recharts.Bar,
	              {
	                dataKey: "Average unit Costs ($)",
	                barSize: 18,
	                stackId: "a",
	                minPointSize: 5,
	                label: _react2.default.createElement(_customLabel2.default, {
	                  precision: 2,
	                  prefix: "$",
	                  suffix: "",
	                  layout: "vertical"
	                })
	              },
	              this.dataValues.map(function (value, i) {
	                return _react2.default.createElement(_recharts.Cell, { key: i, fill: _this2.getColor(i) });
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "dataValues",
	    get: function get() {
	      var data = [];
	
	      this.props.data.forEach(function (item) {
	        var team = item.team,
	            value = item.value;
	
	
	        data.push({
	          team: team,
	          "Average unit Costs ($)": value
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "margin",
	    get: function get() {
	      return {
	        top: 20,
	        left: 0,
	        right: 0,
	        bottom: 0
	      };
	    }
	  }]);
	
	  return ProductCostsChart;
	}(_react.PureComponent);
	
	exports.default = ProductCostsChart;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OPEN_CONTACT_SUPPORT_EVENT = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  border: none;\n  background: #52C5CD;\n  color: #ffffff;\n  font-family: ', ';\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n  z-index: 1400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(82, 197, 205, 0.35), 0 6px 16px rgba(0, 0, 0, 0.2);\n  }\n'], ['\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  border: none;\n  background: #52C5CD;\n  color: #ffffff;\n  font-family: ', ';\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n  z-index: 1400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(82, 197, 205, 0.35), 0 6px 16px rgba(0, 0, 0, 0.2);\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  padding: 32px 36px;\n  font-family: ', ';\n'], ['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  padding: 32px 36px;\n  font-family: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n'], ['\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n'], ['\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: none;\n  font-family: ', ';\n  font-size: 24px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.55);\n  cursor: pointer;\n  padding: 0 4px;\n\n  &:hover { color: rgba(0, 27, 59, 0.85); }\n'], ['\n  background: transparent;\n  border: none;\n  font-family: ', ';\n  font-size: 24px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.55);\n  cursor: pointer;\n  padding: 0 4px;\n\n  &:hover { color: rgba(0, 27, 59, 0.85); }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.72);\n  margin: 0 0 8px;\n'], ['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.72);\n  margin: 0 0 8px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.55);\n  margin: 0 0 20px;\n'], ['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.55);\n  margin: 0 0 20px;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  margin-bottom: 16px;\n'], ['\n  margin-bottom: 16px;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  display: block;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 6px;\n'], ['\n  display: block;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 6px;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['', ''], ['', '']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  ', '\n  resize: vertical;\n  min-height: 140px;\n'], ['\n  ', '\n  resize: vertical;\n  min-height: 140px;\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 4px;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 4px;\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 20px;\n  color: ', ';\n'], ['\n  font-size: 16px;\n  line-height: 20px;\n  color: ', ';\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  margin-top: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  color: #c74234;\n'], ['\n  margin-top: 6px;\n  font-size: 16px;\n  line-height: 20px;\n  color: #c74234;\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  margin: 8px 0 16px;\n  padding: 10px 12px;\n  background: #fdecea;\n  border: 1px solid rgba(199, 66, 52, 0.35);\n  border-radius: 6px;\n  font-size: 16px;\n  line-height: 22px;\n  color: #7a2a20;\n'], ['\n  margin: 8px 0 16px;\n  padding: 10px 12px;\n  background: #fdecea;\n  border: 1px solid rgba(199, 66, 52, 0.35);\n  border-radius: 6px;\n  font-size: 16px;\n  line-height: 22px;\n  color: #7a2a20;\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 12px;\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: 1.5px solid rgba(0, 27, 59, 0.2);\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: ', ';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.85);\n  cursor: pointer;\n\n  &:hover { background: rgba(0, 27, 59, 0.04); }\n  &:disabled { opacity: 0.5; cursor: default; }\n'], ['\n  background: transparent;\n  border: 1.5px solid rgba(0, 27, 59, 0.2);\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: ', ';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.85);\n  cursor: pointer;\n\n  &:hover { background: rgba(0, 27, 59, 0.04); }\n  &:disabled { opacity: 0.5; cursor: default; }\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  background: #52C5CD;\n  border: 1.5px solid #52C5CD;\n  border-radius: 4px;\n  padding: 8px 22px;\n  font-family: ', ';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #3faab1; border-color: #3faab1; }\n  &:disabled { background: #a7dde2; border-color: #a7dde2; cursor: default; }\n'], ['\n  background: #52C5CD;\n  border: 1.5px solid #52C5CD;\n  border-radius: 4px;\n  padding: 8px 22px;\n  font-family: ', ';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #3faab1; border-color: #3faab1; }\n  &:disabled { background: #a7dde2; border-color: #a7dde2; cursor: default; }\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n'], ['\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  padding: 8px 4px 4px;\n  animation: ', ' 180ms ease-out;\n'], ['\n  padding: 8px 4px 4px;\n  animation: ', ' 180ms ease-out;\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 6px;\n'], ['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 6px;\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.72);\n  margin: 0 0 20px;\n'], ['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.72);\n  margin: 0 0 20px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _ContactSupport = __webpack_require__(1076);
	
	var _NewMGLogoIcon = __webpack_require__(557);
	
	var _NewMGLogoIcon2 = _interopRequireDefault(_NewMGLogoIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Event fired by any entry point (FAB, user-menu item) to open the
	// support modal. Handled by ContactSupport below.
	var OPEN_CONTACT_SUPPORT_EVENT = exports.OPEN_CONTACT_SUPPORT_EVENT = 'open-contact-support';
	
	var SUBJECT_MAX = 200;
	var MESSAGE_MAX = 500;
	var MESSAGE_COUNTER_WARN = 475;
	
	var FONT = "'Mukta Vaani', sans-serif";
	
	// Bottom-right floating help button. z-index chosen to sit above
	// the leftbar (default z-index) but below the modal itself so that
	// opening the modal covers the button with the backdrop.
	var Fab = _styledComponents2.default.button(_templateObject, FONT);
	
	var Backdrop = _styledComponents2.default.div(_templateObject2);
	
	var Card = _styledComponents2.default.div(_templateObject3, FONT);
	
	var HeaderRow = _styledComponents2.default.div(_templateObject4);
	
	var TitleGroup = _styledComponents2.default.div(_templateObject5);
	
	var LogoIcon = _styledComponents2.default.img(_templateObject6);
	
	var Title = _styledComponents2.default.h2(_templateObject7);
	
	var CloseButton = _styledComponents2.default.button(_templateObject8, FONT);
	
	var Subtitle = _styledComponents2.default.p(_templateObject9);
	
	var IntroNote = _styledComponents2.default.p(_templateObject10);
	
	var FieldGroup = _styledComponents2.default.div(_templateObject11);
	
	var Label = _styledComponents2.default.label(_templateObject12);
	
	var inputStyles = '\n  width: 100%;\n  border: 1px solid rgba(0, 27, 59, 0.2);\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  font-family: \'Mukta Vaani\', sans-serif;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n    border-color: #52C5CD;\n    box-shadow: 0 0 0 3px rgba(82, 197, 205, 0.18);\n  }\n\n  &:disabled {\n    background: #f6f7f9;\n    color: rgba(0, 27, 59, 0.55);\n    cursor: not-allowed;\n  }\n';
	
	var Input = _styledComponents2.default.input(_templateObject13, inputStyles);
	
	var Textarea = _styledComponents2.default.textarea(_templateObject14, inputStyles);
	
	var CounterRow = _styledComponents2.default.div(_templateObject15);
	
	var Counter = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.warn ? '#c74234' : 'rgba(0, 27, 59, 0.55)';
	});
	
	var FieldError = _styledComponents2.default.div(_templateObject17);
	
	var FormError = _styledComponents2.default.div(_templateObject18);
	
	var ButtonRow = _styledComponents2.default.div(_templateObject19);
	
	var CancelButton = _styledComponents2.default.button(_templateObject20, FONT);
	
	var SubmitButton = _styledComponents2.default.button(_templateObject21, FONT);
	
	var fadeIn = (0, _styledComponents.keyframes)(_templateObject22);
	
	var SuccessBox = _styledComponents2.default.div(_templateObject23, fadeIn);
	
	var SuccessTitle = _styledComponents2.default.div(_templateObject24);
	
	var SuccessBody = _styledComponents2.default.p(_templateObject25);
	
	var ContactSupport = function (_PureComponent) {
	  _inherits(ContactSupport, _PureComponent);
	
	  function ContactSupport() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactSupport);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactSupport.__proto__ || Object.getPrototypeOf(ContactSupport)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false,
	      subject: '',
	      message: '',
	      submitting: false,
	      sent: false,
	      fieldErrors: null, // { subject?: string, message?: string }
	      formError: null // string
	    }, _this.isMounted_ = false, _this.handleOpen = function () {
	      // Reset on every open so a prior success/error state doesn't
	      // linger; keep subject/message empty by default (users rarely
	      // want to resend the same message).
	      _this.setState({
	        open: true,
	        subject: '',
	        message: '',
	        submitting: false,
	        sent: false,
	        fieldErrors: null,
	        formError: null
	      });
	    }, _this.handleClose = function () {
	      if (_this.state.submitting) return; // don't close mid-flight
	      _this.setState({ open: false });
	    }, _this.handleKeydown = function (e) {
	      if (e.key === 'Escape' && _this.state.open && !_this.state.submitting) {
	        _this.setState({ open: false });
	      }
	    }, _this.handleSubjectChange = function (e) {
	      var v = e.target.value.slice(0, SUBJECT_MAX);
	      _this.setState({ subject: v, fieldErrors: null });
	    }, _this.handleMessageChange = function (e) {
	      var v = e.target.value.slice(0, MESSAGE_MAX);
	      _this.setState({ message: v, fieldErrors: null });
	    }, _this.buildPayload = function () {
	      var _this$state = _this.state,
	          subject = _this$state.subject,
	          message = _this$state.message;
	
	      var url = typeof window !== 'undefined' && window.location ? window.location.href : '';
	      // Auto-append current page URL so support can jump straight to
	      // wherever the user was when they hit trouble. Two blank lines
	      // between the message body and the appended context keeps it
	      // visually separated in the email BE forwards.
	      var messageWithContext = url ? message.trim() + '\n\n---\nPage: ' + url : message.trim();
	      return {
	        subject: subject.trim(),
	        message: messageWithContext
	      };
	    }, _this.handleSubmit = function (e) {
	      if (e && e.preventDefault) e.preventDefault();
	      var _this$state2 = _this.state,
	          subject = _this$state2.subject,
	          message = _this$state2.message,
	          submitting = _this$state2.submitting;
	
	      if (submitting) return;
	      // Client-side required-field validation. Server also validates,
	      // but catching it here saves a round-trip on the obvious cases.
	      var trimmedSubject = subject.trim();
	      var trimmedMessage = message.trim();
	      var fieldErrors = {};
	      if (!trimmedSubject) fieldErrors.subject = 'Subject is required.';
	      if (!trimmedMessage) fieldErrors.message = 'Message is required.';
	      if (Object.keys(fieldErrors).length > 0) {
	        _this.setState({ fieldErrors: fieldErrors, formError: null });
	        return;
	      }
	
	      _this.setState({ submitting: true, fieldErrors: null, formError: null });
	      (0, _ContactSupport.submitSupportMessage)(_this.buildPayload()).then(function () {
	        if (!_this.isMounted_) return;
	        _this.setState({ submitting: false, sent: true });
	      }).catch(function (err) {
	        if (!_this.isMounted_) return;
	        _this.handleError(err);
	      });
	    }, _this.handleError = function (err) {
	      var status = err && err.status;
	      var body = err && err.response && err.response.body;
	      if (status === 400 && body && (typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object') {
	        var fieldErrors = {};
	        if (Array.isArray(body.subject) && body.subject.length > 0) {
	          fieldErrors.subject = body.subject[0];
	        }
	        if (Array.isArray(body.message) && body.message.length > 0) {
	          fieldErrors.message = body.message[0];
	        }
	        _this.setState({
	          submitting: false,
	          fieldErrors: Object.keys(fieldErrors).length > 0 ? fieldErrors : null,
	          formError: Object.keys(fieldErrors).length > 0 ? null : 'Please check the form and try again.'
	        });
	        return;
	      }
	      if (status === 429) {
	        _this.setState({
	          submitting: false,
	          formError: "You've sent a lot of messages recently. Please try again in about an hour."
	        });
	        return;
	      }
	      if (status === 401) {
	        // Fall through — App-level auth handling will pick up the 401
	        // on the next request. Show a message so the user isn't left
	        // wondering; the form contents are preserved by not clearing
	        // state.
	        _this.setState({
	          submitting: false,
	          formError: 'Your session expired. Please log in again and retry.'
	        });
	        return;
	      }
	      _this.setState({
	        submitting: false,
	        formError: 'Something went wrong. Please try again.'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ContactSupport, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isMounted_ = true;
	      _eventEmitter2.default.getInstance().on(OPEN_CONTACT_SUPPORT_EVENT, this.handleOpen);
	      document.addEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isMounted_ = false;
	      _eventEmitter2.default.getInstance().off(OPEN_CONTACT_SUPPORT_EVENT, this.handleOpen);
	      document.removeEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var _state = this.state,
	          subject = _state.subject,
	          message = _state.message,
	          submitting = _state.submitting,
	          fieldErrors = _state.fieldErrors,
	          formError = _state.formError;
	
	      var messageWarn = message.length >= MESSAGE_COUNTER_WARN;
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: this.handleSubmit, noValidate: true },
	        _react2.default.createElement(
	          Subtitle,
	          null,
	          'Send us a note and support will reach out by email.'
	        ),
	        _react2.default.createElement(
	          IntroNote,
	          null,
	          'For screenshots or attachments, email support@marketgames.io directly.'
	        ),
	        formError && _react2.default.createElement(
	          FormError,
	          null,
	          formError
	        ),
	        _react2.default.createElement(
	          FieldGroup,
	          null,
	          _react2.default.createElement(
	            Label,
	            { htmlFor: 'contact-support-subject' },
	            'Subject'
	          ),
	          _react2.default.createElement(Input, {
	            id: 'contact-support-subject',
	            type: 'text',
	            value: subject,
	            onChange: this.handleSubjectChange,
	            disabled: submitting,
	            maxLength: SUBJECT_MAX,
	            autoFocus: true
	          }),
	          fieldErrors && fieldErrors.subject && _react2.default.createElement(
	            FieldError,
	            null,
	            fieldErrors.subject
	          )
	        ),
	        _react2.default.createElement(
	          FieldGroup,
	          null,
	          _react2.default.createElement(
	            Label,
	            { htmlFor: 'contact-support-message' },
	            'Message'
	          ),
	          _react2.default.createElement(Textarea, {
	            id: 'contact-support-message',
	            value: message,
	            onChange: this.handleMessageChange,
	            disabled: submitting,
	            maxLength: MESSAGE_MAX
	          }),
	          _react2.default.createElement(
	            CounterRow,
	            null,
	            _react2.default.createElement(
	              Counter,
	              { warn: messageWarn },
	              message.length,
	              ' / ',
	              MESSAGE_MAX
	            )
	          ),
	          fieldErrors && fieldErrors.message && _react2.default.createElement(
	            FieldError,
	            null,
	            fieldErrors.message
	          )
	        ),
	        _react2.default.createElement(
	          ButtonRow,
	          null,
	          _react2.default.createElement(
	            CancelButton,
	            { type: 'button', onClick: this.handleClose, disabled: submitting },
	            'Cancel'
	          ),
	          _react2.default.createElement(
	            SubmitButton,
	            { type: 'submit', disabled: submitting },
	            submitting ? 'Sending…' : 'Send Message'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSuccess',
	    value: function renderSuccess() {
	      return _react2.default.createElement(
	        SuccessBox,
	        null,
	        _react2.default.createElement(
	          SuccessTitle,
	          null,
	          'Message sent'
	        ),
	        _react2.default.createElement(
	          SuccessBody,
	          null,
	          'Thanks for reaching out. Support will reach out to you by email soon.'
	        ),
	        _react2.default.createElement(
	          ButtonRow,
	          null,
	          _react2.default.createElement(
	            SubmitButton,
	            { type: 'button', onClick: this.handleClose },
	            'Done'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          open = _state2.open,
	          sent = _state2.sent;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          Fab,
	          {
	            type: 'button',
	            'aria-label': 'Contact support',
	            title: 'Contact support',
	            onClick: this.handleOpen
	          },
	          '?'
	        ),
	        open && _react2.default.createElement(
	          Backdrop,
	          { onClick: this.handleClose },
	          _react2.default.createElement(
	            Card,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              HeaderRow,
	              null,
	              _react2.default.createElement(
	                TitleGroup,
	                null,
	                _react2.default.createElement(LogoIcon, { src: _NewMGLogoIcon2.default, alt: '' }),
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  'Contact Market Games Support'
	                )
	              ),
	              _react2.default.createElement(
	                CloseButton,
	                {
	                  type: 'button',
	                  'aria-label': 'Close',
	                  onClick: this.handleClose
	                },
	                '\xD7'
	              )
	            ),
	            sent ? this.renderSuccess() : this.renderForm()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ContactSupport;
	}(_react.PureComponent);
	
	exports.default = ContactSupport;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "grey");
	
	function DebtButton(props) {
	  var onClick = props.onClick;
	
	
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    {
	      className: "btn-fn-decisions-button",
	      bsStyle: "primary",
	      onClick: onClick
	    },
	    "Debt"
	  );
	}
	
	exports.default = DebtButton;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "grey");
	
	function EquityButton(props) {
	  var onClick = props.onClick,
	      disabled = props.disabled;
	
	
	  var style = disabled === true ? "grey" : "primary";
	
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    {
	      className: "btn-fn-decisions-button ml-20",
	      bsStyle: style,
	      onClick: onClick,
	      disabled: disabled
	    },
	    "Equity"
	  );
	}
	
	exports.default = EquityButton;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VarianceAnalysisWidget = function (_PureComponent) {
	  _inherits(VarianceAnalysisWidget, _PureComponent);
	
	  function VarianceAnalysisWidget(props) {
	    _classCallCheck(this, VarianceAnalysisWidget);
	
	    var _this = _possibleConstructorReturn(this, (VarianceAnalysisWidget.__proto__ || Object.getPrototypeOf(VarianceAnalysisWidget)).call(this, props));
	
	    _this.expandTotalCostOfSales = function () {
	      _this.setState({
	        totalCostOfSalesExpanded: true
	      });
	    };
	
	    _this.collapseTotalCostOfSales = function () {
	      _this.setState({
	        totalCostOfSalesExpanded: false
	      });
	    };
	
	    _this.expandTotalRevenues = function () {
	      _this.setState({
	        totalRevenuesExpanded: true
	      });
	    };
	
	    _this.collapseTotalRevenues = function () {
	      _this.setState({
	        totalRevenuesExpanded: false
	      });
	    };
	
	    _this.expandGrossProfits = function () {
	      _this.setState({
	        grossProfitsExpanded: true
	      });
	    };
	
	    _this.collapseGrossProfits = function () {
	      _this.setState({
	        grossProfitsExpanded: false
	      });
	    };
	
	    _this.expandNetProfits = function () {
	      _this.setState({
	        netProfitsExpanded: true
	      });
	    };
	
	    _this.collapseNetProfits = function () {
	      _this.setState({
	        netProfitsExpanded: false
	      });
	    };
	
	    _this.state = {
	      totalRevenuesExpanded: true,
	      totalCostOfSalesExpanded: true,
	      grossProfitsExpanded: true,
	      netProfitsExpanded: true
	    };
	    return _this;
	  }
	
	  _createClass(VarianceAnalysisWidget, [{
	    key: "getActualYearParam",
	    value: function getActualYearParam(key) {
	      var _props = this.props,
	          actual = _props.actual,
	          current_year = _props.current_year;
	
	
	      if (current_year in actual) {
	        var obj = actual[current_year];
	        if (key in obj) {
	          return obj[key];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getExpectedYearParam",
	    value: function getExpectedYearParam(key) {
	      var _props2 = this.props,
	          expected = _props2.expected,
	          current_year = _props2.current_year;
	
	
	      if (current_year in expected) {
	        var obj = expected[current_year];
	        if (key in obj) {
	          return obj[key];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getDiffYearParam",
	    value: function getDiffYearParam(key, before, after) {
	      before = before || this.getExpectedYearParam(key);
	      after = after || this.getActualYearParam(key);
	
	      if (before === 0 || after === 0) {
	        return 0;
	      }
	
	      var percent = (after - before) / Math.abs(before) * 100;
	
	      return percent.toFixed(2);
	    }
	
	    /**
	     * Expected values
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var current_year = this.props.current_year;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white-full team-reports-with-scroll" },
	        _react2.default.createElement(
	          "h5",
	          { className: "title-sky-blue" },
	          "VARIANCE ANALYSIS"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "table-responsive team-reports-hide-scroll" },
	          _react2.default.createElement(
	            "table",
	            { className: "table border-analysis mb-20" },
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  { className: "table-title text-center" },
	                  _react2.default.createElement("span", null)
	                ),
	                _react2.default.createElement(
	                  "th",
	                  { className: "table-title text-center title-sky-blue" },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "YEAR ",
	                    current_year
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "block" },
	                    "(CURRENT YEAR)"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement("th", { className: "sub-title title-sky-blue" }),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Expected"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Actual"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "Diff"
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "sub-title title-sky-blue" },
	                  "Revenues"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalRevenuesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Units"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalRevenuesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Average Selling Price"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgSellingPrice,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgSellingPrice,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgSellingPrice,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Revenues"
	                  ),
	                  this.state.totalRevenuesExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandTotalRevenues
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseTotalRevenues
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalRevenues,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalRevenues,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalRevenues,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "sub-title title-sky-blue" },
	                  "Cost of Sales"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalCostOfSalesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Units"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalCostOfSalesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Average Unit Costs"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgUnitCosts,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgUnitCosts,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgUnitCosts,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Cost of Sales"
	                  ),
	                  this.state.totalCostOfSalesExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandTotalCostOfSales
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseTotalCostOfSales
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalCostOfSales,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalCostOfSales,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalCostOfSales,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Gross Profits"
	                  ),
	                  this.state.grossProfitsExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandGrossProfits
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseGrossProfits
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedGrossProfits,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualGrossProfits,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffGrossProfits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.netProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Other Expenses"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedOperatingExpenses,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualOperatingExpenses,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffOperatingExpenses,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.netProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Income Before Taxes"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalIncomeBeforeTaxes,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalIncomeBeforeTaxes,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalIncomeBeforeTaxes,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Net Profits"
	                  ),
	                  this.state.netProfitsExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandNetProfits
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseNetProfits
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedNetProfits,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualNetProfits,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffNetProfits,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "expectedUnits",
	    get: function get() {
	      return Math.abs(this.getExpectedYearParam("units_sold"));
	    }
	  }, {
	    key: "expectedAvgSellingPrice",
	    get: function get() {
	      return this.getExpectedYearParam("average_selling_price");
	    }
	  }, {
	    key: "expectedTotalRevenues",
	    get: function get() {
	      return this.getExpectedYearParam("total_revenues");
	    }
	  }, {
	    key: "expectedAvgUnitCosts",
	    get: function get() {
	      return this.getExpectedYearParam("average_unit_costs");
	    }
	  }, {
	    key: "expectedTotalCostOfSales",
	    get: function get() {
	      return this.getExpectedYearParam("total_cost_goods_sold");
	    }
	  }, {
	    key: "expectedGrossProfits",
	    get: function get() {
	      return this.getExpectedYearParam("gross_profits");
	    }
	  }, {
	    key: "expectedOperatingExpenses",
	    get: function get() {
	      return this.getExpectedYearParam("total_operating_costs") + this.getExpectedYearParam("total_non_operating_costs");
	    }
	  }, {
	    key: "expectedNonOperatingExpenses",
	    get: function get() {
	      return this.getExpectedYearParam("total_non_operating_costs");
	    }
	  }, {
	    key: "expectedTotalIncomeBeforeTaxes",
	    get: function get() {
	      return this.getExpectedYearParam("income_before_taxes");
	    }
	  }, {
	    key: "expectedNetProfits",
	    get: function get() {
	      return this.getExpectedYearParam("net_income");
	    }
	
	    /**
	     * Actual values
	     */
	
	  }, {
	    key: "actualUnits",
	    get: function get() {
	      return Math.abs(this.getActualYearParam("units_sold"));
	    }
	  }, {
	    key: "actualAvgSellingPrice",
	    get: function get() {
	      return this.getActualYearParam("average_selling_price");
	    }
	  }, {
	    key: "actualTotalRevenues",
	    get: function get() {
	      return this.getActualYearParam("total_revenues");
	    }
	  }, {
	    key: "actualAvgUnitCosts",
	    get: function get() {
	      return this.getActualYearParam("average_unit_costs");
	    }
	  }, {
	    key: "actualTotalCostOfSales",
	    get: function get() {
	      return this.getActualYearParam("total_cost_goods_sold");
	    }
	  }, {
	    key: "actualGrossProfits",
	    get: function get() {
	      return this.getActualYearParam("gross_profits");
	    }
	  }, {
	    key: "actualOperatingExpenses",
	    get: function get() {
	      return this.getActualYearParam("total_operating_costs") + this.getActualYearParam("total_non_operating_costs");
	    }
	  }, {
	    key: "actualNonOperatingExpenses",
	    get: function get() {
	      return this.getActualYearParam("total_non_operating_costs");
	    }
	  }, {
	    key: "actualTotalIncomeBeforeTaxes",
	    get: function get() {
	      return this.getActualYearParam("income_before_taxes");
	    }
	  }, {
	    key: "actualNetProfits",
	    get: function get() {
	      return this.getActualYearParam("net_income");
	    }
	
	    /**
	     * Diff values
	     */
	
	  }, {
	    key: "diffUnits",
	    get: function get() {
	      return this.getDiffYearParam(null, null, this.expectedUnits, this.actualUnits);
	    }
	  }, {
	    key: "diffAvgSellingPrice",
	    get: function get() {
	      return this.getDiffYearParam("average_selling_price");
	    }
	  }, {
	    key: "diffTotalRevenues",
	    get: function get() {
	      return this.getDiffYearParam("total_revenues");
	    }
	  }, {
	    key: "diffAvgUnitCosts",
	    get: function get() {
	      return -1 * this.getDiffYearParam("average_unit_costs");
	    }
	  }, {
	    key: "diffTotalCostOfSales",
	    get: function get() {
	      return this.getDiffYearParam("total_cost_goods_sold");
	    }
	  }, {
	    key: "diffGrossProfits",
	    get: function get() {
	      return this.getDiffYearParam("gross_profits");
	    }
	  }, {
	    key: "diffOperatingExpenses",
	    get: function get() {
	      return this.getDiffYearParam(null, null, this.expectedOperatingExpenses, this.actualOperatingExpenses);
	    }
	  }, {
	    key: "diffNonOperatingExpenses",
	    get: function get() {
	      return this.getDiffYearParam("total_non_operating_costs");
	    }
	  }, {
	    key: "diffTotalIncomeBeforeTaxes",
	    get: function get() {
	      return this.getDiffYearParam("income_before_taxes");
	    }
	  }, {
	    key: "diffNetProfits",
	    get: function get() {
	      return this.getDiffYearParam("net_income");
	    }
	  }]);
	
	  return VarianceAnalysisWidget;
	}(_react.PureComponent);
	
	exports.default = VarianceAnalysisWidget;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Step5 = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactCustomScrollbars = __webpack_require__(955);
	
	var _radium = __webpack_require__(2079);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _reactAnimations = __webpack_require__(2141);
	
	var _recompose = __webpack_require__(55);
	
	var _lodash = __webpack_require__(21);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fadeInStyle = {
	  animation: "x 1s",
	  animationName: _radium2.default.keyframes(_reactAnimations.fadeIn, "fadeIn")
	};
	
	var renderTeamPlayer = function renderTeamPlayer(_ref) {
	  var id = _ref.id,
	      name = _ref.name,
	      role = _ref.role,
	      user = _ref.user;
	
	  var roleStrings = {
	    CEO: "CEO",
	    PD: "Head of Product Management",
	    PM: "Head of Product Marketing",
	    OP: "Head of Operations",
	    FI: "Head of Finance",
	    VI: "Viewer"
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { key: id, className: "playerBlock" },
	    _react2.default.createElement("div", { className: "playerBlock__circle" }),
	    _react2.default.createElement(
	      "div",
	      null,
	      user ? _react2.default.createElement(
	        "p",
	        { className: "playerBlock__name" },
	        user.first_name,
	        " ",
	        user.last_name
	      ) : _react2.default.createElement(
	        "p",
	        { className: "playerBlock__name" },
	        "Unassigned"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "playerBlock__role" },
	        roleStrings[role]
	      )
	    )
	  );
	};
	
	var renderTeamMembers = function renderTeamMembers() {
	  return _react2.default.createElement(
	    "div",
	    { className: "step5__right" },
	    (0, _lodash.flatten)((0, _lodash.map)((0, _lodash.partition)(_Teams2.default.players().filter(function (player) {
	      return player.role !== "VI";
	    }), function (player) {
	      return !(0, _lodash.isNil)(player.user);
	    }), function (list) {
	      return (0, _lodash.map)(list, renderTeamPlayer);
	    }))
	  );
	};
	
	var Step1 = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    _radium.StyleRoot,
	    null,
	    _react2.default.createElement(
	      "p",
	      { className: "steps__text", style: fadeInStyle },
	      "Market Games is a team based business competition"
	    )
	  );
	});
	
	var Step2 = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    _radium.StyleRoot,
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "step2", style: fadeInStyle },
	      _react2.default.createElement(
	        "p",
	        { className: "steps__text" },
	        "1. The Goal"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "steps__text" },
	        "2. Your Role"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "steps__text" },
	        "3. Your Team"
	      )
	    )
	  );
	});
	
	var Step3 = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "step3" },
	    _react2.default.createElement(
	      "p",
	      { className: "steps__text", style: fadeInStyle },
	      "Your goal is to capture more market share and profits than your competitors and your grades are determined by how your team performs on key metrics relative to your competitors."
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "steps__text" },
	      "For more information on grading, please review our grading guidelines."
	    )
	  );
	});
	
	var Step4 = (0, _recompose.pure)(function (_ref2) {
	  var getRoleDescription = _ref2.getRoleDescription;
	  return _react2.default.createElement(
	    _radium.StyleRoot,
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "step4", style: fadeInStyle },
	      getRoleDescription()
	    )
	  );
	});
	
	var Step5 = exports.Step5 = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "step5", style: fadeInStyle },
	    _react2.default.createElement(
	      "div",
	      { className: "step5__left" },
	      _react2.default.createElement(
	        "p",
	        { className: "steps__text" },
	        "You will be working closely with your team to make decisions throughout the course of this game."
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "steps__text" },
	        "Be sure to check in with your team when making decisions."
	      )
	    ),
	    renderTeamMembers()
	  );
	});
	
	var GetStartedModal = function (_PureComponent) {
	  _inherits(GetStartedModal, _PureComponent);
	
	  function GetStartedModal(props) {
	    _classCallCheck(this, GetStartedModal);
	
	    var _this = _possibleConstructorReturn(this, (GetStartedModal.__proto__ || Object.getPrototypeOf(GetStartedModal)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      show: true,
	      step: 1
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(GetStartedModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("open-get-started-modal", this.show);
	      this.eventemitter.on("open-guide-after-role", this.showAfterRole);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("open-get-started-modal", this.show);
	      this.eventemitter.off("open-guide-after-role", this.showAfterRole);
	    }
	  }, {
	    key: "getFullName",
	    value: function getFullName() {
	      var _Auth$getUser = _Auth2.default.getUser(),
	          first_name = _Auth$getUser.first_name,
	          last_name = _Auth$getUser.last_name;
	
	      return first_name + " " + last_name;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          show = _state.show,
	          step = _state.step;
	      var _props = this.props,
	          team_color = _props.team_color,
	          className = _props.className;
	
	      var captionStyle = { color: team_color };
	      var scrollBarsSettings = {
	        style: {
	          height: "calc(100% - 60px)"
	        },
	        renderThumbVertical: this.renderThumbVertical
	      };
	      var nextOnLastStep = this.props.nextOnLastStep || false;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          onHide: this.hide,
	          dialogClassName: className + " feedback-modal",
	          backdrop: "static",
	          backdropClassName: "feedback-backdrop"
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _reactCustomScrollbars.Scrollbars,
	            scrollBarsSettings,
	            _react2.default.createElement(
	              "div",
	              { className: "steps", style: captionStyle },
	              _react2.default.createElement("div", { className: "steps__icon" }),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "p",
	                  {
	                    className: step === 1 ? "steps__title steps__title_one" : "steps__title"
	                  },
	                  this.getHeaderText()
	                ),
	                {
	                  1: _react2.default.createElement(Step1, null),
	                  2: _react2.default.createElement(Step2, null),
	                  3: _react2.default.createElement(Step3, null),
	                  4: _react2.default.createElement(Step4, { getRoleDescription: this.getRoleDescription }),
	                  5: _react2.default.createElement(Step5, null)
	                }[step] || null
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "feedback-button" },
	            step > 1 && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                className: "backBtn",
	                bsSize: this.isMobile === true ? "md" : "lg",
	                onClick: this.prev
	              },
	              "Back"
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: "primary",
	                bsSize: this.isMobile === true ? "md" : "lg",
	                onClick: this.next
	              },
	              step === 5 && !nextOnLastStep ? "Close" : "Continue",
	              _react2.default.createElement("span", null)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "currentRole",
	    get: function get() {
	      var activeRound = this.props.activeRound;
	
	      var role = _Auth2.default.getRole(activeRound).toLowerCase();
	
	      if (role === "ceo") {
	        return "CEO";
	      } else if (role === "pd") {
	        return "Product Development";
	      } else if (role === "pm") {
	        return "Product Marketing";
	      } else if (role === "op") {
	        return "Operations";
	      } else if (role === "fi") {
	        return "Finance";
	      }
	
	      return "";
	    }
	  }]);
	
	  return GetStartedModal;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.show = function () {
	    _this2.setState({
	      show: true,
	      step: 1
	    });
	  };
	
	  this.hide = function () {
	    _this2.props.onFinish();
	  };
	
	  this.showAfterRole = function () {
	    _this2.setState({
	      show: true,
	      step: 4
	    });
	  };
	
	  this.showRole = function (e) {
	    e.preventDefault();
	    _this2.setState({
	      show: false
	    }, function () {
	      _this2.eventemitter.trigger("open-from-guide");
	    });
	  };
	
	  this.getRoleRaw = function () {
	    return _Auth2.default.getRole(_this2.props.activeRound);
	  };
	
	  this.prev = function () {
	    var step = _this2.state.step;
	
	
	    if (step > 1) {
	      _this2.setState({
	        step: step - 1
	      });
	    }
	  };
	
	  this.next = function () {
	    var step = _this2.state.step;
	
	
	    if (step < 5) {
	      _this2.setState({
	        step: step + 1
	      });
	    } else {
	      (0, _utils.setGetStartedShown)().then(function () {
	        _this2.props.onFinish();
	      });
	    }
	  };
	
	  this.renderThumbVertical = function (_ref3) {
	    var style = _ref3.style,
	        props = _objectWithoutProperties(_ref3, ["style"]);
	
	    var _props$team_color = _this2.props.team_color,
	        team_color = _props$team_color === undefined ? "#fff" : _props$team_color;
	
	
	    return _react2.default.createElement("div", Object.assign({}, props, {
	      style: Object.assign({}, style, {
	        backgroundColor: (0, _utils.hexToRgba)(team_color, 0.6),
	        borderRadius: "5px"
	      }),
	      className: "thumb-vertical"
	    }));
	  };
	
	  this.getHeaderText = function () {
	    var step = _this2.state.step;
	
	
	    switch (step) {
	      case 1:
	        return "Welcome to Market Games, " + _this2.getFullName() + "!";
	      case 2:
	        return "This tutorial is going to cover everything you need to know to get you started";
	      case 3:
	        return "The Goal";
	      case 4:
	        return "Your Role: " + _this2.currentRole;
	      case 5:
	        return "Your Team: " + _Teams2.default.currentTeam().name;
	      case 6:
	        return "How to navigate and play the game";
	      case 7:
	        return "How to make decisions";
	      default:
	        return "Resources to help make decisions";
	    }
	  };
	
	  this.getRoleDescription = function () {
	    return {
	      CEO: _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "Your role is to work with your management team to develop and execute a strategy that will help your business achieves its goals. Your key responsibilities are:"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Make Financial Projections"
	          ),
	          " \u2014 You have to translate your strategy into financial goals in order to raise capital. Therefore, you have to make a 3 year financial projection."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Lead Team"
	          ),
	          " \u2014 Ensure team decisions are sound and submitted."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "Note: Your role changes each year."
	        )
	      ),
	      PD: _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "You are the core of the business. You build products that drive revenues and ultimately profits. Your key responsibility is to develop product strategies and product designs that customers will demand now and into the future."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "Note: Your role changes each year."
	        )
	      ),
	      PM: _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "You know the customer better than any other department in your organization. Therefore you know how to reach them and their willingness to pay. Your key responsibilities are:"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Price & Forecast"
	          ),
	          " \u2014 You set the price for your business's products."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Promotion"
	          ),
	          " \u2014 You decide on the channel(s) to market your business's products and the budget to spend."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Sales"
	          ),
	          " \u2014 You decide on the channel to sell your products."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "Note: Your role changes each year."
	        )
	      ),
	      OP: _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "You are critical to your business because you drive efficiency. Your role is to build quality products at the lowest costs."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Decide the Facility"
	          ),
	          " \u2014 you have to decide if you want to produce in-house or outsource production."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Decide on the machines"
	          ),
	          " \u2014 you have to decide on the machine(s) that you will use to produce the products."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Decide on the # of units to produce"
	          ),
	          " \u2014 you have to decide on how many units to produce."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "Note: Your role changes each year."
	        )
	      ),
	      FI: _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "You provide the fuel that drives growth. Your key responsibilities are:"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Raising Capital"
	          ),
	          " \u2014 You have to decide how much capital does your business need and the form of capital (i.e. debt and/or equity)."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Managing Capital"
	          ),
	          " \u2014 You have to periodically assess how effective the business has been in using capital by performing various financial analysis."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "Returning Capital"
	          ),
	          " \u2014 You have to decide when and how much capital should be returned to investors."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "steps__text" },
	          "Note: Your role changes each year."
	        )
	      ),
	      VI: _react2.default.createElement(
	        "div",
	        null,
	        "Viewer"
	      )
	    }[_this2.getRoleRaw()] || _react2.default.createElement("div", null);
	  };
	};
	
	exports.default = GetStartedModal;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 0;\n  height: 0;\n  position: relative;\n  overflow: visible;\n  z-index: 1200;\n\n  ', '\n\n  ', '\n'], ['\n  width: 0;\n  height: 0;\n  position: relative;\n  overflow: visible;\n  z-index: 1200;\n\n  ', '\n\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  & > div {\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    &:after {\n      content: \'\';\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  ', '\n'], ['\n  & > div {\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    &:after {\n      content: \'\';\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _range = __webpack_require__(487);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(1220);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FORCE = 0.5; // 0-1 roughly the vertical force at which particles initially explode
	var SIZE = 12; // max height for particle rectangles, diameter for particle circles
	var FLOOR_HEIGHT = 800; // pixels the particles will fall from initial explosion point
	var FLOOR_WIDTH = 1600; // horizontal spread of particles in pixels
	var PARTICLE_COUNT = 150;
	var DURATION = 3500;
	var COLORS = ['#FFC700', '#FF0000', '#2E3191', '#41BBC7'];
	
	var createParticles = function createParticles(count, colors) {
	  var increment = 360 / count;
	  return (0, _range2.default)(count).map(function (index) {
	    return {
	      color: colors[index % colors.length],
	      degree: increment * index
	    };
	  });
	};
	
	var Container = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.rotations && p.rotations.map(function (rotation) {
	    return '\n    @keyframes ' + rotation[0] + ' {\n      to {\n        transform: ' + rotation[1].transform + ';\n      }\n    }\n  ';
	  });
	}, function (p) {
	  return p.keyframes && p.keyframes.map(function (keyframe) {
	    return '\n    @keyframes ' + keyframe[0] + ' {\n      to {\n        transform: ' + keyframe[1].transform + ';\n      }\n    }\n  ';
	  });
	});
	
	var Particle = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.motions && p.motions.map(function (motion) {
	    return '\n    ' + motion[0] + ' {\n      animation: ' + motion[1].animation + ';\n\n      & > div {\n        width: ' + motion[1]['& > div']['width'] + 'px;\n        height: ' + motion[1]['& > div']['height'] + 'px;\n        animation: ' + motion[1]['& > div']['animation'] + ';\n\n        &:after {\n          animation: ' + motion[1]['& > div']['&:after']['animation'] + ';\n          background-color: ' + motion[1]['& > div']['&:after']['backgroundColor'] + ';\n          border-radius: ' + (motion[1]['& > div']['&:after']['borderRadius'] || 0) + ';\n        }\n      }\n    }\n  ';
	  });
	});
	
	function ConfettiExplosion(_ref) {
	  var _ref$particleCount = _ref.particleCount,
	      particleCount = _ref$particleCount === undefined ? PARTICLE_COUNT : _ref$particleCount,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === undefined ? DURATION : _ref$duration,
	      _ref$colors = _ref.colors,
	      colors = _ref$colors === undefined ? COLORS : _ref$colors,
	      _ref$particleSize = _ref.particleSize,
	      particleSize = _ref$particleSize === undefined ? SIZE : _ref$particleSize,
	      _ref$force = _ref.force,
	      force = _ref$force === undefined ? FORCE : _ref$force,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? FLOOR_HEIGHT : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? FLOOR_WIDTH : _ref$width,
	      floorHeight = _ref.floorHeight,
	      floorWidth = _ref.floorWidth;
	
	  var particles = createParticles(particleCount, colors);
	  var classes = (0, _styles2.default)({
	    particles: particles,
	    duration: duration,
	    particleSize: particleSize,
	    force: force,
	    width: floorWidth || width,
	    height: floorHeight || height
	  });
	
	  var particlesAnimation = Object.entries(classes.particle);
	
	  return React.createElement(
	    Container,
	    {
	      rotations: Object.entries(classes.rotation),
	      keyframes: Object.entries(classes.keyframes)
	    },
	    particles.map(function (particle, i) {
	      return React.createElement(
	        Particle,
	        {
	          id: 'confetti-particle-' + i,
	          key: particle.degree,
	          motions: particlesAnimation
	        },
	        React.createElement('div', null)
	      );
	    })
	  );
	}
	
	exports.default = ConfettiExplosion;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 24px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Page404 = function (_PureComponent) {
	  _inherits(Page404, _PureComponent);
	
	  function Page404(props) {
	    _classCallCheck(this, Page404);
	
	    var _this = _possibleConstructorReturn(this, (Page404.__proto__ || Object.getPrototypeOf(Page404)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Page404, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.setMode) {
	        this.props.setMode('basic');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          '404 Not Found'
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          'The current page does not exist.'
	        )
	      );
	    }
	  }]);
	
	  return Page404;
	}(_react.PureComponent);
	
	exports.default = Page404;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 80px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 40px;\n  width: calc(100% - 130px);\n'], ['\n  height: 80px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 40px;\n  width: calc(100% - 130px);\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  img {\n    margin-right: 5px;\n  }\n\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgba(0, 27, 59, 0.6);\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ', '\n'], ['\n  img {\n    margin-right: 5px;\n  }\n\n  &:active,\n  &:visited,\n  &:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgba(0, 27, 59, 0.6);\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  &:active, &:visited, &:link {\n    width: 160px;\n    height: 40px;\n    background: #5c91f5;\n    border-radius: 4px;\n    text-align: center;\n    line-height: 40px;\n\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n\n    ', '\n\n    ', '\n\n    ', '\n  }\n\n  &:hover {\n    text-decoration: none;\n\n    ', '\n\n    ', '\n  }\n'], ['\n  &:active, &:visited, &:link {\n    width: 160px;\n    height: 40px;\n    background: #5c91f5;\n    border-radius: 4px;\n    text-align: center;\n    line-height: 40px;\n\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n\n    ', '\n\n    ', '\n\n    ', '\n  }\n\n  &:hover {\n    text-decoration: none;\n\n    ', '\n\n    ', '\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingChevron = __webpack_require__(252);
	
	var _onboardingChevron2 = _interopRequireDefault(_onboardingChevron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PrevButton = _styledComponents2.default.a(_templateObject2, function (p) {
	  return p.isHidden && '\n    visibility: hidden;\n  ';
	});
	
	var Text = _styledComponents2.default.div(_templateObject3);
	
	var NextButton = _styledComponents2.default.a(_templateObject4, function (p) {
	  return !p.isDisabled && !p.isLoadingMode && '\n      transition: background-color .4s ease-in-out;\n    ';
	}, function (p) {
	  return (p.isDisabled || p.isLoadingMode) && '\n      pointer-events: none;\n      color: rgba(0, 27, 59, 0.38);\n      background: rgba(0, 27, 59, 0.08);\n    ';
	}, function (p) {
	  return p.isValidationMode && '\n      color: #ffffff;\n      background: #ec5e59;\n    ';
	}, function (p) {
	  return !p.isDisabled && !p.isValidationMode && !p.isLoadingMode && '\n      background-color: #74a1f6;\n    ';
	}, function (p) {
	  return p.isValidationMode && '\n      background-color: #ef7672;\n    ';
	});
	
	var getNextTitle = function getNextTitle(isLastStep, isNextDisabled, isValidationMode, isLoadingMode) {
	  if (isLastStep) {
	    return 'Close';
	  }
	
	  if (isLoadingMode) {
	    return 'Submitting...';
	  }
	
	  if (isNextDisabled || isValidationMode) {
	    return 'Submit';
	  }
	
	  return 'Next';
	};
	
	var Pagination = function Pagination(_ref) {
	  var currentStep = _ref.currentStep,
	      countOfSteps = _ref.countOfSteps,
	      goNext = _ref.goNext,
	      goPrev = _ref.goPrev,
	      onValidate = _ref.onValidate,
	      isFirstStep = _ref.isFirstStep,
	      isLastStep = _ref.isLastStep,
	      isNextDisabled = _ref.isNextDisabled,
	      isValidationMode = _ref.isValidationMode,
	      isLoadingMode = _ref.isLoadingMode,
	      isTriviaPage = _ref.isTriviaPage;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      PrevButton,
	      { href: '#', onClick: goPrev, isHidden: isFirstStep || isTriviaPage },
	      _react2.default.createElement('img', { src: _onboardingChevron2.default, alt: '' }),
	      'Previous'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      currentStep,
	      '/',
	      countOfSteps
	    ),
	    _react2.default.createElement(
	      NextButton,
	      {
	        href: '#',
	        onClick: isValidationMode ? onValidate : goNext,
	        isDisabled: isNextDisabled,
	        isValidationMode: isValidationMode,
	        isLoadingMode: isLoadingMode
	      },
	      getNextTitle(isLastStep, isNextDisabled, isValidationMode, isLoadingMode)
	    )
	  );
	};
	
	exports.default = Pagination;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ROLE_INTRO_DISMISSED_EVENT = exports.isRoleIntroDismissed = exports.roleIntroStorageKey = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n'], ['\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n'], ['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #FAFBFD;\n  min-height: 100%;\n  margin: 0 -40px -40px;\n  padding: 64px 32px 24px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  color: #0F172A;\n'], ['\n  background: #FAFBFD;\n  min-height: 100%;\n  margin: 0 -40px -40px;\n  padding: 64px 32px 24px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  color: #0F172A;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  max-width: 760px;\n  margin: 0 auto 16px;\n  text-align: center;\n'], ['\n  max-width: 760px;\n  margin: 0 auto 16px;\n  text-align: center;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin: 0 0 14px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  color: #0F172A;\n'], ['\n  margin: 0 0 14px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  color: #0F172A;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 0 0 14px;\n  font-size: 16px;\n  color: #475569;\n  line-height: 1.4;\n'], ['\n  margin: 0 0 14px;\n  font-size: 16px;\n  color: #475569;\n  line-height: 1.4;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 96px;\n  height: 4px;\n  margin: 0 auto;\n  background: #E2E8F0;\n  border-radius: 999px;\n  overflow: hidden;\n'], ['\n  width: 96px;\n  height: 4px;\n  margin: 0 auto;\n  background: #E2E8F0;\n  border-radius: 999px;\n  overflow: hidden;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  height: 100%;\n  background: #10B981;\n  border-radius: 999px;\n  width: ', '%;\n  transition: width 400ms ease;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  height: 100%;\n  background: #10B981;\n  border-radius: 999px;\n  width: ', '%;\n  transition: width 400ms ease;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  max-width: 720px;\n  margin: 40px auto 0;\n  padding: 44px 40px 40px;\n  background: #FFFFFF;\n  border: 1px solid #E2E8F0;\n  border-radius: 20px;\n  text-align: center;\n  animation: ', ' 400ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  max-width: 720px;\n  margin: 40px auto 0;\n  padding: 44px 40px 40px;\n  background: #FFFFFF;\n  border: 1px solid #E2E8F0;\n  border-radius: 20px;\n  text-align: center;\n  animation: ', ' 400ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  margin: 0 0 28px;\n  font-size: 18px;\n  color: #475569;\n  line-height: 1.5;\n'], ['\n  margin: 0 0 28px;\n  font-size: 18px;\n  color: #475569;\n  line-height: 1.5;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  display: inline-block;\n  padding: 10px 22px;\n  margin: 0 0 24px;\n  background: #EFF6FF;\n  border: 2px solid #2563EB;\n  border-radius: 999px;\n  color: #2563EB;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 20px;\n  letter-spacing: 0.3px;\n'], ['\n  display: inline-block;\n  padding: 10px 22px;\n  margin: 0 0 24px;\n  background: #EFF6FF;\n  border: 2px solid #2563EB;\n  border-radius: 999px;\n  color: #2563EB;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 20px;\n  letter-spacing: 0.3px;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  margin: 0 auto 32px;\n  max-width: 560px;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #0F172A;\n'], ['\n  margin: 0 auto 32px;\n  max-width: 560px;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #0F172A;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 28px;\n  border: 0;\n  border-radius: 10px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background 200ms ease;\n\n  &:hover {\n    background: #1D4ED8;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 28px;\n  border: 0;\n  border-radius: 10px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background 200ms ease;\n\n  &:hover {\n    background: #1D4ED8;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 1180px;\n'], ['\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 1180px;\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 18px;\n  padding: 10px 14px 10px 6px;\n  margin-bottom: 12px;\n  border-radius: 14px;\n  background: transparent;\n  transition: background 200ms ease;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    left: 25px;\n    width: 2px;\n    top: 0;\n    /* Extend 12px past the step\'s bottom edge so the connector\n       bridges the inter-step margin gap. The last step overrides\n       this so the line still stops at circle 3\'s center. */\n    bottom: -12px;\n    background: #E2E8F0;\n    z-index: 0;\n  }\n\n  &:first-child::before {\n    top: 30px;\n  }\n\n  &:last-child::before {\n    bottom: auto;\n    height: 30px;\n  }\n\n  ', '\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 18px;\n  padding: 10px 14px 10px 6px;\n  margin-bottom: 12px;\n  border-radius: 14px;\n  background: transparent;\n  transition: background 200ms ease;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    left: 25px;\n    width: 2px;\n    top: 0;\n    /* Extend 12px past the step\'s bottom edge so the connector\n       bridges the inter-step margin gap. The last step overrides\n       this so the line still stops at circle 3\'s center. */\n    bottom: -12px;\n    background: #E2E8F0;\n    z-index: 0;\n  }\n\n  &:first-child::before {\n    top: 30px;\n  }\n\n  &:last-child::before {\n    bottom: auto;\n    height: 30px;\n  }\n\n  ', '\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n    background: #DBEAFE;\n  '], ['\n    background: #DBEAFE;\n  ']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  ', '\n  cursor: pointer;\n\n  ', '\n\n  ', '\n'], ['\n  ', '\n  cursor: pointer;\n\n  ', '\n\n  ', '\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n    background: #10B981;\n    border-color: #10B981;\n    color: #FFFFFF;\n  '], ['\n    background: #10B981;\n    border-color: #10B981;\n    color: #FFFFFF;\n  ']),
	    _templateObject19 = _taggedTemplateLiteral(['\n    background: #EFF6FF;\n    border-color: #2563EB;\n    color: #2563EB;\n  '], ['\n    background: #EFF6FF;\n    border-color: #2563EB;\n    color: #2563EB;\n  ']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  padding-top: 2px;\n'], ['\n  padding-top: 2px;\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 8px;\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n'], ['\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 8px;\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  min-width: 0;\n'], ['\n  flex: 1 1 auto;\n  min-width: 0;\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  color: #64748B;\n  font-size: 14px;\n  line-height: 1;\n  transition: color 150ms ease;\n\n  ', ':hover & {\n    color: #0F172A;\n  }\n'], ['\n  flex: 0 0 auto;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  color: #64748B;\n  font-size: 14px;\n  line-height: 1;\n  transition: color 150ms ease;\n\n  ', ':hover & {\n    color: #0F172A;\n  }\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  margin-left: 10px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n  letter-spacing: 0;\n'], ['\n  margin-left: 10px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n  letter-spacing: 0;\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0F172A;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0F172A;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n    color: #94A3B8;\n    text-decoration: line-through;\n    text-decoration-color: #CBD5E1;\n  '], ['\n    color: #94A3B8;\n    text-decoration: line-through;\n    text-decoration-color: #CBD5E1;\n  ']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  margin: 0 0 6px;\n  font-size: 16px;\n  line-height: 1.45;\n  color: #475569;\n  max-width: 900px;\n'], ['\n  margin: 0 0 6px;\n  font-size: 16px;\n  line-height: 1.45;\n  color: #475569;\n  max-width: 900px;\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: #2563EB;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n'], ['\n  background: transparent;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: #2563EB;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  display: inline-block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n'], ['\n  display: inline-block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n']),
	    _templateObject31 = _taggedTemplateLiteral(['\n  margin-top: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 4px;\n'], ['\n  margin-top: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 4px;\n']),
	    _templateObject32 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 150ms ease;\n\n  & + & {\n    border-top: 1px solid #E2E8F0;\n  }\n\n  &:hover {\n    background: #FFFFFF;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: -2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 150ms ease;\n\n  & + & {\n    border-top: 1px solid #E2E8F0;\n  }\n\n  &:hover {\n    background: #FFFFFF;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: -2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject33 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  border: 2px solid #CBD5E1;\n  border-radius: 5px;\n  background: #FFFFFF;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  transition: background 200ms ease, border-color 200ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  border: 2px solid #CBD5E1;\n  border-radius: 5px;\n  background: #FFFFFF;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  transition: background 200ms ease, border-color 200ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject34 = _taggedTemplateLiteral(['\n    background: #10B981;\n    border-color: #10B981;\n  '], ['\n    background: #10B981;\n    border-color: #10B981;\n  ']),
	    _templateObject35 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n']),
	    _templateObject36 = _taggedTemplateLiteral(['\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject37 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 1.4;\n  color: #475569;\n'], ['\n  font-size: 16px;\n  line-height: 1.4;\n  color: #475569;\n']),
	    _templateObject38 = _taggedTemplateLiteral(['\n  align-self: flex-start;\n  font-size: 16px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n'], ['\n  align-self: flex-start;\n  font-size: 16px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n']),
	    _templateObject39 = _taggedTemplateLiteral(['\n  max-width: 760px;\n  margin: 32px auto 0;\n  padding: 28px 32px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ECFDF5, #D1FAE5);\n  border: 1px solid #A7F3D0;\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 20px;\n  align-items: center;\n  animation: ', ' 500ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  max-width: 760px;\n  margin: 32px auto 0;\n  padding: 28px 32px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ECFDF5, #D1FAE5);\n  border: 1px solid #A7F3D0;\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 20px;\n  align-items: center;\n  animation: ', ' 500ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject40 = _taggedTemplateLiteral(['\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #10B981;\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n'], ['\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #10B981;\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n']),
	    _templateObject41 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #064E3B;\n'], ['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #064E3B;\n']),
	    _templateObject42 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-size: 15px;\n  color: #047857;\n  line-height: 1.5;\n'], ['\n  margin: 0;\n  font-size: 15px;\n  color: #047857;\n  line-height: 1.5;\n']),
	    _templateObject43 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n'], ['\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n']),
	    _templateObject44 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject45 = _taggedTemplateLiteral(['\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 640px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  overflow: hidden;\n'], ['\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 640px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  overflow: hidden;\n']),
	    _templateObject46 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #E2E8F0;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #E2E8F0;\n']),
	    _templateObject47 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n'], ['\n  margin: 0;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n']),
	    _templateObject48 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject49 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n']),
	    _templateObject50 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: #2563EB;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  text-decoration: none;\n\n  &:hover {\n    background: #1D4ED8;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  background: #2563EB;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  text-decoration: none;\n\n  &:hover {\n    background: #1D4ED8;\n  }\n']),
	    _templateObject51 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: 0;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n'], ['\n  background: transparent;\n  border: 0;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n']),
	    _templateObject52 = _taggedTemplateLiteral(['\n  overflow-y: auto;\n  padding: 24px 28px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n'], ['\n  overflow-y: auto;\n  padding: 24px 28px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n']),
	    _templateObject53 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 4px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 4px;\n']),
	    _templateObject54 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n']),
	    _templateObject55 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 0 0 auto;\n'], ['\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 0 0 auto;\n']),
	    _templateObject56 = _taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  height: 44px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 44px;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 0 64px 0 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n'], ['\n  flex: 1 1 auto;\n  height: 44px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 44px;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 0 64px 0 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n']),
	    _templateObject57 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 52px;\n  height: 100%;\n  border: 0;\n  background: #5C91F5;\n  border-radius: 0 8px 8px 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background: #74A1F6;\n  }\n\n  img {\n    width: 18px;\n    height: 18px;\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 52px;\n  height: 100%;\n  border: 0;\n  background: #5C91F5;\n  border-radius: 0 8px 8px 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background: #74A1F6;\n  }\n\n  img {\n    width: 18px;\n    height: 18px;\n  }\n']),
	    _templateObject58 = _taggedTemplateLiteral(['\n  text-align: right;\n  margin-top: 20px;\n'], ['\n  text-align: right;\n  margin-top: 20px;\n']),
	    _templateObject59 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  color: #5C91F5;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  color: #5C91F5;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject60 = _taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #0F172A;\n  color: #ffffff;\n  padding: 10px 18px;\n  border-radius: 999px;\n  font-size: 14px;\n  z-index: 1100;\n  animation: ', ' 150ms ease both;\n'], ['\n  position: fixed;\n  bottom: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #0F172A;\n  color: #ffffff;\n  padding: 10px 18px;\n  border-radius: 999px;\n  font-size: 14px;\n  z-index: 1100;\n  animation: ', ' 150ms ease both;\n']),
	    _templateObject61 = _taggedTemplateLiteral(['\n  padding: 32px 0;\n  text-align: center;\n  color: #64748B;\n'], ['\n  padding: 32px 0;\n  text-align: center;\n  color: #64748B;\n']),
	    _templateObject62 = _taggedTemplateLiteral(['\n  margin: 0 0 16px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n'], ['\n  margin: 0 0 16px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n']),
	    _templateObject63 = _taggedTemplateLiteral(['\n  margin: 0 0 16px;\n  padding: 0 0 0 24px;\n  text-align: left;\n\n  li {\n    font-size: 16px;\n    line-height: 1.55;\n    color: #1F2A44;\n    margin-bottom: 4px;\n  }\n'], ['\n  margin: 0 0 16px;\n  padding: 0 0 0 24px;\n  text-align: left;\n\n  li {\n    font-size: 16px;\n    line-height: 1.55;\n    color: #1F2A44;\n    margin-bottom: 4px;\n  }\n']),
	    _templateObject64 = _taggedTemplateLiteral(['\n  margin: 0 0 24px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n  font-style: italic;\n'], ['\n  margin: 0 0 24px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n  font-style: italic;\n']),
	    _templateObject65 = _taggedTemplateLiteral(['\n  margin: 0 0 24px;\n  padding: 0;\n  text-align: left;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  margin: 0 0 24px;\n  padding: 0;\n  text-align: left;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject66 = _taggedTemplateLiteral(['\n  margin: 0 0 10px;\n  padding: 0;\n  text-align: left;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 17px;\n  font-weight: 800;\n  color: #2563EB;\n'], ['\n  margin: 0 0 10px;\n  padding: 0;\n  text-align: left;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 17px;\n  font-weight: 800;\n  color: #2563EB;\n']),
	    _templateObject67 = _taggedTemplateLiteral(['\n  margin: 0;\n  padding: 0 0 0 24px;\n  text-align: left;\n  list-style: upper-alpha;\n\n  li {\n    margin-bottom: 6px;\n    font-size: 16px;\n    line-height: 1.55;\n    color: #1F2A44;\n  }\n'], ['\n  margin: 0;\n  padding: 0 0 0 24px;\n  text-align: left;\n  list-style: upper-alpha;\n\n  li {\n    margin-bottom: 6px;\n    font-size: 16px;\n    line-height: 1.55;\n    color: #1F2A44;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _onboardingCopy = __webpack_require__(1061);
	
	var _onboardingCopy2 = _interopRequireDefault(_onboardingCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// PDF for download. Served as a static asset from /public/ rather
	// than bundled through webpack (webpack 1.x doesn't have a PDF
	// loader configured). Save the PDF at:
	//   public/team-contract-template.pdf
	// and it will be served at the URL below.
	var TEAM_CONTRACT_PDF_URL = '/team-contract-template.pdf';
	
	// Round 1 onboarding checklist. Single consolidated welcome page
	// at /onboarding/welcome/intro?round=1. Behavior contract:
	//   - 3 visible top-level steps. Conduct Research is parent-only
	//     (auto-completes when all substeps are checked).
	//   - 5 countable items total drive the progress bar + success
	//     banner.
	//   - First incomplete top-level step gets the blue active highlight.
	//   - "(view teammates)" inline opens a popup with the team roster
	//     + copy-email controls.
	//   - "View the team contract template" opens a popup showing the
	//     contract with a Download button.
	//   - Other link destinations route into the existing app pages,
	//     carrying ?round=N forward.
	//
	// Persistence: localStorage, keyed per user + round. Swap for a
	// backend endpoint once one exists.
	
	// ---------- copy ---------------------------------------------------
	
	var COMPLETION_COPY = {
	  icon: '✓',
	  title: "You're ready for the round.",
	  description: 'Great work. Check back here next round for your updated checklist.'
	};
	
	// IDs that count toward the progress bar / success banner.
	// `conduct-research` is parent-only.
	var COUNTABLE_IDS = ['team-outreach', 'review-case-study', 'review-round-goals', 'analyze-customers', 'make-decisions'];
	
	var TOTAL_COUNTABLE = COUNTABLE_IDS.length;
	
	var storageKey = function storageKey() {
	  var uid = _Auth2.default.getUserId();
	  return 'onboarding:checklist:round1:' + (uid || 'anon');
	};
	
	// Role-intro screen: shown BEFORE the checklist on first load so the
	// student sees what role they've been assigned and what they're
	// responsible for this round. Dismissal persists per user + role so
	// the intro doesn't reappear on refresh (but does resurface if the
	// user's role somehow changes).
	var roleIntroStorageKey = exports.roleIntroStorageKey = function roleIntroStorageKey() {
	  var uid = _Auth2.default.getUserId();
	  var role = '';
	  try {
	    role = (_Auth2.default.getRole() || '').toString().toUpperCase();
	  } catch (e) {
	    role = '';
	  }
	  return 'onboarding:role-intro:round1:' + (uid || 'anon') + ':' + (role || 'unknown');
	};
	
	// Read the persisted "has the student clicked through the role-intro
	// screen" flag. Consumed by StudentLeftBar to decide whether to hide
	// non-Welcome nav items while the intro is still on screen.
	var isRoleIntroDismissed = exports.isRoleIntroDismissed = function isRoleIntroDismissed() {
	  try {
	    return window.localStorage.getItem(roleIntroStorageKey()) === '1';
	  } catch (e) {
	    return false;
	  }
	};
	
	// Event name for cross-component notification. Fires when the student
	// clicks Continue on the role-intro screen so consumers like
	// StudentLeftBar can react immediately (their own re-render won't be
	// triggered by localStorage writes alone).
	var ROLE_INTRO_DISMISSED_EVENT = exports.ROLE_INTRO_DISMISSED_EVENT = 'role-intro-dismissed';
	
	// Role → intro copy. Labels match how the user wrote them (simple
	// functional names for students), which are shorter than the display
	// names on join-page.js. Descriptions are paraphrased from the
	// product spec, kept concise and college-student-friendly.
	var ROLE_INTRO_CONTENT = {
	  CEO: {
	    label: 'CEO',
	    description: "You own the big picture. Build the financial projections for investors, and make sure every team decision is made and posted before the deadline. You can also step in to make, modify, or override any teammate's decision."
	  },
	  PD: {
	    label: 'Product',
	    description: 'Your job is to design and launch products customers actually want.'
	  },
	  PM: {
	    label: 'Marketing',
	    description: "Set the product's price, then choose which promotional and sales channels to reach customers, along with how much to invest in each. You can't post decisions until your Product Manager creates a product."
	  },
	  OP: {
	    label: 'Operations',
	    description: 'Manufacture the products, and manage inventory levels and locations to keep supply flowing.'
	  },
	  FI: {
	    label: 'Finance',
	    description: "Manage the company's money. Raise capital from investors to fund product, marketing, and operations decisions, and return capital to investors when the time is right."
	  },
	  FN: {
	    label: 'Finance',
	    description: "Manage the company's money. Raise capital from investors to fund product, marketing, and operations decisions, and return capital to investors when the time is right."
	  }
	};
	
	var getCurrentRoleCode = function getCurrentRoleCode() {
	  try {
	    return (_Auth2.default.getRole() || '').toString().toUpperCase();
	  } catch (e) {
	    return '';
	  }
	};
	
	// Team names are commonly stored as a bare number ("4", "12").
	// Prefix with "Team " unless the name already starts with that
	// word so we don't double-prefix things like "Team Northstar".
	var formatTeamName = function formatTeamName(name) {
	  var str = (name == null ? '' : String(name)).trim();
	  if (!str) return '';
	  return (/^team\s/i.test(str) ? str : 'Team ' + str
	  );
	};
	
	// Auth.getRole() returns one of: ceo, pd, pm, op, fi, fn.
	// Map to the analysis route prefix.
	var getRoleForAnalysisRoute = function getRoleForAnalysisRoute() {
	  var role = '';
	  try {
	    role = (_Auth2.default.getRole() || '').toString().toLowerCase();
	  } catch (e) {
	    role = '';
	  }
	  // `fi` and `fn` both exist in older code paths; analysis routes
	  // are registered as /fn. Normalize.
	  if (role === 'fi') role = 'fn';
	  // Fall back to /ceo if the role isn't set — the page exists for
	  // every role, so any of them works; CEO is the safest default.
	  return role || 'ceo';
	};
	
	// Display label for the user's current role (rotates per round via
	// Auth.getRole()). Matches the labels shown on join-page.js. Returns
	// '' if the role can't be determined so callers can skip rendering.
	var ROLE_DISPLAY_NAMES = {
	  CEO: 'CEO',
	  PD: 'Product Management',
	  PM: 'Product Marketing',
	  OP: 'Operations',
	  FI: 'Finance',
	  FN: 'Finance'
	};
	
	var getRoleDisplayName = function getRoleDisplayName() {
	  var role = '';
	  try {
	    role = (_Auth2.default.getRole() || '').toString().toUpperCase();
	  } catch (e) {
	    role = '';
	  }
	  return ROLE_DISPLAY_NAMES[role] || '';
	};
	
	// ---------- styles -------------------------------------------------
	
	var fadeUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var fadeIn = (0, _styledComponents.keyframes)(_templateObject2);
	
	var Styled = {};
	
	// Tightened from the original design spec so the whole checklist
	// fits one viewport without scrolling. The proportions still match
	// the reference, just compressed across the board.
	// Negative margins are applied on left/right/bottom only — the top
	// stays at 0 so the page title doesn't slip behind the top nav bar.
	Styled.Root = _styledComponents2.default.section(_templateObject3);
	
	Styled.Header = _styledComponents2.default.div(_templateObject4);
	
	Styled.Title = _styledComponents2.default.h1(_templateObject5);
	
	Styled.Subhead = _styledComponents2.default.p(_templateObject6);
	
	Styled.ProgressTrack = _styledComponents2.default.div(_templateObject7);
	
	Styled.ProgressFill = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.pct || 0;
	});
	
	// ---- role intro screen styles ------------------------------------
	
	Styled.IntroCard = _styledComponents2.default.div(_templateObject9, fadeUp);
	
	Styled.IntroSubhead = _styledComponents2.default.p(_templateObject10);
	
	Styled.RoleBadge = _styledComponents2.default.div(_templateObject11);
	
	Styled.IntroDescription = _styledComponents2.default.p(_templateObject12);
	
	Styled.IntroContinueButton = _styledComponents2.default.button(_templateObject13);
	
	Styled.Timeline = _styledComponents2.default.ol(_templateObject14);
	
	/* Each Step draws its own segment of the connector line via a
	   ::before. Math:
	     - Step has padding-top: 10px, circle is 40px → circle spans
	       y=10..50, center at y=30 within the step.
	     - Step has padding-left: 6px, circle is 40px → circle center
	       sits 26px in. Line is 2px wide → left: 25px keeps centered.
	   First step: clipped above its circle (top: 30px).
	   Last step:  clipped at its circle's center (bottom anchored 30px
	                from the step's top).
	   The result is a single visually continuous line that begins at
	   circle 1's center and ends at the last circle's center,
	   regardless of how tall each step is. */
	Styled.Step = _styledComponents2.default.li(_templateObject15, function (p) {
	  return p.active && (0, _styledComponents.css)(_templateObject16);
	});
	
	var stepCircleBase = '\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  background: #FFFFFF;\n  border: 2px solid #E2E8F0;\n  color: #64748B;\n  position: relative;\n  z-index: 1;\n  padding: 0;\n  transition: background 200ms ease, border-color 200ms ease, color 200ms ease;\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n';
	
	Styled.StepCircleButton = _styledComponents2.default.button(_templateObject17, stepCircleBase, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject18);
	}, function (p) {
	  return !p.completed && p.active && (0, _styledComponents.css)(_templateObject19);
	});
	
	Styled.StepCircleStatic = _styledComponents2.default.div(_templateObject20, stepCircleBase, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject18);
	}, function (p) {
	  return !p.completed && p.active && (0, _styledComponents.css)(_templateObject19);
	});
	
	Styled.StepBody = _styledComponents2.default.div(_templateObject21);
	
	// Clickable wrapper around a parent step's title + description that
	// toggles its substeps open/closed. Rendered as div+role=button so it
	// can legally contain the existing <h2> and <p> children (a real
	// <button> can't nest those).
	Styled.StepHeaderToggle = _styledComponents2.default.div(_templateObject22);
	
	Styled.StepHeaderTextGroup = _styledComponents2.default.div(_templateObject23);
	
	// Chevron rendered next to a collapsible step header. Colored/sized to
	// read as a UI affordance without competing with the title text.
	Styled.StepHeaderChevron = _styledComponents2.default.span(_templateObject24, Styled.StepHeaderToggle);
	
	// Small, muted annotation that sits inline next to the step title
	// (used for "est. time" callouts). Lighter weight + smaller size so
	// it reads as metadata rather than part of the title.
	Styled.StepTimeEstimate = _styledComponents2.default.span(_templateObject25);
	
	Styled.StepTitle = _styledComponents2.default.h2(_templateObject26, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject27);
	});
	
	Styled.StepDescription = _styledComponents2.default.p(_templateObject28);
	
	Styled.InlineButton = _styledComponents2.default.button(_templateObject29);
	
	Styled.StepLink = _styledComponents2.default.a(_templateObject30);
	
	Styled.SubstepGroup = _styledComponents2.default.div(_templateObject31);
	
	Styled.SubstepRow = _styledComponents2.default.button(_templateObject32);
	
	Styled.Checkbox = _styledComponents2.default.span(_templateObject33, function (p) {
	  return p.checked && (0, _styledComponents.css)(_templateObject34);
	});
	
	Styled.SubstepBody = _styledComponents2.default.div(_templateObject35);
	
	Styled.SubstepTitle = _styledComponents2.default.span(_templateObject36, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject27);
	});
	
	Styled.SubstepDescription = _styledComponents2.default.span(_templateObject37);
	
	Styled.SubstepLink = _styledComponents2.default.a(_templateObject38);
	
	Styled.CompletionBanner = _styledComponents2.default.div(_templateObject39, fadeUp);
	
	Styled.CompletionIcon = _styledComponents2.default.div(_templateObject40);
	
	Styled.CompletionTitle = _styledComponents2.default.h3(_templateObject41);
	
	Styled.CompletionDescription = _styledComponents2.default.p(_templateObject42);
	
	Styled.SrOnly = _styledComponents2.default.span(_templateObject43);
	
	// ---------- popup shell -------------------------------------------
	
	Styled.Modal = {};
	
	Styled.Modal.Backdrop = _styledComponents2.default.div(_templateObject44, fadeIn);
	
	Styled.Modal.Card = _styledComponents2.default.div(_templateObject45);
	
	Styled.Modal.HeaderBar = _styledComponents2.default.div(_templateObject46);
	
	Styled.Modal.Title = _styledComponents2.default.h2(_templateObject47);
	
	Styled.Modal.TitleStack = _styledComponents2.default.div(_templateObject35);
	
	Styled.Modal.Subtitle = _styledComponents2.default.span(_templateObject48);
	
	Styled.Modal.HeaderActions = _styledComponents2.default.div(_templateObject49);
	
	Styled.Modal.DownloadButton = _styledComponents2.default.a(_templateObject50);
	
	Styled.Modal.CloseButton = _styledComponents2.default.button(_templateObject51);
	
	Styled.Modal.Body = _styledComponents2.default.div(_templateObject52);
	
	// ---------- teammates popup ---------------------------------------
	
	Styled.Roster = _styledComponents2.default.div(_templateObject53);
	
	Styled.RosterRow = _styledComponents2.default.div(_templateObject54);
	
	Styled.RosterName = _styledComponents2.default.div(_templateObject55);
	
	Styled.RosterEmail = _styledComponents2.default.div(_templateObject56);
	
	Styled.RosterCopyButton = _styledComponents2.default.button(_templateObject57);
	
	Styled.CopyAllRow = _styledComponents2.default.div(_templateObject58);
	
	Styled.CopyAllLink = _styledComponents2.default.a(_templateObject59);
	
	Styled.Toast = _styledComponents2.default.div(_templateObject60, fadeIn);
	
	Styled.Empty = _styledComponents2.default.div(_templateObject61);
	
	// ---------- contract popup ----------------------------------------
	
	Styled.ContractIntro = _styledComponents2.default.p(_templateObject62);
	
	Styled.ContractList = _styledComponents2.default.ol(_templateObject63);
	
	Styled.ContractCallout = _styledComponents2.default.p(_templateObject64);
	
	// Sections (Expectations, Team Communication, etc.) left-align
	// with the intro paragraph above. h3 and ol both reset their
	// browser-default left padding/margin; the list gets its own
	// padding-left so the "A.", "B." markers sit inside the visible
	// content area instead of being pushed off into negative space.
	Styled.ContractSection = _styledComponents2.default.section(_templateObject65);
	
	Styled.ContractSectionTitle = _styledComponents2.default.h3(_templateObject66);
	
	Styled.ContractSectionList = _styledComponents2.default.ol(_templateObject67);
	
	// ---------- component ---------------------------------------------
	
	var TEAMMATES_API = ("https://be-production-itb.marketgames.io/api/") + 'v2/games/teamplayers/';
	
	var Round1Checklist = function (_PureComponent) {
	  _inherits(Round1Checklist, _PureComponent);
	
	  function Round1Checklist(props) {
	    _classCallCheck(this, Round1Checklist);
	
	    var _this = _possibleConstructorReturn(this, (Round1Checklist.__proto__ || Object.getPrototypeOf(Round1Checklist)).call(this, props));
	
	    _this.readRoleIntroDismissed = function () {
	      return isRoleIntroDismissed();
	    };
	
	    _this.dismissRoleIntro = function () {
	      try {
	        window.localStorage.setItem(roleIntroStorageKey(), '1');
	      } catch (e) {}
	      // Safe fallback — dismissal still applies in-memory for this
	      // session even if storage is blocked.
	
	      // Notify listeners (StudentLeftBar hides non-Welcome nav until
	      // this fires — that gate lifts as soon as the user clicks
	      // Continue on the role-intro screen).
	      _eventEmitter2.default.getInstance().trigger(ROLE_INTRO_DISMISSED_EVENT);
	      _this.setState({ roleIntroDismissed: true });
	    };
	
	    _this.toggleStepCollapse = function (stepId) {
	      _this.setState(function (prev) {
	        var next = Object.assign({}, prev.collapsedSteps);
	        if (next[stepId]) delete next[stepId];else next[stepId] = true;
	        return { collapsedSteps: next };
	      });
	    };
	
	    _this.isStepCollapsed = function (stepId) {
	      return !!_this.state.collapsedSteps[stepId];
	    };
	
	    _this.handleStepHeaderKeyDown = function (stepId) {
	      return function (e) {
	        if (e.key === 'Enter' || e.key === ' ') {
	          e.preventDefault();
	          _this.toggleStepCollapse(stepId);
	        }
	      };
	    };
	
	    _this.setRootEl = function (el) {
	      _this._rootEl = el;
	    };
	
	    _this.handleKeydown = function (e) {
	      if (e.key !== 'Escape') return;
	      if (_this.state.teammatesPopupOpen || _this.state.contractPopupOpen) {
	        _this.closeAllPopups();
	      }
	    };
	
	    _this.overrideParentBackgrounds = function () {
	      if (typeof window === 'undefined' || !_this._rootEl) return;
	      _this._modifiedNodes = [];
	      var node = _this._rootEl.parentElement;
	      var hops = 0;
	      while (node && hops < 6) {
	        var cs = window.getComputedStyle(node);
	        if (cs.backgroundColor === 'rgb(245, 246, 247)') {
	          _this._modifiedNodes.push({
	            el: node,
	            originalBg: node.style.background
	          });
	          node.style.background = '#FAFBFD';
	        }
	        node = node.parentElement;
	        hops += 1;
	      }
	    };
	
	    _this.restoreParentBackgrounds = function () {
	      if (_this._modifiedNodes) {
	        _this._modifiedNodes.forEach(function (entry) {
	          entry.el.style.background = entry.originalBg;
	        });
	        _this._modifiedNodes = null;
	      }
	    };
	
	    _this.readFromStorage = function () {
	      try {
	        var raw = window.localStorage.getItem(storageKey());
	        if (!raw) return {};
	        var parsed = JSON.parse(raw);
	        if (!Array.isArray(parsed)) return {};
	        var next = {};
	        parsed.forEach(function (id) {
	          if (typeof id === 'string') next[id] = true;
	        });
	        return next;
	      } catch (e) {
	        return {};
	      }
	    };
	
	    _this.writeToStorage = function (completed) {
	      try {
	        var ids = Object.keys(completed).filter(function (k) {
	          return completed[k] === true;
	        });
	        window.localStorage.setItem(storageKey(), JSON.stringify(ids));
	      } catch (e) {
	        // localStorage unavailable — silent. In-memory state still drives
	        // this render, we just lose persistence across reloads.
	      }
	    };
	
	    _this.toggle = function (id) {
	      _this.setState(function (prev) {
	        var next = Object.assign({}, prev.completed);
	        if (next[id]) {
	          delete next[id];
	        } else {
	          next[id] = true;
	        }
	        _this.writeToStorage(next);
	        return { completed: next };
	      });
	    };
	
	    _this.countableCompleted = function () {
	      var completed = _this.state.completed;
	
	      return COUNTABLE_IDS.filter(function (id) {
	        return completed[id];
	      }).length;
	    };
	
	    _this.isConductResearchComplete = function () {
	      var completed = _this.state.completed;
	
	      return completed['review-case-study'] && completed['review-round-goals'] && completed['analyze-customers'] ? true : false;
	    };
	
	    _this.isLeafStepComplete = function (id) {
	      var completed = _this.state.completed;
	
	      return !!completed[id];
	    };
	
	    _this.firstIncompleteStepId = function () {
	      if (!_this.isLeafStepComplete('team-outreach')) return 'team-outreach';
	      if (!_this.isConductResearchComplete()) return 'conduct-research';
	      if (!_this.isLeafStepComplete('make-decisions')) return 'make-decisions';
	      return null;
	    };
	
	    _this.openTeammatesPopup = function () {
	      _this.setState({ teammatesPopupOpen: true });
	      _this.fetchTeammates();
	    };
	
	    _this.openContractPopup = function () {
	      _this.setState({ contractPopupOpen: true });
	    };
	
	    _this.closeAllPopups = function () {
	      _this.setState({ teammatesPopupOpen: false, contractPopupOpen: false });
	    };
	
	    _this.fetchTeammates = function () {
	      if (_this.state.teammatesLoaded || _this.state.teammatesLoading) return;
	      _this.setState({ teammatesLoading: true });
	      (0, _ApiService.getRequest)(TEAMMATES_API + '?game=' + _Auth2.default.getGameId()).then(function (res) {
	        var body = res && res.body || {};
	        var rows = Array.isArray(body.results) ? body.results : [];
	        var myUserId = Number(_Auth2.default.getUserId());
	        var currentTeam = _Teams2.default.currentTeam();
	        var myTeamId = currentTeam ? Number(currentTeam.id) : null;
	        // Filter to teammates on the current team, excluding self.
	        var teammates = rows.filter(function (r) {
	          return r && r.user;
	        }).filter(function (r) {
	          return myTeamId == null || Number(r.team) === myTeamId;
	        }).filter(function (r) {
	          return Number(r.user.id) !== myUserId;
	        }).map(function (r) {
	          return {
	            fullname: ((r.user.first_name || '') + ' ' + (r.user.last_name || '')).trim() || r.user.username || 'Teammate',
	            email: r.user.email || ''
	          };
	        });
	
	        _this.setState({
	          teammates: teammates,
	          teammatesLoading: false,
	          teammatesLoaded: true
	        });
	      }).catch(function () {
	        _this.setState({ teammatesLoading: false, teammatesLoaded: true });
	      });
	    };
	
	    _this.showToast = function () {
	      if (_this._toastTimer) clearTimeout(_this._toastTimer);
	      _this.setState({ toastVisible: true });
	      _this._toastTimer = setTimeout(function () {
	        _this.setState({ toastVisible: false });
	        _this._toastTimer = null;
	      }, 1800);
	    };
	
	    _this.copyEmail = function (email) {
	      if (!email) return;
	      if (navigator && navigator.clipboard) {
	        navigator.clipboard.writeText(email).then(_this.showToast).catch(function () {});
	      }
	    };
	
	    _this.copyAllEmails = function (e) {
	      if (e) e.preventDefault();
	      var emails = _this.state.teammates.map(function (t) {
	        return t.email;
	      }).filter(Boolean).join('\n');
	      _this.copyEmail(emails);
	    };
	
	    _this.withRound = function (path) {
	      return '' + path + (path.indexOf('?') >= 0 ? '&' : '?') + 'round=' + _this.activeRound;
	    };
	
	    _this.customerAnalysisUrl = function () {
	      var role = getRoleForAnalysisRoute();
	      return _this.withRound('/' + role + '/analysis/market');
	    };
	
	    _this.stopRowClickPropagation = function (e) {
	      if (e) e.stopPropagation();
	    };
	
	    _this.renderStepCircle = function (step, completed, active) {
	      var label = completed ? 'Mark ' + step.title + ' as incomplete' : 'Mark ' + step.title + ' as complete';
	      var content = completed ? '✓' : step.number;
	
	      if (step.id === 'conduct-research') {
	        return _react2.default.createElement(
	          Styled.StepCircleStatic,
	          {
	            completed: completed,
	            active: active,
	            'aria-hidden': 'true'
	          },
	          content
	        );
	      }
	
	      return _react2.default.createElement(
	        Styled.StepCircleButton,
	        {
	          type: 'button',
	          onClick: function onClick() {
	            return _this.toggle(step.id);
	          },
	          'aria-pressed': completed,
	          'aria-label': label,
	          completed: completed,
	          active: active
	        },
	        content
	      );
	    };
	
	    _this.renderTeamOutreachDescription = function () {
	      return _react2.default.createElement(
	        Styled.StepDescription,
	        null,
	        'Introduce yourself to your teammates',
	        ' ',
	        _react2.default.createElement(
	          Styled.InlineButton,
	          {
	            type: 'button',
	            onClick: _this.openTeammatesPopup,
	            'aria-haspopup': 'dialog'
	          },
	          '(view teammates)'
	        ),
	        ', schedule a meeting, and align on how you\'ll work together this round. Create a team contract to enhance collaboration.',
	        ' ',
	        _react2.default.createElement(
	          Styled.StepLink,
	          {
	            as: 'button',
	            type: 'button',
	            onClick: _this.openContractPopup,
	            'aria-haspopup': 'dialog'
	          },
	          'View the team contract template \u2192'
	        )
	      );
	    };
	
	    _this.renderInternalLink = function (label, href) {
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: href, style: { textDecoration: 'none' } },
	        _react2.default.createElement(
	          Styled.StepLink,
	          { as: 'span' },
	          label,
	          ' \u2192'
	        )
	      );
	    };
	
	    _this.renderSubsteps = function () {
	      var completed = _this.state.completed;
	
	      var substeps = [{
	        id: 'review-case-study',
	        title: 'Review Case Study',
	        description: 'Gain a general understanding of the market and how it might impact each of the core business functions.',
	        linkText: 'Open case study',
	        linkHref: _this.withRound('/analysis/bcase/executive-summary')
	      }, {
	        id: 'review-round-goals',
	        title: 'Review Round Goals',
	        description: 'Understand the 4 financial metrics and targets that you need to hit each round to earn a 100% score.',
	        linkText: 'View round goals',
	        linkHref: _this.withRound('/goals-and-targets')
	      }, {
	        id: 'analyze-customers',
	        title: 'Analyze Customers',
	        description: 'Identify which customers to target to reach your financial goals.',
	        linkText: 'Open customer analysis',
	        linkHref: _this.customerAnalysisUrl()
	      }];
	
	      return _react2.default.createElement(
	        Styled.SubstepGroup,
	        null,
	        substeps.map(function (sub) {
	          var isDone = !!completed[sub.id];
	          return _react2.default.createElement(
	            Styled.SubstepRow,
	            {
	              key: sub.id,
	              type: 'button',
	              onClick: function onClick() {
	                return _this.toggle(sub.id);
	              },
	              'aria-pressed': isDone,
	              'aria-label': isDone ? 'Mark ' + sub.title + ' as incomplete' : 'Mark ' + sub.title + ' as complete'
	            },
	            _react2.default.createElement(
	              Styled.Checkbox,
	              { checked: isDone, 'aria-hidden': 'true' },
	              isDone ? '✓' : ''
	            ),
	            _react2.default.createElement(
	              Styled.SubstepBody,
	              null,
	              _react2.default.createElement(
	                Styled.SubstepTitle,
	                { completed: isDone },
	                sub.title
	              ),
	              _react2.default.createElement(
	                Styled.SubstepDescription,
	                null,
	                sub.description,
	                ' ',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: sub.linkHref,
	                    onClick: _this.stopRowClickPropagation,
	                    style: { textDecoration: 'none' }
	                  },
	                  _react2.default.createElement(
	                    Styled.SubstepLink,
	                    { as: 'span' },
	                    sub.linkText,
	                    ' \u2192'
	                  )
	                )
	              )
	            )
	          );
	        })
	      );
	    };
	
	    _this.renderTeammatesPopup = function () {
	      var _this$state = _this.state,
	          teammates = _this$state.teammates,
	          teammatesLoading = _this$state.teammatesLoading,
	          teammatesLoaded = _this$state.teammatesLoaded;
	
	      var currentTeam = _Teams2.default.currentTeam();
	      var teamLabel = formatTeamName(currentTeam && currentTeam.name);
	      return _react2.default.createElement(
	        Styled.Modal.Backdrop,
	        { onClick: _this.closeAllPopups, role: 'dialog', 'aria-modal': 'true' },
	        _react2.default.createElement(
	          Styled.Modal.Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Styled.Modal.HeaderBar,
	            null,
	            _react2.default.createElement(
	              Styled.Modal.TitleStack,
	              null,
	              _react2.default.createElement(
	                Styled.Modal.Title,
	                null,
	                'Your Teammates'
	              ),
	              teamLabel && _react2.default.createElement(
	                Styled.Modal.Subtitle,
	                null,
	                teamLabel
	              )
	            ),
	            _react2.default.createElement(
	              Styled.Modal.HeaderActions,
	              null,
	              _react2.default.createElement(
	                Styled.Modal.CloseButton,
	                {
	                  type: 'button',
	                  onClick: _this.closeAllPopups,
	                  'aria-label': 'Close'
	                },
	                '\xD7'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Modal.Body,
	            null,
	            teammatesLoading && !teammatesLoaded && _react2.default.createElement(
	              Styled.Empty,
	              null,
	              'Loading teammates\u2026'
	            ),
	            teammatesLoaded && teammates.length === 0 && _react2.default.createElement(
	              Styled.Empty,
	              null,
	              'No teammates found.'
	            ),
	            teammates.length > 0 && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                Styled.Roster,
	                null,
	                teammates.map(function (t, idx) {
	                  return _react2.default.createElement(
	                    Styled.RosterRow,
	                    { key: idx },
	                    _react2.default.createElement(
	                      Styled.RosterName,
	                      null,
	                      t.fullname
	                    ),
	                    _react2.default.createElement(
	                      Styled.RosterEmail,
	                      null,
	                      t.email,
	                      _react2.default.createElement(
	                        Styled.RosterCopyButton,
	                        {
	                          type: 'button',
	                          onClick: function onClick() {
	                            return _this.copyEmail(t.email);
	                          },
	                          'aria-label': 'Copy ' + t.fullname + '\'s email'
	                        },
	                        _react2.default.createElement('img', { src: _onboardingCopy2.default, alt: '' })
	                      )
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                Styled.CopyAllRow,
	                null,
	                _react2.default.createElement(
	                  Styled.CopyAllLink,
	                  { onClick: _this.copyAllEmails },
	                  'Copy All Emails'
	                )
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderContractPopup = function () {
	      return _react2.default.createElement(
	        Styled.Modal.Backdrop,
	        { onClick: _this.closeAllPopups, role: 'dialog', 'aria-modal': 'true' },
	        _react2.default.createElement(
	          Styled.Modal.Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Styled.Modal.HeaderBar,
	            null,
	            _react2.default.createElement(
	              Styled.Modal.Title,
	              null,
	              'Team Contract Template'
	            ),
	            _react2.default.createElement(
	              Styled.Modal.HeaderActions,
	              null,
	              _react2.default.createElement(
	                Styled.Modal.DownloadButton,
	                {
	                  href: TEAM_CONTRACT_PDF_URL,
	                  download: 'Market_Games_Team_Contract.pdf',
	                  target: '_blank',
	                  rel: 'noopener noreferrer'
	                },
	                '\u2B07 Download'
	              ),
	              _react2.default.createElement(
	                Styled.Modal.CloseButton,
	                {
	                  type: 'button',
	                  onClick: _this.closeAllPopups,
	                  'aria-label': 'Close'
	                },
	                '\xD7'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Modal.Body,
	            null,
	            _react2.default.createElement(
	              Styled.ContractIntro,
	              null,
	              'A team contract is a set of basic principles and standards for working together to create a supportive and productive team environment. This team contract covers the following:'
	            ),
	            _react2.default.createElement(
	              Styled.ContractList,
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Expectations of one another'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Meeting planning'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Team communication and participation norms (approach to problem-solving, decision-making, conflict management)'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Responsibilities to one another'
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractCallout,
	              null,
	              'It is recommended that teams revisit their Contract at each team meeting to ensure they are living up to their commitments and can course-correct as needed.'
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Expectations'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Work collaboratively on this team project.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Attend team meetings and arrive on time. Whenever possible, meet in person; when meeting remotely, cameras on.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Communicate effectively and respond to teammates quickly.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Support each other\'s learning. Give each other the benefit of the doubt.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'See the simulation through to completion.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Don\'t be evil.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Team Meeting Planning & Attendance'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Meetings will be held every ____ days/weeks (pick a day and time and set that schedule up front).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Agendas will be issued every ____ days in advance by _____________ (since sim roles rotate, pick a role in the sim that will be responsible for the agenda).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Team members will come to the meetings prepared.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Agenda items for the next meeting will be discussed at the end of each meeting.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Unresolved issues will be added to the Issues list.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'If a team member cannot attend a meeting, they will let team members know well in advance (if possible).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Meeting tasks will be rotated among members.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Team Communication'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Be responsive to team member requests and outreach. Agree and stick to a turnaround time for responding.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Practice active, effective listening skills. Playback what you heard to ensure it is what was intended.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Seek first to understand, and then to be understood.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Be clear and to the point.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Keep discussions on track. Consider appointing a time keeper to keep team meetings focused and moving.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Team Participation'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Be honest and open during meetings.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Encourage a diversity of opinions on all topics.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Give everyone the opportunity for equal participation.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Be open to new approaches and listen to new ideas.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Avoid placing blame when things go wrong. Instead, discuss the process and explore how it can be improved next time.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Team Problem-Solving'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Build on each other\'s ideas.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Whenever possible, use data to assist in problem-solving.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Remember that solving problems is a creative process. New ideas and new understandings often result.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Team Decision-Making'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Make decisions based on data whenever feasible.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Seek to find the needed information or data.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Discuss criteria (cost, time, impact, etc.) for making a decision before choosing an option.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Encourage and explore different interpretations of data.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Get input from the entire team before a decision is made.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Styled.ContractSection,
	              null,
	              _react2.default.createElement(
	                Styled.ContractSectionTitle,
	                null,
	                'Handling Conflict'
	              ),
	              _react2.default.createElement(
	                Styled.ContractSectionList,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'View conflict as normal and as an opportunity for growth.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Seek to understand the interests and desires of each party involved before arriving at answers or solutions.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Listen openly to other points of view.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Repeat what we understand to the other person and ask if it is correct.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Acknowledge valid points that the other person has made.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'State our points of view and our interests in a non-judgmental and non-attacking manner.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Seek to find some common ground for agreement.'
	                )
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderRoleIntro = function (roleMeta) {
	      return _react2.default.createElement(
	        Styled.Root,
	        { innerRef: _this.setRootEl },
	        _react2.default.createElement(
	          Styled.Header,
	          null,
	          _react2.default.createElement(
	            Styled.Title,
	            null,
	            'Welcome to the Intro to Business Challenge!'
	          )
	        ),
	        _react2.default.createElement(
	          Styled.IntroCard,
	          null,
	          _react2.default.createElement(
	            Styled.IntroSubhead,
	            null,
	            'Each round you\'ll take on a different role. Here\'s what you\'re responsible for this round.'
	          ),
	          _react2.default.createElement(
	            Styled.RoleBadge,
	            null,
	            'Your Role: ',
	            roleMeta.label
	          ),
	          _react2.default.createElement(
	            Styled.IntroDescription,
	            null,
	            roleMeta.description
	          ),
	          _react2.default.createElement(
	            Styled.IntroContinueButton,
	            {
	              type: 'button',
	              onClick: _this.dismissRoleIntro
	            },
	            'Continue \u2192'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      completed: _this.readFromStorage(),
	      teammatesPopupOpen: false,
	      contractPopupOpen: false,
	      teammates: [],
	      teammatesLoading: false,
	      teammatesLoaded: false,
	      toastVisible: false,
	      // Which parent steps are collapsed. Keyed by step id; absence
	      // means expanded. Sub-sections start expanded by default so
	      // users see the substeps immediately. In-memory only — resets
	      // on reload.
	      collapsedSteps: {},
	      // Role-intro screen is shown before the checklist on first
	      // visit. Dismissal persists per user + role via localStorage.
	      roleIntroDismissed: _this.readRoleIntroDismissed()
	    };
	    return _this;
	  }
	
	  _createClass(Round1Checklist, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.overrideParentBackgrounds();
	      if (typeof window !== 'undefined') {
	        window.addEventListener('keydown', this.handleKeydown);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.restoreParentBackgrounds();
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this._toastTimer) {
	        clearTimeout(this._toastTimer);
	        this._toastTimer = null;
	      }
	    }
	
	    // Esc closes any open popup.
	
	
	    // ---- persistence -----------------------------------------------
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // Role-intro screen precedes the checklist. Only rendered when
	      // the user's role maps to known copy — unknown roles fall
	      // straight through to the checklist to avoid a blank state.
	      if (!this.state.roleIntroDismissed) {
	        var roleMeta = ROLE_INTRO_CONTENT[getCurrentRoleCode()];
	        if (roleMeta) {
	          return this.renderRoleIntro(roleMeta);
	        }
	      }
	
	      var completedCount = this.countableCompleted();
	      var pct = Math.round(completedCount / TOTAL_COUNTABLE * 100);
	      var activeId = this.firstIncompleteStepId();
	      var allDone = completedCount === TOTAL_COUNTABLE;
	
	      var conductComplete = this.isConductResearchComplete();
	      var teamOutreachComplete = this.isLeafStepComplete('team-outreach');
	      var makeDecisionsComplete = this.isLeafStepComplete('make-decisions');
	
	      return _react2.default.createElement(
	        Styled.Root,
	        { innerRef: this.setRootEl },
	        _react2.default.createElement(
	          Styled.Header,
	          null,
	          _react2.default.createElement(
	            Styled.Title,
	            null,
	            'Welcome to the Intro to Business Challenge!'
	          ),
	          _react2.default.createElement(
	            Styled.Subhead,
	            null,
	            'To get started for the round, follow the checklist below.'
	          ),
	          _react2.default.createElement(
	            Styled.SrOnly,
	            { 'aria-live': 'polite' },
	            completedCount,
	            ' of ',
	            TOTAL_COUNTABLE,
	            ' steps complete'
	          )
	        ),
	        _react2.default.createElement(
	          Styled.Timeline,
	          null,
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'team-outreach' },
	            this.renderStepCircle({ id: 'team-outreach', number: 1, title: 'Team Outreach' }, teamOutreachComplete, activeId === 'team-outreach'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepTitle,
	                { completed: teamOutreachComplete },
	                'Team Outreach'
	              ),
	              this.renderTeamOutreachDescription()
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'conduct-research' },
	            this.renderStepCircle({ id: 'conduct-research', number: 2, title: 'Conduct Research' }, conductComplete, activeId === 'conduct-research'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepHeaderToggle,
	                {
	                  role: 'button',
	                  tabIndex: 0,
	                  onClick: function onClick() {
	                    return _this2.toggleStepCollapse('conduct-research');
	                  },
	                  onKeyDown: this.handleStepHeaderKeyDown('conduct-research'),
	                  'aria-expanded': !this.isStepCollapsed('conduct-research'),
	                  'aria-controls': 'substeps-conduct-research',
	                  'aria-label': this.isStepCollapsed('conduct-research') ? 'Expand Conduct Research' : 'Collapse Conduct Research'
	                },
	                _react2.default.createElement(
	                  Styled.StepHeaderTextGroup,
	                  null,
	                  _react2.default.createElement(
	                    Styled.StepTitle,
	                    { completed: conductComplete },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Conduct Research'
	                    ),
	                    _react2.default.createElement(
	                      Styled.StepTimeEstimate,
	                      null,
	                      '(est. time 1-2 hrs)'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    Styled.StepDescription,
	                    null,
	                    'Do this on your own before the team meeting, three quick reviews to come prepared.'
	                  )
	                ),
	                _react2.default.createElement(
	                  Styled.StepHeaderChevron,
	                  { 'aria-hidden': 'true' },
	                  this.isStepCollapsed('conduct-research') ? '▸' : '▾'
	                )
	              ),
	              !this.isStepCollapsed('conduct-research') && _react2.default.createElement(
	                'div',
	                { id: 'substeps-conduct-research' },
	                this.renderSubsteps()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'make-decisions' },
	            this.renderStepCircle({ id: 'make-decisions', number: 3, title: 'Make Decisions' }, makeDecisionsComplete, activeId === 'make-decisions'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepTitle,
	                { completed: makeDecisionsComplete },
	                'Make Decisions',
	                _react2.default.createElement(
	                  Styled.StepTimeEstimate,
	                  null,
	                  '(est. time 1-1.5 hrs)'
	                )
	              ),
	              _react2.default.createElement(
	                Styled.StepDescription,
	                null,
	                getRoleDisplayName() && _react2.default.createElement(
	                  'span',
	                  null,
	                  'You\'re assigned the ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    getRoleDisplayName()
	                  ),
	                  ' role this round.',
	                  ' '
	                ),
	                'Meet with your team, in person or online, to make and post all team decisions before the round ends. That\'s it.',
	                ' ',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: this.withRound('/decisions'), style: { textDecoration: 'none' } },
	                  _react2.default.createElement(
	                    Styled.StepLink,
	                    { as: 'span' },
	                    'Go to decisions \u2192'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        allDone && _react2.default.createElement(
	          Styled.CompletionBanner,
	          null,
	          _react2.default.createElement(
	            Styled.CompletionIcon,
	            { 'aria-hidden': 'true' },
	            COMPLETION_COPY.icon
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              Styled.CompletionTitle,
	              null,
	              COMPLETION_COPY.title
	            ),
	            _react2.default.createElement(
	              Styled.CompletionDescription,
	              null,
	              COMPLETION_COPY.description
	            )
	          )
	        ),
	        this.state.teammatesPopupOpen && this.renderTeammatesPopup(),
	        this.state.contractPopupOpen && this.renderContractPopup(),
	        this.state.toastVisible && _react2.default.createElement(
	          Styled.Toast,
	          null,
	          'Copied to clipboard'
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	
	
	    // ---- derived helpers -------------------------------------------
	
	    get: function get() {
	      var _props = this.props,
	          roundInUrl = _props.roundInUrl,
	          currentRound = _props.currentRound;
	
	      return roundInUrl || currentRound || 1;
	    }
	
	    // First incomplete top-level step drives the blue active highlight.
	
	
	    // ---- popup actions ---------------------------------------------
	
	    // ---- URL builders ----------------------------------------------
	
	    // Click handler shared by step + substep rows. Stops the event
	    // from toggling the parent step when an inline link is clicked.
	
	
	    // ---- render ----------------------------------------------------
	
	  }]);
	
	  return Round1Checklist;
	}(_react.PureComponent);
	
	exports.default = Round1Checklist;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CustomerPreferences = __webpack_require__(1231);
	
	Object.defineProperty(exports, 'CustomerPreferences', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CustomerPreferences).default;
	  }
	});
	
	var _ProductStrategy = __webpack_require__(1237);
	
	Object.defineProperty(exports, 'ProductStrategy', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProductStrategy).default;
	  }
	});
	
	var _MachineOptions = __webpack_require__(1233);
	
	Object.defineProperty(exports, 'MachineOptions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MachineOptions).default;
	  }
	});
	
	var _DistributionCenters = __webpack_require__(1232);
	
	Object.defineProperty(exports, 'DistributionCenters', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DistributionCenters).default;
	  }
	});
	
	var _ShareBuyback = __webpack_require__(1238);
	
	Object.defineProperty(exports, 'ShareBuyback', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShareBuyback).default;
	  }
	});
	
	var _NewMetricROE = __webpack_require__(1236);
	
	Object.defineProperty(exports, 'NewMetricROE', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewMetricROE).default;
	  }
	});
	
	var _NewMetricROA = __webpack_require__(1235);
	
	Object.defineProperty(exports, 'NewMetricROA', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewMetricROA).default;
	  }
	});
	
	var _NewMetricEPS = __webpack_require__(1234);
	
	Object.defineProperty(exports, 'NewMetricEPS', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewMetricEPS).default;
	  }
	});
	
	var _ConductResearch = __webpack_require__(1230);
	
	Object.defineProperty(exports, 'ConductResearch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ConductResearch).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Location = __webpack_require__(23);
	
	var _LandingPageLogo = __webpack_require__(392);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactLoaders2 = _interopRequireDefault(_reactLoaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentsWidget = function (_PureComponent) {
	  _inherits(PaymentsWidget, _PureComponent);
	
	  function PaymentsWidget(props) {
	    _classCallCheck(this, PaymentsWidget);
	
	    var _this = _possibleConstructorReturn(this, (PaymentsWidget.__proto__ || Object.getPrototypeOf(PaymentsWidget)).call(this, props));
	
	    _this.checkout = function () {
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/payments/create-checkout-session/").send('quantity=1').then(function (res) {
	        window.location.href = res.body;
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    _this.continue = function () {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/coursemembers/").then(function (res) {
	        var courseMember = res.body.results.find(function (i) {
	          return Number(i.user.id) === Number(_Auth2.default.getUserId());
	        });
	
	        if (courseMember) {
	          (0, _ApiService.patchRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/coursemembers/" + courseMember.id + "/").send({
	            registered_at: new Date()
	          }).then(function (res) {
	            _this.detectIsPaid();
	          }).catch(function (err) {
	            console.log(err);
	            _this.detectIsPaid();
	          });
	        } else {
	          console.log("Cannot find course member for user = " + _Auth2.default.getUserId());
	          _this.detectIsPaid();
	        }
	      }).catch(function (err) {
	        console.log(err);
	        _this.detectIsPaid();
	      });
	    };
	
	    _this.detectIsPaid = function () {
	      (0, _ApiService.getRequest)(_Auth2.default.getUserDataRequest()).then(function (res) {
	        _Auth2.default.setUserData(res.body);
	
	        if (_Auth2.default.isPaid() === true) {
	          _this.authorizeUser();
	        } else {
	          setTimeout(function () {
	            _this.detectIsPaid();
	          }, 1000);
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.authorizeUser = function () {
	      if (_Auth2.default.getRole() === "" || !_Auth2.default.getTeamId()) {
	        _Teams2.default.setEmptyData();
	        _this.eventemitter.trigger("reload-data");
	        (0, _Location.changeLocation)("/join");
	      } else {
	        _this.loadTeamRoles(function () {
	          _this.eventemitter.trigger("reload-data");
	          (0, _Location.changeLocation)("/start");
	        });
	      }
	    };
	
	    _this.loadTeamRoles = function (callback) {
	      var joinRequest = (0, _ApiService.batchRequest)([].concat(_toConsumableArray(_Teams2.default.requests()), [("https://be-production-itb.marketgames.io/api/") + "v2/games/teamplayers/?game=" + _Auth2.default.getGameId()]));
	
	      joinRequest.then(function (res) {
	        var teams_data = [{
	          status: res[0].statusCode,
	          data: res[0].body
	        }, {
	          status: res[1].statusCode,
	          data: res[1].body
	        }];
	        var teams_status = _Teams2.default.setData(teams_data);
	        if (teams_status === "Error") {
	          throw teams_status;
	        }
	
	        _Auth2.default.setPlayerRoles(res[2].body.results);
	
	        if (callback) {
	          callback();
	        }
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	
	    _this.logout = function () {
	      if (_Auth2.default.isUserAuthenticated()) {
	        _Auth2.default.deauthenticateUser();
	      }
	
	      (0, _Location.changeLocation)("/login");
	    };
	
	    _this.state = {
	      isSuccess: props.isSuccess,
	      isCancel: props.isCancel
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(PaymentsWidget, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _state = this.state,
	          isSuccess = _state.isSuccess,
	          isCancel = _state.isCancel;
	
	
	      if (isSuccess) {
	        this.continue();
	      } else if (isCancel) {
	        this.logout();
	      } else if (_Auth2.default.isPaid() === true) {
	        this.detectIsPaid();
	      } else {
	        this.checkout();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var mode = this.props.mode;
	
	      var containerClassName = mode === "page" ? "container promocode-container" : "promocode-container without-max-width";
	
	      return _react2.default.createElement(
	        "div",
	        { className: containerClassName },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "promocode-header" },
	              _react2.default.createElement("img", { src: _LandingPageLogo2.default, alt: "Logo", className: "promocode-logo" }),
	              _react2.default.createElement(
	                "span",
	                { className: "payment-header-caption" },
	                "Market Games"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "text-center loader-inline", style: { paddingTop: '40px', paddingBottom: '40px' } },
	              _react2.default.createElement(_reactLoaders2.default, { type: "ball-scale-ripple", active: true })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentsWidget;
	}(_react.PureComponent);
	
	exports.default = PaymentsWidget;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ApiService = __webpack_require__(4);
	
	var _InFlightDedup = __webpack_require__(393);
	
	var _peerEvaluationCard = __webpack_require__(589);
	
	var _peerEvaluationCard2 = _interopRequireDefault(_peerEvaluationCard);
	
	var _peerEvaluationModal = __webpack_require__(256);
	
	var _peerEvaluationModal2 = _interopRequireDefault(_peerEvaluationModal);
	
	var _peerEvaluationFeedback = __webpack_require__(305);
	
	var _peerEvaluationFeedback2 = _interopRequireDefault(_peerEvaluationFeedback);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _sortBy = __webpack_require__(235);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactLoaders2 = _interopRequireDefault(_reactLoaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PeerEvaluation = function (_Component) {
	  _inherits(PeerEvaluation, _Component);
	
	  function PeerEvaluation(props) {
	    _classCallCheck(this, PeerEvaluation);
	
	    var _this = _possibleConstructorReturn(this, (PeerEvaluation.__proto__ || Object.getPrototypeOf(PeerEvaluation)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._isMounted = false;
	
	    var userId = parseInt(_Auth2.default.getUserId(), 10);
	    var readonlyMode = _this.props.viewOnly;
	    if (typeof readonlyMode === 'undefined') {
	      readonlyMode = !_this.isSurveyStarted(props.survey);
	    }
	
	    _this.state = {
	      currentUserId: userId,
	      currentTeamId: _Auth2.default.getTeamId(),
	      readonlyMode: readonlyMode,
	      finishedFeedbacks: [],
	      feedbacks: {},
	      questionsOrder: [],
	      answers: [],
	      isIntroScreen: true,
	      isFinalScreen: false,
	      isBeforeTransitionScreen: false,
	      isTransitionScreen: false,
	      currentPage: 0,
	      questionsCount: 0,
	      self_assessment_count: 0,
	      peer_rating_count: 0,
	      skills_assessment_count: 0,
	      final_reflection_count: 0,
	      showFeedbackError: false,
	      show: false,
	      progressBar: [],
	      teamList: [],
	      submitPages: {},
	      showAlert: false,
	      adjustedScore: 0,
	      submitButtonLoading: false,
	      showSubmissionError: false
	    };
	    return _this;
	  }
	
	  _createClass(PeerEvaluation, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var survey, finishedFeedbacks, progressBar, isFinalReflectionsVisible;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this._isMounted = true;
	
	                survey = this.props.survey;
	                _context.next = 4;
	                return this.getTeamList();
	
	              case 4:
	                _context.next = 6;
	                return this.getFinishedFeedbacks();
	
	              case 6:
	                finishedFeedbacks = _context.sent;
	                progressBar = [{ id: 1, title: "1. Self Assessment", progress: 0 }, {
	                  id: 2,
	                  title: "2. Peer Rating",
	                  progress: 0,
	                  isDisabled: true
	                }];
	                isFinalReflectionsVisible = this.isFinalReflectionsVisible(survey.questions);
	
	
	                if (this.isSkillsAssessmentVisible(survey.questions)) {
	                  progressBar.push({ id: 3, title: "3. Skills Assessment", progress: 0, isDisabled: true });
	
	                  if (isFinalReflectionsVisible) {
	                    progressBar.push({ id: 4, title: "4. Final Reflections", progress: 0, isDisabled: true });
	                  }
	                } else {
	                  if (isFinalReflectionsVisible) {
	                    progressBar.push({ id: 4, title: "3. Final Reflections", progress: 0, isDisabled: true });
	                  }
	                }
	
	                if (this._isMounted) {
	                  _context.next = 12;
	                  break;
	                }
	
	                return _context.abrupt("return");
	
	              case 12:
	
	                this.setState({
	                  finishedFeedbacks: finishedFeedbacks,
	                  progressBar: progressBar
	                });
	
	              case 13:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: "getTeamList",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var _state, currentUserId, currentTeamId, _ref3, users, teamList;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _state = this.state, currentUserId = _state.currentUserId, currentTeamId = _state.currentTeamId;
	                _context2.next = 3;
	                return (0, _InFlightDedup.dedupedGet)(("https://be-production-itb.marketgames.io/api/") + "team/players/?team=" + currentTeamId);
	
	              case 3:
	                _ref3 = _context2.sent;
	                users = _ref3.body;
	                teamList = (0, _sortBy2.default)(users.filter(function (teammate) {
	                  return teammate.role !== 'VI' && teammate.team === currentTeamId && teammate.user && teammate.user.id !== currentUserId;
	                }).map(function (teammate) {
	                  return teammate.user;
	                }), "id").map(function (teammate) {
	                  return {
	                    id: teammate.id,
	                    username: teammate.username,
	                    fullname: teammate.first_name + " " + teammate.last_name
	                  };
	                });
	
	                if (this._isMounted) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                return _context2.abrupt("return");
	
	              case 8:
	
	                this.setState({
	                  teamList: teamList
	                }, function () {
	                  _this2.questionsOrder();
	                });
	
	              case 9:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getTeamList() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getTeamList;
	    }()
	  }, {
	    key: "getFeedback",
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(sendData, finishedFeedbacks) {
	        var readonlyMode, feedback, _ref5, body;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                readonlyMode = this.state.readonlyMode;
	                feedback = finishedFeedbacks.find(function (i) {
	                  return i.survey === sendData.survey && i.giver === sendData.giver && i.giver_team === sendData.giver_team && i.receiver === sendData.receiver;
	                });
	
	                if (!(!feedback && readonlyMode === false)) {
	                  _context3.next = 8;
	                  break;
	                }
	
	                _context3.next = 5;
	                return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/").send(sendData);
	
	              case 5:
	                _ref5 = _context3.sent;
	                body = _ref5.body;
	
	                feedback = body;
	
	              case 8:
	                return _context3.abrupt("return", feedback);
	
	              case 9:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getFeedback(_x, _x2) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getFeedback;
	    }()
	  }, {
	    key: "getFinishedFeedbacks",
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var survey, _ref7, finishedFeedbacks;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                survey = this.props.survey;
	                _context4.next = 3;
	                return (0, _InFlightDedup.dedupedGet)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/");
	
	              case 3:
	                _ref7 = _context4.sent;
	                finishedFeedbacks = _ref7.body;
	                return _context4.abrupt("return", finishedFeedbacks.results.filter(function (i) {
	                  return i.survey === survey.id;
	                }));
	
	              case 6:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function getFinishedFeedbacks() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getFinishedFeedbacks;
	    }()
	  }, {
	    key: "loadFeedback",
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var survey, _state2, currentUserId, currentTeamId, teamList, self_assessment_count, peer_rating_count, skills_assessment_count, final_reflection_count, data, feedbacksData, finishedFeedbacks, feedbacks, feedbacksIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, feedbackData, feedback, _ref9, answersData, answers, submitPages, i, teammate, index;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                survey = this.props.survey;
	                _state2 = this.state, currentUserId = _state2.currentUserId, currentTeamId = _state2.currentTeamId, teamList = _state2.teamList, self_assessment_count = _state2.self_assessment_count, peer_rating_count = _state2.peer_rating_count, skills_assessment_count = _state2.skills_assessment_count, final_reflection_count = _state2.final_reflection_count;
	                data = {
	                  survey: survey.id,
	                  giver: currentUserId,
	                  giver_team: currentTeamId
	                };
	                feedbacksData = [currentUserId].concat(_toConsumableArray(teamList.map(function (teammate) {
	                  return teammate.id;
	                }))).map(function (userId) {
	                  return Object.assign({}, data, {
	                    receiver: userId
	                  });
	                });
	                _context5.next = 6;
	                return this.getFinishedFeedbacks();
	
	              case 6:
	                finishedFeedbacks = _context5.sent;
	                feedbacks = {};
	                feedbacksIds = [];
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context5.prev = 12;
	                _iterator = feedbacksData[Symbol.iterator]();
	
	              case 14:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context5.next = 24;
	                  break;
	                }
	
	                feedbackData = _step.value;
	                _context5.next = 18;
	                return this.getFeedback(feedbackData, finishedFeedbacks);
	
	              case 18:
	                feedback = _context5.sent;
	
	                feedbacks[feedbackData.receiver] = feedback;
	                feedbacksIds.push(feedback.id);
	
	              case 21:
	                _iteratorNormalCompletion = true;
	                _context5.next = 14;
	                break;
	
	              case 24:
	                _context5.next = 30;
	                break;
	
	              case 26:
	                _context5.prev = 26;
	                _context5.t0 = _context5["catch"](12);
	                _didIteratorError = true;
	                _iteratorError = _context5.t0;
	
	              case 30:
	                _context5.prev = 30;
	                _context5.prev = 31;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 33:
	                _context5.prev = 33;
	
	                if (!_didIteratorError) {
	                  _context5.next = 36;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 36:
	                return _context5.finish(33);
	
	              case 37:
	                return _context5.finish(30);
	
	              case 38:
	                _context5.next = 40;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers/");
	
	              case 40:
	                _ref9 = _context5.sent;
	                answersData = _ref9.body;
	                answers = [];
	
	                if (answersData && answersData.length > 0 && feedbacksIds.length > 0) {
	                  answersData.filter(function (answer) {
	                    return feedbacksIds.includes(answer.feedback);
	                  }).forEach(function (answer) {
	                    var question = survey.questions.find(function (q) {
	                      return q.id === answer.survey_question;
	                    });
	                    answers.push({
	                      id: answer.id,
	                      value: question.answer_type === "rating" ? parseInt(answer.text, 10) : answer.text,
	                      hasError: false,
	                      type: "text",
	                      isModified: false,
	                      survey_question: answer.survey_question,
	                      feedback: answer.feedback
	                    });
	                  });
	                }
	
	                submitPages = {};
	
	                if (feedbacks[currentUserId]) {
	                  submitPages[self_assessment_count] = feedbacks[currentUserId];
	                }
	
	                for (i = 0; i < teamList.length; i++) {
	                  teammate = teamList[i];
	
	                  if (feedbacks[teammate.id]) {
	                    index = (i + 1) * final_reflection_count / teamList.length + self_assessment_count + peer_rating_count + skills_assessment_count + 2;
	
	                    submitPages[index] = feedbacks[teammate.id];
	                  }
	                }
	
	                this.setState({
	                  feedbacks: feedbacks,
	                  answers: answers,
	                  finishedFeedbacks: finishedFeedbacks,
	                  submitPages: submitPages
	                });
	
	              case 48:
	              case "end":
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this, [[12, 26, 30, 38], [31,, 33, 37]]);
	      }));
	
	      function loadFeedback() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return loadFeedback;
	    }()
	  }, {
	    key: "sendAnswers",
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var _state3, questionsOrder, currentPage, answers, currentQuestion, currentQuestionId, changedAnswers, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, answer, newAnswers;
	
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _state3 = this.state, questionsOrder = _state3.questionsOrder, currentPage = _state3.currentPage, answers = _state3.answers;
	                currentQuestion = questionsOrder[currentPage];
	                currentQuestionId = currentQuestion ? currentQuestion.id : null;
	
	                if (!currentQuestionId) {
	                  _context6.next = 39;
	                  break;
	                }
	
	                changedAnswers = answers.filter(function (i) {
	                  return i.survey_question === currentQuestionId && i.isModified === true;
	                });
	
	                if (!(changedAnswers.length > 0)) {
	                  _context6.next = 39;
	                  break;
	                }
	
	                _iteratorNormalCompletion2 = true;
	                _didIteratorError2 = false;
	                _iteratorError2 = undefined;
	                _context6.prev = 9;
	                _iterator2 = changedAnswers[Symbol.iterator]();
	
	              case 11:
	                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                  _context6.next = 23;
	                  break;
	                }
	
	                answer = _step2.value;
	
	                if (!(answer.id === 0)) {
	                  _context6.next = 18;
	                  break;
	                }
	
	                _context6.next = 16;
	                return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers/").send({
	                  feedback: answer.feedback,
	                  survey_question: answer.survey_question,
	                  text: answer.value
	                });
	
	              case 16:
	                _context6.next = 20;
	                break;
	
	              case 18:
	                _context6.next = 20;
	                return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers/" + answer.id + "/").send({
	                  feedback: answer.feedback,
	                  survey_question: answer.survey_question,
	                  text: answer.value
	                });
	
	              case 20:
	                _iteratorNormalCompletion2 = true;
	                _context6.next = 11;
	                break;
	
	              case 23:
	                _context6.next = 29;
	                break;
	
	              case 25:
	                _context6.prev = 25;
	                _context6.t0 = _context6["catch"](9);
	                _didIteratorError2 = true;
	                _iteratorError2 = _context6.t0;
	
	              case 29:
	                _context6.prev = 29;
	                _context6.prev = 30;
	
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	
	              case 32:
	                _context6.prev = 32;
	
	                if (!_didIteratorError2) {
	                  _context6.next = 35;
	                  break;
	                }
	
	                throw _iteratorError2;
	
	              case 35:
	                return _context6.finish(32);
	
	              case 36:
	                return _context6.finish(29);
	
	              case 37:
	                newAnswers = [].concat(_toConsumableArray(answers)).map(function (answer) {
	                  return Object.assign({}, answer, {
	                    isModified: false
	                  });
	                });
	
	                this.setState({
	                  answers: newAnswers
	                });
	
	              case 39:
	              case "end":
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this, [[9, 25, 29, 37], [30,, 32, 36]]);
	      }));
	
	      function sendAnswers() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return sendAnswers;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          survey = _props.survey,
	          _props$displayCheckMa = _props.displayCheckMark,
	          displayCheckMark = _props$displayCheckMa === undefined ? true : _props$displayCheckMa,
	          _props$viewOnly = _props.viewOnly,
	          viewOnly = _props$viewOnly === undefined ? false : _props$viewOnly;
	      var _state4 = this.state,
	          show = _state4.show,
	          questionsOrder = _state4.questionsOrder,
	          answers = _state4.answers,
	          isIntroScreen = _state4.isIntroScreen,
	          isFinalScreen = _state4.isFinalScreen,
	          isBeforeTransitionScreen = _state4.isBeforeTransitionScreen,
	          isTransitionScreen = _state4.isTransitionScreen,
	          showFeedbackError = _state4.showFeedbackError,
	          currentPage = _state4.currentPage,
	          progressBar = _state4.progressBar,
	          self_assessment_count = _state4.self_assessment_count,
	          peer_rating_count = _state4.peer_rating_count,
	          skills_assessment_count = _state4.skills_assessment_count,
	          teamList = _state4.teamList,
	          questionsCount = _state4.questionsCount,
	          currentUserId = _state4.currentUserId,
	          feedbacks = _state4.feedbacks,
	          readonlyMode = _state4.readonlyMode,
	          showAlert = _state4.showAlert,
	          finishedFeedbacks = _state4.finishedFeedbacks,
	          adjustedScore = _state4.adjustedScore,
	          submitButtonLoading = _state4.submitButtonLoading,
	          showSubmissionError = _state4.showSubmissionError;
	
	
	      var currentQuestion = questionsOrder[currentPage];
	      var currentQuestionId = currentQuestion ? currentQuestion.id : null;
	      var currentQuestionAnswers = answers.filter(function (answer) {
	        return !!currentQuestionId && answer.survey_question === currentQuestionId;
	      });
	      var hasAnswer = true;
	      if (currentQuestion) {
	        if (currentQuestion.category === "self_assessment" && feedbacks[currentUserId]) {
	          hasAnswer = currentQuestionAnswers.filter(function (i) {
	            return i.feedback === feedbacks[currentUserId].id;
	          }).length >= 1;
	        } else if (["collaboration", "peer_rating"].includes(currentQuestion.category)) {
	          var feedbacksIds = [];
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = teamList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var teammate = _step3.value;
	
	              if (feedbacks[teammate.id]) {
	                feedbacksIds.push(feedbacks[teammate.id].id);
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          hasAnswer = currentQuestionAnswers.filter(function (i) {
	            return feedbacksIds.includes(i.feedback);
	          }).length >= teamList.length;
	        }if (["communication", "other", "skills"].includes(currentQuestion.category)) {
	          var answer = currentQuestionAnswers.find(function (i) {
	            return i.feedback === feedbacks[currentQuestion.userId].id;
	          });
	          hasAnswer = answer && !!answer.value && answer.value !== "";
	        }
	      }
	      var previousAnswers = this.getPreviousAnswers(currentPage, currentQuestion ? currentQuestion.userId : null);
	
	      var submitButtonText = submitButtonLoading ? _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactLoaders2.default, { type: "ball-clip-rotate", active: true }),
	        _react2.default.createElement(
	          "span",
	          null,
	          "Processing"
	        )
	      ) : currentPage + 1 === questionsOrder.length - 1 ? "Submit" : isBeforeTransitionScreen ? "Continue" : isIntroScreen || isTransitionScreen ? "Start" : "Save & Continue";
	
	      return _react2.default.createElement(
	        "div",
	        { className: "peerEvaluation" },
	        _react2.default.createElement(_peerEvaluationCard2.default, {
	          survey: survey,
	          onClick: this.handleShowModal,
	          isStarted: this.isSurveyStarted(survey),
	          isSubmitted: this.isSurveySubmitted(),
	          isEnded: this.isSurveyEnded(survey),
	          isEndedWithExtended: this.isSurveyEndedWithExtended(survey),
	          isSurveyCompleted: this.isSurveyCompleted(),
	          defaultPeerEvaluationCard: false,
	          hasFeedbacks: this.isSurveyHasFeedbacks(),
	          displayCheckMark: displayCheckMark,
	          viewOnly: viewOnly,
	          completedAt: finishedFeedbacks.length ? finishedFeedbacks[finishedFeedbacks.length - 1].completed_at : null
	        }),
	        _react2.default.createElement(
	          _peerEvaluationModal2.default,
	          {
	            surveyId: survey.id,
	            show: show,
	            onHide: this.handleHideModal,
	            onSubmit: this.goToNextPage,
	            progressBar: progressBar,
	            submitButtonText: submitButtonText,
	            currentPage: currentPage ? Number(currentPage) : 0,
	            countOfPages: questionsCount ? Number(questionsCount) : 0,
	            goNext: this.goToNextPage,
	            goPrev: this.goToPrevPage,
	            canSubmit: hasAnswer,
	            isFinalScreen: isFinalScreen,
	            isTransitionScreen: isTransitionScreen,
	            readonlyMode: readonlyMode
	          },
	          showAlert && _react2.default.createElement(_warning2.default, {
	            title: "Warning! Incomplete",
	            message: "Your peer evaluation is not completed. Please make sure to complete your peer evaluation by the deadline.  ",
	            onSuccess: this.hideAlert,
	            successButtonText: "Got it",
	            showCancel: false
	          }),
	          showSubmissionError && _react2.default.createElement(_error2.default, {
	            title: "Submission failed",
	            message: "Submission failed. Please reach out to tech support (info@marketgames.io).",
	            onHide: this.hideSubmissionError
	          }),
	          !!currentQuestion && _react2.default.createElement(_peerEvaluationFeedback2.default, {
	            question: currentQuestion,
	            answers: currentQuestionAnswers,
	            self_assessment_count: self_assessment_count,
	            peer_rating_count: peer_rating_count,
	            skills_assessment_count: skills_assessment_count,
	            showError: showFeedbackError,
	            onChange: function onChange(result) {
	              return _this3.handleFeedbackOnChange(result);
	            },
	            teamList: teamList,
	            currentUserId: currentUserId,
	            feedbacks: feedbacks,
	            previousAnswers: previousAnswers,
	            readonlyMode: readonlyMode,
	            adjustedScore: adjustedScore
	          })
	        )
	      );
	    }
	  }]);
	
	  return PeerEvaluation;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.pasteTeamateName = function (text, name) {
	    var result = text;
	    var replacements = ['this teammate', '<insert teammate name>', '<insert name>', '<Insert User FirstName>'];
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = replacements[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var replacement = _step4.value;
	
	        result = result.replace(replacement, "<span>" + name + "</span>");
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	
	    return result;
	  };
	
	  this.formatFinalReflectionTitle = function (text, name) {
	    var likeStyle = 'color: #55B4BC;';
	    var wishStyle = 'color: #ECA427;';
	
	    return _this4.pasteTeamateName(text, name).replace('I Like', "<span style=\"" + likeStyle + "\">I Like</span>").replace('I Wish', "<span style=\"" + wishStyle + "\">I Wish</span>");
	  };
	
	  this.questionsOrder = function () {
	    var survey = _this4.props.survey;
	    var teamList = _this4.state.teamList;
	
	    var questions = survey.questions;
	
	    var self_assessment_questions = questions.filter(function (question) {
	      return question.category === "self_assessment";
	    });
	
	    var peer_rating_questions = questions.filter(function (question) {
	      return question.category === "collaboration" || question.category === "peer_rating";
	    });
	
	    var skills_assessment_questions = [];
	    var skills_assessment_base_questions = questions.filter(function (question) {
	      return question.category === "skills" || question.category === "other";
	    });
	
	    var isSkillsAssessmentVisible = _this4.isSkillsAssessmentVisible(survey.questions);
	    if (isSkillsAssessmentVisible) {
	      var _loop = function _loop(i) {
	        var teammate = teamList[i];
	
	        if (i < teamList.length) {
	          skills_assessment_questions.push({
	            answer_type: "transition_page",
	            username: teammate.fullname
	          });
	        }
	
	        skills_assessment_questions = [].concat(_toConsumableArray(skills_assessment_questions), _toConsumableArray(skills_assessment_base_questions.map(function (q) {
	          return Object.assign({}, q, {
	            text: _this4.pasteTeamateName(q.text, teammate.fullname),
	            userId: teammate.id
	          });
	        })));
	      };
	
	      for (var i = 0; i < teamList.length; i++) {
	        _loop(i);
	      }
	    }
	
	    var final_reflection_questions = [];
	    var final_reflection_base_questions = questions.filter(function (question) {
	      return question.category === "communication" && question.answer_type === "freeform";
	    });
	
	    var _loop2 = function _loop2(i) {
	      var teammate = teamList[i];
	
	      if (i < teamList.length) {
	        final_reflection_questions.push({
	          answer_type: "transition_page",
	          username: teammate.fullname
	        });
	      }
	
	      final_reflection_questions = [].concat(_toConsumableArray(final_reflection_questions), _toConsumableArray(final_reflection_base_questions.map(function (q) {
	        return Object.assign({}, q, {
	          text: _this4.formatFinalReflectionTitle(q.text, teammate.fullname),
	          userId: teammate.id
	        });
	      })));
	    };
	
	    for (var i = 0; i < teamList.length; i++) {
	      _loop2(i);
	    }
	
	    var questionsOrder = [{ answer_type: "self_assessment_intro" }].concat(_toConsumableArray(self_assessment_questions), [{ answer_type: "peer_rating_intro" }], _toConsumableArray(peer_rating_questions));
	
	    if (isSkillsAssessmentVisible) questionsOrder.push.apply(questionsOrder, [{ answer_type: "skills_assessment_intro" }].concat(_toConsumableArray(skills_assessment_questions)));
	
	    if (_this4.isFinalReflectionsVisible(survey.questions)) questionsOrder.push.apply(questionsOrder, [{ answer_type: "final_reflections_intro" }].concat(_toConsumableArray(final_reflection_questions)));
	
	    questionsOrder.push({ answer_type: "final_page" });
	
	    _this4.setState(function () {
	      return {
	        questionsOrder: questionsOrder,
	        questionsCount: questionsOrder.length - 1,
	        self_assessment_count: self_assessment_questions.length,
	        peer_rating_count: peer_rating_questions.length,
	        skills_assessment_count: skills_assessment_questions.length,
	        final_reflection_count: final_reflection_questions.length
	      };
	    });
	  };
	
	  this.isSkillsAssessmentVisible = function (questions) {
	    return questions.filter(function (question) {
	      return (question.category === 'other' || question.category === 'skills') && question.answer_type === 'freeform';
	    }).length > 0;
	  };
	
	  this.isFinalReflectionsVisible = function (questions) {
	    return questions.filter(function (question) {
	      return question.category === 'communication' && question.answer_type === 'freeform';
	    }).length > 0;
	  };
	
	  this.isSurveyEnded = function (survey) {
	    var endDate = (0, _moment2.default)(survey.end);
	    var currentDate = _moment2.default.utc();
	
	    return currentDate.isSameOrAfter(endDate);
	  };
	
	  this.isSurveyEndedWithExtended = function (survey) {
	    var endDate = (0, _moment2.default)(survey.end);
	    var endDateWithExtendedTime = (0, _moment2.default)(survey.end).add(survey.extended_time, 'hours');
	    var currentDate = _moment2.default.utc();
	
	    var endDatePassed = currentDate.isSameOrAfter(endDate);
	    var endDateWithExtendedTimePassed = currentDate.isSameOrAfter(endDateWithExtendedTime);
	
	    if (endDatePassed) {
	      if (!endDateWithExtendedTimePassed) {
	        return _this4.isSurveyCompleted();
	      }
	      return true;
	    }
	
	    return false;
	  };
	
	  this.isSurveyCompleted = function () {
	    var finishedFeedbacks = _this4.state.finishedFeedbacks;
	
	    var notCompletedSurveyFormsFeedbacks = finishedFeedbacks.filter(function (i) {
	      return i.completed === false;
	    });
	
	    return !!(finishedFeedbacks.length && !notCompletedSurveyFormsFeedbacks.length);
	  };
	
	  this.isSurveySubmitted = function () {
	    var _state5 = _this4.state,
	        currentUserId = _state5.currentUserId,
	        teamList = _state5.teamList,
	        finishedFeedbacks = _state5.finishedFeedbacks;
	
	    var feedbacks = finishedFeedbacks.filter(function (i) {
	      return i.completed === true;
	    });
	    var teammates = [].concat(_toConsumableArray(teamList.map(function (i) {
	      return i.id;
	    })), [currentUserId]);
	
	    var feedbackExists = true;
	
	    var _loop3 = function _loop3(_teammate) {
	      var feedback = feedbacks.find(function (i) {
	        return i.receiver === _teammate;
	      });
	      if (!feedback) {
	        feedbackExists = false;
	        return "break";
	      }
	    };
	
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = teammates[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var _teammate = _step5.value;
	
	        var _ret3 = _loop3(_teammate);
	
	        if (_ret3 === "break") break;
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	
	    return feedbackExists;
	  };
	
	  this.isSurveyHasFeedbacks = function () {
	    var finishedFeedbacks = _this4.state.finishedFeedbacks;
	
	
	    return finishedFeedbacks.length;
	  };
	
	  this.isSurveyStarted = function (survey) {
	    var startDate = (0, _moment2.default)(survey.start);
	    var endDate = (0, _moment2.default)(survey.end);
	    var currentDate = _moment2.default.utc();
	
	    return currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate.add(survey.extended_time, 'hours'));
	  };
	
	  this.isIntroScreen = function (nextPage) {
	    var questionsOrder = _this4.state.questionsOrder;
	
	    var type = questionsOrder[nextPage].answer_type;
	
	    return type === "self_assessment_intro" || type === "peer_rating_intro" || type === "skills_assessment_intro" || type === "final_reflections_intro";
	  };
	
	  this.isFinalScreen = function (nextPage) {
	    var questionsOrder = _this4.state.questionsOrder;
	
	    var type = questionsOrder[nextPage].answer_type;
	
	    return type === "final_page";
	  };
	
	  this.isBeforeTransitionScreen = function (nextPage) {
	    var questionsOrder = _this4.state.questionsOrder;
	
	    var currentType = questionsOrder[nextPage].answer_type;
	    var nextType = questionsOrder[nextPage + 1] ? questionsOrder[nextPage + 1].answer_type : null;
	
	    return (currentType === "self_assessment_intro" || currentType === "peer_rating_intro" || currentType === "skills_assessment_intro" || currentType === "final_reflections_intro") && nextType === "transition_page";
	  };
	
	  this.isTransitionScreen = function (nextPage) {
	    var questionsOrder = _this4.state.questionsOrder;
	
	    var type = questionsOrder[nextPage].answer_type;
	
	    return type === "transition_page";
	  };
	
	  this.handleShowModal = function () {
	    _this4.setState(function () {
	      return { show: true };
	    }, function () {
	      _this4.loadFeedback();
	    });
	  };
	
	  this.handleHideModal = function () {
	    var survey = _this4.props.survey;
	
	    (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks").then(function (res) {
	      var formsFeedbacks = res.body.results;
	      var notCompletedSurveyFormsFeedbacks = formsFeedbacks.filter(function (formsFeedback) {
	        return formsFeedback.survey === survey.id && formsFeedback.completed !== true;
	      });
	      if (notCompletedSurveyFormsFeedbacks.length && _Auth2.default.getPosition() === 'Student') {
	        _this4.showAlert();
	      } else {
	        _this4.resetPeerEvaluationPages();
	      }
	    }).catch(function (err) {});
	  };
	
	  this.showAlert = function () {
	    _this4.setState({
	      showAlert: true
	    });
	  };
	
	  this.hideAlert = function () {
	    _this4.setState({
	      showAlert: false
	    }, function () {
	      return _this4.resetPeerEvaluationPages();
	    });
	  };
	
	  this.showSubmissionError = function () {
	    _this4.setState({
	      showSubmissionError: true
	    });
	  };
	
	  this.hideSubmissionError = function () {
	    _this4.setState({
	      showSubmissionError: false
	    });
	  };
	
	  this.resetPeerEvaluationPages = function () {
	    _this4.setState(function (prevState) {
	      return {
	        show: false,
	        currentPage: 0,
	        isIntroScreen: true,
	        isFinalScreen: false,
	        isBeforeTransitionScreen: false,
	        isTransitionScreen: false,
	        submitPages: {},
	        progressBar: prevState.progressBar.map(function (item) {
	          return Object.assign({}, item, { progress: 0, isDisabled: item.id > 1 });
	        })
	      };
	    });
	  };
	
	  this.goToNextPage = function () {
	    var _state6 = _this4.state,
	        currentPage = _state6.currentPage,
	        questionsCount = _state6.questionsCount,
	        self_assessment_count = _state6.self_assessment_count,
	        peer_rating_count = _state6.peer_rating_count,
	        skills_assessment_count = _state6.skills_assessment_count,
	        final_reflection_count = _state6.final_reflection_count,
	        questionsOrder = _state6.questionsOrder,
	        answers = _state6.answers,
	        submitPages = _state6.submitPages,
	        readonlyMode = _state6.readonlyMode,
	        feedbacks = _state6.feedbacks;
	    var survey = _this4.props.survey;
	
	
	    var currentQuestionId = questionsOrder[currentPage].id;
	    var currentAnswers = answers.filter(function (answer) {
	      return !!currentQuestionId && answer.survey_question === currentQuestionId;
	    });
	    var hasError = !readonlyMode ? currentAnswers.some(function (answer) {
	      return answer.hasError === true;
	    }) : false;
	
	    var nextPage = hasError ? currentPage : currentPage + 1;
	    if (nextPage > questionsCount) {
	      nextPage = questionsCount;
	    }
	
	    if (!hasError && !readonlyMode) {
	      _this4.sendAnswers();
	    }
	
	    if (!readonlyMode && submitPages[currentPage] && submitPages[currentPage].completed === false) {
	      (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/" + submitPages[currentPage].id + "/").send({
	        giver: submitPages[currentPage].giver,
	        giver_team: submitPages[currentPage].giver_team,
	        receiver: submitPages[currentPage].receiver,
	        survey: submitPages[currentPage].survey,
	        completed: true
	      }).then(function () {}).catch(function () {});
	    }
	
	    var isIntroScreen = _this4.isIntroScreen(nextPage);
	    var isFinalScreen = _this4.isFinalScreen(nextPage);
	    var isBeforeTransitionScreen = _this4.isBeforeTransitionScreen(nextPage);
	    var isTransitionScreen = _this4.isTransitionScreen(nextPage);
	
	    var adjustedScore = 0;
	    if (!readonlyMode && currentPage === questionsCount - 1) {
	      var feedbackPromises = Object.keys(feedbacks).map(function (feedbackId) {
	        if (feedbacks[feedbackId].completed !== true) {
	          return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/" + feedbacks[feedbackId].id + "/").send(Object.assign({}, feedbacks[feedbackId], {
	            completed: true
	          })).then(function () {}).catch(function () {});
	        } else {
	          return Promise.resolve(); // Skip if already completed
	        }
	      });
	
	      Promise.all(feedbackPromises).then(function () {
	        // All feedback requests have completed, now make the post request
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/surveys/" + survey.id + "/submission-scoring/").then(_asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	          var maxAttempts, attempt, _ret4;
	
	          return _regenerator2.default.wrap(function _callee8$(_context8) {
	            while (1) {
	              switch (_context8.prev = _context8.next) {
	                case 0:
	                  maxAttempts = 3;
	                  attempt = 1;
	
	                  _this4.setState({
	                    submitButtonLoading: true
	                  });
	
	                case 3:
	                  if (!(attempt <= maxAttempts)) {
	                    _context8.next = 22;
	                    break;
	                  }
	
	                  if (!(attempt > 1)) {
	                    _context8.next = 7;
	                    break;
	                  }
	
	                  _context8.next = 7;
	                  return new Promise(function (resolve) {
	                    return setTimeout(resolve, 2500);
	                  });
	
	                case 7:
	                  _context8.prev = 7;
	                  return _context8.delegateYield(_regenerator2.default.mark(function _callee7() {
	                    var userId, res, feedbackSubmissionScores, adjustedScore;
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            userId = _Auth2.default.getUserId();
	                            _context7.next = 3;
	                            return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedback-submission-scores/" + userId + "/" + survey.id);
	
	                          case 3:
	                            res = _context7.sent;
	                            feedbackSubmissionScores = res.body;
	                            adjustedScore = feedbackSubmissionScores.adjusted_score;
	
	
	                            _this4.setState({
	                              submitButtonLoading: false
	                            }, function () {
	                              return _this4.setGoToNextPageState(nextPage, isIntroScreen, isFinalScreen, isBeforeTransitionScreen, isTransitionScreen, self_assessment_count, peer_rating_count, skills_assessment_count, final_reflection_count, hasError, adjustedScore);
	                            });
	                            return _context7.abrupt("return", "break");
	
	                          case 8:
	                          case "end":
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this4);
	                  })(), "t0", 9);
	
	                case 9:
	                  _ret4 = _context8.t0;
	
	                  if (!(_ret4 === "break")) {
	                    _context8.next = 12;
	                    break;
	                  }
	
	                  return _context8.abrupt("break", 22);
	
	                case 12:
	                  _context8.next = 20;
	                  break;
	
	                case 14:
	                  _context8.prev = 14;
	                  _context8.t1 = _context8["catch"](7);
	
	                  if (!(attempt >= maxAttempts)) {
	                    _context8.next = 19;
	                    break;
	                  }
	
	                  _this4.setState({
	                    submitButtonLoading: false
	                  }, function () {
	                    return _this4.showSubmissionError();
	                  });
	                  return _context8.abrupt("break", 22);
	
	                case 19:
	
	                  attempt++;
	
	                case 20:
	                  _context8.next = 3;
	                  break;
	
	                case 22:
	                case "end":
	                  return _context8.stop();
	              }
	            }
	          }, _callee8, _this4, [[7, 14]]);
	        }))).catch(function () {});
	      });
	    } else {
	      _this4.setGoToNextPageState(nextPage, isIntroScreen, isFinalScreen, isBeforeTransitionScreen, isTransitionScreen, self_assessment_count, peer_rating_count, skills_assessment_count, final_reflection_count, hasError, adjustedScore);
	    }
	  };
	
	  this.setGoToNextPageState = function (nextPage, isIntroScreen, isFinalScreen, isBeforeTransitionScreen, isTransitionScreen, self_assessment_count, peer_rating_count, skills_assessment_count, final_reflection_count, hasError, adjustedScore) {
	    var finalReflectionsProgressAdjuster = skills_assessment_count ? 3 : 2;
	    var finalReflectionsDisabledAdjuster = skills_assessment_count ? 2 : 1;
	    _this4.setState(function (prevState) {
	      return {
	        currentPage: nextPage,
	        isIntroScreen: isIntroScreen,
	        isFinalScreen: isFinalScreen,
	        isBeforeTransitionScreen: isBeforeTransitionScreen,
	        isTransitionScreen: isTransitionScreen,
	        showFeedbackError: hasError,
	        adjustedScore: adjustedScore,
	        progressBar: prevState.progressBar.map(function (item) {
	          return item.id === 1 ? Object.assign({}, item, {
	            progress: Math.min(nextPage / self_assessment_count * 100, 100)
	          }) : item.id === 2 ? Object.assign({}, item, {
	            progress: Math.min(Math.max(nextPage - self_assessment_count - 1, 0) / peer_rating_count * 100, 100),
	            isDisabled: nextPage <= self_assessment_count
	          }) : item.id === 3 ? Object.assign({}, item, {
	            progress: Math.min(Math.max(nextPage - self_assessment_count - peer_rating_count - 2, 0) / skills_assessment_count * 100, 100),
	            isDisabled: nextPage <= self_assessment_count + peer_rating_count + 1
	          }) : item.id === 4 ? Object.assign({}, item, {
	            progress: Math.min(Math.max(nextPage - self_assessment_count - peer_rating_count - skills_assessment_count - finalReflectionsProgressAdjuster, 0) / final_reflection_count * 100, 100),
	            isDisabled: nextPage <= self_assessment_count + peer_rating_count + skills_assessment_count + finalReflectionsDisabledAdjuster
	          }) : item;
	        })
	      };
	    });
	  };
	
	  this.goToPrevPage = function () {
	    var _state7 = _this4.state,
	        currentPage = _state7.currentPage,
	        self_assessment_count = _state7.self_assessment_count,
	        peer_rating_count = _state7.peer_rating_count,
	        skills_assessment_count = _state7.skills_assessment_count,
	        final_reflection_count = _state7.final_reflection_count,
	        questionsOrder = _state7.questionsOrder,
	        answers = _state7.answers,
	        readonlyMode = _state7.readonlyMode;
	
	
	    var currentQuestionId = questionsOrder[currentPage].id;
	    var currentAnswers = answers.filter(function (answer) {
	      return !!currentQuestionId && answer.survey_question === currentQuestionId;
	    });
	    var hasError = !readonlyMode ? currentAnswers.some(function (answer) {
	      return answer.hasError === true;
	    }) : false;
	
	    var prevPage = hasError ? currentPage : currentPage - 1;
	    if (prevPage < 1) {
	      prevPage = 1;
	    }
	
	    if (!hasError && !readonlyMode) {
	      _this4.sendAnswers();
	    }
	
	    var isIntroScreen = _this4.isIntroScreen(prevPage);
	    var isFinalScreen = _this4.isFinalScreen(prevPage);
	    var isBeforeTransitionScreen = _this4.isBeforeTransitionScreen(prevPage);
	    var isTransitionScreen = _this4.isTransitionScreen(prevPage);
	
	    var finalReflectionsProgressAdjuster = skills_assessment_count ? 3 : 2;
	    var finalReflectionsDisabledAdjuster = skills_assessment_count ? 2 : 1;
	    _this4.setState(function (prevState) {
	      return {
	        currentPage: prevPage,
	        isIntroScreen: isIntroScreen,
	        isFinalScreen: isFinalScreen,
	        isBeforeTransitionScreen: isBeforeTransitionScreen,
	        isTransitionScreen: isTransitionScreen,
	        showFeedbackError: hasError,
	        progressBar: prevState.progressBar.map(function (item) {
	          return item.id === 1 ? Object.assign({}, item, {
	            progress: Math.min(prevPage / self_assessment_count * 100, 100)
	          }) : item.id === 2 ? Object.assign({}, item, {
	            progress: Math.min(Math.max(prevPage - self_assessment_count - 1, 0) / peer_rating_count * 100, 100),
	            isDisabled: prevPage <= self_assessment_count
	          }) : item.id === 3 ? Object.assign({}, item, {
	            progress: Math.min(Math.max(prevPage - self_assessment_count - peer_rating_count - 2, 0) / skills_assessment_count * 100, 100),
	            isDisabled: prevPage <= self_assessment_count + peer_rating_count + 1
	          }) : item.id === 4 ? Object.assign({}, item, {
	            progress: Math.min(Math.max(prevPage - self_assessment_count - peer_rating_count - skills_assessment_count - finalReflectionsProgressAdjuster, 0) / final_reflection_count * 100, 100),
	            isDisabled: prevPage <= self_assessment_count + peer_rating_count + skills_assessment_count + finalReflectionsDisabledAdjuster
	          }) : item;
	        })
	      };
	    });
	  };
	
	  this.handleFeedbackOnChange = function (result) {
	    var _state8 = _this4.state,
	        answers = _state8.answers,
	        showFeedbackError = _state8.showFeedbackError;
	
	    var id = result.id,
	        feedback = result.feedback,
	        rest = _objectWithoutProperties(result, ["id", "feedback"]);
	
	    if (feedback) {
	      var hasError = result.hasError ? showFeedbackError : false;
	      var answerIndex = answers.findIndex(function (i) {
	        return i.survey_question === id && i.feedback === feedback;
	      });
	      var newAnswers = [].concat(_toConsumableArray(answers));
	      if (answerIndex >= 0) {
	        newAnswers[answerIndex] = Object.assign({
	          id: answers[answerIndex].id,
	          survey_question: id,
	          feedback: feedback
	        }, rest, {
	          isModified: true
	        });
	      } else {
	        newAnswers.push(Object.assign({
	          id: 0,
	          survey_question: id,
	          feedback: feedback
	        }, rest, {
	          isModified: true
	        }));
	      }
	
	      _this4.setState({
	        answers: newAnswers,
	        showFeedbackError: hasError
	      });
	    }
	  };
	
	  this.getPreviousAnswers = function (currentPage, userId) {
	    var _state9 = _this4.state,
	        questionsOrder = _state9.questionsOrder,
	        answers = _state9.answers,
	        feedbacks = _state9.feedbacks;
	
	    if (!userId) {
	      return [];
	    }
	
	    var pages = Object.keys(questionsOrder).map(function (page) {
	      return Number(page);
	    });
	    var filteredPages = pages.filter(function (page) {
	      return page < currentPage;
	    }).map(function (page) {
	      return questionsOrder[page];
	    }).filter(function (page) {
	      return !!page.userId && page.userId === userId;
	    });
	    var questions = [];
	
	    var _loop4 = function _loop4(page) {
	      var feedback = feedbacks[page.userId];
	      if (!feedback) {
	        return "continue";
	      }
	
	      var answer = answers.find(function (i) {
	        return i.survey_question === page.id && i.feedback === feedback.id;
	      });
	      var values = page.category === 'communication' ? [answer.value] : answer.value.split(', ');
	      var filteredValues = values.filter(function (i) {
	        return !!i && i !== '';
	      });
	
	      var _loop5 = function _loop5(val) {
	        if (Number(val) > 0) {
	          var statement = page.statements.find(function (i) {
	            return i.id === Number(val);
	          });
	          if (statement && !questions.includes(statement.text)) {
	            questions.push(statement.text);
	          }
	        } else if (!questions.includes(val)) {
	          questions.push(val);
	        }
	      };
	
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = filteredValues[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var val = _step7.value;
	
	          _loop5(val);
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	    };
	
	    var _iteratorNormalCompletion6 = true;
	    var _didIteratorError6 = false;
	    var _iteratorError6 = undefined;
	
	    try {
	      for (var _iterator6 = filteredPages[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	        var page = _step6.value;
	
	        var _ret5 = _loop4(page);
	
	        if (_ret5 === "continue") continue;
	      }
	    } catch (err) {
	      _didIteratorError6 = true;
	      _iteratorError6 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion6 && _iterator6.return) {
	          _iterator6.return();
	        }
	      } finally {
	        if (_didIteratorError6) {
	          throw _iteratorError6;
	        }
	      }
	    }
	
	    return questions;
	  };
	};
	
	exports.default = PeerEvaluation;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconCheckCircle = __webpack_require__(1847);
	
	var _iconCheckCircle2 = _interopRequireDefault(_iconCheckCircle);
	
	var _iconCheckCircleActive = __webpack_require__(1845);
	
	var _iconCheckCircleActive2 = _interopRequireDefault(_iconCheckCircleActive);
	
	var _iconCheckSquare = __webpack_require__(1848);
	
	var _iconCheckSquare2 = _interopRequireDefault(_iconCheckSquare);
	
	var _iconCheckCircleDisabled = __webpack_require__(1846);
	
	var _iconCheckCircleDisabled2 = _interopRequireDefault(_iconCheckCircleDisabled);
	
	var _timeIcon = __webpack_require__(1864);
	
	var _timeIcon2 = _interopRequireDefault(_timeIcon);
	
	var _timeIconActive = __webpack_require__(1863);
	
	var _timeIconActive2 = _interopRequireDefault(_timeIconActive);
	
	var _marketButton = __webpack_require__(307);
	
	var _marketButton2 = _interopRequireDefault(_marketButton);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _jstz = __webpack_require__(276);
	
	var _jstz2 = _interopRequireDefault(_jstz);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getButtonText = function getButtonText(isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtendedWithExtended, viewOnly) {
	  if (isEndedWithExtendedWithExtended || viewOnly) {
	    return "View";
	  }
	
	  if (isSubmitted || isEnded && !isEndedWithExtendedWithExtended) {
	    return "Edit";
	  }
	
	  if (isStarted && hasFeedbacks) {
	    return "Continue";
	  }
	
	  return "Start";
	};
	
	var getTimestampMark = function getTimestampMark(isStarted, isEndedWithExtended) {
	  if (isStarted || isEndedWithExtended) {
	    return "Due ";
	  } else {
	    return "Open ";
	  }
	};
	
	var getButtonType = function getButtonType(isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtended, onClick, viewOnly) {
	  var buttonText = getButtonText(isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtended, viewOnly);
	
	  if (isSubmitted || isEndedWithExtended || viewOnly) {
	    return _react2.default.createElement(
	      _marketButton2.default,
	      { variant: "primary", type: "outlined", onClick: onClick },
	      buttonText
	    );
	  } else {
	    return _react2.default.createElement(
	      _marketButton2.default,
	      {
	        variant: "error",
	        type: "solid",
	        disabled: !isStarted,
	        onClick: onClick
	      },
	      buttonText
	    );
	  }
	};
	
	var getCorrectDate = function getCorrectDate(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  return _momentTimezone2.default.utc().isAfter(start) ? end : start;
	};
	
	var PeerEvaluationCard = function PeerEvaluationCard(props) {
	  var isSubmitted = props.isSubmitted,
	      hasFeedbacks = props.hasFeedbacks,
	      isEnded = props.isEnded,
	      isEndedWithExtended = props.isEndedWithExtended,
	      isSurveyCompleted = props.isSurveyCompleted,
	      _props$defaultPeerEva = props.defaultPeerEvaluationCard,
	      defaultPeerEvaluationCard = _props$defaultPeerEva === undefined ? true : _props$defaultPeerEva,
	      isStarted = props.isStarted,
	      onClick = props.onClick,
	      survey = props.survey,
	      displayCheckMark = props.displayCheckMark,
	      viewOnly = props.viewOnly,
	      completedAt = props.completedAt;
	  var name = survey.name;
	
	  var checkMarkSrc = defaultPeerEvaluationCard ? isSubmitted ? _iconCheckCircleActive2.default : _iconCheckCircle2.default : isSurveyCompleted ? _iconCheckCircleActive2.default : isEndedWithExtended ? _iconCheckCircleDisabled2.default : _iconCheckSquare2.default;
	
	  var timezone = _jstz2.default.determine();
	  var completedDate = (0, _momentTimezone2.default)(completedAt).tz(timezone.name()).format("MMM DD hh:mm A");
	
	  return _react2.default.createElement(
	    "div",
	    { className: "peerCard" },
	    displayCheckMark && _react2.default.createElement(
	      "div",
	      { className: "peerCard__status" },
	      _react2.default.createElement("img", { alt: "Check Mark", src: checkMarkSrc })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "peerCard__info" },
	      _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("peerCard__info__title", {
	            is_ended: isEnded
	          }) },
	        name
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("peerCard__info__date", {
	            is_ended: isEnded
	          }) },
	        _react2.default.createElement("img", { alt: "Time Icon", src: isEnded ? _timeIcon2.default : _timeIconActive2.default }),
	        getTimestampMark(isStarted, isEnded),
	        (0, _momentTimezone2.default)(getCorrectDate(survey)).format("MMM DD hh:mm A")
	      )
	    ),
	    !defaultPeerEvaluationCard && _react2.default.createElement(
	      "div",
	      { className: "peerCard__status-text" },
	      isSurveyCompleted && _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "completed" },
	          "Completed"
	        ),
	        completedAt && _react2.default.createElement(
	          "p",
	          { className: "completed-date" },
	          "Date: ",
	          completedDate
	        )
	      ),
	      !isSurveyCompleted && _react2.default.createElement(
	        "p",
	        { className: "not-completed" },
	        "Incomplete"
	      )
	    ),
	    getButtonType(isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtended, onClick, viewOnly)
	  );
	};
	
	PeerEvaluationCard.propTypes = {};
	
	exports.default = PeerEvaluationCard;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 12px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 10px;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Roboto\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  margin-right: 20px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 20px;\n    height: 20px;\n    margin-right: 14px;\n  }\n\n  &', '}\n  \n  &', '}\n  \n  &', '\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Roboto\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 13px;\n  letter-spacing: 1px;\n  margin-right: 20px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 20px;\n    height: 20px;\n    margin-right: 14px;\n  }\n\n  &', '}\n  \n  &', '}\n  \n  &', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _recharts = __webpack_require__(27);
	
	var _ui = __webpack_require__(50);
	
	var _polarAngleAxis = __webpack_require__(1261);
	
	var _polarAngleAxis2 = _interopRequireDefault(_polarAngleAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartTitle = _styledComponents2.default.h2(_templateObject);
	
	var ChartLegendsContainer = _styledComponents2.default.div(_templateObject2);
	
	var ChartLegend = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.isFinal && ':before {\n    background: #A98DF6;\n  }';
	}, function (p) {
	  return p.isSecond && ':before {\n    background: #52C5CD;\n  }';
	}, function (p) {
	  return p.isInitial && ':before {\n    background: #ECA427;\n  }';
	});
	
	var SkillsChart = function (_Component) {
	  _inherits(SkillsChart, _Component);
	
	  function SkillsChart() {
	    _classCallCheck(this, SkillsChart);
	
	    return _possibleConstructorReturn(this, (SkillsChart.__proto__ || Object.getPrototypeOf(SkillsChart)).apply(this, arguments));
	  }
	
	  _createClass(SkillsChart, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          data = _props.data,
	          showData = _props.showData;
	
	
	      var secondDataLegend = showData.final ? 'Skills (previous)' : 'Skills (As of now)';
	
	      return _react2.default.createElement(
	        _ui.ContentContainerWithBackground,
	        null,
	        _react2.default.createElement(
	          ChartTitle,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: '100%', height: 300 },
	          _react2.default.createElement(
	            _recharts.RadarChart,
	            { cx: '50%', cy: '50%', outerRadius: '80%', data: data, margin: { bottom: 50 } },
	            _react2.default.createElement(_recharts.PolarGrid, null),
	            _react2.default.createElement(_recharts.PolarAngleAxis, {
	              dataKey: 'question',
	              tick: function tick(props) {
	                return (0, _polarAngleAxis2.default)(props);
	              },
	              cx: 10,
	              cy: 10
	            }),
	            _react2.default.createElement(_recharts.Radar, {
	              dataKey: 'initial',
	              stroke: '#F9C151',
	              strokeWidth: 2,
	              fill: 'rgba(254, 198, 101, 0.25)',
	              cx: 10,
	              cy: 10,
	              dot: { stroke: '#F9C151', strokeWidth: 3, r: 2, strokeDasharray: '' }
	            }),
	            showData.second && _react2.default.createElement(_recharts.Radar, {
	              dataKey: 'second',
	              stroke: '#55B4BC',
	              strokeWidth: 2,
	              fill: 'rgba(82, 197, 205, 0.5)',
	              cx: 10,
	              cy: 10,
	              dot: { stroke: '#55B4BC', strokeWidth: 3, r: 2, strokeDasharray: '' }
	            }),
	            showData.final && _react2.default.createElement(_recharts.Radar, {
	              dataKey: 'final',
	              stroke: '#A98DF6',
	              strokeWidth: 2,
	              fill: 'rgba(169, 141, 246, 0.5)',
	              cx: 10,
	              cy: 10,
	              dot: { stroke: '#A98DF6', strokeWidth: 3, r: 2, strokeDasharray: '' }
	            }),
	            _react2.default.createElement(_recharts.PolarRadiusAxis, {
	              angle: 90,
	              orientation: 'left',
	              domain: [0, 5],
	              ticks: [1, 2, 3, 4, 5],
	              tickCount: 6,
	              style: {
	                transform: 'translateY(5px)',
	                fill: '#667689'
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          ChartLegendsContainer,
	          null,
	          showData.final && _react2.default.createElement(
	            ChartLegend,
	            { isFinal: true },
	            'Skills (As of now)'
	          ),
	          showData.second && _react2.default.createElement(
	            ChartLegend,
	            { isSecond: true },
	            secondDataLegend
	          ),
	          _react2.default.createElement(
	            ChartLegend,
	            { isInitial: true },
	            'Skills (Initial)'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SkillsChart;
	}(_react.Component);
	
	exports.default = SkillsChart;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 26px;\n  color: #36507e;\n  margin-top: -80px;\n  margin-bottom: 60px;\n"], ["\n  text-align: center;\n  font-size: 26px;\n  color: #36507e;\n  margin-top: -80px;\n  margin-bottom: 60px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"], ["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  padding: 10px 40px 25px !important;\n"], ["\n  padding: 10px 40px 25px !important;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"], ["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"], ["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"], ["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"], ["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"], ["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  max-width: 530px;\n"], ["\n  max-width: 530px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(367);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recharts = __webpack_require__(27);
	
	var _rating = __webpack_require__(306);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartTitle = _styledComponents2.default.div(_templateObject);
	
	var ModalWrapper = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject2);
	
	var ModalHeader = (0, _styledComponents2.default)(_reactBootstrap.Modal.Header)(_templateObject3);
	
	var ModalBody = (0, _styledComponents2.default)(_reactBootstrap.Modal.Body)(_templateObject4);
	
	var ModalTitle = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	});
	
	var ModalQuestion = _styledComponents2.default.div(_templateObject6);
	
	var ModalFeedbackValue = _styledComponents2.default.div(_templateObject7);
	
	var RatingText = _styledComponents2.default.div(_templateObject8);
	
	var RatingRow = _styledComponents2.default.div(_templateObject9);
	
	var AnswerWrapper = _styledComponents2.default.div(_templateObject10);
	
	var AnswerRow = _styledComponents2.default.div(_templateObject11);
	
	var AnswerCounter = _styledComponents2.default.div(_templateObject12);
	
	var AnswerText = _styledComponents2.default.div(_templateObject13);
	
	var BarChartWrapper = _styledComponents2.default.div(_templateObject14);
	
	var getAllValues = function getAllValues(reports) {
	  return Object.values(reports).map(function (report) {
	    return [Number(report.median_user_score.toFixed(2)), Number(report.team_average_score.toFixed(2)), Number(report.team_median_score.toFixed(2))];
	  }).reduce(function (result, currentArray) {
	    return [].concat(_toConsumableArray(result), _toConsumableArray(currentArray));
	  }, []);
	};
	
	var MODAL_TYPE_INITIAL = 0;
	//const MODAL_TYPE_POSITIVE = 1;
	//const MODAL_TYPE_NEGATIVE = 2;
	var MODAL_TYPE_SELF_REFLECTION = 1;
	
	var SurveyChart = function (_Component) {
	  _inherits(SurveyChart, _Component);
	
	  function SurveyChart(props) {
	    _classCallCheck(this, SurveyChart);
	
	    var _this = _possibleConstructorReturn(this, (SurveyChart.__proto__ || Object.getPrototypeOf(SurveyChart)).call(this, props));
	
	    _this.showModal = function (currentReport, stage) {
	      var surveys = _this.props.surveys;
	
	      var currentSurvey = surveys.find(function (survey) {
	        return survey.stage === stage;
	      });
	      _this.setState({
	        currentReport: currentReport,
	        currentSurvey: currentSurvey,
	        currentPage: 0,
	        currentType: MODAL_TYPE_INITIAL
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        currentReport: null,
	        currentSurvey: null
	      });
	    };
	
	    _this.getQuestions = function (currentType) {
	      var _this$state = _this.state,
	          currentReport = _this$state.currentReport,
	          currentSurvey = _this$state.currentSurvey;
	
	
	      if (!currentReport || !currentSurvey) {
	        return [];
	      }
	
	      var questions = [];
	      if (currentType === MODAL_TYPE_INITIAL) {
	        questions = currentReport.average_user_score_question;
	      } /*else if (currentType === MODAL_TYPE_POSITIVE) {
	        const ids = currentSurvey.questions
	          .filter(
	            question =>
	              question.answer_type === "freeform" &&
	              question.category === "communication"
	          )
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        } else if (currentType === MODAL_TYPE_NEGATIVE) {
	        const ids = currentSurvey.questions
	          .filter(
	            question =>
	              question.assessment_type === "negative" &&
	              question.category !== "self_assessment"
	          )
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        }*/else if (currentType === MODAL_TYPE_SELF_REFLECTION) {
	          var ids = currentSurvey.questions.filter(function (question) {
	            return question.category === "self_assessment";
	          }).map(function (question) {
	            return question.id;
	          });
	          questions = currentReport.freeform_answers.filter(function (answer) {
	            return ids.includes(answer.survey_question);
	          });
	        }
	
	      var needSkip = currentSurvey.questions.filter(function (i) {
	        return i.most_valuable === true || i.work_together === true;
	      }).map(function (i) {
	        return i.id;
	      });
	
	      if (currentType !== MODAL_TYPE_INITIAL) {
	        questions = questions.filter(function (i) {
	          return !needSkip.includes(i.survey_question);
	        });
	      }
	
	      return _lodash2.default.chunk(questions, 4);
	    };
	
	    _this.nextPage = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          currentType = _this$state2.currentType;
	
	
	      if (currentPage < _this.questions.length - 1) {
	        _this.setState({
	          currentPage: currentPage + 1
	        });
	      } else if (currentType === 0) {
	        _this.setState({
	          currentPage: 0,
	          currentType: currentType + 1
	        });
	      }
	    };
	
	    _this.goBack = function () {
	      var _this$state3 = _this.state,
	          currentPage = _this$state3.currentPage,
	          currentType = _this$state3.currentType;
	
	
	      if (currentPage > 0) {
	        _this.setState({
	          currentPage: currentPage - 1
	        });
	      } else if (currentType > 0) {
	        var prevQuestions = _this.getQuestions(currentType - 1);
	
	        _this.setState({
	          currentPage: prevQuestions.length - 1,
	          currentType: currentType - 1
	        });
	      }
	    };
	
	    _this.state = {
	      currentSurvey: null,
	      currentReport: null,
	      currentPage: 0,
	      currentType: MODAL_TYPE_INITIAL
	    };
	    return _this;
	  }
	
	  _createClass(SurveyChart, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _reactChartjs.Chart.Tooltip.positioners.custom = function (elements) {
	        if (!elements.length) {
	          return false;
	        }
	
	        var i = void 0,
	            len = void 0;
	        var y = 0;
	        var count = 0;
	        var nearestElement = void 0;
	
	        for (i = 0, len = elements.length; i < len; ++i) {
	          var el = elements[i];
	          if (el && el.hasValue()) {
	            if (!nearestElement) {
	              nearestElement = el;
	            }
	            var pos = el.tooltipPosition();
	            y += pos.y;
	            ++count;
	          }
	        }
	
	        var barOffset = nearestElement ? Math.round(nearestElement.getArea() / 45 + 20) : 0;
	
	        return {
	          x: barOffset + 40,
	          y: Math.round(y / count)
	        };
	      };
	
	      _reactChartjs.Chart.pluginService.register({
	        beforeRender: function beforeRender(chart) {
	          if (chart.config.options.showAllTooltips) {
	            chart.pluginTooltips = [];
	            chart.config.data.datasets.forEach(function (_, i) {
	              chart.getDatasetMeta(i).data.forEach(function (sector, j) {
	                chart.pluginTooltips.push(new _reactChartjs.Chart.Tooltip({
	                  _chart: chart.chart,
	                  _chartInstance: chart,
	                  _data: chart.data,
	                  _options: chart.options.tooltips,
	                  _active: [sector]
	                }, chart));
	              });
	            });
	
	            chart.options.tooltips.enabled = false;
	          }
	        },
	
	        afterDraw: function afterDraw(chart, easing) {
	          if (chart.config.options.showAllTooltips) {
	            if (!chart.allTooltipsOnce) {
	              if (easing !== 1) {
	                return;
	              }
	
	              chart.allTooltipsOnce = true;
	            }
	
	            chart.options.tooltips.enabled = true;
	            _reactChartjs.Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
	              tooltip.initialize();
	              tooltip.update();
	              tooltip.pivot();
	              tooltip.transition(easing).draw();
	            });
	            chart.options.tooltips.enabled = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          reports = _props.reports,
	          isSurveyFinished = _props.isSurveyFinished;
	      var _state = this.state,
	          currentReport = _state.currentReport,
	          currentPage = _state.currentPage,
	          currentType = _state.currentType;
	
	      var allValues = getAllValues(reports);
	      var isBarChart = Object.keys(reports).length === 1 ? true : false;
	      var options = {
	        legend: {
	          display: false
	        },
	        scales: {
	          xAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              min: 0,
	              max: Math.max.apply(null, allValues),
	              callback: function callback() {
	                return "";
	              }
	            }
	          }],
	          yAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              callbacks: function callbacks() {
	                return "";
	              }
	            }
	          }]
	        },
	        tooltips: {
	          enabled: true,
	          mode: "point",
	          position: "custom",
	          backgroundColor: "transparent",
	          bodyFontFamily: "Lato",
	          bodyFontSize: 16,
	          bodyFontStyle: "bold",
	          bodyFontColor: "#2a4169",
	          bodyAlign: "center",
	          displayColors: false,
	          xPadding: 0,
	          yPadding: 0,
	          bodySpacing: 0,
	          callbacks: {
	            title: function title() {
	              return "";
	            },
	            label: function label(tooltipItem) {
	              return (Math.round(tooltipItem.value * 100) / 100).toFixed(2);
	            }
	          }
	        },
	        showAllTooltips: true,
	        layout: {
	          padding: {
	            right: 40
	          }
	        }
	      };
	
	      var getReportForBar = function getReportForBar(key, label, backgroundColor) {
	        return {
	          label: label,
	          data: Object.values(Object.keys(reports).reduce(function (result, stage) {
	            return Object.assign({}, result, _defineProperty({}, stage, Number(reports[stage][key].toFixed(2))));
	          }, {})),
	          backgroundColor: backgroundColor,
	          borderWidth: 0,
	          minBarLength: 20,
	          barPercentage: 0.8,
	          maxBarThickness: 45
	        };
	      };
	
	      var data = {
	        labels: [""],
	        datasets: [getReportForBar("median_user_score", "You", _Teams2.default.currentTeamColor()), getReportForBar("team_average_score", "Team Average", "#eee"), getReportForBar("team_median_score", "Team Median", "#c4c4c4")],
	        options: options
	      };
	      var surveys = this.props.surveys.filter(function (survey) {
	        return isSurveyFinished(survey);
	      }).map(function (survey) {
	        return survey.stage;
	      });
	      if (surveys.length < 3) {
	        for (var i = 0; i < 3 - surveys.length; i++) {
	          surveys.push("");
	        }
	      }
	
	      var stages = {
	        initial: "Initial Feedback",
	        second: "Second Feedback",
	        final: "Final Feedback"
	      };
	      var tmpData = Object.keys(reports).map(function (stage) {
	        return {
	          name: stages[stage],
	          You: Number(reports[stage].median_user_score.toFixed(2)),
	          "Team Average": Number(reports[stage].team_average_score.toFixed(2)),
	          "Team Median": Number(reports[stage].team_median_score.toFixed(2))
	        };
	      });
	
	      var initial = tmpData.find(function (i) {
	        return i.name === "Initial Feedback";
	      });
	      if (!initial) {
	        initial = {
	          name: "Initial Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var second = tmpData.find(function (i) {
	        return i.name === "Second Feedback";
	      });
	      if (!second) {
	        second = {
	          name: "Second Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var final = tmpData.find(function (i) {
	        return i.name === "Final Feedback";
	      });
	      if (!final) {
	        final = {
	          name: "Final Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var chartData = [initial, second, final];
	      var isShowModal = currentReport ? true : false;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          ChartTitle,
	          null,
	          title
	        ),
	        !isBarChart && _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 300 },
	          _react2.default.createElement(
	            _recharts.LineChart,
	            {
	              data: chartData,
	              margin: {
	                top: 0,
	                right: 0,
	                left: 0,
	                bottom: 0
	              }
	            },
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(_recharts.XAxis, {
	              dataKey: "name",
	              padding: { top: 30, left: 30, right: 30, bottom: 30 },
	              hide: true
	            }),
	            _react2.default.createElement(_recharts.YAxis, {
	              hide: true,
	              domain: [Math.min.apply(null, allValues) * 0.9, Math.max.apply(null, allValues) * 1.1]
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "You",
	              stroke: _Teams2.default.currentTeamColor(),
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Average",
	              stroke: "#eee",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Median",
	              stroke: "#c4c4c4",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            })
	          )
	        ),
	        isBarChart && _react2.default.createElement(
	          BarChartWrapper,
	          null,
	          _react2.default.createElement(_reactChartjs.HorizontalBar, { data: data, options: options })
	        ),
	        isShowModal === true && _react2.default.createElement(
	          ModalWrapper,
	          { show: true, onHide: this.hideModal },
	          _react2.default.createElement(
	            ModalHeader,
	            { closeButton: true },
	            _react2.default.createElement(
	              ModalTitle,
	              { align: "left" },
	              this.modalTitle
	            ),
	            currentType === MODAL_TYPE_INITIAL && _react2.default.createElement(
	              ModalTitle,
	              { align: "right" },
	              "Collaboration"
	            )
	          ),
	          _react2.default.createElement(
	            ModalBody,
	            null,
	            currentType === MODAL_TYPE_INITIAL && this.questionsList.map(function (_ref, i) {
	              var question = _ref.question,
	                  rating = _ref.value;
	              return _react2.default.createElement(
	                "div",
	                { key: currentType + "-" + (currentPage * 4 + i + 1) },
	                _react2.default.createElement(
	                  ModalQuestion,
	                  null,
	                  currentPage * 4 + i + 1,
	                  ". ",
	                  question
	                ),
	                _react2.default.createElement(
	                  RatingRow,
	                  null,
	                  _react2.default.createElement(
	                    ModalFeedbackValue,
	                    null,
	                    Number(rating.toFixed(2))
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      RatingText,
	                      null,
	                      "Average Rating"
	                    ),
	                    _react2.default.createElement(_rating2.default, { value: rating })
	                  )
	                )
	              );
	            }),
	            currentType !== MODAL_TYPE_INITIAL && _react2.default.createElement(
	              AnswerWrapper,
	              null,
	              this.questionsList.map(function (_ref2, i) {
	                var text = _ref2.text;
	                return _react2.default.createElement(
	                  AnswerRow,
	                  {
	                    key: currentType + "-" + (currentPage * 4 + i + 1)
	                  },
	                  _react2.default.createElement(
	                    AnswerCounter,
	                    null,
	                    currentPage * 4 + i + 1
	                  ),
	                  _react2.default.createElement(
	                    AnswerText,
	                    null,
	                    text
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "questions",
	    get: function get() {
	      var currentType = this.state.currentType;
	
	
	      return this.getQuestions(currentType);
	    }
	  }, {
	    key: "questionsList",
	    get: function get() {
	      var currentPage = this.state.currentPage;
	
	      var questions = this.questions;
	      var result = currentPage < questions.length ? questions[currentPage] : [];
	      var team = _Teams2.default.currentTeam();
	      var players = _Teams2.default.players();
	      var teammates = players.filter(function (player) {
	        return player.team === team.id && player.user.id !== parseInt(_Auth2.default.getUserId(), 10);
	      }).map(function (teammate) {
	        return teammate.user.username;
	      });
	
	      return result.filter(function (answer) {
	        return !teammates.includes(answer.text);
	      });
	    }
	  }, {
	    key: "isFirstPage",
	    get: function get() {
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          currentType = _state2.currentType;
	
	
	      return currentPage === 0 && currentType === MODAL_TYPE_INITIAL ? true : false;
	    }
	  }, {
	    key: "isLastPage",
	    get: function get() {
	      var _state3 = this.state,
	          currentPage = _state3.currentPage,
	          currentType = _state3.currentType;
	
	
	      if (currentPage === this.questions.length - 1) {
	        if (currentType === 0) {
	          var nextQuestions = this.getQuestions(currentType + 1);
	
	          if (nextQuestions.length === 0) {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "modalTitle",
	    get: function get() {
	      var _titles;
	
	      var currentType = this.state.currentType;
	
	      var titles = (_titles = {}, _defineProperty(_titles, MODAL_TYPE_INITIAL, "Initial Feedback"), _defineProperty(_titles, MODAL_TYPE_SELF_REFLECTION, "Self Reflection"), _titles);
	
	      return titles[currentType];
	    }
	  }]);
	
	  return SurveyChart;
	}(_react.Component);
	
	exports.default = SurveyChart;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    font-weight: 500;\n    color: #ff4d4f;\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  span {\n    font-weight: 700;\n  }\n'], ['\n  margin-top: 12px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n\n  b {\n    font-weight: 500;\n    color: #ff4d4f;\n  }\n\n  a:active, a:visited, a:link {\n    color: #97b8f6;\n    text-decoration: underline;\n  }\n\n  a:hover {\n    text-decoration: none;\n  }\n\n  ul {\n    list-style-type: disc;\n    margin-left: 20px;\n    margin-top: 10px;\n  }\n\n  span {\n    font-weight: 700;\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = _styledComponents2.default.div(_templateObject);

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = _styledComponents2.default.div(_templateObject);

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  background: #ffffff;\n  min-height: 200px;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  img {\n    width: 100%;\n  }\n'], ['\n  margin-top: 12px;\n  background: #ffffff;\n  min-height: 200px;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  img {\n    width: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var VisualWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.height && '\n    height: ' + p.height + ';\n  ';
	}, function (p) {
	  return p.noMargin && '\n    margin: 0;\n  ';
	}, function (p) {
	  return p.noBorder && '\n    border: 0;\n  ';
	}, function (p) {
	  return p.noBackground && '\n    background: none;\n  ';
	}, function (p) {
	  return p.autoHeight && '\n    min-height: auto;\n  ';
	}, function (p) {
	  return p.padding && '\n    padding: ' + p.padding + ';\n  ';
	}, function (p) {
	  return p.borderColor && '\n    border-color: ' + p.borderColor + ';\n  ';
	}, function (p) {
	  return p.background && '\n    background-color: ' + p.background + ';\n  ';
	}, function (p) {
	  return p.flexCenter && '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  ';
	}, function (p) {
	  return p.flexDirection && '\n    flex-direction: ' + p.flexDirection + ';\n  ';
	}, function (p) {
	  return p.gap && '\n    gap: ' + p.gap + ';\n  ';
	});
	
	var Visual = function Visual(_ref) {
	  var noMargin = _ref.noMargin,
	      data = _ref.data,
	      rest = _objectWithoutProperties(_ref, ['noMargin', 'data']);
	
	  return _react2.default.createElement(
	    VisualWrapper,
	    Object.assign({ noMargin: noMargin || false }, rest),
	    data || null
	  );
	};
	
	exports.default = Visual;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Column = exports.PageRow = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  margin-top: 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n'], ['\n  margin-top: 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n'], ['\n  flex: 1;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PageRow = exports.PageRow = _styledComponents2.default.div(_templateObject2);
	
	var Column = exports.Column = _styledComponents2.default.div(_templateObject3);

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RoundLink = function RoundLink(_ref) {
	  var round = _ref.round,
	      to = _ref.to,
	      params = _ref.params,
	      props = _objectWithoutProperties(_ref, ["round", "to", "params"]);
	
	  var otherParams = '';
	  if (params) {
	    params.forEach(function (param) {
	      otherParams += "&" + param.name + "=" + param.value;
	    });
	  }
	  return _react2.default.createElement(_reactRouter.Link, Object.assign({
	    to: to + "?round=" + round + otherParams
	  }, props, params ? { target: '_self' } : {}));
	};
	
	exports.default = RoundLink;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  inset: 0;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Above the app topbar (App.scss .header is at z-index 3000) so\n     the badge popup covers the header for the in-app instructor +\n     student views. Higher than any other popup on the dashboard. */\n  z-index: 3500;\n"], ["\n  position: fixed;\n  inset: 0;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Above the app topbar (App.scss .header is at z-index 3000) so\n     the badge popup covers the header for the in-app instructor +\n     student views. Higher than any other popup on the dashboard. */\n  z-index: 3500;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  max-width: 96vw;\n  max-height: 92vh;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  max-width: 96vw;\n  max-height: 92vh;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 24px;\n  width: 1180px;\n  min-width: 0;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  box-shadow: ", ";\n  font-family: 'Inter', 'Mukta Vaani', sans-serif;\n  color: ", ";\n  position: relative;\n  flex: 0 1 auto;\n"], ["\n  background: ", ";\n  border-radius: 24px;\n  width: 1180px;\n  min-width: 0;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  box-shadow: ", ";\n  font-family: 'Inter', 'Mukta Vaani', sans-serif;\n  color: ", ";\n  position: relative;\n  flex: 0 1 auto;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  width: 240px;\n  flex: 0 0 240px;\n  align-self: center;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 22px 20px;\n  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);\n  font-family: 'Mukta Vaani', sans-serif;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"], ["\n  width: 240px;\n  flex: 0 0 240px;\n  align-self: center;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 22px 20px;\n  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);\n  font-family: 'Mukta Vaani', sans-serif;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-size: 17px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  line-height: 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n"], ["\n  font-size: 17px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  line-height: 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #F47C71;\n  flex: 0 0 auto;\n  margin-top: 8px;\n"], ["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #F47C71;\n  flex: 0 0 auto;\n  margin-top: 8px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  > * {\n    width: 100%;\n  }\n\n  button {\n    width: 100%;\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  > * {\n    width: 100%;\n  }\n\n  button {\n    width: 100%;\n    justify-content: center;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  z-index: 5;\n  background: none;\n  border: 0;\n  color: rgba(0, 27, 59, 0.55);\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  &:hover { color: rgba(0, 27, 59, 0.94); }\n"], ["\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  z-index: 5;\n  background: none;\n  border: 0;\n  color: rgba(0, 27, 59, 0.55);\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  &:hover { color: rgba(0, 27, 59, 0.94); }\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  flex: 0 0 268px;\n  background: ", ";\n  padding: 43px 25px 30px;\n  overflow-y: auto;\n  font-family: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 0 0 268px;\n  background: ", ";\n  padding: 43px 25px 30px;\n  overflow-y: auto;\n  font-family: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 11px;\n"], ["\n  color: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 11px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  letter-spacing: -0.035em;\n  font-size: 19px;\n  font-weight: 700;\n  line-height: 1.35;\n  color: ", ";\n  margin: 18px 0 5px;\n"], ["\n  font-family: ", ";\n  letter-spacing: -0.035em;\n  font-size: 19px;\n  font-weight: 700;\n  line-height: 1.35;\n  color: ", ";\n  margin: 18px 0 5px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1.6;\n  color: ", ";\n"], ["\n  font-size: 13px;\n  line-height: 1.6;\n  color: ", ";\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  margin: 35px 0 22px;\n  border-top: 1px solid ", ";\n"], ["\n  margin: 35px 0 22px;\n  border-top: 1px solid ", ";\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1.55;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1.55;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  margin-top: 12px;\n  font-size: 12px;\n  color: ", ";\n  line-height: 1.6;\n"], ["\n  margin-top: 12px;\n  font-size: 12px;\n  color: ", ";\n  line-height: 1.6;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  overflow-y: auto;\n  background: ", ";\n"], ["\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  overflow-y: auto;\n  background: ", ";\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 830px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 19px;\n  box-shadow: ", ";\n  padding: 43px;\n  font-family: ", ";\n  color: ", ";\n"], ["\n  width: 100%;\n  max-width: 830px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 19px;\n  box-shadow: ", ";\n  padding: 43px;\n  font-family: ", ";\n  color: ", ";\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 22px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 22px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 0;\n"], ["\n  flex: 1 1 auto;\n  min-width: 0;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  letter-spacing: -0.035em;\n  font-size: 37px;\n  line-height: 1.18;\n  margin: 15px 0 12px;\n  font-weight: 700;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  letter-spacing: -0.035em;\n  font-size: 37px;\n  line-height: 1.18;\n  margin: 15px 0 12px;\n  font-weight: 700;\n  color: ", ";\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 7px 12px;\n  background: ", ";\n  color: ", ";\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 999px;\n"], ["\n  display: inline-block;\n  padding: 7px 12px;\n  background: ", ";\n  color: ", ";\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 999px;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 12px;\n  background: ", ";\n  color: ", ";\n  border-radius: 999px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 12px;\n  background: ", ";\n  color: ", ";\n  border-radius: 999px;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.1;\n"], ["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.1;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.15;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.15;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: 500;\n  color: ", ";\n  opacity: 0.85;\n"], ["\n  font-size: 10px;\n  font-weight: 500;\n  color: ", ";\n  opacity: 0.85;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: ", ";\n"], ["\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: ", ";\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n"], ["\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: ", ";\n  box-shadow: 0 0 0 5px ", ";\n"], ["\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: ", ";\n  box-shadow: 0 0 0 5px ", ";\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"], ["\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n  margin: 27px 0 25px;\n"], ["\n  border-top: 1px solid ", ";\n  margin: 27px 0 25px;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  margin: 0 0 18px;\n"], ["\n  margin: 0 0 18px;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 13px;\n  line-height: 1.55;\n  margin: 7px 0 19px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n  line-height: 1.55;\n  margin: 7px 0 19px;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1fr);\n  gap: 34px;\n  align-items: start;\n"], ["\n  display: grid;\n  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1fr);\n  gap: 34px;\n  align-items: start;\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  min-height: 340px;\n  border-radius: 13px;\n  background: ", ";\n  padding: 16px;\n"], ["\n  min-height: 340px;\n  border-radius: 13px;\n  background: ", ";\n  padding: 16px;\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: ", ";\n  background: ", ";\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 5px 9px;\n  letter-spacing: 0.02em;\n"], ["\n  display: inline-block;\n  color: ", ";\n  background: ", ";\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 5px 9px;\n  letter-spacing: 0.02em;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  min-height: 340px;\n  border-radius: 13px;\n  background: ", ";\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n"], ["\n  min-height: 340px;\n  border-radius: 13px;\n  background: ", ";\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  background: ", ";\n  border-radius: 12px;\n  border: 1px solid ", ";\n  padding: 22px 20px;\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  text-align: center;\n"], ["\n  flex: 1 1 auto;\n  background: ", ";\n  border-radius: 12px;\n  border: 1px solid ", ";\n  padding: 22px 20px;\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  text-align: center;\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: ", ";\n  color: ", ";\n  display: grid;\n  place-items: center;\n\n  svg {\n    width: 22px;\n    height: 22px;\n  }\n"], ["\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: ", ";\n  color: ", ";\n  display: grid;\n  place-items: center;\n\n  svg {\n    width: 22px;\n    height: 22px;\n  }\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  letter-spacing: -0.02em;\n  font-size: 22px;\n  line-height: 1.25;\n  font-weight: 700;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  letter-spacing: -0.02em;\n  font-size: 22px;\n  line-height: 1.25;\n  font-weight: 700;\n  color: ", ";\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 13px;\n  line-height: 1.7;\n  margin: 0 0 19px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n  line-height: 1.7;\n  margin: 0 0 19px;\n"]),
	    _templateObject43 = _taggedTemplateLiteral([""], [""]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  letter-spacing: -0.01em;\n  font-size: 13px;\n  font-weight: 700;\n  margin: 0 0 12px;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  letter-spacing: -0.01em;\n  font-size: 13px;\n  font-weight: 700;\n  margin: 0 0 12px;\n  color: ", ";\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 8px;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 8px;\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  border-left: 2px solid ", ";\n  padding-left: 10px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: ", ";\n  font-style: italic;\n"], ["\n  border-left: 2px solid ", ";\n  padding-left: 10px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: ", ";\n  font-style: italic;\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  border-top: 1px solid ", ";\n  padding-top: 19px;\n  margin-top: 22px;\n  color: ", ";\n  font-size: 10px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  border-top: 1px solid ", ";\n  padding-top: 19px;\n  margin-top: 22px;\n  color: ", ";\n  font-size: 10px;\n"]);
	
	exports.getSkillName = getSkillName;
	exports.getSkillCount = getSkillCount;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _recharts = __webpack_require__(27);
	
	var _NewMGLogoIcon = __webpack_require__(557);
	
	var _NewMGLogoIcon2 = _interopRequireDefault(_NewMGLogoIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Load Inter + Plus Jakarta Sans once when this module first loads
	// so the badge popup can adopt the reference design's typography
	// without changing the rest of the app's Mukta Vaani. Guarded so
	// hot-reload / repeated imports don't stack duplicate <link>s.
	if (typeof document !== "undefined" && !document.getElementById("mg-badge-fonts")) {
	  var link = document.createElement("link");
	  link.id = "mg-badge-fonts";
	  link.rel = "stylesheet";
	  link.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap";
	  document.head.appendChild(link);
	}
	
	// Shared Skills Badge popup used by both:
	//   - Instructor Student Spotlight (Most Valuable Teammate → Skills Badge link)
	//   - Student badge consent flow (StudentBadgesFlow design step)
	//
	// Renders a two-column "badge" (previously called "certificate") with
	// a sidebar summary and a main content pane containing a radar chart
	// of the four interpersonal skills, a strengths summary, and evidence
	// quotes from peers.
	//
	// Props:
	//   open              — bool: if false, renders null
	//   data              — insights payload; expects insight_json.strengths.{summary, skills}
	//   loading           — bool
	//   error             — string | null
	//   studentName       — string
	//   teammateCount     — number (denominator for the radar's "% of teammates")
	//   onClose           — function; when provided, backdrop click + close X close the popup
	//   footer            — optional React node; rendered below the main content (used by
	//                       the student flow for Accept / Decline / Not Sure Yet buttons)
	//   personalize       — optional function(text) => text; substitutes redaction tokens
	//                       with the student's name. Defaults to identity.
	
	var Backdrop = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.theme && p.theme.railBg || "rgba(15, 23, 42, 0.5)";
	});
	
	/* Outer wrapper that lines the badge Card up next to the optional
	   DecisionPanel side-by-side. Owns the viewport-budget so the two
	   siblings can share it. Falls back to just the Card when no
	   decision is required (e.g. instructor Certificate view). */
	var PopupWrap = _styledComponents2.default.div(_templateObject2);
	
	var Card = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.theme.cardBg;
	}, function (p) {
	  return p.theme.cardShadowOuter;
	}, function (p) {
	  return p.theme.ink;
	});
	
	/* Floating decision panel that sits to the right of the badge card.
	   Deliberately styled as a separate white card with its own shadow
	   so the student reads it as "here is where I decide", visually
	   detached from the badge itself. */
	var DecisionPanel = _styledComponents2.default.div(_templateObject4);
	
	var DecisionPrompt = _styledComponents2.default.div(_templateObject5);
	
	var DecisionPromptDot = _styledComponents2.default.span(_templateObject6);
	
	/* Stacks the decision buttons vertically and stretches every child
	   (including AcceptButtonWrap-style wrappers) to the panel width so
	   the two options read as parallel choices. */
	var DecisionButtons = _styledComponents2.default.div(_templateObject7);
	
	var CloseButton = _styledComponents2.default.button(_templateObject8);
	
	/* -------------------------------------------------------------------
	 * New badge design (Career Readiness redesign)
	 * Palette + typography lifted from the standalone badge.marketgames.io
	 * design system: purple accent (#665ba3), navy ink (#273654), Inter for
	 * body text, Plus Jakarta Sans (letter-spacing: -0.035em) for headings.
	 * ---------------------------------------------------------------- */
	
	var BADGE_FONT_BODY = "'Inter', 'Mukta Vaani', sans-serif";
	var BADGE_FONT_HEAD = "'Plus Jakarta Sans', 'Mukta Vaani', sans-serif";
	
	// Purple is the default palette. Gold is scoped to Most Valuable
	// Teammate badges. Well Rounded / Market Master keep purple. Colors
	// mirror the standalone badge.marketgames.io CSS one-to-one so the
	// modal and public card stay visually consistent.
	var PURPLE_THEME = {
	  ink: "#273654",
	  muted: "#69758b",
	  accent: "#665ba3",
	  kicker: "#665ba3",
	  railBg: "#eff0f7",
	  cardBg: "#ffffff",
	  cardBorder: "#eeebf5",
	  cardShadowOuter: "0 22px 60px rgba(35, 35, 73, 0.13), 0 2px 7px rgba(35, 35, 73, 0.05)",
	  cardShadowInner: "0 14px 35px rgba(39, 54, 84, 0.1), 0 2px 3px rgba(39, 54, 84, 0.03)",
	  aboutBg: "#ffffff",
	  aboutBorder: "#e0e1eb",
	  divider: "#d9dbe8",
	  pillBg: "#f1eef8",
	  pillText: "#665b9b",
	  logoBg: "#f7f5fa",
	  rule: "#e9e9ef",
	  observationText: "#69758b",
	  skillsBoxBg: "#f5f4f9",
	  skillsTitleBg: "#e8e3f3",
	  skillsTitleText: "#665b9b",
	  axisText: "#56647c",
	  assessmentText: "#5e6a7f",
	  feedbackBorder: "#786daf",
	  feedbackText: "#68748b",
	  footerBorder: "#ecebf2",
	  footerText: "#8790a3",
	  radarStroke: "#7B6BB0",
	  radarFill: "#7B6BB0",
	  radarGrid: "#c8c3d9",
	  spotlightIconBg: "#e8e3f3",
	  spotlightIconText: "#665ba3",
	  spotlightInnerBg: "#ffffff",
	  spotlightInnerBorder: "#eeebf5"
	};
	
	var GOLD_THEME = {
	  ink: "#342b1d",
	  muted: "#74664e",
	  accent: "#8c5e0a",
	  kicker: "#80560d",
	  railBg: "#f3ead8",
	  cardBg: "#fffdf8",
	  cardBorder: "#eee4d0",
	  cardShadowOuter: "0 22px 60px rgba(73, 54, 19, 0.14), 0 2px 7px rgba(73, 54, 19, 0.06)",
	  cardShadowInner: "0 14px 35px rgba(61, 47, 23, 0.11), 0 2px 3px rgba(61, 47, 23, 0.04)",
	  aboutBg: "#fffaf0",
	  aboutBorder: "#e8dcc4",
	  divider: "#dfd2b9",
	  pillBg: "#FBEDD5",
	  pillText: "#66450c",
	  logoBg: "#fbf4e5",
	  rule: "#eee5d5",
	  observationText: "#74664e",
	  skillsBoxBg: "#FBEDD5",
	  skillsTitleBg: "#f7dfa0",
	  skillsTitleText: "#68470b",
	  axisText: "#665a43",
	  assessmentText: "#665a47",
	  feedbackBorder: "#c58c1d",
	  feedbackText: "#6d604b",
	  footerBorder: "#eee5d5",
	  footerText: "#796d58",
	  radarStroke: "#c58c1d",
	  radarFill: "#c58c1d",
	  radarGrid: "#dfd2b9",
	  spotlightIconBg: "#f7dfa0",
	  spotlightIconText: "#8c5e0a",
	  spotlightInnerBg: "#fffdf8",
	  spotlightInnerBorder: "#eee4d0"
	};
	
	var themeForCategory = function themeForCategory(category) {
	  return category === "most_valuable" ? GOLD_THEME : PURPLE_THEME;
	};
	
	// Left panel. Muted lavender-gray background; hosts the certifier
	// summary + About the Market Games Simulation toggle.
	var Sidebar = _styledComponents2.default.div(_templateObject9, function (p) {
	  return p.theme.railBg;
	}, BADGE_FONT_BODY, function (p) {
	  return p.theme.ink;
	});
	
	var SidebarKicker = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.theme.kicker;
	});
	
	var SidebarInstructor = _styledComponents2.default.div(_templateObject11, BADGE_FONT_HEAD, function (p) {
	  return p.theme.ink;
	});
	
	var SidebarInstitution = _styledComponents2.default.div(_templateObject12, function (p) {
	  return p.theme.muted;
	});
	
	var SidebarDivider = _styledComponents2.default.div(_templateObject13, function (p) {
	  return p.theme.divider;
	});
	
	var SidebarAboutTitle = _styledComponents2.default.div(_templateObject14, function (p) {
	  return p.theme.ink;
	}, BADGE_FONT_BODY);
	
	var SidebarAboutBody = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.theme.muted;
	});
	
	// Right / main stage that hosts the badge card.
	var BadgeStage = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.theme.cardBg;
	});
	
	var BadgeCard = _styledComponents2.default.div(_templateObject17, function (p) {
	  return p.theme.cardBg;
	}, function (p) {
	  return p.theme.cardBorder;
	}, function (p) {
	  return p.theme.cardShadowInner;
	}, BADGE_FONT_BODY, function (p) {
	  return p.theme.ink;
	});
	
	var CardHeader = _styledComponents2.default.div(_templateObject18);
	
	var CardHeaderText = _styledComponents2.default.div(_templateObject19);
	
	var CardKicker = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.theme.kicker;
	});
	
	var CardName = _styledComponents2.default.h2(_templateObject20, BADGE_FONT_HEAD, function (p) {
	  return p.theme.ink;
	});
	
	var CardAwardPill = _styledComponents2.default.span(_templateObject21, function (p) {
	  return p.theme.pillBg;
	}, function (p) {
	  return p.theme.pillText;
	});
	
	// Horizontal row for the pills under the student name. Lets the
	// "Top X%" bubble sit alongside the category pill when the student's
	// top_percent qualifies (≤ 10). Wraps on narrow viewports so the
	// second pill drops below instead of overflowing.
	var CardPillRow = _styledComponents2.default.div(_templateObject22);
	
	// Rank pill: bold "Top X.XX%" value on the left, two-line caption
	// ("of their class" / "VERIFIED STUDENT RANK") on the right. Shares
	// the category pill's palette so both read as part of the same award
	// row.
	var CardRankPill = _styledComponents2.default.span(_templateObject23, function (p) {
	  return p.theme.pillBg;
	}, function (p) {
	  return p.theme.pillText;
	});
	
	var CardRankPillValue = _styledComponents2.default.span(_templateObject24);
	
	var CardRankPillCaption = _styledComponents2.default.span(_templateObject25);
	
	var CardRankPillCaptionTop = _styledComponents2.default.span(_templateObject26, function (p) {
	  return p.theme.pillText;
	});
	
	var CardRankPillCaptionBottom = _styledComponents2.default.span(_templateObject27, function (p) {
	  return p.theme.pillText;
	});
	
	// Column that stacks the circular logo and the "Market Games" link
	// vertically. flex:none so the whole column keeps its intrinsic size
	// inside the space-between CardHeader (which also holds the title /
	// name / pill on the left).
	var CardLogoColumn = _styledComponents2.default.div(_templateObject28);
	
	// 64px logo + 5px spread box-shadow acts as an outer ring in the
	// theme's tint. Per the reference CSS: purple gets #f7f5fa, gold
	// gets #fbf4e5 (theme.logoBg).
	var CardLogoRing = _styledComponents2.default.div(_templateObject29, function (p) {
	  return p.theme.logoBg;
	}, function (p) {
	  return p.theme.logoBg;
	});
	
	var CardLogoImg = _styledComponents2.default.img(_templateObject30);
	
	var CardLogoLink = _styledComponents2.default.a(_templateObject31, BADGE_FONT_BODY, function (p) {
	  return p.theme.kicker;
	});
	
	var CardRule = _styledComponents2.default.div(_templateObject32, function (p) {
	  return p.theme.rule;
	});
	
	var ObservationSection = _styledComponents2.default.div(_templateObject33);
	
	var ObservationKicker = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.theme.kicker;
	});
	
	var ObservationSkills = _styledComponents2.default.p(_templateObject34, function (p) {
	  return p.theme.observationText;
	});
	
	var EvidenceGrid = _styledComponents2.default.div(_templateObject35);
	
	var SkillsBox = _styledComponents2.default.div(_templateObject36, function (p) {
	  return p.theme.skillsBoxBg;
	});
	
	var SkillsBoxTitle = _styledComponents2.default.div(_templateObject37, function (p) {
	  return p.theme.skillsTitleText;
	}, function (p) {
	  return p.theme.skillsTitleBg;
	});
	
	// Alternative to SkillsBox when only ONE strength has count > 0 and
	// the radar chart collapses to a single line. Same outer footprint
	// so the two-column grid layout is unchanged.
	var SkillSpotlightBox = _styledComponents2.default.div(_templateObject38, function (p) {
	  return p.theme.skillsBoxBg;
	});
	
	var SkillSpotlightInner = _styledComponents2.default.div(_templateObject39, function (p) {
	  return p.theme.spotlightInnerBg;
	}, function (p) {
	  return p.theme.spotlightInnerBorder;
	});
	
	var SkillSpotlightIcon = _styledComponents2.default.div(_templateObject40, function (p) {
	  return p.theme.spotlightIconBg;
	}, function (p) {
	  return p.theme.spotlightIconText;
	});
	
	var SkillSpotlightKicker = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.theme.kicker;
	});
	
	var SkillSpotlightName = _styledComponents2.default.div(_templateObject41, BADGE_FONT_HEAD, function (p) {
	  return p.theme.ink;
	});
	
	var AssessmentText = _styledComponents2.default.p(_templateObject42, function (p) {
	  return p.theme.assessmentText;
	});
	
	var FeedbackBlock = _styledComponents2.default.div(_templateObject43);
	
	var FeedbackHeading = _styledComponents2.default.h3(_templateObject44, BADGE_FONT_HEAD, function (p) {
	  return p.theme.ink;
	});
	
	var FeedbackList = _styledComponents2.default.ul(_templateObject45);
	
	var FeedbackItem = _styledComponents2.default.li(_templateObject46, function (p) {
	  return p.theme.feedbackBorder;
	}, function (p) {
	  return p.theme.feedbackText;
	});
	
	var CardFooter = _styledComponents2.default.div(_templateObject47, function (p) {
	  return p.theme.footerBorder;
	}, function (p) {
	  return p.theme.footerText;
	});
	
	// -----------------------------------------------------------------
	// Data extraction helpers — resilient to backend shape variations.
	// -----------------------------------------------------------------
	
	// Resolve the skill name for one row of strengths data. Exported for
	// reuse (Insights popup on the instructor dashboard also consumes it).
	function getSkillName(row) {
	  if (!row) return "";
	  return row.skill_name || row.skill || row.name || row.label || row.skill && row.skill.name || "";
	}
	
	// Resolve the count for one row of strengths data. Exported for reuse.
	function getSkillCount(row) {
	  if (!row) return 0;
	  return Number(row.count || row.total_student_count || row.student_count || row.value || row.peers && row.peers.length || 0) || 0;
	}
	
	function getStrengths(data) {
	  if (!data) return [];
	  var candidates = [data.insight_json && data.insight_json.strengths && data.insight_json.strengths.skills, data.strengths && data.strengths.skills, data.strengths, data.strength, data.skills, data.results && data.results.strengths, data.data && data.data.strengths];
	  for (var i = 0; i < candidates.length; i += 1) {
	    if (Array.isArray(candidates[i])) return candidates[i];
	  }
	  return [];
	}
	
	function getSummary(data) {
	  if (!data) return null;
	  return data.insight_json && data.insight_json.strengths && data.insight_json.strengths.summary || data.strengths && data.strengths.summary || data.strength_summary || data.strengths_summary || data.summary || null;
	}
	
	// Radar dataset for the 4 interpersonal-skill axes. Each axis renders
	// as `count / # of teammates`, capped at 100%.
	function getRadarData(strengths, teammateCount) {
	  var axes = [{ label: "Strong Work Ethic", aliases: ["Strong Work Ethics", "Strong Work Ethic", "Work Ethic"] }, { label: "Communication", aliases: ["Communication", "Effective Communication"] }, { label: "Supportive", aliases: ["Supportive"] }, { label: "Problem-Solver", aliases: ["Problem-Solver", "Problem Solver", "Problem Solving"] }];
	  var list = Array.isArray(strengths) ? strengths : [];
	  var lookupCount = function lookupCount(aliases) {
	    var _loop = function _loop(i) {
	      var want = aliases[i];
	      var hit = list.find(function (s) {
	        return getSkillName(s) === want;
	      });
	      if (hit) return {
	          v: getSkillCount(hit)
	        };
	    };
	
	    for (var i = 0; i < aliases.length; i += 1) {
	      var _ret = _loop(i);
	
	      if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	    }
	    return 0;
	  };
	  return axes.map(function (a) {
	    var count = lookupCount(a.aliases);
	    var pct = teammateCount > 0 ? Math.min(100, count / teammateCount * 100) : 0;
	    return { axis: a.label, value: pct, count: count };
	  });
	}
	
	// Evidence selection rules (in order of application):
	//   1. Consider strengths only (never weaknesses).
	//   2. Skip any quote with fewer than MIN_QUOTE_WORDS words.
	//   3. Rank skills by supporting_feedback_count descending. Within a
	//      skill, rank surviving quotes by length descending (longer first).
	//   4. Round-robin across skills tied at the current count. When the
	//      tie group is exhausted, cascade to the next-lower count level.
	//   5. Hard cap at MAX_EVIDENCE_QUOTES. If fewer than that exist across
	//      all skills, show whatever we have.
	var MIN_QUOTE_WORDS = 6;
	var MAX_EVIDENCE_QUOTES = 4;
	
	function countWords(str) {
	  return String(str || "").trim().split(/\s+/).filter(Boolean).length;
	}
	
	// Normalize a quote for near-duplicate comparison: lowercase, strip
	// punctuation, collapse whitespace. "Allowed him to explain." and
	// "allowed him to explain" become equal after normalization.
	function normalizeQuote(str) {
	  return String(str || "").toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, " ").trim();
	}
	
	// Two quotes are treated as duplicates when one is a substring of the
	// other after normalization. Common with peer feedback: teammates
	// sometimes phrase the same observation with slight variations, or the
	// same source quote gets attached to multiple skills (see badge
	// MG-27191: "allowed him to explain certain situation" appeared under
	// both Supportive and Communication).
	function isDuplicateOfAny(candidate, existing) {
	  var a = normalizeQuote(candidate);
	  if (!a) return false;
	  return existing.some(function (e) {
	    var b = normalizeQuote(e.quote);
	    if (!b) return false;
	    return a.includes(b) || b.includes(a);
	  });
	}
	
	// Collect every quote attached to one skill row. Prior version only
	// pulled the first — now we need the full list so we can rank and
	// round-robin.
	function getSkillQuotes(row) {
	  if (!row) return [];
	  var ev = row.evidence || row.evidences || row.quote || row.quotes || row.feedback || row.peer_feedback || null;
	  var out = [];
	  var push = function push(q) {
	    if (typeof q === "string" && q.trim()) out.push(q);
	  };
	  if (Array.isArray(ev)) {
	    ev.forEach(function (item) {
	      if (typeof item === "string") push(item);else if (item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object") push(item.text || item.quote || "");
	    });
	  } else if (typeof ev === "string") {
	    push(ev);
	  } else if (ev && (typeof ev === "undefined" ? "undefined" : _typeof(ev)) === "object") {
	    push(ev.text || ev.quote || "");
	  }
	  return out;
	}
	
	function getEvidence(strengths) {
	  var list = Array.isArray(strengths) ? strengths : [];
	
	  // Build { skill, count, quotes[] }: rank remaining quotes
	  // longest-first, drop skills with nothing usable. `applyWordFilter`
	  // gates whether the MIN_QUOTE_WORDS length filter is applied.
	  var buildSkills = function buildSkills(applyWordFilter) {
	    return list.map(function (s) {
	      var skill = getSkillName(s);
	      var count = getSkillCount(s);
	      var quotes = getSkillQuotes(s);
	      if (applyWordFilter) {
	        quotes = quotes.filter(function (q) {
	          return countWords(q) >= MIN_QUOTE_WORDS;
	        });
	      }
	      quotes = quotes.slice().sort(function (a, b) {
	        return b.length - a.length;
	      });
	      return { skill: skill, count: count, quotes: quotes };
	    }).filter(function (s) {
	      return s.skill && s.quotes.length > 0;
	    });
	  };
	
	  var out = [];
	
	  // Count-based round-robin: sort skills by count desc, group ties,
	  // pull one quote per skill per pass within each tie group, skipping
	  // near-duplicates of anything already in `out`. Called once per
	  // pass (strict, then backfill) so backfill honors what strict
	  // already pulled and doesn't repeat.
	  var pull = function pull(skills) {
	    var sorted = skills.slice().sort(function (a, b) {
	      return b.count - a.count;
	    });
	    var i = 0;
	    while (i < sorted.length && out.length < MAX_EVIDENCE_QUOTES) {
	      var currentCount = sorted[i].count;
	      var j = i;
	      while (j < sorted.length && sorted[j].count === currentCount) {
	        j += 1;
	      }var tieGroup = sorted.slice(i, j).map(function (s) {
	        return {
	          skill: s.skill,
	          quotes: s.quotes,
	          cursor: 0
	        };
	      });
	
	      var pulledThisPass = true;
	      while (out.length < MAX_EVIDENCE_QUOTES && pulledThisPass) {
	        pulledThisPass = false;
	        for (var k = 0; k < tieGroup.length && out.length < MAX_EVIDENCE_QUOTES; k += 1) {
	          var t = tieGroup[k];
	          while (t.cursor < t.quotes.length && isDuplicateOfAny(t.quotes[t.cursor], out)) {
	            t.cursor += 1;
	          }
	          if (t.cursor < t.quotes.length) {
	            out.push({ skill: t.skill, quote: t.quotes[t.cursor] });
	            t.cursor += 1;
	            pulledThisPass = true;
	          }
	        }
	      }
	      i = j;
	    }
	  };
	
	  // Strict pass: only quotes >= MIN_QUOTE_WORDS. These are the
	  // preferred, substantive quotes for the badge.
	  pull(buildSkills(true));
	
	  // Backfill pass: if the strict pass left slots open (i.e. the badge
	  // earned few long quotes), top up from the unfiltered list so short
	  // quotes still make it in rather than leaving a nearly-empty
	  // Teammate Feedback section. Duplicate detection in pull() ensures
	  // strict-pass quotes don't get pulled again from the unfiltered
	  // build.
	  if (out.length < MAX_EVIDENCE_QUOTES) {
	    pull(buildSkills(false));
	  }
	
	  return out;
	}
	
	var SkillsBadgePopup = function (_PureComponent) {
	  _inherits(SkillsBadgePopup, _PureComponent);
	
	  function SkillsBadgePopup() {
	    _classCallCheck(this, SkillsBadgePopup);
	
	    return _possibleConstructorReturn(this, (SkillsBadgePopup.__proto__ || Object.getPrototypeOf(SkillsBadgePopup)).apply(this, arguments));
	  }
	
	  _createClass(SkillsBadgePopup, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          data = _props.data,
	          loading = _props.loading,
	          error = _props.error,
	          studentName = _props.studentName,
	          teammateCount = _props.teammateCount,
	          onClose = _props.onClose,
	          footer = _props.footer,
	          footerPrompt = _props.footerPrompt,
	          personalize = _props.personalize,
	          categoryLabel = _props.categoryLabel,
	          category = _props.category;
	
	
	      if (!open) return null;
	      var theme = themeForCategory(category);
	
	      var payload = data || {};
	      var strengths = getStrengths(payload);
	      var sortedStrengths = strengths.slice().map(function (s) {
	        return { name: getSkillName(s), count: getSkillCount(s) };
	      }).filter(function (s) {
	        return s.name;
	      }).sort(function (a, b) {
	        return b.count - a.count;
	      });
	
	      var rawSummary = getSummary(payload) || strengths[0] && (strengths[0].summary || strengths[0].text) || (studentName || "This student") + " demonstrated standout interpersonal skills this round.";
	
	      var personalizeFn = typeof personalize === "function" ? personalize : function (t) {
	        return t;
	      };
	      var summaryRendered = personalizeFn(rawSummary);
	
	      var evidenceQuotes = getEvidence(strengths).map(function (q) {
	        return Object.assign({}, q, { quote: personalizeFn(q.quote) });
	      });
	
	      var radarData = getRadarData(strengths, teammateCount || 0);
	      // "Only one skill observed" trigger: radar chart collapses to a
	      // straight line when only one of the four axes has a non-zero
	      // value, which reads as empty. Swap in the Skill Spotlight card
	      // instead so a single-skill badge still feels earned.
	      var observedSkills = sortedStrengths.filter(function (s) {
	        return s.count > 0;
	      });
	      var singleSkillMode = observedSkills.length === 1;
	      var spotlightSkill = singleSkillMode ? observedSkills[0] : null;
	      var badgeId = payload.certificate_id || payload.cert_id || payload.badge_id || (payload.user_id != null ? "MG-" + payload.user_id : "MG");
	
	      return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: theme },
	        _react2.default.createElement(
	          Backdrop,
	          { onClick: onClose },
	          _react2.default.createElement(
	            PopupWrap,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              Card,
	              null,
	              onClose && _react2.default.createElement(
	                CloseButton,
	                {
	                  type: "button",
	                  onClick: onClose,
	                  "aria-label": "Close"
	                },
	                "\xD7"
	              ),
	              _react2.default.createElement(
	                Sidebar,
	                null,
	                _react2.default.createElement(
	                  SidebarKicker,
	                  null,
	                  "Badge extended by"
	                ),
	                _react2.default.createElement(
	                  SidebarInstructor,
	                  null,
	                  payload.instructor_last_name ? "Professor " + payload.instructor_last_name : "Professor"
	                ),
	                _react2.default.createElement(
	                  SidebarInstitution,
	                  null,
	                  payload.course_institution || "School of Business"
	                ),
	                _react2.default.createElement(SidebarDivider, null),
	                _react2.default.createElement(
	                  SidebarAboutTitle,
	                  null,
	                  "About the Market Games Simulation"
	                ),
	                _react2.default.createElement(
	                  SidebarAboutBody,
	                  null,
	                  payload.about_marketgames || "In the Intro to Business Challenge, teams compete for market share and profit in a simulated business environment. They work through market research, competitor data, and financing options, then make decisions that cut across every core business function. After each round, they analyze their financial statements and KPIs to evaluate what worked and sharpen their next set of decisions. Capital is scarce, information is incomplete, and there is no right answer. What the challenge tests is how a student reasons through ambiguity and uncertainty while making decisions with teammates who see the problem differently."
	                )
	              ),
	              _react2.default.createElement(
	                BadgeStage,
	                null,
	                _react2.default.createElement(
	                  BadgeCard,
	                  null,
	                  _react2.default.createElement(
	                    CardHeader,
	                    null,
	                    _react2.default.createElement(
	                      CardHeaderText,
	                      null,
	                      _react2.default.createElement(
	                        CardKicker,
	                        null,
	                        "Badge / Career Readiness"
	                      ),
	                      _react2.default.createElement(
	                        CardName,
	                        null,
	                        studentName
	                      ),
	                      _react2.default.createElement(
	                        CardPillRow,
	                        null,
	                        _react2.default.createElement(
	                          CardAwardPill,
	                          null,
	                          categoryLabel || "Most Valuable Teammate"
	                        ),
	                        function () {
	                          // Rank pill: visible only when top_percent is a
	                          // positive number ≤ 10. The payload for the
	                          // dashboard-side instructor view may not carry
	                          // top_percent; the Number.isFinite guard
	                          // silently skips rendering in that case.
	                          var topPct = Number(payload.top_percent);
	                          if (!Number.isFinite(topPct) || topPct <= 0 || topPct > 10) return null;
	                          return _react2.default.createElement(
	                            CardRankPill,
	                            null,
	                            _react2.default.createElement(
	                              CardRankPillValue,
	                              null,
	                              "Top ",
	                              topPct.toFixed(2),
	                              "%"
	                            ),
	                            _react2.default.createElement(
	                              CardRankPillCaption,
	                              null,
	                              _react2.default.createElement(
	                                CardRankPillCaptionTop,
	                                null,
	                                "of their class"
	                              ),
	                              _react2.default.createElement(
	                                CardRankPillCaptionBottom,
	                                null,
	                                "Verified Student Rank"
	                              )
	                            )
	                          );
	                        }()
	                      )
	                    ),
	                    _react2.default.createElement(
	                      CardLogoColumn,
	                      null,
	                      _react2.default.createElement(
	                        CardLogoRing,
	                        null,
	                        _react2.default.createElement(CardLogoImg, { src: _NewMGLogoIcon2.default, alt: "Market Games" })
	                      ),
	                      _react2.default.createElement(
	                        CardLogoLink,
	                        {
	                          href: "https://www.marketgames.io",
	                          target: "_blank",
	                          rel: "noopener noreferrer"
	                        },
	                        "Market Games"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(CardRule, null),
	                  _react2.default.createElement(
	                    ObservationSection,
	                    null,
	                    _react2.default.createElement(
	                      ObservationKicker,
	                      null,
	                      "Career Readiness Observed"
	                    ),
	                    _react2.default.createElement(
	                      ObservationSkills,
	                      null,
	                      sortedStrengths.length > 0 ? sortedStrengths.map(function (s) {
	                        return s.name.toLowerCase();
	                      }).join(", ") : ""
	                    )
	                  ),
	                  _react2.default.createElement(
	                    EvidenceGrid,
	                    null,
	                    singleSkillMode ? _react2.default.createElement(
	                      SkillSpotlightBox,
	                      null,
	                      _react2.default.createElement(
	                        SkillsBoxTitle,
	                        null,
	                        "Skill Spotlight"
	                      ),
	                      _react2.default.createElement(
	                        SkillSpotlightInner,
	                        null,
	                        _react2.default.createElement(
	                          SkillSpotlightIcon,
	                          { "aria-hidden": true },
	                          _react2.default.createElement(
	                            "svg",
	                            { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	                            _react2.default.createElement("circle", { cx: "12", cy: "9", r: "5" }),
	                            _react2.default.createElement("path", { d: "M8 13 L6 22 L12 19 L18 22 L16 13" })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          SkillSpotlightKicker,
	                          null,
	                          "Skill Demonstrated"
	                        ),
	                        _react2.default.createElement(
	                          SkillSpotlightName,
	                          null,
	                          spotlightSkill.name
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      SkillsBox,
	                      null,
	                      _react2.default.createElement(
	                        SkillsBoxTitle,
	                        null,
	                        "Skills Map"
	                      ),
	                      _react2.default.createElement(
	                        _recharts.ResponsiveContainer,
	                        { width: "100%", height: 300 },
	                        _react2.default.createElement(
	                          _recharts.RadarChart,
	                          {
	                            cx: "50%",
	                            cy: "50%",
	                            outerRadius: "90%",
	                            data: radarData,
	                            margin: { top: 14, right: 90, bottom: 14, left: 90 }
	                          },
	                          _react2.default.createElement(_recharts.PolarGrid, { stroke: theme.radarGrid }),
	                          _react2.default.createElement(_recharts.PolarAngleAxis, {
	                            dataKey: "axis",
	                            tick: { fontSize: 10, fill: theme.axisText, fontFamily: BADGE_FONT_BODY }
	                          }),
	                          _react2.default.createElement(_recharts.PolarRadiusAxis, {
	                            angle: 90,
	                            domain: [0, 100],
	                            tickCount: 5,
	                            tick: false,
	                            axisLine: false
	                          }),
	                          _react2.default.createElement(_recharts.Tooltip, {
	                            formatter: function formatter(value, name, item) {
	                              var count = item && item.payload && item.payload.count;
	                              return [Math.round(value) + "% (" + count + " of " + (teammateCount || 0) + ")", "Strength"];
	                            }
	                          }),
	                          _react2.default.createElement(_recharts.Radar, {
	                            name: "Strength",
	                            dataKey: "value",
	                            stroke: theme.radarStroke,
	                            fill: theme.radarFill,
	                            fillOpacity: 0.55
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      loading && _react2.default.createElement(
	                        AssessmentText,
	                        null,
	                        "Loading badge\u2026"
	                      ),
	                      error && _react2.default.createElement(
	                        AssessmentText,
	                        null,
	                        error
	                      ),
	                      !loading && !error && _react2.default.createElement(
	                        AssessmentText,
	                        null,
	                        summaryRendered
	                      ),
	                      evidenceQuotes.length > 0 && _react2.default.createElement(
	                        FeedbackBlock,
	                        null,
	                        _react2.default.createElement(
	                          FeedbackHeading,
	                          null,
	                          "Snapshot of teammates feedback"
	                        ),
	                        _react2.default.createElement(
	                          FeedbackList,
	                          null,
	                          evidenceQuotes.map(function (q, i) {
	                            return _react2.default.createElement(
	                              FeedbackItem,
	                              { key: "badge-quote-" + i },
	                              "\u201C",
	                              q.quote,
	                              "\u201D"
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    CardFooter,
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Badge ID: ",
	                      badgeId
	                    )
	                  )
	                )
	              )
	            ),
	            (footer || footerPrompt) && _react2.default.createElement(
	              DecisionPanel,
	              null,
	              footerPrompt && _react2.default.createElement(
	                DecisionPrompt,
	                null,
	                _react2.default.createElement(DecisionPromptDot, { "aria-hidden": true }),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  footerPrompt
	                )
	              ),
	              footer && _react2.default.createElement(
	                DecisionButtons,
	                null,
	                footer
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SkillsBadgePopup;
	}(_react.PureComponent);
	
	exports.default = SkillsBadgePopup;

/***/ },
/* 598 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MgBusinessCaseContent = {
	  PRODUCT_FEATURES: {
	    description: "As the Head of Products, you have to decide on your product’s features. Each product you develop has 4 features and you have to decide which features are important for your product by ranking each from 1 to 10 (1= lowest importance, 10= highest importance).",
	    mgAbout: "your product features",
	    mgSection: "Product"
	  },
	  PROMOTIONAL_SPEND: {
	    description: "As the Head of Product Marketing, you have to decide how much to spend on promoting your product and which channels to use to promote your product - Traditional or Digital Marketing Channels.",
	    mgAbout: "promotional spend",
	    mgSection: "Marketing"
	  },
	  SALES_SPEND: {
	    description: "As the Head of Product Marketing, you have to decide which sales channels to use to sell your product. You have a choice of direct sales (i.e. selling directly to the customer) or distributor (i.e. selling through a third party/agent).",
	    mgAbout: "sales spend",
	    mgSection: "Marketing"
	  }
	};
	
	exports.default = MgBusinessCaseContent;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _wrapper = __webpack_require__(1181);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function capitalizeFirstLetter(s) {
	  return s.charAt(0).toUpperCase() + s.slice(1);
	}
	
	var DecisionsSummary = function (_PureComponent) {
	  _inherits(DecisionsSummary, _PureComponent);
	
	  function DecisionsSummary(props) {
	    _classCallCheck(this, DecisionsSummary);
	
	    var _this = _possibleConstructorReturn(this, (DecisionsSummary.__proto__ || Object.getPrototypeOf(DecisionsSummary)).call(this, props));
	
	    _this.fetchData = function () {
	      var _this$props = _this.props,
	          rounds = _this$props.rounds,
	          currentRound = _this$props.currentRound;
	
	
	      if (rounds.length === 0) {
	        return;
	      }
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	      if (!round) {
	        return;
	      }
	
	      var joinRequest = (0, _ApiService.batchRequest)([].concat(_toConsumableArray((0, _SubmitDecisions.getSubmissionRequest)(["pd", "pm", "op", "fn"], currentRound, round.is_finished))));
	
	      joinRequest.then(function (res) {
	        var submission_data = (0, _SubmitDecisions.handleSubmission)(["pd", "pm", "op", "fn"], [res[0].body, res[1].body, res[2].body, res[3].body, res[4].body], round.is_finished);
	
	        _this.setState({
	          submission_data: submission_data,
	          submitDecisionsLoadingDevelopment: false,
	          submitDecisionsLoadingMarketing: false,
	          submitDecisionsLoadingOperations: false,
	          submitDecisionsLoadingFinance: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.submitDecisions = function (type) {
	      var t = capitalizeFirstLetter(type);
	      _this.setState(_defineProperty({}, "submitDecisionsLoading" + t, true));
	
	      (0, _SubmitDecisions.submitDecisions)(type, _this.props.roundInUrl || _this.props.currentRound, function (showWarnings) {
	        return _this.getSubmissionData(t, showWarnings);
	      });
	    };
	
	    _this.getSubmissionData = function (type, showWarnings) {
	      _this.setState(_defineProperty({}, "submitDecisionsLoading" + type, true));
	
	      if (showWarnings) {
	        showWarnings(null);
	      }
	      _this.fetchData();
	    };
	
	    _this.state = {
	      submission_data: {
	        pd: {
	          date: "N/A",
	          unaccepted: 0
	        },
	        pm: {
	          date: "N/A",
	          unaccepted: 0
	        },
	        op: {
	          date: "N/A",
	          unaccepted: 0
	        },
	        fn: {
	          date: "N/A",
	          unaccepted: 0
	        }
	      },
	      submitDecisionsLoadingDevelopment: false,
	      submitDecisionsLoadingMarketing: false,
	      submitDecisionsLoadingOperations: false,
	      submitDecisionsLoadingFinance: false,
	      hasAccess: _Auth2.default.getRole() === "CEO"
	    };
	    return _this;
	  }
	
	  _createClass(DecisionsSummary, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      //this.fetchData()
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_wrapper2.default, {
	          location: window.location,
	          position: this.props.position,
	          breadcrumbsTitle: this.props.location.pathname
	        })
	      );
	    }
	  }, {
	    key: "showActionButtons",
	    get: function get() {
	      var hasAccess = this.state.hasAccess;
	      var _props = this.props,
	          roundShouldBeFinished = _props.roundShouldBeFinished,
	          roundInUrl = _props.roundInUrl,
	          currentRound = _props.currentRound,
	          rounds = _props.rounds;
	
	
	      if (!rounds) {
	        return false;
	      }
	
	      if (hasAccess === false) {
	        return false;
	      }
	
	      if (roundShouldBeFinished === true) {
	        return false;
	      }
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return false;
	      }
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	
	      if (!round) {
	        return false;
	      }
	
	      return round.is_started === true && round.is_finished === false;
	    }
	  }]);
	
	  return DecisionsSummary;
	}(_react.PureComponent);
	
	exports.default = DecisionsSummary;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPageLogo = __webpack_require__(1049);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _LandingPageLogo3 = __webpack_require__(210);
	
	var _LandingPageLogo4 = _interopRequireDefault(_LandingPageLogo3);
	
	var _Screenshot = __webpack_require__(2567);
	
	var _Screenshot2 = _interopRequireDefault(_Screenshot);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinPage = function (_PureComponent) {
	  _inherits(JoinPage, _PureComponent);
	
	  function JoinPage(props) {
	    _classCallCheck(this, JoinPage);
	
	    var _this = _possibleConstructorReturn(this, (JoinPage.__proto__ || Object.getPrototypeOf(JoinPage)).call(this, props));
	
	    _this.handleInputChange = function (e) {
	      var id = e.target.id;
	      var value = e.target.value;
	
	      if (id === "team") {
	        value = parseInt(value, 10);
	        if (isNaN(value)) {
	          value = 0;
	        }
	      }
	
	      _this.setState(_defineProperty({}, id, value), function () {
	        if (id === "team") {
	          _this.updatePlayers();
	        }
	      });
	    };
	
	    _this.updatePlayers = function () {
	      var team = _this.state.team;
	
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "teams/" + team + "/players/").then(function (res) {
	        var players = res.body.filter(function (i) {
	          return !("user" in i) || !i.user;
	        });
	
	        _this.setState({
	          players: players,
	          role: ""
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.handleSubmit = function () {
	      var _this$state = _this.state,
	          team = _this$state.team,
	          role = _this$state.role;
	
	      var game_id = _Auth2.default.getGameId();
	
	      _this.setState({
	        showError: false
	      });
	
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/join_team/").send({ team: team, role: role }).then(function (res) {
	        (0, _ApiService.getRequest)(_Auth2.default.getUserDataRequest()).then(function (res2) {
	          _Auth2.default.setUserData(res2.body);
	
	          (0, _ApiService.batchRequest)([].concat(_toConsumableArray(_Teams2.default.requests()))).then(function (res3) {
	            var teams_data = [{
	              status: res3[0].statusCode,
	              data: res3[0].body
	            }, {
	              status: res3[1].statusCode,
	              data: res3[1].body
	            }];
	            _Teams2.default.setData(teams_data);
	
	            _this.eventemitter.trigger("reload-data");
	            (0, _Location.changeLocation)("/start");
	          }).catch(function (err) {});
	        }).catch(function (err) {});
	      }).catch(function (err) {
	        _this.setState({
	          showError: true
	        });
	      });
	    };
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	    };
	
	    _this.logout = function (e) {
	      e.preventDefault();
	
	      if (_Auth2.default.isUserAuthenticated()) {
	        _Auth2.default.deauthenticateUser();
	        window.location.reload();
	      }
	    };
	
	    _this.state = {
	      team: 0,
	      role: "",
	      showError: false,
	      teams: [],
	      players: [],
	      roles: {
	        CEO: "CEO",
	        PD: "Product Management",
	        PM: "Product Marketing",
	        OP: "Operations",
	        FI: "Finance"
	      }
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(JoinPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var game_id = _Auth2.default.getGameId();
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/", (0, _Teams.teamsEndpoint)()]).then(function (res) {
	        var res1 = res[0].body;
	        var res2 = res[1].body;
	        var teams = res2.filter(function (i) {
	          return res1.teams.includes(i.id);
	        });
	
	        _this2.setState({
	          teams: teams
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          team = _state.team,
	          role = _state.role,
	          showError = _state.showError,
	          teams = _state.teams,
	          players = _state.players,
	          roles = _state.roles;
	
	      var logoStyle = (0, _utils.getLogoStyle)(this.isMobile);
	      var LogoImg = this.isMobile ? _react2.default.createElement("img", { src: _LandingPageLogo4.default, style: logoStyle, alt: "Logo" }) : _react2.default.createElement("img", { src: _LandingPageLogo2.default, className: "join-page-logo", alt: "Logo" });
	      var logoClass = this.isMobile ? "text-center mg-top-15vh" : "text-center mg-top-10vh";
	      var formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-color-blue height-100vh" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-4 col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: logoClass },
	              LogoImg
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: formClass },
	              _react2.default.createElement(
	                "form",
	                { className: "form-signin", onSubmit: this.onSubmit },
	                showError === true && _react2.default.createElement(
	                  "div",
	                  { className: "col-md-10 col-md-offset-1 alert alert-danger col-xs-12" },
	                  "Select valid Team & Role"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group col-md-10 col-md-offset-1 mg-top-5vh col-xs-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      htmlFor: "team",
	                      className: "control-label font-size-14 color-white"
	                    },
	                    "Join a Team"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      id: "team",
	                      value: team,
	                      onChange: this.handleInputChange,
	                      className: "join-select-input"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "Join a Team"
	                    ),
	                    Object.keys(teams).map(function (i) {
	                      var team = teams[i];
	                      return _react2.default.createElement(
	                        "option",
	                        { key: i, value: team.id },
	                        team.name
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group col-md-10 col-md-offset-1 mg-top-2vh col-xs-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      htmlFor: "role",
	                      className: "control-label font-size-14 color-white"
	                    },
	                    "Select a Role"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      id: "role",
	                      value: role,
	                      onChange: this.handleInputChange,
	                      className: "join-select-input"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "Select a Role"
	                    ),
	                    Object.keys(players).map(function (i) {
	                      var player = players[i];
	
	                      return _react2.default.createElement(
	                        "option",
	                        { key: i, value: player.role },
	                        roles[player.role]
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-10 col-md-offset-1 mg-top-3vh col-xs-12" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "submit",
	                      onClick: this.handleSubmit,
	                      className: "btn login-btn btn-lg btn-block"
	                    },
	                    "Let's Play!"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-10 col-md-offset-1 logout-btn col-xs-12" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/#", className: "btn btn-link", onClick: this.logout },
	                    "Logout"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-8 color-white hidden-xs" },
	            _react2.default.createElement(
	              "div",
	              { className: "text-center mg-top-10vh join-page-caption" },
	              "Will you be the Market Leader?"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement("img", {
	                src: _Screenshot2.default,
	                className: "join-page-screen-preview",
	                alt: "Screen Preview"
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return JoinPage;
	}(_react.PureComponent);
	
	exports.default = JoinPage;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _LandingPageLogo = __webpack_require__(210);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Turn a login-flow error into a user-facing message. Three buckets:
	//   1. Bad credentials (only from the initial loginRequest — 400/401):
	//      "Login details are incorrect, please try again."
	//   2. Network / offline (no status code — browser couldn't reach the
	//      server, timeout, DNS, CORS block, etc.):
	//      "Can't reach the server. Check your internet connection..."
	//   3. Anything else (server 5xx, or a downstream call failed after
	//      credentials already validated):
	//      "Something went wrong. Please try again..."
	// `phase` is 'credentials' only for the initial loginRequest catch;
	// every other catch runs AFTER login already succeeded, so 400/401
	// there is not a credentials issue and shouldn't say so.
	var classifyLoginError = function classifyLoginError(err, phase) {
	  var status = err && (err.status || err.response && err.response.status);
	  if (status == null) {
	    return "Can't reach the server. Check your internet connection and try again.";
	  }
	  if (phase === 'credentials' && (status === 400 || status === 401)) {
	    return "Login details are incorrect, please try again.";
	  }
	  return "Something went wrong. Please try again in a moment.";
	};
	
	var LoginPage = function (_PureComponent) {
	  _inherits(LoginPage, _PureComponent);
	
	  function LoginPage(props) {
	    _classCallCheck(this, LoginPage);
	
	    var _this = _possibleConstructorReturn(this, (LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call(this, props));
	
	    _this.handleInputChange = function (e) {
	      _this.setState(_defineProperty({
	        loginError: ""
	      }, e.target.id, e.target.value));
	    };
	
	    _this.renderLoginError = function () {
	      var loginError = _this.state.loginError;
	
	
	      if (loginError === "") {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row text-center mg-top-3vh" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4 col-md-offset-4 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            _react2.default.createElement(
	              "h4",
	              null,
	              loginError
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderActivationAlert = function () {
	      var location = _this.props.location;
	      var loginError = _this.state.loginError;
	
	
	      if (loginError !== "") {
	        return null;
	      }
	
	      if (location.query.activation) {
	        return _react2.default.createElement(
	          "div",
	          { className: "row text-center mg-top-3vh" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-4 col-md-offset-4 col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "alert alert-info" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "We have sent a verify link to your email on file. Please check your email."
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    };
	
	    _this.renderVerifiedAlert = function () {
	      var location = _this.props.location;
	      var loginError = _this.state.loginError;
	
	
	      if (loginError !== "") {
	        return null;
	      }
	
	      if (location.query.verified) {
	        return _react2.default.createElement(
	          "div",
	          { className: "row text-center mg-top-3vh" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-4 col-md-offset-4 col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "alert alert-info" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Your account has been verified. You can login to continue working with Market Games!"
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    };
	
	    _this.renderResetPasswordAlert = function () {
	      var location = _this.props.location;
	      var loginError = _this.state.loginError;
	
	
	      if (loginError !== "") {
	        return null;
	      }
	
	      if (location.query.reset_password) {
	        return _react2.default.createElement(
	          "div",
	          { className: "row text-center mg-top-3vh" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-4 col-md-offset-4 col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "alert alert-info" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Your password has been reset. You can login to continue working with Market Games!"
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    };
	
	    _this.handleSubmit = function () {
	      var _this$state = _this.state,
	          username = _this$state.username,
	          password = _this$state.password;
	
	      var data = {
	        username: username,
	        password: password
	      };
	
	      _this.setState({
	        loginPlaceholder: "Login..."
	      });
	
	      (0, _ApiService.loginRequest)(data).then(function (res) {
	        var _res$body = res.body,
	            token = _res$body.token,
	            user = _res$body.user,
	            position = _res$body.position,
	            is_paid = _res$body.is_paid;
	
	        // FE prefers the deterministic picker (highest-id course /
	        // highest-id game) when the login response carries the plural
	        // arrays — this matters for multi-course instructors. But for
	        // students, BE currently returns only res.body.game (singular
	        // id) and res.body.course (singular id), no plural arrays, so
	        // the picker returns null and Auth would end up storing "null"
	        // in sessionStorage → downstream game_id lookups return 0 →
	        // /start bounces to /onboarding → wrong Round 1 landing.
	        // Fall back to the singular ids when the picker gives us
	        // nothing.
	
	        var _pickCourseAndGame = (0, _AppGeneralInfoService.pickCourseAndGame)(res.body.courses, res.body.games),
	            pickedCourse = _pickCourseAndGame.course,
	            pickedGame = _pickCourseAndGame.game;
	
	        var courseId = pickedCourse ? pickedCourse.id : res.body.course || null;
	        var game = pickedGame ? pickedGame.id : res.body.game || null;
	
	        console.log('[MG:login] response body:', {
	          user: user, position: position, is_paid: is_paid,
	          courses: res.body && res.body.courses,
	          games: res.body && res.body.games,
	          pickedCourse: pickedCourse, pickedGame: pickedGame
	        });
	        console.log('[MG:login] storing in sessionStorage:', { course_id: courseId, game_id: game });
	
	        _Auth2.default.authenticateUser(token, user, position, game, courseId);
	
	        // Nuke any cached general-info from a previous session in this
	        // tab. Otherwise a stale response (e.g. from before backend
	        // added the intro field) can bypass the intro gate.
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	
	        var joinRequest1 = (0, _ApiService.batchRequest)([_Auth2.default.getUserDataRequest()]);
	
	        joinRequest1.then(function (res) {
	          if (res[0].statusCode !== 200) {
	            throw res[0];
	          }
	
	          var user_data = res[0].body;
	          _Auth2.default.setUserData(user_data);
	
	          if (position === "Student") {
	            // Fetch general-info directly here so we can synchronously
	            // decide on the intro gate. The get_info endpoint used
	            // above may not include the intro field, so we can't rely
	            // on user_data alone.
	            (0, _AppGeneralInfoService.fetchAppGeneralInfo)(game, "student").then(function (gi) {
	              var freshUser = gi && gi.user || user_data;
	              if (freshUser) {
	                _Auth2.default.setUserData(freshUser);
	              }
	
	              // Intro gate: first-time students must watch the ITB
	              // intro video before continuing. Intro flag is a 0/1
	              // field on the user record; 0 means "not yet watched".
	              if (freshUser && freshUser.intro === 0) {
	                _Teams2.default.setEmptyData();
	                _this.eventemitter.trigger("reload-data");
	                (0, _Location.changeLocation)("/intro-video");
	                return;
	              }
	
	              // Kick off the App-level refresh so the rest of the app
	              // has fresh state, but we don't need to wait for it.
	              _this.eventemitter.trigger("reload-data");
	
	              if (is_paid === false) {
	                _Teams2.default.setEmptyData();
	
	                if (_this.isMobile === true) {
	                  (0, _Location.changeLocation)("/promo-code");
	                } else {
	                  (0, _Location.changeLocation)("/start");
	                }
	              } else if (!game) {
	                // Picker returned no game for the current course:
	                // instructor hasn't spun up the exercise yet. Route
	                // to /onboarding — App.js's fetchData will set
	                // noGameYet and OnboardingPage will render the
	                // locked "Waiting on Instructor" screen. Skipping
	                // the /join branch here avoids a flash of the join
	                // page for a student who is already in a course.
	                _Teams2.default.setEmptyData();
	                (0, _Location.changeLocation)("/onboarding");
	              } else if (_Auth2.default.getRole() === "" || !_Auth2.default.getTeamId()) {
	                _Teams2.default.setEmptyData();
	                (0, _Location.changeLocation)("/join");
	              } else {
	                var joinRequest2 = (0, _ApiService.batchRequest)([].concat(_toConsumableArray(_Teams2.default.requests())));
	
	                joinRequest2.then(function (res2) {
	                  var teams_data = [{
	                    status: res2[0].statusCode,
	                    data: res2[0].body
	                  }, {
	                    status: res2[1].statusCode,
	                    data: res2[1].body
	                  }];
	                  var teams_status = _Teams2.default.setData(teams_data);
	                  if (teams_status === "Error") {
	                    throw teams_status;
	                  }
	
	                  (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/teamplayers/?game=" + _Auth2.default.getGameId()).then(function (res3) {
	                    _Auth2.default.setPlayerRoles(res3.body.results);
	                    (0, _Location.changeLocation)("/start");
	                  }).catch(function (err3) {
	                    console.log("Error3", err3);
	                    _Auth2.default.deauthenticateUser();
	
	                    _this.setState({
	                      loginPlaceholder: "Login",
	                      loginError: classifyLoginError(err3)
	                    });
	                  });
	                }).catch(function (err1) {
	                  console.log("Error1", err1);
	                  _Auth2.default.deauthenticateUser();
	
	                  _this.setState({
	                    loginPlaceholder: "Login",
	                    loginError: classifyLoginError(err1)
	                  });
	                });
	              }
	            }).catch(function (err) {
	              console.log("Error general-info", err);
	              _Auth2.default.deauthenticateUser();
	              _this.setState({
	                loginPlaceholder: "Login",
	                loginError: classifyLoginError(err)
	              });
	            });
	          } else if (position === "Instructor" || position === "Co-Instructor" || position === "Instructor Assistant") {
	            _Teams2.default.setEmptyData();
	            // Mirror the student branch: refresh Auth._user from
	            // general-info's data.user before navigating to /start.
	            // /users/<id>/get_info/ has been observed to return a
	            // stale `onboard` (0) even after the BE has flipped it,
	            // which routes already-onboarded instructors back into
	            // /instructor/onboarding/intro. general-info sources
	            // user from a different path and reflects current state,
	            // so letting it override closes the gap. Falls back to
	            // the get_info body if general-info can't be fetched.
	            (0, _AppGeneralInfoService.fetchAppGeneralInfo)(0, "instructor").then(function (gi) {
	              var freshUser = gi && gi.user || user_data;
	              if (freshUser) {
	                _Auth2.default.setUserData(freshUser);
	              }
	            }).catch(function () {
	              // Non-fatal: fall through with the get_info value.
	            }).then(function () {
	              _this.eventemitter.trigger("reload-data", [function () {
	                (0, _Location.changeLocation)("/start");
	              }]);
	            });
	          } else {
	            throw res[0];
	          }
	        }).catch(function (err2) {
	          console.log("Error2", err2);
	          _Auth2.default.deauthenticateUser();
	
	          _this.setState({
	            loginPlaceholder: "Login",
	            loginError: classifyLoginError(err2)
	          });
	        });
	      }).catch(function (err) {
	        console.log("Error3", err);
	        _this.setState({
	          loginPlaceholder: "Login",
	          loginError: classifyLoginError(err, 'credentials')
	        });
	      });
	    };
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	    };
	
	    _this.state = {
	      username: "",
	      password: "",
	      loginError: "",
	      loginPlaceholder: "Login"
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(LoginPage, [{
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          username = _state.username,
	          password = _state.password,
	          loginPlaceholder = _state.loginPlaceholder;
	
	      var logoStyle = (0, _utils.getLogoStyle)(this.isMobile);
	      var loginError = this.renderLoginError();
	      var activationAlert = this.renderActivationAlert();
	      var verifiedAlert = this.renderVerifiedAlert();
	      var resetPasswordAlert = this.renderResetPasswordAlert();
	      var formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-color-blue height-100vh" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-center mg-top-15vh" },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/welcome" },
	            _react2.default.createElement("img", { src: _LandingPageLogo2.default, style: logoStyle, alt: "Logo" })
	          )
	        ),
	        loginError,
	        activationAlert,
	        verifiedAlert,
	        resetPasswordAlert,
	        _react2.default.createElement(
	          "div",
	          { className: formClass },
	          _react2.default.createElement(
	            "form",
	            { className: "form-signin", onSubmit: this.onSubmit },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-group col-md-4 col-md-offset-2 col-xs-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    htmlFor: "username",
	                    className: "control-label font-size-14 color-white"
	                  },
	                  "Username"
	                ),
	                _react2.default.createElement("input", {
	                  id: "username",
	                  type: "text",
	                  value: username,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Username",
	                  required: true,
	                  autoFocus: !this.isMobile
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-group col-md-4 col-xs-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    htmlFor: "password",
	                    className: "control-label font-size-14 color-white"
	                  },
	                  "Password"
	                ),
	                _react2.default.createElement("input", {
	                  id: "password",
	                  type: "password",
	                  value: password,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Password",
	                  required: true
	                }),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: "/reset-password",
	                    className: "btn btn-link reset-password-link"
	                  },
	                  "Reset password"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mg-top-3vh" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2 col-md-offset-8 col-xs-12" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    onClick: this.handleSubmit,
	                    className: "btn login-btn btn-lg btn-block"
	                  },
	                  loginPlaceholder
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoginPage;
	}(_react.PureComponent);
	
	exports.default = LoginPage;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _payments = __webpack_require__(587);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PromoCodePage(props) {
	  return _react2.default.createElement(_payments2.default, { mode: "page" });
	}
	
	exports.default = PromoCodePage;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _Location = __webpack_require__(23);
	
	var _LandingPageLogo = __webpack_require__(210);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REGISTER_URL = ("https://be-production-itb.marketgames.io/api/") + "account/register/";
	var FIELDS_STEP1 = ["first_name", "last_name", "course_code"];
	var FIELDS_STEP2 = ["username", "password", "password_2", "email"];
	
	var RegisterPage = function (_PureComponent) {
	  _inherits(RegisterPage, _PureComponent);
	
	  function RegisterPage(props) {
	    _classCallCheck(this, RegisterPage);
	
	    var _this = _possibleConstructorReturn(this, (RegisterPage.__proto__ || Object.getPrototypeOf(RegisterPage)).call(this, props));
	
	    _this.handleInputChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.id, e.target.value));
	    };
	
	    _this.canChangeStep = function () {
	      var _this$state = _this.state,
	          step = _this$state.step,
	          validations = _this$state.validations;
	
	      var fields = step === 1 ? FIELDS_STEP1 : FIELDS_STEP2;
	
	      var result = true;
	      fields.forEach(function (field) {
	        if (field in validations && validations[field] !== "") {
	          result = false;
	        }
	      });
	
	      return result;
	    };
	
	    _this.changeStep = function () {
	      var step = _this.state.step;
	
	
	      if (step === 1) {
	        _this.setState({
	          step: 2,
	          validations: {}
	        });
	      } else if (step === 2) {
	        (0, _Location.changeLocation)("/login?activation=1");
	      }
	    };
	
	    _this.updateValidations = function (validations) {
	      _this.setState({
	        validations: validations
	      }, function () {
	        if (_this.canChangeStep()) {
	          _this.changeStep();
	        }
	      });
	    };
	
	    _this.goToNext = function (e) {
	      var data = {};
	      var keys = ["first_name", "last_name", "course_code", "username", "password", "password_2", "email"];
	
	      keys.forEach(function (key) {
	        if (_this.state[key] && _this.state[key] !== "") {
	          data[key] = _this.state[key];
	        }
	      });
	
	      (0, _ApiService.postRequest)(REGISTER_URL).send(data).then(function (response) {
	        _this.updateValidations({});
	      }).catch(function (err) {
	        if (err.response && err.response.statusCode === 400) {
	          _this.updateValidations(err.response.body);
	        } else if (err.response && err.response.statusCode === 201) {
	          _this.updateValidations({});
	        } else {
	          (0, _utils.logError)(err, "RegisterPage", "goToNext");
	        }
	      });
	    };
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	    };
	
	    _this.hasError = function (key) {
	      var validations = _this.state.validations;
	
	
	      if (key in validations && validations[key] !== "") {
	        return "form-group has-error register-error";
	      }
	
	      return "form-group";
	    };
	
	    _this.getError = function (key) {
	      var validations = _this.state.validations;
	
	
	      if (key in validations && validations[key] !== "") {
	        return _react2.default.createElement(
	          "span",
	          { className: "help-block" },
	          validations[key]
	        );
	      }
	
	      return null;
	    };
	
	    _this.state = {
	      first_name: "",
	      last_name: "",
	      course_code: "",
	      username: "",
	      password: "",
	      password_2: "",
	      email: "",
	      validations: {},
	      step: 1
	    };
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(RegisterPage, [{
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          first_name = _state.first_name,
	          last_name = _state.last_name,
	          course_code = _state.course_code,
	          username = _state.username,
	          password = _state.password,
	          password_2 = _state.password_2,
	          email = _state.email,
	          step = _state.step;
	
	      var logoStyle = (0, _utils.getLogoStyle)(this.isMobile);
	      var formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
	      var buttonStyle = this.isMobile ? {
	        paddingTop: "20px"
	      } : {};
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-color-blue height-100vh" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-center mg-top-15vh" },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/welcome" },
	            _react2.default.createElement("img", { src: _LandingPageLogo2.default, style: logoStyle, alt: "Logo" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: formClass },
	          _react2.default.createElement(
	            "form",
	            {
	              className: "form-signin form-horizontal",
	              onSubmit: this.onSubmit
	            },
	            step === 1 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("first_name") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "first_name",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "First Name"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "first_name",
	                  type: "text",
	                  value: first_name,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "First Name",
	                  required: true,
	                  autoFocus: !this.isMobile
	                }),
	                this.getError("first_name")
	              )
	            ),
	            step === 1 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("last_name") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "last_name",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "Last Name"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "last_name",
	                  type: "text",
	                  value: last_name,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Last Name",
	                  required: true
	                }),
	                this.getError("last_name")
	              )
	            ),
	            step === 1 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("course_code") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "course_code",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "Course Code"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "course_code",
	                  type: "text",
	                  value: course_code,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Course Code",
	                  required: true
	                }),
	                this.getError("course_code")
	              )
	            ),
	            step === 2 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("username") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "username",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "Username"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "username",
	                  type: "text",
	                  value: username,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Username",
	                  required: true,
	                  autoFocus: !this.isMobile
	                }),
	                this.getError("username")
	              )
	            ),
	            step === 2 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("password") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "password",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "Password"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "password",
	                  type: "password",
	                  value: password,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Password",
	                  required: true
	                }),
	                this.getError("password")
	              )
	            ),
	            step === 2 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("password_2") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "password_2",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "Confirm password"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "password_2",
	                  type: "password",
	                  value: password_2,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Confirm password",
	                  required: true
	                }),
	                this.getError("password_2")
	              )
	            ),
	            step === 2 && _react2.default.createElement(
	              "div",
	              { className: this.hasError("email") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "email",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "E-mail"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "email",
	                  type: "text",
	                  value: email,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "E-mail",
	                  required: true
	                }),
	                this.getError("email")
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-group mg-top-3vh", style: buttonStyle },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2 col-md-offset-6 col-xs-12" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: step === 2 ? "submit" : "button",
	                    onClick: this.goToNext,
	                    className: "btn login-btn btn-lg btn-block"
	                  },
	                  "Continue"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RegisterPage;
	}(_react.PureComponent);
	
	exports.default = RegisterPage;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _LandingPageLogo = __webpack_require__(210);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESET_PASSWORD_URL = ("https://be-production-itb.marketgames.io/api/") + "account/password_reset/";
	
	var ERROR_MESSAGE = "You do not have an email on file, please have Market Games admin add an email for you.";
	var SUCCESS_MESSAGE = "We have sent a reset password link to your email on file. Please check your email.";
	
	var ResetPasswordPage = function (_PureComponent) {
	  _inherits(ResetPasswordPage, _PureComponent);
	
	  function ResetPasswordPage(props) {
	    _classCallCheck(this, ResetPasswordPage);
	
	    var _this = _possibleConstructorReturn(this, (ResetPasswordPage.__proto__ || Object.getPrototypeOf(ResetPasswordPage)).call(this, props));
	
	    _this.handleInputChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, e.target.id, e.target.value), _defineProperty(_this$setState, "result", ""), _defineProperty(_this$setState, "resultStatus", ""), _this$setState));
	    };
	
	    _this.isValidEmail = function () {
	      var email = _this.state.email;
	
	      var validEmail = (0, _utils.validateEmail)(email);
	
	      _this.setState({
	        validEmail: validEmail
	      });
	    };
	
	    _this.handleSubmit = function () {
	      _this.isValidEmail();
	
	      var _this$state = _this.state,
	          email = _this$state.email,
	          validEmail = _this$state.validEmail;
	
	
	      if (validEmail === false) {
	        return;
	      }
	
	      (0, _ApiService.postRequest)(RESET_PASSWORD_URL).send({
	        email: email
	      }).then(function (response) {
	        var message = response.body === "reset email sent" ? SUCCESS_MESSAGE : (0, _utils.ucfirst)(response.body);
	
	        _this.setState({
	          result: message,
	          resultStatus: "success"
	        });
	      }).catch(function (err) {
	        if (err.response && err.response.statusCode === 404) {
	          var message = err.response.body === "user not found" ? ERROR_MESSAGE : (0, _utils.ucfirst)(err.response.body);
	
	          _this.setState({
	            result: message,
	            resultStatus: "danger"
	          });
	        } else {
	          (0, _utils.logError)(err, "ResetPasswordPage", "handleSubmit");
	        }
	      });
	    };
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	    };
	
	    _this.state = {
	      email: "",
	      validEmail: true,
	      result: "",
	      resultStatus: ""
	    };
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(ResetPasswordPage, [{
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          email = _state.email,
	          validEmail = _state.validEmail,
	          result = _state.result,
	          resultStatus = _state.resultStatus;
	
	      var logoStyle = (0, _utils.getLogoStyle)(this.isMobile);
	      var formGroupClass = validEmail === true ? "form-group" : "form-group has-error reset-password-error";
	      var alertClass = "alert alert-" + resultStatus;
	      var formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
	      var buttonStyle = this.isMobile ? {
	        paddingTop: "20px"
	      } : {};
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-color-blue height-100vh" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-center mg-top-15vh" },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/welcome" },
	            _react2.default.createElement("img", { src: _LandingPageLogo2.default, style: logoStyle, alt: "Logo" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: formClass },
	          result !== "" && resultStatus !== "" && _react2.default.createElement(
	            "div",
	            { className: "row text-center" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-md-offset-4 col-xs-12" },
	              _react2.default.createElement(
	                "div",
	                { className: alertClass },
	                result
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              className: "form-signin form-horizontal",
	              onSubmit: this.onSubmit
	            },
	            _react2.default.createElement(
	              "div",
	              { className: formGroupClass },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "email",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "E-mail"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "email",
	                  type: "text",
	                  value: email,
	                  onChange: this.handleInputChange,
	                  onBlur: this.isValidEmail,
	                  className: "form-control border-radius-none",
	                  placeholder: "E-mail",
	                  required: true,
	                  autoFocus: !this.isMobile
	                }),
	                validEmail === false && _react2.default.createElement(
	                  "span",
	                  { className: "help-block" },
	                  "Email is not valid"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row mg-top-3vh", style: buttonStyle },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4 col-md-offset-4 col-xs-12" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    onClick: this.handleSubmit,
	                    className: "btn login-btn btn-lg btn-block"
	                  },
	                  "Reset password"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPasswordPage;
	}(_react.PureComponent);
	
	exports.default = ResetPasswordPage;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPageLogo = __webpack_require__(210);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _reactRouter = __webpack_require__(24);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WelcomePage(props) {
	  var isMobile = (0, _utils.detectMobile)();
	  var logoStyle = (0, _utils.getLogoStyle)(isMobile);
	
	  var secondButtonStyle = isMobile ? {
	    marginTop: "20px",
	    marginBottom: "20px"
	  } : {};
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid bg-color-blue height-100vh" },
	    _react2.default.createElement(
	      "div",
	      { className: "text-center mg-top-15vh" },
	      _react2.default.createElement("img", { src: _LandingPageLogo2.default, style: logoStyle, alt: "Logo" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "row mg-top-10vh" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-3 col-md-offset-3 col-xs-12" },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/login", className: "btn login-btn btn-lg btn-block" },
	          "Login"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-3 col-xs-12" },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: "/register",
	            className: "btn login-btn btn-lg btn-block",
	            style: secondButtonStyle
	          },
	          "Register"
	        )
	      )
	    )
	  );
	}
	
	exports.default = WelcomePage;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 11px 50px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 15px;\n'], ['\n  padding: 11px 50px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 15px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 25px;\n'], ['\n  display: flex;\n  gap: 25px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: 20px;\n'], ['\n  margin-left: 20px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 20px;\n  margin-left: 20px;\n'], ['\n  display: flex;\n  gap: 20px;\n  margin-left: 20px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 27px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: .4;\n  pointer-events: none;\n\n  ', '\n\n  ', '}\n'], ['\n  width: 27px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: .4;\n  pointer-events: none;\n\n  ', '\n\n  ', '}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _selector = __webpack_require__(607);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _constants = __webpack_require__(409);
	
	var _iconTeamsRolesPaginationRight = __webpack_require__(688);
	
	var _iconTeamsRolesPaginationRight2 = _interopRequireDefault(_iconTeamsRolesPaginationRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PaginationWrapper = _styledComponents2.default.div(_templateObject);
	
	var RowsSelectorWrapper = _styledComponents2.default.div(_templateObject2);
	
	var RowsCount = _styledComponents2.default.div(_templateObject3);
	
	var PageArrows = _styledComponents2.default.div(_templateObject4);
	
	var PageArrow = _styledComponents2.default.button(_templateObject5, function (p) {
	  return p.prev && '\n    transform: rotate(180deg);\n  ';
	}, function (p) {
	  return p.active && '{\n    opacity: 1;\n    pointer-events: auto;\n  }';
	});
	
	var AnswersPagination = function (_PureComponent) {
	  _inherits(AnswersPagination, _PureComponent);
	
	  function AnswersPagination(props) {
	    _classCallCheck(this, AnswersPagination);
	
	    var _this = _possibleConstructorReturn(this, (AnswersPagination.__proto__ || Object.getPrototypeOf(AnswersPagination)).call(this, props));
	
	    _this.state = {
	      query: '',
	      typing: false,
	      typingTimeout: 0
	    };
	    return _this;
	  }
	
	  _createClass(AnswersPagination, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rowsPerPage = _props.rowsPerPage,
	          handleRowsPerPageChange = _props.handleRowsPerPageChange,
	          rowsTotal = _props.rowsTotal,
	          activePrevPage = _props.activePrevPage,
	          activeNextPage = _props.activeNextPage,
	          page = _props.page,
	          handlePageChange = _props.handlePageChange;
	
	
	      var rowStart = (page - 1) * Number(rowsPerPage) + 1;
	      var rowsEnd = rowStart + Number(rowsPerPage) - 1;
	      if (rowsEnd > rowsTotal) {
	        rowsEnd = rowsTotal;
	      }
	
	      return _react2.default.createElement(
	        PaginationWrapper,
	        null,
	        _react2.default.createElement(
	          RowsSelectorWrapper,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Rows per page:'
	          ),
	          _react2.default.createElement(_selector2.default, {
	            options: _constants.answersRowsPerPage,
	            selectedOptionId: _constants.answersRowsPerPage.find(function (item) {
	              return item.name === rowsPerPage;
	            }).id,
	            size: 'small',
	            onSelectorChange: handleRowsPerPageChange
	          })
	        ),
	        _react2.default.createElement(
	          RowsCount,
	          null,
	          rowStart,
	          '-',
	          rowsEnd,
	          ' of ',
	          rowsTotal
	        ),
	        _react2.default.createElement(
	          PageArrows,
	          null,
	          _react2.default.createElement(
	            PageArrow,
	            { prev: true, active: activePrevPage, onClick: function onClick() {
	                return handlePageChange(page - 1);
	              } },
	            _react2.default.createElement('img', { src: _iconTeamsRolesPaginationRight2.default, alt: 'Prev' })
	          ),
	          _react2.default.createElement(
	            PageArrow,
	            { active: activeNextPage, onClick: function onClick() {
	                return handlePageChange(page + 1);
	              } },
	            _react2.default.createElement('img', { src: _iconTeamsRolesPaginationRight2.default, alt: 'Next' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AnswersPagination;
	}(_react.PureComponent);
	
	exports.default = AnswersPagination;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"], ["\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  border: 2px solid #5C91F5;\n  border-radius: 4px;\n  width: 180px;\n  padding: 6px 40px 6px 16px;\n  color: #5C91F5;\n  cursor: pointer;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 16px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  background: #fff;\n\n  ", "}\n"], ["\n  border: 2px solid #5C91F5;\n  border-radius: 4px;\n  width: 180px;\n  padding: 6px 40px 6px 16px;\n  color: #5C91F5;\n  cursor: pointer;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 16px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  background: #fff;\n\n  ", "}\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  background-color: #5C91F5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n\n  ", "}\n"], ["\n  width: 32px;\n  height: 32px;\n  background-color: #5C91F5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n\n  ", "}\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  z-index: 1;\n  position: absolute;\n  display: none;\n  left: 0;\n  right: 0;\n  width: 100%;\n\n  ", "\n"], ["\n  z-index: 1;\n  position: absolute;\n  display: none;\n  left: 0;\n  right: 0;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 3px solid #ffffff;\n  border-radius: 5px;\n  list-style: none;\n  font-weight: 800;\n  color: #ffffff;\n  background-color: #2a4169;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #5C91F5; \n  }\n\n  li {\n    cursor: pointer;\n    padding: 6px 16px;\n  }\n\n  li:hover {\n    color: #2a4169;\n    background: #fff;\n  }\n\n  ", "}\n"], ["\n  width: 100%;\n  border: 3px solid #ffffff;\n  border-radius: 5px;\n  list-style: none;\n  font-weight: 800;\n  color: #ffffff;\n  background-color: #2a4169;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #5C91F5; \n  }\n\n  li {\n    cursor: pointer;\n    padding: 6px 16px;\n  }\n\n  li:hover {\n    color: #2a4169;\n    background: #fff;\n  }\n\n  ", "}\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _iconDropdownArrowFilled = __webpack_require__(687);
	
	var _iconDropdownArrowFilled2 = _interopRequireDefault(_iconDropdownArrowFilled);
	
	var _iconArrowSelectSolid = __webpack_require__(686);
	
	var _iconArrowSelectSolid2 = _interopRequireDefault(_iconArrowSelectSolid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SelectorContainer = _styledComponents2.default.div(_templateObject);
	
	var SelectedOptionWrapper = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.size && p.size === 'small' && "{\n    padding: 2px 28.5px 2px 12px;\n    width: auto;\n    height: auto;\n    line-height: 20px;\n    font-size: 14px;\n    border: 1px solid #D5D9DD;\n    color: rgba(0,27,59,0.94);\n  }";
	});
	
	var SelectorArrow = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.size && p.size === 'small' && "{\n    background-color: transparent;\n    width: 28.5px;\n    height: auto;\n    display: flex;\n    align-items: center;\n\n    img {\n      width: 7px;\n      height: auto;\n      margin-left: 6.5px;\n      content: url(" + _iconArrowSelectSolid2.default + ");\n    }\n  }";
	});
	
	var SelectorItemsWrapper = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.isShown && "\n    display: block;\n  ";
	});
	
	var SelectorItems = _styledComponents2.default.ul(_templateObject5, function (p) {
	  return p.size && p.size === 'small' && "{\n    background-color: #fff;\n    color: rgba(0, 27, 59, 0.94);\n    font-weight: 500;\n    border: 1px solid #D5D9DD;\n\n    li {\n      padding: 2px 16px;\n    }\n\n    li:hover {\n      background: #FAFBFD;\n    }\n  }";
	});
	
	var Selector = function (_PureComponent) {
	  _inherits(Selector, _PureComponent);
	
	  function Selector(props) {
	    _classCallCheck(this, Selector);
	
	    var _this = _possibleConstructorReturn(this, (Selector.__proto__ || Object.getPrototypeOf(Selector)).call(this, props));
	
	    _this.handleClickOutside = function (e) {
	      var clicked1 = false;
	      if (_this.currentRef && _this.currentRef.contains(e.target)) {
	        clicked1 = true;
	      }
	
	      var clicked2 = false;
	      if (_this.currentRef2 && _this.currentRef2.contains(e.target)) {
	        clicked2 = true;
	      }
	
	      if (!clicked1 && !clicked2) {
	        _this.setState({
	          menuShown: false
	        });
	      }
	    };
	
	    _this.toggleMenu = function () {
	      _this.setState({
	        menuShown: !_this.state.menuShown
	      });
	    };
	
	    _this.currentRef = null;
	    _this.currentRef2 = null;
	
	    _this.state = {
	      menuShown: false
	    };
	    return _this;
	  }
	
	  _createClass(Selector, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (window) {
	        document.addEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (window) {
	        document.removeEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var menuShown = this.state.menuShown;
	      var _props = this.props,
	          options = _props.options,
	          onSelectorChange = _props.onSelectorChange,
	          selectedOptionId = _props.selectedOptionId,
	          size = _props.size;
	
	
	      return _react2.default.createElement(
	        SelectorContainer,
	        null,
	        _react2.default.createElement(
	          SelectedOptionWrapper,
	          {
	            innerRef: function innerRef(node) {
	              return _this2.currentRef = node;
	            },
	            onClick: this.toggleMenu,
	            size: size
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            selectedOptionId ? options.find(function (i) {
	              return i.id === selectedOptionId;
	            }).name : options[0].name
	          ),
	          _react2.default.createElement(
	            SelectorArrow,
	            { size: size },
	            _react2.default.createElement("img", { src: _iconDropdownArrowFilled2.default, alt: "arrow" })
	          )
	        ),
	        _react2.default.createElement(
	          SelectorItemsWrapper,
	          {
	            innerRef: function innerRef(node) {
	              return _this2.currentRef2 = node;
	            },
	            isShown: menuShown
	          },
	          _react2.default.createElement(
	            SelectorItems,
	            { size: size },
	            options.map(function (option, index) {
	              return _react2.default.createElement(
	                "li",
	                {
	                  onClick: function onClick() {
	                    onSelectorChange(option.id);
	                    _this2.toggleMenu();
	                  },
	                  value: option.id,
	                  key: index
	                },
	                option.name
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Selector;
	}(_react.PureComponent);
	
	exports.default = Selector;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cell = exports.Row = exports.Table = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #ffffff;\n  margin-top: 12px;\n  overflow: hidden;\n'], ['\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #ffffff;\n  margin-top: 12px;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  width: auto;\n\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: auto;\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 13px 22px;\n  display: flex;\n  align-items: center;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  flex: 1;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 13px 22px;\n  display: flex;\n  align-items: center;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Table = exports.Table = _styledComponents2.default.div(_templateObject);
	
	var Row = exports.Row = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	});
	
	var Cell = exports.Cell = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.color && '\n    color: ' + p.color + ';\n  ';
	}, function (p) {
	  return p.fontWeight && '\n    font-weight: ' + p.fontWeight + ';\n  ';
	}, function (p) {
	  return p.background && '\n    background: ' + p.background + ';\n  ';
	}, function (p) {
	  return p.percentageWidth && '\n    flex-basis: ' + p.percentageWidth + '%;\n  ';
	}, function (p) {
	  return p.textAlign && '\n    text-align: ' + p.textAlign + ';\n  ';
	});

/***/ },
/* 609 */
594,
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"], ["\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  border: 1px solid #D5D9DD;\n  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);\n  border-radius: 4px;\n  width: 100%;\n  padding: 2px 33px 2px 16px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  background: #fff;\n\n  ", "}\n"], ["\n  border: 1px solid #D5D9DD;\n  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);\n  border-radius: 4px;\n  width: 100%;\n  padding: 2px 33px 2px 16px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  background: #fff;\n\n  ", "}\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  display: flex;\n  align-items: center;\n\n  img {\n    width: 10px;\n    margin-left: 8px;\n  }\n\n  ", "}\n"], ["\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  display: flex;\n  align-items: center;\n\n  img {\n    width: 10px;\n    margin-left: 8px;\n  }\n\n  ", "}\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  z-index: 1;\n  position: absolute;\n  display: none;\n  left: 0;\n  right: 0;\n  width: 100%;\n\n  ", "\n\n  ", "\n"], ["\n  z-index: 1;\n  position: absolute;\n  display: none;\n  left: 0;\n  right: 0;\n  width: 100%;\n\n  ", "\n\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  list-style: none;\n  color: rgba(0, 27, 59, 0.94);\n  background-color: #fff;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #D5D9DD; \n  }\n\n  li {\n    cursor: pointer;\n    padding: 2px 16px;\n  }\n\n  li:hover {\n    background: #FAFBFD;\n  }\n"], ["\n  width: 100%;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  list-style: none;\n  color: rgba(0, 27, 59, 0.94);\n  background-color: #fff;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #D5D9DD; \n  }\n\n  li {\n    cursor: pointer;\n    padding: 2px 16px;\n  }\n\n  li:hover {\n    background: #FAFBFD;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _iconArrowSelectSolid = __webpack_require__(686);
	
	var _iconArrowSelectSolid2 = _interopRequireDefault(_iconArrowSelectSolid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TeamRolesSelectorContainer = _styledComponents2.default.div(_templateObject);
	
	var SelectedOptionWrapper = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.size && p.size === 'small' && "{\n    padding: 2px 28.5px 2px 12px;\n  }";
	});
	
	var TeamRolesSelectorArrow = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.size && p.size === 'small' && "{\n    width: 28.5px;\n\n    img {\n      width: 7px;\n      margin-left: 6.5px;\n    }\n  }";
	});
	
	var TeamRolesSelectorItemsWrapper = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.dropUp ? "\n    bottom: 100%;\n    margin-bottom: 4px;\n  " : "\n    top: 100%;\n    margin-top: 4px;\n  ";
	}, function (p) {
	  return p.isShown && "\n    display: block;\n  ";
	});
	
	var TeamRolesSelectorItems = _styledComponents2.default.ul(_templateObject5);
	
	var TeamRolesSelector = function (_PureComponent) {
	  _inherits(TeamRolesSelector, _PureComponent);
	
	  function TeamRolesSelector(props) {
	    _classCallCheck(this, TeamRolesSelector);
	
	    var _this = _possibleConstructorReturn(this, (TeamRolesSelector.__proto__ || Object.getPrototypeOf(TeamRolesSelector)).call(this, props));
	
	    _this.handleClickOutside = function (e) {
	      var clicked1 = false;
	      if (_this.currentRef && _this.currentRef.contains(e.target)) {
	        clicked1 = true;
	      }
	
	      var clicked2 = false;
	      if (_this.currentRef2 && _this.currentRef2.contains(e.target)) {
	        clicked2 = true;
	      }
	
	      if (!clicked1 && !clicked2) {
	        _this.setState({
	          menuShown: false
	        });
	      }
	    };
	
	    _this.toggleMenu = function () {
	      _this.setState({
	        menuShown: !_this.state.menuShown
	      });
	    };
	
	    _this.currentRef = null;
	    _this.currentRef2 = null;
	
	    _this.state = {
	      menuShown: false
	    };
	    return _this;
	  }
	
	  _createClass(TeamRolesSelector, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (window) {
	        document.addEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (window) {
	        document.removeEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var menuShown = this.state.menuShown;
	      var _props = this.props,
	          options = _props.options,
	          onSelectorChange = _props.onSelectorChange,
	          selectedOptionId = _props.selectedOptionId,
	          size = _props.size,
	          dropUp = _props.dropUp;
	
	
	      return _react2.default.createElement(
	        TeamRolesSelectorContainer,
	        null,
	        _react2.default.createElement(
	          SelectedOptionWrapper,
	          {
	            innerRef: function innerRef(node) {
	              return _this2.currentRef = node;
	            },
	            onClick: this.toggleMenu,
	            size: size
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            selectedOptionId ? options[' ' + selectedOptionId] ? options[' ' + selectedOptionId] : options[selectedOptionId] : Object.values(options)[0]
	          ),
	          _react2.default.createElement(
	            TeamRolesSelectorArrow,
	            { size: size },
	            _react2.default.createElement("img", { src: _iconArrowSelectSolid2.default, alt: "arrow" })
	          )
	        ),
	        _react2.default.createElement(
	          TeamRolesSelectorItemsWrapper,
	          {
	            innerRef: function innerRef(node) {
	              return _this2.currentRef2 = node;
	            },
	            isShown: menuShown,
	            dropUp: dropUp
	          },
	          _react2.default.createElement(
	            TeamRolesSelectorItems,
	            null,
	            Object.keys(options).map(function (option_id, index) {
	              return _react2.default.createElement(
	                "li",
	                {
	                  onClick: function onClick() {
	                    if (option_id !== selectedOptionId) onSelectorChange(option_id);
	
	                    _this2.toggleMenu();
	                  },
	                  value: option_id,
	                  key: index
	                },
	                options[option_id]
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamRolesSelector;
	}(_react.PureComponent);
	
	exports.default = TeamRolesSelector;

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractRoundErrorMessage = extractRoundErrorMessage;
	// Extracts a friendly error message from a round-creation / update
	// response. Handles three shapes the backend can return:
	//
	//   1. `non_field_errors`: ["..."]  — generic validation errors
	//   2. `detail`: "..."              — DRF default error envelope
	//   3. field-level errors           — { start_date: ["can not be less than now 2026-..."], ... }
	//
	// For field-level errors the field name is humanized
	// ("start_date" → "Start date") and the message is cleaned up
	// ("can not" → "cannot", trailing ISO-ish timestamps stripped) so
	// the dialog reads naturally:
	//
	//   { "start_date": ["can not be less than now 2026-06-10 14:55:00-07:00"] }
	//     →  "Start date cannot be less than now"
	//
	// Returns null when no usable message is found so the caller can
	// fall back to its own generic copy.
	function extractRoundErrorMessage(err) {
	  var body = err && err.response && err.response.body;
	  if (!body) return null;
	
	  if (typeof body === "string") return body;
	
	  if (Array.isArray(body.non_field_errors) && body.non_field_errors.length > 0) {
	    return cleanMessage(body.non_field_errors[0]);
	  }
	
	  if (body.detail) return cleanMessage(String(body.detail));
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Object.keys(body)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      var val = body[key];
	      var raw = Array.isArray(val) ? val[0] : typeof val === "string" ? val : null;
	      if (!raw) continue;
	
	      var label = humanizeFieldName(key);
	      var cleaned = cleanMessage(String(raw));
	      return label ? label + " " + cleaned : cleaned;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return null;
	}
	
	function humanizeFieldName(key) {
	  if (!key) return "";
	  var spaced = key.replace(/_/g, " ").trim();
	  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
	}
	
	function cleanMessage(msg) {
	  if (!msg) return "";
	  return String(msg)
	  // "can not" → "cannot"
	  .replace(/\bcan not\b/gi, "cannot")
	  // Strip a trailing ISO-ish timestamp (with optional timezone).
	  // Matches: "2026-06-10", "2026-06-10 14:55", "2026-06-10 14:55:00",
	  // "2026-06-10T14:55:00-07:00", "2026-06-10 14:55:00-0700", etc.
	  .replace(/\s+\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2})?(?:[+-]\d{2}:?\d{2})?)?\s*\.?$/, "").trim();
	}

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERIFY_URL = ("https://be-production-itb.marketgames.io/api/") + "account/verify/";
	
	function verifyCallback() {
	  (0, _Location.changeLocation)("/login?verified=1");
	}
	
	function AccountVerify(_ref) {
	  var token = _ref.token;
	
	  (0, _ApiService.getRequest)("" + VERIFY_URL + token + "/").then(verifyCallback).catch(verifyCallback);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "application-loading" },
	    _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	  );
	}
	
	exports.default = AccountVerify;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _Location = __webpack_require__(23);
	
	var _LandingPageLogo = __webpack_require__(210);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESET_PASSWORD_URL = ("https://be-production-itb.marketgames.io/api/") + "account/reset/";
	
	var ResetPassword = function (_PureComponent) {
	  _inherits(ResetPassword, _PureComponent);
	
	  function ResetPassword(props) {
	    _classCallCheck(this, ResetPassword);
	
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props));
	
	    _this.handleInputChange = function (e) {
	      _this.setState(_defineProperty({}, e.target.id, e.target.value));
	    };
	
	    _this.onSubmit = function (e) {
	      e.preventDefault();
	    };
	
	    _this.hasError = function (key) {
	      var validations = _this.state.validations;
	
	
	      if (key in validations && validations[key] !== "") {
	        return "form-group has-error register-error";
	      }
	
	      return "form-group";
	    };
	
	    _this.getError = function (key) {
	      var validations = _this.state.validations;
	
	
	      if (key in validations && validations[key] !== "") {
	        return _react2.default.createElement(
	          "span",
	          { className: "help-block" },
	          validations[key]
	        );
	      }
	
	      return null;
	    };
	
	    _this.submit = function () {
	      var data = {};
	      var keys = ["new_password", "new_password_2"];
	
	      keys.forEach(function (key) {
	        if (_this.state[key] && _this.state[key] !== "") {
	          data[key] = _this.state[key];
	        }
	      });
	
	      var _this$props = _this.props,
	          token1 = _this$props.token1,
	          token2 = _this$props.token2;
	
	
	      (0, _ApiService.postRequest)("" + RESET_PASSWORD_URL + token1 + "/" + token2 + "/").send(data).then(function (response) {
	        (0, _Location.changeLocation)("/login?reset_password=1");
	      }).catch(function (err) {
	        if (err.response && err.response.statusCode === 400) {
	          _this.setState({
	            validations: err.response.body
	          });
	        } else {
	          (0, _utils.logError)(err, "ResetPassword", "submit");
	        }
	      });
	    };
	
	    _this.state = {
	      new_password: "",
	      new_password_2: "",
	      validations: {}
	    };
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          new_password = _state.new_password,
	          new_password_2 = _state.new_password_2;
	
	      var logoStyle = (0, _utils.getLogoStyle)(this.isMobile);
	      var formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
	      var buttonStyle = this.isMobile ? {
	        paddingTop: "20px"
	      } : {};
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-color-blue height-100vh" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-center mg-top-15vh" },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/welcome" },
	            _react2.default.createElement("img", { src: _LandingPageLogo2.default, style: logoStyle, alt: "Logo" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: formClass },
	          _react2.default.createElement(
	            "form",
	            {
	              className: "form-signin form-horizontal",
	              onSubmit: this.onSubmit
	            },
	            _react2.default.createElement(
	              "div",
	              { className: this.hasError("new_password") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "new_password",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "New password"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "new_password",
	                  type: "password",
	                  value: new_password,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "New password",
	                  required: true,
	                  autoFocus: !this.isMobile
	                }),
	                this.getError("new_password")
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: this.hasError("new_password_2") },
	              _react2.default.createElement(
	                "label",
	                {
	                  htmlFor: "new_password_2",
	                  className: "control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
	                },
	                "Confirm new password"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 col-xs-12" },
	                _react2.default.createElement("input", {
	                  id: "new_password_2",
	                  type: "password",
	                  value: new_password_2,
	                  onChange: this.handleInputChange,
	                  className: "form-control border-radius-none",
	                  placeholder: "Confirm new password",
	                  required: true
	                }),
	                this.getError("new_password_2")
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-group mg-top-3vh", style: buttonStyle },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2 col-md-offset-6 col-xs-12" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "submit",
	                    onClick: this.submit,
	                    className: "btn login-btn btn-lg btn-block"
	                  },
	                  "Submit"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react.PureComponent);
	
	exports.default = ResetPassword;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1564), __esModule: true };

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1566), __esModule: true };

/***/ },
/* 616 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 617 */
[2693, 221, 160],
/* 618 */
[2697, 158, 264, 617],
/* 619 */
[2698, 412],
/* 620 */
[2703, 311, 159, 625, 220, 265, 1581, 418, 1588, 127],
/* 621 */
[2710, 267, 268, 186, 422, 184, 618, 158],
/* 622 */
[2712, 623, 415],
/* 623 */
[2714, 184, 186, 1573, 419],
/* 624 */
[2716, 158, 266, 186, 267],
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220);


/***/ },
/* 626 */
[2724, 421],
/* 627 */
[2736, 1590, 620],
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(116);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(64);
	var toAbsoluteIndex = __webpack_require__(195);
	var toLength = __webpack_require__(48);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(188);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(86);
	var toObject = __webpack_require__(64);
	var IObject = __webpack_require__(270);
	var toLength = __webpack_require__(48);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(86);
	var isObject = __webpack_require__(33);
	var invoke = __webpack_require__(638);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(57).f;
	var create = __webpack_require__(189);
	var redefineAll = __webpack_require__(193);
	var ctx = __webpack_require__(118);
	var anInstance = __webpack_require__(187);
	var forOf = __webpack_require__(188);
	var $iterDefine = __webpack_require__(436);
	var step = __webpack_require__(641);
	var setSpecies = __webpack_require__(194);
	var DESCRIPTORS = __webpack_require__(51);
	var fastKey = __webpack_require__(163).fastKey;
	var validate = __webpack_require__(197);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(222);
	var from = __webpack_require__(630);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(193);
	var getWeak = __webpack_require__(163).getWeak;
	var anObject = __webpack_require__(26);
	var isObject = __webpack_require__(33);
	var anInstance = __webpack_require__(187);
	var forOf = __webpack_require__(188);
	var createArrayMethod = __webpack_require__(128);
	var $has = __webpack_require__(104);
	var validate = __webpack_require__(197);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(317);
	var isObject = __webpack_require__(33);
	var toLength = __webpack_require__(48);
	var ctx = __webpack_require__(118);
	var IS_CONCAT_SPREADABLE = __webpack_require__(44)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 637 */
[2697, 51, 31, 429],
/* 638 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(33);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 640 */
[2701, 26],
/* 641 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(438);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 643 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 644 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 645 */
[2706, 51, 191, 321, 271, 64, 270, 31],
/* 646 */
[2709, 57, 26, 191, 51],
/* 647 */
[2711, 107, 190],
/* 648 */
[2714, 104, 107, 314, 443],
/* 649 */
[2716, 51, 191, 107, 271],
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(190);
	var gOPS = __webpack_require__(321);
	var anObject = __webpack_require__(26);
	var Reflect = __webpack_require__(30).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(30).parseFloat;
	var $trim = __webpack_require__(225).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(446) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(30).parseInt;
	var $trim = __webpack_require__(225).trim;
	var ws = __webpack_require__(446);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(26);
	var isObject = __webpack_require__(33);
	var newPromiseCapability = __webpack_require__(440);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 655 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(48);
	var repeat = __webpack_require__(445);
	var defined = __webpack_require__(129);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(120);
	var toLength = __webpack_require__(48);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 658 */
[2728, 44],
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(633);
	var validate = __webpack_require__(197);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(315)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(441);
	__webpack_require__(8)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(51) && /./g.flags != 'g') __webpack_require__(57).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(269)
	});


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(633);
	var validate = __webpack_require__(197);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(315)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(30);
	var each = __webpack_require__(128)(0);
	var redefine = __webpack_require__(97);
	var meta = __webpack_require__(163);
	var assign = __webpack_require__(645);
	var weak = __webpack_require__(635);
	var isObject = __webpack_require__(33);
	var validate = __webpack_require__(197);
	var NATIVE_WEAK_MAP = __webpack_require__(197);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(315)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(1884);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */
	;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js-light v2.5.1
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js-light
	   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Expat Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	  var MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	
	    // The initial configuration properties of the Decimal constructor.
	    Decimal = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed during run-time using `Decimal.config`.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
	      // `toFixed`, `toPrecision` and `toSignificantDigits`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -MAX_E
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to MAX_E
	
	      // The natural logarithm of 10.
	      // 115 digits
	      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    exponentOutOfRange = decimalError + 'Exponent out of range: ',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    ONE,
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284
	
	    // Decimal.prototype object
	    P = {};
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue                       abs
	   *  comparedTo                          cmp
	   *  decimalPlaces                       dp
	   *  dividedBy                           div
	   *  dividedToIntegerBy                  idiv
	   *  equals                              eq
	   *  exponent
	   *  greaterThan                         gt
	   *  greaterThanOrEqualTo                gte
	   *  isInteger                           isint
	   *  isNegative                          isneg
	   *  isPositive                          ispos
	   *  isZero
	   *  lessThan                            lt
	   *  lessThanOrEqualTo                   lte
	   *  logarithm                           log
	   *  minus                               sub
	   *  modulo                              mod
	   *  naturalExponential                  exp
	   *  naturalLogarithm                    ln
	   *  negated                             neg
	   *  plus                                add
	   *  precision                           sd
	   *  squareRoot                          sqrt
	   *  times                               mul
	   *  toDecimalPlaces                     todp
	   *  toExponential
	   *  toFixed
	   *  toInteger                           toint
	   *  toNumber
	   *  toPower                             pow
	   *  toPrecision
	   *  toSignificantDigits                 tosd
	   *  toString
	   *  valueOf                             val
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s) x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this;
	
	    y = new x.constructor(y);
	
	    // Signs differ?
	    if (x.s !== y.s) return x.s || -y.s;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
	
	    xdL = x.d.length;
	    ydL = y.d.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var x = this,
	      w = x.d.length - 1,
	      dp = (w - x.e) * LOG_BASE;
	
	    // Subtract the number of trailing zeros of the last word.
	    w = x.d[w];
	    if (w) for (; w % 10 == 0; w /= 10) dp--;
	
	    return dp < 0 ? 0 : dp;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, truncated to `precision` significant digits.
	   *
	   */
	  P.dividedToIntegerBy = P.idiv = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
	   *
	   */
	  P.exponent = function () {
	    return getBase10Exponent(this);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    return this.cmp(y) >= 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isint = function () {
	    return this.e > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isneg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.ispos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return this.s === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, truncated to
	   * `precision` significant digits.
	   *
	   * If no base is specified, return log[10](x).
	   *
	   * log[base](x) = ln(x) / ln(base)
	   *
	   * The maximum error of the result is 1 ulp (unit in the last place).
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var r,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      wpr = pr + 5;
	
	    // Default base is 10.
	    if (base === void 0) {
	      base = new Ctor(10);
	    } else {
	      base = new Ctor(base);
	
	      // log[-b](x) = NaN
	      // log[0](x)  = NaN
	      // log[1](x)  = NaN
	      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
	    }
	
	    // log[b](-x) = NaN
	    // log[b](0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // log[b](1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    external = false;
	    r = divide(ln(x, wpr), ln(base, wpr), wpr);
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    y = new Ctor(y);
	
	    // x % 0 = NaN
	    if (!y.s) throw Error(decimalError + 'NaN');
	
	    // Return x if x is 0.
	    if (!x.s) return round(new Ctor(x), pr);
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	    q = divide(x, y, 0, 1).times(y);
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return exp(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * truncated to `precision` significant digits.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return ln(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s || 0;
	    return x;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var e, sd, w,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    e = getBase10Exponent(x) + 1;
	    w = x.d.length - 1;
	    sd = w * LOG_BASE + 1;
	    w = x.d[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) sd--;
	
	      // Add the number of digits of the first word.
	      for (w = x.d[0]; w >= 10; w /= 10) sd++;
	    }
	
	    return z && e > sd ? e : sd;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var e, n, pr, r, s, t, wpr,
	      x = this,
	      Ctor = x.constructor;
	
	    // Negative or zero?
	    if (x.s < 1) {
	      if (!x.s) return new Ctor(0);
	
	      // sqrt(-x) = NaN
	      throw Error(decimalError + 'NaN');
	    }
	
	    e = getBase10Exponent(x);
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(x.d);
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '5e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    pr = Ctor.precision;
	    s = wpr = pr + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, wpr + 2)).times(0.5);
	
	      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
	        n = n.slice(wpr - 3, wpr + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (s == wpr && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          round(t, pr + 1, 0);
	
	          if (t.times(t).eq(x)) {
	            r = t;
	            break;
	          }
	        } else if (n != '9999') {
	          break;
	        }
	
	        wpr += 4;
	      }
	    }
	
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    // Return 0 if either is 0.
	    if (!x.s || !y.s) return new Ctor(0);
	
	    y.s *= x.s;
	    e = x.e + y.e;
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = e;
	
	    return external ? round(y, Ctor.precision) : y;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.todp = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return round(x, dp + getBase10Exponent(x) + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = toString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), dp + 1, rm);
	      str = toString(x, true, dp + 1);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) return toString(x);
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
	    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isneg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.toInteger = P.toint = function () {
	    var x = this,
	      Ctor = x.constructor;
	    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
	   * truncated to `precision` significant digits.
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * The maximum error is 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, sign, yIsInt,
	      x = this,
	      Ctor = x.constructor,
	      guard = 12,
	      yn = +(y = new Ctor(y));
	
	    // pow(x, 0) = 1
	    if (!y.s) return new Ctor(ONE);
	
	    x = new Ctor(x);
	
	    // pow(0, y > 0) = 0
	    // pow(0, y < 0) = Infinity
	    if (!x.s) {
	      if (y.s < 1) throw Error(decimalError + 'Infinity');
	      return x;
	    }
	
	    // pow(1, y) = 1
	    if (x.eq(ONE)) return x;
	
	    pr = Ctor.precision;
	
	    // pow(x, 1) = x
	    if (y.eq(ONE)) return round(x, pr);
	
	    e = y.e;
	    k = y.d.length - 1;
	    yIsInt = e >= k;
	    sign = x.s;
	
	    if (!yIsInt) {
	
	      // pow(x < 0, y non-integer) = NaN
	      if (sign < 0) throw Error(decimalError + 'NaN');
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = new Ctor(ONE);
	
	      // Max k of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      e = Math.ceil(pr / LOG_BASE + 4);
	
	      external = false;
	
	      for (;;) {
	        if (k % 2) {
	          r = r.times(x);
	          truncate(r.d, e);
	        }
	
	        k = mathfloor(k / 2);
	        if (k === 0) break;
	
	        x = x.times(x);
	        truncate(x.d, e);
	      }
	
	      external = true;
	
	      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
	    }
	
	    // Result is negative if x is negative and the last digit of integer y is odd.
	    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
	
	    x.s = 1;
	    external = false;
	    r = y.times(ln(x, pr + guard));
	    external = true;
	    r = exp(r);
	    r.s = sign;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var e, str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      e = getBase10Exponent(x);
	      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), sd, rm);
	      e = getBase10Exponent(x);
	      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toSignificantDigits = P.tosd = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return round(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = P.valueOf = P.val = P.toJSON = function () {
	    var x = this,
	      e = getBase10Exponent(x),
	      Ctor = x.constructor;
	
	    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	  };
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  add                 P.minus, P.plus
	   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
	   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
	   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
	   *  exp                 P.exp, P.pow
	   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
	   *                      P.toString, divide, round, toString, exp, ln
	   *  getLn10             P.log, ln
	   *  getZeroString       digitsToString, toString
	   *  ln                  P.log, P.ln, P.pow, exp
	   *  parseDecimal        Decimal
	   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
	   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
	   *                      divide, getLn10, exp, ln
	   *  subtract            P.minus, P.plus
	   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
	   *  truncate            P.pow
	   *
	   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
	   *                      getLn10, exp, ln, parseDecimal, Decimal, config
	   */
	
	
	  function add(x, y) {
	    var carry, d, e, i, k, len, xd, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // If either is zero...
	    if (!x.s || !y.s) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!y.s) y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    k = x.e;
	    e = y.e;
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = e;
	
	    return external ? round(y, pr) : y;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % BASE | 0;
	        carry = temp / BASE | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * BASE + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, dp) {
	      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either 0?
	      if (!x.s) return new Ctor(x);
	      if (!y.s) throw Error(decimalError + 'Division by zero');
	
	      e = x.e - y.e;
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
	      if (yd[i] > (xd[i] || 0)) --e;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	      } else if (dp) {
	        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) return new Ctor(0);
	
	      // Convert precision in number of base 10 digits to base 1e7 digits.
	      sd = sd / LOG_BASE + 2 | 0;
	      i = 0;
	
	      // divisor < 1e7
	      if (yL == 1) {
	        k = 0;
	        yd = yd[0];
	        sd++;
	
	        // k is the carry.
	        for (; (i < xL || k) && sd--; i++) {
	          t = k * BASE + (xd[i] || 0);
	          qd[i] = t / yd | 0;
	          k = t % yd | 0;
	        }
	
	      // divisor >= 1e7
	      } else {
	
	        // Normalise xd and yd so highest order digit of yd is >= BASE/2
	        k = BASE / (yd[0] + 1) | 0;
	
	        if (k > 1) {
	          yd = multiplyInteger(yd, k);
	          xd = multiplyInteger(xd, k);
	          yL = yd.length;
	          xL = xd.length;
	        }
	
	        xi = yL;
	        rem = xd.slice(0, yL);
	        remL = rem.length;
	
	        // Add zeros to make remainder as long as divisor.
	        for (; remL < yL;) rem[remL++] = 0;
	
	        yz = yd.slice();
	        yz.unshift(0);
	        yd0 = yd[0];
	
	        if (yd[1] >= BASE / 2) ++yd0;
	
	        do {
	          k = 0;
	
	          // Compare divisor and remainder.
	          cmp = compare(yd, rem, yL, remL);
	
	          // If divisor < remainder.
	          if (cmp < 0) {
	
	            // Calculate trial digit, k.
	            rem0 = rem[0];
	            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
	
	            // k will be how many times the divisor goes into the current remainder.
	            k = rem0 / yd0 | 0;
	
	            //  Algorithm:
	            //  1. product = divisor * trial digit (k)
	            //  2. if product > remainder: product -= divisor, k--
	            //  3. remainder -= product
	            //  4. if product was < remainder at 2:
	            //    5. compare new remainder and divisor
	            //    6. If remainder > divisor: remainder -= divisor, k++
	
	            if (k > 1) {
	              if (k >= BASE) k = BASE - 1;
	
	              // product = divisor * trial digit.
	              prod = multiplyInteger(yd, k);
	              prodL = prod.length;
	              remL = rem.length;
	
	              // Compare product and remainder.
	              cmp = compare(prod, rem, prodL, remL);
	
	              // product > remainder.
	              if (cmp == 1) {
	                k--;
	
	                // Subtract divisor from product.
	                subtract(prod, yL < prodL ? yz : yd, prodL);
	              }
	            } else {
	
	              // cmp is -1.
	              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	              if (k == 0) cmp = k = 1;
	              prod = yd.slice();
	            }
	
	            prodL = prod.length;
	            if (prodL < remL) prod.unshift(0);
	
	            // Subtract product from remainder.
	            subtract(rem, prod, remL);
	
	            // If product was < previous remainder.
	            if (cmp == -1) {
	              remL = rem.length;
	
	              // Compare divisor and new remainder.
	              cmp = compare(yd, rem, yL, remL);
	
	              // If divisor < new remainder, subtract divisor from remainder.
	              if (cmp < 1) {
	                k++;
	
	                // Subtract divisor from remainder.
	                subtract(rem, yL < remL ? yz : yd, remL);
	              }
	            }
	
	            remL = rem.length;
	          } else if (cmp === 0) {
	            k++;
	            rem = [0];
	          }    // if cmp === 1, k will be 0
	
	          // Add the next digit, k, to the result array.
	          qd[i++] = k;
	
	          // Update the remainder.
	          if (cmp && rem[0]) {
	            rem[remL++] = xd[xi] || 0;
	          } else {
	            rem = [xd[xi]];
	            remL = 1;
	          }
	
	        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	      }
	
	      // Leading zero?
	      if (!qd[0]) qd.shift();
	
	      q.e = e;
	
	      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
	    };
	  })();
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
	   * significant digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   */
	  function exp(x, sd) {
	    var denominator, guard, pow, sum, t, wpr,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
	
	    // exp(0) = 1
	    if (!x.s) return new Ctor(ONE);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    while (x.abs().gte(0.1)) {
	      x = x.times(t);    // x = x / 2^5
	      k += 5;
	    }
	
	    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(ONE);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = round(pow.times(x), wpr);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        while (k--) sum = round(sum.times(sum), wpr);
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	    }
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(x) {
	    var e = x.e * LOG_BASE,
	      w = x.d[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for (; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	
	    if (sd > Ctor.LN10.sd()) {
	
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(decimalError + 'LN10 precision limit exceeded');
	    }
	
	    return round(new Ctor(Ctor.LN10), sd);
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
	   * digits.
	   *
	   *  ln(n) is non-terminating (n != 1)
	   *
	   */
	  function ln(y, sd) {
	    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // ln(-x) = NaN
	    // ln(0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // ln(1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    if (x.eq(10)) {
	      if (sd == null) external = true;
	      return getLn10(Ctor, wpr);
	    }
	
	    wpr += guard;
	    Ctor.precision = wpr;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	    e = getBase10Exponent(x);
	
	    if (Math.abs(e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = getBase10Exponent(x);
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	
	      Ctor.precision = pr;
	      return sd == null ? (external = true, round(x, pr)) : x;
	    }
	
	    // x is reduced to a value near 1.
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
	    x2 = round(x.times(x), wpr);
	    denominator = 3;
	
	    for (;;) {
	      numerator = round(numerator.times(x2), wpr);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr);
	
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48;) ++i;
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      e = e - i - 1;
	      x.e = mathfloor(e / LOG_BASE);
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
	    } else {
	
	      // Zero.
	      x.s = 0;
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
	   */
	   function round(x, sd, rm) {
	    var i, j, k, n, rd, doRound, w, xdi,
	      xd = x.d;
	
	    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	    // w: the word of xd which contains the rounding digit, a base 1e7 number.
	    // xdi: the index of w within xd.
	    // n: the number of digits of w.
	    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	    // they had leading zeros)
	    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	    // Get the length of the first word of the digits array xd.
	    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
	    i = sd - n;
	
	    // Is the rounding digit in the first word of xd?
	    if (i < 0) {
	      i += LOG_BASE;
	      j = sd;
	      w = xd[xdi = 0];
	    } else {
	      xdi = Math.ceil((i + 1) / LOG_BASE);
	      k = xd.length;
	      if (xdi >= k) return x;
	      w = k = xd[xdi];
	
	      // Get the number of digits of w.
	      for (n = 1; k >= 10; k /= 10) n++;
	
	      // Get the index of rd within w.
	      i %= LOG_BASE;
	
	      // Get the index of rd within w, adjusted for leading zeros.
	      // The number of leading zeros of w is given by LOG_BASE - n.
	      j = i - LOG_BASE + n;
	    }
	
	    if (rm !== void 0) {
	      k = mathpow(10, n - j - 1);
	
	      // Get the rounding digit at index j of w.
	      rd = w / k % 10 | 0;
	
	      // Are there any non-zero digits after the rounding digit?
	      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
	
	      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
	      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
	      // 714.
	
	      doRound = rm < 4
	        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	    }
	
	    if (sd < 1 || !xd[0]) {
	      if (doRound) {
	        k = getBase10Exponent(x);
	        xd.length = 1;
	
	        // Convert sd to decimal places.
	        sd = sd - k - 1;
	
	        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	        x.e = mathfloor(-sd / LOG_BASE) || 0;
	      } else {
	        xd.length = 1;
	
	        // Zero.
	        xd[0] = x.e = x.s = 0;
	      }
	
	      return x;
	    }
	
	    // Remove excess digits.
	    if (i == 0) {
	      xd.length = xdi;
	      k = 1;
	      xdi--;
	    } else {
	      xd.length = xdi + 1;
	      k = mathpow(10, LOG_BASE - i);
	
	      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	      // j > 0 means i > number of leading zeros of w.
	      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
	    }
	
	    if (doRound) {
	      for (;;) {
	
	        // Is the digit to be rounded up in the first word of xd?
	        if (xdi == 0) {
	          if ((xd[0] += k) == BASE) {
	            xd[0] = 1;
	            ++x.e;
	          }
	
	          break;
	        } else {
	          xd[xdi] += k;
	          if (xd[xdi] != BASE) break;
	          xd[xdi--] = 0;
	          k = 1;
	        }
	      }
	    }
	
	    // Remove trailing zeros.
	    for (i = xd.length; xd[--i] === 0;) xd.pop();
	
	    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
	      throw Error(exponentOutOfRange + getBase10Exponent(x));
	    }
	
	    return x;
	  }
	
	
	  function subtract(x, y) {
	    var d, e, i, j, k, len, xd, xe, xLTy, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // Return y negated if x is zero.
	    // Return x if y is zero and x is non-zero.
	    if (!x.s || !y.s) {
	      if (y.s) y.s = -y.s;
	      else y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are non-zero numbers with the same sign.
	
	    e = y.e;
	    xe = x.e;
	    xd = xd.slice();
	    k = xe - e;
	
	    // If exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of zeros
	      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
	      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to xd if shorter.
	    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(0);
	
	    y.d = xd;
	    y.e = e;
	
	    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
	    return external ? round(y, pr) : y;
	  }
	
	
	  function toString(x, isExp, sd) {
	    var k,
	      e = getBase10Exponent(x),
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (e < 0 ? 'e' : 'e+') + e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  clone
	   *  config/set
	   */
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * value {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(value) {
	      var x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(value);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (value instanceof Decimal) {
	        x.s = value.s;
	        x.e = value.e;
	        x.d = (value = value.d) ? value.slice() : value;
	        return;
	      }
	
	      if (typeof value === 'number') {
	
	        // Reject Infinity/NaN.
	        if (value * 0 !== 0) {
	          throw Error(invalidArgument + value);
	        }
	
	        if (value > 0) {
	          x.s = 1;
	        } else if (value < 0) {
	          value = -value;
	          x.s = -1;
	        } else {
	          x.s = 0;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        // Fast path for small integers.
	        if (value === ~~value && value < 1e7) {
	          x.e = 0;
	          x.d = [value];
	          return;
	        }
	
	        return parseDecimal(x, value.toString());
	      } else if (typeof value !== 'string') {
	        throw Error(invalidArgument + value);
	      }
	
	      // Minus sign?
	      if (value.charCodeAt(0) === 45) {
	        value = value.slice(1);
	        x.s = -1;
	      } else {
	        x.s = 1;
	      }
	
	      if (isDecimal.test(value)) parseDecimal(x, value);
	      else throw Error(invalidArgument + value);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	
	    Decimal.clone = clone;
	    Decimal.config = Decimal.set = config;
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
	      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') {
	      throw Error(decimalError + 'Object expected');
	    }
	    var i, p, v,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -1 / 0, 0,
	        'toExpPos', 0, 1 / 0
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if ((v = obj[p = ps[i]]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if ((v = obj[p = 'LN10']) !== void 0) {
	        if (v == Math.LN10) this[p] = new this(v);
	        else throw Error(invalidArgument + p + ': ' + v);
	    }
	
	    return this;
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(Decimal);
	
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Internal constant.
	  ONE = new Decimal(1);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Decimal;
	
	    // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self
	        ? self : Function('return this')();
	    }
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var prefix = __webpack_require__(2069)
	var toCamelCase = __webpack_require__(2554)
	var cache = { 'float': 'cssFloat' }
	var addPxToStyle = __webpack_require__(1074)
	
	function style (element, property, value) {
	  var camel = cache[property]
	  if (typeof camel === 'undefined') {
	    camel = detect(property)
	  }
	
	  // may be false if CSS prop is unsupported
	  if (camel) {
	    if (value === undefined) {
	      return element.style[camel]
	    }
	
	    element.style[camel] = addPxToStyle(camel, value)
	  }
	}
	
	function each (element, properties) {
	  for (var k in properties) {
	    if (properties.hasOwnProperty(k)) {
	      style(element, k, properties[k])
	    }
	  }
	}
	
	function detect (cssProp) {
	  var camel = toCamelCase(cssProp)
	  var result = prefix(camel)
	  cache[camel] = cache[cssProp] = cache[result] = result
	  return result
	}
	
	function set () {
	  if (arguments.length === 2) {
	    if (typeof arguments[1] === 'string') {
	      arguments[0].style.cssText = arguments[1]
	    } else {
	      each(arguments[0], arguments[1])
	    }
	  } else {
	    style(arguments[0], arguments[1], arguments[2])
	  }
	}
	
	module.exports = set
	module.exports.set = set
	
	module.exports.get = function (element, properties) {
	  if (Array.isArray(properties)) {
	    return properties.reduce(function (obj, prop) {
	      obj[prop] = style(element, prop || '')
	      return obj
	    }, {})
	  } else {
	    return style(element, properties || '')
	  }
	}


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(227));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(670));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 670 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(228));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(329));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(227));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(329));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(164));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(1817));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(164));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(132);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 680 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1832);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bars-emoji-neutral.15e46e5e.svg";

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bars-emoji-strongly-agree.3022f313.svg";

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bars-emoji-strongly-disagree.be5fa73c.svg";

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dropdown-arrow.72d2c62f.svg";

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-arrow-select-solid.ddf9e770.svg";

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-dropdown-arrow-filled.b7e13730.svg";

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-teams-roles-pagination-right.ac663e4e.svg";

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon_expand.af4243f3.svg";

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-what-to-expect-line-horizontal.44deec77.svg";

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-what-to-expect-line-vertical.7055f823.svg";

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/radio-checked.3d1c8c64.svg";

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/radio-unchecked.80417b25.svg";

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    Checkbox: __webpack_require__(1867),
	    CheckboxGroup: __webpack_require__(1866),
	    Icon: __webpack_require__(458),
	    Input: __webpack_require__(1870),
	    File: __webpack_require__(1869),
	    RadioGroup: __webpack_require__(1871),
	    Row: __webpack_require__(166),
	    Select: __webpack_require__(1872),
	    Textarea: __webpack_require__(1873),
	    ComponentMixin: __webpack_require__(165),
	    ParentContextMixin: __webpack_require__(695),
	    Form: __webpack_require__(1868)
	};

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = {
	
	    childContextTypes: {
	        layout: React.PropTypes.string,
	        validateOnSubmit: React.PropTypes.bool,
	        validatePristine: React.PropTypes.bool,
	        rowClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        labelClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object]),
	        elementWrapperClassName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array, React.PropTypes.object])
	    },
	
	    getChildContext: function getChildContext() {
	        return {
	            layout: this.props.layout || 'horizontal',
	            validateOnSubmit: this.props.validateOnSubmit || false,
	            validatePristine: this.props.validatePristine || false,
	            rowClassName: this.props.rowClassName || '',
	            labelClassName: this.props.labelClassName || '',
	            elementWrapperClassName: this.props.elementWrapperClassName || ''
	        };
	    },
	
	    getLayoutClassName: function getLayoutClassName() {
	        return 'form-' + this.getChildContext().layout;
	    }
	
	};

/***/ },
/* 696 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = {
	  arraysDiffer: function arraysDiffer(a, b) {
	    var isDifferent = false;
	    if (a.length !== b.length) {
	      isDifferent = true;
	    } else {
	      a.forEach(function (item, index) {
	        if (!this.isSame(item, b[index])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },
	
	  objectsDiffer: function objectsDiffer(a, b) {
	    var isDifferent = false;
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      isDifferent = true;
	    } else {
	      Object.keys(a).forEach(function (key) {
	        if (!this.isSame(a[key], b[key])) {
	          isDifferent = true;
	        }
	      }, this);
	    }
	    return isDifferent;
	  },
	
	  isSame: function isSame(a, b) {
	    if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== (typeof b === 'undefined' ? 'undefined' : _typeof(b))) {
	      return false;
	    } else if (Array.isArray(a) && Array.isArray(b)) {
	      return !this.arraysDiffer(a, b);
	    } else if (typeof a === 'function') {
	      return a.toString() === b.toString();
	    } else if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a !== null && b !== null) {
	      return !this.objectsDiffer(a, b);
	    }
	
	    return a === b;
	  },
	
	  find: function find(collection, fn) {
	    for (var i = 0, l = collection.length; i < l; i++) {
	      var item = collection[i];
	      if (fn(item)) {
	        return item;
	      }
	    }
	    return null;
	  }
	};

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(463);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(2078);
	
	var _runTransitionHook = __webpack_require__(463);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(229);
	
	var _PathUtils = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 700 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 701 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ },
/* 702 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198),
	    root = __webpack_require__(108);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(108);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 705 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1941);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 707 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1963),
	    isArguments = __webpack_require__(482),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(483),
	    isIndex = __webpack_require__(477),
	    isTypedArray = __webpack_require__(734);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 709 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(277),
	    eq = __webpack_require__(345);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 711 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1939),
	    keys = __webpack_require__(234);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(470),
	    isArray = __webpack_require__(40);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 714 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(278),
	    isArrayLike = __webpack_require__(199);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(231),
	    baseGet = __webpack_require__(339),
	    baseIteratee = __webpack_require__(99),
	    baseMap = __webpack_require__(716),
	    baseSortBy = __webpack_require__(1961),
	    baseUnary = __webpack_require__(279),
	    compareMultiple = __webpack_require__(1975),
	    identity = __webpack_require__(232),
	    isArray = __webpack_require__(40);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(232),
	    overRest = __webpack_require__(729),
	    setToString = __webpack_require__(730);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(1929),
	    baseAggregator = __webpack_require__(1932),
	    baseIteratee = __webpack_require__(99),
	    isArray = __webpack_require__(40);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(468),
	    arraySome = __webpack_require__(709),
	    cacheHas = __webpack_require__(473);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 722 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(713),
	    getSymbols = __webpack_require__(476),
	    keys = __webpack_require__(234);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(713),
	    getSymbolsIn = __webpack_require__(725),
	    keysIn = __webpack_require__(486);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(470),
	    getPrototype = __webpack_require__(475),
	    getSymbols = __webpack_require__(476),
	    stubArray = __webpack_require__(740);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(101);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 728 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1928);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1958),
	    shortOut = __webpack_require__(2023);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 731 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(101),
	    now = __webpack_require__(2050),
	    toNumber = __webpack_require__(488);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1931),
	    baseEvery = __webpack_require__(1937),
	    baseIteratee = __webpack_require__(99),
	    isArray = __webpack_require__(40),
	    isIterateeCall = __webpack_require__(343);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1950),
	    baseUnary = __webpack_require__(279),
	    nodeUtil = __webpack_require__(480);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 735 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(338),
	    baseGt = __webpack_require__(714),
	    identity = __webpack_require__(232);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(338),
	    baseGt = __webpack_require__(714),
	    baseIteratee = __webpack_require__(99);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(338),
	    baseLt = __webpack_require__(715),
	    identity = __webpack_require__(232);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(231),
	    baseClone = __webpack_require__(1935),
	    baseUnset = __webpack_require__(1967),
	    castPath = __webpack_require__(340),
	    copyObject = __webpack_require__(280),
	    customOmitClone = __webpack_require__(1986),
	    flatRest = __webpack_require__(1989),
	    getAllKeysIn = __webpack_require__(724);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 740 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(488);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(741);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1964);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(99),
	    baseUniq = __webpack_require__(1966);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1075);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(2076);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 882 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 883 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appendPxIfNeeded;
	
	
	// Copied from https://github.com/facebook/react/blob/
	// 102cd291899f9942a76c40a0e78920a6fe544dc1/
	// src/renderers/dom/shared/CSSProperty.js
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	function appendPxIfNeeded(propertyName, value) {
	  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
	  return needsPxSuffix ? value + 'px' : value;
	}

/***/ },
/* 884 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _camelCaseRegex = /([a-z])?([A-Z])/g;
	
	var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
	  return (p1 || '') + '-' + p2.toLowerCase();
	};
	
	var camelCaseToDashCase = exports.camelCaseToDashCase = function camelCaseToDashCase(s) {
	  return s.replace(_camelCaseRegex, _camelCaseReplacer);
	};
	
	var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
	  // Since prefix is expected to work on inline style objects, we must
	  // translate the keys to dash case for rendering to CSS.
	  return Object.keys(prefixedStyle).reduce(function (result, key) {
	    var dashCaseKey = camelCaseToDashCase(key);
	
	    // Fix IE vendor prefix
	    if (/^ms-/.test(dashCaseKey)) {
	      dashCaseKey = '-' + dashCaseKey;
	    }
	
	    result[dashCaseKey] = prefixedStyle[key];
	    return result;
	  }, {});
	};
	
	exports.default = camelCasePropsToDashCase;

/***/ },
/* 885 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* flow */
	
	var cleanStateKey = function cleanStateKey(key) {
	  return key === null || typeof key === 'undefined' ? 'main' : key.toString();
	};
	
	exports.default = cleanStateKey;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = enhanceWithRadium;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleKeeper = __webpack_require__(491);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	var _resolveStyles2 = __webpack_require__(892);
	
	var _resolveStyles3 = _interopRequireDefault(_resolveStyles2);
	
	var _getRadiumStyleState = __webpack_require__(887);
	
	var _getRadiumStyleState2 = _interopRequireDefault(_getRadiumStyleState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];
	
	function copyProperties(source, target) {
	  Object.getOwnPropertyNames(source).forEach(function (key) {
	    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
	      var descriptor = Object.getOwnPropertyDescriptor(source, key);
	      Object.defineProperty(target, key, descriptor);
	    }
	  });
	}
	
	function isStateless(component) {
	  return !component.render && !(component.prototype && component.prototype.render);
	}
	
	// Check if value is a real ES class in Native / Node code.
	// See: https://stackoverflow.com/a/30760236
	function isNativeClass(component) {
	  return typeof component === 'function' && /^\s*class\s+/.test(component.toString());
	}
	
	// Manually apply babel-ish class inheritance.
	function inherits(subClass, superClass) {
	  if (typeof superClass !== 'function' && superClass !== null) {
	    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (superClass) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(subClass, superClass);
	    } else {
	      subClass.__proto__ = superClass; // eslint-disable-line no-proto
	    }
	  }
	}
	
	function enhanceWithRadium(configOrComposedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof configOrComposedComponent !== 'function') {
	    var newConfig = _extends({}, config, configOrComposedComponent);
	    return function (configOrComponent) {
	      return enhanceWithRadium(configOrComponent, newConfig);
	    };
	  }
	
	  var component = configOrComposedComponent;
	  var ComposedComponent = component;
	
	  // Handle Native ES classes.
	  if (isNativeClass(ComposedComponent)) {
	    // Manually approximate babel's class transpilation, but _with_ a real `new` call.
	    ComposedComponent = function (OrigComponent) {
	      function NewComponent() {
	        // Ordinarily, babel would produce something like:
	        //
	        // ```
	        // return _possibleConstructorReturn(this, OrigComponent.apply(this, arguments));
	        // ```
	        //
	        // Instead, we just call `new` directly without the `_possibleConstructorReturn` wrapper.
	        var source = new (Function.prototype.bind.apply(OrigComponent, [null].concat(Array.prototype.slice.call(arguments))))();
	
	        // Then we manually update context with properties.
	        copyProperties(source, this);
	
	        return this;
	      }
	
	      inherits(NewComponent, OrigComponent);
	
	      return NewComponent;
	    }(ComposedComponent);
	  }
	
	  // Handle stateless components
	  if (isStateless(ComposedComponent)) {
	    ComposedComponent = function (_Component) {
	      _inherits(ComposedComponent, _Component);
	
	      function ComposedComponent() {
	        _classCallCheck(this, ComposedComponent);
	
	        return _possibleConstructorReturn(this, (ComposedComponent.__proto__ || Object.getPrototypeOf(ComposedComponent)).apply(this, arguments));
	      }
	
	      _createClass(ComposedComponent, [{
	        key: 'render',
	        value: function render() {
	          return component(this.props, this.context);
	        }
	      }]);
	
	      return ComposedComponent;
	    }(_react.Component);
	
	    ComposedComponent.displayName = component.displayName || component.name;
	  }
	
	  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
	    _inherits(RadiumEnhancer, _ComposedComponent);
	
	    function RadiumEnhancer() {
	      _classCallCheck(this, RadiumEnhancer);
	
	      var _this2 = _possibleConstructorReturn(this, (RadiumEnhancer.__proto__ || Object.getPrototypeOf(RadiumEnhancer)).apply(this, arguments));
	
	      _this2.state = _this2.state || {};
	      _this2.state._radiumStyleState = {};
	      _this2._radiumIsMounted = true;
	      return _this2;
	    }
	
	    _createClass(RadiumEnhancer, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (_get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this)) {
	          _get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        }
	
	        this._radiumIsMounted = false;
	
	        if (this._radiumMouseUpListener) {
	          this._radiumMouseUpListener.remove();
	        }
	
	        if (this._radiumMediaQueryListenersByQuery) {
	          Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
	            this._radiumMediaQueryListenersByQuery[query].remove();
	          }, this);
	        }
	      }
	    }, {
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var superChildContext = _get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'getChildContext', this) ? _get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'getChildContext', this).call(this) : {};
	
	        if (!this.props.radiumConfig) {
	          return superChildContext;
	        }
	
	        var newContext = _extends({}, superChildContext);
	
	        if (this.props.radiumConfig) {
	          newContext._radiumConfig = this.props.radiumConfig;
	        }
	
	        return newContext;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var renderedElement = _get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'render', this).call(this);
	        var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;
	
	        if (config && currentConfig !== config) {
	          currentConfig = _extends({}, config, currentConfig);
	        }
	
	        var _resolveStyles = (0, _resolveStyles3.default)(this, renderedElement, currentConfig),
	            extraStateKeyMap = _resolveStyles.extraStateKeyMap,
	            element = _resolveStyles.element;
	
	        this._extraRadiumStateKeys = Object.keys(extraStateKeyMap);
	
	        return element;
	      }
	
	      /* eslint-disable react/no-did-update-set-state, no-unused-vars */
	
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        if (_get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentDidUpdate', this)) {
	          _get(RadiumEnhancer.prototype.__proto__ || Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentDidUpdate', this).call(this, prevProps, prevState);
	        }
	
	        if (this._extraRadiumStateKeys.length > 0) {
	          var trimmedRadiumState = this._extraRadiumStateKeys.reduce(function (state, key) {
	            var extraStateKey = state[key],
	                remainingState = _objectWithoutProperties(state, [key]);
	
	            return remainingState;
	          }, (0, _getRadiumStyleState2.default)(this));
	
	          this._lastRadiumState = trimmedRadiumState;
	          this.setState({ _radiumStyleState: trimmedRadiumState });
	        }
	      }
	      /* eslint-enable react/no-did-update-set-state, no-unused-vars */
	
	    }]);
	
	    return RadiumEnhancer;
	  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);
	
	  // Class inheritance uses Object.create and because of __proto__ issues
	  // with IE <10 any static properties of the superclass aren't inherited and
	  // so need to be manually populated.
	  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	
	  copyProperties(component, RadiumEnhancer);
	
	  if (false) {
	    // This also fixes React Hot Loader by exposing the original components top
	    // level prototype methods on the Radium enhanced prototype as discussed in
	    // https://github.com/FormidableLabs/radium/issues/219.
	    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
	  }
	
	  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
	    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
	      style: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
	    });
	  }
	
	  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';
	
	  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
	    _radiumConfig: _propTypes2.default.object,
	    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	  });
	
	  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
	    _radiumConfig: _propTypes2.default.object,
	    _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	  });
	
	  return RadiumEnhancer;
	}

/***/ },
/* 887 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getRadiumStyleState = function getRadiumStyleState(component) {
	  return component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	};
	
	exports.default = getRadiumStyleState;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cleanStateKey = __webpack_require__(885);
	
	var _cleanStateKey2 = _interopRequireDefault(_cleanStateKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getState = function getState(state, elementKey, value) {
	  var key = (0, _cleanStateKey2.default)(elementKey);
	
	  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
	};
	
	exports.default = getState;

/***/ },
/* 889 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hash;
	
	
	// a simple djb2 hash based on hash-string:
	// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
	// returns a hex-encoded hash
	function hash(text) {
	  if (!text) {
	    return '';
	  }
	
	  var hashValue = 5381;
	  var index = text.length - 1;
	
	  while (index) {
	    hashValue = hashValue * 33 ^ text.charCodeAt(index);
	    index -= 1;
	  }
	
	  return (hashValue >>> 0).toString(16);
	}

/***/ },
/* 890 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapObject;
	function mapObject(object, mapper) {
	  return Object.keys(object).reduce(function (result, key) {
	    result[key] = mapper(object[key], key);
	    return result;
	  }, {});
	}

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkPropsPlugin = __webpack_require__(2088);
	
	var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);
	
	var _keyframesPlugin = __webpack_require__(2089);
	
	var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);
	
	var _mergeStyleArrayPlugin = __webpack_require__(2090);
	
	var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);
	
	var _prefixPlugin = __webpack_require__(2092);
	
	var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);
	
	var _removeNestedStylesPlugin = __webpack_require__(2093);
	
	var _removeNestedStylesPlugin2 = _interopRequireDefault(_removeNestedStylesPlugin);
	
	var _resolveInteractionStylesPlugin = __webpack_require__(2094);
	
	var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);
	
	var _resolveMediaQueriesPlugin = __webpack_require__(2095);
	
	var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);
	
	var _visitedPlugin = __webpack_require__(2096);
	
	var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkProps: _checkPropsPlugin2.default,
	  keyframes: _keyframesPlugin2.default,
	  mergeStyleArray: _mergeStyleArrayPlugin2.default,
	  prefix: _prefixPlugin2.default,
	  removeNestedStyles: _removeNestedStylesPlugin2.default,
	  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
	  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
	  visited: _visitedPlugin2.default
	};
	/* eslint-disable block-scoped-const */

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _appendImportantToEachValue = __webpack_require__(2080);
	
	var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);
	
	var _cssRuleSetToString = __webpack_require__(489);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _getState = __webpack_require__(888);
	
	var _getState2 = _interopRequireDefault(_getState);
	
	var _getStateKey = __webpack_require__(2084);
	
	var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
	var _cleanStateKey = __webpack_require__(885);
	
	var _cleanStateKey2 = _interopRequireDefault(_cleanStateKey);
	
	var _getRadiumStyleState = __webpack_require__(887);
	
	var _getRadiumStyleState2 = _interopRequireDefault(_getRadiumStyleState);
	
	var _hash = __webpack_require__(889);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _mergeStyles = __webpack_require__(2087);
	
	var _plugins = __webpack_require__(891);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _exenv = __webpack_require__(677);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CONFIG = {
	  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.removeNestedStyles, _plugins2.default.prefix, _plugins2.default.checkProps]
	};
	
	// Gross
	var globalState = {};
	
	// Declare early for recursive helpers.
	var resolveStyles = null;
	
	var _shouldResolveStyles = function _shouldResolveStyles(component) {
	  return component.type && !component.type._isRadiumEnhanced;
	};
	
	var _resolveChildren = function _resolveChildren(_ref) {
	  var children = _ref.children,
	      component = _ref.component,
	      config = _ref.config,
	      existingKeyMap = _ref.existingKeyMap,
	      extraStateKeyMap = _ref.extraStateKeyMap;
	
	  if (!children) {
	    return children;
	  }
	
	  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (childrenType === 'string' || childrenType === 'number') {
	    // Don't do anything with a single primitive child
	    return children;
	  }
	
	  if (childrenType === 'function') {
	    // Wrap the function, resolving styles on the result
	    return function () {
	      var result = children.apply(this, arguments);
	
	      if (_react2.default.isValidElement(result)) {
	        var _key = (0, _getStateKey2.default)(result);
	        delete extraStateKeyMap[_key];
	
	        var _resolveStyles = resolveStyles(component, result, config, existingKeyMap, true, extraStateKeyMap),
	            _element = _resolveStyles.element;
	
	        return _element;
	      }
	
	      return result;
	    };
	  }
	
	  if (_react2.default.Children.count(children) === 1 && children.type) {
	    // If a React Element is an only child, don't wrap it in an array for
	    // React.Children.map() for React.Children.only() compatibility.
	    var onlyChild = _react2.default.Children.only(children);
	    var _key2 = (0, _getStateKey2.default)(onlyChild);
	    delete extraStateKeyMap[_key2];
	
	    var _resolveStyles2 = resolveStyles(component, onlyChild, config, existingKeyMap, true, extraStateKeyMap),
	        _element2 = _resolveStyles2.element;
	
	    return _element2;
	  }
	
	  return _react2.default.Children.map(children, function (child) {
	    if (_react2.default.isValidElement(child)) {
	      var _key3 = (0, _getStateKey2.default)(child);
	      delete extraStateKeyMap[_key3];
	
	      var _resolveStyles3 = resolveStyles(component, child, config, existingKeyMap, true, extraStateKeyMap),
	          _element3 = _resolveStyles3.element;
	
	      return _element3;
	    }
	
	    return child;
	  });
	};
	
	// Recurse over props, just like children
	var _resolveProps = function _resolveProps(_ref2) {
	  var component = _ref2.component,
	      config = _ref2.config,
	      existingKeyMap = _ref2.existingKeyMap,
	      props = _ref2.props,
	      extraStateKeyMap = _ref2.extraStateKeyMap;
	
	  var newProps = props;
	
	  Object.keys(props).forEach(function (prop) {
	    // We already recurse over children above
	    if (prop === 'children') {
	      return;
	    }
	
	    var propValue = props[prop];
	    if (_react2.default.isValidElement(propValue)) {
	      var _key4 = (0, _getStateKey2.default)(propValue);
	      delete extraStateKeyMap[_key4];
	      newProps = _extends({}, newProps);
	
	      var _resolveStyles4 = resolveStyles(component, propValue, config, existingKeyMap, true, extraStateKeyMap),
	          _element4 = _resolveStyles4.element;
	
	      newProps[prop] = _element4;
	    }
	  });
	
	  return newProps;
	};
	
	var _buildGetKey = function _buildGetKey(_ref3) {
	  var componentName = _ref3.componentName,
	      existingKeyMap = _ref3.existingKeyMap,
	      renderedElement = _ref3.renderedElement;
	
	  // We need a unique key to correlate state changes due to user interaction
	  // with the rendered element, so we know to apply the proper interactive
	  // styles.
	  var originalKey = (0, _getStateKey2.default)(renderedElement);
	  var key = (0, _cleanStateKey2.default)(originalKey);
	
	  var alreadyGotKey = false;
	  var getKey = function getKey() {
	    if (alreadyGotKey) {
	      return key;
	    }
	
	    alreadyGotKey = true;
	
	    if (existingKeyMap[key]) {
	      var elementName = void 0;
	      if (typeof renderedElement.type === 'string') {
	        elementName = renderedElement.type;
	      } else if (renderedElement.type.constructor) {
	        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
	      }
	
	      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
	    }
	
	    existingKeyMap[key] = true;
	
	    return key;
	  };
	
	  return getKey;
	};
	
	var _setStyleState = function _setStyleState(component, key, stateKey, value) {
	  if (!component._radiumIsMounted) {
	    return;
	  }
	
	  var existing = (0, _getRadiumStyleState2.default)(component);
	  var state = { _radiumStyleState: _extends({}, existing) };
	
	  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
	  state._radiumStyleState[key][stateKey] = value;
	
	  component._lastRadiumState = state._radiumStyleState;
	  component.setState(state);
	};
	
	var _runPlugins = function _runPlugins(_ref4) {
	  var component = _ref4.component,
	      config = _ref4.config,
	      existingKeyMap = _ref4.existingKeyMap,
	      props = _ref4.props,
	      renderedElement = _ref4.renderedElement;
	
	  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
	  // no style.
	  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
	    return props;
	  }
	
	  var newProps = props;
	
	  var plugins = config.plugins || DEFAULT_CONFIG.plugins;
	
	  var componentName = component.constructor.displayName || component.constructor.name;
	  var getKey = _buildGetKey({
	    renderedElement: renderedElement,
	    existingKeyMap: existingKeyMap,
	    componentName: componentName
	  });
	  var getComponentField = function getComponentField(key) {
	    return component[key];
	  };
	  var getGlobalState = function getGlobalState(key) {
	    return globalState[key];
	  };
	  var componentGetState = function componentGetState(stateKey, elementKey) {
	    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
	  };
	  var setState = function setState(stateKey, value, elementKey) {
	    return _setStyleState(component, elementKey || getKey(), stateKey, value);
	  };
	
	  var addCSS = function addCSS(css) {
	    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
	    if (!styleKeeper) {
	      if (__isTestModeEnabled) {
	        return {
	          remove: function remove() {}
	        };
	      }
	
	      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
	    }
	
	    return styleKeeper.addCSS(css);
	  };
	
	  var newStyle = props.style;
	
	  plugins.forEach(function (plugin) {
	    var result = plugin({
	      ExecutionEnvironment: _exenv2.default,
	      addCSS: addCSS,
	      appendImportantToEachValue: _appendImportantToEachValue2.default,
	      componentName: componentName,
	      config: config,
	      cssRuleSetToString: _cssRuleSetToString2.default,
	      getComponentField: getComponentField,
	      getGlobalState: getGlobalState,
	      getState: componentGetState,
	      hash: _hash2.default,
	      mergeStyles: _mergeStyles.mergeStyles,
	      props: newProps,
	      setState: setState,
	      isNestedStyle: _mergeStyles.isNestedStyle,
	      style: newStyle
	    }) || {};
	
	    newStyle = result.style || newStyle;
	
	    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;
	
	    var newComponentFields = result.componentFields || {};
	    Object.keys(newComponentFields).forEach(function (fieldName) {
	      component[fieldName] = newComponentFields[fieldName];
	    });
	
	    var newGlobalState = result.globalState || {};
	    Object.keys(newGlobalState).forEach(function (key) {
	      globalState[key] = newGlobalState[key];
	    });
	  });
	
	  if (newStyle !== props.style) {
	    newProps = _extends({}, newProps, { style: newStyle });
	  }
	
	  return newProps;
	};
	
	// Wrapper around React.cloneElement. To avoid processing the same element
	// twice, whenever we clone an element add a special prop to make sure we don't
	// process this element again.
	var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
	  // Only add flag if this is a normal DOM element
	  if (typeof renderedElement.type === 'string') {
	    newProps = _extends({}, newProps, { 'data-radium': true });
	  }
	
	  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
	};
	
	//
	// The nucleus of Radium. resolveStyles is called on the rendered elements
	// before they are returned in render. It iterates over the elements and
	// children, rewriting props to add event handlers required to capture user
	// interactions (e.g. mouse over). It also replaces the style prop because it
	// adds in the various interaction styles (e.g. :hover).
	//
	/* eslint-disable max-params */
	resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
	renderedElement) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
	  var existingKeyMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var shouldCheckBeforeResolve = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	  var extraStateKeyMap = arguments[5];
	
	  // The extraStateKeyMap is for determining which keys should be erased from
	  // the state (i.e. which child components are unmounted and should no longer
	  // have a style state).
	  if (!extraStateKeyMap) {
	    var state = (0, _getRadiumStyleState2.default)(component);
	    extraStateKeyMap = Object.keys(state).reduce(function (acc, key) {
	      // 'main' is the auto-generated key when there is only one element with
	      // interactive styles and if a custom key is not assigned. Because of
	      // this, it is impossible to know which child is 'main', so we won't
	      // count this key when generating our extraStateKeyMap.
	      if (key !== 'main') {
	        acc[key] = true;
	      }
	      return acc;
	    }, {});
	  }
	
	  // ReactElement
	  if (!renderedElement ||
	  // Bail if we've already processed this element. This ensures that only the
	  // owner of an element processes that element, since the owner's render
	  // function will be called first (which will always be the case, since you
	  // can't know what else to render until you render the parent component).
	  renderedElement.props && renderedElement.props['data-radium'] ||
	  // Bail if this element is a radium enhanced element, because if it is,
	  // then it will take care of resolving its own styles.
	  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
	    return { extraStateKeyMap: extraStateKeyMap, element: renderedElement };
	  }
	
	  var newChildren = _resolveChildren({
	    children: renderedElement.props.children,
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    extraStateKeyMap: extraStateKeyMap
	  });
	
	  var newProps = _resolveProps({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    extraStateKeyMap: extraStateKeyMap,
	    props: renderedElement.props
	  });
	
	  newProps = _runPlugins({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: newProps,
	    renderedElement: renderedElement
	  });
	
	  // If nothing changed, don't bother cloning the element. Might be a bit
	  // wasteful, as we add the sentinal to stop double-processing when we clone.
	  // Assume benign double-processing is better than unneeded cloning.
	  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
	    return { extraStateKeyMap: extraStateKeyMap, element: renderedElement };
	  }
	
	  var element = _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
	
	  return { extraStateKeyMap: extraStateKeyMap, element: element };
	};
	/* eslint-enable max-params */
	
	// Only for use by tests
	var __isTestModeEnabled = false;
	if (false) {
	  resolveStyles.__clearStateForTests = function () {
	    globalState = {};
	  };
	  resolveStyles.__setTestMode = function (isEnabled) {
	    __isTestModeEnabled = isEnabled;
	  };
	}
	
	exports.default = resolveStyles;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	var RavenConstructor = __webpack_require__(2101);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function() {
	  _window.Raven = _Raven;
	  return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/**
	 * DISCLAIMER:
	 *
	 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
	 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
	 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
	 *
	 * It's called `Client' to be in-line with Raven Node implementation.
	 *
	 * HOWTO:
	 *
	 * import Raven from 'raven-js';
	 *
	 * const someAppReporter = new Raven.Client();
	 * const someOtherAppReporter = new Raven.Client();
	 *
	 * someAppReporter.config('__DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someOtherAppReporter.config('__OTHER_DSN__', {
	 *   ...config goes here
	 * });
	 *
	 * someAppReporter.captureMessage(...);
	 * someAppReporter.captureException(...);
	 * someAppReporter.captureBreadcrumb(...);
	 *
	 * someOtherAppReporter.captureMessage(...);
	 * someOtherAppReporter.captureException(...);
	 * someOtherAppReporter.captureBreadcrumb(...);
	 *
	 * It should "just work".
	 */
	module.exports.Client = RavenConstructor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 894 */
/***/ function(module, exports) {

	/*
	 json-stringify-safe
	 Like JSON.stringify, but doesn't throw on circular references.
	
	 Originally forked from https://github.com/isaacs/json-stringify-safe
	 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
	 and IE8 compatibility. Tests for this are in test/vendor.
	
	 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
	*/
	
	exports = module.exports = stringify;
	exports.getSerialize = serializer;
	
	function indexOf(haystack, needle) {
	  for (var i = 0; i < haystack.length; ++i) {
	    if (haystack[i] === needle) return i;
	  }
	  return -1;
	}
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
	}
	
	// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
	function stringifyError(value) {
	  var err = {
	    // These properties are implemented as magical getters and don't show up in for in
	    stack: value.stack,
	    message: value.message,
	    name: value.name
	  };
	
	  for (var i in value) {
	    if (Object.prototype.hasOwnProperty.call(value, i)) {
	      err[i] = value[i];
	    }
	  }
	
	  return err;
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [];
	  var keys = [];
	
	  if (cycleReplacer == null) {
	    cycleReplacer = function(key, value) {
	      if (stack[0] === value) {
	        return '[Circular ~]';
	      }
	      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
	    };
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = indexOf(stack, this);
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
	
	      if (~indexOf(stack, value)) {
	        value = cycleReplacer.call(this, key, value);
	      }
	    } else {
	      stack.push(value);
	    }
	
	    return replacer == null
	      ? value instanceof Error ? stringifyError(value) : value
	      : replacer.call(this, key, value);
	  };
	}


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(924);
	
	__webpack_require__(928);
	
	__webpack_require__(2232);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Cache = exports.CACHE_KEY_FAILING = exports.CACHE_PREFIX = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var CACHE_PREFIX = 'react-avatar/';
	exports.CACHE_PREFIX = CACHE_PREFIX;
	var CACHE_KEY_FAILING = 'failing';
	exports.CACHE_KEY_FAILING = CACHE_KEY_FAILING;
	
	var _hasLocalStorage = function isLocalStorageAvailable() {
	  try {
	    return 'localStorage' in window && window['localStorage'];
	  } catch (err) {
	    return false;
	  }
	}();
	
	var Cache = /*#__PURE__*/function () {
	  function Cache() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Cache);
	
	    var _options$cachePrefix = options.cachePrefix,
	        cachePrefix = _options$cachePrefix === void 0 ? CACHE_PREFIX : _options$cachePrefix,
	        _options$sourceTTL = options.sourceTTL,
	        sourceTTL = _options$sourceTTL === void 0 ? 7 * 24 * 3600 * 1000 : _options$sourceTTL,
	        _options$sourceSize = options.sourceSize,
	        sourceSize = _options$sourceSize === void 0 ? 20 : _options$sourceSize;
	    this.cachePrefix = cachePrefix;
	    this.sourceTTL = sourceTTL;
	    this.sourceSize = sourceSize;
	  }
	
	  _createClass(Cache, [{
	    key: "set",
	    value: function set(key, value) {
	      // cache not available
	      if (!_hasLocalStorage) return;
	      value = JSON.stringify(value);
	
	      try {
	        localStorage.setItem(this.cachePrefix + key, value);
	      } catch (e) {
	        // failsafe for mobile Safari private mode
	        console.error(e); // eslint-disable-line no-console
	      }
	    }
	  }, {
	    key: "get",
	    value: function get(key) {
	      // cache not available
	      if (!_hasLocalStorage) return null;
	      var value = localStorage.getItem(this.cachePrefix + key);
	      if (value) return JSON.parse(value);
	      return null;
	    }
	  }, {
	    key: "sourceFailed",
	    value: function sourceFailed(source) {
	      var cacheList = this.get(CACHE_KEY_FAILING) || []; // Remove expired entries or previous instances of this source
	
	      cacheList = cacheList.filter(function (entry) {
	        var hasExpired = entry.expires > 0 && entry.expires < Date.now();
	        var isMatch = entry === source || entry.url == source;
	        return !hasExpired && !isMatch;
	      }); // Add the source to the end of the list
	
	      cacheList.unshift({
	        url: source,
	        expires: Date.now() + this.sourceTTL
	      }); // only keep the last X results so we don't fill up local storage
	
	      cacheList = cacheList.slice(0, this.sourceSize - 1);
	      return this.set(CACHE_KEY_FAILING, cacheList);
	    }
	  }, {
	    key: "hasSourceFailedBefore",
	    value: function hasSourceFailedBefore(source) {
	      var cacheList = this.get(CACHE_KEY_FAILING) || [];
	      return cacheList.some(function (entry) {
	        var hasExpired = entry.expires > 0 && entry.expires < Date.now();
	        var isMatch = entry === source || entry.url == source;
	        return isMatch && !hasExpired;
	      });
	    }
	  }]);
	
	  return Cache;
	}();
	
	exports.Cache = Cache;
	
	var _default = new Cache();
	
	exports.default = _default;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createAvatarComponent: true,
	  GravatarSource: true,
	  FacebookSource: true,
	  GithubSource: true,
	  SkypeSource: true,
	  ValueSource: true,
	  SrcSource: true,
	  IconSource: true,
	  TwitterSource: true,
	  VKontakteSource: true,
	  InstagramSource: true,
	  GoogleSource: true,
	  RedirectSource: true
	};
	Object.defineProperty(exports, "createAvatarComponent", {
	  enumerable: true,
	  get: function get() {
	    return _avatar.default;
	  }
	});
	Object.defineProperty(exports, "GravatarSource", {
	  enumerable: true,
	  get: function get() {
	    return _Gravatar.default;
	  }
	});
	Object.defineProperty(exports, "FacebookSource", {
	  enumerable: true,
	  get: function get() {
	    return _Facebook.default;
	  }
	});
	Object.defineProperty(exports, "GithubSource", {
	  enumerable: true,
	  get: function get() {
	    return _Github.default;
	  }
	});
	Object.defineProperty(exports, "SkypeSource", {
	  enumerable: true,
	  get: function get() {
	    return _Skype.default;
	  }
	});
	Object.defineProperty(exports, "ValueSource", {
	  enumerable: true,
	  get: function get() {
	    return _Value.default;
	  }
	});
	Object.defineProperty(exports, "SrcSource", {
	  enumerable: true,
	  get: function get() {
	    return _Src.default;
	  }
	});
	Object.defineProperty(exports, "IconSource", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "TwitterSource", {
	  enumerable: true,
	  get: function get() {
	    return _Twitter.default;
	  }
	});
	Object.defineProperty(exports, "VKontakteSource", {
	  enumerable: true,
	  get: function get() {
	    return _VKontakte.default;
	  }
	});
	Object.defineProperty(exports, "InstagramSource", {
	  enumerable: true,
	  get: function get() {
	    return _Instagram.default;
	  }
	});
	Object.defineProperty(exports, "GoogleSource", {
	  enumerable: true,
	  get: function get() {
	    return _Google.default;
	  }
	});
	Object.defineProperty(exports, "RedirectSource", {
	  enumerable: true,
	  get: function get() {
	    return _AvatarRedirect.default;
	  }
	});
	exports.default = void 0;
	
	var _avatar = _interopRequireWildcard(__webpack_require__(2182));
	
	Object.keys(_avatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _avatar[key]) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _avatar[key];
	    }
	  });
	});
	
	var _Gravatar = _interopRequireDefault(__webpack_require__(2188));
	
	var _Facebook = _interopRequireDefault(__webpack_require__(2185));
	
	var _Github = _interopRequireDefault(__webpack_require__(2186));
	
	var _Skype = _interopRequireDefault(__webpack_require__(2191));
	
	var _Value = _interopRequireDefault(__webpack_require__(2195));
	
	var _Src = _interopRequireDefault(__webpack_require__(2192));
	
	var _Icon = _interopRequireDefault(__webpack_require__(2189));
	
	var _Twitter = _interopRequireDefault(__webpack_require__(2193));
	
	var _VKontakte = _interopRequireDefault(__webpack_require__(2194));
	
	var _Instagram = _interopRequireDefault(__webpack_require__(2190));
	
	var _Google = _interopRequireDefault(__webpack_require__(2187));
	
	var _AvatarRedirect = _interopRequireDefault(__webpack_require__(282));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	// Avatar Redirect
	var SOURCES = [_Facebook.default, _Google.default, _Github.default, _Twitter.default, _Instagram.default, _VKontakte.default, _Skype.default, _Gravatar.default, _Src.default, _Value.default, _Icon.default];
	
	var _default = (0, _avatar.default)({
	  sources: SOURCES
	});
	
	exports.default = _default;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(2226).charAt;
	
	// `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $forEach = __webpack_require__(353).forEach;
	var arrayMethodIsStrict = __webpack_require__(283);
	
	var STRICT_METHOD = arrayMethodIsStrict('forEach');
	
	// `Array.prototype.forEach` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
	  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	} : [].forEach;


/***/ },
/* 899 */
[2744, 239, 508, 237],
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var arraySpeciesConstructor = __webpack_require__(2200);
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};


/***/ },
/* 901 */
[2746, 2228, 90, 201, 124],
/* 902 */
[2749, 90, 238, 2213, 497],
/* 903 */
/***/ function(module, exports) {

	var documentAll = typeof document == 'object' && document.all;
	
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;
	
	module.exports = {
	  all: documentAll,
	  IS_HTMLDDA: IS_HTMLDDA
	};


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4` since it's moved to entry points
	__webpack_require__(362);
	var uncurryThis = __webpack_require__(500);
	var defineBuiltIn = __webpack_require__(902);
	var regexpExec = __webpack_require__(359);
	var fails = __webpack_require__(65);
	var wellKnownSymbol = __webpack_require__(124);
	var createNonEnumerableProperty = __webpack_require__(355);
	
	var SPECIES = wellKnownSymbol('species');
	var RegExpPrototype = RegExp.prototype;
	
	module.exports = function (KEY, exec, FORCED, SHAM) {
	  var SYMBOL = wellKnownSymbol(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	
	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {};
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }
	
	    re.exec = function () { execCalled = true; return null; };
	
	    re[SYMBOL]('');
	    return !execCalled;
	  });
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    FORCED
	  ) {
	    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var uncurriedNativeMethod = uncurryThis(nativeMethod);
	      var $exec = regexp.exec;
	      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
	        }
	        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
	      }
	      return { done: false };
	    });
	
	    defineBuiltIn(String.prototype, KEY, methods[0]);
	    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
	  }
	
	  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var NATIVE_BIND = __webpack_require__(357);
	
	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;
	
	// eslint-disable-next-line es/no-reflect -- safe
	module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});


/***/ },
/* 906 */
[2757, 134, 202],
/* 907 */
[2762, 134, 65, 498],
/* 908 */
[2764, 58, 90, 506],
/* 909 */
[2765, 2229, 102, 145, 355, 202, 506, 917, 502],
/* 910 */
[2769, 358, 90, 2219, 921],
/* 911 */
[2773, 134, 170, 914, 495, 239, 510, 202, 907],
/* 912 */
/***/ function(module, exports) {

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 913 */
[2776, 58, 202, 239, 899, 502],
/* 914 */
/***/ function(module, exports) {

	'use strict';
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
	
	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var call = __webpack_require__(170);
	var anObject = __webpack_require__(144);
	var isCallable = __webpack_require__(90);
	var classof = __webpack_require__(201);
	var regexpExec = __webpack_require__(359);
	
	var $TypeError = TypeError;
	
	// `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (isCallable(exec)) {
	    var result = call(exec, R, S);
	    if (result !== null) anObject(result);
	    return result;
	  }
	  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
	  throw $TypeError('RegExp#exec called on incompatible receiver');
	};


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(65);
	var global = __webpack_require__(102);
	
	// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	var $RegExp = global.RegExp;
	
	var UNSUPPORTED_Y = fails(function () {
	  var re = $RegExp('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') != null;
	});
	
	// UC Browser bug
	// https://github.com/zloirock/core-js/issues/1008
	var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
	  return !$RegExp('a', 'y').sticky;
	});
	
	var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = $RegExp('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') != null;
	});
	
	module.exports = {
	  BROKEN_CARET: BROKEN_CARET,
	  MISSED_STICKY: MISSED_STICKY,
	  UNSUPPORTED_Y: UNSUPPORTED_Y
	};


/***/ },
/* 917 */
[2780, 507, 920],
/* 918 */
[2783, 356, 65],
/* 919 */
/***/ function(module, exports) {

	var $String = String;
	
	module.exports = function (argument) {
	  try {
	    return $String(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};


/***/ },
/* 920 */
[2793, 58],
/* 921 */
[2794, 918],
/* 922 */
[2795, 134, 65],
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var fails = __webpack_require__(65);
	var isArray = __webpack_require__(503);
	var isObject = __webpack_require__(145);
	var toObject = __webpack_require__(203);
	var lengthOfArrayLike = __webpack_require__(237);
	var doesNotExceedSafeInteger = __webpack_require__(2202);
	var createProperty = __webpack_require__(496);
	var arraySpeciesCreate = __webpack_require__(900);
	var arrayMethodHasSpeciesSupport = __webpack_require__(354);
	var wellKnownSymbol = __webpack_require__(124);
	var V8_VERSION = __webpack_require__(356);
	
	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
	
	// We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679
	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	
	var isConcatSpreadable = function (O) {
	  if (!isObject(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray(O);
	};
	
	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
	
	// `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;
	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];
	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike(E);
	        doesNotExceedSafeInteger(n + len);
	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        doesNotExceedSafeInteger(n + 1);
	        createProperty(A, n++, E);
	      }
	    }
	    A.length = n;
	    return A;
	  }
	});


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var $filter = __webpack_require__(353).filter;
	var arrayMethodHasSpeciesSupport = __webpack_require__(354);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
	
	// `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var forEach = __webpack_require__(898);
	
	// `Array.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
	  forEach: forEach
	});


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var uncurryThis = __webpack_require__(58);
	var IndexedObject = __webpack_require__(284);
	var toIndexedObject = __webpack_require__(239);
	var arrayMethodIsStrict = __webpack_require__(283);
	
	var nativeJoin = uncurryThis([].join);
	
	var ES3_STRINGS = IndexedObject != Object;
	var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');
	
	// `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  join: function join(separator) {
	    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var $reduce = __webpack_require__(2197).left;
	var arrayMethodIsStrict = __webpack_require__(283);
	var CHROME_VERSION = __webpack_require__(356);
	var IS_NODE = __webpack_require__(2205);
	
	// Chrome 80-82 has a critical bug
	// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
	var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
	var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');
	
	// `Array.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-array.prototype.reduce
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var length = arguments.length;
	    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var isArray = __webpack_require__(503);
	var isConstructor = __webpack_require__(504);
	var isObject = __webpack_require__(145);
	var toAbsoluteIndex = __webpack_require__(508);
	var lengthOfArrayLike = __webpack_require__(237);
	var toIndexedObject = __webpack_require__(239);
	var createProperty = __webpack_require__(496);
	var wellKnownSymbol = __webpack_require__(124);
	var arrayMethodHasSpeciesSupport = __webpack_require__(354);
	var nativeSlice = __webpack_require__(2199);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	var max = Math.max;
	
	// `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject(this);
	    var length = lengthOfArrayLike(O);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
	    var Constructor, result, n;
	    if (isArray(O)) {
	      Constructor = O.constructor;
	      // cross-realm fallback
	      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject(Constructor)) {
	        Constructor = Constructor[SPECIES];
	        if (Constructor === null) Constructor = undefined;
	      }
	      if (Constructor === $Array || Constructor === undefined) {
	        return nativeSlice(O, k, fin);
	      }
	    }
	    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
	    result.length = n;
	    return result;
	  }
	});


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(134);
	var FUNCTION_NAME_EXISTS = __webpack_require__(906).EXISTS;
	var uncurryThis = __webpack_require__(58);
	var defineProperty = __webpack_require__(238).f;
	
	var FunctionPrototype = Function.prototype;
	var functionToString = uncurryThis(FunctionPrototype.toString);
	var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
	var regExpExec = uncurryThis(nameRE.exec);
	var NAME = 'name';
	
	// Function instances `.name` property
	// https://tc39.es/ecma262/#sec-function-instances-name
	if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
	  defineProperty(FunctionPrototype, NAME, {
	    configurable: true,
	    get: function () {
	      try {
	        return regExpExec(nameRE, functionToString(this))[1];
	      } catch (error) {
	        return '';
	      }
	    }
	  });
	}


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var apply = __webpack_require__(905);
	var call = __webpack_require__(170);
	var uncurryThis = __webpack_require__(58);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(904);
	var fails = __webpack_require__(65);
	var anObject = __webpack_require__(144);
	var isCallable = __webpack_require__(90);
	var isNullOrUndefined = __webpack_require__(285);
	var toIntegerOrInfinity = __webpack_require__(360);
	var toLength = __webpack_require__(509);
	var toString = __webpack_require__(361);
	var requireObjectCoercible = __webpack_require__(286);
	var advanceStringIndex = __webpack_require__(897);
	var getMethod = __webpack_require__(501);
	var getSubstitution = __webpack_require__(2208);
	var regExpExec = __webpack_require__(915);
	var wellKnownSymbol = __webpack_require__(124);
	
	var REPLACE = wellKnownSymbol('replace');
	var max = Math.max;
	var min = Math.min;
	var concat = uncurryThis([].concat);
	var push = uncurryThis([].push);
	var stringIndexOf = uncurryThis(''.indexOf);
	var stringSlice = uncurryThis(''.slice);
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
	var REPLACE_KEEPS_$0 = (function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	})();
	
	// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }
	  return false;
	})();
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	// @@replace logic
	fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
	
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.es/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = requireObjectCoercible(this);
	      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
	      return replacer
	        ? call(replacer, searchValue, O, replaceValue)
	        : call(nativeReplace, toString(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	    function (string, replaceValue) {
	      var rx = anObject(this);
	      var S = toString(string);
	
	      if (
	        typeof replaceValue == 'string' &&
	        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
	        stringIndexOf(replaceValue, '$<') === -1
	      ) {
	        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
	        if (res.done) return res.value;
	      }
	
	      var functionalReplace = isCallable(replaceValue);
	      if (!functionalReplace) replaceValue = toString(replaceValue);
	
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	
	        push(results, result);
	        if (!global) break;
	
	        var matchStr = toString(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	
	        var matched = toString(result[0]);
	        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = concat([matched], captures, position, S);
	          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
	          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + stringSlice(S, nextSourcePosition);
	    }
	  ];
	}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(102);
	var DOMIterables = __webpack_require__(2203);
	var DOMTokenListPrototype = __webpack_require__(2204);
	var forEach = __webpack_require__(898);
	var createNonEnumerableProperty = __webpack_require__(355);
	
	var handlePrototype = function (CollectionPrototype) {
	  // some Chrome versions have non-configurable methods on DOMTokenList
	  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
	    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
	  } catch (error) {
	    CollectionPrototype.forEach = forEach;
	  }
	};
	
	for (var COLLECTION_NAME in DOMIterables) {
	  if (DOMIterables[COLLECTION_NAME]) {
	    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
	  }
	}
	
	handlePrototype(DOMTokenListPrototype);


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2.default.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2.default.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2.default.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3.default)(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2.default.createElement(
	      'li',
	      { className: (0, _classnames2.default)(className, { active: active }) },
	      active ? _react2.default.createElement('span', props) : _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2.default.Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports.default = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(2296);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  animateIn: _propTypes2.default.bool,
	  animateOut: _propTypes2.default.bool,
	  index: _propTypes2.default.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3.default)(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2.default.addEndEventListener(_reactDom2.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports.default = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  useAnchor: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3.default)(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2.default : _Button2.default;
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        role: 'button',
	        className: (0, _classnames2.default)(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2.default.createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2.default.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3.default)(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3.default)(this, Grid);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2.default.Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(218);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.any,
	  disabled: _propTypes2.default.any,
	  header: _propTypes2.default.node,
	  listItem: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  href: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3.default)(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3.default)(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2.default.isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2.default)(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2.default.createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2.default.createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2.default.Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1808);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(227);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(164);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(676);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(2378);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(988);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(364);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(938);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(2269);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(939);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(940);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(941);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(366);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2.default.propTypes.container
	});
	
	var defaultProps = (0, _extends3.default)({}, _Modal2.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2.default
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	    _this.setModalRef = _this.setModalRef.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        backdropClassName = _props.backdropClassName,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Modal2.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      (0, _extends3.default)({}, baseModalProps, {
	        ref: this.setModalRef,
	        show: show,
	        onEntering: (0, _createChainedFunction2.default)(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2.default)(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2.default : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2.default.createElement(
	        Dialog,
	        (0, _extends3.default)({}, dialogProps, {
	          style: (0, _extends3.default)({}, this.state.style, style),
	          className: (0, _classnames2.default)(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2.default;
	Modal.Header = _ModalHeader2.default;
	Modal.Title = _ModalTitle2.default;
	Modal.Footer = _ModalFooter2.default;
	
	Modal.Dialog = _ModalDialog2.default;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3.default)(this, ModalBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3.default)(this, ModalFooter);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(512);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2.default.func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3.default)(this, ModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      closeButton && _react2.default.createElement(_CloseButton2.default, {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2.default)(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3.default)(this, ModalTitle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(465);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(349);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2.default.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2.default.bool,
	
	  justified: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    onSelect: _propTypes2.default.func
	  }),
	
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3.default)(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3.default)(this, Nav);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2.default.toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2.default.findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2.default)(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.left:
	      case _keycode2.default.codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2.default.codes.right:
	      case _keycode2.default.codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends4.default)({}, elementProps, {
	        role: role,
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4.default)({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3.default)(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3.default)(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2.default.Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports.default = NavItem;
	module.exports = exports['default'];

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3.default)(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3.default)(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2.default.isValidElement(children)) {
	      return _react2.default.cloneElement(children, {
	        className: (0, _classnames2.default)(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2.default.Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports.default = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(2380);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(364);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2.default,
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3.default)(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2.default : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2.default)(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  previous: _propTypes2.default.bool,
	  next: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3.default)(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports.default = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  className: _propTypes2.default.string,
	  eventKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2.default,
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3.default)(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3.default)(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2.default) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2.default.Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports.default = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(614);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  accordion: _propTypes2.default.bool,
	  activeKey: _propTypes2.default.any,
	  defaultActiveKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3.default)(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3.default)(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2.default)(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2.default)(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2.default.Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(364);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /** @private * */
	  id: _propTypes2.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    getTabId: _propTypes2.default.func,
	    getPaneId: _propTypes2.default.func
	  }),
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3.default)(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this.in = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3.default)(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2.default.createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2.default)(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2.default)(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * The `<input>` `type`
	   * @type {[type]}
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']),
	
	  /**
	   * The HTML input name, used to group like checkboxes or radio buttons together
	   * semantically
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * The disabled state of both the label and input
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * [onChange description]
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * The value of the input, and unique identifier in the ToggleButtonGroup
	   */
	  value: _propTypes2.default.any.isRequired
	};
	
	var ToggleButton = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    (0, _classCallCheck3.default)(this, ToggleButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButton.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        name = _props.name,
	        checked = _props.checked,
	        type = _props.type,
	        onChange = _props.onChange,
	        value = _props.value,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);
	
	    var disabled = props.disabled;
	
	    return _react2.default.createElement(
	      _Button2.default,
	      (0, _extends3.default)({}, props, {
	        active: !!checked,
	        componentClass: 'label'
	      }),
	      _react2.default.createElement('input', {
	        name: name,
	        type: type,
	        autoComplete: 'off',
	        value: value,
	        checked: !!checked,
	        disabled: !!disabled,
	        onChange: onChange
	      }),
	      children
	    );
	  };
	
	  return ToggleButton;
	}(_react2.default.Component);
	
	ToggleButton.propTypes = propTypes;
	
	exports.default = ToggleButton;
	module.exports = exports['default'];

/***/ },
/* 951 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2300);


/***/ },
/* 953 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isSafari = exports.isSafari = function isSafari() {
	  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	  );
	};
	
	var isJsons = exports.isJsons = function isJsons(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
	  });
	};
	
	var isArrays = exports.isArrays = function isArrays(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return Array.isArray(row);
	  });
	};
	
	var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
	  return Array.from(array.map(function (json) {
	    return Object.keys(json);
	  }).reduce(function (a, b) {
	    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
	  }, []));
	};
	
	var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
	  headers = headers || jsonsHeaders(jsons);
	
	  var headerLabels = headers;
	  var headerKeys = headers;
	  if (isJsons(headers)) {
	    headerLabels = headers.map(function (header) {
	      return header.label;
	    });
	    headerKeys = headers.map(function (header) {
	      return header.key;
	    });
	  }
	
	  var data = jsons.map(function (object) {
	    return headerKeys.map(function (header) {
	      return getHeaderValue(header, object);
	    });
	  });
	  return [headerLabels].concat(_toConsumableArray(data));
	};
	
	var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
	  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
	    var value = o[p];
	    if (value === undefined || value === null) {
	      arr.splice(1);
	    } else {
	      return value;
	    }
	  }, obj);
	
	  return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
	};
	
	var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
	  return typeof element === 'undefined' || element === null ? '' : element;
	};
	
	var joiner = exports.joiner = function joiner(data) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
	  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
	
	  return data.filter(function (e) {
	    return e;
	  }).map(function (row) {
	    return row.map(function (element) {
	      return elementOrEmpty(element);
	    }).map(function (column) {
	      return "" + enclosingCharacter + column + enclosingCharacter;
	    }).join(separator);
	  }).join("\n");
	};
	
	var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
	  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
	};
	
	var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
	  return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
	};
	
	var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
	  return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
	};
	
	var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
	  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
	  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
	  if (typeof data === 'string') return string2csv(data, headers, separator);
	  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
	};
	
	var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
	  var csv = toCSV(data, headers, separator, enclosingCharacter);
	  var type = isSafari() ? 'application/csv' : 'text/csv';
	  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
	  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
	
	  var URL = window.URL || window.webkitURL;
	
	  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
	};

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = exports.propTypes = {
	  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array, _propTypes.func]).isRequired,
	  headers: _propTypes.array,
	  target: _propTypes.string,
	  separator: _propTypes.string,
	  filename: _propTypes.string,
	  uFEFF: _propTypes.bool,
	  onClick: _propTypes.func,
	  asyncOnClick: _propTypes.bool,
	  enclosingCharacter: _propTypes.string
	};
	
	var defaultProps = exports.defaultProps = {
	  separator: ',',
	  filename: 'generatedBy_react-csv.csv',
	  uFEFF: true,
	  asyncOnClick: false,
	  enclosingCharacter: '"'
	};
	
	var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scrollbars = undefined;
	
	var _Scrollbars = __webpack_require__(2302);
	
	var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Scrollbars2["default"];
	exports.Scrollbars = _Scrollbars2["default"];

/***/ },
/* 956 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 957 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(204);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(241);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(111);
	
	var quoteAttributeValueForBrowser = __webpack_require__(2372);
	var warning = __webpack_require__(39);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 960 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(533);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var LinkedValueUtils = __webpack_require__(522);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(125);
	
	var warning = __webpack_require__(39);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var ReactUpdates = __webpack_require__(125);
	var Transaction = __webpack_require__(371);
	
	var emptyFunction = __webpack_require__(132);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(2314);
	var BeforeInputEventPlugin = __webpack_require__(2316);
	var ChangeEventPlugin = __webpack_require__(2318);
	var DefaultEventPluginOrder = __webpack_require__(2320);
	var EnterLeaveEventPlugin = __webpack_require__(2321);
	var HTMLDOMPropertyConfig = __webpack_require__(2323);
	var ReactComponentBrowserEnvironment = __webpack_require__(2325);
	var ReactDOMComponent = __webpack_require__(2328);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactDOMEmptyComponent = __webpack_require__(2329);
	var ReactDOMTreeTraversal = __webpack_require__(2338);
	var ReactDOMTextComponent = __webpack_require__(2336);
	var ReactDefaultBatchingStrategy = __webpack_require__(963);
	var ReactEventListener = __webpack_require__(2341);
	var ReactInjection = __webpack_require__(2342);
	var ReactReconcileTransaction = __webpack_require__(2346);
	var SVGDOMPropertyConfig = __webpack_require__(2351);
	var SelectEventPlugin = __webpack_require__(2352);
	var SimpleEventPlugin = __webpack_require__(2353);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 965 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 966 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(2334);
	
	var containsNode = __webpack_require__(1827);
	var focusNode = __webpack_require__(679);
	var getActiveElement = __webpack_require__(680);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(2364);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var DOMLazyTree = __webpack_require__(240);
	var DOMProperty = __webpack_require__(241);
	var React = __webpack_require__(206);
	var ReactBrowserEventEmitter = __webpack_require__(369);
	var ReactCurrentOwner = __webpack_require__(148);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactDOMContainerInfo = __webpack_require__(961);
	var ReactDOMFeatureFlags = __webpack_require__(2330);
	var ReactFeatureFlags = __webpack_require__(966);
	var ReactInstanceMap = __webpack_require__(289);
	var ReactInstrumentation = __webpack_require__(111);
	var ReactMarkupChecksum = __webpack_require__(969);
	var ReactReconciler = __webpack_require__(205);
	var ReactUpdateQueue = __webpack_require__(525);
	var ReactUpdates = __webpack_require__(125);
	
	var emptyObject = __webpack_require__(331);
	var instantiateReactComponent = __webpack_require__(530);
	var invariant = __webpack_require__(29);
	var setInnerHTML = __webpack_require__(373);
	var shouldUpdateReactComponent = __webpack_require__(532);
	var warning = __webpack_require__(39);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var React = __webpack_require__(206);
	
	var invariant = __webpack_require__(29);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var PooledClass = __webpack_require__(204);
	var Transaction = __webpack_require__(371);
	var ReactInstrumentation = __webpack_require__(111);
	var ReactServerUpdateQueue = __webpack_require__(2350);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 973 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 974 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 976 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(971);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(59);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 980 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	var escapeTextContentForBrowser = __webpack_require__(372);
	var setInnerHTML = __webpack_require__(373);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var ReactCurrentOwner = __webpack_require__(148);
	var REACT_ELEMENT_TYPE = __webpack_require__(2339);
	
	var getIteratorFn = __webpack_require__(2369);
	var invariant = __webpack_require__(29);
	var KeyEscapeUtils = __webpack_require__(521);
	var warning = __webpack_require__(39);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1), __webpack_require__(2)) :
		typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
		(factory((global.ReactDragtastic = {}),global.React,global.PropTypes));
	}(this, (function (exports,React,PropTypes) { 'use strict';
	
	PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var initialState = {
	  x: 0,
	  y: 0,
	  isDragging: false,
	  startingX: 0,
	  startingY: 0,
	  currentlyDraggingId: null,
	  currentlyHoveredDroppableId: null,
	  currentlyHoveredDroppableAccepts: null,
	  data: null,
	  type: null
	};
	
	var Store = function () {
	  function Store() {
	    classCallCheck(this, Store);
	    this._state = initialState;
	    this._callbacks = [];
	  }
	
	  Store.prototype.update = function update(payload) {
	    this._state = _extends({}, this._state, payload);
	    this._callbacks.forEach(function (callback) {
	      return callback();
	    });
	  };
	
	  Store.prototype.reset = function reset() {
	    this.update(initialState);
	  };
	
	  Store.prototype.subscribe = function subscribe(callback) {
	    var _this = this;
	
	    this._callbacks = [].concat(this._callbacks, [callback]);
	    return function () {
	      _this._callbacks = _this._callbacks.filter(function (f) {
	        return f !== callback;
	      });
	    };
	  };
	
	  Store.prototype.getState = function getState() {
	    return this._state;
	  };
	
	  return Store;
	}();
	
	var dndStore = new Store();
	
	var getId = function getId() {
	  var text = '';
	  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
	  for (var i = 0; i < 5; i++) {
	    text += possible.charAt(Math.floor(Math.random() * possible.length));
	  }
	
	  return text;
	};
	
	var noop = function noop() {};
	
	var DragComponent = function (_React$Component) {
	  inherits(DragComponent, _React$Component);
	
	  function DragComponent() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, DragComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = dndStore.getState(), _this.shouldComponentUpdate = function (nextProps, nextState) {
	      if (nextProps !== _this.props) {
	        return true;
	      } else {
	        if (nextProps.subscribeTo) {
	          var shouldUpdate = false;
	          var i = 0;
	          while (i < nextProps.subscribeTo.length - 1) {
	            if (_this.state[nextProps.subscribeTo[i]] !== nextState[nextProps.subscribeTo[i]]) {
	              shouldUpdate = true;
	              i = nextProps.length;
	            } else {
	              i++;
	            }
	          }
	          return shouldUpdate;
	        } else {
	          if (nextState !== _this.state) {
	            return true;
	          } else {
	            return false;
	          }
	        }
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  DragComponent.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.unsubscribe = dndStore.subscribe(function () {
	      _this2.setState(dndStore.getState());
	    });
	  };
	
	  DragComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  DragComponent.prototype.render = function render() {
	    var state = this.state;
	    var accepts = state.currentlyHoveredDroppableAccepts;
	    var isOverDroppable = typeof state.currentlyHoveredDroppableId === "string";
	
	    return (this.props.alwaysRender || state.isDragging && state.currentlyDraggingId === this.props.for) && this.props.children(_extends({}, state, {
	      isOverAccepted: isOverDroppable ? accepts !== null ? Array.isArray(accepts) ? accepts.includes(state.type) : state.type === accepts : true : false
	    }));
	  };
	
	  return DragComponent;
	}(React.Component);
	
	DragComponent.defaultProps = {
	  for: "",
	  alwaysRender: false,
	  subscribeTo: null
	};
	
	
	DragComponent.propTypes = {
	  children: PropTypes.func.isRequired,
	  for: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	  alwaysRender: PropTypes.bool,
	  subscribeTo: PropTypes.array
	};
	
	var Draggable = function (_React$Component) {
	  inherits(Draggable, _React$Component);
	
	  function Draggable() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Draggable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      startCoordinate: null,
	      storeState: _extends({}, dndStore.getState(), { isActive: false })
	    }, _this.startDragDelay = function (e) {
	      var x = void 0;
	      var y = void 0;
	      if ("ontouchstart" in window && e.touches) {
	        x = e.touches[0].clientX;
	        y = e.touches[0].clientY;
	      } else {
	        e.preventDefault();
	        x = e.clientX;
	        y = e.clientY;
	      }
	      dndStore.update({
	        startingX: x,
	        startingY: y
	      });
	      _this.setState({ startCoordinate: { x: x, y: y } });
	      document.addEventListener("mouseup", _this.endDragDelay);
	      document.addEventListener("mousemove", _this.checkDragDelay);
	      document.addEventListener("touchend", _this.endDragDelay);
	      document.addEventListener("touchmove", _this.checkDragDelay);
	    }, _this.checkDragDelay = function (e) {
	      var x = void 0;
	      var y = void 0;
	      if ("ontouchstart" in window && e.touches) {
	        x = e.touches[0].clientX;
	        y = e.touches[0].clientY;
	      } else {
	        e.preventDefault();
	        x = e.clientX;
	        y = e.clientY;
	      }
	      var a = Math.abs(_this.state.startCoordinate.x - x);
	      var b = Math.abs(_this.state.startCoordinate.y - y);
	      var distance = Math.round(Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)));
	      var dragDistance = _this.props.delay;
	      if (distance >= dragDistance) {
	        _this.endDragDelay();
	        if ("ontouchstart" in window && e.touches) {
	          _this.startMobileDrag(e);
	        } else {
	          _this.startDrag(e);
	        }
	      }
	    }, _this.endDragDelay = function () {
	      document.removeEventListener("mouseup", _this.endDragDelay);
	      document.removeEventListener("mousemove", _this.checkDragDelay);
	      document.removeEventListener("touchend", _this.endDragDelay);
	      document.removeEventListener("touchmove", _this.checkDragDelay);
	      _this.setState({ startCoordinate: null });
	    }, _this.startDrag = function (e) {
	      dndStore.update({
	        isDragging: true,
	        startingX: e.clientX,
	        startingY: e.clientY,
	        x: e.clientX,
	        y: e.clientY,
	        currentlyDraggingId: _this.props.id,
	        data: _this.props.data,
	        type: _this.props.type
	      });
	      _this.props.onDragStart(dndStore.getState().data);
	      window.addEventListener("mouseup", _this.stopDrag);
	      window.addEventListener("mousemove", _this.updateCoordinates);
	    }, _this.startMobileDrag = function (e) {
	      _this.props.onDragStart(dndStore.getState().data);
	      var touch = e.touches[0];
	      dndStore.update({
	        isDragging: true,
	        startingX: touch.clientX,
	        startingY: touch.clientY,
	        x: touch.clientX,
	        y: touch.clientY,
	        currentlyDraggingId: _this.props.id,
	        data: _this.props.data,
	        type: _this.props.type
	      });
	      window.addEventListener("touchend", _this.stopDrag);
	      window.addEventListener("touchmove", _this.updateMobileCoordinates);
	    }, _this.stopDrag = function (e) {
	      _this.props.onDragEnd(dndStore.getState().data);
	      dndStore.reset();
	      window.removeEventListener("mouseup", _this.stopDrag);
	      window.removeEventListener("mousemove", _this.updateCoordinates);
	      window.removeEventListener("touchend", _this.stopDrag);
	      window.removeEventListener("touchmove", _this.updateMobileCoordinates);
	    }, _this.updateCoordinates = function (e) {
	      dndStore.update({
	        x: e.clientX,
	        y: e.clientY
	      });
	      _this.props.onDrag();
	    }, _this.updateMobileCoordinates = function (e) {
	      var touch = e.touches[0];
	      dndStore.update({
	        x: touch.clientX,
	        y: touch.clientY
	      });
	      _this.props.onDrag();
	    }, _this.shouldComponentUpdate = function (nextProps, nextState) {
	      if (nextProps !== _this.props) {
	        return true;
	      } else {
	        if (nextProps.subscribeTo) {
	          var shouldUpdate = false;
	          var i = 0;
	          while (i < nextProps.subscribeTo.length - 1) {
	            if (_this.state[nextProps.subscribeTo[i]] !== nextState[nextProps.subscribeTo[i]]) {
	              shouldUpdate = true;
	              i = nextProps.length;
	            } else {
	              i++;
	            }
	          }
	          return shouldUpdate;
	        } else {
	          if (nextState !== _this.state) {
	            return true;
	          } else {
	            return false;
	          }
	        }
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Draggable.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.unsubscribe = dndStore.subscribe(function () {
	      var state = dndStore.getState();
	      _this2.setState({
	        storeState: _extends({}, state, {
	          isActive: state.currentlyDraggingId === _this2.props.id
	        })
	      });
	    });
	  };
	
	  Draggable.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  Draggable.prototype.render = function render() {
	    var state = this.state.storeState;
	    return this.props.children(_extends({}, state, {
	      events: {
	        onMouseDown: this.startDragDelay,
	        onTouchStart: this.startDragDelay
	      }
	    }));
	  };
	
	  return Draggable;
	}(React.Component);
	
	Draggable.defaultProps = {
	  id: getId(),
	  data: null,
	  type: null,
	  delay: 8,
	  onDragStart: noop,
	  onDrag: noop,
	  onDragEnd: noop,
	  subscribeTo: null
	};
	
	
	Draggable.propTypes = {
	  children: PropTypes.func.isRequired,
	  delay: PropTypes.number,
	  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	  type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  onDragStart: PropTypes.func,
	  onDrag: PropTypes.func,
	  onDragEnd: PropTypes.func,
	  subscribeTo: PropTypes.array
	};
	
	var Droppable = function (_React$Component) {
	  inherits(Droppable, _React$Component);
	
	  function Droppable() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Droppable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = _extends({}, dndStore.getState(), { isOver: false }), _this.setOver = function () {
	      if (dndStore.getState().isDragging) {
	        dndStore.update({
	          currentlyHoveredDroppableId: _this.props.id,
	          currentlyHoveredDroppableAccepts: _this.props.accepts
	        });
	        _this.props.onDragEnter();
	      }
	    }, _this.setOut = function () {
	      if (dndStore.getState().isDragging) {
	        dndStore.update({
	          currentlyHoveredDroppableId: null,
	          currentlyHoveredDroppableAccepts: null
	        });
	        _this.props.onDragLeave();
	      }
	    }, _this.onDrop = function () {
	      var _store$getState = dndStore.getState(),
	          data = _store$getState.data,
	          type = _store$getState.type,
	          isDragging = _store$getState.isDragging;
	
	      if (isDragging) {
	        if (Array.isArray(_this.props.accepts)) {
	          if (_this.props.accepts.includes(type)) {
	            _this.props.onDrop(data);
	          }
	        } else {
	          if (type === _this.props.accepts) {
	            _this.props.onDrop(data);
	          }
	        }
	      }
	    }, _this.shouldComponentUpdate = function (nextProps, nextState) {
	      if (nextProps !== _this.props) {
	        return true;
	      } else {
	        if (nextProps.subscribeTo) {
	          var shouldUpdate = false;
	          var i = 0;
	          while (i < nextProps.subscribeTo.length - 1) {
	            if (_this.state[nextProps.subscribeTo[i]] !== nextState[nextProps.subscribeTo[i]]) {
	              shouldUpdate = true;
	              i = nextProps.length;
	            } else {
	              i++;
	            }
	          }
	          return shouldUpdate;
	        } else {
	          if (nextState !== _this.state) {
	            return true;
	          } else {
	            return false;
	          }
	        }
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Droppable.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.unsubscribe = dndStore.subscribe(function () {
	      var state = dndStore.getState();
	      _this2.setState(_extends({}, state, {
	        isOver: state.currentlyHoveredDroppableId === _this2.props.id,
	        willAccept: Array.isArray(_this2.props.accepts) ? _this2.props.accepts.includes(state.type) : _this2.props.accepts === state.type
	      }));
	    });
	  };
	
	  Droppable.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  Droppable.prototype.render = function render() {
	    var state = this.state;
	    return this.props.children(_extends({}, state, {
	      events: {
	        onMouseEnter: this.setOver,
	        onMouseLeave: this.setOut,
	        onMouseUp: this.onDrop
	      }
	    }));
	  };
	
	  return Droppable;
	}(React.Component);
	
	Droppable.defaultProps = {
	  id: getId(),
	  accepts: null,
	  onDragEnter: noop,
	  onDragLeave: noop,
	  onDrop: noop,
	  subscribeTo: null
	};
	
	
	Droppable.propTypes = {
	  id: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  children: PropTypes.func.isRequired,
	  accepts: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  onDrop: PropTypes.func,
	  onDragEnter: PropTypes.func,
	  onDragLeave: PropTypes.func,
	  subscribeTo: PropTypes.array
	};
	
	var DragState = function (_React$Component) {
	  inherits(DragState, _React$Component);
	
	  function DragState() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, DragState);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = dndStore.getState(), _this.shouldComponentUpdate = function (nextProps, nextState) {
	      if (nextProps !== _this.props) {
	        return true;
	      } else {
	        if (nextProps.subscribeTo) {
	          var shouldUpdate = false;
	          var i = 0;
	          while (i < nextProps.subscribeTo.length - 1) {
	            if (_this.state[nextProps.subscribeTo[i]] !== nextState[nextProps.subscribeTo[i]]) {
	              shouldUpdate = true;
	              i = nextProps.length;
	            } else {
	              i++;
	            }
	          }
	          return shouldUpdate;
	        } else {
	          if (nextState !== _this.state) {
	            return true;
	          } else {
	            return false;
	          }
	        }
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  DragState.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.unsubscribe = dndStore.subscribe(function () {
	      _this2.setState(dndStore.getState());
	    });
	  };
	
	  DragState.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  DragState.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children(_extends({}, this.state));
	  };
	
	  return DragState;
	}(React.Component);
	
	DragState.defaultProps = {
	  subscribeTo: null
	};
	
	
	DragState.propTypes = {
	  children: PropTypes.func.isRequired,
	  subscribeTo: PropTypes.array
	};
	
	exports.DragComponent = DragComponent;
	exports.Draggable = Draggable;
	exports.Droppable = Droppable;
	exports.DragState = DragState;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(350);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(374);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(242);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(2377);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(228);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(987);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(242);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(328);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(674);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.updateStatus = function () {
	      if (_this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        _this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(_this);
	
	        if (_this.nextStatus === ENTERING) {
	          _this.props.onEnter(node);
	
	          _this.safeSetState({ status: ENTERING }, function () {
	            _this.props.onEntering(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: ENTERED }, function () {
	                _this.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          _this.props.onExit(node);
	
	          _this.safeSetState({ status: EXITING }, function () {
	            _this.props.onExiting(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: EXITED }, function () {
	                _this.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        _this.nextStatus = null;
	      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
	        _this.setState({ status: UNMOUNTED });
	      }
	    };
	
	    _this.cancelNextCallback = function () {
	      if (_this.nextCallback !== null) {
	        _this.nextCallback.cancel();
	        _this.nextCallback = null;
	      }
	    };
	
	    _this.safeSetState = function (nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      _this.setState(nextState, _this.setNextCallback(callback));
	    };
	
	    _this.setNextCallback = function (callback) {
	      var active = true;
	
	      _this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      _this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return _this.nextCallback;
	    };
	
	    _this.onTransitionEnd = function (node, handler) {
	      _this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
	        setTimeout(_this.nextCallback, _this.props.timeout);
	      } else {
	        setTimeout(_this.nextCallback, 0);
	      }
	    };
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = void 0;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, _extends({}, childProps, {
	      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _propTypes2.default.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _propTypes2.default.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(328);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(452);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(329);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(227);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(537);
	
	var _ContextUtils = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 990 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _PatternUtils = __webpack_require__(243);
	
	var _InternalPropTypes = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 992 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(699);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(698);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1882);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(996);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(244);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(2396);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(2393);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(2400);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(2397);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(2402);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(699);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(698);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _AnimateManager = _interopRequireDefault(__webpack_require__(2406));
	
	var _easing = __webpack_require__(998);
	
	var _configUpdate = _interopRequireDefault(__webpack_require__(2407));
	
	var _util = __webpack_require__(375);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Animate =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Animate, _PureComponent);
	
	  function Animate(props, context) {
	    var _this;
	
	    _classCallCheck(this, Animate);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    if (!isActive) {
	      _this.state = {
	        style: {}
	      }; // if children is a function and animation is not active, set style to 'to'
	
	      if (typeof children === 'function') {
	        _this.state = {
	          style: to
	        };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = {
	        style: steps[0].style
	      };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	        return _possibleConstructorReturn(_this);
	      }
	
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = {
	        style: {}
	      };
	    }
	
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props2 = this.props,
	          isActive = _this$props2.isActive,
	          canBegin = _this$props2.canBegin;
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props3 = this.props,
	          isActive = _this$props3.isActive,
	          canBegin = _this$props3.canBegin,
	          attributeName = _this$props3.attributeName,
	          shouldReAnimate = _this$props3.shouldReAnimate;
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        var newState = {
	          style: attributeName ? _defineProperty({}, attributeName, this.props.to) : this.props.to
	        };
	
	        if (this.state && this.state.style) {
	          if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) {
	            // eslint-disable-next-line react/no-did-update-set-state
	            this.setState(newState);
	          }
	        }
	
	        return;
	      }
	
	      if ((0, _isEqual2.default)(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
	        return;
	      }
	
	      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;
	
	      if (this.state && this.state.style) {
	        var _newState = {
	          style: attributeName ? _defineProperty({}, attributeName, from) : from
	        };
	
	        if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) {
	          // eslint-disable-next-line react/no-did-update-set-state
	          this.setState(_newState);
	        }
	      }
	
	      this.runAnimation(_objectSpread({}, this.props, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: "runJSAnimation",
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	      var startAnimation = (0, _configUpdate.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: "runStepAnimation",
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	
	        var newStyle = _objectSpread({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: "runAnimation",
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager.default)();
	      }
	
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	      var manager = this.manager;
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
	        transition: transition
	      }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: "handleStyleChange",
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: "changeStyle",
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          children = _this$props4.children,
	          begin = _this$props4.begin,
	          duration = _this$props4.duration,
	          attributeName = _this$props4.attributeName,
	          easing = _this$props4.easing,
	          isActive = _this$props4.isActive,
	          steps = _this$props4.steps,
	          from = _this$props4.from,
	          to = _this$props4.to,
	          canBegin = _this$props4.canBegin,
	          onAnimationEnd = _this$props4.onAnimationEnd,
	          shouldReAnimate = _this$props4.shouldReAnimate,
	          onAnimationReStart = _this$props4.onAnimationReStart,
	          others = _objectWithoutProperties(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);
	
	      var count = _react.Children.count(children);
	
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === void 0 ? {} : _container$props$styl,
	            className = _container$props.className;
	        var res = (0, _react.cloneElement)(container, _objectSpread({}, others, {
	          style: _objectSpread({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react.default.createElement("div", null, _react.Children.map(children, function (child) {
	        return cloneContainer(child);
	      }));
	    }
	  }]);
	
	  return Animate;
	}(_react.PureComponent);
	
	Animate.displayName = 'Animate';
	Animate.propTypes = {
	  from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  attributeName: _propTypes.default.string,
	  // animation duration
	  duration: _propTypes.default.number,
	  begin: _propTypes.default.number,
	  easing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
	    duration: _propTypes.default.number.isRequired,
	    style: _propTypes.default.object.isRequired,
	    easing: _propTypes.default.oneOfType([_propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes.default.arrayOf('string'),
	    onAnimationEnd: _propTypes.default.func
	  })),
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  isActive: _propTypes.default.bool,
	  canBegin: _propTypes.default.bool,
	  onAnimationEnd: _propTypes.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes.default.bool,
	  onAnimationStart: _propTypes.default.func,
	  onAnimationReStart: _propTypes.default.func
	};
	Animate.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	};
	var _default = Animate;
	exports.default = _default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = void 0;
	
	var _util = __webpack_require__(375);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    var newParams = _toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)).concat([0]);
	
	    return multyTime(newParams, t);
	  };
	}; // calculate cubic-bezier using Newton's method
	
	
	var configBezier = function configBezier() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      default:
	        {
	          var easing = args[0].split('(');
	
	          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
	            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
	              return parseFloat(x);
	            });
	
	            var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
	
	            x1 = _easing$1$split$0$spl2[0];
	            y1 = _easing$1$split$0$spl2[1];
	            x2 = _easing$1$split$0$spl2[2];
	            y2 = _easing$1$split$0$spl2[3];
	          } else {
	            (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
	          }
	        }
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	  return bezier;
	};
	
	exports.configBezier = configBezier;
	
	var configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === void 0 ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === void 0 ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	  return stepper;
	};
	
	exports.configSpring = configSpring;
	
	var configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	
	      case 'spring':
	        return configSpring();
	
	      default:
	        if (easing.split('(')[0] === 'cubic-bezier') {
	          return configBezier(easing);
	        }
	
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	  return null;
	};
	
	exports.configEasing = configEasing;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(49));
	
	var _reactLifecyclesCompat = __webpack_require__(534);
	
	var _PropTypes = __webpack_require__(1002);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(534);
	
	var _ChildMapping = __webpack_require__(2411);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(2409));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(2410));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(1000));
	
	var _Transition = _interopRequireDefault(__webpack_require__(999));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(293),
	    _assign = __webpack_require__(45);
	
	var ReactNoopUpdateQueue = __webpack_require__(1006);
	
	var canDefineProperty = __webpack_require__(1007);
	var emptyObject = __webpack_require__(331);
	var invariant = __webpack_require__(29);
	var lowPriorityWarning = __webpack_require__(2422);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(293);
	
	var ReactCurrentOwner = __webpack_require__(148);
	
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 1005 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(39);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 1008 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoize = exports.reverse = exports.compose = exports.map = exports.range = exports.curry = exports.PLACE_HOLDER = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	exports.PLACE_HOLDER = PLACE_HOLDER;
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(void 0, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(void 0, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	exports.curry = curry;
	
	var range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	exports.range = range;
	var map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	exports.map = map;
	
	var compose = function compose() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  } // can be string
	
	
	  return arr.split('').reverse.join('');
	};
	
	exports.reverse = reverse;
	
	var memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(void 0, args);
	    return lastResult;
	  };
	};
	
	exports.memoize = memoize;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _range2 = _interopRequireDefault(__webpack_require__(487));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _d3Scale = __webpack_require__(1044);
	
	var _ChartUtils = __webpack_require__(87);
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Text = _interopRequireDefault(__webpack_require__(207));
	
	var _DataUtils = __webpack_require__(38);
	
	var _CssPrefixUtils = __webpack_require__(2447);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Brush =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Brush, _PureComponent);
	
	  function Brush(props) {
	    var _this;
	
	    _classCallCheck(this, Brush);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
	    };
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Brush, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          x = _this$props.x,
	          travellerWidth = _this$props.travellerWidth,
	          updateId = _this$props.updateId;
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _this$props2 = this.props,
	          gap = _this$props2.gap,
	          data = _this$props2.data;
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: "getTextOfTick",
	    value: function getTextOfTick(index) {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          tickFormatter = _this$props3.tickFormatter,
	          dataKey = _this$props3.dataKey;
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	      return (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: "handleSlideDrag",
	    value: function handleSlideDrag(e) {
	      var _this$state = this.state,
	          slideMoveStartX = _this$state.slideMoveStartX,
	          startX = _this$state.startX,
	          endX = _this$state.endX;
	      var _this$props4 = this.props,
	          x = _this$props4.x,
	          width = _this$props4.width,
	          travellerWidth = _this$props4.travellerWidth,
	          startIndex = _this$props4.startIndex,
	          endIndex = _this$props4.endIndex,
	          onChange = _this$props4.onChange;
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerDragStart",
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerMove",
	    value: function handleTravellerMove(e) {
	      var _this$setState;
	
	      var _this$state2 = this.state,
	          brushMoveStartX = _this$state2.brushMoveStartX,
	          movingTravellerId = _this$state2.movingTravellerId,
	          endX = _this$state2.endX,
	          startX = _this$state2.startX;
	      var prevValue = this.state[movingTravellerId];
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          width = _this$props5.width,
	          travellerWidth = _this$props5.travellerWidth,
	          onChange = _this$props5.onChange,
	          gap = _this$props5.gap,
	          data = _this$props5.data;
	      var params = {
	        startX: this.state.startX,
	        endX: this.state.endX
	      };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	
	        return false;
	      };
	
	      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: "updateScale",
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range2["default"])(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          fill = _this$props6.fill,
	          stroke = _this$props6.stroke;
	      return _react["default"].createElement("rect", {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: "renderPanorama",
	    value: function renderPanorama() {
	      var _this$props7 = this.props,
	          x = _this$props7.x,
	          y = _this$props7.y,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          data = _this$props7.data,
	          children = _this$props7.children,
	          padding = _this$props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react["default"].cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: "renderTraveller",
	    value: function renderTraveller(travellerX, id) {
	      var _this$props8 = this.props,
	          y = _this$props8.y,
	          travellerWidth = _this$props8.travellerWidth,
	          height = _this$props8.height,
	          stroke = _this$props8.stroke;
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-traveller",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.travellerDragStartHandlers[id],
	        onTouchStart: this.travellerDragStartHandlers[id],
	        style: {
	          cursor: 'col-resize'
	        }
	      }, _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: travellerWidth,
	        height: height,
	        fill: stroke,
	        stroke: "none"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY,
	        x2: x + travellerWidth - 1,
	        y2: lineY,
	        fill: "none",
	        stroke: "#fff"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY + 2,
	        x2: x + travellerWidth - 1,
	        y2: lineY + 2,
	        fill: "none",
	        stroke: "#fff"
	      }));
	    }
	  }, {
	    key: "renderSlide",
	    value: function renderSlide(startX, endX) {
	      var _this$props9 = this.props,
	          y = _this$props9.y,
	          height = _this$props9.height,
	          stroke = _this$props9.stroke;
	      return _react["default"].createElement("rect", {
	        className: "recharts-brush-slide",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: {
	          cursor: 'move'
	        },
	        stroke: "none",
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: "renderText",
	    value: function renderText() {
	      var _this$props10 = this.props,
	          startIndex = _this$props10.startIndex,
	          endIndex = _this$props10.endIndex,
	          y = _this$props10.y,
	          height = _this$props10.height,
	          travellerWidth = _this$props10.travellerWidth,
	          stroke = _this$props10.stroke;
	      var _this$state3 = this.state,
	          startX = _this$state3.startX,
	          endX = _this$state3.endX;
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-texts"
	      }, _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "end",
	        verticalAnchor: "middle",
	        x: Math.min(startX, endX) - offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(startIndex)), _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "start",
	        verticalAnchor: "middle",
	        x: Math.max(startX, endX) + travellerWidth + offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(endIndex)));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props11 = this.props,
	          data = _this$props11.data,
	          className = _this$props11.className,
	          children = _this$props11.children,
	          x = _this$props11.x,
	          y = _this$props11.y,
	          width = _this$props11.width,
	          height = _this$props11.height,
	          alwaysShowText = _this$props11.alwaysShowText;
	      var _this$state4 = this.state,
	          startX = _this$state4.startX,
	          endX = _this$state4.endX,
	          isTextActive = _this$state4.isTextActive,
	          isSlideMoving = _this$state4.isSlideMoving,
	          isTravellerMoving = _this$state4.isTravellerMoving;
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-brush', className);
	      var isPanoramic = _react["default"].Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        onMouseMove: this.handleDrag,
	        onMouseLeave: this.handleLeaveWrapper,
	        onMouseUp: this.handleDragEnd,
	        onTouchEnd: this.handleDragEnd,
	        onTouchMove: this.handleTouchMove,
	        style: style
	      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
	    }
	  }], [{
	    key: "getIndexInRange",
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }]);
	
	  return Brush;
	}(_react.PureComponent);
	
	Brush.displayName = 'Brush';
	Brush.propTypes = {
	  className: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number.isRequired,
	  travellerWidth: _propTypes["default"].number,
	  gap: _propTypes["default"].number,
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  }),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].array,
	  startIndex: _propTypes["default"].number,
	  endIndex: _propTypes["default"].number,
	  tickFormatter: _propTypes["default"].func,
	  children: _propTypes["default"].node,
	  onChange: _propTypes["default"].func,
	  updateId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  leaveTimeOut: _propTypes["default"].number,
	  alwaysShowText: _propTypes["default"].bool
	};
	Brush.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  },
	  leaveTimeOut: 1000,
	  alwaysShowText: false
	};
	var _default = Brush;
	exports["default"] = _default;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _ShallowEqual = __webpack_require__(384);
	
	var _DOMUtils = __webpack_require__(382);
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Text = _interopRequireDefault(__webpack_require__(207));
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianAxis =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ["viewBox"]);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _this$props = this.props,
	          viewBoxOld = _this$props.viewBox,
	          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);
	
	      return !(0, _ShallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _ShallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _ShallowEqual.shallowEqual)(state, this.state);
	    }
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: "getTickLineCoord",
	    value: function getTickLineCoord(data) {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          orientation = _this$props2.orientation,
	          tickSize = _this$props2.tickSize,
	          mirror = _this$props2.mirror,
	          tickMargin = _this$props2.tickMargin;
	      var x1, x2, y1, y2, tx, ty;
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return {
	        line: {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2
	        },
	        tick: {
	          x: tx,
	          y: ty
	        }
	      };
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var _this$props3 = this.props,
	          orientation = _this$props3.orientation,
	          mirror = _this$props3.mirror;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getTickVerticalAnchor",
	    value: function getTickVerticalAnchor() {
	      var _this$props4 = this.props,
	          orientation = _this$props4.orientation,
	          mirror = _this$props4.mirror;
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          orientation = _this$props5.orientation,
	          axisLine = _this$props5.axisLine,
	          mirror = _this$props5.mirror;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-cartesian-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	    value: function renderTicks(ticks) {
	      var _this = this;
	
	      var _this$props6 = this.props,
	          tickLine = _this$props6.tickLine,
	          stroke = _this$props6.stroke,
	          tick = _this$props6.tick,
	          tickFormatter = _this$props6.tickFormatter,
	          unit = _this$props6.unit;
	      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
	        ticks: ticks
	      }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = finalTicks.map(function (entry, i) {
	        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
	            lineCoord = _this$getTickLineCoor.line,
	            tickCoord = _this$getTickLineCoor.tick;
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {}, tickCoord, {
	          index: i,
	          payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-cartesian-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-cartesian-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat((0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          axisLine = _this$props7.axisLine,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          ticksGenerator = _this$props7.ticksGenerator,
	          className = _this$props7.className,
	          hide = _this$props7.hide;
	
	      if (hide) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          ticks = _this$props8.ticks,
	          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction2["default"])(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-cartesian-axis', className)
	      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), _Label["default"].renderCallByParent(this.props));
	    }
	  }], [{
	    key: "getTicks",
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        }, true);
	      }
	
	      if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks,
	        tickFormatter: tickFormatter,
	        viewBox: viewBox,
	        orientation: orientation,
	        minTickGap: minTickGap,
	        unit: unit
	      });
	    }
	  }, {
	    key: "getNumberIntervalTicks",
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: "getTicksStart",
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _objectSpread({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _objectSpread({}, tail, {
	            isShow: true
	          });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	
	      for (var _i = 0; _i < count; _i++) {
	        var entry = result[_i];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[_i] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "getTicksEnd",
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var _i2 = len - 1; _i2 >= 0; _i2--) {
	        var entry = result[_i2];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i2 === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[_i2] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-cartesian-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component);
	
	CartesianAxis.displayName = 'CartesianAxis';
	CartesianAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  orientation: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  mirror: _propTypes["default"].bool,
	  tickMargin: _propTypes["default"].number.isRequired,
	  minTickGap: _propTypes["default"].number,
	  ticks: _propTypes["default"].array,
	  tickSize: _propTypes["default"].number,
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  ticksGenerator: _propTypes["default"].func,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	});
	CartesianAxis.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	};
	var _default = CartesianAxis;
	exports["default"] = _default;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _CartesianUtils = __webpack_require__(175);
	
	var _IfOverflowMatches = __webpack_require__(383);
	
	var _DataUtils = __webpack_require__(38);
	
	var _LogUtils = __webpack_require__(251);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(250));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceArea =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceArea, _PureComponent);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: "getRect",
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _this$props = this.props,
	          xValue1 = _this$props.x1,
	          xValue2 = _this$props.x2,
	          yValue1 = _this$props.y1,
	          yValue2 = _this$props.y2,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scale = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var p1 = {
	        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
	        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
	      };
	      var p2 = {
	        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
	        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
	      };
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
	        return null;
	      }
	
	      return (0, _CartesianUtils.rectWithPoints)(p1, p2);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x1 = _this$props2.x1,
	          x2 = _this$props2.x2,
	          y1 = _this$props2.y1,
	          y2 = _this$props2.y2,
	          className = _this$props2.className,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	      var shape = this.props.shape;
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect && !shape) {
	        return null;
	      }
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-area', className)
	      }, this.constructor.renderRect(shape, _objectSpread({
	        clipPath: clipPath
	      }, this.props, {}, rect)), _Label["default"].renderCallByParent(this.props, rect));
	    }
	  }], [{
	    key: "renderRect",
	    value: function renderRect(option, props) {
	      var rect;
	
	      if (_react["default"].isValidElement(option)) {
	        rect = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rect = option(props);
	      } else {
	        rect = _react["default"].createElement(_Rectangle["default"], _extends({}, props, {
	          className: "recharts-reference-area-rect"
	        }));
	      }
	
	      return rect;
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.PureComponent);
	
	ReferenceArea.displayName = 'ReferenceArea';
	ReferenceArea.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  x2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element])
	});
	ReferenceArea.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	};
	var _default = ReferenceArea;
	exports["default"] = _default;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Dot = _interopRequireDefault(__webpack_require__(208));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _DataUtils = __webpack_require__(38);
	
	var _IfOverflowMatches = __webpack_require__(383);
	
	var _CartesianUtils = __webpack_require__(175);
	
	var _LogUtils = __webpack_require__(251);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceDot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceDot, _PureComponent);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: "getCoordinate",
	    value: function getCoordinate() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var result = scales.apply({
	        x: x,
	        y: y
	      }, {
	        bandAware: true
	      });
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.isInRange(result)) {
	        return null;
	      }
	
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          r = _this$props2.r,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var cx = coordinate.x,
	          cy = coordinate.y;
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          className = _this$props3.className;
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var dotProps = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        cx: cx,
	        cy: cy
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-dot', className)
	      }, this.constructor.renderDot(shape, dotProps), _Label["default"].renderCallByParent(this.props, {
	        x: cx - r,
	        y: cy - r,
	        width: 2 * r,
	        height: 2 * r
	      }));
	    }
	  }], [{
	    key: "renderDot",
	    value: function renderDot(option, props) {
	      var dot;
	
	      if (_react["default"].isValidElement(option)) {
	        dot = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dot = option(props);
	      } else {
	        dot = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: "recharts-reference-dot-dot"
	        }));
	      }
	
	      return dot;
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.PureComponent);
	
	ReferenceDot.displayName = 'ReferenceDot';
	ReferenceDot.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes["default"].number,
	  xAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  yAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  clipPathId: _propTypes["default"].string
	});
	ReferenceDot.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	};
	var _default = ReferenceDot;
	exports["default"] = _default;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _some2 = _interopRequireDefault(__webpack_require__(2053));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _IfOverflowMatches = __webpack_require__(383);
	
	var _DataUtils = __webpack_require__(38);
	
	var _CartesianUtils = __webpack_require__(175);
	
	var _LogUtils = __webpack_require__(251);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var renderLine = function renderLine(option, props) {
	  var line;
	
	  if (_react["default"].isValidElement(option)) {
	    line = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    line = option(props);
	  } else {
	    line = _react["default"].createElement("line", _extends({}, props, {
	      className: "recharts-reference-line-line"
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceLine, _PureComponent);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: "getEndPoints",
	    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
	      var _this$props = this.props,
	          _this$props$viewBox = _this$props.viewBox,
	          x = _this$props$viewBox.x,
	          y = _this$props$viewBox.y,
	          width = _this$props$viewBox.width,
	          height = _this$props$viewBox.height,
	          position = _this$props.position;
	
	      if (isFixedY) {
	        var _this$props2 = this.props,
	            yCoord = _this$props2.y,
	            orientation = _this$props2.yAxis.orientation;
	        var coord = scales.y.apply(yCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.y.isInRange(coord)) {
	          return null;
	        }
	
	        var points = [{
	          x: x + width,
	          y: coord
	        }, {
	          x: x,
	          y: coord
	        }];
	        return orientation === 'left' ? points.reverse() : points;
	      }
	
	      if (isFixedX) {
	        var _this$props3 = this.props,
	            xCoord = _this$props3.x,
	            _orientation = _this$props3.xAxis.orientation;
	
	        var _coord = scales.x.apply(xCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.x.isInRange(_coord)) {
	          return null;
	        }
	
	        var _points = [{
	          x: _coord,
	          y: y + height
	        }, {
	          x: _coord,
	          y: y
	        }];
	        return _orientation === 'top' ? _points.reverse() : _points;
	      }
	
	      if (isSegment) {
	        var segment = this.props.segment;
	
	        var _points2 = segment.map(function (p) {
	          return scales.apply(p, {
	            position: position
	          });
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (0, _some2["default"])(_points2, function (p) {
	          return !scales.isInRange(p);
	        })) {
	          return null;
	        }
	
	        return _points2;
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          fixedX = _this$props4.x,
	          fixedY = _this$props4.y,
	          segment = _this$props4.segment,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          shape = _this$props4.shape,
	          className = _this$props4.className,
	          alwaysShow = _this$props4.alwaysShow,
	          clipPathId = _this$props4.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var isX = (0, _DataUtils.isNumOrStr)(fixedX);
	      var isY = (0, _DataUtils.isNumOrStr)(fixedY);
	      var isSegment = segment && segment.length === 2;
	      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          _endPoints$ = _endPoints[0],
	          x1 = _endPoints$.x,
	          y1 = _endPoints$.y,
	          _endPoints$2 = _endPoints[1],
	          x2 = _endPoints$2.x,
	          y2 = _endPoints$2.y;
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var props = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-line', className)
	      }, renderLine(shape, props), _Label["default"].renderCallByParent(this.props, (0, _CartesianUtils.rectWithCoords)({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      })));
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.PureComponent);
	
	ReferenceLine.displayName = 'ReferenceLine';
	ReferenceLine.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  segment: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  })),
	  position: _propTypes["default"].oneOf(['middle', 'start', 'end']),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].func
	});
	ReferenceLine.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  position: 'middle'
	};
	var _default = ReferenceLine;
	exports["default"] = _default;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(485));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(739));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(348));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(347));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Trapezoid = _interopRequireDefault(__webpack_require__(1019));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _Cell = _interopRequireDefault(__webpack_require__(248));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Funnel =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Funnel, _PureComponent);
	
	  function Funnel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Funnel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (trapezoids) {
	      _this.setState({
	        prevTrapezoids: trapezoids
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Funnel, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          trapezoids = _this$props.trapezoids;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(trapezoids);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderTrapezoidsStatically",
	    value: function renderTrapezoidsStatically(trapezoids) {
	      var _this2 = this;
	
	      var activeShape = this.props.activeShape;
	      return trapezoids.map(function (entry, i) {
	        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;
	
	        var trapezoidProps = _objectSpread({}, entry, {
	          stroke: entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-funnel-trapezoid"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "trapezoid-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
	      });
	    }
	  }, {
	    key: "renderTrapezoidsWithAnimation",
	    value: function renderTrapezoidsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          trapezoids = _this$props2.trapezoids,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevTrapezoids = this.state.prevTrapezoids;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "funnel-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = trapezoids.map(function (entry, index) {
	          var prev = prevTrapezoids && prevTrapezoids[index];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            var _interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
	
	            var _interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
	
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t),
	              upperWidth: _interpolatorUpperWidth(t),
	              lowerWidth: _interpolatorLowerWidth(t),
	              height: _interpolatorHeight(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
	          var interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(0, entry.upperWidth);
	          var interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(0, entry.lowerWidth);
	          var interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t),
	            upperWidth: interpolatorUpperWidth(t),
	            lowerWidth: interpolatorLowerWidth(t),
	            height: interpolatorHeight(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderTrapezoidsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderTrapezoids",
	    value: function renderTrapezoids() {
	      var _this$props3 = this.props,
	          trapezoids = _this$props3.trapezoids,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevTrapezoids = this.state.prevTrapezoids;
	
	      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqual2["default"])(prevTrapezoids, trapezoids))) {
	        return this.renderTrapezoidsWithAnimation();
	      }
	
	      return this.renderTrapezoidsStatically(trapezoids);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          hide = _this$props4.hide,
	          trapezoids = _this$props4.trapezoids,
	          className = _this$props4.className,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (hide || !trapezoids || !trapezoids.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoids', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, trapezoids));
	    }
	  }], [{
	    key: "renderTrapezoidItem",
	    value: function renderTrapezoidItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Trapezoid["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Trapezoid["default"], props);
	    }
	  }]);
	
	  return Funnel;
	}(_react.PureComponent);
	
	Funnel.displayName = 'Funnel';
	Funnel.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  trapezoids: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	});
	Funnel.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  labelLine: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	};
	
	Funnel.getRealFunnelData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Funnel.getRealWidthHeight = function (item, offset) {
	  var customWidth = item.props.width;
	  var width = offset.width,
	      height = offset.height,
	      left = offset.left,
	      right = offset.right,
	      top = offset.top,
	      bottom = offset.bottom;
	  var realHeight = height;
	  var realWidth = width;
	
	  if ((0, _isNumber2["default"])(customWidth)) {
	    realWidth = customWidth;
	  } else if ((0, _isString2["default"])(customWidth)) {
	    realWidth = realWidth * parseFloat(customWidth) / 100;
	  }
	
	  return {
	    realWidth: realWidth - left - right - 50,
	    realHeight: realHeight - bottom - top,
	    offsetX: (width - realWidth) / 2,
	    offsetY: (height - realHeight) / 2
	  };
	};
	
	Funnel.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      offset = _ref2.offset,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter;
	  var funnelData = Funnel.getRealFunnelData(item);
	  var _item$props2 = item.props,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      tooltipType = _item$props2.tooltipType;
	  var left = offset.left,
	      top = offset.top;
	
	  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
	      realHeight = _Funnel$getRealWidthH.realHeight,
	      realWidth = _Funnel$getRealWidthH.realWidth,
	      offsetX = _Funnel$getRealWidthH.offsetX,
	      offsetY = _Funnel$getRealWidthH.offsetY;
	
	  var maxValue = (0, _ChartUtils.getValueByDataKey)(funnelData[0], dataKey, 0);
	  var len = funnelData.length;
	  var rowHeight = realHeight / len;
	  var trapezoids = funnelData.map(function (entry, i) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	    var nextVal = 0;
	
	    if (i !== len - 1) {
	      nextVal = (0, _ChartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
	    }
	
	    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
	    var y = realHeight / len * i + left + offsetY;
	    var upperWidth = val / maxValue * realWidth;
	    var lowerWidth = nextVal / maxValue * realWidth;
	    var tooltipPayload = [{
	      name: name,
	      value: val,
	      payload: entry,
	      dataKey: dataKey,
	      type: tooltipType
	    }];
	    var tooltipPosition = {
	      x: x + upperWidth / 2,
	      y: y + rowHeight / 2
	    };
	    return _objectSpread({
	      x: x,
	      y: y,
	      width: Math.max(upperWidth, lowerWidth),
	      upperWidth: upperWidth,
	      lowerWidth: lowerWidth,
	      height: rowHeight,
	      name: name,
	      val: val,
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: tooltipPosition
	    }, (0, _omit2["default"])(entry, 'width'), {
	      payload: entry
	    });
	  });
	  return {
	    trapezoids: trapezoids,
	    data: funnelData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  };
	};
	
	var _default = Funnel;
	exports["default"] = _default;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _get2 = _interopRequireDefault(__webpack_require__(133));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(485));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(100));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Sector = _interopRequireDefault(__webpack_require__(381));
	
	var _Curve = _interopRequireDefault(__webpack_require__(249));
	
	var _Text = _interopRequireDefault(__webpack_require__(207));
	
	var _Label = _interopRequireDefault(__webpack_require__(174));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _Cell = _interopRequireDefault(__webpack_require__(248));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _PolarUtils = __webpack_require__(126);
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	var _LogUtils = __webpack_require__(251);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Pie =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Pie, _PureComponent);
	
	  function Pie() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-pie-');
	
	    _this.cachePrevData = function (sectors) {
	      _this.setState({
	        prevSectors: sectors
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Pie, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          sectors = _this$props.sectors;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderLabels",
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          label = _this$props2.label,
	          labelLine = _this$props2.labelLine,
	          dataKey = _this$props2.dataKey,
	          valueKey = _this$props2.valueKey;
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	
	        var labelProps = _objectSpread({}, pieProps, {}, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	
	        var lineProps = _objectSpread({}, pieProps, {}, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
	          key: 'line'
	        });
	
	        var realDataKey = dataKey; // TODO: compatible to lower versions
	
	        if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil2["default"])(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], {
	            key: "label-".concat(i)
	          }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey)))
	        );
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-pie-labels"
	      }, labels);
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          activeShape = _this$props3.activeShape,
	          blendStroke = _this$props3.blendStroke;
	      return sectors.map(function (entry, i) {
	        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;
	
	        var sectorProps = _objectSpread({}, entry, {
	          stroke: blendStroke ? entry.fill : entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-pie-sector"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          sectors = _this$props4.sectors,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevSectors = this.state.prevSectors;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = [];
	        var first = sectors && sectors[0];
	        var curAngle = first.startAngle;
	        sectors.forEach(function (entry, index) {
	          var prev = prevSectors && prevSectors[index];
	          var paddingAngle = index > 0 ? (0, _get2["default"])(entry, 'paddingAngle', 0) : 0;
	
	          if (prev) {
	            var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	
	            var latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + angleIp(t) + paddingAngle
	            });
	
	            stepData.push(latest);
	            curAngle = latest.endAngle;
	          } else {
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	            var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	            var deltaAngle = interpolatorAngle(t);
	
	            var _latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + deltaAngle + paddingAngle
	            });
	
	            stepData.push(_latest);
	            curAngle = _latest.endAngle;
	          }
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this4.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          sectors = _this$props5.sectors,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual2["default"])(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          sectors = _this$props6.sectors,
	          className = _this$props6.className,
	          label = _this$props6.label,
	          cx = _this$props6.cx,
	          cy = _this$props6.cy,
	          innerRadius = _this$props6.innerRadius,
	          outerRadius = _this$props6.outerRadius,
	          isAnimationActive = _this$props6.isAnimationActive,
	          prevSectors = _this$props6.prevSectors;
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-pie', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderSectors(), label && this.renderLabels(sectors), _Label["default"].renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && (0, _isEqual2["default"])(prevSectors, sectors)) && _LabelList["default"].renderCallByParent(this.props, sectors, false));
	    }
	  }], [{
	    key: "getTextAnchor",
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      }
	
	      if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: "renderLabelLineItem",
	    value: function renderLabelLineItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, props, {
	        type: "linear",
	        className: "recharts-pie-label-line"
	      }));
	    }
	  }, {
	    key: "renderLabelItem",
	    value: function renderLabelItem(option, props, value) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      var label = value;
	
	      if ((0, _isFunction2["default"])(option)) {
	        label = option(props);
	
	        if (_react["default"].isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react["default"].createElement(_Text["default"], _extends({}, props, {
	        alignmentBaseline: "middle",
	        className: "recharts-pie-label-text"
	      }), label);
	    }
	  }, {
	    key: "renderSectorItem",
	    value: function renderSectorItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Sector["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Sector["default"], props);
	    }
	  }]);
	
	  return Pie;
	}(_react.PureComponent);
	
	Pie.displayName = 'Pie';
	Pie.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  paddingAngle: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  valueKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  blendStroke: _propTypes["default"].bool,
	  minAngle: _propTypes["default"].number,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  maxRadius: _propTypes["default"].number,
	  sectors: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  labelLine: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].shape({
	    offsetRadius: _propTypes["default"].number
	  }), _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes["default"].string
	});
	Pie.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name',
	  // Match each sector's stroke color to it's fill color
	  blendStroke: false
	};
	
	Pie.parseDeltaAngle = function (_ref2) {
	  var startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	Pie.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Pie.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	  return {
	    cx: cx,
	    cy: cy,
	    innerRadius: innerRadius,
	    outerRadius: outerRadius,
	    maxRadius: maxRadius
	  };
	};
	
	Pie.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      offset = _ref3.offset,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter;
	  var pieData = Pie.getRealPieData(item);
	
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey,
	      tooltipType = _item$props2.tooltipType;
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({
	    startAngle: startAngle,
	    endAngle: endAngle
	  });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = 'value';
	  } else if ((0, _isNil2["default"])(dataKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors;
	
	  if (sum > 0) {
	    var prev;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{
	        name: name,
	        value: val,
	        payload: entry,
	        dataKey: realDataKey,
	        type: tooltipType
	      }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	      prev = _objectSpread({
	        percent: percent,
	        cornerRadius: cornerRadius,
	        name: name,
	        tooltipPayload: tooltipPayload,
	        midAngle: midAngle,
	        middleRadius: middleRadius,
	        tooltipPosition: tooltipPosition
	      }, entry, {}, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	      return prev;
	    });
	  }
	
	  return _objectSpread({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	};
	
	var _default = Pie;
	exports["default"] = _default;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _PolarUtils = __webpack_require__(126);
	
	var _ChartUtils = __webpack_require__(87);
	
	var _Polygon = _interopRequireDefault(__webpack_require__(380));
	
	var _Dot = _interopRequireDefault(__webpack_require__(208));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Radar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Radar, _PureComponent);
	
	  function Radar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    };
	
	    _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Radar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          dataKey = _this$props2.dataKey;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, baseProps, {}, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-dots"
	      }, dots);
	    }
	  }, {
	    key: "renderPolygonStatically",
	    value: function renderPolygonStatically(points) {
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          dot = _this$props3.dot;
	      var radar;
	
	      if (_react["default"].isValidElement(shape)) {
	        radar = _react["default"].cloneElement(shape, _objectSpread({}, this.props, {
	          points: points
	        }));
	      } else if ((0, _isFunction2["default"])(shape)) {
	        radar = shape(_objectSpread({}, this.props, {
	          points: points
	        }));
	      } else {
	        radar = _react["default"].createElement(_Polygon["default"], _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-polygon"
	      }, radar, dot ? this.renderDots(points) : null);
	    }
	  }, {
	    key: "renderPolygonWithAnimation",
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t)
	          });
	        });
	        return _this3.renderPolygonStatically(stepData);
	      });
	    }
	  }, {
	    key: "renderPolygon",
	    value: function renderPolygon() {
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          className = _this$props6.className,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-radar', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: "recharts-radar-dot"
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Radar;
	}(_react.PureComponent);
	
	Radar.displayName = 'Radar';
	Radar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]).isRequired,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    angle: _propTypes["default"].number,
	    radius: _propTypes["default"].number,
	    value: _propTypes["default"].number,
	    payload: _propTypes["default"].object
	  })),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // whether have dot in poly line
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].bool]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Radar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Radar.getComposedData = function (_ref2) {
	  var radiusAxis = _ref2.radiusAxis,
	      angleAxis = _ref2.angleAxis,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _objectSpread({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name,
	      value: value,
	      cx: cx,
	      cy: cy,
	      radius: radius,
	      angle: angle,
	      payload: entry
	    });
	  });
	  return {
	    points: points
	  };
	};
	
	var _default = Radar;
	exports["default"] = _default;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(109));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _Sector = _interopRequireDefault(__webpack_require__(381));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _LabelList = _interopRequireDefault(__webpack_require__(150));
	
	var _Cell = _interopRequireDefault(__webpack_require__(248));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RadialBar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(RadialBar, _PureComponent);
	
	  function RadialBar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(RadialBar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "getDeltaAngle",
	    value: function getDeltaAngle() {
	      var _this$props2 = this.props,
	          startAngle = _this$props2.startAngle,
	          endAngle = _this$props2.endAngle;
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	      return sign * deltaAngle;
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          activeShape = _this$props3.activeShape,
	          activeIndex = _this$props3.activeIndex,
	          cornerRadius = _this$props3.cornerRadius,
	          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      return sectors.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, {}, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-sector',
	          forceCornerRadius: others.forceCornerRadius,
	          cornerIsExternal: others.cornerIsExternal
	        });
	
	        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radialBar-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	            var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	            return _objectSpread({}, entry, {
	              startAngle: interpolatorStartAngle(t),
	              endAngle: interpolatorEndAngle(t)
	            });
	          }
	
	          var endAngle = entry.endAngle,
	              startAngle = entry.startAngle;
	          var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	          return _objectSpread({}, entry, {
	            endAngle: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          data = _this$props5.data,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.constructor.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          data = _this$props6.data,
	          className = _this$props6.className,
	          background = _this$props6.background,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, background && _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-background"
	      }, this.renderBackground(data)), _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-sectors"
	      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(_objectSpread({}, this.props, {
	        clockWise: this.getDeltaAngle() < 0
	      }), data));
	    }
	  }], [{
	    key: "renderSectorShape",
	    value: function renderSectorShape(shape, props) {
	      var sectorShape;
	
	      if (_react["default"].isValidElement(shape)) {
	        sectorShape = _react["default"].cloneElement(shape, props);
	      } else if ((0, _isFunction2["default"])(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react["default"].createElement(_Sector["default"], props);
	      }
	
	      return sectorShape;
	    }
	  }]);
	
	  return RadialBar;
	}(_react.PureComponent);
	
	RadialBar.displayName = 'RadialBar';
	RadialBar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool,
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    innerRadius: _propTypes["default"].number,
	    outerRadius: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object]),
	  background: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	});
	RadialBar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	
	RadialBar.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      props = _ref2.props,
	      radiusAxis = _ref2.radiusAxis,
	      radiusAxisTicks = _ref2.radiusAxisTicks,
	      angleAxis = _ref2.angleAxis,
	      angleAxisTicks = _ref2.angleAxisTicks,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      dataStartIndex = _ref2.dataStartIndex;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var sectors = displayedData.map(function (entry, index) {
	    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	        endAngle += delta;
	      }
	
	      backgroundSector = {
	        background: {
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	
	        outerRadius += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {}, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	  return {
	    data: sectors,
	    layout: layout
	  };
	};
	
	var _default = RadialBar;
	exports["default"] = _default;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _DataUtils = __webpack_require__(38);
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Cross =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Cross, _PureComponent);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          top = _this$props.top,
	          left = _this$props.left,
	          className = _this$props.className;
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames["default"])('recharts-cross', className),
	        d: this.constructor.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }], [{
	    key: "getPath",
	    value: function getPath(x, y, width, height, top, left) {
	      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
	    }
	  }]);
	
	  return Cross;
	}(_react.PureComponent);
	
	Cross.displayName = 'Cross';
	Cross.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  className: _propTypes["default"].string
	});
	Cross.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	};
	var _default = Cross;
	exports["default"] = _default;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
	  var widthGap = upperWidth - lowerWidth;
	  var path;
	  path = "M ".concat(x, ",").concat(y);
	  path += "L ".concat(x + upperWidth, ",").concat(y);
	  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
	  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
	  path += "L ".concat(x, ",").concat(y, " Z");
	  return path;
	};
	
	var Trapezoid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Trapezoid, _PureComponent);
	
	  function Trapezoid() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Trapezoid);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Trapezoid, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          upperWidth = _this$props.upperWidth,
	          lowerWidth = _this$props.lowerWidth,
	          height = _this$props.height,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoid', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("g", null, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
	        })));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          upperWidth: 0,
	          lowerWidth: 0,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          upperWidth: upperWidth,
	          lowerWidth: lowerWidth,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currUpperWidth = _ref.upperWidth,
	            currLowerWidth = _ref.lowerWidth,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Trapezoid;
	}(_react.PureComponent);
	
	Trapezoid.displayName = 'Trapezoid';
	Trapezoid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  upperWidth: _propTypes["default"].number,
	  lowerWidth: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Trapezoid.defaultProps = {
	  x: 0,
	  y: 0,
	  upperWidth: 0,
	  lowerWidth: 0,
	  height: 0,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Trapezoid;
	exports["default"] = _default;

/***/ },
/* 1020 */
[2745, 75],
/* 1021 */
[2748, 176, 296, 1022],
/* 1022 */
192,
/* 1023 */
903,
/* 1024 */
[2755, 80],
/* 1025 */
[2759, 92, 103],
/* 1026 */
223,
/* 1027 */
[2762, 176, 80, 2458],
/* 1028 */
[2767, 80, 103],
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(209);
	
	var floor = Math.floor;
	
	// `IsIntegralNumber` abstract operation
	// https://tc39.es/ecma262/#sec-isintegralnumber
	// eslint-disable-next-line es/no-number-isinteger -- safe
	module.exports = Number.isInteger || function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 1030 */
285,
/* 1031 */
162,
/* 1032 */
/***/ function(module, exports) {

	var log = Math.log;
	var LOG10E = Math.LOG10E;
	
	// eslint-disable-next-line es/no-math-log10 -- safe
	module.exports = Math.log10 || function log10(x) {
	  return log(x) * LOG10E;
	};


/***/ },
/* 1033 */
/***/ function(module, exports) {

	var log = Math.log;
	
	// `Math.log1p` method implementation
	// https://tc39.es/ecma262/#sec-math.log1p
	// eslint-disable-next-line es/no-math-log1p -- safe
	module.exports = Math.log1p || function log1p(x) {
	  var n = +x;
	  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
	};


/***/ },
/* 1034 */
/***/ function(module, exports) {

	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	module.exports = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};


/***/ },
/* 1035 */
[2774, 2475, 2461],
/* 1036 */
[2775, 75],
/* 1037 */
[2782, 1031, 552],
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(297);
	var toString = __webpack_require__(388);
	var requireObjectCoercible = __webpack_require__(386);
	
	var $RangeError = RangeError;
	
	// `String.prototype.repeat` method implementation
	// https://tc39.es/ecma262/#sec-string.prototype.repeat
	module.exports = function repeat(count) {
	  var str = toString(requireObjectCoercible(this));
	  var result = '';
	  var n = toIntegerOrInfinity(count);
	  if (n < 0 || n == Infinity) throw $RangeError('Wrong number of repetitions');
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
	  return result;
	};


/***/ },
/* 1039 */
[2783, 2460, 80],
/* 1040 */
[2789, 547, 209, 548, 2463, 2478, 389],
/* 1041 */
[2790, 1040, 548],
/* 1042 */
[2793, 75],
/* 1043 */
[2794, 1039],
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(2521), __webpack_require__(2520), __webpack_require__(2524), __webpack_require__(2523), __webpack_require__(1045), __webpack_require__(2526)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-array', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Array,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	function initRange(domain, range) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.range(domain); break;
	    default: this.range(range).domain(domain); break;
	  }
	  return this;
	}
	
	function initInterpolator(domain, interpolator) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.interpolator(domain); break;
	    default: this.interpolator(interpolator).domain(domain); break;
	  }
	  return this;
	}
	
	var array = Array.prototype;
	
	var map = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal() {
	  var index = d3Collection.map(),
	      domain = [],
	      range = [],
	      unknown = implicit;
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal(domain, range).unknown(unknown);
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band(domain(), range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return initRange.apply(rescale(), arguments);
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band.apply(null, arguments).paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function identity(x) {
	  return x;
	}
	
	function normalize(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(isNaN(b) ? NaN : 0.5);
	}
	
	function clamper(domain) {
	  var a = domain[0], b = domain[domain.length - 1], t;
	  if (a > b) t = a, a = b, b = t;
	  return function(x) { return Math.max(a, Math.min(b, x)); };
	}
	
	// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
	function bimap(domain, range, interpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, interpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = normalize(domain[i], domain[i + 1]);
	    r[i] = interpolate(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function transformer() {
	  var domain = unit,
	      range = unit,
	      interpolate = d3Interpolate.interpolate,
	      transform,
	      untransform,
	      unknown,
	      clamp = identity,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	  }
	
	  scale.invert = function(y) {
	    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), d3Interpolate.interpolateNumber)))(y)));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map.call(_, number), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t, u) {
	    transform = t, untransform = u;
	    return rescale();
	  };
	}
	
	function continuous(transform, untransform) {
	  return transformer()(transform, untransform);
	}
	
	function tickFormat(start, stop, count, specifier) {
	  var step = d3Array.tickStep(start, stop, count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    var d = domain();
	    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(identity, identity);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return linearish(scale);
	}
	
	function identity$1(domain) {
	  var unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map.call(_, number), scale) : domain.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return identity$1(domain).unknown(unknown);
	  };
	
	  domain = arguments.length ? map.call(domain, number) : [0, 1];
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function transformLog(x) {
	  return Math.log(x);
	}
	
	function transformExp(x) {
	  return Math.exp(x);
	}
	
	function transformLogn(x) {
	  return -Math.log(-x);
	}
	
	function transformExpn(x) {
	  return -Math.exp(-x);
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function loggish(transform) {
	  var scale = transform(transformLog, transformExp),
	      domain = scale.domain,
	      base = 10,
	      logs,
	      pows;
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) {
	      logs = reflect(logs), pows = reflect(pows);
	      transform(transformLogn, transformExpn);
	    } else {
	      transform(transformLog, transformExp);
	    }
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  return scale;
	}
	
	function log() {
	  var scale = loggish(transformer()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy(scale, log()).base(scale.base());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function transformSymlog(c) {
	  return function(x) {
	    return Math.sign(x) * Math.log1p(Math.abs(x / c));
	  };
	}
	
	function transformSymexp(c) {
	  return function(x) {
	    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
	  };
	}
	
	function symlogish(transform) {
	  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
	
	  scale.constant = function(_) {
	    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
	  };
	
	  return linearish(scale);
	}
	
	function symlog() {
	  var scale = symlogish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, symlog()).constant(scale.constant());
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function transformPow(exponent) {
	  return function(x) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  };
	}
	
	function transformSqrt(x) {
	  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
	}
	
	function transformSquare(x) {
	  return x < 0 ? -x * x : x * x;
	}
	
	function powish(transform) {
	  var scale = transform(identity, identity),
	      exponent = 1;
	
	  function rescale() {
	    return exponent === 1 ? transform(identity, identity)
	        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
	        : transform(transformPow(exponent), transformPow(1 / exponent));
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, rescale()) : exponent;
	  };
	
	  return linearish(scale);
	}
	
	function pow() {
	  var scale = powish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, pow()).exponent(scale.exponent());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function sqrt() {
	  return pow.apply(null, arguments).exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [],
	      unknown;
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : range[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1],
	      unknown;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : scale;
	  };
	
	  scale.thresholds = function() {
	    return domain.slice();
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(linearish(scale), arguments);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      unknown,
	      n = 1;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = continuous(identity, identity),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}
	
	function time() {
	  return initRange.apply(calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
	}
	
	function utcTime() {
	  return initRange.apply(calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
	}
	
	function transformer$1() {
	  var x0 = 0,
	      x1 = 1,
	      t0,
	      t1,
	      k10,
	      transform,
	      interpolator = identity,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
	    return scale;
	  };
	}
	
	function copy$1(source, target) {
	  return target
	      .domain(source.domain())
	      .interpolator(source.interpolator())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function sequential() {
	  var scale = linearish(transformer$1()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, sequential());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialLog() {
	  var scale = loggish(transformer$1()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSymlog() {
	  var scale = symlogish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialPow() {
	  var scale = powish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSqrt() {
	  return sequentialPow.apply(null, arguments).exponent(0.5);
	}
	
	function sequentialQuantile() {
	  var domain = [],
	      interpolator = identity;
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return interpolator((d3Array.bisect(domain, x) - 1) / (domain.length - 1));
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return scale;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequentialQuantile(interpolator).domain(domain);
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function transformer$2() {
	  var x0 = 0,
	      x1 = 0.5,
	      x2 = 1,
	      t0,
	      t1,
	      t2,
	      k10,
	      k21,
	      interpolator = identity,
	      transform,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
	    return scale;
	  };
	}
	
	function diverging() {
	  var scale = linearish(transformer$2()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, diverging());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingLog() {
	  var scale = loggish(transformer$2()).domain([0.1, 1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, divergingLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSymlog() {
	  var scale = symlogish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingPow() {
	  var scale = powish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSqrt() {
	  return divergingPow.apply(null, arguments).exponent(0.5);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity$1;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleSymlog = symlog;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	exports.scaleSequentialLog = sequentialLog;
	exports.scaleSequentialPow = sequentialPow;
	exports.scaleSequentialSqrt = sequentialSqrt;
	exports.scaleSequentialSymlog = sequentialSymlog;
	exports.scaleSequentialQuantile = sequentialQuantile;
	exports.scaleDiverging = diverging;
	exports.scaleDivergingLog = divergingLog;
	exports.scaleDivergingPow = divergingPow;
	exports.scaleDivergingSqrt = divergingSqrt;
	exports.scaleDivergingSymlog = divergingSymlog;
	exports.tickFormat = tickFormat;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1046 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1047 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 1048 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var defaultParams = {
	  title: '',
	  text: '',
	  type: null,
	  allowOutsideClick: false,
	  showConfirmButton: true,
	  showCancelButton: false,
	  closeOnConfirm: true,
	  closeOnCancel: true,
	  confirmButtonText: 'OK',
	  confirmButtonColor: '#8CD4F5',
	  cancelButtonText: 'Cancel',
	  imageUrl: null,
	  imageSize: null,
	  timer: null,
	  customClass: '',
	  html: false,
	  animation: true,
	  allowEscapeKey: true,
	  inputType: 'text',
	  inputPlaceholder: '',
	  inputValue: '',
	  showLoaderOnConfirm: false
	};
	
	exports['default'] = defaultParams;
	module.exports = exports['default'];

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/LandingPageLogo2.c0505ab1.png";

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/New MG Logo (Dark BG) (1).6786de9c.png";

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/answers-profile-pic-1.a6a44d28.png";

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/answers-profile-pic-2.9fea5e9e.png";

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/answers-profile-pic-3.77576b15.png";

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/answers-profile-pic-4.6bd9bd47.png";

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/finance-capital-structure.e3e6b231.mp4";

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/finance-debt-to-capital.b7974f87.mp4";

/***/ },
/* 1057 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAImSURBVHgBnVRRbtpAEJ1ZO5EKpKInKJyg9AbpCXD+UkokcoFSnwA4gUnofyIV2v7VnID0Btyg7glAKiRSk53pztqmBNlA8qT1Wrs7b9/MzgxCDrxgVj4Cx2PHrSNzjQEqydYUECPSNP7ql66zbDFr8X2w9FzFVwxYhi0wxpEm7m2Sq82DZ5e3gaPghyVkvmFi/4FUddguogwifmvGudmPRL1SeNUc3HU2LvuP5mDZAYKu+Z0bst7IL/VhCz4Ei0+oUAjLjNgffSz4j0gbwaIltwqhUfLOuDSFPWDsasZuIsRA+mTovwxXpGcXy1/ijri7S2GO4kAEufS3iusqJU6jdqGaZSiXyvylXczcb14uJsB4LPG2D6UcrMvMRL0cMSbUaEceWMNYZgT03HiFK0l4c+OY50EKDU7oAgVKwZskpbAm322PI+6nIcjCd/9FZPWZd3FhT6xV1E5YpVIZMjc+82t4JiS1kt+pJWWMY4n3yxN4PiwpE/yOSTX/tKSOqudZxGWJUd6+E1eWOcdx8rdMR3pQh/IIZSY0yV94UvI3B7dtIO6neW6VXvuvpDTjulXcWYvPTjSCWc10ma5VmeT5qksR3N+YaS5qzWJrH0JR6KiDie1oBKsWaFPqNJhVDtSh2TTuGxc0qFz3T4O7igPas/EnPmbJHeKLoV/qpmdsTNNmAk/HXBOcf/OL4fqiVSo1jZLeewAZpDlPkfX4DxyFoY/zzTP/AEDF/Ox5ZkXGAAAAAElFTkSuQmCC"

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-successful-teams3.0b876561.png";

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/new-map-without-buttons.e33fd78a.png";

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-conduct-research.32370f35.png";

/***/ },
/* 1061 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgB7ZTRDQIhDIaLcQBHwA0cwRXcwFFuE3UEJzg3cARuA2+DWgwkBGmlwpPelzRHoOUvlB7A34CIG7IT2QPfuft1aCUISLQJhVNEbDJvuwklmzlm3l+hUwsxNeBEXBjrhLBcA1dIJJ7EqoQwqwEy1xV8R+QZU99VFhszmIwxE8gcyC7MmpVEqqEkZrKjSaDpbcn3axENi0hXkTl8/dO28JldFvdiLUX4F0Sb32i4J3M0hkqu7Eqp+UKDnrEO/wcYQELq8Bb/vCZdalCT3Yh6Bo1G/xr8FE+IewexAYraNAAAAABJRU5ErkJggg=="

/***/ },
/* 1062 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADWSURBVHgB3ZK7CsJAEEXvTmRFXBSFgC+0ECxSKWphIfgNgt9saZXOSkVSRQwRQfCRiCyJmaBl9FSzpxh2Lhf4WwzWWpZEvjtCsWPA3x61b0wGUB0Zcy9y7KJDoQZBFsS9Frw2T2eOg1n0QTdfu4+LKmcHnrRxJUc78+TCK9vB5OInEKw1LQWjNAUJB/vlKtVFIHZRrlAFURhuW7s8ZMJ9RX3YhjlTCVeaVJEdwqKmwDc7DLbcW0A1W/B3a+0ulXnMReDDRlEFrZasI0r9FU94xvspnMssD86HLt9WotS3AAAAAElFTkSuQmCC"

/***/ },
/* 1063 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALTSURBVHgBlVXNUhpBEO6eWRAPsXyE9ZayglnfQA+Jm1yiRzVGeAL0CcQniDwBUAo5yilSyQHfwEUSK8d9g3AKP2G30z2wVlhB4Kui2J3Z+abn6/56EGZgvfLG0aAdCsGWd1TgBxB4D4ffvefW4aRBu7i1upJK5SigE0BcnbLWR60uVOdP2cvetmcSv7p0tziqovADUTsErGmgJhH5BKqtkBwCdADow2hTn0+T/XFUv51KvFF1j4mgJM8EVLD6vfykaATOF9ceDCDDQZwZIoTM/UG9/IR4FGlDoiTCvXgE07Beee9oChoSPUe+Ha0zxKLpi2TqTh41qE3v8KsHC+AxKJZF97ubckolEyuJ5YyQ8o7ni5IKJEoKsSAcAyt1ImOGmJByHHzbsob6zoIcP111G+nqu91ozBp08iIjKszJO64XuU6TWmQotQ7r2VmkL4uunUiaYwN/v/b/XPrKLbG4x1znm4pJHRkMCZswB5hUqsDWCrbjcyHQUMZAO5Y4ioUHJBrTNn35dpcN8JlnCvcHNxcytlHZyRFAhoM4be3f+HFixbUudacQbBUNog7HHNY6+lYjKX6CMzm+/NgYskHp58fhRnGIgaJnS7xvjhFqO/6h7nX3Ai7DZBKv2TDGZSzBOUwBF4GDLHJI4KugHxgJ2Kqv4x9KPYpdmVTyIOWY9fbr/jRihTjk0IFnDJK+2vktbUv3O2uTLMwGyBNie5oEAlMtCbpjjdtSLZY5AmEBkc6CpWXJ+Gl8ERsgDzOQTMExm2QVEY1UJnnWoCuR+LzDidgTFoQYhmXKC4fqdUqPxJGW8szOuZbmPi+pBGKaEMPkYCTlWNtMV9wM/xWHG0C+34Xyr+zkZJnLgKXjPm16QxBA9uFTvRTNz2z0nIwam6fJpvBQs4ZhaJNkn2h37kYfweFo/iaWMlw+ObPBJAz7dkHyM9fVFIdp5BDGLlPFl+nz7fUfIQdZ7xkO18AAAAAASUVORK5CYII="

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf28.c76ec9b5.png";

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/share-buyback.a8a45b9f.png";

/***/ },
/* 1066 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADwSURBVHgB7ZSxEYIwFED/RwdwBEuPjg3QRbRVKycwbEAj2rKIOAIVWDICE+RLTrhLuAskhJLXQXLvXXL/ArAwAsofu/B6XCGPCWAD06g4eez7eaTdD09e9ZAzB7lg2zhixdnfAO5shgJTyXULzgECSovsGQBRNHtAyMvsdWpVNGtAlvvh5Q5IzCpAgLmrXB9AisosCYTIRa4PtPcpRHLEVq4PEDH/0AikyBS5QHkq/P1ZnQREVrwTZfxM5M3Y4vAJOqSTmMr7rEd3/CMAHMBWbhZoI+plmjPXW2QcqMGRZkoqbYAT3fobLKlJ8+gtaPkBNBeCDC9u4AUAAAAASUVORK5CYII="

/***/ },
/* 1067 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACFSURBVHgB7ZXBDUBAEEX/ijt3ohA6UQkVUIlOKEQirjRgGIlkdx1kVyQO827zd3b+nP4AwgPKqNKixEbNoUbwY8SmWsx9dwmB8UxUvRjOZMf/RhfCWwMzDTF8SPIFiowFA3yMGIiBGIjBHwzMNCWsZ1xzKvoz6oV1D1RtNzjBC/LBEVzYAWaNGXpMiKJjAAAAAElFTkSuQmCC"

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (typeof Promise === "undefined") {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(2071).enable();
	  window.Promise = __webpack_require__(2070);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2685);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(45);
	
	if (!Array.prototype.includes) {
	  Object.defineProperty(Array.prototype, "includes", {
	    value: function(searchElement, fromIndex) {
	      // 1. Let O be ? ToObject(this value).
	      if (this == null) {
	        throw new TypeError('"this" is null or not defined');
	      }
	
	      var o = Object(this);
	
	      // 2. Let len be ? ToLength(? Get(O, "length")).
	      var len = o.length >>> 0;
	
	      // 3. If len is 0, return false.
	      if (len === 0) {
	        return false;
	      }
	
	      // 4. Let n be ? ToInteger(fromIndex).
	      //    (If fromIndex is undefined, this step produces the value 0.)
	      var n = fromIndex | 0;
	
	      // 5. If n ≥ 0, then
	      //  a. Let k be n.
	      // 6. Else n < 0,
	      //  a. Let k be len + n.
	      //  b. If k < 0, let k be 0.
	      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	      function sameValueZero(x, y) {
	        return (
	          x === y ||
	          (typeof x === "number" &&
	            typeof y === "number" &&
	            isNaN(x) &&
	            isNaN(y))
	        );
	      }
	
	      // 7. Repeat, while k < len
	      while (k < len) {
	        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
	        // b. If SameValueZero(searchElement, elementK) is true, return true.
	        // c. Increase k by 1.
	        if (sameValueZero(o[k], searchElement)) {
	          return true;
	        }
	        k++;
	      }
	
	      // 8. Return false
	      return false;
	    }
	  });
	}


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1071);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1070 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1071 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1072 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var connectionStore = new WeakMap();
	var ITERATION_KEY = Symbol('iteration key');
	
	function storeObservable(obj) {
	  // this will be used to save (obj.key -> reaction) connections later
	  connectionStore.set(obj, new Map());
	}
	
	function registerReactionForOperation(reaction, ref) {
	  var target = ref.target;
	  var key = ref.key;
	  var type = ref.type;
	
	  if (type === 'iterate') {
	    key = ITERATION_KEY;
	  }
	
	  var reactionsForObj = connectionStore.get(target);
	  var reactionsForKey = reactionsForObj.get(key);
	  if (!reactionsForKey) {
	    reactionsForKey = new Set();
	    reactionsForObj.set(key, reactionsForKey);
	  }
	  // save the fact that the key is used by the reaction during its current run
	  if (!reactionsForKey.has(reaction)) {
	    reactionsForKey.add(reaction);
	    reaction.cleaners.push(reactionsForKey);
	  }
	}
	
	function getReactionsForOperation(ref) {
	  var target = ref.target;
	  var key = ref.key;
	  var type = ref.type;
	
	  var reactionsForTarget = connectionStore.get(target);
	  var reactionsForKey = new Set();
	
	  if (type === 'clear') {
	    reactionsForTarget.forEach(function (_, key) {
	      addReactionsForKey(reactionsForKey, reactionsForTarget, key);
	    });
	  } else {
	    addReactionsForKey(reactionsForKey, reactionsForTarget, key);
	  }
	
	  if (type === 'add' || type === 'delete' || type === 'clear') {
	    var iterationKey = Array.isArray(target) ? 'length' : ITERATION_KEY;
	    addReactionsForKey(reactionsForKey, reactionsForTarget, iterationKey);
	  }
	
	  return reactionsForKey;
	}
	
	function addReactionsForKey(reactionsForKey, reactionsForTarget, key) {
	  var reactions = reactionsForTarget.get(key);
	  reactions && reactions.forEach(reactionsForKey.add, reactionsForKey);
	}
	
	function releaseReaction(reaction) {
	  if (reaction.cleaners) {
	    reaction.cleaners.forEach(releaseReactionKeyConnection, reaction);
	  }
	  reaction.cleaners = [];
	}
	
	function releaseReactionKeyConnection(reactionsForKey) {
	  reactionsForKey.delete(this);
	}
	
	// reactions can call each other and form a call stack
	var reactionStack = [];
	var isDebugging = false;
	
	function runAsReaction(reaction, fn, context, args) {
	  // do not build reactive relations, if the reaction is unobserved
	  if (reaction.unobserved) {
	    return Reflect.apply(fn, context, args);
	  }
	
	  // only run the reaction if it is not already in the reaction stack
	  // TODO: improve this to allow explicitly recursive reactions
	  if (reactionStack.indexOf(reaction) === -1) {
	    // release the (obj -> key -> reactions) connections
	    // and reset the cleaner connections
	    releaseReaction(reaction);
	
	    try {
	      // set the reaction as the currently running one
	      // this is required so that we can create (observable.prop -> reaction) pairs in the get trap
	      reactionStack.push(reaction);
	      return Reflect.apply(fn, context, args);
	    } finally {
	      // always remove the currently running flag from the reaction when it stops execution
	      reactionStack.pop();
	    }
	  }
	}
	
	// register the currently running reaction to be queued again on obj.key mutations
	function registerRunningReactionForOperation(operation) {
	  // get the current reaction from the top of the stack
	  var runningReaction = reactionStack[reactionStack.length - 1];
	  if (runningReaction) {
	    debugOperation(runningReaction, operation);
	    registerReactionForOperation(runningReaction, operation);
	  }
	}
	
	function queueReactionsForOperation(operation) {
	  // iterate and queue every reaction, which is triggered by obj.key mutation
	  getReactionsForOperation(operation).forEach(queueReaction, operation);
	}
	
	function queueReaction(reaction) {
	  debugOperation(reaction, this);
	  // queue the reaction for later execution or run it immediately
	  if (typeof reaction.scheduler === 'function') {
	    reaction.scheduler(reaction);
	  } else if (typeof reaction.scheduler === 'object') {
	    reaction.scheduler.add(reaction);
	  } else {
	    reaction();
	  }
	}
	
	function debugOperation(reaction, operation) {
	  if (reaction.debugger && !isDebugging) {
	    try {
	      isDebugging = true;
	      reaction.debugger(operation);
	    } finally {
	      isDebugging = false;
	    }
	  }
	}
	
	function hasRunningReaction() {
	  return reactionStack.length > 0;
	}
	
	var IS_REACTION = Symbol('is reaction');
	
	function observe(fn, options) {
	  if ( options === void 0 ) options = {};
	
	  // wrap the passed function in a reaction, if it is not already one
	  var reaction = fn[IS_REACTION] ? fn : function reaction() {
	    return runAsReaction(reaction, fn, this, arguments);
	  };
	  // save the scheduler and debugger on the reaction
	  reaction.scheduler = options.scheduler;
	  reaction.debugger = options.debugger;
	  // save the fact that this is a reaction
	  reaction[IS_REACTION] = true;
	  // run the reaction once if it is not a lazy one
	  if (!options.lazy) {
	    reaction();
	  }
	  return reaction;
	}
	
	function unobserve(reaction) {
	  // do nothing, if the reaction is already unobserved
	  if (!reaction.unobserved) {
	    // indicate that the reaction should not be triggered any more
	    reaction.unobserved = true;
	    // release (obj -> key -> reaction) connections
	    releaseReaction(reaction);
	  }
	  // unschedule the reaction, if it is scheduled
	  if (typeof reaction.scheduler === 'object') {
	    reaction.scheduler.delete(reaction);
	  }
	}
	
	var proxyToRaw = new WeakMap();
	var rawToProxy = new WeakMap();
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function findObservable(obj) {
	  var observableObj = rawToProxy.get(obj);
	  if (hasRunningReaction() && typeof obj === 'object' && obj !== null) {
	    if (observableObj) {
	      return observableObj;
	    }
	    return observable(obj);
	  }
	  return observableObj || obj;
	}
	
	function patchIterator(iterator, isEntries) {
	  var originalNext = iterator.next;
	  iterator.next = function () {
	    var ref = originalNext.call(iterator);
	    var done = ref.done;
	    var value = ref.value;
	    if (!done) {
	      if (isEntries) {
	        value[1] = findObservable(value[1]);
	      } else {
	        value = findObservable(value);
	      }
	    }
	    return { done: done, value: value };
	  };
	  return iterator;
	}
	
	var instrumentations = {
	  has: function has(key) {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, key: key, type: 'has' });
	    return proto.has.apply(target, arguments);
	  },
	  get: function get(key) {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, key: key, type: 'get' });
	    return findObservable(proto.get.apply(target, arguments));
	  },
	  add: function add(key) {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    var hadKey = proto.has.call(target, key);
	    // forward the operation before queueing reactions
	    var result = proto.add.apply(target, arguments);
	    if (!hadKey) {
	      queueReactionsForOperation({ target: target, key: key, value: key, type: 'add' });
	    }
	    return result;
	  },
	  set: function set(key, value) {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    var hadKey = proto.has.call(target, key);
	    var oldValue = proto.get.call(target, key);
	    // forward the operation before queueing reactions
	    var result = proto.set.apply(target, arguments);
	    if (!hadKey) {
	      queueReactionsForOperation({ target: target, key: key, value: value, type: 'add' });
	    } else if (value !== oldValue) {
	      queueReactionsForOperation({ target: target, key: key, value: value, oldValue: oldValue, type: 'set' });
	    }
	    return result;
	  },
	  delete: function delete$1(key) {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    var hadKey = proto.has.call(target, key);
	    var oldValue = proto.get ? proto.get.call(target, key) : undefined;
	    // forward the operation before queueing reactions
	    var result = proto.delete.apply(target, arguments);
	    if (hadKey) {
	      queueReactionsForOperation({ target: target, key: key, oldValue: oldValue, type: 'delete' });
	    }
	    return result;
	  },
	  clear: function clear() {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    var hadItems = target.size !== 0;
	    var oldTarget = target instanceof Map ? new Map(target) : new Set(target);
	    // forward the operation before queueing reactions
	    var result = proto.clear.apply(target, arguments);
	    if (hadItems) {
	      queueReactionsForOperation({ target: target, oldTarget: oldTarget, type: 'clear' });
	    }
	    return result;
	  },
	  forEach: function forEach(cb) {
	    var args = [], len = arguments.length - 1;
	    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
	
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, type: 'iterate' });
	    // swap out the raw values with their observable pairs
	    // before passing them to the callback
	    var wrappedCb = function (value) {
	      var rest = [], len = arguments.length - 1;
	      while ( len-- > 0 ) rest[ len ] = arguments[ len + 1 ];
	
	      return cb.apply(void 0, [ findObservable(value) ].concat( rest ));
	    };
	    return (ref = proto.forEach).call.apply(ref, [ target, wrappedCb ].concat( args ));
	    var ref;
	  },
	  keys: function keys() {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, type: 'iterate' });
	    return proto.keys.apply(target, arguments);
	  },
	  values: function values() {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, type: 'iterate' });
	    var iterator = proto.values.apply(target, arguments);
	    return patchIterator(iterator, false);
	  },
	  entries: function entries() {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, type: 'iterate' });
	    var iterator = proto.entries.apply(target, arguments);
	    return patchIterator(iterator, true);
	  },
	  get size() {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, type: 'iterate' });
	    return Reflect.get(proto, 'size', target);
	  }
	};
	instrumentations[Symbol.iterator] = function () {
	    var target = proxyToRaw.get(this);
	    var proto = Reflect.getPrototypeOf(this);
	    registerRunningReactionForOperation({ target: target, type: 'iterate' });
	    var iterator = proto[Symbol.iterator].apply(target, arguments);
	    return patchIterator(iterator, target instanceof Map);
	  };
	
	var collectionHandlers = {
	  get: function get(target, key, receiver) {
	    // instrument methods and property accessors to be reactive
	    target = hasOwnProperty.call(instrumentations, key) ? instrumentations : target;
	    return Reflect.get(target, key, receiver);
	  }
	};
	
	// eslint-disable-next-line
	var globalObj = typeof window === 'object' ? window : Function('return this')();
	
	// built-in object can not be wrapped by Proxies
	// their methods expect the object instance as the 'this' instead of the Proxy wrapper
	// complex objects are wrapped with a Proxy of instrumented methods
	// which switch the proxy to the raw object and to add reactive wiring
	var handlers = new Map([[Map, collectionHandlers], [Set, collectionHandlers], [WeakMap, collectionHandlers], [WeakSet, collectionHandlers], [Object, false], [Array, false], [Int8Array, false], [Uint8Array, false], [Uint8ClampedArray, false], [Int16Array, false], [Uint16Array, false], [Int32Array, false], [Uint32Array, false], [Float32Array, false], [Float64Array, false]]);
	
	function shouldInstrument(ref) {
	  var constructor = ref.constructor;
	
	  var isBuiltIn = typeof constructor === 'function' && constructor.name in globalObj && globalObj[constructor.name] === constructor;
	  return !isBuiltIn || handlers.has(constructor);
	}
	
	function getHandlers(obj) {
	  return handlers.get(obj.constructor);
	}
	
	var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	var wellKnownSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function (key) { return Symbol[key]; }).filter(function (value) { return typeof value === 'symbol'; }));
	
	// intercept get operations on observables to know which reaction uses their properties
	function get(target, key, receiver) {
	  var result = Reflect.get(target, key, receiver);
	  // do not register (observable.prop -> reaction) pairs for well known symbols
	  // these symbols are frequently retrieved in low level JavaScript under the hood
	  if (typeof key === 'symbol' && wellKnownSymbols.has(key)) {
	    return result;
	  }
	  // register and save (observable.prop -> runningReaction)
	  registerRunningReactionForOperation({ target: target, key: key, receiver: receiver, type: 'get' });
	  // if we are inside a reaction and observable.prop is an object wrap it in an observable too
	  // this is needed to intercept property access on that object too (dynamic observable tree)
	  var observableResult = rawToProxy.get(result);
	  if (hasRunningReaction() && typeof result === 'object' && result !== null) {
	    if (observableResult) {
	      return observableResult;
	    }
	    // do not violate the none-configurable none-writable prop get handler invariant
	    // fall back to none reactive mode in this case, instead of letting the Proxy throw a TypeError
	    var descriptor = Reflect.getOwnPropertyDescriptor(target, key);
	    if (!descriptor || !(descriptor.writable === false && descriptor.configurable === false)) {
	      return observable(result);
	    }
	  }
	  // otherwise return the observable wrapper if it is already created and cached or the raw object
	  return observableResult || result;
	}
	
	function has(target, key) {
	  var result = Reflect.has(target, key);
	  // register and save (observable.prop -> runningReaction)
	  registerRunningReactionForOperation({ target: target, key: key, type: 'has' });
	  return result;
	}
	
	function ownKeys(target) {
	  registerRunningReactionForOperation({ target: target, type: 'iterate' });
	  return Reflect.ownKeys(target);
	}
	
	// intercept set operations on observables to know when to trigger reactions
	function set(target, key, value, receiver) {
	  // make sure to do not pollute the raw object with observables
	  if (typeof value === 'object' && value !== null) {
	    value = proxyToRaw.get(value) || value;
	  }
	  // save if the object had a descriptor for this key
	  var hadKey = hasOwnProperty$1.call(target, key);
	  // save if the value changed because of this set operation
	  var oldValue = target[key];
	  // execute the set operation before running any reaction
	  var result = Reflect.set(target, key, value, receiver);
	  // do not queue reactions if the target of the operation is not the raw receiver
	  // (possible because of prototypal inheritance)
	  if (target !== proxyToRaw.get(receiver)) {
	    return result;
	  }
	  // queue a reaction if it's a new property or its value changed
	  if (!hadKey) {
	    queueReactionsForOperation({ target: target, key: key, value: value, receiver: receiver, type: 'add' });
	  } else if (value !== oldValue) {
	    queueReactionsForOperation({
	      target: target,
	      key: key,
	      value: value,
	      oldValue: oldValue,
	      receiver: receiver,
	      type: 'set'
	    });
	  }
	  return result;
	}
	
	function deleteProperty(target, key) {
	  // save if the object had the key
	  var hadKey = hasOwnProperty$1.call(target, key);
	  var oldValue = target[key];
	  // execute the delete operation before running any reaction
	  var result = Reflect.deleteProperty(target, key);
	  // only queue reactions for delete operations which resulted in an actual change
	  if (hadKey) {
	    queueReactionsForOperation({ target: target, key: key, oldValue: oldValue, type: 'delete' });
	  }
	  return result;
	}
	
	var baseHandlers = { get: get, has: has, ownKeys: ownKeys, set: set, deleteProperty: deleteProperty };
	
	function observable(obj) {
	  if ( obj === void 0 ) obj = {};
	
	  // if it is already an observable or it should not be wrapped, return it
	  if (proxyToRaw.has(obj) || !shouldInstrument(obj)) {
	    return obj;
	  }
	  // if it already has a cached observable wrapper, return it
	  // otherwise create a new observable
	  return rawToProxy.get(obj) || createObservable(obj);
	}
	
	function createObservable(obj) {
	  // if it is a complex built-in object or a normal object, wrap it
	  var handlers = getHandlers(obj) || baseHandlers;
	  var observable = new Proxy(obj, handlers);
	  // save these to switch between the raw object and the wrapped object with ease later
	  rawToProxy.set(obj, observable);
	  proxyToRaw.set(observable, obj);
	  // init basic data structures to save and cleanup later (observable.prop -> reaction) connections
	  storeObservable(obj);
	  return observable;
	}
	
	function isObservable(obj) {
	  return proxyToRaw.has(obj);
	}
	
	function raw(obj) {
	  return proxyToRaw.get(obj) || obj;
	}
	
	exports.observe = observe;
	exports.unobserve = unobserve;
	exports.observable = observable;
	exports.isObservable = isObservable;
	exports.raw = raw;


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var reactDom = __webpack_require__(49);
	
	
	
	Object.keys(reactDom).forEach(function (k) {
		if (k !== 'default') Object.defineProperty(exports, k, {
			enumerable: true,
			get: function () {
				return reactDom[k];
			}
		});
	});


/***/ },
/* 1074 */
/***/ function(module, exports) {

	/* The following list is defined in React's core */
	var IS_UNITLESS = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	module.exports = function(name, value) {
	  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
	    return value + 'px';
	  } else {
	    return value;
	  }
	};

/***/ },
/* 1075 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitSupportMessage = undefined;
	
	var _ApiService = __webpack_require__(4);
	
	// POST /api/account/contact-support/
	// See guidance/contact-support-fe-guide.md for the full BE contract.
	//
	// Returns a Promise that resolves to { sent: boolean } on success or
	// rejects with the superagent error (err.status is the HTTP status,
	// err.response.body carries the DRF error shape for 400s and the
	// { detail } string for 429s).
	var submitSupportMessage = exports.submitSupportMessage = function submitSupportMessage(_ref) {
	  var subject = _ref.subject,
	      message = _ref.message;
	
	  var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	  return (0, _ApiService.postRequest)(apiUrl + 'account/contact-support/').send({ subject: subject, message: message }).then(function (res) {
	    return res && res.body || { sent: false };
	  });
	};

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOGOUT_CHECK_INTERVAL = 1000; // 1 second
	var LOGOUT_TIMEOUT = 600000; // 10 minutes
	var STORE_KEY = "lastAction";
	
	var EVENTS = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mouseWheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "click", "mouseover", "mouseout", "keyup", "keypress"];
	
	var AutoLogout = function (_Component) {
	  _inherits(AutoLogout, _Component);
	
	  function AutoLogout(props) {
	    _classCallCheck(this, AutoLogout);
	
	    var _this = _possibleConstructorReturn(this, (AutoLogout.__proto__ || Object.getPrototypeOf(AutoLogout)).call(this, props));
	
	    _this.setLastActive = function (last_active) {
	      sessionStorage.setItem(STORE_KEY, last_active.toString());
	    };
	
	    _this.getLastActive = function () {
	      return parseInt(sessionStorage.getItem(STORE_KEY), 10);
	    };
	
	    _this.checkForLocalhost = function () {
	      if (window) {
	        var _window = window,
	            location = _window.location;
	
	        if (location) {
	          var hostname = location.hostname,
	              port = location.port;
	
	
	          if (hostname && hostname.toLowerCase() === "localhost" && port && port + "" === "3000") {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    };
	
	    _this.handleEvent = function (e) {
	      var _this$state = _this.state,
	          pageX = _this$state.pageX,
	          pageY = _this$state.pageY;
	
	
	      if (e.type === "mousemove") {
	        if (e.pageX === pageX && e.pageY === pageY) {
	          return;
	        }
	
	        if (typeof e.pageX === "undefined" && typeof e.pageY === "undefined") {
	          return;
	        }
	
	        if (_this.getStartDelay() < 200) {
	          return;
	        }
	      }
	
	      clearTimeout(_this.tId);
	
	      _this.setLastActive(+new Date());
	
	      _this.setState({
	        pageX: e.pageX,
	        pageY: e.pageY
	      });
	
	      _this.tId = setTimeout(_this.logout, LOGOUT_CHECK_INTERVAL);
	    };
	
	    _this.logout = function () {
	      if (_this.getElapsedTime() >= LOGOUT_TIMEOUT) {
	        clearTimeout(_this.tId);
	
	        if (_Auth2.default.isUserAuthenticated()) {
	          _Auth2.default.deauthenticateUser();
	        }
	
	        window.location.href = "/login";
	
	        return;
	      }
	
	      clearTimeout(_this.tId);
	      _this.tId = setTimeout(_this.logout, LOGOUT_CHECK_INTERVAL);
	    };
	
	    _this.reset = function () {
	      var initializeTime = _this.state.initializeTime;
	
	
	      clearTimeout(_this.tId);
	
	      _this.setLastActive(initializeTime);
	
	      _this.setState({
	        initializeTime: +new Date()
	      });
	
	      _this.tId = setTimeout(_this.logout, LOGOUT_CHECK_INTERVAL);
	    };
	
	    _this.getElapsedTime = function () {
	      return +new Date() - _this.getLastActive();
	    };
	
	    _this.getStartDelay = function () {
	      var initializeTime = _this.state.initializeTime;
	
	
	      return +new Date() - initializeTime;
	    };
	
	    _this.state = {
	      initializeTime: +new Date(),
	      pageX: null,
	      pageY: null
	    };
	
	    _this.tId = null;
	    return _this;
	  }
	
	  _createClass(AutoLogout, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (this.checkForLocalhost() === false) {
	        this.setLastActive(+new Date());
	        EVENTS.forEach(function (e) {
	          return document.addEventListener(e, _this2.handleEvent);
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.checkForLocalhost() === false) {
	        this.reset();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (this.checkForLocalhost() === false) {
	        clearTimeout(this.tId);
	        sessionStorage.removeItem(STORE_KEY);
	        EVENTS.forEach(function (e) {
	          return document.removeEventListener(e, _this3.handleEvent);
	        });
	      }
	    }
	  }]);
	
	  return AutoLogout;
	}(_react.Component);
	
	exports.default = AutoLogout;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  margin: 24px 50px;\n  width: calc(100% - 100px);\n  font-family: Lato;\n  line-height: 100%;\n"], ["\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  margin: 24px 50px;\n  width: calc(100% - 100px);\n  font-family: Lato;\n  line-height: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n  width: 27px;\n"], ["\n  margin-bottom: 24px;\n  width: 27px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 32px;\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 32px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-size: 18px;\n"], ["\n  font-size: 18px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _lodash = __webpack_require__(21);
	
	var _recompose = __webpack_require__(55);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _utils = __webpack_require__(18);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils2 = __webpack_require__(53);
	
	var _styles = __webpack_require__(68);
	
	var _Paper = __webpack_require__(304);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Menu = __webpack_require__(1103);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _TeamReports = __webpack_require__(1112);
	
	var _TeamReports2 = _interopRequireDefault(_TeamReports);
	
	var _GradesRanks = __webpack_require__(1089);
	
	var _GradesRanks2 = _interopRequireDefault(_GradesRanks);
	
	var _MarketShare = __webpack_require__(1094);
	
	var _MarketShare2 = _interopRequireDefault(_MarketShare);
	
	var _Revenues = __webpack_require__(1109);
	
	var _Revenues2 = _interopRequireDefault(_Revenues);
	
	var _GrossMargins = __webpack_require__(1090);
	
	var _GrossMargins2 = _interopRequireDefault(_GrossMargins);
	
	var _SharePrice = __webpack_require__(1110);
	
	var _SharePrice2 = _interopRequireDefault(_SharePrice);
	
	var _EarningsPerShare = __webpack_require__(1084);
	
	var _EarningsPerShare2 = _interopRequireDefault(_EarningsPerShare);
	
	var _ReturnOnAssets = __webpack_require__(1107);
	
	var _ReturnOnAssets2 = _interopRequireDefault(_ReturnOnAssets);
	
	var _ReturnOnEquity = __webpack_require__(1108);
	
	var _ReturnOnEquity2 = _interopRequireDefault(_ReturnOnEquity);
	
	var _FPA = __webpack_require__(1085);
	
	var _FPA2 = _interopRequireDefault(_FPA);
	
	var _FPAIncomeStatement = __webpack_require__(1086);
	
	var _FPAIncomeStatement2 = _interopRequireDefault(_FPAIncomeStatement);
	
	var _LeadTime = __webpack_require__(1093);
	
	var _LeadTime2 = _interopRequireDefault(_LeadTime);
	
	var _MarketingAnalysis = __webpack_require__(1095);
	
	var _MarketingAnalysis2 = _interopRequireDefault(_MarketingAnalysis);
	
	var _MarketingAnalysis3 = __webpack_require__(1096);
	
	var _MarketingAnalysis4 = _interopRequireDefault(_MarketingAnalysis3);
	
	var _MarketingNoUnitsSold = __webpack_require__(1099);
	
	var _MarketingNoUnitsSold2 = _interopRequireDefault(_MarketingNoUnitsSold);
	
	var _MarketingNoUnitsSold3 = __webpack_require__(1100);
	
	var _MarketingNoUnitsSold4 = _interopRequireDefault(_MarketingNoUnitsSold3);
	
	var _MarketingPositioning = __webpack_require__(1101);
	
	var _MarketingPositioning2 = _interopRequireDefault(_MarketingPositioning);
	
	var _MarketingSellingPrice = __webpack_require__(1102);
	
	var _MarketingSellingPrice2 = _interopRequireDefault(_MarketingSellingPrice);
	
	var _MarketingAwareness = __webpack_require__(1097);
	
	var _MarketingAwareness2 = _interopRequireDefault(_MarketingAwareness);
	
	var _MarketingChannelSpend = __webpack_require__(1098);
	
	var _MarketingChannelSpend2 = _interopRequireDefault(_MarketingChannelSpend);
	
	var _OperationalAnalysis = __webpack_require__(1106);
	
	var _OperationalAnalysis2 = _interopRequireDefault(_OperationalAnalysis);
	
	var _UnitCosts = __webpack_require__(1113);
	
	var _UnitCosts2 = _interopRequireDefault(_UnitCosts);
	
	var _UnitCosts3 = __webpack_require__(1114);
	
	var _UnitCosts4 = _interopRequireDefault(_UnitCosts3);
	
	var _InventoryManagement = __webpack_require__(1092);
	
	var _InventoryManagement2 = _interopRequireDefault(_InventoryManagement);
	
	var _OAFinancialImpact = __webpack_require__(1104);
	
	var _OAFinancialImpact2 = _interopRequireDefault(_OAFinancialImpact);
	
	var _FinancingAnalysis = __webpack_require__(1088);
	
	var _FinancingAnalysis2 = _interopRequireDefault(_FinancingAnalysis);
	
	var _CapitalStructure = __webpack_require__(1080);
	
	var _CapitalStructure2 = _interopRequireDefault(_CapitalStructure);
	
	var _CostOfDebt = __webpack_require__(1083);
	
	var _CostOfDebt2 = _interopRequireDefault(_CostOfDebt);
	
	var _ImpactOfDebt = __webpack_require__(1091);
	
	var _ImpactOfDebt2 = _interopRequireDefault(_ImpactOfDebt);
	
	var _CostOfCapital = __webpack_require__(1082);
	
	var _CostOfCapital2 = _interopRequireDefault(_CostOfCapital);
	
	var _Valuation = __webpack_require__(1115);
	
	var _Valuation2 = _interopRequireDefault(_Valuation);
	
	var _Shares = __webpack_require__(1111);
	
	var _Shares2 = _interopRequireDefault(_Shares);
	
	var _FinancialStatements = __webpack_require__(1087);
	
	var _FinancialStatements2 = _interopRequireDefault(_FinancialStatements);
	
	var _IncomeStatement = __webpack_require__(395);
	
	var _IncomeStatement2 = _interopRequireDefault(_IncomeStatement);
	
	var _BalanceSheet = __webpack_require__(1079);
	
	var _BalanceSheet2 = _interopRequireDefault(_BalanceSheet);
	
	var _CashFlows = __webpack_require__(1081);
	
	var _CashFlows2 = _interopRequireDefault(_CashFlows);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _iconLock = __webpack_require__(333);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var RoundLockedScreen = {};
	RoundLockedScreen.Wrapper = _styledComponents2.default.div(_templateObject);
	RoundLockedScreen.Image = _styledComponents2.default.img(_templateObject2);
	RoundLockedScreen.Title = _styledComponents2.default.h2(_templateObject3);
	RoundLockedScreen.Text = _styledComponents2.default.h3(_templateObject4);
	
	var CrumbSeparator = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    "span",
	    {
	      style: {
	        marginLeft: "1ch",
	        marginRight: "1ch",
	        fontSize: "12px",
	        fontFamily: _styles.fontFamily,
	        color: "#828282"
	      }
	    },
	    ">"
	  );
	});
	
	var BreadCrumbs = (0, _recompose.pure)(function (_ref) {
	  var crumbs = _ref.crumbs;
	  return _react2.default.createElement(
	    "div",
	    { style: { marginTop: "1em", marginBottom: "1em" } },
	    (0, _lodash.flatten)((0, _lodash.map)(crumbs, function (_ref2, index) {
	      var location = _ref2.location,
	          label = _ref2.label;
	      return [index !== 0 ? _react2.default.createElement(CrumbSeparator, { key: location + ":" + label + "-sep" }) : null, _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: location,
	          style: { fontSize: "12px", fontFamily: _styles.fontFamily, color: "#828282" },
	          key: location + ":" + label
	        },
	        label
	      )];
	    }))
	  );
	});
	
	// Remaining API calls not covered by team-decisions or financial-statements
	var APICalls = function APICalls(gameId) {
	  return [{ url: "teams", key: "teams" }, {
	    url: "games/" + gameId + "/top_performers",
	    key: "topPerformers",
	    round: 'attachCompetition'
	  }, { url: "v2/games/targets", key: "targets" }];
	};
	
	var Content = function Content(_ref3) {
	  var ifLoaded = _ref3.ifLoaded,
	      active = _ref3.active,
	      hasAccess = _ref3.hasAccess;
	  return hasAccess === true ? ({
	    "": function _() {
	      return ifLoaded(["grades", "teamRank", "round", "isFinished", "location"], _TeamReports2.default);
	    },
	    "grades-ranks": function gradesRanks() {
	      return ifLoaded(["round", "targets"], _GradesRanks2.default);
	    },
	    "market-share": function marketShare() {
	      return ifLoaded(["teams", "competitionMetrics"], _MarketShare2.default);
	    },
	    revenues: function revenues() {
	      return ifLoaded(["teams", "competitionMetrics"], _Revenues2.default);
	    },
	    "gross-margins": function grossMargins() {
	      return ifLoaded(["teams", "competitionMetrics"], _GrossMargins2.default);
	    },
	    "share-price": function sharePrice() {
	      return ifLoaded(["constants", "teams", "competitionMetrics"], _SharePrice2.default);
	    },
	    "earnings-per-share": function earningsPerShare() {
	      return ifLoaded(["teams", "competitionMetrics"], _EarningsPerShare2.default);
	    },
	    "return-on-assets": function returnOnAssets() {
	      return ifLoaded(["teams", "competitionMetrics"], _ReturnOnAssets2.default);
	    },
	    "return-on-equity": function returnOnEquity() {
	      return ifLoaded(["teams", "competitionMetrics"], _ReturnOnEquity2.default);
	    },
	    "fp-a": function fpA() {
	      return _react2.default.createElement(_FPA2.default, null);
	    },
	    "financial-planning-and-analysis": function financialPlanningAndAnalysis() {
	      return ifLoaded(["teams", "teamId", "incomeStatement", "financialAnalysis", "round", "rounds"], _FPAIncomeStatement2.default);
	    },
	    "marketing-analysis": function marketingAnalysis() {
	      return _react2.default.createElement(_MarketingAnalysis2.default, null);
	    },
	    "market-share-capture": function marketShareCapture() {
	      return ifLoaded(["competitiveAnalysis", "competitiveAnalysisTeam", "teams", "totalDemand", "competitionMetrics"], _MarketingAnalysis4.default);
	    },
	    "low-sales-1": function lowSales1() {
	      return ifLoaded(["financials", "round"], _MarketingNoUnitsSold2.default);
	    },
	    "low-sales-2": function lowSales2() {
	      return ifLoaded(["messages"], _MarketingNoUnitsSold4.default);
	    },
	    "customer-survey": function customerSurvey() {
	      return ifLoaded(["competitiveAnalysis", "teamId", "topPerformers", "teams", "rounds", "round"], _MarketingPositioning2.default);
	    },
	    "marketing-selling-price": function marketingSellingPrice() {
	      return ifLoaded(["competitiveAnalysis", "teamId", "unitSales", "teams", "products", "forecasts", "competitionMetrics", "rounds", "round"], _MarketingSellingPrice2.default);
	    },
	    "marketing-awareness": function marketingAwareness() {
	      return ifLoaded(["incomeStatement", "competitiveAnalysis", "teamId", "teams", "competitionMetrics"], _MarketingAwareness2.default);
	    },
	    "marketing-financial-impact-1": function marketingFinancialImpact1() {
	      return ifLoaded(["roundId", "teams", "teamId"], _MarketingChannelSpend2.default);
	    },
	    "operational-analysis": function operationalAnalysis() {
	      return _react2.default.createElement(_OperationalAnalysis2.default, null);
	    },
	    "operational-analysis-unit-costs": function operationalAnalysisUnitCosts() {
	      return ifLoaded(["competitiveAnalysis", "teams", "teamId", "competitionMetrics"], _UnitCosts2.default);
	    },
	    "operational-analysis-unit-costs-breakdown": function operationalAnalysisUnitCostsBreakdown() {
	      return ifLoaded(["manufactureCosts", "round", "rounds", "teamId"], _UnitCosts4.default);
	    },
	    "operational-analysis-inventory-management": function operationalAnalysisInventoryManagement() {
	      return ifLoaded(["constants", "inventoryBalances", "competitiveAnalysis", "products", "teamId", "teams", "competitionMetrics", "rounds", "round"], _InventoryManagement2.default);
	    },
	    "operational-analysis-lead-time": function operationalAnalysisLeadTime() {
	      return ifLoaded(["teamId", "teams", "competitionMetrics", "roundId"], _LeadTime2.default);
	    },
	    "operational-analysis-financial-impact": function operationalAnalysisFinancialImpact() {
	      return ifLoaded(["incomeStatement"], _OAFinancialImpact2.default);
	    },
	    "financing-analysis": function financingAnalysis() {
	      return ifLoaded(["competitionMetrics", "teamId"], _FinancingAnalysis2.default);
	    },
	    "financing-analysis-capital-structure": function financingAnalysisCapitalStructure() {
	      return ifLoaded(["teams", "competitionMetrics", "metrics"], _CapitalStructure2.default);
	    },
	    "financing-analysis-cost-of-debt": function financingAnalysisCostOfDebt() {
	      return ifLoaded(["metrics"], _CostOfDebt2.default);
	    },
	    "financing-analysis-impact-of-debt": function financingAnalysisImpactOfDebt() {
	      return ifLoaded(["incomeStatement"], _ImpactOfDebt2.default);
	    },
	    "financing-analysis-cost-of-capital": function financingAnalysisCostOfCapital() {
	      return ifLoaded(["metrics", "teams", "competitionMetrics"], _CostOfCapital2.default);
	    },
	    "financing-analysis-valuation": function financingAnalysisValuation() {
	      return ifLoaded(["round", "teams", "competitiveAnalysis", "competitiveAnalysisAll", "competitionMetrics", "teamId", "comparableCompanies", "constants"], _Valuation2.default);
	    },
	    "financing-analysis-shares": function financingAnalysisShares() {
	      return ifLoaded(["constants", "metrics", "teams", "competitionMetrics", "equities", "stockRepurchased", "preMoneys", "equityCumulative", "teamId", "round", "roundId"], _Shares2.default);
	    },
	    "financial-statements": function financialStatements() {
	      return _react2.default.createElement(_FinancialStatements2.default, null);
	    },
	    "income-statement": function incomeStatement() {
	      return ifLoaded(["incomeStatement", "round", "rounds"], _IncomeStatement2.default);
	    },
	    "balance-sheet": function balanceSheet() {
	      return ifLoaded(["balanceSheet", "round", "constants"], _BalanceSheet2.default);
	    },
	    "cash-flows": function cashFlows() {
	      return ifLoaded(["cashFlows", "round"], _CashFlows2.default);
	    }
	  }[active] || function () {
	    return _react2.default.createElement(
	      _Paper2.default,
	      null,
	      "Page Not Found"
	    );
	  })() : _react2.default.createElement(
	    _Paper2.default,
	    null,
	    "Page Not Found"
	  );
	};
	
	var getQueryVariable = function getQueryVariable(variable) {
	  var temporaryUser = _Auth2.default.getTemporaryUser();
	  if (temporaryUser && temporaryUser[variable]) {
	    return temporaryUser[variable];
	  }
	
	  console.log("Temporary user doesn't have %s field", variable);
	};
	
	var Analysis = function (_PureComponent) {
	  _inherits(Analysis, _PureComponent);
	
	  function Analysis(props) {
	    _classCallCheck(this, Analysis);
	
	    var _this = _possibleConstructorReturn(this, (Analysis.__proto__ || Object.getPrototypeOf(Analysis)).call(this, props));
	
	    _this.initialState = {
	      //  team: null,
	      grades: [],
	      //  gradesLte: [],
	      balanceSheet: null,
	      competitiveAnalysis: null,
	      competitiveAnalysisAll: null,
	      competitionMetrics: null,
	      metricsReports: null,
	      incomeStatement: null,
	      cashFlows: null,
	      metrics: null,
	      messages: null,
	      projections: null,
	      products: null,
	      forecasts: null,
	      promos: null,
	      sales: null,
	      financials: null,
	      manufactureCosts: null,
	      teamGrade: "",
	      topPerformers: null,
	      unitSales: null,
	      ceo: null,
	      equities: null,
	      stockRepurchased: null,
	      preMoneys: null,
	      equityCumulative: null,
	      comparableCompanies: null,
	      inventoryBalances: null,
	      teams: null,
	      tmpTeamGrade: 0,
	      tmpRankName: "",
	      tmpRounds: []
	    };
	
	    _this.fetchDataForInstructor = function (apiCalls) {
	      var round = _this.getRound();
	      var roundId = _this.getRoundId();
	      // Use the picker's current round as-is for the financial-statements
	      // fetch. The old `round + 1 > maxRound ? maxRound : round + 1` clamp
	      // against props.rounds (which filters to finished rounds) was pulling
	      // lte back to Round 1 whenever the instructor viewed a later year
	      // that hadn't finished yet, making every statement render blank.
	      var roundFinancial = Number(round) || 0;
	      var gameId = parseInt(getQueryVariable("game_id"), 10) || _Auth2.default.getGameId();
	
	      // Fetch team decisions data
	      (0, _TeamDecisionsService.fetchTeamDecisions)(round, 'team-reports', _this.teamId).then(function (data) {
	        _this.setState({
	          manufactureCosts: data.manufacture_costs || [],
	          inventoryBalances: data.inventory_balances || [],
	          unitSales: data.unit_sales || [],
	          products: data.products || [],
	          forecasts: data.price_forecasts || [],
	          equities: data.equities || [],
	          stockRepurchased: data.repurchased_shares || data.stock_repurchased || [],
	          preMoneys: data.pre_moneys || [],
	          equityCumulative: data.equity_cumulative || [],
	          ceo: data.decisions ? { team: data.decisions } : {}
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchTeamDecisions");
	      });
	
	      // Fetch financial statements
	      (0, _FinancialStatementsService.fetchFinancialStatements)({ roundLte: roundFinancial, teamId: _this.teamId }).then(function (data) {
	        var currentRoundNumber = Number(_this.getRound()) || 0;
	        var incomeStatement = data.incomeStatement.find(function (i) {
	          return Number(i.Round) === currentRoundNumber;
	        }) || null;
	        var balanceSheet = data.balanceSheet.find(function (i) {
	          return Number(i.Round) === currentRoundNumber;
	        }) || null;
	        var cashFlows = data.cashflow.find(function (i) {
	          return Number(i.Round) === currentRoundNumber;
	        }) || null;
	        _this.setState({
	          incomeStatement: incomeStatement,
	          balanceSheet: balanceSheet,
	          cashFlows: cashFlows,
	          projections: data.projections || [],
	          financialAnalysis: data.financialAnalysis || []
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchFinancialStatements");
	      });
	
	      // Fetch static data
	      _this.fetchStaticData(round);
	
	      // Resolve the user's competition up front. Props are the primary
	      // source (populated by App.js on load) but they're not available
	      // for the student flow, so fall back to Teams.currentTeam() which
	      // reads localStorage populated during login.
	      var teamsFromProps = _this.props.teams || [];
	      var currentTeamFromProps = teamsFromProps.find(function (t) {
	        return Number(t.id) === _this.teamId;
	      });
	      var currentTeam = currentTeamFromProps || _Teams2.default.currentTeam();
	      var competition = currentTeam && currentTeam.competition ? Number(currentTeam.competition) : 0;
	
	      // Fetch competition metrics — derive teams and team metrics from it
	      // This replaces separate teams/, fetchTeamMetrics, and fetchCompetitionMetrics calls.
	      // include=product_awareness returns per-team `promos` used by the
	      // Marketing Channel Spend page.
	      (0, _MetricsService.fetchCompetitionMetrics)(competition || null, roundId, null).then(function (data) {
	        // Build teams from MetricsReport. Also pin down the user's
	        // competition from the response in case we didn't already have
	        // it (falls through to the loop's resolvedCompetition).
	        var teamsFromMetrics = [];
	        var resolvedCompetition = competition;
	        data.forEach(function (row) {
	          if (row.team_name && !teamsFromMetrics.find(function (t) {
	            return t.id === row.team;
	          })) {
	            teamsFromMetrics.push({
	              id: row.team,
	              name: row.team_name,
	              competition: row.competition
	            });
	          }
	          if (Number(row.team) === _this.teamId && row.competition) {
	            resolvedCompetition = Number(row.competition);
	          }
	        });
	
	        // Guard against the "no competition filter" case where the
	        // metrics endpoint returned every team in the game. Team colors
	        // are derived from sort-by-id position within the array, so a
	        // list contaminated with other competitions' teams shifts the
	        // user's position and gives them a different color than the
	        // topbar (which is already competition-scoped).
	        var competitionTeams = resolvedCompetition > 0 ? teamsFromMetrics.filter(function (t) {
	          return Number(t.competition) === Number(resolvedCompetition);
	        }) : teamsFromMetrics;
	
	        if (competitionTeams.length > 0) {
	          var _require = __webpack_require__(173),
	              reactLocalStorage = _require.reactLocalStorage;
	
	          reactLocalStorage.setObject("teams_data", competitionTeams);
	          // Refresh the shared competition color-index map so every
	          // downstream chart resolves team colors from the same source
	          // as the topbar (which was seeded at login by Teams.setData).
	          (0, _Teams.persistTeamColorIndexMap)(competitionTeams);
	        }
	
	        // Extract team-specific metrics (replaces fetchTeamMetrics)
	        var rawMetrics = data.find(function (i) {
	          return Number(i.team) === _this.teamId;
	        }) || null;
	        var metrics = rawMetrics ? _this.getCompetitionMetrics(rawMetrics) : null;
	
	        var mappedData = data.map(function (i) {
	          return _this.getCompetitionMetrics(i);
	        });
	        _this.setState({
	          competitionMetrics: mappedData,
	          competitiveAnalysis: mappedData,
	          competitiveAnalysisAll: mappedData,
	          metricsReports: data,
	          teams: competitionTeams.length > 0 ? competitionTeams : _this.state.teams,
	          metrics: metrics
	        });
	
	        // Now fetch top_performers and targets with the correct competition
	        (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + "games/" + gameId + "/top_performers/?round_number=" + round + "&competition=" + resolvedCompetition, ("https://be-production-itb.marketgames.io/api/") + "v2/games/targets/?round_number=" + round + "&course=" + _Auth2.default.getCourseId()]).then(function (res) {
	          var targetObj = res[1].body ? res[1].body.find(function (i) {
	            return i.round_number === round;
	          }) : null;
	          _this.setState({
	            topPerformers: res[0].body,
	            targets: targetObj || null
	          });
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchCompetitionMetrics");
	      });
	
	      _this.fetchTeamGradesForInstructor(_this.getRound());
	
	      // Use rounds from general-info props instead of separate API call
	      _this.setState({ tmpRounds: _this.props.rounds || [] });
	    };
	
	    _this.getCompetitionMetrics = function (data) {
	      var result = {};
	
	      Object.keys(data).forEach(function (key) {
	        var ignores = ["id", "round", "created_at", "updated_at", "is_actual", "reason"];
	        var convert = {
	          team: "team",
	          round_number: "Round",
	          salesrep: "SalesRep",
	          roa: "ROA",
	          roe: "ROE",
	          ros: "ROS",
	          roic: "ROIC",
	          capm: "CAPM",
	          ebitda: "EBITDA",
	          rnoa: "RNOA",
	          wacc: "WACC",
	          market_demand_auto: "Market Demand - Auto",
	          market_demand_mobile: "Market Demand - Mobile",
	          average_unit_costs: "Average Unit Cost",
	          market_value: "Market Capitalization",
	          avg_revenues_per_unit_auto: "Average Selling Price - Auto",
	          avg_revenues_per_unit_mobile: "Average Selling Price - Mobile",
	          contribution_margin_percent: "Contribution Margin %",
	          depreciation_sales_related: "Depreciation-Sales Related",
	          equity_cost_of_capital: "Equity Cost of Capital",
	          oh_cost_per_unit: "OH Cost Per Unit",
	          earnings_per_share: "Earnings Per Share",
	          dividends_per_share: "Dividends Per Share",
	          contribution_margin_per_unit: "Contribution Margin Per Unit",
	          gross_margin_per_unit: "Gross Margin Per Unit",
	          price_to_ebitda: "Price to EBITDA",
	          profit_margin_percent: "Profit Margin %",
	          required_rate_of_return: "Required Rate of Return",
	          sgna_costs_percent_sales: "SG&A Costs % Sales"
	        };
	        var ucFirst = function ucFirst(str) {
	          return str[0].toUpperCase() + str.slice(1);
	        };
	        var newKey = ignores.includes(key) ? key : key in convert ? convert[key] : key.split("_").map(function (i, idx) {
	          return ["to", "of", "per", "and", "in"].includes(i) && idx > 0 ? i : ucFirst(i);
	        }).join(" ");
	
	        if (!["game", "competition"].includes(key)) {
	          result[newKey] = data[key];
	        }
	      });
	
	      // Compute combined Market Demand from auto + mobile (old competitive_analysis had this)
	      if (result["Market Demand - Auto"] != null || result["Market Demand - Mobile"] != null) {
	        result["Market Demand"] = (result["Market Demand - Auto"] || 0) + (result["Market Demand - Mobile"] || 0);
	      }
	
	      return result;
	    };
	
	    _this.fetchCompetitionMetricsForInstructor = function () {
	      var teams = _this.state.teams;
	
	      var team = teams.find(function (i) {
	        return i.id === _this.teamId;
	      });
	
	      if (team) {
	        var competition = team.competition;
	
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/finance/metricsreports/?competition=" + competition + "&round=" + _this.getRoundId()).then(function (res) {
	          _this.setState({
	            competitionMetrics: res.body.results.map(function (i) {
	              return _this.getCompetitionMetrics(i);
	            })
	          });
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.fetchRoundsForInstructor = function () {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "game/rounds/").then(function (res) {
	        var game_id = parseInt(getQueryVariable("game_id"), 10);
	
	        _this.setState({
	          tmpRounds: res.body.filter(function (i) {
	            return i.game === game_id;
	          })
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.fetchTeamGradesForInstructor = function (round) {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/grading/?round_number=" + round + "&team_id=" + _this.teamId).then(function (res) {
	        // Drop late responses whose round no longer matches the URL/
	        // state — otherwise a stale in-flight request (e.g. mount fired
	        // before App.js parsed ?round= from a new URL) can clobber the
	        // good data with "Unknown Rank" / 0.
	        if (Number(round) !== Number(_this.getRound())) return;
	        var tmpTeamGrade = 0;
	        var tmpRankName = "Unknown Rank";
	
	        var obj = res.body.find(function (i) {
	          return i.round_number === round;
	        });
	        if (obj) {
	          tmpTeamGrade = obj.weighted_value * 100;
	          if (obj.ranking !== "") {
	            tmpRankName = obj.ranking;
	          }
	        }
	
	        _this.setState({
	          grades: res.body,
	          tmpTeamGrade: tmpTeamGrade,
	          tmpRankName: tmpRankName
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.fetchIncomeStatement = function (round) {
	      _this.getIncomeStatement(round).then(function (res) {
	        _this.setState({
	          incomeStatement: res.body[0]
	        });
	      }).catch(function (err) {
	        console.log("income err", err);
	      });
	    };
	
	    _this.fetchBalanceSheet = function (round) {
	      _this.getBalanceSheet(round).then(function (res) {
	        _this.setState({
	          balanceSheet: res.body[0]
	        });
	      }).catch(function (err) {
	        console.log("balanceSheet err", err);
	      });
	    };
	
	    _this.fetchCashFlows = function (round) {
	      _this.getCashFlows(round).then(function (_ref4) {
	        var body = _ref4.body;
	
	        _this.setState({
	          cashFlows: body[0]
	        });
	      }).catch(function (err) {
	        console.log("cashFlow err", err);
	      });
	    };
	
	    _this.fetchBalance = function (round) {
	      if (round) {
	        var url = ("https://be-production-itb.marketgames.io/api/") + "team/page/financials/?round_number=" + round;
	
	        if (_this.balanceRequest) {
	          _this.balanceRequest.abort();
	          _this.balanceRequest = null;
	        }
	        _this.balanceRequest = (0, _ApiService.getRequest)(url);
	
	        _this.balanceRequest.then(function (_ref5) {
	          var team = _ref5.body.team;
	
	          _this.setState({
	            team: team
	          });
	        }).catch(function (err) {
	          (0, _utils.logError)(err, "Analysis", "fetchBalance");
	        });
	      }
	    };
	
	    _this.fetchTeamGrades = function (round) {
	      if (round) {
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/grading/?round_number=" + round).then(function (_ref6) {
	          var body = _ref6.body;
	
	          // Drop late responses whose round no longer matches the URL/
	          // state — otherwise a stale in-flight request (e.g. mount fired
	          // before App.js parsed ?round= from a new URL) can clobber the
	          // good data with "Unknown Rank" / 0.
	          if (Number(round) !== Number(_this.getRound())) return;
	          var tmpTeamGrade = 0;
	          var tmpRankName = "Unknown Rank";
	
	          var obj = body.find(function (i) {
	            return i.round_number === round;
	          });
	          if (obj) {
	            tmpTeamGrade = obj.weighted_value * 100;
	            if (obj.ranking !== "") {
	              tmpRankName = obj.ranking;
	            }
	          }
	
	          _this.setState({
	            grades: body,
	            tmpTeamGrade: tmpTeamGrade,
	            tmpRankName: tmpRankName
	          });
	        }).catch(function (err) {
	          (0, _utils.logError)(err, "Analysis", "fetchTeamGrades");
	        });
	      }
	    };
	
	    _this.fetchTeamGradesLte = function (round) {
	      if (round) {
	        var url = ("https://be-production-itb.marketgames.io/api/") + "team/grading/?round_lte=" + round;
	
	        if (_this.teamGradeLteRequest) {
	          _this.teamGradeLteRequest.abort();
	          _this.teamGradeLteRequest = null;
	        }
	        _this.teamGradeLteRequest = (0, _ApiService.getRequest)(url);
	
	        _this.teamGradeLteRequest.then(function (_ref7) {
	          var body = _ref7.body;
	
	          _this.setState({
	            gradesLte: body
	          });
	        }).catch(function (err) {
	          (0, _utils.logError)(err, "Analysis", "fetchTeamGradesLte");
	        });
	      }
	    };
	
	    _this.fetchCompetitiveAnalysis = function (round) {
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = currentTeam ? Number(currentTeam.competition) : 0;
	      var rounds = _this.props.rounds;
	
	      var roundObj = (rounds || []).find(function (i) {
	        return Number(i.number) === round;
	      });
	      var roundId = roundObj ? Number(roundObj.id) : 0;
	
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId).then(function (data) {
	        _this.setState({
	          competitiveAnalysis: data.map(function (i) {
	            return _this.getCompetitionMetrics(i);
	          })
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchCompetitiveAnalysis");
	      });
	    };
	
	    _this.fetchCompetitiveAnalysisAll = function (round) {
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = currentTeam ? Number(currentTeam.competition) : 0;
	
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId || null, null).then(function (data) {
	        _this.setState({
	          competitiveAnalysisAll: data.map(function (i) {
	            return _this.getCompetitionMetrics(i);
	          })
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchCompetitiveAnalysisAll");
	      });
	    };
	
	    _this.fetchProjections = function () {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/projections";
	
	      if (_this.projectionsRequest) {
	        _this.projectionsRequest.abort();
	        _this.projectionsRequest = null;
	      }
	      _this.projectionsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.projectionsRequest.then(function (_ref8) {
	        var body = _ref8.body;
	
	        _this.setState({
	          projections: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchProjections");
	      });
	    };
	
	    _this.fetchProducts = function (round) {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/products?round_number=" + round;
	
	      if (_this.productsRequest) {
	        _this.productsRequest.abort();
	        _this.productsRequest = null;
	      }
	      _this.productsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.productsRequest.then(function (_ref9) {
	        var body = _ref9.body;
	
	        _this.setState({
	          products: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchProducts");
	      });
	    };
	
	    _this.fetchForecasts = function (round) {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/price_forecasts?round_number=" + round;
	
	      if (_this.forecastsRequest) {
	        _this.forecastsRequest.abort();
	        _this.forecastsRequest = null;
	      }
	      _this.forecastsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.forecastsRequest.then(function (_ref10) {
	        var body = _ref10.body;
	
	        _this.setState({
	          forecasts: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchForecasts");
	      });
	    };
	
	    _this.fetchPromos = function () {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/promos";
	
	      if (_this.promosRequest) {
	        _this.promosRequest.abort();
	        _this.promosRequest = null;
	      }
	      _this.promosRequest = (0, _ApiService.getRequest)(url);
	
	      _this.promosRequest.then(function (_ref11) {
	        var body = _ref11.body;
	
	        _this.setState({
	          promos: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchPromos");
	      });
	    };
	
	    _this.fetchSales = function () {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/sales";
	
	      if (_this.salesRequest) {
	        _this.salesRequest.abort();
	        _this.salesRequest = null;
	      }
	      _this.salesRequest = (0, _ApiService.getRequest)(url);
	
	      _this.salesRequest.then(function (_ref12) {
	        var body = _ref12.body;
	
	        _this.setState({
	          sales: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchSales");
	      });
	    };
	
	    _this.fetchFinancials = function (round) {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/page/financials/?round_number=" + round;
	
	      if (_this.financialsRequest) {
	        _this.financialsRequest.abort();
	        _this.financialsRequest = null;
	      }
	      _this.financialsRequest = (0, _ApiService.getRequest)(url);
	      _this.setState({ financials: null });
	      _this.financialsRequest.then(function (_ref13) {
	        var team = _ref13.body.team;
	
	        _this.setState({
	          financials: team
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchFinancials");
	      });
	    };
	
	    _this.state = Object.assign({}, _this.initialState, {
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl
	    });
	
	    if (_Auth2.default.getPosition() === "Student") {
	      var team = _Teams2.default.currentTeam();
	      _this.teamId = team ? team.id : 0;
	    } else {
	      _this.teamId = parseInt(getQueryVariable("team_id"), 10);
	    }
	    return _this;
	  }
	
	  _createClass(Analysis, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.currentRound !== this.state.currentRound || nextProps.roundInUrl !== this.state.roundInUrl) {
	        this.setState({
	          currentRound: nextProps.currentRound,
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.fetchData(_this2.getRound());
	        });
	      } else if (nextProps.rounds !== this.props.rounds && (!this.props.rounds || this.props.rounds.length === 0) && nextProps.rounds && nextProps.rounds.length > 0 || nextProps.teams !== this.props.teams && (!this.props.teams || this.props.teams.length === 0) && nextProps.teams && nextProps.teams.length > 0) {
	        // Re-fetch if rounds or teams went from empty to populated (initial load)
	        this.fetchData(this.getRound());
	      }
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData(round) {
	      var _this3 = this;
	
	      var apiCalls = APICalls(_Auth2.default.getPosition() === "Student" ? _Auth2.default.getGameId() : parseInt(getQueryVariable("game_id"), 10));
	      var rounds = this.props.rounds;
	
	
	      if (_Auth2.default.getPosition() !== "Student") {
	        if (!rounds || rounds.length === 0) {
	          return; // Wait for componentWillReceiveProps when rounds load
	        }
	        var _roundId = this.getRoundId();
	        if (!_roundId) {
	          return; // Round not found in rounds array yet
	        }
	        this.fetchDataForInstructor(apiCalls);
	        return;
	      }
	
	      if (!rounds || rounds.length === 0) {
	        return;
	      }
	      // Use the picker's current round as-is. The former maxRound clamp
	      // against props.rounds dropped lte back to Round 1 whenever the
	      // user viewed a later year that hadn't finished yet, blanking all
	      // three financial statement panels.
	      var roundFinancial = Number(round) || 0;
	      var roundObj = rounds.find(function (i) {
	        return Number(i.number) === round;
	      });
	      var roundId = roundObj ? Number(roundObj.id) : 0;
	      (0, _ApiService.batchRequest)((0, _lodash.map)(apiCalls, function (call) {
	        return "" + ("https://be-production-itb.marketgames.io/api/") + call.url + {
	          false: function _false() {
	            return "";
	          },
	          undefined: function undefined() {
	            return "/?round_number=" + round;
	          },
	          id: function id() {
	            return "/?round=" + roundId;
	          },
	          attachCompetition: function attachCompetition() {
	            return "/?round_number=" + round;
	          }
	        }[call.round]();
	      })).then(function (res) {
	        var newState = (0, _lodash.fromPairs)((0, _lodash.map)((0, _lodash.zip)(res, apiCalls), function (_ref14) {
	          var _ref15 = _slicedToArray(_ref14, 2),
	              body = _ref15[0].body,
	              key = _ref15[1].key;
	
	          return [key, body];
	        }));
	        try {
	          newState.targets = newState.targets.find(function (i) {
	            return i.round_number === round;
	          });
	        } catch (err) {
	          newState.targets = null;
	        }
	        _this3.setState(newState);
	      });
	
	      // Fetch team decisions data (replaces manufacture_costs, inventory_balances,
	      // unit_sales, products, price_forecasts, equities, stock_repurchased, ceo)
	      (0, _TeamDecisionsService.fetchTeamDecisions)(round, 'team-reports').then(function (data) {
	        _this3.setState({
	          manufactureCosts: data.manufacture_costs || [],
	          inventoryBalances: data.inventory_balances || [],
	          unitSales: data.unit_sales || [],
	          products: data.products || [],
	          forecasts: data.price_forecasts || [],
	          equities: data.equities || [],
	          stockRepurchased: data.repurchased_shares || data.stock_repurchased || [],
	          preMoneys: data.pre_moneys || [],
	          equityCumulative: data.equity_cumulative || [],
	          ceo: data.decisions ? { team: data.decisions } : {}
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchTeamDecisions");
	      });
	
	      // Fetch financial statements (replaces income_statement, balance_sheet, cashflow, projections, financial_analysis)
	      (0, _FinancialStatementsService.fetchFinancialStatements)({ roundLte: roundFinancial }).then(function (data) {
	        var currentRoundNumber = Number(_this3.getRound()) || 0;
	        var incomeStatement = data.incomeStatement.find(function (i) {
	          return Number(i.Round) === currentRoundNumber;
	        }) || null;
	        var balanceSheet = data.balanceSheet.find(function (i) {
	          return Number(i.Round) === currentRoundNumber;
	        }) || null;
	        var cashFlows = data.cashflow.find(function (i) {
	          return Number(i.Round) === currentRoundNumber;
	        }) || null;
	        _this3.setState({
	          incomeStatement: incomeStatement,
	          balanceSheet: balanceSheet,
	          cashFlows: cashFlows,
	          projections: data.projections || [],
	          financialAnalysis: data.financialAnalysis || []
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchFinancialStatements");
	      });
	
	      this.fetchStaticData(round);
	      this.fetchTeamGrades(round);
	
	      // Fetch metrics via MetricsService (cached, avoids duplicate calls from child pages)
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = currentTeam ? Number(currentTeam.competition) : 0;
	      var teamId = currentTeam ? Number(currentTeam.id) : 0;
	
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId, null).then(function (data) {
	        // Build teams from MetricsReport for chart colors
	        var teamsFromMetrics = [];
	        data.forEach(function (row) {
	          if (row.team_name && !teamsFromMetrics.find(function (t) {
	            return t.id === row.team;
	          })) {
	            teamsFromMetrics.push({
	              id: row.team,
	              name: row.team_name,
	              competition: row.competition
	            });
	          }
	        });
	        // Update localStorage so Teams.competitiveColors() has all competition teams
	        if (teamsFromMetrics.length > 0) {
	          var _require2 = __webpack_require__(173),
	              reactLocalStorage = _require2.reactLocalStorage;
	
	          reactLocalStorage.setObject("teams_data", teamsFromMetrics);
	          (0, _Teams.persistTeamColorIndexMap)(teamsFromMetrics);
	        }
	        var mappedData = data.map(function (i) {
	          return _this3.getCompetitionMetrics(i);
	        });
	
	        // Extract team-specific metrics (replaces fetchTeamMetrics)
	        var rawMetrics = data.find(function (i) {
	          return Number(i.team) === teamId;
	        }) || null;
	        var metrics = rawMetrics ? _this3.getCompetitionMetrics(rawMetrics) : null;
	
	        _this3.setState({
	          competitionMetrics: mappedData,
	          competitiveAnalysis: mappedData,
	          competitiveAnalysisAll: mappedData,
	          metricsReports: data,
	          teams: teamsFromMetrics.length > 0 ? teamsFromMetrics : _this3.state.teams,
	          metrics: metrics
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Analysis", "fetchCompetitionMetrics");
	      });
	      //this.fetchCEO(round)
	      /*
	      this.fetchBalance()
	      this.fetchCompetitionMetrics(round)
	      this.fetchTeams(round)
	      this.fetchMetrics(round)
	      this.fetchIncomeStatement(round)
	      this.fetchBalanceSheet(round)
	      this.fetchCashFlows(round)
	      this.fetchTotalDemand(round)
	      this.fetchTeamGradesLte()
	      this.fetchCompetitiveAnalysis(round)
	      this.fetchCompetitiveAnalysisAll(round)
	      this.fetchFinancialAnalysis(round)
	      this.fetchProjections()
	      this.fetchProducts(round)
	      this.fetchForecasts(round)
	      this.fetchPromos(round)
	      this.fetchSales(round)
	      this.fetchFinancials(round)
	      this.fetchMessages(round)
	      this.fetchManufactureCosts(round)
	      this.fetchTopPerformers(round)
	      this.fetchUnitSales(round)
	      this.fetchEquities(round)
	      this.fetchStockRepurchased(round)
	      this.fetchComparableCompanies(round)
	      this.fetchInventoryBalances(round)
	      */
	    }
	  }, {
	    key: "getRound",
	    value: function getRound() {
	      var _state = this.state,
	          currentRound = _state.currentRound,
	          roundInUrl = _state.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }, {
	    key: "getRoundId",
	    value: function getRoundId() {
	      var rounds = this.props.rounds;
	
	      var roundNumber = this.getRound();
	      var round = rounds.find(function (i) {
	        return Number(i.number) === roundNumber;
	      });
	
	      return round ? Number(round.id) : 0;
	    }
	  }, {
	    key: "getCountOfRounds",
	    value: function getCountOfRounds() {
	      var tmpRounds = this.state.tmpRounds;
	      var rounds = this.props.rounds;
	
	
	      return _Auth2.default.getPosition() === "Student" ? rounds.length : tmpRounds.length;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (_Auth2.default.isAnyInstructor()) {
	        var rounds = this.props.rounds;
	
	        var roundNumber = Number(this.getRound());
	
	        var activeRound = rounds.find(function (item) {
	          return item.number === roundNumber;
	        });
	        var isActiveRoundFinished = activeRound ? activeRound.is_finished : false;
	
	        if (!isActiveRoundFinished) {
	          (0, _Location.changeLocation)("/decisions/ceo?round=" + roundNumber);
	        }
	      }
	      this.fetchData(this.getRound());
	    }
	  }, {
	    key: "fetchStaticData",
	    value: function fetchStaticData(round) {
	      var _this4 = this;
	
	      // team-reports scope returns constants as an object (not a
	      // single-element array) and pre-filters total_demand to the
	      // requested round, so no [0]-indirection or per-row round filter
	      // downstream in extendedState.
	      (0, _StaticDataService.fetchAllStaticData)(round, 'team-reports').then(function (data) {
	        _this4.setState({
	          constants: data.constants,
	          totalDemand: data.totalDemand && data.totalDemand[0] || null,
	          comparableCompanies: data.comparableCompanies
	        });
	      });
	    }
	  }, {
	    key: "fetchManufactureCosts",
	    value: function fetchManufactureCosts(round) {
	      var _this5 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/manufacture_costs/?round_number=" + round).then(function (res) {
	        var avgMaterialCostsPerUnit = 0;
	        var avgLaborCostsPerUnit = 0;
	        var avgOverheadCostsPerUnit = 0;
	
	        res.body.forEach(function (product) {
	          avgMaterialCostsPerUnit += product.material_costs;
	          avgLaborCostsPerUnit += product.labor_costs;
	          avgOverheadCostsPerUnit += product.overhead_costs;
	        });
	
	        _this5.setState({
	          avgMaterialCostsPerUnit: avgMaterialCostsPerUnit,
	          avgLaborCostsPerUnit: avgLaborCostsPerUnit,
	          avgOverheadCostsPerUnit: avgOverheadCostsPerUnit
	        });
	      });
	    }
	  }, {
	    key: "fetchTotalDemand",
	    value: function fetchTotalDemand(round) {
	      var _this6 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "static/total_demand/?round_number=" + round).then(function (_ref16) {
	        var body = _ref16.body;
	
	        _this6.setState({
	          totalDemand: body
	        });
	      });
	    }
	  }, {
	    key: "fetchInventoryBalances",
	    value: function fetchInventoryBalances(round) {
	      var _this7 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/inventory_balances/?round_number=" + round).then(function (_ref17) {
	        var body = _ref17.body;
	
	        _this7.setState({
	          inventoryBalances: body
	        });
	      });
	    }
	  }, {
	    key: "fetchComparableCompanies",
	    value: function fetchComparableCompanies(round) {
	      var _this8 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "static/comparable_companies/?round_number=" + round).then(function (_ref18) {
	        var body = _ref18.body;
	
	        _this8.setState({
	          comparableCompanies: body
	        });
	      });
	    }
	  }, {
	    key: "fetchTopPerformers",
	    value: function fetchTopPerformers(round) {
	      var _this9 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + _Auth2.default.getGameId() + "/top_performers/?round_number=" + round).then(function (_ref19) {
	        var body = _ref19.body;
	
	        _this9.setState({
	          topPerformers: body
	        });
	      });
	    }
	  }, {
	    key: "fetchEquities",
	    value: function fetchEquities(round) {
	      var _this10 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/equities/?round_number=" + round).then(function (_ref20) {
	        var body = _ref20.body;
	
	        _this10.setState({
	          equities: body
	        });
	      });
	    }
	  }, {
	    key: "fetchStockRepurchased",
	    value: function fetchStockRepurchased(round) {
	      var _this11 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/stock_repurchased/?round_number=" + round).then(function (_ref21) {
	        var body = _ref21.body;
	
	        _this11.setState({
	          stockRepurchased: body
	        });
	      });
	    }
	  }, {
	    key: "fetchMetrics",
	    value: function fetchMetrics(round) {
	      var team = _Teams2.default.currentTeam();
	      var teamId = team ? Number(team.id) : 0;
	      var rounds = this.props.rounds;
	
	      var roundObj = rounds.find(function (i) {
	        return Number(i.number) === round;
	      });
	      var roundId = roundObj ? Number(roundObj.id) : 0;
	
	      (0, _MetricsService.fetchTeamMetrics)(teamId, roundId).then(function (results) {
	        this.setState({
	          metrics: results[0]
	        });
	      }.bind(this));
	    }
	  }, {
	    key: "fetchFinancialAnalysis",
	    value: function fetchFinancialAnalysis(round) {
	      var _this12 = this;
	
	      var rounds = this.props.rounds;
	
	      var maxRound = rounds[rounds.length - 1].number;
	      var activeRound = round + 1 > maxRound ? maxRound : round + 1;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/financial_analysis/?round_lte=" + activeRound).then(function (_ref22) {
	        var body = _ref22.body;
	
	        _this12.setState({
	          financialAnalysis: body
	        });
	      });
	    }
	  }, {
	    key: "fetchTeams",
	    value: function fetchTeams() {
	      var _this13 = this;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (_ref23) {
	        var body = _ref23.body;
	
	        _this13.setState({
	          teams: body
	        });
	      });
	    }
	  }, {
	    key: "fetchCompetitionMetrics",
	    value: function fetchCompetitionMetrics(round) {
	      var _this14 = this;
	
	      var rounds = this.props.rounds;
	
	      var roundObj = rounds.find(function (i) {
	        return Number(i.number) === Number(round);
	      });
	      var roundId = roundObj ? roundObj.id : null;
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = currentTeam ? currentTeam.competition : null;
	
	      if (!competitionId || !roundId) {
	        return;
	      }
	
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId).then(function (data) {
	        _this14.setState({
	          competitionMetrics: data
	        });
	      });
	    }
	  }, {
	    key: "fetchUnitSales",
	    value: function fetchUnitSales(round) {
	      var _this15 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/unit_sales/?round_number=" + round).then(function (_ref24) {
	        var body = _ref24.body;
	
	        _this15.setState({
	          unitSales: body
	        });
	      });
	    }
	  }, {
	    key: "fetchCEO",
	    value: function fetchCEO(round) {
	      var _this16 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/page/ceo/?round_number=" + round).then(function (_ref25) {
	        var body = _ref25.body;
	
	        _this16.setState({
	          ceo: body
	        });
	      });
	    }
	  }, {
	    key: "fetchMessages",
	    value: function fetchMessages(round) {
	      var _this17 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "teams/messages/?round_number=" + round).then(function (_ref26) {
	        var body = _ref26.body;
	
	        _this17.setState({
	          messages: body
	        });
	
	        if (body["type_name"]) {
	          if (body.minimum_requirement_fail || body.price_range_fail || body.distribution_fail) {
	            _this17.setState({
	              conditionalPage: true
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: "getIncomeStatement",
	    value: function getIncomeStatement(round) {
	      return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/report/income_statement/?round_number=" + round);
	    }
	  }, {
	    key: "getBalanceSheet",
	    value: function getBalanceSheet(round) {
	      return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/report/balance_sheet/?round_number=" + round);
	    }
	  }, {
	    key: "getCashFlows",
	    value: function getCashFlows(round) {
	      return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/report/cashflow/?round_number=" + round);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var teamId = this.teamId;
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          rounds = _props.rounds;
	      var _state2 = this.state,
	          totalDemand = _state2.totalDemand,
	          competitiveAnalysis = _state2.competitiveAnalysis,
	          teams = _state2.teams,
	          tmpTeamGrade = _state2.tmpTeamGrade,
	          tmpRankName = _state2.tmpRankName,
	          tmpRounds = _state2.tmpRounds;
	
	
	      var activeRound = this.activeRound;
	      var currentRound = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	
	      if ((0, _lodash.isNil)(rounds) && _Auth2.default.getPosition() === "Student") {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true });
	      }
	      var round = this.getRound();
	      var selectedRound = (0, _lodash.find)(rounds, function (rnd) {
	        return rnd.number === round;
	      });
	      if ((0, _lodash.isNil)(selectedRound) && _Auth2.default.getPosition() === "Student") {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true });
	      }
	      if ((0, _lodash.isNil)(competitiveAnalysis) && _Auth2.default.getPosition() !== "Student") {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true });
	      }
	      if (currentRound.results_viewable === false && _Auth2.default.getPosition() === "Student") {
	        return _react2.default.createElement(
	          RoundLockedScreen.Wrapper,
	          null,
	          _react2.default.createElement(RoundLockedScreen.Image, { alt: "Round results locked", src: _iconLock2.default }),
	          _react2.default.createElement(
	            RoundLockedScreen.Title,
	            null,
	            "Round Results Locked"
	          ),
	          _react2.default.createElement(
	            RoundLockedScreen.Text,
	            null,
	            "The instructor has locked the results for this round. Check back when they reopen it."
	          )
	        );
	      }
	      var isFinished = _Auth2.default.getPosition() === "Student" ? selectedRound.is_finished : true;
	      var report1 = (0, _lodash.isNil)(params.report1) ? "" : params.report1;
	      var report2 = (0, _lodash.isNil)(params.report2) ? "" : params.report2;
	      var hasAccess = report1 === "financial-statements" || report1 === "" || report1 !== "financial-statements" && isFinished === true ? true : false;
	      var active = report2 !== "" ? report2 : report1;
	      var competitionTeams = teams && (0, _utils2.getCompetitionTeams)(teams, teamId);
	      var currentRounds = rounds ? rounds : tmpRounds;
	      var roundIdObj = currentRounds.find(function (r) {
	        return r.number === round;
	      });
	      var roundId = roundIdObj ? roundIdObj.id : null;
	      var extState = Object.assign({}, this.state, {
	        teams: competitionTeams,
	        round: round,
	        roundId: roundId,
	        countOfRounds: this.getCountOfRounds(),
	        teamId: teamId,
	        teamRank: tmpRankName,
	        teamGrade: tmpTeamGrade,
	        // totalDemand is now the pre-filtered single row from
	        // fetchStaticData; no per-round find needed.
	        totalDemand: totalDemand,
	        competitiveAnalysisTeam: (0, _utils2.getTeam)(teamId, competitiveAnalysis),
	        rounds: currentRounds,
	        isFinished: isFinished,
	        location: location
	      });
	      var ifLoaded = function ifLoaded(fields, Component) {
	        return (0, _lodash.some)(fields.filter(function (i) {
	          return i !== "roundInUrl";
	        }), function (field) {
	          return (0, _lodash.isNil)(extState[field]);
	        }) ? _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true }) : _react2.default.createElement(Component, (0, _lodash.pick)(extState, fields));
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { className: "dashboard" },
	        _Auth2.default.getPosition() === "Student" && _react2.default.createElement(BreadCrumbs, {
	          crumbs: [{ label: "Home", location: "/start" }, { label: "Analysis", location: "/analysis" }, { label: "Team Reports", location: "/analysis/team-reports" }]
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", flexDirection: "row" } },
	          [_react2.default.createElement(
	            "div",
	            { key: 0, className: "team-reports-menu" },
	            _react2.default.createElement(_Menu2.default, {
	              location: location.pathname,
	              search: location.search,
	              round: this.getRound(),
	              messages: this.state.messages,
	              isFinished: isFinished,
	              targets: this.state.targets
	            })
	          ), _react2.default.createElement(Content, {
	            key: 1,
	            ifLoaded: ifLoaded,
	            active: active,
	            hasAccess: hasAccess
	          })]
	        )
	      );
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          roundInUrl = _props2.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }]);
	
	  return Analysis;
	}(_react.PureComponent);
	
	exports.default = Analysis;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n"], ["\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _format = __webpack_require__(63);
	
	var _MoneyTable = __webpack_require__(396);
	
	var _MoneyTable2 = _interopRequireDefault(_MoneyTable);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _FormulaTable = __webpack_require__(303);
	
	var _FormulaTable2 = _interopRequireDefault(_FormulaTable);
	
	var _ApiService = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var BalanceSheet = function (_PureComponent) {
	  _inherits(BalanceSheet, _PureComponent);
	
	  function BalanceSheet(props) {
	    _classCallCheck(this, BalanceSheet);
	
	    var _this = _possibleConstructorReturn(this, (BalanceSheet.__proto__ || Object.getPrototypeOf(BalanceSheet)).call(this, props));
	
	    _this.formatNumber = function (value) {
	      return (value / 1000000).toFixed(1) + "M";
	    };
	
	    _this.generateBalanceTableKeys = function () {
	      var _this$state = _this.state,
	          equitiesIssuanceLte = _this$state.equitiesIssuanceLte,
	          stockRepurchasedSharesLte = _this$state.stockRepurchasedSharesLte;
	      var constants = _this.props.constants;
	
	
	      return [{
	        group: "Assets",
	        rows: [{ key: "Cash", label: "Cash" }, { key: "Accounts Receivable", label: "Accounts Receivable" }, { key: "Inventory", label: "Inventory" }, { key: "PPE", label: "Property, Plant, & Equipment" }, { key: "Accumulated Depreciation", label: "Accumulated Depreciation" }, { key: "Total Assets", label: "Total Assets" }]
	      }, {
	        group: "Liabilities",
	        rows: [{ label: "Interest Payable" }, { key: "Accounts Payable", label: "Accounts Payable" }, { key: "Short Term Debt", label: "Short Term Debt" }, {
	          key: "Distribution Center Liability",
	          label: "DC Lease Liabilities",
	          tooltip: "Distribution Center Lease Liability"
	        }, { key: "Long Term Debt", label: "Long Term Debt" }, { key: "Total Liabilities", label: "Total Liabilities" }]
	      }, {
	        group: "Equity",
	        rows: [{ label: "Common Stock", withoutValue: true }, { label: "Issued Shares (" + _this.formatNumber(equitiesIssuanceLte + constants.initial_shares) + ")", key: "Common Stock" }, { label: "Bought Back Shares (" + _this.formatNumber(stockRepurchasedSharesLte) + ")", key: "Treasury Stock" }, { label: "Retained Earnings", withoutValue: true }, { label: "Beginning Balance", key: "Prior Period Retained Earnings" }, { label: "Net Profits", key: "Net Income" }, { label: "Dividends" }, { label: "Additional Paid in Capital" }, { label: "Total Equity" }]
	      }];
	    };
	
	    _this.state = {
	      loaded: false,
	      equitiesIssuanceLte: 0,
	      stockRepurchasedSharesLte: 0
	    };
	    return _this;
	  }
	
	  _createClass(BalanceSheet, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var round = this.props.round;
	
	
	      var teamEquitiesUrl = ("https://be-production-itb.marketgames.io/api/") + "team/equities/?round_lte=" + round;
	      var teamStockRepurchased = ("https://be-production-itb.marketgames.io/api/") + "team/stock_repurchased/?round_lte=" + round;
	
	      if (_Auth2.default.isAnyInstructor()) {
	        teamEquitiesUrl += "&team_id=" + _Auth2.default.getTeamId();
	        teamStockRepurchased += "&team_id=" + _Auth2.default.getTeamId();
	      }
	
	      (0, _ApiService.batchRequest)([teamEquitiesUrl, teamStockRepurchased]).then(function (res) {
	        var equitiesLte = res[0].body;
	        var stockRepurchasedLte = res[1].body;
	
	        var equitiesIssuanceLte = 0;
	        var stockRepurchasedSharesLte = 0;
	
	        if (equitiesLte.length) {
	          equitiesLte.forEach(function (equity) {
	            equitiesIssuanceLte += equity.issuance;
	          });
	        }
	
	        if (stockRepurchasedLte.length) {
	          stockRepurchasedLte.forEach(function (stockRepurchased) {
	            stockRepurchasedSharesLte += stockRepurchased.shares;
	          });
	        }
	
	        _this2.setState({
	          loaded: true,
	          equitiesIssuanceLte: equitiesIssuanceLte,
	          stockRepurchasedSharesLte: stockRepurchasedSharesLte
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var balanceSheet = this.props.balanceSheet;
	      var loaded = this.state.loaded;
	
	
	      var balanceTableKeys = this.generateBalanceTableKeys();
	
	      return loaded ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          _TwoPanels2.default,
	          { title1: "Balance Sheet", title2: "BalanceSheet" },
	          _react2.default.createElement(
	            "fragment",
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              null,
	              "This report breaks down your Total Equity, which comprises of your Total Assets less any liabilities you owe."
	            ),
	            _react2.default.createElement(_FormulaTable2.default, {
	              items: [{
	                name: "Assets",
	                highlighted: true,
	                value: (0, _format.moneyFormat)(balanceSheet["Total Assets"])
	              }, { name: "-", highlighted: false, value: "" }, {
	                name: "Liabilities",
	                highlighted: true,
	                value: (0, _format.moneyFormat)(balanceSheet["Total Liabilities"])
	              }, { name: "=", highlighted: false, value: "" }, {
	                name: "Equities",
	                highlighted: true,
	                value: (0, _format.moneyFormat)(balanceSheet["Total Equity"])
	              }]
	            })
	          ),
	          _react2.default.createElement(_MoneyTable2.default, { keys: (0, _MoneyTable.populateKeys)(balanceTableKeys, balanceSheet) })
	        )
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	      );
	    }
	  }]);
	
	  return BalanceSheet;
	}(_react.PureComponent);
	
	exports.default = BalanceSheet;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n  margin-top: 2px;\n'], ['\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n  margin-top: 2px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n'], ['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n'], ['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _utils = __webpack_require__(53);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _financeCapitalStructure = __webpack_require__(1055);
	
	var _financeCapitalStructure2 = _interopRequireDefault(_financeCapitalStructure);
	
	var _financeDebtToCapital = __webpack_require__(1056);
	
	var _financeDebtToCapital2 = _interopRequireDefault(_financeDebtToCapital);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var videos = {
	  'Capital Structure': _financeCapitalStructure2.default,
	  'Debt to Capital': _financeDebtToCapital2.default
	};
	
	var HelpIcon = _styledComponents2.default.img(_templateObject);
	
	var ModalVideoWrapper = _styledComponents2.default.div(_templateObject2);
	
	var PlayPauseButton = _styledComponents2.default.button(_templateObject3);
	
	var CloseModalVideoButton = _styledComponents2.default.button(_templateObject4);
	
	var TextWithButton = _styledComponents2.default.p(_templateObject5);
	
	var CapitalStructure = function (_PureComponent) {
	  _inherits(CapitalStructure, _PureComponent);
	
	  function CapitalStructure(props) {
	    _classCallCheck(this, CapitalStructure);
	
	    var _this = _possibleConstructorReturn(this, (CapitalStructure.__proto__ || Object.getPrototypeOf(CapitalStructure)).call(this, props));
	
	    _this.handlePlayPause = function () {
	      if (_this.videoRef) {
	        if (_this.state.isVideoPlaying) {
	          _this.videoRef.pause();
	        } else {
	          _this.videoRef.play();
	        }
	        _this.setState({ isVideoPlaying: !_this.state.isVideoPlaying });
	      }
	    };
	
	    _this.openVideoModal = function (videoSrc) {
	      _this.setState({
	        isVideoModalShown: true,
	        selectedVideo: videoSrc
	      });
	    };
	
	    _this.closeVideoModal = function () {
	      _this.setState({
	        isVideoModalShown: false,
	        isVideoPlaying: false
	      });
	    };
	
	    _this.onHelpIconClick = function (field) {
	      if (videos[field]) {
	        _this.openVideoModal(videos[field]);
	      }
	    };
	
	    _this.state = {
	      isVideoModalShown: false,
	      isVideoPlaying: false,
	      selectedVideo: null
	    };
	
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(CapitalStructure, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isVideoModalShown = _state.isVideoModalShown,
	          isVideoPlaying = _state.isVideoPlaying;
	      var _props = this.props,
	          teams = _props.teams,
	          competitionMetrics = _props.competitionMetrics,
	          metrics = _props.metrics;
	
	      return _react2.default.createElement(
	        _OnePanelChart2.default,
	        {
	          title: _react2.default.createElement(
	            TextWithButton,
	            null,
	            'Capital Structure ',
	            _react2.default.createElement(HelpIcon, { src: _iconTableHelp2.default, onClick: function onClick() {
	                return _this2.onHelpIconClick("Capital Structure");
	              } })
	          ),
	          chartTitle: _react2.default.createElement(
	            TextWithButton,
	            null,
	            'Debt to Capital Ratio ',
	            _react2.default.createElement(HelpIcon, { src: _iconTableHelp2.default, onClick: function onClick() {
	                return _this2.onHelpIconClick("Debt to Capital");
	              } })
	          ),
	          vertical: true,
	          suffix: '%',
	          data: (0, _utils.pickPercent)(teams, competitionMetrics, "Debt to Total Capital"),
	          teams: teams
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { show: isVideoModalShown, onHide: this.closeVideoModal, className: 'goals-and-targets-modal' },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              ModalVideoWrapper,
	              { className: isVideoPlaying ? 'is-playing' : '' },
	              _react2.default.createElement('video', {
	                ref: function ref(_ref) {
	                  _this2.videoRef = _ref;
	                },
	                src: this.state.selectedVideo,
	                alt: 'Welcome Video',
	                onClick: this.handlePlayPause,
	                onEnded: function onEnded() {
	                  return _this2.setState({ isVideoPlaying: false });
	                },
	                style: { width: '100%', borderRadius: 10 }
	              }),
	              _react2.default.createElement(
	                PlayPauseButton,
	                { onClick: this.handlePlayPause },
	                isVideoPlaying ? '❚❚' : '▶'
	              ),
	              _react2.default.createElement(
	                CloseModalVideoButton,
	                { onClick: this.closeVideoModal },
	                '\xD7'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          null,
	          'As a result of the net capital raised, your team\u2019s new capital structure is ',
	          (metrics["Debt to Total Capital"] * 100).toFixed(1),
	          '% debt and',
	          " ",
	          ((1 - metrics["Debt to Total Capital"]) * 100).toFixed(1),
	          '% equity.'
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          null,
	          'Lenders will use your capital structure to assess the level of risks of your business and to help determine the rate of interests they will charge on lending you capital (i.e. Cost of Debt).'
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          null,
	          'Equity investors will use your capital structure to assess the risk level of your business to help determine the required rate of return they should expect for taking on the risks (i.e. Cost of Equity).'
	        )
	      );
	    }
	  }]);
	
	  return CapitalStructure;
	}(_react.PureComponent);
	
	exports.default = CapitalStructure;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _MoneyTable = __webpack_require__(396);
	
	var _MoneyTable2 = _interopRequireDefault(_MoneyTable);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cashFlowKeys = [{
	  group: "Operating Activities",
	  rows: [{ key: "Cash received from Customers", label: "Customers" }, { key: "Cash payment for Wages", label: "Wages" }, { key: "Cash payments for Purchases", label: "Suppliers" }, {
	    key: "Cash payments for Operating expenses",
	    label: "Other Operating Expenses"
	  }, { key: "Cash payment for Interests", label: "Interests" }, { key: "Cash payment for Income Taxes", label: "Income Taxes" }, {
	    key: "Total Cash Flows from Operations",
	    label: "Cash Flows from Operations"
	  }]
	}, {
	  group: "Investing Activities",
	  rows: [{ key: "Capital Expenditure Purchases", label: "Capex Purchases" }, { key: "Capital Expenditure Sales", label: "Capex Sales" }, {
	    key: "Total Cash Flows from Investing",
	    label: "Cash Flows from Investing"
	  }]
	}, {
	  group: "Financing Activities",
	  rows: [{
	    fn: function fn(data) {
	      return data["Debt Borrowed"] + data["Stock Issuance"];
	    },
	    label: "Raised Capital"
	  }, {
	    fn: function fn(data) {
	      return data["Debt Repaid"] + data["Stock Repurchase"];
	    },
	    label: "Returned Capital"
	  }, { key: "Dividends", label: "Dividends" }, { key: "Cash Payment for Leases", label: "Cash Payment for Leases" }, {
	    key: "Total Cash Flows from Financing",
	    label: "Cash Flows from Financing"
	  }]
	}, {
	  group: "",
	  rows: [{ key: "Net Change in Cash", label: "Net Cash Received" }, { key: "Beginning Cash", label: "Beginning Cash" }, { key: "Ending Cash", label: "Ending Cash" }]
	}];
	
	var CashFlows = function CashFlows(_ref) {
	  var round = _ref.round,
	      cashFlows = _ref.cashFlows;
	
	  var totalFinancing = cashFlows["Total Cash Flows from Financing"];
	  var totalInvesting = cashFlows["Total Cash Flows from Investing"];
	  var totalOperations = cashFlows["Total Cash Flows from Operations"];
	
	  return _react2.default.createElement(
	    _TwoPanels2.default,
	    { title1: "Cash Flows", title2: "Cash Flows" },
	    _react2.default.createElement(
	      "fragment",
	      null,
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "This section breaks down your cash activities."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "In this game, you start out by raising capital (i.e. Financing Activities). You then used that capital to invest in long lived assets such as your production line lines (i.e. Investing activities). These long-lived assets were then used in your operations, which includes creating, marketing, producing, and selling products to generate revenues and profits (i.e. Operating activities)."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "In Year ",
	        round,
	        ", your team net",
	        " ",
	        totalFinancing > 0 ? "raised" : "returned",
	        " ",
	        (0, _format.moneyFormat)(Math.abs(totalFinancing)),
	        " ",
	        totalFinancing > 0 ? "from" : "to",
	        " investors in financing activities. You also net ",
	        totalInvesting < 0 ? "used" : "received",
	        " ",
	        (0, _format.moneyFormat)(Math.abs(totalInvesting)),
	        " ",
	        totalInvesting < 0 ? "to acquire" : "from sale of",
	        " long lived assets. Lastly, your operation activities resulted in net cash",
	        " ",
	        totalOperations < 0 ? "used" : "received",
	        " of",
	        " ",
	        (0, _format.moneyFormat)(Math.abs(totalOperations))
	      )
	    ),
	    _react2.default.createElement(_MoneyTable2.default, { keys: (0, _MoneyTable.populateKeys)(cashFlowKeys, cashFlows) })
	  );
	};
	
	exports.default = CashFlows;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _utils = __webpack_require__(53);
	
	var _FormulaTable = __webpack_require__(303);
	
	var _FormulaTable2 = _interopRequireDefault(_FormulaTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CostOfCapital = function CostOfCapital(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics,
	      metrics = _ref.metrics;
	
	  var debtWeight = (0, _lodash.min)([metrics["Debt to Total Capital"], 0.99]);
	  var equityWeight = 1 - debtWeight;
	  var costOfDebt = metrics["Bond Yield"] * (1 - metrics["Tax Rate"]);
	  var costOfEquity = metrics["Required Rate of Return"];
	  var wacc = debtWeight * costOfDebt + equityWeight * costOfEquity;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Cost of Capital",
	      chartTitle: "Cost of Capital Ratio",
	      vertical: true,
	      suffix: "%",
	      data: (0, _utils.pickPercent)(teams, competitionMetrics, "WACC"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Your Cost of Capital (i.e. WACC) is the weighted average costs of raising both equity and debt capital."
	    ),
	    _react2.default.createElement(_FormulaTable2.default, {
	      items: [{
	        name: "WACC",
	        highlighted: true,
	        value: (wacc * 100).toFixed(2) + "%"
	      }, { name: "=", highlighted: false, value: "=" }, {
	        name: "Cost of Equity",
	        highlighted: true,
	        value: (costOfEquity * 100).toFixed(2) + "%"
	      }, { name: "×", highlighted: false, value: "×" }, {
	        name: "Equity Weight",
	        highlighted: true,
	        value: (equityWeight * 100).toFixed(2) + "%"
	      }, { name: "+", highlighted: false, value: "+" }, {
	        name: "Cost of Debt",
	        highlighted: true,
	        value: (costOfDebt * 100).toFixed(2) + "%"
	      }, { name: "×", highlighted: false, value: "×" }, {
	        name: "Debt weight",
	        highlighted: true,
	        value: (debtWeight * 100).toFixed(2) + "%"
	      }]
	    }),
	    _react2.default.createElement(
	      _Text2.default,
	      { style: { marginTop: "1em" } },
	      _react2.default.createElement(
	        "b",
	        null,
	        "Note"
	      ),
	      ": Higher cost of capital signals higher risks. Equity investors will use the cost of capital metric to value your team in Round 5 and beyond. This will have a direct impact to your Share Price."
	    ),
	    wacc > 0.5 && _react2.default.createElement(
	      _Text2.default,
	      null,
	      "A 50% cap is placed on your team\u2019s cost of capital ratio"
	    )
	  );
	};
	
	exports.default = CostOfCapital;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _styles = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CostOfDebt = function CostOfDebt(_ref) {
	  var metrics = _ref.metrics;
	  return _react2.default.createElement(
	    _TwoPanels2.default,
	    { title1: "Cost of Debt & Equity", title2: "" },
	    _react2.default.createElement(
	      "fragment",
	      null,
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "Your cost of debt is the weighted average financing costs that you incur from borrowing money across different lenders. It is the interest charges. Your cost of debt is now",
	        " ",
	        (metrics["Bond Yield"] * 100).toFixed(2),
	        "%."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "Your cost of equity is now",
	        " ",
	        (metrics["Required Rate of Return"] * 100).toFixed(2),
	        "%."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "Your cost of equity is the required rate of return that GBorGH Ventures (your equity investor) expects plus a spread if you have any debt."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Note"
	        ),
	        ": If your current costs of equity is higher than investors\u2019 initial required return, then investors are worried about your company having financial distress."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "In this game, financial distress is driven by your debt to capital ratio. For more details, please reviewing the financing section of the MG Business Case."
	      )
	    ),
	    _react2.default.createElement(
	      "fragment",
	      null,
	      _react2.default.createElement(
	        "h3",
	        { style: _styles.blueHeader },
	        "Weighted Average",
	        _react2.default.createElement("br", null),
	        "Interest Rate"
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        {
	          style: { fontSize: "30px", textAlign: "center", marginTop: "1.5em" }
	        },
	        (metrics["Bond Yield"] * 100).toFixed(2),
	        "%"
	      ),
	      _react2.default.createElement(
	        "h3",
	        { style: _styles.blueHeader },
	        "Initial Required Rate of Return"
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        {
	          style: { fontSize: "30px", textAlign: "center", marginTop: "1.5em" }
	        },
	        (metrics["Equity Cost of Capital"] * 100).toFixed(2),
	        "%"
	      )
	    )
	  );
	};
	
	exports.default = CostOfDebt;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _DivFormula = __webpack_require__(211);
	
	var _DivFormula2 = _interopRequireDefault(_DivFormula);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EarningsPerShare = function EarningsPerShare(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Earnings Per Share (EPS)",
	      vertical: true,
	      prefix: "$",
	      data: (0, _utils.pickValue)(teams, competitionMetrics, "Earnings Per Share"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "EPS is a very common metric that investors track to evaluate the performance of a company and assess the value of owning a share of the company. Investors expect the EPS to grow over time."
	    ),
	    _react2.default.createElement(_DivFormula2.default, {
	      sm: true,
	      name1: "EARNINGS PER SHARE (EPS)",
	      name2: "NET PROFITS",
	      name3: "AVERAGE SHARES OUTSTANDING"
	    })
	  );
	};
	
	exports.default = EarningsPerShare;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FPA = function FPA() {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Financial Planning and Analysis (FP&A)" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "In the game, the CEO sets expectation when s/he makes financial projections and in this section, We are going to evaluate the FP&A data to see how well your team was able to meet those expectations."
	    )
	  );
	};
	
	exports.default = FPA;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _styles = __webpack_require__(68);
	
	var _format = __webpack_require__(63);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tdStyle = {
	  padding: ".8em",
	  border: "solid #000000 1px",
	  background: "#FFFFFF",
	  borderBottom: "hidden"
	};
	
	var tdLeft = Object.assign({}, tdStyle, {
	  borderRight: "hidden"
	});
	
	var tdRight = Object.assign({}, tdStyle, {
	  borderLeft: "hidden"
	});
	
	var tdMiddle = Object.assign({}, tdStyle, {
	  borderRight: "hidden",
	  borderLeft: "hidden"
	});
	
	var tdPadding = "10px";
	
	var DiffTable = function DiffTable(_ref) {
	  var tables = _ref.tables;
	  return _react2.default.createElement(
	    "div",
	    null,
	    (0, _lodash.map)(tables, function (table, idx) {
	      return _react2.default.createElement(
	        "div",
	        {
	          key: idx,
	          style: {
	            backgroundColor: "#FFFFFF",
	            padding: "2em",
	            boxShadow: "0 4px 8px rgba(0, 0, 0, .15)",
	            marginTop: idx > 0 ? "20px" : 0,
	            fontFamily: _styles.fontFamily
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "12px",
	              color: "rgba(58, 58, 58, 0.8)",
	              textAlign: "center",
	              marginTop: "-15px"
	            }
	          },
	          "M = Millions"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              fontSize: "16px",
	              fontWeight: "bold"
	            }
	          },
	          table.title
	        ),
	        _react2.default.createElement(
	          "table",
	          {
	            style: {
	              border: "none",
	              marginBottom: "1em",
	              width: "100%",
	              color: "#3a3a3a"
	            }
	          },
	          _react2.default.createElement(
	            "tbody",
	            { style: {} },
	            _react2.default.createElement(
	              "tr",
	              { style: {} },
	              _react2.default.createElement("td", {
	                style: Object.assign({}, tdLeft, {
	                  border: "none",
	                  paddingTop: tdPadding,
	                  paddingBottom: tdPadding
	                })
	              }),
	              _react2.default.createElement(
	                "td",
	                {
	                  style: Object.assign({}, tdMiddle, {
	                    border: "none",
	                    color: "#3a3a3a",
	                    textAlign: "center",
	                    fontSize: "14px",
	                    paddingTop: tdPadding,
	                    paddingBottom: tdPadding,
	                    borderRight: "1px solid #e0e0e0"
	                  })
	                },
	                "Expected"
	              ),
	              _react2.default.createElement(
	                "td",
	                {
	                  style: Object.assign({}, tdMiddle, {
	                    color: "#3a3a3a",
	                    border: "none",
	                    textAlign: "center",
	                    fontSize: "14px",
	                    paddingTop: tdPadding,
	                    paddingBottom: tdPadding,
	                    borderLeft: "1px solid #e0e0e0",
	                    borderRight: "1px solid #e0e0e0"
	                  })
	                },
	                "Actual"
	              ),
	              _react2.default.createElement(
	                "td",
	                {
	                  style: Object.assign({}, tdRight, {
	                    color: "#3a3a3a",
	                    border: "none",
	                    textAlign: "center",
	                    fontSize: "14px",
	                    paddingTop: tdPadding,
	                    paddingBottom: tdPadding,
	                    borderLeft: "1px solid #e0e0e0"
	                  })
	                },
	                "Diff"
	              )
	            ),
	            (0, _lodash.map)(table.data, function (row, index) {
	              return _react2.default.createElement(
	                "tr",
	                { key: index },
	                _react2.default.createElement(
	                  "td",
	                  {
	                    style: Object.assign({}, tdLeft, {
	                      color: "#3a3a3a",
	                      border: "none",
	                      fontSize: "14px",
	                      textAlign: "right",
	                      width: "150px",
	                      paddingTop: tdPadding,
	                      paddingBottom: tdPadding
	                    })
	                  },
	                  row[0]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    style: Object.assign({}, tdMiddle, {
	                      color: index === table.data.length - 1 ? "#fff" : "#3a3a3a",
	                      border: "none",
	                      fontSize: "16px",
	                      textAlign: "center",
	                      fontWeight: "bold",
	                      paddingTop: tdPadding,
	                      paddingBottom: tdPadding,
	                      borderRight: "1px solid #e0e0e0"
	                    })
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: index === table.data.length - 1 ? {
	                        backgroundColor: "#52c5cd",
	                        display: "inline-block",
	                        paddingLeft: "5px",
	                        paddingRight: "5px",
	                        minWidth: "85px"
	                      } : row[0] === "Total Cost of Sales" ? {
	                        backgroundColor: "rgba(82, 197, 205, 0.3)",
	                        display: "inline-block",
	                        paddingLeft: "5px",
	                        paddingRight: "5px",
	                        minWidth: "85px"
	                      } : {}
	                    },
	                    _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                      value: row[1],
	                      prefix: row[4],
	                      decimalPrecision: row[5],
	                      forceConvert: row[6]
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    style: Object.assign({}, tdMiddle, {
	                      color: index === table.data.length - 1 ? "#fff" : "#383838",
	                      border: "none",
	                      fontSize: "16px",
	                      textAlign: "center",
	                      fontWeight: "bold",
	                      paddingTop: tdPadding,
	                      paddingBottom: tdPadding,
	                      borderLeft: "1px solid #e0e0e0",
	                      borderRight: "1px solid #e0e0e0"
	                    })
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    {
	                      style: index === table.data.length - 1 ? {
	                        backgroundColor: "#52c5cd",
	                        display: "inline-block",
	                        paddingLeft: "5px",
	                        paddingRight: "5px",
	                        minWidth: "85px"
	                      } : row[0] === "Total Cost of Sales" ? {
	                        backgroundColor: "rgba(82, 197, 205, 0.3)",
	                        display: "inline-block",
	                        paddingLeft: "5px",
	                        paddingRight: "5px",
	                        minWidth: "85px"
	                      } : {}
	                    },
	                    _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                      value: row[2],
	                      prefix: row[4],
	                      decimalPrecision: row[5],
	                      forceConvert: row[6]
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    style: Object.assign({}, tdRight, {
	                      color: row[3] < 0 ? "#ff0000" : "#383838",
	                      border: "none",
	                      fontSize: "16px",
	                      textAlign: "center",
	                      fontWeight: "bold",
	                      paddingTop: tdPadding,
	                      paddingBottom: tdPadding,
	                      borderLeft: "1px solid #e0e0e0"
	                    })
	                  },
	                  row[3],
	                  "%"
	                )
	              );
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	function getDataValue(data, round, field, is_actual, roundId) {
	  var row = data.find(function (i) {
	    return i.target_round_number === round && i.is_actual === is_actual && i.round === roundId;
	  });
	
	  if (row && field in row) {
	    return row[field];
	  }
	
	  return 0;
	}
	
	function getExpected(data, round, field, roundId) {
	  return getDataValue(data, round, field, false, roundId);
	}
	
	function getActual(data, round, field, roundId) {
	  return getDataValue(data, round, field, true, roundId);
	}
	
	function getDiff(expected, actual) {
	  if (expected === 0 || actual === 0) {
	    return 0;
	  }
	
	  return Number(((actual - expected) / Math.abs(expected) * 100).toFixed(2));
	}
	
	function getRevenues(round, roundId, data) {
	  var unitsExpected = Math.abs(getExpected(data, round, "units_sold", roundId));
	  var unitsActual = Math.abs(getActual(data, round, "units_sold", roundId));
	  var unitsDiff = getDiff(unitsExpected, unitsActual);
	
	  var avgSellingPriceExpected = getExpected(data, round, "average_selling_price", roundId);
	  var avgSellingPriceActual = getActual(data, round, "average_selling_price", roundId);
	  var avgSellingPriceDiff = getDiff(avgSellingPriceExpected, avgSellingPriceActual);
	
	  var totalRevenuesExpected = getExpected(data, round, "total_revenues", roundId);
	  var totalRevenuesActual = getActual(data, round, "total_revenues", roundId);
	  var totalRevenuesDiff = getDiff(totalRevenuesExpected, totalRevenuesActual);
	
	  return [["Units", unitsExpected, unitsActual, unitsDiff, "", 0, false], ["Avg. Selling Price", avgSellingPriceExpected, avgSellingPriceActual, avgSellingPriceDiff, "$", 2, false], ["Total Revenues", totalRevenuesExpected, totalRevenuesActual, totalRevenuesDiff, "$", 2, true]];
	}
	
	function getGrossProfits(round, roundId, data) {
	  var unitsExpected = Math.abs(getExpected(data, round, "units_sold", roundId));
	  var unitsActual = Math.abs(getActual(data, round, "units_sold", roundId));
	  var unitsDiff = getDiff(unitsExpected, unitsActual);
	
	  var avgUnitCostsExpected = getExpected(data, round, "average_unit_costs", roundId);
	  var avgUnitCostsActual = getActual(data, round, "average_unit_costs", roundId);
	  var avgUnitCostsDiff = getDiff(avgUnitCostsExpected, avgUnitCostsActual);
	
	  var totalCostOfSalesExpected = getExpected(data, round, "total_cost_goods_sold", roundId);
	  var totalCostOfSalesActual = getActual(data, round, "total_cost_goods_sold", roundId);
	  var totalCostOfSalesDiff = getDiff(totalCostOfSalesExpected, totalCostOfSalesActual);
	
	  var grossProfitsExpected = getExpected(data, round, "gross_profits", roundId);
	  var grossProfitsActual = getActual(data, round, "gross_profits", roundId);
	  var grossProfitsDiff = getDiff(grossProfitsExpected, grossProfitsActual);
	
	  return [["Units", unitsExpected, unitsActual, unitsDiff, "", 0, false], ["Avg. Units Costs", avgUnitCostsExpected, avgUnitCostsActual, avgUnitCostsDiff, "$", 2, false], ["Total Cost of Sales", totalCostOfSalesExpected, totalCostOfSalesActual, totalCostOfSalesDiff, "$", 2, true], ["Gross Profits", grossProfitsExpected, grossProfitsActual, grossProfitsDiff, "$", 2, true]];
	}
	
	function getNetProfits(round, roundId, data, incomeStatement) {
	
	  var expensesExpected = getExpected(data, round, "total_operating_costs", roundId) + getExpected(data, round, "total_non_operating_costs", roundId);
	  var expensesActual = getActual(data, round, "total_operating_costs", roundId) + getActual(data, round, "total_non_operating_costs", roundId);
	  var expensesDiff = getDiff(expensesExpected, expensesActual);
	
	  var grossIncomeExpected = getExpected(data, round, "income_before_taxes", roundId);
	  var grossIncomeActual = getActual(data, round, "income_before_taxes", roundId);
	  var grossIncomeDiff = getDiff(grossIncomeExpected, grossIncomeActual);
	
	  var netProfitsExpected = getExpected(data, round, "net_income", roundId);
	  var netProfitsActual = incomeStatement['Net Income'];
	  var netProfitsDiff = getDiff(netProfitsExpected, netProfitsActual);
	
	  return [["Expenses", expensesExpected, expensesActual, expensesDiff, "$", 2, true], ["Income Before Taxes", grossIncomeExpected, grossIncomeActual, grossIncomeDiff, "$", 2, true], ["Net Profits", netProfitsExpected, netProfitsActual, netProfitsDiff, "$", 2, true]];
	}
	
	var FPAIncomeStatement = function FPAIncomeStatement(_ref2) {
	  var round = _ref2.round,
	      teamId = _ref2.teamId,
	      teams = _ref2.teams,
	      incomeStatement = _ref2.incomeStatement,
	      financialAnalysis = _ref2.financialAnalysis,
	      rounds = _ref2.rounds;
	
	  var roundObj = rounds.find(function (r) {
	    return r.number === round;
	  });
	  var roundId = roundObj ? roundObj.id : 0;
	  var teamName = (0, _lodash.find)(teams, function (team) {
	    return team["id"] === teamId;
	  }).name;
	
	  return _react2.default.createElement(
	    "div",
	    { style: _styles.dFlex },
	    _react2.default.createElement(
	      _OnePanel2.default,
	      { title: "Income Statement", style: _styles.flex1 },
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "The FP&A (to the right) is comparing your expected vs. actual Income Statement.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "In this round, your CEO expected Team ",
	        teamName,
	        " to generate net profits of ",
	        (0, _format.moneyFormat)(financialAnalysis.net_income),
	        ", but Team",
	        " ",
	        teamName,
	        " actually generated net profits of",
	        " ",
	        (0, _format.moneyFormat)(incomeStatement["Net Income"]),
	        ".",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Was your expectation too bullish or bearish?"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: Object.assign({}, _styles.flex1, _styles.dFlexC, { marginLeft: "2em" }) },
	      _react2.default.createElement(DiffTable, {
	        tables: [{
	          title: "Revenues",
	          data: getRevenues(round, roundId, financialAnalysis)
	        }, {
	          title: "Gross Profits",
	          data: getGrossProfits(round, roundId, financialAnalysis)
	        }, {
	          title: "Net Profits",
	          data: getNetProfits(round, roundId, financialAnalysis, incomeStatement)
	        }]
	      })
	    )
	  );
	};
	
	exports.default = FPAIncomeStatement;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinancialStatements = function FinancialStatements() {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Financial Statements" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "This section covers your financial statements."
	    )
	  );
	};
	
	exports.default = FinancialStatements;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinancingAnalysis = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Financing Analysis" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "This section we are going to review Head of Finance decisions and how they impact your Income Statement."
	    )
	  );
	});
	
	exports.default = FinancingAnalysis;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Title = __webpack_require__(572);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GradesRanks = function GradesRanks(_ref) {
	  var round = _ref.round,
	      targets = _ref.targets;
	
	  var metricTitles = {
	    market_share: "Market Share",
	    net_revenues: "Net Revenues",
	    gross_margin: "Gross Margins",
	    stock_price: "Share Price",
	    roa: "Return on Assets (ROA)",
	    roe: "Return on Equity (ROE)",
	    earnings_per_share: "Earnings Per Share"
	  };
	
	  // Get the non-zero metrics from targets
	  var getNonZeroMetrics = function getNonZeroMetrics() {
	    if (!targets) return [];
	
	    var metricsToCheck = ['market_share', 'net_revenues', 'gross_margin', 'stock_price', 'roa', 'roe', 'earnings_per_share'];
	
	    return metricsToCheck.filter(function (metric) {
	      var value = parseFloat(targets[metric]);
	      return value > 0;
	    }).map(function (metric) {
	      return metricTitles[metric];
	    });
	  };
	
	  var activeMetrics = getNonZeroMetrics();
	
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Metrics That Drive Your Grade & Ranking" },
	    _react2.default.createElement(
	      "div",
	      { style: Object.assign({}, _styles.dFlex, { alignItems: "flex-start" }) },
	      _react2.default.createElement(
	        "div",
	        { style: _styles.flex1 },
	        _react2.default.createElement(
	          _Text2.default,
	          null,
	          "For Year",
	          " ",
	          round <= 2 ? "1" : round === 3 ? "3" : "4 and beyond",
	          ", these are 4 metrics that will drive your team grade & ranking"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: Object.assign({}, _styles.flex1, { textAlign: "center" }) },
	        activeMetrics.map(function (metric, index) {
	          return _react2.default.createElement(
	            _Title2.default,
	            { key: metric },
	            index + 1,
	            ". ",
	            metric
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = GradesRanks;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _DivFormula = __webpack_require__(211);
	
	var _DivFormula2 = _interopRequireDefault(_DivFormula);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GrossMargins = function GrossMargins(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      vertical: true,
	      title: "Gross Margins",
	      suffix: "%",
	      data: (0, _utils.pickPercent)(teams, competitionMetrics, "Gross Margin"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Gross Margins is a percentage that measures the spread between the revenues that you generated from selling a product with the cost of producing that product."
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "For example, if Apple generates a total of $100 in sales from selling the iPhone, but it cost Apple $30 to produce the iPhone, then iPhone's gross margin would be 70% (i.e. $100 - $30) / $100."
	    ),
	    _react2.default.createElement(_DivFormula2.default, {
	      sm: true,
	      name1: "GROSS MARGINS",
	      name2: "REVENUES - COST OF SALES",
	      name3: "REVENUES"
	    })
	  );
	};
	
	exports.default = GrossMargins;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Formula = __webpack_require__(570);
	
	var _Formula2 = _interopRequireDefault(_Formula);
	
	var _IncomeStatement = __webpack_require__(395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImpactOfDebt = function ImpactOfDebt(_ref) {
	  var incomeStatement = _ref.incomeStatement;
	
	  var interestExpense = incomeStatement["Interest Expense"];
	
	  return _react2.default.createElement(
	    _TwoPanels2.default,
	    {
	      title1: "Financial Impact of Holding Debt",
	      title2: "IncomeStatement"
	    },
	    _react2.default.createElement(
	      "fragment",
	      null,
	      interestExpense !== 0 ? _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Interest Expense"
	        ),
	        ": Your Interest Expense of",
	        " ",
	        (0, _format.moneyFormat)(interestExpense),
	        " was driven by the weighted average interest rate your lenders charged you given the amount of money you borrowed."
	      ) : null,
	      _react2.default.createElement(
	        _Formula2.default,
	        null,
	        "Interest Expense = Money Borrowed x Interest Rates"
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "In this game, lenders determine your interest rates based on your debt to capital ratio. For more details, please review the MG Business Case."
	      )
	    ),
	    _react2.default.createElement(_IncomeStatement.IncomeStatementPanel, { sheet: incomeStatement })
	  );
	};
	
	exports.default = ImpactOfDebt;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _recompose = __webpack_require__(55);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _GenericTable = __webpack_require__(394);
	
	var _GenericTable2 = _interopRequireDefault(_GenericTable);
	
	var _format = __webpack_require__(63);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InventoryManagement = (0, _recompose.pure)(function (_ref) {
	  var inventoryBalances = _ref.inventoryBalances,
	      competitiveAnalysis = _ref.competitiveAnalysis,
	      teams = _ref.teams,
	      constants = _ref.constants,
	      products = _ref.products,
	      teamId = _ref.teamId,
	      competitionMetrics = _ref.competitionMetrics,
	      rounds = _ref.rounds,
	      round = _ref.round;
	
	  var data = _Auth2.default.getPosition() === "Student" ? competitiveAnalysis : competitionMetrics;
	  var roundId = rounds.find(function (i) {
	    return i.number === round;
	  }).id;
	  var teamInventory = (0, _lodash.filter)(inventoryBalances, function (item) {
	    return item.team == teamId && item.round == roundId || item.round_number == round || !item.team && !item.round;
	  });
	  var chartData = (0, _lodash.map)(teams, function (team) {
	    return {
	      name: team.name,
	      value: (0, _lodash.sumBy)((0, _lodash.filter)(data, function (item) {
	        return item.team === team.id;
	      }), "Available For Sale")
	    };
	  });
	
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Inventory Management",
	      chartTitle: "Volume",
	      data: chartData,
	      format: _format.numberFormatM,
	      teams: teams,
	      yaxisFormatter: _format.numberFormat
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      (0, _format.numberFormat)((0, _lodash.sumBy)(teamInventory, "units_sold")),
	      " of units available for sale were sold, leaving",
	      " ",
	      (0, _format.numberFormat)((0, _lodash.sumBy)(teamInventory, "ending_inventory")),
	      " of unsold inventory. All teams incur a",
	      " ",
	      (constants["holding_rate"] * 100).toFixed(1),
	      "% costs of holding ending inventory."
	    ),
	    _react2.default.createElement(_GenericTable2.default, {
	      header: [{ name: "Product Name", highlighted: true }, { name: "Available for Sales", highlighted: true }, { name: "", highlighted: false }, { name: "Units Sold", highlighted: true }, { name: "", highlighted: false }, { name: "Ending Inventory", highlighted: true }],
	      rows: (0, _lodash.map)(teamInventory, function (item) {
	        return [((0, _lodash.find)(products, function (product) {
	          return product.id === item.product;
	        }) || {}).name, (0, _format.numberFormat)(item["available_for_sale"]), "-", (0, _format.numberFormat)(item["units_sold"]), "=", (0, _format.numberFormat)(item["ending_inventory"])];
	      })
	    }),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Note"
	      ),
	      ": Units available for sale is the combination of your beginning inventory plus any units produced in the current round."
	    )
	  );
	});
	
	exports.default = InventoryManagement;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _utils = __webpack_require__(53);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Lead Time gets its own dedicated MetricsReport fetch with
	// include=lead_scores so weighted_lead_time (and any future
	// per-product lead_score breakdowns) are guaranteed to be present
	// without piggybacking on the shared Analysis fetch.
	var LeadTime = function (_PureComponent) {
	  _inherits(LeadTime, _PureComponent);
	
	  function LeadTime(props) {
	    _classCallCheck(this, LeadTime);
	
	    var _this = _possibleConstructorReturn(this, (LeadTime.__proto__ || Object.getPrototypeOf(LeadTime)).call(this, props));
	
	    _this.fetch = function () {
	      var roundId = _this.props.roundId;
	
	      if (!roundId) return;
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = currentTeam ? Number(currentTeam.competition) : null;
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId || null, roundId, { include: 'lead_scores' }).then(function (data) {
	        if (_this._mounted) _this.setState({ reports: data, loading: false });
	      }).catch(function () {
	        if (_this._mounted) _this.setState({ loading: false });
	      });
	    };
	
	    _this.state = {
	      reports: null,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(LeadTime, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.fetch();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.roundId !== this.props.roundId) {
	        this.fetch();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._mounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          teamId = _props.teamId,
	          teams = _props.teams,
	          competitionMetrics = _props.competitionMetrics;
	      var _state = this.state,
	          reports = _state.reports,
	          loading = _state.loading;
	
	
	      if (loading && !reports) {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true });
	      }
	
	      var teamsIds = teams.map(function (i) {
	        return Number(i.id);
	      });
	      var data = _Auth2.default.getPosition() === 'Student' ? reports ? reports.filter(function (i) {
	        return teamsIds.includes(Number(i.team));
	      }) : [] : competitionMetrics ? competitionMetrics.map(function (i) {
	        return Object.assign({}, i, {
	          weighted_lead_time: i['Weighted Lead Time'] || 0
	        });
	      }) : [];
	      var obj = data.find(function (i) {
	        return Number(i.team) === teamId;
	      });
	      // Guard against null/undefined — Year 1 rows can arrive with the
	      // field unset, and .toFixed on null throws mid-render.
	      var weightedLeadTime = (Number(obj && obj.weighted_lead_time) || 0).toFixed(2);
	      var chartData = (0, _utils.pickValue)(teams, data, 'weighted_lead_time').map(function (i) {
	        return Object.assign({}, i, {
	          value: Number((i.value || 0).toFixed(2))
	        });
	      });
	
	      return _react2.default.createElement(
	        _OnePanelChart2.default,
	        {
	          title: "Lead Time",
	          chartTitle: "WEIGHTED LEAD TIME",
	          vertical: true,
	          suffix: " hrs",
	          data: chartData,
	          teams: teams
	        },
	        _react2.default.createElement(
	          _Text2.default,
	          null,
	          "Your team's weighted lead time is ",
	          _react2.default.createElement(
	            "b",
	            null,
	            weightedLeadTime
	          ),
	          " hours. Lead time is how long it takes your product to travel from your inventory to a customer after they place an order. The number is weighted by customer demand, so greater demand pulls more weight in the average. A shorter lead time means faster delivery, which makes customers more likely to pick you over a slower competitor."
	        )
	      );
	    }
	  }]);
	
	  return LeadTime;
	}(_react.PureComponent);
	
	exports.default = LeadTime;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _DivFormula = __webpack_require__(211);
	
	var _DivFormula2 = _interopRequireDefault(_DivFormula);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketShare = function MarketShare(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Market Share",
	      suffix: "%",
	      data: (0, _utils.pickPercent)(teams, competitionMetrics, "Market Share"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Market Share represents the percentage of total sales that your business has captured within a market within a period of time. It is calculated by taking your business sales and dividing it by the total of all sales."
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "For example, if Apple sold 36 smartphones in 2017 and there were a total of 100 smartphones sold in 2017, then Apple held 36% market share (i.e. 36% = 36/100)."
	    ),
	    _react2.default.createElement(_DivFormula2.default, {
	      name1: "MARKET SHARE",
	      name2: "YOUR UNIT SALES",
	      name3: "TOTAL INDUSTRY SALES"
	    })
	  );
	};
	
	exports.default = MarketShare;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingAnalysis = function MarketingAnalysis() {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Marketing Analysis" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "This section we are going to review Head of Product and Marketing decisions and how they impact your Income Statement."
	    )
	  );
	};
	
	exports.default = MarketingAnalysis;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Title = __webpack_require__(572);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _marketCaptureChart = __webpack_require__(1439);
	
	var _marketCaptureChart2 = _interopRequireDefault(_marketCaptureChart);
	
	var _format = __webpack_require__(63);
	
	var _utils = __webpack_require__(53);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingAnalysis1 = function MarketingAnalysis1(_ref) {
	  var competitiveAnalysis = _ref.competitiveAnalysis,
	      teams = _ref.teams,
	      competitiveAnalysisTeam = _ref.competitiveAnalysisTeam,
	      totalDemand = _ref.totalDemand,
	      competitionMetrics = _ref.competitionMetrics;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var team = competitiveAnalysisTeam;
	  var unitsSold = (0, _lodash.sumBy)(data, function (team) {
	    return -team["Units Sold"];
	  });
	  var totalDemandAuto = totalDemand.auto;
	  var totalDemandMobile = totalDemand.mobile;
	  var colors = (0, _utils.teamColors)(teams, data);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { display: "flex", flexDirection: "row" } },
	    _react2.default.createElement(
	      _OnePanel2.default,
	      { title: "Market Capture", style: { flex: "1" } },
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "In this round, the market demanded",
	        " ",
	        (0, _format.numberFormat)(team["Market Demand"]),
	        " units of image sensors and overall units sold were ",
	        (0, _format.numberFormat)(unitsSold),
	        "."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "Your team was able to capture",
	        " ",
	        (-team["Units Sold"] / unitsSold * 100).toFixed(1),
	        "% of the overall units sold."
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "You had",
	        " ",
	        (0, _format.numberFormat)(team["Available For Sale"] + team["Units Sold"]),
	        " units of inventory remaining."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { flex: "1" } },
	      _react2.default.createElement(
	        _Title2.default,
	        { style: { textAlign: "center" } },
	        "MARKET CAPTURE - MOBILE"
	      ),
	      _react2.default.createElement(_marketCaptureChart2.default, {
	        data: (0, _lodash.map)((0, _utils.pickValue)(teams, data, "Units Sold Mobile"), function (item) {
	          return Object.assign({}, item, {
	            value: -item.value
	          });
	        }),
	        colors: colors,
	        totalDemand: totalDemandMobile
	      }),
	      _react2.default.createElement(
	        _Title2.default,
	        { style: { textAlign: "center" } },
	        "MARKET CAPTURE - AUTO"
	      ),
	      _react2.default.createElement(_marketCaptureChart2.default, {
	        data: (0, _lodash.map)((0, _utils.pickValue)(teams, data, "Units Sold Auto"), function (item) {
	          return Object.assign({}, item, {
	            value: -item.value
	          });
	        }),
	        colors: colors,
	        totalDemand: totalDemandAuto
	      })
	    )
	  );
	};
	
	exports.default = MarketingAnalysis1;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 320px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #ffffff;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  white-space: normal;\n  text-align: left;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 20;\n\n  p {\n    margin: 0 0 8px;\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 320px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #ffffff;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  white-space: normal;\n  text-align: left;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 20;\n\n  p {\n    margin: 0 0 8px;\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(0, 27, 59, 0.4);\n  color: rgba(0, 27, 59, 0.6);\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n  user-select: none;\n\n  &:hover {\n    border-color: rgba(0, 27, 59, 0.7);\n    color: rgba(0, 27, 59, 0.85);\n  }\n\n  &:hover ", ",\n  &:focus-within ", " {\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(0, 27, 59, 0.4);\n  color: rgba(0, 27, 59, 0.6);\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n  user-select: none;\n\n  &:hover {\n    border-color: rgba(0, 27, 59, 0.7);\n    color: rgba(0, 27, 59, 0.85);\n  }\n\n  &:hover ", ",\n  &:focus-within ", " {\n    opacity: 1;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _format = __webpack_require__(63);
	
	var _utils = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Hover-only help affordance next to the panel title. CSS-only tooltip
	// (no state/JS) so it doesn't fight with recharts' animation timers.
	// Reuses the same visual language as ActivationTooltip in round-admin.
	var TitleWrap = _styledComponents2.default.span(_templateObject);
	
	var HelpTooltip = _styledComponents2.default.div(_templateObject2);
	
	var HelpHover = _styledComponents2.default.span(_templateObject3, HelpTooltip, HelpTooltip);
	
	var AwarenessTitle = function AwarenessTitle() {
	  return _react2.default.createElement(
	    TitleWrap,
	    null,
	    "Awareness",
	    _react2.default.createElement(
	      HelpHover,
	      { tabIndex: 0, "aria-label": "What is Awareness?" },
	      "?",
	      _react2.default.createElement(
	        HelpTooltip,
	        { role: "tooltip" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Awareness measures how visible your product is to interested customers."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Spending on the right promotional channels lifts it, but returns diminish. After a point, extra dollars don\u2019t buy much more awareness."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Awareness also fades about 25% each round, so invest every round to stay visible."
	        )
	      )
	    )
	  );
	};
	
	var MarketingAwareness = function MarketingAwareness(_ref) {
	  var competitiveAnalysis = _ref.competitiveAnalysis,
	      teamId = _ref.teamId,
	      incomeStatement = _ref.incomeStatement,
	      teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var team = (0, _utils.getTeam)(teamId, data);
	
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: _react2.default.createElement(AwarenessTitle, null),
	      chartTitle: "PRODUCT AWARENESS",
	      vertical: true,
	      suffix: "%",
	      data: (0, _utils.pickPercent)(teams, data, "Product Awareness"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Your team spent ",
	      (0, _format.moneyFormat)(-incomeStatement["Promotion Costs"]),
	      " in marketing to drive overall product awareness to",
	      " ",
	      (team["Product Awareness"] * 100).toFixed(2),
	      "%."
	    )
	  );
	};
	
	exports.default = MarketingAwareness;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _recharts = __webpack_require__(27);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _MetricsService = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Y-axis tick formatter: "$1.2M" / "$45k" / "$800".
	var moneyTick = function moneyTick(value) {
	  var n = Number(value) || 0;
	  if (Math.abs(n) >= 1e6) return "$" + (n / 1e6).toFixed(1) + "M";
	  if (Math.abs(n) >= 1e3) return "$" + (n / 1e3).toFixed(0) + "k";
	  return "$" + n.toFixed(0);
	};
	
	var tooltipFormatter = function tooltipFormatter(value) {
	  return "$" + Number(value || 0).toLocaleString("en-US");
	};
	
	// Aggregate the metricsReports.promos rows into one row per marketing
	// client with a per-team spend column. Sums across all products a team
	// promoted on that channel.
	var buildChartData = function buildChartData(metricsReports, teams) {
	  var clientById = {};
	  metricsReports.forEach(function (report) {
	    (report.promos || []).forEach(function (p) {
	      var id = p.marketing_client_id;
	      if (id != null && !clientById[id]) {
	        clientById[id] = p.marketing_client_name || "Client " + id;
	      }
	    });
	  });
	
	  var clientIds = Object.keys(clientById);
	  return clientIds.map(function (idStr) {
	    var id = Number(idStr);
	    var row = { client: clientById[idStr] };
	    teams.forEach(function (team) {
	      var teamReport = metricsReports.find(function (r) {
	        return Number(r.team) === Number(team.id);
	      });
	      var spend = teamReport ? (teamReport.promos || []).filter(function (p) {
	        return Number(p.marketing_client_id) === id;
	      }).reduce(function (s, p) {
	        return s + (Number(p.spend) || 0);
	      }, 0) : 0;
	      row[team.name] = spend;
	    });
	    return row;
	  });
	};
	
	// Marketing Channel Spend runs its own dedicated MetricsReport fetch
	// with include=product_awareness so per-team promos[] arrays are
	// present. The shared Analysis fetch is left include-free because
	// the backend's product_awareness include reshapes the response and
	// drops unrelated fields (e.g. Available For Sale, which broke
	// Inventory Management).
	
	var MarketingChannelSpend = function (_PureComponent) {
	  _inherits(MarketingChannelSpend, _PureComponent);
	
	  function MarketingChannelSpend(props) {
	    _classCallCheck(this, MarketingChannelSpend);
	
	    var _this = _possibleConstructorReturn(this, (MarketingChannelSpend.__proto__ || Object.getPrototypeOf(MarketingChannelSpend)).call(this, props));
	
	    _this.fetch = function () {
	      var roundId = _this.props.roundId;
	
	      if (!roundId) return;
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = currentTeam ? Number(currentTeam.competition) : null;
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId || null, roundId, { include: 'product_awareness' }).then(function (data) {
	        if (_this._mounted) _this.setState({ reports: data, loading: false });
	      }).catch(function () {
	        if (_this._mounted) _this.setState({ loading: false });
	      });
	    };
	
	    _this.state = {
	      reports: null,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(MarketingChannelSpend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.fetch();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.roundId !== this.props.roundId) {
	        this.fetch();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._mounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          teams = _props.teams,
	          teamId = _props.teamId;
	      var _state = this.state,
	          reports = _state.reports,
	          loading = _state.loading;
	
	
	      if (loading && !reports) {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true });
	      }
	
	      var safeTeams = teams || [];
	      var chartData = buildChartData(reports || [], safeTeams);
	      var currentTeam = safeTeams.find(function (t) {
	        return Number(t.id) === Number(teamId);
	      });
	
	      var chart = _react2.default.createElement(
	        _recharts.ResponsiveContainer,
	        { width: "100%", height: 360 },
	        _react2.default.createElement(
	          _recharts.BarChart,
	          {
	            data: chartData,
	            layout: "vertical",
	            barSize: 18,
	            margin: { top: 12, right: 16, left: 4, bottom: 12 }
	          },
	          _react2.default.createElement(_recharts.CartesianGrid, { strokeDasharray: "3 3", horizontal: false }),
	          _react2.default.createElement(_recharts.XAxis, {
	            type: "number",
	            tickFormatter: moneyTick,
	            tick: { fontSize: 12 }
	          }),
	          _react2.default.createElement(_recharts.YAxis, {
	            type: "category",
	            dataKey: "client",
	            tick: { fontSize: 12 },
	            width: 100,
	            interval: 0
	          }),
	          _react2.default.createElement(_recharts.Tooltip, { formatter: tooltipFormatter }),
	          safeTeams.map(function (team) {
	            return _react2.default.createElement(_recharts.Bar, {
	              key: team.id,
	              dataKey: team.name,
	              stackId: "channels",
	              fill: (0, _Teams.colorForTeamId)(safeTeams, team.id)
	            });
	          })
	        )
	      );
	
	      return _react2.default.createElement(
	        _OnePanelChart2.default,
	        {
	          title: "Marketing Channel Spend",
	          chartTitle: "MARKETING CHANNEL SPEND",
	          customChart: chart,
	          teams: safeTeams
	        },
	        _react2.default.createElement(
	          _Text2.default,
	          null,
	          "The chart on the right reflects the channels that teams are spending on to create awareness of their products. Each horizontal bar is one channel and the stacked segments show how much each team allocated to it this round."
	        ),
	        currentTeam ? _react2.default.createElement(
	          _Text2.default,
	          null,
	          "Find ",
	          _react2.default.createElement(
	            "b",
	            null,
	            currentTeam.name
	          ),
	          " in the legend to see how your allocation compares to the rest of the competition."
	        ) : null
	      );
	    }
	  }]);
	
	  return MarketingChannelSpend;
	}(_react.PureComponent);
	
	exports.default = MarketingChannelSpend;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingNoUnitsSold1 = function MarketingNoUnitsSold1(_ref) {
	  var financials = _ref.financials,
	      round = _ref.round;
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "No Units Sold - Insufficient Capital" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Your business weren\u2019t able to sell any units of the following products this round because your cash balance of",
	      " ",
	      (0, _format.moneyFormat)(financials["net_cash_balance_from_finance"] + financials["prev_cash"]),
	      " ",
	      "was not sufficient to execute your total spending request of",
	      " ",
	      (0, _format.moneyFormat)(financials["net_cash_balance_from_opinv"]),
	      " in Year ",
	      round,
	      ". Therefore, your requests (i.e. decisions) were not accepted. Going forward, please ensure that Finance has sufficient capital."
	    )
	  );
	};
	
	exports.default = MarketingNoUnitsSold1;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketingNoUnitsSold2 = function (_Component) {
	  _inherits(MarketingNoUnitsSold2, _Component);
	
	  function MarketingNoUnitsSold2() {
	    _classCallCheck(this, MarketingNoUnitsSold2);
	
	    return _possibleConstructorReturn(this, (MarketingNoUnitsSold2.__proto__ || Object.getPrototypeOf(MarketingNoUnitsSold2)).apply(this, arguments));
	  }
	
	  _createClass(MarketingNoUnitsSold2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _TwoPanels2.default,
	        {
	          title1: "Little to No Units Sold - Product Market Fit",
	          title2: "Potential Reasons"
	        },
	        _react2.default.createElement(
	          "fragment",
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            null,
	            "Your business didn\u2019t sell any units this round because the Marketing Mix of the following products did not meet any of the 14 customer requirements and therefore, no customer bought the following products."
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "ul",
	              null,
	              "Product Name",
	              _react2.default.createElement(
	                "li",
	                null,
	                "Mob 1"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Mob 2"
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                "Mob 3"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "fragment",
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Minimum Requirements:"
	            ),
	            " Product did not meet minimum customer requirements. Please review Customer Analysis and cross-refeerence their perferences with your product's features."
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Pricing and Feature Preferences:"
	            ),
	            "Product's pricing and features were not aligned with customers. If pricing was out of mobile customers range, then your mobile market potentional is reduced to 25% or less and 0% if the price was $15.00 or higher. If pricing was out of auto customers range, then your auto market potentional is reduced to 25% or less and 0% if the price was $40.00 or higher."
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            null,
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Sales Channel Preferences:"
	            ),
	            " Product's distribution channels were not alignd with customers. The misalignment would further reduce your market potentional by 50%."
	          )
	        )
	      );
	    }
	  }]);
	
	  return MarketingNoUnitsSold2;
	}(_react.Component);
	
	exports.default = MarketingNoUnitsSold2;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _lodash = __webpack_require__(21);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _recompose = __webpack_require__(55);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _GenericTable = __webpack_require__(394);
	
	var _GenericTable2 = _interopRequireDefault(_GenericTable);
	
	var _styles = __webpack_require__(68);
	
	var _utils = __webpack_require__(53);
	
	var _utils2 = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var calculateReleaseDate = function calculateReleaseDate(product, rounds) {
	  var total_duration = product.total_duration;
	
	  var round = rounds.find(function (i) {
	    return i.id === product.round;
	  });
	
	  var duration = total_duration;
	  if (round && round.number > 1 && duration >= 12) {
	    duration += (round.number - 1) * 12;
	  }
	
	  var year = parseInt((duration - 1) / 12, 10);
	  var quarter = duration - year * 12;
	
	  year += 1;
	  quarter = quarter / 3 + 1;
	  if (quarter >= 5) {
	    quarter -= 4;
	    year += 1;
	  }
	
	  if (round && year < round.number) {
	    year = round.number;
	  }
	
	  return "Year " + year + ", Q" + quarter;
	};
	
	var popoverComponent = function popoverComponent(product, rounds) {
	  return _react2.default.createElement(
	    _reactBootstrap.Popover,
	    {
	      id: "popover-product-features-" + product.id,
	      title: "Product's Features",
	      bsClass: "map-popover popover"
	    },
	    _react2.default.createElement(
	      "b",
	      null,
	      "Resolution:"
	    ),
	    " ",
	    product.pixels_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Sensitivity:"
	    ),
	    " ",
	    product.sensitivity_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Power:"
	    ),
	    " ",
	    product.power_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Temperature:"
	    ),
	    " ",
	    product.temp_range_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Release Date:"
	    ),
	    " ",
	    calculateReleaseDate(product, rounds)
	  );
	};
	
	// BE now returns rank_auto: 0 (or rank_mobile: 0) for products the
	// segment's customers have no interest in (feature/price mismatch).
	// Those rows are tacked on to the end of the array with a `note`
	// field. Exclude them from segment-scoped Top-N lists; for the
	// mixed team-specific table below, show "N/A" instead of "0th".
	var formatRankCell = function formatRankCell(rank) {
	  return rank === 0 ? "N/A" : (0, _utils2.numericSuffix)(rank);
	};
	
	var TopTable = (0, _recompose.pure)(function (_ref) {
	  var data = _ref.data,
	      rounds = _ref.rounds;
	  return _react2.default.createElement(
	    "div",
	    { style: { marginTop: "2em", marginBottom: "1.5em" } },
	    _react2.default.createElement(
	      "table",
	      null,
	      _react2.default.createElement(
	        "tbody",
	        null,
	        (0, _lodash.map)(data, function (row, idx) {
	          return _react2.default.createElement(
	            "tr",
	            { key: idx },
	            _react2.default.createElement(
	              "td",
	              null,
	              (0, _utils2.numericSuffix)(row.rank)
	            ),
	            _react2.default.createElement(
	              "td",
	              { style: { padding: "10px" } },
	              _react2.default.createElement(
	                _reactBootstrap.OverlayTrigger,
	                {
	                  trigger: ["hover", "focus"],
	                  placement: "bottom",
	                  overlay: popoverComponent(row.product, rounds)
	                },
	                _react2.default.createElement("span", {
	                  style: {
	                    display: "inline-block",
	                    width: "15px",
	                    height: "15px",
	                    backgroundColor: row.color
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              row.name
	            )
	          );
	        })
	      )
	    )
	  );
	});
	
	var autoData = function autoData(teams, data) {
	  return (0, _lodash.map)(data, function (item) {
	    return {
	      name: item.product.name,
	      rank: item.rank_auto,
	      color: (0, _utils.teamColor)(teams, item.team),
	      product: item.product
	    };
	  });
	};
	
	var mobileData = function mobileData(teams, data) {
	  return (0, _lodash.map)(data, function (item) {
	    return {
	      name: item.product.name,
	      rank: item.rank_mobile,
	      color: (0, _utils.teamColor)(teams, item.team),
	      product: item.product
	    };
	  });
	};
	
	var headerStyle = Object.assign({}, _styles.panelHeaderStyle, {
	  textTransform: "uppercase",
	  fontSize: "16px"
	});
	
	var MarketingPositioning = (0, _recompose.pure)(function (_ref2) {
	  var topPerformers = _ref2.topPerformers,
	      teams = _ref2.teams,
	      teamId = _ref2.teamId,
	      rounds = _ref2.rounds,
	      round = _ref2.round;
	
	  var teamsIds = (0, _lodash.map)(teams, function (team) {
	    return team.id;
	  });
	  var inCompetition = function inCompetition(item) {
	    return (0, _lodash.includes)(teamsIds, item.team);
	  };
	  var rawMobile = topPerformers && topPerformers["Mobile"] ? (0, _lodash.filter)(topPerformers["Mobile"], inCompetition) : [];
	  var rawAuto = topPerformers && topPerformers["Auto"] ? (0, _lodash.filter)(topPerformers["Auto"], inCompetition) : [];
	  // Top-N sidebar lists drop rank_*: 0 rows — those products
	  // aren't ranked in that segment and shouldn't compete for a
	  // "Top 5" slot. Team-specific rows below keep the zero-rank
	  // entries so we can still show the *other* segment's rank
	  // alongside a "N/A" for the segment with no interest.
	  var topPerformersMobile = rawMobile.filter(function (i) {
	    return i.rank_mobile !== 0;
	  });
	  var topPerformersAuto = rawAuto.filter(function (i) {
	    return i.rank_auto !== 0;
	  });
	  var topPerformersMobileTeamSpecific = rawMobile.filter(function (i) {
	    return i.team === teamId;
	  });
	  var topPerformersAutoTeamSpecific = rawAuto.filter(function (i) {
	    return i.team === teamId;
	  });
	  var topPerformersTeamSpecific = [].concat(_toConsumableArray(topPerformersMobileTeamSpecific), _toConsumableArray((0, _lodash.differenceBy)(topPerformersAutoTeamSpecific, topPerformersMobileTeamSpecific, "id")));
	
	  return _react2.default.createElement(
	    "div",
	    { style: _styles.dFlex },
	    _react2.default.createElement(
	      _OnePanel2.default,
	      { title: "Customer Survey", style: _styles.flex1 },
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "Given your product's price, features, and the",
	        " ",
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: "/analysis/team-reports/operational-analysis/operational-analysis-lead-time?round=" + round,
	            style: { color: "#2F9CA3", textDecoration: "underline" }
	          },
	          "lead time"
	        ),
	        ", in relation to your competitors', customers ranked your products as follows:"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_GenericTable2.default, {
	          header: [{ name: "Product Name", highlighted: true }, { name: "Ranked (Auto)", highlighted: true }, { name: "Ranked (Mobile)", highlighted: true }],
	          rows: (0, _lodash.map)(topPerformersTeamSpecific, function (el) {
	            return [el.product.name, formatRankCell(el.rank_auto), formatRankCell(el.rank_mobile)];
	          })
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: Object.assign({}, _styles.flex1, _styles.dFlexC, { alignItems: "center" }) },
	      _react2.default.createElement(
	        "h3",
	        { style: headerStyle },
	        "Top 5 Ranked Products Mobile"
	      ),
	      _react2.default.createElement(TopTable, {
	        data: mobileData(teams, (0, _lodash.take)(topPerformersMobile, 5)),
	        rounds: rounds
	      }),
	      _react2.default.createElement(
	        "h3",
	        { style: headerStyle },
	        "Top 5 Ranked Products Auto"
	      ),
	      _react2.default.createElement(TopTable, {
	        data: autoData(teams, (0, _lodash.take)(topPerformersAuto, 5)),
	        rounds: rounds
	      })
	    )
	  );
	});
	
	exports.default = MarketingPositioning;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _recompose = __webpack_require__(55);
	
	var _OnePanelPlus = __webpack_require__(1105);
	
	var _OnePanelPlus2 = _interopRequireDefault(_OnePanelPlus);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _GenericTable = __webpack_require__(394);
	
	var _GenericTable2 = _interopRequireDefault(_GenericTable);
	
	var _pricing = __webpack_require__(575);
	
	var _pricing2 = _interopRequireDefault(_pricing);
	
	var _format = __webpack_require__(63);
	
	var _utils = __webpack_require__(53);
	
	var _styles = __webpack_require__(68);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _TeamLegend = __webpack_require__(571);
	
	var _TeamLegend2 = _interopRequireDefault(_TeamLegend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketingSellingPrice = (0, _recompose.pure)(function (_ref) {
	  var competitiveAnalysis = _ref.competitiveAnalysis,
	      teamId = _ref.teamId,
	      unitSales = _ref.unitSales,
	      teams = _ref.teams,
	      products = _ref.products,
	      forecasts = _ref.forecasts,
	      competitionMetrics = _ref.competitionMetrics,
	      rounds = _ref.rounds,
	      round = _ref.round;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var field1 = "Average Selling Price - Mobile";
	  var field2 = "Average Selling Price - Auto";
	  var team = (0, _utils.getTeam)(teamId, data);
	  var units = -team["Units Sold"];
	  var price = team["Net Revenues"] / units;
	  var mobileData = (0, _utils.pickValue)(teams, data, field1, "team");
	  var autoData = (0, _utils.pickValue)(teams, data, field2, "team");
	  var roundId = rounds.find(function (i) {
	    return i.number === round;
	  }).id;
	  var unitSalesFiltered = unitSales.filter(function (i) {
	    return i.team === teamId && i.round === roundId;
	  });
	
	  return _react2.default.createElement(
	    _OnePanelPlus2.default,
	    { title: "Selling price" },
	    _react2.default.createElement(
	      "fragment",
	      null,
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "Your team sold a total of ",
	        (0, _format.numberFormat)(units),
	        " units of image sensors at a weighted average selling price of",
	        " ",
	        (0, _format.moneyFormatCents)(price),
	        ". Below is the breakdown of each of your product\u2019s selling prices."
	      ),
	      _react2.default.createElement(_GenericTable2.default, {
	        header: [{ name: "Product Name", highlighted: true }, { name: "Units Sold (Auto)", highlighted: true }, { name: "", highlighted: false }, { name: "Units Sold (Mobile)", highlighted: true }, { name: "", highlighted: false }, { name: "Total Units Sold", highlighted: true }, { name: "", highlighted: false }, { name: "Selling Price", highlighted: true }],
	        rows: (0, _lodash.map)(unitSalesFiltered, function (_ref2) {
	          var product = _ref2.product,
	              units_sold_auto = _ref2.units_sold_auto,
	              units_sold_mobile = _ref2.units_sold_mobile,
	              units_sold = _ref2.units_sold;
	          return [(0, _utils.getField)("name", "id", products, product), (0, _format.numberFormat)(-units_sold_auto), "+", (0, _format.numberFormat)(-units_sold_mobile), "=", (0, _format.numberFormat)(-units_sold), "@", (0, _format.moneyFormat)((0, _utils.getField)("price", "product", forecasts, product))];
	        })
	      }),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "n/a: This product did not sell."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: Object.assign({}, _styles.dFlexC, { alignItems: 'center' }) },
	      _react2.default.createElement(
	        "div",
	        { style: { display: 'flex', flexDirection: 'row', gap: 16, alignItems: 'flex-start', width: '100%' } },
	        _react2.default.createElement(
	          "div",
	          { style: { flex: 1, minWidth: 0 } },
	          _react2.default.createElement(_pricing2.default, {
	            title: "MOBILE PHONES",
	            data: mobileData,
	            hideZero: true,
	            teams: teams
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { flex: 1, minWidth: 0 } },
	          _react2.default.createElement(_pricing2.default, {
	            title: "AUTONOMOUS VEHICLES",
	            data: autoData,
	            hideZero: true,
	            teams: teams
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        { marginTop: "15px" },
	        "SELLING PRICE"
	      ),
	      _react2.default.createElement(_TeamLegend2.default, { teams: teams })
	    )
	  );
	});
	
	exports.default = MarketingSellingPrice;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _lodash = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var base_url = "/analysis/team-reports";
	var loc = function loc(str) {
	  return str === "" ? base_url : base_url + "/" + str;
	};
	
	var Separator = function Separator() {
	  return _react2.default.createElement("hr", { style: { height: "1px", backgroundColor: "#8F8F8F", width: "100%" } });
	};
	
	var Item = function Item(_ref) {
	  var label = _ref.label,
	      active = _ref.active,
	      level = _ref.level,
	      to = _ref.to,
	      search = _ref.search,
	      global_location = _ref.global_location,
	      has_arrow = _ref.has_arrow,
	      _ref$is_shown = _ref.is_shown,
	      is_shown = _ref$is_shown === undefined ? true : _ref$is_shown;
	
	  return is_shown ? _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      style: {
	        paddingLeft: 15 * level + "px"
	      },
	      className: to === global_location ? "active" : null,
	      to: to + ((0, _lodash.isNil)(search) ? "" : search)
	    },
	    has_arrow === true ? _react2.default.createElement("span", {
	      className: global_location.indexOf(to) === 0 ? "fa fa-chevron-down" : "fa fa-chevron-right",
	      style: { fontSize: "11px", fontWeight: "normal" }
	    }) : null,
	    " ",
	    label
	  ) : null;
	};
	
	var menu = function menu(state) {
	  var isMetricActive = function isMetricActive(metricKey) {
	    if (!state.targets) return false;
	    var value = parseFloat(state.targets[metricKey]);
	    return value > 0;
	  };
	
	  return state.isFinished === true ? [{
	    label: "Team Reports",
	    to: loc(""),
	    level: 1,
	    has_arrow: false,
	    children: [{
	      level: 2,
	      label: "Grades & Ranks",
	      to: loc("grades-ranks"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Market Share",
	        is_shown: isMetricActive('market_share'),
	        has_arrow: false,
	        to: loc("grades-ranks/market-share")
	      }, {
	        level: 3,
	        label: isMetricActive('net_revenues') ? "Net Revenues" : "Revenues",
	        is_shown: isMetricActive('net_revenues'),
	        has_arrow: false,
	        to: loc("grades-ranks/revenues")
	      }, {
	        level: 3,
	        label: "Gross Margins",
	        is_shown: isMetricActive('gross_margin'),
	        has_arrow: false,
	        to: loc("grades-ranks/gross-margins")
	      }, {
	        level: 3,
	        label: "Return on Assets",
	        to: loc("grades-ranks/return-on-assets"),
	        has_arrow: false,
	        is_shown: isMetricActive('roa')
	      }, {
	        level: 3,
	        label: "Return on Equity",
	        to: loc("grades-ranks/return-on-equity"),
	        has_arrow: false,
	        is_shown: isMetricActive('roe')
	      }, {
	        level: 3,
	        label: "Earnings per Share",
	        to: loc("grades-ranks/earnings-per-share"),
	        has_arrow: false,
	        is_shown: isMetricActive('earnings_per_share')
	      }, {
	        level: 3,
	        label: "Share Price",
	        has_arrow: false,
	        to: loc("grades-ranks/share-price"),
	        is_shown: isMetricActive('stock_price')
	      }]
	    }, {
	      level: 2,
	      label: "FP&A",
	      to: loc("fp-a"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Financial Planning & Analysis",
	        to: loc("fp-a/financial-planning-and-analysis"),
	        has_arrow: false
	      }]
	    }, {
	      level: 2,
	      label: "Marketing Analysis",
	      to: loc("marketing-analysis"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Market Share Capture",
	        to: loc("marketing-analysis/market-share-capture"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Low Sales 1",
	        to: loc("marketing-analysis/low-sales-1"),
	        has_arrow: false,
	        is_shown: state.messages && (0, _lodash.some)(state.messages, function (message) {
	          return message["type_name"] === "insufficient_capital";
	        })
	      }, {
	        level: 3,
	        label: "Low Sales 2",
	        to: loc("marketing-analysis/low-sales-2"),
	        has_arrow: false,
	        is_shown: state.messages && (0, _lodash.some)(state.messages, function (message) {
	          return message["type_name"] === "minimum_requirement_fail" || message["type_name"] === "price_range_fail" || message["type_name"] === "distribution_fail";
	        })
	      }, {
	        level: 3,
	        label: "Customer Survey",
	        has_arrow: false,
	        to: loc("marketing-analysis/customer-survey")
	      }, {
	        level: 3,
	        label: "Selling Price",
	        to: loc("marketing-analysis/marketing-selling-price"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Awareness",
	        has_arrow: false,
	        to: loc("marketing-analysis/marketing-awareness")
	      }, {
	        level: 3,
	        label: "Marketing Channel Spend",
	        to: loc("marketing-analysis/marketing-financial-impact-1"),
	        has_arrow: false
	      }]
	    }, {
	      level: 2,
	      label: "Operational Analysis",
	      to: loc("operational-analysis"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Unit Costs",
	        to: loc("operational-analysis/operational-analysis-unit-costs"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Unit Costs Breakdown",
	        to: loc("operational-analysis/operational-analysis-unit-costs-breakdown"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Inventory Management",
	        to: loc("operational-analysis/operational-analysis-inventory-management"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Lead Time",
	        to: loc("operational-analysis/operational-analysis-lead-time"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Financial Impact",
	        to: loc("operational-analysis/operational-analysis-financial-impact"),
	        has_arrow: false
	      }]
	    }, {
	      level: 2,
	      label: "Financing Analysis",
	      to: loc("financing-analysis"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Capital Structure",
	        to: loc("financing-analysis/financing-analysis-capital-structure"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Cost of Debt & Equity",
	        to: loc("financing-analysis/financing-analysis-cost-of-debt"),
	        has_arrow: false,
	        is_shown: false
	      }, {
	        level: 3,
	        label: "Impact of Holding Debt",
	        to: loc("financing-analysis/financing-analysis-impact-of-debt"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Cost of Capital",
	        to: loc("financing-analysis/financing-analysis-cost-of-capital"),
	        has_arrow: false,
	        is_shown: state.round > 4
	      }, {
	        level: 3,
	        label: "Valuation",
	        to: loc("financing-analysis/financing-analysis-valuation"),
	        has_arrow: false
	      }, {
	        level: 3,
	        label: "Shares",
	        has_arrow: false,
	        to: loc("financing-analysis/financing-analysis-shares")
	      }]
	    }, {
	      level: 2,
	      label: "Financial Statements",
	      to: loc("financial-statements"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Income Statement",
	        has_arrow: false,
	        to: loc("financial-statements/income-statement")
	      }, {
	        level: 3,
	        label: "Balance Sheet",
	        has_arrow: false,
	        to: loc("financial-statements/balance-sheet")
	      }, {
	        level: 3,
	        label: "Cash Flows",
	        has_arrow: false,
	        to: loc("financial-statements/cash-flows")
	      }]
	    }]
	  }] : [{
	    label: "Team Reports",
	    to: loc(""),
	    level: 1,
	    has_arrow: false,
	    children: [{
	      level: 2,
	      label: "Financial Statements",
	      to: loc("financial-statements"),
	      has_arrow: true,
	      children: [{
	        level: 3,
	        label: "Income Statement",
	        has_arrow: false,
	        to: loc("financial-statements/income-statement")
	      }, {
	        level: 3,
	        label: "Balance Sheet",
	        has_arrow: false,
	        to: loc("financial-statements/balance-sheet")
	      }, {
	        level: 3,
	        label: "Cash Flows",
	        has_arrow: false,
	        to: loc("financial-statements/cash-flows")
	      }]
	    }]
	  }];
	};
	
	var inSubtree = function inSubtree(item, location) {
	  if (item.to === location) {
	    return true;
	  }
	  if (item.children) {
	    return (0, _lodash.some)(item.children, function (element) {
	      return inSubtree(element, location);
	    });
	  }
	  return false;
	};
	
	var renderItem = function renderItem(item, global_location) {
	  if (item.type === "separator") {
	    return _react2.default.createElement(Separator, null);
	  }
	  return _react2.default.createElement(Item, Object.assign({
	    key: "" + item.level + item.label
	  }, item, {
	    global_location: global_location
	  }));
	};
	
	var renderItemTree = function renderItemTree(location, search) {
	  return function (item) {
	    if (inSubtree(item, location)) {
	      return [_react2.default.createElement(Item, Object.assign({}, item, { search: search, global_location: location })), (0, _lodash.map)(item.children || [], renderItemTree(location, search))];
	    }
	    return renderItem(Object.assign({}, item, { search: search }), location);
	  };
	};
	
	var Menu = function Menu(_ref2) {
	  var location = _ref2.location,
	      search = _ref2.search,
	      state = _objectWithoutProperties(_ref2, ["location", "search"]);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { display: "flex", flexDirection: "column" } },
	    (0, _lodash.map)(menu(state), renderItemTree(location, search))
	  );
	};
	
	exports.default = Menu;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _TwoPanels = __webpack_require__(179);
	
	var _TwoPanels2 = _interopRequireDefault(_TwoPanels);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _IncomeStatement = __webpack_require__(395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OAFinancialImpact = function OAFinancialImpact(_ref) {
	  var incomeStatement = _ref.incomeStatement;
	
	  return _react2.default.createElement(
	    _TwoPanels2.default,
	    {
	      title1: "Financial Impact of Operation's Decisions",
	      title2: "IncomeStatement"
	    },
	    _react2.default.createElement(
	      "fragment",
	      null,
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        "As a result of your operation decisions, your team incurred the following costs:"
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Cost of Sales"
	        ),
	        ": Your Cost of Sales of",
	        " ",
	        (0, _format.moneyFormat)(-incomeStatement["Cost of Sales"]),
	        " was partly driven by the product feature quality. The higher the quality, the more expensive the materials that is needed to produce the product."
	      ),
	      incomeStatement["Holding Costs"] !== 0 && _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Holding Costs"
	        ),
	        ": Your holding costs of",
	        " ",
	        (0, _format.moneyFormat)(-incomeStatement["Holding Costs"]),
	        " is the costs of holding unsold inventory."
	      ),
	      incomeStatement["Gain or Loss of Sales"] !== 0 && _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Loss on Sale"
	        ),
	        ": This non-operating costs is a result of selling your production lines (i.e. machines)."
	      )
	    ),
	    _react2.default.createElement(_IncomeStatement.IncomeStatementPanel, { sheet: incomeStatement })
	  );
	};
	
	exports.default = OAFinancialImpact;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(68);
	
	var _Paper = __webpack_require__(304);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _OnePanel = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OnePanelPlus = function OnePanelPlus(_ref) {
	  var title = _ref.title,
	      children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { style: _styles.dFlex },
	    _react2.default.createElement(
	      _Paper2.default,
	      { style: Object.assign({}, _styles.flex1, { marginRight: "20px" }) },
	      _react2.default.createElement(
	        "h1",
	        { style: Object.assign({}, _OnePanel.panelHeaderStyle, { marginBottom: "3em" }) },
	        title
	      ),
	      children[0]
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: _styles.flex1 },
	      children[1]
	    )
	  );
	};
	
	exports.default = OnePanelPlus;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OperationalAnalysis = function OperationalAnalysis() {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Operational Analysis" },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "This section we are going to review Head of Operation decisions and how they impact your Income Statement."
	    )
	  );
	};
	
	exports.default = OperationalAnalysis;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _DivFormula = __webpack_require__(211);
	
	var _DivFormula2 = _interopRequireDefault(_DivFormula);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReturnOnInvestedCapital = function ReturnOnInvestedCapital(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Return on Assets",
	      vertical: true,
	      suffix: "%",
	      data: (0, _utils.pickPercent)(teams, competitionMetrics, "ROA"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Investors use this metric to measure how well a business has used its assets to generate profits. The higher the ROA, the better."
	    ),
	    _react2.default.createElement(_DivFormula2.default, { name1: "ROA", name2: "NET PROFITS", name3: "AVERAGE TOTAL ASSETS" })
	  );
	};
	
	exports.default = ReturnOnInvestedCapital;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _DivFormula = __webpack_require__(211);
	
	var _DivFormula2 = _interopRequireDefault(_DivFormula);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReturnOnEquity = function ReturnOnEquity(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Return on Equity",
	      vertical: true,
	      suffix: "%",
	      data: (0, _utils.pickPercent)(teams, competitionMetrics, "ROE"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Investors use ROE to measure how well a business uses its equity to generate net profits. The higher the ROE, the better. Here is the formula:"
	    ),
	    _react2.default.createElement(_DivFormula2.default, { name1: "ROE", name2: "NET PROFITS", name3: "AVERAGE TOTAL EQUITY" })
	  );
	};
	
	exports.default = ReturnOnEquity;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Formula = __webpack_require__(570);
	
	var _Formula2 = _interopRequireDefault(_Formula);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Revenues = function Revenues(_ref) {
	  var teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Net Revenues",
	      data: (0, _utils.pickMillions)(teams, competitionMetrics, "Net Revenues"),
	      prefix: "$",
	      suffix: "M",
	      precision: 3,
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Revenues are the total dollar sales that a business might generate within a period of time. It is calculated by taking the number of units sold multiplied by the selling price of each unit:",
	      _react2.default.createElement("br", null)
	    ),
	    _react2.default.createElement(
	      _Formula2.default,
	      null,
	      "REVENUES = UNIT SALES \xD7 UNIT SELLING PRICE"
	    )
	  );
	};
	
	exports.default = Revenues;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _utils = __webpack_require__(53);
	
	var _format = __webpack_require__(63);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _DivFormula = __webpack_require__(211);
	
	var _DivFormula2 = _interopRequireDefault(_DivFormula);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharePrice = (0, _recompose.pure)(function (_ref) {
	  var constants = _ref.constants,
	      teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics;
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Share Price",
	      prefix: "$",
	      data: (0, _utils.pickValue)(teams, competitionMetrics, "Share Price"),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Share price is synonymous with the term stock price. It represents the price an investor will pay to own 1 share of a company. At the start of the competition, all teams start out with a share price of",
	      " ",
	      (0, _format.moneyFormatCents)(constants.initial_share_price),
	      ". Here\u2019s the formula for Share Price."
	    ),
	    _react2.default.createElement(_DivFormula2.default, {
	      name1: "SHARE PRICE",
	      name2: "YOUR BUSINESS VALUE",
	      name3: "SHARES OUTSTANDING"
	    })
	  );
	});
	
	exports.default = SharePrice;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _utils = __webpack_require__(53);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shares = function Shares(_ref) {
	  var constants = _ref.constants,
	      teams = _ref.teams,
	      competitionMetrics = _ref.competitionMetrics,
	      preMoneys = _ref.preMoneys,
	      equityCumulative = _ref.equityCumulative,
	      roundId = _ref.roundId;
	
	  // Issued shares: initial_shares at the start of this round plus the
	  // cumulative shares issued across all rounds up to and including it.
	  // pre_moneys[i].initial_shares is per-round; match on round so the
	  // page reflects the round the user is viewing. If the lookup misses
	  // (shouldn't, but defensive), fall back to constants.initial_shares.
	  var preMoneyRow = Array.isArray(preMoneys) ? preMoneys.find(function (p) {
	    return Number(p.round) === Number(roundId);
	  }) : null;
	  var initialShares = preMoneyRow && preMoneyRow.initial_shares != null ? Number(preMoneyRow.initial_shares) : Number(constants && constants.initial_shares) || 0;
	
	  // equity_cumulative is a single-row array with totals-to-date.
	  var cumRow = Array.isArray(equityCumulative) ? equityCumulative[0] : null;
	  var sharesIssuedCumulative = cumRow && cumRow.shares_issued_cumulative != null ? Number(cumRow.shares_issued_cumulative) : 0;
	  var sharesRepurchasedCumulative = cumRow && cumRow.shares_repurchased_cumulative != null ? Number(cumRow.shares_repurchased_cumulative) : 0;
	
	  var issuedShares = initialShares + sharesIssuedCumulative;
	  var repurchasedShares = sharesRepurchasedCumulative;
	  var outstandingShares = issuedShares - repurchasedShares;
	
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Shares Issued & Outstanding",
	      prefix: "",
	      suffix: "M",
	      data: (0, _utils.pickMillions)(teams, competitionMetrics, "Shares"),
	      precision: 0,
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Your business is authorized to issue up to",
	      " ",
	      (0, _format.numberFormat)(constants["authorized_shares"]),
	      " shares. In this round, you did the following:"
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Issued ",
	      (0, _format.numberFormat)(issuedShares),
	      " shares"
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "Repurchased ",
	      (0, _format.numberFormat)(repurchasedShares),
	      " shares"
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "This resulted in total outstanding shares of",
	      " ",
	      (0, _format.numberFormat)(outstandingShares),
	      "."
	    )
	  );
	};
	
	exports.default = Shares;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Location = __webpack_require__(23);
	
	var _styles = __webpack_require__(68);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FEEDBACK_CONTENT = {
	  "market leader": _react2.default.createElement(
	    "span",
	    null,
	    "Bold, fearless, dominant, are a few words that come into mind. Keep performing at this high level and maintain your leadership. ",
	    _react2.default.createElement(
	      "b",
	      null,
	      "#Boss"
	    ),
	    "!"
	  ),
	  "market challenger": _react2.default.createElement(
	    "span",
	    null,
	    "Great round! You've done a great job in challenging the leader. Next round, become the leader. ",
	    _react2.default.createElement(
	      "b",
	      null,
	      "#Soon-to-be-Boss"
	    )
	  ),
	  "market climber": _react2.default.createElement(
	    "span",
	    null,
	    "Not bad! Keep climbing until you reach your full potential.",
	    " ",
	    _react2.default.createElement(
	      "b",
	      null,
	      "#Be-the-Boss"
	    )
	  ),
	  "market warrior": _react2.default.createElement(
	    "span",
	    null,
	    "Good battle! You fought the good fight. Now let's go win the war. Become the leader! ",
	    _react2.default.createElement(
	      "b",
	      null,
	      "#Be-the-Boss"
	    )
	  ),
	  "market newbie": _react2.default.createElement(
	    "span",
	    null,
	    "Young Grasshopper, you have ways to go, but we will help you climb, to become a warrior to then challenge the leader. You will be a Master.",
	    " ",
	    _react2.default.createElement(
	      "b",
	      null,
	      "#Be-the-Boss"
	    )
	  )
	};
	
	var teamRankMessage = function teamRankMessage(rank_name) {
	  var rank_name_key = rank_name.toLowerCase();
	  return FEEDBACK_CONTENT[rank_name_key] || "";
	};
	
	var TeamReports = function (_PureComponent) {
	  _inherits(TeamReports, _PureComponent);
	
	  function TeamReports(props) {
	    _classCallCheck(this, TeamReports);
	
	    var _this = _possibleConstructorReturn(this, (TeamReports.__proto__ || Object.getPrototypeOf(TeamReports)).call(this, props));
	
	    _this.state = {
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(TeamReports, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        loading: true
	      }, function () {
	        setTimeout(function () {
	          var _props = _this2.props,
	              round = _props.round,
	              isFinished = _props.isFinished;
	
	
	          if (!isFinished) {
	            (0, _Location.changeLocation)("/analysis/team-reports/financial-statements?round=" + round);
	          } else {
	            _this2.setState({
	              loading: false
	            });
	          }
	        }, 500);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var loading = this.state.loading;
	      var _props2 = this.props,
	          grades = _props2.grades,
	          teamRank = _props2.teamRank,
	          round = _props2.round;
	
	      var grade = grades.find(function (i) {
	        return i.round_number === round;
	      });
	      var gradeValue = grade ? grade.current_weighted_value : 0;
	
	      return loading ? _react2.default.createElement(
	        "div",
	        null,
	        "Loading..."
	      ) : _react2.default.createElement(
	        _OnePanel2.default,
	        { title: "Team reports" },
	        _react2.default.createElement(
	          "div",
	          { style: _styles.dFlex },
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "2", textAlign: "center" } },
	            _react2.default.createElement(
	              _Text2.default,
	              null,
	              "As of this round, your team is the"
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { style: { fontSize: "32px" } },
	              teamRank,
	              "!"
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              null,
	              teamRankMessage(teamRank)
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { flex: "1", textAlign: "center" } },
	            _react2.default.createElement(
	              "span",
	              { style: { fontFamily: _styles.fontFamily, fontSize: "24px" } },
	              "Team grade"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { style: { fontFamily: _styles.fontFamily, fontSize: "60px" } },
	              (0, _utils.decimalsRound)(gradeValue * 100, 2),
	              "%"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamReports;
	}(_react.PureComponent);
	
	exports.default = TeamReports;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _format = __webpack_require__(63);
	
	var _utils = __webpack_require__(53);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitCosts1 = function UnitCosts1(_ref) {
	  var competitiveAnalysis = _ref.competitiveAnalysis,
	      teams = _ref.teams,
	      teamId = _ref.teamId,
	      competitionMetrics = _ref.competitionMetrics;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var field = "Average Unit Cost";
	  var team = (0, _utils.getTeam)(teamId, data);
	  var unitsProduced = team["Units Produced"];
	  var averageUnitCost = team[field];
	  var totalProductionCosts = unitsProduced * averageUnitCost;
	
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Unit Costs",
	      chartTitle: "Average Unit Cost ($)",
	      data: (0, _utils.pickValue)(teams, data, field),
	      prefix: "$",
	      teams: teams,
	      vertical: true
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "In this round, the Head of Operations produced",
	      " ",
	      (0, _format.numberFormat)(unitsProduced),
	      " units at a total production costs of",
	      " ",
	      (0, _format.moneyFormat)(totalProductionCosts),
	      ", which resulted in product unit costs of ",
	      (0, _format.moneyFormatCents)(averageUnitCost),
	      ". Your unit costs may vary if you have any inventory remaining from prior rounds."
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "What drives your production costs?"
	    )
	  );
	};
	
	exports.default = UnitCosts1;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _lodash = __webpack_require__(21);
	
	var _OnePanel = __webpack_require__(83);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitCosts2 = (0, _recompose.pure)(function (_ref) {
	  var manufactureCosts = _ref.manufactureCosts,
	      teamId = _ref.teamId,
	      round = _ref.round,
	      rounds = _ref.rounds;
	
	  var roundId = rounds.find(function (i) {
	    return i.number === round;
	  }).id;
	  var data = manufactureCosts.filter(function (i) {
	    return i.team == teamId && i.round == roundId || i.round_number == round || !i.team && !i.round;
	  });
	  var unitsProduced = (0, _lodash.sumBy)(data, "units_produced");
	  var avgMaterialCostsPerUnit = (unitsProduced !== 0 ? (0, _lodash.sumBy)(data, "material_costs") / unitsProduced : 0).toFixed(2);
	  var avgLaborCostsPerUnit = (unitsProduced !== 0 ? (0, _lodash.sumBy)(data, "labor_costs") / unitsProduced : 0).toFixed(2);
	  var avgOverheadCostsPerUnit = (unitsProduced !== 0 ? (0, _lodash.sumBy)(data, "overhead_costs") / unitsProduced : 0).toFixed(2);
	  var avgProductsUnitCosts = (parseFloat(avgMaterialCostsPerUnit) + parseFloat(avgLaborCostsPerUnit) + parseFloat(avgOverheadCostsPerUnit)).toFixed(2);
	
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "Unit Costs Breakdown" },
	    _react2.default.createElement(
	      "div",
	      {
	        style: {
	          marginTop: "-20px"
	        }
	      },
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          "span",
	          {
	            style: {
	              fontSize: "16px",
	              color: "#999"
	            }
	          },
	          "Direct Materials, Labor, and Overhead drives your product costs. The costs below is a breakdown of the average unit costs of all your products."
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "team-reports-operational-analysis" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "price" },
	              "$",
	              avgMaterialCostsPerUnit
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "+"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "price" },
	              "$",
	              avgLaborCostsPerUnit
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "+"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "price" },
	              "$",
	              avgOverheadCostsPerUnit
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "="
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "price" },
	              "$",
	              avgProductsUnitCosts
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              { className: "price-description" },
	              "Material",
	              _react2.default.createElement("br", null),
	              "Costs Per Unit"
	            ),
	            _react2.default.createElement("td", null),
	            _react2.default.createElement(
	              "td",
	              { className: "price-description" },
	              "Labor",
	              _react2.default.createElement("br", null),
	              "Costs Per Unit"
	            ),
	            _react2.default.createElement("td", null),
	            _react2.default.createElement(
	              "td",
	              { className: "price-description" },
	              "Overhead",
	              _react2.default.createElement("br", null),
	              "Costs Per Unit"
	            ),
	            _react2.default.createElement("td", null),
	            _react2.default.createElement(
	              "td",
	              { className: "price-description" },
	              "Product's",
	              _react2.default.createElement("br", null),
	              "Unit Costs"
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = UnitCosts2;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Valuation = __webpack_require__(1116);
	
	var _Valuation2 = _interopRequireDefault(_Valuation);
	
	var _Valuation3 = __webpack_require__(1117);
	
	var _Valuation4 = _interopRequireDefault(_Valuation3);
	
	var _Valuation5 = __webpack_require__(1118);
	
	var _Valuation6 = _interopRequireDefault(_Valuation5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Valuation = function Valuation(_ref) {
	  var round = _ref.round,
	      props = _objectWithoutProperties(_ref, ["round"]);
	
	  return round <= 2 && _react2.default.createElement(_Valuation2.default, Object.assign({}, props, { round: round })) || round <= 4 && _react2.default.createElement(_Valuation4.default, Object.assign({}, props, { round: round })) || _react2.default.createElement(_Valuation6.default, props);
	};
	
	exports.default = Valuation;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _format = __webpack_require__(63);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _FormulaTable = __webpack_require__(303);
	
	var _FormulaTable2 = _interopRequireDefault(_FormulaTable);
	
	var _utils = __webpack_require__(53);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Valuation1 = function Valuation1(_ref) {
	  var teams = _ref.teams,
	      competitiveAnalysis = _ref.competitiveAnalysis,
	      competitiveAnalysisAll = _ref.competitiveAnalysisAll,
	      competitionMetrics = _ref.competitionMetrics,
	      teamId = _ref.teamId,
	      comparableCompanies = _ref.comparableCompanies,
	      constants = _ref.constants,
	      round = _ref.round;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var field = "Market Capitalization";
	  var team = (0, _utils.getTeam)(teamId, data);
	  var marketCap = (0, _format.moneyFormat)(team[field]);
	  var teamRounds = (0, _lodash.filter)(competitiveAnalysisAll, function (item) {
	    return item.team === teamId;
	  });
	  var obj1 = teamRounds.find(function (i) {
	    return i.Round === round;
	  });
	  var netRevenues = obj1 && "Net Revenues" in obj1 ? obj1["Net Revenues"] : 0;
	  var psMultiples = (0, _lodash.sumBy)(comparableCompanies, "price_to_sales") / comparableCompanies.length;
	  var marketCapCalculated = netRevenues * psMultiples;
	  var minValuation = constants["min_valuation"];
	
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Valuation",
	      prefix: "$",
	      suffix: "M",
	      data: (0, _utils.pickMillions)(teams, data, field),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "In this round, equity investors use the Price to Sales Multiples (P/S) valuation method to value your business at ",
	      marketCap,
	      ".",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      "P/S valuation method takes your net revenues and multiply that by the P/S multiple of a comparable company. Here\u2019s the breakdown:"
	    ),
	    _react2.default.createElement(_FormulaTable2.default, {
	      items: [{
	        name: "Team Valuation",
	        highlighted: true,
	        value: (0, _format.moneyFormat)(marketCapCalculated)
	      }, { name: "=", highlighted: false, value: "" }, {
	        name: "Net Revenues",
	        highlighted: true,
	        value: (0, _format.moneyFormat)(netRevenues)
	      }, { name: "×", highlighted: false, value: "" }, {
	        name: "P/S multiples",
	        highlighted: true,
	        value: psMultiples.toFixed(2)
	      }]
	    }),
	    marketCapCalculated < minValuation && _react2.default.createElement(
	      _Text2.default,
	      { style: { marginTop: "1.5em" } },
	      "Investors place a minimum value of ",
	      (0, _format.moneyFormat)(minValuation),
	      " to your business."
	    )
	  );
	};
	
	exports.default = Valuation1;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _FormulaTable = __webpack_require__(303);
	
	var _FormulaTable2 = _interopRequireDefault(_FormulaTable);
	
	var _utils = __webpack_require__(53);
	
	var _format = __webpack_require__(63);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Valuation2 = function Valuation2(_ref) {
	  var teams = _ref.teams,
	      competitiveAnalysis = _ref.competitiveAnalysis,
	      competitiveAnalysisAll = _ref.competitiveAnalysisAll,
	      competitionMetrics = _ref.competitionMetrics,
	      teamId = _ref.teamId,
	      comparableCompanies = _ref.comparableCompanies,
	      constants = _ref.constants,
	      round = _ref.round;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var field = "Market Capitalization";
	  var team = (0, _utils.getTeam)(teamId, data);
	  var teamRounds = (0, _lodash.filter)(competitiveAnalysisAll, function (item) {
	    return item.team === teamId;
	  });
	  var obj1 = teamRounds.find(function (i) {
	    return i.Round === round;
	  });
	  var netProfits = obj1 && "Net Profits" in obj1 ? obj1["Net Profits"] : 0;
	  var peMultiples = (0, _lodash.sumBy)(comparableCompanies, "price_to_earnings") / comparableCompanies.length;
	  var marketCap = team[field];
	  var marketCapCalculated = netProfits * peMultiples;
	  var minValuation = constants["min_valuation"];
	
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Valuation",
	      prefix: "$",
	      suffix: "M",
	      data: (0, _utils.pickMillions)(teams, data, field),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "In this round, equity investors used the Price to Earnings Multiples (P/E) valuation method to value your business at",
	      " ",
	      (0, _format.moneyFormat)(marketCap),
	      "."
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "P/E valuation method takes your net income and multiply that by the P/E multiple of a comparable company. Here\u2019s the breakdown:"
	    ),
	    _react2.default.createElement(_FormulaTable2.default, {
	      items: [{
	        name: "Team Valuation",
	        highlighted: true,
	        value: (0, _format.moneyFormat)(marketCapCalculated)
	      }, { name: "=", highlighted: false, value: "" }, {
	        name: "Net Profits",
	        highlighted: true,
	        value: (0, _format.moneyFormat)(netProfits)
	      }, { name: "×", highlighted: false, value: "" }, {
	        name: "P/E multiples",
	        highlighted: true,
	        value: peMultiples.toFixed(2)
	      }]
	    }),
	    marketCapCalculated < minValuation && _react2.default.createElement(
	      _Text2.default,
	      { style: { marginTop: "1.5em" } },
	      "Investors place a minimum value of ",
	      (0, _format.moneyFormat)(minValuation),
	      " to your business."
	    )
	  );
	};
	
	exports.default = Valuation2;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(63);
	
	var _OnePanelChart = __webpack_require__(71);
	
	var _OnePanelChart2 = _interopRequireDefault(_OnePanelChart);
	
	var _Text = __webpack_require__(25);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _utils = __webpack_require__(53);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Valuation3 = function Valuation3(_ref) {
	  var teams = _ref.teams,
	      competitiveAnalysis = _ref.competitiveAnalysis,
	      competitionMetrics = _ref.competitionMetrics,
	      teamId = _ref.teamId;
	
	  var data = competitiveAnalysis || competitionMetrics;
	  var field = "Market Capitalization";
	  return _react2.default.createElement(
	    _OnePanelChart2.default,
	    {
	      title: "Valuation",
	      prefix: "$",
	      suffix: "M",
	      data: (0, _utils.pickMillions)(teams, data, field),
	      teams: teams
	    },
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "In this round, equity investors used the Discounted Cash Flow (DCF) valuation method to value your business at",
	      " ",
	      (0, _format.moneyFormat)((0, _utils.getTeam)(teamId, data)[field]),
	      "."
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "The DCF model, in this game, predicts your future cash flows, based on past performance and other factors, and discount those cash flows using an appropriate discount rate to determine the present value (i.e. your business value)."
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      "The discount rate used in this game is your Cost of Capital."
	    )
	  );
	};
	
	exports.default = Valuation3;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatNumber(val, precision) {
	  return val.toFixed(precision);
	}
	
	function CustomLabel(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      value = _ref.value,
	      _ref$prefix = _ref.prefix,
	      prefix = _ref$prefix === undefined ? "" : _ref$prefix,
	      _ref$suffix = _ref.suffix,
	      suffix = _ref$suffix === undefined ? "" : _ref$suffix,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? 1 : _ref$precision,
	      _ref$layout = _ref.layout,
	      layout = _ref$layout === undefined ? "horizontal" : _ref$layout,
	      _ref$xOffset = _ref.xOffset,
	      xOffset = _ref$xOffset === undefined ? 30 : _ref$xOffset;
	
	  var xxOffset = layout === "horizontal" ? x + width / 2 : value < 0 ? x + width - xOffset : x + width + xOffset;
	  var yOffset = layout === "vertical" ? y + height / 2 : value < 0 ? y + 10 : y - 10;
	  var className = value < 0 ? "red" : null;
	  var val = "" + prefix + formatNumber(value, precision) + suffix;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: xxOffset,
	      y: yOffset,
	      className: className,
	      textAnchor: "middle",
	      dominantBaseline: "middle"
	    },
	    val
	  );
	}
	
	exports.default = CustomLabel;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCurrentToken = function getCurrentToken() {
	  return _Auth2.default.getToken();
	};
	
	var getCurrentCourseId = function getCurrentCourseId() {
	  return _Auth2.default.getCourseId();
	};
	
	var getCurrentUserId = function getCurrentUserId() {
	  return _Auth2.default.getUserId();
	};
	
	function formatNumber(val, precision) {
	  return val.toFixed(precision);
	}
	
	function CustomLabel(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      value = _ref.value,
	      prefix = _ref.prefix,
	      suffix = _ref.suffix,
	      precision = _ref.precision,
	      _ref$layout = _ref.layout,
	      layout = _ref$layout === undefined ? "horizontal" : _ref$layout,
	      _ref$xOffset = _ref.xOffset,
	      xOffset = _ref$xOffset === undefined ? 30 : _ref$xOffset,
	      format = _ref.format;
	
	  var xxOffset = layout === "horizontal" ? x + width / 2 : value < 0 ? x + width - xOffset : x + width + xOffset;
	  var yOffset = layout === "vertical" ? y + height / 2 : value < 0 ? y + 10 : y - 10;
	  var className = value < 0 ? "red" : null;
	  var val = "" + prefix + (format ? format(value, precision) : formatNumber(value, precision)) + suffix;
	
	  return _react2.default.createElement(
	    "g",
	    null,
	    _react2.default.createElement(
	      "text",
	      {
	        x: xxOffset,
	        y: yOffset,
	        className: className,
	        textAnchor: "middle",
	        dominantBaseline: "middle"
	      },
	      val
	    )
	  );
	}
	
	function TooltipContent(_ref2) {
	  var active = _ref2.active,
	      payload = _ref2.payload,
	      label = _ref2.label,
	      prefix = _ref2.prefix,
	      suffix = _ref2.suffix,
	      format = _ref2.format;
	
	  var tooltipStyle = {
	    margin: 0,
	    padding: 10,
	    backgroundColor: "#fff",
	    border: "1px solid #ccc",
	    whiteSpace: "nowrap"
	  };
	
	  if (active) {
	    var value = "";
	    var style = {};
	
	    if (payload && payload.length > 0) {
	      value = format ? format(payload[0].value) : payload[0].value.toFixed(2);
	      if (payload[0].value < 0) {
	        style = {
	          color: "red"
	        };
	      }
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "recharts-default-tooltip", style: tooltipStyle },
	      label,
	      ":",
	      " ",
	      _react2.default.createElement(
	        "span",
	        { style: style },
	        prefix,
	        value,
	        suffix
	      )
	    );
	  }
	
	  return null;
	}
	
	var CustomXAxisLabel = function (_PureComponent) {
	  _inherits(CustomXAxisLabel, _PureComponent);
	
	  function CustomXAxisLabel() {
	    _classCallCheck(this, CustomXAxisLabel);
	
	    return _possibleConstructorReturn(this, (CustomXAxisLabel.__proto__ || Object.getPrototypeOf(CustomXAxisLabel)).apply(this, arguments));
	  }
	
	  _createClass(CustomXAxisLabel, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          payload = _props.payload,
	          data = _props.data,
	          instructorData = _props.instructorData;
	
	
	      return _react2.default.createElement(
	        "g",
	        { transform: "translate(" + x + "," + y + ")" },
	        _react2.default.createElement(
	          "text",
	          { x: 0, y: 0, dy: 10, textAnchor: "middle", fill: "#666" },
	          data[payload.index].name
	        ),
	        _react2.default.createElement(
	          "a",
	          {
	            href: "/analysis/team-reports/grades-ranks/" + instructorData.type + "?team_id=" + data[payload.index].id + "&round_number=" + instructorData.roundNumber + "&game_id=" + instructorData.currentGame + "&_token=" + getCurrentToken() + "&_userid=" + getCurrentUserId() + "&_courseid=" + getCurrentCourseId() + "&_target=blank",
	            target: "_blank",
	            rel: "noreferrer"
	          },
	          _react2.default.createElement(
	            "text",
	            {
	              x: 0,
	              y: 0,
	              dy: 25,
	              textAnchor: "middle",
	              fill: "#666"
	            },
	            "View"
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomXAxisLabel;
	}(_react.PureComponent);
	
	function HorizontalBar(_ref3) {
	  var _ref3$prefix = _ref3.prefix,
	      prefix = _ref3$prefix === undefined ? "" : _ref3$prefix,
	      _ref3$suffix = _ref3.suffix,
	      suffix = _ref3$suffix === undefined ? "" : _ref3$suffix,
	      _ref3$precision = _ref3.precision,
	      precision = _ref3$precision === undefined ? 2 : _ref3$precision,
	      _ref3$data = _ref3.data,
	      data = _ref3$data === undefined ? [] : _ref3$data,
	      _ref3$barSize = _ref3.barSize,
	      barSize = _ref3$barSize === undefined ? 18 : _ref3$barSize,
	      _ref3$format = _ref3.format,
	      format = _ref3$format === undefined ? null : _ref3$format,
	      _ref3$customColors = _ref3.customColors,
	      customColors = _ref3$customColors === undefined ? null : _ref3$customColors,
	      _ref3$showCategoryLab = _ref3.showCategoryLabels,
	      showCategoryLabels = _ref3$showCategoryLab === undefined ? false : _ref3$showCategoryLab,
	      _ref3$instructorData = _ref3.instructorData,
	      instructorData = _ref3$instructorData === undefined ? null : _ref3$instructorData,
	      _ref3$teams = _ref3.teams,
	      teams = _ref3$teams === undefined ? null : _ref3$teams,
	      _ref3$yaxisFormatter = _ref3.yaxisFormatter,
	      yaxisFormatter = _ref3$yaxisFormatter === undefined ? null : _ref3$yaxisFormatter;
	
	  var colors = customColors ? customColors : _Teams2.default.competitiveColors(teams);
	
	  return _react2.default.createElement(
	    _recharts.ResponsiveContainer,
	    { height: 200 },
	    _react2.default.createElement(
	      _recharts.BarChart,
	      { data: data, barSize: barSize },
	      !instructorData && _react2.default.createElement(_recharts.XAxis, { dataKey: "name", tickLine: false, tick: showCategoryLabels }),
	      instructorData && _react2.default.createElement(_recharts.XAxis, {
	        dataKey: "name",
	        tickLine: false,
	        tick: _react2.default.createElement(CustomXAxisLabel, { data: data, instructorData: instructorData })
	      }),
	      _react2.default.createElement(_recharts.YAxis, {
	        hide: false
	        // When every team is 0, dataMax * 1.2 = 0 and recharts renders
	        // decimal filler ticks (0.25, 0.5, 0.75...). Fall back to a
	        // domain of [0, 1] so the axis stays clean and bars sit at
	        // baseline instead of drawing 5px slivers over garbage ticks.
	        , domain: [function (dataMin) {
	          return 0;
	        }, function (dataMax) {
	          return dataMax > 0 ? dataMax * 1.2 : 1;
	        }],
	        interval: "preserveStart",
	        tickFormatter: function tickFormatter(value) {
	          return yaxisFormatter ? yaxisFormatter(value) : value;
	        }
	      }),
	      _react2.default.createElement(_recharts.Tooltip, {
	        content: _react2.default.createElement(TooltipContent, { prefix: prefix, suffix: suffix, format: format })
	      }),
	      _react2.default.createElement(
	        _recharts.Bar,
	        {
	          dataKey: "value",
	          minPointSize: 5,
	          isAnimationActive: !showCategoryLabels,
	          label: _react2.default.createElement(CustomLabel, {
	            prefix: prefix,
	            suffix: suffix,
	            precision: precision,
	            format: format,
	            instructorData: instructorData
	          })
	        },
	        colors.map(function (color, i) {
	          return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	        })
	      )
	    )
	  );
	}
	
	exports.default = HorizontalBar;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TooltipContent(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload,
	      label = _ref.label,
	      prefix = _ref.prefix,
	      suffix = _ref.suffix;
	
	  var tooltipStyle = {
	    margin: 0,
	    padding: 10,
	    backgroundColor: "#fff",
	    border: "1px solid #ccc",
	    whiteSpace: "nowrap"
	  };
	
	  if (active) {
	    var value = "";
	    var style = {};
	
	    if (payload && payload.length > 0) {
	      value = payload[0].value.toFixed(2);
	      if (payload[0].value < 0) {
	        style = {
	          color: "red"
	        };
	      }
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "recharts-default-tooltip", style: tooltipStyle },
	      label,
	      ":",
	      " ",
	      _react2.default.createElement(
	        "span",
	        { style: style },
	        prefix,
	        value,
	        suffix
	      )
	    );
	  }
	
	  return null;
	}
	
	exports.default = TooltipContent;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n"], ["\n  font-family: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n"], ["\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 220px;\n  padding: 10px 14px;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  background: #F5F7FB;\n  font-size: 14px;\n  font-family: ", ";\n  color: rgba(0, 27, 59, 0.94);\n  outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &:focus {\n    border-color: #3A507B;\n    background: #FFFFFF;\n  }\n"], ["\n  flex: 1;\n  min-width: 220px;\n  padding: 10px 14px;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  background: #F5F7FB;\n  font-size: 14px;\n  font-family: ", ";\n  color: rgba(0, 27, 59, 0.94);\n  outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &:focus {\n    border-color: #3A507B;\n    background: #FFFFFF;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 8px 14px;\n  border: 1.5px solid ", ";\n  background: ", ";\n  color: ", ";\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: ", ";\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    border-color: #3A507B;\n  }\n"], ["\n  padding: 8px 14px;\n  border: 1.5px solid ", ";\n  background: ", ";\n  color: ", ";\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: ", ";\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    border-color: #3A507B;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.5);\n  margin-left: auto;\n"], ["\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.5);\n  margin-left: auto;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  background: #FFFFFF;\n  border: 1px solid #EEF0F4;\n  border-radius: 12px;\n  overflow: hidden;\n"], ["\n  background: #FFFFFF;\n  border: 1px solid #EEF0F4;\n  border-radius: 12px;\n  overflow: hidden;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 150px 110px minmax(0, 1fr) 110px 90px 28px;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #F2F4F8;\n  align-items: center;\n  cursor: ", ";\n  background: ", ";\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 150px 110px minmax(0, 1fr) 110px 90px 28px;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #F2F4F8;\n  align-items: center;\n  cursor: ", ";\n  background: ", ";\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: #FAFBFD;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n  cursor: default;\n\n  &:hover {\n    background: #FAFBFD;\n  }\n"], ["\n  background: #FAFBFD;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n  cursor: default;\n\n  &:hover {\n    background: #FAFBFD;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  line-height: 1.4;\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n"], ["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  line-height: 1.4;\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  border-radius: 6px;\n  background: ", ";\n  color: ", ";\n"], ["\n  display: inline-block;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  border-radius: 6px;\n  background: ", ";\n  color: ", ";\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  padding: 14px 24px 18px 24px;\n  background: #FAFBFD;\n  border-bottom: 1px solid #F2F4F8;\n"], ["\n  padding: 14px 24px 18px 24px;\n  background: #FAFBFD;\n  border-bottom: 1px solid #F2F4F8;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.5);\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 8px 24px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 8px 24px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.82);\n"], ["\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.82);\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.5);\n  margin-right: 6px;\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n"], ["\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.5);\n  margin-right: 6px;\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  padding: 60px 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.4);\n  font-size: 14px;\n"], ["\n  padding: 60px 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.4);\n  font-size: 14px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.4);\n  font-size: 18px;\n  font-weight: 700;\n  transform: ", ";\n  transition: transform 0.15s ease;\n"], ["\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.4);\n  font-size: 18px;\n  font-weight: 700;\n  transform: ", ";\n  transition: transform 0.15s ease;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Unified audit-trail event table. Renders a normalized stream of
	// {when, who, action, target, status, detail, round} entries with a
	// filter bar (action chips + search) and a per-row expander that
	// surfaces the role-specific detail object.
	//
	// Consumes events emitted by the role getters in page.js — no role-
	// aware rendering lives here, so the same component renders CEO,
	// PD, PM, OP, and FN streams.
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	var Wrap = _styledComponents2.default.div(_templateObject, FONT);
	
	var FiltersBar = _styledComponents2.default.div(_templateObject2);
	
	var Search = _styledComponents2.default.input(_templateObject3, FONT);
	
	var ChipGroup = _styledComponents2.default.div(_templateObject4);
	
	var Chip = _styledComponents2.default.button(_templateObject5, function (p) {
	  return p.active ? "#3A507B" : "#E5E9F0";
	}, function (p) {
	  return p.active ? "#3A507B" : "#FFFFFF";
	}, function (p) {
	  return p.active ? "#FFFFFF" : "rgba(0, 27, 59, 0.7)";
	}, FONT);
	
	var ResultCount = _styledComponents2.default.div(_templateObject6);
	
	var Card = _styledComponents2.default.div(_templateObject7);
	
	// 6-column grid: When | Who | Description | Amount | Status | Chevron.
	// Fixed columns are sized to their widest realistic content (timestamp
	// "Jun 1, 2026 · 10:32 AM", names like "Utest 8", "$1,234,567", status
	// badges); the Description column then claims everything left over.
	var Row = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.clickable ? "pointer" : "default";
	}, function (p) {
	  return p.open ? "#FAFBFD" : "transparent";
	}, function (p) {
	  return p.clickable ? "#FAFBFD" : "transparent";
	});
	
	var HeaderRow = (0, _styledComponents2.default)(Row)(_templateObject9);
	
	var Cell = _styledComponents2.default.div(_templateObject10);
	
	// Description cell wraps onto additional lines instead of truncating —
	// the full sentence is the row's most informative piece of content, so
	// readability beats single-line uniformity here.
	var DescriptionCell = _styledComponents2.default.div(_templateObject11);
	
	// Render a description string with **markdown-style bold** support.
	// Splits on `**...**` segments and wraps the inner text in <strong>.
	// We use this only for the table row — search/filter continues to
	// match against the raw string since `includes` ignores the asterisks
	// around the keyword.
	var renderDescription = function renderDescription(text) {
	  if (text == null) return null;
	  var str = String(text);
	  var parts = str.split(/(\*\*[^*]+\*\*)/g);
	  return parts.map(function (part, i) {
	    var m = part.match(/^\*\*(.+)\*\*$/);
	    if (m) return _react2.default.createElement(
	      "strong",
	      { key: i },
	      m[1]
	    );
	    return part;
	  });
	};
	
	var ActionBadge = _styledComponents2.default.span(_templateObject12, function (p) {
	  return p.bg;
	}, function (p) {
	  return p.fg;
	});
	
	var StatusBadge = _styledComponents2.default.span(_templateObject12, function (p) {
	  return p.bg;
	}, function (p) {
	  return p.fg;
	});
	
	var DetailPanel = _styledComponents2.default.div(_templateObject13);
	
	var DetailHeader = _styledComponents2.default.div(_templateObject14);
	
	var DetailGrid = _styledComponents2.default.div(_templateObject15);
	
	var DetailItem = _styledComponents2.default.div(_templateObject16);
	
	var DetailKey = _styledComponents2.default.span(_templateObject17);
	
	var Empty = _styledComponents2.default.div(_templateObject18);
	
	var Chevron = _styledComponents2.default.div(_templateObject19, function (p) {
	  return p.open ? "rotate(90deg)" : "rotate(0)";
	});
	
	// Visual palette per action verb. Colors stay muted so the badge reads
	// at a glance without competing with the row content.
	var ACTION_COLORS = {
	  Created: { bg: "#E0F2E9", fg: "#1F7A3E" },
	  Updated: { bg: "#E3ECFA", fg: "#1F4FB6" },
	  Deleted: { bg: "#FCE4E4", fg: "#9F1D1D" },
	  Submitted: { bg: "#EFE7FE", fg: "#5B3DAF" },
	  Posted: { bg: "#FFF4D6", fg: "#8A5B00" }
	};
	
	var STATUS_COLORS = {
	  success: { bg: "#E0F2E9", fg: "#1F7A3E" },
	  failure: { bg: "#FCE4E4", fg: "#9F1D1D" },
	  neutral: { bg: "#EFF1F6", fg: "rgba(0, 27, 59, 0.55)" }
	};
	
	var ACTION_OPTIONS = ["All", "Created", "Updated", "Deleted", "Submitted"];
	
	var EventTable = function (_PureComponent) {
	  _inherits(EventTable, _PureComponent);
	
	  function EventTable(props) {
	    _classCallCheck(this, EventTable);
	
	    var _this = _possibleConstructorReturn(this, (EventTable.__proto__ || Object.getPrototypeOf(EventTable)).call(this, props));
	
	    _this.onSearchChange = function (e) {
	      return _this.setState({ search: e.target.value });
	    };
	
	    _this.setAction = function (action) {
	      return function () {
	        return _this.setState({ action: action });
	      };
	    };
	
	    _this.toggleExpand = function (id) {
	      return function () {
	        return _this.setState(function (s) {
	          return {
	            expanded: Object.assign({}, s.expanded, _defineProperty({}, id, !s.expanded[id]))
	          };
	        });
	      };
	    };
	
	    _this.state = {
	      search: "",
	      action: "All",
	      expanded: {}
	    };
	    return _this;
	  }
	
	  _createClass(EventTable, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props$events = this.props.events,
	          events = _props$events === undefined ? [] : _props$events;
	      var _state = this.state,
	          search = _state.search,
	          action = _state.action,
	          expanded = _state.expanded;
	
	      var q = search.trim().toLowerCase();
	
	      var filtered = events.filter(function (ev) {
	        if (action !== "All" && ev.action !== action) return false;
	        if (q) {
	          var hay = (ev.who + " " + (ev.description || "")).toLowerCase();
	          if (!hay.includes(q)) return false;
	        }
	        return true;
	      });
	
	      var sorted = _lodash2.default.sortBy(filtered, function (ev) {
	        return -ev.unix;
	      });
	
	      return _react2.default.createElement(
	        Wrap,
	        null,
	        _react2.default.createElement(
	          FiltersBar,
	          null,
	          _react2.default.createElement(Search, {
	            type: "text",
	            placeholder: "Search by user or target\u2026",
	            value: search,
	            onChange: this.onSearchChange
	          }),
	          _react2.default.createElement(
	            ChipGroup,
	            null,
	            ACTION_OPTIONS.map(function (a) {
	              return _react2.default.createElement(
	                Chip,
	                {
	                  key: a,
	                  active: action === a,
	                  onClick: _this2.setAction(a)
	                },
	                a
	              );
	            })
	          ),
	          _react2.default.createElement(
	            ResultCount,
	            null,
	            sorted.length,
	            " event",
	            sorted.length === 1 ? "" : "s"
	          )
	        ),
	        _react2.default.createElement(
	          Card,
	          null,
	          _react2.default.createElement(
	            HeaderRow,
	            null,
	            _react2.default.createElement(
	              Cell,
	              null,
	              "When"
	            ),
	            _react2.default.createElement(
	              Cell,
	              null,
	              "Who"
	            ),
	            _react2.default.createElement(
	              Cell,
	              null,
	              "Description"
	            ),
	            _react2.default.createElement(
	              Cell,
	              null,
	              "Amount"
	            ),
	            _react2.default.createElement(
	              Cell,
	              null,
	              "Status"
	            ),
	            _react2.default.createElement(Cell, null)
	          ),
	          sorted.length === 0 && _react2.default.createElement(
	            Empty,
	            null,
	            "No activity to show for this round."
	          ),
	          sorted.map(function (ev) {
	            var isOpen = !!expanded[ev.id];
	            var actionColor = ACTION_COLORS[ev.action] || ACTION_COLORS.Posted;
	            var statusColor = STATUS_COLORS[ev.status.type] || STATUS_COLORS.neutral;
	            var detailEntries = ev.detail ? Object.keys(ev.detail).filter(function (k) {
	              return ev.detail[k] != null && ev.detail[k] !== "";
	            }) : [];
	            // Detail panel is always available — even rows with no
	            // detail items still surface the Action badge there now.
	            var hasDetail = true;
	            return _react2.default.createElement(
	              "div",
	              { key: ev.id },
	              _react2.default.createElement(
	                Row,
	                {
	                  open: isOpen,
	                  clickable: hasDetail,
	                  onClick: _this2.toggleExpand(ev.id)
	                },
	                _react2.default.createElement(
	                  Cell,
	                  null,
	                  ev.when
	                ),
	                _react2.default.createElement(
	                  Cell,
	                  null,
	                  ev.who
	                ),
	                _react2.default.createElement(
	                  DescriptionCell,
	                  null,
	                  renderDescription(ev.description)
	                ),
	                _react2.default.createElement(
	                  Cell,
	                  null,
	                  ev.amount || "—"
	                ),
	                _react2.default.createElement(
	                  Cell,
	                  null,
	                  _react2.default.createElement(
	                    StatusBadge,
	                    { bg: statusColor.bg, fg: statusColor.fg },
	                    ev.status.label
	                  )
	                ),
	                _react2.default.createElement(
	                  Cell,
	                  null,
	                  _react2.default.createElement(
	                    Chevron,
	                    { open: isOpen },
	                    "\u203A"
	                  )
	                )
	              ),
	              isOpen && _react2.default.createElement(
	                DetailPanel,
	                null,
	                _react2.default.createElement(
	                  DetailHeader,
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Action"
	                  ),
	                  _react2.default.createElement(
	                    ActionBadge,
	                    { bg: actionColor.bg, fg: actionColor.fg },
	                    ev.action
	                  )
	                ),
	                detailEntries.length > 0 && _react2.default.createElement(
	                  DetailGrid,
	                  null,
	                  detailEntries.map(function (k) {
	                    return _react2.default.createElement(
	                      DetailItem,
	                      { key: k },
	                      _react2.default.createElement(
	                        DetailKey,
	                        null,
	                        k
	                      ),
	                      ev.detail[k]
	                    );
	                  })
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return EventTable;
	}(_react.PureComponent);
	
	exports.default = EventTable;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _eventTable = __webpack_require__(1122);
	
	var _eventTable2 = _interopRequireDefault(_eventTable);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _ApiService = __webpack_require__(4);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var numberWithCommas = function numberWithCommas(x) {
	  return x != null && x !== "" ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
	};
	
	var fmtMoney = function fmtMoney(v) {
	  return "$" + numberWithCommas(Math.round(Number(v) || 0));
	};
	var fmtMoneyDecimals = function fmtMoneyDecimals(v) {
	  return "$" + (Number(v) || 0).toFixed(2);
	};
	
	// The backend stores journal request bodies as a Python repr string.
	// Two flavors show up in the wild:
	//   - Python 2: `{u'product': u'31955', u'price': 5}`
	//   - Python 3: `{'product': '31955', 'price': 5}`  ← no u-prefix
	// Strip the optional u-prefix, then swap single quotes for double
	// quotes so JSON.parse can read it. Also lowercase True/False/None.
	var jsonDecode = function jsonDecode(str) {
	  if (!str || typeof str !== "string") return {};
	  try {
	    var cleaned = str.replace(/u'/g, "'").replace(/'/g, '"').replace(/\bTrue\b/g, "true").replace(/\bFalse\b/g, "false").replace(/\bNone\b/g, "null");
	    return JSON.parse(cleaned);
	  } catch (e) {
	    return {};
	  }
	};
	
	// Journal `response` is stored server-side as a Python bytes-literal
	// repr — e.g. `b'{"id":31955,"name":"Hello",...}'`. The inner payload
	// is real JSON; we just need to strip the `b'`...`'` wrapper before
	// JSON.parse. Also tolerates already-parsed objects (older entries)
	// and plain JSON strings.
	var parseJournalResponse = function parseJournalResponse(raw) {
	  if (raw == null) return {};
	  if ((typeof raw === "undefined" ? "undefined" : _typeof(raw)) === "object") return raw;
	  if (typeof raw !== "string") return {};
	
	  var str = raw.trim();
	  if (str.startsWith("b'") && str.endsWith("'") || str.startsWith('b"') && str.endsWith('"')) {
	    str = str.slice(2, -1);
	  }
	  try {
	    return JSON.parse(str);
	  } catch (e) {
	    return jsonDecode(str);
	  }
	};
	
	var fmtTimestamp = function fmtTimestamp(ts) {
	  return (0, _moment2.default)(ts).format("MMM D, YYYY · h:mm A");
	};
	
	var STATUS_SUCCESS = { type: "success", label: "Success" };
	var STATUS_FAILURE = { type: "failure", label: "Failed" };
	var STATUS_NEUTRAL = { type: "neutral", label: "—" };
	
	var ROLES = [{ key: "ceo", path: "/ceo/audit-trail", label: "CEO" }, { key: "pd", path: "/pd/audit-trail", label: "Head of Product" }, { key: "pm", path: "/pm/audit-trail", label: "Head of Marketing" }, { key: "op", path: "/op/audit-trail", label: "Head of Operations" }, { key: "fn", path: "/fn/audit-trail", label: "Head of Finance" }];
	
	var AuditTrail = function (_PureComponent) {
	  _inherits(AuditTrail, _PureComponent);
	
	  function AuditTrail(props) {
	    _classCallCheck(this, AuditTrail);
	
	    var _this = _possibleConstructorReturn(this, (AuditTrail.__proto__ || Object.getPrototypeOf(AuditTrail)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var isInstructor = _Auth2.default.isAnyInstructor();
	
	    _this.state = {
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds,
	      histories: [],
	      users: [],
	      team_machines: [],
	      products: {},
	      equity_clients: [],
	      debt_clients: [],
	      marketing_clients: [],
	      sales_clients: [],
	      distribution_centers_info: [],
	      isInstructor: isInstructor
	    };
	    return _this;
	  }
	
	  _createClass(AuditTrail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          return _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	      var routes = location.pathname.split("/").filter(function (i) {
	        return i !== "";
	      });
	      var role = routes[0];
	      var activeRound = roundInUrl != null && roundInUrl !== currentRound ? roundInUrl : currentRound;
	
	      var events = this.eventsForRole(role);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "dashboard" },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              flexDirection: "row",
	              paddingTop: "30px"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "team-reports-menu" },
	            _react2.default.createElement(
	              "div",
	              { style: { display: "flex", flexDirection: "column" } },
	              ROLES.map(function (r) {
	                return _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    key: r.key,
	                    to: r.path + "?round=" + activeRound,
	                    className: role === r.key ? "active" : null,
	                    style: { paddingLeft: "15px" }
	                  },
	                  r.label
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                background: "#F5F7FB",
	                padding: "24px",
	                fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                width: "100%",
	                minHeight: "70vh"
	              }
	            },
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: 22,
	                  fontWeight: 800,
	                  color: "rgba(0, 27, 59, 0.94)",
	                  marginBottom: 4
	                }
	              },
	              "Audit Trail"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: 13,
	                  color: "rgba(0, 27, 59, 0.6)",
	                  marginBottom: 18
	                }
	              },
	              "Every post, update, and delete made by team members in this round."
	            ),
	            _react2.default.createElement(_eventTable2.default, { events: events })
	          )
	        )
	      );
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var _state = this.state,
	          currentRound = _state.currentRound,
	          roundInUrl = _state.roundInUrl;
	
	      if (roundInUrl != null && roundInUrl !== currentRound) return roundInUrl;
	      return currentRound || 0;
	    }
	
	    // Prefer a team_id passed via the URL query string (used by the
	    // instructor-facing /analysis/audit-trail route, which navigates
	    // here with the picked team) and fall back to the session's
	    // logged-in team for the existing role-prefixed flows
	    // (/ceo/audit-trail, /finance/audit-trail, …).
	
	
	    // Helper used by every formatter: resolve the user name from the
	    // journal entry's user id, falling back to "Unknown" so the row
	    // never renders blank.
	
	  }, {
	    key: "ceoEvents",
	
	
	    // ---------- CEO: /api/team/projections/ -----------------------------
	
	    get: function get() {
	      var _this3 = this;
	
	      var histories = this.state.histories;
	
	      return histories.filter(function (h) {
	        return h.path.startsWith("/api/team/projections/") && (h.method === "POST" && h.status_code === 201 || h.method === "PATCH" && h.status_code === 200) && h.round_number === _this3.activeRound;
	      }).map(function (h, idx) {
	        var t = (0, _moment2.default)(h.requested_at);
	        var resp = h.response || {};
	        var targetRoundNumber = resp.target_round_number;
	        var projectionLabel = targetRoundNumber != null ? "Projection for Year " + targetRoundNumber : "Projection";
	
	        return {
	          id: "ceo-" + idx + "-" + h.requested_at,
	          when: fmtTimestamp(h.requested_at),
	          unix: t.unix(),
	          who: _this3.whoFromUserId(h.user),
	          action: h.method === "POST" ? "Created" : "Updated",
	          description: projectionLabel,
	          amount: "—",
	          status: STATUS_SUCCESS,
	          detail: {
	            "Average Unit Costs": resp.average_unit_costs != null ? fmtMoneyDecimals(resp.average_unit_costs) : null,
	            "Other Expenses": resp.other_operating_costs != null ? "$" + (resp.other_operating_costs / 1e6).toFixed(2) + "M" : null,
	            "Average Selling Price": resp.average_selling_price != null ? fmtMoneyDecimals(resp.average_selling_price) : null,
	            "Units Sold": resp.units_sold != null ? (resp.units_sold / 1e6).toFixed(3) + "M" : null
	          },
	          round: h.round_number
	        };
	      });
	    }
	
	    // ---------- PD: /api/team/products/ + submit_development/ -----------
	
	  }, {
	    key: "pdEvents",
	    get: function get() {
	      var _this4 = this;
	
	      var histories = this.state.histories;
	
	      var productNames = Object.assign({}, this.state.products);
	      var events = [];
	
	      // R&D cost comes straight off the journal response payload for
	      // POST/PATCH. DELETE has no response body, so the amount falls
	      // through to "—".
	      var rndCostFromResp = function rndCostFromResp(resp) {
	        var v = resp && resp.rnd_costs;
	        if (v == null) return "—";
	        return fmtMoney(Math.abs(Number(v) || 0));
	      };
	
	      histories.filter(function (h) {
	        return (h.path.startsWith("/api/team/products/") && (h.method === "POST" && h.status_code === 201 || h.method === "PATCH" && h.status_code === 200 || h.method === "DELETE" && h.status_code === 204) || h.path === "/api/teams/submit_development/") && h.round_number === _this4.activeRound;
	      }).forEach(function (h, idx) {
	        var t = (0, _moment2.default)(h.requested_at);
	        var base = {
	          id: "pd-" + idx + "-" + h.requested_at,
	          when: fmtTimestamp(h.requested_at),
	          unix: t.unix(),
	          who: _this4.whoFromUserId(h.user),
	          round: h.round_number
	        };
	
	        if (h.path === "/api/teams/submit_development/") {
	          var success = h.response && h.response.success === true;
	          events.push(Object.assign({}, base, {
	            action: "Submitted",
	            description: success ? "Submission was successful" : "Submission failed",
	            amount: "—",
	            status: success ? STATUS_SUCCESS : STATUS_FAILURE,
	            detail: success ? null : { Error: h.response && h.response.message || "Unknown error" }
	          }));
	          return;
	        }
	
	        if (h.method === "POST") {
	          var data = jsonDecode(h.data || "{}");
	          var resp = h.response || {};
	          if (resp.id != null) {
	            productNames[resp.id] = data.name || resp.name;
	          }
	          var name = data && data.name || resp.name || "Unnamed";
	          events.push(Object.assign({}, base, {
	            action: "Created",
	            description: "Updated the features' quality for product **" + name + "** to Resolution: " + resp.pixels_rank + ", Sensitivity: " + resp.sensitivity_rank + ", Power: " + resp.power_rank + ", Temperature: " + resp.temp_range_rank,
	            amount: rndCostFromResp(resp),
	            status: STATUS_SUCCESS,
	            detail: null
	          }));
	          return;
	        }
	
	        if (h.method === "PATCH") {
	          var _resp = h.response || {};
	          var _name = productNames[_resp.id] || _resp.name || "Product";
	          events.push(Object.assign({}, base, {
	            action: "Updated",
	            description: "Updated the features' quality for product **" + _name + "** to Resolution: " + _resp.pixels_rank + ", Sensitivity: " + _resp.sensitivity_rank + ", Power: " + _resp.power_rank + ", Temperature: " + _resp.temp_range_rank,
	            amount: rndCostFromResp(_resp),
	            status: STATUS_SUCCESS,
	            detail: null
	          }));
	          return;
	        }
	
	        if (h.method === "DELETE") {
	          var match = h.path.match(/\/api\/team\/products\/(\d+)\//i);
	          var productId = match ? parseInt(match[1], 10) : null;
	          var _name2 = productId != null && productNames[productId] || "Product";
	          events.push(Object.assign({}, base, {
	            action: "Deleted",
	            description: "Deleted product **" + _name2 + "**",
	            amount: "—",
	            status: STATUS_SUCCESS,
	            detail: null
	          }));
	        }
	      });
	
	      return events;
	    }
	
	    // ---------- PM: journal-based event stream --------------------------
	    // Marketing audit trail tracks every POST/PUT/DELETE on price_forecasts,
	    // promos, and sales — including the bulk endpoints, which fan out into
	    // one row per item in the request body. Product names come from
	    // `products` (already keyed by id) and channel names from the
	    // marketing_clients / sales_clients lookups loaded off team-decisions
	    // role=marketing. Sales channels fall back to a hard-coded id→name
	    // map (3 = Direct Sales, 4 = Distributors) since static endpoints
	    // sometimes omit the list.
	
	  }, {
	    key: "pmEvents",
	    get: function get() {
	      var _this5 = this;
	
	      var histories = this.state.histories;
	
	      var events = [];
	
	      var isPmPath = function isPmPath(path) {
	        return path.startsWith("/api/team/price_forecasts/") || path.startsWith("/api/team/promos/") || path.startsWith("/api/team/sales/") || path === "/api/teams/submit_marketing/";
	      };
	
	      histories.filter(function (h) {
	        return h.round_number === _this5.activeRound && isPmPath(h.path);
	      }).filter(function (h) {
	        // Only successful writes belong in the audit trail. 2xx and 204
	        // pass; 4xx/5xx don't.
	        var code = h.status_code;
	        return code >= 200 && code < 300;
	      }).forEach(function (h, idx) {
	        var t = (0, _moment2.default)(h.requested_at);
	        var base = {
	          when: fmtTimestamp(h.requested_at),
	          unix: t.unix(),
	          who: _this5.whoFromUserId(h.user),
	          round: h.round_number
	        };
	        var data = h.data ? jsonDecode(h.data) : {};
	        var resp = h.response || {};
	
	        // ----- /api/team/price_forecasts/[bulk|N]/ ----------------------
	        if (h.path.startsWith("/api/team/price_forecasts/")) {
	          if (h.path === "/api/team/price_forecasts/bulk/") {
	            (data.forecasts || []).forEach(function (f, fIdx) {
	              var name = _this5.pmProductName(f.product);
	              var price = Number(f.price) || 0;
	              var forecast = Number(f.forecast) || 0;
	              var isZero = price === 0 && forecast === 0;
	              events.push(Object.assign({}, base, {
	                id: "pm-pfb-" + idx + "-" + fIdx + "-" + h.requested_at,
	                action: isZero ? "Deleted" : "Updated",
	                description: isZero ? "Deleted the price forecast decision for product **" + name + "**, dropping its selling price and unit forecast to zero." : "Updated product **" + name + "** selling price to " + fmtMoneyDecimals(price) + " and the unit forecast to " + numberWithCommas(forecast) + ".",
	                amount: "—",
	                status: STATUS_NEUTRAL,
	                detail: null
	              }));
	            });
	            return;
	          }
	          // Individual price_forecast endpoint. The journal body shape
	          // is {product, price, forecast}; we prefer the request body
	          // over the response so DELETEs (which have no response body)
	          // and bare POSTs still resolve correctly.
	          if (h.method === "DELETE") {
	            events.push(Object.assign({}, base, {
	              id: "pm-pf-" + idx + "-" + h.requested_at,
	              action: "Deleted",
	              description: "Deleted a price forecast decision, dropping its selling price and unit forecast to zero.",
	              amount: "—",
	              status: STATUS_NEUTRAL,
	              detail: null
	            }));
	            return;
	          }
	          var pid = data.product != null ? data.product : resp.product;
	          var price = Number(data.price != null ? data.price : resp.price) || 0;
	          var forecast = Number(data.forecast != null ? data.forecast : resp.forecast != null ? resp.forecast : 0);
	          var name = _this5.pmProductName(pid);
	          events.push(Object.assign({}, base, {
	            id: "pm-pf-" + idx + "-" + h.requested_at,
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: "Updated product **" + name + "** selling price to " + fmtMoneyDecimals(price) + " and the unit forecast to " + numberWithCommas(forecast) + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          }));
	          return;
	        }
	
	        // ----- /api/team/promos/[bulk|N]/ -------------------------------
	        if (h.path.startsWith("/api/team/promos/")) {
	          if (h.path === "/api/team/promos/bulk/") {
	            var _pid2 = data.product;
	            var _name4 = _this5.pmProductName(_pid2);
	            (data.spends || []).forEach(function (s, sIdx) {
	              var spend = Number(s.spend) || 0;
	              var clientName = _this5.pmMarketingClientName(s.client);
	              events.push(Object.assign({}, base, {
	                id: "pm-prb-" + idx + "-" + sIdx + "-" + h.requested_at,
	                action: spend === 0 ? "Deleted" : "Updated",
	                description: spend === 0 ? "Deleted the spend allocation in " + clientName + " for product **" + _name4 + "**." : "Adjusted the spend allocation for product **" + _name4 + "** to " + fmtMoney(spend) + " in " + clientName + ".",
	                amount: spend === 0 ? "—" : fmtMoney(spend),
	                status: STATUS_NEUTRAL,
	                detail: null
	              }));
	            });
	            return;
	          }
	          if (h.method === "DELETE") {
	            // The individual DELETE doesn't carry product/client in the
	            // path or response, so the message stays generic.
	            events.push(Object.assign({}, base, {
	              id: "pm-pr-" + idx + "-" + h.requested_at,
	              action: "Deleted",
	              description: "Deleted a promotional spend allocation.",
	              amount: "—",
	              status: STATUS_NEUTRAL,
	              detail: null
	            }));
	            return;
	          }
	          var _pid = resp.product != null ? resp.product : data.product;
	          var cid = resp.client != null ? resp.client : data.client;
	          var spend = Number(resp.spend != null ? resp.spend : data.spend) || 0;
	          var _name3 = _this5.pmProductName(_pid);
	          var clientName = _this5.pmMarketingClientName(cid);
	          events.push(Object.assign({}, base, {
	            id: "pm-pr-" + idx + "-" + h.requested_at,
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: h.method === "POST" ? "Spent " + fmtMoney(spend) + " in " + clientName + " to promote product **" + _name3 + "**." : "Adjusted the spend allocation for product **" + _name3 + "** to " + fmtMoney(spend) + " in " + clientName + ".",
	            amount: fmtMoney(spend),
	            status: STATUS_NEUTRAL,
	            detail: null
	          }));
	          return;
	        }
	
	        // ----- /api/team/sales/[bulk|N]/ --------------------------------
	        if (h.path.startsWith("/api/team/sales/")) {
	          if (h.path === "/api/team/sales/bulk/") {
	            // Atomic replace — group entries by product so each product
	            // becomes one row listing the channels selected for it.
	            var byProduct = {};
	            (data.sales || []).forEach(function (s) {
	              var pid = s.product;
	              if (!byProduct[pid]) byProduct[pid] = [];
	              byProduct[pid].push(s.client);
	            });
	            Object.keys(byProduct).forEach(function (pidStr, pIdx) {
	              var pid = Number(pidStr);
	              var name = _this5.pmProductName(pid);
	              var clients = byProduct[pid] || [];
	              if (clients.length === 0) {
	                events.push(Object.assign({}, base, {
	                  id: "pm-sb-" + idx + "-" + pIdx + "-" + h.requested_at,
	                  action: "Deleted",
	                  description: "Channel Strategy deleted for product **" + name + "**.",
	                  amount: "—",
	                  status: STATUS_NEUTRAL,
	                  detail: null
	                }));
	                return;
	              }
	              var clientList = clients.map(function (c) {
	                return _this5.pmSalesClientName(c);
	              }).join(" and ");
	              events.push(Object.assign({}, base, {
	                id: "pm-sb-" + idx + "-" + pIdx + "-" + h.requested_at,
	                action: "Updated",
	                description: "Adjusted the channel strategy for product **" + name + "** to " + clientList + ".",
	                amount: "—",
	                status: STATUS_NEUTRAL,
	                detail: null
	              }));
	            });
	            return;
	          }
	          if (h.method === "DELETE") {
	            events.push(Object.assign({}, base, {
	              id: "pm-sa-" + idx + "-" + h.requested_at,
	              action: "Deleted",
	              description: "Channel Strategy deleted.",
	              amount: "—",
	              status: STATUS_NEUTRAL,
	              detail: null
	            }));
	            return;
	          }
	          var _pid3 = resp.product != null ? resp.product : data.product;
	          var _cid = resp.client != null ? resp.client : data.client;
	          var _name5 = _this5.pmProductName(_pid3);
	          var _clientName = _this5.pmSalesClientName(_cid);
	          events.push(Object.assign({}, base, {
	            id: "pm-sa-" + idx + "-" + h.requested_at,
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: h.method === "POST" ? "Selected " + _clientName + " as the channel strategy for product **" + _name5 + "**." : "Adjusted the channel strategy for product **" + _name5 + "** to " + _clientName + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          }));
	          return;
	        }
	
	        // ----- /api/teams/submit_marketing/ -----------------------------
	        if (h.path === "/api/teams/submit_marketing/") {
	          var success = h.response && h.response.success === true;
	          events.push(Object.assign({}, base, {
	            id: "pm-submit-" + idx + "-" + h.requested_at,
	            action: "Submitted",
	            description: success ? "Submission was successful" : "Submission failed",
	            amount: "—",
	            status: success ? STATUS_SUCCESS : STATUS_FAILURE,
	            detail: success ? null : { Error: h.response && h.response.message || "Unknown error" }
	          }));
	        }
	      });
	
	      return events;
	    }
	
	    // ---------- OP: machines + product_manufactures + submit_operations -
	    // The production-line number (1..N) shown in descriptions doesn't
	    // come from the path id — that's the DB pk. For machine purchases,
	    // the journal `data` body carries `machine` as the line number; for
	    // sells we extract the path id and resolve the line via two lookup
	    // sources, in order: team_machines (current list) and a journal-walk
	    // map built from prior /api/team/machines/ POSTs.
	    //
	    // For DELETE on /product_manufactures/<id>/, the path tells us the
	    // pm row id but not the product. We build a {pm_id → product_id}
	    // map from prior POST/PUT responses in this round so the description
	    // can name the product even after deletion.
	    //
	    // /get_max_allowed/ and /api/team/factories/ are not user-driven
	    // decisions and are filtered out entirely.
	
	  }, {
	    key: "opEvents",
	    get: function get() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          histories = _state2.histories,
	          team_machines = _state2.team_machines,
	          distribution_centers_info = _state2.distribution_centers_info;
	
	      // machineDbId → production line number
	
	      var machineDbToLine = {};
	      team_machines.forEach(function (m) {
	        if (m && m.id != null) machineDbToLine[m.id] = m.machine;
	      });
	      histories.forEach(function (h) {
	        if (h.path === "/api/team/machines/" && h.method === "POST" && h.response && h.response.id != null) {
	          machineDbToLine[h.response.id] = h.response.machine;
	        }
	      });
	
	      // product_manufactures row id → product id (for DELETE lookups)
	      var pmIdToProduct = {};
	      histories.forEach(function (h) {
	        var isPmCreate = h.path === "/api/team/product_manufactures/" && h.method === "POST";
	        var isPmUpdate = /^\/api\/team\/product_manufactures\/\d+\/?$/i.test(h.path) && h.method === "PUT";
	        if ((isPmCreate || isPmUpdate) && h.response && h.response.id != null && h.response.product != null) {
	          pmIdToProduct[h.response.id] = h.response.product;
	        }
	      });
	
	      // Distribution-center static lookup: id → display name. Used to
	      // surface a readable location ("Toledo", "Little Rock") rather
	      // than a raw id in team-center rows.
	      var dcNameById = {};
	      (distribution_centers_info || []).forEach(function (dc) {
	        if (dc && dc.id != null) {
	          dcNameById[dc.id] = dc.name || dc.location || "DC " + dc.id;
	        }
	      });
	      // Returns the resolved DC display name or null if we couldn't
	      // figure out which DC this row refers to. The render branches
	      // adapt their copy when null is returned (rather than splicing
	      // "DC undefined" or a stale id into the sentence).
	      var dcName = function dcName(id) {
	        if (id == null) return null;
	        return dcNameById[id] || null;
	      };
	
	      // team_center row id → distribution_center id (for DELETE lookups)
	      // The DC id can show up under several field names depending on the
	      // serializer (`distribution_center` from the model, `distributionCenter`
	      // camelCased, or just echoed from the request body). Check all of
	      // them so the DELETE row can still name the DC.
	      var teamCenterToDc = {};
	      histories.forEach(function (h) {
	        if (h.path === "/api/v2/distributions/team-centers/" && h.method === "POST" && h.response && h.response.id != null) {
	          var data = h.data ? jsonDecode(h.data) : {};
	          var dcId = h.response.distribution_center != null ? h.response.distribution_center : h.response.distributionCenter != null ? h.response.distributionCenter : data.distribution_center != null ? data.distribution_center : data.distributionCenter != null ? data.distributionCenter : null;
	          if (dcId != null) {
	            teamCenterToDc[h.response.id] = dcId;
	            teamCenterToDc[String(h.response.id)] = dcId;
	          }
	        }
	      });
	
	      return histories.filter(function (h) {
	        return h.round_number === _this6.activeRound;
	      }).filter(function (h) {
	        return !h.path.includes("/get_max_allowed/");
	      }).filter(function (h) {
	        return !h.path.startsWith("/api/team/factories/");
	      }).filter(function (h) {
	        var isMachineBuy = h.path === "/api/team/machines/" && h.method === "POST" && h.status_code === 201;
	        var isMachineSell = /\/api\/team\/machines\/\d+\/sell\/?$/i.test(h.path) && h.method === "POST";
	        var isMachineUnsell = /\/api\/team\/machines\/\d+\/unsell\/?$/i.test(h.path) && h.method === "POST";
	        var isPmCreate = h.path === "/api/team/product_manufactures/" && h.method === "POST" && h.status_code === 201;
	        var isPmUpdate = /^\/api\/team\/product_manufactures\/\d+\/?$/i.test(h.path) && h.method === "PUT" && h.status_code === 200;
	        var isPmDelete = /^\/api\/team\/product_manufactures\/\d+\/?$/i.test(h.path) && h.method === "DELETE";
	        var isDcCreate = h.path === "/api/v2/distributions/team-centers/" && h.method === "POST" && h.status_code === 201;
	        var isDcDelete = /^\/api\/v2\/distributions\/team-centers\/\d+\/?$/i.test(h.path) && h.method === "DELETE";
	        var isSubmit = h.path === "/api/teams/submit_operations/";
	        return isMachineBuy || isMachineSell || isMachineUnsell || isPmCreate || isPmUpdate || isPmDelete || isDcCreate || isDcDelete || isSubmit;
	      }).map(function (h, idx) {
	        var t = (0, _moment2.default)(h.requested_at);
	        var base = {
	          id: "op-" + idx + "-" + h.requested_at,
	          when: fmtTimestamp(h.requested_at),
	          unix: t.unix(),
	          who: _this6.whoFromUserId(h.user),
	          round: h.round_number
	        };
	        var data = h.data ? jsonDecode(h.data) : {};
	        var resp = h.response || {};
	
	        // ----- /api/team/machines/ (acquire) ---------------------------
	        if (h.path === "/api/team/machines/" && h.method === "POST") {
	          var line = data.machine != null ? data.machine : resp.machine;
	          return Object.assign({}, base, {
	            action: "Created",
	            description: "Acquired production line " + (line != null ? line : "—") + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/machines/<id>/sell/ ---------------------------
	        if (/\/api\/team\/machines\/\d+\/sell\/?$/i.test(h.path)) {
	          var match = h.path.match(/\/api\/team\/machines\/(\d+)\/sell\/?$/i);
	          var machineDbId = match ? parseInt(match[1], 10) : null;
	          var _line = machineDbId != null ? machineDbToLine[machineDbId] : null;
	          return Object.assign({}, base, {
	            action: "Deleted",
	            description: "Sold production line " + (_line != null ? _line : machineDbId) + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/machines/<id>/unsell/ -------------------------
	        if (/\/api\/team\/machines\/\d+\/unsell\/?$/i.test(h.path)) {
	          var _match = h.path.match(/\/api\/team\/machines\/(\d+)\/unsell\/?$/i);
	          var _machineDbId = _match ? parseInt(_match[1], 10) : null;
	          var _line2 = _machineDbId != null ? machineDbToLine[_machineDbId] : null;
	          return Object.assign({}, base, {
	            action: "Updated",
	            description: "Canceled the sale of production line " + (_line2 != null ? _line2 : _machineDbId) + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/product_manufactures/ (create) ----------------
	        if (h.path === "/api/team/product_manufactures/" && h.method === "POST") {
	          var productId = resp.product;
	          var name = _this6.pmProductName(productId);
	          var units = numberWithCommas(resp.units_produced);
	          var _line3 = machineDbToLine[resp.machine];
	          return Object.assign({}, base, {
	            action: "Created",
	            description: "Updated production for product **" + name + "** to " + units + " units on production line " + (_line3 != null ? _line3 : "—") + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/product_manufactures/<id>/ (update) -----------
	        if (/^\/api\/team\/product_manufactures\/\d+\/?$/i.test(h.path) && h.method === "PUT") {
	          var _productId = resp.product;
	          var _name6 = _this6.pmProductName(_productId);
	          var _units = numberWithCommas(resp.units_produced);
	          var _line4 = machineDbToLine[resp.machine];
	          return Object.assign({}, base, {
	            action: "Updated",
	            description: "Updated production for product **" + _name6 + "** to " + _units + " units on production line " + (_line4 != null ? _line4 : "—") + ".",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/product_manufactures/<id>/ (delete) -----------
	        if (/^\/api\/team\/product_manufactures\/\d+\/?$/i.test(h.path) && h.method === "DELETE") {
	          var _match2 = h.path.match(/^\/api\/team\/product_manufactures\/(\d+)\/?$/i);
	          var pmId = _match2 ? parseInt(_match2[1], 10) : null;
	          var _productId2 = pmId != null ? pmIdToProduct[pmId] : null;
	          var _name7 = _productId2 != null ? _this6.pmProductName(_productId2) : "product";
	          return Object.assign({}, base, {
	            action: "Deleted",
	            description: "Deleted production for product **" + _name7 + "**",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/v2/distributions/team-centers/ (create) -----------
	        if (h.path === "/api/v2/distributions/team-centers/" && h.method === "POST") {
	          // Prefer the explicit name the backend echoes in response or
	          // request body; only fall back to the id-based lookup against
	          // distribution_centers_info when neither carries one.
	          var explicitName = resp.distribution_center_name || data.distribution_center_name || null;
	          var dcId = resp.distribution_center != null ? resp.distribution_center : data.distribution_center != null ? data.distribution_center : null;
	          var _name8 = explicitName || dcName(dcId);
	          return Object.assign({}, base, {
	            action: "Created",
	            description: _name8 ? "Selected distribution center " + _name8 : "Selected a distribution center",
	            amount: resp.cash_payment != null ? fmtMoney(resp.cash_payment) : "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/v2/distributions/team-centers/<id>/ (delete) ------
	        if (/^\/api\/v2\/distributions\/team-centers\/\d+\/?$/i.test(h.path) && h.method === "DELETE") {
	          var _explicitName = resp.distribution_center_name || data.distribution_center_name || null;
	          var dcIdFromBody = resp.distribution_center != null ? resp.distribution_center : data.distribution_center != null ? data.distribution_center : null;
	          var _dcId = dcIdFromBody;
	          if (_dcId == null) {
	            // Older journal entries don't echo distribution_center on DELETE;
	            // fall back to the walk-back map keyed by the team-center row id
	            // pulled from the URL path.
	            var _match3 = h.path.match(/^\/api\/v2\/distributions\/team-centers\/(\d+)\/?$/i);
	            var teamCenterId = _match3 ? parseInt(_match3[1], 10) : null;
	            if (teamCenterId != null) _dcId = teamCenterToDc[teamCenterId];
	          }
	          var _name9 = _explicitName || dcName(_dcId);
	          return Object.assign({}, base, {
	            action: "Deleted",
	            description: _name9 ? "Deleted distribution center " + _name9 + " decision" : "Deleted distribution center decision",
	            amount: "—",
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/teams/submit_operations/ ---------------------------
	        if (h.path === "/api/teams/submit_operations/") {
	          var success = resp && resp.success === true;
	          return Object.assign({}, base, {
	            action: "Submitted",
	            description: success ? "Submission was successful" : "Submission failed",
	            amount: "—",
	            status: success ? STATUS_SUCCESS : STATUS_FAILURE,
	            detail: success ? null : { Error: resp && resp.message || "Unknown error" }
	          });
	        }
	
	        return null;
	      }).filter(Boolean);
	    }
	
	    // ---------- FN: journal-based event stream --------------------------
	    // Tracks the three finance write endpoints the user spec'd
	    // (/equities/, /debts/, /debt_repayments/) plus the submit_finance
	    // call. Counterparty names come from /static/equity_clients/ and
	    // /static/debt_clients/. Any /api/static/debt_clients GETs that
	    // leak into the journal are filtered out explicitly.
	
	  }, {
	    key: "fnEvents",
	    get: function get() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          histories = _state3.histories,
	          equity_clients = _state3.equity_clients,
	          debt_clients = _state3.debt_clients;
	
	
	      var equityClientName = function equityClientName(id) {
	        var c = (equity_clients || []).find(function (c) {
	          return c.id === id;
	        });
	        return c ? c.name : "Investor " + id;
	      };
	      var debtClientName = function debtClientName(id) {
	        var c = (debt_clients || []).find(function (c) {
	          return c.id === id;
	        });
	        return c ? c.name : "Lender " + id;
	      };
	
	      return histories.filter(function (h) {
	        return h.round_number === _this7.activeRound;
	      }).filter(function (h) {
	        return !h.path.startsWith("/api/static/debt_clients");
	      }).filter(function (h) {
	        // Audit trail surfaces accepted writes only — failed (4xx)
	        // requests on these endpoints carry an error-shaped response
	        // body, not the model fields, so letting them through would
	        // print things like "Issued shares to Investor undefined".
	        // The submit_finance row is exempt because the audit trail
	        // intentionally shows successful AND failed submissions.
	        var ok = h.status_code >= 200 && h.status_code < 300;
	        var isSubmit = h.path === "/api/teams/submit_finance/";
	        if (!ok && !isSubmit) return false;
	
	        var equityCreate = h.path === "/api/team/equities/" && h.method === "POST";
	        var equityUpdate = /^\/api\/team\/equities\/\d+\/?$/i.test(h.path) && h.method === "PUT";
	        var debtCreate = h.path === "/api/team/debts/" && h.method === "POST";
	        var debtUpdate = /^\/api\/team\/debts\/\d+\/?$/i.test(h.path) && h.method === "PUT";
	        var repayCreate = h.path === "/api/team/debt_repayments/" && h.method === "POST";
	        var repayUpdate = /^\/api\/team\/debt_repayments\/\d+\/?$/i.test(h.path) && h.method === "PUT";
	        var interestCreate = h.path === "/api/v2/finance/interest-payments/" && h.method === "POST";
	        var interestUpdate = /^\/api\/v2\/finance\/interest-payments\/\d+\/?$/i.test(h.path) && h.method === "PUT";
	        return equityCreate || equityUpdate || debtCreate || debtUpdate || repayCreate || repayUpdate || interestCreate || interestUpdate || isSubmit;
	      }).map(function (h, idx) {
	        var t = (0, _moment2.default)(h.requested_at);
	        var base = {
	          id: "fn-" + idx + "-" + h.requested_at,
	          when: fmtTimestamp(h.requested_at),
	          unix: t.unix(),
	          who: _this7.whoFromUserId(h.user),
	          round: h.round_number
	        };
	        var resp = h.response || {};
	
	        // ----- /api/team/equities/ ------------------------------------
	        if (h.path.startsWith("/api/team/equities/")) {
	          var clientName = equityClientName(resp.client);
	          var issuance = numberWithCommas(resp.issuance);
	          var amount = resp.total_capital != null ? fmtMoney(resp.total_capital) : "—";
	          return Object.assign({}, base, {
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: h.method === "POST" ? "Issued " + issuance + " shares to " + clientName : "Adjusted issuance to " + issuance + " shares to " + clientName,
	            amount: amount,
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/debts/ ---------------------------------------
	        // Path prefix `/api/team/debts/` does not match
	        // `/api/team/debt_repayments/` (the 15th char differs).
	        if (h.path.startsWith("/api/team/debts/")) {
	          var _clientName2 = debtClientName(resp.client);
	          var _amount = resp.new_amount != null ? fmtMoney(resp.new_amount) : "—";
	          return Object.assign({}, base, {
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: h.method === "POST" ? "Borrowed from " + _clientName2 : "Adjusted the borrowing amount from " + _clientName2,
	            amount: _amount,
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/team/debt_repayments/ -----------------------------
	        if (h.path.startsWith("/api/team/debt_repayments/")) {
	          var _clientName3 = debtClientName(resp.client);
	          var _amount2 = resp.amount != null ? fmtMoney(resp.amount) : "—";
	          return Object.assign({}, base, {
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: h.method === "POST" ? "Made a payment to reduce outstanding loan balance from " + _clientName3 : "Adjusted loan repayment to " + _clientName3,
	            amount: _amount2,
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/v2/finance/interest-payments/ ---------------------
	        if (h.path.startsWith("/api/v2/finance/interest-payments/")) {
	          var _clientName4 = debtClientName(resp.client);
	          var _amount3 = resp.amount != null ? fmtMoney(resp.amount) : "—";
	          return Object.assign({}, base, {
	            action: h.method === "POST" ? "Created" : "Updated",
	            description: h.method === "POST" ? "Made a payment to reduce outstanding loan balance from " + _clientName4 : "Adjusted loan repayment to " + _clientName4,
	            amount: _amount3,
	            status: STATUS_NEUTRAL,
	            detail: null
	          });
	        }
	
	        // ----- /api/teams/submit_finance/ -----------------------------
	        if (h.path === "/api/teams/submit_finance/") {
	          var success = resp && resp.success === true;
	          return Object.assign({}, base, {
	            action: "Submitted",
	            description: success ? "Submission was successful" : "Submission failed",
	            amount: "—",
	            status: success ? STATUS_SUCCESS : STATUS_FAILURE,
	            detail: success ? null : { Error: resp && resp.message || "Unknown error" }
	          });
	        }
	
	        return null;
	      }).filter(Boolean);
	    }
	  }]);
	
	  return AuditTrail;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this8 = this;
	
	  this.resolveTeamId = function () {
	    var queryTeamId = _this8.props.location && _this8.props.location.query && _this8.props.location.query.team_id;
	    var parsed = Number(queryTeamId);
	    if (queryTeamId && !isNaN(parsed) && parsed > 0) return parsed;
	    return _Auth2.default.getTeamId();
	  };
	
	  this.fetchData = function () {
	    var isInstructor = _this8.state.isInstructor;
	
	    var team_id = _this8.resolveTeamId();
	
	    _this8.getAuditTrailRequest(isInstructor, team_id).then(function (res) {
	      var histories = res.filter(function (r) {
	        return r.statusCode === 200;
	      }).reduce(function (acc, r) {
	        return acc.concat(r.body);
	      }, []).map(function (h) {
	        return Object.assign({}, h, { response: parseJournalResponse(h.response) });
	      });
	      _this8.setState({ histories: histories });
	    }).catch(function () {});
	
	    // Teammate names come from Teams.players() — localStorage cache
	    // populated by App.js from data.teamplayers on general-info. The
	    // old /api/users/ endpoint only ever returned the signed-in user,
	    // so any journal row authored by a teammate rendered as "Unknown".
	    var players = _Teams2.default.players() || [];
	    var users = players.map(function (p) {
	      return p && p.user;
	    }).filter(function (u) {
	      return u && u.id != null;
	    });
	    _this8.setState({ users: users });
	
	    _this8.getProductsRequest(isInstructor, team_id).then(function (res) {
	      var products = {};
	      res.body.forEach(function (p) {
	        products[p.id] = p.name;
	      });
	      _this8.setState({ products: products });
	    }).catch(function () {});
	
	    _this8.getTeamMachinesRequest(isInstructor, team_id).then(function (res) {
	      return _this8.setState({ team_machines: res.body });
	    }).catch(function () {});
	
	    _this8.getEquityClientsRequest().then(function (res) {
	      return _this8.setState({ equity_clients: res.body || [] });
	    }).catch(function () {});
	
	    _this8.getDebtClientsRequest().then(function (res) {
	      return _this8.setState({ debt_clients: res.body || [] });
	    }).catch(function () {});
	
	    // Pull marketing_clients (and sales_clients when surfaced) from
	    // team-decisions role=marketing so the PM descriptions can name the
	    // promo channel and sales channel rather than show raw ids.
	    (0, _TeamDecisionsService.fetchTeamDecisions)(_this8.activeRound, "marketing").then(function (decisions) {
	      _this8.setState({
	        marketing_clients: decisions.marketing_clients || [],
	        sales_clients: decisions.sales_clients || []
	      });
	    }).catch(function () {});
	
	    // Pull distribution_centers_info from team-decisions role=operations
	    // so OP team-center rows can name the distribution center the user
	    // selected/deleted (e.g. "Toledo", "Little Rock") instead of an id.
	    (0, _TeamDecisionsService.fetchTeamDecisions)(_this8.activeRound, "operations").then(function (decisions) {
	      _this8.setState({
	        distribution_centers_info: decisions.distributionCentersInfo || []
	      });
	    }).catch(function () {});
	  };
	
	  this.getEquityClientsRequest = function () {
	    return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "static/equity_clients/");
	  };
	
	  this.getDebtClientsRequest = function () {
	    return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "static/debt_clients/");
	  };
	
	  this.getTeamMachinesRequest = function (isInstructor, team_id) {
	    return (0, _ApiService.getRequest)(isInstructor ? ("https://be-production-itb.marketgames.io/api/") + "team/machines/?team_id=" + team_id : ("https://be-production-itb.marketgames.io/api/") + "team/machines/");
	  };
	
	  this.getProductsRequest = function (isInstructor, team_id) {
	    return (0, _ApiService.getRequest)(isInstructor ? ("https://be-production-itb.marketgames.io/api/") + "team/products/?round_lte=" + _this8.activeRound + "&team_id=" + team_id : ("https://be-production-itb.marketgames.io/api/") + "team/products/?round_lte=" + _this8.activeRound);
	  };
	
	  this.getAuditTrailRequest = function (isInstructor, team_id) {
	    var game_id = _Auth2.default.getGameId();
	    var requests = [];
	    for (var i = 1; i <= _this8.activeRound; i++) {
	      requests.push(isInstructor ? ("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/journal/?round_number=" + i + "&team_id=" + team_id : ("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/journal/?round_number=" + i);
	    }
	    return (0, _ApiService.batchRequest)(requests);
	  };
	
	  this.whoFromUserId = function (userId) {
	    var user = _this8.state.users.find(function (u) {
	      return u.id === userId;
	    });
	    return user ? user.first_name + " " + user.last_name : "Unknown";
	  };
	
	  this.pmProductName = function (id) {
	    // Journal payload can carry product as either a number or a quoted
	    // string (e.g. '31955'). The products map is keyed by numeric id,
	    // so coerce before lookup. Both numeric and string keys are
	    // accepted as a safety net.
	    if (id == null) return "product";
	    var numKey = Number(id);
	    return _this8.state.products[numKey] || _this8.state.products[id] || "product";
	  };
	
	  this.pmMarketingClientName = function (id) {
	    var c = (_this8.state.marketing_clients || []).find(function (c) {
	      return c.id === id;
	    });
	    return c ? c.name : "Client " + id;
	  };
	
	  this.pmSalesClientName = function (id) {
	    var c = (_this8.state.sales_clients || []).find(function (c) {
	      return c.id === id;
	    });
	    if (c) return c.name;
	    if (Number(id) === 3) return "Direct Sales";
	    if (Number(id) === 4) return "Distributors";
	    return "Client " + id;
	  };
	
	  this.eventsForRole = function (role) {
	    if (role === "ceo") return _this8.ceoEvents;
	    if (role === "pd") return _this8.pdEvents;
	    if (role === "pm") return _this8.pmEvents;
	    if (role === "op") return _this8.opEvents;
	    if (role === "fn") return _this8.fnEvents;
	    return [];
	  };
	};
	
	exports.default = AuditTrail;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _lodash = __webpack_require__(21);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var divStyle = {
	  marginTop: "1em",
	  marginBottom: "1em"
	};
	
	var linkStyle = {
	  fontSize: "12px",
	  fontFamily: "Lato",
	  color: "#828282"
	};
	
	var separatorStyle = {
	  marginLeft: "1ch",
	  marginRight: "1ch",
	  fontSize: "12px",
	  fontFamily: "Lato",
	  color: "#828282"
	};
	
	var bStyle = {
	  fontSize: "12px",
	  fontFamily: "Lato",
	  color: "#222222"
	};
	
	exports.default = (0, _recompose.pure)(function (_ref) {
	  var crumbs = _ref.crumbs;
	  return _react2.default.createElement(
	    "div",
	    { style: divStyle },
	    (0, _lodash.flatten)((0, _lodash.map)(crumbs, function (_ref2, index) {
	      var location = _ref2.location,
	          label = _ref2.label;
	      return [index !== 0 ? _react2.default.createElement(
	        "span",
	        { key: location + ":" + label + "-sep", style: separatorStyle },
	        ">"
	      ) : null, location ? _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: location,
	          style: linkStyle,
	          key: location + ":" + label
	        },
	        label
	      ) : _react2.default.createElement(
	        "b",
	        { key: location + ":" + label, style: bStyle },
	        label
	      )];
	    }))
	  );
	});

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessCase = function BusinessCase(props) {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "BUSINESS CASE" },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: "/analysis/bcase/executive-summary" },
	      "Start to read"
	    ),
	    " ",
	    "MG Business Case."
	  );
	};
	
	exports.default = BusinessCase;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(573);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _BusinessCase = __webpack_require__(1125);
	
	var _BusinessCase2 = _interopRequireDefault(_BusinessCase);
	
	var _ExecutiveSummary = __webpack_require__(1127);
	
	var _ExecutiveSummary2 = _interopRequireDefault(_ExecutiveSummary);
	
	var _OpportunityEconomyIndustry = __webpack_require__(1138);
	
	var _OpportunityEconomyIndustry2 = _interopRequireDefault(_OpportunityEconomyIndustry);
	
	var _Market = __webpack_require__(1129);
	
	var _Market2 = _interopRequireDefault(_Market);
	
	var _Product = __webpack_require__(1139);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Operations = __webpack_require__(1137);
	
	var _Operations2 = _interopRequireDefault(_Operations);
	
	var _Investors = __webpack_require__(1128);
	
	var _Investors2 = _interopRequireDefault(_Investors);
	
	var _ModalExhibit = __webpack_require__(1131);
	
	var _ModalExhibit2 = _interopRequireDefault(_ModalExhibit);
	
	var _ModalExhibit3 = __webpack_require__(1132);
	
	var _ModalExhibit4 = _interopRequireDefault(_ModalExhibit3);
	
	var _ModalExhibit5 = __webpack_require__(1133);
	
	var _ModalExhibit6 = _interopRequireDefault(_ModalExhibit5);
	
	var _ModalExhibit7 = __webpack_require__(1134);
	
	var _ModalExhibit8 = _interopRequireDefault(_ModalExhibit7);
	
	var _ModalExhibit9 = __webpack_require__(1135);
	
	var _ModalExhibit10 = _interopRequireDefault(_ModalExhibit9);
	
	var _ModalExhibit11 = __webpack_require__(1136);
	
	var _ModalExhibit12 = _interopRequireDefault(_ModalExhibit11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paperStyle = {
	  width: "100%"
	};
	
	var Content = function Content(_ref) {
	  var ifLoaded = _ref.ifLoaded,
	      active = _ref.active;
	  return ({
	    "": function _() {
	      return _react2.default.createElement(_BusinessCase2.default, null);
	    },
	    "executive-summary": function executiveSummary() {
	      return ifLoaded(["initialDemand", "bcaseRevenueEstimate"], _ExecutiveSummary2.default);
	    },
	    "opportunity-economy-industry": function opportunityEconomyIndustry() {
	      return _react2.default.createElement(_OpportunityEconomyIndustry2.default, null);
	    },
	    market: function market() {
	      return ifLoaded(["initialDemand", "salesClients", "bcasePriceFloor", "bcasePriceCeiling", "activeRound"], _Market2.default);
	    },
	    product: function product() {
	      return ifLoaded(["activeRound"], _Product2.default);
	    },
	    operations: function operations() {
	      return ifLoaded(["constants", "activeRound"], _Operations2.default);
	    },
	    investors: function investors() {
	      return ifLoaded(["primeRates", "constants", "activeRound", "debtClients"], _Investors2.default);
	    },
	    "modal-exhibit1": function modalExhibit1() {
	      return ifLoaded(["initialDemand", "demandGrowthRate", "goBack"], _ModalExhibit2.default);
	    },
	    "modal-exhibit2": function modalExhibit2() {
	      return ifLoaded(["features", "activeRound", "goBack"], _ModalExhibit4.default);
	    },
	    "modal-exhibit3": function modalExhibit3() {
	      return ifLoaded(["features", "activeRound", "goBack"], _ModalExhibit6.default);
	    },
	    "modal-exhibit4": function modalExhibit4() {
	      return ifLoaded(["machines", "goBack"], _ModalExhibit8.default);
	    },
	    "modal-exhibit5": function modalExhibit5() {
	      return ifLoaded(["debtClients", "ratings", "goBack"], _ModalExhibit10.default);
	    },
	    "modal-exhibit6": function modalExhibit6() {
	      return ifLoaded(["comparableCompanies", "goBack"], _ModalExhibit12.default);
	    }
	  }[active] || function () {
	    return _react2.default.createElement(
	      _Paper2.default,
	      { style: paperStyle },
	      "Page Not Found"
	    );
	  })();
	};
	
	exports.default = Content;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  color: #2a4169;\n  font-weight: bold;\n"], ["\n  color: #2a4169;\n  font-weight: bold;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  color: #ff5252;\n  font-weight: bold;\n"], ["\n  color: #ff5252;\n  font-weight: bold;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  color: #52c5cd;\n  font-weight: bold;\n"], ["\n  color: #52c5cd;\n  font-weight: bold;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  color: #f9c151;\n  font-weight: bold;\n"], ["\n  color: #f9c151;\n  font-weight: bold;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  color: #9900ff;\n  font-weight: bold;\n"], ["\n  color: #9900ff;\n  font-weight: bold;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  color: #38761D;\n  font-weight: bold;\n"], ["\n  color: #38761D;\n  font-weight: bold;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  color: #FF00FF;\n  font-weight: bold;\n"], ["\n  color: #FF00FF;\n  font-weight: bold;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  padding: 0 0 0 40px;\n  list-style: disc;\n"], ["\n  padding: 0 0 0 40px;\n  list-style: disc;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-size: 16px !important;\n  line-height: 22.8571px;\n"], ["\n  font-size: 16px !important;\n  line-height: 22.8571px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  color: #2a4169;\n  font-size: 18px;\n  font-weight: bold;\n"], ["\n  color: #2a4169;\n  font-size: 18px;\n  font-weight: bold;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _styles = __webpack_require__(95);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ProductColor = _styledComponents2.default.span(_templateObject);
	
	var MarketingColor = _styledComponents2.default.span(_templateObject2);
	
	var OperationsColor = _styledComponents2.default.span(_templateObject3);
	
	var CeoColor = _styledComponents2.default.span(_templateObject4);
	
	var FinanceColor = _styledComponents2.default.span(_templateObject5);
	
	var DarkGreenColor = _styledComponents2.default.span(_templateObject6);
	
	var DarkMagenta = _styledComponents2.default.span(_templateObject7);
	
	var UnorderedList = _styledComponents2.default.ul(_templateObject8);
	
	var ListItem = _styledComponents2.default.li(_templateObject9);
	
	var SubTitle = _styledComponents2.default.h2(_templateObject10);
	
	var calculate = function calculate(initialDemand) {
	  return ((initialDemand.auto + initialDemand.mobile) / 1000000).toFixed(2);
	};
	
	// Format the BE-supplied revenue estimate as "$NM". Was previously
	// derived on the FE from customerPreferences × customerDemands; now
	// arrives pre-computed as a raw dollar number from the business-case
	// scoped endpoint.
	var formatRevenue = function formatRevenue(bcaseRevenueEstimate) {
	  return "$" + ((Number(bcaseRevenueEstimate) || 0) / 1000000).toFixed(0) + "M";
	};
	
	var ExecutiveSummary = function ExecutiveSummary(_ref) {
	  var initialDemand = _ref.initialDemand,
	      bcaseRevenueEstimate = _ref.bcaseRevenueEstimate;
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "EXECUTIVE SUMMARY" },
	    "Fresh out of college, you and your close-knit group of friends made a bold choice during your senior year: to venture into the start-up world before considering a corporate job. With enthusiasm and determination, your team uncovered a promising prospect within the image sensor market. Image sensors, electronic devices responsible for transforming optical images into electronic signals, hold immense importance across diverse sectors, including the realms of smartphones and automobiles.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      ProductColor,
	      null,
	      "You\u2019re Entering the Image Sensor Market"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Image sensors have been on the market for quite some time. However, the image sensor technology as well as the product requirements (product features) demanded by customers are constantly evolving. Because of the expanding demand for mobile phones as well as the increasing interest in semi-autonomous vehicles, existing suppliers have not been able to meet the demand for image sensors. It is estimated that there will be an unmet demand for approximately ",
	    calculate(initialDemand),
	    "M image sensors in the coming year and it is expected to grow further in the following years. Image sensor industry experts have estimated that this unmet demand translates to over ",
	    formatRevenue(bcaseRevenueEstimate),
	    " in revenue.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "In this simulation, you are going to assume that your team is entering the image sensor market to compete for the unmet demand in mobile and/or automobile customer segments. As such, you will need to make decisions related to capital, product development, product manufacturing, marketing, and sales, assuming that you will be in this business for multiple years. The game will be played in multiple rounds; each round corresponds to a year. You will be provided with product requirements as well as the expected volume requirements of different customers in each customer segment for each round.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      MarketingColor,
	      null,
	      "Your Goal is to Capture Market Share and Hit Financial Targets"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "In each round, your team will compete with other teams to meet specific numerical goals. These goals vary from round to round, to reflect the success that a start-up business is expected to make over time. In each round, your team\u2019s overall goal is to meet or exceed the numerical goals set for that round. The teams that achieve all goals will be designated as Market Leaders and will receive a score of 100. Other teams will earn designations and scores reflecting their levels of achievement. It is important to understand that the salability of your product depends on how your products compare with the competitors\u2019 products (in terms of quality, price, promotion, and place) and you will not know the answer to this until the round ends, so it is full of ambiguity, just like the real business world.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      FinanceColor,
	      null,
	      "You are Working As a Team And Will be Assigned A Role"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "This is a team-based simulation. Therefore, all team members must work in collaboration with the aim of achieving overall success. At the beginning of each round, each team member will be assigned the role of a divisional head or the CEO. Each divisional head is responsible to post decisions pertaining to their division. While the submission is done individually by divisional heads, decisions should be discussed and evaluated collaboratively, as each division\u2019s decision will impact other decisions. It is also important to note that the CEO can post decisions related to all divisions, the CEO should not dominate the decisions; instead, the CEO is expected to strategize, forecast, coordinate, and collaborate.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      OperationsColor,
	      null,
	      "You\u2019ll Need to Leverage Research Data to Better Your Odds of Success"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "The Business Case and the Customer Analysis are the key resources to help you make informed decisions in Round 1. Therefore before making decisions, it\u2019s in your best interest to conduct research and review The Business Case and the Customer Analysis. It\u2019s also highly recommended that you refer back to research data as you make decisions. The Business Case gives you a general overview of the simulation (industry, market, product, operations, marketing, and capital sources), and The Customer Analysis provides greater insights into the customers and their preferences. The Business Case and Customer Analysis can be found on the game site located on the left nav panel under \"Research\".",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      DarkGreenColor,
	      null,
	      "Make & Post ALL Decisions Before Deadline"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "It\u2019s highly recommended that your team make decisions in the following order: ",
	    _react2.default.createElement(
	      ProductColor,
	      null,
	      "Product"
	    ),
	    " \u2192\xA0",
	    _react2.default.createElement(
	      MarketingColor,
	      null,
	      "Marketing"
	    ),
	    " \u2192\xA0",
	    _react2.default.createElement(
	      OperationsColor,
	      null,
	      "Operations"
	    ),
	    " \u2192\xA0",
	    _react2.default.createElement(
	      CeoColor,
	      null,
	      "CEO Projections"
	    ),
	    " \u2192\xA0",
	    _react2.default.createElement(
	      FinanceColor,
	      null,
	      "Finance Decisions"
	    ),
	    ". It\u2019s also required that your team POST ALL DECISIONS BEFORE THE ROUND DEADLINE. If decisions are not posted by the deadline, your team will likely perform poorly for that round.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      DarkMagenta,
	      null,
	      "Review & Analyze Results"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "After each round ends, you should review The Performance Feedback and Team Reports to gain a better understanding of your performance. The Performance Feedback report will provide personalized feedback. The Team Report will provide competitive analysis information. It compares your team\u2019s performance in relation to your competitors and provides insights to help your team figure out what changes must be needed in order to do better in the next round.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      ProductColor,
	      null,
	      "Tips to Getting Started"
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      UnorderedList,
	      null,
	      _react2.default.createElement(
	        ListItem,
	        null,
	        "Conduct Market Research to understand the market and customers"
	      ),
	      _react2.default.createElement(
	        ListItem,
	        null,
	        "Review and understand the financial targets you\u2019ll need to hit each round"
	      ),
	      _react2.default.createElement(
	        ListItem,
	        null,
	        "Make Decisions in the following order: Product \u2192 Marketing \u2192 Operations \u2192 CEO Projections \u2192 Finance"
	      ),
	      _react2.default.createElement(
	        ListItem,
	        null,
	        "Post all decisions (CEO decision page)"
	      )
	    ),
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      SubTitle,
	      null,
	      "Welcome to Market Games! May the odds be ever in your favor!"
	    )
	  );
	};
	
	exports.default = ExecutiveSummary;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  color: #ff5252;\n  font-weight: bold;\n"], ["\n  color: #ff5252;\n  font-weight: bold;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _styles = __webpack_require__(95);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Name = _styledComponents2.default.span(_templateObject);
	
	var calculate1 = function calculate1(primeRates) {
	  var USRates = primeRates.find(function (i) {
	    return i.region === "US";
	  });
	
	  return USRates ? (USRates.rate * 100).toFixed(2) : 0;
	};
	var calculate2 = function calculate2(debtClients) {
	  var obj = debtClients.find(function (debtClient) {
	    return debtClient.name === 'Prudent Bank';
	  });
	
	  return obj ? obj.lt_debt_to_capital * 100 : '0';
	};
	var calculate3 = function calculate3(debtClients) {
	  var obj = debtClients.find(function (debtClient) {
	    return debtClient.name === 'Mezz Capital';
	  });
	
	  return obj ? obj.lt_debt_to_capital * 100 : '0';
	};
	var calculate4 = function calculate4(constants) {
	  return constants.initial_valuation / 1000000;
	};
	var calculate5 = function calculate5(constants) {
	  return constants.wacc * 100;
	};
	
	var Investors = function Investors(_ref) {
	  var primeRates = _ref.primeRates,
	      constants = _ref.constants,
	      activeRound = _ref.activeRound,
	      debtClients = _ref.debtClients;
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "THE INVESTORS" },
	    "Teresa and Anna were in charge of raising capital. As recent college graduates, they do not have any money to invest in their business. The five team members agreed that they would try their best to fund the business through debt capital because they want to retain control over their business. Also, they know that the value of the business at the beginning is at a rock bottom. Based on all the research they did, they expect this business to be successful and the value of the business to increase exponentially. They, therefore, want to make sure that they make every effort to raise funds through debt.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "The team registered their business, GENZ, in the state of CA. Based on the articles of incorporation, GENZ has 10M shares authorized at a par value of $0.00001. GENZ will issue one million shares at $0.00001 initially to meet the statutory minimum capital requirement. This will leave the company with 1M shares outstanding, 9M shares available to issue.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Teresa researched thousands of investors and lined up meetings with three investors that provide loans: Prudent Bank, Mezz Capital, and Great White Financials.",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Prudent Bank"
	    ),
	    "Her first meeting was with James Tyghtmon of Prudent commercial bank. Like most commercial banks, Prudent earns income from customer deposits & savings. They do so by investing the deposits in income earning assets that generate minimum returns to cover the cost of managing customer deposits and savings. Given that customers have the right to withdraw their deposits at any time, commercial banks have to be careful how they use those deposits for investments.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "At first, Teresa and Anna were not sure if they should approach the small business banking division or the corporate banking division. They noticed that the corporate banking division has technology experts, so they decided to start with the corporate banking division. They set up a meeting with James Tyghtmon, director of technology lending and debt capital markets in Prudent Bank\u2019s corporate banking division. After the initial introductions they dived right into business.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"We\u2019ve identified an opportunity to capture a significant market share in a fast growing technology sector , and we are seeking capital to pursue opportunity.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "James"
	    ),
	    ": \"That\u2019s great! But do you understand the role commercial banks play in society?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"You save and lend money to individuals and organizations, like all commercial banks.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "James"
	    ),
	    ": \"We do more than that. We match savers and borrowers so that capital in our society, our community, is productive. We are the guardians of the economy\u2019s financial system. Therefore, we don\u2019t take many risks. We invest in assets that are low risk. You\u2019re a startup. That\u2019s inherently risky. How much equity did you raise?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"We weren\u2019t interested in raising equity at this point. We didn\u2019t want to give up any ownership.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "James"
	    ),
	    ": \"Teresa, there\u2019s no way Prudent Bank would be able to provide a loan if you and your team have not raised any equity. Our debt policy states that we cannot lend money to anyone if they exceed our debt to capital limit requirement (See ",
	    _react2.default.createElement(_styles.Exhibit, { number: 5, round: activeRound }),
	    "). In other words, we won\u2019t lend to any company that has a debt to capital ratio higher than ",
	    calculate2(debtClients),
	    "%. To determine our lending rates We use the prime rate as our base rate ",
	    calculate1(primeRates),
	    "% and then we add a credit spread plus additional spread based on our terms & conditions (See ",
	    _react2.default.createElement(_styles.Exhibit, { number: 5, round: activeRound }),
	    "). Please reach out to Jermaine at Mezz Capital. He might be able to provide funding without equity.\"",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Mezz Capital"
	    ),
	    "Teresa contacted Jermaine who was a workhorse. Jermaine started his career in Investment Banking within the TMT sector and moved up the ranks from Analyst to Director very quickly. He wanted more of a challenge, saw an opportunity in the subordinated debt space, and decided to start his own fund - Mezz Capital, a mezzanine fund that provides both debt and equity capital to companies. Mezzanine funds seek to invest in promising, but risky companies that could repay within a few years. They are usually subordinate to commercial lending debt and therefore these lenders expect to be compensated for the additional risks (i.e. charge a higher interest rate).",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"I hope you were able to review our business plan. What do you think about this opportunity?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jermaine"
	    ),
	    ": \"I\u2019ve reviewed your business plan and it. looks good, I\u2019m interested in investing. I can\u2019t invest in equity at this point, but I can offer debt. Mezz Capital offers better debt-to-capital requirement terms than Prudent Bank or any other commercial bank.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"You mean your upper limit for the debt-to-capital ratio is higher than that of commercial banks?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jermaine"
	    ),
	    ": \"That\u2019s exactly correct. To be exact, our debt to capital ratio limit is ",
	    calculate3(debtClients),
	    "% whereas Prudent Bank\u2019s is ",
	    calculate2(debtClients),
	    "%.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "The fact that your company does not have equity capital is the obstacle that is preventing us from forming a partnership. You will still need to raise equity before we can lend. You should talk to David, an angel investor. Actually, please reach out to Greg Shark of Great White Financials as well. They like to take bigger risks.",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Great White Financials"
	    ),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"Hi Mr. Shark, we need funding for a unique opportunity we would like to capture. Would you be able to help?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Mr. Shark"
	    ),
	    ": \"But of course! We are here for you and we provide generous funding amounts. More so than any other investors. We only ask that you pay us a small annual fee of ~15% of any funding we provide to you that remains outstanding.\"",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Angel Investors"
	    ),
	    "Teresa then met with David Wong, an angel investor who runs a small syndicate out of a converted garage in Menlo Park. Angel investors write the earliest institutional-ish checks, funding companies at the pre-seed and seed stages when there's little more than a team, a plan, and a hope. They invest their own money, so their decisions are personal, and they often bet on people as much as on ideas. Each angel also has a personal cap on how much they can commit to any one company.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"Hey Teresa, I heard great things about you and your team. How can I help?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"Hi David, we have a unique opportunity that would generate immense returns for you and your firm.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"Tell me more!\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"It\u2019s the image sensor market. We are developing an image sensor technology that is at least 10x better than any other image sensor on the market. It\u2019s a great fit for the automobile and mobile phone sectors. However, it will take some time to get the product to market.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"I\u2019m still listening.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"There\u2019s an opportunity to offer existing technologies, which would allow us to enter the market now.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"But we invest in disruptive innovation, why would I want to invest in existing technologies? What are you offering?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"For you, low risks and high returns. For the market, servicing unmet demand. We are in a great position to capture value.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"There must be other competitors?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"All the major competitors are resource constrained. However, there are a few other startups that are likely to compete directly with us. It will be very competitive amongst these other startups, but we have a superior team with a track record of success. Here\u2019s our business plan including our 1 year financial projections.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"Thanks Teresa! I will review with my team and we\u2019ll be in touch.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Given that angels invest at the earliest stages with little track record, they place significant value in the strength of the team. David is no different. In fact, David prides himself on his ability to look into the soul of the founding team and see if they have what it takes. It\u2019s a skill that he believes he learned from being a serial entrepreneur. He\u2019s taken companies from seed stage to series stages to exits. He even allows founders that he invested in to buyback shares from him only after a year. This is very uncommon in angel investing, but reflects his maverick style approach to business.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "A few weeks later, Teresa gets a call from David.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "David"
	    ),
	    ": \"The business plan looks solid! And nice work on the financial projections! We want to invest in you and your team. We ran some analyses and determined that an appropriate value for your business is $",
	    calculate4(constants),
	    "M based on several factors including your strengths (strong team and partnership agreements) and weaknesses (you are a startup). We will evaluate your business periodically and adjust your company\u2019s value to current market rates. Here\u2019s our valuation approach for each year (",
	    _react2.default.createElement(_styles.Exhibit, { number: 6, round: activeRound }),
	    "). Overall, we expect an annual return of at least",
	    " ",
	    calculate5(constants),
	    "% from this opportunity, assuming you are holding no debt. I\u2019m sending over the term sheet for you to review and sign. We look forward to partnering with you on this exciting journey!\"",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Venture Capital"
	    ),
	    "If angels are the first spark, venture capital is the accelerant. VC firms pool money from institutional LPs (endowments, pensions, family offices) and deploy it into companies that already have a product and real market results behind them. In the real world, some VCs do write checks on day one at the seed stage, but the larger growth-stage funds almost always want to see a full year of actual performance before they commit. They're paying to reduce risk, and one year of execution is the cheapest risk they can buy. That's why in this exercise Redwood won't fund you in Year 1: they want to see how the team executes against its plan before betting bigger. Once you have that Year 1 track record, VC checks are larger than an angel's, but so is the ownership they take. VCs also have a fund-mandated ceiling on how much of the fund they can put into any single company, so no matter how much they love a deal, there's a hard cap.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Teresa's next meeting was with Priya Kapoor, a partner at Redwood Ventures. Priya is famous in the Valley for writing initial term sheets on the back of restaurant napkins and mailing the original napkin to founders as a keepsake when a deal closes. Three napkins hang in frames behind her desk, the ones that turned into unicorns.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Priya"
	    ),
	    ": \"Teresa, I've read the deck. I want to hear the one sentence that makes me regret not investing.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"One product, two segments, no direct competitor.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Priya"
	    ),
	    ": \"Good pitch. Now go ship a full year. Bring me Year 1's actuals against your projections. If the model holds up, Redwood will lead your Year 2 round.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "A year later, Teresa returns with Year 1 results in hand. The numbers back up the pitch, and Priya delivers a term sheet (on Cafe Vino letterhead this time; the napkins are ceremonial). Redwood Ventures is in, though at a valuation that requires Teresa to share more ownership than she did with the angel round.",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Private Equity Investor"
	    ),
	    "Private equity sits at the opposite end of the timeline from angels. PE firms invest in more mature companies with proven cash flows and a real operating history. In practice, that usually means at least five years of audited financials. Their playbook is different too: instead of betting on a story, they look for operational levers to pull, such as cost restructuring, margin improvement, or acquisitions of adjacent businesses. PE checks are typically the largest of the three equity categories, but each firm still has a capital ceiling per company.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Because PE needs a track record, GENZ won\u2019t be a fit until at least Year 3, when the team has two full years of audited financials to point to. That\u2019s shorter than the five years many PE firms prefer, but a few funds (especially special-situations shops) will look at companies with as little as two years of demonstrated performance when the operating metrics are strong and the market opportunity is unusually large.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Teresa nevertheless took an introductory meeting with Roland Fairchild, managing director at Sterling Capital Partners. Roland is the type of investor a founder meets over a two-hour dinner at a members-only club. He has never once said the word \"startup\" in his career, refers to companies exclusively by their EBITDA multiple, and loosens his tie by exactly one inch after 6 PM as his sole concession to informality. His parting words to Teresa: \"Come back when you\u2019ve printed two years of audited financials.\""
	  );
	};
	
	exports.default = Investors;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  color: #ff5252;\n  font-weight: bold;\n"], ["\n  color: #ff5252;\n  font-weight: bold;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  color: #2A4169;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: #001B3B;\n  }\n"], ["\n  color: #2A4169;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: #001B3B;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _styles = __webpack_require__(95);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _canvas = __webpack_require__(2561);
	
	var _canvas2 = _interopRequireDefault(_canvas);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Name = _styledComponents2.default.span(_templateObject);
	
	var InlineLink = _styledComponents2.default.a(_templateObject2);
	
	var goToCustomerAnalysis = function goToCustomerAnalysis(e) {
	  e.preventDefault();
	  (0, _Location.changeLocation)("/ceo/analysis/market");
	};
	
	var calculate1 = function calculate1(initialDemand) {
	  return ((initialDemand.auto + initialDemand.mobile) / 1000000).toFixed(2);
	};
	var calculate2 = function calculate2(salesClients) {
	  var salesRep = salesClients.find(function (i) {
	    return i.name === "SalesRep";
	  });
	
	  return salesRep ? salesRep.commission_rate * 100 : 0;
	};
	
	// bcasePriceFloor / bcasePriceCeiling arrive from the business-case
	// scoped endpoint as pre-computed min(min_price) / max(max_price)
	// across customer preferences. Replaces the previous FE-side
	// minBy / maxBy reductions on the full customerPreferences table,
	// which is no longer downloaded.
	
	var Market = function Market(_ref) {
	  var initialDemand = _ref.initialDemand,
	      salesClients = _ref.salesClients,
	      bcasePriceFloor = _ref.bcasePriceFloor,
	      bcasePriceCeiling = _ref.bcasePriceCeiling,
	      activeRound = _ref.activeRound;
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "THE MARKET" },
	    "Even though William was not optimistic about the image sensor opportunity, he felt obliged to make an informed decision on behalf of his team, rather than simply rejecting it. Therefore he reached out to his cousin Emily, who is a senior equity research analyst at XYZ Investments. Without even realizing that Emily\u2019s specialization is in the semiconductor industry, he asked her about the market potential of the image sensors.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Emily"
	    ),
	    ": \"I love this sector! An image sensor is such a tiny product, but the applications are enormous! Smartphone developers are the main buyers, but exponential growth is expected in the automobile, healthcare, and surveillance markets. Gross margins in the mobile segment are roughly ~35%, but the auto segment can be roughly 2x that. Why are you interested in image sensors?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "William"
	    ),
	    ": \"My buddies and I are looking to launch a start-up. One of them read an article and got hooked on image sensors. Honestly, I don't know anything about them and wasn't interested.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Emily"
	    ),
	    ": \"There are major global players in healthcare and surveillance spaces and it will be hard for you to compete there. However from my analysis, a substantial unmet demand still exists in mobile phone and automobile sectors; since there aren\u2019t large dominant players your chances would be better in those two segments. Based on my calculations, there will be about ~",
	    calculate1(initialDemand),
	    " million units of unmet demand next year from the mobile and auto markets. Here is some market information on the unmet demand and growth projections for the image sensor needs in the mobile and auto market segments (",
	    _react2.default.createElement(_styles.Exhibit, { number: 1, round: activeRound }),
	    ").\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "At the end of the conversation, William\u2019s thoughts changed from pessimistic to cautiously optimistic. He was impatient to share this new information with his team.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Anna continued researching the image sensor market. The more she read, the more optimistic she became. While Bob got discouraged after his call with Tom, Anna and William convinced him to join a team meeting to discuss the image sensor opportunity further. William was able to convince Jose, his freshman year roommate, a materials science major who is now working for a silicon chip manufacturer, to join  Team Z. Based on the initial chit-chat, it was clear to Anna that if the billion dollar facility cost that Tom mentioned is true, then there is no point in wasting time. Therefore, Anna asked Jose to share his thoughts on this.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"It will not be realistic for you to build a manufacturing facility from scratch. However, there are few companies that operated semiconductor fabs in multiple locations but ceased operations of some when they consolidated their operations. Those fabs already have the cleanrooms and other infrastructure that is needed.  All you will have to do may be to lease a fab and buy the machines for the production lines. So, you will be looking at about one million dollars lease and another few millions for the production line costs. In other words, you will be looking at a few millions, instead of a billion.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "With that, Anna noticed her team lightening up. She took a quick vote to see if the team wants to pursue the opportunity further. With everyone on board, Anna started talking about the next steps.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Let\u2019s start by drafting our business plan.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "William"
	    ),
	    ": \"You mean now? Doesn\u2019t it take days? Isn\u2019t it a comprehensive document?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Yes, a traditional business plan is, but we can use the BMC framework.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "William"
	    ),
	    ": \"What\u2019s BMC?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"It stands for Business Model Canvas. It is a lean business plan. BMC has a high-level focus and contains only the key factors.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Teresa did a quick search on her tablet.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"A typical BMC is a single page document. BMC framework is based on nine  factors. See here:\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(_styles2.default.ResponsiveImage, { src: _canvas2.default, alt: "canvas" }),
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Okay, let\u2019s take a look at these nine elements. Based on what Jose said, we might be able to secure a key partner on the fab facility side.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"Wait Anna, I think our starting point should be the customers. If we don\u2019t have customers we don\u2019t have anything.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"I agree, let\u2019s start with the customer segments, value propositions. After that we will look at the other elements.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Any suggestions on how we can get more information about customers?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Industry events are one place to start. CES is coming up soon and it draws customers, competitors, and everyone in between. About 170,000 people attend each year, including OEMs like Apple, Tesla, and Ford. You'll get a sense of the space in a few days there.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Worth a shot.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.Title,
	      null,
	      "CES Conference"
	    ),
	    "The team agreed that Anna should attend ",
	    _react2.default.createElement(
	      "a",
	      { href: "http://www.ces.tech/Conference", target: "_blank", rel: "noreferrer" },
	      "CES"
	    ),
	    " held in Las Vegas. Determined to learn and network as much as possible Anna attended as many presentations and visited as many booths as possible. On the third day of the conference, while grabbing drinks at the hotel bar at the conference, Anna overheard a conversation around image sensors.. She decided to join the conversation:",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"I\u2019m sorry, but I couldn\u2019t help but listen to you two complain about the image sensor market. What\u2019s to complain about? Seems like it\u2019s a great market to be in right now. Hi, my name is Anna.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"Hi I am Fred. I actually love the image sensor space. Our gripe is with corporate. There is so much more of the market we can capture, but corporate is not investing in capacity. This has impacted me personally because my compensation is heavily based on commissions. I earn ",
	    calculate2(salesClients),
	    "% on all sales contracts.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Can\u2019t you join a company that is willing to expand? Is the ",
	    calculate2(salesClients),
	    "% sales commission pretty standard for this industry?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"I\u2019ve looked into that, but all the other players either have capacity constraints or are focused on other customer segments. But, to answer your other question, yes ",
	    calculate2(salesClients),
	    "% commission is almost like an industry standard for direct selling.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Who are these customers that no one is serving right now?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"Boy!!! You are asking a lot of questions. Well, I am planning to retire soon and I attended this year\u2019s conference for fun and to say my goodbyes. I have no ambitions to pursue. So, you caught me at the perfect time to ask all these questions; So what was your last question?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"I appreciate your willingness to answer my questions. Currently which customers have unmet demand?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"These are mobile phone manufacturers and automobile manufacturers. In the image sensor world, we call them mobile customers and auto customers. Based on the information I have, there will be an unmet demand for ",
	    calculate1(initialDemand),
	    "M sensors next year, just in these two market segments and all sales occur at year end of year (i.e. customers buy in December).\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"How much are these customers willing to pay?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"The price they are willing to pay ranges from $",
	    bcasePriceFloor,
	    " to $",
	    bcasePriceCeiling,
	    ". Mobile customers sit at the lower end and auto customers at the higher end. The lower and upper prices that these two customer segments are willing to pay are very different. For example, no mobile customer will pay over $15.00 for an image sensor because that would be too expensive for them. At the same time, any sensor priced at or below $1.00 is probably too good to be true (i.e. really bad chips) and therefore, they won\u2019t buy. Auto customers on the other hand, will not pay more than $40 for an image sensor, and they believe that any sensor sold for less than $5, is too good to be true. The Customer Analysis Page has details on the minimum product features customers will accept and the prices that each customer is willing to pay.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Oh wow!! This is a pretty detailed customer analysis; I like how you have identified the minimum product requirements of each customer.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"None of these customers are loyal. They will always buy the highest quality product at the lowest price. Actually let me rephrase, mobile customers are more price sensitive and auto customers are more sensitive about the image sensor\u2019s quality.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"How do you reach these customers?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"It's not one channel. Different mixes work for different segments and products. Jon runs marketing for us and can share how we think about it.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jon"
	    ),
	    ": \"Thanks for volunteering me, Fred. I'm not planning to retire, so I'll keep the specifics high level, but I don't mind sharing the general approach.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Well, thank you. I really appreciate it.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jon"
	    ),
	    ": \"For larger customers, we invest across a handful of the highest-impact awareness channels. Plan on a total marketing budget of $3M to $4M per product each year to hit peak impact. Products in the autonomous vehicle segment usually need a bit more given how new it is. Spending past $4M per product doesn't add value, and it takes a few years of consistent investment to reach peak awareness. Figuring out which channels work best for your segments is part of the job.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"What about smaller customers? I keep hearing about content marketing, email campaigns, paid digital ads...\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jon"
	    ),
	    ": \"Great question. Online channels have reshaped how we reach customers. They're cheaper per touch, easier to measure, and they run around the clock, unlike a trade show that lives and dies over a few days. For our larger customers, we use content marketing and email campaigns to warm leads before an event and stay top of mind after. They don't replace trade shows, they amplify them. For smaller customers, online IS the game. Content marketing, email campaigns, and paid ads are how you reach buyers who never set foot at CES.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"What about influencer marketing? Are we talking Instagram creators?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jon"
	    ),
	    ": \"Not in our world. For image sensors, 'influencers' are the technical experts customers already trust, industry vision podcasters engineers listen to on their commute, and academic innovators publishing new benchmarks. When one of them recommends your product, buyers pay attention because the endorsement is credible in a way an ad never is.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"And sponsorships? Where does that fit in?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jon"
	    ),
	    ": \"Think of sponsorships as the sister channel to trade shows. Sponsoring a track at CES or a keynote at a technical conference puts your brand on the same stage as the events your customers already attend. Trade shows get you the booth; sponsorships get you the spotlight.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Fred"
	    ),
	    ": \"One last thing. Smaller customers are a different game to sell to. Most of them don't turn up at big industry events, so we work with distributors to close deals. These tend to be the customers listed in our",
	    " ",
	    _react2.default.createElement(
	      InlineLink,
	      { href: "/ceo/analysis/market", onClick: goToCustomerAnalysis },
	      "Customer Analysis Report"
	    ),
	    " with volume of 10% or less within a segment.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jon"
	    ),
	    ": \"And the budget scales down. For smaller customers, plan on roughly 25% less on what you'd spend on the top channels per product.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Anna collected their business cards and quickly sent a message to the team summarizing the wealth of information she gathered. about potential partnerships and customers.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Based on the conversations she had with Fred and Jon, the importance of understanding the customers\u2019 product requirements is a key determinant of the success or failure of an image sensor manufacturer. While she understood the product features, she was not sure if Bob and William did. She therefore summarized the product features as below."
	  );
	};
	
	exports.default = Market;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// styles
	
	var columnsStyle = {
	  display: "flex",
	  flexDirection: "column"
	};
	
	var menuItemStyle = function menuItemStyle(level) {
	  return {
	    paddingLeft: 15 * level + "px"
	  };
	};
	
	var menuItemArrowStyle = {
	  fontSize: "11px",
	  fontWeight: "normal"
	};
	
	var separatorStyle = {
	  height: "1px",
	  backgroundColor: "#8f8f8f",
	  width: "100%"
	};
	
	// menu items
	
	var menu = [{
	  label: "Business Case",
	  to: "/analysis/bcase",
	  level: 1,
	  has_arrow: false,
	  children: [{
	    label: "Executive Summary",
	    to: "/analysis/bcase/executive-summary",
	    level: 2,
	    has_arrow: false
	  }, {
	    label: "The Opportunity, Economy, Industry",
	    to: "/analysis/bcase/opportunity-economy-industry",
	    level: 2,
	    has_arrow: false
	  }, {
	    label: "The Market",
	    to: "/analysis/bcase/market",
	    level: 2,
	    has_arrow: false,
	    children: [{
	      label: "Exhibit 1",
	      to: "/analysis/bcase/modal-exhibit1",
	      level: 3,
	      has_arrow: false
	    }]
	  }, {
	    label: "The Product",
	    to: "/analysis/bcase/product",
	    level: 2,
	    has_arrow: false,
	    children: [{
	      label: "Exhibit 2",
	      to: "/analysis/bcase/modal-exhibit2",
	      level: 3,
	      has_arrow: false
	    }]
	  }, {
	    label: "The Operations",
	    to: "/analysis/bcase/operations",
	    level: 2,
	    has_arrow: false,
	    children: [{
	      label: "Exhibit 3",
	      to: "/analysis/bcase/modal-exhibit3",
	      level: 3,
	      has_arrow: false
	    }, {
	      label: "Exhibit 4",
	      to: "/analysis/bcase/modal-exhibit4",
	      level: 3,
	      has_arrow: false
	    }]
	  }, {
	    label: "The Investors",
	    to: "/analysis/bcase/investors",
	    level: 2,
	    has_arrow: false,
	    children: [{
	      label: "Exhibit 5",
	      to: "/analysis/bcase/modal-exhibit5",
	      level: 3,
	      has_arrow: false
	    }, {
	      label: "Exhibit 6",
	      to: "/analysis/bcase/modal-exhibit6",
	      level: 3,
	      has_arrow: false
	    }]
	  }]
	}];
	
	// components
	
	var isChildrenShown = function isChildrenShown(item, location) {
	  if (item.to === location) {
	    return true;
	  }
	
	  if (item.children) {
	    return (0, _lodash.some)(item.children, function (element) {
	      return isChildrenShown(element, location);
	    });
	  }
	
	  return false;
	};
	
	var MenuItem = function MenuItem(_ref) {
	  var has_arrow = _ref.has_arrow,
	      global_location = _ref.global_location,
	      to = _ref.to,
	      label = _ref.label,
	      level = _ref.level,
	      search = _ref.search;
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      style: menuItemStyle(level),
	      className: to === global_location ? "active" : null,
	      to: to + ((0, _lodash.isNil)(search) ? "" : search)
	    },
	    has_arrow === true && _react2.default.createElement("span", {
	      className: global_location.indexOf(to) === 0 ? "fa fa-chevron-down" : "fa fa-chevron-right",
	      style: menuItemArrowStyle
	    }),
	    " ",
	    label
	  );
	};
	
	var renderItem = function renderItem(item, global_location, search, key) {
	  if (item.type === "separator") {
	    return _react2.default.createElement("hr", { key: key, style: separatorStyle });
	  }
	
	  return _react2.default.createElement(MenuItem, Object.assign({}, item, {
	    search: search,
	    global_location: global_location,
	    key: key
	  }));
	};
	
	var renderItemTree = function renderItemTree(location, search) {
	  return function (item, i) {
	    if (isChildrenShown(item, location)) {
	      return [_react2.default.createElement(MenuItem, Object.assign({}, item, { search: search, global_location: location, key: i })), (0, _lodash.map)(item.children || [], renderItemTree(location, search))];
	    }
	
	    return renderItem(Object.assign({}, item, { search: search }), location, search, i);
	  };
	};
	
	function Menu(_ref2) {
	  var location = _ref2.location,
	      search = _ref2.search;
	
	  return _react2.default.createElement(
	    "div",
	    { style: columnsStyle },
	    (0, _lodash.map)(menu, renderItemTree(location, search))
	  );
	}
	
	exports.default = Menu;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(95);
	
	var _ExhibitLayout = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberWithCommas = function numberWithCommas(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	var ModalExhibit1 = function ModalExhibit1(_ref) {
	  var initialDemand = _ref.initialDemand,
	      demandGrowthRate = _ref.demandGrowthRate,
	      goBack = _ref.goBack;
	  return _react2.default.createElement(
	    _styles.CustomModal,
	    { goBack: goBack },
	    _react2.default.createElement(
	      _ExhibitLayout.Container,
	      null,
	      _react2.default.createElement(
	        _ExhibitLayout.Header,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.Title,
	          null,
	          "Exhibit 1: Unmet Demand & Growth Projections"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Subtitle,
	          null,
	          "Year 1 baseline demand and projected annual growth for each segment."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Year 1 Annual Unmet Demand"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Segment"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Unmet Demand"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Mobile"
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                { className: "numeric" },
	                numberWithCommas(initialDemand.mobile),
	                " units"
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Auto"
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                { className: "numeric" },
	                numberWithCommas(initialDemand.auto),
	                " units"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Expected Annual Growth"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Year"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Mobile Segment"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Auto Segment"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            demandGrowthRate.filter(function (row) {
	              return row.round_number + 1 <= 3;
	            }).map(function (row) {
	              return _react2.default.createElement(
	                "tr",
	                { key: row.id },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Year ",
	                    row.round_number + 1
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  row.mobile * 100,
	                  "%"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  row.auto * 100,
	                  "%"
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ModalExhibit1;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(95);
	
	var _lodash = __webpack_require__(21);
	
	var _ExhibitLayout = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberWithCommas = function numberWithCommas(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	// The business-case scoped endpoint pre-filters `features` to the
	// requested round and drops `round_number` from each row, so there's
	// no per-row filter to apply on the FE anymore.
	var getData = function getData(features) {
	  return (0, _lodash.mapValues)((0, _lodash.groupBy)(features, "rank"), function (i) {
	    return (0, _lodash.mapValues)((0, _lodash.keyBy)(i, "type"), function (i) {
	      return numberWithCommas(i.rnd_costs.toFixed(0));
	    });
	  });
	};
	
	var ModalExhibit2 = function ModalExhibit2(_ref) {
	  var features = _ref.features,
	      goBack = _ref.goBack;
	
	  var data = getData(features);
	  return _react2.default.createElement(
	    _styles.CustomModal,
	    { goBack: goBack },
	    _react2.default.createElement(
	      _ExhibitLayout.Container,
	      null,
	      _react2.default.createElement(
	        _ExhibitLayout.Header,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.Title,
	          null,
	          "Exhibit 2: Estimated R&D Costs"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Subtitle,
	          null,
	          "R&D cost per feature type, broken out by rank."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Cost by Feature"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Quality Rank"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Resolution"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Sensitivity"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Power"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Temperature"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            Object.keys(data).map(function (rank) {
	              var feature = data[rank];
	              return _react2.default.createElement(
	                "tr",
	                { key: rank },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    rank
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Pixels"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Sensitivity"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Power"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Temperature Range"]
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ModalExhibit2;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(95);
	
	var _lodash = __webpack_require__(21);
	
	var _ExhibitLayout = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The business-case scoped endpoint pre-filters `features` to the
	// requested round and drops `round_number` from each row, so there's
	// no per-row filter to apply on the FE anymore.
	var getData = function getData(features) {
	  return (0, _lodash.mapValues)((0, _lodash.groupBy)(features, "rank"), function (i) {
	    return (0, _lodash.mapValues)((0, _lodash.keyBy)(i, "type"), function (i) {
	      return i.material_cpu.toFixed(2);
	    });
	  });
	};
	
	var ModalExhibit3 = function ModalExhibit3(_ref) {
	  var features = _ref.features,
	      goBack = _ref.goBack;
	
	  var data = getData(features);
	  return _react2.default.createElement(
	    _styles.CustomModal,
	    { goBack: goBack },
	    _react2.default.createElement(
	      _ExhibitLayout.Container,
	      null,
	      _react2.default.createElement(
	        _ExhibitLayout.Header,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.Title,
	          null,
	          "Exhibit 3: Estimated Direct Material Costs"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Subtitle,
	          null,
	          "Direct material cost per unit for each feature type, by rank."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Cost per Unit"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Quality Rank"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Resolution"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Sensitivity"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Power"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Temperature"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            Object.keys(data).map(function (rank) {
	              var feature = data[rank];
	              return _react2.default.createElement(
	                "tr",
	                { key: rank },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    rank
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Pixels"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Sensitivity"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Power"]
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  feature["Temperature Range"]
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ModalExhibit3;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(95);
	
	var _ExhibitLayout = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberWithCommas = function numberWithCommas(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	var ModalExhibit4 = function ModalExhibit4(_ref) {
	  var machines = _ref.machines,
	      goBack = _ref.goBack;
	  return _react2.default.createElement(
	    _styles.CustomModal,
	    { goBack: goBack },
	    _react2.default.createElement(
	      _ExhibitLayout.Container,
	      null,
	      _react2.default.createElement(
	        _ExhibitLayout.Header,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.Title,
	          null,
	          "Exhibit 4: Production Lines"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Subtitle,
	          null,
	          "Cost, capacity, and setup profile for each available production line."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Production Line Specs"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Line"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Cost"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Units / Hour"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Useful Life"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Annual Capacity"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Setup Time"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Ideal Utilization"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            machines.map(function (machine) {
	              return _react2.default.createElement(
	                "tr",
	                { key: machine.id },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    machine.id
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "$",
	                  numberWithCommas(machine.costs)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  machine.units_per_hour
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  machine.lifetime_years,
	                  " years"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  numberWithCommas(machine.annual_hours),
	                  " hours"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  machine.setup_time,
	                  " months"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "75%"
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ModalExhibit4;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  margin-left: 6px;\n  vertical-align: middle;\n\n  &:hover > div,\n  &:focus-within > div {\n    visibility: visible;\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  margin-left: 6px;\n  vertical-align: middle;\n\n  &:hover > div,\n  &:focus-within > div {\n    visibility: visible;\n    opacity: 1;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.55);\n  color: rgba(0, 27, 59, 0.72);\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.55);\n  color: rgba(0, 27, 59, 0.72);\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 280px;\n  max-width: 340px;\n  padding: 12px 14px;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.85);\n  text-transform: none;\n  letter-spacing: normal;\n  text-align: left;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n  z-index: 100;\n  pointer-events: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #ffffff;\n    border-right: 1px solid #D5D9DD;\n    border-bottom: 1px solid #D5D9DD;\n  }\n"], ["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 280px;\n  max-width: 340px;\n  padding: 12px 14px;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.85);\n  text-transform: none;\n  letter-spacing: normal;\n  text-align: left;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n  z-index: 100;\n  pointer-events: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #ffffff;\n    border-right: 1px solid #D5D9DD;\n    border-bottom: 1px solid #D5D9DD;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(95);
	
	var _ExhibitLayout = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Hover tooltip on the "Debt to Capital Limit" column header. The
	// wrap owns the hover state, the icon is the visual affordance, and
	// the tooltip body renders above the header with a downward arrow.
	var InfoTooltipWrap = _styledComponents2.default.span(_templateObject);
	
	var InfoIcon = _styledComponents2.default.span(_templateObject2);
	
	var InfoTooltip = _styledComponents2.default.div(_templateObject3);
	
	var getInvestorType = function getInvestorType(name) {
	  if (name === "Prudent Bank") return "Commercial Bank";
	  if (name === "Mezz Capital") return "Mezzanine Lender";
	  if (name === "Great White Financials") return "Sharky Sparky";
	  return "";
	};
	
	var getCategory = function getCategory(rating) {
	  return rating.name === "AAA" || rating.name === "BBB" ? "Investment Grade" : "High Yield";
	};
	
	var getDebtToCapital = function getDebtToCapital(rating, ratings) {
	  var from = (rating.debt_to_capital * 100).toFixed(2);
	  var index = ratings.findIndex(function (i) {
	    return i.name === rating.name;
	  });
	  if (index + 1 >= ratings.length) return from + "% or more";
	  var to = ((ratings[index + 1].debt_to_capital - 0.0001) * 100).toFixed(2);
	  return from + "% to " + to + "%";
	};
	
	var ModalExhibit5 = function ModalExhibit5(_ref) {
	  var debtClients = _ref.debtClients,
	      ratings = _ref.ratings,
	      goBack = _ref.goBack;
	  return _react2.default.createElement(
	    _styles.CustomModal,
	    { goBack: goBack },
	    _react2.default.createElement(
	      _ExhibitLayout.Container,
	      null,
	      _react2.default.createElement(
	        _ExhibitLayout.Header,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.Title,
	          null,
	          "Exhibit 5: Lending Rates & Credit Ratings"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Subtitle,
	          null,
	          "How each lender sets its interest rate, and how credit ratings shape the credit spread."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.ExplainerCard,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.ExplainerTitle,
	          null,
	          "How lending rates work"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.ExplainerBody,
	          null,
	          "A lender's interest rate is the sum of three parts:",
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            "Prime Rate + Credit Spread + Profit Spread"
	          ),
	          ".",
	          _react2.default.createElement(
	            _ExhibitLayout.ExplainerList,
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Prime Rate"
	              ),
	              ": the benchmark rate banks charge their safest business borrowers, set at 3 percentage points above the Federal Reserve's fund rate. So if the Fed's rate is 4%, prime is 7%."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Credit Spread"
	              ),
	              ": set by rating agencies based on your credit rating (see the second table). Riskier borrowers get wider spreads."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Profit Spread"
	              ),
	              ": each lender's own markup based on how much risk they're willing to take. Shown in basis points (100 bps = 1%)."
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Lenders' Terms & Conditions"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Investor Type"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Investor Name"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Loan Term"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Debt to Capital Limit",
	                _react2.default.createElement(
	                  InfoTooltipWrap,
	                  { tabIndex: 0, "aria-label": "What is Debt to Capital Limit?" },
	                  _react2.default.createElement(
	                    InfoIcon,
	                    { "aria-hidden": "true" },
	                    "?"
	                  ),
	                  _react2.default.createElement(
	                    InfoTooltip,
	                    { role: "tooltip" },
	                    "Caps how much this lender will let you borrow, based on your leverage. Calculated as Total Debt divided by Total Stockholders' Equity. Once your ratio hits their limit, they will not lend you any more."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Profit Spread"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            debtClients && debtClients.map(function (client) {
	              return _react2.default.createElement(
	                "tr",
	                { key: client.id },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  getInvestorType(client.name)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    client.name
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  "8 years"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  client.lt_debt_to_capital
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  client.lt_company_spread * 10000,
	                  " bps"
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Footnote,
	          null,
	          "* Starting Year 2, Great White Financials can lend, at minimum, $15M, irrespective of your debt to capital ratio."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Corporate Credit Ratings & Spreads"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Rating"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Category"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Debt to Capital"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Credit Spread"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            ratings && ratings.map(function (rating) {
	              var category = getCategory(rating);
	              return _react2.default.createElement(
	                "tr",
	                { key: rating.name },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    rating.name
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    _ExhibitLayout.Pill,
	                    { variant: category === "Investment Grade" ? "investment" : "high-yield" },
	                    category
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  getDebtToCapital(rating, ratings)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  rating.credit_spread * 10000,
	                  " bps"
	                )
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ModalExhibit5;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _styles = __webpack_require__(95);
	
	var _ExhibitLayout = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avg = function avg(items, key) {
	  return ((0, _lodash.sumBy)(items, key) / items.length).toFixed(2);
	};
	
	var ModalExhibit6 = function ModalExhibit6(_ref) {
	  var comparableCompanies = _ref.comparableCompanies,
	      goBack = _ref.goBack;
	  return _react2.default.createElement(
	    _styles.CustomModal,
	    { goBack: goBack },
	    _react2.default.createElement(
	      _ExhibitLayout.Container,
	      null,
	      _react2.default.createElement(
	        _ExhibitLayout.Header,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.Title,
	          null,
	          "Exhibit 6: Valuation Methods & Comps"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Subtitle,
	          null,
	          "How the company is valued in each year of the simulation, and the comparable public companies used as benchmarks."
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Valuation Method by Year"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Year"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Valuation Method"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Rationale"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "1 and 2"
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Price to Sales (P/S)"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Early on, your business does not yet have steady profits, so it is valued off revenues. We multiply your revenues by the average P/S ratio of the comparable public companies below, which reflects what the market currently pays for each dollar of sales at similar businesses."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "3 and 4"
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Price to Earnings (P/E)"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "By now your business is generating consistent profits. We multiply your net earnings by the average P/E ratio of the comparable public companies below, which reflects what the market currently pays for each dollar of earnings at similar businesses."
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "5 to 8"
	                )
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "Discounted Cash Flows (DCF)"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                "With a longer track record, your future cash flows can be projected with reasonable confidence. We discount those projected free cash flows back to today's dollars using rates that reflect the risk and returns of the comparable public companies below."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _ExhibitLayout.Section,
	        null,
	        _react2.default.createElement(
	          _ExhibitLayout.SectionTitle,
	          null,
	          "Comparable Public Companies"
	        ),
	        _react2.default.createElement(
	          _ExhibitLayout.Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Comparable"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Price to Sales (P/S)"
	              ),
	              _react2.default.createElement(
	                "th",
	                null,
	                "Price to Earnings (P/E)"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            comparableCompanies.map(function (company) {
	              return _react2.default.createElement(
	                "tr",
	                { key: company.id },
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    company.name
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  company.price_to_sales.toFixed(2)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "numeric" },
	                  company.price_to_earnings.toFixed(2)
	                )
	              );
	            }),
	            _react2.default.createElement(
	              "tr",
	              { className: "highlight" },
	              _react2.default.createElement(
	                "td",
	                null,
	                "Average Comps"
	              ),
	              _react2.default.createElement(
	                "td",
	                { className: "numeric" },
	                avg(comparableCompanies, "price_to_sales")
	              ),
	              _react2.default.createElement(
	                "td",
	                { className: "numeric" },
	                avg(comparableCompanies, "price_to_earnings")
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ModalExhibit6;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  color: #ff5252;\n  font-weight: bold;\n"], ["\n  color: #ff5252;\n  font-weight: bold;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  width: 600px;\n  float: right;\n  margin-left: 50px;\n"], ["\n  width: 600px;\n  float: right;\n  margin-left: 50px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _styles = __webpack_require__(95);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _distributionCenters = __webpack_require__(2573);
	
	var _distributionCenters2 = _interopRequireDefault(_distributionCenters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Name = _styledComponents2.default.span(_templateObject);
	
	var Image = _styledComponents2.default.img(_templateObject2);
	
	var calculate = function calculate(constants) {
	  return constants.holding_rate * 100;
	};
	
	var Operations = function Operations(_ref) {
	  var constants = _ref.constants,
	      activeRound = _ref.activeRound;
	
	  var unsoldInventoryValue = 100;
	  var holdingCost = unsoldInventoryValue * constants.holding_rate;
	
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "THE OPERATIONS" },
	    "Jose with his materials science degree and experience in semiconductor manufacturing understood the science and technical details behind the manufacturing process. Through his industry connections, he was also able to narrow down a handful of idling fabs. After intense negotiations, the team was able to secure a fab for $1M.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "In order to start operating the fab, Team Z will have to purchase production lines. Jose worked closely with Bob, who\u2019s degree is in industrial engineering, to explore the production line options. They identified four options. Each product line has an estimated useful life of eight years. Just like every other semiconductor fab, this fab is expected to operate 24/7; therefore, the annual capacity of the fab (as well as each product line) will be 8,736 hours. In the semiconductor industry, it is customary to allow 25% of the full annual capacity for machine set-up, maintenance and other downtimes. Therefore, the practical utilization of each machine is 75% of the full capacity. If needed, machines can be operated close to 100% capacity, but that would increase machine wear and tear and therefore result in maintenance cost (around $200K max of additional cost). ",
	    _react2.default.createElement(_styles.Exhibit, { number: 4, round: activeRound }),
	    " ",
	    "summarizes the initial investment, output per hour and the set-up time (time required to get the machine to operating condition) for each production line.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Anna took a careful look at the production line information.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Oh man!!! These are expensive machines; Do these have a good resale value?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Well there is a second-hand market for sure. However, I can\u2019t say that the resale value is good. If you think about it, semiconductor technology changes fast; so better machines come to market almost every year.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"So, let\u2019s say we want to sell a machine after using it for one year. How much can we recover?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"If you sell a production line, you'll take a loss. The loss is 5-10% of the machine's book value, which is what you originally paid minus the value it's already lost to depreciation. The longer you've owned the machine, the bigger the loss. Selling after three years, for example, usually means a 10% loss.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"I have another question. Since there is a large unmet demand, should we plan to do production scheduling to produce as much as we can?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Anna, you have to be very careful here. I heard that typical inventory carrying costs for image sensors are about ",
	    calculate(constants),
	    "%.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"What does that mean?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "William"
	    ),
	    ": \"Oh I know the answer to that one. Say the value of unsold inventory at the year end is $",
	    unsoldInventoryValue,
	    ". It will cost you $",
	    holdingCost,
	    " to hold that inventory, due to storage, insurance, finance costs etc.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Wow!!! That means we have to be very careful in making our product line decisions and our production volume decisions.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Teresa"
	    ),
	    ": \"Yes and yes!!! but really, we have to be very careful with all of our decisions. So each one of us should have an understanding related to all our business decisions.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"If we have unsold inventory at the end of year 1, can we sell it next year, or do we need to drop the price?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"It depends on why it didn't sell. If it's pricing, we can adjust and try again. If it's quality, or a competitor had a better product, no price cut will help. We can upgrade quality, but that means extra R&D spend.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Jose and Bob, you two know manufacturing best. Could you compile some basic info on image sensor production for us?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Jose and Bob compiled the following information related to product costs. Product cost is based on three manufacturing resources: direct materials, direct labor, and manufacturing overhead. Product cost per unit is needed to calculate the gross profit and gross margin of each product.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.UnmarkedList,
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          _styles2.default.Bold,
	          null,
	          "Direct Materials"
	        ),
	        ": Materials used to produce the image sensors (e.g. silicon wafers). This cost is roughly 60-85% of total product cost. Direct material cost depends on the product design (type and quantity of materials required) and the supplier pricing. Direct materials cost variation based on the design is due to the differences in product features. Based on information from competitor analysis, materials cost per sensor based on different product feature ranks are provided in",
	        " ",
	        _react2.default.createElement(_styles.Exhibit, { number: 3, round: activeRound }),
	        "."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          _styles2.default.Bold,
	          null,
	          "Direct Labor Costs"
	        ),
	        ": These are production employee wages. These employees are paid at an hourly rate of $20 per hour. Direct labor hours are driven by production run hours (i.e. how long do the machines operate per period). It takes at least two employees to manage one production line and no employees can work more than two daily shifts (i.e. 16 hrs per day). 1 daily shift = 8hrs. Employees receive overtime pay at a rate of time and a half e for any hours they work over 40 hours per week. Using efficient machines (machines that produce more units per hour) reduces the need for labor hours; thereby reduces the labor cost."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          _styles2.default.Bold,
	          null,
	          "Manufacturing Overhead Costs"
	        ),
	        ": All manufacturing costs except for direct materials and direct labor costs are categorized as manufacturing overhead cost. A large portion of overhead cost is machine depreciation (i.e. depreciation of production lines). Manufacturing overhead cost is the second largest component of the product cost. We use the unit of production method to depreciate equipment. Manufacturing overhead costs are allocated to the individual products."
	      )
	    ),
	    "Anna, a business major, looked concerned. \"Do we have to calculate direct materials, labor, and overhead costs to get unit cost per product?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "William"
	    ),
	    ": \"Maybe we hire an accountant.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"No need. Jose set us up with a program that calculates unit cost once we input product features, volumes, and production line info.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Jose, I\u2019ve been thinking\u2026 How are we going to get our products to customers quickly once we start manufacturing?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Good question. We should consider using a distribution center.\"",
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"A distribution center? Like a warehouse?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Sort of, but more than that. A distribution center is where products are received, stored briefly, and then shipped out efficiently to customers. It helps reduce lead time.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(Image, { src: _distributionCenters2.default, alt: "Distribution center options" }),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Lead time? What\u2019s that?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"It\u2019s the time between when a customer places an order and when they receive the product. The shorter the lead time, the better. Customers don\u2019t like waiting.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Oh, so having a distribution center means we can ship products faster?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Exactly. If we place it strategically, we can improve delivery speed. We have three location options: Arizona, Arkansas, and Ohio. Each has advantages in terms of customer proximity.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"That makes sense. If we\u2019re closer to customers, we can move inventory faster and avoid stockpiling too much.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Jose"
	    ),
	    ": \"Right. Less inventory holding means lower costs and fewer risks. Choosing the right location could give us a big operational and customer advantage.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    ": \"Good point! To be cautious, let's start with a manufacturing facility first, see how it goes, and then consider adding a distribution center. If we do, we'll make sure to pick the best location.\"",
	    _react2.default.createElement(_styles.LineBreak, null)
	  );
	};
	
	exports.default = Operations;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  color: #ff5252;\n  font-weight: bold;\n"], ["\n  color: #ff5252;\n  font-weight: bold;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _styles = __webpack_require__(95);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Name = _styledComponents2.default.span(_templateObject);
	
	var OpportunityEconomyIndustry = function OpportunityEconomyIndustry(props) {
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "THE OPPORTUNITY" },
	    "Anna is a recent business graduate. She had two successful internships during her junior and senior years and had a return offer from the company that she interned during her senior year. However, she and three of her close friends were not ready to assume the role of \"employee\"; these five ambitious graduates wanted to pursue entrepreneurial aspirations first. The Z team, as they called themselves, included, Anna, Bob, William, Teresa ). They agreed to explore start-up opportunities for six months and at the end of six months if they can\u2019t identify and agree on an opportunity then they would pursue traditional career paths.One afternoon, as usual Anna was sitting at her favorite coffeeshop, combing through webpages, hoping to uncover a business opportunity. An article in the Daily Californian caught her eyes and attention.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Filled with excitement, Anna jumped out of her seat, and dashed towards Bancroft way. She was eager to meet the rest of the Z team to share the exciting news.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna yelled"
	    ),
	    ", \"Hey guys! I have some great news to tell you!\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob responded"
	    ),
	    ", \"What is it?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna"
	    ),
	    " pointed at a Daily Californian article and said, \"we have a great opportunity in the image sensor business!\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Bob and William looked at each other in confusion, and William responded, \"who cares about image sensors!?!\" and returned to taking selfies.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Anna responded"
	    ),
	    ", \"apparently, many do and there\u2019s an opportunity for us to capture value in this market. Shall we do some research and then make a decision?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "\"Informed decisions are always good\" Teresa responded with a wink.",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.Title,
	      null,
	      "THE ECONOMY"
	    ),
	    "During this time, the U.S economy was still in its expansionary phase for more than 8 years, which was unusual. Some analysts suspected that the economic cycle would shift towards recession. However, conflicting data such as the low inflation rate suggested otherwise. To compound that, there was a new president with a new fiscal policy and with plans to nominate a new Federal Reserve Chairman. Therefore, the level of uncertainty with the Fed\u2019s monetary policy was high. It was unclear if the Fed would remain dovish.",
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.Title,
	      null,
	      "THE INDUSTRY"
	    ),
	    "The industry is driven heavily by demand from smartphone manufacturers, but is expected to expand further due to the growing demand from the automotive, healthcare, and surveillance space.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Bob, Anna\u2019s friend, called his buddy Tom, an expert in the semiconductor industry.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"Hey Tom, this market is huge. How do we play in this game?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Tom"
	    ),
	    ": \"This game?? It's not a game, it's a billion dollar market.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"All markets are games to play. It\u2019s a competition right? With players? Rules? Uncertainty? Goals?\"",
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Tom"
	    ),
	    ": \"What's the goal?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"Capturing market share of course!\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Tom"
	    ),
	    ": \"Are you sure about that? Anyways, in this 'game', you have to pay to play.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"How much, a few millions?\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Tom"
	    ),
	    ": \"How about a billion dollars...and that\u2019s just to buy the facility and production line. High barriers to entry my friend.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      Name,
	      null,
	      "Bob"
	    ),
	    ": \"I'm no longer enjoying this call Tom, speak to you later.\"",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "Digital image sensors are silicon microchips that are engineered to operate in different ways. The engineering involved in these circuits is very complex; so are the techniques used to manufacture these microchips. Integrated circuits are manufactured in semiconductor fabrication plants (commonly called fabs; sometimes foundry). The central part of a fab is a clean room, which is very expensive to build and maintain. Fabs also require very expensive equipment, and can easily cost hundreds of millions of dollars.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    "In addition to the high fab costs, constant new technologies create shorter product life cycles in this industry. Another challenge had been the low prices, especially in the case of mobile phone image sensors. Therefore, historically, the image sensor manufacturers had to be efficient, adapt to technological changes, and customer-centric to make a profit. Image sensors required by the automobile industry require higher quality than the mobile phone industry, but those sensors are priced high and have higher profit margins."
	  );
	};
	
	exports.default = OpportunityEconomyIndustry;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OnePanel = __webpack_require__(180);
	
	var _OnePanel2 = _interopRequireDefault(_OnePanel);
	
	var _styles = __webpack_require__(95);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _chip = __webpack_require__(2562);
	
	var _chip2 = _interopRequireDefault(_chip);
	
	var _chip3 = __webpack_require__(2563);
	
	var _chip4 = _interopRequireDefault(_chip3);
	
	var _auto = __webpack_require__(2560);
	
	var _auto2 = _interopRequireDefault(_auto);
	
	var _sliders = __webpack_require__(2564);
	
	var _sliders2 = _interopRequireDefault(_sliders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Product = function Product(_ref) {
	  var activeRound = _ref.activeRound;
	  return _react2.default.createElement(
	    _OnePanel2.default,
	    { title: "THE PRODUCT" },
	    "Image sensors are devices made from silicon chips that capture photons and convert the photons into electrons to display optical information (i.e. images). It is used in a variety of devices. Most notable are digital cameras and mobile phones. It is produced in a semiconductor Fabrication plant (\"Fab\" or \"Fab Plant\") from silicon wafers.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6 },
	        _react2.default.createElement(
	          _styles2.default.ImageDescription,
	          null,
	          "Silicon Wafer"
	        ),
	        _react2.default.createElement(_styles2.default.ResponsiveImage, {
	          maxWidth: "80%",
	          src: _chip2.default,
	          alt: "chip image 1"
	        })
	      ),
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 6 },
	        _react2.default.createElement(
	          _styles2.default.ImageDescription,
	          null,
	          "Image Sensor Chip"
	        ),
	        _react2.default.createElement(_styles2.default.ResponsiveImage, {
	          maxWidth: "80%",
	          src: _chip4.default,
	          alt: "chip image 2"
	        })
	      )
	    ),
	    _react2.default.createElement(_styles.LineBreak, { count: 3 }),
	    _react2.default.createElement(
	      _styles2.default.Subtitle,
	      null,
	      "PRODUCT FEATURES"
	    ),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Resolution"
	    ),
	    "Resolution is the fineness of details in an image. High resolution sensors are small sensors with high pixel count, which means the pixel has to be smaller. The smaller the pixels, the higher the resolution (the finer the details you can capture in an image). Mobile customers want image sensors with high resolution because 1) smartphones need small sensors and 2) smartphone customers want high resolution pictures. For auto customers, having a high resolution is not that important as fine details of the image is not as important as image detection.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Sensitivity"
	    ),
	    "Light sensitivity is a measure of the minimum amount of light needed to generate an electronic signal. Reducing pixel sizes (increasing the resolution), reduces light sensitivity, which has consequences both for high and low levels of scene luminance and for short and long exposure duration. For Auto image sensors, this increases safety risks. For example, when driving in fog or darkness, an image sensor with low light sensitivity might not be able to detect objects correctly. See picture below:",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(_styles2.default.ResponsiveImage, { src: _auto2.default, alt: "auto image 2" }),
	    _react2.default.createElement(_styles.LineBreak, null),
	    "The downsides are, when the light sensitivity is high (larger sensor with larger pixel sizes), that resolution and power consumption suffer. These are not negative factors for mobile sensors.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Power"
	    ),
	    "Power refers to the power efficiency of the sensor (the higher the power consumption, the lower the power efficiency). Power consumption of the sensor impacts the battery life of a mobile phone. Therefore the mobile customers require power efficient image sensors. On the other hand, power efficiency is not a critical product feature for auto customers.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Temperature Range"
	    ),
	    "Temperature range measures a sensor's ability to perform in extreme temperatures, which is an essential feature for auto sensors. This is a minor factor for mobile sensors as smartphones are not exposed to extreme temperatures in the way that vehicles are.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Product Feature Ranking System"
	    ),
	    _react2.default.createElement(_styles2.default.ResponsiveImage, { src: _sliders2.default, alt: "sliders", align: "right" }),
	    "Image sensor industry (in the sim only) uses a standard ranking system to communicate the product features. Each feature is ranked from 1 to 10. 1 being the lowest and 10 being the highest. Customers use the ranking system to express their minimum product requirements (in terms of resolution, sensitivity, power, and temperature in that order). For example, if a customer specifies their minimum product requirements as 1, 4, 6, 8, then that customer\u2019s image sensor requires a chip that has a low resolution, moderate light sensitivity efficiency and a very high power and temperature tolerance. Based on the customer segment information, this customer is likely an auto manufacturer. If an image sensor manufacturer intends to sell to this customer, its image sensor should at least meet the 1,4,6,8 requirement.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(
	      _styles2.default.GreyBold,
	      null,
	      "Product Features, Development Time, and Research and Development (R&D) Cost"
	    ),
	    "Another impact of the product development time is, it impacts the product release date. For example, if your product release date is July 1, then you can\u2019t start production until that date. As a result, your production volumes will only be 50% of the annual capacity.",
	    _react2.default.createElement(_styles.LineBreak, null),
	    _react2.default.createElement(_styles.Exhibit, { number: 2, round: activeRound }),
	    " provides the expected research and development cost at different quality levels (different ranks for each product feature)."
	  );
	};
	
	exports.default = Product;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d = __webpack_require__(1805);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PerceptualMapChart = function (_PureComponent) {
	  _inherits(PerceptualMapChart, _PureComponent);
	
	  function PerceptualMapChart() {
	    _classCallCheck(this, PerceptualMapChart);
	
	    return _possibleConstructorReturn(this, (PerceptualMapChart.__proto__ || Object.getPrototypeOf(PerceptualMapChart)).apply(this, arguments));
	  }
	
	  _createClass(PerceptualMapChart, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var data = [[0, 0, 15]];
	
	      var margin = {
	        top: 20,
	        right: 15,
	        bottom: 15,
	        left: 15
	      };
	
	      var width = 400 - margin.left - margin.right;
	      var height = 400 - margin.top - margin.bottom;
	
	      // create the svg container
	      var svg = _d2.default.select("#PerceptualMapChart").append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
	
	      // set up the x scale
	      var xScale = _d2.default.scale.linear().domain([-10, 10]).range([0, width]);
	
	      // set up the y scale
	      var yScale = _d2.default.scale.linear().domain([-10, 10]).range([height, 0]);
	
	      var rScale = _d2.default.scale.linear().domain([0, 100]).range([0, height]);
	
	      // append a circle
	      svg.selectAll("circle").data(data).enter().append("circle").attr("cx", function (d) {
	        return xScale(d[0]);
	      }).attr("cy", function (d) {
	        return yScale(d[1]);
	      }).attr("r", function (d) {
	        return rScale(d[2]);
	      }).attr("class", "color-data");
	
	      // define the x axis
	      var xAxis = _d2.default.svg.axis().scale(xScale).orient("bottom");
	
	      // define the y axis
	      var yAxis = _d2.default.svg.axis().scale(yScale).orient("right");
	
	      // call the xAxis function to generate the x axis
	      svg.append("g").attr("class", "axis").attr("transform", "translate(0, " + height / 2 + ")").call(xAxis);
	
	      // call the yAxis function to generate the x axis
	      svg.append("g").attr("class", "axis").attr("transform", "translate(" + width / 2 + ", 0)").call(yAxis);
	
	      // y NORTH
	      svg.append("text").attr("font-size", "10px").attr("transform", "translate(" + width / 2 + " ," + -7 + ")").style("text-anchor", "middle").text("Sensitivity");
	
	      // -y SOUTH
	      svg.append("text").attr("font-size", "10px").attr("transform", "translate(" + width / 2 + " ," + (height + margin.bottom - 2) + ")").style("text-anchor", "middle").text("Resolution");
	
	      // x EAST
	      svg.append("text").attr("font-size", "10px").attr("transform", "translate(" + (width - 25) + " ," + (height / 2 + 20) + ")").style("text-anchor", "middle").text("Temp Range");
	
	      // -x WEST
	      svg.append("text").attr("font-size", "10px").attr("transform", "translate(" + 15 + " , " + (height / 2 + 20) + ")").style("text-anchor", "middle").text("Power");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "perceptualChart text-center" },
	        _react2.default.createElement("div", { id: "PerceptualMapChart" })
	      );
	    }
	  }]);
	
	  return PerceptualMapChart;
	}(_react.PureComponent);
	
	exports.default = PerceptualMapChart;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _customLabel = __webpack_require__(213);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromotionalSpend = function (_PureComponent) {
	  _inherits(PromotionalSpend, _PureComponent);
	
	  function PromotionalSpend() {
	    _classCallCheck(this, PromotionalSpend);
	
	    return _possibleConstructorReturn(this, (PromotionalSpend.__proto__ || Object.getPrototypeOf(PromotionalSpend)).apply(this, arguments));
	  }
	
	  _createClass(PromotionalSpend, [{
	    key: "getColor",
	    value: function getColor(i) {
	      var baseColors = _Teams2.default.competitiveColors();
	      return baseColors[i % baseColors.length];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-center" },
	        _react2.default.createElement(
	          "div",
	          { id: "chartHorizontalBarPSPhones", className: "horizontalBar lmm30" },
	          _react2.default.createElement(
	            _recharts.BarChart,
	            {
	              layout: "vertical",
	              width: 220,
	              height: 230,
	              data: this.dataValues,
	              margin: this.margin
	            },
	            _react2.default.createElement(_recharts.YAxis, { type: "category", dataKey: "team", tick: false }),
	            _react2.default.createElement(_recharts.XAxis, {
	              type: "number",
	              ticks: [0, 20, 40, 60, 80, 100],
	              interval: 0,
	              domain: [function (dataMin) {
	                return 0;
	              }, function (dataMax) {
	                return dataMax < 90 ? dataMax : dataMax * 1.2;
	              }],
	              tick: { textAnchor: "end" },
	              tickFormatter: function tickFormatter(val) {
	                return val + "%";
	              }
	            }),
	            _react2.default.createElement(_recharts.Tooltip, { formatter: function formatter(val) {
	                return val + "%";
	              } }),
	            _react2.default.createElement(
	              _recharts.Bar,
	              {
	                dataKey: "Product Awareness",
	                barSize: 18,
	                stackId: "a",
	                minPointSize: 5,
	                label: _react2.default.createElement(_customLabel2.default, {
	                  prefix: "",
	                  precision: 0,
	                  suffix: "%",
	                  layout: "vertical",
	                  xOffset: 15
	                })
	              },
	              this.dataValues.map(function (value, i) {
	                return _react2.default.createElement(_recharts.Cell, { key: i, fill: _this2.getColor(i) });
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "dataValues",
	    get: function get() {
	      var data = [];
	
	      this.props.data.forEach(function (item) {
	        var team = item.team,
	            value = item.value;
	
	
	        data.push({
	          team: team,
	          "Product Awareness": value * 100
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "margin",
	    get: function get() {
	      return {
	        top: 20,
	        left: -20,
	        right: 0,
	        bottom: 0
	      };
	    }
	  }]);
	
	  return PromotionalSpend;
	}(_react.PureComponent);
	
	exports.default = PromotionalSpend;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalesSpendingChart = function (_Component) {
	  _inherits(SalesSpendingChart, _Component);
	
	  function SalesSpendingChart(props) {
	    _classCallCheck(this, SalesSpendingChart);
	
	    var _this = _possibleConstructorReturn(this, (SalesSpendingChart.__proto__ || Object.getPrototypeOf(SalesSpendingChart)).call(this, props));
	
	    _this.formatMillions = function (val) {
	      var valStr = (val / 1000000).toFixed(2);
	      return "$" + valStr + "M";
	    };
	
	    _this.onMouseLeave = function () {
	      _this.setState({
	        showPopover: false
	      });
	    };
	
	    _this.onMouseEnter = function (entry, index, e) {
	      var parentNode = _reactDom2.default.findDOMNode(_this.refs["sales-spending-chart"]);
	      var parentCoords = parentNode.getBoundingClientRect();
	
	      _this.setState({
	        showPopover: true,
	        positionTop: e.clientY - parentCoords.top - 90,
	        positionLeft: e.clientX - parentCoords.left - 25,
	        teamName: entry.value
	      });
	    };
	
	    _this.renderPopover = function () {
	      var _this$state = _this.state,
	          teamName = _this$state.teamName,
	          positionTop = _this$state.positionTop,
	          positionLeft = _this$state.positionLeft,
	          showPopover = _this$state.showPopover;
	
	
	      if (showPopover === false) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Popover,
	        {
	          id: "sales-spending-legend-popover",
	          placement: "top",
	          positionTop: positionTop,
	          positionLeft: positionLeft
	        },
	        teamName
	      );
	    };
	
	    _this.state = {
	      teamName: "",
	      positionTop: 0,
	      positionLeft: 0,
	      showPopover: false
	    };
	    return _this;
	  }
	
	  _createClass(SalesSpendingChart, [{
	    key: "render",
	    value: function render() {
	      var colors = _Teams2.default.competitiveColors();
	      var _props = this.props,
	          data1 = _props.data1,
	          data2 = _props.data2,
	          teams = _props.teams;
	
	      var payload = Object.values(teams).map(function (team, index) {
	        return {
	          value: team,
	          type: "square",
	          id: "SSCID" + index,
	          color: colors[index % colors.length]
	        };
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { id: "sales-spending-chart", ref: "sales-spending-chart" },
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 192 },
	          _react2.default.createElement(
	            _recharts.PieChart,
	            {
	              margin: {
	                top: 20,
	                left: 0,
	                right: 0,
	                bottom: 0
	              }
	            },
	            _react2.default.createElement(
	              "text",
	              {
	                x: "20%",
	                y: 10,
	                className: "recharts-text recharts-label",
	                textAnchor: "left"
	              },
	              _react2.default.createElement(
	                "tspan",
	                { dx: -45, dy: 0 },
	                "DIRECT SALES"
	              )
	            ),
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                id: "ssid-1",
	                data: data1,
	                dataKey: "value",
	                cx: "20%",
	                cy: "50%",
	                innerRadius: 40,
	                outerRadius: 70,
	                fill: "#8884d8"
	              },
	              colors.map(function (color, i) {
	                return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	              })
	            ),
	            _react2.default.createElement(
	              "text",
	              {
	                x: "75%",
	                y: 0,
	                className: "recharts-text recharts-label",
	                textAnchor: "left"
	              },
	              _react2.default.createElement(
	                "tspan",
	                { dx: -49, dy: 10 },
	                "DISTRIBUTORS"
	              )
	            ),
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                data: data2,
	                dataKey: "value",
	                cx: "75%",
	                cy: "50%",
	                innerRadius: 40,
	                outerRadius: 70,
	                fill: "#8884d8"
	              },
	              colors.map(function (color, i) {
	                return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	              })
	            ),
	            _react2.default.createElement(_recharts.Tooltip, { formatter: this.formatMillions }),
	            _react2.default.createElement(_recharts.Legend, {
	              layout: "horizontal",
	              align: "center",
	              verticalAlign: "bottom",
	              payload: payload,
	              onMouseEnter: this.onMouseEnter,
	              onMouseLeave: this.onMouseLeave
	            })
	          )
	        ),
	        this.renderPopover()
	      );
	    }
	  }]);
	
	  return SalesSpendingChart;
	}(_react.Component);
	
	exports.default = SalesSpendingChart;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AxisLabel = function AxisLabel(_ref) {
	  var axisType = _ref.axisType,
	      x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      stroke = _ref.stroke,
	      children = _ref.children;
	
	  var isVert = axisType === "yAxis";
	  var cx = isVert ? x : x + width / 2;
	  var cy = isVert ? height / 2 + y : y + height + 10;
	  var rot = isVert ? "270 " + cx + " " + cy : 0;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: cx,
	      y: cy,
	      transform: "rotate(" + rot + ")",
	      textAnchor: "middle",
	      stroke: stroke
	    },
	    children
	  );
	};
	
	var VolumeChart = function (_Component) {
	  _inherits(VolumeChart, _Component);
	
	  function VolumeChart(props) {
	    _classCallCheck(this, VolumeChart);
	
	    var _this = _possibleConstructorReturn(this, (VolumeChart.__proto__ || Object.getPrototypeOf(VolumeChart)).call(this, props));
	
	    _this.numberWithCommas = function (val) {
	      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    };
	
	    _this.onMouseLeave = function () {
	      _this.setState({
	        showPopover: false
	      });
	    };
	
	    _this.onMouseEnter = function (entry, index, e) {
	      var parentNode = _reactDom2.default.findDOMNode(_this.refs["volume-chart"]);
	      var parentCoords = parentNode.getBoundingClientRect();
	
	      _this.setState({
	        showPopover: true,
	        positionTop: e.clientY - parentCoords.top - 90,
	        positionLeft: e.clientX - parentCoords.left - 25,
	        teamName: entry.value
	      });
	    };
	
	    _this.renderPopover = function () {
	      var _this$state = _this.state,
	          teamName = _this$state.teamName,
	          positionTop = _this$state.positionTop,
	          positionLeft = _this$state.positionLeft,
	          showPopover = _this$state.showPopover;
	
	
	      if (showPopover === false) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactBootstrap.Popover,
	        {
	          id: "volume-legend-popover",
	          placement: "top",
	          positionTop: positionTop,
	          positionLeft: positionLeft
	        },
	        teamName
	      );
	    };
	
	    _this.state = {
	      teamName: "",
	      positionTop: 0,
	      positionLeft: 0,
	      showPopover: false
	    };
	    return _this;
	  }
	
	  _createClass(VolumeChart, [{
	    key: "getMaxValue",
	    value: function getMaxValue(data) {
	      return Math.max.apply(null, data.map(function (item) {
	        return item.value;
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var sales_colors = _Teams2.default.competitiveColors();
	      var unsold_colors = _Teams2.default.unsoldColors();
	      var _props = this.props,
	          unsoldInventory = _props.unsoldInventory,
	          teams = _props.teams;
	
	      var payload = Object.values(teams).map(function (team, index) {
	        return {
	          value: team,
	          type: "square",
	          id: "SSCID" + index,
	          color: sales_colors[index % sales_colors.length]
	        };
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { id: "volume-chart", ref: "volume-chart" },
	        _react2.default.createElement(
	          _recharts.BarChart,
	          {
	            width: 450,
	            height: 220,
	            data: this.dataValues,
	            margin: this.margin
	          },
	          _react2.default.createElement(_recharts.XAxis, { dataKey: "team", tick: false }),
	          _react2.default.createElement(_recharts.YAxis, {
	            label: _react2.default.createElement(
	              AxisLabel,
	              { axisType: "yAxis", x: 80, y: 80, height: 0 },
	              "# of units"
	            ),
	            tickFormatter: this.numberWithCommas,
	            domain: this.domain
	          }),
	          _react2.default.createElement(_recharts.Tooltip, null),
	          _react2.default.createElement(
	            _recharts.Bar,
	            { dataKey: "Sales", barSize: 18, stackId: "a" },
	            unsoldInventory.map(function (item, i) {
	              return _react2.default.createElement(_recharts.Cell, { key: i, fill: sales_colors[i % sales_colors.length] });
	            })
	          ),
	          _react2.default.createElement(
	            _recharts.Bar,
	            { dataKey: "Unsold Inventory", barSize: 18, stackId: "a" },
	            unsoldInventory.map(function (item, i) {
	              return _react2.default.createElement(_recharts.Cell, { key: i, fill: unsold_colors[i % unsold_colors.length] });
	            })
	          ),
	          _react2.default.createElement(_recharts.Legend, {
	            layout: "horizontal",
	            align: "center",
	            verticalAlign: "bottom",
	            payload: payload,
	            onMouseEnter: this.onMouseEnter,
	            onMouseLeave: this.onMouseLeave
	          })
	        ),
	        this.renderPopover()
	      );
	    }
	  }, {
	    key: "domain",
	    get: function get() {
	      var _props2 = this.props,
	          unsoldInventory = _props2.unsoldInventory,
	          unitsSold = _props2.unitsSold;
	
	      var max = Math.max(this.getMaxValue(unsoldInventory), this.getMaxValue(unitsSold));
	
	      if (max < 1000000) {
	        return [0, 1000000];
	      }
	
	      return [0, "dataMax"];
	    }
	  }, {
	    key: "margin",
	    get: function get() {
	      return {
	        top: 0,
	        right: 50,
	        bottom: 0,
	        left: 100
	      };
	    }
	  }, {
	    key: "dataValues",
	    get: function get() {
	      var _props3 = this.props,
	          unsoldInventory = _props3.unsoldInventory,
	          unitsSold = _props3.unitsSold;
	
	      var data = [];
	
	      unsoldInventory.forEach(function (item) {
	        var A = unsoldInventory.find(function (i) {
	          return i.team === item.team;
	        });
	        var B = unitsSold.find(function (i) {
	          return i.team === item.team;
	        });
	
	        data.push({
	          team: item.team,
	          "Unsold Inventory": A ? A.value : 0,
	          Sales: B ? B.value : 0
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return VolumeChart;
	}(_react.Component);
	
	exports.default = VolumeChart;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _horizontalBar = __webpack_require__(214);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Kpis1 = function (_PureComponent) {
	  _inherits(Kpis1, _PureComponent);
	
	  function Kpis1() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Kpis1);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Kpis1.__proto__ || Object.getPrototypeOf(Kpis1)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Kpis1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_horizontalBar2.default, { suffix: "%", data: this.MarketShare }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Market Share"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_verticalBar2.default, {
	              prefix: "$",
	              suffix: "M",
	              precision: 3,
	              data: this.Revenues
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Revenues"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.GrossMargins }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Gross Margins"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_horizontalBar2.default, { prefix: "$", data: this.SharePrice }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Share Price",
	              _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                iconSize: "xs"
	              }, _TypeformContent2.default.STOCK_PRICE))
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "MarketShare",
	    get: function get() {
	      var _props = this.props,
	          teams = _props.teams,
	          metrics = _props.metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: metrics[team_id] && metrics[team_id]["MarketShare"] ? metrics[team_id]["MarketShare"] * 100 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "GrossMargins",
	    get: function get() {
	      var _props2 = this.props,
	          teams = _props2.teams,
	          metrics = _props2.metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: metrics[team_id] && metrics[team_id]["GrossMargins"] ? metrics[team_id]["GrossMargins"] * 100 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "Revenues",
	    get: function get() {
	      var _props3 = this.props,
	          teams = _props3.teams,
	          metrics = _props3.metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: metrics[team_id] && metrics[team_id]["Revenues"] ? metrics[team_id]["Revenues"] / 1000000 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "SharePrice",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "Share Price")
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return Kpis1;
	}(_react.PureComponent);
	
	exports.default = Kpis1;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _horizontalBar = __webpack_require__(214);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Kpis2 = function (_PureComponent) {
	  _inherits(Kpis2, _PureComponent);
	
	  function Kpis2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Kpis2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Kpis2.__proto__ || Object.getPrototypeOf(Kpis2)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Kpis2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_horizontalBar2.default, { prefix: "$", data: this.SharePrice }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Share Price",
	              _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                iconSize: "xs"
	              }, _TypeformContent2.default.STOCK_PRICE))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_verticalBar2.default, { prefix: "$", data: this.EarningPerShare }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Earnings Per Share",
	              _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                iconSize: "xs"
	              }, _TypeformContent2.default.EARNINGS_PER_SHARE))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.ROIC }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Return on Invested Capital",
	              _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                iconSize: "xs"
	              }, _TypeformContent2.default.ROIC_KPI))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white p-30" },
	            _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.RNOA }),
	            _react2.default.createElement(
	              "div",
	              { className: "text-center", style: { marginTop: "-20px" } },
	              "Return on Net Operating Assets",
	              _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                iconSize: "xs"
	              }, _TypeformContent2.default.RNOA_KPI))
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "ROIC",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "ROIC") * 100
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "RNOA",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this3.getDataValue(team_id, "RNOA") * 100
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "EarningPerShare",
	    get: function get() {
	      var _this4 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this4.getDataValue(team_id, "Earnings Per Share")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "SharePrice",
	    get: function get() {
	      var _this5 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this5.getDataValue(team_id, "Share Price")
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return Kpis2;
	}(_react.PureComponent);
	
	exports.default = Kpis2;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marketCapture = __webpack_require__(574);
	
	var _marketCapture2 = _interopRequireDefault(_marketCapture);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketCapture = function (_PureComponent) {
	  _inherits(MarketCapture, _PureComponent);
	
	  function MarketCapture() {
	    _classCallCheck(this, MarketCapture);
	
	    return _possibleConstructorReturn(this, (MarketCapture.__proto__ || Object.getPrototypeOf(MarketCapture)).apply(this, arguments));
	  }
	
	  _createClass(MarketCapture, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var total_demand = this.props.total_demand;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white" },
	            _react2.default.createElement(
	              "div",
	              { className: "pt-30 pl-30 pr-30" },
	              _react2.default.createElement(
	                "h5",
	                null,
	                "MARKET CAPTURE - MOBILE",
	                _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	                  category: "Market Capture Mobile",
	                  tooltipContent: "This section shows the # of units you were able to sell in the market in relation to your competitors.",
	                  iconSize: "sm"
	                })
	              ),
	              _react2.default.createElement("hr", null)
	            ),
	            _react2.default.createElement(_marketCapture2.default, {
	              data: this.dataMobile,
	              totalDemand: total_demand.mobile
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-6 col-xs-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "bg-white" },
	            _react2.default.createElement(
	              "div",
	              { className: "pt-30 pl-30 pr-30" },
	              _react2.default.createElement(
	                "h5",
	                null,
	                "MARKET CAPTURE - AUTO",
	                _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	                  category: "Market Capture Auto",
	                  tooltipContent: "This section shows the # of units you were able to sell in the market in relation to your competitors.",
	                  iconSize: "sm"
	                })
	              ),
	              _react2.default.createElement("hr", null)
	            ),
	            _react2.default.createElement(_marketCapture2.default, {
	              data: this.dataAuto,
	              totalDemand: total_demand.auto
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "dataMobile",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var chartData = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        chartData.push({
	          team: teams[team_id],
	          value: Math.abs(_this2.getDataValue(team_id, "Units Sold Mobile"))
	        });
	      });
	
	      return chartData;
	    }
	  }, {
	    key: "dataAuto",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var chartData = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        chartData.push({
	          team: teams[team_id],
	          value: Math.abs(_this3.getDataValue(team_id, "Units Sold Auto"))
	        });
	      });
	
	      return chartData;
	    }
	  }]);
	
	  return MarketCapture;
	}(_react.PureComponent);
	
	exports.default = MarketCapture;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _perceptualMap = __webpack_require__(1140);
	
	var _perceptualMap2 = _interopRequireDefault(_perceptualMap);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PerceptualMap(props) {
	  var style = {
	    color: "#f00",
	    fontWeight: "bold",
	    fontSize: "12px",
	    marginLeft: "10px"
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row m-0" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30" },
	      _react2.default.createElement(
	        "h5",
	        null,
	        "PERCEPTUAL MAP",
	        _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	          iconSize: "sm"
	        }, _TypeformContent2.default.PERCEPTUAL_MAP)),
	        _react2.default.createElement(
	          "span",
	          { style: style },
	          "Not available at this time"
	        )
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "div",
	        { className: "mt-30" },
	        _react2.default.createElement(_perceptualMap2.default, null)
	      )
	    )
	  );
	}
	
	exports.default = PerceptualMap;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pricing = __webpack_require__(575);
	
	var _pricing2 = _interopRequireDefault(_pricing);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pricing = function (_PureComponent) {
	  _inherits(Pricing, _PureComponent);
	
	  function Pricing() {
	    _classCallCheck(this, Pricing);
	
	    return _possibleConstructorReturn(this, (Pricing.__proto__ || Object.getPrototypeOf(Pricing)).apply(this, arguments));
	  }
	
	  _createClass(Pricing, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "col-md-3 col-xs-12" },
	        _react2.default.createElement(
	          "div",
	          { className: "bg-white p-30 mh-858" },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "PRICING",
	            _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	              iconSize: "sm"
	            }, _TypeformContent2.default.PRICING))
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "mt-30" },
	            _react2.default.createElement(_pricing2.default, {
	              title: "MOBILE PHONES",
	              id: "chartHorizontalBarPricingPhones",
	              data: this.sellingPriceMobile
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mt-30" },
	            _react2.default.createElement(_pricing2.default, {
	              title: "AUTONOMOUS VEHICLES",
	              id: "chartHorizontalBarPricingVehicles",
	              data: this.sellingPriceAuto
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "sellingPriceAuto",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: _this2.getDataValue(team_id, "Average Selling Price - Auto")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "sellingPriceMobile",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: _this3.getDataValue(team_id, "Average Selling Price - Mobile")
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return Pricing;
	}(_react.PureComponent);
	
	exports.default = Pricing;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _productCosts = __webpack_require__(576);
	
	var _productCosts2 = _interopRequireDefault(_productCosts);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductCosts = function (_Component) {
	  _inherits(ProductCosts, _Component);
	
	  function ProductCosts() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProductCosts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductCosts.__proto__ || Object.getPrototypeOf(ProductCosts)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProductCosts, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "col-md-3 col-xs-12" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "bg-white p-30 mh-330",
	            style: { height: this.blockHeight }
	          },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "PRODUCT COSTS",
	            _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	              iconSize: "sm"
	            }, _TypeformContent2.default.PRODUCT_COSTS))
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "mt-15", style: this.marginStyle },
	            _react2.default.createElement(_productCosts2.default, { data: this.productCosts })
	          )
	        )
	      );
	    }
	  }, {
	    key: "productCosts",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: _this2.getDataValue(team_id, "Average Unit Cost")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "blockHeight",
	    get: function get() {
	      var teams = this.props.teams;
	
	      var c = Object.keys(teams).length;
	      var h = 152 + 34 * c;
	
	      return h < 330 ? 330 : h;
	    }
	  }, {
	    key: "marginStyle",
	    get: function get() {
	      var teams = this.props.teams;
	
	      var c = Object.keys(teams).length - 5;
	      var c1 = c >= 0 ? c : 0;
	      var c2 = 15 * c1;
	
	      return {
	        marginTop: c2 > 0 ? c2 : 15
	      };
	    }
	  }]);
	
	  return ProductCosts;
	}(_react.Component);
	
	exports.default = ProductCosts;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _promotionalSpend = __webpack_require__(1141);
	
	var _promotionalSpend2 = _interopRequireDefault(_promotionalSpend);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromotionalSpend = function (_PureComponent) {
	  _inherits(PromotionalSpend, _PureComponent);
	
	  function PromotionalSpend() {
	    _classCallCheck(this, PromotionalSpend);
	
	    return _possibleConstructorReturn(this, (PromotionalSpend.__proto__ || Object.getPrototypeOf(PromotionalSpend)).apply(this, arguments));
	  }
	
	  _createClass(PromotionalSpend, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "col-md-3 col-xs-12" },
	        _react2.default.createElement(
	          "div",
	          { className: "bg-white p-30 mh-858" },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "PRODUCT AWARENESS",
	            _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	              iconSize: "sm"
	            }, _TypeformContent2.default.PRODUCT_AWARENESS))
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "mt-30" },
	            _react2.default.createElement(_promotionalSpend2.default, { data: this.productAwareness })
	          )
	        )
	      );
	    }
	  }, {
	    key: "productAwareness",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: _this2.getDataValue(team_id, "Product Awareness")
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return PromotionalSpend;
	}(_react.PureComponent);
	
	exports.default = PromotionalSpend;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _salesSpending = __webpack_require__(1142);
	
	var _salesSpending2 = _interopRequireDefault(_salesSpending);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SalesSpending = function (_PureComponent) {
	  _inherits(SalesSpending, _PureComponent);
	
	  function SalesSpending() {
	    _classCallCheck(this, SalesSpending);
	
	    return _possibleConstructorReturn(this, (SalesSpending.__proto__ || Object.getPrototypeOf(SalesSpending)).apply(this, arguments));
	  }
	
	  _createClass(SalesSpending, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var teams = this.props.teams;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row m-0 mt-20" },
	        _react2.default.createElement(
	          "div",
	          { className: "bg-white p-30", style: { height: 318 } },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "SALES SPENDING",
	            _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	              category: "Sales Spending",
	              tooltipContent: "This section highlights where you are spending to get sales (i.e. Direct Sales vs. Distributors).  Direct Sales are employees of the firm whereas distributors are 3rd parties.",
	              iconSize: "sm"
	            })
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "row mt-30" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 col-xs-12" },
	              _react2.default.createElement(_salesSpending2.default, {
	                data1: this.directSalesSpend,
	                data2: this.distributionSpend,
	                teams: teams
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "directSalesSpend",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          name: teams[team_id],
	          value: _this2.getDataValue(team_id, "Direct Sales Spend")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "distributionSpend",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          name: teams[team_id],
	          value: _this3.getDataValue(team_id, "Distribution Spend")
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return SalesSpending;
	}(_react.PureComponent);
	
	exports.default = SalesSpending;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _utils = __webpack_require__(18);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var popoverComponent = function popoverComponent(product) {
	  return _react2.default.createElement(
	    _reactBootstrap.Popover,
	    {
	      id: "popover-product-features-" + product.product.id,
	      title: "Product's Features",
	      bsClass: "map-popover popover"
	    },
	    _react2.default.createElement(
	      "b",
	      null,
	      "Resolution:"
	    ),
	    " ",
	    product.product.pixels_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Sensitivity:"
	    ),
	    " ",
	    product.product.sensitivity_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Power:"
	    ),
	    " ",
	    product.product.power_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Temperature:"
	    ),
	    " ",
	    product.product.temp_range_rank
	  );
	};
	
	function TopProductsAuto(_ref) {
	  var _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? [] : _ref$teams,
	      _ref$top_performers = _ref.top_performers,
	      top_performers = _ref$top_performers === undefined ? {} : _ref$top_performers;
	
	  var colors = _Teams2.default.competitiveColors();
	  var top_products = [];
	  if ("Auto" in top_performers) {
	    // Drop rank_auto === 0 entries — BE tags products with no
	    // interested Auto customers with a zero rank + a `note` field,
	    // and they shouldn't compete for a "Top ranked" slot in this
	    // segment.
	    top_products = top_performers.Auto.filter(function (i) {
	      return i.rank_auto !== 0;
	    });
	  }
	
	  if (top_products.length > 0) {
	    var top_products_rank_1 = top_products.filter(function (i) {
	      return i.rank_auto === 1;
	    });
	
	    if (top_products.length === top_products_rank_1.length) {
	      if (top_products.length > 7) {
	        top_products = _lodash2.default.shuffle(top_products);
	        top_products = top_products.slice(0, 7);
	      }
	    } else {
	      top_products.sort(function (a, b) {
	        return a.rank_auto - b.rank_auto;
	      });
	    }
	  }
	
	  if (top_products.length > 7) {
	    top_products = top_products.slice(0, 7);
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-4 col-xs-12" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30 mh-230" },
	      _react2.default.createElement(
	        "h5",
	        { className: "text-center" },
	        "TOP RANKED PRODUCTS AUTO"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white mt-30 text-center" },
	        top_products.length > 0 && _react2.default.createElement(
	          "div",
	          { className: "table-responsive" },
	          _react2.default.createElement(
	            "table",
	            { className: "table table-top-list" },
	            _react2.default.createElement(
	              "tbody",
	              null,
	              top_products.map(function (product, num) {
	                var index = 0;
	                Object.keys(teams).forEach(function (id, i) {
	                  var idNum = parseInt(id, 10);
	                  if (isNaN(idNum)) {
	                    idNum = 0;
	                  }
	                  if (product.team === idNum) {
	                    index = i;
	                  }
	                });
	                var squareStyle = {
	                  display: "inline-block",
	                  width: 15,
	                  height: 15,
	                  backgroundColor: colors[index % colors.length]
	                };
	
	                return _react2.default.createElement(
	                  "tr",
	                  { className: "text-center", key: product.product.id },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "short-column" },
	                    (0, _utils.numericSuffix)(num + 1)
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "short-column" },
	                    _react2.default.createElement(
	                      _reactBootstrap.OverlayTrigger,
	                      {
	                        trigger: ["hover", "focus"],
	                        placement: "bottom",
	                        overlay: popoverComponent(product)
	                      },
	                      _react2.default.createElement("span", { style: squareStyle })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    product.product.name
	                  )
	                );
	              })
	            )
	          )
	        ),
	        top_products.length === 0 && _react2.default.createElement(
	          "div",
	          { className: "text-center no-products" },
	          "No Product in the Market"
	        )
	      )
	    )
	  );
	}
	
	exports.default = TopProductsAuto;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _utils = __webpack_require__(18);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactBootstrap = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var popoverComponent = function popoverComponent(product) {
	  return _react2.default.createElement(
	    _reactBootstrap.Popover,
	    {
	      id: "popover-product-features-" + product.product.id,
	      title: "Product's Features",
	      bsClass: "map-popover popover"
	    },
	    _react2.default.createElement(
	      "b",
	      null,
	      "Resolution:"
	    ),
	    " ",
	    product.product.pixels_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Sensitivity:"
	    ),
	    " ",
	    product.product.sensitivity_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Power:"
	    ),
	    " ",
	    product.product.power_rank,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Temperature:"
	    ),
	    " ",
	    product.product.temp_range_rank
	  );
	};
	
	function TopProductsMobile(_ref) {
	  var _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? [] : _ref$teams,
	      _ref$top_performers = _ref.top_performers,
	      top_performers = _ref$top_performers === undefined ? {} : _ref$top_performers;
	
	  var colors = _Teams2.default.competitiveColors();
	  var top_products = [];
	  if ("Mobile" in top_performers) {
	    // Drop rank_mobile === 0 entries — BE tags products with no
	    // interested Mobile customers with a zero rank + a `note` field,
	    // and they shouldn't compete for a "Top ranked" slot in this
	    // segment.
	    top_products = top_performers.Mobile.filter(function (i) {
	      return i.rank_mobile !== 0;
	    });
	  }
	
	  if (top_products.length > 0) {
	    var top_products_rank_1 = top_products.filter(function (i) {
	      return i.rank_mobile === 1;
	    });
	
	    if (top_products.length === top_products_rank_1.length) {
	      if (top_products.length > 7) {
	        top_products = _lodash2.default.shuffle(top_products);
	        top_products = top_products.slice(0, 7);
	      }
	    } else {
	      top_products.sort(function (a, b) {
	        return a.rank_mobile - b.rank_mobile;
	      });
	    }
	  }
	
	  if (top_products.length > 7) {
	    top_products = top_products.slice(0, 7);
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-4 col-xs-12" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30 mh-230" },
	      _react2.default.createElement(
	        "h5",
	        { className: "text-center" },
	        "TOP RANKED PRODUCTS MOBILE"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white mt-30 text-center" },
	        top_products.length > 0 && _react2.default.createElement(
	          "div",
	          { className: "table-responsive" },
	          _react2.default.createElement(
	            "table",
	            { className: "table table-top-list" },
	            _react2.default.createElement(
	              "tbody",
	              null,
	              top_products.map(function (product, num) {
	                var index = 0;
	                Object.keys(teams).forEach(function (id, i) {
	                  var idNum = parseInt(id, 10);
	                  if (isNaN(idNum)) {
	                    idNum = 0;
	                  }
	                  if (product.team === idNum) {
	                    index = i;
	                  }
	                });
	                var squareStyle = {
	                  display: "inline-block",
	                  width: 15,
	                  height: 15,
	                  backgroundColor: colors[index % colors.length]
	                };
	
	                return _react2.default.createElement(
	                  "tr",
	                  { className: "text-center", key: product.product.id },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "short-column" },
	                    (0, _utils.numericSuffix)(num + 1)
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "short-column" },
	                    _react2.default.createElement(
	                      _reactBootstrap.OverlayTrigger,
	                      {
	                        trigger: ["hover", "focus"],
	                        placement: "bottom",
	                        overlay: popoverComponent(product)
	                      },
	                      _react2.default.createElement("span", { style: squareStyle })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    product.product.name
	                  )
	                );
	              })
	            )
	          )
	        ),
	        top_products.length === 0 && _react2.default.createElement(
	          "div",
	          { className: "text-center no-products" },
	          "No Product in the Market"
	        )
	      )
	    )
	  );
	}
	
	exports.default = TopProductsMobile;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TopTeams(_ref) {
	  var _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? [] : _ref$teams,
	      _ref$top_performers = _ref.top_performers,
	      top_performers = _ref$top_performers === undefined ? {} : _ref$top_performers;
	
	  var colors = _Teams2.default.competitiveColors();
	  var top_teams = [];
	  if ("teams" in top_performers) {
	    top_teams = top_performers.teams;
	  }
	
	  if (top_teams.length > 0) {
	    top_teams.sort(function (a, b) {
	      return b.weighted_value - a.weighted_value;
	    });
	  }
	
	  if (top_teams.length > 7) {
	    top_teams = top_teams.slice(0, 7);
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-4 col-xs-12" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30 mh-230" },
	      _react2.default.createElement(
	        "h5",
	        { className: "text-center" },
	        "TOP TEAMS"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white mt-30 text-center" },
	        _react2.default.createElement(
	          "div",
	          { className: "table-responsive" },
	          _react2.default.createElement(
	            "table",
	            { className: "table table-top-list" },
	            _react2.default.createElement(
	              "tbody",
	              null,
	              top_teams.map(function (top_team, num) {
	                var team_id = top_team.team_id,
	                    team__name = top_team.team__name;
	
	                var index = 0;
	                Object.keys(teams).forEach(function (id, i) {
	                  var idNum = parseInt(id, 10);
	                  if (isNaN(idNum)) {
	                    idNum = 0;
	                  }
	                  if (team_id === idNum) {
	                    index = i;
	                  }
	                });
	                var squareStyle = {
	                  display: "inline-block",
	                  width: 15,
	                  height: 15,
	                  backgroundColor: colors[index % colors.length]
	                };
	
	                return _react2.default.createElement(
	                  "tr",
	                  { className: "text-center", key: team_id },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "short-column" },
	                    (0, _utils.numericSuffix)(num + 1)
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "short-column" },
	                    _react2.default.createElement("span", { style: squareStyle })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    team__name
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = TopTeams;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactBootstrap = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Utilization = function (_PureComponent) {
	  _inherits(Utilization, _PureComponent);
	
	  function Utilization() {
	    _classCallCheck(this, Utilization);
	
	    return _possibleConstructorReturn(this, (Utilization.__proto__ || Object.getPrototypeOf(Utilization)).apply(this, arguments));
	  }
	
	  _createClass(Utilization, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }
	  }, {
	    key: "getHumanResources",
	    value: function getHumanResources(team_id) {
	      return (this.getDataValue(team_id, "Human Utilization") * 100).toFixed(0);
	    }
	  }, {
	    key: "getMachineFacility",
	    value: function getMachineFacility(team_id) {
	      return (this.getDataValue(team_id, "Machine Utilization") * 100).toFixed(0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var colors = _Teams2.default.competitiveColors();
	
	      return _react2.default.createElement(
	        "div",
	        { className: "col-md-3 col-xs-12" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "bg-white p-30 mh-330",
	            style: { height: this.blockHeight }
	          },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "UTILIZATION",
	            _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	              category: "Utilization",
	              tooltipContent: "This section displays your labor and machine hour utilization (i.e. actual hours divided by ideal hours).",
	              iconSize: "sm"
	            })
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "panel-dashboard-white mt-30" },
	            _react2.default.createElement(
	              "div",
	              { className: "table-responsive" },
	              _react2.default.createElement(
	                "table",
	                { className: "table" },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "Team"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "Human Resources"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "Machine & Facility"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  Object.keys(teams).map(function (team_id, index) {
	                    var squareStyle = {
	                      display: "inline-block",
	                      width: 15,
	                      height: 15,
	                      backgroundColor: colors[index % colors.length]
	                    };
	                    var tooltipElement = _react2.default.createElement(
	                      _reactBootstrap.Tooltip,
	                      { id: "tooltip-" + team_id },
	                      teams[team_id]
	                    );
	
	                    return _react2.default.createElement(
	                      "tr",
	                      { className: "text-center", key: team_id },
	                      _react2.default.createElement(
	                        "th",
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.OverlayTrigger,
	                          {
	                            placement: "top",
	                            overlay: tooltipElement
	                          },
	                          _react2.default.createElement("span", { style: squareStyle })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        _this2.getHumanResources(team_id),
	                        "%"
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        _this2.getMachineFacility(team_id),
	                        "%"
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "blockHeight",
	    get: function get() {
	      var teams = this.props.teams;
	
	      var c = Object.keys(teams).length;
	      var h = 152 + 34 * c;
	
	      return h < 330 ? 330 : h;
	    }
	  }]);
	
	  return Utilization;
	}(_react.PureComponent);
	
	exports.default = Utilization;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _volume = __webpack_require__(1143);
	
	var _volume2 = _interopRequireDefault(_volume);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Volume = function (_PureComponent) {
	  _inherits(Volume, _PureComponent);
	
	  function Volume() {
	    _classCallCheck(this, Volume);
	
	    return _possibleConstructorReturn(this, (Volume.__proto__ || Object.getPrototypeOf(Volume)).apply(this, arguments));
	  }
	
	  _createClass(Volume, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var teams = this.props.teams;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "col-md-6" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "bg-white p-30 mh-330",
	            style: { height: this.blockHeight }
	          },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "VOLUME",
	            _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	              category: "Volume",
	              tooltipContent: "This section displays the total units that your business produced and sold in relation to your competitors.",
	              iconSize: "sm"
	            })
	          ),
	          _react2.default.createElement("hr", null),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 p-0 competitive-analysis-volume-section",
	                style: this.marginStyle
	              },
	              _react2.default.createElement(_volume2.default, {
	                unsoldInventory: this.unsoldInventory,
	                unitsSold: this.unitsSold,
	                teams: teams
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "unitsSold",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: Math.abs(_this2.getDataValue(team_id, "Units Sold"))
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "unsoldInventory",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: Math.abs(_this3.getDataValue(team_id, "Available For Sale")) - Math.abs(_this3.getDataValue(team_id, "Units Sold"))
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "blockHeight",
	    get: function get() {
	      var teams = this.props.teams;
	
	      var c = Object.keys(teams).length;
	      var h = 152 + 34 * c;
	
	      return h < 330 ? 330 : h;
	    }
	  }, {
	    key: "marginStyle",
	    get: function get() {
	      var teams = this.props.teams;
	
	      var c = Object.keys(teams).length - 5;
	      var c1 = c >= 0 ? c : 0;
	
	      return {
	        marginTop: 15 * c1
	      };
	    }
	  }]);
	
	  return Volume;
	}(_react.PureComponent);
	
	exports.default = Volume;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AsiaInfo(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "col-xs-12 mb-20" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30" },
	      _react2.default.createElement(
	        "h4",
	        { className: "title-green" },
	        "ASIA"
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Units Demanded Automobile: n/a"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Growth Rate: n/a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Units Demanded Mobile Phones: n/a"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Growth Rate: n/a"
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = AsiaInfo;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EuropeInfo(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "col-xs-12 mb-20" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30" },
	      _react2.default.createElement(
	        "h4",
	        { className: "title-yellow" },
	        "EUROPE"
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Units Demanded Automobile: n/a"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Growth Rate: n/a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Units Demanded Mobile Phones: n/a"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Growth Rate: n/a"
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = EuropeInfo;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _reactCsv = __webpack_require__(952);
	
	var _style = __webpack_require__(255);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _newMapWithoutButtons = __webpack_require__(1059);
	
	var _newMapWithoutButtons2 = _interopRequireDefault(_newMapWithoutButtons);
	
	var _customerAnalysis = __webpack_require__(1432);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var popoverComponent = function popoverComponent(num, customers_preferences, customer_demands) {
	  var customer_preferences = customers_preferences.find(function (i) {
	    return i.customer === num;
	  });
	  if (!customer_preferences) {
	    return _react2.default.createElement("div", null);
	  }
	
	  var customer_demand = customer_demands.find(function (i) {
	    return i.customer === num;
	  });
	  if (!customer_demand) {
	    return _react2.default.createElement("div", null);
	  }
	
	  var customer = customer_preferences.customer,
	      segment = customer_preferences.segment,
	      min_price = customer_preferences.min_price,
	      max_price = customer_preferences.max_price,
	      min_temp_range = customer_preferences.min_temp_range,
	      min_sensitivity = customer_preferences.min_sensitivity,
	      min_power = customer_preferences.min_power,
	      min_pixels = customer_preferences.min_pixels;
	
	
	  var min_price_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    prefix: "$",
	    value: min_price.toFixed(2),
	    displayType: "text"
	  });
	  var max_price_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    prefix: "$",
	    value: max_price.toFixed(2),
	    displayType: "text"
	  });
	  var temp_range_rank_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    value: min_temp_range.toFixed(1),
	    displayType: "text"
	  });
	  var sensitivity_rank_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    value: min_sensitivity.toFixed(1),
	    displayType: "text"
	  });
	  var power_rank_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    value: min_power.toFixed(1),
	    displayType: "text"
	  });
	  var pixels_rank_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    value: min_pixels.toFixed(1),
	    displayType: "text"
	  });
	
	  var demand = customer_demand.demand;
	
	  var demand_object = _react2.default.createElement(_reactNumberFormat2.default, {
	    thousandSeparator: ",",
	    decimalSeparator: ".",
	    value: demand.toFixed(0),
	    displayType: "text"
	  });
	
	  return _react2.default.createElement(
	    _reactBootstrap.Popover,
	    {
	      id: "popover-map-us-" + num,
	      title: _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "span",
	          null,
	          num
	        ),
	        " ",
	        _customerAnalysis.mapDotsData[num - 1].title
	      ),
	      bsClass: "map-popover popover"
	    },
	    _react2.default.createElement(
	      "b",
	      null,
	      "Customer Name:"
	    ),
	    " ",
	    customer,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Segment:"
	    ),
	    " ",
	    segment,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Demand:"
	    ),
	    " ",
	    demand_object,
	    " units",
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Price Range:"
	    ),
	    " ",
	    min_price_object,
	    " to ",
	    max_price_object,
	    _react2.default.createElement("br", null),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "b",
	      null,
	      "Minimum Features:"
	    ),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "table",
	      null,
	      _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	          "td",
	          { className: "no-left-spacing" },
	          "Resolution: ",
	          pixels_rank_object
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "no-right-spacing" },
	          "Sensitivity: ",
	          sensitivity_rank_object
	        )
	      ),
	      _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	          "td",
	          { className: "no-left-spacing" },
	          "Power: ",
	          power_rank_object
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "no-right-spacing" },
	          "Temp Range: ",
	          temp_range_rank_object
	        )
	      )
	    )
	  );
	};
	
	function getCSVData(customer_preferences, customer_demands) {
	  var data = [];
	
	  customer_preferences.forEach(function (customer_preference) {
	    var customer_demand = customer_demands.find(function (i) {
	      return i.customer === customer_preference.customer;
	    });
	
	    data.push({
	      customer: customer_preference.customer,
	      round: customer_preference.round_number,
	      segment: customer_preference.segment,
	      demand: customer_demand ? customer_demand.demand : 0,
	      price_lower_bound: "$" + customer_preference.min_price.toFixed(2),
	      price_higher_bound: "$" + customer_preference.max_price.toFixed(2),
	      min_resolution: customer_preference.min_pixels,
	      min_sensitivity: customer_preference.min_sensitivity,
	      min_power: customer_preference.min_power,
	      min_temperature_range: customer_preference.min_temp_range
	    });
	  });
	
	  return data;
	}
	
	function Map(props) {
	  var customer_preferences = props.customer_preferences,
	      customer_demands = props.customer_demands;
	
	  var csvData = getCSVData(customer_preferences, customer_demands);
	  var csvHeaders = [{ key: "customer", label: "Customer" }, { key: "round", label: "Round" }, { key: "segment", label: "Segment" }, { key: "demand", label: "Demand" }, { key: "price_lower_bound", label: "Price Lower Bound" }, { key: "price_higher_bound", label: "Price Higher Bound" }, { key: "min_resolution", label: "Min. Resolution" }, { key: "min_sensitivity", label: "Min. Sensitivity" }, { key: "min_power", label: "Min Power" }, { key: "min_temperature_range", label: "Min. Temperature Range" }];
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-6 col-xs-12" },
	    _react2.default.createElement(
	      "div",
	      { className: "market-analysis" },
	      _react2.default.createElement(
	        "div",
	        { className: "market-analysis" },
	        _react2.default.createElement(
	          "div",
	          { className: "row img-map" },
	          _react2.default.createElement(
	            "div",
	            { className: "mapUS" },
	            _react2.default.createElement(
	              _style2.default.WhiteBlock,
	              { width: "100%" },
	              _react2.default.createElement(
	                _style2.default.GoogleMap,
	                null,
	                _react2.default.createElement("img", { src: _newMapWithoutButtons2.default, alt: "map" }),
	                _lodash2.default.range(1, 15).map(function (num) {
	                  return _react2.default.createElement(
	                    _reactBootstrap.OverlayTrigger,
	                    {
	                      key: num,
	                      trigger: ["hover", "focus"],
	                      placement: "bottom",
	                      overlay: popoverComponent(num, customer_preferences, customer_demands)
	                    },
	                    _react2.default.createElement(
	                      _style2.default.MapDot,
	                      {
	                        xPercentage: _customerAnalysis.mapDotsData[num - 1].x,
	                        yPercentage: _customerAnalysis.mapDotsData[num - 1].y
	                      },
	                      num
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "region" },
	          csvData.length > 0 && _react2.default.createElement(
	            "div",
	            { className: "market-analysis-download-link" },
	            _react2.default.createElement(
	              _reactCsv.CSVLink,
	              {
	                data: csvData,
	                headers: csvHeaders,
	                separator: ",",
	                filename: "market-analysis-round-" + csvData[0].round + ".csv",
	                target: "_blank"
	              },
	              "Download"
	            )
	          ),
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Region: US"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Extra customer information"
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = Map;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UsInfo(_ref) {
	  var _ref$units_demanded_a = _ref.units_demanded_automobile,
	      units_demanded_automobile = _ref$units_demanded_a === undefined ? 0 : _ref$units_demanded_a,
	      _ref$units_demanded_m = _ref.units_demanded_mobile_phone,
	      units_demanded_mobile_phone = _ref$units_demanded_m === undefined ? 0 : _ref$units_demanded_m,
	      _ref$growth_rate_auto = _ref.growth_rate_automobile,
	      growth_rate_automobile = _ref$growth_rate_auto === undefined ? 0 : _ref$growth_rate_auto,
	      _ref$growth_rate_mobi = _ref.growth_rate_mobile_phones,
	      growth_rate_mobile_phones = _ref$growth_rate_mobi === undefined ? 0 : _ref$growth_rate_mobi;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-xs-12 mb-20" },
	    _react2.default.createElement(
	      "div",
	      { className: "bg-white p-30" },
	      _react2.default.createElement(
	        "h4",
	        { className: "title-blue" },
	        "UNITED STATES"
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Units Demanded Automobile:",
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              prefix: " ",
	              value: units_demanded_automobile
	            })
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Growth Rate: ",
	            growth_rate_automobile,
	            "%"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Units Demanded Mobile Phones:",
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              prefix: " ",
	              value: units_demanded_mobile_phone
	            })
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Growth Rate: ",
	            growth_rate_mobile_phones,
	            "%"
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = UsInfo;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _icon_expand = __webpack_require__(689);
	
	var _icon_expand2 = _interopRequireDefault(_icon_expand);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _horizontalBar = __webpack_require__(214);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompetitiveAnalysis = function (_PureComponent) {
	  _inherits(CompetitiveAnalysis, _PureComponent);
	
	  function CompetitiveAnalysis() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CompetitiveAnalysis);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CompetitiveAnalysis.__proto__ || Object.getPrototypeOf(CompetitiveAnalysis)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CompetitiveAnalysis, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	      var url = "/ceo/analysis/competitive";
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        url = "/ceo/analysis/competitive?round=" + roundInUrl;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-analysis" },
	        _react2.default.createElement(
	          "h3",
	          { className: "semibold" },
	          "Competitive Analysis",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, _TypeformContent2.default.COMPETITIVE_ANALYSIS),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: url, className: "icon-zoom" },
	            _react2.default.createElement("img", { src: _icon_expand2.default, className: "icon", alt: "ExpandImage" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "panel-dashboard-white bg-light-gray p-15 mt-30" },
	          activeRound <= 4 && _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 no-padding col-xs-12" },
	              _react2.default.createElement(_horizontalBar2.default, {
	                suffix: "%",
	                data: this.MarketShare,
	                barSize: 20
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-center", style: { marginTop: "-20px" } },
	                "Market Share"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 no-padding col-xs-12" },
	              _react2.default.createElement(_verticalBar2.default, {
	                prefix: "$",
	                suffix: "M",
	                precision: 3,
	                data: this.Revenues
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-center", style: { marginTop: "-20px" } },
	                "Revenues"
	              )
	            )
	          ),
	          activeRound > 4 && _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 no-padding col-xs-12" },
	              _react2.default.createElement(_horizontalBar2.default, {
	                prefix: "$",
	                data: this.SharePrice,
	                barSize: 20
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-center", style: { marginTop: "-20px" } },
	                "Share Price",
	                _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                  iconSize: "xs"
	                }, _TypeformContent2.default.STOCK_PRICE))
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 no-padding col-xs-12" },
	              _react2.default.createElement(_verticalBar2.default, { prefix: "$", data: this.EarningPerShare }),
	              _react2.default.createElement(
	                "div",
	                { className: "text-center", style: { marginTop: "-20px" } },
	                "Earnings Per Share",
	                _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                  iconSize: "xs"
	                }, _TypeformContent2.default.EARNINGS_PER_SHARE))
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "EarningPerShare",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "Earnings Per Share")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "SharePrice",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this3.getDataValue(team_id, "Share Price")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "MarketShare",
	    get: function get() {
	      var _props2 = this.props,
	          teams = _props2.teams,
	          metrics = _props2.metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: metrics[team_id] && metrics[team_id]["MarketShare"] ? metrics[team_id]["MarketShare"] * 100 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "Revenues",
	    get: function get() {
	      var _props3 = this.props,
	          teams = _props3.teams,
	          metrics = _props3.metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: metrics[team_id] && metrics[team_id]["Revenues"] ? metrics[team_id]["Revenues"] / 1000000 : 0
	        });
	      });
	
	      return data;
	    }
	  }]);
	
	  return CompetitiveAnalysis;
	}(_react.PureComponent);
	
	exports.default = CompetitiveAnalysis;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 24px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 24px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 4px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 34px;\n  color: ", ";\n  margin: 0;\n"], ["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 34px;\n  color: ", ";\n  margin: 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  margin: 0;\n  max-width: 640px;\n"], ["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  margin: 0;\n  max-width: 640px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  padding: 10px 22px;\n  border-radius: 8px;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"], ["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  padding: 10px 22px;\n  border-radius: 8px;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  background: #fff;\n  color: ", ";\n  border-color: ", ";\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.3);\n    color: ", ";\n  }\n"], ["\n  background: #fff;\n  color: ", ";\n  border-color: ", ";\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.3);\n    color: ", ";\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #2A4169;\n  }\n"], ["\n  background: ", ";\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #2A4169;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  background: #fff;\n  color: ", ";\n  border-color: ", ";\n  font-size: 14px;\n  padding: 7px 16px;\n\n  &:hover:not(:disabled) {\n    background: rgba(58, 80, 123, 0.08);\n    color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  background: #fff;\n  color: ", ";\n  border-color: ", ";\n  font-size: 14px;\n  padding: 7px 16px;\n\n  &:hover:not(:disabled) {\n    background: rgba(58, 80, 123, 0.08);\n    color: ", ";\n    border-color: ", ";\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n  align-items: stretch;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n  align-items: stretch;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.06);\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0, 27, 59, 0.04);\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  min-height: 260px;\n"], ["\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.06);\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0, 27, 59, 0.04);\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  min-height: 260px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.06);\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.06);\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: ", ";\n  margin: 0;\n"], ["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: ", ";\n  margin: 0;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: ", ";\n  background: rgba(58, 80, 123, 0.08);\n  padding: 3px 10px;\n  border-radius: 12px;\n"], ["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: ", ";\n  background: rgba(58, 80, 123, 0.08);\n  padding: 3px 10px;\n  border-radius: 12px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  gap: 12px;\n\n  & + & {\n    border-top: 1px solid rgba(0, 27, 59, 0.04);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  gap: 12px;\n\n  & + & {\n    border-top: 1px solid rgba(0, 27, 59, 0.04);\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 22px;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 22px;\n  color: ", ";\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 22px;\n  color: ", ";\n  min-width: 110px;\n  text-align: right;\n"], ["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 22px;\n  color: ", ";\n  min-width: 110px;\n  text-align: right;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  border: 1.5px solid ", ";\n  border-radius: 8px;\n  padding: 7px 12px;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  color: ", ";\n  text-align: right;\n  outline: none;\n  width: 118px;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0 0 0 3px rgba(58, 80, 123, 0.12);\n  }\n"], ["\n  border: 1.5px solid ", ";\n  border-radius: 8px;\n  padding: 7px 12px;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  color: ", ";\n  text-align: right;\n  outline: none;\n  width: 118px;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0 0 0 3px rgba(58, 80, 123, 0.12);\n  }\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  padding: 7px 14px;\n  border-radius: 8px;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  min-width: 118px;\n  text-align: right;\n  background: ", ";\n  color: ", ";\n"], ["\n  padding: 7px 14px;\n  border-radius: 8px;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  min-width: 118px;\n  text-align: right;\n  background: ", ";\n  color: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReactComponents = __webpack_require__(694);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _PriceInMillions = __webpack_require__(1409);
	
	var _PriceInMillions2 = _interopRequireDefault(_PriceInMillions);
	
	var _ApiService = __webpack_require__(4);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _projectionsTour = __webpack_require__(1163);
	
	var _projectionsTour2 = _interopRequireDefault(_projectionsTour);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TOUR_STEPS = [{
	  targetId: null,
	  title: "Financial Projections",
	  body: _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      "Welcome! Quick note before we start: these projections are just estimates to help you plan and think through your decisions. Your inputs here will not impact your scores, but working through them sharpens how you think about the business."
	    )
	  )
	}, {
	  targetId: "ceo-tour-revenues-card",
	  title: "Project your revenues",
	  body: _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      "Start here. Project your revenues for the year."
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Units:"
	        ),
	        " how many units you expect to sell."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Avg. Selling Price:"
	        ),
	        " your total expected sales divided by total units expected to sell. This price can vary if there are multiple products with different pricing and units expected to sell."
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Total Revenues = Units x Avg. Selling Price."
	    )
	  )
	}, {
	  targetId: "ceo-tour-gross-profits-card",
	  title: "Project your cost of sales",
	  body: _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      "Now project what it will cost to produce those units."
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Avg. Unit Costs:"
	        ),
	        " your all-in production costs divided by the total units expected to sell. This cost can vary if there are multiple products with different costs and units expected to sell."
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Total Cost of Sales = Units x Avg. Unit Costs."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Gross Profit = Total Revenues minus Total Cost of Sales."
	    )
	  )
	}, {
	  targetId: "ceo-tour-net-profits-card",
	  title: "Project your other expenses",
	  body: _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      "Finally, project everything that falls below gross profit. The \"Other Expenses\" field is a single input that must cover the sum of six expense lines:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "R&D:"
	        ),
	        " product development spend."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Holding Expenses:"
	        ),
	        " charges for unsold inventory held either at the distribution center or at the production facility."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Promotion:"
	        ),
	        " promotional spend."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Selling:"
	        ),
	        " sales team and 3rd party distributor sales commissions."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Other G&A:"
	        ),
	        " annual depreciation on your facility and any selected distribution centers, plus breakage fees for canceling a distribution center agreement."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Interest Expense:"
	        ),
	        " interest on outstanding debt."
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Add these together and enter the total. Net Profit = Gross Profit minus Other Expenses minus Taxes."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Remember, these numbers are your best estimates. You will refine them each round as you learn more about the market. The goal is to strengthen your decision making."
	    )
	  )
	}];
	
	var postProjectionsAPI = ("https://be-production-itb.marketgames.io/api/") + "team/projections/";
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	var ACCENT = "#52C5CD";
	var ACCENT_DARK = "#3A507B";
	var INK = "rgba(0, 27, 59, 0.94)";
	var INK_MUTED = "rgba(0, 27, 59, 0.7)";
	var INK_SUBTLE = "rgba(0, 27, 59, 0.5)";
	var BORDER = "#E5E9F0";
	
	var HeaderRow = _styledComponents2.default.div(_templateObject);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject2);
	
	var TitleRow = _styledComponents2.default.div(_templateObject3);
	
	var Title = _styledComponents2.default.h1(_templateObject4, FONT, INK);
	
	var Subtitle = _styledComponents2.default.p(_templateObject5, FONT, INK_SUBTLE);
	
	var HeaderActions = _styledComponents2.default.div(_templateObject6);
	
	var ActionButton = _styledComponents2.default.button(_templateObject7, FONT);
	
	var CancelButton = (0, _styledComponents2.default)(ActionButton)(_templateObject8, INK_MUTED, BORDER, INK);
	
	var SaveButton = (0, _styledComponents2.default)(ActionButton)(_templateObject9, ACCENT_DARK);
	
	var WalkThroughButton = (0, _styledComponents2.default)(ActionButton)(_templateObject10, ACCENT_DARK, ACCENT_DARK, INK, INK);
	
	var CardsGrid = _styledComponents2.default.div(_templateObject11);
	
	var Card = _styledComponents2.default.div(_templateObject12);
	
	var CardHeader = _styledComponents2.default.div(_templateObject13);
	
	var CardTitle = _styledComponents2.default.h3(_templateObject14, FONT, INK);
	
	var YearBadge = _styledComponents2.default.span(_templateObject15, FONT, ACCENT_DARK);
	
	var Row = _styledComponents2.default.div(_templateObject16);
	
	var RowLabel = _styledComponents2.default.span(_templateObject17, FONT, INK_MUTED);
	
	var RowStaticValue = _styledComponents2.default.span(_templateObject18, FONT, INK);
	
	var ModernInput = (0, _styledComponents2.default)(_reactNumberFormat2.default)(_templateObject19, BORDER, FONT, INK, ACCENT_DARK);
	
	var TotalPill = _styledComponents2.default.div(_templateObject20, FONT, function (p) {
	  return p.subtle ? "rgba(82, 197, 205, 0.18)" : ACCENT;
	}, function (p) {
	  return p.subtle ? INK : "#fff";
	});
	
	var ProjectionsModal = function (_Component) {
	  _inherits(ProjectionsModal, _Component);
	
	  function ProjectionsModal(props) {
	    _classCallCheck(this, ProjectionsModal);
	
	    var _this = _possibleConstructorReturn(this, (ProjectionsModal.__proto__ || Object.getPrototypeOf(ProjectionsModal)).call(this, props));
	
	    _this.rerender = function () {
	      _this.forceUpdate();
	    };
	
	    _this.hideModal = function () {
	      _this.props.hideModal();
	    };
	
	    _this.showModalTour = function () {
	      // do nothing there
	    };
	
	    _this.showModal = function () {
	      if (_this.props.tourMode === true) {
	        _this.props.showModal();
	      } else if (_this.props.hasAccess === true) {
	        _this.props.showModal();
	      } else {
	        _this.props.showRoleAlert();
	      }
	    };
	
	    _this.hideAlert = function () {
	      _this.setState({
	        showAlert: false
	      });
	    };
	
	    _this.changeInputElement2 = function (e, nonFormattedValue, formatValue, maxValue) {
	      var input = e.target;
	      var value = nonFormattedValue instanceof Object && nonFormattedValue.floatValue || parseFloat(nonFormattedValue);
	      var key = input.name;
	
	      _this.changeInputElement(key, value, formatValue, maxValue);
	      _this.changeInputElement(key.replace("year1_", "year2_"), value, formatValue, maxValue);
	      _this.changeInputElement(key.replace("year1_", "year3_"), value, formatValue, maxValue);
	    };
	
	    _this.changeInputElement = function (key, value, formatValue, maxValue) {
	      var _key$split = key.split("_"),
	          _key$split2 = _toArray(_key$split),
	          year = _key$split2[0],
	          param = _key$split2.slice(1);
	
	      param = param.join("_");
	
	      if (year in _this.state) {
	        var data = _this.state[year];
	
	        value = parseFloat(value, 10);
	        if (isNaN(value)) {
	          value = 0;
	        }
	
	        if (value < 0) {
	          value = 0;
	        }
	
	        if (value > maxValue) {
	          value = maxValue;
	        }
	
	        if (formatValue === true) {
	          value *= 1000000;
	        }
	
	        data[param] = 0;
	        _this.setState(_defineProperty({}, year, data), function () {
	          data[param] = value;
	
	          _this.setState(_defineProperty({}, year, data));
	        });
	      }
	    };
	
	    _this.getInputElement = function (year_number, key, formatValue, max_value) {
	      var year = year_number - _this.props.year_number1 + 1;
	      var name = "year" + year + "_" + key;
	      var value = _this.getObjectValue(_this.getObject(year), key);
	
	      if (formatValue === true) {
	        value /= 1000000;
	
	        return _react2.default.createElement(ModernInput, {
	          thousandSeparator: ",",
	          decimalSeparator: ".",
	          decimalPrecision: 2,
	          name: name,
	          value: value,
	          onChange: function onChange(e, v) {
	            return _this.changeInputElement2(e, v, formatValue, max_value);
	          },
	          suffix: " M"
	        });
	      }
	
	      return _react2.default.createElement(ModernInput, {
	        prefix: "$",
	        thousandSeparator: ",",
	        decimalSeparator: ".",
	        decimalPrecision: 2,
	        name: name,
	        value: value,
	        onChange: function onChange(e, v) {
	          return _this.changeInputElement2(e, v, formatValue, max_value);
	        }
	      });
	    };
	
	    _this.getRequest = function (url, method) {
	      if (method === "patch") {
	        return (0, _ApiService.patchRequest)(url);
	      } else if (method === "get") {
	        return (0, _ApiService.getRequest)(url);
	      }
	
	      return (0, _ApiService.postRequest)(url);
	    };
	
	    _this.getProjectionsUrl = function (object_id) {
	      var url = postProjectionsAPI;
	      var method = "post";
	      if (object_id > 0) {
	        url += object_id + "/";
	        method = "patch";
	      }
	
	      return [url, method];
	    };
	
	    _this.getProjections = function (object_id) {
	      var _this$getProjectionsU = _this.getProjectionsUrl(object_id),
	          _this$getProjectionsU2 = _slicedToArray(_this$getProjectionsU, 2),
	          url = _this$getProjectionsU2[0],
	          method = _this$getProjectionsU2[1];
	
	      return _this.getRequest(url, method);
	    };
	
	    _this.submitData = function () {
	      if (_this.props.tourMode === true) {
	        // do nothing there
	        return;
	      }
	
	      _this.setState({
	        loading: true
	      });
	      _this.updateYear1();
	    };
	
	    _this.updateYear1 = function () {
	      _this.updateYear("year1", _this.updateYear2);
	    };
	
	    _this.updateYear2 = function () {
	      _this.updateYear("year2", _this.updateYear3);
	    };
	
	    _this.updateYear3 = function () {
	      _this.updateYear("year3", _this.closeModal);
	    };
	
	    _this.closeModal = function () {
	      _this.setState({
	        loading: false,
	        afterSave: true
	      }, function () {
	        _this.props.onSave();
	        _this.props.hideModal();
	      });
	    };
	
	    _this.updateYear = function (year, callback) {
	      var data = _this.getObject(year);
	      var units_sold = _this.getObjectValue(data, "units_sold");
	      var average_selling_price = _this.getObjectValue(data, "average_selling_price");
	      var average_unit_costs = _this.getObjectValue(data, "average_unit_costs");
	
	      if (units_sold < 1) {
	        _this.setState({
	          loading: false,
	          alertText: "Units cannot be lower then 1",
	          showAlert: true
	        });
	        return;
	      }
	
	      if (average_selling_price < 0.1) {
	        _this.setState({
	          loading: false,
	          alertText: "Average selling price cannot be lower then 0.1",
	          showAlert: true
	        });
	        return;
	      }
	
	      if (average_unit_costs < 0.1) {
	        _this.setState({
	          loading: false,
	          alertText: "Average unit costs cannot be lower then 0.1",
	          showAlert: true
	        });
	        return;
	      }
	
	      var object_value = _this.getObjectValue(data, "id");
	
	      var target_round_number = parseInt(year.replace("year", ""), 10);
	      if (isNaN(target_round_number)) {
	        target_round_number = 0;
	      }
	
	      target_round_number = target_round_number - 1 + _this.props.year_number1;
	
	      _this.getProjections(object_value).send({
	        average_selling_price: average_selling_price,
	        average_unit_costs: average_unit_costs,
	        capital_expenditures: _this.getObjectValue(data, "capital_expenditures"),
	        non_operating_expenses: _this.getObjectValue(data, "non_operating_expenses"),
	        other_operating_costs: _this.getObjectValue(data, "other_operating_costs"),
	        debt_borrowing: _this.getObjectValue(data, "debt_borrowing"),
	        units_sold: units_sold,
	        sales_costs: _this.getObjectValue(data, "sales_costs"),
	        promo_costs: _this.getObjectValue(data, "promo_costs"),
	        rnd_costs: _this.getObjectValue(data, "rnd_costs"),
	        target_round_number: target_round_number
	      }).then(function (res) {
	        callback();
	      }).catch(function (err) {
	        if ("detail" in err.response.body) {
	          var error = err.response.body["detail"];
	          _this.setState({
	            loading: false,
	            alertText: "Error: " + error + " Object: " + object_value,
	            showAlert: true
	          });
	        }
	
	        (0, _utils.logError)(err, "ModalCeoProjections", "updateYear");
	      });
	    };
	
	    _this.getUnits = function (year) {
	      return _this.getObjectValue(_this.getObject(year), "units_sold");
	    };
	
	    _this.getAvgSellingPrice = function (year) {
	      return _this.getObjectValue(_this.getObject(year), "average_selling_price");
	    };
	
	    _this.getTotalRevenues = function (year) {
	      return _this.getUnits(year) * _this.getAvgSellingPrice(year);
	    };
	
	    _this.getAvgUnitCosts = function (year) {
	      return _this.getObjectValue(_this.getObject(year), "average_unit_costs");
	    };
	
	    _this.getCostOfSales = function (year) {
	      return _this.getUnits(year) * _this.getAvgUnitCosts(year);
	    };
	
	    _this.getGrossProfits = function (year) {
	      return _this.getTotalRevenues(year) - _this.getCostOfSales(year);
	    };
	
	    _this.getTotalOperatingExpenses = function (year) {
	      return _this.getObjectValue(_this.getObject(year), "other_operating_costs");
	    };
	
	    _this.getOperatingProfits = function (year) {
	      return _this.getGrossProfits(year) - _this.getTotalOperatingExpenses(year);
	    };
	
	    _this.getNonOperatingExpenses = function (year) {
	      return _this.getObjectValue(_this.getObject(year), "non_operating_expenses");
	    };
	
	    _this.getIncomeBeforeTaxes = function (year) {
	      return _this.getOperatingProfits(year) - _this.getNonOperatingExpenses(year);
	    };
	
	    _this.getTaxes = function (year) {
	      return _this.getIncomeBeforeTaxes(year) < 0 ? 0 : _this.getIncomeBeforeTaxes(year) * 0.3 * -1;
	    };
	
	    _this.getNetIncome = function (year) {
	      return _this.getIncomeBeforeTaxes(year) - Math.abs(_this.getTaxes(year));
	    };
	
	    _this.state = {
	      year1: props.year1,
	      year2: props.year2,
	      year3: props.year3,
	      loading: false,
	      showAlert: false,
	      alertText: "",
	      currentRound: props.currentRound,
	      afterSave: false,
	      defaultValues: {
	        units_sold: 200000,
	        average_selling_price: 5,
	        average_unit_costs: 3,
	        other_operating_costs: 600000
	      }
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ProjectionsModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if ((this.state.year1 !== nextProps.year1 || this.state.year2 !== nextProps.year2 || this.state.year3 !== nextProps.year3) && (this.state.currentRound !== nextProps.currentRound || this.state.afterSave === true)) {
	        this.setState({
	          year1: nextProps.year1,
	          currentRound: nextProps.currentRound,
	          afterSave: false
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("ceo-show-modal", this.showModal);
	      this.eventemitter.on("ceo-hide-modal", this.hideModal);
	      this.eventemitter.on("ceo-force-update", this.rerender);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("ceo-show-modal", this.showModal);
	      this.eventemitter.off("ceo-hide-modal", this.hideModal);
	      this.eventemitter.off("ceo-force-update", this.rerender);
	    }
	  }, {
	    key: "getObject",
	
	
	    /**
	     * getUnits
	     */
	    value: function getObject(year) {
	      if (typeof year === "string") {
	        year = year.replace("year", "");
	        year = parseInt(year, 10);
	        if (isNaN(year)) {
	          year = 0;
	        }
	      }
	
	      return this.state["year" + year];
	    }
	  }, {
	    key: "getObjectValue",
	    value: function getObjectValue(obj, key) {
	      if (key in obj) {
	        return obj[key];
	      }
	
	      var _state = this.state,
	          currentRound = _state.currentRound,
	          defaultValues = _state.defaultValues;
	
	      if (currentRound === 1 && key in defaultValues) {
	        return defaultValues[key];
	      }
	
	      return 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          showModalState = _props.showModalState,
	          year_number1 = _props.year_number1;
	
	
	      if (!showModalState) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: this.state.showAlert,
	          title: "Error",
	          text: this.state.alertText,
	          type: "error",
	          onConfirm: this.hideAlert
	        }),
	        _react2.default.createElement(
	          _formsyReactComponents.Form,
	          { onValidSubmit: this.submitData },
	          _react2.default.createElement(
	            HeaderRow,
	            null,
	            _react2.default.createElement(
	              HeaderLeft,
	              null,
	              _react2.default.createElement(
	                TitleRow,
	                null,
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  "CEO Projections"
	                ),
	                _react2.default.createElement(
	                  WalkThroughButton,
	                  {
	                    type: "button",
	                    disabled: this.props.showTour === true,
	                    onClick: this.props.onStartTour
	                  },
	                  "Walk me through"
	                )
	              ),
	              _react2.default.createElement(
	                Subtitle,
	                null,
	                "Forecast this year's performance so lenders and investors know what to expect."
	              )
	            ),
	            _react2.default.createElement(
	              HeaderActions,
	              null,
	              this.state.loading ? _react2.default.createElement(
	                SaveButton,
	                { type: "submit", disabled: true },
	                "Saving..."
	              ) : _react2.default.createElement(
	                _reactDotFragment2.default,
	                null,
	                _react2.default.createElement(
	                  CancelButton,
	                  {
	                    type: "button",
	                    disabled: this.props.tourMode,
	                    onClick: this.hideModal
	                  },
	                  "Cancel"
	                ),
	                _react2.default.createElement(
	                  SaveButton,
	                  {
	                    type: "submit",
	                    id: "ceo-projections-save-button",
	                    disabled: this.isSaveDisabled
	                  },
	                  "Save"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            CardsGrid,
	            null,
	            _react2.default.createElement(
	              Card,
	              { id: "ceo-tour-revenues-card" },
	              _react2.default.createElement(
	                CardHeader,
	                null,
	                _react2.default.createElement(
	                  CardTitle,
	                  null,
	                  "Revenues"
	                ),
	                _react2.default.createElement(
	                  YearBadge,
	                  null,
	                  "Year ",
	                  year_number1
	                )
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Units"
	                ),
	                this.getInputElement(year_number1, "units_sold", true, 99)
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Avg. Selling Price"
	                ),
	                this.getInputElement(year_number1, "average_selling_price", false, 100)
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Total Revenues"
	                ),
	                _react2.default.createElement(
	                  TotalPill,
	                  null,
	                  _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                    value: this.totalRevenuesYear1,
	                    prefix: "$",
	                    decimalPrecision: 3,
	                    addSpaceBeforeSuffix: true,
	                    forceConvert: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Card,
	              { id: "ceo-tour-gross-profits-card" },
	              _react2.default.createElement(
	                CardHeader,
	                null,
	                _react2.default.createElement(
	                  CardTitle,
	                  null,
	                  "Gross Profits"
	                ),
	                _react2.default.createElement(
	                  YearBadge,
	                  null,
	                  "Year ",
	                  year_number1
	                )
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Units"
	                ),
	                _react2.default.createElement(
	                  RowStaticValue,
	                  null,
	                  _react2.default.createElement(_PriceInMillions2.default, {
	                    price: this.unitsYear1,
	                    prefix: "",
	                    baseClassName: "",
	                    decimalPrecision: 3,
	                    addSpaceBeforeSuffix: true
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Avg. Unit Costs"
	                ),
	                this.getInputElement(year_number1, "average_unit_costs", false, 100)
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Total Cost of Sales"
	                ),
	                _react2.default.createElement(
	                  TotalPill,
	                  { subtle: true },
	                  _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                    value: this.costOfSalesYear1,
	                    prefix: "$",
	                    decimalPrecision: 3,
	                    addSpaceBeforeSuffix: true,
	                    forceConvert: true
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Gross Profits"
	                ),
	                _react2.default.createElement(
	                  TotalPill,
	                  null,
	                  _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                    value: this.grossProfitsYear1,
	                    prefix: "$",
	                    decimalPrecision: 3,
	                    addSpaceBeforeSuffix: true,
	                    forceConvert: true
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Card,
	              { id: "ceo-tour-net-profits-card" },
	              _react2.default.createElement(
	                CardHeader,
	                null,
	                _react2.default.createElement(
	                  CardTitle,
	                  null,
	                  "Net Profits"
	                ),
	                _react2.default.createElement(
	                  YearBadge,
	                  null,
	                  "Year ",
	                  year_number1
	                )
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Other Expenses"
	                ),
	                this.getInputElement(year_number1, "other_operating_costs", true, 99)
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Income Before Taxes"
	                ),
	                _react2.default.createElement(
	                  TotalPill,
	                  { subtle: true },
	                  _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                    value: this.incomeBeforeTaxesYear1,
	                    prefix: "$",
	                    decimalPrecision: 3,
	                    addSpaceBeforeSuffix: true,
	                    forceConvert: true
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  RowLabel,
	                  null,
	                  "Net Profits"
	                ),
	                _react2.default.createElement(
	                  TotalPill,
	                  null,
	                  _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                    value: this.netIncomeYear1,
	                    prefix: "$",
	                    decimalPrecision: 3,
	                    addSpaceBeforeSuffix: true,
	                    forceConvert: true
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_projectionsTour2.default, {
	          active: this.props.showTour === true,
	          steps: TOUR_STEPS,
	          onEnd: this.props.onTourEnd
	        })
	      );
	    }
	  }, {
	    key: "isSaveDisabled",
	    get: function get() {
	      if (this.props.tourMode === false) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "unitsYear1",
	    get: function get() {
	      return this.getUnits(1);
	    }
	
	    /**
	     * getAvgSellingPrice
	     */
	
	
	    /**
	     * getTotalRevenues
	     */
	
	  }, {
	    key: "totalRevenuesYear1",
	    get: function get() {
	      return this.getTotalRevenues(1);
	    }
	
	    /**
	     * getAvgUnitCosts
	     */
	
	
	    /**
	     * getCostOfSales
	     */
	
	  }, {
	    key: "costOfSalesYear1",
	    get: function get() {
	      return this.getCostOfSales(1);
	    }
	
	    /**
	     * getGrossProfits
	     */
	
	  }, {
	    key: "grossProfitsYear1",
	    get: function get() {
	      return this.getGrossProfits(1);
	    }
	
	    /**
	     * getTotalOperatingExpenses
	     */
	
	
	    /**
	     * getOperatingProfits
	     */
	
	
	    /**
	     * getNonOperatingExpenses
	     */
	
	
	    /**
	     * getIncomeBeforeTaxes
	     */
	
	  }, {
	    key: "incomeBeforeTaxesYear1",
	    get: function get() {
	      return this.getIncomeBeforeTaxes(1);
	    }
	
	    /**
	     * getTaxes
	     */
	
	
	    /**
	     * getNetIncome
	     */
	
	  }, {
	    key: "netIncomeYear1",
	    get: function get() {
	      return this.getNetIncome(1);
	    }
	  }, {
	    key: "inputProps",
	    get: function get() {
	      return {
	        type: "text",
	        validations: {
	          isNumeric: true
	        },
	        validationErrors: {
	          isNumeric: "Only numeric values supported"
	        },
	        labelClassName: [{ "col-sm-3": false }, "hidden"],
	        elementWrapperClassName: [{ "col-sm-9": false }, "custom-error-size"],
	        rowClassName: ["form-group", "row", "projections-row"],
	        validateOnSubmit: true,
	        className: "",
	        required: true
	      };
	    }
	  }]);
	
	  return ProjectionsModal;
	}(_react.Component);
	
	exports.default = ProjectionsModal;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  box-shadow:\n    0 0 0 4px rgba(82, 197, 205, 0.9),\n    0 0 0 9999px rgba(0, 27, 59, 0.5);\n  border-radius: 14px;\n  z-index: 2000;\n  pointer-events: none;\n  transition: top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease;\n"], ["\n  position: fixed;\n  box-shadow:\n    0 0 0 4px rgba(82, 197, 205, 0.9),\n    0 0 0 9999px rgba(0, 27, 59, 0.5);\n  border-radius: 14px;\n  z-index: 2000;\n  pointer-events: none;\n  transition: top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.5);\n  z-index: 2000;\n  pointer-events: none;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.5);\n  z-index: 2000;\n  pointer-events: none;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(0, 27, 59, 0.28);\n  padding: 24px 26px;\n  width: 546px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  z-index: 2002;\n  font-family: ", ";\n  transition: top 0.2s ease, left 0.2s ease;\n"], ["\n  position: fixed;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(0, 27, 59, 0.28);\n  padding: 24px 26px;\n  width: 546px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  z-index: 2002;\n  font-family: ", ";\n  transition: top 0.2s ease, left 0.2s ease;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 13px;\n  font-weight: 600;\n  color: ", ";\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n"], ["\n  font-family: ", ";\n  font-size: 13px;\n  font-weight: 600;\n  color: ", ";\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: ", ";\n  margin: 0 0 12px;\n"], ["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: ", ";\n  margin: 0 0 12px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin: 0 0 12px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  ul {\n    margin: 0 0 12px;\n    padding-left: 20px;\n  }\n\n  li {\n    margin: 0 0 6px;\n  }\n\n  li:last-child {\n    margin-bottom: 0;\n  }\n\n  strong {\n    color: ", ";\n    font-weight: 600;\n  }\n"], ["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin: 0 0 12px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  ul {\n    margin: 0 0 12px;\n    padding-left: 20px;\n  }\n\n  li {\n    margin: 0 0 6px;\n  }\n\n  li:last-child {\n    margin-bottom: 0;\n  }\n\n  strong {\n    color: ", ";\n    font-weight: 600;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 10px;\n"], ["\n  display: flex;\n  gap: 10px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n"], ["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 15px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  background: #fff;\n  color: ", ";\n  border-color: ", ";\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.3);\n    color: ", ";\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n"], ["\n  background: #fff;\n  color: ", ";\n  border-color: ", ";\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.3);\n    color: ", ";\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: #fff;\n\n  &:hover {\n    background: #2A4169;\n  }\n"], ["\n  background: ", ";\n  color: #fff;\n\n  &:hover {\n    background: #2A4169;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  color: ", ";\n  font-family: ", ";\n  font-size: 15px;\n  cursor: pointer;\n  padding: 6px 4px;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"], ["\n  background: none;\n  border: none;\n  color: ", ";\n  font-family: ", ";\n  font-size: 15px;\n  cursor: pointer;\n  padding: 6px 4px;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	var ACCENT_DARK = "#3A507B";
	var INK = "rgba(0, 27, 59, 0.94)";
	var INK_MUTED = "rgba(0, 27, 59, 0.7)";
	var INK_SUBTLE = "rgba(0, 27, 59, 0.5)";
	var BORDER = "#E5E9F0";
	
	var Spotlight = _styledComponents2.default.div(_templateObject);
	
	var FullOverlay = _styledComponents2.default.div(_templateObject2);
	
	var Tooltip = _styledComponents2.default.div(_templateObject3, FONT);
	
	var StepIndicator = _styledComponents2.default.div(_templateObject4, FONT, INK_SUBTLE);
	
	var Title = _styledComponents2.default.h3(_templateObject5, FONT, INK);
	
	var Body = _styledComponents2.default.div(_templateObject6, FONT, INK_MUTED, INK);
	
	var Footer = _styledComponents2.default.div(_templateObject7);
	
	var ButtonRow = _styledComponents2.default.div(_templateObject8);
	
	var Button = _styledComponents2.default.button(_templateObject9, FONT);
	
	var BackButton = (0, _styledComponents2.default)(Button)(_templateObject10, INK_MUTED, BORDER, INK);
	
	var NextButton = (0, _styledComponents2.default)(Button)(_templateObject11, ACCENT_DARK);
	
	var SkipLink = _styledComponents2.default.button(_templateObject12, INK_SUBTLE, FONT, INK);
	
	var PADDING = 12;
	var TOOLTIP_WIDTH = 546;
	var TOOLTIP_HEIGHT_GUESS = 320;
	var GAP = 20;
	
	var ProjectionsTour = function (_Component) {
	  _inherits(ProjectionsTour, _Component);
	
	  function ProjectionsTour(props) {
	    _classCallCheck(this, ProjectionsTour);
	
	    var _this = _possibleConstructorReturn(this, (ProjectionsTour.__proto__ || Object.getPrototypeOf(ProjectionsTour)).call(this, props));
	
	    _this.attachListeners = function () {
	      window.addEventListener("resize", _this.measure);
	      window.addEventListener("scroll", _this.measure, true);
	    };
	
	    _this.detachListeners = function () {
	      window.removeEventListener("resize", _this.measure);
	      window.removeEventListener("scroll", _this.measure, true);
	    };
	
	    _this.measure = function () {
	      var steps = _this.props.steps;
	      var step = _this.state.step;
	
	      if (!steps || !steps[step]) return;
	
	      var currentStep = steps[step];
	
	      // Intro / outro steps that aren't tied to any card: render the
	      // tooltip centered in the viewport with the dimming overlay but
	      // no spotlight ring.
	      if (!currentStep.targetId) {
	        var _vw = window.innerWidth;
	        var _vh = window.innerHeight;
	        var _left = Math.max(PADDING, (_vw - TOOLTIP_WIDTH) / 2);
	        var _top = Math.max(PADDING, (_vh - TOOLTIP_HEIGHT_GUESS) / 2);
	        _this.setState({ targetRect: null, tooltipPos: { top: _top, left: _left } });
	        return;
	      }
	
	      var target = document.getElementById(currentStep.targetId);
	      if (!target) {
	        _this.setState({ targetRect: null });
	        return;
	      }
	
	      var rect = target.getBoundingClientRect();
	      var vw = window.innerWidth;
	      var vh = window.innerHeight;
	
	      // Preferred placement: right of the target. If the tooltip would
	      // run past the viewport on the right, try the left side of the
	      // target instead. Only fall back to a below-the-target placement
	      // when neither side has room (e.g. narrow viewports).
	      var left = rect.right + GAP;
	      var top = rect.top;
	
	      var fitsRight = left + TOOLTIP_WIDTH + PADDING <= vw;
	      if (!fitsRight) {
	        var leftOfTarget = rect.left - GAP - TOOLTIP_WIDTH;
	        if (leftOfTarget >= PADDING) {
	          left = leftOfTarget;
	          top = rect.top;
	        } else {
	          left = Math.max(PADDING, rect.left);
	          top = rect.bottom + GAP;
	        }
	      }
	
	      if (top + TOOLTIP_HEIGHT_GUESS > vh - PADDING) {
	        top = Math.max(PADDING, vh - TOOLTIP_HEIGHT_GUESS - PADDING);
	      }
	
	      _this.setState({
	        targetRect: {
	          top: rect.top,
	          left: rect.left,
	          width: rect.width,
	          height: rect.height
	        },
	        tooltipPos: { top: top, left: left }
	      });
	    };
	
	    _this.next = function () {
	      var step = _this.state.step;
	      var _this$props = _this.props,
	          steps = _this$props.steps,
	          onEnd = _this$props.onEnd;
	
	      if (step >= steps.length - 1) {
	        if (onEnd) onEnd();
	        return;
	      }
	      _this.setState({ step: step + 1 });
	    };
	
	    _this.back = function () {
	      var step = _this.state.step;
	
	      if (step <= 0) return;
	      _this.setState({ step: step - 1 });
	    };
	
	    _this.skip = function () {
	      var onEnd = _this.props.onEnd;
	
	      if (onEnd) onEnd();
	    };
	
	    _this.state = {
	      step: 0,
	      targetRect: null,
	      tooltipPos: { top: 0, left: 0 }
	    };
	    return _this;
	  }
	
	  _createClass(ProjectionsTour, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.active) {
	        this.attachListeners();
	        // Target may not be in the DOM for the first paint; measure
	        // after the modal has committed its layout.
	        this.rafId = window.requestAnimationFrame(this.measure);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (!prevProps.active && this.props.active) {
	        this.attachListeners();
	        this.setState({ step: 0 }, function () {
	          _this2.rafId = window.requestAnimationFrame(_this2.measure);
	        });
	      } else if (prevProps.active && !this.props.active) {
	        this.detachListeners();
	      } else if (prevState.step !== this.state.step && this.props.active) {
	        this.rafId = window.requestAnimationFrame(this.measure);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.detachListeners();
	      if (this.rafId) window.cancelAnimationFrame(this.rafId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          steps = _props.steps;
	      var _state = this.state,
	          step = _state.step,
	          targetRect = _state.targetRect,
	          tooltipPos = _state.tooltipPos;
	
	      if (!active || !steps || steps.length === 0) return null;
	
	      var current = steps[step];
	      if (!current) return null;
	
	      var isLast = step === steps.length - 1;
	      var isFirst = step === 0;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        targetRect ? _react2.default.createElement(Spotlight, {
	          style: {
	            top: targetRect.top - 6,
	            left: targetRect.left - 6,
	            width: targetRect.width + 12,
	            height: targetRect.height + 12
	          }
	        }) : _react2.default.createElement(FullOverlay, null),
	        _react2.default.createElement(
	          Tooltip,
	          {
	            style: {
	              top: tooltipPos.top,
	              left: tooltipPos.left
	            }
	          },
	          _react2.default.createElement(
	            StepIndicator,
	            null,
	            "Step ",
	            step + 1,
	            " of ",
	            steps.length
	          ),
	          _react2.default.createElement(
	            Title,
	            null,
	            current.title
	          ),
	          _react2.default.createElement(
	            Body,
	            null,
	            current.body
	          ),
	          _react2.default.createElement(
	            Footer,
	            null,
	            _react2.default.createElement(
	              SkipLink,
	              { onClick: this.skip },
	              "Skip tour"
	            ),
	            _react2.default.createElement(
	              ButtonRow,
	              null,
	              _react2.default.createElement(
	                BackButton,
	                { onClick: this.back, disabled: isFirst },
	                "Back"
	              ),
	              _react2.default.createElement(
	                NextButton,
	                { onClick: this.next },
	                isLast ? "Got it" : "Next"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProjectionsTour;
	}(_react.Component);
	
	exports.default = ProjectionsTour;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 1001;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  opacity: 0.4;\n  z-index: 1001;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  width: 100%;\n  max-width: 600px;\n  position: fixed;\n  z-index: 1002;\n  top: 200px;\n  left: 50%;\n  margin-left: -300px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n"], ["\n  background: #ffffff;\n  width: 100%;\n  max-width: 600px;\n  position: fixed;\n  z-index: 1002;\n  top: 200px;\n  left: 50%;\n  margin-left: -300px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  border-bottom: 1px solid #f0f0f0;\n"], ["\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  border-bottom: 1px solid #f0f0f0;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n"], ["\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  width: 100%;\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 24px;\n  align-items: flex-start;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  width: 100%;\n  border-top: 1px solid #f0f0f0;\n  padding: 10px 24px;\n  align-items: flex-start;\n  justify-content: flex-end;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  background: #5c91f5;\n  border: 1.5px solid #5c91f5;\n  border-radius: 4px;\n  color: #ffffff;\n  display: block;\n  padding: 6px 14px;\n  cursor: pointer;\n\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  background: #5c91f5;\n  border: 1.5px solid #5c91f5;\n  border-radius: 4px;\n  color: #ffffff;\n  display: block;\n  padding: 6px 14px;\n  cursor: pointer;\n\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  background: #ebf2ff;\n  padding: 12px;\n  border-radius: 4px;\n  flex: 0 0 100%;\n  width: 100%;\n\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  background: #ebf2ff;\n  padding: 12px;\n  border-radius: 4px;\n  flex: 0 0 100%;\n  width: 100%;\n\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 8px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _infoIcon = __webpack_require__(2583);
	
	var _infoIcon2 = _interopRequireDefault(_infoIcon);
	
	var _avatarIcon = __webpack_require__(2569);
	
	var _avatarIcon2 = _interopRequireDefault(_avatarIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AlertOverlay = _styledComponents2.default.div(_templateObject);
	
	var AlertWrapper = _styledComponents2.default.div(_templateObject2);
	
	var AlertTitle = _styledComponents2.default.div(_templateObject3);
	
	var AlertMessage = _styledComponents2.default.div(_templateObject4);
	
	var AlertButtons = _styledComponents2.default.div(_templateObject5);
	
	var AlertButton = _styledComponents2.default.div(_templateObject6);
	
	var AlertRow = _styledComponents2.default.div(_templateObject7);
	
	var AlertRowBody = _styledComponents2.default.div(_templateObject8);
	
	var isShown = function isShown(show, title, message1, message2, message3, onClose) {
	  return show === true && title !== "" && (message1 !== "" && message1 !== null || message2 !== "" && message2 !== null || message3 !== "" && message3 !== null) && onClose;
	};
	
	var closeAction = function closeAction(e, onClose) {
	  e.preventDefault();
	
	  onClose(e);
	};
	
	var CoachingFeedback = function CoachingFeedback(_ref) {
	  var team_color = _ref.team_color,
	      onClose = _ref.onClose,
	      title = _ref.title,
	      message1 = _ref.message1,
	      message2 = _ref.message2,
	      message3 = _ref.message3,
	      show = _ref.show;
	  return isShown(show, title, message1, message2, message3, onClose) ? _react2.default.createElement(
	    _reactDotFragment2.default,
	    null,
	    _react2.default.createElement(AlertOverlay, null),
	    _react2.default.createElement(
	      AlertWrapper,
	      null,
	      _react2.default.createElement(
	        AlertTitle,
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("img", { src: _infoIcon2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(
	        AlertMessage,
	        null,
	        message1 && _react2.default.createElement(
	          AlertRow,
	          null,
	          _react2.default.createElement(
	            AlertRowBody,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: _avatarIcon2.default, alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              message1
	            )
	          )
	        ),
	        message2 && _react2.default.createElement(
	          AlertRow,
	          null,
	          _react2.default.createElement(
	            AlertRowBody,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: _avatarIcon2.default, alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              message2
	            )
	          )
	        ),
	        message3 && _react2.default.createElement(
	          AlertRow,
	          null,
	          _react2.default.createElement(
	            AlertRowBody,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement("img", { src: _avatarIcon2.default, alt: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              message3
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        AlertButtons,
	        null,
	        _react2.default.createElement(
	          AlertButton,
	          { onClick: function onClick(e) {
	              return closeAction(e, onClose);
	            } },
	          "Ok, I got it"
	        )
	      )
	    )
	  ) : null;
	};
	
	exports.default = CoachingFeedback;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1822);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Countdown = function (_PureComponent) {
	  _inherits(Countdown, _PureComponent);
	
	  function Countdown(props) {
	    _classCallCheck(this, Countdown);
	
	    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));
	
	    _this.startTimer = function () {
	      var timer = Object.assign({}, _this.state.timer);
	      var index = 0;
	      var _this$props = _this.props,
	          rounds = _this$props.rounds,
	          currentRound = _this$props.currentRound,
	          roundInUrl = _this$props.roundInUrl;
	
	      var round_number = currentRound;
	
	      var is_previous_round = false;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        round_number = roundInUrl;
	        is_previous_round = true;
	      }
	
	      var round = rounds.find(function (i) {
	        return i.number === round_number;
	      });
	      var end_date_str = "";
	      var is_finished = false;
	      if (round) {
	        end_date_str = round.end_date;
	        is_finished = round.is_finished;
	      }
	
	      var end_date = _momentTimezone2.default.utc((0, _momentTimezone2.default)(end_date_str));
	      var time = end_date - _momentTimezone2.default.utc((0, _momentTimezone2.default)());
	
	      if (is_finished === true || is_previous_round === true) {
	        time = 0;
	      }
	
	      time = time > 0 ? time : 0;
	
	      var rings = timer.rings1;
	      var lessThanDay = false;
	      if (time <= 86400000) {
	        rings = timer.rings2;
	        lessThanDay = true;
	      }
	
	      var countdownArray = [];
	      for (var key in rings) {
	        var ring = rings[key];
	        var number = time / ring.ms;
	        if (number < 0) {
	          number = 0;
	        }
	        number = Math.floor(number);
	        countdownArray.push({ key: key, number: number, maxNumber: ring.max });
	        time = _this.drawTimer(index, key, ring, time);
	        index++;
	      }
	      _this.setState({
	        countdownArray: countdownArray,
	        lessThanDay: lessThanDay
	      });
	
	      if (_this.timer) {
	        clearTimeout(_this.timer);
	      }
	      _this.timer = setTimeout(_this.startTimer, 100);
	    };
	
	    _this.getSign = function (index, lessThanDay) {
	      switch (index) {
	        case 0:
	          return lessThanDay ? "hours" : "days";
	        case 2:
	          return lessThanDay ? "minutes" : "hours";
	        default:
	          return lessThanDay ? "seconds" : "minutes";
	      }
	    };
	
	    _this.state = {
	      timer: {
	        rings1: {
	          DAYS: {
	            max: 365,
	            ms: 86400000
	          },
	          hours: {
	            max: 24,
	            ms: 3600000
	          },
	          mins: {
	            max: 60,
	            ms: 60000
	          }
	        },
	        rings2: {
	          hours: {
	            max: 24,
	            ms: 3600000
	          },
	          mins: {
	            max: 60,
	            ms: 60000
	          },
	          secs: {
	            max: 60,
	            ms: 1000
	          }
	        }
	      },
	      countdownArray: [],
	      lessThanDay: false
	    };
	    return _this;
	  }
	
	  _createClass(Countdown, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearTimeout(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initTimer();
	    }
	  }, {
	    key: "initTimer",
	    value: function initTimer() {
	      var _this2 = this;
	
	      var timer = Object.assign({}, this.state.timer);
	
	      this.setState({
	        timer: timer
	      }, function () {
	        _this2.startTimer();
	      });
	    }
	  }, {
	    key: "drawTimer",
	    value: function drawTimer(index, text, data, time) {
	      var number = time / data.ms;
	      if (number < 0) {
	        number = 0;
	      }
	
	      var numberText = Math.floor(number);
	      return time - numberText * data.ms;
	    }
	  }, {
	    key: "renderItem",
	    value: function renderItem(item, index, lessThanDay) {
	      return index === 1 || index === 3 ? _react2.default.createElement(
	        "div",
	        { key: "countdown-item-" + index, className: "countdown-timer__number" },
	        ":"
	      ) : _react2.default.createElement(
	        "div",
	        { key: "countdown-item-" + index, className: "countdown-timer__item" },
	        _react2.default.createElement(
	          "div",
	          { className: "countdown-timer__number" },
	          ("0" + item.number).slice(-2)
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "countdown-timer__sign" },
	          this.getSign(index, lessThanDay)
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          countdownArrayRaw = _state.countdownArray,
	          lessThanDay = _state.lessThanDay;
	      var _props = this.props,
	          isMenuExpanded = _props.isMenuExpanded,
	          rounds = _props.rounds,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	      // Determine which round the sidebar deadline refers to — the
	      // roundInUrl override (if the user is viewing a specific round)
	      // or the game's current round. This mirrors the logic in
	      // startTimer above so the "not started" check and the running
	      // timer stay in sync.
	
	      var roundNumber = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        roundNumber = roundInUrl;
	      }
	      var viewedRound = (rounds || []).find(function (r) {
	        return Number(r.number) === Number(roundNumber);
	      });
	      // Show the "Round not started" placeholder when the round
	      // record doesn't exist yet (game hasn't been set up) OR when
	      // the backend hasn't flipped is_started on that round. Relying
	      // on `is_started` avoids false-positives against `game.round`,
	      // which is a manually-set pointer (updated by Activate Main
	      // Rounds) and lags behind auto-started rounds.
	      var roundNotStarted = !viewedRound || !viewedRound.is_started;
	
	      /* To insert separators  */
	      var countdownArray = [].concat(_toConsumableArray(countdownArrayRaw.slice(0, 1)), [{}], _toConsumableArray(countdownArrayRaw.slice(1, 2)), [{}], _toConsumableArray(countdownArrayRaw.slice(2, 3)));
	
	      return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)('countdown-timer', {
	            'countdown-timer__hidden': !isMenuExpanded
	          }) },
	        _react2.default.createElement(
	          "div",
	          { className: "countdown-timer__title" },
	          "Deadline Countdown"
	        ),
	        roundNotStarted ? _react2.default.createElement(
	          "div",
	          { className: "countdown-timer__not-started" },
	          "Round not started"
	        ) : _react2.default.createElement(
	          "div",
	          { className: "countdown-timer__row" },
	          countdownArray.map(function (item, index) {
	            return _this3.renderItem(item, index, lessThanDay);
	          })
	        )
	      );
	    }
	  }]);
	
	  return Countdown;
	}(_react.PureComponent);
	
	exports.default = Countdown;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadCrumbs = __webpack_require__(1124);
	
	var _BreadCrumbs2 = _interopRequireDefault(_BreadCrumbs);
	
	var _Menu = __webpack_require__(1130);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Content = __webpack_require__(1126);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _lodash = __webpack_require__(21);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Location = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dashboardStyle = {
	  width: "100%"
	};
	
	var columnsStyle = {
	  display: "flex",
	  flexDirection: "row",
	  width: "100%"
	};
	
	var menuStyle = {
	  paddingRight: 0
	};
	
	var BusinessCase = function (_Component) {
	  _inherits(BusinessCase, _Component);
	
	  function BusinessCase(props) {
	    _classCallCheck(this, BusinessCase);
	
	    var _this = _possibleConstructorReturn(this, (BusinessCase.__proto__ || Object.getPrototypeOf(BusinessCase)).call(this, props));
	
	    _this.getRound = function () {
	      var _this$state = _this.state,
	          currentRound = _this$state.currentRound,
	          roundInUrl = _this$state.roundInUrl;
	
	
	      return roundInUrl !== null ? roundInUrl : currentRound;
	    };
	
	    _this.fetchData = function () {
	      var _this$state2 = _this.state,
	          rounds = _this$state2.rounds,
	          roundInUrl = _this$state2.roundInUrl;
	
	
	      if ((!rounds || rounds.length === 0) && !roundInUrl) {
	        return;
	      }
	
	      var round = _this.getRound();
	      // Scoped endpoint returns initial_demand and constants as objects
	      // (not single-element arrays like the un-scoped payload), so no
	      // [0] indirection here. customer_preferences / customer_demand
	      // are intentionally absent. The three bcase_* scalars carry the
	      // values Executive Summary and Market used to derive from them.
	      (0, _StaticDataService.fetchAllStaticData)(round, 'business-case').then(function (data) {
	        _this.setState({
	          initialDemand: data.initialDemand,
	          salesClients: data.salesClients,
	          constants: data.constants,
	          primeRates: data.primeRates,
	          demandGrowthRate: data.demandGrowthRate,
	          features: data.features,
	          machines: data.machines,
	          debtClients: data.debtClients,
	          ratings: data.ratings,
	          comparableCompanies: data.comparableCompanies,
	          bcaseRevenueEstimate: data.bcaseRevenueEstimate,
	          bcasePriceFloor: data.bcasePriceFloor,
	          bcasePriceCeiling: data.bcasePriceCeiling
	        });
	      });
	    };
	
	    _this.goBack = function () {
	      (0, _Location.goBack)();
	    };
	
	    _this.ifLoaded = function (fields, Component) {
	      return (0, _lodash.some)(fields.filter(function (i) {
	        return i !== "roundInUrl";
	      }), function (field) {
	        return (0, _lodash.isNil)(_this.extendedState[field]);
	      }) ? _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true }) : _react2.default.createElement(Component, (0, _lodash.pick)(_this.extendedState, fields));
	    };
	
	    _this.state = Object.assign({}, _this.initialState, {
	      currentRound: "",
	      roundInUrl: props.roundInUrl,
	      rounds: []
	    });
	    return _this;
	  }
	
	  _createClass(BusinessCase, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.currentRound !== this.state.currentRound || nextProps.roundInUrl !== this.state.roundInUrl || nextProps.rounds !== this.state.rounds) {
	        this.setState({
	          currentRound: nextProps.currentRound,
	          roundInUrl: nextProps.roundInUrl,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.setState({
	        currentRound: this.props.currentRound,
	        roundInUrl: this.props.roundInUrl,
	        rounds: this.props.rounds
	      }, function () {
	        _this3.fetchData();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params;
	      var pathname = location.pathname,
	          search = location.search;
	
	      var active = (0, _lodash.isNil)(params.part) ? "" : params.part;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "dashboard", style: dashboardStyle },
	        _react2.default.createElement(_BreadCrumbs2.default, {
	          crumbs: [{ label: "Home", location: "/start" }, { label: "Analysis", location: "/analysis" }, { label: "Business Case" }]
	        }),
	        _react2.default.createElement(
	          "div",
	          { style: columnsStyle },
	          _react2.default.createElement(
	            "div",
	            { className: "team-reports-menu", style: menuStyle },
	            _react2.default.createElement(_Menu2.default, { location: pathname, search: search })
	          ),
	          _react2.default.createElement(_Content2.default, { active: active, ifLoaded: this.ifLoaded })
	        )
	      );
	    }
	  }, {
	    key: "initialState",
	    get: function get() {
	      return {
	        initialDemand: null,
	        salesClients: null,
	        constants: null,
	        primeRates: null,
	        demandGrowthRate: null,
	        features: null,
	        machines: null,
	        debtClients: null,
	        ratings: null,
	        comparableCompanies: null,
	        // Scalars pre-computed by the business-case-scoped endpoint,
	        // replacing the previous FE-side reductions over
	        // customerPreferences and customerDemand (both dropped from the
	        // scoped payload to save ~90 KB per open).
	        bcaseRevenueEstimate: null,
	        bcasePriceFloor: null,
	        bcasePriceCeiling: null
	      };
	    }
	  }, {
	    key: "extendedState",
	    get: function get() {
	      return Object.assign({}, this.state, {
	        activeRound: this.getRound(),
	        goBack: this.goBack
	      });
	    }
	  }]);
	
	  return BusinessCase;
	}(_react.Component);
	
	exports.default = BusinessCase;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _Goal = __webpack_require__(215);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CEOGoals = (0, _recompose.pure)(function (_ref) {
	  var team = _ref.team;
	  return _react2.default.createElement(_Goal2.default, {
	    name: "Financial Projections",
	    checked: team.projections_submitted === true ? true : null
	  });
	});
	
	exports.default = CEOGoals;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _utils = __webpack_require__(18);
	
	var _GreetingsText = __webpack_require__(1172);
	
	var _GreetingsText2 = _interopRequireDefault(_GreetingsText);
	
	var _HowTeamDid = __webpack_require__(1173);
	
	var _HowTeamDid2 = _interopRequireDefault(_HowTeamDid);
	
	var _TeamDecisions = __webpack_require__(1178);
	
	var _TeamDecisions2 = _interopRequireDefault(_TeamDecisions);
	
	var _FinancialTargets = __webpack_require__(399);
	
	var _FinancialTargets2 = _interopRequireDefault(_FinancialTargets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var APICalls = function APICalls(roundId, competitionId, courseId) {
	  return [
	  //{ url: 'static/constants', key: 'constants', round: false },
	  { url: "team/page/financials", key: "team", fn: function fn(body) {
	      return body.team;
	    } }, {
	    url: "team/grading",
	    key: "grades",
	    fn: function fn(body) {
	      return body.length === 0 ? {} : body[0];
	    }
	  }, { url: "teams", key: "teams", zeroItem: false }, {
	    url: "game/rounds/" + roundId + "/instructor_dashboard/?competition_id=" + competitionId,
	    key: "instructorData",
	    zeroItem: false,
	    round: false
	  }, {
	    url: "teams/unaccepted_decisions",
	    key: "unaccepted_decisions",
	    zeroItem: false
	  }, { url: "team/products", key: "products", zeroItem: false }, { url: "team/price_forecasts", key: "forecasts", zeroItem: false }, { url: "team/promos", key: "promos", zeroItem: false }, { url: "team/sales", key: "sales", zeroItem: false }, {
	    url: "v2/games/teamgradings/",
	    key: "teamGradings",
	    zeroItem: false,
	    round: false
	  }, {
	    url: "v2/games/targets/?course=" + courseId,
	    key: "financialTargets",
	    zeroItem: false,
	    round: false
	  }];
	};
	
	var Dashboard = function (_PureComponent) {
	  _inherits(Dashboard, _PureComponent);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.getCurrentCourseId = function () {
	      return _Auth2.default.getCourseId();
	    };
	
	    _this.fetchData = function () {
	      var round = _this.getRound();
	      if (_this.props.rounds.length === 0) {
	        return;
	      }
	      var competitionId = _Teams2.default.currentTeam().competition;
	      var roundData = (0, _lodash.find)(_this.props.rounds, function (r) {
	        return r.number === round;
	      });
	      var roundId = (roundData || {}).id;
	      var courseId = _this.getCurrentCourseId();
	      var apiCalls = APICalls(roundId, competitionId, courseId);
	      _this.setState({
	        competitiveAnalysisLte: null,
	        instructorData: null
	      });
	      (0, _ApiService.batchRequest)((0, _lodash.map)(apiCalls, function (call) {
	        return "" + ("https://be-production-itb.marketgames.io/api/") + call.url + {
	          false: function _false() {
	            return "";
	          },
	          undefined: function undefined() {
	            return "/?round_number=" + round;
	          },
	          lte: function lte() {
	            return "/?round_lte=" + round;
	          }
	          //'lteFinancial': () => `/?round_lte=${roundFinancial}`,
	        }[call.round]();
	      })).then(function (res) {
	        var newState = (0, _lodash.fromPairs)((0, _lodash.map)((0, _lodash.zip)(res, apiCalls), function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2),
	              body = _ref2[0].body,
	              _ref2$ = _ref2[1],
	              key = _ref2$.key,
	              zeroItem = _ref2$.zeroItem,
	              fn = _ref2$.fn;
	
	          return [key, fn ? fn(body) : !(0, _lodash.isNil)(zeroItem) && !zeroItem ? body : body[0]];
	        }));
	        _this.setState(newState);
	      });
	      // Fetch competitive analysis via MetricsService
	      (0, _MetricsService.fetchCompetitiveAnalysis)(competitionId, roundId).then(function (data) {
	        _this.setState({ competitiveAnalysis: data });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchCompetitiveAnalysis");
	      });
	      // competitiveAnalysisLte needs all rounds up to current, fetch directly
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "competition/competitive_analysis/?round_lte=" + round).then(function (_ref3) {
	        var body = _ref3.body;
	
	        _this.setState({ competitiveAnalysisLte: body });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchCompetitiveAnalysisLte");
	      });
	    };
	
	    _this.getRound = function () {
	      var _this$state = _this.state,
	          roundInUrl = _this$state.roundInUrl,
	          currentRound = _this$state.currentRound;
	
	      return roundInUrl !== null ? roundInUrl : currentRound;
	    };
	
	    _this.withRound = function (url) {
	      return "" + ("https://be-production-itb.marketgames.io/api/") + url + "/?round_number=" + _this.getRound();
	    };
	
	    _this.fetchInstructorData = function (roundId) {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "game/rounds/" + roundId + "/instructor_dashboard/";
	      var request = (0, _ApiService.getRequest)(url);
	      request.then(function (_ref4) {
	        var body = _ref4.body;
	
	        _this.setState({
	          instructorData: body
	        });
	      });
	    };
	
	    _this.fetchUnacceptedDecisions = function () {
	      var url = _this.withRound("teams/unaccepted_decisions");
	
	      if (_this.unacceptedDecisionsRequest) {
	        _this.unacceptedDecisionsRequest.abort();
	        _this.unacceptedDecisionsRequest = null;
	      }
	      _this.unacceptedDecisionsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.unacceptedDecisionsRequest.then(function (_ref5) {
	        var body = _ref5.body;
	
	        _this.setState({
	          unaccepted_decisions: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchUnacceptedDecisions");
	      });
	    };
	
	    _this.fetchBalance = function () {
	      (0, _ApiService.getRequest)(_this.withRound("team/page/financials")).then(function (_ref6) {
	        var team = _ref6.body.team;
	
	        _this.setState({
	          team: team
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchBalance");
	      });
	    };
	
	    _this.fetchTeamGrades = function () {
	      var url = _this.withRound("team/grading");
	
	      _this.teamGradeRequest = (0, _ApiService.getRequest)(url);
	
	      _this.teamGradeRequest.then(function (_ref7) {
	        var body = _ref7.body;
	
	        _this.setState({
	          grades: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchTeamGrades");
	      });
	    };
	
	    _this.fetchCompetitiveAnalysis = function () {
	      var round = _this.getRound();
	      var competitionId = _Teams2.default.currentTeam().competition;
	      var roundData = (0, _lodash.find)(_this.props.rounds, function (r) {
	        return r.number === round;
	      });
	      var roundId = (roundData || {}).id;
	
	      (0, _MetricsService.fetchCompetitiveAnalysis)(competitionId, roundId).then(function (data) {
	        _this.setState({
	          competitiveAnalysis: data
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchCompetitiveAnalysis");
	      });
	    };
	
	    _this.fetchProjections = function () {
	      var url = _this.withRound("team/projections");
	
	      if (_this.projectionsRequest) {
	        _this.projectionsRequest.abort();
	        _this.projectionsRequest = null;
	      }
	      _this.projectionsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.projectionsRequest.then(function (_ref8) {
	        var body = _ref8.body;
	
	        _this.setState({
	          projections: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchProjections");
	      });
	    };
	
	    _this.fetchProducts = function () {
	      var url = _this.withRound("team/products");
	
	      if (_this.productsRequest) {
	        _this.productsRequest.abort();
	        _this.productsRequest = null;
	      }
	      _this.productsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.productsRequest.then(function (_ref9) {
	        var body = _ref9.body;
	
	        _this.setState({
	          products: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchProducts");
	      });
	    };
	
	    _this.fetchForecasts = function () {
	      var url = _this.withRound("team/price_forecasts");
	
	      if (_this.forecastsRequest) {
	        _this.forecastsRequest.abort();
	        _this.forecastsRequest = null;
	      }
	      _this.forecastsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.forecastsRequest.then(function (_ref10) {
	        var body = _ref10.body;
	
	        _this.setState({
	          forecasts: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchForecasts");
	      });
	    };
	
	    _this.fetchPromos = function () {
	      var url = _this.withRound("team/promos");
	
	      if (_this.promosRequest) {
	        _this.promosRequest.abort();
	        _this.promosRequest = null;
	      }
	      _this.promosRequest = (0, _ApiService.getRequest)(url);
	
	      _this.promosRequest.then(function (_ref11) {
	        var body = _ref11.body;
	
	        _this.setState({
	          promos: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchPromos");
	      });
	    };
	
	    _this.fetchSales = function () {
	      var url = _this.withRound("team/sales");
	
	      if (_this.salesRequest) {
	        _this.salesRequest.abort();
	        _this.salesRequest = null;
	      }
	      _this.salesRequest = (0, _ApiService.getRequest)(url);
	
	      _this.salesRequest.then(function (_ref12) {
	        var body = _ref12.body;
	
	        _this.setState({
	          sales: body
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchSales");
	      });
	    };
	
	    _this.fetchFinancials = function () {
	      var url = _this.withRound("team/page/financials");
	
	      if (_this.financialsRequest) {
	        _this.financialsRequest.abort();
	        _this.financialsRequest = null;
	      }
	      _this.financialsRequest = (0, _ApiService.getRequest)(url);
	
	      _this.financialsRequest.then(function (_ref13) {
	        var team = _ref13.body.team;
	
	        _this.setState({
	          financials: team
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Dashboard", "fetchFinancials");
	      });
	    };
	
	    _this.state = {
	      team: {},
	      grades: null,
	      competitiveAnalysis: null,
	      projections: [],
	      products: [],
	      forecasts: [],
	      promos: [],
	      sales: [],
	      financials: {},
	      unaccepted_decisions: null,
	      teams: {},
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      instructorData: null
	    };
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var rounds = this.props.rounds;
	
	      var nextRounds = nextProps.rounds;
	      var roundsAreGood = !(0, _lodash.isNil)(rounds) && rounds.length > 0;
	      var nextRoundsAreGood = !(0, _lodash.isNil)(nextRounds) && nextRounds.length > 0;
	      if (nextProps.currentRound !== this.state.currentRound || nextProps.roundInUrl !== this.state.roundInUrl || !roundsAreGood && nextRoundsAreGood) {
	        this.setState({
	          currentRound: nextProps.currentRound,
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          team = _state.team,
	          competitiveAnalysisLte = _state.competitiveAnalysisLte,
	          grades = _state.grades,
	          instructorData = _state.instructorData,
	          unaccepted_decisions = _state.unaccepted_decisions,
	          products = _state.products,
	          forecasts = _state.forecasts,
	          promos = _state.promos,
	          sales = _state.sales,
	          financialTargets = _state.financialTargets,
	          teamGradings = _state.teamGradings;
	      var _props = this.props,
	          team_grade = _props.team_grade,
	          rounds = _props.rounds;
	
	
	      if (rounds.length === 0 || (0, _lodash.isNil)(competitiveAnalysisLte) || (0, _lodash.isNil)(instructorData) || (0, _lodash.isNil)(grades) || (0, _lodash.isNil)(instructorData)) {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true });
	      }
	
	      var _Auth$getUser = _Auth2.default.getUser(),
	          first_name = _Auth$getUser.first_name,
	          last_name = _Auth$getUser.last_name,
	          role = _Auth$getUser.role;
	
	      var round = this.getRound();
	      var isFinished = (0, _lodash.find)(rounds, function (rnd) {
	        return rnd.number === round;
	      })["is_finished"];
	      var gradeForText = grades.ranking;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "dashboard" },
	          !isFinished ? _react2.default.createElement(
	            "div",
	            { className: "dashboard-body" },
	            _react2.default.createElement(_GreetingsText2.default, {
	              team_grade: team_grade,
	              data: gradeForText,
	              round: round,
	              isFinished: isFinished,
	              role: role,
	              first_name: first_name,
	              last_name: last_name
	            }),
	            _react2.default.createElement(_FinancialTargets2.default, {
	              round: round,
	              financialTargets: financialTargets
	            }),
	            _react2.default.createElement(_TeamDecisions2.default, {
	              unaccepted_decisions: unaccepted_decisions,
	              products: products,
	              forecasts: forecasts,
	              promos: promos,
	              sales: sales,
	              team: team,
	              round: round,
	              role: role
	            })
	          ) : _react2.default.createElement(
	            "div",
	            { className: "dashboard-body" },
	            _react2.default.createElement(_GreetingsText2.default, {
	              team_grade: team_grade,
	              data: gradeForText,
	              round: round,
	              isFinished: isFinished,
	              role: role,
	              first_name: first_name,
	              last_name: last_name
	            }),
	            _react2.default.createElement(_HowTeamDid2.default, { round_number: round, teamGradings: teamGradings }),
	            _react2.default.createElement(_FinancialTargets2.default, {
	              round: round,
	              financialTargets: financialTargets
	            }),
	            _react2.default.createElement(_TeamDecisions2.default, {
	              unaccepted_decisions: unaccepted_decisions,
	              products: products,
	              forecasts: forecasts,
	              promos: promos,
	              sales: sales,
	              team: team,
	              round: round,
	              role: role
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.PureComponent);
	
	exports.default = Dashboard;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 150px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: row;\n"], ["\n  width: 100%;\n  height: 150px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: row;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  div {\n    font-family: 'Mukta Vaani';\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    color: hsla(213, 100%, 12%, 0.6);\n    text-align: right;\n  }\n\n  border-right: 2px solid #8794a3;\n  gap: 18px;\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n  padding-right: 5px;\n"], ["\n  div {\n    font-family: 'Mukta Vaani';\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    color: hsla(213, 100%, 12%, 0.6);\n    text-align: right;\n  }\n\n  border-right: 2px solid #8794a3;\n  gap: 18px;\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n  padding-right: 5px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 18px;\n  flex: 1;\n  margin-right: 40px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 18px;\n  flex: 1;\n  margin-right: 40px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 0;\n  transition: width 0.6s ease-in-out;\n\n  ", "\n\n  ", "\n\n  span {\n    font-family: Roboto;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: 1px;\n    color: hsla(213, 100%, 12%, 0.94);\n    position: relative;\n    left: calc(100% + 5px);\n  }\n"], ["\n  height: 24px;\n  width: 0;\n  transition: width 0.6s ease-in-out;\n\n  ", "\n\n  ", "\n\n  span {\n    font-family: Roboto;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: 1px;\n    color: hsla(213, 100%, 12%, 0.94);\n    position: relative;\n    left: calc(100% + 5px);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _utils = __webpack_require__(18);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var BarWrapper = _styledComponents2.default.div(_templateObject);
	
	var TextWrapper = _styledComponents2.default.div(_templateObject2);
	
	var ValueWrapper = _styledComponents2.default.div(_templateObject3);
	
	var BarValue = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.width && "\n    width: " + p.width + "%;\n  ";
	}, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	var BarValueAnimated = function (_PureComponent) {
	  _inherits(BarValueAnimated, _PureComponent);
	
	  function BarValueAnimated(props) {
	    _classCallCheck(this, BarValueAnimated);
	
	    var _this = _possibleConstructorReturn(this, (BarValueAnimated.__proto__ || Object.getPrototypeOf(BarValueAnimated)).call(this, props));
	
	    _this.state = {
	      width: 0,
	      delayed: props.width,
	      color: props.color,
	      animated: false
	    };
	    return _this;
	  }
	
	  _createClass(BarValueAnimated, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({
	          width: _this2.state.delayed
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              animated: true
	            });
	          }, 600);
	        });
	      }, 700);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          color = _state.color,
	          width = _state.width,
	          animated = _state.animated;
	
	
	      return _react2.default.createElement(
	        BarValue,
	        {
	          background: color,
	          width: width
	        },
	        animated && _react2.default.createElement(
	          "span",
	          null,
	          width,
	          "%"
	        )
	      );
	    }
	  }]);
	
	  return BarValueAnimated;
	}(_react.PureComponent);
	
	var DashboardBarChart = function (_PureComponent2) {
	  _inherits(DashboardBarChart, _PureComponent2);
	
	  function DashboardBarChart() {
	    _classCallCheck(this, DashboardBarChart);
	
	    return _possibleConstructorReturn(this, (DashboardBarChart.__proto__ || Object.getPrototypeOf(DashboardBarChart)).apply(this, arguments));
	  }
	
	  _createClass(DashboardBarChart, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          rawTeamGradings = _props.teamGradings,
	          round_number = _props.round_number;
	
	
	      var currentTeam = _Teams2.default.currentTeam();
	      var teamGradings = rawTeamGradings.results;
	      var currentGrading = teamGradings.find(function (item) {
	        return Number(item.round_number) === Number(round_number) && Number(item.team) === Number(currentTeam.id);
	      }) || {
	        weighted_value: 0,
	        highest_weighted_value: 0,
	        median_weighted_value: 0,
	        average_weighted_value: 0
	      };
	
	      var weighted_value = currentGrading.weighted_value,
	          highest_weighted_value = currentGrading.highest_weighted_value,
	          median_weighted_value = currentGrading.median_weighted_value,
	          average_weighted_value = currentGrading.average_weighted_value;
	
	
	      var teamColor = _Teams2.default.currentTeamColorLevel3();
	
	      var data = [{
	        name: "Team",
	        value: Number((0, _utils.decimalsRound)(weighted_value * 100, 2)),
	        color: teamColor
	      }, {
	        name: "Highest",
	        value: Number((0, _utils.decimalsRound)(highest_weighted_value * 100, 2)),
	        color: "hsla(213, 100%, 12%, 0.8)"
	      }, {
	        name: "Median",
	        value: Number((0, _utils.decimalsRound)(median_weighted_value * 100, 2)),
	        color: "hsla(213, 100%, 12%, 0.45)"
	      }, {
	        name: "Average",
	        value: Number((0, _utils.decimalsRound)(average_weighted_value * 100, 2)),
	        color: "hsla(213, 100%, 12%, 0.2)"
	      }];
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          BarWrapper,
	          null,
	          _react2.default.createElement(
	            TextWrapper,
	            null,
	            data.map(function (_ref, index) {
	              var name = _ref.name;
	              return _react2.default.createElement(
	                "div",
	                { key: "bar-chart-text-" + index },
	                name
	              );
	            })
	          ),
	          _react2.default.createElement(
	            ValueWrapper,
	            null,
	            data.map(function (_ref2, index) {
	              var value = _ref2.value,
	                  color = _ref2.color;
	              return _react2.default.createElement(BarValueAnimated, {
	                key: "bar-chart-value-" + index,
	                color: color,
	                width: value
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DashboardBarChart;
	}(_react.PureComponent);
	
	exports.default = DashboardBarChart;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(18);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _styles = __webpack_require__(1179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardLineChart = function (_PureComponent) {
	  _inherits(DashboardLineChart, _PureComponent);
	
	  function DashboardLineChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DashboardLineChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardLineChart.__proto__ || Object.getPrototypeOf(DashboardLineChart)).call.apply(_ref, [this].concat(args))), _this), _this.getTooltipName = function (key) {
	      switch (key) {
	        case "wv":
	          return "Team";
	        case "hvw":
	          return "Highest";
	        case "mvw":
	          return "Medium";
	        case "avw":
	          return "Average";
	        default:
	          return null;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DashboardLineChart, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          rawTeamGradings = _props.teamGradings,
	          round_number = _props.round_number;
	
	
	      var textColor = "hsla(213, 100%, 12%, 0.6)";
	      var lineColor = "hsla(213, 100%, 12%, 0.94)";
	
	      var currentTeam = _Teams2.default.currentTeam();
	
	      var teamGradings = rawTeamGradings.results;
	      var filteredTeamGrading = teamGradings.filter(function (item) {
	        return Number(item.round_number) <= Number(round_number) && Number(item.team) === Number(currentTeam.id);
	      });
	
	      var data = filteredTeamGrading.map(function (item) {
	        return {
	          name: "Year " + item.round_number,
	          wv: (0, _utils.decimalsRound)(item.weighted_value * 100, 2),
	          hvw: (0, _utils.decimalsRound)(item.highest_weighted_value * 100, 2),
	          mvw: (0, _utils.decimalsRound)(item.median_weighted_value * 100, 2),
	          avw: (0, _utils.decimalsRound)(item.average_weighted_value * 100, 2)
	        };
	      });
	      if (data.length === 0) {
	        data.push({
	          name: "Year " + round_number,
	          wv: 0,
	          hwv: 0,
	          mvw: 0,
	          avw: 0
	        });
	      }
	
	      var teamColor = _Teams2.default.currentTeamColorLevel3();
	
	      return _react2.default.createElement(
	        _recharts.ResponsiveContainer,
	        { width: "100%", height: 160 },
	        _react2.default.createElement(
	          _recharts.LineChart,
	          {
	            width: 340,
	            height: 160,
	            data: data,
	            margin: {
	              top: 5,
	              right: 10,
	              left: 10,
	              bottom: 0
	            }
	          },
	          _react2.default.createElement(_recharts.Tooltip, {
	            formatter: function formatter(value, name, props) {
	              return [value + "%", _this2.getTooltipName(name)];
	            },
	            allowEscapeViewBox: { x: true, y: true }
	          }),
	          _react2.default.createElement(_recharts.XAxis, {
	            dataKey: "name",
	            padding: { left: 20, right: 20 },
	            axisLine: { stroke: lineColor },
	            style: Object.assign({}, _styles.GraphText, { fill: textColor }),
	            tickLine: { stroke: lineColor }
	          }),
	          _react2.default.createElement(_recharts.YAxis, {
	            tickFormatter: function tickFormatter(value) {
	              return value + "%";
	            },
	            tickCount: 5,
	            interval: 0,
	            width: 30,
	            axisLine: { stroke: lineColor },
	            style: Object.assign({}, _styles.GraphText, { fill: textColor }),
	            tickLine: { stroke: lineColor }
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "wv",
	            stroke: teamColor,
	            strokeWidth: 1,
	            dot: false
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "hvw",
	            stroke: "hsla(213, 100%, 12%, 0.8)",
	            strokeWidth: 1,
	            dot: false
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "mvw",
	            stroke: "hsla(213, 100%, 12%, 0.45)",
	            strokeWidth: 1,
	            dot: false
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "avw",
	            stroke: "hsla(213, 100%, 12%, 0.2)",
	            strokeWidth: 1,
	            dot: false
	          })
	        )
	      );
	    }
	  }]);
	
	  return DashboardLineChart;
	}(_react.PureComponent);
	
	exports.default = DashboardLineChart;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _Goal = __webpack_require__(215);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIGoals = (0, _recompose.pure)(function (_ref) {
	  var team = _ref.team;
	  return _react2.default.createElement(_Goal2.default, {
	    name: "Sufficient Capital?",
	    checked: team.ending_cash && team.ending_cash >= 0 ? true : null
	  });
	});
	
	exports.default = FIGoals;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GreetingsText = function (_PureComponent) {
	  _inherits(GreetingsText, _PureComponent);
	
	  function GreetingsText() {
	    _classCallCheck(this, GreetingsText);
	
	    return _possibleConstructorReturn(this, (GreetingsText.__proto__ || Object.getPrototypeOf(GreetingsText)).apply(this, arguments));
	  }
	
	  _createClass(GreetingsText, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          round = _props.round,
	          team_grade = _props.team_grade,
	          data = _props.data,
	          isFinished = _props.isFinished,
	          role = _props.role,
	          first_name = _props.first_name,
	          last_name = _props.last_name;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "dashboard__title" },
	          "Hi ",
	          first_name,
	          " ",
	          last_name,
	          " ",
	          _react2.default.createElement(
	            "span",
	            null,
	            "(",
	            role,
	            ")"
	          )
	        ),
	        !isFinished ? _react2.default.createElement(
	          "p",
	          { className: "dashboard__text" },
	          "Below are the financial targets that your team needs to hit each year. ",
	          _react2.default.createElement(
	            "span",
	            { className: "dashboard__text_bold" },
	            "Hit all targets"
	          ),
	          " ",
	          "each year and you\u2019ll score 100%."
	        ) : _react2.default.createElement(
	          "fragment",
	          null,
	          _react2.default.createElement(
	            "p",
	            { className: "dashboard__text" },
	            "As of Year ",
	            round,
	            ", your team was ranked the",
	            " ",
	            _react2.default.createElement(
	              "span",
	              { className: "dashboard__text_highlighted" },
	              data
	            ),
	            " with a performance score of",
	            " ",
	            _react2.default.createElement(
	              "span",
	              { className: "dashboard__text_highlighted" },
	              (0, _utils.decimalsRound)(team_grade, 2),
	              "%"
	            ),
	            "!"
	          )
	        )
	      );
	    }
	  }]);
	
	  return GreetingsText;
	}(_react.PureComponent);
	
	exports.default = GreetingsText;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _roundLink = __webpack_require__(596);
	
	var _roundLink2 = _interopRequireDefault(_roundLink);
	
	var _DashboardBarChart = __webpack_require__(1169);
	
	var _DashboardBarChart2 = _interopRequireDefault(_DashboardBarChart);
	
	var _marketButton = __webpack_require__(307);
	
	var _marketButton2 = _interopRequireDefault(_marketButton);
	
	var _DashboardLineChart = __webpack_require__(1170);
	
	var _DashboardLineChart2 = _interopRequireDefault(_DashboardLineChart);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HowTeamDid = (0, _recompose.pure)(function (_ref) {
	  var teamGradings = _ref.teamGradings,
	      round_number = _ref.round_number;
	
	  var teamColor = _Teams2.default.currentTeamColorLevel3();
	
	  return _react2.default.createElement(
	    "div",
	    { className: "dashboard-summary" },
	    _react2.default.createElement(
	      "div",
	      { style: { paddingRight: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "dashboard-summary__chartHeader" },
	        _react2.default.createElement(
	          "h5",
	          null,
	          "Overall Score"
	        ),
	        _react2.default.createElement("img", { alt: "Overall Score icon help", src: _iconTableHelp2.default })
	      ),
	      _react2.default.createElement(_DashboardBarChart2.default, {
	        teamGradings: teamGradings,
	        round_number: round_number
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "dashboard-summary__chartHeader" },
	        _react2.default.createElement(
	          "h5",
	          null,
	          "Score Trend"
	        ),
	        _react2.default.createElement("img", { alt: "Score Trend icon help", src: _iconTableHelp2.default }),
	        _react2.default.createElement(
	          "div",
	          { className: "dashboard-summary__teamColor" },
	          _react2.default.createElement("div", {
	            style: {
	              width: "12px",
	              height: "2px",
	              backgroundColor: teamColor
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "dashboard-summary__teamColor_title" },
	            "Your team"
	          )
	        )
	      ),
	      _react2.default.createElement(_DashboardLineChart2.default, { teamGradings: teamGradings, round_number: round_number })
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h5",
	        { className: "dashboard-summary__title" },
	        "Year ",
	        round_number,
	        " Results"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "dashboard-summary__text" },
	        "Want to gain a better understanding of your team's performance in relative to your competitors'? Review your Team Report below."
	      ),
	      _react2.default.createElement(
	        _roundLink2.default,
	        { to: "/team-reports", round: round_number },
	        _react2.default.createElement(
	          _marketButton2.default,
	          { type: "solid", variant: "error" },
	          "See Full Team Reports"
	        )
	      )
	    )
	  );
	});
	
	exports.default = HowTeamDid;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _utils = __webpack_require__(18);
	
	var _Goal = __webpack_require__(215);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPGoals = (0, _recompose.pure)(function (_ref) {
	  var products = _ref.products;
	  return _react2.default.createElement(_Goal2.default, { name: "Production", checked: (0, _utils.isAccepted)(products) });
	});
	
	exports.default = OPGoals;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _Goal = __webpack_require__(215);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PDGoals = (0, _recompose.pure)(function (_ref) {
	  var unaccepted_decisions = _ref.unaccepted_decisions;
	  return _react2.default.createElement(_Goal2.default, {
	    name: "Product Management",
	    checked: unaccepted_decisions.PD === 0 ? true : null
	  });
	});
	
	exports.default = PDGoals;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _utils = __webpack_require__(18);
	
	var _Goal = __webpack_require__(215);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PMGoals = (0, _recompose.pure)(function (_ref) {
	  var forecasts = _ref.forecasts,
	      promos = _ref.promos,
	      sales = _ref.sales;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Goal2.default, { name: "Price", checked: (0, _utils.isAccepted)(forecasts) }),
	    _react2.default.createElement(_Goal2.default, { name: "Promotion", checked: (0, _utils.isAccepted)(promos) }),
	    _react2.default.createElement(_Goal2.default, { name: "Sales", checked: (0, _utils.isAccepted)(sales) })
	  );
	});
	
	exports.default = PMGoals;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _CEOGoals = __webpack_require__(1167);
	
	var _CEOGoals2 = _interopRequireDefault(_CEOGoals);
	
	var _PDGoals = __webpack_require__(1175);
	
	var _PDGoals2 = _interopRequireDefault(_PDGoals);
	
	var _PMGoals = __webpack_require__(1176);
	
	var _PMGoals2 = _interopRequireDefault(_PMGoals);
	
	var _OPGoals = __webpack_require__(1174);
	
	var _OPGoals2 = _interopRequireDefault(_OPGoals);
	
	var _FIGoals = __webpack_require__(1171);
	
	var _FIGoals2 = _interopRequireDefault(_FIGoals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var renderGoals = function renderGoals(role, _ref) {
	  var team = _ref.team,
	      products = _ref.products,
	      unaccepted_decisions = _ref.unaccepted_decisions,
	      forecasts = _ref.forecasts,
	      promos = _ref.promos,
	      sales = _ref.sales;
	
	  switch (role) {
	    case "CEO":
	      return _react2.default.createElement(_CEOGoals2.default, { team: team });
	    case "PD":
	      return _react2.default.createElement(_PDGoals2.default, { unaccepted_decisions: unaccepted_decisions });
	    case "PM":
	      return _react2.default.createElement(_PMGoals2.default, { forecasts: forecasts, promos: promos, sales: sales });
	    case "OP":
	      return _react2.default.createElement(_OPGoals2.default, { products: products });
	    default:
	      return _react2.default.createElement(_FIGoals2.default, { team: team });
	  }
	};
	
	var TeamDecision = (0, _recompose.pure)(function (_ref2) {
	  var name = _ref2.name,
	      role = _ref2.role,
	      props = _objectWithoutProperties(_ref2, ["name", "role"]);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "team-decision", key: name },
	    _react2.default.createElement(
	      "p",
	      { className: "team-decision__name" },
	      name
	    ),
	    renderGoals(role, props)
	  );
	});
	
	exports.default = TeamDecision;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _TeamDecision = __webpack_require__(1177);
	
	var _TeamDecision2 = _interopRequireDefault(_TeamDecision);
	
	var _Goal = __webpack_require__(215);
	
	var _Goal2 = _interopRequireDefault(_Goal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamDecisions = (0, _recompose.pure)(function (props) {
	  var roles = {
	    CEO: "CEO",
	    PD: "Head of Product",
	    PM: "Head of Marketing",
	    OP: "Head of Operations",
	    FI: "Head of Finance"
	  };
	
	  var mappedRoles = Object.keys(roles).map(function (r) {
	    return {
	      role: r,
	      name: props.role === r ? roles[r] + " (You)" : roles[r]
	    };
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: "team-decisions" },
	    _react2.default.createElement(
	      "div",
	      { className: "team-decisions__header" },
	      _react2.default.createElement(
	        "p",
	        { className: "team-decisions__title" },
	        "Decision Submission Status"
	      ),
	      _react2.default.createElement(_Goal2.default, { name: "incomplete" }),
	      _react2.default.createElement(_Goal2.default, { name: "complete", checked: true })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "team-decisions__body" },
	      mappedRoles.map(function (role) {
	        return _react2.default.createElement(_TeamDecision2.default, Object.assign({ key: role.role }, props, role));
	      })
	    )
	  );
	});
	
	exports.default = TeamDecisions;

/***/ },
/* 1179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CaptionText = {
	  fontFamily: "Mukta Vaani",
	  fontSize: "14px",
	  fontWeight: "500",
	  lineHeight: "20px",
	  fill: "hsla(213, 100%, 12%, 0.6)"
	};
	
	var GraphText = {
	  fontFamily: "Roboto",
	  fontSize: "11px",
	  fontWeight: "500",
	  lineHeight: "13px",
	  letterSpacing: "1px",
	  fill: "hsla(213, 100%, 12%, 0.94)"
	};
	
	exports.CaptionText = CaptionText;
	exports.GraphText = GraphText;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: #e5e5e5;\n  padding: 43px 62px 0;\n  width: 100%;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: #000;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"], ["\n  background: #e5e5e5;\n  padding: 43px 62px 0;\n  width: 100%;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: #000;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 100%;\n  margin-bottom: 22px;\n"], ["\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 100%;\n  margin-bottom: 22px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 18px;\n"], ["\n  font-weight: 400;\n  font-size: 18px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 35px;\n  display: flex;\n  gap: 40px;\n  max-width: 1120px;\n  align-items: stretch;\n  justify-content: space-between;\n}\n"], ["\n  margin-top: 35px;\n  display: flex;\n  gap: 40px;\n  max-width: 1120px;\n  align-items: stretch;\n  justify-content: space-between;\n}\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 22px 25px 28px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  width: calc(100% / 3 - 40px / 2);\n\n  &.blue {\n    background-color: #EBF2FF;\n  }\n  \n  &.ivory {\n    background-color: #FFF8EB;\n  }\n  \n  &.white {\n    background-color: #fff;\n  }\n"], ["\n  padding: 22px 25px 28px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  width: calc(100% / 3 - 40px / 2);\n\n  &.blue {\n    background-color: #EBF2FF;\n  }\n  \n  &.ivory {\n    background-color: #FFF8EB;\n  }\n  \n  &.white {\n    background-color: #fff;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 100%;\n  text-align: center;\n\n  &:after {\n    display: block;\n    content: '';\n    width: calc(100% - 140px);\n    height: 1px;\n    background: rgba(42, 65, 105, 0.2);\n    margin: 14px auto 10px;\n  }\n"], ["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 100%;\n  text-align: center;\n\n  &:after {\n    display: block;\n    content: '';\n    width: calc(100% - 140px);\n    height: 1px;\n    background: rgba(42, 65, 105, 0.2);\n    margin: 14px auto 10px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  margin-bottom: 19px;\n\n  &.small {\n    font-size: 14px;\n    margin-bottom: 2px;\n  }\n  \n  &.no-margin {\n    margin-bottom: 0;\n  }\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  margin-bottom: 19px;\n\n  &.small {\n    font-size: 14px;\n    margin-bottom: 2px;\n  }\n  \n  &.no-margin {\n    margin-bottom: 0;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n"], ["\n  padding: 0;\n  margin: 0;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: normal;\n  background: #fff;\n  padding: 6px 14px 3px;\n  border: 1px solid #2A4169;\n  margin-bottom: 40px;\n  position: relative;\n\n  &:after {\n    display: block;\n    content: '';\n    position: absolute;\n    bottom: -30px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 7px;\n    height: 30px;\n    background: url(", ") no-repeat center center;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n    \n  &:last-child:after {\n    display: none;\n  }\n"], ["\n  font-size: 16px;\n  line-height: normal;\n  background: #fff;\n  padding: 6px 14px 3px;\n  border: 1px solid #2A4169;\n  margin-bottom: 40px;\n  position: relative;\n\n  &:after {\n    display: block;\n    content: '';\n    position: absolute;\n    bottom: -30px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 7px;\n    height: 30px;\n    background: url(", ") no-repeat center center;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n    \n  &:last-child:after {\n    display: none;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  margin-bottom: 120px;\n"], ["\n  margin-bottom: 120px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  margin-bottom: 19px;\n"], ["\n  max-width: 100%;\n  margin-bottom: 19px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  list-style: disc;\n  margin-bottom: 0;\n  padding-left: 22px;\n"], ["\n  list-style: disc;\n  margin-bottom: 0;\n  padding-left: 22px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  line-height: normal;\n  margin-top: 10px;\n"], ["\n  line-height: normal;\n  margin-top: 10px;\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _arrowBlueDown = __webpack_require__(1837);
	
	var _arrowBlueDown2 = _interopRequireDefault(_arrowBlueDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Styled = {};
	
	Styled.BodyWrapper = _styledComponents2.default.div(_templateObject);
	
	Styled.Title = _styledComponents2.default.h2(_templateObject2);
	
	Styled.Paragraph = _styledComponents2.default.p(_templateObject3);
	
	Styled.Steps = _styledComponents2.default.div(_templateObject4);
	
	Styled.Step = _styledComponents2.default.div(_templateObject5);
	
	Styled.StepTitle = _styledComponents2.default.h3(_templateObject6);
	
	Styled.StepParagraph = _styledComponents2.default.p(_templateObject7);
	
	Styled.StepOrderItems = _styledComponents2.default.ul(_templateObject8);
	
	Styled.StepOrderItem = _styledComponents2.default.li(_templateObject9, _arrowBlueDown2.default);
	
	Styled.Gap = _styledComponents2.default.div(_templateObject10);
	
	Styled.Image = _styledComponents2.default.img(_templateObject11);
	
	Styled.List = _styledComponents2.default.ul(_templateObject12);
	
	Styled.ListItem = _styledComponents2.default.li(_templateObject13);
	
	exports.default = Styled;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getLinkClassName(location, url) {
	  var isAccurate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  //console.log(url)
	
	  var pathname = location.pathname;
	
	  var isActive = false;
	
	  if (pathname.length >= url.length && isAccurate === false && pathname.substr(0, url.length) === url) {
	    isActive = true;
	  }
	
	  if (isAccurate === true && pathname === url) {
	    isActive = true;
	  }
	  //console.log(isActive)
	  return isActive === true ? "active" : null;
	}
	
	var DecisionsWrapper = function (_React$Component) {
	  _inherits(DecisionsWrapper, _React$Component);
	
	  function DecisionsWrapper() {
	    _classCallCheck(this, DecisionsWrapper);
	
	    return _possibleConstructorReturn(this, (DecisionsWrapper.__proto__ || Object.getPrototypeOf(DecisionsWrapper)).apply(this, arguments));
	  }
	
	  _createClass(DecisionsWrapper, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          breadcrumbsTitle = _props.breadcrumbsTitle,
	          position = _props.position;
	
	
	      return _react2.default.createElement(
	        "div",
	        { style: { padding: "50px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "breadcrumbs" },
	          "Home\xA0\xA0>\xA0\xA0Decisions\xA0\xA0>\xA0\xA0",
	          _react2.default.createElement(
	            "b",
	            { style: { textTransform: "capitalize" } },
	            breadcrumbsTitle.split("/")[2].indexOf("teamoverview") > -1 ? breadcrumbsTitle.split("/")[2].split(/(?=.{8}$)/).join(" ") : breadcrumbsTitle.split("/")[2]
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "clearfix", style: { maxHeight: "300px" } },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "decisions-menu",
	              style: { border: "1px solid #DADADA", marginTop: "20px" }
	            },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/decisions/teamoverview",
	                className: getLinkClassName(location, "/decisions/teamoverview")
	              },
	              "Team Overview"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: position !== undefined ? "/decisions/" + position.toString() : null,
	                className: position !== undefined ? getLinkClassName(location, "/decisions/" + position.toString()) : null
	              },
	              position.toUpperCase()
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/decisions/product-development",
	                className: getLinkClassName(location, "/decisions/product-development")
	              },
	              "Head of Product"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/decisions/product-marketing",
	                className: getLinkClassName(location, "/decisions/product-marketing")
	              },
	              "Head of Marketing"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/decisions/operations",
	                className: getLinkClassName(location, "/decisions/operations")
	              },
	              "Head of Operations"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/decisions/finance",
	                className: getLinkClassName(location, "/decisions/finance")
	              },
	              "Head of Finance"
	            ),
	            _react2.default.createElement("hr", null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return DecisionsWrapper;
	}(_react2.default.Component);
	
	exports.default = DecisionsWrapper;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VarianceAnalysis = function (_Component) {
	  _inherits(VarianceAnalysis, _Component);
	
	  function VarianceAnalysis(props) {
	    _classCallCheck(this, VarianceAnalysis);
	
	    var _this = _possibleConstructorReturn(this, (VarianceAnalysis.__proto__ || Object.getPrototypeOf(VarianceAnalysis)).call(this, props));
	
	    _this.expandTotalCostOfSales = function () {
	      _this.setState({
	        totalCostOfSalesExpanded: true
	      });
	    };
	
	    _this.collapseTotalCostOfSales = function () {
	      _this.setState({
	        totalCostOfSalesExpanded: false
	      });
	    };
	
	    _this.expandTotalRevenues = function () {
	      _this.setState({
	        totalRevenuesExpanded: true
	      });
	    };
	
	    _this.collapseTotalRevenues = function () {
	      _this.setState({
	        totalRevenuesExpanded: false
	      });
	    };
	
	    _this.expandGrossProfits = function () {
	      _this.setState({
	        grossProfitsExpanded: true
	      });
	    };
	
	    _this.collapseGrossProfits = function () {
	      _this.setState({
	        grossProfitsExpanded: false
	      });
	    };
	
	    _this.expandNetProfits = function () {
	      _this.setState({
	        netProfitsExpanded: true
	      });
	    };
	
	    _this.collapseNetProfits = function () {
	      _this.setState({
	        netProfitsExpanded: false
	      });
	    };
	
	    _this.fetchData = function () {
	      var rounds = _this.state.rounds;
	
	
	      if (rounds.length > 0) {
	        _this.getFinancialAnalysis().then(function (res) {
	          var actual = {};
	          var expected = {};
	
	          res.body.forEach(function (item) {
	            if (item.is_actual === true) {
	              actual[item.target_round_number] = item;
	            } else {
	              expected[item.target_round_number] = item;
	            }
	          });
	
	          _this.setState({
	            actual: actual,
	            expected: expected
	          });
	        }).catch(function (err) {
	          (0, _utils.logError)(err, "VarianceAnalysis", "fetchData");
	        });
	      }
	    };
	
	    var isMobile = (0, _utils.detectMobile)();
	
	    _this.state = {
	      expected: {},
	      actual: {},
	      roundInUrl: props.roundInUrl,
	      currentRound: props.currentRound,
	      rounds: props.rounds,
	      totalRevenuesExpanded: isMobile,
	      totalCostOfSalesExpanded: isMobile,
	      grossProfitsExpanded: isMobile,
	      netProfitsExpanded: isMobile
	    };
	    return _this;
	  }
	
	  _createClass(VarianceAnalysis, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "getFinancialAnalysis",
	    value: function getFinancialAnalysis() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/financial_analysis/";
	      var _state = this.state,
	          currentRound = _state.currentRound,
	          roundInUrl = _state.roundInUrl,
	          rounds = _state.rounds;
	
	
	      var maxRound = rounds[rounds.length - 1].number;
	      var activeRound = currentRound + 1;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        activeRound = roundInUrl + 1;
	      }
	
	      if (activeRound > maxRound) {
	        activeRound = maxRound;
	      }
	
	      return (0, _ApiService.getRequest)(base_url + "?round_lte=" + activeRound);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "getActualYearParam",
	    value: function getActualYearParam(year, key) {
	      if (year in this.state.actual) {
	        var obj = this.state.actual[year];
	        if (key in obj) {
	          return obj[key];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getExpectedYearParam",
	    value: function getExpectedYearParam(year, key) {
	      if (year in this.state.expected) {
	        var obj = this.state.expected[year];
	        if (key in obj) {
	          return obj[key];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getDiffYearParam",
	    value: function getDiffYearParam(year, key, before, after) {
	      before = before || this.getExpectedYearParam(year, key);
	      after = after || this.getActualYearParam(year, key);
	
	      if (before === 0 || after === 0) {
	        return 0;
	      }
	
	      var percent = (after - before) / Math.abs(before) * 100;
	
	      return percent.toFixed(2);
	    }
	
	    /**
	     * Expected values
	     */
	
	  }, {
	    key: "getExpectedUnits",
	    value: function getExpectedUnits(year) {
	      return Math.abs(this.getExpectedYearParam(year, "units_sold"));
	    }
	  }, {
	    key: "getExpectedAvgSellingPrice",
	    value: function getExpectedAvgSellingPrice(year) {
	      return this.getExpectedYearParam(year, "average_selling_price");
	    }
	  }, {
	    key: "getExpectedTotalRevenues",
	    value: function getExpectedTotalRevenues(year) {
	      return this.getExpectedYearParam(year, "total_revenues");
	    }
	  }, {
	    key: "getExpectedAvgUnitCosts",
	    value: function getExpectedAvgUnitCosts(year) {
	      return this.getExpectedYearParam(year, "average_unit_costs");
	    }
	  }, {
	    key: "getExpectedTotalCostOfSales",
	    value: function getExpectedTotalCostOfSales(year) {
	      return this.getExpectedYearParam(year, "total_cost_goods_sold");
	    }
	  }, {
	    key: "getExpectedGrossProfits",
	    value: function getExpectedGrossProfits(year) {
	      return this.getExpectedYearParam(year, "gross_profits");
	    }
	  }, {
	    key: "getExpectedOperatingExpenses",
	    value: function getExpectedOperatingExpenses(year) {
	      return this.getExpectedYearParam(year, "total_operating_costs") + this.getExpectedYearParam(year, "total_non_operating_costs");
	    }
	  }, {
	    key: "getExpectedNonOperatingExpenses",
	    value: function getExpectedNonOperatingExpenses(year) {
	      return this.getExpectedYearParam(year, "total_non_operating_costs");
	    }
	  }, {
	    key: "getExpectedTotalIncomeBeforeTaxes",
	    value: function getExpectedTotalIncomeBeforeTaxes(year) {
	      return this.getExpectedYearParam(year, "income_before_taxes");
	    }
	  }, {
	    key: "getExpectedNetProfits",
	    value: function getExpectedNetProfits(year) {
	      return this.getExpectedYearParam(year, "net_income");
	    }
	  }, {
	    key: "getActualUnits",
	
	
	    /**
	     * Actual values
	     */
	    value: function getActualUnits(year) {
	      return Math.abs(this.getActualYearParam(year, "units_sold"));
	    }
	  }, {
	    key: "getActualAvgSellingPrice",
	    value: function getActualAvgSellingPrice(year) {
	      return this.getActualYearParam(year, "average_selling_price");
	    }
	  }, {
	    key: "getActualTotalRevenues",
	    value: function getActualTotalRevenues(year) {
	      return this.getActualYearParam(year, "total_revenues");
	    }
	  }, {
	    key: "getActualAvgUnitCosts",
	    value: function getActualAvgUnitCosts(year) {
	      return this.getActualYearParam(year, "average_unit_costs");
	    }
	  }, {
	    key: "getActualTotalCostOfSales",
	    value: function getActualTotalCostOfSales(year) {
	      return this.getActualYearParam(year, "total_cost_goods_sold");
	    }
	  }, {
	    key: "getActualGrossProfits",
	    value: function getActualGrossProfits(year) {
	      return this.getActualYearParam(year, "gross_profits");
	    }
	  }, {
	    key: "getActualOperatingExpenses",
	    value: function getActualOperatingExpenses(year) {
	      return this.getActualYearParam(year, "total_operating_costs") + this.getActualYearParam(year, "total_non_operating_costs");
	    }
	  }, {
	    key: "getActualNonOperatingExpenses",
	    value: function getActualNonOperatingExpenses(year) {
	      return this.getActualYearParam(year, "total_non_operating_costs");
	    }
	  }, {
	    key: "getActualTotalIncomeBeforeTaxes",
	    value: function getActualTotalIncomeBeforeTaxes(year) {
	      return this.getActualYearParam(year, "income_before_taxes");
	    }
	  }, {
	    key: "getActualNetProfits",
	    value: function getActualNetProfits(year) {
	      return this.getActualYearParam(year, "net_income");
	    }
	  }, {
	    key: "getDiffUnits",
	
	
	    /**
	     * Diff values
	     */
	    value: function getDiffUnits(year) {
	      return this.getDiffYearParam(null, null, this.getExpectedUnits(year), this.getActualUnits(year));
	    }
	  }, {
	    key: "getDiffAvgSellingPrice",
	    value: function getDiffAvgSellingPrice(year) {
	      return this.getDiffYearParam(year, "average_selling_price");
	    }
	  }, {
	    key: "getDiffTotalRevenues",
	    value: function getDiffTotalRevenues(year) {
	      return this.getDiffYearParam(year, "total_revenues");
	    }
	  }, {
	    key: "getDiffAvgUnitCosts",
	    value: function getDiffAvgUnitCosts(year) {
	      return -1 * this.getDiffYearParam(year, "average_unit_costs");
	    }
	  }, {
	    key: "getDiffTotalCostOfSales",
	    value: function getDiffTotalCostOfSales(year) {
	      return this.getDiffYearParam(year, "total_cost_goods_sold");
	    }
	  }, {
	    key: "getDiffGrossProfits",
	    value: function getDiffGrossProfits(year) {
	      return this.getDiffYearParam(year, "gross_profits");
	    }
	  }, {
	    key: "getDiffOperatingExpenses",
	    value: function getDiffOperatingExpenses(year) {
	      return this.getDiffYearParam(null, null, this.getExpectedOperatingExpenses(year), this.getActualOperatingExpenses(year));
	    }
	  }, {
	    key: "getDiffNonOperatingExpenses",
	    value: function getDiffNonOperatingExpenses(year) {
	      return this.getDiffYearParam(year, "total_non_operating_costs");
	    }
	  }, {
	    key: "getDiffTotalIncomeBeforeTaxes",
	    value: function getDiffTotalIncomeBeforeTaxes(year) {
	      return this.getDiffYearParam(year, "income_before_taxes");
	    }
	  }, {
	    key: "getDiffNetProfits",
	    value: function getDiffNetProfits(year) {
	      return this.getDiffYearParam(year, "net_income");
	    }
	  }, {
	    key: "getYear",
	    value: function getYear(offset) {
	      var _state2 = this.state,
	          currentRound = _state2.currentRound,
	          roundInUrl = _state2.roundInUrl,
	          rounds = _state2.rounds;
	
	
	      var current_year = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_year = roundInUrl;
	      }
	
	      var result = [current_year - 1, current_year, current_year + 1];
	      if (current_year === 1) {
	        result = [current_year, current_year + 1, current_year + 2];
	      } else if (current_year === rounds.length) {
	        result = [current_year - 2, current_year - 1, current_year];
	      }
	
	      return result[offset];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white-full" },
	        _react2.default.createElement(
	          "h5",
	          { className: "title-sky-blue" },
	          "VARIANCE ANALYSIS"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "table-responsive" },
	          _react2.default.createElement(
	            "table",
	            { className: "table border-analysis mb-20" },
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  { className: "table-title text-center" },
	                  _react2.default.createElement("span", null)
	                ),
	                _react2.default.createElement(
	                  "th",
	                  {
	                    className: "table-title text-center " + (this.year1 === this.currentYear ? "title-sky-blue" : "title-gray")
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "YEAR ",
	                    this.year1
	                  ),
	                  this.year1 === this.currentYear && _react2.default.createElement(
	                    "span",
	                    { className: "block" },
	                    "(CURRENT YEAR)"
	                  )
	                ),
	                _react2.default.createElement(
	                  "th",
	                  {
	                    className: "table-title text-center " + (this.year2 === this.currentYear ? "title-sky-blue" : "title-gray")
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "block" },
	                    "YEAR ",
	                    this.year2
	                  ),
	                  this.year2 === this.currentYear && _react2.default.createElement(
	                    "span",
	                    { className: "block" },
	                    "(CURRENT YEAR)"
	                  )
	                ),
	                _react2.default.createElement(
	                  "th",
	                  {
	                    className: "table-title text-center border-right-none " + (this.year3 === this.currentYear ? "title-sky-blue" : "title-gray")
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "YEAR ",
	                    this.year3
	                  ),
	                  this.year3 === this.currentYear && _react2.default.createElement(
	                    "span",
	                    { className: "block" },
	                    "(CURRENT YEAR)"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement("th", { className: "sub-title title-sky-blue" }),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Expected"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Actual"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "Diff"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Expected"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Actual"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "Diff"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Expected"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      "Actual"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "Diff"
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "sub-title title-sky-blue" },
	                  "Revenues"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalRevenuesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Units"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalRevenuesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Average Selling Price"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgSellingPrice1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgSellingPrice1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgSellingPrice1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgSellingPrice2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgSellingPrice2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgSellingPrice2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgSellingPrice3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgSellingPrice3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgSellingPrice3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Revenues"
	                  ),
	                  this.state.totalRevenuesExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandTotalRevenues
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseTotalRevenues
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalRevenues1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalRevenues1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalRevenues1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalRevenues2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalRevenues2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalRevenues2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalRevenues3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalRevenues3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalRevenues3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "sub-title title-sky-blue" },
	                  "Cost of Sales"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement("div", { className: "col-xs-4" }),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      "\xA0"
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalCostOfSalesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Units"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedUnits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualUnits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffUnits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && this.state.totalCostOfSalesExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Average Unit Costs"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgUnitCosts1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgUnitCosts1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgUnitCosts1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgUnitCosts2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgUnitCosts2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgUnitCosts2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedAvgUnitCosts3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualAvgUnitCosts3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffAvgUnitCosts3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.grossProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Cost of Sales"
	                  ),
	                  this.state.totalCostOfSalesExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandTotalCostOfSales
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseTotalCostOfSales
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalCostOfSales1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalCostOfSales1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalCostOfSales1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalCostOfSales2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalCostOfSales2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalCostOfSales2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalCostOfSales3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalCostOfSales3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalCostOfSales3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Gross Profits"
	                  ),
	                  this.state.grossProfitsExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandGrossProfits
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseGrossProfits
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedGrossProfits1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualGrossProfits1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffGrossProfits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedGrossProfits2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualGrossProfits2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffGrossProfits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedGrossProfits3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualGrossProfits3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffGrossProfits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.netProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  "Other Expenses"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedOperatingExpenses1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualOperatingExpenses1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffOperatingExpenses1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedOperatingExpenses2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualOperatingExpenses2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffOperatingExpenses2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedOperatingExpenses3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualOperatingExpenses3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffOperatingExpenses3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              this.state.netProfitsExpanded === true && _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Total Income Before Taxes"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalIncomeBeforeTaxes1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalIncomeBeforeTaxes1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalIncomeBeforeTaxes1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalIncomeBeforeTaxes2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalIncomeBeforeTaxes2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalIncomeBeforeTaxes2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedTotalIncomeBeforeTaxes3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualTotalIncomeBeforeTaxes3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffTotalIncomeBeforeTaxes3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tr",
	                { className: "text-center bg-gray none-shadow" },
	                _react2.default.createElement(
	                  "th",
	                  { className: "description" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Net Profits"
	                  ),
	                  this.state.netProfitsExpanded === false ? _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-plus",
	                      onClick: this.expandNetProfits
	                    },
	                    "+"
	                  ) : _react2.default.createElement(
	                    "span",
	                    {
	                      className: "fn-analysis-minus",
	                      onClick: this.collapseNetProfits
	                    },
	                    "-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedNetProfits1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualNetProfits1,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffNetProfits1,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row flex" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedNetProfits2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualNetProfits2,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffNetProfits2,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.expectedNetProfits3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.actualNetProfits3,
	                        prefix: "$",
	                        negativeClass: "title-red",
	                        forceConvert: true,
	                        hideZero: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-xs-4 make-it-bolder" },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: this.diffNetProfits3,
	                        prefix: "",
	                        negativeClass: "title-red",
	                        suffix: "%",
	                        hideZero: true
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "expectedUnits1",
	    get: function get() {
	      return this.getExpectedUnits(this.year1);
	    }
	  }, {
	    key: "expectedUnits2",
	    get: function get() {
	      return this.getExpectedUnits(this.year2);
	    }
	  }, {
	    key: "expectedUnits3",
	    get: function get() {
	      return this.getExpectedUnits(this.year3);
	    }
	  }, {
	    key: "expectedAvgSellingPrice1",
	    get: function get() {
	      return this.getExpectedAvgSellingPrice(this.year1);
	    }
	  }, {
	    key: "expectedAvgSellingPrice2",
	    get: function get() {
	      return this.getExpectedAvgSellingPrice(this.year2);
	    }
	  }, {
	    key: "expectedAvgSellingPrice3",
	    get: function get() {
	      return this.getExpectedAvgSellingPrice(this.year3);
	    }
	  }, {
	    key: "expectedTotalRevenues1",
	    get: function get() {
	      return this.getExpectedTotalRevenues(this.year1);
	    }
	  }, {
	    key: "expectedTotalRevenues2",
	    get: function get() {
	      return this.getExpectedTotalRevenues(this.year2);
	    }
	  }, {
	    key: "expectedTotalRevenues3",
	    get: function get() {
	      return this.getExpectedTotalRevenues(this.year3);
	    }
	  }, {
	    key: "expectedAvgUnitCosts1",
	    get: function get() {
	      return this.getExpectedAvgUnitCosts(this.year1);
	    }
	  }, {
	    key: "expectedAvgUnitCosts2",
	    get: function get() {
	      return this.getExpectedAvgUnitCosts(this.year2);
	    }
	  }, {
	    key: "expectedAvgUnitCosts3",
	    get: function get() {
	      return this.getExpectedAvgUnitCosts(this.year3);
	    }
	  }, {
	    key: "expectedTotalCostOfSales1",
	    get: function get() {
	      return this.getExpectedTotalCostOfSales(this.year1);
	    }
	  }, {
	    key: "expectedTotalCostOfSales2",
	    get: function get() {
	      return this.getExpectedTotalCostOfSales(this.year2);
	    }
	  }, {
	    key: "expectedTotalCostOfSales3",
	    get: function get() {
	      return this.getExpectedTotalCostOfSales(this.year3);
	    }
	  }, {
	    key: "expectedGrossProfits1",
	    get: function get() {
	      return this.getExpectedGrossProfits(this.year1);
	    }
	  }, {
	    key: "expectedGrossProfits2",
	    get: function get() {
	      return this.getExpectedGrossProfits(this.year2);
	    }
	  }, {
	    key: "expectedGrossProfits3",
	    get: function get() {
	      return this.getExpectedGrossProfits(this.year3);
	    }
	  }, {
	    key: "expectedOperatingExpenses1",
	    get: function get() {
	      return this.getExpectedOperatingExpenses(this.year1);
	    }
	  }, {
	    key: "expectedOperatingExpenses2",
	    get: function get() {
	      return this.getExpectedOperatingExpenses(this.year2);
	    }
	  }, {
	    key: "expectedOperatingExpenses3",
	    get: function get() {
	      return this.getExpectedOperatingExpenses(this.year3);
	    }
	  }, {
	    key: "expectedNonOperatingExpenses1",
	    get: function get() {
	      return this.getExpectedNonOperatingExpenses(this.year1);
	    }
	  }, {
	    key: "expectedNonOperatingExpenses2",
	    get: function get() {
	      return this.getExpectedNonOperatingExpenses(this.year2);
	    }
	  }, {
	    key: "expectedNonOperatingExpenses3",
	    get: function get() {
	      return this.getExpectedNonOperatingExpenses(this.year3);
	    }
	  }, {
	    key: "expectedTotalIncomeBeforeTaxes1",
	    get: function get() {
	      return this.getExpectedTotalIncomeBeforeTaxes(this.year1);
	    }
	  }, {
	    key: "expectedTotalIncomeBeforeTaxes2",
	    get: function get() {
	      return this.getExpectedTotalIncomeBeforeTaxes(this.year2);
	    }
	  }, {
	    key: "expectedTotalIncomeBeforeTaxes3",
	    get: function get() {
	      return this.getExpectedTotalIncomeBeforeTaxes(this.year3);
	    }
	  }, {
	    key: "expectedNetProfits1",
	    get: function get() {
	      return this.getExpectedNetProfits(this.year1);
	    }
	  }, {
	    key: "expectedNetProfits2",
	    get: function get() {
	      return this.getExpectedNetProfits(this.year2);
	    }
	  }, {
	    key: "expectedNetProfits3",
	    get: function get() {
	      return this.getExpectedNetProfits(this.year3);
	    }
	  }, {
	    key: "actualUnits1",
	    get: function get() {
	      return this.getActualUnits(this.year1);
	    }
	  }, {
	    key: "actualUnits2",
	    get: function get() {
	      return this.getActualUnits(this.year2);
	    }
	  }, {
	    key: "actualUnits3",
	    get: function get() {
	      return this.getActualUnits(this.year3);
	    }
	  }, {
	    key: "actualAvgSellingPrice1",
	    get: function get() {
	      return this.getActualAvgSellingPrice(this.year1);
	    }
	  }, {
	    key: "actualAvgSellingPrice2",
	    get: function get() {
	      return this.getActualAvgSellingPrice(this.year2);
	    }
	  }, {
	    key: "actualAvgSellingPrice3",
	    get: function get() {
	      return this.getActualAvgSellingPrice(this.year3);
	    }
	  }, {
	    key: "actualTotalRevenues1",
	    get: function get() {
	      return this.getActualTotalRevenues(this.year1);
	    }
	  }, {
	    key: "actualTotalRevenues2",
	    get: function get() {
	      return this.getActualTotalRevenues(this.year2);
	    }
	  }, {
	    key: "actualTotalRevenues3",
	    get: function get() {
	      return this.getActualTotalRevenues(this.year3);
	    }
	  }, {
	    key: "actualAvgUnitCosts1",
	    get: function get() {
	      return this.getActualAvgUnitCosts(this.year1);
	    }
	  }, {
	    key: "actualAvgUnitCosts2",
	    get: function get() {
	      return this.getActualAvgUnitCosts(this.year2);
	    }
	  }, {
	    key: "actualAvgUnitCosts3",
	    get: function get() {
	      return this.getActualAvgUnitCosts(this.year3);
	    }
	  }, {
	    key: "actualTotalCostOfSales1",
	    get: function get() {
	      return this.getActualTotalCostOfSales(this.year1);
	    }
	  }, {
	    key: "actualTotalCostOfSales2",
	    get: function get() {
	      return this.getActualTotalCostOfSales(this.year2);
	    }
	  }, {
	    key: "actualTotalCostOfSales3",
	    get: function get() {
	      return this.getActualTotalCostOfSales(this.year3);
	    }
	  }, {
	    key: "actualGrossProfits1",
	    get: function get() {
	      return this.getActualGrossProfits(this.year1);
	    }
	  }, {
	    key: "actualGrossProfits2",
	    get: function get() {
	      return this.getActualGrossProfits(this.year2);
	    }
	  }, {
	    key: "actualGrossProfits3",
	    get: function get() {
	      return this.getActualGrossProfits(this.year3);
	    }
	  }, {
	    key: "actualOperatingExpenses1",
	    get: function get() {
	      return this.getActualOperatingExpenses(this.year1);
	    }
	  }, {
	    key: "actualOperatingExpenses2",
	    get: function get() {
	      return this.getActualOperatingExpenses(this.year2);
	    }
	  }, {
	    key: "actualOperatingExpenses3",
	    get: function get() {
	      return this.getActualOperatingExpenses(this.year3);
	    }
	  }, {
	    key: "actualNonOperatingExpenses1",
	    get: function get() {
	      return this.getActualNonOperatingExpenses(this.year1);
	    }
	  }, {
	    key: "actualNonOperatingExpenses2",
	    get: function get() {
	      return this.getActualNonOperatingExpenses(this.year2);
	    }
	  }, {
	    key: "actualNonOperatingExpenses3",
	    get: function get() {
	      return this.getActualNonOperatingExpenses(this.year3);
	    }
	  }, {
	    key: "actualTotalIncomeBeforeTaxes1",
	    get: function get() {
	      return this.getActualTotalIncomeBeforeTaxes(this.year1);
	    }
	  }, {
	    key: "actualTotalIncomeBeforeTaxes2",
	    get: function get() {
	      return this.getActualTotalIncomeBeforeTaxes(this.year2);
	    }
	  }, {
	    key: "actualTotalIncomeBeforeTaxes3",
	    get: function get() {
	      return this.getActualTotalIncomeBeforeTaxes(this.year3);
	    }
	  }, {
	    key: "actualNetProfits1",
	    get: function get() {
	      return this.getActualNetProfits(this.year1);
	    }
	  }, {
	    key: "actualNetProfits2",
	    get: function get() {
	      return this.getActualNetProfits(this.year2);
	    }
	  }, {
	    key: "actualNetProfits3",
	    get: function get() {
	      return this.getActualNetProfits(this.year3);
	    }
	  }, {
	    key: "diffUnits1",
	    get: function get() {
	      return this.getDiffUnits(this.year1);
	    }
	  }, {
	    key: "diffUnits2",
	    get: function get() {
	      return this.getDiffUnits(this.year2);
	    }
	  }, {
	    key: "diffUnits3",
	    get: function get() {
	      return this.getDiffUnits(this.year3);
	    }
	  }, {
	    key: "diffAvgSellingPrice1",
	    get: function get() {
	      return this.getDiffAvgSellingPrice(this.year1);
	    }
	  }, {
	    key: "diffAvgSellingPrice2",
	    get: function get() {
	      return this.getDiffAvgSellingPrice(this.year2);
	    }
	  }, {
	    key: "diffAvgSellingPrice3",
	    get: function get() {
	      return this.getDiffAvgSellingPrice(this.year3);
	    }
	  }, {
	    key: "diffTotalRevenues1",
	    get: function get() {
	      return this.getDiffTotalRevenues(this.year1);
	    }
	  }, {
	    key: "diffTotalRevenues2",
	    get: function get() {
	      return this.getDiffTotalRevenues(this.year2);
	    }
	  }, {
	    key: "diffTotalRevenues3",
	    get: function get() {
	      return this.getDiffTotalRevenues(this.year3);
	    }
	  }, {
	    key: "diffAvgUnitCosts1",
	    get: function get() {
	      return this.getDiffAvgUnitCosts(this.year1);
	    }
	  }, {
	    key: "diffAvgUnitCosts2",
	    get: function get() {
	      return this.getDiffAvgUnitCosts(this.year2);
	    }
	  }, {
	    key: "diffAvgUnitCosts3",
	    get: function get() {
	      return this.getDiffAvgUnitCosts(this.year3);
	    }
	  }, {
	    key: "diffTotalCostOfSales1",
	    get: function get() {
	      return this.getDiffTotalCostOfSales(this.year1);
	    }
	  }, {
	    key: "diffTotalCostOfSales2",
	    get: function get() {
	      return this.getDiffTotalCostOfSales(this.year2);
	    }
	  }, {
	    key: "diffTotalCostOfSales3",
	    get: function get() {
	      return this.getDiffTotalCostOfSales(this.year3);
	    }
	  }, {
	    key: "diffGrossProfits1",
	    get: function get() {
	      return this.getDiffGrossProfits(this.year1);
	    }
	  }, {
	    key: "diffGrossProfits2",
	    get: function get() {
	      return this.getDiffGrossProfits(this.year2);
	    }
	  }, {
	    key: "diffGrossProfits3",
	    get: function get() {
	      return this.getDiffGrossProfits(this.year3);
	    }
	  }, {
	    key: "diffOperatingExpenses1",
	    get: function get() {
	      return this.getDiffOperatingExpenses(this.year1);
	    }
	  }, {
	    key: "diffOperatingExpenses2",
	    get: function get() {
	      return this.getDiffOperatingExpenses(this.year2);
	    }
	  }, {
	    key: "diffOperatingExpenses3",
	    get: function get() {
	      return this.getDiffOperatingExpenses(this.year3);
	    }
	  }, {
	    key: "diffNonOperatingExpenses1",
	    get: function get() {
	      return this.getDiffNonOperatingExpenses(this.year1);
	    }
	  }, {
	    key: "diffNonOperatingExpenses2",
	    get: function get() {
	      return this.getDiffNonOperatingExpenses(this.year2);
	    }
	  }, {
	    key: "diffNonOperatingExpenses3",
	    get: function get() {
	      return this.getDiffNonOperatingExpenses(this.year3);
	    }
	  }, {
	    key: "diffTotalIncomeBeforeTaxes1",
	    get: function get() {
	      return this.getDiffTotalIncomeBeforeTaxes(this.year1);
	    }
	  }, {
	    key: "diffTotalIncomeBeforeTaxes2",
	    get: function get() {
	      return this.getDiffTotalIncomeBeforeTaxes(this.year2);
	    }
	  }, {
	    key: "diffTotalIncomeBeforeTaxes3",
	    get: function get() {
	      return this.getDiffTotalIncomeBeforeTaxes(this.year3);
	    }
	  }, {
	    key: "diffNetProfits1",
	    get: function get() {
	      return this.getDiffNetProfits(this.year1);
	    }
	  }, {
	    key: "diffNetProfits2",
	    get: function get() {
	      return this.getDiffNetProfits(this.year2);
	    }
	  }, {
	    key: "diffNetProfits3",
	    get: function get() {
	      return this.getDiffNetProfits(this.year3);
	    }
	  }, {
	    key: "year1",
	    get: function get() {
	      return this.getYear(0);
	    }
	  }, {
	    key: "year2",
	    get: function get() {
	      return this.getYear(1);
	    }
	  }, {
	    key: "year3",
	    get: function get() {
	      return this.getYear(2);
	    }
	  }, {
	    key: "currentYear",
	    get: function get() {
	      var _state3 = this.state,
	          currentRound = _state3.currentRound,
	          roundInUrl = _state3.roundInUrl;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      return current_round;
	    }
	  }]);
	
	  return VarianceAnalysis;
	}(_react.Component);
	
	exports.default = VarianceAnalysis;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CashBalanceModal = function (_PureComponent) {
	  _inherits(CashBalanceModal, _PureComponent);
	
	  function CashBalanceModal(props) {
	    _classCallCheck(this, CashBalanceModal);
	
	    var _this = _possibleConstructorReturn(this, (CashBalanceModal.__proto__ || Object.getPrototypeOf(CashBalanceModal)).call(this, props));
	
	    _this.close = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.state = {
	      show: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(CashBalanceModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-cash-balance-modal", this.show);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-cash-balance-modal", this.show);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var show = this.state.show;
	      var _props = this.props,
	          beginningCash = _props.beginningCash,
	          ProductNMarketing = _props.ProductNMarketing,
	          operations = _props.operations,
	          financing = _props.financing,
	          cashBalance = _props.cashBalance;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          onHide: this.close,
	          dialogClassName: "modal-dialog-bigger-more fn-modal-dialog finance-decisions-modal"
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Cash Balance Reconciliation"
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive fn-decisions-cash-balance-modal" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Beginning",
	                    _react2.default.createElement("br", null),
	                    "Cash"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "table-plus-icon" },
	                    "+"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Product &",
	                    _react2.default.createElement("br", null),
	                    "Marketing Spend"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "table-plus-icon" },
	                    "+"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Operations",
	                    _react2.default.createElement("br", null),
	                    "Spend"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "table-plus-icon" },
	                    "+"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Financing"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "table-equal-icon" },
	                    "="
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Cash Balance"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: beginningCash.toFixed(0),
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ",",
	                      className: beginningCash < 0 ? 'negative' : ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "\xA0"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: ProductNMarketing.toFixed(0),
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ",",
	                      className: ProductNMarketing < 0 ? 'negative' : ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "\xA0"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: operations.toFixed(0),
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ",",
	                      className: operations < 0 ? 'negative' : ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "\xA0"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: financing.toFixed(0),
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ",",
	                      className: financing < 0 ? 'negative' : ''
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "\xA0"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: cashBalance.toFixed(0),
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ",",
	                      className: cashBalance < 0 ? 'negative' : ''
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CashBalanceModal;
	}(_react.PureComponent);
	
	exports.default = CashBalanceModal;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _reactEasyState = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberWithCommas = function numberWithCommas(val) {
	  var n = Number(val) || 0;
	  return "$" + n.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	var DEBT_COLOR = "#F5A623";
	var EQUITY_COLOR = "#5C91F5";
	
	function Chart(_ref) {
	  var _ref$debt = _ref.debt,
	      debt = _ref$debt === undefined ? 0 : _ref$debt,
	      _ref$equity = _ref.equity,
	      equity = _ref$equity === undefined ? 0 : _ref$equity,
	      _ref$debtLabel = _ref.debtLabel,
	      debtLabel = _ref$debtLabel === undefined ? "Outstanding Debt" : _ref$debtLabel,
	      _ref$equityLabel = _ref.equityLabel,
	      equityLabel = _ref$equityLabel === undefined ? "Outstanding Equity" : _ref$equityLabel;
	
	  var total = (Number(debt) || 0) + (Number(equity) || 0);
	  var data = [{ name: debtLabel, value: Math.max(0, Number(debt) || 0), color: DEBT_COLOR }, { name: equityLabel, value: Math.max(0, Number(equity) || 0), color: EQUITY_COLOR }];
	
	  var debtPct = total > 0 ? data[0].value / total * 100 : 0;
	  var equityPct = total > 0 ? data[1].value / total * 100 : 0;
	
	  return _react2.default.createElement(
	    _style2.default.DonutWrapper,
	    null,
	    _react2.default.createElement(
	      _style2.default.DonutChart,
	      null,
	      _react2.default.createElement(
	        _recharts.ResponsiveContainer,
	        { width: "100%", height: "100%" },
	        _react2.default.createElement(
	          _recharts.PieChart,
	          { margin: { top: 0, right: 0, bottom: 0, left: 0 } },
	          _react2.default.createElement(_recharts.Tooltip, { formatter: numberWithCommas }),
	          _react2.default.createElement(
	            _recharts.Pie,
	            {
	              data: data,
	              dataKey: "value",
	              nameKey: "name",
	              innerRadius: "60%",
	              outerRadius: "95%",
	              startAngle: 90,
	              endAngle: -270,
	              stroke: "#fff",
	              strokeWidth: 2
	            },
	            data.map(function (entry, i) {
	              return _react2.default.createElement(_recharts.Cell, { key: i, fill: entry.color });
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _style2.default.DonutCenter,
	        null,
	        _react2.default.createElement(
	          _style2.default.DonutCenterLabel,
	          null,
	          "Total Capital"
	        ),
	        _react2.default.createElement(
	          _style2.default.DonutCenterValue,
	          null,
	          numberWithCommas(total)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _style2.default.DonutLegend,
	      null,
	      _react2.default.createElement(
	        _style2.default.LegendRow,
	        null,
	        _react2.default.createElement(
	          _style2.default.LegendRowTop,
	          null,
	          _react2.default.createElement(_style2.default.LegendDot, { color: DEBT_COLOR }),
	          _react2.default.createElement(
	            _style2.default.LegendLabel,
	            null,
	            debtLabel
	          ),
	          _react2.default.createElement(
	            _style2.default.LegendValue,
	            null,
	            numberWithCommas(data[0].value)
	          ),
	          _react2.default.createElement(
	            _style2.default.LegendPercent,
	            null,
	            Math.round(debtPct),
	            "%"
	          )
	        ),
	        _react2.default.createElement(
	          _style2.default.LegendBar,
	          null,
	          _react2.default.createElement(_style2.default.LegendBarFill, { color: DEBT_COLOR, percentage: debtPct })
	        )
	      ),
	      _react2.default.createElement(
	        _style2.default.LegendRow,
	        null,
	        _react2.default.createElement(
	          _style2.default.LegendRowTop,
	          null,
	          _react2.default.createElement(_style2.default.LegendDot, { color: EQUITY_COLOR }),
	          _react2.default.createElement(
	            _style2.default.LegendLabel,
	            null,
	            equityLabel
	          ),
	          _react2.default.createElement(
	            _style2.default.LegendValue,
	            null,
	            numberWithCommas(data[1].value)
	          ),
	          _react2.default.createElement(
	            _style2.default.LegendPercent,
	            null,
	            Math.round(equityPct),
	            "%"
	          )
	        ),
	        _react2.default.createElement(
	          _style2.default.LegendBar,
	          null,
	          _react2.default.createElement(_style2.default.LegendBarFill, { color: EQUITY_COLOR, percentage: equityPct })
	        )
	      )
	    )
	  );
	}
	
	exports.default = (0, _reactEasyState.view)(Chart);

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  0%, 100% { transform: rotate(-2deg); }\n  50%     { transform: rotate(2deg); }\n"], ["\n  0%, 100% { transform: rotate(-2deg); }\n  50%     { transform: rotate(2deg); }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  0%   { transform: translateY(-12px); opacity: 0; }\n  20%  { opacity: 1; }\n  60%  { transform: translateY(0); opacity: 1; }\n  80%  { opacity: 1; }\n  100% { transform: translateY(0); opacity: 0; }\n"], ["\n  0%   { transform: translateY(-12px); opacity: 0; }\n  20%  { opacity: 1; }\n  60%  { transform: translateY(0); opacity: 1; }\n  80%  { opacity: 1; }\n  100% { transform: translateY(0); opacity: 0; }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateY(0); }\n  50%     { transform: translateY(-2px); }\n"], ["\n  0%, 100% { transform: translateY(0); }\n  50%     { transform: translateY(-2px); }\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  0%   { transform: scaleY(0.4); opacity: 0.4; }\n  60%  { transform: scaleY(1);   opacity: 1; }\n  100% { transform: scaleY(1);   opacity: 1; }\n"], ["\n  0%   { transform: scaleY(0.4); opacity: 0.4; }\n  60%  { transform: scaleY(1);   opacity: 1; }\n  100% { transform: scaleY(1);   opacity: 1; }\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateY(0) rotate(-1deg); }\n  50%     { transform: translateY(-1.5px) rotate(1deg); }\n"], ["\n  0%, 100% { transform: translateY(0) rotate(-1deg); }\n  50%     { transform: translateY(-1.5px) rotate(1deg); }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateY(0) scaleY(1); }\n  10%     { transform: translateY(2px) scaleY(1.3); }\n  20%     { transform: translateY(0) scaleY(1); }\n"], ["\n  0%, 100% { transform: translateY(0) scaleY(1); }\n  10%     { transform: translateY(2px) scaleY(1.3); }\n  20%     { transform: translateY(0) scaleY(1); }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: inherit;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: inherit;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  transform-origin: 32px 38px;\n  animation: ", " 3.4s ease-in-out infinite;\n"], ["\n  transform-origin: 32px 38px;\n  animation: ", " 3.4s ease-in-out infinite;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  animation: ", " 2.6s ease-in-out infinite;\n"], ["\n  transform-origin: center;\n  animation: ", " 2.6s ease-in-out infinite;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  transform-origin: 32px 50px;\n  transform-box: fill-box;\n  animation: ", " 2.8s ease-out infinite;\n"], ["\n  transform-origin: 32px 50px;\n  transform-box: fill-box;\n  animation: ", " 2.8s ease-out infinite;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  animation: ", " 3.2s ease-in-out infinite;\n"], ["\n  transform-origin: center;\n  animation: ", " 3.2s ease-in-out infinite;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  transform-origin: 32px 36px;\n  transform-box: fill-box;\n  animation: ", " 2.4s ease-in-out infinite;\n"], ["\n  transform-origin: 32px 36px;\n  transform-box: fill-box;\n  animation: ", " 2.4s ease-in-out infinite;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -3px;\n  width: 12px;\n  height: 12px;\n  transform: translateX(-50%);\n\n  &:hover > span.ratio-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: absolute;\n  top: -3px;\n  width: 12px;\n  height: 12px;\n  transform: translateX(-50%);\n\n  &:hover > span.ratio-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.94);\n  border: 2px solid #fff;\n"], ["\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.94);\n  border: 2px solid #fff;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-10px);\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.12);\n  color: rgba(0, 27, 59, 0.94);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 8px 14px;\n  border-radius: 6px;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 27, 59, 0.15);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-top-color: #fff;\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-10px);\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.12);\n  color: rgba(0, 27, 59, 0.94);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 8px 14px;\n  border-radius: 6px;\n  white-space: nowrap;\n  box-shadow: 0 4px 12px rgba(0, 27, 59, 0.15);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-top-color: #fff;\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n\n  &:hover > span.lender-info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n\n  &:hover > span.lender-info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 20;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 20;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Subtle on-card animations, one personality per lender risk tier.
	// Slow durations (2.5-3.5s) so the motion stays in the background.
	var piggyBob = (0, _styledComponents.keyframes)(_templateObject);
	
	var coinDrop = (0, _styledComponents.keyframes)(_templateObject2);
	
	var briefcaseLift = (0, _styledComponents.keyframes)(_templateObject3);
	
	var arrowGrow = (0, _styledComponents.keyframes)(_templateObject4);
	
	var sharkSwim = (0, _styledComponents.keyframes)(_templateObject5);
	
	var sharkJaw = (0, _styledComponents.keyframes)(_templateObject6);
	
	// 56×56 slot in the card, matches Styled.LenderLogo's footprint.
	// overflow: hidden so the shark's tail / coin drop don't bleed past
	// the rounded edge.
	var LenderArtFrame = _styledComponents2.default.div(_templateObject7);
	
	var PiggyBob = _styledComponents2.default.g(_templateObject8, piggyBob);
	
	var PiggyCoin = _styledComponents2.default.g(_templateObject9, coinDrop);
	
	var BriefcaseLift = _styledComponents2.default.g(_templateObject9, briefcaseLift);
	
	var ArrowGrow = _styledComponents2.default.g(_templateObject10, arrowGrow);
	
	var SharkSwim = _styledComponents2.default.g(_templateObject11, sharkSwim);
	
	var SharkJaw = _styledComponents2.default.g(_templateObject12, sharkJaw);
	
	function PiggyBankArt() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 64 64", width: "48", height: "48", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      PiggyCoin,
	      null,
	      _react2.default.createElement("circle", { cx: "32", cy: "12", r: "3.5", fill: "#F2B900", stroke: "#2DA548", strokeWidth: "1" }),
	      _react2.default.createElement(
	        "text",
	        { x: "32", y: "14.2", fontSize: "4", fontFamily: "Mukta Vaani, Lato, sans-serif",
	          fontWeight: "700", textAnchor: "middle", fill: "#2DA548" },
	        "$"
	      )
	    ),
	    _react2.default.createElement(
	      PiggyBob,
	      null,
	      _react2.default.createElement("rect", { x: "29", y: "22", width: "6", height: "2", rx: "0.5", fill: "#1A6F30" }),
	      _react2.default.createElement("ellipse", { cx: "32", cy: "40", rx: "20", ry: "14", fill: "#A6E4B7", stroke: "#2DA548", strokeWidth: "1.6" }),
	      _react2.default.createElement("path", { d: "M22 28 L 25 24 L 27 30 Z", fill: "#A6E4B7", stroke: "#2DA548", strokeWidth: "1.2" }),
	      _react2.default.createElement("ellipse", { cx: "50", cy: "40", rx: "5", ry: "4", fill: "#86D69D", stroke: "#2DA548", strokeWidth: "1.2" }),
	      _react2.default.createElement("circle", { cx: "49", cy: "39", r: "0.8", fill: "#1A6F30" }),
	      _react2.default.createElement("circle", { cx: "51", cy: "40.5", r: "0.8", fill: "#1A6F30" }),
	      _react2.default.createElement("circle", { cx: "38", cy: "36", r: "1.5", fill: "#1A6F30" }),
	      _react2.default.createElement("circle", { cx: "38.5", cy: "35.5", r: "0.5", fill: "#FFFFFF" }),
	      _react2.default.createElement("rect", { x: "22", y: "52", width: "4", height: "6", rx: "1", fill: "#86D69D", stroke: "#2DA548", strokeWidth: "1" }),
	      _react2.default.createElement("rect", { x: "38", y: "52", width: "4", height: "6", rx: "1", fill: "#86D69D", stroke: "#2DA548", strokeWidth: "1" }),
	      _react2.default.createElement("path", { d: "M14 36 Q 10 36 12 32", fill: "none", stroke: "#2DA548", strokeWidth: "1.6", strokeLinecap: "round" })
	    )
	  );
	}
	
	function BriefcaseChartArt() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 64 64", width: "48", height: "48", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      BriefcaseLift,
	      null,
	      _react2.default.createElement("rect", { x: "26", y: "16", width: "12", height: "6", rx: "2", fill: "none", stroke: "#B17F00", strokeWidth: "1.6" }),
	      _react2.default.createElement("rect", { x: "12", y: "22", width: "40", height: "28", rx: "3", fill: "#FFE08A", stroke: "#B17F00", strokeWidth: "1.6" }),
	      _react2.default.createElement("rect", { x: "29", y: "30", width: "6", height: "4", rx: "0.5", fill: "#B17F00" }),
	      _react2.default.createElement("rect", { x: "16", y: "38", width: "32", height: "10", rx: "1", fill: "#FFFFFF", stroke: "#B17F00", strokeWidth: "1" }),
	      _react2.default.createElement(
	        ArrowGrow,
	        null,
	        _react2.default.createElement("path", { d: "M18 46 L 26 42 L 32 44 L 40 38", fill: "none",
	          stroke: "#1A6F30", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
	        _react2.default.createElement("path", { d: "M37 38 L 42 38 L 42 41", fill: "none",
	          stroke: "#1A6F30", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
	      )
	    )
	  );
	}
	
	function SharkSuitArt() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 64 64", width: "48", height: "48", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      SharkSwim,
	      null,
	      _react2.default.createElement("path", { d: "M10 60 L 18 44 L 32 48 L 46 44 L 54 60 Z",
	        fill: "#1A1F2B", stroke: "#0D1119", strokeWidth: "1" }),
	      _react2.default.createElement("path", { d: "M26 44 L 32 56 L 38 44 L 36 42 L 32 46 L 28 42 Z",
	        fill: "#FFFFFF", stroke: "#2A3E55", strokeWidth: "0.6" }),
	      _react2.default.createElement("path", { d: "M30.5 42 L 33.5 42 L 34 46 L 32 56 L 30 46 Z",
	        fill: "#EC5E59", stroke: "#A8403E", strokeWidth: "0.5" }),
	      _react2.default.createElement("path", { d: "M30.5 42 L 33.5 42 L 33.2 44 L 30.8 44 Z", fill: "#A8403E" }),
	      _react2.default.createElement("path", { d: "M14 38 L 6 44 L 12 46 Z",
	        fill: "#6B8FAB", stroke: "#2A3E55", strokeWidth: "1" }),
	      _react2.default.createElement("path", { d: "M50 38 L 58 44 L 52 46 Z",
	        fill: "#6B8FAB", stroke: "#2A3E55", strokeWidth: "1" }),
	      _react2.default.createElement("path", { d: "M14 18 Q 32 6 50 18 L 46 38 Q 32 46 18 38 Z",
	        fill: "#8FB0CC", stroke: "#2A3E55", strokeWidth: "1.4" }),
	      _react2.default.createElement("path", { d: "M20 34 Q 32 42 44 34 L 42 38 Q 32 44 22 38 Z",
	        fill: "#D0DEEA" }),
	      _react2.default.createElement("path", { d: "M30 10 L 32 4 L 34 10 Z",
	        fill: "#6B8FAB", stroke: "#2A3E55", strokeWidth: "1" }),
	      _react2.default.createElement("path", { d: "M18 26 L 20 28 M 18 29 L 20 31", stroke: "#2A3E55", strokeWidth: "0.6" }),
	      _react2.default.createElement("path", { d: "M46 26 L 44 28 M 46 29 L 44 31", stroke: "#2A3E55", strokeWidth: "0.6" }),
	      _react2.default.createElement("ellipse", { cx: "24", cy: "22", rx: "3", ry: "2.6", fill: "#FFFFFF", stroke: "#2A3E55", strokeWidth: "0.8" }),
	      _react2.default.createElement("ellipse", { cx: "40", cy: "22", rx: "3", ry: "2.6", fill: "#FFFFFF", stroke: "#2A3E55", strokeWidth: "0.8" }),
	      _react2.default.createElement("circle", { cx: "24.5", cy: "22.2", r: "1.3", fill: "#1A1F2B" }),
	      _react2.default.createElement("circle", { cx: "40.5", cy: "22.2", r: "1.3", fill: "#1A1F2B" }),
	      _react2.default.createElement("circle", { cx: "25", cy: "21.6", r: "0.4", fill: "#FFFFFF" }),
	      _react2.default.createElement("circle", { cx: "41", cy: "21.6", r: "0.4", fill: "#FFFFFF" }),
	      _react2.default.createElement("path", { d: "M20 18 L 27 19 M 37 19 L 44 18",
	        fill: "none", stroke: "#2A3E55", strokeWidth: "1.2", strokeLinecap: "round" }),
	      _react2.default.createElement(
	        SharkJaw,
	        null,
	        _react2.default.createElement("path", { d: "M22 32 Q 32 36 42 32 L 42 36 Q 32 41 22 36 Z",
	          fill: "#1A1F2B", stroke: "#2A3E55", strokeWidth: "0.8" }),
	        _react2.default.createElement("path", { d: "M23 33 L 25 36 L 27 33 L 29 36 L 31 33 L 33 36 L 35 33 L 37 36 L 39 33 L 41 36",
	          fill: "#FFFFFF", stroke: "#FFFFFF", strokeWidth: "0.5" }),
	        _react2.default.createElement("path", { d: "M23 33 L 25 36 L 27 33 L 29 36 L 31 33 L 33 36 L 35 33 L 37 36 L 39 33 L 41 36",
	          fill: "none", stroke: "#2A3E55", strokeWidth: "0.4" }),
	        _react2.default.createElement("path", { d: "M24 39 L 26 36.5 L 28 39 L 30 36.5 L 32 39 L 34 36.5 L 36 39 L 38 36.5 L 40 39",
	          fill: "#FFFFFF", stroke: "#FFFFFF", strokeWidth: "0.5" }),
	        _react2.default.createElement("path", { d: "M24 39 L 26 36.5 L 28 39 L 30 36.5 L 32 39 L 34 36.5 L 36 39 L 38 36.5 L 40 39",
	          fill: "none", stroke: "#2A3E55", strokeWidth: "0.4" })
	      )
	    )
	  );
	}
	
	function renderLenderArt(iconKey) {
	  switch (iconKey) {
	    case "piggy":
	      return _react2.default.createElement(PiggyBankArt, null);
	    case "briefcase":
	      return _react2.default.createElement(BriefcaseChartArt, null);
	    case "shark":
	      return _react2.default.createElement(SharkSuitArt, null);
	    default:
	      return null;
	  }
	}
	
	// Static per-lender presentation. Keyed by lender name (case-insensitive
	// prefix match). Falls back to a generic theme if no match.
	var LENDER_PRESETS = [{
	  match: /prudent/i,
	  theme: "green",
	  iconKey: "piggy",
	  tagline: "Safe, Steady, Simple",
	  risk: "Low Risk",
	  description: "Your trusted community partner. Conservative lending with the lowest rates in the market.",
	  fallbackDcLimit: 0.40
	}, {
	  match: /mezz/i,
	  theme: "yellow",
	  iconKey: "briefcase",
	  tagline: "More Capital, More Ambition",
	  risk: "Medium Risk",
	  description: "Mezzanine financing for businesses ready to scale. Bridges the gap between conventional debt and equity.",
	  fallbackDcLimit: 0.60
	}, {
	  match: /great white|shark/i,
	  theme: "red",
	  iconKey: "shark",
	  tagline: "Big Money. Sharp Terms.",
	  risk: "High Risk",
	  description: "Maximum capital, maximum risk. Great White operates where traditional lenders won't.",
	  fallbackDcLimit: 0.75
	}];
	
	var THEME_BY_INDEX = ["green", "yellow", "red"];
	var ICON_BY_INDEX = ["piggy", "briefcase", "shark"];
	
	function pickPreset(name, index) {
	  var byName = LENDER_PRESETS.find(function (p) {
	    return p.match.test(name || "");
	  });
	  if (byName) return byName;
	  return {
	    theme: THEME_BY_INDEX[index] || "green",
	    iconKey: ICON_BY_INDEX[index] || null,
	    tagline: "",
	    risk: index === 0 ? "Low Risk" : index === 1 ? "Medium Risk" : "High Risk",
	    description: ""
	  };
	}
	
	var SEGMENT_COLORS = {
	  green: "#2DA548",
	  yellow: "#E5B636",
	  red: "#EC5E59",
	  black: "#1A1F2B"
	};
	
	var numberToM = function numberToM(val) {
	  var n = Number(val) || 0;
	  var sign = n < 0 ? "-" : "";
	  var abs = Math.abs(n);
	  return sign + "$" + (abs / 1000000).toFixed(abs >= 10000000 ? 2 : 3) + "M";
	};
	
	// Tween a numeric value from its previous to current prop over ~600ms
	// using requestAnimationFrame + an easeOutCubic curve, then render via
	// the provided format function. Used for the Max Loan, Available to
	// Borrow, Outstanding Balance, Principal / Interest, and the status
	// bar totals so they animate when a borrow/repay post succeeds.
	
	var CountUp = function (_PureComponent) {
	  _inherits(CountUp, _PureComponent);
	
	  function CountUp(props) {
	    _classCallCheck(this, CountUp);
	
	    var _this = _possibleConstructorReturn(this, (CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call(this, props));
	
	    _this.state = { display: Number(props.value) || 0 };
	    return _this;
	  }
	
	  _createClass(CountUp, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var next = Number(this.props.value) || 0;
	      var prev = Number(prevProps.value) || 0;
	      if (next !== prev) {
	        this.animateTo(this.state.display, next);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._cancelled = true;
	    }
	  }, {
	    key: "animateTo",
	    value: function animateTo(from, to) {
	      var _this2 = this;
	
	      if (this._raf) cancelAnimationFrame(this._raf);
	      var duration = 600;
	      var start = typeof performance !== 'undefined' ? performance.now() : Date.now();
	      var step = function step(now) {
	        if (_this2._cancelled) return;
	        var elapsed = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
	        var t = Math.min(elapsed / duration, 1);
	        var eased = 1 - Math.pow(1 - t, 3);
	        var value = from + (to - from) * eased;
	        _this2.setState({ display: t === 1 ? to : value });
	        if (t < 1) {
	          _this2._raf = requestAnimationFrame(step);
	        }
	      };
	      this._raf = requestAnimationFrame(step);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var format = this.props.format;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        format(this.state.display)
	      );
	    }
	  }]);
	
	  return CountUp;
	}(_react.PureComponent);
	
	var formatMoneyShort = function formatMoneyShort(val) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var n = Number(val) || 0;
	  if (Math.abs(n) >= 1000) {
	    return numberToM(n);
	  }
	  return (opts.prefix || "$") + n.toFixed(0);
	};
	
	var formatFullDollar = function formatFullDollar(val) {
	  var n = Math.round(Number(val) || 0);
	  var sign = n < 0 ? "-" : "";
	  return sign + "$" + Math.abs(n).toLocaleString('en-US');
	};
	
	// Wrapper for the debt-to-capital indicator dot on the ratio bar.
	// Positions itself at `left: N%` inside the bar and reveals a
	// white-background tooltip with the exact ratio on hover — the always-
	// visible "N.NN%" label was overlapping the "Your Current Debt /
	// Capital Ratio" text so we moved the number into this hover reveal.
	var RatioDotWrapper = _styledComponents2.default.div(_templateObject13);
	
	var RatioDotVisual = _styledComponents2.default.div(_templateObject14);
	
	var RatioTooltip = _styledComponents2.default.span(_templateObject15);
	
	// Hover tooltip wrapper for the "i" info icons on the Lender Offer row
	// (Max Loan, D/C Limit). Reveals a dark 16px pill below the icon with a
	// plain-language explanation. Pointer-events on the icon are killed so
	// hover fires reliably on the wrapper.
	var LenderInfoWrapper = _styledComponents2.default.span(_templateObject16);
	
	var LenderInfoTooltip = _styledComponents2.default.span(_templateObject17);
	
	var DebtDecisionsPage = function (_PureComponent2) {
	  _inherits(DebtDecisionsPage, _PureComponent2);
	
	  function DebtDecisionsPage(props) {
	    _classCallCheck(this, DebtDecisionsPage);
	
	    var _this3 = _possibleConstructorReturn(this, (DebtDecisionsPage.__proto__ || Object.getPrototypeOf(DebtDecisionsPage)).call(this, props));
	
	    _this3.fetchAll = function () {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var roundNumber = _this3.props.roundNumber;
	
	
	      Promise.all([(0, _ApiService.getRequest)(apiUrl + "static/debt_clients/"), (0, _TeamDecisionsService.fetchTeamDecisions)(roundNumber, "finance"), (0, _ApiService.getRequest)(apiUrl + "team/debt_repayments/?round_number=" + roundNumber).then(function (r) {
	        return r.body;
	      }).catch(function () {
	        return [];
	      }), (0, _ApiService.getRequest)(apiUrl + "v2/finance/interest-payments/?round_number=" + roundNumber).then(function (r) {
	        return r.body;
	      }).catch(function () {
	        return { results: [] };
	      }), (0, _ApiService.getRequest)(apiUrl + "team/players/").then(function (r) {
	        return r.body;
	      }).catch(function () {
	        return [];
	      })]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 5),
	            clientsRes = _ref2[0],
	            decisions = _ref2[1],
	            debtRepaymentsRes = _ref2[2],
	            interestPaymentsRes = _ref2[3],
	            playersRes = _ref2[4];
	
	        if (!_this3._isMounted) return;
	
	        var debtClients = clientsRes.body || [];
	        var teamDebts = decisions.teamDebts || [];
	        var financial = decisions.financial_decisions && decisions.financial_decisions.team || {};
	
	        // Normalize repayments shapes (debt_repayments returns an array;
	        // interest-payments returns {results: [...]} paginated)
	        var debtRepayments = Array.isArray(debtRepaymentsRes) ? debtRepaymentsRes : debtRepaymentsRes && debtRepaymentsRes.results || [];
	        var interestPayments = Array.isArray(interestPaymentsRes) ? interestPaymentsRes : interestPaymentsRes && interestPaymentsRes.results || [];
	
	        // Find the current user's player record. interest-payments
	        // POST requires player as a required FK.
	        var players = Array.isArray(playersRes) ? playersRes : [];
	        var userId = Number(_Auth2.default.getUserId());
	        var player = players.find(function (p) {
	          return p && p.user && Number(p.user.id) === userId;
	        });
	        var playerId = player ? Number(player.id) : 0;
	
	        var debtToCapital = Number(financial.debt_to_capital || 0);
	
	        // Single bulk POST replaces the previous per-lender pair
	        // (get_max_amount/ + get_debt_conditions/). Returns one entry
	        // per (client, term) requested. We ask LT for every lender —
	        // the Choose Your Lender cards display long-term offerings.
	        var bulkBody = {
	          requests: debtClients.map(function (client) {
	            return {
	              client: client.id,
	              term: 'LT',
	              amount: 0
	            };
	          })
	        };
	
	        (0, _ApiService.postRequest)(apiUrl + "static/debt_clients/bulk/").send(bulkBody).then(function (r) {
	          return Array.isArray(r.body) ? r.body : [];
	        }).catch(function () {
	          return [];
	        }).then(function (bulkResponse) {
	          if (!_this3._isMounted) return;
	
	          // Index the bulk response by client_id for O(1) lookup. Each
	          // entry: { client, term, max_amount, allowed_amount, rate }.
	          var bulkByClient = {};
	          bulkResponse.forEach(function (row) {
	            if (row && row.client != null) {
	              bulkByClient[Number(row.client)] = row;
	            }
	          });
	
	          var lenders = debtClients.map(function (client, idx) {
	            var bulkRow = bulkByClient[Number(client.id)] || null;
	            var maxAmount = bulkRow && bulkRow.max_amount != null ? Number(bulkRow.max_amount) : 0;
	            var debtsForClient = teamDebts.filter(function (d) {
	              return d.client === client.id;
	            });
	
	            var principal = debtsForClient.reduce(function (sum, d) {
	              return sum + (Number(d.balance) || 0);
	            }, 0);
	            // On an active round, current-round interest is still
	            // accruing; show prior_year_interest_payable (finalized
	            // carry-in). On a closed round, interest_payable is final.
	            //
	            // Floor per row so the interest displayed on the lender
	            // card matches the integer used as the repayment cap
	            // (backend interest field carries decimal cents that
	            // otherwise cause "exceeds outstanding" false-positives
	            // when the user types the displayed whole-dollar total).
	            var interestField = _this3.props.isActiveRound ? 'prior_year_interest_payable' : 'interest_payable';
	            var interest = debtsForClient.reduce(function (sum, d) {
	              return sum + Math.floor(Number(d[interestField]) || 0);
	            }, 0);
	            // Pull the displayed interest rate from the team's debt record
	            // for this lender so an in-flight loan shows the rate that was
	            // locked in at borrow time. If the team has no debt with this
	            // lender yet, fall back to the current offer rate from the
	            // bulk response so the card still displays a live %.
	            var bulkRate = bulkRow && bulkRow.rate != null ? Number(bulkRow.rate) : 0;
	            var rate = debtsForClient.length ? Number(debtsForClient[0].rate || 0) : bulkRate;
	
	            // D/C limit isn't returned by the bulk endpoint; fall back to
	            // the lender preset (Prudent 40, Mezz 60, Great White 75) so
	            // the progress-bar segments still render.
	            var preset = pickPreset(client.name, idx);
	            var dcLimit = preset.fallbackDcLimit || 0;
	
	            // Track this round's debt record id (if any) so subsequent
	            // borrow/repay clicks PUT (update) rather than POST (create
	            // and hit the unique constraint on client/team/round).
	            var roundId = _this3.props.roundId;
	
	            var debtThisRound = roundId ? debtsForClient.find(function (d) {
	              return Number(d.round) === Number(roundId);
	            }) : null;
	
	            // Per-lender amount math:
	            //   currentRoundBorrow = how much was borrowed THIS round.
	            //     Pulled from the debt record's `new_amount` field.
	            //   prevRoundAmount   = the cumulative amount BEFORE this
	            //     round. The backend's amount field on a debt row is
	            //     prevRoundAmount + currentRoundBorrow.
	            //
	            // Used for two things:
	            //  - Pre-filling the "Amount to Borrow This Round" input
	            //    with what's already been borrowed this round.
	            //  - Sending amount: prevRoundAmount + userInput on POST/PUT
	            //    so the user's input represents the new total borrowed
	            //    this round rather than an increment-on-top-of-existing.
	            var currentRoundBorrow = debtThisRound ? Number(debtThisRound.new_amount || 0) : 0;
	            var prevRoundAmount = 0;
	            if (debtThisRound) {
	              if (debtThisRound.prev_round_amount != null) {
	                prevRoundAmount = Number(debtThisRound.prev_round_amount);
	              } else {
	                prevRoundAmount = Math.max(0, Number(debtThisRound.amount || 0) - currentRoundBorrow);
	              }
	            } else {
	              var prior = debtsForClient.slice().sort(function (a, b) {
	                return Number(b.round) - Number(a.round);
	              })[0];
	              if (prior) {
	                prevRoundAmount = Number(prior.amount || 0);
	              }
	            }
	
	            // Look up any repayment records already posted this round.
	            // Hoisted above the return so currentRoundInterestRepaid can
	            // offset the displayed interest in `outstanding` — otherwise
	            // Outstanding stays pinned at the starting prior-year value
	            // even after the user paid down interest earlier this round.
	            var dr = debtRepayments.find(function (r) {
	              return r.client === client.id;
	            });
	            var ip = interestPayments.find(function (r) {
	              return r.client === client.id;
	            });
	            var currentRoundInterestRepaid = ip ? Number(ip.amount || 0) : 0;
	            var netInterest = Math.max(0, interest - currentRoundInterestRepaid);
	
	            return Object.assign({
	              client_id: client.id,
	              name: client.name,
	              maxAmount: Number(maxAmount) || 0,
	              rate: Number(rate) || 0,
	              dcLimit: dcLimit, // 0..1 expected
	              principal: principal,
	              interest: netInterest,
	              outstanding: principal + netInterest,
	              debtIdThisRound: debtThisRound ? debtThisRound.id : null,
	              currentAmountThisRound: debtThisRound ? Number(debtThisRound.amount || debtThisRound.balance || 0) : 0,
	              currentRoundBorrow: currentRoundBorrow,
	              prevRoundAmount: prevRoundAmount
	            }, function () {
	              var priorPrincipal = debtThisRound ? Number(debtThisRound.prior_year_principal_balance || 0) : 0;
	              // Floor to match the interest displayed on the lender
	              // card so validation against priorYearOutstanding
	              // (used as the repayment cap) uses the same integer
	              // the user sees.
	              var priorInterest = debtThisRound ? Math.floor(Number(debtThisRound.prior_year_interest_payable || 0)) : 0;
	              return {
	                debtRepaymentId: dr ? dr.id : null,
	                interestRepaymentId: ip ? ip.id : null,
	                currentRoundPrincipalRepaid: dr ? Number(dr.amount || 0) : 0,
	                currentRoundInterestRepaid: currentRoundInterestRepaid,
	                priorYearPrincipalBalance: priorPrincipal,
	                priorYearInterestPayable: priorInterest,
	                priorYearOutstanding: priorPrincipal + priorInterest
	              };
	            }());
	          });
	
	          var totalExistingDebt = lenders.reduce(function (sum, l) {
	            return sum + l.outstanding;
	          }, 0);
	
	          // Net Capital Raised/Returned for debt = new borrowing this
	          // round minus principal + interest repaid this round. Positive
	          // means net inflow; negative means net outflow. All three
	          // sources are already round-scoped (team-decisions and the
	          // repayments/interest endpoints filter by round_number).
	          var newDebtRaised = teamDebts.reduce(function (sum, d) {
	            return sum + (Number(d.new_amount) || 0);
	          }, 0);
	          var principalRepaid = debtRepayments.reduce(function (sum, r) {
	            return sum + (Number(r.amount) || 0);
	          }, 0);
	          var interestPaid = interestPayments.reduce(function (sum, p) {
	            return sum + (Number(p.amount) || 0);
	          }, 0);
	          var netCapital = newDebtRaised - (principalRepaid + interestPaid);
	
	          var cashBalance = Number(financial.ending_cash) || 0;
	
	          _this3.setState({
	            loading: false,
	            lenders: lenders,
	            totalExistingDebt: totalExistingDebt,
	            netCapital: netCapital,
	            debtToCapital: debtToCapital,
	            cashBalance: cashBalance,
	            playerId: playerId
	          });
	        });
	      }).catch(function () {
	        if (!_this3._isMounted) return;
	        _this3.setState({ loading: false });
	      });
	    };
	
	    _this3.refreshAfterPost = function () {
	      var _this3$props = _this3.props,
	          roundNumber = _this3$props.roundNumber,
	          roundId = _this3$props.roundId;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var currentLenders = _this3.state.lenders;
	
	      // Notify the parent so the Finance Decisions page can re-fetch its
	      // KPIs (debt_to_capital, outstanding debt, etc.) — fired once per
	      // successful POST/PUT inside this popup.
	      if (typeof _this3.props.onDecisionMade === 'function') {
	        _this3.props.onDecisionMade();
	      }
	
	      // Re-fetch team-decisions (for new balances + debt_to_capital)
	      // alongside one bulk POST that returns max_amount + rate per
	      // lender (replaces the previous N×2 per-lender calls).
	      var bulkBody = {
	        requests: currentLenders.map(function (lender) {
	          return {
	            client: lender.client_id,
	            term: 'LT',
	            amount: 0
	          };
	        })
	      };
	
	      return Promise.all([(0, _TeamDecisionsService.fetchTeamDecisions)(roundNumber, "finance"), (0, _ApiService.postRequest)(apiUrl + "static/debt_clients/bulk/").send(bulkBody).then(function (r) {
	        return Array.isArray(r.body) ? r.body : [];
	      }).catch(function () {
	        return [];
	      }), (0, _ApiService.getRequest)(apiUrl + "team/debt_repayments/?round_number=" + roundNumber).then(function (r) {
	        return r.body;
	      }).catch(function () {
	        return [];
	      }), (0, _ApiService.getRequest)(apiUrl + "v2/finance/interest-payments/?round_number=" + roundNumber).then(function (r) {
	        return r.body;
	      }).catch(function () {
	        return { results: [] };
	      })]).then(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 4),
	            decisions = _ref4[0],
	            bulkResponse = _ref4[1],
	            debtRepaymentsRes = _ref4[2],
	            interestPaymentsRes = _ref4[3];
	
	        var debtRepayments = Array.isArray(debtRepaymentsRes) ? debtRepaymentsRes : debtRepaymentsRes && debtRepaymentsRes.results || [];
	        var interestPayments = Array.isArray(interestPaymentsRes) ? interestPaymentsRes : interestPaymentsRes && interestPaymentsRes.results || [];
	        return [decisions, bulkResponse, debtRepayments, interestPayments];
	      }).then(function (_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 4),
	            decisions = _ref6[0],
	            bulkResponse = _ref6[1],
	            debtRepayments = _ref6[2],
	            interestPayments = _ref6[3];
	
	        if (!_this3._isMounted) return;
	        var teamDebts = decisions.teamDebts || [];
	        var financial = decisions.financial_decisions && decisions.financial_decisions.team || {};
	        var debtToCapital = Number(financial.debt_to_capital || 0);
	        var cashBalance = Number(financial.ending_cash) || 0;
	
	        // Index the bulk response by client_id for O(1) lookup.
	        var bulkByClient = {};
	        bulkResponse.forEach(function (row) {
	          if (row && row.client != null) {
	            bulkByClient[Number(row.client)] = row;
	          }
	        });
	
	        var lenders = currentLenders.map(function (lender) {
	          var debtsForClient = teamDebts.filter(function (d) {
	            return d.client === lender.client_id;
	          });
	          var principal = debtsForClient.reduce(function (sum, d) {
	            return sum + (Number(d.balance) || 0);
	          }, 0);
	          // Same active-round rule + floor as the initial load above.
	          var interestFieldRefresh = _this3.props.isActiveRound ? 'prior_year_interest_payable' : 'interest_payable';
	          var interest = debtsForClient.reduce(function (sum, d) {
	            return sum + Math.floor(Number(d[interestFieldRefresh]) || 0);
	          }, 0);
	          var bulkRow = bulkByClient[Number(lender.client_id)] || null;
	          var bulkRate = bulkRow && bulkRow.rate != null ? Number(bulkRow.rate) : null;
	          var rate = debtsForClient.length ? Number(debtsForClient[0].rate || 0) : bulkRate != null ? bulkRate : lender.rate;
	
	          // Refresh max_amount from the bulk response. Fall back to the
	          // pre-refresh value if the bulk row is missing for any reason.
	          var refreshedMax = bulkRow && bulkRow.max_amount != null ? Number(bulkRow.max_amount) : lender.maxAmount;
	
	          // D/C limit isn't returned by the bulk endpoint; carry forward
	          // the per-lender value already on state (seeded from the preset
	          // at initial load).
	          var newDcLimit = lender.dcLimit;
	
	          // Recompute prevRoundAmount + currentRoundBorrow so the
	          // next borrow click sends correct cumulative math and
	          // the input pre-fill reflects the just-saved value.
	          var debtThisRound = roundId ? debtsForClient.find(function (d) {
	            return Number(d.round) === Number(roundId);
	          }) : null;
	          var currentRoundBorrow = debtThisRound ? Number(debtThisRound.new_amount || 0) : 0;
	          var prevRoundAmount = 0;
	          if (debtThisRound) {
	            if (debtThisRound.prev_round_amount != null) {
	              prevRoundAmount = Number(debtThisRound.prev_round_amount);
	            } else {
	              prevRoundAmount = Math.max(0, Number(debtThisRound.amount || 0) - currentRoundBorrow);
	            }
	          } else {
	            var prior = debtsForClient.slice().sort(function (a, b) {
	              return Number(b.round) - Number(a.round);
	            })[0];
	            if (prior) {
	              prevRoundAmount = Number(prior.amount || 0);
	            }
	          }
	
	          var dr = debtRepayments.find(function (r) {
	            return r.client === lender.client_id;
	          });
	          var ip = interestPayments.find(function (r) {
	            return r.client === lender.client_id;
	          });
	          var priorPrincipal = debtThisRound ? Number(debtThisRound.prior_year_principal_balance || 0) : 0;
	          // Floor to match displayed integer (see initial-load site).
	          var priorInterest = debtThisRound ? Math.floor(Number(debtThisRound.prior_year_interest_payable || 0)) : 0;
	
	          // Offset the displayed interest by any interest payments
	          // already posted this round (mirrors the initial-load site).
	          var currentRoundInterestRepaid = ip ? Number(ip.amount || 0) : 0;
	          var netInterest = Math.max(0, interest - currentRoundInterestRepaid);
	
	          return Object.assign({}, lender, {
	            principal: principal,
	            interest: netInterest,
	            outstanding: principal + netInterest,
	            rate: rate,
	            maxAmount: Number(refreshedMax) || 0,
	            dcLimit: newDcLimit,
	            currentRoundBorrow: currentRoundBorrow,
	            prevRoundAmount: prevRoundAmount,
	            debtIdThisRound: debtThisRound ? debtThisRound.id : null,
	            currentAmountThisRound: debtThisRound ? Number(debtThisRound.amount || debtThisRound.balance || 0) : 0,
	            debtRepaymentId: dr ? dr.id : null,
	            interestRepaymentId: ip ? ip.id : null,
	            currentRoundPrincipalRepaid: dr ? Number(dr.amount || 0) : 0,
	            currentRoundInterestRepaid: currentRoundInterestRepaid,
	            priorYearPrincipalBalance: priorPrincipal,
	            priorYearInterestPayable: priorInterest,
	            priorYearOutstanding: priorPrincipal + priorInterest
	          });
	        });
	        var totalExistingDebt = lenders.reduce(function (sum, l) {
	          return sum + l.outstanding;
	        }, 0);
	        var newDebtRaised = teamDebts.reduce(function (sum, d) {
	          return sum + (Number(d.new_amount) || 0);
	        }, 0);
	        var principalRepaid = debtRepayments.reduce(function (sum, r) {
	          return sum + (Number(r.amount) || 0);
	        }, 0);
	        var interestPaid = interestPayments.reduce(function (sum, p) {
	          return sum + (Number(p.amount) || 0);
	        }, 0);
	        var netCapital = newDebtRaised - (principalRepaid + interestPaid);
	        _this3.setState({ lenders: lenders, totalExistingDebt: totalExistingDebt, netCapital: netCapital, debtToCapital: debtToCapital, cashBalance: cashBalance });
	      }).catch(function () {});
	    };
	
	    _this3.handleSelectLenderInternal = function (lender) {
	      // Pre-populate the inputs with the existing this-round values so the
	      // input's value tracks state directly. Falling back to the existing
	      // amount only when state is empty caused a clear-to-empty backspace
	      // to snap the input back to the pre-existing borrow amount.
	      var existingBorrow = Math.round(Number(lender.currentRoundBorrow || 0));
	      var existingRepay = Math.round(Number(lender.currentRoundPrincipalRepaid || 0) + Number(lender.currentRoundInterestRepaid || 0));
	      _this3.setState({
	        selectedLenderId: lender.client_id,
	        borrowAmount: existingBorrow > 0 ? String(existingBorrow) : '',
	        repayAmount: existingRepay > 0 ? String(existingRepay) : ''
	      });
	    };
	
	    _this3.handleChooseDifferentLender = function () {
	      _this3.setState({ selectedLenderId: null, borrowAmount: '', repayAmount: '' });
	    };
	
	    _this3.handleBorrowAmountChange = function (e) {
	      var val = e.target.value.replace(/[^\d]/g, '');
	      _this3.setState({ borrowAmount: val });
	    };
	
	    _this3.handleRepayAmountChange = function (e) {
	      var val = e.target.value.replace(/[^\d]/g, '');
	      _this3.setState({ repayAmount: val });
	    };
	
	    _this3.showNotice = function (title, message) {
	      _this3.setState({ noticeOpen: true, noticeTitle: title, noticeMessage: message });
	    };
	
	    _this3.hideNotice = function () {
	      _this3.setState({ noticeOpen: false });
	    };
	
	    _this3.extractBackendError = function (err) {
	      var body = err && err.response && err.response.body;
	      if (!body) return null;
	      if (typeof body === 'string') return body;
	      if (body.detail) return String(body.detail);
	      if (Array.isArray(body.non_field_errors) && body.non_field_errors.length > 0) {
	        return String(body.non_field_errors[0]);
	      }
	      if (body.message) return String(body.message);
	      if (body.error) return String(body.error);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(body)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          var val = body[key];
	          if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'string') {
	            return key + ": " + val[0];
	          }
	          if (typeof val === 'string' && val.length > 0) {
	            return key + ": " + val;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return null;
	    };
	
	    _this3.getBorrowValidationError = function () {
	      var _this3$state = _this3.state,
	          lenders = _this3$state.lenders,
	          selectedLenderId = _this3$state.selectedLenderId,
	          borrowAmount = _this3$state.borrowAmount;
	
	      var lender = lenders.find(function (l) {
	        return l.client_id === selectedLenderId;
	      });
	      if (!lender) return { title: 'Error', message: 'No lender selected.' };
	
	      var amount = Number(borrowAmount) || 0;
	      if (amount < 0) {
	        return { title: 'Invalid amount', message: 'Borrow amount cannot be negative.' };
	      }
	      // See handlePostBorrow for the delta-vs-total explanation.
	      var currentRoundBorrow = Number(lender.currentRoundBorrow || 0);
	      var isIncreasing = amount > currentRoundBorrow;
	      var incrementalBorrow = amount - currentRoundBorrow;
	      var maxAmt = Number(lender.maxAmount || 0);
	      if (isIncreasing && incrementalBorrow > maxAmt) {
	        var totalAllowed = currentRoundBorrow + maxAmt;
	        return {
	          title: 'Exceeds Available to Borrow',
	          message: "The amount requested is in excess of what you can currently borrow from " + lender.name + " given their debt-to-capital limits. You can borrow up to " + numberToM(totalAllowed) + " in total this round based on your current debt-to-capital ratio."
	        };
	      }
	      return null;
	    };
	
	    _this3.requestBorrow = function () {
	      var err = _this3.getBorrowValidationError();
	      if (err) {
	        _this3.showNotice(err.title, err.message);
	        return;
	      }
	      var _this3$state2 = _this3.state,
	          lenders = _this3$state2.lenders,
	          selectedLenderId = _this3$state2.selectedLenderId,
	          borrowAmount = _this3$state2.borrowAmount;
	
	      var lender = lenders.find(function (l) {
	        return l.client_id === selectedLenderId;
	      });
	      if (!lender) return;
	
	      var amount = Number(borrowAmount) || 0;
	      var cumulativeAmount = Number(lender.prevRoundAmount || 0) + amount;
	      // Seed the modal with the bulk rate (may be `--`) so it opens
	      // immediately, then update in place once the live rate arrives.
	      var seedRate = Number(lender.rate) > 0 ? Number(lender.rate) : null;
	      _this3.setState({
	        borrowConfirmOpen: true,
	        borrowConfirmRate: seedRate,
	        borrowConfirmLoadingRate: true
	      });
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.postRequest)(apiUrl + "static/debt_clients/" + lender.client_id + "/get_debt_conditions/").send({ amount: cumulativeAmount, term: 8 }).then(function (res) {
	        if (!_this3._isMounted) return;
	        var body = res && res.body || {};
	        var liveRate = Number(body.rate);
	        _this3.setState({
	          borrowConfirmRate: liveRate > 0 ? liveRate : seedRate,
	          borrowConfirmLoadingRate: false
	        });
	      }).catch(function () {
	        // Fetch failed — leave whatever seed rate we already have
	        // and stop the loading indicator. Confirm still works.
	        if (!_this3._isMounted) return;
	        _this3.setState({ borrowConfirmLoadingRate: false });
	      });
	    };
	
	    _this3.cancelBorrowConfirm = function () {
	      _this3.setState({
	        borrowConfirmOpen: false,
	        borrowConfirmRate: null,
	        borrowConfirmLoadingRate: false
	      });
	    };
	
	    _this3.confirmBorrow = function () {
	      _this3.setState({
	        borrowConfirmOpen: false,
	        borrowConfirmRate: null,
	        borrowConfirmLoadingRate: false
	      }, function () {
	        _this3.handlePostBorrow();
	      });
	    };
	
	    _this3.handlePostBorrow = function () {
	      var _this3$state3 = _this3.state,
	          lenders = _this3$state3.lenders,
	          selectedLenderId = _this3$state3.selectedLenderId,
	          borrowAmount = _this3$state3.borrowAmount;
	
	      var lender = lenders.find(function (l) {
	        return l.client_id === selectedLenderId;
	      });
	      if (!lender) return;
	
	      var amount = Number(borrowAmount) || 0;
	      if (amount < 0) {
	        _this3.showNotice('Invalid amount', 'Borrow amount cannot be negative.');
	        return;
	      }
	      // Only validate Max Loan when the user is INCREASING this round's
	      // borrowing. If they're decreasing (or leaving the same) the
	      // existing `new_amount`, they're just modifying an existing loan
	      // and the lender's current cap is not relevant.
	      //
	      // maxAmount is the REMAINING capacity from the backend, computed
	      // after this round's already-booked borrow. So compare the DELTA
	      // (new total minus already-borrowed-this-round) against maxAmount,
	      // not the new total — otherwise editing a $2M borrow up to $3M
	      // reads as "$3M > $1M remaining" even though the $1M delta fits.
	      var currentRoundBorrow = Number(lender.currentRoundBorrow || 0);
	      var isIncreasing = amount > currentRoundBorrow;
	      var incrementalBorrow = amount - currentRoundBorrow;
	      var maxAmt = Number(lender.maxAmount || 0);
	      if (isIncreasing && incrementalBorrow > maxAmt) {
	        var totalAllowed = currentRoundBorrow + maxAmt;
	        _this3.showNotice('Exceeds Available to Borrow', "The amount requested is in excess of what you can currently borrow from " + lender.name + " given their debt-to-capital limits. You can borrow up to " + numberToM(totalAllowed) + " in total this round based on your current debt-to-capital ratio.");
	        return;
	      }
	
	      _this3.setState({ postingBorrow: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var roundId = _this3.props.roundId;
	
	      // The DB has a unique constraint on (client, team, round). If a
	      // debt record already exists for this lender this round, PUT to
	      // update it; otherwise POST to create.
	
	      var request = lender.debtIdThisRound ? (0, _ApiService.putRequest)(apiUrl + "team/debts/" + lender.debtIdThisRound + "/") : (0, _ApiService.postRequest)(apiUrl + "team/debts/");
	
	      // Per backend contract: the `amount` field is the cumulative
	      // total loan amount = prior round's amount + the user's new
	      // "Amount to Borrow This Round" input (which represents the
	      // total borrowed this round, not an increment). The backend
	      // validator rejects writes where amount < the prior round's
	      // debt, so always send prevRoundAmount + input.
	      var cumulativeAmount = Number(lender.prevRoundAmount || 0) + amount;
	
	      request.send({
	        client: lender.client_id,
	        round: roundId,
	        amount: cumulativeAmount,
	        new_amount: amount,
	        term: 8
	      }).then(function () {
	        if (!_this3._isMounted) return;
	        _this3.refreshAfterPost().then(function () {
	          if (!_this3._isMounted) return;
	          // Keep borrowAmount in sync with the just-saved value so the
	          // input stays populated with what's borrowed this round.
	          _this3.setState({ postingBorrow: false });
	        });
	      }).catch(function (err) {
	        if (!_this3._isMounted) return;
	        var msg = _this3.extractBackendError(err) || 'Unable to post the borrowing decision. Please try again.';
	        _this3.setState({ postingBorrow: false });
	        _this3.showNotice('Post Failed', msg);
	      });
	    };
	
	    _this3.handlePostRepay = function () {
	      var _this3$state4 = _this3.state,
	          lenders = _this3$state4.lenders,
	          selectedLenderId = _this3$state4.selectedLenderId,
	          repayAmount = _this3$state4.repayAmount,
	          cashBalance = _this3$state4.cashBalance;
	
	      var lender = lenders.find(function (l) {
	        return l.client_id === selectedLenderId;
	      });
	      if (!lender) return;
	
	      var amount = Number(repayAmount) || 0;
	      if (amount < 0) {
	        _this3.showNotice('Invalid amount', 'Repayment amount cannot be negative.');
	        return;
	      }
	      // Block repayment when the team has also borrowed from the same
	      // lender this round. The team's intent in that moment is to reduce
	      // their total exposure to this lender — the right lever is to
	      // lower this round's borrow amount, not to post a repayment on top.
	      // Repayments only apply to prior-round balances, so we steer them
	      // back to the Borrow input. Clearing an existing repayment (amount
	      // = 0) is still allowed since that's a cancellation, not a new
	      // repayment.
	      var currentRoundBorrow = Number(lender.currentRoundBorrow) || 0;
	      if (amount > 0 && currentRoundBorrow > 0) {
	        _this3.showNotice('New loan active', "You can't repay " + lender.name + " while a new loan from them is active this round. To reduce your total loan, lower this round's borrow amount instead. Once the new loan is set to $0, you can repay prior balances.");
	        return;
	      }
	      // Only enforce caps when the user is INCREASING this round's
	      // repayment. Decreasing an existing repayment frees up cash and
	      // can't push outstanding above its already-accepted value.
	      var existingRepayment = (Number(lender.currentRoundPrincipalRepaid) || 0) + (Number(lender.currentRoundInterestRepaid) || 0);
	      var isIncreasing = amount > existingRepayment;
	
	      // Cap the repayment at the "Outstanding" value shown on the
	      // Repay panel header (prior_year_principal_balance +
	      // prior_year_interest_payable). Backend rejects anything more.
	      if (isIncreasing && amount > Number(lender.priorYearOutstanding || 0)) {
	        _this3.showNotice('Exceeds Outstanding Value', "The value entered is in excess of the outstanding value. " + lender.name + "'s Outstanding is " + numberToM(lender.priorYearOutstanding) + ".");
	        return;
	      }
	      // Only the delta from what's already been paid this round hits
	      // cash — the prior payment was deducted from cashBalance when it
	      // was posted, so a PUT that increases the total by X only needs X
	      // in available cash, not the full new total.
	      var additionalCashNeeded = Math.max(0, amount - existingRepayment);
	      if (isIncreasing && additionalCashNeeded > Number(cashBalance || 0)) {
	        _this3.showNotice('Insufficient Cash', "Your available cash balance is " + numberToM(cashBalance) + ". Reduce the repayment amount or raise additional capital first.");
	        return;
	      }
	
	      _this3.setState({ postingRepay: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      // Split the user's input: pay outstanding interest first, then
	      // any remaining to principal. The caps here must match the
	      // "Outstanding" header (prior-year fields) — the backend
	      // interest-payments endpoint rejects amounts > prior_year_interest_payable
	      // and debt_repayments rejects amounts > prior_year_principal_balance.
	      //
	      // Floor the interest portion to a whole dollar — the interest-payments
	      // API expects integer amounts (no cents). Any sub-dollar residual on
	      // prior_year_interest_payable rolls forward instead of being paid.
	      // Principal is derived from the floored interest so the user's total
	      // repayment intent is preserved (the "lost" cents go to principal).
	      var interestOutstanding = Math.max(0, Number(lender.priorYearInterestPayable || 0));
	      var principalOutstanding = Math.max(0, Number(lender.priorYearPrincipalBalance || 0));
	      var interestPortion = Math.floor(Math.min(amount, interestOutstanding));
	      var principalPortion = Math.min(Math.max(0, amount - interestPortion), principalOutstanding);
	
	      var requests = [];
	
	      // Interest. Always PUT an existing record (so the user can
	      // reset a prior payment to 0). Only POST a new record when the
	      // portion is > 0 — no point creating a zero-amount record.
	      if (lender.interestRepaymentId || interestPortion > 0) {
	        var req = lender.interestRepaymentId ? (0, _ApiService.putRequest)(apiUrl + "v2/finance/interest-payments/" + lender.interestRepaymentId + "/") : (0, _ApiService.postRequest)(apiUrl + "v2/finance/interest-payments/");
	        requests.push(req.send({
	          client: lender.client_id,
	          amount: interestPortion,
	          debt: lender.debtIdThisRound,
	          player: _this3.state.playerId,
	          round: _this3.props.roundId,
	          team: Number(_Auth2.default.getTeamId()),
	          term: 8
	        }));
	      }
	
	      // Principal. Same pattern — PUT existing even at 0, POST only
	      // when there's actually a principal payment.
	      if (lender.debtRepaymentId || principalPortion > 0) {
	        var _req = lender.debtRepaymentId ? (0, _ApiService.putRequest)(apiUrl + "team/debt_repayments/" + lender.debtRepaymentId + "/") : (0, _ApiService.postRequest)(apiUrl + "team/debt_repayments/");
	        requests.push(_req.send({
	          client: lender.client_id,
	          term: 8,
	          amount: principalPortion
	        }));
	      }
	
	      Promise.all(requests).then(function () {
	        if (!_this3._isMounted) return;
	        _this3.refreshAfterPost().then(function () {
	          if (!_this3._isMounted) return;
	          _this3.setState({ postingRepay: false, repayAmount: '' });
	        });
	      }).catch(function (err) {
	        if (!_this3._isMounted) return;
	        var msg = _this3.extractBackendError(err) || 'Unable to post the repayment decision. Please try again.';
	        _this3.setState({ postingRepay: false });
	        _this3.showNotice('Post Failed', msg);
	      });
	    };
	
	    _this3.renderLenderCard = function (lender, idx, opts) {
	      var roundNumber = _this3.props.roundNumber;
	
	      var preset = pickPreset(lender.name, idx);
	
	      var _ref7 = opts || {},
	          _ref7$withAnimation = _ref7.withAnimation,
	          withAnimation = _ref7$withAnimation === undefined ? true : _ref7$withAnimation,
	          _ref7$hideSelectButto = _ref7.hideSelectButton,
	          hideSelectButton = _ref7$hideSelectButto === undefined ? false : _ref7$hideSelectButto,
	          _ref7$showOutstanding = _ref7.showOutstanding,
	          showOutstanding = _ref7$showOutstanding === undefined ? true : _ref7$showOutstanding;
	
	      // Per-lender round activity sum drives the section header verb:
	      //   sum = debts.new_amount − debt_repayments.amount − interest_payments.amount
	      // ≥ 0 → "Amount Borrowed Year N"; < 0 → "Amount Repaid Year N".
	      // The big numeric value is the signed sum; a negative one renders red.
	
	
	      var borrowedThisRound = Number(lender.currentRoundBorrow) || 0;
	      var principalRepaidThisRound = Number(lender.currentRoundPrincipalRepaid) || 0;
	      var interestPaidThisRound = Number(lender.currentRoundInterestRepaid) || 0;
	      var amountSign = borrowedThisRound - principalRepaidThisRound - interestPaidThisRound;
	      var amountVerb = amountSign >= 0 ? 'Borrowed' : 'Repaid';
	      return _react2.default.createElement(
	        _style2.default.LenderCard,
	        {
	          key: lender.client_id,
	          theme: preset.theme,
	          index: withAnimation ? idx : 0,
	          noAnimation: !withAnimation
	        },
	        _react2.default.createElement(
	          _style2.default.LenderCardTop,
	          null,
	          _react2.default.createElement(
	            _style2.default.LenderLogo,
	            null,
	            _react2.default.createElement(
	              LenderArtFrame,
	              null,
	              renderLenderArt(preset.iconKey)
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderTitleArea,
	            null,
	            _react2.default.createElement(
	              _style2.default.LenderName,
	              null,
	              lender.name
	            ),
	            preset.tagline && _react2.default.createElement(
	              _style2.default.LenderTagline,
	              null,
	              preset.tagline
	            ),
	            _react2.default.createElement(
	              _style2.default.LenderRiskBadge,
	              { theme: preset.theme },
	              preset.risk
	            )
	          )
	        ),
	        preset.description && _react2.default.createElement(
	          _style2.default.LenderDescription,
	          null,
	          preset.description
	        ),
	        _react2.default.createElement(
	          _style2.default.LenderInnerCard,
	          null,
	          _react2.default.createElement(
	            _style2.default.LenderInnerLabel,
	            null,
	            "Lender Offer"
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderOfferRow,
	            null,
	            _react2.default.createElement(
	              _style2.default.LenderOfferCol,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderOfferLabel,
	                null,
	                "Max Loan",
	                ' ',
	                _react2.default.createElement(
	                  LenderInfoWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.LenderCardInfoIcon,
	                    null,
	                    "i"
	                  ),
	                  _react2.default.createElement(
	                    LenderInfoTooltip,
	                    { className: "lender-info-tooltip" },
	                    "The most this lender will offer right now, based on your debt-to-capital ratio. Lower your ratio and you can borrow more."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderOfferValue,
	                { theme: preset.theme },
	                _react2.default.createElement(CountUp, { value: lender.maxAmount, format: formatFullDollar })
	              )
	            ),
	            _react2.default.createElement(
	              _style2.default.LenderOfferCol,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderOfferLabel,
	                null,
	                "Interest Rate"
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderOfferValue,
	                { theme: preset.theme },
	                function () {
	                  if (Number(lender.rate) > 0) {
	                    return (lender.rate * 100).toFixed(1) + "%";
	                  }
	                  if (preset.theme === 'green') return 'Low';
	                  if (preset.theme === 'yellow') return 'Moderate';
	                  if (preset.theme === 'red') return 'High';
	                  return '--';
	                }()
	              )
	            ),
	            _react2.default.createElement(
	              _style2.default.LenderOfferCol,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderOfferLabel,
	                null,
	                "D/C Limit",
	                ' ',
	                _react2.default.createElement(
	                  LenderInfoWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.LenderCardInfoIcon,
	                    null,
	                    "i"
	                  ),
	                  _react2.default.createElement(
	                    LenderInfoTooltip,
	                    { className: "lender-info-tooltip" },
	                    "The debt-to-capital ratio this lender won't let you cross. Stay below it and they'll keep lending to you."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderOfferValue,
	                { theme: preset.theme },
	                (lender.dcLimit * 100).toFixed(0),
	                "%"
	              )
	            )
	          )
	        ),
	        showOutstanding && _react2.default.createElement(
	          _style2.default.LenderInnerCard,
	          null,
	          _react2.default.createElement(
	            _style2.default.LenderInnerLabel,
	            null,
	            "Net Amount " + amountVerb + " Year " + roundNumber
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderBalanceBig,
	            {
	              theme: preset.theme,
	              style: amountSign < 0 ? { color: '#FE7474' } : undefined
	            },
	            _react2.default.createElement(CountUp, { value: amountSign, format: formatFullDollar })
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderBalanceSplit,
	            null,
	            _react2.default.createElement(
	              _style2.default.LenderBalanceSplitCol,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderBalanceSplitLabel,
	                null,
	                "Outstanding Balance"
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderBalanceSplitValue,
	                { theme: preset.theme },
	                _react2.default.createElement(CountUp, { value: lender.outstanding, format: formatFullDollar })
	              )
	            )
	          )
	        ),
	        !hideSelectButton && _react2.default.createElement(
	          _style2.default.LenderSelectButton,
	          {
	            theme: preset.theme,
	            onClick: function onClick() {
	              return _this3.handleSelectLenderInternal(lender);
	            }
	          },
	          "Select"
	        )
	      );
	    };
	
	    _this3.renderManageLoanPanel = function (lender) {
	      var preset = pickPreset(lender.name, 0);
	      var _this3$state5 = _this3.state,
	          borrowAmount = _this3$state5.borrowAmount,
	          repayAmount = _this3$state5.repayAmount,
	          postingBorrow = _this3$state5.postingBorrow,
	          postingRepay = _this3$state5.postingRepay,
	          cashBalance = _this3$state5.cashBalance;
	      var roundNumber = _this3.props.roundNumber;
	
	      var showRepaySection = Number(cashBalance) >= 0 && Number(roundNumber) > 1;
	
	      var existingBorrow = Math.round(Number(lender.currentRoundBorrow || 0));
	      var hasExistingBorrow = existingBorrow > 0;
	      var borrowDisplay = borrowAmount !== '' ? Number(borrowAmount).toLocaleString() : '';
	      var borrowChanged = borrowAmount !== '' && Number(borrowAmount) !== existingBorrow;
	
	      var existingRepay = Math.round(Number(lender.currentRoundPrincipalRepaid || 0) + Number(lender.currentRoundInterestRepaid || 0));
	      var hasExistingRepay = existingRepay > 0;
	      var repayDisplay = repayAmount !== '' ? Number(repayAmount).toLocaleString() : '';
	      var repayChanged = repayAmount !== '' && Number(repayAmount) !== existingRepay;
	
	      return _react2.default.createElement(
	        _style2.default.ManageLoanPanel,
	        null,
	        _react2.default.createElement(
	          _style2.default.ManageLoanTitle,
	          null,
	          "Manage Your Loan"
	        ),
	        _react2.default.createElement(
	          _style2.default.ManageLoanSubtitle,
	          null,
	          "Set how much you'd like to borrow this round and manage any prior balances."
	        ),
	        _react2.default.createElement(
	          _style2.default.ManageLoanSection,
	          { theme: preset.theme },
	          _react2.default.createElement(
	            _style2.default.ManageSectionTitle,
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Amount to Borrow This Round"
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.ManageSectionDescription,
	            null,
	            lender.name,
	            " can lend up to ",
	            numberToM(lender.maxAmount),
	            " based on your current debt-to-capital ratio."
	          ),
	          _react2.default.createElement(
	            _style2.default.ManageInputRow,
	            null,
	            _react2.default.createElement(
	              _style2.default.ManageAmountField,
	              null,
	              _react2.default.createElement(
	                _style2.default.ManageAmountPrefix,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(_style2.default.ManageAmountInput, {
	                type: "text",
	                inputMode: "numeric",
	                value: borrowDisplay,
	                onChange: _this3.handleBorrowAmountChange,
	                placeholder: "0"
	              })
	            ),
	            hasExistingBorrow ? _react2.default.createElement(
	              _style2.default.ManageUpdateButton,
	              {
	                onClick: _this3.handlePostBorrow,
	                disabled: postingBorrow || !borrowChanged
	              },
	              postingBorrow ? 'UPDATING...' : 'UPDATE'
	            ) : _react2.default.createElement(
	              _style2.default.ManagePostButton,
	              {
	                theme: preset.theme,
	                onClick: _this3.requestBorrow,
	                disabled: postingBorrow
	              },
	              postingBorrow ? 'BORROWING...' : 'BORROW'
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.ManageMetaRow,
	            null,
	            _react2.default.createElement(
	              _style2.default.ManageMetaLabel,
	              null,
	              "Available to Borrow:"
	            ),
	            _react2.default.createElement(
	              _style2.default.ManageMetaValue,
	              null,
	              _react2.default.createElement(CountUp, { value: lender.maxAmount, format: numberToM })
	            )
	          )
	        ),
	        showRepaySection && _react2.default.createElement(
	          _style2.default.ManageLoanSection,
	          { theme: preset.theme },
	          _react2.default.createElement(
	            _style2.default.ManageSectionTitle,
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Repay Prior Year Balance"
	            ),
	            _react2.default.createElement(
	              "span",
	              { style: { fontSize: 14, color: 'rgba(0,27,59,0.6)' } },
	              "OUTSTANDING ",
	              _react2.default.createElement(
	                "strong",
	                { style: { color: '#001B3B', marginLeft: 8 } },
	                _react2.default.createElement(CountUp, { value: lender.priorYearOutstanding, format: numberToM })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.ManageSectionDescription,
	            null,
	            "Pay down any outstanding balance from previous rounds to reduce your interest burden."
	          ),
	          _react2.default.createElement(
	            _style2.default.ManageInputRow,
	            null,
	            _react2.default.createElement(
	              _style2.default.ManageAmountField,
	              null,
	              _react2.default.createElement(
	                _style2.default.ManageAmountPrefix,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(_style2.default.ManageAmountInput, {
	                type: "text",
	                inputMode: "numeric",
	                value: repayDisplay,
	                onChange: _this3.handleRepayAmountChange,
	                placeholder: "0"
	              })
	            ),
	            hasExistingRepay ? _react2.default.createElement(
	              _style2.default.ManageUpdateButton,
	              {
	                onClick: _this3.handlePostRepay,
	                disabled: postingRepay || !repayChanged
	              },
	              postingRepay ? 'UPDATING...' : 'UPDATE'
	            ) : _react2.default.createElement(
	              _style2.default.ManagePostButton,
	              {
	                theme: preset.theme,
	                onClick: _this3.handlePostRepay,
	                disabled: postingRepay
	              },
	              postingRepay ? 'REPAYING...' : 'REPAY'
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.ManageMetaRow,
	            null,
	            _react2.default.createElement(
	              _style2.default.ManageMetaLabel,
	              null,
	              "Your Available Cash Balance:"
	            ),
	            _react2.default.createElement(
	              _style2.default.ManageMetaValue,
	              null,
	              _react2.default.createElement(CountUp, { value: cashBalance, format: formatFullDollar })
	            )
	          )
	        )
	      );
	    };
	
	    _this3.state = {
	      loading: true,
	      lenders: [],
	      totalExistingDebt: 0,
	      netCapital: 0,
	      debtToCapital: 0,
	      cashBalance: 0,
	      selectedLenderId: null,
	      borrowAmount: '',
	      repayAmount: '',
	      playerId: 0,
	      postingBorrow: false,
	      postingRepay: false,
	      noticeOpen: false,
	      noticeTitle: '',
	      noticeMessage: '',
	      // Borrow confirmation modal — shows loan amount, interest rate,
	      // and maturity before committing to the POST. See requestBorrow
	      // / confirmBorrow / cancelBorrowConfirm below.
	      borrowConfirmOpen: false,
	      // Interest rate fetched on the fly from the debt_conditions
	      // endpoint when the user clicks BORROW. Null while the request
	      // is in flight (or unknown), a number when we have a value.
	      borrowConfirmRate: null,
	      borrowConfirmLoadingRate: false
	    };
	    return _this3;
	  }
	
	  _createClass(DebtDecisionsPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.fetchAll();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	
	    // Pull an error message out of an HTTP error. Looks at common shapes:
	    //   - body.detail            (DRF default)
	    //   - body.non_field_errors  (DRF validators)
	    //   - any field-level error  (e.g. { amount: ["..."] })
	    //   - plain string body
	    // Returns null when nothing usable is found.
	
	
	    // Runs the same validation checks as handlePostBorrow but returns
	    // {title, message} on failure so callers can surface the error
	    // BEFORE showing a confirmation dialog. Returns null on success.
	
	
	    // Called from the BORROW button (POST only). Validates first so
	    // errors surface immediately, then fetches the current interest
	    // rate from the debt_conditions endpoint and opens the confirmation
	    // modal with the actual rate. Bulk-response rate can be 0/missing
	    // for some lenders — this call always returns the live rate for
	    // the requested amount.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          loading = _state.loading,
	          lenders = _state.lenders,
	          totalExistingDebt = _state.totalExistingDebt,
	          netCapital = _state.netCapital,
	          debtToCapital = _state.debtToCapital,
	          selectedLenderId = _state.selectedLenderId,
	          noticeOpen = _state.noticeOpen,
	          noticeTitle = _state.noticeTitle,
	          noticeMessage = _state.noticeMessage;
	
	      var selectedLender = selectedLenderId ? lenders.find(function (l) {
	        return l.client_id === selectedLenderId;
	      }) : null;
	
	      // Build progress bar segments based on lender D/C limits, sorted ascending.
	      // Each lender's limit is a threshold; the bar shows green up to lender 1's
	      // limit, yellow to lender 2's, red to lender 3's, dark beyond.
	      var sortedByLimit = [].concat(_toConsumableArray(lenders)).sort(function (a, b) {
	        return a.dcLimit - b.dcLimit;
	      });
	      var segmentColorKeys = ["green", "yellow", "red"];
	
	      var currentRatioPct = Math.min(100, Math.max(0, debtToCapital * 100));
	
	      // Build segments cumulative widths up to 100%
	      var prevLimit = 0;
	      var segments = [];
	      sortedByLimit.forEach(function (lender, idx) {
	        var limitPct = Math.min(100, lender.dcLimit * 100);
	        var width = Math.max(0, limitPct - prevLimit);
	        segments.push({
	          color: SEGMENT_COLORS[segmentColorKeys[idx] || "red"],
	          width: width,
	          labelPct: limitPct,
	          labelText: lender.name.split(" ")[0] + " " + limitPct.toFixed(0) + "%",
	          labelColor: SEGMENT_COLORS[segmentColorKeys[idx] || "red"]
	        });
	        prevLimit = limitPct;
	      });
	      if (prevLimit < 100) {
	        segments.push({
	          color: SEGMENT_COLORS.black,
	          width: 100 - prevLimit
	        });
	      }
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        _react2.default.createElement(
	          _style2.default.LenderModalHeader,
	          null,
	          _react2.default.createElement(
	            _style2.default.LenderModalTitle,
	            null,
	            "Choose Your Lender"
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderModalSubtitle,
	            null,
	            "Select one or more lenders to fund your business. Each lender comes with different terms. The higher your debt to capital ratio, the less you can borrow."
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderModalClose,
	            { onClick: onClose, "aria-label": "Close" },
	            "x"
	          )
	        ),
	        loading && _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", padding: 60 } },
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        ),
	        !loading && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _style2.default.LenderStatusBar,
	            null,
	            _react2.default.createElement(
	              _style2.default.LenderStatusLeft,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderStatusItem,
	                { divider: true },
	                _react2.default.createElement(
	                  _style2.default.LenderStatusLabel,
	                  null,
	                  "Net Capital Raised/Returned"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderStatusValue,
	                  { style: { color: netCapital < 0 ? '#C62828' : undefined } },
	                  _react2.default.createElement(CountUp, { value: netCapital, format: numberToM })
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderStatusItem,
	                null,
	                _react2.default.createElement(
	                  _style2.default.LenderStatusLabel,
	                  null,
	                  "Your Existing Debt"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderStatusValue,
	                  null,
	                  _react2.default.createElement(CountUp, { value: totalExistingDebt, format: numberToM })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _style2.default.LenderStatusRight,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderStatusRightLabel,
	                null,
	                "Your Current Debt / Capital Ratio"
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderRatioBar,
	                null,
	                segments.map(function (seg, i) {
	                  return _react2.default.createElement(
	                    _style2.default.LenderRatioSegment,
	                    { key: i, color: seg.color, width: seg.width },
	                    seg.labelText && _react2.default.createElement(
	                      _style2.default.LenderRatioMarker,
	                      { color: seg.labelColor, position: 100 },
	                      seg.labelText
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  RatioDotWrapper,
	                  { style: { left: currentRatioPct + "%" } },
	                  _react2.default.createElement(RatioDotVisual, null),
	                  _react2.default.createElement(
	                    RatioTooltip,
	                    { className: "ratio-tooltip" },
	                    (debtToCapital * 100).toFixed(2),
	                    "%"
	                  )
	                )
	              )
	            )
	          ),
	          function () {
	            // Show the "Amount Borrowed/Repaid" section on every card
	            // when any lender has either an outstanding balance OR any
	            // round activity (borrow / repayment / interest payment).
	            // This way a round whose only activity was a full payoff
	            // still surfaces the "Amount Repaid Year N" header.
	            var anyOutstanding = lenders.some(function (l) {
	              return Number(l.outstanding) > 0 || Number(l.currentRoundBorrow) !== 0 || Number(l.currentRoundPrincipalRepaid) !== 0 || Number(l.currentRoundInterestRepaid) !== 0;
	            });
	            return _react2.default.createElement(
	              "div",
	              null,
	              !selectedLender && _react2.default.createElement(
	                _style2.default.LenderGrid,
	                null,
	                lenders.map(function (lender, idx) {
	                  return _this4.renderLenderCard(lender, idx, { showOutstanding: anyOutstanding });
	                })
	              ),
	              selectedLender && _react2.default.createElement(
	                _style2.default.LenderSplit,
	                null,
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.SelectedLenderWrapper,
	                    null,
	                    _this4.renderLenderCard(selectedLender, 0, { withAnimation: false, hideSelectButton: true, showOutstanding: anyOutstanding })
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.ChooseDifferentLenderRow,
	                    null,
	                    _react2.default.createElement(
	                      _style2.default.ChooseDifferentLenderButton,
	                      { onClick: _this4.handleChooseDifferentLender },
	                      "Choose a different Lender"
	                    )
	                  )
	                ),
	                _this4.renderManageLoanPanel(selectedLender)
	              )
	            );
	          }()
	        ),
	        noticeOpen && function () {
	          var isNoCeoProjections = typeof noticeMessage === 'string' && /no ceo projections/i.test(noticeMessage);
	          var handleAction = function handleAction() {
	            _this4.hideNotice();
	            if (isNoCeoProjections && typeof _this4.props.onGoToCeoProjections === 'function') {
	              _this4.props.onGoToCeoProjections();
	            }
	          };
	          var displayMessage = isNoCeoProjections ? "Before you can raise capital, the CEO needs to submit financial projections for this round. Lenders use those projections to decide how much they'll offer. Head to CEO Decisions to enter them, then come back to borrow." : noticeMessage;
	          return _react2.default.createElement(
	            _style2.default.LenderNoticeOverlay,
	            { onClick: _this4.hideNotice },
	            _react2.default.createElement(
	              _style2.default.LenderNoticeModal,
	              { onClick: function onClick(e) {
	                  return e.stopPropagation();
	                } },
	              _react2.default.createElement(
	                _style2.default.LenderNoticeTitle,
	                null,
	                noticeTitle
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeMessage,
	                null,
	                displayMessage
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeActions,
	                null,
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeButton,
	                  { onClick: handleAction },
	                  isNoCeoProjections ? 'Check CEO Projections' : 'OK'
	                )
	              )
	            )
	          );
	        }(),
	        this.state.borrowConfirmOpen && function () {
	          var lender = (_this4.state.lenders || []).find(function (l) {
	            return l.client_id === _this4.state.selectedLenderId;
	          });
	          var amount = Number(_this4.state.borrowAmount) || 0;
	          // Prefer the live rate fetched from debt_conditions when
	          // the user clicked BORROW. Fall back to the lender's card
	          // rate (from the bulk endpoint) if the fetch hasn't
	          // returned yet AND the card had a positive value.
	          var fetchedRate = _this4.state.borrowConfirmRate;
	          var cardRate = lender ? Number(lender.rate || 0) : 0;
	          var rate = fetchedRate != null ? Number(fetchedRate) : cardRate;
	          var rateLabel = _this4.state.borrowConfirmLoadingRate && fetchedRate == null ? 'Loading…' : rate > 0 ? (rate * 100).toFixed(1) + "%" : '--';
	          return _react2.default.createElement(
	            _style2.default.LenderNoticeOverlay,
	            { onClick: _this4.cancelBorrowConfirm },
	            _react2.default.createElement(
	              _style2.default.LenderNoticeModal,
	              { onClick: function onClick(e) {
	                  return e.stopPropagation();
	                } },
	              _react2.default.createElement(
	                _style2.default.LenderNoticeTitle,
	                null,
	                "Confirm Loan Terms"
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeMessage,
	                null,
	                "Review the loan terms below before you commit. Once accepted, ",
	                lender ? lender.name : 'this lender',
	                " will hold the loan on your books until you repay it."
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeTermsList,
	                null,
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermLabel,
	                  null,
	                  "Lender"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermValue,
	                  null,
	                  lender ? lender.name : '--'
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermLabel,
	                  null,
	                  "Loan Amount"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermValue,
	                  null,
	                  "$",
	                  amount.toLocaleString('en-US')
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermLabel,
	                  null,
	                  "Interest Rate"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermValue,
	                  null,
	                  rateLabel
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermLabel,
	                  null,
	                  "Maturity"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeTermValue,
	                  null,
	                  "8 years"
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeActions,
	                null,
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeCancelButton,
	                  { onClick: _this4.cancelBorrowConfirm },
	                  "Cancel"
	                ),
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeButton,
	                  { onClick: _this4.confirmBorrow },
	                  "Accept"
	                )
	              )
	            )
	          );
	        }()
	      );
	    }
	  }]);
	
	  return DebtDecisionsPage;
	}(_react.PureComponent);
	
	exports.default = DebtDecisionsPage;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateY(0); }\n  50%     { transform: translateY(-3px); }\n"], ["\n  0%, 100% { transform: translateY(0); }\n  50%     { transform: translateY(-3px); }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  0%, 100% { opacity: 0.55; transform: scale(1); }\n  50%     { opacity: 0.95; transform: scale(1.08); }\n"], ["\n  0%, 100% { opacity: 0.55; transform: scale(1); }\n  50%     { opacity: 0.95; transform: scale(1.08); }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  0%, 100% { transform: translateY(0); }\n  50%     { transform: translateY(-4px); }\n"], ["\n  0%, 100% { transform: translateY(0); }\n  50%     { transform: translateY(-4px); }\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  0%, 100% { transform: scaleY(1)   translateY(0); opacity: 0.9; }\n  50%     { transform: scaleY(1.25) translateY(2px); opacity: 1; }\n"], ["\n  0%, 100% { transform: scaleY(1)   translateY(0); opacity: 0.9; }\n  50%     { transform: scaleY(1.25) translateY(2px); opacity: 1; }\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  0%, 100% { transform: scale(1); }\n  50%     { transform: scale(1.03); }\n"], ["\n  0%, 100% { transform: scale(1); }\n  50%     { transform: scale(1.03); }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  0%   { transform: rotateY(0deg); }\n  100% { transform: rotateY(360deg); }\n"], ["\n  0%   { transform: rotateY(0deg); }\n  100% { transform: rotateY(360deg); }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: inherit;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: inherit;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  animation: ", " 3.2s ease-in-out infinite;\n"], ["\n  transform-origin: center;\n  animation: ", " 3.2s ease-in-out infinite;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  transform-box: fill-box;\n  animation: ", " 2.6s ease-in-out infinite;\n"], ["\n  transform-origin: center;\n  transform-box: fill-box;\n  animation: ", " 2.6s ease-in-out infinite;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  animation: ", " 2.2s ease-in-out infinite;\n"], ["\n  transform-origin: center;\n  animation: ", " 2.2s ease-in-out infinite;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  transform-origin: center top;\n  transform-box: fill-box;\n  animation: ", " 0.6s ease-in-out infinite;\n"], ["\n  transform-origin: center top;\n  transform-box: fill-box;\n  animation: ", " 0.6s ease-in-out infinite;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  animation: ", " 3.6s ease-in-out infinite;\n"], ["\n  transform-origin: center;\n  animation: ", " 3.6s ease-in-out infinite;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  transform-origin: center;\n  transform-box: fill-box;\n  animation: ", " 3.4s linear infinite;\n"], ["\n  transform-origin: center;\n  transform-box: fill-box;\n  animation: ", " 3.4s linear infinite;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: not-allowed;\n\n  /* Dim the underlying card and block interactions with its children. */\n  > * {\n    opacity: 0.45;\n    filter: grayscale(0.65);\n    pointer-events: none;\n  }\n"], ["\n  position: relative;\n  cursor: not-allowed;\n\n  /* Dim the underlying card and block interactions with its children. */\n  > * {\n    opacity: 0.45;\n    filter: grayscale(0.65);\n    pointer-events: none;\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 10px 18px;\n  border-radius: 999px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.4;\n  white-space: nowrap;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 120ms ease;\n  z-index: 3;\n\n  ", ":hover & {\n    opacity: 1;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 10px 18px;\n  border-radius: 999px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.4;\n  white-space: nowrap;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 120ms ease;\n  z-index: 3;\n\n  ", ":hover & {\n    opacity: 1;\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex: 1;\n\n  &:hover > span.year1-lock-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  flex: 1;\n\n  &:hover > span.year1-lock-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 280px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 280px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _ApiService = __webpack_require__(4);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Subtle on-card animations per investor type. Each runs forever so
	// the card has a small bit of life even when the user is just hovering
	// the picker. Durations are slow (3-4s) so the motion never competes
	// with the form below.
	var floatY = (0, _styledComponents.keyframes)(_templateObject);
	
	var haloGlow = (0, _styledComponents.keyframes)(_templateObject2);
	
	var liftRocket = (0, _styledComponents.keyframes)(_templateObject3);
	
	var flameFlicker = (0, _styledComponents.keyframes)(_templateObject4);
	
	var vaultPulse = (0, _styledComponents.keyframes)(_templateObject5);
	
	var coinSpin = (0, _styledComponents.keyframes)(_templateObject6);
	
	// SVG canvas wrapper — keeps the 84×84 card slot from changing size as
	// the children animate. overflow: hidden so a stray translateY doesn't
	// bleed past the rounded border on the EquityLogo box.
	var InvestorArtFrame = _styledComponents2.default.div(_templateObject7);
	
	var AngelFloat = _styledComponents2.default.g(_templateObject8, floatY);
	
	var AngelHalo = _styledComponents2.default.ellipse(_templateObject9, haloGlow);
	
	var RocketLift = _styledComponents2.default.g(_templateObject10, liftRocket);
	
	var RocketFlame = _styledComponents2.default.g(_templateObject11, flameFlicker);
	
	var VaultPulse = _styledComponents2.default.g(_templateObject12, vaultPulse);
	
	var VaultCoin = _styledComponents2.default.g(_templateObject13, coinSpin);
	
	function AngelArt() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 64 64", width: "60", height: "60", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "defs",
	      null,
	      _react2.default.createElement(
	        "radialGradient",
	        { id: "angelHalo", cx: "50%", cy: "50%", r: "50%" },
	        _react2.default.createElement("stop", { offset: "0%", stopColor: "#FFE9A8", stopOpacity: "0.9" }),
	        _react2.default.createElement("stop", { offset: "100%", stopColor: "#FFE9A8", stopOpacity: "0" })
	      )
	    ),
	    _react2.default.createElement(AngelHalo, { cx: "32", cy: "14", rx: "14", ry: "5", fill: "url(#angelHalo)" }),
	    _react2.default.createElement(
	      AngelFloat,
	      null,
	      _react2.default.createElement("path", { d: "M16 32 C 10 28, 8 36, 14 40 C 18 42, 22 40, 22 36 Z", fill: "#EFE7FE", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("path", { d: "M48 32 C 54 28, 56 36, 50 40 C 46 42, 42 40, 42 36 Z", fill: "#EFE7FE", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("ellipse", { cx: "32", cy: "14", rx: "9", ry: "2.5", fill: "none", stroke: "#F2B900", strokeWidth: "1.5" }),
	      _react2.default.createElement("circle", { cx: "32", cy: "22", r: "6.5", fill: "#FFD8B3", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("path", { d: "M29 23.5 Q 32 26 35 23.5", fill: "none", stroke: "#5C3D8A", strokeWidth: "1.1", strokeLinecap: "round" }),
	      _react2.default.createElement("path", { d: "M22 48 C 22 36, 42 36, 42 48 L 40 52 L 24 52 Z", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.4" })
	    )
	  );
	}
	
	function RocketArt() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 64 64", width: "60", height: "60", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      RocketLift,
	      null,
	      _react2.default.createElement(
	        RocketFlame,
	        null,
	        _react2.default.createElement("path", { d: "M26 46 Q 32 60 38 46 Q 34 52 32 52 Q 30 52 26 46 Z", fill: "#FFB347" }),
	        _react2.default.createElement("path", { d: "M28 46 Q 32 56 36 46 Q 34 50 32 50 Q 30 50 28 46 Z", fill: "#FFE066" })
	      ),
	      _react2.default.createElement("path", { d: "M18 38 L 24 32 L 24 46 Z", fill: "#7B5BE5" }),
	      _react2.default.createElement("path", { d: "M46 38 L 40 32 L 40 46 Z", fill: "#7B5BE5" }),
	      _react2.default.createElement("rect", { x: "24", y: "20", width: "16", height: "28", rx: "8", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.4" }),
	      _react2.default.createElement("path", { d: "M24 20 Q 32 4 40 20 Z", fill: "#A98DF6" }),
	      _react2.default.createElement("circle", { cx: "32", cy: "30", r: "4", fill: "#EFE7FE", stroke: "#7B5BE5", strokeWidth: "1.2" }),
	      _react2.default.createElement("circle", { cx: "32", cy: "30", r: "2", fill: "#7B5BE5" })
	    )
	  );
	}
	
	function VaultArt() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 64 64", width: "60", height: "60", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      VaultPulse,
	      null,
	      _react2.default.createElement("path", { d: "M10 22 L 32 8 L 54 22 Z", fill: "#7B5BE5" }),
	      _react2.default.createElement("rect", { x: "10", y: "22", width: "44", height: "4", fill: "#A98DF6" }),
	      _react2.default.createElement("rect", { x: "14", y: "26", width: "5", height: "22", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("rect", { x: "22", y: "26", width: "5", height: "22", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("rect", { x: "30", y: "26", width: "5", height: "22", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("rect", { x: "38", y: "26", width: "5", height: "22", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("rect", { x: "46", y: "26", width: "5", height: "22", fill: "#FFFFFF", stroke: "#A98DF6", strokeWidth: "1.2" }),
	      _react2.default.createElement("rect", { x: "8", y: "48", width: "48", height: "6", rx: "1", fill: "#7B5BE5" })
	    ),
	    _react2.default.createElement(
	      VaultCoin,
	      null,
	      _react2.default.createElement("circle", { cx: "32", cy: "44", r: "6", fill: "#F2B900", stroke: "#7B5BE5", strokeWidth: "1" }),
	      _react2.default.createElement(
	        "text",
	        { x: "32", y: "47.5", fontSize: "7", fontFamily: "Mukta Vaani, Lato, sans-serif",
	          fontWeight: "700", textAnchor: "middle", fill: "#7B5BE5" },
	        "$"
	      )
	    )
	  );
	}
	
	function renderInvestorArt(iconKey) {
	  switch (iconKey) {
	    case "angel":
	      return _react2.default.createElement(AngelArt, null);
	    case "rocket":
	      return _react2.default.createElement(RocketArt, null);
	    case "vault":
	      return _react2.default.createElement(VaultArt, null);
	    default:
	      return null;
	  }
	}
	
	// Static per-investor presentation. Keyed by equity_client name
	// (case-insensitive substring match). Falls back to index-based shade
	// + generic stage label for unknown investors.
	var INVESTOR_PRESETS = [{
	  match: /angel/i,
	  shade: "light",
	  iconKey: "angel",
	  tagline: "Believers with capital",
	  stage: "EARLY STAGE",
	  description: "Wealthy individuals investing personal money. Founder-friendly, patient, and often your first cheerleader, but limited check size."
	}, {
	  match: /venture/i,
	  shade: "mid",
	  iconKey: "rocket",
	  tagline: "Rocket fuel for hypergrowth",
	  stage: "GROWTH STAGE",
	  description: "Professional fund managers chasing 10x+ returns. Aggressive growth expectations, board seats, and access to a powerful network and follow-on capital."
	}, {
	  match: /private equity|p\.?e\.?$/i,
	  shade: "dark",
	  iconKey: "vault",
	  tagline: "We buy companies, not stories",
	  stage: "MATURE STAGE",
	  description: "Institutional capital seeking proven cash flow. Massive checks but expects majority control, operational discipline, and a clear exit within 3 to 5 years."
	}];
	
	var THEME_BY_INDEX = ["light", "mid", "dark"];
	
	function pickPreset(name, index) {
	  var byName = INVESTOR_PRESETS.find(function (p) {
	    return p.match.test(name || "");
	  });
	  if (byName) return byName;
	  var fallbackIcons = ["angel", "rocket", "vault"];
	  return {
	    shade: THEME_BY_INDEX[index] || "light",
	    iconKey: fallbackIcons[index] || null,
	    tagline: "",
	    stage: index === 0 ? "EARLY STAGE" : index === 1 ? "GROWTH STAGE" : "MATURE STAGE",
	    description: ""
	  };
	}
	
	var formatFullDollar = function formatFullDollar(val) {
	  var n = Math.round(Number(val) || 0);
	  var sign = n < 0 ? "-" : "";
	  return sign + "$" + Math.abs(n).toLocaleString("en-US");
	};
	
	var formatNumber = function formatNumber(val) {
	  var n = Math.round(Number(val) || 0);
	  return n.toLocaleString("en-US");
	};
	
	var numberToM = function numberToM(val) {
	  var n = Number(val) || 0;
	  var sign = n < 0 ? "-" : "";
	  var abs = Math.abs(n);
	  return sign + "$" + (abs / 1000000).toFixed(abs >= 10000000 ? 2 : 3) + "M";
	};
	
	var formatSharePrice = function formatSharePrice(val) {
	  return "$" + (Number(val) || 0).toFixed(2);
	};
	var formatPlainInt = function formatPlainInt(val) {
	  return Math.round(Number(val) || 0).toLocaleString('en-US');
	};
	
	var LockedCardWrapper = _styledComponents2.default.div(_templateObject14);
	
	var LockedTooltip = _styledComponents2.default.div(_templateObject15, LockedCardWrapper);
	
	// Wrapper + tooltip for Buyback / Pay Dividends tabs that are locked
	// in Year 1. Same pattern used elsewhere: disabled child kills its own
	// pointer-events so the wrapper's :hover reliably fires and the anchor
	// sits on the container instead of the disabled button.
	var Year1LockTooltipWrapper = _styledComponents2.default.span(_templateObject16);
	
	var Year1LockTooltip = _styledComponents2.default.span(_templateObject17);
	
	// Animates between numeric values whenever `value` changes (rAF + ease-out
	// cubic, 600ms). Mirrors the CountUp used on Choose Your Lender. Renders
	// inside a <span> because React 15 requires component render to return an
	// element, not a bare string.
	
	var CountUp = function (_PureComponent) {
	  _inherits(CountUp, _PureComponent);
	
	  function CountUp(props) {
	    _classCallCheck(this, CountUp);
	
	    var _this = _possibleConstructorReturn(this, (CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call(this, props));
	
	    _this.state = { display: Number(props.value) || 0 };
	    return _this;
	  }
	
	  _createClass(CountUp, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var next = Number(this.props.value) || 0;
	      var prev = Number(prevProps.value) || 0;
	      if (next !== prev) {
	        this.animateTo(this.state.display, next);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._cancelled = true;
	    }
	  }, {
	    key: "animateTo",
	    value: function animateTo(from, to) {
	      var _this2 = this;
	
	      if (this._raf) cancelAnimationFrame(this._raf);
	      var duration = 600;
	      var start = typeof performance !== 'undefined' ? performance.now() : Date.now();
	      var step = function step() {
	        if (_this2._cancelled) return;
	        var elapsed = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
	        var t = Math.min(elapsed / duration, 1);
	        var eased = 1 - Math.pow(1 - t, 3);
	        var value = from + (to - from) * eased;
	        _this2.setState({ display: t === 1 ? to : value });
	        if (t < 1) {
	          _this2._raf = requestAnimationFrame(step);
	        }
	      };
	      this._raf = requestAnimationFrame(step);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var format = this.props.format;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        format(this.state.display)
	      );
	    }
	  }]);
	
	  return CountUp;
	}(_react.PureComponent);
	
	var EquityDecisionsPage = function (_PureComponent2) {
	  _inherits(EquityDecisionsPage, _PureComponent2);
	
	  function EquityDecisionsPage(props) {
	    _classCallCheck(this, EquityDecisionsPage);
	
	    var _this3 = _possibleConstructorReturn(this, (EquityDecisionsPage.__proto__ || Object.getPrototypeOf(EquityDecisionsPage)).call(this, props));
	
	    _this3.showPopupTooManyShares = function (sharePriceLabel) {
	      _this3.eventemitter.trigger("coaching-feedback", ["Issuing Ownership", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Make it rain! Raise that equity! But don't forget, you are issuing a lot of shares at a very low price of ",
	        sharePriceLabel,
	        ".",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Pop quiz: If you expect your business value to increase over time (i.e. expect your share price to go up), would you rather issue so many shares at a lower price today or wait to issue at a higher price tomorrow?"
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "To learn more about your capital raising limits, please read The Investor section of the Business Case."
	      )]);
	    };
	
	    _this3.showPopupTooFewShares = function (sharePriceLabel, capitalRaised) {
	      var capitalFormatted = Math.round(Number(capitalRaised) || 0).toLocaleString("en-US");
	      _this3.eventemitter.trigger("coaching-feedback", ["Issuing Ownership", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Very Interesting. You're only raising $",
	        capitalFormatted,
	        " of equity capital! I get it, you don't want to issue ownership shares at this very low price of ",
	        sharePriceLabel,
	        ", but is that enough equity to raise? You could try to raise your remaining capital needs through debt, but your borrowing limits is based on your equity raised (i.e. the more equity raised, the more money lenders will lend)."
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "To learn more about your capital raising limits, please read The Investor section of the Business Case."
	      )]);
	    };
	
	    _this3.buildStateFromDecisions = function (decisions) {
	      var _this3$props = _this3.props,
	          roundId = _this3$props.roundId,
	          roundNumber = _this3$props.roundNumber,
	          isActiveRound = _this3$props.isActiveRound;
	
	      var equityClients = decisions.equity_clients || [];
	      var equities = decisions.equities || [];
	      var repurchasedSharesArr = decisions.repurchased_shares || decisions.stock_repurchased || [];
	      var dividendsPaymentArr = decisions.dividends_payments || decisions.dividends_payment || decisions.dividend_payments || [];
	      var preMoneysArr = decisions.pre_moneys || decisions.pre_money || [];
	      var postMoneysArr = decisions.post_moneys || [];
	      var performanceMoneysArr = decisions.performance_moneys || [];
	      var constantsObj = decisions.constants || {};
	      var financial = decisions.financial_decisions && decisions.financial_decisions.team || {};
	
	      // Always filter snapshot arrays by the round we're viewing. The
	      // team-decisions endpoint can return historical rows alongside the
	      // current-round row, so picking by array index gives the wrong
	      // round. Within a round we take the last matching entry to honor
	      // the "latest snapshot" semantic when multiple rows exist.
	      var lastFor = function lastFor(arr, id) {
	        var matches = arr.filter(function (r) {
	          return Number(r.round) === Number(id);
	        });
	        return matches.length > 0 ? matches[matches.length - 1] : null;
	      };
	      var postMoneyRow = lastFor(postMoneysArr, roundId);
	      var perfMoneyRow = lastFor(performanceMoneysArr, roundId);
	
	      // The most recent performance_moneys row for any round prior to the
	      // current one (highest round number < roundId, last entry within
	      // that round). Used as the active-round fallback when post_moneys
	      // hasn't been written yet.
	      var priorPerfRows = performanceMoneysArr.filter(function (r) {
	        return Number(r.round) < Number(roundId);
	      });
	      var maxPriorRoundId = priorPerfRows.reduce(function (m, r) {
	        return Math.max(m, Number(r.round));
	      }, -Infinity);
	      var priorPerfRow = priorPerfRows.length > 0 ? lastFor(priorPerfRows, maxPriorRoundId) : null;
	
	      // Resolve the status-bar trio:
	      //   • Closed round  → performance_moneys for this round
	      //   • Active round, post_moneys present → post_moneys
	      //   • Active round, no post_moneys, round > 1 → prior round's performance_moneys
	      //   • Active round, no post_moneys, round 1   → constants (initial_*)
	      var companyValuation = 0;
	      var sharePrice = 0;
	      var outstandingShares = 0;
	
	      if (!isActiveRound) {
	        if (perfMoneyRow) {
	          companyValuation = Number(perfMoneyRow.equity_value) || 0;
	          sharePrice = Number(perfMoneyRow.share_price) || 0;
	          outstandingShares = Number(perfMoneyRow.shares) || 0;
	        }
	      } else if (postMoneyRow) {
	        companyValuation = Number(postMoneyRow.valuation) || 0;
	        sharePrice = Number(postMoneyRow.share_price) || 0;
	        outstandingShares = Number(postMoneyRow.shares) || 0;
	      } else if (Number(roundNumber) > 1 && priorPerfRow) {
	        companyValuation = Number(priorPerfRow.equity_value) || 0;
	        sharePrice = Number(priorPerfRow.share_price) || 0;
	        outstandingShares = Number(priorPerfRow.shares) || 0;
	      } else {
	        // Active round 1 (or no prior data at all): seed from game constants.
	        companyValuation = Number(constantsObj.initial_valuation) || 0;
	        sharePrice = Number(constantsObj.initial_share_price) || 0;
	        outstandingShares = Number(constantsObj.initial_shares) || 0;
	      }
	
	      // Available Shares to Issue cap:
	      //   1. current round post_moneys.max_share_issuance if present
	      //   2. else prior round pre_moneys.max_share_issuance (highest round
	      //      number < current roundId)
	      var maxShareIssuance = 0;
	      if (postMoneyRow && postMoneyRow.max_share_issuance != null) {
	        maxShareIssuance = Number(postMoneyRow.max_share_issuance) || 0;
	      } else {
	        var priorPreRows = preMoneysArr.filter(function (r) {
	          return Number(r.round) < Number(roundId);
	        });
	        if (priorPreRows.length > 0) {
	          var maxPriorPreRoundId = priorPreRows.reduce(function (m, r) {
	            return Math.max(m, Number(r.round));
	          }, -Infinity);
	          var priorPreRow = lastFor(priorPreRows, maxPriorPreRoundId);
	          maxShareIssuance = priorPreRow ? Number(priorPreRow.max_share_issuance) || 0 : 0;
	        }
	      }
	
	      var cashBalance = Number(financial.ending_cash) || 0;
	
	      var investors = equityClients.map(function (client) {
	        var clientEquities = equities.filter(function (e) {
	          return e.client === client.id;
	        });
	        var clientRepurchases = repurchasedSharesArr.filter(function (r) {
	          return r.client === client.id;
	        });
	        var issuedForClient = clientEquities.reduce(function (sum, e) {
	          return sum + (Number(e.issuance) || 0);
	        }, 0);
	        var capitalInvestedGross = clientEquities.reduce(function (sum, e) {
	          return sum + (Number(e.capital) || 0);
	        }, 0);
	        var repurchasedForClient = clientRepurchases.reduce(function (sum, r) {
	          return sum + (Number(r.shares) || 0);
	        }, 0);
	        // Net Capital Invested = Σ equities.capital − Σ repurchased_shares.cost
	        // (across all rounds for this client).
	        var repurchasedCostForClient = clientRepurchases.reduce(function (sum, r) {
	          return sum + (Number(r.cost) || 0);
	        }, 0);
	        var capitalInvested = capitalInvestedGross - repurchasedCostForClient;
	
	        var capitalLimit = Number(client.capital_limit) || 0;
	        var thisRoundEquity = clientEquities.find(function (e) {
	          return Number(e.round) === Number(roundId);
	        });
	        var thisRoundRepurchase = repurchasedSharesArr.find(function (r) {
	          return r.client === client.id && Number(r.round) === Number(roundId);
	        });
	        var thisRoundDividend = dividendsPaymentArr.find(function (d) {
	          return d.client === client.id && Number(d.round) === Number(roundId);
	        });
	
	        var equityIssuanceThisRound = thisRoundEquity ? Number(thisRoundEquity.issuance) || 0 : 0;
	        var equityCapitalThisRound = thisRoundEquity ? Number(thisRoundEquity.capital) || 0 : 0;
	        var repurchaseSharesThisRound = thisRoundRepurchase ? Number(thisRoundRepurchase.shares) || 0 : 0;
	        var repurchaseCostThisRound = thisRoundRepurchase ? Number(thisRoundRepurchase.cost) || 0 : 0;
	        var dividendPaymentThisRound = thisRoundDividend ? Number(thisRoundDividend.payment) || 0 : 0;
	
	        // Per-round sums used by the card's "Capital Invested/Returned"
	        // block. Sign drives the verb (Invested vs Returned); the displayed
	        // value is the absolute magnitude.
	        //   shares this round   = equities.issuance − repurchased_shares.shares
	        //   capital this round  = equities.capital  − repurchased_shares.cost
	        //                                            − dividends_payments.payment
	        var sharesValueThisRound = equityIssuanceThisRound - repurchaseSharesThisRound;
	        var capitalValueThisRound = equityCapitalThisRound - repurchaseCostThisRound - dividendPaymentThisRound;
	
	        return {
	          client_id: client.id,
	          name: client.name,
	          capitalLimit: capitalLimit,
	          maxAmount: Math.max(0, capitalLimit - capitalInvested),
	          sharesOwned: issuedForClient - repurchasedForClient,
	          capitalInvested: capitalInvested,
	          sharesValueThisRound: sharesValueThisRound,
	          capitalValueThisRound: capitalValueThisRound,
	          equityIdThisRound: thisRoundEquity ? thisRoundEquity.id : null,
	          equityIssuanceThisRound: equityIssuanceThisRound,
	          equityCapitalThisRound: equityCapitalThisRound,
	          repurchaseIdThisRound: thisRoundRepurchase ? thisRoundRepurchase.id : null,
	          repurchaseSharesThisRound: repurchaseSharesThisRound,
	          repurchaseCostThisRound: repurchaseCostThisRound,
	          dividendIdThisRound: thisRoundDividend ? thisRoundDividend.id : null,
	          dividendPaymentThisRound: dividendPaymentThisRound
	        };
	      });
	
	      // Net Capital Raised/Returned for equity (this round) =
	      //   Σ equities.capital - (Σ repurchased_shares.cost + Σ dividends_payments.payment).
	      // Positive = net inflow this round; negative = net outflow (e.g.
	      // dividends paid out). Filter every array to the active round so
	      // the header reflects current-round activity only.
	      var capitalRaised = equities.filter(function (e) {
	        return Number(e.round) === Number(roundId);
	      }).reduce(function (sum, e) {
	        return sum + (Number(e.capital) || 0);
	      }, 0);
	      var repurchaseCost = repurchasedSharesArr.filter(function (r) {
	        return Number(r.round) === Number(roundId);
	      }).reduce(function (sum, r) {
	        return sum + (Number(r.cost) || 0);
	      }, 0);
	      var dividendsPaid = dividendsPaymentArr.filter(function (d) {
	        return Number(d.round) === Number(roundId);
	      }).reduce(function (sum, d) {
	        return sum + (Number(d.payment) || 0);
	      }, 0);
	      var netCapital = capitalRaised - (repurchaseCost + dividendsPaid);
	
	      return {
	        investors: investors,
	        companyValuation: companyValuation,
	        netCapital: netCapital,
	        sharePrice: sharePrice,
	        outstandingShares: outstandingShares,
	        maxShareIssuance: maxShareIssuance,
	        cashBalance: cashBalance
	      };
	    };
	
	    _this3.loadData = function () {
	      var _this3$props2 = _this3.props,
	          roundNumber = _this3$props2.roundNumber,
	          isActiveRound = _this3$props2.isActiveRound;
	
	      return (0, _TeamDecisionsService.fetchTeamDecisions)(roundNumber, "finance").then(function (decisions) {
	        var needsPrior = isActiveRound && (decisions.post_moneys || []).length === 0 && Number(roundNumber) > 1;
	        if (!needsPrior) return { decisions: decisions, priorDecisions: null };
	        return (0, _TeamDecisionsService.fetchTeamDecisions)(Number(roundNumber) - 1, "finance").then(function (priorDecisions) {
	          return { decisions: decisions, priorDecisions: priorDecisions };
	        }).catch(function () {
	          return { decisions: decisions, priorDecisions: null };
	        });
	      });
	    };
	
	    _this3.fetchAll = function () {
	      _this3.loadData().then(function (_ref) {
	        var decisions = _ref.decisions,
	            priorDecisions = _ref.priorDecisions;
	
	        if (!_this3._isMounted) return;
	        _this3.setState(Object.assign({
	          loading: false
	        }, _this3.buildStateFromDecisions(decisions, priorDecisions)));
	      }).catch(function () {
	        if (!_this3._isMounted) return;
	        _this3.setState({ loading: false });
	      });
	    };
	
	    _this3.handleSelectInvestorInternal = function (investor) {
	      // Reset all input state so the next investor starts fresh; render()
	      // shows the existing per-round value as a ghost placeholder.
	      _this3.setState({
	        selectedInvestorId: investor.client_id,
	        activeDecisionTab: 'issue',
	        sharesToIssue: '',
	        sharesToBuyback: '',
	        dividendPerShare: ''
	      });
	    };
	
	    _this3.handleChooseDifferentInvestor = function () {
	      _this3.setState({
	        selectedInvestorId: null,
	        sharesToIssue: '',
	        sharesToBuyback: '',
	        dividendPerShare: ''
	      });
	    };
	
	    _this3.setActiveDecisionTab = function (tab) {
	      _this3.setState({ activeDecisionTab: tab });
	    };
	
	    _this3.handleSharesToIssueChange = function (e) {
	      var val = e.target.value.replace(/[^\d]/g, '');
	      _this3.setState({ sharesToIssue: val });
	    };
	
	    _this3.handleSharesToBuybackChange = function (e) {
	      var val = e.target.value.replace(/[^\d]/g, '');
	      _this3.setState({ sharesToBuyback: val });
	    };
	
	    _this3.handleDividendPerShareChange = function (e) {
	      // Cents-as-you-type: every keystroke shifts the decimal. The state
	      // holds the raw digit string (no decimal); the displayed value is
	      // digits / 100 with .toFixed(2). e.g. "1" → "0.01", "135" → "1.35",
	      // "200" → "2.00". Strip non-digits and any leading zeros so the
	      // numeric value stays accurate without padding indefinitely.
	      var digits = e.target.value.replace(/[^\d]/g, '').replace(/^0+(?=\d)/, '');
	      _this3.setState({ dividendPerShare: digits });
	    };
	
	    _this3.showNotice = function (title, message) {
	      _this3.setState({ noticeOpen: true, noticeTitle: title, noticeMessage: message });
	    };
	
	    _this3.extractBackendError = function (err) {
	      var body = err && err.response && err.response.body;
	      if (!body) return null;
	      if (typeof body === 'string') return body;
	      if (body.detail) return String(body.detail);
	      if (Array.isArray(body.non_field_errors) && body.non_field_errors.length > 0) {
	        return String(body.non_field_errors[0]);
	      }
	      if (body.message) return String(body.message);
	      if (body.error) return String(body.error);
	      // Field-level: { fieldname: ["error msg"] } or { fieldname: "error msg" }
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(body)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          var val = body[key];
	          if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'string') {
	            return key + ": " + val[0];
	          }
	          if (typeof val === 'string' && val.length > 0) {
	            return key + ": " + val;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return null;
	    };
	
	    _this3.hideNotice = function () {
	      _this3.setState({ noticeOpen: false });
	    };
	
	    _this3.refreshAfterPost = function () {
	      // Re-fetch team-decisions (and the prior-round fallback if needed)
	      // so counters and UPDATE buttons pick up the new rows.
	      // Also notify the parent so the Finance Decisions page can
	      // re-fetch its KPIs (debt_to_capital, outstanding debt, etc.).
	      if (typeof _this3.props.onDecisionMade === 'function') {
	        _this3.props.onDecisionMade();
	      }
	      return new Promise(function (resolve) {
	        _this3.loadData().then(function (_ref2) {
	          var decisions = _ref2.decisions,
	              priorDecisions = _ref2.priorDecisions;
	
	          if (!_this3._isMounted) {
	            resolve();return;
	          }
	          _this3.setState(_this3.buildStateFromDecisions(decisions, priorDecisions), resolve);
	        }).catch(function () {
	          return resolve();
	        });
	      });
	    };
	
	    _this3.handlePostIssueShares = function () {
	      var _this3$state = _this3.state,
	          investors = _this3$state.investors,
	          selectedInvestorId = _this3$state.selectedInvestorId,
	          sharesToIssue = _this3$state.sharesToIssue,
	          sharePrice = _this3$state.sharePrice,
	          maxShareIssuance = _this3$state.maxShareIssuance;
	      var roundId = _this3.props.roundId;
	
	      var investor = investors.find(function (i) {
	        return i.client_id === selectedInvestorId;
	      });
	      if (!investor) return;
	
	      var shares = Number(sharesToIssue) || 0;
	      if (shares < 0) {
	        _this3.showNotice('Invalid amount', 'Share amount cannot be negative.');
	        return;
	      }
	
	      // Only validate caps when the user is INCREASING this round's
	      // issuance. If they're modifying down (or leaving it the same), the
	      // current-round Available cap isn't relevant — the existing record
	      // was already accepted, and a smaller value strictly reduces exposure.
	      var existingIssuance = Number(investor.equityIssuanceThisRound) || 0;
	      var isIncreasing = shares > existingIssuance;
	
	      // Available Shares to Issue = min(post_moneys.max_share_issuance for
	      // this round (or prior round's pre_moneys fallback), capital_limit / share_price)
	      var capLimitShares = sharePrice > 0 ? Math.floor(Number(investor.capitalLimit || 0) / sharePrice) : 0;
	      // Use maxShareIssuance directly (not `|| Infinity`) — a value of 0
	      // means "cap exhausted this round" and must be honored, not treated
	      // as missing.
	      var availableToIssue = Math.min(maxShareIssuance, capLimitShares);
	      // availableToIssue is REMAINING capacity net of shares already
	      // booked this round. Compare the incremental delta against it, not
	      // the new total — otherwise editing an existing issuance from
	      // 5.5M up to 6M reads as "6M > 3.5M remaining" even though the
	      // +0.5M delta fits. Same shape as the capital check below.
	      var incrementalShares = shares - existingIssuance;
	      if (isIncreasing && incrementalShares > availableToIssue) {
	        var totalAllowed = existingIssuance + availableToIssue;
	        _this3.showNotice('Exceeds Available Shares to Issue', "You can issue up to " + totalAllowed.toLocaleString('en-US') + " shares to " + investor.name + " this round.");
	        return;
	      }
	
	      // maxAmount is REMAINING capacity beyond capital already booked
	      // (including this round's existing issuance). So compare the
	      // incremental delta the user is adding against maxAmount, not the
	      // new total against maxAmount — otherwise editing an existing
	      // raise from $3.75M up to $6M reads as "$6M > $2.25M remaining"
	      // even though the incremental $2.25M fits exactly.
	      var alreadyRaisedThisRound = Number(investor.equityCapitalThisRound) || 0;
	      var expectedCapital = shares * sharePrice;
	      var incrementalCapital = expectedCapital - alreadyRaisedThisRound;
	      if (isIncreasing && incrementalCapital > investor.maxAmount) {
	        var _totalAllowed = alreadyRaisedThisRound + investor.maxAmount;
	        _this3.showNotice('Exceeds Max Amount', "Expected capital raised of $" + Math.round(expectedCapital).toLocaleString('en-US') + " exceeds what " + investor.name + " can offer. You can raise up to $" + Math.round(_totalAllowed).toLocaleString('en-US') + " in total this round.");
	        return;
	      }
	
	      // Capture BEFORE the POST: is this Round 1 AND the team's first
	      // equity issuance ever? Fires the coaching popup exactly once,
	      // on the very first raise.
	      var wasFirstEquityRd1 = Number(_this3.props.roundNumber) === 1 && !investors.some(function (i) {
	        return Number(i.equityIssuanceThisRound) > 0;
	      });
	
	      _this3.setState({ postingIssue: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var body = { client: investor.client_id, issuance: shares, round: roundId };
	      var req = investor.equityIdThisRound ? (0, _ApiService.putRequest)(apiUrl + "team/equities/" + investor.equityIdThisRound + "/") : (0, _ApiService.postRequest)(apiUrl + "team/equities/");
	
	      req.send(body).then(function (res) {
	        // Coaching popups (ported from raise-equity-modal): issuing
	        // > 4.5M shares warns about too many at low price; issuing
	        // <= 1M shares warns about too little equity for downstream debt.
	        var respBody = res && res.body || {};
	        var issuance = Number(respBody.issuance) || 0;
	        var capital = Number(respBody.capital) || 0;
	        var sharePriceLabel = issuance > 0 ? "$" + (capital / issuance).toFixed(2) : "$0.00";
	        if (issuance > 4500000) {
	          _this3.showPopupTooManyShares(sharePriceLabel);
	        } else if (issuance > 0 && issuance <= 1000000) {
	          _this3.showPopupTooFewShares(sharePriceLabel, capital);
	        }
	        if (wasFirstEquityRd1 && _this3.props.onFirstEquityIssued) {
	          _this3.props.onFirstEquityIssued();
	        }
	        return _this3.refreshAfterPost();
	      }).then(function () {
	        if (!_this3._isMounted) return;
	        _this3.setState({ postingIssue: false, sharesToIssue: '' });
	      }).catch(function (err) {
	        if (!_this3._isMounted) return;
	        var msg = _this3.extractBackendError(err) || 'Failed to post share issuance.';
	        _this3.setState({ postingIssue: false });
	        _this3.showNotice('Post Failed', msg);
	      });
	    };
	
	    _this3.handlePostBuyback = function () {
	      var _this3$state2 = _this3.state,
	          investors = _this3$state2.investors,
	          selectedInvestorId = _this3$state2.selectedInvestorId,
	          sharesToBuyback = _this3$state2.sharesToBuyback,
	          sharePrice = _this3$state2.sharePrice,
	          cashBalance = _this3$state2.cashBalance;
	      var roundId = _this3.props.roundId;
	
	      var investor = investors.find(function (i) {
	        return i.client_id === selectedInvestorId;
	      });
	      if (!investor) return;
	
	      var shares = Number(sharesToBuyback) || 0;
	      if (shares < 0) {
	        _this3.showNotice('Invalid amount', 'Share amount cannot be negative.');
	        return;
	      }
	
	      // Cannot buyback more than this investor currently owns
	      // (issued − previously repurchased from this investor). sharesOwned
	      // already subtracts THIS round's buyback, so add it back to get
	      // the "true" cap and gate on isIncreasing — otherwise editing a
	      // 500-share buyback down to 300 reads as "300 > 0" and false-fires.
	      var existingBuyback = Number(investor.repurchaseSharesThisRound) || 0;
	      var isIncreasing = shares > existingBuyback;
	      var effectiveAvailable = (Number(investor.sharesOwned) || 0) + existingBuyback;
	      if (isIncreasing && shares > effectiveAvailable) {
	        _this3.showNotice('Exceeds Available Shares to Buyback', investor.name + " currently owns " + effectiveAvailable.toLocaleString('en-US') + " shares. You can repurchase up to that amount.");
	        return;
	      }
	
	      // Cash check — only the incremental cost hits cash. The already-
	      // booked buyback cost was deducted when it was posted, so editing
	      // up by 100 shares only needs (100 × sharePrice) in available cash.
	      var newTotalCost = shares * (Number(sharePrice) || 0);
	      var existingBuybackCost = Number(investor.repurchaseCostThisRound) || 0;
	      var additionalCashNeeded = Math.max(0, newTotalCost - existingBuybackCost);
	      if (isIncreasing && additionalCashNeeded > Number(cashBalance || 0)) {
	        _this3.showNotice('Insufficient Cash', "Your available cash balance is " + numberToM(cashBalance) + ". Reduce the buyback amount or raise additional capital first.");
	        return;
	      }
	
	      _this3.setState({ postingBuyback: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var body = { client: investor.client_id, round: roundId, shares: shares };
	      var req = investor.repurchaseIdThisRound ? (0, _ApiService.putRequest)(apiUrl + "team/stock_repurchased/" + investor.repurchaseIdThisRound + "/") : (0, _ApiService.postRequest)(apiUrl + "team/stock_repurchased/");
	
	      req.send(body).then(function () {
	        return _this3.refreshAfterPost();
	      }).then(function () {
	        if (!_this3._isMounted) return;
	        _this3.setState({ postingBuyback: false, sharesToBuyback: '' });
	      }).catch(function (err) {
	        if (!_this3._isMounted) return;
	        var msg = _this3.extractBackendError(err) || 'Failed to post share buyback.';
	        _this3.setState({ postingBuyback: false });
	        _this3.showNotice('Post Failed', msg);
	      });
	    };
	
	    _this3.handlePostDividends = function () {
	      var _this3$state3 = _this3.state,
	          investors = _this3$state3.investors,
	          selectedInvestorId = _this3$state3.selectedInvestorId,
	          dividendPerShare = _this3$state3.dividendPerShare,
	          cashBalance = _this3$state3.cashBalance;
	      var roundId = _this3.props.roundId;
	
	      var investor = investors.find(function (i) {
	        return i.client_id === selectedInvestorId;
	      });
	      if (!investor) return;
	
	      // State stores raw digits (cents-as-you-type); value = digits / 100.
	      var dps = (Number(dividendPerShare) || 0) / 100;
	      // Allow $0 only when updating an existing dividend record (PUT) so
	      // students can cancel a dividend they already paid this round.
	      // Posting a fresh $0 dividend has no effect and is still blocked so
	      // we don't create noise records.
	      var isUpdate = !!investor.dividendIdThisRound;
	      if (dps < 0 || dps === 0 && !isUpdate) {
	        _this3.showNotice('Invalid amount', 'Dividend per share must be greater than zero.');
	        return;
	      }
	
	      // Backend `payment` field expects the Total Payout (dollars paid out),
	      // not the per-share rate. Total Payout = dps × this investor's net
	      // shares owned.
	      var totalPayout = dps * (Number(investor.sharesOwned) || 0);
	      // Cash check — same delta-vs-total rationale as buyback: the prior
	      // dividend payment was already deducted from cashBalance, so only
	      // the incremental payout hits cash on a PUT.
	      var existingPayment = Number(investor.dividendPaymentThisRound) || 0;
	      var isIncreasing = totalPayout > existingPayment;
	      var additionalCashNeeded = Math.max(0, totalPayout - existingPayment);
	      if (isIncreasing && additionalCashNeeded > Number(cashBalance || 0)) {
	        _this3.showNotice('Insufficient Cash', "Your available cash balance is " + numberToM(cashBalance) + ". Reduce the dividend per share or raise additional capital first.");
	        return;
	      }
	
	      _this3.setState({ postingDividends: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var body = {
	        client: investor.client_id,
	        round: roundId,
	        payment: totalPayout
	      };
	      var req = investor.dividendIdThisRound ? (0, _ApiService.putRequest)(apiUrl + "team/dividends_payment/" + investor.dividendIdThisRound + "/") : (0, _ApiService.postRequest)(apiUrl + "team/dividends_payment/");
	
	      req.send(body).then(function () {
	        return _this3.refreshAfterPost();
	      }).then(function () {
	        if (!_this3._isMounted) return;
	        _this3.setState({ postingDividends: false, dividendPerShare: '' });
	      }).catch(function (err) {
	        if (!_this3._isMounted) return;
	        var msg = _this3.extractBackendError(err) || 'Failed to post dividend payment.';
	        _this3.setState({ postingDividends: false });
	        _this3.showNotice('Post Failed', msg);
	      });
	    };
	
	    _this3.renderDecisionPanel = function (investor) {
	      var _this3$state4 = _this3.state,
	          activeDecisionTab = _this3$state4.activeDecisionTab,
	          cashBalance = _this3$state4.cashBalance;
	
	      var isYear1 = Number(_this3.props.roundNumber) === 1;
	      var isNoCash = Number(cashBalance) < 0;
	      // Exception to the no-cash lock: if the team already posted a
	      // buyback or dividend for this investor this round, keep that tab
	      // reachable so they can reduce or cancel the decision and free up
	      // cash. handlePostBuyback / handlePostDividends already gate the
	      // insufficient-cash guard on `isIncreasing`, so reducing an
	      // existing record can't dig the hole any deeper.
	      var hasExistingBuyback = !!investor.repurchaseIdThisRound;
	      var hasExistingDividend = !!investor.dividendIdThisRound;
	      var buybackLocked = isNoCash && !hasExistingBuyback;
	      var dividendsLocked = isNoCash && !hasExistingDividend;
	      var lockedTabStyle = { opacity: 0.5, pointerEvents: 'none', width: '100%' };
	      return _react2.default.createElement(
	        _style2.default.DecisionOptionsWrap,
	        null,
	        _react2.default.createElement(
	          _style2.default.DecisionOptionsTitle,
	          null,
	          "Decision Options"
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionTabBar,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionTab,
	            {
	              active: activeDecisionTab === 'issue',
	              onClick: function onClick() {
	                return _this3.setActiveDecisionTab('issue');
	              }
	            },
	            "Issue Shares"
	          ),
	          isYear1 ? _react2.default.createElement(
	            Year1LockTooltipWrapper,
	            { style: { cursor: 'not-allowed' } },
	            _react2.default.createElement(
	              _style2.default.DecisionTab,
	              { disabled: true, style: lockedTabStyle },
	              "Buyback Shares"
	            ),
	            _react2.default.createElement(
	              Year1LockTooltip,
	              { className: "year1-lock-tooltip" },
	              "Buyback Shares isn't available in Year 1. You'll be able to use it in later years."
	            )
	          ) : buybackLocked ? _react2.default.createElement(
	            Year1LockTooltipWrapper,
	            { style: { cursor: 'not-allowed' } },
	            _react2.default.createElement(
	              _style2.default.DecisionTab,
	              { disabled: true, style: lockedTabStyle },
	              "Buyback Shares"
	            ),
	            _react2.default.createElement(
	              Year1LockTooltip,
	              { className: "year1-lock-tooltip" },
	              "You have insufficient capital to buyback shares."
	            )
	          ) : _react2.default.createElement(
	            _style2.default.DecisionTab,
	            {
	              active: activeDecisionTab === 'buyback',
	              onClick: function onClick() {
	                return _this3.setActiveDecisionTab('buyback');
	              }
	            },
	            "Buyback Shares"
	          ),
	          isYear1 ? _react2.default.createElement(
	            Year1LockTooltipWrapper,
	            { style: { cursor: 'not-allowed' } },
	            _react2.default.createElement(
	              _style2.default.DecisionTab,
	              { disabled: true, style: lockedTabStyle },
	              "Pay Dividends"
	            ),
	            _react2.default.createElement(
	              Year1LockTooltip,
	              { className: "year1-lock-tooltip" },
	              "Pay Dividends isn't available in Year 1. You'll be able to use it in later years."
	            )
	          ) : dividendsLocked ? _react2.default.createElement(
	            Year1LockTooltipWrapper,
	            { style: { cursor: 'not-allowed' } },
	            _react2.default.createElement(
	              _style2.default.DecisionTab,
	              { disabled: true, style: lockedTabStyle },
	              "Pay Dividends"
	            ),
	            _react2.default.createElement(
	              Year1LockTooltip,
	              { className: "year1-lock-tooltip" },
	              "You have insufficient funds to pay dividends."
	            )
	          ) : _react2.default.createElement(
	            _style2.default.DecisionTab,
	            {
	              active: activeDecisionTab === 'dividends',
	              onClick: function onClick() {
	                return _this3.setActiveDecisionTab('dividends');
	              }
	            },
	            "Pay Dividends"
	          )
	        ),
	        activeDecisionTab === 'issue' && _this3.renderIssueSharesPanel(investor),
	        activeDecisionTab === 'buyback' && !isYear1 && !buybackLocked && _this3.renderBuybackPanel(investor),
	        activeDecisionTab === 'dividends' && !isYear1 && !dividendsLocked && _this3.renderDividendsPanel(investor)
	      );
	    };
	
	    _this3.renderIssueSharesPanel = function (investor) {
	      var _this3$state5 = _this3.state,
	          sharesToIssue = _this3$state5.sharesToIssue,
	          postingIssue = _this3$state5.postingIssue,
	          sharePrice = _this3$state5.sharePrice,
	          maxShareIssuance = _this3$state5.maxShareIssuance;
	
	
	      var existingShares = Math.round(Number(investor.equityIssuanceThisRound) || 0);
	      var hasExisting = existingShares > 0;
	      var sharesDisplay = sharesToIssue !== '' ? Number(sharesToIssue).toLocaleString('en-US') : hasExisting ? existingShares.toLocaleString('en-US') : '';
	      var sharesForCalc = sharesToIssue !== '' ? Number(sharesToIssue) || 0 : hasExisting ? existingShares : 0;
	      var capitalRaised = sharesForCalc * sharePrice;
	      var changed = sharesToIssue !== '' && Number(sharesToIssue) !== existingShares;
	      // Available Shares to Issue = min(pre_moneys.max_share_issuance,
	      //                                 equity_clients.capital_limit / share_price)
	      var capLimitShares = sharePrice > 0 ? Math.floor(Number(investor.capitalLimit || 0) / sharePrice) : 0;
	      // Use maxShareIssuance directly (not `|| Infinity`) — a value of 0
	      // means "cap exhausted this round" and must be honored, not treated
	      // as missing.
	      var availableToIssue = Math.min(maxShareIssuance, capLimitShares);
	
	      return _react2.default.createElement(
	        _style2.default.DecisionPanel,
	        null,
	        _react2.default.createElement(
	          _style2.default.DecisionPanelTitle,
	          null,
	          "Issue New Shares to ",
	          investor.name
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionPanelSubtitle,
	          null,
	          "Raise capital by issuing new shares from your authorized pool. New shares dilute existing ownership."
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionInputsRow,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionInputGroup,
	            null,
	            _react2.default.createElement(
	              _style2.default.DecisionInputLabel,
	              null,
	              "Shares to Issue"
	            ),
	            _react2.default.createElement(
	              _style2.default.DecisionAmountField,
	              null,
	              _react2.default.createElement(_style2.default.DecisionAmountInput, {
	                type: "text",
	                inputMode: "numeric",
	                value: sharesDisplay,
	                onChange: _this3.handleSharesToIssueChange,
	                placeholder: "0",
	                hasButton: true
	              }),
	              hasExisting ? _react2.default.createElement(
	                _style2.default.DecisionUpdateButton,
	                {
	                  onClick: _this3.handlePostIssueShares,
	                  disabled: postingIssue || !changed
	                },
	                postingIssue ? 'UPDATING...' : 'UPDATE'
	              ) : _react2.default.createElement(
	                _style2.default.DecisionPostButton,
	                {
	                  onClick: _this3.handlePostIssueShares,
	                  disabled: postingIssue
	                },
	                postingIssue ? 'ISSUING...' : 'ISSUE'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.DecisionInputGroup,
	            null,
	            _react2.default.createElement(
	              _style2.default.DecisionInputLabel,
	              null,
	              "Capital Raised"
	            ),
	            _react2.default.createElement(
	              _style2.default.DecisionAmountField,
	              null,
	              _react2.default.createElement(
	                _style2.default.DecisionAmountPrefix,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(
	                _style2.default.DecisionAmountStatic,
	                null,
	                _react2.default.createElement(CountUp, { value: capitalRaised, format: formatPlainInt })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionFooterRow,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionFooterLabel,
	            null,
	            "Available Shares to Issue in Round " + (Number(_this3.props.roundNumber) || 1) + ":"
	          ),
	          _react2.default.createElement(
	            _style2.default.DecisionFooterValue,
	            null,
	            _react2.default.createElement(CountUp, { value: availableToIssue, format: formatNumber })
	          )
	        )
	      );
	    };
	
	    _this3.renderBuybackPanel = function (investor) {
	      var _this3$state6 = _this3.state,
	          sharesToBuyback = _this3$state6.sharesToBuyback,
	          postingBuyback = _this3$state6.postingBuyback,
	          sharePrice = _this3$state6.sharePrice;
	
	
	      var existingShares = Math.round(Number(investor.repurchaseSharesThisRound) || 0);
	      var existingCost = Number(investor.repurchaseCostThisRound) || 0;
	      var hasExisting = existingShares > 0;
	      var sharesDisplay = sharesToBuyback !== '' ? Number(sharesToBuyback).toLocaleString('en-US') : hasExisting ? existingShares.toLocaleString('en-US') : '';
	      var cashOutflow = sharesToBuyback !== '' ? Number(sharesToBuyback) * sharePrice : hasExisting ? existingCost : 0;
	      var changed = sharesToBuyback !== '' && Number(sharesToBuyback) !== existingShares;
	
	      return _react2.default.createElement(
	        _style2.default.DecisionPanel,
	        null,
	        _react2.default.createElement(
	          _style2.default.DecisionPanelTitle,
	          null,
	          "Shares to Repurchase"
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionPanelSubtitle,
	          null,
	          "Repurchase shares from the investor."
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionInputsRow,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionInputGroup,
	            null,
	            _react2.default.createElement(
	              _style2.default.DecisionInputLabel,
	              null,
	              "Shares to Buyback"
	            ),
	            _react2.default.createElement(
	              _style2.default.DecisionAmountField,
	              null,
	              _react2.default.createElement(_style2.default.DecisionAmountInput, {
	                type: "text",
	                inputMode: "numeric",
	                value: sharesDisplay,
	                onChange: _this3.handleSharesToBuybackChange,
	                placeholder: "0",
	                hasButton: true
	              }),
	              hasExisting ? _react2.default.createElement(
	                _style2.default.DecisionUpdateButton,
	                {
	                  onClick: _this3.handlePostBuyback,
	                  disabled: postingBuyback || !changed
	                },
	                postingBuyback ? 'UPDATING...' : 'UPDATE'
	              ) : _react2.default.createElement(
	                _style2.default.DecisionPostButton,
	                {
	                  onClick: _this3.handlePostBuyback,
	                  disabled: postingBuyback
	                },
	                postingBuyback ? 'BUYING BACK...' : 'BUYBACK'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.DecisionInputGroup,
	            null,
	            _react2.default.createElement(
	              _style2.default.DecisionInputLabel,
	              null,
	              "Cash Outflow"
	            ),
	            _react2.default.createElement(
	              _style2.default.DecisionAmountField,
	              null,
	              _react2.default.createElement(
	                _style2.default.DecisionAmountPrefix,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(
	                _style2.default.DecisionAmountStatic,
	                null,
	                _react2.default.createElement(CountUp, { value: cashOutflow, format: formatPlainInt })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionFooterRow,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionFooterLabel,
	            null,
	            "Available Shares to Buyback:"
	          ),
	          _react2.default.createElement(
	            _style2.default.DecisionFooterValue,
	            null,
	            _react2.default.createElement(CountUp, { value: investor.sharesOwned, format: formatNumber })
	          )
	        )
	      );
	    };
	
	    _this3.renderDividendsPanel = function (investor) {
	      var _this3$state7 = _this3.state,
	          dividendPerShare = _this3$state7.dividendPerShare,
	          postingDividends = _this3$state7.postingDividends,
	          cashBalance = _this3$state7.cashBalance;
	      // Cents-as-you-type: state holds raw digits, displayed value is
	      // digits/100 with 2 decimal places.
	
	      var sharesOwned = Number(investor.sharesOwned) || 0;
	      var existingPayment = Number(investor.dividendPaymentThisRound) || 0;
	      // Existing per-share rate, in cents for state-shape comparison.
	      var existingDpsCents = sharesOwned > 0 ? Math.round(existingPayment / sharesOwned * 100) : 0;
	      var hasExisting = existingPayment > 0 && sharesOwned > 0;
	
	      var typedCents = Number(dividendPerShare) || 0;
	      var cents = dividendPerShare !== '' ? typedCents : hasExisting ? existingDpsCents : 0;
	      var dps = cents / 100;
	      var dividendDisplay = dividendPerShare !== '' ? (typedCents / 100).toFixed(2) : hasExisting ? (existingDpsCents / 100).toFixed(2) : '';
	      var totalPayout = dps * sharesOwned;
	      var changed = dividendPerShare !== '' && typedCents !== existingDpsCents;
	
	      return _react2.default.createElement(
	        _style2.default.DecisionPanel,
	        null,
	        _react2.default.createElement(
	          _style2.default.DecisionPanelTitle,
	          null,
	          "Dividend Payments"
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionPanelSubtitle,
	          null,
	          "Pay cash dividends to this investor."
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionInputsRow,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionInputGroup,
	            null,
	            _react2.default.createElement(
	              _style2.default.DecisionInputLabel,
	              null,
	              "Dividend Per Share"
	            ),
	            _react2.default.createElement(
	              _style2.default.DecisionAmountField,
	              null,
	              _react2.default.createElement(
	                _style2.default.DecisionAmountPrefix,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(_style2.default.DecisionAmountInput, {
	                type: "text",
	                inputMode: "numeric",
	                value: dividendDisplay,
	                onChange: _this3.handleDividendPerShareChange,
	                placeholder: "0.00",
	                hasButton: true
	              }),
	              hasExisting ? _react2.default.createElement(
	                _style2.default.DecisionUpdateButton,
	                {
	                  onClick: _this3.handlePostDividends,
	                  disabled: postingDividends || !changed
	                },
	                postingDividends ? 'UPDATING...' : 'UPDATE'
	              ) : _react2.default.createElement(
	                _style2.default.DecisionPostButton,
	                {
	                  onClick: _this3.handlePostDividends,
	                  disabled: postingDividends || dps <= 0
	                },
	                postingDividends ? 'PAYING...' : 'PAY'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.DecisionInputGroup,
	            null,
	            _react2.default.createElement(
	              _style2.default.DecisionInputLabel,
	              null,
	              "Total Payout"
	            ),
	            _react2.default.createElement(
	              _style2.default.DecisionAmountField,
	              null,
	              _react2.default.createElement(
	                _style2.default.DecisionAmountPrefix,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(
	                _style2.default.DecisionAmountStatic,
	                null,
	                _react2.default.createElement(CountUp, { value: totalPayout, format: formatPlainInt })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _style2.default.DecisionFooterRow,
	          null,
	          _react2.default.createElement(
	            _style2.default.DecisionFooterLabel,
	            null,
	            "Available Cash Balance:"
	          ),
	          _react2.default.createElement(
	            _style2.default.DecisionFooterValue,
	            null,
	            _react2.default.createElement(CountUp, { value: cashBalance, format: numberToM })
	          )
	        )
	      );
	    };
	
	    _this3.renderInvestorCard = function (investor, idx, opts) {
	      var roundNumber = _this3.props.roundNumber;
	
	      var preset = pickPreset(investor.name, idx);
	
	      var _ref3 = opts || {},
	          _ref3$withAnimation = _ref3.withAnimation,
	          withAnimation = _ref3$withAnimation === undefined ? true : _ref3$withAnimation,
	          _ref3$hideSelectButto = _ref3.hideSelectButton,
	          hideSelectButton = _ref3$hideSelectButto === undefined ? false : _ref3$hideSelectButto,
	          _ref3$showExisting = _ref3.showExisting,
	          showExisting = _ref3$showExisting === undefined ? true : _ref3$showExisting;
	
	      // Sign drives the verb (Invested vs Returned, Issued vs Returned).
	      // The displayed numeric value is the absolute magnitude so it reads
	      // naturally next to the label ("Capital Returned: $50,000", not "-$50,000").
	
	
	      var capitalSign = Number(investor.capitalValueThisRound) || 0;
	      var sharesSign = Number(investor.sharesValueThisRound) || 0;
	      var capitalVerb = capitalSign >= 0 ? 'Invested' : 'Returned';
	      var sharesVerb = sharesSign >= 0 ? 'Issued' : 'Returned';
	
	      // Private Equity is a Year 3+ investor; Venture Capital is Year 2+.
	      // Earlier rounds see the card dimmed with an "Available in Year N"
	      // hover message and a disabled Select button — the picker stays
	      // visible so students know the option exists but it can't be
	      // committed until later.
	      var isPrivateEquity = /private equity|p\.?e\.?$/i.test(investor.name || "") || preset.iconKey === "vault";
	      var isVentureCapital = /venture/i.test(investor.name || "") || preset.iconKey === "rocket";
	      var round = Number(roundNumber);
	      var lockMessage = null;
	      if (isPrivateEquity && round < 3) {
	        lockMessage = "Available in Year 3";
	      } else if (isVentureCapital && round < 2) {
	        lockMessage = "Available in Year 2";
	      }
	      var isLocked = lockMessage !== null;
	
	      var cardBody = _react2.default.createElement(
	        _style2.default.EquityCard,
	        {
	          key: investor.client_id,
	          shade: preset.shade,
	          index: withAnimation ? idx : 0,
	          noAnimation: !withAnimation
	        },
	        _react2.default.createElement(
	          _style2.default.EquityCardTop,
	          null,
	          _react2.default.createElement(
	            _style2.default.EquityLogo,
	            null,
	            _react2.default.createElement(
	              InvestorArtFrame,
	              null,
	              renderInvestorArt(preset.iconKey)
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.EquityTitleArea,
	            null,
	            _react2.default.createElement(
	              _style2.default.EquityName,
	              null,
	              investor.name
	            ),
	            preset.tagline && _react2.default.createElement(
	              _style2.default.EquityTagline,
	              null,
	              preset.tagline
	            ),
	            _react2.default.createElement(
	              _style2.default.EquityStageBadge,
	              null,
	              preset.stage
	            )
	          )
	        ),
	        preset.description && _react2.default.createElement(
	          _style2.default.EquityDescription,
	          null,
	          preset.description
	        ),
	        _react2.default.createElement(
	          _style2.default.EquityInnerCard,
	          null,
	          _react2.default.createElement(
	            _style2.default.EquityInnerLabel,
	            null,
	            "Max Amount"
	          ),
	          _react2.default.createElement(
	            _style2.default.EquityInnerDescription,
	            null,
	            "Max amount investor can offer"
	          ),
	          _react2.default.createElement(
	            _style2.default.EquityInnerBigValue,
	            null,
	            _react2.default.createElement(CountUp, { value: investor.maxAmount, format: formatFullDollar })
	          )
	        ),
	        showExisting && _react2.default.createElement(
	          _style2.default.EquityInnerCard,
	          null,
	          _react2.default.createElement(
	            _style2.default.EquityInnerLabel,
	            null,
	            "Capital " + capitalVerb + " Year " + roundNumber
	          ),
	          _react2.default.createElement(
	            _style2.default.EquityExistingRow,
	            null,
	            _react2.default.createElement(
	              _style2.default.EquityExistingCol,
	              null,
	              _react2.default.createElement(
	                _style2.default.EquityExistingLabel,
	                null,
	                "Capital " + capitalVerb
	              ),
	              _react2.default.createElement(
	                _style2.default.EquityExistingValue,
	                {
	                  style: capitalSign < 0 ? { color: '#FE7474' } : undefined
	                },
	                _react2.default.createElement(CountUp, { value: capitalSign, format: formatFullDollar })
	              )
	            ),
	            _react2.default.createElement(
	              _style2.default.EquityExistingCol,
	              null,
	              _react2.default.createElement(
	                _style2.default.EquityExistingLabel,
	                null,
	                "Shares " + sharesVerb
	              ),
	              _react2.default.createElement(
	                _style2.default.EquityExistingValue,
	                {
	                  style: sharesSign < 0 ? { color: '#FE7474' } : undefined
	                },
	                _react2.default.createElement(CountUp, { value: sharesSign, format: formatNumber })
	              )
	            )
	          )
	        ),
	        !hideSelectButton && _react2.default.createElement(
	          _style2.default.EquitySelectButton,
	          { onClick: function onClick() {
	              return _this3.handleSelectInvestorInternal(investor);
	            } },
	          "Select Investor"
	        )
	      );
	
	      if (isLocked) {
	        return _react2.default.createElement(
	          LockedCardWrapper,
	          { key: investor.client_id, title: lockMessage },
	          cardBody,
	          _react2.default.createElement(
	            LockedTooltip,
	            null,
	            lockMessage
	          )
	        );
	      }
	
	      return cardBody;
	    };
	
	    _this3.state = {
	      loading: true,
	      investors: [],
	      companyValuation: 0,
	      netCapital: 0,
	      sharePrice: 0,
	      outstandingShares: 0,
	      maxShareIssuance: 0,
	      cashBalance: 0,
	      selectedInvestorId: null,
	      // Decision panel state (after an investor is selected)
	      activeDecisionTab: 'issue', // 'issue' | 'buyback' | 'dividends'
	      sharesToIssue: '',
	      sharesToBuyback: '',
	      dividendPerShare: '',
	      postingIssue: false,
	      postingBuyback: false,
	      postingDividends: false,
	      noticeOpen: false,
	      noticeTitle: '',
	      noticeMessage: ''
	    };
	    _this3.eventemitter = _eventEmitter2.default.getInstance();
	    return _this3;
	  }
	
	  _createClass(EquityDecisionsPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.fetchAll();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	
	    // Shape the consolidated team-decisions response into the state we
	    // render against. Single source of truth for both initial load and
	    // post-action refresh.
	
	
	    // Single team-decisions fetch, with one conditional follow-up call
	    // for round (N-1) when we're on an active round that doesn't yet
	    // have post_moneys data. Returns { decisions, priorDecisions }.
	
	
	    // Pull an error message out of an HTTP error. Looks at common shapes:
	    //   - body.detail            (DRF default)
	    //   - body.non_field_errors  (DRF validators)
	    //   - any field-level error  (e.g. { amount: ["..."] })
	    //   - plain string body
	    // Returns null when nothing usable is found.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          loading = _state.loading,
	          investors = _state.investors,
	          companyValuation = _state.companyValuation,
	          netCapital = _state.netCapital,
	          sharePrice = _state.sharePrice,
	          outstandingShares = _state.outstandingShares,
	          selectedInvestorId = _state.selectedInvestorId,
	          noticeOpen = _state.noticeOpen,
	          noticeTitle = _state.noticeTitle,
	          noticeMessage = _state.noticeMessage;
	
	
	      var selectedInvestor = selectedInvestorId ? investors.find(function (i) {
	        return i.client_id === selectedInvestorId;
	      }) : null;
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        _react2.default.createElement(
	          _style2.default.LenderModalHeader,
	          null,
	          _react2.default.createElement(
	            _style2.default.LenderModalTitle,
	            null,
	            "Choose Your Equity Investor"
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderModalSubtitle,
	            null,
	            "Select one or more equity investors to fund your business. Each comes with different terms."
	          ),
	          _react2.default.createElement(
	            _style2.default.LenderModalClose,
	            { onClick: onClose, "aria-label": "Close" },
	            "x"
	          )
	        ),
	        loading && _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", padding: 60 } },
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        ),
	        !loading && function () {
	          // Show the "Capital Invested/Returned Year N" block whenever
	          // any investor has round activity in either direction (issuance,
	          // buyback, or dividend). A zero row is hidden so first-time
	          // viewing of a fresh round stays clean.
	          var anyExistingInvestment = investors.some(function (i) {
	            return Number(i.sharesValueThisRound) !== 0 || Number(i.capitalValueThisRound) !== 0;
	          });
	          return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _style2.default.EquityStatusBar,
	              null,
	              _react2.default.createElement(
	                _style2.default.EquityStatusValuation,
	                null,
	                _react2.default.createElement(
	                  _style2.default.EquityStatusLabel,
	                  null,
	                  "Net Capital Raised/Returned"
	                ),
	                _react2.default.createElement(
	                  _style2.default.EquityStatusValueBig,
	                  { style: { color: netCapital < 0 ? '#C62828' : undefined } },
	                  _react2.default.createElement(CountUp, { value: netCapital, format: numberToM })
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.EquityStatusValuation,
	                null,
	                _react2.default.createElement(
	                  _style2.default.EquityStatusLabel,
	                  null,
	                  "Company Valuation"
	                ),
	                _react2.default.createElement(
	                  _style2.default.EquityStatusValueBig,
	                  null,
	                  _react2.default.createElement(CountUp, { value: companyValuation, format: numberToM })
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.EquityStatusSharePrice,
	                null,
	                _react2.default.createElement(
	                  _style2.default.EquityStatusLabel,
	                  null,
	                  "Share Price"
	                ),
	                _react2.default.createElement(
	                  _style2.default.EquityStatusValueBig,
	                  null,
	                  _react2.default.createElement(CountUp, { value: sharePrice, format: formatSharePrice })
	                )
	              ),
	              _react2.default.createElement(
	                _style2.default.EquityStatusSharePrice,
	                { last: true },
	                _react2.default.createElement(
	                  _style2.default.EquityStatusLabel,
	                  null,
	                  "Outstanding Shares"
	                ),
	                _react2.default.createElement(
	                  _style2.default.EquityStatusValueBig,
	                  null,
	                  _react2.default.createElement(CountUp, { value: outstandingShares, format: formatNumber })
	                )
	              )
	            ),
	            !selectedInvestor && _react2.default.createElement(
	              _style2.default.LenderGrid,
	              null,
	              investors.map(function (investor, idx) {
	                return _this4.renderInvestorCard(investor, idx, { showExisting: anyExistingInvestment });
	              })
	            ),
	            selectedInvestor && _react2.default.createElement(
	              _style2.default.LenderSplit,
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  _style2.default.SelectedLenderWrapper,
	                  null,
	                  _this4.renderInvestorCard(selectedInvestor, 0, {
	                    withAnimation: false,
	                    hideSelectButton: true,
	                    showExisting: anyExistingInvestment
	                  })
	                ),
	                _react2.default.createElement(
	                  _style2.default.ChooseDifferentLenderRow,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.ChooseDifferentLenderButton,
	                    { onClick: _this4.handleChooseDifferentInvestor },
	                    "Choose a different Investor"
	                  )
	                )
	              ),
	              _this4.renderDecisionPanel(selectedInvestor)
	            )
	          );
	        }(),
	        noticeOpen && function () {
	          // Backend returns "No CEO Projections" when finance actions
	          // are blocked by missing projections — show a button that
	          // jumps the user to the CEO Decisions page instead of a
	          // plain OK acknowledgement.
	          var isNoCeoProjections = typeof noticeMessage === 'string' && /no ceo projections/i.test(noticeMessage);
	          // Backend returns "Debt to capital ratio level too high" when
	          // shrinking equity (issuing fewer shares / buying back) would
	          // push the team's D/C ratio past a lender's cap. Replace the
	          // raw string with a plain-language explanation of cause + fix.
	          var isDebtCapitalBreach = typeof noticeMessage === 'string' && /debt to capital/i.test(noticeMessage);
	          var handleAction = function handleAction() {
	            _this4.hideNotice();
	            if (isNoCeoProjections && typeof _this4.props.onGoToCeoProjections === 'function') {
	              _this4.props.onGoToCeoProjections();
	            }
	          };
	          var displayTitle = noticeTitle;
	          var displayMessage = noticeMessage;
	          if (isNoCeoProjections) {
	            displayMessage = "Before you can raise capital, the CEO needs to submit financial projections for this round. Investors use those projections to decide how much they'll offer. Head to CEO Decisions to enter them, then come back to issue shares.";
	          } else if (isDebtCapitalBreach) {
	            displayTitle = "Unsuccessful! Debt to Capital Ratio Limit Breach";
	            displayMessage = "Reducing your shares outstanding lowers your equity, which pushes your debt-to-capital ratio above your lender's limit. To make this adjustment, you'll have to reduce the amount of debt you hold if possible.";
	          }
	          return _react2.default.createElement(
	            _style2.default.LenderNoticeOverlay,
	            { onClick: _this4.hideNotice },
	            _react2.default.createElement(
	              _style2.default.LenderNoticeModal,
	              { onClick: function onClick(e) {
	                  return e.stopPropagation();
	                } },
	              _react2.default.createElement(
	                _style2.default.LenderNoticeTitle,
	                null,
	                displayTitle
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeMessage,
	                null,
	                displayMessage
	              ),
	              _react2.default.createElement(
	                _style2.default.LenderNoticeActions,
	                null,
	                _react2.default.createElement(
	                  _style2.default.LenderNoticeButton,
	                  { onClick: handleAction },
	                  isNoCeoProjections ? 'Check CEO Projections' : 'OK'
	                )
	              )
	            )
	          );
	        }()
	      );
	    }
	  }]);
	
	  return EquityDecisionsPage;
	}(_react.PureComponent);
	
	exports.default = EquityDecisionsPage;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "grey");
	
	function RaiseCapitalButton(props) {
	  var onClick = props.onClick,
	      loading = props.loading;
	
	
	  var style = loading === true ? "grey" : "primary";
	
	  return _react2.default.createElement(
	    _style2.default.UIButton,
	    {
	      className: "btn-fn-decisions-button",
	      bsStyle: style,
	      onClick: onClick,
	      disabled: loading
	    },
	    loading === true ? "Loading..." : "Raise or Modify Capital Raised"
	  );
	}
	
	exports.default = RaiseCapitalButton;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _debtButton = __webpack_require__(578);
	
	var _debtButton2 = _interopRequireDefault(_debtButton);
	
	var _equityButton = __webpack_require__(579);
	
	var _equityButton2 = _interopRequireDefault(_equityButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RaiseCapitalSelectModal = function (_PureComponent) {
	  _inherits(RaiseCapitalSelectModal, _PureComponent);
	
	  function RaiseCapitalSelectModal(props) {
	    _classCallCheck(this, RaiseCapitalSelectModal);
	
	    var _this = _possibleConstructorReturn(this, (RaiseCapitalSelectModal.__proto__ || Object.getPrototypeOf(RaiseCapitalSelectModal)).call(this, props));
	
	    _this.close = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.state = {
	      show: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(RaiseCapitalSelectModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-raise-capital-select-modal", this.show);
	      this.eventemitter.on("hide-raise-capital-select-modal", this.close);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-raise-capital-select-modal", this.show);
	      this.eventemitter.off("hide-raise-capital-select-modal", this.close);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var show = this.state.show;
	      var _props = this.props,
	          onDebt = _props.onDebt,
	          onEquity = _props.onEquity;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { id: "raiseCapitalSelectModal", show: show, onHide: this.close },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            "h4",
	            { className: "fn-decisions-modal-title" },
	            "Please click on the type of capital",
	            _react2.default.createElement("br", null),
	            "you want to raise or modify?"
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "text-center" },
	            _react2.default.createElement(_debtButton2.default, { onClick: onDebt }),
	            _react2.default.createElement(_equityButton2.default, { onClick: onEquity })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RaiseCapitalSelectModal;
	}(_react.PureComponent);
	
	exports.default = RaiseCapitalSelectModal;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _server = __webpack_require__(2374);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _errorInline = __webpack_require__(302);
	
	var _errorInline2 = _interopRequireDefault(_errorInline);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBT_CLIENTS_URL = ("https://be-production-itb.marketgames.io/api/") + "static/debt_clients/";
	var DEBTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/debts/";
	var DEBT_CONDITIONS_URL = ("https://be-production-itb.marketgames.io/api/") + "static/debt_clients/CLIENT_ID/get_debt_conditions/";
	
	var RaiseDebtModal = function (_Component) {
	  _inherits(RaiseDebtModal, _Component);
	
	  function RaiseDebtModal(props) {
	    _classCallCheck(this, RaiseDebtModal);
	
	    var _this = _possibleConstructorReturn(this, (RaiseDebtModal.__proto__ || Object.getPrototypeOf(RaiseDebtModal)).call(this, props));
	
	    _this.showSuccessMessage = function (successMessage) {
	      _this.setState({
	        successMessage: successMessage
	      }, function () {
	        _this.hideSuccessMessage();
	      });
	    };
	
	    _this.hideSuccessMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          successMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.showErrorMessage = function (errorMessage) {
	      _this.setState({
	        errorMessage: errorMessage
	      }, function () {
	        _this.hideErrorMessage();
	      });
	    };
	
	    _this.hideErrorMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          errorMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.fetchData = function (callback) {
	      var roundNumber = _this.props.roundNumber;
	
	
	      (0, _ApiService.batchRequest)([DEBT_CLIENTS_URL + ("?round_number=" + roundNumber), DEBTS_URL + ("?round_number=" + roundNumber)]).then(function (res) {
	        if (res[0].statusCode !== 200 || res[1].statusCode !== 200) {
	          throw res;
	        }
	
	        var debt_clients = res[0].body;
	        var debts = res[1].body;
	
	        var clients = debt_clients.map(function (client) {
	          var client_id = parseInt(client.id, 10);
	          var name = client.name;
	
	          var debt = debts.find(function (i) {
	            return i.client === client_id && i.term === 8;
	          });
	
	          return {
	            client_id: client_id,
	            name: name,
	            term: debt ? debt.term : 8,
	            amount: debt ? debt.amount : 0,
	            balance: debt ? debt.balance : 0,
	            new_amount: debt ? debt.new_amount : 0,
	            is_prev: debt && debt.prev_round_amount !== 0 ? true : false,
	            prev_amount: debt ? debt.prev_round_amount : 0,
	            debt_id: debt ? debt.id : 0,
	            rate: debt ? debt.rate : 0
	          };
	        });
	
	        var interestCharge = debts.reduce(function (acc, item) {
	          return acc + item.interest_charge;
	        }, 0);
	
	        _this.setState({
	          clients: clients,
	          loading: false,
	          interestCharge: interestCharge
	        }, function () {
	          _this.loadMaxAmounts();
	          if (callback) {
	            callback();
	          }
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "RaiseDebtModal", "fetchData");
	      });
	    };
	
	    _this.getMaximumCapital = function (client_id) {
	      var max_amounts = _this.state.max_amounts;
	
	
	      if (client_id in max_amounts) {
	        return Number(max_amounts[client_id]);
	      }
	
	      return 0;
	    };
	
	    _this.getMaximumCapitalFixed = function (client_id) {
	      return Math.floor(_this.getMaximumCapital(client_id));
	    };
	
	    _this.getMaxAmount = function (client_id) {
	      var clients = _this.state.clients;
	
	      var client = clients.find(function (i) {
	        return i.client_id === client_id;
	      });
	      var term = client ? client.term : 0;
	
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "static/debt_clients/" + client_id + "/get_max_amount/").send({ term: term });
	    };
	
	    _this.loadMaxAmounts = function () {
	      var requests = [];
	      var clients = _lodash2.default.cloneDeep(_this.state.clients);
	      var max_amounts = {};
	
	      clients.forEach(function (client) {
	        requests.push(_this.getMaxAmount(client.client_id));
	      });
	
	      if (requests.length > 0) {
	        var joinRequest = Promise.all(requests);
	
	        joinRequest.then(function (res) {
	          res.forEach(function (obj) {
	            var path = obj.req.url.split("/");
	            var client_id = Number(path[6]);
	            max_amounts[client_id] = obj.body.max_amount;
	          });
	
	          _this.setState({
	            max_amounts: max_amounts
	          });
	        }).catch(function (err) {
	          (0, _utils.logError)(err, "RaiseDebtModal", "loadMaxAmounts");
	        });
	      }
	    };
	
	    _this.setSavingState = function (client_id, value) {
	      var saving = _lodash2.default.cloneDeep(_this.state.saving);
	      saving[client_id] = value;
	
	      _this.setState({
	        saving: saving
	      });
	    };
	
	    _this.getSavingState = function (client_id) {
	      var saving = _this.state.saving;
	
	
	      if (client_id in saving) {
	        return saving[client_id];
	      }
	
	      return false;
	    };
	
	    _this.errorText = function (_ref) {
	      var message = _ref.message;
	
	      return (0, _server.renderToStaticMarkup)(_react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          message
	        )
	      ));
	    };
	
	    _this.showAlert = function () {
	      _this.setState({
	        showAlert: true
	      });
	    };
	
	    _this.hideAlert = function () {
	      var client_id = _this.state.client_id;
	
	
	      _this.setState({
	        showAlert: false
	      }, function () {
	        _this.setSavingState(client_id, false);
	      });
	    };
	
	    _this.close = function () {
	      var showInterestChargeWarning = _this.props.showInterestChargeWarning;
	      var interestChargeWarningCanBeShown = _this.state.interestChargeWarningCanBeShown;
	
	      _this.setState({
	        show: false
	      }, function () {
	        if (interestChargeWarningCanBeShown) {
	          showInterestChargeWarning();
	          _this.setState({
	            interestChargeWarningCanBeShown: false
	          });
	        }
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      }, function () {
	        _this.fetchData();
	      });
	    };
	
	    _this.changeAmount = function (e, value, client_id) {
	      var clients = _lodash2.default.cloneDeep(_this.state.clients);
	      var val = "floatValue" in value ? value.floatValue : Number(e.target.value);
	      var index = clients.findIndex(function (i) {
	        return i.client_id === client_id;
	      });
	
	      if (index >= 0) {
	        clients[index].new_amount = val;
	
	        _this.setState({
	          clients: clients
	        });
	      }
	    };
	
	    _this.onDelete = function (client_id, debt_id) {
	      var reloadData = _this.props.reloadData;
	
	
	      _this.setSavingState(client_id, true);
	
	      (0, _ApiService.deleteRequest)(DEBTS_URL + debt_id + "/").then(function (res) {
	        _this.setSavingState(client_id, false);
	        _this.fetchData();
	        reloadData();
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "RaiseDebtModal", "onDelete");
	      });
	    };
	
	    _this.onSave = function (client_id) {
	      var equity = _this.props.equity;
	      var clients = _this.state.clients;
	
	      var client = clients.find(function (i) {
	        return i.client_id === client_id;
	      });
	
	      if (!client) {
	        return;
	      }
	
	      if (equity === 0) {
	        _this.showErrorMessage('Show us some equity and we\'ll give you some debt. Please raise equity.');
	        return;
	      }
	
	      if (client.new_amount < 0) {
	        _this.showErrorMessage('Input Capital Request must be 0 or greater than 0.');
	        return;
	      }
	
	      var max_amount = _this.getMaximumCapital(client_id);
	      var validation_amount = Math.floor(max_amount + client.amount);
	      if (client.prev_amount + client.new_amount > validation_amount) {
	        var message = client.is_prev === true ? "Your loan size cannot exceed the maximum capital." : "You've exceed the maximum capital allowed. Please adjust loan amount.";
	
	        _this.showErrorMessage(message);
	        return;
	      }
	
	      _this.setSavingState(client_id, true);
	
	      (0, _ApiService.postRequest)(DEBT_CONDITIONS_URL.replace("CLIENT_ID", client_id)).send({
	        amount: client.prev_amount + client.new_amount,
	        term: client.term
	      }).then(function (conditions) {
	        var _conditions$body = conditions.body,
	            term = _conditions$body.term,
	            rate = _conditions$body.rate;
	
	
	        _this.setState({
	          term: term,
	          amount: client.new_amount,
	          rate: rate,
	          client_id: client_id
	        }, function () {
	          _this.showAlert();
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "RaiseDebtModal", "onSave");
	      });
	    };
	
	    _this.getDebtsUrl = function () {
	      var _this$state = _this.state,
	          clients = _this$state.clients,
	          client_id = _this$state.client_id;
	
	      var client = clients.find(function (i) {
	        return i.client_id === client_id;
	      });
	      var debt_id = client ? client.debt_id : 0;
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/debts/";
	
	      return debt_id > 0 ? (0, _ApiService.putRequest)("" + url + debt_id + "/") : (0, _ApiService.postRequest)(url);
	    };
	
	    _this.submit = function () {
	      var _this$state2 = _this.state,
	          client_id = _this$state2.client_id,
	          term = _this$state2.term,
	          clients = _this$state2.clients;
	      var reloadData = _this.props.reloadData;
	
	      var client = clients.find(function (i) {
	        return i.client_id === client_id;
	      });
	      var amount = client ? client.prev_amount + client.new_amount : 0;
	
	      var interestCharge = _this.state.interestCharge;
	
	      if (amount === 0) {
	        (0, _SubmitDecisions.decrementUnacceptedDecisions)("finance");
	      } else {
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("finance");
	      }
	      _this.showSuccessMessage(_react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          client.new_amount.toLocaleString('en-US', {
	            style: 'currency',
	            currency: 'USD',
	            maximumFractionDigits: 0
	          })
	        ),
	        " of debt capital raised successfully"
	      ));
	
	      _this.hideAlert();
	      if (interestCharge > 2500000) {
	        _this.setState({ interestChargeWarningCanBeShown: true });
	      }
	      _this.getDebtsUrl().send({
	        client: client_id,
	        term: term,
	        amount: amount
	      }).then(function (res) {
	
	        _this.fetchData();
	        reloadData();
	      }).catch(function (err, res) {
	        var message = _lodash2.default.get(err, ["response", "body", "amount", 0]);
	        _this.showErrorMessage(message);
	        (0, _utils.logError)(err, "RaiseDebtModal", "submit");
	      });
	    };
	
	    _this.getRaisedCapitalFixed = function (client) {
	      return client ? Math.floor(client.balance) : 0;
	    };
	
	    _this.state = {
	      show: false,
	      clients: [],
	      term: 0,
	      amount: 0,
	      rate: 0,
	      client_id: 0,
	      showAlert: false,
	      loading: true,
	      saving: {},
	      max_amounts: {},
	      successMessage: null,
	      errorMessage: null,
	      interestCharge: 0,
	      interestChargeWarningCanBeShown: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(RaiseDebtModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-raise-debt-modal", this.show);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-raise-debt-modal", this.show);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          show = _state.show,
	          clients = _state.clients,
	          showAlert = _state.showAlert,
	          loading = _state.loading,
	          errorMessage = _state.errorMessage,
	          successMessage = _state.successMessage;
	
	
	      var style = {
	        zIndex: 100,
	        position: "relative"
	      };
	
	      return show ? _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        showAlert && _react2.default.createElement(_warning2.default, {
	          title: "ARE YOU SURE?",
	          message: this.alertText,
	          onSuccess: this.submit,
	          onCancel: this.hideAlert
	        }),
	        !showAlert && _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            show: true,
	            onHide: this.close,
	            dialogClassName: "modal-dialog-bigger-more fn-modal-dialog"
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              "p",
	              { className: "modal-p text-align-left ml-10", style: style },
	              _react2.default.createElement(
	                "b",
	                null,
	                "Loans"
	              ),
	              _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                iconSize: "xs"
	              }, _TypeformContent2.default.DEBT_VS_EQUITY))
	            )
	          ),
	          loading === true && _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "text-center loader-inline" },
	              _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	            )
	          ),
	          loading === false && _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            successMessage && _react2.default.createElement(_success2.default, {
	              message: successMessage,
	              marginTop: 1,
	              marginBottom: 80
	            }),
	            errorMessage && _react2.default.createElement(_errorInline2.default, {
	              title: "Error",
	              message: errorMessage,
	              marginTop: 1,
	              marginBottom: 80
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "table-responsive fn-decisions-raise-debt" },
	              _react2.default.createElement(
	                "table",
	                { className: "table" },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "\xA0"
	                    ),
	                    clients.map(function (client) {
	                      return _react2.default.createElement("th", {
	                        key: client.client_id,
	                        dangerouslySetInnerHTML: {
	                          __html: client.name.replace(" ", "<br />")
	                        }
	                      });
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align select-maturity" },
	                      "Select Maturity"
	                    ),
	                    clients.map(function (client) {
	                      return _react2.default.createElement(
	                        "td",
	                        { key: client.client_id },
	                        "8 years"
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align" },
	                      "Borrowing Limit"
	                    ),
	                    clients.map(function (client) {
	                      return _react2.default.createElement(
	                        "td",
	                        { key: client.client_id },
	                        _react2.default.createElement(_reactNumberFormat2.default, {
	                          value: _this2.getMaximumCapitalFixed(client.client_id),
	                          displayType: "text",
	                          prefix: "$",
	                          thousandSeparator: ","
	                        })
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align input-capital-request" },
	                      "Input Loan Request"
	                    ),
	                    clients.map(function (client) {
	                      return _react2.default.createElement(
	                        "td",
	                        { key: client.client_id },
	                        _react2.default.createElement(_AbbreviateNumber2.default, {
	                          type: "input",
	                          value: client.new_amount,
	                          onChange: function onChange(e, value) {
	                            return _this2.changeAmount(e, value, client.client_id);
	                          }
	                        })
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      "\xA0"
	                    ),
	                    clients.map(function (client) {
	                      var saving = _this2.getSavingState(client.client_id);
	
	                      return _react2.default.createElement(
	                        "td",
	                        { key: client.client_id },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            className: "btn btn-save",
	                            onClick: function onClick() {
	                              return _this2.onSave(client.client_id);
	                            },
	                            disabled: saving
	                          },
	                          saving === true ? "Loading..." : "Save"
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align capital-raised" },
	                      "Loan Balance"
	                    ),
	                    clients.map(function (client) {
	                      return _react2.default.createElement(
	                        "td",
	                        { key: client.client_id, className: "capital-raised" },
	                        _react2.default.createElement(_reactNumberFormat2.default, {
	                          value: _this2.getRaisedCapitalFixed(client),
	                          displayType: "text",
	                          prefix: "$",
	                          thousandSeparator: ","
	                        })
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align" },
	                      "Lending Rate"
	                    ),
	                    clients.map(function (client) {
	                      return _react2.default.createElement(
	                        "td",
	                        { key: client.client_id, className: "lending-rate" },
	                        client.debt_id > 0 && client.balance > 0 && _react2.default.createElement(_reactNumberFormat2.default, {
	                          value: (client.rate * 100).toFixed(2),
	                          displayType: "text",
	                          suffix: "%",
	                          thousandSeparator: ","
	                        })
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "right" } },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-close-modal",
	                  onClick: this.close
	                },
	                "Close"
	              )
	            )
	          )
	        )
	      ) : null;
	    }
	  }, {
	    key: "maturity",
	    get: function get() {
	      var term = this.state.term;
	
	
	      return term === 1 ? "1 year" : "8 years";
	    }
	  }, {
	    key: "amountFormatted",
	    get: function get() {
	      var amount = this.state.amount;
	
	      var val = (amount / 1000000).toFixed(2);
	
	      return "$" + val + "M";
	    }
	  }, {
	    key: "interestRate",
	    get: function get() {
	      var rate = this.state.rate;
	
	      var val = (rate * 100).toFixed(2);
	
	      return val + "%";
	    }
	  }, {
	    key: "alertText",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Based on your Capital Structure, we are going to offer you the following:"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Maturity ",
	        this.maturity,
	        _react2.default.createElement("br", null),
	        "Amount ",
	        this.amountFormatted,
	        _react2.default.createElement("br", null),
	        "Interest Rate ",
	        this.interestRate
	      );
	    }
	  }]);
	
	  return RaiseDebtModal;
	}(_react.Component);
	
	exports.default = RaiseDebtModal;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _errorInline = __webpack_require__(302);
	
	var _errorInline2 = _interopRequireDefault(_errorInline);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEBT_CLIENTS_URL = ("https://be-production-itb.marketgames.io/api/") + "static/debt_clients/";
	var DEBTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/debts/";
	var EQUITY_CLIENTS_URL = ("https://be-production-itb.marketgames.io/api/") + "static/equity_clients/";
	var EQUITIES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/equities/";
	var PRE_MONEY_URL = ("https://be-production-itb.marketgames.io/api/") + "team/pre_money/";
	var PERFORMANCE_MONEY_URL = ("https://be-production-itb.marketgames.io/api/") + "team/performance_money/";
	var EQUITY_KEY = "GBorGH Ventures";
	var DEFAULT_ISSUANCE = 200000;
	var AUTHORIZED_SHARES = ("https://be-production-itb.marketgames.io/api/") + "static/constants/";
	var OUTSTANDING_SHARES = ("https://be-production-itb.marketgames.io/api/") + "team/post_money/";
	
	var numberWithCommas = function numberWithCommas(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	var RaiseEquityModal = function (_Component) {
	  _inherits(RaiseEquityModal, _Component);
	
	  function RaiseEquityModal(props) {
	    _classCallCheck(this, RaiseEquityModal);
	
	    var _this = _possibleConstructorReturn(this, (RaiseEquityModal.__proto__ || Object.getPrototypeOf(RaiseEquityModal)).call(this, props));
	
	    _this.showSuccessMessage = function (successMessage) {
	      _this.setState({
	        successMessage: successMessage
	      }, function () {
	        _this.hideSuccessMessage();
	      });
	    };
	
	    _this.hideSuccessMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          successMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.showErrorMessage = function (errorMessage) {
	      _this.setState({
	        errorMessage: errorMessage
	      }, function () {
	        _this.hideErrorMessage();
	      });
	    };
	
	    _this.hideErrorMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          errorMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.showAreYouSure = function () {
	      var _this$state = _this.state,
	          issuance = _this$state.issuance,
	          authorizedShares = _this$state.authorizedShares,
	          initialShares = _this$state.initialShares,
	          max_share_issuance = _this$state.max_share_issuance;
	      var roundNumber = _this.props.roundNumber;
	
	
	      var initialMax = authorizedShares - initialShares;
	      if (roundNumber === 1 && issuance > initialMax || roundNumber > 1 && issuance > max_share_issuance) {
	        _this.showErrorMessage('Share issuance cannot exceed the available shares to issue');
	        return;
	      }
	
	      if (roundNumber === 1) {
	        _this.submit();
	      } else {
	        _this.setState({
	          showAreYouSure: true
	        });
	      }
	    };
	
	    _this.hideAreYouSure = function () {
	      _this.setState({
	        showAreYouSure: false
	      });
	    };
	
	    _this.fetchShares = function () {
	      var roundNumber = _this.props.roundNumber;
	
	
	      (0, _ApiService.getRequest)(AUTHORIZED_SHARES).then(function (res) {
	        _this.setState({
	          authorizedShares: res.body[0].authorized_shares,
	          initialShares: res.body[0].initial_shares
	        });
	      });
	
	      (0, _ApiService.getRequest)(OUTSTANDING_SHARES + ("?round_number=" + roundNumber)).then(function (res) {
	        _this.setState({
	          shares: res.body[0].shares
	        });
	      });
	    };
	
	    _this.fetchData = function () {
	      var _this$props = _this.props,
	          roundNumber = _this$props.roundNumber,
	          currentRound = _this$props.currentRound;
	
	
	      (0, _ApiService.batchRequest)([DEBT_CLIENTS_URL + ("?round_number=" + roundNumber), DEBTS_URL + ("?round_number=" + roundNumber), EQUITY_CLIENTS_URL + ("?round_number=" + roundNumber), EQUITIES_URL + ("?round_lte=" + roundNumber), PRE_MONEY_URL, PERFORMANCE_MONEY_URL + ("?round_number=" + (currentRound - 1)), AUTHORIZED_SHARES + "?authorized_shares"]).then(function (res) {
	        if (res[0].statusCode !== 200 || res[1].statusCode !== 200 || res[2].statusCode !== 200 || res[3].statusCode !== 200 || res[4].statusCode !== 200 || res[5].statusCode !== 200) {
	          throw res;
	        }
	
	        var debt_clients = res[0].body;
	        var debts = res[1].body;
	        var equity_clients = res[2].body;
	        var equities = res[3].body;
	        var pre_money = res[4].body;
	        var performance_money = res[5].body;
	
	        var issuance = currentRound === 1 ? DEFAULT_ISSUANCE : 0;
	        var equity_id = 0;
	        var amount = 0;
	        var client_id = 0;
	
	        var equity_client = equity_clients.find(function (i) {
	          return i.name === EQUITY_KEY;
	        });
	        if (equity_client) {
	          client_id = equity_client.id;
	
	          var equity_data = equities.find(function (i) {
	            return i.client === client_id && i.round === _this.roundId;
	          });
	          if (equity_data) {
	            issuance = equity_data.issuance;
	            equity_id = equity_data.id;
	          }
	
	          amount = _lodash2.default.sumBy(equities.filter(function (i) {
	            return i.client === client_id;
	          }), "capital");
	        }
	
	        var max_share_issuance = 0;
	        var share_price = 0;
	
	        if (pre_money.length > 0) {
	          max_share_issuance = pre_money[0].max_share_issuance;
	          share_price = pre_money[0].share_price;
	        }
	
	        if (performance_money.length > 0) {
	          share_price = performance_money[0].share_price;
	        }
	
	        var loans = debt_clients.map(function (debt_client) {
	          var client_id = parseInt(debt_client.id, 10);
	          var term = client_id === 2 || client_id === 3 ? 5 : 1;
	          var debt = debts.find(function (i) {
	            return i.client === client_id;
	          });
	
	          return {
	            name: debt_client.name,
	            amount: debt ? debt.amount : 0,
	            term: debt ? debt.term : term,
	            lt_debt_to_capital: debt_client.lt_debt_to_capital,
	            st_debt_to_capital: debt_client.st_debt_to_capital,
	            is_prev: debt && debt.prev_round_amount !== 0 ? true : false
	          };
	        });
	
	        _this.setState({
	          issuance: issuance,
	          prev_issuance: issuance,
	          equity_id: equity_id,
	          amount: amount,
	          client_id: client_id,
	          max_share_issuance: max_share_issuance,
	          share_price: share_price,
	          loans: loans,
	          loading: false,
	          saving: false
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "RaiseEquityModal", "fetchData");
	      });
	    };
	
	    _this.close = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      }, function () {
	        _this.fetchData();
	        _this.fetchShares();
	      });
	    };
	
	    _this.changeIssuance = function (event, value) {
	      var issuance = value ? value.floatValue : Number(event.target.value);
	      var prev_issuance = _this.state.issuance;
	
	      _this.setState({
	        issuance: issuance,
	        prev_issuance: prev_issuance
	      });
	    };
	
	    _this.getEquitiesRequest = function () {
	      var _this$state2 = _this.state,
	          equity_id = _this$state2.equity_id,
	          client_id = _this$state2.client_id,
	          issuance = _this$state2.issuance;
	
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/equities/";
	
	      if (issuance === 0) {
	        if (equity_id > 0) {
	          url += equity_id + "/";
	
	          return (0, _ApiService.deleteRequest)(url);
	        }
	
	        return null;
	      }
	
	      var data = {
	        client: client_id,
	        issuance: issuance
	      };
	
	      if (equity_id > 0) {
	        url += equity_id + "/";
	
	        return (0, _ApiService.putRequest)(url).send(data);
	      }
	
	      return (0, _ApiService.postRequest)(url).send(data);
	    };
	
	    _this.showPopup = function (share_price) {
	      _this.eventemitter.trigger("coaching-feedback", ["Issuing Ownership", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Make it rain! Raise that equity! But don\u2019t forget, you are issuing a lot of shares at a very low price of ",
	        share_price,
	        ".",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Pop quiz: If you expect your business value to increase over time (i.e. expect your share price to go up), would you rather issue so many ownership shares at ",
	        share_price,
	        " or at a higher price when you have created value?",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Also increasing the # of shares issued can impact your share price if your valuation does not increase as well.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Note 1: Share Price = Business Value / Shares Outstanding",
	        _react2.default.createElement("br", null),
	        "Note 2: Share Price = a key grading metric"
	      )]);
	    };
	
	    _this.showPopup2 = function (share_price, capital) {
	      _this.eventemitter.trigger("coaching-feedback", ["Issuing Ownership", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Very Interesting. You\u2019re only raising $",
	        numberWithCommas(capital),
	        " of equity capital! I get it, you don\u2019t want to issue ownership shares at this very low price of ",
	        share_price,
	        ", but is that enough equity to raise? You could try to raise your remaining capital needs through debt, but your borrowing limits is based on your equity raised (i.e. the more equity raised, the more money lenders will lend).",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about your capital raising limits, please read The Investor section of the Business Case."
	      )]);
	    };
	
	    _this.submit = function () {
	      var reloadData = _this.props.reloadData;
	
	
	      _this.setState({
	        showAreYouSure: false,
	        saving: true
	      });
	
	      var equitiesRequest = _this.getEquitiesRequest();
	      if (equitiesRequest) {
	        equitiesRequest.then(function (res) {
	          var issuance = 0;
	          var capital = 0;
	          var share_price = 0;
	
	          if (res.body) {
	            issuance = res.body.issuance;
	            capital = res.body.capital;
	            share_price = "$" + (capital / issuance).toFixed(2);
	          }
	
	          if (issuance > 4500000) {
	            _this.showPopup(share_price);
	          } else if (issuance <= 1000000) {
	            _this.showPopup2(share_price, capital);
	          }
	
	          _this.setState({
	            saving: false
	          }, function () {
	            if (issuance === 0) {
	              (0, _SubmitDecisions.decrementUnacceptedDecisions)("finance");
	            } else {
	              (0, _SubmitDecisions.incrementUnacceptedDecisions)("finance");
	            }
	            _this.showSuccessMessage(_react2.default.createElement(
	              _reactDotFragment2.default,
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                capital.toLocaleString('en-US', {
	                  style: 'currency',
	                  currency: 'USD',
	                  maximumFractionDigits: 0
	                })
	              ),
	              " of equity capital raised successfully"
	            ));
	
	            reloadData();
	            _this.fetchData();
	          });
	        }).catch(function (err) {
	          if (err.response && err.response.status === 400 && "non_field_errors" in err.response.body && err.response.body["non_field_errors"].length > 0 && err.response.body["non_field_errors"][0] === "No CEO Projections") {
	            _this.showErrorMessage('Show us your projections and we\'ll show you the money.');
	            _this.setState({
	              saving: false
	            });
	            return;
	          }
	
	          if (err.response && err.response.status === 400 && "issuance" in err.response.body && (_lodash2.default.isArray(err.response.body["issuance"]) && err.response.body["issuance"].length > 0 || _lodash2.default.isString(err.response.body["issuance"]))) {
	            _this.showErrorMessage('This decision will result in breaching your lender(s) debt to capital ratio limit');
	            _this.setState({
	              saving: false
	            });
	            return;
	          }
	
	          if (!err.response) {
	            console.error(err);
	          }
	
	          (0, _utils.logError)(err, "RaiseEquityModal", "submit");
	        });
	      } else {
	        _this.setState({
	          saving: false
	        }, function () {
	          reloadData();
	          _this.fetchData();
	        });
	      }
	    };
	
	    _this.state = {
	      show: false,
	      max_share_issuance: 0,
	      issuance: 0,
	      prev_issuance: 0,
	      equity_id: 0,
	      amount: 0,
	      share_price: 0,
	      client_id: 0,
	      loans: [],
	      loading: true,
	      saving: false,
	      authorizedShares: "",
	      initialShares: "",
	      shares: "",
	      showAreYouSure: false,
	      successMessage: null,
	      errorMessage: null
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(RaiseEquityModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-raise-equity-modal", this.show);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-raise-equity-modal", this.show);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          show = _state.show,
	          loading = _state.loading,
	          saving = _state.saving,
	          showAreYouSure = _state.showAreYouSure,
	          successMessage = _state.successMessage,
	          errorMessage = _state.errorMessage;
	      var currentRound = this.props.currentRound;
	
	
	      return show ? _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        showAreYouSure && _react2.default.createElement(_warning2.default, {
	          title: "ARE YOU SURE?",
	          message: _react2.default.createElement(
	            "div",
	            null,
	            "Are you sure you want to issue additional shares? You might not be able to modify and reduce these shares if that reduction results in a breach of your lender's debt to capital requirement.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "For more information on each lender's debt to capital requirement, please review",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "/analysis/bcase/modal-exhibit5?round=" + currentRound,
	                target: "_blank",
	                rel: "noreferrer"
	              },
	              "Exhibit 5"
	            ),
	            " ",
	            "of the business case."
	          ),
	          onSuccess: this.submit,
	          onCancel: this.hideAreYouSure
	        }),
	        !showAreYouSure && _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            show: true,
	            onHide: this.close,
	            dialogClassName: "modal-dialog-bigger fn-modal-dialog"
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              "p",
	              { className: "modal-p text-align-left ml-10" },
	              _react2.default.createElement(
	                "b",
	                null,
	                "GBorGH Ventures - Equity Capital"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            successMessage && _react2.default.createElement(_success2.default, {
	              message: successMessage,
	              marginTop: 1,
	              marginBottom: 80
	            }),
	            errorMessage && _react2.default.createElement(_errorInline2.default, {
	              title: "Error",
	              message: errorMessage,
	              marginTop: 1,
	              marginBottom: 80
	            }),
	            loading === true && _react2.default.createElement(
	              "div",
	              { className: "text-center loader-inline" },
	              _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	            ),
	            loading === false && _react2.default.createElement(
	              "div",
	              { className: "table-responsive fn-decisions-raise-equity" },
	              _react2.default.createElement(
	                "table",
	                { className: "table" },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "Equity",
	                      _react2.default.createElement("br", null),
	                      "Offering",
	                      _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                        iconSize: "xs"
	                      }, _TypeformContent2.default.EQUITY_OFFERING))
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align" },
	                      "Authorized Shares"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: this.state.authorizedShares,
	                        displayType: "text",
	                        thousandSeparator: ","
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align" },
	                      "Outstanding Shares"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: this.state.shares,
	                        displayType: "text",
	                        thousandSeparator: ","
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    { style: { borderTop: "2px solid black" } },
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align" },
	                      "Available Shares to Issue"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: this.state.max_share_issuance,
	                        displayType: "text",
	                        thousandSeparator: ","
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align shares-to-issue" },
	                      "Shares To Issue"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(_AbbreviateNumber2.default, {
	                        name: "shares_of_issue",
	                        type: "input",
	                        value: this.issuance,
	                        onChange: this.changeIssuance,
	                        prefix: ""
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align" },
	                      "Price Per Share"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: this.sharePrice,
	                        displayType: "text",
	                        thousandSeparator: ",",
	                        decimalSeparator: ".",
	                        prefix: "$"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      "\xA0"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          className: "btn btn-save",
	                          onClick: this.showAreYouSure,
	                          disabled: saving
	                        },
	                        saving === true ? "Loading..." : "Save"
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          className: "btn btn-close-modal",
	                          onClick: this.close,
	                          style: {
	                            marginLeft: 20
	                          }
	                        },
	                        "Close"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "td",
	                      { className: "no-align capital-raised" },
	                      "Capital Raised"
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "capital-raised" },
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: this.capitalRaised,
	                        displayType: "text",
	                        thousandSeparator: ",",
	                        prefix: "$"
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ) : null;
	    }
	  }, {
	    key: "roundId",
	    get: function get() {
	      var _props = this.props,
	          roundNumber = _props.roundNumber,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === roundNumber;
	      });
	
	      return round ? round.id : 0;
	    }
	  }, {
	    key: "maxShareIssuance",
	    get: function get() {
	      var max_share_issuance = this.state.max_share_issuance;
	
	
	      return max_share_issuance;
	    }
	  }, {
	    key: "issuance",
	    get: function get() {
	      var issuance = this.state.issuance;
	
	
	      return issuance;
	    }
	  }, {
	    key: "sharePrice",
	    get: function get() {
	      var share_price = this.state.share_price;
	
	
	      return share_price.toFixed(2);
	    }
	  }, {
	    key: "capitalRaised",
	    get: function get() {
	      var amount = this.state.amount;
	
	
	      return amount.toFixed(0);
	    }
	  }]);
	
	  return RaiseEquityModal;
	}(_react.Component);
	
	exports.default = RaiseEquityModal;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "grey");
	
	function ReturnCapitalButton(props) {
	  var onClick = props.onClick,
	      disabled = props.disabled,
	      loading = props.loading;
	
	
	  var style = disabled === true || loading === true ? "grey" : "primary";
	
	  return _react2.default.createElement(
	    _style2.default.UIButton,
	    {
	      className: "btn-fn-decisions-button",
	      bsStyle: style,
	      onClick: onClick,
	      disabled: disabled
	    },
	    loading === true ? "Loading..." : "Return Capital"
	  );
	}
	
	// get isReturnCapitalDisabled() {
	//   const { currentRound } = this.state;
	
	//   return currentRound === 1 ? true : false;
	// }
	exports.default = ReturnCapitalButton;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _debtButton = __webpack_require__(578);
	
	var _debtButton2 = _interopRequireDefault(_debtButton);
	
	var _equityButton = __webpack_require__(579);
	
	var _equityButton2 = _interopRequireDefault(_equityButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReturnCapitalSelectModal = function (_PureComponent) {
	  _inherits(ReturnCapitalSelectModal, _PureComponent);
	
	  function ReturnCapitalSelectModal(props) {
	    _classCallCheck(this, ReturnCapitalSelectModal);
	
	    var _this = _possibleConstructorReturn(this, (ReturnCapitalSelectModal.__proto__ || Object.getPrototypeOf(ReturnCapitalSelectModal)).call(this, props));
	
	    _this.close = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.state = {
	      show: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ReturnCapitalSelectModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-return-capital-select-modal", this.show);
	      this.eventemitter.on("hide-return-capital-select-modal", this.close);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-return-capital-select-modal", this.show);
	      this.eventemitter.off("hide-return-capital-select-modal", this.close);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var show = this.state.show;
	      var _props = this.props,
	          onDebt = _props.onDebt,
	          onEquity = _props.onEquity,
	          equityEnabled = _props.equityEnabled;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { id: "returnCapitalSelectModal", show: show, onHide: this.close },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            "h4",
	            { className: "fn-decisions-modal-title" },
	            "Please click on the type of capital",
	            _react2.default.createElement("br", null),
	            "you want to return or modify?"
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "text-center" },
	            _react2.default.createElement(_debtButton2.default, { onClick: onDebt }),
	            _react2.default.createElement(_equityButton2.default, { onClick: onEquity, disabled: !equityEnabled })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReturnCapitalSelectModal;
	}(_react.PureComponent);
	
	exports.default = ReturnCapitalSelectModal;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"], ["\n  width: 14px;\n  height: 14px;\n  margin-left: 4px;\n  cursor: pointer;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: '';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: '';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n"], ["\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n"], ["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _financeLoanRepayment = __webpack_require__(2580);
	
	var _financeLoanRepayment2 = _interopRequireDefault(_financeLoanRepayment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DEBT_CLIENTS_URL = ("https://be-production-itb.marketgames.io/api/") + "static/debt_clients/";
	var DEBTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/debts/";
	var DEBT_REPAYMENTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/debt_repayments/";
	var FINANCE_INTEREST_PAYMENTS_URL = ("https://be-production-itb.marketgames.io/api/") + "v2/finance/interest-payments/";
	var PLAYERS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/players/";
	
	var HelpIcon = _styledComponents2.default.img(_templateObject);
	
	var ModalVideoWrapper = _styledComponents2.default.div(_templateObject2);
	
	var PlayPauseButton = _styledComponents2.default.button(_templateObject3);
	
	var CloseModalVideoButton = _styledComponents2.default.button(_templateObject4);
	
	var ReturnDebtModal = function (_Component) {
	  _inherits(ReturnDebtModal, _Component);
	
	  function ReturnDebtModal(props) {
	    _classCallCheck(this, ReturnDebtModal);
	
	    var _this = _possibleConstructorReturn(this, (ReturnDebtModal.__proto__ || Object.getPrototypeOf(ReturnDebtModal)).call(this, props));
	
	    _this.handlePlayPause = function () {
	      if (_this.videoRef) {
	        if (_this.state.isVideoPlaying) {
	          _this.videoRef.pause();
	        } else {
	          _this.videoRef.play();
	        }
	        _this.setState({ isVideoPlaying: !_this.state.isVideoPlaying });
	      }
	    };
	
	    _this.openVideoModal = function () {
	      _this.setState({
	        isVideoModalShown: true
	      });
	    };
	
	    _this.closeVideoModal = function () {
	      _this.setState({
	        isVideoModalShown: false,
	        isVideoPlaying: false
	      });
	    };
	
	    _this.showSuccessMessage = function (successMessage) {
	      _this.setState({
	        successMessage: successMessage
	      }, function () {
	        _this.hideSuccessMessage();
	      });
	    };
	
	    _this.hideSuccessMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          successMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.showErrorMessage = function (errorMessage) {
	      _this.setState({
	        errorMessage: errorMessage
	      }, function () {
	        _this.hideErrorMessage();
	      });
	    };
	
	    _this.hideErrorMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          errorMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.fetchData = function () {
	      var roundNumber = _this.props.roundNumber;
	
	
	      (0, _ApiService.batchRequest)([DEBT_CLIENTS_URL + ("?round_number=" + roundNumber), DEBTS_URL + ("?round_number=" + roundNumber), DEBT_REPAYMENTS_URL + ("?round_number=" + roundNumber), DEBTS_URL + ("?round_number=" + (roundNumber - 1)), FINANCE_INTEREST_PAYMENTS_URL + ("?round_number=" + roundNumber), PLAYERS_URL]).then(function (res) {
	        if (res[0].statusCode !== 200 || res[1].statusCode !== 200 || res[2].statusCode !== 200 || res[3].statusCode !== 200 || res[4].statusCode !== 200 || res[5].statusCode !== 200) {
	          throw res;
	        }
	
	        var debt_clients = res[0].body;
	        var debts = res[1].body;
	        var debt_repayments = res[2].body;
	        var debts_prior = res[3].body;
	        var finance_iterest_payments = res[4].body.results;
	        var players = res[5].body;
	
	        var userId = Number(_Auth2.default.getUserId());
	        var player = players.find(function (i) {
	          return Number(i.user.id) === userId;
	        });
	        var playerId = player ? Number(player.id) : 0;
	
	        var clients = debt_clients.map(function (client) {
	          var client_id = parseInt(client.id, 10);
	          var name = client.name;
	
	          var term = client_id === 2 || client_id === 3 ? 5 : 1;
	          var debt = debts.find(function (i) {
	            return i.client === client_id;
	          });
	          var debt_prior = debts_prior.find(function (i) {
	            return i.client === client_id;
	          });
	          var debt_repayment = debt_repayments.find(function (i) {
	            return i.client === client_id;
	          });
	          var finance_interest_payment = finance_iterest_payments.find(function (i) {
	            return i.client === client_id;
	          });
	
	          var interest_beginning_balance = debt_prior ? Math.abs(debt_prior.interest_payable) : 0;
	
	          return {
	            client_id: client_id,
	            name: name,
	            term: debt ? debt.term : term,
	            balance: debt ? debt.balance : 0,
	            debt_id: debt ? debt.id : 0,
	            interest_payable: debt ? debt.interest_payable : 0,
	            interest_charge: debt ? debt.interest_charge : 0,
	            prior_balance: debt_prior ? debt_prior.balance : 0,
	            amount_repaid: debt_repayment ? debt_repayment.amount : 0,
	            repayment_amount: debt_repayment ? debt_repayment.amount : 0,
	            repayment_debt_id: debt_repayment ? debt_repayment.id : 0,
	            interest_beginning_balance: interest_beginning_balance,
	            interest_repayment: finance_interest_payment ? finance_interest_payment.amount : 0,
	            interest_repayment_id: finance_interest_payment ? finance_interest_payment.id : 0
	          };
	        });
	
	        _this.setState({
	          clients: clients,
	          loading: false,
	          playerId: playerId
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ReturnDebtModal", "fetchData");
	      });
	    };
	
	    _this.getSavingState = function (client_id) {
	      var saving = _this.state.saving;
	
	
	      if (client_id in saving) {
	        return saving[client_id];
	      }
	
	      return false;
	    };
	
	    _this.setSavingState = function (client_id, value) {
	      var saving = _lodash2.default.cloneDeep(_this.state.saving);
	      saving[client_id] = value;
	
	      _this.setState({
	        saving: saving
	      });
	    };
	
	    _this.getInterestRepaymentSavingState = function (client_id) {
	      var interestRepaymentSaving = _this.state.interestRepaymentSaving;
	
	
	      if (client_id in interestRepaymentSaving) {
	        return interestRepaymentSaving[client_id];
	      }
	
	      return false;
	    };
	
	    _this.setInterestRepaymentSavingState = function (client_id, value) {
	      var interestRepaymentSaving = _lodash2.default.cloneDeep(_this.state.interestRepaymentSaving);
	      interestRepaymentSaving[client_id] = value;
	
	      _this.setState({
	        interestRepaymentSaving: interestRepaymentSaving
	      });
	    };
	
	    _this.close = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      }, function () {
	        _this.fetchData();
	      });
	    };
	
	    _this.changeRepaymentAmount = function (e, value, client_id) {
	      var clients = _lodash2.default.cloneDeep(_this.state.clients);
	      var val = "floatValue" in value ? value.floatValue : Number(e.target.value);
	      var index = clients.findIndex(function (i) {
	        return i.client_id === client_id;
	      });
	
	      if (index >= 0) {
	        clients[index].repayment_amount = val;
	
	        _this.setState({
	          clients: clients
	        });
	      }
	    };
	
	    _this.changeInterestRepaymentsAmount = function (e, value, client_id) {
	      var clients = _lodash2.default.cloneDeep(_this.state.clients);
	      var val = "floatValue" in value ? value.floatValue : Number(e.target.value);
	      var index = clients.findIndex(function (i) {
	        return i.client_id === client_id;
	      });
	
	      if (index >= 0) {
	        clients[index].interest_repayment = val;
	
	        _this.setState({
	          clients: clients
	        });
	      }
	    };
	
	    _this.getDebtsUrl = function (object_id) {
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/debt_repayments/";
	
	      return object_id > 0 ? (0, _ApiService.putRequest)("" + url + object_id + "/") : (0, _ApiService.postRequest)(url);
	    };
	
	    _this.getInterestRepaymentUrl = function (object_id) {
	      var url = FINANCE_INTEREST_PAYMENTS_URL;
	
	      return object_id > 0 ? (0, _ApiService.putRequest)("" + url + object_id + "/") : (0, _ApiService.postRequest)(url);
	    };
	
	    _this.submit = function (client_id) {
	      var errorTitle = '';
	      var errorMessage = '';
	
	      var reloadData = _this.props.reloadData;
	      var clients = _this.state.clients;
	
	      var client = clients.find(function (i) {
	        return i.client_id === client_id;
	      });
	
	      if (!client) {
	        return;
	      }
	
	      if (client.prior_balance <= 0) {
	        errorTitle = 'No Prior Year Outstanding Balance Exist';
	        errorMessage = 'You do not have any outstanding loan balance with this lender';
	      }
	
	      if (client.repayment_amount < 0) {
	        errorTitle = 'Value Cannot Be Negative';
	        errorMessage = 'Please input a value that’s zero or greater';
	      }
	
	      if (errorMessage !== '') {
	        _this.setState({
	          showError: true,
	          errorTitle: errorTitle,
	          errorMessage: errorMessage
	        });
	        return;
	      }
	
	      _this.setSavingState(client_id, true);
	
	      _this.getDebtsUrl(client.repayment_debt_id).send({
	        client: client_id,
	        term: client.term,
	        amount: client.repayment_amount
	      }).then(function (res) {
	        if (client.repayment_amount === 0) {
	          (0, _SubmitDecisions.decrementUnacceptedDecisions)("finance");
	        } else {
	          (0, _SubmitDecisions.incrementUnacceptedDecisions)("finance");
	        }
	        _this.showSuccessMessage(_react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            client.repayment_amount.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 0
	            })
	          ),
	          " is successfully scheduled to be paid to ",
	          _react2.default.createElement(
	            "b",
	            null,
	            client.name
	          )
	        ));
	        _this.setSavingState(client_id, false);
	        reloadData();
	        _this.fetchData();
	      }).catch(function (err) {
	        if (err.response.status === 400 && err.response.body.non_field_errors && err.response.body.non_field_errors.length > 0) {
	          var error = err.response.body.non_field_errors[0];
	
	          if (error.length >= 25 && error.substr(0, 25) === "Insufficient cash balance") {
	            errorTitle = 'Value > Available Cash';
	            errorMessage = 'Payment cannot exceed your available cash balance';
	          }
	
	          if (error.length >= 24 && error.substr(0, 24) === "paying more than you owe") {
	            errorTitle = 'Payment Exceeds Outstanding Balance';
	            errorMessage = 'Your payment request is in excess of what you owe. Please adjust payment amount accordingly.';
	          }
	
	          if (error === "Manual repayments not allowed for short term debts") {
	            errorTitle = 'Debt to Capital Breach';
	            errorMessage = 'This payment would put you in breach of your lender(s) debt-to-capital limit. In order to make this payment, you’ll need to reduce your debt-to-capital ratio.';
	          }
	          _this.setSavingState(client_id, false);
	
	          if (errorMessage !== '') {
	            _this.setState({
	              showError: true,
	              errorTitle: errorTitle,
	              errorMessage: errorMessage
	            });
	          }
	        }
	
	        (0, _utils.logError)(err, "ReturnDebtModal", "submit");
	      });
	    };
	
	    _this.submitInterestRepayment = function (client_id) {
	      var _this$props = _this.props,
	          reloadData = _this$props.reloadData,
	          roundId = _this$props.roundId;
	      var _this$state = _this.state,
	          clients = _this$state.clients,
	          playerId = _this$state.playerId;
	
	      var client = clients.find(function (i) {
	        return i.client_id === client_id;
	      });
	
	      if (!client) {
	        return;
	      }
	
	      _this.setInterestRepaymentSavingState(client_id, true);
	
	      _this.getInterestRepaymentUrl(client.interest_repayment_id).send({
	        client: client_id,
	        amount: client.interest_repayment,
	        debt: client.debt_id,
	        player: playerId,
	        round: roundId,
	        team: _Auth2.default.getTeamId(),
	        term: client.term
	      }).then(function (res) {
	        _this.showSuccessMessage(_react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            client.interest_repayment.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 0
	            })
	          ),
	          " is successfully set to be paid to ",
	          _react2.default.createElement(
	            "b",
	            null,
	            client.name
	          )
	        ));
	        _this.setInterestRepaymentSavingState(client_id, false);
	        reloadData();
	        _this.fetchData();
	      }).catch(function (err) {
	        if (err.response.status === 400 && err.response.body.non_field_errors && err.response.body.non_field_errors.length > 0) {
	          var error = err.response.body.non_field_errors[0];
	          var errorTitle = '';
	          var errorMessage = '';
	
	          if (error.indexOf("Amount can not exceed interest_payable") !== -1) {
	            errorTitle = 'Payment Exceeds Outstanding Balance';
	            errorMessage = 'Your payment request is in excess of what you owe. Please adjust payment amount accordingly.';
	          }
	
	          _this.setInterestRepaymentSavingState(client_id, false);
	
	          if (errorMessage !== '') {
	            _this.setState({
	              showError: true,
	              errorTitle: errorTitle,
	              errorMessage: errorMessage
	            });
	          }
	        }
	        (0, _utils.logError)(err, "ReturnDebtModal", "submit");
	      });
	    };
	
	    _this.hideError = function () {
	      _this.setState({
	        showError: false
	      });
	    };
	
	    _this.state = {
	      show: false,
	      clients: [],
	      loading: true,
	      saving: {},
	      successMessage: null,
	      interestRepaymentSaving: {},
	      playerId: 0,
	      showError: false,
	      errorTitle: '',
	      errorMessage: '',
	      isVideoModalShown: false,
	      isVideoPlaying: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(ReturnDebtModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-return-debt-modal", this.show);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-return-debt-modal", this.show);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          show = _state.show,
	          clients = _state.clients,
	          loading = _state.loading,
	          successMessage = _state.successMessage,
	          showError = _state.showError,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          isVideoModalShown = _state.isVideoModalShown,
	          isVideoPlaying = _state.isVideoPlaying;
	
	      var cashBalance = this.cashBalance;
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            show: show,
	            onHide: this.close,
	            dialogClassName: "modal-dialog-bigger-more fn-modal-dialog finance-decisions-modal"
	          },
	          showError && _react2.default.createElement(_error2.default, {
	            title: errorTitle,
	            message: errorMessage,
	            onHide: this.hideError
	          }),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Header,
	            { closeButton: true },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Returning Capital | Paying Down Debt",
	              _react2.default.createElement(HelpIcon, { src: _iconTableHelp2.default, onClick: this.openVideoModal })
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Cash Balance: ",
	              _react2.default.createElement(_reactNumberFormat2.default, {
	                value: cashBalance,
	                displayType: "text",
	                prefix: "$",
	                thousandSeparator: ","
	              })
	            )
	          ),
	          loading === true && _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "text-center loader-inline" },
	              _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	            )
	          ),
	          loading === false && _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            successMessage && _react2.default.createElement(_success2.default, {
	              message: successMessage,
	              marginTop: 1,
	              marginBottom: 80
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line loan-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label grey" },
	                "Loan Principal"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label black" },
	                  "Prudent Bank"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label black" },
	                  "Mezz Capital"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label black" },
	                  "Great White Financials"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label" },
	                "Loan Beginning Balance"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-label", key: client.client_id },
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: client.prior_balance,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line principal-repayment-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label black bigger" },
	                "Principal Repayment(s)"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-input-wrapper", key: client.client_id },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: "input",
	                      value: client.repayment_amount,
	                      onChange: function onChange(e, value) {
	                        return _this2.changeRepaymentAmount(e, value, client.client_id);
	                      }
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  var saving = _this2.getSavingState(client.client_id);
	
	                  return _react2.default.createElement(
	                    "div",
	                    { key: client.client_id },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "modal-button",
	                        onClick: function onClick() {
	                          return _this2.submit(client.client_id);
	                        },
	                        disabled: saving
	                      },
	                      saving === true ? "Loading..." : "Save"
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line loan-ending-balance-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label" },
	                "Loan Ending Balance"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-label", key: client.client_id },
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: client.balance,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("div", { className: "modal-divider" }),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line loan-line loan-interest-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label grey" },
	                "Loan Interest"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label" },
	                "Interest Beginning Balance"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-label", key: client.client_id },
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: client.interest_beginning_balance,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line interest-repayment-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label black bigger" },
	                "Interest Repayment(s)"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-input-wrapper", key: client.client_id },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: "input",
	                      value: client.interest_repayment,
	                      onChange: function onChange(e, value) {
	                        return _this2.changeInterestRepaymentsAmount(e, value, client.client_id);
	                      }
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line interest-repayment-buttons-line" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  var interestRepaymentSaving = _this2.getInterestRepaymentSavingState(client.client_id);
	
	                  return _react2.default.createElement(
	                    "div",
	                    { key: client.client_id },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "modal-button",
	                        onClick: function onClick() {
	                          return _this2.submitInterestRepayment(client.client_id);
	                        },
	                        disabled: interestRepaymentSaving
	                      },
	                      interestRepaymentSaving === true ? "Loading..." : "Save"
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label" },
	                "Current Year Interest"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-label", key: client.client_id },
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: client.interest_charge,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-line" },
	              _react2.default.createElement(
	                "p",
	                { className: "modal-label" },
	                "Interest Ending Balance"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-right-content-container content-container-row col-3" },
	                clients.map(function (client) {
	                  return _react2.default.createElement(
	                    "p",
	                    { className: "modal-label", key: client.client_id },
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: client.interest_payable,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { show: isVideoModalShown, onHide: this.closeVideoModal, className: "goals-and-targets-modal" },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              ModalVideoWrapper,
	              { className: isVideoPlaying ? 'is-playing' : '' },
	              _react2.default.createElement("video", {
	                ref: function ref(_ref) {
	                  _this2.videoRef = _ref;
	                },
	                src: _financeLoanRepayment2.default,
	                alt: "Welcome Video",
	                onClick: this.handlePlayPause,
	                onEnded: function onEnded() {
	                  return _this2.setState({ isVideoPlaying: false });
	                },
	                style: { width: '100%', borderRadius: 10 }
	              }),
	              _react2.default.createElement(
	                PlayPauseButton,
	                { onClick: this.handlePlayPause },
	                isVideoPlaying ? '❚❚' : '▶'
	              ),
	              _react2.default.createElement(
	                CloseModalVideoButton,
	                { onClick: this.closeVideoModal },
	                "\xD7"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "cashBalance",
	    get: function get() {
	      var cashBalance = this.props.cashBalance;
	
	
	      return Number(cashBalance).toFixed(0);
	    }
	  }]);
	
	  return ReturnDebtModal;
	}(_react.Component);
	
	exports.default = ReturnDebtModal;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _ApiService = __webpack_require__(4);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AVAILABLE_CASH = ("https://be-production-itb.marketgames.io/api/") + "team/page/financials/";
	var OUTSTANDING_CASH = ("https://be-production-itb.marketgames.io/api/") + "team/post_money/";
	var REPURCHASED_COSTS = ("https://be-production-itb.marketgames.io/api/") + "team/stock_repurchased/";
	var DIVIDENTS_PAYMENT = ("https://be-production-itb.marketgames.io/api/") + "team/dividends_payment/";
	var REPURCHASED_COSTS_PERFORMANCE = ("https://be-production-itb.marketgames.io/api/") + "team/performance_money/";
	
	var ReturnEquityModal = function (_Component) {
	  _inherits(ReturnEquityModal, _Component);
	
	  function ReturnEquityModal(props) {
	    _classCallCheck(this, ReturnEquityModal);
	
	    var _this = _possibleConstructorReturn(this, (ReturnEquityModal.__proto__ || Object.getPrototypeOf(ReturnEquityModal)).call(this, props));
	
	    _this.showSuccessMessage = function (successMessage) {
	      _this.setState({
	        successMessage: successMessage
	      }, function () {
	        _this.hideSuccessMessage();
	      });
	    };
	
	    _this.hideSuccessMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          successMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.fetchData = function () {
	      var roundNumber = _this.props.roundNumber;
	
	      var prevRoundNumber = roundNumber - 1 > 0 ? roundNumber - 1 : 1;
	
	      _this.setState({
	        loading: true
	      });
	
	      (0, _ApiService.getRequest)(REPURCHASED_COSTS + ("?round_number=" + roundNumber)).then(function (res) {
	        _this.setState({
	          id: res.body.length > 0 ? res.body[0].id : 0
	        });
	      });
	
	      (0, _ApiService.getRequest)(AVAILABLE_CASH + ("?round_number=" + roundNumber)).then(function (res) {
	        var ending_cash = res.body.team.ending_cash;
	
	
	        _this.setState({
	          availableCash: Number(ending_cash.toFixed(0)),
	          loading: false
	        });
	      });
	
	      (0, _ApiService.getRequest)(OUTSTANDING_CASH + ("?round_number=" + roundNumber)).then(function (res) {
	        if (res.body.length > 0) {
	          var shares = res.body[0].shares;
	
	
	          _this.setState({
	            outstandingShares: shares
	          });
	        }
	      });
	
	      (0, _ApiService.getRequest)(REPURCHASED_COSTS_PERFORMANCE + ("?round_number=" + prevRoundNumber)).then(function (res) {
	        if (res.body.length > 0) {
	          var share_price = res.body[0].share_price;
	
	
	          _this.setState({
	            pricePerShares: Number(share_price.toFixed(2))
	          });
	        }
	      });
	
	      (0, _ApiService.getRequest)(REPURCHASED_COSTS + ("?round_number=" + roundNumber)).then(function (res) {
	        if (res.body.length > 0) {
	          var _res$body$ = res.body[0],
	              shares = _res$body$.shares,
	              id = _res$body$.id;
	
	
	          _this.setState({
	            sharesToRepurchase: shares,
	            sharesToRepurchaseId: id
	          });
	        } else {
	          _this.setState({
	            sharesToRepurchase: 0,
	            sharesToRepurchaseId: 0
	          });
	        }
	      });
	
	      (0, _ApiService.getRequest)(DIVIDENTS_PAYMENT + ("?round_number=" + roundNumber)).then(function (res) {
	        if (res.body.length > 0) {
	          var _res$body$2 = res.body[0],
	              payment = _res$body$2.payment,
	              id = _res$body$2.id;
	
	
	          _this.setState({
	            dividentPayment: payment,
	            dividentPaymentId: id
	          });
	        } else {
	          _this.setState({
	            dividentPayment: 0,
	            dividentPaymentId: 0
	          });
	        }
	      });
	    };
	
	    _this.deleteDividentPayment = function () {
	      var dividentPaymentId = _this.state.dividentPaymentId;
	
	
	      if (dividentPaymentId > 0) {
	        (0, _ApiService.deleteRequest)(DIVIDENTS_PAYMENT + (dividentPaymentId + "/")).then(function (res) {
	          _this.hideAlert();
	          _this.fetchData();
	        });
	      }
	    };
	
	    _this.submitDividentPayment = function () {
	      var reloadData = _this.props.reloadData;
	      var _this$state = _this.state,
	          dividentPayment = _this$state.dividentPayment,
	          dividentPaymentId = _this$state.dividentPaymentId;
	
	
	      _this.setState({
	        error: ""
	      });
	
	      var sendRequest = dividentPaymentId > 0 ? _ApiService.putRequest : _ApiService.postRequest;
	      var url = dividentPaymentId > 0 ? dividentPaymentId + "/" : "";
	
	      sendRequest(DIVIDENTS_PAYMENT + url).send({ payment: dividentPayment }).then(function (res) {
	        _this.showSuccessMessage(_react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          "A dividend payment of ",
	          _react2.default.createElement(
	            "b",
	            null,
	            dividentPayment.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 0
	            })
	          ),
	          " is successfully scheduled to be paid to equity investors"
	        ));
	        reloadData();
	        _this.fetchData();
	      }).catch(function (err) {
	        if (err.response) {
	          if ("payment" in err.response.body) {
	            _this.handleError(err.response.body["payment"][0].toLowerCase());
	          } else if ("non_field_errors" in err.response.body) {
	            _this.handleError(err.response.body["non_field_errors"][0].toLowerCase());
	          }
	        }
	      });
	    };
	
	    _this.deleteSharesToRepurchase = function () {
	      var sharesToRepurchaseId = _this.state.sharesToRepurchaseId;
	
	
	      if (sharesToRepurchaseId > 0) {
	        (0, _ApiService.deleteRequest)(REPURCHASED_COSTS + (sharesToRepurchaseId + "/")).then(function (res) {
	          _this.hideAlert();
	          _this.fetchData();
	        });
	      }
	    };
	
	    _this.submitSharesToRepurchase = function () {
	      var reloadData = _this.props.reloadData;
	      var _this$state2 = _this.state,
	          sharesToRepurchase = _this$state2.sharesToRepurchase,
	          sharesToRepurchaseId = _this$state2.sharesToRepurchaseId;
	
	
	      _this.setState({
	        error: ""
	      });
	
	      var sendRequest = sharesToRepurchaseId > 0 ? _ApiService.putRequest : _ApiService.postRequest;
	      var url = sharesToRepurchaseId > 0 ? sharesToRepurchaseId + "/" : "";
	
	      sendRequest(REPURCHASED_COSTS + url).send({ shares: sharesToRepurchase }).then(function (res) {
	        var _res$body = res.body,
	            shares = _res$body.shares,
	            cost = _res$body.cost;
	
	        _this.showSuccessMessage(_react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            shares.toLocaleString('en-US')
	          ),
	          " shares is successfully scheduled to be repurchased at a cost ",
	          _react2.default.createElement(
	            "b",
	            null,
	            cost.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 0
	            })
	          )
	        ));
	        reloadData();
	        _this.fetchData();
	      }).catch(function (err) {
	        if (err.response) {
	          if ("shares" in err.response.body) {
	            _this.handleError(err.response.body["shares"][0].toLowerCase());
	          } else if ("non_field_errors" in err.response.body) {
	            _this.handleError(err.response.body["non_field_errors"][0].toLowerCase());
	          }
	        }
	      });
	    };
	
	    _this.handleError = function (text) {
	      var errorTitle = '';
	      var errorMessage = '';
	      if (text.indexOf("shares cannot be negative") > -1) {
	        errorTitle = 'Value Cannot Be Negative';
	        errorMessage = 'Please input a value that’s zero or greater';
	      }
	      if (text.indexOf("payment cannot be negative") > -1) {
	        errorTitle = 'Value Cannot Be Negative';
	        errorMessage = 'Please input a value that’s zero or greater';
	      }
	      if (text.indexOf("cannot repurchase more than available") > -1) {
	        errorTitle = 'Buyback > Outstanding Shares';
	        errorMessage = 'You cannot buy back more than your outstanding shares.';
	      }
	      if (text.indexOf("amount too high") > -1 || text.indexOf("amount exceeds the available capital") > -1) {
	        errorTitle = 'Value > Available Cash';
	        errorMessage = 'Payment cannot exceed your available cash balance';
	      }
	      if (text.indexOf("exceding debt to capital ratio") > -1) {
	        errorTitle = 'Debt to Capital Breach';
	        errorMessage = 'This payment would put you in breach of your lender(s) debt-to-capital limit. In order to make this payment, you’ll need to reduce your debt-to-capital ratio.';
	      }
	
	      if (text !== "") {
	        _this.setState({
	          showError: true,
	          errorTitle: errorTitle,
	          errorMessage: errorMessage
	        });
	      }
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      }, function () {
	        _this.fetchData();
	      });
	    };
	
	    _this.close = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.hideError = function () {
	      _this.setState({
	        showError: false
	      });
	    };
	
	    _this.showAlert = function (onAlertSuccess) {
	      _this.setState({
	        showAlert: true,
	        onAlertSuccess: onAlertSuccess
	      });
	    };
	
	    _this.hideAlert = function () {
	      _this.setState({
	        showAlert: false
	      });
	    };
	
	    _this.onModifyRepCosts = function () {
	      var urlForPut = REPURCHASED_COSTS + ("" + _this.state.id);
	      _this.handlingErrors(" ");
	
	      console.log(urlForPut);
	
	      if (_this.state.id !== "") {
	        (0, _ApiService.putRequest)(urlForPut).send({
	          shares: _this.state.repurchasedCosts.replace(/,/g, "")
	        }).then(function (res) {
	          _this.handlingErrors(" ");
	          _this.setState({
	            id: ""
	          });
	          _this.fetchData();
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }
	    };
	
	    _this.modifyDivident = function () {
	      var urlForPut = DIVIDENTS_PAYMENT + ("" + _this.state.dividentPaymentId);
	      _this.handlingErrors(" ");
	
	      console.log(urlForPut);
	      if (_this.state.dividentPaymentId !== "") {
	        (0, _ApiService.putRequest)(urlForPut).send({
	          payment: _this.state.dividentPayment.replace("$", "").replace(/,/g, "")
	        }).then(function (res) {
	          _this.handlingErrors(" ");
	          _this.setState({
	            dividentPaymentId: ""
	          });
	          _this.fetchData();
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }
	    };
	
	    _this.handleChangeShares = function (e, value) {
	      var val = "floatValue" in value ? value.floatValue : Number(e.target.value);
	      _this.setState({
	        sharesToRepurchase: val
	      });
	    };
	
	    _this.handleChangeDivident = function (e, value) {
	      var val = "floatValue" in value ? value.floatValue : Number(e.target.value);
	      _this.setState({
	        dividentPayment: val
	      });
	    };
	
	    _this.state = {
	      show: false,
	      loading: true,
	      availableCash: 0,
	      outstandingShares: 0,
	      pricePerShares: 0,
	      sharesToRepurchase: 0,
	      sharesToRepurchaseId: 0,
	      dividentPayment: 0,
	      dividentPaymentId: 0,
	      error: "",
	      showError: false,
	      errorTitle: '',
	      errorMessage: '',
	      showAlert: '',
	      successMessage: null,
	      onAlertSuccess: function onAlertSuccess() {}
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ReturnEquityModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-return-equity-modal", this.show);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-return-equity-modal", this.show);
	    }
	  }, {
	    key: "conditionalRenderCash",
	    value: function conditionalRenderCash() {
	      var availableCash = this.state.availableCash;
	
	
	      return _react2.default.createElement(
	        "span",
	        { style: { color: availableCash < 0 ? "#FF4D4F" : "#9EA8B4" } },
	        _react2.default.createElement(_reactNumberFormat2.default, {
	          value: availableCash,
	          displayType: "text",
	          prefix: "$",
	          thousandSeparator: ","
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          show = _state.show,
	          loading = _state.loading,
	          outstandingShares = _state.outstandingShares,
	          pricePerShares = _state.pricePerShares,
	          sharesToRepurchase = _state.sharesToRepurchase,
	          sharesToRepurchaseId = _state.sharesToRepurchaseId,
	          dividentPayment = _state.dividentPayment,
	          showError = _state.showError,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          successMessage = _state.successMessage,
	          showAlert = _state.showAlert,
	          onAlertSuccess = _state.onAlertSuccess;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          onHide: this.close,
	          dialogClassName: "modal-dialog-bigger-more fn-modal-dialog finance-decisions-modal"
	        },
	        showError && _react2.default.createElement(_error2.default, {
	          title: errorTitle,
	          message: errorMessage,
	          onHide: this.hideError
	        }),
	        showAlert && _react2.default.createElement(_warning2.default, {
	          title: "Are you sure?",
	          message: "Deleting this decision cannot be undone",
	          onSuccess: onAlertSuccess,
	          onCancel: this.hideAlert
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          { closeButton: true },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Returning Capital | Equity"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Cash Balance: ",
	            this.conditionalRenderCash()
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          loading === true && _react2.default.createElement(
	            "div",
	            { className: "text-center loader-inline" },
	            _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	          ),
	          loading === false && _react2.default.createElement(
	            "div",
	            null,
	            successMessage && _react2.default.createElement(_success2.default, {
	              message: successMessage,
	              marginTop: 1,
	              marginBottom: 80
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-narrow-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-line outstanding-line" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label" },
	                  "Outstanding Shares"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-value" },
	                  _react2.default.createElement(_reactNumberFormat2.default, {
	                    value: outstandingShares,
	                    displayType: "text",
	                    thousandSeparator: ","
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-line buyback-line" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label black" },
	                  "Buyback Shares"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-input-wrapper" },
	                  _react2.default.createElement(_AbbreviateNumber2.default, {
	                    type: "input",
	                    value: sharesToRepurchase,
	                    onChange: this.handleChangeShares,
	                    prefix: ""
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-line per-share-line" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label" },
	                  "Price Per Share"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-value" },
	                  _react2.default.createElement(_reactNumberFormat2.default, {
	                    value: pricePerShares,
	                    displayType: "text",
	                    prefix: "$",
	                    thousandSeparator: ","
	                  })
	                )
	              ),
	              _react2.default.createElement("div", { className: "modal-divider" }),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-line repurchase-cost-line" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label" },
	                  "Total Repurchase Cost"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "modal-right-content-container" },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "modal-value" },
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: this.totalRepurchaseCosts,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "modal-button",
	                        onClick: this.submitSharesToRepurchase
	                      },
	                      "Update"
	                    ),
	                    sharesToRepurchaseId > 0 && _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "modal-button delete",
	                        onClick: function onClick() {
	                          return _this2.showAlert(_this2.deleteSharesToRepurchase);
	                        }
	                      },
	                      "Delete"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "modal-divider" }),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-narrow-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-line pay-dividends-line" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "modal-label black" },
	                  "Pay Dividends"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "modal-right-content-container" },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "modal-input-wrapper" },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: "input",
	                      value: dividentPayment,
	                      onChange: this.handleChangeDivident
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "modal-button",
	                        onClick: this.submitDividentPayment
	                      },
	                      "Update"
	                    ),
	                    sharesToRepurchaseId > 0 && _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "modal-button delete",
	                        onClick: function onClick() {
	                          return _this2.showAlert(_this2.deleteDividentPayment);
	                        }
	                      },
	                      "Delete"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "totalRepurchaseCosts",
	    get: function get() {
	      var _state2 = this.state,
	          pricePerShares = _state2.pricePerShares,
	          sharesToRepurchase = _state2.sharesToRepurchase;
	
	
	      return pricePerShares * sharesToRepurchase;
	    }
	  }]);
	
	  return ReturnEquityModal;
	}(_react.Component);
	
	exports.default = ReturnEquityModal;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _roleButtons = __webpack_require__(258);
	
	var _roleButtons2 = _interopRequireDefault(_roleButtons);
	
	var _submitDecisions = __webpack_require__(261);
	
	var _submitDecisions2 = _interopRequireDefault(_submitDecisions);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UiTitle(props) {
	  var isOwnRole = props.isOwnRole,
	      hasAccess = props.hasAccess,
	      submitDecisionsLoading = props.submitDecisionsLoading,
	      submitDecisionsData = props.submitDecisionsData,
	      submitDecisions = props.submitDecisions,
	      financial_decisions = props.financial_decisions,
	      unaccepted_decisions = props.unaccepted_decisions,
	      loading = props.loading,
	      isPreChecked = props.isPreChecked,
	      isRoundEnded = props.isRoundEnded;
	
	
	  return _react2.default.createElement(
	    _style2.default.TitleWrapper,
	    null,
	    _react2.default.createElement(
	      _style2.default.Title,
	      null,
	      "Finance Decisions",
	      isOwnRole === true && loading === false && _react2.default.createElement(_roleButtons2.default, { type: "finance" })
	    ),
	    hasAccess === true && _react2.default.createElement(_submitDecisions2.default, {
	      id: "finance-submit-decisions",
	      tooltipPlacement: "bottom",
	      data: submitDecisionsData,
	      isLoading: submitDecisionsLoading,
	      onClick: submitDecisions,
	      financial_decisions: financial_decisions,
	      unaccepted_decisions: unaccepted_decisions,
	      buttonComponent: _style2.default.SubmitDecisionButton,
	      isPreChecked: isPreChecked,
	      isRoundEnded: isRoundEnded
	    })
	  );
	}
	
	exports.default = UiTitle;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	/**
	 * Price in millions.
	 */
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName;
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "n/a"
	    );
	  }
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(2) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: "red " + baseClassName },
	      "-$" + newPrice + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(2);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "$" + newPrice + "M"
	    );
	  }
	};
	
	/**
	 * Table Head
	 */
	
	/**
	 *
	 * FNAnalysisFNStatementsBalanceSheet
	 *
	 */
	
	var TableHead = function TableHead(_ref2) {
	  var current_year = _ref2.current_year;
	  return _react2.default.createElement(
	    "thead",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "th",
	        { className: "table-title text-center" },
	        _react2.default.createElement("span", null)
	      ),
	      _react2.default.createElement(
	        "th",
	        { className: "table-title title-gray text-center" },
	        "YEAR ",
	        current_year
	      )
	    )
	  );
	};
	
	/**
	 * Table row contents
	 */
	var TableRowContentWhite = function TableRowContentWhite(_ref3) {
	  var balanceSheet = _ref3.balanceSheet;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      balanceSheet.name
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: balanceSheet.data.value
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents with gray background color.
	 */
	
	var TableRowContentGray = function TableRowContentGray(_ref4) {
	  var balanceSheet = _ref4.balanceSheet;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      balanceSheet.name
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: balanceSheet.data.value
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents with dim gray background color.
	 */
	
	var TableRowContentDimGray = function TableRowContentDimGray(_ref5) {
	  var balanceSheet = _ref5.balanceSheet;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center dim-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        balanceSheet.name
	      )
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: balanceSheet.data.value
	      })
	    )
	  );
	};
	
	/**
	 * Table row title.
	 */
	
	var TableRowContentHeader = function TableRowContentHeader(_ref6) {
	  var title = _ref6.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title title-sky-blue" },
	      title
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row flex" },
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" })
	      )
	    )
	  );
	};
	
	/**
	 * Table row sub header.
	 */
	
	var TableRowContentSubheader = function TableRowContentSubheader(_ref7) {
	  var title = _ref7.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title" },
	      title
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row flex" },
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" })
	      )
	    )
	  );
	};
	
	/**
	 *
	 * FNAnalysisFNStatementsBalanceSheet
	 *
	 */
	function BalanceSheetWidget(_ref8) {
	  var balanceSheet = _ref8.balanceSheet,
	      current_year = _ref8.current_year,
	      _ref8$className = _ref8.className,
	      className = _ref8$className === undefined ? "team-reports-with-scroll" : _ref8$className;
	  var accountsPayable = balanceSheet.accountsPayable,
	      accountsReceivable = balanceSheet.accountsReceivable,
	      accruedExpenses = balanceSheet.accruedExpenses,
	      accumulatedDepreciation = balanceSheet.accumulatedDepreciation,
	      additionalPaidinCapital = balanceSheet.additionalPaidinCapital,
	      begRetainedEarnings = balanceSheet.begRetainedEarnings,
	      cash = balanceSheet.cash,
	      commonStock = balanceSheet.commonStock,
	      deferredRevenues = balanceSheet.deferredRevenues,
	      dividends = balanceSheet.dividends,
	      inventory = balanceSheet.inventory,
	      longTermDebt = balanceSheet.longTermDebt,
	      netIncome = balanceSheet.netIncome,
	      otherCurrentLiabilities = balanceSheet.otherCurrentLiabilities,
	      otherLongTermLiabilities = balanceSheet.otherLongTermLiabilities,
	      ppe = balanceSheet.ppe,
	      preferredStock = balanceSheet.preferredStock,
	      prepaidExpenses = balanceSheet.prepaidExpenses,
	      shortTermDebt = balanceSheet.shortTermDebt,
	      supplies = balanceSheet.supplies,
	      totalAssets = balanceSheet.totalAssets,
	      totalCurrentAssets = balanceSheet.totalCurrentAssets,
	      totalCurrentLiabilities = balanceSheet.totalCurrentLiabilities,
	      totalEquity = balanceSheet.totalEquity,
	      totalLiabilities = balanceSheet.totalLiabilities,
	      totalLongTermAssets = balanceSheet.totalLongTermAssets,
	      totalLongTermLiabilities = balanceSheet.totalLongTermLiabilities;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "panel-dashboard-white-full " + className },
	    _react2.default.createElement(
	      "h5",
	      { className: "title-sky-blue" },
	      "Balance Sheet",
	      _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	        iconSize: "sm"
	      }, _TypeformContent2.default.BALANCE_SHEET))
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table-responsive fn-results-table" },
	      _react2.default.createElement(
	        "table",
	        { className: "table border-analysis mb-20" },
	        _react2.default.createElement(TableHead, { current_year: current_year }),
	        Object.keys(accountsPayable.data).length > 0 || Object.keys(accountsReceivable.data).length > 0 || Object.keys(accruedExpenses.data).length > 0 ? _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(TableRowContentSubheader, { title: "Current Assets:" }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: cash }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: accountsReceivable }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: inventory }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: prepaidExpenses }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: supplies }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalCurrentAssets }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "" }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "Long Term Assets:" }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: ppe }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: accumulatedDepreciation }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "" }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalLongTermAssets }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalAssets }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentHeader, { title: "Liabilities" }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "Current Liabilities" }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: deferredRevenues }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: accountsPayable }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: accruedExpenses }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: shortTermDebt }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: otherCurrentLiabilities }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalCurrentLiabilities }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "Long Term Liabilities" }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: longTermDebt }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: otherLongTermLiabilities }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalLongTermLiabilities }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalLiabilities }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentHeader, { title: "Equity" }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: commonStock }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: preferredStock }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: additionalPaidinCapital }),
	          _react2.default.createElement(TableRowContentHeader, { title: "Retained Earnings:" }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: begRetainedEarnings }),
	          _react2.default.createElement(TableRowContentWhite, { balanceSheet: netIncome }),
	          _react2.default.createElement(TableRowContentGray, { balanceSheet: dividends }),
	          _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalEquity })
	        ) : _react2.default.createElement("tbody", null)
	      )
	    )
	  );
	}
	
	exports.default = BalanceSheetWidget;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	/**
	 * Price in millions.
	 */
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName;
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "n/a"
	    );
	  }
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(2) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: "red " + baseClassName },
	      "-$" + newPrice + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(2);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "$" + newPrice + "M"
	    );
	  }
	};
	
	/**
	 * Table Head
	 */
	
	/**
	 *
	 * FNAnalysisFNStatementsCashFlow
	 *
	 */
	
	var TableHead = function TableHead(_ref2) {
	  var current_year = _ref2.current_year;
	  return _react2.default.createElement(
	    "thead",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "th",
	        { className: "table-title text-center" },
	        _react2.default.createElement("span", null)
	      ),
	      _react2.default.createElement(
	        "th",
	        { className: "table-title title-gray text-center" },
	        "YEAR ",
	        current_year
	      )
	    )
	  );
	};
	
	/**
	 * Table row contents
	 */
	
	var TableRowContentWhite = function TableRowContentWhite(_ref3) {
	  var cashFlow = _ref3.cashFlow,
	      title = _ref3.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      title ? title : cashFlow.name
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: cashFlow.data.value
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents with gray background color.
	 */
	
	var TableRowContentGray = function TableRowContentGray(_ref4) {
	  var cashFlow = _ref4.cashFlow;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      cashFlow.name
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: cashFlow.data.value
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents with dim gray background color.
	 */
	
	var TableRowContentDimGray = function TableRowContentDimGray(_ref5) {
	  var cashFlow = _ref5.cashFlow;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center dim-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        cashFlow.name
	      )
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(PriceInMillions, {
	        baseClassName: "text-center",
	        price: cashFlow.data.value
	      })
	    )
	  );
	};
	
	/**
	 * Table row title.
	 */
	
	var TableRowContentHeader = function TableRowContentHeader(_ref6) {
	  var title = _ref6.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title title-sky-blue" },
	      title
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row flex" },
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" })
	      )
	    )
	  );
	};
	
	/**
	 * Table row sub header.
	 */
	
	var TableRowContentSubheader = function TableRowContentSubheader(_ref7) {
	  var title = _ref7.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title" },
	      title
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row flex" },
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" }),
	        _react2.default.createElement("div", { className: "col-xs-6" })
	      )
	    )
	  );
	};
	
	/**
	 *
	 * FNAnalysisFNStatementsCashFlow
	 *
	 */
	function CashFlowWidget(_ref8) {
	  var cashFlow = _ref8.cashFlow,
	      current_year = _ref8.current_year,
	      _ref8$className = _ref8.className,
	      className = _ref8$className === undefined ? "team-reports-with-scroll" : _ref8$className;
	  var beginningCash = cashFlow.beginningCash,
	      capitalExpenditurePurchases = cashFlow.capitalExpenditurePurchases,
	      capitalExpenditureSales = cashFlow.capitalExpenditureSales,
	      cashpaymentforIncomeTaxes = cashFlow.cashpaymentforIncomeTaxes,
	      cashpaymentforInterests = cashFlow.cashpaymentforInterests,
	      cashpaymentsforOperatingexpenses = cashFlow.cashpaymentsforOperatingexpenses,
	      cashpaymentsforPurchases = cashFlow.cashpaymentsforPurchases,
	      cashpaymentsforWages = cashFlow.cashpaymentsforWages,
	      cashreceivedfromCustomers = cashFlow.cashreceivedfromCustomers,
	      debtBorrowed = cashFlow.debtBorrowed,
	      debtRepaid = cashFlow.debtRepaid,
	      dividends = cashFlow.dividends,
	      endingCash = cashFlow.endingCash,
	      investmentPurchases = cashFlow.investmentPurchases,
	      investmentSales = cashFlow.investmentSales,
	      netChangeinCash = cashFlow.netChangeinCash,
	      stockIssuance = cashFlow.stockIssuance,
	      stockRepurchase = cashFlow.stockRepurchase,
	      totalCashFlowsfromFinancing = cashFlow.totalCashFlowsfromFinancing,
	      totalCashFlowsfromInvesting = cashFlow.totalCashFlowsfromInvesting,
	      totalCashFlowsfromOperations = cashFlow.totalCashFlowsfromOperations;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "panel-dashboard-white-full " + className },
	    _react2.default.createElement(
	      "h5",
	      { className: "title-sky-blue" },
	      "Cash Flows",
	      _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	        iconSize: "sm"
	      }, _TypeformContent2.default.CASH_FLOWS))
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table-responsive fn-results-table" },
	      _react2.default.createElement(
	        "table",
	        { className: "table border-analysis mb-20" },
	        _react2.default.createElement(TableHead, { current_year: current_year }),
	        Object.keys(beginningCash.data).length > 0 || Object.keys(capitalExpenditurePurchases.data).length > 0 || Object.keys(capitalExpenditureSales.data).length > 0 ? _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(TableRowContentSubheader, { title: "Cash Flows From Operations:" }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: cashreceivedfromCustomers }),
	          _react2.default.createElement(TableRowContentWhite, {
	            cashFlow: cashpaymentsforPurchases,
	            title: "Cash payment for Suppliers"
	          }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: cashpaymentsforWages }),
	          _react2.default.createElement(TableRowContentWhite, {
	            cashFlow: cashpaymentsforOperatingexpenses,
	            title: "Cash payment for Operating expenses"
	          }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: cashpaymentforInterests }),
	          _react2.default.createElement(TableRowContentWhite, { cashFlow: cashpaymentforIncomeTaxes }),
	          _react2.default.createElement(TableRowContentDimGray, { cashFlow: totalCashFlowsfromOperations }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "" }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "Cash Flows From Investing:" }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: capitalExpenditurePurchases }),
	          _react2.default.createElement(TableRowContentWhite, { cashFlow: capitalExpenditureSales }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: investmentPurchases }),
	          _react2.default.createElement(TableRowContentWhite, { cashFlow: investmentSales }),
	          _react2.default.createElement(TableRowContentDimGray, { cashFlow: totalCashFlowsfromInvesting }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "" }),
	          _react2.default.createElement(TableRowContentSubheader, { title: "Cash Flow From Financing:" }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: stockIssuance }),
	          _react2.default.createElement(TableRowContentWhite, { cashFlow: stockRepurchase }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: dividends }),
	          _react2.default.createElement(TableRowContentWhite, { cashFlow: debtBorrowed }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: debtRepaid }),
	          _react2.default.createElement(TableRowContentDimGray, { cashFlow: totalCashFlowsfromFinancing }),
	          _react2.default.createElement(TableRowContentHeader, { title: "" }),
	          _react2.default.createElement(TableRowContentHeader, { title: "Change In Cash" }),
	          _react2.default.createElement(TableRowContentWhite, { cashFlow: beginningCash }),
	          _react2.default.createElement(TableRowContentGray, { cashFlow: endingCash }),
	          _react2.default.createElement(TableRowContentDimGray, { cashFlow: netChangeinCash })
	        ) : _react2.default.createElement("tbody", { className: "empty-table" })
	      )
	    )
	  );
	}
	
	exports.default = CashFlowWidget;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _modal = __webpack_require__(581);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.bsSizes(["md"], _reactBootstrap.Button);
	
	var GetStartedPage = function (_PureComponent) {
	  _inherits(GetStartedPage, _PureComponent);
	
	  function GetStartedPage(props) {
	    _classCallCheck(this, GetStartedPage);
	
	    var _this = _possibleConstructorReturn(this, (GetStartedPage.__proto__ || Object.getPrototypeOf(GetStartedPage)).call(this, props));
	
	    _this.handleClick = function (e) {
	      e.preventDefault();
	      _this.eventemitter.trigger("open-get-started-modal");
	    };
	
	    _this.onFinish = function () {
	      var routes = {
	        ceo: 'ceo',
	        pd: 'product-development',
	        pm: 'product-marketing',
	        op: 'operations',
	        fi: 'finance',
	        fn: 'finance'
	      };
	      var round = _this.props.currentRound;
	
	      var role = _Auth2.default.getRole();
	      var route = routes[role.toLowerCase()];
	
	      if (_this.redirectToDecisions === true) {
	        _this.props.router.push("/decisions/" + route + "?round=" + round + "&from=get-started");
	      } else {
	        _this.props.router.push("/start");
	      }
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(GetStartedPage, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          _props$team_color = _props.team_color,
	          team_color = _props$team_color === undefined ? "#fff" : _props$team_color,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	      var activeRound = roundInUrl !== null ? roundInUrl : currentRound;
	
	      return _react2.default.createElement(
	        "section",
	        { className: "welcomePage" },
	        _react2.default.createElement(
	          "div",
	          { className: "text-center" },
	          _react2.default.createElement(
	            "h1",
	            { className: "welcome-header" },
	            "Welcome to Market Games!"
	          )
	        ),
	        _react2.default.createElement(_modal2.default, {
	          className: "getStarterModal",
	          team_color: team_color,
	          activeRound: activeRound,
	          onFinish: this.onFinish,
	          nextOnLastStep: this.redirectToDecisions
	        })
	      );
	    }
	  }, {
	    key: "redirectToDecisions",
	    get: function get() {
	      var round = this.props.currentRound;
	
	
	      return round === 1 && !this.roundIsFinished;
	    }
	  }, {
	    key: "roundIsFinished",
	    get: function get() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          rounds = _props2.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	
	      return round && (round.should_be_finished === true || round.is_finished) ? true : false;
	    }
	  }]);
	
	  return GetStartedPage;
	}(_react.PureComponent);
	
	exports.default = GetStartedPage;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _goalsAndTargetsMarketShare = __webpack_require__(560);
	
	var _goalsAndTargetsMarketShare2 = _interopRequireDefault(_goalsAndTargetsMarketShare);
	
	var _goalsAndTargetsRevenues = __webpack_require__(561);
	
	var _goalsAndTargetsRevenues2 = _interopRequireDefault(_goalsAndTargetsRevenues);
	
	var _goalsAndTargetsGrossMargins = __webpack_require__(559);
	
	var _goalsAndTargetsGrossMargins2 = _interopRequireDefault(_goalsAndTargetsGrossMargins);
	
	var _goalsAndTargetsSharePrice = __webpack_require__(564);
	
	var _goalsAndTargetsSharePrice2 = _interopRequireDefault(_goalsAndTargetsSharePrice);
	
	var _goalsAndTargetsRoe = __webpack_require__(563);
	
	var _goalsAndTargetsRoe2 = _interopRequireDefault(_goalsAndTargetsRoe);
	
	var _goalsAndTargetsRoa = __webpack_require__(562);
	
	var _goalsAndTargetsRoa2 = _interopRequireDefault(_goalsAndTargetsRoa);
	
	var _goalsAndTargetsEps = __webpack_require__(558);
	
	var _goalsAndTargetsEps2 = _interopRequireDefault(_goalsAndTargetsEps);
	
	var _styles = __webpack_require__(1200);
	
	var _FinancialTargets = __webpack_require__(399);
	
	var _FinancialTargets2 = _interopRequireDefault(_FinancialTargets);
	
	var _infoTooltip = __webpack_require__(1057);
	
	var _infoTooltip2 = _interopRequireDefault(_infoTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var videos = {
	  'Market Share': _goalsAndTargetsMarketShare2.default,
	  'Revenues': _goalsAndTargetsRevenues2.default,
	  'Gross Margins': _goalsAndTargetsGrossMargins2.default,
	  'Share Price': _goalsAndTargetsSharePrice2.default,
	  'ROE': _goalsAndTargetsRoe2.default,
	  'ROA': _goalsAndTargetsRoa2.default,
	  'EPS': _goalsAndTargetsEps2.default
	};
	
	var GoalsAndTargets = function (_PureComponent) {
	  _inherits(GoalsAndTargets, _PureComponent);
	
	  function GoalsAndTargets(props) {
	    _classCallCheck(this, GoalsAndTargets);
	
	    var _this = _possibleConstructorReturn(this, (GoalsAndTargets.__proto__ || Object.getPrototypeOf(GoalsAndTargets)).call(this, props));
	
	    _this.handlePlayPause = function () {
	      if (_this.videoRef) {
	        if (_this.state.isVideoPlaying) {
	          _this.videoRef.pause();
	        } else {
	          _this.videoRef.play();
	        }
	        _this.setState({ isVideoPlaying: !_this.state.isVideoPlaying });
	      }
	    };
	
	    _this.openModal = function (videoSrc) {
	      _this.setState({
	        isModalShown: true,
	        selectedVideo: videoSrc
	      });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({
	        isModalShown: false,
	        isVideoPlaying: false
	      });
	    };
	
	    _this.onHelpIconClick = function (field) {
	      if (videos[field]) {
	        _this.openModal(videos[field]);
	      }
	    };
	
	    _this.getData = function (res) {
	      var currentRound = _this.currentRound;
	      var roundId = currentRound ? Number(currentRound.id) : 0;
	      var currentTeam = _Teams2.default.currentTeam();
	      var teamId = Number(currentTeam.id);
	      var courseId = Number(_Auth2.default.getCourseId());
	      var userId = Number(_Auth2.default.getUserId());
	
	      return res && res.results ? res.results.find(function (i) {
	        return Number(i.round) === roundId && Number(i.user) === userId && Number(i.course) === courseId && Number(i.team) === teamId;
	      }) || null : null;
	    };
	
	    _this.getFormattedData = function (res) {
	      var values = _this.getData(res);
	      var data = {
	        id: values ? Number(values.id) : null
	      };
	      var columns = _this.columns;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var column = _step.value;
	
	          var field = column[2];
	          data[field] = 0;
	
	          if (values && values[field]) {
	            data[field] = Number(values[field]);
	          }
	
	          var callback = column[4];
	          data[field] = callback(data[field]).toFixed(2);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return data;
	    };
	
	    _this.getValue = function (field) {
	      var data = _this.state.data;
	
	
	      if (!(field in data)) {
	        return '';
	      }
	
	      return data[field];
	    };
	
	    _this.setValue = function (e, field) {
	      var data = _this.state.data;
	
	
	      if (!(field in data)) {
	        return;
	      }
	
	      var value = e.target.value;
	
	      _this.setState({
	        data: Object.assign({}, data, _defineProperty({}, field, value))
	      });
	    };
	
	    _this.formatValue = function (field) {
	      var data = _this.state.data;
	
	
	      if (!(field in data)) {
	        return;
	      }
	
	      var value = Number(data[field]);
	      if (isNaN(value)) {
	        value = 0;
	      }
	      value = value.toFixed(2);
	      if (value !== data[field]) {
	        _this.setState({
	          data: Object.assign({}, data, _defineProperty({}, field, value))
	        });
	      }
	    };
	
	    _this.percentToValue = function (percent) {
	      return percent / 100;
	    };
	
	    _this.valueToPercent = function (value) {
	      return value * 100;
	    };
	
	    _this.millionToValue = function (million) {
	      return million * 1000000;
	    };
	
	    _this.valueToMillion = function (value) {
	      return value / 1000000;
	    };
	
	    _this.asIsValue = function (value) {
	      return value;
	    };
	
	    _this.save = function () {
	      _this.setState({
	        formLoading: true
	      });
	
	      var currentRound = _this.currentRound;
	      var roundId = currentRound ? Number(currentRound.id) : 0;
	      var currentTeam = _Teams2.default.currentTeam();
	      var teamId = Number(currentTeam.id);
	      var courseId = Number(_Auth2.default.getCourseId());
	      var userId = Number(_Auth2.default.getUserId());
	
	      var data = _this.state.data;
	
	      var preparedData = {
	        round: roundId,
	        user: userId,
	        course: courseId,
	        team: teamId,
	        market_share: 0,
	        net_revenues: 0,
	        gross_margins: 0,
	        share_price: 0,
	        roe: 0,
	        roa: 0,
	        earnings_per_share: 0
	      };
	      var columns = _this.columns;
	
	      var _loop = function _loop(k, v) {
	        var column = columns.find(function (i) {
	          return i[2] === k;
	        });
	        if (column) {
	          var callback = column[3];
	          preparedData[k] = callback(Number(v));
	        }
	      };
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = Object.entries(data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _ref = _step2.value;
	
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var k = _ref2[0];
	          var v = _ref2[1];
	
	          _loop(k, v);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var apiRequest = _ApiService.postRequest;
	      var url = ("https://be-production-itb.marketgames.io/api/") + 'v2/games/goaltargets/';
	      if (!!data.id) {
	        apiRequest = _ApiService.putRequest;
	        url = '' + url + data.id + '/';
	      }
	
	      apiRequest(url).send(preparedData).then(function (res) {
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/goaltargets/').then(function (res) {
	          var data = _this.getFormattedData(res.body);
	          var values = _this.getData(res.body);
	          var alreadySaved = !!values;
	
	          _this.setState({
	            formLoading: false,
	            alreadySaved: alreadySaved,
	            data: data
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      financialTargets: [],
	      data: {},
	      loaded: false,
	      formLoading: false,
	      alreadySaved: false,
	      isModalShown: false,
	      isVideoPlaying: false,
	      selectedVideo: null
	    };
	
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(GoalsAndTargets, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var courseId = Number(_Auth2.default.getCourseId());
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + courseId).then(function (res) {
	        _this2.setState({
	          financialTargets: res.body,
	          loaded: true
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          financialTargets = _state.financialTargets,
	          formLoading = _state.formLoading,
	          isModalShown = _state.isModalShown,
	          isVideoPlaying = _state.isVideoPlaying;
	
	      var activeRound = this.activeRound;
	
	      return loaded ? _react2.default.createElement(
	        _styles.Wrapper,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { show: isModalShown, onHide: this.closeModal, className: 'goals-and-targets-modal' },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              _styles.ModalVideoWrapper,
	              { className: isVideoPlaying ? 'is-playing' : '' },
	              _react2.default.createElement('video', {
	                ref: function ref(_ref3) {
	                  _this3.videoRef = _ref3;
	                },
	                src: this.state.selectedVideo,
	                alt: 'Welcome Video',
	                onClick: this.handlePlayPause,
	                onEnded: function onEnded() {
	                  return _this3.setState({ isVideoPlaying: false });
	                },
	                style: { width: '100%', borderRadius: 10 }
	              }),
	              _react2.default.createElement(
	                _styles.PlayPauseButton,
	                { onClick: this.handlePlayPause },
	                isVideoPlaying ? '❚❚' : '▶'
	              ),
	              _react2.default.createElement(
	                _styles.CloseModalVideoButton,
	                { onClick: this.closeModal },
	                '\xD7'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _styles.Title,
	          null,
	          'Set Team Goals & Targets'
	        ),
	        formLoading && _react2.default.createElement(
	          _styles.Form,
	          { height: '232px' },
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        ),
	        _react2.default.createElement(
	          _styles.Description,
	          null,
	          'Below shows the financial targets to hit in each year. Note that a few financial metrics are only relevant in certain years. Use the information here as references to set your team goals.'
	        ),
	        _react2.default.createElement(
	          _styles.Form,
	          { maxWidth: '800px' },
	          _react2.default.createElement(_FinancialTargets2.default, {
	            round: activeRound,
	            financialTargets: financialTargets,
	            showTableOnly: true,
	            showFullTable: true,
	            hideTitle: true,
	            padding: '0px',
	            onHelpIconClick: this.onHelpIconClick
	          })
	        )
	      ) : _react2.default.createElement(
	        _styles.Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return Number(roundInUrl || currentRound);
	    }
	  }, {
	    key: 'columns',
	    get: function get() {
	      var activeRound = this.activeRound;
	
	      if (activeRound === 1 || activeRound === 2) {
	        return [['Market Share', '%', 'market_share', this.percentToValue, this.valueToPercent], ['Revenues', '$ (million)', 'net_revenues', this.millionToValue, this.valueToMillion], ['Gross Margins', '%', 'gross_margins', this.percentToValue, this.valueToPercent], ['Share Price', '$', 'share_price', this.asIsValue, this.asIsValue]];
	      }
	
	      if (activeRound === 3) {
	        return [['Revenues', '$ (million)', 'net_revenues', this.millionToValue, this.valueToMillion], ['Gross Margins', '%', 'gross_margins', this.percentToValue, this.valueToPercent], ['Return On Equity', '%', 'roe', this.percentToValue, this.valueToPercent], ['Return On Assets', '%', 'roa', this.percentToValue, this.valueToPercent]];
	      }
	
	      if (activeRound === 4) {
	        return [['Return On Equity', '%', 'roe', this.percentToValue, this.valueToPercent], ['Return On Assets', '%', 'roa', this.percentToValue, this.valueToPercent], ['Earnings Per Share', '$', 'earnings_per_share', this.asIsValue, this.asIsValue], ['Share Price', '$', 'share_price', this.asIsValue, this.asIsValue]];
	      }
	
	      return [];
	    }
	  }, {
	    key: 'currentRound',
	    get: function get() {
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	
	      return rounds.find(function (i) {
	        return Number(i.number) === activeRound;
	      });
	    }
	  }, {
	    key: 'isReadOnly',
	    get: function get() {
	      var round = this.currentRound;
	      return !(round ? round.is_started === true && round.is_finished === false && round.should_be_finished === false : false);
	    }
	  }]);
	
	  return GoalsAndTargets;
	}(_react.PureComponent);
	
	exports.default = GoalsAndTargets;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CloseModalVideoButton = exports.PlayPauseButton = exports.ModalVideoWrapper = exports.InfoTooltip = exports.Button = exports.ButtonRow = exports.Description = exports.Line = exports.FormLabelRight = exports.FormLabelLeft = exports.FormLabel = exports.FormColumn = exports.FormColumns = exports.FormTitle = exports.Form = exports.Title = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #fafafa;\n  padding: 40px;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n'], ['\n  background: #fafafa;\n  padding: 40px;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  max-width: 960px;\n  padding: 20px;\n  margin-top: 12px;\n\n  ', '\n\n  ', '\n\n  .loader {\n    max-width: auto;\n\n    .loader-inner {\n      div {\n        margin: 0;\n      }\n    }\n  }\n'], ['\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  max-width: 960px;\n  padding: 20px;\n  margin-top: 12px;\n\n  ', '\n\n  ', '\n\n  .loader {\n    max-width: auto;\n\n    .loader-inner {\n      div {\n        margin: 0;\n      }\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  span {\n    color: #ee6863;\n    font-weight: 500;\n    font-size: 16px;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  span {\n    color: #ee6863;\n    font-weight: 500;\n    font-size: 16px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 40px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 40px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  flex: 1;\n\n  input[type="text"] {\n    display: block;\n    width: 100%;\n    margin: 4px 0 0;\n    padding: 5px 12px;\n    background: #ffffff;\n    border: 1px solid #d9d9d9;\n    border-radius: 2px;\n    outline: none;\n\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: rgba(0, 27, 59, 0.94);\n\n    &:read-only {\n      color: rgba(0, 27, 59, 0.38);\n      background: rgba(0, 27, 59, 0.04);\n    }\n  }\n'], ['\n  flex: 1;\n\n  input[type="text"] {\n    display: block;\n    width: 100%;\n    margin: 4px 0 0;\n    padding: 5px 12px;\n    background: #ffffff;\n    border: 1px solid #d9d9d9;\n    border-radius: 2px;\n    outline: none;\n\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: rgba(0, 27, 59, 0.94);\n\n    &:read-only {\n      color: rgba(0, 27, 59, 0.38);\n      background: rgba(0, 27, 59, 0.04);\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.38);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.38);\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 960px;\n  height: 1px;\n  background: #d5d9dd;\n  margin-top: 20px;\n'], ['\n  width: 100%;\n  max-width: 960px;\n  height: 1px;\n  background: #d5d9dd;\n  margin-top: 20px;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  max-width: 800px;\n  margin-top: 12px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  max-width: 800px;\n  margin-top: 12px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n  text-align: right;\n'], ['\n  margin-top: 20px;\n  text-align: right;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  display: inline-block;\n  width: 160px;\n  height: 40px;\n  margin: 0;\n  padding: 0;\n  border-radius: 4px;\n  border: 0;\n  background: #5c91f5;\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.5s ease-in-out;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #ffffff;\n\n  &:hover {\n    background-color: #85acf7;\n  }\n'], ['\n  display: inline-block;\n  width: 160px;\n  height: 40px;\n  margin: 0;\n  padding: 0;\n  border-radius: 4px;\n  border: 0;\n  background: #5c91f5;\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.5s ease-in-out;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #ffffff;\n\n  &:hover {\n    background-color: #85acf7;\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: #5c91f5;\n\n  width: 273px;\n  height: 40px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n  margin-top: 40px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: #5c91f5;\n\n  width: 273px;\n  height: 40px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n  margin-top: 40px;\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n'], ['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n'], ['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = exports.Title = _styledComponents2.default.div(_templateObject2);
	
	var Form = exports.Form = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.maxWidth && '\n    max-width: ' + p.maxWidth + ';\n  ';
	}, function (p) {
	  return p.height && '\n    height: ' + p.height + ';\n  ';
	});
	
	var FormTitle = exports.FormTitle = _styledComponents2.default.div(_templateObject4);
	
	var FormColumns = exports.FormColumns = _styledComponents2.default.div(_templateObject5);
	
	var FormColumn = exports.FormColumn = _styledComponents2.default.div(_templateObject6);
	
	var FormLabel = exports.FormLabel = _styledComponents2.default.div(_templateObject7);
	
	var FormLabelLeft = exports.FormLabelLeft = _styledComponents2.default.div(_templateObject8);
	
	var FormLabelRight = exports.FormLabelRight = _styledComponents2.default.div(_templateObject9);
	
	var Line = exports.Line = _styledComponents2.default.div(_templateObject10);
	
	var Description = exports.Description = _styledComponents2.default.div(_templateObject11);
	
	var ButtonRow = exports.ButtonRow = _styledComponents2.default.div(_templateObject12);
	
	var Button = exports.Button = _styledComponents2.default.button(_templateObject13);
	
	var InfoTooltip = exports.InfoTooltip = _styledComponents2.default.div(_templateObject14);
	
	var ModalVideoWrapper = exports.ModalVideoWrapper = _styledComponents2.default.div(_templateObject15);
	
	var PlayPauseButton = exports.PlayPauseButton = _styledComponents2.default.button(_templateObject16);
	
	var CloseModalVideoButton = exports.CloseModalVideoButton = _styledComponents2.default.button(_templateObject17);

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n  font-family: 'Mukta Vaani', sans-serif;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n  font-family: 'Mukta Vaani', sans-serif;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"], ["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.78);\n  margin: 0 0 24px;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.78);\n  margin: 0 0 24px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"], ["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #248339; border-color: #248339; }\n  &:disabled { background: #a4d9b1; border-color: #a4d9b1; cursor: default; }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #248339; border-color: #248339; }\n  &:disabled { background: #a4d9b1; border-color: #a4d9b1; cursor: default; }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n  text-align: left;\n"], ["\n  margin-top: 24px;\n  text-align: left;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-bottom: 8px;\n"], ["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.7);\n  margin-bottom: 8px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 8px;\n  background: hsla(213, 100%, 12%, 0.08);\n  border-radius: 999px;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  height: 8px;\n  background: hsla(213, 100%, 12%, 0.08);\n  border-radius: 999px;\n  overflow: hidden;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  height: 100%;\n  background: #2DA548;\n  width: ", "%;\n  transition: width 0.4s ease;\n"], ["\n  height: 100%;\n  background: #2DA548;\n  width: ", "%;\n  transition: width 0.4s ease;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  font-size: 14px;\n  color: #d34c4c;\n"], ["\n  margin-top: 16px;\n  font-size: 14px;\n  color: #d34c4c;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Instructor-only "Survey Ready to Review" popup. Fires on login when
	// at least one finished peer-eval survey (initial or final) exists
	// AND insights haven't been generated for it yet.
	//
	// Click "Generate Insights" runs four server steps back-to-back
	// (fires for both initial and final peer-eval surveys):
	//   1a) POST /v2/forms/surveys/<survey>/calc-score/
	//       (peer-score calculation from the latest feedback)
	//   1b) POST /v2/games/usergrade/run/  { game, survey } form-encoded
	//       (per-user grade compile — needs 1a's peer scores to be fresh)
	//   2)  GET  /v2/insights/survey/<survey>/students/?page=1&page_size=1
	//       (short-circuit if insights are already there)
	//   3)  POST /v2/insights/generate/<survey>/              (insights job)
	//       Then poll the returned status_url until status === 'done'.
	//
	// A progress bar advances through the four stages so the instructor
	// sees continuous motion. Poll cadence + timeouts mirror the existing
	// dashboard.js flow (10s / 30s / 60s tiers, 6-minute cap).
	
	var Backdrop = _styledComponents2.default.div(_templateObject);
	
	var Card = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3);
	
	var Description = _styledComponents2.default.p(_templateObject4);
	
	var Actions = _styledComponents2.default.div(_templateObject5);
	
	var PrimaryButton = _styledComponents2.default.button(_templateObject6);
	
	var ProgressWrap = _styledComponents2.default.div(_templateObject7);
	
	var ProgressLabel = _styledComponents2.default.div(_templateObject8);
	
	var ProgressTrack = _styledComponents2.default.div(_templateObject9);
	
	var ProgressFill = _styledComponents2.default.div(_templateObject10, function (p) {
	  return Math.max(0, Math.min(100, p.pct));
	});
	
	var ErrorMsg = _styledComponents2.default.div(_templateObject11);
	
	// Poll tiers — same shape as the roster-upload + dashboard flow.
	var POLL_FIRST_DELAY_MS = 10 * 1000;
	var POLL_MID_DELAY_MS = 30 * 1000;
	var POLL_LATE_DELAY_MS = 60 * 1000;
	var POLL_MID_THRESHOLD_MS = 2 * 60 * 1000;
	var POLL_LATE_THRESHOLD_MS = 4 * 60 * 1000;
	var POLL_MAX_DURATION_MS = 6 * 60 * 1000;
	
	// Progress percentage per stage. Polling grows over time within its
	// slice so the bar visibly moves.
	var STAGE_PROGRESS = {
	  idle: 0,
	  'running-score': 10,
	  'checking-insights': 20,
	  'generating': 30,
	  'polling-min': 30,
	  'polling-max': 95,
	  'done': 100
	};
	
	// Map peer-eval survey stage → course_members field that gates the
	// popup and gets PATCHed once the instructor clicks Generate.
	var VIEWED_FIELD_FOR_STAGE = {
	  initial: 'initial_survey_viewed',
	  final: 'final_survey_viewed'
	};
	
	var InstructorSurveyReadyNotification = function (_PureComponent) {
	  _inherits(InstructorSurveyReadyNotification, _PureComponent);
	
	  function InstructorSurveyReadyNotification() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InstructorSurveyReadyNotification);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstructorSurveyReadyNotification.__proto__ || Object.getPrototypeOf(InstructorSurveyReadyNotification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      checked: false,
	      targetSurvey: null,
	      gameId: null,
	      // Instructor's own course_members row id — needed for the PATCH
	      // that marks the viewed flag true once Generate is clicked.
	      courseMemberId: null,
	      stage: 'idle',
	      errorMessage: null,
	      pollElapsedMs: 0,
	      dismissed: false
	    }, _this.evaluate = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var courseId, gameId, userId, allSurveys, courseMembers, authUser, viewedResults, isLeadInstructor, hasSectionAssignments, selfSummary, coversAll, isAssistantOrCo, leadAllowed, assistantAllowed, now, isFinished, evalSurveys, withStatus, missing, target;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              courseId = _Auth2.default.getCourseId();
	              gameId = _Auth2.default.getGameId();
	              userId = _Auth2.default.getUserId();
	
	              if (!(!courseId || !gameId || !userId)) {
	                _context.next = 6;
	                break;
	              }
	
	              _this.setState({ checked: true });
	              return _context.abrupt("return");
	
	            case 6:
	
	              // All four decision inputs are available in state the Dashboard
	              // already loaded on mount — no dedicated surveys/ or course_members/
	              // fetch at mount time:
	              //   - props.allSurveys                (from /app/survey-data/)
	              //   - props.courseMembers[0]          (from general-info; carries
	              //                                      covers_all_sections for the
	              //                                      Co-Instructor / IAS branch)
	              //   - Auth.getUser().position         (lead vs assistant / co)
	              //   - Auth.getUser().sections         (section assignments, if any)
	              //   - Auth.getUser().viewed_results   (from general-info data.user)
	              allSurveys = Array.isArray(_this.props.allSurveys) ? _this.props.allSurveys : [];
	              courseMembers = Array.isArray(_this.props.courseMembers) ? _this.props.courseMembers : [];
	              authUser = _Auth2.default.getUser() || {};
	              viewedResults = authUser.viewed_results && _typeof(authUser.viewed_results) === 'object' ? authUser.viewed_results : {};
	
	              // Wait for Dashboard to hydrate before deciding; componentDidUpdate
	              // re-runs this when allSurveys arrives.
	
	              if (!(allSurveys.length === 0)) {
	                _context.next = 12;
	                break;
	              }
	
	              return _context.abrupt("return");
	
	            case 12:
	
	              // Peer evaluation + insight generation is a course-level action.
	              // Allowed to see this popup:
	              //   1. Lead instructor (position === "Instructor") with no
	              //      section assignments on their user record (full course lead).
	              //   2. Co-Instructor OR Instructor Assistant whose course_members
	              //      row has covers_all_sections === true.
	              // Section-scoped assistants / co-instructors stay suppressed.
	              isLeadInstructor = authUser.position === "Instructor";
	              hasSectionAssignments = Array.isArray(authUser.sections) && authUser.sections.length > 0;
	              selfSummary = courseMembers[0];
	              coversAll = selfSummary && selfSummary.covers_all_sections === true;
	              isAssistantOrCo = authUser.position === "Co-Instructor" || authUser.position === "Instructor Assistant";
	              leadAllowed = isLeadInstructor && !hasSectionAssignments;
	              assistantAllowed = isAssistantOrCo && coversAll;
	
	              if (!(!leadAllowed && !assistantAllowed)) {
	                _context.next = 22;
	                break;
	              }
	
	              _this.setState({ checked: true });
	              return _context.abrupt("return");
	
	            case 22:
	
	              // Peer-eval surveys are stage 'initial' or 'final'. Only care about
	              // the ones past their end AND whose matching viewed flag on
	              // user.viewed_results is still false (i.e. the instructor hasn't
	              // acknowledged / generated for this one yet).
	              now = Date.now();
	
	              isFinished = function isFinished(s) {
	                return s && s.end && new Date(s.end).getTime() < now;
	              };
	
	              evalSurveys = allSurveys.filter(function (s) {
	                if (!s || !isFinished(s)) return false;
	                var field = VIEWED_FIELD_FOR_STAGE[s.stage];
	                if (!field) return false;
	                return viewedResults[field] === false;
	              });
	
	              if (!(evalSurveys.length === 0)) {
	                _context.next = 28;
	                break;
	              }
	
	              _this.setState({ checked: true });
	              return _context.abrupt("return");
	
	            case 28:
	              _context.prev = 28;
	              _context.next = 31;
	              return Promise.all(evalSurveys.map(function (s) {
	                return Promise.all([_this.checkInsightsExist(s.id), _this.checkAnyCompletion(s.id)]).then(function (_ref3) {
	                  var _ref4 = _slicedToArray(_ref3, 2),
	                      hasInsights = _ref4[0],
	                      hasAnyCompletion = _ref4[1];
	
	                  return {
	                    survey: s,
	                    hasInsights: hasInsights,
	                    hasAnyCompletion: hasAnyCompletion
	                  };
	                });
	              }));
	
	            case 31:
	              withStatus = _context.sent;
	              missing = withStatus.filter(function (x) {
	                return !x.hasInsights && x.hasAnyCompletion;
	              }).map(function (x) {
	                return x.survey;
	              }).sort(function (a, b) {
	                return new Date(b.end) - new Date(a.end);
	              });
	              target = missing[0] || null;
	              // courseMemberId left null here; it's resolved lazily right
	              // before the viewed-flag PATCH on Generate click. The PATCH is
	              // fire-and-forget and guarded by `if (courseMemberId)` so the
	              // generate flow doesn't block on it.
	
	              _this.setState({
	                checked: true,
	                targetSurvey: target,
	                gameId: gameId
	              });
	              _context.next = 40;
	              break;
	
	            case 37:
	              _context.prev = 37;
	              _context.t0 = _context["catch"](28);
	
	              _this.setState({ checked: true });
	
	            case 40:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[28, 37]]);
	    })), _this.resolveCourseMemberId = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var courseId, userId, apiUrl, res, body, list, selfMember, id;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!_this.state.courseMemberId) {
	                _context2.next = 2;
	                break;
	              }
	
	              return _context2.abrupt("return", _this.state.courseMemberId);
	
	            case 2:
	              courseId = _Auth2.default.getCourseId();
	              userId = _Auth2.default.getUserId();
	
	              if (!(!courseId || !userId)) {
	                _context2.next = 6;
	                break;
	              }
	
	              return _context2.abrupt("return", null);
	
	            case 6:
	              apiUrl = ("https://be-production-itb.marketgames.io/api/");
	              _context2.prev = 7;
	              _context2.next = 10;
	              return (0, _ApiService.getRequest)(apiUrl + "course_members/?course=" + courseId + "&user=" + userId);
	
	            case 10:
	              res = _context2.sent;
	              body = res && res.body;
	              list = Array.isArray(body && body.results) ? body.results : Array.isArray(body) ? body : body ? [body] : [];
	              selfMember = list.find(function (m) {
	                return m && Number(m.user) === Number(userId);
	              });
	              id = selfMember ? selfMember.id : null;
	
	              if (id) _this.setState({ courseMemberId: id });
	              return _context2.abrupt("return", id);
	
	            case 19:
	              _context2.prev = 19;
	              _context2.t0 = _context2["catch"](7);
	              return _context2.abrupt("return", null);
	
	            case 22:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[7, 19]]);
	    })), _this.checkInsightsExist = function (surveyId) {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      return (0, _ApiService.getRequest)(apiUrl + "v2/insights/survey/" + surveyId + "/students/?page=1&page_size=1").then(function (res) {
	        var body = res && res.body || {};
	        var results = Array.isArray(body.results) ? body.results : [];
	        return results.length > 0;
	      }).catch(function () {
	        return false;
	      });
	    }, _this.checkAnyCompletion = function (surveyId) {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      return (0, _ApiService.getRequest)(apiUrl + "v2/games/peer-score/" + surveyId + "/").then(function (res) {
	        var body = res && res.body || {};
	        var rows = Array.isArray(body) ? body : body.results || [];
	        return rows.some(function (r) {
	          return r && r.completion === true;
	        });
	      }).catch(function () {
	        return false;
	      });
	    }, _this.progressPct = function () {
	      var _this$state = _this.state,
	          stage = _this$state.stage,
	          pollElapsedMs = _this$state.pollElapsedMs;
	
	      if (stage === 'polling') {
	        var min = STAGE_PROGRESS['polling-min'];
	        var max = STAGE_PROGRESS['polling-max'];
	        var capped = Math.min(POLL_MAX_DURATION_MS, pollElapsedMs);
	        var ratio = capped / POLL_MAX_DURATION_MS;
	        return Math.round(min + (max - min) * ratio);
	      }
	      return STAGE_PROGRESS[stage] || 0;
	    }, _this.progressLabel = function () {
	      switch (_this.state.stage) {
	        case 'running-score':
	          return 'Running peer scores…';
	        case 'checking-insights':
	          return 'Checking for existing insights…';
	        case 'generating':
	          return 'Kicking off insight generation…';
	        case 'polling':
	          return 'Generating insights (typically up to 5 minutes)…';
	        case 'done':
	          return 'Done!';
	        default:
	          return '';
	      }
	    }, _this.handleGenerate = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var targetSurvey, gameId, apiUrl, field, alreadyThere, res, body, statusUrl;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              targetSurvey = _this.state.targetSurvey;
	
	              if (targetSurvey) {
	                _context3.next = 3;
	                break;
	              }
	
	              return _context3.abrupt("return");
	
	            case 3:
	
	              // Resolve gameId defensively at click time. state.gameId was
	              // captured during evaluate() and can be stale (or zero if the
	              // instructor's sessionStorage was missing game_id at mount);
	              // Auth.getGameId() reads from sessionStorage now, which is the
	              // freshest source we have. Fall back to state.gameId only if
	              // Auth is empty.
	              gameId = Number(_Auth2.default.getGameId()) || Number(_this.state.gameId) || 0;
	
	              if (gameId) {
	                _context3.next = 7;
	                break;
	              }
	
	              _this.setState({
	                stage: 'error',
	                errorMessage: "Couldn't determine the game context. Please refresh the page and try again."
	              });
	              return _context3.abrupt("return");
	
	            case 7:
	
	              _this.setState({ stage: 'running-score', errorMessage: null });
	              apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	              // Fire-and-forget the course_members PATCH so the popup won't
	              // resurface on next login regardless of whether the downstream
	              // score/generate steps succeed. Instructor's intent has been
	              // captured by the button click. courseMemberId is resolved lazily
	              // here (one GET to course_members/) rather than at mount — keeps
	              // the dashboard first-paint clean of popup-only fetches.
	
	              field = VIEWED_FIELD_FOR_STAGE[targetSurvey.stage];
	
	              if (field) {
	                _this.resolveCourseMemberId().then(function (id) {
	                  if (!id) return;
	                  (0, _ApiService.patchRequest)(apiUrl + "course_members/" + id + "/viewed/").send(_defineProperty({}, field, true)).catch(function () {/* silent — retry naturally next click */});
	                });
	              }
	
	              _context3.prev = 11;
	              _context3.next = 14;
	              return (0, _ApiService.postRequest)(apiUrl + "v2/forms/surveys/" + targetSurvey.id + "/calc-score/");
	
	            case 14:
	              _context3.next = 20;
	              break;
	
	            case 16:
	              _context3.prev = 16;
	              _context3.t0 = _context3["catch"](11);
	
	              _this.setState({
	                stage: 'error',
	                errorMessage: "Couldn't run the peer-score calculation. Please try again."
	              });
	              return _context3.abrupt("return");
	
	            case 20:
	              _context3.prev = 20;
	              _context3.next = 23;
	              return (0, _ApiService.postRequest)(apiUrl + "v2/games/usergrade/run/").send({ game: gameId, survey: targetSurvey.id }).type("form");
	
	            case 23:
	              _context3.next = 29;
	              break;
	
	            case 25:
	              _context3.prev = 25;
	              _context3.t1 = _context3["catch"](20);
	
	              _this.setState({
	                stage: 'error',
	                errorMessage: "Couldn't run the peer-score job. Please try again."
	              });
	              return _context3.abrupt("return");
	
	            case 29:
	
	              // Step 2: re-check insights existence in case another
	              // instructor already generated between our initial evaluate() and
	              // now. Skip generation if so.
	              _this.setState({ stage: 'checking-insights' });
	              alreadyThere = false;
	              _context3.prev = 31;
	              _context3.next = 34;
	              return _this.checkInsightsExist(targetSurvey.id);
	
	            case 34:
	              alreadyThere = _context3.sent;
	              _context3.next = 40;
	              break;
	
	            case 37:
	              _context3.prev = 37;
	              _context3.t2 = _context3["catch"](31);
	
	              // Ignore — treat as "not there" so we still try to generate.
	              alreadyThere = false;
	
	            case 40:
	              if (!alreadyThere) {
	                _context3.next = 43;
	                break;
	              }
	
	              _this.setState({ stage: 'done', dismissed: true });
	              return _context3.abrupt("return");
	
	            case 43:
	
	              // Step 3: kick off insights job + poll status_url.
	              _this.setState({ stage: 'generating' });
	              _context3.prev = 44;
	              _context3.next = 47;
	              return (0, _ApiService.postRequest)(apiUrl + "v2/insights/generate/" + targetSurvey.id + "/").send({});
	
	            case 47:
	              res = _context3.sent;
	              body = res && res.body || {};
	              statusUrl = body.status_url;
	
	              if (statusUrl) {
	                _context3.next = 53;
	                break;
	              }
	
	              // BE didn't return a status_url — assume job is queued and
	              // dismiss. Instructor can refresh later to see if it landed.
	              _this.setState({ stage: 'done', dismissed: true });
	              return _context3.abrupt("return");
	
	            case 53:
	              _this._startPolling(statusUrl);
	              _context3.next = 59;
	              break;
	
	            case 56:
	              _context3.prev = 56;
	              _context3.t3 = _context3["catch"](44);
	
	              _this.setState({
	                stage: 'error',
	                errorMessage: "Couldn't kick off insight generation. Please try again."
	              });
	
	            case 59:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this2, [[11, 16], [20, 25], [31, 37], [44, 56]]);
	    })), _this._startPolling = function (statusUrl) {
	      _this._pollStartTime = Date.now();
	      _this.setState({ stage: 'polling', pollElapsedMs: 0 });
	      // Tick the local elapsed counter every second so the bar visibly
	      // fills between actual poll responses.
	      _this._pollTicker = setInterval(function () {
	        var elapsed = Date.now() - _this._pollStartTime;
	        _this.setState({ pollElapsedMs: elapsed });
	        if (elapsed > POLL_MAX_DURATION_MS) {
	          _this._stopPolling();
	          _this.setState({
	            stage: 'error',
	            errorMessage: 'Still processing. Please refresh in a moment to check again.'
	          });
	        }
	      }, 1000);
	      _this._scheduleNextPoll(statusUrl, POLL_FIRST_DELAY_MS);
	    }, _this._scheduleNextPoll = function (statusUrl, delay) {
	      _this._pollTimeout = setTimeout(function () {
	        return _this._pollOnce(statusUrl);
	      }, delay);
	    }, _this._pollOnce = function (statusUrl) {
	      var elapsed = Date.now() - _this._pollStartTime;
	      if (elapsed > POLL_MAX_DURATION_MS) {
	        _this._stopPolling();
	        return;
	      }
	      var url = _this._resolveStatusUrl(statusUrl);
	      (0, _ApiService.getRequest)(url).then(function (res) {
	        var body = res && res.body || {};
	        var status = body.status;
	        if (status === 'done') {
	          _this._stopPolling();
	          _this.setState({ stage: 'done', dismissed: true });
	          return;
	        }
	        if (status === 'error' || status === 'failed') {
	          _this._stopPolling();
	          _this.setState({
	            stage: 'error',
	            errorMessage: body.error || 'Insight generation failed. Please try again.'
	          });
	          return;
	        }
	        // Still running — schedule next poll based on elapsed time.
	        var nowElapsed = Date.now() - _this._pollStartTime;
	        var nextDelay = nowElapsed < POLL_MID_THRESHOLD_MS ? POLL_FIRST_DELAY_MS : nowElapsed < POLL_LATE_THRESHOLD_MS ? POLL_MID_DELAY_MS : POLL_LATE_DELAY_MS;
	        _this._scheduleNextPoll(statusUrl, nextDelay);
	      }).catch(function () {
	        // Transient error — keep polling on the same cadence.
	        _this._scheduleNextPoll(statusUrl, POLL_MID_DELAY_MS);
	      });
	    }, _this._stopPolling = function () {
	      if (_this._pollTimeout) {
	        clearTimeout(_this._pollTimeout);
	        _this._pollTimeout = null;
	      }
	      if (_this._pollTicker) {
	        clearInterval(_this._pollTicker);
	        _this._pollTicker = null;
	      }
	    }, _this._resolveStatusUrl = function (statusUrl) {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      if (statusUrl.startsWith('/api/')) {
	        return "" + apiUrl + statusUrl.slice(5);
	      }
	      return "" + apiUrl + statusUrl.replace(/^\//, '');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InstructorSurveyReadyNotification, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.evaluate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Props arrive from Dashboard after its own general-info / survey-
	      // data fetches resolve. If evaluate() ran before props landed, it
	      // bailed early; re-run once allSurveys becomes available so we
	      // don't miss the popup on first mount.
	      if (this.state.checked) return;
	      var prevReady = Array.isArray(prevProps.allSurveys) && prevProps.allSurveys.length > 0;
	      var nextReady = Array.isArray(this.props.allSurveys) && this.props.allSurveys.length > 0;
	      if (!prevReady && nextReady) {
	        this.evaluate();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._stopPolling();
	      if (this._pollTicker) clearInterval(this._pollTicker);
	    }
	
	    // Peer-eval "at least one student completed" gate. If nobody
	    // submitted peer feedback, there's nothing to score and no reason
	    // to nudge the instructor toward the scoring/insights job.
	
	
	    // Progress percentage from current stage + polling elapsed.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          checked = _state.checked,
	          targetSurvey = _state.targetSurvey,
	          stage = _state.stage,
	          errorMessage = _state.errorMessage,
	          dismissed = _state.dismissed;
	
	      if (!checked || dismissed || !targetSurvey) return null;
	
	      var isBusy = ['running-score', 'checking-insights', 'generating', 'polling'].includes(stage);
	      var label = this.progressLabel();
	      var pct = this.progressPct();
	
	      return _react2.default.createElement(
	        Backdrop,
	        null,
	        _react2.default.createElement(
	          Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Title,
	            null,
	            targetSurvey.stage === 'initial' ? 'Initial Survey Ready to Review' : 'Final Survey Ready to Review'
	          ),
	          _react2.default.createElement(
	            Description,
	            null,
	            "Peer feedback has been collected for this survey. Run the scoring job and generate insights so students can review their results."
	          ),
	          _react2.default.createElement(
	            Actions,
	            null,
	            _react2.default.createElement(
	              PrimaryButton,
	              {
	                type: "button",
	                onClick: this.handleGenerate,
	                disabled: isBusy
	              },
	              isBusy ? 'Working…' : 'Generate Peer Scores & Insights'
	            )
	          ),
	          isBusy && _react2.default.createElement(
	            ProgressWrap,
	            null,
	            _react2.default.createElement(
	              ProgressLabel,
	              null,
	              label
	            ),
	            _react2.default.createElement(
	              ProgressTrack,
	              null,
	              _react2.default.createElement(ProgressFill, { pct: pct })
	            )
	          ),
	          errorMessage && _react2.default.createElement(
	            ErrorMsg,
	            null,
	            errorMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return InstructorSurveyReadyNotification;
	}(_react.PureComponent);
	
	exports.default = InstructorSurveyReadyNotification;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onClickHandler(e, url, title) {
	  e.preventDefault();
	  var eventemitter = _eventEmitter2.default.getInstance();
	  eventemitter.trigger("open-typeform-modal", [url, "knowledge-base-modal", { margin: "10px 0", height: "calc(100% - 20px)" }]);
	}
	
	function KnowledgeBaseCard(_ref) {
	  var _ref$url = _ref.url,
	      url = _ref$url === undefined ? "" : _ref$url,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$isMobile = _ref.isMobile,
	      isMobile = _ref$isMobile === undefined ? false : _ref$isMobile;
	
	  var cardClass = isMobile ? "knowledge-base-card knowledge-base-card-mobile" : "knowledge-base-card";
	
	  return _react2.default.createElement(
	    "a",
	    { href: "/#", onClick: function onClick(e) {
	        return onClickHandler(e, url, title);
	      } },
	    _react2.default.createElement(
	      "div",
	      { className: cardClass },
	      _react2.default.createElement(
	        "h4",
	        { className: "title" },
	        title
	      )
	    )
	  );
	}
	
	KnowledgeBaseCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	
	exports.default = KnowledgeBaseCard;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KnowledgeBaseContent = [
	/*{
	  key: 'balance_sheet',
	  title: 'Balance Sheet',
	  url: TypeformUrls.BALANCE_SHEET,
	  order: 10000,
	},
	{
	  key: 'capital_budgeting',
	  title: 'Capital Budgeting',
	  url: TypeformUrls.CAPITAL_BUDGETING,
	  order: 10000,
	},
	{
	  key: 'capital_structure',
	  title: 'Capital Structure',
	  url: TypeformUrls.CAPITAL_STRUCTURE,
	  order: 10000,
	},
	{
	  key: 'cash_flows',
	  title: 'Cash Flows',
	  url: TypeformUrls.CASH_FLOWS,
	  order: 10000,
	},
	{
	  key: 'cost_of_capital',
	  title: 'Cost of Capital',
	  url: TypeformUrls.COST_OF_CAPITAL,
	  order: 10000,
	},
	{
	  key: 'debt_vs_equity',
	  title: 'Debt vs Equity',
	  url: TypeformUrls.DEBT_VS_EQUITY,
	  order: 10000,
	},
	{
	  key: 'debt_to_capital',
	  title: 'Debt to Capital',
	  url: TypeformUrls.DEBT_TO_CAPITAL,
	  order: 10000,
	},
	{
	  key: 'discount_rate',
	  title: 'Discount Rate',
	  url: TypeformUrls.DISCOUNT_RATE,
	  order: 10000,
	},
	{
	  key: 'dividend_yield',
	  title: 'Dividend Yield',
	  url: TypeformUrls.DIVIDEND_YIELD,
	  order: 10000,
	},
	{
	  key: 'earnings_per_share',
	  title: 'Earnings Per Share',
	  url: TypeformUrls.EARNINGS_PER_SHARE,
	  order: 10000,
	},
	{
	  key: 'earnings_yield',
	  title: 'Earnings Yield',
	  url: TypeformUrls.EARNINGS_YIELD,
	  order: 10000,
	},*/
	{
	  title: "Financial Metrics",
	  url: _TypeformUrls2.default.FINANCIAL_METRICS,
	  order: 2
	},
	/*{
	  key: 'financial_projections',
	  title: 'Financial Projections',
	  url: TypeformUrls.FINANCIAL_PROJECTIONS,
	  order: 10000,
	},
	{
	  key: 'financial_planning_analysis',
	  title: 'Financial Planning & Analysis',
	  url: TypeformUrls.FINANCIAL_ANALYSIS,
	  order: 10000,
	},*/
	{
	  key: "financials",
	  title: "Financials",
	  url: _TypeformUrls2.default.FINANCIALS,
	  order: 1
	  /*{
	    key: 'income_statement',
	    title: 'Income Statement',
	    url: TypeformUrls.INCOME_STATEMENT,
	    order: 10000,
	  },
	  {
	    key: 'irr',
	    title: 'IRR',
	    url: TypeformUrls.IRR,
	    order: 10000,
	  },
	  {
	    key: 'issuing_shares',
	    title: 'Issuing Shares',
	    url: TypeformUrls.SHARES_OUTSTANDING,
	    order: 10000,
	  },
	  {
	    key: 'kpi',
	    title: 'KPIs',
	    url: TypeformUrls.KPI,
	    order: 10000,
	  },
	  {
	    key: 'marketing_mix',
	    title: 'Marketing Mix',
	    url: TypeformUrls.MARKETING_MIX,
	    order: 10000,
	  },
	  {
	    key: 'marketing_funnel',
	    title: 'Marketing Funnel',
	    url: TypeformUrls.MARKETING_FUNNEL,
	    order: 10000,
	  },
	  {
	    key: 'product_market_fit',
	    title: 'Product Market Fit',
	    url: TypeformUrls.PRODUCT_MARKET_FIT,
	    order: 10000,
	  },
	  {
	    key: 'product_costs',
	    title: 'Product Costs',
	    url: TypeformUrls.PRODUCT_COSTS,
	    order: 10000,
	  },
	  {
	    key: 'product_lifecycle',
	    title: 'Product Lifecycle',
	    url: TypeformUrls.PRODUCT_LIFECYCLE,
	    order: 10000,
	  },
	  {
	    key: 'roic',
	    title: 'Return on Invested Capital',
	    url: TypeformUrls.ROIC,
	    order: 10000,
	  },
	  {
	    key: 'rnoa',
	    title: 'Return on Net Operating Assets',
	    url: TypeformUrls.RNOA,
	    order: 10000,
	  },
	  {
	    key: 'stock_price',
	    title: 'Stock Price',
	    url: TypeformUrls.STOCK_PRICE,
	    order: 10000,
	  },
	  {
	    key: 'time_value_of_money',
	    title: 'Time Value of Money',
	    url: TypeformUrls.TIME_VALUE_OF_MONEY,
	    order: 10000,
	  },
	  {
	    key: 'utilization',
	    title: 'Utilization',
	    url: TypeformUrls.UTILIZATION,
	    order: 10000,
	  },
	  {
	    key: 'business_valuation',
	    title: 'Business Valuation',
	    url: TypeformUrls.BUSINESS_VALUATION,
	    order: 10000,
	  },
	  {
	    key: 'working_capital',
	    title: 'Working Capital',
	    url: TypeformUrls.WORKING_CAPITAL,
	    order: 10000,
	  }*/
	}];
	
	exports.default = KnowledgeBaseContent;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RANK_NAME_TO_NUMBER = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marketLeader = __webpack_require__(2630);
	
	var _marketLeader2 = _interopRequireDefault(_marketLeader);
	
	var _marketChallenger = __webpack_require__(2628);
	
	var _marketChallenger2 = _interopRequireDefault(_marketChallenger);
	
	var _marketClimber = __webpack_require__(2629);
	
	var _marketClimber2 = _interopRequireDefault(_marketClimber);
	
	var _marketWarrior = __webpack_require__(2632);
	
	var _marketWarrior2 = _interopRequireDefault(_marketWarrior);
	
	var _marketNewbie = __webpack_require__(2631);
	
	var _marketNewbie2 = _interopRequireDefault(_marketNewbie);
	
	var _styled = __webpack_require__(1205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Character art lives alongside the existing performance-feedback
	// images (`pf1.png`, `pf2.png`). Save the JPGs at these paths to
	// match the imports below.
	
	
	// Per-rank presentation. `celebrate` gates the confetti (only the
	// top three ranks). `sub` receives the team name so the copy reads
	// personal where it can.
	var RANK_META = {
	  1: {
	    word: 'Market Leader',
	    accent: '#D9A93E',
	    image: _marketLeader2.default,
	    celebrate: true,
	    sub: function sub() {
	      return "Congrats on finishing first! Let's keep it up!";
	    },
	    confetti: ['#D9A93E', '#1F9D6B', '#E0533A', '#3E8FD8']
	  },
	  2: {
	    word: 'Market Challenger',
	    accent: '#6E8CA8',
	    image: _marketChallenger2.default,
	    celebrate: true,
	    sub: function sub() {
	      return "Second place, and right on the leader's heels.";
	    },
	    confetti: ['#6E8CA8', '#A9B0B8', '#D9A93E']
	  },
	  3: {
	    word: 'Market Climber',
	    accent: '#2E9E8F',
	    image: _marketClimber2.default,
	    celebrate: true,
	    sub: function sub() {
	      return "Third place and still climbing. The summit is in sight.";
	    },
	    confetti: ['#2E9E8F', '#7FC8A0', '#D9A93E']
	  },
	  4: {
	    word: 'Market Warrior',
	    accent: '#B23A48',
	    image: _marketWarrior2.default,
	    celebrate: false,
	    sub: function sub() {
	      return 'Fourth place, earned the hard way. You fought for every point.';
	    },
	    confetti: []
	  },
	  5: {
	    word: 'Market Newbie',
	    accent: '#7FB2D9',
	    image: _marketNewbie2.default,
	    celebrate: false,
	    sub: function sub() {
	      return "Rookie numbers. Grow up fast, the next round won't wait for you.";
	    },
	    confetti: []
	  }
	};
	
	// Team names in this product are often stored as a bare number
	// ("4", "12"). Prefix with "Team " unless the upstream name already
	// starts with that word so we don't double-prefix things like
	// "Team Northstar".
	var formatTeamName = function formatTeamName(name) {
	  var str = (name == null ? '' : String(name)).trim();
	  if (!str) return 'Your team';
	  return (/^team\s/i.test(str) ? str : 'Team ' + str
	  );
	};
	
	// Backend `ranking` is a string ("Market Leader" etc.). Mapped to
	// the 1-5 tier the design works in.
	var RANK_NAME_TO_NUMBER = exports.RANK_NAME_TO_NUMBER = {
	  'market leader': 1,
	  'market challenger': 2,
	  'market climber': 3,
	  'market warrior': 4,
	  'market newbie': 5
	};
	
	// Scores are stored as fractions (0..1). Display as percentage with
	// two decimals to match how step5 / Final Scores format the same
	// underlying number.
	var fmtPct = function fmtPct(n) {
	  if (n == null || isNaN(Number(n))) return '—';
	  return (Number(n) * 100).toFixed(2) + '%';
	};
	
	// Confetti pieces. Generated once on construction so the random
	// timings don't reshuffle across re-renders (React 15 has no
	// useMemo — instance fields are the equivalent here).
	
	var Confetti = function (_PureComponent) {
	  _inherits(Confetti, _PureComponent);
	
	  function Confetti(props) {
	    _classCallCheck(this, Confetti);
	
	    var _this = _possibleConstructorReturn(this, (Confetti.__proto__ || Object.getPrototypeOf(Confetti)).call(this, props));
	
	    var colors = props.colors || [];
	    _this.pieces = [];
	    for (var k = 0; k < 12; k += 1) {
	      _this.pieces.push({
	        left: 4 + k * 8 + '%',
	        background: colors[k % Math.max(colors.length, 1)] || '#D9A93E',
	        animationDuration: (5 + Math.random() * 2.5).toFixed(2) + 's',
	        animationDelay: (Math.random() * 4).toFixed(2) + 's'
	      });
	    }
	    return _this;
	  }
	
	  _createClass(Confetti, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _styled.Styled.Confetti,
	        { 'aria-hidden': 'true' },
	        this.pieces.map(function (p, i) {
	          return _react2.default.createElement('i', { key: i, style: p });
	        })
	      );
	    }
	  }]);
	
	  return Confetti;
	}(_react.PureComponent);
	
	var MarketRanking = function (_PureComponent2) {
	  _inherits(MarketRanking, _PureComponent2);
	
	  function MarketRanking() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, MarketRanking);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = MarketRanking.__proto__ || Object.getPrototypeOf(MarketRanking)).call.apply(_ref, [this].concat(args))), _this2), _this2.setRootEl = function (el) {
	      _this2._rootEl = el;
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(MarketRanking, [{
	    key: 'componentDidMount',
	
	    // The parent PerformanceFeedback layout (Content + ContentWrapper)
	    // paints a #f5f6f7 gray background that shows through to the
	    // right of the 794px max-width and in the gap above the Pagination
	    // bar. For this page only we want a single white panel — so on
	    // mount, walk up the DOM, swap any matching gray ancestors to
	    // white, and restore the originals on unmount so other steps
	    // keep their gray.
	    value: function componentDidMount() {
	      if (typeof window === 'undefined' || !this._rootEl) return;
	      this._modifiedNodes = [];
	      var node = this._rootEl.parentElement;
	      var hops = 0;
	      while (node && hops < 6) {
	        var cs = window.getComputedStyle(node);
	        if (cs.backgroundColor === 'rgb(245, 246, 247)') {
	          this._modifiedNodes.push({
	            el: node,
	            originalBg: node.style.background
	          });
	          node.style.background = '#ffffff';
	        }
	        node = node.parentElement;
	        hops += 1;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._modifiedNodes) {
	        this._modifiedNodes.forEach(function (entry) {
	          entry.el.style.background = entry.originalBg;
	        });
	        this._modifiedNodes = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          teamName = _props.teamName,
	          rank = _props.rank,
	          totalTeams = _props.totalTeams,
	          score = _props.score,
	          changePct = _props.changePct,
	          cohort = _props.cohort;
	
	
	      var meta = RANK_META[rank];
	      if (!meta) {
	        // Defensive: don't crash on an unknown rank. The parent should
	        // gate on a recognized rank before rendering, but if something
	        // slips through, show a friendly placeholder instead of nothing.
	        return _react2.default.createElement(
	          _styled.Styled.Root,
	          { innerRef: this.setRootEl },
	          _react2.default.createElement(
	            _styled.Styled.Content,
	            null,
	            _react2.default.createElement(
	              _styled.Styled.Empty,
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Round results unavailable'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We couldn\'t determine your ranking for this round yet.'
	              )
	            )
	          )
	        );
	      }
	
	      var hasChange = changePct != null && !isNaN(Number(changePct));
	      var up = hasChange ? Number(changePct) >= 0 : true;
	      var displayTeamName = formatTeamName(teamName);
	
	      return _react2.default.createElement(
	        _styled.Styled.Root,
	        { innerRef: this.setRootEl, style: { '--mr-accent': meta.accent } },
	        meta.celebrate && _react2.default.createElement(Confetti, { colors: meta.confetti }),
	        _react2.default.createElement(
	          _styled.Styled.Content,
	          null,
	          _react2.default.createElement(
	            _styled.Styled.Eyebrow,
	            null,
	            'Round Performance'
	          ),
	          _react2.default.createElement(
	            _styled.Styled.Title,
	            null,
	            meta.word
	          ),
	          _react2.default.createElement(
	            _styled.Styled.PortraitWrap,
	            null,
	            _react2.default.createElement(
	              _styled.Styled.Portrait,
	              null,
	              _react2.default.createElement('img', { src: meta.image, alt: meta.word + ' mascot' })
	            )
	          ),
	          _react2.default.createElement(
	            _styled.Styled.Team,
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              displayTeamName
	            ),
	            ' \xB7 Rank ',
	            rank,
	            ' of ',
	            totalTeams
	          ),
	          _react2.default.createElement(
	            _styled.Styled.Sub,
	            null,
	            meta.sub(displayTeamName)
	          ),
	          _react2.default.createElement(
	            _styled.Styled.Card,
	            null,
	            _react2.default.createElement(
	              _styled.Styled.ScoreTop,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _styled.Styled.ScoreLabel,
	                  null,
	                  'Team score'
	                ),
	                _react2.default.createElement(
	                  _styled.Styled.ScoreVal,
	                  null,
	                  fmtPct(score)
	                )
	              ),
	              hasChange && _react2.default.createElement(
	                _styled.Styled.Pill,
	                { up: up },
	                up ? '▲' : '▼',
	                ' ',
	                Math.abs(Number(changePct)).toFixed(1),
	                '%'
	              )
	            ),
	            cohort && _react2.default.createElement(
	              _styled.Styled.Grid,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _styled.Styled.GridLabel,
	                  null,
	                  'Highest'
	                ),
	                _react2.default.createElement(
	                  _styled.Styled.GridVal,
	                  null,
	                  fmtPct(cohort.highest)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _styled.Styled.GridLabel,
	                  null,
	                  'Median'
	                ),
	                _react2.default.createElement(
	                  _styled.Styled.GridVal,
	                  null,
	                  fmtPct(cohort.median)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _styled.Styled.GridLabel,
	                  null,
	                  'Average'
	                ),
	                _react2.default.createElement(
	                  _styled.Styled.GridVal,
	                  null,
	                  fmtPct(cohort.average)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MarketRanking;
	}(_react.PureComponent);
	
	exports.default = MarketRanking;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Styled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  0%   { transform: translateY(-20vh) rotate(0deg); opacity: 0; }\n  10%  { opacity: 1; }\n  100% { transform: translateY(120vh) rotate(720deg); opacity: 0; }\n'], ['\n  0%   { transform: translateY(-20vh) rotate(0deg); opacity: 0; }\n  10%  { opacity: 1; }\n  100% { transform: translateY(120vh) rotate(720deg); opacity: 0; }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  --mr-accent: #5C91F5;\n  position: relative;\n  background: #ffffff;\n  min-height: 100%;\n  margin: -40px;\n  padding: 90px 24px 64px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow: hidden;\n  font-family: \'Inter\', \'Mukta Vaani\', -apple-system, sans-serif;\n'], ['\n  --mr-accent: #5C91F5;\n  position: relative;\n  background: #ffffff;\n  min-height: 100%;\n  margin: -40px;\n  padding: 90px 24px 64px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow: hidden;\n  font-family: \'Inter\', \'Mukta Vaani\', -apple-system, sans-serif;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  text-align: center;\n  z-index: 1;\n'], ['\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  text-align: center;\n  z-index: 1;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n'], ['\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin: 0 0 24px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 56px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  letter-spacing: -0.03em;\n  line-height: 1.05;\n'], ['\n  margin: 0 0 24px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 56px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  letter-spacing: -0.03em;\n  line-height: 1.05;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-size: 17px;\n  color: rgba(0, 27, 59, 0.85);\n\n  strong {\n    font-weight: 700;\n  }\n'], ['\n  margin: 0 0 4px;\n  font-size: 17px;\n  color: rgba(0, 27, 59, 0.85);\n\n  strong {\n    font-weight: 700;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  margin: 0 auto 36px;\n  max-width: 380px;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n'], ['\n  margin: 0 auto 36px;\n  max-width: 380px;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n'], ['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  position: relative;\n  z-index: 1;\n  width: 196px;\n  height: 196px;\n  border-radius: 50%;\n  background: #faf6ed;\n  border: 4px solid var(--mr-accent);\n  overflow: hidden;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center top;\n    display: block;\n  }\n'], ['\n  position: relative;\n  z-index: 1;\n  width: 196px;\n  height: 196px;\n  border-radius: 50%;\n  background: #faf6ed;\n  border: 4px solid var(--mr-accent);\n  overflow: hidden;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center top;\n    display: block;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 12px;\n  padding: 17px 20px;\n  margin: 0 auto;\n  max-width: 392px;\n  text-align: left;\n  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.05);\n'], ['\n  background: #ffffff;\n  border: 1px solid rgba(0, 27, 59, 0.08);\n  border-radius: 12px;\n  padding: 17px 20px;\n  margin: 0 auto;\n  max-width: 392px;\n  text-align: left;\n  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.05);\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 17px;\n  margin-bottom: 17px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.08);\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 17px;\n  margin-bottom: 17px;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.08);\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin-bottom: 4px;\n'], ['\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin-bottom: 4px;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  display: block;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 28px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  letter-spacing: -0.02em;\n  line-height: 1;\n'], ['\n  display: block;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 28px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  letter-spacing: -0.02em;\n  line-height: 1;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  ', '\n'], ['\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  ', '\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n    background: #E8F5EE;\n    color: #2E7D4F;\n  '], ['\n    background: #E8F5EE;\n    color: #2E7D4F;\n  ']),
	    _templateObject16 = _taggedTemplateLiteral(['\n    background: #FBECEB;\n    color: #B5413B;\n  '], ['\n    background: #FBECEB;\n    color: #B5413B;\n  ']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 11px;\n  text-align: center;\n'], ['\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 11px;\n  text-align: center;\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  display: block;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  display: block;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  padding: 64px 24px;\n  text-align: center;\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  color: rgba(0, 27, 59, 0.65);\n\n  h2 {\n    font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    margin: 0 0 8px;\n  }\n'], ['\n  padding: 64px 24px;\n  text-align: center;\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  color: rgba(0, 27, 59, 0.65);\n\n  h2 {\n    font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    margin: 0 0 8px;\n  }\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 0;\n\n  i {\n    position: absolute;\n    top: -10vh;\n    width: 10px;\n    height: 16px;\n    border-radius: 2px;\n    animation-name: ', ';\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    display: none;\n  }\n'], ['\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 0;\n\n  i {\n    position: absolute;\n    top: -10vh;\n    width: 10px;\n    height: 16px;\n    border-radius: 2px;\n    animation-name: ', ';\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    display: none;\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var fall = (0, _styledComponents.keyframes)(_templateObject);
	
	var Styled = {};
	
	// Outer section. The accent color is set inline via the --mr-accent
	// CSS variable so the title and portrait ring swap per rank from a
	// single source of truth. Negative margins cancel the parent
	// PerformanceFeedback Wrapper's 40px padding so the white background
	// covers the whole panel rather than floating inside a gray border.
	Styled.Root = _styledComponents2.default.section(_templateObject2);
	
	Styled.Content = _styledComponents2.default.div(_templateObject3);
	
	Styled.Eyebrow = _styledComponents2.default.p(_templateObject4);
	
	Styled.Title = _styledComponents2.default.h1(_templateObject5);
	
	Styled.Team = _styledComponents2.default.p(_templateObject6);
	
	Styled.Sub = _styledComponents2.default.p(_templateObject7);
	
	Styled.PortraitWrap = _styledComponents2.default.div(_templateObject8);
	
	// 30% smaller than the previous 280px portrait (per design tweak).
	Styled.Portrait = _styledComponents2.default.div(_templateObject9);
	
	// Scores block sized ~30% smaller than the original (560 → 392px
	// width, internal paddings and font sizes scaled to ~0.7×).
	Styled.Card = _styledComponents2.default.div(_templateObject10);
	
	Styled.ScoreTop = _styledComponents2.default.div(_templateObject11);
	
	Styled.ScoreLabel = _styledComponents2.default.span(_templateObject12);
	
	Styled.ScoreVal = _styledComponents2.default.span(_templateObject13);
	
	Styled.Pill = _styledComponents2.default.span(_templateObject14, function (p) {
	  return p.up ? (0, _styledComponents.css)(_templateObject15) : (0, _styledComponents.css)(_templateObject16);
	});
	
	Styled.Grid = _styledComponents2.default.div(_templateObject17);
	
	Styled.GridLabel = _styledComponents2.default.span(_templateObject12);
	
	Styled.GridVal = _styledComponents2.default.span(_templateObject18);
	
	Styled.Empty = _styledComponents2.default.div(_templateObject19);
	
	// Confetti container. 12 falling pieces, randomized timings — only
	// rendered when celebrate=true on the rank meta. Respects
	// prefers-reduced-motion at the CSS level: a user with that pref
	// set never sees the animation, even if the JSX is mounted.
	Styled.Confetti = _styledComponents2.default.div(_templateObject20, fall);
	
	exports.Styled = Styled;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _roundLink = __webpack_require__(596);
	
	var _roundLink2 = _interopRequireDefault(_roundLink);
	
	var _reactRouter = __webpack_require__(24);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _arrow_drop_down = __webpack_require__(1839);
	
	var _arrow_drop_down2 = _interopRequireDefault(_arrow_drop_down);
	
	var _leftMenu = __webpack_require__(2593);
	
	var _leftMenu2 = _interopRequireDefault(_leftMenu);
	
	var _leftMenuActive = __webpack_require__(2603);
	
	var _leftMenuActive2 = _interopRequireDefault(_leftMenuActive);
	
	var _leftMenu3 = __webpack_require__(2595);
	
	var _leftMenu4 = _interopRequireDefault(_leftMenu3);
	
	var _leftMenuActive3 = __webpack_require__(2605);
	
	var _leftMenuActive4 = _interopRequireDefault(_leftMenuActive3);
	
	var _leftMenu5 = __webpack_require__(2596);
	
	var _leftMenu6 = _interopRequireDefault(_leftMenu5);
	
	var _leftMenuActive5 = __webpack_require__(2606);
	
	var _leftMenuActive6 = _interopRequireDefault(_leftMenuActive5);
	
	var _leftMenu7 = __webpack_require__(2597);
	
	var _leftMenu8 = _interopRequireDefault(_leftMenu7);
	
	var _leftMenuActive7 = __webpack_require__(2607);
	
	var _leftMenuActive8 = _interopRequireDefault(_leftMenuActive7);
	
	var _leftMenu9 = __webpack_require__(2598);
	
	var _leftMenu10 = _interopRequireDefault(_leftMenu9);
	
	var _leftMenuActive9 = __webpack_require__(2608);
	
	var _leftMenuActive10 = _interopRequireDefault(_leftMenuActive9);
	
	var _leftMenu11 = __webpack_require__(2599);
	
	var _leftMenu12 = _interopRequireDefault(_leftMenu11);
	
	var _leftMenuActive11 = __webpack_require__(2609);
	
	var _leftMenuActive12 = _interopRequireDefault(_leftMenuActive11);
	
	var _leftMenu13 = __webpack_require__(2600);
	
	var _leftMenu14 = _interopRequireDefault(_leftMenu13);
	
	var _leftMenuActive13 = __webpack_require__(2610);
	
	var _leftMenuActive14 = _interopRequireDefault(_leftMenuActive13);
	
	var _leftMenu15 = __webpack_require__(2601);
	
	var _leftMenu16 = _interopRequireDefault(_leftMenu15);
	
	var _leftMenuActive15 = __webpack_require__(2611);
	
	var _leftMenuActive16 = _interopRequireDefault(_leftMenuActive15);
	
	var _leftMenu17 = __webpack_require__(2602);
	
	var _leftMenu18 = _interopRequireDefault(_leftMenu17);
	
	var _leftMenuActive17 = __webpack_require__(2612);
	
	var _leftMenuActive18 = _interopRequireDefault(_leftMenuActive17);
	
	var _leftMenu19 = __webpack_require__(2594);
	
	var _leftMenu20 = _interopRequireDefault(_leftMenu19);
	
	var _leftMenuActive19 = __webpack_require__(2604);
	
	var _leftMenuActive20 = _interopRequireDefault(_leftMenuActive19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLink = function renderLink(_ref, isMenuExpanded) {
	  var to = _ref.to,
	      title = _ref.title,
	      round = _ref.round,
	      active = _ref.active,
	      level = _ref.level,
	      onClick = _ref.onClick,
	      alignCenter = _ref.alignCenter,
	      params = _ref.params,
	      key = _ref.key;
	
	  if (round || params) return _react2.default.createElement(
	    _roundLink2.default,
	    {
	      key: key,
	      to: to,
	      round: round,
	      onClick: onClick,
	      className: (0, _classnames2.default)({
	        linksWrapper__mainLinkWrapper__link: level === 1,
	        linksWrapper__subLinkWrapper__link: level > 1,
	        linksWrapper__mainLinkWrapper_active: active && level === 1,
	        linksWrapper__subLinkWrapper_active: active && level > 1,
	        linksWrapper__subLinkWrapper_centered: alignCenter
	      }),
	      params: params
	    },
	    menuIcon(title, isMenuExpanded),
	    isMenuExpanded ? title : ''
	  );else return _react2.default.createElement(
	    _reactRouter.Link,
	    {
	      key: key,
	      to: to,
	      onClick: onClick,
	      className: (0, _classnames2.default)({
	        linksWrapper__mainLinkWrapper__link: level === 1,
	        linksWrapper__subLinkWrapper__link: level > 1,
	        linksWrapper__mainLinkWrapper_active: active && level === 1,
	        linksWrapper__subLinkWrapper_active: active && level > 1
	      })
	    },
	    menuIcon(title, isMenuExpanded),
	    isMenuExpanded ? title : ''
	  );
	};
	
	var menuIcon = function menuIcon(title, isMenuExpanded) {
	  if (_Auth2.default.isAnyInstructor()) {
	    if (title === 'Dashboard') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu2.default, alt: "dashboard icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive2.default, alt: "dashboard icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Welcome') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu4.default, alt: "welcome icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive4.default, alt: "welcome icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Game Admin') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu18.default, alt: "game setup icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive18.default, alt: "game setup icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Monitoring') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu20.default, alt: "monitoring icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive20.default, alt: "monitoring icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Results') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu12.default, alt: "results icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive12.default, alt: "results icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    return null;
	  } else {
	    if (title === 'Dashboard') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu2.default, alt: "dashboard icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive2.default, alt: "dashboard icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Welcome') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu4.default, alt: "welcome icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive4.default, alt: "welcome icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Research') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu6.default, alt: "research icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive6.default, alt: "research icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Goals & Targets') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu8.default, alt: "goals icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive8.default, alt: "goals icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Decisions') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu10.default, alt: "decisions icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive10.default, alt: "decisions icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Results') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu12.default, alt: "results icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive12.default, alt: "results icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Trivia') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu14.default, alt: "trivia icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive14.default, alt: "trivia icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    if (title === 'Peer Review') {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("img", { src: _leftMenu16.default, alt: "peer-review icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_default', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) }),
	        _react2.default.createElement("img", { src: _leftMenuActive16.default, alt: "peer-review icon", className: (0, _classnames2.default)('linksWrapper__symbol linksWrapper__symbol_active', {
	            linksWrapper__symbol__collapsed: !isMenuExpanded
	          }) })
	      );
	    }
	
	    return null;
	  }
	};
	
	var LinkWithSubLink = function (_PureComponent) {
	  _inherits(LinkWithSubLink, _PureComponent);
	
	  function LinkWithSubLink(props) {
	    _classCallCheck(this, LinkWithSubLink);
	
	    var _this = _possibleConstructorReturn(this, (LinkWithSubLink.__proto__ || Object.getPrototypeOf(LinkWithSubLink)).call(this, props));
	
	    _this.activateSubmenu = function () {
	      if (_this.props.link.active && _this.props.isMenuExpanded) {
	        requestAnimationFrame(function () {
	          var submenuHeight = _this.submenu.scrollHeight;
	          _this.submenu.style.height = submenuHeight + "px";
	          _this.submenu.style.opacity = 100;
	        });
	      } else if (_this.props.link.active) {
	        requestAnimationFrame(function () {
	          var submenuHeight = Number(_this.submenu.style.height.replace('px', ''));
	          if (submenuHeight > 0) {
	            _this.submenu.style.height = '0px';
	            _this.submenu.style.opacity = 0;
	          }
	        });
	      }
	    };
	
	    _this.clickOutside = function (event) {
	      if (!_this.props.isMenuExpanded && _this.submenu && !_this.submenu.contains(event.target)) {
	        requestAnimationFrame(function () {
	          var submenuHeight = Number(_this.submenu.style.height.replace('px', ''));
	          if (submenuHeight > 0) {
	            _this.submenu.style.height = '0px';
	            _this.submenu.style.opacity = 0;
	          }
	        });
	      }
	    };
	
	    _this.setRef = function (submenu) {
	      _this.submenu = submenu;
	    };
	
	    _this.submenuClick = function () {
	      if (_this.props.link.active && _this.props.isMenuExpanded) {
	        requestAnimationFrame(function () {
	          var submenuHeight = _this.submenu.scrollHeight;
	          _this.submenu.style.height = submenuHeight + "px";
	          _this.submenu.style.opacity = 100;
	        });
	      } else {
	        requestAnimationFrame(function () {
	          _this.submenu.style.height = '0px';
	          _this.submenu.style.opacity = 0;
	        });
	      }
	    };
	
	    _this.collapseSubmenu = function (linkId) {
	      if (_this.props.isMenuExpanded) {
	        if (_this.props.link.active) {
	          requestAnimationFrame(function () {
	            var submenuHeight = _this.submenu.scrollHeight;
	            _this.submenu.style.height = submenuHeight + "px";
	            _this.submenu.style.opacity = 100;
	          });
	        } else {
	          requestAnimationFrame(function () {
	            _this.submenu.style.height = '0px';
	            _this.submenu.style.opacity = 0;
	          });
	        }
	      } else if (linkId === _this.props.link.id) {
	        requestAnimationFrame(function () {
	          var submenuHeight = _this.submenu.scrollHeight;
	          _this.submenu.style.height = submenuHeight + "px";
	          _this.submenu.style.opacity = 100;
	        });
	      }
	    };
	
	    _this.toggle = function (callback) {
	      return function () {
	        callback();
	
	        var submenuHeight = _this.submenu.scrollHeight;
	        var currentHeight = Number(_this.submenu.style.height.replace('px', '').trim());
	
	        if (currentHeight > 0) {
	          requestAnimationFrame(function () {
	            _this.submenu.style.height = '0px';
	            _this.submenu.style.opacity = 0;
	          });
	        } else {
	          requestAnimationFrame(function () {
	            _this.submenu.style.height = submenuHeight + "px";
	            _this.submenu.style.opacity = 100;
	          });
	        }
	      };
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(LinkWithSubLink, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.eventemitter.on('collapse-submenu', this.collapseSubmenu);
	      this.eventemitter.on('submenu-click', this.submenuClick);
	      this.eventemitter.on('activate-submenu', this.activateSubmenu);
	      document.addEventListener('mousedown', this.clickOutside);
	
	      if (this.props.link.active && this.props.isMenuExpanded) {
	        requestAnimationFrame(function () {
	          var submenuHeight = _this2.submenu.scrollHeight;
	          _this2.submenu.style.height = submenuHeight + "px";
	          _this2.submenu.style.opacity = 100;
	        });
	      }
	    }
	
	    // Sync submenu open/closed state when link.active changes as a
	    // result of external navigation (e.g., the user clicks a link
	    // elsewhere in the app that routes into this section). Without
	    // this, LinksWrapper's setState updates active in the render tree
	    // but the imperatively-managed submenu height stays stuck at its
	    // previous value.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      if (!this.submenu) return;
	      if (!this.props.isMenuExpanded) return;
	      if (prevProps.link.active === this.props.link.active) return;
	
	      if (this.props.link.active) {
	        requestAnimationFrame(function () {
	          var submenuHeight = _this3.submenu.scrollHeight;
	          _this3.submenu.style.height = submenuHeight + "px";
	          _this3.submenu.style.opacity = 100;
	        });
	      } else {
	        requestAnimationFrame(function () {
	          _this3.submenu.style.height = '0px';
	          _this3.submenu.style.opacity = 0;
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off('collapse-submenu', this.collapseSubmenu);
	      this.eventemitter.off('submenu-click', this.submenuClick);
	      this.eventemitter.off('activate-submenu', this.activateSubmenu);
	      document.removeEventListener('mousedown', this.clickOutside);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          link = _props.link,
	          isMenuExpanded = _props.isMenuExpanded;
	
	      var subLinksActive = link.links.some(function (subLink) {
	        return subLink.active;
	      });
	
	      var shouldShowMainLinkActive = link.expandable ? link.active && !subLinksActive : isMenuExpanded ? link.active && !subLinksActive : link.active;
	
	      var isNavigableLink = link.expandable && !link.to.includes('/expand/');
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "linksWrapper__mainLinkWrapper", style: { position: 'relative' } },
	          isNavigableLink ? [renderLink(Object.assign({}, link, {
	            active: shouldShowMainLinkActive,
	            onClick: this.toggle(link.onClick),
	            key: "link"
	          }), isMenuExpanded), isMenuExpanded && _react2.default.createElement(
	            "svg",
	            {
	              key: "arrow",
	              className: (0, _classnames2.default)("linksWrapper__icon", {
	                linksWrapper__iconActive: link.active
	              }),
	              onClick: this.toggle(link.onClick)
	            },
	            _react2.default.createElement("use", { xlinkHref: _arrow_drop_down2.default + "#arrow" })
	          )].filter(Boolean) : _react2.default.createElement(
	            "button",
	            {
	              className: (0, _classnames2.default)("linksWrapper__mainLinkWrapper__link", {
	                linksWrapper__mainLinkWrapper_active: shouldShowMainLinkActive
	              }),
	              onClick: this.toggle(link.onClick)
	            },
	            menuIcon(link.title, isMenuExpanded),
	            isMenuExpanded ? link.title : '',
	            _react2.default.createElement(
	              "svg",
	              {
	                className: (0, _classnames2.default)("linksWrapper__icon", {
	                  linksWrapper__iconActive: link.active,
	                  linksWrapper__iconHidden: !isMenuExpanded
	                })
	              },
	              _react2.default.createElement("use", { xlinkHref: _arrow_drop_down2.default + "#arrow" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { ref: this.setRef, className: (0, _classnames2.default)('linksWrapper__subLinkWrapper', {
	              linksWrapper__subLinkWrapper__collapsed: !isMenuExpanded
	            }) },
	          link.links.map(function (link) {
	            return _react2.default.createElement(
	              "span",
	              { key: link.id },
	              renderLink(link, true)
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return LinkWithSubLink;
	}(_react.PureComponent);
	
	var LinksWrapper = function (_PureComponent2) {
	  _inherits(LinksWrapper, _PureComponent2);
	
	  function LinksWrapper(props) {
	    _classCallCheck(this, LinksWrapper);
	
	    var _this4 = _possibleConstructorReturn(this, (LinksWrapper.__proto__ || Object.getPrototypeOf(LinksWrapper)).call(this, props));
	
	    _this4.isMainLinkActive = function (link, pathname) {
	      var _this4$props = _this4.props,
	          currentRound = _this4$props.currentRound,
	          roundInUrl = _this4$props.roundInUrl;
	
	      var roundNumber = roundInUrl || currentRound;
	      var isInstructor = _Auth2.default.isAnyInstructor();
	      var compareRound = pathname.startsWith('/analysis/team-reports') && !isInstructor ? true : false;
	      var alternatives = link.alternatives || [];
	
	      if (link.expandable && link.innerLinks) {
	        var isOnMainPage = [].concat(_toConsumableArray(alternatives), [link.to]).some(function (path) {
	          return pathname === path;
	        });
	        var isOnChildPage = link.innerLinks.some(function (subLink) {
	          return [].concat(_toConsumableArray(subLink.alternatives || []), [subLink.to]).some(function (path) {
	            return pathname.startsWith(path);
	          });
	        });
	
	        if (compareRound) {
	          return isOnMainPage && link.round === roundNumber || isOnChildPage && link.innerLinks.some(function (subLink) {
	            return subLink.round === roundNumber;
	          });
	        }
	
	        return isOnMainPage || isOnChildPage;
	      }
	
	      if (compareRound) {
	        return !!link.innerLinks ? link.innerLinks.some(function (subLink) {
	          return [].concat(_toConsumableArray(subLink.alternatives || []), [subLink.to]).some(function (path) {
	            return pathname.startsWith(path);
	          }) && subLink.round === roundNumber;
	        }) : [].concat(_toConsumableArray(alternatives), [link.to]).some(function (path) {
	          return pathname.startsWith(path);
	        }) && link.round === roundNumber;
	      }
	
	      // Section is active when on the parent's own URL OR any of its
	      // children. Previously we only checked children, which meant a
	      // page like /instructor/welcome (the section's own landing)
	      // didn't count as "active" for the Welcome parent, so the
	      // submenu collapsed whenever navigation landed there (notably
	      // after Onboarding's redirect-when-already-onboarded bounces
	      // back to /instructor/welcome). Mirrors the expandable branch
	      // above, which already treats the main page as active.
	      return !!link.innerLinks ? [].concat(_toConsumableArray(alternatives), [link.to]).some(function (path) {
	        return pathname.startsWith(path);
	      }) || link.innerLinks.some(function (subLink) {
	        return [].concat(_toConsumableArray(subLink.alternatives || []), [subLink.to]).some(function (path) {
	          return pathname.startsWith(path);
	        });
	      }) : [].concat(_toConsumableArray(alternatives), [link.to]).some(function (path) {
	        return pathname.startsWith(path);
	      });
	    };
	
	    _this4.isSubLinkActive = function (subLink, pathname) {
	      var _this4$props2 = _this4.props,
	          currentRound = _this4$props2.currentRound,
	          roundInUrl = _this4$props2.roundInUrl;
	
	      var roundNumber = roundInUrl || currentRound;
	      var isInstructor = _Auth2.default.isAnyInstructor();
	      var compareRound = pathname.startsWith('/analysis/team-reports') && !isInstructor ? true : false;
	      var alternatives = subLink.alternatives || [];
	
	      return compareRound ? [].concat(_toConsumableArray(alternatives), [subLink.to]).some(function (path) {
	        return pathname.startsWith(path);
	      }) && subLink.round === roundNumber : [].concat(_toConsumableArray(alternatives), [subLink.to]).some(function (path) {
	        return pathname.startsWith(path);
	      });
	    };
	
	    _this4.initiateLinks = function () {
	      var _this4$props3 = _this4.props,
	          rawLinks = _this4$props3.links,
	          location = _this4$props3.location;
	
	      var filteredLinks = rawLinks.filter(function (link) {
	        return link.hide !== true;
	      });
	
	      return filteredLinks.map(function (link, index) {
	        return Object.assign({
	          id: "main-link-" + link.to + "_" + index,
	          to: link.to,
	          round: link.round,
	          title: link.title,
	          active: _this4.isMainLinkActive(link, location.pathname),
	          alternatives: link.alternatives,
	          expandable: link.expandable,
	          level: 1
	        }, !!link.innerLinks ? {
	          links: link.innerLinks.map(function (subLink, subIndex) {
	            return {
	              id: "sub-link-" + index + "-" + subIndex,
	              to: subLink.to,
	              round: subLink.round,
	              title: subLink.title,
	              active: _this4.isSubLinkActive(subLink, location.pathname),
	              alternatives: subLink.alternatives,
	              level: 2,
	              alignCenter: subLink.alignCenter,
	              params: subLink.params,
	              onClick: function onClick() {
	                return _this4.setActive(index, subIndex, "main-link-" + link.to + "_" + index, true, "sub-link-" + index + "-" + subIndex);
	              }
	            };
	          })
	        } : {}, {
	          onClick: function onClick() {
	            return _this4.setActive(index, -1, "main-link-" + link.to + "_" + index, false, "main-link-" + link.to + "_" + index);
	          }
	        });
	      });
	    };
	
	    _this4.setActive = function (index, subIndex, lastClickedId, clickFromSubmenu, linkId) {
	      _this4.setState(function (prevState) {
	        return {
	          lastClickedId: lastClickedId,
	          links: prevState.links.map(function (link, i) {
	            return Object.assign({}, link, {
	              active: !!link.links ? prevState.lastClickedId === lastClickedId && link.id === lastClickedId && subIndex === -1 ? !link.active : subIndex === -1 && index === i || link.links.some(function (subLink, j) {
	                return i === index && j === subIndex;
	              }) : subIndex === -1 && index === i
	            }, !!link.links ? {
	              links: link.links.map(function (subLink, j) {
	                return Object.assign({}, subLink, {
	                  active: i === index && j === subIndex
	                });
	              })
	            } : {});
	          })
	        };
	      }, function () {
	        if (clickFromSubmenu) {
	          _this4.eventemitter.trigger('submenu-click');
	        } else {
	          _this4.eventemitter.trigger('collapse-submenu', [linkId]);
	        }
	      });
	    };
	
	    var links = _this4.initiateLinks();
	    var activeLink = links.find(function (i) {
	      return !!i.active;
	    });
	
	    _this4.state = {
	      links: links,
	      lastClickedId: activeLink ? activeLink.id : null
	    };
	    _this4.eventemitter = _eventEmitter2.default.getInstance();
	    return _this4;
	  }
	
	  _createClass(LinksWrapper, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _props2 = this.props,
	          position = _props2.position,
	          location = _props2.location;
	
	      if (position !== prevProps.position || location.pathname !== prevProps.location.pathname || JSON.stringify(this.props.links) !== JSON.stringify(prevProps.links)) {
	        var links = this.initiateLinks();
	        var activeLink = links.find(function (i) {
	          return !!i.active;
	        });
	
	        this.setState({
	          links: links,
	          lastClickedId: activeLink ? activeLink.id : null
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var links = this.state.links;
	      var isMenuExpanded = this.props.isMenuExpanded;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "linksWrapper" },
	        links.map(function (link) {
	          return !!link.links ? _react2.default.createElement(LinkWithSubLink, {
	            key: link.id,
	            link: link,
	            isMenuExpanded: isMenuExpanded
	          }) : _react2.default.createElement(
	            "div",
	            {
	              key: link.id,
	              className: "linksWrapper__mainLinkWrapper"
	            },
	            renderLink(link, isMenuExpanded)
	          );
	        })
	      );
	    }
	  }]);
	
	  return LinksWrapper;
	}(_react.PureComponent);
	
	LinksWrapper.defaultProps = {
	  position: ""
	};
	
	exports.default = LinksWrapper;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Location = __webpack_require__(23);
	
	var _chevronDown = __webpack_require__(1842);
	
	var _chevronDown2 = _interopRequireDefault(_chevronDown);
	
	var _spinner = __webpack_require__(2672);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoundSwitcherList = function (_PureComponent) {
	  _inherits(RoundSwitcherList, _PureComponent);
	
	  function RoundSwitcherList(props) {
	    _classCallCheck(this, RoundSwitcherList);
	
	    var _this = _possibleConstructorReturn(this, (RoundSwitcherList.__proto__ || Object.getPrototypeOf(RoundSwitcherList)).call(this, props));
	
	    _this.setContentRef = function (content) {
	      return _this.contentRef = content;
	    };
	
	    _this.setHeaderRef = function (content) {
	      return _this.headerRef = content;
	    };
	
	    _this.isInstructor = function () {
	      return _Auth2.default.isAnyInstructor();
	    };
	
	    _this.handleClickOutside = function (e) {
	      var clickedHeader = false;
	      if (_this.headerRef && _this.headerRef.contains(e.target)) {
	        clickedHeader = true;
	      }
	
	      var clickedContent = false;
	      if (_this.contentRef && _this.contentRef.contains(e.target)) {
	        clickedContent = true;
	      }
	
	      if (!clickedContent && !clickedHeader) {
	        _this.setState({ showMenu: false });
	      }
	    };
	
	    _this.changeRound = function (round, current) {
	      var location = _this.props.location;
	      var loading = _this.state.loading;
	      var pathname = location.pathname;
	
	
	      if (loading === true) {
	        return;
	      }
	
	      if (Number(round) === Number(current)) {
	        _this.setState({
	          showMenu: false
	        });
	        return;
	      }
	
	      var query = _this.isInstructor() ? _this.buildQuery(Object.assign({}, location.query, {
	        round: round + ""
	      })) : "round=" + round;
	
	      _this.goToPathname(pathname, query);
	    };
	
	    _this.goToPathname = function (pathname, query) {
	      var url = pathname;
	      if (url.indexOf('/onboarding') === 0) {
	        url = '/onboarding';
	      } else if (url.indexOf('/performance-feedback') === 0) {
	        url = '/performance-feedback';
	      } else if (url.indexOf('/analysis/team-reports') === 0) {
	        url = '/analysis/team-reports';
	      } else if (url.indexOf('/round-trivia') === 0) {
	        url = '/round-trivia';
	      }
	
	      (0, _Location.changeLocation)(url + "?" + query);
	
	      _this.setState({
	        showMenu: false
	      }, function () {
	        window.location.reload();
	      });
	    };
	
	    _this.buildQuery = function (data) {
	      var result = [];
	      Object.keys(data).forEach(function (key) {
	        result.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
	      });
	
	      return result.join("&");
	    };
	
	    _this.toggleMenu = function () {
	      if (_this.state.loading === true) {
	        return;
	      }
	
	      _this.setState(function (prevState) {
	        return { showMenu: !prevState.showMenu };
	      });
	    };
	
	    _this.state = {
	      showMenu: false,
	      loading: false
	    };
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(RoundSwitcherList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (window) {
	        document.addEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (window) {
	        document.removeEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          location = _props.location,
	          rounds = _props.rounds,
	          round = _props.round,
	          isMenuExpanded = _props.isMenuExpanded,
	          rest = _objectWithoutProperties(_props, ["currentRound", "location", "rounds", "round", "isMenuExpanded"]);
	
	      var _state = this.state,
	          showMenu = _state.showMenu,
	          loading = _state.loading;
	
	      // Instructors (real or impersonating a student) see every round
	      // sorted ascending — they need to jump to unstarted rounds for
	      // round setup, previewing content, etc. Students see only rounds
	      // whose start time has passed (past rounds + the currently-live
	      // one).
	
	      var years = this.isInstructor() ? (0, _orderBy2.default)(rounds, ["number"], ["asc"]) : (0, _orderBy2.default)(rounds, ["number"], ["asc"]).filter(function (i) {
	        return i.is_started === true;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        Object.assign({ className: (0, _classnames2.default)('round-switcher', {
	            'round-switcher__hidden': !isMenuExpanded
	          }) }, rest),
	        _react2.default.createElement(
	          "div",
	          { className: "dropdown" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "dropdown__header",
	              onClick: this.toggleMenu,
	              ref: this.setHeaderRef
	            },
	            "Year ",
	            round,
	            " ",
	            !loading && _react2.default.createElement("img", {
	              src: _chevronDown2.default,
	              className: "dropdown__icon",
	              alt: "Dropdown"
	            }),
	            loading && _react2.default.createElement("img", {
	              src: _spinner2.default,
	              className: "dropdown__icon",
	              alt: "Dropdown"
	            })
	          ),
	          showMenu && _react2.default.createElement(
	            "div",
	            { className: "dropdown__content", ref: this.setContentRef },
	            years.map(function (year) {
	              return _react2.default.createElement(
	                "div",
	                {
	                  key: year.id,
	                  onClick: function onClick() {
	                    return _this2.changeRound(year.number, round);
	                  }
	                },
	                "Year ",
	                year.number
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RoundSwitcherList;
	}(_react.PureComponent);
	
	exports.default = RoundSwitcherList;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Location = __webpack_require__(23);
	
	var _lodash = __webpack_require__(21);
	
	var _recompose = __webpack_require__(55);
	
	var _reactRouter = __webpack_require__(24);
	
	var _utils = __webpack_require__(18);
	
	var _decisionsSummary = __webpack_require__(599);
	
	var _decisionsSummary2 = _interopRequireDefault(_decisionsSummary);
	
	var _countdown = __webpack_require__(1165);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _RoundSwitcherList = __webpack_require__(1207);
	
	var _RoundSwitcherList2 = _interopRequireDefault(_RoundSwitcherList);
	
	var _LinksWrapper = __webpack_require__(1206);
	
	var _LinksWrapper2 = _interopRequireDefault(_LinksWrapper);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Round1Checklist = __webpack_require__(585);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var InstructorLeftBar = (0, _recompose.pure)(function (props) {
	  var location = props.location,
	      instructorRounds = props.instructorRounds,
	      currentRound = props.currentRound,
	      roundInUrl = props.roundInUrl,
	      rounds = props.rounds,
	      isMenuExpanded = props.isMenuExpanded,
	      isPerformanceFeedbackVisible = props.isPerformanceFeedbackVisible;
	
	  var round = (0, _lodash.isNil)(roundInUrl) ? currentRound : roundInUrl;
	  var temporaryUser = _Auth2.default.getTemporaryUser();
	  // Hide the Onboarding entry once the instructor has finished the
	  // guided flow. `user.onboard !== 0` mirrors the InstructorOnboarding
	  // container's completion check ([containers/onboarding.js]); if
	  // still 0 the sidebar entry remains so the instructor can re-enter
	  // mid-flow.
	  var authUser = _Auth2.default.getUser();
	  var isInstructorOnboarded = !!(authUser && authUser.onboard !== 0);
	
	  var welcomeInnerLinks = [{
	    to: '/instructor/onboarding',
	    title: 'Onboarding',
	    round: round,
	    hide: isInstructorOnboarded
	  }, {
	    to: '/analysis/bcase/executive-summary',
	    title: 'The Business Case',
	    round: round
	  }, {
	    to: '/ceo/analysis/market',
	    title: 'Customer Analysis',
	    round: round
	  }, {
	    to: '/instructor/goals-and-targets',
	    title: 'Goals & Targets'
	  }].filter(function (link) {
	    return link.hide !== true;
	  });
	
	  var activeRound = rounds.find(function (item) {
	    return item.number === round;
	  });
	  var isActiveRoundFinished = activeRound ? activeRound.is_finished : false;
	  // Performance Feedback / Final Scores visibility is scoped to the
	  // current game's rounds (rounds prop is loaded per game). Hide both
	  // when the game has no rounds; additionally hide Performance
	  // Feedback until at least one round has finished.
	  var hasAnyRound = Array.isArray(rounds) && rounds.length > 0;
	  var hasFinishedRound = Array.isArray(rounds) && rounds.some(function (r) {
	    return r.is_finished === true;
	  });
	  var canShowPerformanceFeedback = isPerformanceFeedbackVisible && hasFinishedRound;
	  var canShowFinalScores = hasAnyRound;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)('left__bar', {
	        left__bar__collapsed: !isMenuExpanded
	      }) },
	    _react2.default.createElement(
	      "div",
	      { className: "left__bar__div" },
	      _react2.default.createElement(_RoundSwitcherList2.default, {
	        round: round,
	        currentRound: currentRound,
	        rounds: instructorRounds,
	        location: location,
	        isMenuExpanded: isMenuExpanded
	      }),
	      _react2.default.createElement(_countdown2.default, {
	        currentRound: currentRound,
	        rounds: instructorRounds,
	        roundInUrl: roundInUrl,
	        isMenuExpanded: isMenuExpanded
	      }),
	      _react2.default.createElement(_LinksWrapper2.default, {
	        isMenuExpanded: isMenuExpanded,
	        location: location,
	        links: [{
	          to: "/instructor/dashboard",
	          hide: !!temporaryUser,
	          round: round,
	          title: "Dashboard"
	        }, {
	          to: '/instructor/welcome',
	          title: 'Welcome',
	          hide: !!temporaryUser,
	          round: round,
	          innerLinks: welcomeInnerLinks
	        }, {
	          to: '/instructor/game-setup',
	          title: 'Game Admin',
	          hide: !!temporaryUser,
	          round: round,
	          innerLinks: [{
	            to: '/instructor/teams-roles',
	            title: 'Teams & Roles'
	          }, {
	            to: '/instructor/rounds',
	            title: 'Rounds',
	            round: round
	          }, {
	            to: '/instructor/peer-review',
	            title: 'Team Evaluation'
	          }, {
	            to: '/instructor/grading',
	            title: 'Grading',
	            round: round
	          }]
	        }, {
	          to: '/instructor/monitoring',
	          title: 'Monitoring',
	          hide: !temporaryUser,
	          round: round,
	          innerLinks: [{
	            to: "/decisions/ceo",
	            round: round,
	            title: "CEO Decisions"
	          }, {
	            to: "/decisions/product-development",
	            round: round,
	            title: "Product Management"
	          }, {
	            to: "/decisions/product-marketing",
	            round: round,
	            title: "Product Marketing"
	          }, {
	            to: "/decisions/operations",
	            round: round,
	            title: "Operations Decisions"
	          }, {
	            to: "/decisions/finance",
	            round: round,
	            title: "Finance Decisions"
	          }, {
	            to: '/ceo/audit-trail',
	            alternatives: ['/pd/audit-trail', '/pm/audit-trail', '/op/audit-trail', '/fn/audit-trail'],
	            title: 'Audit Trail',
	            round: round
	          }]
	        }, {
	          to: '/instructor/results',
	          title: 'Results',
	          hide: !!temporaryUser,
	          round: round,
	          innerLinks: [].concat(_toConsumableArray(canShowPerformanceFeedback ? [{
	            to: '/instructor/performance-feedback',
	            title: 'Performance Feedback',
	            round: round
	          }] : []), _toConsumableArray(canShowFinalScores ? [{
	            to: '/instructor/final-scores',
	            title: 'Final Scores',
	            round: round
	          }] : []))
	        }, {
	          to: '/instructor/results',
	          title: 'Results',
	          hide: !temporaryUser || !isActiveRoundFinished,
	          innerLinks: [{
	            to: '/analysis/team-reports',
	            title: 'Team Reports',
	            round: round
	          }]
	        }]
	      })
	    )
	  );
	});
	
	var LeftBar = (0, _recompose.pure)(function (_ref) {
	  var isStudent = _ref.isStudent,
	      noGameYet = _ref.noGameYet,
	      props = _objectWithoutProperties(_ref, ["isStudent", "noGameYet"]);
	
	  // Even in the noGameYet locked state we render the LeftBar so the
	  // student has visual context of the app shell behind the popup.
	  // The OnboardingPage's dim backdrop covers the LeftBar area,
	  // making its links non-interactive without hiding them.
	  return isStudent ? _react2.default.createElement(StudentLeftBar, props) : _react2.default.createElement(InstructorLeftBar, props);
	});
	
	var StudentLeftBar = function (_PureComponent) {
	  _inherits(StudentLeftBar, _PureComponent);
	
	  function StudentLeftBar(props) {
	    _classCallCheck(this, StudentLeftBar);
	
	    var _this = _possibleConstructorReturn(this, (StudentLeftBar.__proto__ || Object.getPrototypeOf(StudentLeftBar)).call(this, props));
	
	    _this.showDecisionsMenu = function (e) {
	      e.preventDefault();
	
	      _this.setState({
	        showDecisionsMenu: true
	      }, function () {
	        document.addEventListener("click", _this.hideDecisionsMenu);
	      });
	    };
	
	    _this.hideDecisionsMenu = function (e) {
	      if (e.target.toString().indexOf("decisions") > -1) {
	        return;
	      } else {
	        _this.setState({
	          showDecisionsMenu: false
	        }, function () {
	          document.removeEventListener("click", _this.hideDecisionsMenu);
	        });
	      }
	    };
	
	    _this.showTeamReportsMenu = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        showTeamReportsMenu: true
	      }, function () {
	        document.addEventListener("click", _this.closeTeamReports);
	      });
	    };
	
	    _this.closeTeamReports = function (e) {
	      if (e.target.toString().indexOf("analysis") > -1 || e.target.toString().indexOf("team-reports") > -1) {
	        return;
	      } else {
	        _this.setState({ showTeamReportsMenu: false }, function () {
	          document.removeEventListener("click", _this.closeTeamReports);
	        });
	      }
	    };
	
	    _this.showMenu = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        showMenu: true
	      }, function () {
	        document.addEventListener("click", _this.closeMenu);
	      });
	    };
	
	    _this.closeMenu = function () {
	      _this.setState({ showMenu: false }, function () {
	        document.removeEventListener("click", _this.closeMenu);
	      });
	    };
	
	    _this.showPositionsMenu = function (event) {
	      event.preventDefault();
	
	      var position = _this.props.position;
	
	
	      var route = "/decisions/" + position.toString().toLowerCase();
	      (0, _Location.changeLocation)(route);
	
	      _this.setState({
	        showNavigation: true
	      }, function () {
	        document.addEventListener("click", _this.closePositionsMenu);
	      });
	    };
	
	    _this.closePositionsMenu = function (e) {
	      if (e.target.toString().indexOf("decisions") > -1) {
	        return;
	      } else {
	        _this.setState({ showNavigation: false }, function () {
	          document.removeEventListener("click", _this.closePositionsMenu);
	        });
	      }
	    };
	
	    var pathname = props.location.pathname;
	
	
	    _this.state = {
	      showMenu: false,
	      showNavigation: false,
	      isPeerReviewVisible: true,
	      showTeamReportsMenu: ["/analysis/bcase", "/ceo/analysis/market", "/pd/analysis/market", "/pm/analysis/market", "/op/analysis/market", "/fn/analysis/market", "/team-reports"].includes(pathname) || pathname.indexOf("/analysis/team-reports") === 0,
	      showDecisionsMenu: ["/decisions/ceo", "/decisions/product-development", "/decisions/product-marketing", "/decisions/operations", "/decisions/finance"].includes(pathname),
	      // Mirrors the persisted "user clicked Continue on the role-intro
	      // screen" flag. Used to hide every non-Welcome nav item while
	      // the role-intro screen is on the /onboarding page so we nudge
	      // the student to click Continue instead of jumping elsewhere.
	      roleIntroDismissed: (0, _Round1Checklist.isRoleIntroDismissed)()
	    };
	    _this.handleRoleIntroDismissed = function () {
	      _this.setState({ roleIntroDismissed: true });
	    };
	    return _this;
	  }
	
	  _createClass(StudentLeftBar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _eventEmitter2.default.getInstance().on(_Round1Checklist.ROLE_INTRO_DISMISSED_EVENT, this.handleRoleIntroDismissed);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _eventEmitter2.default.getInstance().off(_Round1Checklist.ROLE_INTRO_DISMISSED_EVENT, this.handleRoleIntroDismissed);
	    }
	  }, {
	    key: "renderYears",
	    value: function renderYears() {
	      var _props = this.props,
	          years = _props.years,
	          currentRound = _props.currentRound;
	
	
	      if (years.data.length > 0) {
	        years.data.map(function (el) {
	          return _react2.default.createElement(
	            "li",
	            null,
	            "Year : ",
	            el <= currentRound ? el : ""
	          );
	        });
	      } else {
	        return _react2.default.createElement(
	          "li",
	          null,
	          "Year : ",
	          years.data[0]
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          rounds = _props2.rounds,
	          roundInUrl = _props2.roundInUrl,
	          gameRound = _props2.gameRound,
	          position = _props2.position,
	          location = _props2.location,
	          isMenuExpanded = _props2.isMenuExpanded,
	          isPerformanceFeedbackVisible = _props2.isPerformanceFeedbackVisible;
	      var _state = this.state,
	          isPeerReviewVisible = _state.isPeerReviewVisible,
	          roleIntroDismissed = _state.roleIntroDismissed;
	
	
	      var round = (0, _lodash.isNil)(roundInUrl) ? currentRound : roundInUrl;
	      var roleUrl = (0, _utils.roleToUrl)(position);
	      // Mirror the instructor rule: hide Performance Feedback until at
	      // least one round for this game has finished. Still respects the
	      // parent's isPerformanceFeedbackVisible.
	      //
	      // Additionally hide the link while the currently VIEWED round is
	      // still active — the link routes to /performance-feedback?round=<round>
	      // and PF doesn't exist for an unfinished round. Prior-round PF
	      // remains accessible via the "Open performance feedback" link in
	      // the Welcome checklist, which explicitly targets the prior round.
	      var hasFinishedRound = Array.isArray(rounds) && rounds.some(function (r) {
	        return r.is_finished === true;
	      });
	      var viewedRoundFinished = Array.isArray(rounds) && rounds.some(function (r) {
	        return Number(r.number) === Number(round) && r.is_finished === true;
	      });
	      var canShowPerformanceFeedback = isPerformanceFeedbackVisible && hasFinishedRound && viewedRoundFinished;
	
	      // On first onboarding visit the role-intro screen (Round1Checklist's
	      // pre-checklist "Your Role: X" card) is on screen. Hide every
	      // non-Welcome nav item until the student clicks Continue so the
	      // sidebar nudges them toward that action instead of scattering.
	      // The gate lifts as soon as the role intro is dismissed (localStorage
	      // flag + ROLE_INTRO_DISMISSED_EVENT).
	      //
	      // Only round 1 has the intro — round 2+ uses RoundChecklist which
	      // has no intro screen, so the gate would otherwise hide the whole
	      // nav on round 2+ any time the current role's round1 dismissal key
	      // isn't set (e.g. after role rotation).
	      var onOnboarding = location && location.pathname && location.pathname.indexOf('/onboarding') === 0;
	      var hideNonWelcomeNav = onOnboarding && round === 1 && !roleIntroDismissed;
	
	      return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)('left__bar', {
	            left__bar__collapsed: !isMenuExpanded
	          }) },
	        _react2.default.createElement(
	          "div",
	          { className: "left__bar__div" },
	          _react2.default.createElement(_RoundSwitcherList2.default, {
	            round: round,
	            currentRound: currentRound,
	            rounds: rounds,
	            location: location,
	            isMenuExpanded: isMenuExpanded
	          }),
	          _react2.default.createElement(_countdown2.default, {
	            currentRound: currentRound,
	            rounds: rounds,
	            roundInUrl: roundInUrl,
	            gameRound: gameRound,
	            isMenuExpanded: isMenuExpanded
	          }),
	          _react2.default.createElement(_LinksWrapper2.default, {
	            currentRound: currentRound,
	            roundInUrl: roundInUrl,
	            position: position,
	            location: location,
	            isMenuExpanded: isMenuExpanded,
	            links: [
	            /*{
	              to: "/dashboard",
	              round,
	              title: "Dashboard",
	              hide: false
	            },*/
	            {
	              to: '/onboarding',
	              round: round,
	              title: 'Welcome',
	              hide: false
	            }, {
	              to: "/expand/research",
	              round: round,
	              hide: round === 1 || hideNonWelcomeNav,
	              title: "Research",
	              innerLinks: [{
	                to: "/analysis/bcase/executive-summary",
	                round: round,
	                title: "Business Case"
	              }, {
	                to: "/" + roleUrl + "/analysis/market",
	                round: round,
	                title: "Customer Analysis"
	              }, {
	                to: "/analysis/team-reports",
	                round: round - 1,
	                title: "Prior Round Team Report"
	              }]
	            }, {
	              to: "/expand/research",
	              round: round,
	              hide: round !== 1 || hideNonWelcomeNav,
	              title: "Research",
	              innerLinks: [{
	                to: "/analysis/bcase/executive-summary",
	                round: round,
	                title: "Business Case"
	              }, {
	                to: "/" + roleUrl + "/analysis/market",
	                round: round,
	                title: "Customer Analysis"
	              }]
	            }, {
	              to: '/goals-and-targets',
	              round: round,
	              title: 'Goals & Targets',
	              hide: hideNonWelcomeNav
	            }, {
	              to: '/round-trivia',
	              round: round,
	              title: 'Trivia',
	              hide: true
	            }, {
	              to: "/decisions",
	              round: round,
	              title: "Decisions",
	              hide: hideNonWelcomeNav,
	              expandable: true,
	              innerLinks: [{
	                to: "/decisions/ceo",
	                round: round,
	                title: "CEO"
	              }, {
	                to: "/decisions/product-development",
	                round: round,
	                title: "Product Management"
	              }, {
	                to: "/decisions/product-marketing",
	                round: round,
	                title: "Product Marketing"
	              }, {
	                to: "/decisions/operations",
	                round: round,
	                title: "Operations"
	              }, {
	                to: "/decisions/finance",
	                round: round,
	                title: "Finance"
	              }]
	            }].concat(_toConsumableArray(isPeerReviewVisible ? [{
	              to: "/peer-review",
	              title: "Peer Review",
	              round: round,
	              hide: hideNonWelcomeNav
	            }] : []), [{
	              to: "/expand/results",
	              round: round,
	              title: 'Results',
	              hide: hideNonWelcomeNav,
	              innerLinks: [].concat(_toConsumableArray(canShowPerformanceFeedback ? [{
	                to: "/performance-feedback",
	                round: round,
	                title: "Performance Feedback"
	              }] : []), [{
	                to: "/analysis/team-reports",
	                round: round,
	                title: "Team Report"
	              }, {
	                to: "/scoring-breakdown",
	                round: round,
	                title: "Scoring Breakdown"
	              }])
	            }])
	          }),
	          this.state.showNavigation ? _react2.default.createElement(_decisionsSummary2.default, { location: window.location, position: position }) : null
	        )
	      );
	    }
	  }]);
	
	  return StudentLeftBar;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactEasyState.view)(LeftBar));

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _tracksCache = __webpack_require__(263);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _onboardingRouting = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	//import moment from "moment-timezone";
	
	//import { isSurveyFinished } from '../../api/Surveys';
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var StartPage = function (_PureComponent) {
	  _inherits(StartPage, _PureComponent);
	
	  function StartPage(props) {
	    _classCallCheck(this, StartPage);
	
	    var _this = _possibleConstructorReturn(this, (StartPage.__proto__ || Object.getPrototypeOf(StartPage)).call(this, props));
	
	    _this.fetchData = function () {
	      if (_Auth2.default.isCoInstructor() || _Auth2.default.isInstructorAssistant()) {
	        // Only the course-lead Instructor (INS) owns onboarding —
	        // Co-Instructors and Instructor Assistants can't create games
	        // or surveys, so skip the resolveOnboardingEntry gate and go
	        // straight to the normal landing (welcome / performance-feedback).
	        _this.continueInstructorRouting();
	        return;
	      }
	      if (_Auth2.default.getPosition() === 'Instructor') {
	        // Async gate: resolve full vs partial onboarding vs. skip based on
	        // user.onboard + whether the current course already has a game
	        // and a survey. See onboardingRouting.js for the rules.
	        (0, _onboardingRouting.resolveOnboardingEntry)().then(function (onboardingUrl) {
	          if (onboardingUrl) {
	            (0, _Location.changeLocation)(onboardingUrl);
	            return;
	          }
	          _this.continueInstructorRouting();
	        }).catch(function () {
	          // If the check itself fails, fall through to the existing
	          // welcome routing rather than blocking the user.
	          _this.continueInstructorRouting();
	        });
	        return;
	      } else {
	        // Intro gate safety net for reloads. If a student refreshes /start
	        // before watching the intro video, bounce them back to it. Login
	        // itself also routes here first; this covers the reload case.
	        var currentUser = _Auth2.default.getUser();
	        if (currentUser && currentUser.intro === 0) {
	          (0, _Location.changeLocation)('/intro-video');
	          return;
	        }
	
	        if (_Auth2.default.isPaid() === false) {
	          _this.setState({
	            loaded: true
	          });
	          return;
	        }
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'game/rounds/').then(function (res) {
	          var allRounds = (0, _orderBy2.default)(res.body, ['number'], ['asc']);
	          var startedRounds = allRounds.filter(function (i) {
	            return i.is_started === true;
	          });
	
	          if (startedRounds.length === 0) {
	            (0, _Location.changeLocation)('/onboarding');
	            return;
	          }
	
	          var currentRound = startedRounds[startedRounds.length - 1];
	          if (currentRound.is_finished === true || currentRound.should_be_finished === true) {
	            (0, _Location.changeLocation)('/performance-feedback?round=' + currentRound.number);
	            return;
	          }
	
	          if (currentRound.number === 1) {
	            (0, _Location.changeLocation)('/onboarding?round=' + currentRound.number);
	            return;
	          }
	
	          var courseId = Number(_Auth2.default.getCourseId());
	          var gameId = Number(_Auth2.default.getGameId());
	          var userId = Number(_Auth2.default.getUserId());
	          var priorRound = currentRound.number - 1;
	
	          (0, _tracksCache.fetchTracks)({ gameId: gameId, courseId: courseId, userId: userId, roundNumber: priorRound }).then(function (res) {
	            var visited = res.body.results.find(function (i) {
	              return i.page === window.location.protocol + '//' + window.location.host + '/performance-feedback/good-luck';
	            });
	
	            if (!visited) {
	              (0, _Location.changeLocation)('/performance-feedback?round=' + priorRound);
	              window.location.reload();
	            } else {
	              (0, _Location.changeLocation)('/onboarding?round=' + currentRound.number);
	            }
	          }).catch(function (err) {});
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.continueInstructorRouting = function () {
	      var rounds = _this.props.rounds;
	      // Sort by round number ascending before taking the last element.
	      // The BE returns rounds in insertion / id order, not number order,
	      // so after Activate Main Rounds the array can land as (2, 3, 1)
	      // and `finishedRounds[last]` would be Round 1 instead of the real
	      // latest round. See also the twin fix on performance-feedback.js.
	
	      var finishedRounds = (rounds || []).filter(function (i) {
	        return i.is_started === true && i.is_finished === true;
	      }).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	      if (finishedRounds.length === 0) {
	        (0, _Location.changeLocation)('/instructor/welcome?round=1');
	      } else {
	        var lastFinishedRound = finishedRounds[finishedRounds.length - 1];
	        (0, _Location.changeLocation)('/instructor/performance-feedback?round=' + lastFinishedRound.number);
	      }
	    };
	
	    _this.state = {
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(StartPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	
	    // Existing instructor welcome/performance-feedback routing, extracted
	    // from fetchData so the new async onboarding gate can fall through
	    // to it when the instructor doesn't need onboarding.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var loaded = this.state.loaded;
	
	
	      return !loaded ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      ) : _react2.default.createElement(Wrapper, null);
	    }
	  }]);
	
	  return StartPage;
	}(_react.PureComponent);
	
	exports.default = StartPage;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypist = __webpack_require__(2412);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderGameName = function (_PureComponent) {
	  _inherits(HeaderGameName, _PureComponent);
	
	  function HeaderGameName(props) {
	    _classCallCheck(this, HeaderGameName);
	
	    var _this = _possibleConstructorReturn(this, (HeaderGameName.__proto__ || Object.getPrototypeOf(HeaderGameName)).call(this, props));
	
	    _this.onTypingDone = function () {
	      _this.setState({
	        typing: false
	      });
	    };
	
	    _this.state = {
	      typing: true
	    };
	    return _this;
	  }
	
	  _createClass(HeaderGameName, [{
	    key: "render",
	    value: function render() {
	      var typing = this.state.typing;
	
	
	      if (this.gameName === "") return null;
	
	      return typing === true ? _react2.default.createElement(
	        _reactTypist2.default,
	        {
	          cursor: this.typistStyle,
	          avgTypingDelay: 150,
	          className: "inline-block",
	          onTypingDone: this.onTypingDone
	        },
	        this.renderText
	      ) : this.renderText;
	    }
	  }, {
	    key: "textStyle",
	    get: function get() {
	      var team_color = this.props.team_color;
	
	
	      return {
	        color: team_color,
	        fontSize: "20px"
	      };
	    }
	  }, {
	    key: "typistStyle",
	    get: function get() {
	      return {
	        show: true,
	        blink: true,
	        element: "|",
	        hideWhenDone: false,
	        hideWhenDoneDelay: 300
	      };
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return roundInUrl !== null && roundInUrl !== currentRound ? roundInUrl : currentRound;
	    }
	  }, {
	    key: "gameName",
	    get: function get() {
	      var _this2 = this;
	
	      var rounds = this.props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === _this2.activeRound;
	      });
	
	      return round ? round.game_name : "";
	    }
	  }, {
	    key: "renderText",
	    get: function get() {
	      return _react2.default.createElement(
	        "b",
	        { style: this.textStyle },
	        this.gameName
	      );
	    }
	  }]);
	
	  return HeaderGameName;
	}(_react.PureComponent);
	
	exports.default = HeaderGameName;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAvatar = __webpack_require__(896);
	
	var _reactAvatar2 = _interopRequireDefault(_reactAvatar);
	
	var _reactRouter = __webpack_require__(24);
	
	var _Location = __webpack_require__(23);
	
	var _iconDropdownArrow = __webpack_require__(1849);
	
	var _iconDropdownArrow2 = _interopRequireDefault(_iconDropdownArrow);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _myProfileLink = __webpack_require__(1213);
	
	var _myProfileLink2 = _interopRequireDefault(_myProfileLink);
	
	var _teamProfileLink = __webpack_require__(1214);
	
	var _teamProfileLink2 = _interopRequireDefault(_teamProfileLink);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _contactSupport = __webpack_require__(577);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Map the raw role code stored in App state to the human-readable
	// label shown next to the user's name in the topbar. Unknown values
	// fall through unchanged so the app doesn't hide unexpected roles.
	var POSITION_DISPLAY_NAMES = {
	  CEO: "CEO",
	  PD: "Product Manager",
	  PM: "Product Marketing",
	  OP: "Operations Manager",
	  FI: "Finance Manager"
	};
	
	var formatPosition = function formatPosition(position) {
	  if (!position) return position;
	  var key = String(position).toUpperCase();
	  return POSITION_DISPLAY_NAMES[key] || position;
	};
	
	var HeaderUserGroup = function (_Component) {
	  _inherits(HeaderUserGroup, _Component);
	
	  function HeaderUserGroup(props) {
	    _classCallCheck(this, HeaderUserGroup);
	
	    var _this = _possibleConstructorReturn(this, (HeaderUserGroup.__proto__ || Object.getPrototypeOf(HeaderUserGroup)).call(this, props));
	
	    _this.openContactSupport = function () {
	      _eventEmitter2.default.getInstance().trigger(_contactSupport.OPEN_CONTACT_SUPPORT_EVENT);
	    };
	
	    _this.showMenu = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        showMenu: true
	      }, function () {
	        document.addEventListener("click", _this.closeMenu);
	      });
	    };
	
	    _this.closeMenu = function () {
	      _this.setState({ showMenu: false }, function () {
	        document.removeEventListener("click", _this.closeMenu);
	      });
	    };
	
	    _this.state = {
	      showMenu: false
	    };
	    return _this;
	  }
	
	  _createClass(HeaderUserGroup, [{
	    key: "logout",
	    value: function logout() {
	      if (_Auth2.default.isUserAuthenticated()) {
	        _Auth2.default.deauthenticateUser();
	      }
	
	      (0, _Location.changeLocation)("/login");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          team_color = _props.team_color,
	          position = _props.position,
	          isStudent = _props.isStudent;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "header__user__group", onClick: this.showMenu },
	        " ",
	        _react2.default.createElement(_reactAvatar2.default, { name: name, color: team_color, size: isStudent ? 50 : 45, round: true }),
	        _react2.default.createElement(
	          "p",
	          { className: "username" },
	          name
	        ),
	        position && _react2.default.createElement(
	          "p",
	          { className: "position" },
	          "(",
	          formatPosition(position),
	          ")"
	        ),
	        _react2.default.createElement("img", { src: _iconDropdownArrow2.default, className: "icon-dropdown", alt: "Dropdown" }),
	        this.state.showMenu ? _react2.default.createElement(
	          "div",
	          { className: "menu" },
	          _react2.default.createElement(
	            "ul",
	            { className: "drop__down__menu" },
	            isStudent && _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_myProfileLink2.default, null)
	            ),
	            isStudent && _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_teamProfileLink2.default, null)
	            ),
	            isStudent && _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: "/ceo/audit-trail"
	                },
	                "Audit Trail"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "button",
	                { onClick: this.openContactSupport },
	                "Contact Support"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "button",
	                { onClick: this.logout },
	                "Log Off"
	              )
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return HeaderUserGroup;
	}(_react.Component);
	
	exports.default = HeaderUserGroup;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 40px;\n  color: #52c5cd;\n"], ["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 40px;\n  color: #52c5cd;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #3a507b;\n  width: 210px;\n  height: 59px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n\n  ", "\n"], ["\n  background: #3a507b;\n  width: 210px;\n  height: 59px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n\n  ", "\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  padding-left: 21px;\n  cursor: pointer;\n\n  ", "\n"], ["\n  padding-left: 21px;\n  cursor: pointer;\n\n  ", "\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  height: 28px;\n  width: auto;\n  display: block;\n  flex-shrink: 0;\n\n  ", "\n"], ["\n  height: 28px;\n  width: auto;\n  display: block;\n  flex-shrink: 0;\n\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 22px;\n  color: #f5f6f7;\n\n  ", "\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 22px;\n  color: #f5f6f7;\n\n  ", "\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _topBarExpand = __webpack_require__(2677);
	
	var _topBarExpand2 = _interopRequireDefault(_topBarExpand);
	
	var _NewMGLogoDarkBG = __webpack_require__(1050);
	
	var _NewMGLogoDarkBG2 = _interopRequireDefault(_NewMGLogoDarkBG);
	
	var _headerUserGroup = __webpack_require__(1211);
	
	var _headerUserGroup2 = _interopRequireDefault(_headerUserGroup);
	
	var _headerGameName = __webpack_require__(1210);
	
	var _headerGameName2 = _interopRequireDefault(_headerGameName);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _reactAvatar = __webpack_require__(896);
	
	var _reactAvatar2 = _interopRequireDefault(_reactAvatar);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var InstructorPageName = _styledComponents2.default.b(_templateObject);
	
	var LogoGroup = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.isCollapsed && "\n    justify-content: center;\n    width: 66px;\n    margin-right: 144px;\n  ";
	});
	
	var LogoIcon = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.isCollapsed && "\n    padding-left: 0;\n  ";
	});
	
	// Brand mark that sits to the left of the "Market Games" text in
	// the topbar. Sized to fit comfortably inside the 59px LogoGroup
	// without crowding the wordmark.
	var LogoMark = _styledComponents2.default.img(_templateObject4, function (p) {
	  return p.isCollapsed && "\n    display: none;\n  ";
	});
	
	var LogoText = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.isCollapsed && "\n    display: none;\n  ";
	});
	
	function TopBar(_ref) {
	  var isStudent = _ref.isStudent,
	      team_color = _ref.team_color,
	      currentRound = _ref.currentRound,
	      roundInUrl = _ref.roundInUrl,
	      rounds = _ref.rounds,
	      name = _ref.name,
	      position = _ref.position,
	      instructorTeams = _ref.instructorTeams,
	      isMenuExpanded = _ref.isMenuExpanded,
	      setMenuState = _ref.setMenuState;
	
	  var temporaryUser = _Auth2.default.getTemporaryUser();
	  var teamName = '';
	  if (temporaryUser && instructorTeams) {
	    var team = instructorTeams.find(function (i) {
	      return Number(i.id) === Number(temporaryUser.team_id);
	    });
	    teamName = team ? team.name : '';
	  }
	
	  return _react2.default.createElement(
	    "header",
	    { className: "header" },
	    _react2.default.createElement(
	      LogoGroup,
	      { isCollapsed: !isMenuExpanded },
	      _react2.default.createElement(
	        LogoIcon,
	        {
	          isCollapsed: !isMenuExpanded,
	          onClick: function onClick() {
	            return setMenuState(!isMenuExpanded);
	          }
	        },
	        _react2.default.createElement("img", { src: _topBarExpand2.default, alt: "expand" })
	      ),
	      _react2.default.createElement(LogoMark, {
	        src: _NewMGLogoDarkBG2.default,
	        alt: "Market Games",
	        isCollapsed: !isMenuExpanded
	      }),
	      _react2.default.createElement(
	        LogoText,
	        { isCollapsed: !isMenuExpanded },
	        "Market Games"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "navbar-center" },
	      isStudent && _react2.default.createElement(_headerGameName2.default, {
	        team_color: team_color,
	        currentRound: currentRound,
	        roundInUrl: roundInUrl,
	        rounds: rounds
	      }),
	      !isStudent && _react2.default.createElement(
	        InstructorPageName,
	        null,
	        "Dashboard"
	      )
	    ),
	    isStudent && _react2.default.createElement(_headerUserGroup2.default, {
	      team_color: team_color,
	      name: name,
	      position: position,
	      isStudent: isStudent
	    }),
	    temporaryUser && _react2.default.createElement(
	      "div",
	      { className: "header__user__group2" },
	      " ",
	      _react2.default.createElement(_reactAvatar2.default, { name: teamName, color: team_color, size: "50", round: true }),
	      _react2.default.createElement(
	        "p",
	        { className: "username" },
	        teamName
	      )
	    ),
	    !temporaryUser && !isStudent && _react2.default.createElement(_headerUserGroup2.default, {
	      team_color: "#52c5cd",
	      name: name,
	      position: null,
	      isStudent: isStudent
	    })
	  );
	}
	
	exports.default = (0, _reactEasyState.view)(TopBar);

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MyProfileLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MyProfileLink() {
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: "/profile", id: "my-profile-link" },
	    "My Profile"
	  );
	}

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(55);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventEmitter = _eventEmitter2.default.getInstance();
	
	var onClickHandler = function onClickHandler(e) {
	  e.preventDefault();
	  eventEmitter.trigger("team-profile-modal-show");
	};
	
	var TeamProfileLink = (0, _recompose.pure)(function () {
	  return _react2.default.createElement(
	    "a",
	    { href: "/#", id: "team-profile-link", onClick: onClickHandler },
	    "Team Profile"
	  );
	});
	
	exports.default = TeamProfileLink;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #2da548;\n  display: flex;\n  flex-direction: row;\n  padding: 16px 0;\n  text-align: center;\n  justify-content: center;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #ffffff;\n'], ['\n  background: #2da548;\n  display: flex;\n  flex-direction: row;\n  padding: 16px 0;\n  text-align: center;\n  justify-content: center;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #ffffff;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var CopiedMessage = function CopiedMessage() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    'Copied'
	  );
	};
	
	exports.default = CopiedMessage;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n\n  .loader {\n    display: inline-block;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n\n  .loader {\n    display: inline-block;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 992px;\n'], ['\n  padding: 40px;\n  width: 992px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -7.5px;\n  right: 40px;\n\n  img {\n    height: 255px;\n  }\n'], ['\n  position: absolute;\n  top: -7.5px;\n  right: 40px;\n\n  img {\n    height: 255px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  border-radius: 8px;\n  background: #fec665;\n  padding: 56px 40px 40px 40px;\n  position: relative;\n  min-height: 240px;\n  max-width: 912px;\n'], ['\n  margin-top: 24px;\n  border-radius: 8px;\n  background: #fec665;\n  padding: 56px 40px 40px 40px;\n  position: relative;\n  min-height: 240px;\n  max-width: 912px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 32px;\n  height: 32px;\n  background: #faf5eb;\n  border-radius: 4px;\n  border: 1px solid #eca427;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: #eca427;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 32px;\n  height: 32px;\n  background: #faf5eb;\n  border-radius: 4px;\n  border: 1px solid #eca427;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: #eca427;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  margin-top: 4px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  width: calc(100% - 472px);\n'], ['\n  margin-top: 4px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  width: calc(100% - 472px);\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  margin-top: 27px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px 19px;\n  width: calc(100% - 460px);\n  flex-wrap: wrap;\n'], ['\n  margin-top: 27px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px 19px;\n  width: calc(100% - 460px);\n  flex-wrap: wrap;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n  flex-wrap: nowrap;\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n  flex-wrap: nowrap;\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  margin-top: 24px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 24px;\n'], ['\n  margin-top: 24px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 24px;\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  width: 288px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  padding: 16px 16px 48px;\n  position: relative;\n\n  ', '\n\n  img {\n    position: absolute;\n    right: 16px;\n    bottom: 16px;\n  }\n'], ['\n  width: 288px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  padding: 16px 16px 48px;\n  position: relative;\n\n  ', '\n\n  img {\n    position: absolute;\n    right: 16px;\n    bottom: 16px;\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  margin-top: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  margin-top: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _tracksCache = __webpack_require__(263);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _smallCheckbox = __webpack_require__(1067);
	
	var _smallCheckbox2 = _interopRequireDefault(_smallCheckbox);
	
	var _smallCheckboxActive = __webpack_require__(1066);
	
	var _smallCheckboxActive2 = _interopRequireDefault(_smallCheckboxActive);
	
	var _nextSteps = __webpack_require__(2633);
	
	var _nextSteps2 = _interopRequireDefault(_nextSteps);
	
	var _nextSteps3 = __webpack_require__(2634);
	
	var _nextSteps4 = _interopRequireDefault(_nextSteps3);
	
	var _nextSteps5 = __webpack_require__(2635);
	
	var _nextSteps6 = _interopRequireDefault(_nextSteps5);
	
	var _nextSteps7 = __webpack_require__(2636);
	
	var _nextSteps8 = _interopRequireDefault(_nextSteps7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable react/jsx-no-target-blank */
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Image = _styledComponents2.default.div(_templateObject5);
	
	var BigGoal = _styledComponents2.default.div(_templateObject6);
	
	var BigGoalTitleNum = _styledComponents2.default.div(_templateObject7);
	
	var BigGoalTitle = _styledComponents2.default.div(_templateObject8);
	
	var BigGoalDescription = _styledComponents2.default.div(_templateObject9);
	
	var CheckboxesRow = _styledComponents2.default.div(_templateObject10);
	
	var Checkbox = _styledComponents2.default.div(_templateObject11);
	
	var SmallGoals = _styledComponents2.default.div(_templateObject12);
	
	var SmallGoal = _styledComponents2.default.div(_templateObject13, function (p) {
	  return p.isGreyed && '\n    opacity: 0.6;\n  ';
	});
	
	var SmallGoalTitleNum = _styledComponents2.default.div(_templateObject7);
	
	var SmallGoalTitle = _styledComponents2.default.div(_templateObject14);
	
	var SmallGoalDescription = _styledComponents2.default.div(_templateObject15);
	
	var NextStepsPage = function (_PureComponent) {
	  _inherits(NextStepsPage, _PureComponent);
	
	  function NextStepsPage(props) {
	    _classCallCheck(this, NextStepsPage);
	
	    var _this = _possibleConstructorReturn(this, (NextStepsPage.__proto__ || Object.getPrototypeOf(NextStepsPage)).call(this, props));
	
	    _this.state = {
	      loading: true,
	      isBusinessCaseVisited: false,
	      isCustomerAnalysisVisited: false,
	      isPriorRoundVisited: false,
	      isGoalsSubmitted: false,
	      isTriviaDone: false,
	      userRole: '',
	      pdSubmitted: false,
	      pmSubmitted: false,
	      opSubmitted: false,
	      fnSubmitted: false,
	      triviaCourseAvailable: 0
	    };
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(NextStepsPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          rounds = _props.rounds;
	
	
	      var courseId = Number(_Auth2.default.getCourseId());
	      var gameId = Number(_Auth2.default.getGameId());
	      var userId = Number(_Auth2.default.getUserId());
	
	      this.eventemitter.trigger('next-steps-visited');
	      this.props.setMode('basic');
	
	      // Per-role "Submitted" state used to come from a full journal scan
	      // (find latest successful submit_*, look for newer same-role edits).
	      // team-status already exposes the same signal in two fields per
	      // role — submission_data.{pd,pm,op,fn}.date and .unaccepted — so
	      // we run that fetch in parallel and skip the journal call.
	      //
	      // The three engagement-tracks reads go through fetchTracks (a
	      // module-level promise cache), which means App.js's identical
	      // current-round call and analytics-send's preflight check all
	      // share one network round trip instead of three.
	      Promise.all([(0, _tracksCache.fetchTracks)({ gameId: gameId, courseId: courseId, userId: userId, roundNumber: currentRound }), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/goaltargets/')].concat(_toConsumableArray(currentRound === 1 ? [] : [(0, _tracksCache.fetchTracks)({ gameId: gameId, courseId: courseId, userId: userId, roundNumber: currentRound - 1 })]), [(0, _tracksCache.fetchTracks)({ gameId: gameId, courseId: courseId, userId: userId }), (0, _TeamDecisionsService.fetchTeamStatus)(currentRound)])).then(function (results) {
	        // Slot layout matches the downstream `res[N]` references below.
	        // When currentRound === 1, the prior-round slot is omitted so
	        // res[2] becomes the all-rounds response (used for both the
	        // prior-round-visited check, which short-circuits to true, and
	        // the all-rounds business-case check).
	        var hasPrior = currentRound !== 1;
	        var res = hasPrior ? [results[0], results[1], results[2], results[3]] : [results[0], results[1], results[2]];
	        var statusData = hasPrior ? results[4] : results[3];
	        var currentTeam = _Teams2.default.currentTeam();
	        var teamId = Number(currentTeam.id);
	
	        var round = rounds.find(function (i) {
	          return i.number === currentRound;
	        });
	        var roundId = round ? Number(round.id) : 0;
	        var baseUrl = window.location.protocol + '//' + window.location.host;
	
	        // Index map after dropping the journal slot:
	        //   res[0] = current-round engagement tracks
	        //   res[1] = goalsTargets
	        //   res[2] = prior-round engagement tracks (only when currentRound > 1)
	        //   res[2/3] = all-rounds engagement tracks
	        // When currentRound === 1, prior-round tracks isn't fetched, so
	        // res[2] is the all-rounds payload (used twice as a stand-in).
	        var trackedPages = res[0].body;
	        var goalsTargets = res[1].body;
	        var triviaCourseAvailable = 0;
	        var priorRoundTrackedPages = currentRound === 1 ? [] : res[2].body;
	
	        var trackedPagesForAllRounds = currentRound === 1 ? res[2].body : res[3].body;
	
	        var pages = trackedPages.results.filter(function (i) {
	          return i.page.indexOf(window.location.protocol + '//' + window.location.host) === 0;
	        }).map(function (i) {
	          return i.page.replace(window.location.protocol + '//' + window.location.host + '/', '');
	        }).map(function (i) {
	          return i.split('?')[0];
	        });
	
	        var pagesForAllRounds = trackedPagesForAllRounds.results.filter(function (i) {
	          return i.page.indexOf(window.location.protocol + '//' + window.location.host) === 0;
	        }).map(function (i) {
	          return i.page.replace(window.location.protocol + '//' + window.location.host + '/', '');
	        }).map(function (i) {
	          return i.split('?')[0];
	        });
	        var priorRoundPages = currentRound === 1 ? [] : priorRoundTrackedPages.results.filter(function (i) {
	          return Number(i.course) === courseId && Number(i.game) === gameId && Number(i.round_number) === currentRound - 1 && Number(i.user) === userId && i.page.indexOf(baseUrl) === 0;
	        }).map(function (i) {
	          return i.page.replace(baseUrl + '/', '');
	        }).map(function (i) {
	          return i.split('?')[0];
	        });
	
	        var isBusinessCaseVisited = pagesForAllRounds.includes('analysis/bcase/executive-summary') && pagesForAllRounds.includes('analysis/bcase/opportunity-economy-industry') && pagesForAllRounds.includes('analysis/bcase/market') && pagesForAllRounds.includes('analysis/bcase/product') && pagesForAllRounds.includes('analysis/bcase/operations') && pagesForAllRounds.includes('analysis/bcase/investors');
	        var isCustomerAnalysisVisited = pages.includes('ceo/analysis/market') || pages.includes('pd/analysis/market') || pages.includes('pm/analysis/market') || pages.includes('op/analysis/market') || pages.includes('fn/analysis/market');
	        var isPriorRoundVisited = currentRound === 1 ? true : priorRoundPages.includes('analysis/team-reports/marketing-analysis/market-share-capture') && priorRoundPages.includes('analysis/team-reports/marketing-analysis/customer-survey') && priorRoundPages.includes('analysis/team-reports/marketing-analysis/marketing-selling-price') && priorRoundPages.includes('analysis/team-reports/marketing-analysis/marketing-awareness') && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-unit-costs') && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-unit-costs-breakdown') && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-inventory-management') && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-capital-structure') && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-valuation') && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-shares');
	        var isTriviaDone = pages.includes('round-trivia/trivia/done');
	
	        var userGoals = goalsTargets.results.find(function (i) {
	          return Number(i.course) === courseId && Number(i.round) === roundId && Number(i.team) === teamId && Number(i.user) === userId;
	        });
	        var isGoalsSubmitted = !!userGoals;
	
	        var user = _Auth2.default.getUser();
	        var userRole = (0, _utils.roleToUrl)(user.role);
	
	        // Per-role "Submitted" checkbox state, derived from team-status.
	        // Each role is considered submitted when:
	        //   1. A successful submit_* has happened this round
	        //      (submission_data.<role>.date !== 'N/A')
	        //   2. The user hasn't touched any of that role's decision
	        //      endpoints since then (unaccepted_decisions counter is 0)
	        // This replaces a journal-history scan that walked every entry
	        // looking for the latest submit_* and any newer same-role edits.
	        var isSubmittedAndAccepted = function isSubmittedAndAccepted(entry) {
	          return !!entry && entry.date !== 'N/A' && Number(entry.unaccepted) === 0;
	        };
	        var pdSubmitted = isSubmittedAndAccepted(statusData.submission_data.pd);
	        var pmSubmitted = isSubmittedAndAccepted(statusData.submission_data.pm);
	        var opSubmitted = isSubmittedAndAccepted(statusData.submission_data.op);
	        var fnSubmitted = isSubmittedAndAccepted(statusData.submission_data.fn);
	
	        _this2.setState({
	          loading: false,
	          isBusinessCaseVisited: isBusinessCaseVisited,
	          isCustomerAnalysisVisited: isCustomerAnalysisVisited,
	          isPriorRoundVisited: isPriorRoundVisited,
	          isGoalsSubmitted: isGoalsSubmitted,
	          isTriviaDone: isTriviaDone,
	          userRole: userRole,
	          pdSubmitted: pdSubmitted,
	          pmSubmitted: pmSubmitted,
	          opSubmitted: opSubmitted,
	          fnSubmitted: fnSubmitted,
	          triviaCourseAvailable: triviaCourseAvailable
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currentRound = this.props.currentRound;
	      var _state = this.state,
	          loading = _state.loading,
	          isBusinessCaseVisited = _state.isBusinessCaseVisited,
	          isCustomerAnalysisVisited = _state.isCustomerAnalysisVisited,
	          isPriorRoundVisited = _state.isPriorRoundVisited,
	          isGoalsSubmitted = _state.isGoalsSubmitted,
	          isTriviaDone = _state.isTriviaDone,
	          pdSubmitted = _state.pdSubmitted,
	          pmSubmitted = _state.pmSubmitted,
	          opSubmitted = _state.opSubmitted,
	          fnSubmitted = _state.fnSubmitted,
	          triviaCourseAvailable = _state.triviaCourseAvailable;
	
	
	      var showMarketResearch = !isBusinessCaseVisited || !isCustomerAnalysisVisited || !isPriorRoundVisited;
	      var showGoalsAndTargets = !showMarketResearch && !isGoalsSubmitted;
	      var showTrivia = !showMarketResearch && !showGoalsAndTargets && !isTriviaDone;
	      var showSubmitDecisions = !showMarketResearch && !showGoalsAndTargets && !showTrivia;
	
	      var showPriorRound = false;
	
	      return loading ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'Next Steps'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'Complete Round Challenges'
	          ),
	          showMarketResearch && _react2.default.createElement(
	            BigGoal,
	            null,
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _nextSteps2.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              BigGoalTitle,
	              null,
	              _react2.default.createElement(
	                BigGoalTitleNum,
	                null,
	                '1'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '/analysis/bcase/executive-summary?round=' + currentRound },
	                  'Research'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              BigGoalDescription,
	              null,
	              'Understand the opportunity to help your team make informed decisions.'
	            ),
	            _react2.default.createElement(
	              CheckboxesRow,
	              null,
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                'Viewed'
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: isBusinessCaseVisited ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/bcase/executive-summary?round=' + currentRound },
	                    'Business Case'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: isCustomerAnalysisVisited ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/ceo/analysis/market?round=' + currentRound },
	                    'Customer Analysis'
	                  )
	                )
	              ),
	              currentRound > 1 && _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: isPriorRoundVisited ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/team-reports?round=' + currentRound },
	                    'Prior Round Report'
	                  )
	                )
	              )
	            )
	          ),
	          showMarketResearch && _react2.default.createElement(
	            SmallGoals,
	            null,
	            currentRound > 1 && _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement('img', { src: isGoalsSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '2'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/team-reports?round=' + currentRound },
	                    'Read Prior Round Report'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Analyze and improve your decisions with concrete team reports.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 3 : 2
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/goals-and-targets?round=' + currentRound },
	                    'View Goals & Targets'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'View specific, attainable goals that drive your round decisions.'
	              )
	            ),
	            triviaCourseAvailable !== 0 && _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement('img', { src: isTriviaDone ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 4 : 3
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/round-trivia?round=' + currentRound },
	                    'Take the Trivia'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Assess how prepared you are for this round.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 4 + triviaCourseAvailable : 3 + triviaCourseAvailable
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/ceo?round=' + currentRound },
	                    'Make & Submit Decisions'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Reach out and collaborate with your teammates to make and submit decisions.'
	              )
	            )
	          ),
	          showPriorRound && _react2.default.createElement(
	            BigGoal,
	            null,
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _nextSteps8.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              BigGoalTitle,
	              null,
	              _react2.default.createElement(
	                BigGoalTitleNum,
	                null,
	                '2'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '/analysis/team-reports?round=' + currentRound },
	                  'Read Prior Round Report'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              BigGoalDescription,
	              null,
	              'Analyze and improve your decisions with concrete team reports.'
	            ),
	            _react2.default.createElement(
	              CheckboxesRow,
	              null,
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                'Submited'
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Decisions (5)'
	                )
	              )
	            )
	          ),
	          showPriorRound && _react2.default.createElement(
	            SmallGoals,
	            null,
	            _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '3'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/goals-and-targets?round=' + currentRound },
	                    'View Goals & Targets'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'View specific, attainable goals that drive your round decisions.'
	              )
	            ),
	            triviaCourseAvailable !== 0 && _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement('img', { src: _smallCheckboxActive2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '4'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/round-trivia?round=' + currentRound },
	                    'Take a Trivia'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Are you prepared for making new decisions? Take a trivia to assess.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  4 + triviaCourseAvailable
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/ceo?round=' + currentRound },
	                    'Make & Submit Decisions'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Reach out and collaborate with your teammates to make and submit decisions.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: _smallCheckboxActive2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '1'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/bcase/executive-summary?round=' + currentRound },
	                    'Research'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Understand the image censor market opportunity and the customers.'
	              )
	            )
	          ),
	          showGoalsAndTargets && _react2.default.createElement(
	            BigGoal,
	            null,
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _nextSteps4.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              BigGoalTitle,
	              null,
	              _react2.default.createElement(
	                BigGoalTitleNum,
	                null,
	                currentRound > 1 ? 3 : 2
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '/goals-and-targets?round=' + currentRound },
	                  'View Goals & Targets'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              BigGoalDescription,
	              null,
	              'View specific, attainable goals that drive your round decisions.'
	            ),
	            _react2.default.createElement(CheckboxesRow, null)
	          ),
	          showGoalsAndTargets && _react2.default.createElement(
	            SmallGoals,
	            null,
	            triviaCourseAvailable !== 0 && _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement('img', { src: isTriviaDone ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 4 : 3
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/round-trivia?round=' + currentRound },
	                    'Take the Trivia'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Assess how prepared you are for this round.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 4 + triviaCourseAvailable : 3 + triviaCourseAvailable
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/ceo?round=' + currentRound },
	                    'Make & Submit Decisions'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Reach out and collaborate with your teammates to make and submit decisions.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: _smallCheckboxActive2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '1'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/bcase/executive-summary?round=' + currentRound },
	                    'Research'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Understand the image censor market opportunity and the customers.'
	              )
	            ),
	            currentRound > 1 && _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: isGoalsSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '2'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/team-reports?round=' + currentRound },
	                    'Read Prior Round Report'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Analyze and improve your decisions with concrete team reports.'
	              )
	            )
	          ),
	          showTrivia && triviaCourseAvailable !== 0 && _react2.default.createElement(
	            BigGoal,
	            null,
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _nextSteps6.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              BigGoalTitle,
	              null,
	              _react2.default.createElement(
	                BigGoalTitleNum,
	                null,
	                currentRound > 1 ? 4 : 3
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Take a Trivia'
	              )
	            ),
	            _react2.default.createElement(
	              BigGoalDescription,
	              null,
	              'Are you prepared for making new decisions? Assess with a few questions.'
	            ),
	            _react2.default.createElement(
	              CheckboxesRow,
	              null,
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                'Completed'
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: isTriviaDone ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/round-trivia?round=' + currentRound },
	                    'Trivia'
	                  )
	                )
	              )
	            )
	          ),
	          showTrivia && _react2.default.createElement(
	            SmallGoals,
	            null,
	            _react2.default.createElement(
	              SmallGoal,
	              null,
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 4 + triviaCourseAvailable : 3 + triviaCourseAvailable
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/ceo?round=' + currentRound },
	                    'Make & Submit Decisions'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Reach out and collaborate with your teammates to make and submit decisions.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: _smallCheckboxActive2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '1'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/bcase/executive-summary?round=' + currentRound },
	                    'Research'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Understand the image censor market opportunity and the customers.'
	              )
	            ),
	            currentRound > 1 && _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: isGoalsSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '2'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/team-reports?round=' + currentRound },
	                    'Read Prior Round Report'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Analyze and improve your decisions with concrete team reports.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 3 : 2
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/goals-and-targets?round=' + currentRound },
	                    'View Goals & Targets'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'View specific, attainable goals that drive your round decisions.'
	              )
	            )
	          ),
	          showSubmitDecisions && _react2.default.createElement(
	            BigGoal,
	            null,
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _nextSteps8.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              BigGoalTitle,
	              null,
	              _react2.default.createElement(
	                BigGoalTitleNum,
	                null,
	                currentRound > 1 ? 4 + triviaCourseAvailable : 3 + triviaCourseAvailable
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '/decisions/ceo?round=' + currentRound },
	                  'Make & Submit Decisions'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              BigGoalDescription,
	              null,
	              'Gather information, evaluate possible resolutions and make team choices.'
	            ),
	            _react2.default.createElement(
	              CheckboxesRow,
	              null,
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                'Submitted'
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: pdSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/product-development?round=' + currentRound },
	                    'Product'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: pmSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/product-marketing?round=' + currentRound },
	                    'Marketing'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: opSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/operations?round=' + currentRound },
	                    'Operations'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Checkbox,
	                null,
	                _react2.default.createElement('img', { src: fnSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/decisions/finance?round=' + currentRound },
	                    'Finance'
	                  )
	                )
	              )
	            )
	          ),
	          showSubmitDecisions && _react2.default.createElement(
	            SmallGoals,
	            null,
	            _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: _smallCheckboxActive2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '1'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/bcase/executive-summary?round=' + currentRound },
	                    'Research'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Understand the image censor market opportunity and the customers.'
	              )
	            ),
	            currentRound > 1 && _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: isGoalsSubmitted ? _smallCheckboxActive2.default : _smallCheckbox2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  '2'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/analysis/team-reports?round=' + currentRound },
	                    'Read Prior Round Report'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Analyze and improve your decisions with concrete team reports.'
	              )
	            ),
	            _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 3 : 2
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/goals-and-targets?round=' + currentRound },
	                    'View Goals & Targets'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'View specific, attainable goals that drive your round decisions.'
	              )
	            ),
	            triviaCourseAvailable !== 0 && _react2.default.createElement(
	              SmallGoal,
	              { isGreyed: true },
	              _react2.default.createElement('img', { src: _smallCheckboxActive2.default, alt: 'small checkbox' }),
	              _react2.default.createElement(
	                SmallGoalTitle,
	                null,
	                _react2.default.createElement(
	                  SmallGoalTitleNum,
	                  null,
	                  currentRound > 1 ? 4 : 3
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Take a Trivia'
	                )
	              ),
	              _react2.default.createElement(
	                SmallGoalDescription,
	                null,
	                'Are you prepared for making new decisions? Take a trivia to assess.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NextStepsPage;
	}(_react.PureComponent);
	
	exports.default = NextStepsPage;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  overflow: hidden;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 59px;\n  left: 475px;\n  width: calc(100vw - 475px);\n  height: calc(100vh - 139px);\n  overflow: hidden;\n'], ['\n  position: absolute;\n  top: 59px;\n  left: 475px;\n  width: calc(100vw - 475px);\n  height: calc(100vh - 139px);\n  overflow: hidden;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 30%;\n  left: 50%;\n'], ['\n  position: absolute;\n  top: 30%;\n  left: 50%;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc(30% + 59px);\n  left: calc(50% + 130px);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding: 10px 20px;\n  background: #FFBABA;\n  border: 1px solid #D8000C;\n  border-radius: 8px;\n  z-index: 3000;\n'], ['\n  position: absolute;\n  top: calc(30% + 59px);\n  left: calc(50% + 130px);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding: 10px 20px;\n  background: #FFBABA;\n  border: 1px solid #D8000C;\n  border-radius: 8px;\n  z-index: 3000;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n'], ['\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n'], ['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  margin: 0;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  margin: 0;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n  margin-top: 24px;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n'], ['\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n  margin-top: 24px;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _tracksCache = __webpack_require__(263);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Pagination = __webpack_require__(584);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _CopiedMessage = __webpack_require__(1215);
	
	var _CopiedMessage2 = _interopRequireDefault(_CopiedMessage);
	
	var _Page = __webpack_require__(583);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Step = __webpack_require__(1229);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _Round1Checklist = __webpack_require__(585);
	
	var _Round1Checklist2 = _interopRequireDefault(_Round1Checklist);
	
	var _RoundChecklist = __webpack_require__(1228);
	
	var _RoundChecklist2 = _interopRequireDefault(_RoundChecklist);
	
	var _TeamsAndCompetitions = __webpack_require__(1219);
	
	var _TeamsAndCompetitions2 = _interopRequireDefault(_TeamsAndCompetitions);
	
	var _whatToExpect = __webpack_require__(586);
	
	var _NextSteps = __webpack_require__(1216);
	
	var _NextSteps2 = _interopRequireDefault(_NextSteps);
	
	var _ConfettiExplosion = __webpack_require__(582);
	
	var _ConfettiExplosion2 = _interopRequireDefault(_ConfettiExplosion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var LoaderWrapper = _styledComponents2.default.div(_templateObject3);
	
	var ConfettiWrapper = _styledComponents2.default.div(_templateObject4);
	
	var ConfettiPosition = _styledComponents2.default.div(_templateObject5);
	
	var ErrorMessage = _styledComponents2.default.div(_templateObject6);
	
	/* Full-screen dim backdrop below the topbar. Topbar stays visible
	   and clickable (logout works). No dismiss — student can only leave
	   by logging out. */
	var LockedBackdrop = _styledComponents2.default.div(_templateObject7);
	
	var LockedCard = _styledComponents2.default.div(_templateObject8);
	
	var LockedMessage = _styledComponents2.default.div(_templateObject9);
	
	var LockedLogoutButton = _styledComponents2.default.button(_templateObject10);
	
	var OnboardingPage = function (_Component) {
	  _inherits(OnboardingPage, _Component);
	
	  function OnboardingPage(props) {
	    _classCallCheck(this, OnboardingPage);
	
	    var _this = _possibleConstructorReturn(this, (OnboardingPage.__proto__ || Object.getPrototypeOf(OnboardingPage)).call(this, props));
	
	    _this.setFetchData = function (isFetchData) {
	      _this.setState({
	        isFetchData: isFetchData
	      });
	    };
	
	    _this.showConfetti = function () {
	      _this.setState({
	        showConfetti: true
	      }, function () {
	        setTimeout(function () {
	          _this.setState({
	            showConfetti: false
	          });
	        }, 5000);
	      });
	    };
	
	    _this.showIncorrectMessage = function () {
	      _this.setState({
	        showIncorrectMessage: true
	      }, function () {
	        setTimeout(function () {
	          _this.setState({
	            showIncorrectMessage: false
	          });
	        }, 5000);
	      });
	    };
	
	    _this.loadNavigation = function (callback) {
	      var _this$props = _this.props,
	          location = _this$props.location,
	          roundInUrl = _this$props.roundInUrl,
	          currentRound = _this$props.currentRound;
	      // Resolve `round` to a NUMBER before comparing with `=== 1`. The
	      // sources arrive in mixed types:
	      //   - location.query.round → string (React Router 3 raw query)
	      //   - roundInUrl prop      → string (App.js reads it raw, not
	      //                            parsed — see App.js state init)
	      //   - currentRound prop    → number
	      // Coerce first, then fall back through the chain so any entry
	      // point (deep link, sidebar click, redirect) resolves the same
	      // way. Skipping the coercion previously caused Round 1 to land
	      // on the rounds-2+ checklist because `"1" === 1` is false.
	
	      var round = null;
	      if (location && location.query && location.query.round) {
	        var parsed = parseInt(location.query.round, 10);
	        if (!isNaN(parsed)) round = parsed;
	      }
	      if (round == null && roundInUrl != null) {
	        var _parsed = parseInt(roundInUrl, 10);
	        if (!isNaN(_parsed)) round = _parsed;
	      }
	      if (round == null) {
	        round = currentRound;
	      }
	
	      {
	        // Round 1 lands students on Round1Checklist (specific to
	        // first round). Rounds 2+ use the shared RoundChecklist
	        // which adapts its substeps based on round + active targets.
	        // The legacy WelcomeStep1 file is kept in the repo but is
	        // no longer mounted.
	        var stepsWelcome = round === 1 ? [{ component: _Round1Checklist2.default, alias: 'intro' }] : [{ component: _RoundChecklist2.default, alias: '' }];
	
	        var tempPages = [{
	          title: 'Welcome',
	          alias: 'welcome',
	          steps: stepsWelcome
	        }];
	        if (round === 1) {
	          tempPages.push({
	            title: 'Teams & Competitions',
	            alias: 'teams-and-competitions',
	            steps: [{ component: _TeamsAndCompetitions2.default, alias: '' }]
	          });
	        }
	
	        if (round > 3) {
	          tempPages.push({
	            title: 'What to Expect',
	            alias: '',
	            hasChilds: true,
	            steps: [{ alias: '' }]
	          }, {
	            title: 'Customer Preferences',
	            alias: 'customer-preferences',
	            subpage: true,
	            steps: [{ component: _whatToExpect.CustomerPreferences, alias: '' }]
	          });
	          if (round === 2) {
	            tempPages.push({
	              title: 'Product Strategy',
	              alias: 'product-strategy',
	              subpage: true,
	              steps: [{ component: _whatToExpect.ProductStrategy, alias: '' }]
	            }, {
	              title: 'Machine Options',
	              alias: 'machine-options',
	              subpage: true,
	              steps: [{ component: _whatToExpect.MachineOptions, alias: '' }]
	            }, {
	              title: 'Distribution Centers',
	              alias: 'distribution-centers',
	              subpage: true,
	              steps: [{ component: _whatToExpect.DistributionCenters, alias: '' }]
	            });
	          }
	
	          if (round === 3) {
	            tempPages.push({
	              title: 'Share Buyback',
	              alias: 'share-buyback',
	              subpage: true,
	              steps: [{ component: _whatToExpect.ShareBuyback, alias: '' }]
	            }, {
	              title: 'New Metric: ROE',
	              alias: 'new-metric-roe',
	              subpage: true,
	              steps: [{ component: _whatToExpect.NewMetricROE, alias: '' }]
	            }, {
	              title: 'New Metric: ROA',
	              alias: 'new-metric-roa',
	              subpage: true,
	              steps: [{ component: _whatToExpect.NewMetricROA, alias: '' }]
	            }, {
	              title: 'Conduct Research',
	              alias: 'conduct-research',
	              subpage: true,
	              steps: [{ component: _whatToExpect.ConductResearch, alias: '' }]
	            });
	          }
	
	          if (round === 4) {
	            tempPages.push({
	              title: 'New Metric: EPS',
	              alias: 'new-metric-eps',
	              subpage: true,
	              steps: [{ component: _whatToExpect.NewMetricEPS, alias: '' }]
	            }, {
	              title: 'Conduct Research',
	              alias: 'conduct-research',
	              subpage: true,
	              steps: [{ component: _whatToExpect.ConductResearch, alias: '' }]
	            });
	          }
	        }
	
	        tempPages.push({
	          title: 'Next Steps',
	          alias: 'next-steps',
	          steps: [{ component: _NextSteps2.default, alias: '' }]
	        });
	
	        _this.setState({
	          pages: tempPages,
	          navigationLoaded: true
	        }, function () {
	          if (callback) {
	            callback();
	          }
	        });
	      }
	    };
	
	    _this.getLastNotFinishedPage = function (trackedPages, pages) {
	      var prevPage = 0;
	      var prevStep = 0;
	      for (var pageNum = 0; pageNum < pages.length; pageNum++) {
	        var _loop = function _loop(stepNum) {
	          var pageAlias = pages[pageNum].alias;
	          var stepAlias = pages[pageNum].steps[stepNum].alias;
	
	          if (pageAlias === '' && stepAlias === '') {
	            return 'continue';
	          }
	
	          var foundPage = trackedPages.find(function (i) {
	            return i[0] === pageAlias && i[1] === stepAlias;
	          });
	          if (!foundPage) {
	            return {
	              v: {
	                page: prevPage,
	                step: prevStep
	              }
	            };
	          }
	
	          prevPage = pageNum;
	          prevStep = stepNum;
	        };
	
	        for (var stepNum = 0; stepNum < pages[pageNum].steps.length; stepNum++) {
	          var _ret = _loop(stepNum);
	
	          switch (_ret) {
	            case 'continue':
	              continue;
	
	            default:
	              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	          }
	        }
	      }
	
	      return {
	        page: prevPage,
	        step: prevStep
	      };
	    };
	
	    _this.trackPage = function (url, page, step) {
	      var currentRound = _this.activeRound;
	
	      var user_id = Number(_Auth2.default.getUserId());
	      var round_number = Number(currentRound);
	      var game_id = Number(_Auth2.default.getGameId());
	      var course_id = Number(_Auth2.default.getCourseId());
	      (0, _tracksCache.fetchTracks)({ gameId: game_id, courseId: course_id, userId: user_id, roundNumber: round_number }).then(function (res) {
	        var current_page = window.location.protocol + '//' + window.location.host + url;
	
	        var history = res.body.results.filter(function (i) {
	          return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/onboarding/');
	        }).map(function (i) {
	          return i.page.replace(window.location.protocol + '//' + window.location.host + '/onboarding/', '');
	        });
	        var trackedPage = res.body.results.find(function (i) {
	          return i.page === current_page;
	        });
	
	        (0, _Location.changeLocation)(url + '?round=' + currentRound);
	
	        if (!trackedPage) {
	          (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').send({
	            page: current_page,
	            user: user_id,
	            course: course_id,
	            game: game_id,
	            round_number: round_number
	          }).then(function (data) {
	            (0, _tracksCache.invalidateTracks)();
	            _this.setState({
	              history: [].concat(_toConsumableArray(history), ['' + page + (step !== '' ? '/' + step : '')])
	            });
	          });
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.goNext = function (e) {
	      e.preventDefault();
	
	      var _this$state = _this.state,
	          pages = _this$state.pages,
	          currentPage = _this$state.currentPage,
	          currentStep = _this$state.currentStep;
	
	
	      var nextPage = currentPage;
	      var nextStep = currentStep + 1;
	      if (nextStep > pages[nextPage].steps.length - 1) {
	        nextPage = currentPage + 1;
	        nextStep = 0;
	
	        if (nextPage > pages.length - 1) {
	          return;
	        }
	      }
	
	      if (pages[nextPage].hasChilds) {
	        nextPage += 1;
	      }
	
	      var page = pages[nextPage].alias;
	      var step = pages[nextPage].steps[nextStep].alias;
	
	      _this.trackPage('/onboarding/' + page + (step !== '' ? '/' + step : ''), page, step);
	
	      _this.setState({
	        currentPage: nextPage,
	        currentStep: nextStep,
	        showIncorrectMessage: false
	      });
	    };
	
	    _this.goPrev = function (e) {
	      e.preventDefault();
	
	      var _this$state2 = _this.state,
	          pages = _this$state2.pages,
	          currentPage = _this$state2.currentPage,
	          currentStep = _this$state2.currentStep;
	
	
	      var prevPage = currentPage;
	      var prevStep = currentStep - 1;
	      if (prevStep < 0) {
	        prevPage = currentPage - 1;
	        if (prevPage < 0) {
	          return;
	        }
	
	        prevStep = pages[prevPage].steps.length - 1;
	      }
	
	      if (pages[prevPage].hasChilds) {
	        prevPage -= 1;
	      }
	
	      var page = pages[prevPage].alias;
	      var step = pages[prevPage].steps[prevStep].alias;
	
	      (0, _Location.changeLocation)('/onboarding/' + page + (step !== '' ? '/' + step : '') + '?round=' + _this.activeRound);
	
	      _this.setState({
	        currentPage: prevPage,
	        currentStep: prevStep
	      });
	    };
	
	    _this.onValidate = function (e) {
	      e.preventDefault();
	
	      var validateCallback = _this.state.validateCallback;
	
	
	      if (validateCallback) {
	        validateCallback();
	      }
	    };
	
	    _this.setMode = function (mode) {
	      var validateCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (['basic', 'disabled', 'validate', 'loading'].includes(mode) && mode !== _this.state.mode) {
	        _this.setState({
	          mode: mode,
	          validateCallback: validateCallback
	        });
	      }
	    };
	
	    _this.showMessage = function () {
	      _this.setState({
	        showMessage: true
	      }, function () {
	        setTimeout(function () {
	          _this.setState({
	            showMessage: false
	          });
	        }, 5000);
	      });
	    };
	
	    _this.state = {
	      loading: false,
	      pages: [{
	        title: 'Welcome',
	        alias: 'welcome',
	        steps: [{ component: _Step2.default, alias: '' }]
	      }],
	      currentPage: -2,
	      currentStep: -2,
	      mode: 'basic', // basic | disabled | validate | loading
	      showMessage: false,
	      validateCallback: null,
	      history: [],
	      showConfetti: false,
	      isFetchData: false,
	      showIncorrectMessage: false,
	      navigationLoaded: false
	    };
	    return _this;
	  }
	
	  _createClass(OnboardingPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // In the locked "no game yet" state we render a static message
	      // only — skip the navigation/data fetch which would 404 or return
	      // empty since the student has no game.
	      if (this.props.noGameYet) return;
	      this.loadNavigation(function () {
	        _this2.getCurrentPage();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var navigationLoaded = this.state.navigationLoaded;
	
	
	      if (navigationLoaded === true) {
	        this.getCurrentPage();
	      }
	    }
	  }, {
	    key: 'getCurrentPage',
	    value: function getCurrentPage() {
	      var _this3 = this;
	
	      var location = this.props.location;
	      var pages = this.state.pages;
	
	      var currentRound = this.activeRound;
	
	      var pathes = location.pathname.substring(1).split('/');
	
	      var currentPage = 0;
	      var currentStep = 0;
	      var doRedirect = true;
	      if (pathes.length > 1) {
	        currentPage = -1;
	        currentStep = -1;
	        doRedirect = false;
	
	        var category = pages.findIndex(function (i) {
	          return i.alias === pathes[1];
	        });
	        if (category > -1) {
	          if (pathes.length === 3) {
	            var step = pages[category].steps.findIndex(function (i) {
	              return i.alias === pathes[2];
	            });
	            if (step > -1) {
	              currentPage = category;
	              currentStep = step;
	            }
	          } else {
	            currentPage = category;
	            currentStep = 0;
	          }
	        }
	
	        if (currentPage !== this.state.currentPage || currentStep !== this.state.currentStep) {
	          this.setState({
	            loading: true,
	            currentPage: currentPage,
	            currentStep: currentStep
	          });
	
	          var user_id = Number(_Auth2.default.getUserId());
	          var round_number = Number(currentRound);
	          var game_id = Number(_Auth2.default.getGameId());
	          var course_id = Number(_Auth2.default.getCourseId());
	          (0, _tracksCache.fetchTracks)({ gameId: game_id, courseId: course_id, userId: user_id, roundNumber: round_number }).then(function (res) {
	            var history = res.body.results.filter(function (i) {
	              return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/onboarding/');
	            }).map(function (i) {
	              return i.page.replace(window.location.protocol + '//' + window.location.host + '/onboarding/', '');
	            });
	
	            _this3.setState({
	              loading: false,
	              history: history
	            }, function () {
	              if (doRedirect) {
	                var page = pages[currentPage].alias;
	                var _step = pages[currentPage].steps[currentStep].alias;
	
	                (0, _Location.changeLocation)('/onboarding/' + page + (_step !== '' ? '/' + _step : '') + '?round=' + currentRound);
	              }
	            });
	          }).catch(function (err) {});
	        }
	      } else {
	        if (this.state.loading !== true) {
	          this.setState({
	            loading: true
	          });
	
	          var _user_id = Number(_Auth2.default.getUserId());
	          var _round_number = Number(currentRound);
	          var _game_id = Number(_Auth2.default.getGameId());
	          var _course_id = Number(_Auth2.default.getCourseId());
	          (0, _tracksCache.fetchTracks)({ gameId: _game_id, courseId: _course_id, userId: _user_id, roundNumber: _round_number }).then(function (res) {
	            var history = res.body.results.filter(function (i) {
	              return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/onboarding/');
	            }).map(function (i) {
	              return i.page.replace(window.location.protocol + '//' + window.location.host + '/onboarding/', '');
	            });
	
	            // The old behavior on a bare /onboarding URL was to use
	            // tracks history to find the "last not finished page",
	            // which landed students on Next Steps once they'd been
	            // through the flow. With the consolidated checklist we
	            // always want the leftbar Welcome link to open the
	            // checklist, so we leave currentPage/currentStep at 0/0
	            // (= Welcome's first step) regardless of tracks state.
	
	            if (doRedirect) {
	              var page = pages[currentPage].alias;
	              var _step2 = pages[currentPage].steps[currentStep].alias;
	
	              if (currentPage === 0 && currentStep === 0 && !history.includes('' + page + (_step2 !== '' ? '/' + _step2 : ''))) {
	                (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').send({
	                  page: window.location.protocol + '//' + window.location.host + '/onboarding/' + page + (_step2 !== '' ? '/' + _step2 : ''),
	                  user: _Auth2.default.getUserId(),
	                  course: _Auth2.default.getCourseId(),
	                  game: _Auth2.default.getGameId(),
	                  round_number: currentRound
	                }).then(function (data) {
	                  // New tracks entry — drop the cache so the next
	                  // read picks it up.
	                  (0, _tracksCache.invalidateTracks)();
	                  history = [].concat(_toConsumableArray(history), ['' + page + (_step2 !== '' ? '/' + _step2 : '')]);
	
	                  _this3.setState({
	                    history: history
	                  });
	                });
	              }
	              (0, _Location.changeLocation)('/onboarding/' + page + (_step2 !== '' ? '/' + _step2 : '') + '?round=' + currentRound);
	            }
	
	            _this3.setState({
	              loading: false,
	              currentPage: currentPage,
	              currentStep: currentStep,
	              history: history
	            });
	          }).catch(function (err) {
	            console.log(err);
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Locked "Waiting on Instructor" state: student is authenticated
	      // but no game exists for the picked course yet. Renders as a
	      // popup card centered over a fixed dim backdrop that covers
	      // everything below the topbar. Topbar stays visible and
	      // clickable so logout is reachable. No dismiss affordance.
	      if (this.props.noGameYet) {
	        // Skeleton Welcome page renders behind the dim backdrop so
	        // students see the shape of the app they'll enter once the
	        // instructor sets up the exercise. Real Welcome components
	        // (Round1Checklist etc.) require game/round data that isn't
	        // available yet — we render static placeholder blocks
	        // instead. Popup + Log Out sit on top.
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: {
	                  flex: 1,
	                  minHeight: 'calc(100vh - 60px)',
	                  background: '#f5f6f7',
	                  padding: 40
	                } },
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    background: '#ffffff',
	                    borderRadius: 12,
	                    padding: '32px 40px',
	                    maxWidth: 900
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { style: {
	                      fontFamily: 'Mukta Vaani',
	                      fontWeight: 700,
	                      fontSize: 28,
	                      lineHeight: '36px',
	                      color: 'rgba(0, 27, 59, 0.94)',
	                      marginBottom: 24
	                    } },
	                  'Welcome'
	                ),
	                _react2.default.createElement('div', { style: { background: '#f0f2f4', height: 20, width: '55%', borderRadius: 4, marginBottom: 24 } }),
	                _react2.default.createElement('div', { style: { background: '#f0f2f4', height: 280, borderRadius: 12, marginBottom: 28 } }),
	                _react2.default.createElement('div', { style: { background: '#f0f2f4', height: 16, width: '82%', borderRadius: 4, marginBottom: 12 } }),
	                _react2.default.createElement('div', { style: { background: '#f0f2f4', height: 16, width: '76%', borderRadius: 4, marginBottom: 12 } }),
	                _react2.default.createElement('div', { style: { background: '#f0f2f4', height: 16, width: '68%', borderRadius: 4 } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            LockedBackdrop,
	            null,
	            _react2.default.createElement(
	              LockedCard,
	              null,
	              _react2.default.createElement(
	                LockedMessage,
	                null,
	                this.props.studentLockReason === 'round_not_started' ? 'Round Has Not Started Yet.' : 'Waiting on Instructor to set up exercise.'
	              ),
	              _react2.default.createElement(
	                LockedLogoutButton,
	                {
	                  type: 'button',
	                  onClick: function onClick() {
	                    if (_Auth2.default.isUserAuthenticated()) {
	                      _Auth2.default.deauthenticateUser();
	                    }
	                    (0, _Location.changeLocation)("/login");
	                  }
	                },
	                'Log Out'
	              )
	            )
	          )
	        );
	      }
	
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          currentStep = _state.currentStep,
	          pages = _state.pages,
	          mode = _state.mode,
	          showMessage = _state.showMessage,
	          loading = _state.loading,
	          history = _state.history,
	          showConfetti = _state.showConfetti,
	          isFetchData = _state.isFetchData,
	          showIncorrectMessage = _state.showIncorrectMessage;
	      var _props = this.props,
	          rounds = _props.rounds,
	          roundInUrl = _props.roundInUrl;
	
	      var currentRound = this.activeRound;
	      var ContentPage = loading ? null : currentPage > -1 && currentStep > -1 ? pages[currentPage].steps[currentStep].component : _Page2.default;
	      var data = loading ? null : currentPage > -1 && currentStep > -1 ? pages[currentPage].steps[currentStep].data || null : null;
	      var pageAlias = loading ? null : currentPage > -1 ? pages[currentPage].alias : null;
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        showConfetti && _react2.default.createElement(
	          ConfettiWrapper,
	          null,
	          _react2.default.createElement(
	            ConfettiPosition,
	            null,
	            _react2.default.createElement(_ConfettiExplosion2.default, {
	              force: 0.6,
	              duration: 3000,
	              particleCount: 100,
	              height: 1000,
	              width: 1000
	            })
	          )
	        ),
	        showIncorrectMessage && _react2.default.createElement(
	          ErrorMessage,
	          null,
	          'This is incorrect!'
	        ),
	        _react2.default.createElement(
	          Content,
	          null,
	          ContentPage && _react2.default.createElement(ContentPage, {
	            setMode: this.setMode,
	            showMessage: this.showMessage,
	            currentRound: currentRound,
	            rounds: rounds,
	            data: data,
	            stage: 'welcome',
	            showConfetti: this.showConfetti,
	            setFetchData: this.setFetchData,
	            isFetchData: isFetchData,
	            showIncorrectMessage: this.showIncorrectMessage,
	            roundInUrl: roundInUrl
	          }),
	          !ContentPage && _react2.default.createElement(
	            LoaderWrapper,
	            null,
	            _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	          ),
	          showMessage && _react2.default.createElement(_CopiedMessage2.default, null),
	          currentPage > -1 && currentStep > -1 && _react2.default.createElement(_Pagination2.default, {
	            currentStep: currentStep + 1,
	            countOfSteps: pages[currentPage].steps.length,
	            goNext: this.goNext,
	            goPrev: this.goPrev,
	            onValidate: this.onValidate,
	            isFirstStep: this.isFirstStep,
	            isLastStep: this.isLastStep,
	            isNextDisabled: mode === 'disabled',
	            isValidationMode: mode === 'validate',
	            isLoadingMode: mode === 'loading',
	            isTriviaPage: pageAlias === 'trivia'
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          roundInUrl = _props2.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          currentStep = _state2.currentStep;
	
	
	      return currentPage === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          pages = _state3.pages,
	          currentPage = _state3.currentPage,
	          currentStep = _state3.currentStep;
	
	
	      return currentPage === pages.length - 1 && currentStep === pages[pages.length - 1].steps.length - 1;
	    }
	  }]);
	
	  return OnboardingPage;
	}(_react.Component);
	
	exports.default = OnboardingPage;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  overflow: hidden;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 59px;\n  left: 210px;\n  width: calc(100vw - 210px);\n  height: calc(100vh - 139px);\n  overflow: hidden;\n'], ['\n  position: absolute;\n  top: 59px;\n  left: 210px;\n  width: calc(100vw - 210px);\n  height: calc(100vh - 139px);\n  overflow: hidden;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 30%;\n  left: 50%;\n'], ['\n  position: absolute;\n  top: 30%;\n  left: 50%;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc(30% + 59px);\n  left: calc(50%);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding: 10px 20px;\n  background: #FFBABA;\n  border: 1px solid #D8000C;\n  border-radius: 8px;\n  z-index: 3000;\n'], ['\n  position: absolute;\n  top: calc(30% + 59px);\n  left: calc(50%);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding: 10px 20px;\n  background: #FFBABA;\n  border: 1px solid #D8000C;\n  border-radius: 8px;\n  z-index: 3000;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _tracksCache = __webpack_require__(263);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _Pagination = __webpack_require__(584);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Page = __webpack_require__(583);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Intro = __webpack_require__(1224);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _SingleChoice = __webpack_require__(1226);
	
	var _SingleChoice2 = _interopRequireDefault(_SingleChoice);
	
	var _MultipleChoice = __webpack_require__(1225);
	
	var _MultipleChoice2 = _interopRequireDefault(_MultipleChoice);
	
	var _Formula = __webpack_require__(1222);
	
	var _Formula2 = _interopRequireDefault(_Formula);
	
	var _Formula3 = __webpack_require__(1223);
	
	var _Formula4 = _interopRequireDefault(_Formula3);
	
	var _Final = __webpack_require__(1221);
	
	var _Final2 = _interopRequireDefault(_Final);
	
	var _ConfettiExplosion = __webpack_require__(582);
	
	var _ConfettiExplosion2 = _interopRequireDefault(_ConfettiExplosion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var LoaderWrapper = _styledComponents2.default.div(_templateObject3);
	
	var ConfettiWrapper = _styledComponents2.default.div(_templateObject4);
	
	var ConfettiPosition = _styledComponents2.default.div(_templateObject5);
	
	var ErrorMessage = _styledComponents2.default.div(_templateObject6);
	
	var RoundTriviaPage = function (_Component) {
	  _inherits(RoundTriviaPage, _Component);
	
	  function RoundTriviaPage(props) {
	    _classCallCheck(this, RoundTriviaPage);
	
	    var _this = _possibleConstructorReturn(this, (RoundTriviaPage.__proto__ || Object.getPrototypeOf(RoundTriviaPage)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeRound = Number(props.roundInUrl || props.currentRound);
	    _this.state = {
	      loading: false,
	      pages: [{
	        title: 'Trivia: Round ' + activeRound,
	        alias: 'trivia',
	        steps: [{ component: _Intro2.default, alias: 'intro' }]
	      }],
	      currentPage: -2,
	      currentStep: -2,
	      mode: 'basic', // basic | disabled | validate | loading
	      validateCallback: null,
	      history: [],
	      showConfetti: false,
	      isFetchData: false,
	      showIncorrectMessage: false
	    };
	    return _this;
	  }
	
	  _createClass(RoundTriviaPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.loadNavigation(function () {
	        _this2.getCurrentPage();
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.getCurrentPage();
	    }
	  }, {
	    key: 'getCurrentPage',
	    value: function getCurrentPage() {
	      var _this3 = this;
	
	      var location = this.props.location;
	      var pages = this.state.pages;
	
	      var currentRound = this.activeRound;
	
	      var pathes = location.pathname.substring(1).split('/');
	
	      var currentPage = 0;
	      var currentStep = 0;
	      var doRedirect = true;
	      if (pathes.length > 1) {
	        currentPage = -1;
	        currentStep = -1;
	        doRedirect = false;
	
	        var category = pages.findIndex(function (i) {
	          return i.alias === pathes[1];
	        });
	        if (category > -1) {
	          if (pathes.length === 3) {
	            var step = pages[category].steps.findIndex(function (i) {
	              return i.alias === pathes[2];
	            });
	            if (step > -1) {
	              currentPage = category;
	              currentStep = step;
	            }
	          } else {
	            currentPage = category;
	            currentStep = 0;
	          }
	        }
	
	        if (currentPage !== this.state.currentPage || currentStep !== this.state.currentStep) {
	          this.setState({
	            loading: true,
	            currentPage: currentPage,
	            currentStep: currentStep
	          });
	
	          var user_id = Number(_Auth2.default.getUserId());
	          var round_number = Number(currentRound);
	          var game_id = Number(_Auth2.default.getGameId());
	          var course_id = Number(_Auth2.default.getCourseId());
	          (0, _tracksCache.fetchTracks)({ gameId: game_id, courseId: course_id, userId: user_id, roundNumber: round_number }).then(function (res) {
	            var history = res.body.results.filter(function (i) {
	              return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/round-trivia/');
	            }).map(function (i) {
	              return i.page.replace(window.location.protocol + '//' + window.location.host + '/round-trivia/', '');
	            });
	
	            _this3.setState({
	              loading: false,
	              history: history
	            }, function () {
	              if (doRedirect) {
	                var page = pages[currentPage].alias;
	                var _step = pages[currentPage].steps[currentStep].alias;
	
	                (0, _Location.changeLocation)('/round-trivia/' + page + (_step !== '' ? '/' + _step : '') + '?round=' + currentRound);
	              }
	            });
	          }).catch(function (err) {});
	        }
	      } else {
	        if (this.state.loading !== true) {
	          this.setState({
	            loading: true
	          });
	
	          var _user_id = Number(_Auth2.default.getUserId());
	          var _round_number = Number(currentRound);
	          var _game_id = Number(_Auth2.default.getGameId());
	          var _course_id = Number(_Auth2.default.getCourseId());
	          (0, _tracksCache.fetchTracks)({ gameId: _game_id, courseId: _course_id, userId: _user_id, roundNumber: _round_number }).then(function (res) {
	            var history = res.body.results.filter(function (i) {
	              return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/round-trivia/');
	            }).map(function (i) {
	              return i.page.replace(window.location.protocol + '//' + window.location.host + '/round-trivia/', '');
	            });
	            var trackedPages = res.body.results.filter(function (i) {
	              return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/round-trivia/');
	            }).map(function (i) {
	              return i.page.replace(window.location.protocol + '//' + window.location.host + '/round-trivia/', '').split('/');
	            }).map(function (i) {
	              return i.length === 2 ? i : [i[0], ''];
	            });
	
	            if (trackedPages.length > 0) {
	              var foundPage = _this3.getLastNotFinishedPage(trackedPages, pages);
	              if (foundPage) {
	                currentPage = foundPage.page;
	                currentStep = foundPage.step;
	              }
	            }
	
	            if (doRedirect) {
	              var page = pages[currentPage].alias;
	              var _step2 = pages[currentPage].steps[currentStep].alias;
	
	              if (currentPage === 0 && currentStep === 0 && !history.includes('' + page + (_step2 !== '' ? '/' + _step2 : ''))) {
	                (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').send({
	                  page: window.location.protocol + '//' + window.location.host + '/round-trivia/' + page + (_step2 !== '' ? '/' + _step2 : ''),
	                  user: _Auth2.default.getUserId(),
	                  course: _Auth2.default.getCourseId(),
	                  game: _Auth2.default.getGameId(),
	                  round_number: currentRound
	                }).then(function (data) {
	                  (0, _tracksCache.invalidateTracks)();
	                  history = [].concat(_toConsumableArray(history), ['' + page + (_step2 !== '' ? '/' + _step2 : '')]);
	
	                  _this3.setState({
	                    history: history
	                  });
	                });
	              }
	
	              (0, _Location.changeLocation)('/round-trivia/' + page + (_step2 !== '' ? '/' + _step2 : '') + '?round=' + currentRound);
	            }
	
	            _this3.setState({
	              loading: false,
	              currentPage: currentPage,
	              currentStep: currentStep,
	              history: history
	            });
	          }).catch(function (err) {});
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentPage = _state.currentPage,
	          currentStep = _state.currentStep,
	          pages = _state.pages,
	          mode = _state.mode,
	          loading = _state.loading,
	          showConfetti = _state.showConfetti,
	          isFetchData = _state.isFetchData,
	          showIncorrectMessage = _state.showIncorrectMessage;
	      var rounds = this.props.rounds;
	
	      var currentRound = this.activeRound;
	      var ContentPage = loading ? null : currentPage > -1 && currentStep > -1 ? pages[currentPage].steps[currentStep].component : _Page2.default;
	      var data = loading ? null : currentPage > -1 && currentStep > -1 ? pages[currentPage].steps[currentStep].data || null : null;
	      var pageAlias = loading ? null : currentPage > -1 ? pages[currentPage].alias : null;
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Content,
	          null,
	          ContentPage && _react2.default.createElement(ContentPage, {
	            setMode: this.setMode,
	            currentRound: currentRound,
	            rounds: rounds,
	            data: data,
	            stage: '' + currentRound,
	            showConfetti: this.showConfetti,
	            setFetchData: this.setFetchData,
	            isFetchData: isFetchData,
	            showIncorrectMessage: this.showIncorrectMessage
	          }),
	          showConfetti && _react2.default.createElement(
	            ConfettiWrapper,
	            null,
	            _react2.default.createElement(
	              ConfettiPosition,
	              null,
	              _react2.default.createElement(_ConfettiExplosion2.default, {
	                force: 0.6,
	                duration: 3000,
	                particleCount: 100,
	                height: 1000,
	                width: 1000
	              })
	            )
	          ),
	          showIncorrectMessage && _react2.default.createElement(
	            ErrorMessage,
	            null,
	            'This is incorrect!'
	          ),
	          !ContentPage && _react2.default.createElement(
	            LoaderWrapper,
	            null,
	            _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	          ),
	          currentPage > -1 && currentStep > -1 && _react2.default.createElement(_Pagination2.default, {
	            currentStep: currentStep + 1,
	            countOfSteps: pages[currentPage].steps.length,
	            goNext: this.goNext,
	            goPrev: this.goPrev,
	            onValidate: this.onValidate,
	            isFirstStep: this.isFirstStep,
	            isLastStep: this.isLastStep,
	            isNextDisabled: mode === 'disabled',
	            isValidationMode: mode === 'validate',
	            isLoadingMode: mode === 'loading',
	            isTriviaPage: pageAlias === 'trivia'
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          currentStep = _state2.currentStep;
	
	
	      return currentPage === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          pages = _state3.pages,
	          currentPage = _state3.currentPage,
	          currentStep = _state3.currentStep;
	
	
	      return currentPage === pages.length - 1 && currentStep === pages[pages.length - 1].steps.length - 1;
	    }
	  }]);
	
	  return RoundTriviaPage;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.setFetchData = function (isFetchData) {
	    _this4.setState({
	      isFetchData: isFetchData
	    });
	  };
	
	  this.loadNavigation = function (callback) {
	    var activeRound = _this4.activeRound;
	
	    (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/coursetrivias/', ("https://be-production-itb.marketgames.io/api/") + 'static/debt_clients/']).then(function (res) {
	      var userId = Number(_Auth2.default.getUserId());
	      var triviasRaw = res[0].body;
	      var stage = triviasRaw.results.find(function (i) {
	        return i.trivia.stage === '' + activeRound;
	      });
	      var triviaId = stage ? stage.id : 0;
	      var questions = stage ? stage.trivia.triviaquestions : [];
	      questions = (0, _orderBy2.default)(questions, ['list_order'], ['asc']);
	      for (var i = 0; i < questions.length; i++) {
	        questions[i].question.optionchoices = (0, _orderBy2.default)(questions[i].question.optionchoices, ['id'], ['asc']);
	      }
	
	      var debtClients = res[1].body;
	      var debtClient1 = debtClients.find(function (i) {
	        return i.id === 1;
	      });
	      var debtClientValue1 = debtClient1 ? (Number(debtClient1.lt_debt_to_capital) * 100).toFixed(0) + '%' : '';
	      var debtClient2 = debtClients.find(function (i) {
	        return i.id === 2;
	      });
	      var debtClientValue2 = debtClient2 ? (Number(debtClient2.lt_debt_to_capital) * 100).toFixed(0) + '%' : '';
	      var debtClient3 = debtClients.find(function (i) {
	        return i.id === 3;
	      });
	      var debtClientValue3 = debtClient3 ? (Number(debtClient3.lt_debt_to_capital) * 100).toFixed(0) + '%' : '';
	
	      var triviaSteps = [];
	      var counter = 0;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = questions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion = (_step3 = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var question = _step3.value;
	
	          counter++;
	          if (question.question.question_type === 'Single Choice') {
	            triviaSteps.push({
	              component: _SingleChoice2.default,
	              alias: 'question' + counter,
	              data: {
	                num: counter,
	                text: question.question.text,
	                choices: question.question.optionchoices,
	                questionId: question.id,
	                triviaId: triviaId,
	                userId: userId
	              }
	            });
	          } else if (question.question.question_type === 'Multiple Choice') {
	            triviaSteps.push({
	              component: _MultipleChoice2.default,
	              alias: 'question' + counter,
	              data: {
	                num: counter,
	                text: question.question.text,
	                choices: question.question.optionchoices,
	                questionId: question.id,
	                triviaId: triviaId,
	                userId: userId
	              }
	            });
	          } else if (question.question.question_type === 'Multiple Choice with Ordering' && [22, 38, 15].includes(question.question.id)) {
	            triviaSteps.push({
	              component: _Formula2.default,
	              alias: 'question' + counter,
	              data: {
	                num: counter,
	                text: question.question.text,
	                choices: question.question.optionchoices,
	                captions: question.question.id === 22 ? ['Assets', 'Liabilities', 'Equity'] : question.question.id === 38 ? ['Gross Profit Section', 'Operating Profit Section', 'Net Profit Section'] : [debtClientValue1, debtClientValue2, debtClientValue3],
	                questionId: question.id,
	                triviaId: triviaId,
	                userId: userId
	              }
	            });
	          } else if (question.question.question_type === 'Multiple Choice with Ordering' && [20, 37, 35, 36, 34, 28].includes(question.question.id)) {
	            triviaSteps.push({
	              component: _Formula4.default,
	              alias: 'question' + counter,
	              data: {
	                num: counter,
	                text: question.question.text,
	                choices: question.question.optionchoices,
	                caption: question.question.id === 20 ? 'Market Share' : [37, 35].includes(question.question.id) ? 'Return on Assets' : [36, 34].includes(question.question.id) ? 'Return on Equity' : 'Debt to Total Capital',
	                questionId: question.id,
	                triviaId: triviaId,
	                userId: userId
	              }
	            });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      _this4.setState({
	        pages: [{
	          title: 'Trivia: Round ' + activeRound,
	          alias: 'trivia',
	          steps: [{ component: _Intro2.default, alias: 'intro' }].concat(triviaSteps, [{ component: _Final2.default, alias: 'done' }])
	        }]
	      }, function () {
	        if (callback) {
	          callback();
	        }
	      });
	    }).catch(function (err) {});
	  };
	
	  this.showIncorrectMessage = function () {
	    _this4.setState({
	      showIncorrectMessage: true
	    }, function () {
	      setTimeout(function () {
	        _this4.setState({
	          showIncorrectMessage: false
	        });
	      }, 5000);
	    });
	  };
	
	  this.getLastNotFinishedPage = function (trackedPages, pages) {
	    var prevPage = 0;
	    var prevStep = 0;
	    for (var pageNum = 0; pageNum < pages.length; pageNum++) {
	      var _loop = function _loop(stepNum) {
	        var pageAlias = pages[pageNum].alias;
	        var stepAlias = pages[pageNum].steps[stepNum].alias;
	
	        var foundPage = trackedPages.find(function (i) {
	          return i[0] === pageAlias && i[1] === stepAlias;
	        });
	        if (!foundPage) {
	          return {
	            v: {
	              page: prevPage,
	              step: prevStep
	            }
	          };
	        }
	
	        prevPage = pageNum;
	        prevStep = stepNum;
	      };
	
	      for (var stepNum = 0; stepNum < pages[pageNum].steps.length; stepNum++) {
	        var _ret = _loop(stepNum);
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	    }
	
	    return {
	      page: prevPage,
	      step: prevStep
	    };
	  };
	
	  this.trackPage = function (url, page, step) {
	    var currentRound = _this4.activeRound;
	
	    var user_id = Number(_Auth2.default.getUserId());
	    var round_number = Number(currentRound);
	    var game_id = Number(_Auth2.default.getGameId());
	    var course_id = Number(_Auth2.default.getCourseId());
	    (0, _tracksCache.fetchTracks)({ gameId: game_id, courseId: course_id, userId: user_id, roundNumber: round_number }).then(function (res) {
	      var current_page = window.location.protocol + '//' + window.location.host + url;
	
	      var history = res.body.results.filter(function (i) {
	        return i.page.startsWith(window.location.protocol + '//' + window.location.host + '/round-trivia/');
	      }).map(function (i) {
	        return i.page.replace(window.location.protocol + '//' + window.location.host + '/round-trivia/', '');
	      });
	      var trackedPage = res.body.results.find(function (i) {
	        return i.page === current_page;
	      });
	
	      (0, _Location.changeLocation)(url + '?round=' + currentRound);
	
	      if (!trackedPage) {
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').send({
	          page: current_page,
	          user: user_id,
	          course: course_id,
	          game: game_id,
	          round_number: round_number
	        }).then(function (data) {
	          (0, _tracksCache.invalidateTracks)();
	          _this4.setState({
	            history: [].concat(_toConsumableArray(history), ['' + page + (step !== '' ? '/' + step : '')])
	          });
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  this.goNext = function (e) {
	    e.preventDefault();
	
	    var _state4 = _this4.state,
	        pages = _state4.pages,
	        currentPage = _state4.currentPage,
	        currentStep = _state4.currentStep;
	
	
	    var nextPage = currentPage;
	    var nextStep = currentStep + 1;
	    if (nextStep > pages[nextPage].steps.length - 1) {
	      nextPage = currentPage + 1;
	      nextStep = 0;
	
	      if (nextPage > pages.length - 1) {
	        return;
	      }
	    }
	
	    var page = pages[nextPage].alias;
	    var step = pages[nextPage].steps[nextStep].alias;
	
	    _this4.trackPage('/round-trivia/' + page + (step !== '' ? '/' + step : ''), page, step);
	
	    _this4.setState({
	      currentPage: nextPage,
	      currentStep: nextStep,
	      showIncorrectMessage: false
	    });
	  };
	
	  this.goPrev = function (e) {
	    e.preventDefault();
	
	    var _state5 = _this4.state,
	        pages = _state5.pages,
	        currentPage = _state5.currentPage,
	        currentStep = _state5.currentStep;
	
	
	    var prevPage = currentPage;
	    var prevStep = currentStep - 1;
	    if (prevStep < 0) {
	      prevPage = currentPage - 1;
	      if (prevPage < 0) {
	        return;
	      }
	
	      prevStep = pages[prevPage].steps.length - 1;
	    }
	
	    var page = pages[prevPage].alias;
	    var step = pages[prevPage].steps[prevStep].alias;
	
	    (0, _Location.changeLocation)('/round-trivia/' + page + (step !== '' ? '/' + step : '') + '?round=' + _this4.activeRound);
	
	    _this4.setState({
	      currentPage: prevPage,
	      currentStep: prevStep
	    });
	  };
	
	  this.onValidate = function (e) {
	    e.preventDefault();
	
	    var validateCallback = _this4.state.validateCallback;
	
	
	    if (validateCallback) {
	      validateCallback();
	    }
	  };
	
	  this.setMode = function (mode) {
	    var validateCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    if (['basic', 'disabled', 'validate', 'loading'].includes(mode) && mode !== _this4.state.mode) {
	      _this4.setState({
	        mode: mode,
	        validateCallback: validateCallback
	      });
	    }
	  };
	
	  this.showConfetti = function () {
	    _this4.setState({
	      showConfetti: true
	    }, function () {
	      setTimeout(function () {
	        _this4.setState({
	          showConfetti: false
	        });
	      }, 5000);
	    });
	  };
	};
	
	exports.default = RoundTriviaPage;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n  text-align: left;\n\n  .loader {\n    display: inline-block;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n  text-align: left;\n\n  .loader {\n    display: inline-block;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    font-weight: 500;\n    color: #ed716d;\n  }\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #5c91f5;\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    font-weight: 500;\n    color: #ed716d;\n  }\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #5c91f5;\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  display: block;\n  width: 372px;\n  height: 48px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 48px;\n  color: rgba(0, 27, 59, 0.6);\n  text-align: left;\n\n  padding: 0 84px 0 20px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n'], ['\n  display: block;\n  width: 372px;\n  height: 48px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 48px;\n  color: rgba(0, 27, 59, 0.6);\n  text-align: left;\n\n  padding: 0 84px 0 20px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n  border: 0;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  width: 64px;\n  height: 48px;\n  background: #5c91f5;\n  border-radius: 0 8px 8px 0;\n  align-items: center;\n  justify-content: center;\n  transition: background-color .4s ease-in-out;\n\n  &:hover {\n    cursor: pointer;\n    background-color: #74a1f6;\n  }\n'], ['\n  display: flex;\n  border: 0;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  width: 64px;\n  height: 48px;\n  background: #5c91f5;\n  border-radius: 0 8px 8px 0;\n  align-items: center;\n  justify-content: center;\n  transition: background-color .4s ease-in-out;\n\n  &:hover {\n    cursor: pointer;\n    background-color: #74a1f6;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  text-align: right;\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #5c91f5;\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n'], ['\n  margin-top: 24px;\n  text-align: right;\n\n  a:active, a:visited, a:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #5c91f5;\n    text-decoration: none;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _onboardingCopy = __webpack_require__(1061);
	
	var _onboardingCopy2 = _interopRequireDefault(_onboardingCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable jsx-a11y/anchor-is-valid */
	
	
	var dummyClick = function dummyClick(e) {
	  e.preventDefault();
	};
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Text3 = _styledComponents2.default.div(_templateObject4);
	
	var TeamPlayers = _styledComponents2.default.div(_templateObject5);
	
	var TeamPlayer = _styledComponents2.default.div(_templateObject6);
	
	var TeamPlayerName = _styledComponents2.default.div(_templateObject7);
	
	var TeamPlayerEmail = _styledComponents2.default.div(_templateObject8);
	
	var CopyButton = _styledComponents2.default.button(_templateObject9);
	
	var CopyAll = _styledComponents2.default.div(_templateObject10);
	
	var TeamsAndCompetitionsStep = function (_PureComponent) {
	  _inherits(TeamsAndCompetitionsStep, _PureComponent);
	
	  function TeamsAndCompetitionsStep(props) {
	    _classCallCheck(this, TeamsAndCompetitionsStep);
	
	    var _this = _possibleConstructorReturn(this, (TeamsAndCompetitionsStep.__proto__ || Object.getPrototypeOf(TeamsAndCompetitionsStep)).call(this, props));
	
	    _this.copyToClipboard = function (email) {
	      navigator.clipboard.writeText(email);
	
	      _this.props.showMessage();
	    };
	
	    _this.copyAllEmails = function (e) {
	      e.preventDefault();
	
	      var teammates = _this.state.teammates;
	
	
	      _this.copyToClipboard(teammates.map(function (i) {
	        return i.email;
	      }).join("\n"));
	    };
	
	    _this.state = {
	      loading: true,
	      countOfTeams: 0,
	      teammates: []
	    };
	    return _this;
	  }
	
	  _createClass(TeamsAndCompetitionsStep, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.props.setMode('basic');
	
	      var currentTeam = _Teams2.default.currentTeam();
	      var teamID = Number(currentTeam.id);
	      var competitionID = Number(currentTeam.competition);
	
	      (0, _ApiService.batchRequest)([(0, _Teams.teamsEndpoint)(), ("https://be-production-itb.marketgames.io/api/") + 'v2/games/teamplayers/?game=' + _Auth2.default.getGameId()]).then(function (res) {
	        var body1 = res[0].body;
	        var teams = body1.filter(function (i) {
	          return Number(i.competition) === competitionID;
	        }).filter(function (i) {
	          return Number(i.id) !== teamID;
	        });
	        var countOfTeams = teams.length;
	
	        var body2 = res[1].body;
	        var teammates = body2.results.map(function (i) {
	          return {
	            fullname: i.user.first_name + ' ' + i.user.last_name,
	            email: i.user.email
	          };
	        });
	
	        _this2.setState({
	          loading: false,
	          countOfTeams: countOfTeams,
	          teammates: teammates
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          countOfTeams = _state.countOfTeams,
	          teammates = _state.teammates;
	
	
	      return loading ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          'Teams & Competitions'
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          'Your team will compete with ',
	          countOfTeams,
	          ' other teams'
	        ),
	        _react2.default.createElement(
	          Text3,
	          null,
	          'It is recommended to arrange ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'a kickoff meeting'
	          ),
	          ' with your team before the game officially starts. You can also find your teammates\' information on ',
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: dummyClick },
	            'Team Profile'
	          ),
	          ' page.'
	        ),
	        _react2.default.createElement(
	          TeamPlayers,
	          null,
	          teammates.map(function (_ref, index) {
	            var fullname = _ref.fullname,
	                email = _ref.email;
	            return _react2.default.createElement(
	              TeamPlayer,
	              { key: index },
	              _react2.default.createElement(
	                TeamPlayerName,
	                null,
	                fullname
	              ),
	              _react2.default.createElement(
	                TeamPlayerEmail,
	                null,
	                email,
	                _react2.default.createElement(
	                  CopyButton,
	                  { onClick: function onClick() {
	                      return _this3.copyToClipboard(email);
	                    } },
	                  _react2.default.createElement('img', { src: _onboardingCopy2.default, alt: '' })
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          CopyAll,
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#', onClick: this.copyAllEmails },
	            'Copy All Emails'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamsAndCompetitionsStep;
	}(_react.PureComponent);
	
	exports.default = TeamsAndCompetitionsStep;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _round = __webpack_require__(2052);
	
	var _round2 = _interopRequireDefault(_round);
	
	var _utils = __webpack_require__(1227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ROTATION_SPEED_MIN = 200; // minimum possible duration of single particle full rotation
	var ROTATION_SPEED_MAX = 800; // maximum possible duration of single particle full rotation
	var CRAZY_PARTICLES_FREQUENCY = 0.1; // 0-1 frequency of crazy curvy unpredictable particles
	var CRAZY_PARTICLE_CRAZINESS = 0.3; // 0-1 how crazy these crazy particles are
	var BEZIER_MEDIAN = 0.5; // utility for mid-point bezier curves, to ensure smooth motion paths
	
	var rotationKeyframes = _utils.rotationTransforms.reduce(function (acc, xyz, i) {
	  return Object.assign({}, acc, _defineProperty({}, 'rotation-' + i, {
	    transform: 'rotate3d(' + xyz.join() + ', 360deg)'
	  }));
	}, {});
	
	var confettiKeyframes = function confettiKeyframes(degrees, height, width) {
	  var xLandingPoints = degrees.reduce(function (acc, degree, i) {
	    var landingPoint = (0, _utils.mapRange)(Math.abs((0, _utils.rotate)(degree, 90) - 180), 0, 180, -width / 2, width / 2);
	    return Object.assign({}, acc, _defineProperty({}, 'x-axis-' + i, {
	      transform: 'translateX(' + landingPoint + 'px)'
	    }));
	  }, {});
	
	  return Object.assign({
	    'y-axis': {
	      transform: 'translateY(' + height + 'px)'
	    }
	  }, xLandingPoints);
	};
	
	var confettoStyle = function confettoStyle(particle, duration, force, size, i) {
	  var rotation = Math.random() * (ROTATION_SPEED_MAX - ROTATION_SPEED_MIN) + ROTATION_SPEED_MIN;
	  var rotationIndex = Math.round(Math.random() * (_utils.rotationTransforms.length - 1));
	  var durationChaos = duration - Math.round(Math.random() * 1000);
	  var shouldBeCrazy = Math.random() < CRAZY_PARTICLES_FREQUENCY;
	  var isCircle = (0, _utils.shouldBeCircle)(rotationIndex);
	
	  // x-axis disturbance, roughly the distance the particle will initially deviate from its target
	  var x1 = shouldBeCrazy ? (0, _round2.default)(Math.random() * CRAZY_PARTICLE_CRAZINESS, 2) : 0;
	  var x2 = x1 * -1;
	  var x3 = x1;
	  // x-axis arc of explosion, so 90deg and 270deg particles have curve of 1, 0deg and 180deg have 0
	  var x4 = (0, _round2.default)(Math.abs((0, _utils.mapRange)(Math.abs((0, _utils.rotate)(particle.degree, 90) - 180), 0, 180, -1, 1)), 4);
	
	  // roughly how fast particle reaches end of its explosion curve
	  var y1 = (0, _round2.default)(Math.random() * BEZIER_MEDIAN, 4);
	  // roughly maps to the distance particle goes before reaching free-fall
	  var y2 = (0, _round2.default)(Math.random() * force * ((0, _utils.coinFlip)() ? 1 : -1), 4);
	  // roughly how soon the particle transitions from explosion to free-fall
	  var y3 = BEZIER_MEDIAN;
	  // roughly the ease of free-fall
	  var y4 = (0, _round2.default)(Math.max((0, _utils.mapRange)(Math.abs(particle.degree - 180), 0, 180, force, -force), 0), 4);
	
	  return _defineProperty({}, '&#confetti-particle-' + i, {
	    animation: 'x-axis-' + i + ' ' + durationChaos + 'ms forwards cubic-bezier(' + x1 + ', ' + x2 + ', ' + x3 + ', ' + x4 + ')',
	    '& > div': {
	      width: isCircle ? size : Math.round(Math.random() * 4) + size / 2,
	      height: isCircle ? size : Math.round(Math.random() * 2) + size,
	      animation: 'y-axis ' + durationChaos + 'ms forwards cubic-bezier(' + y1 + ', ' + y2 + ', ' + y3 + ', ' + y4 + ')',
	      '&:after': Object.assign({
	        backgroundColor: particle.color,
	        animation: 'rotation-' + rotationIndex + ' ' + rotation + 'ms infinite linear'
	      }, isCircle ? { borderRadius: '50%' } : {})
	    }
	  });
	};
	
	var useStyles = function useStyles(_ref2) {
	  var particles = _ref2.particles,
	      duration = _ref2.duration,
	      height = _ref2.height,
	      width = _ref2.width,
	      force = _ref2.force,
	      particleSize = _ref2.particleSize;
	
	  var confettiStyles = particles.reduce(function (acc, particle, i) {
	    return Object.assign({}, acc, confettoStyle(particle, duration, force, particleSize, i));
	  }, {});
	
	  return {
	    rotation: rotationKeyframes,
	    keyframes: confettiKeyframes(particles.map(function (particle) {
	      return particle.degree;
	    }), height, width),
	    particle: confettiStyles
	  };
	};
	
	exports.default = useStyles;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    font-weight: 500;\n    color: #ed716d;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    font-weight: 500;\n    color: #ed716d;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n  position: relative;\n\n  div.trivia-chart {\n    position: absolute;\n    top: 80px;\n    left: 505px;\n    width: 140px;\n    height: 140px;\n  }\n\n  div.trivia-amount {\n    position: absolute;\n    width: 140px;\n    height: 140px;\n    top: 80px;\n    left: 505px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 40px;\n    line-height: 48px;\n    color: rgba(0, 27, 59, 0.94);\n\n    span {\n      font-size: 18px;\n      line-height: 18px;\n      position: relative;\n      top: 7px;\n    }\n  }\n'], ['\n  display: flex;\n  margin-top: 12px;\n  position: relative;\n\n  div.trivia-chart {\n    position: absolute;\n    top: 80px;\n    left: 505px;\n    width: 140px;\n    height: 140px;\n  }\n\n  div.trivia-amount {\n    position: absolute;\n    width: 140px;\n    height: 140px;\n    top: 80px;\n    left: 505px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 40px;\n    line-height: 48px;\n    color: rgba(0, 27, 59, 0.94);\n\n    span {\n      font-size: 18px;\n      line-height: 18px;\n      position: relative;\n      top: 7px;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _recharts = __webpack_require__(27);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _onboardingTriviaFinal = __webpack_require__(2641);
	
	var _onboardingTriviaFinal2 = _interopRequireDefault(_onboardingTriviaFinal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Text3 = _styledComponents2.default.div(_templateObject4);
	
	var Image = _styledComponents2.default.div(_templateObject5);
	
	var TriviaFinal = function (_PureComponent) {
	  _inherits(TriviaFinal, _PureComponent);
	
	  function TriviaFinal(props) {
	    _classCallCheck(this, TriviaFinal);
	
	    var _this = _possibleConstructorReturn(this, (TriviaFinal.__proto__ || Object.getPrototypeOf(TriviaFinal)).call(this, props));
	
	    _this.state = {
	      value: null
	    };
	    return _this;
	  }
	
	  _createClass(TriviaFinal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var stage = this.props.stage;
	
	
	      this.props.setMode('basic');
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/user-scores/' + _Auth2.default.getUserId() + '/').then(function (res) {
	        var value = null;
	        var key = stage === 'welcome' ? '0' : '' + stage;
	        if (res.body.stage_user_score && res.body.stage_user_score[key]) {
	          value = (Number(res.body.stage_user_score[key]) * 100).toFixed(2);
	        }
	
	        _this2.setState({
	          value: value
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var value = this.state.value;
	      var stage = this.props.stage;
	
	      var valueNumber = Number(value);
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          'Trivia: ',
	          stage === 'welcome' ? 'Warm Up' : 'Round ' + stage
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          'Well done!'
	        ),
	        _react2.default.createElement(
	          Text3,
	          null,
	          'You\'ve completed the first trivia. Don\'t worry if you feel new to the field. We will guide you through some fundamentals of the game next.'
	        ),
	        _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', { src: _onboardingTriviaFinal2.default, alt: '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'trivia-chart' },
	            _react2.default.createElement(
	              _recharts.PieChart,
	              { width: 140, height: 140, margin: { top: 0, right: 0, bottom: 0, left: 0 } },
	              _react2.default.createElement(
	                _recharts.Pie,
	                {
	                  dataKey: 'value',
	                  data: [{ name: 'Free', value: 100 - valueNumber }].concat(_toConsumableArray(valueNumber > 0 ? [{ name: 'Total', value: valueNumber }] : [])),
	                  cx: 70,
	                  cy: 70,
	                  innerRadius: 62,
	                  outerRadius: 70,
	                  cornerRadius: 8,
	                  fill: '#e3e3e3',
	                  startAngle: 90,
	                  endAngle: 450
	                },
	                _react2.default.createElement(_recharts.Cell, { fill: '#e3e3e3' }),
	                valueNumber > 0 && _react2.default.createElement(_recharts.Cell, { fill: '#a98df6' })
	              )
	            )
	          ),
	          value && _react2.default.createElement(
	            'div',
	            { className: 'trivia-amount' },
	            value.split('.')[0],
	            '.',
	            _react2.default.createElement(
	              'span',
	              null,
	              value.split('.')[1],
	              '%'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TriviaFinal;
	}(_react.PureComponent);
	
	exports.default = TriviaFinal;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 20px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 20px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  width: 210px;\n  height: 208px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 12px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 36px;\n'], ['\n  display: flex;\n  width: 210px;\n  height: 208px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 12px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 36px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding-top: 36px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  padding-top: 36px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 178px;\n  height: 96px;\n  background: #ffffff;\n  border: 1.5px dashed rgba(0, 27, 59, 0.6);\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n\n  ', '\n'], ['\n  width: 178px;\n  height: 96px;\n  background: #ffffff;\n  border: 1.5px dashed rgba(0, 27, 59, 0.6);\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n\n  ', '\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 16px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 16px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: block;\n  padding: 12px 20px 12px 24px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 6px 4px rgba(0, 0, 0, 0.08);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  position: relative;\n\n  ', '\n\n  ', '\n\n  img {\n    position: absolute;\n    top: 10px;\n    left: 4px;\n  }\n'], ['\n  display: block;\n  padding: 12px 20px 12px 24px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 6px 4px rgba(0, 0, 0, 0.08);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  position: relative;\n\n  ', '\n\n  ', '\n\n  img {\n    position: absolute;\n    top: 10px;\n    left: 4px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactDragtastic = __webpack_require__(983);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _onboardingGrip = __webpack_require__(1062);
	
	var _onboardingGrip2 = _interopRequireDefault(_onboardingGrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Items = _styledComponents2.default.div(_templateObject4);
	
	var Item = _styledComponents2.default.div(_templateObject5);
	
	var ItemCaption = _styledComponents2.default.div(_templateObject6);
	
	var ItemZone = _styledComponents2.default.div(_templateObject7, function (p) {
	  return p.isDropped && '\n    background: rgba(0, 27, 59, 0.08);\n  ';
	});
	
	var Options = _styledComponents2.default.div(_templateObject8);
	
	var Option = _styledComponents2.default.div(_templateObject9, function (p) {
	  return p.isHidden && '\n    opacity: 0;\n  ';
	}, function (p) {
	  return p.isDropped && '\n    box-shadow: none;\n    display: inline-block;\n    cursor: default;\n    font-size: 14px;\n    line-height: 14px;\n  ';
	});
	
	var TriviaFormula1 = function (_PureComponent) {
	  _inherits(TriviaFormula1, _PureComponent);
	
	  function TriviaFormula1(props) {
	    _classCallCheck(this, TriviaFormula1);
	
	    var _this = _possibleConstructorReturn(this, (TriviaFormula1.__proto__ || Object.getPrototypeOf(TriviaFormula1)).call(this, props));
	
	    _this.fetchData = function () {
	      var data = _this.props.data;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      _this.props.setMode('disabled');
	
	      _this.props.setFetchData(true);
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/triviaresponses/').then(function (res) {
	        var answer = res.body.results.find(function (i) {
	          return i.user === userId && i.trivia_question === questionId && i.course_trivia === triviaId;
	        });
	        var isReadOnly = !!answer;
	        var val1Choice = answer ? answer.pickedoptions.find(function (i) {
	          return i.order === 1;
	        }) : null;
	        var val1 = val1Choice ? val1Choice.option_choice : null;
	        var val2Choice = answer ? answer.pickedoptions.find(function (i) {
	          return i.order === 2;
	        }) : null;
	        var val2 = val2Choice ? val2Choice.option_choice : null;
	        var val3Choice = answer ? answer.pickedoptions.find(function (i) {
	          return i.order === 3;
	        }) : null;
	        var val3 = val3Choice ? val3Choice.option_choice : null;
	
	        if (isReadOnly) {
	          _this.props.setMode('basic');
	        }
	
	        _this.props.setFetchData(false);
	        _this.setState({
	          isReadOnly: isReadOnly,
	          val1: val1,
	          val2: val2,
	          val3: val3
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.onDrop1 = function (val) {
	      _this.setState({
	        val1: val
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDropOut1 = function () {
	      _this.setState({
	        val1: null
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDrop2 = function (val) {
	      _this.setState({
	        val2: val
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDropOut2 = function () {
	      _this.setState({
	        val2: null
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDrop3 = function (val) {
	      _this.setState({
	        val3: val
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDropOut3 = function () {
	      _this.setState({
	        val3: null
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.prevalidate = function () {
	      var _this$state = _this.state,
	          val1 = _this$state.val1,
	          val2 = _this$state.val2,
	          val3 = _this$state.val3;
	
	
	      if (!!val1 && !!val2 && !!val3) {
	        _this.props.setMode('validate', _this.validate);
	      } else {
	        _this.props.setMode('disabled');
	      }
	    };
	
	    _this.validate = function () {
	      var data = _this.props.data;
	      var _this$state2 = _this.state,
	          val1 = _this$state2.val1,
	          val2 = _this$state2.val2,
	          val3 = _this$state2.val3;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      _this.props.setMode('loading');
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/triviaresponses/').send({
	        user: userId,
	        trivia_question: questionId,
	        course_trivia: triviaId,
	        pickedoptions: [{ option_choice: val1, order: 1 }, { option_choice: val2, order: 2 }, { option_choice: val3, order: 3 }]
	      }).then(function (res) {
	        if (res.body.is_correct === 'Yes') {
	          _this.props.showConfetti();
	        } else {
	          _this.props.showIncorrectMessage();
	        }
	
	        _this.setState({
	          isReadOnly: true
	        });
	
	        _this.props.setMode('basic');
	      }).catch(function (err) {
	        _this.props.setMode('basic');
	      });
	    };
	
	    _this.state = {
	      val1: null,
	      val2: null,
	      val3: null,
	      isReadOnly: false
	    };
	    return _this;
	  }
	
	  _createClass(TriviaFormula1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.data.num !== prevProps.data.num) {
	        this.setState({
	          val1: null,
	          val2: null,
	          val3: null,
	          isReadOnly: false
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          val1 = _state.val1,
	          val2 = _state.val2,
	          val3 = _state.val3,
	          isReadOnly = _state.isReadOnly;
	      var _props = this.props,
	          data = _props.data,
	          stage = _props.stage,
	          isFetchData = _props.isFetchData;
	      var num = data.num,
	          text = data.text,
	          choices = data.choices,
	          captions = data.captions;
	
	
	      var val1Text = null;
	      if (val1) {
	        var val1Obj = choices.find(function (i) {
	          return i.id === val1;
	        });
	        val1Text = val1Obj ? val1Obj.text : null;
	      }
	
	      var val2Text = null;
	      if (val2) {
	        var val2Obj = choices.find(function (i) {
	          return i.id === val2;
	        });
	        val2Text = val2Obj ? val2Obj.text : null;
	      }
	
	      var val3Text = null;
	      if (val3) {
	        var val3Obj = choices.find(function (i) {
	          return i.id === val3;
	        });
	        val3Text = val3Obj ? val3Obj.text : null;
	      }
	
	      return isFetchData ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          'Trivia: ',
	          stage === 'welcome' ? 'Warm Up' : 'Round ' + stage
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          num,
	          '. ',
	          text
	        ),
	        _react2.default.createElement(
	          Items,
	          null,
	          _react2.default.createElement(
	            Item,
	            null,
	            _react2.default.createElement(
	              ItemCaption,
	              null,
	              captions[0]
	            ),
	            _react2.default.createElement(
	              _reactDragtastic.Droppable,
	              {
	                id: 'formula1',
	                accepts: 'formula',
	                onDrop: this.onDrop1,
	                onDragLeave: this.onDropOut1
	              },
	              function (_ref) {
	                var events = _ref.events,
	                    isOver = _ref.isOver;
	                return _react2.default.createElement(
	                  ItemZone,
	                  Object.assign({}, events, {
	                    isDropped: isOver || !!val1
	                  }),
	                  val1 && isReadOnly && _react2.default.createElement(
	                    Option,
	                    { isDropped: true },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    val1Text
	                  ),
	                  val1 && !isReadOnly && _react2.default.createElement(
	                    _reactDragtastic.Draggable,
	                    {
	                      id: 'choice-' + val1,
	                      type: 'formula',
	                      data: val1
	                    },
	                    function (_ref2) {
	                      var isActive = _ref2.isActive,
	                          events = _ref2.events;
	                      return _react2.default.createElement(
	                        Option,
	                        Object.assign({}, events, { isDropped: true, isHidden: isActive }),
	                        _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                        val1Text
	                      );
	                    }
	                  )
	                );
	              }
	            )
	          ),
	          _react2.default.createElement(
	            Item,
	            null,
	            _react2.default.createElement(
	              ItemCaption,
	              null,
	              captions[1]
	            ),
	            _react2.default.createElement(
	              _reactDragtastic.Droppable,
	              {
	                id: 'formula2',
	                accepts: 'formula',
	                onDrop: this.onDrop2,
	                onDragLeave: this.onDropOut2
	              },
	              function (_ref3) {
	                var events = _ref3.events,
	                    isOver = _ref3.isOver;
	                return _react2.default.createElement(
	                  ItemZone,
	                  Object.assign({}, events, {
	                    isDropped: isOver || !!val2
	                  }),
	                  val2 && isReadOnly && _react2.default.createElement(
	                    Option,
	                    { isDropped: true },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    val2Text
	                  ),
	                  val2 && !isReadOnly && _react2.default.createElement(
	                    _reactDragtastic.Draggable,
	                    {
	                      id: 'choice-' + val2,
	                      type: 'formula',
	                      data: val2
	                    },
	                    function (_ref4) {
	                      var isActive = _ref4.isActive,
	                          events = _ref4.events;
	                      return _react2.default.createElement(
	                        Option,
	                        Object.assign({}, events, { isDropped: true, isHidden: isActive }),
	                        _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                        val2Text
	                      );
	                    }
	                  )
	                );
	              }
	            )
	          ),
	          _react2.default.createElement(
	            Item,
	            null,
	            _react2.default.createElement(
	              ItemCaption,
	              null,
	              captions[2]
	            ),
	            _react2.default.createElement(
	              _reactDragtastic.Droppable,
	              {
	                id: 'formula3',
	                accepts: 'formula',
	                onDrop: this.onDrop3,
	                onDragLeave: this.onDropOut3
	              },
	              function (_ref5) {
	                var events = _ref5.events,
	                    isOver = _ref5.isOver;
	                return _react2.default.createElement(
	                  ItemZone,
	                  Object.assign({}, events, {
	                    isDropped: isOver || !!val3
	                  }),
	                  val3 && isReadOnly && _react2.default.createElement(
	                    Option,
	                    { isDropped: true },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    val3Text
	                  ),
	                  val3 && !isReadOnly && _react2.default.createElement(
	                    _reactDragtastic.Draggable,
	                    {
	                      id: 'choice-' + val3,
	                      type: 'formula',
	                      data: val3
	                    },
	                    function (_ref6) {
	                      var isActive = _ref6.isActive,
	                          events = _ref6.events;
	                      return _react2.default.createElement(
	                        Option,
	                        Object.assign({}, events, { isDropped: true, isHidden: isActive }),
	                        _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                        val3Text
	                      );
	                    }
	                  )
	                );
	              }
	            )
	          )
	        ),
	        !isReadOnly && _react2.default.createElement(
	          Options,
	          null,
	          choices.map(function (choice) {
	            return _react2.default.createElement(
	              _reactDotFragment2.default,
	              { key: 'choice-fragment-' + choice.id },
	              _react2.default.createElement(
	                _reactDragtastic.Draggable,
	                {
	                  id: 'choice-' + choice.id,
	                  type: 'formula',
	                  data: choice.id
	                },
	                function (_ref7) {
	                  var isActive = _ref7.isActive,
	                      events = _ref7.events;
	                  return _react2.default.createElement(
	                    Option,
	                    Object.assign({}, events, { isHidden: isActive || val1 === choice.id || val2 === choice.id || val3 === choice.id }),
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    choice.text
	                  );
	                }
	              ),
	              _react2.default.createElement(
	                _reactDragtastic.DragComponent,
	                { 'for': 'choice-' + choice.id },
	                function (_ref8) {
	                  var x = _ref8.x,
	                      y = _ref8.y;
	                  return _react2.default.createElement(
	                    Option,
	                    { style: {
	                        position: 'fixed',
	                        left: x - 20,
	                        top: y - 21,
	                        pointerEvents: 'none',
	                        zIndex: 2
	                      } },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    choice.text
	                  );
	                }
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return TriviaFormula1;
	}(_react.PureComponent);
	
	exports.default = TriviaFormula1;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 45px;\n'], ['\n  margin-top: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 45px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 150px;\n  height: 82px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #5c91f5;\n'], ['\n  width: 150px;\n  height: 82px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: #5c91f5;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 24px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 24px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  width: 200px;\n  height: 68px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1.5px dashed rgba(0, 27, 59, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ', '\n'], ['\n  width: 200px;\n  height: 68px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1.5px dashed rgba(0, 27, 59, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ', '\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 200px;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n'], ['\n  width: 200px;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 16px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 24px;\n  gap: 16px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  display: block;\n  padding: 12px 20px 12px 24px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 6px 4px rgba(0, 0, 0, 0.08);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  position: relative;\n\n  ', '\n\n  ', '\n\n  img {\n    position: absolute;\n    top: 10px;\n    left: 4px;\n  }\n'], ['\n  display: block;\n  padding: 12px 20px 12px 24px;\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 6px 4px rgba(0, 0, 0, 0.08);\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  position: relative;\n\n  ', '\n\n  ', '\n\n  img {\n    position: absolute;\n    top: 10px;\n    left: 4px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDragtastic = __webpack_require__(983);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _onboardingEqual = __webpack_require__(2639);
	
	var _onboardingEqual2 = _interopRequireDefault(_onboardingEqual);
	
	var _onboardingGrip = __webpack_require__(1062);
	
	var _onboardingGrip2 = _interopRequireDefault(_onboardingGrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Formula = _styledComponents2.default.div(_templateObject4);
	
	var Formula1 = _styledComponents2.default.div(_templateObject5);
	
	var Formula2 = _styledComponents2.default.div(_templateObject6);
	
	var Formula3 = _styledComponents2.default.div(_templateObject7, function (p) {
	  return p.isDropped && '\n    background: rgba(0, 27, 59, 0.08);\n  ';
	});
	
	var Formula4 = _styledComponents2.default.div(_templateObject8);
	
	var Options = _styledComponents2.default.div(_templateObject9);
	
	var Option = _styledComponents2.default.div(_templateObject10, function (p) {
	  return p.isHidden && '\n    opacity: 0;\n  ';
	}, function (p) {
	  return p.isDropped && '\n    box-shadow: none;\n    display: inline-block;\n    cursor: default;\n  ';
	});
	
	var TriviaFormula2 = function (_PureComponent) {
	  _inherits(TriviaFormula2, _PureComponent);
	
	  function TriviaFormula2(props) {
	    _classCallCheck(this, TriviaFormula2);
	
	    var _this = _possibleConstructorReturn(this, (TriviaFormula2.__proto__ || Object.getPrototypeOf(TriviaFormula2)).call(this, props));
	
	    _this.fetchData = function () {
	      var data = _this.props.data;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      _this.props.setMode('disabled');
	
	      _this.props.setFetchData(true);
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/triviaresponses/').then(function (res) {
	        var answer = res.body.results.find(function (i) {
	          return i.user === userId && i.trivia_question === questionId && i.course_trivia === triviaId;
	        });
	        var isReadOnly = !!answer;
	        var topChoice = answer ? answer.pickedoptions.find(function (i) {
	          return i.order === 1;
	        }) : null;
	        var top = topChoice ? topChoice.option_choice : null;
	        var bottomChoice = answer ? answer.pickedoptions.find(function (i) {
	          return i.order === 2;
	        }) : null;
	        var bottom = bottomChoice ? bottomChoice.option_choice : null;
	
	        if (isReadOnly) {
	          _this.props.setMode('basic');
	        }
	
	        _this.props.setFetchData(false);
	        _this.setState({
	          isReadOnly: isReadOnly,
	          top: top,
	          bottom: bottom
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.onDropTop = function (val) {
	      _this.setState({
	        top: val
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDropTopOut = function () {
	      _this.setState({
	        top: null
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDropBottom = function (val) {
	      _this.setState({
	        bottom: val
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.onDropBottomOut = function () {
	      _this.setState({
	        bottom: null
	      }, function () {
	        _this.prevalidate();
	      });
	    };
	
	    _this.prevalidate = function () {
	      var _this$state = _this.state,
	          top = _this$state.top,
	          bottom = _this$state.bottom;
	
	
	      if (!!top && !!bottom) {
	        _this.props.setMode('validate', _this.validate);
	      } else {
	        _this.props.setMode('disabled');
	      }
	    };
	
	    _this.validate = function () {
	      var data = _this.props.data;
	      var _this$state2 = _this.state,
	          top = _this$state2.top,
	          bottom = _this$state2.bottom;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      _this.props.setMode('loading');
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/triviaresponses/').send({
	        user: userId,
	        trivia_question: questionId,
	        course_trivia: triviaId,
	        pickedoptions: [{ option_choice: top, order: 1 }, { option_choice: bottom, order: 2 }]
	      }).then(function (res) {
	        if (res.body.is_correct === 'Yes') {
	          _this.props.showConfetti();
	        } else {
	          _this.props.showIncorrectMessage();
	        }
	
	        _this.setState({
	          isReadOnly: true
	        });
	
	        _this.props.setMode('basic');
	      }).catch(function (err) {
	        _this.props.setMode('basic');
	      });
	    };
	
	    _this.state = {
	      top: null,
	      bottom: null,
	      isReadOnly: false
	    };
	    return _this;
	  }
	
	  _createClass(TriviaFormula2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.data.num !== prevProps.data.num) {
	        this.setState({
	          top: null,
	          bottom: null,
	          isReadOnly: false
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          top = _state.top,
	          bottom = _state.bottom,
	          isReadOnly = _state.isReadOnly;
	      var _props = this.props,
	          data = _props.data,
	          stage = _props.stage,
	          isFetchData = _props.isFetchData;
	      var num = data.num,
	          text = data.text,
	          choices = data.choices,
	          caption = data.caption;
	
	      var topText = null;
	      if (top) {
	        var topObj = choices.find(function (i) {
	          return i.id === top;
	        });
	        topText = topObj ? topObj.text : null;
	      }
	
	      var bottomText = null;
	      if (bottom) {
	        var bottomObj = choices.find(function (i) {
	          return i.id === bottom;
	        });
	        bottomText = bottomObj ? bottomObj.text : null;
	      }
	
	      return isFetchData ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          'Trivia: ',
	          stage === 'welcome' ? 'Warm Up' : 'Round ' + stage
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          num,
	          '. ',
	          text
	        ),
	        _react2.default.createElement(
	          Formula,
	          null,
	          _react2.default.createElement(
	            Formula1,
	            null,
	            caption
	          ),
	          _react2.default.createElement('img', { src: _onboardingEqual2.default, alt: '' }),
	          _react2.default.createElement(
	            Formula2,
	            null,
	            _react2.default.createElement(
	              _reactDragtastic.Droppable,
	              {
	                id: 'formula1',
	                accepts: 'formula',
	                onDrop: this.onDropTop,
	                onDragLeave: this.onDropTopOut
	              },
	              function (_ref) {
	                var events = _ref.events,
	                    isOver = _ref.isOver;
	                return _react2.default.createElement(
	                  Formula3,
	                  Object.assign({}, events, {
	                    isDropped: isOver || !!top
	                  }),
	                  top && isReadOnly && _react2.default.createElement(
	                    Option,
	                    { isDropped: true },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    topText
	                  ),
	                  top && !isReadOnly && _react2.default.createElement(
	                    _reactDragtastic.Draggable,
	                    {
	                      id: 'choice-' + top,
	                      type: 'formula',
	                      data: top
	                    },
	                    function (_ref2) {
	                      var isActive = _ref2.isActive,
	                          events = _ref2.events;
	                      return _react2.default.createElement(
	                        Option,
	                        Object.assign({}, events, { isDropped: true, isHidden: isActive }),
	                        _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                        topText
	                      );
	                    }
	                  )
	                );
	              }
	            ),
	            _react2.default.createElement(Formula4, null),
	            _react2.default.createElement(
	              _reactDragtastic.Droppable,
	              {
	                id: 'formula2',
	                accepts: 'formula',
	                onDrop: this.onDropBottom,
	                onDragLeave: this.onDropBottomOut
	              },
	              function (_ref3) {
	                var events = _ref3.events,
	                    isOver = _ref3.isOver;
	                return _react2.default.createElement(
	                  Formula3,
	                  Object.assign({}, events, {
	                    isDropped: isOver || !!bottom
	                  }),
	                  bottom && isReadOnly && _react2.default.createElement(
	                    Option,
	                    { isDropped: true },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    bottomText
	                  ),
	                  bottom && !isReadOnly && _react2.default.createElement(
	                    _reactDragtastic.Draggable,
	                    {
	                      id: 'choice-' + bottom,
	                      type: 'formula',
	                      data: bottom
	                    },
	                    function (_ref4) {
	                      var isActive = _ref4.isActive,
	                          events = _ref4.events;
	                      return _react2.default.createElement(
	                        Option,
	                        Object.assign({}, events, { isDropped: true, isHidden: isActive }),
	                        _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                        bottomText
	                      );
	                    }
	                  )
	                );
	              }
	            )
	          )
	        ),
	        !isReadOnly && _react2.default.createElement(
	          Options,
	          null,
	          choices.map(function (choice) {
	            return _react2.default.createElement(
	              _reactDotFragment2.default,
	              { key: 'choice-fragment-' + choice.id },
	              _react2.default.createElement(
	                _reactDragtastic.Draggable,
	                {
	                  id: 'choice-' + choice.id,
	                  type: 'formula',
	                  data: choice.id
	                },
	                function (_ref5) {
	                  var isActive = _ref5.isActive,
	                      events = _ref5.events;
	                  return _react2.default.createElement(
	                    Option,
	                    Object.assign({}, events, { isHidden: isActive || top === choice.id || bottom === choice.id }),
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    choice.text
	                  );
	                }
	              ),
	              _react2.default.createElement(
	                _reactDragtastic.DragComponent,
	                { 'for': 'choice-' + choice.id },
	                function (_ref6) {
	                  var x = _ref6.x,
	                      y = _ref6.y;
	                  return _react2.default.createElement(
	                    Option,
	                    { style: {
	                        position: 'fixed',
	                        left: x - 20,
	                        top: y - 21,
	                        pointerEvents: 'none',
	                        zIndex: 2
	                      } },
	                    _react2.default.createElement('img', { src: _onboardingGrip2.default, alt: '' }),
	                    choice.text
	                  );
	                }
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return TriviaFormula2;
	}(_react.PureComponent);
	
	exports.default = TriviaFormula2;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    font-weight: 500;\n    color: #ed716d;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    font-weight: 500;\n    color: #ed716d;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingTriviaImage = __webpack_require__(2642);
	
	var _onboardingTriviaImage2 = _interopRequireDefault(_onboardingTriviaImage);
	
	var _triviaRound = __webpack_require__(2678);
	
	var _triviaRound2 = _interopRequireDefault(_triviaRound);
	
	var _triviaRound3 = __webpack_require__(2679);
	
	var _triviaRound4 = _interopRequireDefault(_triviaRound3);
	
	var _triviaRound5 = __webpack_require__(2680);
	
	var _triviaRound6 = _interopRequireDefault(_triviaRound5);
	
	var _triviaRound7 = __webpack_require__(2681);
	
	var _triviaRound8 = _interopRequireDefault(_triviaRound7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Text3 = _styledComponents2.default.div(_templateObject4);
	
	var Image = _styledComponents2.default.div(_templateObject5);
	
	var TriviaIntro = function (_PureComponent) {
	  _inherits(TriviaIntro, _PureComponent);
	
	  function TriviaIntro(props) {
	    _classCallCheck(this, TriviaIntro);
	
	    var _this = _possibleConstructorReturn(this, (TriviaIntro.__proto__ || Object.getPrototypeOf(TriviaIntro)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TriviaIntro, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setMode('basic');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stage = this.props.stage;
	
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          'Trivia: ',
	          stage === 'welcome' ? 'Warm Up' : 'Round ' + stage
	        ),
	        stage === 'welcome' && _react2.default.createElement(
	          Text2,
	          null,
	          'It\'s Time for Trivia'
	        ),
	        stage !== 'welcome' && _react2.default.createElement(
	          Text2,
	          null,
	          'How Prepared Are You'
	        ),
	        stage === 'welcome' && _react2.default.createElement(
	          Text3,
	          null,
	          'Before we kick things off, let\u2019s see how well you understand how business works. Note: This Trivia and all other Trivia are not graded.'
	        ),
	        stage !== 'welcome' && _react2.default.createElement(
	          Text3,
	          null,
	          'It\'s time for trivia! Let\'s see how prepared you are for this round.'
	        ),
	        stage === 'welcome' && _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', { src: _onboardingTriviaImage2.default, alt: '' })
	        ),
	        stage === '1' && _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', { src: _triviaRound2.default, alt: '' })
	        ),
	        stage === '2' && _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', { src: _triviaRound4.default, alt: '' })
	        ),
	        stage === '3' && _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', { src: _triviaRound6.default, alt: '' })
	        ),
	        stage === '4' && _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', { src: _triviaRound8.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return TriviaIntro;
	}(_react.PureComponent);
	
	exports.default = TriviaIntro;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 29px;\n  margin-top: 34px;\n  align-items: flex-start;\n  justify-content: flex-start;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 29px;\n  margin-top: 34px;\n  align-items: flex-start;\n  justify-content: flex-start;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 27px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 21px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  ', '\n\n  ', '\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 27px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 21px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  ', '\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _checkbox = __webpack_require__(2571);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _checkboxActive = __webpack_require__(2570);
	
	var _checkboxActive2 = _interopRequireDefault(_checkboxActive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Options = _styledComponents2.default.div(_templateObject4);
	
	var Option = _styledComponents2.default.button(_templateObject5, function (p) {
	  return !p.isReadOnly && '\n    &:hover {\n      cursor: pointer;\n    }\n  ';
	}, function (p) {
	  return p.isReadOnly && '\n    &:hover {\n      cursor: default;\n    }\n  ';
	});
	
	var TriviaMultipleChoice = function (_PureComponent) {
	  _inherits(TriviaMultipleChoice, _PureComponent);
	
	  function TriviaMultipleChoice(props) {
	    _classCallCheck(this, TriviaMultipleChoice);
	
	    var _this = _possibleConstructorReturn(this, (TriviaMultipleChoice.__proto__ || Object.getPrototypeOf(TriviaMultipleChoice)).call(this, props));
	
	    _this.setValue = function (value) {
	      var values = _this.state.values;
	
	
	      if (values.includes(value)) {
	        _this.setState({
	          values: values.filter(function (i) {
	            return i !== value;
	          })
	        }, function () {
	          _this.prevalidate();
	        });
	      } else {
	        _this.setState({
	          values: [].concat(_toConsumableArray(values), [value])
	        }, function () {
	          _this.prevalidate();
	        });
	      }
	    };
	
	    _this.prevalidate = function () {
	      var values = _this.state.values;
	
	
	      if (values.length > 0) {
	        _this.props.setMode('validate', _this.validate);
	      } else {
	        _this.props.setMode('disabled');
	      }
	    };
	
	    _this.validate = function () {
	      var data = _this.props.data;
	      var values = _this.state.values;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      _this.props.setMode('loading');
	      var counter = 0;
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/triviaresponses/').send({
	        user: userId,
	        trivia_question: questionId,
	        course_trivia: triviaId,
	        pickedoptions: values.map(function (i) {
	          return { option_choice: i, order: ++counter };
	        })
	      }).then(function (res) {
	        if (res.body.is_correct === 'Yes') {
	          _this.props.showConfetti();
	        } else {
	          _this.props.showIncorrectMessage();
	        }
	
	        _this.setState({
	          isReadOnly: true
	        });
	
	        _this.props.setMode('basic');
	      }).catch(function (err) {
	        _this.props.setMode('basic');
	      });
	    };
	
	    _this.state = {
	      values: [],
	      isReadOnly: false
	    };
	    return _this;
	  }
	
	  _createClass(TriviaMultipleChoice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var data = this.props.data;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      this.props.setMode('disabled');
	
	      this.props.setFetchData(true);
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/trivia/triviaresponses/').then(function (res) {
	        var answer = res.body.results.find(function (i) {
	          return i.user === userId && i.trivia_question === questionId && i.course_trivia === triviaId;
	        });
	        var isReadOnly = !!answer;
	        var values = answer ? answer.pickedoptions.map(function (i) {
	          return i.option_choice;
	        }) : [];
	
	        if (isReadOnly) {
	          _this2.props.setMode('basic');
	        }
	
	        _this2.props.setFetchData(false);
	        _this2.setState({
	          isReadOnly: isReadOnly,
	          values: values
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          values = _state.values,
	          isReadOnly = _state.isReadOnly;
	      var _props = this.props,
	          data = _props.data,
	          stage = _props.stage,
	          isFetchData = _props.isFetchData;
	      var num = data.num,
	          text = data.text,
	          choices = data.choices;
	
	
	      return isFetchData ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          'Trivia: ',
	          stage === 'welcome' ? 'Warm Up' : 'Round ' + stage
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          num,
	          '. ',
	          text
	        ),
	        _react2.default.createElement(
	          Options,
	          null,
	          choices.map(function (choice) {
	            return _react2.default.createElement(
	              Option,
	              {
	                key: 'option-choice-' + choice.id,
	                isActive: values.includes(choice.id),
	                onClick: function onClick() {
	                  return isReadOnly ? {} : _this3.setValue(choice.id);
	                },
	                isReadOnly: isReadOnly
	              },
	              !values.includes(choice.id) && _react2.default.createElement('img', { src: _checkbox2.default, alt: 'checkbox inactive icon' }),
	              values.includes(choice.id) && _react2.default.createElement('img', { src: _checkboxActive2.default, alt: 'checkbox active icon' }),
	              choice.text
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return TriviaMultipleChoice;
	}(_react.PureComponent);
	
	exports.default = TriviaMultipleChoice;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n"], ["\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n"], ["\n  font-family: \"Mukta Vaani\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n"], ["\n  font-family: \"Mukta Vaani\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 24px;\n  align-items: flex-start;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 24px;\n  align-items: flex-start;\n  justify-content: flex-start;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 320px;\n  height: 60px;\n  background: #ffffff;\n  border: 1.5px solid #d5d9dd;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n\n  font-family: \"Mukta Vaani\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    color 0.3s ease-in-out;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  width: 320px;\n  height: 60px;\n  background: #ffffff;\n  border: 1.5px solid #d5d9dd;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n\n  font-family: \"Mukta Vaani\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    color 0.3s ease-in-out;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Text1 = _styledComponents2.default.div(_templateObject2);
	
	var Text2 = _styledComponents2.default.div(_templateObject3);
	
	var Options = _styledComponents2.default.div(_templateObject4);
	
	var Option = _styledComponents2.default.button(_templateObject5, function (p) {
	  return p.isActive && "\n    background-color: #eff4fe;\n    border: 2px solid #5c91f5;\n    color: #5c91f5;\n  ";
	}, function (p) {
	  return !p.isReadOnly && "\n    &:hover {\n      cursor: pointer;\n      background-color: #eff4fe;\n      border: 2px solid #5c91f5;\n      color: #5c91f5;\n    }\n  ";
	}, function (p) {
	  return p.isReadOnly && !p.isActive && "\n    &:hover {\n      cursor: default;\n      background-color: #ffffff;\n      border: 1.5px solid #d5d9dd;\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ";
	}, function (p) {
	  return p.isReadOnly && p.isActive && "\n    &:hover {\n      cursor: default;\n      background-color: #eff4fe;\n      border: 2px solid #5c91f5;\n      color: #5c91f5;\n    }\n  ";
	});
	
	var TriviaSingleChoice = function (_PureComponent) {
	  _inherits(TriviaSingleChoice, _PureComponent);
	
	  function TriviaSingleChoice(props) {
	    _classCallCheck(this, TriviaSingleChoice);
	
	    var _this = _possibleConstructorReturn(this, (TriviaSingleChoice.__proto__ || Object.getPrototypeOf(TriviaSingleChoice)).call(this, props));
	
	    _this.setValue = function (value) {
	      if (_this.state.value === value) {
	        _this.setState({
	          value: null
	        }, function () {
	          _this.prevalidate();
	        });
	      } else {
	        _this.setState({
	          value: value
	        }, function () {
	          _this.prevalidate();
	        });
	      }
	    };
	
	    _this.prevalidate = function () {
	      var value = _this.state.value;
	
	
	      if (!!value) {
	        _this.props.setMode("validate", _this.validate);
	      } else {
	        _this.props.setMode("disabled");
	      }
	    };
	
	    _this.validate = function () {
	      var data = _this.props.data;
	      var value = _this.state.value;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      _this.props.setMode('loading');
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/trivia/triviaresponses/").send({
	        user: userId,
	        trivia_question: questionId,
	        course_trivia: triviaId,
	        pickedoptions: [{ option_choice: value, order: 1 }]
	      }).then(function (res) {
	        if (res.body.is_correct === 'Yes') {
	          _this.props.showConfetti();
	        } else {
	          _this.props.showIncorrectMessage();
	        }
	
	        _this.setState({
	          isReadOnly: true
	        });
	
	        _this.props.setMode('basic');
	      }).catch(function (err) {
	        _this.props.setMode('basic');
	      });
	    };
	
	    _this.state = {
	      value: null,
	      isReadOnly: false
	    };
	    return _this;
	  }
	
	  _createClass(TriviaSingleChoice, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var data = this.props.data;
	      var userId = data.userId,
	          questionId = data.questionId,
	          triviaId = data.triviaId;
	
	
	      this.props.setMode('disabled');
	
	      this.props.setFetchData(true);
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/trivia/triviaresponses/").then(function (res) {
	        var answer = res.body.results.find(function (i) {
	          return i.user === userId && i.trivia_question === questionId && i.course_trivia === triviaId;
	        });
	        var isReadOnly = !!answer;
	        var value = answer ? answer.pickedoptions[0].option_choice : null;
	
	        if (isReadOnly) {
	          _this2.props.setMode('basic');
	        }
	
	        _this2.props.setFetchData(false);
	        _this2.setState({
	          isReadOnly: isReadOnly,
	          value: value
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          value = _state.value,
	          isReadOnly = _state.isReadOnly;
	      var _props = this.props,
	          data = _props.data,
	          stage = _props.stage,
	          isFetchData = _props.isFetchData;
	      var num = data.num,
	          text = data.text,
	          choices = data.choices;
	
	
	      return isFetchData ? _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	      ) : _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Text1,
	          null,
	          "Trivia: ",
	          stage === 'welcome' ? 'Warm Up' : "Round " + stage
	        ),
	        _react2.default.createElement(
	          Text2,
	          null,
	          num,
	          ". ",
	          text
	        ),
	        _react2.default.createElement(
	          Options,
	          null,
	          choices.map(function (choice) {
	            return _react2.default.createElement(
	              Option,
	              {
	                key: "option-choice-" + choice.id,
	                isActive: value === choice.id,
	                onClick: function onClick() {
	                  return isReadOnly ? {} : _this3.setValue(choice.id);
	                },
	                isReadOnly: isReadOnly
	              },
	              choice.text
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return TriviaSingleChoice;
	}(_react.PureComponent);
	
	exports.default = TriviaSingleChoice;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shouldBeCircle = exports.rotationTransforms = exports.coinFlip = exports.rotate = exports.mapRange = undefined;
	
	var _isEqual = __webpack_require__(109);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapRange = exports.mapRange = function mapRange(value, x1, y1, x2, y2) {
	  return (value - x1) * (y2 - x2) / (y1 - x1) + x2;
	};
	
	var rotate = exports.rotate = function rotate(degree, amount) {
	  var result = degree + amount;
	  return result > 360 ? result - 360 : result;
	};
	
	var coinFlip = exports.coinFlip = function coinFlip() {
	  return Math.random() > 0.5;
	};
	
	// avoid this for circles, as it will have no visual effect
	var zAxisRotation = [0, 0, 1];
	
	var rotationTransforms = exports.rotationTransforms = [
	// dual axis rotations (a bit more realistic)
	[1, 1, 0], [1, 0, 1], [0, 1, 1],
	// single axis rotations (a bit dumber)
	[1, 0, 0], [0, 1, 0], zAxisRotation];
	
	var shouldBeCircle = exports.shouldBeCircle = function shouldBeCircle(rotationIndex) {
	  return !(0, _isEqual2.default)(rotationTransforms[rotationIndex], zAxisRotation) && coinFlip();
	};

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n'], ['\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n'], ['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #FAFBFD;\n  min-height: 100%;\n  margin: 0 -40px -40px;\n  padding: 64px 32px 24px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  color: #0F172A;\n'], ['\n  background: #FAFBFD;\n  min-height: 100%;\n  margin: 0 -40px -40px;\n  padding: 64px 32px 24px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  color: #0F172A;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  max-width: 760px;\n  margin: 0 auto 16px;\n  text-align: center;\n'], ['\n  max-width: 760px;\n  margin: 0 auto 16px;\n  text-align: center;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin: 0 0 14px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  color: #0F172A;\n'], ['\n  margin: 0 0 14px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  color: #0F172A;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 0 0 14px;\n  font-size: 16px;\n  color: #475569;\n  line-height: 1.4;\n'], ['\n  margin: 0 0 14px;\n  font-size: 16px;\n  color: #475569;\n  line-height: 1.4;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 1180px;\n'], ['\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 1180px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 18px;\n  padding: 10px 14px 10px 6px;\n  margin-bottom: 12px;\n  border-radius: 14px;\n  background: transparent;\n  transition: background 200ms ease;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    left: 25px;\n    width: 2px;\n    top: 0;\n    bottom: -12px;\n    background: #E2E8F0;\n    z-index: 0;\n  }\n\n  &:first-child::before {\n    top: 30px;\n  }\n\n  &:last-child::before {\n    bottom: auto;\n    height: 30px;\n  }\n\n  ', '\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 18px;\n  padding: 10px 14px 10px 6px;\n  margin-bottom: 12px;\n  border-radius: 14px;\n  background: transparent;\n  transition: background 200ms ease;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    left: 25px;\n    width: 2px;\n    top: 0;\n    bottom: -12px;\n    background: #E2E8F0;\n    z-index: 0;\n  }\n\n  &:first-child::before {\n    top: 30px;\n  }\n\n  &:last-child::before {\n    bottom: auto;\n    height: 30px;\n  }\n\n  ', '\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    background: #DBEAFE;\n  '], ['\n    background: #DBEAFE;\n  ']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    background: #10B981;\n    border-color: #10B981;\n    color: #FFFFFF;\n  '], ['\n    background: #10B981;\n    border-color: #10B981;\n    color: #FFFFFF;\n  ']),
	    _templateObject12 = _taggedTemplateLiteral(['\n    background: #EFF6FF;\n    border-color: #2563EB;\n    color: #2563EB;\n  '], ['\n    background: #EFF6FF;\n    border-color: #2563EB;\n    color: #2563EB;\n  ']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  padding-top: 2px;\n'], ['\n  padding-top: 2px;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 8px;\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n'], ['\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 8px;\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  min-width: 0;\n'], ['\n  flex: 1 1 auto;\n  min-width: 0;\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  color: #64748B;\n  font-size: 14px;\n  line-height: 1;\n  transition: color 150ms ease;\n\n  ', ':hover & {\n    color: #0F172A;\n  }\n'], ['\n  flex: 0 0 auto;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  color: #64748B;\n  font-size: 14px;\n  line-height: 1;\n  transition: color 150ms ease;\n\n  ', ':hover & {\n    color: #0F172A;\n  }\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 18px;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-weight: 800;\n  font-size: 18px;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n    color: #94A3B8;\n    text-decoration: line-through;\n    text-decoration-color: #CBD5E1;\n  '], ['\n    color: #94A3B8;\n    text-decoration: line-through;\n    text-decoration-color: #CBD5E1;\n  ']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  margin: 0 0 6px;\n  font-size: 16px;\n  line-height: 1.45;\n  color: #475569;\n  max-width: 900px;\n'], ['\n  margin: 0 0 6px;\n  font-size: 16px;\n  line-height: 1.45;\n  color: #475569;\n  max-width: 900px;\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  margin-top: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 4px;\n'], ['\n  margin-top: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 4px;\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 150ms ease;\n\n  & + & {\n    border-top: 1px solid #E2E8F0;\n  }\n\n  &:hover {\n    background: #FFFFFF;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: -2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 150ms ease;\n\n  & + & {\n    border-top: 1px solid #E2E8F0;\n  }\n\n  &:hover {\n    background: #FFFFFF;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: -2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  border: 2px solid #CBD5E1;\n  border-radius: 5px;\n  background: #FFFFFF;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  transition: background 200ms ease, border-color 200ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  border: 2px solid #CBD5E1;\n  border-radius: 5px;\n  background: #FFFFFF;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  transition: background 200ms ease, border-color 200ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n    background: #10B981;\n    border-color: #10B981;\n  '], ['\n    background: #10B981;\n    border-color: #10B981;\n  ']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 1.4;\n  color: #475569;\n'], ['\n  font-size: 16px;\n  line-height: 1.4;\n  color: #475569;\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n  align-self: flex-start;\n  font-size: 16px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n'], ['\n  align-self: flex-start;\n  font-size: 16px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  max-width: 760px;\n  margin: 32px auto 0;\n  padding: 28px 32px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ECFDF5, #D1FAE5);\n  border: 1px solid #A7F3D0;\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 20px;\n  align-items: center;\n  animation: ', ' 500ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  max-width: 760px;\n  margin: 32px auto 0;\n  padding: 28px 32px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ECFDF5, #D1FAE5);\n  border: 1px solid #A7F3D0;\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 20px;\n  align-items: center;\n  animation: ', ' 500ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #10B981;\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n'], ['\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #10B981;\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #064E3B;\n'], ['\n  margin: 0 0 4px;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #064E3B;\n']),
	    _templateObject31 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-size: 15px;\n  color: #047857;\n  line-height: 1.5;\n'], ['\n  margin: 0;\n  font-size: 15px;\n  color: #047857;\n  line-height: 1.5;\n']),
	    _templateObject32 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n'], ['\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n']),
	    _templateObject33 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject34 = _taggedTemplateLiteral(['\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  overflow: hidden;\n'], ['\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  overflow: hidden;\n']),
	    _templateObject35 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #E2E8F0;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #E2E8F0;\n']),
	    _templateObject36 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n'], ['\n  margin: 0;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n']),
	    _templateObject37 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: 0;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n'], ['\n  background: transparent;\n  border: 0;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n']),
	    _templateObject38 = _taggedTemplateLiteral(['\n  overflow-y: auto;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n'], ['\n  overflow-y: auto;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _whatToExpect = __webpack_require__(586);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable react/no-multi-comp */
	
	
	// Consolidated onboarding checklist for rounds 2+. Same visual
	// design as Round1Checklist but content is different:
	//
	//   Step 1 — Review Prior Round Results (substeps)
	//     - Review Performance Feedback report (only if didn't hit
	//       every target in the prior round)
	//     - Review Team Report (always)
	//
	//   Step 2 — What to Expect This Round (substeps)
	//     Conditional on round number + active financial targets:
	//       - Customer Preferences (rounds 2+)
	//       - Product Strategy / Machine Options / Distribution Centers
	//         / Share Buyback (round 2 only)
	//       - New Metric: ROE / ROA / EPS (when each is an active
	//         target for this round)
	//     Each substep opens the existing What-to-Expect component
	//     inside a modal — same pattern as the Team Contract popup
	//     in Round1Checklist.
	//
	// Persistence: per-round localStorage key so progress is tracked
	// independently each round. No backend endpoint yet.
	
	// ---------- copy ---------------------------------------------------
	
	var COMPLETION_COPY = {
	  icon: '✓',
	  title: "You're ready for this round.",
	  description: 'Great work. Make sure to post all team decisions before the round ends.'
	};
	
	var POPUP_COMPONENTS = {
	  'customer-preferences': _whatToExpect.CustomerPreferences,
	  'product-strategy': _whatToExpect.ProductStrategy,
	  'machine-options': _whatToExpect.MachineOptions,
	  'distribution-centers': _whatToExpect.DistributionCenters,
	  'share-buyback': _whatToExpect.ShareBuyback,
	  'new-metric-roe': _whatToExpect.NewMetricROE,
	  'new-metric-roa': _whatToExpect.NewMetricROA,
	  'new-metric-eps': _whatToExpect.NewMetricEPS
	};
	
	var POPUP_TITLES = {
	  'customer-preferences': 'Customer Preferences',
	  'product-strategy': 'Product Strategy',
	  'machine-options': 'Machine Options',
	  'distribution-centers': 'Distribution Centers',
	  'share-buyback': 'Share Buyback',
	  'new-metric-roe': 'New Metric: ROE',
	  'new-metric-roa': 'New Metric: ROA',
	  'new-metric-eps': 'New Metric: EPS'
	};
	
	var POPUP_SUBSTEPS = {
	  'customer-preferences': {
	    title: 'Customer Preferences',
	    description: 'Review the latest customer preferences for this round.',
	    linkText: 'View customer preferences'
	  },
	  'product-strategy': {
	    title: 'Product Strategy',
	    description: 'Get familiar with the product strategy changes for this round.',
	    linkText: 'View product strategy'
	  },
	  'machine-options': {
	    title: 'Machine Options',
	    description: 'New machine options are available this round.',
	    linkText: 'View machine options'
	  },
	  'distribution-centers': {
	    title: 'Distribution Centers',
	    description: 'New distribution centers come online this round.',
	    linkText: 'View distribution centers'
	  },
	  'share-buyback': {
	    title: 'Share Buyback',
	    description: 'A share buyback option becomes available this round.',
	    linkText: 'View share buyback'
	  },
	  'new-metric-roe': {
	    title: 'New Metric: ROE',
	    description: 'Return on Equity is a target this round.',
	    linkText: 'View ROE explainer'
	  },
	  'new-metric-roa': {
	    title: 'New Metric: ROA',
	    description: 'Return on Assets is a target this round.',
	    linkText: 'View ROA explainer'
	  },
	  'new-metric-eps': {
	    title: 'New Metric: EPS',
	    description: 'Earnings Per Share is a target this round.',
	    linkText: 'View EPS explainer'
	  }
	};
	
	// Substeps for Step 1 — Review Prior Round Results.
	var STEP1_SUBSTEP_PERFORMANCE = {
	  id: 'review-performance-feedback',
	  title: 'Review Performance Feedback report',
	  description: "This report explains why your team didn't hit the financial targets for the prior round.",
	  linkText: 'Open performance feedback'
	};
	
	var STEP1_SUBSTEP_TEAMREPORT = {
	  id: 'review-team-report',
	  title: 'Review Team Report',
	  description: "Compare your team's results against your competitors. Spot what top teams did differently so you can adjust this round.",
	  linkText: 'Open team report'
	};
	
	// Builds the per-round storage key so progress is tracked
	// independently per round.
	var storageKey = function storageKey(round) {
	  var uid = _Auth2.default.getUserId();
	  return 'onboarding:checklist:round' + (round || 'X') + ':' + (uid || 'anon');
	};
	
	// ---------- styles -------------------------------------------------
	
	var fadeUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var fadeIn = (0, _styledComponents.keyframes)(_templateObject2);
	
	var Styled = {};
	
	Styled.Root = _styledComponents2.default.section(_templateObject3);
	
	Styled.Header = _styledComponents2.default.div(_templateObject4);
	
	Styled.Title = _styledComponents2.default.h1(_templateObject5);
	
	Styled.Subhead = _styledComponents2.default.p(_templateObject6);
	
	Styled.Timeline = _styledComponents2.default.ol(_templateObject7);
	
	Styled.Step = _styledComponents2.default.li(_templateObject8, function (p) {
	  return p.active && (0, _styledComponents.css)(_templateObject9);
	});
	
	var stepCircleBase = '\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Mukta Vaani\', Lato, sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  background: #FFFFFF;\n  border: 2px solid #E2E8F0;\n  color: #64748B;\n  position: relative;\n  z-index: 1;\n  padding: 0;\n  transition: background 200ms ease, border-color 200ms ease, color 200ms ease;\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n';
	
	Styled.StepCircleStatic = _styledComponents2.default.div(_templateObject10, stepCircleBase, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject11);
	}, function (p) {
	  return !p.completed && p.active && (0, _styledComponents.css)(_templateObject12);
	});
	
	Styled.StepBody = _styledComponents2.default.div(_templateObject13);
	
	// Clickable wrapper around a parent step's title + description that
	// toggles its substeps open/closed. Rendered as div+role=button so it
	// can legally contain the existing <h2> and <p> children.
	Styled.StepHeaderToggle = _styledComponents2.default.div(_templateObject14);
	
	Styled.StepHeaderTextGroup = _styledComponents2.default.div(_templateObject15);
	
	Styled.StepHeaderChevron = _styledComponents2.default.span(_templateObject16, Styled.StepHeaderToggle);
	
	Styled.StepTitle = _styledComponents2.default.h2(_templateObject17, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject18);
	});
	
	Styled.StepDescription = _styledComponents2.default.p(_templateObject19);
	
	Styled.SubstepGroup = _styledComponents2.default.div(_templateObject20);
	
	Styled.SubstepRow = _styledComponents2.default.button(_templateObject21);
	
	Styled.Checkbox = _styledComponents2.default.span(_templateObject22, function (p) {
	  return p.checked && (0, _styledComponents.css)(_templateObject23);
	});
	
	Styled.SubstepBody = _styledComponents2.default.div(_templateObject24);
	
	Styled.SubstepTitle = _styledComponents2.default.span(_templateObject25, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject18);
	});
	
	Styled.SubstepDescription = _styledComponents2.default.span(_templateObject26);
	
	Styled.SubstepLink = _styledComponents2.default.a(_templateObject27);
	
	Styled.CompletionBanner = _styledComponents2.default.div(_templateObject28, fadeUp);
	
	Styled.CompletionIcon = _styledComponents2.default.div(_templateObject29);
	
	Styled.CompletionTitle = _styledComponents2.default.h3(_templateObject30);
	
	Styled.CompletionDescription = _styledComponents2.default.p(_templateObject31);
	
	Styled.SrOnly = _styledComponents2.default.span(_templateObject32);
	
	// ---------- modal shell -------------------------------------------
	
	Styled.Modal = {};
	
	Styled.Modal.Backdrop = _styledComponents2.default.div(_templateObject33, fadeIn);
	
	Styled.Modal.Card = _styledComponents2.default.div(_templateObject34);
	
	Styled.Modal.HeaderBar = _styledComponents2.default.div(_templateObject35);
	
	Styled.Modal.Title = _styledComponents2.default.h2(_templateObject36);
	
	Styled.Modal.CloseButton = _styledComponents2.default.button(_templateObject37);
	
	// Wraps the existing What-to-Expect component inside the modal.
	// The legacy components have their own gray Wrapper + 40px padding
	// — we let those take over by zeroing the modal body padding.
	Styled.Modal.Body = _styledComponents2.default.div(_templateObject38);
	
	// ---------- component ---------------------------------------------
	
	var RoundChecklist = function (_PureComponent) {
	  _inherits(RoundChecklist, _PureComponent);
	
	  function RoundChecklist(props) {
	    _classCallCheck(this, RoundChecklist);
	
	    var _this = _possibleConstructorReturn(this, (RoundChecklist.__proto__ || Object.getPrototypeOf(RoundChecklist)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      completed: _this.readFromStorage(props),
	      // Which What-to-Expect popup is currently open. Null = none.
	      activePopupId: null,
	      // Gating data for substeps:
	      //   - hitAllTargets: bool — gates the Performance Feedback substep
	      //   - targets: { roe, roa, earnings_per_share, ... } — gates the
	      //     New Metric ROE/ROA/EPS substeps
	      gatingLoaded: false,
	      hitAllTargets: false,
	      targets: {},
	      // Which parent steps are collapsed. Keyed by step id; absence
	      // means expanded. Sub-sections start expanded by default so
	      // users see the substeps immediately. In-memory only — resets
	      // on reload.
	      collapsedSteps: {}
	    };
	    return _this;
	  }
	
	  _createClass(RoundChecklist, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.overrideParentBackgrounds();
	      this.fetchGatingData();
	      if (typeof window !== 'undefined') {
	        window.addEventListener('keydown', this.handleKeydown);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.restoreParentBackgrounds();
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('keydown', this.handleKeydown);
	      }
	    }
	
	    // Esc closes any open popup.
	
	
	    // Match the Round1Checklist trick: parent OnboardingPage paints
	    // a #f5f6f7 background; override to the softer #FAFBFD so the
	    // checklist surface fills the panel.
	
	
	    // ---- persistence -----------------------------------------------
	
	    // ---- data fetching ---------------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ---- render ----------------------------------------------------
	
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.state.gatingLoaded) {
	        // No skeleton needed — the checklist is short. Render
	        // empty Root so parent-bg override still applies.
	        return _react2.default.createElement(Styled.Root, { innerRef: this.setRootEl });
	      }
	
	      var step1Complete = this.isStep1Complete();
	      var step2Complete = this.isStep2Complete();
	      var activeId = this.firstIncompleteStepId();
	      var allDone = this.allComplete();
	
	      return _react2.default.createElement(
	        Styled.Root,
	        { innerRef: this.setRootEl },
	        _react2.default.createElement(
	          Styled.Header,
	          null,
	          _react2.default.createElement(
	            Styled.Title,
	            null,
	            'Welcome to Round ',
	            this.activeRound,
	            '!'
	          ),
	          _react2.default.createElement(
	            Styled.Subhead,
	            null,
	            'To get started for the round, follow the checklist below.'
	          ),
	          _react2.default.createElement(
	            Styled.SrOnly,
	            { 'aria-live': 'polite' },
	            this.countableIds.filter(function (id) {
	              return _this2.isLeafComplete(id);
	            }).length,
	            ' of ',
	            this.countableIds.length,
	            ' steps complete'
	          )
	        ),
	        _react2.default.createElement(
	          Styled.Timeline,
	          null,
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'review-prior-results' },
	            this.renderStepCircle(1, step1Complete, activeId === 'review-prior-results'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepHeaderToggle,
	                {
	                  role: 'button',
	                  tabIndex: 0,
	                  onClick: function onClick() {
	                    return _this2.toggleStepCollapse('review-prior-results');
	                  },
	                  onKeyDown: this.handleStepHeaderKeyDown('review-prior-results'),
	                  'aria-expanded': !this.isStepCollapsed('review-prior-results'),
	                  'aria-controls': 'substeps-review-prior-results',
	                  'aria-label': this.isStepCollapsed('review-prior-results') ? 'Expand Review Prior Round Results' : 'Collapse Review Prior Round Results'
	                },
	                _react2.default.createElement(
	                  Styled.StepHeaderTextGroup,
	                  null,
	                  _react2.default.createElement(
	                    Styled.StepTitle,
	                    { completed: step1Complete },
	                    'Review Prior Round Results'
	                  ),
	                  _react2.default.createElement(
	                    Styled.StepDescription,
	                    null,
	                    'Reflect on what happened last round so this team can sharpen its strategy.'
	                  )
	                ),
	                _react2.default.createElement(
	                  Styled.StepHeaderChevron,
	                  { 'aria-hidden': 'true' },
	                  this.isStepCollapsed('review-prior-results') ? '▸' : '▾'
	                )
	              ),
	              !this.isStepCollapsed('review-prior-results') && _react2.default.createElement(
	                'div',
	                { id: 'substeps-review-prior-results' },
	                this.renderStep1Substeps()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'what-to-expect' },
	            this.renderStepCircle(2, step2Complete, activeId === 'what-to-expect'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepHeaderToggle,
	                {
	                  role: 'button',
	                  tabIndex: 0,
	                  onClick: function onClick() {
	                    return _this2.toggleStepCollapse('what-to-expect');
	                  },
	                  onKeyDown: this.handleStepHeaderKeyDown('what-to-expect'),
	                  'aria-expanded': !this.isStepCollapsed('what-to-expect'),
	                  'aria-controls': 'substeps-what-to-expect',
	                  'aria-label': this.isStepCollapsed('what-to-expect') ? 'Expand What to Expect This Round' : 'Collapse What to Expect This Round'
	                },
	                _react2.default.createElement(
	                  Styled.StepHeaderTextGroup,
	                  null,
	                  _react2.default.createElement(
	                    Styled.StepTitle,
	                    { completed: step2Complete },
	                    'What to Expect This Round'
	                  ),
	                  _react2.default.createElement(
	                    Styled.StepDescription,
	                    null,
	                    'Get up to speed on what\'s changing this round before the team meets to make decisions.'
	                  )
	                ),
	                _react2.default.createElement(
	                  Styled.StepHeaderChevron,
	                  { 'aria-hidden': 'true' },
	                  this.isStepCollapsed('what-to-expect') ? '▸' : '▾'
	                )
	              ),
	              !this.isStepCollapsed('what-to-expect') && _react2.default.createElement(
	                'div',
	                { id: 'substeps-what-to-expect' },
	                this.renderStep2Substeps()
	              )
	            )
	          )
	        ),
	        allDone && _react2.default.createElement(
	          Styled.CompletionBanner,
	          null,
	          _react2.default.createElement(
	            Styled.CompletionIcon,
	            { 'aria-hidden': 'true' },
	            COMPLETION_COPY.icon
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              Styled.CompletionTitle,
	              null,
	              COMPLETION_COPY.title
	            ),
	            _react2.default.createElement(
	              Styled.CompletionDescription,
	              null,
	              COMPLETION_COPY.description
	            )
	          )
	        ),
	        this.renderPopup()
	      );
	    }
	  }, {
	    key: 'activeRound',
	
	
	    // ---- derived helpers -------------------------------------------
	
	    get: function get() {
	      var _props = this.props,
	          roundInUrl = _props.roundInUrl,
	          currentRound = _props.currentRound;
	
	      return Number(roundInUrl || currentRound || 2);
	    }
	  }, {
	    key: 'priorRound',
	    get: function get() {
	      return this.activeRound > 1 ? this.activeRound - 1 : null;
	    }
	
	    // Builds the list of substep objects for Step 1 based on whether
	    // the team hit every target in the prior round.
	
	  }, {
	    key: 'step1Substeps',
	    get: function get() {
	      var list = [];
	      if (!this.state.hitAllTargets) {
	        list.push(STEP1_SUBSTEP_PERFORMANCE);
	      }
	      list.push(STEP1_SUBSTEP_TEAMREPORT);
	      return list;
	    }
	
	    // Builds the list of "What to Expect" substep ids for Step 2,
	    // gated by the round number + active targets.
	
	  }, {
	    key: 'step2SubstepIds',
	    get: function get() {
	      var round = this.activeRound;
	      var targets = this.state.targets || {};
	      var ids = [];
	
	      // Customer Preferences: all rounds except 1
	      if (round > 1) ids.push('customer-preferences');
	
	      // Product Strategy / Machine Options / Distribution Centers /
	      // Share Buyback: round 2 only (per current spec).
	      if (round === 2) {
	        ids.push('product-strategy');
	        ids.push('machine-options');
	        ids.push('distribution-centers');
	        ids.push('share-buyback');
	      }
	
	      // New Metric substeps gated on the metric being a target.
	      if (Number(targets.roe) > 0) ids.push('new-metric-roe');
	      if (Number(targets.roa) > 0) ids.push('new-metric-roa');
	      if (Number(targets.earnings_per_share) > 0) ids.push('new-metric-eps');
	
	      return ids;
	    }
	
	    // Total of all countable items across both steps. Drives the
	    // completion banner.
	
	  }, {
	    key: 'countableIds',
	    get: function get() {
	      return [].concat(_toConsumableArray(this.step1Substeps.map(function (s) {
	        return s.id;
	      })), _toConsumableArray(this.step2SubstepIds));
	    }
	
	    // ---- popup actions ---------------------------------------------
	
	    // ---- URL builders ----------------------------------------------
	
	    // The Performance Feedback link should point at the prior round
	    // (that's the round we're reviewing).
	
	
	    // Team report likewise refers to the prior round.
	
	
	    // Customer Analysis lives at /ceo/analysis/market and is round-aware.
	    // Uses the ACTIVE round (not prior) so students see the preferences
	    // that apply to the round they're about to play.
	
	
	    // ---- render helpers --------------------------------------------
	
	    // Rendered as a <button> that imperatively navigates via
	    // changeLocation. Avoids nesting <a> inside the parent <button>
	    // SubstepRow (invalid HTML) which was preventing reliable
	    // navigation in some browsers.
	
	  }]);
	
	  return RoundChecklist;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.toggleStepCollapse = function (stepId) {
	    _this3.setState(function (prev) {
	      var next = Object.assign({}, prev.collapsedSteps);
	      if (next[stepId]) delete next[stepId];else next[stepId] = true;
	      return { collapsedSteps: next };
	    });
	  };
	
	  this.isStepCollapsed = function (stepId) {
	    return !!_this3.state.collapsedSteps[stepId];
	  };
	
	  this.handleStepHeaderKeyDown = function (stepId) {
	    return function (e) {
	      if (e.key === 'Enter' || e.key === ' ') {
	        e.preventDefault();
	        _this3.toggleStepCollapse(stepId);
	      }
	    };
	  };
	
	  this.setRootEl = function (el) {
	    _this3._rootEl = el;
	  };
	
	  this.handleKeydown = function (e) {
	    if (e.key === 'Escape' && _this3.state.activePopupId) {
	      _this3.closePopup();
	    }
	  };
	
	  this.overrideParentBackgrounds = function () {
	    if (typeof window === 'undefined' || !_this3._rootEl) return;
	    _this3._modifiedNodes = [];
	    var node = _this3._rootEl.parentElement;
	    var hops = 0;
	    while (node && hops < 6) {
	      var cs = window.getComputedStyle(node);
	      if (cs.backgroundColor === 'rgb(245, 246, 247)') {
	        _this3._modifiedNodes.push({
	          el: node,
	          originalBg: node.style.background
	        });
	        node.style.background = '#FAFBFD';
	      }
	      node = node.parentElement;
	      hops += 1;
	    }
	  };
	
	  this.restoreParentBackgrounds = function () {
	    if (_this3._modifiedNodes) {
	      _this3._modifiedNodes.forEach(function (entry) {
	        entry.el.style.background = entry.originalBg;
	      });
	      _this3._modifiedNodes = null;
	    }
	  };
	
	  this.readFromStorage = function (props) {
	    try {
	      var round = (props || _this3.props).roundInUrl || (props || _this3.props).currentRound || 0;
	      var raw = window.localStorage.getItem(storageKey(round));
	      if (!raw) return {};
	      var parsed = JSON.parse(raw);
	      if (!Array.isArray(parsed)) return {};
	      var next = {};
	      parsed.forEach(function (id) {
	        if (typeof id === 'string') next[id] = true;
	      });
	      return next;
	    } catch (e) {
	      return {};
	    }
	  };
	
	  this.writeToStorage = function (completed) {
	    try {
	      var ids = Object.keys(completed).filter(function (k) {
	        return completed[k] === true;
	      });
	      window.localStorage.setItem(storageKey(_this3.activeRound), JSON.stringify(ids));
	    } catch (e) {
	      // localStorage unavailable — silent.
	    }
	  };
	
	  this.toggle = function (id) {
	    _this3.setState(function (prev) {
	      var next = Object.assign({}, prev.completed);
	      if (next[id]) {
	        delete next[id];
	      } else {
	        next[id] = true;
	      }
	      _this3.writeToStorage(next);
	      return { completed: next };
	    });
	  };
	
	  this.fetchGatingData = function () {
	    var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	    var activeRound = _this3.activeRound;
	    var priorRound = activeRound > 1 ? activeRound - 1 : null;
	
	    // Current-round targets gate ROE/ROA/EPS substeps.
	    var targetsReq = (0, _ApiService.getRequest)(apiUrl + 'v2/games/targets/?round_number=' + activeRound + '&course=' + _Auth2.default.getCourseId()).catch(function () {
	      return null;
	    });
	
	    // Prior-round teamgrading gates the Performance Feedback substep.
	    // If no prior round (shouldn't happen for round 2+, but defensive),
	    // assume targets were "hit" so the substep is hidden.
	    var team = _Teams2.default.currentTeam();
	    var teamId = team ? Number(team.id) : null;
	    var gameId = Number(_Auth2.default.getGameId());
	    var priorReq = priorRound != null && teamId != null ? (0, _ApiService.getRequest)(apiUrl + 'v2/games/teamgradings/?round_number=' + priorRound + '&game=' + gameId + '&team=' + teamId).catch(function () {
	      return null;
	    }) : Promise.resolve(null);
	
	    Promise.all([targetsReq, priorReq]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          targetsRes = _ref2[0],
	          priorRes = _ref2[1];
	
	      var targetsBody = targetsRes && targetsRes.body || {};
	      var targets = Array.isArray(targetsBody.results) ? targetsBody.results[0] || {} : Array.isArray(targetsBody) ? targetsBody[0] || {} : targetsBody;
	
	      // "Hit all targets" check — uses prior round's current_weighted_value.
	      // If it's at 1, the team hit every target. Anything less means at
	      // least one target was missed, so we show the Performance Feedback
	      // substep to walk them through what went wrong.
	      var hitAllTargets = false;
	      if (priorRes && priorRes.body) {
	        var rows = Array.isArray(priorRes.body.results) ? priorRes.body.results : [];
	        var myRow = rows.find(function (r) {
	          return Number(r.team) === teamId;
	        }) || (rows.length > 0 ? rows[0] : null);
	        if (myRow) {
	          var wv = Number(myRow.current_weighted_value);
	          hitAllTargets = !isNaN(wv) && wv >= 1;
	        }
	      }
	
	      _this3.setState({
	        gatingLoaded: true,
	        hitAllTargets: hitAllTargets,
	        targets: targets || {}
	      });
	    }).catch(function () {
	      _this3.setState({ gatingLoaded: true });
	    });
	  };
	
	  this.isLeafComplete = function (id) {
	    return !!_this3.state.completed[id];
	  };
	
	  this.isStep1Complete = function () {
	    return _this3.step1Substeps.every(function (s) {
	      return _this3.isLeafComplete(s.id);
	    });
	  };
	
	  this.isStep2Complete = function () {
	    return _this3.step2SubstepIds.every(function (id) {
	      return _this3.isLeafComplete(id);
	    });
	  };
	
	  this.firstIncompleteStepId = function () {
	    if (!_this3.isStep1Complete()) return 'review-prior-results';
	    if (!_this3.isStep2Complete()) return 'what-to-expect';
	    return null;
	  };
	
	  this.allComplete = function () {
	    var ids = _this3.countableIds;
	    if (ids.length === 0) return false;
	    return ids.every(function (id) {
	      return _this3.isLeafComplete(id);
	    });
	  };
	
	  this.openPopup = function (id) {
	    _this3.setState({ activePopupId: id });
	  };
	
	  this.closePopup = function () {
	    _this3.setState({ activePopupId: null });
	  };
	
	  this.withRound = function (path, round) {
	    var r = round != null ? round : _this3.activeRound;
	    return '' + path + (path.indexOf('?') >= 0 ? '&' : '?') + 'round=' + r;
	  };
	
	  this.performanceFeedbackUrl = function () {
	    return _this3.withRound('/performance-feedback', _this3.priorRound);
	  };
	
	  this.teamReportUrl = function () {
	    return _this3.withRound('/analysis/team-reports', _this3.priorRound);
	  };
	
	  this.customerAnalysisUrl = function () {
	    return _this3.withRound('/ceo/analysis/market', _this3.activeRound);
	  };
	
	  this.stopRowClickPropagation = function (e) {
	    if (e) e.stopPropagation();
	  };
	
	  this.renderStepCircle = function (number, completed, active) {
	    var content = completed ? '✓' : number;
	    // Both top-level steps are parent-only (their completion is
	    // derived from substeps), so the circle is informational.
	    return _react2.default.createElement(
	      Styled.StepCircleStatic,
	      {
	        completed: completed,
	        active: active,
	        'aria-hidden': 'true'
	      },
	      content
	    );
	  };
	
	  this.renderInternalSubstepLink = function (text, href) {
	    return _react2.default.createElement(
	      Styled.SubstepLink,
	      {
	        as: 'button',
	        type: 'button',
	        onClick: function onClick(e) {
	          _this3.stopRowClickPropagation(e);
	          (0, _Location.changeLocation)(href);
	        }
	      },
	      text,
	      ' \u2192'
	    );
	  };
	
	  this.renderPopupSubstepLink = function (text, popupId) {
	    return _react2.default.createElement(
	      Styled.SubstepLink,
	      {
	        as: 'button',
	        type: 'button',
	        onClick: function onClick(e) {
	          _this3.stopRowClickPropagation(e);
	          _this3.openPopup(popupId);
	        }
	      },
	      text,
	      ' \u2192'
	    );
	  };
	
	  this.renderSubstepRow = function (id, title, description, linkNode) {
	    var isDone = _this3.isLeafComplete(id);
	    var label = isDone ? 'Mark ' + title + ' as incomplete' : 'Mark ' + title + ' as complete';
	    return _react2.default.createElement(
	      Styled.SubstepRow,
	      {
	        key: id,
	        type: 'button',
	        onClick: function onClick() {
	          return _this3.toggle(id);
	        },
	        'aria-pressed': isDone,
	        'aria-label': label
	      },
	      _react2.default.createElement(
	        Styled.Checkbox,
	        { checked: isDone, 'aria-hidden': 'true' },
	        isDone ? '✓' : ''
	      ),
	      _react2.default.createElement(
	        Styled.SubstepBody,
	        null,
	        _react2.default.createElement(
	          Styled.SubstepTitle,
	          { completed: isDone },
	          title
	        ),
	        _react2.default.createElement(
	          Styled.SubstepDescription,
	          null,
	          description,
	          linkNode && _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            linkNode
	          )
	        )
	      )
	    );
	  };
	
	  this.renderStep1Substeps = function () {
	    var subs = _this3.step1Substeps;
	    if (subs.length === 0) return null;
	    return _react2.default.createElement(
	      Styled.SubstepGroup,
	      null,
	      subs.map(function (sub) {
	        var linkNode = null;
	        if (sub.id === 'review-performance-feedback') {
	          linkNode = _this3.renderInternalSubstepLink(sub.linkText, _this3.performanceFeedbackUrl());
	        } else if (sub.id === 'review-team-report') {
	          linkNode = _this3.renderInternalSubstepLink(sub.linkText, _this3.teamReportUrl());
	        }
	        return _this3.renderSubstepRow(sub.id, sub.title, sub.description, linkNode);
	      })
	    );
	  };
	
	  this.renderStep2Substeps = function () {
	    var ids = _this3.step2SubstepIds;
	    if (ids.length === 0) {
	      return _react2.default.createElement(
	        Styled.SubstepGroup,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { padding: '14px 16px', fontSize: 14, color: '#475569' } },
	          'No new updates to review for this round. You\'re ready to move on to decisions.'
	        )
	      );
	    }
	    return _react2.default.createElement(
	      Styled.SubstepGroup,
	      null,
	      ids.map(function (id) {
	        var meta = POPUP_SUBSTEPS[id];
	        if (!meta) return null;
	        // Customer Preferences links straight to the Customer Analysis
	        // page for the active round rather than opening the modal
	        // explainer, so students land on real data instead of a
	        // teaser.
	        var linkNode = id === 'customer-preferences' ? _this3.renderInternalSubstepLink(meta.linkText, _this3.customerAnalysisUrl()) : _this3.renderPopupSubstepLink(meta.linkText, id);
	        return _this3.renderSubstepRow(id, meta.title, meta.description, linkNode);
	      })
	    );
	  };
	
	  this.renderPopup = function () {
	    var activePopupId = _this3.state.activePopupId;
	
	    if (!activePopupId) return null;
	    var Component = POPUP_COMPONENTS[activePopupId];
	    if (!Component) return null;
	    return _react2.default.createElement(
	      Styled.Modal.Backdrop,
	      { onClick: _this3.closePopup, role: 'dialog', 'aria-modal': 'true' },
	      _react2.default.createElement(
	        Styled.Modal.Card,
	        { onClick: function onClick(e) {
	            return e.stopPropagation();
	          } },
	        _react2.default.createElement(
	          Styled.Modal.HeaderBar,
	          null,
	          _react2.default.createElement(
	            Styled.Modal.Title,
	            null,
	            POPUP_TITLES[activePopupId]
	          ),
	          _react2.default.createElement(
	            Styled.Modal.CloseButton,
	            {
	              type: 'button',
	              onClick: _this3.closePopup,
	              'aria-label': 'Close'
	            },
	            '\xD7'
	          )
	        ),
	        _react2.default.createElement(
	          Styled.Modal.Body,
	          null,
	          _react2.default.createElement(Component, {
	            setMode: function setMode() {},
	            roundInUrl: _this3.activeRound,
	            currentRound: _this3.props.currentRound
	          })
	        )
	      )
	    );
	  };
	};
	
	exports.default = RoundChecklist;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  background: #3A507B;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 15px;\n    right: 15px;\n    top: 15px;\n    bottom: 15px;\n    transition: opacity .3s ease;\n    border-radius: 5px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  background: #3A507B;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 15px;\n    right: 15px;\n    top: 15px;\n    bottom: 15px;\n    transition: opacity .3s ease;\n    border-radius: 5px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n'], ['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  margin-top: 32px;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  margin-top: 32px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  padding: 2px 15px;\n  background: #fff;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  font-family: Mukta Vaani;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 28px;\n'], ['\n  border-radius: 4px;\n  padding: 2px 15px;\n  background: #fff;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  font-family: Mukta Vaani;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 28px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  color: #5C91F5;\n'], ['\n  color: #5C91F5;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  color: rgba(0, 27, 59, 0.94);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _welcome = __webpack_require__(1919);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _onboardingWelcomeRound = __webpack_require__(2643);
	
	var _onboardingWelcomeRound2 = _interopRequireDefault(_onboardingWelcomeRound);
	
	var _onboardingWelcomeRound3 = __webpack_require__(2644);
	
	var _onboardingWelcomeRound4 = _interopRequireDefault(_onboardingWelcomeRound3);
	
	var _onboardingWelcomeRound5 = __webpack_require__(2645);
	
	var _onboardingWelcomeRound6 = _interopRequireDefault(_onboardingWelcomeRound5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var roundsVideos = [_onboardingWelcomeRound2.default, _onboardingWelcomeRound4.default, _onboardingWelcomeRound6.default];
	
	var level1Controls = [{ time: 0, timeLabel: 0, label: "Overview" }, { time: 32, timeLabel: 30, label: "Research" }, { time: 48, timeLabel: 40, label: "The Decisions" }, { time: 103, timeLabel: 100, label: "Sales Process" }, { time: 147, timeLabel: 135, label: "Review" }];
	
	var level2Controls = [{ time: 0, timeLabel: 0, label: "Overview" }, { time: 18, timeLabel: 15, label: "Customer" }, { time: 26, timeLabel: 25, label: "Product" }, { time: 62, timeLabel: 62, label: "Operations" }, { time: 87.5, timeLabel: 90, label: "Finance" }];
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var VideoWrapper = _styledComponents2.default.div(_templateObject6);
	
	var PlayPauseButton = _styledComponents2.default.button(_templateObject7);
	
	var ControlButtonsRow = _styledComponents2.default.div(_templateObject8);
	
	var ControlButton = _styledComponents2.default.button(_templateObject9);
	
	var ControlButtonFirstLine = _styledComponents2.default.span(_templateObject10);
	
	var ControlButtonSecondLine = _styledComponents2.default.span(_templateObject11);
	
	var WelcomeStep1 = function (_PureComponent) {
	  _inherits(WelcomeStep1, _PureComponent);
	
	  function WelcomeStep1(props) {
	    _classCallCheck(this, WelcomeStep1);
	
	    var _this = _possibleConstructorReturn(this, (WelcomeStep1.__proto__ || Object.getPrototypeOf(WelcomeStep1)).call(this, props));
	
	    _this.handlePlayPause = function () {
	      if (_this.videoRef) {
	        if (_this.state.isPlaying) {
	          _this.videoRef.pause();
	        } else {
	          _this.videoRef.play();
	        }
	        _this.setState({ isPlaying: !_this.state.isPlaying });
	      }
	    };
	
	    _this.seekTo = function (time) {
	      if (_this.videoRef) {
	        _this.videoRef.currentTime = time;
	        _this.videoRef.play();
	        _this.setState({ isPlaying: true });
	      }
	    };
	
	    _this.state = {
	      isPlaying: false
	    };
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(WelcomeStep1, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          roundInUrl = _props.roundInUrl,
	          currentRound = _props.currentRound;
	
	      var activeRound = roundInUrl || currentRound;
	
	      var validVideoIndex = activeRound - 1 < roundsVideos.length ? activeRound - 1 : 0;
	      var isPlaying = this.state.isPlaying;
	
	
	      var controls = currentRound === 2 ? level2Controls : level1Controls;
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            _welcome2.default.rounds[activeRound - 1].text1
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            _welcome2.default.rounds[activeRound - 1].text2
	          ),
	          _react2.default.createElement(Text3, { dangerouslySetInnerHTML: { __html: _welcome2.default.rounds[activeRound - 1].text3 } }),
	          _react2.default.createElement(
	            VideoWrapper,
	            { className: isPlaying ? 'is-playing' : '' },
	            _react2.default.createElement('video', {
	              ref: function ref(_ref) {
	                _this2.videoRef = _ref;
	              },
	              src: roundsVideos[validVideoIndex],
	              alt: 'Welcome Video',
	              onClick: this.handlePlayPause,
	              onEnded: function onEnded() {
	                return _this2.setState({ isPlaying: false });
	              },
	              style: { width: '100%', borderRadius: 5 }
	            }),
	            _react2.default.createElement(
	              PlayPauseButton,
	              { onClick: this.handlePlayPause },
	              isPlaying ? '❚❚' : '▶'
	            )
	          ),
	          currentRound < 3 && _react2.default.createElement(
	            ControlButtonsRow,
	            null,
	            controls.map(function (_ref2, index) {
	              var time = _ref2.time,
	                  timeLabel = _ref2.timeLabel,
	                  label = _ref2.label;
	              return _react2.default.createElement(
	                ControlButton,
	                { key: index, onClick: function onClick() {
	                    return _this2.seekTo(time);
	                  } },
	                _react2.default.createElement(
	                  ControlButtonFirstLine,
	                  null,
	                  'From (',
	                  new Date(timeLabel * 1000).toISOString().substr(14, 5),
	                  ')'
	                ),
	                _react2.default.createElement(
	                  ControlButtonSecondLine,
	                  null,
	                  label
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return WelcomeStep1;
	}(_react.PureComponent);
	
	exports.default = WelcomeStep1;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  background: #6FD1D9;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 30px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n'], ['\n  background: #6FD1D9;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 30px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  background: #2A4169;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 12px;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n'], ['\n  background: #2A4169;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 12px;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n'], ['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 212px;\n  margin-left: 12px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 212px;\n  margin-left: 12px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n'], ['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  margin-left: 5px;\n  position: relative;\n  padding: 0 12px;\n\n  &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    bottom: 8px;\n    height: 43px;\n    left: 0;\n    right: 0;\n    border-radius: 4px;\n    border: 2px solid #2A4169;\n  }\n'], ['\n  margin-left: 5px;\n  position: relative;\n  padding: 0 12px;\n\n  &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    bottom: 8px;\n    height: 43px;\n    left: 0;\n    right: 0;\n    border-radius: 4px;\n    border: 2px solid #2A4169;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _conductResearch = __webpack_require__(1917);
	
	var _conductResearch2 = _interopRequireDefault(_conductResearch);
	
	var _onboardingConductResearch = __webpack_require__(1060);
	
	var _onboardingConductResearch2 = _interopRequireDefault(_onboardingConductResearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var FormulaBlock = _styledComponents2.default.div(_templateObject6);
	
	var FormulaLeftPart = _styledComponents2.default.div(_templateObject7);
	
	var EqualitySign = _styledComponents2.default.div(_templateObject8);
	
	var FormulaRightPart = _styledComponents2.default.div(_templateObject9);
	
	var FormulaDivider = _styledComponents2.default.div(_templateObject10);
	
	var Image = _styledComponents2.default.div(_templateObject11);
	
	var ConductResearch = function (_PureComponent) {
	  _inherits(ConductResearch, _PureComponent);
	
	  function ConductResearch() {
	    _classCallCheck(this, ConductResearch);
	
	    return _possibleConstructorReturn(this, (ConductResearch.__proto__ || Object.getPrototypeOf(ConductResearch)).apply(this, arguments));
	  }
	
	  _createClass(ConductResearch, [{
	    key: 'render',
	    value: function render() {
	      var roundInUrl = this.props.roundInUrl;
	
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'Conduct Research | Prior Round Financial Statements'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _conductResearch2.default.rounds[roundInUrl - 1].text3
	            )
	          ),
	          _react2.default.createElement(
	            FormulaBlock,
	            null,
	            _react2.default.createElement(
	              FormulaLeftPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'ROI Metrics'
	              )
	            ),
	            _react2.default.createElement(EqualitySign, null),
	            _react2.default.createElement(
	              FormulaRightPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Income Statements'
	              ),
	              _react2.default.createElement(FormulaDivider, null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Balance Sheet'
	              )
	            ),
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _onboardingConductResearch2.default, alt: '' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConductResearch;
	}(_react.PureComponent);
	
	exports.default = ConductResearch;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #2da548;\n  }\n\n  strong {\n    color: #ec5e59;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #2da548;\n  }\n\n  strong {\n    color: #ec5e59;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _customerPreferences = __webpack_require__(1918);
	
	var _customerPreferences2 = _interopRequireDefault(_customerPreferences);
	
	var _onboardingCustomerPreferences = __webpack_require__(2637);
	
	var _onboardingCustomerPreferences2 = _interopRequireDefault(_onboardingCustomerPreferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var CustomerPreferences = function (_PureComponent) {
	  _inherits(CustomerPreferences, _PureComponent);
	
	  function CustomerPreferences(props) {
	    _classCallCheck(this, CustomerPreferences);
	
	    var _this = _possibleConstructorReturn(this, (CustomerPreferences.__proto__ || Object.getPrototypeOf(CustomerPreferences)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CustomerPreferences, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setMode('basic');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var roundInUrl = this.props.roundInUrl;
	
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            _customerPreferences2.default.rounds[roundInUrl - 1].text1
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            _customerPreferences2.default.rounds[roundInUrl - 1].text2
	          ),
	          _react2.default.createElement(Text3, { dangerouslySetInnerHTML: { __html: _customerPreferences2.default.rounds[roundInUrl - 1].text3 } }),
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement('img', { src: _onboardingCustomerPreferences2.default, alt: '' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomerPreferences;
	}(_react.PureComponent);
	
	exports.default = CustomerPreferences;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: #5c91f5;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: #5c91f5;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n\n  img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n  }\n'], ['\n  display: flex;\n  margin-top: 12px;\n\n  img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingDistributionCenters = __webpack_require__(2638);
	
	var _onboardingDistributionCenters2 = _interopRequireDefault(_onboardingDistributionCenters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var DistributionCenters = function (_PureComponent) {
	  _inherits(DistributionCenters, _PureComponent);
	
	  function DistributionCenters() {
	    _classCallCheck(this, DistributionCenters);
	
	    return _possibleConstructorReturn(this, (DistributionCenters.__proto__ || Object.getPrototypeOf(DistributionCenters)).apply(this, arguments));
	  }
	
	  _createClass(DistributionCenters, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'Distribution Centers'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'You currently have 1 central location that you use to deliver your products to customers: your production facility. You\u2019ll now have the option to open up a distribution center that could help reduce your lead time and thereby capture more customers if your lead time is better.'
	            )
	          ),
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement('img', { src: _onboardingDistributionCenters2.default, alt: '' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DistributionCenters;
	}(_react.PureComponent);
	
	exports.default = DistributionCenters;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  b {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  p {\n    margin-bottom: 8px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  b {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingMachineOptions = __webpack_require__(2640);
	
	var _onboardingMachineOptions2 = _interopRequireDefault(_onboardingMachineOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var MachineOptions = function (_PureComponent) {
	  _inherits(MachineOptions, _PureComponent);
	
	  function MachineOptions() {
	    _classCallCheck(this, MachineOptions);
	
	    return _possibleConstructorReturn(this, (MachineOptions.__proto__ || Object.getPrototypeOf(MachineOptions)).apply(this, arguments));
	  }
	
	  _createClass(MachineOptions, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'Manufacturing Machine Options'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Also, your team will have new Ops decisions to consider.  Machine options is one and these are the options:  '
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Option 1:'
	              ),
	              ' Keep existing production lines with no changes.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Option 2:'
	              ),
	              ' Keep existing production line and buy additional lines.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Option 3:'
	              ),
	              ' Sell the existing production line and upgrade to another line.'
	            )
	          ),
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement('img', { src: _onboardingMachineOptions2.default, alt: '' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MachineOptions;
	}(_react.PureComponent);
	
	exports.default = MachineOptions;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  background: #E5F4E9;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 76px 59px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n'], ['\n  background: #E5F4E9;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 76px 59px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  background: #2DA548;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 24px;\n'], ['\n  background: #2DA548;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 24px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n'], ['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 324px;\n  margin-left: 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    color: #EC5E59;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 324px;\n  margin-left: 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    color: #EC5E59;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n'], ['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var FormulaBlock = _styledComponents2.default.div(_templateObject6);
	
	var FormulaLeftPart = _styledComponents2.default.div(_templateObject7);
	
	var EqualitySign = _styledComponents2.default.div(_templateObject8);
	
	var FormulaRightPart = _styledComponents2.default.div(_templateObject9);
	
	var FormulaDivider = _styledComponents2.default.div(_templateObject10);
	
	var NewMetricEPS = function (_PureComponent) {
	  _inherits(NewMetricEPS, _PureComponent);
	
	  function NewMetricEPS() {
	    _classCallCheck(this, NewMetricEPS);
	
	    return _possibleConstructorReturn(this, (NewMetricEPS.__proto__ || Object.getPrototypeOf(NewMetricEPS)).apply(this, arguments));
	  }
	
	  _createClass(NewMetricEPS, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'New Scoring Metric: Earnings Per Share (EPS)'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Investors will continue to evaluate the return on their investment using net profits as a measure of that return.  Therefore, make sure your company makes a profit. '
	            )
	          ),
	          _react2.default.createElement(
	            FormulaBlock,
	            null,
	            _react2.default.createElement(
	              FormulaLeftPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Earnings Per Share'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '(EPS)'
	              )
	            ),
	            _react2.default.createElement(EqualitySign, null),
	            _react2.default.createElement(
	              FormulaRightPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Net Profits'
	              ),
	              _react2.default.createElement(FormulaDivider, null),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  '*'
	                ),
	                ' Average Total Shares Outstanding'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Earnings Per Share (EPS) is one of the profit driven metrics that will be used to measure your performance this round. ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.investopedia.com/terms/e/eps.asp#:~:text=Earnings per share (EPS) is a company\'s net profit divided,metric for estimating corporate value', target: '_blank', rel: 'noreferrer' },
	                'Learn More'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewMetricEPS;
	}(_react.PureComponent);
	
	exports.default = NewMetricEPS;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  background: #E6EDFB;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 76px 60px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n'], ['\n  background: #E6EDFB;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 76px 60px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  background: #5C91F5;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 24px;\n'], ['\n  background: #5C91F5;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 24px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n'], ['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 202px;\n  margin-left: 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    color: #EC5E59;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 202px;\n  margin-left: 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    color: #EC5E59;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n'], ['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var FormulaBlock = _styledComponents2.default.div(_templateObject6);
	
	var FormulaLeftPart = _styledComponents2.default.div(_templateObject7);
	
	var EqualitySign = _styledComponents2.default.div(_templateObject8);
	
	var FormulaRightPart = _styledComponents2.default.div(_templateObject9);
	
	var FormulaDivider = _styledComponents2.default.div(_templateObject10);
	
	var NewMetricROA = function (_PureComponent) {
	  _inherits(NewMetricROA, _PureComponent);
	
	  function NewMetricROA() {
	    _classCallCheck(this, NewMetricROA);
	
	    return _possibleConstructorReturn(this, (NewMetricROA.__proto__ || Object.getPrototypeOf(NewMetricROA)).apply(this, arguments));
	  }
	
	  _createClass(NewMetricROA, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'New Scoring Metric ROA'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Return on Assets (RoA) is another profit driven metrics that will be used to measure your performance this round. ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.investopedia.com/terms/r/returnonassets.asp', target: '_blank', rel: 'noreferrer' },
	                'Learn More'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            FormulaBlock,
	            null,
	            _react2.default.createElement(
	              FormulaLeftPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Return on Assets'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '(ROA)'
	              )
	            ),
	            _react2.default.createElement(EqualitySign, null),
	            _react2.default.createElement(
	              FormulaRightPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Net Profits'
	              ),
	              _react2.default.createElement(FormulaDivider, null),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  '*'
	                ),
	                ' Average Total Assets'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewMetricROA;
	}(_react.PureComponent);
	
	exports.default = NewMetricROA;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  background: #EAE4F9;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 76px 60px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n'], ['\n  background: #EAE4F9;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 76px 60px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  background: #A98DF6;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 24px;\n'], ['\n  background: #A98DF6;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 24px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n'], ['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 202px;\n  margin-left: 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    color: #EC5E59;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 202px;\n  margin-left: 24px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    color: #EC5E59;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n'], ['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var FormulaBlock = _styledComponents2.default.div(_templateObject6);
	
	var FormulaLeftPart = _styledComponents2.default.div(_templateObject7);
	
	var EqualitySign = _styledComponents2.default.div(_templateObject8);
	
	var FormulaRightPart = _styledComponents2.default.div(_templateObject9);
	
	var FormulaDivider = _styledComponents2.default.div(_templateObject10);
	
	var NewMetricROE = function (_PureComponent) {
	  _inherits(NewMetricROE, _PureComponent);
	
	  function NewMetricROE() {
	    _classCallCheck(this, NewMetricROE);
	
	    return _possibleConstructorReturn(this, (NewMetricROE.__proto__ || Object.getPrototypeOf(NewMetricROE)).apply(this, arguments));
	  }
	
	  _createClass(NewMetricROE, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'New Scoring Metric: Return on Equity (ROE)'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'In this round, investors will be evaluating the return on their investment (ROI) and will use net profits as a measure of that return.  Therefore, your company has to make a profit.'
	            )
	          ),
	          _react2.default.createElement(
	            FormulaBlock,
	            null,
	            _react2.default.createElement(
	              FormulaLeftPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Return on Equity'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '(ROE)'
	              )
	            ),
	            _react2.default.createElement(EqualitySign, null),
	            _react2.default.createElement(
	              FormulaRightPart,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Net Income'
	              ),
	              _react2.default.createElement(FormulaDivider, null),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  '*'
	                ),
	                ' Average Total Equity'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Return on Equity (RoE) is one of the profit driven metrics that will be used to measure your performance this round. ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.investopedia.com/terms/r/returnonequity.asp#:~:text=Return on equity (ROE) is the measure of a company\'s,its equity financing into profits.', target: '_blank', rel: 'noreferrer' },
	                'Learn More'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewMetricROE;
	}(_react.PureComponent);
	
	exports.default = NewMetricROE;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #2da548;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #2da548;\n  }\n\n  strong {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  margin-top: 12px;\n\n  > div:first-child {\n    grid-column: 3;\n    text-align: center;\n    margin-bottom: 12px;\n  }\n  \n  > div:nth-child(2) {\n    grid-column: 3;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-bottom: 7px;\n  }\n  \n  > div:nth-child(3) {\n    display: flex;\n    align-items: center;\n    width: 176px;\n  }\n  \n  > div:nth-child(4) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 36px;\n  }\n'], ['\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  margin-top: 12px;\n\n  > div:first-child {\n    grid-column: 3;\n    text-align: center;\n    margin-bottom: 12px;\n  }\n  \n  > div:nth-child(2) {\n    grid-column: 3;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-bottom: 7px;\n  }\n  \n  > div:nth-child(3) {\n    display: flex;\n    align-items: center;\n    width: 176px;\n  }\n  \n  > div:nth-child(4) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 36px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  background: rgba(0, 27, 43, 0.02);\n  border-radius: 4px;\n  padding: 2px 8px;\n  color: rgba(0, 27, 59, 0.6);\n  display: inline-block;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  background: rgba(0, 27, 43, 0.02);\n  border-radius: 4px;\n  padding: 2px 8px;\n  color: rgba(0, 27, 59, 0.6);\n  display: inline-block;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  width: 100px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  width: 100px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  transform: rotate(-90deg) translateX(-2%);\n\n  &:first-child {\n    transform: rotate(-90deg) translateX(-15%);\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  transform: rotate(-90deg) translateX(-2%);\n\n  &:first-child {\n    transform: rotate(-90deg) translateX(-15%);\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n  row-gap: 20px;\n  column-gap: 20px;\n  width: fit-content;\n  position: relative;\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 12px;\n    height: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  &:after {\n    display: block;\n    content: \'\';\n    height: 12px;\n    width: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  > div {\n    width: 220px;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    color: #fff;\n\n    &:first-child {\n      background: #F9C151;\n      color: rgba(0, 27, 59, 0.94);\n    }\n\n    &:nth-child(2) {\n      background: #52C5CD;\n    }\n\n    &:nth-child(3) {\n      background: #EC5E59;\n    }\n\n    &:nth-child(4) {\n      background: #2A4169;\n    }\n  }\n'], ['\n  display: grid;\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n  row-gap: 20px;\n  column-gap: 20px;\n  width: fit-content;\n  position: relative;\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 12px;\n    height: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  &:after {\n    display: block;\n    content: \'\';\n    height: 12px;\n    width: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  > div {\n    width: 220px;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    color: #fff;\n\n    &:first-child {\n      background: #F9C151;\n      color: rgba(0, 27, 59, 0.94);\n    }\n\n    &:nth-child(2) {\n      background: #52C5CD;\n    }\n\n    &:nth-child(3) {\n      background: #EC5E59;\n    }\n\n    &:nth-child(4) {\n      background: #2A4169;\n    }\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 4px; \n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 4px; \n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingWhatToExpectLineVertical = __webpack_require__(691);
	
	var _onboardingWhatToExpectLineVertical2 = _interopRequireDefault(_onboardingWhatToExpectLineVertical);
	
	var _onboardingWhatToExpectLineHorizontal = __webpack_require__(690);
	
	var _onboardingWhatToExpectLineHorizontal2 = _interopRequireDefault(_onboardingWhatToExpectLineHorizontal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var MarketsCustomersBlock1 = _styledComponents2.default.div(_templateObject6);
	
	var MarketsCustomersLabel = _styledComponents2.default.div(_templateObject7);
	
	var MarketsCustomersHeader = _styledComponents2.default.div(_templateObject8);
	
	var MarketsCustomersHeaderRotated = _styledComponents2.default.div(_templateObject9);
	
	var MarketsCustomersBlock2 = _styledComponents2.default.div(_templateObject10, _onboardingWhatToExpectLineVertical2.default, _onboardingWhatToExpectLineHorizontal2.default);
	
	var MarketsCustomersTitle = _styledComponents2.default.h4(_templateObject11);
	
	var MarketsCustomersText = _styledComponents2.default.p(_templateObject12);
	
	var ProductStrategy = function (_PureComponent) {
	  _inherits(ProductStrategy, _PureComponent);
	
	  function ProductStrategy() {
	    _classCallCheck(this, ProductStrategy);
	
	    return _possibleConstructorReturn(this, (ProductStrategy.__proto__ || Object.getPrototypeOf(ProductStrategy)).apply(this, arguments));
	  }
	
	  _createClass(ProductStrategy, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'Product Market Expansion Options'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Expect competition to continue to heat up in ',
	              _react2.default.createElement(
	                'b',
	                null,
	                'Round 2'
	              ),
	              '. Therefore, your team will need to be more strategic and vigilant. As you can see below, there are a few product market expansion strategies to consider. ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.mindtools.com/pages/article/newTMC_90.htm', target: '_blank', rel: 'noreferrer' },
	                'Learn More'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            MarketsCustomersBlock1,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersLabel,
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'PRODUCTS'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersHeader,
	                null,
	                'Current'
	              ),
	              _react2.default.createElement(
	                MarketsCustomersHeader,
	                null,
	                'New'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersLabel,
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'MARKETS/ CUSTOMERS'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '(auto & mobile)'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersHeaderRotated,
	                null,
	                'Current'
	              ),
	              _react2.default.createElement(
	                MarketsCustomersHeaderRotated,
	                null,
	                'New'
	              )
	            ),
	            _react2.default.createElement(
	              MarketsCustomersBlock2,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  MarketsCustomersTitle,
	                  null,
	                  'Market Penetration'
	                ),
	                _react2.default.createElement(
	                  MarketsCustomersText,
	                  null,
	                  'Penetrate existing market (auto or mobile)'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  MarketsCustomersTitle,
	                  null,
	                  'Product Development'
	                ),
	                _react2.default.createElement(
	                  MarketsCustomersText,
	                  null,
	                  'Not Applicable'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  MarketsCustomersTitle,
	                  null,
	                  'Market Development'
	                ),
	                _react2.default.createElement(
	                  MarketsCustomersText,
	                  null,
	                  'Enter new markets with existing products (auto or mobile)'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  MarketsCustomersTitle,
	                  null,
	                  'Diversification'
	                ),
	                _react2.default.createElement(
	                  MarketsCustomersText,
	                  null,
	                  'Enter new markets with new products (auto or mobile)'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Tip:'
	              ),
	              ' Strategies are best executed when you understand your competitive position. Therefore review round 1 Team Report to better understand your competitors\u2019 moves.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductStrategy;
	}(_react.PureComponent);
	
	exports.default = ProductStrategy;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  a {\n    color: #5c91f5;\n  }\n\n  b {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  a {\n    color: #5c91f5;\n  }\n\n  b {\n    font-weight: 700;\n    color: rgba(0, 27, 59, 1);\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _shareBuyback = __webpack_require__(1065);
	
	var _shareBuyback2 = _interopRequireDefault(_shareBuyback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var ShareBuyback = function (_PureComponent) {
	  _inherits(ShareBuyback, _PureComponent);
	
	  function ShareBuyback() {
	    _classCallCheck(this, ShareBuyback);
	
	    return _possibleConstructorReturn(this, (ShareBuyback.__proto__ || Object.getPrototypeOf(ShareBuyback)).apply(this, arguments));
	  }
	
	  _createClass(ShareBuyback, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            Text1,
	            null,
	            'What to expect'
	          ),
	          _react2.default.createElement(
	            Text2,
	            null,
	            'Share Buyback'
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your Head of Finance will be able to buyback ownership shares from investors. There are a variety of reasons why companies buyback shares. ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.investopedia.com/articles/investing/112013/impact-share-repurchases.asp#:~:text=The buyback will simultaneously shrink,subsequent to a share buyback.', target: '_blank', rel: 'noreferrer' },
	                'Reason 1'
	              ),
	              ', ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://hbr.org/2001/04/is-a-share-buyback-right-for-your-company', target: '_blank', rel: 'noreferrer' },
	                'Reason 2'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement('img', { src: _shareBuyback2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            Text3,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Tip:'
	              ),
	              ' Buying back shares has an impact on your Balance Sheet\u2019s Total Equity.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShareBuyback;
	}(_react.PureComponent);
	
	exports.default = ShareBuyback;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 0 48px 48px;\n  max-width: 1280px;\n  margin: 0 auto;\n  font-family: ", ";\n"], ["\n  padding: 0 48px 48px;\n  max-width: 1280px;\n  margin: 0 auto;\n  font-family: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0 16px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 32px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 32px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  background: #F4F6FB;\n  border-radius: 12px;\n  padding: 24px 28px;\n  margin-bottom: 24px;\n"], ["\n  background: #F4F6FB;\n  border-radius: 12px;\n  padding: 24px 28px;\n  margin-bottom: 24px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"], ["\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  text-align: right;\n"], ["\n  text-align: right;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 36px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 36px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.4);\n  margin-left: 4px;\n"], ["\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.4);\n  margin-left: 4px;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"], ["\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  height: 6px;\n  background: #DEE3EC;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-top: 18px;\n"], ["\n  height: 6px;\n  background: #DEE3EC;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-top: 18px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  height: 100%;\n  background: #5C91F5;\n  width: ", "%;\n  transition: width 0.2s ease;\n"], ["\n  height: 100%;\n  background: #5C91F5;\n  width: ", "%;\n  transition: width 0.2s ease;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-top: 18px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-top: 18px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 8px;\n  padding: 14px 18px;\n"], ["\n  background: #fff;\n  border-radius: 8px;\n  padding: 14px 18px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  letter-spacing: 0;\n  text-transform: none;\n  width: 240px;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #FFFFFF;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  letter-spacing: 0;\n  text-transform: none;\n  width: 240px;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.4);\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 27, 59, 0.4);\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 4px;\n"], ["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 4px;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"], ["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 14px;\n  margin-left: 28px;\n  width: 75%;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 14px;\n  margin-left: 28px;\n  width: 75%;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"], ["\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: 10px;\n  padding: 22px 24px;\n  margin-bottom: 14px;\n  margin-left: 28px;\n  width: 75%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n"], ["\n  background: #fff;\n  border-radius: 10px;\n  padding: 22px 24px;\n  margin-bottom: 14px;\n  margin-left: 28px;\n  width: 75%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  margin-bottom: 14px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  margin-bottom: 14px;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.status-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.status-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.3px;\n\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.3px;\n\n  ", "\n  ", "\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  width: 240px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  width: 240px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n\n  strong {\n    color: #5C91F5;\n    font-weight: 600;\n  }\n"], ["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n\n  strong {\n    color: #5C91F5;\n    font-weight: 600;\n  }\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 280px;\n  gap: 28px;\n  align-items: start;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 280px;\n  gap: 28px;\n  align-items: start;\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"], ["\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 8px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 8px;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  0%   { box-shadow: 0 0 0 0 rgba(92, 145, 245, 0.55); }\n  70%  { box-shadow: 0 0 0 12px rgba(92, 145, 245, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(92, 145, 245, 0); }\n"], ["\n  0%   { box-shadow: 0 0 0 0 rgba(92, 145, 245, 0.55); }\n  70%  { box-shadow: 0 0 0 12px rgba(92, 145, 245, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(92, 145, 245, 0); }\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-radius: 8px;\n  background: ", ";\n  border: 1px solid ", ";\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n\n  ", "\n\n  ", "\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-radius: 8px;\n  background: ", ";\n  border: 1px solid ", ";\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n\n  ", "\n\n  ", "\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n    background: #EBF2FF;\n    border-color: #5C91F5;\n    animation: ", " 1.6s ease-out infinite;\n  "], ["\n    background: #EBF2FF;\n    border-color: #5C91F5;\n    animation: ", " 1.6s ease-out infinite;\n  "]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n\n  &:hover > span.machine-locked-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: block;\n\n  &:hover > span.machine-locked-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject43 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 320px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 320px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid ", ";\n  background: #fff;\n  margin-right: 12px;\n  flex-shrink: 0;\n  position: relative;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"], ["\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid ", ";\n  background: #fff;\n  margin-right: 12px;\n  flex-shrink: 0;\n  position: relative;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n"], ["\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 12px;\n"], ["\n  position: relative;\n  margin-bottom: 12px;\n"]),
	    _templateObject48 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 14px 64px 14px 16px;\n  border-radius: 8px;\n  border: 1px solid #D5D9DD;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: left;\n  background: #fff;\n\n  &:focus {\n    outline: none;\n    border-color: #5C91F5;\n  }\n"], ["\n  width: 100%;\n  padding: 14px 64px 14px 16px;\n  border-radius: 8px;\n  border: 1px solid #D5D9DD;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: left;\n  background: #fff;\n\n  &:focus {\n    outline: none;\n    border-color: #5C91F5;\n  }\n"]),
	    _templateObject49 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #C62828;\n  margin-top: -4px;\n  margin-bottom: 10px;\n"], ["\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #C62828;\n  margin-top: -4px;\n  margin-bottom: 10px;\n"]),
	    _templateObject50 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: #2DA548;\n  margin-top: -4px;\n  margin-bottom: 10px;\n"], ["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: #2DA548;\n  margin-top: -4px;\n  margin-bottom: 10px;\n"]),
	    _templateObject51 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  pointer-events: none;\n"], ["\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  pointer-events: none;\n"]),
	    _templateObject52 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 14px;\n  border-radius: 8px;\n  border: none;\n  background: #B6BAE5;\n  color: #fff;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: #9DA1D8;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  ", "\n"], ["\n  width: 100%;\n  padding: 14px;\n  border-radius: 8px;\n  border: none;\n  background: #B6BAE5;\n  color: #fff;\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: #9DA1D8;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  ", "\n"]),
	    _templateObject53 = _taggedTemplateLiteral(["\n  position: relative;\n\n  &:hover .produce-units-tooltip { visibility: visible; opacity: 1; }\n"], ["\n  position: relative;\n\n  &:hover .produce-units-tooltip { visibility: visible; opacity: 1; }\n"]),
	    _templateObject54 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 240px;\n  max-width: 320px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.85);\n  text-align: center;\n  text-transform: none;\n  letter-spacing: normal;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n  z-index: 10;\n  pointer-events: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #ffffff;\n    border-right: 1px solid #D5D9DD;\n    border-bottom: 1px solid #D5D9DD;\n  }\n"], ["\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 240px;\n  max-width: 320px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);\n  font-family: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.85);\n  text-align: center;\n  text-transform: none;\n  letter-spacing: normal;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n  z-index: 10;\n  pointer-events: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #ffffff;\n    border-right: 1px solid #D5D9DD;\n    border-bottom: 1px solid #D5D9DD;\n  }\n"]),
	    _templateObject55 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 80px 0;\n"], ["\n  display: flex;\n  justify-content: center;\n  padding: 80px 0;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactLoaders2 = _interopRequireDefault(_reactLoaders);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _utils = __webpack_require__(18);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Location = __webpack_require__(23);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AVAILABLE_MACHINES_URL = ("https://be-production-itb.marketgames.io/api/") + "static/machines/";
	var TEAM_MACHINES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/machines/";
	var PRODUCT_MANUFACTURES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/";
	
	// Annual operating hours used to convert units_per_hour → annual capacity.
	// Matches the figure used elsewhere on the Operations page (see Machine
	// Utilization help copy).
	var ANNUAL_HOURS = 8736;
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	// Tween a numeric value from its previous to current prop over ~600ms
	// using requestAnimationFrame + easeOutCubic. Mirrors the CountUp
	// pattern from Choose Your Lender / Choose Your Equity Investor — used
	// for Scheduled and Total Available so they animate after a successful
	// production post.
	
	var CountUp = function (_PureComponent) {
	  _inherits(CountUp, _PureComponent);
	
	  function CountUp(props) {
	    _classCallCheck(this, CountUp);
	
	    var _this = _possibleConstructorReturn(this, (CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call(this, props));
	
	    _this.state = { display: Number(props.value) || 0 };
	    return _this;
	  }
	
	  _createClass(CountUp, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var next = Number(this.props.value) || 0;
	      var prev = Number(prevProps.value) || 0;
	      if (next !== prev) {
	        this.animateTo(this.state.display, next);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._cancelled = true;
	    }
	  }, {
	    key: "animateTo",
	    value: function animateTo(from, to) {
	      var _this2 = this;
	
	      if (this._raf) cancelAnimationFrame(this._raf);
	      var duration = 600;
	      var start = typeof performance !== 'undefined' ? performance.now() : Date.now();
	      var step = function step() {
	        if (_this2._cancelled) return;
	        var elapsed = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start;
	        var t = Math.min(elapsed / duration, 1);
	        var eased = 1 - Math.pow(1 - t, 3);
	        var value = from + (to - from) * eased;
	        _this2.setState({ display: t === 1 ? to : value });
	        if (t < 1) {
	          _this2._raf = requestAnimationFrame(step);
	        }
	      };
	      this._raf = requestAnimationFrame(step);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var format = this.props.format;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        format(this.state.display)
	      );
	    }
	  }]);
	
	  return CountUp;
	}(_react.PureComponent);
	
	var formatInt = function formatInt(n) {
	  return Math.round(Number(n) || 0).toLocaleString('en-US');
	};
	
	var Page = _styledComponents2.default.div(_templateObject, FONT);
	
	var HeaderRow = _styledComponents2.default.div(_templateObject2);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject3);
	
	var HeaderTitle = _styledComponents2.default.h2(_templateObject4);
	
	var HeaderSubtitle = _styledComponents2.default.div(_templateObject5);
	
	var CloseButton = _styledComponents2.default.button(_templateObject6);
	
	var CapacityCard = _styledComponents2.default.div(_templateObject7);
	
	var CapacityCardTopRow = _styledComponents2.default.div(_templateObject8);
	
	var CapacityCardHeading = _styledComponents2.default.div(_templateObject3);
	
	var SectionLabel = _styledComponents2.default.div(_templateObject9);
	
	var CapacityCardSubtitle = _styledComponents2.default.div(_templateObject10);
	
	var CapacityNumbers = _styledComponents2.default.div(_templateObject11);
	
	var CapacityScheduled = _styledComponents2.default.span(_templateObject12);
	
	var CapacityTotal = _styledComponents2.default.span(_templateObject13);
	
	var CapacityUtilization = _styledComponents2.default.div(_templateObject14);
	
	var ProgressBar = _styledComponents2.default.div(_templateObject15);
	
	var ProgressFill = _styledComponents2.default.div(_templateObject16, function (p) {
	  return Math.min(100, Math.max(0, p.pct || 0));
	});
	
	var CapacityMiniRow = _styledComponents2.default.div(_templateObject17);
	
	var CapacityMiniCard = _styledComponents2.default.div(_templateObject18);
	
	var CapacityMiniLabel = _styledComponents2.default.div(_templateObject19);
	
	var InfoTooltip = _styledComponents2.default.div(_templateObject20);
	
	var InfoIconWrapper = _styledComponents2.default.span(_templateObject21, InfoTooltip);
	
	var CapacityMiniValue = _styledComponents2.default.div(_templateObject22);
	
	var CapacityMiniSub = _styledComponents2.default.div(_templateObject23);
	
	var ScheduleHeader = _styledComponents2.default.div(_templateObject24);
	
	var ScheduleTitle = _styledComponents2.default.div(_templateObject25);
	
	var ScheduleHint = _styledComponents2.default.div(_templateObject26);
	
	var ProductCard = _styledComponents2.default.div(_templateObject27);
	
	var ProductHeader = _styledComponents2.default.div(_templateObject28);
	
	var ProductNameRow = _styledComponents2.default.div(_templateObject29);
	
	var ProductName = _styledComponents2.default.div(_templateObject30);
	
	var StatusBadgeWrapper = _styledComponents2.default.span(_templateObject31);
	
	var StatusBadge = _styledComponents2.default.span(_templateObject32, FONT, function (p) {
	  return p.variant === 'released' && "\n    background: #E8F5EC;\n    color: #2DA548;\n    border: 1px solid #B7DEC2;\n  ";
	}, function (p) {
	  return p.variant === 'not-released' && "\n    background: #FFF1DD;\n    color: #C77700;\n    border: 1px solid #F0CB91;\n    cursor: help;\n  ";
	});
	
	var StatusTooltip = _styledComponents2.default.span(_templateObject33, FONT);
	
	var ProductDemand = _styledComponents2.default.div(_templateObject34);
	
	var ProductBody = _styledComponents2.default.div(_templateObject35);
	
	var ColumnLabel = _styledComponents2.default.div(_templateObject36);
	
	var MachineHeaderRow = _styledComponents2.default.div(_templateObject37);
	
	var MachineList = _styledComponents2.default.div(_templateObject38);
	
	// Pulsing halo used when this product has no production yet and it's
	// Round 1 — visually nudges the student toward the machine-line rows
	// so they realize they need to pick one before hitting Produce.
	var machineOptionPulse = (0, _styledComponents.keyframes)(_templateObject39);
	
	var MachineOption = _styledComponents2.default.label(_templateObject40, function (p) {
	  return p.selected ? '#EBF2FF' : '#F5F6F7';
	}, function (p) {
	  return p.selected ? '#5C91F5' : 'transparent';
	}, function (p) {
	  return p.selected ? '#EBF2FF' : '#EEF1F5';
	}, function (p) {
	  return p.attention && !p.selected && (0, _styledComponents.css)(_templateObject41, machineOptionPulse);
	}, function (p) {
	  return p.locked && "\n    opacity: 0.5;\n    cursor: not-allowed;\n    &:hover { background: #F5F6F7; }\n  ";
	});
	
	// Wrapper + tooltip for a machine option that has been locked out
	// because the product is already committed to a different line this
	// round. Tooltip renders on top-right corner of the row so it doesn't
	// clash with the radio dot on the left.
	var MachineOptionWrapper = _styledComponents2.default.span(_templateObject42);
	
	var MachineLockedTooltip = _styledComponents2.default.span(_templateObject43, FONT);
	
	var MachineRadio = _styledComponents2.default.span(_templateObject44, function (p) {
	  return p.selected ? '#5C91F5' : 'rgba(0, 27, 59, 0.3)';
	}, function (p) {
	  return p.selected ? '#5C91F5' : 'transparent';
	});
	
	var MachineLineText = _styledComponents2.default.span(_templateObject45);
	
	var MachineCap = _styledComponents2.default.span(_templateObject46);
	
	var UnitsLabel = ColumnLabel;
	
	var UnitsInputWrapper = _styledComponents2.default.div(_templateObject47);
	
	var UnitsInput = _styledComponents2.default.input(_templateObject48, FONT);
	
	var FieldError = _styledComponents2.default.div(_templateObject49, FONT);
	
	var FieldSuccess = _styledComponents2.default.div(_templateObject50, FONT);
	
	var UnitsSuffix = _styledComponents2.default.span(_templateObject51, FONT);
	
	var PostButton = _styledComponents2.default.button(_templateObject52, FONT, function (p) {
	  return p.ready && "\n    background: #2A4169;\n    &:hover:not(:disabled) {\n      background: #36507e;\n    }\n  ";
	});
	
	// Wraps the Produce Units button so we can show an explanatory hover
	// tooltip while the button is disabled. The tooltip only renders when
	// there is an unmet-condition message to show (i.e. not while an API
	// call is in flight, which has its own "Producing…" label).
	var PostButtonTooltipWrap = _styledComponents2.default.div(_templateObject53);
	
	var PostButtonTooltip = _styledComponents2.default.div(_templateObject54, FONT);
	
	var LoaderWrap = _styledComponents2.default.div(_templateObject55);
	
	var ManageProductionPage = function (_PureComponent2) {
	  _inherits(ManageProductionPage, _PureComponent2);
	
	  function ManageProductionPage(props) {
	    _classCallCheck(this, ManageProductionPage);
	
	    var _this3 = _possibleConstructorReturn(this, (ManageProductionPage.__proto__ || Object.getPrototypeOf(ManageProductionPage)).call(this, props));
	
	    _this3.goToCustomerAnalysis = function (e) {
	      e.preventDefault();
	      _this3.eventemitter.trigger("coaching-feedback-hide");
	      (0, _Location.changeLocation)("/ceo/analysis/market");
	    };
	
	    _this3.showPopupLowProduction = function (units) {
	      var formatted = Math.round(Number(units) || 0).toLocaleString("en-US");
	      _this3.eventemitter.trigger("coaching-feedback", ["Inventory Management", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Whoa! You're only producing ",
	        formatted,
	        " units? How many image sensors are customers demanding again? You should double check customer demand in the ",
	        _react2.default.createElement(
	          "a",
	          { href: "/ceo/analysis/market", onClick: _this3.goToCustomerAnalysis },
	          "customer analysis"
	        ),
	        " before finalizing production."
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Rule of thumb:"
	        ),
	        " aim to produce at least what customers are expected to buy so you don't leave revenue on the table."
	      )]);
	    };
	
	    _this3.showPopupNotReleasedYet = function () {
	      _this3.eventemitter.trigger("coaching-feedback", ["Not Released Yet", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Whoa! This product won't be released from design this year and therefore you won't be able to produce units.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "For more details on this product's release date, please follow up with your Head of Product who created the product. S/he has the power to change the design if needed."
	      )]);
	    };
	
	    _this3.fetchData = function () {
	      (0, _ApiService.batchRequest)([AVAILABLE_MACHINES_URL, TEAM_MACHINES_URL, PRODUCT_MANUFACTURES_URL]).then(function (res) {
	        if (!_this3._mounted) return;
	        if (res[0].statusCode !== 200 || res[1].statusCode !== 200 || res[2].statusCode !== 200) {
	          throw res;
	        }
	        var available_machines = res[0].body;
	        var team_machines = (res[1].body || []).filter(function (m) {
	          return !m.sold_in_round;
	        });
	        var product_manufactures = res[2].body || [];
	
	        // Pre-fill selections and units from any existing manufactures
	        // so the UI reflects the current schedule on open.
	        var selectedMachines = {};
	        var unitsInputs = {};
	        product_manufactures.forEach(function (pm) {
	          selectedMachines[pm.product] = pm.machine;
	          unitsInputs[pm.product] = String(pm.units_produced || 0);
	        });
	
	        // Convenience default: if the team owns exactly one machine
	        // line, auto-select it for every product that doesn't already
	        // have a machine assigned. Students with a single line only
	        // have to enter units. Teams with >1 line still pick manually.
	        if (team_machines.length === 1) {
	          var soloMachineId = team_machines[0] && team_machines[0].id;
	          if (soloMachineId != null) {
	            var products = _this3.props.products || [];
	            products.forEach(function (p) {
	              var pid = p && p.product_id;
	              if (pid != null && selectedMachines[pid] == null) {
	                selectedMachines[pid] = soloMachineId;
	              }
	            });
	          }
	        }
	
	        _this3.setState({
	          loading: false,
	          available_machines: available_machines,
	          team_machines: team_machines,
	          product_manufactures: product_manufactures,
	          selectedMachines: selectedMachines,
	          unitsInputs: unitsInputs
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ManageProductionPage", "fetchData");
	        if (_this3._mounted) {
	          _this3.setState({ loading: false });
	        }
	      });
	    };
	
	    _this3.getMaxAllowed = function (productId, teamMachineId) {
	      var _this3$props$maxAllow = _this3.props.maxAllowedMatrix,
	          maxAllowedMatrix = _this3$props$maxAllow === undefined ? [] : _this3$props$maxAllow;
	
	      var row = maxAllowedMatrix.find(function (r) {
	        return Number(r.product) === Number(productId) && Number(r.machine) === Number(teamMachineId);
	      });
	      return row ? Number(row.max_allowed) || 0 : 0;
	    };
	
	    _this3.getMachineCapacityUnits = function (teamMachine) {
	      var available_machines = _this3.state.available_machines;
	
	      var spec = available_machines.find(function (m) {
	        return Number(m.id) === Number(teamMachine.machine);
	      });
	      if (!spec) return 0;
	      return Math.round(Number(spec.units_per_hour) * ANNUAL_HOURS);
	    };
	
	    _this3.demandForecastFor = function (productId) {
	      var _this3$props$priceFor = _this3.props.priceForecasts,
	          priceForecasts = _this3$props$priceFor === undefined ? [] : _this3$props$priceFor;
	
	      var entry = priceForecasts.find(function (pf) {
	        return Number(pf.product) === Number(productId);
	      });
	      return entry ? Number(entry.forecast) || 0 : 0;
	    };
	
	    _this3.selectMachine = function (productId, teamMachineId) {
	      return function () {
	        _this3.setState({
	          selectedMachines: Object.assign({}, _this3.state.selectedMachines, _defineProperty({}, productId, teamMachineId)),
	          errors: Object.assign({}, _this3.state.errors, _defineProperty({}, productId, null)),
	          successes: Object.assign({}, _this3.state.successes, _defineProperty({}, productId, null))
	        });
	      };
	    };
	
	    _this3.changeUnits = function (productId) {
	      return function (e) {
	        var raw = (e.target.value || "").replace(/[^0-9]/g, "");
	        _this3.setState({
	          unitsInputs: Object.assign({}, _this3.state.unitsInputs, _defineProperty({}, productId, raw)),
	          errors: Object.assign({}, _this3.state.errors, _defineProperty({}, productId, null)),
	          successes: Object.assign({}, _this3.state.successes, _defineProperty({}, productId, null))
	        });
	      };
	    };
	
	    _this3.extractPostError = function (err) {
	      var body = err && err.response && err.response.body;
	      if (!body) return null;
	      if (typeof body === 'string') return body;
	
	      if (Array.isArray(body.units_produced) && body.units_produced.length > 0) {
	        var raw = String(body.units_produced[0]);
	        var match = raw.match(/Max allowed\s+(\d+)/i);
	        if (match) {
	          var max = Number(match[1]);
	          return "Units exceed production capacity. Maximum allowed is " + max.toLocaleString('en-US') + " units.";
	        }
	        return raw;
	      }
	      if (body.detail) return String(body.detail);
	      if (Array.isArray(body.non_field_errors) && body.non_field_errors.length > 0) {
	        return String(body.non_field_errors[0]);
	      }
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(body)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          var val = body[key];
	          if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'string') {
	            return key + ": " + val[0];
	          }
	          if (typeof val === 'string' && val.length > 0) {
	            return key + ": " + val;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return null;
	    };
	
	    _this3.postProduct = function (productId) {
	      return function () {
	        var _this3$state = _this3.state,
	            product_manufactures = _this3$state.product_manufactures,
	            selectedMachines = _this3$state.selectedMachines;
	
	        var existing = product_manufactures.find(function (pm) {
	          return pm.product === productId;
	        });
	
	        var selectedMachineId = selectedMachines[productId];
	        var isMachineSwitch = !!(existing && selectedMachineId != null && Number(existing.machine) !== Number(selectedMachineId) && Number(existing.units_produced || 0) > 0);
	        if (isMachineSwitch) {
	          _this3.setState({ machineSwitchAlertProductId: productId });
	          return;
	        }
	
	        _this3.runAllocationCheckOrPost(productId);
	      };
	    };
	
	    _this3.runAllocationCheckOrPost = function (productId) {
	      var product_manufactures = _this3.state.product_manufactures;
	      var _this3$props$inventor = _this3.props.inventoryAllocations,
	          inventoryAllocations = _this3$props$inventor === undefined ? [] : _this3$props$inventor;
	
	      var existing = product_manufactures.find(function (pm) {
	        return pm.product === productId;
	      });
	      var hasAllocations = (inventoryAllocations || []).some(function (a) {
	        return Number(a.product) === Number(productId) && (Number(a.units) || 0) > 0;
	      });
	
	      if (existing && hasAllocations) {
	        _this3.setState({ allocationAlertProductId: productId });
	        return;
	      }
	
	      _this3.doPostProduct(productId);
	    };
	
	    _this3.confirmAllocationAlert = function () {
	      var productId = _this3.state.allocationAlertProductId;
	      _this3.setState({ allocationAlertProductId: null });
	      if (productId != null) _this3.doPostProduct(productId);
	    };
	
	    _this3.cancelAllocationAlert = function () {
	      _this3.setState({ allocationAlertProductId: null });
	    };
	
	    _this3.confirmMachineSwitchAlert = function () {
	      var productId = _this3.state.machineSwitchAlertProductId;
	      _this3.setState({ machineSwitchAlertProductId: null });
	      if (productId != null) _this3.runAllocationCheckOrPost(productId);
	    };
	
	    _this3.cancelMachineSwitchAlert = function () {
	      _this3.setState({ machineSwitchAlertProductId: null });
	    };
	
	    _this3.doPostProduct = function (productId) {
	      var _this3$state2 = _this3.state,
	          selectedMachines = _this3$state2.selectedMachines,
	          unitsInputs = _this3$state2.unitsInputs,
	          product_manufactures = _this3$state2.product_manufactures;
	
	      var machineId = selectedMachines[productId];
	      var units = Number(unitsInputs[productId]) || 0;
	      if (!machineId) return;
	
	      var existing = product_manufactures.find(function (pm) {
	        return pm.product === productId;
	      });
	      // Brand-new schedules need at least 1 unit; updates can drop to 0.
	      if (!existing && units <= 0) return;
	
	      // Capture BEFORE the POST: is this the team's first production
	      // decision in Round 2? Used to fire the DC coaching popup once,
	      // right after the very first successful Round-2 production.
	      //
	      // Test the sum of `units_produced` across product_manufactures —
	      // the backend may pre-seed a product_manufactures row per product
	      // with units_produced=0, so "no production yet" means the sum is
	      // still 0 (empty array also satisfies this via reduce init).
	      var totalUnitsProduced = Array.isArray(product_manufactures) ? product_manufactures.reduce(function (sum, pm) {
	        return sum + (Number(pm.units_produced) || 0);
	      }, 0) : 0;
	      var wasFirstProductionInRound2 = Number(_this3.props.currentRound) === 2 && totalUnitsProduced <= 0;
	
	      // Snapshot the saved value so we can revert the input if the
	      // request fails — leaves the user looking at the actual backend
	      // state rather than the rejected number they tried to submit.
	      var priorValue = existing ? String(existing.units_produced || 0) : "";
	
	      _this3.setState({ posting: Object.assign({}, _this3.state.posting, _defineProperty({}, productId, true)) });
	      var request = existing ? (0, _ApiService.putRequest)("" + PRODUCT_MANUFACTURES_URL + existing.id + "/").send({
	        product: productId,
	        machine: machineId,
	        units_produced: units
	      }) : (0, _ApiService.postRequest)(PRODUCT_MANUFACTURES_URL).send({
	        product: productId,
	        machine: machineId,
	        units_produced: units
	      });
	
	      request.then(function (res) {
	        // Coaching popups (ported from produce-product.js): the backend
	        // echoes units_produced and months_to_produce on the response.
	        // Low production → "review demand"; months_to_produce === 0 →
	        // "product isn't released yet."
	        var body = res && res.body || {};
	        var unitsProduced = Number(body.units_produced);
	        var monthsToProduce = Number(body.months_to_produce);
	        if (Number.isFinite(unitsProduced) && unitsProduced > 0 && unitsProduced <= 100000) {
	          _this3.showPopupLowProduction(unitsProduced);
	        } else if (monthsToProduce === 0) {
	          _this3.showPopupNotReleasedYet();
	        }
	
	        if (!existing) (0, _SubmitDecisions.incrementUnacceptedDecisions)("operations");
	        if (_this3.props.reloadData) _this3.props.reloadData();
	        // Rebuild product_manufactures from the response body before the
	        // refetch lands. On a machine switch the BE deletes the old row
	        // and creates a new one with a different id — if a follow-up
	        // PATCH fired against this.state.product_manufactures before
	        // fetchData completed, it would PUT to the stale (deleted) id
	        // and 404. Picking the id up from the response immediately
	        // closes that window.
	        var existingPMs = Array.isArray(_this3.state.product_manufactures) ? _this3.state.product_manufactures : [];
	        var nextPMs = body && body.id != null && body.product != null ? [].concat(_toConsumableArray(existingPMs.filter(function (pm) {
	          return Number(pm.product) !== Number(body.product);
	        })), [body]) : existingPMs;
	        var nextSelectedMachines = body && body.product != null && body.machine != null ? Object.assign({}, _this3.state.selectedMachines, _defineProperty({}, body.product, body.machine)) : _this3.state.selectedMachines;
	        _this3.fetchData();
	        _this3.setState({
	          posting: Object.assign({}, _this3.state.posting, _defineProperty({}, productId, false)),
	          errors: Object.assign({}, _this3.state.errors, _defineProperty({}, productId, null)),
	          successes: Object.assign({}, _this3.state.successes, _defineProperty({}, productId, 'Success')),
	          product_manufactures: nextPMs,
	          selectedMachines: nextSelectedMachines
	        });
	        if (wasFirstProductionInRound2 && _this3.props.onFirstProductionInRound2) {
	          _this3.props.onFirstProductionInRound2();
	        }
	        // Auto-clear the success indicator after a few seconds.
	        if (_this3._successTimers[productId]) clearTimeout(_this3._successTimers[productId]);
	        _this3._successTimers[productId] = setTimeout(function () {
	          if (!_this3._mounted) return;
	          _this3.setState({
	            successes: Object.assign({}, _this3.state.successes, _defineProperty({}, productId, null))
	          });
	        }, 3500);
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ManageProductionPage", "postProduct");
	        var message = _this3.extractPostError(err) || "Could not submit production. Please try again.";
	        _this3.setState({
	          posting: Object.assign({}, _this3.state.posting, _defineProperty({}, productId, false)),
	          errors: Object.assign({}, _this3.state.errors, _defineProperty({}, productId, message)),
	          // Revert input to the saved value so the user sees what's
	          // actually persisted, not the rejected number.
	          unitsInputs: Object.assign({}, _this3.state.unitsInputs, _defineProperty({}, productId, priorValue))
	        });
	      });
	    };
	
	    _this3.renderProductCard = function (product) {
	      var _this3$state3 = _this3.state,
	          team_machines = _this3$state3.team_machines,
	          selectedMachines = _this3$state3.selectedMachines,
	          unitsInputs = _this3$state3.unitsInputs,
	          posting = _this3$state3.posting,
	          errors = _this3$state3.errors,
	          successes = _this3$state3.successes;
	
	      var productId = product.product_id;
	      var selectedMachineId = selectedMachines[productId];
	      var unitsValue = unitsInputs[productId] != null ? unitsInputs[productId] : "";
	      var isPosting = !!posting[productId];
	      var isUpdate = Number(product.units_produced) > 0;
	      // Nudge the machine-line rows with a pulsing halo only in Round 1
	      // when this product has no production yet. Same pattern as the
	      // Manage Promotion product pill.
	      var attention = Number(_this3.props.currentRound) === 1 && !isUpdate;
	      // Update is allowed at 0 (lets users zero out an existing production
	      // run). Post still requires > 0 — submitting a brand-new schedule of
	      // 0 units doesn't carry any decision.
	      var ready = !!selectedMachineId && (isUpdate ? Number(unitsValue) >= 0 && unitsValue !== "" : Number(unitsValue) > 0);
	      var demandForecast = _this3.demandForecastFor(productId);
	      var buttonLabel = isPosting ? isUpdate ? "Updating…" : "Producing…" : isUpdate ? "Update Production" : "Produce Units";
	
	      // Game rule: a product can only be manufactured on one line per
	      // round. Once a production decision has been committed
	      // (units_produced > 0), lock the other machine rows so the team
	      // can't split or switch without first zeroing out the current
	      // schedule. The currently-committed machine stays clickable.
	      var committedMachineId = isUpdate ? Number(selectedMachineId) : null;
	      var committedMachine = committedMachineId != null ? team_machines.find(function (m) {
	        return Number(m.id) === committedMachineId;
	      }) : null;
	      var committedLineNumber = committedMachine ? committedMachine.machine : null;
	
	      // months_available_to_produce lives on the team-decisions top-level
	      // `products` array (id/name/months_available_to_produce/round/...),
	      // not on operations_decisions.products. Look it up by id.
	      var _this3$props$teamProd = _this3.props.teamProducts,
	          teamProducts = _this3$props$teamProd === undefined ? [] : _this3$props$teamProd;
	
	      var teamProduct = teamProducts.find(function (p) {
	        return Number(p.id) === Number(productId);
	      });
	      var monthsAvailable = teamProduct ? Number(teamProduct.months_available_to_produce) || 0 : 0;
	      var isReleased = monthsAvailable > 0;
	
	      return _react2.default.createElement(
	        ProductCard,
	        { key: productId },
	        _react2.default.createElement(
	          ProductHeader,
	          null,
	          _react2.default.createElement(
	            ProductNameRow,
	            null,
	            _react2.default.createElement(
	              ProductName,
	              null,
	              product.product_name
	            ),
	            isReleased ? _react2.default.createElement(
	              StatusBadge,
	              { variant: "released" },
	              "Released"
	            ) : _react2.default.createElement(
	              StatusBadgeWrapper,
	              null,
	              _react2.default.createElement(
	                StatusBadge,
	                { variant: "not-released" },
	                "Not Yet Released"
	              ),
	              _react2.default.createElement(
	                StatusTooltip,
	                { className: "status-tooltip" },
	                "Check with your Head of Product or CEO about the release date with this product."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ProductDemand,
	            null,
	            "Demand forecast:",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              demandForecast > 0 ? _react2.default.createElement(_reactNumberFormat2.default, { value: demandForecast, displayType: "text", thousandSeparator: ",", suffix: " units" }) : "-"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ProductBody,
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              MachineHeaderRow,
	              null,
	              _react2.default.createElement(
	                ColumnLabel,
	                null,
	                "Machine Line"
	              ),
	              _react2.default.createElement(
	                ColumnLabel,
	                null,
	                "Production Capacity"
	              )
	            ),
	            _react2.default.createElement(
	              MachineList,
	              null,
	              team_machines.length === 0 && _react2.default.createElement(
	                MachineCap,
	                null,
	                "No production machines available. Acquire a machine first."
	              ),
	              [].concat(_toConsumableArray(team_machines)).sort(function (a, b) {
	                return Number(a.machine) - Number(b.machine);
	              }).map(function (tm) {
	                var cap = _this3.getMaxAllowed(productId, tm.id);
	                var selected = Number(selectedMachineId) === Number(tm.id);
	                var locked = committedMachineId != null && Number(tm.id) !== committedMachineId;
	                var option = _react2.default.createElement(
	                  MachineOption,
	                  {
	                    key: tm.id,
	                    selected: selected,
	                    attention: !locked && attention,
	                    locked: locked,
	                    onClick: locked ? undefined : _this3.selectMachine(productId, tm.id)
	                  },
	                  _react2.default.createElement(MachineRadio, { selected: selected }),
	                  _react2.default.createElement(
	                    MachineLineText,
	                    null,
	                    "Production Line ",
	                    tm.machine
	                  ),
	                  _react2.default.createElement(
	                    MachineCap,
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, { value: cap, displayType: "text", thousandSeparator: "," }),
	                    " units"
	                  )
	                );
	                if (!locked) return option;
	                return _react2.default.createElement(
	                  MachineOptionWrapper,
	                  { key: tm.id },
	                  option,
	                  _react2.default.createElement(
	                    MachineLockedTooltip,
	                    { className: "machine-locked-tooltip" },
	                    "You're already producing this product on Production Line ",
	                    committedLineNumber,
	                    ". Only one production line per product per round. To switch, set Line ",
	                    committedLineNumber,
	                    "'s units to 0 first."
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              UnitsLabel,
	              null,
	              "Units to Produce"
	            ),
	            _react2.default.createElement(
	              UnitsInputWrapper,
	              null,
	              _react2.default.createElement(UnitsInput, {
	                type: "text",
	                value: unitsValue ? Number(unitsValue).toLocaleString('en-US') : "",
	                onChange: _this3.changeUnits(productId),
	                placeholder: "0"
	              }),
	              _react2.default.createElement(
	                UnitsSuffix,
	                null,
	                "units"
	              )
	            ),
	            errors[productId] && _react2.default.createElement(
	              FieldError,
	              null,
	              errors[productId]
	            ),
	            successes[productId] && !errors[productId] && _react2.default.createElement(
	              FieldSuccess,
	              null,
	              successes[productId]
	            ),
	            function () {
	              var machineMissing = !selectedMachineId;
	              var unitsMissing = isUpdate ? unitsValue === "" || Number(unitsValue) < 0 : !(Number(unitsValue) > 0);
	              var showTooltip = !isPosting && (machineMissing || unitsMissing);
	              var tooltipMsg = null;
	              if (showTooltip) {
	                if (machineMissing && unitsMissing) {
	                  tooltipMsg = isUpdate ? "Select a production line and enter the number of units to produce." : "Select a production line and enter a number greater than 0 in Units to Produce.";
	                } else if (machineMissing) {
	                  tooltipMsg = "Select a production line.";
	                } else {
	                  tooltipMsg = isUpdate ? "Enter the number of units to produce." : "Enter a number greater than 0 in Units to Produce.";
	                }
	              }
	              return _react2.default.createElement(
	                PostButtonTooltipWrap,
	                null,
	                _react2.default.createElement(
	                  PostButton,
	                  {
	                    ready: ready,
	                    disabled: !ready || isPosting,
	                    onClick: _this3.postProduct(productId)
	                  },
	                  buttonLabel
	                ),
	                tooltipMsg && _react2.default.createElement(
	                  PostButtonTooltip,
	                  {
	                    className: "produce-units-tooltip",
	                    role: "tooltip"
	                  },
	                  tooltipMsg
	                )
	              );
	            }()
	          )
	        )
	      );
	    };
	
	    _this3.state = {
	      loading: true,
	      available_machines: [],
	      team_machines: [],
	      product_manufactures: [],
	      // Per-product UI state, keyed by product_id
	      selectedMachines: {},
	      unitsInputs: {},
	      posting: {},
	      errors: {},
	      successes: {},
	      // Holds the product id whose Update was clicked when allocations
	      // exist for it. Drives the Allocation Alert popup; null when closed.
	      allocationAlertProductId: null,
	      // Holds the product id whose Update was clicked when the chosen
	      // machine differs from the already-saved one AND units_produced
	      // on the existing row is > 0. Drives the Machine Switch confirmation
	      // (BE deletes the old row and creates a new one on this change,
	      // so warn the student that production on the current line will go).
	      machineSwitchAlertProductId: null
	    };
	    // Per-product timeout handles for auto-clearing success messages.
	    _this3._successTimers = {};
	    _this3.eventemitter = _eventEmitter2.default.getInstance();
	    return _this3;
	  }
	
	  _createClass(ManageProductionPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this4 = this;
	
	      this._mounted = false;
	      Object.keys(this._successTimers).forEach(function (id) {
	        return clearTimeout(_this4._successTimers[id]);
	      });
	    }
	
	    // Production Capacity per (product, team_machine) is now read directly
	    // from the team-decisions `max_allowed_matrix` prop. Backend already
	    // accounts for release status, shared-machine scheduling, etc.
	
	
	    // ---------- capacity calculations ----------
	
	  }, {
	    key: "renderCapacityCard",
	
	
	    // ---------- render helpers ----------
	
	    value: function renderCapacityCard() {
	      var _props$inventoryBalan = this.props.inventoryBalances,
	          inventoryBalances = _props$inventoryBalan === undefined ? [] : _props$inventoryBalan;
	
	      var total = this.totalCapacity;
	      var scheduled = this.scheduledUnits;
	      var available = inventoryBalances.reduce(function (sum, b) {
	        return sum + (Number(b.available_for_sale) || 0);
	      }, 0);
	      var utilization = total > 0 ? scheduled / total * 100 : 0;
	      var totalDemand = this.totalDemandForecast;
	
	      return _react2.default.createElement(
	        CapacityCard,
	        null,
	        _react2.default.createElement(
	          SectionLabel,
	          null,
	          "Plant Production Capacity"
	        ),
	        _react2.default.createElement(
	          CapacityMiniRow,
	          null,
	          _react2.default.createElement(
	            CapacityMiniCard,
	            null,
	            _react2.default.createElement(
	              CapacityMiniLabel,
	              null,
	              "Units Produced"
	            ),
	            _react2.default.createElement(
	              CapacityMiniValue,
	              null,
	              _react2.default.createElement(CountUp, { value: scheduled, format: formatInt })
	            ),
	            _react2.default.createElement(
	              CapacityMiniSub,
	              null,
	              "this period"
	            )
	          ),
	          _react2.default.createElement(
	            CapacityMiniCard,
	            null,
	            _react2.default.createElement(
	              CapacityMiniLabel,
	              null,
	              "Total Available"
	            ),
	            _react2.default.createElement(
	              CapacityMiniValue,
	              null,
	              _react2.default.createElement(CountUp, { value: available, format: formatInt })
	            ),
	            _react2.default.createElement(
	              CapacityMiniSub,
	              null,
	              "units for sale"
	            )
	          ),
	          _react2.default.createElement(
	            CapacityMiniCard,
	            null,
	            _react2.default.createElement(
	              CapacityMiniLabel,
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "Machine Annual Capacity Utilized"
	              ),
	              _react2.default.createElement(
	                InfoIconWrapper,
	                null,
	                "?",
	                _react2.default.createElement(
	                  InfoTooltip,
	                  null,
	                  "Reflects a full year of production. Products released later in the year have proportionally less production capacity available."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              CapacityMiniValue,
	              null,
	              utilization.toFixed(1),
	              "%"
	            ),
	            _react2.default.createElement(
	              CapacityMiniSub,
	              null,
	              _react2.default.createElement(_reactNumberFormat2.default, { value: scheduled, displayType: "text", thousandSeparator: "," }),
	              " / ",
	              _react2.default.createElement(_reactNumberFormat2.default, { value: total, displayType: "text", thousandSeparator: "," })
	            )
	          ),
	          _react2.default.createElement(
	            CapacityMiniCard,
	            null,
	            _react2.default.createElement(
	              CapacityMiniLabel,
	              null,
	              "Total Demand Forecast"
	            ),
	            _react2.default.createElement(
	              CapacityMiniValue,
	              null,
	              _react2.default.createElement(_reactNumberFormat2.default, { value: totalDemand, displayType: "text", thousandSeparator: "," })
	            ),
	            _react2.default.createElement(
	              CapacityMiniSub,
	              null,
	              "units across all products"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          _props$products = _props.products,
	          products = _props$products === undefined ? [] : _props$products,
	          onClose = _props.onClose;
	      var _state = this.state,
	          loading = _state.loading,
	          allocationAlertProductId = _state.allocationAlertProductId,
	          machineSwitchAlertProductId = _state.machineSwitchAlertProductId,
	          team_machines = _state.team_machines,
	          product_manufactures = _state.product_manufactures,
	          selectedMachines = _state.selectedMachines;
	
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        _react2.default.createElement(
	          Page,
	          null,
	          _react2.default.createElement(
	            HeaderRow,
	            null,
	            _react2.default.createElement(
	              HeaderLeft,
	              null,
	              _react2.default.createElement(
	                HeaderTitle,
	                null,
	                "Manage Production"
	              ),
	              _react2.default.createElement(
	                HeaderSubtitle,
	                null,
	                "Plan how much of each product to manufacture this year and which machine line to run it on. Balance demand forecasts against available capacity to make the most cost-effective production decision."
	              )
	            ),
	            _react2.default.createElement(
	              CloseButton,
	              { onClick: onClose, "aria-label": "Close" },
	              "\xD7"
	            )
	          ),
	          loading && _react2.default.createElement(
	            LoaderWrap,
	            null,
	            _react2.default.createElement(_reactLoaders2.default, { type: "ball-scale-ripple", active: true })
	          ),
	          !loading && _react2.default.createElement(
	            "div",
	            null,
	            this.renderCapacityCard(),
	            _react2.default.createElement(
	              ScheduleHeader,
	              null,
	              _react2.default.createElement(
	                ScheduleTitle,
	                null,
	                "Manufacturing Schedule: ",
	                products.length,
	                " ",
	                products.length === 1 ? "Product" : "Products"
	              ),
	              _react2.default.createElement(
	                ScheduleHint,
	                null,
	                "Select machine line and set production quantity"
	              )
	            ),
	            products.map(this.renderProductCard)
	          )
	        ),
	        allocationAlertProductId != null && function () {
	          var alertProduct = products.find(function (p) {
	            return Number(p.product_id) === Number(allocationAlertProductId);
	          });
	          var productName = alertProduct ? alertProduct.product_name : 'this product';
	          return _react2.default.createElement(_warning2.default, {
	            title: "Allocation Alert",
	            successButtonText: "Yes, Update Production",
	            onSuccess: _this5.confirmAllocationAlert,
	            onCancel: _this5.cancelAllocationAlert,
	            message: _react2.default.createElement(
	              "span",
	              null,
	              "Updating production for ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                productName
	              ),
	              " will remove any distribution center allocations you've made this round for this product.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "You'll need to redo those allocations after this change.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Do you want to continue?"
	            )
	          });
	        }(),
	        machineSwitchAlertProductId != null && function () {
	          var alertProduct = products.find(function (p) {
	            return Number(p.product_id) === Number(machineSwitchAlertProductId);
	          });
	          var productName = alertProduct ? alertProduct.product_name : 'this product';
	          var existing = (product_manufactures || []).find(function (pm) {
	            return pm.product === machineSwitchAlertProductId;
	          });
	          var currentMachineId = existing ? Number(existing.machine) : null;
	          var nextMachineId = Number((selectedMachines || {})[machineSwitchAlertProductId]);
	          var currentLine = (team_machines || []).find(function (m) {
	            return Number(m.id) === currentMachineId;
	          });
	          var nextLine = (team_machines || []).find(function (m) {
	            return Number(m.id) === nextMachineId;
	          });
	          var currentLineLabel = currentLine ? "Production Line " + currentLine.machine : 'the current production line';
	          var nextLineLabel = nextLine ? "Production Line " + nextLine.machine : 'the selected production line';
	          return _react2.default.createElement(_warning2.default, {
	            title: "Switch Production Line?",
	            successButtonText: "Yes, Switch Production Line",
	            onSuccess: _this5.confirmMachineSwitchAlert,
	            onCancel: _this5.cancelMachineSwitchAlert,
	            message: _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(
	                "strong",
	                null,
	                productName
	              ),
	              " is already being produced on ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                currentLineLabel
	              ),
	              ". Switching to ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                nextLineLabel
	              ),
	              " will cancel any production on ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                currentLineLabel
	              ),
	              ".",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "A product cannot be produced on multiple production lines.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Do you want to continue?"
	            )
	          });
	        }()
	      );
	    }
	  }, {
	    key: "totalCapacity",
	    get: function get() {
	      var _this6 = this;
	
	      var team_machines = this.state.team_machines;
	
	      return team_machines.reduce(function (sum, tm) {
	        return sum + _this6.getMachineCapacityUnits(tm);
	      }, 0);
	    }
	
	    // Demand forecast for a single product. Pulled from the team-decisions
	    // price_forecasts array (passed in as a prop). The team-decisions
	    // response is already round-scoped, so we just match on product_id.
	
	  }, {
	    key: "totalDemandForecast",
	    get: function get() {
	      var _this7 = this;
	
	      var _props$products2 = this.props.products,
	          products = _props$products2 === undefined ? [] : _props$products2;
	
	      return products.reduce(function (sum, p) {
	        return sum + _this7.demandForecastFor(p.product_id);
	      }, 0);
	    }
	
	    // Scheduled units = sum of inventory_balances[*].units_produced for the
	    // round. Sourced from the team-decisions response (passed via prop), so
	    // it refreshes automatically whenever the parent's reloadData runs —
	    // including right after a successful POST/PUT here.
	
	  }, {
	    key: "scheduledUnits",
	    get: function get() {
	      var _props$inventoryBalan2 = this.props.inventoryBalances,
	          inventoryBalances = _props$inventoryBalan2 === undefined ? [] : _props$inventoryBalan2;
	
	      return inventoryBalances.reduce(function (sum, b) {
	        return sum + (Number(b.units_produced) || 0);
	      }, 0);
	    }
	
	    // ---------- per-product handlers ----------
	
	    // Pulls a user-friendly message out of a failed POST/PUT response.
	    // Specifically rephrases the {"units_produced":["Max allowed N"]}
	    // shape into "Units exceed production capacity. Maximum allowed is
	    // N units." Falls back through other common DRF error shapes.
	
	
	    // Click handler. Two confirmation gates run before the actual
	    // POST/PUT:
	    //
	    //   1. Machine-switch warning: the student has existing production
	    //      on one machine (units_produced > 0) and is switching to a
	    //      different machine. BE deletes the old row and creates a new
	    //      one, so the units on the current line go away.
	    //   2. Allocation warning: an existing production exists AND the
	    //      product has distribution-center allocations this round — BE
	    //      wipes those on any production change.
	    //
	    // Both gates are skipped for brand-new schedules (nothing to warn
	    // about yet). The machine-switch gate runs first because it is the
	    // more fundamental state change; the allocation warning fires on
	    // the confirm callback.
	
	
	    // Second gate factored out so the machine-switch confirmation can
	    // fall through into it (switching machines may ALSO need to clear
	    // allocations if any exist for this product).
	
	  }]);
	
	  return ManageProductionPage;
	}(_react.PureComponent);
	
	exports.default = ManageProductionPage;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  z-index: 2000;\n  left: 210px;\n  top: 59px;\n  width: calc(100vw - 210px);\n  height: calc(100vh - 59px);\n  background: rgba(0, 0, 0, 0.4);\n'], ['\n  position: fixed;\n  z-index: 2000;\n  left: 210px;\n  top: 59px;\n  width: calc(100vw - 210px);\n  height: calc(100vh - 59px);\n  background: rgba(0, 0, 0, 0.4);\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: fixed;\n  z-index: 2001;\n  top: 230px;\n  background: #ffffff;\n  border-radius: 8px;\n  width: calc(100vw - 810px);\n  max-width: 590px;\n  padding: 32px 40px;\n\n  ', '\n'], ['\n  position: fixed;\n  z-index: 2001;\n  top: 230px;\n  background: #ffffff;\n  border-radius: 8px;\n  width: calc(100vw - 810px);\n  max-width: 590px;\n  padding: 32px 40px;\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 15px solid #ffffff;\n  position: fixed;\n  z-index: 2001;\n  top: 322px;\n\n  ', '\n'], ['\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 15px solid #ffffff;\n  position: fixed;\n  z-index: 2001;\n  top: 322px;\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 24px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  background: #faeded;\n  flex: 0 0 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 40px;\n    height: 40px;\n  }\n'], ['\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  background: #faeded;\n  flex: 0 0 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 40px;\n    height: 40px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n\n  span {\n    margin-left: 5px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n\n    b {\n      font-weight: 500;\n      color: red;\n    }\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n\n  span {\n    margin-left: 5px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n\n    b {\n      font-weight: 500;\n      color: red;\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 8px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  outline: none;\n  border: 0;\n  margin: 24px 0 0;\n  padding: 0;\n  width: 100%;\n  height: 40px;\n  background: #5c91f5;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: center;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #ffffff;\n'], ['\n  display: flex;\n  outline: none;\n  border: 0;\n  margin: 24px 0 0;\n  padding: 0;\n  width: 100%;\n  height: 40px;\n  background: #5c91f5;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: center;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #ffffff;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _selectFacility = __webpack_require__(2671);
	
	var _selectFacility2 = _interopRequireDefault(_selectFacility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Overlay = _styledComponents2.default.div(_templateObject);
	
	var Popup = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.left && '\n    left: ' + p.left + 'px;\n  ';
	});
	
	var PopupArrow = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.left && '\n    left: ' + p.left + 'px;\n  ';
	});
	
	var ImageRow = _styledComponents2.default.div(_templateObject4);
	
	var Image = _styledComponents2.default.div(_templateObject5);
	
	var Title = _styledComponents2.default.div(_templateObject6);
	
	var Description = _styledComponents2.default.div(_templateObject7);
	
	var Button = _styledComponents2.default.button(_templateObject8);
	
	var SelectFacilityPopup = function (_PureComponent) {
	  _inherits(SelectFacilityPopup, _PureComponent);
	
	  function SelectFacilityPopup(props) {
	    _classCallCheck(this, SelectFacilityPopup);
	
	    var _this = _possibleConstructorReturn(this, (SelectFacilityPopup.__proto__ || Object.getPrototypeOf(SelectFacilityPopup)).call(this, props));
	
	    _this.checkPopupSize = function () {
	      var facilityPopup = _this.state.facilityPopup;
	
	
	      if (facilityPopup) {
	        _this.setState({
	          arrowLeftPosition: facilityPopup.offsetWidth + 255,
	          popupLeftPosition: facilityPopup.offsetWidth + 270
	        });
	      }
	    };
	
	    _this.confirm = function () {
	      var action = _this.props.action;
	
	
	      if (action) {
	        action();
	      }
	    };
	
	    _this.onClose = function () {
	      var close = _this.props.close;
	
	
	      if (close) {
	        close();
	      }
	    };
	
	    _this.state = {
	      facilityPopup: props.facilityPopup,
	      arrowLeftPosition: -1,
	      popupLeftPosition: -1
	    };
	    return _this;
	  }
	
	  _createClass(SelectFacilityPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkPopupSize();
	
	      window.addEventListener('resize', this.checkPopupSize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.checkPopupSize);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.facilityPopup !== prevProps.facilityPopup) {
	        this.setState({
	          facilityPopup: this.props.facilityPopup
	        }, function () {
	          _this2.checkPopupSize();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          arrowLeftPosition = _state.arrowLeftPosition,
	          popupLeftPosition = _state.popupLeftPosition;
	      var show = this.props.show;
	
	
	      return show ? _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(Overlay, { onClick: this.onClose }),
	        arrowLeftPosition > -1 && _react2.default.createElement(PopupArrow, { left: arrowLeftPosition }),
	        popupLeftPosition > -1 && _react2.default.createElement(
	          Popup,
	          { left: popupLeftPosition },
	          _react2.default.createElement(
	            ImageRow,
	            null,
	            _react2.default.createElement(
	              Image,
	              null,
	              _react2.default.createElement('img', { src: _selectFacility2.default, alt: 'select facility icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                Title,
	                null,
	                'Select a Facility',
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    '*'
	                  ),
	                  ' mandatory'
	                )
	              ),
	              _react2.default.createElement(
	                Description,
	                null,
	                'By selecting a facility, you now are able to produce products and have inventories for sale.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Button,
	            { onClick: this.confirm },
	            'Yes, Confirm'
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return SelectFacilityPopup;
	}(_react.PureComponent);
	
	exports.default = SelectFacilityPopup;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _utils2 = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "grey");
	
	function UiButton(props) {
	  var onClick = props.onClick,
	      disabled = props.disabled,
	      children = props.children,
	      className = props.className;
	
	
	  var isMobile = (0, _utils2.detectMobile)();
	  var style = disabled === true ? "grey" : "primary";
	  var btnClassName = className ? "btn-op-decisions-button " + className : "btn-op-decisions-button";
	
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    {
	      className: btnClassName,
	      bsStyle: style,
	      bsSize: isMobile === true ? "sm" : null,
	      onClick: onClick,
	      disabled: disabled
	    },
	    children
	  );
	}
	
	exports.default = UiButton;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 8px 0 20px;\n\n  strong {\n    color: rgba(0, 27, 59, 0.94);\n    font-weight: 700;\n  }\n"], ["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 8px 0 20px;\n\n  strong {\n    color: rgba(0, 27, 59, 0.94);\n    font-weight: 700;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: ", ";\n  margin: 0;\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: ", ";\n  margin: 0;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #ECEDEF;\n"], ["\n  border-bottom: 1px solid #ECEDEF;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  text-align: ", ";\n  padding: 12px 16px 10px 0;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n\n  &:last-child {\n    padding-right: 0;\n  }\n"], ["\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  text-align: ", ";\n  padding: 12px 16px 10px 0;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n\n  &:last-child {\n    padding-right: 0;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #F5F6F7;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"], ["\n  border-bottom: 1px solid #F5F6F7;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: ", ";\n  padding: 14px 16px 14px 0;\n  vertical-align: middle;\n  font-variant-numeric: tabular-nums;\n\n  &:last-child {\n    padding-right: 0;\n  }\n"], ["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: ", ";\n  padding: 14px 16px 14px 0;\n  vertical-align: middle;\n  font-variant-numeric: tabular-nums;\n\n  &:last-child {\n    padding-right: 0;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 6px 18px;\n  border-radius: 6px;\n  border: none;\n  min-width: 86px;\n  float: none !important;\n  text-align: center;\n"], ["\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 6px 18px;\n  border-radius: 6px;\n  border: none;\n  min-width: 86px;\n  float: none !important;\n  text-align: center;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background-color: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  color: rgba(0, 27, 59, 0.4);\n  cursor: not-allowed;\n"], ["\n  background-color: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  color: rgba(0, 27, 59, 0.4);\n  cursor: not-allowed;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  background-color: #fff;\n  color: #2A4169;\n  border: 1px solid #2A4169;\n  &:hover, &:focus, &:active {\n    background-color: #F5F6F7;\n    color: #2A4169;\n    border: 1px solid #2A4169;\n    outline: none;\n  }\n"], ["\n  background-color: #fff;\n  color: #2A4169;\n  border: 1px solid #2A4169;\n  &:hover, &:focus, &:active {\n    background-color: #F5F6F7;\n    color: #2A4169;\n    border: 1px solid #2A4169;\n    outline: none;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  background-color: #D34C4C;\n  color: #fff;\n  &:hover, &:focus, &:active {\n    background-color: #c43c3c;\n    color: #fff;\n    border: none;\n    outline: none;\n  }\n"], ["\n  background-color: #D34C4C;\n  color: #fff;\n  &:hover, &:focus, &:active {\n    background-color: #c43c3c;\n    color: #fff;\n    border: none;\n    outline: none;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  background-color: #2A4169;\n  color: #fff;\n  &:hover, &:focus, &:active {\n    background-color: #36507e;\n    color: #fff;\n    border: none;\n    outline: none;\n  }\n"], ["\n  background-color: #2A4169;\n  color: #fff;\n  &:hover, &:focus, &:active {\n    background-color: #36507e;\n    color: #fff;\n    border: none;\n    outline: none;\n  }\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.buy-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.buy-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  transform: translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    right: 32px;\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  transform: translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    right: 32px;\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  opacity: 0.5;\n  pointer-events: none;\n"], ["\n  opacity: 0.5;\n  pointer-events: none;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 22px;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n\n  &:hover {\n    background: #F5F6F7;\n  }\n"], ["\n  background: transparent;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 22px;\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n\n  &:hover {\n    background: #F5F6F7;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _lodash = __webpack_require__(21);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils2 = __webpack_require__(18);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactLoaders2 = _interopRequireDefault(_reactLoaders);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "save");
	
	var AVAILABLE_MACHINES_URL = ("https://be-production-itb.marketgames.io/api/") + "static/machines/";
	var TEAM_MACHINES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/machines/";
	var FACTORIES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/factories/";
	var PRODUCT_MANUFACTURES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/";
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	var ModalTitle = _styledComponents2.default.h3(_templateObject, FONT);
	
	var ModalDescription = _styledComponents2.default.p(_templateObject2, FONT);
	
	var ModernTable = _styledComponents2.default.table(_templateObject3, FONT);
	
	var HeadRow = _styledComponents2.default.tr(_templateObject4);
	
	var HeadCell = _styledComponents2.default.th(_templateObject5, function (p) {
	  return p.align || 'left';
	});
	
	var Row = _styledComponents2.default.tr(_templateObject6);
	
	var Cell = _styledComponents2.default.td(_templateObject7, function (p) {
	  return p.align || 'left';
	});
	
	var ActionBase = (0, _styledComponents2.default)(_reactBootstrap.Button)(_templateObject8, FONT);
	
	var LoadingButton = (0, _styledComponents2.default)(ActionBase)(_templateObject9);
	var UndoSellButton = (0, _styledComponents2.default)(ActionBase)(_templateObject10);
	var SellButton = (0, _styledComponents2.default)(ActionBase)(_templateObject11);
	var BuyButton = (0, _styledComponents2.default)(ActionBase)(_templateObject12);
	
	// Wrapper + tooltip for the disabled Buy button on Production Line 4
	// in Year 1 (locked until later rounds). Same pattern as the tooltips
	// in PDDecisions / PMDecisions — the disabled button's pointer-events
	// are killed so hover reliably fires on the wrapper.
	var BuyTooltipWrapper = _styledComponents2.default.span(_templateObject13);
	
	var BuyTooltip = _styledComponents2.default.span(_templateObject14, FONT);
	
	var DisabledBuyButton = (0, _styledComponents2.default)(BuyButton)(_templateObject15);
	
	var FooterCloseButton = _styledComponents2.default.button(_templateObject16, FONT);
	
	var BuyingMachines = function (_Component) {
	  _inherits(BuyingMachines, _Component);
	
	  function BuyingMachines(props) {
	    _classCallCheck(this, BuyingMachines);
	
	    var _this = _possibleConstructorReturn(this, (BuyingMachines.__proto__ || Object.getPrototypeOf(BuyingMachines)).call(this, props));
	
	    _this.showSuccessMessage = function (successMessage) {
	      _this.setState({
	        successMessage: successMessage
	      }, function () {
	        _this.hideSuccessMessage();
	      });
	    };
	
	    _this.hideSuccessMessage = function () {
	      setTimeout(function () {
	        _this.setState({
	          successMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.showModal = function () {
	      _this.setState({
	        show: true
	      }, function () {
	        _this.fetchData();
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.showNpvModal = function () {
	      _this.setState({
	        show: false
	      }, function () {
	        _this.eventemitter.trigger("show-npv-modal");
	      });
	    };
	
	    _this.reloadData = function () {
	      var reloadData = _this.props.reloadData;
	      var loading_machines = _this.state.loading_machines;
	
	
	      reloadData();
	
	      (0, _ApiService.getRequest)(TEAM_MACHINES_URL).then(function (res) {
	        _this.setState({
	          team_machines: (0, _lodash.filter)(res.body, function (machine) {
	            return machine.team === _this.props.teamId;
	          }),
	          loading_machines: (0, _lodash.map)(loading_machines, function () {
	            return false;
	          })
	        });
	      }).catch(function (err) {
	        (0, _utils2.logError)(err, "BuyingMachines", "reloadData");
	      });
	    };
	
	    _this.fetchData = function () {
	      var joinRequest = (0, _ApiService.batchRequest)([AVAILABLE_MACHINES_URL, TEAM_MACHINES_URL, FACTORIES_URL, PRODUCT_MANUFACTURES_URL]);
	
	      joinRequest.then(function (res) {
	        if (res[0].statusCode !== 200 || res[1].statusCode !== 200 || res[2].statusCode !== 200 || res[3].statusCode !== 200) {
	          throw res;
	        }
	
	        var available_machines = res[0].body;
	        var team_machines = res[1].body;
	        var factories = res[2].body;
	        var factory = factories.length > 0 ? factories[0].id : 0;
	        var product_manufactures = res[3].body;
	
	        _this.setState({
	          available_machines: available_machines,
	          team_machines: (0, _lodash.filter)(team_machines, function (machine) {
	            return machine.team === _this.props.teamId;
	          }),
	          factory: factory,
	          product_manufactures: product_manufactures,
	          loading: false
	        });
	      }).catch(function (err) {
	        (0, _utils2.logError)(err, "BuyingMachines", "fetchData");
	      });
	    };
	
	    _this.haveMachine = function (machineId) {
	      var team_machines = _this.state.team_machines;
	
	
	      return !(0, _lodash.isNil)(team_machines.find(function (i) {
	        return i.machine === machineId;
	      }));
	    };
	
	    _this.isSoldMachine = function (machine_id) {
	      return !(0, _lodash.isNil)((0, _lodash.find)(_this.state.team_machines, function (machine) {
	        return machine.id === machine_id && machine.accepted === false;
	      }));
	    };
	
	    _this.isLoadingMachine = function (machine_id) {
	      var loading_machines = _this.state.loading_machines;
	
	
	      if (machine_id in loading_machines) {
	        return loading_machines[machine_id];
	      }
	
	      return false;
	    };
	
	    _this.createMachineRequest = function (machine) {
	      var factory = _this.state.factory;
	
	
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/machines/").send({
	        factory: factory,
	        machine: machine
	      });
	    };
	
	    _this.onCreateMachine = function (machine_id) {
	      var _this$props = _this.props,
	          tourMode = _this$props.tourMode,
	          currentRound = _this$props.currentRound,
	          onFirstMachineBought = _this$props.onFirstMachineBought;
	
	
	      if (tourMode === true) {
	        return;
	      }
	
	      // Capture BEFORE the POST: is this the team's first-ever machine
	      // in Round 1? Used to fire the coaching popup once, on the very
	      // first purchase.
	      var wasFirstMachineRd1 = Number(currentRound) === 1 && Array.isArray(_this.state.team_machines) && _this.state.team_machines.length === 0;
	
	      _this.setState({
	        loading_machines: Object.assign({}, _this.state.loading_machines, _defineProperty({}, machine_id, true))
	      });
	
	      _this.createMachineRequest(machine_id).then(function (res) {
	        var foundMachine = _this.state.available_machines.find(function (i) {
	          return i.id === machine_id;
	        });
	        _this.showSuccessMessage("Production Line " + foundMachine.name + " selected successfully");
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("operations");
	        _this.reloadData();
	        if (wasFirstMachineRd1 && onFirstMachineBought) {
	          onFirstMachineBought();
	        }
	      }).catch(function (err) {
	        (0, _utils2.logError)(err, "BuyingMachines", "onCreateMachine");
	      });
	    };
	
	    _this.deleteMachineRequest = function (machine_id) {
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/machines/" + machine_id + "/sell/");
	    };
	
	    _this.onDeleteMachine = function (machineId) {
	      var _this$props2 = _this.props,
	          tourMode = _this$props2.tourMode,
	          currentRound = _this$props2.currentRound,
	          rounds = _this$props2.rounds;
	      var _this$state = _this.state,
	          team_machines = _this$state.team_machines,
	          product_manufactures = _this$state.product_manufactures;
	
	
	      if (tourMode === true) {
	        return;
	      }
	
	      var obj = team_machines.find(function (i) {
	        return i.machine === machineId;
	      });
	      if (!obj) {
	        return;
	      }
	
	      // Does the machine have any live production assignments? Used
	      // only to decide which confirmation copy to show — BE handles the
	      // cascade delete when the machine is sold, so the FE no longer
	      // needs the specific production ids. units_produced=0 rows don't
	      // tie up the line and are intentionally excluded.
	      var hasLiveProduction = product_manufactures.some(function (i) {
	        return Number(i.machine) === Number(obj.id) && Number(i.units_produced) > 0;
	      });
	
	      var round = rounds.find(function (i) {
	        return i.id === obj.round;
	      });
	      var is_prev_round = !!round && round.number !== currentRound;
	
	      _this.setState({
	        loading_machines: Object.assign({}, _this.state.loading_machines, _defineProperty({}, machineId, true))
	      });
	
	      // Three paths:
	      //  - Prior-round sell: always show the confirmation (loss on sale,
	      //    plus the cascade warning when production is attached).
	      //  - Same-round Undo Buy with production: show the undo-buy warning
	      //    so the student is aware the production rows will go with it.
	      //  - Same-round Undo Buy without production: direct delete, no modal.
	      if (is_prev_round || hasLiveProduction) {
	        _this.setState({
	          tmp_object_id: obj.id,
	          tmp_machine_id: machineId,
	          tmp_prev_round: is_prev_round,
	          sellConfirmationHasProduction: hasLiveProduction
	        }, function () {
	          _this.showSellConfirmation(machineId);
	        });
	      } else {
	        _this.onDeleteMachineRequest(obj.id, machineId, is_prev_round);
	      }
	    };
	
	    _this.computeLossOnSale = function (teamMachineRecordId) {
	      var _this$props3 = _this.props,
	          _this$props3$richTeam = _this$props3.richTeamMachines,
	          richTeamMachines = _this$props3$richTeam === undefined ? [] : _this$props3$richTeam,
	          _this$props3$machineD = _this$props3.machineDepreciations,
	          machineDepreciations = _this$props3$machineD === undefined ? [] : _this$props3$machineD,
	          _this$props3$sellingP = _this$props3.sellingPriceFactors,
	          sellingPriceFactors = _this$props3$sellingP === undefined ? [] : _this$props3$sellingP,
	          currentRound = _this$props3.currentRound,
	          _this$props3$rounds = _this$props3.rounds,
	          rounds = _this$props3$rounds === undefined ? [] : _this$props3$rounds;
	
	
	      var machine = richTeamMachines.find(function (m) {
	        return Number(m.id) === Number(teamMachineRecordId);
	      });
	      if (!machine) return 0;
	
	      var a = Number(machine.cost) || 0;
	
	      // machine_depreciations entries reference a round id (rd) — map our
	      // current round number to its id so we can exclude it from the sum.
	      var currentRoundObj = rounds.find(function (r) {
	        return Number(r.number) === Number(currentRound);
	      });
	      var currentRoundId = currentRoundObj ? Number(currentRoundObj.id) : null;
	
	      var b = machineDepreciations.filter(function (d) {
	        return Number(d.machine) === Number(teamMachineRecordId) && Number(d.rd) !== currentRoundId;
	      }).reduce(function (sum, d) {
	        return sum + (Number(d.value) || 0);
	      }, 0);
	
	      var age = Number(machine.age) || 0;
	      var factor = sellingPriceFactors.find(function (f) {
	        return Number(f.age) === age;
	      });
	      var c = factor ? Number(factor.sales_value) || 0 : 0;
	
	      var loss = (a - b) * (1 - c);
	      return loss > 0 ? loss : 0;
	    };
	
	    _this.showSellConfirmation = function (machineId) {
	      var sellConfirmationMachine = null;
	      if (machineId) {
	        var foundMachine = _this.state.available_machines.find(function (i) {
	          return i.id === machineId;
	        });
	        if (foundMachine) {
	          sellConfirmationMachine = foundMachine.name;
	        }
	      }
	
	      var sellConfirmationLoss = _this.computeLossOnSale(_this.state.tmp_object_id);
	
	      _this.setState({
	        showSellConfirmation: true,
	        sellConfirmationMachine: sellConfirmationMachine,
	        sellConfirmationLoss: sellConfirmationLoss
	      });
	    };
	
	    _this.cancelSellConfirmation = function () {
	      var tmp_machine_id = _this.state.tmp_machine_id;
	
	
	      _this.setState({
	        showSellConfirmation: false,
	        sellConfirmationHasProduction: false,
	        loading_machines: Object.assign({}, _this.state.loading_machines, _defineProperty({}, tmp_machine_id, false))
	      });
	    };
	
	    _this.doSellConfirmation = function () {
	      var _this$state2 = _this.state,
	          tmp_object_id = _this$state2.tmp_object_id,
	          tmp_machine_id = _this$state2.tmp_machine_id,
	          tmp_prev_round = _this$state2.tmp_prev_round;
	
	      // Production rows attached to this machine are cascade-deleted by
	      // the backend as part of the sell call — the FE just has to warn
	      // the student and fire the sell.
	
	      _this.onDeleteMachineRequest(tmp_object_id, tmp_machine_id, tmp_prev_round);
	    };
	
	    _this.onUndoSell = function (machineId) {
	      var _this$props4 = _this.props,
	          tourMode = _this$props4.tourMode,
	          currentRound = _this$props4.currentRound,
	          rounds = _this$props4.rounds;
	      var team_machines = _this.state.team_machines;
	
	
	      if (tourMode === true) return;
	
	      var currentRoundObj = (rounds || []).find(function (r) {
	        return Number(r.number) === Number(currentRound);
	      });
	      var currentRoundId = currentRoundObj ? Number(currentRoundObj.id) : null;
	
	      var obj = team_machines.find(function (m) {
	        return Number(m.machine) === Number(machineId) && Number(m.sold_in_round) === currentRoundId;
	      });
	      if (!obj) return;
	
	      _this.setState({
	        loading_machines: Object.assign({}, _this.state.loading_machines, _defineProperty({}, machineId, true))
	      });
	
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/machines/" + obj.id + "/unsell/").then(function () {
	        var foundMachine = _this.state.available_machines.find(function (i) {
	          return i.id === machineId;
	        });
	        var name = foundMachine ? foundMachine.name : machineId;
	        _this.showSuccessMessage("Production Line " + name + " sale was undone successfully");
	        // Selling decremented the unaccepted-decisions counter, so
	        // undoing the sell increments it back for balance.
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("operations");
	        _this.reloadData();
	      }).catch(function (err) {
	        (0, _utils2.logError)(err, "BuyingMachines", "onUndoSell");
	        _this.setState({
	          loading_machines: Object.assign({}, _this.state.loading_machines, _defineProperty({}, machineId, false))
	        });
	      });
	    };
	
	    _this.onDeleteMachineRequest = function (object_id, machine_id, is_prev_round) {
	      _this.deleteMachineRequest(object_id).then(function (res) {
	        var foundMachine = _this.state.available_machines.find(function (i) {
	          return i.id === machine_id;
	        });
	        _this.showSuccessMessage("Production Line " + foundMachine.name + " was de-selected successfully");
	        (0, _SubmitDecisions.decrementUnacceptedDecisions)("operations");
	        _this.reloadData();
	
	        var loading_machines = Object.assign({}, _this.state.loading_machines);
	        loading_machines[machine_id] = false;
	
	        _this.setState({
	          //loading_machines,
	          showSellConfirmation: false,
	          sellConfirmationHasProduction: false
	        });
	      }).catch(function (err) {
	        (0, _utils2.logError)(err, "BuyingMachines", "onDeleteMachine");
	      });
	    };
	
	    _this.getBuyMachineButtonClassname = function (machine_id) {
	      var base_classname = "btn-factory-modal btn btn-danger btn-xs";
	
	      if (_this.haveMachine(machine_id) || _this.isSoldMachine(machine_id)) {
	        return base_classname + " btn-opd-step-passed";
	      }
	
	      return base_classname;
	    };
	
	    _this.getSellMachineButtonClassname = function (machine_id) {
	      var base_classname = "btn-factory-modal btn btn-danger btn-xs";
	
	      if (_this.isSoldMachine(machine_id)) {
	        return base_classname + " btn-opd-step-passed";
	      }
	
	      return base_classname;
	    };
	
	    _this.isBuyMachineButtonDisabled = function (machine_id) {
	      return _this.isLoadingMachine(machine_id) || _this.haveMachine(machine_id);
	    };
	
	    _this.isSellMachineButtonDisabled = function (machine_id) {
	      return _this.isLoadingMachine(machine_id) || !_this.haveMachine(machine_id);
	    };
	
	    _this.purchasedThisRound = function (machine_id) {
	      var _this$props5 = _this.props,
	          currentRound = _this$props5.currentRound,
	          rounds = _this$props5.rounds;
	      var team_machines = _this.state.team_machines;
	
	      var currentRoundObj = (rounds || []).find(function (r) {
	        return Number(r.number) === Number(currentRound);
	      });
	      var currentRoundId = currentRoundObj ? Number(currentRoundObj.id) : null;
	      if (currentRoundId == null) return false;
	      var obj = team_machines.find(function (m) {
	        return Number(m.machine) === Number(machine_id);
	      });
	      if (!obj) return false;
	      return Number(obj.round) === currentRoundId;
	    };
	
	    _this.soldOldMachine = function (machine_id) {
	      var _this$props6 = _this.props,
	          currentRound = _this$props6.currentRound,
	          rounds = _this$props6.rounds;
	      var team_machines = _this.state.team_machines;
	
	      var currentRoundId = (0, _lodash.find)(rounds, function (round) {
	        return round.number === currentRound;
	      })["id"];
	      var soldMachine = (0, _lodash.find)(team_machines, function (machine) {
	        return machine["sold_in_round"] === currentRoundId && machine.machine === machine_id;
	      });
	
	      return !(0, _lodash.isNil)(soldMachine);
	    };
	
	    _this.getButton = function (machineId, lineIndex) {
	      if (_this.isLoadingMachine(machineId)) {
	        return _react2.default.createElement(
	          LoadingButton,
	          { disabled: true },
	          "Loading..."
	        );
	      }
	      if (_this.soldOldMachine(machineId)) {
	        return _react2.default.createElement(
	          UndoSellButton,
	          { onClick: function onClick() {
	              return _this.onUndoSell(machineId);
	            } },
	          "Undo Sell"
	        );
	      }
	      if (_this.haveMachine(machineId)) {
	        // Same-round buys are cheap to reverse (no loss on sale, no
	        // confirmation) — render as "Undo" with the neutral outline
	        // style, mirroring the existing Undo-Sell affordance. Prior-
	        // round buys stay red "Sell" so the destructive action reads
	        // clearly and still triggers the confirmation modal.
	        if (_this.purchasedThisRound(machineId)) {
	          return _react2.default.createElement(
	            UndoSellButton,
	            { onClick: function onClick() {
	                return _this.onDeleteMachine(machineId);
	              } },
	            "Undo Buy"
	          );
	        }
	        return _react2.default.createElement(
	          SellButton,
	          { onClick: function onClick() {
	              return _this.onDeleteMachine(machineId);
	            } },
	          "Sell"
	        );
	      }
	
	      // Production Line 4 (index 3) is locked in Year 1 — its higher
	      // capital cost + output is intended to unlock in later rounds.
	      if (Number(_this.props.currentRound) === 1 && lineIndex === 3) {
	        return _react2.default.createElement(
	          BuyTooltipWrapper,
	          { style: { cursor: 'not-allowed' } },
	          _react2.default.createElement(
	            DisabledBuyButton,
	            { disabled: true },
	            "Buy"
	          ),
	          _react2.default.createElement(
	            BuyTooltip,
	            { className: "buy-tooltip" },
	            "Production Line 4 isn't available in Year 1. You'll be able to purchase it in later years."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        BuyButton,
	        { onClick: function onClick() {
	            return _this.onCreateMachine(machineId);
	          } },
	        "Buy"
	      );
	    };
	
	    _this.getMachineCosts = function (costs) {
	      return "$" + (costs / 1000000).toFixed(2) + "M";
	    };
	
	    _this.state = {
	      show: false,
	      loading: true,
	      available_machines: [],
	      team_machines: [],
	      loading_machines: {},
	      product_manufactures: [],
	      factory: 0,
	      showSellConfirmation: false,
	      tmp_object_id: 0,
	      tmp_machine_id: 0,
	      tmp_prev_round: false,
	      sellConfirmationMachine: null,
	      sellConfirmationLoss: 0,
	      sellConfirmationHasProduction: false,
	      successMessage: null
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(BuyingMachines, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-buying-machines-modal", this.showModal);
	      this.eventemitter.on("hide-buying-machines-modal", this.hideModal);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-buying-machines-modal", this.showModal);
	      this.eventemitter.off("hide-buying-machines-modal", this.hideModal);
	    }
	
	    // Loss on sale = (a - b) * (1 - c) where
	    //   a = machine cost (from rich team-decisions team_machines.cost)
	    //   b = sum of machine_depreciations.value for this machine across
	    //       every round EXCEPT the current one
	    //   c = selling_price_factors.sales_value matched by the machine's age
	
	
	    // Reverses a prior-round machine sell that was made in the current
	    // round. Hits POST /api/team/machines/{id}/unsell/ where {id} is the
	    // team_machine record id (not the machine line number).
	
	
	    // True when the machine was purchased in the current round — the
	    // user can just "undo" the buy (no depreciation loss, no
	    // confirmation modal). Prior-round purchases render as "Sell" and
	    // route through the loss-on-sale confirmation flow.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          show = _state.show,
	          loading = _state.loading,
	          available_machines = _state.available_machines,
	          showSellConfirmation = _state.showSellConfirmation,
	          sellConfirmationLoss = _state.sellConfirmationLoss,
	          sellConfirmationHasProduction = _state.sellConfirmationHasProduction,
	          tmp_prev_round = _state.tmp_prev_round,
	          successMessage = _state.successMessage;
	
	      var hideModal = this.hideModal;
	
	      // Message copy depends on which action triggered the confirmation.
	      //   - Prior-round Sell, no production: loss-on-sale only (original).
	      //   - Prior-round Sell with production: loss-on-sale + cascade warning.
	      //   - Same-round Undo Buy with production: cascade warning only.
	      var formattedLoss = "$" + Math.round(sellConfirmationLoss || 0).toLocaleString('en-US');
	      var hasProduction = !!sellConfirmationHasProduction;
	      var message = void 0;
	      if (tmp_prev_round && hasProduction) {
	        message = _react2.default.createElement(
	          "span",
	          null,
	          "Selling this production line will result in a loss on sale of ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            formattedLoss
	          ),
	          " and will delete any existing production currently assigned to the machine. Are you sure?"
	        );
	      } else if (tmp_prev_round) {
	        message = _react2.default.createElement(
	          "span",
	          null,
	          "Selling this machine will result in a loss on sale of ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            formattedLoss
	          ),
	          ". Are you sure?"
	        );
	      } else {
	        message = _react2.default.createElement(
	          "span",
	          null,
	          "You currently have production scheduled on this production line. Undoing the purchase will remove those production units. Are you sure?"
	        );
	      }
	
	      return show ? _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        showSellConfirmation && _react2.default.createElement(_warning2.default, {
	          title: "Heads Up!",
	          message: message,
	          onSuccess: this.doSellConfirmation,
	          onCancel: this.cancelSellConfirmation
	        }),
	        !showSellConfirmation && _react2.default.createElement(
	          _reactBootstrap.Modal,
	          {
	            show: true,
	            onHide: hideModal,
	            dialogClassName: "modal-dialog-bigger"
	          },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              ModalTitle,
	              null,
	              "Machine Selection"
	            ),
	            _react2.default.createElement(
	              ModalDescription,
	              null,
	              "Choose which production machines to add to or remove from your facility. Each line has a different output rate and capital cost, so pick the mix that fits your production goals for the year. ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Units Per Hour"
	              ),
	              " is each machine's maximum hourly output."
	            ),
	            successMessage && _react2.default.createElement(_success2.default, {
	              message: successMessage
	            }),
	            _react2.default.createElement(
	              ModernTable,
	              null,
	              _react2.default.createElement(
	                "colgroup",
	                null,
	                _react2.default.createElement("col", { style: { width: '25%' } }),
	                _react2.default.createElement("col", { style: { width: '25%' } }),
	                _react2.default.createElement("col", { style: { width: '25%' } }),
	                _react2.default.createElement("col", { style: { width: '25%' } })
	              ),
	              loading === false && _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  HeadRow,
	                  null,
	                  _react2.default.createElement(
	                    HeadCell,
	                    null,
	                    "Production Line"
	                  ),
	                  _react2.default.createElement(
	                    HeadCell,
	                    { align: "center" },
	                    "Units Per Hour"
	                  ),
	                  _react2.default.createElement(
	                    HeadCell,
	                    { align: "center" },
	                    "Cost"
	                  ),
	                  _react2.default.createElement(
	                    HeadCell,
	                    { align: "center" },
	                    "Action"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                loading === true ? _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    { className: "loader-inline", colSpan: "4", style: { textAlign: 'center', padding: '40px 0' } },
	                    _react2.default.createElement(_reactLoaders2.default, { type: "ball-scale-ripple", active: true })
	                  )
	                ) : available_machines.map(function (machine, i) {
	                  return _react2.default.createElement(
	                    Row,
	                    { key: i },
	                    _react2.default.createElement(
	                      Cell,
	                      null,
	                      "Production Line ",
	                      i + 1
	                    ),
	                    _react2.default.createElement(
	                      Cell,
	                      { align: "center" },
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: machine.units_per_hour,
	                        suffix: " units",
	                        thousandSeparator: ",",
	                        displayType: "text"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      Cell,
	                      { align: "center" },
	                      _this2.getMachineCosts(machine.costs)
	                    ),
	                    _react2.default.createElement(
	                      Cell,
	                      { align: "center" },
	                      _this2.getButton(machine.id, i)
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Footer,
	            { bsClass: "modal-footer op-decision-modal-footer" },
	            _react2.default.createElement(
	              FooterCloseButton,
	              { onClick: hideModal },
	              "Close"
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return BuyingMachines;
	}(_react.Component);
	
	exports.default = BuyingMachines;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _ModalSubheader = __webpack_require__(1404);
	
	var _ModalSubheader2 = _interopRequireDefault(_ModalSubheader);
	
	var _utils = __webpack_require__(66);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Location = __webpack_require__(23);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	var _HelpIconButton = __webpack_require__(1402);
	
	var _HelpIconButton2 = _interopRequireDefault(_HelpIconButton);
	
	var _OPSelectBox = __webpack_require__(1244);
	
	var _OPSelectBox2 = _interopRequireDefault(_OPSelectBox);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils2 = __webpack_require__(18);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactLoaders2 = _interopRequireDefault(_reactLoaders);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _errorInline = __webpack_require__(302);
	
	var _errorInline2 = _interopRequireDefault(_errorInline);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "save");
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "cancel");
	
	var numberWithCommas = function numberWithCommas(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	var AVAILABLE_MACHINES_URL = ("https://be-production-itb.marketgames.io/api/") + "static/machines/";
	var TEAM_MACHINES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/machines/";
	var PRODUCT_MANUFACTURES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/";
	var PRICE_FORECASTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/price_forecasts/";
	var MAX_ALLOWED_URL = ("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/get_max_allowed/";
	var FACTORIES_URL = ("https://be-production-itb.marketgames.io/api/") + "team/factories/";
	
	var ProduceProduct = function (_Component) {
	  _inherits(ProduceProduct, _Component);
	
	  function ProduceProduct(props) {
	    _classCallCheck(this, ProduceProduct);
	
	    var _this = _possibleConstructorReturn(this, (ProduceProduct.__proto__ || Object.getPrototypeOf(ProduceProduct)).call(this, props));
	
	    _this.showInfoAlert = function () {
	      _this.setState({
	        infoAlert: true
	      });
	    };
	
	    _this.hideInfoAlert = function () {
	      _this.setState({
	        infoAlert: false
	      });
	    };
	
	    _this.showError = function (errorTitle, errorMessage) {
	      _this.setState({
	        errorTitle: errorTitle,
	        errorMessage: errorMessage
	      }, function () {
	        _this.hideError();
	      });
	    };
	
	    _this.hideError = function () {
	      setTimeout(function () {
	        _this.setState({
	          errorTitle: null,
	          errorMessage: null
	        });
	      }, 5000);
	    };
	
	    _this.showModal = function () {
	      var products = _this.props.products;
	
	
	      if (products.length === 0) {
	        _this.eventemitter.trigger("app-show-error", ["You have no products. For more information, please speak to Product Management."]);
	        return;
	      }
	
	      _this.setState({
	        show: true
	      }, function () {
	        _this.fetchData();
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.getMaxUnits = function (product, machine, units_produced) {
	      return (0, _ApiService.postRequest)(MAX_ALLOWED_URL).send({
	        product: product,
	        machine: machine,
	        units_produced: units_produced || 1
	      });
	    };
	
	    _this.loadMaxUnits = function () {
	      var products = _this.props.products;
	      var _this$state = _this.state,
	          product_manufactures = _this$state.product_manufactures,
	          units = _this$state.units;
	
	
	      var max_units = {};
	      var requests = [];
	
	      products.forEach(function (product) {
	        var product_id = product.product_id;
	
	
	        var units_produced = product.units_produced;
	        if (product_id in units) {
	          units_produced = units[product_id];
	        }
	
	        var obj = product_manufactures.find(function (i) {
	          return i.product === product_id;
	        });
	        if (obj) {
	          var machine = obj.machine;
	
	          if (machine > 0) {
	            requests.push(_this.getMaxUnits(product_id, machine, units_produced));
	          } else {
	            max_units[product_id] = 0;
	          }
	        } else {
	          max_units[product_id] = 0;
	        }
	      });
	
	      if (requests.length === 0) {
	        _this.setState({
	          max_units: max_units,
	          loading: false
	        });
	        return;
	      }
	
	      Promise.allSettled(requests).then(function (results) {
	        results.forEach(function (result, index) {
	          if (result.status === 'fulfilled') {
	            var max_allowed = result.value.body.max_allowed;
	
	
	            var product_id = parseInt(result.value.req._data.product, 10);
	            if (isNaN(product_id)) {
	              product_id = 0;
	            }
	
	            if (product_id > 0) {
	              max_units[product_id] = max_allowed;
	            }
	          } else {
	            var err = result.reason;
	            var errUnitsProduced = err.response && err.response.body && err.response.body.units_produced;
	
	            if (errUnitsProduced && errUnitsProduced[0].indexOf('Max allowed') !== -1) {
	              var _product_id = parseInt(err.response.req._data.product, 10);
	              max_units[_product_id] = errUnitsProduced[0].match(/\d+/)[0];
	            }
	
	            (0, _utils2.logError)(err, "ProduceProduct", "loadMaxUnits");
	          }
	        });
	
	        _this.setState({
	          max_units: max_units,
	          loading: false
	        });
	      });
	    };
	
	    _this.updateMaxUnits = function (product_id) {
	      var products = _this.props.products;
	      var _this$state2 = _this.state,
	          product_manufactures = _this$state2.product_manufactures,
	          machines = _this$state2.machines,
	          units = _this$state2.units;
	
	      var max_units = Object.assign({}, _this.state.max_units);
	      var product = products.find(function (i) {
	        return i.product_id === product_id;
	      });
	
	      var machine = 0;
	      var obj = product_manufactures.find(function (i) {
	        return i.product === product_id;
	      });
	      if (obj) {
	        machine = obj.machine;
	      } else if (product_id in machines) {
	        machine = machines[product_id];
	      }
	
	      var units_produced = product.units_produced;
	      if (product_id in units) {
	        units_produced = units[product_id];
	      }
	
	      if (machine === 0) {
	        max_units[product_id] = 0;
	        _this.setState({
	          max_units: max_units
	        });
	        return;
	      }
	
	      _this.getMaxUnits(product_id, machine, units_produced).then(function (res) {
	        max_units[product_id] = res.body.max_allowed;
	
	        _this.setState({
	          max_units: max_units
	        });
	      }).catch(function (err) {
	        var errUnitsProduced = err.response.body.units_produced;
	        if (errUnitsProduced) {
	          if (errUnitsProduced[0].indexOf('Max allowed') !== -1) {
	            var _product_id2 = parseInt(err.response.req._data.product, 10);
	            max_units[_product_id2] = errUnitsProduced[0].match(/\d+/)[0];
	            _this.setState({
	              max_units: max_units
	            });
	          }
	        }
	        (0, _utils2.logError)(err, "ProduceProduct", "updateMaxUnits");
	      });
	    };
	
	    _this.updateMachine = function (e) {
	      var input = e.target;
	
	      var value = Number(input.value);
	      if (typeof value !== "number") {
	        value = 0;
	      }
	
	      var productId = input.dataset.productId;
	
	      productId = parseInt(productId, 10);
	      if (isNaN(productId)) {
	        productId = 0;
	      }
	
	      var product_manufactures = [].concat(_toConsumableArray(_this.state.product_manufactures));
	      var machines = Object.assign({}, _this.state.machines);
	      var units = Object.assign({}, _this.state.units);
	
	      var objIndex = product_manufactures.findIndex(function (i) {
	        return i.product === productId;
	      });
	      if (objIndex >= 0) {
	        var obj = product_manufactures[objIndex];
	        if (obj.machine !== value) {
	          product_manufactures[objIndex].machine = value;
	
	          _this.setState({
	            product_manufactures: product_manufactures,
	            units: Object.assign({}, units, _defineProperty({}, productId, units[productId] > 0 ? units[productId] : 1))
	          }, function () {
	            _this.updateMaxUnits(productId);
	          });
	        }
	      } else {
	        machines[productId] = value;
	
	        _this.setState({
	          machines: machines,
	          units: Object.assign({}, units, _defineProperty({}, productId, units[productId] > 0 ? units[productId] : 1))
	        }, function () {
	          _this.updateMaxUnits(productId);
	        });
	      }
	    };
	
	    _this.updateUnits = function (e, nonFormattedValue) {
	      var input = e.target;
	
	      var value = nonFormattedValue ? nonFormattedValue.floatValue : Number(input.value);
	      if (typeof value !== "number") {
	        value = 0;
	      }
	
	      var productId = input.dataset.productId;
	
	      productId = parseInt(productId, 10);
	      if (isNaN(productId)) {
	        productId = 0;
	      }
	
	      var units = Object.assign({}, _this.state.units);
	      units[productId] = value;
	
	      _this.setState({
	        units: units
	      });
	    };
	
	    _this.isLoading = function (product_id) {
	      var loading_set = _this.state.loading_set;
	
	
	      if (product_id in loading_set) {
	        return loading_set[product_id];
	      }
	
	      return false;
	    };
	
	    _this.updateLoading = function (product_id, value) {
	      var loading_set = Object.assign({}, _this.state.loading_set);
	      loading_set[product_id] = value;
	
	      _this.setState({
	        loading_set: loading_set
	      });
	    };
	
	    _this.setModalLoading = function () {
	      _this.setState({
	        loading: true
	      });
	    };
	
	    _this.updateError = function (showError, errorText) {
	      _this.setState({
	        showError: showError,
	        errorText: errorText
	      });
	    };
	
	    _this.submitRequest = function (product_id, machine, units_produced, product_manufacture) {
	      var factory = _this.state.factory;
	
	      var data = {
	        factory: factory,
	        machine: machine,
	        product: parseInt(product_id, 10),
	        units_produced: units_produced
	      };
	
	      var url = ("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/";
	
	      if (product_manufacture) {
	        url += product_manufacture.id + "/";
	
	        return (0, _ApiService.putRequest)(url).send(data);
	      }
	
	      return (0, _ApiService.postRequest)(url).send(data);
	    };
	
	    _this.goToCustomerAnalysis = function (e) {
	      e.preventDefault();
	      _this.eventemitter.trigger("coaching-feedback-hide");
	      (0, _Location.changeLocation)("/ceo/analysis/market");
	    };
	
	    _this.showPopup = function (units) {
	      _this.eventemitter.trigger("coaching-feedback", ["Inventory Management", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Whoa! You\u2019re only producing ",
	        numberWithCommas(units),
	        " units? How many image sensors are customers demanding again? You should double check customer demand in the <",
	        _react2.default.createElement(
	          "a",
	          { href: "/ceo/analysis/market", onClick: _this.goToCustomerAnalysis },
	          "customer analysis"
	        ),
	        "> page and reconsider producing more units if you only have a few or no units in inventory."
	      )]);
	    };
	
	    _this.showPopup2 = function () {
	      _this.eventemitter.trigger("coaching-feedback", ["Not Released Yet", _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Whoa! This product won\u2019t be released from design this year and therefore you won\u2019t be able to produce units.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "For more details on this product\u2019s release date, please follow up with your Head of Product who created the product. S/he has the power to modify its features if you want to produce it this year."
	      )]);
	    };
	
	    _this.submit = function (product_id) {
	      var _this$props = _this.props,
	          products = _this$props.products,
	          reloadData = _this$props.reloadData;
	      var _this$state3 = _this.state,
	          product_manufactures = _this$state3.product_manufactures,
	          units = _this$state3.units,
	          max_units = _this$state3.max_units,
	          machines = _this$state3.machines;
	
	      var product = products.find(function (i) {
	        return i.product_id === product_id;
	      });
	
	      if (!product) {
	        return;
	      }
	
	      var machine = 0;
	      var product_manufacture = product_manufactures.find(function (i) {
	        return i.product === product_id;
	      });
	      if (product_manufacture) {
	        machine = product_manufacture.machine;
	      } else if (product_id in machines) {
	        machine = machines[product_id];
	      }
	
	      var units_produced = product.units_produced;
	      if (product_id in units) {
	        units_produced = units[product_id];
	      }
	
	      if (!units_produced) {
	        _this.showError('Value Must Be At Least 1', 'You have to input at least 1 unit for production in order to produce units');
	        return;
	      }
	
	      if (units_produced < 1) {
	        _this.showError('Value Must Be At Least 1', product.product_name + "'s units cannot be lower than 1");
	        return;
	      }
	
	      if (machine === 0) {
	        _this.showError('Machine Required', 'Please make machine selection!');
	        return;
	      }
	
	      var max_allowed = 0;
	      if (product_id in max_units) {
	        max_allowed = max_units[product_id];
	      }
	
	      var isIncrease = !product_manufacture || units_produced > product_manufacture.units_produced;
	      if (isIncrease && units_produced > max_allowed && max_allowed > 0) {
	        _this.showError('Error | No More Available Capacity', 'You cannot manufacture more than your available capacity. Please modify the no. of units or consider a production line with greater capacity.');
	        return;
	      }
	
	      var p = _this.state.products.find(function (i) {
	        return i.id === product_id;
	      });
	      if (!p || p.months_available_to_produce === 0) {
	        _this.showError('Error | Product Not Yet Released From Design', "You cannot manufacture units of this product until it's released from product design. To modify the release date, please follow up with your Product Manager.");
	        return;
	      }
	
	      _this.updateError(false, "");
	      _this.updateLoading(product_id, true);
	      _this.setModalLoading();
	
	      _this.submitRequest(product_id, machine, units_produced, product_manufacture).then(function (res) {
	        var _res$body = res.body,
	            units_produced = _res$body.units_produced,
	            months_to_produce = _res$body.months_to_produce;
	
	        if (units_produced <= 100000) {
	          _this.showPopup(units_produced);
	        } else if (months_to_produce === 0) {
	          _this.showPopup2();
	        }
	
	        var foundProduct = products.find(function (i) {
	          return i.product_id === product_id;
	        });
	
	        _this.props.showSuccessMessage(units_produced.toLocaleString('en-US') + " units of Product " + foundProduct.product_name + " is now scheduled to be manufactured");
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("operations");
	        _this.updateLoading(product_id, false);
	        reloadData();
	        _this.fetchData();
	      }).catch(function (err) {
	        _this.updateLoading(product_id, false);
	        if (err.response.status === 400 && "machine" in err.response.body && err.response.body["machine"].length > 0) {
	          _this.updateLoading(product_id, false);
	          _this.updateError(true, err.response.body["machine"][0]);
	          return;
	        } else {
	          if (machine === 0) {
	            _this.updateError(true, "Please make machine selection!");
	            return;
	          }
	
	          if (units_produced < 1) {
	            _this.updateError(true, product.product_name + "'s units cannot be lower then 1");
	            return;
	          }
	
	          var _max_allowed = 0;
	          if (product_id in max_units) {
	            _max_allowed = max_units[product_id];
	          }
	
	          var _p = _this.state.products.find(function (i) {
	            return i.id === product_id;
	          });
	          if (!_p || _p.months_available_to_produce === 0) {
	            _this.showError('Error | Product Not Yet Released From Design', 'You cannot manufacture units of this product until it’s released from product design. To modify the release date, please follow up with your Product Manager.');
	            return;
	          }
	
	          if (units_produced > _max_allowed) {
	            _this.showError('Error | No More Available Capacity', 'You cannot manufacture more than your available capacity. Please modify the no. of units or consider a production line with greater capacity.');
	            return;
	          }
	        }
	
	        (0, _utils2.logError)(err, "ProduceProduct", "submit");
	      });
	    };
	
	    _this.onRemoveOperation = function (e, product_id) {
	      _this.setModalLoading();
	      _this.props.onRemoveOperation(e, product_id, function () {
	        _this.props.reloadData();
	        _this.fetchData();
	      });
	    };
	
	    _this.onAvailableCapacityQuestionClick = function () {
	      var currentRound = _this.props.currentRound;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/products/?round_number=" + currentRound).then(function (res) {
	        var teamProduct = res.body[0];
	        var availableCapacityInfoText = '';
	        if (teamProduct.months_available_to_produce === 0) {
	          availableCapacityInfoText = _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "Your product\u2019s release date is beyond a year (round):"
	            ),
	            " If you want the release date to be within this year, navigate to product decision page and adjust your product features."
	          );
	        } else {
	          availableCapacityInfoText = _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "You\u2019ve reached maximum production with this machine:"
	            ),
	            "  You\u2019ve already manufactured the maximum units. To check, close the production pop up and view your the In-House production.  "
	          );
	        }
	
	        _this.setState({
	          showAwailableCapacityModal: true,
	          availableCapacityInfoText: availableCapacityInfoText
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.onAvailableCapacityInfoHide = function () {
	      _this.setState({
	        showAwailableCapacityModal: false
	      });
	    };
	
	    _this.state = {
	      showError: false,
	      errorText: "",
	      show: false,
	      available_machines: [],
	      team_machines: [],
	      product_manufactures: [],
	      machines: {},
	      price_forecasts: [],
	      max_units: {},
	      products: [],
	      units: {},
	      loading_set: {},
	      factory: 0,
	      loading: true,
	      errorTitle: null,
	      errorMessage: null,
	      showAwailableCapacityModal: false,
	      availableCapacityInfoText: '',
	      infoAlert: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ProduceProduct, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("show-product-product-modal", this.showModal);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("show-product-product-modal", this.showModal);
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this2 = this;
	
	      var joinRequest = (0, _ApiService.batchRequest)([AVAILABLE_MACHINES_URL, TEAM_MACHINES_URL, PRODUCT_MANUFACTURES_URL, PRICE_FORECASTS_URL, FACTORIES_URL, ("https://be-production-itb.marketgames.io/api/") + "team/products/"]);
	
	      joinRequest.then(function (res) {
	        if (res[0].statusCode !== 200 || res[1].statusCode !== 200 || res[2].statusCode !== 200 || res[3].statusCode !== 200 || res[4].statusCode !== 200 || res[5].statusCode !== 200) {
	          throw res;
	        }
	
	        var available_machines = res[0].body;
	        var team_machines = res[1].body.filter(function (team_machine) {
	          return !team_machine.sold_in_round;
	        });
	        var product_manufactures = res[2].body;
	        var price_forecasts = res[3].body;
	        var factories = res[4].body;
	        var factory = factories.length > 0 ? factories[0].id : 0;
	        var products = res[5].body;
	
	        _this2.setState({
	          available_machines: available_machines,
	          team_machines: team_machines,
	          product_manufactures: product_manufactures,
	          price_forecasts: price_forecasts,
	          factory: factory,
	          units: {},
	          loading_set: {},
	          machines: {},
	          products: products
	        }, function () {
	          _this2.loadMaxUnits();
	        });
	      }).catch(function (err) {
	        (0, _utils2.logError)(err, "ProduceProduct", "fetchData");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          showError = _state.showError,
	          errorText = _state.errorText,
	          show = _state.show,
	          loading = _state.loading,
	          available_machines = _state.available_machines,
	          team_machines = _state.team_machines,
	          product_manufactures = _state.product_manufactures,
	          price_forecasts = _state.price_forecasts,
	          max_units = _state.max_units,
	          units = _state.units,
	          machines = _state.machines,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          showAwailableCapacityModal = _state.showAwailableCapacityModal,
	          availableCapacityInfoText = _state.availableCapacityInfoText,
	          infoAlert = _state.infoAlert;
	      var products = this.props.products;
	
	      var hideModal = this.hideModal;
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          onHide: hideModal,
	          dialogClassName: "modal-dialog-biggest"
	        },
	        showAwailableCapacityModal && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Your Available Capacity is zero. Here\u2019s why",
	          message: availableCapacityInfoText,
	          buttonText: "Done",
	          onHide: this.onAvailableCapacityInfoHide,
	          overlayStylings: 'border-radius: 30px;',
	          modalStylings: 'top: 50%; transform: translateY(-50%);'
	        }),
	        infoAlert && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Available Capacity",
	          message: "Refers to the maximum number of units that can be produced.",
	          buttonText: "Done",
	          onHide: this.hideInfoAlert,
	          modalStylings: 'top: 50%; transform: translateY(-50%);'
	        }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Title,
	            {
	              bsClass: "modal-title title-light-blue",
	              componentClass: _ModalSubheader2.default,
	              subheader: "FAB FACILITY"
	            },
	            "Foundry"
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          showError === true && _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-xs-12" },
	              _react2.default.createElement(
	                _reactBootstrap.Alert,
	                { bsStyle: "danger" },
	                errorText
	              )
	            )
	          ),
	          errorTitle && errorMessage && _react2.default.createElement(_errorInline2.default, {
	            title: errorTitle,
	            message: errorMessage
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive mt-15" },
	            _react2.default.createElement(
	              "h4",
	              { className: "mb-20 title-blue" },
	              "Production Run"
	            ),
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              loading === false && _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none" },
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "b",
	                      { className: "title-black" },
	                      "Products"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "b",
	                      { className: "title-black" },
	                      "Production Line"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "b",
	                      { className: "title-black" },
	                      "Units"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "b",
	                      { className: "title-black" },
	                      "Sales Forecast"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "b",
	                      { className: "title-black" },
	                      "Available Capacity"
	                    ),
	                    _react2.default.createElement("img", { alt: "icon help", src: _iconTableHelp2.default, style: { marginLeft: 4, cursor: 'pointer' }, onClick: this.showInfoAlert })
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "b",
	                      { className: "title-black" },
	                      "Actions"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                loading === true ? _react2.default.createElement(
	                  "tr",
	                  { className: "border-none" },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "text-center loader-inline", colSpan: "6" },
	                    _react2.default.createElement(_reactLoaders2.default, { type: "ball-scale-ripple", active: true })
	                  )
	                ) : products.map(function (product, i) {
	                  var product_id = product.product_id,
	                      product_name = product.product_name;
	
	                  var is_loading = _this3.isLoading(product_id);
	                  var machine_id = 0;
	                  var product_manufacture = product_manufactures.find(function (i) {
	                    return i.product === product_id;
	                  });
	                  if (product_manufacture) {
	                    machine_id = product_manufacture.machine;
	                  } else if (product_id in machines) {
	                    machine_id = machines[product_id];
	                  }
	                  var forecast = 0;
	                  var price_forecast = price_forecasts.find(function (i) {
	                    return i.product === product_id;
	                  });
	                  if (price_forecast) {
	                    forecast = price_forecast.forecast;
	                  }
	                  var max_units_value = 0;
	                  if (product_id in max_units) {
	                    max_units_value = max_units[product_id];
	                  }
	                  var units_produced = product.units_produced;
	                  if (product_id in units) {
	                    units_produced = units[product_id];
	                  }
	
	                  var actionsStyle = {
	                    width: "135px",
	                    verticalAlign: "middle"
	                  };
	                  var removeBtnStyle = {
	                    marginLeft: "10px",
	                    top: "2px"
	                  };
	                  var can_remove = product.units_produced > 0 ? true : false;
	
	                  return _react2.default.createElement(
	                    "tr",
	                    { className: "border-none", key: i },
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center" },
	                      "Product ",
	                      product_name
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center" },
	                      _react2.default.createElement(_OPSelectBox2.default, {
	                        available_machines: available_machines,
	                        team_machines: team_machines,
	                        productId: product_id,
	                        name: "machine",
	                        value: machine_id,
	                        onChange: _this3.updateMachine,
	                        isDisabled: can_remove
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center" },
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        name: "units_produced",
	                        "data-product-id": product_id,
	                        value: units_produced,
	                        thousandSeparator: ",",
	                        onChange: _this3.updateUnits
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center" },
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: forecast,
	                        thousandSeparator: ",",
	                        displayType: "text"
	                      }),
	                      forecast === 0 && _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	                        tooltipContent: "Marketing has not made any forecast for sales yet. Please coordinate with Marketing if you want sales forecast numbers.",
	                        iconSize: "sm",
	                        category: "Product Units Sales Forecast"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center" },
	                      _react2.default.createElement(_reactNumberFormat2.default, {
	                        value: max_units_value,
	                        thousandSeparator: ",",
	                        displayType: "text"
	                      }),
	                      max_units_value === 0 && machine_id > 0 && _react2.default.createElement(_HelpIconButton2.default, {
	                        onClick: _this3.onAvailableCapacityQuestionClick,
	                        iconSize: "sm",
	                        category: "Produce Units Max Units"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center", style: actionsStyle },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "cancel",
	                          disabled: is_loading,
	                          onClick: function onClick() {
	                            return _this3.submit(product_id);
	                          }
	                        },
	                        is_loading === true ? "Loading..." : "Update"
	                      ),
	                      can_remove === true && _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/#",
	                          className: "remove-operation",
	                          onClick: function onClick(e) {
	                            return _this3.onRemoveOperation(e, product_id);
	                          },
	                          style: removeBtnStyle
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: "trash-o" })
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Footer,
	          { bsClass: "modal-footer op-decision-modal-footer" },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: "save", onClick: hideModal },
	            "Close"
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProduceProduct;
	}(_react.Component);
	
	exports.default = ProduceProduct;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SelectBox(props) {
	  var name = props.name,
	      productId = props.productId,
	      value = props.value,
	      onChange = props.onChange,
	      available_machines = props.available_machines,
	      team_machines = props.team_machines;
	
	  var isDisabled = props.isDisabled || false;
	
	  return _react2.default.createElement(
	    "select",
	    {
	      name: name,
	      "data-product-id": productId,
	      value: value,
	      onChange: onChange,
	      disabled: isDisabled
	    },
	    _react2.default.createElement(
	      "option",
	      { value: 0, disabled: isDisabled },
	      "Choose"
	    ),
	    team_machines.map(function (machine, i) {
	      var index = available_machines.findIndex(function (ii) {
	        return ii.id === machine.machine;
	      });
	
	      return _react2.default.createElement(
	        "option",
	        { key: i, value: machine.id, disabled: isDisabled },
	        index + 1
	      );
	    })
	  );
	}
	
	exports.default = SelectBox;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _recompose = __webpack_require__(55);
	
	var _index = __webpack_require__(587);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsPopup = (0, _recompose.pure)(function (props) {
	  return _react2.default.createElement(
	    _reactBootstrap.Modal,
	    { show: true, backdrop: "static", dialogClassName: "mg-payments-popup" },
	    _react2.default.createElement(
	      _reactBootstrap.Modal.Body,
	      null,
	      _react2.default.createElement(_index2.default, Object.assign({ mode: "popup" }, props))
	    )
	  );
	});
	
	exports.default = PaymentsPopup;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral([""], [""]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ImageWrapperDefaultComponent = _styledComponents2.default.div(_templateObject);
	var ImageDefaultComponent = _styledComponents2.default.img(_templateObject);
	var AgeDefaultComponent = _styledComponents2.default.div(_templateObject);
	var ReleaseDateDefaultComponent = _styledComponents2.default.div(_templateObject);
	
	var PDSensor = function PDSensor(_ref) {
	  var product = _ref.product,
	      image = _ref.image,
	      currentRound = _ref.currentRound,
	      rounds = _ref.rounds,
	      showReleaseDate = _ref.showReleaseDate,
	      showImage = _ref.showImage,
	      showAge = _ref.showAge,
	      _ref$duration_field = _ref.duration_field,
	      duration_field = _ref$duration_field === undefined ? "total_duration" : _ref$duration_field,
	      _ref$ImageComponent = _ref.ImageComponent,
	      ImageComponent = _ref$ImageComponent === undefined ? ImageDefaultComponent : _ref$ImageComponent,
	      _ref$ImageWrapperComp = _ref.ImageWrapperComponent,
	      ImageWrapperComponent = _ref$ImageWrapperComp === undefined ? ImageWrapperDefaultComponent : _ref$ImageWrapperComp,
	      _ref$AgeComponent = _ref.AgeComponent,
	      AgeComponent = _ref$AgeComponent === undefined ? AgeDefaultComponent : _ref$AgeComponent,
	      _ref$ReleaseDateCompo = _ref.ReleaseDateComponent,
	      ReleaseDateComponent = _ref$ReleaseDateCompo === undefined ? ReleaseDateDefaultComponent : _ref$ReleaseDateCompo;
	
	  var productRounds = Object.keys(product).map(function (r) {
	    return Number(r);
	  });
	  var currentProduct = productRounds.includes(currentRound) ? product[currentRound] : {};
	  var round = rounds.find(function (r) {
	    return r.number === currentRound;
	  });
	
	  var duration = _lodash2.default.get(currentProduct, duration_field, 0);
	  if (round && round.number > 1 && duration >= 12) {
	    duration += (round.number - 1) * 12;
	  }
	
	  var year = parseInt((duration - 1) / 12, 10);
	  var quarter = duration - year * 12;
	
	  year += 1;
	  quarter = quarter / 3 + 1;
	  if (quarter >= 5) {
	    quarter -= 4;
	    year += 1;
	  }
	
	  if (round && year < round.number) {
	    year = round.number;
	  }
	
	  var releaseDate = "Year " + year + " Q" + quarter;
	  var age = currentRound in product ? product[currentRound].age : 0;
	  var ageInYears = (age / 12).toFixed(0);
	
	  var releaseDateComponent = _react2.default.createElement(
	    ReleaseDateComponent,
	    null,
	    releaseDate
	  );
	  var imageWrapperComponent = _react2.default.createElement(
	    ImageWrapperComponent,
	    null,
	    _react2.default.createElement(ImageComponent, { src: image, alt: "PD Sensor" })
	  );
	  var ageComponent = _react2.default.createElement(
	    AgeComponent,
	    null,
	    "Age: ",
	    ageInYears,
	    " Year"
	  );
	
	  if (showReleaseDate === true && showImage === false && showAge === false) {
	    return releaseDateComponent;
	  }
	
	  if (showReleaseDate === false && showImage === true && showAge === false) {
	    return imageWrapperComponent;
	  }
	
	  if (showReleaseDate === false && showImage === false && showAge === true) {
	    return ageComponent;
	  }
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    showReleaseDate && releaseDateComponent,
	    showImage && imageWrapperComponent,
	    showAge && ageComponent
	  );
	};
	
	exports.default = PDSensor;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 24px 40px 64px;\n  max-width: 760px;\n  margin: 0 auto;\n  font-family: ", ";\n"], ["\n  padding: 24px 40px 64px;\n  max-width: 760px;\n  margin: 0 auto;\n  font-family: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"], ["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 28px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n"], ["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 28px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"], ["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1.5px solid ", ";\n  background: #F5F7FB;\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n    background: #FFFFFF;\n  }\n"], ["\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1.5px solid ", ";\n  background: #F5F7FB;\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n    background: #FFFFFF;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: rgba(0, 27, 59, 0.5);\n  margin-top: 6px;\n"], ["\n  font-size: 12px;\n  color: rgba(0, 27, 59, 0.5);\n  margin-top: 6px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #DC2626;\n  font-weight: 600;\n  margin-top: 6px;\n"], ["\n  font-size: 12px;\n  color: #DC2626;\n  font-weight: 600;\n  margin-top: 6px;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 110px 1fr 56px;\n  gap: 16px;\n  align-items: center;\n"], ["\n  display: grid;\n  grid-template-columns: 110px 1fr 56px;\n  gap: 16px;\n  align-items: center;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 110px 1fr 56px;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 6px;\n"], ["\n  display: grid;\n  grid-template-columns: 110px 1fr 56px;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 6px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n"], ["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  background: #3A507B;\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 800;\n  border-radius: 10px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-variant-numeric: tabular-nums;\n"], ["\n  background: #3A507B;\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 800;\n  border-radius: 10px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-variant-numeric: tabular-nums;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 4px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 4px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"], ["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  opacity: ", ";\n  touch-action: none;\n  user-select: none;\n  min-width: 0;\n"], ["\n  position: relative;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  opacity: ", ";\n  touch-action: none;\n  user-select: none;\n  min-width: 0;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: #E5E9F0;\n  border-radius: 999px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: #E5E9F0;\n  border-radius: 999px;\n  pointer-events: none;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  height: 6px;\n  background: #3A507B;\n  border-radius: 999px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  height: 6px;\n  background: #3A507B;\n  border-radius: 999px;\n  pointer-events: none;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  background: #FFFFFF;\n  border: 3px solid #3A507B;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(58, 80, 123, 0.25);\n  transform: translateX(-50%);\n  top: 50%;\n  margin-top: -11px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  width: 22px;\n  height: 22px;\n  background: #FFFFFF;\n  border: 3px solid #3A507B;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(58, 80, 123, 0.25);\n  transform: translateX(-50%);\n  top: 50%;\n  margin-top: -11px;\n  pointer-events: none;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _utils = __webpack_require__(18);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Location = __webpack_require__(23);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PRODUCTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/products/";
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	var RANK_MIN = 1;
	var RANK_MAX = 10;
	var RANK_DEFAULT = 5;
	var NAME_MAX = 6;
	
	var FEATURES = [{ key: "pixels_rank", label: "Resolution" }, { key: "sensitivity_rank", label: "Sensitivity" }, { key: "power_rank", label: "Power" }, { key: "temp_range_rank", label: "Temperature" }];
	
	// ---------- styled components ----------
	
	var Page = _styledComponents2.default.div(_templateObject, FONT);
	
	var HeaderBlock = _styledComponents2.default.div(_templateObject2);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject3);
	
	var TitleRow = _styledComponents2.default.div(_templateObject4);
	
	var TitleIcon = _styledComponents2.default.div(_templateObject5);
	
	var Title = _styledComponents2.default.h1(_templateObject6);
	
	var Subtitle = _styledComponents2.default.p(_templateObject7);
	
	var CloseButton = _styledComponents2.default.button(_templateObject8);
	
	var FormCard = _styledComponents2.default.div(_templateObject9);
	
	var FieldLabel = _styledComponents2.default.div(_templateObject10);
	
	var TextInput = _styledComponents2.default.input(_templateObject11, function (p) {
	  return p.invalid ? "#DC2626" : "#E5E9F0";
	}, FONT, function (p) {
	  return p.invalid ? "#DC2626" : "#3A507B";
	}, function (p) {
	  return p.invalid ? "rgba(220, 38, 38, 0.12)" : "rgba(58, 80, 123, 0.12)";
	});
	
	var HelperText = _styledComponents2.default.div(_templateObject12);
	
	var FieldError = _styledComponents2.default.div(_templateObject13);
	
	var FeatureRow = _styledComponents2.default.div(_templateObject14);
	
	// Column header row — mirrors FeatureRow's grid so the "Quality Level"
	// label sits directly above the rank-badge column.
	var FeatureHeaderRow = _styledComponents2.default.div(_templateObject15);
	
	var FeatureColumnHeader = _styledComponents2.default.div(_templateObject16);
	
	var FeatureName = _styledComponents2.default.div(_templateObject17);
	
	var RankBadge = _styledComponents2.default.div(_templateObject18);
	
	var FooterRow = _styledComponents2.default.div(_templateObject19);
	
	var BtnSecondary = _styledComponents2.default.button(_templateObject20, FONT);
	
	var BtnPrimary = _styledComponents2.default.button(_templateObject21, FONT);
	
	// Custom div-based slider for product feature ranks (1-10). Mirrors the
	// slider used in the marketing pages but stepped to integers.
	var SliderRoot = _styledComponents2.default.div(_templateObject22, function (p) {
	  return p.disabled ? "not-allowed" : "pointer";
	}, function (p) {
	  return p.disabled ? 0.5 : 1;
	});
	
	var SliderTrack = _styledComponents2.default.div(_templateObject23);
	
	var SliderFill = _styledComponents2.default.div(_templateObject24);
	
	var SliderThumb = _styledComponents2.default.div(_templateObject25);
	
	var FeatureSlider = function (_Component) {
	  _inherits(FeatureSlider, _Component);
	
	  function FeatureSlider(props) {
	    _classCallCheck(this, FeatureSlider);
	
	    var _this = _possibleConstructorReturn(this, (FeatureSlider.__proto__ || Object.getPrototypeOf(FeatureSlider)).call(this, props));
	
	    _this.setRef = function (el) {
	      _this.rootEl = el;
	    };
	
	    _this.updateFromX = function (clientX) {
	      if (!_this.rootEl || _this.props.disabled) return;
	      var rect = _this.rootEl.getBoundingClientRect();
	      if (rect.width <= 0) return;
	      var _this$props = _this.props,
	          min = _this$props.min,
	          max = _this$props.max;
	
	      var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
	      var raw = min + (max - min) * ratio;
	      raw = Math.round(raw);
	      raw = Math.max(min, Math.min(max, raw));
	      if (_this.props.onChange) _this.props.onChange(raw);
	    };
	
	    _this.onMouseDown = function (e) {
	      if (_this.props.disabled) return;
	      e.preventDefault();
	      _this.setState({ dragging: true });
	      _this.attach();
	      _this.updateFromX(e.clientX);
	    };
	
	    _this.onTouchStart = function (e) {
	      if (_this.props.disabled || !e.touches || !e.touches.length) return;
	      _this.setState({ dragging: true });
	      _this.attach();
	      _this.updateFromX(e.touches[0].clientX);
	    };
	
	    _this.onWindowMove = function (e) {
	      if (!_this.state.dragging) return;
	      _this.updateFromX(e.clientX);
	    };
	
	    _this.onWindowTouchMove = function (e) {
	      if (!_this.state.dragging || !e.touches || !e.touches.length) return;
	      e.preventDefault();
	      _this.updateFromX(e.touches[0].clientX);
	    };
	
	    _this.onWindowUp = function () {
	      if (!_this.state.dragging) return;
	      _this.setState({ dragging: false });
	      _this.detach();
	    };
	
	    _this.state = { dragging: false };
	    return _this;
	  }
	
	  _createClass(FeatureSlider, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.detach();
	    }
	  }, {
	    key: "attach",
	    value: function attach() {
	      window.addEventListener("mousemove", this.onWindowMove);
	      window.addEventListener("mouseup", this.onWindowUp);
	      window.addEventListener("touchmove", this.onWindowTouchMove, { passive: false });
	      window.addEventListener("touchend", this.onWindowUp);
	    }
	  }, {
	    key: "detach",
	    value: function detach() {
	      window.removeEventListener("mousemove", this.onWindowMove);
	      window.removeEventListener("mouseup", this.onWindowUp);
	      window.removeEventListener("touchmove", this.onWindowTouchMove);
	      window.removeEventListener("touchend", this.onWindowUp);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          min = _props.min,
	          max = _props.max,
	          disabled = _props.disabled;
	
	      var range = max - min;
	      var pct = range > 0 ? Math.max(0, Math.min(100, (Number(value) - min) / range * 100)) : 0;
	      return _react2.default.createElement(
	        SliderRoot,
	        {
	          innerRef: this.setRef,
	          onMouseDown: this.onMouseDown,
	          onTouchStart: this.onTouchStart,
	          disabled: disabled
	        },
	        _react2.default.createElement(SliderTrack, null),
	        _react2.default.createElement(SliderFill, { style: { width: pct + "%" } }),
	        _react2.default.createElement(SliderThumb, { style: { left: pct + "%" } })
	      );
	    }
	  }]);
	
	  return FeatureSlider;
	}(_react.Component);
	
	// ---------- component ----------
	
	var AddProductPage = function (_PureComponent) {
	  _inherits(AddProductPage, _PureComponent);
	
	  function AddProductPage(props) {
	    _classCallCheck(this, AddProductPage);
	
	    // When `editingProduct` is supplied the popup runs in edit mode:
	    // name is locked, sliders seed from the existing product, and the
	    // submit handler issues a PATCH instead of a POST.
	    var _this2 = _possibleConstructorReturn(this, (AddProductPage.__proto__ || Object.getPrototypeOf(AddProductPage)).call(this, props));
	
	    _initialiseProps.call(_this2);
	
	    var editing = props.editingProduct;
	    _this2.state = {
	      name: editing ? editing.name || "" : "",
	      ranks: {
	        pixels_rank: editing ? Number(editing.pixels_rank) || RANK_DEFAULT : RANK_DEFAULT,
	        sensitivity_rank: editing ? Number(editing.sensitivity_rank) || RANK_DEFAULT : RANK_DEFAULT,
	        power_rank: editing ? Number(editing.power_rank) || RANK_DEFAULT : RANK_DEFAULT,
	        temp_range_rank: editing ? Number(editing.temp_range_rank) || RANK_DEFAULT : RANK_DEFAULT
	      },
	      isSaving: false,
	      errorMessage: null,
	      nameInvalid: false
	    };
	    _this2.eventemitter = _eventEmitter2.default.getInstance();
	    return _this2;
	  }
	
	  _createClass(AddProductPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._mounted = false;
	    }
	
	    // Validates the name against the existing product list (case-insensitive
	    // unique) and the 1-6 alphanumeric requirement before issuing a POST.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var onClose = this.props.onClose;
	      var _state = this.state,
	          name = _state.name,
	          ranks = _state.ranks,
	          isSaving = _state.isSaving,
	          errorMessage = _state.errorMessage,
	          nameInvalid = _state.nameInvalid;
	
	      var editing = this.isEditMode;
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        errorMessage && _react2.default.createElement(_error2.default, {
	          title: "Heads up",
	          message: errorMessage,
	          onHide: this.hideErrorMessage
	        }),
	        _react2.default.createElement(
	          Page,
	          null,
	          _react2.default.createElement(
	            HeaderBlock,
	            null,
	            _react2.default.createElement(
	              HeaderLeft,
	              null,
	              _react2.default.createElement(
	                TitleRow,
	                null,
	                _react2.default.createElement(
	                  TitleIcon,
	                  null,
	                  "\uD83E\uDDEC"
	                ),
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  editing ? 'Edit Product' : 'Add Product'
	                )
	              ),
	              _react2.default.createElement(
	                Subtitle,
	                null,
	                editing ? "Update the quality for each of " + name + "'s 4 features." : 'Name your product and set the quality for each of its 4 features.'
	              )
	            ),
	            _react2.default.createElement(
	              CloseButton,
	              { onClick: onClose, "aria-label": "Close" },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            FormCard,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FieldLabel,
	                null,
	                "Product Name"
	              ),
	              _react2.default.createElement(TextInput, {
	                type: "text",
	                value: name,
	                onChange: this.onChangeName,
	                placeholder: "e.g. Hello",
	                maxLength: NAME_MAX,
	                invalid: nameInvalid,
	                disabled: isSaving || editing,
	                readOnly: editing
	              }),
	              nameInvalid ? _react2.default.createElement(
	                FieldError,
	                null,
	                "Please enter a unique name (up to ",
	                NAME_MAX,
	                " letters or digits)."
	              ) : _react2.default.createElement(
	                HelperText,
	                null,
	                editing ? 'Product name cannot be changed once created.' : "Up to " + NAME_MAX + " letters or digits, no spaces or symbols."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FieldLabel,
	                null,
	                "Features"
	              ),
	              _react2.default.createElement(
	                FeatureHeaderRow,
	                null,
	                _react2.default.createElement("div", null),
	                _react2.default.createElement("div", null),
	                _react2.default.createElement(
	                  FeatureColumnHeader,
	                  null,
	                  "Quality Level"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: 'flex', flexDirection: 'column', gap: 14 } },
	                FEATURES.map(function (feature) {
	                  return _react2.default.createElement(
	                    FeatureRow,
	                    { key: feature.key },
	                    _react2.default.createElement(
	                      FeatureName,
	                      null,
	                      feature.label
	                    ),
	                    _react2.default.createElement(FeatureSlider, {
	                      min: RANK_MIN,
	                      max: RANK_MAX,
	                      value: ranks[feature.key],
	                      onChange: _this3.onChangeRank(feature.key),
	                      disabled: isSaving
	                    }),
	                    _react2.default.createElement(
	                      RankBadge,
	                      null,
	                      ranks[feature.key]
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                HelperText,
	                null,
	                "Each feature's quality can be set anywhere from ",
	                RANK_MIN,
	                " to ",
	                RANK_MAX,
	                ", with higher quality requiring more development time."
	              )
	            ),
	            _react2.default.createElement(
	              FooterRow,
	              null,
	              _react2.default.createElement(
	                BtnSecondary,
	                { onClick: onClose, disabled: isSaving },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                BtnPrimary,
	                { onClick: this.submit, disabled: isSaving },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  isSaving ? editing ? "Saving…" : "Creating…" : editing ? "Save Changes" : "Create Product"
	                ),
	                !isSaving && _react2.default.createElement(
	                  "span",
	                  null,
	                  "\u2192"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "isEditMode",
	    get: function get() {
	      return !!this.props.editingProduct;
	    }
	  }]);
	
	  return AddProductPage;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.goToCustomerAnalysis = function (e) {
	    e.preventDefault();
	    _this4.eventemitter.trigger("coaching-feedback-hide");
	    (0, _Location.changeLocation)("/ceo/analysis/market");
	  };
	
	  this.showPopupIsThereAMarket = function () {
	    _this4.eventemitter.trigger("coaching-feedback", ["Food for Thought", "Nice work! You've created a product, but is there a market?", "Essentially will a customer buy your product given its features", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "I like you so here's a hint"
	      ),
	      _react2.default.createElement("br", null),
	      "Understand the customer needs/wants first (i.e. review ",
	      _react2.default.createElement(
	        "a",
	        { href: "/ceo/analysis/market", onClick: _this4.goToCustomerAnalysis },
	        "customer analysis"
	      ),
	      ")...you're welcome!"
	    )]);
	  };
	
	  this.showPopupNotReleasedThisYear = function () {
	    _this4.eventemitter.trigger("coaching-feedback", ["Food for Thought", "Heads up! Your product won't be released this year given your product features ranking (i.e. its higher quality).", "The higher the design quality, the longer it takes for your product to be released to the market.", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Here's the real dilemma, as with most Product Managers (PMs):"
	      ),
	      _react2.default.createElement("br", null),
	      "Do you build a higher quality product now and forgo potential revenues this year or create a lower quality product now and upgrade features as you go?"
	    )]);
	  };
	
	  this.onChangeName = function (e) {
	    // Match the existing add-product modal's filter: alphanumeric only,
	    // max 6 chars. Keeps the new flow API-compatible with the legacy
	    // create endpoint.
	    var cleaned = (e.target.value || "").replace(/[^a-zA-Z0-9]/g, "").slice(0, NAME_MAX);
	    _this4.setState({ name: cleaned, nameInvalid: false });
	  };
	
	  this.onChangeRank = function (key) {
	    return function (value) {
	      _this4.setState({
	        ranks: Object.assign({}, _this4.state.ranks, _defineProperty({}, key, value))
	      });
	    };
	  };
	
	  this.hideErrorMessage = function () {
	    _this4.setState({ errorMessage: null });
	  };
	
	  this.validateName = function () {
	    var name = _this4.state.name;
	
	    if (!name || name.length === 0) {
	      return "Product name is required.";
	    }
	    if (name.length > NAME_MAX) {
	      return "Product name must be " + NAME_MAX + " characters or fewer.";
	    }
	    var existingNames = Object.keys(_this4.props.existingProducts || {}).map(function (uid) {
	      var productRounds = Object.values(_this4.props.existingProducts[uid]);
	      return productRounds.length > 0 ? productRounds[0].name : null;
	    }).filter(Boolean).map(function (n) {
	      return n.toLowerCase();
	    });
	    if (existingNames.includes(name.toLowerCase())) {
	      return "A product with that name already exists.";
	    }
	    return null;
	  };
	
	  this.submit = function () {
	    var _state2 = _this4.state,
	        name = _state2.name,
	        ranks = _state2.ranks;
	    var editingProduct = _this4.props.editingProduct;
	
	    var editing = _this4.isEditMode;
	
	    // Skip uniqueness/validation in edit mode — name is locked.
	    if (!editing) {
	      var nameError = _this4.validateName();
	      if (nameError) {
	        _this4.setState({ errorMessage: nameError, nameInvalid: true });
	        return;
	      }
	    }
	
	    _this4.setState({ isSaving: true });
	
	    // Capture BEFORE the POST: is this Round 1 AND the team's first
	    // ever product? Used to fire the "Nice work on creating your first
	    // product!" coaching popup once, on the very first successful save.
	    var wasFirstProductRd1 = !editing && Number(_this4.props.currentRound) === 1 && Object.keys(_this4.props.existingProducts || {}).length === 0;
	
	    var payload = {
	      pixels_rank: ranks.pixels_rank,
	      sensitivity_rank: ranks.sensitivity_rank,
	      power_rank: ranks.power_rank,
	      temp_range_rank: ranks.temp_range_rank
	    };
	    if (!editing) payload.name = name;
	
	    var request = editing ? (0, _ApiService.patchRequest)("" + PRODUCTS_URL + editingProduct.id + "/").send(payload) : (0, _ApiService.postRequest)(PRODUCTS_URL).send(payload);
	
	    request.then(function (res) {
	      // Coaching popups (ported from ModalPDDecisionsAddProduct /
	      // ModalPDUpdateProduct): the backend flags an aggressive quality
	      // build via months_available_to_produce === 0 and a features
	      // profile that likely misses the market via
	      // minimum_requirement_feedback === 1.
	      var body = res && res.body || {};
	      var minimumRequirementFeedback = Number(body.minimum_requirement_feedback);
	      var monthsAvailableToProduce = Number(body.months_available_to_produce);
	      if (minimumRequirementFeedback === 1) {
	        _this4.showPopupIsThereAMarket();
	      } else if (monthsAvailableToProduce === 0) {
	        _this4.showPopupNotReleasedThisYear();
	      }
	
	      (0, _SubmitDecisions.incrementUnacceptedDecisions)("development");
	      if (_this4.props.reloadProducts) _this4.props.reloadProducts();
	      if (_this4.props.showSuccessMessage) {
	        _this4.props.showSuccessMessage(editing ? "Product \"" + name + "\" was successfully updated." : "Product \"" + name + "\" was successfully created.");
	      }
	      if (_this4._mounted) {
	        _this4.setState({ isSaving: false });
	      }
	      if (_this4.props.onClose) _this4.props.onClose();
	      if (wasFirstProductRd1 && _this4.props.onFirstProductCreated) {
	        _this4.props.onFirstProductCreated();
	      }
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "AddProductPage", "submit");
	      if (_this4._mounted) {
	        _this4.setState({
	          isSaving: false,
	          errorMessage: editing ? "Something went wrong saving these changes. Please try again." : "Something went wrong creating your product. Please try again."
	        });
	      }
	    });
	  };
	};
	
	exports.default = AddProductPage;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _barsEmojiStronglyDisagree = __webpack_require__(684);
	
	var _barsEmojiStronglyDisagree2 = _interopRequireDefault(_barsEmojiStronglyDisagree);
	
	var _barsEmojiNeutral = __webpack_require__(682);
	
	var _barsEmojiNeutral2 = _interopRequireDefault(_barsEmojiNeutral);
	
	var _barsEmojiStronglyAgree = __webpack_require__(683);
	
	var _barsEmojiStronglyAgree2 = _interopRequireDefault(_barsEmojiStronglyAgree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rating = Array.from({ length: 5 }, function (_, i) {
	  return i + 1;
	});
	
	var Bars = function (_Component) {
	  _inherits(Bars, _Component);
	
	  function Bars(props) {
	    _classCallCheck(this, Bars);
	
	    var _this = _possibleConstructorReturn(this, (Bars.__proto__ || Object.getPrototypeOf(Bars)).call(this, props));
	
	    _this.handleSingleSelect = function (value) {
	      var selectedValues = _this.state.selectedValues;
	      var _this$props = _this.props,
	          feedback = _this$props.feedback,
	          readonlyMode = _this$props.readonlyMode;
	
	
	      if (readonlyMode) {
	        return;
	      }
	
	      if (selectedValues !== value) {
	        _this.setState(function () {
	          return { selectedValues: value };
	        }, function () {
	          var _this$props2 = _this.props,
	              onChange = _this$props2.onChange,
	              id = _this$props2.id;
	
	
	          var hasError = !rating.includes(value);
	
	          if (onChange) onChange({
	            id: id,
	            value: value,
	            type: 'bars',
	            hasError: hasError,
	            feedback: feedback
	          });
	        });
	      }
	    };
	
	    _this.handleMultiSelect = function (teammate, value) {
	      var selectedValues = _this.state.selectedValues;
	      var _this$props3 = _this.props,
	          feedbacks = _this$props3.feedbacks,
	          readonlyMode = _this$props3.readonlyMode;
	
	
	      if (readonlyMode) {
	        return;
	      }
	
	      var feedback = feedbacks[teammate.id];
	      if (!feedback) {
	        return;
	      }
	
	      var newValues = [].concat(_toConsumableArray(selectedValues));
	      var answerIndex = newValues.findIndex(function (i) {
	        return i.feedback === feedback.id;
	      });
	      var stateChanged = false;
	      if (answerIndex === -1) {
	        newValues.push({
	          feedback: feedback.id,
	          value: value
	        });
	        stateChanged = true;
	      } else if (answerIndex >= 0 && newValues[answerIndex].value !== value) {
	        newValues[answerIndex].value = value;
	        stateChanged = true;
	      }
	
	      if (stateChanged) {
	        _this.setState({
	          selectedValues: newValues
	        }, function () {
	          var _this$props4 = _this.props,
	              onChange = _this$props4.onChange,
	              id = _this$props4.id;
	
	
	          if (onChange) {
	            onChange({
	              id: id,
	              value: value,
	              type: "bars",
	              hasError: false,
	              feedback: feedback.id
	            });
	          }
	        });
	      }
	    };
	
	    _this.isMultiRatingSelected = function (teammate, value) {
	      var selectedValues = _this.state.selectedValues;
	      var feedbacks = _this.props.feedbacks;
	
	
	      var feedback = feedbacks[teammate.id];
	      if (!feedback) {
	        return false;
	      }
	
	      var answer = selectedValues.find(function (i) {
	        return i.feedback === feedback.id;
	      });
	      if (!answer) {
	        return false;
	      }
	
	      return answer.value === value;
	    };
	
	    _this.state = {
	      selectedValues: props.values
	    };
	    return _this;
	  }
	
	  _createClass(Bars, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          id = _props.id,
	          values = _props.values;
	
	
	      if (prevProps.id !== id) {
	        this.setState(function () {
	          return { selectedValues: values };
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          title = _props2.title,
	          options = _props2.options,
	          teamList = _props2.teamList,
	          category = _props2.category,
	          readonlyMode = _props2.readonlyMode;
	      var selectedValues = this.state.selectedValues;
	
	
	      var rateTitle = category === 'self_assessment' ? 'Rate your behavior' : 'Rate your teammate’s behavior';
	
	      return _react2.default.createElement(
	        "div",
	        { className: "bars-question-block" },
	        _react2.default.createElement(
	          "div",
	          { className: "title" },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "bars-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "bars-left-part" },
	            options.map(function (item, index) {
	              var text = item.text;
	              text = text.replace(/[^\r\n]+/g, '<li>$&</li>');
	              return _react2.default.createElement(
	                "div",
	                { className: "bar-option", key: index },
	                _react2.default.createElement(
	                  "div",
	                  { className: "bar-header" },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    item.list_order
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    item.list_order === 1 && _react2.default.createElement("img", {
	                      alt: "Strongly Disagree",
	                      src: _barsEmojiStronglyDisagree2.default
	                    }),
	                    item.list_order === 3 && _react2.default.createElement("img", {
	                      alt: "Neutral",
	                      src: _barsEmojiNeutral2.default
	                    }),
	                    item.list_order === 5 && _react2.default.createElement("img", {
	                      alt: "Strongly Agree",
	                      src: _barsEmojiStronglyAgree2.default
	                    })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "bar-content", dangerouslySetInnerHTML: { __html: text } })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "bars-right-part" },
	            _react2.default.createElement(
	              "h4",
	              null,
	              rateTitle
	            ),
	            _react2.default.createElement(
	              "h5",
	              null,
	              "* A rating of 3 or higher = 100%"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "bars-teammates" },
	              category === 'self_assessment' && _react2.default.createElement(
	                "div",
	                { className: "bar-teammate" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "bar-teammate-rating" },
	                  rating.map(function (ratingItem) {
	                    var itemClass = ratingItem === selectedValues ? 'selected' : '';
	                    itemClass += readonlyMode ? ' inactive' : '';
	                    return _react2.default.createElement(
	                      "span",
	                      {
	                        key: ratingItem,
	                        onClick: function onClick() {
	                          return _this2.handleSingleSelect(ratingItem);
	                        },
	                        className: itemClass
	                      },
	                      ratingItem
	                    );
	                  })
	                )
	              ),
	              category === 'collaboration' && _react2.default.createElement(
	                "div",
	                null,
	                teamList.map(function (teammateItem, teammateIndex) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: teammateIndex, className: "bar-teammate" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "bar-teammate-name" },
	                      teammateItem.fullname
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "bar-teammate-rating" },
	                      rating.map(function (ratingItem) {
	                        var itemClass = _this2.isMultiRatingSelected(teammateItem, ratingItem) ? 'selected' : '';
	                        itemClass += readonlyMode ? ' inactive' : '';
	                        return _react2.default.createElement(
	                          "span",
	                          {
	                            key: ratingItem,
	                            onClick: function onClick() {
	                              return _this2.handleMultiSelect(teammateItem, ratingItem);
	                            },
	                            className: itemClass
	                          },
	                          ratingItem
	                        );
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Bars;
	}(_react.Component);
	
	exports.default = Bars;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LikeWishResults = function (_Component) {
	  _inherits(LikeWishResults, _Component);
	
	  function LikeWishResults() {
	    _classCallCheck(this, LikeWishResults);
	
	    return _possibleConstructorReturn(this, (LikeWishResults.__proto__ || Object.getPrototypeOf(LikeWishResults)).apply(this, arguments));
	  }
	
	  _createClass(LikeWishResults, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          items = _props.items,
	          header = _props.header;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "peer-evaluation-like-wish-results" },
	        title && _react2.default.createElement("h5", {
	          className: "title",
	          dangerouslySetInnerHTML: { __html: title } }),
	        header,
	        _react2.default.createElement(
	          "div",
	          { className: "like-wish-items" },
	          items.map(function (item, index) {
	            return _react2.default.createElement(
	              "div",
	              { key: index, className: item.name ? 'like-wish-item' : 'like-wish-item-feedback' },
	              item.name && _react2.default.createElement(
	                "div",
	                { className: "like-wish-item-name-block" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  item.name
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: item.name ? 'like-wish-item-text-block' : '' },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  item.text
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return LikeWishResults;
	}(_react.Component);
	
	LikeWishResults.defaultProps = {
	  title: "",
	  items: []
	};
	
	LikeWishResults.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  items: _propTypes2.default.array
	};
	
	exports.default = LikeWishResults;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emojiStronglyDisagree = __webpack_require__(457);
	
	var _emojiStronglyDisagree2 = _interopRequireDefault(_emojiStronglyDisagree);
	
	var _emojiDisagree = __webpack_require__(454);
	
	var _emojiDisagree2 = _interopRequireDefault(_emojiDisagree);
	
	var _emojiNeutral = __webpack_require__(455);
	
	var _emojiNeutral2 = _interopRequireDefault(_emojiNeutral);
	
	var _emojiAgree = __webpack_require__(453);
	
	var _emojiAgree2 = _interopRequireDefault(_emojiAgree);
	
	var _emojiStronglyAgree = __webpack_require__(456);
	
	var _emojiStronglyAgree2 = _interopRequireDefault(_emojiStronglyAgree);
	
	var _peer_image = __webpack_require__(2648);
	
	var _peer_image2 = _interopRequireDefault(_peer_image);
	
	var _peer_image3 = __webpack_require__(2649);
	
	var _peer_image4 = _interopRequireDefault(_peer_image3);
	
	var _peer_image5 = __webpack_require__(2650);
	
	var _peer_image6 = _interopRequireDefault(_peer_image5);
	
	var _peer_image7 = __webpack_require__(2651);
	
	var _peer_image8 = _interopRequireDefault(_peer_image7);
	
	var _peer_image9 = __webpack_require__(2652);
	
	var _peer_image10 = _interopRequireDefault(_peer_image9);
	
	var _peer_image11 = __webpack_require__(2653);
	
	var _peer_image12 = _interopRequireDefault(_peer_image11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scale = {
	  "Strongly Disagree": 1,
	  Disagree: 2,
	  Neutral: 3,
	  Agree: 4,
	  "Strongly Agree": 5
	};
	
	var LikertScaleTable = function (_Component) {
	  _inherits(LikertScaleTable, _Component);
	
	  function LikertScaleTable(props) {
	    _classCallCheck(this, LikertScaleTable);
	
	    var _this = _possibleConstructorReturn(this, (LikertScaleTable.__proto__ || Object.getPrototypeOf(LikertScaleTable)).call(this, props));
	
	    _this.getEmoji = function (key) {
	      switch (key) {
	        case "Strongly Disagree":
	          {
	            return _emojiStronglyDisagree2.default;
	          }
	        case "Disagree":
	          {
	            return _emojiDisagree2.default;
	          }
	        case "Neutral":
	          {
	            return _emojiNeutral2.default;
	          }
	        case "Agree":
	          {
	            return _emojiAgree2.default;
	          }
	        case "Strongly Agree":
	          {
	            return _emojiStronglyAgree2.default;
	          }
	        default:
	          break;
	      }
	    };
	
	    _this.handleOnSelect = function (teammate, emoji) {
	      var selectedValues = _this.state.selectedValues;
	      var _this$props = _this.props,
	          feedbacks = _this$props.feedbacks,
	          readonlyMode = _this$props.readonlyMode;
	
	
	      if (readonlyMode) {
	        return;
	      }
	
	      var feedback = feedbacks[teammate.id];
	      if (!feedback) {
	        return;
	      }
	
	      var newValues = [].concat(_toConsumableArray(selectedValues));
	      var answerIndex = newValues.findIndex(function (i) {
	        return i.feedback === feedback.id;
	      });
	      var stateChanged = false;
	      if (answerIndex === -1) {
	        newValues.push({
	          feedback: feedback.id,
	          value: Scale[emoji]
	        });
	        stateChanged = true;
	      } else if (answerIndex >= 0 && newValues[answerIndex].value !== Scale[emoji]) {
	        newValues[answerIndex].value = Scale[emoji];
	        stateChanged = true;
	      }
	
	      if (stateChanged) {
	        _this.setState({
	          selectedValues: newValues
	        }, function () {
	          var _this$props2 = _this.props,
	              onChange = _this$props2.onChange,
	              id = _this$props2.id;
	
	
	          if (onChange) {
	            onChange({
	              id: id,
	              value: Scale[emoji],
	              type: "likert",
	              hasError: false,
	              feedback: feedback.id
	            });
	          }
	        });
	      }
	    };
	
	    _this.isEmojiSelected = function (teammate, emoji) {
	      var selectedValues = _this.state.selectedValues;
	      var feedbacks = _this.props.feedbacks;
	
	
	      var feedback = feedbacks[teammate.id];
	      if (!feedback) {
	        return false;
	      }
	
	      var answer = selectedValues.find(function (i) {
	        return i.feedback === feedback.id;
	      });
	      if (!answer) {
	        return false;
	      }
	
	      return answer.value === Scale[emoji];
	    };
	
	    _this.renderTitle = function (title) {
	      switch (title) {
	        case "<contributingtoteamwork>":
	          return _react2.default.createElement("img", { src: _peer_image2.default, alt: "contributingtoteamwork" });
	        case "<interactingwithteammates>":
	          return _react2.default.createElement("img", { src: _peer_image4.default, alt: "interactingwithteammates" });
	        case "<keepteamontrack>":
	          return _react2.default.createElement("img", { src: _peer_image6.default, alt: "keepteamontrack" });
	        case "<expectingquality>":
	          return _react2.default.createElement("img", { src: _peer_image8.default, alt: "expectingquality" });
	        case "<knowledgeskillsabilities>":
	          return _react2.default.createElement("img", { src: _peer_image10.default, alt: "knowledgeskillsabilities" });
	        case "<conflictmanagement>":
	          return _react2.default.createElement("img", { src: _peer_image12.default, alt: "conflictmanagement" });
	        default:
	          return title;
	      }
	    };
	
	    _this.state = {
	      selectedValues: props.values
	    };
	    return _this;
	  }
	
	  _createClass(LikertScaleTable, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          id = _props.id,
	          values = _props.values;
	
	
	      if (prevProps.id !== id) {
	        this.setState(function () {
	          return { selectedValues: values };
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          title = _props2.title,
	          teamList = _props2.teamList,
	          readonlyMode = _props2.readonlyMode;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "likertScaleTable" },
	        _react2.default.createElement(
	          "div",
	          { className: "title" },
	          this.renderTitle(title)
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "likertScaleTableWrapper" },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                { className: "likertScaleTableHeader" },
	                _react2.default.createElement("th", null),
	                Object.keys(Scale).map(function (item, index) {
	                  return _react2.default.createElement(
	                    "th",
	                    {
	                      key: "likert-scale-table-column-" + index,
	                      className: "likertScaleTableEmojiColumn"
	                    },
	                    item
	                  );
	                }),
	                _react2.default.createElement("th", { className: "likertScaleTableEmptyColumn" })
	              ),
	              teamList.map(function (teammate, teammateIndex) {
	                return _react2.default.createElement(
	                  "tr",
	                  { key: "likert-scale-table-row-" + teammateIndex, className: (0, _classnames2.default)({
	                      likertScaleTableGrayRow: teammateIndex % 2 === 0
	                    }) },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "likertScaleTableUserName" },
	                    teammate.fullname
	                  ),
	                  Object.keys(Scale).map(function (item, index) {
	                    return _react2.default.createElement(
	                      "td",
	                      {
	                        key: "likert-scale-table-emoji-" + teammateIndex + "-" + index,
	                        className: "likertScaleTableEmojiColumn"
	                      },
	                      _react2.default.createElement("img", {
	                        alt: "emoji",
	                        className: (0, _classnames2.default)("likertScaleTableEmoji", {
	                          likertScaleTableEmoji_selected: _this2.isEmojiSelected(teammate, item),
	                          likertScaleTableEmoji_nofocus: readonlyMode
	                        }),
	                        src: _this2.getEmoji(item),
	                        onClick: function onClick() {
	                          return _this2.handleOnSelect(teammate, item);
	                        }
	                      })
	                    );
	                  }),
	                  _react2.default.createElement("td", { className: "likertScaleTableEmptyColumn" })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LikertScaleTable;
	}(_react.Component);
	
	LikertScaleTable.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    feedback: _propTypes2.default.number,
	    value: _propTypes2.default.number
	  })),
	  onChange: _propTypes2.default.func,
	  teamList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    fullname: _propTypes2.default.string
	  })),
	  readonlyMode: _propTypes2.default.bool
	};
	
	exports.default = LikertScaleTable;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emojiStronglyDisagree = __webpack_require__(457);
	
	var _emojiStronglyDisagree2 = _interopRequireDefault(_emojiStronglyDisagree);
	
	var _emojiDisagree = __webpack_require__(454);
	
	var _emojiDisagree2 = _interopRequireDefault(_emojiDisagree);
	
	var _emojiNeutral = __webpack_require__(455);
	
	var _emojiNeutral2 = _interopRequireDefault(_emojiNeutral);
	
	var _emojiAgree = __webpack_require__(453);
	
	var _emojiAgree2 = _interopRequireDefault(_emojiAgree);
	
	var _emojiStronglyAgree = __webpack_require__(456);
	
	var _emojiStronglyAgree2 = _interopRequireDefault(_emojiStronglyAgree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scale = {
	  "Strongly Disagree": 1,
	  Disagree: 2,
	  Neutral: 3,
	  Agree: 4,
	  "Strongly Agree": 5
	};
	
	var LikertScale = function (_Component) {
	  _inherits(LikertScale, _Component);
	
	  function LikertScale(props) {
	    _classCallCheck(this, LikertScale);
	
	    var _this = _possibleConstructorReturn(this, (LikertScale.__proto__ || Object.getPrototypeOf(LikertScale)).call(this, props));
	
	    _this.getEmoji = function (key) {
	      switch (key) {
	        case "Strongly Disagree":
	          {
	            return _emojiStronglyDisagree2.default;
	          }
	        case "Disagree":
	          {
	            return _emojiDisagree2.default;
	          }
	        case "Neutral":
	          {
	            return _emojiNeutral2.default;
	          }
	        case "Agree":
	          {
	            return _emojiAgree2.default;
	          }
	        case "Strongly Agree":
	          {
	            return _emojiStronglyAgree2.default;
	          }
	        default:
	          break;
	      }
	    };
	
	    _this.handleOnSelect = function (value) {
	      var selectedValue = _this.state.selectedValue;
	      var _this$props = _this.props,
	          feedback = _this$props.feedback,
	          readonlyMode = _this$props.readonlyMode;
	
	
	      if (readonlyMode) {
	        return;
	      }
	
	      if (selectedValue !== value) {
	        _this.setState(function () {
	          return { selectedValue: value };
	        }, function () {
	          var _this$props2 = _this.props,
	              onChange = _this$props2.onChange,
	              id = _this$props2.id;
	
	
	          var hasError = !Object.keys(Scale).find(function (key) {
	            return Scale[key] === value;
	          });
	
	          if (onChange) onChange({
	            id: id,
	            value: value,
	            type: "likert",
	            hasError: hasError,
	            feedback: feedback
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      selectedValue: props.value
	    };
	    return _this;
	  }
	
	  _createClass(LikertScale, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          id = _props.id,
	          value = _props.value;
	
	
	      if (prevProps.id !== id) {
	        this.setState(function () {
	          return { selectedValue: value };
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var selectedValue = this.state.selectedValue;
	      var _props2 = this.props,
	          title = _props2.title,
	          readonlyMode = _props2.readonlyMode;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "likertScale" },
	        _react2.default.createElement(
	          "div",
	          { className: "title" },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "likertList" },
	          Object.keys(Scale).map(function (item, index) {
	            return _react2.default.createElement(
	              "div",
	              {
	                key: "likert-skale-" + index,
	                className: (0, _classnames2.default)("likertContainer", {
	                  likertContainer_selected: Scale[item] === selectedValue,
	                  likertContainer_nofocus: readonlyMode
	                }),
	                onClick: function onClick() {
	                  return _this2.handleOnSelect(Scale[item]);
	                }
	              },
	              _react2.default.createElement("img", {
	                alt: "emoji",
	                className: "likertEmoji",
	                src: _this2.getEmoji(item)
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "likertTitle" },
	                item
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return LikertScale;
	}(_react.Component);
	
	LikertScale.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  value: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  feedback: _propTypes2.default.number,
	  readonlyMode: _propTypes2.default.bool
	};
	
	exports.default = LikertScale;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiSelect = function (_Component) {
	  _inherits(MultiSelect, _Component);
	
	  function MultiSelect(props) {
	    _classCallCheck(this, MultiSelect);
	
	    var _this = _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var values = props.value.split(', ').filter(function (i) {
	      return !!i && i !== '';
	    });
	
	    _this.state = {
	      selectedValues: values && values.length > 0 ? values.map(function (value) {
	        return Number(value) > 0 ? Number(value) : value;
	      }) : []
	    };
	    return _this;
	  }
	
	  _createClass(MultiSelect, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          id = _props.id,
	          value = _props.value;
	
	
	      if (prevProps.id !== id) {
	        var values = value.split(', ').filter(function (i) {
	          return !!i && i !== '';
	        });
	        this.setState({
	          selectedValues: values && values.length > 0 ? values.map(function (value) {
	            return Number(value) > 0 ? Number(value) : value;
	          }) : []
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          title = _props2.title,
	          statements = _props2.statements,
	          readonlyMode = _props2.readonlyMode;
	      var selectedValues = this.state.selectedValues;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "MultiSelectWrapper" },
	        title && _react2.default.createElement("h5", {
	          className: "title",
	          dangerouslySetInnerHTML: { __html: title } }),
	        _react2.default.createElement(
	          "div",
	          { className: "MultiSelectOptions" },
	          statements.map(function (_ref, index) {
	            var id = _ref.id,
	                text = _ref.text;
	            return _react2.default.createElement(
	              "button",
	              {
	                key: "multi-select-option-" + index,
	                className: (0, _classnames2.default)("MultiSelectOption", {
	                  MultiSelectOption_selected: text === 'Not Applicable' ? selectedValues.includes(text) : selectedValues.includes(id),
	                  MultiSelectOption_nofocus: readonlyMode
	                }),
	                onClick: function onClick() {
	                  return text === 'Not Applicable' ? _this2.selectOption(text) : _this2.selectOption(id);
	                }
	              },
	              text
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return MultiSelect;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.selectOption = function (statementValue) {
	    var selectedValues = _this3.state.selectedValues;
	    var _props3 = _this3.props,
	        id = _props3.id,
	        onChange = _props3.onChange,
	        feedback = _props3.feedback,
	        readonlyMode = _props3.readonlyMode;
	
	
	    if (readonlyMode) {
	      return;
	    }
	
	    var index = selectedValues.findIndex(function (i) {
	      return i === statementValue;
	    });
	    var values = [];
	    if (selectedValues.length >= 3 && !selectedValues.includes(statementValue)) {
	      return;
	    } else {
	      if (index >= 0) {
	        values = selectedValues.filter(function (i) {
	          return i !== statementValue;
	        });
	      } else {
	        if (statementValue !== 'Not Applicable' && selectedValues.includes('Not Applicable')) {
	          return;
	        }
	
	        if (statementValue === 'Not Applicable' && selectedValues.length > 0) {
	          return;
	        }
	
	        values = [].concat(_toConsumableArray(selectedValues), [statementValue]);
	      }
	    }
	
	    if (!values.includes('Not Applicable')) {
	      values.sort(function (a, b) {
	        return a - b;
	      });
	    }
	
	    if (onChange) {
	      onChange({
	        id: id,
	        value: values.join(', '),
	        type: 'text',
	        hasError: false,
	        feedback: feedback
	      });
	    }
	
	    _this3.setState({
	      selectedValues: values
	    });
	  };
	};
	
	MultiSelect.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  feedback: _propTypes2.default.number,
	  statements: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	
	exports.default = MultiSelect;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconArrowRight = __webpack_require__(1844);
	
	var _iconArrowRight2 = _interopRequireDefault(_iconArrowRight);
	
	var _peer_rating_intro = __webpack_require__(1860);
	
	var _peer_rating_intro2 = _interopRequireDefault(_peer_rating_intro);
	
	var _self_assessment_intro = __webpack_require__(1861);
	
	var _self_assessment_intro2 = _interopRequireDefault(_self_assessment_intro);
	
	var _skills_assessment_intro = __webpack_require__(1862);
	
	var _skills_assessment_intro2 = _interopRequireDefault(_skills_assessment_intro);
	
	var _finalPage = __webpack_require__(1843);
	
	var _finalPage2 = _interopRequireDefault(_finalPage);
	
	var _textArea = __webpack_require__(1257);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _likertScale = __webpack_require__(1251);
	
	var _likertScale2 = _interopRequireDefault(_likertScale);
	
	var _teamList = __webpack_require__(1255);
	
	var _teamList2 = _interopRequireDefault(_teamList);
	
	var _likertScaleTable = __webpack_require__(1250);
	
	var _likertScaleTable2 = _interopRequireDefault(_likertScaleTable);
	
	var _teamTable = __webpack_require__(1256);
	
	var _teamTable2 = _interopRequireDefault(_teamTable);
	
	var _multiSelect = __webpack_require__(1252);
	
	var _multiSelect2 = _interopRequireDefault(_multiSelect);
	
	var _likeWishResults = __webpack_require__(1249);
	
	var _likeWishResults2 = _interopRequireDefault(_likeWishResults);
	
	var _bars = __webpack_require__(1248);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var selfAssessmentIntroText = _react2.default.createElement(
	  "p",
	  null,
	  "Answer a few questions to let the instructor know how you feel in the game so far."
	);
	
	var peerRatingIntroText = _react2.default.createElement(
	  "p",
	  null,
	  "Answer a few questions to evaluate how your teammates are collaborating. Your answers are ",
	  _react2.default.createElement(
	    "span",
	    null,
	    "anonymous"
	  ),
	  "."
	);
	
	var peerRatingFeedbackIntroText = _react2.default.createElement(
	  "p",
	  null,
	  "Here's how your teammates rated your collaboration skills."
	);
	
	var skillsAssessmentText = _react2.default.createElement(
	  "p",
	  null,
	  "This section ",
	  _react2.default.createElement(
	    "span",
	    null,
	    "does not impact your teammates grade"
	  ),
	  ". The main purpose is to let your teammates know what they are doing well. This helps them to be aware of the team skills that they are demonstrating as well as focus on areas to improve."
	);
	
	var FinalReflectionsText = _react2.default.createElement(
	  "p",
	  null,
	  "This section ",
	  _react2.default.createElement(
	    "span",
	    null,
	    "does not impact your teammates grade"
	  ),
	  " and your ",
	  _react2.default.createElement(
	    "span",
	    null,
	    "feedback is only visible to your instructor"
	  ),
	  ". The main purpose is to let your instructor know the level of collaboration within your team. This helps your instructors improve the overall learning experience."
	);
	
	var finalPageText = function finalPageText(adjustedScore) {
	  var text = adjustedScore === 1 ? 'You\'ve earned 100% of your feedback submission score. Please encourage your teammates to submit by the deadline or they\'ll lose points.' : "You've earned " + adjustedScore * 100 + "% of your feedback submission score since you've submitted it by the deadline.";
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      "Congratulation on completing your peer evaluation!"
	    ),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      "p",
	      null,
	      text
	    )
	  );
	};
	
	var iLikeTitle = _react2.default.createElement(
	  "h5",
	  { className: "title" },
	  "Here's what ",
	  _react2.default.createElement(
	    "span",
	    null,
	    "Sophie"
	  ),
	  " did well."
	);
	
	var iWishTitle = _react2.default.createElement(
	  "h5",
	  { className: "title" },
	  "Here's what ",
	  _react2.default.createElement(
	    "span",
	    null,
	    "Sophie"
	  ),
	  " can improve."
	);
	
	var transitionPageText = function transitionPageText(username) {
	  return _react2.default.createElement(
	    "p",
	    { style: { textAlign: 'center' } },
	    username
	  );
	};
	
	var GenerateIntroScreen = function GenerateIntroScreen(props) {
	  var title = props.title,
	      imgSrc = props.imgSrc,
	      text = props.text,
	      tagText = props.tagText,
	      background = props.background,
	      _props$backgroundBloc = props.backgroundBlockWidth,
	      backgroundBlockWidth = _props$backgroundBloc === undefined ? '780' : _props$backgroundBloc,
	      _props$showTeamCircle = props.showTeamCircle,
	      showTeamCircle = _props$showTeamCircle === undefined ? false : _props$showTeamCircle,
	      teamCircleBackground = props.teamCircleBackground;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "feedbackIntroScreen" },
	    _react2.default.createElement(
	      "div",
	      {
	        className: (0, _classnames2.default)({
	          backgroundImage: !!background
	        }),
	        style: {
	          backgroundColor: background,
	          width: backgroundBlockWidth,
	          display: 'flex',
	          alignItems: 'center',
	          justifyContent: 'center'
	        } },
	      imgSrc && _react2.default.createElement("img", { alt: "Intro img", src: imgSrc }),
	      showTeamCircle && _react2.default.createElement("div", { style: { borderRadius: '50%', width: 140, height: 140, backgroundColor: teamCircleBackground } })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "introScreenInfo" },
	      title && _react2.default.createElement(
	        "div",
	        { className: "introScreenInfo__title" },
	        _react2.default.createElement("img", { alt: "right arrow", src: _iconArrowRight2.default }),
	        title,
	        tagText && _react2.default.createElement(
	          "div",
	          { className: "tag" },
	          tagText
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("introScreenInfo__text", {
	            "introScreenInfo__notitle": !title
	          }) },
	        text
	      )
	    )
	  );
	};
	
	var statementsColors = ['#52c5cd', '#00b0ff', '#f7d48f', '#bfa4fc', '#f27676', '#78cc7b', '#f2b682', '#81d9f1', '#81efe8', '#ebed80'];
	var prepareStatements = function prepareStatements(statements) {
	  return _react2.default.createElement(
	    "div",
	    { className: "coloredText" },
	    statements.map(function (statement, index) {
	      return _react2.default.createElement(
	        "span",
	        { key: index, style: { color: statementsColors[index % statementsColors.length] } },
	        statement,
	        index === statements.length - 1 ? '.' : ';',
	        " "
	      );
	    })
	  );
	};
	
	var parseFeedback = function parseFeedback(props) {
	  var question = props.question,
	      answers = props.answers,
	      self_assessment_count = props.self_assessment_count,
	      peer_rating_count = props.peer_rating_count,
	      showError = props.showError,
	      onChange = props.onChange,
	      teamList = props.teamList,
	      currentUserId = props.currentUserId,
	      feedbacks = props.feedbacks,
	      previousAnswers = props.previousAnswers,
	      readonlyMode = props.readonlyMode,
	      adjustedScore = props.adjustedScore;
	
	
	  var teamColorCircle = _Teams2.default.currentTeamColor();
	  var teamColorBackground = _Teams2.default.currentTeamColorLevel1();
	
	  switch (question.answer_type) {
	    case "self_assessment_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Self Assessment",
	        imgSrc: _self_assessment_intro2.default,
	        text: selfAssessmentIntroText,
	        tagText: self_assessment_count + " questions"
	      });
	    case "self_assessment_results_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Self Assessment",
	        imgSrc: _self_assessment_intro2.default,
	        text: "",
	        tagText: self_assessment_count + " questions"
	      });
	    case "peer_rating_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Peer Rating",
	        imgSrc: _peer_rating_intro2.default,
	        text: peerRatingIntroText,
	        tagText: peer_rating_count + " criteria"
	      });
	    case "peer_rating_feedback_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Peer Rating",
	        imgSrc: _peer_rating_intro2.default,
	        text: peerRatingFeedbackIntroText,
	        tagText: peer_rating_count + " criteria"
	      });
	    case "final_reflection_feedback_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Final Reflections",
	        imgSrc: _skills_assessment_intro2.default,
	        text: '',
	        tagText: peer_rating_count + " criteria"
	      });
	    case "ilike":
	      return _react2.default.createElement(_likeWishResults2.default, {
	        id: question.id,
	        header: iLikeTitle,
	        items: question.answers
	      });
	    case "iwish":
	      return _react2.default.createElement(_likeWishResults2.default, {
	        id: question.id,
	        header: iWishTitle,
	        items: question.answers
	      });
	    case "skills_assessment_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Skills Assessment",
	        imgSrc: _skills_assessment_intro2.default,
	        text: skillsAssessmentText
	      });
	    case "final_reflections_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Final Reflections",
	        imgSrc: _skills_assessment_intro2.default,
	        text: FinalReflectionsText
	      });
	    case "final_reflections_results_intro":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: "Final Reflections",
	        imgSrc: _skills_assessment_intro2.default,
	        text: ""
	      });
	    case "final_page":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: null,
	        imgSrc: _finalPage2.default,
	        background: "#D7F0F2",
	        text: finalPageText(adjustedScore)
	      });
	    case "final_peer_rating_page":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: null,
	        imgSrc: _finalPage2.default,
	        background: "#D7F0F2"
	      });
	    case "transition_page":
	      return _react2.default.createElement(GenerateIntroScreen, {
	        title: null,
	        imgSrc: null,
	        background: teamColorBackground,
	        backgroundBlockWidth: 280,
	        showTeamCircle: true,
	        teamCircleBackground: teamColorCircle,
	        text: transitionPageText(question.username)
	      });
	    case "freeform":
	      if (question.category === "self_assessment" && question.text.indexOf("most valuable") === -1) {
	        var feedback = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
	        var answer = feedback ? answers.find(function (i) {
	          return i.feedback === feedback;
	        }) : null;
	
	        var value = feedback ? answer ? answer.value : '' : question.value ? question.value : '';
	
	        return _react2.default.createElement(_textArea2.default, {
	          id: question.id,
	          title: question.text,
	          onChange: onChange,
	          showError: showError,
	          value: value,
	          feedback: feedback || 0,
	          readonlyMode: readonlyMode
	        });
	      }
	
	      if (question.category === "self_assessment" && question.text.indexOf("most valuable") >= 0) {
	        var _feedback = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
	        var _answer = _feedback ? answers.find(function (i) {
	          return i.feedback === _feedback;
	        }) : null;
	
	        return _react2.default.createElement(_teamList2.default, {
	          id: question.id,
	          title: question.text,
	          onChange: onChange,
	          value: _answer ? _answer.value : "",
	          teamList: teamList,
	          feedback: _feedback || 0,
	          readonlyMode: readonlyMode
	        });
	      }
	
	      if (question.category === "collaboration" || question.category === "peer_rating") {
	        var feedbacksIds = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = teamList.map(function (teammate) {
	            return teammate.id;
	          })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var userId = _step.value;
	
	            if (feedbacks[userId]) {
	              feedbacksIds.push(feedbacks[userId].id);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        var teamAnswers = answers.filter(function (i) {
	          return feedbacksIds.includes(i.feedback);
	        }).map(function (i) {
	          return {
	            feedback: i.feedback,
	            value: i.value
	          };
	        });
	
	        return _react2.default.createElement(_teamTable2.default, {
	          id: question.id,
	          title: question.text,
	          onChange: onChange,
	          values: teamAnswers,
	          teamList: teamList,
	          feedbacks: feedbacks,
	          readonlyMode: readonlyMode
	        });
	      }
	
	      if (question.category === "communication") {
	        var _feedback2 = feedbacks[question.userId] ? feedbacks[question.userId].id : null;
	        var _answer2 = _feedback2 ? answers.find(function (i) {
	          return i.feedback === _feedback2;
	        }) : null;
	
	        var leftExtraInfo = question.answer_type === "freeform" ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "b",
	              null,
	              "Consider any of the following in your response:"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "The effectiveness of this teammate's communication, whether in person or via email."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "The level of preparedness demonstrated by this teammate during team meetings."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "The extent to which this teammate adeptly employed and/or analyzed data during discussions or decision-making."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "The degree of supportiveness exhibited by this teammate."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "How well this teammate listened to your ideas and those of others."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "How adeptly this teammate managed conflicts."
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "The extent to which this teammate is open to considering multiple options and perspectives while making decisions."
	            )
	          )
	        ) : null;
	
	        return _react2.default.createElement(_textArea2.default, {
	          id: question.id,
	          title: question.text,
	          onChange: onChange,
	          showError: showError,
	          value: _answer2 ? _answer2.value : "",
	          feedback: _feedback2 || 0,
	          text: previousAnswers && previousAnswers.length > 0 && question.answer_type !== "freeform" ? prepareStatements(previousAnswers) : null,
	          readonlyMode: readonlyMode,
	          leftExtraInfo: leftExtraInfo
	        });
	      }
	
	      if (question.category === "other" || question.category === "skills") {
	        var _feedback3 = feedbacks[question.userId] ? feedbacks[question.userId].id : null;
	        var _answer3 = _feedback3 ? answers.find(function (i) {
	          return i.feedback === _feedback3;
	        }) : null;
	
	        return _react2.default.createElement(_multiSelect2.default, {
	          id: question.id,
	          title: question.text,
	          onChange: onChange,
	          value: _answer3 ? _answer3.value : "",
	          feedback: _feedback3 || 0,
	          statements: question.statements ? [].concat(_toConsumableArray(question.statements), [{ id: 0, text: 'Not Applicable' }]) : [],
	          readonlyMode: readonlyMode
	        });
	      }
	
	      if (question.category === "like_wish_results") {
	        return _react2.default.createElement(_likeWishResults2.default, {
	          id: question.id,
	          title: question.text,
	          items: question.items
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        question.category,
	        " - ",
	        question.answer_type
	      );
	    case "rating":
	      {
	        if (question.assessment_type === "bars") {
	
	          var _feedback4 = 0;
	          var answersValue = 0;
	
	          if (question.category === "self_assessment") {
	            _feedback4 = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
	            var _answer4 = _feedback4 ? answers.find(function (i) {
	              return i.feedback === _feedback4;
	            }) : 0;
	            answersValue = _answer4 ? _answer4.value : 0;
	          } else {
	            var _feedbacksIds = [];
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = teamList.map(function (teammate) {
	                return teammate.id;
	              })[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _userId = _step2.value;
	
	                if (feedbacks[_userId]) {
	                  _feedbacksIds.push(feedbacks[_userId].id);
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            answersValue = answers.filter(function (i) {
	              return _feedbacksIds.includes(i.feedback);
	            }).map(function (i) {
	              return {
	                feedback: i.feedback,
	                value: i.value
	              };
	            });
	          }
	
	          return _react2.default.createElement(_bars2.default, {
	            id: question.id,
	            title: question.text,
	            onChange: onChange,
	            options: question.option_choices,
	            teamList: teamList,
	            readonlyMode: readonlyMode,
	            category: question.category,
	            feedback: _feedback4 || 0,
	            feedbacks: feedbacks,
	            values: answersValue
	          });
	        } else {
	          if ((question.category === "self_assessment" || question.category === "likert") && !question.most_valuable) {
	            var _feedback5 = feedbacks[currentUserId] ? feedbacks[currentUserId].id : null;
	            var _answer5 = _feedback5 ? answers.find(function (i) {
	              return i.feedback === _feedback5;
	            }) : null;
	            var _value = question.category === "likert" ? question.value : _answer5 ? _answer5.value : 0;
	
	            return _react2.default.createElement(_likertScale2.default, {
	              id: question.id,
	              title: question.text,
	              onChange: onChange,
	              value: _value,
	              feedback: _feedback5 || 0,
	              readonlyMode: readonlyMode
	            });
	          }
	
	          if ((question.category === "collaboration" || question.category === "peer_rating") && !question.most_valuable) {
	            var _feedbacksIds2 = [];
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = teamList.map(function (teammate) {
	                return teammate.id;
	              })[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _userId2 = _step3.value;
	
	                if (feedbacks[_userId2]) {
	                  _feedbacksIds2.push(feedbacks[_userId2].id);
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	
	            var _teamAnswers = answers.filter(function (i) {
	              return _feedbacksIds2.includes(i.feedback);
	            }).map(function (i) {
	              return {
	                feedback: i.feedback,
	                value: i.value
	              };
	            });
	
	            return _react2.default.createElement(_likertScaleTable2.default, {
	              id: question.id,
	              title: question.text,
	              onChange: onChange,
	              values: _teamAnswers,
	              teamList: teamList,
	              feedbacks: feedbacks,
	              readonlyMode: readonlyMode
	            });
	          }
	        }
	
	        return _react2.default.createElement("div", null);
	      }
	    default:
	      return _react2.default.createElement("div", null);
	  }
	};
	
	exports.default = parseFeedback;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBarItem = function ProgressBarItem(props) {
	  var id = props.id,
	      title = props.title,
	      isDisabled = props.isDisabled,
	      progress = props.progress,
	      surveyId = props.surveyId,
	      linearExtraId = props.linearExtraId;
	
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "svg",
	      {
	        width: "202",
	        height: "48",
	        viewBox: "0 0 202 48",
	        fill: "none",
	        xmlns: "http://www.w3.org/2000/svg"
	      },
	      _react2.default.createElement(
	        "linearGradient",
	        { id: "progressFill_" + surveyId + "_" + id + linearExtraId },
	        _react2.default.createElement("stop", { offset: progress + "%", stopColor: "hsla(0, 81%, 92%, 1)" }),
	        _react2.default.createElement("stop", { offset: progress + "%", stopColor: "hsla(0, 0%, 100%, 1)" })
	      ),
	      _react2.default.createElement("path", {
	        d: "M1.76777 3.06066C0.82282 2.11571 1.49207 0.5 2.82843 0.5H177.172C177.569 0.5 177.951 0.658034 178.232 0.939342L200.232 22.9393C200.818 23.5251 200.818 24.4749 200.232 25.0607L178.232 47.0607C177.951 47.342 177.569 47.5 177.172 47.5H2.82843C1.49207 47.5 0.82282 45.8843 1.76777 44.9393L20.9393 25.7678C21.9156 24.7915 21.9156 23.2085 20.9393 22.2322L1.76777 3.06066Z",
	        stroke: isDisabled ? "" : "#EC5E59",
	        fill: isDisabled ? "hsla(213, 100%, 12%, 0.04)" : "url(#progressFill_" + surveyId + "_" + id + linearExtraId + ")"
	      }),
	      _react2.default.createElement(
	        "text",
	        {
	          className: (0, _classnames2.default)("progressBarText", {
	            progressBarText_disabled: isDisabled
	          }),
	          x: 202 / 2,
	          y: 48 / 2,
	          dominantBaseline: "middle",
	          textAnchor: "middle"
	        },
	        title
	      )
	    )
	  );
	};
	
	exports.default = ProgressBarItem;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _radioUnchecked = __webpack_require__(693);
	
	var _radioUnchecked2 = _interopRequireDefault(_radioUnchecked);
	
	var _radioChecked = __webpack_require__(692);
	
	var _radioChecked2 = _interopRequireDefault(_radioChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamList = function (_Component) {
	  _inherits(TeamList, _Component);
	
	  function TeamList(props) {
	    _classCallCheck(this, TeamList);
	
	    var _this = _possibleConstructorReturn(this, (TeamList.__proto__ || Object.getPrototypeOf(TeamList)).call(this, props));
	
	    _this.handleOnSelect = function (value) {
	      var selectedValue = _this.state.selectedValue;
	      var _this$props = _this.props,
	          feedback = _this$props.feedback,
	          readonlyMode = _this$props.readonlyMode;
	
	
	      if (readonlyMode) {
	        return;
	      }
	
	      if (selectedValue !== value) {
	        _this.setState(function () {
	          return { selectedValue: value };
	        }, function () {
	          var _this$props2 = _this.props,
	              onChange = _this$props2.onChange,
	              id = _this$props2.id;
	
	
	          if (onChange) onChange({
	            id: id,
	            value: value,
	            type: "text",
	            hasError: false,
	            feedback: feedback
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      selectedValue: props.value
	    };
	    return _this;
	  }
	
	  _createClass(TeamList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var img1Preload = new Image();
	      img1Preload.src = _radioUnchecked2.default;
	
	      var img2Preload = new Image();
	      img2Preload.src = _radioChecked2.default;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          id = _props.id,
	          value = _props.value;
	
	
	      if (prevProps.id !== id) {
	        this.setState(function () {
	          return { selectedValue: value };
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var selectedValue = this.state.selectedValue;
	      var _props2 = this.props,
	          title = _props2.title,
	          teamList = _props2.teamList,
	          readonlyMode = _props2.readonlyMode;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "teamList" },
	        _react2.default.createElement(
	          "div",
	          { className: "title" },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "teamListItems" },
	          teamList.map(function (_ref, index) {
	            var id = _ref.id,
	                username = _ref.username,
	                fullname = _ref.fullname;
	            return _react2.default.createElement(
	              "div",
	              {
	                key: "team-list-item-" + index,
	                className: "teamListItemWrapper"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: (0, _classnames2.default)("teamListItem", {
	                    teamListItem_selected: selectedValue === username,
	                    teamListItem_nofocus: readonlyMode
	                  }),
	                  onClick: function onClick() {
	                    return _this2.handleOnSelect(username);
	                  }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "teamListItemRadio teamListItemRadioUnchecked" },
	                  _react2.default.createElement("img", {
	                    alt: "radio-unchecked",
	                    src: _radioUnchecked2.default
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "teamListItemRadio teamListItemRadioChecked" },
	                  _react2.default.createElement("img", {
	                    alt: "radio-checked",
	                    src: _radioChecked2.default
	                  })
	                ),
	                fullname
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamList;
	}(_react.Component);
	
	TeamList.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  teamList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    fullname: _propTypes2.default.string
	  })),
	  feedback: _propTypes2.default.number,
	  readonlyMode: _propTypes2.default.bool
	};
	
	exports.default = TeamList;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _radioUnchecked = __webpack_require__(693);
	
	var _radioUnchecked2 = _interopRequireDefault(_radioUnchecked);
	
	var _radioChecked = __webpack_require__(692);
	
	var _radioChecked2 = _interopRequireDefault(_radioChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamTable = function (_Component) {
	  _inherits(TeamTable, _Component);
	
	  function TeamTable(props) {
	    _classCallCheck(this, TeamTable);
	
	    var _this = _possibleConstructorReturn(this, (TeamTable.__proto__ || Object.getPrototypeOf(TeamTable)).call(this, props));
	
	    _this.isCheckboxSelected = function (teammate, value) {
	      var selectedValues = _this.state.selectedValues;
	      var feedbacks = _this.props.feedbacks;
	
	
	      var feedback = feedbacks[teammate.id];
	      if (!feedback) {
	        return false;
	      }
	
	      var answer = selectedValues.find(function (i) {
	        return i.feedback === feedback.id;
	      });
	      if (!answer) {
	        return false;
	      }
	
	      return typeof answer.value === "string" && answer.value.toLowerCase() === value;
	    };
	
	    _this.handleOnSelect = function (teammate, value) {
	      var selectedValues = _this.state.selectedValues;
	      var _this$props = _this.props,
	          feedbacks = _this$props.feedbacks,
	          readonlyMode = _this$props.readonlyMode;
	
	
	      if (readonlyMode) {
	        return;
	      }
	
	      var feedback = feedbacks[teammate.id];
	      if (!feedback) {
	        return;
	      }
	
	      var newValues = [].concat(_toConsumableArray(selectedValues));
	      var answerIndex = newValues.findIndex(function (i) {
	        return i.feedback === feedback.id;
	      });
	      var stateChanged = false;
	      if (answerIndex === -1) {
	        newValues.push({
	          feedback: feedback.id,
	          value: value
	        });
	        stateChanged = true;
	      } else if (answerIndex >= 0 && (typeof newValues[answerIndex].value !== "string" || newValues[answerIndex].value.toLowerCase() !== value)) {
	        newValues[answerIndex].value = value;
	        stateChanged = true;
	      }
	
	      if (stateChanged) {
	        _this.setState({
	          selectedValues: newValues
	        }, function () {
	          var _this$props2 = _this.props,
	              onChange = _this$props2.onChange,
	              id = _this$props2.id;
	
	
	          if (onChange) {
	            onChange({
	              id: id,
	              value: value,
	              type: "likert",
	              hasError: false,
	              feedback: feedback.id
	            });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      selectedValues: props.values
	    };
	    return _this;
	  }
	
	  _createClass(TeamTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var img1Preload = new Image();
	      img1Preload.src = _radioUnchecked2.default;
	
	      var img2Preload = new Image();
	      img2Preload.src = _radioChecked2.default;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var _props = this.props,
	          id = _props.id,
	          values = _props.values;
	
	
	      if (prevProps.id !== id) {
	        this.setState(function () {
	          return { selectedValues: values };
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          title = _props2.title,
	          teamList = _props2.teamList,
	          readonlyMode = _props2.readonlyMode;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "teamTable" },
	        _react2.default.createElement(
	          "div",
	          { className: "title" },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "teamTableWrapper" },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                { className: "teamTableHeader" },
	                _react2.default.createElement("th", null),
	                _react2.default.createElement(
	                  "th",
	                  { className: "teamTableCheckboxColumn" },
	                  "Yes"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  { className: "teamTableCheckboxColumn" },
	                  "No"
	                ),
	                _react2.default.createElement("th", { className: "teamTableEmptyColumn" })
	              ),
	              teamList.map(function (teammate, teammateIndex) {
	                return _react2.default.createElement(
	                  "tr",
	                  { key: "team-table-row-" + teammateIndex, className: (0, _classnames2.default)({
	                      teamTableGrayRow: teammateIndex % 2 === 0
	                    }) },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "teamTableUserName" },
	                    teammate.fullname
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "teamTableCheckboxColumn" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: (0, _classnames2.default)("teamTableCheckbox", {
	                          teamTableCheckbox_selected: _this2.isCheckboxSelected(teammate, "yes"),
	                          teamTableCheckbox_nofocus: readonlyMode
	                        }) },
	                      _react2.default.createElement("img", {
	                        alt: "radio-unchecked",
	                        src: _radioUnchecked2.default,
	                        className: "unchecked",
	                        onClick: function onClick() {
	                          return _this2.handleOnSelect(teammate, "yes");
	                        }
	                      }),
	                      _react2.default.createElement("img", {
	                        alt: "radio-checked",
	                        src: _radioChecked2.default,
	                        className: "checked",
	                        onClick: function onClick() {
	                          return _this2.handleOnSelect(teammate, "yes");
	                        }
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "teamTableCheckboxColumn" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: (0, _classnames2.default)("teamTableCheckbox", {
	                          teamTableCheckbox_selected: _this2.isCheckboxSelected(teammate, "no"),
	                          teamTableCheckbox_nofocus: readonlyMode
	                        }) },
	                      _react2.default.createElement("img", {
	                        alt: "radio-unchecked",
	                        src: _radioUnchecked2.default,
	                        className: "unchecked",
	                        onClick: function onClick() {
	                          return _this2.handleOnSelect(teammate, "no");
	                        }
	                      }),
	                      _react2.default.createElement("img", {
	                        alt: "radio-checked",
	                        src: _radioChecked2.default,
	                        className: "checked",
	                        onClick: function onClick() {
	                          return _this2.handleOnSelect(teammate, "no");
	                        }
	                      })
	                    )
	                  ),
	                  _react2.default.createElement("td", { className: "teamTableEmptyColumn" })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamTable;
	}(_react.Component);
	
	TeamTable.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    feedback: _propTypes2.default.number,
	    value: _propTypes2.default.string
	  })),
	  onChange: _propTypes2.default.func,
	  teamList: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    fullname: _propTypes2.default.string
	  })),
	  readonlyMode: _propTypes2.default.bool
	};
	
	exports.default = TeamTable;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextArea = function (_Component) {
	  _inherits(TextArea, _Component);
	
	  function TextArea(props) {
	    _classCallCheck(this, TextArea);
	
	    var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));
	
	    _this.initState = function () {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          maxWords = _this$props.maxWords,
	          minWords = _this$props.minWords;
	
	
	      var wordsCount = _this.getCountOfWords(value);
	
	      var isInputFull = wordsCount > maxWords;
	      var isInputLess = wordsCount < minWords;
	      var hasError = isInputLess || isInputFull;
	
	      _this.setState(function () {
	        return {
	          value: value,
	          isInputLess: isInputLess,
	          isInputFull: isInputFull,
	          hasError: hasError,
	          wordsCount: wordsCount
	        };
	      });
	    };
	
	    _this.getCountOfWords = function (str) {
	      str = str.replace(/(^\s*)|(\s*$)/gi, "");
	      str = str.replace(/[ ]{2,}/gi, " ");
	      str = str.replace(/\n /, "\n");
	
	      return str.split(" ").filter(function (w) {
	        return w !== "";
	      }).length;
	    };
	
	    _this.getErrorMessage = function () {
	      var isInputFull = _this.state.isInputFull;
	      var _this$props2 = _this.props,
	          maxWords = _this$props2.maxWords,
	          minWords = _this$props2.minWords;
	
	
	      if (isInputFull) {
	        return "You\u2019ve exceeded the " + maxWords + " word limit";
	      } else {
	        return "A minimum of " + minWords + " words are required in order to move forward";
	      }
	    };
	
	    _this.handleInputChange = function (e) {
	      var _this$props3 = _this.props,
	          id = _this$props3.id,
	          maxWords = _this$props3.maxWords,
	          minWords = _this$props3.minWords,
	          onChange = _this$props3.onChange,
	          feedback = _this$props3.feedback,
	          readonlyMode = _this$props3.readonlyMode;
	
	      if (readonlyMode) {
	        return;
	      }
	
	      var inputValue = e.target.value;
	      var wordsCount = _this.getCountOfWords(inputValue);
	
	      var isInputFull = wordsCount > maxWords;
	      var isInputLess = wordsCount < minWords;
	      var hasError = isInputLess || isInputFull;
	
	      if (onChange) onChange({
	        id: id,
	        value: inputValue,
	        type: "text",
	        hasError: hasError,
	        feedback: feedback
	      });
	
	      _this.setState(function () {
	        return {
	          wordsCount: wordsCount,
	          isInputFull: isInputFull,
	          isInputLess: isInputLess,
	          hasError: hasError,
	          value: inputValue
	        };
	      });
	    };
	
	    _this.state = {
	      wordsCount: 0
	    };
	    return _this;
	  }
	
	  _createClass(TextArea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initState();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState, snapshot) {
	      var id = this.props.id;
	
	
	      if (prevProps.id !== id) {
	        this.initState();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          wordsCount = _state.wordsCount,
	          isInputFull = _state.isInputFull,
	          hasError = _state.hasError;
	      var _props = this.props,
	          id = _props.id,
	          title = _props.title,
	          maxWords = _props.maxWords,
	          placeholder = _props.placeholder,
	          showError = _props.showError,
	          text = _props.text,
	          readonlyMode = _props.readonlyMode,
	          leftExtraInfo = _props.leftExtraInfo;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "peerEvaluationTextArea" },
	        title && _react2.default.createElement("h5", {
	          className: "title",
	          dangerouslySetInnerHTML: { __html: title } }),
	        _react2.default.createElement(
	          "div",
	          { className: "maxWords" },
	          "(" + maxWords + " words maximum)"
	        ),
	        text,
	        _react2.default.createElement(
	          "div",
	          { className: "textarea-container " + (leftExtraInfo && 'textarea-container--wide') },
	          leftExtraInfo && leftExtraInfo,
	          _react2.default.createElement("textarea", {
	            id: id,
	            name: id,
	            value: value,
	            placeholder: placeholder,
	            onChange: this.handleInputChange,
	            readOnly: readonlyMode,
	            className: (0, _classnames2.default)({ nofocus: readonlyMode })
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "footer" },
	          showError && hasError && _react2.default.createElement(
	            "div",
	            { className: "errorMessage" },
	            this.getErrorMessage()
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "wordsCount" },
	            _react2.default.createElement(
	              "span",
	              { className: (0, _classnames2.default)({ wordsCount_full: isInputFull }) },
	              wordsCount
	            ),
	            "/",
	            maxWords
	          )
	        )
	      );
	    }
	  }]);
	
	  return TextArea;
	}(_react.Component);
	
	TextArea.defaultProps = {
	  maxWords: 200,
	  minWords: 10,
	  placeholder: "Type your thoughts here...",
	  value: "",
	  text: null
	};
	
	TextArea.propTypes = {
	  id: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  maxWords: _propTypes2.default.number,
	  minWords: _propTypes2.default.number,
	  placeholder: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  feedback: _propTypes2.default.number,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([null])]),
	  readonlyMode: _propTypes2.default.bool
	};
	
	exports.default = TextArea;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 12px;\n  color: rgba(0, 27, 59, 0.94);\n  text-transform: capitalize;\n'], ['\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  margin-bottom: 12px;\n  color: rgba(0, 27, 59, 0.94);\n  text-transform: capitalize;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _ui = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartTitle = _styledComponents2.default.h2(_templateObject);
	
	var LineLabel = function LineLabel(props) {
	  var x = props.x,
	      y = props.y,
	      fill = props.fill,
	      value = props.value;
	
	
	  return _react2.default.createElement(
	    'g',
	    { style: { backgroundColor: '#fff' } },
	    _react2.default.createElement(
	      'text',
	      {
	        x: x,
	        y: y,
	        dy: -14,
	        style: {
	          fill: fill,
	          fontWeight: 500
	        },
	        fontSize: 10,
	        textAnchor: 'middle'
	      },
	      value
	    ),
	    _react2.default.createElement('line', { x1: x, y1: y - 2, x2: x, y2: y - 10, stroke: '#F1F1F1' })
	  );
	};
	
	var AxisLabel = function AxisLabel(_ref) {
	  var axisType = _ref.axisType,
	      x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      stroke = _ref.stroke,
	      children = _ref.children;
	
	  var isVert = axisType === "yAxis";
	  var cx = isVert ? x : x + width / 2;
	  var cy = isVert ? height / 2 + y : y + height + 10;
	  var rot = isVert ? "270 0 0" : 0;
	
	  return _react2.default.createElement(
	    'text',
	    {
	      x: cx,
	      y: cy,
	      transform: 'rotate(' + rot + ')',
	      textAnchor: 'middle',
	      stroke: stroke
	    },
	    children
	  );
	};
	
	var XAxisTicker = function XAxisTicker(_ref2) {
	  var payload = _ref2.payload,
	      x = _ref2.x,
	      y = _ref2.y,
	      rest = _objectWithoutProperties(_ref2, ['payload', 'x', 'y']);
	
	  var regex = /(?![^\n]{1,20}$)([^\n]{1,20})\s/g;
	  var labelRows = payload.value.split(regex).filter(function (i) {
	    return i !== '';
	  });
	
	  var labelRowHeight = 14;
	  var labelsToDisplay = labelRows.map(function (str, index) {
	    var newRowShift = index * labelRowHeight;
	    return _react2.default.createElement(
	      _recharts.Text,
	      Object.assign({ y: y + newRowShift, x: x }, rest),
	      str
	    );
	  });
	  return _react2.default.createElement(
	    'g',
	    null,
	    labelsToDisplay
	  );
	};
	
	var AssessmentChart = function (_Component) {
	  _inherits(AssessmentChart, _Component);
	
	  function AssessmentChart() {
	    _classCallCheck(this, AssessmentChart);
	
	    return _possibleConstructorReturn(this, (AssessmentChart.__proto__ || Object.getPrototypeOf(AssessmentChart)).apply(this, arguments));
	  }
	
	  _createClass(AssessmentChart, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        _ui.ContentContainerWithBackground,
	        null,
	        _react2.default.createElement(
	          ChartTitle,
	          null,
	          'Self-Assessment'
	        ),
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: 672, height: 400 },
	          _react2.default.createElement(
	            _recharts.LineChart,
	            {
	              data: data,
	              margin: { bottom: 20, right: 10 }
	            },
	            _react2.default.createElement(_recharts.XAxis, {
	              dataKey: 'question',
	              padding: { left: 50, right: 10 },
	              axisLine: false,
	              tickLine: false,
	              tickCount: data.length,
	              interval: 0,
	              tick: function tick(props) {
	                return XAxisTicker(props);
	              },
	              cx: '10',
	              cy: '0',
	              style: {
	                fontWeight: 700,
	                fill: "rgba(0, 27, 59, 0.6)"
	              }
	            }),
	            _react2.default.createElement(_recharts.YAxis, {
	              tickLine: false,
	              tickFormatter: function tickFormatter(value) {
	                return value.toFixed(2);
	              },
	              label: _react2.default.createElement(
	                AxisLabel,
	                { axisType: 'yAxis', x: -210, y: 10, height: 0 },
	                'Rating'
	              ),
	              style: {
	                fontWeight: 700
	              },
	              padding: { top: 20 }
	            }),
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(_recharts.Legend, {
	              verticalAlign: 'top',
	              iconType: 'plainline',
	              iconSize: 15,
	              formatter: function formatter(value, entry, index) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: 12 } },
	                  value
	                );
	              },
	              margin: { top: 15, left: 0, right: 0, bottom: 0 }
	            }),
	            _react2.default.createElement(
	              _recharts.Line,
	              {
	                type: 'monotone',
	                dataKey: 'Self-Assessment',
	                stroke: _Teams2.default.currentTeamColor(),
	                strokeWidth: 3,
	                dot: false,
	                activeDot: false
	              },
	              _react2.default.createElement(_recharts.LabelList, { content: _react2.default.createElement(LineLabel, { fill: _Teams2.default.currentTeamColor() }) })
	            ),
	            _react2.default.createElement(
	              _recharts.Line,
	              {
	                type: 'monotone',
	                dataKey: 'Team-Assessment',
	                stroke: '#2A4169',
	                dot: false,
	                activeDot: false
	              },
	              _react2.default.createElement(_recharts.LabelList, { content: _react2.default.createElement(LineLabel, { fill: '#2A4169' }) })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssessmentChart;
	}(_react.Component);
	
	exports.default = AssessmentChart;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n'], ['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 1px;\n  height: 16px;\n  background: #2da548;\n  margin-left: 10px;\n'], ['\n  width: 1px;\n  height: 16px;\n  background: #2da548;\n  margin-left: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n'], ['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _onboardingCheck = __webpack_require__(301);
	
	var _onboardingCheck2 = _interopRequireDefault(_onboardingCheck);
	
	var _onboardingUncheck = __webpack_require__(1063);
	
	var _onboardingUncheck2 = _interopRequireDefault(_onboardingUncheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Line = _styledComponents2.default.div(_templateObject2);
	
	var Step = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var SubSection = _styledComponents2.default.div(_templateObject4);
	
	var SubSectionItem = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var Navigation = function Navigation(_ref) {
	  var data = _ref.data,
	      category = _ref.category,
	      visitsHistory = _ref.visitsHistory,
	      activeRound = _ref.activeRound;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    data.map(function (link, index) {
	      if (!!link.parent) {
	        return null;
	      }
	
	      var isLinkActive = visitsHistory.filter(function (i) {
	        return i.indexOf(link.pattern) === 0;
	      }).length > 0 || index === category;
	      var subLinks = data.filter(function (i) {
	        return i.parent === link.title;
	      });
	      var subLinksOpened = subLinks.some(function (i) {
	        return visitsHistory.filter(function (j) {
	          return j.indexOf(i.pattern) === 0;
	        }).length > 0;
	      });
	      var linkUrl = link.steps.length > 0 ? link.steps[0].url : subLinks.length > 0 ? subLinks[0].steps[0].url : null;
	      if (!linkUrl) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        { key: 'section-' + index },
	        _react2.default.createElement(
	          Step,
	          { isActive: isLinkActive },
	          _react2.default.createElement('img', { src: isLinkActive ? _onboardingCheck2.default : _onboardingUncheck2.default, alt: 'nav icon' }),
	          isLinkActive && index !== category && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: linkUrl + '?round=' + activeRound },
	            link.title
	          ),
	          (!isLinkActive || index === category) && link.title
	        ),
	        !subLinksOpened && index < data.length - 1 && _react2.default.createElement(Line, null),
	        subLinksOpened && _react2.default.createElement(
	          SubSection,
	          null,
	          subLinks.map(function (subLink) {
	            var subLinkIndex = data.findIndex(function (i) {
	              return i.title === subLink.title;
	            });
	            var isSubLinkActive = visitsHistory.filter(function (i) {
	              return i.indexOf(subLink.pattern) === 0;
	            }).length > 0 || subLinkIndex === category;
	
	            return subLink.steps[0] ? _react2.default.createElement(
	              SubSectionItem,
	              { key: 'subsection-' + index + '-' + subLinkIndex, isActive: isSubLinkActive },
	              isSubLinkActive && subLinkIndex !== category && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: subLink.steps[0].url + '?round=' + activeRound },
	                subLink.title
	              ),
	              (!isSubLinkActive || subLinkIndex === category) && subLink.title
	            ) : null;
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = Navigation;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 80px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 170px 20px 40px;\n  width: 100%;\n'], ['\n  height: 80px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 170px 20px 40px;\n  width: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  img {\n    margin-right: 5px;\n  }\n\n  &:active, &:visited, &:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgba(0, 27, 59, 0.6);\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ', '\n'], ['\n  img {\n    margin-right: 5px;\n  }\n\n  &:active, &:visited, &:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgba(0, 27, 59, 0.6);\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  &:active, &:visited, &:link {\n    width: 160px;\n    height: 40px;\n    background: #5c91f5;\n    border-radius: 4px;\n    text-align: center;\n    line-height: 40px;\n\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n\n    ', '\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n'], ['\n  &:active, &:visited, &:link {\n    width: 160px;\n    height: 40px;\n    background: #5c91f5;\n    border-radius: 4px;\n    text-align: center;\n    line-height: 40px;\n\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n\n    ', '\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingChevron = __webpack_require__(252);
	
	var _onboardingChevron2 = _interopRequireDefault(_onboardingChevron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PrevButton = _styledComponents2.default.a(_templateObject2, function (p) {
	  return p.isHidden && '\n    visibility: hidden;\n  ';
	});
	
	var Text = _styledComponents2.default.div(_templateObject3);
	
	var NextButton = _styledComponents2.default.a(_templateObject4, function (p) {
	  return p.isHidden && '\n      visibility: hidden;\n    ';
	});
	
	var Pagination = function Pagination(_ref) {
	  var goNext = _ref.goNext,
	      goPrev = _ref.goPrev,
	      isFirstStep = _ref.isFirstStep,
	      isLastStep = _ref.isLastStep,
	      currentStep = _ref.currentStep,
	      countOfSteps = _ref.countOfSteps;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      PrevButton,
	      {
	        href: '#',
	        onClick: goPrev,
	        isHidden: isFirstStep
	      },
	      _react2.default.createElement('img', { src: _onboardingChevron2.default, alt: '' }),
	      'Previous'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      currentStep,
	      '/',
	      countOfSteps
	    ),
	    _react2.default.createElement(
	      NextButton,
	      {
	        href: '#',
	        onClick: goNext,
	        isHidden: isLastStep
	      },
	      'Next'
	    )
	  );
	};
	
	exports.default = Pagination;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TextWrapper = function TextWrapper(_ref) {
	  var y = _ref.y,
	      x = _ref.x,
	      children = _ref.children,
	      rest = _objectWithoutProperties(_ref, ["y", "x", "children"]);
	
	  return _react2.default.createElement(
	    _recharts.Text,
	    Object.assign({
	      verticalAnchor: "middle",
	      y: y,
	      x: x,
	      style: {
	        fontFamily: "'Roboto'",
	        fontStyle: "normal",
	        fontWeight: 500,
	        fontSize: "11px",
	        lineHeight: "13px",
	        letterSpacing: "1px",
	        fill: "rgba(0, 27, 59, 0.94)"
	      }
	    }, rest),
	    children
	  );
	};
	
	var polarAngleAxis = function polarAngleAxis(_ref2) {
	  var payload = _ref2.payload,
	      x = _ref2.x,
	      y = _ref2.y,
	      _ref2$width = _ref2.width,
	      width = _ref2$width === undefined ? 672 : _ref2$width,
	      _ref2$height = _ref2.height,
	      height = _ref2$height === undefined ? 300 : _ref2$height,
	      _ref2$bottomValue = _ref2.bottomValue,
	      bottomValue = _ref2$bottomValue === undefined ? null : _ref2$bottomValue,
	      rest = _objectWithoutProperties(_ref2, ["payload", "x", "y", "width", "height", "bottomValue"]);
	
	  var yShift = y + (y - height / 2) / 6;
	  var xShift = x + (x - width / 2) / 12;
	
	  var regex = /(?![^\n]{1,18}$)([^\n]{1,18})\s/g;
	  var labelRows = payload.value.split(regex).filter(function (i) {
	    return i !== '';
	  });
	  if (bottomValue) {
	    labelRows.push("(" + bottomValue + ")");
	  }
	  var labelRowsCount = labelRows.length;
	  var labelRowHeight = 12.8;
	  var labelsToDisplay = labelRows.map(function (str, index) {
	    var newRowShift = index * labelRowHeight;
	    var rowsCountTopShift = labelRowsCount > 1 ? labelRowHeight / 4 * labelRowsCount : 0;
	    return _react2.default.createElement(
	      TextWrapper,
	      Object.assign({ key: index, y: yShift + newRowShift - rowsCountTopShift, x: xShift }, rest),
	      str
	    );
	  });
	  return _react2.default.createElement(
	    "g",
	    null,
	    labelsToDisplay
	  );
	};
	
	exports.default = polarAngleAxis;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n'], ['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Surveys = __webpack_require__(56);
	
	var _navigation = __webpack_require__(1259);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _pagination = __webpack_require__(1260);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _teamworksSkills = __webpack_require__(1282);
	
	var _teamworksSkills2 = _interopRequireDefault(_teamworksSkills);
	
	var _selfAssessment = __webpack_require__(1281);
	
	var _selfAssessment2 = _interopRequireDefault(_selfAssessment);
	
	var _peerRatingScoreInitial = __webpack_require__(1279);
	
	var _peerRatingScoreInitial2 = _interopRequireDefault(_peerRatingScoreInitial);
	
	var _peerRatingScoreSecond = __webpack_require__(1280);
	
	var _peerRatingScoreSecond2 = _interopRequireDefault(_peerRatingScoreSecond);
	
	var _step = __webpack_require__(1273);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1274);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _workEthics = __webpack_require__(1277);
	
	var _workEthics2 = _interopRequireDefault(_workEthics);
	
	var _communication = __webpack_require__(1265);
	
	var _communication2 = _interopRequireDefault(_communication);
	
	var _problemSolvingStep = __webpack_require__(1270);
	
	var _problemSolvingStep2 = _interopRequireDefault(_problemSolvingStep);
	
	var _problemSolvingStep3 = __webpack_require__(1271);
	
	var _problemSolvingStep4 = _interopRequireDefault(_problemSolvingStep3);
	
	var _supportive = __webpack_require__(1275);
	
	var _supportive2 = _interopRequireDefault(_supportive);
	
	var _contribution = __webpack_require__(1266);
	
	var _contribution2 = _interopRequireDefault(_contribution);
	
	var _teamInteraction = __webpack_require__(1276);
	
	var _teamInteraction2 = _interopRequireDefault(_teamInteraction);
	
	var _keepOnTrack = __webpack_require__(1267);
	
	var _keepOnTrack2 = _interopRequireDefault(_keepOnTrack);
	
	var _qualityWork = __webpack_require__(1272);
	
	var _qualityWork2 = _interopRequireDefault(_qualityWork);
	
	var _knowledgeSkills = __webpack_require__(1268);
	
	var _knowledgeSkills2 = _interopRequireDefault(_knowledgeSkills);
	
	var _managingConflict = __webpack_require__(1269);
	
	var _managingConflict2 = _interopRequireDefault(_managingConflict);
	
	var _step5 = __webpack_require__(1263);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1264);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _goodLuck = __webpack_require__(1278);
	
	var _goodLuck2 = _interopRequireDefault(_goodLuck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject3);
	
	var PeerFeedback = function (_PureComponent) {
	  _inherits(PeerFeedback, _PureComponent);
	
	  function PeerFeedback(props) {
	    _classCallCheck(this, PeerFeedback);
	
	    var _this = _possibleConstructorReturn(this, (PeerFeedback.__proto__ || Object.getPrototypeOf(PeerFeedback)).call(this, props));
	
	    _this.updateCurrentState = function () {
	      var navigation = _this.state.navigation;
	
	
	      _this.setState({
	        loaded: false
	      });
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').then(function (res) {
	        var activeRound = _this.activeRound;
	        var user_id = Number(_Auth2.default.getUserId());
	        var round_number = Number(activeRound);
	        var game_id = Number(_Auth2.default.getGameId());
	        var course_id = Number(_Auth2.default.getCourseId());
	
	        var visitsHistory = res.body.results.filter(function (i) {
	          return Number(i.course) === course_id && Number(i.game) === game_id && Number(i.round_number) === round_number && Number(i.user) === user_id && i.page.indexOf(window.location.protocol + '//' + window.location.host) === 0;
	        }).map(function (i) {
	          return i.page.replace(window.location.protocol + '//' + window.location.host, '');
	        });
	
	        var currentCategory = 0;
	        var currentStep = 0;
	        var found = false;
	
	        for (var i = 0; i < navigation.length; i++) {
	          var stepIndex = navigation[i].steps.findIndex(function (j) {
	            return j.url === _this.props.location.pathname;
	          });
	          if (stepIndex > -1) {
	            currentCategory = i;
	            currentStep = stepIndex;
	            found = true;
	            break;
	          }
	        }
	
	        if (!found) {
	          var needBreak = false;
	          for (var _i = 0; _i < navigation.length; _i++) {
	            if (needBreak === true) {
	              break;
	            }
	
	            for (var j = 0; j < navigation[_i].steps.length; j++) {
	              if (visitsHistory.includes(navigation[_i].steps[j].url)) {
	                currentCategory = _i;
	                currentStep = j;
	              } else {
	                needBreak = true;
	                break;
	              }
	            }
	          }
	        }
	
	        if (currentCategory !== _this.state.currentCategory || currentStep !== _this.state.currentStep) {
	          _this.setState({
	            currentCategory: currentCategory,
	            currentStep: currentStep,
	            visitsHistory: visitsHistory,
	            loaded: true
	          }, function () {
	            _this.checkLocation();
	          });
	        } else {
	          _this.setState({
	            visitsHistory: visitsHistory,
	            loaded: true
	          });
	
	          if (_this.props.location.pathname === '/performance-feedback') {
	            _this.checkLocation();
	          }
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.checkLocation = function () {
	      var _this$state = _this.state,
	          currentCategory = _this$state.currentCategory,
	          currentStep = _this$state.currentStep,
	          navigation = _this$state.navigation;
	
	      var activeRound = _this.activeRound;
	
	      if (_this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
	        _this.setState({
	          loaded: false
	        });
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').then(function (res) {
	          var user_id = Number(_Auth2.default.getUserId());
	          var round_number = Number(activeRound);
	          var game_id = Number(_Auth2.default.getGameId());
	          var course_id = Number(_Auth2.default.getCourseId());
	          var current_page = '' + navigation[currentCategory].steps[currentStep].url;
	
	          var visitsHistory = res.body.results.filter(function (i) {
	            return Number(i.course) === course_id && Number(i.game) === game_id && Number(i.round_number) === round_number && Number(i.user) === user_id && i.page.indexOf(window.location.protocol + '//' + window.location.host) === 0;
	          }).map(function (i) {
	            return i.page.replace(window.location.protocol + '//' + window.location.host, '');
	          });
	          if (!visitsHistory.includes(current_page)) {
	            (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/engagement/tracks/').send({
	              page: window.location.protocol + '//' + window.location.host + current_page,
	              user: user_id,
	              course: course_id,
	              game: game_id,
	              round_number: round_number
	            }).then(function (data) {
	              _this.setState({
	                visitsHistory: [].concat(_toConsumableArray(visitsHistory), [current_page]),
	                loaded: true
	              });
	            });
	          } else {
	            _this.setState({
	              visitsHistory: visitsHistory,
	              loaded: true
	            });
	          }
	        }).catch(function (err) {});
	
	        (0, _Location.changeLocation)(navigation[currentCategory].steps[currentStep].url + '?round=' + activeRound);
	      }
	    };
	
	    _this.goNext = function (e) {
	      e.preventDefault();
	
	      var _this$state2 = _this.state,
	          currentCategory = _this$state2.currentCategory,
	          currentStep = _this$state2.currentStep,
	          navigation = _this$state2.navigation;
	
	
	      var nextCategory = currentCategory;
	      var nextStep = currentStep + 1;
	      if (nextStep >= navigation[currentCategory].steps.length) {
	        nextCategory = currentCategory + 1;
	        nextStep = 0;
	
	        if (nextCategory >= navigation.length) {
	          return false;
	        } else if (nextStep >= navigation[nextCategory].steps.length) {
	          nextCategory = currentCategory + 2;
	          nextStep = 0;
	
	          if (nextCategory >= navigation.length) {
	            return false;
	          }
	        }
	      }
	
	      _this.setState({
	        currentCategory: nextCategory,
	        currentStep: nextStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.goPrev = function (e) {
	      e.preventDefault();
	
	      var _this$state3 = _this.state,
	          currentCategory = _this$state3.currentCategory,
	          currentStep = _this$state3.currentStep,
	          navigation = _this$state3.navigation;
	
	
	      var prevCategory = currentCategory;
	      var prevStep = currentStep - 1;
	      if (prevStep < 0) {
	        prevCategory = currentCategory - 1;
	        if (prevCategory < 0) {
	          return false;
	        }
	
	        prevStep = navigation[prevCategory].steps.length - 1;
	        if (prevStep < 0) {
	          prevCategory = currentCategory - 2;
	          if (prevCategory < 0) {
	            return false;
	          }
	
	          prevStep = navigation[prevCategory].steps.length - 1;
	        }
	      }
	
	      _this.setState({
	        currentCategory: prevCategory,
	        currentStep: prevStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.state = {
	      currentCategory: 0,
	      currentStep: 0,
	      navigation: [],
	      loaded: false,
	      visitsHistory: [],
	      surveys: [],
	      courses: []
	    };
	    return _this;
	  }
	
	  _createClass(PeerFeedback, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.loadNavigation(function () {
	        _this2.updateCurrentState();
	      });
	    }
	  }, {
	    key: 'loadNavigation',
	    value: function loadNavigation(callback) {
	      var _this3 = this;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/?course=' + _Auth2.default.getCourseId(), ("https://be-production-itb.marketgames.io/api/") + 'courses/']).then(function (res) {
	
	        var surveys = res[0].body.results;
	
	        var initialSurvey = surveys.find(function (i) {
	          return i.stage === 'initial';
	        });
	        var secondSurvey = surveys.find(function (i) {
	          return i.stage === 'second';
	        });
	
	        var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	          return (0, _Surveys.isSurveyFinished)(i);
	        }) : [];
	
	        var lastFinishedSurvey = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1] : null;
	
	        var courseId = Number(_Auth2.default.getCourseId());
	        var courses = [];
	        var course = res[1].body.find(function (i) {
	          return Number(i.id) === courseId;
	        });
	
	        if (course && course.subcourses) {
	          courses = course.subcourses.filter(function (i) {
	            return ['leadership'].includes(i.category.toLowerCase());
	          });
	        }
	
	        var showLeadershipPathway = courses.length > 0;
	
	        var showWorkEthics = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Work Ethics';
	        }) : false;
	        var showCommunication = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Communication';
	        }) : false;
	        var showAnalytical = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Analytical';
	        }) : false;
	        var showConflictManagement = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Conflict Management';
	        }) : false;
	        var showSupportive = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Supportive';
	        }) : false;
	        var showContribution = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Contributing to Teamwork';
	        }) : false;
	        var showTeamInteraction = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Interacting with Teammates';
	        }) : false;
	        var showKeepOnTrack = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Keeping the Team on Track';
	        }) : false;
	        var showQualityWork = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Expecting Quality';
	        }) : false;
	        var showKnowledgeSkills = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Having Relevant Knowledge, Skills, and Abilities';
	        }) : false;
	        var showManagingConflict = lastFinishedSurvey ? lastFinishedSurvey.questions.find(function (i) {
	          return i.text === 'Managing Conflict';
	        }) : false;
	
	        var selfAssessmentQuestions = lastFinishedSurvey ? lastFinishedSurvey.questions.filter(function (i) {
	          return i.category === 'self_assessment';
	        }) : [];
	        var showSelfAssessment = selfAssessmentQuestions.filter(function (i) {
	          return ['SELF | Analytical', 'SELF | Conflict Management', 'SELF | Supportive', 'SELF | Communication', 'SELF | Work Ethics', 'SELF | Contributing to the Teams Work', 'SELF | Interacting with Teammates', 'SELF | Keeping the Team on Track', 'SELF | Expecting Quality', 'SELF | Having Relevant Knowledge, Skills, and Abilities', 'SELF | Conflict Management'].includes(i.text);
	        }).length > 0;
	
	        var navigation = [{
	          title: 'Overview',
	          pattern: '/peer-feedback/',
	          steps: [{
	            url: '/peer-feedback/teamwork-skills',
	            component: _teamworksSkills2.default
	          }]
	        }].concat(_toConsumableArray(showSelfAssessment ? [{
	          title: 'Self-Assessment',
	          pattern: '/peer-feedback/self-assessment',
	          parent: 'Overview',
	          steps: [{
	            url: '/peer-feedback/self-assessment',
	            component: _selfAssessment2.default
	          }]
	        }] : []), _toConsumableArray(initialSurvey || secondSurvey ? [{
	          title: 'Peer Rating',
	          pattern: '/peer-feedback/peer-rating-score',
	          parent: 'Overview',
	          steps: [].concat(_toConsumableArray(initialSurvey && !secondSurvey ? [{
	            url: '/peer-feedback/peer-rating-score',
	            component: _peerRatingScoreInitial2.default
	          }] : []), _toConsumableArray(secondSurvey ? [{
	            url: '/peer-feedback/peer-rating-score',
	            component: _peerRatingScoreSecond2.default
	          }] : []))
	        }] : []), [{
	          title: 'Feedback',
	          pattern: '/peer-feedback/feedback',
	          steps: [{
	            url: '/peer-feedback/feedback/strengths-and-areas-of-development',
	            component: _step2.default
	          }, {
	            url: '/peer-feedback/feedback/teamwork-skills-that-you-are-demonstrating',
	            component: _step4.default
	          }]
	        }], _toConsumableArray(showWorkEthics ? [{
	          title: 'Work Ethic',
	          pattern: '/peer-feedback/work-ethics',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/work-ethics',
	            component: _workEthics2.default
	          }]
	        }] : []), _toConsumableArray(showCommunication ? [{
	          title: 'Communication',
	          pattern: '/peer-feedback/communication',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/communication',
	            component: _communication2.default
	          }]
	        }] : []), _toConsumableArray(showAnalytical || showConflictManagement ? [{
	          title: 'Problem Solving',
	          pattern: '/peer-feedback/problem-solving',
	          parent: 'Feedback',
	          steps: [].concat(_toConsumableArray(showAnalytical ? [{
	            url: '/peer-feedback/problem-solving/analytical',
	            component: _problemSolvingStep2.default
	          }] : []), _toConsumableArray(showConflictManagement ? [{
	            url: '/peer-feedback/problem-solving/conflict-management',
	            component: _problemSolvingStep4.default
	          }] : []))
	        }] : []), _toConsumableArray(showSupportive ? [{
	          title: 'Supportive',
	          pattern: '/peer-feedback/supportive',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/supportive',
	            component: _supportive2.default
	          }]
	        }] : []), _toConsumableArray(showContribution ? [{
	          title: 'Contribution',
	          pattern: '/peer-feedback/contribution',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/contribution',
	            component: _contribution2.default
	          }]
	        }] : []), _toConsumableArray(showTeamInteraction ? [{
	          title: 'Team Interaction',
	          pattern: '/peer-feedback/team-interaction',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/team-interaction',
	            component: _teamInteraction2.default
	          }]
	        }] : []), _toConsumableArray(showKeepOnTrack ? [{
	          title: 'Keeping On Track',
	          pattern: '/peer-feedback/keep-on-track',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/keep-on-track',
	            component: _keepOnTrack2.default
	          }]
	        }] : []), _toConsumableArray(showQualityWork ? [{
	          title: 'Quality Work',
	          pattern: '/peer-feedback/quality-work',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/quality-work',
	            component: _qualityWork2.default
	          }]
	        }] : []), _toConsumableArray(showKnowledgeSkills ? [{
	          title: 'Knowledge & Skills',
	          pattern: '/peer-feedback/knowledge-and-skills',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/knowledge-and-skills',
	            component: _knowledgeSkills2.default
	          }]
	        }] : []), _toConsumableArray(showManagingConflict ? [{
	          title: 'Managing Conflict',
	          pattern: '/peer-feedback/managing-conflict',
	          parent: 'Feedback',
	          steps: [{
	            url: '/peer-feedback/managing-conflict',
	            component: _managingConflict2.default
	          }]
	        }] : []), _toConsumableArray(showLeadershipPathway ? [{
	          title: 'Leadership Pathway',
	          pattern: '/peer-feedback/leadership-pathway',
	          steps: [{
	            url: '/peer-feedback/leadership-pathway/supply-chain-management',
	            component: _step6.default
	          }, {
	            url: '/peer-feedback/leadership-pathway/career-pathway-courses',
	            component: _step8.default
	          }]
	        }] : []), [{
	          title: 'Good Luck!',
	          pattern: '/peer-feedback/good-luck',
	          steps: [{
	            url: '/peer-feedback/good-luck',
	            component: _goodLuck2.default
	          }]
	        }]);
	
	        if (JSON.stringify(navigation) !== JSON.stringify(_this3.state.navigation)) {
	          _this3.setState({
	            navigation: navigation,
	            loaded: true,
	            surveys: surveys,
	            courses: courses
	          }, function () {
	            if (callback) {
	              callback();
	            }
	          });
	        } else {
	          if (callback) {
	            callback();
	          }
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.pathname !== this.props.location.pathname) {
	        this.updateCurrentState();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentCategory = _state.currentCategory,
	          currentStep = _state.currentStep,
	          navigation = _state.navigation,
	          loaded = _state.loaded,
	          visitsHistory = _state.visitsHistory,
	          surveys = _state.surveys,
	          courses = _state.courses;
	
	      var activeRound = this.activeRound;
	
	      if (navigation.length === 0 || !loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      var category = navigation[currentCategory];
	      var Component = null;
	      if (category) {
	        Component = category.steps[currentStep].component;
	      }
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_navigation2.default, {
	          data: navigation,
	          category: currentCategory,
	          visitsHistory: visitsHistory,
	          activeRound: activeRound
	        }),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            ContentWrapper,
	            null,
	            Component && _react2.default.createElement(Component, {
	              surveys: surveys,
	              courses: courses
	            })
	          ),
	          _react2.default.createElement(_pagination2.default, {
	            goNext: this.goNext,
	            goPrev: this.goPrev,
	            isFirstStep: this.isFirstStep,
	            isLastStep: this.isLastStep,
	            currentStep: currentStep + 1,
	            countOfSteps: this.countOfSteps
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentCategory = _state2.currentCategory,
	          currentStep = _state2.currentStep;
	
	
	      return currentCategory === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          currentCategory = _state3.currentCategory,
	          currentStep = _state3.currentStep,
	          navigation = _state3.navigation;
	
	
	      var lastCategory = navigation.length - 1;
	      var lastStep = navigation[lastCategory].steps.length - 1;
	
	      return currentCategory === lastCategory && currentStep === lastStep;
	    }
	  }, {
	    key: 'countOfSteps',
	    get: function get() {
	      var _state4 = this.state,
	          currentCategory = _state4.currentCategory,
	          navigation = _state4.navigation;
	
	
	      return navigation[currentCategory].steps.length;
	    }
	  }]);
	
	  return PeerFeedback;
	}(_react.PureComponent);
	
	exports.default = PeerFeedback;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(50);
	
	var _peerFeedbackCultivatingLeadership = __webpack_require__(2646);
	
	var _peerFeedbackCultivatingLeadership2 = _interopRequireDefault(_peerFeedbackCultivatingLeadership);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CareerPathwayStep1 = function (_PureComponent) {
	  _inherits(CareerPathwayStep1, _PureComponent);
	
	  function CareerPathwayStep1() {
	    _classCallCheck(this, CareerPathwayStep1);
	
	    return _possibleConstructorReturn(this, (CareerPathwayStep1.__proto__ || Object.getPrototypeOf(CareerPathwayStep1)).apply(this, arguments));
	  }
	
	  _createClass(CareerPathwayStep1, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Leadership Pathway'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Cultivating Leadership & Teamwork Skills'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'This section provides information about leadership and teamwork experiences that you have explored in the game and how you can further cultivate these skills.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement('img', { src: _peerFeedbackCultivatingLeadership2.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return CareerPathwayStep1;
	}(_react.PureComponent);
	
	exports.default = CareerPathwayStep1;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 24px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 24px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 600px;\n  height: 52px;\n  background: #ffffff;\n  display: flex;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n\n  img {\n    margin-left: 4px;\n    width: 24px;\n    height: 24px;\n    position: relative;\n    top: -1px;\n  }\n'], ['\n  width: 100%;\n  max-width: 600px;\n  height: 52px;\n  background: #ffffff;\n  display: flex;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n\n  img {\n    margin-left: 4px;\n    width: 24px;\n    height: 24px;\n    position: relative;\n    top: -1px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ui = __webpack_require__(50);
	
	var _redArrow = __webpack_require__(2670);
	
	var _redArrow2 = _interopRequireDefault(_redArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CourseLinks = _styledComponents2.default.div(_templateObject);
	
	var CourseLink = _styledComponents2.default.div(_templateObject2);
	
	var CareerPathwayStep2 = function (_PureComponent) {
	  _inherits(CareerPathwayStep2, _PureComponent);
	
	  function CareerPathwayStep2() {
	    _classCallCheck(this, CareerPathwayStep2);
	
	    return _possibleConstructorReturn(this, (CareerPathwayStep2.__proto__ || Object.getPrototypeOf(CareerPathwayStep2)).apply(this, arguments));
	  }
	
	  _createClass(CareerPathwayStep2, [{
	    key: 'render',
	    value: function render() {
	      var courses = this.props.courses;
	
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Leadership Pathway'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Cultivating Leadership & Teamwork Skills'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'To further nurture your career ready skills, you should consider taking anyone of the following courses offered at your program.'
	          )
	        ),
	        _react2.default.createElement(
	          CourseLinks,
	          null,
	          courses.map(function (course, index) {
	            return _react2.default.createElement(
	              CourseLink,
	              { key: index },
	              _react2.default.createElement(
	                'div',
	                null,
	                course.name
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                course.code,
	                _react2.default.createElement(
	                  'a',
	                  { href: course.url, rel: 'noreferrer', target: '_blank' },
	                  _react2.default.createElement('img', { src: _redArrow2.default, alt: 'red arrow icon' })
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'To learn more about career pathways and opportunities, we highly recommend that you reach out to your career center.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CareerPathwayStep2;
	}(_react.PureComponent);
	
	exports.default = CareerPathwayStep2;

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkEthics = function (_PureComponent) {
	  _inherits(WorkEthics, _PureComponent);
	
	  function WorkEthics(props) {
	    _classCallCheck(this, WorkEthics);
	
	    var _this = _possibleConstructorReturn(this, (WorkEthics.__proto__ || Object.getPrototypeOf(WorkEthics)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(WorkEthics, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Communication';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Your Communication Skills Rating'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Communication',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Articulating your point of view clearly and concisely is a great way to demonstrate good communication skills.  Another great way is through actively listening in which you allow other teammates to share their thoughts, pay close attention to what they have to say, and respond with thoughtful questions or insights.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019ve mastered the art of ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.thebalancemoney.com/active-listening-skills-with-examples-2059684', target: '_blank', rel: 'noreferrer' },
	              'Actively Listening'
	            ),
	            ', asking for feedback and using your teammate suggestions, and/or improving the communication amongst teammates then you\u2019re demonstrating very strong and highly desirable communication skills.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you avoid discussing team problems,  interrupts and dominates team discussions,  or rarely respond to teammates\u2019 communication then you\u2019re demonstrating low levels of communication skills.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return WorkEthics;
	}(_react.PureComponent);
	
	exports.default = WorkEthics;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contribution = function (_PureComponent) {
	  _inherits(Contribution, _PureComponent);
	
	  function Contribution(props) {
	    _classCallCheck(this, Contribution);
	
	    var _this = _possibleConstructorReturn(this, (Contribution.__proto__ || Object.getPrototypeOf(Contribution)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(Contribution, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Contributing to Teamwork';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Contributing to the Team\u2019s Work'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Contribution to The Team\u2019s Work',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re delivering higher-quality work than expected and/or helping to coach teammates that might be having difficulty, then you are contributing to the team\u2019s work at a high level.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you\u2019re not doing your fair share of the team\u2019s work and/or do not assist teammates when they\u2019re asking for your help, then you are contributing to the team\u2019s work at a low level.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return Contribution;
	}(_react.PureComponent);
	
	exports.default = Contribution;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeepOnTrack = function (_PureComponent) {
	  _inherits(KeepOnTrack, _PureComponent);
	
	  function KeepOnTrack(props) {
	    _classCallCheck(this, KeepOnTrack);
	
	    var _this = _possibleConstructorReturn(this, (KeepOnTrack.__proto__ || Object.getPrototypeOf(KeepOnTrack)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(KeepOnTrack, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Keeping the Team on Track';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Keeping Team On Track'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Keeping Team On Track',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re making sure that teammates are making appropriate progress then you\u2019re doing a great job of keeping the team on track.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you\u2019re not paying attention to team\u2019s progress and avoids discussing team proglems, even when they are obvious,  then you\u2019re not doing a great of keeping the team on track.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return KeepOnTrack;
	}(_react.PureComponent);
	
	exports.default = KeepOnTrack;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KnowledgeSkills = function (_PureComponent) {
	  _inherits(KnowledgeSkills, _PureComponent);
	
	  function KnowledgeSkills(props) {
	    _classCallCheck(this, KnowledgeSkills);
	
	    var _this = _possibleConstructorReturn(this, (KnowledgeSkills.__proto__ || Object.getPrototypeOf(KnowledgeSkills)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(KnowledgeSkills, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Having Relevant Knowledge, Skills, and Abilities';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Having Knowledge, Skills, and Abilities'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Having Knowledge, Skills, and Abilities',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Having the knowledge, skills, and abilities are great characteristics to possess on any task/group project.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re acquiring knowledge or skills to improve team\u2019s performance and/or demonstrating the knowledge, skills, and abilities to do excellent team work, you are demonstrating high levels of these highly desirable skills.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you are unable or unwilling to develop knowledge or skills to contribute to the team, then you\u2019re demonstrating low levels of knowledge, skills, and abilities.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return KnowledgeSkills;
	}(_react.PureComponent);
	
	exports.default = KnowledgeSkills;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManagingConflict = function (_PureComponent) {
	  _inherits(ManagingConflict, _PureComponent);
	
	  function ManagingConflict(props) {
	    _classCallCheck(this, ManagingConflict);
	
	    var _this = _possibleConstructorReturn(this, (ManagingConflict.__proto__ || Object.getPrototypeOf(ManagingConflict)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(ManagingConflict, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Managing Conflict';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Having Knowledge, Skills, and Abilities'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Having Knowledge, Skills, and Abilities',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Having the knowledge, skills, and abilities are great characteristics to possess on any task/group project.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re acquiring knowledge or skills to improve team\u2019s performance and/or demonstrating the knowledge, skills, and abilities to do excellent team work, you are demonstrating high levels of these highly desirable skills.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you are unable or unwilling to develop knowledge or skills to contribute to the team, then you\u2019re demonstrating low levels of knowledge, skills, and abilities.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ManagingConflict;
	}(_react.PureComponent);
	
	exports.default = ManagingConflict;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProblemSolvingStep1 = function (_PureComponent) {
	  _inherits(ProblemSolvingStep1, _PureComponent);
	
	  function ProblemSolvingStep1(props) {
	    _classCallCheck(this, ProblemSolvingStep1);
	
	    var _this = _possibleConstructorReturn(this, (ProblemSolvingStep1.__proto__ || Object.getPrototypeOf(ProblemSolvingStep1)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(ProblemSolvingStep1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Analytical';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Your Problem Solving | Analytical Skills Rating'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Analytical',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Analytical skills refer to the ability to research,  investigate, and leverage data to solve problems.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re also exploring and identifying multiple solutions to a problem then you\u2019re demonstrating very strong and highly desirable analytical skills.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you\u2019re making decisions without considerating alternative points of view and/or unable to support conclusion with facts or logic, then you\u2019re demonstrating very low levels of analytical skills.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ProblemSolvingStep1;
	}(_react.PureComponent);
	
	exports.default = ProblemSolvingStep1;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProblemSolvingStep2 = function (_PureComponent) {
	  _inherits(ProblemSolvingStep2, _PureComponent);
	
	  function ProblemSolvingStep2(props) {
	    _classCallCheck(this, ProblemSolvingStep2);
	
	    var _this = _possibleConstructorReturn(this, (ProblemSolvingStep2.__proto__ || Object.getPrototypeOf(ProblemSolvingStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(ProblemSolvingStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Conflict Management';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Your Problem Solving | Conflict Management Skills Rating'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Conflict Management',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Having conflicts within a team is very common and at times often encouraged to help teams perform better (',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://hbr.org/2012/07/conflict-keeps-teams-at-the-to', target: '_blank', rel: 'noreferrer' },
	              'HBS article'
	            ),
	            '). However, conflicts can be destructive if not managed properly. It\u2019s why the ability to manage and de-escalate conflicts is one of the most invaluable and highly desirable skill that employers seek.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re treating conflict as a mutual problem and work with other team members to better understand their point of view, then you\u2019re demonstrating very strong and highly desirable conflict management skills.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you\u2019re treating conflict as a win-lose contest, then you\u2019re demonstrating very low levels of analytical skills.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.cnbc.com/2022/10/13/ryan-reynolds-credits-his-success-to-one-skill-it-changed-my-life.html', target: '_blank', rel: 'noreferrer' },
	              'Ryan Reynolds reveal the No. 1 skill that helps him succeed.'
	            )
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ProblemSolvingStep2;
	}(_react.PureComponent);
	
	exports.default = ProblemSolvingStep2;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QualityWork = function (_PureComponent) {
	  _inherits(QualityWork, _PureComponent);
	
	  function QualityWork(props) {
	    _classCallCheck(this, QualityWork);
	
	    var _this = _possibleConstructorReturn(this, (QualityWork.__proto__ || Object.getPrototypeOf(QualityWork)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(QualityWork, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Expecting Quality';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Expecting Quality Work'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Expecting Quality Work',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Recruiters and hiring managers highly desire candidates that can consistently deliver high quality work.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re  motivating the team to do excellent work and/or cares that the team does outstanding work, even if there is no additional reward, then you have a high expectation of delivery quality work.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you are satisfied even if the team does not meet assigned standards, then you have low expectation of delivery quality work.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return QualityWork;
	}(_react.PureComponent);
	
	exports.default = QualityWork;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(50);
	
	var _peerFeedbackStrengthAreasOfDevelopment = __webpack_require__(566);
	
	var _peerFeedbackStrengthAreasOfDevelopment2 = _interopRequireDefault(_peerFeedbackStrengthAreasOfDevelopment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackStep1 = function (_PureComponent) {
	  _inherits(FeedbackStep1, _PureComponent);
	
	  function FeedbackStep1() {
	    _classCallCheck(this, FeedbackStep1);
	
	    return _possibleConstructorReturn(this, (FeedbackStep1.__proto__ || Object.getPrototypeOf(FeedbackStep1)).apply(this, arguments));
	  }
	
	  _createClass(FeedbackStep1, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Strengths and Areas of Development'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Now let\u2019s get a little deeper into the peer feedback and explore the teamwork skills that you\u2019ve been demonstrating in this exercise.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement('img', { src: _peerFeedbackStrengthAreasOfDevelopment2.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return FeedbackStep1;
	}(_react.PureComponent);
	
	exports.default = FeedbackStep1;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsChart = __webpack_require__(590);
	
	var _skillsChart2 = _interopRequireDefault(_skillsChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackStep2 = function (_PureComponent) {
	  _inherits(FeedbackStep2, _PureComponent);
	
	  function FeedbackStep2(props) {
	    _classCallCheck(this, FeedbackStep2);
	
	    var _this = _possibleConstructorReturn(this, (FeedbackStep2.__proto__ || Object.getPrototypeOf(FeedbackStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      chartData: [],
	      showData: {
	        second: false,
	        final: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(FeedbackStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	
	      var requestUrls = finishedSurveys.map(function (i) {
	        return ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + i.id + '/';
	      });
	
	      (0, _ApiService.batchRequest)(requestUrls).then(function (res) {
	        var chartData = [];
	        var showData = {
	          second: false,
	          final: false
	        };
	
	        res.forEach(function (scoreValueResult, index) {
	          var currentSurvey = finishedSurveys[index];
	
	          if (currentSurvey.stage === 'initial') {
	            chartData = scoreValueResult.body && scoreValueResult.body.user_score_question ? scoreValueResult.body.user_score_question.map(function (userScoreQuestion) {
	              var chartItem = {
	                question: userScoreQuestion.question,
	                initial: userScoreQuestion.median
	              };
	
	              return chartItem;
	            }) : [];
	          } else if (scoreValueResult.body && scoreValueResult.body.user_score_question) {
	            scoreValueResult.body.user_score_question.forEach(function (userScoreQuestion) {
	              var currentQuestion = chartData.find(function (chartItem) {
	                return chartItem.question === userScoreQuestion.question;
	              });
	              if (currentQuestion) {
	                chartData.find(function (chartItem) {
	                  return chartItem.question === userScoreQuestion.question;
	                })[currentSurvey.stage] = userScoreQuestion.median;
	              } else {
	                chartData.push(_defineProperty({
	                  question: userScoreQuestion.question
	                }, currentSurvey.stage, userScoreQuestion.median));
	              }
	
	              showData[currentSurvey.stage] = true;
	            });
	          }
	        });
	
	        var chartOrder = {
	          'Work Ethics': 1,
	          'Conflict Management': 2,
	          'Supportive': 3,
	          'Communication': 4,
	          'Analytical': 5
	        };
	        chartData = chartData.map(function (i) {
	          return Object.assign({}, i, {
	            order: i.question in chartOrder ? chartOrder[i.question] : 100
	          });
	        });
	        chartData = (0, _orderBy2.default)(chartData, 'order', ['asc']);
	
	        _this2.setState({
	          loaded: true,
	          chartData: chartData,
	          showData: showData
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          chartData = _state.chartData,
	          showData = _state.showData;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Teamwork Skills That You Are Demonstrating'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Skills Map below is a visual indicator of your performance. The wider the filled area, on a specific skill, the greater your performance in demonstrating that skill.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(_skillsChart2.default, {
	            title: 'Skills Map',
	            data: chartData,
	            showData: showData
	          })
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Let\u2019s explore each, starting with Work Ethic.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return FeedbackStep2;
	}(_react.PureComponent);
	
	exports.default = FeedbackStep2;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Supportive = function (_PureComponent) {
	  _inherits(Supportive, _PureComponent);
	
	  function Supportive(props) {
	    _classCallCheck(this, Supportive);
	
	    var _this = _possibleConstructorReturn(this, (Supportive.__proto__ || Object.getPrototypeOf(Supportive)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(Supportive, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Supportive';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Supportive Skills'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Supportive',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Being supportive helps build trust and rapport within a team. It also helps a team be more productive.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re recognizing other contributions and willing to help others understand concepts and/or make decisions, then you are demonstrating high levels of being supportive.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you interrupt, ignore, bosses, or make fun of teammates. then you\u2019re demonstrating a very low level of work ethic.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return Supportive;
	}(_react.PureComponent);
	
	exports.default = Supportive;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamInteraction = function (_PureComponent) {
	  _inherits(TeamInteraction, _PureComponent);
	
	  function TeamInteraction(props) {
	    _classCallCheck(this, TeamInteraction);
	
	    var _this = _possibleConstructorReturn(this, (TeamInteraction.__proto__ || Object.getPrototypeOf(TeamInteraction)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(TeamInteraction, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Interacting with Teammates';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Interaction with Team'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Interaction with Team',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Building team rapport can help drive productivity and performance.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re showing interests in teammates\u2019 ideas, recommending their suggestions, and/or provide encouragement to the team, then you\u2019re doing a great job with building rapport and trust with teammates.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re complaining, making excuses, or not interact with teammates, then you might struggle with building rapport within teams.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return TeamInteraction;
	}(_react.PureComponent);
	
	exports.default = TeamInteraction;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _skillsProgress = __webpack_require__(114);
	
	var _skillsProgress2 = _interopRequireDefault(_skillsProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorkEthics = function (_PureComponent) {
	  _inherits(WorkEthics, _PureComponent);
	
	  function WorkEthics(props) {
	    _classCallCheck(this, WorkEthics);
	
	    var _this = _possibleConstructorReturn(this, (WorkEthics.__proto__ || Object.getPrototypeOf(WorkEthics)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      progressValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(WorkEthics, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	
	      var lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/').then(function (res) {
	        var surveyScore = res.body;
	        var userScoreQuestions = surveyScore.user_score_question || [];
	
	        var neededQuestion = userScoreQuestions.find(function (i) {
	          return i.question === 'Work Ethics';
	        });
	        var progressValue = neededQuestion ? neededQuestion.median : 0;
	
	        _this2.setState({
	          loaded: true,
	          progressValue: progressValue
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          progressValue = _state.progressValue;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Feedback'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Your Work Ethic Skills Rating'
	        ),
	        _react2.default.createElement(_skillsProgress2.default, {
	          title: 'Work Ethic',
	          progressValue: progressValue
	        }),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Having a good work ethic indicates that you\u2019re demonstrating a high level of passion in any work that you do. This includes consistently delivering quality work on time, following through on commitments, and being present at all times.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you\u2019re also proactive, take initiatives, and/or deliver higher quality work than expected then you\u2019re demonstrating a very strong, and highly desirable, work ethic.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the flip side, if you\u2019re not doing your fair share of the work, unprepared for meetings and/or missed deadline then you\u2019re demonstrating a very low level of work ethic.'
	          )
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return WorkEthics;
	}(_react.PureComponent);
	
	exports.default = WorkEthics;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(50);
	
	var _peerFeedbackGoodLuck = __webpack_require__(565);
	
	var _peerFeedbackGoodLuck2 = _interopRequireDefault(_peerFeedbackGoodLuck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoodLuck = function (_PureComponent) {
	  _inherits(GoodLuck, _PureComponent);
	
	  function GoodLuck() {
	    _classCallCheck(this, GoodLuck);
	
	    return _possibleConstructorReturn(this, (GoodLuck.__proto__ || Object.getPrototypeOf(GoodLuck)).apply(this, arguments));
	  }
	
	  _createClass(GoodLuck, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'All the best!'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'That\u2019s All For Now!'
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement('img', { src: _peerFeedbackGoodLuck2.default, alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return GoodLuck;
	}(_react.PureComponent);
	
	exports.default = GoodLuck;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _surveyChart = __webpack_require__(591);
	
	var _surveyChart2 = _interopRequireDefault(_surveyChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PeerRatingScoreInitial = function (_PureComponent) {
	  _inherits(PeerRatingScoreInitial, _PureComponent);
	
	  function PeerRatingScoreInitial(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PeerRatingScoreInitial);
	
	    var _this = _possibleConstructorReturn(this, (PeerRatingScoreInitial.__proto__ || Object.getPrototypeOf(PeerRatingScoreInitial)).call(this, props));
	
	    _this.loadReport = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref, receiver_id) {
	        var survey_id = _ref.id,
	            stage = _ref.stage;
	
	        var _ref3, report, reports;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(survey_id && Number(survey_id) > 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiver_id + '/' + survey_id + '/');
	
	              case 4:
	                _ref3 = _context.sent;
	                report = _ref3.body;
	                reports = _this.state.reports;
	
	
	                _this.setState({
	                  reports: Object.assign({}, reports, _defineProperty({}, stage, report))
	                });
	                _context.next = 12;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](1);
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 10]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      reports: {}
	    };
	    return _this;
	  }
	
	  _createClass(PeerRatingScoreInitial, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var surveys = this.props.surveys;
	
	
	      var userId = _Auth2.default.getUserId();
	
	      surveys.forEach(function (survey) {
	        if ((0, _Surveys.isSurveyFinished)(survey)) {
	          _this3.loadReport(survey, userId);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var surveys = this.props.surveys;
	      var reports = this.state.reports;
	
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Overview'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Peer Rating Score'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Here\u2019s your peer rating score in relation to your team\u2019s average and median rating score.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.Charts.Wrapper,
	            {
	              setMaxHeight: Object.keys(reports).length === 1 ? true : false
	            },
	            _react2.default.createElement(
	              _ui.Charts.Teams.Wrapper,
	              null,
	              _react2.default.createElement(
	                _ui.Charts.Teams.Row,
	                null,
	                _react2.default.createElement(_ui.Charts.Teams.TeamColor, {
	                  background: _Teams2.default.currentTeamColor()
	                }),
	                _react2.default.createElement(
	                  _ui.Charts.Teams.TeamName,
	                  null,
	                  'You'
	                )
	              ),
	              _react2.default.createElement(
	                _ui.Charts.Teams.Row,
	                { margin: '0 20px' },
	                _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: '#eee' }),
	                _react2.default.createElement(
	                  _ui.Charts.Teams.TeamName,
	                  null,
	                  'Team Average'
	                )
	              ),
	              _react2.default.createElement(
	                _ui.Charts.Teams.Row,
	                { margin: '0 20px' },
	                _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: '#c4c4c4' }),
	                _react2.default.createElement(
	                  _ui.Charts.Teams.TeamName,
	                  null,
	                  'Team Median'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _ui.Charts.Chart,
	              null,
	              _react2.default.createElement(_surveyChart2.default, {
	                reports: reports,
	                surveys: surveys,
	                isSurveyFinished: _Surveys.isSurveyFinished
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PeerRatingScoreInitial;
	}(_react.PureComponent);
	
	exports.default = PeerRatingScoreInitial;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _surveyChart = __webpack_require__(591);
	
	var _surveyChart2 = _interopRequireDefault(_surveyChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PeerRatingScoreSecond = function (_PureComponent) {
	  _inherits(PeerRatingScoreSecond, _PureComponent);
	
	  function PeerRatingScoreSecond(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PeerRatingScoreSecond);
	
	    var _this = _possibleConstructorReturn(this, (PeerRatingScoreSecond.__proto__ || Object.getPrototypeOf(PeerRatingScoreSecond)).call(this, props));
	
	    _this.loadReport = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref, receiver_id) {
	        var survey_id = _ref.id,
	            stage = _ref.stage;
	
	        var _ref3, report, reports;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(survey_id && Number(survey_id) > 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiver_id + '/' + survey_id + '/');
	
	              case 4:
	                _ref3 = _context.sent;
	                report = _ref3.body;
	                reports = _this.state.reports;
	
	
	                _this.setState({
	                  reports: Object.assign({}, reports, _defineProperty({}, stage, report))
	                });
	                _context.next = 12;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](1);
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 10]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      reports: {}
	    };
	    return _this;
	  }
	
	  _createClass(PeerRatingScoreSecond, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var surveys = this.props.surveys;
	
	
	      var userId = _Auth2.default.getUserId();
	
	      surveys.forEach(function (survey) {
	        if ((0, _Surveys.isSurveyFinished)(survey)) {
	          _this3.loadReport(survey, userId);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var surveys = this.props.surveys;
	      var reports = this.state.reports;
	
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Overview'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Peer Rating Score Trend'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Here\u2019s the change in your peer rating score.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.Charts.Wrapper,
	            {
	              setMaxHeight: Object.keys(reports).length === 1 ? true : false
	            },
	            _react2.default.createElement(
	              _ui.Charts.Teams.Wrapper,
	              null,
	              _react2.default.createElement(
	                _ui.Charts.Teams.Row,
	                null,
	                _react2.default.createElement(_ui.Charts.Teams.TeamColor, {
	                  background: _Teams2.default.currentTeamColor()
	                }),
	                _react2.default.createElement(
	                  _ui.Charts.Teams.TeamName,
	                  null,
	                  'You'
	                )
	              ),
	              _react2.default.createElement(
	                _ui.Charts.Teams.Row,
	                { margin: '0 20px' },
	                _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: '#eee' }),
	                _react2.default.createElement(
	                  _ui.Charts.Teams.TeamName,
	                  null,
	                  'Team Average'
	                )
	              ),
	              _react2.default.createElement(
	                _ui.Charts.Teams.Row,
	                { margin: '0 20px' },
	                _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: '#c4c4c4' }),
	                _react2.default.createElement(
	                  _ui.Charts.Teams.TeamName,
	                  null,
	                  'Team Median'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _ui.Charts.Chart,
	              null,
	              _react2.default.createElement(_surveyChart2.default, {
	                reports: reports,
	                surveys: surveys,
	                isSurveyFinished: _Surveys.isSurveyFinished
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PeerRatingScoreSecond;
	}(_react.PureComponent);
	
	exports.default = PeerRatingScoreSecond;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Surveys = __webpack_require__(56);
	
	var _ui = __webpack_require__(50);
	
	var _assessmentChart = __webpack_require__(1258);
	
	var _assessmentChart2 = _interopRequireDefault(_assessmentChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelfAssessment = function (_PureComponent) {
	  _inherits(SelfAssessment, _PureComponent);
	
	  function SelfAssessment(props) {
	    _classCallCheck(this, SelfAssessment);
	
	    var _this = _possibleConstructorReturn(this, (SelfAssessment.__proto__ || Object.getPrototypeOf(SelfAssessment)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      chartData: []
	    };
	    return _this;
	  }
	
	  _createClass(SelfAssessment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveys = this.props.surveys;
	
	      var receiverId = _Auth2.default.getUserId();
	      var finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	        return (0, _Surveys.isSurveyFinished)(i);
	      }) : [];
	
	      var lastSurvey = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1] : null;
	
	      var lastSurveyId = lastSurvey ? lastSurvey.id : 0;
	
	      var selfAssessmentQuestions = lastSurvey ? lastSurvey.questions.filter(function (i) {
	        return i.category === 'self_assessment' && i.assessment_type === 'bars' && i.answer_type === 'rating';
	      }) : [];
	
	      if (!lastSurveyId) {
	        return this.setState({
	          loaded: true
	        });
	      }
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + receiverId + '/' + lastSurveyId + '/'].concat(_toConsumableArray(selfAssessmentQuestions.length > 0 ? [("https://be-production-itb.marketgames.io/api/") + 'v2/forms/answers/'] : []))).then(function (res) {
	        var surveyScore = res[0].body;
	
	        var selfAnswers = [];
	        var selfAssessmentAverage = null;
	        if (selfAssessmentQuestions.length > 0) {
	          var formsAnswers = res[1].body;
	          var selfAssessmentQuestionsIds = selfAssessmentQuestions.map(function (question) {
	            return question.id;
	          });
	          selfAnswers = formsAnswers.filter(function (answer) {
	            return selfAssessmentQuestionsIds.includes(answer.survey_question);
	          });
	          selfAssessmentAverage = selfAnswers.reduce(function (total, next) {
	            return total + Number(next.text);
	          }, 0) / selfAnswers.length;
	        }
	
	        var chartData = surveyScore && surveyScore.user_score_question ? surveyScore.user_score_question.map(function (userQuestion) {
	          var currentSelfAssessmentQuestion = selfAssessmentQuestions.find(function (selfAssessmentQuestion) {
	            return selfAssessmentQuestion.text.includes(userQuestion.question);
	          });
	          var currentFormAnswer = currentSelfAssessmentQuestion ? selfAnswers.find(function (answer) {
	            return answer.survey_question === currentSelfAssessmentQuestion.id;
	          }) : null;
	          var currentSelfAssessmentValue = currentFormAnswer ? currentFormAnswer.text : null;
	
	          return {
	            question: userQuestion.question,
	            "Team-Assessment": userQuestion.median,
	            "Self-Assessment": currentSelfAssessmentValue !== null ? Number(currentSelfAssessmentValue) : null
	          };
	        }) : [];
	
	        chartData.push({
	          question: 'Overall',
	          "Team-Assessment": surveyScore.median_user_score,
	          "Self-Assessment": Math.round(selfAssessmentAverage * 100) / 100
	        });
	
	        _this2.setState({
	          loaded: true,
	          chartData: chartData.filter(function (i) {
	            return i['Self-Assessment'] !== null;
	          })
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          chartData = _state.chartData;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Overview'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Self-Assessment'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Let\u2019s start with a snapshot of how you evaluate your teamwork skills in relation to your team\u2019s evaluation.  Overall, you rated yourself ',
	            chartData.length ? chartData.at(-1)['Self-Assessment'] : 0,
	            ' out of 5 whereas your team gave you a ',
	            chartData.length ? chartData.at(-1)['Team-Assessment'] : 0,
	            ' rating (i.e. your peer rating score).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please also review your self assessment on each of the following categories below.'
	          )
	        ),
	        _react2.default.createElement(_assessmentChart2.default, { data: chartData })
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return SelfAssessment;
	}(_react.PureComponent);
	
	exports.default = SelfAssessment;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(50);
	
	var _peerFeedbackTeamwordSkills = __webpack_require__(2647);
	
	var _peerFeedbackTeamwordSkills2 = _interopRequireDefault(_peerFeedbackTeamwordSkills);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamworkSkills = function (_PureComponent) {
	  _inherits(TeamworkSkills, _PureComponent);
	
	  function TeamworkSkills() {
	    _classCallCheck(this, TeamworkSkills);
	
	    return _possibleConstructorReturn(this, (TeamworkSkills.__proto__ || Object.getPrototypeOf(TeamworkSkills)).apply(this, arguments));
	  }
	
	  _createClass(TeamworkSkills, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Overview'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Teamwork Skills'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'According to the ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.naceweb.org/talent-acquisition/candidate-selection/the-attributes-employers-seek-on-students-resumes/', target: '_blank', rel: 'noreferrer' },
	              'National Association of Colleges and Employers'
	            ),
	            ', teamwork skills are one of the most important soft skills that employers seek. Therefore, your instructor wants you to be aware of these skills and continuously develop/refine them throughout your college and career journey.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement('img', { src: _peerFeedbackTeamwordSkills2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Let\u2019s walk through some of the teamwork skills that you\u2019ve been demonstrating in this exercise.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamworkSkills;
	}(_react.PureComponent);
	
	exports.default = TeamworkSkills;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 16px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 0 10px;\n\n  &:last-child {\n    justify-content: flex-end;\n  }\n  &:first-child {\n    justify-content: flex-start;\n  }\n"], ["\n  font-family: Lato;\n  font-size: 16px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 0 10px;\n\n  &:last-child {\n    justify-content: flex-end;\n  }\n  &:first-child {\n    justify-content: flex-start;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-align: center;\n\n  h3 {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #36507e;\n  }\n\n  span {\n    color: #74abec;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  display: inline-block;\n  text-align: center;\n\n  h3 {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #36507e;\n  }\n\n  span {\n    color: #74abec;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _peerEvaluationModal = __webpack_require__(256);
	
	var _peerEvaluationModal2 = _interopRequireDefault(_peerEvaluationModal);
	
	var _peerEvaluationFeedback = __webpack_require__(305);
	
	var _peerEvaluationFeedback2 = _interopRequireDefault(_peerEvaluationFeedback);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _sortBy = __webpack_require__(235);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartButton = _styledComponents2.default.div(_templateObject);
	
	var ChartButtonContent = _styledComponents2.default.div(_templateObject2);
	
	var ucFirst = function ucFirst(str) {
	  return str ? str[0].toUpperCase() + str.slice(1) : str;
	};
	
	var ChartViewMore = function (_Component) {
	  _inherits(ChartViewMore, _Component);
	
	  function ChartViewMore(props) {
	    _classCallCheck(this, ChartViewMore);
	
	    var _this = _possibleConstructorReturn(this, (ChartViewMore.__proto__ || Object.getPrototypeOf(ChartViewMore)).call(this, props));
	
	    _this.questionsOrder = function () {
	      var _this$props = _this.props,
	          survey = _this$props.survey,
	          reports = _this$props.reports;
	
	      var questions = reports[survey.stage] ? reports[survey.stage].user_score_question : [];
	
	      var peer_rating_questions = questions.map(function (item, index) {
	        return {
	          id: index + 1,
	          text: item.question,
	          category: 'likert',
	          answer_type: 'rating',
	          value: Math.round(item.median)
	        };
	      });
	
	      var questionsOrder = [{ answer_type: "peer_rating_feedback_intro" }].concat(_toConsumableArray(peer_rating_questions));
	
	      questionsOrder.push({ answer_type: "final_peer_rating_page" });
	
	      _this.setState(function () {
	        return {
	          questionsOrder: questionsOrder,
	          questionsCount: questionsOrder.length - 1,
	          peer_rating_count: peer_rating_questions.length
	        };
	      });
	    };
	
	    _this.isIntroScreen = function (nextPage) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextPage].answer_type;
	
	      return type === "peer_rating_feedback_intro";
	    };
	
	    _this.isFinalScreen = function (nextPage) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextPage].answer_type;
	
	      return type === "final_peer_rating_page";
	    };
	
	    _this.isTransitionScreen = function (nextPage) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextPage].answer_type;
	
	      return type === "transition_page";
	    };
	
	    _this.handleShowModal = function () {
	      _this.setState(function () {
	        return { show: true };
	      });
	    };
	
	    _this.handleHideModal = function () {
	      _this.setState(function (prevState) {
	        return {
	          show: false,
	          currentPage: 0,
	          isIntroScreen: true,
	          isFinalScreen: false,
	          isTransitionScreen: false,
	          submitPages: {},
	          progressBar: prevState.progressBar.map(function (item) {
	            return Object.assign({}, item, { progress: 0 });
	          })
	        };
	      });
	    };
	
	    _this.goToNextPage = function () {
	      var _this$state = _this.state,
	          currentPage = _this$state.currentPage,
	          questionsCount = _this$state.questionsCount,
	          peer_rating_count = _this$state.peer_rating_count;
	
	
	      var nextPage = currentPage + 1;
	      if (nextPage > questionsCount) {
	        nextPage = questionsCount;
	      }
	
	      var isIntroScreen = _this.isIntroScreen(nextPage);
	      var isFinalScreen = _this.isFinalScreen(nextPage);
	      var isTransitionScreen = _this.isTransitionScreen(nextPage);
	
	      _this.setState(function (prevState) {
	        return {
	          currentPage: nextPage,
	          isIntroScreen: isIntroScreen,
	          isFinalScreen: isFinalScreen,
	          isTransitionScreen: isTransitionScreen,
	          progressBar: prevState.progressBar.map(function (item) {
	            return Object.assign({}, item, {
	              progress: Math.min(nextPage / peer_rating_count * 100, 100)
	            });
	          })
	        };
	      });
	    };
	
	    _this.goToPrevPage = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          peer_rating_count = _this$state2.peer_rating_count;
	
	
	      var prevPage = currentPage - 1;
	      if (prevPage < 1) {
	        prevPage = 1;
	      }
	
	      var isIntroScreen = _this.isIntroScreen(prevPage);
	      var isFinalScreen = _this.isFinalScreen(prevPage);
	      var isTransitionScreen = _this.isTransitionScreen(prevPage);
	
	      _this.setState(function (prevState) {
	        return {
	          currentPage: prevPage,
	          isIntroScreen: isIntroScreen,
	          isFinalScreen: isFinalScreen,
	          isTransitionScreen: isTransitionScreen,
	          progressBar: prevState.progressBar.map(function (item) {
	            return Object.assign({}, item, {
	              progress: Math.min(prevPage / peer_rating_count * 100, 100)
	            });
	          })
	        };
	      });
	    };
	
	    _this._isMounted = false;
	
	    var userId = parseInt(_Auth2.default.getUserId(), 10);
	
	    _this.state = {
	      currentUserId: userId,
	      currentTeamId: _Auth2.default.getTeamId(),
	      readonlyMode: true,
	      questionsOrder: [],
	      isIntroScreen: true,
	      isFinalScreen: false,
	      isTransitionScreen: false,
	      currentPage: 0,
	      questionsCount: 0,
	      peer_rating_count: 0,
	      show: false,
	      progressBar: [],
	      teamList: [],
	      submitPages: {}
	    };
	    return _this;
	  }
	
	  _createClass(ChartViewMore, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var progressBar;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this._isMounted = true;
	
	                _context.next = 3;
	                return this.getTeamList();
	
	              case 3:
	                progressBar = [{
	                  id: 1,
	                  title: "Peer Rating",
	                  progress: 0
	                }];
	
	                if (this._isMounted) {
	                  _context.next = 6;
	                  break;
	                }
	
	                return _context.abrupt("return");
	
	              case 6:
	
	                this.setState({
	                  progressBar: progressBar
	                });
	
	              case 7:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: "getTeamList",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var _state, currentUserId, currentTeamId, _ref3, users, teamList;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _state = this.state, currentUserId = _state.currentUserId, currentTeamId = _state.currentTeamId;
	                _context2.next = 3;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/players/?team=" + currentTeamId);
	
	              case 3:
	                _ref3 = _context2.sent;
	                users = _ref3.body;
	                teamList = (0, _sortBy2.default)(users.filter(function (teammate) {
	                  return teammate.role !== 'VI' && teammate.team === currentTeamId && teammate.user && teammate.user.id !== currentUserId;
	                }).map(function (teammate) {
	                  return teammate.user;
	                }), "id").map(function (teammate) {
	                  return {
	                    id: teammate.id,
	                    username: teammate.username,
	                    fullname: teammate.first_name + " " + teammate.last_name
	                  };
	                });
	
	                if (this._isMounted) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                return _context2.abrupt("return");
	
	              case 8:
	
	                this.setState({
	                  teamList: teamList
	                }, function () {
	                  _this2.questionsOrder();
	                });
	
	              case 9:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getTeamList() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getTeamList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var survey = this.props.survey;
	      var _state2 = this.state,
	          show = _state2.show,
	          questionsOrder = _state2.questionsOrder,
	          isIntroScreen = _state2.isIntroScreen,
	          isFinalScreen = _state2.isFinalScreen,
	          isTransitionScreen = _state2.isTransitionScreen,
	          currentPage = _state2.currentPage,
	          progressBar = _state2.progressBar,
	          peer_rating_count = _state2.peer_rating_count,
	          teamList = _state2.teamList,
	          questionsCount = _state2.questionsCount,
	          currentUserId = _state2.currentUserId,
	          submitPages = _state2.submitPages,
	          readonlyMode = _state2.readonlyMode;
	
	
	      var currentQuestion = questionsOrder[currentPage];
	      var hasAnswer = true;
	
	      return _react2.default.createElement(
	        ChartButton,
	        null,
	        _react2.default.createElement(
	          ChartButtonContent,
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            ucFirst(survey.stage),
	            " ",
	            _react2.default.createElement("br", null),
	            " Feedback"
	          ),
	          _react2.default.createElement(
	            "span",
	            { onClick: this.handleShowModal },
	            "View Details >"
	          )
	        ),
	        _react2.default.createElement(
	          _peerEvaluationModal2.default,
	          {
	            surveyId: survey.id,
	            show: show,
	            onHide: this.handleHideModal,
	            onSubmit: this.goToNextPage,
	            progressBar: progressBar,
	            submitButtonText: submitPages[currentPage] ? "Submit" : isIntroScreen ? "Start" : "Save & Continue",
	            currentPage: currentPage ? Number(currentPage) : 0,
	            countOfPages: questionsCount ? Number(questionsCount) : 0,
	            goNext: this.goToNextPage,
	            goPrev: this.goToPrevPage,
	            canSubmit: hasAnswer,
	            isFinalScreen: isFinalScreen,
	            isTransitionScreen: isTransitionScreen,
	            readonlyMode: readonlyMode,
	            linearExtraId: "_peer-review"
	          },
	          !!currentQuestion && _react2.default.createElement(_peerEvaluationFeedback2.default, {
	            question: currentQuestion,
	            answers: [],
	            peer_rating_count: peer_rating_count,
	            teamList: teamList,
	            currentUserId: currentUserId,
	            feedbacks: {},
	            readonlyMode: readonlyMode
	          })
	        )
	      );
	    }
	  }]);
	
	  return ChartViewMore;
	}(_react.Component);
	
	exports.default = ChartViewMore;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 26px;\n  color: #36507e;\n  margin-top: -80px;\n  margin-bottom: 60px;\n"], ["\n  text-align: center;\n  font-size: 26px;\n  color: #36507e;\n  margin-top: -80px;\n  margin-bottom: 60px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"], ["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 10px 40px 25px !important;\n"], ["\n  padding: 10px 40px 25px !important;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"], ["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  padding: 0 !important;\n  height: 75px !important;\n  position: relative;\n"], ["\n  padding: 0 !important;\n  height: 75px !important;\n  position: relative;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 25px;\n  right: 35px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"], ["\n  position: absolute;\n  bottom: 25px;\n  right: 35px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"], ["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"], ["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"], ["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"], ["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  max-width: 530px;\n"], ["\n  max-width: 530px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 25px;\n  right: 195px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"], ["\n  position: absolute;\n  bottom: 25px;\n  right: 195px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(367);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recharts = __webpack_require__(27);
	
	var _index = __webpack_require__(306);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _chartViewMore = __webpack_require__(1283);
	
	var _chartViewMore2 = _interopRequireDefault(_chartViewMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartTitle = _styledComponents2.default.div(_templateObject);
	
	var ButtonsRow = _styledComponents2.default.div(_templateObject2);
	
	var ModalWrapper = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject3);
	
	var ModalHeader = (0, _styledComponents2.default)(_reactBootstrap.Modal.Header)(_templateObject4);
	
	var ModalBody = (0, _styledComponents2.default)(_reactBootstrap.Modal.Body)(_templateObject5);
	
	var ModalTitle = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	});
	
	var ModalQuestion = _styledComponents2.default.div(_templateObject7);
	
	var ModalFeedbackValue = _styledComponents2.default.div(_templateObject8);
	
	var RatingText = _styledComponents2.default.div(_templateObject9);
	
	var RatingRow = _styledComponents2.default.div(_templateObject10);
	
	var ModalFooter = (0, _styledComponents2.default)(_reactBootstrap.Modal.Footer)(_templateObject11);
	
	var ContinueButton = _styledComponents2.default.button(_templateObject12);
	
	var AnswerWrapper = _styledComponents2.default.div(_templateObject13);
	
	var AnswerRow = _styledComponents2.default.div(_templateObject14);
	
	var AnswerCounter = _styledComponents2.default.div(_templateObject15);
	
	var AnswerText = _styledComponents2.default.div(_templateObject16);
	
	var BarChartWrapper = _styledComponents2.default.div(_templateObject17);
	
	var BackButton = _styledComponents2.default.button(_templateObject18);
	
	var getAllValues = function getAllValues(reports) {
	  return Object.values(reports).map(function (report) {
	    return [Number(report.median_user_score.toFixed(2)), Number(report.team_average_score.toFixed(2)), Number(report.team_median_score.toFixed(2))];
	  }).reduce(function (result, currentArray) {
	    return [].concat(_toConsumableArray(result), _toConsumableArray(currentArray));
	  }, []);
	};
	
	var MODAL_TYPE_INITIAL = 0;
	//const MODAL_TYPE_POSITIVE = 1;
	//const MODAL_TYPE_NEGATIVE = 2;
	var MODAL_TYPE_SELF_REFLECTION = 1;
	
	var Chart = function (_Component) {
	  _inherits(Chart, _Component);
	
	  function Chart(props) {
	    _classCallCheck(this, Chart);
	
	    var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props));
	
	    _this.showModal = function (currentReport, stage) {
	      var surveys = _this.props.surveys;
	
	      var currentSurvey = surveys.find(function (survey) {
	        return survey.stage === stage;
	      });
	      _this.setState({
	        currentReport: currentReport,
	        currentSurvey: currentSurvey,
	        currentPage: 0,
	        currentType: MODAL_TYPE_INITIAL
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        currentReport: null,
	        currentSurvey: null
	      });
	    };
	
	    _this.getQuestions = function (currentType) {
	      var _this$state = _this.state,
	          currentReport = _this$state.currentReport,
	          currentSurvey = _this$state.currentSurvey;
	
	
	      if (!currentReport || !currentSurvey) {
	        return [];
	      }
	
	      var questions = [];
	      if (currentType === MODAL_TYPE_INITIAL) {
	        questions = currentReport.average_user_score_question;
	      } /*else if (currentType === MODAL_TYPE_POSITIVE) {
	        const ids = currentSurvey.questions
	          .filter(
	            question =>
	              question.answer_type === "freeform" &&
	              question.category === "communication"
	          )
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        } else if (currentType === MODAL_TYPE_NEGATIVE) {
	        const ids = currentSurvey.questions
	          .filter(
	            question =>
	              question.assessment_type === "negative" &&
	              question.category !== "self_assessment"
	          )
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        }*/else if (currentType === MODAL_TYPE_SELF_REFLECTION) {
	          var ids = currentSurvey.questions.filter(function (question) {
	            return question.category === "self_assessment";
	          }).map(function (question) {
	            return question.id;
	          });
	          questions = currentReport.freeform_answers.filter(function (answer) {
	            return ids.includes(answer.survey_question);
	          });
	        }
	
	      var needSkip = currentSurvey.questions.filter(function (i) {
	        return i.most_valuable === true || i.work_together === true;
	      }).map(function (i) {
	        return i.id;
	      });
	
	      if (currentType !== MODAL_TYPE_INITIAL) {
	        questions = questions.filter(function (i) {
	          return !needSkip.includes(i.survey_question);
	        });
	      }
	
	      return _lodash2.default.chunk(questions, 4);
	    };
	
	    _this.nextPage = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          currentType = _this$state2.currentType;
	
	
	      if (currentPage < _this.questions.length - 1) {
	        _this.setState({
	          currentPage: currentPage + 1
	        });
	      } else if (currentType === 0) {
	        _this.setState({
	          currentPage: 0,
	          currentType: currentType + 1
	        });
	      }
	    };
	
	    _this.goBack = function () {
	      var _this$state3 = _this.state,
	          currentPage = _this$state3.currentPage,
	          currentType = _this$state3.currentType;
	
	
	      if (currentPage > 0) {
	        _this.setState({
	          currentPage: currentPage - 1
	        });
	      } else if (currentType > 0) {
	        var prevQuestions = _this.getQuestions(currentType - 1);
	
	        _this.setState({
	          currentPage: prevQuestions.length - 1,
	          currentType: currentType - 1
	        });
	      }
	    };
	
	    _this.state = {
	      currentSurvey: null,
	      currentReport: null,
	      currentPage: 0,
	      currentType: MODAL_TYPE_INITIAL
	    };
	    return _this;
	  }
	
	  _createClass(Chart, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _reactChartjs.Chart.Tooltip.positioners.custom = function (elements) {
	        if (!elements.length) {
	          return false;
	        }
	
	        var i = void 0,
	            len = void 0;
	        var y = 0;
	        var count = 0;
	        var nearestElement = void 0;
	
	        for (i = 0, len = elements.length; i < len; ++i) {
	          var el = elements[i];
	          if (el && el.hasValue()) {
	            if (!nearestElement) {
	              nearestElement = el;
	            }
	            var pos = el.tooltipPosition();
	            y += pos.y;
	            ++count;
	          }
	        }
	
	        var barOffset = nearestElement ? Math.round(nearestElement.getArea() / 45 + 20) : 0;
	
	        return {
	          x: barOffset + 40,
	          y: Math.round(y / count)
	        };
	      };
	
	      _reactChartjs.Chart.pluginService.register({
	        beforeRender: function beforeRender(chart) {
	          if (chart.config.options.showAllTooltips) {
	            chart.pluginTooltips = [];
	            chart.config.data.datasets.forEach(function (_, i) {
	              chart.getDatasetMeta(i).data.forEach(function (sector, j) {
	                chart.pluginTooltips.push(new _reactChartjs.Chart.Tooltip({
	                  _chart: chart.chart,
	                  _chartInstance: chart,
	                  _data: chart.data,
	                  _options: chart.options.tooltips,
	                  _active: [sector]
	                }, chart));
	              });
	            });
	
	            chart.options.tooltips.enabled = false;
	          }
	        },
	
	        afterDraw: function afterDraw(chart, easing) {
	          if (chart.config.options.showAllTooltips) {
	            if (!chart.allTooltipsOnce) {
	              if (easing !== 1) {
	                return;
	              }
	
	              chart.allTooltipsOnce = true;
	            }
	
	            chart.options.tooltips.enabled = true;
	            _reactChartjs.Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
	              tooltip.initialize();
	              tooltip.update();
	              tooltip.pivot();
	              tooltip.transition(easing).draw();
	            });
	            chart.options.tooltips.enabled = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          reports = _props.reports,
	          isSurveyFinished = _props.isSurveyFinished;
	      var _state = this.state,
	          currentReport = _state.currentReport,
	          currentPage = _state.currentPage,
	          currentType = _state.currentType;
	
	      var allValues = getAllValues(reports);
	      var isBarChart = Object.keys(reports).length === 1 ? true : false;
	      var options = {
	        legend: {
	          display: false
	        },
	        scales: {
	          xAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              min: 0,
	              max: Math.max.apply(null, allValues),
	              callback: function callback() {
	                return "";
	              }
	            }
	          }],
	          yAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              callbacks: function callbacks() {
	                return "";
	              }
	            }
	          }]
	        },
	        tooltips: {
	          enabled: true,
	          mode: "point",
	          position: "custom",
	          backgroundColor: "transparent",
	          bodyFontFamily: "Lato",
	          bodyFontSize: 16,
	          bodyFontStyle: "bold",
	          bodyFontColor: "#2a4169",
	          bodyAlign: "center",
	          displayColors: false,
	          xPadding: 0,
	          yPadding: 0,
	          bodySpacing: 0,
	          callbacks: {
	            title: function title() {
	              return "";
	            },
	            label: function label(tooltipItem) {
	              return (Math.round(tooltipItem.value * 100) / 100).toFixed(2);
	            }
	          }
	        },
	        showAllTooltips: true,
	        layout: {
	          padding: {
	            right: 40
	          }
	        }
	      };
	
	      var getReportForBar = function getReportForBar(key, label, backgroundColor) {
	        return {
	          label: label,
	          data: Object.values(Object.keys(reports).reduce(function (result, stage) {
	            return Object.assign({}, result, _defineProperty({}, stage, Number(reports[stage][key].toFixed(2))));
	          }, {})),
	          backgroundColor: backgroundColor,
	          borderWidth: 0,
	          minBarLength: 20,
	          barPercentage: 0.8,
	          maxBarThickness: 45
	        };
	      };
	
	      var data = {
	        labels: [""],
	        datasets: [getReportForBar("median_user_score", "You", _Teams2.default.currentTeamColor()), getReportForBar("team_average_score", "Team Average", "#eee"), getReportForBar("team_median_score", "Team Median", "#c4c4c4")],
	        options: options
	      };
	      var surveys = this.props.surveys.filter(function (survey) {
	        return isSurveyFinished(survey);
	      });
	      var surveysStages = surveys.map(function (survey) {
	        return survey.stage;
	      });
	      if (surveysStages.length < 3) {
	        for (var i = 0; i < 3 - surveysStages.length; i++) {
	          surveysStages.push("");
	        }
	      }
	
	      var stages = {
	        initial: "Initial Feedback",
	        second: "Second Feedback",
	        final: "Final Feedback"
	      };
	      var tmpData = Object.keys(reports).map(function (stage) {
	        return {
	          name: stages[stage],
	          You: Number(reports[stage].median_user_score.toFixed(2)),
	          "Team Average": Number(reports[stage].team_average_score.toFixed(2)),
	          "Team Median": Number(reports[stage].team_median_score.toFixed(2))
	        };
	      });
	
	      var initial = tmpData.find(function (i) {
	        return i.name === "Initial Feedback";
	      });
	      if (!initial) {
	        initial = {
	          name: "Initial Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var second = tmpData.find(function (i) {
	        return i.name === "Second Feedback";
	      });
	
	      var final = tmpData.find(function (i) {
	        return i.name === "Final Feedback";
	      });
	
	      var chartData = [initial];
	      if (second) {
	        chartData.push(second);
	      }
	      if (final) {
	        chartData.push(final);
	      }
	      var isShowModal = currentReport ? true : false;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          ChartTitle,
	          null,
	          title
	        ),
	        !isBarChart && _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 300 },
	          _react2.default.createElement(
	            _recharts.LineChart,
	            {
	              data: chartData,
	              margin: {
	                top: 0,
	                right: 0,
	                left: 0,
	                bottom: 0
	              }
	            },
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(_recharts.XAxis, {
	              dataKey: "name",
	              padding: { top: 30, left: 30, right: 30, bottom: 30 },
	              hide: true
	            }),
	            _react2.default.createElement(_recharts.YAxis, {
	              hide: true,
	              domain: [Math.min.apply(null, allValues) * 0.9, Math.max.apply(null, allValues) * 1.1]
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "You",
	              stroke: _Teams2.default.currentTeamColor(),
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Average",
	              stroke: "#eee",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Median",
	              stroke: "#c4c4c4",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            })
	          )
	        ),
	        isBarChart && _react2.default.createElement(
	          BarChartWrapper,
	          null,
	          _react2.default.createElement(_reactChartjs.HorizontalBar, { data: data, options: options })
	        ),
	        _react2.default.createElement(
	          ButtonsRow,
	          null,
	          surveys.map(function (survey, index) {
	            return _react2.default.createElement(_chartViewMore2.default, { key: index, survey: survey, reports: reports });
	          })
	        ),
	        isShowModal === true && _react2.default.createElement(
	          ModalWrapper,
	          { show: true, onHide: this.hideModal },
	          _react2.default.createElement(
	            ModalHeader,
	            { closeButton: true },
	            _react2.default.createElement(
	              ModalTitle,
	              { align: "left" },
	              this.modalTitle
	            ),
	            currentType === MODAL_TYPE_INITIAL && _react2.default.createElement(
	              ModalTitle,
	              { align: "right" },
	              "Collaboration"
	            )
	          ),
	          _react2.default.createElement(
	            ModalBody,
	            null,
	            currentType === MODAL_TYPE_INITIAL && this.questionsList.map(function (_ref, i) {
	              var question = _ref.question,
	                  rating = _ref.value;
	              return _react2.default.createElement(
	                "div",
	                { key: currentType + "-" + (currentPage * 4 + i + 1) },
	                _react2.default.createElement(
	                  ModalQuestion,
	                  null,
	                  currentPage * 4 + i + 1,
	                  ". ",
	                  question
	                ),
	                _react2.default.createElement(
	                  RatingRow,
	                  null,
	                  _react2.default.createElement(
	                    ModalFeedbackValue,
	                    null,
	                    Number(rating.toFixed(2))
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      RatingText,
	                      null,
	                      "Average Rating"
	                    ),
	                    _react2.default.createElement(_index2.default, { value: rating })
	                  )
	                )
	              );
	            }),
	            currentType !== MODAL_TYPE_INITIAL && _react2.default.createElement(
	              AnswerWrapper,
	              null,
	              this.questionsList.map(function (_ref2, i) {
	                var text = _ref2.text;
	                return _react2.default.createElement(
	                  AnswerRow,
	                  {
	                    key: currentType + "-" + (currentPage * 4 + i + 1)
	                  },
	                  _react2.default.createElement(
	                    AnswerCounter,
	                    null,
	                    currentPage * 4 + i + 1
	                  ),
	                  _react2.default.createElement(
	                    AnswerText,
	                    null,
	                    text
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            ModalFooter,
	            null,
	            !this.isFirstPage && _react2.default.createElement(
	              BackButton,
	              { onClick: this.goBack },
	              _react2.default.createElement(
	                "span",
	                { className: "small" },
	                "\u25C0"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Back"
	              )
	            ),
	            _react2.default.createElement(
	              ContinueButton,
	              {
	                onClick: this.isLastPage ? this.hideModal : this.nextPage
	              },
	              _react2.default.createElement(
	                "span",
	                null,
	                this.isLastPage ? "Close" : "Continue"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "small" },
	                "\u25B6"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "questions",
	    get: function get() {
	      var currentType = this.state.currentType;
	
	
	      return this.getQuestions(currentType);
	    }
	  }, {
	    key: "questionsList",
	    get: function get() {
	      var currentPage = this.state.currentPage;
	
	      var questions = this.questions;
	      var result = currentPage < questions.length ? questions[currentPage] : [];
	      var team = _Teams2.default.currentTeam();
	      var players = _Teams2.default.players();
	      var teammates = players.filter(function (player) {
	        return player.team === team.id && player.user.id !== parseInt(_Auth2.default.getUserId(), 10);
	      }).map(function (teammate) {
	        return teammate.user.username;
	      });
	
	      return result.filter(function (answer) {
	        return !teammates.includes(answer.text);
	      });
	    }
	  }, {
	    key: "isFirstPage",
	    get: function get() {
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          currentType = _state2.currentType;
	
	
	      return currentPage === 0 && currentType === MODAL_TYPE_INITIAL ? true : false;
	    }
	  }, {
	    key: "isLastPage",
	    get: function get() {
	      var _state3 = this.state,
	          currentPage = _state3.currentPage,
	          currentType = _state3.currentType;
	
	
	      if (currentPage === this.questions.length - 1) {
	        if (currentType === 0) {
	          var nextQuestions = this.getQuestions(currentType + 1);
	
	          if (nextQuestions.length === 0) {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "modalTitle",
	    get: function get() {
	      var _titles;
	
	      var currentType = this.state.currentType;
	
	      var titles = (_titles = {}, _defineProperty(_titles, MODAL_TYPE_INITIAL, "Initial Feedback"), _defineProperty(_titles, MODAL_TYPE_SELF_REFLECTION, "Self Reflection"), _titles);
	
	      return titles[currentType];
	    }
	  }]);
	
	  return Chart;
	}(_react.Component);
	
	exports.default = Chart;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 20px 40px !important;\n  max-width: 1180px;\n  background-color: hsla(0, 0%, 98%, 1);\n  box-sizing: content-box;\n"], ["\n  width: 100%;\n  padding: 20px 40px !important;\n  max-width: 1180px;\n  background-color: hsla(0, 0%, 98%, 1);\n  box-sizing: content-box;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 21px;\n  font-weight: 600;\n  color: lightgray;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-size: 21px;\n  font-weight: 600;\n  color: lightgray;\n\n  ", "\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  padding: 30px 0;\n  display: flex;\n  align-items: center;\n"], ["\n  padding: 30px 0;\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  margin-right: 15px;\n\n  ", "\n"], ["\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  margin-right: 15px;\n\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 24px;\n  font-weight: 700;\n  color: #5f5f5f;\n"], ["\n  font-family: Lato;\n  font-size: 24px;\n  font-weight: 700;\n  color: #5f5f5f;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: hsla(0, 0%, 100%, 1);\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n"], ["\n  width: 100%;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: hsla(0, 0%, 100%, 1);\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: hsla(213, 100%, 12%, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: hsla(213, 100%, 12%, 0.94);\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr);\n  gap: 20px;\n  margin-top: 20px;\n  font-family: 'Mukta Vaani', sans-serif;\n"], ["\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr);\n  gap: 20px;\n  margin-top: 20px;\n  font-family: 'Mukta Vaani', sans-serif;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 12px;\n  padding: 28px 32px;\n"], ["\n  background: #ffffff;\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 12px;\n  padding: 28px 32px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  margin-bottom: 24px;\n"], ["\n  font-size: 22px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  margin-bottom: 24px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n"], ["\n  font-size: 22px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  padding: 4px;\n  background: hsla(213, 100%, 12%, 0.06);\n  border-radius: 8px;\n  gap: 2px;\n"], ["\n  display: inline-flex;\n  padding: 4px;\n  background: hsla(213, 100%, 12%, 0.06);\n  border-radius: 8px;\n  gap: 2px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  padding: 6px 14px;\n  border: 0;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  &:hover {\n    color: hsla(213, 100%, 12%, 0.94);\n  }\n"], ["\n  padding: 6px 14px;\n  border: 0;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  &:hover {\n    color: hsla(213, 100%, 12%, 0.94);\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: hsla(213, 100%, 12%, 0.6);\n  text-transform: uppercase;\n  margin-bottom: 4px;\n"], ["\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: hsla(213, 100%, 12%, 0.6);\n  text-transform: uppercase;\n  margin-bottom: 4px;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin-bottom: 14px;\n"], ["\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin-bottom: 14px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  font-size: 56px;\n  font-weight: 700;\n  line-height: 1;\n  color: #2AB3AF;\n"], ["\n  font-size: 56px;\n  font-weight: 700;\n  line-height: 1;\n  color: #2AB3AF;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 500;\n  color: hsla(213, 100%, 12%, 0.5);\n"], ["\n  font-size: 22px;\n  font-weight: 500;\n  color: hsla(213, 100%, 12%, 0.5);\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: hsla(151, 55%, 92%, 1);\n  color: hsl(151, 60%, 30%);\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 18px;\n\n  &::before {\n    content: '\u25B2';\n    font-size: 10px;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: hsla(151, 55%, 92%, 1);\n  color: hsl(151, 60%, 30%);\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 18px;\n\n  &::before {\n    content: '\u25B2';\n    font-size: 10px;\n  }\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  line-height: 22px;\n  color: hsla(213, 100%, 12%, 0.78);\n  margin: 0 0 20px;\n"], ["\n  font-size: 15px;\n  line-height: 22px;\n  color: hsla(213, 100%, 12%, 0.78);\n  margin: 0 0 20px;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 15px;\n  color: hsla(213, 100%, 12%, 0.86);\n\n  &:not(:last-child) {\n    border-bottom: 1px solid hsla(213, 100%, 12%, 0.06);\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 15px;\n  color: hsla(213, 100%, 12%, 0.86);\n\n  &:not(:last-child) {\n    border-bottom: 1px solid hsla(213, 100%, 12%, 0.06);\n  }\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: ", ";\n  }\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 40px;\n  margin: 24px 0;\n"], ["\n  display: flex;\n  gap: 40px;\n  margin: 24px 0;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  font-size: 32px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  line-height: 1;\n"], ["\n  font-size: 32px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  line-height: 1;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: hsla(213, 100%, 12%, 0.6);\n  margin-top: 4px;\n"], ["\n  font-size: 14px;\n  color: hsla(213, 100%, 12%, 0.6);\n  margin-top: 4px;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 22px;\n  background: #2AB3AF;\n  color: #ffffff;\n  border: 1px solid #2AB3AF;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n\n  &:hover { background: #23918d; border-color: #23918d; }\n\n  &:disabled {\n    background: hsla(213, 100%, 12%, 0.06);\n    color: hsla(213, 100%, 12%, 0.4);\n    border-color: hsla(213, 100%, 12%, 0.1);\n    cursor: default;\n  }\n\n  &::before {\n    content: '\u25CF';\n    font-size: 10px;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 22px;\n  background: #2AB3AF;\n  color: #ffffff;\n  border: 1px solid #2AB3AF;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n\n  &:hover { background: #23918d; border-color: #23918d; }\n\n  &:disabled {\n    background: hsla(213, 100%, 12%, 0.06);\n    color: hsla(213, 100%, 12%, 0.4);\n    border-color: hsla(213, 100%, 12%, 0.1);\n    cursor: default;\n  }\n\n  &::before {\n    content: '\u25CF';\n    font-size: 10px;\n  }\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1500;\n  padding: 24px;\n"], ["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1500;\n  padding: 24px;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);\n  width: 100%;\n  max-width: 1120px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: 'Mukta Vaani', sans-serif;\n"], ["\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);\n  width: 100%;\n  max-width: 1120px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: 'Mukta Vaani', sans-serif;\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  padding: 24px 32px 16px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid hsla(213, 100%, 12%, 0.08);\n"], ["\n  padding: 24px 32px 16px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid hsla(213, 100%, 12%, 0.08);\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n"], ["\n  flex: 1 1 auto;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: hsla(213, 100%, 12%, 0.94);\n  margin: 0 0 6px;\n"], ["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: hsla(213, 100%, 12%, 0.94);\n  margin: 0 0 6px;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  line-height: 22px;\n  color: hsla(213, 100%, 12%, 0.6);\n  margin: 0;\n"], ["\n  font-size: 15px;\n  line-height: 22px;\n  color: hsla(213, 100%, 12%, 0.6);\n  margin: 0;\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  background: #ffffff;\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: hsla(213, 100%, 12%, 0.6);\n  font-size: 20px;\n  line-height: 1;\n\n  &:hover { background: hsla(213, 100%, 12%, 0.04); }\n"], ["\n  flex: 0 0 auto;\n  background: #ffffff;\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: hsla(213, 100%, 12%, 0.6);\n  font-size: 20px;\n  line-height: 1;\n\n  &:hover { background: hsla(213, 100%, 12%, 0.04); }\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  padding: 16px 32px 0;\n  display: flex;\n  gap: 4px;\n"], ["\n  padding: 16px 32px 0;\n  display: flex;\n  gap: 4px;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  color: ", ";\n  cursor: pointer;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  padding: 24px 32px 32px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n"], ["\n  padding: 24px 32px 32px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: ", ";\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 700;\n"], ["\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: ", ";\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 700;\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  line-height: 22px;\n"], ["\n  font-size: 18px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  line-height: 22px;\n"]),
	    _templateObject43 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: hsla(213, 100%, 12%, 0.6);\n  line-height: 20px;\n"], ["\n  font-size: 14px;\n  color: hsla(213, 100%, 12%, 0.6);\n  line-height: 20px;\n"]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid hsla(213, 100%, 12%, 0.08);\n  border-left: 3px solid ", ";\n  border-radius: 8px;\n  padding: 16px 18px;\n  margin-bottom: 12px;\n"], ["\n  background: #ffffff;\n  border: 1px solid hsla(213, 100%, 12%, 0.08);\n  border-left: 3px solid ", ";\n  border-radius: 8px;\n  padding: 16px 18px;\n  margin-bottom: 12px;\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  line-height: 22px;\n  color: hsla(213, 100%, 12%, 0.86);\n"], ["\n  font-size: 15px;\n  line-height: 22px;\n  color: hsla(213, 100%, 12%, 0.86);\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: hsla(213, 100%, 12%, 0.55);\n  font-weight: 500;\n"], ["\n  font-size: 13px;\n  color: hsla(213, 100%, 12%, 0.55);\n  font-weight: 500;\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  margin-top: 16px;\n  border-bottom: 1px solid hsla(213, 100%, 12%, 0.15);\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin-top: 16px;\n  border-bottom: 1px solid hsla(213, 100%, 12%, 0.15);\n"]),
	    _templateObject48 = _taggedTemplateLiteral(["\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: hsla(0, 0%, 100%, 1);\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n"], ["\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: hsla(0, 0%, 100%, 1);\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n"]),
	    _templateObject49 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #3A507B;\n  margin-top: 18px;\n"], ["\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #3A507B;\n  margin-top: 18px;\n"]),
	    _templateObject50 = _taggedTemplateLiteral(["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  max-height: 450px;\n  position: relative;\n  z-index: 1;\n"], ["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  max-height: 450px;\n  position: relative;\n  z-index: 1;\n"]),
	    _templateObject51 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 0 20px;\n\n  ", "\n  img {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  padding: 0 20px;\n\n  ", "\n  img {\n    cursor: pointer;\n  }\n"]),
	    _templateObject52 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  padding: 15px 20px;\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  padding: 15px 20px;\n\n  ", "\n  ", "\n\n  ", "\n"]),
	    _templateObject53 = _taggedTemplateLiteral(["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  z-index: 1;\n\n  ", "\n"], ["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  z-index: 1;\n\n  ", "\n"]),
	    _templateObject54 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n"], ["\n  display: flex;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n"]),
	    _templateObject55 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"]),
	    _templateObject56 = _taggedTemplateLiteral(["\n  height: 10px;\n  width: 40px;\n  margin-right: 10px;\n\n  ", "\n"], ["\n  height: 10px;\n  width: 40px;\n  margin-right: 10px;\n\n  ", "\n"]),
	    _templateObject57 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #36507e;\n"], ["\n  font-size: 14px;\n  color: #36507e;\n"]),
	    _templateObject58 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
	    _templateObject59 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n  gap: 20px;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n  gap: 20px;\n"]),
	    _templateObject60 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n  margin-top: 20px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n  margin-top: 20px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject61 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  margin-top: 8px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  margin-top: 8px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject62 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n"]),
	    _templateObject63 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  padding: 1px 8px;\n  border-radius: 2px;\n  border: 1px solid rgba(0, 27, 59, 0.15);\n  color: #5c91f5;\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  padding: 1px 8px;\n  border-radius: 2px;\n  border: 1px solid rgba(0, 27, 59, 0.15);\n  color: #5c91f5;\n"]),
	    _templateObject64 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject65 = _taggedTemplateLiteral([""], [""]),
	    _templateObject66 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject67 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n"]),
	    _templateObject68 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #6fd1d9;\n  background: rgba(82, 197, 205, 0.5);\n  border-radius: 4px;\n"], ["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #6fd1d9;\n  background: rgba(82, 197, 205, 0.5);\n  border-radius: 4px;\n"]),
	    _templateObject69 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #fd9595;\n  background: rgba(255, 153, 102, 0.5);\n  border-radius: 4px;\n"], ["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #fd9595;\n  background: rgba(255, 153, 102, 0.5);\n  border-radius: 4px;\n"]),
	    _templateObject70 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #2a4169;\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #2a4169;\n"]),
	    _templateObject71 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  margin-top: 16px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject72 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex-wrap: wrap;\n"], ["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex-wrap: wrap;\n"]),
	    _templateObject73 = _taggedTemplateLiteral(["\n  padding: 1px 8px;\n  background: #fff;\n  border: 1.5px solid #2a4169;\n  border-radius: 4px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #2a4169;\n"], ["\n  padding: 1px 8px;\n  background: #fff;\n  border: 1.5px solid #2a4169;\n  border-radius: 4px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #2a4169;\n"]),
	    _templateObject74 = _taggedTemplateLiteral(["\n  max-width: 560px;\n  margin-top: 20px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    font-weight: 700;\n  }\n"], ["\n  max-width: 560px;\n  margin-top: 20px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    font-weight: 700;\n  }\n"]),
	    _templateObject75 = _taggedTemplateLiteral(["\n  background: rgba(0, 27, 43, 0.02);\n\n  .recharts-legend-item-text {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .recharts-legend-item {\n    display: block !important;\n    margin: 0 !important;\n\n    svg {\n      margin-right: 12px !important;\n\n      line {\n        stroke-width: 2;\n      }\n    }\n  }\n\n  .recharts-polar-angle-axis-tick-value {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    fill: rgba(0, 27, 59, 0.6);\n\n    &:hover, &.recharts-polar-angle-axis-tick-value-selected {\n      font-weight: 700;\n      fill: rgba(0, 27, 59, 0.94);\n      cursor: pointer;\n    }\n  }\n\n  .recharts-polar-angle-axis-ticks {\n    transform: translateY(5px);\n  }\n"], ["\n  background: rgba(0, 27, 43, 0.02);\n\n  .recharts-legend-item-text {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .recharts-legend-item {\n    display: block !important;\n    margin: 0 !important;\n\n    svg {\n      margin-right: 12px !important;\n\n      line {\n        stroke-width: 2;\n      }\n    }\n  }\n\n  .recharts-polar-angle-axis-tick-value {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    fill: rgba(0, 27, 59, 0.6);\n\n    &:hover, &.recharts-polar-angle-axis-tick-value-selected {\n      font-weight: 700;\n      fill: rgba(0, 27, 59, 0.94);\n      cursor: pointer;\n    }\n  }\n\n  .recharts-polar-angle-axis-ticks {\n    transform: translateY(5px);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _performance = __webpack_require__(1286);
	
	var _performance2 = _interopRequireDefault(_performance);
	
	var _chart = __webpack_require__(1284);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _ApiService = __webpack_require__(4);
	
	var _InFlightDedup = __webpack_require__(393);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _get2 = __webpack_require__(133);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _peerEvaluation = __webpack_require__(588);
	
	var _peerEvaluation2 = _interopRequireDefault(_peerEvaluation);
	
	var _iconLock = __webpack_require__(333);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	var _recharts = __webpack_require__(27);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// profile components
	var Profile = {};
	
	Profile.Wrapper = _styledComponents2.default.section(_templateObject);
	
	Profile.CardWrapper = _styledComponents2.default.div(_templateObject2);
	
	Profile.Title = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.marginTop && "\n    margin-top: " + p.marginTop + ";\n  ";
	});
	
	// evaluation form components
	var EvaluationForm = {};
	
	EvaluationForm.Wrapper = _styledComponents2.default.div(_templateObject4);
	
	EvaluationForm.Circle = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	EvaluationForm.Title = _styledComponents2.default.div(_templateObject6);
	
	// performance components
	var Performance = {};
	
	Performance.Wrapper = _styledComponents2.default.div(_templateObject7);
	
	Performance.Title = _styledComponents2.default.div(_templateObject8);
	
	// -----------------------------------------------------------------
	// Peer-rating summary + teammates-said grid.
	// Replaces the old "Performance Summary" block. Hardcoded values for
	// now — will be wired to real data (average, median, comment counts,
	// feedback strings) in a follow-up once the BE endpoints are ready.
	// -----------------------------------------------------------------
	var Summary = {};
	
	Summary.Grid = _styledComponents2.default.div(_templateObject9);
	
	Summary.Card = _styledComponents2.default.div(_templateObject10);
	
	Summary.SectionTitle = _styledComponents2.default.div(_templateObject11);
	
	Summary.TitleRow = _styledComponents2.default.div(_templateObject12);
	
	Summary.TitleRowTitle = _styledComponents2.default.div(_templateObject13);
	
	Summary.Toggle = _styledComponents2.default.div(_templateObject14);
	
	Summary.ToggleButton = _styledComponents2.default.button(_templateObject15, function (p) {
	  return p.active ? '#ffffff' : 'transparent';
	}, function (p) {
	  return p.active ? 'hsla(213, 100%, 12%, 0.94)' : 'hsla(213, 100%, 12%, 0.6)';
	}, function (p) {
	  return p.active ? '0 1px 2px rgba(0, 0, 0, 0.08)' : 'none';
	});
	
	Summary.RatingLabel = _styledComponents2.default.div(_templateObject16);
	
	Summary.RatingValueRow = _styledComponents2.default.div(_templateObject17);
	
	Summary.RatingValue = _styledComponents2.default.span(_templateObject18);
	
	Summary.RatingDenom = _styledComponents2.default.span(_templateObject19);
	
	Summary.DeltaChip = _styledComponents2.default.div(_templateObject20);
	
	Summary.Blurb = _styledComponents2.default.p(_templateObject21);
	
	Summary.BreakdownRow = _styledComponents2.default.div(_templateObject22);
	
	Summary.BreakdownLabel = _styledComponents2.default.span(_templateObject23, function (p) {
	  return p.dotColor || '#c4c4c4';
	});
	
	Summary.BreakdownValue = _styledComponents2.default.span(_templateObject24);
	
	Summary.StatsRow = _styledComponents2.default.div(_templateObject25);
	
	Summary.Stat = _styledComponents2.default.div(_templateObject26);
	
	Summary.StatValue = _styledComponents2.default.span(_templateObject27);
	
	Summary.StatLabel = _styledComponents2.default.span(_templateObject28);
	
	Summary.FeedbackButton = _styledComponents2.default.button(_templateObject29);
	
	// -----------------------------------------------------------------
	// Feedback modal — appears when "View feedback" is clicked. Two-tab
	// (Final / Initial) with two columns per tab (What they appreciate /
	// Room to grow). Hardcoded quotes for now — will be wired to a BE
	// endpoint in a follow-up.
	// -----------------------------------------------------------------
	var Feedback = {};
	
	Feedback.Backdrop = _styledComponents2.default.div(_templateObject30);
	
	Feedback.Card = _styledComponents2.default.div(_templateObject31);
	
	Feedback.Header = _styledComponents2.default.div(_templateObject32);
	
	Feedback.HeaderText = _styledComponents2.default.div(_templateObject33);
	
	Feedback.Title = _styledComponents2.default.h2(_templateObject34);
	
	Feedback.Subtitle = _styledComponents2.default.p(_templateObject35);
	
	Feedback.Close = _styledComponents2.default.button(_templateObject36);
	
	Feedback.TabRow = _styledComponents2.default.div(_templateObject37);
	
	Feedback.Tab = _styledComponents2.default.button(_templateObject38, function (p) {
	  return p.active ? '#ffffff' : 'hsla(213, 100%, 12%, 0.04)';
	}, function (p) {
	  return p.active ? 'hsla(213, 100%, 12%, 0.15)' : 'transparent';
	}, function (p) {
	  return p.active ? 'hsla(213, 100%, 12%, 0.94)' : 'hsla(213, 100%, 12%, 0.6)';
	});
	
	Feedback.Body = _styledComponents2.default.div(_templateObject39);
	
	Feedback.ColumnHeader = _styledComponents2.default.div(_templateObject40);
	
	Feedback.ColumnIcon = _styledComponents2.default.div(_templateObject41, function (p) {
	  return p.background || '#e5e5e5';
	}, function (p) {
	  return p.color || '#ffffff';
	});
	
	Feedback.ColumnLabel = _styledComponents2.default.div(_templateObject26);
	
	Feedback.ColumnTitle = _styledComponents2.default.div(_templateObject42);
	
	Feedback.ColumnSubtitle = _styledComponents2.default.div(_templateObject43);
	
	Feedback.QuoteCard = _styledComponents2.default.div(_templateObject44, function (p) {
	  return p.accent || '#e5e5e5';
	});
	
	Feedback.QuoteText = _styledComponents2.default.div(_templateObject45);
	
	Feedback.QuoteAttrib = _styledComponents2.default.div(_templateObject46);
	
	Performance.Menu = _styledComponents2.default.div(_templateObject47);
	
	var LockScreen = {};
	LockScreen.Wrapper = _styledComponents2.default.div(_templateObject48);
	LockScreen.Text = _styledComponents2.default.div(_templateObject49);
	
	// table components
	
	var Table = {};
	
	Table.Wrapper = _styledComponents2.default.div(_templateObject50);
	
	Table.Row = _styledComponents2.default.div(_templateObject51, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Table.Column = _styledComponents2.default.div(_templateObject52, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	}, function (p) {
	  return p.width && "\n    flex: 0 0 " + p.width + ";\n  ";
	}, function (p) {
	  return p.isValue && "\n    font-weight: 500;\n  ";
	});
	
	// charts components
	var Charts = {};
	
	Charts.Wrapper = _styledComponents2.default.div(_templateObject53, function (p) {
	  return p.setMaxHeight && "\n    max-height: 450px;\n  ";
	});
	
	Charts.Teams = {};
	
	Charts.Teams.Wrapper = _styledComponents2.default.div(_templateObject54);
	
	Charts.Teams.Row = _styledComponents2.default.div(_templateObject55, function (p) {
	  return p.margin && "\n    margin: " + p.margin + ";\n  ";
	});
	
	Charts.Teams.TeamColor = _styledComponents2.default.div(_templateObject56, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Charts.Teams.TeamName = _styledComponents2.default.div(_templateObject57);
	
	Charts.Chart = _styledComponents2.default.div(_templateObject58);
	
	var SkillsAssessment = {};
	
	SkillsAssessment.Wrapper = _styledComponents2.default.div(_templateObject59);
	
	SkillsAssessment.InfoTitle = _styledComponents2.default.div(_templateObject60);
	
	SkillsAssessment.InfoBody = _styledComponents2.default.div(_templateObject61);
	
	SkillsAssessment.TagWrapper = _styledComponents2.default.div(_templateObject62);
	
	SkillsAssessment.Tag = _styledComponents2.default.div(_templateObject63);
	
	SkillsAssessment.TagTitle = _styledComponents2.default.div(_templateObject64);
	
	SkillsAssessment.SkillsMap = _styledComponents2.default.div(_templateObject65);
	
	SkillsAssessment.SkillsMapTitle = _styledComponents2.default.div(_templateObject66);
	
	SkillsAssessment.SkillsMapBody = _styledComponents2.default.div(_templateObject67);
	
	SkillsAssessment.MintSection = _styledComponents2.default.div(_templateObject68);
	
	SkillsAssessment.OrangeSection = _styledComponents2.default.div(_templateObject69);
	
	SkillsAssessment.ColorSectionTitle = _styledComponents2.default.div(_templateObject70);
	
	SkillsAssessment.ColorSectionBody = _styledComponents2.default.div(_templateObject71);
	
	SkillsAssessment.ColorSectionTags = _styledComponents2.default.div(_templateObject72);
	
	SkillsAssessment.ColorSectionTag = _styledComponents2.default.div(_templateObject73);
	
	SkillsAssessment.ChartDescription = _styledComponents2.default.div(_templateObject74);
	
	SkillsAssessment.RadarChartWrapper = _styledComponents2.default.div(_templateObject75);
	
	var PeerReview = function (_React$Component) {
	  _inherits(PeerReview, _React$Component);
	
	  function PeerReview(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, PeerReview);
	
	    var _this = _possibleConstructorReturn(this, (PeerReview.__proto__ || Object.getPrototypeOf(PeerReview)).call(this, props));
	
	    _this.openFeedbackModal = function () {
	      return _this.setState({ feedbackModalOpen: true });
	    };
	
	    _this.closeFeedbackModal = function () {
	      return _this.setState({ feedbackModalOpen: false });
	    };
	
	    _this.getSkillsAssessmentDefinitions = function (survey) {
	      var definitions = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = survey.questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var question = _step.value;
	
	          definitions = definitions.concat(question.statements);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return definitions.map(function (d) {
	        return d.student_category || null;
	      }).filter(function (d) {
	        return !!d;
	      }).reduce(function (obj, item) {
	        return Object.assign({}, obj, _defineProperty({}, item.name, item.definition));
	      }, {});
	    };
	
	    _this._waitForCourseId = function () {
	      return new Promise(function (resolve) {
	        var elapsed = 0;
	        var check = function check() {
	          var id = _Auth2.default.getCourseId();
	          if (id) return resolve(id);
	          elapsed += 100;
	          if (elapsed >= 5000) return resolve(0);
	          setTimeout(check, 100);
	        };
	        check();
	      });
	    };
	
	    _this.fetchUserScores = function (finishedSurveys) {
	      var peerEvalSurveys = (finishedSurveys || []).filter(function (s) {
	        return s && (s.stage === 'initial' || s.stage === 'final');
	      });
	      if (peerEvalSurveys.length === 0) return;
	      var userId = _Auth2.default.getUserId();
	      if (!userId) return;
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      Promise.all(peerEvalSurveys.map(function (s) {
	        return (0, _ApiService.getRequest)(apiUrl + "v2/forms/surveys/" + s.id + "/user-score/" + userId + "/").then(function (res) {
	          return { id: s.id, body: res && res.body || null };
	        }).catch(function () {
	          return { id: s.id, body: null };
	        });
	      })).then(function (results) {
	        var userScores = {};
	        results.forEach(function (r) {
	          if (r.body) userScores[r.id] = r.body;
	        });
	        var finalSurvey = peerEvalSurveys.find(function (s) {
	          return s.stage === 'final';
	        });
	        var initialSurvey = peerEvalSurveys.find(function (s) {
	          return s.stage === 'initial';
	        });
	        var selectedSurveyId = finalSurvey && userScores[finalSurvey.id] ? finalSurvey.id : initialSurvey && userScores[initialSurvey.id] ? initialSurvey.id : null;
	        _this.setState({ userScores: userScores, selectedSurveyId: selectedSurveyId });
	      });
	    };
	
	    _this.selectSurveyById = function (surveyId) {
	      _this.setState({ selectedSurveyId: surveyId });
	    };
	
	    _this.fetchInsights = function (finishedSurveys) {
	      var peerEvalSurveys = (finishedSurveys || []).filter(function (s) {
	        return s && (s.stage === 'initial' || s.stage === 'final');
	      });
	      if (peerEvalSurveys.length === 0) return;
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      Promise.all(peerEvalSurveys.map(function (s) {
	        return (0, _ApiService.getRequest)(apiUrl + "v2/insights/mine/" + s.id + "/").then(function (res) {
	          return { id: s.id, body: res && res.body || null };
	        }).catch(function () {
	          return { id: s.id, body: null };
	        });
	      })).then(function (results) {
	        var insights = {};
	        results.forEach(function (r) {
	          insights[r.id] = r.body;
	        });
	        _this.setState({ insights: insights });
	      });
	    };
	
	    _this.isSurveyFinished = function (survey) {
	      var surveyEndDate = (0, _moment2.default)(survey.end);
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isAfter(surveyEndDate);
	    };
	
	    _this.loadReport = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref, receiver_id) {
	        var survey_id = _ref.id,
	            stage = _ref.stage;
	
	        var _ref3, report, reports;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(survey_id && Number(survey_id) > 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/score/" + receiver_id + "/" + survey_id + "/");
	
	              case 4:
	                _ref3 = _context.sent;
	                report = _ref3.body;
	                reports = _this.state.reports;
	
	
	                _this.setState({
	                  reports: Object.assign({}, reports, _defineProperty({}, stage, report))
	                });
	                _context.next = 12;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context["catch"](1);
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 10]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.handleShowTab = function (id) {
	      var performance = _this.state.performance.map(function (tab) {
	        return tab.id === id ? Object.assign({}, tab, { isActive: true }) : Object.assign({}, tab, { isActive: false });
	      });
	
	      _this.setState({
	        performance: performance
	      });
	    };
	
	    _this.getGradingValue = function (number, is_finished) {
	      var grading = _this.state.grading;
	
	
	      if (is_finished === true && number in grading) {
	        return (grading[number] * 100).toFixed(2) + "%";
	      }
	
	      return "-----";
	    };
	
	    _this.skillsAssessmentDescription = function (showSkillsAssessmentData) {
	      return showSkillsAssessmentData === true ? 'view results' : '---';
	    };
	
	    _this.skillsAssessmentStrengthsCategories = function (key) {
	      var skillsAssessmentRating = _this.state.skillsAssessmentRating;
	
	
	      if (key === '') {
	        return [];
	      }
	
	      if (key === 'initial') {
	        return skillsAssessmentRating.length > 0 ? Object.entries(skillsAssessmentRating[0]).filter(function (i) {
	          return i[1] >= 0.7;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      if (key === 'second') {
	        return skillsAssessmentRating.length > 1 ? Object.entries(skillsAssessmentRating[1]).filter(function (i) {
	          return i[1] >= 0.7;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      return skillsAssessmentRating.length > 2 ? Object.entries(skillsAssessmentRating[2]).filter(function (i) {
	        return i[1] >= 0.7;
	      }).map(function (i) {
	        return i[0];
	      }) : [];
	    };
	
	    _this.skillsAssessmentAreasOfDevelopmentCategories = function (key) {
	      var skillsAssessmentRating = _this.state.skillsAssessmentRating;
	
	
	      if (key === '') {
	        return [];
	      }
	
	      if (key === 'initial') {
	        return skillsAssessmentRating.length > 0 ? Object.entries(skillsAssessmentRating[0]).filter(function (i) {
	          return i[1] <= 0.3;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      if (key === 'second') {
	        return skillsAssessmentRating.length > 1 ? Object.entries(skillsAssessmentRating[1]).filter(function (i) {
	          return i[1] <= 0.3;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      return skillsAssessmentRating.length > 2 ? Object.entries(skillsAssessmentRating[2]).filter(function (i) {
	        return i[1] <= 0.3;
	      }).map(function (i) {
	        return i[0];
	      }) : [];
	    };
	
	    _this.sortSurveys = function (surveys) {
	      // Stage-first ordering: Initial peer eval on the left, Final on
	      // the right. Anything else (unknown stage) sorts last with a
	      // stable index tiebreak so relative order is preserved.
	      var stageOrder = { initial: 0, final: 1 };
	      return (Array.isArray(surveys) ? surveys : []).map(function (s, i) {
	        return { s: s, i: i };
	      }).sort(function (a, b) {
	        var aStage = String(a.s && a.s.stage || '').toLowerCase();
	        var bStage = String(b.s && b.s.stage || '').toLowerCase();
	        var ao = stageOrder[aStage] != null ? stageOrder[aStage] : 2;
	        var bo = stageOrder[bStage] != null ? stageOrder[bStage] : 2;
	        if (ao !== bo) return ao - bo;
	        return a.i - b.i;
	      }).map(function (x) {
	        return x.s;
	      });
	    };
	
	    _this.isSurveyEnded = function (survey) {
	      var endDate = (0, _moment2.default)(survey.end);
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isSameOrAfter(endDate);
	    };
	
	    _this.getCurrentUserId = function () {
	      return _Auth2.default.getUserId();
	    };
	
	    _this.skillsAssessmentChartData = function (showSkillsAssessmentData) {
	      var skillsAssessmentRating = _this.state.skillsAssessmentRating;
	
	      var result = [];
	      var hasSecond = false;
	      var hasFinal = false;
	      var defaultData = {
	        Organized: 0.7,
	        Communicative: 0.75,
	        Creative: 0.57,
	        Inquisitive: 0.3,
	        Accountable: 0.48,
	        Analytical: 0.38,
	        Decisive: 0.63,
	        Supportive: 0.9
	      };
	
	      if (skillsAssessmentRating && skillsAssessmentRating.length > 0) {
	        var categories = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = skillsAssessmentRating[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var data = _step2.value;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = Object.keys(data).filter(function (c) {
	                return c.toLowerCase() !== 'not applicable';
	              })[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var category = _step3.value;
	
	                if (!categories.includes(category)) {
	                  categories.push(category);
	                  var value = {
	                    category: category,
	                    initial: showSkillsAssessmentData ? (0, _get3.default)(skillsAssessmentRating, "0." + category, 0) : (0, _get3.default)(defaultData, category, 0),
	                    second: (0, _get3.default)(skillsAssessmentRating, "1." + category, 0),
	                    final: (0, _get3.default)(skillsAssessmentRating, "2." + category, 0)
	                  };
	                  result.push(value);
	
	                  if (value.second > 0) {
	                    hasSecond = true;
	                  }
	
	                  if (value.final > 0) {
	                    hasFinal = true;
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	
	      return {
	        hasSecond: hasSecond,
	        hasFinal: hasFinal,
	        data: result
	      };
	    };
	
	    _this.customRadiusTick = function (showSkillsAssessmentData) {
	      return function (_ref4) {
	        var radius = _ref4.radius,
	            stroke = _ref4.stroke,
	            x = _ref4.x,
	            y = _ref4.y,
	            textAnchor = _ref4.textAnchor,
	            payload = _ref4.payload;
	        var skillsAssessmentTooltip = _this.state.skillsAssessmentTooltip;
	
	        var radiusOffset = 10;
	        var radiusCorrection = 90;
	        var xCalculated = radiusOffset * Math.sin(Math.PI * 2 * (payload.coordinate - radiusCorrection) / 360);
	        var yCalculated = radiusOffset * Math.cos(Math.PI * 2 * (payload.coordinate - radiusCorrection) / 360);
	        var rectCorrection = Math.abs(payload.coordinate - 90);
	        var rectOffsetX = 32;
	        var rectOffsetY = 10;
	        if (rectCorrection > 0 && rectCorrection < 180) {
	          rectOffsetX = 0;
	        }
	
	        if (rectCorrection > 180) {
	          rectOffsetX = 64;
	        }
	
	        return _react2.default.createElement(
	          "g",
	          { className: "recharts-layer recharts-polar-angle-axis-tick" },
	          !showSkillsAssessmentData && _react2.default.createElement("rect", {
	            x: x - xCalculated - rectOffsetX,
	            y: y - yCalculated - rectOffsetY,
	            rx: "5",
	            ry: "5",
	            width: "64",
	            height: "9",
	            style: { fill: '#c4c4c4' } }),
	          showSkillsAssessmentData && _react2.default.createElement(
	            "text",
	            {
	              radius: radius,
	              stroke: stroke,
	              x: x - xCalculated,
	              y: y - yCalculated,
	              className: (0, _classnames2.default)("recharts-text recharts-polar-angle-axis-tick-value", {
	                'recharts-polar-angle-axis-tick-value-selected': skillsAssessmentTooltip && payload.value === skillsAssessmentTooltip.category
	              }),
	              textAnchor: textAnchor
	            },
	            _react2.default.createElement(
	              "tspan",
	              { x: x - xCalculated, dy: "0em" },
	              payload.value
	            )
	          )
	        );
	      };
	    };
	
	    _this.customTickClick = function (showSkillsAssessmentData) {
	      return function (data) {
	        var _this$state = _this.state,
	            skillsAssessmentDefinitions = _this$state.skillsAssessmentDefinitions,
	            skillsAssessmentTooltip = _this$state.skillsAssessmentTooltip;
	
	
	        if (showSkillsAssessmentData === true && data && data.value && skillsAssessmentDefinitions[data.value]) {
	          if (skillsAssessmentTooltip && skillsAssessmentTooltip.category === data.value) {
	            _this.setState({
	              skillsAssessmentTooltip: null
	            });
	          } else {
	            _this.setState({
	              skillsAssessmentTooltip: {
	                category: data.value,
	                text: skillsAssessmentDefinitions[data.value]
	              }
	            });
	          }
	        }
	      };
	    };
	
	    _this.renderFeedbackModal = function () {
	      var _this$state2 = _this.state,
	          surveys = _this$state2.surveys,
	          insights = _this$state2.insights,
	          selectedSurveyId = _this$state2.selectedSurveyId;
	
	      var initialEval = surveys.find(function (s) {
	        return s && s.stage === 'initial' && _this.isSurveyFinished(s);
	      });
	      var finalEval = surveys.find(function (s) {
	        return s && s.stage === 'final' && _this.isSurveyFinished(s);
	      });
	      var hasBothEvals = !!(initialEval && finalEval);
	      var selectedIsFinal = finalEval && selectedSurveyId === finalEval.id;
	
	      var activeInsight = selectedSurveyId ? insights[selectedSurveyId] : null;
	      var insightJson = activeInsight && activeInsight.insight_json;
	      // Flatten every evidence string across the skills lists.
	      var collect = function collect(section) {
	        if (!insightJson || !insightJson[section]) return [];
	        var skills = insightJson[section].skills || [];
	        var out = [];
	        skills.forEach(function (s) {
	          (s.evidence || []).forEach(function (e) {
	            if (e) out.push(e);
	          });
	        });
	        return out;
	      };
	      var appreciate = collect('strengths');
	      var grow = collect('weaknesses');
	
	      return _react2.default.createElement(
	        Feedback.Backdrop,
	        { onClick: _this.closeFeedbackModal },
	        _react2.default.createElement(
	          Feedback.Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Feedback.Header,
	            null,
	            _react2.default.createElement(
	              Feedback.HeaderText,
	              null,
	              _react2.default.createElement(
	                Feedback.Title,
	                null,
	                "What your teammates said"
	              ),
	              _react2.default.createElement(
	                Feedback.Subtitle,
	                null,
	                "Anonymous written feedback collected with each evaluation."
	              )
	            ),
	            _react2.default.createElement(
	              Feedback.Close,
	              {
	                type: "button",
	                onClick: _this.closeFeedbackModal,
	                "aria-label": "Close"
	              },
	              "\xD7"
	            )
	          ),
	          hasBothEvals && _react2.default.createElement(
	            Feedback.TabRow,
	            null,
	            _react2.default.createElement(
	              Feedback.Tab,
	              {
	                type: "button",
	                active: selectedIsFinal,
	                onClick: function onClick() {
	                  return _this.selectSurveyById(finalEval.id);
	                }
	              },
	              "Final evaluation"
	            ),
	            _react2.default.createElement(
	              Feedback.Tab,
	              {
	                type: "button",
	                active: !selectedIsFinal,
	                onClick: function onClick() {
	                  return _this.selectSurveyById(initialEval.id);
	                }
	              },
	              "Initial evaluation"
	            )
	          ),
	          _react2.default.createElement(
	            Feedback.Body,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                Feedback.ColumnHeader,
	                null,
	                _react2.default.createElement(
	                  Feedback.ColumnIcon,
	                  { background: "hsla(151, 55%, 92%, 1)", color: "hsl(151, 60%, 30%)" },
	                  "\uD83D\uDC4D"
	                ),
	                _react2.default.createElement(
	                  Feedback.ColumnLabel,
	                  null,
	                  _react2.default.createElement(
	                    Feedback.ColumnTitle,
	                    null,
	                    "What they appreciate"
	                  ),
	                  _react2.default.createElement(
	                    Feedback.ColumnSubtitle,
	                    null,
	                    "Strengths teammates called out"
	                  )
	                )
	              ),
	              appreciate.length > 0 ? appreciate.map(function (text, i) {
	                return _react2.default.createElement(
	                  Feedback.QuoteCard,
	                  { key: "appreciate-" + i, accent: "#2AB37A" },
	                  _react2.default.createElement(
	                    Feedback.QuoteText,
	                    null,
	                    text
	                  )
	                );
	              }) : _react2.default.createElement(
	                Feedback.QuoteText,
	                null,
	                "No strengths feedback yet."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                Feedback.ColumnHeader,
	                null,
	                _react2.default.createElement(
	                  Feedback.ColumnIcon,
	                  { background: "hsla(30, 100%, 92%, 1)", color: "hsl(30, 90%, 40%)" },
	                  "\u2191"
	                ),
	                _react2.default.createElement(
	                  Feedback.ColumnLabel,
	                  null,
	                  _react2.default.createElement(
	                    Feedback.ColumnTitle,
	                    null,
	                    "Room to grow"
	                  ),
	                  _react2.default.createElement(
	                    Feedback.ColumnSubtitle,
	                    null,
	                    "What they'd like to see more or less of"
	                  )
	                )
	              ),
	              grow.length > 0 ? grow.map(function (text, i) {
	                return _react2.default.createElement(
	                  Feedback.QuoteCard,
	                  { key: "grow-" + i, accent: "#F4A93C" },
	                  _react2.default.createElement(
	                    Feedback.QuoteText,
	                    null,
	                    text
	                  )
	                );
	              }) : _react2.default.createElement(
	                Feedback.QuoteText,
	                null,
	                "No growth feedback yet."
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      performance: [{ id: 1, name: "Peer Rating", isActive: true }],
	      surveys: [],
	      reports: {},
	      grading: {},
	      teamGrade: 0,
	      currentScore: {},
	      userGrade: {},
	      skillsAssessmentCalculated: false,
	      skillsAssessmentRating: [],
	      skillsAssessmentTooltip: null,
	      skillsAssessmentDefinitions: {},
	      peerScoreValue: null,
	      showPerformanceSummary: false,
	      // Map of surveyId → { average_user_score, team_average_score,
	      // team_median_score } from /v2/forms/surveys/<id>/user-score/<uid>/.
	      // Fed by fetchUserScores() in componentDidMount once we know
	      // which surveys are finished.
	      userScores: {},
	      // Which finished peer-eval survey is currently displayed in the
	      // peer-rating + teammates cards + feedback modal. Defaults to
	      // Final if present, else Initial. Toggled via any of the
	      // Initial/Final buttons — all three surfaces stay in sync.
	      selectedSurveyId: null,
	      // Map of surveyId → /v2/insights/mine/<id>/ response body.
	      // Drives the "What your teammates said" blurb (overall_summary)
	      // and the feedback modal columns (strengths / weaknesses
	      // evidence). null value = fetch returned nothing / errored.
	      insights: {},
	      feedbackModalOpen: false
	    };
	    return _this;
	  }
	
	  // Poll sessionStorage every 100ms up to 5s waiting for App.js's
	  // general-info fetch to populate the course_id. Prevents a
	  // race-condition GET to `?course=0` when a student navigates
	  // directly to /peer-review before the initial data load resolves.
	
	
	  // Fires GET /v2/forms/surveys/<id>/user-score/<userId>/ for every
	  // finished Initial + Final peer-eval survey. Response fields used:
	  //   average_user_score, team_average_score, team_median_score.
	  // Populates state.userScores keyed by survey id and picks a
	  // sensible default for selectedSurveyId (Final if we have it, else
	  // Initial). Silently skips any survey whose fetch fails.
	
	
	  // Fires GET /v2/insights/mine/<surveyId>/ for each finished Initial
	  // + Final peer-eval. Response has insight_json.overall_summary
	  // (drives the teammates-said blurb) plus strengths.skills[] and
	  // weaknesses.skills[] with evidence arrays (drives the feedback
	  // modal columns). Silently stores null for any survey whose fetch
	  // fails or 404s — the UI treats that as "no insights released yet".
	
	
	  _createClass(PeerReview, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var courseId, surveysRaw, surveys, finishedSurveys, lastSurveyId, skillsAssessmentCalculated, skillsAssessmentRating, performance, skillsAssessmentDefinitions, initialSurvey, initialSurveyExists, skillsQuestions, _ref6, body, secondSurvey, _skillsQuestions, _ref7, _body, finalSurvey, _skillsQuestions2, _ref8, _body2, formsFeedbacksRaw, formsFeedbacks, allFeedbacksCompleted, _ref9, currentScore, errorDetail, rounds, maxRoundNumber, latestCompletedRound, latestCompletedRoundObj, latestCompletedRoundId, showSkillsAssessmentTab;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this._waitForCourseId();
	
	              case 2:
	                courseId = _context2.sent;
	
	                if (courseId) {
	                  _context2.next = 5;
	                  break;
	                }
	
	                return _context2.abrupt("return");
	
	              case 5:
	                _context2.next = 7;
	                return (0, _InFlightDedup.dedupedGet)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/surveys/?course=" + courseId);
	
	              case 7:
	                surveysRaw = _context2.sent;
	                surveys = surveysRaw.body.results;
	                finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	                  return _this3.isSurveyFinished(i);
	                }) : [];
	                lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	                // Fire the user-score fetches for finished Initial + Final peer
	                // eval surveys in parallel. Each response provides the average
	                // user score plus team average / median — displayed in the
	                // "Your peer rating" card. Fire-and-forget; setState handles the
	                // late arrival, and if any request fails we just render "—" for
	                // that survey.
	
	                this.fetchUserScores(finishedSurveys);
	                // Same idea for insights: overall_summary + strengths/weaknesses
	                // evidence per survey. Drives the "What your teammates said"
	                // card + feedback modal.
	                this.fetchInsights(finishedSurveys);
	
	                if (!(surveys.length > 0)) {
	                  _context2.next = 75;
	                  break;
	                }
	
	                skillsAssessmentCalculated = false;
	                skillsAssessmentRating = [];
	                performance = [].concat(_toConsumableArray(this.state.performance));
	                skillsAssessmentDefinitions = {};
	                initialSurvey = surveys.find(function (i) {
	                  return i.stage === 'initial';
	                });
	                initialSurveyExists = false;
	
	                if (!(initialSurvey && initialSurvey.questions)) {
	                  _context2.next = 36;
	                  break;
	                }
	
	                skillsQuestions = initialSurvey.questions.filter(function (i) {
	                  return ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform';
	                });
	
	                if (!(skillsQuestions.length > 0)) {
	                  _context2.next = 36;
	                  break;
	                }
	
	                initialSurveyExists = true;
	                skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(initialSurvey);
	
	                _context2.prev = 25;
	                _context2.next = 28;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/skills-assessment/" + initialSurvey.id + "/student/" + _Auth2.default.getUserId() + "/");
	
	              case 28:
	                _ref6 = _context2.sent;
	                body = _ref6.body;
	
	                if (body) {
	                  skillsAssessmentRating.push(body);
	                  skillsAssessmentCalculated = Object.values(body).some(function (i) {
	                    return i > 0;
	                  });
	                }
	                _context2.next = 36;
	                break;
	
	              case 33:
	                _context2.prev = 33;
	                _context2.t0 = _context2["catch"](25);
	
	                initialSurveyExists = false;
	
	              case 36:
	                if (!initialSurveyExists) {
	                  _context2.next = 67;
	                  break;
	                }
	
	                secondSurvey = surveys.find(function (i) {
	                  return i.stage === 'second';
	                });
	
	                if (!(secondSurvey && secondSurvey.questions)) {
	                  _context2.next = 52;
	                  break;
	                }
	
	                _skillsQuestions = secondSurvey.questions.filter(function (i) {
	                  return ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform';
	                });
	
	                if (!(_skillsQuestions.length > 0)) {
	                  _context2.next = 52;
	                  break;
	                }
	
	                skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(secondSurvey);
	
	                _context2.prev = 42;
	                _context2.next = 45;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/skills-assessment/" + secondSurvey.id + "/student/" + _Auth2.default.getUserId() + "/");
	
	              case 45:
	                _ref7 = _context2.sent;
	                _body = _ref7.body;
	
	                if (_body && Object.values(_body).some(function (i) {
	                  return i > 0;
	                })) {
	                  skillsAssessmentRating.push(_body);
	                  if (!skillsAssessmentCalculated) {
	                    skillsAssessmentCalculated = Object.values(_body).some(function (i) {
	                      return i > 0;
	                    });
	                  }
	                }
	                _context2.next = 52;
	                break;
	
	              case 50:
	                _context2.prev = 50;
	                _context2.t1 = _context2["catch"](42);
	
	              case 52:
	                finalSurvey = surveys.find(function (i) {
	                  return i.stage === 'final';
	                });
	
	                if (!(finalSurvey && finalSurvey.questions)) {
	                  _context2.next = 67;
	                  break;
	                }
	
	                _skillsQuestions2 = finalSurvey.questions.filter(function (i) {
	                  return ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform';
	                });
	
	                if (!(_skillsQuestions2.length > 0)) {
	                  _context2.next = 67;
	                  break;
	                }
	
	                skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(finalSurvey);
	
	                _context2.prev = 57;
	                _context2.next = 60;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/skills-assessment/" + finalSurvey.id + "/student/" + _Auth2.default.getUserId() + "/");
	
	              case 60:
	                _ref8 = _context2.sent;
	                _body2 = _ref8.body;
	
	                if (_body2 && Object.values(_body2).some(function (i) {
	                  return i > 0;
	                })) {
	                  skillsAssessmentRating.push(_body2);
	                  if (!skillsAssessmentCalculated) {
	                    skillsAssessmentCalculated = Object.values(_body2).some(function (i) {
	                      return i > 0;
	                    });
	                  }
	                }
	                _context2.next = 67;
	                break;
	
	              case 65:
	                _context2.prev = 65;
	                _context2.t2 = _context2["catch"](57);
	
	              case 67:
	
	                if (initialSurveyExists) {
	                  performance.push({ id: 3, name: 'Skills Assessment', isActive: false });
	                }
	
	                _context2.next = 70;
	                return (0, _InFlightDedup.dedupedGet)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/");
	
	              case 70:
	                formsFeedbacksRaw = _context2.sent;
	                formsFeedbacks = formsFeedbacksRaw.body.results;
	                allFeedbacksCompleted = true;
	
	                finishedSurveys.forEach(function (finishedSurvey) {
	                  var notCompletedSurveyFormsFeedbacks = formsFeedbacks.filter(function (formsFeedback) {
	                    return formsFeedback.survey === finishedSurvey.id && formsFeedback.completed !== true;
	                  });
	                  if (notCompletedSurveyFormsFeedbacks.length) {
	                    allFeedbacksCompleted = false;
	                    return;
	                  }
	                });
	
	                this.setState({
	                  performance: performance,
	                  skillsAssessmentCalculated: skillsAssessmentCalculated,
	                  skillsAssessmentRating: skillsAssessmentRating,
	                  skillsAssessmentDefinitions: skillsAssessmentDefinitions,
	                  showPerformanceSummary: allFeedbacksCompleted || finishedSurveys.length
	                });
	
	              case 75:
	                if (!(lastSurveyId > 0)) {
	                  _context2.next = 88;
	                  break;
	                }
	
	                _context2.prev = 76;
	                _context2.next = 79;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/score/" + _Auth2.default.getUserId() + "/" + lastSurveyId + "/");
	
	              case 79:
	                _ref9 = _context2.sent;
	                currentScore = _ref9.body;
	
	
	                this.setState({
	                  currentScore: currentScore
	                });
	                _context2.next = 88;
	                break;
	
	              case 84:
	                _context2.prev = 84;
	                _context2.t3 = _context2["catch"](76);
	                errorDetail = (0, _get3.default)(_context2.t3, 'response.body.detail', null);
	
	                if (errorDetail === 'Not found.') {
	                  this.setState({
	                    currentScore: {}
	                  });
	                }
	
	              case 88:
	                rounds = this.props.rounds;
	                maxRoundNumber = Math.max.apply(null, rounds.map(function (round) {
	                  return round.number;
	                }));
	                latestCompletedRound = Math.max.apply(null, rounds.filter(function (round) {
	                  return round.is_finished;
	                }).map(function (round) {
	                  return round.number;
	                }));
	                latestCompletedRoundObj = rounds.find(function (i) {
	                  return i.number === latestCompletedRound;
	                });
	                latestCompletedRoundId = 0;
	
	                if (latestCompletedRoundObj) {
	                  latestCompletedRoundId = latestCompletedRoundObj.id;
	                }
	
	                if (!(lastSurveyId > 0 && latestCompletedRoundId > 0)) {
	                  _context2.next = 97;
	                  break;
	                }
	
	                _context2.next = 97;
	                return this.getPeerScoreValue(latestCompletedRoundId, lastSurveyId);
	
	              case 97:
	                showSkillsAssessmentTab = surveys.some(function (survey) {
	                  return survey.questions.some(function (question) {
	                    return question.category === "skills_assessment";
	                  });
	                });
	
	
	                this.setState(function (prevState) {
	                  return {
	                    surveys: surveys,
	                    performance: showSkillsAssessmentTab ? [].concat(_toConsumableArray(prevState.performance), [{ id: 3, name: "Skills Assessment", isActive: false }]) : prevState.performance
	                  };
	                }, function () {
	                  surveys.forEach(function (survey) {
	                    if (_this3.isSurveyFinished(survey)) {
	                      _this3.loadReport(survey, _Auth2.default.getUserId());
	                    }
	                  });
	                });
	
	              case 99:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[25, 33], [42, 50], [57, 65], [76, 84]]);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "getPeerScoreValue",
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(roundId, surveyId) {
	        var userId, res, peer_adjustment_grade;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                userId = Number(this.getCurrentUserId());
	                _context3.prev = 1;
	                _context3.next = 4;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/" + surveyId + "/" + roundId + "/" + userId + "/");
	
	              case 4:
	                res = _context3.sent;
	                peer_adjustment_grade = res.body.peer_adjustment_grade;
	
	
	                this.setState({
	                  peerScoreValue: Number(peer_adjustment_grade)
	                });
	                _context3.next = 13;
	                break;
	
	              case 9:
	                _context3.prev = 9;
	                _context3.t0 = _context3["catch"](1);
	
	                this.setState({
	                  peerScoreValue: null
	                });
	                console.log('Cannot get peer score data', _context3.t0);
	
	              case 13:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[1, 9]]);
	      }));
	
	      function getPeerScoreValue(_x3, _x4) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return getPeerScoreValue;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          performance = _state.performance,
	          surveys = _state.surveys,
	          reports = _state.reports,
	          skillsAssessmentCalculated = _state.skillsAssessmentCalculated,
	          skillsAssessmentTooltip = _state.skillsAssessmentTooltip,
	          showPerformanceSummary = _state.showPerformanceSummary,
	          userScores = _state.userScores,
	          selectedSurveyId = _state.selectedSurveyId;
	
	      // Peer-rating card data derived from the fetched user-score
	      // responses. We surface BOTH open and closed peer-eval surveys
	      // so the Initial/Final toggle always renders when both exist —
	      // an "evaluation still open" message replaces the score/insight
	      // rendering downstream when the toggled survey hasn't closed.
	
	      var initialEval = surveys.find(function (s) {
	        return s && s.stage === 'initial';
	      });
	      var finalEval = surveys.find(function (s) {
	        return s && s.stage === 'final';
	      });
	      var initialClosed = initialEval && this.isSurveyFinished(initialEval);
	      var finalClosed = finalEval && this.isSurveyFinished(finalEval);
	      // "Not open yet" = survey exists but its `start` timestamp is in
	      // the future. Distinct from "open" (started, not yet closed) and
	      // "closed" (past end).
	      var isSurveyNotOpenYet = function isSurveyNotOpenYet(survey) {
	        if (!survey || !survey.start) return false;
	        return new Date(survey.start).getTime() > Date.now();
	      };
	      var initialNotOpenYet = initialEval && !initialClosed && isSurveyNotOpenYet(initialEval);
	      var finalNotOpenYet = finalEval && !finalClosed && isSurveyNotOpenYet(finalEval);
	      var initialScore = initialEval ? userScores[initialEval.id] : null;
	      var finalScore = finalEval ? userScores[finalEval.id] : null;
	      var hasBothEvals = !!(initialEval && finalEval);
	      // Fall back to whichever survey exists if state hasn't picked one
	      // yet (fetchUserScores only sets selectedSurveyId when a finished
	      // survey has scores; the toggle still needs a default before then).
	      var effectiveSelectedSurveyId = selectedSurveyId || initialEval && initialEval.id || finalEval && finalEval.id || null;
	      var selectedIsFinal = finalEval && effectiveSelectedSurveyId === finalEval.id;
	      var activeScore = selectedIsFinal ? finalScore : initialScore || finalScore;
	      var activeSurveyClosed = selectedIsFinal ? finalClosed : initialClosed;
	      var activeSurveyNotOpenYet = selectedIsFinal ? finalNotOpenYet : initialNotOpenYet;
	      var fmt = function fmt(n) {
	        return n == null || isNaN(Number(n)) ? '—' : Number(n).toFixed(1);
	      };
	      // Delta only meaningful when we have BOTH scores and viewing Final.
	      var deltaChip = null;
	      if (hasBothEvals && selectedIsFinal && initialScore && finalScore && initialScore.average_user_score != null && finalScore.average_user_score != null) {
	        var delta = Number(finalScore.average_user_score) - Number(initialScore.average_user_score);
	        var rounded = Math.abs(delta).toFixed(1);
	        if (Number(rounded) > 0) {
	          deltaChip = delta > 0 ? "Up " + rounded + " since initial" : "Down " + rounded + " since initial";
	        }
	      }
	      // Insight for the selected survey drives the teammates-said card
	      // + feedback modal. Missing = professor hasn't released yet
	      // (only meaningful once the survey has closed).
	      var insights = this.state.insights;
	
	      var activeInsight = effectiveSelectedSurveyId ? insights[effectiveSelectedSurveyId] : null;
	      var insightJson = activeInsight && activeInsight.insight_json;
	      var overallSummary = insightJson && insightJson.overall_summary;
	      var hasInsights = !!insightJson;
	
	      var isPeerRatingScoreActive = _lodash2.default.get(_lodash2.default.find(performance, {
	        name: "Peer Rating"
	      }), "isActive", false);
	
	      var isSkillsAssessmentActive = _lodash2.default.get(_lodash2.default.find(performance, {
	        name: "Skills Assessment"
	      }), "isActive", false);
	
	      var sortedSurveys = this.sortSurveys(surveys);
	      var latestCompletedFormValue = this.latestCompletedFormValue;
	      var latestCompletedFormKey = this.latestCompletedFormKey;
	      var showSkillsAssessmentData = skillsAssessmentCalculated === true && ['initial', 'second', 'final'].includes(latestCompletedFormKey);
	      var showSkillsAssessmentDataSecond = skillsAssessmentCalculated === true && ['second', 'final'].includes(latestCompletedFormKey);
	      var showSkillsAssessmentDataFinal = skillsAssessmentCalculated === true && latestCompletedFormKey === 'final';
	      var skillsAssessmentStrengthsCategories = this.skillsAssessmentStrengthsCategories(latestCompletedFormKey);
	      var skillsAssessmentAreasOfDevelopmentCategories = this.skillsAssessmentAreasOfDevelopmentCategories(latestCompletedFormKey);
	      var skillsAssessmentChartData = this.skillsAssessmentChartData(showSkillsAssessmentData);
	
	      return _react2.default.createElement(
	        Profile.Wrapper,
	        { className: "instructorPage instructorDashboard" },
	        _react2.default.createElement(
	          Profile.CardWrapper,
	          null,
	          sortedSurveys.map(function (survey) {
	            return _react2.default.createElement(_peerEvaluation2.default, { key: survey.id, survey: survey });
	          })
	        ),
	        showPerformanceSummary && _react2.default.createElement(
	          Summary.Grid,
	          null,
	          _react2.default.createElement(
	            Summary.Card,
	            null,
	            _react2.default.createElement(
	              Summary.TitleRow,
	              null,
	              _react2.default.createElement(
	                Summary.TitleRowTitle,
	                null,
	                "Your peer rating"
	              ),
	              hasBothEvals && _react2.default.createElement(
	                Summary.Toggle,
	                null,
	                _react2.default.createElement(
	                  Summary.ToggleButton,
	                  {
	                    type: "button",
	                    active: !selectedIsFinal,
	                    onClick: function onClick() {
	                      return _this4.selectSurveyById(initialEval.id);
	                    }
	                  },
	                  "Initial"
	                ),
	                _react2.default.createElement(
	                  Summary.ToggleButton,
	                  {
	                    type: "button",
	                    active: selectedIsFinal,
	                    onClick: function onClick() {
	                      return _this4.selectSurveyById(finalEval.id);
	                    }
	                  },
	                  "Final"
	                )
	              )
	            ),
	            activeSurveyClosed ? _react2.default.createElement(
	              _reactDotFragment2.default,
	              null,
	              _react2.default.createElement(
	                Summary.RatingLabel,
	                null,
	                selectedIsFinal ? 'Final rating' : 'Initial rating'
	              ),
	              _react2.default.createElement(
	                Summary.RatingValueRow,
	                null,
	                _react2.default.createElement(
	                  Summary.RatingValue,
	                  null,
	                  fmt(activeScore && activeScore.average_user_score)
	                ),
	                _react2.default.createElement(
	                  Summary.RatingDenom,
	                  null,
	                  "/ 5"
	                )
	              ),
	              deltaChip && _react2.default.createElement(
	                Summary.DeltaChip,
	                null,
	                deltaChip
	              ),
	              _react2.default.createElement(
	                Summary.BreakdownRow,
	                null,
	                _react2.default.createElement(
	                  Summary.BreakdownLabel,
	                  { dotColor: "#2AB3AF" },
	                  "You"
	                ),
	                _react2.default.createElement(
	                  Summary.BreakdownValue,
	                  null,
	                  fmt(activeScore && activeScore.average_user_score)
	                )
	              ),
	              _react2.default.createElement(
	                Summary.BreakdownRow,
	                null,
	                _react2.default.createElement(
	                  Summary.BreakdownLabel,
	                  { dotColor: "#e5e5e5" },
	                  "Team average"
	                ),
	                _react2.default.createElement(
	                  Summary.BreakdownValue,
	                  null,
	                  fmt(activeScore && activeScore.team_average_score)
	                )
	              ),
	              _react2.default.createElement(
	                Summary.BreakdownRow,
	                null,
	                _react2.default.createElement(
	                  Summary.BreakdownLabel,
	                  { dotColor: "#c4c4c4" },
	                  "Team median"
	                ),
	                _react2.default.createElement(
	                  Summary.BreakdownValue,
	                  null,
	                  fmt(activeScore && activeScore.team_median_score)
	                )
	              )
	            ) : _react2.default.createElement(
	              Summary.Blurb,
	              null,
	              activeSurveyNotOpenYet ? "This evaluation hasn't opened yet. Your peer rating will appear here after it opens and closes." : "This evaluation is still open. Your peer rating will appear here after it closes."
	            )
	          ),
	          _react2.default.createElement(
	            Summary.Card,
	            null,
	            _react2.default.createElement(
	              Summary.TitleRow,
	              null,
	              _react2.default.createElement(
	                Summary.TitleRowTitle,
	                null,
	                "What your teammates said"
	              ),
	              hasBothEvals && _react2.default.createElement(
	                Summary.Toggle,
	                null,
	                _react2.default.createElement(
	                  Summary.ToggleButton,
	                  {
	                    type: "button",
	                    active: !selectedIsFinal,
	                    onClick: function onClick() {
	                      return _this4.selectSurveyById(initialEval.id);
	                    }
	                  },
	                  "Initial"
	                ),
	                _react2.default.createElement(
	                  Summary.ToggleButton,
	                  {
	                    type: "button",
	                    active: selectedIsFinal,
	                    onClick: function onClick() {
	                      return _this4.selectSurveyById(finalEval.id);
	                    }
	                  },
	                  "Final"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Summary.Blurb,
	              null,
	              activeSurveyNotOpenYet ? "This evaluation hasn't opened yet. Your teammates' feedback will appear here after it opens and closes." : !activeSurveyClosed ? "This evaluation is still open. Your teammates' feedback will appear here after it closes." : hasInsights ? overallSummary : "Your professor hasn't released feedback for this evaluation yet. Check back after it's shared."
	            ),
	            _react2.default.createElement(
	              Summary.FeedbackButton,
	              {
	                type: "button",
	                onClick: this.openFeedbackModal,
	                disabled: !hasInsights || !activeSurveyClosed
	              },
	              "View feedback"
	            )
	          )
	        ),
	        !showPerformanceSummary && _react2.default.createElement(
	          LockScreen.Wrapper,
	          null,
	          _react2.default.createElement("img", { alt: "The results is locked", src: _iconLock2.default }),
	          _react2.default.createElement(
	            LockScreen.Text,
	            null,
	            "To unlock results, complete peer evaluation."
	          )
	        ),
	        this.state.feedbackModalOpen && this.renderFeedbackModal()
	      );
	    }
	
	    // Feedback modal body pulls evidence from /v2/insights/mine/<id>/
	    // for whichever survey is currently selected outside the modal
	    // (selectedSurveyId, shared with the card toggles). Modal tabs also
	    // update selectedSurveyId so the card + modal stay in sync.
	
	  }, {
	    key: "peerScoreValue",
	    get: function get() {
	      var peerScoreValue = this.state.peerScoreValue;
	
	
	      return peerScoreValue === null ? '---' : (peerScoreValue * 100).toFixed(2) + "%";
	    }
	  }, {
	    key: "gradingValue",
	    get: function get() {
	      var _state2 = this.state,
	          userGrade = _state2.userGrade,
	          teamGrade = _state2.teamGrade;
	
	      var curved_adjusted_cumulative_value = (0, _get3.default)(userGrade, "curved_adjusted_cumulative_value", 0);
	      var adjusted_cumulative_value = (0, _get3.default)(userGrade, "adjusted_cumulative_value", 0);
	
	      var result = 0;
	      if (curved_adjusted_cumulative_value > 0) {
	        result = curved_adjusted_cumulative_value;
	      } else if (adjusted_cumulative_value > 0) {
	        result = adjusted_cumulative_value;
	      } else if (teamGrade > 0) {
	        result = teamGrade;
	      }
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "latestCompletedFormValue",
	    get: function get() {
	      var reports = this.state.reports;
	
	      var key = "";
	
	      if ("initial" in reports) {
	        key = "initial";
	      }
	
	      if ("second" in reports) {
	        key = "second";
	      }
	
	      if ("final" in reports) {
	        key = "final";
	      }
	
	      return key === "" ? "---" : _lodash2.default.get(reports[key], "average_user_score", 0).toFixed(2);
	    }
	  }, {
	    key: "latestCompletedFormKey",
	    get: function get() {
	      var reports = this.state.reports;
	
	      var key = "";
	
	      if ("initial" in reports) {
	        key = "initial";
	      }
	
	      if ("second" in reports) {
	        key = "second";
	      }
	
	      if ("final" in reports) {
	        key = "final";
	      }
	
	      return key;
	    }
	  }, {
	    key: "peerAdjustment",
	    get: function get() {
	      var currentScore = this.state.currentScore;
	
	      var average_user_score = (0, _get3.default)(currentScore, "average_user_score", 0);
	      var team_median_score = (0, _get3.default)(currentScore, "team_median_score", 0);
	      var result = average_user_score < 6 ? team_median_score !== 0 ? Math.min(1, average_user_score / Math.max(team_median_score, 6)) : 0 : 1;
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "individualGrade",
	    get: function get() {
	      var userGrade = this.state.userGrade;
	
	      var result = (0, _get3.default)(userGrade, "adjusted_cumulative_value", 0);
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "finalGrade",
	    get: function get() {
	      var userGrade = this.state.userGrade;
	
	      var result = (0, _get3.default)(userGrade, "curved_adjusted_cumulative_value", 0);
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }]);
	
	  return PeerReview;
	}(_react2.default.Component);
	
	exports.default = PeerReview;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 240px;\n  padding-bottom: 8px;\n  cursor: pointer;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 240px;\n  padding-bottom: 8px;\n  cursor: pointer;\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: hsla(213, 100%, 12%, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: hsla(213, 100%, 12%, 0.94);\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\";\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: hsla(213, 100%, 12%, 0.6);\n"], ["\n  font-family: \"Mukta Vaani\";\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: hsla(213, 100%, 12%, 0.6);\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PerformanceBlock = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.isActive && "\n    border-bottom: 4px solid hsla(218, 43%, 29%, 1);\n  ";
	});
	
	var PerformanceName = _styledComponents2.default.div(_templateObject2);
	
	var PerformanceValue = _styledComponents2.default.div(_templateObject3);
	
	var Performance = function Performance(_ref) {
	  var handleShowTab = _ref.handleShowTab,
	      id = _ref.id,
	      name = _ref.name,
	      value = _ref.value,
	      isActive = _ref.isActive;
	
	  return _react2.default.createElement(
	    PerformanceBlock,
	    { onClick: function onClick() {
	        return handleShowTab(id);
	      }, isActive: isActive },
	    _react2.default.createElement(
	      PerformanceName,
	      null,
	      name
	    ),
	    _react2.default.createElement(
	      PerformanceValue,
	      null,
	      value
	    )
	  );
	};
	
	exports.default = Performance;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 20px;\n\n  ", "\n"], ["\n  padding: 20px;\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _responsiveTable = __webpack_require__(403);
	
	var _responsiveTable2 = _interopRequireDefault(_responsiveTable);
	
	var _row = __webpack_require__(404);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _tbody = __webpack_require__(405);
	
	var _tbody2 = _interopRequireDefault(_tbody);
	
	var _headCell = __webpack_require__(402);
	
	var _headCell2 = _interopRequireDefault(_headCell);
	
	var _bodyCell = __webpack_require__(401);
	
	var _bodyCell2 = _interopRequireDefault(_bodyCell);
	
	var _utils = __webpack_require__(18);
	
	var _thead = __webpack_require__(406);
	
	var _thead2 = _interopRequireDefault(_thead);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var getBackgroundVariant = function getBackgroundVariant(value, itemRound, currentRound) {
	  if (itemRound === currentRound && value > 0) {
	    return "highlighted";
	  } else if (value <= 0) {
	    return "disabled";
	  } else {
	    return "default";
	  }
	};
	
	var TableWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.padding && "\n    padding: " + p.padding + ";\n  ";
	});
	
	var TableHeaderText = _styledComponents2.default.div(_templateObject2);
	
	var FinancialTargets = function FinancialTargets(props) {
	  var round = props.round,
	      financialTargets = props.financialTargets,
	      hideTitle = props.hideTitle,
	      _props$title = props.title,
	      title = _props$title === undefined ? 'Financial Metrics & Targets' : _props$title,
	      padding = props.padding,
	      onHelpIconClick = props.onHelpIconClick;
	
	
	  var shouldShowMetric = function shouldShowMetric(metricKey) {
	    return financialTargets.some(function (target) {
	      var value = parseFloat(target[metricKey]);
	      return value > 0;
	    });
	  };
	
	  // Determine which columns to show
	  var showMarketShare = shouldShowMetric('market_share');
	  var showRevenues = shouldShowMetric('net_revenues');
	  var showGrossMargins = shouldShowMetric('gross_margin');
	  var showSharePrice = shouldShowMetric('stock_price');
	  var showROE = shouldShowMetric('roe');
	  var showROA = shouldShowMetric('roa');
	  var showEPS = shouldShowMetric('earnings_per_share');
	
	  return _react2.default.createElement(
	    TableWrapper,
	    { padding: padding },
	    !hideTitle && _react2.default.createElement(
	      TableHeaderText,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      _responsiveTable2.default,
	      null,
	      _react2.default.createElement(
	        _thead2.default,
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "sort", cellSize: "small" },
	            "Year"
	          ),
	          showMarketShare && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("Market Share");
	              } : null },
	            "Market Share"
	          ),
	          showRevenues && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("Revenues");
	              } : null },
	            "Revenues"
	          ),
	          showGrossMargins && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("Gross Margins");
	              } : null },
	            "Gross Margins"
	          ),
	          showSharePrice && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("Share Price");
	              } : null },
	            "Share Price"
	          ),
	          showROE && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("ROE");
	              } : null },
	            "ROE"
	          ),
	          showROA && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("ROA");
	              } : null },
	            "ROA"
	          ),
	          showEPS && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: onHelpIconClick ? "help" : null, onHelpIconClick: onHelpIconClick ? function () {
	                return onHelpIconClick("EPS");
	              } : null },
	            "EPS"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _tbody2.default,
	        null,
	        financialTargets.map(function (item, index) {
	          // Check which metrics are active for this specific item
	          var itemHasMarketShare = parseFloat(item.market_share) > 0;
	          var itemHasRevenues = parseFloat(item.net_revenues) > 0;
	          var itemHasGrossMargins = parseFloat(item.gross_margin) > 0;
	          var itemHasSharePrice = parseFloat(item.stock_price) > 0;
	          var itemHasROE = parseFloat(item.roe) > 0;
	          var itemHasROA = parseFloat(item.roa) > 0;
	          var itemHasEPS = parseFloat(item.earnings_per_share) > 0;
	
	          return _react2.default.createElement(
	            _row2.default,
	            { key: "financial-targets-row-" + index, isBody: true },
	            _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                alignText: "center",
	                cellSize: "small",
	                backgroundVariant: "default"
	              },
	              item.round_number
	            ),
	            showMarketShare && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.market_share, item.round_number, round)
	              },
	              itemHasMarketShare ? (0, _utils.decimalsRound)(item.market_share * 100, 2) + "%" : "--"
	            ),
	            showRevenues && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.net_revenues, item.round_number, round)
	              },
	              itemHasRevenues ? "$" + (0, _utils.decimalsRound)(item.net_revenues / 1000000, 2) + "M" : "--"
	            ),
	            showGrossMargins && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.gross_margin, item.round_number, round)
	              },
	              itemHasGrossMargins ? (0, _utils.decimalsRound)(item.gross_margin * 100, 2) + "%" : "--"
	            ),
	            showSharePrice && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.stock_price, item.round_number, round)
	              },
	              itemHasSharePrice ? "$" + (0, _utils.decimalsRound)(item.stock_price, 2) : "--"
	            ),
	            showROE && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.roe, item.round_number, round)
	              },
	              itemHasROE ? (0, _utils.decimalsRound)(item.roe * 100, 2) + "%" : "--"
	            ),
	            showROA && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.roa, item.round_number, round)
	              },
	              itemHasROA ? (0, _utils.decimalsRound)(item.roa * 100, 2) + "%" : "--"
	            ),
	            showEPS && _react2.default.createElement(
	              _bodyCell2.default,
	              {
	                backgroundVariant: getBackgroundVariant(item.earnings_per_share, item.round_number, round)
	              },
	              itemHasEPS ? "$" + (0, _utils.decimalsRound)(item.earnings_per_share, 2) : "--"
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = FinancialTargets;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 20px;\n\n  ", "\n"], ["\n  padding: 20px;\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _responsiveTable = __webpack_require__(403);
	
	var _responsiveTable2 = _interopRequireDefault(_responsiveTable);
	
	var _row = __webpack_require__(404);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _tbody = __webpack_require__(405);
	
	var _tbody2 = _interopRequireDefault(_tbody);
	
	var _headCell = __webpack_require__(402);
	
	var _headCell2 = _interopRequireDefault(_headCell);
	
	var _bodyCell = __webpack_require__(401);
	
	var _bodyCell2 = _interopRequireDefault(_bodyCell);
	
	var _utils = __webpack_require__(18);
	
	var _thead = __webpack_require__(406);
	
	var _thead2 = _interopRequireDefault(_thead);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TableWrapper = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.padding && "\n    padding: " + p.padding + ";\n  ";
	});
	
	var TableHeaderText = _styledComponents2.default.div(_templateObject2);
	
	var FinancialTargetsAndPerformance = function FinancialTargetsAndPerformance(props) {
	  var financialTargets = props.financialTargets,
	      teamReportMetrics = props.teamReportMetrics,
	      hideTitle = props.hideTitle,
	      _props$title = props.title,
	      title = _props$title === undefined ? 'Financial Metrics & Targets' : _props$title,
	      padding = props.padding,
	      _onHelpIconClick = props.onHelpIconClick;
	
	  // Check which metrics are active
	
	  var itemHasMarketShare = parseFloat(financialTargets.market_share) > 0;
	  var itemHasRevenues = parseFloat(financialTargets.net_revenues) > 0;
	  var itemHasGrossMargins = parseFloat(financialTargets.gross_margin) > 0;
	  var itemHasSharePrice = parseFloat(financialTargets.stock_price) > 0;
	  var itemHasROE = parseFloat(financialTargets.roe) > 0;
	  var itemHasROA = parseFloat(financialTargets.roa) > 0;
	  var itemHasEPS = parseFloat(financialTargets.earnings_per_share) > 0;
	
	  return _react2.default.createElement(
	    TableWrapper,
	    { padding: padding },
	    !hideTitle && _react2.default.createElement(
	      TableHeaderText,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      _responsiveTable2.default,
	      null,
	      _react2.default.createElement(
	        _thead2.default,
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          null,
	          _react2.default.createElement(_headCell2.default, { iconType: "sort", cellSize: "small" }),
	          itemHasMarketShare && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Market Share");
	              } },
	            "Market Share"
	          ),
	          itemHasRevenues && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Revenues");
	              } },
	            "Revenues"
	          ),
	          itemHasGrossMargins && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Gross Margins");
	              } },
	            "Gross Margins"
	          ),
	          itemHasSharePrice && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("Share Price");
	              } },
	            "Share Price"
	          ),
	          itemHasROE && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("ROE");
	              } },
	            "ROE"
	          ),
	          itemHasROA && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("ROA");
	              } },
	            "ROA"
	          ),
	          itemHasEPS && _react2.default.createElement(
	            _headCell2.default,
	            { iconType: "help", onHelpIconClick: function onHelpIconClick() {
	                return _onHelpIconClick("EPS");
	              } },
	            "EPS"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _tbody2.default,
	        null,
	        _react2.default.createElement(
	          _row2.default,
	          { isBody: true },
	          _react2.default.createElement(
	            _bodyCell2.default,
	            {
	              alignText: "center",
	              cellSize: "small",
	              backgroundVariant: "default"
	            },
	            "Target Goals"
	          ),
	          itemHasMarketShare && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            financialTargets.market_share.toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasRevenues && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            "$" + (0, _utils.decimalsRound)(financialTargets.net_revenues / 1000000, 2) + "M"
	          ),
	          itemHasGrossMargins && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            financialTargets.gross_margin.toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasSharePrice && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            financialTargets.stock_price.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasROE && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            financialTargets.roe.toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasROA && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            financialTargets.roa.toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasEPS && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            financialTargets.earnings_per_share.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 2
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _row2.default,
	          { isBody: true },
	          _react2.default.createElement(
	            _bodyCell2.default,
	            {
	              alignText: "center",
	              cellSize: "small",
	              backgroundVariant: "default"
	            },
	            "Team Performance"
	          ),
	          itemHasMarketShare && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            teamReportMetrics['Market Share'].toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasRevenues && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            "$" + (0, _utils.decimalsRound)(teamReportMetrics['Net Revenues'] / 1000000, 2) + "M"
	          ),
	          itemHasGrossMargins && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            teamReportMetrics['Gross Margin'].toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasSharePrice && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            teamReportMetrics['Share Price'].toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasROE && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            teamReportMetrics['ROE'].toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasROA && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            teamReportMetrics['ROA'].toLocaleString('en-US', {
	              style: 'percent',
	              minimumFractionDigits: 2,
	              maximumFractionDigits: 2
	            })
	          ),
	          itemHasEPS && _react2.default.createElement(
	            _bodyCell2.default,
	            { backgroundVariant: "default" },
	            teamReportMetrics['Earnings Per Share'].toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 2
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FinancialTargetsAndPerformance;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  background: #fbedd5;\n  border: 1px solid #f9c151;\n  border-radius: 4px;\n  padding: 22px 20px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n\n  span {\n    display: flex;\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    background: #2196f3;\n    border-radius: 28px;\n    color: #fbedd5;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n'], ['\n  margin-top: 24px;\n  background: #fbedd5;\n  border: 1px solid #f9c151;\n  border-radius: 4px;\n  padding: 22px 20px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n\n  span {\n    display: flex;\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    background: #2196f3;\n    border-radius: 28px;\n    color: #fbedd5;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = _styledComponents2.default.div(_templateObject);

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n'], ['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 1px;\n  height: 16px;\n  background: #2da548;\n  margin-left: 10px;\n'], ['\n  width: 1px;\n  height: 16px;\n  background: #2da548;\n  margin-left: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n'], ['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _onboardingCheck = __webpack_require__(301);
	
	var _onboardingCheck2 = _interopRequireDefault(_onboardingCheck);
	
	var _onboardingUncheck = __webpack_require__(1063);
	
	var _onboardingUncheck2 = _interopRequireDefault(_onboardingUncheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Line = _styledComponents2.default.div(_templateObject2);
	
	var Step = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var SubSection = _styledComponents2.default.div(_templateObject4);
	
	var SubSectionItem = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var Navigation = function Navigation(_ref) {
	  var data = _ref.data,
	      category = _ref.category,
	      visitsHistory = _ref.visitsHistory,
	      activeRound = _ref.activeRound,
	      removeEngagement = _ref.removeEngagement;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    data.map(function (link, index) {
	      if (!!link.parent) {
	        return null;
	      }
	
	      var isLinkActive = removeEngagement ? true : visitsHistory.filter(function (i) {
	        return i.indexOf(link.pattern) === 0;
	      }).length > 0 || index === category;
	      var subLinks = data.filter(function (i) {
	        return i.parent === link.title;
	      });
	      var subLinksOpened = removeEngagement ? true : subLinks.some(function (i) {
	        return visitsHistory.filter(function (j) {
	          return j.indexOf(i.pattern) === 0;
	        }).length > 0;
	      });
	      var linkUrl = link.steps.length > 0 ? link.steps[0].url : subLinks.length > 0 ? subLinks[0].steps[0].url : null;
	      if (!linkUrl) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        { key: 'section-' + index },
	        _react2.default.createElement(
	          Step,
	          { isActive: isLinkActive },
	          _react2.default.createElement('img', { src: isLinkActive ? _onboardingCheck2.default : _onboardingUncheck2.default, alt: 'nav icon' }),
	          isLinkActive && index !== category && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: linkUrl + '?round=' + activeRound },
	            link.title
	          ),
	          (!isLinkActive || index === category) && link.title
	        ),
	        !subLinksOpened && index < data.length - 1 && _react2.default.createElement(Line, null),
	        subLinksOpened && _react2.default.createElement(
	          SubSection,
	          null,
	          subLinks.map(function (subLink) {
	            var subLinkIndex = data.findIndex(function (i) {
	              return i.title === subLink.title;
	            });
	            var isSubLinkActive = removeEngagement ? true : visitsHistory.filter(function (i) {
	              return i.indexOf(subLink.pattern) === 0;
	            }).length > 0 || subLinkIndex === category;
	
	            return subLink.steps[0] ? _react2.default.createElement(
	              SubSectionItem,
	              { key: 'subsection-' + index + '-' + subLinkIndex, isActive: isSubLinkActive },
	              isSubLinkActive && subLinkIndex !== category && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: subLink.steps[0].url + '?round=' + activeRound },
	                subLink.title
	              ),
	              (!isSubLinkActive || subLinkIndex === category) && subLink.title
	            ) : null;
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = Navigation;

/***/ },
/* 1291 */
1260,
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = _styledComponents2.default.div(_templateObject);

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = _styledComponents2.default.div(_templateObject);

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n'], ['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  margin: 24px 50px;\n  width: calc(100% - 100px);\n  font-family: Lato;\n  line-height: 100%;\n'], ['\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  margin: 24px 50px;\n  width: calc(100% - 100px);\n  font-family: Lato;\n  line-height: 100%;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-bottom: 24px;\n  width: 27px;\n'], ['\n  margin-bottom: 24px;\n  width: 27px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 32px;\n'], ['\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 32px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-size: 18px;\n'], ['\n  font-size: 18px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _navigation = __webpack_require__(1290);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _pagination = __webpack_require__(1291);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _step = __webpack_require__(1330);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1331);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1332);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1333);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _feedback = __webpack_require__(1301);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _step9 = __webpack_require__(1308);
	
	var _step10 = _interopRequireDefault(_step9);
	
	var _step11 = __webpack_require__(1312);
	
	var _step12 = _interopRequireDefault(_step11);
	
	var _step13 = __webpack_require__(1313);
	
	var _step14 = _interopRequireDefault(_step13);
	
	var _step15 = __webpack_require__(1314);
	
	var _step16 = _interopRequireDefault(_step15);
	
	var _step17 = __webpack_require__(1315);
	
	var _step18 = _interopRequireDefault(_step17);
	
	var _step19 = __webpack_require__(1316);
	
	var _step20 = _interopRequireDefault(_step19);
	
	var _step21 = __webpack_require__(1302);
	
	var _step22 = _interopRequireDefault(_step21);
	
	var _step23 = __webpack_require__(1303);
	
	var _step24 = _interopRequireDefault(_step23);
	
	var _step25 = __webpack_require__(1304);
	
	var _step26 = _interopRequireDefault(_step25);
	
	var _step27 = __webpack_require__(1305);
	
	var _step28 = _interopRequireDefault(_step27);
	
	var _step29 = __webpack_require__(1306);
	
	var _step30 = _interopRequireDefault(_step29);
	
	var _step31 = __webpack_require__(1307);
	
	var _step32 = _interopRequireDefault(_step31);
	
	var _step33 = __webpack_require__(1309);
	
	var _step34 = _interopRequireDefault(_step33);
	
	var _step35 = __webpack_require__(1310);
	
	var _step36 = _interopRequireDefault(_step35);
	
	var _step37 = __webpack_require__(1311);
	
	var _step38 = _interopRequireDefault(_step37);
	
	var _step39 = __webpack_require__(1319);
	
	var _step40 = _interopRequireDefault(_step39);
	
	var _step41 = __webpack_require__(1320);
	
	var _step42 = _interopRequireDefault(_step41);
	
	var _step43 = __webpack_require__(1321);
	
	var _step44 = _interopRequireDefault(_step43);
	
	var _step45 = __webpack_require__(1297);
	
	var _step46 = _interopRequireDefault(_step45);
	
	var _step47 = __webpack_require__(1298);
	
	var _step48 = _interopRequireDefault(_step47);
	
	var _step49 = __webpack_require__(1299);
	
	var _step50 = _interopRequireDefault(_step49);
	
	var _step51 = __webpack_require__(1300);
	
	var _step52 = _interopRequireDefault(_step51);
	
	var _step53 = __webpack_require__(1326);
	
	var _step54 = _interopRequireDefault(_step53);
	
	var _step55 = __webpack_require__(1327);
	
	var _step56 = _interopRequireDefault(_step55);
	
	var _step57 = __webpack_require__(1317);
	
	var _step58 = _interopRequireDefault(_step57);
	
	var _step59 = __webpack_require__(1318);
	
	var _step60 = _interopRequireDefault(_step59);
	
	var _step61 = __webpack_require__(1324);
	
	var _step62 = _interopRequireDefault(_step61);
	
	var _step63 = __webpack_require__(1325);
	
	var _step64 = _interopRequireDefault(_step63);
	
	var _step65 = __webpack_require__(1322);
	
	var _step66 = _interopRequireDefault(_step65);
	
	var _step67 = __webpack_require__(1323);
	
	var _step68 = _interopRequireDefault(_step67);
	
	var _step69 = __webpack_require__(1295);
	
	var _step70 = _interopRequireDefault(_step69);
	
	var _step71 = __webpack_require__(1296);
	
	var _step72 = _interopRequireDefault(_step71);
	
	var _step73 = __webpack_require__(1329);
	
	var _step74 = _interopRequireDefault(_step73);
	
	var _step75 = __webpack_require__(1328);
	
	var _step76 = _interopRequireDefault(_step75);
	
	var _iconLock = __webpack_require__(333);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject3);
	
	var RoundLockedScreen = {};
	RoundLockedScreen.Wrapper = _styledComponents2.default.div(_templateObject4);
	RoundLockedScreen.Image = _styledComponents2.default.img(_templateObject5);
	RoundLockedScreen.Title = _styledComponents2.default.h2(_templateObject6);
	RoundLockedScreen.Text = _styledComponents2.default.h3(_templateObject7);
	
	var PerformanceFeedback = function (_PureComponent) {
	  _inherits(PerformanceFeedback, _PureComponent);
	
	  function PerformanceFeedback(props) {
	    _classCallCheck(this, PerformanceFeedback);
	
	    var _this = _possibleConstructorReturn(this, (PerformanceFeedback.__proto__ || Object.getPrototypeOf(PerformanceFeedback)).call(this, props));
	
	    _this.updateCurrentState = function () {
	      var navigation = _this.state.navigation;
	
	
	      var currentCategory = 0;
	      var currentStep = 0;
	      for (var i = 0; i < navigation.length; i++) {
	        var stepIndex = navigation[i].steps.findIndex(function (j) {
	          return j.url === _this.props.location.pathname;
	        });
	        if (stepIndex > -1) {
	          currentCategory = i;
	          currentStep = stepIndex;
	          break;
	        }
	      }
	
	      if (currentCategory !== _this.state.currentCategory || currentStep !== _this.state.currentStep) {
	
	        _this.setState({
	          currentCategory: currentCategory,
	          currentStep: currentStep
	        }, function () {
	          _this.checkLocation();
	        });
	      } else {
	        if (_this.props.location.pathname === '/performance-feedback') {
	          _this.checkLocation();
	        }
	      }
	    };
	
	    _this.checkLocation = function () {
	      var _this$state = _this.state,
	          currentCategory = _this$state.currentCategory,
	          currentStep = _this$state.currentStep,
	          navigation = _this$state.navigation;
	
	      var activeRound = _this.activeRound;
	
	      var roundInPath = _this.props.location.query.round;
	      var roundChange = false;
	      if (roundInPath && Number(roundInPath) !== Number(activeRound)) {
	        roundChange = true;
	      }
	
	      if (_this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url && !roundChange) {
	        (0, _Location.changeLocation)(navigation[currentCategory].steps[currentStep].url + '?round=' + activeRound);
	      }
	    };
	
	    _this.goNext = function (e) {
	      e.preventDefault();
	
	      var _this$state2 = _this.state,
	          currentCategory = _this$state2.currentCategory,
	          currentStep = _this$state2.currentStep,
	          navigation = _this$state2.navigation;
	
	
	      var nextCategory = currentCategory;
	      var nextStep = currentStep + 1;
	      if (nextStep >= navigation[currentCategory].steps.length) {
	        nextCategory = currentCategory + 1;
	        nextStep = 0;
	
	        if (nextCategory >= navigation.length) {
	          return false;
	        } else if (nextStep >= navigation[nextCategory].steps.length) {
	          nextCategory = currentCategory + 2;
	          nextStep = 0;
	
	          if (nextCategory >= navigation.length) {
	            return false;
	          }
	        }
	      }
	
	      _this.setState({
	        currentCategory: nextCategory,
	        currentStep: nextStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.goPrev = function (e) {
	      e.preventDefault();
	
	      var _this$state3 = _this.state,
	          currentCategory = _this$state3.currentCategory,
	          currentStep = _this$state3.currentStep,
	          navigation = _this$state3.navigation;
	
	
	      var prevCategory = currentCategory;
	      var prevStep = currentStep - 1;
	      if (prevStep < 0) {
	        prevCategory = currentCategory - 1;
	        if (prevCategory < 0) {
	          return false;
	        }
	
	        prevStep = navigation[prevCategory].steps.length - 1;
	        if (prevStep < 0) {
	          prevCategory = currentCategory - 2;
	          if (prevCategory < 0) {
	            return false;
	          }
	
	          prevStep = navigation[prevCategory].steps.length - 1;
	        }
	      }
	
	      _this.setState({
	        currentCategory: prevCategory,
	        currentStep: prevStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.state = {
	      currentCategory: 0,
	      currentStep: 0,
	      navigation: [],
	      reportsPerformanceFeedback: [],
	      resultsTeamGrading: {},
	      resultsTargets: {},
	      loaded: false,
	      visitsHistory: []
	    };
	    return _this;
	  }
	
	  _createClass(PerformanceFeedback, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          rounds = _props.rounds,
	          location = _props.location;
	      // Read round from URL directly instead of relying on activeRound
	      // (which falls back to currentRound via a prop populated async by
	      // App.js). On a fresh navigation to /performance-feedback?round=N
	      // the roundInUrl prop can be stale for one tick, causing the check
	      // below to fall back to the LIVE currentRound and incorrectly
	      // redirect to /onboarding when the student is legitimately trying
	      // to view a prior finished round's feedback.
	
	      var urlRound = null;
	      if (location && location.query && location.query.round) {
	        var parsed = parseInt(location.query.round, 10);
	        if (!isNaN(parsed)) urlRound = parsed;
	      }
	      var activeRound = urlRound != null ? urlRound : this.activeRound;
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var isRoundLive = round ? round.is_started === true && round.is_finished === false && round.should_be_finished === false : false;
	
	      if (isRoundLive) {
	        (0, _Location.changeLocation)('/onboarding');
	      } else {
	        this.loadNavigation(function () {
	          _this2.updateCurrentState();
	        });
	      }
	    }
	  }, {
	    key: 'loadNavigation',
	    value: function loadNavigation(callback) {
	      var _this3 = this;
	
	      var activeRound = this.activeRound;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/reports/performancefeedbacks/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/grading/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?round_number=' + activeRound + '&course=' + _Auth2.default.getCourseId(), ("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound]).then(function (res) {
	        var results = res[0].body.results || [];
	        var resultsTeamGrading = res[1].body[0] || {};
	        var resultsTargets = res[2].body[0] || {};
	        var priceForecasts = res[3].body || [];
	        var inventoryBalances = res[4].body || [];
	
	        var didNotSubmit = results.find(function (i) {
	          return i.type.toLowerCase() === 'did not submit';
	        });
	
	        var totalForecastsPrice = priceForecasts.reduce(function (sum, item) {
	          return sum + item.price;
	        }, 0);
	        var totalAvailableForSale = inventoryBalances.reduce(function (sum, item) {
	          return sum + item.available_for_sale;
	        }, 0);
	        var showDecisionsNotSubmitted = !!didNotSubmit && !totalForecastsPrice && !totalAvailableForSale;
	
	        var insufficientCapital = results.find(function (i) {
	          return i.type.toLowerCase() === 'insufficient capital';
	        });
	        var showInsufficientCapital = !!insufficientCapital && !showDecisionsNotSubmitted;
	
	        var foundMarketShareError1 = results.find(function (i) {
	          return i.type.toLowerCase() === 'extended release date';
	        });
	        var foundMarketShareError2 = results.find(function (i) {
	          return i.type.toLowerCase() === 'minimum requirement failed';
	        });
	        var foundMarketShareError3 = results.find(function (i) {
	          return i.type.toLowerCase() === 'product market fit';
	        });
	        var foundMarketShareError4 = results.find(function (i) {
	          return i.type.toLowerCase() === 'awareness';
	        });
	        var foundMarketShareError5 = results.find(function (i) {
	          return i.type.toLowerCase() === 'place';
	        });
	        var foundMarketShareError6 = results.filter(function (i) {
	          return i.type.toLowerCase() === 'mobile overproduced' || i.type.toLowerCase() === 'auto overproduced';
	        });
	        var foundMarketShareError7 = results.find(function (i) {
	          return i.type.toLowerCase() === 'low inventory';
	        });
	        var foundMarketShareError8 = results.find(function (i) {
	          return i.type.toLowerCase() === 'low product ranking';
	        });
	
	        var priceRangeFailed = results.find(function (i) {
	          return i.type === "Price range failed";
	        });
	        var showMarketShareStep2 = priceRangeFailed && !(didNotSubmit || insufficientCapital);
	
	        var showMarketShareError1 = !!foundMarketShareError1;
	        var showMarketShareError2 = !!foundMarketShareError2;
	        var showMarketShareError3 = !!foundMarketShareError3;
	        var showMarketShareError4 = !!foundMarketShareError4;
	        var showMarketShareError5 = !!foundMarketShareError5;
	        var showMarketShareError6 = foundMarketShareError6.length > 0;
	        var showMarketShareError7 = !!foundMarketShareError7;
	        var showMarketShareError8 = !!foundMarketShareError8;
	        var showMarketShare = false;
	        if (resultsTargets.market_share > 0) {
	          var found1 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var found2 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!found1 && !found2) {
	            showMarketShare = true;
	          }
	        }
	
	        var foundRevenuesError = results.find(function (i) {
	          return i.type.toLowerCase() === 'expected revenue low';
	        });
	        var showRevenuesError = !!foundRevenuesError;
	        var showRevenues = false;
	        if (resultsTargets.net_revenues > 0) {
	          var _found = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found2 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!_found && !_found2) {
	            showRevenues = true;
	          }
	        }
	
	        var foundGrossMarginError1 = results.find(function (i) {
	          return i.type.toLowerCase() === 'gross margin fail';
	        });
	        var foundGrossMarginError2 = results.find(function (i) {
	          return i.type.toLowerCase() === 'negative gross margins';
	        });
	        var showGrossMarginError1 = !!foundGrossMarginError1 && !foundGrossMarginError2;
	        var showGrossMarginError2 = !!foundGrossMarginError2;
	        var showGrossMargin = false;
	        if (resultsTargets.gross_margin > 0) {
	          var _found3 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found4 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!_found3 && !_found4) {
	            showGrossMargin = true;
	          }
	        }
	
	        var foundSharePriceError = results.find(function (i) {
	          return i.type.toLowerCase() === 'share price fail';
	        });
	        var showSharePriceError = !!foundSharePriceError;
	        var showSharePrice = false;
	        if (resultsTargets.stock_price > 0) {
	          var _found5 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found6 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!_found5 && !_found6) {
	            showSharePrice = true;
	          }
	        }
	
	        var foundNetLossError = results.find(function (i) {
	          return i.type.toLowerCase() === 'negative profits';
	        });
	        var showNetLossError = !!foundNetLossError;
	        var showNetLoss = false;
	        if (showNetLossError && (resultsTargets.roe > 0 || resultsTargets.roa > 0 || resultsTargets.earnings_per_share > 0)) {
	          var _found7 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found8 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          var found3 = results.find(function (i) {
	            return i.type.toLowerCase() === 'negative profits';
	          });
	          if (!_found7 && !_found8 && found3) {
	            showNetLoss = true;
	          }
	        }
	
	        var foundROEError = results.find(function (i) {
	          return i.type.toLowerCase() === 'roe fail';
	        });
	        var showROEError = !!foundROEError;
	        var showROE = false;
	        if (!showNetLoss && resultsTargets.roe > 0) {
	          var _found9 = results.find(function (i) {
	            return i.type.toLowerCase() === 'negative profits';
	          });
	          var _found10 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found11 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!_found9 && !_found10 && !_found11) {
	            showROE = true;
	          }
	        }
	
	        var foundROAError = results.find(function (i) {
	          return i.type.toLowerCase() === 'roa fail';
	        });
	        var showROAError = !!foundROAError;
	        var showROA = false;
	        if (!showNetLoss && resultsTargets.roa > 0) {
	          var _found12 = results.find(function (i) {
	            return i.type.toLowerCase() === 'negative profits';
	          });
	          var _found13 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found14 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!_found12 && !_found13 && !_found14) {
	            showROA = true;
	          }
	        }
	
	        var showEPSError = false;
	        var found = results.find(function (i) {
	          return i.type.toLowerCase() === 'eps fail';
	        });
	        if (found) {
	          showEPSError = true;
	        }
	
	        var showEPS = false;
	        if (!showNetLoss && resultsTargets.earnings_per_share > 0) {
	          var _found15 = results.find(function (i) {
	            return i.type.toLowerCase() === 'negative profits';
	          });
	          var _found16 = results.find(function (i) {
	            return i.type.toLowerCase() === 'did not submit';
	          });
	          var _found17 = results.find(function (i) {
	            return i.type.toLowerCase() === 'not accepted decision that will be deleted';
	          });
	          if (!_found15 && !_found16 && !_found17) {
	            showEPS = true;
	          }
	        }
	
	        var navigation = [{
	          title: 'Results Are In!',
	          pattern: '/performance-feedback/results-are-in',
	          steps: [].concat(_toConsumableArray(showInsufficientCapital ? [{
	            url: '/performance-feedback/results-are-in/insufficient-capital',
	            component: _step2.default
	          }] : []), _toConsumableArray(showDecisionsNotSubmitted ? [{
	            url: '/performance-feedback/results-are-in/decisions-not-submitted',
	            component: _step4.default
	          }] : []), [{
	            url: '/performance-feedback/results-are-in/round-team-score',
	            component: _step6.default
	          }, {
	            url: '/performance-feedback/results-are-in/financial-goals',
	            component: _step8.default
	          }])
	        }, {
	          title: 'Feedback',
	          pattern: '/performance-feedback/feedback',
	          steps: [{
	            url: '/performance-feedback/overall',
	            component: _feedback2.default
	          }]
	        }].concat(_toConsumableArray(showMarketShare ? [{
	          parent: 'Feedback',
	          title: 'Market Share',
	          pattern: '/performance-feedback/market-share',
	          steps: [].concat(_toConsumableArray(showMarketShareStep2 ? [{
	            url: '/performance-feedback/market-share/outside-price-range',
	            component: _step10.default
	          }] : []), _toConsumableArray(showMarketShareError1 ? [{
	            url: '/performance-feedback/market-share/release-date',
	            component: _step12.default,
	            hasErrorAlert: true
	          }] : []), _toConsumableArray(showMarketShareError2 ? [{
	            url: '/performance-feedback/market-share/demand-issue-no-customer',
	            component: _step14.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/market-share/understand-the-customer',
	            component: _step16.default
	          }] : []), _toConsumableArray(showMarketShareError3 ? [{
	            url: '/performance-feedback/market-share/demand-issue-small-market',
	            component: _step18.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/market-share/product-market-fit',
	            component: _step20.default
	          }] : []), _toConsumableArray(showMarketShareError4 ? [{
	            url: '/performance-feedback/market-share/demand-issue-low-visibility',
	            component: _step22.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/market-share/awareness-matters',
	            component: _step24.default
	          }] : []), _toConsumableArray(showMarketShareError5 && false ? [// channels-flow disabled per product; keep components wired for future re-enable
	          {
	            url: '/performance-feedback/market-share/channels',
	            component: _step26.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/market-share/place',
	            component: _step28.default
	          }] : []), _toConsumableArray(showMarketShareError6 ? [{
	            url: '/performance-feedback/market-share/overproduced',
	            component: _step30.default,
	            hasErrorAlert: true,
	            performanceFeedbackData: foundMarketShareError6
	          }] : []), _toConsumableArray(showMarketShareError7 ? [{
	            url: '/performance-feedback/market-share/supply-issue',
	            component: _step32.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/market-share/capacity-constraint',
	            component: _step34.default
	          }] : []), _toConsumableArray(showMarketShareError8 || false ? [// hide this page for now since the backend needs to be adjusted
	          {
	            url: '/performance-feedback/market-share/low-ranging-product',
	            component: _step36.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/market-share/low-ranging-product-research-investigate',
	            component: _step38.default,
	            hasErrorAlert: true
	          }] : []))
	        }] : []), _toConsumableArray(showRevenues && showRevenuesError ? [{
	          parent: 'Feedback',
	          pattern: '/performance-feedback/revenues',
	          title: 'Revenues',
	          steps: [{
	            url: '/performance-feedback/revenues/low-price',
	            component: _step40.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/revenues/pricing-your-products',
	            component: _step42.default
	          }, {
	            url: '/performance-feedback/revenues/build-inventory',
	            component: _step44.default
	          }]
	        }] : []), _toConsumableArray(showGrossMargin && (showGrossMarginError1 || showGrossMarginError2) ? [{
	          parent: 'Feedback',
	          title: 'Gross Margins',
	          pattern: '/performance-feedback/gross-margins',
	          steps: [].concat(_toConsumableArray(showGrossMarginError1 ? [{
	            url: '/performance-feedback/gross-margins/low-price-formula',
	            component: _step46.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/gross-margins/low-price-unit-economics',
	            component: _step48.default
	          }] : []), _toConsumableArray(showGrossMarginError2 ? [{
	            url: '/performance-feedback/gross-margins/non-profit-formula',
	            component: _step50.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/gross-margins/non-profit-unit-economics',
	            component: _step52.default
	          }] : []))
	        }] : []), _toConsumableArray(showSharePrice && showSharePriceError ? [{
	          parent: 'Feedback',
	          title: 'Share Price',
	          pattern: '/performance-feedback/share-price',
	          steps: [{
	            url: '/performance-feedback/share-price/formula',
	            component: _step54.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/share-price/excess-share-issuance',
	            component: _step56.default
	          }]
	        }] : []), _toConsumableArray(showNetLoss ? [{
	          parent: 'Feedback',
	          title: 'Net Loss',
	          pattern: '/performance-feedback/net-loss',
	          steps: [{
	            url: '/performance-feedback/net-loss/stats',
	            component: _step58.default
	          }].concat(_toConsumableArray(showNetLossError ? [{
	            url: '/performance-feedback/net-loss/profit',
	            component: _step60.default,
	            hasErrorAlert: true
	          }] : []))
	        }] : []), _toConsumableArray(showROE && showROEError ? [{
	          parent: 'Feedback',
	          title: 'Return on Equity',
	          pattern: '/performance-feedback/roe',
	          steps: [{
	            url: '/performance-feedback/roe/formula',
	            component: _step62.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/roe/return-on-investments',
	            component: _step64.default
	          }]
	        }] : []), _toConsumableArray(showROA && showROAError ? [{
	          parent: 'Feedback',
	          title: 'Return on Assets',
	          pattern: '/performance-feedback/roa',
	          steps: [{
	            url: '/performance-feedback/roa/formula',
	            component: _step66.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/roa/return-on-investments',
	            component: _step68.default
	          }]
	        }] : []), _toConsumableArray(showEPS && showEPSError ? [{
	          parent: 'Feedback',
	          title: 'Earnings Per Share',
	          pattern: '/performance-feedback/eps',
	          steps: [{
	            url: '/performance-feedback/eps/formula',
	            component: _step70.default,
	            hasErrorAlert: true
	          }, {
	            url: '/performance-feedback/eps/return-on-investments',
	            component: _step72.default,
	            hasErrorAlert: true
	          }]
	        }] : []), [{
	          title: 'Research & Investigate',
	          pattern: '/performance-feedback/research-and-investigate',
	          steps: [{
	            url: '/performance-feedback/research-and-investigate',
	            component: _step74.default
	          }]
	        }, {
	          title: 'Good Luck!',
	          pattern: '/performance-feedback/good-luck',
	          steps: [{
	            url: '/performance-feedback/good-luck',
	            component: _step76.default
	          }]
	        }]);
	
	        if (JSON.stringify(navigation) !== JSON.stringify(_this3.state.navigation)) {
	          _this3.setState({
	            navigation: navigation,
	            reportsPerformanceFeedback: results,
	            resultsTeamGrading: resultsTeamGrading,
	            resultsTargets: resultsTargets,
	            loaded: true
	          }, function () {
	            if (callback) {
	              callback();
	            }
	          });
	        } else {
	          if (callback) {
	            callback();
	          }
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.pathname !== this.props.location.pathname) {
	        this.updateCurrentState();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentCategory = _state.currentCategory,
	          currentStep = _state.currentStep,
	          navigation = _state.navigation,
	          loaded = _state.loaded,
	          visitsHistory = _state.visitsHistory,
	          reportsPerformanceFeedback = _state.reportsPerformanceFeedback,
	          resultsTeamGrading = _state.resultsTeamGrading,
	          resultsTargets = _state.resultsTargets;
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	      var currentRound = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	
	      if (navigation.length === 0 || !loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      var category = navigation[currentCategory];
	      var Component = null;
	      var previousShownErrors = 0;
	      var performanceFeedbackData = null;
	      if (category) {
	        Component = category.steps[currentStep].component;
	
	        var url = category.steps[currentStep].url;
	        var allSteps = navigation.reduce(function (prev, curr) {
	          return [].concat(_toConsumableArray(prev), _toConsumableArray(curr.steps));
	        }, []);
	
	        var currentStepIndex = allSteps.findIndex(function (i) {
	          return i.url === url;
	        });
	        previousShownErrors = allSteps.slice(0, currentStepIndex).filter(function (i) {
	          return i.hasErrorAlert === true;
	        }).length;
	        performanceFeedbackData = category.steps[currentStep].performanceFeedbackData;
	      }
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        currentRound.results_viewable === false && _Auth2.default.getPosition() === "Student" ? _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            RoundLockedScreen.Wrapper,
	            null,
	            _react2.default.createElement(RoundLockedScreen.Image, { alt: 'Round results locked', src: _iconLock2.default }),
	            _react2.default.createElement(
	              RoundLockedScreen.Title,
	              null,
	              'Round Results Locked'
	            ),
	            _react2.default.createElement(
	              RoundLockedScreen.Text,
	              null,
	              'The instructor has locked the results for this round. Check back when they reopen it.'
	            )
	          )
	        ) : _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(_navigation2.default, {
	            data: navigation,
	            category: currentCategory,
	            visitsHistory: visitsHistory,
	            activeRound: activeRound,
	            removeEngagement: true
	          }),
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(
	              ContentWrapper,
	              null,
	              Component && _react2.default.createElement(Component, {
	                activeRound: activeRound,
	                rounds: rounds,
	                previousShownErrors: previousShownErrors,
	                reportsPerformanceFeedback: reportsPerformanceFeedback,
	                resultsTeamGrading: resultsTeamGrading,
	                resultsTargets: resultsTargets,
	                performanceFeedbackData: performanceFeedbackData
	              })
	            ),
	            _react2.default.createElement(_pagination2.default, {
	              goNext: this.goNext,
	              goPrev: this.goPrev,
	              isFirstStep: this.isFirstStep,
	              isLastStep: this.isLastStep,
	              currentStep: currentStep + 1,
	              countOfSteps: this.countOfSteps
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          roundInUrl = _props2.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentCategory = _state2.currentCategory,
	          currentStep = _state2.currentStep;
	
	
	      return currentCategory === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          currentCategory = _state3.currentCategory,
	          currentStep = _state3.currentStep,
	          navigation = _state3.navigation;
	
	
	      var lastCategory = navigation.length - 1;
	      var lastStep = navigation[lastCategory].steps.length - 1;
	
	      return currentCategory === lastCategory && currentStep === lastStep;
	    }
	  }, {
	    key: 'countOfSteps',
	    get: function get() {
	      var _state4 = this.state,
	          currentCategory = _state4.currentCategory,
	          navigation = _state4.navigation;
	
	
	      return navigation[currentCategory].steps.length;
	    }
	  }]);
	
	  return PerformanceFeedback;
	}(_react.PureComponent);
	
	exports.default = PerformanceFeedback;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _formulaValue = __webpack_require__(217);
	
	var _formulaValue2 = _interopRequireDefault(_formulaValue);
	
	var _formulaName = __webpack_require__(216);
	
	var _formulaName2 = _interopRequireDefault(_formulaName);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EpsStep2 = function (_PureComponent) {
	  _inherits(EpsStep2, _PureComponent);
	
	  function EpsStep2(props) {
	    _classCallCheck(this, EpsStep2);
	
	    var _this = _possibleConstructorReturn(this, (EpsStep2.__proto__ || Object.getPrototypeOf(EpsStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      netIncome: 0,
	      shares: 0,
	      earningsPerShare: 0,
	      earningsPerShareTarget: 0
	    };
	    return _this;
	  }
	
	  _createClass(EpsStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      var gameId = Number(_Auth2.default.getGameId());
	      var team = _Teams2.default.currentTeam();
	      var teamId = Number(team.id);
	
	      Promise.all([(0, _MetricsService.fetchTeamMetrics)(teamId, roundId), (0, _FinancialStatementsService.fetchFinancialStatements)({ roundNumber: activeRound }), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId())]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            metricsResults = _ref2[0],
	            financialData = _ref2[1],
	            targetsRes = _ref2[2];
	
	        var currentRoundMetrics = metricsResults.find(function (i) {
	          return Number(i.game) === gameId && Number(i.round) === roundId;
	        });
	        var earningsPerShare = currentRoundMetrics ? Number(currentRoundMetrics.earnings_per_share || 0) : 0;
	        var shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;
	
	        var incomeStatement = financialData.incomeStatement;
	        var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;
	
	        var targets = targetsRes.body;
	        var currentRoundTargets = targets.find(function (i) {
	          return i.round_number === activeRound;
	        });
	        var earningsPerShareTarget = currentRoundTargets.earnings_per_share;
	
	        _this2.setState({
	          loaded: true,
	          netIncome: netIncome,
	          shares: shares,
	          earningsPerShare: earningsPerShare,
	          earningsPerShareTarget: earningsPerShareTarget
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          netIncome = _state.netIncome,
	          earningsPerShare = _state.earningsPerShare,
	          earningsPerShareTarget = _state.earningsPerShareTarget,
	          shares = _state.shares;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      var negativeEarningsPerShare = earningsPerShare < 0 ? "-" : "";
	      var negativeEarningsPerShareTarget = earningsPerShareTarget < 0 ? "-" : "";
	
	      var earningsPerShareFormatted = negativeEarningsPerShare + '$' + Number(Math.abs(earningsPerShare)).toFixed(2);
	      var earningsPerShareWithColor = negativeEarningsPerShare ? _react2.default.createElement(
	        'b',
	        null,
	        earningsPerShareFormatted
	      ) : earningsPerShareFormatted;
	
	      var earningsPerShareTargetFormatted = negativeEarningsPerShareTarget + '$' + Number(Math.abs(earningsPerShareTarget)).toFixed(2);
	      var earningsPerShareTargetWithColor = negativeEarningsPerShareTarget ? _react2.default.createElement(
	        'b',
	        null,
	        earningsPerShareTargetFormatted
	      ) : earningsPerShareTargetFormatted;
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'EPS',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Your net profit was not enough.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'The net profits of ',
	          Number((netIncome / 1000000).toFixed(2)),
	          ', which resulted in an EPS of ',
	          earningsPerShareWithColor,
	          ' was not enough to hit your EPS target of ',
	          earningsPerShareTargetWithColor
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _formulaName2.default,
	            { background: '#2da548' },
	            'Earnings Per Share',
	            _react2.default.createElement('br', null),
	            '(EPS)'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            'Net Profits',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Total Shares'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: netIncome,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: shares,
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#d5d9dd',
	          background: 'rgba(45, 165, 72, 0.12)',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return EpsStep2;
	}(_react.PureComponent);
	
	exports.default = EpsStep2;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2668);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EpsStep3 = function EpsStep3(_ref) {
	  var previousShownErrors = _ref.previousShownErrors;
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'EPS',
	    previousShownErrors: previousShownErrors,
	    alertText: 'Your net profit was not enough.',
	    subTitle: 'Return on Investments',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Investors monitor the earnings per share metric (EPS) very closely. A few cents off EPS can have a significant impact on a company\'s stock price. For example when ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.cnbc.com/2019/08/06/disney-fiscal-q3-2019-earnings.html', rel: 'noreferrer', target: '_blank' },
	        'Disney missed their earnings'
	      ),
	      ' forecast by 40 cents a share, their stock price fell by 3.7%.'
	    ),
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Image source: disneydining.com'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = EpsStep3;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _formulaValue = __webpack_require__(217);
	
	var _formulaValue2 = _interopRequireDefault(_formulaValue);
	
	var _formulaName = __webpack_require__(216);
	
	var _formulaName2 = _interopRequireDefault(_formulaName);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GrossMarginsStep2 = function (_PureComponent) {
	  _inherits(GrossMarginsStep2, _PureComponent);
	
	  function GrossMarginsStep2(props) {
	    _classCallCheck(this, GrossMarginsStep2);
	
	    var _this = _possibleConstructorReturn(this, (GrossMarginsStep2.__proto__ || Object.getPrototypeOf(GrossMarginsStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      sellingPrice: 0,
	      unitCost: 0,
	      grossMargin: 0
	    };
	    return _this;
	  }
	
	  _createClass(GrossMarginsStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      var gameId = Number(_Auth2.default.getGameId());
	      var team = _Teams2.default.currentTeam();
	      var teamId = Number(team.id);
	
	      Promise.all([(0, _MetricsService.fetchTeamMetrics)(teamId, roundId), (0, _FinancialStatementsService.fetchFinancialStatements)({ roundNumber: activeRound }), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId())]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            metricsResults = _ref2[0],
	            financialData = _ref2[1],
	            targetsRes = _ref2[2];
	
	        var currentRoundMetrics = metricsResults.find(function (i) {
	          return Number(i.game) === gameId && Number(i.round) === roundId;
	        });
	
	        var netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
	        var unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
	        var sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
	
	        var incomeStatement = financialData.incomeStatement;
	        var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
	        var unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
	
	        var targets = targetsRes.body;
	        var currentRoundTargets = targets.find(function (i) {
	          return i.round_number === activeRound;
	        });
	
	        _this2.setState({
	          loaded: true,
	          sellingPrice: sellingPrice,
	          unitCost: unitCost,
	          grossMargin: Number(currentRoundTargets.gross_margin || 0)
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          sellingPrice = _state.sellingPrice,
	          unitCost = _state.unitCost,
	          grossMargin = _state.grossMargin;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'GROSS MARGINS',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Your product(s) generated insufficient margins',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'The gross profit spread between your product\u2019s ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            sellingPrice.toFixed(2)
	          ),
	          ' average selling price and the ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            unitCost.toFixed(2)
	          ),
	          ' average cost to manufacture each unit was ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            (sellingPrice - unitCost).toFixed(2)
	          ),
	          ', which was not enough to generate the gross profit margin needed to hit the ',
	          _react2.default.createElement(
	            'b',
	            null,
	            Number((grossMargin * 100).toFixed(2)),
	            '%'
	          ),
	          ' gross margin target.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _formulaName2.default,
	            { background: '#fec665', color: 'rgba(0, 27, 59, 0.94)' },
	            'Gross Profit Margin',
	            _react2.default.createElement('br', null),
	            'Per Unit of Sale'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            'Selling Price - Unit Cost',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Selling Price'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            '$',
	            (sellingPrice - unitCost).toFixed(2),
	            _react2.default.createElement('span', { className: 'divider' }),
	            '$',
	            sellingPrice.toFixed(2)
	          )
	        ),
	        visualProps: {
	          borderColor: '#d5d9dd',
	          background: '#fbedd5',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return GrossMarginsStep2;
	}(_react.PureComponent);
	
	exports.default = GrossMarginsStep2;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ApiService = __webpack_require__(4);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _pf = __webpack_require__(2659);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/anchor-is-valid */
	
	
	var GrossMarginsStep3 = function (_PureComponent) {
	  _inherits(GrossMarginsStep3, _PureComponent);
	
	  function GrossMarginsStep3(props) {
	    _classCallCheck(this, GrossMarginsStep3);
	
	    var _this = _possibleConstructorReturn(this, (GrossMarginsStep3.__proto__ || Object.getPrototypeOf(GrossMarginsStep3)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      grossMargin: 0
	    };
	    return _this;
	  }
	
	  _createClass(GrossMarginsStep3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var activeRound = this.props.activeRound;
	
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId()).then(function (res) {
	        var targets = res.body.find(function (i) {
	          return i.round_number === activeRound;
	        });
	
	        _this2.setState({
	          loaded: true,
	          grossMargin: Number(targets.gross_margin || 0)
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          grossMargin = _state.grossMargin;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'GROSS MARGINS',
	        hideAlert: true,
	        subTitle: 'Unit Economics',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Gross margins is an unit economic measurement that informs managers on how much profit they are generating on each unit of sale. Some companies have very impressive gross margins and some have very low gross margins yet still very successful.'
	        ),
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'In the exercise, however, your team had to hit a gross margin target of ',
	          _react2.default.createElement(
	            'b',
	            null,
	            Number((grossMargin * 100).toFixed(2)),
	            '%'
	          ),
	          '.'
	        ),
	        visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return GrossMarginsStep3;
	}(_react.PureComponent);
	
	exports.default = GrossMarginsStep3;

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _formulaValue = __webpack_require__(217);
	
	var _formulaValue2 = _interopRequireDefault(_formulaValue);
	
	var _formulaName = __webpack_require__(216);
	
	var _formulaName2 = _interopRequireDefault(_formulaName);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GrossMarginsStep5 = function (_PureComponent) {
	  _inherits(GrossMarginsStep5, _PureComponent);
	
	  function GrossMarginsStep5(props) {
	    _classCallCheck(this, GrossMarginsStep5);
	
	    var _this = _possibleConstructorReturn(this, (GrossMarginsStep5.__proto__ || Object.getPrototypeOf(GrossMarginsStep5)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      sellingPrice: 0,
	      unitCost: 0
	    };
	    return _this;
	  }
	
	  _createClass(GrossMarginsStep5, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	      var courseId = Number(_Auth2.default.getCourseId());
	      var gameId = Number(_Auth2.default.getGameId());
	      var team = _Teams2.default.currentTeam();
	      var teamId = Number(team.id);
	
	      Promise.all([(0, _MetricsService.fetchTeamMetrics)(teamId, roundId), (0, _FinancialStatementsService.fetchFinancialStatements)({ roundNumber: activeRound }), (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/reports/performancefeedbacks/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound])]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            metricsResults = _ref2[0],
	            financialData = _ref2[1],
	            batchRes = _ref2[2];
	
	        var currentRoundMetrics = metricsResults.find(function (i) {
	          return Number(i.game) === gameId && Number(i.round) === roundId;
	        });
	
	        var netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
	        var unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
	        var sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
	
	        var incomeStatement = financialData.incomeStatement;
	        var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
	        var unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
	
	        var pfReportRaw = batchRes[0].body;
	        var pfReport = pfReportRaw.results.find(function (i) {
	          return Number(i.course) === courseId && Number(i.game) === gameId && Number(i.round) === roundId && Number(i.team) === teamId && i.type === 'Negative gross margins';
	        });
	        if (!!pfReport) {
	          var message = JSON.parse(pfReport.message);
	          if (message.faild_products && message.faild_products.length > 0) {
	            var productId = Number(message.faild_products[0]);
	            var priceForecastsRaw = batchRes[1].body;
	            var priceForecastsProduct = priceForecastsRaw.find(function (i) {
	              return Number(i.product) === productId;
	            });
	            var inventoryBalancesRaw = batchRes[2].body;
	            var inventoryBalancesProduct = inventoryBalancesRaw.find(function (i) {
	              return Number(i.product) === productId;
	            });
	
	            if (priceForecastsProduct && inventoryBalancesProduct) {
	              sellingPrice = Number(priceForecastsProduct.price);
	              unitCost = Number(inventoryBalancesProduct.cost_per_unit);
	            }
	          }
	        }
	
	        _this2.setState({
	          loaded: true,
	          sellingPrice: sellingPrice,
	          unitCost: unitCost
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          sellingPrice = _state.sellingPrice,
	          unitCost = _state.unitCost;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'GROSS MARGINS',
	        previousShownErrors: previousShownErrors,
	        alertText: 'You might be running a non-profit or a growth-at-all-cost strategy.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'You\'re selling your product below what it cost for you to make the product.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _formulaName2.default,
	            { background: '#4cc7d1', color: 'rgba(0, 27, 59, 0.94)' },
	            'Gross Profit Margin',
	            _react2.default.createElement('br', null),
	            'Per Unit of Sale'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            'Selling Price - Unit Cost',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Selling Price'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            (0, _PerformanceFeedback.formatNumber)(sellingPrice - unitCost),
	            _react2.default.createElement('span', { className: 'divider' }),
	            (0, _PerformanceFeedback.formatNumber)(sellingPrice)
	          )
	        ),
	        visualProps: {
	          borderColor: '#d5d9dd',
	          background: '#d7f0f2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return GrossMarginsStep5;
	}(_react.PureComponent);
	
	exports.default = GrossMarginsStep5;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2658);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var GrossMarginsStep6 = function GrossMarginsStep6() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'GROSS MARGINS',
	    hideAlert: true,
	    subTitle: 'Unit Economics',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Gross margins is an unit economic measurement that informs managers on how much profit they are generating on each unit of sale. Some businesses have found success by initiall offering their products for free (e.g. freemium model). However, it\'s really difficult for a business to survive if their selling price continues to be below their variable costs (i.e. if they have negative gross margins or contribution margins).'
	    ),
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Ron Johnson\'s startup, Enjoy Company, is a great example. At the time Enjoy went public, the company was generating both negative gross and contribution margins. Within 9 months, Enjoy filed for bankruptcy. ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.cnbc.com/2022/06/30/ex-apple-exec-ron-johnsons-enjoy-technology-files-for-bankruptcy.html', rel: 'noreferrer', target: '_blank' },
	        'Learn More'
	      )
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = GrossMarginsStep6;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  padding: 20px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 20px;\n'], ['\n  width: 100%;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  padding: 20px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 20px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 7px;\n'], ['\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 7px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  line-height: 24px;\n'], ['\n  line-height: 24px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FeedbackBlock = _styledComponents2.default.div(_templateObject);
	
	var FeedbackBlockTitle = _styledComponents2.default.h3(_templateObject2);
	
	var FeedbackBlockList = _styledComponents2.default.ul(_templateObject3);
	
	var FeedbackBlockListItem = _styledComponents2.default.li(_templateObject3);
	
	var FeedbackOverall = function (_PureComponent) {
	  _inherits(FeedbackOverall, _PureComponent);
	
	  function FeedbackOverall(props) {
	    _classCallCheck(this, FeedbackOverall);
	
	    var _this = _possibleConstructorReturn(this, (FeedbackOverall.__proto__ || Object.getPrototypeOf(FeedbackOverall)).call(this, props));
	
	    _this.state = {
	      incomeStatement: {},
	      staticConstants: {}
	    };
	    return _this;
	  }
	
	  _createClass(FeedbackOverall, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var activeRound = this.props.activeRound;
	
	
	      Promise.all([(0, _FinancialStatementsService.fetchFinancialStatements)({ roundNumber: activeRound }),
	      // performance-feedback scope returns constants as an object
	      // (not a single-element array), which is what staticConstants
	      // was already treated as. Previously the un-scoped payload
	      // returned constants as an array here, so this component's
	      // `staticConstants.holding_rate` read was quietly always
	      // undefined; switching to the scope also fixes that.
	      (0, _StaticDataService.fetchAllStaticData)(activeRound, 'performance-feedback')]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            financialData = _ref2[0],
	            staticData = _ref2[1];
	
	        var incomeStatement = financialData.incomeStatement[0] || {};
	        var staticConstants = staticData.constants || {};
	
	        _this2.setState({
	          incomeStatement: incomeStatement,
	          staticConstants: staticConstants
	        });
	      }).catch(function () {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          reportsPerformanceFeedback = _props.reportsPerformanceFeedback,
	          resultsTargets = _props.resultsTargets,
	          activeRound = _props.activeRound;
	      var _state = this.state,
	          incomeStatement = _state.incomeStatement,
	          staticConstants = _state.staticConstants;
	
	
	      var hasDidNotSubmitOrInsufficientCapital = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Did not submit" || item.type === "Insufficient capital";
	      });
	
	      var submissionStatusText = incomeStatement['Net Revenues'] === 0 && hasDidNotSubmitOrInsufficientCapital ? 'Some team decisions weren’t posted, either because they weren’t made or your team didn’t have sufficient capital. Check the CEO page for unposted decisions and/or the Finance page for your cash balance.' : 'Your team posted all decisions successfully for this round.';
	
	      var hasMarketFitIssues = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Product market fit" || item.type === "Price range failed";
	      });
	
	      var hasPriceSupplyIssues = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Expected revenue low";
	      });
	
	      var hasAwarenessIssues = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Awareness";
	      });
	
	      var hasMarketShareNetRevenuesTargets = resultsTargets.net_revenues !== 0 || resultsTargets.market_share !== 0;
	      var hasMarketShareOrRevenueFail = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Market share" || item.type === "Revenue fail";
	      });
	      var hasNoRevenueIssues = !reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Product market fit" || item.type === "Price range failed" || item.type === "Expected revenue low" || item.type === "Awareness";
	      });
	
	      var hasNegativeGrossMargins = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Negative gross margins";
	      });
	
	      var hasGrossMarginFail = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Gross margin fail";
	      });
	
	      var hasAutoOrMobileOverproduced = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Auto overproduced" || item.type === "Mobile overproduced";
	      });
	
	      var hasHighInterest = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "High interest";
	      });
	
	      var hasRoeRoaEps = resultsTargets.roe !== 0 || resultsTargets.roa !== 0 || resultsTargets.earnings_per_share !== 0;
	
	      var hasRoeRoaEpsFail = reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Roe fail" || item.type === "Roa fail" || item.type === "EPS fail";
	      });
	
	      var hasNoGrossMarginIssuesOrOverproducedOrHighInterest = !reportsPerformanceFeedback.some(function (item) {
	        return item.type === "Negative gross margins" || item.type === "Gross margin fail" || item.type === "Auto overproduced" || item.type === "Mobile overproduced" || item.type === "High interest";
	      });
	
	      // Whether each feedback block will render any <li>. Used to
	      // fall back to a "No feedback." placeholder when the team hit
	      // its targets and none of the gating flags are set.
	      var showMarketShareRevenueMix = hasMarketShareNetRevenuesTargets && hasMarketShareOrRevenueFail && hasNoRevenueIssues;
	      var hasMarketShareRevenuesFeedback = hasMarketFitIssues || hasPriceSupplyIssues || hasAwarenessIssues || showMarketShareRevenueMix;
	
	      var showProfitChallenges = hasRoeRoaEps && hasRoeRoaEpsFail && hasNoGrossMarginIssuesOrOverproducedOrHighInterest;
	      var hasProfitsFeedback = hasNegativeGrossMargins || hasGrossMarginFail || hasAutoOrMobileOverproduced || hasHighInterest || showProfitChallenges;
	
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'Feedback | OVERALL',
	        title: 'Overall Feedback',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            FeedbackBlock,
	            null,
	            _react2.default.createElement(
	              FeedbackBlockTitle,
	              null,
	              'Submission Status'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              submissionStatusText
	            )
	          ),
	          _react2.default.createElement(
	            FeedbackBlock,
	            null,
	            _react2.default.createElement(
	              FeedbackBlockTitle,
	              null,
	              'Feedback: Generating Market Share & Revenues'
	            ),
	            hasMarketShareRevenuesFeedback ? _react2.default.createElement(
	              FeedbackBlockList,
	              null,
	              hasMarketFitIssues && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Market Fit Challenges:'
	                ),
	                ' Your team has a product that is either targeting customers with low demand or is priced outside what the target market is willing to pay. Review customer analysis to better understand customer preferences.'
	              ),
	              hasPriceSupplyIssues && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Price & Supply Misalignment:'
	                ),
	                ' You either produced or set your product\u2019s price too low given customer demand and what they were willing to pay. There might be coordination issues between your operations function (units available) and your marketing function (selling price).'
	              ),
	              hasAwarenessIssues && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Awareness:'
	                ),
	                ' Visit the Awareness page (',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/analysis/team-reports/marketing-analysis/marketing-awareness?round=' + activeRound },
	                  'click here'
	                ),
	                ') to see how your product\u2019s awareness compares to competitors. If it\u2019s relatively low, consider increasing your promotional spend.'
	              ),
	              showMarketShareRevenueMix && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Market Mix Challenges:'
	                ),
	                ' Your current 4Ps may be hindering performance. Review the Marketing Analysis in your Team Report to compare your product\u2019s features, pricing, and awareness with top competitors.'
	              )
	            ) : _react2.default.createElement(
	              'p',
	              null,
	              'No feedback.'
	            )
	          ),
	          _react2.default.createElement(
	            FeedbackBlock,
	            null,
	            _react2.default.createElement(
	              FeedbackBlockTitle,
	              null,
	              'Feedback on Generating Profits'
	            ),
	            hasProfitsFeedback ? _react2.default.createElement(
	              FeedbackBlockList,
	              null,
	              hasNegativeGrossMargins && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Negative Margins:'
	                ),
	                ' It looks like your product\u2019s selling price is below its production cost. Remember, this isn\u2019t a nonprofit game. Ensure Marketing (who sets price) and Operations (who manages cost) are coordinating.'
	              ),
	              hasGrossMarginFail && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Low Gross Margins:'
	                ),
	                ' Your team\u2019s margins are insufficient. Review your product\u2019s selling price and manufacturing cost, and adjust as needed.'
	              ),
	              hasAutoOrMobileOverproduced && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Overproduced:'
	                ),
	                ' Overproducing creates unsold inventory, carrying holding costs of about ',
	                staticConstants.holding_rate && staticConstants.holding_rate.toLocaleString('en-US', { style: 'percent' }),
	                ' of its value. Remember, a top product in a segment (e.g., mobile) can capture roughly 15% of the market; producing beyond that may result in excess inventory.'
	              ),
	              hasHighInterest && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'High Interest:'
	                ),
	                ' Your outstanding loan is incurring a lot of interest, which impacts your profitability. Monitor it closely and consider paying down your loan or interest payable.'
	              ),
	              showProfitChallenges && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Profit Challenges:'
	                ),
	                ' Your revenues aren\'t keeping up with expenses, which can lower your score in rounds targeting profit metrics (ROE, ROA, EPS). Check your income statement in Team Reports to see what\u2019s impacting profitability.'
	              )
	            ) : _react2.default.createElement(
	              'p',
	              null,
	              'No feedback.'
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return FeedbackOverall;
	}(_react.PureComponent);
	
	exports.default = FeedbackOverall;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 20px;\n'], ['\n  padding: 20px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 20px;\n\n  ', '\n\n  img {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    position: relative;\n    top: -1px;\n    margin-left: 5px;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 20px;\n\n  ', '\n\n  img {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    position: relative;\n    top: -1px;\n    margin-left: 5px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  max-width: 65%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n'], ['\n  max-width: 65%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _verticalBar = __webpack_require__(397);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _utils = __webpack_require__(53);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartWrapper = _styledComponents2.default.div(_templateObject);
	
	var ChartTitle = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.isFlex && '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  ';
	});
	
	var ChartData = _styledComponents2.default.div(_templateObject3);
	
	var MarketShareStep10 = function (_PureComponent) {
	  _inherits(MarketShareStep10, _PureComponent);
	
	  function MarketShareStep10(props) {
	    _classCallCheck(this, MarketShareStep10);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep10.__proto__ || Object.getPrototypeOf(MarketShareStep10)).call(this, props));
	
	    _this.state = {
	      teams: [],
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep10, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var currentTeam = _Teams2.default.currentTeam();
	      var competitionId = Number(currentTeam.competition);
	      var roundObj = (rounds || []).find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundId = roundObj ? Number(roundObj.id) : 0;
	
	      (0, _MetricsService.fetchCompetitiveAnalysis)(competitionId, roundId).then(function (competitiveAnalysis) {
	        // Build teams from MetricsReport data
	        var teamsMap = {};
	        competitiveAnalysis.forEach(function (item) {
	          if (!teamsMap[item.team]) {
	            teamsMap[item.team] = {
	              id: item.team,
	              name: item.team_name || String(item.team),
	              competition: item.competition || competitionId
	            };
	          }
	        });
	        var teams = Object.values(teamsMap);
	
	        var data = (0, _utils.pickPercent)(teams, competitiveAnalysis, 'product_awareness');
	
	        _this2.setState({
	          teams: teams,
	          data: data
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          teams = _state.teams,
	          data = _state.data;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Demand Issue : You have a product with low customer visibility.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'You\'ll need to promote your product to better your chances of capturing more market share.'
	        ),
	        visual: _react2.default.createElement(
	          ChartWrapper,
	          null,
	          _react2.default.createElement(
	            ChartTitle,
	            null,
	            'Product Awareness',
	            _react2.default.createElement('img', { alt: 'Product Awareness icon help', src: _iconTableHelp2.default })
	          ),
	          _react2.default.createElement(
	            ChartData,
	            null,
	            _react2.default.createElement(_verticalBar2.default, {
	              data: data,
	              prefix: "",
	              suffix: "%",
	              precision: 2,
	              customColors: null,
	              showCategoryLabels: false,
	              instructorData: null,
	              teams: teams
	            })
	          )
	        )
	      });
	    }
	  }]);
	
	  return MarketShareStep10;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep10;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2662);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketShareStep11 = function MarketShareStep11() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    hideAlert: true,
	    subTitle: 'Awareness Matters',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Customers need to be aware that your product exists in order to have interest and make a purchase. It\'s why companies spend on marketing to create awareness.',
	      _react2.default.createElement('br', null),
	      'The marketing spend is generally deployed in various marketing channels including traditional (e.g. print, billboards and events/conference) and/or digital (e.g. content marketing, email marketing, social media, ads).'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep11;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(1064);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketShareStep13 = function MarketShareStep13(_ref) {
	  var previousShownErrors = _ref.previousShownErrors;
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    previousShownErrors: previousShownErrors,
	    alertText: 'Demand Issue : Your sales channel choice might be sub-optimal.',
	    subTitle: 'Direct vs. Indirect Channels',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'In this exercise, your team had to decide between using direct or indirect sales channels to sell your products to customers.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep13;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2661);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var MarketShareStep14 = function MarketShareStep14() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    hideAlert: true,
	    subTitle: 'Place',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'In the real world, companies can sell their products directly to customers and/or indirectly (e.g. 3rd. party distributor). It all depends on what works best. For example, Nike\'s channel of choice has been indirect sales (~84% of their sales). There is, however, a gradual shift towards selling directly to consumers because it\'s now optimal. ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://qz.com/2025862/nikes-direct-to-consumer-sales-are-taking-off/', rel: 'noreferrer', target: '_blank' },
	        'Learn more'
	      )
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep14;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep18 = function (_PureComponent) {
	  _inherits(MarketShareStep18, _PureComponent);
	
	  function MarketShareStep18() {
	    _classCallCheck(this, MarketShareStep18);
	
	    return _possibleConstructorReturn(this, (MarketShareStep18.__proto__ || Object.getPrototypeOf(MarketShareStep18)).apply(this, arguments));
	  }
	
	  _createClass(MarketShareStep18, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          previousShownErrors = _props.previousShownErrors,
	          performanceFeedbackData = _props.performanceFeedbackData;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Supply Issue : Your inventory levels are high!',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              'Customers prefer lower concentration risk:'
	            ),
	            ' They prefer to limit how many units they\u2019ll purchase from 1 single seller. Therefore don\u2019t expect to capture more than ',
	            _react2.default.createElement(
	              'b',
	              null,
	              '15% of a customer segment (mobile or auto)'
	            ),
	            '. However if there are irrational players in your competition, it\u2019s possible to capture more than 20%.'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              'Recommendation:'
	            ),
	            ' When deciding on production, factor in the overall demand from your target customers, taking into account concentration risk limits.'
	          )
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Segments'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Available Inventory'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Customer Demand'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Inventory %',
	              _react2.default.createElement('br', null),
	              ' of Demand'
	            )
	          ),
	          performanceFeedbackData.map(function (item, index) {
	            var parsedItemMessage = JSON.parse(item.message);
	
	            var availableForSale = parsedItemMessage.available_for_sale;
	            var demand = parsedItemMessage.demand;
	            var segment = parsedItemMessage.segment;
	            var inventoryPercentageOfDemand = availableForSale / demand;
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                segment
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                availableForSale.toLocaleString()
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                demand.toLocaleString()
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                (inventoryPercentageOfDemand * 100).toFixed(2),
	                '%'
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep18;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep18;

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _recharts = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep19 = function (_PureComponent) {
	  _inherits(MarketShareStep19, _PureComponent);
	
	  function MarketShareStep19(props) {
	    _classCallCheck(this, MarketShareStep19);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep19.__proto__ || Object.getPrototypeOf(MarketShareStep19)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      loaded: false,
	      marketShare: 0,
	      totalUnitsSold: 0,
	      otherTeamsUnitsSold: 0,
	      otherTeamsUnitsSoldPercent: 0,
	      teamUnits: 0,
	      teamUnitsPercent: 0
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep19, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var currentTeam = _Teams2.default.currentTeam();
	      var teamId = Number(currentTeam.id);
	      var competitionId = currentTeam.competition;
	      var roundObj = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundId = roundObj ? roundObj.id : null;
	
	      Promise.all([(0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId), (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId(), ("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound])]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            metrics = _ref2[0],
	            batchRes = _ref2[1];
	
	        var targets = batchRes[0].body;
	        var target = targets.find(function (i) {
	          return i.round_number === activeRound;
	        });
	
	        var totalUnitsSold = metrics.map(function (i) {
	          return Math.abs(Number(i['units_sold'] || i['Units Sold'] || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var otherTeamsUnitsSold = metrics.filter(function (i) {
	          return Number(i.team) !== teamId;
	        }).map(function (i) {
	          return Math.abs(Number(i['units_sold'] || i['Units Sold'] || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var inventoryBalances = batchRes[1].body;
	        var teamUnits = inventoryBalances.map(function (i) {
	          return Math.abs(Number(i.available_for_sale || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	
	        var otherTeamsUnitsSoldPercent = Number((otherTeamsUnitsSold / (otherTeamsUnitsSold + teamUnits) * 100).toFixed(2));
	        var teamUnitsPercent = Number((100 - otherTeamsUnitsSoldPercent).toFixed(2));
	
	        _this2.setState({
	          loaded: true,
	          marketShare: target ? Number(target.market_share || 0) : 0,
	          totalUnitsSold: totalUnitsSold,
	          otherTeamsUnitsSold: otherTeamsUnitsSold,
	          otherTeamsUnitsSoldPercent: otherTeamsUnitsSoldPercent,
	          teamUnits: teamUnits,
	          teamUnitsPercent: teamUnitsPercent
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'numberWithCommas',
	    value: function numberWithCommas(x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          marketShare = _state.marketShare,
	          otherTeamsUnitsSold = _state.otherTeamsUnitsSold,
	          otherTeamsUnitsSoldPercent = _state.otherTeamsUnitsSoldPercent,
	          teamUnits = _state.teamUnits,
	          teamUnitsPercent = _state.teamUnitsPercent;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Supply Issue : you didn\'t produce enough to hit your market share target.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Your company\u2019s goal was to capture ',
	          _react2.default.createElement(
	            'b',
	            null,
	            Number((marketShare * 100).toFixed(2)),
	            '%'
	          ),
	          ' of total unit sold within your competition. However, the total inventory that Operations had available for sale accounted for ',
	          _react2.default.createElement(
	            'b',
	            null,
	            teamUnitsPercent,
	            '%'
	          ),
	          ' of all units sold.'
	        ),
	        visual: _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: '100%', height: 320 },
	          _react2.default.createElement(
	            _recharts.PieChart,
	            null,
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                data: [{ name: 'Units sold (other teams)', originalValue: otherTeamsUnitsSold, value: otherTeamsUnitsSoldPercent }, { name: 'Team\'s units available for sale', originalValue: teamUnits, value: teamUnitsPercent }],
	                cx: '50%',
	                cy: '50%',
	                innerRadius: 60,
	                outerRadius: 90,
	                fill: '#8884d8',
	                dataKey: 'value',
	                label: this.renderLabel,
	                labelLine: false,
	                startAngle: 90,
	                endAngle: 450
	              },
	              '$',
	              ['#52c5cd', '#f9c151'].map(function (color, index) {
	                return _react2.default.createElement(_recharts.Cell, { key: 'pie-cell-' + index, fill: color });
	              })
	            )
	          )
	        )
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep19;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.renderLabel = function (props) {
	    var cx = props.cx,
	        cy = props.cy,
	        midAngle = props.midAngle,
	        outerRadius = props.outerRadius,
	        value = props.value,
	        name = props.name,
	        index = props.index,
	        payload = props.payload;
	    var originalValue = payload.originalValue;
	    var totalUnitsSold = _this3.state.totalUnitsSold;
	
	    var RADIAN = Math.PI / 180;
	    var sin = Math.sin(-RADIAN * midAngle);
	    var cos = Math.cos(-RADIAN * midAngle);
	    var sx = cx + (outerRadius + 10) * cos;
	    var sy = cy + (outerRadius + 10) * sin;
	    var mx = cx + (outerRadius + 30) * cos;
	    var my = cy + (outerRadius + 30) * sin;
	    var ex = mx + (cos >= 0 ? 1 : -1) * 35;
	    var ey = my;
	    var textAnchor = cos >= 0 ? 'start' : 'end';
	
	    return _react2.default.createElement(
	      'g',
	      null,
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: 0,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        'Total Units'
	      ),
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: 20,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        Number((totalUnitsSold / 1000000).toFixed(2)),
	        'M'
	      ),
	      _react2.default.createElement('path', { d: 'M' + sx + ',' + sy + 'L' + mx + ',' + my + 'L' + ex + ',' + ey, stroke: 'rgba(0, 27, 59, 0.94)', fill: 'none' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: -10,
	          textAnchor: textAnchor,
	          className: 'chartLabel'
	        },
	        value + '%'
	      ),
	      _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: 10,
	          textAnchor: textAnchor,
	          className: 'chartDescription1'
	        },
	        _this3.numberWithCommas(originalValue)
	      ),
	      _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: 32,
	          textAnchor: textAnchor,
	          className: 'chartDescription2'
	        },
	        name
	      )
	    );
	  };
	};
	
	exports.default = MarketShareStep19;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep2 = function (_PureComponent) {
	  _inherits(MarketShareStep2, _PureComponent);
	
	  function MarketShareStep2(props) {
	    _classCallCheck(this, MarketShareStep2);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep2.__proto__ || Object.getPrototypeOf(MarketShareStep2)).call(this, props));
	
	    _this.state = {
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_lte=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound]).then(function (res) {
	        var priceForecasts = res[1].body;
	        var products = res[0].body.filter(function (i) {
	          return Number(i.round) === roundId;
	        }).map(function (product) {
	          var priceForecast = priceForecasts.find(function (priceForecast) {
	            return priceForecast.product === product.id;
	          });
	          return {
	            name: product.name,
	            pixels_rank: product.pixels_rank,
	            sensitivity_rank: product.sensitivity_rank,
	            power_rank: product.power_rank,
	            temp_range_rank: product.temp_range_rank,
	            price: priceForecast ? priceForecast.price : 1
	          };
	        });
	
	        _this2.setState({
	          products: products
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var products = this.state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Pricing Issue: At least one of your products\u2019 selling prices is outside of what the customer is willing to pay',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Make sure to review the Customer Analysis page to ensure that your marketing mix is aligned with customers\u2019 preferences.'
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(_table.Cell, { color: '#ffffff' }),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Price'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Resolution'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Sensitivity'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Power'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Temp Range'
	            )
	          ),
	          products.map(function (product, index) {
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                product.name
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.price.toLocaleString('en-US', {
	                  style: 'currency',
	                  currency: 'USD',
	                  maximumFractionDigits: 2
	                })
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.pixels_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.sensitivity_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.power_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.temp_range_rank
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep2;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep2;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2660);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketShareStep20 = function MarketShareStep20() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    hideAlert: true,
	    subTitle: 'Capacity Constraint',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Capacity constraints could be the reason why your company was unable to manufacture more goods available for sale. For example, Operations might have produced the maximum units possible given the production machine used.',
	      _react2.default.createElement('br', null),
	      'It should be noted that your product\'s design release date and your machine choice impacts production capacity.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep20;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep22 = function (_PureComponent) {
	  _inherits(MarketShareStep22, _PureComponent);
	
	  function MarketShareStep22(props) {
	    _classCallCheck(this, MarketShareStep22);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep22.__proto__ || Object.getPrototypeOf(MarketShareStep22)).call(this, props));
	
	    _this.state = {
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep22, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_lte=' + activeRound).then(function (res) {
	        var products = res.body.filter(function (i) {
	          return Number(i.round) === roundId;
	        });
	
	        _this2.setState({
	          products: products
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var products = this.state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Potential Demand Issue : You have a low ranking product',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Having products that are ranked lower than Top 10 could impact your ability to capture market share and revenues.'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Product ranking is influenced by factors such as your product\u2019s features and pricing, and the lead time (the time it takes for product delivery). Lead time becomes increasingly significant from round 2 onward.'
	          )
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(_table.Cell, { color: '#ffffff' }),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Resolution'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Sensitivity'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Power'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Temp Range'
	            )
	          ),
	          products.map(function (product, index) {
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                product.name
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.pixels_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.sensitivity_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.power_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.temp_range_rank
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep22;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep22;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2666);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarketShareStep23 = function MarketShareStep23(previousShownErrors) {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    previousShownErrors: previousShownErrors,
	    alertText: 'Potential Demand Issue : You have a low ranking product',
	    subTitle: 'Research & Investigate',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'To better understand your product\u2019s ranking in relation to your competitors, we highly recommend you conduct Research and ',
	      _react2.default.createElement(
	        'span',
	        null,
	        'review the Team Reports'
	      ),
	      ', particularly the ',
	      _react2.default.createElement(
	        'span',
	        null,
	        'Marketing Analysis (sub-section Customer Surveye)'
	      ),
	      '.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep23;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep3 = function (_PureComponent) {
	  _inherits(MarketShareStep3, _PureComponent);
	
	  function MarketShareStep3(props) {
	    _classCallCheck(this, MarketShareStep3);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep3.__proto__ || Object.getPrototypeOf(MarketShareStep3)).call(this, props));
	
	    _this.state = {
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_lte=' + activeRound).then(function (res) {
	        var products = res.body.filter(function (i) {
	          return Number(i.round) === roundId;
	        });
	
	        _this2.setState({
	          products: products
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var products = this.state.products;
	      var _props2 = this.props,
	          previousShownErrors = _props2.previousShownErrors,
	          activeRound = _props2.activeRound,
	          rounds = _props2.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Release Date Issue: You didn\u2019t have a product release in the round',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'A product needs to be release from design in order for you to manufacture and sell products'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Recommendations: Make sure you have at least product released in the active round.'
	          )
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(_table.Cell, { color: '#ffffff' }),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Release Date'
	            )
	          ),
	          products.map(function (product, index) {
	            var duration = Math.max(product.pixels_duration, product.sensitivity_duration, product.power_duration, product.temp_range_duration);
	
	            if (round && round.number > 1 && duration >= 12) {
	              duration += (round.number - 1) * 12;
	            }
	
	            var year = parseInt((duration - 1) / 12, 10);
	            var quarter = duration - year * 12;
	
	            year += 1;
	            quarter = quarter / 3 + 1;
	            if (quarter >= 5) {
	              quarter -= 4;
	              year += 1;
	            }
	
	            if (round && year < round.number) {
	              year = round.number;
	            }
	
	            var releaseDate = 'Year ' + year + ' Q' + quarter;
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                product.name
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                {
	                  percentageWidth: '70',
	                  color: 'rgba(0, 27, 59, 0.94)',
	                  fontWeight: '500',
	                  textAlign: 'center'
	                },
	                releaseDate
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true,
	          autoHeight: true
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep3;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep3;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep4 = function (_PureComponent) {
	  _inherits(MarketShareStep4, _PureComponent);
	
	  function MarketShareStep4(props) {
	    _classCallCheck(this, MarketShareStep4);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep4.__proto__ || Object.getPrototypeOf(MarketShareStep4)).call(this, props));
	
	    _this.state = {
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep4, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_lte=' + activeRound).then(function (res) {
	        var products = res.body.filter(function (i) {
	          return Number(i.round) === roundId;
	        });
	
	        _this2.setState({
	          products: products
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var products = this.state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Demand Issue : No customer was interested in buying some or all of your product(s).',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'To drive demand, you\u2019ll need to build products that customers want and to understand customers\' interest, conducting market research is critical.'
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(_table.Cell, { color: '#ffffff' }),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Resolution'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Sensitivity'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Power'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Temp Range'
	            )
	          ),
	          products.map(function (product, index) {
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                product.name
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.pixels_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.sensitivity_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.power_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.temp_range_rank
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep4;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep4;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2665);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var MarketShareStep5 = function MarketShareStep5() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    hideAlert: true,
	    subTitle: 'Understand the Customer',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Sergey Brin, the co-founder of Google, learned the hard way when his team launched one of the biggest and very public product flops: the Google Glass. The product was intended for mass consumers but insufficient market research led to low interest and adoption. Google ultimately decided to pivot from the mass consumer market. ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://medium.com/nyc-design/the-assumptions-that-led-to-failures-of-google-glass-8b40a07cfa1e#:~:text=Unfortunately%2C%20the%20Glass%20failed%20because,enough%20to%20appeal%20to%20everyone.', rel: 'noreferrer', target: '_blank' },
	        'Learn More'
	      )
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep5;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep7 = function (_PureComponent) {
	  _inherits(MarketShareStep7, _PureComponent);
	
	  function MarketShareStep7(props) {
	    _classCallCheck(this, MarketShareStep7);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep7.__proto__ || Object.getPrototypeOf(MarketShareStep7)).call(this, props));
	
	    _this.state = {
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep7, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_lte=' + activeRound).then(function (res) {
	        var products = res.body.filter(function (i) {
	          return Number(i.round) === roundId;
	        });
	
	        _this2.setState({
	          products: products
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var products = this.state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Demand Issue : Your product is chasing a small market.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'You have a product with features and pricing that met the interest of only a few customers that have smaller demand.'
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(_table.Cell, { color: '#ffffff' }),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Resolution'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Sensitivity'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Power'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Temp Range'
	            )
	          ),
	          products.map(function (product, index) {
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                product.name
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.pixels_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.sensitivity_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.power_rank
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                product.temp_range_rank
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep7;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep7;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2664);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var MarketShareStep8 = function MarketShareStep8() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'MARKET SHARE',
	    hideAlert: true,
	    subTitle: 'Product Market Fit',
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'When companies are building products, they consider the size of the opportunity (i.e. demand) in the development process partly because investors love big markets! Marc Andreessen, an influential venture capitalist in Silicon Valley, believes ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://pmarchive.com/guide_to_startups_part4.html', rel: 'noreferrer', target: '_blank' },
	        'market size is "the only thing that matters"'
	      ),
	      '.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = MarketShareStep8;

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/anchor-is-valid */
	
	
	var MarketShareStep1 = function (_PureComponent) {
	  _inherits(MarketShareStep1, _PureComponent);
	
	  function MarketShareStep1(props) {
	    _classCallCheck(this, MarketShareStep1);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep1.__proto__ || Object.getPrototypeOf(MarketShareStep1)).call(this, props));
	
	    _this.state = {
	      incomeStatement: {
	        costOfSales: {
	          name: "Cost of Sales",
	          data: {}
	        },
	        revenues: {
	          name: "Net Revenues",
	          data: {}
	        },
	        grossProfits: {
	          name: "Gross Profit",
	          data: {}
	        },
	        RnDCosts: {
	          name: "R&D Costs",
	          data: {}
	        },
	        holdingCosts: {
	          name: "Holding Costs",
	          data: {}
	        },
	        promotionCosts: {
	          name: "Promotion Costs",
	          data: {}
	        },
	        sellingCosts: {
	          name: "Selling Costs",
	          data: {}
	        },
	        gnACosts: {
	          name: "Other G&A Costs",
	          data: {}
	        },
	        incomingBeforeTaxes: {
	          name: "Income Before Taxes",
	          data: {}
	        },
	        taxes: {
	          name: "Taxes",
	          data: {}
	        },
	        totalOperatingExpenses: {
	          name: "Total Operating Costs",
	          data: {}
	        },
	        totalNonOperatingCost: {
	          name: "Total Non-Operating Costs",
	          data: {}
	        },
	        gainOrLossoFSales: {
	          name: "Gain or Loss of Sales",
	          data: {}
	        },
	        interestExpense: {
	          name: "Interest Expense",
	          data: {}
	        },
	        otherNonOperatingCosts: {
	          name: "Other Non-Operating Costs",
	          data: {}
	        },
	        netIncome: {
	          name: "Net Income",
	          data: {}
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var activeRound = this.props.activeRound;
	
	      var incomeStatement = Object.assign({}, this.state.incomeStatement);
	
	      for (var key in incomeStatement) {
	        incomeStatement[key].data = {
	          value: 0
	        };
	      }
	
	      (0, _FinancialStatementsService.fetchFinancialStatements)({ roundLte: activeRound }).then(function (financialData) {
	        var _loop = function _loop(_key) {
	          // eslint-disable-next-line
	          financialData.incomeStatement.forEach(function (item) {
	            var round_number = item.Round || item.round_number;
	            var hash = incomeStatement[_key].name;
	
	            if (round_number === activeRound && item[hash]) {
	              incomeStatement[_key].data.value = item[hash];
	            }
	          });
	        };
	
	        for (var _key in incomeStatement) {
	          _loop(_key);
	        }
	
	        _this2.setState({
	          incomeStatement: incomeStatement
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activeRound = this.props.activeRound;
	      var incomeStatement = this.state.incomeStatement;
	
	
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'FEEDBACK',
	        subSection: 'NET LOSS',
	        title: 'Negative Profits',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Unfortunately, your company\'s expenses (i.e. red line items) exceeded revenues and as a result, your company generated negative profits, which adversely impacted your team\'s ability to hit any profitability targets (e.g. ROE, ROA, or EPS).'
	        ),
	        visual: _react2.default.createElement(_incomeStatement2.default, {
	          incomeStatement: incomeStatement,
	          current_year: activeRound,
	          className: 'team-reports-with-scroll-2',
	          isPerformanceFeedback: true
	        }),
	        visualProps: {
	          padding: '10px'
	        }
	      });
	    }
	  }]);
	
	  return MarketShareStep1;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep1;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2656);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var NetLossStep2 = function NetLossStep2(_ref) {
	  var previousShownErrors = _ref.previousShownErrors;
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'NET LOSS',
	    previousShownErrors: previousShownErrors,
	    alertText: 'Your company generated a net loss.',
	    subTitle: 'You gotta make a profit!',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'It\'s very common and expected to generate losses in the early years, but investors expect companies to make a profit at some point.'
	    ),
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Uber learned the hard way when they went public, expecting to be valued at $120 billion dollars, but their net losses, which were in the billions, concerned investors to the point where Uber lost 60% of its market value within a few months of their IPO. ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.thedrive.com/news/27393/uber-officially-files-ipo-in-new-york-stock-exchange-with-valuation-of-up-to-120b', rel: 'noreferrer', target: '_blank' },
	        'Learn More'
	      )
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = NetLossStep2;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevenuesStep2 = function (_PureComponent) {
	  _inherits(RevenuesStep2, _PureComponent);
	
	  function RevenuesStep2(props) {
	    _classCallCheck(this, RevenuesStep2);
	
	    var _this = _possibleConstructorReturn(this, (RevenuesStep2.__proto__ || Object.getPrototypeOf(RevenuesStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      netRevenues: 0,
	      products: [],
	      totalRevenues: 0
	    };
	    return _this;
	  }
	
	  _createClass(RevenuesStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_lte=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound, ("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId()]).then(function (res) {
	        var products = res[0].body;
	        var productsFiltered = products.filter(function (i) {
	          return Number(i.round) === roundId;
	        });
	        var priceForecasts = res[1].body;
	        var inventoryBalances = res[2].body;
	
	        var totalRevenues = 0;
	
	        var _loop = function _loop(i) {
	          var priceForecast = priceForecasts.find(function (j) {
	            return j.product === productsFiltered[i].id;
	          });
	          var inventoryBalance = inventoryBalances.find(function (j) {
	            return j.product === productsFiltered[i].id;
	          });
	          productsFiltered[i].selling_price = priceForecast ? Number(priceForecast.price || 0) : 0;
	          productsFiltered[i].available_for_sale = inventoryBalance ? Number(inventoryBalance.available_for_sale || 0) : 0;
	          productsFiltered[i].total_revenues = productsFiltered[i].selling_price * productsFiltered[i].available_for_sale;
	          totalRevenues += productsFiltered[i].total_revenues;
	        };
	
	        for (var i = 0; i <= productsFiltered.length - 1; i++) {
	          _loop(i);
	        }
	
	        var targets = res[3].body;
	        var currentRoundTargets = targets.find(function (i) {
	          return i.round_number === activeRound;
	        });
	
	        _this2.setState({
	          loaded: true,
	          netRevenues: Number(currentRoundTargets.net_revenues || 0),
	          products: productsFiltered,
	          totalRevenues: totalRevenues
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'numberWithCommas',
	    value: function numberWithCommas(x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          netRevenues = _state.netRevenues,
	          products = _state.products,
	          totalRevenues = _state.totalRevenues;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'REVENUES',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Your product\'s selling price and/or units available for sale were too low.',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'As you can see below, the selling price (set by Marketing) and the units available for sale (set by Operations) reflect an expected sales value that is lower than the revenue target of ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            Number((netRevenues / 1000000).toFixed(2)),
	            'M'
	          ),
	          '.'
	        ),
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(_table.Cell, { color: '#ffffff' }),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Selling Price'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Available For Sale Inventory'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Total Expected Revenues'
	            )
	          ),
	          products.map(function (product, index) {
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                product.name
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                '$',
	                product.selling_price.toFixed(2)
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                _this3.numberWithCommas(product.available_for_sale)
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                '$',
	                _this3.numberWithCommas(product.total_revenues)
	              )
	            );
	          }),
	          _react2.default.createElement(
	            _table.Row,
	            null,
	            _react2.default.createElement(
	              _table.Cell,
	              { color: 'rgba(0, 27, 59, 0.94)' },
	              'Total Expected Revenues'
	            ),
	            _react2.default.createElement(_table.Cell, null),
	            _react2.default.createElement(_table.Cell, null),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	              '$',
	              this.numberWithCommas(totalRevenues)
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RevenuesStep2;
	}(_react.PureComponent);
	
	exports.default = RevenuesStep2;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n  text-align: center;\n  margin-bottom: 10px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n  text-align: center;\n  margin-bottom: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 35px;\n  background: #52c5cd;\n  position: relative;\n'], ['\n  width: 100%;\n  height: 35px;\n  background: #52c5cd;\n  position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 35px;\n  background: #00274c;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 35px;\n  background: #00274c;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 12.5px;\n\n  ', '\n\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background: #ff5252;\n  text-align: center;\n\n  span {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 12px;\n    color: rgba(0, 27, 59, 0.94);\n\n    position: relative;\n    top: 22px;\n\n    ', '\n  }\n'], ['\n  position: absolute;\n  top: 12.5px;\n\n  ', '\n\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background: #ff5252;\n  text-align: center;\n\n  span {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 12px;\n    color: rgba(0, 27, 59, 0.94);\n\n    position: relative;\n    top: 22px;\n\n    ', '\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  position: absolute;\n  bottom: -28px;\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  position: absolute;\n  bottom: -28px;\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ApiService = __webpack_require__(4);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Row = _styledComponents2.default.div(_templateObject);
	
	var Label = _styledComponents2.default.div(_templateObject2);
	
	var Line = _styledComponents2.default.div(_templateObject3);
	
	var InnerLine = _styledComponents2.default.div(_templateObject4);
	
	var RedDot = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.left && '\n    left: ' + p.left + ';\n  ';
	}, function (p) {
	  return p.cw && '\n      left: ' + p.cw + 'px;\n    ';
	});
	
	var XAxisLabel = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.left && '\n    left: ' + p.left + ';\n  ';
	});
	
	var RevenuesStep3 = function (_PureComponent) {
	  _inherits(RevenuesStep3, _PureComponent);
	
	  function RevenuesStep3(props) {
	    _classCallCheck(this, RevenuesStep3);
	
	    var _this = _possibleConstructorReturn(this, (RevenuesStep3.__proto__ || Object.getPrototypeOf(RevenuesStep3)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      prices: []
	    };
	    return _this;
	  }
	
	  _createClass(RevenuesStep3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var activeRound = this.props.activeRound;
	
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound).then(function (res) {
	        _this2.setState({
	          loaded: true,
	          prices: res.body.map(function (i) {
	            return Number(i.price);
	          }).filter(function (i) {
	            return i > 0;
	          })
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'convertPriceToPosition',
	    value: function convertPriceToPosition(price) {
	      if (price >= 12) {
	        return (Math.floor(price) - 12) / 0.46 + 50 + '%';
	      }
	
	      return (Math.floor(price) - 2) * 5 + '%';
	    }
	  }, {
	    key: 'convertPriceToCW',
	    value: function convertPriceToCW(price) {
	      return (('' + price).replace(/[^0-9]/, '').length + 1) / 2 * -5;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          prices = _state.prices;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'REVENUES',
	        hideAlert: true,
	        subTitle: 'Pricing Your Products',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Let\'s explore your pricing. Here\'s the price range of what customers are willing to pay in relation to the prices that you set for your product(s).'
	        ),
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Given what customers\' are willing to pay and other Research data, could you have set your product\'s selling prices higher to meet your revenue target?'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            Row,
	            null,
	            _react2.default.createElement(
	              Label,
	              null,
	              'Mobile'
	            ),
	            _react2.default.createElement(
	              Label,
	              null,
	              'Auto'
	            )
	          ),
	          _react2.default.createElement(
	            Row,
	            null,
	            _react2.default.createElement(
	              Line,
	              null,
	              _react2.default.createElement(InnerLine, null),
	              prices.map(function (price, index) {
	                return _react2.default.createElement(
	                  RedDot,
	                  { key: 'red-dot-' + index, left: _this3.convertPriceToPosition(price), cw: _this3.convertPriceToCW(price) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '$',
	                    price
	                  )
	                );
	              }),
	              _react2.default.createElement(
	                XAxisLabel,
	                { left: '-10px' },
	                '$2'
	              ),
	              _react2.default.createElement(
	                XAxisLabel,
	                { left: 'calc(50% - 15px)' },
	                '$12'
	              ),
	              _react2.default.createElement(
	                XAxisLabel,
	                { left: 'calc(100% - 20px)' },
	                '$35'
	              )
	            )
	          )
	        ),
	        visualProps: {
	          flexCenter: true,
	          flexDirection: 'column',
	          noPadding: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RevenuesStep3;
	}(_react.PureComponent);
	
	exports.default = RevenuesStep3;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _recharts = __webpack_require__(27);
	
	var _ApiService = __webpack_require__(4);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _reactLoaders = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevenuesStep4 = function (_PureComponent) {
	  _inherits(RevenuesStep4, _PureComponent);
	
	  function RevenuesStep4(props) {
	    _classCallCheck(this, RevenuesStep4);
	
	    var _this = _possibleConstructorReturn(this, (RevenuesStep4.__proto__ || Object.getPrototypeOf(RevenuesStep4)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      loaded: false,
	      freeSpace: 0,
	      teamUnits: 0,
	      teamUnitsPercent: 0,
	      totalDemand: 0
	    };
	    return _this;
	  }
	
	  _createClass(RevenuesStep4, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var activeRound = this.props.activeRound;
	
	
	      Promise.all([(0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound),
	      // performance-feedback scope pre-filters total_demand to the
	      // requested round and drops the round_number column, so the
	      // per-row find becomes just [0].
	      (0, _StaticDataService.fetchAllStaticData)(activeRound, 'performance-feedback')]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            inventoryRes = _ref2[0],
	            staticData = _ref2[1];
	
	        var inventoryBalances = inventoryRes.body;
	        var teamUnits = inventoryBalances.map(function (i) {
	          return Math.abs(Number(i.available_for_sale || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	
	        var totalDemandValue = (staticData.totalDemand || [])[0];
	        var totalDemand = Number(totalDemandValue && totalDemandValue.total);
	
	        var teamUnitsPercent = Number((teamUnits / totalDemand * 100).toFixed(2));
	        var freeSpace = 100 - teamUnitsPercent;
	
	        _this2.setState({
	          loaded: true,
	          freeSpace: freeSpace,
	          teamUnits: teamUnits,
	          teamUnitsPercent: teamUnitsPercent,
	          totalDemand: totalDemand
	        });
	      }).catch(function () {});
	    }
	  }, {
	    key: 'numberWithCommas',
	    value: function numberWithCommas(x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          freeSpace = _state.freeSpace,
	          teamUnits = _state.teamUnits,
	          teamUnitsPercent = _state.teamUnitsPercent;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'REVENUES',
	        hideAlert: true,
	        subTitle: 'Building Inventory to Meet Demand',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Let\'s now look at the amount of inventory available for sale. Here\'s what customers demanded this past round in relation to the number of units you had available for sale (i.e. volume).'
	        ),
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Given customers\' demand and other Research data, could your team have produced more inventory to hit your revenue target especially if your team believed it did not make sense to increase your selling prices?'
	        ),
	        visual: _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: '100%', height: 320 },
	          _react2.default.createElement(
	            _recharts.PieChart,
	            null,
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                data: [{ name: 'Free space', hideLabel: true, value: freeSpace }, { name: 'Team\'s units available for sale', originalValue: teamUnits, value: teamUnitsPercent }],
	                cx: '50%',
	                cy: '50%',
	                innerRadius: 60,
	                outerRadius: 90,
	                fill: '#8884d8',
	                dataKey: 'value',
	                label: this.renderLabel,
	                labelLine: false,
	                startAngle: 90,
	                endAngle: 450
	              },
	              '$',
	              ['#52c5cd', '#f9c151'].map(function (color, index) {
	                return _react2.default.createElement(_recharts.Cell, { key: 'pie-cell-' + index, fill: color });
	              })
	            )
	          )
	        )
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RevenuesStep4;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.renderLabel = function (props) {
	    var cx = props.cx,
	        cy = props.cy,
	        midAngle = props.midAngle,
	        outerRadius = props.outerRadius,
	        value = props.value,
	        name = props.name,
	        index = props.index,
	        payload = props.payload;
	    var originalValue = payload.originalValue;
	    var totalDemand = _this3.state.totalDemand;
	
	    var RADIAN = Math.PI / 180;
	    var sin = Math.sin(-RADIAN * midAngle);
	    var cos = Math.cos(-RADIAN * midAngle);
	    var sx = cx + (outerRadius + 10) * cos;
	    var sy = cy + (outerRadius + 10) * sin;
	    var mx = cx + (outerRadius + 30) * cos;
	    var my = cy + (outerRadius + 30) * sin;
	    var ex = mx + (cos >= 0 ? 1 : -1) * 35;
	    var ey = my;
	    var textAnchor = cos >= 0 ? 'start' : 'end';
	    var hideLabel = payload.hideLabel || false;
	
	    return _react2.default.createElement(
	      'g',
	      null,
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: -10,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        'Total Units'
	      ),
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: 10,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        'Demanded'
	      ),
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: 30,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        Number((totalDemand / 1000000).toFixed(2)),
	        'M'
	      ),
	      !hideLabel && _react2.default.createElement('path', { d: 'M' + sx + ',' + sy + 'L' + mx + ',' + my + 'L' + ex + ',' + ey, stroke: 'rgba(0, 27, 59, 0.94)', fill: 'none' }),
	      !hideLabel && _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: -10,
	          textAnchor: textAnchor,
	          className: 'chartLabel'
	        },
	        value + '%'
	      ),
	      !hideLabel && _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: 10,
	          textAnchor: textAnchor,
	          className: 'chartDescription1'
	        },
	        _this3.numberWithCommas(originalValue)
	      ),
	      !hideLabel && _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: 32,
	          textAnchor: textAnchor,
	          className: 'chartDescription2'
	        },
	        name
	      )
	    );
	  };
	};
	
	exports.default = RevenuesStep4;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _formulaValue = __webpack_require__(217);
	
	var _formulaValue2 = _interopRequireDefault(_formulaValue);
	
	var _formulaName = __webpack_require__(216);
	
	var _formulaName2 = _interopRequireDefault(_formulaName);
	
	var _ApiService = __webpack_require__(4);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoaStep2 = function (_PureComponent) {
	  _inherits(RoaStep2, _PureComponent);
	
	  function RoaStep2(props) {
	    _classCallCheck(this, RoaStep2);
	
	    var _this = _possibleConstructorReturn(this, (RoaStep2.__proto__ || Object.getPrototypeOf(RoaStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      averageTotalAssets: 0,
	      totalAssets: 0,
	      netIncome: 0
	    };
	    return _this;
	  }
	
	  _createClass(RoaStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	      var prevRound = rounds.find(function (i) {
	        return i.number === activeRound - 1;
	      });
	      var prevRoundId = prevRound ? prevRound.id : 0;
	
	      Promise.all([(0, _FinancialStatementsService.fetchFinancialStatements)({ roundLte: activeRound }), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId())]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            financialData = _ref2[0],
	            targetsRes = _ref2[1];
	
	        var balanceSheet = financialData.balanceSheet;
	        var currentRoundBalanceSheet = balanceSheet.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var prevRoundBalanceSheet = balanceSheet.find(function (i) {
	          return i.Round === activeRound - 1;
	        });
	
	        var totalAssets = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Assets'] || 0) : 0;
	        if (prevRoundBalanceSheet) {
	          var prevTotalAssets = Number(prevRoundBalanceSheet['Total Assets'] || 0);
	          totalAssets = (totalAssets + prevTotalAssets) / 2;
	        }
	
	        var incomeStatement = financialData.incomeStatement;
	        var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;
	
	        var targets = targetsRes.body;
	        var currentRoundTargets = targets.find(function (i) {
	          return i.round_number === activeRound;
	        });
	        var roaTarget = currentRoundTargets ? Number(currentRoundTargets.roa || 0) : 0;
	
	        _this2.setState({
	          loaded: true,
	          averageTotalAssets: totalAssets * roaTarget,
	          totalAssets: totalAssets,
	          netIncome: netIncome
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          averageTotalAssets = _state.averageTotalAssets,
	          totalAssets = _state.totalAssets,
	          netIncome = _state.netIncome;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'ROA',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Your net profit was not enough.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Given your average total assets, your company needed to generate ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            Number((averageTotalAssets / 1000000).toFixed(2)),
	            'M'
	          ),
	          ' in net profits in order to hit your ROA target.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _formulaName2.default,
	            { background: '#5c91f5' },
	            'Return on Assets',
	            _react2.default.createElement('br', null),
	            '(ROA)'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            'Net Profits',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Total Assets'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: netIncome,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: totalAssets,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#d5d9dd',
	          background: '#e6edfb',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RoaStep2;
	}(_react.PureComponent);
	
	exports.default = RoaStep2;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2654);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoaStep3 = function RoaStep3() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'ROA',
	    hideAlert: true,
	    subTitle: 'Return on Investments',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Some companies have sizable assets and therefore it can be challenging to generate the needed income to hit a decent return on their assets. Apple is not one of those companies.'
	    ),
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'For example, Apple\'s average total assets in $337 billion dollars. To generate just 1% return on assets, Apple would need to generate $3.52 billion dollars in net profits. The company, however, generated $94 billion dollars, which based on their average total assets is a 28% ROA.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = RoaStep3;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _formulaValue = __webpack_require__(217);
	
	var _formulaValue2 = _interopRequireDefault(_formulaValue);
	
	var _formulaName = __webpack_require__(216);
	
	var _formulaName2 = _interopRequireDefault(_formulaName);
	
	var _ApiService = __webpack_require__(4);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoeStep2 = function (_PureComponent) {
	  _inherits(RoeStep2, _PureComponent);
	
	  function RoeStep2(props) {
	    _classCallCheck(this, RoeStep2);
	
	    var _this = _possibleConstructorReturn(this, (RoeStep2.__proto__ || Object.getPrototypeOf(RoeStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      averageTotalEquity: 0,
	      totalEquity: 0,
	      netIncome: 0
	    };
	    return _this;
	  }
	
	  _createClass(RoeStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	      var prevRound = rounds.find(function (i) {
	        return i.number === activeRound - 1;
	      });
	      var prevRoundId = prevRound ? prevRound.id : 0;
	
	      Promise.all([(0, _FinancialStatementsService.fetchFinancialStatements)({ roundLte: activeRound }), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId())]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            financialData = _ref2[0],
	            targetsRes = _ref2[1];
	
	        var balanceSheet = financialData.balanceSheet;
	        var currentRoundBalanceSheet = balanceSheet.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var prevRoundBalanceSheet = balanceSheet.find(function (i) {
	          return i.Round === activeRound - 1;
	        });
	
	        var totalEquity = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Equity'] || 0) : 0;
	        if (prevRoundBalanceSheet) {
	          var prevTotalEquity = Number(prevRoundBalanceSheet['Total Equity'] || 0);
	          totalEquity = (totalEquity + prevTotalEquity) / 2;
	        }
	
	        var incomeStatement = financialData.incomeStatement;
	        var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	          return i.Round === activeRound;
	        });
	        var netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;
	
	        var targets = targetsRes.body;
	        var currentRoundTargets = targets.find(function (i) {
	          return i.round_number === activeRound;
	        });
	        var roeTarget = currentRoundTargets ? Number(currentRoundTargets.roe || 0) : 0;
	
	        _this2.setState({
	          loaded: true,
	          averageTotalEquity: totalEquity * roeTarget,
	          totalEquity: totalEquity,
	          netIncome: netIncome
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          averageTotalEquity = _state.averageTotalEquity,
	          totalEquity = _state.totalEquity,
	          netIncome = _state.netIncome;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'ROE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Your net profit was not enough.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Given your average total equity, your company needed to generate ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '$',
	            Number((averageTotalEquity / 1000000).toFixed(2)),
	            'M'
	          ),
	          ' in net profits in order to hit your ROE target.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _formulaName2.default,
	            { background: '#a98df6' },
	            'Return on Equity',
	            _react2.default.createElement('br', null),
	            '(ROE)'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            'Net Profits',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Total Equity'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: netIncome,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: totalEquity,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#d5d9dd',
	          background: '#eae4f9',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RoeStep2;
	}(_react.PureComponent);
	
	exports.default = RoeStep2;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2655);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var RoeStep3 = function RoeStep3() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'ROE',
	    hideAlert: true,
	    subTitle: 'Return on Investments',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Investors expect a minimum return on their investments.'
	    ),
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'It\'s a key reason why Warren Buffet, one of the most successful investors in the world, passed on Japan\'s private sector in the \'90s: their return on equity was on of the lowest within the developed world.',
	      _react2.default.createElement('br', null),
	      'Times have changed since ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.youtube.com/watch?v=P55HPJAH_v0', rel: 'noreferrer', target: '_blank' },
	        'Warren Buffett\'s famous 1998 speech on investing in Japan'
	      ),
	      '. Japanese companies are generating higher ROE and Buffet recently made sizable investments in Japan\'s private sector.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = RoeStep3;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _formulaValue = __webpack_require__(217);
	
	var _formulaValue2 = _interopRequireDefault(_formulaValue);
	
	var _formulaName = __webpack_require__(216);
	
	var _formulaName2 = _interopRequireDefault(_formulaName);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/anchor-is-valid */
	
	
	var SharePriceStep2 = function (_PureComponent) {
	  _inherits(SharePriceStep2, _PureComponent);
	
	  function SharePriceStep2(props) {
	    _classCallCheck(this, SharePriceStep2);
	
	    var _this = _possibleConstructorReturn(this, (SharePriceStep2.__proto__ || Object.getPrototypeOf(SharePriceStep2)).call(this, props));
	
	    _this.state = {
	      loaded: false,
	      marketValue: 0,
	      shares: 0
	    };
	    return _this;
	  }
	
	  _createClass(SharePriceStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	
	      var gameId = Number(_Auth2.default.getGameId());
	      var team = _Teams2.default.currentTeam();
	      var teamId = Number(team.id);
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundId = round ? round.id : 0;
	      var prevRound = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound) - 1;
	      });
	      var prevRoundId = prevRound ? prevRound.id : 0;
	
	      var currentPromise = (0, _MetricsService.fetchTeamMetrics)(teamId, roundId);
	      var prevPromise = prevRoundId ? (0, _MetricsService.fetchTeamMetrics)(teamId, prevRoundId) : Promise.resolve([]);
	
	      Promise.all([currentPromise, prevPromise]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            currentResults = _ref2[0],
	            prevResults = _ref2[1];
	
	        var currentRoundMetrics = currentResults.find(function (i) {
	          return Number(i.game) === gameId && Number(i.round) === roundId;
	        });
	        var prevRoundMetrics = prevResults.find(function (i) {
	          return Number(i.game) === gameId && Number(i.round) === prevRoundId;
	        });
	
	        var marketValue = currentRoundMetrics ? Number(currentRoundMetrics.total_market_capital || 0) : 0;
	        var shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;
	        if (prevRoundMetrics) {
	          var prevShares = Number(prevRoundMetrics.shares || 0);
	          shares = (shares + prevShares) / 2;
	        }
	
	        _this2.setState({
	          loaded: true,
	          marketValue: marketValue,
	          shares: shares
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          marketValue = _state.marketValue,
	          shares = _state.shares;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'SHARE PRICE',
	        previousShownErrors: previousShownErrors,
	        alertText: 'Here\u2019s what impacted your share price.',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'In round 1 & 2, investors determine your valuation by taking your revenues and applying a revenue multiplier, which is commonly known as: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.investopedia.com/terms/p/price-to-salesratio.asp', target: '_blank', rel: 'noreferrer' },
	            'price to sales ratio'
	          ),
	          '. Therefore higher revenues should drive a higher valuation and hopefully a higher share price.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _formulaName2.default,
	            { background: '#6fd1d9', padding: '30px 53px', color: 'rgba(0, 27, 59, 0.94)' },
	            'Share Price'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            'Business Value',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Shares Outstanding'
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _formulaValue2.default,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: marketValue,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: shares,
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#d5d9dd',
	          background: '#d7f0f2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return SharePriceStep2;
	}(_react.PureComponent);
	
	exports.default = SharePriceStep2;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(32);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _pf = __webpack_require__(2657);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/anchor-is-valid */
	var SharePriceStep3 = function SharePriceStep3() {
	  return _react2.default.createElement(_banner2.default, {
	    section: 'FEEDBACK',
	    subSection: 'SHARE PRICE',
	    hideAlert: true,
	    subTitle: 'Excess Share Issuance',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Issuing too many shares can also reduce a company\u2019s share price if the new shares are offered at a price below the share\u2019s current price. Google, for example, felt their share price was too high and therefore intentionally reduced their share price by issuing excessive # of new shares at an implied price of $0 (i.e. via stock split). ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.cnbc.com/2022/02/02/what-is-a-stock-split-what-alphabets-20-for-1-split-means-for-you.html', rel: 'noreferrer', target: '_blank' },
	        'Learn More'
	      )
	    ),
	    paragraph2: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'In the simulation, all new shares are issued at current prices and therefore issuing new shares will technically not have an adverse impact on your company\'s value.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = SharePriceStep3;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _pf = __webpack_require__(2663);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoodLuckStep1 = function GoodLuckStep1() {
	  return _react2.default.createElement(_oneVisual2.default, {
	    section: 'GOOD LUCK!',
	    title: 'See You in the Next Round',
	    paragraph2: _react2.default.createElement(
	      'span',
	      null,
	      'Expect a few changes next year based on current market performance.'
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = GoodLuckStep1;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _pf = __webpack_require__(2667);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResearchAndInvestigateStep1 = function ResearchAndInvestigateStep1() {
	  return _react2.default.createElement(_oneVisual2.default, {
	    section: 'RESEARCH & INVESTIGATE',
	    title: 'Do Your Homework Before Next Round',
	    paragraph1: _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      'Before you commit to next round\'s decisions:',
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Open your Team Report. How did your results compare to the top teams? What did they do differently?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Review the Customer Analysis. Have customer preferences shifted? What matters most to them now?'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Re-read the business case for details you skimmed the first time.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Revisit the financial metrics and targets you need to hit next round.'
	        )
	      )
	    ),
	    visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'preview' }),
	    visualProps: {
	      noBorder: true,
	      noBackground: true
	    }
	  });
	};
	
	exports.default = ResearchAndInvestigateStep1;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 16px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #ffffff;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  padding: 16px;\n  text-align: center;\n  border-radius: 8px;\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #ffffff;\n\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  ', '\n\n  span.divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n\n  b, .negative-value {\n    color: #EC5E59;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  ', '\n\n  ', '\n\n  span.divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 27, 59, 0.94);\n    margin: 13px 0 13px -5px;\n    width: calc(100% + 10px);\n  }\n\n  b, .negative-value {\n    color: #EC5E59;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FormulaName = _styledComponents2.default.div(_templateObject, function (p) {
	  return p.background && '\n    background-color: ' + p.background + ';\n  ';
	}, function (p) {
	  return p.padding && '\n    padding: ' + p.padding + ';\n  ';
	}, function (p) {
	  return p.color && '\n    color: ' + p.color + ';\n  ';
	});
	
	var FormulaValue = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.fontSize && '\n    font-size: ' + p.fontSize + ';\n  ';
	}, function (p) {
	  return p.isNegative && '\n    color: #EC5E59;\n  ';
	});
	
	var ResultsAreInStep1 = function (_PureComponent) {
	  _inherits(ResultsAreInStep1, _PureComponent);
	
	  function ResultsAreInStep1(props) {
	    _classCallCheck(this, ResultsAreInStep1);
	
	    var _this = _possibleConstructorReturn(this, (ResultsAreInStep1.__proto__ || Object.getPrototypeOf(ResultsAreInStep1)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var activeRound = _this.props.activeRound;
	
	      var teamId = _Auth2.default.getTeamId();
	
	      (0, _ApiService.getRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/page/financials/?round_number=' + activeRound + '&team_id=' + teamId]).then(function (res) {
	        var teamFinancialsEndingCash = res.body.team.ending_cash;
	
	        _this.setState({
	          loaded: true,
	          teamFinancialsEndingCash: teamFinancialsEndingCash
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      teamFinancialsEndingCash: 0
	    };
	    return _this;
	  }
	
	  _createClass(ResultsAreInStep1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamFinancialsEndingCash = _state.teamFinancialsEndingCash;
	
	
	      return loaded ? _react2.default.createElement(_oneVisual2.default, {
	        section: 'RESULTS ARE IN!',
	        title: 'Insufficient Capital',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Your team did not have enough capital to cover your product, marketing, and/or operation spending decisions. Therefore some or all of your team decisions were not accepted.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _reactDotFragment2.default,
	            null,
	            _react2.default.createElement(
	              FormulaName,
	              { background: '#4CC7D1', color: 'rgba(0, 27, 59, 0.94)' },
	              'Insufficient Capital'
	            ),
	            _react2.default.createElement(
	              FormulaValue,
	              { fontSize: '28px' },
	              '='
	            ),
	            _react2.default.createElement(
	              FormulaValue,
	              { fontSize: '40px', isNegative: teamFinancialsEndingCash < 0 },
	              teamFinancialsEndingCash.toLocaleString('en-US', {
	                style: 'currency',
	                currency: 'USD',
	                maximumFractionDigits: 0
	              })
	            )
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#D7F0F2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ResultsAreInStep1;
	}(_react.PureComponent);
	
	exports.default = ResultsAreInStep1;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #55b4bc;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: default;\n'], ['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #55b4bc;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: default;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid #ec5e59;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ec5e59;\n  cursor: default;\n'], ['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid #ec5e59;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ec5e59;\n  cursor: default;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _table = __webpack_require__(154);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SubmittedButton = _styledComponents2.default.div(_templateObject);
	
	var NotSubmittedButton = _styledComponents2.default.div(_templateObject2);
	
	var ResultsAreInStep2 = function (_PureComponent) {
	  _inherits(ResultsAreInStep2, _PureComponent);
	
	  function ResultsAreInStep2(props) {
	    _classCallCheck(this, ResultsAreInStep2);
	
	    var _this = _possibleConstructorReturn(this, (ResultsAreInStep2.__proto__ || Object.getPrototypeOf(ResultsAreInStep2)).call(this, props));
	
	    _this.state = {
	      result: {
	        pd: false,
	        pm: false,
	        op: false,
	        fn: false
	      },
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(ResultsAreInStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var activeRound = this.props.activeRound;
	
	      var keys = {
	        pd: 'submit_development',
	        pm: 'submit_marketing',
	        op: 'submit_operations',
	        fn: 'submit_finance'
	      };
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'games/' + _Auth2.default.getGameId() + '/journal/?round_number=' + activeRound).then(function (res) {
	        var result = {};
	        var history = [].concat(_toConsumableArray(res.body));
	        history.sort(function (a, b) {
	          var dateA = new Date(a.requested_at);
	          var dateB = new Date(b.requested_at);
	
	          return dateB - dateA;
	        });
	
	        ['pd', 'pm', 'op', 'fn'].forEach(function (type) {
	          result[type] = false;
	
	          var obj = history.find(function (i) {
	            return i.path === '/api/teams/' + keys[type] + '/';
	          });
	          if (obj && obj.response && typeof obj.response.success !== 'undefined') {
	            result[type] = obj.response.success;
	          }
	        });
	
	        _this2.setState({
	          result: result,
	          loaded: true
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          result = _state.result,
	          loaded = _state.loaded;
	
	
	      return loaded ? _react2.default.createElement(_oneVisual2.default, {
	        section: 'RESULTS ARE IN!',
	        title: 'Decisions Not Posted',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'It looks like all of your team decisions were not successfully posted. This could be due to your team either not making or posting all decisions. You can always check submission status on ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'the CEO page'
	          ),
	          '.'
	        ),
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _table.Table,
	            null,
	            _react2.default.createElement(
	              _table.Row,
	              { background: '#2a4169' },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: '#ffffff' },
	                'Department'
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: '#ffffff' },
	                'Submission Status'
	              )
	            ),
	            _react2.default.createElement(
	              _table.Row,
	              { background: 'rgba(0, 27, 43, 0.02)' },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)' },
	                'Product Management'
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                null,
	                result.pd && _react2.default.createElement(
	                  SubmittedButton,
	                  null,
	                  'Submitted'
	                ),
	                !result.pd && _react2.default.createElement(
	                  NotSubmittedButton,
	                  null,
	                  'Not Submitted'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _table.Row,
	              { background: 'rgba(0, 27, 43, 0.02)' },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)' },
	                'Product Marketing'
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                null,
	                result.pm && _react2.default.createElement(
	                  SubmittedButton,
	                  null,
	                  'Submitted'
	                ),
	                !result.pm && _react2.default.createElement(
	                  NotSubmittedButton,
	                  null,
	                  'Not Submitted'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _table.Row,
	              { background: 'rgba(0, 27, 43, 0.02)' },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)' },
	                'Operations'
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                null,
	                result.op && _react2.default.createElement(
	                  SubmittedButton,
	                  null,
	                  'Submitted'
	                ),
	                !result.op && _react2.default.createElement(
	                  NotSubmittedButton,
	                  null,
	                  'Not Submitted'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _table.Row,
	              { background: 'rgba(0, 27, 43, 0.02)' },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)' },
	                'Finance'
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                null,
	                result.fn && _react2.default.createElement(
	                  SubmittedButton,
	                  null,
	                  'Submitted'
	                ),
	                !result.fn && _react2.default.createElement(
	                  NotSubmittedButton,
	                  null,
	                  'Not Submitted'
	                )
	              )
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ResultsAreInStep2;
	}(_react.PureComponent);
	
	exports.default = ResultsAreInStep2;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _marketRanking = __webpack_require__(1204);
	
	var _marketRanking2 = _interopRequireDefault(_marketRanking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// "Round Team Score" step — replaces the previous Overall Score
	// bar / Score Trend line chart layout with a per-rank celebration
	// screen keyed off the team's `ranking` string from teamgradings.
	//
	// Data flow:
	//   1. Fetch /v2/games/teamgradings/?round=<thisRoundId>&game=<gameId>
	//      (no &team= filter) — gives us this team's row PLUS every other
	//      team in the cohort. From that one response we get the team's
	//      score + ranking and can compute highest / median / average.
	//   2. If we're past round 1, also fetch the prior round (team
	//      filtered) to compute the round-over-round changePct.
	//
	// Both calls are wrapped so a single failure doesn't blank the page.
	var ResultsAreInStep5 = function (_PureComponent) {
	  _inherits(ResultsAreInStep5, _PureComponent);
	
	  function ResultsAreInStep5(props) {
	    _classCallCheck(this, ResultsAreInStep5);
	
	    var _this = _possibleConstructorReturn(this, (ResultsAreInStep5.__proto__ || Object.getPrototypeOf(ResultsAreInStep5)).call(this, props));
	
	    _this.fetchData = function () {
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      var gameId = Number(_Auth2.default.getGameId());
	      var team = _Teams2.default.currentTeam();
	      var teamId = Number(team && team.id);
	      var teamName = team && team.name || 'Your team';
	      var roundNumber = Number(activeRound);
	      var thisRound = rounds.find(function (i) {
	        return Number(i.number) === roundNumber;
	      });
	      var thisRoundId = thisRound ? Number(thisRound.id) : 0;
	      var prevRound = roundNumber > 1 ? rounds.find(function (i) {
	        return Number(i.number) === roundNumber - 1;
	      }) : null;
	      var prevRoundId = prevRound ? Number(prevRound.id) : 0;
	
	      var thisRoundReq = (0, _ApiService.getRequest)(apiUrl + 'v2/games/teamgradings/?round=' + thisRoundId + '&game=' + gameId).catch(function () {
	        return null;
	      });
	
	      var prevRoundReq = prevRoundId ? (0, _ApiService.getRequest)(apiUrl + 'v2/games/teamgradings/?round=' + prevRoundId + '&game=' + gameId + '&team=' + teamId).catch(function () {
	        return null;
	      }) : Promise.resolve(null);
	
	      // Cohort is the current team's competition (a subset of the
	      // game), not the whole game. Teams.teams() already returns the
	      // teams in the current team's competition; use those ids to
	      // filter the teamgradings response.
	      var competitionTeamIds = new Set(_Teams2.default.teams().map(function (t) {
	        return Number(t.id);
	      }));
	
	      Promise.all([thisRoundReq, prevRoundReq]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            thisRes = _ref2[0],
	            prevRes = _ref2[1];
	
	        var allRows = thisRes && thisRes.body && thisRes.body.results || [];
	        var cohortRows = allRows.filter(function (r) {
	          return Number(r.game) === gameId && competitionTeamIds.has(Number(r.team));
	        });
	        var myRow = cohortRows.find(function (r) {
	          return Number(r.team) === teamId;
	        }) || null;
	
	        var score = myRow ? Number(myRow.current_weighted_value) || 0 : 0;
	        var rankName = myRow && myRow.ranking ? String(myRow.ranking) : '';
	        var rank = _marketRanking.RANK_NAME_TO_NUMBER[rankName.toLowerCase()] || null;
	        var totalTeams = cohortRows.length;
	
	        // Cohort stats — read directly off the team's own gradings
	        // row. The backend already computes highest / median / average
	        // at the competition level for student users, so trusting
	        // those fields keeps the UI aligned with what's on the wire
	        // instead of re-deriving them locally.
	        var highest = myRow ? Number(myRow.highest_weighted_value) || 0 : 0;
	        var median = myRow ? Number(myRow.median_weighted_value) || 0 : 0;
	        var average = myRow ? Number(myRow.average_weighted_value) || 0 : 0;
	
	        // Prior-round score → changePct. Null for round 1 or when
	        // the prior score was zero (avoids divide-by-zero).
	        var changePct = null;
	        if (prevRes && prevRes.body && Array.isArray(prevRes.body.results)) {
	          var prevRow = prevRes.body.results.find(function (r) {
	            return Number(r.team) === teamId;
	          });
	          if (prevRow) {
	            var prevScore = Number(prevRow.current_weighted_value) || 0;
	            if (prevScore > 0) {
	              changePct = (score - prevScore) / prevScore * 100;
	            }
	          }
	        }
	
	        _this.setState({
	          loaded: true,
	          rank: rank,
	          teamName: teamName,
	          totalTeams: totalTeams,
	          score: score,
	          changePct: changePct,
	          cohort: { highest: highest, median: median, average: average }
	        });
	      }).catch(function () {
	        _this.setState({ loaded: true });
	      });
	    };
	
	    _this.state = {
	      loaded: false,
	      rank: null,
	      teamName: '',
	      totalTeams: 0,
	      score: 0,
	      changePct: null,
	      cohort: null
	    };
	    return _this;
	  }
	
	  _createClass(ResultsAreInStep5, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          rank = _state.rank,
	          teamName = _state.teamName,
	          totalTeams = _state.totalTeams,
	          score = _state.score,
	          changePct = _state.changePct,
	          cohort = _state.cohort;
	
	
	      if (!loaded) {
	        return _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	      }
	
	      return _react2.default.createElement(_marketRanking2.default, {
	        teamName: teamName,
	        rank: rank,
	        totalTeams: totalTeams,
	        score: score,
	        changePct: changePct,
	        cohort: cohort
	      });
	    }
	  }]);
	
	  return ResultsAreInStep5;
	}(_react.PureComponent);
	
	exports.default = ResultsAreInStep5;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n'], ['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n'], ['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(181);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FinancialTargetsAndPerformance = __webpack_require__(1288);
	
	var _FinancialTargetsAndPerformance2 = _interopRequireDefault(_FinancialTargetsAndPerformance);
	
	var _goalsAndTargetsMarketShare = __webpack_require__(560);
	
	var _goalsAndTargetsMarketShare2 = _interopRequireDefault(_goalsAndTargetsMarketShare);
	
	var _goalsAndTargetsRevenues = __webpack_require__(561);
	
	var _goalsAndTargetsRevenues2 = _interopRequireDefault(_goalsAndTargetsRevenues);
	
	var _goalsAndTargetsGrossMargins = __webpack_require__(559);
	
	var _goalsAndTargetsGrossMargins2 = _interopRequireDefault(_goalsAndTargetsGrossMargins);
	
	var _goalsAndTargetsSharePrice = __webpack_require__(564);
	
	var _goalsAndTargetsSharePrice2 = _interopRequireDefault(_goalsAndTargetsSharePrice);
	
	var _goalsAndTargetsRoe = __webpack_require__(563);
	
	var _goalsAndTargetsRoe2 = _interopRequireDefault(_goalsAndTargetsRoe);
	
	var _goalsAndTargetsRoa = __webpack_require__(562);
	
	var _goalsAndTargetsRoa2 = _interopRequireDefault(_goalsAndTargetsRoa);
	
	var _goalsAndTargetsEps = __webpack_require__(558);
	
	var _goalsAndTargetsEps2 = _interopRequireDefault(_goalsAndTargetsEps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var videos = {
	  'Market Share': _goalsAndTargetsMarketShare2.default,
	  'Revenues': _goalsAndTargetsRevenues2.default,
	  'Gross Margins': _goalsAndTargetsGrossMargins2.default,
	  'Share Price': _goalsAndTargetsSharePrice2.default,
	  'ROE': _goalsAndTargetsRoe2.default,
	  'ROA': _goalsAndTargetsRoa2.default,
	  'EPS': _goalsAndTargetsEps2.default
	};
	
	var ModalVideoWrapper = _styledComponents2.default.div(_templateObject);
	
	var PlayPauseButton = _styledComponents2.default.button(_templateObject2);
	
	var CloseModalVideoButton = _styledComponents2.default.button(_templateObject3);
	
	var ResultsAreInStep6 = function (_PureComponent) {
	  _inherits(ResultsAreInStep6, _PureComponent);
	
	  function ResultsAreInStep6(props) {
	    _classCallCheck(this, ResultsAreInStep6);
	
	    var _this = _possibleConstructorReturn(this, (ResultsAreInStep6.__proto__ || Object.getPrototypeOf(ResultsAreInStep6)).call(this, props));
	
	    _this.handlePlayPause = function () {
	      if (_this.videoRef) {
	        if (_this.state.isVideoPlaying) {
	          _this.videoRef.pause();
	        } else {
	          _this.videoRef.play();
	        }
	        _this.setState({ isVideoPlaying: !_this.state.isVideoPlaying });
	      }
	    };
	
	    _this.openModal = function (videoSrc) {
	      _this.setState({
	        isModalShown: true,
	        selectedVideo: videoSrc
	      });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({
	        isModalShown: false,
	        isVideoPlaying: false
	      });
	    };
	
	    _this.onHelpIconClick = function (field) {
	      if (videos[field]) {
	        _this.openModal(videos[field]);
	      }
	    };
	
	    _this.state = {
	      financialTargets: {},
	      teamReportMetrics: {},
	      loaded: false,
	      isModalShown: false,
	      isVideoPlaying: false,
	      selectedVideo: null
	    };
	
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(ResultsAreInStep6, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          rounds = _props.rounds;
	
	
	      var gameId = Number(_Auth2.default.getGameId());
	      var team = _Teams2.default.currentTeam();
	      var teamId = Number(team.id);
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundId = round ? round.id : 0;
	
	      Promise.all([(0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?round_number=' + activeRound + '&course=' + _Auth2.default.getCourseId()), (0, _MetricsService.fetchTeamMetrics)(teamId, roundId)]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            targetsRes = _ref2[0],
	            metricsResults = _ref2[1];
	
	        var financialTargets = targetsRes.body[0] || {};
	
	        var metricsData = metricsResults.find(function (i) {
	          return Number(i.game) === gameId && Number(i.round) === roundId;
	        }) || {};
	
	        // Map snake_case MetricsReport fields to title-case names
	        // expected by FinancialTargetsAndPerformance component
	        var teamReportMetrics = {
	          'Market Share': Number(metricsData.market_share || 0),
	          'Net Revenues': Number(metricsData.net_revenues || 0),
	          'Gross Margin': Number(metricsData.gross_margin || 0),
	          'Share Price': Number(metricsData.share_price || 0),
	          'ROE': Number(metricsData.roe || 0),
	          'ROA': Number(metricsData.roa || 0),
	          'Earnings Per Share': Number(metricsData.earnings_per_share || 0)
	        };
	
	        console.log('financialTargets', financialTargets);
	        console.log('teamReportMetrics', teamReportMetrics);
	
	        _this2.setState({
	          financialTargets: financialTargets,
	          teamReportMetrics: teamReportMetrics,
	          loaded: true
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var activeRound = this.props.activeRound;
	      var _state = this.state,
	          financialTargets = _state.financialTargets,
	          teamReportMetrics = _state.teamReportMetrics,
	          loaded = _state.loaded,
	          isModalShown = _state.isModalShown,
	          isVideoPlaying = _state.isVideoPlaying;
	
	
	      return loaded ? _react2.default.createElement(_oneVisual2.default, {
	        section: 'RESULTS ARE IN!',
	        title: 'Financial Goals & Performance',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'These were the ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'financial metrics and target goals'
	          ),
	          ' that drove your team score this round.'
	        ),
	        visual: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Modal,
	            { show: isModalShown, onHide: this.closeModal, className: 'goals-and-targets-modal' },
	            _react2.default.createElement(
	              _reactBootstrap.Modal.Body,
	              null,
	              _react2.default.createElement(
	                ModalVideoWrapper,
	                { className: isVideoPlaying ? 'is-playing' : '' },
	                _react2.default.createElement('video', {
	                  ref: function ref(_ref3) {
	                    _this3.videoRef = _ref3;
	                  },
	                  src: this.state.selectedVideo,
	                  alt: 'Welcome Video',
	                  onClick: this.handlePlayPause,
	                  onEnded: function onEnded() {
	                    return _this3.setState({ isVideoPlaying: false });
	                  },
	                  style: { width: '100%', borderRadius: 10 }
	                }),
	                _react2.default.createElement(
	                  PlayPauseButton,
	                  { onClick: this.handlePlayPause },
	                  isVideoPlaying ? '❚❚' : '▶'
	                ),
	                _react2.default.createElement(
	                  CloseModalVideoButton,
	                  { onClick: this.closeModal },
	                  '\xD7'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FinancialTargetsAndPerformance2.default, {
	            round: activeRound,
	            financialTargets: financialTargets,
	            teamReportMetrics: teamReportMetrics,
	            showTableOnly: true,
	            onHelpIconClick: this.onHelpIconClick,
	            title: 'Financial Metrics & Target Goals'
	          })
	        )
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ResultsAreInStep6;
	}(_react.PureComponent);
	
	exports.default = ResultsAreInStep6;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DonutPMDecisionsPlacement = __webpack_require__(1337);
	
	var _DonutPMDecisionsPlacement2 = _interopRequireDefault(_DonutPMDecisionsPlacement);
	
	var _ModalPMDecisionsPlacement = __webpack_require__(1427);
	
	var _ModalPMDecisionsPlacement2 = _interopRequireDefault(_ModalPMDecisionsPlacement);
	
	var _PromoSpendTextMasking = __webpack_require__(400);
	
	var _PromoSpendTextMasking2 = _interopRequireDefault(_PromoSpendTextMasking);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _style = __webpack_require__(257);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _reactEasyState = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PMDecisionsPlacement = function (_Component) {
	  _inherits(PMDecisionsPlacement, _Component);
	
	  function PMDecisionsPlacement(props) {
	    _classCallCheck(this, PMDecisionsPlacement);
	
	    var _this = _possibleConstructorReturn(this, (PMDecisionsPlacement.__proto__ || Object.getPrototypeOf(PMDecisionsPlacement)).call(this, props));
	
	    _this.onRemoveSales = function (e, object_id) {
	      e.preventDefault();
	
	      var products_prepared = _this.state.products_prepared;
	
	      var products = Object.values(products_prepared);
	      var product = products.find(function (i) {
	        return i.sale_id === object_id;
	      });
	
	      _this.removeSalesRequest(object_id).then(function (res) {
	        _this.props.showSuccessMessage("Sales decision set for product " + product.name + " was successfully deleted");
	        (0, _SubmitDecisions.decrementUnacceptedDecisions)("marketing");
	        _this.props.reloadData();
	        _this.props.getSubmissionData();
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "PMDecisionsPlacement", "onRemoveSales");
	      });
	    };
	
	    _this.state = {
	      products: props.products,
	      sales: props.sales,
	      products_prepared: {}
	    };
	    return _this;
	  }
	
	  _createClass(PMDecisionsPlacement, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.products !== nextProps.products || this.state.sales !== nextProps.sales) {
	        this.setState({
	          products: nextProps.products,
	          sales: nextProps.sales
	        }, function () {
	          _this2.prepareData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.prepareData();
	    }
	  }, {
	    key: "prepareData",
	    value: function prepareData() {
	      var products_prepared = {};
	
	      this.state.products.forEach(function (item) {
	        products_prepared[item.id] = {
	          name: item.name,
	          client: 0,
	          total: 0,
	          sale_id: 0,
	          player: null
	        };
	      });
	
	      this.state.sales.forEach(function (item) {
	        if (item.product in products_prepared) {
	          products_prepared[item.product].client = item.client;
	          products_prepared[item.product].total = item.total;
	          products_prepared[item.product].sale_id = item.id;
	          products_prepared[item.product].player = item.player;
	        }
	      });
	
	      this.setState({
	        products_prepared: products_prepared
	      });
	    }
	  }, {
	    key: "removeSalesRequest",
	    value: function removeSalesRequest(object_id) {
	      return (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "team/sales/" + object_id + "/");
	    }
	  }, {
	    key: "calculateSum",
	    value: function calculateSum(data, type, key) {
	      var sum = 0;
	      var l = data.length;
	
	      for (var i = 0; i < l; i += 1) {
	        if (data[i].player !== null && data[i].client === type) {
	          sum += data[i][key];
	        }
	      }
	
	      return sum;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _style2.default.WhiteBlockColumn,
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _style2.default.P.Title,
	            null,
	            "Place"
	          ),
	          _react2.default.createElement(_ModalPMDecisionsPlacement2.default, {
	            reloadData: this.props.reloadData,
	            products: this.state.products_prepared,
	            price_forecasts: this.props.price_forecasts,
	            sales_clients: this.props.sales_clients,
	            hasAccess: this.props.hasAccess,
	            showRoleAlert: this.props.showRoleAlert,
	            countOfProducts: this.props.countOfProducts,
	            tourMode: this.props.tourMode,
	            getSubmissionData: this.props.getSubmissionData,
	            showSuccessMessage: this.props.showSuccessMessage
	          })
	        ),
	        _react2.default.createElement(
	          _style2.default.P.Amount,
	          null,
	          _react2.default.createElement(_AbbreviateNumber2.default, { value: this.total })
	        ),
	        _react2.default.createElement(_DonutPMDecisionsPlacement2.default, {
	          products: this.state.products_prepared,
	          sales_clients: this.props.sales_clients
	        }),
	        _react2.default.createElement(
	          _style2.default.P.Table,
	          {
	            rowColor: (0, _utils.hexToRgba)(_Teams2.default.currentTeamColorLevel1(), 0.3)
	          },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Product"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Sales Channel"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Total"
	                ),
	                _react2.default.createElement("th", null)
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              Object.keys(this.state.products_prepared).map(function (product_id) {
	                var product = _this3.state.products_prepared[product_id];
	                var can_remove = product.player !== null ? true : false;
	                if (_this3.props.actionsAllowed === false) {
	                  can_remove = false;
	                }
	
	                return _react2.default.createElement(
	                  "tr",
	                  { key: product_id },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    product.name
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    product.client === _this3.props.sales_clients["Direct Sales"] ? "Direct Sales" : product.client === _this3.props.sales_clients["Distributors"] ? "Distributors" : ""
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_PromoSpendTextMasking2.default, { value: product.total })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    can_remove === true && _react2.default.createElement(
	                      "a",
	                      {
	                        href: "/#",
	                        className: "remove-operation",
	                        onClick: function onClick(e) {
	                          return _this3.onRemoveSales(e, product.sale_id);
	                        }
	                      },
	                      _react2.default.createElement(_reactFontawesome2.default, { name: "trash-o" })
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "sumOfDirectSalesSpend",
	    get: function get() {
	      return this.calculateSum(this.props.sales, this.props.sales_clients["Direct Sales"], "total");
	    }
	  }, {
	    key: "sumOfDistributorsSpend",
	    get: function get() {
	      return this.calculateSum(this.props.sales, this.props.sales_clients["Distributors"], "total");
	    }
	  }, {
	    key: "total",
	    get: function get() {
	      return -this.sumOfDirectSalesSpend - this.sumOfDistributorsSpend;
	    }
	  }, {
	    key: "sumOfCashReceiptsPriorRoundSales",
	    get: function get() {
	      var accountsReceivable = this.props.accountsReceivable;
	
	
	      return accountsReceivable;
	    }
	  }]);
	
	  return PMDecisionsPlacement;
	}(_react.Component);
	
	exports.default = (0, _reactEasyState.view)(PMDecisionsPlacement);

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DonutPMDecisionsPromotionalSpend = __webpack_require__(1338);
	
	var _DonutPMDecisionsPromotionalSpend2 = _interopRequireDefault(_DonutPMDecisionsPromotionalSpend);
	
	var _ModalPMDecisionsPromotionalSpend = __webpack_require__(1428);
	
	var _ModalPMDecisionsPromotionalSpend2 = _interopRequireDefault(_ModalPMDecisionsPromotionalSpend);
	
	var _PromoSpendTextMasking = __webpack_require__(400);
	
	var _PromoSpendTextMasking2 = _interopRequireDefault(_PromoSpendTextMasking);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _style = __webpack_require__(257);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _reactEasyState = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PMDecisionsPromotionalSpend = function (_Component) {
	  _inherits(PMDecisionsPromotionalSpend, _Component);
	
	  function PMDecisionsPromotionalSpend(props) {
	    _classCallCheck(this, PMDecisionsPromotionalSpend);
	
	    var _this = _possibleConstructorReturn(this, (PMDecisionsPromotionalSpend.__proto__ || Object.getPrototypeOf(PMDecisionsPromotionalSpend)).call(this, props));
	
	    _this.onRemovePromos = function (e, product) {
	      e.preventDefault();
	
	      var requests = [];
	
	      if (product.traditional_spend_id > 0 && product.player_traditional !== null) {
	        requests.push(_this.removePromosRequest(product.traditional_spend_id));
	      }
	
	      if (product.digital_spend_id > 0 && product.player_digital !== null) {
	        requests.push(_this.removePromosRequest(product.digital_spend_id));
	      }
	
	      var joinRequest = Promise.all(requests);
	
	      joinRequest.then(function (res) {
	        _this.props.showSuccessMessage("Promo decision set for product " + product.name + " was successfully deleted");
	        (0, _SubmitDecisions.decrementUnacceptedDecisions)("marketing");
	        _this.props.reloadData();
	        _this.props.getSubmissionData();
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "PMDecisionsPromotionalSpend", "onRemovePromos");
	      });
	    };
	
	    _this.state = {
	      products: props.products,
	      promos: props.promos,
	      products_prepared: {}
	    };
	    return _this;
	  }
	
	  _createClass(PMDecisionsPromotionalSpend, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.products !== nextProps.products || this.state.promos !== nextProps.promos) {
	        this.setState({
	          products: nextProps.products,
	          promos: nextProps.promos
	        }, function () {
	          _this2.prepareData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.prepareData();
	    }
	  }, {
	    key: "prepareData",
	    value: function prepareData() {
	      var _this3 = this;
	
	      var products_prepared = {};
	
	      this.state.products.forEach(function (item) {
	        products_prepared[item.id] = {
	          name: item.name,
	          traditional_spend: 0,
	          digital_spend: 0,
	          traditional_spend_id: 0,
	          digital_spend_id: 0,
	          player_traditional: null,
	          player_digital: null
	        };
	      });
	
	      this.state.promos.forEach(function (item) {
	        if (item.product in products_prepared) {
	          if (item.client === _this3.props.marketing_clients["Traditional Marketing"]) {
	            products_prepared[item.product].traditional_spend = item.spend;
	            products_prepared[item.product].traditional_spend_id = item.id;
	            products_prepared[item.product].player_traditional = item.player;
	          } else if (item.client === _this3.props.marketing_clients["Digital Marketing"]) {
	            products_prepared[item.product].digital_spend = item.spend;
	            products_prepared[item.product].digital_spend_id = item.id;
	            products_prepared[item.product].player_digital = item.player;
	          }
	        }
	      });
	
	      this.setState({
	        products_prepared: products_prepared
	      });
	    }
	  }, {
	    key: "removePromosRequest",
	    value: function removePromosRequest(object_id) {
	      return (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "team/promos/" + object_id + "/");
	    }
	  }, {
	    key: "calculateSum",
	    value: function calculateSum(data, type, key) {
	      var sum = 0;
	      var l = data.length;
	
	      for (var i = 0; i < l; i += 1) {
	        if (data[i].player !== null && data[i].client === type) {
	          sum += data[i][key];
	        }
	      }
	
	      return sum;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        _style2.default.WhiteBlockColumn,
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _style2.default.PS.Title,
	            null,
	            "Promotional Spend"
	          ),
	          _react2.default.createElement(_ModalPMDecisionsPromotionalSpend2.default, {
	            reloadData: this.props.reloadData,
	            products: this.state.products_prepared,
	            marketing_clients: this.props.marketing_clients,
	            price_forecasts: this.props.price_forecasts,
	            hasAccess: this.props.hasAccess,
	            showRoleAlert: this.props.showRoleAlert,
	            countOfProducts: this.props.countOfProducts,
	            tourMode: this.props.tourMode,
	            getSubmissionData: this.props.getSubmissionData,
	            currentRound: this.props.currentRound,
	            roundInUrl: this.props.roundInUrl,
	            rounds: this.props.rounds,
	            showSuccessMessage: this.props.showSuccessMessage
	          })
	        ),
	        _react2.default.createElement(
	          _style2.default.PS.Amount,
	          null,
	          _react2.default.createElement(_AbbreviateNumber2.default, { value: this.total })
	        ),
	        _react2.default.createElement(_DonutPMDecisionsPromotionalSpend2.default, {
	          products: this.state.products_prepared
	        }),
	        _react2.default.createElement(
	          _style2.default.PS.Table,
	          { rowColor: (0, _utils.hexToRgba)(_Teams2.default.currentTeamColorLevel1(), 0.3) },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Product"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Traditional"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Digital"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Total"
	                ),
	                _react2.default.createElement("th", null)
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              Object.keys(this.state.products_prepared).map(function (product_id) {
	                var product = _this4.state.products_prepared[product_id];
	                var total = product.traditional_spend + product.digital_spend;
	                var can_remove = false;
	                if (product.player_traditional !== null || product.player_digital !== null) {
	                  can_remove = true;
	                }
	                if (_this4.props.actionsAllowed === false) {
	                  can_remove = false;
	                }
	
	                return _react2.default.createElement(
	                  "tr",
	                  { key: product_id },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    product.name
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_PromoSpendTextMasking2.default, {
	                      value: product.traditional_spend
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_PromoSpendTextMasking2.default, { value: product.digital_spend })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_PromoSpendTextMasking2.default, { value: total })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    can_remove === true && _react2.default.createElement(
	                      "a",
	                      {
	                        href: "/#",
	                        className: "remove-operation",
	                        onClick: function onClick(e) {
	                          return _this4.onRemovePromos(e, product);
	                        }
	                      },
	                      _react2.default.createElement(_reactFontawesome2.default, { name: "trash-o" })
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "sumOfCashReceiptsPriorRoundSales",
	    get: function get() {
	      var accountsReceivable = this.props.accountsReceivable;
	
	
	      return accountsReceivable;
	    }
	  }, {
	    key: "total",
	    get: function get() {
	      return -this.sumOfTraditionalMarketingSpend - this.sumOfDigitalMarketingSpend;
	    }
	  }, {
	    key: "sumOfTraditionalMarketingSpend",
	    get: function get() {
	      return this.calculateSum(this.props.promos, this.props.marketing_clients["Traditional Marketing"], "spend");
	    }
	  }, {
	    key: "sumOfDigitalMarketingSpend",
	    get: function get() {
	      return this.calculateSum(this.props.promos, this.props.marketing_clients["Digital Marketing"], "spend");
	    }
	  }]);
	
	  return PMDecisionsPromotionalSpend;
	}(_react.Component);
	
	exports.default = (0, _reactEasyState.view)(PMDecisionsPromotionalSpend);

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalPMDecisionsRevenueForecast = __webpack_require__(1429);
	
	var _ModalPMDecisionsRevenueForecast2 = _interopRequireDefault(_ModalPMDecisionsRevenueForecast);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _AbbreviateForecastUnit = __webpack_require__(1406);
	
	var _AbbreviateForecastUnit2 = _interopRequireDefault(_AbbreviateForecastUnit);
	
	var _PromoSpendTextMasking = __webpack_require__(400);
	
	var _PromoSpendTextMasking2 = _interopRequireDefault(_PromoSpendTextMasking);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _style = __webpack_require__(257);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactEasyState = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PMDecisionsRevenueForecast = function (_Component) {
	  _inherits(PMDecisionsRevenueForecast, _Component);
	
	  function PMDecisionsRevenueForecast(props) {
	    _classCallCheck(this, PMDecisionsRevenueForecast);
	
	    var _this = _possibleConstructorReturn(this, (PMDecisionsRevenueForecast.__proto__ || Object.getPrototypeOf(PMDecisionsRevenueForecast)).call(this, props));
	
	    _this.onRemoveForecasts = function (e, object_id) {
	      e.preventDefault();
	
	      var products_prepared = _this.state.products_prepared;
	
	      var products = Object.values(products_prepared);
	      var product = products.find(function (i) {
	        return i.forecast_id === object_id;
	      });
	
	      _this.removeForecastsRequest(object_id).then(function (res) {
	        _this.props.showSuccessMessage("Price forecast for product " + product.name + " was successfully deleted");
	        (0, _SubmitDecisions.decrementUnacceptedDecisions)("marketing");
	        _this.props.reloadData();
	        _this.props.getSubmissionData();
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "PMDecisionsRevenueForecast", "onRemoveForecasts");
	      });
	    };
	
	    _this.state = {
	      products: props.products,
	      price_forecasts: props.price_forecasts,
	      products_prepared: {}
	    };
	    return _this;
	  }
	
	  _createClass(PMDecisionsRevenueForecast, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.products !== nextProps.products || this.state.price_forecasts !== nextProps.price_forecasts) {
	        this.setState({
	          products: nextProps.products,
	          price_forecasts: nextProps.price_forecasts
	        }, function () {
	          _this2.prepareData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.prepareData();
	    }
	  }, {
	    key: "prepareData",
	    value: function prepareData() {
	      var products_prepared = {};
	
	      this.state.products.forEach(function (item) {
	        products_prepared[item.id] = {
	          name: item.name,
	          price: 0,
	          forecast: 0,
	          revenue_forecast: 0,
	          forecast_id: 0,
	          player: null
	        };
	      });
	
	      this.state.price_forecasts.forEach(function (item) {
	        if (item.product in products_prepared) {
	          products_prepared[item.product].price = item.price;
	          products_prepared[item.product].forecast = item.forecast;
	          products_prepared[item.product].revenue_forecast = item.revenue_forecast;
	          products_prepared[item.product].forecast_id = item.id;
	          products_prepared[item.product].player = item.player;
	        }
	      });
	
	      this.setState({
	        products_prepared: products_prepared
	      });
	    }
	  }, {
	    key: "removeForecastsRequest",
	    value: function removeForecastsRequest(object_id) {
	      return (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "team/price_forecasts/" + object_id + "/");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _style2.default.WhiteBlockColumn,
	        { width: "407px" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _style2.default.RF.Title,
	            null,
	            "Revenue Forecast"
	          ),
	          _react2.default.createElement(_ModalPMDecisionsRevenueForecast2.default, {
	            reloadData: this.props.reloadData,
	            products: this.state.products_prepared,
	            hasAccess: this.props.hasAccess,
	            showRoleAlert: this.props.showRoleAlert,
	            countOfProducts: this.props.countOfProducts,
	            tourMode: this.props.tourMode,
	            getSubmissionData: this.props.getSubmissionData,
	            currentRound: this.props.currentRound,
	            roundInUrl: this.props.roundInUrl,
	            rounds: this.props.rounds,
	            showSuccessMessage: this.props.showSuccessMessage
	          })
	        ),
	        _react2.default.createElement(
	          _style2.default.RF.Table,
	          { rowColor: (0, _utils.hexToRgba)(_Teams2.default.currentTeamColorLevel1(), 0.3) },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Product"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Price"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Units Forecast"
	                ),
	                _react2.default.createElement(
	                  "th",
	                  null,
	                  "Expected Revenue"
	                ),
	                _react2.default.createElement("th", null)
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              Object.keys(this.state.products_prepared).map(function (product_id) {
	                var item = _this3.state.products_prepared[product_id];
	                var can_remove = item.player !== null ? true : false;
	                if (_this3.props.actionsAllowed === false) {
	                  can_remove = false;
	                }
	
	                return _react2.default.createElement(
	                  "tr",
	                  { key: product_id },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    item.name
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: item.price,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ",",
	                      decimalSeparator: ".",
	                      decimalPrecision: 2
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_AbbreviateForecastUnit2.default, { value: item.forecast })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(_PromoSpendTextMasking2.default, { value: item.revenue_forecast })
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    can_remove === true && _react2.default.createElement(
	                      "a",
	                      {
	                        href: "/#",
	                        className: "remove-operation",
	                        onClick: function onClick(e) {
	                          return _this3.onRemoveForecasts(e, item.forecast_id);
	                        }
	                      },
	                      _react2.default.createElement(_reactFontawesome2.default, { name: "trash-o" })
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PMDecisionsRevenueForecast;
	}(_react.Component);
	
	exports.default = (0, _reactEasyState.view)(PMDecisionsRevenueForecast);

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _style = __webpack_require__(257);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DonutPMDecisionsPlacement = function (_Component) {
	  _inherits(DonutPMDecisionsPlacement, _Component);
	
	  function DonutPMDecisionsPlacement(props) {
	    _classCallCheck(this, DonutPMDecisionsPlacement);
	
	    var _this = _possibleConstructorReturn(this, (DonutPMDecisionsPlacement.__proto__ || Object.getPrototypeOf(DonutPMDecisionsPlacement)).call(this, props));
	
	    _this.showInfoAlert = function () {
	      _this.setState({
	        infoAlert: true
	      });
	    };
	
	    _this.hideInfoAlert = function () {
	      _this.setState({
	        infoAlert: false
	      });
	    };
	
	    _this.state = {
	      infoAlert: false
	    };
	    return _this;
	  }
	
	  _createClass(DonutPMDecisionsPlacement, [{
	    key: "calculate",
	    value: function calculate(type) {
	      var products = this.props.products;
	      var total = Object.keys(products).length;
	      var count = 0;
	
	      if (total === 0) return 0;
	
	      Object.keys(products).forEach(function (product_id) {
	        var product = products[product_id];
	
	        if (product.player !== null && product.client === type) {
	          count++;
	        }
	      });
	
	      return parseFloat((count / total * 100).toFixed(2), 10);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var infoAlert = this.state.infoAlert;
	
	
	      return _react2.default.createElement(
	        _style2.default.P.Chart,
	        null,
	        infoAlert && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Distributor Cost",
	          message: "Refers to the estimated cost incurred for selling goods through a middleman.",
	          buttonText: "Done",
	          onHide: this.hideInfoAlert
	        }),
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 150, debounce: 500 },
	          _react2.default.createElement(
	            _recharts.PieChart,
	            null,
	            _react2.default.createElement(_recharts.Legend, {
	              iconType: "circle",
	              layout: "vertical",
	              align: "right",
	              verticalAlign: "top"
	            }),
	            _react2.default.createElement(_recharts.Tooltip, { formatter: function formatter(val) {
	                return val + "%";
	              } }),
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                data: this.data,
	                cx: 63,
	                cy: 78,
	                innerRadius: 27,
	                outerRadius: 63,
	                labelLine: true,
	                dataKey: "value"
	              },
	              _react2.default.createElement(_recharts.Cell, { fill: _Teams2.default.directSalesColor() }),
	              _react2.default.createElement(_recharts.Cell, { fill: _Teams2.default.distributorsColor() })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "directSales",
	    get: function get() {
	      return this.calculate(this.props.sales_clients["Direct Sales"]);
	    }
	  }, {
	    key: "distributors",
	    get: function get() {
	      return this.calculate(this.props.sales_clients["Distributors"]);
	    }
	  }, {
	    key: "data",
	    get: function get() {
	      return [{
	        name: "Direct Sales",
	        value: this.directSales
	      }, {
	        name: _react2.default.createElement(
	          _style2.default.TextWithButton,
	          null,
	          "Distributors ",
	          _react2.default.createElement(_style2.default.HelpIcon, { src: _iconTableHelp2.default, onClick: this.showInfoAlert })
	        ),
	        value: this.distributors
	      }];
	    }
	  }]);
	
	  return DonutPMDecisionsPlacement;
	}(_react.Component);
	
	exports.default = (0, _reactEasyState.view)(DonutPMDecisionsPlacement);

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _style = __webpack_require__(257);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _reactEasyState = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIGITAL_MARKETING_LABEL = "Digital Marketing";
	var TRADITIONAL_MARKETING_LABEL = "Traditional Marketing";
	
	var DonutPMDecisionsPromotionalSpend = function (_Component) {
	  _inherits(DonutPMDecisionsPromotionalSpend, _Component);
	
	  function DonutPMDecisionsPromotionalSpend() {
	    _classCallCheck(this, DonutPMDecisionsPromotionalSpend);
	
	    return _possibleConstructorReturn(this, (DonutPMDecisionsPromotionalSpend.__proto__ || Object.getPrototypeOf(DonutPMDecisionsPromotionalSpend)).apply(this, arguments));
	  }
	
	  _createClass(DonutPMDecisionsPromotionalSpend, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        _style2.default.PS.Chart,
	        null,
	        _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 150, debounce: 500 },
	          _react2.default.createElement(
	            _recharts.PieChart,
	            null,
	            _react2.default.createElement(_recharts.Legend, {
	              iconType: "circle",
	              layout: "vertical",
	              align: "right",
	              verticalAlign: "top"
	            }),
	            _react2.default.createElement(_recharts.Tooltip, { formatter: function formatter(val) {
	                return val + "%";
	              } }),
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                data: this.data,
	                cx: 63,
	                cy: 78,
	                innerRadius: 27,
	                outerRadius: 63,
	                labelLine: true,
	                dataKey: "value"
	              },
	              _react2.default.createElement(_recharts.Cell, { fill: _Teams2.default.traditionalMarketingColor() }),
	              _react2.default.createElement(_recharts.Cell, { fill: _Teams2.default.digitalMarketingColor() })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "total",
	    get: function get() {
	      var _this2 = this;
	
	      var sum = 0;
	
	      Object.keys(this.props.products).forEach(function (product_id) {
	        var product = _this2.props.products[product_id];
	
	        if (product.player_traditional !== null && product.traditional_spend_id > 0) {
	          sum += parseFloat(product.traditional_spend, 10);
	        }
	
	        if (product.player_digital !== null && product.digital_spend_id > 0) {
	          sum += parseFloat(product.digital_spend, 10);
	        }
	      });
	
	      return sum;
	    }
	  }, {
	    key: "traditionalMarketing",
	    get: function get() {
	      var _this3 = this;
	
	      var sum = 0;
	      var total = this.total;
	
	      if (total === 0) return 0;
	
	      Object.keys(this.props.products).forEach(function (product_id) {
	        var product = _this3.props.products[product_id];
	
	        if (product.player_traditional !== null && product.traditional_spend_id > 0) {
	          sum += parseFloat(product.traditional_spend, 10);
	        }
	      });
	
	      return (sum / total * 100).toFixed(2);
	    }
	  }, {
	    key: "digitalMarketing",
	    get: function get() {
	      var _this4 = this;
	
	      var sum = 0;
	      var total = this.total;
	
	      if (total === 0) return 0;
	
	      Object.keys(this.props.products).forEach(function (product_id) {
	        var product = _this4.props.products[product_id];
	
	        if (product.player_digital !== null && product.digital_spend_id > 0) {
	          sum += parseFloat(product.digital_spend, 10);
	        }
	      });
	
	      return (sum / total * 100).toFixed(2);
	    }
	  }, {
	    key: "data",
	    get: function get() {
	      return [{
	        name: TRADITIONAL_MARKETING_LABEL,
	        value: parseFloat(this.traditionalMarketing, 10)
	      }, {
	        name: DIGITAL_MARKETING_LABEL,
	        value: parseFloat(this.digitalMarketing, 10)
	      }];
	    }
	  }]);
	
	  return DonutPMDecisionsPromotionalSpend;
	}(_react.Component);
	
	exports.default = (0, _reactEasyState.view)(DonutPMDecisionsPromotionalSpend);

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 24px 40px 64px;\n  max-width: 1320px;\n  margin: 0 auto;\n  font-family: ", ";\n"], ["\n  padding: 24px 40px 64px;\n  max-width: 1320px;\n  margin: 0 auto;\n  font-family: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  margin-bottom: -12px;\n\n  & > * {\n    pointer-events: auto;\n  }\n"], ["\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  margin-bottom: -12px;\n\n  & > * {\n    pointer-events: auto;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"], ["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin: 0;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin: 0;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n"], ["\n  display: flex;\n  gap: 12px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"], ["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  border: 1.5px solid ", ";\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"], ["\n  border: 1.5px solid ", ";\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  flex-shrink: 0;\n"], ["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  flex-shrink: 0;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: rgba(0, 27, 59, 0.94);\n  word-break: break-word;\n"], ["\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: rgba(0, 27, 59, 0.94);\n  word-break: break-word;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n"], ["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  background: ", ";\n  border: 1.5px solid ", ";\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  background: ", ";\n  border: 1.5px solid ", ";\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: ", ";\n  }\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  border: 1.5px solid ", ";\n  background: ", ";\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &::after {\n    content: '';\n    width: 10px;\n    height: 6px;\n    border-left: 2px solid #FFFFFF;\n    border-bottom: 2px solid #FFFFFF;\n    transform: rotate(-45deg) translate(1px, -1px);\n    display: ", ";\n  }\n"], ["\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  border: 1.5px solid ", ";\n  background: ", ";\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &::after {\n    content: '';\n    width: 10px;\n    height: 6px;\n    border-left: 2px solid #FFFFFF;\n    border-bottom: 2px solid #FFFFFF;\n    transform: rotate(-45deg) translate(1px, -1px);\n    display: ", ";\n  }\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 15px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"], ["\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  border: 1.5px solid #E5E9F0;\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 22px;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  border: 1.5px solid #E5E9F0;\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 22px;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1200;\n"], ["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1200;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n"], ["\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 20px;\n"], ["\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 20px;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-weight: 700;\n"], ["\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-weight: 700;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border: 1.5px solid #D5D9DD;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  border: 1.5px solid #D5D9DD;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border: 0;\n  background: #2563EB;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #ffffff;\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  border: 0;\n  background: #2563EB;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #ffffff;\n  cursor: pointer;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _utils = __webpack_require__(18);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Trailing slash matters: without it Django redirects 301 → /bulk/ and
	// the browser drops the PUT body across the redirect.
	var SALES_BULK_URL = ("https://be-production-itb.marketgames.io/api/") + "team/sales/bulk/";
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	// Friendly description per channel name. Falls back to the channel
	// name if no entry exists. Keys match the renamed labels emitted by
	// PMDecisions ("SalesRep" → "Direct Sales", "Distributor1" → "Distributors").
	var CHANNEL_META = {
	  "Direct Sales": {
	    description: "Your in-house team sells the product straight to customers."
	  },
	  "Distributors": {
	    description: "Third-party distributors carry the product into wider channels."
	  }
	};
	
	// ---------- styled components ----------
	
	var Page = _styledComponents2.default.div(_templateObject, FONT);
	
	var ToastSlot = _styledComponents2.default.div(_templateObject2);
	
	var HeaderBlock = _styledComponents2.default.div(_templateObject3);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject4);
	
	var TitleRow = _styledComponents2.default.div(_templateObject5);
	
	var TitleIcon = _styledComponents2.default.div(_templateObject6);
	
	var Title = _styledComponents2.default.h1(_templateObject7);
	
	var Subtitle = _styledComponents2.default.p(_templateObject8);
	
	var CloseButton = _styledComponents2.default.button(_templateObject9);
	
	var SectionHeader = _styledComponents2.default.div(_templateObject10);
	
	var SectionTitle = _styledComponents2.default.h2(_templateObject11);
	
	var FooterButtons = _styledComponents2.default.div(_templateObject12);
	
	var BtnSecondary = _styledComponents2.default.button(_templateObject13, FONT);
	
	var BtnPrimary = _styledComponents2.default.button(_templateObject14, FONT);
	
	var ProductsGrid = _styledComponents2.default.div(_templateObject15);
	
	// Card lights up navy when at least one channel is checked, matching
	// the affordance used on the other decision pages.
	var ProductCard = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.selected ? "#3A507B" : "#E5E9F0";
	}, function (p) {
	  return p.selected ? "0 6px 20px rgba(58, 80, 123, 0.18)" : "none";
	}, function (p) {
	  return p.selected ? "0 8px 24px rgba(58, 80, 123, 0.24)" : "0 4px 16px rgba(15, 23, 41, 0.06)";
	});
	
	var ProductHeader = _styledComponents2.default.div(_templateObject17);
	
	var ProductIconWrap = _styledComponents2.default.div(_templateObject18);
	
	var ProductName = _styledComponents2.default.div(_templateObject19);
	
	var ChannelLabel = _styledComponents2.default.div(_templateObject20);
	
	var ChannelList = _styledComponents2.default.div(_templateObject21);
	
	// Each channel row is a clickable label with a custom checkbox affordance
	// on the left, the channel name in the middle, and a short description
	// below. Selecting highlights the row navy.
	var ChannelOption = _styledComponents2.default.label(_templateObject22, function (p) {
	  return p.checked ? "#F5F8FF" : "#F5F7FB";
	}, function (p) {
	  return p.checked ? "#3A507B" : "transparent";
	}, function (p) {
	  return p.checked ? "#EFF3FF" : "#EEF1F5";
	});
	
	var HiddenCheckbox = _styledComponents2.default.input(_templateObject23);
	
	// Square checkbox with a navy check when ticked. Avoids the browser's
	// default checkbox so the design is consistent across platforms.
	var CheckboxVisual = _styledComponents2.default.span(_templateObject24, function (p) {
	  return p.checked ? "#3A507B" : "rgba(0, 27, 59, 0.25)";
	}, function (p) {
	  return p.checked ? "#3A507B" : "#FFFFFF";
	}, function (p) {
	  return p.checked ? "block" : "none";
	});
	
	var ChannelContent = _styledComponents2.default.div(_templateObject25);
	
	var ChannelName = _styledComponents2.default.span(_templateObject26);
	
	var ChannelDesc = _styledComponents2.default.span(_templateObject27);
	
	var EmptyCard = _styledComponents2.default.div(_templateObject28);
	
	// ---------- no-sales-channel confirmation modal ----------
	//
	// Fires when the user tries to Select while at least one released
	// product still has no sales channel ticked. Two buttons: Cancel
	// returns them to the checkboxes; Continue commits the save with the
	// un-channel'd products intact.
	
	var ConfirmBackdrop = _styledComponents2.default.div(_templateObject29);
	
	var ConfirmCard = _styledComponents2.default.div(_templateObject30);
	
	var ConfirmTitle = _styledComponents2.default.h2(_templateObject31);
	
	var ConfirmBody = _styledComponents2.default.div(_templateObject32);
	
	var ConfirmProductList = _styledComponents2.default.ul(_templateObject33);
	
	var ConfirmActions = _styledComponents2.default.div(_templateObject34);
	
	var ConfirmSecondaryBtn = _styledComponents2.default.button(_templateObject35);
	
	var ConfirmPrimaryBtn = _styledComponents2.default.button(_templateObject36);
	
	// ---------- component ----------
	
	var ManagePlacementPage = function (_PureComponent) {
	  _inherits(ManagePlacementPage, _PureComponent);
	
	  function ManagePlacementPage(props) {
	    _classCallCheck(this, ManagePlacementPage);
	
	    var _this = _possibleConstructorReturn(this, (ManagePlacementPage.__proto__ || Object.getPrototypeOf(ManagePlacementPage)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Selection map keyed by product id; each inner Set holds the
	      // sales-client ids selected for that product. Switching products
	      // doesn't apply here (all cards visible at once) — the map just
	      // tracks which boxes are ticked.
	      selections: {},
	      isSaving: false,
	      errorMessage: null,
	      successMessage: null,
	      // Names of released products with no sales channel selected.
	      // When non-null, the "continue anyway?" confirmation modal
	      // renders and the actual save is deferred until the user picks
	      // a button.
	      noChannelProductNames: null
	    };
	    _this._successTimer = null;
	    return _this;
	  }
	
	  _createClass(ManagePlacementPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.initSelections(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.sales !== this.props.sales || nextProps.products !== this.props.products || nextProps.sales_clients !== this.props.sales_clients) {
	        this.initSelections(nextProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      if (this._successTimer) {
	        clearTimeout(this._successTimer);
	        this._successTimer = null;
	      }
	    }
	
	    // Seed the selection map from the existing sales rows. Each (product,
	    // client) pair where player !== null marks that channel as ticked
	    // for that product.
	
	
	    // Resets ticks to whatever's currently saved on the server (not
	    // a hard "everything off" wipe). Matches the convention used on the
	    // promo and pricing pages.
	
	
	    // ---------- save ----------
	
	  }, {
	    key: "renderProductIcon",
	
	
	    // ---------- render ----------
	
	    value: function renderProductIcon() {
	      return _react2.default.createElement(
	        "svg",
	        { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
	          strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round",
	          width: "22", height: "22" },
	        _react2.default.createElement("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
	        _react2.default.createElement("line", { x1: "7", y1: "7", x2: "7.01", y2: "7" })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          _props$products = _props.products,
	          products = _props$products === undefined ? [] : _props$products,
	          actionsAllowed = _props.actionsAllowed,
	          onClose = _props.onClose;
	      var _state = this.state,
	          isSaving = _state.isSaving,
	          errorMessage = _state.errorMessage,
	          successMessage = _state.successMessage,
	          noChannelProductNames = _state.noChannelProductNames;
	
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        errorMessage && _react2.default.createElement(_error2.default, {
	          title: "Heads up",
	          message: errorMessage,
	          onHide: this.hideErrorMessage
	        }),
	        noChannelProductNames && noChannelProductNames.length > 0 && _react2.default.createElement(
	          ConfirmBackdrop,
	          { role: "dialog", "aria-modal": "true" },
	          _react2.default.createElement(
	            ConfirmCard,
	            null,
	            _react2.default.createElement(
	              ConfirmTitle,
	              null,
	              "Continue with no sales channel?"
	            ),
	            _react2.default.createElement(
	              ConfirmBody,
	              null,
	              noChannelProductNames.length === 1 ? "This released product has no sales channel selected:" : "These released products have no sales channel selected:",
	              _react2.default.createElement(
	                ConfirmProductList,
	                null,
	                noChannelProductNames.map(function (name) {
	                  return _react2.default.createElement(
	                    "li",
	                    { key: name },
	                    name
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 12 } },
	                "Without a sales channel, customers might find it difficult to buy",
	                noChannelProductNames.length === 1 ? " this product." : " these products.",
	                " ",
	                "Go back to pick a channel, or continue anyway."
	              )
	            ),
	            _react2.default.createElement(
	              ConfirmActions,
	              null,
	              _react2.default.createElement(
	                ConfirmSecondaryBtn,
	                { onClick: this.cancelNoChannelPost },
	                "Go Back"
	              ),
	              _react2.default.createElement(
	                ConfirmPrimaryBtn,
	                { onClick: this.confirmNoChannelPost },
	                "Continue"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Page,
	          null,
	          successMessage && _react2.default.createElement(
	            ToastSlot,
	            null,
	            _react2.default.createElement(_success2.default, { message: successMessage })
	          ),
	          _react2.default.createElement(
	            HeaderBlock,
	            null,
	            _react2.default.createElement(
	              HeaderLeft,
	              null,
	              _react2.default.createElement(
	                TitleRow,
	                null,
	                _react2.default.createElement(
	                  TitleIcon,
	                  null,
	                  "\uD83D\uDED2"
	                ),
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  "Manage Placement"
	                )
	              ),
	              _react2.default.createElement(
	                Subtitle,
	                null,
	                "Choose which sales channels carry each of your products. You can pick more than one channel per product."
	              )
	            ),
	            _react2.default.createElement(
	              CloseButton,
	              { onClick: onClose, "aria-label": "Close" },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            SectionHeader,
	            null,
	            _react2.default.createElement(
	              SectionTitle,
	              null,
	              "Product Placement"
	            ),
	            _react2.default.createElement(
	              FooterButtons,
	              null,
	              _react2.default.createElement(
	                BtnSecondary,
	                { onClick: this.resetAll, disabled: !actionsAllowed || isSaving },
	                "Reset All"
	              ),
	              _react2.default.createElement(
	                BtnPrimary,
	                {
	                  onClick: this.postSelections,
	                  disabled: !actionsAllowed || isSaving
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  isSaving ? "Saving…" : "Select"
	                ),
	                !isSaving && _react2.default.createElement(
	                  "span",
	                  null,
	                  "\u2192"
	                )
	              )
	            )
	          ),
	          products.length === 0 ? _react2.default.createElement(
	            EmptyCard,
	            null,
	            "No products available yet. Coordinate with your Head of Product (or CEO) to develop a product first."
	          ) : _react2.default.createElement(
	            ProductsGrid,
	            null,
	            products.map(this.renderProductCard)
	          )
	        )
	      );
	    }
	  }]);
	
	  return ManagePlacementPage;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.initSelections = function (props) {
	    var selections = {};
	    (props.products || []).forEach(function (product) {
	      selections[product.id] = {};
	    });
	    (props.sales || []).forEach(function (row) {
	      if (row.player === null) return;
	      var productId = Number(row.product);
	      var clientId = Number(row.client);
	      if (selections[productId]) {
	        selections[productId][clientId] = true;
	      }
	    });
	    _this2.setState({ selections: selections });
	  };
	
	  this.toggleSelection = function (productId, clientId) {
	    return function () {
	      if (!_this2.props.actionsAllowed) return;
	      var selections = _this2.state.selections;
	
	      var productMap = Object.assign({}, selections[productId] || {});
	      if (productMap[clientId]) {
	        delete productMap[clientId];
	      } else {
	        productMap[clientId] = true;
	      }
	      _this2.setState({
	        selections: Object.assign({}, selections, _defineProperty({}, productId, productMap))
	      });
	    };
	  };
	
	  this.resetAll = function () {
	    _this2.initSelections(_this2.props);
	  };
	
	  this.hideErrorMessage = function () {
	    _this2.setState({ errorMessage: null });
	  };
	
	  this.showLocalSuccess = function (message) {
	    if (_this2._successTimer) clearTimeout(_this2._successTimer);
	    _this2.setState({ successMessage: message });
	    _this2._successTimer = setTimeout(function () {
	      if (!_this2._mounted) return;
	      _this2.setState({ successMessage: null });
	    }, 5000);
	  };
	
	  this.resolveBulkContext = function () {
	    var _props2 = _this2.props,
	        _props2$rounds = _props2.rounds,
	        rounds = _props2$rounds === undefined ? [] : _props2$rounds,
	        currentRound = _props2.currentRound;
	
	    var teamId = _Auth2.default.getTeamId();
	    var player = _Teams2.default.currentPlayer();
	    var playerId = player ? player.id : null;
	    var round = rounds.find(function (r) {
	      return Number(r.number) === Number(currentRound);
	    });
	    var roundId = round ? round.id : null;
	    return { teamId: teamId, playerId: playerId, roundId: roundId };
	  };
	
	  this.postSelections = function () {
	    if (!_this2.props.actionsAllowed) return;
	    var _props$products2 = _this2.props.products,
	        products = _props$products2 === undefined ? [] : _props$products2;
	
	
	    if (products.length === 0) {
	      _this2.setState({
	        errorMessage: "There are no products to place. Coordinate with Product Development first."
	      });
	      return;
	    }
	
	    // Soft-warn on released products with no sales channel selected
	    // (empty inner selection map means no sales row will be posted for
	    // that product, which is the same as "no sales.id" once saved).
	    // Missing months_available_to_produce is treated as "released" per
	    // the game rule so we don't quietly let an unchannel'd product
	    // slip through when the field is absent.
	    var selections = _this2.state.selections;
	
	    var noChannelReleasedNames = products.filter(function (product) {
	      var productMap = selections[product.id] || {};
	      var hasAnySelection = Object.keys(productMap).some(function (cid) {
	        return productMap[cid];
	      });
	      if (hasAnySelection) return false;
	      var months = product.months_available_to_produce != null ? Number(product.months_available_to_produce) : 1;
	      return months > 0;
	    }).map(function (p) {
	      return p.name;
	    });
	    if (noChannelReleasedNames.length > 0) {
	      _this2.setState({ noChannelProductNames: noChannelReleasedNames });
	      return;
	    }
	
	    _this2.doPostSelections();
	  };
	
	  this.confirmNoChannelPost = function () {
	    _this2.setState({ noChannelProductNames: null });
	    _this2.doPostSelections();
	  };
	
	  this.cancelNoChannelPost = function () {
	    _this2.setState({ noChannelProductNames: null });
	  };
	
	  this.doPostSelections = function () {
	    var _props$products3 = _this2.props.products,
	        products = _props$products3 === undefined ? [] : _props$products3;
	
	    var _resolveBulkContext = _this2.resolveBulkContext(),
	        teamId = _resolveBulkContext.teamId,
	        playerId = _resolveBulkContext.playerId,
	        roundId = _resolveBulkContext.roundId;
	
	    if (!teamId || !playerId || !roundId) {
	      _this2.setState({
	        errorMessage: "We couldn't determine your team, round, or player context. Please refresh the page and try again."
	      });
	      return;
	    }
	
	    // Atomic-replace: send the complete sales matrix. Each ticked
	    // (product, client) becomes an entry; unticked combinations are
	    // omitted entirely (the backend wipes prior rows then inserts the
	    // payload). Empty sales[] = clear all this round's sales decisions.
	    var selections = _this2.state.selections;
	
	    var sales = [];
	    products.forEach(function (product) {
	      var productMap = selections[product.id] || {};
	      Object.keys(productMap).forEach(function (clientId) {
	        if (productMap[clientId]) {
	          sales.push({
	            product: product.id,
	            client: Number(clientId)
	          });
	        }
	      });
	    });
	
	    var body = {
	      team: teamId,
	      round: roundId,
	      player: playerId,
	      sales: sales
	    };
	
	    _this2.setState({ isSaving: true });
	
	    (0, _ApiService.putRequest)(SALES_BULK_URL).send(body).then(function () {
	      // The atomic-replace endpoint can result in zero net new rows
	      // (re-selecting an existing matrix), so only bump unaccepted if
	      // anything was actually selected this round.
	      if (sales.length > 0) {
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("marketing");
	      }
	      if (_this2.props.reloadData) _this2.props.reloadData();
	      if (_this2._mounted) {
	        _this2.setState({ isSaving: false });
	        _this2.showLocalSuccess("Sales channel selections were successfully saved.");
	      }
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "ManagePlacementPage", "postSelections");
	      if (_this2._mounted) {
	        _this2.setState({
	          isSaving: false,
	          errorMessage: "Something went wrong saving your placement selections. Please try again."
	        });
	      }
	    });
	  };
	
	  this.renderProductCard = function (product) {
	    var _props3 = _this2.props,
	        actionsAllowed = _props3.actionsAllowed,
	        _props3$sales_clients = _props3.sales_clients,
	        sales_clients = _props3$sales_clients === undefined ? [] : _props3$sales_clients;
	
	    var productMap = _this2.state.selections[product.id] || {};
	    var selectedCount = Object.keys(productMap).filter(function (k) {
	      return productMap[k];
	    }).length;
	
	    return _react2.default.createElement(
	      ProductCard,
	      { key: product.id, selected: selectedCount > 0 },
	      _react2.default.createElement(
	        ProductHeader,
	        null,
	        _react2.default.createElement(
	          ProductIconWrap,
	          null,
	          _this2.renderProductIcon()
	        ),
	        _react2.default.createElement(
	          ProductName,
	          null,
	          product.name
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          ChannelLabel,
	          null,
	          "Sales Channels"
	        ),
	        _react2.default.createElement(
	          ChannelList,
	          null,
	          sales_clients.length === 0 && _react2.default.createElement(
	            ChannelDesc,
	            null,
	            "No sales channels available."
	          ),
	          sales_clients.map(function (client) {
	            var checked = !!productMap[client.id];
	            var meta = CHANNEL_META[client.name] || {};
	            return _react2.default.createElement(
	              ChannelOption,
	              { key: client.id, checked: checked },
	              _react2.default.createElement(HiddenCheckbox, {
	                type: "checkbox",
	                checked: checked,
	                onChange: _this2.toggleSelection(product.id, client.id),
	                disabled: !actionsAllowed
	              }),
	              _react2.default.createElement(CheckboxVisual, { checked: checked }),
	              _react2.default.createElement(
	                ChannelContent,
	                null,
	                _react2.default.createElement(
	                  ChannelName,
	                  null,
	                  client.name
	                ),
	                meta.description && _react2.default.createElement(
	                  ChannelDesc,
	                  null,
	                  meta.description
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	};
	
	exports.default = ManagePlacementPage;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 24px 40px 64px;\n  max-width: 1320px;\n  margin: 0 auto;\n  font-family: ", ";\n  height: calc(100vh - 59px);\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 27, 59, 0.28);\n    border-radius: 5px;\n  }\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 27, 59, 0.45);\n  }\n"], ["\n  padding: 24px 40px 64px;\n  max-width: 1320px;\n  margin: 0 auto;\n  font-family: ", ";\n  height: calc(100vh - 59px);\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 27, 59, 0.28);\n    border-radius: 5px;\n  }\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 27, 59, 0.45);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"], ["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 28px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 28px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  margin-bottom: -12px;\n\n  & > * {\n    pointer-events: auto;\n  }\n"], ["\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  margin-bottom: -12px;\n\n  & > * {\n    pointer-events: auto;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 20px 22px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n"], ["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 20px 22px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n  background: #EAF3EC;\n  color: #2DA548;\n  font-weight: 700;\n"], ["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n  background: #EAF3EC;\n  color: #2DA548;\n  font-weight: 700;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n"], ["\n  flex: 1;\n  min-width: 0;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  margin-bottom: 6px;\n"], ["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  margin-bottom: 6px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 40px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  padding-right: 24px;\n"], ["\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 40px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  padding-right: 24px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: ", ";\n"], ["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: ", ";\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 600;\n"], ["\n  font-size: 12px;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 600;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n"], ["\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin: 0;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin: 0;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  flex-wrap: wrap;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.04em;\n  margin-right: 4px;\n"], ["\n  font-size: 13px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.04em;\n  margin-right: 4px;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  0%   { box-shadow: 0 0 0 0 rgba(58, 80, 123, 0.55); }\n  70%  { box-shadow: 0 0 0 12px rgba(58, 80, 123, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(58, 80, 123, 0); }\n"], ["\n  0%   { box-shadow: 0 0 0 0 rgba(58, 80, 123, 0.55); }\n  70%  { box-shadow: 0 0 0 12px rgba(58, 80, 123, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(58, 80, 123, 0); }\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1.5px solid ", ";\n  color: ", ";\n  padding: 7px 14px;\n  border-radius: 999px;\n  font-family: ", ";\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover:not(:disabled) {\n    border-color: #3A507B;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  ", "\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n"], ["\n  background: ", ";\n  border: 1.5px solid ", ";\n  color: ", ";\n  padding: 7px 14px;\n  border-radius: 999px;\n  font-family: ", ";\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover:not(:disabled) {\n    border-color: #3A507B;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  ", "\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n    background: #EEF3FB;\n    border-color: #3A507B;\n    color: #3A507B;\n    animation: ", " 1.6s ease-out infinite;\n  "], ["\n    background: #EEF3FB;\n    border-color: #3A507B;\n    color: #3A507B;\n    animation: ", " 1.6s ease-out infinite;\n  "]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  border: 1.5px dashed #C6CDD8;\n  background: #FBFCFE;\n  border-radius: 14px;\n  padding: 60px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 8px;\n"], ["\n  border: 1.5px dashed #C6CDD8;\n  background: #FBFCFE;\n  border-radius: 14px;\n  padding: 60px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 8px;\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  font-size: 36px;\n  line-height: 1;\n  margin-bottom: 6px;\n"], ["\n  font-size: 36px;\n  line-height: 1;\n  margin-bottom: 6px;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n  max-width: 460px;\n"], ["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n  max-width: 460px;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  border: 1.5px solid ", ";\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"], ["\n  border: 1.5px solid ", ";\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  flex-shrink: 0;\n"], ["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  flex-shrink: 0;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 6px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"], ["\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 6px;\n  color: rgba(0, 27, 59, 0.94);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n\n  &:hover > span.channel-info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n\n  &:hover > span.channel-info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(0, 27, 59, 0.35);\n  color: rgba(0, 27, 59, 0.6);\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 1;\n  user-select: none;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(0, 27, 59, 0.35);\n  color: rgba(0, 27, 59, 0.6);\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 1;\n  user-select: none;\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 280px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 20;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 6px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 280px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 20;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 6px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border: 1.5px solid;\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border: 1.5px solid;\n  ", "\n"]),
	    _templateObject43 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  min-height: 40px;\n  margin: 0;\n"], ["\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  min-height: 40px;\n  margin: 0;\n"]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  flex: 1;\n  position: relative;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  opacity: ", ";\n  touch-action: none;\n  user-select: none;\n  min-width: 0;\n"], ["\n  flex: 1;\n  position: relative;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  opacity: ", ";\n  touch-action: none;\n  user-select: none;\n  min-width: 0;\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: #E5E9F0;\n  border-radius: 999px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: #E5E9F0;\n  border-radius: 999px;\n  pointer-events: none;\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background: #FFFFFF;\n  border: 3px solid #FD9595;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(253, 149, 149, 0.25);\n  transform: translateX(-50%);\n  top: 50%;\n  margin-top: -10px;\n  pointer-events: none;\n  transition: transform 0.15s ease;\n\n  ", ":hover & {\n    transform: translateX(-50%) scale(1.1);\n  }\n"], ["\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background: #FFFFFF;\n  border: 3px solid #FD9595;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(253, 149, 149, 0.25);\n  transform: translateX(-50%);\n  top: 50%;\n  margin-top: -10px;\n  pointer-events: none;\n  transition: transform 0.15s ease;\n\n  ", ":hover & {\n    transform: translateX(-50%) scale(1.1);\n  }\n"]),
	    _templateObject48 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: #F5F7FB;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  padding: 8px 12px;\n  width: 120px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus-within {\n    border-color: #EA580C;\n    box-shadow: 0 0 0 3px rgba(234, 88, 12, 0.12);\n    background: #FFFFFF;\n  }\n\n  input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-family: ", ";\n    font-size: 15px;\n    font-weight: 800;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    width: 100%;\n    min-width: 0;\n    padding: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: #F5F7FB;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  padding: 8px 12px;\n  width: 120px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus-within {\n    border-color: #EA580C;\n    box-shadow: 0 0 0 3px rgba(234, 88, 12, 0.12);\n    background: #FFFFFF;\n  }\n\n  input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-family: ", ";\n    font-size: 15px;\n    font-weight: 800;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    width: 100%;\n    min-width: 0;\n    padding: 0;\n  }\n"]),
	    _templateObject49 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.35);\n  margin-right: 6px;\n"], ["\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.35);\n  margin-right: 6px;\n"]),
	    _templateObject50 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  min-width: 120px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  min-width: 120px;\n"]),
	    _templateObject51 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 700;\n  color: #3A507B;\n  letter-spacing: 0.02em;\n  max-width: 120px;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  font-size: 12px;\n  font-weight: 700;\n  color: #3A507B;\n  letter-spacing: 0.02em;\n  max-width: 120px;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]),
	    _templateObject52 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n"], ["\n  display: flex;\n  gap: 12px;\n"]),
	    _templateObject53 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject54 = _taggedTemplateLiteral(["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"], ["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"]),
	    _templateObject55 = _taggedTemplateLiteral(["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1200;\n"], ["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1200;\n"]),
	    _templateObject56 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject57 = _taggedTemplateLiteral(["\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n"], ["\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n"]),
	    _templateObject58 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 20px;\n"], ["\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 20px;\n"]),
	    _templateObject59 = _taggedTemplateLiteral(["\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-weight: 700;\n"], ["\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-weight: 700;\n"]),
	    _templateObject60 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"]),
	    _templateObject61 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border: 1.5px solid #D5D9DD;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  border: 1.5px solid #D5D9DD;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n"]),
	    _templateObject62 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border: 0;\n  background: #2563EB;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #ffffff;\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  border: 0;\n  background: #2563EB;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #ffffff;\n  cursor: pointer;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _utils = __webpack_require__(18);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Trailing slash matters: without it Django responds 301 → /bulk/,
	// and the browser-side PUT redirect drops the request body which then
	// 500s server-side.
	var PROMOS_BULK_URL = ("https://be-production-itb.marketgames.io/api/") + "team/promos/bulk/";
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	// Per-channel slider cap. Channels can hold up to $5,000,000 each.
	var PER_CHANNEL_MAX = 5000000;
	var SLIDER_STEP = 5000;
	
	var CATEGORY_DIGITAL = 2;
	
	// Name → description / icon map. Names match what the backend returns
	// in marketing_clients. Unknown names fall back to a generic icon and
	// the name as the description.
	var CHANNEL_META = {
	  "Trade Shows & Events": {
	    description: "Face-to-face engagement with high-intent buyers",
	    iconKey: "tradeshow",
	    explainer: "Industry expos where you set up a booth and meet potential buyers face-to-face. Great for demoing your product to serious customers."
	  },
	  "TV & Print Ads": {
	    description: "Mass market reach with strong brand recall",
	    iconKey: "tv",
	    explainer: "Broadcast commercials and print ads in newspapers or magazines. Reaches a huge audience and builds strong brand recognition over time."
	  },
	  "Direct Mail": {
	    description: "Targeted physical outreach with high demographic precision",
	    iconKey: "mail",
	    explainer: "Postcards, catalogs, and letters sent to specific mailing lists so you can zero in on the neighborhoods and households that fit your buyer."
	  },
	  "Sponsorships": {
	    description: "Associates your brand with events your audience already loves",
	    iconKey: "sponsorship",
	    explainer: "Paying to attach your brand to an event, team, or cause your audience already loves, so their goodwill rubs off on you."
	  },
	  "In-Store / POS": {
	    description: "Drives conversion at the point of purchase",
	    iconKey: "store",
	    explainer: "Displays, signage, and product placement inside retail stores that catch shoppers right when they're about to make a purchase."
	  },
	  "Content Marketing": {
	    description: "Builds long-term organic visibility and trust",
	    iconKey: "content",
	    explainer: "Blog posts, articles, and videos your team publishes to educate customers and pull them in through search over time."
	  },
	  "Paid Digital Ads": {
	    description: "Fast, targeted reach with measurable conversion",
	    iconKey: "ads",
	    explainer: "Ads on Google, Facebook, Instagram, and similar platforms. You pick who sees them and can measure exactly who clicks and buys."
	  },
	  "Influencer Marketing": {
	    description: "Authentic social proof with younger audiences",
	    iconKey: "influencer",
	    explainer: "Partnering with technical experts, industrial vision podcasters, and academic innovators whose audiences trust their recommendations."
	  },
	  "Email Campaigns": {
	    description: "Direct nurture channel with high conversion rates",
	    iconKey: "email",
	    explainer: "Regular emails sent to your prospects and customers, delivered straight to their inbox. High conversion rate for every dollar spent."
	  }
	};
	
	// Inline SVG icons keyed by CHANNEL_META.iconKey. Stroke icons sized
	// 22x22, currentColor — match the design HTML.
	var renderChannelIcon = function renderChannelIcon(key) {
	  var common = {
	    viewBox: "0 0 24 24",
	    fill: "none",
	    stroke: "currentColor",
	    strokeWidth: 2,
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    width: 22,
	    height: 22
	  };
	  switch (key) {
	    case "tradeshow":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("circle", { cx: "9", cy: "7", r: "4" }),
	        _react2.default.createElement("path", { d: "M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" }),
	        _react2.default.createElement("circle", { cx: "17", cy: "7", r: "3" }),
	        _react2.default.createElement("path", { d: "M20 21v-1.5a3 3 0 0 0-3-3" })
	      );
	    case "tv":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }),
	        _react2.default.createElement("line", { x1: "8", y1: "22", x2: "16", y2: "22" }),
	        _react2.default.createElement("line", { x1: "12", y1: "19", x2: "12", y2: "22" })
	      );
	    case "mail":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("line", { x1: "22", y1: "2", x2: "11", y2: "13" }),
	        _react2.default.createElement("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
	      );
	    case "sponsorship":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("circle", { cx: "12", cy: "8", r: "7" }),
	        _react2.default.createElement("polyline", { points: "8.21 13.89 7 23 12 20 17 23 15.79 13.88" })
	      );
	    case "store":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" }),
	        _react2.default.createElement("path", { d: "M3 6h18" }),
	        _react2.default.createElement("path", { d: "M16 10a4 4 0 0 1-8 0" })
	      );
	    case "content":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
	        _react2.default.createElement("polyline", { points: "14 2 14 8 20 8" }),
	        _react2.default.createElement("line", { x1: "16", y1: "13", x2: "8", y2: "13" }),
	        _react2.default.createElement("line", { x1: "16", y1: "17", x2: "8", y2: "17" }),
	        _react2.default.createElement("line", { x1: "10", y1: "9", x2: "8", y2: "9" })
	      );
	    case "ads":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
	        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "6" }),
	        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "2" })
	      );
	    case "influencer":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("circle", { cx: "18", cy: "5", r: "3" }),
	        _react2.default.createElement("circle", { cx: "6", cy: "12", r: "3" }),
	        _react2.default.createElement("circle", { cx: "18", cy: "19", r: "3" }),
	        _react2.default.createElement("line", { x1: "8.59", y1: "13.51", x2: "15.42", y2: "17.49" }),
	        _react2.default.createElement("line", { x1: "15.41", y1: "6.51", x2: "8.59", y2: "10.49" })
	      );
	    case "email":
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
	        _react2.default.createElement("polyline", { points: "22,6 12,13 2,6" })
	      );
	    default:
	      return _react2.default.createElement(
	        "svg",
	        common,
	        _react2.default.createElement("circle", { cx: "12", cy: "12", r: "9" })
	      );
	  }
	};
	
	var fmt = function fmt(n) {
	  return Math.round(Number(n) || 0).toLocaleString("en-US");
	};
	
	// ---------- styled components ----------
	
	var Page = _styledComponents2.default.div(_templateObject, FONT);
	
	// Header lays out title block on the left and a close affordance on
	// the right. Matches the Manage Production page pattern so the close
	// "x" behaves the same across decision overlays.
	var HeaderBlock = _styledComponents2.default.div(_templateObject2);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject3);
	
	var CloseButton = _styledComponents2.default.button(_templateObject4);
	
	var TitleRow = _styledComponents2.default.div(_templateObject5);
	
	var TitleIcon = _styledComponents2.default.div(_templateObject6);
	
	var Title = _styledComponents2.default.h1(_templateObject7);
	
	var Subtitle = _styledComponents2.default.p(_templateObject8);
	
	var KpiRow = _styledComponents2.default.div(_templateObject9);
	
	// Floating toast slot at the top of the overlay. The page is a
	// scrollable column inside LenderOverlay; pinning the alert here keeps
	// it visible regardless of scroll position.
	var ToastSlot = _styledComponents2.default.div(_templateObject10);
	
	var KpiCard = _styledComponents2.default.div(_templateObject11);
	
	var KpiIcon = _styledComponents2.default.div(_templateObject12);
	
	var KpiContent = _styledComponents2.default.div(_templateObject13);
	
	var KpiLabel = _styledComponents2.default.div(_templateObject14);
	
	var KpiValueRow = _styledComponents2.default.div(_templateObject15);
	
	var KpiValue = _styledComponents2.default.span(_templateObject16);
	
	// Per-product breakdown chips laid out side-by-side, sitting closer
	// to the center of the KPI card (not pinned to the far right) so the
	// eye reads Total Spending → per-product split as a continuous group.
	var SpendBreakdown = _styledComponents2.default.div(_templateObject17);
	
	var SpendBreakdownItem = _styledComponents2.default.div(_templateObject18);
	
	var SpendDot = _styledComponents2.default.span(_templateObject19, function (p) {
	  return p.color;
	});
	
	var SpendLabel = _styledComponents2.default.span(_templateObject20);
	
	var SpendValue = _styledComponents2.default.span(_templateObject21);
	
	// Header row above the channel grid — title on the left, action
	// buttons on the right, vertically centered together so the user can
	// see Reset All / Post Allocation without scrolling past the cards.
	var SectionHeader = _styledComponents2.default.div(_templateObject22);
	
	var SectionTitle = _styledComponents2.default.h2(_templateObject23);
	
	// Title + product selector pills sit together on the left of the
	// section header so the user always sees which product the channel
	// cards are bound to.
	var SectionTitleGroup = _styledComponents2.default.div(_templateObject24);
	
	var ProductPillsLabel = _styledComponents2.default.span(_templateObject25);
	
	var ProductPills = _styledComponents2.default.div(_templateObject26);
	
	// Active pill: white background + navy border/text to read as "this is
	// the product we're editing right now". Inactive: soft gray chip.
	// Pulsing halo used when no product has been picked yet — visually
	// nudges the user toward the pill they need to click to unlock the
	// channel allocation grid below.
	var pillPulse = (0, _styledComponents.keyframes)(_templateObject27);
	
	var ProductPill = _styledComponents2.default.button(_templateObject28, function (p) {
	  return p.active ? "#FFFFFF" : "#F5F7FB";
	}, function (p) {
	  return p.active ? "#3A507B" : "#E5E9F0";
	}, function (p) {
	  return p.active ? "#3A507B" : "rgba(0, 27, 59, 0.6)";
	}, FONT, function (p) {
	  return p.active ? "0 2px 6px rgba(58, 80, 123, 0.18)" : "none";
	}, function (p) {
	  return p.attention && !p.active && (0, _styledComponents.css)(_templateObject29, pillPulse);
	});
	
	var ChannelsGrid = _styledComponents2.default.div(_templateObject30);
	
	// Empty state shown before the user picks a product. Sits in the same
	// slot the channel grid would occupy so the layout doesn't jump when a
	// pill is clicked.
	var EmptyState = _styledComponents2.default.div(_templateObject31);
	
	var EmptyStateIcon = _styledComponents2.default.div(_templateObject32);
	
	var EmptyStateTitle = _styledComponents2.default.div(_templateObject33, FONT);
	
	var EmptyStateBody = _styledComponents2.default.div(_templateObject34, FONT);
	
	var ChannelCard = _styledComponents2.default.div(_templateObject35, function (p) {
	  return p.allocated ? "#3A507B" : "#E5E9F0";
	}, function (p) {
	  return p.allocated ? "0 6px 20px rgba(58, 80, 123, 0.18)" : "none";
	}, function (p) {
	  return p.allocated ? "0 8px 24px rgba(58, 80, 123, 0.24)" : "0 4px 16px rgba(15, 23, 41, 0.06)";
	});
	
	var ChannelHeader = _styledComponents2.default.div(_templateObject36);
	
	var ChannelIconWrap = _styledComponents2.default.div(_templateObject37);
	
	var ChannelTitleBlock = _styledComponents2.default.div(_templateObject13);
	
	var ChannelName = _styledComponents2.default.div(_templateObject38);
	
	// Small "?" pill next to the channel name. Hovers reveal a tooltip
	// with a plain-language explanation of what the channel is. Same
	// disabled-child pointer-events trick used elsewhere so hover fires
	// on the wrapper, not the icon, and the tooltip anchors cleanly.
	var ChannelInfoWrapper = _styledComponents2.default.span(_templateObject39);
	
	var ChannelInfoIcon = _styledComponents2.default.span(_templateObject40, FONT);
	
	var ChannelInfoTooltip = _styledComponents2.default.span(_templateObject41, FONT);
	
	var ChannelBadge = _styledComponents2.default.span(_templateObject42, function (p) {
	  return p.category === CATEGORY_DIGITAL ? "background: #EBF2FF; color: #4C8AFF; border-color: #4C8AFF;" : "background: #ECF6F7; color: #4CC7D1; border-color: #4CC7D1;";
	});
	
	var ChannelDesc = _styledComponents2.default.p(_templateObject43);
	
	var AllocRow = _styledComponents2.default.div(_templateObject44);
	
	// Custom div-based slider — native input[type=range] doesn't style
	// reliably through styled-components v3 (vendor pseudo-elements stripped
	// or overridden by the browser default skin). Building it from divs
	// guarantees the design pixel-matches across browsers.
	var SliderRoot = _styledComponents2.default.div(_templateObject45, function (p) {
	  return p.disabled ? "not-allowed" : "pointer";
	}, function (p) {
	  return p.disabled ? 0.5 : 1;
	});
	
	var SliderTrack = _styledComponents2.default.div(_templateObject46);
	
	var SliderThumb = _styledComponents2.default.div(_templateObject47, SliderRoot);
	
	var CustomSlider = function (_Component) {
	  _inherits(CustomSlider, _Component);
	
	  function CustomSlider(props) {
	    _classCallCheck(this, CustomSlider);
	
	    var _this = _possibleConstructorReturn(this, (CustomSlider.__proto__ || Object.getPrototypeOf(CustomSlider)).call(this, props));
	
	    _this.setRootRef = function (el) {
	      _this.rootEl = el;
	    };
	
	    _this.updateFromClientX = function (clientX) {
	      if (!_this.rootEl || _this.props.disabled) return;
	      var rect = _this.rootEl.getBoundingClientRect();
	      if (rect.width <= 0) return;
	      var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
	      var _this$props = _this.props,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step,
	          onChange = _this$props.onChange;
	
	      var raw = min + (max - min) * ratio;
	      if (step && step > 0) raw = Math.round(raw / step) * step;
	      raw = Math.max(min, Math.min(max, raw));
	      if (onChange) onChange(raw);
	    };
	
	    _this.onMouseDown = function (e) {
	      if (_this.props.disabled) return;
	      e.preventDefault();
	      _this.setState({ dragging: true });
	      _this.attachWindowListeners();
	      _this.updateFromClientX(e.clientX);
	    };
	
	    _this.onTouchStart = function (e) {
	      if (_this.props.disabled) return;
	      if (!e.touches || e.touches.length === 0) return;
	      _this.setState({ dragging: true });
	      _this.attachWindowListeners();
	      _this.updateFromClientX(e.touches[0].clientX);
	    };
	
	    _this.onWindowMouseMove = function (e) {
	      if (!_this.state.dragging) return;
	      _this.updateFromClientX(e.clientX);
	    };
	
	    _this.onWindowTouchMove = function (e) {
	      if (!_this.state.dragging) return;
	      if (!e.touches || e.touches.length === 0) return;
	      e.preventDefault();
	      _this.updateFromClientX(e.touches[0].clientX);
	    };
	
	    _this.onWindowMouseUp = function () {
	      if (!_this.state.dragging) return;
	      _this.setState({ dragging: false });
	      _this.detachWindowListeners();
	    };
	
	    _this.state = { dragging: false };
	    return _this;
	  }
	
	  _createClass(CustomSlider, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.detachWindowListeners();
	    }
	  }, {
	    key: "attachWindowListeners",
	    value: function attachWindowListeners() {
	      window.addEventListener("mousemove", this.onWindowMouseMove);
	      window.addEventListener("mouseup", this.onWindowMouseUp);
	      window.addEventListener("touchmove", this.onWindowTouchMove, { passive: false });
	      window.addEventListener("touchend", this.onWindowMouseUp);
	    }
	  }, {
	    key: "detachWindowListeners",
	    value: function detachWindowListeners() {
	      window.removeEventListener("mousemove", this.onWindowMouseMove);
	      window.removeEventListener("mouseup", this.onWindowMouseUp);
	      window.removeEventListener("touchmove", this.onWindowTouchMove);
	      window.removeEventListener("touchend", this.onWindowMouseUp);
	    }
	
	    // Convert a clientX position to a clamped, stepped value, then push
	    // it back up via props.onChange.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          min = _props.min,
	          max = _props.max,
	          disabled = _props.disabled;
	
	      var range = max - min;
	      var pct = range > 0 ? Math.max(0, Math.min(100, (Number(value) - min) / range * 100)) : 0;
	      return _react2.default.createElement(
	        SliderRoot,
	        {
	          innerRef: this.setRootRef,
	          onMouseDown: this.onMouseDown,
	          onTouchStart: this.onTouchStart,
	          disabled: disabled
	        },
	        _react2.default.createElement(SliderTrack, null),
	        _react2.default.createElement(SliderThumb, { style: { left: pct + "%" } })
	      );
	    }
	  }]);
	
	  return CustomSlider;
	}(_react.Component);
	
	// Wrap NumberFormat (react-number-format v2) inside a styled container.
	// Styling the NumberFormat-rendered <input> directly via descendant
	// selector is more reliable across the v2 component than wrapping it
	// with styled() — v2's class component doesn't always forward className.
	
	
	var InputWrap = _styledComponents2.default.div(_templateObject48, FONT);
	
	var InputPrefix = _styledComponents2.default.span(_templateObject49);
	
	// Stacks the product name above the dollar input so every channel
	// card makes it visually clear which product the allocation belongs to.
	// Left-aligned (not flex-end) so "Product X" reads naturally from the
	// start of the input area.
	var InputColumn = _styledComponents2.default.div(_templateObject50);
	
	var InputProductLabel = _styledComponents2.default.span(_templateObject51);
	
	var FooterButtons = _styledComponents2.default.div(_templateObject52);
	
	var BtnSecondary = _styledComponents2.default.button(_templateObject53, FONT);
	
	var BtnPrimary = _styledComponents2.default.button(_templateObject54, FONT);
	
	// ---------- $0-promo confirmation modal ----------
	//
	// Fires when the user tries to Set Allocation while at least one
	// released product still has $0 total promo spend across every
	// channel. Two buttons: Cancel returns them to the sliders; Continue
	// commits the save with the un-promoted products intact.
	
	var ConfirmBackdrop = _styledComponents2.default.div(_templateObject55);
	
	var ConfirmCard = _styledComponents2.default.div(_templateObject56);
	
	var ConfirmTitle = _styledComponents2.default.h2(_templateObject57);
	
	var ConfirmBody = _styledComponents2.default.div(_templateObject58);
	
	var ConfirmProductList = _styledComponents2.default.ul(_templateObject59);
	
	var ConfirmActions = _styledComponents2.default.div(_templateObject60);
	
	var ConfirmSecondaryBtn = _styledComponents2.default.button(_templateObject61);
	
	var ConfirmPrimaryBtn = _styledComponents2.default.button(_templateObject62);
	
	// ---------- component ----------
	
	var ManagePromotionPage = function (_PureComponent) {
	  _inherits(ManagePromotionPage, _PureComponent);
	
	  function ManagePromotionPage(props) {
	    _classCallCheck(this, ManagePromotionPage);
	
	    var _this2 = _possibleConstructorReturn(this, (ManagePromotionPage.__proto__ || Object.getPrototypeOf(ManagePromotionPage)).call(this, props));
	
	    _initialiseProps.call(_this2);
	
	    _this2.state = {
	      // Allocations are keyed first by product id, then by client id.
	      // Switching the selected product just changes which inner map is
	      // wired to the sliders/inputs; edits on a previously-viewed
	      // product stay buffered until the user posts that product.
	      allocations: {},
	      selectedProductId: null,
	      isSaving: false,
	      errorMessage: null,
	      successMessage: null,
	      // Names of released products with $0 total promo spend. When
	      // non-null, the "continue anyway?" confirmation modal renders
	      // and the actual save is deferred until the user picks a button.
	      noPromoProductNames: null,
	      // "No allocation at all" soft warn. True when the CEO clicks
	      // Set Allocation without spending on any channel of any product.
	      // Was previously a hard block; now surfaces the same confirm
	      // modal pattern so the user can proceed with an empty post.
	      confirmEmptyPost: false
	    };
	    _this2._successTimer = null;
	    _this2.eventemitter = _eventEmitter2.default.getInstance();
	    return _this2;
	  }
	
	  _createClass(ManagePromotionPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.initAllocations(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.promos !== this.props.promos || nextProps.marketing_clients !== this.props.marketing_clients || nextProps.products !== this.props.products) {
	        // Reload allocations from props but keep the current
	        // selectedProductId — resetting on reload would jump the user
	        // back to the empty state right after they save.
	        this.initAllocations(nextProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      if (this._successTimer) {
	        clearTimeout(this._successTimer);
	        this._successTimer = null;
	      }
	    }
	
	    // Local in-overlay success toast. We can't rely on the parent's
	    // SuccessAlert because it renders behind LenderOverlay (z-index 1500),
	    // so a confirmation here is invisible until the user closes the page.
	
	
	    // Build a per-product map of per-client allocations from the promos
	    // array. We only treat a promo as a live decision when player !== null
	    // (matches the convention in the rest of the team-decisions code).
	    // Each product gets its own inner map so switching product selection
	    // simply swaps which inner map drives the sliders.
	
	
	    // Reset only the currently-selected product back to zeros — other
	    // products keep their buffered edits intact.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          _props2$marketing_cli = _props2.marketing_clients,
	          marketing_clients = _props2$marketing_cli === undefined ? [] : _props2$marketing_cli,
	          _props2$products = _props2.products,
	          products = _props2$products === undefined ? [] : _props2$products,
	          _props2$promos = _props2.promos,
	          promos = _props2$promos === undefined ? [] : _props2$promos,
	          actionsAllowed = _props2.actionsAllowed,
	          onClose = _props2.onClose;
	      var _state = this.state,
	          isSaving = _state.isSaving,
	          errorMessage = _state.errorMessage,
	          successMessage = _state.successMessage,
	          selectedProductId = _state.selectedProductId,
	          noPromoProductNames = _state.noPromoProductNames,
	          confirmEmptyPost = _state.confirmEmptyPost;
	
	
	      var totalSpent = this.totalSpent;
	      // Only nudge with the pulsing glow on the very first visit — once
	      // any promo record has been posted (any product), the user has
	      // discovered the pill affordance and the glow becomes noisy.
	      var hasAnyPromoDecision = (promos || []).some(function (p) {
	        return p.player !== null;
	      });
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        errorMessage && _react2.default.createElement(_error2.default, {
	          title: "Heads up",
	          message: errorMessage,
	          onHide: this.hideErrorMessage
	        }),
	        confirmEmptyPost && _react2.default.createElement(
	          ConfirmBackdrop,
	          { role: "dialog", "aria-modal": "true" },
	          _react2.default.createElement(
	            ConfirmCard,
	            null,
	            _react2.default.createElement(
	              ConfirmTitle,
	              null,
	              "Continue with no promo spend?"
	            ),
	            _react2.default.createElement(
	              ConfirmBody,
	              null,
	              "You haven't allocated any spending across your channels. Without promo spend, customers may not hear about your products. Go back to allocate spending, or continue anyway."
	            ),
	            _react2.default.createElement(
	              ConfirmActions,
	              null,
	              _react2.default.createElement(
	                ConfirmSecondaryBtn,
	                { onClick: this.cancelEmptyPost },
	                "Go Back"
	              ),
	              _react2.default.createElement(
	                ConfirmPrimaryBtn,
	                { onClick: this.confirmEmptyPostContinue },
	                "Continue"
	              )
	            )
	          )
	        ),
	        noPromoProductNames && noPromoProductNames.length > 0 && _react2.default.createElement(
	          ConfirmBackdrop,
	          { role: "dialog", "aria-modal": "true" },
	          _react2.default.createElement(
	            ConfirmCard,
	            null,
	            _react2.default.createElement(
	              ConfirmTitle,
	              null,
	              "Continue with no promo spend?"
	            ),
	            _react2.default.createElement(
	              ConfirmBody,
	              null,
	              noPromoProductNames.length === 1 ? "This released product has no marketing spend across any channel:" : "These released products have no marketing spend across any channel:",
	              _react2.default.createElement(
	                ConfirmProductList,
	                null,
	                noPromoProductNames.map(function (name) {
	                  return _react2.default.createElement(
	                    "li",
	                    { key: name },
	                    name
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 12 } },
	                "Without promo spend, customers may not hear about",
	                noPromoProductNames.length === 1 ? " this product." : " these products.",
	                " ",
	                "Go back to allocate spending, or continue anyway."
	              )
	            ),
	            _react2.default.createElement(
	              ConfirmActions,
	              null,
	              _react2.default.createElement(
	                ConfirmSecondaryBtn,
	                { onClick: this.cancelNoPromoPost },
	                "Go Back"
	              ),
	              _react2.default.createElement(
	                ConfirmPrimaryBtn,
	                { onClick: this.confirmNoPromoPost },
	                "Continue"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Page,
	          null,
	          successMessage && _react2.default.createElement(
	            ToastSlot,
	            null,
	            _react2.default.createElement(_success2.default, { message: successMessage })
	          ),
	          _react2.default.createElement(
	            HeaderBlock,
	            null,
	            _react2.default.createElement(
	              HeaderLeft,
	              null,
	              _react2.default.createElement(
	                TitleRow,
	                null,
	                _react2.default.createElement(
	                  TitleIcon,
	                  null,
	                  "\uD83D\uDCE3"
	                ),
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  "Manage Promotion"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              CloseButton,
	              { onClick: onClose, "aria-label": "Close" },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            KpiRow,
	            null,
	            _react2.default.createElement(
	              KpiCard,
	              null,
	              _react2.default.createElement(
	                KpiIcon,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(
	                KpiContent,
	                null,
	                _react2.default.createElement(
	                  KpiLabel,
	                  null,
	                  "Total Promo Spending"
	                ),
	                _react2.default.createElement(
	                  KpiValueRow,
	                  null,
	                  _react2.default.createElement(
	                    KpiValue,
	                    null,
	                    "$",
	                    fmt(totalSpent)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                SpendBreakdown,
	                null,
	                products.map(function (product) {
	                  return _react2.default.createElement(
	                    SpendBreakdownItem,
	                    { key: "product-spend-" + product.id },
	                    _react2.default.createElement(SpendDot, { color: "#3A507B" }),
	                    _react2.default.createElement(
	                      SpendLabel,
	                      null,
	                      "Product ",
	                      product.name
	                    ),
	                    _react2.default.createElement(
	                      SpendValue,
	                      null,
	                      "$",
	                      fmt(_this3.spentByProduct(product.id))
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            SectionHeader,
	            null,
	            _react2.default.createElement(
	              SectionTitleGroup,
	              null,
	              _react2.default.createElement(
	                SectionTitle,
	                null,
	                "Channel Allocation"
	              ),
	              products.length > 0 && _react2.default.createElement(
	                ProductPills,
	                null,
	                _react2.default.createElement(
	                  ProductPillsLabel,
	                  null,
	                  "Products:"
	                ),
	                products.map(function (product) {
	                  return _react2.default.createElement(
	                    ProductPill,
	                    {
	                      key: "pill-" + product.id,
	                      active: Number(product.id) === Number(selectedProductId),
	                      attention: selectedProductId == null && !hasAnyPromoDecision,
	                      onClick: _this3.selectProduct(product.id),
	                      type: "button"
	                    },
	                    product.name
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              FooterButtons,
	              null,
	              _react2.default.createElement(
	                BtnSecondary,
	                {
	                  onClick: this.resetAll,
	                  disabled: !actionsAllowed || isSaving || selectedProductId == null
	                },
	                "Reset All"
	              ),
	              _react2.default.createElement(
	                BtnPrimary,
	                {
	                  onClick: this.postAllocation,
	                  disabled: !actionsAllowed || isSaving || selectedProductId == null
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  isSaving ? "Saving…" : "Set Allocation"
	                ),
	                !isSaving && _react2.default.createElement(
	                  "span",
	                  null,
	                  "\u2192"
	                )
	              )
	            )
	          ),
	          selectedProductId != null && _react2.default.createElement(
	            Subtitle,
	            { style: { marginTop: 4, marginBottom: 12 } },
	            "These are your marketing channel options. Invest in the ones best suited to reach your customers."
	          ),
	          selectedProductId == null ? _react2.default.createElement(
	            EmptyState,
	            null,
	            _react2.default.createElement(
	              EmptyStateIcon,
	              null,
	              "\uD83D\uDC46"
	            ),
	            _react2.default.createElement(
	              EmptyStateTitle,
	              null,
	              "Select a product to begin"
	            ),
	            _react2.default.createElement(
	              EmptyStateBody,
	              null,
	              "Channel allocations are set per product. Pick a product above to view channel allocation options."
	            )
	          ) : _react2.default.createElement(
	            ChannelsGrid,
	            null,
	            marketing_clients.map(this.renderChannelCard)
	          )
	        )
	      );
	    }
	  }, {
	    key: "totalSpent",
	
	
	    // ---------- totals ----------
	
	    // Total promo spend across every product the team owns (sum of every
	    // buffered allocation map). Drives the headline KPI value.
	    get: function get() {
	      var allocations = this.state.allocations;
	
	      return Object.keys(allocations).reduce(function (sum, productId) {
	        var inner = allocations[productId] || {};
	        return sum + Object.keys(inner).reduce(function (s, clientId) {
	          return s + (Number(inner[clientId]) || 0);
	        }, 0);
	      }, 0);
	    }
	
	    // Total spend for a single product across all channels. Drives the
	    // per-product chips in the KPI breakdown row.
	
	
	    // Allocation value for a (selectedProduct, client) pair. Returns 0
	    // when the inner map hasn't been populated yet.
	
	
	    // ---------- save ----------
	
	    // The bulk endpoint is scoped to (team, product, round). team and
	    // player come from auth/Teams; round id is looked up from the rounds
	    // array. Each product is sent as its own bulk request.
	
	
	    // ---------- render ----------
	
	  }]);
	
	  return ManagePromotionPage;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.showPopupLowPromo = function (spend) {
	    var formatted = Math.round(Number(spend) || 0).toLocaleString("en-US");
	    _this4.eventemitter.trigger("coaching-feedback", ["Food for Thought", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Uh Oh! Very low promo!"
	      ),
	      _react2.default.createElement("br", null),
	      "You should double check the ",
	      _react2.default.createElement(
	        "a",
	        { href: "/analysis/bcase", target: "_blank" },
	        "business case"
	      ),
	      " to see what others have spent on their marketing budget."
	    ), _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      "You don't have to spend the same amount as others, but it's in your best interests to spend more than $",
	      formatted,
	      " if this is the first time promoting this product."
	    )]);
	  };
	
	  this.showLocalSuccess = function (message) {
	    if (_this4._successTimer) clearTimeout(_this4._successTimer);
	    _this4.setState({ successMessage: message });
	    _this4._successTimer = setTimeout(function () {
	      if (!_this4._mounted) return;
	      _this4.setState({ successMessage: null });
	    }, 5000);
	  };
	
	  this.initAllocations = function (props) {
	    var allocations = {};
	    (props.products || []).forEach(function (product) {
	      var inner = {};
	      (props.marketing_clients || []).forEach(function (client) {
	        var spend = (props.promos || []).filter(function (p) {
	          return p.player !== null && Number(p.product) === Number(product.id) && Number(p.client) === Number(client.id);
	        }).reduce(function (s, p) {
	          return s + (Number(p.spend) || 0);
	        }, 0);
	        inner[client.id] = Math.abs(spend);
	      });
	      allocations[product.id] = inner;
	    });
	
	    // Intentionally leave selectedProductId as null on first load and on
	    // reloads. The Channel Allocation grid is per-product and it should
	    // be an explicit choice — otherwise the user misses that the sliders
	    // they're editing only apply to one product at a time.
	    _this4.setState({ allocations: allocations });
	  };
	
	  this.selectProduct = function (productId) {
	    return function () {
	      if (Number(_this4.state.selectedProductId) === Number(productId)) return;
	      _this4.setState({ selectedProductId: productId });
	    };
	  };
	
	  this.setAllocation = function (clientId, value) {
	    var _state2 = _this4.state,
	        selectedProductId = _state2.selectedProductId,
	        allocations = _state2.allocations;
	
	    if (selectedProductId == null) return;
	    var clamped = Math.max(0, Math.min(PER_CHANNEL_MAX, Number(value) || 0));
	    _this4.setState({
	      allocations: Object.assign({}, allocations, _defineProperty({}, selectedProductId, Object.assign({}, allocations[selectedProductId] || {}, _defineProperty({}, clientId, clamped))))
	    });
	  };
	
	  this.onSliderChange = function (clientId) {
	    return function (value) {
	      _this4.setAllocation(clientId, value);
	    };
	  };
	
	  this.onInputChange = function (clientId) {
	    return function (e, values) {
	      var next = values && typeof values.floatValue === "number" ? values.floatValue : 0;
	      _this4.setAllocation(clientId, next);
	    };
	  };
	
	  this.resetAll = function () {
	    var _state3 = _this4.state,
	        selectedProductId = _state3.selectedProductId,
	        allocations = _state3.allocations;
	
	    if (selectedProductId == null) return;
	    var inner = {};
	    (_this4.props.marketing_clients || []).forEach(function (client) {
	      inner[client.id] = 0;
	    });
	    _this4.setState({
	      allocations: Object.assign({}, allocations, _defineProperty({}, selectedProductId, inner))
	    });
	  };
	
	  this.spentByProduct = function (productId) {
	    var inner = (_this4.state.allocations || {})[productId] || {};
	    return Object.keys(inner).reduce(function (s, clientId) {
	      return s + (Number(inner[clientId]) || 0);
	    }, 0);
	  };
	
	  this.currentAllocation = function (clientId) {
	    var _state4 = _this4.state,
	        selectedProductId = _state4.selectedProductId,
	        allocations = _state4.allocations;
	
	    if (selectedProductId == null) return 0;
	    var inner = allocations[selectedProductId] || {};
	    return Number(inner[clientId]) || 0;
	  };
	
	  this.hideErrorMessage = function () {
	    _this4.setState({ errorMessage: null });
	  };
	
	  this.resolveBulkContext = function () {
	    var _props3 = _this4.props,
	        _props3$rounds = _props3.rounds,
	        rounds = _props3$rounds === undefined ? [] : _props3$rounds,
	        currentRound = _props3.currentRound;
	
	    var teamId = _Auth2.default.getTeamId();
	    var player = _Teams2.default.currentPlayer();
	    var playerId = player ? player.id : null;
	    var round = rounds.find(function (r) {
	      return Number(r.number) === Number(currentRound);
	    });
	    var roundId = round ? round.id : null;
	    return { teamId: teamId, playerId: playerId, roundId: roundId };
	  };
	
	  this.postAllocation = function () {
	    if (!_this4.props.actionsAllowed) return;
	    var _props4 = _this4.props,
	        marketing_clients = _props4.marketing_clients,
	        _props4$products = _props4.products,
	        products = _props4$products === undefined ? [] : _props4$products;
	    var allocations = _this4.state.allocations;
	
	
	    if (products.length === 0) {
	      _this4.setState({
	        errorMessage: "There are no products to allocate promo spending to."
	      });
	      return;
	    }
	
	    // Validation: at least ONE product must have at least one channel
	    // with spending > 0. With zero everywhere there's nothing
	    // meaningful to post — the user likely clicked by mistake.
	    var hasAnySpend = products.some(function (product) {
	      var inner = (allocations || {})[product.id] || {};
	      return (marketing_clients || []).some(function (client) {
	        return (Number(inner[client.id]) || 0) > 0;
	      });
	    });
	    if (!hasAnySpend) {
	      _this4.setState({ confirmEmptyPost: true });
	      return;
	    }
	
	    // Soft-warn on released products that still have $0 total promo
	    // spend (nothing invested across any channel). Missing
	    // months_available_to_produce is treated as "released" per the
	    // game rule so we don't quietly let an un-promoted product slip
	    // through when the field is absent.
	    var noPromoReleasedNames = products.filter(function (product) {
	      var inner = (allocations || {})[product.id] || {};
	      var totalSpend = (marketing_clients || []).reduce(function (sum, client) {
	        return sum + (Number(inner[client.id]) || 0);
	      }, 0);
	      if (totalSpend > 0) return false;
	      var months = product.months_available_to_produce != null ? Number(product.months_available_to_produce) : 1;
	      return months > 0;
	    }).map(function (p) {
	      return p.name;
	    });
	    if (noPromoReleasedNames.length > 0) {
	      _this4.setState({ noPromoProductNames: noPromoReleasedNames });
	      return;
	    }
	
	    _this4.doPostAllocation();
	  };
	
	  this.confirmNoPromoPost = function () {
	    _this4.setState({ noPromoProductNames: null });
	    _this4.doPostAllocation();
	  };
	
	  this.cancelNoPromoPost = function () {
	    _this4.setState({ noPromoProductNames: null });
	  };
	
	  this.confirmEmptyPostContinue = function () {
	    _this4.setState({ confirmEmptyPost: false });
	    _this4.doPostAllocation();
	  };
	
	  this.cancelEmptyPost = function () {
	    _this4.setState({ confirmEmptyPost: false });
	  };
	
	  this.doPostAllocation = function () {
	    var _props5 = _this4.props,
	        marketing_clients = _props5.marketing_clients,
	        _props5$products = _props5.products,
	        products = _props5$products === undefined ? [] : _props5$products;
	    var allocations = _this4.state.allocations;
	
	    var _resolveBulkContext = _this4.resolveBulkContext(),
	        teamId = _resolveBulkContext.teamId,
	        playerId = _resolveBulkContext.playerId,
	        roundId = _resolveBulkContext.roundId;
	
	    if (!teamId || !playerId || !roundId) {
	      _this4.setState({
	        errorMessage: "We couldn't determine your team, round, or player context. Please refresh the page and try again."
	      });
	      return;
	    }
	
	    // Capture BEFORE the POST: is this Round 1 AND the team's first
	    // promo record ever? Used to fire the "one more marketing
	    // decision to go" coaching popup on the very first Set Allocation.
	    var wasFirstPromoRd1 = Number(_this4.props.currentRound) === 1 && !(_this4.props.promos || []).some(function (p) {
	      return p && p.player !== null;
	    });
	
	    // One bulk PUT per product, fired in parallel. Each request sends
	    // the full spends array (with explicit 0s) so the bulk endpoint
	    // can upsert/delete each channel independently per product.
	    var requests = products.map(function (product) {
	      var inner = (allocations || {})[product.id] || {};
	      var spends = (marketing_clients || []).map(function (client) {
	        return {
	          client: client.id,
	          spend: Math.round(Number(inner[client.id]) || 0)
	        };
	      });
	      var body = {
	        team: teamId,
	        round: roundId,
	        player: playerId,
	        product: product.id,
	        spends: spends
	      };
	      return (0, _ApiService.putRequest)(PROMOS_BULK_URL).send(body);
	    });
	
	    _this4.setState({ isSaving: true });
	
	    Promise.all(requests).then(function () {
	      // Coaching popup: if ANY product's total promo spend (across
	      // both Traditional and Digital channels) is <= $200k, nudge
	      // the student to review the business case. Uses the minimum
	      // across products so a well-funded product doesn't mask an
	      // under-invested one.
	      var clients = marketing_clients || [];
	      var minPromoPerProduct = null;
	      products.forEach(function (product) {
	        var inner = (allocations || {})[product.id] || {};
	        var totalPromo = clients.reduce(function (sum, c) {
	          return sum + (Number(inner[c.id]) || 0);
	        }, 0);
	        if (minPromoPerProduct === null || totalPromo < minPromoPerProduct) {
	          minPromoPerProduct = totalPromo;
	        }
	      });
	      if (minPromoPerProduct !== null && minPromoPerProduct <= 200000) {
	        _this4.showPopupLowPromo(minPromoPerProduct);
	      }
	
	      (0, _SubmitDecisions.incrementUnacceptedDecisions)("marketing");
	      // reloadData already refreshes team-decisions + team-status +
	      // submission_data in one go; calling getSubmissionData on top
	      // would duplicate both network requests for no extra state.
	      if (_this4.props.reloadData) _this4.props.reloadData();
	      if (_this4._mounted) {
	        _this4.setState({ isSaving: false });
	        _this4.showLocalSuccess("Promo allocations were successfully saved.");
	      }
	      if (wasFirstPromoRd1 && _this4.props.onFirstPromoSet) {
	        _this4.props.onFirstPromoSet();
	      }
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "ManagePromotionPage", "postAllocation");
	      if (_this4._mounted) {
	        _this4.setState({
	          isSaving: false,
	          errorMessage: "Something went wrong saving your promo allocations. Please try again."
	        });
	      }
	    });
	  };
	
	  this.renderChannelCard = function (client) {
	    var _props6 = _this4.props,
	        actionsAllowed = _props6.actionsAllowed,
	        _props6$products = _props6.products,
	        products = _props6$products === undefined ? [] : _props6$products;
	    var selectedProductId = _this4.state.selectedProductId;
	
	    var value = _this4.currentAllocation(client.id);
	    var meta = CHANNEL_META[client.name] || { description: client.name, iconKey: "default" };
	    var selectedProduct = products.find(function (p) {
	      return Number(p.id) === Number(selectedProductId);
	    });
	    var productName = selectedProduct ? selectedProduct.name : null;
	
	    return _react2.default.createElement(
	      ChannelCard,
	      { key: client.id, allocated: value > 0 },
	      _react2.default.createElement(
	        ChannelHeader,
	        null,
	        _react2.default.createElement(
	          ChannelIconWrap,
	          null,
	          renderChannelIcon(meta.iconKey)
	        ),
	        _react2.default.createElement(
	          ChannelTitleBlock,
	          null,
	          _react2.default.createElement(
	            ChannelName,
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              client.name
	            ),
	            meta.explainer && _react2.default.createElement(
	              ChannelInfoWrapper,
	              null,
	              _react2.default.createElement(
	                ChannelInfoIcon,
	                { "aria-label": "About " + client.name },
	                "?"
	              ),
	              _react2.default.createElement(
	                ChannelInfoTooltip,
	                { className: "channel-info-tooltip" },
	                meta.explainer
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ChannelBadge,
	            { category: Number(client.category) },
	            Number(client.category) === CATEGORY_DIGITAL ? "Digital" : "Traditional"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ChannelDesc,
	        null,
	        meta.description
	      ),
	      _react2.default.createElement(
	        AllocRow,
	        null,
	        _react2.default.createElement(CustomSlider, {
	          min: 0,
	          max: PER_CHANNEL_MAX,
	          step: SLIDER_STEP,
	          value: value,
	          onChange: _this4.onSliderChange(client.id),
	          disabled: !actionsAllowed || selectedProductId == null
	        }),
	        _react2.default.createElement(
	          InputColumn,
	          null,
	          productName && _react2.default.createElement(
	            InputProductLabel,
	            { title: "Product " + productName },
	            "Product ",
	            productName
	          ),
	          _react2.default.createElement(
	            InputWrap,
	            null,
	            _react2.default.createElement(
	              InputPrefix,
	              null,
	              "$"
	            ),
	            _react2.default.createElement(_reactNumberFormat2.default, {
	              value: value,
	              thousandSeparator: ",",
	              allowNegative: false,
	              onChange: _this4.onInputChange(client.id),
	              disabled: !actionsAllowed || selectedProductId == null
	            })
	          )
	        )
	      )
	    );
	  };
	};
	
	exports.default = ManagePromotionPage;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  padding: 24px 40px 64px;\n  max-width: 1320px;\n  margin: 0 auto;\n  font-family: ", ";\n"], ["\n  padding: 24px 40px 64px;\n  max-width: 1320px;\n  margin: 0 auto;\n  font-family: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  margin-bottom: -12px;\n\n  & > * {\n    pointer-events: auto;\n  }\n"], ["\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  margin-bottom: -12px;\n\n  & > * {\n    pointer-events: auto;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 22px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"], ["\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #DBEAFE;\n  color: #2563EB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"], ["\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  line-height: 1.5;\n  margin: 0;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 4px 10px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 28px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 28px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 20px 22px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n"], ["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 20px 22px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n  background: #EAF3EC;\n  color: #2DA548;\n  font-weight: 700;\n"], ["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n  background: #EAF3EC;\n  color: #2DA548;\n  font-weight: 700;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n"], ["\n  flex: 1;\n  min-width: 0;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  margin-bottom: 6px;\n"], ["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  margin-bottom: 6px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 600;\n"], ["\n  margin-left: auto;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 600;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin: 0;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  margin: 0;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n"], ["\n  display: flex;\n  gap: 12px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: rgba(0, 27, 59, 0.6);\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"], ["\n  background: #3A507B;\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 12px;\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(58, 80, 123, 0.25);\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 800px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  border: 1.5px solid ", ";\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"], ["\n  border: 1.5px solid ", ";\n  background: #FFFFFF;\n  border-radius: 14px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  flex-shrink: 0;\n"], ["\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  flex-shrink: 0;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: rgba(0, 27, 59, 0.94);\n  word-break: break-word;\n"], ["\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: rgba(0, 27, 59, 0.94);\n  word-break: break-word;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n"], ["\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: #F5F7FB;\n  border: 1.5px solid ", ";\n  border-radius: 10px;\n  padding: 10px 12px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus-within {\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n    background: #FFFFFF;\n  }\n\n  input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    width: 100%;\n    min-width: 0;\n    padding: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background: #F5F7FB;\n  border: 1.5px solid ", ";\n  border-radius: 10px;\n  padding: 10px 12px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:focus-within {\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n    background: #FFFFFF;\n  }\n\n  input {\n    flex: 1;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    width: 100%;\n    min-width: 0;\n    padding: 0;\n  }\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.35);\n  margin-right: 8px;\n"], ["\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.35);\n  margin-right: 8px;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.5);\n  margin-left: 8px;\n"], ["\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.5);\n  margin-left: 8px;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #DC2626;\n  font-weight: 600;\n  margin-top: 6px;\n"], ["\n  font-size: 12px;\n  color: #DC2626;\n  font-weight: 600;\n  margin-top: 6px;\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 14px;\n  border-top: 1px solid #E5E9F0;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 14px;\n  border-top: 1px solid #E5E9F0;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n"], ["\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(0, 27, 59, 0.6);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  font-variant-numeric: tabular-nums;\n"], ["\n  font-size: 18px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  font-variant-numeric: tabular-nums;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1200;\n"], ["\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1200;\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 28px 24px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n"], ["\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 800;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 20px;\n"], ["\n  font-size: 16px;\n  line-height: 1.55;\n  margin-bottom: 20px;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-weight: 700;\n"], ["\n  margin: 8px 0 0;\n  padding-left: 20px;\n  font-weight: 700;\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border: 1.5px solid #D5D9DD;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  border: 1.5px solid #D5D9DD;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border: 0;\n  background: #2563EB;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #ffffff;\n  cursor: pointer;\n"], ["\n  padding: 10px 20px;\n  border: 0;\n  background: #2563EB;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #ffffff;\n  cursor: pointer;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _utils = __webpack_require__(18);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Trailing slash matters: without it Django redirects 301 → /bulk/ and
	// the browser-side PUT redirect drops the request body.
	var PRICE_FORECASTS_BULK_URL = ("https://be-production-itb.marketgames.io/api/") + "team/price_forecasts/bulk/";
	
	var FONT = "'Mukta Vaani', Lato, sans-serif";
	
	// Validation bounds mirror what the existing pricing modal enforces
	// (and what the backend serializer expects).
	var PRICE_MIN = 0;
	var PRICE_MAX = 99.99;
	var FORECAST_MIN = 0;
	var FORECAST_MAX = 99999999;
	
	var fmtMoney = function fmtMoney(n) {
	  return "$" + Math.round(Number(n) || 0).toLocaleString("en-US");
	};
	var fmtInt = function fmtInt(n) {
	  return Math.round(Number(n) || 0).toLocaleString("en-US");
	};
	
	// ---------- styled components ----------
	
	var Page = _styledComponents2.default.div(_templateObject, FONT);
	
	var ToastSlot = _styledComponents2.default.div(_templateObject2);
	
	var HeaderBlock = _styledComponents2.default.div(_templateObject3);
	
	var HeaderLeft = _styledComponents2.default.div(_templateObject4);
	
	var TitleRow = _styledComponents2.default.div(_templateObject5);
	
	var TitleIcon = _styledComponents2.default.div(_templateObject6);
	
	var Title = _styledComponents2.default.h1(_templateObject7);
	
	var Subtitle = _styledComponents2.default.p(_templateObject8);
	
	var CloseButton = _styledComponents2.default.button(_templateObject9);
	
	var KpiRow = _styledComponents2.default.div(_templateObject10);
	
	var KpiCard = _styledComponents2.default.div(_templateObject11);
	
	var KpiIcon = _styledComponents2.default.div(_templateObject12);
	
	var KpiContent = _styledComponents2.default.div(_templateObject13);
	
	var KpiLabel = _styledComponents2.default.div(_templateObject14);
	
	var KpiValue = _styledComponents2.default.span(_templateObject15);
	
	var KpiAside = _styledComponents2.default.div(_templateObject16);
	
	var SectionHeader = _styledComponents2.default.div(_templateObject17);
	
	var SectionTitle = _styledComponents2.default.h2(_templateObject18);
	
	var FooterButtons = _styledComponents2.default.div(_templateObject19);
	
	var BtnSecondary = _styledComponents2.default.button(_templateObject20, FONT);
	
	var BtnPrimary = _styledComponents2.default.button(_templateObject21, FONT);
	
	var ProductsGrid = _styledComponents2.default.div(_templateObject22);
	
	var ProductCard = _styledComponents2.default.div(_templateObject23, function (p) {
	  return p.touched ? "#3A507B" : "#E5E9F0";
	}, function (p) {
	  return p.touched ? "0 6px 20px rgba(58, 80, 123, 0.18)" : "none";
	}, function (p) {
	  return p.touched ? "0 8px 24px rgba(58, 80, 123, 0.24)" : "0 4px 16px rgba(15, 23, 41, 0.06)";
	});
	
	var ProductHeader = _styledComponents2.default.div(_templateObject24);
	
	var ProductIconWrap = _styledComponents2.default.div(_templateObject25);
	
	var ProductName = _styledComponents2.default.div(_templateObject26);
	
	var FieldLabel = _styledComponents2.default.div(_templateObject27);
	
	// Styled input wrappers so the NumberFormat-rendered <input> picks up
	// the same focus/hover treatment as the surrounding cards. Styling the
	// inner input by descendant selector — react-number-format v2 doesn't
	// always forward className through styled().
	var InputBox = _styledComponents2.default.div(_templateObject28, function (p) {
	  return p.invalid ? "#DC2626" : "#E5E9F0";
	}, function (p) {
	  return p.invalid ? "#DC2626" : "#3A507B";
	}, function (p) {
	  return p.invalid ? "rgba(220, 38, 38, 0.12)" : "rgba(58, 80, 123, 0.12)";
	}, FONT);
	
	var InputPrefix = _styledComponents2.default.span(_templateObject29);
	
	var InputSuffix = _styledComponents2.default.span(_templateObject30);
	
	var FieldError = _styledComponents2.default.div(_templateObject31);
	
	var RevenueRow = _styledComponents2.default.div(_templateObject32);
	
	var RevenueLabel = _styledComponents2.default.div(_templateObject33);
	
	var RevenueValue = _styledComponents2.default.div(_templateObject34);
	
	// ---------- $0-price confirmation modal ----------
	//
	// Fires when the user tries to Set Pricing while a released product
	// still has a $0 price. Two buttons: Cancel returns them to the
	// pricing table; Continue commits the save with the $0 price intact.
	
	var ConfirmBackdrop = _styledComponents2.default.div(_templateObject35);
	
	var ConfirmCard = _styledComponents2.default.div(_templateObject36);
	
	var ConfirmTitle = _styledComponents2.default.h2(_templateObject37);
	
	var ConfirmBody = _styledComponents2.default.div(_templateObject38);
	
	var ConfirmProductList = _styledComponents2.default.ul(_templateObject39);
	
	var ConfirmActions = _styledComponents2.default.div(_templateObject40);
	
	var ConfirmSecondaryBtn = _styledComponents2.default.button(_templateObject41);
	
	var ConfirmPrimaryBtn = _styledComponents2.default.button(_templateObject42);
	
	// ---------- component ----------
	
	var SetPricingPage = function (_PureComponent) {
	  _inherits(SetPricingPage, _PureComponent);
	
	  function SetPricingPage(props) {
	    _classCallCheck(this, SetPricingPage);
	
	    var _this = _possibleConstructorReturn(this, (SetPricingPage.__proto__ || Object.getPrototypeOf(SetPricingPage)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Per-product local edit state, keyed by product id.
	      // { [productId]: { price, forecast, forecast_id, player, invalidPrice, invalidForecast } }
	      products: {},
	      isSaving: false,
	      errorMessage: null,
	      successMessage: null,
	      // Names of released products currently priced at $0. When
	      // non-null, the "continue anyway?" confirmation modal renders
	      // and the actual save is deferred until the user picks a button.
	      zeroPriceProductNames: null
	    };
	    _this._successTimer = null;
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(SetPricingPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._mounted = true;
	      this.initProducts(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.products !== this.props.products || nextProps.price_forecasts !== this.props.price_forecasts) {
	        this.initProducts(nextProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      if (this._successTimer) {
	        clearTimeout(this._successTimer);
	        this._successTimer = null;
	      }
	    }
	
	    // Seed each product row from the current price_forecasts entry. If
	    // there's no live forecast for a product, default price and forecast
	    // to 0 per the spec ("if no pricing exists, input zero value").
	
	
	    // Single update entry-point. Keeps validation flags in sync so the
	    // red ring clears as soon as the user fixes the value.
	
	
	    // ---------- totals ----------
	
	  }, {
	    key: "renderProductIcon",
	
	
	    // ---------- render ----------
	
	    // Product card icon — simple price-tag glyph. Doesn't depend on the
	    // product name so every product gets the same affordance.
	    value: function renderProductIcon() {
	      return _react2.default.createElement(
	        "svg",
	        { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
	          strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round",
	          width: "22", height: "22" },
	        _react2.default.createElement("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
	        _react2.default.createElement("line", { x1: "7", y1: "7", x2: "7.01", y2: "7" })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          _props$products = _props.products,
	          products = _props$products === undefined ? [] : _props$products,
	          actionsAllowed = _props.actionsAllowed,
	          onClose = _props.onClose;
	      var _state = this.state,
	          isSaving = _state.isSaving,
	          errorMessage = _state.errorMessage,
	          successMessage = _state.successMessage,
	          zeroPriceProductNames = _state.zeroPriceProductNames;
	
	      var totalRevenue = this.totalForecastRevenue;
	
	      return _react2.default.createElement(
	        _style2.default.LenderOverlay,
	        null,
	        errorMessage && _react2.default.createElement(_error2.default, {
	          title: "Heads up",
	          message: errorMessage,
	          onHide: this.hideErrorMessage
	        }),
	        zeroPriceProductNames && zeroPriceProductNames.length > 0 && _react2.default.createElement(
	          ConfirmBackdrop,
	          { role: "dialog", "aria-modal": "true" },
	          _react2.default.createElement(
	            ConfirmCard,
	            null,
	            _react2.default.createElement(
	              ConfirmTitle,
	              null,
	              "Continue with a $0 price?"
	            ),
	            _react2.default.createElement(
	              ConfirmBody,
	              null,
	              zeroPriceProductNames.length === 1 ? "This released product still has a $0 selling price:" : "These released products still have a $0 selling price:",
	              _react2.default.createElement(
	                ConfirmProductList,
	                null,
	                zeroPriceProductNames.map(function (name) {
	                  return _react2.default.createElement(
	                    "li",
	                    { key: name },
	                    name
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { marginTop: 12 } },
	                "Selling at $0 means no revenue on those units. Go back to set a price, or continue anyway."
	              )
	            ),
	            _react2.default.createElement(
	              ConfirmActions,
	              null,
	              _react2.default.createElement(
	                ConfirmSecondaryBtn,
	                { onClick: this.cancelZeroPricePost },
	                "Go Back"
	              ),
	              _react2.default.createElement(
	                ConfirmPrimaryBtn,
	                { onClick: this.confirmZeroPricePost },
	                "Continue"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Page,
	          null,
	          successMessage && _react2.default.createElement(
	            ToastSlot,
	            null,
	            _react2.default.createElement(_success2.default, { message: successMessage })
	          ),
	          _react2.default.createElement(
	            HeaderBlock,
	            null,
	            _react2.default.createElement(
	              HeaderLeft,
	              null,
	              _react2.default.createElement(
	                TitleRow,
	                null,
	                _react2.default.createElement(
	                  TitleIcon,
	                  null,
	                  "\uD83D\uDCB2"
	                ),
	                _react2.default.createElement(
	                  Title,
	                  null,
	                  "Set Pricing"
	                )
	              ),
	              _react2.default.createElement(
	                Subtitle,
	                null,
	                "Set the selling price and unit forecast for each of your products."
	              )
	            ),
	            _react2.default.createElement(
	              CloseButton,
	              { onClick: onClose, "aria-label": "Close" },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            KpiRow,
	            null,
	            _react2.default.createElement(
	              KpiCard,
	              null,
	              _react2.default.createElement(
	                KpiIcon,
	                null,
	                "$"
	              ),
	              _react2.default.createElement(
	                KpiContent,
	                null,
	                _react2.default.createElement(
	                  KpiLabel,
	                  null,
	                  "Total Forecast Revenue"
	                ),
	                _react2.default.createElement(
	                  KpiValue,
	                  null,
	                  fmtMoney(totalRevenue)
	                )
	              ),
	              _react2.default.createElement(
	                KpiAside,
	                null,
	                products.length,
	                " ",
	                products.length === 1 ? "product" : "products"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            SectionHeader,
	            null,
	            _react2.default.createElement(
	              SectionTitle,
	              null,
	              "Product Pricing"
	            ),
	            _react2.default.createElement(
	              FooterButtons,
	              null,
	              _react2.default.createElement(
	                BtnSecondary,
	                { onClick: this.resetAll, disabled: !actionsAllowed || isSaving },
	                "Reset All"
	              ),
	              _react2.default.createElement(
	                BtnPrimary,
	                {
	                  onClick: this.postPricing,
	                  disabled: !actionsAllowed || isSaving
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  isSaving ? "Saving…" : "Set Pricing"
	                ),
	                !isSaving && _react2.default.createElement(
	                  "span",
	                  null,
	                  "\u2192"
	                )
	              )
	            )
	          ),
	          products.length === 0 ? _react2.default.createElement(
	            ProductCard,
	            null,
	            _react2.default.createElement(
	              ProductName,
	              null,
	              "No products available yet."
	            ),
	            _react2.default.createElement(
	              Subtitle,
	              null,
	              "Coordinate with your Head of Product (or CEO) to develop a product first."
	            )
	          ) : _react2.default.createElement(
	            ProductsGrid,
	            null,
	            products.map(this.renderProductCard)
	          )
	        )
	      );
	    }
	  }, {
	    key: "totalForecastRevenue",
	    get: function get() {
	      return this.productList().reduce(function (sum, row) {
	        return sum + (Number(row.price) || 0) * (Number(row.forecast) || 0);
	      }, 0);
	    }
	
	    // ---------- save ----------
	
	    // The bulk endpoint is scoped to (team, round). team and player come
	    // from auth/Teams; round id is looked up from the rounds array.
	
	  }, {
	    key: "hasNewForecast",
	
	
	    // Whether any product on the team currently lacks a saved forecast row.
	    // Used to decide whether to bump the unaccepted-decisions counter
	    // after a successful bulk save (only counts the first time a forecast
	    // appears for a product).
	    get: function get() {
	      var rows = this.productList();
	      return rows.some(function (row) {
	        return !row.forecast_id || row.forecast_id <= 0;
	      });
	    }
	  }]);
	
	  return SetPricingPage;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.goToCustomerAnalysis = function (e) {
	    e.preventDefault();
	    _this2.eventemitter.trigger("coaching-feedback-hide");
	    (0, _Location.changeLocation)("/ceo/analysis/market");
	  };
	
	  this.showPopupHighPriceMobile = function () {
	    _this2.eventemitter.trigger("coaching-feedback", ["Food for Thought", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Wow! You're looking to crush it this year!"
	      ),
	      _react2.default.createElement("br", null),
	      "But are you sure any mobile customer is willing to pay that high price for this product"
	    ), "If so, how many units will the customer buy? I doubt any auto customers will buy", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      "Before pricing your product, please double check ",
	      _react2.default.createElement(
	        "a",
	        { href: "/ceo/analysis/market", onClick: _this2.goToCustomerAnalysis },
	        "customer analysis"
	      ),
	      " to gain a better understanding of your customers needs/wants... you're welcome!"
	    )]);
	  };
	
	  this.showPopupHighPriceAuto = function () {
	    _this2.eventemitter.trigger("coaching-feedback", ["Food for Thought", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Wow! You're looking to crush it this year!"
	      ),
	      _react2.default.createElement("br", null),
	      "But are you sure any customer is willing to pay that high price for this product"
	    ), "If so, how many units will the customer buy?", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      "Before pricing your product, please double check ",
	      _react2.default.createElement(
	        "a",
	        { href: "/ceo/analysis/market", onClick: _this2.goToCustomerAnalysis },
	        "customer analysis"
	      ),
	      " to gain a better understanding of your customers needs/wants... you're welcome!"
	    )]);
	  };
	
	  this.showPopupLowPrice = function () {
	    _this2.eventemitter.trigger("coaching-feedback", ["Food for Thought", "I see what you're doing! Low prices, higher demand for your product. Econ 101, I get it...but you should consider a few things.", _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Is the price too low?"
	      ),
	      _react2.default.createElement("br", null),
	      "At a certain low price point, customers might think your product must not be good and won't buy."
	    ), _react2.default.createElement(
	      _reactDotFragment2.default,
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "How much of a Gross Margin (GM) will you make on each unit sold?"
	      ),
	      _react2.default.createElement("br", null),
	      "GM = (Selling Price - Unit Costs) / Selling Price. GM is also a key grading metric."
	    )]);
	  };
	
	  this.initProducts = function (props) {
	    var products = {};
	    (props.products || []).forEach(function (product) {
	      var pf = (props.price_forecasts || []).find(function (i) {
	        return Number(i.product) === Number(product.id);
	      });
	      products[product.id] = {
	        name: product.name,
	        price: pf ? Number(pf.price) || 0 : 0,
	        forecast: pf ? Number(pf.forecast) || 0 : 0,
	        forecast_id: pf ? pf.id : 0,
	        player: pf ? pf.player : null,
	        invalidPrice: false,
	        invalidForecast: false
	      };
	    });
	    _this2.setState({ products: products });
	  };
	
	  this.setField = function (productId, key, value) {
	    var products = Object.assign({}, _this2.state.products);
	    var row = products[productId];
	    if (!row) return;
	    var next = Object.assign({}, row, _defineProperty({}, key, value));
	    if (key === "price") {
	      next.invalidPrice = !(value >= PRICE_MIN && value <= PRICE_MAX);
	    } else if (key === "forecast") {
	      next.invalidForecast = !(value >= FORECAST_MIN && value <= FORECAST_MAX);
	    }
	    products[productId] = next;
	    _this2.setState({ products: products });
	  };
	
	  this.onPriceChange = function (productId) {
	    return function (e, values) {
	      var raw = values && typeof values.floatValue === "number" ? values.floatValue : 0;
	      _this2.setField(productId, "price", raw);
	    };
	  };
	
	  this.onForecastChange = function (productId) {
	    return function (e, values) {
	      var raw = values && typeof values.floatValue === "number" ? values.floatValue : 0;
	      _this2.setField(productId, "forecast", raw);
	    };
	  };
	
	  this.resetAll = function () {
	    // Reset to the values currently saved on the backend, not zeros —
	    // matches the convention in the rest of the app where "Reset" means
	    // "discard my unsaved edits."
	    _this2.initProducts(_this2.props);
	  };
	
	  this.productList = function () {
	    var _props$products2 = _this2.props.products,
	        products = _props$products2 === undefined ? [] : _props$products2;
	
	    return (products || []).map(function (p) {
	      return Object.assign({
	        id: p.id
	      }, _this2.state.products[p.id]);
	    }).filter(function (p) {
	      return p.name != null;
	    });
	  };
	
	  this.hideErrorMessage = function () {
	    _this2.setState({ errorMessage: null });
	  };
	
	  this.showLocalSuccess = function (message) {
	    if (_this2._successTimer) clearTimeout(_this2._successTimer);
	    _this2.setState({ successMessage: message });
	    _this2._successTimer = setTimeout(function () {
	      if (!_this2._mounted) return;
	      _this2.setState({ successMessage: null });
	    }, 5000);
	  };
	
	  this.resolveBulkContext = function () {
	    var _props2 = _this2.props,
	        _props2$rounds = _props2.rounds,
	        rounds = _props2$rounds === undefined ? [] : _props2$rounds,
	        currentRound = _props2.currentRound;
	
	    var teamId = _Auth2.default.getTeamId();
	    var player = _Teams2.default.currentPlayer();
	    var playerId = player ? player.id : null;
	    var round = rounds.find(function (r) {
	      return Number(r.number) === Number(currentRound);
	    });
	    var roundId = round ? round.id : null;
	    return { teamId: teamId, playerId: playerId, roundId: roundId };
	  };
	
	  this.postPricing = function () {
	    if (!_this2.props.actionsAllowed) return;
	
	    var rows = _this2.productList();
	    if (rows.length === 0) {
	      _this2.setState({
	        errorMessage: "There are no products to price. Please coordinate with Product Development first."
	      });
	      return;
	    }
	
	    // Validate every row before sending anything; surface a single
	    // error message if any value is out of range.
	    var products = Object.assign({}, _this2.state.products);
	    var hasInvalid = false;
	    rows.forEach(function (row) {
	      var invalidPrice = !(row.price >= PRICE_MIN && row.price <= PRICE_MAX);
	      var invalidForecast = !(row.forecast >= FORECAST_MIN && row.forecast <= FORECAST_MAX);
	      if (invalidPrice || invalidForecast) hasInvalid = true;
	      products[row.id] = Object.assign({}, products[row.id], { invalidPrice: invalidPrice, invalidForecast: invalidForecast });
	    });
	    if (hasInvalid) {
	      _this2.setState({
	        products: products,
	        errorMessage: "Price must be between $" + PRICE_MIN + " and $" + PRICE_MAX + ", and unit forecast must be between " + fmtInt(FORECAST_MIN) + " and " + fmtInt(FORECAST_MAX) + "."
	      });
	      return;
	    }
	
	    // Soft-warn on released products (months_available_to_produce > 0)
	    // still priced at $0. PRICE_MIN is 0, so the range check above
	    // lets these through, but shipping a released product for $0 is
	    // almost always a mistake. Missing months_available_to_produce is
	    // treated as "released" per the game rule so we don't quietly
	    // let a $0 price slip through when the field is absent.
	    var productsById = new Map((_this2.props.products || []).map(function (p) {
	      return [Number(p.id), p];
	    }));
	    var zeroPriceReleasedNames = rows.filter(function (row) {
	      return Number(row.price) === 0;
	    }).filter(function (row) {
	      var p = productsById.get(Number(row.id));
	      var months = p && p.months_available_to_produce != null ? Number(p.months_available_to_produce) : 1;
	      return months > 0;
	    }).map(function (row) {
	      return row.name;
	    });
	    if (zeroPriceReleasedNames.length > 0) {
	      _this2.setState({ zeroPriceProductNames: zeroPriceReleasedNames });
	      return;
	    }
	
	    _this2.doPostPricing(rows);
	  };
	
	  this.confirmZeroPricePost = function () {
	    _this2.setState({ zeroPriceProductNames: null });
	    _this2.doPostPricing(_this2.productList());
	  };
	
	  this.cancelZeroPricePost = function () {
	    _this2.setState({ zeroPriceProductNames: null });
	  };
	
	  this.doPostPricing = function (rows) {
	    var _resolveBulkContext = _this2.resolveBulkContext(),
	        teamId = _resolveBulkContext.teamId,
	        playerId = _resolveBulkContext.playerId,
	        roundId = _resolveBulkContext.roundId;
	
	    if (!teamId || !playerId || !roundId) {
	      _this2.setState({
	        errorMessage: "We couldn't determine your team, round, or player context. Please refresh the page and try again."
	      });
	      return;
	    }
	
	    var willCreate = _this2.hasNewForecast;
	    // True when NO product's forecast has been posted by a player yet.
	    // Used with currentRound === 1 to detect the student's very
	    // first pricing decision so PMDecisions can show the coaching
	    // popup that reminds them about the other two marketing
	    // decisions (promotion + sales channel).
	    //
	    // Test `player`, not `forecast_id` — the backend pre-seeds a
	    // price_forecasts row for every product with a valid id but
	    // player=null. A decision is "made" only once a player is
	    // attached to the record (mirrors the Set Allocation trigger
	    // in manage-promotion-page.js).
	    var wasFirstPricingRd1 = Number(_this2.props.currentRound) === 1 && rows.every(function (row) {
	      return row.player == null;
	    });
	    var forecasts = rows.map(function (row) {
	      return {
	        product: row.id,
	        price: Number(row.price) || 0,
	        forecast: Number(row.forecast) || 0
	      };
	    });
	
	    var body = {
	      team: teamId,
	      round: roundId,
	      player: playerId,
	      forecasts: forecasts
	    };
	
	    _this2.setState({ isSaving: true });
	
	    (0, _ApiService.putRequest)(PRICE_FORECASTS_BULK_URL).send(body).then(function (res) {
	      // Coaching popups (ported from ModalPMDecisionsRevenueForecast).
	      // The bulk endpoint may return either an array or a shape like
	      // { forecasts: [...] } / { results: [...] }; grab whichever is
	      // present so we can scan per-forecast feedback flags.
	      var bodyRes = res && res.body || {};
	      var forecastRows = Array.isArray(bodyRes) ? bodyRes : bodyRes.forecasts || bodyRes.results || [];
	      var anyMobileHigh = forecastRows.some(function (r) {
	        return Number(r.high_price_mobile_feedback) === 1;
	      });
	      var anyAutoHigh = forecastRows.some(function (r) {
	        return Number(r.high_price_auto_feedback) === 1;
	      });
	      var anyLowPrice = forecastRows.some(function (r) {
	        return Number(r.price) > 0 && Number(r.price) <= 5;
	      });
	      var anyAutoLow = forecastRows.some(function (r) {
	        return Number(r.low_price_auto_feedback) === 1;
	      });
	      if (anyMobileHigh) {
	        _this2.showPopupHighPriceMobile();
	      } else if (anyAutoHigh) {
	        _this2.showPopupHighPriceAuto();
	      } else if (anyLowPrice || anyAutoLow) {
	        _this2.showPopupLowPrice();
	      }
	
	      if (willCreate) {
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("marketing");
	      }
	      if (_this2.props.reloadData) _this2.props.reloadData();
	      if (_this2._mounted) {
	        _this2.setState({ isSaving: false });
	        _this2.showLocalSuccess("Pricing and unit forecast were successfully saved.");
	      }
	      if (wasFirstPricingRd1 && _this2.props.onFirstPricingSet) {
	        _this2.props.onFirstPricingSet();
	      }
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "SetPricingPage", "postPricing");
	      if (_this2._mounted) {
	        _this2.setState({
	          isSaving: false,
	          errorMessage: "Something went wrong saving your pricing. Please try again."
	        });
	      }
	    });
	  };
	
	  this.renderProductCard = function (product) {
	    var actionsAllowed = _this2.props.actionsAllowed;
	
	    var row = _this2.state.products[product.id];
	    if (!row) return null;
	    var expectedRevenue = (Number(row.price) || 0) * (Number(row.forecast) || 0);
	    var touched = (Number(row.price) || 0) > 0 || (Number(row.forecast) || 0) > 0;
	
	    return _react2.default.createElement(
	      ProductCard,
	      { key: product.id, touched: touched },
	      _react2.default.createElement(
	        ProductHeader,
	        null,
	        _react2.default.createElement(
	          ProductIconWrap,
	          null,
	          _this2.renderProductIcon()
	        ),
	        _react2.default.createElement(
	          ProductName,
	          null,
	          "Product ",
	          row.name
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          FieldLabel,
	          null,
	          "Set Price"
	        ),
	        _react2.default.createElement(
	          InputBox,
	          { invalid: row.invalidPrice },
	          _react2.default.createElement(
	            InputPrefix,
	            null,
	            "$"
	          ),
	          _react2.default.createElement(_reactNumberFormat2.default, {
	            value: row.price,
	            thousandSeparator: ",",
	            decimalSeparator: ".",
	            decimalPrecision: 2,
	            allowNegative: false,
	            onChange: _this2.onPriceChange(product.id),
	            disabled: !actionsAllowed
	          })
	        ),
	        row.invalidPrice && _react2.default.createElement(
	          FieldError,
	          null,
	          "Price must be between $",
	          PRICE_MIN,
	          " and $",
	          PRICE_MAX,
	          "."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          FieldLabel,
	          null,
	          "Set Unit Forecast"
	        ),
	        _react2.default.createElement(
	          InputBox,
	          { invalid: row.invalidForecast },
	          _react2.default.createElement(_reactNumberFormat2.default, {
	            value: row.forecast,
	            thousandSeparator: ",",
	            allowNegative: false,
	            onChange: _this2.onForecastChange(product.id),
	            disabled: !actionsAllowed
	          }),
	          _react2.default.createElement(
	            InputSuffix,
	            null,
	            "units"
	          )
	        ),
	        row.invalidForecast && _react2.default.createElement(
	          FieldError,
	          null,
	          "Forecast must be between ",
	          fmtInt(FORECAST_MIN),
	          " and ",
	          fmtInt(FORECAST_MAX),
	          "."
	        )
	      ),
	      _react2.default.createElement(
	        RevenueRow,
	        null,
	        _react2.default.createElement(
	          RevenueLabel,
	          null,
	          "Expected Revenue"
	        ),
	        _react2.default.createElement(
	          RevenueValue,
	          null,
	          fmtMoney(expectedRevenue)
	        )
	      )
	    );
	  };
	};
	
	exports.default = SetPricingPage;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "grey");
	
	function UiButton(props) {
	  var onClick = props.onClick,
	      disabled = props.disabled,
	      children = props.children,
	      className = props.className;
	
	
	  var style = disabled === true ? "grey" : "primary";
	  var btnClassName = className ? "btn-pm-decisions-button " + className : "btn-pm-decisions-button";
	
	  return _react2.default.createElement(
	    _reactBootstrap.Button,
	    {
	      className: btnClassName,
	      bsStyle: style,
	      onClick: onClick,
	      disabled: disabled
	    },
	    children
	  );
	}
	
	exports.default = UiButton;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 26px;\n  color: #36507e;\n  margin-top: -80px;\n  margin-bottom: 60px;\n"], ["\n  text-align: center;\n  font-size: 26px;\n  color: #36507e;\n  margin-top: -80px;\n  margin-bottom: 60px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 16px;\n  width: 100%;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-size: 16px;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-align: center;\n\n  h3 {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #36507e;\n  }\n\n  span {\n    color: #74abec;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  display: inline-block;\n  text-align: center;\n\n  h3 {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #36507e;\n  }\n\n  span {\n    color: #74abec;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"], ["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  padding: 10px 40px 25px !important;\n"], ["\n  padding: 10px 40px 25px !important;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"], ["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  padding: 0 !important;\n  height: 75px !important;\n  position: relative;\n"], ["\n  padding: 0 !important;\n  height: 75px !important;\n  position: relative;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 25px;\n  right: 35px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"], ["\n  position: absolute;\n  bottom: 25px;\n  right: 35px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"], ["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"], ["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"], ["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"], ["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  max-width: 530px;\n"], ["\n  max-width: 530px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 25px;\n  right: 195px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"], ["\n  position: absolute;\n  bottom: 25px;\n  right: 195px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(367);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recharts = __webpack_require__(27);
	
	var _index = __webpack_require__(306);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartTitle = _styledComponents2.default.div(_templateObject);
	
	var ButtonsRow = _styledComponents2.default.div(_templateObject2);
	
	var ChartButton = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	});
	
	var ChartButtonContent = _styledComponents2.default.div(_templateObject4);
	
	var ModalWrapper = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject5);
	
	var ModalHeader = (0, _styledComponents2.default)(_reactBootstrap.Modal.Header)(_templateObject6);
	
	var ModalBody = (0, _styledComponents2.default)(_reactBootstrap.Modal.Body)(_templateObject7);
	
	var ModalTitle = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	});
	
	var ModalQuestion = _styledComponents2.default.div(_templateObject9);
	
	var ModalFeedbackValue = _styledComponents2.default.div(_templateObject10);
	
	var RatingText = _styledComponents2.default.div(_templateObject11);
	
	var RatingRow = _styledComponents2.default.div(_templateObject12);
	
	var ModalFooter = (0, _styledComponents2.default)(_reactBootstrap.Modal.Footer)(_templateObject13);
	
	var ContinueButton = _styledComponents2.default.button(_templateObject14);
	
	var AnswerWrapper = _styledComponents2.default.div(_templateObject15);
	
	var AnswerRow = _styledComponents2.default.div(_templateObject16);
	
	var AnswerCounter = _styledComponents2.default.div(_templateObject17);
	
	var AnswerText = _styledComponents2.default.div(_templateObject18);
	
	var BarChartWrapper = _styledComponents2.default.div(_templateObject19);
	
	var BackButton = _styledComponents2.default.button(_templateObject20);
	
	var ucFirst = function ucFirst(str) {
	  return str ? str[0].toUpperCase() + str.slice(1) : str;
	};
	var getAllValues = function getAllValues(reports) {
	  return Object.values(reports).map(function (report) {
	    return [Number(report.average_user_score.toFixed(2)), Number(report.team_average_score.toFixed(2)), Number(report.team_median_score.toFixed(2))];
	  }).reduce(function (result, currentArray) {
	    return [].concat(_toConsumableArray(result), _toConsumableArray(currentArray));
	  }, []);
	};
	
	var MODAL_TYPE_INITIAL = 0;
	//const MODAL_TYPE_POSITIVE = 1;
	//const MODAL_TYPE_NEGATIVE = 2;
	//const MODAL_TYPE_SELF_REFLECTION = 1;
	
	var Chart = function (_Component) {
	  _inherits(Chart, _Component);
	
	  function Chart(props) {
	    _classCallCheck(this, Chart);
	
	    var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props));
	
	    _this.showModal = function (currentReport, stage) {
	      var surveys = _this.props.surveys;
	
	      var currentSurvey = surveys.find(function (survey) {
	        return survey.stage === stage;
	      });
	      _this.setState({
	        currentReport: currentReport,
	        currentSurvey: currentSurvey,
	        currentPage: 0,
	        currentType: MODAL_TYPE_INITIAL
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        currentReport: null,
	        currentSurvey: null
	      });
	    };
	
	    _this.getQuestions = function (currentType) {
	      var _this$state = _this.state,
	          currentReport = _this$state.currentReport,
	          currentSurvey = _this$state.currentSurvey;
	
	
	      if (!currentReport || !currentSurvey) {
	        return [];
	      }
	
	      var questions = [];
	      if (currentType === MODAL_TYPE_INITIAL) {
	        questions = currentReport.average_user_score_question;
	      } /*else if (currentType === MODAL_TYPE_POSITIVE) {
	        const ids = currentSurvey.questions
	          .filter(
	            question =>
	              question.answer_type === "freeform" &&
	              question.category === "communication"
	          )
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        } else if (currentType === MODAL_TYPE_NEGATIVE) {
	        const ids = currentSurvey.questions
	          .filter(
	            question =>
	              question.assessment_type === "negative" &&
	              question.category !== "self_assessment"
	          )
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        } else if (currentType === MODAL_TYPE_SELF_REFLECTION) {
	        const ids = currentSurvey.questions
	          .filter(question => question.category === "self_assessment")
	          .map(question => question.id);
	        questions = currentReport.freeform_answers.filter(answer =>
	          ids.includes(answer.survey_question)
	        );
	        }*/
	
	      var needSkip = currentSurvey.questions.filter(function (i) {
	        return i.most_valuable === true || i.work_together === true;
	      }).map(function (i) {
	        return i.id;
	      });
	
	      if (currentType !== MODAL_TYPE_INITIAL) {
	        questions = questions.filter(function (i) {
	          return !needSkip.includes(i.survey_question);
	        });
	      }
	
	      return _lodash2.default.chunk(questions, 4);
	    };
	
	    _this.nextPage = function () {
	      var currentPage = _this.state.currentPage;
	
	
	      if (currentPage < _this.questions.length - 1) {
	        _this.setState({
	          currentPage: currentPage + 1
	        });
	      }
	    };
	
	    _this.goBack = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          currentType = _this$state2.currentType;
	
	
	      if (currentPage > 0) {
	        _this.setState({
	          currentPage: currentPage - 1
	        });
	      } else if (currentType > 0) {
	        var prevQuestions = _this.getQuestions(currentType - 1);
	
	        _this.setState({
	          currentPage: prevQuestions.length - 1,
	          currentType: currentType - 1
	        });
	      }
	    };
	
	    _this.state = {
	      currentSurvey: null,
	      currentReport: null,
	      currentPage: 0,
	      currentType: MODAL_TYPE_INITIAL
	    };
	    return _this;
	  }
	
	  _createClass(Chart, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _reactChartjs.Chart.Tooltip.positioners.custom = function (elements) {
	        if (!elements.length) {
	          return false;
	        }
	
	        var i = void 0,
	            len = void 0;
	        var y = 0;
	        var count = 0;
	        var nearestElement = void 0;
	
	        for (i = 0, len = elements.length; i < len; ++i) {
	          var el = elements[i];
	          if (el && el.hasValue()) {
	            if (!nearestElement) {
	              nearestElement = el;
	            }
	            var pos = el.tooltipPosition();
	            y += pos.y;
	            ++count;
	          }
	        }
	
	        var barOffset = nearestElement ? Math.round(nearestElement.getArea() / 45 + 20) : 0;
	
	        return {
	          x: barOffset + 40,
	          y: Math.round(y / count)
	        };
	      };
	
	      _reactChartjs.Chart.pluginService.register({
	        beforeRender: function beforeRender(chart) {
	          if (chart.config.options.showAllTooltips) {
	            chart.pluginTooltips = [];
	            chart.config.data.datasets.forEach(function (_, i) {
	              chart.getDatasetMeta(i).data.forEach(function (sector, j) {
	                chart.pluginTooltips.push(new _reactChartjs.Chart.Tooltip({
	                  _chart: chart.chart,
	                  _chartInstance: chart,
	                  _data: chart.data,
	                  _options: chart.options.tooltips,
	                  _active: [sector]
	                }, chart));
	              });
	            });
	
	            chart.options.tooltips.enabled = false;
	          }
	        },
	
	        afterDraw: function afterDraw(chart, easing) {
	          if (chart.config.options.showAllTooltips) {
	            if (!chart.allTooltipsOnce) {
	              if (easing !== 1) {
	                return;
	              }
	
	              chart.allTooltipsOnce = true;
	            }
	
	            chart.options.tooltips.enabled = true;
	            _reactChartjs.Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
	              tooltip.initialize();
	              tooltip.update();
	              tooltip.pivot();
	              tooltip.transition(easing).draw();
	            });
	            chart.options.tooltips.enabled = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          title = _props.title,
	          reports = _props.reports,
	          isSurveyFinished = _props.isSurveyFinished;
	      var _state = this.state,
	          currentReport = _state.currentReport,
	          currentPage = _state.currentPage,
	          currentType = _state.currentType;
	
	      var allValues = getAllValues(reports);
	      var isBarChart = Object.keys(reports).length === 1 ? true : false;
	      var align = {
	        initial: "left",
	        second: "center",
	        final: "right"
	      };
	      var options = {
	        legend: {
	          display: false
	        },
	        scales: {
	          xAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              min: 0,
	              max: Math.max.apply(null, allValues),
	              callback: function callback() {
	                return "";
	              }
	            }
	          }],
	          yAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              callbacks: function callbacks() {
	                return "";
	              }
	            }
	          }]
	        },
	        tooltips: {
	          enabled: true,
	          mode: "point",
	          position: "custom",
	          backgroundColor: "transparent",
	          bodyFontFamily: "Lato",
	          bodyFontSize: 16,
	          bodyFontStyle: "bold",
	          bodyFontColor: "#2a4169",
	          bodyAlign: "center",
	          displayColors: false,
	          xPadding: 0,
	          yPadding: 0,
	          bodySpacing: 0,
	          callbacks: {
	            title: function title() {
	              return "";
	            },
	            label: function label(tooltipItem) {
	              return (Math.round(tooltipItem.value * 100) / 100).toFixed(2);
	            }
	          }
	        },
	        showAllTooltips: true,
	        layout: {
	          padding: {
	            right: 40
	          }
	        }
	      };
	
	      var getReportForBar = function getReportForBar(key, label, backgroundColor) {
	        return {
	          label: label,
	          data: Object.values(Object.keys(reports).reduce(function (result, stage) {
	            return Object.assign({}, result, _defineProperty({}, stage, Number(reports[stage][key].toFixed(2))));
	          }, {})),
	          backgroundColor: backgroundColor,
	          borderWidth: 0,
	          minBarLength: 20,
	          barPercentage: 0.8,
	          maxBarThickness: 45
	        };
	      };
	
	      var data = {
	        labels: [""],
	        datasets: [getReportForBar("average_user_score", "You", _Teams2.default.currentTeamColor()), getReportForBar("team_average_score", "Team Average", "#eee"), getReportForBar("team_median_score", "Team Median", "#c4c4c4")],
	        options: options
	      };
	      var surveys = this.props.surveys.filter(function (survey) {
	        return isSurveyFinished(survey);
	      }).map(function (survey) {
	        return survey.stage;
	      });
	      if (surveys.length < 3) {
	        for (var i = 0; i < 3 - surveys.length; i++) {
	          surveys.push("");
	        }
	      }
	
	      var stages = {
	        initial: "Initial Feedback",
	        second: "Second Feedback",
	        final: "Final Feedback"
	      };
	      var tmpData = Object.keys(reports).map(function (stage) {
	        return {
	          name: stages[stage],
	          You: Number(reports[stage].average_user_score.toFixed(2)),
	          "Team Average": Number(reports[stage].team_average_score.toFixed(2)),
	          "Team Median": Number(reports[stage].team_median_score.toFixed(2))
	        };
	      });
	
	      var initial = tmpData.find(function (i) {
	        return i.name === "Initial Feedback";
	      });
	      if (!initial) {
	        initial = {
	          name: "Initial Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var second = tmpData.find(function (i) {
	        return i.name === "Second Feedback";
	      });
	      if (!second) {
	        second = {
	          name: "Second Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var final = tmpData.find(function (i) {
	        return i.name === "Final Feedback";
	      });
	      if (!final) {
	        final = {
	          name: "Final Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var chartData = [initial, second, final];
	      var isShowModal = currentReport ? true : false;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          ChartTitle,
	          null,
	          title
	        ),
	        !isBarChart && _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 300 },
	          _react2.default.createElement(
	            _recharts.LineChart,
	            {
	              data: chartData,
	              margin: {
	                top: 0,
	                right: 0,
	                left: 0,
	                bottom: 0
	              }
	            },
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(_recharts.XAxis, {
	              dataKey: "name",
	              padding: { top: 30, left: 30, right: 30, bottom: 30 },
	              hide: true
	            }),
	            _react2.default.createElement(_recharts.YAxis, {
	              hide: true,
	              domain: [Math.min.apply(null, allValues) * 0.9, Math.max.apply(null, allValues) * 1.1]
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "You",
	              stroke: _Teams2.default.currentTeamColor(),
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Average",
	              stroke: "#eee",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Median",
	              stroke: "#c4c4c4",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2
	            })
	          )
	        ),
	        isBarChart && _react2.default.createElement(
	          BarChartWrapper,
	          null,
	          _react2.default.createElement(_reactChartjs.HorizontalBar, { data: data, options: options })
	        ),
	        _react2.default.createElement(
	          ButtonsRow,
	          null,
	          surveys.map(function (stage, id) {
	            return stage !== "" ? _react2.default.createElement(
	              ChartButton,
	              {
	                key: id,
	                align: stage in align ? align[stage] : "center"
	              },
	              _react2.default.createElement(
	                ChartButtonContent,
	                null,
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  ucFirst(stage),
	                  " ",
	                  _react2.default.createElement("br", null),
	                  " Feedback"
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { onClick: function onClick() {
	                      return _this2.showModal(reports[stage], stage);
	                    } },
	                  "View Details >"
	                )
	              )
	            ) : _react2.default.createElement(ChartButton, { key: id });
	          })
	        ),
	        isShowModal === true && _react2.default.createElement(
	          ModalWrapper,
	          { show: true, onHide: this.hideModal },
	          _react2.default.createElement(
	            ModalHeader,
	            { closeButton: true },
	            _react2.default.createElement(
	              ModalTitle,
	              { align: "left" },
	              this.modalTitle
	            ),
	            currentType === MODAL_TYPE_INITIAL && _react2.default.createElement(
	              ModalTitle,
	              { align: "right" },
	              "Collaboration"
	            )
	          ),
	          _react2.default.createElement(
	            ModalBody,
	            null,
	            currentType === MODAL_TYPE_INITIAL && this.questionsList.map(function (_ref, i) {
	              var question = _ref.question,
	                  rating = _ref.value;
	              return _react2.default.createElement(
	                "div",
	                { key: currentType + "-" + (currentPage * 4 + i + 1) },
	                _react2.default.createElement(
	                  ModalQuestion,
	                  null,
	                  currentPage * 4 + i + 1,
	                  ". ",
	                  question
	                ),
	                _react2.default.createElement(
	                  RatingRow,
	                  null,
	                  _react2.default.createElement(
	                    ModalFeedbackValue,
	                    null,
	                    Number(rating.toFixed(2))
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      RatingText,
	                      null,
	                      "Average Rating"
	                    ),
	                    _react2.default.createElement(_index2.default, { value: rating })
	                  )
	                )
	              );
	            }),
	            currentType !== MODAL_TYPE_INITIAL && _react2.default.createElement(
	              AnswerWrapper,
	              null,
	              this.questionsList.map(function (_ref2, i) {
	                var text = _ref2.text;
	                return _react2.default.createElement(
	                  AnswerRow,
	                  {
	                    key: currentType + "-" + (currentPage * 4 + i + 1)
	                  },
	                  _react2.default.createElement(
	                    AnswerCounter,
	                    null,
	                    currentPage * 4 + i + 1
	                  ),
	                  _react2.default.createElement(
	                    AnswerText,
	                    null,
	                    text
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            ModalFooter,
	            null,
	            !this.isFirstPage && _react2.default.createElement(
	              BackButton,
	              { onClick: this.goBack },
	              _react2.default.createElement(
	                "span",
	                { className: "small" },
	                "\u25C0"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Back"
	              )
	            ),
	            _react2.default.createElement(
	              ContinueButton,
	              {
	                onClick: this.isLastPage ? this.hideModal : this.nextPage
	              },
	              _react2.default.createElement(
	                "span",
	                null,
	                this.isLastPage ? "Close" : "Continue"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "small" },
	                "\u25B6"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "questions",
	    get: function get() {
	      var currentType = this.state.currentType;
	
	
	      return this.getQuestions(currentType);
	    }
	  }, {
	    key: "questionsList",
	    get: function get() {
	      var currentPage = this.state.currentPage;
	
	      var questions = this.questions;
	      var result = currentPage < questions.length ? questions[currentPage] : [];
	      var team = _Teams2.default.currentTeam();
	      var players = _Teams2.default.players();
	      var teammates = players.filter(function (player) {
	        return player.team === team.id && player.user.id !== parseInt(_Auth2.default.getUserId(), 10);
	      }).map(function (teammate) {
	        return teammate.user.username;
	      });
	
	      return result.filter(function (answer) {
	        return !teammates.includes(answer.text);
	      });
	    }
	  }, {
	    key: "isFirstPage",
	    get: function get() {
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          currentType = _state2.currentType;
	
	
	      return currentPage === 0 && currentType === MODAL_TYPE_INITIAL ? true : false;
	    }
	  }, {
	    key: "isLastPage",
	    get: function get() {
	      var _state3 = this.state,
	          currentPage = _state3.currentPage,
	          currentType = _state3.currentType;
	
	
	      if (currentPage === this.questions.length - 1) {
	        if (currentType === 0) {
	          var nextQuestions = this.getQuestions(currentType + 1);
	
	          if (nextQuestions.length === 0) {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "modalTitle",
	    get: function get() {
	      var currentType = this.state.currentType;
	
	      var titles = _defineProperty({}, MODAL_TYPE_INITIAL, "Initial Feedback");
	
	      return titles[currentType];
	    }
	  }]);
	
	  return Chart;
	}(_react.Component);
	
	exports.default = Chart;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 20px 40px !important;\n  max-width: 1180px;\n  background-color: hsla(0, 0%, 98%, 1);\n  box-sizing: content-box;\n  margin-left: 0;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n"], ["\n  width: 100%;\n  padding: 20px 40px !important;\n  max-width: 1180px;\n  background-color: hsla(0, 0%, 98%, 1);\n  box-sizing: content-box;\n  margin-left: 0;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 21px;\n  font-weight: 600;\n  color: lightgray;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-size: 21px;\n  font-weight: 600;\n  color: lightgray;\n\n  ", "\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  padding: 30px 0;\n  display: flex;\n  align-items: center;\n"], ["\n  padding: 30px 0;\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  margin-right: 15px;\n\n  ", "\n"], ["\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  margin-right: 15px;\n\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 24px;\n  font-weight: 700;\n  color: #5f5f5f;\n"], ["\n  font-family: Lato;\n  font-size: 24px;\n  font-weight: 700;\n  color: #5f5f5f;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: hsla(0, 0%, 100%, 1);\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n"], ["\n  width: 100%;\n  margin-top: 20px;\n  padding: 20px;\n  background-color: hsla(0, 0%, 100%, 1);\n  border: 1px solid hsla(213, 100%, 12%, 0.15);\n  border-radius: 8px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: hsla(213, 100%, 12%, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: hsla(213, 100%, 12%, 0.94);\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  margin-top: 16px;\n  border-bottom: 1px solid hsla(213, 100%, 12%, 0.15);\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin-top: 16px;\n  border-bottom: 1px solid hsla(213, 100%, 12%, 0.15);\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  max-height: 450px;\n  position: relative;\n  z-index: 1;\n"], ["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  max-height: 450px;\n  position: relative;\n  z-index: 1;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 0 20px;\n\n  ", "\n  img {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  padding: 0 20px;\n\n  ", "\n  img {\n    cursor: pointer;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  padding: 15px 20px;\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 700;\n  color: hsla(213, 100%, 12%, 0.94);\n  padding: 15px 20px;\n\n  ", "\n  ", "\n\n  ", "\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n\n  ", "\n"], ["\n  background: #fff;\n  margin-top: 20px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n\n  ", "\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n"], ["\n  display: flex;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  height: 10px;\n  width: 40px;\n  margin-right: 10px;\n\n  ", "\n"], ["\n  height: 10px;\n  width: 40px;\n  margin-right: 10px;\n\n  ", "\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #36507e;\n"], ["\n  font-size: 14px;\n  color: #36507e;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n  gap: 20px;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n  gap: 20px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n  margin-top: 20px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 700;\n  margin-top: 20px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  margin-top: 8px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  margin-top: 8px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  padding: 1px 8px;\n  border-radius: 2px;\n  border: 1px solid rgba(0, 27, 59, 0.15);\n  color: #5c91f5;\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  padding: 1px 8px;\n  border-radius: 2px;\n  border: 1px solid rgba(0, 27, 59, 0.15);\n  color: #5c91f5;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject25 = _taggedTemplateLiteral([""], [""]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 8px;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #6fd1d9;\n  background: rgba(82, 197, 205, 0.5);\n  border-radius: 4px;\n"], ["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #6fd1d9;\n  background: rgba(82, 197, 205, 0.5);\n  border-radius: 4px;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #fd9595;\n  background: rgba(255, 153, 102, 0.5);\n  border-radius: 4px;\n"], ["\n  margin-top: 16px;\n  padding: 20px;\n  border: 1px solid #fd9595;\n  background: rgba(255, 153, 102, 0.5);\n  border-radius: 4px;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #2a4169;\n"], ["\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: #2a4169;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  margin-top: 16px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex-wrap: wrap;\n"], ["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex-wrap: wrap;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  padding: 1px 8px;\n  background: #fff;\n  border: 1.5px solid #2a4169;\n  border-radius: 4px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #2a4169;\n"], ["\n  padding: 1px 8px;\n  background: #fff;\n  border: 1.5px solid #2a4169;\n  border-radius: 4px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 23px;\n  color: #2a4169;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  max-width: 560px;\n  margin-top: 20px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    font-weight: 700;\n  }\n"], ["\n  max-width: 560px;\n  margin-top: 20px;\n  font-family: \"Mukta Vaani\", sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  b {\n    font-weight: 700;\n  }\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  background: rgba(0, 27, 43, 0.02);\n\n  .recharts-legend-item-text {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .recharts-legend-item {\n    display: block !important;\n    margin: 0 !important;\n\n    svg {\n      margin-right: 12px !important;\n\n      line {\n        stroke-width: 2;\n      }\n    }\n  }\n\n  .recharts-polar-angle-axis-tick-value {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    fill: rgba(0, 27, 59, 0.6);\n\n    &:hover, &.recharts-polar-angle-axis-tick-value-selected {\n      font-weight: 700;\n      fill: rgba(0, 27, 59, 0.94);\n      cursor: pointer;\n    }\n  }\n\n  .recharts-polar-angle-axis-ticks {\n    transform: translateY(5px);\n  }\n"], ["\n  background: rgba(0, 27, 43, 0.02);\n\n  .recharts-legend-item-text {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: center;\n    gap: 20px;\n  }\n\n  .recharts-legend-item {\n    display: block !important;\n    margin: 0 !important;\n\n    svg {\n      margin-right: 12px !important;\n\n      line {\n        stroke-width: 2;\n      }\n    }\n  }\n\n  .recharts-polar-angle-axis-tick-value {\n    font-family: \"Mukta Vaani\", sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    fill: rgba(0, 27, 59, 0.6);\n\n    &:hover, &.recharts-polar-angle-axis-tick-value-selected {\n      font-weight: 700;\n      fill: rgba(0, 27, 59, 0.94);\n      cursor: pointer;\n    }\n  }\n\n  .recharts-polar-angle-axis-ticks {\n    transform: translateY(5px);\n  }\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  margin: 24px 50px;\n  width: calc(100% - 100px);\n  font-family: Lato;\n  line-height: 100%;\n"], ["\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);\n  margin: 24px 50px;\n  width: calc(100% - 100px);\n  font-family: Lato;\n  line-height: 100%;\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n  width: 27px;\n"], ["\n  margin-bottom: 24px;\n  width: 27px;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 32px;\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 32px;\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  font-size: 18px;\n"], ["\n  font-size: 18px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _performance = __webpack_require__(1345);
	
	var _performance2 = _interopRequireDefault(_performance);
	
	var _chart = __webpack_require__(1343);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	__webpack_require__(1824);
	
	var _ApiService = __webpack_require__(4);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _get2 = __webpack_require__(133);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _peerEvaluation = __webpack_require__(588);
	
	var _peerEvaluation2 = _interopRequireDefault(_peerEvaluation);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	var _recharts = __webpack_require__(27);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _iconLock = __webpack_require__(333);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// profile components
	var Profile = {};
	
	Profile.Wrapper = _styledComponents2.default.section(_templateObject);
	
	Profile.CardWrapper = _styledComponents2.default.div(_templateObject2);
	
	Profile.Title = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.marginTop && "\n    margin-top: " + p.marginTop + ";\n  ";
	});
	
	// evaluation form components
	var EvaluationForm = {};
	
	EvaluationForm.Wrapper = _styledComponents2.default.div(_templateObject4);
	
	EvaluationForm.Circle = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	EvaluationForm.Title = _styledComponents2.default.div(_templateObject6);
	
	// performance components
	var Performance = {};
	
	Performance.Wrapper = _styledComponents2.default.div(_templateObject7);
	
	Performance.Title = _styledComponents2.default.div(_templateObject8);
	
	Performance.Menu = _styledComponents2.default.div(_templateObject9);
	
	// table components
	
	var Table = {};
	
	Table.Wrapper = _styledComponents2.default.div(_templateObject10);
	
	Table.Row = _styledComponents2.default.div(_templateObject11, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Table.Column = _styledComponents2.default.div(_templateObject12, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	}, function (p) {
	  return p.width && "\n    flex: 0 0 " + p.width + ";\n  ";
	}, function (p) {
	  return p.isValue && "\n    font-weight: 500;\n  ";
	});
	
	// charts components
	var Charts = {};
	
	Charts.Wrapper = _styledComponents2.default.div(_templateObject13, function (p) {
	  return p.setMaxHeight && "\n    max-height: 450px;\n  ";
	});
	
	Charts.Teams = {};
	
	Charts.Teams.Wrapper = _styledComponents2.default.div(_templateObject14);
	
	Charts.Teams.Row = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.margin && "\n    margin: " + p.margin + ";\n  ";
	});
	
	Charts.Teams.TeamColor = _styledComponents2.default.div(_templateObject16, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Charts.Teams.TeamName = _styledComponents2.default.div(_templateObject17);
	
	Charts.Chart = _styledComponents2.default.div(_templateObject18);
	
	var SkillsAssessment = {};
	
	SkillsAssessment.Wrapper = _styledComponents2.default.div(_templateObject19);
	
	SkillsAssessment.InfoTitle = _styledComponents2.default.div(_templateObject20);
	
	SkillsAssessment.InfoBody = _styledComponents2.default.div(_templateObject21);
	
	SkillsAssessment.TagWrapper = _styledComponents2.default.div(_templateObject22);
	
	SkillsAssessment.Tag = _styledComponents2.default.div(_templateObject23);
	
	SkillsAssessment.TagTitle = _styledComponents2.default.div(_templateObject24);
	
	SkillsAssessment.SkillsMap = _styledComponents2.default.div(_templateObject25);
	
	SkillsAssessment.SkillsMapTitle = _styledComponents2.default.div(_templateObject26);
	
	SkillsAssessment.SkillsMapBody = _styledComponents2.default.div(_templateObject27);
	
	SkillsAssessment.MintSection = _styledComponents2.default.div(_templateObject28);
	
	SkillsAssessment.OrangeSection = _styledComponents2.default.div(_templateObject29);
	
	SkillsAssessment.ColorSectionTitle = _styledComponents2.default.div(_templateObject30);
	
	SkillsAssessment.ColorSectionBody = _styledComponents2.default.div(_templateObject31);
	
	SkillsAssessment.ColorSectionTags = _styledComponents2.default.div(_templateObject32);
	
	SkillsAssessment.ColorSectionTag = _styledComponents2.default.div(_templateObject33);
	
	SkillsAssessment.ChartDescription = _styledComponents2.default.div(_templateObject34);
	
	SkillsAssessment.RadarChartWrapper = _styledComponents2.default.div(_templateObject35);
	
	var RoundLockedScreen = {};
	RoundLockedScreen.Wrapper = _styledComponents2.default.div(_templateObject36);
	RoundLockedScreen.Image = _styledComponents2.default.img(_templateObject37);
	RoundLockedScreen.Title = _styledComponents2.default.h2(_templateObject38);
	RoundLockedScreen.Text = _styledComponents2.default.h3(_templateObject39);
	
	var ProfileComponent = function (_React$Component) {
	  _inherits(ProfileComponent, _React$Component);
	
	  function ProfileComponent(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ProfileComponent);
	
	    var _this = _possibleConstructorReturn(this, (ProfileComponent.__proto__ || Object.getPrototypeOf(ProfileComponent)).call(this, props));
	
	    _this.getSkillsAssessmentDefinitions = function (survey) {
	      var definitions = [];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = survey.questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var question = _step.value;
	
	          definitions = definitions.concat(question.statements);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return definitions.map(function (d) {
	        return d.student_category || null;
	      }).filter(function (d) {
	        return !!d;
	      }).reduce(function (obj, item) {
	        return Object.assign({}, obj, _defineProperty({}, item.name, item.definition));
	      }, {});
	    };
	
	    _this.isSurveyFinished = function (survey) {
	      var surveyEndDate = (0, _moment2.default)(survey.end);
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isAfter(surveyEndDate);
	    };
	
	    _this.loadReport = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref, receiver_id) {
	        var survey_id = _ref.id,
	            stage = _ref.stage;
	
	        var _ref3, report, reports;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(survey_id && Number(survey_id) > 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                _context.prev = 1;
	                _context.next = 4;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/score/" + receiver_id + "/" + survey_id + "/");
	
	              case 4:
	                _ref3 = _context.sent;
	                report = _ref3.body;
	                reports = _this.state.reports;
	
	
	                _this.setState({
	                  reports: Object.assign({}, reports, _defineProperty({}, stage, report))
	                });
	                _context.next = 12;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context["catch"](1);
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[1, 10]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.handleShowTab = function (id) {
	      var performance = _this.state.performance.map(function (tab) {
	        return tab.id === id ? Object.assign({}, tab, { isActive: true }) : Object.assign({}, tab, { isActive: false });
	      });
	
	      _this.setState({
	        performance: performance
	      });
	    };
	
	    _this.getGradingValue = function (number, is_finished) {
	      var grading = _this.state.grading;
	
	
	      if (is_finished === true && number in grading) {
	        return (grading[number] * 100).toFixed(2) + "%";
	      }
	
	      return "-----";
	    };
	
	    _this.skillsAssessmentDescription = function (showSkillsAssessmentData) {
	      return showSkillsAssessmentData === true ? 'view results' : '---';
	    };
	
	    _this.skillsAssessmentStrengthsCategories = function (key) {
	      var skillsAssessmentRating = _this.state.skillsAssessmentRating;
	
	
	      if (key === '') {
	        return [];
	      }
	
	      if (key === 'initial') {
	        return skillsAssessmentRating.length > 0 ? Object.entries(skillsAssessmentRating[0]).filter(function (i) {
	          return i[1] >= 0.7;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      if (key === 'second') {
	        return skillsAssessmentRating.length > 1 ? Object.entries(skillsAssessmentRating[1]).filter(function (i) {
	          return i[1] >= 0.7;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      return skillsAssessmentRating.length > 2 ? Object.entries(skillsAssessmentRating[2]).filter(function (i) {
	        return i[1] >= 0.7;
	      }).map(function (i) {
	        return i[0];
	      }) : [];
	    };
	
	    _this.skillsAssessmentAreasOfDevelopmentCategories = function (key) {
	      var skillsAssessmentRating = _this.state.skillsAssessmentRating;
	
	
	      if (key === '') {
	        return [];
	      }
	
	      if (key === 'initial') {
	        return skillsAssessmentRating.length > 0 ? Object.entries(skillsAssessmentRating[0]).filter(function (i) {
	          return i[1] <= 0.3;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      if (key === 'second') {
	        return skillsAssessmentRating.length > 1 ? Object.entries(skillsAssessmentRating[1]).filter(function (i) {
	          return i[1] <= 0.3;
	        }).map(function (i) {
	          return i[0];
	        }) : [];
	      }
	
	      return skillsAssessmentRating.length > 2 ? Object.entries(skillsAssessmentRating[2]).filter(function (i) {
	        return i[1] <= 0.3;
	      }).map(function (i) {
	        return i[0];
	      }) : [];
	    };
	
	    _this.sortSurveys = function (surveys) {
	      var endedSurveys = [];
	      var openedSurveys = [];
	
	      surveys.forEach(function (survey) {
	        if (_this.isSurveyEnded(survey)) {
	          endedSurveys = [survey].concat(_toConsumableArray(endedSurveys));
	        } else {
	          openedSurveys = [].concat(_toConsumableArray(openedSurveys), [survey]);
	        }
	      });
	
	      return [].concat(_toConsumableArray(openedSurveys), _toConsumableArray(endedSurveys));
	    };
	
	    _this.isSurveyEnded = function (survey) {
	      var endDate = (0, _moment2.default)(survey.end);
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isSameOrAfter(endDate);
	    };
	
	    _this.getCurrentUserId = function () {
	      return _Auth2.default.getUserId();
	    };
	
	    _this.skillsAssessmentChartData = function (showSkillsAssessmentData) {
	      var skillsAssessmentRating = _this.state.skillsAssessmentRating;
	
	      var result = [];
	      var hasSecond = false;
	      var hasFinal = false;
	      var defaultData = {
	        Organized: 0.7,
	        Communicative: 0.75,
	        Creative: 0.57,
	        Inquisitive: 0.3,
	        Accountable: 0.48,
	        Analytical: 0.38,
	        Decisive: 0.63,
	        Supportive: 0.9
	      };
	
	      if (skillsAssessmentRating && skillsAssessmentRating.length > 0) {
	        var categories = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = skillsAssessmentRating[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var data = _step2.value;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = Object.keys(data).filter(function (c) {
	                return c.toLowerCase() !== 'not applicable';
	              })[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var category = _step3.value;
	
	                if (!categories.includes(category)) {
	                  categories.push(category);
	                  var value = {
	                    category: category,
	                    initial: showSkillsAssessmentData ? (0, _get3.default)(skillsAssessmentRating, "0." + category, 0) : (0, _get3.default)(defaultData, category, 0),
	                    second: (0, _get3.default)(skillsAssessmentRating, "1." + category, 0),
	                    final: (0, _get3.default)(skillsAssessmentRating, "2." + category, 0)
	                  };
	                  result.push(value);
	
	                  if (value.second > 0) {
	                    hasSecond = true;
	                  }
	
	                  if (value.final > 0) {
	                    hasFinal = true;
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	
	      return {
	        hasSecond: hasSecond,
	        hasFinal: hasFinal,
	        data: result
	      };
	    };
	
	    _this.customRadiusTick = function (showSkillsAssessmentData) {
	      return function (_ref4) {
	        var radius = _ref4.radius,
	            stroke = _ref4.stroke,
	            x = _ref4.x,
	            y = _ref4.y,
	            textAnchor = _ref4.textAnchor,
	            payload = _ref4.payload;
	        var skillsAssessmentTooltip = _this.state.skillsAssessmentTooltip;
	
	        var radiusOffset = 10;
	        var radiusCorrection = 90;
	        var xCalculated = radiusOffset * Math.sin(Math.PI * 2 * (payload.coordinate - radiusCorrection) / 360);
	        var yCalculated = radiusOffset * Math.cos(Math.PI * 2 * (payload.coordinate - radiusCorrection) / 360);
	        var rectCorrection = Math.abs(payload.coordinate - 90);
	        var rectOffsetX = 32;
	        var rectOffsetY = 10;
	        if (rectCorrection > 0 && rectCorrection < 180) {
	          rectOffsetX = 0;
	        }
	
	        if (rectCorrection > 180) {
	          rectOffsetX = 64;
	        }
	
	        return _react2.default.createElement(
	          "g",
	          { className: "recharts-layer recharts-polar-angle-axis-tick" },
	          !showSkillsAssessmentData && _react2.default.createElement("rect", {
	            x: x - xCalculated - rectOffsetX,
	            y: y - yCalculated - rectOffsetY,
	            rx: "5",
	            ry: "5",
	            width: "64",
	            height: "9",
	            style: { fill: '#c4c4c4' } }),
	          showSkillsAssessmentData && _react2.default.createElement(
	            "text",
	            {
	              radius: radius,
	              stroke: stroke,
	              x: x - xCalculated,
	              y: y - yCalculated,
	              className: (0, _classnames2.default)("recharts-text recharts-polar-angle-axis-tick-value", {
	                'recharts-polar-angle-axis-tick-value-selected': skillsAssessmentTooltip && payload.value === skillsAssessmentTooltip.category
	              }),
	              textAnchor: textAnchor
	            },
	            _react2.default.createElement(
	              "tspan",
	              { x: x - xCalculated, dy: "0em" },
	              payload.value
	            )
	          )
	        );
	      };
	    };
	
	    _this.customTickClick = function (showSkillsAssessmentData) {
	      return function (data) {
	        var _this$state = _this.state,
	            skillsAssessmentDefinitions = _this$state.skillsAssessmentDefinitions,
	            skillsAssessmentTooltip = _this$state.skillsAssessmentTooltip;
	
	
	        if (showSkillsAssessmentData === true && data && data.value && skillsAssessmentDefinitions[data.value]) {
	          if (skillsAssessmentTooltip && skillsAssessmentTooltip.category === data.value) {
	            _this.setState({
	              skillsAssessmentTooltip: null
	            });
	          } else {
	            _this.setState({
	              skillsAssessmentTooltip: {
	                category: data.value,
	                text: skillsAssessmentDefinitions[data.value]
	              }
	            });
	          }
	        }
	      };
	    };
	
	    _this.showRoundScoreAlert = function () {
	      _this.setState({
	        isRoundScoreAlertVisible: true
	      });
	    };
	
	    _this.hideRoundScoreAlert = function () {
	      _this.setState({
	        isRoundScoreAlertVisible: false
	      });
	    };
	
	    _this.showTeamScoreAlert = function () {
	      _this.setState({
	        isTeamScoreAlertVisible: true
	      });
	    };
	
	    _this.hideTeamScoreAlert = function () {
	      _this.setState({
	        isTeamScoreAlertVisible: false
	      });
	    };
	
	    _this.showPeerRatingScoreAlert = function () {
	      _this.setState({
	        isPeerRatingScoreAlertVisible: true
	      });
	    };
	
	    _this.hidePeerRatingScoreAlert = function () {
	      _this.setState({
	        isPeerRatingScoreAlertVisible: false
	      });
	    };
	
	    _this.showEngagementScoreAlert = function () {
	      _this.setState({
	        isEngagementScoreAlertVisible: true
	      });
	    };
	
	    _this.hideEngagementScoreAlert = function () {
	      _this.setState({
	        isEngagementScoreAlertVisible: false
	      });
	    };
	
	    _this.showPeerCompletionScoreAlert = function () {
	      _this.setState({
	        isPeerCompletionScoreAlertVisible: true
	      });
	    };
	
	    _this.hidePeerCompletionScoreAlert = function () {
	      _this.setState({
	        isPeerCompletionScoreAlertVisible: false
	      });
	    };
	
	    _this.showIndividualScoreAlert = function () {
	      _this.setState({
	        isIndividualScoreAlertVisible: true
	      });
	    };
	
	    _this.hideIndividualScoreAlert = function () {
	      _this.setState({
	        isIndividualScoreAlertVisible: false
	      });
	    };
	
	    _this.showFinalScoreAlert = function () {
	      _this.setState({
	        isFinalScoreAlertVisible: true
	      });
	    };
	
	    _this.hideFinalScoreAlert = function () {
	      _this.setState({
	        isFinalScoreAlertVisible: false
	      });
	    };
	
	    var isScoringBreakdown = props.location.pathname === '/scoring-breakdown';
	
	    _this.state = {
	      performance: [{ id: 1, name: "Scoring", isActive: true }].concat(_toConsumableArray(isScoringBreakdown === true ? [] : [{ id: 2, name: "Peer Rating", isActive: false }])),
	      surveys: [],
	      reports: {},
	      grading: {},
	      teamGrade: 0,
	      currentScore: {},
	      userGrade: {},
	      skillsAssessmentCalculated: false,
	      skillsAssessmentRating: [],
	      skillsAssessmentTooltip: null,
	      skillsAssessmentDefinitions: {},
	      peerScoreValue: null,
	      isScoringBreakdown: isScoringBreakdown,
	      gamesGradingWeights: {},
	      loaded: false,
	      isRoundScoreAlertVisible: false,
	      isTeamScoreAlertVisible: false,
	      isPeerRatingScoreAlertVisible: false,
	      isPeerCompletionScoreAlertVisible: false,
	      isEngagementScoreAlertVisible: false,
	      isIndividualScoreAlertVisible: false,
	      isFinalScoreAlertVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(ProfileComponent, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var isScoringBreakdown = prevProps.location.pathname === '/scoring-breakdown';
	      if (isScoringBreakdown !== this.state.isScoringBreakdown) {
	        window.location.reload();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var surveysRaw, isScoringBreakdown, surveys, finishedSurveys, lastSurveyId, skillsAssessmentCalculated, skillsAssessmentRating, performance, skillsAssessmentDefinitions, initialSurvey, initialSurveyExists, skillsQuestions, _ref6, body, secondSurvey, _skillsQuestions, _ref7, _body, finalSurvey, _skillsQuestions2, _ref8, _body2, _ref9, currentScore, errorDetail, rounds, maxRoundNumber, latestCompletedRound, latestCompletedRoundObj, latestCompletedRoundId, _ref10, userGrade, _errorDetail, _ref11, gradingData, grading, teamGrade, completedRound, showSkillsAssessmentTab, gamesGradingWeightsRaw, gamesGradingWeights;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/surveys/?course=" + _Auth2.default.getCourseId());
	
	              case 2:
	                surveysRaw = _context2.sent;
	                isScoringBreakdown = this.state.isScoringBreakdown;
	                surveys = surveysRaw.body.results;
	                finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	                  return _this3.isSurveyFinished(i);
	                }) : [];
	                lastSurveyId = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1].id : 0;
	
	                if (!(surveys.length > 0)) {
	                  _context2.next = 63;
	                  break;
	                }
	
	                skillsAssessmentCalculated = false;
	                skillsAssessmentRating = [];
	                performance = [].concat(_toConsumableArray(this.state.performance));
	                skillsAssessmentDefinitions = {};
	                initialSurvey = surveys.find(function (i) {
	                  return i.stage === 'initial';
	                });
	                initialSurveyExists = false;
	
	                if (!(initialSurvey && initialSurvey.questions)) {
	                  _context2.next = 30;
	                  break;
	                }
	
	                skillsQuestions = initialSurvey.questions.filter(function (i) {
	                  return ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform';
	                });
	
	                if (!(skillsQuestions.length > 0)) {
	                  _context2.next = 30;
	                  break;
	                }
	
	                initialSurveyExists = true;
	                skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(initialSurvey);
	
	                _context2.prev = 19;
	                _context2.next = 22;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/skills-assessment/" + initialSurvey.id + "/student/" + _Auth2.default.getUserId() + "/");
	
	              case 22:
	                _ref6 = _context2.sent;
	                body = _ref6.body;
	
	                if (body) {
	                  skillsAssessmentRating.push(body);
	                  skillsAssessmentCalculated = Object.values(body).some(function (i) {
	                    return i > 0;
	                  });
	                }
	                _context2.next = 30;
	                break;
	
	              case 27:
	                _context2.prev = 27;
	                _context2.t0 = _context2["catch"](19);
	
	                initialSurveyExists = false;
	
	              case 30:
	                if (!initialSurveyExists) {
	                  _context2.next = 61;
	                  break;
	                }
	
	                secondSurvey = surveys.find(function (i) {
	                  return i.stage === 'second';
	                });
	
	                if (!(secondSurvey && secondSurvey.questions)) {
	                  _context2.next = 46;
	                  break;
	                }
	
	                _skillsQuestions = secondSurvey.questions.filter(function (i) {
	                  return ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform';
	                });
	
	                if (!(_skillsQuestions.length > 0)) {
	                  _context2.next = 46;
	                  break;
	                }
	
	                skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(secondSurvey);
	
	                _context2.prev = 36;
	                _context2.next = 39;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/skills-assessment/" + secondSurvey.id + "/student/" + _Auth2.default.getUserId() + "/");
	
	              case 39:
	                _ref7 = _context2.sent;
	                _body = _ref7.body;
	
	                if (_body && Object.values(_body).some(function (i) {
	                  return i > 0;
	                })) {
	                  skillsAssessmentRating.push(_body);
	                  if (!skillsAssessmentCalculated) {
	                    skillsAssessmentCalculated = Object.values(_body).some(function (i) {
	                      return i > 0;
	                    });
	                  }
	                }
	                _context2.next = 46;
	                break;
	
	              case 44:
	                _context2.prev = 44;
	                _context2.t1 = _context2["catch"](36);
	
	              case 46:
	                finalSurvey = surveys.find(function (i) {
	                  return i.stage === 'final';
	                });
	
	                if (!(finalSurvey && finalSurvey.questions)) {
	                  _context2.next = 61;
	                  break;
	                }
	
	                _skillsQuestions2 = finalSurvey.questions.filter(function (i) {
	                  return ['other', 'skills'].includes(i.category) && i.answer_type === 'freeform';
	                });
	
	                if (!(_skillsQuestions2.length > 0)) {
	                  _context2.next = 61;
	                  break;
	                }
	
	                skillsAssessmentDefinitions = this.getSkillsAssessmentDefinitions(finalSurvey);
	
	                _context2.prev = 51;
	                _context2.next = 54;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/skills-assessment/" + finalSurvey.id + "/student/" + _Auth2.default.getUserId() + "/");
	
	              case 54:
	                _ref8 = _context2.sent;
	                _body2 = _ref8.body;
	
	                if (_body2 && Object.values(_body2).some(function (i) {
	                  return i > 0;
	                })) {
	                  skillsAssessmentRating.push(_body2);
	                  if (!skillsAssessmentCalculated) {
	                    skillsAssessmentCalculated = Object.values(_body2).some(function (i) {
	                      return i > 0;
	                    });
	                  }
	                }
	                _context2.next = 61;
	                break;
	
	              case 59:
	                _context2.prev = 59;
	                _context2.t2 = _context2["catch"](51);
	
	              case 61:
	
	                if (!isScoringBreakdown && initialSurveyExists) {
	                  performance.push({ id: 3, name: 'Skills Assessment', isActive: false });
	                }
	
	                this.setState({
	                  performance: performance,
	                  skillsAssessmentCalculated: skillsAssessmentCalculated,
	                  skillsAssessmentRating: skillsAssessmentRating,
	                  skillsAssessmentDefinitions: skillsAssessmentDefinitions
	                });
	
	              case 63:
	                if (!(lastSurveyId > 0)) {
	                  _context2.next = 76;
	                  break;
	                }
	
	                _context2.prev = 64;
	                _context2.next = 67;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/score/" + _Auth2.default.getUserId() + "/" + lastSurveyId + "/");
	
	              case 67:
	                _ref9 = _context2.sent;
	                currentScore = _ref9.body;
	
	
	                this.setState({
	                  currentScore: currentScore
	                });
	                _context2.next = 76;
	                break;
	
	              case 72:
	                _context2.prev = 72;
	                _context2.t3 = _context2["catch"](64);
	                errorDetail = (0, _get3.default)(_context2.t3, 'response.body.detail', null);
	
	                if (errorDetail === 'Not found.') {
	                  this.setState({
	                    currentScore: {}
	                  });
	                }
	
	              case 76:
	                rounds = this.props.rounds;
	                maxRoundNumber = Math.max.apply(null, rounds.map(function (round) {
	                  return round.number;
	                }));
	                latestCompletedRound = Math.max.apply(null, rounds.filter(function (round) {
	                  return round.is_finished;
	                }).map(function (round) {
	                  return round.number;
	                }));
	                latestCompletedRoundObj = rounds.find(function (i) {
	                  return i.number === latestCompletedRound;
	                });
	                latestCompletedRoundId = 0;
	
	                if (latestCompletedRoundObj) {
	                  latestCompletedRoundId = latestCompletedRoundObj.id;
	                }
	
	                if (!(lastSurveyId > 0 && latestCompletedRoundId > 0)) {
	                  _context2.next = 97;
	                  break;
	                }
	
	                _context2.prev = 83;
	                _context2.next = 86;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/" + latestCompletedRoundId + "/" + _Auth2.default.getUserId() + "/");
	
	              case 86:
	                _ref10 = _context2.sent;
	                userGrade = _ref10.body;
	
	
	                this.setState({
	                  userGrade: userGrade
	                });
	                _context2.next = 95;
	                break;
	
	              case 91:
	                _context2.prev = 91;
	                _context2.t4 = _context2["catch"](83);
	                _errorDetail = (0, _get3.default)(_context2.t4, 'response.body.detail', null);
	
	                if (_errorDetail === 'Not found.') {
	                  this.setState({
	                    userGrade: {}
	                  });
	                }
	
	              case 95:
	                _context2.next = 97;
	                return this.getPeerScoreValue(latestCompletedRoundId, lastSurveyId);
	
	              case 97:
	                _context2.next = 99;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/grading/?round_lte=" + maxRoundNumber);
	
	              case 99:
	                _ref11 = _context2.sent;
	                gradingData = _ref11.body;
	                grading = {};
	
	                gradingData.forEach(function (data) {
	                  grading[data.round_number] = data.current_weighted_value;
	                });
	                teamGrade = 0;
	                completedRound = gradingData.find(function (i) {
	                  return i.round_number === latestCompletedRound;
	                });
	
	                if (completedRound) {
	                  teamGrade = completedRound.weighted_value;
	                }
	
	                showSkillsAssessmentTab = surveys.some(function (survey) {
	                  return survey.questions.some(function (question) {
	                    return question.category === "skills_assessment";
	                  });
	                });
	                _context2.next = 109;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/gradingweights/");
	
	              case 109:
	                gamesGradingWeightsRaw = _context2.sent;
	                gamesGradingWeights = gamesGradingWeightsRaw.body.results[0];
	
	
	                this.setState(function (prevState) {
	                  return {
	                    surveys: surveys,
	                    grading: grading,
	                    teamGrade: teamGrade,
	                    performance: showSkillsAssessmentTab ? [].concat(_toConsumableArray(prevState.performance), [{ id: 3, name: "Skills Assessment", isActive: false }]) : prevState.performance,
	                    gamesGradingWeights: gamesGradingWeights,
	                    loaded: true
	                  };
	                }, function () {
	                  surveys.forEach(function (survey) {
	                    if (_this3.isSurveyFinished(survey)) {
	                      _this3.loadReport(survey, _Auth2.default.getUserId());
	                    }
	                  });
	                });
	
	              case 112:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[19, 27], [36, 44], [51, 59], [64, 72], [83, 91]]);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "getPeerScoreValue",
	    value: function () {
	      var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(roundId, surveyId) {
	        var userId, res, peer_adjustment_grade;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                userId = Number(this.getCurrentUserId());
	                _context3.prev = 1;
	                _context3.next = 4;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/" + roundId + "/" + userId + "/");
	
	              case 4:
	                res = _context3.sent;
	                peer_adjustment_grade = res.body.peer_adjustment_grade;
	
	
	                this.setState({
	                  peerScoreValue: Number(peer_adjustment_grade)
	                });
	                _context3.next = 13;
	                break;
	
	              case 9:
	                _context3.prev = 9;
	                _context3.t0 = _context3["catch"](1);
	
	                this.setState({
	                  peerScoreValue: null
	                });
	                console.log('Cannot get peer score data', _context3.t0);
	
	              case 13:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[1, 9]]);
	      }));
	
	      function getPeerScoreValue(_x3, _x4) {
	        return _ref12.apply(this, arguments);
	      }
	
	      return getPeerScoreValue;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          performance = _state.performance,
	          surveys = _state.surveys,
	          reports = _state.reports,
	          teamGrade = _state.teamGrade,
	          skillsAssessmentCalculated = _state.skillsAssessmentCalculated,
	          skillsAssessmentTooltip = _state.skillsAssessmentTooltip,
	          isScoringBreakdown = _state.isScoringBreakdown,
	          gamesGradingWeights = _state.gamesGradingWeights,
	          loaded = _state.loaded,
	          isRoundScoreAlertVisible = _state.isRoundScoreAlertVisible,
	          isTeamScoreAlertVisible = _state.isTeamScoreAlertVisible,
	          isPeerRatingScoreAlertVisible = _state.isPeerRatingScoreAlertVisible,
	          isPeerCompletionScoreAlertVisible = _state.isPeerCompletionScoreAlertVisible,
	          isEngagementScoreAlertVisible = _state.isEngagementScoreAlertVisible,
	          isIndividualScoreAlertVisible = _state.isIndividualScoreAlertVisible,
	          isFinalScoreAlertVisible = _state.isFinalScoreAlertVisible;
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	
	      var currentRound = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	
	      var isGradingActive = _lodash2.default.get(_lodash2.default.find(performance, {
	        name: "Scoring"
	      }), "isActive", false);
	      var isPeerRatingScoreActive = _lodash2.default.get(_lodash2.default.find(performance, {
	        name: "Peer Rating"
	      }), "isActive", false);
	
	      var isSkillsAssessmentActive = _lodash2.default.get(_lodash2.default.find(performance, {
	        name: "Skills Assessment"
	      }), "isActive", false);
	
	      var sortedSurveys = this.sortSurveys(surveys);
	      var latestCompletedFormValue = this.latestCompletedFormValue;
	      var latestCompletedFormKey = this.latestCompletedFormKey;
	      var showSkillsAssessmentData = skillsAssessmentCalculated === true && ['initial', 'second', 'final'].includes(latestCompletedFormKey);
	      var showSkillsAssessmentDataSecond = skillsAssessmentCalculated === true && ['second', 'final'].includes(latestCompletedFormKey);
	      var showSkillsAssessmentDataFinal = skillsAssessmentCalculated === true && latestCompletedFormKey === 'final';
	      var skillsAssessmentStrengthsCategories = this.skillsAssessmentStrengthsCategories(latestCompletedFormKey);
	      var skillsAssessmentAreasOfDevelopmentCategories = this.skillsAssessmentAreasOfDevelopmentCategories(latestCompletedFormKey);
	      var skillsAssessmentChartData = this.skillsAssessmentChartData(showSkillsAssessmentData);
	
	      return loaded ? currentRound.results_viewable === false && _Auth2.default.getPosition() === "Student" ? _react2.default.createElement(
	        RoundLockedScreen.Wrapper,
	        null,
	        _react2.default.createElement(RoundLockedScreen.Image, { alt: "Round results locked", src: _iconLock2.default }),
	        _react2.default.createElement(
	          RoundLockedScreen.Title,
	          null,
	          "Round Results Locked"
	        ),
	        _react2.default.createElement(
	          RoundLockedScreen.Text,
	          null,
	          "The instructor has locked the results for this round. Check back when they reopen it."
	        )
	      ) : _react2.default.createElement(
	        Profile.Wrapper,
	        { className: "instructorPage instructorDashboard" },
	        !isScoringBreakdown && _react2.default.createElement(
	          Profile.CardWrapper,
	          null,
	          sortedSurveys.map(function (survey) {
	            return _react2.default.createElement(_peerEvaluation2.default, { key: survey.id, survey: survey });
	          })
	        ),
	        isRoundScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Team Round Score",
	          message: "Your Round Score is based on how well you meet the targets for the 4 metrics in the round. Hit targets and score 100%. Hit 90% of each target and score 90%.",
	          buttonText: "Done",
	          onHide: this.hideRoundScoreAlert
	        }),
	        isTeamScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Team Score",
	          message: "Team Score is the weighted average Round Score across all rounds. Note: Your instructor sets the weights and could weigh each round differently.",
	          buttonText: "Done",
	          onHide: this.hideTeamScoreAlert
	        }),
	        isPeerRatingScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Individual Peer Rating Score",
	          message: "Peer Rating Score is your average peer rating compared to the team\u2019s overall average. (e.g. your average peer rating/ team\u2019s average peer rating).",
	          buttonText: "Done",
	          onHide: this.hidePeerRatingScoreAlert
	        }),
	        isPeerCompletionScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Peer Completion Score",
	          message: "Peer Completion Score is the score you received from completing the peer evaluation.",
	          buttonText: "Done",
	          onHide: this.hidePeerCompletionScoreAlert
	        }),
	        isEngagementScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Engagement Score",
	          message: "Your Engagement Score reflects how actively you engaged with the Research pages. Viewing all Research pages earns a score of 100. This is an optional score that your instructor may choose to apply.",
	          buttonText: "Done",
	          onHide: this.hideEngagementScoreAlert
	        }),
	        isIndividualScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Individual Score",
	          message: "Your Individual Score is the weighted average of your Team Score and Peer Rating score (e.g. Team Score (weight) + Peer Rating Score (weight)). Note: Your instructor sets the weights and could place more weight on Team Score over Peer Rating Score and vice versa.",
	          buttonText: "Done",
	          onHide: this.hideIndividualScoreAlert
	        }),
	        isFinalScoreAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: "Final Individual Score",
	          message: "Your Final Score is typically the same as your Individual Score.",
	          buttonText: "Done",
	          onHide: this.hideFinalScoreAlert
	        }),
	        _react2.default.createElement(
	          Performance.Wrapper,
	          null,
	          _react2.default.createElement(
	            Performance.Title,
	            null,
	            isScoringBreakdown ? 'Scoring Breakdown' : 'Performance Summary'
	          ),
	          _react2.default.createElement(
	            Performance.Menu,
	            null,
	            performance.map(function (item, index) {
	              return _react2.default.createElement(_performance2.default, Object.assign({
	                key: index,
	                handleShowTab: _this4.handleShowTab,
	                value: item.name === "Skills Assessment" ? _this4.skillsAssessmentDescription(showSkillsAssessmentData) : item.name === "Peer Rating" ? latestCompletedFormValue : _this4.gradingValue
	              }, item));
	            })
	          ),
	          isGradingActive && _react2.default.createElement(
	            Table.Wrapper,
	            null,
	            _react2.default.createElement(
	              Table.Row,
	              null,
	              _react2.default.createElement(Table.Column, null),
	              rounds.map(function (_ref13) {
	                var id = _ref13.id,
	                    number = _ref13.number;
	                return _react2.default.createElement(
	                  Table.Column,
	                  { key: id, align: "center" },
	                  "Round ",
	                  number || ""
	                );
	              }),
	              _react2.default.createElement(Table.Column, null)
	            ),
	            _react2.default.createElement(
	              Table.Row,
	              null,
	              _react2.default.createElement(
	                Table.Column,
	                null,
	                "Deadlines"
	              ),
	              rounds.map(function (_ref14) {
	                var id = _ref14.id,
	                    end_date = _ref14.end_date;
	                return _react2.default.createElement(
	                  Table.Column,
	                  { key: id, align: "center", isValue: true },
	                  (0, _moment2.default)(end_date).format("MM/DD/YYYY") || "n/a"
	                );
	              }),
	              _react2.default.createElement(Table.Column, null)
	            ),
	            _react2.default.createElement(
	              Table.Row,
	              { background: _Teams2.default.currentTeamColorLevel1() },
	              _react2.default.createElement(
	                Table.Column,
	                null,
	                "Round Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showRoundScoreAlert
	                })
	              ),
	              rounds.map(function (_ref15) {
	                var id = _ref15.id,
	                    number = _ref15.number,
	                    is_finished = _ref15.is_finished;
	                return _react2.default.createElement(
	                  Table.Column,
	                  { key: id, align: "center", isValue: true },
	                  _this4.getGradingValue(number, is_finished)
	                );
	              }),
	              _react2.default.createElement(Table.Column, null)
	            ),
	            _react2.default.createElement(
	              Table.Row,
	              null,
	              _react2.default.createElement(
	                Table.Column,
	                { width: "70%" },
	                "Team Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showTeamScoreAlert
	                })
	              ),
	              _react2.default.createElement(
	                Table.Column,
	                { align: "right", isValue: true },
	                (teamGrade * 100).toFixed(2),
	                "%"
	              )
	            ),
	            _react2.default.createElement(
	              Table.Row,
	              { background: _Teams2.default.currentTeamColorLevel1() },
	              _react2.default.createElement(
	                Table.Column,
	                { width: "70%" },
	                "Peer Rating Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showPeerRatingScoreAlert
	                })
	              ),
	              _react2.default.createElement(
	                Table.Column,
	                { align: "right", isValue: true },
	                this.peerScoreValue
	              )
	            ),
	            gamesGradingWeights.peer_completion_score && Number(gamesGradingWeights.peer_completion_score) !== 0 && _react2.default.createElement(
	              Table.Row,
	              { background: _Teams2.default.currentTeamColorLevel1() },
	              _react2.default.createElement(
	                Table.Column,
	                { width: "70%" },
	                "Peer Completion Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showPeerCompletionScoreAlert
	                })
	              ),
	              _react2.default.createElement(
	                Table.Column,
	                { align: "right", isValue: true },
	                "-----"
	              )
	            ),
	            Number(gamesGradingWeights.engagement_score) !== 0 && _react2.default.createElement(
	              Table.Row,
	              { background: _Teams2.default.currentTeamColorLevel1() },
	              _react2.default.createElement(
	                Table.Column,
	                { width: "70%" },
	                "Engagement Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showEngagementScoreAlert
	                })
	              ),
	              _react2.default.createElement(
	                Table.Column,
	                { align: "right", isValue: true },
	                "-----"
	              )
	            ),
	            _react2.default.createElement(
	              Table.Row,
	              null,
	              _react2.default.createElement(
	                Table.Column,
	                { width: "70%" },
	                "Individual Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showIndividualScoreAlert
	                })
	              ),
	              _react2.default.createElement(
	                Table.Column,
	                { align: "right", isValue: true },
	                this.individualGrade
	              )
	            ),
	            _react2.default.createElement(
	              Table.Row,
	              { background: _Teams2.default.currentTeamColorLevel1() },
	              _react2.default.createElement(
	                Table.Column,
	                { width: "70%" },
	                "Final Score",
	                _react2.default.createElement("img", {
	                  alt: "Info Icon",
	                  width: "16px",
	                  height: "16px",
	                  src: _iconTableHelp2.default,
	                  onClick: this.showFinalScoreAlert
	                })
	              ),
	              _react2.default.createElement(
	                Table.Column,
	                { align: "right", isValue: true },
	                this.finalGrade
	              )
	            )
	          ),
	          isPeerRatingScoreActive && _react2.default.createElement(
	            Charts.Wrapper,
	            {
	              setMaxHeight: Object.keys(reports).length === 1 ? true : false
	            },
	            _react2.default.createElement(
	              Charts.Teams.Wrapper,
	              null,
	              _react2.default.createElement(
	                Charts.Teams.Row,
	                null,
	                _react2.default.createElement(Charts.Teams.TeamColor, {
	                  background: _Teams2.default.currentTeamColor()
	                }),
	                _react2.default.createElement(
	                  Charts.Teams.TeamName,
	                  null,
	                  "You"
	                )
	              ),
	              _react2.default.createElement(
	                Charts.Teams.Row,
	                { margin: "0 20px" },
	                _react2.default.createElement(Charts.Teams.TeamColor, { background: "#eee" }),
	                _react2.default.createElement(
	                  Charts.Teams.TeamName,
	                  null,
	                  "Team Average"
	                )
	              ),
	              _react2.default.createElement(
	                Charts.Teams.Row,
	                { margin: "0 20px" },
	                _react2.default.createElement(Charts.Teams.TeamColor, { background: "#c4c4c4" }),
	                _react2.default.createElement(
	                  Charts.Teams.TeamName,
	                  null,
	                  "Team Median"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Charts.Chart,
	              null,
	              _react2.default.createElement(_chart2.default, {
	                reports: reports,
	                surveys: surveys,
	                isSurveyFinished: this.isSurveyFinished,
	                title: "Collaboration"
	              })
	            )
	          ),
	          isSkillsAssessmentActive && _react2.default.createElement(
	            SkillsAssessment.Wrapper,
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                SkillsAssessment.RadarChartWrapper,
	                null,
	                _react2.default.createElement(
	                  _recharts.RadarChart,
	                  { width: 560, height: 480, cx: "50%", cy: "50%", outerRadius: "65%", data: skillsAssessmentChartData.data },
	                  showSkillsAssessmentData && _react2.default.createElement(_recharts.Legend, { iconType: "plainline", iconSize: 40 }),
	                  _react2.default.createElement(_recharts.PolarGrid, null),
	                  _react2.default.createElement(_recharts.PolarAngleAxis, { dataKey: "category", tick: this.customRadiusTick(showSkillsAssessmentData), onClick: this.customTickClick(showSkillsAssessmentData) }),
	                  _react2.default.createElement(_recharts.PolarRadiusAxis, { domain: [0, 1], axisLine: false, tick: false, tickCount: 6 }),
	                  _react2.default.createElement(_recharts.Radar, {
	                    name: skillsAssessmentChartData.hasFinal && showSkillsAssessmentDataFinal ? 'Skills (Initial)' : 'Skills Demonstrated (Initial)',
	                    dataKey: "initial",
	                    stroke: showSkillsAssessmentData ? '#f9c151' : 'rgba(0, 31, 62, 0.2)',
	                    strokeWidth: "2px",
	                    fill: showSkillsAssessmentData ? '#fec665' : '#001f3e',
	                    fillOpacity: showSkillsAssessmentData ? 0.25 : 0.13
	                  }),
	                  skillsAssessmentChartData.hasSecond && showSkillsAssessmentDataSecond && _react2.default.createElement(_recharts.Radar, {
	                    name: skillsAssessmentChartData.hasFinal && showSkillsAssessmentDataFinal ? 'Skills (Previous)' : 'Skills Demonstrated (As of now)',
	                    dataKey: "second",
	                    stroke: "#55b4bc",
	                    strokeWidth: "2px",
	                    fill: "#52c5cd",
	                    fillOpacity: 0.5
	                  }),
	                  skillsAssessmentChartData.hasFinal && showSkillsAssessmentDataFinal && _react2.default.createElement(_recharts.Radar, {
	                    name: "Skills (As of now)",
	                    dataKey: "final",
	                    stroke: "#a98df6",
	                    strokeWidth: "2px",
	                    fill: "#a98df6",
	                    fillOpacity: 0.5
	                  })
	                )
	              ),
	              !!skillsAssessmentTooltip && _react2.default.createElement(
	                SkillsAssessment.ChartDescription,
	                null,
	                skillsAssessmentTooltip.text
	              )
	            ),
	            showSkillsAssessmentData === false && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                SkillsAssessment.TagWrapper,
	                null,
	                _react2.default.createElement(
	                  SkillsAssessment.Tag,
	                  null,
	                  "Locked"
	                ),
	                _react2.default.createElement(
	                  SkillsAssessment.TagTitle,
	                  null,
	                  "Complete the Peer Evaluation to unlock this section"
	                )
	              ),
	              _react2.default.createElement(
	                SkillsAssessment.InfoTitle,
	                null,
	                "What would be here?"
	              ),
	              _react2.default.createElement(
	                SkillsAssessment.InfoBody,
	                null,
	                "Each invidudual is unique and can bring different things to a team. The Skills Map on the left will show your",
	                " ",
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "strengths"
	                ),
	                " and ",
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "areas of development"
	                ),
	                " reflected in the game by hearing from the others on your team."
	              ),
	              _react2.default.createElement(
	                SkillsAssessment.InfoBody,
	                null,
	                "Take this as a resource to further know your shining points and grow with more understanding of yourself."
	              )
	            ),
	            showSkillsAssessmentData === true && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                SkillsAssessment.SkillsMap,
	                null,
	                _react2.default.createElement(
	                  SkillsAssessment.SkillsMapTitle,
	                  null,
	                  "Skills Map"
	                ),
	                _react2.default.createElement(
	                  SkillsAssessment.SkillsMapBody,
	                  null,
	                  "The Skills Map on the left shows your interpersonal skills reflected in the game as well as your classmates. Interact with the map to learn more about each skill and how you can develop them as your personal strength in future career."
	                )
	              ),
	              skillsAssessmentStrengthsCategories.length > 0 && _react2.default.createElement(
	                SkillsAssessment.MintSection,
	                null,
	                _react2.default.createElement(
	                  SkillsAssessment.ColorSectionTitle,
	                  null,
	                  "My Strengths"
	                ),
	                _react2.default.createElement(
	                  SkillsAssessment.ColorSectionBody,
	                  null,
	                  "Well done! You are demonstrating these teamwork skills at a high level."
	                ),
	                _react2.default.createElement(
	                  SkillsAssessment.ColorSectionTags,
	                  null,
	                  skillsAssessmentStrengthsCategories.map(function (category, index) {
	                    return _react2.default.createElement(
	                      SkillsAssessment.ColorSectionTag,
	                      { key: "sa-strengths-category-" + index },
	                      category
	                    );
	                  })
	                )
	              ),
	              skillsAssessmentAreasOfDevelopmentCategories.length > 0 && _react2.default.createElement(
	                SkillsAssessment.OrangeSection,
	                null,
	                _react2.default.createElement(
	                  SkillsAssessment.ColorSectionTitle,
	                  null,
	                  "Areas of Development"
	                ),
	                _react2.default.createElement(
	                  SkillsAssessment.ColorSectionBody,
	                  null,
	                  "This assessment might only be able to reflect part of you and what you're good at, but here are some tips to help you shine in these areas that are highly valued in workspace."
	                ),
	                _react2.default.createElement(
	                  SkillsAssessment.ColorSectionTags,
	                  null,
	                  skillsAssessmentAreasOfDevelopmentCategories.map(function (category, index) {
	                    return _react2.default.createElement(
	                      SkillsAssessment.ColorSectionTag,
	                      { key: "sa-areasofdevelopment-category-" + index },
	                      category
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        Profile.Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	      );
	    }
	  }, {
	    key: "peerScoreValue",
	    get: function get() {
	      var peerScoreValue = this.state.peerScoreValue;
	
	
	      return peerScoreValue === null ? '---' : (peerScoreValue * 100).toFixed(2) + "%";
	    }
	  }, {
	    key: "gradingValue",
	    get: function get() {
	      var _state2 = this.state,
	          userGrade = _state2.userGrade,
	          teamGrade = _state2.teamGrade;
	
	      var curved_adjusted_cumulative_value = (0, _get3.default)(userGrade, "curved_adjusted_cumulative_value", 0);
	      var adjusted_cumulative_value = (0, _get3.default)(userGrade, "adjusted_cumulative_value", 0);
	
	      var result = 0;
	      if (curved_adjusted_cumulative_value > 0) {
	        result = curved_adjusted_cumulative_value;
	      } else if (adjusted_cumulative_value > 0) {
	        result = adjusted_cumulative_value;
	      } else if (teamGrade > 0) {
	        result = teamGrade;
	      }
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "latestCompletedFormValue",
	    get: function get() {
	      var reports = this.state.reports;
	
	      var key = "";
	
	      if ("initial" in reports) {
	        key = "initial";
	      }
	
	      if ("second" in reports) {
	        key = "second";
	      }
	
	      if ("final" in reports) {
	        key = "final";
	      }
	
	      return key === "" ? "---" : _lodash2.default.get(reports[key], "average_user_score", 0).toFixed(2);
	    }
	  }, {
	    key: "latestCompletedFormKey",
	    get: function get() {
	      var reports = this.state.reports;
	
	      var key = "";
	
	      if ("initial" in reports) {
	        key = "initial";
	      }
	
	      if ("second" in reports) {
	        key = "second";
	      }
	
	      if ("final" in reports) {
	        key = "final";
	      }
	
	      return key;
	    }
	  }, {
	    key: "peerAdjustment",
	    get: function get() {
	      var currentScore = this.state.currentScore;
	
	      var average_user_score = (0, _get3.default)(currentScore, "average_user_score", 0);
	      var team_median_score = (0, _get3.default)(currentScore, "team_median_score", 0);
	      var result = average_user_score < 6 ? team_median_score !== 0 ? Math.min(1, average_user_score / Math.max(team_median_score, 6)) : 0 : 1;
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "individualGrade",
	    get: function get() {
	      var userGrade = this.state.userGrade;
	
	      var result = (0, _get3.default)(userGrade, "adjusted_cumulative_value", 0);
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "finalGrade",
	    get: function get() {
	      var userGrade = this.state.userGrade;
	
	      var result = (0, _get3.default)(userGrade, "curved_adjusted_cumulative_value", 0);
	
	      return result !== 0 ? (result * 100).toFixed(2) + "%" : "-----";
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return roundInUrl || currentRound;
	    }
	  }]);
	
	  return ProfileComponent;
	}(_react2.default.Component);
	
	exports.default = ProfileComponent;

/***/ },
/* 1345 */
1286,
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component will return input element masked with dollary symbol
	 */
	var PromoSpendInputMasking = function (_Component) {
	  _inherits(PromoSpendInputMasking, _Component);
	
	  function PromoSpendInputMasking() {
	    _classCallCheck(this, PromoSpendInputMasking);
	
	    return _possibleConstructorReturn(this, (PromoSpendInputMasking.__proto__ || Object.getPrototypeOf(PromoSpendInputMasking)).apply(this, arguments));
	  }
	
	  _createClass(PromoSpendInputMasking, [{
	    key: "render",
	    value: function render() {
	      var value = this.props.value;
	
	      return _react2.default.createElement(_reactNumberFormat2.default, {
	        "data-name": this.props.name,
	        "data-client-id": this.props.clientId,
	        "data-promo-id": this.props.promoId,
	        "data-product-id": this.props.productId,
	        value: value,
	        prefix: "$",
	        thousandSeparator: ",",
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return PromoSpendInputMasking;
	}(_react.Component);
	
	exports.default = PromoSpendInputMasking;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000;\n  margin-top: 30px;\n"], ["\n  font-family: Lato;\n  font-size: 18px;\n  line-height: 22px;\n  color: #000;\n  margin-top: 30px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  padding: 10px;\n  width: 100%;\n  height: 130px;\n  background: #fff;\n  border: 1px solid #857e7e;\n  resize: none;\n  margin-top: 10px;\n  outline: none;\n  font-family: Lato;\n  font-size: 14px;\n  color: #222;\n  line-height: 1.2;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: block;\n  padding: 10px;\n  width: 100%;\n  height: 130px;\n  background: #fff;\n  border: 1px solid #857e7e;\n  resize: none;\n  margin-top: 10px;\n  outline: none;\n  font-family: Lato;\n  font-size: 14px;\n  color: #222;\n  line-height: 1.2;\n\n  &:focus {\n    outline: none;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-style: italic;\n  font-size: 14px;\n  color: #ff0000;\n"], ["\n  font-family: Lato;\n  font-style: italic;\n  font-size: 14px;\n  color: #ff0000;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  text-align: center;\n"], ["\n  margin-top: 20px;\n  text-align: center;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 14px;\n  line-height: 14px;\n  color: #bdbdbd;\n  text-align: right;\n  margin-top: -14px;\n\n  ", "\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-size: 14px;\n  line-height: 14px;\n  color: #bdbdbd;\n  text-align: right;\n  margin-top: -14px;\n\n  ", "\n\n  ", "\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n\n  label {\n    font-family: Lato;\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 20px;\n    color: #000;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n  }\n\n  input[type=\"radio\"] {\n    width: 20px;\n    height: 20px;\n    margin: 0 15px;\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n\n  label {\n    font-family: Lato;\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 20px;\n    color: #000;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n  }\n\n  input[type=\"radio\"] {\n    width: 20px;\n    height: 20px;\n    margin: 0 15px;\n    cursor: pointer;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rheostat = __webpack_require__(2533);
	
	var _rheostat2 = _interopRequireDefault(_rheostat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Question = _styledComponents2.default.div(_templateObject);
	
	var SliderButton = function SliderButton(props) {
	  return _react2.default.createElement(
	    "button",
	    Object.assign({}, props, { type: "button" }),
	    props["aria-valuenow"]
	  );
	};
	
	var TextareaFeedback = _styledComponents2.default.textarea(_templateObject2);
	
	var ErrorMessage = _styledComponents2.default.div(_templateObject3);
	
	var ErrorMessageFeedback = (0, _styledComponents2.default)(ErrorMessage)(_templateObject4);
	
	var ErrorMessageRating = (0, _styledComponents2.default)(ErrorMessage)(_templateObject5);
	
	var CharsCounter = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.countOfWords < 10 && "\n    span {\n      color: #f00;\n    }\n  ";
	}, function (p) {
	  return p.countOfWords > 200 && "\n    span {\n      color: #f00;\n    }\n  ";
	});
	
	var RadioFieldRow = _styledComponents2.default.div(_templateObject7);
	
	var getCountOfWords = function getCountOfWords(str) {
	  str = str.replace(/(^\s*)|(\s*$)/gi, '');
	  str = str.replace(/[ ]{2,}/gi, ' ');
	  str = str.replace(/\n /, "\n");
	
	  return str.split(' ').filter(function (w) {
	    return w !== '';
	  }).length;
	};
	
	var FeedbackResponseComponent = function FeedbackResponseComponent(_ref) {
	  var questions = _ref.questions,
	      questionsOffset = _ref.questionsOffset,
	      setAnswer = _ref.setAnswer,
	      getAnswer = _ref.getAnswer,
	      showErrors = _ref.showErrors,
	      getError = _ref.getError,
	      teammates = _ref.teammates,
	      _ref$readonly_mode = _ref.readonly_mode,
	      readonly_mode = _ref$readonly_mode === undefined ? false : _ref$readonly_mode;
	  return _react2.default.createElement(
	    "div",
	    null,
	    questions && questions.length > 0 && questions.map(function (question, i) {
	      var answer = getAnswer(question.id);
	      var error = getError(question.id);
	
	      if (question.answer_type === "rating") {
	        return _react2.default.createElement(
	          "div",
	          { key: question.id },
	          _react2.default.createElement(
	            Question,
	            null,
	            i + questionsOffset + 1,
	            ". ",
	            question.text
	          ),
	          _react2.default.createElement(_rheostat2.default, {
	            className: "feedback-rheostat",
	            min: 0,
	            max: 7,
	            snap: true,
	            handle: SliderButton,
	            values: [answer.answer_text ? answer.answer_text : 0],
	            onChange: function onChange(obj) {
	              return readonly_mode ? function () {} : setAnswer(question.id, obj.values[0]);
	            },
	            disabled: readonly_mode
	          }),
	          showErrors === true && error && _react2.default.createElement(
	            ErrorMessageRating,
	            null,
	            error
	          )
	        );
	      }
	
	      if (question.answer_type === "freeform" && question.text !== "Besides yourself, who is the most valuable person on your team?" && question.text !== "Besides yourself, who was the most valuable person on your team?" && question.text !== "Would you want to work with this teammate again?") {
	        var countOfWords = answer.answer_text ? getCountOfWords(answer.answer_text) : 0;
	
	        return _react2.default.createElement(
	          "div",
	          { key: question.id },
	          _react2.default.createElement(
	            Question,
	            null,
	            i + questionsOffset + 1,
	            ". ",
	            question.text
	          ),
	          !readonly_mode && _react2.default.createElement(
	            CharsCounter,
	            { countOfWords: countOfWords },
	            _react2.default.createElement(
	              "span",
	              null,
	              countOfWords
	            ),
	            " / 200"
	          ),
	          _react2.default.createElement(TextareaFeedback, {
	            value: answer.answer_text ? answer.answer_text : "",
	            onChange: function onChange(e) {
	              return readonly_mode ? function () {} : setAnswer(question.id, e.target.value);
	            },
	            readOnly: readonly_mode
	          }),
	          showErrors === true && error && _react2.default.createElement(
	            ErrorMessageFeedback,
	            null,
	            error
	          )
	        );
	      }
	
	      if (question.text === "Besides yourself, who is the most valuable person on your team?" || question.text === "Besides yourself, who was the most valuable person on your team?") {
	        return _react2.default.createElement(
	          "div",
	          { key: question.id },
	          _react2.default.createElement(
	            Question,
	            null,
	            i + questionsOffset + 1,
	            ". ",
	            question.text
	          ),
	          teammates.map(function (_ref2) {
	            var user = _ref2.user;
	            return _react2.default.createElement(
	              RadioFieldRow,
	              { key: user.id },
	              _react2.default.createElement("input", {
	                type: "radio",
	                id: "selectTeamMember" + user.id,
	                value: user.username,
	                name: "selectTeamMember",
	                checked: answer.answer_text ? user.username === answer.answer_text ? true : false : false,
	                onChange: function onChange() {
	                  return readonly_mode ? function () {} : setAnswer(question.id, user.username);
	                },
	                disabled: readonly_mode
	              }),
	              _react2.default.createElement(
	                "label",
	                { htmlFor: "selectTeamMember" + user.id },
	                user.first_name,
	                " ",
	                user.last_name
	              )
	            );
	          }),
	          showErrors === true && error && _react2.default.createElement(
	            ErrorMessageFeedback,
	            null,
	            error
	          )
	        );
	      }
	
	      if (question.text === "Would you want to work with this teammate again?") {
	        return _react2.default.createElement(
	          "div",
	          { key: question.id },
	          _react2.default.createElement(
	            Question,
	            null,
	            i + questionsOffset + 1,
	            ". ",
	            question.text
	          ),
	          _react2.default.createElement(
	            RadioFieldRow,
	            null,
	            _react2.default.createElement("input", {
	              type: "radio",
	              id: "select" + question.id + "_yes",
	              value: "yes",
	              name: "select" + question.id,
	              checked: answer.answer_text ? "yes" === answer.answer_text ? true : false : false,
	              onChange: function onChange() {
	                return readonly_mode ? function () {} : setAnswer(question.id, "yes");
	              },
	              disabled: readonly_mode
	            }),
	            _react2.default.createElement(
	              "label",
	              { htmlFor: "select" + question.id + "_yes" },
	              "Yes"
	            )
	          ),
	          _react2.default.createElement(
	            RadioFieldRow,
	            null,
	            _react2.default.createElement("input", {
	              type: "radio",
	              id: "select" + question.id + "_no",
	              value: "no",
	              name: "select" + question.id,
	              checked: answer.answer_text ? "no" === answer.answer_text ? true : false : false,
	              onChange: function onChange() {
	                return readonly_mode ? function () {} : setAnswer(question.id, "no");
	              },
	              disabled: readonly_mode
	            }),
	            _react2.default.createElement(
	              "label",
	              { htmlFor: "select" + question.id + "_no" },
	              "No"
	            )
	          ),
	          showErrors === true && error && _react2.default.createElement(
	            ErrorMessageFeedback,
	            null,
	            error
	          )
	        );
	      }
	
	      return null;
	    })
	  );
	};
	
	exports.default = FeedbackResponseComponent;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 24px;\n  text-align: center;\n  padding-top: 50px;\n"], ["\n  font-family: Lato;\n  font-size: 24px;\n  text-align: center;\n  padding-top: 50px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _feedbackResponse = __webpack_require__(1347);
	
	var _feedbackResponse2 = _interopRequireDefault(_feedbackResponse);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _ApiService = __webpack_require__(4);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _peerEvaluationCard = __webpack_require__(589);
	
	var _peerEvaluationCard2 = _interopRequireDefault(_peerEvaluationCard);
	
	var _peerEvaluationModal = __webpack_require__(256);
	
	var _peerEvaluationModal2 = _interopRequireDefault(_peerEvaluationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FinalMessage = _styledComponents2.default.div(_templateObject);
	
	var Quiz = function (_React$Component) {
	  _inherits(Quiz, _React$Component);
	
	  function Quiz(props) {
	    _classCallCheck(this, Quiz);
	
	    var _this = _possibleConstructorReturn(this, (Quiz.__proto__ || Object.getPrototypeOf(Quiz)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var userId = parseInt(_Auth2.default.getUserId(), 10);
	
	    var hasSelfAssessmentQuestions = false;
	    if (props.survey && props.survey.questions && props.survey.questions.length > 0) {
	      var self_assessment_question = props.survey.questions.find(function (i) {
	        return i.category === "self_assessment";
	      });
	      if (self_assessment_question) {
	        hasSelfAssessmentQuestions = true;
	      }
	    }
	
	    var nonCurrentUserId = 0;
	    var team = _Teams2.default.currentTeam();
	    var players = _Teams2.default.players();
	
	    if (team && players && players.length > 0) {
	      var teammates = players.filter(function (player) {
	        return player.user ? player.team === team.id && player.user.id !== userId : false;
	      });
	
	      if (teammates && teammates.length > 0) {
	        var teammate = teammates[0];
	
	        if (teammate && teammate.user) {
	          nonCurrentUserId = teammate.user.id;
	        }
	      }
	    }
	
	    _this.state = {
	      show: false,
	      currentUserId: hasSelfAssessmentQuestions ? userId : nonCurrentUserId,
	      myselfUserId: userId,
	      nonMyselfUserId: nonCurrentUserId,
	      hasSelfAssessmentQuestions: hasSelfAssessmentQuestions,
	      currentPage: 0,
	      questionsOffset: 0,
	      answers: {},
	      errors: {},
	      showFinalPage: false,
	      feedback: null,
	      finished_feedbacks: {},
	      completed_feedbacks: [],
	      readonly_mode: false
	    };
	    return _this;
	  }
	
	  _createClass(Quiz, [{
	    key: "getFeedback",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(data) {
	        var readonly_mode, feedback, _ref2, body, query, _ref3, _body;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                readonly_mode = this.state.readonly_mode;
	                feedback = null;
	
	                if (!(readonly_mode === false)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _context.next = 5;
	                return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/").send(data);
	
	              case 5:
	                _ref2 = _context.sent;
	                body = _ref2.body;
	
	                feedback = body;
	                _context.next = 17;
	                break;
	
	              case 10:
	                query = "";
	
	                Object.keys(data).forEach(function (q) {
	                  query = "" + query + (query === "" ? "?" : "&") + q + "=" + data[q];
	                });
	
	                _context.next = 14;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/" + query);
	
	              case 14:
	                _ref3 = _context.sent;
	                _body = _ref3.body;
	
	
	                if (_body && _body.results && _body.results.length > 0) {
	                  feedback = _body.results[0];
	                }
	
	              case 17:
	                return _context.abrupt("return", feedback);
	
	              case 18:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getFeedback(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getFeedback;
	    }()
	  }, {
	    key: "loadFeedback",
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var set_completed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var survey, _state, currentUserId, myselfUserId, team, sendData, feedback, _ref5, answersData, answers;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                survey = this.props.survey;
	                _state = this.state, currentUserId = _state.currentUserId, myselfUserId = _state.myselfUserId;
	                team = _Teams2.default.currentTeam();
	                sendData = {
	                  survey: survey.id,
	                  giver: myselfUserId,
	                  receiver: currentUserId,
	                  giver_team: team.id
	                };
	                _context2.next = 6;
	                return this.getFeedback(sendData);
	
	              case 6:
	                feedback = _context2.sent;
	                _context2.next = 9;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers/");
	
	              case 9:
	                _ref5 = _context2.sent;
	                answersData = _ref5.body;
	                answers = {};
	
	                if (answersData && answersData.length > 0 && feedback) {
	                  answersData.filter(function (answer) {
	                    return answer.feedback === feedback.id;
	                  }).forEach(function (answer) {
	                    var question = survey.questions.find(function (q) {
	                      return q.id === answer.survey_question;
	                    });
	                    answers[answer.survey_question] = {
	                      id: answer.id,
	                      answer_text: question.answer_type === "rating" ? parseInt(answer.text, 10) : answer.text
	                    };
	                  });
	                }
	
	                this.setState({
	                  feedback: feedback,
	                  answers: answers
	                }, function () {
	                  if (set_completed === true && feedback) {
	                    var finished_feedbacks = _this2.state.finished_feedbacks;
	
	
	                    _this2.setState({
	                      finished_feedbacks: Object.assign({}, finished_feedbacks, _defineProperty({}, feedback.id, sendData))
	                    });
	                  }
	                });
	
	              case 14:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function loadFeedback() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return loadFeedback;
	    }()
	  }, {
	    key: "sendCompletedAll",
	    value: function sendCompletedAll() {
	      var _this3 = this;
	
	      var finished_feedbacks = this.state.finished_feedbacks;
	
	
	      Object.keys(finished_feedbacks).forEach(function (feedback_id) {
	        _this3.sendCompleted(feedback_id, finished_feedbacks[feedback_id]);
	      });
	    }
	  }, {
	    key: "sendCompleted",
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(feedback_id, sendData) {
	        var _this4 = this;
	
	        var readonly_mode, completed_feedbacks;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                readonly_mode = this.state.readonly_mode;
	
	                if (!(readonly_mode === false)) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                _context3.next = 4;
	                return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedbacks/" + feedback_id + "/").send(Object.assign({}, sendData, {
	                  completed: true
	                }));
	
	              case 4:
	                completed_feedbacks = this.state.completed_feedbacks;
	
	                this.setState({
	                  completed_feedbacks: [].concat(_toConsumableArray(completed_feedbacks), [feedback_id])
	                }, function () {
	                  if (_this4.state.completed_feedbacks.length === Object.keys(_this4.state.finished_feedbacks).length) {
	                    _this4.setState({
	                      completed_feedbacks: [],
	                      finished_feedbacks: {}
	                    });
	                  }
	                });
	
	              case 6:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function sendCompleted(_x3, _x4) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return sendCompleted;
	    }()
	  }, {
	    key: "sendAnswers",
	    value: function sendAnswers(newState) {
	      var _this5 = this;
	
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          feedback = _state2.feedback,
	          readonly_mode = _state2.readonly_mode;
	
	
	      if (this.questions[currentPage] && this.questions[currentPage].length > 0 && readonly_mode === false) {
	        this.questions[currentPage].forEach(function () {
	          var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(question) {
	            var answer;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    answer = _this5.getAnswer(question.id);
	
	                    if (!(answer.id === 0)) {
	                      _context4.next = 6;
	                      break;
	                    }
	
	                    _context4.next = 4;
	                    return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers/").send({
	                      feedback: feedback.id,
	                      survey_question: question.id,
	                      text: answer.answer_text
	                    });
	
	                  case 4:
	                    _context4.next = 8;
	                    break;
	
	                  case 6:
	                    _context4.next = 8;
	                    return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers/" + answer.id + "/").send({
	                      feedback: feedback.id,
	                      survey_question: question.id,
	                      text: answer.answer_text
	                    });
	
	                  case 8:
	                  case "end":
	                    return _context4.stop();
	                }
	              }
	            }, _callee4, _this5);
	          }));
	
	          return function (_x6) {
	            return _ref7.apply(this, arguments);
	          };
	        }());
	      }
	
	      this.setState(newState, function () {
	        if (callback) {
	          callback();
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state3 = this.state,
	          show = _state3.show,
	          currentPage = _state3.currentPage,
	          questionsOffset = _state3.questionsOffset,
	          showFinalPage = _state3.showFinalPage,
	          readonly_mode = _state3.readonly_mode;
	      var _props = this.props,
	          survey = _props.survey,
	          isStarted = _props.isStarted,
	          isEnded = _props.isEnded;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "survey-quiz" },
	        _react2.default.createElement(_peerEvaluationCard2.default, {
	          survey: survey,
	          onClick: this.handleShowModal,
	          isActive: this.isLinkActive,
	          isEnded: isEnded,
	          isStarted: isStarted
	        }),
	        _react2.default.createElement(
	          _peerEvaluationModal2.default,
	          {
	            show: show,
	            onHide: this.handleShowModal
	            // title={this.title}
	            // subtitle={this.subtitle}
	            // feedbackType={`${surveyStage} Feedback`}
	            // onSubmit={this.onSubmit}
	            // onSaveDraft={this.onSaveDraft}
	            // submitButtonText={showFinalPage ? "Close" : "Next"}
	            // showFinalMessage={showFinalPage}
	            // showBackButton={!this.isFirstPage}
	            // goBack={this.goBack}
	            // backdrop={readonly_mode === true ? true : "static"}
	            // keyboard={false}
	            // readonly_mode={readonly_mode}
	          },
	          !showFinalPage && _react2.default.createElement(_feedbackResponse2.default, {
	            questions: this.questions[currentPage],
	            questionsOffset: questionsOffset,
	            setAnswer: this.setAnswer,
	            getAnswer: this.getAnswer,
	            showErrors: this.hasErrors,
	            getError: this.getError,
	            teammates: this.teammates,
	            readonly_mode: readonly_mode
	          }),
	          showFinalPage && _react2.default.createElement(
	            FinalMessage,
	            null,
	            "Congratulations! You've completed your ",
	            survey.name,
	            ". You can revisit and modify this survey at any time before the deadline."
	          )
	        )
	      );
	    }
	  }, {
	    key: "isLinkNotActive",
	    get: function get() {
	      var survey = this.props.survey;
	
	
	      var startDate = (0, _moment2.default)(survey.start);
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isBefore(startDate);
	    }
	  }, {
	    key: "isLinkActive",
	    get: function get() {
	      var survey = this.props.survey;
	
	
	      var startDate = (0, _moment2.default)(survey.start);
	      var endDate = (0, _moment2.default)(survey.end);
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate);
	    }
	  }, {
	    key: "questions",
	    get: function get() {
	      var _state4 = this.state,
	          currentUserId = _state4.currentUserId,
	          myselfUserId = _state4.myselfUserId;
	      var survey = this.props.survey;
	      var questions = survey.questions;
	
	
	      var group1 = _lodash2.default.groupBy(questions.map(function (question) {
	        var category = question.category === "self_assessment" ? "self_assessment" : "non_self_assessment";
	
	        return Object.assign({}, question, { category: category });
	      }), "category");
	
	      var group2 = currentUserId === myselfUserId ? _lodash2.default.get(group1, "self_assessment", []) : _lodash2.default.get(group1, "non_self_assessment", []);
	
	      var group3 = _lodash2.default.groupBy(_lodash2.default.sortBy(group2, "list_order"), "answer_type");
	
	      var rating = _lodash2.default.chunk(_lodash2.default.get(group3, "rating", []), 4);
	      var freeform = _lodash2.default.chunk(_lodash2.default.get(group3, "freeform", []), 2);
	
	      return [].concat(_toConsumableArray(rating), _toConsumableArray(freeform));
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      var _state5 = this.state,
	          currentUserId = _state5.currentUserId,
	          myselfUserId = _state5.myselfUserId;
	
	
	      if (currentUserId === myselfUserId) {
	        return "Self Assessment";
	      }
	
	      var userIndex = this.team.findIndex(function (i) {
	        return i.user.id === currentUserId;
	      });
	
	      return userIndex > -1 ? "Team Member: " + userIndex : null;
	    }
	  }, {
	    key: "subtitle",
	    get: function get() {
	      var _state6 = this.state,
	          currentUserId = _state6.currentUserId,
	          myselfUserId = _state6.myselfUserId;
	
	
	      if (currentUserId === myselfUserId) {
	        return null;
	      }
	
	      var user = this.team.find(function (i) {
	        return i.user.id === currentUserId;
	      });
	
	      return user ? user.user.first_name + " " + user.user.last_name : null;
	    }
	  }, {
	    key: "team",
	    get: function get() {
	      return [this.myself].concat(_toConsumableArray(this.teammates));
	    }
	  }, {
	    key: "myself",
	    get: function get() {
	      var myselfUserId = this.state.myselfUserId;
	
	      var team = _Teams2.default.currentTeam();
	      var players = _Teams2.default.players();
	
	      return players.find(function (player) {
	        return player.team === team.id && player.user.id === myselfUserId;
	      });
	    }
	  }, {
	    key: "teammates",
	    get: function get() {
	      var myselfUserId = this.state.myselfUserId;
	
	      var team = _Teams2.default.currentTeam();
	      var players = _Teams2.default.players();
	
	      return players.filter(function (player) {
	        return player.team === team.id && player.user.id !== myselfUserId;
	      });
	    }
	  }, {
	    key: "hasErrors",
	    get: function get() {
	      return Object.keys(this.state.errors).length > 0 ? true : false;
	    }
	  }, {
	    key: "isFirstPage",
	    get: function get() {
	      var _state7 = this.state,
	          currentUserId = _state7.currentUserId,
	          myselfUserId = _state7.myselfUserId,
	          currentPage = _state7.currentPage,
	          hasSelfAssessmentQuestions = _state7.hasSelfAssessmentQuestions,
	          nonMyselfUserId = _state7.nonMyselfUserId;
	
	      var initialUserId = hasSelfAssessmentQuestions ? myselfUserId : nonMyselfUserId;
	
	      return currentUserId === initialUserId && currentPage === 0;
	    }
	  }]);
	
	  return Quiz;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this6 = this;
	
	  this.handleShowModal = function () {
	    if (_this6.isLinkActive) {
	      _this6.setState({ show: !_this6.state.show }, function () {
	        if (_this6.state.show === true) {
	          _this6.setState({
	            currentUserId: _this6.state.hasSelfAssessmentQuestions ? _this6.state.myselfUserId : _this6.state.nonMyselfUserId,
	            currentPage: 0,
	            questionsOffset: 0,
	            errors: {},
	            showFinalPage: false,
	            feedback: null,
	            completed_feedbacks: [],
	            finished_feedbacks: {},
	            readonly_mode: false
	          }, function () {
	            _this6.loadFeedback();
	          });
	        }
	      });
	    } else {
	      _this6.setState({ show: !_this6.state.show }, function () {
	        if (_this6.state.show === true) {
	          _this6.setState({
	            currentUserId: _this6.state.hasSelfAssessmentQuestions ? _this6.state.myselfUserId : _this6.state.nonMyselfUserId,
	            currentPage: 0,
	            questionsOffset: 0,
	            errors: {},
	            showFinalPage: false,
	            feedback: null,
	            completed_feedbacks: [],
	            finished_feedbacks: {},
	            readonly_mode: true
	          }, function () {
	            _this6.loadFeedback();
	          });
	        }
	      });
	    }
	  };
	
	  this.getCountOfWords = function (str) {
	    str = str.replace(/(^\s*)|(\s*$)/gi, "");
	    str = str.replace(/[ ]{2,}/gi, " ");
	    str = str.replace(/\n /, "\n");
	
	    return str.split(" ").filter(function (w) {
	      return w !== "";
	    }).length;
	  };
	
	  this.checkErrors = function () {
	    var errors = {};
	    var currentPage = _this6.state.currentPage;
	
	
	    if (_this6.questions[currentPage] && _this6.questions[currentPage].length > 0) {
	      _this6.questions[currentPage].forEach(function (question) {
	        var answer = _this6.getAnswer(question.id);
	        if (question.answer_type === "rating") {
	          var value = parseInt(answer.answer_text, 10);
	          if (isNaN(value)) {
	            value = 0;
	          }
	
	          if (value === 0) {
	            errors[question.id] = "Please provide a rating for all questions before you can continue.";
	          }
	        } else if (question.answer_type === "freeform") {
	          var _value = answer.answer_text;
	          if (!_value) {
	            _value = "";
	          }
	
	          if (question.text === "Besides yourself, who is the most valuable person on your team?" || question.text === "Besides yourself, who was the most valuable person on your team?") {
	            var possible_answers = _this6.teammates.map(function (i) {
	              return i.user;
	            }).map(function (i) {
	              return i.username;
	            });
	            if (_value.length === 0 || !possible_answers.includes(_value)) {
	              errors[question.id] = "The most valuable person should be selected";
	            }
	          } else if (question.text === "Would you want to work with this teammate again?") {
	            if (_value.length === 0) {
	              errors[question.id] = "Please answer on the question";
	            }
	          } else {
	            if (_this6.getCountOfWords(_value) < 10) {
	              errors[question.id] = "Your feedback is too short. Please ensure that it is at least 60 words long.";
	            } else if (_this6.getCountOfWords(_value) > 200) {
	              errors[question.id] = "Your feedback is too long. Please ensure that it is not more than 200 words long.";
	            }
	          }
	        }
	      });
	    }
	
	    _this6.setState({
	      errors: errors
	    });
	
	    return Object.keys(errors).length > 0 ? true : false;
	  };
	
	  this.goBack = function () {
	    var _state8 = _this6.state,
	        currentPage = _state8.currentPage,
	        questionsOffset = _state8.questionsOffset,
	        currentUserId = _state8.currentUserId,
	        showFinalPage = _state8.showFinalPage;
	
	    var questions = _this6.questions;
	
	    if (showFinalPage) {
	      _this6.setState({
	        showFinalPage: false
	      });
	    } else if (currentPage > 0) {
	      _this6.setState({
	        currentPage: currentPage - 1,
	        questionsOffset: questionsOffset - questions[currentPage - 1].length,
	        errors: {}
	      });
	    } else {
	      var hasSelfAssessmentQuestions = _this6.state.hasSelfAssessmentQuestions;
	
	      var team = hasSelfAssessmentQuestions ? _this6.team : _this6.teammates;
	      var teamIndex = team.findIndex(function (player) {
	        return player.user.id === currentUserId;
	      });
	
	      if (teamIndex > 0) {
	        _this6.setState({
	          currentUserId: team[teamIndex - 1].user.id,
	          errors: {}
	        }, function () {
	          var new_questions = _this6.questions;
	          var questions_count = Object.values(new_questions).map(function (el) {
	            return el.length;
	          });
	          questions_count.splice(-1, 1);
	
	          _this6.setState({
	            currentPage: new_questions.length - 1,
	            questionsOffset: _lodash2.default.sum(questions_count)
	          }, function () {
	            _this6.loadFeedback();
	          });
	        });
	      }
	    }
	  };
	
	  this.onSubmit = function () {
	    var _state9 = _this6.state,
	        currentPage = _state9.currentPage,
	        questionsOffset = _state9.questionsOffset,
	        currentUserId = _state9.currentUserId,
	        showFinalPage = _state9.showFinalPage,
	        readonly_mode = _state9.readonly_mode;
	
	
	    if (showFinalPage) {
	      _this6.setState({
	        show: false
	      }, function () {
	        _this6.sendCompletedAll();
	      });
	      return;
	    }
	
	    var questions = _this6.questions;
	    var hasErrors = readonly_mode ? false : _this6.checkErrors();
	
	    if (hasErrors === true) {
	      return;
	    }
	
	    if (currentPage < questions.length - 1) {
	      _this6.sendAnswers({
	        currentPage: currentPage + 1,
	        questionsOffset: questionsOffset + questions[currentPage].length,
	        errors: {}
	      });
	    } else {
	      var hasSelfAssessmentQuestions = _this6.state.hasSelfAssessmentQuestions;
	
	      var team = hasSelfAssessmentQuestions ? _this6.team : _this6.teammates;
	      var teamIndex = team.findIndex(function (player) {
	        return player.user.id === currentUserId;
	      });
	
	      if (teamIndex < team.length - 1) {
	        _this6.sendAnswers({
	          currentPage: 0,
	          questionsOffset: 0,
	          currentUserId: team[teamIndex + 1].user.id,
	          errors: {}
	        }, function () {
	          _this6.loadFeedback(true);
	        });
	      } else {
	        _this6.sendAnswers({
	          showFinalPage: true
	        });
	      }
	    }
	  };
	
	  this.onSaveDraft = function () {
	    var hasErrors = _this6.checkErrors();
	    if (hasErrors === true) {
	      return;
	    }
	
	    _this6.sendAnswers({
	      show: false,
	      errors: {}
	    });
	  };
	
	  this.setAnswer = function (question_id, answer_text) {
	    var answers = _this6.state.answers;
	
	    var answer = question_id in answers ? Object.assign({}, answers[question_id], { answer_text: answer_text }) : {
	      id: 0,
	      answer_text: answer_text
	    };
	
	    _this6.setState({
	      answers: Object.assign({}, answers, _defineProperty({}, question_id, answer))
	    });
	  };
	
	  this.getAnswer = function (question_id) {
	    var answers = _this6.state.answers;
	
	
	    return question_id in answers ? answers[question_id] : { id: 0, answer_text: null };
	  };
	
	  this.getError = function (question_id) {
	    var errors = _this6.state.errors;
	
	
	    return question_id in errors ? errors[question_id] : null;
	  };
	};
	
	exports.default = (0, _reactRouter.withRouter)(Quiz);

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsPanelBalanceSheet = function (_Component) {
	  _inherits(ResultsPanelBalanceSheet, _Component);
	
	  function ResultsPanelBalanceSheet(props) {
	    _classCallCheck(this, ResultsPanelBalanceSheet);
	
	    var _this = _possibleConstructorReturn(this, (ResultsPanelBalanceSheet.__proto__ || Object.getPrototypeOf(ResultsPanelBalanceSheet)).call(this, props));
	
	    _this.state = {
	      total_assets: {},
	      total_liabilities: {},
	      total_equity: {},
	      roundInUrl: props.roundInUrl
	    };
	    return _this;
	  }
	
	  _createClass(ResultsPanelBalanceSheet, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "getBalanceSheet",
	    value: function getBalanceSheet() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/report/balance_sheet/";
	      var url = base_url + "?round_lte=" + this.props.currentRound;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound) {
	        url = base_url + "?round_lte=" + this.state.roundInUrl;
	      }
	
	      return (0, _ApiService.getRequest)(url);
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this3 = this;
	
	      this.getBalanceSheet().then(function (res) {
	        var total_assets = {};
	        var total_liabilities = {};
	        var total_equity = {};
	
	        res.body.forEach(function (item) {
	          var round_id = item.round;
	          var round = _this3.props.rounds.find(function (i) {
	            return i.id === round_id;
	          });
	          var round_number = round.number;
	
	          if (item["Total Assets"]) {
	            total_assets[round_number] = item["Total Assets"];
	          }
	
	          if (item["Total Liabilities"]) {
	            total_liabilities[round_number] = item["Total Liabilities"];
	          }
	
	          if (item["Total Equity"]) {
	            total_equity[round_number] = item["Total Equity"];
	          }
	        });
	
	        _this3.setState({
	          total_assets: total_assets,
	          total_liabilities: total_liabilities,
	          total_equity: total_equity
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ResultsPanelBalanceSheet", "fetchData");
	      });
	    }
	  }, {
	    key: "getYear",
	    value: function getYear(offset) {
	      var currentRound = this.props.currentRound;
	      var roundInUrl = this.state.roundInUrl;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      var rounds = [current_round, current_round + 1, current_round + 2];
	      if (current_round + 2 > this.props.rounds.length) {
	        current_round = this.props.rounds[this.props.rounds.length - 1].number;
	        rounds = [current_round - 2, current_round - 1, current_round];
	      }
	
	      return rounds[offset];
	    }
	  }, {
	    key: "getDataValue",
	    value: function getDataValue(key, year) {
	      if (key in this.state) {
	        var data = this.state[key];
	        if (year in data) {
	          return data[year];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getTotalAssets",
	    value: function getTotalAssets(year) {
	      return this.getDataValue("total_assets", year);
	    }
	  }, {
	    key: "getTotalLiabilities",
	    value: function getTotalLiabilities(year) {
	      return this.getDataValue("total_liabilities", year);
	    }
	  }, {
	    key: "getTotalEquity",
	    value: function getTotalEquity(year) {
	      return this.getDataValue("total_equity", year);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "table-responsive" },
	        _react2.default.createElement(
	          "table",
	          { className: "table" },
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement("span", null)
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year1
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year2
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year3
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Total Assets"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalAssets1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalAssets2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalAssets3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Total Liabilities"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalLiabilities1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalLiabilities2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalLiabilities3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Total Equity"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalEquity1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalEquity2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.totalEquity3,
	                  prefix: "$"
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "year1",
	    get: function get() {
	      return this.getYear(0);
	    }
	  }, {
	    key: "year2",
	    get: function get() {
	      return this.getYear(1);
	    }
	  }, {
	    key: "year3",
	    get: function get() {
	      return this.getYear(2);
	    }
	  }, {
	    key: "totalAssets1",
	    get: function get() {
	      return this.getTotalAssets(this.year1);
	    }
	  }, {
	    key: "totalAssets2",
	    get: function get() {
	      return this.getTotalAssets(this.year2);
	    }
	  }, {
	    key: "totalAssets3",
	    get: function get() {
	      return this.getTotalAssets(this.year3);
	    }
	  }, {
	    key: "totalLiabilities1",
	    get: function get() {
	      return this.getTotalLiabilities(this.year1);
	    }
	  }, {
	    key: "totalLiabilities2",
	    get: function get() {
	      return this.getTotalLiabilities(this.year2);
	    }
	  }, {
	    key: "totalLiabilities3",
	    get: function get() {
	      return this.getTotalLiabilities(this.year3);
	    }
	  }, {
	    key: "totalEquity1",
	    get: function get() {
	      return this.getTotalEquity(this.year1);
	    }
	  }, {
	    key: "totalEquity2",
	    get: function get() {
	      return this.getTotalEquity(this.year2);
	    }
	  }, {
	    key: "totalEquity3",
	    get: function get() {
	      return this.getTotalEquity(this.year3);
	    }
	  }]);
	
	  return ResultsPanelBalanceSheet;
	}(_react.Component);
	
	exports.default = ResultsPanelBalanceSheet;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsPanelCashFlows = function (_Component) {
	  _inherits(ResultsPanelCashFlows, _Component);
	
	  function ResultsPanelCashFlows(props) {
	    _classCallCheck(this, ResultsPanelCashFlows);
	
	    var _this = _possibleConstructorReturn(this, (ResultsPanelCashFlows.__proto__ || Object.getPrototypeOf(ResultsPanelCashFlows)).call(this, props));
	
	    _this.state = {
	      cash_flows_from_operations: {},
	      cash_flows_from_investing: {},
	      cash_flows_from_financing: {},
	      net_change_in_cash: {},
	      roundInUrl: props.roundInUrl
	    };
	    return _this;
	  }
	
	  _createClass(ResultsPanelCashFlows, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "getCashflow",
	    value: function getCashflow() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/report/cashflow/";
	      var url = base_url + "?round_lte=" + this.props.currentRound;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound) {
	        url = base_url + "?round_lte=" + this.state.roundInUrl;
	      }
	
	      return (0, _ApiService.getRequest)(url);
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this3 = this;
	
	      this.getCashflow().then(function (res) {
	        var cash_flows_from_operations = {};
	        var cash_flows_from_investing = {};
	        var cash_flows_from_financing = {};
	        var net_change_in_cash = {};
	
	        res.body.forEach(function (item) {
	          var round_id = item.round;
	          var round = _this3.props.rounds.find(function (i) {
	            return i.id === round_id;
	          });
	          var round_number = round.number;
	
	          if (item["Total Cash Flows from Operations"]) {
	            cash_flows_from_operations[round_number] = item["Total Cash Flows from Operations"];
	          }
	
	          if (item["Total Cash Flows from Investing"]) {
	            cash_flows_from_investing[round_number] = item["Total Cash Flows from Investing"];
	          }
	
	          if (item["Total Cash Flows from Financing"]) {
	            cash_flows_from_financing[round_number] = item["Total Cash Flows from Financing"];
	          }
	
	          if (item["Net Change in Cash"]) {
	            net_change_in_cash[round_number] = item["Net Change in Cash"];
	          }
	        });
	
	        _this3.setState({
	          cash_flows_from_operations: cash_flows_from_operations,
	          cash_flows_from_investing: cash_flows_from_investing,
	          cash_flows_from_financing: cash_flows_from_financing,
	          net_change_in_cash: net_change_in_cash
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ResultsPanelCashFlows", "fetchData");
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "getYear",
	    value: function getYear(offset) {
	      var currentRound = this.props.currentRound;
	      var roundInUrl = this.state.roundInUrl;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      var rounds = [current_round, current_round + 1, current_round + 2];
	      if (current_round + 2 > this.props.rounds.length) {
	        current_round = this.props.rounds[this.props.rounds.length - 1].number;
	        rounds = [current_round - 2, current_round - 1, current_round];
	      }
	
	      return rounds[offset];
	    }
	  }, {
	    key: "getDataValue",
	    value: function getDataValue(key, year) {
	      if (key in this.state) {
	        var data = this.state[key];
	        if (year in data) {
	          return data[year];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getCashFlowsFromOperations",
	    value: function getCashFlowsFromOperations(year) {
	      return this.getDataValue("cash_flows_from_operations", year);
	    }
	  }, {
	    key: "getCashFlowsFromInvesting",
	    value: function getCashFlowsFromInvesting(year) {
	      return this.getDataValue("cash_flows_from_investing", year);
	    }
	  }, {
	    key: "getCashFlowsFromFinancing",
	    value: function getCashFlowsFromFinancing(year) {
	      return this.getDataValue("cash_flows_from_financing", year);
	    }
	  }, {
	    key: "getNetChangeInCash",
	    value: function getNetChangeInCash(year) {
	      return this.getDataValue("net_change_in_cash", year);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "table-responsive" },
	        _react2.default.createElement(
	          "table",
	          { className: "table" },
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement("span", null)
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year1
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year2
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year3
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Cash Flows from Operations"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromOperations1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromOperations2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromOperations3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Cash Flows from Investing"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromInvesting1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromInvesting2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromInvesting3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Cash Flows from Financing"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromFinancing1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromFinancing2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.cashFlowsFromFinancing3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Net Change in Cash"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.netChangeInCash1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.netChangeInCash2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.netChangeInCash3,
	                  prefix: "$"
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "year1",
	    get: function get() {
	      return this.getYear(0);
	    }
	  }, {
	    key: "year2",
	    get: function get() {
	      return this.getYear(1);
	    }
	  }, {
	    key: "year3",
	    get: function get() {
	      return this.getYear(2);
	    }
	  }, {
	    key: "cashFlowsFromOperations1",
	    get: function get() {
	      return this.getCashFlowsFromOperations(this.year1);
	    }
	  }, {
	    key: "cashFlowsFromOperations2",
	    get: function get() {
	      return this.getCashFlowsFromOperations(this.year2);
	    }
	  }, {
	    key: "cashFlowsFromOperations3",
	    get: function get() {
	      return this.getCashFlowsFromOperations(this.year3);
	    }
	  }, {
	    key: "cashFlowsFromInvesting1",
	    get: function get() {
	      return this.getCashFlowsFromInvesting(this.year1);
	    }
	  }, {
	    key: "cashFlowsFromInvesting2",
	    get: function get() {
	      return this.getCashFlowsFromInvesting(this.year2);
	    }
	  }, {
	    key: "cashFlowsFromInvesting3",
	    get: function get() {
	      return this.getCashFlowsFromInvesting(this.year3);
	    }
	  }, {
	    key: "cashFlowsFromFinancing1",
	    get: function get() {
	      return this.getCashFlowsFromFinancing(this.year1);
	    }
	  }, {
	    key: "cashFlowsFromFinancing2",
	    get: function get() {
	      return this.getCashFlowsFromFinancing(this.year2);
	    }
	  }, {
	    key: "cashFlowsFromFinancing3",
	    get: function get() {
	      return this.getCashFlowsFromFinancing(this.year3);
	    }
	  }, {
	    key: "netChangeInCash1",
	    get: function get() {
	      return this.getNetChangeInCash(this.year1);
	    }
	  }, {
	    key: "netChangeInCash2",
	    get: function get() {
	      return this.getNetChangeInCash(this.year2);
	    }
	  }, {
	    key: "netChangeInCash3",
	    get: function get() {
	      return this.getNetChangeInCash(this.year3);
	    }
	  }]);
	
	  return ResultsPanelCashFlows;
	}(_react.Component);
	
	exports.default = ResultsPanelCashFlows;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsPanelIncomeStatement = function (_Component) {
	  _inherits(ResultsPanelIncomeStatement, _Component);
	
	  function ResultsPanelIncomeStatement(props) {
	    _classCallCheck(this, ResultsPanelIncomeStatement);
	
	    var _this = _possibleConstructorReturn(this, (ResultsPanelIncomeStatement.__proto__ || Object.getPrototypeOf(ResultsPanelIncomeStatement)).call(this, props));
	
	    _this.state = {
	      gross_profit: {},
	      total_operating_costs: {},
	      net_income: {},
	      roundInUrl: props.roundInUrl
	    };
	    return _this;
	  }
	
	  _createClass(ResultsPanelIncomeStatement, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "getIncomeStatement",
	    value: function getIncomeStatement() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/report/income_statement/";
	      var url = base_url + "?round_lte=" + this.props.currentRound;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound) {
	        url = base_url + "?round_lte=" + this.state.roundInUrl;
	      }
	
	      return (0, _ApiService.getRequest)(url);
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this3 = this;
	
	      this.getIncomeStatement().then(function (res) {
	        var gross_profit = {};
	        var total_operating_costs = {};
	        var net_income = {};
	
	        res.body.forEach(function (item) {
	          var round_id = item.round;
	          var round = _this3.props.rounds.find(function (i) {
	            return i.id === round_id;
	          });
	          var round_number = round.number;
	
	          if (item["Gross Profit"]) {
	            gross_profit[round_number] = item["Gross Profit"];
	          }
	
	          if (item["Total Operating Costs"]) {
	            total_operating_costs[round_number] = item["Total Operating Costs"];
	          }
	
	          if (item["Net Income"]) {
	            net_income[round_number] = item["Net Income"];
	          }
	        });
	
	        _this3.setState({
	          gross_profit: gross_profit,
	          total_operating_costs: total_operating_costs,
	          net_income: net_income
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ResultsPanelIncomeStatement", "fetchData");
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "getYear",
	    value: function getYear(offset) {
	      var currentRound = this.props.currentRound;
	      var roundInUrl = this.state.roundInUrl;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      var rounds = [current_round, current_round + 1, current_round + 2];
	      if (current_round + 2 > this.props.rounds.length) {
	        current_round = this.props.rounds[this.props.rounds.length - 1].number;
	        rounds = [current_round - 2, current_round - 1, current_round];
	      }
	
	      return rounds[offset];
	    }
	  }, {
	    key: "getDataValue",
	    value: function getDataValue(key, year) {
	      if (key in this.state) {
	        var data = this.state[key];
	        if (year in data) {
	          return data[year];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getGrossProfit",
	    value: function getGrossProfit(year) {
	      return this.getDataValue("gross_profit", year);
	    }
	  }, {
	    key: "getOperatingProfit",
	    value: function getOperatingProfit(year) {
	      return this.getGrossProfit(year) + this.getDataValue("total_operating_costs", year);
	    }
	  }, {
	    key: "getNetIncome",
	    value: function getNetIncome(year) {
	      return this.getDataValue("net_income", year);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "table-responsive" },
	        _react2.default.createElement(
	          "table",
	          { className: "table" },
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement("span", null)
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year1
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year2
	                )
	              ),
	              _react2.default.createElement(
	                "th",
	                { className: "table-title text-center" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "YEAR ",
	                  this.year3
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Gross Profits"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.grossProfit1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.grossProfit2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.grossProfit3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Operating Profits"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.operatingProfit1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.operatingProfit2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.operatingProfit3,
	                  prefix: "$"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "tr",
	              { className: "text-center" },
	              _react2.default.createElement(
	                "th",
	                { className: "text-left" },
	                "Net Profits"
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.netIncome1,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.netIncome2,
	                  prefix: "$"
	                })
	              ),
	              _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                  value: this.netIncome3,
	                  prefix: "$"
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "year1",
	    get: function get() {
	      return this.getYear(0);
	    }
	  }, {
	    key: "year2",
	    get: function get() {
	      return this.getYear(1);
	    }
	  }, {
	    key: "year3",
	    get: function get() {
	      return this.getYear(2);
	    }
	  }, {
	    key: "grossProfit1",
	    get: function get() {
	      return this.getGrossProfit(this.year1);
	    }
	  }, {
	    key: "grossProfit2",
	    get: function get() {
	      return this.getGrossProfit(this.year2);
	    }
	  }, {
	    key: "grossProfit3",
	    get: function get() {
	      return this.getGrossProfit(this.year3);
	    }
	  }, {
	    key: "operatingProfit1",
	    get: function get() {
	      return this.getOperatingProfit(this.year1);
	    }
	  }, {
	    key: "operatingProfit2",
	    get: function get() {
	      return this.getOperatingProfit(this.year2);
	    }
	  }, {
	    key: "operatingProfit3",
	    get: function get() {
	      return this.getOperatingProfit(this.year3);
	    }
	  }, {
	    key: "netIncome1",
	    get: function get() {
	      return this.getNetIncome(this.year1);
	    }
	  }, {
	    key: "netIncome2",
	    get: function get() {
	      return this.getNetIncome(this.year2);
	    }
	  }, {
	    key: "netIncome3",
	    get: function get() {
	      return this.getNetIncome(this.year3);
	    }
	  }]);
	
	  return ResultsPanelIncomeStatement;
	}(_react.Component);
	
	exports.default = ResultsPanelIncomeStatement;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TabNavigation(props) {
	  var updateSidebar = props.updateSidebar,
	      currentUrl = props.currentUrl,
	      currentBaseUrl = props.currentBaseUrl,
	      roundInUrl = props.roundInUrl,
	      currentRound = props.currentRound,
	      isMobile = props.isMobile;
	
	
	  var suffix = "";
	  if (roundInUrl !== null && roundInUrl !== currentRound) {
	    suffix = "?round=" + roundInUrl;
	  }
	
	  var emptyClass = isMobile ? "col-xs-4" : "";
	  var activeClass = isMobile ? "active col-xs-4" : "active";
	  var navClass = isMobile ? "row text-center" : "nav-justified";
	
	  return _react2.default.createElement(
	    "ul",
	    { className: "nav nav-tabs " + navClass + " mb-20" },
	    _react2.default.createElement(
	      "li",
	      {
	        role: "presentation",
	        className: currentUrl === "IncomeStatement" ? activeClass : emptyClass
	      },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: "/" + currentBaseUrl + "/results/FinancialAnalysis" + suffix,
	          onClick: function onClick(e) {
	            return updateSidebar("IncomeStatement");
	          }
	        },
	        _react2.default.createElement(
	          "span",
	          null,
	          "Income Statement"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      {
	        role: "presentation",
	        className: currentUrl === "BalanceSheet" ? activeClass : emptyClass
	      },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: "/" + currentBaseUrl + "/results/FinancialAnalysis/BalanceSheet" + suffix,
	          onClick: function onClick(e) {
	            return updateSidebar("BalanceSheet");
	          }
	        },
	        _react2.default.createElement(
	          "span",
	          null,
	          "Balance Sheet"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      {
	        role: "presentation",
	        className: currentUrl === "CashFlow" ? activeClass : emptyClass
	      },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: "/" + currentBaseUrl + "/results/FinancialAnalysis/CashFlow" + suffix,
	          onClick: function onClick(e) {
	            return updateSidebar("CashFlow");
	          }
	        },
	        _react2.default.createElement(
	          "span",
	          null,
	          "Cash Flow"
	        )
	      )
	    )
	  );
	}
	
	exports.default = TabNavigation;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n'], ['\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  padding: 36px 40px;\n  text-align: center;\n  font-family: ', ';\n'], ['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  padding: 36px 40px;\n  text-align: center;\n  font-family: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n'], ['\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.72);\n  margin: 0 0 28px;\n'], ['\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.72);\n  margin: 0 0 28px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin: 0 auto 12px;\n  max-width: 480px;\n'], ['\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin: 0 auto 12px;\n  max-width: 480px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  flex: 1;\n  height: 12px;\n  border-radius: 999px;\n  background: ', ';\n  transition: background 200ms ease;\n  animation: ', ';\n\n  @keyframes progressStripe {\n    from { background-position: 0 0; }\n    to   { background-position: 32px 0; }\n  }\n'], ['\n  flex: 1;\n  height: 12px;\n  border-radius: 999px;\n  background: ', ';\n  transition: background 200ms ease;\n  animation: ', ';\n\n  @keyframes progressStripe {\n    from { background-position: 0 0; }\n    to   { background-position: 32px 0; }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 8px;\n  max-width: 480px;\n  margin: 0 auto 28px;\n'], ['\n  display: flex;\n  gap: 8px;\n  max-width: 480px;\n  margin: 0 auto 28px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-size: 12px;\n  line-height: 16px;\n  color: ', ';\n  font-weight: ', ';\n  text-align: center;\n'], ['\n  flex: 1;\n  font-size: 12px;\n  line-height: 16px;\n  color: ', ';\n  font-weight: ', ';\n  text-align: center;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  display: block;\n  margin: 8px auto 0;\n  padding: 6px 10px;\n  background: transparent;\n  border: none;\n  font-family: ', ';\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.55);\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover { color: rgba(0, 27, 59, 0.85); }\n'], ['\n  display: block;\n  margin: 8px auto 0;\n  padding: 6px 10px;\n  background: transparent;\n  border: none;\n  font-family: ', ';\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.55);\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover { color: rgba(0, 27, 59, 0.85); }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// End-of-round processing lock screen. Replaces the previous SweetAlert
	// "Currently processing round. Please be patient." warning.
	//
	// Trigger: mounted whenever App.js's isRoundProcessing is true. Once
	// mounted, the popup owns its own visibility via state.active so a
	// mid-flight fetchData that flips isRoundProcessing back to false
	// doesn't rip it away before the student clicks View Results.
	//
	// Progress:
	//   Polls /api/game/rounds/<round_id>/end-round-status/ on a decaying
	//   schedule (10s x3, 15s x2, 30s xN up to 5min, then stop). Response
	//   has 7 backend steps which we group into 3 UI stages:
	//     1. Closing the Round          -> before_end_round
	//     2. Processing Sales           -> allocate_round
	//     3. Generating Financial Reports -> end_round_reports, grade_round,
	//                                        performance_feedback,
	//                                        engagement_scoring,
	//                                        after_end_round
	//   404 ("This round has not been processed yet.") is treated as "all
	//   three stages pending" — keep polling.
	//
	// View Results click mirrors StudentResultsNotifications.viewResults:
	// PATCH course_members/{id}/viewed with rd{N}_viewed: true, then
	// changeLocation to the results-are-in flow.
	
	var STAGE_MAP = [{ title: 'Closing the Round', steps: ['before_end_round'] }, { title: 'Processing Sales', steps: ['allocate_round'] }, {
	  title: 'Generating Financial Reports',
	  steps: ['end_round_reports', 'grade_round', 'performance_feedback', 'engagement_scoring', 'after_end_round']
	}];
	
	var POLL_MAX_MS = 300000;
	var scheduleForElapsed = function scheduleForElapsed(elapsedMs) {
	  if (elapsedMs >= POLL_MAX_MS) return null;
	  if (elapsedMs < 30000) return 10000;
	  if (elapsedMs < 60000) return 15000;
	  return 30000;
	};
	
	// Detects a failure signal in the status response. Any of these count:
	//   - overall job status is 'failed' / 'error'
	//   - top-level error_message is non-empty
	//   - any individual step is 'failed' / 'error'
	// When triggered we silently freeze the popup at its current progress
	// per product decision — never surface backend failures to students.
	var hasFailure = function hasFailure(body) {
	  if (!body) return false;
	  var jobStatus = String(body.status || '').toLowerCase();
	  if (jobStatus === 'failed' || jobStatus === 'error') return true;
	  if (body.error_message) return true;
	  var steps = Array.isArray(body.steps) ? body.steps : [];
	  return steps.some(function (s) {
	    var st = String(s && s.status || '').toLowerCase();
	    return st === 'failed' || st === 'error';
	  });
	};
	
	// Group the flat BE step array into a 3-stage view. Each stage:
	//   status: 'done'    -> every constituent step is done
	//   status: 'running' -> at least one step is running, or any is done
	//                        without all being done (partial progress)
	//   status: 'pending' -> every step pending / missing
	var groupSteps = function groupSteps(steps) {
	  var byName = {};
	  (steps || []).forEach(function (s) {
	    if (s && s.name) byName[s.name] = s.status;
	  });
	  return STAGE_MAP.map(function (stage) {
	    var statuses = stage.steps.map(function (n) {
	      return byName[n] || 'pending';
	    });
	    var allDone = statuses.every(function (s) {
	      return s === 'done';
	    });
	    var anyRunning = statuses.some(function (s) {
	      return s === 'running';
	    });
	    var anyDone = statuses.some(function (s) {
	      return s === 'done';
	    });
	    var status = void 0;
	    if (allDone) status = 'done';else if (anyRunning || anyDone) status = 'running';else status = 'pending';
	    return { title: stage.title, status: status };
	  });
	};
	
	var FONT = "'Mukta Vaani', sans-serif";
	
	var Backdrop = _styledComponents2.default.div(_templateObject);
	
	var Card = _styledComponents2.default.div(_templateObject2, FONT);
	
	var Title = _styledComponents2.default.h2(_templateObject3);
	
	var Subtitle = _styledComponents2.default.p(_templateObject4);
	
	var StepperRow = _styledComponents2.default.div(_templateObject5);
	
	// Each stage renders as a rounded segment. Fills teal when done, shows
	// a soft striped/pulsing fill while running, stays grey when pending.
	var stripeAnimation = 'progressStripe 1.2s linear infinite';
	var Segment = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.status === 'done' ? '#52C5CD' : p.status === 'running' ? 'repeating-linear-gradient(45deg, #52C5CD, #52C5CD 8px, #B8E5E9 8px, #B8E5E9 16px)' : '#E5E9F0';
	}, function (p) {
	  return p.status === 'running' ? stripeAnimation : 'none';
	});
	
	var StageLabels = _styledComponents2.default.div(_templateObject7);
	
	var StageLabel = _styledComponents2.default.div(_templateObject8, function (p) {
	  return p.status === 'pending' ? 'rgba(0, 27, 59, 0.4)' : 'rgba(0, 27, 59, 0.7)';
	}, function (p) {
	  return p.status === 'done' ? 600 : 500;
	});
	
	// Escape hatch for students who don't want to sit through the wait.
	// The popup dismisses itself once processing completes (see auto-
	// dismiss in componentDidUpdate) so there's no primary action button
	// here — StudentResultsNotifications takes over with the "Round N
	// Results Ready to Review" popup and its View Results button.
	var LogoutLink = _styledComponents2.default.button(_templateObject9, FONT);
	
	var RoundProcessingPopup = function (_PureComponent) {
	  _inherits(RoundProcessingPopup, _PureComponent);
	
	  function RoundProcessingPopup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoundProcessingPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoundProcessingPopup.__proto__ || Object.getPrototypeOf(RoundProcessingPopup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // Owns visibility once mounted so an isRoundProcessing race can't
	      // rip the popup away mid-flight. Auto-dismisses when the two-source
	      // done check clears (overall_percent === 100 AND round.is_finished
	      // === true) — at that point StudentResultsNotifications fires with
	      // its own "Round N Results Ready to Review" popup.
	      active: !!_this.props.isRoundProcessing,
	      stages: STAGE_MAP.map(function (s) {
	        return { title: s.title, status: 'pending' };
	      }),
	      overallPercent: 0,
	      jobStatus: null // 'running' | 'done' | 'error' | null
	    }, _this.pollTimer = null, _this.dismissTimer = null, _this.dismissAttempts = 0, _this.startedAt = 0, _this.isMounted_ = false, _this.clearPollTimer = function () {
	      if (_this.pollTimer) {
	        clearTimeout(_this.pollTimer);
	        _this.pollTimer = null;
	      }
	    }, _this.clearDismissTimer = function () {
	      if (_this.dismissTimer) {
	        clearTimeout(_this.dismissTimer);
	        _this.dismissTimer = null;
	      }
	    }, _this.beginPolling = function () {
	      _this.startedAt = Date.now();
	      // Small initial delay before the first status call. Guards against
	      // an instructor re-closing the round: at re-close moment the BE can
	      // briefly still return the previous run's 'succeeded'/100% state,
	      // which would trip our done detection and dismiss the popup on
	      // stale data. The popup still renders immediately with all-pending
	      // stages so students see the progress bar during the wait.
	      _this.pollTimer = setTimeout(_this.fetchStatus, 2000);
	    }, _this.scheduleNextPoll = function () {
	      var elapsed = Date.now() - _this.startedAt;
	      var nextDelay = scheduleForElapsed(elapsed);
	      if (nextDelay == null) return; // exceeded 5min, stop
	      _this.clearPollTimer();
	      _this.pollTimer = setTimeout(_this.fetchStatus, nextDelay);
	    }, _this.fetchStatus = function () {
	      var round = _this.props.round;
	
	      var roundId = round && round.id;
	      if (!roundId) {
	        // No round id to poll against. Keep re-checking in case props
	        // populate late.
	        _this.scheduleNextPoll();
	        return;
	      }
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.getRequest)(apiUrl + 'game/rounds/' + roundId + '/end-round-status/').then(function (res) {
	        if (!_this.isMounted_) return;
	        var body = res && res.body || {};
	        // Silent-freeze on backend failure: don't apply the response's
	        // stages/percent (which would show a regression or expose an
	        // error state), and don't schedule another poll. The popup
	        // holds whatever progress the previous successful poll rendered,
	        // and the View Results button stays disabled — the student
	        // never learns processing died on the server side, they just
	        // see the bar stuck partway.
	        if (hasFailure(body)) return;
	        var percent = Number(body.overall_percent) || 0;
	        _this.setState({
	          stages: groupSteps(body.steps),
	          overallPercent: percent,
	          jobStatus: body.status || null
	        });
	        // Treat any of these as "processing complete":
	        //   - status: 'done'       (documented)
	        //   - status: 'succeeded'  (what the BE actually returns on
	        //                           successful completion)
	        //   - overall_percent >= 100 (belt-and-suspenders — if the
	        //     status string drifts again the percent still stops us)
	        var jobStatusStr = String(body.status || '').toLowerCase();
	        var jobDone = jobStatusStr === 'done' || jobStatusStr === 'succeeded' || percent >= 100;
	        if (!jobDone) {
	          _this.scheduleNextPoll();
	        } else {
	          // Stop status polling, then defer the general-info refetch
	          // until end_date has passed by a few seconds — otherwise BE
	          // is likely to still return is_finished: false and the
	          // two-source dismissal gate keeps the popup stuck.
	          _this.scheduleDismissWhenReady();
	        }
	      }).catch(function (err) {
	        if (!_this.isMounted_) return;
	        // 404 = "This round has not been processed yet." — treat as
	        // "queued, all stages pending" and keep polling. Any other error
	        // also just schedules the next poll; we don't want to fail
	        // permanently on a transient blip. scheduleNextPoll enforces
	        // the 300s ceiling for 404s and errors just like it does for
	        // success responses — nothing here gets to poll forever.
	        _this.scheduleNextPoll();
	      });
	    }, _this.isJobDone = function () {
	      // Two-source gate — dismiss the popup only when the status endpoint
	      // says 100% AND App.js has already seen the round flip to
	      // is_finished=true. We delay the reload-data call after status
	      // reports done (see scheduleDismissWhenReady) so that by the time
	      // general-info is refetched, BE has committed is_finished. That
	      // lets this strict check stay in place and prevents dismissing
	      // before StudentResultsNotifications is ready to take over (its
	      // isRoundEnded needs end_date < now).
	      var round = _this.props.round;
	      var overallPercent = _this.state.overallPercent;
	
	      return overallPercent === 100 && round && round.is_finished === true;
	    }, _this.scheduleDismissWhenReady = function () {
	      if (_this.dismissTimer || _this.dismissAttempts > 0) return;
	      var round = _this.props.round;
	
	      var endDate = round && round.end_date ? new Date(round.end_date).getTime() : Date.now();
	      var scheduleAttempt = function scheduleAttempt(delay) {
	        _this.dismissTimer = setTimeout(function () {
	          _this.dismissTimer = null;
	          if (!_this.isMounted_ || !_this.state.active) return;
	          _this.dismissAttempts += 1;
	          (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	          _eventEmitter2.default.getInstance().trigger('reload-data');
	          if (_this.dismissAttempts < 3) {
	            scheduleAttempt(10000);
	          }
	        }, delay);
	      };
	      var initialDelay = Math.max(0, endDate + 10000 - Date.now());
	      scheduleAttempt(initialDelay);
	    }, _this.handleLogout = function () {
	      if (_Auth2.default.isUserAuthenticated()) {
	        _Auth2.default.deauthenticateUser();
	      }
	      (0, _Location.changeLocation)('/login');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoundProcessingPopup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isMounted_ = true;
	      if (this.state.active) {
	        this.beginPolling();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.isRoundProcessing && !prevProps.isRoundProcessing) {
	        this.setState({ active: true }, function () {
	          if (!_this2.pollTimer && _this2.startedAt === 0) _this2.beginPolling();
	        });
	      }
	      // Auto-dismiss the moment the two-source done gate flips true.
	      // Uses componentDidUpdate so we catch both paths that get us here:
	      //   - polling response updates state.overallPercent to 100
	      //   - App.js refetches general-info and props.round flips
	      //     is_finished to true
	      if (this.state.active && this.isJobDone()) {
	        this.clearPollTimer();
	        this.clearDismissTimer();
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({ active: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isMounted_ = false;
	      this.clearPollTimer();
	      this.clearDismissTimer();
	    }
	
	    // Called once when the status endpoint first reports done. Runs a
	    // retry ladder that refetches general-info at end_date + 10s, then
	    // again 10s later, then 10s later — 3 attempts, ~30s total. BE has
	    // been observed committing is_finished 5-10s past end_date on the
	    // round record, so a single refetch was landing before BE caught up.
	    // If is_finished flips during any attempt, componentDidUpdate's
	    // two-source gate dismisses the popup and clearDismissTimer cancels
	    // the remaining attempts. After 3 tries we give up and let the next
	    // natural fetchData tick catch it — never poll forever.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.active) return null;
	      var stages = this.state.stages;
	
	
	      return _react2.default.createElement(
	        Backdrop,
	        null,
	        _react2.default.createElement(
	          Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Title,
	            null,
	            'Round Results are processing.'
	          ),
	          _react2.default.createElement(
	            Subtitle,
	            null,
	            'It can take up to 5 minutes.'
	          ),
	          _react2.default.createElement(
	            StepperRow,
	            null,
	            stages.map(function (s) {
	              return _react2.default.createElement(Segment, { key: s.title, status: s.status });
	            })
	          ),
	          _react2.default.createElement(
	            StageLabels,
	            null,
	            stages.map(function (s) {
	              return _react2.default.createElement(
	                StageLabel,
	                { key: s.title, status: s.status },
	                s.title
	              );
	            })
	          ),
	          _react2.default.createElement(
	            LogoutLink,
	            { type: 'button', onClick: this.handleLogout },
	            'Logout'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RoundProcessingPopup;
	}(_react.PureComponent);
	
	exports.default = RoundProcessingPopup;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 24px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 24px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"], ["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    background: #a4d9b1;\n    border-color: #a4d9b1;\n    cursor: default;\n  }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    background: #a4d9b1;\n    border-color: #a4d9b1;\n    cursor: default;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.4);\n  }\n"], ["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.4);\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteral([""], [""]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  padding: 36px 40px;\n  font-family: 'Mukta Vaani', sans-serif;\n  text-align: center;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 560px;\n  padding: 36px 40px;\n  font-family: 'Mukta Vaani', sans-serif;\n  text-align: center;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: #2DA548;\n  color: #ffffff;\n  font-size: 34px;\n  line-height: 64px;\n  margin: 0 auto 20px;\n"], ["\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: #2DA548;\n  color: #ffffff;\n  font-size: 34px;\n  line-height: 64px;\n  margin: 0 auto 20px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.78);\n  margin: 0 0 24px;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.78);\n  margin: 0 0 24px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.78);\n  text-align: left;\n  margin-bottom: 8px;\n"], ["\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.78);\n  text-align: left;\n  margin-bottom: 8px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  margin-bottom: 28px;\n"], ["\n  display: flex;\n  gap: 8px;\n  margin-bottom: 28px;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 10px 14px;\n  background: #F1F4F8;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 10px 14px;\n  background: #F1F4F8;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 15px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  padding: 10px 16px;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover { background: #f5f6f7; }\n"], ["\n  flex: 0 0 auto;\n  padding: 10px 16px;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover { background: #f5f6f7; }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  padding: 10px 28px;\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n"], ["\n  padding: 10px 28px;\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 620px;\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 620px;\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  padding: 24px 32px 12px;\n  border-bottom: 1px solid #ECEDEF;\n"], ["\n  padding: 24px 32px 12px;\n  border-bottom: 1px solid #ECEDEF;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  padding: 20px 32px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  padding: 20px 32px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  white-space: pre-wrap;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  margin-bottom: 16px;\n  white-space: pre-wrap;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  margin: 4px 0 16px;\n  padding: 16px 20px;\n  background: #F1F4F8;\n  border-left: 3px solid #F4A93C;\n  border-radius: 8px;\n  white-space: pre-wrap;\n"], ["\n  margin: 4px 0 16px;\n  padding: 16px 20px;\n  background: #F1F4F8;\n  border-left: 3px solid #F4A93C;\n  border-radius: 8px;\n  white-space: pre-wrap;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  color: #1f6feb;\n  text-decoration: underline;\n\n  &:hover {\n    color: #0d5bc0;\n  }\n"], ["\n  color: #1f6feb;\n  text-decoration: underline;\n\n  &:hover {\n    color: #0d5bc0;\n  }\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  padding: 16px 24px;\n  border-top: 1px solid #ECEDEF;\n  background: #ffffff;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n"], ["\n  padding: 16px 24px;\n  border-top: 1px solid #ECEDEF;\n  background: #ffffff;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: #d34c4c;\n  margin-right: auto;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: #d34c4c;\n  margin-right: auto;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  .accept-tooltip {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    right: 0;\n    width: 300px;\n    padding: 12px 16px;\n    background: rgba(0, 27, 59, 0.94);\n    color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n    font-family: 'Mukta Vaani', sans-serif;\n    font-size: 16px;\n    line-height: 22px;\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n    pointer-events: none;\n    z-index: 20;\n  }\n\n  /* Small arrow pointing down at the Accept button. */\n  .accept-tooltip::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    right: 32px;\n    border: 6px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:hover .accept-tooltip,\n  &:focus-within .accept-tooltip {\n    visibility: visible;\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n\n  .accept-tooltip {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    right: 0;\n    width: 300px;\n    padding: 12px 16px;\n    background: rgba(0, 27, 59, 0.94);\n    color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n    font-family: 'Mukta Vaani', sans-serif;\n    font-size: 16px;\n    line-height: 22px;\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n    pointer-events: none;\n    z-index: 20;\n  }\n\n  /* Small arrow pointing down at the Accept button. */\n  .accept-tooltip::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    right: 32px;\n    border: 6px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:hover .accept-tooltip,\n  &:focus-within .accept-tooltip {\n    visibility: visible;\n    opacity: 1;\n  }\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: #1f6feb;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: #0d5bc0;\n  }\n"], ["\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: #1f6feb;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: #0d5bc0;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _SkillsBadgePopup = __webpack_require__(597);
	
	var _SkillsBadgePopup2 = _interopRequireDefault(_SkillsBadgePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Fetches the student's badge on mount from /badges/mine/. If a
	// pending badge exists (not consented, not revoked, not declined),
	// shows a three-step flow:
	//   1) Congratulations intro popup — Continue only
	//   2) Tour popup with the student_message body (URL stripped,
	//      "Here's your badge:" replaced with a "View your badge" link)
	//      + a View Badge button
	//   3) Skills Badge design popup — the shared SkillsBadgePopup
	//      driven by /v2/insights/mine/<surveyId>/, with Decline / Accept
	//      action buttons in the footer
	//
	// No dismiss affordance anywhere in the flow: the student must
	// commit to Accept or Decline. Until they do, the badge stays
	// pending on the BE and the flow re-appears on every login.
	// Accept → POST /badges/consent/<token>/ (publishes badge).
	// Decline → POST /badges/decline/<token>/ (opts out).
	
	/* Shared backdrop — dims everything below the topbar. */
	var Backdrop = _styledComponents2.default.div(_templateObject);
	
	/* Intro popup */
	
	var IntroCard = _styledComponents2.default.div(_templateObject2);
	
	var IntroTitle = _styledComponents2.default.h2(_templateObject3);
	
	var IntroActions = _styledComponents2.default.div(_templateObject4);
	
	var PrimaryButton = _styledComponents2.default.button(_templateObject5);
	
	var SecondaryButton = _styledComponents2.default.button(_templateObject6);
	
	var DeclineButton = (0, _styledComponents2.default)(SecondaryButton)(_templateObject7);
	
	/* Confirmation card — shown after Accept succeeds so the student
	   gets an in-app receipt with their public badge URL. Also mentions
	   the confirmation email so they know the same link is in their
	   inbox. */
	
	var ConfirmationCard = _styledComponents2.default.div(_templateObject8);
	
	var ConfirmationCheckmark = _styledComponents2.default.div(_templateObject9);
	
	var ConfirmationTitle = _styledComponents2.default.h2(_templateObject10);
	
	var ConfirmationDescription = _styledComponents2.default.p(_templateObject11);
	
	var UrlLabel = _styledComponents2.default.div(_templateObject12);
	
	var UrlRow = _styledComponents2.default.div(_templateObject13);
	
	/* Read-only text field the student can select to copy the URL
	   manually. Also styled to feel like a familiar "copy this" field. */
	var UrlField = _styledComponents2.default.input(_templateObject14);
	
	var CopyButton = _styledComponents2.default.button(_templateObject15);
	
	var ConfirmationActions = _styledComponents2.default.div(_templateObject16);
	
	var ViewButton = _styledComponents2.default.a(_templateObject17);
	
	/* Tour popup */
	
	var TourCard = _styledComponents2.default.div(_templateObject18);
	
	var TourHeader = _styledComponents2.default.div(_templateObject19);
	
	var TourTitle = _styledComponents2.default.h2(_templateObject20);
	
	var TourBody = _styledComponents2.default.div(_templateObject21);
	
	/* Paragraph inside the tour body. Preserves any single \n inside a
	   paragraph (e.g. the signature) via pre-wrap. Gap between paragraphs
	   is handled with margin-bottom instead of the raw \n\n. */
	var TourParagraph = _styledComponents2.default.div(_templateObject22);
	
	/* Highlighted resume-wording block — light gray card so the copy the
	   student can paste into LinkedIn / Handshake / résumé visually stands
	   out from the surrounding narrative. */
	var TourHighlightBox = _styledComponents2.default.div(_templateObject23);
	
	/* Inline external link (LinkedIn / Handshake). Kept subtle so it
	   doesn't compete with the primary "View your badge" affordance. */
	var TourExternalLink = _styledComponents2.default.a(_templateObject24);
	
	var TourFooter = _styledComponents2.default.div(_templateObject25);
	
	var ErrorMsg = _styledComponents2.default.div(_templateObject26);
	
	/* Wraps the Accept button so we can render a custom hover tooltip
	   explaining what accepting the badge unlocks. Native `title` would
	   render at the browser's default (< 16px) size — see the project's
	   hover-text convention. Custom CSS tooltip lets us honor the ≥16px
	   rule and gives us nicer styling. */
	var AcceptButtonWrap = _styledComponents2.default.span(_templateObject27);
	
	/* Inline "View your badge" link inside the tour body — styled as a
	   text link but implemented as a button for accessibility. */
	var ViewBadgeLink = _styledComponents2.default.button(_templateObject28);
	
	var StudentBadgesFlow = function (_PureComponent) {
	  _inherits(StudentBadgesFlow, _PureComponent);
	
	  function StudentBadgesFlow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StudentBadgesFlow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StudentBadgesFlow.__proto__ || Object.getPrototypeOf(StudentBadgesFlow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      badge: null,
	      checked: false,
	      tourOpen: false,
	      designOpen: false,
	      submitting: false,
	      error: null,
	      // Insights payload for the shared badge popup — fetched lazily
	      // the first time the design step opens.
	      insightsData: null,
	      insightsLoading: false,
	      insightsError: null,
	      // Populated after a successful Accept — holds the public_url and
	      // manage_url from the consent response so we can show them on the
	      // in-app confirmation screen.
	      consentResult: null,
	      copied: false
	    }, _this.fetchBadge = function () {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.getRequest)(apiUrl + "v2/badges/mine/").then(function (res) {
	        var body = res && res.body || {};
	        var badges = Array.isArray(body.badges) ? body.badges : [];
	        // Per the guide: 1 badge per student per course. Popup
	        // appears when the student hasn't consented AND hasn't
	        // declined — those are the two terminal states we skip.
	        var pending = badges.find(function (b) {
	          return !b.is_consented && !b.is_declined;
	        });
	        _this.setState({ badge: pending || null, checked: true });
	      }).catch(function () {
	        // Endpoint 404s / errors — no popup rather than a broken
	        // affordance. Student can still see badges elsewhere later.
	        _this.setState({ badge: null, checked: true });
	      });
	    }, _this.openTour = function () {
	      _this.setState({ tourOpen: true });
	    }, _this.openDesign = function () {
	      _this.setState({ designOpen: true, error: null });
	      if (!_this.state.insightsData && !_this.state.insightsLoading) {
	        _this.fetchInsights();
	      }
	    }, _this.fetchInsights = function () {
	      var badge = _this.state.badge;
	
	      var surveyId = badge && badge.survey_id;
	      if (!surveyId) {
	        _this.setState({ insightsError: "No survey linked to this badge" });
	        return;
	      }
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      _this.setState({ insightsLoading: true, insightsError: null });
	      (0, _ApiService.getRequest)(apiUrl + "v2/insights/mine/" + surveyId + "/").then(function (res) {
	        _this.setState({
	          insightsData: res && res.body || null,
	          insightsLoading: false
	        });
	      }).catch(function () {
	        _this.setState({
	          insightsLoading: false,
	          insightsError: "Unable to load badge"
	        });
	      });
	    }, _this.getStudentName = function () {
	      var user = _Auth2.default.getUser();
	      if (!user) return "";
	      var first = user.first_name || "";
	      var last = user.last_name || "";
	      return (first + " " + last).trim();
	    }, _this.getTeammateCount = function () {
	      var players = _Teams2.default.players() || [];
	      if (players.length === 0) return 0;
	      var myUserId = Number(_Auth2.default.getUserId());
	      return players.filter(function (p) {
	        return p && p.user && Number(p.user.id) !== myUserId;
	      }).length;
	    }, _this.approve = function () {
	      var _this$state = _this.state,
	          badge = _this$state.badge,
	          submitting = _this$state.submitting;
	
	      if (!badge || submitting) return;
	      _this.setState({ submitting: true, error: null });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.postRequest)(apiUrl + "v2/badges/consent/" + badge.consent_token + "/").send({}).then(function (res) {
	        var body = res && res.body || {};
	        _this.setState({
	          submitting: false,
	          tourOpen: false,
	          designOpen: false,
	          badge: Object.assign({}, badge, { is_consented: true }),
	          consentResult: {
	            public_url: body.public_url || null,
	            manage_url: body.manage_url || null
	          }
	        });
	      }).catch(function () {
	        _this.setState({
	          submitting: false,
	          error: "Couldn't publish your badge. Please try again."
	        });
	      });
	    }, _this.closeConfirmation = function () {
	      _this.setState({ consentResult: null, copied: false });
	    }, _this.copyUrl = function () {
	      var url = _this.state.consentResult && _this.state.consentResult.public_url;
	      if (!url) return;
	      var flash = function flash() {
	        _this.setState({ copied: true });
	        if (_this._copyTimeout) clearTimeout(_this._copyTimeout);
	        _this._copyTimeout = setTimeout(function () {
	          return _this.setState({ copied: false });
	        }, 2000);
	      };
	      if (navigator.clipboard && navigator.clipboard.writeText) {
	        navigator.clipboard.writeText(url).then(flash).catch(function () {});
	        return;
	      }
	      // Legacy fallback for older browsers without navigator.clipboard.
	      try {
	        var el = document.createElement("textarea");
	        el.value = url;
	        el.style.position = "fixed";
	        el.style.opacity = "0";
	        document.body.appendChild(el);
	        el.select();
	        document.execCommand("copy");
	        document.body.removeChild(el);
	        flash();
	      } catch (e) {/* swallow */}
	    }, _this.decline = function () {
	      var _this$state2 = _this.state,
	          badge = _this$state2.badge,
	          submitting = _this$state2.submitting;
	
	      if (!badge || submitting) return;
	      _this.setState({ submitting: true, error: null });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.postRequest)(apiUrl + "v2/badges/decline/" + badge.consent_token + "/").send({}).then(function () {
	        _this.setState({
	          submitting: false,
	          tourOpen: false,
	          designOpen: false,
	          badge: Object.assign({}, badge, { is_declined: true })
	        });
	      }).catch(function () {
	        _this.setState({
	          submitting: false,
	          error: "Couldn't decline your badge. Please try again."
	        });
	      });
	    }, _this.renderInlineLinks = function (text, keyPrefix) {
	      var LINK_MAP = {
	        LinkedIn: "https://www.linkedin.com/",
	        Handshake: "https://joinhandshake.com/"
	      };
	      var regex = /\b(LinkedIn|Handshake)\b/g;
	      var out = [];
	      var lastIndex = 0;
	      var match = void 0;
	      var n = 0;
	      // eslint-disable-next-line no-cond-assign
	      while ((match = regex.exec(text)) !== null) {
	        if (match.index > lastIndex) {
	          out.push(text.substring(lastIndex, match.index));
	        }
	        out.push(_react2.default.createElement(
	          TourExternalLink,
	          {
	            key: keyPrefix + "-lnk-" + n,
	            href: LINK_MAP[match[1]],
	            target: "_blank",
	            rel: "noopener noreferrer"
	          },
	          match[1]
	        ));
	        lastIndex = match.index + match[0].length;
	        n += 1;
	      }
	      if (lastIndex < text.length) {
	        out.push(text.substring(lastIndex));
	      }
	      return out;
	    }, _this.renderTourBody = function (message) {
	      var stripped = message.replace(/\s*https?:\/\/badges\.marketgames\.io\/consent\/[^\s]+/g, "");
	      var paragraphs = stripped.split(/\n\n+/).map(function (p) {
	        return p.trim();
	      }).filter(function (p) {
	        return p.length > 0;
	      });
	
	      if (paragraphs.length === 0) return stripped;
	
	      return paragraphs.map(function (p, i) {
	        var key = "p-" + i;
	
	        if (/Here's your badge:/i.test(p)) {
	          return _react2.default.createElement(
	            TourParagraph,
	            { key: key },
	            _react2.default.createElement(
	              ViewBadgeLink,
	              {
	                type: "button",
	                onClick: _this.openDesign
	              },
	              "View your badge"
	            )
	          );
	        }
	
	        if (/^Market Games Skills Badge, awarded to the top/i.test(p)) {
	          return _react2.default.createElement(
	            TourHighlightBox,
	            { key: key },
	            _this.renderInlineLinks(p, key)
	          );
	        }
	
	        return _react2.default.createElement(
	          TourParagraph,
	          { key: key },
	          _this.renderInlineLinks(p, key)
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StudentBadgesFlow, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchBadge();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this._copyTimeout) clearTimeout(this._copyTimeout);
	    }
	
	    // Direct fetch: badge.survey_id is authoritative for which survey's
	    // peer-feedback insights back this badge. Silently degrades if the
	    // call fails — the shared popup renders the snapshot summary text.
	
	
	    // Resolve the current student's display name from the cached user
	    // object populated by /users/<id>/get_info/. Falls back to empty
	    // string if the user isn't populated yet.
	
	
	    // Teammate count = current team's players minus self. Used as the
	    // radar's "% of teammates who commented on this skill" denominator.
	
	
	    // Replace inline "LinkedIn" / "Handshake" mentions with external
	    // link elements. Returns an array of strings and elements suitable
	    // for React 15 children (no Fragment needed).
	
	
	    // Renders the tour message body as a series of paragraphs. Three
	    // special paragraphs get bespoke treatment:
	    //   - "Here's your badge:" is replaced with a "View your badge"
	    //     button that opens the badge design popup. The consent URL
	    //     itself is stripped out first.
	    //   - The résumé-wording paragraph is wrapped in a highlight box so
	    //     the student can spot the copy-paste block at a glance.
	    //   - All other paragraphs render with inline LinkedIn / Handshake
	    //     mentions turned into external links.
	    // Falls back to the raw stripped message string if the message can't
	    // be split into paragraphs (defensive against instructor-customized
	    // copy that drops the double-newline structure).
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          badge = _state.badge,
	          tourOpen = _state.tourOpen,
	          designOpen = _state.designOpen,
	          submitting = _state.submitting,
	          error = _state.error,
	          insightsData = _state.insightsData,
	          insightsLoading = _state.insightsLoading,
	          insightsError = _state.insightsError,
	          consentResult = _state.consentResult,
	          copied = _state.copied;
	
	      // Confirmation screen — shown after a successful Accept. Checked
	      // BEFORE the terminal-state guard because badge.is_consented is
	      // also true at this point (patched in the approve success handler),
	      // and we still want to render the confirmation until the student
	      // explicitly dismisses it.
	
	      if (consentResult) {
	        var publicUrl = consentResult.public_url;
	        return _react2.default.createElement(
	          Backdrop,
	          null,
	          _react2.default.createElement(
	            ConfirmationCard,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              ConfirmationCheckmark,
	              { "aria-hidden": true },
	              "\u2713"
	            ),
	            _react2.default.createElement(
	              ConfirmationTitle,
	              null,
	              "Skills Badge Accepted!"
	            ),
	            _react2.default.createElement(
	              ConfirmationDescription,
	              null,
	              "Your Skills Badge is now live. We've also sent you the link by email so you can share it anytime."
	            ),
	            publicUrl && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                UrlLabel,
	                null,
	                "Your public badge URL"
	              ),
	              _react2.default.createElement(
	                UrlRow,
	                null,
	                _react2.default.createElement(UrlField, {
	                  type: "text",
	                  value: publicUrl,
	                  readOnly: true,
	                  onFocus: function onFocus(e) {
	                    return e.target.select();
	                  }
	                }),
	                _react2.default.createElement(
	                  CopyButton,
	                  {
	                    type: "button",
	                    onClick: this.copyUrl
	                  },
	                  copied ? "Copied!" : "Copy"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              ConfirmationActions,
	              null,
	              _react2.default.createElement(
	                SecondaryButton,
	                {
	                  type: "button",
	                  onClick: this.closeConfirmation
	                },
	                "Done"
	              ),
	              publicUrl && _react2.default.createElement(
	                ViewButton,
	                {
	                  href: publicUrl,
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                "View Badge"
	              )
	            )
	          )
	        );
	      }
	
	      // Nothing to prompt if no pending badge OR the badge is in a
	      // terminal state (guards against stale state after Approve /
	      // Decline while a race condition could re-render).
	      if (!badge) return null;
	      if (badge.is_consented || badge.is_declined) return null;
	
	      // Design popup takes highest priority — replaces the tour view
	      // once opened. Renders the shared SkillsBadgePopup with the
	      // student action buttons (Decline / Accept) in its footer slot.
	      if (designOpen) {
	        // React 15 has no Fragment — pass footer children as a keyed array.
	        var badgeFooter = [error && _react2.default.createElement(
	          ErrorMsg,
	          { key: "err" },
	          error
	        ), _react2.default.createElement(
	          DeclineButton,
	          {
	            key: "dc",
	            type: "button",
	            onClick: this.decline,
	            disabled: submitting
	          },
	          submitting ? "Working…" : "Decline, the Badge"
	        ), _react2.default.createElement(
	          AcceptButtonWrap,
	          { key: "ac" },
	          _react2.default.createElement(
	            PrimaryButton,
	            {
	              type: "button",
	              onClick: this.approve,
	              disabled: submitting
	            },
	            submitting ? "Working…" : "Accept the Skills Badge"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "accept-tooltip" },
	            "Once accepted, you'll receive an email with your Skills Badge link. Add it to LinkedIn or your r\xE9sum\xE9 to help you stand out for internships and jobs."
	          )
	        )];
	        // Merge the badge.snapshot fields into the insights payload so
	        // SkillsBadgePopup can read snapshot-only fields like
	        // instructor_last_name / course_institution. Insights fields
	        // take precedence when both sources have the same key.
	        var snapshot = badge && badge.snapshot || {};
	        var mergedData = Object.assign({}, snapshot, insightsData || {});
	        // Fallback for instructor_last_name + course_institution:
	        // general-info?position=student already ships data.user
	        // .course_instructor_last_name and .institution (persisted via
	        // Auth.setUserData). Use those when neither the badge snapshot
	        // nor /insights/mine/ populated the fields — no extra API call,
	        // just a local Auth read.
	        var authUser = _Auth2.default.getUser() || {};
	        if (!mergedData.instructor_last_name && authUser.course_instructor_last_name) {
	          mergedData.instructor_last_name = authUser.course_instructor_last_name;
	        }
	        if (!mergedData.course_institution && authUser.institution) {
	          mergedData.course_institution = authUser.institution;
	        }
	        return _react2.default.createElement(_SkillsBadgePopup2.default, {
	          open: true,
	          data: mergedData,
	          loading: insightsLoading,
	          error: insightsError,
	          studentName: this.getStudentName(),
	          teammateCount: this.getTeammateCount(),
	          footer: badgeFooter
	        });
	      }
	
	      // Tour: congratulations text with "View your badge" link inline.
	      // Only exit is Continue (opens the design popup).
	      if (tourOpen) {
	        var message = badge.student_message || "Congratulations on earning the Market Games Skills Badge!";
	        return _react2.default.createElement(
	          Backdrop,
	          null,
	          _react2.default.createElement(
	            TourCard,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              TourHeader,
	              null,
	              _react2.default.createElement(
	                TourTitle,
	                null,
	                "Market Games Skills Badge"
	              )
	            ),
	            _react2.default.createElement(
	              TourBody,
	              null,
	              this.renderTourBody(message)
	            ),
	            _react2.default.createElement(
	              TourFooter,
	              null,
	              _react2.default.createElement(
	                PrimaryButton,
	                { type: "button", onClick: this.openDesign },
	                "View Badge"
	              )
	            )
	          )
	        );
	      }
	
	      // Intro popup — no dismiss affordance; the student must click
	      // Continue to move forward. The badge stays pending on the BE
	      // until Accept / Decline, so the flow re-appears on re-login.
	      return _react2.default.createElement(
	        Backdrop,
	        null,
	        _react2.default.createElement(
	          IntroCard,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            IntroTitle,
	            null,
	            "Congratulations! You've earned the Market Games Skills Badge!"
	          ),
	          _react2.default.createElement(
	            IntroActions,
	            null,
	            _react2.default.createElement(
	              PrimaryButton,
	              { type: "button", onClick: this.openTour },
	              "Continue"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StudentBadgesFlow;
	}(_react.PureComponent);
	
	exports.default = StudentBadgesFlow;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n  font-family: 'Mukta Vaani', sans-serif;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n  font-family: 'Mukta Vaani', sans-serif;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"], ["\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.78);\n  margin: 0 0 24px;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.78);\n  margin: 0 0 24px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"], ["\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #248339; border-color: #248339; }\n  &:disabled { background: #a4d9b1; border-color: #a4d9b1; cursor: default; }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #248339; border-color: #248339; }\n  &:disabled { background: #a4d9b1; border-color: #a4d9b1; cursor: default; }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _InFlightDedup = __webpack_require__(393);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Results-Ready notification popup. Fires once at student login (via
	// props from App.js) if there's an un-viewed round or peer-eval whose
	// results are available.
	//
	// Priority (only one notification is shown per login):
	//   1. Round popup — for the student's current round.
	//      If current round has ENDED and rdN_viewed is false → show it.
	//      If current round has NOT ended, check the PRIOR round only:
	//        - Round 1 with no prior round → no popup.
	//        - Round 2+ with prior rd(N-1)_viewed false → show prior round.
	//      We deliberately don't cascade further back (e.g. Round 3 doesn't
	//      check Round 1 if Round 2 was viewed).
	//   2. Survey popup — only if no round popup was chosen this pass.
	//      Initial peer eval first, then final peer eval.
	//      Shows if the survey is past its `end` timestamp AND the matching
	//      viewed flag is false.
	//
	// Action:
	//   "View Results" click → PATCH /api/course_members/<id>/ with the
	//   relevant viewed flag set to true, then navigate:
	//     round   → /performance-feedback/results-are-in/round-team-score?round=N
	//     survey  → /peer-review
	//
	// Data sources:
	//   viewedResults, currentRound, rounds, courseMemberId  → props from App.js
	//   surveys                                              → fetched on mount
	
	var Backdrop = _styledComponents2.default.div(_templateObject);
	
	var Card = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h2(_templateObject3);
	
	var Description = _styledComponents2.default.p(_templateObject4);
	
	var Actions = _styledComponents2.default.div(_templateObject5);
	
	var PrimaryButton = _styledComponents2.default.button(_templateObject6);
	
	var StudentResultsNotifications = function (_PureComponent) {
	  _inherits(StudentResultsNotifications, _PureComponent);
	
	  function StudentResultsNotifications() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StudentResultsNotifications);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StudentResultsNotifications.__proto__ || Object.getPrototypeOf(StudentResultsNotifications)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      surveys: [],
	      surveysLoaded: false,
	      // Set of surveyIds where the student's own peer-score row has
	      // completion === true. Used to gate the peer-eval popup: if the
	      // student hasn't completed peer eval for a survey, the peer-review
	      // page would show its lock screen ("To unlock results, complete
	      // peer evaluation"), so the popup should stay silent.
	      completedSurveyIds: null,
	      submitting: false,
	      // True once "View Results" is clicked and the PATCH+navigate
	      // completes — prevents the popup from re-appearing in the same
	      // session while the local viewedResults prop still shows false
	      // (until the next general-info refresh updates App state).
	      dismissed: false
	    }, _this.waitForCourseId = function () {
	      return new Promise(function (resolve) {
	        var elapsed = 0;
	        var check = function check() {
	          var id = _Auth2.default.getCourseId();
	          if (id) return resolve(id);
	          elapsed += 100;
	          if (elapsed >= 5000) return resolve(0);
	          setTimeout(check, 100);
	        };
	        check();
	      });
	    }, _this.fetchSurveys = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var courseId, apiUrl;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.waitForCourseId();
	
	            case 2:
	              courseId = _context.sent;
	
	              if (courseId) {
	                _context.next = 6;
	                break;
	              }
	
	              _this.setState({ surveysLoaded: true });
	              return _context.abrupt("return");
	
	            case 6:
	              apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	              (0, _InFlightDedup.dedupedGet)(apiUrl + "v2/forms/surveys/?course=" + courseId).then(function (res) {
	                var body = res && res.body || {};
	                var list = Array.isArray(body) ? body : body.results || [];
	                // Defensive course filter — same pattern the onboarding uses,
	                // since the endpoint occasionally returns rows for other
	                // courses under the same account.
	                var filtered = list.filter(function (s) {
	                  return Number(s.course) === Number(courseId);
	                });
	                _this.setState({ surveys: filtered, surveysLoaded: true });
	                // Fetch each closed survey's peer-score to see whether the
	                // student themselves completed peer eval. If they didn't, the
	                // peer-review page shows its "complete peer evaluation" lock
	                // screen and the popup would send them nowhere useful.
	                _this.fetchCompletionForClosedSurveys(filtered);
	              }).catch(function () {
	                // Silent — no survey popup will fire without the survey list,
	                // but the round popup path still works.
	                _this.setState({ surveysLoaded: true, completedSurveyIds: new Set() });
	              });
	
	            case 8:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), _this.fetchCompletionForClosedSurveys = function (surveys) {
	      var closed = (surveys || []).filter(function (s) {
	        return _this.isSurveyClosed(s);
	      });
	      if (closed.length === 0) {
	        _this.setState({ completedSurveyIds: new Set() });
	        return;
	      }
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      // Students have permission on /v2/forms/feedbacks/ (their own
	      // feedback rows). The previous /v2/games/peer-score/<id>/ call
	      // was instructor-only and 403'd here, which silently suppressed
	      // the popup for every closed peer-eval. Mirror the Peer-Review
	      // page's completion rule: a survey counts as completed when the
	      // student has at least one feedback row for it AND none are
	      // completed === false. One request total instead of N.
	      (0, _InFlightDedup.dedupedGet)(apiUrl + "v2/forms/feedbacks/").then(function (res) {
	        var body = res && res.body || {};
	        var rows = Array.isArray(body) ? body : body.results || [];
	        var bySurvey = new Map();
	        rows.forEach(function (r) {
	          var sid = Number(r && r.survey);
	          if (!bySurvey.has(sid)) bySurvey.set(sid, []);
	          bySurvey.get(sid).push(r);
	        });
	        var completedSurveyIds = new Set(closed.filter(function (s) {
	          var list = bySurvey.get(Number(s.id)) || [];
	          if (list.length === 0) return false;
	          return list.every(function (r) {
	            return r.completed !== false;
	          });
	        }).map(function (s) {
	          return s.id;
	        }));
	        _this.setState({ completedSurveyIds: completedSurveyIds });
	      }).catch(function () {
	        _this.setState({ completedSurveyIds: new Set() });
	      });
	    }, _this.isSurveyClosed = function (survey) {
	      if (!survey || !survey.end) return false;
	      return new Date(survey.end).getTime() < Date.now();
	    }, _this.isRoundEnded = function (round) {
	      if (!round || !round.end_date) return false;
	      return new Date(round.end_date).getTime() < Date.now();
	    }, _this.pickNotification = function () {
	      var _this$props = _this.props,
	          viewedResults = _this$props.viewedResults,
	          currentRound = _this$props.currentRound,
	          rounds = _this$props.rounds;
	      var _this$state = _this.state,
	          surveys = _this$state.surveys,
	          surveysLoaded = _this$state.surveysLoaded,
	          completedSurveyIds = _this$state.completedSurveyIds;
	
	      if (!viewedResults) return null;
	
	      // --- Round check (priority 1) ---
	      // currentRound arrives as a NUMBER from App.js's getter, not the
	      // round object — so we look up the object in `rounds` by number
	      // to inspect its end_date / is_finished.
	      // Gate: skip the popup for any round whose results are locked
	      // (results_viewable === false). Clicking through would land on
	      // the performance-feedback lock screen ("The instructor has
	      // locked the results for this round.").
	      var isRoundResultsLocked = function isRoundResultsLocked(round) {
	        return round && round.results_viewable === false;
	      };
	      if (Array.isArray(rounds) && rounds.length > 0) {
	        var n = Number(currentRound);
	        var currentRoundObj = rounds.find(function (r) {
	          return Number(r.number) === n;
	        });
	        if (currentRoundObj) {
	          if (_this.isRoundEnded(currentRoundObj)) {
	            var field = "rd" + n + "_viewed";
	            if (viewedResults[field] === false && !isRoundResultsLocked(currentRoundObj)) {
	              return { type: 'round', number: n };
	            }
	          } else if (n > 1) {
	            var priorRound = rounds.find(function (r) {
	              return Number(r.number) === n - 1;
	            });
	            if (priorRound) {
	              var _field = "rd" + (n - 1) + "_viewed";
	              if (viewedResults[_field] === false && !isRoundResultsLocked(priorRound)) {
	                return { type: 'round', number: n - 1 };
	              }
	            }
	          }
	        }
	      }
	
	      // --- Survey check (priority 2) ---
	      // Final wins over initial. Once the final survey has closed, the
	      // initial popup is stale news — even if the initial was never
	      // reviewed, we only want to nudge the student toward the newest
	      // available survey. Initial only fires when the final hasn't
	      // closed yet (or doesn't exist for this course).
	      // Gate: skip the popup for any survey the student hasn't
	      // completed their own peer eval on — the peer-review page shows
	      // its "To unlock results, complete peer evaluation" lock in
	      // that case. Wait for completedSurveyIds to load before deciding.
	      if (surveysLoaded && surveys.length > 0 && completedSurveyIds !== null) {
	        var initial = surveys.find(function (s) {
	          return s && s.stage === 'initial';
	        });
	        var final = surveys.find(function (s) {
	          return s && s.stage === 'final';
	        });
	        var finalClosed = _this.isSurveyClosed(final);
	        if (finalClosed && viewedResults.final_survey_viewed === false && completedSurveyIds.has(final.id)) {
	          return { type: 'survey', which: 'final' };
	        }
	        if (!finalClosed && initial && _this.isSurveyClosed(initial) && viewedResults.initial_survey_viewed === false && completedSurveyIds.has(initial.id)) {
	          return { type: 'survey', which: 'initial' };
	        }
	      }
	
	      return null;
	    }, _this.titleFor = function (notif) {
	      if (notif.type === 'round') {
	        return "Round " + notif.number + " Results Ready to Review";
	      }
	      return notif.which === 'initial' ? 'Initial Peer Evaluation Ready to Review' : 'Final Peer Evaluation Ready to Review';
	    }, _this.descriptionFor = function (notif) {
	      if (notif.type === 'round') {
	        return "2 reports to check out. Start with the Performance Feedback to see how your team did and why any targets were missed. Then review the Team Reports to compare your moves against your competitors. Financial statements are included.";
	      }
	      // Same description for both initial and final peer evaluations.
	      return "See what your teammates appreciate about you and where they'd like to see you do more or less. Your results also include a peer score that may factor into your overall score.";
	    }, _this.redirectFor = function (notif) {
	      if (notif.type === 'round') {
	        return "/performance-feedback/results-are-in/round-team-score?round=" + notif.number;
	      }
	      return '/peer-review';
	    }, _this.fieldFor = function (notif) {
	      if (notif.type === 'round') return "rd" + notif.number + "_viewed";
	      return notif.which === 'initial' ? 'initial_survey_viewed' : 'final_survey_viewed';
	    }, _this.viewResults = function () {
	      var notif = _this.pickNotification();
	      if (!notif) return;
	      var courseMemberId = _this.props.courseMemberId;
	
	      if (!courseMemberId || _this.state.submitting) return;
	
	      _this.setState({ submitting: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var field = _this.fieldFor(notif);
	      var url = _this.redirectFor(notif);
	
	      (0, _ApiService.patchRequest)(apiUrl + "course_members/" + courseMemberId + "/viewed/").send(_defineProperty({}, field, true)).then(function () {
	        _this.setState({ submitting: false, dismissed: true });
	        (0, _Location.changeLocation)(url);
	      }).catch(function () {
	        // Navigate anyway — the student clicked View Results, we should
	        // honor that. The viewed flag will re-sync on next login if the
	        // PATCH silently succeeded server-side, or stay false and the
	        // popup will re-appear (better than a broken affordance).
	        _this.setState({ submitting: false, dismissed: true });
	        (0, _Location.changeLocation)(url);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StudentResultsNotifications, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchSurveys();
	    }
	
	    // Poll sessionStorage briefly for course_id. Same reason as
	    // peer-review's fix — general-info may still be in flight when this
	    // component mounts.
	
	
	    // Returns { type: 'round', number: N } or
	    //         { type: 'survey', which: 'initial'|'final' } or null.
	
	  }, {
	    key: "render",
	    value: function render() {
	      // While RoundProcessingPopup is on screen it owns the flow — showing
	      // this popup on top would double up on the "results ready" nudge
	      // and cover the progress bar. Once round.is_finished flips true,
	      // App.js's isRoundProcessing goes false → suppress lifts → this
	      // popup fires with its own View Results button as normal.
	      if (this.props.suppress) return null;
	      if (this.state.dismissed) return null;
	      var notif = this.pickNotification();
	      if (!notif) return null;
	
	      return _react2.default.createElement(
	        Backdrop,
	        null,
	        _react2.default.createElement(
	          Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Title,
	            null,
	            this.titleFor(notif)
	          ),
	          _react2.default.createElement(
	            Description,
	            null,
	            this.descriptionFor(notif)
	          ),
	          _react2.default.createElement(
	            Actions,
	            null,
	            _react2.default.createElement(
	              PrimaryButton,
	              {
	                type: "button",
	                onClick: this.viewResults,
	                disabled: this.state.submitting
	              },
	              this.state.submitting ? "Working…" : "View Results"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StudentResultsNotifications;
	}(_react.PureComponent);
	
	exports.default = StudentResultsNotifications;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _reactCustomScrollbars = __webpack_require__(955);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _modal = __webpack_require__(581);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderTeamMembers = function renderTeamMembers() {
	  return _react2.default.createElement(
	    "div",
	    { className: "step5__right" },
	    _Teams2.default.players().filter(function (player) {
	      return player.role !== "VI";
	    }).map(undefined.renderTeamPlayer)
	  );
	};
	
	var TeamProfilePage = function (_PureComponent) {
	  _inherits(TeamProfilePage, _PureComponent);
	
	  function TeamProfilePage(props) {
	    _classCallCheck(this, TeamProfilePage);
	
	    var _this = _possibleConstructorReturn(this, (TeamProfilePage.__proto__ || Object.getPrototypeOf(TeamProfilePage)).call(this, props));
	
	    _this.showModal = function () {
	      _this.setState({ show: true });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        show: false
	      }, function () {
	        if (_this.state.returnToGuide === true) {
	          _this.setState({
	            returnToGuide: false
	          });
	        }
	      });
	    };
	
	    _this.state = { show: false };
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(TeamProfilePage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("team-profile-modal-show", this.showModal);
	      this.eventemitter.on("team-profile-modal-hide", this.hideModal);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("team-profile-modal-show", this.showModal);
	      this.eventemitter.off("team-profile-modal-hide", this.hideModal);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var show = this.state.show;
	
	      var currentTeam = _Teams2.default.currentTeam();
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          onHide: this.hideModal,
	          dialogClassName: "getStarterModal feedback-modal",
	          backdrop: true,
	          backdropClassName: "feedback-backdrop"
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            _reactCustomScrollbars.Scrollbars,
	            { style: { height: "calc(100% - 60px)" } },
	            _react2.default.createElement(
	              "div",
	              { className: "steps" },
	              _react2.default.createElement(
	                "p",
	                { className: "steps__title" },
	                "Your Team: ",
	                currentTeam ? currentTeam.name : ""
	              ),
	              _react2.default.createElement(_modal.Step5, { renderTeamMembers: renderTeamMembers })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Footer,
	          { bsClass: "modal-footer modal-footer-my-profile" },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: "primary", onClick: this.hideModal },
	            "Close"
	          )
	        )
	      );
	    }
	  }, {
	    key: "roleKey",
	    get: function get() {
	      return _Auth2.default.getRole().toLowerCase();
	    }
	  }, {
	    key: "role",
	    get: function get() {
	      var role = this.roleKey;
	
	      if (role === "ceo") {
	        return "CEO";
	      } else if (role === "pd") {
	        return "Head of Product Development";
	      } else if (role === "pm") {
	        return "Head of Product Marketing";
	      } else if (role === "op") {
	        return "Head of Operations";
	      } else if (role === "fi") {
	        return "Head of Finance";
	      } else if (role === "vi") {
	        return "Viewer";
	      }
	
	      return "";
	    }
	  }]);
	
	  return TeamProfilePage;
	}(_react.PureComponent);
	
	exports.default = TeamProfilePage;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LandingPageLogo = __webpack_require__(392);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsTableContentsLayout(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$left_content = _ref.left_content,
	      left_content = _ref$left_content === undefined ? "" : _ref$left_content,
	      _ref$right_content = _ref.right_content,
	      right_content = _ref$right_content === undefined ? "" : _ref$right_content;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "team-reports-layout table-contents" },
	    _react2.default.createElement(
	      "div",
	      { className: "team-reports-logo without-border" },
	      _react2.default.createElement("img", { src: _LandingPageLogo2.default, alt: "logo" }),
	      _react2.default.createElement("div", { className: "orange-line" }),
	      _react2.default.createElement("div", { className: "green-line" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table-contents-inner-content clearfix" },
	      _react2.default.createElement(
	        "div",
	        { className: "left" },
	        left_content
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "right" },
	        right_content
	      )
	    )
	  );
	}
	
	exports.default = TeamReportsTableContentsLayout;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function changeSection(e, section) {
	  e.preventDefault();
	
	  var eventemitter = _eventEmitter2.default.getInstance();
	  eventemitter.trigger("team-reports-go-to-section", [section]);
	}
	
	function TeamReportsCard(_ref) {
	  var _ref$section = _ref.section,
	      section = _ref$section === undefined ? 1 : _ref$section,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$active = _ref.active,
	      active = _ref$active === undefined ? false : _ref$active;
	
	  var cardClassName = active === true ? "team-reports-card active" : "team-reports-card";
	
	  return _react2.default.createElement(
	    "a",
	    {
	      href: "/#",
	      className: cardClassName,
	      onClick: function onClick(e) {
	        changeSection(e, section);
	      }
	    },
	    _react2.default.createElement(
	      "span",
	      { className: "title" },
	      _react2.default.createElement(
	        "span",
	        { className: "title-inner" },
	        title
	      )
	    )
	  );
	}
	
	exports.default = TeamReportsCard;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _card = __webpack_require__(1358);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsLeftNavigation = function (_PureComponent) {
	  _inherits(TeamReportsLeftNavigation, _PureComponent);
	
	  function TeamReportsLeftNavigation(props) {
	    _classCallCheck(this, TeamReportsLeftNavigation);
	
	    var _this = _possibleConstructorReturn(this, (TeamReportsLeftNavigation.__proto__ || Object.getPrototypeOf(TeamReportsLeftNavigation)).call(this, props));
	
	    _this.changeSection = function (section) {
	      _this.setState({
	        section: section
	      });
	    };
	
	    _this.state = {
	      section: 1
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(TeamReportsLeftNavigation, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("team-reports-change-section", this.changeSection);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("team-reports-change-section", this.changeSection);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var section = this.state.section;
	
	
	      return _react2.default.createElement(
	        "aside",
	        { className: "aside aside-team-reports" },
	        _react2.default.createElement(
	          "div",
	          { className: "inner-sidebar" },
	          _react2.default.createElement(_card2.default, {
	            section: 1,
	            title: "MG Team Reports",
	            active: section === 1
	          }),
	          _react2.default.createElement(_card2.default, {
	            section: 2,
	            title: "Grades & Ranks",
	            active: section === 2
	          }),
	          _react2.default.createElement(_card2.default, {
	            section: 3,
	            title: "Financial Planning & Analysis",
	            active: section === 3
	          }),
	          _react2.default.createElement(_card2.default, {
	            section: 4,
	            title: "Market Analysis",
	            active: section === 4
	          }),
	          _react2.default.createElement(_card2.default, {
	            section: 5,
	            title: "Operational Analysis",
	            active: section === 5
	          }),
	          _react2.default.createElement(_card2.default, {
	            section: 6,
	            title: "Financing Analysis",
	            active: section === 6
	          }),
	          _react2.default.createElement(_card2.default, {
	            section: 7,
	            title: "Financial Reports",
	            active: section === 7
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsLeftNavigation;
	}(_react.PureComponent);
	
	exports.default = TeamReportsLeftNavigation;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Location = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsTopNavigation = function (_PureComponent) {
	  _inherits(TeamReportsTopNavigation, _PureComponent);
	
	  function TeamReportsTopNavigation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsTopNavigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsTopNavigation.__proto__ || Object.getPrototypeOf(TeamReportsTopNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.goHome = function (e) {
	      e.preventDefault();
	
	      var url = sessionStorage.getItem("previousLocation");
	      if (url && url !== "") {
	        (0, _Location.changeLocation)(url);
	      } else {
	        (0, _Location.goBack)();
	      }
	    }, _this.goToPrev = function (e) {
	      e.preventDefault();
	
	      var prevStep = _this.prevStep;
	
	      if (prevStep) {
	        _this.props.changeStep(prevStep.section, prevStep.step);
	      }
	    }, _this.goToNext = function (e) {
	      e.preventDefault();
	
	      var nextStep = _this.nextStep;
	
	      if (nextStep) {
	        _this.props.changeStep(nextStep.section, nextStep.step);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsTopNavigation, [{
	    key: "render",
	    value: function render() {
	      var prevStep = this.prevStep;
	      var nextStep = this.nextStep;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-top" },
	        _react2.default.createElement(
	          "a",
	          { href: "/#", className: "home-link", onClick: this.goHome },
	          _react2.default.createElement("i", { className: "fa fa-home" })
	        ),
	        prevStep && _react2.default.createElement(
	          "div",
	          { className: "team-reports-top-left-button" },
	          _react2.default.createElement(
	            "div",
	            { className: "team-reports-top-button" },
	            _react2.default.createElement(
	              "a",
	              { href: "/#", onClick: this.goToPrev },
	              _react2.default.createElement("i", { className: "fa fa-long-arrow-left" })
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "title" },
	              prevStep.title
	            )
	          )
	        ),
	        nextStep && _react2.default.createElement(
	          "div",
	          { className: "team-reports-top-right-button" },
	          _react2.default.createElement(
	            "div",
	            { className: "team-reports-top-button right" },
	            _react2.default.createElement(
	              "a",
	              { href: "/#", onClick: this.goToNext },
	              _react2.default.createElement("i", { className: "fa fa-long-arrow-right" })
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "title" },
	              nextStep.title
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "steps",
	    get: function get() {
	      var current_year = this.props.current_year;
	
	
	      return [{
	        section: 1,
	        step: 1,
	        title: "Intro Page"
	      }, {
	        section: 1,
	        step: 2,
	        title: "Table of Contents"
	      }, {
	        section: 2,
	        step: 1,
	        title: "Grade & Ranks"
	      }, {
	        section: 2,
	        step: 2,
	        title: "KPI Analysis"
	      }, {
	        section: 2,
	        step: 3,
	        title: current_year <= 4 ? "Market Share" : "Share Price"
	      }, {
	        section: 2,
	        step: 4,
	        title: current_year <= 4 ? "Revenues" : "Earnings Per Share"
	      }, {
	        section: 2,
	        step: 5,
	        title: current_year <= 4 ? "Gross Margins" : "Return on Invested Capital"
	      }, {
	        section: 2,
	        step: 6,
	        title: current_year <= 4 ? "Share Price" : "Return on Net Operating Assets"
	      }, {
	        section: 3,
	        step: 1,
	        title: "Financial Planning & Analysis"
	      }, {
	        section: 3,
	        step: 2,
	        title: "Financial Planning & Analysis 2"
	      }, {
	        section: 3,
	        step: 3,
	        title: "Financial Planning & Analysis 3"
	      }, {
	        section: 3,
	        step: 4,
	        title: "Income Statement"
	      }, {
	        section: 4,
	        step: 1,
	        title: "Market Analysis"
	      }, {
	        section: 4,
	        step: 2,
	        title: "Market Analysis 2"
	      }, {
	        section: 4,
	        step: 3,
	        title: "Market Analysis 3"
	      }, {
	        section: 4,
	        step: 4,
	        title: "Market Analysis 4"
	      }, {
	        section: 4,
	        step: 5,
	        title: "Market Analysis 5"
	      }, {
	        section: 5,
	        step: 1,
	        title: "Operational Analysis"
	      }, {
	        section: 5,
	        step: 2,
	        title: "Operational Analysis 2"
	      }, {
	        section: 5,
	        step: 3,
	        title: "Operational Analysis 3"
	      }, {
	        section: 5,
	        step: 4,
	        title: "Operational Analysis 4"
	      }, {
	        section: 6,
	        step: 1,
	        title: "Financing Analysis"
	      }, {
	        section: 6,
	        step: 2,
	        title: "Financing Analysis 2"
	      }, {
	        section: 6,
	        step: 3,
	        title: "Financing Analysis 3"
	      }, {
	        section: 6,
	        step: 4,
	        title: "Financing Analysis 4"
	      }, {
	        section: 7,
	        step: 1,
	        title: "Financial Results"
	      }, {
	        section: 7,
	        step: 2,
	        title: "Income Statement"
	      }, {
	        section: 7,
	        step: 3,
	        title: "Balance Sheet"
	      }, {
	        section: 7,
	        step: 4,
	        title: "Cash Flows"
	      }, {
	        section: 7,
	        step: 5,
	        title: "End of Report"
	      }];
	    }
	  }, {
	    key: "currentStepIndex",
	    get: function get() {
	      var _props = this.props,
	          section = _props.section,
	          step = _props.step;
	
	      var steps = this.steps;
	      var index = steps.findIndex(function (i) {
	        return i.section === section && i.step === step;
	      });
	
	      return index;
	    }
	  }, {
	    key: "prevStep",
	    get: function get() {
	      var index = this.currentStepIndex;
	      var steps = this.steps;
	
	      if (index === 0) {
	        return null;
	      }
	
	      return steps[index - 1];
	    }
	  }, {
	    key: "nextStep",
	    get: function get() {
	      var index = this.currentStepIndex;
	      var steps = this.steps;
	
	      if (index === steps.length - 1) {
	        return null;
	      }
	
	      return steps[index + 1];
	    }
	  }]);
	
	  return TeamReportsTopNavigation;
	}(_react.PureComponent);
	
	exports.default = TeamReportsTopNavigation;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1368);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1369);
	
	var _step4 = _interopRequireDefault(_step3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection1(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      _ref$rank_name = _ref.rank_name,
	      rank_name = _ref$rank_name === undefined ? "" : _ref$rank_name;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, { rank_name: rank_name });
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, null);
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection1;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1370);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1371);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1372);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1373);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(1374);
	
	var _step10 = _interopRequireDefault(_step9);
	
	var _step11 = __webpack_require__(1375);
	
	var _step12 = _interopRequireDefault(_step11);
	
	var _step13 = __webpack_require__(1376);
	
	var _step14 = _interopRequireDefault(_step13);
	
	var _step15 = __webpack_require__(1377);
	
	var _step16 = _interopRequireDefault(_step15);
	
	var _step17 = __webpack_require__(1378);
	
	var _step18 = _interopRequireDefault(_step17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection2(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      _ref$team_grade = _ref.team_grade,
	      team_grade = _ref$team_grade === undefined ? 0 : _ref$team_grade,
	      _ref$rank_name = _ref.rank_name,
	      rank_name = _ref$rank_name === undefined ? "" : _ref$rank_name,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? {} : _ref$data,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? {} : _ref$teams,
	      _ref$share_price = _ref.share_price,
	      share_price = _ref$share_price === undefined ? 0 : _ref$share_price,
	      _ref$current_year = _ref.current_year,
	      current_year = _ref$current_year === undefined ? 1 : _ref$current_year,
	      _ref$competition_metr = _ref.competition_metrics,
	      competition_metrics = _ref$competition_metr === undefined ? {} : _ref$competition_metr;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, { team_grade: team_grade, rank_name: rank_name });
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, { current_year: current_year });
	  }
	
	  if (step === 3) {
	    if (current_year <= 4) {
	      return _react2.default.createElement(_step14.default, { teams: teams, competition_metrics: competition_metrics });
	    }
	
	    return _react2.default.createElement(_step6.default, { data: data, teams: teams, share_price: share_price });
	  }
	
	  if (step === 4) {
	    if (current_year <= 4) {
	      return _react2.default.createElement(_step16.default, { teams: teams, competition_metrics: competition_metrics });
	    }
	
	    return _react2.default.createElement(_step8.default, { data: data, teams: teams });
	  }
	
	  if (step === 5) {
	    if (current_year <= 4) {
	      return _react2.default.createElement(_step18.default, { teams: teams, competition_metrics: competition_metrics });
	    }
	
	    return _react2.default.createElement(_step10.default, { data: data, teams: teams });
	  }
	
	  if (step === 6) {
	    if (current_year <= 4) {
	      return _react2.default.createElement(_step6.default, { data: data, teams: teams, share_price: share_price });
	    }
	
	    return _react2.default.createElement(_step12.default, { data: data, teams: teams });
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection2;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1379);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1380);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1381);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1382);
	
	var _step8 = _interopRequireDefault(_step7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection3(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      _ref$expectedNetProfi = _ref.expectedNetProfits,
	      expectedNetProfits = _ref$expectedNetProfi === undefined ? 0 : _ref$expectedNetProfi,
	      _ref$actualNetProfits = _ref.actualNetProfits,
	      actualNetProfits = _ref$actualNetProfits === undefined ? 0 : _ref$actualNetProfits,
	      _ref$netRevenues = _ref.netRevenues,
	      netRevenues = _ref$netRevenues === undefined ? 0 : _ref$netRevenues,
	      _ref$netProfits = _ref.netProfits,
	      netProfits = _ref$netProfits === undefined ? 0 : _ref$netProfits,
	      _ref$actual = _ref.actual,
	      actual = _ref$actual === undefined ? {} : _ref$actual,
	      _ref$expected = _ref.expected,
	      expected = _ref$expected === undefined ? {} : _ref$expected,
	      _ref$current_year = _ref.current_year,
	      current_year = _ref$current_year === undefined ? 0 : _ref$current_year,
	      incomeStatement = _ref.incomeStatement;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, null);
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, { actual: actual, expected: expected, current_year: current_year });
	  }
	
	  if (step === 3) {
	    return _react2.default.createElement(_step6.default, {
	      expectedNetProfits: expectedNetProfits,
	      actualNetProfits: actualNetProfits,
	      actual: actual,
	      expected: expected,
	      current_year: current_year
	    });
	  }
	
	  if (step === 4) {
	    return _react2.default.createElement(_step8.default, {
	      netRevenues: netRevenues,
	      netProfits: netProfits,
	      incomeStatement: incomeStatement,
	      current_year: current_year
	    });
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection3;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1383);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1384);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1385);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1386);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(1387);
	
	var _step10 = _interopRequireDefault(_step9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection4(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      incomeStatement = _ref.incomeStatement,
	      _ref$netRevenues = _ref.netRevenues,
	      netRevenues = _ref$netRevenues === undefined ? 0 : _ref$netRevenues,
	      _ref$costOfSales = _ref.costOfSales,
	      costOfSales = _ref$costOfSales === undefined ? 0 : _ref$costOfSales,
	      _ref$rndCosts = _ref.rndCosts,
	      rndCosts = _ref$rndCosts === undefined ? 0 : _ref$rndCosts,
	      _ref$promotionCosts = _ref.promotionCosts,
	      promotionCosts = _ref$promotionCosts === undefined ? 0 : _ref$promotionCosts,
	      _ref$sellingCosts = _ref.sellingCosts,
	      sellingCosts = _ref$sellingCosts === undefined ? 0 : _ref$sellingCosts,
	      _ref$current_year = _ref.current_year,
	      current_year = _ref$current_year === undefined ? 0 : _ref$current_year,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? {} : _ref$data,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? {} : _ref$teams,
	      _ref$total_demand = _ref.total_demand,
	      total_demand = _ref$total_demand === undefined ? {} : _ref$total_demand,
	      _ref$endingInventory = _ref.endingInventory,
	      endingInventory = _ref$endingInventory === undefined ? 0 : _ref$endingInventory;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, null);
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, {
	      data: data,
	      teams: teams,
	      total_demand: total_demand,
	      endingInventory: endingInventory
	    });
	  }
	
	  if (step === 3) {
	    return _react2.default.createElement(_step6.default, {
	      incomeStatement: incomeStatement,
	      netRevenues: netRevenues,
	      costOfSales: costOfSales,
	      current_year: current_year
	    });
	  }
	
	  if (step === 4) {
	    return _react2.default.createElement(_step8.default, {
	      incomeStatement: incomeStatement,
	      rndCosts: rndCosts,
	      promotionCosts: promotionCosts,
	      current_year: current_year
	    });
	  }
	
	  if (step === 5) {
	    return _react2.default.createElement(_step10.default, {
	      incomeStatement: incomeStatement,
	      sellingCosts: sellingCosts,
	      current_year: current_year
	    });
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection4;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1388);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1389);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1390);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1391);
	
	var _step8 = _interopRequireDefault(_step7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection5(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? {} : _ref$data,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? {} : _ref$teams,
	      _ref$costOfSales = _ref.costOfSales,
	      costOfSales = _ref$costOfSales === undefined ? 0 : _ref$costOfSales,
	      _ref$holdingCosts = _ref.holdingCosts,
	      holdingCosts = _ref$holdingCosts === undefined ? 0 : _ref$holdingCosts,
	      _ref$current_year = _ref.current_year,
	      current_year = _ref$current_year === undefined ? 0 : _ref$current_year,
	      incomeStatement = _ref.incomeStatement,
	      _ref$totalCosts = _ref.totalCosts,
	      totalCosts = _ref$totalCosts === undefined ? 0 : _ref$totalCosts,
	      _ref$avgMaterialCosts = _ref.avgMaterialCostsPerUnit,
	      avgMaterialCostsPerUnit = _ref$avgMaterialCosts === undefined ? 0 : _ref$avgMaterialCosts,
	      _ref$avgLaborCostsPer = _ref.avgLaborCostsPerUnit,
	      avgLaborCostsPerUnit = _ref$avgLaborCostsPer === undefined ? 0 : _ref$avgLaborCostsPer,
	      _ref$avgOverheadCosts = _ref.avgOverheadCostsPerUnit,
	      avgOverheadCostsPerUnit = _ref$avgOverheadCosts === undefined ? 0 : _ref$avgOverheadCosts;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, null);
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, { data: data, teams: teams, totalCosts: totalCosts });
	  }
	
	  if (step === 3) {
	    return _react2.default.createElement(_step6.default, {
	      avgMaterialCostsPerUnit: avgMaterialCostsPerUnit,
	      avgLaborCostsPerUnit: avgLaborCostsPerUnit,
	      avgOverheadCostsPerUnit: avgOverheadCostsPerUnit,
	      data: data
	    });
	  }
	
	  if (step === 4) {
	    return _react2.default.createElement(_step8.default, {
	      costOfSales: costOfSales,
	      holdingCosts: holdingCosts,
	      incomeStatement: incomeStatement,
	      current_year: current_year
	    });
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection5;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1392);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1393);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1394);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1395);
	
	var _step8 = _interopRequireDefault(_step7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection6(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      _ref$current_year = _ref.current_year,
	      current_year = _ref$current_year === undefined ? 0 : _ref$current_year,
	      incomeStatement = _ref.incomeStatement,
	      _ref$interestExpense = _ref.interestExpense,
	      interestExpense = _ref$interestExpense === undefined ? 0 : _ref$interestExpense,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? {} : _ref$data,
	      _ref$teams = _ref.teams,
	      teams = _ref$teams === undefined ? {} : _ref$teams,
	      metrics = _ref.metrics,
	      _ref$financeRaised = _ref.financeRaised,
	      financeRaised = _ref$financeRaised === undefined ? 0 : _ref$financeRaised,
	      _ref$returnedToInvest = _ref.returnedToInvestors,
	      returnedToInvestors = _ref$returnedToInvest === undefined ? 0 : _ref$returnedToInvest;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, null);
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, {
	      data: data,
	      teams: teams,
	      metrics: metrics,
	      financeRaised: financeRaised,
	      returnedToInvestors: returnedToInvestors
	    });
	  }
	
	  if (step === 3) {
	    return _react2.default.createElement(_step6.default, {
	      incomeStatement: incomeStatement,
	      current_year: current_year,
	      interestExpense: interestExpense
	    });
	  }
	
	  if (step === 4) {
	    return _react2.default.createElement(_step8.default, { incomeStatement: incomeStatement, current_year: current_year });
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection6;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _step = __webpack_require__(1396);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1397);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1398);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1399);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(1400);
	
	var _step10 = _interopRequireDefault(_step9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TeamReportsSection7(_ref) {
	  var _ref$step = _ref.step,
	      step = _ref$step === undefined ? 1 : _ref$step,
	      incomeStatement = _ref.incomeStatement,
	      balanceSheet = _ref.balanceSheet,
	      cashFlow = _ref.cashFlow,
	      _ref$current_year = _ref.current_year,
	      current_year = _ref$current_year === undefined ? 0 : _ref$current_year;
	
	  if (step === 1) {
	    return _react2.default.createElement(_step2.default, null);
	  }
	
	  if (step === 2) {
	    return _react2.default.createElement(_step4.default, { incomeStatement: incomeStatement, current_year: current_year });
	  }
	
	  if (step === 3) {
	    return _react2.default.createElement(_step6.default, { balanceSheet: balanceSheet, current_year: current_year });
	  }
	
	  if (step === 4) {
	    return _react2.default.createElement(_step8.default, { cashFlow: cashFlow, current_year: current_year });
	  }
	
	  if (step === 5) {
	    return _react2.default.createElement(_step10.default, null);
	  }
	
	  return null;
	}
	
	exports.default = TeamReportsSection7;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FEEDBACK_CONTENT = {
	  "market leader": "Bold, fearless, dominant, are a few words that come into mind. Keep performing at this high level and maintain your leadership. <b>#Boss</b>!",
	  "market challenger": "Great round! You've done a great job in challenging the leader. Next round, become the leader. <b>#Soon-to-be-Boss</b>",
	  "market climber": "Not bad! Keep climbing until you reach your full potential. <b>#Be-the-Boss</b>",
	  "market warrior": "Good battle! You fought the good fight. Now let's go win the war. Become the leader! <b>#Be-the-Boss</b>",
	  "market newbie": "Young Grasshopper, you have ways to go, but we will help you climb, to become a warrior to then challenge the leader. You will be a Master. <b>#Be-the-Boss</b>"
	};
	
	var TeamReportsSection1Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection1Step1, _PureComponent);
	
	  function TeamReportsSection1Step1() {
	    _classCallCheck(this, TeamReportsSection1Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection1Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection1Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection1Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, {
	        title: "MG Team Reports",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var team = _Teams2.default.currentTeam();
	      var team_name = team ? team.name : "";
	      var players = _Teams2.default.players().filter(function (i) {
	        return "user" in i && i.user;
	      });
	      var roles = {
	        CEO: "CEO",
	        PD: "Head of Product Management",
	        PM: "Head of Product Marketing",
	        OP: "Head of Operations",
	        FI: "Head of Finance",
	        VI: "Viewer"
	      };
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "b",
	          null,
	          team_name
	        ),
	        _react2.default.createElement("br", null),
	        players.map(function (player) {
	          return _react2.default.createElement(
	            "span",
	            { key: player.id },
	            player.user.username,
	            " - ",
	            roles[player.role],
	            _react2.default.createElement("br", null)
	          );
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var rank_name = this.props.rank_name;
	
	      var message = rank_name.toLowerCase() in FEEDBACK_CONTENT ? FEEDBACK_CONTENT[rank_name.toLowerCase()] : "";
	
	      return _react2.default.createElement(
	        "span",
	        { className: "team-reports-welcome-1" },
	        "You are",
	        _react2.default.createElement(
	          "span",
	          { className: "rank-name" },
	          rank_name
	        ),
	        _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: message } })
	      );
	    }
	  }]);
	
	  return TeamReportsSection1Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection1Step1;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tableContents = __webpack_require__(1357);
	
	var _tableContents2 = _interopRequireDefault(_tableContents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection1Step2 = function (_PureComponent) {
	  _inherits(TeamReportsSection1Step2, _PureComponent);
	
	  function TeamReportsSection1Step2() {
	    _classCallCheck(this, TeamReportsSection1Step2);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection1Step2.__proto__ || Object.getPrototypeOf(TeamReportsSection1Step2)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection1Step2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_tableContents2.default, {
	        title: "Table of Contents",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "1. Grading & Ranking",
	        _react2.default.createElement("br", null),
	        "2. Financial, Planning, & Analysis",
	        _react2.default.createElement("br", null),
	        "3. Marketing & Sales Analysis",
	        _react2.default.createElement("br", null),
	        "4. Operational Analysis",
	        _react2.default.createElement("br", null),
	        "5. Financing Analysis"
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Let's breakdown your performance",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "In this report, we first cover the metrics that drive your grades/ranks, and then analyze each of your core team's performance."
	      );
	    }
	  }]);
	
	  return TeamReportsSection1Step2;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection1Step2;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step1, _PureComponent);
	
	  function TeamReportsSection2Step1() {
	    _classCallCheck(this, TeamReportsSection2Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection2Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection2Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, {
	        title: "Grades & Ranks",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          rank_name = _props.rank_name,
	          team_grade = _props.team_grade;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "welcome-percent" },
	          team_grade.toFixed(2),
	          "%"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "welcome-rank" },
	          rank_name
	        )
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Your grade and ranking are driven by your relative",
	        _react2.default.createElement("br", null),
	        "performance on 4 key metrics.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about grading/ranking, please click here",
	        _react2.default.createElement("i", { className: "fa fa-long-arrow-right" }),
	        " ",
	        _react2.default.createElement(_link2.default, { title: "Grading", url: _TypeformUrls2.default.GRADING }),
	        "."
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step1;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneColumn = __webpack_require__(260);
	
	var _oneColumn2 = _interopRequireDefault(_oneColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step1, _PureComponent);
	
	  function TeamReportsSection2Step1() {
	    _classCallCheck(this, TeamReportsSection2Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection2Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection2Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_oneColumn2.default, {
	        title: "KPI Analysis - Metrics That Drive Grade & Ranking",
	        content: this.content
	      });
	    }
	  }, {
	    key: "content",
	    get: function get() {
	      var current_year = this.props.current_year;
	
	
	      if (current_year <= 4) {
	        return _react2.default.createElement(
	          "span",
	          null,
	          "1. Market Share",
	          _react2.default.createElement("br", null),
	          "2. Revenues",
	          _react2.default.createElement("br", null),
	          "3. Gross Margins",
	          _react2.default.createElement("br", null),
	          "4. Share Price"
	        );
	      }
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "1. Share Price",
	        _react2.default.createElement("br", null),
	        "2. Earnings Per Share",
	        _react2.default.createElement("br", null),
	        "3. Return on Invested Capital (ROIC)",
	        _react2.default.createElement("br", null),
	        "4. Return on Net Operating Assets (RNOA)"
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step1;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _horizontalBar = __webpack_require__(214);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step3 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step3, _PureComponent);
	
	  function TeamReportsSection2Step3() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection2Step3);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection2Step3.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step3)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection2Step3, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Share Price",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "SharePrice",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "Share Price")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var share_price = this.props.share_price;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Share Price is synonymous with the term stock price. It represents the price an investor will pay to own 1 share of a company. The higher the growth rate in the share price, the better.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "At the start of the competition, all teams started out with a share price of $",
	        share_price.toFixed(2),
	        ". Here's the formula for Share Price.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "SHARE PRICE =",
	          _react2.default.createElement(
	            "div",
	            { className: "formula" },
	            "YOUR BUSINESS VALUE",
	            _react2.default.createElement("hr", null),
	            "SHARES OUTSTANDING"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about what drives your share price, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "Share Price", url: _TypeformUrls2.default.STOCK_PRICE }),
	        _react2.default.createElement(_link2.default, {
	          title: "Business Valuation",
	          url: _TypeformUrls2.default.BUSINESS_VALUATION,
	          className: "link-with-margin"
	        }),
	        _react2.default.createElement(_link2.default, {
	          title: "Shares Outstanding",
	          url: _TypeformUrls2.default.SHARES_OUTSTANDING,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_horizontalBar2.default, { prefix: "$", data: this.SharePrice }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Share Price",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "xs"
	          }, _TypeformContent2.default.STOCK_PRICE))
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step3;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step3;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step4 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step4, _PureComponent);
	
	  function TeamReportsSection2Step4() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection2Step4);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection2Step4.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step4)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection2Step4, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Earnings Per Share (EPS)",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "EarningPerShare",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "Earnings Per Share")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "EPS is a very common metric that investors track to evaluate the performance of a company and assess the value of owning a share of the company. Investors expect the EPS to grow over time.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          _react2.default.createElement(
	            "div",
	            { className: "formula first-child" },
	            "AVERAGE EARNINGS",
	            _react2.default.createElement("br", null),
	            "PER SHARE (EPS)"
	          ),
	          "=",
	          _react2.default.createElement(
	            "div",
	            { className: "formula" },
	            "AVERAGE NET PROFITS",
	            _react2.default.createElement("hr", null),
	            "SHARES OUTSTANDING"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "How could you maximize your EPS?",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about EPS, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, {
	          title: "Earnings Per Share",
	          url: _TypeformUrls2.default.EARNINGS_PER_SHARE
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_verticalBar2.default, { prefix: "$", data: this.EarningPerShare }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Earnings Per Share",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "xs"
	          }, _TypeformContent2.default.EARNINGS_PER_SHARE))
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step4;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step4;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step5 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step5, _PureComponent);
	
	  function TeamReportsSection2Step5() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection2Step5);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection2Step5.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step5)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection2Step5, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Return on Invested Capital",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "ROIC",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "ROIC") * 100
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Investors use this metric to measure how well a business used its capital to generate profits. The higher the ROIC, the better.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "ROIC =",
	          _react2.default.createElement(
	            "div",
	            { className: "formula" },
	            "AVERAGE NET PROFITS",
	            _react2.default.createElement("hr", null),
	            "INVESTED CAPITAL"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "How could you maximize your ROIC?",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about ROIC, please click here \u2192",
	        _react2.default.createElement(_link2.default, {
	          title: "Return on Invested Capital",
	          url: _TypeformUrls2.default.ROIC,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.ROIC }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Return on Invested Capital",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "xs"
	          }, _TypeformContent2.default.ROIC_KPI))
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step5;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step5;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step6 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step6, _PureComponent);
	
	  function TeamReportsSection2Step6() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection2Step6);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection2Step6.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step6)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection2Step6, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Return on Net Operating Assets",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "RNOA",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "RNOA") * 100
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Investors use RNOA to measure how well a business uses its operating assets to generate operating profits. The higher the RNOA, the better. Here is the formula:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "RNOA =",
	          _react2.default.createElement(
	            "div",
	            { className: "formula" },
	            "AVERAGE OPERATING PROFITS",
	            _react2.default.createElement("hr", null),
	            "OPERATING ASSETS"
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about RNOA, please click here \u2192",
	        _react2.default.createElement(_link2.default, {
	          title: "Return on Net Operating Assets",
	          url: _TypeformUrls2.default.RNOA,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.RNOA }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Return on Net Operating Assets",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "xs"
	          }, _TypeformContent2.default.RNOA_KPI))
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step6;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step6;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _horizontalBar = __webpack_require__(214);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step7 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step7, _PureComponent);
	
	  function TeamReportsSection2Step7() {
	    _classCallCheck(this, TeamReportsSection2Step7);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection2Step7.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step7)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection2Step7, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Market Share",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "MarketShare",
	    get: function get() {
	      var _props = this.props,
	          teams = _props.teams,
	          competition_metrics = _props.competition_metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: competition_metrics[team_id] && competition_metrics[team_id]["MarketShare"] ? competition_metrics[team_id]["MarketShare"] * 100 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Market Share represents the percentage of total sales that your business has captured within a market within a period of time. It is calculated by taking your business sales and dividing it by the total of all sales.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "For example, if Apple sold 36 smartphones in 2017 and there were a total of 100 smartphones sold in 2017, then Apple held 36% market share (i.e. 36% = 36/100).",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "MARKET SHARE =",
	          _react2.default.createElement(
	            "div",
	            { className: "formula" },
	            "YOUR UNIT SALES",
	            _react2.default.createElement("hr", null),
	            "TOTAL INDUSTRY SALES"
	          )
	        )
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_horizontalBar2.default, { suffix: "%", data: this.MarketShare }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Market Share"
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step7;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step7;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _horizontalBar = __webpack_require__(214);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step8 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step8, _PureComponent);
	
	  function TeamReportsSection2Step8() {
	    _classCallCheck(this, TeamReportsSection2Step8);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection2Step8.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step8)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection2Step8, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Revenues",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "Revenues",
	    get: function get() {
	      var _props = this.props,
	          teams = _props.teams,
	          competition_metrics = _props.competition_metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: competition_metrics[team_id] && competition_metrics[team_id]["Revenues"] ? competition_metrics[team_id]["Revenues"] / 1000000 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Revenues are the total dollar sales that a business might generate within a period of time. It is calculated by taking the number of units sold multiplied by the selling price of each unit:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "REVENUES = UNIT SALES X UNIT SELLING PRICE"
	        )
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_horizontalBar2.default, {
	          prefix: "$",
	          suffix: "M",
	          precision: 3,
	          data: this.Revenues
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Revenues"
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step8;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step8;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection2Step9 = function (_PureComponent) {
	  _inherits(TeamReportsSection2Step9, _PureComponent);
	
	  function TeamReportsSection2Step9() {
	    _classCallCheck(this, TeamReportsSection2Step9);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection2Step9.__proto__ || Object.getPrototypeOf(TeamReportsSection2Step9)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection2Step9, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Gross Margins",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "GrossMargins",
	    get: function get() {
	      var _props = this.props,
	          teams = _props.teams,
	          competition_metrics = _props.competition_metrics;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: competition_metrics[team_id] && competition_metrics[team_id]["GrossMargins"] ? competition_metrics[team_id]["GrossMargins"] * 100 : 0
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Gross Margins is a percentage that measures the spread between the revenues that you generated from selling a product with the cost of producing that product.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "For example, if Apple generates a total of $100 in sales from selling the iPhone, but it cost Apple $30 to produce the iPhone, then iPhone's gross margin would be 70% (i.e. $100 - $30) / $100.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "GROSS MARGINS =",
	          _react2.default.createElement(
	            "div",
	            { className: "formula" },
	            "REVENUES - COST OF SALES",
	            _react2.default.createElement("hr", null),
	            "REVENUES"
	          )
	        )
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.GrossMargins }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Gross Margins"
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection2Step9;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection2Step9;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection3Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection3Step1, _PureComponent);
	
	  function TeamReportsSection3Step1() {
	    _classCallCheck(this, TeamReportsSection3Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection3Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection3Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection3Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, { title: this.title, right_content: this.right_content });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Financial Planning &",
	        _react2.default.createElement("br", null),
	        "Analysis"
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Did you meet expectations?"
	      );
	    }
	  }]);
	
	  return TeamReportsSection3Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection3Step1;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _varianceAnalysis = __webpack_require__(580);
	
	var _varianceAnalysis2 = _interopRequireDefault(_varianceAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection3Step2 = function (_PureComponent) {
	  _inherits(TeamReportsSection3Step2, _PureComponent);
	
	  function TeamReportsSection3Step2() {
	    _classCallCheck(this, TeamReportsSection3Step2);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection3Step2.__proto__ || Object.getPrototypeOf(TeamReportsSection3Step2)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection3Step2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Financing Planning and Analysis (FP&A) Page",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "FP&A is a process that many businesses perform periodically to evaluate how well management was able to meet expectations.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "In this game, the CEO sets expectation when s/he makes financial projections. Investors rely on those projections to derive a value of the business.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "The FP&A (to the right) is comparing your expected vs. actual Income Statement."
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props = this.props,
	          actual = _props.actual,
	          expected = _props.expected,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_varianceAnalysis2.default, {
	        actual: actual,
	        expected: expected,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection3Step2;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection3Step2;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _varianceAnalysis = __webpack_require__(580);
	
	var _varianceAnalysis2 = _interopRequireDefault(_varianceAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection3Step3 = function (_PureComponent) {
	  _inherits(TeamReportsSection3Step3, _PureComponent);
	
	  function TeamReportsSection3Step3() {
	    _classCallCheck(this, TeamReportsSection3Step3);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection3Step3.__proto__ || Object.getPrototypeOf(TeamReportsSection3Step3)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection3Step3, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Financial Planning and Analysis (FP&A) Page",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var team = _Teams2.default.currentTeam();
	      var team_name = team ? team.name : "";
	      var _props = this.props,
	          expectedNetProfits = _props.expectedNetProfits,
	          actualNetProfits = _props.actualNetProfits;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "In this round, your CEO expected Team ",
	        team_name,
	        " to generate net profits of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: expectedNetProfits,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        ", but Team ",
	        team_name,
	        " actually generated net profits of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: actualNetProfits,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        ".",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Was your expectation too bullish or bearish? Please investigate if you didn't meet or exceed expectations.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about FP&A, please view the following content",
	        _react2.default.createElement(_link2.default, {
	          title: "Financial Planning & Analysis",
	          url: _TypeformUrls2.default.FINANCIAL_ANALYSIS,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props2 = this.props,
	          actual = _props2.actual,
	          expected = _props2.expected,
	          current_year = _props2.current_year;
	
	
	      return _react2.default.createElement(_varianceAnalysis2.default, {
	        actual: actual,
	        expected: expected,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection3Step3;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection3Step3;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection3Step4 = function (_PureComponent) {
	  _inherits(TeamReportsSection3Step4, _PureComponent);
	
	  function TeamReportsSection3Step4() {
	    _classCallCheck(this, TeamReportsSection3Step4);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection3Step4.__proto__ || Object.getPrototypeOf(TeamReportsSection3Step4)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection3Step4, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Income Statement",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          netRevenues = _props.netRevenues,
	          netProfits = _props.netProfits;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "This is your Income Statement, which has 3 key sections:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "1. Gross Profits",
	        _react2.default.createElement("br", null),
	        "2. Operating Profits",
	        _react2.default.createElement("br", null),
	        "3. Net Profits",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "You generated Net Revenues of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: netRevenues,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "and Net Profits of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: netProfits,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        ".",
	        _react2.default.createElement("br", null),
	        "Let's analyze each department's impact on the Income Statement!",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about FP&A, please view the following content",
	        _react2.default.createElement(_link2.default, {
	          title: "Financial Planning & Analysis",
	          url: _TypeformUrls2.default.FINANCIAL_ANALYSIS,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props2 = this.props,
	          incomeStatement = _props2.incomeStatement,
	          current_year = _props2.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection3Step4;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection3Step4;

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection4Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection4Step1, _PureComponent);
	
	  function TeamReportsSection4Step1() {
	    _classCallCheck(this, TeamReportsSection4Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection4Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection4Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection4Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, {
	        title: "Market Analysis",
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Are you building what",
	        _react2.default.createElement("br", null),
	        "customers want? If so, are",
	        _react2.default.createElement("br", null),
	        "they buying your products?"
	      );
	    }
	  }]);
	
	  return TeamReportsSection4Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection4Step1;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _marketCapture = __webpack_require__(574);
	
	var _marketCapture2 = _interopRequireDefault(_marketCapture);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection4Step2 = function (_PureComponent) {
	  _inherits(TeamReportsSection4Step2, _PureComponent);
	
	  function TeamReportsSection4Step2() {
	    _classCallCheck(this, TeamReportsSection4Step2);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection4Step2.__proto__ || Object.getPrototypeOf(TeamReportsSection4Step2)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection4Step2, [{
	    key: "getDataValue",
	    value: function getDataValue(team_id, key) {
	      var data = this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      var val = data[team_id][key];
	
	      if (!val) {
	        return 0;
	      }
	
	      return val;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Market Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          total_demand = _props.total_demand,
	          endingInventory = _props.endingInventory;
	
	      var team = _Teams2.default.currentTeam();
	      var team_id = team ? team.id : 0;
	      var overallMarketDemand = ((Math.abs(this.getDataValue(team_id, "Units Sold Auto")) + Math.abs(this.getDataValue(team_id, "Units Sold Mobile"))) / total_demand.total * 100).toFixed(2);
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "In this round, the market demanded",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: total_demand.total,
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "units of image sensors, and your team was able to capture",
	        " ",
	        overallMarketDemand,
	        "% of the overall market demand. You had",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: endingInventory,
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "units of inventory remaining.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about what impacts your sales, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "STP", url: _TypeformUrls2.default.STP }),
	        _react2.default.createElement(_link2.default, {
	          title: "Marketing Mix",
	          url: _TypeformUrls2.default.MARKETING_MIX,
	          className: "link-with-margin"
	        }),
	        _react2.default.createElement(_link2.default, {
	          title: "Product Market Fit",
	          url: _TypeformUrls2.default.PRODUCT_MARKET_FIT,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "dataMobile",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var chartData = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        chartData.push({
	          team: teams[team_id],
	          value: Math.abs(_this2.getDataValue(team_id, "Units Sold Mobile"))
	        });
	      });
	
	      return chartData;
	    }
	  }, {
	    key: "dataAuto",
	    get: function get() {
	      var _this3 = this;
	
	      var teams = this.props.teams;
	
	      var chartData = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        chartData.push({
	          team: teams[team_id],
	          value: Math.abs(_this3.getDataValue(team_id, "Units Sold Auto"))
	        });
	      });
	
	      return chartData;
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var total_demand = this.props.total_demand;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "pt-30 pl-30 pr-30" },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "MARKET CAPTURE - MOBILE",
	            _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	              category: "Market Capture Mobile",
	              tooltipContent: "This section shows the # of units you were able to sell in the market in relation to your competitors.",
	              iconSize: "sm"
	            })
	          ),
	          _react2.default.createElement("hr", null)
	        ),
	        _react2.default.createElement(_marketCapture2.default, {
	          data: this.dataMobile,
	          totalDemand: total_demand.mobile
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "pt-30 pl-30 pr-30" },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "MARKET CAPTURE - AUTO",
	            _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	              category: "Market Capture Auto",
	              tooltipContent: "This section shows the # of units you were able to sell in the market in relation to your competitors.",
	              iconSize: "sm"
	            })
	          ),
	          _react2.default.createElement("hr", null)
	        ),
	        _react2.default.createElement(_marketCapture2.default, {
	          data: this.dataAuto,
	          totalDemand: total_demand.auto
	        })
	      );
	    }
	  }]);
	
	  return TeamReportsSection4Step2;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection4Step2;

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection4Step3 = function (_PureComponent) {
	  _inherits(TeamReportsSection4Step3, _PureComponent);
	
	  function TeamReportsSection4Step3() {
	    _classCallCheck(this, TeamReportsSection4Step3);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection4Step3.__proto__ || Object.getPrototypeOf(TeamReportsSection4Step3)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection4Step3, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Market Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          netRevenues = _props.netRevenues,
	          costOfSales = _props.costOfSales;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "u",
	          null,
	          "Financial Impact of Your Decisions"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Both Product Management and Marketing decisions impact the following line items:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Net Revenues:"
	        ),
	        " Your Net revenues of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: netRevenues,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "was driven by the attractiveness of your Marketing Mix in relation to your competitors.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Cost of Sales:"
	        ),
	        " Your Cost of Sales of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: costOfSales,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "was partly driven by the product feature quality. The higher the quality, the more expensive the materials that is needed to produce the product.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about what impacts your Gross Profits, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "STP", url: _TypeformUrls2.default.STP }),
	        _react2.default.createElement(_link2.default, {
	          title: "Marketing Mix",
	          url: _TypeformUrls2.default.MARKETING_MIX,
	          className: "link-with-margin"
	        }),
	        _react2.default.createElement(_link2.default, {
	          title: "Product Market Fit",
	          url: _TypeformUrls2.default.PRODUCT_MARKET_FIT,
	          className: "link-with-margin"
	        }),
	        _react2.default.createElement(_link2.default, {
	          title: "Product Costs",
	          url: _TypeformUrls2.default.PRODUCT_COSTS,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props2 = this.props,
	          incomeStatement = _props2.incomeStatement,
	          current_year = _props2.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection4Step3;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection4Step3;

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection4Step4 = function (_PureComponent) {
	  _inherits(TeamReportsSection4Step4, _PureComponent);
	
	  function TeamReportsSection4Step4() {
	    _classCallCheck(this, TeamReportsSection4Step4);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection4Step4.__proto__ || Object.getPrototypeOf(TeamReportsSection4Step4)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection4Step4, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Market Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          rndCosts = _props.rndCosts,
	          promotionCosts = _props.promotionCosts;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "u",
	          null,
	          "Financial Impact of Your Decisions"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Both Product Management and Marketing decisions also impact the following line items:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "R&D Costs:"
	        ),
	        " Your R&D Costs of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: rndCosts,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "was driven by the quality of the product features and the number of products designed by your Head of Product Management.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Promotion Costs:"
	        ),
	        " Your Promotion Costs of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: promotionCosts,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "was driven by the amount that your Head of Product Marketing spent on creating awareness.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about what impacts these Operating Expenses, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "Marketing Mix", url: _TypeformUrls2.default.MARKETING_MIX })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props2 = this.props,
	          incomeStatement = _props2.incomeStatement,
	          current_year = _props2.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection4Step4;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection4Step4;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection4Step5 = function (_PureComponent) {
	  _inherits(TeamReportsSection4Step5, _PureComponent);
	
	  function TeamReportsSection4Step5() {
	    _classCallCheck(this, TeamReportsSection4Step5);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection4Step5.__proto__ || Object.getPrototypeOf(TeamReportsSection4Step5)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection4Step5, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Market Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var sellingCosts = this.props.sellingCosts;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "u",
	          null,
	          "Financial Impact of Your Decisions"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Product Marketing decisions impact the following line items:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Selling Costs:"
	        ),
	        " Your Selling Costs of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: sellingCosts,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "was driven by the costs to sell to the customer. These costs are mainly sales commissions that are paid to sales representatives and/or distributors.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about what impacts these Operating Expenses, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "Marketing Mix", url: _TypeformUrls2.default.MARKETING_MIX })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props = this.props,
	          incomeStatement = _props.incomeStatement,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection4Step5;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection4Step5;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection5Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection5Step1, _PureComponent);
	
	  function TeamReportsSection5Step1() {
	    _classCallCheck(this, TeamReportsSection5Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection5Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection5Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection5Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, {
	        title: "Operational Analysis",
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "How productive are your",
	        _react2.default.createElement("br", null),
	        "assets?"
	      );
	    }
	  }]);
	
	  return TeamReportsSection5Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection5Step1;

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _productCosts = __webpack_require__(576);
	
	var _productCosts2 = _interopRequireDefault(_productCosts);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection5Step2 = function (_PureComponent) {
	  _inherits(TeamReportsSection5Step2, _PureComponent);
	
	  function TeamReportsSection5Step2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection5Step2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection5Step2.__proto__ || Object.getPrototypeOf(TeamReportsSection5Step2)).call.apply(_ref, [this].concat(args))), _this), _this.numberWithCommas = function (x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }, _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection5Step2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Operational Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var team = _Teams2.default.currentTeam();
	      var team_id = team ? team.id : 0;
	      var unitsProduced = this.numberWithCommas(this.getDataValue(team_id, "Units Produced"));
	      var avgUnitCost = this.getDataValue(team_id, "Average Unit Cost").toFixed(2);
	      var totalCosts = this.props.totalCosts;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "In this round, the Head of Operations produced ",
	        unitsProduced,
	        " units at a total production costs of $",
	        this.numberWithCommas(totalCosts.toFixed(0)),
	        ", which resulted in product unit costs of $",
	        avgUnitCost,
	        ". Your unit costs may vary if you have any inventory remaining from prior rounds.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "What drives your production costs?"
	      );
	    }
	  }, {
	    key: "productCosts",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        data.push({
	          team: teams[team_id],
	          value: _this2.getDataValue(team_id, "Average Unit Cost")
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(
	          "h5",
	          null,
	          "PRODUCT COSTS",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "sm"
	          }, _TypeformContent2.default.PRODUCT_COSTS))
	        ),
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement(
	          "div",
	          { className: "mt-15" },
	          _react2.default.createElement(_productCosts2.default, { data: this.productCosts })
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection5Step2;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection5Step2;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneColumn = __webpack_require__(260);
	
	var _oneColumn2 = _interopRequireDefault(_oneColumn);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection5Step3 = function (_PureComponent) {
	  _inherits(TeamReportsSection5Step3, _PureComponent);
	
	  function TeamReportsSection5Step3() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection5Step3);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection5Step3.__proto__ || Object.getPrototypeOf(TeamReportsSection5Step3)).call.apply(_ref, [this].concat(args))), _this), _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection5Step3, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_oneColumn2.default, { title: "Operational Analysis", content: this.content });
	    }
	  }, {
	    key: "content",
	    get: function get() {
	      var team = _Teams2.default.currentTeam();
	      var team_id = team ? team.id : 0;
	      var unitsProduced = this.getDataValue(team_id, "Units Produced");
	      var _props = this.props,
	          avgMaterialCostsPerUnit = _props.avgMaterialCostsPerUnit,
	          avgLaborCostsPerUnit = _props.avgLaborCostsPerUnit,
	          avgOverheadCostsPerUnit = _props.avgOverheadCostsPerUnit;
	
	
	      avgMaterialCostsPerUnit /= unitsProduced;
	      avgLaborCostsPerUnit /= unitsProduced;
	      avgOverheadCostsPerUnit /= unitsProduced;
	
	      avgMaterialCostsPerUnit = Number(avgMaterialCostsPerUnit.toFixed(2));
	      avgLaborCostsPerUnit = Number(avgLaborCostsPerUnit.toFixed(2));
	      avgOverheadCostsPerUnit = Number(avgOverheadCostsPerUnit.toFixed(2));
	
	      if (!isFinite(avgMaterialCostsPerUnit)) {
	        avgMaterialCostsPerUnit = 0;
	      }
	
	      if (!isFinite(avgLaborCostsPerUnit)) {
	        avgLaborCostsPerUnit = 0;
	      }
	
	      if (!isFinite(avgOverheadCostsPerUnit)) {
	        avgOverheadCostsPerUnit = 0;
	      }
	
	      var avgProductsUnitCosts = (avgMaterialCostsPerUnit + avgLaborCostsPerUnit + avgOverheadCostsPerUnit).toFixed(2);
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "Direct Materials, Labor, and Overhead drives your product costs. The costs below is a breakdown of the average unit costs of all your products.",
	        _react2.default.createElement(
	          "div",
	          { className: "team-reports-operational-analysis" },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "td",
	                  { className: "price" },
	                  "$",
	                  avgMaterialCostsPerUnit.toFixed(2)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  "+"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "price" },
	                  "$",
	                  avgLaborCostsPerUnit.toFixed(2)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  "+"
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "price" },
	                  "$",
	                  avgOverheadCostsPerUnit.toFixed(2)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  null,
	                  "="
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "price" },
	                  "$",
	                  avgProductsUnitCosts
	                )
	              ),
	              _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                  "td",
	                  { className: "price-description" },
	                  "Material",
	                  _react2.default.createElement("br", null),
	                  "Costs Per Unit"
	                ),
	                _react2.default.createElement("td", null),
	                _react2.default.createElement(
	                  "td",
	                  { className: "price-description" },
	                  "Labor",
	                  _react2.default.createElement("br", null),
	                  "Costs Per Unit"
	                ),
	                _react2.default.createElement("td", null),
	                _react2.default.createElement(
	                  "td",
	                  { className: "price-description" },
	                  "Overhead",
	                  _react2.default.createElement("br", null),
	                  "Costs Per Unit"
	                ),
	                _react2.default.createElement("td", null),
	                _react2.default.createElement(
	                  "td",
	                  { className: "price-description" },
	                  "Product's",
	                  _react2.default.createElement("br", null),
	                  "Unit Costs"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("br", null),
	        "To learn more about what impacts these Operating Expenses, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "Product Costs", url: _TypeformUrls2.default.PRODUCT_COSTS })
	      );
	    }
	  }]);
	
	  return TeamReportsSection5Step3;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection5Step3;

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection5Step4 = function (_PureComponent) {
	  _inherits(TeamReportsSection5Step4, _PureComponent);
	
	  function TeamReportsSection5Step4() {
	    _classCallCheck(this, TeamReportsSection5Step4);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection5Step4.__proto__ || Object.getPrototypeOf(TeamReportsSection5Step4)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection5Step4, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Operational Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          costOfSales = _props.costOfSales,
	          holdingCosts = _props.holdingCosts;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "u",
	          null,
	          "Financial Impact of Your Decisions"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Operation decisions impact the following line items:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Cost of Sales (COS):"
	        ),
	        " Your COS of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: costOfSales,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "is the cost of the products that were sold (i.e. product costs).",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Holding Costs:"
	        ),
	        " Your holding costs of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: holdingCosts,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "is the costs of holding unsold inventory.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Gain or Loss of Sales:"
	        ),
	        " This non-operating costs is a result of selling your production lines (i.e. machines).",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about what impacts these Operating Expenses, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, { title: "Product Costs", url: _TypeformUrls2.default.PRODUCT_COSTS })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props2 = this.props,
	          incomeStatement = _props2.incomeStatement,
	          current_year = _props2.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection5Step4;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection5Step4;

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection6Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection6Step1, _PureComponent);
	
	  function TeamReportsSection6Step1() {
	    _classCallCheck(this, TeamReportsSection6Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection6Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection6Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection6Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, {
	        title: "Financing Analysis",
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "How risky is your capital?"
	      );
	    }
	  }]);
	
	  return TeamReportsSection6Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection6Step1;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _verticalBar = __webpack_require__(153);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection6Step2 = function (_PureComponent) {
	  _inherits(TeamReportsSection6Step2, _PureComponent);
	
	  function TeamReportsSection6Step2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamReportsSection6Step2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamReportsSection6Step2.__proto__ || Object.getPrototypeOf(TeamReportsSection6Step2)).call.apply(_ref, [this].concat(args))), _this), _this.numberWithCommas = function (x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }, _this.getDataValue = function (team_id, key) {
	      var data = _this.props.data;
	
	
	      if (!(team_id in data)) {
	        return 0;
	      }
	
	      if (!(key in data[team_id])) {
	        return 0;
	      }
	
	      return data[team_id][key] || 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TeamReportsSection6Step2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Financing Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var _props = this.props,
	          metrics = _props.metrics,
	          financeRaised = _props.financeRaised,
	          returnedToInvestors = _props.returnedToInvestors;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        "In this round, Head of Finance raised $",
	        this.numberWithCommas(financeRaised),
	        " in capital to finance the business and $",
	        this.numberWithCommas(returnedToInvestors),
	        " were returned to investors. As a result, your capital structure and cost of capital are now ",
	        metrics.debt,
	        "% debt / ",
	        metrics.equity,
	        "% equity and",
	        " ",
	        metrics.wacc,
	        "%, respectively.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "To learn more about Capital Structure and Cost of Capital, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, {
	          title: "Capital Structure",
	          url: _TypeformUrls2.default.CAPITAL_STRUCTURE
	        }),
	        _react2.default.createElement(_link2.default, {
	          title: "Cost of Capital",
	          url: _TypeformUrls2.default.COST_OF_CAPITAL,
	          className: "link-with-margin"
	        })
	      );
	    }
	  }, {
	    key: "CostOfCapital",
	    get: function get() {
	      var _this2 = this;
	
	      var teams = this.props.teams;
	
	      var data = [];
	
	      Object.keys(teams).forEach(function (team_id) {
	        var team = teams[team_id];
	        data.push({
	          name: team,
	          value: _this2.getDataValue(team_id, "Cost of Capital") * 100
	        });
	      });
	
	      return data;
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-valign-center" },
	        _react2.default.createElement(_verticalBar2.default, { suffix: "%", data: this.CostOfCapital }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-center", style: { marginTop: "-20px" } },
	          "Cost of Capital",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "xs"
	          }, _TypeformContent2.default.COST_OF_CAPITAL))
	        )
	      );
	    }
	  }]);
	
	  return TeamReportsSection6Step2;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection6Step2;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	var _link = __webpack_require__(84);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _TypeformUrls = __webpack_require__(76);
	
	var _TypeformUrls2 = _interopRequireDefault(_TypeformUrls);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection6Step3 = function (_PureComponent) {
	  _inherits(TeamReportsSection6Step3, _PureComponent);
	
	  function TeamReportsSection6Step3() {
	    _classCallCheck(this, TeamReportsSection6Step3);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection6Step3.__proto__ || Object.getPrototypeOf(TeamReportsSection6Step3)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection6Step3, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Financing Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      var interestExpense = this.props.interestExpense;
	
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "u",
	          null,
	          "Financial Impact of Your Decisions"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Finance impacts the following line items:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "- ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "Interest Expense:"
	        ),
	        " Your Interest Expense of",
	        " ",
	        _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	          value: interestExpense,
	          prefix: "$",
	          negativeClass: "title-red",
	          forceConvert: true
	        }),
	        " ",
	        "was driven by 2 things:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "1. The amount of money you borrowed from lenders",
	        _react2.default.createElement("br", null),
	        "2. The weighted average interest rate your lenders charged you",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { className: "formula" },
	          "Interest Expense = Money Borrowed x Interest Rates"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Lenders determine your interest rates based on your debt to capital ratio. To learn more about Debt to capital ratio, please review the following content:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_link2.default, {
	          title: "Debt to Capital",
	          url: _TypeformUrls2.default.DEBT_TO_CAPITAL
	        })
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props = this.props,
	          incomeStatement = _props.incomeStatement,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection6Step3;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection6Step3;

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twoColumns = __webpack_require__(69);
	
	var _twoColumns2 = _interopRequireDefault(_twoColumns);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection6Step4 = function (_PureComponent) {
	  _inherits(TeamReportsSection6Step4, _PureComponent);
	
	  function TeamReportsSection6Step4() {
	    _classCallCheck(this, TeamReportsSection6Step4);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection6Step4.__proto__ || Object.getPrototypeOf(TeamReportsSection6Step4)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection6Step4, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_twoColumns2.default, {
	        title: "Financing Analysis",
	        left_content: this.left_content,
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "left_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "u",
	          null,
	          "Financial Impact of Your Decisions"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Financing decisions also impact the value of your business. In later years (i.e. rounds), your business will be valued based on the DCF valuation approach.",
	        _react2.default.createElement("br", null),
	        "takes into account the following:",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "1. Expected Free Cash Flows",
	        _react2.default.createElement("br", null),
	        "2. Your Cost of Capital"
	      );
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      var _props = this.props,
	          incomeStatement = _props.incomeStatement,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year
	      });
	    }
	  }]);
	
	  return TeamReportsSection6Step4;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection6Step4;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection7Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection7Step1, _PureComponent);
	
	  function TeamReportsSection7Step1() {
	    _classCallCheck(this, TeamReportsSection7Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection7Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection7Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection7Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, {
	        title: "Financial Reports",
	        right_content: this.right_content
	      });
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "What is the end results?"
	      );
	    }
	  }]);
	
	  return TeamReportsSection7Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection7Step1;

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneColumn = __webpack_require__(260);
	
	var _oneColumn2 = _interopRequireDefault(_oneColumn);
	
	var _incomeStatement = __webpack_require__(139);
	
	var _incomeStatement2 = _interopRequireDefault(_incomeStatement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection7Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection7Step1, _PureComponent);
	
	  function TeamReportsSection7Step1() {
	    _classCallCheck(this, TeamReportsSection7Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection7Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection7Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection7Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_oneColumn2.default, { title: "Income Statement", content: this.content });
	    }
	  }, {
	    key: "content",
	    get: function get() {
	      var _props = this.props,
	          incomeStatement = _props.incomeStatement,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_incomeStatement2.default, {
	        incomeStatement: incomeStatement,
	        current_year: current_year,
	        className: "team-reports-with-scroll-2"
	      });
	    }
	  }]);
	
	  return TeamReportsSection7Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection7Step1;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneColumn = __webpack_require__(260);
	
	var _oneColumn2 = _interopRequireDefault(_oneColumn);
	
	var _balanceSheet = __webpack_require__(1196);
	
	var _balanceSheet2 = _interopRequireDefault(_balanceSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection7Step2 = function (_PureComponent) {
	  _inherits(TeamReportsSection7Step2, _PureComponent);
	
	  function TeamReportsSection7Step2() {
	    _classCallCheck(this, TeamReportsSection7Step2);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection7Step2.__proto__ || Object.getPrototypeOf(TeamReportsSection7Step2)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection7Step2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_oneColumn2.default, { title: "Balance Sheet", content: this.content });
	    }
	  }, {
	    key: "content",
	    get: function get() {
	      var _props = this.props,
	          balanceSheet = _props.balanceSheet,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_balanceSheet2.default, {
	        balanceSheet: balanceSheet,
	        current_year: current_year,
	        className: "team-reports-with-scroll-2"
	      });
	    }
	  }]);
	
	  return TeamReportsSection7Step2;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection7Step2;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneColumn = __webpack_require__(260);
	
	var _oneColumn2 = _interopRequireDefault(_oneColumn);
	
	var _cashFlow = __webpack_require__(1197);
	
	var _cashFlow2 = _interopRequireDefault(_cashFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection7Step3 = function (_PureComponent) {
	  _inherits(TeamReportsSection7Step3, _PureComponent);
	
	  function TeamReportsSection7Step3() {
	    _classCallCheck(this, TeamReportsSection7Step3);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection7Step3.__proto__ || Object.getPrototypeOf(TeamReportsSection7Step3)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection7Step3, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_oneColumn2.default, { title: "Cash Flow", content: this.content });
	    }
	  }, {
	    key: "content",
	    get: function get() {
	      var _props = this.props,
	          cashFlow = _props.cashFlow,
	          current_year = _props.current_year;
	
	
	      return _react2.default.createElement(_cashFlow2.default, {
	        cashFlow: cashFlow,
	        current_year: current_year,
	        className: "team-reports-with-scroll-2"
	      });
	    }
	  }]);
	
	  return TeamReportsSection7Step3;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection7Step3;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _welcome = __webpack_require__(155);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReportsSection7Step1 = function (_PureComponent) {
	  _inherits(TeamReportsSection7Step1, _PureComponent);
	
	  function TeamReportsSection7Step1() {
	    _classCallCheck(this, TeamReportsSection7Step1);
	
	    return _possibleConstructorReturn(this, (TeamReportsSection7Step1.__proto__ || Object.getPrototypeOf(TeamReportsSection7Step1)).apply(this, arguments));
	  }
	
	  _createClass(TeamReportsSection7Step1, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_welcome2.default, { title: "End of Report", right_content: this.right_content });
	    }
	  }, {
	    key: "right_content",
	    get: function get() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "That's it for now. All the best",
	        _react2.default.createElement("br", null),
	        "in the next round!"
	      );
	    }
	  }]);
	
	  return TeamReportsSection7Step1;
	}(_react.PureComponent);
	
	exports.default = TeamReportsSection7Step1;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  .knowledge-base-modal {\n    min-height: 500px !important;\n    width: 85vw !important;\n    height: 85vh !important;\n    top: 0 !important;\n\n    .modal-content {\n      height: 85vh !important;\n    }\n\n    .modal-body {\n      padding: 0 !important;\n      height: 100% !important;\n    }\n  }\n"], ["\n  .knowledge-base-modal {\n    min-height: 500px !important;\n    width: 85vw !important;\n    height: 85vh !important;\n    top: 0 !important;\n\n    .modal-content {\n      height: 85vh !important;\n    }\n\n    .modal-body {\n      padding: 0 !important;\n      height: 100% !important;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var IFRAME_REF = "typeform-iframe";
	
	var ModalWrapper = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject);
	
	var TypeformModal = function (_PureComponent) {
	  _inherits(TypeformModal, _PureComponent);
	
	  function TypeformModal(props) {
	    _classCallCheck(this, TypeformModal);
	
	    var _this = _possibleConstructorReturn(this, (TypeformModal.__proto__ || Object.getPrototypeOf(TypeformModal)).call(this, props));
	
	    _this.open = function (url) {
	      var additionalClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	      var iframeCustomStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      _this.setState({
	        url: url,
	        additionalClassName: additionalClassName,
	        iframeCustomStyle: iframeCustomStyle
	      }, function () {
	        _this.show();
	      });
	    };
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.hide = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.onEntered = function () {
	      _reactDom2.default.findDOMNode(_this.refs[IFRAME_REF]).focus();
	    };
	
	    _this.state = {
	      show: false,
	      url: "",
	      additionalClassName: "",
	      iframeCustomStyle: {}
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(TypeformModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("open-typeform-modal", this.open);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("open-typeform-modal", this.open);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          show = _state.show,
	          url = _state.url,
	          iframeCustomStyle = _state.iframeCustomStyle;
	
	      var iframeStyle = Object.assign({
	        width: "100%",
	        height: "500px"
	      }, iframeCustomStyle);
	
	      return _react2.default.createElement(
	        ModalWrapper,
	        {
	          backdrop: true,
	          dialogClassName: this.modalClassName,
	          show: show,
	          onHide: this.hide,
	          onEntered: this.onEntered
	        },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          url !== "" && _react2.default.createElement("iframe", { ref: IFRAME_REF, src: url, style: iframeStyle, title: "Typeform" })
	        )
	      );
	    }
	  }, {
	    key: "modalClassName",
	    get: function get() {
	      var additionalClassName = this.state.additionalClassName;
	
	
	      if (additionalClassName !== "") {
	        return "typeform-modal " + additionalClassName;
	      }
	
	      return "typeform-modal";
	    }
	  }]);
	
	  return TypeformModal;
	}(_react.PureComponent);
	
	exports.default = TypeformModal;

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HelpIconButtonWithTooltip = function (_Component) {
	  _inherits(HelpIconButtonWithTooltip, _Component);
	
	  function HelpIconButtonWithTooltip() {
	    _classCallCheck(this, HelpIconButtonWithTooltip);
	
	    return _possibleConstructorReturn(this, (HelpIconButtonWithTooltip.__proto__ || Object.getPrototypeOf(HelpIconButtonWithTooltip)).apply(this, arguments));
	  }
	
	  _createClass(HelpIconButtonWithTooltip, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactFontawesome2.default, {
	        className: "question-mark pointer" + (this.props.iconSize ? " question-mark-" + this.props.iconSize : ""),
	        style: { textDecoration: "none" },
	        name: "question-circle",
	        onClick: this.props.onClick
	      });
	    }
	  }]);
	
	  return HelpIconButtonWithTooltip;
	}(_react.Component);
	
	HelpIconButtonWithTooltip.propTypes = {
	  iconSize: _propTypes2.default.oneOf(["xs", "sm"])
	};
	
	exports.default = HelpIconButtonWithTooltip;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoadingIndicator(props) {
	  if (props.loading === true) {
	    return _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12" },
	        _react2.default.createElement(
	          "p",
	          { className: "text-center" },
	          "loading..."
	        )
	      )
	    );
	  }
	
	  return null;
	}
	
	exports.default = LoadingIndicator;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ModalSubheader(props) {
	  var className = props.className,
	      children = props.children,
	      subheader = props.subheader;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-xs-7" },
	      _react2.default.createElement(
	        "h4",
	        { className: className },
	        children
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xs-5" },
	      _react2.default.createElement(
	        "p",
	        { className: "modal-p" },
	        subheader
	      )
	    )
	  );
	}
	
	exports.default = ModalSubheader;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HowToVideo = function (_PureComponent) {
	  _inherits(HowToVideo, _PureComponent);
	
	  function HowToVideo(props) {
	    _classCallCheck(this, HowToVideo);
	
	    var _this = _possibleConstructorReturn(this, (HowToVideo.__proto__ || Object.getPrototypeOf(HowToVideo)).call(this, props));
	
	    _this.show = function () {
	      _this.setState({
	        show: true
	      });
	    };
	
	    _this.hide = function () {
	      _this.setState({
	        show: false
	      });
	    };
	
	    _this.state = {
	      show: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(HowToVideo, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("how-to-videos-modal-show", this.show);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("how-to-videos-modal-show", this.show);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$url = this.props.url,
	          url = _props$url === undefined ? "" : _props$url;
	      var show = this.state.show;
	
	
	      if (url === "") {
	        return null;
	      }
	
	      var iframeStyle = {
	        width: "100%",
	        height: "100%"
	      };
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          backdrop: true,
	          dialogClassName: "how-to-videos-modal",
	          show: show,
	          onHide: this.hide
	        },
	        _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement("iframe", { src: url, style: iframeStyle, title: "How To" })
	        )
	      );
	    }
	  }]);
	
	  return HowToVideo;
	}(_react.PureComponent);
	
	exports.default = HowToVideo;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AbbreviateForecastUnit = function (_Component) {
	  _inherits(AbbreviateForecastUnit, _Component);
	
	  function AbbreviateForecastUnit() {
	    _classCallCheck(this, AbbreviateForecastUnit);
	
	    return _possibleConstructorReturn(this, (AbbreviateForecastUnit.__proto__ || Object.getPrototypeOf(AbbreviateForecastUnit)).apply(this, arguments));
	  }
	
	  _createClass(AbbreviateForecastUnit, [{
	    key: "render",
	    value: function render() {
	      var type = this.props.type || "text";
	      var value = this.props.value;
	
	      return _react2.default.createElement(_reactNumberFormat2.default, { value: value, displayType: type, thousandSeparator: "," });
	    }
	  }]);
	
	  return AbbreviateForecastUnit;
	}(_react.Component);
	
	exports.default = AbbreviateForecastUnit;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomNumberFormat = function (_NumberFormat) {
	  _inherits(CustomNumberFormat, _NumberFormat);
	
	  function CustomNumberFormat() {
	    _classCallCheck(this, CustomNumberFormat);
	
	    return _possibleConstructorReturn(this, (CustomNumberFormat.__proto__ || Object.getPrototypeOf(CustomNumberFormat)).apply(this, arguments));
	  }
	
	  _createClass(CustomNumberFormat, [{
	    key: "onChange",
	    value: function onChange(k, v) {
	      //let inputValue = v
	      var state = this.state,
	          props = this.props;
	      var isAllowed = props.isAllowed;
	      //const lastValue = state.value || ''
	
	      var lastValue = state.value;
	
	      var _formatInput = this.formatInput(v),
	          formattedValue = _formatInput.formattedValue,
	          value = _formatInput.value;
	
	      //let formattedValue = this.formatInput(inputValue) || ''
	      //let numAsString = this.removeFormatting(formattedValue)
	
	      /*const valueObj = {
	        formattedValue,
	        value: numAsString,
	        floatValue: parseFloat(numAsString)
	      }*/
	
	      //if (!isAllowed(valueObj)) {
	
	
	      if (!isAllowed(formattedValue, value, this.getFloatValue(value))) {
	        formattedValue = lastValue;
	      }
	
	      /*if (isNaN(valueObj.floatValue)) {
	        valueObj.formattedValue = '$0'
	        valueObj.floatValue = 0
	      }*/
	
	      //numAsString = '' + valueObj.floatValue
	      //valueObj.value = numAsString
	
	      if (formattedValue !== lastValue || v !== lastValue) {
	        this.setState({
	          value: formattedValue /*,
	                                numAsString*/
	        }, function () {
	          props.onChange(null, value);
	          //props.onValueChange(valueObj)
	          //props.onChange(null, valueObj.floatValue, v)
	        });
	      } /* else {
	        props.onChange(null, valueObj.floatValue, v)
	        }*/
	    }
	  }]);
	
	  return CustomNumberFormat;
	}(_reactNumberFormat2.default);
	
	exports.default = CustomNumberFormat;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formsyReactComponents = __webpack_require__(694);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// FormsyControlledInput extends formsy-react Input and is controlled version of it
	var FormsyControlledInput = function (_Input) {
	  _inherits(FormsyControlledInput, _Input);
	
	  function FormsyControlledInput(props) {
	    _classCallCheck(this, FormsyControlledInput);
	
	    // changeValue method is overriden to avoid original behavior which changes the _value property of component state
	    // This allows to set the value of the inout only through passing it as a prop (which can be validated).
	    var _this = _possibleConstructorReturn(this, (FormsyControlledInput.__proto__ || Object.getPrototypeOf(FormsyControlledInput)).call(this, props));
	
	    _this.changeValue = function (event) {
	      return props.onChange(_this.props.name, event.target.value);
	    };
	    return _this;
	  }
	
	  return FormsyControlledInput;
	}(_formsyReactComponents.Input);
	
	exports.default = FormsyControlledInput;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Price in millions.
	 */
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName,
	      prefix = _ref.prefix,
	      _ref$decimalPrecision = _ref.decimalPrecision,
	      decimalPrecision = _ref$decimalPrecision === undefined ? 2 : _ref$decimalPrecision,
	      _ref$addSpaceBeforeSu = _ref.addSpaceBeforeSuffix,
	      addSpaceBeforeSuffix = _ref$addSpaceBeforeSu === undefined ? false : _ref$addSpaceBeforeSu;
	
	  if (typeof prefix === "undefined") {
	    prefix = "$";
	  }
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "n/a"
	    );
	  }
	
	  var space = addSpaceBeforeSuffix ? " " : "";
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(decimalPrecision) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "-" + prefix + newPrice + space + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(decimalPrecision);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "" + prefix + newPrice + space + "M"
	    );
	  }
	};
	
	exports.default = PriceInMillions;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _icon_collapse = __webpack_require__(274);
	
	var _icon_collapse2 = _interopRequireDefault(_icon_collapse);
	
	var _utils = __webpack_require__(18);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TabNavigation = __webpack_require__(1352);
	
	var _TabNavigation2 = _interopRequireDefault(_TabNavigation);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FNAnalysisIncomeState = function (_Component) {
	  _inherits(FNAnalysisIncomeState, _Component);
	
	  function FNAnalysisIncomeState(props) {
	    _classCallCheck(this, FNAnalysisIncomeState);
	
	    var _this = _possibleConstructorReturn(this, (FNAnalysisIncomeState.__proto__ || Object.getPrototypeOf(FNAnalysisIncomeState)).call(this, props));
	
	    _this.updateSidebar = function (currentUrl) {
	      return _this.setState({
	        currentUrl: currentUrl
	      });
	    };
	
	    _this.state = {
	      currentUrl: "IncomeStatement",
	      currentBaseUrl: "ceo",
	      roundInUrl: props.roundInUrl
	    };
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(FNAnalysisIncomeState, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.detectCurrentLocation();
	        });
	      }
	    }
	  }, {
	    key: "detectCurrentLocation",
	    value: function detectCurrentLocation() {
	      var parts = this.props.location.pathname.split("/");
	      var currentUrl = "IncomeStatement";
	      var currentBaseUrl = "ceo";
	
	      if (parts.length === 5 && parts[4].length > 0) {
	        currentUrl = parts[4];
	      }
	
	      if (parts.length >= 2) {
	        currentBaseUrl = parts[1];
	      }
	
	      if (currentUrl !== this.state.currentUrl) {
	        this.setState({
	          currentUrl: currentUrl
	        });
	      }
	
	      if (currentBaseUrl !== this.state.currentBaseUrl) {
	        this.setState({
	          currentBaseUrl: currentBaseUrl
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.detectCurrentLocation();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.detectCurrentLocation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          currentUrl = _state.currentUrl,
	          currentBaseUrl = _state.currentBaseUrl,
	          roundInUrl = _state.roundInUrl;
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          rounds = _props.rounds;
	
	      var rowStyle = this.isMobile ? {
	        marginLeft: 0,
	        marginRight: 0
	      } : {};
	      var colClass = this.isMobile ? "col-xs-12 no-padding" : "col-xs-12";
	
	      return _react2.default.createElement(
	        "section",
	        { className: "analysis section-mobile bg-gray" },
	        _react2.default.createElement(
	          "div",
	          { className: "row", style: rowStyle },
	          _react2.default.createElement(
	            "div",
	            { className: colClass },
	            _react2.default.createElement(
	              "div",
	              { className: "container-analysis report-collapse none-shadow" },
	              _react2.default.createElement(_TabNavigation2.default, {
	                updateSidebar: this.updateSidebar,
	                currentUrl: currentUrl,
	                currentBaseUrl: currentBaseUrl,
	                roundInUrl: roundInUrl,
	                currentRound: currentRound,
	                isMobile: this.isMobile
	              }),
	              _react2.default.createElement(
	                "h3",
	                { className: "semibold" },
	                "Financials",
	                _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, _TypeformContent2.default.FINANCIALS),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/fn/results", className: "icon-zoom" },
	                  _react2.default.createElement("img", {
	                    src: _icon_collapse2.default,
	                    className: "icon",
	                    alt: "CollapseImage"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white p-20 mt-20" },
	                _react2.default.Children.map(this.props.children, function (child) {
	                  return _react2.default.cloneElement(child, {
	                    rounds: rounds,
	                    currentRound: currentRound,
	                    roundInUrl: roundInUrl
	                  });
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FNAnalysisIncomeState;
	}(_react.Component);
	
	exports.default = FNAnalysisIncomeState;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FNAnalysisFNStatementsBalanceSheet
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Components
	
	/**
	 * Price in millions.
	 */
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName;
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "n/a"
	    );
	  }
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(2) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: "red " + baseClassName },
	      "-$" + newPrice + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(2);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "$" + newPrice + "M"
	    );
	  }
	};
	
	/**
	 * Table Head
	 */
	
	var TableHead = function TableHead(_ref2) {
	  var rounds = _ref2.rounds;
	  return _react2.default.createElement(
	    "thead",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "th",
	        { className: "table-title text-center" },
	        _react2.default.createElement("span", null)
	      ),
	      rounds.map(function (round, i) {
	        return _react2.default.createElement(
	          "th",
	          { key: i, className: "table-title title-gray text-center" },
	          "YEAR ",
	          round.number
	        );
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents
	 */
	var TableRowContentWhite = function TableRowContentWhite(_ref3) {
	  var balanceSheet = _ref3.balanceSheet;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      balanceSheet.name
	    ),
	    Object.keys(balanceSheet.data).map(function (round_number) {
	      var data = balanceSheet.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row contents with gray background color.
	 */
	
	var TableRowContentGray = function TableRowContentGray(_ref4) {
	  var balanceSheet = _ref4.balanceSheet,
	      _ref4$title = _ref4.title,
	      title = _ref4$title === undefined ? "" : _ref4$title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      title !== "" ? title : balanceSheet.name
	    ),
	    Object.keys(balanceSheet.data).map(function (round_number) {
	      var data = balanceSheet.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row contents with dim gray background color.
	 */
	
	var TableRowContentDimGray = function TableRowContentDimGray(_ref5) {
	  var balanceSheet = _ref5.balanceSheet;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center dim-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        balanceSheet.name
	      )
	    ),
	    Object.keys(balanceSheet.data).map(function (round_number) {
	      var data = balanceSheet.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row title.
	 */
	
	var TableRowContentHeader = function TableRowContentHeader(_ref6) {
	  var title = _ref6.title,
	      rounds = _ref6.rounds;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title title-sky-blue" },
	      title
	    ),
	    rounds.map(function (round, i) {
	      return _react2.default.createElement(
	        "td",
	        { key: i },
	        _react2.default.createElement(
	          "div",
	          { className: "row flex" },
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" })
	        )
	      );
	    })
	  );
	};
	
	/**
	 * Table row sub header.
	 */
	
	var TableRowContentSubheader = function TableRowContentSubheader(_ref7) {
	  var title = _ref7.title,
	      rounds = _ref7.rounds;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title" },
	      title
	    ),
	    rounds.map(function (round, i) {
	      return _react2.default.createElement(
	        "td",
	        { key: i },
	        _react2.default.createElement(
	          "div",
	          { className: "row flex" },
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" })
	        )
	      );
	    })
	  );
	};
	
	/**
	 *
	 * FNAnalysisFNStatementsBalanceSheet
	 *
	 */
	
	var FNAnalysisFNStatementsBalanceSheet = function (_Component) {
	  _inherits(FNAnalysisFNStatementsBalanceSheet, _Component);
	
	  function FNAnalysisFNStatementsBalanceSheet(props) {
	    _classCallCheck(this, FNAnalysisFNStatementsBalanceSheet);
	
	    var _this = _possibleConstructorReturn(this, (FNAnalysisFNStatementsBalanceSheet.__proto__ || Object.getPrototypeOf(FNAnalysisFNStatementsBalanceSheet)).call(this, props));
	
	    _this.loadState = function () {
	      if (_this.props.rounds.length === 0) {
	        _this.timer = setTimeout(_this.loadState, 1000);
	        return;
	      }
	
	      _this.clearData();
	      _this.fetchData();
	    };
	
	    _this.state = {
	      roundInUrl: props.roundInUrl,
	      balanceSheet: {
	        accountsPayable: {
	          name: "Accounts Payable",
	          data: {}
	        },
	        accountsReceivable: {
	          name: "Accounts Receivable",
	          data: {}
	        },
	        accruedExpenses: {
	          name: "Accrued Expenses",
	          data: {}
	        },
	        accumulatedDepreciation: {
	          name: "Accumulated Depreciation",
	          data: {}
	        },
	        additionalPaidinCapital: {
	          name: "Additional Paid in Capital",
	          data: {}
	        },
	        begRetainedEarnings: {
	          name: "Prior Period Retained Earnings",
	          data: {}
	        },
	        cash: {
	          name: "Cash",
	          data: {}
	        },
	        commonStock: {
	          name: "Common Stock",
	          data: {}
	        },
	        currentLiabilities: {
	          name: "Current Liabilities:",
	          data: {}
	        },
	        deferredRevenues: {
	          name: "Deferred Revenues",
	          data: {}
	        },
	        dividends: {
	          name: "Dividends",
	          data: {}
	        },
	        inventory: {
	          name: "Inventory",
	          data: {}
	        },
	        longTermDebt: {
	          name: "Long Term Debt",
	          data: {}
	        },
	        longTermLiabilities: {
	          name: "Long Term Liabilities:",
	          data: {}
	        },
	        netIncome: {
	          name: "Net Income",
	          data: {}
	        },
	        otherCurrentLiabilities: {
	          name: "Other Current Liabilities",
	          data: {}
	        },
	        otherLongTermLiabilities: {
	          name: "Other Long Term Liabilities",
	          data: {}
	        },
	        ppe: {
	          name: "PPE",
	          data: {}
	        },
	        preferredStock: {
	          name: "Preferred Stock",
	          data: {}
	        },
	        prepaidExpenses: {
	          name: "Prepaid Expenses",
	          data: {}
	        },
	        shortTermDebt: {
	          name: "Short Term Debt",
	          data: {}
	        },
	        supplies: {
	          name: "Supplies",
	          data: {}
	        },
	        totalAssets: {
	          name: "Total Assets",
	          data: {}
	        },
	        totalCurrentAssets: {
	          name: "Total Current Assets",
	          data: {}
	        },
	        totalCurrentLiabilities: {
	          name: "Total Current Liabilities",
	          data: {}
	        },
	        totalEquity: {
	          name: "Total Equity",
	          data: {}
	        },
	        totalLiabilities: {
	          name: "Total Liabilities",
	          data: {}
	        },
	        totalLongTermAssets: {
	          name: "Total Long Term Assets",
	          data: {}
	        },
	        totalLongTermLiabilities: {
	          name: "Total Long Term Liabilities",
	          data: {}
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(FNAnalysisFNStatementsBalanceSheet, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.loadState();
	        });
	      }
	    }
	  }, {
	    key: "getBalanceSheet",
	    value: function getBalanceSheet() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/report/balance_sheet/";
	      var url = base_url + "?round_lte=" + this.props.currentRound;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound) {
	        url = base_url + "?round_lte=" + this.state.roundInUrl;
	      }
	
	      return (0, _ApiService.getRequest)(url);
	    }
	  }, {
	    key: "clearData",
	    value: function clearData() {
	      var balanceSheet = Object.assign({}, this.state.balanceSheet);
	      var headRounds = this.headRounds;
	
	      var _loop = function _loop(key) {
	        balanceSheet[key].data = {};
	        headRounds.forEach(function (round) {
	          balanceSheet[key].data[round.number] = {
	            value: 0
	          };
	        });
	      };
	
	      for (var key in balanceSheet) {
	        _loop(key);
	      }
	
	      this.setState({
	        balanceSheet: balanceSheet
	      });
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this3 = this;
	
	      this.getBalanceSheet().then(function (res) {
	        var balanceSheet = Object.assign({}, _this3.state.balanceSheet);
	
	        var _loop2 = function _loop2(key) {
	          res.body.forEach(function (item) {
	            var round_id = item.round;
	            var round = _this3.props.rounds.find(function (i) {
	              return i.id === round_id;
	            });
	            var round_number = round.number;
	            var hash = balanceSheet[key].name;
	
	            if (item[hash]) {
	              balanceSheet[key].data[round_number].value = item[hash];
	            }
	          });
	        };
	
	        for (var key in balanceSheet) {
	          _loop2(key);
	        }
	
	        _this3.setState({
	          balanceSheet: balanceSheet
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "FNAnalysisFNStatementsBalanceSheet", "fetchData");
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadState();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearTimeout(this.timer);
	        return;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state$balanceSheet = this.state.balanceSheet,
	          accountsPayable = _state$balanceSheet.accountsPayable,
	          accountsReceivable = _state$balanceSheet.accountsReceivable,
	          accruedExpenses = _state$balanceSheet.accruedExpenses,
	          accumulatedDepreciation = _state$balanceSheet.accumulatedDepreciation,
	          additionalPaidinCapital = _state$balanceSheet.additionalPaidinCapital,
	          begRetainedEarnings = _state$balanceSheet.begRetainedEarnings,
	          cash = _state$balanceSheet.cash,
	          commonStock = _state$balanceSheet.commonStock,
	          deferredRevenues = _state$balanceSheet.deferredRevenues,
	          dividends = _state$balanceSheet.dividends,
	          inventory = _state$balanceSheet.inventory,
	          longTermDebt = _state$balanceSheet.longTermDebt,
	          netIncome = _state$balanceSheet.netIncome,
	          otherCurrentLiabilities = _state$balanceSheet.otherCurrentLiabilities,
	          otherLongTermLiabilities = _state$balanceSheet.otherLongTermLiabilities,
	          ppe = _state$balanceSheet.ppe,
	          preferredStock = _state$balanceSheet.preferredStock,
	          prepaidExpenses = _state$balanceSheet.prepaidExpenses,
	          shortTermDebt = _state$balanceSheet.shortTermDebt,
	          supplies = _state$balanceSheet.supplies,
	          totalAssets = _state$balanceSheet.totalAssets,
	          totalCurrentAssets = _state$balanceSheet.totalCurrentAssets,
	          totalCurrentLiabilities = _state$balanceSheet.totalCurrentLiabilities,
	          totalEquity = _state$balanceSheet.totalEquity,
	          totalLiabilities = _state$balanceSheet.totalLiabilities,
	          totalLongTermAssets = _state$balanceSheet.totalLongTermAssets,
	          totalLongTermLiabilities = _state$balanceSheet.totalLongTermLiabilities;
	
	      var headRounds = this.headRounds;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white-full" },
	        _react2.default.createElement(
	          "h5",
	          { className: "title-sky-blue" },
	          "Balance Sheet",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "sm"
	          }, _TypeformContent2.default.BALANCE_SHEET))
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "table-responsive fn-results-table" },
	          _react2.default.createElement(
	            "table",
	            { className: "table border-analysis mb-20" },
	            _react2.default.createElement(TableHead, { rounds: headRounds }),
	            Object.keys(accountsPayable.data).length > 0 || Object.keys(accountsReceivable.data).length > 0 || Object.keys(accruedExpenses.data).length > 0 ? _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Current Assets:",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: cash }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: accountsReceivable }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: inventory }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: prepaidExpenses }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: supplies }),
	              _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalCurrentAssets }),
	              _react2.default.createElement(TableRowContentSubheader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Long Term Assets:",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: ppe }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: accumulatedDepreciation }),
	              _react2.default.createElement(TableRowContentSubheader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalLongTermAssets }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalAssets }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentHeader, {
	                title: "Liabilities",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Current Liabilities",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: deferredRevenues }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: accountsPayable }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: accruedExpenses }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: shortTermDebt }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: otherCurrentLiabilities }),
	              _react2.default.createElement(TableRowContentDimGray, {
	                balanceSheet: totalCurrentLiabilities
	              }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Long Term Liabilities",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: longTermDebt }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: otherLongTermLiabilities }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentDimGray, {
	                balanceSheet: totalLongTermLiabilities
	              }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalLiabilities }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentHeader, { title: "Equity", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: commonStock }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: preferredStock }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: additionalPaidinCapital }),
	              _react2.default.createElement(TableRowContentHeader, {
	                title: "Retained Earnings:",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, {
	                balanceSheet: begRetainedEarnings,
	                title: "Beg Retained Earnings"
	              }),
	              _react2.default.createElement(TableRowContentWhite, { balanceSheet: netIncome }),
	              _react2.default.createElement(TableRowContentGray, { balanceSheet: dividends }),
	              _react2.default.createElement(TableRowContentDimGray, { balanceSheet: totalEquity })
	            ) : _react2.default.createElement("tbody", null)
	          )
	        )
	      );
	    }
	  }, {
	    key: "headRounds",
	    get: function get() {
	      var roundInUrl = this.state.roundInUrl;
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          rounds = _props.rounds;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      return rounds.filter(function (i) {
	        return i.number <= current_round;
	      });
	    }
	  }]);
	
	  return FNAnalysisFNStatementsBalanceSheet;
	}(_react.Component);
	
	exports.default = FNAnalysisFNStatementsBalanceSheet;

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FNAnalysisFNStatementsCashFlow
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Components
	
	/**
	 * Price in millions.
	 */
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName;
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "n/a"
	    );
	  }
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(2) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: "red " + baseClassName },
	      "-$" + newPrice + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(2);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "$" + newPrice + "M"
	    );
	  }
	};
	
	/**
	 * Table Head
	 */
	
	var TableHead = function TableHead(_ref2) {
	  var rounds = _ref2.rounds;
	  return _react2.default.createElement(
	    "thead",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "th",
	        { className: "table-title text-center" },
	        _react2.default.createElement("span", null)
	      ),
	      rounds.map(function (round, i) {
	        return _react2.default.createElement(
	          "th",
	          { key: i, className: "table-title title-gray text-center" },
	          "YEAR ",
	          round.number
	        );
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents
	 */
	
	var TableRowContentWhite = function TableRowContentWhite(_ref3) {
	  var cashFlow = _ref3.cashFlow,
	      title = _ref3.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      title ? title : cashFlow.name
	    ),
	    Object.keys(cashFlow.data).map(function (round_number) {
	      var data = cashFlow.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row contents with gray background color.
	 */
	
	var TableRowContentGray = function TableRowContentGray(_ref4) {
	  var cashFlow = _ref4.cashFlow;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      cashFlow.name
	    ),
	    Object.keys(cashFlow.data).map(function (round_number) {
	      var data = cashFlow.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row contents with dim gray background color.
	 */
	
	var TableRowContentDimGray = function TableRowContentDimGray(_ref5) {
	  var cashFlow = _ref5.cashFlow;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center dim-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        cashFlow.name
	      )
	    ),
	    Object.keys(cashFlow.data).map(function (round_number) {
	      var data = cashFlow.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row title.
	 */
	
	var TableRowContentHeader = function TableRowContentHeader(_ref6) {
	  var title = _ref6.title,
	      rounds = _ref6.rounds;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title title-sky-blue" },
	      title
	    ),
	    rounds.map(function (round, i) {
	      return _react2.default.createElement(
	        "td",
	        { key: i },
	        _react2.default.createElement(
	          "div",
	          { className: "row flex" },
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" })
	        )
	      );
	    })
	  );
	};
	
	/**
	 * Table row sub header.
	 */
	
	var TableRowContentSubheader = function TableRowContentSubheader(_ref7) {
	  var title = _ref7.title,
	      rounds = _ref7.rounds;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title" },
	      title
	    ),
	    rounds.map(function (round, i) {
	      return _react2.default.createElement(
	        "td",
	        { key: i },
	        _react2.default.createElement(
	          "div",
	          { className: "row flex" },
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" })
	        )
	      );
	    })
	  );
	};
	
	/**
	 *
	 * FNAnalysisFNStatementsCashFlow
	 *
	 */
	
	var FNAnalysisFNStatementsCashFlow = function (_Component) {
	  _inherits(FNAnalysisFNStatementsCashFlow, _Component);
	
	  function FNAnalysisFNStatementsCashFlow(props) {
	    _classCallCheck(this, FNAnalysisFNStatementsCashFlow);
	
	    var _this = _possibleConstructorReturn(this, (FNAnalysisFNStatementsCashFlow.__proto__ || Object.getPrototypeOf(FNAnalysisFNStatementsCashFlow)).call(this, props));
	
	    _this.loadState = function () {
	      if (_this.props.rounds.length === 0) {
	        _this.timer = setTimeout(_this.loadState, 1000);
	        return;
	      }
	
	      _this.clearData();
	      _this.fetchData();
	    };
	
	    _this.state = {
	      roundInUrl: props.roundInUrl,
	      cashFlow: {
	        beginningCash: {
	          name: "Beginning Cash",
	          data: {}
	        },
	        capitalExpenditurePurchases: {
	          name: "Capital Expenditure Purchases",
	          data: {}
	        },
	        capitalExpenditureSales: {
	          name: "Capital Expenditure Sales",
	          data: {}
	        },
	        cashpaymentforIncomeTaxes: {
	          name: "Cash payment for Income Taxes",
	          data: {}
	        },
	        cashpaymentforInterests: {
	          name: "Cash payment for Interests",
	          data: {}
	        },
	        cashpaymentsforOperatingexpenses: {
	          name: "Cash payments for Operating expenses",
	          data: {}
	        },
	        cashpaymentsforPurchases: {
	          name: "Cash payments for Purchases",
	          data: {}
	        },
	        cashpaymentsforWages: {
	          name: "Cash payment for Wages",
	          data: {}
	        },
	        cashreceivedfromCustomers: {
	          name: "Cash received from Customers",
	          data: {}
	        },
	        debtBorrowed: {
	          name: "Debt Borrowed",
	          data: {}
	        },
	        debtRepaid: {
	          name: "Debt Repaid",
	          data: {}
	        },
	        dividends: {
	          name: "Dividends",
	          data: {}
	        },
	        endingCash: {
	          name: "Ending Cash",
	          data: {}
	        },
	        investmentPurchases: {
	          name: "Investment Purchases",
	          data: {}
	        },
	        investmentSales: {
	          name: "Investment Sales",
	          data: {}
	        },
	        netChangeinCash: {
	          name: "Net Change in Cash",
	          data: {}
	        },
	        stockIssuance: {
	          name: "Stock Issuance",
	          data: {}
	        },
	        stockRepurchase: {
	          name: "Stock Repurchase",
	          data: {}
	        },
	        totalCashFlowsfromFinancing: {
	          name: "Total Cash Flows from Financing",
	          data: {}
	        },
	        totalCashFlowsfromInvesting: {
	          name: "Total Cash Flows from Investing",
	          data: {}
	        },
	        totalCashFlowsfromOperations: {
	          name: "Total Cash Flows from Operations",
	          data: {}
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(FNAnalysisFNStatementsCashFlow, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.loadState();
	        });
	      }
	    }
	  }, {
	    key: "getCashflow",
	    value: function getCashflow() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/report/cashflow/";
	      var url = base_url + "?round_lte=" + this.props.currentRound;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound) {
	        url = base_url + "?round_lte=" + this.state.roundInUrl;
	      }
	
	      return (0, _ApiService.getRequest)(url);
	    }
	  }, {
	    key: "clearData",
	    value: function clearData() {
	      var cashFlow = Object.assign({}, this.state.cashFlow);
	      var headRounds = this.headRounds;
	
	      var _loop = function _loop(key) {
	        cashFlow[key].data = {};
	        headRounds.forEach(function (round) {
	          cashFlow[key].data[round.number] = {
	            value: 0
	          };
	        });
	      };
	
	      for (var key in cashFlow) {
	        _loop(key);
	      }
	
	      this.setState({
	        cashFlow: cashFlow
	      });
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this3 = this;
	
	      this.getCashflow().then(function (res) {
	        var cashFlow = Object.assign({}, _this3.state.cashFlow);
	
	        var _loop2 = function _loop2(key) {
	          res.body.forEach(function (item) {
	            var round_id = item.round;
	            var round = _this3.props.rounds.find(function (i) {
	              return i.id === round_id;
	            });
	            var round_number = round.number;
	            var hash = cashFlow[key].name;
	
	            if (item[hash]) {
	              cashFlow[key].data[round_number].value = item[hash];
	            }
	          });
	        };
	
	        for (var key in cashFlow) {
	          _loop2(key);
	        }
	
	        _this3.setState({
	          cashFlow: cashFlow
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "FNAnalysisFNStatementsCashFlow", "componentDidMount");
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadState();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearTimeout(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state$cashFlow = this.state.cashFlow,
	          beginningCash = _state$cashFlow.beginningCash,
	          capitalExpenditurePurchases = _state$cashFlow.capitalExpenditurePurchases,
	          capitalExpenditureSales = _state$cashFlow.capitalExpenditureSales,
	          cashpaymentforIncomeTaxes = _state$cashFlow.cashpaymentforIncomeTaxes,
	          cashpaymentforInterests = _state$cashFlow.cashpaymentforInterests,
	          cashpaymentsforOperatingexpenses = _state$cashFlow.cashpaymentsforOperatingexpenses,
	          cashpaymentsforPurchases = _state$cashFlow.cashpaymentsforPurchases,
	          cashpaymentsforWages = _state$cashFlow.cashpaymentsforWages,
	          cashreceivedfromCustomers = _state$cashFlow.cashreceivedfromCustomers,
	          debtBorrowed = _state$cashFlow.debtBorrowed,
	          debtRepaid = _state$cashFlow.debtRepaid,
	          dividends = _state$cashFlow.dividends,
	          endingCash = _state$cashFlow.endingCash,
	          investmentPurchases = _state$cashFlow.investmentPurchases,
	          investmentSales = _state$cashFlow.investmentSales,
	          netChangeinCash = _state$cashFlow.netChangeinCash,
	          stockIssuance = _state$cashFlow.stockIssuance,
	          stockRepurchase = _state$cashFlow.stockRepurchase,
	          totalCashFlowsfromFinancing = _state$cashFlow.totalCashFlowsfromFinancing,
	          totalCashFlowsfromInvesting = _state$cashFlow.totalCashFlowsfromInvesting,
	          totalCashFlowsfromOperations = _state$cashFlow.totalCashFlowsfromOperations;
	
	      var headRounds = this.headRounds;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white-full" },
	        _react2.default.createElement(
	          "h5",
	          { className: "title-sky-blue" },
	          "Cash Flows",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "sm"
	          }, _TypeformContent2.default.CASH_FLOWS))
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "table-responsive fn-results-table" },
	          _react2.default.createElement(
	            "table",
	            { className: "table border-analysis mb-20" },
	            _react2.default.createElement(TableHead, { rounds: headRounds }),
	            Object.keys(beginningCash.data).length > 0 || Object.keys(capitalExpenditurePurchases.data).length > 0 || Object.keys(capitalExpenditureSales.data).length > 0 ? _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Cash Flows From Operations:",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: cashreceivedfromCustomers }),
	              _react2.default.createElement(TableRowContentWhite, {
	                cashFlow: cashpaymentsforPurchases,
	                title: "Cash payment for Suppliers"
	              }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: cashpaymentsforWages }),
	              _react2.default.createElement(TableRowContentWhite, {
	                cashFlow: cashpaymentsforOperatingexpenses,
	                title: "Cash payment for Operating expenses"
	              }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: cashpaymentforInterests }),
	              _react2.default.createElement(TableRowContentWhite, { cashFlow: cashpaymentforIncomeTaxes }),
	              _react2.default.createElement(TableRowContentDimGray, {
	                cashFlow: totalCashFlowsfromOperations
	              }),
	              _react2.default.createElement(TableRowContentSubheader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Cash Flows From Investing:",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: capitalExpenditurePurchases }),
	              _react2.default.createElement(TableRowContentWhite, { cashFlow: capitalExpenditureSales }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: investmentPurchases }),
	              _react2.default.createElement(TableRowContentWhite, { cashFlow: investmentSales }),
	              _react2.default.createElement(TableRowContentDimGray, {
	                cashFlow: totalCashFlowsfromInvesting
	              }),
	              _react2.default.createElement(TableRowContentSubheader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentSubheader, {
	                title: "Cash Flow From Financing:",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: stockIssuance }),
	              _react2.default.createElement(TableRowContentWhite, { cashFlow: stockRepurchase }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: dividends }),
	              _react2.default.createElement(TableRowContentWhite, { cashFlow: debtBorrowed }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: debtRepaid }),
	              _react2.default.createElement(TableRowContentDimGray, {
	                cashFlow: totalCashFlowsfromFinancing
	              }),
	              _react2.default.createElement(TableRowContentHeader, { title: "", rounds: headRounds }),
	              _react2.default.createElement(TableRowContentHeader, {
	                title: "Change In Cash",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContentWhite, { cashFlow: beginningCash }),
	              _react2.default.createElement(TableRowContentGray, { cashFlow: endingCash }),
	              _react2.default.createElement(TableRowContentDimGray, { cashFlow: netChangeinCash })
	            ) : _react2.default.createElement("tbody", { className: "empty-table" })
	          )
	        )
	      );
	    }
	  }, {
	    key: "headRounds",
	    get: function get() {
	      var roundInUrl = this.state.roundInUrl;
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          rounds = _props.rounds;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      return rounds.filter(function (i) {
	        return i.number <= current_round;
	      });
	    }
	  }]);
	
	  return FNAnalysisFNStatementsCashFlow;
	}(_react.Component);
	
	exports.default = FNAnalysisFNStatementsCashFlow;

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _utils = __webpack_require__(18);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FNAnalysisFNStatementsIncomeStatement
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Components
	
	/**
	 * Price in millions.
	 */
	var PriceInMillions = function PriceInMillions(_ref) {
	  var price = _ref.price,
	      baseClassName = _ref.baseClassName;
	
	  if (typeof price !== "number") {
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "n/a"
	    );
	  }
	
	  var newPrice = void 0;
	  if (price < 0) {
	    newPrice = (price / 1000000).toFixed(2) * -1;
	    return _react2.default.createElement(
	      "div",
	      { className: "red " + baseClassName },
	      "-$" + newPrice + "M"
	    );
	  } else {
	    newPrice = (price / 1000000).toFixed(2);
	    return _react2.default.createElement(
	      "div",
	      { className: baseClassName },
	      "$" + newPrice + "M"
	    );
	  }
	};
	
	/**
	 * Table row contents
	 */
	
	var TableHead = function TableHead(_ref2) {
	  var rounds = _ref2.rounds;
	  return _react2.default.createElement(
	    "thead",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "th",
	        { className: "table-title text-center" },
	        _react2.default.createElement("span", null)
	      ),
	      rounds.map(function (round, i) {
	        return _react2.default.createElement(
	          "th",
	          { key: i, className: "table-title title-gray text-center" },
	          "YEAR ",
	          round.number
	        );
	      })
	    )
	  );
	};
	
	/**
	 * Table row contents
	 */
	
	var TableRowContents = function TableRowContents(_ref3) {
	  var incomeStatement = _ref3.incomeStatement,
	      name = _ref3.name;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      name ? name : incomeStatement.name
	    ),
	    Object.keys(incomeStatement.data).map(function (round_number) {
	      var data = incomeStatement.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	var OtherGnACosts = function OtherGnACosts(_ref4) {
	  var gnaCosts = _ref4.gnaCosts,
	      depExpense = _ref4.depExpense,
	      name = _ref4.name;
	
	  var total = {};
	
	  Object.keys(gnaCosts.data).forEach(function (round_number) {
	    if (!(round_number in total)) {
	      total[round_number] = 0;
	    }
	
	    total[round_number] += gnaCosts.data[round_number].value;
	  });
	
	  Object.keys(depExpense.data).forEach(function (round_number) {
	    if (!(round_number in total)) {
	      total[round_number] = 0;
	    }
	
	    total[round_number] += depExpense.data[round_number].value;
	  });
	
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      name ? name : ""
	    ),
	    Object.keys(total).map(function (round_number) {
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, {
	          baseClassName: "text-center",
	          price: total[round_number]
	        })
	      );
	    })
	  );
	};
	
	/**
	 * Table row contents with gray background color.
	 */
	
	var TableRowContentsFooter = function TableRowContentsFooter(_ref5) {
	  var incomeStatement = _ref5.incomeStatement;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        incomeStatement.name,
	        incomeStatement.name === "Gross Profit" && _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	          iconSize: "sm"
	        }, _TypeformContent2.default.GROSS_PROFITS))
	      )
	    ),
	    Object.keys(incomeStatement.data).map(function (round_number) {
	      var data = incomeStatement.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row total content
	 */
	
	var TotalComponent = function TotalComponent(_ref6) {
	  var incomeStatement = _ref6.incomeStatement,
	      title = _ref6.title;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        title ? title : incomeStatement.name,
	        title === "Net Profits" && _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	          iconSize: "sm"
	        }, _TypeformContent2.default.NET_PROFITS))
	      )
	    ),
	    Object.keys(incomeStatement.data).map(function (round_number) {
	      var data = incomeStatement.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, { baseClassName: "text-center", price: data.value })
	      );
	    })
	  );
	};
	
	/**
	 * Table row operating profit
	 */
	
	var OperatingProfitComponent = function OperatingProfitComponent(_ref7) {
	  var totalOperatingExpenses = _ref7.totalOperatingExpenses,
	      grossProfits = _ref7.grossProfits;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center bg-gray none-shadow" },
	    _react2.default.createElement(
	      "th",
	      { className: "description" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        "Operation Profits"
	      )
	    ),
	    Object.keys(totalOperatingExpenses.data).map(function (round_number) {
	      var data1 = totalOperatingExpenses.data[round_number];
	      var data2 = grossProfits.data[round_number];
	      return _react2.default.createElement(
	        "td",
	        { key: round_number },
	        _react2.default.createElement(PriceInMillions, {
	          baseClassName: "text-center",
	          price: data1.value + data2.value
	        })
	      );
	    })
	  );
	};
	
	/**
	 * Table row title.
	 */
	
	var TotalTitleHeader = function TotalTitleHeader(_ref8) {
	  var title = _ref8.title,
	      rounds = _ref8.rounds;
	  return _react2.default.createElement(
	    "tr",
	    { className: "text-center" },
	    _react2.default.createElement(
	      "th",
	      { className: "sub-title title-sky-blue" },
	      title
	    ),
	    rounds.map(function (round, i) {
	      return _react2.default.createElement(
	        "td",
	        { key: i },
	        _react2.default.createElement(
	          "div",
	          { className: "row flex" },
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" }),
	          _react2.default.createElement("div", { className: "col-xs-6" })
	        )
	      );
	    })
	  );
	};
	
	/**
	 *
	 * FNAnalysisFNStatementsIncomeStatement
	 *
	 */
	
	var FNAnalysisFNStatementsIncomeStatement = function (_Component) {
	  _inherits(FNAnalysisFNStatementsIncomeStatement, _Component);
	
	  function FNAnalysisFNStatementsIncomeStatement(props) {
	    _classCallCheck(this, FNAnalysisFNStatementsIncomeStatement);
	
	    var _this = _possibleConstructorReturn(this, (FNAnalysisFNStatementsIncomeStatement.__proto__ || Object.getPrototypeOf(FNAnalysisFNStatementsIncomeStatement)).call(this, props));
	
	    _this.loadState = function () {
	      if (_this.props.rounds.length === 0) {
	        _this.timer = setTimeout(_this.loadState, 1000);
	        return;
	      }
	
	      _this.clearData();
	      _this.fetchData();
	    };
	
	    _this.state = {
	      roundInUrl: props.roundInUrl,
	      incomeStatement: {
	        costOfSales: {
	          name: "Cost of Sales",
	          data: {}
	        },
	        revenues: {
	          name: "Net Revenues",
	          data: {}
	        },
	        grossProfits: {
	          name: "Gross Profit",
	          data: {}
	        },
	        RnDCosts: {
	          name: "R&D Costs",
	          data: {}
	        },
	        holdingCosts: {
	          name: "Holding Costs",
	          data: {}
	        },
	        promotionCosts: {
	          name: "Promotion Costs",
	          data: {}
	        },
	        sellingCosts: {
	          name: "Selling Costs",
	          data: {}
	        },
	        gnACosts: {
	          name: "Other G&A Costs",
	          data: {}
	        },
	        depExpense: {
	          name: "Depreciation Expense",
	          data: {}
	        },
	        incomingBeforeTaxes: {
	          name: "Income Before Taxes",
	          data: {}
	        },
	        taxes: {
	          name: "Taxes",
	          data: {}
	        },
	        totalOperatingExpenses: {
	          name: "Total Operating Costs",
	          data: {}
	        },
	        totalNonOperatingCost: {
	          name: "Total Non-Operating Costs",
	          data: {}
	        },
	        gainOrLossoFSales: {
	          name: "Gain or Loss of Sales",
	          data: {}
	        },
	        interestExpense: {
	          name: "Interest Expense",
	          data: {}
	        },
	        otherNonOperatingCosts: {
	          name: "Other Non-Operating Costs",
	          data: {}
	        },
	        netIncome: {
	          name: "Net Income",
	          data: {}
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(FNAnalysisFNStatementsIncomeStatement, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl
	        }, function () {
	          _this2.loadState();
	        });
	      }
	    }
	  }, {
	    key: "getIncomeStatement",
	    value: function getIncomeStatement() {
	      var base_url = ("https://be-production-itb.marketgames.io/api/") + "team/report/income_statement/";
	      var url = base_url + "?round_lte=" + this.props.currentRound;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound) {
	        url = base_url + "?round_lte=" + this.state.roundInUrl;
	      }
	
	      return (0, _ApiService.getRequest)(url);
	    }
	  }, {
	    key: "clearData",
	    value: function clearData() {
	      var incomeStatement = Object.assign({}, this.state.incomeStatement);
	      var headRounds = this.headRounds;
	
	      var _loop = function _loop(key) {
	        incomeStatement[key].data = {};
	        headRounds.forEach(function (round) {
	          incomeStatement[key].data[round.number] = {
	            value: 0
	          };
	        });
	      };
	
	      for (var key in incomeStatement) {
	        _loop(key);
	      }
	
	      this.setState({
	        incomeStatement: incomeStatement
	      });
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this3 = this;
	
	      this.getIncomeStatement().then(function (res) {
	        var incomeStatement = Object.assign({}, _this3.state.incomeStatement);
	
	        var _loop2 = function _loop2(key) {
	          res.body.forEach(function (item) {
	            var round_id = item.round;
	            var round = _this3.props.rounds.find(function (i) {
	              return i.id === round_id;
	            });
	            var round_number = round.number;
	            var hash = incomeStatement[key].name;
	
	            if (item[hash]) {
	              incomeStatement[key].data[round_number].value = item[hash];
	            }
	          });
	        };
	
	        for (var key in incomeStatement) {
	          _loop2(key);
	        }
	
	        _this3.setState({
	          incomeStatement: incomeStatement
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "FNAnalysisFNStatementsIncomeStatement", "componentDidMount");
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadState();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.timer) {
	        clearTimeout(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state$incomeStatemen = this.state.incomeStatement,
	          costOfSales = _state$incomeStatemen.costOfSales,
	          revenues = _state$incomeStatemen.revenues,
	          grossProfits = _state$incomeStatemen.grossProfits,
	          RnDCosts = _state$incomeStatemen.RnDCosts,
	          holdingCosts = _state$incomeStatemen.holdingCosts,
	          promotionCosts = _state$incomeStatemen.promotionCosts,
	          sellingCosts = _state$incomeStatemen.sellingCosts,
	          gnACosts = _state$incomeStatemen.gnACosts,
	          incomingBeforeTaxes = _state$incomeStatemen.incomingBeforeTaxes,
	          taxes = _state$incomeStatemen.taxes,
	          totalNonOperatingCost = _state$incomeStatemen.totalNonOperatingCost,
	          interestExpense = _state$incomeStatemen.interestExpense,
	          totalOperatingExpenses = _state$incomeStatemen.totalOperatingExpenses,
	          gainOrLossoFSales = _state$incomeStatemen.gainOrLossoFSales,
	          otherNonOperatingCosts = _state$incomeStatemen.otherNonOperatingCosts,
	          netIncome = _state$incomeStatemen.netIncome,
	          depExpense = _state$incomeStatemen.depExpense;
	
	      var headRounds = this.headRounds;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "panel-dashboard-white-full" },
	        _react2.default.createElement(
	          "h5",
	          { className: "title-sky-blue" },
	          "Income Statement",
	          _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	            iconSize: "sm"
	          }, _TypeformContent2.default.INCOME_STATEMENT))
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "table-responsive fn-results-table" },
	          _react2.default.createElement(
	            "table",
	            { className: "table border-analysis mb-20" },
	            _react2.default.createElement(TableHead, { rounds: headRounds }),
	            Object.keys(costOfSales.data).length > 0 || Object.keys(revenues.data).length > 0 || Object.keys(grossProfits.data).length > 0 ? _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(TableRowContents, { incomeStatement: revenues }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: costOfSales }),
	              _react2.default.createElement(TableRowContentsFooter, { incomeStatement: grossProfits }),
	              _react2.default.createElement(TotalTitleHeader, {
	                title: "Operating Expenses",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: RnDCosts }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: holdingCosts }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: promotionCosts }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: sellingCosts }),
	              _react2.default.createElement(OtherGnACosts, {
	                gnaCosts: gnACosts,
	                depExpense: depExpense,
	                name: "Other G&A Costs"
	              }),
	              _react2.default.createElement(TableRowContentsFooter, {
	                incomeStatement: totalOperatingExpenses
	              }),
	              _react2.default.createElement(OperatingProfitComponent, {
	                totalOperatingExpenses: totalOperatingExpenses,
	                grossProfits: grossProfits
	              }),
	              _react2.default.createElement(TotalTitleHeader, {
	                title: "Non-Operating Costs",
	                rounds: headRounds
	              }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: interestExpense }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: gainOrLossoFSales }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: otherNonOperatingCosts }),
	              _react2.default.createElement(TotalComponent, { incomeStatement: totalNonOperatingCost }),
	              _react2.default.createElement(TotalTitleHeader, { title: "Profits", rounds: headRounds }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: incomingBeforeTaxes }),
	              _react2.default.createElement(TableRowContents, { incomeStatement: taxes }),
	              _react2.default.createElement(TotalComponent, {
	                incomeStatement: netIncome,
	                title: "Net Profits"
	              })
	            ) : _react2.default.createElement("tbody", { className: "empty-table" })
	          )
	        )
	      );
	    }
	  }, {
	    key: "headRounds",
	    get: function get() {
	      var roundInUrl = this.state.roundInUrl;
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          rounds = _props.rounds;
	
	
	      var current_round = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_round = roundInUrl;
	      }
	
	      return rounds.filter(function (i) {
	        return i.number <= current_round;
	      });
	    }
	  }]);
	
	  return FNAnalysisFNStatementsIncomeStatement;
	}(_react.Component);
	
	exports.default = FNAnalysisFNStatementsIncomeStatement;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _KnowledgeBaseCard = __webpack_require__(1202);
	
	var _KnowledgeBaseCard2 = _interopRequireDefault(_KnowledgeBaseCard);
	
	var _KnowledgeBaseContent = __webpack_require__(1203);
	
	var _KnowledgeBaseContent2 = _interopRequireDefault(_KnowledgeBaseContent);
	
	var _utils = __webpack_require__(18);
	
	var _modal = __webpack_require__(1401);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getOrderedList = function getOrderedList(items) {
	  return (0, _orderBy2.default)(items, ["order"], ["asc"]);
	};
	
	var KnowledgeBase = function (_PureComponent) {
	  _inherits(KnowledgeBase, _PureComponent);
	
	  function KnowledgeBase(props) {
	    _classCallCheck(this, KnowledgeBase);
	
	    var _this = _possibleConstructorReturn(this, (KnowledgeBase.__proto__ || Object.getPrototypeOf(KnowledgeBase)).call(this, props));
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(KnowledgeBase, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "section",
	        { className: "knowledge bg-gray" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "h3",
	            { className: "h3-icon semibold" },
	            "Knowledge Base"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            getOrderedList(_KnowledgeBaseContent2.default).map(function (_ref) {
	              var key = _ref.key,
	                  url = _ref.url,
	                  title = _ref.title;
	              return _react2.default.createElement(
	                "div",
	                { key: "knowledge-base-" + key, className: "col-md-3 col-xs-12" },
	                _react2.default.createElement(_KnowledgeBaseCard2.default, {
	                  title: title,
	                  url: (0, _utils.addUserSpecificParams)(url),
	                  isMobile: _this2.isMobile
	                })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_modal2.default, null)
	      );
	    }
	  }]);
	
	  return KnowledgeBase;
	}(_react.PureComponent);
	
	exports.default = KnowledgeBase;

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 18px;\n\n  @media (max-width: 960px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 18px;\n\n  @media (max-width: 960px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 22px 24px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"], ["\n  background: #FFFFFF;\n  border: 1px solid #E5E9F0;\n  border-radius: 14px;\n  padding: 22px 24px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"], ["\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  background: #F5F7FB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  line-height: 1.2;\n  word-break: break-word;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  line-height: 1.2;\n  word-break: break-word;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 12px;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 600;\n  margin-top: 4px;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 12px;\n  color: rgba(0, 27, 59, 0.6);\n  font-weight: 600;\n  margin-top: 4px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n"], ["\n  display: flex;\n  gap: 8px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  color: rgba(0, 27, 59, 0.6);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 8px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  color: rgba(0, 27, 59, 0.6);\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 8px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 10px;\n\n  strong {\n    color: #C62828;\n    font-weight: 700;\n    font-size: 16px;\n    margin-left: 4px;\n  }\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 10px;\n\n  strong {\n    color: #C62828;\n    font-weight: 700;\n    font-size: 16px;\n    margin-left: 4px;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 110px 1fr 30px 110px;\n  gap: 12px;\n  align-items: center;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"], ["\n  display: grid;\n  grid-template-columns: 110px 1fr 30px 110px;\n  gap: 12px;\n  align-items: center;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-size: 15px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.7);\n"], ["\n  font-size: 15px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.7);\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n"], ["\n  font-size: 16px;\n  font-weight: 800;\n  color: rgba(0, 27, 59, 0.94);\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  opacity: ", ";\n  touch-action: none;\n  user-select: none;\n  min-width: 0;\n"], ["\n  position: relative;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  cursor: ", ";\n  opacity: ", ";\n  touch-action: none;\n  user-select: none;\n  min-width: 0;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: #E5E9F0;\n  border-radius: 999px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: #E5E9F0;\n  border-radius: 999px;\n  pointer-events: none;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  height: 6px;\n  background: #A98DF6;\n  border-radius: 999px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  height: 6px;\n  background: #A98DF6;\n  border-radius: 999px;\n  pointer-events: none;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: #FFFFFF;\n  border: 3px solid #A98DF6;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(169, 141, 246, 0.30);\n  transform: translateX(-50%);\n  top: 50%;\n  margin-top: -9px;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: #FFFFFF;\n  border: 3px solid #A98DF6;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(169, 141, 246, 0.30);\n  transform: translateX(-50%);\n  top: 50%;\n  margin-top: -9px;\n  pointer-events: none;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.status-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.status-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.3px;\n  margin-left: 10px;\n\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.3px;\n  margin-left: 10px;\n\n  ", "\n  ", "\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  width: 260px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.add-product-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.add-product-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 300px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 24px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 300px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 24px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: #3A507B;\n    color: #3A507B;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: #3A507B;\n    color: #3A507B;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: #DC2626;\n    color: #DC2626;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"], ["\n  background: transparent;\n  border: 1.5px solid #E5E9F0;\n  border-radius: 10px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    border-color: #DC2626;\n    color: #DC2626;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.trash-disabled-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.trash-disabled-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  right: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 280px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    right: 12px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  right: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 280px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    right: 12px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 110px 1fr 30px 110px;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 4px;\n  padding: 0;\n"], ["\n  display: grid;\n  grid-template-columns: 110px 1fr 30px 110px;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 4px;\n  padding: 0;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.4);\n  text-align: center;\n"], ["\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.4);\n  text-align: center;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 4px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 4px;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border: none;\n  padding: 10px 22px;\n  border-radius: 10px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: ", ";\n  transition: background 0.15s ease, transform 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: ", ";\n    cursor: not-allowed;\n    transform: none;\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n  border: none;\n  padding: 10px 22px;\n  border-radius: 10px;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: ", ";\n  transition: background 0.15s ease, transform 0.15s ease;\n  box-shadow: ", ";\n\n  &:hover:not(:disabled) {\n    background: #2E3F62;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: ", ";\n    cursor: not-allowed;\n    transform: none;\n  }\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.6);\n  background: #F5F7FB;\n  border-radius: 8px;\n  padding: 4px 8px;\n  text-align: center;\n"], ["\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.6);\n  background: #F5F7FB;\n  border-radius: 8px;\n  padding: 4px 8px;\n  text-align: center;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  background: #FFFFFF;\n  border: 1px dashed #E5E9F0;\n  border-radius: 14px;\n  padding: 36px 24px;\n  text-align: center;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.6);\n\n  h3 {\n    margin: 0 0 6px;\n    font-size: 18px;\n    font-weight: 800;\n    color: rgba(0, 27, 59, 0.94);\n  }\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n"], ["\n  background: #FFFFFF;\n  border: 1px dashed #E5E9F0;\n  border-radius: 14px;\n  padding: 36px 24px;\n  text-align: center;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  color: rgba(0, 27, 59, 0.6);\n\n  h3 {\n    margin: 0 0 6px;\n    font-size: 18px;\n    font-weight: 800;\n    color: rgba(0, 27, 59, 0.94);\n  }\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _roundNotStarted = __webpack_require__(259);
	
	var _roundNotStarted2 = _interopRequireDefault(_roundNotStarted);
	
	var _addProductPage = __webpack_require__(1247);
	
	var _addProductPage2 = _interopRequireDefault(_addProductPage);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _LoadingIndicator = __webpack_require__(1403);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _submitDecisions = __webpack_require__(261);
	
	var _submitDecisions2 = _interopRequireDefault(_submitDecisions);
	
	var _utils = __webpack_require__(18);
	
	var _PDSensor = __webpack_require__(1246);
	
	var _PDSensor2 = _interopRequireDefault(_PDSensor);
	
	var _ImageSensor = __webpack_require__(2565);
	
	var _ImageSensor2 = _interopRequireDefault(_ImageSensor);
	
	var _roleButtons = __webpack_require__(258);
	
	var _roleButtons2 = _interopRequireDefault(_roleButtons);
	
	var _style = __webpack_require__(255);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _style3 = __webpack_require__(78);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _lastStep = __webpack_require__(254);
	
	var _lastStep2 = _interopRequireDefault(_lastStep);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _firstDecisionModal = __webpack_require__(253);
	
	var _firstDecisionModal2 = _interopRequireDefault(_firstDecisionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PRODUCTS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/products/";
	
	var FEATURES = [{ key: "pixels_rank", durationKey: "pixels_duration", label: "Resolution" }, { key: "sensitivity_rank", durationKey: "sensitivity_duration", label: "Sensitivity" }, { key: "power_rank", durationKey: "power_duration", label: "Power" }, { key: "temp_range_rank", durationKey: "temp_range_duration", label: "Temperature" }];
	
	var ROUND_1_MAX = 2;
	var TOTAL_MAX = 4;
	
	// ---------- styled components (lead-page only) ----------
	
	var ProductsGrid = _styledComponents2.default.div(_templateObject);
	
	var ProductCard = _styledComponents2.default.div(_templateObject2);
	
	var CardTopRow = _styledComponents2.default.div(_templateObject3);
	
	var CardLeft = _styledComponents2.default.div(_templateObject4);
	
	var SensorWrap = _styledComponents2.default.div(_templateObject5);
	
	var ProductName = _styledComponents2.default.div(_templateObject6);
	
	var ProductMeta = _styledComponents2.default.div(_templateObject7);
	
	var CardActions = _styledComponents2.default.div(_templateObject8);
	
	var IconButton = _styledComponents2.default.button(_templateObject9, function (p) {
	  return p.danger ? "#DC2626" : "#3A507B";
	}, function (p) {
	  return p.danger ? "#DC2626" : "#3A507B";
	});
	
	var RDCost = _styledComponents2.default.div(_templateObject10);
	
	var FeatureList = _styledComponents2.default.div(_templateObject11);
	
	var FeatureRow = _styledComponents2.default.div(_templateObject12);
	
	var FeatureLabel = _styledComponents2.default.div(_templateObject13);
	
	var RankValue = _styledComponents2.default.div(_templateObject14);
	
	// Custom div-based slider for product feature ranks (1-10, integer
	// steps). Identical to the slider used in the add-product overlay —
	// duplicated inline here to keep the card editable in place. Drag
	// updates flow back via props.onChange(value).
	var SliderRoot = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.disabled ? "not-allowed" : "pointer";
	}, function (p) {
	  return p.disabled ? 0.5 : 1;
	});
	
	var SliderTrack = _styledComponents2.default.div(_templateObject16);
	
	var SliderFill = _styledComponents2.default.div(_templateObject17);
	
	var SliderThumb = _styledComponents2.default.div(_templateObject18);
	
	var FeatureSlider = function (_Component) {
	  _inherits(FeatureSlider, _Component);
	
	  function FeatureSlider(props) {
	    _classCallCheck(this, FeatureSlider);
	
	    var _this = _possibleConstructorReturn(this, (FeatureSlider.__proto__ || Object.getPrototypeOf(FeatureSlider)).call(this, props));
	
	    _this.setRef = function (el) {
	      _this.rootEl = el;
	    };
	
	    _this.updateFromX = function (clientX) {
	      if (!_this.rootEl || _this.props.disabled) return;
	      var rect = _this.rootEl.getBoundingClientRect();
	      if (rect.width <= 0) return;
	      var _this$props = _this.props,
	          min = _this$props.min,
	          max = _this$props.max;
	
	      var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
	      var raw = min + (max - min) * ratio;
	      raw = Math.round(raw);
	      raw = Math.max(min, Math.min(max, raw));
	      if (_this.props.onChange) _this.props.onChange(raw);
	    };
	
	    _this.onMouseDown = function (e) {
	      if (_this.props.disabled) return;
	      e.preventDefault();
	      _this.setState({ dragging: true });
	      _this.attach();
	      _this.updateFromX(e.clientX);
	    };
	
	    _this.onTouchStart = function (e) {
	      if (_this.props.disabled || !e.touches || !e.touches.length) return;
	      _this.setState({ dragging: true });
	      _this.attach();
	      _this.updateFromX(e.touches[0].clientX);
	    };
	
	    _this.onWindowMove = function (e) {
	      if (!_this.state.dragging) return;
	      _this.updateFromX(e.clientX);
	    };
	
	    _this.onWindowTouchMove = function (e) {
	      if (!_this.state.dragging || !e.touches || !e.touches.length) return;
	      e.preventDefault();
	      _this.updateFromX(e.touches[0].clientX);
	    };
	
	    _this.onWindowUp = function () {
	      if (!_this.state.dragging) return;
	      _this.setState({ dragging: false });
	      _this.detach();
	    };
	
	    _this.state = { dragging: false };
	    return _this;
	  }
	
	  _createClass(FeatureSlider, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.detach();
	    }
	  }, {
	    key: "attach",
	    value: function attach() {
	      window.addEventListener("mousemove", this.onWindowMove);
	      window.addEventListener("mouseup", this.onWindowUp);
	      window.addEventListener("touchmove", this.onWindowTouchMove, { passive: false });
	      window.addEventListener("touchend", this.onWindowUp);
	    }
	  }, {
	    key: "detach",
	    value: function detach() {
	      window.removeEventListener("mousemove", this.onWindowMove);
	      window.removeEventListener("mouseup", this.onWindowUp);
	      window.removeEventListener("touchmove", this.onWindowTouchMove);
	      window.removeEventListener("touchend", this.onWindowUp);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          min = _props.min,
	          max = _props.max,
	          disabled = _props.disabled;
	
	      var range = max - min;
	      var pct = range > 0 ? Math.max(0, Math.min(100, (Number(value) - min) / range * 100)) : 0;
	      return _react2.default.createElement(
	        SliderRoot,
	        {
	          innerRef: this.setRef,
	          onMouseDown: this.onMouseDown,
	          onTouchStart: this.onTouchStart,
	          disabled: disabled
	        },
	        _react2.default.createElement(SliderTrack, null),
	        _react2.default.createElement(SliderFill, { style: { width: pct + "%" } }),
	        _react2.default.createElement(SliderThumb, { style: { left: pct + "%" } })
	      );
	    }
	  }]);
	
	  return FeatureSlider;
	}(_react.Component);
	
	// Pill-shaped Released / Not Released Yet badge mirroring the Manage
	// Production page. Hovering "Not Released Yet" surfaces a short tooltip
	// explaining the constraint.
	
	
	var StatusBadgeWrapper = _styledComponents2.default.span(_templateObject19);
	
	var StatusBadge = _styledComponents2.default.span(_templateObject20, function (p) {
	  return p.variant === 'released' && "\n    background: #E8F5EC;\n    color: #2DA548;\n    border: 1px solid #B7DEC2;\n  ";
	}, function (p) {
	  return p.variant === 'not-released' && "\n    background: #FFF1DD;\n    color: #C77700;\n    border: 1px solid #F0CB91;\n    cursor: help;\n  ";
	});
	
	var StatusTooltip = _styledComponents2.default.span(_templateObject21);
	
	// Wrapper that anchors a tooltip above the disabled Add Product button
	// in Year 1. Anchors below the button (top: 100%) so it doesn't collide
	// with the page title above.
	var AddProductTooltipWrapper = _styledComponents2.default.span(_templateObject22);
	
	var AddProductTooltip = _styledComponents2.default.span(_templateObject23);
	
	// Pencil icon for the per-card edit action. Same chrome as TrashButton
	// so the two sit visually as a paired action group on the card header.
	var EditButton = _styledComponents2.default.button(_templateObject24);
	
	// Trash icon for the per-card delete action. Inline SVG keeps it free
	// from icon-pack dependencies and lets us recolor on hover.
	var TrashButton = _styledComponents2.default.button(_templateObject25);
	
	// Wrapper + tooltip for the disabled trash button on prior-round
	// products. Anchored below the icon so the tooltip doesn't collide
	// with the card header above.
	var TrashTooltipWrapper = _styledComponents2.default.span(_templateObject26);
	
	var TrashDisabledTooltip = _styledComponents2.default.span(_templateObject27);
	
	var ColumnHeaderRow = _styledComponents2.default.div(_templateObject28);
	
	var ColumnHeader = _styledComponents2.default.div(_templateObject29);
	
	var CardFooter = _styledComponents2.default.div(_templateObject30);
	
	var UpdateButton = _styledComponents2.default.button(_templateObject31, function (p) {
	  return p.active ? "#3A507B" : "#E5E9F0";
	}, function (p) {
	  return p.active ? "#FFFFFF" : "rgba(0, 27, 59, 0.4)";
	}, function (p) {
	  return p.active ? "pointer" : "not-allowed";
	}, function (p) {
	  return p.active ? "0 4px 12px rgba(58, 80, 123, 0.25)" : "none";
	}, function (p) {
	  return p.active ? 0.6 : 1;
	});
	
	var ReleaseCell = _styledComponents2.default.div(_templateObject32);
	
	var EmptyState = _styledComponents2.default.div(_templateObject33);
	
	// ---------- component ----------
	
	var PDDecisions = function (_Component2) {
	  _inherits(PDDecisions, _Component2);
	
	  function PDDecisions(props) {
	    _classCallCheck(this, PDDecisions);
	
	    var _this2 = _possibleConstructorReturn(this, (PDDecisions.__proto__ || Object.getPrototypeOf(PDDecisions)).call(this, props));
	
	    _initialiseProps.call(_this2);
	
	    _this2._isMounted = false;
	
	    var role = _Auth2.default.getRole();
	    var has_access = role === "CEO" || role === "PD";
	    var isOwnRole = role === "PD";
	
	    _this2.state = {
	      products: {},
	      product_manufactures: [],
	      // team_products is the enriched product list from team-decisions
	      // (role=product). We need months_available_to_produce off it to
	      // drive the Released / Not Released Yet badge.
	      team_products: [],
	      // Buffered slider edits keyed by product id. Empty until the user
	      // moves a slider; cleared on successful PATCH. Used both to drive
	      // the slider UI and to gate the Update button.
	      editedRanks: {},
	      // Product id currently being PATCHed — disables Update + sliders
	      // for just that card.
	      savingProductId: null,
	      loading: true,
	      hasAccess: has_access,
	      isOwnRole: isOwnRole,
	      roleAlert: false,
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      submission_data: {
	        pd: { date: "N/A", unaccepted: 0 }
	      },
	      submitDecisionsLoading: false,
	      rounds: props.rounds,
	      isPreChecked: false,
	      successMessage: null,
	      errorMessage: null,
	      showAddProductPage: false,
	      // First-time coaching popup after the team's first product
	      // creation in Round 1. See handleFirstProductCreated below.
	      firstProductModalOpen: false,
	      deleteConfirmationUid: null,
	      // Product currently being edited via the Edit Product popup.
	      // null when no edit popup is open; otherwise the uid of the
	      // product whose features the user is changing.
	      editingUid: null
	    };
	
	    _this2.eventemitter = _eventEmitter2.default.getInstance();
	    return _this2;
	  }
	
	  _createClass(PDDecisions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.loadProducts();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      if (this.timer) {
	        clearTimeout(this.timer);
	        this.timer = null;
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds !== nextProps.rounds) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this3.loadProducts();
	          _this3.reloadRole();
	        });
	      }
	    }
	
	    // ---------- gating + helpers ----------
	
	  }, {
	    key: "renderProductsSection",
	    value: function renderProductsSection() {
	      var products = this.state.products;
	
	      var currentYear = this.currentYear;
	      // Newest product first so the latest creation sits in the top-left
	      // slot of the grid, then fills rightward. Product ids are
	      // auto-incremented so higher id = more recently created.
	      var uids = Object.keys(products).sort(function (a, b) {
	        var aId = Number((products[a] && products[a][currentYear] || {}).id) || 0;
	        var bId = Number((products[b] && products[b][currentYear] || {}).id) || 0;
	        return bId - aId;
	      });
	
	      if (uids.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        ProductsGrid,
	        null,
	        uids.map(this.renderProductCard)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // Lock the page for students only when no round has ever been
	      // started. Does not fire for finished games (see ceo-decisions.js
	      // for the full explanation).
	      var _props2 = this.props,
	          rounds = _props2.rounds,
	          rounds_loaded = _props2.rounds_loaded;
	
	      var hasEverStarted = (rounds || []).some(function (r) {
	        return r && r.is_started === true;
	      });
	      if (rounds_loaded && !hasEverStarted) {
	        return _react2.default.createElement(_roundNotStarted2.default, null);
	      }
	
	      var _props3 = this.props,
	          location = _props3.location,
	          router = _props3.router,
	          round = _props3.currentRound;
	      var _state = this.state,
	          products = _state.products,
	          isOwnRole = _state.isOwnRole,
	          roleAlert = _state.roleAlert,
	          submission_data = _state.submission_data,
	          submitDecisionsLoading = _state.submitDecisionsLoading,
	          loading = _state.loading,
	          isPreChecked = _state.isPreChecked,
	          successMessage = _state.successMessage,
	          errorMessage = _state.errorMessage,
	          showAddProductPage = _state.showAddProductPage,
	          deleteConfirmationUid = _state.deleteConfirmationUid;
	
	      var actionsAllowed = this.actionsAllowed;
	      var canAddProduct = this.canAddProduct;
	      var showAddProductButton = actionsAllowed && !loading;
	      var deleteTarget = deleteConfirmationUid && products[deleteConfirmationUid] ? products[deleteConfirmationUid][this.currentYear] : null;
	
	      return _react2.default.createElement(
	        _style2.default.BodyWrapper,
	        null,
	        _react2.default.createElement(_lastStep2.default, {
	          location: location,
	          router: router,
	          url: "/decisions/product-development?round=" + round
	        }),
	        _react2.default.createElement(
	          _style2.default.TitleWrapper,
	          null,
	          _react2.default.createElement(
	            _style2.default.Title,
	            { id: "product-development-decisions-title" },
	            "Product Management",
	            isOwnRole && _react2.default.createElement(_roleButtons2.default, { type: "product_development" })
	          ),
	          actionsAllowed === true && loading === false && _react2.default.createElement(_submitDecisions2.default, {
	            id: "product-development-submit-decisions",
	            tooltipPlacement: "bottom",
	            data: submission_data.pd,
	            isLoading: submitDecisionsLoading,
	            onClick: this.submitDecisions,
	            buttonComponent: _style2.default.SubmitDecisionButton,
	            isPreChecked: isPreChecked
	          })
	        ),
	        _react2.default.createElement(
	          _style2.default.Subtitle,
	          null,
	          "Design an image sensor product to sell. Every product is built on four features: Resolution, Sensitivity, Power, and Temperature. You can create up to 2 in Year 1, plus 2 more in later years. Keep upgrading existing products each year to stay competitive."
	        ),
	        showAddProductButton && _react2.default.createElement(
	          _style4.default.ManageButtonBar,
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            AddProductTooltipWrapper,
	            {
	              style: !canAddProduct ? { cursor: 'not-allowed' } : undefined
	            },
	            _react2.default.createElement(
	              _style4.default.ManageButton,
	              {
	                onClick: this.openAddProductPage,
	                disabled: !canAddProduct,
	                style: !canAddProduct ? { opacity: 0.6, pointerEvents: 'none' } : undefined
	              },
	              "Add Product"
	            ),
	            !canAddProduct && this.isRound1 && _react2.default.createElement(
	              AddProductTooltip,
	              { className: "add-product-tooltip" },
	              "You can only create ",
	              ROUND_1_MAX,
	              " products in Year 1. You'll be able to add more in later years."
	            )
	          )
	        ),
	        roleAlert && _react2.default.createElement(_error2.default, {
	          title: "Error | Not Authorized",
	          message: "You are not authorized to make decisions for this role.",
	          onHide: this.hideRoleAlert
	        }),
	        errorMessage && _react2.default.createElement(_error2.default, {
	          title: errorMessage.title,
	          message: errorMessage.message,
	          onHide: this.hideErrorMessage
	        }),
	        successMessage && _react2.default.createElement(_success2.default, { message: successMessage }),
	        _react2.default.createElement(_LoadingIndicator2.default, { loading: loading }),
	        loading === false && _react2.default.createElement(
	          _style4.default.KpiRow,
	          { cardCount: 4, style: { marginTop: 16 } },
	          _react2.default.createElement(
	            _style4.default.KpiCard,
	            null,
	            _react2.default.createElement(
	              _style4.default.KpiLabel,
	              null,
	              "Total R&D Costs"
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiValue,
	              { style: { color: '#C62828' } },
	              "$",
	              Math.round(this.totalRDCosts).toLocaleString('en-US')
	            )
	          )
	        ),
	        loading === false && _react2.default.createElement(
	          _style4.default.SectionCard,
	          { style: { marginTop: 16 } },
	          _react2.default.createElement(
	            _style4.default.SectionHeader,
	            null,
	            _react2.default.createElement(
	              _style4.default.SectionTitle,
	              null,
	              "Products"
	            ),
	            _react2.default.createElement(
	              _style4.default.SectionSubtitle,
	              null,
	              "Create a product to sell to customers."
	            )
	          ),
	          this.renderProductsSection()
	        ),
	        showAddProductPage && _react2.default.createElement(_addProductPage2.default, {
	          existingProducts: products,
	          reloadProducts: this.loadProducts,
	          showSuccessMessage: this.showSuccessMessage,
	          onClose: this.closeAddProductPage,
	          currentRound: this.state.currentRound,
	          onFirstProductCreated: this.handleFirstProductCreated
	        }),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.firstProductModalOpen,
	          title: "Nice work on creating your first product!",
	          body: "You can edit this product any time before the round deadline. You can also add a second product. Make sure your product is released in the current round, otherwise your team will get a 0% score for this round.",
	          ctaLabel: "Got it",
	          onCta: this.handleFirstProductClose,
	          onClose: this.handleFirstProductClose
	        }),
	        this.state.editingUid && products[this.state.editingUid] && products[this.state.editingUid][this.currentYear] && _react2.default.createElement(_addProductPage2.default, {
	          editingProduct: products[this.state.editingUid][this.currentYear],
	          existingProducts: products,
	          reloadProducts: this.loadProducts,
	          showSuccessMessage: this.showSuccessMessage,
	          onClose: this.closeEditProductPage
	        }),
	        deleteTarget && _react2.default.createElement(_warning2.default, {
	          title: "Delete Product",
	          successButtonText: "Yes, Delete",
	          onSuccess: this.confirmDeleteProduct,
	          onCancel: this.cancelDeleteProduct,
	          message: _react2.default.createElement(
	            "span",
	            null,
	            "Are you sure you want to delete ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              deleteTarget.name
	            ),
	            "? This can't be undone, and it will remove any pricing or promo decisions tied to this product."
	          )
	        })
	      );
	    }
	  }, {
	    key: "currentYear",
	    get: function get() {
	      var _state2 = this.state,
	          roundInUrl = _state2.roundInUrl,
	          currentRound = _state2.currentRound;
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) return roundInUrl;
	      return currentRound;
	    }
	  }, {
	    key: "actionsAllowed",
	    get: function get() {
	      if (this.state.hasAccess === false) return false;
	      if (this.props.roundShouldBeFinished === true) return false;
	      var _state3 = this.state,
	          roundInUrl = _state3.roundInUrl,
	          currentRound = _state3.currentRound,
	          rounds = _state3.rounds;
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) return false;
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	      if (!round) return false;
	      return round.is_started === true && round.is_finished === false;
	    }
	  }, {
	    key: "isRound1",
	    get: function get() {
	      return Number(this.currentYear) === 1;
	    }
	  }, {
	    key: "productCount",
	    get: function get() {
	      return Object.keys(this.state.products).length;
	    }
	  }, {
	    key: "maxProductsForRound",
	    get: function get() {
	      return this.isRound1 ? ROUND_1_MAX : TOTAL_MAX;
	    }
	  }, {
	    key: "canAddProduct",
	    get: function get() {
	      return this.actionsAllowed && this.productCount < this.maxProductsForRound;
	    }
	
	    // ---------- KPI computations ----------
	
	  }, {
	    key: "totalRDCosts",
	    get: function get() {
	      var products = this.state.products;
	
	      var currentYear = this.currentYear;
	      return Object.keys(products).reduce(function (sum, uid) {
	        var data = products[uid][currentYear] || {};
	        return sum + Math.abs(Number(data.rnd_costs) || 0);
	      }, 0);
	    }
	
	    // Mirrors the Manage Production page: a product is "Released" when
	    // months_available_to_produce > 0 on the team-decisions products
	    // entry for this product id.
	
	
	    // ---------- handlers ----------
	
	    // Fired by AddProductPage after the team's first successful product
	    // creation in Round 1. Shows a coaching modal reminding students they
	    // can edit the product before deadline, add a second one, and must
	    // ensure it releases in the current round or the team scores 0%.
	
	
	    // Get the current rank value for a product/feature, either from
	    // buffered local edits or (falling back to) the saved product row.
	
	
	    // Has the user moved any slider on this product? Drives the Update
	    // button's active state.
	
	
	    // Edit is the only path for changing a product's feature ranks now —
	    // the inline sliders are read-only. Mirrors the legacy in-production
	    // guard before opening the popup so the user sees the explanation
	    // before they start changing values.
	
	
	    // Delete is only allowed for a product that was CREATED in the round
	    // currently being viewed. A product carried over from an earlier round
	    // surfaces the friendly message: once it exists in a prior round it
	    // can only be upgraded or abandoned, not removed.
	    //
	    // Detection: each product row carries `origin_round` (the id of the
	    // round it was first created in). If that doesn't match the current
	    // round's id, it's a carry-over.
	
	
	    // ---------- render ----------
	
	
	  }]);
	
	  return PDDecisions;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.showSuccessMessage = function (successMessage) {
	    _this4.setState({ successMessage: successMessage }, function () {
	      return _this4.hideSuccessMessage();
	    });
	  };
	
	  this.hideSuccessMessage = function () {
	    setTimeout(function () {
	      if (!_this4._isMounted) return;
	      _this4.setState({ successMessage: null });
	    }, 5000);
	  };
	
	  this.setErrorMessage = function (title, message) {
	    _this4.setState({ errorMessage: { title: title, message: message } });
	  };
	
	  this.hideErrorMessage = function () {
	    _this4.setState({ errorMessage: null });
	  };
	
	  this.reloadRole = function () {
	    var role = _Auth2.default.getRole();
	    _this4.setState({
	      hasAccess: role === "CEO" || role === "PD",
	      isOwnRole: role === "PD"
	    });
	  };
	
	  this.showRoleAlert = function () {
	    return _this4.setState({ roleAlert: true });
	  };
	
	  this.hideRoleAlert = function () {
	    return _this4.setState({ roleAlert: false });
	  };
	
	  this.submitDecisions = function () {
	    _this4.setState({ submitDecisionsLoading: true });
	    (0, _SubmitDecisions.submitDecisions)("development", _this4.state.roundInUrl || _this4.state.currentRound, function () {
	      return _this4.getSubmissionData();
	    });
	  };
	
	  this.loadProducts = function () {
	    var _state4 = _this4.state,
	        rounds = _state4.rounds,
	        roundInUrl = _state4.roundInUrl,
	        currentRound = _state4.currentRound;
	
	
	    if (!rounds || rounds.length === 0) {
	      _this4.timer = setTimeout(_this4.loadProducts, 1000);
	      return;
	    }
	
	    var roundNumber = roundInUrl || currentRound;
	
	    // team-decisions (role=product) is the single source of truth for
	    // this page. The response already carries the round-scoped
	    // products[] (with rnd_costs, ranks, durations, and
	    // months_available_to_produce) plus product_manufactures[] — so
	    // there's no need for separate /products/ or /product_manufactures/
	    // round-trips. team-status still gives us submission_data.pd.
	    Promise.all([(0, _TeamDecisionsService.fetchTeamStatus)(roundNumber), (0, _TeamDecisionsService.fetchTeamDecisions)(roundNumber, 'product')]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          statusData = _ref2[0],
	          decisionsData = _ref2[1];
	
	      if (!_this4._isMounted) return;
	
	      var currentYear = _this4.currentYear;
	      var team_products = decisionsData.products || [];
	
	      // Render code keys products by uid → year → product. Every row
	      // in the team-decisions response is for the requested round, so
	      // we always nest under currentYear.
	      var productsByUid = {};
	      team_products.forEach(function (product) {
	        if (!product.uid) return;
	        if (!(product.uid in productsByUid)) productsByUid[product.uid] = {};
	        productsByUid[product.uid][currentYear] = product;
	      });
	
	      // team-decisions already returns product_manufactures scoped to
	      // the requested round, so we can use the array as-is.
	      var product_manufactures = decisionsData.product_manufactures || [];
	
	      var isPreChecked = statusData.submission_data.pd && statusData.submission_data.pd.date !== 'N/A';
	
	      _this4.setState({
	        products: productsByUid,
	        product_manufactures: product_manufactures,
	        team_products: team_products,
	        // Wipe any buffered slider edits — the freshly-loaded ranks
	        // are the new source of truth.
	        editedRanks: {},
	        loading: false,
	        isPreChecked: isPreChecked,
	        submission_data: statusData.submission_data,
	        submitDecisionsLoading: false
	      });
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "PDDecisions", "loadProducts");
	      if (_this4._isMounted) _this4.setState({ loading: false });
	    });
	  };
	
	  this.getSubmissionData = function () {
	    _this4.setState({ submitDecisionsLoading: true });
	    _this4.loadProducts();
	  };
	
	  this.isProductReleased = function (productId) {
	    var tp = (_this4.state.team_products || []).find(function (p) {
	      return Number(p.id) === Number(productId);
	    });
	    if (!tp) return false;
	    return (Number(tp.months_available_to_produce) || 0) > 0;
	  };
	
	  this.handleFirstProductCreated = function () {
	    _this4.setState({ firstProductModalOpen: true });
	  };
	
	  this.handleFirstProductClose = function () {
	    _this4.setState({ firstProductModalOpen: false });
	  };
	
	  this.openAddProductPage = function () {
	    if (!_this4.state.hasAccess) {
	      _this4.showRoleAlert();
	      return;
	    }
	    if (!_this4.canAddProduct) {
	      _this4.setErrorMessage("Can't add another product", _this4.isRound1 ? "You can create up to " + ROUND_1_MAX + " products in Year 1. Submit your existing products first, then add more in later years." : "You already have the maximum of " + TOTAL_MAX + " products. Edit an existing product to refine it.");
	      return;
	    }
	    _this4.setState({ showAddProductPage: true });
	  };
	
	  this.closeAddProductPage = function () {
	    return _this4.setState({ showAddProductPage: false });
	  };
	
	  this.rankFor = function (productData, key) {
	    var edits = _this4.state.editedRanks[productData.id];
	    if (edits && edits[key] != null) return Number(edits[key]);
	    return Number(productData[key]) || 0;
	  };
	
	  this.isDirtyFor = function (productData) {
	    var edits = _this4.state.editedRanks[productData.id];
	    if (!edits) return false;
	    return FEATURES.some(function (feature) {
	      var next = Number(edits[feature.key]);
	      var prev = Number(productData[feature.key]) || 0;
	      return Number.isFinite(next) && next !== prev;
	    });
	  };
	
	  this.onRankChange = function (productData, key) {
	    return function (value) {
	      if (!_this4.actionsAllowed) return;
	      var existing = _this4.state.editedRanks[productData.id] || {};
	      _this4.setState({
	        editedRanks: Object.assign({}, _this4.state.editedRanks, _defineProperty({}, productData.id, Object.assign({}, existing, _defineProperty({}, key, value))))
	      });
	    };
	  };
	
	  this.updateProduct = function (productData) {
	    return function () {
	      if (!_this4.actionsAllowed) return;
	      if (!_this4.isDirtyFor(productData)) return;
	      if (!_this4.state.hasAccess) {
	        _this4.showRoleAlert();
	        return;
	      }
	
	      // Block updates if Operations has already started production —
	      // mirrors the legacy guard so the request doesn't succeed and
	      // leave orphaned manufacture rows behind. A manufacture row with
	      // units_produced === 0 is a draft / cleared decision and does not
	      // count as "in production".
	      var inProduction = _this4.state.product_manufactures.some(function (m) {
	        return Number(m.product) === Number(productData.id) && Number(m.units_produced) > 0;
	      });
	      if (inProduction) {
	        _this4.setErrorMessage("Product is in production", "You can't edit a product's features while it's in production. Cancel the production decision in Operations first, then come back and edit.");
	        return;
	      }
	
	      var edits = _this4.state.editedRanks[productData.id] || {};
	      var payload = {};
	      FEATURES.forEach(function (feature) {
	        payload[feature.key] = edits[feature.key] != null ? edits[feature.key] : Number(productData[feature.key]) || 0;
	      });
	
	      _this4.setState({ savingProductId: productData.id });
	
	      (0, _ApiService.patchRequest)("" + PRODUCTS_URL + productData.id + "/").send(payload).then(function () {
	        (0, _SubmitDecisions.incrementUnacceptedDecisions)("development");
	        if (!_this4._isMounted) return;
	        _this4.setState({ savingProductId: null });
	        _this4.showSuccessMessage("Product \"" + productData.name + "\" was successfully updated.");
	        _this4.loadProducts();
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "PDDecisions", "updateProduct");
	        if (_this4._isMounted) {
	          _this4.setState({
	            savingProductId: null,
	            errorMessage: {
	              title: "Couldn't update product",
	              message: "Something went wrong saving these changes. Please try again."
	            }
	          });
	        }
	      });
	    };
	  };
	
	  this.requestEditProduct = function (uid) {
	    return function () {
	      if (!_this4.state.hasAccess) {
	        _this4.showRoleAlert();
	        return;
	      }
	      var productRounds = _this4.state.products[uid];
	      var productData = productRounds ? productRounds[_this4.currentYear] : null;
	      if (!productData) return;
	
	      var inProduction = _this4.state.product_manufactures.some(function (m) {
	        return Number(m.product) === Number(productData.id) && Number(m.units_produced) > 0;
	      });
	      if (inProduction) {
	        _this4.setErrorMessage("Product is in production", "You can't edit a product's features while it's in production. Cancel the production decision in Operations first, then come back and edit.");
	        return;
	      }
	
	      _this4.setState({ editingUid: uid });
	    };
	  };
	
	  this.closeEditProductPage = function () {
	    _this4.setState({ editingUid: null });
	  };
	
	  this.requestDeleteProduct = function (uid) {
	    return function () {
	      if (!_this4.state.hasAccess) {
	        _this4.showRoleAlert();
	        return;
	      }
	
	      var _state5 = _this4.state,
	          products = _state5.products,
	          rounds = _state5.rounds;
	
	      var productData = products[uid] && products[uid][_this4.currentYear];
	      var currentRoundObj = (rounds || []).find(function (r) {
	        return Number(r.number) === Number(_this4.currentYear);
	      });
	      var currentRoundId = currentRoundObj ? Number(currentRoundObj.id) : null;
	      var createdThisRound = productData && currentRoundId != null && Number(productData.origin_round) === currentRoundId;
	
	      if (!createdThisRound) {
	        _this4.setErrorMessage("Product deletion is only available in the round it was created", "Once a product carries over into a later round, you can either keep upgrading it to make it more competitive in the market, or stop investing in it and put resources into your other products. Editing the product is the way to make those upgrades.");
	        return;
	      }
	      _this4.setState({ deleteConfirmationUid: uid });
	    };
	  };
	
	  this.cancelDeleteProduct = function () {
	    return _this4.setState({ deleteConfirmationUid: null });
	  };
	
	  this.confirmDeleteProduct = function () {
	    var uid = _this4.state.deleteConfirmationUid;
	    if (!uid) return;
	    var productRounds = _this4.state.products[uid];
	    var productData = productRounds ? productRounds[_this4.currentYear] : null;
	    if (!productData) {
	      _this4.setState({ deleteConfirmationUid: null });
	      return;
	    }
	
	    // Block deletion if Operations has already started production for
	    // this product — mirrors the legacy guard so the request doesn't
	    // succeed and then leave orphaned manufacture rows behind. A
	    // manufacture row with units_produced === 0 is a draft / cleared
	    // decision and does not count as "in production".
	    var inProduction = _this4.state.product_manufactures.some(function (m) {
	      return Number(m.product) === Number(productData.id) && Number(m.units_produced) > 0;
	    });
	    if (inProduction) {
	      _this4.setState({
	        deleteConfirmationUid: null,
	        errorMessage: {
	          title: "You cannot delete this product yet",
	          message: "Operations has already started production for this product. Cancel that production decision first, then delete."
	        }
	      });
	      return;
	    }
	
	    (0, _ApiService.deleteRequest)("" + PRODUCTS_URL + productData.id + "/").then(function () {
	      (0, _SubmitDecisions.decrementUnacceptedDecisions)("development");
	      _this4.setState({ deleteConfirmationUid: null });
	      _this4.showSuccessMessage("Product \"" + productData.name + "\" was successfully deleted.");
	      _this4.loadProducts();
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "PDDecisions", "confirmDeleteProduct");
	      _this4.setState({
	        deleteConfirmationUid: null,
	        errorMessage: {
	          title: "Couldn't delete product",
	          message: "Something went wrong deleting this product. Please try again."
	        }
	      });
	    });
	  };
	
	  this.renderProductCard = function (uid) {
	    var _state6 = _this4.state,
	        products = _state6.products,
	        rounds = _state6.rounds;
	
	    var productRounds = products[uid];
	    var currentYear = _this4.currentYear;
	    var productData = productRounds[currentYear];
	    if (!productData) return null;
	
	    var rndCosts = Math.abs(Number(productData.rnd_costs) || 0);
	    var fmtMoney = function fmtMoney(v) {
	      return "$" + Math.round(v).toLocaleString('en-US');
	    };
	    var released = _this4.isProductReleased(productData.id);
	    // Sliders are always read-only — feature changes go through the
	    // Edit Product popup. Saving spinner stays scoped to that flow.
	    var slidersDisabled = true;
	
	    // Prior-round products can't be deleted. BE surfaces `origin_round`
	    // on each product row: if it doesn't match the current round's id,
	    // the product was created earlier and we disable the trash icon +
	    // explain why on hover. Same rule as requestDeleteProduct, but
	    // pre-checked so a stray click never opens the error popup.
	    var currentRoundObj = (rounds || []).find(function (r) {
	      return Number(r.number) === Number(_this4.currentYear);
	    });
	    var currentRoundId = currentRoundObj ? Number(currentRoundObj.id) : null;
	    var priorRoundProduct = currentRoundId != null && Number(productData.origin_round) !== currentRoundId;
	
	    return _react2.default.createElement(
	      ProductCard,
	      { key: uid },
	      _react2.default.createElement(
	        CardTopRow,
	        null,
	        _react2.default.createElement(
	          CardLeft,
	          null,
	          _react2.default.createElement(
	            SensorWrap,
	            null,
	            _react2.default.createElement("img", { src: _ImageSensor2.default, alt: "" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { minWidth: 0 } },
	            _react2.default.createElement(
	              "div",
	              { style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } },
	              _react2.default.createElement(
	                ProductName,
	                null,
	                productData.name
	              ),
	              released ? _react2.default.createElement(
	                StatusBadge,
	                { variant: "released" },
	                "Released"
	              ) : _react2.default.createElement(
	                StatusBadgeWrapper,
	                null,
	                _react2.default.createElement(
	                  StatusBadge,
	                  { variant: "not-released" },
	                  "Not Released Yet"
	                ),
	                _react2.default.createElement(
	                  StatusTooltip,
	                  { className: "status-tooltip" },
	                  "This product won't be released this year because one or more features have a release date beyond the current year. Check the Release Date column to see which features are pushing the timeline out."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              RDCost,
	              null,
	              "R&D Costs ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                fmtMoney(rndCosts)
	              )
	            )
	          )
	        ),
	        _this4.actionsAllowed && _react2.default.createElement(
	          CardActions,
	          null,
	          _react2.default.createElement(
	            EditButton,
	            {
	              onClick: _this4.requestEditProduct(uid),
	              "aria-label": "Edit " + productData.name,
	              title: "Edit " + productData.name
	            },
	            _react2.default.createElement(
	              "svg",
	              { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
	                strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	              _react2.default.createElement("path", { d: "M12 20h9" }),
	              _react2.default.createElement("path", { d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" })
	            )
	          ),
	          priorRoundProduct ? _react2.default.createElement(
	            TrashTooltipWrapper,
	            null,
	            _react2.default.createElement(
	              TrashButton,
	              {
	                disabled: true,
	                "aria-label": "Delete " + productData.name
	              },
	              _react2.default.createElement(
	                "svg",
	                { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
	                  strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	                _react2.default.createElement("polyline", { points: "3 6 5 6 21 6" }),
	                _react2.default.createElement("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }),
	                _react2.default.createElement("path", { d: "M10 11v6" }),
	                _react2.default.createElement("path", { d: "M14 11v6" }),
	                _react2.default.createElement("path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" })
	              )
	            ),
	            _react2.default.createElement(
	              TrashDisabledTooltip,
	              { className: "trash-disabled-tooltip" },
	              "You can't delete a product that was created in a prior round. Modifying it is more cost effective than building a new one."
	            )
	          ) : _react2.default.createElement(
	            TrashButton,
	            {
	              onClick: _this4.requestDeleteProduct(uid),
	              "aria-label": "Delete " + productData.name,
	              title: "Delete " + productData.name
	            },
	            _react2.default.createElement(
	              "svg",
	              { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
	                strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	              _react2.default.createElement("polyline", { points: "3 6 5 6 21 6" }),
	              _react2.default.createElement("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }),
	              _react2.default.createElement("path", { d: "M10 11v6" }),
	              _react2.default.createElement("path", { d: "M14 11v6" }),
	              _react2.default.createElement("path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ColumnHeaderRow,
	        null,
	        _react2.default.createElement(
	          ColumnHeader,
	          { style: { textAlign: 'left' } },
	          "Feature"
	        ),
	        _react2.default.createElement(
	          ColumnHeader,
	          null,
	          "\xA0"
	        ),
	        _react2.default.createElement(
	          ColumnHeader,
	          null,
	          "Quality Level"
	        ),
	        _react2.default.createElement(
	          ColumnHeader,
	          null,
	          "Release",
	          _react2.default.createElement("br", null),
	          "Date"
	        )
	      ),
	      _react2.default.createElement(
	        FeatureList,
	        null,
	        FEATURES.map(function (feature) {
	          var rank = _this4.rankFor(productData, feature.key);
	          return _react2.default.createElement(
	            FeatureRow,
	            { key: feature.key },
	            _react2.default.createElement(
	              FeatureLabel,
	              null,
	              feature.label
	            ),
	            _react2.default.createElement(FeatureSlider, {
	              min: 1,
	              max: 10,
	              value: rank,
	              onChange: _this4.onRankChange(productData, feature.key),
	              disabled: slidersDisabled
	            }),
	            _react2.default.createElement(
	              RankValue,
	              null,
	              rank
	            ),
	            _react2.default.createElement(
	              ReleaseCell,
	              null,
	              _react2.default.createElement(_PDSensor2.default, {
	                product: productRounds,
	                currentRound: currentYear,
	                rounds: rounds,
	                showReleaseDate: true,
	                showImage: false,
	                showAge: false,
	                duration_field: feature.durationKey
	              })
	            )
	          );
	        })
	      )
	    );
	  };
	};
	
	exports.default = (0, _reactEasyState.view)(PDDecisions);

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.make-decisions-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover > span.make-decisions-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 320px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 24px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateY(8px);\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  width: 320px;\n  text-align: left;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease, visibility 0.15s ease;\n  pointer-events: none;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 24px;\n    border: 5px solid transparent;\n    border-bottom-color: rgba(0, 27, 59, 0.94);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PMDecisionsRevenueForecast = __webpack_require__(1336);
	
	var _PMDecisionsRevenueForecast2 = _interopRequireDefault(_PMDecisionsRevenueForecast);
	
	var _PMDecisionsPromotionalSpend = __webpack_require__(1335);
	
	var _PMDecisionsPromotionalSpend2 = _interopRequireDefault(_PMDecisionsPromotionalSpend);
	
	var _PMDecisionsPlacement = __webpack_require__(1334);
	
	var _PMDecisionsPlacement2 = _interopRequireDefault(_PMDecisionsPlacement);
	
	var _managePromotionPage = __webpack_require__(1340);
	
	var _managePromotionPage2 = _interopRequireDefault(_managePromotionPage);
	
	var _setPricingPage = __webpack_require__(1341);
	
	var _setPricingPage2 = _interopRequireDefault(_setPricingPage);
	
	var _managePlacementPage = __webpack_require__(1339);
	
	var _managePlacementPage2 = _interopRequireDefault(_managePlacementPage);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _recharts = __webpack_require__(27);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _roundNotStarted = __webpack_require__(259);
	
	var _roundNotStarted2 = _interopRequireDefault(_roundNotStarted);
	
	var _firstDecisionModal = __webpack_require__(253);
	
	var _firstDecisionModal2 = _interopRequireDefault(_firstDecisionModal);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _submitDecisions = __webpack_require__(261);
	
	var _submitDecisions2 = _interopRequireDefault(_submitDecisions);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _roleButtons = __webpack_require__(258);
	
	var _roleButtons2 = _interopRequireDefault(_roleButtons);
	
	var _style = __webpack_require__(255);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _style3 = __webpack_require__(78);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _lastStep = __webpack_require__(254);
	
	var _lastStep2 = _interopRequireDefault(_lastStep);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Promo breakdown colors. Main category colors anchor the donut slices
	// and the category-row bullet. Each palette entry is a similar-but-
	// distinct shade applied to the sub-category (per-client) bullets in
	// order; the palettes wrap if the backend ever returns more channels
	// per category than we have shades for.
	var TRADITIONAL_COLOR = '#4CC7D1';
	var DIGITAL_COLOR = '#4C8AFF';
	var TRADITIONAL_PALETTE = ['#4CC7D1', '#5FD0D9', '#7BDAE1', '#38B5C0', '#2AA1AB'];
	var DIGITAL_PALETTE = ['#4C8AFF', '#6FA0FF', '#88B5FF', '#3A7AE8', '#2865D6'];
	
	// Wrapper + tooltip for the disabled "Make Decisions" button when no
	// products exist yet. Mirrors the AddProductTooltip pattern in
	// PDDecisions.js — pointer-events on the child button are killed so
	// the wrapper's :hover reliably fires.
	var MakeDecisionsTooltipWrapper = _styledComponents2.default.span(_templateObject);
	
	var MakeDecisionsTooltip = _styledComponents2.default.span(_templateObject2);
	
	var PMDecisions = function (_Component) {
	  _inherits(PMDecisions, _Component);
	
	  function PMDecisions(props) {
	    _classCallCheck(this, PMDecisions);
	
	    var _this = _possibleConstructorReturn(this, (PMDecisions.__proto__ || Object.getPrototypeOf(PMDecisions)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._isMounted = false;
	
	    var role = _Auth2.default.getRole();
	    var has_access = role === "CEO" || role === "PM";
	    var isOwnRole = role === "PM";
	
	    _this.state = {
	      marketing_clients: {},
	      marketing_clients_list: [],
	      sales_clients: {},
	      sales_clients_list: [],
	      sales: [],
	      promos: [],
	      price_forecasts: [],
	      products: [],
	      accountsReceivable: 0,
	      loaded: false,
	      hasAccess: has_access,
	      isOwnRole: isOwnRole,
	      roleAlert: false,
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds,
	      submission_data: {
	        pm: {
	          date: "N/A",
	          unaccepted: 0
	        }
	      },
	      submitDecisionsLoading: false,
	      showNoProductsModal: false,
	      isPreChecked: false,
	      successMessage: null,
	      showMakeDecisionsModal: false,
	      showManagePromotionPage: false,
	      showSetPricingPage: false,
	      showManagePlacementPage: false,
	      // First-time coaching popup after the user sets their first
	      // pricing in Round 1. See handleFirstPricingSet below.
	      firstDecisionModalOpen: false,
	      // Same idea for the first promo (Set Allocation) decision in
	      // Round 1. See handleFirstPromoSet below.
	      firstPromoModalOpen: false,
	      // Promo Spend Breakdown filter — 'all' or a product id. Drives
	      // which slice of promos.spend feeds the donut + per-channel list.
	      promoBreakdownProductId: 'all'
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(PMDecisions, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds && this.state.rounds.length === 0 && nextProps.rounds && nextProps.rounds.length !== 0) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	          _this2.reloadRole();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	
	      if (this.products_timer) {
	        clearTimeout(this.products_timer);
	        this.products_timer = null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      // Lock the page for students only when no round has ever been
	      // started. Does not fire for finished games (see ceo-decisions.js
	      // for the full explanation).
	      var _props = this.props,
	          rounds = _props.rounds,
	          rounds_loaded = _props.rounds_loaded;
	
	      var hasEverStarted = (rounds || []).some(function (r) {
	        return r && r.is_started === true;
	      });
	      if (rounds_loaded && !hasEverStarted) {
	        return _react2.default.createElement(_roundNotStarted2.default, null);
	      }
	
	      var actionsAllowed = this.actionsAllowed;
	      var _state = this.state,
	          isOwnRole = _state.isOwnRole,
	          accountsReceivable = _state.accountsReceivable,
	          showNoProductsModal = _state.showNoProductsModal,
	          isPreChecked = _state.isPreChecked,
	          successMessage = _state.successMessage,
	          showMakeDecisionsModal = _state.showMakeDecisionsModal;
	      var _props2 = this.props,
	          location = _props2.location,
	          router = _props2.router,
	          round = _props2.currentRound;
	
	
	      var fmtMoney = function fmtMoney(v) {
	        return "$" + Math.round(Math.abs(v)).toLocaleString('en-US');
	      };
	      var fmtMoneyM = function fmtMoneyM(v) {
	        return "$" + (Math.abs(v) / 1e6).toFixed(2) + "M";
	      };
	
	      return _react2.default.createElement(
	        _style2.default.BodyWrapper,
	        null,
	        _react2.default.createElement(_lastStep2.default, {
	          location: location,
	          router: router,
	          url: "/decisions/product-marketing?round=" + round
	        }),
	        _react2.default.createElement(
	          _style2.default.TitleWrapper,
	          null,
	          _react2.default.createElement(
	            _style2.default.Title,
	            { id: "product-marketing-decisions-title" },
	            "Product Marketing",
	            isOwnRole && _react2.default.createElement(_roleButtons2.default, { type: "product_marketing" })
	          ),
	          actionsAllowed === true && this.state.loaded === true && _react2.default.createElement(_submitDecisions2.default, {
	            id: "product-marketing-submit-decisions",
	            tooltipPlacement: "bottom",
	            data: this.state.submission_data.pm,
	            isLoading: this.state.submitDecisionsLoading,
	            onClick: this.submitDecisions,
	            buttonComponent: _style2.default.SubmitDecisionButton,
	            isPreChecked: isPreChecked
	          })
	        ),
	        _react2.default.createElement(
	          _style2.default.Subtitle,
	          null,
	          "Set the product price, then choose which promotional and sales channels to reach customers, along with how much to invest in each."
	        ),
	        actionsAllowed === true && this.state.loaded === true && function () {
	          var hasProducts = _this3.state.products && _this3.state.products.length > 0 || _this3.state.price_forecasts && _this3.state.price_forecasts.length > 0;
	          return _react2.default.createElement(
	            _style4.default.ManageButtonBar,
	            { style: { marginTop: 20 } },
	            _react2.default.createElement(
	              MakeDecisionsTooltipWrapper,
	              {
	                style: !hasProducts ? { cursor: 'not-allowed' } : undefined
	              },
	              _react2.default.createElement(
	                _style4.default.ManageButton,
	                {
	                  onClick: _this3.openMakeDecisionsModal,
	                  disabled: !hasProducts,
	                  style: !hasProducts ? { opacity: 0.6, pointerEvents: 'none' } : undefined
	                },
	                "Make Decisions"
	              ),
	              !hasProducts && _react2.default.createElement(
	                MakeDecisionsTooltip,
	                { className: "make-decisions-tooltip" },
	                "No products exist yet. Coordinate with Product Development to create a product first."
	              )
	            )
	          );
	        }(),
	        this.state.roleAlert && _react2.default.createElement(_error2.default, {
	          title: "Error | Not Authorized",
	          message: "You are not authorized to make decisions for this role.",
	          onHide: this.hideRoleAlert
	        }),
	        showNoProductsModal && _react2.default.createElement(_error2.default, {
	          title: "Warning",
	          message: "Product Development has not created a product for you to price. Please coordinate with your Head of Product (or CEO) to develop a product first.",
	          onHide: this.hideNoProductsModal
	        }),
	        successMessage && _react2.default.createElement(_success2.default, { message: successMessage }),
	        _react2.default.createElement(
	          "div",
	          { style: { position: 'absolute', width: 0, height: 0, overflow: 'hidden', visibility: 'hidden' }, "aria-hidden": "true" },
	          _react2.default.createElement(_PMDecisionsRevenueForecast2.default, {
	            hasAccess: this.state.hasAccess,
	            showRoleAlert: this.showRoleAlert,
	            products: this.state.products,
	            price_forecasts: this.state.price_forecasts,
	            reloadData: this.fetchData,
	            actionsAllowed: actionsAllowed,
	            countOfProducts: this.countOfProducts,
	            tourMode: this.props.tourMode,
	            getSubmissionData: this.getSubmissionData,
	            currentRound: this.props.currentRound,
	            roundInUrl: this.props.roundInUrl,
	            rounds: this.props.rounds,
	            showSuccessMessage: this.showSuccessMessage
	          }),
	          _react2.default.createElement(_PMDecisionsPromotionalSpend2.default, {
	            marketing_clients: this.state.marketing_clients,
	            price_forecasts: this.state.price_forecasts,
	            products: this.state.products,
	            promos: this.state.promos,
	            hasAccess: this.state.hasAccess,
	            showRoleAlert: this.showRoleAlert,
	            reloadData: this.fetchData,
	            actionsAllowed: actionsAllowed,
	            countOfProducts: this.countOfProducts,
	            tourMode: this.props.tourMode,
	            getSubmissionData: this.getSubmissionData,
	            currentRound: this.props.currentRound,
	            roundInUrl: this.props.roundInUrl,
	            rounds: this.props.rounds,
	            accountsReceivable: accountsReceivable,
	            showSuccessMessage: this.showSuccessMessage
	          }),
	          _react2.default.createElement(_PMDecisionsPlacement2.default, {
	            sales_clients: this.state.sales_clients,
	            hasAccess: this.state.hasAccess,
	            showRoleAlert: this.showRoleAlert,
	            price_forecasts: this.state.price_forecasts,
	            products: this.state.products,
	            sales: this.state.sales,
	            reloadData: this.fetchData,
	            actionsAllowed: actionsAllowed,
	            countOfProducts: this.countOfProducts,
	            tourMode: this.props.tourMode,
	            getSubmissionData: this.getSubmissionData,
	            accountsReceivable: accountsReceivable,
	            showSuccessMessage: this.showSuccessMessage
	          })
	        ),
	        this.state.loaded === false && _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true }),
	        this.state.loaded === true && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _style4.default.KpiRow,
	            { cardCount: 4 },
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Promotional Spend"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                null,
	                fmtMoney(this.totalPromoSpend)
	              )
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Average Selling Price"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                null,
	                "$",
	                this.avgPrice.toFixed(2)
	              )
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Placement Costs"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                null,
	                fmtMoney(this.sumPlacement)
	              )
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              { style: { gridColumn: 'span 2' } },
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                { style: { whiteSpace: 'nowrap' } },
	                "Total Marketing Spending"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                { style: { color: '#C62828' } },
	                fmtMoney(this.totalMarketingSpend)
	              )
	            )
	          ),
	          function () {
	            var showPromoBreakdown = _this3.totalPromoSpend > 0;
	            var showPricing = _this3.avgPrice > 0;
	            var showPlacement = _this3.sumPlacement > 0;
	            if (!showPromoBreakdown && !showPricing && !showPlacement) {
	              return null;
	            }
	            return _react2.default.createElement(
	              _style2.default.OpsLeadGrid,
	              null,
	              showPromoBreakdown && _react2.default.createElement(
	                _style2.default.OpsLeadGridMarket,
	                null,
	                _react2.default.createElement(
	                  _style4.default.SectionCard,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.SectionHeader,
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { style: {
	                          display: 'flex',
	                          justifyContent: 'space-between',
	                          alignItems: 'center',
	                          gap: 12,
	                          flexWrap: 'wrap'
	                        } },
	                      _react2.default.createElement(
	                        _style4.default.SectionTitle,
	                        null,
	                        "Promotion Spend Breakdown"
	                      ),
	                      _this3.renderPromoBreakdownFilters()
	                    ),
	                    _react2.default.createElement(
	                      _style4.default.SectionSubtitle,
	                      null,
	                      "How your promotional dollars are split across channels."
	                    )
	                  ),
	                  _this3.renderPromoBreakdown()
	                )
	              ),
	              (showPricing || showPlacement) && _react2.default.createElement(
	                _style2.default.OpsLeadGridRight,
	                null,
	                showPricing && _react2.default.createElement(
	                  _style4.default.SectionCard,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.SectionHeader,
	                    null,
	                    _react2.default.createElement(
	                      _style4.default.SectionTitle,
	                      null,
	                      "Pricing & Forecast"
	                    )
	                  ),
	                  _this3.renderPricingTable()
	                ),
	                showPlacement && _react2.default.createElement(
	                  _style4.default.SectionCard,
	                  { style: { marginTop: showPricing ? 16 : 0 } },
	                  _react2.default.createElement(
	                    _style4.default.SectionHeader,
	                    null,
	                    _react2.default.createElement(
	                      _style4.default.SectionTitle,
	                      null,
	                      "Placement"
	                    )
	                  ),
	                  _this3.renderPlacementTable()
	                )
	              )
	            );
	          }()
	        ),
	        this.state.showSetPricingPage && _react2.default.createElement(_setPricingPage2.default, {
	          products: this.state.products,
	          price_forecasts: this.state.price_forecasts,
	          currentRound: this.roundNumber,
	          rounds: this.state.rounds,
	          reloadData: this.fetchData,
	          actionsAllowed: actionsAllowed,
	          onClose: this.closeSetPricingPage,
	          onFirstPricingSet: this.handleFirstPricingSet
	        }),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.firstDecisionModalOpen,
	          title: "Nice work on your first pricing decision!",
	          body: "You can update this any time before the round deadline. Make sure every product has a price, then complete the other two marketing decisions before the round ends: product promotion and sales channel.",
	          ctaLabel: "View Other Decisions",
	          onCta: this.handleFirstDecisionCta,
	          onClose: this.handleFirstDecisionClose
	        }),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.firstPromoModalOpen,
	          title: "Congrats on making your first promo decision!",
	          body: "The last marketing decision you need to make is choosing the sales channel for your product.",
	          ctaLabel: "View Sales Channel",
	          onCta: this.handleFirstPromoModalCta,
	          onClose: this.handleFirstPromoModalClose
	        }),
	        this.state.showManagePromotionPage && _react2.default.createElement(_managePromotionPage2.default, {
	          marketing_clients: this.state.marketing_clients_list,
	          promos: this.state.promos,
	          products: this.state.products,
	          currentRound: this.roundNumber,
	          rounds: this.state.rounds,
	          reloadData: this.fetchData,
	          getSubmissionData: this.getSubmissionData,
	          showSuccessMessage: this.showSuccessMessage,
	          actionsAllowed: actionsAllowed,
	          onClose: this.closeManagePromotionPage,
	          onFirstPromoSet: this.handleFirstPromoSet
	        }),
	        this.state.showManagePlacementPage && _react2.default.createElement(_managePlacementPage2.default, {
	          products: this.state.products,
	          sales: this.state.sales,
	          sales_clients: this.state.sales_clients_list,
	          currentRound: this.roundNumber,
	          rounds: this.state.rounds,
	          reloadData: this.fetchData,
	          actionsAllowed: actionsAllowed,
	          onClose: this.closeManagePlacementPage
	        }),
	        showMakeDecisionsModal && function () {
	          var pricingEnabled = _this3.state.products.length > 0 || _this3.state.price_forecasts.length > 0;
	          var promotionsEnabled = !_this3.isSetPromoBudgetDisabled;
	          var placementEnabled = !_this3.isSetSalesChannelDisabled;
	          return _react2.default.createElement(
	            _style4.default.ManageOverlay,
	            { onClick: _this3.closeMakeDecisionsModal },
	            _react2.default.createElement(
	              _style4.default.ManageModal,
	              { onClick: function onClick(e) {
	                  return e.stopPropagation();
	                }, style: { maxWidth: 760 } },
	              _react2.default.createElement(
	                _style4.default.ManageModalTitle,
	                null,
	                "Make Decisions"
	              ),
	              _react2.default.createElement(
	                _style4.default.ManageModalSubtitle,
	                null,
	                "Select a decision to explore"
	              ),
	              _react2.default.createElement(
	                _style2.default.DecisionFlowRow,
	                null,
	                _react2.default.createElement(
	                  _style2.default.DecisionOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.ManageOption,
	                    {
	                      onClick: pricingEnabled ? _this3.pickMakeDecisionsOption('pricing') : undefined,
	                      disabled: !pricingEnabled
	                    },
	                    "Set Pricing"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.DecisionOptionTooltip,
	                    null,
	                    pricingEnabled ? 'Set the selling price and forecast for each product.' : 'No products available yet. Coordinate with Product Development first.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionFlowArrow,
	                  null,
	                  "\u2192"
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.ManageOption,
	                    {
	                      onClick: promotionsEnabled ? _this3.pickMakeDecisionsOption('promotions') : undefined,
	                      disabled: !promotionsEnabled
	                    },
	                    "Manage Promotions"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.DecisionOptionTooltip,
	                    null,
	                    promotionsEnabled ? 'Split your marketing budget across traditional and digital channels.' : 'Set pricing for at least one product before allocating promotional spend.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionFlowArrow,
	                  null,
	                  "\u2192"
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.ManageOption,
	                    {
	                      onClick: placementEnabled ? _this3.pickMakeDecisionsOption('placement') : undefined,
	                      disabled: !placementEnabled
	                    },
	                    "Manage Placement"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.DecisionOptionTooltip,
	                    null,
	                    placementEnabled ? 'Choose the sales channel for each priced product.' : 'Set pricing for at least one product before choosing a sales channel.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _style4.default.ManageCloseRow,
	                null,
	                _react2.default.createElement(
	                  _style4.default.ManageCloseButton,
	                  { onClick: _this3.closeMakeDecisionsModal },
	                  "Cancel"
	                )
	              )
	            )
	          );
	        }()
	      );
	    }
	
	    // Pill-style filter buttons next to the Promotion Spend Breakdown
	    // header. "Total" defaults; product pills are added one per team
	    // product (none rendered if the team has no products yet).
	
	  }, {
	    key: "renderPromoBreakdownFilters",
	    value: function renderPromoBreakdownFilters() {
	      var _this4 = this;
	
	      var products = this.state.products;
	
	      var filter = this.state.promoBreakdownProductId;
	      var baseStyle = {
	        padding: '5px 12px',
	        borderRadius: 999,
	        fontFamily: "'Mukta Vaani', Lato, sans-serif",
	        fontSize: 12,
	        fontWeight: 700,
	        cursor: 'pointer',
	        transition: 'border-color 0.15s ease, color 0.15s ease, background 0.15s ease',
	        border: '1.5px solid #E5E9F0',
	        background: '#F5F7FB',
	        color: 'rgba(0, 27, 59, 0.6)'
	      };
	      var activeStyle = Object.assign({}, baseStyle, {
	        background: '#FFFFFF',
	        borderColor: '#3A507B',
	        color: '#3A507B',
	        boxShadow: '0 2px 6px rgba(58, 80, 123, 0.18)'
	      });
	      var renderPill = function renderPill(id, label) {
	        return _react2.default.createElement(
	          "button",
	          {
	            key: "promo-pill-" + id,
	            type: "button",
	            onClick: _this4.selectPromoBreakdownProduct(id),
	            style: filter === id || Number(filter) === Number(id) ? activeStyle : baseStyle
	          },
	          label
	        );
	      };
	      return _react2.default.createElement(
	        "div",
	        { style: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' } },
	        renderPill('all', 'Total'),
	        (products || []).map(function (p) {
	          return renderPill(p.id, p.name);
	        })
	      );
	    }
	  }, {
	    key: "renderPromoBreakdown",
	    value: function renderPromoBreakdown() {
	      var filter = this.state.promoBreakdownProductId;
	      var trad = this.sumByCategory(1, filter);
	      var digi = this.sumByCategory(2, filter);
	      var total = trad + digi;
	      var tradColor = TRADITIONAL_COLOR;
	      var digiColor = DIGITAL_COLOR;
	      var tradItems = this.clientsByCategory(1, TRADITIONAL_PALETTE, filter);
	      var digiItems = this.clientsByCategory(2, DIGITAL_PALETTE, filter);
	      var fmtMoney = function fmtMoney(v) {
	        return "$" + Math.round(v).toLocaleString('en-US');
	      };
	      var placeholderColor = '#E1E5EA';
	
	      return _react2.default.createElement(
	        "div",
	        { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'start' } },
	        _react2.default.createElement(
	          "div",
	          { style: { position: 'relative' } },
	          _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { width: "100%", height: 240, debounce: 500 },
	            _react2.default.createElement(
	              _recharts.PieChart,
	              null,
	              _react2.default.createElement(_recharts.Tooltip, {
	                formatter: function formatter(val, name, entry) {
	                  return entry && entry.payload && entry.payload.placeholder ? ['-', ''] : [fmtMoney(val), name];
	                }
	              }),
	              _react2.default.createElement(
	                _recharts.Pie,
	                {
	                  data: this.donutData,
	                  cx: "50%",
	                  cy: "50%",
	                  innerRadius: 60,
	                  outerRadius: 100,
	                  paddingAngle: total > 0 ? 2 : 0,
	                  dataKey: "value"
	                },
	                this.donutData.map(function (d, i) {
	                  return _react2.default.createElement(_recharts.Cell, {
	                    key: "cell-" + i,
	                    fill: d.placeholder ? placeholderColor : d.color || tradColor
	                  });
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: {
	                position: 'absolute',
	                top: '50%', left: '50%',
	                transform: 'translate(-50%, -50%)',
	                textAlign: 'center',
	                pointerEvents: 'none'
	              } },
	            _react2.default.createElement(
	              "div",
	              { style: {
	                  fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                  fontSize: 12,
	                  color: 'rgba(0, 27, 59, 0.6)',
	                  textTransform: 'uppercase',
	                  letterSpacing: '0.5px'
	                } },
	              "Total"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: {
	                  fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                  fontSize: 18,
	                  fontWeight: 700,
	                  color: 'rgba(0, 27, 59, 0.94)'
	                } },
	              fmtMoney(total)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          this.renderBreakdownGroup('Traditional Marketing', trad, tradColor, tradItems, total),
	          _react2.default.createElement("div", { style: { height: 12 } }),
	          this.renderBreakdownGroup('Digital Marketing', digi, digiColor, digiItems, total)
	        )
	      );
	    }
	
	    // `total` here is the category total (digital or traditional). The
	    // grand total `grandTotal` is the full spend across both categories
	    // — used to compute the per-channel "% of total spending" hint
	    // shown next to each sub-category name.
	
	  }, {
	    key: "renderBreakdownGroup",
	    value: function renderBreakdownGroup(label, total, color, subcategories, grandTotal) {
	      var fmt = function fmt(v) {
	        return "$" + Math.round(v).toLocaleString('en-US');
	      };
	      var fmtPct = function fmtPct(v) {
	        return grandTotal > 0 ? (v / grandTotal * 100).toFixed(1) + "%" : '0.0%';
	      };
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: {
	              display: 'flex',
	              alignItems: 'center',
	              gap: 8,
	              marginBottom: 6
	            } },
	          _react2.default.createElement("span", { style: {
	              display: 'inline-block',
	              width: 10, height: 10,
	              borderRadius: '50%',
	              background: color
	            } }),
	          _react2.default.createElement(
	            "span",
	            { style: {
	                flex: 1,
	                fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                fontWeight: 600,
	                fontSize: 14,
	                color: 'rgba(0, 27, 59, 0.94)'
	              } },
	            label
	          ),
	          _react2.default.createElement(
	            "span",
	            { style: {
	                fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                fontWeight: 700,
	                fontSize: 14,
	                color: 'rgba(0, 27, 59, 0.94)'
	              } },
	            fmt(total)
	          )
	        ),
	        _react2.default.createElement(
	          "ul",
	          { style: {
	              margin: 0,
	              padding: '0 0 0 22px',
	              listStyle: 'none',
	              fontFamily: "'Mukta Vaani', Lato, sans-serif",
	              fontSize: 13,
	              lineHeight: '20px'
	            } },
	          subcategories.map(function (sub) {
	            return _react2.default.createElement(
	              "li",
	              {
	                key: sub.id != null ? sub.id : sub.name,
	                style: {
	                  display: 'flex',
	                  alignItems: 'center',
	                  gap: 8,
	                  color: 'rgba(0, 27, 59, 0.7)'
	                }
	              },
	              _react2.default.createElement("span", { style: {
	                  display: 'inline-block',
	                  width: 6,
	                  height: 6,
	                  borderRadius: '50%',
	                  background: sub.color || 'rgba(0, 27, 59, 0.35)',
	                  flexShrink: 0
	                } }),
	              _react2.default.createElement(
	                "span",
	                { style: { flex: 1 } },
	                sub.name
	              ),
	              _react2.default.createElement(
	                "span",
	                { style: {
	                    fontVariantNumeric: 'tabular-nums'
	                  } },
	                fmtPct(sub.spend || 0)
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: "renderPricingTable",
	    value: function renderPricingTable() {
	      var rows = this.productsRows;
	      var fmt = function fmt(v) {
	        return "$" + Math.round(v).toLocaleString('en-US');
	      };
	
	      if (rows.length === 0) {
	        return _react2.default.createElement(
	          _style4.default.SummaryTable,
	          null,
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              _style4.default.SummaryRow,
	              null,
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                null,
	                "\u2014"
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _style4.default.SummaryTable,
	        null,
	        _react2.default.createElement(
	          "thead",
	          null,
	          _react2.default.createElement(
	            _style4.default.SummaryHeadRow,
	            null,
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              null,
	              "Product"
	            ),
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              { align: "center" },
	              "Price"
	            ),
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              { align: "center" },
	              "Unit Forecast"
	            ),
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              { align: "center" },
	              "Expected Revenue"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tbody",
	          null,
	          rows.map(function (row) {
	            return _react2.default.createElement(
	              _style4.default.SummaryRow,
	              { key: "price-row-" + row.id },
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                null,
	                row.name
	              ),
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                { align: "center" },
	                "$",
	                row.price.toFixed(2)
	              ),
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                { align: "center" },
	                Math.round(row.forecast).toLocaleString('en-US')
	              ),
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                { align: "center" },
	                fmt(row.revenue)
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: "renderPlacementTable",
	    value: function renderPlacementTable() {
	      var rows = this.productsRows;
	      if (rows.length === 0) {
	        return _react2.default.createElement(
	          _style4.default.SummaryTable,
	          null,
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              _style4.default.SummaryRow,
	              null,
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                null,
	                "\u2014"
	              )
	            )
	          )
	        );
	      }
	      var checkmark = _react2.default.createElement(
	        "span",
	        { style: { color: '#2DA548', fontWeight: 700, fontSize: 16 } },
	        "\u2713"
	      );
	      var dash = _react2.default.createElement(
	        "span",
	        { style: { color: 'rgba(0, 27, 59, 0.35)' } },
	        "-"
	      );
	      return _react2.default.createElement(
	        _style4.default.SummaryTable,
	        null,
	        _react2.default.createElement(
	          "thead",
	          null,
	          _react2.default.createElement(
	            _style4.default.SummaryHeadRow,
	            null,
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              null,
	              "Product"
	            ),
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              { align: "center" },
	              "Direct Sales"
	            ),
	            _react2.default.createElement(
	              _style4.default.SummaryHeadCell,
	              { align: "center" },
	              "Distributor"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tbody",
	          null,
	          rows.map(function (row) {
	            return _react2.default.createElement(
	              _style4.default.SummaryRow,
	              { key: "place-row-" + row.id },
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                null,
	                row.name
	              ),
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                { align: "center" },
	                row.hasDirectSales ? checkmark : dash
	              ),
	              _react2.default.createElement(
	                _style4.default.SummaryCell,
	                { align: "center" },
	                row.hasDistributors ? checkmark : dash
	              )
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: "roundNumber",
	    get: function get() {
	      var _state2 = this.state,
	          roundInUrl = _state2.roundInUrl,
	          currentRound = _state2.currentRound;
	
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return roundInUrl;
	      }
	
	      return currentRound;
	    }
	  }, {
	    key: "actionsAllowed",
	    get: function get() {
	      if (this.state.hasAccess === false) {
	        return false;
	      }
	
	      if (this.props.roundShouldBeFinished === true) {
	        return false;
	      }
	
	      var roundInUrl = this.state.roundInUrl;
	      var _props3 = this.props,
	          currentRound = _props3.currentRound,
	          rounds = _props3.rounds;
	
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return false;
	      }
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	
	      if (!round) {
	        return false;
	      }
	
	      return round.is_started === true && round.is_finished === false;
	    }
	  }, {
	    key: "countOfProducts",
	    get: function get() {
	      return this.state.products.length;
	    }
	  }, {
	    key: "isSetPromoBudgetDisabled",
	    get: function get() {
	      return this.state.price_forecasts.filter(function (i) {
	        return i.player !== null;
	      }).length === 0;
	    }
	  }, {
	    key: "isSetSalesChannelDisabled",
	    get: function get() {
	      return this.state.price_forecasts.filter(function (i) {
	        return i.player !== null;
	      }).length === 0;
	    }
	
	    // Fired by SetPricingPage after a successful save when the save was
	    // the user's first-ever pricing decision in Round 1. Shows the
	    // "you have more decisions to make" coaching modal.
	
	
	    // CTA: close the popup, close the Set Pricing page, and open the
	    // Make Decisions modal so the user sees the other two marketing
	    // decisions they still need to make.
	
	
	    // First promo (Set Allocation) — fired from ManagePromotionPage
	    // after a successful save when the team had no prior promo record
	    // AND we're in Round 1. Reminds the student they still owe a Sales
	    // Channel decision.
	
	
	    // CTA: close the popup, close Manage Promotion, and open Manage
	    // Placement (Sales Channel) directly — that's the "last marketing
	    // decision" the popup copy tells them about.
	
	
	    // ----- KPI / chart getters -----
	
	    // Returns true if the promo row matches `productFilter`. 'all' (or
	    // null) means every product; otherwise only the matching product's
	    // promos count. Used by the Promotion Spend Breakdown section to
	    // filter by selected product without affecting the top KPI row.
	
	
	    // Promo entries come back signed-negative for outflows. Math.abs gives
	    // the dollar amount the user actually spent.
	
	
	    // Per-client breakdown for the sub-lists under each category header.
	    // Each entry carries a bullet color drawn from `palette` (wrapping)
	    // so multiple sub-categories get visually similar but distinct dots.
	
	  }, {
	    key: "sumTraditionalSpend",
	
	
	    // Top KPI getters always sum across ALL products — the breakdown
	    // filter only affects the Promotion Spend Breakdown card itself.
	    get: function get() {
	      return this.sumByCategory(1, 'all');
	    }
	  }, {
	    key: "sumDigitalSpend",
	    get: function get() {
	      return this.sumByCategory(2, 'all');
	    }
	  }, {
	    key: "sumDirectSalesCost",
	    get: function get() {
	      var dsId = this.state.sales_clients["Direct Sales"];
	      return this.state.sales.filter(function (s) {
	        return s.player !== null && s.client === dsId;
	      }).reduce(function (sum, s) {
	        return sum + Math.abs(Number(s.total) || 0);
	      }, 0);
	    }
	  }, {
	    key: "sumDistributorsCost",
	    get: function get() {
	      var distId = this.state.sales_clients["Distributors"];
	      return this.state.sales.filter(function (s) {
	        return s.player !== null && s.client === distId;
	      }).reduce(function (sum, s) {
	        return sum + Math.abs(Number(s.total) || 0);
	      }, 0);
	    }
	  }, {
	    key: "totalPromoSpend",
	    get: function get() {
	      return this.sumTraditionalSpend + this.sumDigitalSpend;
	    }
	  }, {
	    key: "totalMarketingSpend",
	    get: function get() {
	      return this.totalPromoSpend + this.sumDirectSalesCost + this.sumDistributorsCost;
	    }
	  }, {
	    key: "avgPrice",
	    get: function get() {
	      var priced = this.state.price_forecasts.filter(function (p) {
	        return p.player !== null && Number(p.price) > 0;
	      });
	      if (priced.length === 0) return 0;
	      return priced.reduce(function (s, p) {
	        return s + Number(p.price);
	      }, 0) / priced.length;
	    }
	  }, {
	    key: "placementCount",
	    get: function get() {
	      return this.state.sales.filter(function (s) {
	        return s.player !== null && Number(s.total) > 0;
	      }).length;
	    }
	
	    // Sum of sales.total across every live sales row in the round. Shown
	    // in the Placement KPI card as a dollar figure.
	
	  }, {
	    key: "sumPlacement",
	    get: function get() {
	      return (this.state.sales || []).filter(function (s) {
	        return s.player !== null;
	      }).reduce(function (sum, s) {
	        return sum + Math.abs(Number(s.total) || 0);
	      }, 0);
	    }
	
	    // ----- Per-product table data -----
	
	  }, {
	    key: "productsRows",
	    get: function get() {
	      var _state3 = this.state,
	          products = _state3.products,
	          price_forecasts = _state3.price_forecasts,
	          sales = _state3.sales,
	          sales_clients = _state3.sales_clients;
	
	      return products.map(function (product) {
	        var pf = price_forecasts.find(function (i) {
	          return i.product === product.id;
	        }) || {};
	        var price = Number(pf.price) || 0;
	        var forecast = Number(pf.forecast) || 0;
	        var revenue = Number(pf.revenue_forecast) || price * forecast;
	
	        // Sales channel: pick the sales row tied to this product (sales
	        // rows reference product via the price_forecast they're associated
	        // with). Fall back to looking up by product directly.
	        var productSales = sales.filter(function (s) {
	          return s.player !== null && (Number(s.product) === Number(product.id) || Number(s.price_forecast) === Number(pf.id));
	        });
	        var directId = sales_clients["Direct Sales"];
	        var distId = sales_clients["Distributors"];
	        var hasDirectSales = productSales.some(function (s) {
	          return Number(s.client) === Number(directId);
	        });
	        var hasDistributors = productSales.some(function (s) {
	          return Number(s.client) === Number(distId);
	        });
	
	        return {
	          id: product.id,
	          name: product.name,
	          price: price,
	          forecast: forecast,
	          revenue: revenue,
	          hasDirectSales: hasDirectSales,
	          hasDistributors: hasDistributors
	        };
	      });
	    }
	
	    // Donut data: one slice per marketing client with spend > 0, colored
	    // by the per-client palette so the chart visually echoes the sub-
	    // category bullets in the breakdown list. Traditional first, then
	    // Digital. Respects the Promotion Spend Breakdown product filter so
	    // selecting a product narrows the donut to that product's promos.
	    // When nothing has been spent yet, a single placeholder slice keeps
	    // a gray ring rendered.
	
	  }, {
	    key: "donutData",
	    get: function get() {
	      var filter = this.state.promoBreakdownProductId;
	      var items = [].concat(_toConsumableArray(this.clientsByCategory(1, TRADITIONAL_PALETTE, filter)), _toConsumableArray(this.clientsByCategory(2, DIGITAL_PALETTE, filter))).filter(function (item) {
	        return item.spend > 0;
	      });
	      if (items.length === 0) {
	        return [{ name: 'No spend yet', value: 1, placeholder: true }];
	      }
	      return items.map(function (item) {
	        return {
	          name: item.name,
	          value: item.spend,
	          color: item.color
	        };
	      });
	    }
	  }]);
	
	  return PMDecisions;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.showSuccessMessage = function (successMessage) {
	    _this5.setState({
	      successMessage: successMessage
	    }, function () {
	      _this5.hideSuccessMessage();
	    });
	  };
	
	  this.hideSuccessMessage = function () {
	    setTimeout(function () {
	      _this5.setState({
	        successMessage: null
	      });
	    }, 5000);
	  };
	
	  this.hideErrorMessage = function () {
	    _this5.setState({
	      errorMessage: null
	    });
	  };
	
	  this.hideNoProductsModal = function () {
	    _this5.setState({
	      showNoProductsModal: false
	    });
	  };
	
	  this.reloadRole = function () {
	    var role = _Auth2.default.getRole();
	    var hasAccess = role === "CEO" || role === "PM";
	    var isOwnRole = role === "PM";
	
	    _this5.setState({
	      hasAccess: hasAccess,
	      isOwnRole: isOwnRole
	    });
	  };
	
	  this.showRoleAlert = function () {
	    _this5.setState({
	      roleAlert: true
	    });
	  };
	
	  this.hideRoleAlert = function () {
	    _this5.setState({
	      roleAlert: false
	    });
	  };
	
	  this.submitDecisions = function () {
	    _this5.setState({
	      submitDecisionsLoading: true
	    });
	    (0, _SubmitDecisions.submitDecisions)("marketing", _this5.roundNumber, function (showWarnings) {
	      return _this5.getSubmissionData(showWarnings);
	    });
	  };
	
	  this.fetchData = function () {
	    var currentRound = _this5.roundNumber;
	
	    Promise.all([(0, _TeamDecisionsService.fetchTeamDecisions)(currentRound, 'marketing'), (0, _TeamDecisionsService.fetchTeamStatus)(currentRound)]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          decisionsData = _ref2[0],
	          statusData = _ref2[1];
	
	      if (!_this5._isMounted) return;
	
	      var marketing_clients = {};
	      var sales_clients = {};
	      var sales = decisionsData.sales || [];
	      var promos = decisionsData.promos || [];
	      var price_forecasts = decisionsData.price_forecasts || [];
	      var products = decisionsData.products || [];
	      var balanceSheet = decisionsData.balanceSheet || [];
	      var pmHasPricing = (decisionsData.price_forecasts || []).some(function (i) {
	        return i.player !== null;
	      });
	      var pmHasPromos = (decisionsData.promos || []).some(function (i) {
	        return i.player !== null;
	      });
	      var pmHasSales = (decisionsData.sales || []).some(function (i) {
	        return i.player !== null;
	      });
	      var isPreChecked = pmHasPricing && pmHasPromos && pmHasSales;
	
	      var rounds = _this5.state.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	
	      if (round) {
	        sales = sales.filter(function (i) {
	          return i.round === round.id;
	        });
	        promos = promos.filter(function (i) {
	          return i.round === round.id;
	        });
	        price_forecasts = price_forecasts.filter(function (i) {
	          return i.round === round.id;
	        });
	        products = products.filter(function (i) {
	          return i.round === round.id;
	        });
	        balanceSheet = balanceSheet.filter(function (i) {
	          return i.round === round.id;
	        });
	      }
	
	      // marketing_clients_list comes back from team-decisions with the
	      // category field (1 = Traditional, 2 = Digital).
	      var marketing_clients_list = decisionsData.marketing_clients || [];
	
	      marketing_clients_list.forEach(function (item) {
	        marketing_clients[item.name] = item.id;
	      });
	
	      // Rename the raw sales-client names to their UX-friendly labels
	      // ("SalesRep" → "Direct Sales", "Distributor1" → "Distributors")
	      // and keep both the {name: id} map and the rich array around.
	      // The Manage Placement popup needs the full array to render one
	      // option per client.
	      var sales_clients_list = (decisionsData.sales_clients || []).map(function (item) {
	        var name = item.name;
	
	        if (name === "SalesRep") name = "Direct Sales";else if (name === "Distributor1") name = "Distributors";
	        return Object.assign({}, item, { name: name });
	      });
	      sales_clients_list.forEach(function (item) {
	        sales_clients[item.name] = item.id;
	      });
	
	      var accountsReceivable = 0;
	      if (currentRound > 1 && balanceSheet.length > 0 && "Accounts Receivable" in balanceSheet[0]) {
	        accountsReceivable = balanceSheet[0]["Accounts Receivable"];
	      }
	
	      _this5.setState({
	        marketing_clients: marketing_clients,
	        marketing_clients_list: marketing_clients_list,
	        sales_clients: sales_clients,
	        sales_clients_list: sales_clients_list,
	        sales: sales,
	        promos: promos,
	        price_forecasts: price_forecasts,
	        products: products,
	        accountsReceivable: accountsReceivable,
	        loaded: true,
	        isPreChecked: isPreChecked,
	        submission_data: statusData.submission_data,
	        submitDecisionsLoading: false
	      });
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "PMDecisions", "fetchData");
	    });
	  };
	
	  this.getSubmissionData = function (showWarnings) {
	    _this5.setState({
	      submitDecisionsLoading: true
	    });
	
	    Promise.all([(0, _TeamDecisionsService.fetchTeamDecisions)(_this5.roundNumber, 'marketing'), (0, _TeamDecisionsService.fetchTeamStatus)(_this5.roundNumber)]).then(function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	          decisionsData = _ref4[0],
	          statusData = _ref4[1];
	
	      if (!_this5._isMounted) return;
	
	      if (showWarnings) {
	        showWarnings(decisionsData);
	      }
	
	      _this5.setState({
	        submission_data: statusData.submission_data,
	        submitDecisionsLoading: false
	      });
	    });
	  };
	
	  this.showSetPricingModal = function () {
	    var products = _this5.state.products;
	
	
	    var hasProducts = products && products.length > 0 || _this5.state.price_forecasts && _this5.state.price_forecasts.length > 0;
	    if (!hasProducts) {
	      _this5.setState({
	        showNoProductsModal: true
	      });
	    } else {
	      _this5.eventemitter.trigger("pm-decisions-open-modal");
	    }
	  };
	
	  this.showSetPromoBudgetModal = function () {
	    _this5.eventemitter.trigger("pm-decisions-open-modal2");
	  };
	
	  this.showSetSalesChannelModal = function () {
	    _this5.eventemitter.trigger("pm-decisions-open-modal3");
	  };
	
	  this.openMakeDecisionsModal = function () {
	    _this5.setState({ showMakeDecisionsModal: true });
	  };
	
	  this.closeMakeDecisionsModal = function () {
	    _this5.setState({ showMakeDecisionsModal: false });
	  };
	
	  this.handleFirstPricingSet = function () {
	    _this5.setState({ firstDecisionModalOpen: true });
	  };
	
	  this.handleFirstDecisionClose = function () {
	    _this5.setState({ firstDecisionModalOpen: false });
	  };
	
	  this.handleFirstDecisionCta = function () {
	    _this5.setState({
	      firstDecisionModalOpen: false,
	      showSetPricingPage: false,
	      showMakeDecisionsModal: true
	    });
	  };
	
	  this.handleFirstPromoSet = function () {
	    _this5.setState({ firstPromoModalOpen: true });
	  };
	
	  this.handleFirstPromoModalClose = function () {
	    _this5.setState({ firstPromoModalOpen: false });
	  };
	
	  this.handleFirstPromoModalCta = function () {
	    _this5.setState({
	      firstPromoModalOpen: false,
	      showManagePromotionPage: false,
	      showManagePlacementPage: true
	    });
	  };
	
	  this.pickMakeDecisionsOption = function (option) {
	    return function () {
	      _this5.closeMakeDecisionsModal();
	      if (option === 'pricing') {
	        // Block opening the new page when no products are available yet
	        // — preserves the existing UX hint that the user needs to talk
	        // to Product Development first.
	        var hasProducts = _this5.state.products && _this5.state.products.length > 0 || _this5.state.price_forecasts && _this5.state.price_forecasts.length > 0;
	        if (!hasProducts) {
	          _this5.setState({ showNoProductsModal: true });
	          return;
	        }
	        _this5.setState({ showSetPricingPage: true });
	      } else if (option === 'promotions') {
	        _this5.setState({ showManagePromotionPage: true });
	      } else if (option === 'placement') {
	        _this5.setState({ showManagePlacementPage: true });
	      }
	    };
	  };
	
	  this.closeManagePromotionPage = function () {
	    _this5.setState({ showManagePromotionPage: false });
	  };
	
	  this.closeSetPricingPage = function () {
	    _this5.setState({ showSetPricingPage: false });
	  };
	
	  this.closeManagePlacementPage = function () {
	    _this5.setState({ showManagePlacementPage: false });
	  };
	
	  this.matchesProductFilter = function (promo, productFilter) {
	    if (productFilter == null || productFilter === 'all') return true;
	    return Number(promo.product) === Number(productFilter);
	  };
	
	  this.sumByCategory = function (category, productFilter) {
	    var ids = (_this5.state.marketing_clients_list || []).filter(function (c) {
	      return Number(c.category) === category;
	    }).map(function (c) {
	      return Number(c.id);
	    });
	    if (ids.length === 0) return 0;
	    return (_this5.state.promos || []).filter(function (p) {
	      return p.player !== null && ids.includes(Number(p.client)) && _this5.matchesProductFilter(p, productFilter);
	    }).reduce(function (s, p) {
	      return s + Math.abs(Number(p.spend) || 0);
	    }, 0);
	  };
	
	  this.clientsByCategory = function (category, palette, productFilter) {
	    return (_this5.state.marketing_clients_list || []).filter(function (c) {
	      return Number(c.category) === category;
	    }).map(function (client, i) {
	      var spend = (_this5.state.promos || []).filter(function (p) {
	        return p.player !== null && Number(p.client) === Number(client.id) && _this5.matchesProductFilter(p, productFilter);
	      }).reduce(function (s, p) {
	        return s + Math.abs(Number(p.spend) || 0);
	      }, 0);
	      return {
	        id: client.id,
	        name: client.name,
	        spend: spend,
	        color: palette[i % palette.length]
	      };
	    });
	  };
	
	  this.selectPromoBreakdownProduct = function (id) {
	    return function () {
	      if (_this5.state.promoBreakdownProductId === id) return;
	      _this5.setState({ promoBreakdownProductId: id });
	    };
	  };
	};
	
	exports.default = (0, _reactEasyState.view)(PMDecisions);

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(24);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _ResultsValuationsResults = __webpack_require__(1418);
	
	var _ResultsValuationsResults2 = _interopRequireDefault(_ResultsValuationsResults);
	
	var _icon_expand = __webpack_require__(689);
	
	var _icon_expand2 = _interopRequireDefault(_icon_expand);
	
	var _competitiveAnalysis = __webpack_require__(1161);
	
	var _competitiveAnalysis2 = _interopRequireDefault(_competitiveAnalysis);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _ResultsPanelBalanceSheet = __webpack_require__(1349);
	
	var _ResultsPanelBalanceSheet2 = _interopRequireDefault(_ResultsPanelBalanceSheet);
	
	var _ResultsPanelIncomeStatement = __webpack_require__(1351);
	
	var _ResultsPanelIncomeStatement2 = _interopRequireDefault(_ResultsPanelIncomeStatement);
	
	var _ResultsPanelCashFlows = __webpack_require__(1350);
	
	var _ResultsPanelCashFlows2 = _interopRequireDefault(_ResultsPanelCashFlows);
	
	var _utils = __webpack_require__(18);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Results = function (_Component) {
	  _inherits(Results, _Component);
	
	  function Results(props) {
	    _classCallCheck(this, Results);
	
	    var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));
	
	    _this.fetchData = function () {
	      var teams = {};
	      var data = {};
	      var valuationsResults = Object.assign({}, _this.state.valuationsResults);
	
	      _Teams2.default.teams().forEach(function (item) {
	        teams[item.id] = item.name;
	        data[item.id] = {};
	        valuationsResults.pricetoEarnings.data[item.id] = 0;
	        valuationsResults.marketValue.data[item.id] = 0;
	        valuationsResults.pricetoSales.data[item.id] = 0;
	        valuationsResults.pricetoBook.data[item.id] = 0;
	      });
	
	      _this.setState({
	        teams: teams,
	        data: data,
	        valuationsResults: valuationsResults
	      }, function () {
	        _this.loadState();
	      });
	    };
	
	    _this.loadState = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var roundId = _this.getCompetitiveAnalysisRoundId();
	      var currentTeam = _Teams2.default.teams()[0];
	      var competitionId = currentTeam ? Number(currentTeam.competition) : 0;
	
	      var caPromise = roundId ? (0, _MetricsService.fetchCompetitiveAnalysis)(competitionId, roundId) : Promise.resolve(null);
	
	      var metricsPromise = roundId ? (0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId) : Promise.resolve([]);
	
	      return Promise.all([caPromise, metricsPromise]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            caData = _ref2[0],
	            competitionMetrics = _ref2[1];
	
	        var valuationsResults = Object.assign({}, _this.state.valuationsResults);
	
	        var _loop = function _loop(key) {
	          competitionMetrics.forEach(function (response) {
	            var hash = valuationsResults[key].name;
	            if (response[hash] && response.team in valuationsResults[key].data) {
	              valuationsResults[key].data[response.team] = response[hash];
	            }
	          });
	        };
	
	        for (var key in valuationsResults) {
	          _loop(key);
	        }
	
	        var _loop2 = function _loop2(key) {
	          competitionMetrics.forEach(function (response) {
	            var hash = valuationsResults[key].name;
	            if (response[hash] && response.team in valuationsResults[key].data) {
	              valuationsResults[key].data[response.team] = response[hash];
	            }
	          });
	        };
	
	        for (var key in valuationsResults) {
	          _loop2(key);
	        }
	
	        var metrics = {};
	        var data = _this.state.data;
	
	        if (caData) {
	          var exclude_keys = ["created_at", "id", "is_actual", "reason", "round", "team", "updated_at"];
	
	          caData.forEach(function (item) {
	            if (item.team in data) {
	              Object.keys(item).forEach(function (key) {
	                if (exclude_keys.includes(key)) {
	                  return;
	                }
	
	                data[item.team][key] = item[key] === null ? 0 : item[key];
	              });
	            }
	          });
	
	          competitionMetrics.forEach(function (row) {
	            metrics[row.team] = {
	              MarketShare: row["Market Share"] ? row["Market Share"] : 0,
	              Revenues: row["Net Revenues"] ? row["Net Revenues"] : 0,
	              GrossMargins: row["Gross Margin"] ? row["Gross Margin"] : 0
	            };
	          });
	        }
	
	        _this.setState({
	          data: data,
	          valuationsResults: valuationsResults,
	          metrics: metrics,
	          loaded: true
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "Results", "loadState");
	      });
	    };
	
	    _this.updateActive = function (e) {
	      var statement = e.target.dataset.statement;
	
	
	      var currentStatement = document.querySelector(".statement.active");
	      var nextStatement = document.querySelector("." + statement);
	
	      currentStatement.classList.add("hidden");
	      currentStatement.classList.remove("active");
	
	      nextStatement.classList.add("active");
	      nextStatement.classList.remove("hidden");
	
	      _this.setState({
	        active: statement
	      });
	    };
	
	    _this.state = {
	      active: "income",
	      data: {},
	      teams: {},
	      metrics: {},
	      loaded: false,
	      valuationsResults: {
	        pricetoEarnings: {
	          name: "price_to_earnings",
	          data: {}
	        },
	        marketValue: {
	          name: "market_value",
	          data: {}
	        },
	        pricetoSales: {
	          name: "price_to_sales",
	          data: {}
	        },
	        pricetoBook: {
	          name: "price_to_book",
	          data: {}
	        }
	      },
	      roundInUrl: props.roundInUrl,
	      currentRound: props.currentRound
	    };
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(Results, [{
	    key: "getCompetitiveAnalysisRoundId",
	    value: function getCompetitiveAnalysisRoundId() {
	      var _this2 = this;
	
	      var rounds = this.props.rounds;
	
	      var roundId = null;
	      if (this.state.roundInUrl !== null && this.state.roundInUrl !== this.state.currentRound) {
	        var round = rounds.find(function (i) {
	          return i.number === _this2.state.roundInUrl;
	        });
	        if (round) {
	          roundId = round.id;
	        }
	      } else {
	        var _round = rounds.find(function (i) {
	          return i.number === _this2.state.currentRound;
	        });
	        if (_round) {
	          if (_round.is_finished === true) {
	            roundId = _round.id;
	          } else {
	            var round_number = this.state.currentRound - 1;
	            if (round_number > 0) {
	              _round = rounds.find(function (i) {
	                return i.number === round_number;
	              });
	              if (_round) {
	                roundId = _round.id;
	              }
	            }
	          }
	        }
	      }
	
	      return roundId;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound
	        }, function () {
	          _this3.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          valuationsResults = _state.valuationsResults,
	          metrics = _state.metrics,
	          roundInUrl = _state.roundInUrl,
	          currentRound = _state.currentRound;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "analysis" },
	        this.state.loaded ? _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "container-analysis report-collapse" },
	              _react2.default.createElement(
	                "h3",
	                { className: "semibold" },
	                "Financials",
	                _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, _TypeformContent2.default.FINANCIALS),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: "/pd/results/FinancialAnalysis",
	                    className: "icon-zoom"
	                  },
	                  _react2.default.createElement("img", { src: _icon_expand2.default, className: "icon", alt: "ExpandImage" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "panel-dashboard-white" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "results-submenu" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "mr-15 pointer",
	                      "data-statement": "income",
	                      onClick: this.updateActive
	                    },
	                    "INCOME STATEMENT"
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "mr-15 pointer",
	                      "data-statement": "balance",
	                      onClick: this.updateActive
	                    },
	                    "BALANCE SHEET"
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      className: "mr-15 pointer",
	                      "data-statement": "cash",
	                      onClick: this.updateActive
	                    },
	                    "CASH FLOWS"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "statement income active mt-30" },
	                  _react2.default.createElement(_ResultsPanelIncomeStatement2.default, {
	                    rounds: this.props.rounds,
	                    currentRound: currentRound,
	                    roundInUrl: roundInUrl
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "statement balance hidden mt-30" },
	                  _react2.default.createElement(_ResultsPanelBalanceSheet2.default, {
	                    rounds: this.props.rounds,
	                    currentRound: currentRound,
	                    roundInUrl: roundInUrl
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "statement cash hidden mt-30" },
	                  _react2.default.createElement(_ResultsPanelCashFlows2.default, {
	                    rounds: this.props.rounds,
	                    currentRound: currentRound,
	                    roundInUrl: roundInUrl
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 col-xs-12" },
	            _react2.default.createElement(_competitiveAnalysis2.default, {
	              teams: this.state.teams,
	              data: this.state.data,
	              metrics: metrics,
	              activeRound: this.activeRound,
	              currentRound: currentRound,
	              roundInUrl: roundInUrl
	            }),
	            _react2.default.createElement(_ResultsValuationsResults2.default, {
	              valuationsResults: valuationsResults,
	              teams: this.state.teams
	            })
	          )
	        ) : _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	      );
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var _state2 = this.state,
	          currentRound = _state2.currentRound,
	          roundInUrl = _state2.roundInUrl;
	
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return roundInUrl;
	      }
	
	      return currentRound;
	    }
	  }]);
	
	  return Results;
	}(_react.Component);
	
	exports.default = Results;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _HelpIconButtonWithTooltip = __webpack_require__(156);
	
	var _HelpIconButtonWithTooltip2 = _interopRequireDefault(_HelpIconButtonWithTooltip);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsValuationsResults = function (_React$Component) {
	  _inherits(ResultsValuationsResults, _React$Component);
	
	  function ResultsValuationsResults() {
	    _classCallCheck(this, ResultsValuationsResults);
	
	    return _possibleConstructorReturn(this, (ResultsValuationsResults.__proto__ || Object.getPrototypeOf(ResultsValuationsResults)).apply(this, arguments));
	  }
	
	  _createClass(ResultsValuationsResults, [{
	    key: "getMarketValue",
	    value: function getMarketValue(team_id) {
	      if (team_id in this.props.valuationsResults.marketValue.data) {
	        return this.props.valuationsResults.marketValue.data[team_id];
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getPriceToEarnings",
	    value: function getPriceToEarnings(team_id) {
	      if (team_id in this.props.valuationsResults.pricetoEarnings.data) {
	        return this.props.valuationsResults.pricetoEarnings.data[team_id].toFixed(2);
	      }
	
	      return 0 .toFixed(2);
	    }
	  }, {
	    key: "getPriceToSales",
	    value: function getPriceToSales(team_id) {
	      if (team_id in this.props.valuationsResults.pricetoSales.data) {
	        return this.props.valuationsResults.pricetoSales.data[team_id].toFixed(2);
	      }
	
	      return 0 .toFixed(2);
	    }
	  }, {
	    key: "getPriceToBook",
	    value: function getPriceToBook(team_id) {
	      if (team_id in this.props.valuationsResults.pricetoBook.data) {
	        return this.props.valuationsResults.pricetoBook.data[team_id].toFixed(2);
	      }
	
	      return 0 .toFixed(2);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-analysis" },
	        _react2.default.createElement(
	          "h3",
	          { className: "semibold" },
	          "Valuation Results",
	          _react2.default.createElement(_HelpIconButtonWithTooltip2.default, {
	            tooltipContent: "This section compares your business\u2019s value relative to your competitors on 3 different valuation approaches.",
	            category: "Valuation Results"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "panel-dashboard-white bg-light-gray p-15 mt-30" },
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    _react2.default.createElement("span", null)
	                  ),
	                  Object.keys(this.props.teams).map(function (team_id) {
	                    var team_name = _this2.props.teams[team_id];
	                    return _react2.default.createElement(
	                      "th",
	                      { key: team_id },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        team_name
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "text-center" },
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Market Cap",
	                    _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                      iconSize: "xs"
	                    }, _TypeformContent2.default.BUSINESS_VALUATION))
	                  ),
	                  Object.keys(this.props.teams).map(function (team_id) {
	                    var marketValue = _this2.getMarketValue(team_id);
	                    return _react2.default.createElement(
	                      "td",
	                      { key: team_id },
	                      _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	                        value: marketValue,
	                        prefix: "$"
	                      })
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "text-center" },
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "P/E",
	                    _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                      iconSize: "xs"
	                    }, _TypeformContent2.default.PRICE_EARNINGS_RATIO))
	                  ),
	                  Object.keys(this.props.teams).map(function (team_id) {
	                    var priceToEarnings = _this2.getPriceToEarnings(team_id);
	                    return _react2.default.createElement(
	                      "td",
	                      { key: team_id },
	                      priceToEarnings < 0 ? "n/a" : priceToEarnings + "x"
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "text-center" },
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "P/S",
	                    _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                      iconSize: "xs"
	                    }, _TypeformContent2.default.PRICE_SALES_RATIO))
	                  ),
	                  Object.keys(this.props.teams).map(function (team_id) {
	                    var priceToSales = _this2.getPriceToSales(team_id);
	                    return _react2.default.createElement(
	                      "td",
	                      { key: team_id },
	                      priceToSales < 0 ? "n/a" : priceToSales + "x"
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "text-center" },
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "P/B",
	                    _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                      iconSize: "xs"
	                    }, _TypeformContent2.default.PRICE_TO_BOOK_RATIO))
	                  ),
	                  Object.keys(this.props.teams).map(function (team_id) {
	                    var priceToBook = _this2.getPriceToBook(team_id);
	                    return _react2.default.createElement(
	                      "td",
	                      { key: team_id },
	                      priceToBook < 0 ? "n/a" : priceToBook + "x"
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResultsValuationsResults;
	}(_react2.default.Component);
	
	exports.default = ResultsValuationsResults;

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n\n  th, td {\n    padding: 14px 16px;\n  }\n\n  thead th {\n    font-size: 12px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.6);\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    text-align: left;\n    border-bottom: 1px solid #E5E9F0;\n  }\n\n  tbody tr + tr td,\n  tbody tr + tr th {\n    border-top: 1px solid #E5E9F0;\n  }\n\n  th.dept {\n    font-size: 15px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: left;\n    width: 35%;\n  }\n\n  td.status {\n    text-align: center;\n    width: 35%;\n  }\n\n  td.cash {\n    text-align: right;\n    font-size: 16px;\n    font-weight: 400;\n    color: rgba(0, 27, 59, 0.94);\n    font-variant-numeric: tabular-nums;\n    width: 30%;\n  }\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n\n  th, td {\n    padding: 14px 16px;\n  }\n\n  thead th {\n    font-size: 12px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.6);\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    text-align: left;\n    border-bottom: 1px solid #E5E9F0;\n  }\n\n  tbody tr + tr td,\n  tbody tr + tr th {\n    border-top: 1px solid #E5E9F0;\n  }\n\n  th.dept {\n    font-size: 15px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: left;\n    width: 35%;\n  }\n\n  td.status {\n    text-align: center;\n    width: 35%;\n  }\n\n  td.cash {\n    text-align: right;\n    font-size: 16px;\n    font-weight: 400;\n    color: rgba(0, 27, 59, 0.94);\n    font-variant-numeric: tabular-nums;\n    width: 30%;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 12px;\n\n  b {\n    color: #C62828;\n    font-weight: 700;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 12px;\n\n  b {\n    color: #C62828;\n    font-weight: 700;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 16px;\n  align-items: stretch;\n\n  > * { height: 100%; }\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 16px;\n  align-items: stretch;\n\n  > * { height: 100%; }\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 1fr;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n\n  th, td {\n    padding: 14px 16px;\n  }\n\n  thead th {\n    font-size: 12px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.6);\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    text-align: left;\n    border-bottom: 1px solid #E5E9F0;\n  }\n\n  tbody tr + tr td,\n  tbody tr + tr th {\n    border-top: 1px solid #E5E9F0;\n  }\n\n  th.metric {\n    font-size: 15px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: left;\n  }\n\n  td.amount {\n    text-align: right;\n    font-size: 16px;\n    font-weight: 400;\n    color: rgba(0, 27, 59, 0.94);\n    font-variant-numeric: tabular-nums;\n  }\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Mukta Vaani', Lato, sans-serif;\n\n  th, td {\n    padding: 14px 16px;\n  }\n\n  thead th {\n    font-size: 12px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.6);\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    text-align: left;\n    border-bottom: 1px solid #E5E9F0;\n  }\n\n  tbody tr + tr td,\n  tbody tr + tr th {\n    border-top: 1px solid #E5E9F0;\n  }\n\n  th.metric {\n    font-size: 15px;\n    font-weight: 700;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: left;\n  }\n\n  td.amount {\n    text-align: right;\n    font-size: 16px;\n    font-weight: 400;\n    color: rgba(0, 27, 59, 0.94);\n    font-variant-numeric: tabular-nums;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _roundNotStarted = __webpack_require__(259);
	
	var _roundNotStarted2 = _interopRequireDefault(_roundNotStarted);
	
	var _projectionsModal = __webpack_require__(1162);
	
	var _projectionsModal2 = _interopRequireDefault(_projectionsModal);
	
	var _submitDecisions = __webpack_require__(261);
	
	var _submitDecisions2 = _interopRequireDefault(_submitDecisions);
	
	var _utils = __webpack_require__(18);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _roleButtons = __webpack_require__(258);
	
	var _roleButtons2 = _interopRequireDefault(_roleButtons);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _lastStep = __webpack_require__(254);
	
	var _lastStep2 = _interopRequireDefault(_lastStep);
	
	var _style = __webpack_require__(255);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _style3 = __webpack_require__(78);
	
	var _style4 = _interopRequireDefault(_style3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function capitalizeFirstLetter(s) {
	  return s.charAt(0).toUpperCase() + s.slice(1);
	}
	
	var CEO_PROJECTIONS_URL = ("https://be-production-itb.marketgames.io/api/") + "team/projections/";
	
	// ---------- styled components (lead-page only) ----------
	
	var SignoffsTable = _styledComponents2.default.table(_templateObject);
	
	var CashHeader = _styledComponents2.default.span(_templateObject2);
	
	// Two equal-width columns for the Signoffs (left) and Financial
	// Projection (right) section cards. Stacks on narrow widths so each
	// section still gets full breathing room on small screens.
	var SectionRow = _styledComponents2.default.div(_templateObject3);
	
	var ProjectionTable = _styledComponents2.default.table(_templateObject4);
	
	// ---------- component ----------
	
	var CeoDecisions = function (_PureComponent) {
	  _inherits(CeoDecisions, _PureComponent);
	
	  function CeoDecisions(props) {
	    _classCallCheck(this, CeoDecisions);
	
	    var _this = _possibleConstructorReturn(this, (CeoDecisions.__proto__ || Object.getPrototypeOf(CeoDecisions)).call(this, props));
	
	    _this.reloadRole = function () {
	      _this.setState({ hasAccess: _Auth2.default.getRole() === "CEO" });
	    };
	
	    _this.getProjectionsUrl = function () {
	      var _this$state = _this.state,
	          roundInUrl = _this$state.roundInUrl,
	          currentRound = _this$state.currentRound;
	
	      var apiURL = CEO_PROJECTIONS_URL;
	      var temporaryUser = _Auth2.default.getTemporaryUser();
	      if (temporaryUser) {
	        apiURL = apiURL + "?team_id=" + temporaryUser.team_id;
	      }
	      var literal = temporaryUser ? "&" : "?";
	      var roundNumber = roundInUrl !== null && roundInUrl !== currentRound ? roundInUrl : currentRound;
	      apiURL = "" + apiURL + literal + "round_number=" + roundNumber;
	      return apiURL;
	    };
	
	    _this.fetchData = function (showWarnings) {
	      var rounds = _this.state.rounds;
	
	      var roundNumber = _this.roundNumber;
	
	      if (rounds.length === 0) return;
	      var round = rounds.find(function (i) {
	        return i.number === roundNumber;
	      });
	      if (!round) return;
	
	      var requests = [(0, _TeamDecisionsService.fetchTeamDecisions)(roundNumber, 'ceo'), (0, _TeamDecisionsService.fetchTeamStatus)(roundNumber)];
	      if (!showWarnings) {
	        requests.push((0, _ApiService.getRequest)(_this.getProjectionsUrl()));
	      }
	
	      Promise.all(requests).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            decisionsData = _ref2[0],
	            statusData = _ref2[1],
	            projectionsRes = _ref2[2];
	
	        if (!_this._isMounted) return;
	
	        var decisions = decisionsData.decisions,
	            financial_decisions = decisionsData.financial_decisions;
	        var submission_data = statusData.submission_data,
	            unaccepted_decisions = statusData.unaccepted_decisions;
	
	        var projections = projectionsRes ? projectionsRes.body : _this.state.projections;
	
	        var spending = { pd: 0, pm: 0, op: 0, fn: 0 };
	        spending.pd = decisions.product_development_role;
	        spending.pm = decisions.product_marketing_role;
	        // Operations cash impact is now a single backend-computed
	        // aggregate (financial_decisions.team.operations) — no more
	        // client-side composition from machines / production / DC /
	        // facility components.
	        spending.op = Number(financial_decisions && financial_decisions.team && financial_decisions.team.operations || 0);
	        spending.fn = decisions.finance_role;
	
	        // Pre-check flags drive the SubmitDecisionsButton's "Posted"
	        // vs "POST DECISION" rendering. PM needs all three of its
	        // decisions complete; the rest gate on a real journal entry.
	        var pmHasPricing = (decisionsData.price_forecasts || []).some(function (i) {
	          return i.player !== null;
	        });
	        var pmHasPromos = (decisionsData.promos || []).some(function (i) {
	          return i.player !== null;
	        });
	        var pmHasSales = (decisionsData.sales || []).some(function (i) {
	          return i.player !== null;
	        });
	        var isPMPreChecked = pmHasPricing && pmHasPromos && pmHasSales;
	        var isOPPreChecked = submission_data.op && submission_data.op.date !== 'N/A';
	        var isFNPreChecked = submission_data.fn && submission_data.fn.date !== 'N/A';
	        var isPDPreChecked = submission_data.pd && submission_data.pd.date !== 'N/A';
	
	        // Signal to SubmitDecisions.js when every role has been posted
	        // AND has no pending changes, so it can render the "you're all
	        // set for this round" message instead of the plain success toast.
	        // Both signals must hold: has-posted-once (submission_data.<key>.date)
	        // AND nothing-newer-pending (unaccepted_decisions.<key> === 0).
	        if (showWarnings) {
	          var hasPosted = function hasPosted(k) {
	            return submission_data[k] && submission_data[k].date !== 'N/A';
	          };
	          var noPending = function noPending(k) {
	            return (Number(unaccepted_decisions[k]) || 0) === 0;
	          };
	          var allPosted = hasPosted('pd') && hasPosted('pm') && hasPosted('op') && hasPosted('fn') && noPending('PD') && noPending('PM') && noPending('OP') && noPending('FI');
	          showWarnings(decisionsData, { allPosted: allPosted });
	        }
	
	        _this.setState({
	          spending: spending,
	          financial_decisions: financial_decisions,
	          projections: projections,
	          loaded: true,
	          isPDPreChecked: isPDPreChecked,
	          isPMPreChecked: isPMPreChecked,
	          isOPPreChecked: isOPPreChecked,
	          isFNPreChecked: isFNPreChecked,
	          submission_data: submission_data,
	          unaccepted_decisions: unaccepted_decisions,
	          submitDecisionsLoadingDevelopment: false,
	          submitDecisionsLoadingMarketing: false,
	          submitDecisionsLoadingOperations: false,
	          submitDecisionsLoadingFinance: false
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "CeoDecisions", "fetchData");
	      });
	    };
	
	    _this.showRoleAlert = function () {
	      return _this.setState({ roleAlert: true });
	    };
	
	    _this.hideRoleAlert = function () {
	      return _this.setState({ roleAlert: false });
	    };
	
	    _this.getSubmissionData = function (type, showWarnings) {
	      _this.setState(_defineProperty({}, "submitDecisionsLoading" + type, true));
	      _this.fetchData(showWarnings);
	    };
	
	    _this.submitDecisions = function (type) {
	      var t = capitalizeFirstLetter(type);
	      _this.setState(_defineProperty({}, "submitDecisionsLoading" + t, true));
	      (0, _SubmitDecisions.submitDecisions)(type, _this.props.roundInUrl || _this.props.currentRound, function (showWarnings) {
	        return _this.getSubmissionData(t, showWarnings);
	      });
	    };
	
	    _this.openProjectionsModal = function () {
	      if (!_this.state.hasAccess) {
	        _this.showRoleAlert();
	        return;
	      }
	      _this.setState({ showProjectionsModal: true });
	      // First-time walkthrough: fire the guided tour only when no
	      // projection row has ever been saved for this team across any
	      // round. The round-scoped projections in state cover the current
	      // round only, so we hit the endpoint without round_number to see
	      // if anything exists team-wide.
	      var temporaryUser = _Auth2.default.getTemporaryUser();
	      var url = temporaryUser ? CEO_PROJECTIONS_URL + "?team_id=" + temporaryUser.team_id : CEO_PROJECTIONS_URL;
	      (0, _ApiService.getRequest)(url).then(function (res) {
	        if (!_this._isMounted) return;
	        var all = res && res.body || [];
	        if (all.length === 0) {
	          _this.setState({ showProjectionsTour: true });
	        }
	      }).catch(function (err) {
	        return (0, _utils.logError)(err, "CeoDecisions", "openProjectionsModal");
	      });
	    };
	
	    _this.closeProjectionsModal = function () {
	      return _this.setState({
	        showProjectionsModal: false,
	        showProjectionsTour: false
	      });
	    };
	
	    _this.endProjectionsTour = function () {
	      return _this.setState({ showProjectionsTour: false });
	    };
	
	    _this.startProjectionsTour = function () {
	      return _this.setState({ showProjectionsTour: true });
	    };
	
	    _this.getProjection = function (year) {
	      var found = (_this.state.projections || []).find(function (i) {
	        return i.target_round_number === year;
	      });
	      return found || {};
	    };
	
	    _this.getProjectionObjectModified = function (year, offset) {
	      var obj = Object.assign({}, _this.getProjection(year));
	      delete obj.id;
	      if (typeof obj.target_round_number === 'number') {
	        obj.target_round_number += offset;
	      }
	      return obj;
	    };
	
	    _this.projectionMetrics = function (year) {
	      var proj = _this.getProjection(year);
	      var units = Number(proj.units_sold) || 0;
	      var price = Number(proj.average_selling_price) || 0;
	      var unitCost = Number(proj.average_unit_costs) || 0;
	      var opex = Number(proj.other_operating_costs) || 0;
	      var nonOp = Number(proj.non_operating_expenses) || 0;
	
	      var revenues = units * price;
	      var cogs = units * unitCost;
	      var grossProfits = revenues - cogs;
	      var operatingProfits = grossProfits - opex;
	      var incomeBeforeTaxes = operatingProfits - nonOp;
	      var taxes = incomeBeforeTaxes > 0 ? incomeBeforeTaxes * 0.3 : 0;
	      var netProfits = incomeBeforeTaxes - taxes;
	
	      return { revenues: revenues, grossProfits: grossProfits, operatingProfits: operatingProfits, netProfits: netProfits };
	    };
	
	    _this.fmtCash = function (v) {
	      var num = Number(v) || 0;
	      var rounded = Math.round(Math.abs(num));
	      var formatted = "$" + rounded.toLocaleString('en-US');
	      return num < 0 ? "-" + formatted : formatted;
	    };
	
	    _this.fmtCashCell = function (v) {
	      var num = Number(v) || 0;
	      return _react2.default.createElement(
	        "span",
	        { style: { color: num < 0 ? '#C62828' : 'inherit' } },
	        _this.fmtCash(num)
	      );
	    };
	
	    _this._isMounted = false;
	
	    var hasAccess = _Auth2.default.getRole() === "CEO";
	
	    _this.state = {
	      hasAccess: hasAccess,
	      roleAlert: false,
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds,
	      projections: [],
	      loaded: false,
	      spending: { pd: 0, pm: 0, op: 0, fn: 0 },
	      submission_data: {
	        pd: { date: "N/A", unaccepted: 0 },
	        pm: { date: "N/A", unaccepted: 0 },
	        op: { date: "N/A", unaccepted: 0 },
	        fn: { date: "N/A", unaccepted: 0 }
	      },
	      financial_decisions: null,
	      unaccepted_decisions: null,
	      submitDecisionsLoadingDevelopment: true,
	      submitDecisionsLoadingMarketing: true,
	      submitDecisionsLoadingOperations: true,
	      submitDecisionsLoadingFinance: true,
	      isPDPreChecked: false,
	      isPMPreChecked: false,
	      isOPPreChecked: false,
	      isFNPreChecked: false,
	      showProjectionsModal: false,
	      showProjectionsTour: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(CeoDecisions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds && this.state.rounds.length === 0 && nextProps.rounds && nextProps.rounds.length !== 0) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	          _this2.reloadRole();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: "renderSignoffsRow",
	    value: function renderSignoffsRow(department, type, spend, isLoading, isPreChecked) {
	      var _this3 = this;
	
	      var extraProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	      var dataKey = type === 'development' ? 'pd' : type === 'marketing' ? 'pm' : type === 'operations' ? 'op' : 'fn';
	      var submission = this.state.submission_data[dataKey];
	      var temporaryUser = _Auth2.default.getTemporaryUser();
	
	      return _react2.default.createElement(
	        "tr",
	        { key: department },
	        _react2.default.createElement(
	          "th",
	          { className: "dept" },
	          department
	        ),
	        !temporaryUser && _react2.default.createElement(
	          "td",
	          { className: "status" },
	          _react2.default.createElement(_submitDecisions2.default, Object.assign({
	            id: "ceo-submit-decisions-" + dataKey,
	            tooltipPlacement: "right",
	            data: submission,
	            isLoading: isLoading,
	            isActive: this.showActionButtons,
	            onClick: function onClick() {
	              return _this3.submitDecisions(type);
	            },
	            isPreChecked: isPreChecked
	          }, extraProps))
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "cash" },
	          this.fmtCashCell(spend)
	        )
	      );
	    }
	  }, {
	    key: "renderFinancialProjectionCard",
	    value: function renderFinancialProjectionCard() {
	      var metrics = this.projectionMetrics(this.year1);
	      var fmt = function fmt(v) {
	        return "$" + Math.round(v).toLocaleString('en-US');
	      };
	      var rows = [{ label: 'Revenues', value: metrics.revenues, negative: false }, { label: 'Gross Margins', value: metrics.grossProfits, negative: metrics.grossProfits < 0 }, { label: 'Operating Profits', value: metrics.operatingProfits, negative: metrics.operatingProfits < 0 }, { label: 'Net Profits', value: metrics.netProfits, negative: metrics.netProfits < 0 }];
	
	      return _react2.default.createElement(
	        _style4.default.SectionCard,
	        null,
	        _react2.default.createElement(
	          _style4.default.SectionHeader,
	          null,
	          _react2.default.createElement(
	            _style4.default.SectionTitle,
	            null,
	            "Financial Projection"
	          ),
	          _react2.default.createElement(
	            _style4.default.SectionSubtitle,
	            null,
	            "Year ",
	            this.year1,
	            " projection from the financial assumptions you've saved. Click ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Make Financial Projections"
	            ),
	            " to update."
	          )
	        ),
	        _react2.default.createElement(
	          ProjectionTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Line Items"
	              ),
	              _react2.default.createElement(
	                "th",
	                { style: { textAlign: 'right' } },
	                "Year ",
	                this.year1
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            rows.map(function (row) {
	              return _react2.default.createElement(
	                "tr",
	                { key: row.label },
	                _react2.default.createElement(
	                  "th",
	                  { className: "metric" },
	                  row.label
	                ),
	                _react2.default.createElement(
	                  "td",
	                  { className: "amount" },
	                  _react2.default.createElement(
	                    "span",
	                    { style: { color: row.negative ? '#C62828' : 'inherit' } },
	                    row.negative ? "-" + fmt(Math.abs(row.value)) : fmt(row.value)
	                  )
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderSignoffsCard",
	    value: function renderSignoffsCard() {
	      var temporaryUser = _Auth2.default.getTemporaryUser();
	      var _state = this.state,
	          spending = _state.spending,
	          submitDecisionsLoadingDevelopment = _state.submitDecisionsLoadingDevelopment,
	          submitDecisionsLoadingMarketing = _state.submitDecisionsLoadingMarketing,
	          submitDecisionsLoadingOperations = _state.submitDecisionsLoadingOperations,
	          submitDecisionsLoadingFinance = _state.submitDecisionsLoadingFinance,
	          financial_decisions = _state.financial_decisions,
	          unaccepted_decisions = _state.unaccepted_decisions,
	          isPDPreChecked = _state.isPDPreChecked,
	          isPMPreChecked = _state.isPMPreChecked,
	          isOPPreChecked = _state.isOPPreChecked,
	          isFNPreChecked = _state.isFNPreChecked;
	
	
	      return _react2.default.createElement(
	        _style4.default.SectionCard,
	        null,
	        _react2.default.createElement(
	          _style4.default.SectionHeader,
	          null,
	          _react2.default.createElement(
	            _style4.default.SectionTitle,
	            null,
	            "Signoffs"
	          ),
	          _react2.default.createElement(
	            _style4.default.SectionSubtitle,
	            null,
	            "Post each department's decisions any time before the round ends. You can repost whenever your plans change. The Cash column shows what each function has spent or received this round."
	          )
	        ),
	        _react2.default.createElement(
	          SignoffsTable,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement(
	                "th",
	                null,
	                "Department"
	              ),
	              !temporaryUser && _react2.default.createElement(
	                "th",
	                { style: { textAlign: 'center' } },
	                "Submission Status"
	              ),
	              _react2.default.createElement(
	                "th",
	                { style: { textAlign: 'right' } },
	                _react2.default.createElement(
	                  CashHeader,
	                  null,
	                  "Cash ",
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "used"
	                  ),
	                  "/received"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            this.renderSignoffsRow('Product Management', 'development', spending.pd, submitDecisionsLoadingDevelopment, isPDPreChecked),
	            this.renderSignoffsRow('Product Marketing', 'marketing', spending.pm, submitDecisionsLoadingMarketing, isPMPreChecked),
	            this.renderSignoffsRow('Operations', 'operations', spending.op, submitDecisionsLoadingOperations, isOPPreChecked),
	            this.renderSignoffsRow('Finance', 'finance', spending.fn, submitDecisionsLoadingFinance, isFNPreChecked, {
	              financial_decisions: financial_decisions,
	              unaccepted_decisions: unaccepted_decisions,
	              isRoundEnded: this.isViewedRoundEnded
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // Lock the page for students only when no round has ever been
	      // started (`is_started` false on every record). Covers "no rounds
	      // set up" (empty array) and "rounds scheduled but not yet running".
	      // Deliberately does NOT fire once the game has finished — the
	      // "hasn't started yet" copy would be misleading, and the user
	      // should be free to browse historical decisions read-only.
	      // `game.round` used to be part of this gate, but it's a
	      // manually-set pointer that lags behind auto-started rounds —
	      // relying on it locked students out of the running practice
	      // round. Instructors don't see this because these decision
	      // routes are student-only.
	      var _props = this.props,
	          rounds = _props.rounds,
	          rounds_loaded = _props.rounds_loaded;
	
	      var hasEverStarted = (rounds || []).some(function (r) {
	        return r && r.is_started === true;
	      });
	      if (rounds_loaded && !hasEverStarted) {
	        return _react2.default.createElement(_roundNotStarted2.default, null);
	      }
	
	      var showActionButtons = this.showActionButtons;
	      var _props2 = this.props,
	          tourMode = _props2.tourMode,
	          location = _props2.location,
	          router = _props2.router,
	          round = _props2.currentRound;
	      var _state2 = this.state,
	          hasAccess = _state2.hasAccess,
	          roleAlert = _state2.roleAlert,
	          loaded = _state2.loaded,
	          showProjectionsModal = _state2.showProjectionsModal,
	          showProjectionsTour = _state2.showProjectionsTour;
	
	
	      return _react2.default.createElement(
	        _style2.default.BodyWrapper,
	        null,
	        _react2.default.createElement(_lastStep2.default, {
	          location: location,
	          router: router,
	          url: "/decisions/ceo?round=" + round
	        }),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: roleAlert,
	          title: "Information",
	          text: "Unfortunately, you are not authorized to make this decision",
	          type: "info",
	          onConfirm: this.hideRoleAlert
	        }),
	        _react2.default.createElement(
	          _style2.default.TitleWrapper,
	          null,
	          _react2.default.createElement(
	            _style2.default.Title,
	            { id: "ceo-decisions-title" },
	            "CEO Decisions",
	            hasAccess && _react2.default.createElement(_roleButtons2.default, { type: "ceo" })
	          )
	        ),
	        _react2.default.createElement(
	          _style2.default.Subtitle,
	          null,
	          "Set financial projections that guide Finance's capital raise, then sign off on team decisions by posting them once all roles have submitted."
	        ),
	        showActionButtons && loaded && _react2.default.createElement(
	          _style4.default.ManageButtonBar,
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            _style4.default.ManageButton,
	            { onClick: this.openProjectionsModal },
	            "Make Financial Projections"
	          )
	        ),
	        loaded === false && _react2.default.createElement(
	          "div",
	          { className: "loader_spinner", style: { marginTop: 24 } },
	          "Loading..."
	        ),
	        loaded === true && _react2.default.createElement(
	          SectionRow,
	          null,
	          this.renderSignoffsCard(),
	          this.renderFinancialProjectionCard()
	        ),
	        showProjectionsModal &&
	        // Full-page overlay (z-index 1500) so the projections form
	        // covers the lead page like the product-decision popups. The
	        // existing ProjectionsModal renders its content inline when
	        // showModalState is true; wrapping it here gives that content
	        // the same fixed-positioned canvas as the other decision
	        // overlays without rewriting the form itself.
	        _react2.default.createElement(
	          _style4.default.LenderOverlay,
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: {
	                maxWidth: 1160,
	                margin: '0 auto',
	                padding: '32px 40px 48px',
	                fontFamily: "'Mukta Vaani', Lato, sans-serif"
	              } },
	            _react2.default.createElement(_projectionsModal2.default, {
	              year_number1: this.year1,
	              year1: this.year1Projection,
	              year2: this.year2Projection,
	              year3: this.year3Projection,
	              currentRound: round,
	              onSave: this.fetchData,
	              hasAccess: hasAccess,
	              showRoleAlert: this.showRoleAlert,
	              tourMode: tourMode,
	              showModalState: showProjectionsModal,
	              showModal: this.openProjectionsModal,
	              hideModal: this.closeProjectionsModal,
	              showTour: showProjectionsTour,
	              onTourEnd: this.endProjectionsTour,
	              onStartTour: this.startProjectionsTour
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "roundNumber",
	    get: function get() {
	      var _state3 = this.state,
	          roundInUrl = _state3.roundInUrl,
	          currentRound = _state3.currentRound;
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) return roundInUrl;
	      return currentRound;
	    }
	  }, {
	    key: "showActionButtons",
	    get: function get() {
	      if (this.state.hasAccess === false) return false;
	      if (this.props.roundShouldBeFinished === true) return false;
	      var _state4 = this.state,
	          roundInUrl = _state4.roundInUrl,
	          currentRound = _state4.currentRound,
	          rounds = _state4.rounds;
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) return false;
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	      if (!round) return false;
	      return round.is_started === true && round.is_finished === false;
	    }
	  }, {
	    key: "isViewedRoundEnded",
	    get: function get() {
	      var _state5 = this.state,
	          roundInUrl = _state5.roundInUrl,
	          currentRound = _state5.currentRound,
	          rounds = _state5.rounds;
	
	      var viewedNumber = roundInUrl !== null ? roundInUrl : currentRound;
	      var round = rounds.find(function (i) {
	        return i.number === viewedNumber;
	      });
	      if (!round) return false;
	      return round.is_started === true && round.is_finished === true;
	    }
	
	    // ---------- projection helpers ----------
	
	  }, {
	    key: "year1",
	    get: function get() {
	      var _state6 = this.state,
	          roundInUrl = _state6.roundInUrl,
	          currentRound = _state6.currentRound;
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) return roundInUrl;
	      return currentRound;
	    }
	  }, {
	    key: "year2",
	    get: function get() {
	      return this.year1 + 1;
	    }
	  }, {
	    key: "year3",
	    get: function get() {
	      return this.year1 + 2;
	    }
	  }, {
	    key: "year1Projection",
	    get: function get() {
	      return this.getProjection(this.year1);
	    }
	
	    // ProjectionsModal expects three years' projections; fall back to
	    // copying year 1's row when 2/3 aren't on the backend yet so the
	    // form has something to seed.
	
	  }, {
	    key: "year2Projection",
	    get: function get() {
	      var found = this.getProjection(this.year2);
	      return Object.keys(found).length === 0 ? this.getProjectionObjectModified(this.year1, 1) : found;
	    }
	  }, {
	    key: "year3Projection",
	    get: function get() {
	      var found = this.getProjection(this.year3);
	      return Object.keys(found).length === 0 ? this.getProjectionObjectModified(this.year1, 2) : found;
	    }
	
	    // ---------- render helpers ----------
	
	    // Format cash to the full dollar value, rounded (no millions
	    // abbreviation). Negative values render red to match the existing
	    // "used" treatment.
	
	  }]);
	
	  return CeoDecisions;
	}(_react.PureComponent);
	
	exports.default = (0, _reactEasyState.view)(CeoDecisions);

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(24);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _utils = __webpack_require__(18);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _icon_collapse = __webpack_require__(274);
	
	var _icon_collapse2 = _interopRequireDefault(_icon_collapse);
	
	var _kpis = __webpack_require__(1144);
	
	var _kpis2 = _interopRequireDefault(_kpis);
	
	var _kpis3 = __webpack_require__(1145);
	
	var _kpis4 = _interopRequireDefault(_kpis3);
	
	var _marketCapture = __webpack_require__(1146);
	
	var _marketCapture2 = _interopRequireDefault(_marketCapture);
	
	var _productCosts = __webpack_require__(1149);
	
	var _productCosts2 = _interopRequireDefault(_productCosts);
	
	var _volume = __webpack_require__(1156);
	
	var _volume2 = _interopRequireDefault(_volume);
	
	var _utilization = __webpack_require__(1155);
	
	var _utilization2 = _interopRequireDefault(_utilization);
	
	var _topTeams = __webpack_require__(1154);
	
	var _topTeams2 = _interopRequireDefault(_topTeams);
	
	var _topProductsMobile = __webpack_require__(1153);
	
	var _topProductsMobile2 = _interopRequireDefault(_topProductsMobile);
	
	var _topProductsAuto = __webpack_require__(1152);
	
	var _topProductsAuto2 = _interopRequireDefault(_topProductsAuto);
	
	var _pricing = __webpack_require__(1148);
	
	var _pricing2 = _interopRequireDefault(_pricing);
	
	var _perceptualMap = __webpack_require__(1147);
	
	var _perceptualMap2 = _interopRequireDefault(_perceptualMap);
	
	var _salesSpending = __webpack_require__(1151);
	
	var _salesSpending2 = _interopRequireDefault(_salesSpending);
	
	var _promotionalSpend = __webpack_require__(1150);
	
	var _promotionalSpend2 = _interopRequireDefault(_promotionalSpend);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompetitiveAnalysis = function (_Component) {
	  _inherits(CompetitiveAnalysis, _Component);
	
	  function CompetitiveAnalysis(props) {
	    _classCallCheck(this, CompetitiveAnalysis);
	
	    var _this = _possibleConstructorReturn(this, (CompetitiveAnalysis.__proto__ || Object.getPrototypeOf(CompetitiveAnalysis)).call(this, props));
	
	    _this.fetchData = function () {
	      var teams = {};
	      var data = {};
	
	      _Teams2.default.teams().forEach(function (item) {
	        teams[item.id] = item.name;
	        data[item.id] = {};
	      });
	
	      _this.setState({
	        teams: teams,
	        data: data
	      }, function () {
	        _this.loadState();
	      });
	    };
	
	    _this.getRequests = function () {
	      var request1 = _this.getTotalDemand();
	      var request2 = _this.getTopPerformers();
	
	      return (0, _ApiService.batchRequest)([request1, request2]);
	    };
	
	    _this.loadState = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var roundId = _this.getCompetitiveAnalysisRoundId();
	      if (!roundId) {
	        _this.setState({ loaded: true });
	        return;
	      }
	
	      var currentTeam = _Teams2.default.teams()[0];
	      var competitionId = currentTeam ? Number(currentTeam.competition) : 0;
	
	      if (_this.joinRequest) {
	        _this.joinRequest.abort();
	        _this.joinRequest = null;
	      }
	      _this.joinRequest = _this.getRequests();
	
	      Promise.all([(0, _MetricsService.fetchCompetitiveAnalysis)(competitionId, roundId), (0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId), _this.joinRequest]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            caData = _ref2[0],
	            competition_metrics = _ref2[1],
	            res = _ref2[2];
	
	        var data = Object.assign({}, _this.state.data);
	        var res0 = res[0].body;
	        var top_performers = res[1].body;
	        var _this$state = _this.state,
	            currentRound = _this$state.currentRound,
	            roundInUrl = _this$state.roundInUrl;
	
	        var exclude_keys = ["created_at", "id", "is_actual", "reason", "round", "team", "updated_at"];
	
	        var metrics = {};
	        competition_metrics.forEach(function (row) {
	          metrics[row.team] = {
	            MarketShare: row["Market Share"] ? row["Market Share"] : 0,
	            Revenues: row["Net Revenues"] ? row["Net Revenues"] : 0,
	            GrossMargins: row["Gross Margin"] ? row["Gross Margin"] : 0
	          };
	        });
	
	        caData.forEach(function (item) {
	          if (item.team in data) {
	            Object.keys(item).forEach(function (key) {
	              if (exclude_keys.includes(key)) {
	                return;
	              }
	
	              data[item.team][key] = item[key] === null ? 0 : item[key];
	            });
	          }
	        });
	
	        var current_round = currentRound;
	        if (roundInUrl !== null && roundInUrl !== currentRound) {
	          current_round = roundInUrl;
	        }
	
	        var obj = res0.find(function (i) {
	          return i.round_number === current_round;
	        });
	        var total_demand = {
	          auto: 0,
	          mobile: 0
	        };
	
	        if (obj) {
	          total_demand.auto = obj.auto;
	          total_demand.mobile = obj.mobile;
	        }
	
	        _this.setState({
	          data: data,
	          total_demand: total_demand,
	          top_performers: top_performers,
	          metrics: metrics,
	          loaded: true
	        }, function () {
	          _this.joinRequest = null;
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "CompetitiveAnalysis", "loadState");
	      });
	    };
	
	    _this.state = {
	      data: {},
	      total_demand: {
	        auto: 0,
	        mobile: 0
	      },
	      teams: {},
	      top_performers: {},
	      metrics: {},
	      loaded: false,
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(CompetitiveAnalysis, [{
	    key: "getCompetitiveAnalysisRoundId",
	    value: function getCompetitiveAnalysisRoundId() {
	      var _state = this.state,
	          currentRound = _state.currentRound,
	          roundInUrl = _state.roundInUrl,
	          rounds = _state.rounds;
	
	
	      var roundId = null;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        var round = rounds.find(function (i) {
	          return i.number === roundInUrl;
	        });
	        if (round) {
	          roundId = round.id;
	        }
	      } else {
	        var _round = rounds.find(function (i) {
	          return i.number === currentRound;
	        });
	        if (_round) {
	          if (_round.is_finished === true) {
	            roundId = _round.id;
	          } else {
	            var round_number = currentRound - 1;
	            if (round_number > 0) {
	              _round = rounds.find(function (i) {
	                return i.number === round_number;
	              });
	              if (_round) {
	                roundId = _round.id;
	              }
	            }
	          }
	        }
	      }
	
	      return roundId;
	    }
	  }, {
	    key: "getTotalDemand",
	    value: function getTotalDemand() {
	      return ("https://be-production-itb.marketgames.io/api/") + "static/total_demand/";
	    }
	  }, {
	    key: "getTopPerformers",
	    value: function getTopPerformers() {
	      var _state2 = this.state,
	          currentRound = _state2.currentRound,
	          roundInUrl = _state2.roundInUrl;
	
	      var game_id = _Auth2.default.getGameId();
	      var round_number = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        round_number = roundInUrl;
	      }
	
	      return ("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/top_performers/?round_number=" + round_number;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.joinRequest) {
	        this.joinRequest.abort();
	        this.joinRequest = null;
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var needUpdate = false;
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        needUpdate = true;
	      }
	
	      if (this.state.currentRound !== nextProps.currentRound) {
	        needUpdate = true;
	      }
	
	      if (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
	        needUpdate = true;
	      }
	
	      var round1 = this.state.rounds.find(function (i) {
	        return i.number === nextProps.currentRound;
	      });
	      var round2 = nextProps.rounds.find(function (i) {
	        return i.number === nextProps.currentRound;
	      });
	      if (round1 && round2 && round1.is_finished !== round2.is_finished) {
	        needUpdate = true;
	      }
	
	      if (needUpdate === true) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state3 = this.state,
	          teams = _state3.teams,
	          data = _state3.data,
	          total_demand = _state3.total_demand,
	          top_performers = _state3.top_performers,
	          loaded = _state3.loaded,
	          metrics = _state3.metrics,
	          roundInUrl = _state3.roundInUrl,
	          currentRound = _state3.currentRound;
	
	      var currentYear = this.currentYear;
	      var url = "/ceo/analysis";
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        url = "/ceo/analysis?round=" + roundInUrl;
	      }
	
	      return _react2.default.createElement(
	        "section",
	        {
	          id: "ca-wrapper",
	          className: "analysis" + (loaded ? " bg-gray" : "")
	        },
	        loaded ? _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "h3",
	            { className: "h3-icon semibold" },
	            "Competitive Analysis",
	            _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, _TypeformContent2.default.COMPETITIVE_ANALYSIS),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: url, className: "icon-zoom" },
	              _react2.default.createElement("img", { src: _icon_collapse2.default, className: "icon", alt: "CollapseImage" })
	            )
	          ),
	          this.showTopPerformers === true && _react2.default.createElement(
	            "div",
	            { className: "competitive-analysis-title-bar" },
	            "TOP PERFORMERS"
	          ),
	          this.showTopPerformers === true && _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(_topTeams2.default, { teams: teams, top_performers: top_performers }),
	            _react2.default.createElement(_topProductsMobile2.default, {
	              teams: teams,
	              top_performers: top_performers
	            }),
	            _react2.default.createElement(_topProductsAuto2.default, {
	              teams: teams,
	              top_performers: top_performers
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "competitive-analysis-title-bar" },
	            "LEADING KPIS"
	          ),
	          currentYear <= 4 && _react2.default.createElement(_kpis2.default, { teams: teams, data: data, metrics: metrics }),
	          currentYear > 4 && _react2.default.createElement(_kpis4.default, { teams: teams, data: data }),
	          _react2.default.createElement(
	            "div",
	            { className: "competitive-analysis-title-bar" },
	            "DEMAND ANALYSIS"
	          ),
	          _react2.default.createElement(_marketCapture2.default, {
	            teams: teams,
	            data: data,
	            total_demand: total_demand
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "competitive-analysis-title-bar" },
	            "OPERATIONAL ANALYSIS"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(_productCosts2.default, { teams: teams, data: data }),
	            this.isMobile === false && _react2.default.createElement(_volume2.default, { teams: teams, data: data }),
	            _react2.default.createElement(_utilization2.default, { teams: teams, data: data })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "competitive-analysis-title-bar" },
	            "MARKETING MIX"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(_pricing2.default, { teams: teams, data: data }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 col-xs-12" },
	              this.isMobile === false && _react2.default.createElement(_perceptualMap2.default, null),
	              _react2.default.createElement(_salesSpending2.default, { teams: teams, data: data })
	            ),
	            _react2.default.createElement(_promotionalSpend2.default, { teams: teams, data: data })
	          )
	        ) : _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	      );
	    }
	  }, {
	    key: "showTopPerformers",
	    get: function get() {
	      var top_performers = this.state.top_performers;
	
	      return Object.keys(top_performers).length > 0;
	    }
	  }, {
	    key: "currentYear",
	    get: function get() {
	      var _state4 = this.state,
	          currentRound = _state4.currentRound,
	          roundInUrl = _state4.roundInUrl;
	
	
	      var current_year = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_year = roundInUrl;
	      }
	
	      return current_year;
	    }
	  }]);
	
	  return CompetitiveAnalysis;
	}(_react.Component);
	
	exports.default = CompetitiveAnalysis;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _style = __webpack_require__(1180);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _postedDecisions = __webpack_require__(2669);
	
	var _postedDecisions2 = _interopRequireDefault(_postedDecisions);
	
	var _decisionsWaitForSales = __webpack_require__(2572);
	
	var _decisionsWaitForSales2 = _interopRequireDefault(_decisionsWaitForSales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Decisions = function (_PureComponent) {
	  _inherits(Decisions, _PureComponent);
	
	  function Decisions() {
	    _classCallCheck(this, Decisions);
	
	    return _possibleConstructorReturn(this, (Decisions.__proto__ || Object.getPrototypeOf(Decisions)).apply(this, arguments));
	  }
	
	  _createClass(Decisions, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _style2.default.BodyWrapper,
	        null,
	        _react2.default.createElement(
	          _style2.default.Title,
	          null,
	          "The Decision & Sales Process"
	        ),
	        _react2.default.createElement(
	          _style2.default.Paragraph,
	          null,
	          "Make Cross-functional Decisions\xA0\xA0-->\xA0\xA0Post Them\xA0\xA0-->\xA0\xA0And Then Wait for the Sales Process"
	        ),
	        _react2.default.createElement(
	          _style2.default.Steps,
	          null,
	          _react2.default.createElement(
	            _style2.default.Step,
	            { className: "blue" },
	            _react2.default.createElement(
	              _style2.default.StepTitle,
	              null,
	              "Step 1: Make Decisions"
	            ),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              null,
	              "We recommend making decisions in the following order:"
	            ),
	            _react2.default.createElement(
	              _style2.default.StepOrderItems,
	              null,
	              _react2.default.createElement(
	                _style2.default.StepOrderItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "PRODUCT:"
	                ),
	                " Create an image sensor that customers want. You can create up to 4 sensors."
	              ),
	              _react2.default.createElement(
	                _style2.default.StepOrderItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "MARKETING:"
	                ),
	                " make pricing, promotion, and sales decisions for your product(s)."
	              ),
	              _react2.default.createElement(
	                _style2.default.StepOrderItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "OPERATIONS:"
	                ),
	                " Make manufacturing decisions for your product(s)."
	              ),
	              _react2.default.createElement(
	                _style2.default.StepOrderItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "CEO PROJECTIONS:"
	                ),
	                " Make financial projections for investors."
	              ),
	              _react2.default.createElement(
	                _style2.default.StepOrderItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "FINANCE:"
	                ),
	                " Raise capital from investors to finance your product, marketing, and operation spending."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _style2.default.Step,
	            { className: "ivory" },
	            _react2.default.createElement(
	              _style2.default.StepTitle,
	              null,
	              "Step 2: Post Decisions"
	            ),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              null,
	              "After making all decisions, navigate to the CEO page and post them, ",
	              _react2.default.createElement(
	                "u",
	                null,
	                "start with posting finance"
	              ),
	              "."
	            ),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              null,
	              _react2.default.createElement(
	                "b",
	                null,
	                "Note:"
	              ),
	              " Your cash balance needs to be positive before you can post successfully."
	            ),
	            _react2.default.createElement(_style2.default.Gap, null),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              { className: "small" },
	              "Example: Successfully posted decisions"
	            ),
	            _react2.default.createElement(_style2.default.Image, { src: _postedDecisions2.default, alt: "Posted Decisions" })
	          ),
	          _react2.default.createElement(
	            _style2.default.Step,
	            { className: "white" },
	            _react2.default.createElement(
	              _style2.default.StepTitle,
	              null,
	              "Step 3: Wait for sales"
	            ),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              null,
	              "Your work is done after posting your decisions, Just wait for the round deadline to end for sales to process."
	            ),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              { className: "no-margin" },
	              "Here\u2019s how the sales process works:"
	            ),
	            _react2.default.createElement(
	              _style2.default.List,
	              null,
	              _react2.default.createElement(
	                _style2.default.ListItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Awareness:"
	                ),
	                " Customer search and discover the most visible products."
	              ),
	              _react2.default.createElement(
	                _style2.default.ListItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Consideration:"
	                ),
	                " They compare options that fit their preferences."
	              ),
	              _react2.default.createElement(
	                _style2.default.ListItem,
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Conversion:"
	                ),
	                " They then buy the product that fits the preferences best."
	              )
	            ),
	            _react2.default.createElement(_style2.default.Image, { src: _decisionsWaitForSales2.default, alt: "Decisions Wait For Sales" }),
	            _react2.default.createElement(
	              _style2.default.StepParagraph,
	              { className: "no-margin" },
	              _react2.default.createElement(
	                "b",
	                null,
	                "Tip:"
	              ),
	              " Sales depend on your product\u2019s visibility and attractiveness to customers."
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Decisions;
	}(_react.PureComponent);
	
	exports.default = (0, _reactEasyState.view)(Decisions);

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _icon_collapse = __webpack_require__(274);
	
	var _icon_collapse2 = _interopRequireDefault(_icon_collapse);
	
	var _hawk = __webpack_require__(2581);
	
	var _hawk2 = _interopRequireDefault(_hawk);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EconomicAnalysis = function (_PureComponent) {
	  _inherits(EconomicAnalysis, _PureComponent);
	
	  function EconomicAnalysis(props) {
	    _classCallCheck(this, EconomicAnalysis);
	
	    var _this = _possibleConstructorReturn(this, (EconomicAnalysis.__proto__ || Object.getPrototypeOf(EconomicAnalysis)).call(this, props));
	
	    _this.isMobile = (0, _utils.detectMobile)();
	    return _this;
	  }
	
	  _createClass(EconomicAnalysis, [{
	    key: "render",
	    value: function render() {
	      var style1 = this.isMobile ? {
	        borderSpacing: 0
	      } : {};
	      var style2 = this.isMobile ? {
	        width: "100%",
	        margin: 0
	      } : {};
	
	      return _react2.default.createElement(
	        "section",
	        { className: "analysis bg-gray" },
	        _react2.default.createElement(
	          "h3",
	          { className: "h3-icon semibold" },
	          "Economic Analysis",
	          _react2.default.createElement(_reactFontawesome2.default, { className: "question-mark", name: "question-circle" }),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/ceo/analysis", className: "icon-zoom" },
	            _react2.default.createElement("img", { src: _icon_collapse2.default, className: "icon", alt: "CollapseImage" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "columns", style: style1 },
	          _react2.default.createElement(
	            "div",
	            { className: "column-2", style: style2 },
	            _react2.default.createElement(
	              "div",
	              { className: "row fix-after" },
	              this.isMobile === false && _react2.default.createElement(
	                "div",
	                { className: "col-xs-4 p-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "image hawk ml-15" },
	                  _react2.default.createElement("img", { src: _hawk2.default, alt: "Hawk" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: this.isMobile ? "col-xs-12" : "col-xs-8" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "panel-dashboard-white bg-light-gray pb-15" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "table-responsive" },
	                    _react2.default.createElement(
	                      "table",
	                      { className: "table" },
	                      _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement("span", null)
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              { className: "color-blue" },
	                              "U.S."
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "Europe"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "Asia"
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tbody",
	                        null,
	                        _react2.default.createElement(
	                          "tr",
	                          { className: "text-center" },
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            "Interest Rates"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tr",
	                          { className: "text-center" },
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            "Exchange Rates"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tr",
	                          { className: "text-center" },
	                          _react2.default.createElement(
	                            "th",
	                            null,
	                            "Inflation Rates"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "n/a"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          this.isMobile === false && _react2.default.createElement(
	            "div",
	            { className: "column-2" },
	            _react2.default.createElement(
	              "p",
	              { className: "mb-15" },
	              "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EconomicAnalysis;
	}(_react.PureComponent);
	
	exports.default = EconomicAnalysis;

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n\n  &:hover > span.kpi-info-tooltip,\n  &:focus-within > span.kpi-info-tooltip {\n    visibility: visible;\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n\n  &:hover > span.kpi-info-tooltip,\n  &:focus-within > span.kpi-info-tooltip {\n    visibility: visible;\n    opacity: 1;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 260px;\n  max-width: 340px;\n  padding: 12px 14px;\n  background: #EDF4FF;\n  border: 1px solid #C7D8F0;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n  font-family: 'Mukta Vaani', 'Lato', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.85);\n  text-align: left;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n  z-index: 100;\n  pointer-events: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #EDF4FF;\n    border-left: 1px solid #C7D8F0;\n    border-top: 1px solid #C7D8F0;\n  }\n"], ["\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 260px;\n  max-width: 340px;\n  padding: 12px 14px;\n  background: #EDF4FF;\n  border: 1px solid #C7D8F0;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n  font-family: 'Mukta Vaani', 'Lato', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.85);\n  text-align: left;\n  white-space: normal;\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 120ms ease-out;\n  z-index: 100;\n  pointer-events: none;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #EDF4FF;\n    border-left: 1px solid #C7D8F0;\n    border-top: 1px solid #C7D8F0;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid #C7D8F0;\n  font-family: 'Mukta Vaani', 'Lato', sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid #C7D8F0;\n  font-family: 'Mukta Vaani', 'Lato', sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  min-width: 140px;\n  height: 1.5px;\n  background: rgba(0, 27, 59, 0.6);\n"], ["\n  display: block;\n  width: 100%;\n  min-width: 140px;\n  height: 1.5px;\n  background: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"], ["\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.75);\n"], ["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.75);\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _uiTitle = __webpack_require__(1195);
	
	var _uiTitle2 = _interopRequireDefault(_uiTitle);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _roundNotStarted = __webpack_require__(259);
	
	var _roundNotStarted2 = _interopRequireDefault(_roundNotStarted);
	
	var _firstDecisionModal = __webpack_require__(253);
	
	var _firstDecisionModal2 = _interopRequireDefault(_firstDecisionModal);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(18);
	
	var _chart = __webpack_require__(1184);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _cashBalanceModal = __webpack_require__(1183);
	
	var _cashBalanceModal2 = _interopRequireDefault(_cashBalanceModal);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _raiseCapitalButton = __webpack_require__(1187);
	
	var _raiseCapitalButton2 = _interopRequireDefault(_raiseCapitalButton);
	
	var _raiseCapitalSelectModal = __webpack_require__(1188);
	
	var _raiseCapitalSelectModal2 = _interopRequireDefault(_raiseCapitalSelectModal);
	
	var _raiseEquityModal = __webpack_require__(1190);
	
	var _raiseEquityModal2 = _interopRequireDefault(_raiseEquityModal);
	
	var _raiseDebtModal = __webpack_require__(1189);
	
	var _raiseDebtModal2 = _interopRequireDefault(_raiseDebtModal);
	
	var _returnCapitalButton = __webpack_require__(1191);
	
	var _returnCapitalButton2 = _interopRequireDefault(_returnCapitalButton);
	
	var _returnCapitalSelectModal = __webpack_require__(1192);
	
	var _returnCapitalSelectModal2 = _interopRequireDefault(_returnCapitalSelectModal);
	
	var _returnDebtModal = __webpack_require__(1193);
	
	var _returnDebtModal2 = _interopRequireDefault(_returnDebtModal);
	
	var _returnEquityModal = __webpack_require__(1194);
	
	var _returnEquityModal2 = _interopRequireDefault(_returnEquityModal);
	
	var _debtDecisionsPage = __webpack_require__(1185);
	
	var _debtDecisionsPage2 = _interopRequireDefault(_debtDecisionsPage);
	
	var _equityDecisionsPage = __webpack_require__(1186);
	
	var _equityDecisionsPage2 = _interopRequireDefault(_equityDecisionsPage);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _style = __webpack_require__(78);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _arrow = __webpack_require__(1836);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _lastStep = __webpack_require__(254);
	
	var _lastStep2 = _interopRequireDefault(_lastStep);
	
	var _format = __webpack_require__(63);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _financeCapitalStructure = __webpack_require__(1055);
	
	var _financeCapitalStructure2 = _interopRequireDefault(_financeCapitalStructure);
	
	var _financeLendingRate = __webpack_require__(2579);
	
	var _financeLendingRate2 = _interopRequireDefault(_financeLendingRate);
	
	var _financeDebtToCapital = __webpack_require__(1056);
	
	var _financeDebtToCapital2 = _interopRequireDefault(_financeDebtToCapital);
	
	var _financeInterestCharged = __webpack_require__(2578);
	
	var _financeInterestCharged2 = _interopRequireDefault(_financeInterestCharged);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Hover tooltip that pairs with a KPI-label help icon. Wrap the icon
	// in KpiInfoTooltipWrap and drop a KpiInfoTooltip alongside it; the
	// tooltip fades in whenever the wrapper (or its focused descendant)
	// is hovered/focused. Any existing onClick on the icon still fires.
	var KpiInfoTooltipWrap = _styledComponents2.default.span(_templateObject);
	
	var KpiInfoTooltip = _styledComponents2.default.span(_templateObject2);
	
	// Ownership formula shown inside the Team's Ownership tooltip:
	// (Team's shares / Total outstanding shares) = X.XX%. Rendered as a
	// centered visual fraction with a horizontal bar so students see the
	// math rather than just the outcome.
	var OwnershipFormula = _styledComponents2.default.span(_templateObject3);
	
	var OwnershipFraction = _styledComponents2.default.span(_templateObject4);
	
	var OwnershipNumerator = _styledComponents2.default.span(_templateObject5);
	
	var OwnershipDenominator = _styledComponents2.default.span(_templateObject5);
	
	var OwnershipBar = _styledComponents2.default.span(_templateObject6);
	
	var OwnershipTermLabel = _styledComponents2.default.span(_templateObject7);
	
	var OwnershipEquals = _styledComponents2.default.span(_templateObject8);
	
	var OwnershipResult = _styledComponents2.default.span(_templateObject9);
	
	// Renders a dollar value in a layout where the "$" is left-anchored to
	// a fixed slot and the digits are right-aligned within a tabular-nums
	// container, so the "$" stays vertically aligned across rows even when
	// numbers differ in magnitude. Use this inside SummaryCell.
	var renderMoneyAligned = function renderMoneyAligned(n) {
	  return _react2.default.createElement(
	    _style2.default.MoneyAligned,
	    null,
	    _react2.default.createElement(
	      _style2.default.MoneyPrefix,
	      null,
	      "$"
	    ),
	    _react2.default.createElement(
	      _style2.default.MoneyAmount,
	      null,
	      Math.round(Number(n) || 0).toLocaleString('en-US')
	    )
	  );
	};
	
	var videos = {
	  'Capital Structure': _financeCapitalStructure2.default,
	  'Lending Rate': _financeLendingRate2.default,
	  'Debt to Capital': _financeDebtToCapital2.default,
	  'Interest Charged': _financeInterestCharged2.default
	};
	
	var FinanceDecisions = function (_Component) {
	  _inherits(FinanceDecisions, _Component);
	
	  function FinanceDecisions(props) {
	    _classCallCheck(this, FinanceDecisions);
	
	    var _this = _possibleConstructorReturn(this, (FinanceDecisions.__proto__ || Object.getPrototypeOf(FinanceDecisions)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._isMounted = false;
	
	    var role = _Auth2.default.getRole();
	    var hasAccess = role === "CEO" || role === "FI";
	    var isOwnRole = role === "FI";
	
	    _this.state = {
	      isOwnRole: isOwnRole,
	      hasAccess: hasAccess,
	      submitDecisionsLoading: true,
	      submission_data: {
	        fn: {
	          date: "N/A",
	          unaccepted: 0
	        }
	      },
	      projections_submitted: false,
	      debt_to_capital: 0,
	      cost_to_capital: 0,
	      lending_rate: 0,
	      loans: [],
	      teamDebts: [],
	      interest_payments: [],
	      equity_cumulative: 0,
	      equity: 0,
	      equities: [],
	      equity_clients: [],
	      repurchased_shares: [],
	      total_shares: 0,
	      initialShares: 0,
	      currentSharePrice: 0,
	      companyOwnershipPct: 0,
	      outstandingShares: 0,
	      ending_cash: 0,
	      prev_cash_balance: 0,
	      financial_decisions: null,
	      loading: true,
	      roundInUrl: props.roundInUrl,
	      currentRound: props.currentRound,
	      rounds: props.rounds,
	      unaccepted_decisions: {
	        FI: 0,
	        PM: 0,
	        PD: 0,
	        OP: 0
	      },
	      showNoProjectionsModal: false,
	      isPreChecked: false,
	      showManageFinancesModal: false,
	      manageStep: 'main',
	      showDebtDecisionsPage: false,
	      showEquityDecisionsPage: false,
	      // First-time coaching popup after the team's first equity
	      // issuance in Round 1. See handleFirstEquityIssued below.
	      firstDecisionModalOpen: false,
	      interest_charge: 0,
	      product_n_marketing: 0,
	      operations: 0,
	      net_cash_balance_from_finance: 0,
	      showWarningModal: false,
	      showAccruedInterestInfo: false,
	      warningTitle: '',
	      warningMessage: '',
	      warningButtonText: '',
	      isVideoModalShown: false,
	      isVideoPlaying: false,
	      selectedVideo: null
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    _this.isMobile = (0, _utils.detectMobile)();
	
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(FinanceDecisions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds.length === 0 && nextProps.rounds.length > 0) {
	        this.setState({
	          currentRound: nextProps.currentRound,
	          roundInUrl: nextProps.roundInUrl,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	          _this2.reloadRole();
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      // Lock the page only when no round has ever been started.
	      // Does not fire for finished games (see ceo-decisions.js for the
	      // full explanation).
	      var hasEverStarted = (this.props.rounds || []).some(function (r) {
	        return r && r.is_started === true;
	      });
	      if (this.props.rounds_loaded && !hasEverStarted) {
	        return _react2.default.createElement(_roundNotStarted2.default, null);
	      }
	
	      var _state = this.state,
	          isOwnRole = _state.isOwnRole,
	          submitDecisionsLoading = _state.submitDecisionsLoading,
	          submission_data = _state.submission_data,
	          loading = _state.loading,
	          loans = _state.loans,
	          equity_cumulative = _state.equity_cumulative,
	          currentSharePrice = _state.currentSharePrice,
	          companyOwnershipPct = _state.companyOwnershipPct,
	          initialShares = _state.initialShares,
	          outstandingShares = _state.outstandingShares,
	          ending_cash = _state.ending_cash,
	          prev_cash_balance = _state.prev_cash_balance,
	          currentRound = _state.currentRound,
	          rounds = _state.rounds,
	          roundInUrl = _state.roundInUrl,
	          financial_decisions = _state.financial_decisions,
	          unaccepted_decisions = _state.unaccepted_decisions,
	          showNoProjectionsModal = _state.showNoProjectionsModal,
	          isPreChecked = _state.isPreChecked,
	          product_n_marketing = _state.product_n_marketing,
	          operations = _state.operations,
	          net_cash_balance_from_finance = _state.net_cash_balance_from_finance,
	          showWarningModal = _state.showWarningModal,
	          showAccruedInterestInfo = _state.showAccruedInterestInfo,
	          warningTitle = _state.warningTitle,
	          warningMessage = _state.warningMessage,
	          warningButtonText = _state.warningButtonText,
	          isVideoModalShown = _state.isVideoModalShown,
	          isVideoPlaying = _state.isVideoPlaying;
	      var _props = this.props,
	          location = _props.location,
	          router = _props.router,
	          roundFromProps = _props.currentRound;
	
	
	      var hasAccess = this.showActionButtons;
	      var roundNumber = this.roundNumber;
	      var cashBalance = this.cashBalance;
	      var round = (0, _lodash.isNil)(roundInUrl) ? currentRound : roundInUrl;
	      var roundId = rounds.find(function (i) {
	        return i.number === Number(round);
	      }).id;
	
	      return _react2.default.createElement(
	        _style2.default.BodyWrapper,
	        null,
	        _react2.default.createElement(_lastStep2.default, {
	          location: location,
	          router: router,
	          url: "/decisions/finance?round=" + roundFromProps
	        }),
	        _react2.default.createElement(_uiTitle2.default, {
	          isOwnRole: isOwnRole,
	          hasAccess: hasAccess,
	          submitDecisionsLoading: submitDecisionsLoading,
	          submitDecisionsData: submission_data.fn,
	          submitDecisions: this.submitDecisions,
	          loading: loading,
	          financial_decisions: financial_decisions,
	          unaccepted_decisions: unaccepted_decisions,
	          isPreChecked: isPreChecked,
	          isRoundEnded: function () {
	            // Closed-round only: is_started AND is_finished both true
	            // on the viewed round. Inline because finance-decisions
	            // doesn't expose a shared getter for this yet.
	            var viewedNumber = roundInUrl !== null ? roundInUrl : currentRound;
	            var r = rounds.find(function (i) {
	              return i.number === viewedNumber;
	            });
	            return !!r && r.is_started === true && r.is_finished === true;
	          }()
	        }),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: showNoProjectionsModal,
	          title: "Unsuccessful",
	          text: "You cannot raise capital without making financial projections. It\u2019s the CEO role in this exercise.",
	          type: "warning",
	          onConfirm: this.onNoProjectionsModalConfirm,
	          confirmButtonText: "Make Projections"
	        }),
	        _react2.default.createElement(
	          _style2.default.Subtitle,
	          null,
	          "Raise and manage capital to finance product, marketing, and operations decisions."
	        ),
	        loading === true && _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true }),
	        loading === false && _react2.default.createElement(
	          "div",
	          null,
	          hasAccess === true && _react2.default.createElement(
	            _style2.default.ManageButtonBar,
	            null,
	            _react2.default.createElement(
	              _style2.default.ManageButton,
	              { onClick: this.showManageFinancesModal },
	              "Manage Your Finances"
	            )
	          ),
	          _react2.default.createElement(_raiseDebtModal2.default, {
	            equity: equity_cumulative,
	            roundNumber: roundNumber,
	            reloadData: this.fetchData,
	            showInterestChargeWarning: this.showInterestChargeWarning
	          }),
	          _react2.default.createElement(_raiseEquityModal2.default, {
	            roundNumber: roundNumber,
	            currentRound: currentRound,
	            rounds: rounds,
	            reloadData: this.fetchData
	          }),
	          _react2.default.createElement(_returnDebtModal2.default, {
	            roundNumber: roundNumber,
	            cashBalance: cashBalance,
	            reloadData: this.fetchData,
	            roundId: roundId
	          }),
	          _react2.default.createElement(_returnEquityModal2.default, {
	            roundNumber: roundNumber,
	            cashBalance: cashBalance,
	            reloadData: this.fetchData
	          }),
	          _react2.default.createElement(_cashBalanceModal2.default, {
	            beginningCash: prev_cash_balance,
	            ProductNMarketing: product_n_marketing,
	            operations: operations,
	            financing: net_cash_balance_from_finance,
	            cashBalance: ending_cash
	          }),
	          function () {
	            // Hide the Debt/Equity/Capital Structure blocks entirely
	            // when there's no outstanding capital to summarize. Sums
	            // are taken from the team-decisions API arrays:
	            //   debts[].balance    → outstanding debt
	            //   equities[].capital → outstanding equity
	            var debtsArr = Array.isArray(_this3.state.teamDebts) ? _this3.state.teamDebts : [];
	            var equitiesArr = Array.isArray(_this3.state.equities) ? _this3.state.equities : [];
	            var outstandingDebtSum = debtsArr.reduce(function (s, d) {
	              return s + (Number(d.balance) || 0);
	            }, 0);
	            var outstandingEquitySum = equitiesArr.reduce(function (s, e) {
	              return s + (Number(e.capital) || 0);
	            }, 0);
	            var hasDebt = outstandingDebtSum > 0;
	            var hasEquity = outstandingEquitySum > 0;
	            return _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _style2.default.KpiRow,
	                { cardCount: hasDebt ? 5 : 3 },
	                _react2.default.createElement(
	                  _style2.default.KpiCard,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.KpiLabel,
	                    null,
	                    "Cash on Hand",
	                    _react2.default.createElement(
	                      KpiInfoTooltipWrap,
	                      { tabIndex: 0, "aria-label": "What is Cash on Hand?" },
	                      _react2.default.createElement(_style2.default.HelpIcon, {
	                        src: _iconTableHelp2.default,
	                        onClick: _this3.showCashBalanceModal,
	                        title: "View cash balance breakdown"
	                      }),
	                      _react2.default.createElement(
	                        KpiInfoTooltip,
	                        { className: "kpi-info-tooltip", role: "tooltip" },
	                        "How much cash your team currently has this round. Click for a detailed breakdown."
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.KpiValue,
	                    null,
	                    _react2.default.createElement(_reactNumberFormat2.default, {
	                      value: cashBalance,
	                      displayType: "text",
	                      prefix: "$",
	                      thousandSeparator: ","
	                    })
	                  ),
	                  Number(cashBalance) < 0 && _react2.default.createElement(
	                    _style2.default.HealthBadge,
	                    { status: "High" },
	                    "Insufficient Capital"
	                  )
	                ),
	                hasDebt && _react2.default.createElement(
	                  _style2.default.KpiCard,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.KpiLabel,
	                    null,
	                    "Outstanding Debt"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.KpiValue,
	                    null,
	                    (0, _format.moneyFormat)(_this3.totalOutstandingDebt)
	                  )
	                ),
	                hasDebt && function () {
	                  var totalDebt = Number(_this3.totalOutstandingDebt) || 0;
	                  var totalEquity = Number(_this3.totalCapitalRaised) || 0;
	                  var totalCapital = totalDebt + totalEquity;
	                  var dtcResult = _this3.debtToCapital ? _this3.debtToCapital + "%" : '0%';
	                  var moneyShort = function moneyShort(v) {
	                    return "$" + Math.round(v).toLocaleString('en-US');
	                  };
	                  return _react2.default.createElement(
	                    _style2.default.KpiCard,
	                    null,
	                    _react2.default.createElement(
	                      _style2.default.KpiLabel,
	                      null,
	                      "Debt-to-Capital",
	                      _react2.default.createElement(
	                        KpiInfoTooltipWrap,
	                        { tabIndex: 0, "aria-label": "What is Debt-to-Capital?" },
	                        _react2.default.createElement(_style2.default.HelpIcon, { src: _iconTableHelp2.default }),
	                        _react2.default.createElement(
	                          KpiInfoTooltip,
	                          { className: "kpi-info-tooltip", role: "tooltip" },
	                          "The debt-to-capital ratio shows the share of a business's capital funded by debt. A higher ratio indicates greater financial risk and higher borrowing costs.",
	                          _react2.default.createElement(
	                            OwnershipFormula,
	                            { "aria-hidden": true },
	                            _react2.default.createElement(
	                              OwnershipFraction,
	                              null,
	                              _react2.default.createElement(
	                                OwnershipNumerator,
	                                null,
	                                moneyShort(totalDebt),
	                                _react2.default.createElement(
	                                  OwnershipTermLabel,
	                                  null,
	                                  "Total Debt"
	                                )
	                              ),
	                              _react2.default.createElement(OwnershipBar, null),
	                              _react2.default.createElement(
	                                OwnershipDenominator,
	                                null,
	                                moneyShort(totalCapital),
	                                _react2.default.createElement(
	                                  OwnershipTermLabel,
	                                  null,
	                                  "Total Debt + Total Equity"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              OwnershipEquals,
	                              null,
	                              "="
	                            ),
	                            _react2.default.createElement(
	                              OwnershipResult,
	                              null,
	                              dtcResult
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { style: {
	                                display: 'block',
	                                marginTop: 10,
	                                paddingTop: 8,
	                                borderTop: '1px solid #C7D8F0',
	                                fontSize: 14,
	                                fontStyle: 'italic',
	                                color: 'rgba(0, 27, 59, 0.6)',
	                                lineHeight: '18px'
	                              } },
	                            "Note: Total Equity comes from the balance sheet, not the Equity Summary breakdown below."
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.KpiValue,
	                      null,
	                      dtcResult
	                    ),
	                    _this3.healthBadgeStatus && _react2.default.createElement(
	                      _style2.default.HealthBadge,
	                      { status: _this3.healthBadgeStatus },
	                      _this3.healthBadgeStatus
	                    )
	                  );
	                }(),
	                _react2.default.createElement(
	                  _style2.default.KpiCard,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.KpiLabel,
	                    null,
	                    "Team's Ownership %",
	                    _react2.default.createElement(
	                      KpiInfoTooltipWrap,
	                      { tabIndex: 0, "aria-label": "What is Team's Ownership %?" },
	                      _react2.default.createElement(_style2.default.HelpIcon, { src: _iconTableHelp2.default }),
	                      _react2.default.createElement(
	                        KpiInfoTooltip,
	                        { className: "kpi-info-tooltip", role: "tooltip" },
	                        "The share of the company your team still holds. It's your original founding shares divided by every share outstanding this round (founding shares + any new shares issued to investors).",
	                        _react2.default.createElement(
	                          OwnershipFormula,
	                          { "aria-hidden": true },
	                          _react2.default.createElement(
	                            OwnershipFraction,
	                            null,
	                            _react2.default.createElement(
	                              OwnershipNumerator,
	                              null,
	                              Number(initialShares || 0).toLocaleString("en-US"),
	                              _react2.default.createElement(
	                                OwnershipTermLabel,
	                                null,
	                                "Your team's shares"
	                              )
	                            ),
	                            _react2.default.createElement(OwnershipBar, null),
	                            _react2.default.createElement(
	                              OwnershipDenominator,
	                              null,
	                              Number(outstandingShares || 0).toLocaleString("en-US"),
	                              _react2.default.createElement(
	                                OwnershipTermLabel,
	                                null,
	                                "Total outstanding shares"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            OwnershipEquals,
	                            null,
	                            "="
	                          ),
	                          _react2.default.createElement(
	                            OwnershipResult,
	                            null,
	                            Number(companyOwnershipPct || 0).toFixed(2) + "%"
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.KpiValue,
	                    null,
	                    Number(companyOwnershipPct || 0).toFixed(2) + "%"
	                  )
	                ),
	                _react2.default.createElement(
	                  _style2.default.KpiCard,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.KpiLabel,
	                    null,
	                    "Current Share Price",
	                    _react2.default.createElement(
	                      KpiInfoTooltipWrap,
	                      { tabIndex: 0, "aria-label": "What is Current Share Price?" },
	                      _react2.default.createElement(_style2.default.HelpIcon, { src: _iconTableHelp2.default }),
	                      _react2.default.createElement(
	                        KpiInfoTooltip,
	                        { className: "kpi-info-tooltip", role: "tooltip" },
	                        "Your stock price for this round. It updates each round based on your team's performance. It's calculated by taking your company's market value and dividing it by your company's outstanding shares. In Years 1 and 2, market value is driven by revenues; in Year 3, it's driven by profits."
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.KpiValue,
	                    null,
	                    "$",
	                    Number(currentSharePrice || 0).toFixed(2)
	                  )
	                )
	              ),
	              (hasDebt || hasEquity) && _react2.default.createElement(
	                _style2.default.TwoColumnSection,
	                null,
	                hasDebt && _react2.default.createElement(
	                  _style2.default.SectionCard,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.SectionHeader,
	                    null,
	                    _react2.default.createElement(
	                      _style2.default.SectionTitle,
	                      null,
	                      "Debt Summary Breakdown"
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.SectionSubtitleRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.SectionSubtitleRow_Inner,
	                        null,
	                        "Outstanding debt"
	                      ),
	                      _react2.default.createElement(
	                        _style2.default.SectionSubtitleValue,
	                        null,
	                        (0, _format.moneyFormat)(_this3.totalOutstandingDebt)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.SummaryTable,
	                    null,
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.SummaryHeadRow,
	                        null,
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          null,
	                          "Lenders"
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          { align: "right" },
	                          "Principal"
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          { align: "right" },
	                          "Accrued Interest",
	                          _react2.default.createElement(_style2.default.HelpIconInline, {
	                            src: _iconTableHelp2.default,
	                            onClick: function onClick() {
	                              return _this3.setState({ showAccruedInterestInfo: true });
	                            },
	                            title: "What is accrued interest?"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          { align: "right" },
	                          "Rate"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      function () {
	                        var debts = (_this3.state.teamDebts || []).filter(function (d) {
	                          return Number(d.balance) > 0;
	                        });
	                        if (debts.length === 0) {
	                          return _react2.default.createElement(
	                            _style2.default.SummaryRow,
	                            null,
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { colSpan: "4", style: { color: 'rgba(0,27,59,0.5)' } },
	                              "No outstanding debt"
	                            )
	                          );
	                        }
	                        var isActive = _this3.isActiveRound;
	                        var interestField = isActive ? 'prior_year_interest_payable' : 'interest_payable';
	                        var interestPayments = Array.isArray(_this3.state.interest_payments) ? _this3.state.interest_payments : [];
	                        return debts.map(function (d, i) {
	                          var principal = Number(d.balance) || 0;
	                          // Floor per row (same rationale as totalAccruedInterest).
	                          var grossAccrued = Math.floor(Number(d[interestField]) || 0);
	                          // Offset by any interest payment already posted
	                          // against THIS debt row, during the active round
	                          // only. Match on debt id (unique per row) rather
	                          // than client — a client can carry multiple
	                          // debts over time, and matching on client picks
	                          // the first interest payment chronologically,
	                          // which can be a stale payment against an old
	                          // debt no longer in teamDebts. Same gate as
	                          // totalOutstandingDebt.
	                          var ip = isActive ? interestPayments.find(function (p) {
	                            return Number(p.debt) === Number(d.id);
	                          }) : null;
	                          var paidThisRound = ip ? Number(ip.amount) || 0 : 0;
	                          var accruedInterest = Math.max(0, grossAccrued - paidThisRound);
	                          var rate = d.rate != null ? (Number(d.rate) * 100).toFixed(2) : null;
	                          // Resolve the lender name by matching
	                          // debts[i].client → loans[].client_id. The previous
	                          // code used positional index into loans, which is
	                          // ordered by client_id (Prudent, Mezz, Great White)
	                          // regardless of which lender the team actually
	                          // borrowed from. That mismatch rendered "Prudent
	                          // Bank" on a Great White Financials loan.
	                          var loanMatch = Array.isArray(loans) ? loans.find(function (l) {
	                            return Number(l.client_id) === Number(d.client);
	                          }) : null;
	                          var name = d.client_name || loanMatch && loanMatch.client_name || "Loan " + (i + 1);
	                          return _react2.default.createElement(
	                            _style2.default.SummaryRow,
	                            { key: i },
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              null,
	                              name
	                            ),
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { align: "right" },
	                              renderMoneyAligned(principal)
	                            ),
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { align: "right" },
	                              accruedInterest > 0 ? renderMoneyAligned(accruedInterest) : '-'
	                            ),
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { align: "right", accent: true },
	                              rate !== null ? rate + "%" : '-'
	                            )
	                          );
	                        });
	                      }()
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.SummaryFooter,
	                    null,
	                    _react2.default.createElement(
	                      _style2.default.SummaryFooterLabel,
	                      null,
	                      "Weighted Average Interest Rate",
	                      _react2.default.createElement(_style2.default.HelpIcon, { src: _iconTableHelp2.default, onClick: function onClick() {
	                          return _this3.onHelpIconClick("Lending Rate");
	                        } })
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.SummaryFooterValue,
	                      null,
	                      _this3.weightedAverageRate > 0 ? _this3.weightedAverageRate.toFixed(2) + "%" : '0%'
	                    )
	                  )
	                ),
	                hasEquity && _react2.default.createElement(
	                  _style2.default.SectionCard,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.SectionHeader,
	                    null,
	                    _react2.default.createElement(
	                      _style2.default.SectionTitle,
	                      null,
	                      "Equity Summary Breakdown"
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.SectionSubtitleRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.SectionSubtitleRow_Inner,
	                        null,
	                        "Outstanding Equity"
	                      ),
	                      _react2.default.createElement(
	                        _style2.default.SectionSubtitleValue,
	                        null,
	                        (0, _format.moneyFormat)(_this3.totalCapitalRaised)
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.SummaryTable,
	                    null,
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.SummaryHeadRow,
	                        null,
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          null,
	                          "Equity Investor"
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          { align: "right" },
	                          "Capital"
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          { align: "right" },
	                          "Shares"
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.SummaryHeadCell,
	                          { align: "right" },
	                          "Price"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      function () {
	                        // The per-investor equity records live in the top-level
	                        // `equities` array from the team-decisions response —
	                        // NOT inside financial_decisions.team.equity.
	                        var equityRecords = _this3.state.equities;
	                        var equityClients = _this3.state.equity_clients || [];
	
	                        // Build a clientId -> name lookup. equity_clients comes
	                        // from /static/equity_clients/; each row maps an equity
	                        // record's `client` FK to a readable investor name.
	                        var clientNameById = {};
	                        equityClients.forEach(function (c) {
	                          clientNameById[c.id] = c.name;
	                        });
	
	                        // Issue rows: group equities by client. Each round may
	                        // produce its own row for the same investor, so sum.
	                        // Buybacks are NOT netted into these totals anymore —
	                        // they render as their own red rows below.
	                        var rawEntries = Array.isArray(equityRecords) ? equityRecords : [];
	                        var issuesByClient = {};
	                        rawEntries.forEach(function (e) {
	                          var clientId = e.client;
	                          if (!issuesByClient[clientId]) {
	                            issuesByClient[clientId] = { client: clientId, capital: 0, issuance: 0 };
	                          }
	                          issuesByClient[clientId].capital += Number(e.capital) || 0;
	                          issuesByClient[clientId].issuance += Number(e.issuance) || 0;
	                        });
	
	                        // Buyback rows: group repurchased_shares by client.
	                        // `cost` is cash spent to buy shares back, `shares` is
	                        // the share count reclaimed. Each row renders in red
	                        // under its issue row so instructors see the gross
	                        // in/out flow instead of a netted single row.
	                        var repurchases = Array.isArray(_this3.state.repurchased_shares) ? _this3.state.repurchased_shares : [];
	                        var buybacksByClient = {};
	                        repurchases.forEach(function (r) {
	                          var clientId = r.client;
	                          if (clientId == null) return;
	                          if (!buybacksByClient[clientId]) {
	                            buybacksByClient[clientId] = { client: clientId, cost: 0, shares: 0 };
	                          }
	                          buybacksByClient[clientId].cost += Number(r.cost) || 0;
	                          buybacksByClient[clientId].shares += Number(r.shares) || 0;
	                        });
	
	                        // Direction cue: Capital cell only. Issue rows
	                        // paint it green (cash in), buyback rows paint it
	                        // red (cash out). Shares and Price both stay the
	                        // default navy so the colored cell pops; the
	                        // "(issued)" / "(bought back)" suffix next to the
	                        // investor name labels the direction for the
	                        // uncolored columns.
	                        var greenCellStyle = { color: '#2DA548' };
	                        var redCellStyle = { color: '#FF5252' };
	
	                        // Always-present founder row at the top of the
	                        // table. Reflects the team's founder shares
	                        // (constants.initial_shares) held at $0 cost basis.
	                        var teamShares = Number(_this3.state.initialShares) || 0;
	                        var teamRow = _react2.default.createElement(
	                          _style2.default.SummaryRow,
	                          { key: "team-founder-row" },
	                          _react2.default.createElement(
	                            _style2.default.SummaryCell,
	                            null,
	                            "Founders"
	                          ),
	                          _react2.default.createElement(
	                            _style2.default.SummaryCell,
	                            { align: "right" },
	                            renderMoneyAligned(0)
	                          ),
	                          _react2.default.createElement(
	                            _style2.default.SummaryCell,
	                            { align: "right" },
	                            teamShares.toLocaleString()
	                          ),
	                          _react2.default.createElement(
	                            _style2.default.SummaryCell,
	                            { align: "right", accent: true },
	                            "$0.00"
	                          )
	                        );
	
	                        // Union of client ids with activity (either an issue
	                        // or a buyback). A buyback-only client (no matching
	                        // issue row) still shows up as a red row.
	                        var clientIds = Array.from(new Set([].concat(_toConsumableArray(Object.keys(issuesByClient).map(function (id) {
	                          return Number(id);
	                        })), _toConsumableArray(Object.keys(buybacksByClient).map(function (id) {
	                          return Number(id);
	                        })))));
	
	                        var investorRows = [];
	                        clientIds.forEach(function (clientId) {
	                          var issue = issuesByClient[clientId];
	                          var buyback = buybacksByClient[clientId];
	                          var name = clientNameById[clientId] || 'Equity Investor';
	
	                          if (issue && (Number(issue.capital) > 0 || Number(issue.issuance) > 0)) {
	                            var cap = Number(issue.capital) || 0;
	                            var shares = Number(issue.issuance) || 0;
	                            var pps = shares > 0 ? cap / shares : null;
	                            investorRows.push(_react2.default.createElement(
	                              _style2.default.SummaryRow,
	                              { key: "issue-" + clientId },
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                null,
	                                name,
	                                " (issued)"
	                              ),
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                { align: "right", style: greenCellStyle },
	                                renderMoneyAligned(cap)
	                              ),
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                { align: "right" },
	                                shares.toLocaleString()
	                              ),
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                { align: "right", accent: true },
	                                pps !== null ? "$" + pps.toFixed(2) : '-'
	                              )
	                            ));
	                          }
	                          if (buyback && (Number(buyback.cost) > 0 || Number(buyback.shares) > 0)) {
	                            var cost = Number(buyback.cost) || 0;
	                            var _shares = Number(buyback.shares) || 0;
	                            var _pps = _shares > 0 ? cost / _shares : null;
	                            investorRows.push(_react2.default.createElement(
	                              _style2.default.SummaryRow,
	                              { key: "buyback-" + clientId },
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                null,
	                                name,
	                                " (bought back)"
	                              ),
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                { align: "right", style: redCellStyle },
	                                renderMoneyAligned(cost)
	                              ),
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                { align: "right" },
	                                _shares.toLocaleString()
	                              ),
	                              _react2.default.createElement(
	                                _style2.default.SummaryCell,
	                                { align: "right", accent: true },
	                                _pps !== null ? "$" + _pps.toFixed(2) : '-'
	                              )
	                            ));
	                          }
	                        });
	
	                        if (investorRows.length > 0) {
	                          return [teamRow].concat(investorRows);
	                        }
	                        if (Number(equity_cumulative) > 0) {
	                          var shares = Number(_this3.state.total_shares || 0);
	                          var pps = shares > 0 ? equity_cumulative / shares : null;
	                          return [teamRow, _react2.default.createElement(
	                            _style2.default.SummaryRow,
	                            { key: "common-equity" },
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              null,
	                              "Common Equity"
	                            ),
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { align: "right" },
	                              renderMoneyAligned(equity_cumulative)
	                            ),
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { align: "right" },
	                              shares.toLocaleString()
	                            ),
	                            _react2.default.createElement(
	                              _style2.default.SummaryCell,
	                              { align: "right", accent: true },
	                              pps !== null ? "$" + pps.toFixed(2) : '-'
	                            )
	                          )];
	                        }
	                        // No investor equity yet — still show the founder row alone.
	                        return teamRow;
	                      }()
	                    )
	                  )
	                )
	              )
	            );
	          }()
	        ),
	        this.state.showDebtDecisionsPage && function () {
	          // Match the equity page's "active round" definition
	          // (is_started && !is_finished). Drives which interest field
	          // Outstanding Balance uses on the Lender cards.
	          var viewedRound = _this3.state.rounds.find(function (i) {
	            return i.number === Number(_this3.roundNumber);
	          });
	          return _react2.default.createElement(_debtDecisionsPage2.default, {
	            roundNumber: _this3.roundNumber,
	            roundId: viewedRound ? viewedRound.id : null,
	            isActiveRound: !!viewedRound && viewedRound.is_started === true && viewedRound.is_finished === false,
	            onClose: _this3.closeDebtDecisionsPage,
	            onSelectLender: _this3.handleSelectLender,
	            onGoToCeoProjections: function onGoToCeoProjections() {
	              _this3.props.router.push("/decisions/ceo?round_number=" + _this3.roundNumber);
	            },
	            onDecisionMade: _this3.fetchData
	          });
	        }(),
	        this.state.showEquityDecisionsPage && function () {
	          // A round is "active" only when it's started AND not yet
	          // finished (general-info api flags). This correctly returns
	          // false after the final round ends, even though game.round
	          // still points at it.
	          var viewedRound = _this3.state.rounds.find(function (i) {
	            return i.number === Number(_this3.roundNumber);
	          });
	          return _react2.default.createElement(_equityDecisionsPage2.default, {
	            roundNumber: _this3.roundNumber,
	            roundId: viewedRound ? viewedRound.id : null,
	            isActiveRound: !!viewedRound && viewedRound.is_started === true && viewedRound.is_finished === false,
	            onClose: _this3.closeEquityDecisionsPage,
	            onGoToCeoProjections: function onGoToCeoProjections() {
	              _this3.props.router.push("/decisions/ceo?round_number=" + _this3.roundNumber);
	            },
	            onDecisionMade: _this3.fetchData,
	            onFirstEquityIssued: _this3.handleFirstEquityIssued
	          });
	        }(),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.firstDecisionModalOpen,
	          title: "Nice work on your first capital raise!",
	          body: "You can update this any time before the round deadline. Make sure to raise enough capital to cover product, marketing, and operations spend. If equity alone isn't enough, also raise debt (borrow from lenders) to cover the gap. Otherwise your team won't be able to post decisions and will get a 0% score for the round.",
	          ctaLabel: "View Cash Balance",
	          onCta: this.handleFirstDecisionCta,
	          onClose: this.handleFirstDecisionClose
	        }),
	        this.state.showManageFinancesModal && _react2.default.createElement(
	          _style2.default.ManageOverlay,
	          { onClick: this.hideManageFinancesModal },
	          _react2.default.createElement(
	            _style2.default.ManageModal,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              _style2.default.ManageModalTitle,
	              null,
	              "Manage Your Finances"
	            ),
	            _react2.default.createElement(
	              _style2.default.ManageModalSubtitle,
	              null,
	              "Select a decision to explore"
	            ),
	            this.state.manageStep === 'main' && function () {
	              var hasEquity = Number(_this3.totalCapitalRaised) > 0 || Number(_this3.state.equity_cumulative) > 0;
	              return _react2.default.createElement(
	                _style2.default.ManageGrid,
	                null,
	                _react2.default.createElement(
	                  _style2.default.ManageOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style2.default.ManageOption,
	                    {
	                      onClick: function onClick() {
	                        return hasEquity && _this3.pickManageBranch('debt');
	                      },
	                      disabled: !hasEquity
	                    },
	                    "Debt Decisions"
	                  ),
	                  !hasEquity && _react2.default.createElement(
	                    _style2.default.ManageOptionTooltip,
	                    null,
	                    "You have to raise equity before you can take on debt."
	                  )
	                ),
	                _react2.default.createElement(
	                  _style2.default.ManageOption,
	                  { onClick: function onClick() {
	                      return _this3.pickManageBranch('equity');
	                    } },
	                  "Equity Decisions"
	                )
	              );
	            }(),
	            this.state.manageStep === 'debt' && _react2.default.createElement(
	              _style2.default.ManageGrid,
	              null,
	              _react2.default.createElement(
	                _style2.default.ManageOption,
	                { onClick: function onClick() {
	                    return _this3.pickManageOption('raise-debt');
	                  } },
	                "Raise Debt"
	              ),
	              _react2.default.createElement(
	                _style2.default.ManageOption,
	                { onClick: function onClick() {
	                    return _this3.pickManageOption('return-debt');
	                  } },
	                "Return Debt"
	              )
	            ),
	            this.state.manageStep === 'equity' && _react2.default.createElement(
	              _style2.default.ManageGrid,
	              null,
	              _react2.default.createElement(
	                _style2.default.ManageOption,
	                { onClick: function onClick() {
	                    return _this3.pickManageOption('raise-equity');
	                  } },
	                "Raise Equity"
	              ),
	              _react2.default.createElement(
	                _style2.default.ManageOption,
	                {
	                  onClick: function onClick() {
	                    return _this3.pickManageOption('return-equity');
	                  },
	                  disabled: round < 2,
	                  style: round < 2 ? { opacity: 0.5, cursor: 'not-allowed' } : undefined
	                },
	                "Return Equity"
	              )
	            ),
	            _react2.default.createElement(
	              _style2.default.ManageCloseRow,
	              null,
	              this.state.manageStep !== 'main' && _react2.default.createElement(
	                _style2.default.ManageCloseButton,
	                { onClick: this.backToManageMain, style: { marginRight: 'auto' } },
	                "\u2190 Back"
	              ),
	              _react2.default.createElement(
	                _style2.default.ManageCloseButton,
	                { onClick: this.hideManageFinancesModal },
	                "Cancel"
	              )
	            )
	          )
	        ),
	        showWarningModal && _react2.default.createElement(_warning2.default, {
	          title: warningTitle,
	          message: warningMessage,
	          onSuccess: this.hideWarningModal,
	          onCancel: this.hideWarningModal,
	          successButtonText: warningButtonText,
	          showCancel: false
	        }),
	        showAccruedInterestInfo && _react2.default.createElement(
	          _style2.default.LenderNoticeOverlay,
	          { onClick: function onClick() {
	              return _this3.setState({ showAccruedInterestInfo: false });
	            } },
	          _react2.default.createElement(
	            _style2.default.LenderNoticeModal,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              _style2.default.LenderNoticeTitle,
	              null,
	              "Accrued Interest"
	            ),
	            _react2.default.createElement(
	              _style2.default.LenderNoticeMessage,
	              null,
	              "Accrued interest is the cumulative interest that has built up on a loan since the beginning. New interest accrues at the end of each year on any outstanding balance."
	            ),
	            _react2.default.createElement(
	              _style2.default.LenderNoticeActions,
	              null,
	              _react2.default.createElement(
	                _style2.default.LenderNoticeButton,
	                { onClick: function onClick() {
	                    return _this3.setState({ showAccruedInterestInfo: false });
	                  } },
	                "OK"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { show: isVideoModalShown, onHide: this.closeVideoModal, className: "goals-and-targets-modal" },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              _style2.default.ModalVideoWrapper,
	              { className: isVideoPlaying ? 'is-playing' : '' },
	              _react2.default.createElement("video", {
	                ref: function ref(_ref) {
	                  _this3.videoRef = _ref;
	                },
	                src: this.state.selectedVideo,
	                alt: "Welcome Video",
	                onClick: this.handlePlayPause,
	                onEnded: function onEnded() {
	                  return _this3.setState({ isVideoPlaying: false });
	                },
	                style: { width: '100%', borderRadius: 10 }
	              }),
	              _react2.default.createElement(
	                _style2.default.PlayPauseButton,
	                { onClick: this.handlePlayPause },
	                isVideoPlaying ? '❚❚' : '▶'
	              ),
	              _react2.default.createElement(
	                _style2.default.CloseModalVideoButton,
	                { onClick: this.closeVideoModal },
	                "\xD7"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "roundNumber",
	    get: function get() {
	      var _state2 = this.state,
	          currentRound = _state2.currentRound,
	          roundInUrl = _state2.roundInUrl;
	
	
	      var round_number = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        round_number = roundInUrl;
	      }
	
	      return round_number;
	    }
	  }, {
	    key: "showActionButtons",
	    get: function get() {
	      var _state3 = this.state,
	          currentRound = _state3.currentRound,
	          roundInUrl = _state3.roundInUrl,
	          rounds = _state3.rounds,
	          hasAccess = _state3.hasAccess;
	      var roundShouldBeFinished = this.props.roundShouldBeFinished;
	
	
	      if (hasAccess === false || roundShouldBeFinished === true || roundInUrl !== null && roundInUrl !== currentRound) {
	        return false;
	      }
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	      if (!round) {
	        return false;
	      }
	
	      return round.is_started === true && round.is_finished === false;
	    }
	  }, {
	    key: "debtToCapital",
	    get: function get() {
	      var debt_to_capital = this.state.debt_to_capital;
	
	
	      return debt_to_capital > 0 ? (debt_to_capital * 100).toFixed(2) : "";
	    }
	  }, {
	    key: "costOfCapital",
	    get: function get() {
	      var cost_to_capital = this.state.cost_to_capital;
	
	
	      return cost_to_capital > 0 ? (cost_to_capital * 100).toFixed(2) : "";
	    }
	  }, {
	    key: "interestCharge",
	    get: function get() {
	      var interest_charge = this.state.interest_charge;
	
	
	      return interest_charge > 0 ? (0, _format.moneyFormat)(Math.abs(interest_charge)) : "";
	    }
	  }, {
	    key: "lendingRate",
	    get: function get() {
	      var lending_rate = this.state.lending_rate;
	
	
	      return lending_rate > 0 ? (lending_rate * 100).toFixed(2) : "";
	    }
	  }, {
	    key: "healthBadgeStatus",
	    get: function get() {
	      var ratio = Number(this.state.debt_to_capital) || 0;
	      if (ratio <= 0) return null;
	      var pct = ratio * 100;
	      if (pct <= 40) return 'Healthy';
	      if (pct <= 70) return 'Moderate';
	      if (pct <= 80) return 'High';
	      return 'Very High';
	    }
	
	    // A round is "active" when it's started but not yet finished. On an
	    // active round, interest for the current round is still accruing, so
	    // we display prior_year_interest_payable (the finalized carry-in from
	    // last year). On a closed round, interest_payable is finalized and is
	    // what we display. Falls back to false when we can't identify the
	    // viewed round (safer default: treat as closed / use interest_payable).
	
	  }, {
	    key: "isActiveRound",
	    get: function get() {
	      var _state4 = this.state,
	          rounds = _state4.rounds,
	          currentRound = _state4.currentRound,
	          roundInUrl = _state4.roundInUrl;
	
	      var roundNum = roundInUrl != null ? roundInUrl : currentRound;
	      var round = (rounds || []).find(function (r) {
	        return r.number === roundNum;
	      });
	      return !!round && round.is_started === true && round.is_finished === false;
	    }
	  }, {
	    key: "totalOutstandingDebt",
	    get: function get() {
	      var _state5 = this.state,
	          teamDebts = _state5.teamDebts,
	          interest_payments = _state5.interest_payments;
	
	      if (!Array.isArray(teamDebts)) return 0;
	      var isActive = this.isActiveRound;
	      // Two interest buckets live on each debt row:
	      //   prior_year_interest_payable → due THIS round (interest accrued
	      //     last round). interest_payments posted this round are paid
	      //     against this bucket.
	      //   interest_payable → interest just accrued THIS round. Rolls into
	      //     next round as prior_year_interest_payable; nothing's been
	      //     paid against it yet.
	      // Pick the field that matches the round's state.
	      var interestField = isActive ? 'prior_year_interest_payable' : 'interest_payable';
	      // Floor per row so the KPI matches the integer used as the repay
	      // cap on the Choose Your Lender page (see debt-decisions-page.js).
	      var grossOutstanding = teamDebts.reduce(function (sum, d) {
	        return sum + (Number(d.balance) || 0) + Math.floor(Number(d[interestField]) || 0);
	      }, 0);
	      // Only subtract interest payments during an active round — those
	      // payments reduce prior_year_interest_payable, not interest_payable.
	      // Also only count payments that target a debt row still present
	      // in teamDebts; the response can carry payments against debts
	      // closed in prior rounds, and summing those drags the KPI below
	      // the actual balance.
	      var currentDebtIds = new Set(teamDebts.map(function (d) {
	        return Number(d.id);
	      }));
	      var interestPaidThisRound = isActive ? (Array.isArray(interest_payments) ? interest_payments : []).filter(function (ip) {
	        return currentDebtIds.has(Number(ip.debt));
	      }).reduce(function (sum, ip) {
	        return sum + (Number(ip.amount) || 0);
	      }, 0) : 0;
	      return Math.max(0, grossOutstanding - interestPaidThisRound);
	    }
	
	    // Principal-only outstanding debt (no accrued interest). Used by the
	    // Capital Structure donut so the chart compares the same kind of
	    // capital on both sides (debt principal vs. equity capital raised).
	
	  }, {
	    key: "totalOutstandingDebtPrincipal",
	    get: function get() {
	      var teamDebts = this.state.teamDebts;
	
	      if (!Array.isArray(teamDebts)) return 0;
	      return teamDebts.reduce(function (sum, d) {
	        return sum + (Number(d.balance) || 0);
	      }, 0);
	    }
	  }, {
	    key: "totalAccruedInterest",
	    get: function get() {
	      var _state6 = this.state,
	          teamDebts = _state6.teamDebts,
	          interest_payments = _state6.interest_payments;
	
	      if (!Array.isArray(teamDebts)) return 0;
	      var isActive = this.isActiveRound;
	      var field = isActive ? 'prior_year_interest_payable' : 'interest_payable';
	      // Floor per row (same rationale as totalOutstandingDebt).
	      var grossInterest = teamDebts.reduce(function (sum, d) {
	        return sum + Math.floor(Number(d[field]) || 0);
	      }, 0);
	      // Only subtract interest payments made against still-live debts
	      // during an active round. See totalOutstandingDebt for the full
	      // rationale on both gates (bucket mismatch after close + stale
	      // payments against debts closed in prior rounds).
	      var currentDebtIds = new Set(teamDebts.map(function (d) {
	        return Number(d.id);
	      }));
	      var interestPaidThisRound = isActive ? (Array.isArray(interest_payments) ? interest_payments : []).filter(function (ip) {
	        return currentDebtIds.has(Number(ip.debt));
	      }).reduce(function (sum, ip) {
	        return sum + (Number(ip.amount) || 0);
	      }, 0) : 0;
	      return Math.max(0, grossInterest - interestPaidThisRound);
	    }
	  }, {
	    key: "totalPrincipal",
	    get: function get() {
	      var teamDebts = this.state.teamDebts;
	
	      if (!Array.isArray(teamDebts)) return 0;
	      return teamDebts.reduce(function (sum, d) {
	        return sum + (Number(d.balance) || 0);
	      }, 0);
	    }
	  }, {
	    key: "totalCapitalRaised",
	    get: function get() {
	      // Net of any stock buybacks: Σ equities.capital − Σ repurchased_shares.cost
	      var repurchases = Array.isArray(this.state.repurchased_shares) ? this.state.repurchased_shares : [];
	      var buybackCost = repurchases.reduce(function (sum, r) {
	        return sum + (Number(r.cost) || 0);
	      }, 0);
	      var eq = this.state.equity;
	      if (Array.isArray(eq)) {
	        var gross = eq.reduce(function (sum, e) {
	          return sum + (Number(e.capital) || 0);
	        }, 0);
	        return gross - buybackCost;
	      }
	      return (Number(this.state.equity_cumulative) || 0) - buybackCost;
	    }
	  }, {
	    key: "weightedAverageRate",
	    get: function get() {
	      var teamDebts = this.state.teamDebts;
	
	      if (!Array.isArray(teamDebts) || teamDebts.length === 0) return 0;
	      var totals = teamDebts.reduce(function (acc, d) {
	        var principal = Number(d.balance) || 0;
	        var rate = Number(d.rate) || 0;
	        acc.weighted += principal * rate;
	        acc.principal += principal;
	        return acc;
	      }, { weighted: 0, principal: 0 });
	      if (totals.principal <= 0) return 0;
	      return totals.weighted / totals.principal * 100;
	    }
	
	    // Fired by EquityDecisionsPage after the team's first equity
	    // issuance in Round 1. Shows the coaching modal that reminds the
	    // student to also raise debt if equity isn't enough to cover
	    // downstream product/marketing/operations spend.
	
	
	    // CTA: close the popup, close the equity flow, and open the Cash
	    // Balance modal so the user immediately sees how their raise
	    // affects team cash.
	
	  }, {
	    key: "cashBalance",
	    get: function get() {
	      var ending_cash = this.state.ending_cash;
	
	
	      return ending_cash.toFixed(0);
	    }
	  }, {
	    key: "showGraph",
	    get: function get() {
	      var _state7 = this.state,
	          loans = _state7.loans,
	          equity_cumulative = _state7.equity_cumulative;
	
	      var debts = _lodash2.default.sumBy(loans, "amount");
	
	      return debts > 0 || equity_cumulative > 0;
	    }
	  }]);
	
	  return FinanceDecisions;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.handlePlayPause = function () {
	    if (_this4.videoRef) {
	      if (_this4.state.isVideoPlaying) {
	        _this4.videoRef.pause();
	      } else {
	        _this4.videoRef.play();
	      }
	      _this4.setState({ isVideoPlaying: !_this4.state.isVideoPlaying });
	    }
	  };
	
	  this.openVideoModal = function (videoSrc) {
	    _this4.setState({
	      isVideoModalShown: true,
	      selectedVideo: videoSrc
	    });
	  };
	
	  this.closeVideoModal = function () {
	    _this4.setState({
	      isVideoModalShown: false,
	      isVideoPlaying: false
	    });
	  };
	
	  this.onHelpIconClick = function (field) {
	    if (videos[field]) {
	      _this4.openVideoModal(videos[field]);
	    }
	  };
	
	  this.onNoProjectionsModalConfirm = function () {
	    _this4.setState({
	      showNoProjectionsModal: false
	    });
	
	    _this4.props.router.push("/decisions/ceo?round_number=" + _this4.roundNumber);
	  };
	
	  this.reloadRole = function () {
	    var role = _Auth2.default.getRole();
	    var hasAccess = role === "CEO" || role === "FI";
	    var isOwnRole = role === "FI";
	
	    _this4.setState({
	      hasAccess: hasAccess,
	      isOwnRole: isOwnRole
	    });
	  };
	
	  this.fetchData = function (showWarnings) {
	    var rounds = _this4.state.rounds;
	
	
	    if (rounds.length === 0) {
	      return;
	    }
	
	    var round_number = _this4.roundNumber;
	    var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	    // Equity clients are a static lookup table (id -> name). Fire it in
	    // parallel with team-decisions / team-status so the Equity Summary
	    // Breakdown can resolve each equity[].client into an investor name.
	    (0, _ApiService.getRequest)(apiUrl + "static/equity_clients/").then(function (res) {
	      if (!_this4._isMounted) return;
	      _this4.setState({ equity_clients: res.body || [] });
	    }).catch(function () {});
	
	    Promise.all([(0, _TeamDecisionsService.fetchTeamDecisions)(round_number, 'finance'), (0, _TeamDecisionsService.fetchTeamStatus)(round_number)]).then(function (_ref2) {
	      var _ref3 = _slicedToArray(_ref2, 2),
	          decisionsData = _ref3[0],
	          statusData = _ref3[1];
	
	      if (!_this4._isMounted) return;
	
	      if (showWarnings) {
	        showWarnings(decisionsData);
	      }
	
	      var financial_decisions = decisionsData.financial_decisions,
	          teamDebts = decisionsData.teamDebts,
	          equities = decisionsData.equities;
	
	      var interest_payments = decisionsData.interest_payments || [];
	      var performance_moneys = decisionsData.performance_moneys || [];
	      var post_moneys = decisionsData.post_moneys || [];
	      var repurchased_shares = decisionsData.repurchased_shares || decisionsData.stock_repurchased || [];
	      var constantsObj = decisionsData.constants || {};
	      var submission_data = statusData.submission_data,
	          unaccepted_decisions = statusData.unaccepted_decisions;
	      var _financial_decisions$ = financial_decisions.team,
	          projections_submitted = _financial_decisions$.projections_submitted,
	          debt_to_capital = _financial_decisions$.debt_to_capital,
	          cost_to_capital = _financial_decisions$.cost_to_capital,
	          loans = _financial_decisions$.loans,
	          equity_cumulative = _financial_decisions$.equity_cumulative,
	          equity = _financial_decisions$.equity,
	          ending_cash = _financial_decisions$.ending_cash,
	          prev_cash = _financial_decisions$.prev_cash,
	          product_n_marketing = _financial_decisions$.product_n_marketing,
	          operations = _financial_decisions$.operations,
	          net_cash_balance_from_finance = _financial_decisions$.net_cash_balance_from_finance;
	      var decisions = decisionsData.decisions;
	      // Auto-detect heuristic only fires on closed rounds (is_started
	      // AND is_finished). On active rounds we don't pre-flag Finance
	      // as Posted just because a decision counter is non-zero.
	
	      var viewedRound = _this4.state.rounds.find(function (i) {
	        return i.number === _this4.roundNumber;
	      });
	      var isRoundEnded = !!viewedRound && viewedRound.is_started === true && viewedRound.is_finished === true;
	      var isActiveRound = !!viewedRound && viewedRound.is_started === true && viewedRound.is_finished === false;
	
	      // Current Share Price:
	      //   • round 1 still active (i.e. round 1 has not ended)
	      //                   → constants.initial_share_price
	      //   • active round  → prior round's performance_moneys.share_price
	      //   • otherwise     → viewed round's performance_moneys.share_price
	      // Use the last matching row (handles multiple snapshots per round).
	      var currentRoundId = viewedRound ? viewedRound.id : null;
	      var priorRoundObj = _this4.state.rounds.find(function (r) {
	        return r.number === Number(_this4.roundNumber) - 1;
	      });
	      var priorRoundId = priorRoundObj ? priorRoundObj.id : null;
	      var round1 = _this4.state.rounds.find(function (r) {
	        return r.number === 1;
	      });
	      var isRound1Active = !!round1 && round1.is_finished !== true;
	      var targetRoundId = isActiveRound ? priorRoundId : currentRoundId;
	      var matchingPerf = performance_moneys.filter(function (r) {
	        return Number(r.round) === Number(targetRoundId);
	      });
	      var currentSharePrice = isRound1Active ? Number(constantsObj.initial_share_price) || 0 : matchingPerf.length > 0 ? Number(matchingPerf[matchingPerf.length - 1].share_price) || 0 : 0;
	
	      // Company Ownership % = constants.initial_shares / total outstanding shares
	      // Total outstanding:
	      //   • prefer current round post_moneys.shares
	      //   • else fall back to prior round performance_moneys.shares
	      var currentPostMoneys = post_moneys.filter(function (r) {
	        return Number(r.round) === Number(currentRoundId);
	      });
	      var currentPostMoneyShares = currentPostMoneys.length > 0 ? Number(currentPostMoneys[currentPostMoneys.length - 1].shares) || 0 : 0;
	      var priorPerfForOwnership = performance_moneys.filter(function (r) {
	        return Number(r.round) === Number(priorRoundId);
	      });
	      var priorPerfShares = priorPerfForOwnership.length > 0 ? Number(priorPerfForOwnership[priorPerfForOwnership.length - 1].shares) || 0 : 0;
	      var ownershipDenominator = currentPostMoneyShares || priorPerfShares;
	      var initialShares = Number(constantsObj.initial_shares) || 0;
	      var rawOwnershipPct = ownershipDenominator > 0 ? initialShares / ownershipDenominator * 100 : 0;
	      // Clamp: the ratio is a fraction of ownership, so anything
	      // outside [0, 100] is a data glitch (e.g. a stale denominator)
	      // and displaying it that way just confuses students.
	      var companyOwnershipPct = Math.max(0, Math.min(100, rawOwnershipPct));
	      var outstandingShares = ownershipDenominator;
	
	      // Finance pre-check: explicit user submission is the trigger,
	      // matching PD/OP. We no longer auto-flip the button to Posted
	      // based on cash or any decision counter — the user must
	      // explicitly click POST on Finance.
	      var isPreChecked = submission_data.fn && submission_data.fn.date !== 'N/A';
	
	      var _teamDebts$reduce = teamDebts.reduce(function (acc, item) {
	        acc.teamInterestCharge += item.interest_charge;
	        acc.teamBalance += item.balance;
	        return acc;
	      }, { teamInterestCharge: 0, teamBalance: 0 }),
	          teamInterestCharge = _teamDebts$reduce.teamInterestCharge,
	          teamBalance = _teamDebts$reduce.teamBalance;
	
	      var lending_rate = teamBalance ? teamInterestCharge / teamBalance : 0;
	
	      var total_shares = 0;
	      if (Array.isArray(equity)) {
	        total_shares = equity.reduce(function (sum, e) {
	          return sum + (Number(e.issuance) || 0);
	        }, 0);
	      }
	
	      _this4.setState({
	        projections_submitted: projections_submitted,
	        debt_to_capital: debt_to_capital,
	        cost_to_capital: cost_to_capital,
	        loans: loans,
	        teamDebts: teamDebts,
	        interest_payments: interest_payments,
	        equity_cumulative: equity_cumulative,
	        equity: equity,
	        equities: equities || [],
	        repurchased_shares: repurchased_shares,
	        total_shares: total_shares,
	        initialShares: initialShares,
	        outstandingShares: outstandingShares,
	        currentSharePrice: currentSharePrice,
	        companyOwnershipPct: companyOwnershipPct,
	        ending_cash: ending_cash,
	        financial_decisions: { team: financial_decisions.team, products: financial_decisions.products },
	        prev_cash_balance: prev_cash,
	        submission_data: submission_data,
	        submitDecisionsLoading: false,
	        loading: false,
	        unaccepted_decisions: unaccepted_decisions,
	        isPreChecked: isPreChecked,
	        lending_rate: lending_rate,
	        interest_charge: teamInterestCharge,
	        product_n_marketing: product_n_marketing,
	        operations: operations,
	        net_cash_balance_from_finance: net_cash_balance_from_finance
	      });
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "FinanceDecisions", "fetchData");
	    });
	  };
	
	  this.submitDecisions = function () {
	    _this4.setState({
	      submitDecisionsLoading: true
	    });
	
	    var currentRound = _this4.props.currentRound;
	
	
	    (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/page/financials/?round_number=" + currentRound).then(function (res) {
	      var teamPageFinancials = res.body;
	      var teamData = teamPageFinancials.team ? teamPageFinancials.team : null;
	      var endingCash = teamData.ending_cash ? teamData.ending_cash : null;
	
	      if (endingCash && endingCash < 0) {
	        _this4.setState({
	          showWarningModal: true,
	          warningTitle: 'Warning! You Need More Cash',
	          warningMessage: _react2.default.createElement(
	            _reactDotFragment2.default,
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              "Your finance decisions were successfully posted, but you still have insufficient capital."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "p",
	              null,
	              "In order for your decisions to be fully accepted, your cash balance on the finance decision page needs to have a positive value. "
	            )
	          ),
	          warningButtonText: 'Done'
	        });
	      } else {
	        (0, _SubmitDecisions.submitDecisions)("finance", _this4.state.roundInUrl || _this4.state.currentRound, function (showWarnings) {
	          _this4.fetchData(showWarnings);
	        });
	      }
	    }).catch(function (err) {});
	  };
	
	  this.showManageFinancesModal = function () {
	    _this4.setState({ showManageFinancesModal: true, manageStep: 'main' });
	  };
	
	  this.hideManageFinancesModal = function () {
	    _this4.setState({ showManageFinancesModal: false, manageStep: 'main' });
	  };
	
	  this.pickManageBranch = function (branch) {
	    if (branch === 'debt') {
	      // Replace the Manage popup's debt sub-step with the new
	      // Choose Your Lender page per the latest design.
	      _this4.setState({ showManageFinancesModal: false, manageStep: 'main', showDebtDecisionsPage: true });
	      return;
	    }
	    if (branch === 'equity') {
	      // Replace the equity sub-step with the new Choose Your Equity
	      // Investor page (mirrors the Lender page UX).
	      _this4.setState({ showManageFinancesModal: false, manageStep: 'main', showEquityDecisionsPage: true });
	      return;
	    }
	    _this4.setState({ manageStep: branch });
	  };
	
	  this.closeDebtDecisionsPage = function () {
	    _this4.setState({ showDebtDecisionsPage: false });
	  };
	
	  this.closeEquityDecisionsPage = function () {
	    _this4.setState({ showEquityDecisionsPage: false });
	  };
	
	  this.handleFirstEquityIssued = function () {
	    _this4.setState({ firstDecisionModalOpen: true });
	  };
	
	  this.handleFirstDecisionClose = function () {
	    _this4.setState({ firstDecisionModalOpen: false });
	  };
	
	  this.handleFirstDecisionCta = function () {
	    _this4.setState({
	      firstDecisionModalOpen: false,
	      showEquityDecisionsPage: false
	    }, function () {
	      _this4.eventemitter.trigger('show-cash-balance-modal');
	    });
	  };
	
	  this.handleSelectLender = function (lender) {
	    // For now, picking a lender from the Choose Your Lender page closes
	    // the page and routes through the existing Raise Debt flow. The
	    // backend chosen-lender pre-selection can be wired up in a follow-up.
	    _this4.setState({ showDebtDecisionsPage: false }, function () {
	      _this4.eventemitter.trigger("show-raise-debt-modal");
	    });
	  };
	
	  this.backToManageMain = function () {
	    _this4.setState({ manageStep: 'main' });
	  };
	
	  this.pickManageOption = function (action) {
	    _this4.setState({ showManageFinancesModal: false, manageStep: 'main' }, function () {
	      if (action === 'raise-debt') {
	        _this4.eventemitter.trigger("show-raise-debt-modal");
	      } else if (action === 'return-debt') {
	        _this4.eventemitter.trigger("show-return-debt-modal");
	      } else if (action === 'raise-equity') {
	        var projections_submitted = _this4.state.projections_submitted;
	
	        if (!projections_submitted) {
	          _this4.setState({ showNoProjectionsModal: true });
	        } else {
	          _this4.eventemitter.trigger("show-raise-equity-modal");
	        }
	      } else if (action === 'return-equity') {
	        _this4.eventemitter.trigger("show-return-equity-modal");
	      }
	    });
	  };
	
	  this.showCashBalanceModal = function () {
	    _this4.eventemitter.trigger("show-cash-balance-modal");
	  };
	
	  this.showRaiseCapitalSelectModal = function () {
	    var projections_submitted = _this4.state.projections_submitted;
	
	
	    if (!projections_submitted) {
	      _this4.setState({
	        showNoProjectionsModal: true
	      });
	    } else {
	      _this4.eventemitter.trigger("show-raise-capital-select-modal");
	    }
	  };
	
	  this.showRaiseDebtModal = function () {
	    _this4.eventemitter.trigger("hide-raise-capital-select-modal");
	    _this4.eventemitter.trigger("show-raise-debt-modal");
	  };
	
	  this.showRaiseEquityModal = function () {
	    _this4.eventemitter.trigger("hide-raise-capital-select-modal");
	    _this4.eventemitter.trigger("show-raise-equity-modal");
	  };
	
	  this.showReturnCapitalSelectModal = function () {
	    _this4.eventemitter.trigger("show-return-capital-select-modal");
	  };
	
	  this.showReturnDebtModal = function () {
	    _this4.eventemitter.trigger("hide-return-capital-select-modal");
	    _this4.eventemitter.trigger("show-return-debt-modal");
	  };
	
	  this.showReturnEquityModal = function () {
	    _this4.eventemitter.trigger("hide-return-capital-select-modal");
	    _this4.eventemitter.trigger("show-return-equity-modal");
	  };
	
	  this.showInterestChargeWarning = function () {
	    _this4.setState({
	      showWarningModal: true,
	      warningMessage: _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Warning! Your Overall Interest Charged is High!"
	        ),
	        " High interest expense could have an adverse impact in your Round 3 performance. Consider reducing your outstanding loans or at at the minimum, paying down your interest payable."
	      ),
	      warningButtonText: 'Ok'
	    });
	  };
	
	  this.hideWarningModal = function () {
	    _this4.setState({
	      showWarningModal: false
	    });
	  };
	};
	
	exports.default = (0, _reactEasyState.view)(FinanceDecisions);

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _icon_collapse = __webpack_require__(274);
	
	var _icon_collapse2 = _interopRequireDefault(_icon_collapse);
	
	var _varianceAnalysis = __webpack_require__(1182);
	
	var _varianceAnalysis2 = _interopRequireDefault(_varianceAnalysis);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinancialAnalysis = function (_PureComponent) {
	  _inherits(FinancialAnalysis, _PureComponent);
	
	  function FinancialAnalysis() {
	    _classCallCheck(this, FinancialAnalysis);
	
	    return _possibleConstructorReturn(this, (FinancialAnalysis.__proto__ || Object.getPrototypeOf(FinancialAnalysis)).apply(this, arguments));
	  }
	
	  _createClass(FinancialAnalysis, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl,
	          rounds = _props.rounds;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "analysis section-mobile bg-gray" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "container-analysis report-collapse none-shadow" },
	              _react2.default.createElement(
	                "h3",
	                { className: "semibold" },
	                "Financial, Planning, and Analysis",
	                _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, _TypeformContent2.default.FINANCIAL_PLANNING_ANALYSIS),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: "/ceo/analysis", className: "icon-zoom" },
	                  _react2.default.createElement("img", {
	                    src: _icon_collapse2.default,
	                    className: "icon",
	                    alt: "CollapseImage"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "bg-white p-20 mt-20" },
	                _react2.default.createElement(_varianceAnalysis2.default, {
	                  currentRound: currentRound,
	                  roundInUrl: roundInUrl,
	                  rounds: rounds
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FinancialAnalysis;
	}(_react.PureComponent);
	
	exports.default = FinancialAnalysis;

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  inset: 0;\n  background: #0F172A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  flex-direction: column;\n  padding: 24px;\n  font-family: 'Mukta Vaani', 'Inter', sans-serif;\n"], ["\n  position: fixed;\n  inset: 0;\n  background: #0F172A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  flex-direction: column;\n  padding: 24px;\n  font-family: 'Mukta Vaani', 'Inter', sans-serif;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 20px;\n  right: 24px;\n  padding: 8px 14px;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.72);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: 0.01em;\n  z-index: 10;\n\n  &:hover {\n    color: #FFFFFF;\n    text-decoration: underline;\n  }\n"], ["\n  position: fixed;\n  top: 20px;\n  right: 24px;\n  padding: 8px 14px;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.72);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: 0.01em;\n  z-index: 10;\n\n  &:hover {\n    color: #FFFFFF;\n    text-decoration: underline;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0 0 22px;\n  max-width: 1000px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0 0 22px;\n  max-width: 1000px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  width: 44px;\n  height: 44px;\n  display: block;\n  flex-shrink: 0;\n"], ["\n  width: 44px;\n  height: 44px;\n  display: block;\n  flex-shrink: 0;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-family: 'Bricolage Grotesque', 'Mukta Vaani', 'Inter', sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  color: #FFFFFF;\n  letter-spacing: -0.01em;\n  text-align: left;\n"], ["\n  margin: 0;\n  font-family: 'Bricolage Grotesque', 'Mukta Vaani', 'Inter', sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  color: #FFFFFF;\n  letter-spacing: -0.01em;\n  text-align: left;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  max-width: 1000px;\n  aspect-ratio: 16 / 9;\n  background: #000;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n"], ["\n  position: relative;\n  width: 100%;\n  max-width: 1000px;\n  aspect-ratio: 16 / 9;\n  background: #000;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: block;\n  cursor: pointer;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: block;\n  cursor: pointer;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(15, 23, 42, 0.72);\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  backdrop-filter: blur(6px);\n  z-index: 3;\n\n  &:hover {\n    background: rgba(30, 41, 59, 0.85);\n  }\n"], ["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(15, 23, 42, 0.72);\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  backdrop-filter: blur(6px);\n  z-index: 3;\n\n  &:hover {\n    background: rgba(30, 41, 59, 0.85);\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(37, 99, 235, 0.92);\n  color: #FFFFFF;\n  cursor: pointer;\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n  z-index: 2;\n  transition: transform 120ms ease, background 120ms ease;\n\n  &:hover {\n    background: rgba(29, 78, 216, 1);\n    transform: translate(-50%, -50%) scale(1.05);\n  }\n\n  svg {\n    width: 34px;\n    height: 34px;\n    fill: currentColor;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 84px;\n  height: 84px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(37, 99, 235, 0.92);\n  color: #FFFFFF;\n  cursor: pointer;\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);\n  z-index: 2;\n  transition: transform 120ms ease, background 120ms ease;\n\n  &:hover {\n    background: rgba(29, 78, 216, 1);\n    transform: translate(-50%, -50%) scale(1.05);\n  }\n\n  svg {\n    width: 34px;\n    height: 34px;\n    fill: currentColor;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 10px 16px 12px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.55) 100%);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  z-index: 2;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 10px 16px 12px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.55) 100%);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  z-index: 2;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.14);\n  color: #FFFFFF;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.24);\n  }\n\n  svg {\n    width: 14px;\n    height: 14px;\n    fill: currentColor;\n  }\n"], ["\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.14);\n  color: #FFFFFF;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.24);\n  }\n\n  svg {\n    width: 14px;\n    height: 14px;\n    fill: currentColor;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.85);\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n"], ["\n  font-size: 12px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.85);\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  flex: 1;\n  height: 4px;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.2);\n  overflow: hidden;\n  cursor: default;\n"], ["\n  flex: 1;\n  height: 4px;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.2);\n  overflow: hidden;\n  cursor: default;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  height: 100%;\n  background: #2563EB;\n  width: ", "%;\n  transition: width 200ms linear;\n"], ["\n  height: 100%;\n  background: #2563EB;\n  width: ", "%;\n  transition: width 200ms linear;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  margin-top: 28px;\n  padding: 14px 40px;\n  border: none;\n  border-radius: 12px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-size: 17px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 120ms ease, background 120ms ease;\n  box-shadow: 0 10px 30px rgba(37, 99, 235, 0.35);\n\n  &:hover:not(:disabled) {\n    background: #1D4ED8;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    background: #334155;\n    color: rgba(255, 255, 255, 0.55);\n    cursor: default;\n    box-shadow: none;\n  }\n"], ["\n  margin-top: 28px;\n  padding: 14px 40px;\n  border: none;\n  border-radius: 12px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-size: 17px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 120ms ease, background 120ms ease;\n  box-shadow: 0 10px 30px rgba(37, 99, 235, 0.35);\n\n  &:hover:not(:disabled) {\n    background: #1D4ED8;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    background: #334155;\n    color: rgba(255, 255, 255, 0.55);\n    cursor: default;\n    box-shadow: none;\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  margin-top: 18px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.65);\n  text-align: center;\n  line-height: 1.5;\n  max-width: 520px;\n"], ["\n  margin-top: 18px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.65);\n  text-align: center;\n  line-height: 1.5;\n  max-width: 520px;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 1100px;\n  padding: 0 24px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 1100px;\n  padding: 0 24px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.78);\n  margin-bottom: 18px;\n  letter-spacing: 0.01em;\n"], ["\n  font-size: 22px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.78);\n  margin-bottom: 18px;\n  letter-spacing: 0.01em;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-family: 'Bricolage Grotesque', 'Mukta Vaani', 'Inter', sans-serif;\n  font-size: 50px;\n  line-height: 1.08;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #FFFFFF;\n"], ["\n  margin: 0;\n  font-family: 'Bricolage Grotesque', 'Mukta Vaani', 'Inter', sans-serif;\n  font-size: 50px;\n  line-height: 1.08;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #FFFFFF;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  display: block;\n  color: #5C91F5;\n"], ["\n  display: block;\n  color: #5C91F5;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  width: 115px;\n  height: 115px;\n  margin: 44px 0 36px;\n  display: block;\n"], ["\n  width: 115px;\n  height: 115px;\n  margin: 44px 0 36px;\n  display: block;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  padding: 14px 50px;\n  border: none;\n  border-radius: 9px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 120ms ease, background 120ms ease;\n  box-shadow: 0 11px 32px rgba(37, 99, 235, 0.45);\n\n  &:hover {\n    background: #1D4ED8;\n    transform: translateY(-1px);\n  }\n"], ["\n  padding: 14px 50px;\n  border: none;\n  border-radius: 9px;\n  background: #2563EB;\n  color: #FFFFFF;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 120ms ease, background 120ms ease;\n  box-shadow: 0 11px 32px rgba(37, 99, 235, 0.45);\n\n  &:hover {\n    background: #1D4ED8;\n    transform: translateY(-1px);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _WelcomeToITB = __webpack_require__(2568);
	
	var _WelcomeToITB2 = _interopRequireDefault(_WelcomeToITB);
	
	var _NewMGLogoIcon = __webpack_require__(557);
	
	var _NewMGLogoIcon2 = _interopRequireDefault(_NewMGLogoIcon);
	
	var _NewMGLogoDarkBG = __webpack_require__(1050);
	
	var _NewMGLogoDarkBG2 = _interopRequireDefault(_NewMGLogoDarkBG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	
	var Overlay = _styledComponents2.default.div(_templateObject);
	
	var LogoutLink = _styledComponents2.default.button(_templateObject2);
	
	var TitleRow = _styledComponents2.default.div(_templateObject3);
	
	var TitleLogo = _styledComponents2.default.img(_templateObject4);
	
	var Title = _styledComponents2.default.h1(_templateObject5);
	
	var VideoWrapper = _styledComponents2.default.div(_templateObject6);
	
	var Video = _styledComponents2.default.video(_templateObject7);
	
	var SoundToggle = _styledComponents2.default.button(_templateObject8);
	
	var CenterPlayButton = _styledComponents2.default.button(_templateObject9, function (p) {
	  return p.visible ? 'flex' : 'none';
	});
	
	var BottomBar = _styledComponents2.default.div(_templateObject10);
	
	var SmallPlayPauseButton = _styledComponents2.default.button(_templateObject11);
	
	var TimeText = _styledComponents2.default.div(_templateObject12);
	
	var ProgressTrack = _styledComponents2.default.div(_templateObject13);
	
	var ProgressFill = _styledComponents2.default.div(_templateObject14, function (p) {
	  return p.percent;
	});
	
	var ReadyButton = _styledComponents2.default.button(_templateObject15);
	
	var HelperText = _styledComponents2.default.div(_templateObject16);
	
	var GreetingWrap = _styledComponents2.default.div(_templateObject17);
	
	var GreetingHi = _styledComponents2.default.div(_templateObject18);
	
	var GreetingTitle = _styledComponents2.default.h1(_templateObject19);
	
	var GreetingTitleAccent = _styledComponents2.default.span(_templateObject20);
	
	var GreetingLogo = _styledComponents2.default.img(_templateObject21);
	
	var ContinueButton = _styledComponents2.default.button(_templateObject22);
	
	var PlayIconSvg = function PlayIconSvg() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 24 24" },
	    _react2.default.createElement("path", { d: "M8 5v14l11-7z" })
	  );
	};
	
	var PauseIconSvg = function PauseIconSvg() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 24 24" },
	    _react2.default.createElement("path", { d: "M6 5h4v14H6zM14 5h4v14h-4z" })
	  );
	};
	
	var formatTime = function formatTime(seconds) {
	  if (!seconds || !isFinite(seconds)) return "0:00";
	  var total = Math.floor(seconds);
	  var mins = Math.floor(total / 60);
	  var secs = total % 60;
	  return mins + ":" + (secs < 10 ? '0' : '') + secs;
	};
	
	var IntroVideoPage = function (_Component) {
	  _inherits(IntroVideoPage, _Component);
	
	  function IntroVideoPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IntroVideoPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IntroVideoPage.__proto__ || Object.getPrototypeOf(IntroVideoPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showGreeting: true,
	      ended: false,
	      muted: false,
	      submitting: false,
	      paused: true,
	      currentTime: 0,
	      duration: 0
	    }, _this.handleContinueFromGreeting = function () {
	      _this.setState({ showGreeting: false });
	    }, _this.maxTime = 0, _this.handleTimeUpdate = function () {
	      if (!_this.videoRef) return;
	      var current = _this.videoRef.currentTime;
	      if (current > _this.maxTime) _this.maxTime = current;
	      _this.setState({ currentTime: current });
	    }, _this.handleLoadedMetadata = function () {
	      if (!_this.videoRef) return;
	      _this.setState({ duration: _this.videoRef.duration || 0 });
	    }, _this.handleSeeking = function () {
	      if (!_this.videoRef) return;
	      var tolerance = 0.5;
	      if (Math.abs(_this.videoRef.currentTime - _this.maxTime) > tolerance) {
	        _this.videoRef.currentTime = _this.maxTime;
	      }
	    }, _this.handleVolumeChange = function () {
	      if (!_this.videoRef) return;
	      if (_this.videoRef.muted !== _this.state.muted) {
	        _this.setState({ muted: _this.videoRef.muted });
	      }
	    }, _this.handlePlay = function () {
	      _this.setState({ paused: false });
	    }, _this.handlePause = function () {
	      _this.setState({ paused: true });
	    }, _this.handleEnded = function () {
	      _this.setState({ ended: true, paused: true });
	    }, _this.togglePlayPause = function () {
	      if (!_this.videoRef) return;
	      if (_this.videoRef.paused || _this.videoRef.ended) {
	        _this.videoRef.play().catch(function () {});
	      } else {
	        _this.videoRef.pause();
	      }
	    }, _this.handleToggleSound = function () {
	      _this.setState(function (prev) {
	        return { muted: !prev.muted };
	      }, function () {
	        if (_this.videoRef && _this.state.muted === false) {
	          _this.videoRef.play().catch(function () {});
	        }
	      });
	    }, _this.handleLogout = function () {
	      if (_Auth2.default.isUserAuthenticated()) {
	        _Auth2.default.deauthenticateUser();
	      }
	      (0, _Location.changeLocation)("/login");
	    }, _this.handleReady = function () {
	      if (_this.state.submitting) return;
	      var userId = _Auth2.default.getUserId();
	      if (!userId) {
	        (0, _Location.changeLocation)("/start");
	        return;
	      }
	
	      _this.setState({ submitting: true });
	      (0, _ApiService.patchRequest)(API + "users/" + userId + "/").send({ intro: 1 }).then(function () {
	        var user = _Auth2.default.getUser();
	        if (user) _Auth2.default.setUserData(Object.assign({}, user, { intro: 1 }));
	        // Bust the general-info cache AND ping App.js to refetch.
	        // Clearing the cache alone isn't enough — App.js's fetchData
	        // only runs on componentDidMount or when the "reload-data"
	        // event fires, and route changes via changeLocation don't
	        // remount App or invoke componentDidUpdate's fetch path.
	        // Without the emit, App.js reads the pre-video cached response
	        // (intro=0) on the next render, early-returns before writing
	        // players_data, and downstream views like the Team Profile
	        // popup show empty until the user hard-refreshes.
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	        _eventEmitter2.default.getInstance().trigger("reload-data");
	        (0, _Location.changeLocation)("/start");
	      }).catch(function () {
	        // Same reasoning as the success path — even if the PATCH
	        // failed we're navigating away, so drop the cache and fire
	        // a refetch so App.js's next tick isn't served the stale
	        // intro=0 response.
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	        _eventEmitter2.default.getInstance().trigger("reload-data");
	        (0, _Location.changeLocation)("/start");
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // Furthest playback position the user has reached. Any attempt to
	  // seek beyond this snaps back — a defensive guard in case some input
	  // path (keyboard, media keys, browser extension) tries to skip ahead.
	
	
	  _createClass(IntroVideoPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var user = _Auth2.default.getUser();
	      if (user && user.intro !== 0) {
	        (0, _Location.changeLocation)("/start");
	      }
	    }
	
	    // Block any seek that would move past the furthest point already
	    // watched. Rewinding is also blocked (we snap back to maxTime) so
	    // the student can't scrub back-and-forth to game the "watched"
	    // check either.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          showGreeting = _state.showGreeting,
	          ended = _state.ended,
	          muted = _state.muted,
	          submitting = _state.submitting,
	          paused = _state.paused,
	          currentTime = _state.currentTime,
	          duration = _state.duration;
	
	
	      if (showGreeting) {
	        var user = _Auth2.default.getUser();
	        var firstName = (0, _utils.resolveFirstName)(user && user.first_name);
	        return _react2.default.createElement(
	          Overlay,
	          null,
	          _react2.default.createElement(
	            LogoutLink,
	            { onClick: this.handleLogout },
	            "Logout"
	          ),
	          _react2.default.createElement(
	            GreetingWrap,
	            null,
	            firstName && _react2.default.createElement(
	              GreetingHi,
	              null,
	              "Hi ",
	              firstName,
	              ","
	            ),
	            _react2.default.createElement(
	              GreetingTitle,
	              null,
	              "Welcome to Market Games'",
	              _react2.default.createElement(
	                GreetingTitleAccent,
	                null,
	                "Intro to Business Challenge"
	              )
	            ),
	            _react2.default.createElement(GreetingLogo, { src: _NewMGLogoDarkBG2.default, alt: "Market Games" }),
	            _react2.default.createElement(
	              ContinueButton,
	              { onClick: this.handleContinueFromGreeting },
	              "Continue"
	            )
	          )
	        );
	      }
	
	      var percent = duration > 0 ? Math.min(100, currentTime / duration * 100) : 0;
	      // Unlock the "I'm Ready" button at the 85-second mark so students
	      // aren't forced to sit through the tail of the intro before
	      // continuing. Video-end still counts (safety net for shorter cuts).
	      var canProceed = ended || currentTime >= 85;
	
	      return _react2.default.createElement(
	        Overlay,
	        null,
	        _react2.default.createElement(
	          LogoutLink,
	          { onClick: this.handleLogout },
	          "Logout"
	        ),
	        _react2.default.createElement(
	          TitleRow,
	          null,
	          _react2.default.createElement(TitleLogo, { src: _NewMGLogoIcon2.default, alt: "Market Games" }),
	          _react2.default.createElement(
	            Title,
	            null,
	            "The Intro to Business Challenge"
	          )
	        ),
	        _react2.default.createElement(
	          VideoWrapper,
	          null,
	          _react2.default.createElement(Video, {
	            innerRef: function innerRef(el) {
	              _this2.videoRef = el;
	            },
	            src: _WelcomeToITB2.default,
	            muted: muted,
	            playsInline: true,
	            disablePictureInPicture: true,
	            tabIndex: "-1",
	            onClick: this.togglePlayPause,
	            onPlay: this.handlePlay,
	            onPause: this.handlePause,
	            onEnded: this.handleEnded,
	            onTimeUpdate: this.handleTimeUpdate,
	            onLoadedMetadata: this.handleLoadedMetadata,
	            onSeeking: this.handleSeeking,
	            onVolumeChange: this.handleVolumeChange,
	            onContextMenu: function onContextMenu(e) {
	              return e.preventDefault();
	            }
	          }),
	          _react2.default.createElement(
	            CenterPlayButton,
	            {
	              type: "button",
	              visible: paused && !ended,
	              onClick: this.togglePlayPause,
	              "aria-label": "Play"
	            },
	            _react2.default.createElement(PlayIconSvg, null)
	          ),
	          _react2.default.createElement(
	            SoundToggle,
	            { type: "button", onClick: this.handleToggleSound },
	            muted ? "🔇  Unmute" : "🔊  Mute"
	          ),
	          _react2.default.createElement(
	            BottomBar,
	            null,
	            _react2.default.createElement(
	              SmallPlayPauseButton,
	              {
	                type: "button",
	                onClick: this.togglePlayPause,
	                "aria-label": paused ? "Play" : "Pause"
	              },
	              paused ? _react2.default.createElement(PlayIconSvg, null) : _react2.default.createElement(PauseIconSvg, null)
	            ),
	            _react2.default.createElement(
	              TimeText,
	              null,
	              formatTime(currentTime),
	              " / ",
	              formatTime(duration)
	            ),
	            _react2.default.createElement(
	              ProgressTrack,
	              null,
	              _react2.default.createElement(ProgressFill, { percent: percent })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ReadyButton,
	          { onClick: this.handleReady, disabled: !canProceed || submitting },
	          submitting ? "Saving..." : "I'm Ready"
	        ),
	        _react2.default.createElement(
	          HelperText,
	          null,
	          canProceed ? "Great! Click the button above to continue." : "Press play to watch the intro. The button below will unlock as you watch."
	        )
	      );
	    }
	  }]);
	
	  return IntroVideoPage;
	}(_react.Component);
	
	exports.default = IntroVideoPage;

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _icon_collapse = __webpack_require__(274);
	
	var _icon_collapse2 = _interopRequireDefault(_icon_collapse);
	
	var _map = __webpack_require__(1159);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _usInfo = __webpack_require__(1160);
	
	var _usInfo2 = _interopRequireDefault(_usInfo);
	
	var _europeInfo = __webpack_require__(1158);
	
	var _europeInfo2 = _interopRequireDefault(_europeInfo);
	
	var _asiaInfo = __webpack_require__(1157);
	
	var _asiaInfo2 = _interopRequireDefault(_asiaInfo);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _TypeformContent = __webpack_require__(42);
	
	var _TypeformContent2 = _interopRequireDefault(_TypeformContent);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _utils = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketAnalysis = function (_Component) {
	  _inherits(MarketAnalysis, _Component);
	
	  function MarketAnalysis(props) {
	    _classCallCheck(this, MarketAnalysis);
	
	    var _this = _possibleConstructorReturn(this, (MarketAnalysis.__proto__ || Object.getPrototypeOf(MarketAnalysis)).call(this, props));
	
	    _this.fetchData = function () {
	      var round_number = _this.activeRound;
	
	      // customer-analysis scope pre-filters all four tables to the
	      // requested round and drops the round_number column, so
	      // total_demand / demand_growth_rate arrive as single-row arrays
	      // (take [0]) and customer_preferences / customer_demand arrive
	      // fully filtered (no client-side filter needed).
	      (0, _StaticDataService.fetchAllStaticData)(round_number, 'customer-analysis').then(function (data) {
	        var units_demanded_automobile = 0;
	        var units_demanded_mobile_phone = 0;
	        var obj1 = data.totalDemand && data.totalDemand[0] || null;
	        if (obj1) {
	          units_demanded_automobile = obj1.auto;
	          units_demanded_mobile_phone = obj1.mobile;
	        }
	
	        var growth_rate_automobile = 0;
	        var growth_rate_mobile_phones = 0;
	        var obj2 = data.demandGrowthRate && data.demandGrowthRate[0] || null;
	        if (obj2) {
	          growth_rate_automobile = obj2.auto * 100;
	          growth_rate_mobile_phones = obj2.mobile * 100;
	        }
	
	        var customer_preferences = data.customerPreferences || [];
	        var customer_demands = data.customerDemand || [];
	
	        _this.setState({
	          units_demanded_automobile: units_demanded_automobile,
	          units_demanded_mobile_phone: units_demanded_mobile_phone,
	          growth_rate_automobile: growth_rate_automobile,
	          growth_rate_mobile_phones: growth_rate_mobile_phones,
	          customer_preferences: customer_preferences,
	          customer_demands: customer_demands
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "MarketAnalysis", "fetchData");
	      });
	    };
	
	    _this.state = {
	      units_demanded_automobile: 0,
	      growth_rate_automobile: 0,
	      units_demanded_mobile_phone: 0,
	      growth_rate_mobile_phones: 0,
	      roundInUrl: props.roundInUrl,
	      currentRound: props.currentRound,
	      rounds: props.rounds,
	      customer_preferences: [],
	      customer_demands: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketAnalysis, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          units_demanded_automobile = _state.units_demanded_automobile,
	          growth_rate_automobile = _state.growth_rate_automobile,
	          units_demanded_mobile_phone = _state.units_demanded_mobile_phone,
	          growth_rate_mobile_phones = _state.growth_rate_mobile_phones,
	          customer_preferences = _state.customer_preferences,
	          customer_demands = _state.customer_demands;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "analysis section-mobile bg-gray" },
	        _react2.default.createElement(
	          "div",
	          { className: "container-analysis none-shadow" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-xs-12" },
	              _react2.default.createElement(
	                "h3",
	                { className: "semibold" },
	                "Customer Analysis",
	                _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, _TypeformContent2.default.MARKET_ANALYSIS),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: this.url, className: "icon-zoom" },
	                  _react2.default.createElement("img", {
	                    src: _icon_collapse2.default,
	                    className: "icon",
	                    alt: "CollapseImage"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(_map2.default, {
	              customer_preferences: customer_preferences,
	              customer_demands: customer_demands
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 col-xs-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(_usInfo2.default, {
	                  units_demanded_automobile: units_demanded_automobile,
	                  growth_rate_automobile: growth_rate_automobile,
	                  units_demanded_mobile_phone: units_demanded_mobile_phone,
	                  growth_rate_mobile_phones: growth_rate_mobile_phones
	                }),
	                _react2.default.createElement(_europeInfo2.default, null),
	                _react2.default.createElement(_asiaInfo2.default, null)
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "activeRound",
	    get: function get() {
	      var _state2 = this.state,
	          currentRound = _state2.currentRound,
	          roundInUrl = _state2.roundInUrl;
	
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return roundInUrl;
	      }
	
	      return currentRound;
	    }
	  }, {
	    key: "url",
	    get: function get() {
	      var currentRound = this.state.currentRound;
	
	      var activeRound = this.activeRound;
	      var base_url = "/ceo/analysis";
	
	      if (currentRound !== activeRound) {
	        return base_url + "?round=" + activeRound;
	      }
	
	      return base_url;
	    }
	  }]);
	
	  return MarketAnalysis;
	}(_react.Component);
	
	exports.default = MarketAnalysis;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _ApiService = __webpack_require__(4);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _MgBusinessCaseContent = __webpack_require__(598);
	
	var _MgBusinessCaseContent2 = _interopRequireDefault(_MgBusinessCaseContent);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalPMDecisionsPlacement = function (_Component) {
	  _inherits(ModalPMDecisionsPlacement, _Component);
	
	  function ModalPMDecisionsPlacement(props) {
	    _classCallCheck(this, ModalPMDecisionsPlacement);
	
	    var _this = _possibleConstructorReturn(this, (ModalPMDecisionsPlacement.__proto__ || Object.getPrototypeOf(ModalPMDecisionsPlacement)).call(this, props));
	
	    _this.showPopup = function () {
	      _this.eventemitter.trigger("coaching-feedback", ['Food for Thought', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Very interesting!"
	        ),
	        _react2.default.createElement("br", null),
	        "You chose to sell through an online distributor instead of direct selling for one or more of your products."
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Please double check ",
	        _react2.default.createElement(
	          "a",
	          { href: "/analysis/bcase/market", target: "_blank" },
	          "The Market"
	        ),
	        " section of the business case just to make sure you fully understand the impact of this decision."
	      )]);
	    };
	
	    _this.openModal = function () {
	      if (_this.props.tourMode === true) {
	        _this.showModalTour();
	        return;
	      }
	
	      _this.showModal();
	    };
	
	    _this.rerender = function () {
	      _this.forceUpdate();
	    };
	
	    _this.showModalTour = function () {
	      // do nothing
	    };
	
	    _this.showModal = function () {
	      if (_this.props.tourMode === true) {
	        window.$("#myModalDecisionsPlacement").data("bs.modal", null);
	        window.$("#myModalDecisionsPlacement").modal({
	          keyboard: false,
	          backdrop: "static",
	          show: true
	        });
	        return;
	      }
	
	      if (_this.props.hasAccess === true) {
	        window.$("#myModalDecisionsPlacement").data("bs.modal", null);
	        window.$("#myModalDecisionsPlacement").modal("show");
	      } else {
	        _this.props.showRoleAlert();
	      }
	    };
	
	    _this.hideModal = function () {
	      window.$("#myModalDecisionsPlacement").modal("hide");
	    };
	
	    _this.updateSale = function (data, sale_id) {
	      return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "team/sales/" + sale_id + "/").send(data);
	    };
	
	    _this.updateClient = function (e) {
	      var select = e.target;
	      var products = _this.state.products;
	      var id = parseInt(select.dataset.id, 10);
	      var value = parseInt(select.value, 10);
	
	      if (id in products) {
	        products[id].client = value;
	
	        _this.setState({
	          products: products
	        });
	      }
	    };
	
	    _this.updateSales = function () {
	      if (_this.props.tourMode === true) {
	        // do nothing
	        return;
	      }
	
	      _this.setState({
	        isSaving: true
	      });
	
	      var requests = [];
	
	      Object.keys(_this.state.products).forEach(function (product_id) {
	        product_id = parseInt(product_id, 10);
	
	        var product = _this.state.products[product_id];
	        var client_id = product.client;
	        if (client_id === 0) {
	          client_id = _this.props.sales_clients["Direct Sales"];
	        }
	
	        var data = {
	          product: product_id,
	          client: client_id
	        };
	
	        if (product.sale_id > 0) {
	          requests.push(_this.updateSale(data, product.sale_id));
	        } else {
	          requests.push(_this.createSale(data));
	        }
	      });
	
	      var joinRequest = Promise.all(requests);
	
	      joinRequest.then(function (res) {
	        var popupShown = res.filter(function (i) {
	          return i.body.client === 4;
	        }).length > 0;
	        if (popupShown) {
	          _this.showPopup();
	        }
	
	        _this.setState({
	          isSaving: false
	        }, function () {
	          _this.props.showSuccessMessage('New sales decision was successfully set for your product(s)');
	          (0, _SubmitDecisions.incrementUnacceptedDecisions)("marketing");
	          window.$("#myModalDecisionsPlacement").modal("hide");
	          _this.props.reloadData();
	          _this.props.getSubmissionData();
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ModalPMDecisionsPlacement", "updateSales");
	      });
	    };
	
	    _this.state = {
	      products: props.products,
	      isSaving: false
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ModalPMDecisionsPlacement, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("product-marketing-show-modal3", this.showModal);
	      this.eventemitter.on("product-marketing-hide-modal3", this.hideModal);
	      this.eventemitter.on("product-marketing-force-update3", this.rerender);
	      this.eventemitter.on("pm-decisions-open-modal3", this.openModal);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("product-marketing-show-modal3", this.showModal);
	      this.eventemitter.off("product-marketing-hide-modal3", this.hideModal);
	      this.eventemitter.off("product-marketing-force-update3", this.rerender);
	      this.eventemitter.off("pm-decisions-open-modal3", this.openModal);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.products !== nextProps.products) {
	        this.setState({
	          products: nextProps.products
	        });
	      }
	    }
	  }, {
	    key: "createSale",
	    value: function createSale(data) {
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/sales/").send(data);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isSaving = this.state.isSaving;
	      var modalClassName = "modal fade";
	      if (this.props.tourMode === true) {
	        modalClassName = "modal";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: modalClassName,
	          id: "myModalDecisionsPlacement",
	          tabIndex: "-1",
	          role: "dialog",
	          "aria-labelledby": "myModalLabel",
	          "aria-hidden": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "modal-dialog" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-content" },
	            _react2.default.createElement(
	              "div",
	              {
	                id: "product-marketing-placement-header",
	                className: "modal-header"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-7" },
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "modal-title title-light-blue",
	                      id: "myModalLabel"
	                    },
	                    "Sales Channel",
	                    _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                      iconSize: "xs"
	                    }, _MgBusinessCaseContent2.default.SALES_SPEND))
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-body" },
	              _react2.default.createElement(
	                "div",
	                { className: "table-responsive mt-20" },
	                _react2.default.createElement(
	                  "table",
	                  { className: "table" },
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      { className: "border-none" },
	                      _react2.default.createElement(
	                        "th",
	                        { className: "text-center" },
	                        "Product Name"
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { className: "text-center" },
	                        "Sales Channel"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    Object.keys(this.state.products).map(function (product_id) {
	                      var product = _this2.state.products[product_id];
	
	                      return _react2.default.createElement(
	                        "tr",
	                        {
	                          className: "text-center border-none",
	                          key: product_id
	                        },
	                        _react2.default.createElement(
	                          "th",
	                          { className: "middle text-center" },
	                          "Product ",
	                          product.name
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { className: "text-center" },
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              "data-id": product_id,
	                              onChange: _this2.updateClient,
	                              value: product.client
	                            },
	                            _react2.default.createElement(
	                              "option",
	                              {
	                                value: _this2.props.sales_clients["Direct Sales"]
	                              },
	                              "Direct Sales"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              {
	                                value: _this2.props.sales_clients["Distributors"]
	                              },
	                              "Distributors"
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-footer text-center" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-cancel",
	                  "data-dismiss": "modal",
	                  disabled: this.props.tourMode
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  id: "product-marketing-placement-save",
	                  className: "btn btn-save",
	                  disabled: this.isSaveDisabled,
	                  onClick: !isSaving ? this.updateSales : null
	                },
	                isSaving ? "Saving..." : "Save"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "isSaveDisabled",
	    get: function get() {
	      if (this.props.tourMode === false) {
	        return this.state.isSaving;
	      }
	
	      return true;
	    }
	  }]);
	
	  return ModalPMDecisionsPlacement;
	}(_react.Component);
	
	exports.default = ModalPMDecisionsPlacement;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PromoSpendInputMasking = __webpack_require__(1346);
	
	var _PromoSpendInputMasking2 = _interopRequireDefault(_PromoSpendInputMasking);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _ApiService = __webpack_require__(4);
	
	var _HelpIconButtonWithTooltipAndTypeformModal = __webpack_require__(36);
	
	var _HelpIconButtonWithTooltipAndTypeformModal2 = _interopRequireDefault(_HelpIconButtonWithTooltipAndTypeformModal);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _MgBusinessCaseContent = __webpack_require__(598);
	
	var _MgBusinessCaseContent2 = _interopRequireDefault(_MgBusinessCaseContent);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INPUT_MIN_VALUE = 0;
	var INPUT_MAX_VALUE = 99999999;
	var DEFAULT_DIGITAL = 100000;
	var DEFAULT_TRADITIONAL = 100000;
	
	var numberWithCommas = function numberWithCommas(n) {
	  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};
	
	function initProducts(products) {
	  var result = _lodash2.default.cloneDeep(products);
	
	  Object.keys(result).forEach(function (product_id) {
	    var product = result[product_id];
	
	    if (product.digital_spend_id === 0 || product.player_digital === null) {
	      result[product_id].digital_spend = DEFAULT_DIGITAL;
	    }
	
	    if (product.traditional_spend_id === 0 || product.player_traditional === null) {
	      result[product_id].traditional_spend = DEFAULT_TRADITIONAL;
	    }
	  });
	
	  return result;
	}
	
	var ModalPMDecisionsPromotionalSpend = function (_Component) {
	  _inherits(ModalPMDecisionsPromotionalSpend, _Component);
	
	  function ModalPMDecisionsPromotionalSpend(props) {
	    _classCallCheck(this, ModalPMDecisionsPromotionalSpend);
	
	    var _this = _possibleConstructorReturn(this, (ModalPMDecisionsPromotionalSpend.__proto__ || Object.getPrototypeOf(ModalPMDecisionsPromotionalSpend)).call(this, props));
	
	    _this.openModal = function () {
	      if (_this.props.tourMode === true) {
	        _this.showModalTour();
	        return;
	      }
	
	      _this.showModal();
	    };
	
	    _this.showPopup = function (spend) {
	      _this.eventemitter.trigger("coaching-feedback", ['Food for Thought', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Uh Oh! Very low promo!"
	        ),
	        _react2.default.createElement("br", null),
	        "You should double check the ",
	        _react2.default.createElement(
	          "a",
	          { href: "/analysis/bcase", target: "_blank" },
	          "business case"
	        ),
	        " to see what others have spent on their marketing budget."
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "You don't have to spend the same amount as others, but it's in your best interests to spend more than $",
	        numberWithCommas(spend),
	        " if this is the first time promoting this product."
	      )]);
	    };
	
	    _this.rerender = function () {
	      _this.forceUpdate();
	    };
	
	    _this.showModalTour = function () {
	      // do nothing
	    };
	
	    _this.showModal = function () {
	      if (_this.props.tourMode === true) {
	        window.$("#myModalDecisionsPromotionalSpend").data("bs.modal", null);
	        window.$("#myModalDecisionsPromotionalSpend").modal({
	          keyboard: false,
	          backdrop: "static",
	          show: true
	        });
	        return;
	      }
	
	      if (_this.props.hasAccess === true) {
	        window.$("#myModalDecisionsPromotionalSpend").data("bs.modal", null);
	        window.$("#myModalDecisionsPromotionalSpend").modal("show");
	      } else {
	        _this.props.showRoleAlert();
	      }
	    };
	
	    _this.hideModal = function () {
	      window.$("#myModalDecisionsPromotionalSpend").modal("hide");
	    };
	
	    _this.updateState = function (e, nonFormattedValue) {
	      var input = e.target;
	      var value = nonFormattedValue.floatValue;
	      var name = input.dataset.name;
	      var productId = parseInt(input.dataset.productId, 10);
	      var products = _this.state.products;
	
	      if (productId in products) {
	        if (value < INPUT_MIN_VALUE) {
	          value = INPUT_MIN_VALUE;
	        }
	
	        if (value > INPUT_MAX_VALUE) {
	          value = INPUT_MAX_VALUE;
	        }
	
	        if (name === "traditionalMarketing") {
	          products[productId].traditional_spend = value;
	
	          _this.setState({
	            products: products
	          });
	        } else if (name === "digitalMarketing") {
	          products[productId].digital_spend = value;
	
	          _this.setState({
	            products: products
	          });
	        }
	      }
	    };
	
	    _this.updateProduct = function (e) {
	      if (_this.props.tourMode === true) {
	        // do nothing
	        return;
	      }
	
	      _this.setState({
	        isSaving: true
	      });
	
	      var requests = [];
	
	      Object.keys(_this.state.products).forEach(function (product_id) {
	        var product = _this.state.products[product_id];
	
	        var data_traditional = {
	          client: _this.props.marketing_clients["Traditional Marketing"],
	          spend: parseInt(product.traditional_spend, 10),
	          product: parseInt(product_id, 10)
	        };
	
	        var data_digital = {
	          client: _this.props.marketing_clients["Digital Marketing"],
	          spend: parseInt(product.digital_spend, 10),
	          product: parseInt(product_id, 10)
	        };
	
	        if (product.traditional_spend_id > 0) {
	          requests.push(_this.updatePromo(data_traditional, product.traditional_spend_id));
	        } else {
	          requests.push(_this.createPromo(data_traditional));
	        }
	
	        if (product.digital_spend_id > 0) {
	          requests.push(_this.updatePromo(data_digital, product.digital_spend_id));
	        } else {
	          requests.push(_this.createPromo(data_digital));
	        }
	      });
	
	      var joinRequest = Promise.all(requests);
	
	      joinRequest.then(function (res) {
	        var data = (0, _lodash.map)(res, function (item) {
	          return {
	            client: item.body.client,
	            spend: item.body.spend
	          };
	        });
	        var client = data.find(function (i) {
	          return i.client === 1;
	        });
	        if (client && client.spend <= 200000) {
	          _this.showPopup(client.spend);
	        }
	
	        _this.setState({
	          isSaving: false
	        }, function () {
	          _this.props.showSuccessMessage('New promo decision was successfully set for your product(s)');
	          (0, _SubmitDecisions.incrementUnacceptedDecisions)("marketing");
	          window.$("#myModalDecisionsPromotionalSpend").modal("hide");
	          _this.props.reloadData();
	          _this.props.getSubmissionData();
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ModalPMDecisionsPromotionalSpend", "updateProduct");
	      });
	    };
	
	    _this.state = {
	      products: initProducts(props.products),
	      original_products: props.products,
	      isSaving: false,
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ModalPMDecisionsPromotionalSpend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("product-marketing-show-modal2", this.showModal);
	      this.eventemitter.on("product-marketing-hide-modal2", this.hideModal);
	      this.eventemitter.on("product-marketing-force-update2", this.rerender);
	      this.eventemitter.on("pm-decisions-open-modal2", this.openModal);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("product-marketing-show-modal2", this.showModal);
	      this.eventemitter.off("product-marketing-hide-modal2", this.hideModal);
	      this.eventemitter.off("product-marketing-force-update2", this.rerender);
	      this.eventemitter.off("pm-decisions-open-modal2", this.openModal);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.currentRound !== nextProps.currentRound || this.state.roundInUrl !== nextProps.roundInUrl || this.state.rounds.length === 0 && nextProps.rounds.length !== 0 || this.state.original_products !== nextProps.products) {
	        this.setState({
	          products: initProducts(nextProps.products),
	          original_products: nextProps.products,
	          currentRound: nextProps.currentRound,
	          roundInUrl: nextProps.roundInUrl,
	          rounds: nextProps.rounds
	        });
	      }
	    }
	  }, {
	    key: "createPromo",
	    value: function createPromo(data) {
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/promos/").send(data);
	    }
	  }, {
	    key: "updatePromo",
	    value: function updatePromo(data, promo_id) {
	      return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "team/promos/" + promo_id + "/").send(data);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isSaving = this.state.isSaving;
	      var modalClassName = "modal fade";
	      if (this.props.tourMode === true) {
	        modalClassName = "modal";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: modalClassName,
	          id: "myModalDecisionsPromotionalSpend",
	          tabIndex: "-1",
	          role: "dialog",
	          "aria-labelledby": "myModalLabel",
	          "aria-hidden": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "modal-dialog modal-dialog-bigger" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-content" },
	            _react2.default.createElement(
	              "div",
	              {
	                id: "product-marketing-promo-spend-header",
	                className: "modal-header"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-7" },
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "modal-title title-light-blue",
	                      id: "myModalLabel"
	                    },
	                    "Promotional Spend",
	                    _react2.default.createElement(_HelpIconButtonWithTooltipAndTypeformModal2.default, Object.assign({
	                      iconSize: "xs"
	                    }, _MgBusinessCaseContent2.default.PROMOTIONAL_SPEND))
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-body" },
	              _react2.default.createElement(
	                "div",
	                { className: "table-responsive mt-20" },
	                _react2.default.createElement(
	                  "form",
	                  { id: "form-promotional" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        { className: "border-none" },
	                        _react2.default.createElement(
	                          "th",
	                          { className: "text-center" },
	                          _react2.default.createElement("span", null)
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { className: "text-center" },
	                          _react2.default.createElement(
	                            "span",
	                            null,
	                            "Traditional Marketing"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { className: "text-center" },
	                          _react2.default.createElement(
	                            "span",
	                            null,
	                            "Digital Marketing"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      Object.keys(this.state.products).map(function (product_id) {
	                        var product = _this2.state.products[product_id];
	
	                        return _react2.default.createElement(
	                          "tr",
	                          {
	                            className: "text-center border-none",
	                            key: product_id
	                          },
	                          _react2.default.createElement(
	                            "th",
	                            { className: "middle" },
	                            "Product ",
	                            product.name
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_PromoSpendInputMasking2.default, {
	                              name: "traditionalMarketing",
	                              productId: product_id,
	                              value: product.traditional_spend,
	                              onChange: _this2.updateState
	                            })
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(_PromoSpendInputMasking2.default, {
	                              name: "digitalMarketing",
	                              productId: product_id,
	                              value: product.digital_spend,
	                              onChange: _this2.updateState
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "modal-footer text-center" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-cancel",
	                  "data-dismiss": "modal",
	                  disabled: this.props.tourMode
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  id: "product-marketing-promo-spend-save",
	                  className: "btn btn-save",
	                  disabled: this.isSaveDisabled,
	                  onClick: !isSaving ? this.updateProduct : null
	                },
	                isSaving ? "Saving..." : "Save"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "isSaveDisabled",
	    get: function get() {
	      if (this.props.tourMode === false) {
	        return this.state.isSaving;
	      }
	
	      return true;
	    }
	  }]);
	
	  return ModalPMDecisionsPromotionalSpend;
	}(_react.Component);
	
	exports.default = ModalPMDecisionsPromotionalSpend;

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Modal = __webpack_require__(937);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactNumberFormat = __webpack_require__(60);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _utils = __webpack_require__(18);
	
	var _ApiService = __webpack_require__(4);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _Location = __webpack_require__(23);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PRICE_MIN = 0;
	var PRICE_MAX = 99.99;
	var FORECAST_MIN = 0;
	var FORECAST_MAX = 99999999;
	var DEFAULT_PRICE = 5;
	var DEFAULT_FORECAST = 100000;
	
	function initProducts(products) {
	  var result = _lodash2.default.cloneDeep(products);
	
	  Object.keys(result).forEach(function (product_id) {
	    var product = result[product_id];
	
	    if (product.forecast_id === 0 || product.player === null) {
	      result[product_id].price = DEFAULT_PRICE;
	      result[product_id].forecast = DEFAULT_FORECAST;
	    } else if (product.price === 0) {
	      result[product_id].price = DEFAULT_PRICE;
	    }
	  });
	
	  return result;
	}
	
	var ModalPMDecisionsRevenueForecast = function (_Component) {
	  _inherits(ModalPMDecisionsRevenueForecast, _Component);
	
	  function ModalPMDecisionsRevenueForecast(props) {
	    _classCallCheck(this, ModalPMDecisionsRevenueForecast);
	
	    var _this = _possibleConstructorReturn(this, (ModalPMDecisionsRevenueForecast.__proto__ || Object.getPrototypeOf(ModalPMDecisionsRevenueForecast)).call(this, props));
	
	    _this.goToCustomerAnalysis = function (e) {
	      e.preventDefault();
	      _this.eventemitter.trigger("coaching-feedback-hide");
	      (0, _Location.changeLocation)("/ceo/analysis/market");
	    };
	
	    _this.showPopup = function () {
	      _this.eventemitter.trigger("coaching-feedback", ['Food for Thought', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Wow! You're looking to crush it this year!"
	        ),
	        _react2.default.createElement("br", null),
	        "But are you sure any mobile customer is willing to pay that high price for this product"
	      ), 'If so, how many units will the customer buy? I doubt any auto customers will buy', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Before pricing your product, please double check ",
	        _react2.default.createElement(
	          "a",
	          { href: "/ceo/analysis/market", onClick: _this.goToCustomerAnalysis },
	          "customer analysis"
	        ),
	        " to gain a better understanding of your customers needs/wants... you're welcome!"
	      )]);
	    };
	
	    _this.showPopup2 = function () {
	      _this.eventemitter.trigger("coaching-feedback", ['Food for Thought', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Wow! You're looking to crush it this year!"
	        ),
	        _react2.default.createElement("br", null),
	        "But are you sure any customer is willing to pay that high price for this product"
	      ), 'If so, how many units will the customer buy?', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        "Before pricing your product, please double check ",
	        _react2.default.createElement(
	          "a",
	          { href: "/ceo/analysis/market", onClick: _this.goToCustomerAnalysis },
	          "customer analysis"
	        ),
	        " to gain a better understanding of your customers needs/wants... you're welcome!"
	      )]);
	    };
	
	    _this.showPopup3 = function () {
	      _this.eventemitter.trigger("coaching-feedback", ['Food for Thought', 'I see what you\'re doing! Low prices, higher demand for your product. Econ 101, I get it...but you should consider a few things.', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Is the price too low?"
	        ),
	        _react2.default.createElement("br", null),
	        "At a certain low price point, customers might think your product must not be good and won\u2019t buy."
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "How much of a Gross Margin (GM) will you make on each unit sold?"
	        ),
	        _react2.default.createElement("br", null),
	        "GM = (Selling Price - Unit Costs) / Selling Price. GM is also a key grading metric."
	      )]);
	    };
	
	    _this.showPopup4 = function () {
	      _this.eventemitter.trigger("coaching-feedback", ['Food for Thought', 'I see what you\'re doing! Low prices, higher demand for your product. Econ 101, I get it...but you should consider a few things.', _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Is the price too low?"
	        ),
	        _react2.default.createElement("br", null),
	        "At a certain low price point, customers might think your product must not be good and won\u2019t buy."
	      ), _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "How much of a Gross Margin (GM) will you make on each unit sold?"
	        ),
	        _react2.default.createElement("br", null),
	        "GM = (Selling Price - Unit Costs) / Selling Price. GM is also a key grading metric."
	      )]);
	    };
	
	    _this.openModal = function () {
	      if (_this.props.tourMode === true) {
	        _this.showModalTour();
	        return;
	      }
	
	      _this.showModalDecisionsPricing();
	    };
	
	    _this.rerender = function () {
	      _this.forceUpdate();
	    };
	
	    _this.showModalTour = function () {
	      // do nothing
	    };
	
	    _this.showModalDecisionsPricing = function () {
	      if (_this.props.tourMode === true) {
	        window.$("#modalDecisionsPricing").data("bs.modal", null);
	        window.$("#modalDecisionsPricing").modal({
	          keyboard: false,
	          backdrop: "static",
	          show: true
	        });
	        return;
	      }
	
	      if (_this.props.hasAccess === true) {
	        window.$("#modalDecisionsPricing").data("bs.modal", null);
	        window.$("#modalDecisionsPricing").modal("show");
	      } else {
	        _this.props.showRoleAlert();
	      }
	    };
	
	    _this.hideModalDecisionsPricing = function () {
	      window.$("#modalDecisionsPricing").modal("hide");
	    };
	
	    _this.updateForecastRevenue = function (e) {
	      if (_this.props.tourMode === true) {
	        // do nothing
	        return;
	      }
	
	      _this.setState({
	        isSaving: true
	      });
	
	      var requests = [];
	
	      var productValidations = {};
	      var isEveryProductValid = true;
	
	      Object.keys(_this.state.products).forEach(function (product_id) {
	        var product = _this.state.products[product_id];
	
	        var productValidation = _this.validatePriceAndForecast(product_id, product);
	        Object.assign(productValidations, productValidation);
	        isEveryProductValid = isEveryProductValid && productValidation;
	        if (!isEveryProductValid) {
	          // don't send requests if any product is invalid
	          return;
	        }
	
	        var data = {
	          product: product_id,
	          price: product.price,
	          forecast: product.forecast
	        };
	
	        if (product.forecast_id > 0) {
	          requests.push(_this.updateForecast(data, product.forecast_id));
	        } else {
	          requests.push(_this.createForecast(data));
	        }
	      });
	
	      _this.setState({ productValidations: productValidations });
	      if (!_this.isEveryProductValid(productValidations)) {
	        _this.setState({ isSaving: false });
	        // return early rather than wait on requests if any product is invalid
	        return;
	      }
	
	      var joinRequest = Promise.all(requests);
	
	      joinRequest.then(function (res) {
	        var high_price_mobile_feedback = (0, _lodash.map)(res, "body.high_price_mobile_feedback").filter(function (i) {
	          return i === 1;
	        }).length > 0;
	        var high_price_auto_feedback = (0, _lodash.map)(res, "body.high_price_auto_feedback").filter(function (i) {
	          return i === 1;
	        }).length > 0;
	        var price = (0, _lodash.map)(res, "body.price").filter(function (i) {
	          return i <= 5;
	        }).length > 0;
	        var low_price_auto_feedback = (0, _lodash.map)(res, "body.low_price_auto_feedback").filter(function (i) {
	          return i === 1;
	        }).length > 0;
	
	        if (high_price_mobile_feedback === true) {
	          _this.showPopup();
	        } else if (high_price_auto_feedback === true) {
	          _this.showPopup2();
	        } else if (price === true) {
	          _this.showPopup3();
	        } else if (low_price_auto_feedback === true) {
	          _this.showPopup4();
	        }
	
	        _this.setState({
	          isSaving: false,
	          showModalDecisionsPricing: false
	        }, function () {
	          _this.props.showSuccessMessage('New price forecast was successfully set for your product(s)');
	          (0, _SubmitDecisions.incrementUnacceptedDecisions)("marketing");
	          _this.hideModalDecisionsPricing();
	          _this.props.reloadData();
	          _this.props.getSubmissionData();
	        });
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "ModalPMDecisionsRevenueForecast", "updateForecastRevenue");
	      });
	    };
	
	    _this.updateState = function (e, nonFormattedValue) {
	      var input = e.target;
	      // use floatValue if nonFormattedValue is an object, otherwise parseFloat
	      var value = nonFormattedValue instanceof Object && nonFormattedValue.floatValue || parseFloat(nonFormattedValue);
	      var key = input.dataset.name;
	      var productId = parseInt(input.dataset.productId, 10);
	      var products = _this.state.products;
	
	      if (productId in products) {
	        if (key in products[productId]) {
	          products[productId][key] = value;
	
	          _this.setState({ products: products });
	        }
	      }
	    };
	
	    _this.state = {
	      products: initProducts(props.products),
	      original_products: props.products,
	      isSaving: false,
	      productValidations: {},
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(ModalPMDecisionsRevenueForecast, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventemitter.on("product-marketing-show-modal", this.showModalDecisionsPricing);
	      this.eventemitter.on("product-marketing-hide-modal", this.hideModalDecisionsPricing);
	      this.eventemitter.on("product-marketing-force-update", this.rerender);
	      this.eventemitter.on("pm-decisions-open-modal", this.openModal);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("product-marketing-show-modal", this.showModalDecisionsPricing);
	      this.eventemitter.off("product-marketing-hide-modal", this.hideModalDecisionsPricing);
	      this.eventemitter.off("product-marketing-force-update", this.rerender);
	      this.eventemitter.off("pm-decisions-open-modal", this.openModal);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.currentRound !== nextProps.currentRound || this.state.roundInUrl !== nextProps.roundInUrl || this.state.rounds.length === 0 && nextProps.rounds.length !== 0 || this.state.original_products !== nextProps.products) {
	        this.setState({
	          products: initProducts(nextProps.products),
	          original_products: nextProps.products,
	          currentRound: nextProps.currentRound,
	          roundInUrl: nextProps.roundInUrl,
	          rounds: nextProps.rounds
	        });
	      }
	    }
	  }, {
	    key: "createForecast",
	    value: function createForecast(data) {
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/price_forecasts/").send(data);
	    }
	  }, {
	    key: "updateForecast",
	    value: function updateForecast(data, forecast_id) {
	      return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "team/price_forecasts/" + forecast_id + "/").send(data);
	    }
	  }, {
	    key: "validatePriceAndForecast",
	    value: function validatePriceAndForecast(product_id, product) {
	      var price = product.price,
	          forecast = product.forecast;
	
	
	      var isPriceValid = price >= PRICE_MIN && price <= PRICE_MAX;
	      var isForecastValid = forecast >= FORECAST_MIN && forecast <= FORECAST_MAX;
	
	      return _defineProperty({}, product_id, { isPriceValid: isPriceValid, isForecastValid: isForecastValid });
	    }
	  }, {
	    key: "isEveryProductValid",
	    value: function isEveryProductValid(productValidations) {
	      return _lodash2.default.every(productValidations, function (productValidation) {
	        return _lodash2.default.every(productValidation);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isSaving = this.state.isSaving;
	      var modalClassName = "modal fade";
	      if (this.props.tourMode === true) {
	        modalClassName = "modal";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: modalClassName,
	          id: "modalDecisionsPricing",
	          tabIndex: "-1",
	          role: "dialog",
	          "aria-labelledby": "myModalLabel",
	          "aria-hidden": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "modal-dialog modal-dialog-bigger" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-content" },
	            _react2.default.createElement(
	              _Modal2.default.Header,
	              { id: "product-marketing-revenue-forecast-header" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-7" },
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "modal-title title-light-blue",
	                      id: "myModalLabel"
	                    },
	                    "Products"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xs-5" },
	                  _react2.default.createElement(
	                    "p",
	                    { className: "modal-p" },
	                    "Revenue Forecast"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Modal2.default.Body,
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "table-responsive mt-20" },
	                _react2.default.createElement(
	                  "table",
	                  { className: "table" },
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      "tr",
	                      { className: "border-none" },
	                      _react2.default.createElement(
	                        "th",
	                        { className: "text-center" },
	                        _react2.default.createElement("span", null)
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { className: "text-center" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Price"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "th",
	                        { className: "text-center" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Units Forecast"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    Object.keys(this.state.products).map(function (product_id) {
	                      var product = _this2.state.products[product_id];
	                      var validations = _this2.state.productValidations[product_id];
	                      var defaultValidations = {
	                        isPriceValid: true,
	                        isForecastValid: true
	                      };
	
	                      var _ref2 = validations ? validations : defaultValidations,
	                          isPriceValid = _ref2.isPriceValid,
	                          isForecastValid = _ref2.isForecastValid;
	
	                      return _react2.default.createElement(
	                        "tr",
	                        {
	                          className: "text-center border-none",
	                          key: product_id
	                        },
	                        _react2.default.createElement(
	                          "th",
	                          { className: "middle" },
	                          "Product ",
	                          product.name
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement(_reactNumberFormat2.default, {
	                            "data-product-id": product_id,
	                            "data-name": "price",
	                            prefix: "$",
	                            thousandSeparator: ",",
	                            decimalSeparator: ".",
	                            decimalPrecision: 2,
	                            value: product.price,
	                            onChange: _this2.updateState,
	                            className: isPriceValid ? "" : "invalid"
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement(_reactNumberFormat2.default, {
	                            "data-product-id": product_id,
	                            "data-name": "forecast",
	                            thousandSeparator: ",",
	                            value: product.forecast,
	                            onChange: _this2.updateState,
	                            className: isForecastValid ? "" : "invalid"
	                          })
	                        )
	                      );
	                    })
	                  )
	                ),
	                !this.isEveryProductValid(this.state.productValidations) ? _react2.default.createElement(
	                  "span",
	                  { style: { color: "#a94442" } },
	                  "Price must be between ",
	                  PRICE_MIN,
	                  " and ",
	                  PRICE_MAX,
	                  ", and forecast must be between ",
	                  FORECAST_MIN,
	                  " and ",
	                  FORECAST_MAX
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _Modal2.default.Footer,
	              null,
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  className: "btn btn-cancel",
	                  onClick: this.hideModalDecisionsPricing,
	                  disabled: this.props.tourMode
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  id: "product-marketing-revenue-forecast-save",
	                  className: "btn btn-save",
	                  disabled: this.isSaveDisabled,
	                  onClick: !isSaving ? this.updateForecastRevenue : null
	                },
	                isSaving ? "Saving..." : "Save"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "isSaveDisabled",
	    get: function get() {
	      if (this.props.tourMode === false) {
	        return this.state.isSaving;
	      }
	
	      return true;
	    }
	  }]);
	
	  return ModalPMDecisionsRevenueForecast;
	}(_react.Component);
	
	exports.default = ModalPMDecisionsRevenueForecast;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactLoaders2 = _interopRequireDefault(_reactLoaders);
	
	var _lodash = __webpack_require__(21);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _ApiService = __webpack_require__(4);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _utils = __webpack_require__(18);
	
	var _roleButtons = __webpack_require__(258);
	
	var _roleButtons2 = _interopRequireDefault(_roleButtons);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _roundNotStarted = __webpack_require__(259);
	
	var _roundNotStarted2 = _interopRequireDefault(_roundNotStarted);
	
	var _firstDecisionModal = __webpack_require__(253);
	
	var _firstDecisionModal2 = _interopRequireDefault(_firstDecisionModal);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _submitDecisions = __webpack_require__(261);
	
	var _submitDecisions2 = _interopRequireDefault(_submitDecisions);
	
	var _buyingMachines = __webpack_require__(1242);
	
	var _buyingMachines2 = _interopRequireDefault(_buyingMachines);
	
	var _produceProduct = __webpack_require__(1243);
	
	var _produceProduct2 = _interopRequireDefault(_produceProduct);
	
	var _manageProductionPage = __webpack_require__(1239);
	
	var _manageProductionPage2 = _interopRequireDefault(_manageProductionPage);
	
	var _SubmitDecisions = __webpack_require__(52);
	
	var _style = __webpack_require__(255);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _style3 = __webpack_require__(78);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _reactEasyState = __webpack_require__(81);
	
	var _lastStep = __webpack_require__(254);
	
	var _lastStep2 = _interopRequireDefault(_lastStep);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _selectFacility = __webpack_require__(1240);
	
	var _selectFacility2 = _interopRequireDefault(_selectFacility);
	
	var _newMapWithoutButtons = __webpack_require__(1059);
	
	var _newMapWithoutButtons2 = _interopRequireDefault(_newMapWithoutButtons);
	
	var _mapIcon = __webpack_require__(2617);
	
	var _mapIcon2 = _interopRequireDefault(_mapIcon);
	
	var _mapIcon3 = __webpack_require__(2618);
	
	var _mapIcon4 = _interopRequireDefault(_mapIcon3);
	
	var _mapIcon5 = __webpack_require__(2619);
	
	var _mapIcon6 = _interopRequireDefault(_mapIcon5);
	
	var _mapIcon7 = __webpack_require__(2620);
	
	var _mapIcon8 = _interopRequireDefault(_mapIcon7);
	
	var _mapIcon9 = __webpack_require__(2621);
	
	var _mapIcon10 = _interopRequireDefault(_mapIcon9);
	
	var _mapIcon11 = __webpack_require__(2622);
	
	var _mapIcon12 = _interopRequireDefault(_mapIcon11);
	
	var _mapIcon13 = __webpack_require__(2623);
	
	var _mapIcon14 = _interopRequireDefault(_mapIcon13);
	
	var _mapIcon15 = __webpack_require__(2624);
	
	var _mapIcon16 = _interopRequireDefault(_mapIcon15);
	
	var _mapLines = __webpack_require__(2625);
	
	var _mapLines2 = _interopRequireDefault(_mapLines);
	
	var _mapLines3 = __webpack_require__(2626);
	
	var _mapLines4 = _interopRequireDefault(_mapLines3);
	
	var _mapLines5 = __webpack_require__(2627);
	
	var _mapLines6 = _interopRequireDefault(_mapLines5);
	
	var _tooltipImage = __webpack_require__(2676);
	
	var _tooltipImage2 = _interopRequireDefault(_tooltipImage);
	
	var _mapHoverIcon = __webpack_require__(2613);
	
	var _mapHoverIcon2 = _interopRequireDefault(_mapHoverIcon);
	
	var _mapHoverIcon3 = __webpack_require__(2614);
	
	var _mapHoverIcon4 = _interopRequireDefault(_mapHoverIcon3);
	
	var _mapHoverIcon5 = __webpack_require__(2615);
	
	var _mapHoverIcon6 = _interopRequireDefault(_mapHoverIcon5);
	
	var _mapHoverIcon7 = __webpack_require__(2616);
	
	var _mapHoverIcon8 = _interopRequireDefault(_mapHoverIcon7);
	
	var _smallCheckbox = __webpack_require__(1067);
	
	var _smallCheckbox2 = _interopRequireDefault(_smallCheckbox);
	
	var _smallCheckboxActive = __webpack_require__(1066);
	
	var _smallCheckboxActive2 = _interopRequireDefault(_smallCheckboxActive);
	
	var _format = __webpack_require__(63);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _warning = __webpack_require__(138);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import GoogleMapReact from "google-map-react";
	
	
	var tooltipsPositions = {
	  1: [205, 255],
	  2: [145, 260],
	  3: [5, 130],
	  4: [250, 138],
	  5: [5, 195],
	  6: [135, 88],
	  7: [135, 40],
	  8: [177, 62],
	  9: [205, 130],
	  10: [205, 130],
	  11: [160, 70],
	  12: [40, 110],
	  13: [95, 128],
	  14: [55, 150]
	};
	// Customer dot center positions, calibrated against the rendered map.
	// Mirrors the x/y values used inline by the <Styled.MapDot> elements
	// below — kept in sync so the SVG lead-time lines line up exactly with
	// the visible numbered dots.
	var CUSTOMER_DOT_POSITIONS = [{ id: 1, x: 377, y: 274 }, { id: 2, x: 289, y: 262 }, { id: 3, x: 37, y: 105 }, { id: 4, x: 423, y: 147 }, { id: 5, x: 42, y: 203 }, { id: 6, x: 295, y: 223 }, { id: 7, x: 269, y: 188 }, { id: 8, x: 325, y: 212 }, { id: 9, x: 209, y: 178 }, { id: 10, x: 377, y: 122 }, { id: 11, x: 487, y: 134 }, { id: 12, x: 192, y: 233 }, { id: 13, x: 401, y: 198 }, { id: 14, x: 378, y: 224 }];
	
	// Distribution-center marker centers. The MapIcon styled component uses
	// top-left positioning with a 30×30 icon, so add 15 to each axis to
	// land on the visual center where lines should originate.
	var DC_CENTER_POSITIONS = {
	  1: { x: 338 + 15, y: 135 + 15 },
	  2: { x: 275 + 15, y: 208 + 15 },
	  3: { x: 111 + 15, y: 189 + 15 }
	};
	
	// Each candidate distribution center is operated by a different 3PL
	// partner. Keyed by distribution_centers_info.type (1 = Toledo,
	// 2 = Little Rock, 3 = Phoenix).
	var DC_3PL_NAMES = {
	  1: 'BXO Logistics',
	  2: 'BEVA Logistics',
	  3: 'BHL Supply Chain Logistics'
	};
	
	var customersLocations = {
	  1: 'Jackson, AL',
	  2: 'Garland, TX',
	  3: 'Happy Valley, OR',
	  4: 'Detroit, MI',
	  5: 'Fremont, CA',
	  6: 'Tulsa, OK',
	  7: 'Ellsworth, KS',
	  8: 'Springfield, MO',
	  9: 'Littleton, CO',
	  10: 'Sheboygan, WI',
	  11: 'Henrietta, NY',
	  12: 'Albuquerque, NM',
	  13: 'Jeffersontown, KY',
	  14: 'Dyersburg, TN'
	};
	
	var OperationsDecisions = function (_PureComponent) {
	  _inherits(OperationsDecisions, _PureComponent);
	
	  function OperationsDecisions(props) {
	    _classCallCheck(this, OperationsDecisions);
	
	    var _this = _possibleConstructorReturn(this, (OperationsDecisions.__proto__ || Object.getPrototypeOf(OperationsDecisions)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._isMounted = false;
	
	    var roundInUrl = props.roundInUrl,
	        currentRound = props.currentRound,
	        rounds = props.rounds;
	
	
	    var role = _Auth2.default.getRole();
	    var hasAccess = role === "CEO" || role === "OP";
	    var isOwnRole = role === "OP";
	
	    _this.state = {
	      loaded: false,
	      team_machines: [],
	      products: [],
	      isOwnRole: isOwnRole,
	      hasAccess: hasAccess,
	      submission_data: {
	        op: {
	          date: "N/A",
	          unaccepted: 0
	        }
	      },
	      submitDecisionsLoading: true,
	      loadingFactory: false,
	      factories: [],
	      overall_unit_utilization: 0,
	      operation_spending: 0,
	      operationSpendingBreakdown: [],
	      showOpsSpendingTooltip: false,
	      hoveredNotReleasedProductId: 0,
	      roundInUrl: roundInUrl,
	      currentRound: currentRound,
	      rounds: rounds,
	      selectFacilityPopupShown: false,
	      facilityPopup: null,
	      showDistributionCenters: false,
	      canSelectDistributionCenters: false,
	      activeDistributionCenter: 0,
	      distribution: null,
	      leadTimes: [],
	      leadTimesLoaded: false,
	      tooltip1: false,
	      openingDistributionCenter: false,
	      players: [],
	      distributionCenter: 0,
	      distributionCenterId: 0,
	      ownedDcTypeToTeamCenterId: {},
	      teamDistributionCentersRaw: [],
	      editingExistingDc: false,
	      distributionCentersInfo: [],
	      // Per-product inventory allocations for the currently-viewed
	      // distribution center. Keyed by product_id, value is the raw
	      // digit string in the input field. UI-only for now; partner/
	      // allocate submit fires via the Partner button below.
	      allocations: {},
	      // Hover-only state for the on-map DC tooltips. Kept separate from
	      // activeDistributionCenter (which drives the right-side panel)
	      // so the panel's title and lead-time table don't shift when the
	      // user moves their mouse onto a different DC marker.
	      hoveredDistributionCenter: 0,
	      hoveredDistribution: null,
	      // Heads Up confirmation for the Partner with Distributor button.
	      showPartnerConfirmation: false,
	      // Confirmation popup for Cancel Agreement on the Edit panel.
	      showCancelAgreementConfirmation: false,
	      // Populated when the user tries to allocate more than Max Allocation
	      // for one or more products. Array of { name, requested, available }.
	      allocationValidationError: null,
	      tooltipCustomerName: null,
	      tooltipCustomerDemand: null,
	      customerDemands: [],
	      showChangeLocationAlert: false,
	      movingDistributionCenter: false,
	      isPreChecked: false,
	      successMessage: null,
	      isInfoAlertVisible: false,
	      infoAlertTitle: '',
	      infoAlertText: '',
	      selectDistributionCenterFacilityPopup: false,
	      showDeselectLocationAlert: false,
	      inventory_balances: [],
	      inventory_allocations: [],
	      metrics_report: null,
	      prior_round_cost_per_unit: null,
	      supply_chain_assets: [],
	      machine_depreciations: [],
	      selling_price_factors: [],
	      price_forecasts: [],
	      team_products: [],
	      max_allowed_matrix: [],
	      shipping_batch_size: 0,
	      showMakeDecisionsModal: false,
	      showManageProductionPage: false,
	      // First-time coaching popup after the team's first machine
	      // purchase in Round 1. See handleFirstMachineBought below.
	      firstDecisionModalOpen: false,
	      // First-time coaching popup after the team's first production
	      // decision in Round 2 — nudges them toward the newly-available
	      // Distribution Center decisions. See handleFirstProductionInRound2.
	      firstDistributionModalOpen: false,
	      // Product id whose "delete production" confirmation is open in
	      // the Inventory Management table. null when no confirmation is
	      // showing. See requestDeleteProduction / confirmDeleteProduction.
	      deleteProductionProductId: null,
	      // Dev-only map calibration overlay. Activated by `?devmap=1` URL
	      // param. Clicking on the map logs and displays the x/y so dot
	      // positions can be hand-tuned. Not visible to normal users.
	      devMapMode: function () {
	        try {
	          return new URLSearchParams(window.location.search).get('devmap') === '1';
	        } catch (e) {
	          return false;
	        }
	      }(),
	      devMapLastClick: null
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  // Edit flow for an already-owned DC. Opens the right-side panel with
	  // the same lead-time table + per-product inputs as the new-partnership
	  // flow, but pre-fills inputs from inventory_allocations and switches
	  // the action buttons to Update / Cancel Agreement / Cancel.
	
	
	  // Update Allocation button on the Edit panel. Skips Call 1 (POST
	  // team-centers) since the team-center already exists, and just PUTs
	  // the new allocations array.
	
	
	  // Cancel Agreement on the Edit panel. Pins the team-center id to the
	  // one being edited (so multi-DC teams sell the right record) and opens
	  // the confirmation popup.
	
	
	  // Hover-driven DC tooltip:
	  //   onMouseEnter on marker  → hoverDistributionCenter(N)   (show tooltip)
	  //   onMouseLeave on marker  → unhoverDistributionCenter    (queue close)
	  //   onMouseEnter on tooltip → cancelDistributionCenterUnhover (stay open)
	  //   onMouseLeave on tooltip → unhoverDistributionCenter    (close after delay)
	  // The 400ms close delay lets the user move from the marker into the
	  // tooltip without it disappearing in between.
	
	
	  // Per-product allocation input handler. Strips non-digits and stores
	  // the cleaned value under the product_id key.
	
	
	  // Heads Up confirmation flow for Partner with Distributor.
	
	
	  _createClass(OperationsDecisions, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.state.roundInUrl !== nextProps.roundInUrl || this.state.currentRound !== nextProps.currentRound || this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	          _this2.reloadRole();
	        });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.fetchData();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      if (this._dcCloseTimer) clearTimeout(this._dcCloseTimer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      // Lock the page only when no round has ever been started.
	      // Does not fire for finished games (see ceo-decisions.js for the
	      // full explanation).
	      var hasEverStarted = (this.props.rounds || []).some(function (r) {
	        return r && r.is_started === true;
	      });
	      if (this.props.rounds_loaded && !hasEverStarted) {
	        return _react2.default.createElement(_roundNotStarted2.default, null);
	      }
	
	      var showActionButtons = this.showActionButtons;
	      var _state = this.state,
	          products = _state.products,
	          isOwnRole = _state.isOwnRole,
	          loaded = _state.loaded,
	          submission_data = _state.submission_data,
	          submitDecisionsLoading = _state.submitDecisionsLoading,
	          loadingFactory = _state.loadingFactory,
	          currentRound = _state.currentRound,
	          rounds = _state.rounds,
	          overall_unit_utilization = _state.overall_unit_utilization,
	          operation_spending = _state.operation_spending,
	          operationSpendingBreakdown = _state.operationSpendingBreakdown,
	          showOpsSpendingTooltip = _state.showOpsSpendingTooltip,
	          hoveredNotReleasedProductId = _state.hoveredNotReleasedProductId,
	          factories = _state.factories,
	          selectFacilityPopupShown = _state.selectFacilityPopupShown,
	          facilityPopup = _state.facilityPopup,
	          showDistributionCenters = _state.showDistributionCenters,
	          canSelectDistributionCenters = _state.canSelectDistributionCenters,
	          activeDistributionCenter = _state.activeDistributionCenter,
	          distribution = _state.distribution,
	          leadTimes = _state.leadTimes,
	          leadTimesLoaded = _state.leadTimesLoaded,
	          tooltip1 = _state.tooltip1,
	          openingDistributionCenter = _state.openingDistributionCenter,
	          distributionCenter = _state.distributionCenter,
	          distributionCentersInfo = _state.distributionCentersInfo,
	          tooltipCustomerName = _state.tooltipCustomerName,
	          tooltipCustomerDemand = _state.tooltipCustomerDemand,
	          showChangeLocationAlert = _state.showChangeLocationAlert,
	          movingDistributionCenter = _state.movingDistributionCenter,
	          isPreChecked = _state.isPreChecked,
	          team_machines = _state.team_machines,
	          successMessage = _state.successMessage,
	          isInfoAlertVisible = _state.isInfoAlertVisible,
	          infoAlertTitle = _state.infoAlertTitle,
	          infoAlertText = _state.infoAlertText,
	          selectDistributionCenterFacilityPopup = _state.selectDistributionCenterFacilityPopup,
	          showDeselectLocationAlert = _state.showDeselectLocationAlert,
	          allocations = _state.allocations,
	          inventory_allocations = _state.inventory_allocations,
	          metrics_report = _state.metrics_report,
	          ownedDcTypeToTeamCenterId = _state.ownedDcTypeToTeamCenterId,
	          editingExistingDc = _state.editingExistingDc,
	          hoveredDistributionCenter = _state.hoveredDistributionCenter,
	          hoveredDistribution = _state.hoveredDistribution,
	          showPartnerConfirmation = _state.showPartnerConfirmation,
	          showCancelAgreementConfirmation = _state.showCancelAgreementConfirmation,
	          allocationValidationError = _state.allocationValidationError,
	          supply_chain_assets = _state.supply_chain_assets,
	          machine_depreciations = _state.machine_depreciations,
	          selling_price_factors = _state.selling_price_factors,
	          price_forecasts = _state.price_forecasts,
	          team_products = _state.team_products,
	          max_allowed_matrix = _state.max_allowed_matrix,
	          shipping_batch_size = _state.shipping_batch_size;
	      var _props = this.props,
	          tourMode = _props.tourMode,
	          location = _props.location,
	          router = _props.router,
	          round = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	      var unitUtilizationFormatted = (0, _utils.decimalsRound)(overall_unit_utilization * 100, 0);
	      var temporaryUser = _Auth2.default.getTemporaryUser();
	      var showCustomerTooltip = tooltipCustomerName !== null && tooltipCustomerDemand !== null;
	
	      // Aggregates an owned DC's committed allocations for tooltip display.
	      // Returns total units and total shipping_cost across products. Both
	      // are 0 when the DC has no commits yet.
	      var dcOwnedStats = function dcOwnedStats(dcType) {
	        var tcId = ownedDcTypeToTeamCenterId[dcType];
	        if (!tcId) return { units: 0, shipping: 0 };
	        var allocs = (inventory_allocations || []).filter(function (a) {
	          return Number(a.team_distribution_center) === Number(tcId);
	        });
	        return {
	          units: allocs.reduce(function (s, a) {
	            return s + (Number(a.units) || 0);
	          }, 0),
	          shipping: allocs.reduce(function (s, a) {
	            return s + (Number(a.shipping_cost) || 0);
	          }, 0)
	        };
	      };
	
	      return _react2.default.createElement(
	        _style2.default.BodyWrapper,
	        null,
	        isInfoAlertVisible && _react2.default.createElement(_decisions2.default, {
	          type: "info",
	          title: infoAlertTitle,
	          message: infoAlertText,
	          buttonText: "Done",
	          onHide: this.hideInfoAlert
	        }),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: showChangeLocationAlert,
	          title: "Change location?",
	          text: "You have already opened a distribution center. Continue changing to the new location?",
	          confirmButtonText: "Yes, Change Location",
	          onConfirm: function onConfirm() {
	            return _this3.openDistributionCenter();
	          },
	          cancelButtonText: "No, Keep Current Location",
	          onCancel: this.hideChangeLocationAlert,
	          showCancelButton: true
	        }),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: showDeselectLocationAlert,
	          title: "Are You Sure?",
	          text: "By choosing this option, you are deselecting the previously selected distribution center.",
	          confirmButtonText: "Yes, Change Location",
	          onConfirm: this.deleteDistributionCenter,
	          cancelButtonText: "No, Keep Current Location",
	          onCancel: this.hideDeselectLocationAlert,
	          showCancelButton: true
	        }),
	        _react2.default.createElement(_lastStep2.default, {
	          location: location,
	          router: router,
	          url: "/decisions/operations?round=" + round
	        }),
	        _react2.default.createElement(
	          _style2.default.TitleWrapper,
	          null,
	          _react2.default.createElement(
	            _style2.default.Title,
	            { id: "product-marketing-decisions-title" },
	            "Operations",
	            isOwnRole && !temporaryUser && _react2.default.createElement(_roleButtons2.default, { type: "operations" })
	          ),
	          showActionButtons === true && loaded === true && !temporaryUser && _react2.default.createElement(_submitDecisions2.default, {
	            id: "operations-decision-submit-decisions",
	            tooltipPlacement: "bottom",
	            data: submission_data.op,
	            isLoading: submitDecisionsLoading,
	            onClick: this.submitDecisions,
	            buttonComponent: _style2.default.SubmitDecisionButton,
	            isPreChecked: isPreChecked
	          })
	        ),
	        _react2.default.createElement(
	          _style2.default.Subtitle,
	          null,
	          "Manufacture image sensors and manage inventory levels & locations."
	        ),
	        showActionButtons === true && !temporaryUser && !leadTimesLoaded && _react2.default.createElement(
	          _style4.default.ManageButtonBar,
	          { style: { marginTop: 20 } },
	          _react2.default.createElement(
	            _style4.default.ManageButton,
	            {
	              onClick: this.openMakeDecisionsModal,
	              disabled: loadingFactory === true
	            },
	            loadingFactory === true ? "Loading..." : "Make Decisions"
	          )
	        ),
	        _react2.default.createElement(_buyingMachines2.default, {
	          tourMode: tourMode,
	          reloadData: this.fetchData,
	          currentRound: currentRound,
	          rounds: rounds,
	          teamId: _Teams2.default.currentTeam().id,
	          richTeamMachines: team_machines,
	          machineDepreciations: machine_depreciations,
	          sellingPriceFactors: selling_price_factors,
	          onFirstMachineBought: this.handleFirstMachineBought
	        }),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.firstDecisionModalOpen,
	          title: "Congrats on your first production line!",
	          body: "You can update this any time before the round deadline. Make sure to also make your inventory production decisions before the round ends.",
	          ctaLabel: "View Other Decisions",
	          onCta: this.handleFirstDecisionCta,
	          onClose: this.handleFirstDecisionClose
	        }),
	        _react2.default.createElement(_produceProduct2.default, {
	          products: products,
	          reloadData: this.fetchData,
	          onRemoveOperation: this.onRemoveOperation,
	          showSuccessMessage: this.showSuccessMessage,
	          currentRound: currentRound
	        }),
	        successMessage && _react2.default.createElement(_success2.default, {
	          message: successMessage
	        }),
	        loaded === true && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _style4.default.KpiRow,
	            { cardCount: 4 },
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Available Units for Sale"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                null,
	                Math.round(this.totalAvailableForSale).toLocaleString('en-US')
	              )
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Cost Per Unit"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                null,
	                "$",
	                this.avgCostPerUnit.toFixed(2)
	              ),
	              this.costPerUnitDelta && _react2.default.createElement(
	                _style2.default.KpiDelta,
	                { negative: this.costPerUnitDelta.up },
	                this.costPerUnitDelta.up ? '↑' : '↓',
	                " $",
	                Math.abs(this.costPerUnitDelta.delta).toFixed(2),
	                " vs last year"
	              )
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Production Capacity Utilization",
	                _react2.default.createElement(_style2.default.HelpIcon, {
	                  src: _iconTableHelp2.default,
	                  onClick: function onClick() {
	                    return _this3.showInfoAlert('Production Capacity Utilization');
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                null,
	                unitUtilizationFormatted,
	                "%"
	              )
	            ),
	            _react2.default.createElement(
	              _style4.default.KpiCard,
	              {
	                onMouseEnter: function onMouseEnter() {
	                  return _this3.setState({ showOpsSpendingTooltip: true });
	                },
	                onMouseLeave: function onMouseLeave() {
	                  return _this3.setState({ showOpsSpendingTooltip: false });
	                },
	                style: { position: 'relative' }
	              },
	              _react2.default.createElement(
	                _style4.default.KpiLabel,
	                null,
	                "Operation Spending"
	              ),
	              _react2.default.createElement(
	                _style4.default.KpiValue,
	                { style: { color: '#C62828' } },
	                "$",
	                Math.round(Math.abs(operation_spending)).toLocaleString('en-US')
	              ),
	              showOpsSpendingTooltip && _react2.default.createElement(
	                "div",
	                { style: {
	                    position: 'absolute',
	                    top: '100%',
	                    right: 0,
	                    marginTop: 8,
	                    background: '#fff',
	                    border: '1px solid #D5D9DD',
	                    borderRadius: 6,
	                    boxShadow: '0 4px 12px rgba(0, 27, 59, 0.12)',
	                    padding: '12px 16px',
	                    minWidth: 280,
	                    zIndex: 1000,
	                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                    fontSize: 13,
	                    color: 'rgba(0, 27, 59, 0.94)'
	                  } },
	                _react2.default.createElement(
	                  "div",
	                  { style: {
	                      fontWeight: 600,
	                      fontSize: 12,
	                      letterSpacing: '0.5px',
	                      textTransform: 'uppercase',
	                      color: 'rgba(0, 27, 59, 0.6)',
	                      marginBottom: 8
	                    } },
	                  "Spending Breakdown"
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { style: { margin: 0, padding: 0, listStyle: 'none' } },
	                  (operationSpendingBreakdown || []).map(function (item, i) {
	                    // Costs render red to match the KPI headline;
	                    // cash receipts render in the default navy so
	                    // the inflow visually separates from outflows.
	                    var rowColor = item.kind === 'receipt' ? 'rgba(0, 27, 59, 0.94)' : '#C62828';
	                    return _react2.default.createElement(
	                      "li",
	                      { key: "ops-spend-" + i, style: {
	                          display: 'flex',
	                          justifyContent: 'space-between',
	                          gap: 16,
	                          marginBottom: 4,
	                          color: rowColor
	                        } },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        item.label
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { style: { fontWeight: 600 } },
	                        "$",
	                        Math.round(item.amount).toLocaleString('en-US')
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          showDistributionCenters && _react2.default.createElement("div", { style: {
	              position: 'fixed',
	              top: 0, left: 0, right: 0, bottom: 0,
	              background: 'rgba(0, 0, 0, 0.45)',
	              zIndex: 800
	            } }),
	          _react2.default.createElement(
	            _style2.default.OpsLeadGrid,
	            null,
	            _react2.default.createElement(
	              _style2.default.OpsLeadGridMarket,
	              {
	                style: showDistributionCenters ? { position: 'relative', zIndex: 900 } : undefined
	              },
	              _react2.default.createElement(
	                _style4.default.SectionCard,
	                null,
	                _react2.default.createElement(
	                  _style4.default.SectionHeader,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.SectionTitle,
	                    null,
	                    "Market Information"
	                  ),
	                  _react2.default.createElement(
	                    _style4.default.SectionSubtitle,
	                    null,
	                    "Locations of customers, production facility, and distribution centers."
	                  )
	                ),
	                showDistributionCenters && _react2.default.createElement("div", {
	                  ref: this.setPopupRef,
	                  style: {
	                    position: 'absolute',
	                    left: 0,
	                    top: 0,
	                    width: '500px',
	                    height: '1px',
	                    visibility: 'hidden',
	                    pointerEvents: 'none'
	                  }
	                }),
	                movingDistributionCenter && _react2.default.createElement(
	                  _style2.default.TopBanner,
	                  null,
	                  "Moving distribution center..."
	                ),
	                _react2.default.createElement(
	                  _style2.default.GoogleMap,
	                  null,
	                  _react2.default.createElement("img", { src: _newMapWithoutButtons2.default, alt: "map", onClick: canSelectDistributionCenters && activeDistributionCenter || selectDistributionCenterFacilityPopup > 0 ? this.unselectDistributionCenter : null }),
	                  canSelectDistributionCenters && !activeDistributionCenter && !leadTimesLoaded && _react2.default.createElement(
	                    _style2.default.SelectDcCallout,
	                    null,
	                    "Select a Distribution Center"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 377,
	                      y: 274,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(1),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "1"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 289,
	                      y: 262,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(2),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "2"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 37,
	                      y: 105,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(3),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "3"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 423,
	                      y: 147,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(4),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "4"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 42,
	                      y: 203,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(5),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "5"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 295,
	                      y: 223,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(6),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "6"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 269,
	                      y: 188,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(7),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "7"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 325,
	                      y: 212,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(8),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "8"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 209,
	                      y: 178,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(9),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "9"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 377,
	                      y: 122,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(10),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "10"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 487,
	                      y: 134,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(11),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "11"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 192,
	                      y: 233,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(12),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "12"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 401,
	                      y: 198,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(13),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "13"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.MapDot,
	                    {
	                      x: 378,
	                      y: 224,
	                      onMouseEnter: canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(14),
	                      onMouseLeave: canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip
	                    },
	                    "14"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: showCustomerTooltip,
	                      top: showCustomerTooltip ? tooltipsPositions[tooltipCustomerName][1] : 0,
	                      left: showCustomerTooltip ? tooltipsPositions[tooltipCustomerName][0] : 0
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        showCustomerTooltip ? tooltipCustomerName : ''
	                      ),
	                      showCustomerTooltip ? customersLocations[tooltipCustomerName] : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      { background: "rgba(0, 27, 43, 0.02)" },
	                      "Customer Name: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        showCustomerTooltip ? tooltipCustomerName : ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Demand: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        showCustomerTooltip ? tooltipCustomerDemand : '',
	                        " units"
	                      )
	                    )
	                  ),
	                  factories.length > 0 && _react2.default.createElement(
	                    _style2.default.MapIcon,
	                    {
	                      x: 495,
	                      y: 145,
	                      onMouseEnter: this.showTooltip1,
	                      onMouseLeave: this.hideTooltip1,
	                      onClick: distributionCenter && canSelectDistributionCenters && activeDistributionCenter === 0 ? function () {
	                        return _this3.showSelectDistributionCenterFacilityPopup();
	                      } : null
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon4.default, alt: "map icon facilities" })
	                  ),
	                  factories.length > 0 && tooltip1 && function () {
	                    var facility = (distributionCentersInfo || []).find(function (i) {
	                      return i.type === 'facility';
	                    });
	                    var totalAvailable = (products || []).reduce(function (s, p) {
	                      return s + (Number(p.available_for_sale) || 0);
	                    }, 0);
	                    var totalAllocated = (inventory_allocations || []).reduce(function (s, a) {
	                      return s + (Number(a.units) || 0);
	                    }, 0);
	                    var inventoryAtFacility = Math.max(0, Math.round(totalAvailable - totalAllocated));
	                    return _react2.default.createElement(
	                      _style2.default.Tooltip1,
	                      {
	                        show: true,
	                        top: 100,
	                        left: 210,
	                        onMouseEnter: _this3.showTooltip1,
	                        onMouseLeave: _this3.hideTooltip1
	                      },
	                      _react2.default.createElement(
	                        _style2.default.TooltipTitle,
	                        { background: "#e8eaf0" },
	                        _react2.default.createElement("img", { src: _mapIcon4.default, alt: "facility icon" }),
	                        facility ? facility.location : ''
	                      ),
	                      _react2.default.createElement(
	                        _style2.default.TooltipCost,
	                        null,
	                        "Production Facility",
	                        _react2.default.createElement(_style2.default.TooltipSpace, null),
	                        "Inventory Allocated: ",
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          inventoryAtFacility.toLocaleString('en-US')
	                        )
	                      )
	                    );
	                  }(),
	                  factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[1] && !(leadTimesLoaded && activeDistributionCenter === 1) && _react2.default.createElement(
	                    _style2.default.GlowingMapIcon,
	                    {
	                      x: 338, y: 135,
	                      onMouseEnter: selectDistributionCenterFacilityPopup ? null : this.hoverDistributionCenter(1),
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon6.default, alt: "map icon select-center-yellow" })
	                  ),
	                  factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[1] && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: hoveredDistributionCenter === 1,
	                      top: 55,
	                      left: 80,
	                      onMouseEnter: this.cancelDistributionCenterUnhover,
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#fbedd5" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon4.default, alt: "map icon" }),
	                      hoveredDistribution ? hoveredDistribution.location : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        DC_3PL_NAMES[hoveredDistributionCenter] || ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Cost: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "$",
	                        hoveredDistribution ? (hoveredDistribution.cost / 1e6).toFixed(2) : '',
	                        "M"
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Lease Payment Terms: Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied."
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.calculateDistance },
	                        "View Details"
	                      )
	                    )
	                  ),
	                  factories.length > 0 && ownedDcTypeToTeamCenterId[1] && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: hoveredDistributionCenter === 1,
	                      top: 55,
	                      left: 80,
	                      onMouseEnter: this.cancelDistributionCenterUnhover,
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#fbedd5" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon4.default, alt: "map icon" }),
	                      hoveredDistribution ? hoveredDistribution.location : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        DC_3PL_NAMES[hoveredDistributionCenter] || ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Inventory Allocated: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        dcOwnedStats(1).units.toLocaleString('en-US')
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Transport Cost: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "$",
	                        Math.round(dcOwnedStats(1).shipping).toLocaleString('en-US')
	                      )
	                    ),
	                    showActionButtons === true && _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.editDistributionCenter(1) },
	                        "Edit"
	                      )
	                    )
	                  ),
	                  factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[2] && !(leadTimesLoaded && activeDistributionCenter === 2) && _react2.default.createElement(
	                    _style2.default.GlowingMapIcon,
	                    {
	                      x: 275, y: 208,
	                      onMouseEnter: selectDistributionCenterFacilityPopup ? null : this.hoverDistributionCenter(2),
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon8.default, alt: "map icon select-center-purple" })
	                  ),
	                  factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[2] && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: hoveredDistributionCenter === 2,
	                      top: 10,
	                      left: 175,
	                      onMouseEnter: this.cancelDistributionCenterUnhover,
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#eae4f9" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon6.default, alt: "map icon" }),
	                      hoveredDistribution ? hoveredDistribution.location : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        DC_3PL_NAMES[hoveredDistributionCenter] || ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Cost: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "$",
	                        hoveredDistribution ? (hoveredDistribution.cost / 1e6).toFixed(2) : '',
	                        "M"
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Lease Payment Terms: Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied."
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.calculateDistance },
	                        "View Details"
	                      )
	                    )
	                  ),
	                  factories.length > 0 && ownedDcTypeToTeamCenterId[2] && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: hoveredDistributionCenter === 2,
	                      top: 10,
	                      left: 175,
	                      onMouseEnter: this.cancelDistributionCenterUnhover,
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#eae4f9" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon6.default, alt: "map icon" }),
	                      hoveredDistribution ? hoveredDistribution.location : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        DC_3PL_NAMES[hoveredDistributionCenter] || ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Inventory Allocated: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        dcOwnedStats(2).units.toLocaleString('en-US')
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Transport Cost: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "$",
	                        Math.round(dcOwnedStats(2).shipping).toLocaleString('en-US')
	                      )
	                    ),
	                    showActionButtons === true && _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.editDistributionCenter(2) },
	                        "Edit"
	                      )
	                    )
	                  ),
	                  factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[3] && !(leadTimesLoaded && activeDistributionCenter === 3) && _react2.default.createElement(
	                    _style2.default.GlowingMapIcon,
	                    {
	                      x: 111, y: 189,
	                      onMouseEnter: selectDistributionCenterFacilityPopup ? null : this.hoverDistributionCenter(3),
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon10.default, alt: "map icon select-center-green" })
	                  ),
	                  factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[3] && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: hoveredDistributionCenter === 3,
	                      top: 105,
	                      left: 155,
	                      onMouseEnter: this.cancelDistributionCenterUnhover,
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#d7f0f2" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon8.default, alt: "map icon" }),
	                      hoveredDistribution ? hoveredDistribution.location : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        DC_3PL_NAMES[hoveredDistributionCenter] || ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Cost: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "$",
	                        hoveredDistribution ? (hoveredDistribution.cost / 1e6).toFixed(2) : '',
	                        "M"
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Lease Payment Terms: Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied."
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.calculateDistance },
	                        "View Details"
	                      )
	                    )
	                  ),
	                  factories.length > 0 && ownedDcTypeToTeamCenterId[3] && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    {
	                      show: hoveredDistributionCenter === 3,
	                      top: 105,
	                      left: 155,
	                      onMouseEnter: this.cancelDistributionCenterUnhover,
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#d7f0f2" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon8.default, alt: "map icon" }),
	                      hoveredDistribution ? hoveredDistribution.location : ''
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipCost,
	                      null,
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        DC_3PL_NAMES[hoveredDistributionCenter] || ''
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Inventory Allocated: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        dcOwnedStats(3).units.toLocaleString('en-US')
	                      ),
	                      _react2.default.createElement(_style2.default.TooltipSpace, null),
	                      "Transport Cost: ",
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "$",
	                        Math.round(dcOwnedStats(3).shipping).toLocaleString('en-US')
	                      )
	                    ),
	                    showActionButtons === true && _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.editDistributionCenter(3) },
	                        "Edit"
	                      )
	                    )
	                  ),
	                  canSelectDistributionCenters && distributionCenter && _react2.default.createElement(
	                    _style2.default.Tooltip1,
	                    { show: selectDistributionCenterFacilityPopup, top: 105, left: 155 },
	                    _react2.default.createElement(
	                      _style2.default.TooltipTitle,
	                      { background: "#FBD8D8" },
	                      _react2.default.createElement("img", { src: _mapHoverIcon2.default, alt: "map icon" }),
	                      "Newark, NJ"
	                    ),
	                    _react2.default.createElement(
	                      _style2.default.TooltipButtonRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.TooltipButton,
	                        { onClick: this.showDeselectLocationAlert },
	                        "Select"
	                      )
	                    )
	                  ),
	                  leadTimesLoaded && activeDistributionCenter > 0 && DC_CENTER_POSITIONS[activeDistributionCenter] && _react2.default.createElement(
	                    "svg",
	                    {
	                      style: {
	                        position: 'absolute',
	                        top: 0,
	                        left: 0,
	                        width: '100%',
	                        height: '100%',
	                        pointerEvents: 'none',
	                        overflow: 'visible'
	                      }
	                    },
	                    CUSTOMER_DOT_POSITIONS.map(function (c) {
	                      return _react2.default.createElement("line", {
	                        key: "leadline-" + c.id,
	                        x1: DC_CENTER_POSITIONS[activeDistributionCenter].x,
	                        y1: DC_CENTER_POSITIONS[activeDistributionCenter].y,
	                        x2: c.x,
	                        y2: c.y,
	                        stroke: "rgba(135, 99, 255, 0.5)",
	                        strokeWidth: "1.5"
	                      });
	                    })
	                  ),
	                  (leadTimesLoaded && activeDistributionCenter === 1 || !leadTimesLoaded && ownedDcTypeToTeamCenterId[1]) && _react2.default.createElement(
	                    _style2.default.MapIcon,
	                    {
	                      x: 338, y: 135,
	                      onMouseEnter: this.hoverDistributionCenter(1),
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon12.default, alt: "map icon selected-center-yellow" })
	                  ),
	                  (leadTimesLoaded && activeDistributionCenter === 2 || !leadTimesLoaded && ownedDcTypeToTeamCenterId[2]) && _react2.default.createElement(
	                    _style2.default.MapIcon,
	                    {
	                      x: 275, y: 208,
	                      onMouseEnter: this.hoverDistributionCenter(2),
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon14.default, alt: "map icon selected-center-purple" })
	                  ),
	                  (leadTimesLoaded && activeDistributionCenter === 3 || !leadTimesLoaded && ownedDcTypeToTeamCenterId[3]) && _react2.default.createElement(
	                    _style2.default.MapIcon,
	                    {
	                      x: 111, y: 189,
	                      onMouseEnter: this.hoverDistributionCenter(3),
	                      onMouseLeave: this.unhoverDistributionCenter
	                    },
	                    _react2.default.createElement("img", { src: _mapIcon16.default, alt: "map icon selected-center-green" })
	                  ),
	                  this.state.devMapMode && _react2.default.createElement(
	                    _style2.default.DevMapOverlay,
	                    { onClick: this.handleDevMapClick },
	                    _react2.default.createElement(
	                      _style2.default.DevMapBanner,
	                      null,
	                      "DEV MAP MODE \u2014 click anywhere to log coords (also printed to console)"
	                    ),
	                    this.state.devMapLastClick && _react2.default.createElement(
	                      _style2.default.DevMapCoord,
	                      {
	                        top: this.state.devMapLastClick.rawY,
	                        left: this.state.devMapLastClick.rawX
	                      },
	                      "x=",
	                      this.state.devMapLastClick.x,
	                      " y=",
	                      this.state.devMapLastClick.y
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _style2.default.OpsLeadGridRight,
	              {
	                fillHeight: showDistributionCenters && !leadTimesLoaded,
	                style: showDistributionCenters ? { position: 'relative', zIndex: 900 } : undefined
	              },
	              showDistributionCenters && !leadTimesLoaded && _react2.default.createElement(
	                _style4.default.SectionCard,
	                { style: { position: 'relative', height: '100%' } },
	                _react2.default.createElement(
	                  _style2.default.ManageDistributionClose,
	                  { onClick: this.hideDistributionCenters, "aria-label": "Close" },
	                  "\xD7"
	                ),
	                _react2.default.createElement(
	                  _style4.default.SectionTitle,
	                  null,
	                  "Manage Distribution"
	                ),
	                _react2.default.createElement(
	                  _style2.default.ManageDistributionBody,
	                  null,
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "You can now partner with distribution centers to position inventory closer to your customers. Right now, every order ships from your production facility, which means customers far from your plant wait longer, and long lead times can cost you sales."
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "A well-placed distribution center shortens lead times, improves customer satisfaction, and helps you capture revenue that would otherwise go to faster competitors."
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Three locations are available, and you can choose any one, two, or all three. Each distribution center comes with a cost, structured as a 5-year lease. You will make one payment at the start of each year for five years, and those annual payments together make up the total lease cost."
	                  )
	                )
	              ),
	              leadTimesLoaded && _react2.default.createElement(
	                _style4.default.SectionCard,
	                null,
	                _react2.default.createElement(
	                  _style2.default.DistributionTitle,
	                  null,
	                  activeDistributionCenter === 1 && _react2.default.createElement("img", { src: _mapIcon12.default, alt: "icon" }),
	                  activeDistributionCenter === 2 && _react2.default.createElement("img", { src: _mapIcon14.default, alt: "icon" }),
	                  activeDistributionCenter === 3 && _react2.default.createElement("img", { src: _mapIcon16.default, alt: "icon" }),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    distribution ? distribution.name : ''
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { style: {
	                      display: 'grid',
	                      gridTemplateColumns: '0.85fr 1.15fr',
	                      gap: 24,
	                      alignItems: 'stretch',
	                      marginTop: 12
	                    } },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      _style2.default.DistributionTableRow,
	                      null,
	                      _react2.default.createElement(
	                        _style2.default.DistributionTableCell,
	                        { isHeader: true },
	                        "Customer"
	                      ),
	                      _react2.default.createElement(
	                        _style2.default.DistributionTableCell,
	                        { isHeader: true },
	                        "Lead Time ",
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "(h)"
	                        )
	                      )
	                    ),
	                    leadTimes.map(function (leadTime) {
	                      return _react2.default.createElement(
	                        _style2.default.DistributionTableRow,
	                        { key: "distribution-table-row-" + leadTime.id },
	                        _react2.default.createElement(
	                          _style2.default.DistributionTableCell,
	                          null,
	                          leadTime.customer
	                        ),
	                        _react2.default.createElement(
	                          _style2.default.DistributionTableCell,
	                          null,
	                          Number(leadTime.avg_time.toFixed(2))
	                        )
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { style: { display: 'flex', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                      "div",
	                      { style: {
	                          fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                          fontWeight: 600, fontSize: 11, letterSpacing: '0.5px',
	                          textTransform: 'uppercase', color: 'rgba(0, 27, 59, 0.6)',
	                          marginBottom: 8
	                        } },
	                      "Allocate Inventory"
	                    ),
	                    (products || []).map(function (product) {
	                      var productId = product.product_id;
	                      // Max Allocation = ceiling for what the user can
	                      // assign to THIS DC right now: everything still at
	                      // the facility, PLUS whatever this DC has already
	                      // committed (so editing doesn't shrink the ceiling
	                      // by the pre-filled value). available_for_sale from
	                      // the backend doesn't subtract committed
	                      // allocations, so we subtract sums from
	                      // inventory_allocations and exclude this DC when
	                      // editing.
	                      var currentTcId = editingExistingDc ? ownedDcTypeToTeamCenterId[activeDistributionCenter] : null;
	                      var allocatedElsewhere = (inventory_allocations || []).filter(function (a) {
	                        return Number(a.product) === Number(productId);
	                      }).filter(function (a) {
	                        return !currentTcId || Number(a.team_distribution_center) !== Number(currentTcId);
	                      }).reduce(function (sum, a) {
	                        return sum + (Number(a.units) || 0);
	                      }, 0);
	                      var available = Math.max(0, Math.round((Number(product.available_for_sale) || 0) - allocatedElsewhere));
	                      var rawValue = allocations && allocations[productId];
	                      var displayValue = rawValue ? Number(rawValue).toLocaleString('en-US') : '';
	                      return _react2.default.createElement(
	                        "div",
	                        { key: "alloc-" + productId, style: {
	                            display: 'flex',
	                            alignItems: 'flex-end',
	                            gap: 8,
	                            marginBottom: 10
	                          } },
	                        _react2.default.createElement(
	                          "div",
	                          { style: { flex: 1 } },
	                          _react2.default.createElement(
	                            "div",
	                            { style: {
	                                display: 'flex',
	                                justifyContent: 'space-between',
	                                alignItems: 'baseline',
	                                marginBottom: 4
	                              } },
	                            _react2.default.createElement(
	                              "span",
	                              { style: {
	                                  fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                                  fontWeight: 600,
	                                  fontSize: 14,
	                                  color: 'rgba(0, 27, 59, 0.94)'
	                                } },
	                              "Product: ",
	                              product.product_name
	                            ),
	                            _react2.default.createElement(
	                              "span",
	                              { style: {
	                                  fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                                  fontSize: 12,
	                                  color: 'rgba(0, 27, 59, 0.55)'
	                                } },
	                              "Max Allocation: ",
	                              available.toLocaleString('en-US'),
	                              " units"
	                            )
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            value: displayValue,
	                            onChange: _this3.setAllocation(productId),
	                            placeholder: "0",
	                            disabled: available === 0,
	                            style: {
	                              width: '100%',
	                              boxSizing: 'border-box',
	                              padding: '8px 12px',
	                              borderRadius: 6,
	                              border: '1px solid #D5D9DD',
	                              fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                              fontSize: 14,
	                              fontWeight: 600,
	                              color: 'rgba(0, 27, 59, 0.94)',
	                              background: available === 0 ? '#F5F6F7' : '#fff'
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { style: {
	                              fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                              fontSize: 13,
	                              color: 'rgba(0, 27, 59, 0.6)',
	                              paddingBottom: 10
	                            } },
	                          "units"
	                        )
	                      );
	                    }),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { marginTop: 'auto', paddingTop: 12 } },
	                      _react2.default.createElement(
	                        _style2.default.DistributionButtons,
	                        null,
	                        editingExistingDc ? _react2.default.createElement(
	                          _reactDotFragment2.default,
	                          null,
	                          _react2.default.createElement(
	                            _style2.default.DistributionSubmitButton,
	                            { onClick: openingDistributionCenter ? null : this.updateAllocation, disabled: openingDistributionCenter },
	                            openingDistributionCenter ? 'Loading...' : 'Update Allocation'
	                          ),
	                          _react2.default.createElement(
	                            _style2.default.DistributionCancelButton,
	                            { onClick: this.cancelAgreement },
	                            "Cancel Agreement"
	                          ),
	                          _react2.default.createElement(
	                            _style2.default.DistributionCancelButton,
	                            { onClick: this.cancelDistributionCenter },
	                            "Cancel"
	                          )
	                        ) : _react2.default.createElement(
	                          _reactDotFragment2.default,
	                          null,
	                          _react2.default.createElement(
	                            _style2.default.DistributionSubmitButton,
	                            { onClick: openingDistributionCenter ? null : this.showPartnerConfirmation, disabled: openingDistributionCenter },
	                            openingDistributionCenter ? 'Loading...' : 'Allocate to Distribution Center'
	                          ),
	                          _react2.default.createElement(
	                            _style2.default.DistributionCancelButton,
	                            { onClick: this.cancelDistributionCenter },
	                            "Cancel"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              !leadTimesLoaded && !showDistributionCenters && this.totalAvailableForSale > 0 && _react2.default.createElement(
	                _style4.default.SectionCard,
	                null,
	                _react2.default.createElement(
	                  _style4.default.SectionHeader,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.SectionTitle,
	                    null,
	                    "Inventory Management"
	                  )
	                ),
	                _react2.default.createElement(
	                  _style4.default.SummaryTable,
	                  null,
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      _style4.default.SummaryHeadRow,
	                      null,
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        null,
	                        "Product"
	                      ),
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        { align: "right" },
	                        "Beg. Inventory"
	                      ),
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        { align: "right" },
	                        "Units Produced"
	                      ),
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        { align: "right" },
	                        "Available Units for Sale"
	                      ),
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        { align: "right" },
	                        "Cost Per Unit"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    (products || []).map(function (p, i) {
	                      var tp = (team_products || []).find(function (t) {
	                        return Number(t.id) === Number(p.product_id);
	                      });
	                      var monthsAvailable = tp ? Number(tp.months_available_to_produce) || 0 : 0;
	                      var notReleased = monthsAvailable === 0;
	                      return _react2.default.createElement(
	                        _style4.default.SummaryRow,
	                        { key: "inv-row-" + i },
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          null,
	                          _react2.default.createElement(
	                            "span",
	                            { style: {
	                                display: 'inline-flex',
	                                alignItems: 'center',
	                                gap: 8
	                              } },
	                            p.product_name,
	                            showActionButtons === true && Number(p.available_for_sale || 0) > 0 && _react2.default.createElement(
	                              "button",
	                              {
	                                type: "button",
	                                onClick: _this3.requestDeleteProduction(p.product_id),
	                                "aria-label": "Delete production for " + p.product_name,
	                                title: "Delete production for " + p.product_name,
	                                style: {
	                                  background: 'transparent',
	                                  border: '1.5px solid #E5E9F0',
	                                  borderRadius: 8,
	                                  width: 28,
	                                  height: 28,
	                                  display: 'inline-flex',
	                                  alignItems: 'center',
	                                  justifyContent: 'center',
	                                  color: 'rgba(0, 27, 59, 0.6)',
	                                  cursor: 'pointer',
	                                  padding: 0
	                                },
	                                onMouseEnter: function onMouseEnter(ev) {
	                                  ev.currentTarget.style.borderColor = '#DC2626';
	                                  ev.currentTarget.style.color = '#DC2626';
	                                },
	                                onMouseLeave: function onMouseLeave(ev) {
	                                  ev.currentTarget.style.borderColor = '#E5E9F0';
	                                  ev.currentTarget.style.color = 'rgba(0, 27, 59, 0.6)';
	                                }
	                              },
	                              _react2.default.createElement(
	                                "svg",
	                                { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	                                _react2.default.createElement("polyline", { points: "3 6 5 6 21 6" }),
	                                _react2.default.createElement("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }),
	                                _react2.default.createElement("path", { d: "M10 11v6" }),
	                                _react2.default.createElement("path", { d: "M14 11v6" }),
	                                _react2.default.createElement("path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" })
	                              )
	                            ),
	                            notReleased && _react2.default.createElement(
	                              "span",
	                              {
	                                style: { position: 'relative', display: 'inline-flex' },
	                                onMouseEnter: function onMouseEnter() {
	                                  return _this3.setState({ hoveredNotReleasedProductId: p.product_id });
	                                },
	                                onMouseLeave: function onMouseLeave() {
	                                  return _this3.setState({ hoveredNotReleasedProductId: 0 });
	                                }
	                              },
	                              _react2.default.createElement(
	                                "span",
	                                { style: {
	                                    display: 'inline-block',
	                                    padding: '2px 10px',
	                                    borderRadius: 20,
	                                    background: '#FFF1DD',
	                                    color: '#C77700',
	                                    border: '1px solid #F0CB91',
	                                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                                    fontWeight: 700,
	                                    fontSize: 11,
	                                    lineHeight: '14px',
	                                    letterSpacing: '0.3px',
	                                    whiteSpace: 'nowrap',
	                                    cursor: 'help'
	                                  } },
	                                "Not Yet Released"
	                              ),
	                              Number(hoveredNotReleasedProductId) === Number(p.product_id) && _react2.default.createElement(
	                                "span",
	                                { style: {
	                                    position: 'absolute',
	                                    bottom: '100%',
	                                    left: '50%',
	                                    transform: 'translateX(-50%) translateY(-8px)',
	                                    background: 'rgba(0, 27, 59, 0.94)',
	                                    color: '#fff',
	                                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
	                                    fontWeight: 500,
	                                    fontSize: 13,
	                                    lineHeight: '18px',
	                                    padding: '8px 12px',
	                                    borderRadius: 6,
	                                    width: 240,
	                                    textAlign: 'center',
	                                    pointerEvents: 'none',
	                                    zIndex: 10
	                                  } },
	                                "Check with your Head of Product or CEO about the release date with this product."
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          { align: "right" },
	                          Number(p.beginning_inventory || 0).toLocaleString('en-US')
	                        ),
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          { align: "right" },
	                          Number(p.units_produced || 0).toLocaleString('en-US')
	                        ),
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          { align: "right" },
	                          Number(p.available_for_sale || 0).toLocaleString('en-US')
	                        ),
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          { align: "right" },
	                          "$",
	                          Number(p.cost_per_unit || 0).toFixed(2)
	                        )
	                      );
	                    }),
	                    (!products || products.length === 0) && _react2.default.createElement(
	                      _style4.default.SummaryRow,
	                      null,
	                      _react2.default.createElement(
	                        _style4.default.SummaryCell,
	                        { colSpan: 5 },
	                        "\u2014"
	                      )
	                    )
	                  )
	                )
	              ),
	              !leadTimesLoaded && !showDistributionCenters && (supply_chain_assets || []).length > 0 && _react2.default.createElement(
	                _style4.default.SectionCard,
	                null,
	                _react2.default.createElement(
	                  _style4.default.SectionHeader,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.SectionTitle,
	                    null,
	                    "Supply Chain Assets"
	                  )
	                ),
	                _react2.default.createElement(
	                  _style4.default.SummaryTable,
	                  null,
	                  _react2.default.createElement(
	                    "thead",
	                    null,
	                    _react2.default.createElement(
	                      _style4.default.SummaryHeadRow,
	                      null,
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        null,
	                        "Asset"
	                      ),
	                      _react2.default.createElement(
	                        _style4.default.SummaryHeadCell,
	                        { align: "right" },
	                        "Cost"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    (supply_chain_assets || []).map(function (asset, i) {
	                      return _react2.default.createElement(
	                        _style4.default.SummaryRow,
	                        { key: "asset-" + (asset.type || '') + "-" + (asset.id || i) },
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          null,
	                          asset.name
	                        ),
	                        _react2.default.createElement(
	                          _style4.default.SummaryCell,
	                          { align: "right" },
	                          "$",
	                          Math.round(Number(asset.costs) || 0).toLocaleString('en-US')
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        loaded === false && _react2.default.createElement(_reactLoaders2.default, { type: "ball-scale-ripple", active: true }),
	        _react2.default.createElement(_selectFacility2.default, {
	          show: selectFacilityPopupShown,
	          facilityPopup: facilityPopup,
	          action: this.onCreateFactory,
	          close: this.hideFacilityPopupShown
	        }),
	        showPartnerConfirmation && function () {
	          // Fall back to looking up the distribution from
	          // distributionCentersInfo if state.distribution somehow was
	          // cleared between selecting a DC and clicking Allocate. Without
	          // this fallback the confirmation modal silently didn't render.
	          var dist = distribution || (distributionCentersInfo || []).find(function (i) {
	            return Number(i.type) === Number(activeDistributionCenter);
	          }) || null;
	          if (!dist) return null;
	          return _react2.default.createElement(_warning2.default, {
	            title: "Confirm Distribution Agreement",
	            successButtonText: "Confirm",
	            maxWidth: 500,
	            onSuccess: _this3.confirmPartnerConfirmation,
	            onCancel: _this3.cancelPartnerConfirmation,
	            message: _react2.default.createElement(
	              "span",
	              null,
	              "You're about to enter into a distribution agreement with ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                DC_3PL_NAMES[activeDistributionCenter] || 'this distributor'
	              ),
	              ' ',
	              "for the ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                dist.location || dist.name
	              ),
	              " distribution center. This will allow your team to transport inventory to this location.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Cost:"
	              ),
	              " $",
	              (Number(dist.cost || 0) / 1e6).toFixed(2),
	              "M",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Lease Payment Terms:"
	              ),
	              " Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Annual Payments:"
	              ),
	              " $",
	              Math.round(Number(dist.lease_cash_payment_per_period) || 0).toLocaleString('en-US'),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Shipping Costs:"
	              ),
	              " ",
	              function () {
	                var totalAlloc = Object.values(allocations || {}).reduce(function (sum, v) {
	                  return sum + (Number(v) || 0);
	                }, 0);
	                var batchSize = Number(shipping_batch_size) || 0;
	                var perBatch = Number(dist.shipping_cost_per_batch) || 0;
	                var cost = batchSize > 0 ? totalAlloc / batchSize * perBatch : 0;
	                return "$" + Math.round(cost).toLocaleString('en-US');
	              }(),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Are you sure?"
	            )
	          });
	        }(),
	        allocationValidationError && allocationValidationError.kind === 'overage' && _react2.default.createElement(_warning2.default, {
	          title: "Allocation Exceeds Max Allocation",
	          successButtonText: "OK",
	          showCancel: false,
	          onSuccess: this.dismissAllocationValidationError,
	          onCancel: this.dismissAllocationValidationError,
	          message: _react2.default.createElement(
	            "span",
	            null,
	            allocationValidationError.rows.length === 1 ? _react2.default.createElement(
	              "span",
	              null,
	              "You've allocated more units than are available for ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                allocationValidationError.rows[0].name
	              ),
	              "."
	            ) : _react2.default.createElement(
	              "span",
	              null,
	              "You've allocated more units than are available for the following products:"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            allocationValidationError.rows.map(function (row, idx) {
	              return _react2.default.createElement(
	                "span",
	                { key: idx },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  row.name,
	                  ":"
	                ),
	                " allocated ",
	                row.requested.toLocaleString('en-US'),
	                " units, max ",
	                row.available.toLocaleString('en-US'),
	                " units",
	                _react2.default.createElement("br", null)
	              );
	            }),
	            _react2.default.createElement("br", null),
	            "Reduce each allocation to at most the Max Allocation and try again."
	          )
	        }),
	        allocationValidationError && allocationValidationError.kind === 'zero' && _react2.default.createElement(_warning2.default, {
	          title: "No Units Allocated",
	          successButtonText: "OK",
	          showCancel: false,
	          onSuccess: this.dismissAllocationValidationError,
	          onCancel: this.dismissAllocationValidationError,
	          message: _react2.default.createElement(
	            "span",
	            null,
	            "Allocate at least one unit to this distribution center before partnering. Enter a value greater than 0 for at least one product."
	          )
	        }),
	        showCancelAgreementConfirmation && _react2.default.createElement(_warning2.default, {
	          title: "Cancel Agreement",
	          successButtonText: "Yes, Cancel Agreement",
	          onSuccess: this.confirmCancelAgreement,
	          onCancel: this.hideCancelAgreementConfirmation,
	          message: _react2.default.createElement(
	            "span",
	            null,
	            "Canceling will end your partnership with this distribution center (i.e. you won't be able to allocate inventory to this location).",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "If you cancel in the same round you signed the agreement: no breakage fee.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "If the agreement was made in a prior round, canceling will result in a 10% breakage fee based off the remaining of what you owe.",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            "You can always create a new agreement with this distribution center."
	          )
	        }),
	        this.state.deleteProductionProductId != null && function () {
	          var target = (products || []).find(function (p) {
	            return Number(p.product_id) === Number(_this3.state.deleteProductionProductId);
	          });
	          var productName = target ? target.product_name : 'this product';
	          return _react2.default.createElement(_warning2.default, {
	            title: "Delete Production",
	            successButtonText: "Yes, Delete",
	            onSuccess: _this3.confirmDeleteProduction,
	            onCancel: _this3.cancelDeleteProduction,
	            message: _react2.default.createElement(
	              "span",
	              null,
	              "Are you sure you want to delete production for ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                productName
	              ),
	              "? This will remove your production decision for this product this round."
	            )
	          });
	        }(),
	        this.state.showManageProductionPage && _react2.default.createElement(_manageProductionPage2.default, {
	          products: products,
	          teamProducts: team_products,
	          priceForecasts: price_forecasts,
	          maxAllowedMatrix: max_allowed_matrix,
	          inventoryBalances: this.state.inventory_balances,
	          inventoryAllocations: this.state.inventory_allocations,
	          currentRound: currentRound,
	          reloadData: this.fetchData,
	          onClose: this.closeManageProductionPage,
	          onFirstProductionInRound2: this.handleFirstProductionInRound2
	        }),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.firstDistributionModalOpen,
	          title: "Nice work!",
	          body: "Starting this round, you can make distribution center decisions to move your inventory closer to where your target customers are.",
	          ctaLabel: "View Distribution Center Decisions",
	          onCta: this.handleFirstDistributionCta,
	          onClose: this.handleFirstDistributionClose
	        }),
	        this.state.showMakeDecisionsModal && function () {
	          var hasProducts = (products || []).length > 0;
	          var hasMachines = (team_machines || []).length > 0;
	          var hasAvailableUnits = _this3.totalAvailableForSale > 0;
	          var produceEnabled = hasProducts && hasMachines;
	          var distributionEnabled = currentRound !== 1 && hasAvailableUnits;
	          return _react2.default.createElement(
	            _style4.default.ManageOverlay,
	            { onClick: _this3.closeMakeDecisionsModal },
	            _react2.default.createElement(
	              _style4.default.ManageModal,
	              { onClick: function onClick(e) {
	                  return e.stopPropagation();
	                }, style: { maxWidth: 760 } },
	              _react2.default.createElement(
	                _style4.default.ManageModalTitle,
	                null,
	                "Make Decisions"
	              ),
	              _react2.default.createElement(
	                _style4.default.ManageModalSubtitle,
	                null,
	                "Select a decision to explore"
	              ),
	              _react2.default.createElement(
	                _style2.default.DecisionFlowRow,
	                null,
	                _react2.default.createElement(
	                  _style2.default.DecisionOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.ManageOption,
	                    {
	                      onClick: _this3.pickMakeDecisionsOption('buy-sell-machines')
	                    },
	                    "Acquire/Sell Machines"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.DecisionOptionTooltip,
	                    null,
	                    "Add or remove production machines from your facility."
	                  )
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionFlowArrow,
	                  null,
	                  "\u2192"
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.ManageOption,
	                    {
	                      onClick: produceEnabled ? _this3.pickMakeDecisionsOption('produce-units') : undefined,
	                      disabled: !produceEnabled
	                    },
	                    "Manage Production"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.DecisionOptionTooltip,
	                    null,
	                    produceEnabled ? 'Schedule production runs for this round.' : !hasProducts ? 'No products exist yet. Coordinate with Product Development to create a product first.' : "You don't have any production machines yet. Acquire one before managing production."
	                  )
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionFlowArrow,
	                  null,
	                  "\u2192"
	                ),
	                _react2.default.createElement(
	                  _style2.default.DecisionOptionWrapper,
	                  null,
	                  _react2.default.createElement(
	                    _style4.default.ManageOption,
	                    {
	                      onClick: distributionEnabled ? _this3.pickMakeDecisionsOption('distribution-center') : undefined,
	                      disabled: !distributionEnabled
	                    },
	                    "Manage Distribution"
	                  ),
	                  _react2.default.createElement(
	                    _style2.default.DecisionOptionTooltip,
	                    null,
	                    currentRound === 1 ? 'Decision unavailable for Round 1' : !hasAvailableUnits ? "You don't have any units available for sale yet. Manufacture units before opening a distribution center." : 'Open or move your distribution center.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _style4.default.ManageCloseRow,
	                null,
	                _react2.default.createElement(
	                  _style4.default.ManageCloseButton,
	                  { onClick: _this3.closeMakeDecisionsModal },
	                  "Cancel"
	                )
	              )
	            )
	          );
	        }()
	      );
	    }
	  }, {
	    key: "showActionButtons",
	    get: function get() {
	      var _state2 = this.state,
	          hasAccess = _state2.hasAccess,
	          roundInUrl = _state2.roundInUrl,
	          currentRound = _state2.currentRound,
	          rounds = _state2.rounds;
	      var roundShouldBeFinished = this.props.roundShouldBeFinished;
	
	
	      if (hasAccess === false) {
	        return false;
	      }
	
	      if (roundShouldBeFinished === true) {
	        return false;
	      }
	
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        return false;
	      }
	
	      var round = rounds.find(function (i) {
	        return i.number === currentRound;
	      });
	
	      if (!round) {
	        return false;
	      }
	
	      return round.is_started === true && round.is_finished === false;
	    }
	
	    // Builds the per-product allocation payload from this.state.allocations
	    // and PUTs it to set_allocation/. By default skips zero-unit items (so
	    // a partner-only confirm with all-zero inputs doesn't hit the endpoint).
	    // Pass includeZeros=true from the Edit flow so explicit clears
	    // (e.g. 150,000 -> 0) still reach the backend.
	
	
	    // Opens the redesigned Make Decisions overlay. If this is the first
	    // time the team is reaching the Operations page (no facility row
	    // exists yet), submit the facility selection silently before opening
	    // — matches the old "Facility Selected" button behavior so the user
	    // never has to click it explicitly.
	
	
	    // Fired by BuyingMachines after the team's first successful machine
	    // purchase in Round 1. Shows the coaching modal that reminds the
	    // student they still need to make inventory decisions.
	
	
	    // CTA: close the popup and the machine-picker modal, then open the
	    // Make Decisions overlay so the user sees the other operations
	    // decisions they still need to make.
	
	
	    // Fired by ManageProductionPage after the team's first successful
	    // production decision in Round 2. Shows the coaching modal that
	    // introduces Distribution Center decisions (newly unlocked in Rd 2).
	
	
	    // CTA: close the popup and the Manage Production overlay, then open
	    // the Distribution Center selection UI so the user lands directly on
	    // their next decision.
	
	
	    // Dev-only: capture a click on the map, log the relative x/y to the
	    // console so it can be pasted into a MapDot. MapDot's x/y now anchor
	    // the dot's CENTER (via CSS translate(-50%, -50%)), so the raw click
	    // position is what you paste — no offset adjustment needed.
	
	  }, {
	    key: "totalAvailableForSale",
	
	
	    // ----- Lead-row KPI getters -----
	
	    get: function get() {
	      var inventory_balances = this.state.inventory_balances;
	
	      return (inventory_balances || []).reduce(function (sum, row) {
	        return sum + (Number(row.available_for_sale) || 0);
	      }, 0);
	    }
	  }, {
	    key: "avgCostPerUnit",
	    get: function get() {
	      var _state3 = this.state,
	          inventory_balances = _state3.inventory_balances,
	          products = _state3.products;
	
	      // Primary: value of ending inventory / units in ending inventory
	      // (post-sim). Represents the cost of what's sitting in the
	      // warehouse after sales have run.
	
	      var ending = (inventory_balances || []).reduce(function (acc, row) {
	        acc.costs += Number(row.ending_inventory_costs) || 0;
	        acc.units += Number(row.ending_inventory) || 0;
	        return acc;
	      }, { costs: 0, units: 0 });
	      if (ending.units > 0) return ending.costs / ending.units;
	
	      // Fallback (pre-sim, ending_inventory not yet populated): weight
	      // per-product cost_per_unit by available_for_sale — same source
	      // the Inventory Management table shows. Prevents the KPI from
	      // reading $0.00 during a round that hasn't been simulated.
	      var avail = (products || []).reduce(function (acc, p) {
	        var units = Number(p.available_for_sale) || 0;
	        var cpu = Number(p.cost_per_unit) || 0;
	        acc.costs += cpu * units;
	        acc.units += units;
	        return acc;
	      }, { costs: 0, units: 0 });
	      return avail.units > 0 ? avail.costs / avail.units : 0;
	    }
	
	    // Returns null on round 1 or when the backend hasn't yet supplied a
	    // prior-round value (avoids showing a misleading "vs last year" line
	    // when there's nothing meaningful to compare against).
	
	  }, {
	    key: "costPerUnitDelta",
	    get: function get() {
	      var _state4 = this.state,
	          roundInUrl = _state4.roundInUrl,
	          currentRound = _state4.currentRound,
	          prior_round_cost_per_unit = _state4.prior_round_cost_per_unit;
	
	      var viewedRound = roundInUrl !== null ? roundInUrl : currentRound;
	      if (Number(viewedRound) <= 1) return null;
	      if (prior_round_cost_per_unit == null || prior_round_cost_per_unit <= 0) return null;
	      var delta = this.avgCostPerUnit - prior_round_cost_per_unit;
	      return { delta: delta, up: delta > 0 };
	    }
	
	    // Inventory Management trash-icon handlers. Two-step flow: click
	    // the trash next to the product name -> WarningAlert confirms ->
	    // reuses onRemoveOperation to DELETE the product_manufactures row
	    // for that product (same delete path used by ProduceProduct).
	
	  }]);
	
	  return OperationsDecisions;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.showInfoAlert = function (infoToShow) {
	    var title = void 0,
	        text = void 0;
	    if (infoToShow === 'Facility') {
	      title = 'Facility';
	      text = 'Refers to the building where the image sensors are manufactured. There’s only 1 facility.';
	    } else if (infoToShow === 'Distribution Center') {
	      title = 'Distribution Center';
	      text = 'Refers to the building used to store, manage, and ship goods closer to customers.';
	    } else if (infoToShow === 'Production Capacity Utilization') {
	      title = 'Production Capacity Utilization';
	      text = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { style: { margin: '0 0 12px' } },
	          "Measures how much of your plant\u2019s annual production capacity you\u2019re actually using."
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { margin: '0 0 12px' } },
	          "This can stay below 100% even when you\u2019re producing at max. If your product launches later than January 1, you have fewer months to produce, which caps your annual output."
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { margin: 0 } },
	          "Check your product\u2019s launch date on the Product Management decisions page."
	        )
	      );
	    }
	
	    _this4.setState({
	      isInfoAlertVisible: true,
	      infoAlertTitle: title,
	      infoAlertText: text
	    });
	  };
	
	  this.hideInfoAlert = function () {
	    _this4.setState({
	      isInfoAlertVisible: false
	    });
	  };
	
	  this.showSuccessMessage = function (successMessage) {
	    _this4.setState({
	      successMessage: successMessage
	    }, function () {
	      _this4.hideSuccessMessage();
	    });
	  };
	
	  this.hideSuccessMessage = function () {
	    setTimeout(function () {
	      _this4.setState({
	        successMessage: null
	      });
	    }, 5000);
	  };
	
	  this.showCustomerTooltip = function (tooltipCustomerName) {
	    return function () {
	      var customerDemands = _this4.state.customerDemands;
	
	      var customerDemand = customerDemands.find(function (i) {
	        return Number(i.customer) === Number(tooltipCustomerName);
	      });
	      var tooltipCustomerDemand = customerDemand ? (0, _format.numberFormat)(Number(customerDemand.demand)) : 0;
	
	      _this4.setState({
	        tooltipCustomerName: tooltipCustomerName,
	        tooltipCustomerDemand: tooltipCustomerDemand
	      });
	    };
	  };
	
	  this.showChangeLocationAlert = function () {
	    _this4.setState({
	      showChangeLocationAlert: true
	    });
	  };
	
	  this.hideChangeLocationAlert = function () {
	    _this4.setState({
	      showChangeLocationAlert: false
	    });
	  };
	
	  this.showDeselectLocationAlert = function () {
	    _this4.setState({
	      showDeselectLocationAlert: true
	    });
	  };
	
	  this.hideDeselectLocationAlert = function () {
	    _this4.setState({
	      showDeselectLocationAlert: false
	    });
	  };
	
	  this.hideCustomerTooltip = function () {
	    _this4.setState({
	      tooltipCustomerName: null,
	      tooltipCustomerDemand: null
	    });
	  };
	
	  this.showTooltip1 = function () {
	    _this4.setState({
	      tooltip1: true
	    });
	  };
	
	  this.hideTooltip1 = function () {
	    _this4.setState({
	      tooltip1: false
	    });
	  };
	
	  this.showSelectDistributionCenterFacilityPopup = function () {
	    _this4.setState({
	      selectDistributionCenterFacilityPopup: true
	    });
	  };
	
	  this.hideSelectDistributionCenterFacilityPopup = function () {
	    _this4.setState({
	      selectDistributionCenterFacilityPopup: false
	    });
	  };
	
	  this.setPopupRef = function (ref) {
	    _this4.setState({
	      facilityPopup: ref
	    });
	  };
	
	  this.showDistributionCenters = function () {
	    // Open the side panel AND immediately put the map into the DC
	    // selection mode so the 3 glowing markers appear right away —
	    // there's no longer a separate "Select a Location" button.
	    _this4.setState({
	      showDistributionCenters: true,
	      canSelectDistributionCenters: true,
	      selectDistributionCenterFacilityPopup: false,
	      activeDistributionCenter: 0,
	      distribution: null,
	      leadTimes: [],
	      leadTimesLoaded: false
	    });
	  };
	
	  this.hideDistributionCenters = function () {
	    // Closing the panel returns the map to its normal customer-tooltip
	    // mode and clears any in-progress DC selection.
	    _this4.setState({
	      showDistributionCenters: false,
	      canSelectDistributionCenters: false,
	      selectDistributionCenterFacilityPopup: false,
	      activeDistributionCenter: 0,
	      distribution: null,
	      leadTimes: [],
	      leadTimesLoaded: false
	    });
	  };
	
	  this.cancelDistributionCenter = function () {
	    _this4.setState({
	      activeDistributionCenter: 0,
	      distribution: null,
	      leadTimes: [],
	      leadTimesLoaded: false,
	      editingExistingDc: false,
	      allocations: {}
	    });
	  };
	
	  this.editDistributionCenter = function (dcType) {
	    return function () {
	      var _state5 = _this4.state,
	          distributionCentersInfo = _state5.distributionCentersInfo,
	          inventory_allocations = _state5.inventory_allocations,
	          ownedDcTypeToTeamCenterId = _state5.ownedDcTypeToTeamCenterId;
	
	      var distribution = distributionCentersInfo.find(function (i) {
	        return Number(i.type) === dcType;
	      }) || null;
	      if (!distribution) return;
	      var teamCenterId = ownedDcTypeToTeamCenterId[dcType];
	
	      var prefill = {};
	      (inventory_allocations || []).filter(function (a) {
	        return Number(a.team_distribution_center) === Number(teamCenterId);
	      }).forEach(function (a) {
	        prefill[a.product] = String(a.units);
	      });
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/lead-times/").then(function (res) {
	        var leadTimes = res.body.results.filter(function (i) {
	          return Number(i.distribution_center) === dcType;
	        });
	        _this4.setState({
	          activeDistributionCenter: dcType,
	          distribution: distribution,
	          leadTimes: leadTimes,
	          leadTimesLoaded: true,
	          allocations: prefill,
	          editingExistingDc: true,
	          hoveredDistributionCenter: 0,
	          hoveredDistribution: null
	        });
	      }).catch(function (err) {});
	    };
	  };
	
	  this.updateAllocation = function () {
	    var _state6 = _this4.state,
	        distribution = _state6.distribution,
	        players = _state6.players,
	        ownedDcTypeToTeamCenterId = _state6.ownedDcTypeToTeamCenterId,
	        activeDistributionCenter = _state6.activeDistributionCenter;
	    var _props2 = _this4.props,
	        currentRound = _props2.currentRound,
	        rounds = _props2.rounds;
	
	    if (!distribution) return;
	
	    var round = rounds.find(function (i) {
	      return Number(i.number) === Number(currentRound);
	    });
	    var roundId = round ? Number(round.id) : 0;
	    var userId = Number(_Auth2.default.getUserId());
	    var teamId = Number(_Auth2.default.getTeamId());
	    var player = players.find(function (i) {
	      return Number(i.user.id) === userId;
	    });
	    var playerId = player ? Number(player.id) : 0;
	    var teamCenterId = ownedDcTypeToTeamCenterId[activeDistributionCenter];
	
	    _this4.setState({ openingDistributionCenter: true });
	    _this4.submitAllocations(teamCenterId, teamId, roundId, playerId, { includeZeros: true }).then(function () {
	      _this4.setState({
	        activeDistributionCenter: 0,
	        distribution: null,
	        leadTimes: [],
	        leadTimesLoaded: false,
	        openingDistributionCenter: false,
	        editingExistingDc: false,
	        allocations: {}
	      }, function () {
	        _this4.fetchData();
	      });
	    }).catch(function (err) {
	      _this4.setState({ openingDistributionCenter: false });
	    });
	  };
	
	  this.cancelAgreement = function () {
	    var _state7 = _this4.state,
	        activeDistributionCenter = _state7.activeDistributionCenter,
	        ownedDcTypeToTeamCenterId = _state7.ownedDcTypeToTeamCenterId;
	
	    var teamCenterId = ownedDcTypeToTeamCenterId[activeDistributionCenter];
	    if (!teamCenterId) return;
	    _this4.setState({
	      distributionCenterId: teamCenterId,
	      showCancelAgreementConfirmation: true
	    });
	  };
	
	  this.hideCancelAgreementConfirmation = function () {
	    _this4.setState({ showCancelAgreementConfirmation: false });
	  };
	
	  this.confirmCancelAgreement = function () {
	    var _state8 = _this4.state,
	        distributionCenterId = _state8.distributionCenterId,
	        teamDistributionCentersRaw = _state8.teamDistributionCentersRaw,
	        currentRound = _state8.currentRound;
	    var rounds = _this4.props.rounds;
	
	    if (!distributionCenterId) {
	      _this4.setState({ showCancelAgreementConfirmation: false });
	      return;
	    }
	    _this4.setState({
	      showCancelAgreementConfirmation: false,
	      openingDistributionCenter: true
	    });
	
	    // Same-round cancels are a true undo (no breakage fee, no audit trail
	    // needed) so the backend wants the record gone via DELETE. Prior-round
	    // cancels keep the record around for accounting and use the sell/ verb.
	    var round = rounds.find(function (i) {
	      return Number(i.number) === Number(currentRound);
	    });
	    var currentRoundId = round ? Number(round.id) : 0;
	    var tc = (teamDistributionCentersRaw || []).find(function (t) {
	      return Number(t.id) === Number(distributionCenterId);
	    });
	    var purchasedThisRound = tc && Number(tc.round) === currentRoundId;
	
	    var apiCall = purchasedThisRound ? (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-centers/" + distributionCenterId + "/") : (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-centers/" + distributionCenterId + "/sell/");
	
	    apiCall.then(function () {
	      // Immediately drop the canceled DC from the owned-map so the
	      // glowing "select me" marker re-appears without waiting for
	      // fetchData to round-trip. Also force the panel back into
	      // selection mode in case any of these flags drifted false.
	      var canceledDcType = _this4.state.activeDistributionCenter;
	      var nextOwned = Object.assign({}, _this4.state.ownedDcTypeToTeamCenterId || {});
	      delete nextOwned[canceledDcType];
	      _this4.setState({
	        activeDistributionCenter: 0,
	        distribution: null,
	        leadTimes: [],
	        leadTimesLoaded: false,
	        editingExistingDc: false,
	        allocations: {},
	        openingDistributionCenter: false,
	        showDistributionCenters: true,
	        canSelectDistributionCenters: true,
	        ownedDcTypeToTeamCenterId: nextOwned
	      }, function () {
	        _this4.showSuccessMessage(_react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "Agreement Voided"
	          ),
	          _react2.default.createElement("br", null),
	          "Your partnership with this distribution center has been canceled."
	        ));
	        _this4.fetchData();
	      });
	    }).catch(function () {
	      _this4.setState({ openingDistributionCenter: false });
	    });
	  };
	
	  this.unselectDistributionCenter = function () {
	    _this4.setState({
	      activeDistributionCenter: 0,
	      distribution: null,
	      selectDistributionCenterFacilityPopup: false
	    });
	  };
	
	  this.hoverDistributionCenter = function (n) {
	    return function () {
	      if (_this4._dcCloseTimer) {
	        clearTimeout(_this4._dcCloseTimer);
	        _this4._dcCloseTimer = null;
	      }
	      var distributionCentersInfo = _this4.state.distributionCentersInfo;
	
	      var hoveredDistribution = distributionCentersInfo.find(function (i) {
	        return Number(i.type) === n;
	      }) || null;
	      _this4.setState({
	        hoveredDistributionCenter: n,
	        hoveredDistribution: hoveredDistribution
	      });
	    };
	  };
	
	  this.cancelDistributionCenterUnhover = function () {
	    if (_this4._dcCloseTimer) {
	      clearTimeout(_this4._dcCloseTimer);
	      _this4._dcCloseTimer = null;
	    }
	  };
	
	  this.unhoverDistributionCenter = function () {
	    if (_this4._dcCloseTimer) clearTimeout(_this4._dcCloseTimer);
	    _this4._dcCloseTimer = setTimeout(function () {
	      if (!_this4._isMounted) return;
	      // Only the hover (tooltip) state is cleared here — the panel
	      // continues to display whatever DC the user clicked View Details
	      // on, so its name and lead-time table don't disappear when the
	      // mouse moves off the marker.
	      _this4.setState({
	        hoveredDistributionCenter: 0,
	        hoveredDistribution: null
	      });
	    }, 400);
	  };
	
	  this.setAllocation = function (productId) {
	    return function (e) {
	      var raw = (e.target.value || '').replace(/[^0-9]/g, '');
	      _this4.setState({
	        allocations: Object.assign({}, _this4.state.allocations, _defineProperty({}, productId, raw))
	      });
	    };
	  };
	
	  this.showPartnerConfirmation = function () {
	    // Validate every allocation against its per-product Max Allocation
	    // before showing the confirmation dialog. Uses the same available =
	    // available_for_sale - allocated_elsewhere formula rendered next to
	    // each input (see the Allocate Inventory panel), so the ceiling
	    // matches exactly what the user sees.
	    var _state9 = _this4.state,
	        products = _state9.products,
	        allocations = _state9.allocations,
	        inventory_allocations = _state9.inventory_allocations,
	        editingExistingDc = _state9.editingExistingDc,
	        ownedDcTypeToTeamCenterId = _state9.ownedDcTypeToTeamCenterId,
	        activeDistributionCenter = _state9.activeDistributionCenter;
	
	    var currentTcId = editingExistingDc ? ownedDcTypeToTeamCenterId[activeDistributionCenter] : null;
	    var overages = [];
	    var totalRequested = 0;
	    (products || []).forEach(function (product) {
	      var productId = product.product_id;
	      var allocatedElsewhere = (inventory_allocations || []).filter(function (a) {
	        return Number(a.product) === Number(productId);
	      }).filter(function (a) {
	        return !currentTcId || Number(a.team_distribution_center) !== Number(currentTcId);
	      }).reduce(function (sum, a) {
	        return sum + (Number(a.units) || 0);
	      }, 0);
	      var available = Math.max(0, Math.round((Number(product.available_for_sale) || 0) - allocatedElsewhere));
	      var requested = Number(allocations && allocations[productId]) || 0;
	      totalRequested += requested;
	      if (requested > available) {
	        overages.push({ name: product.product_name, requested: requested, available: available });
	      }
	    });
	    if (overages.length) {
	      _this4.setState({ allocationValidationError: { kind: 'overage', rows: overages } });
	      return;
	    }
	    if (totalRequested === 0) {
	      _this4.setState({ allocationValidationError: { kind: 'zero' } });
	      return;
	    }
	    _this4.setState({ showPartnerConfirmation: true });
	  };
	
	  this.dismissAllocationValidationError = function () {
	    _this4.setState({ allocationValidationError: null });
	  };
	
	  this.cancelPartnerConfirmation = function () {
	    _this4.setState({ showPartnerConfirmation: false });
	  };
	
	  this.confirmPartnerConfirmation = function () {
	    _this4.setState({ showPartnerConfirmation: false });
	    _this4.openDistributionCenter({ forceNew: true });
	  };
	
	  this.selectDistributionCenter = function (activeDistributionCenter) {
	    console.log('inside selectDistributionCenter');
	    var distributionCentersInfo = _this4.state.distributionCentersInfo;
	
	    var distribution = distributionCentersInfo.find(function (i) {
	      return Number(i.type) === activeDistributionCenter;
	    });
	
	    _this4.setState({
	      activeDistributionCenter: activeDistributionCenter,
	      distribution: distribution
	    });
	  };
	
	  this.calculateDistance = function () {
	    // Promote the currently-hovered DC into the panel's active state.
	    // View Details is the user's explicit choice of which DC to inspect,
	    // so we lock activeDistributionCenter/distribution to it here.
	    var _state10 = _this4.state,
	        hoveredDistributionCenter = _state10.hoveredDistributionCenter,
	        hoveredDistribution = _state10.hoveredDistribution;
	
	    if (!hoveredDistributionCenter) return;
	
	    (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/lead-times/").then(function (res) {
	      var leadTimes = res.body.results.filter(function (i) {
	        return Number(i.distribution_center) === hoveredDistributionCenter;
	      });
	
	      // canSelectDistributionCenters stays true so the other 2 DC +
	      // markers remain glowing/hoverable. The user can switch by
	      // hovering another marker and clicking its View Details.
	      _this4.setState({
	        activeDistributionCenter: hoveredDistributionCenter,
	        distribution: hoveredDistribution,
	        leadTimes: leadTimes,
	        leadTimesLoaded: true,
	        allocations: {}
	      });
	    }).catch(function (err) {});
	  };
	
	  this.canSelectDistributionCenters = function () {
	    _this4.setState({
	      showDistributionCenters: false,
	      canSelectDistributionCenters: true,
	      selectDistributionCenterFacilityPopup: false,
	      activeDistributionCenter: 0,
	      distribution: null,
	      leadTimes: [],
	      leadTimesLoaded: false
	    });
	  };
	
	  this.reloadRole = function () {
	    var role = _Auth2.default.getRole();
	    var hasAccess = role === "CEO" || role === "OP";
	    var isOwnRole = role === "OP";
	
	    _this4.setState({
	      hasAccess: hasAccess,
	      isOwnRole: isOwnRole
	    });
	  };
	
	  this.fetchData = function (showWarnings) {
	    var rounds = _this4.props.rounds;
	    var _state11 = _this4.state,
	        roundInUrl = _state11.roundInUrl,
	        currentRound = _state11.currentRound;
	
	    var round_number = roundInUrl !== null ? roundInUrl : currentRound;
	
	    Promise.all([(0, _TeamDecisionsService.fetchTeamDecisions)(round_number, 'operations'), (0, _TeamDecisionsService.fetchTeamStatus)(round_number), (0, _StaticDataService.fetchAllStaticData)(round_number, 'operations')]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 3),
	          decisionsData = _ref2[0],
	          statusData = _ref2[1],
	          staticData = _ref2[2];
	
	      if (!_this4._isMounted) return;
	
	      if (showWarnings) {
	        showWarnings(decisionsData);
	      }
	
	      var operations_decisions = decisionsData.operations_decisions,
	          team_machines = decisionsData.team_machines,
	          factories = decisionsData.factories,
	          distributionCentersRaw = decisionsData.distributionCenter,
	          distributionCentersInfoRaw = decisionsData.distributionCentersInfo,
	          inventory_balances = decisionsData.inventory_balances,
	          inventory_allocations = decisionsData.inventory_allocations,
	          dc_lease_schedules = decisionsData.dc_lease_schedules,
	          metrics_report = decisionsData.metrics_report,
	          machine_depreciations = decisionsData.machine_depreciations,
	          selling_price_factors = decisionsData.selling_price_factors,
	          price_forecasts = decisionsData.price_forecasts,
	          team_products = decisionsData.products,
	          max_allowed_matrix = decisionsData.max_allowed_matrix,
	          shipping_batch_size = decisionsData.shipping_batch_size;
	      var submission_data = statusData.submission_data;
	      var products = operations_decisions.products,
	          team = operations_decisions.team;
	
	      var players = _Teams2.default.players() || [];
	
	      var teamId = Number(_Auth2.default.getTeamId());
	
	      var previousRoundsIds = rounds.filter(function (i) {
	        return Number(i.number) >= 2 && Number(i.number) <= Number(round_number);
	      }).map(function (i) {
	        return i.id;
	      });
	
	      var teamDistributionCentersRaw = (distributionCentersRaw || []).filter(function (i) {
	        return Number(i.team) === teamId && previousRoundsIds.includes(Number(i.round));
	      });
	      var distributionCentersFiltered = (0, _lodash.orderBy)(teamDistributionCentersRaw.filter(function (i) {
	        return !i.sold_in_round;
	      }), 'number', ['desc']);
	      var distributionCenterObj = distributionCentersFiltered.length > 0 ? distributionCentersFiltered[0] : null;
	      var distributionCenter = distributionCenterObj ? Number(distributionCenterObj.distribution_center) : 0;
	      var distributionCenterId = distributionCenterObj ? Number(distributionCenterObj.id) : 0;
	
	      // Multi-DC ownership lookup: map of DC marker number -> team-center
	      // id. Each owned team-center references a catalog DC via FK; the
	      // catalog id happens to equal the map marker number (1=Toledo,
	      // 2=Little Rock, 3=Portland), so we key directly on it.
	      // sold_in_round-bearing records are excluded so canceled DCs aren't
	      // shown as owned.
	      var ownedDcTypeToTeamCenterId = {};
	      distributionCentersFiltered.forEach(function (tc) {
	        var dcType = Number(tc.distribution_center);
	        if (dcType > 0) ownedDcTypeToTeamCenterId[dcType] = Number(tc.id);
	      });
	
	      var overall_unit_utilization = team.overall_unit_utilization,
	          prior_round_cost_per_unit = team.prior_round_cost_per_unit,
	          supply_chain_assets = team.supply_chain_assets;
	
	      // Operation Spending for the round =
	      //   abs(production_costs)
	      //   + Σ abs(machines[].machine_costs)
	      //   + Σ abs(dc_lease_schedules[].cash_payment)
	      //   + abs(facility_costs)
	      //
	      // Every term follows the backend's negative-outflow convention,
	      // so we take the absolute value of each contribution before
	      // summing. Otherwise a negative field silently cancels the
	      // headline against the other costs.
	      // Operation Spending for the round — net cash view:
	      //   abs(production_costs)
	      //   + Σ abs(machines[].machine_costs)
	      //   + Σ abs(dc_lease_schedules[].cash_payment)
	      //   + abs(facility_costs)
	      //   − capital_exp_sales   ← proceeds in from selling a machine
	      //
	      // BE convention: outflow fields come in negative, so each
	      // additive term is Math.abs()'d. capital_exp_sales arrives
	      // positive and is subtracted directly to net the cash out of
	      // the spending headline.
	
	      var machinesCosts = (team.machines || []).reduce(function (s, m) {
	        return s + Math.abs(Number(m.machine_costs) || 0);
	      }, 0);
	      var dcCashPayment = (dc_lease_schedules || []).reduce(function (s, l) {
	        return s + Math.abs(Number(l.cash_payment) || 0);
	      }, 0);
	      var productionCosts = Math.abs(Number(team.production_costs) || 0);
	      var facilityCosts = Math.abs(Number(team.facility_costs) || 0);
	      var capitalExpSales = Math.max(0, Number(team.capital_exp_sales) || 0);
	      var operation_spending = productionCosts + machinesCosts + dcCashPayment + facilityCosts - capitalExpSales;
	
	      // Breakdown for the Operation Spending hover tooltip. Each row
	      // carries a `kind` the render path uses for coloring —
	      // "cost" rows render red, "receipt" rows render black. Order
	      // is explicit so the "Cash received from production line sale"
	      // row always sits directly beneath "Production Line Costs"
	      // (previously labeled "Machine Costs").
	      var operationSpendingBreakdown = [{ label: 'Production Costs (excl. depreciation)', amount: productionCosts, kind: 'cost' }, { label: 'Production Line Costs', amount: machinesCosts, kind: 'cost' }, { label: 'Cash received from production line sale', amount: capitalExpSales, kind: 'receipt' }, { label: 'Distribution Center Costs', amount: dcCashPayment, kind: 'cost' }, { label: 'Facility Costs', amount: facilityCosts, kind: 'cost' }].filter(function (item) {
	        return item.amount > 0;
	      });
	
	      var distributionCentersInfo = distributionCentersInfoRaw || [];
	
	      // BE pre-filters customer_demand to the requested round on the
	      // operations scope, so the per-row round_number filter FE used
	      // to run is no longer needed.
	      var customerDemands = staticData.customerDemand || [];
	
	      var isPreChecked = submission_data.op && submission_data.op.date !== 'N/A';
	
	      _this4.setState({
	        products: products,
	        submission_data: submission_data,
	        team_machines: team_machines,
	        overall_unit_utilization: overall_unit_utilization,
	        operation_spending: operation_spending,
	        operationSpendingBreakdown: operationSpendingBreakdown,
	        factories: factories,
	        submitDecisionsLoading: false,
	        loaded: true,
	        players: players,
	        distributionCenter: distributionCenter,
	        distributionCenterId: distributionCenterId,
	        ownedDcTypeToTeamCenterId: ownedDcTypeToTeamCenterId,
	        teamDistributionCentersRaw: teamDistributionCentersRaw,
	        distributionCentersInfo: distributionCentersInfo,
	        customerDemands: customerDemands,
	        movingDistributionCenter: false,
	        isPreChecked: isPreChecked,
	        inventory_balances: inventory_balances || [],
	        inventory_allocations: inventory_allocations || [],
	        metrics_report: metrics_report || null,
	        prior_round_cost_per_unit: prior_round_cost_per_unit != null ? Number(prior_round_cost_per_unit) : null,
	        supply_chain_assets: supply_chain_assets || [],
	        machine_depreciations: machine_depreciations || [],
	        selling_price_factors: selling_price_factors || [],
	        price_forecasts: price_forecasts || [],
	        team_products: team_products || [],
	        max_allowed_matrix: max_allowed_matrix || [],
	        shipping_batch_size: shipping_batch_size || 0
	      });
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "OperationsDecisions", "fetchData");
	    });
	  };
	
	  this.submitDecisions = function () {
	    _this4.setState({
	      submitDecisionsLoading: true
	    });
	
	    (0, _SubmitDecisions.submitDecisions)("operations", _this4.state.roundInUrl || _this4.state.currentRound, function (showWarnings) {
	      _this4.fetchData(showWarnings);
	    });
	  };
	
	  this.createFactory = function () {
	    return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "team/factories/").send({
	      factory: 1
	    });
	  };
	
	  this.selectFacilityPopupShown = function () {
	    _this4.setState({
	      selectFacilityPopupShown: true
	    });
	  };
	
	  this.hideFacilityPopupShown = function () {
	    _this4.setState({
	      selectFacilityPopupShown: false
	    });
	  };
	
	  this.checkDistributionCenter = function () {
	    var distributionCenter = _this4.state.distributionCenter;
	
	
	    if (distributionCenter > 0) {
	      _this4.showChangeLocationAlert();
	    } else {
	      _this4.openDistributionCenter();
	    }
	  };
	
	  this.openDistributionCenter = function () {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$forceNew = _ref3.forceNew,
	        forceNew = _ref3$forceNew === undefined ? false : _ref3$forceNew;
	
	    var _state12 = _this4.state,
	        distribution = _state12.distribution,
	        players = _state12.players,
	        distributionCenterId = _state12.distributionCenterId;
	    var _props3 = _this4.props,
	        currentRound = _props3.currentRound,
	        rounds = _props3.rounds;
	
	
	    var round = rounds.find(function (i) {
	      return Number(i.number) === Number(currentRound);
	    });
	    var roundId = round ? Number(round.id) : 0;
	    var userId = Number(_Auth2.default.getUserId());
	    var teamId = Number(_Auth2.default.getTeamId());
	    var player = players.find(function (i) {
	      return Number(i.user.id) === userId;
	    });
	    var playerId = player ? Number(player.id) : 0;
	
	    if (distribution) {
	      _this4.setState({
	        openingDistributionCenter: true,
	        showChangeLocationAlert: false
	      });
	
	      if (!forceNew && distributionCenterId > 0) {
	        (0, _ApiService.patchRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-centers/" + distributionCenterId + "/").send({
	          distribution_center: distribution.id
	        }).then(function (res) {
	          return _this4.submitAllocations(distributionCenterId, teamId, roundId, playerId);
	        }).then(function () {
	          _this4.setState({
	            movingDistributionCenter: true,
	            activeDistributionCenter: 0,
	            distribution: null,
	            leadTimes: [],
	            leadTimesLoaded: false,
	            openingDistributionCenter: false
	          }, function () {
	            _this4.fetchData();
	          });
	        }).catch(function (err) {});
	      } else {
	        // Re-partner via unsell/ if this DC was canceled in the CURRENT
	        // round (and originally purchased in a prior round — same-round
	        // cancels DELETE the record, so any sold_in_round record we find
	        // here is guaranteed to be a prior-round purchase). Otherwise
	        // it's a regular new partnership.
	        var teamDistributionCentersRaw = _this4.state.teamDistributionCentersRaw;
	
	        var soldThisRoundTc = (teamDistributionCentersRaw || []).find(function (t) {
	          return Number(t.distribution_center) === Number(distribution.id) && Number(t.sold_in_round) === roundId;
	        });
	
	        var partnerCall = soldThisRoundTc ? (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-centers/" + soldThisRoundTc.id + "/unsell/") : (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-centers/").send({
	          distribution_center: distribution.id,
	          round: roundId,
	          team: teamId,
	          player: playerId
	        });
	
	        partnerCall.then(function (res) {
	          var newTeamCenterId = soldThisRoundTc ? Number(soldThisRoundTc.id) : res && res.body ? Number(res.body.id) : 0;
	          return _this4.submitAllocations(newTeamCenterId, teamId, roundId, playerId);
	        }).then(function () {
	          _this4.setState({
	            activeDistributionCenter: 0,
	            distribution: null,
	            leadTimes: [],
	            leadTimesLoaded: false,
	            openingDistributionCenter: false
	          }, function () {
	            _this4.fetchData();
	          });
	        }).catch(function (err) {});
	      }
	    }
	  };
	
	  this.submitAllocations = function (teamCenterId, teamId, roundId, playerId) {
	    var _ref4 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
	        _ref4$includeZeros = _ref4.includeZeros,
	        includeZeros = _ref4$includeZeros === undefined ? false : _ref4$includeZeros;
	
	    var allocations = _this4.state.allocations;
	
	    if (!teamCenterId) return Promise.resolve();
	
	    var items = Object.keys(allocations || {}).map(function (productId) {
	      return {
	        product: Number(productId),
	        units: Number(allocations[productId]) || 0
	      };
	    }).filter(function (a) {
	      return includeZeros || a.units > 0;
	    });
	
	    if (items.length === 0) return Promise.resolve();
	
	    return (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-origin-inventories/set_allocation/").send({
	      team: teamId,
	      round: roundId,
	      player: playerId,
	      team_distribution_center: Number(teamCenterId),
	      allocations: items
	    });
	  };
	
	  this.deleteDistributionCenter = function () {
	    var distributionCenterId = _this4.state.distributionCenterId;
	
	
	    _this4.setState({
	      openingDistributionCenter: true,
	      showDeselectLocationAlert: false,
	      canSelectDistributionCenters: false
	    });
	    (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/distributions/team-centers/" + distributionCenterId).then(function (res) {
	      _this4.setState({
	        activeDistributionCenter: 0,
	        distribution: null,
	        leadTimes: [],
	        leadTimesLoaded: false,
	        openingDistributionCenter: false
	      }, function () {
	        _this4.fetchData();
	      });
	    }).catch(function (err) {});
	  };
	
	  this.onCreateFactory = function () {
	    var tourMode = _this4.props.tourMode;
	
	
	    if (tourMode === true) {
	      return;
	    }
	
	    _this4.setState({
	      loadingFactory: true,
	      selectFacilityPopupShown: false
	    });
	
	    _this4.createFactory().then(function (res) {
	      _this4.showSuccessMessage(_react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          "b",
	          null,
	          "Facility Selected Successfully"
	        ),
	        _react2.default.createElement("br", null),
	        "Note: This is the only production facility available and you need it to manufacture units."
	      ));
	      (0, _SubmitDecisions.incrementUnacceptedDecisions)("operations");
	      _this4.setState({
	        loadingFactory: false
	      }, function () {
	        _this4.fetchData();
	      });
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "OperationsDecisions", "onCreateFactory");
	    });
	  };
	
	  this.openMakeDecisionsModal = function () {
	    var tourMode = _this4.props.tourMode;
	
	    if (tourMode === true) return;
	
	    _this4.setState({ showMakeDecisionsModal: true });
	
	    var _state13 = _this4.state,
	        factories = _state13.factories,
	        loadingFactory = _state13.loadingFactory;
	
	    if (factories.length === 0 && loadingFactory !== true) {
	      _this4.onCreateFactory();
	    }
	  };
	
	  this.closeMakeDecisionsModal = function () {
	    _this4.setState({ showMakeDecisionsModal: false });
	  };
	
	  this.handleFirstMachineBought = function () {
	    _this4.setState({ firstDecisionModalOpen: true });
	  };
	
	  this.handleFirstDecisionClose = function () {
	    _this4.setState({ firstDecisionModalOpen: false });
	  };
	
	  this.handleFirstDecisionCta = function () {
	    _this4.setState({
	      firstDecisionModalOpen: false,
	      showMakeDecisionsModal: true
	    });
	    _this4.eventemitter.trigger('hide-buying-machines-modal');
	  };
	
	  this.handleFirstProductionInRound2 = function () {
	    _this4.setState({ firstDistributionModalOpen: true });
	  };
	
	  this.handleFirstDistributionClose = function () {
	    _this4.setState({ firstDistributionModalOpen: false });
	  };
	
	  this.handleFirstDistributionCta = function () {
	    _this4.setState({
	      firstDistributionModalOpen: false,
	      showManageProductionPage: false
	    });
	    _this4.showDistributionCenters();
	  };
	
	  this.handleDevMapClick = function (e) {
	    var rect = e.currentTarget.getBoundingClientRect();
	    var x = Math.round(e.clientX - rect.left);
	    var y = Math.round(e.clientY - rect.top);
	    // eslint-disable-next-line no-console
	    console.log("x={" + x + "} y={" + y + "}");
	    _this4.setState({ devMapLastClick: { x: x, y: y } });
	  };
	
	  this.pickMakeDecisionsOption = function (option) {
	    return function () {
	      _this4.closeMakeDecisionsModal();
	      if (option === 'buy-sell-machines') {
	        _this4.eventemitter.trigger('show-buying-machines-modal');
	      } else if (option === 'produce-units') {
	        _this4.setState({ showManageProductionPage: true });
	      } else if (option === 'distribution-center') {
	        _this4.showDistributionCenters();
	      }
	    };
	  };
	
	  this.closeManageProductionPage = function () {
	    _this4.setState({ showManageProductionPage: false });
	  };
	
	  this.requestDeleteProduction = function (productId) {
	    return function (e) {
	      if (e && e.preventDefault) e.preventDefault();
	      _this4.setState({ deleteProductionProductId: productId });
	    };
	  };
	
	  this.cancelDeleteProduction = function () {
	    _this4.setState({ deleteProductionProductId: null });
	  };
	
	  this.confirmDeleteProduction = function () {
	    var productId = _this4.state.deleteProductionProductId;
	    _this4.setState({ deleteProductionProductId: null });
	    if (productId != null) {
	      _this4.onRemoveOperation({ preventDefault: function preventDefault() {} }, productId);
	    }
	  };
	
	  this.onRemoveOperation = function (e, product_id, callback) {
	    e.preventDefault();
	
	    (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/").then(function (res) {
	      var obj = res.body.find(function (i) {
	        return i.product === product_id;
	      });
	
	      if (!obj) {
	        return;
	      }
	
	      (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "team/product_manufactures/" + obj.id + "/").then(function (res) {
	        (0, _SubmitDecisions.decrementUnacceptedDecisions)("operations");
	        _this4.fetchData();
	        if (callback) {
	          callback();
	        }
	      }).catch(function (err) {
	        (0, _utils.logError)(err, "OperationsDecisions", "onRemoveOperation");
	      });
	    }).catch(function (err) {
	      (0, _utils.logError)(err, "OperationsDecisions", "onRemoveOperation");
	    });
	  };
	};
	
	exports.default = (0, _reactEasyState.view)(OperationsDecisions);

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _top = __webpack_require__(1360);
	
	var _top2 = _interopRequireDefault(_top);
	
	var _section = __webpack_require__(1361);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _section3 = __webpack_require__(1362);
	
	var _section4 = _interopRequireDefault(_section3);
	
	var _section5 = __webpack_require__(1363);
	
	var _section6 = _interopRequireDefault(_section5);
	
	var _section7 = __webpack_require__(1364);
	
	var _section8 = _interopRequireDefault(_section7);
	
	var _section9 = __webpack_require__(1365);
	
	var _section10 = _interopRequireDefault(_section9);
	
	var _section11 = __webpack_require__(1366);
	
	var _section12 = _interopRequireDefault(_section11);
	
	var _section13 = __webpack_require__(1367);
	
	var _section14 = _interopRequireDefault(_section13);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _TeamDecisionsService = __webpack_require__(113);
	
	var _StaticDataService = __webpack_require__(178);
	
	var _FinancialStatementsService = __webpack_require__(137);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _reactLoaders = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamReports = function (_PureComponent) {
	  _inherits(TeamReports, _PureComponent);
	
	  function TeamReports(props) {
	    _classCallCheck(this, TeamReports);
	
	    var _this = _possibleConstructorReturn(this, (TeamReports.__proto__ || Object.getPrototypeOf(TeamReports)).call(this, props));
	
	    _this.fetchData = function () {
	      var teams = {};
	      var data = {};
	
	      _this.setState({
	        loading1: true,
	        loading2: true,
	        loading3: true,
	        loading4: true,
	        loading5: true,
	        loading6: true,
	        loading7: true,
	        loading8: true,
	        loading9: true,
	        loading10: true,
	        loading11: true
	      });
	
	      _this.loadFinancialStatements();
	      _this.loadStaticData();
	
	      // Use team-decisions data from Analysis.js props if available,
	      // otherwise fetch our own
	      if (_this.props.manufactureCosts || _this.props.inventoryBalances) {
	        _this.processTeamDecisionsFromProps();
	      } else {
	        _this.loadTeamDecisionsData();
	      }
	
	      _this.loadMetricsAndCompetition();
	      _this.loadTeamGrade();
	
	      _Teams2.default.teams().forEach(function (item) {
	        teams[item.id] = item.name;
	        data[item.id] = {};
	      });
	
	      _this.setState({
	        teams: teams,
	        data: data
	      }, function () {
	        _this.loadState();
	      });
	    };
	
	    _this.loadState = function () {
	      if (_this.joinRequest) {
	        _this.joinRequest.abort();
	        _this.joinRequest = null;
	      }
	
	      var roundId = _this.getCompetitiveAnalysisRoundId();
	      if (roundId) {
	        var currentTeam = _Teams2.default.teams()[0];
	        var competitionId = currentTeam ? Number(currentTeam.competition) : 0;
	
	        (0, _MetricsService.fetchCompetitiveAnalysis)(competitionId, roundId).then(function (caData) {
	          var data = Object.assign({}, _this.state.data);
	          var exclude_keys = ["created_at", "id", "is_actual", "reason", "round", "team", "updated_at"];
	
	          caData.forEach(function (item) {
	            if (item.team in data) {
	              Object.keys(item).forEach(function (key) {
	                if (exclude_keys.includes(key)) {
	                  return;
	                }
	
	                data[item.team][key] = item[key] === null ? 0 : item[key];
	              });
	            }
	          });
	
	          _this.setState({
	            data: data,
	            loading2: false
	          });
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.loadFinancialStatements = function () {
	      var incomeStatement = Object.assign({}, _this.state.incomeStatement);
	      var balanceSheet = Object.assign({}, _this.state.balanceSheet);
	      var cashFlow = Object.assign({}, _this.state.cashFlow);
	
	      for (var key in incomeStatement) {
	        incomeStatement[key].data = { value: 0 };
	      }
	      for (var _key in balanceSheet) {
	        balanceSheet[_key].data = { value: 0 };
	      }
	      for (var _key2 in cashFlow) {
	        cashFlow[_key2].data = { value: 0 };
	      }
	
	      var roundLte = _this.state.roundInUrl !== null && _this.state.roundInUrl !== _this.props.currentRound ? _this.state.roundInUrl : _this.props.currentRound;
	
	      (0, _FinancialStatementsService.fetchFinancialStatements)({ roundLte: roundLte }).then(function (data) {
	        var rounds = _this.props.rounds;
	
	        var current_year = _this.current_year;
	
	        var netRevenues = 0;
	        var netProfits = 0;
	        var costOfSales = 0;
	        var rndCosts = 0;
	        var promotionCosts = 0;
	        var sellingCosts = 0;
	        var holdingCosts = 0;
	        var interestExpense = 0;
	
	        // Process income statement
	
	        var _loop = function _loop(_key3) {
	          // eslint-disable-next-line
	          data.incomeStatement.forEach(function (item) {
	            var round_id = item.round;
	            var round = rounds.find(function (i) {
	              return i.id === round_id;
	            });
	            var round_number = round.number;
	            var hash = incomeStatement[_key3].name;
	
	            if (round_number === current_year && item[hash]) {
	              incomeStatement[_key3].data.value = item[hash];
	
	              if (hash === "Net Revenues") {
	                netRevenues = item[hash];
	              } else if (hash === "Net Income") {
	                netProfits = item[hash];
	              } else if (hash === "Cost of Sales") {
	                costOfSales = item[hash];
	              } else if (hash === "R&D Costs") {
	                rndCosts = item[hash];
	              } else if (hash === "Promotion Costs") {
	                promotionCosts = item[hash];
	              } else if (hash === "Selling Costs") {
	                sellingCosts = item[hash];
	              } else if (hash === "Holding Costs") {
	                holdingCosts = item[hash];
	              } else if (hash === "Interest Expense") {
	                interestExpense = item[hash];
	              }
	            }
	          });
	        };
	
	        for (var _key3 in incomeStatement) {
	          _loop(_key3);
	        }
	
	        // Process balance sheet
	
	        var _loop2 = function _loop2(_key4) {
	          data.balanceSheet.forEach(function (item) {
	            var round_id = item.round;
	            var round = _this.props.rounds.find(function (i) {
	              return i.id === round_id;
	            });
	            var round_number = round.number;
	
	            if (round_number === current_year) {
	              var hash = balanceSheet[_key4].name;
	              if (item[hash]) {
	                balanceSheet[_key4].data.value = item[hash];
	              }
	            }
	          });
	        };
	
	        for (var _key4 in balanceSheet) {
	          _loop2(_key4);
	        }
	
	        // Process cashflow
	        var debtBorrowed = 0;
	        var stockIssuance = 0;
	        var debtRepaid = 0;
	        var dividends = 0;
	        var stockRepurchase = 0;
	
	        var _loop3 = function _loop3(_key5) {
	          // eslint-disable-next-line
	          data.cashflow.forEach(function (item) {
	            var round_id = item.round;
	            var round = _this.props.rounds.find(function (i) {
	              return i.id === round_id;
	            });
	            var round_number = round.number;
	            var hash = cashFlow[_key5].name;
	
	            if (round_number === current_year && item[hash]) {
	              cashFlow[_key5].data.value = item[hash];
	
	              if (hash === "Stock Repurchase") {
	                stockRepurchase = item[hash];
	              } else if (hash === "Dividends") {
	                dividends = item[hash];
	              } else if (hash === "Debt Repaid") {
	                debtRepaid = item[hash];
	              } else if (hash === "Stock Issuance") {
	                stockIssuance = item[hash];
	              } else if (hash === "Debt Borrowed") {
	                debtBorrowed = item[hash];
	              }
	            }
	          });
	        };
	
	        for (var _key5 in cashFlow) {
	          _loop3(_key5);
	        }
	
	        var financeRaised = debtBorrowed + stockIssuance;
	        var returnedToInvestors = debtRepaid + dividends + stockRepurchase;
	
	        // Process financial analysis
	        var actual = {};
	        var expected = {};
	
	        data.financialAnalysis.forEach(function (item) {
	          if (item.is_actual === true) {
	            actual[item.target_round_number] = item;
	          } else {
	            expected[item.target_round_number] = item;
	          }
	        });
	
	        _this.setState({
	          netRevenues: netRevenues,
	          netProfits: netProfits,
	          costOfSales: costOfSales,
	          rndCosts: rndCosts,
	          promotionCosts: promotionCosts,
	          sellingCosts: sellingCosts,
	          holdingCosts: holdingCosts,
	          interestExpense: interestExpense,
	          incomeStatement: incomeStatement,
	          balanceSheet: balanceSheet,
	          cashFlow: cashFlow,
	          financeRaised: financeRaised,
	          returnedToInvestors: returnedToInvestors,
	          actual: actual,
	          expected: expected,
	          loading1: false,
	          loading3: false,
	          loading8: false,
	          loading9: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.goToSection = function (section) {
	      _this.changeStep(section, 1);
	    };
	
	    _this.changeStep = function (section, step) {
	      _this.setState({
	        section: section,
	        step: step
	      }, function () {
	        _this.eventemitter.trigger("team-reports-change-section", [_this.state.section]);
	      });
	    };
	
	    _this.loadStaticData = function () {
	      var round_number = _this.current_year;
	
	      (0, _StaticDataService.fetchAllStaticData)(round_number).then(function (data) {
	        var total_demand = {
	          auto: 0,
	          mobile: 0,
	          total: 0
	        };
	        var obj = data.totalDemand.find(function (i) {
	          return i.round_number === round_number;
	        });
	
	        if (obj) {
	          total_demand.auto = obj.auto;
	          total_demand.mobile = obj.mobile;
	          total_demand.total = obj.total;
	        }
	
	        var constants = data.constants;
	        var share_price = constants ? constants.initial_share_price : 0;
	
	        _this.setState({
	          total_demand: total_demand,
	          share_price: share_price,
	          loading4: false,
	          loading10: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.processTeamDecisionsFromProps = function () {
	      var totalCosts = 0;
	      var avgMaterialCostsPerUnit = 0;
	      var avgLaborCostsPerUnit = 0;
	      var avgOverheadCostsPerUnit = 0;
	      var endingInventory = 0;
	
	      if (_this.props.manufactureCosts) {
	        _this.props.manufactureCosts.forEach(function (product) {
	          totalCosts += product.total_costs || 0;
	          avgMaterialCostsPerUnit += product.material_costs || 0;
	          avgLaborCostsPerUnit += product.labor_costs || 0;
	          avgOverheadCostsPerUnit += product.overhead_costs || 0;
	        });
	      }
	
	      if (_this.props.inventoryBalances) {
	        _this.props.inventoryBalances.forEach(function (product) {
	          endingInventory += product.ending_inventory || 0;
	        });
	      }
	
	      _this.setState({
	        totalCosts: totalCosts,
	        avgMaterialCostsPerUnit: avgMaterialCostsPerUnit,
	        avgLaborCostsPerUnit: avgLaborCostsPerUnit,
	        avgOverheadCostsPerUnit: avgOverheadCostsPerUnit,
	        endingInventory: endingInventory,
	        loading5: false,
	        loading6: false
	      });
	    };
	
	    _this.loadTeamDecisionsData = function () {
	      var round_number = _this.current_year;
	
	      (0, _TeamDecisionsService.fetchTeamDecisions)(round_number, 'team-reports').then(function (data) {
	        var totalCosts = 0;
	        var avgMaterialCostsPerUnit = 0;
	        var avgLaborCostsPerUnit = 0;
	        var avgOverheadCostsPerUnit = 0;
	        var endingInventory = 0;
	
	        if (data.operations_decisions && data.operations_decisions.products) {
	          data.operations_decisions.products.forEach(function (product) {
	            totalCosts += product.total_costs || 0;
	            avgMaterialCostsPerUnit += product.material_costs || 0;
	            avgLaborCostsPerUnit += product.labor_costs || 0;
	            avgOverheadCostsPerUnit += product.overhead_costs || 0;
	          });
	        }
	
	        if (data.inventory_balances) {
	          data.inventory_balances.forEach(function (product) {
	            endingInventory += product.ending_inventory || 0;
	          });
	        }
	
	        _this.setState({
	          totalCosts: totalCosts,
	          avgMaterialCostsPerUnit: avgMaterialCostsPerUnit,
	          avgLaborCostsPerUnit: avgLaborCostsPerUnit,
	          avgOverheadCostsPerUnit: avgOverheadCostsPerUnit,
	          endingInventory: endingInventory,
	          loading5: false,
	          loading6: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.loadMetricsAndCompetition = function () {
	      var round_number = _this.current_year;
	      var team = _Teams2.default.currentTeam();
	      var teamId = team ? Number(team.id) : 0;
	      var competitionId = team ? Number(team.competition) : 0;
	      var roundObj = _this.state.rounds.find(function (i) {
	        return Number(i.number) === round_number;
	      });
	      var roundId = roundObj ? Number(roundObj.id) : 0;
	
	      (0, _MetricsService.fetchCompetitionMetrics)(competitionId, roundId).then(function (allTeamsData) {
	        // Extract team metrics (debt/equity/wacc)
	        var metrics = {
	          debt: "0.00",
	          equity: "100.00",
	          wacc: "0.00"
	        };
	
	        var teamData = allTeamsData.find(function (i) {
	          return Number(i.team) === teamId;
	        });
	
	        if (teamData && teamData.debt_to_total_capital) {
	          metrics.debt = (teamData.debt_to_total_capital * 100).toFixed(2);
	          metrics.equity = (100 - Number(metrics.debt)).toFixed(2);
	        }
	
	        if (teamData && teamData.wacc) {
	          metrics.wacc = (teamData.wacc * 100).toFixed(2);
	        }
	
	        // Extract competition metrics and build teams list from metricsreports
	        var competition_metrics = {};
	        var teams = Object.assign({}, _this.state.teams);
	        var competitionTeams = [];
	        allTeamsData.forEach(function (row) {
	          competition_metrics[row.team] = {
	            MarketShare: row["market_share"] ? row["market_share"] : 0,
	            Revenues: row["net_revenues"] ? row["net_revenues"] : 0,
	            GrossMargins: row["gross_margin"] ? row["gross_margin"] : 0
	          };
	          if (row.team_name) {
	            teams[row.team] = row.team_name;
	            if (!competitionTeams.find(function (t) {
	              return t.id === row.team;
	            })) {
	              competitionTeams.push({
	                id: row.team,
	                name: row.team_name,
	                competition: row.competition
	              });
	            }
	          }
	        });
	
	        // Update teams_data in localStorage so chart colors work
	        if (competitionTeams.length > 0) {
	          var existing = _Teams2.default.teams();
	          var existingIds = new Set(existing.map(function (t) {
	            return t.id;
	          }));
	          var merged = [].concat(_toConsumableArray(existing));
	          competitionTeams.forEach(function (t) {
	            if (!existingIds.has(t.id)) {
	              merged.push(t);
	            }
	          });
	
	          var _require = __webpack_require__(173),
	              reactLocalStorage = _require.reactLocalStorage;
	
	          reactLocalStorage.setObject("teams_data", merged);
	          (0, _Teams.persistTeamColorIndexMap)(merged);
	        }
	
	        _this.setState({
	          metrics: metrics,
	          competition_metrics: competition_metrics,
	          teams: teams,
	          loading7: false,
	          loading11: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.loadTeamGrade = function () {
	      var round_number = _this.current_year;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/grading/?round_number=" + round_number).then(function (res) {
	        var rounds = _this.state.rounds;
	
	        var round = rounds.find(function (i) {
	          return i.number === round_number;
	        });
	        if (!round) return;
	
	        var obj = res.body.find(function (i) {
	          return i.round === round.id;
	        });
	        if (obj) {
	          _this.setState({
	            team_grade: obj.weighted_value * 100,
	            rank_name: obj.ranking || "Unknown Rank"
	          });
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loading1: true,
	      loading2: true,
	      loading3: true,
	      loading4: true,
	      loading5: true,
	      loading6: true,
	      loading7: true,
	      loading8: true,
	      loading9: true,
	      loading10: true,
	      loading11: true,
	      section: 1,
	      step: 1,
	      data: {},
	      teams: {},
	      expected: {},
	      actual: {},
	      competition_metrics: {},
	      netRevenues: 0,
	      netProfits: 0,
	      costOfSales: 0,
	      rndCosts: 0,
	      promotionCosts: 0,
	      sellingCosts: 0,
	      holdingCosts: 0,
	      avgMaterialCostsPerUnit: 0,
	      avgLaborCostsPerUnit: 0,
	      avgOverheadCostsPerUnit: 0,
	      interestExpense: 0,
	      financeRaised: 0,
	      returnedToInvestors: 0,
	      currentRound: props.currentRound,
	      roundInUrl: props.roundInUrl,
	      rounds: props.rounds,
	      endingInventory: 0,
	      totalCosts: 0,
	      team_grade: 0,
	      rank_name: "",
	      metrics: {
	        debt: "0.00",
	        equity: "100.00",
	        wacc: "0.00"
	      },
	      incomeStatement: {
	        costOfSales: {
	          name: "Cost of Sales",
	          data: {}
	        },
	        revenues: {
	          name: "Net Revenues",
	          data: {}
	        },
	        grossProfits: {
	          name: "Gross Profit",
	          data: {}
	        },
	        RnDCosts: {
	          name: "R&D Costs",
	          data: {}
	        },
	        holdingCosts: {
	          name: "Holding Costs",
	          data: {}
	        },
	        promotionCosts: {
	          name: "Promotion Costs",
	          data: {}
	        },
	        sellingCosts: {
	          name: "Selling Costs",
	          data: {}
	        },
	        gnACosts: {
	          name: "Other G&A Costs",
	          data: {}
	        },
	        incomingBeforeTaxes: {
	          name: "Income Before Taxes",
	          data: {}
	        },
	        taxes: {
	          name: "Taxes",
	          data: {}
	        },
	        totalOperatingExpenses: {
	          name: "Total Operating Costs",
	          data: {}
	        },
	        totalNonOperatingCost: {
	          name: "Total Non-Operating Costs",
	          data: {}
	        },
	        gainOrLossoFSales: {
	          name: "Gain or Loss of Sales",
	          data: {}
	        },
	        interestExpense: {
	          name: "Interest Expense",
	          data: {}
	        },
	        otherNonOperatingCosts: {
	          name: "Other Non-Operating Costs",
	          data: {}
	        },
	        netIncome: {
	          name: "Net Income",
	          data: {}
	        }
	      },
	      balanceSheet: {
	        accountsPayable: {
	          name: "Accounts Payable",
	          data: {}
	        },
	        accountsReceivable: {
	          name: "Accounts Receivable",
	          data: {}
	        },
	        accruedExpenses: {
	          name: "Accrued Expenses",
	          data: {}
	        },
	        accumulatedDepreciation: {
	          name: "Accumulated Depreciation",
	          data: {}
	        },
	        additionalPaidinCapital: {
	          name: "Additional Paid in Capital",
	          data: {}
	        },
	        begRetainedEarnings: {
	          name: "Beg Retained Earnings",
	          data: {}
	        },
	        cash: {
	          name: "Cash",
	          data: {}
	        },
	        commonStock: {
	          name: "Common Stock",
	          data: {}
	        },
	        currentLiabilities: {
	          name: "Current Liabilities:",
	          data: {}
	        },
	        deferredRevenues: {
	          name: "Deferred Revenues",
	          data: {}
	        },
	        dividends: {
	          name: "Dividends",
	          data: {}
	        },
	        inventory: {
	          name: "Inventory",
	          data: {}
	        },
	        longTermDebt: {
	          name: "Long Term Debt",
	          data: {}
	        },
	        longTermLiabilities: {
	          name: "Long Term Liabilities:",
	          data: {}
	        },
	        netIncome: {
	          name: "Net Income",
	          data: {}
	        },
	        otherCurrentLiabilities: {
	          name: "Other Current Liabilities",
	          data: {}
	        },
	        otherLongTermLiabilities: {
	          name: "Other Long Term Liabilities",
	          data: {}
	        },
	        ppe: {
	          name: "PPE",
	          data: {}
	        },
	        preferredStock: {
	          name: "Preferred Stock",
	          data: {}
	        },
	        prepaidExpenses: {
	          name: "Prepaid Expenses",
	          data: {}
	        },
	        shortTermDebt: {
	          name: "Short Term Debt",
	          data: {}
	        },
	        supplies: {
	          name: "Supplies",
	          data: {}
	        },
	        totalAssets: {
	          name: "Total Assets",
	          data: {}
	        },
	        totalCurrentAssets: {
	          name: "Total Current Assets",
	          data: {}
	        },
	        totalCurrentLiabilities: {
	          name: "Total Current Liabilities",
	          data: {}
	        },
	        totalEquity: {
	          name: "Total Equity",
	          data: {}
	        },
	        totalLiabilities: {
	          name: "Total Liabilities",
	          data: {}
	        },
	        totalLongTermAssets: {
	          name: "Total Long Term Assets",
	          data: {}
	        },
	        totalLongTermLiabilities: {
	          name: "Total Long Term Liabilities",
	          data: {}
	        }
	      },
	      cashFlow: {
	        beginningCash: {
	          name: "Beginning Cash",
	          data: {}
	        },
	        capitalExpenditurePurchases: {
	          name: "Capital Expenditure Purchases",
	          data: {}
	        },
	        capitalExpenditureSales: {
	          name: "Capital Expenditure Sales",
	          data: {}
	        },
	        cashpaymentforIncomeTaxes: {
	          name: "Cash payment for Income Taxes",
	          data: {}
	        },
	        cashpaymentforInterests: {
	          name: "Cash payment for Interests",
	          data: {}
	        },
	        cashpaymentsforOperatingexpenses: {
	          name: "Cash payments for Operating expenses",
	          data: {}
	        },
	        cashpaymentsforPurchases: {
	          name: "Cash payments for Purchases",
	          data: {}
	        },
	        cashpaymentsforWages: {
	          name: "Cash payment for Wages",
	          data: {}
	        },
	        cashreceivedfromCustomers: {
	          name: "Cash received from Customers",
	          data: {}
	        },
	        debtBorrowed: {
	          name: "Debt Borrowed",
	          data: {}
	        },
	        debtRepaid: {
	          name: "Debt Repaid",
	          data: {}
	        },
	        dividends: {
	          name: "Dividends",
	          data: {}
	        },
	        endingCash: {
	          name: "Ending Cash",
	          data: {}
	        },
	        investmentPurchases: {
	          name: "Investment Purchases",
	          data: {}
	        },
	        investmentSales: {
	          name: "Investment Sales",
	          data: {}
	        },
	        netChangeinCash: {
	          name: "Net Change in Cash",
	          data: {}
	        },
	        stockIssuance: {
	          name: "Stock Issuance",
	          data: {}
	        },
	        stockRepurchase: {
	          name: "Stock Repurchase",
	          data: {}
	        },
	        totalCashFlowsfromFinancing: {
	          name: "Total Cash Flows from Financing",
	          data: {}
	        },
	        totalCashFlowsfromInvesting: {
	          name: "Total Cash Flows from Investing",
	          data: {}
	        },
	        totalCashFlowsfromOperations: {
	          name: "Total Cash Flows from Operations",
	          data: {}
	        }
	      },
	      total_demand: {
	        auto: 0,
	        mobile: 0,
	        total: 0
	      },
	      share_price: 0
	    };
	
	    _this.eventemitter = _eventEmitter2.default.getInstance();
	    return _this;
	  }
	
	  _createClass(TeamReports, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchData();
	      this.eventemitter.on("team-reports-go-to-section", this.goToSection);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.eventemitter.off("team-reports-go-to-section", this.goToSection);
	    }
	  }, {
	    key: "getCompetitiveAnalysisRoundId",
	    value: function getCompetitiveAnalysisRoundId() {
	      var _state = this.state,
	          currentRound = _state.currentRound,
	          roundInUrl = _state.roundInUrl,
	          rounds = _state.rounds;
	
	
	      var roundId = null;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        var round = rounds.find(function (i) {
	          return i.number === roundInUrl;
	        });
	        if (round) {
	          roundId = round.id;
	        }
	      } else {
	        var _round = rounds.find(function (i) {
	          return i.number === currentRound;
	        });
	        if (_round) {
	          if (_round.is_finished === true) {
	            roundId = _round.id;
	          } else {
	            var round_number = currentRound - 1;
	            if (round_number > 0) {
	              _round = rounds.find(function (i) {
	                return i.number === round_number;
	              });
	              if (_round) {
	                roundId = _round.id;
	              }
	            }
	          }
	        }
	      }
	
	      return roundId;
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var needUpdate = false;
	      if (this.state.roundInUrl !== nextProps.roundInUrl) {
	        needUpdate = true;
	      }
	
	      if (this.state.currentRound !== nextProps.currentRound) {
	        needUpdate = true;
	      }
	
	      if (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
	        needUpdate = true;
	      }
	
	      var round1 = this.state.rounds.find(function (i) {
	        return i.number === nextProps.currentRound;
	      });
	      var round2 = nextProps.rounds.find(function (i) {
	        return i.number === nextProps.currentRound;
	      });
	      if (round1 && round2 && round1.is_finished !== round2.is_finished) {
	        needUpdate = true;
	      }
	
	      if (needUpdate === true) {
	        this.setState({
	          roundInUrl: nextProps.roundInUrl,
	          currentRound: nextProps.currentRound,
	          rounds: nextProps.rounds
	        }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "getActualYearParam",
	    value: function getActualYearParam(year, key) {
	      if (year in this.state.actual) {
	        var obj = this.state.actual[year];
	        if (key in obj) {
	          return obj[key];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getExpectedYearParam",
	    value: function getExpectedYearParam(year, key) {
	      if (year in this.state.expected) {
	        var obj = this.state.expected[year];
	        if (key in obj) {
	          return obj[key];
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state2 = this.state,
	          section = _state2.section,
	          step = _state2.step,
	          data = _state2.data,
	          teams = _state2.teams,
	          netRevenues = _state2.netRevenues,
	          netProfits = _state2.netProfits,
	          actual = _state2.actual,
	          expected = _state2.expected,
	          incomeStatement = _state2.incomeStatement,
	          balanceSheet = _state2.balanceSheet,
	          cashFlow = _state2.cashFlow,
	          costOfSales = _state2.costOfSales,
	          rndCosts = _state2.rndCosts,
	          promotionCosts = _state2.promotionCosts,
	          sellingCosts = _state2.sellingCosts,
	          total_demand = _state2.total_demand,
	          holdingCosts = _state2.holdingCosts,
	          endingInventory = _state2.endingInventory,
	          totalCosts = _state2.totalCosts,
	          avgMaterialCostsPerUnit = _state2.avgMaterialCostsPerUnit,
	          avgLaborCostsPerUnit = _state2.avgLaborCostsPerUnit,
	          avgOverheadCostsPerUnit = _state2.avgOverheadCostsPerUnit,
	          interestExpense = _state2.interestExpense,
	          financeRaised = _state2.financeRaised,
	          returnedToInvestors = _state2.returnedToInvestors,
	          metrics = _state2.metrics,
	          competition_metrics = _state2.competition_metrics,
	          share_price = _state2.share_price,
	          rank_name = _state2.rank_name,
	          team_grade = _state2.team_grade;
	
	      var current_year = this.current_year;
	      var isLoading = this.isLoading;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "team-reports-container" },
	        _react2.default.createElement(_top2.default, {
	          section: section,
	          step: step,
	          changeStep: this.changeStep,
	          current_year: current_year
	        }),
	        section === 1 && isLoading === false && _react2.default.createElement(_section2.default, { step: step, rank_name: rank_name }),
	        section === 2 && isLoading === false && _react2.default.createElement(_section4.default, {
	          step: step,
	          team_grade: team_grade,
	          rank_name: rank_name,
	          data: data,
	          teams: teams,
	          share_price: share_price,
	          current_year: current_year,
	          competition_metrics: competition_metrics
	        }),
	        section === 3 && isLoading === false && _react2.default.createElement(_section6.default, {
	          step: step,
	          expectedNetProfits: this.expectedNetProfits,
	          actualNetProfits: this.actualNetProfits,
	          netRevenues: netRevenues,
	          netProfits: netProfits,
	          actual: actual,
	          expected: expected,
	          current_year: current_year,
	          incomeStatement: incomeStatement
	        }),
	        section === 4 && isLoading === false && _react2.default.createElement(_section8.default, {
	          step: step,
	          incomeStatement: incomeStatement,
	          costOfSales: costOfSales,
	          netRevenues: netRevenues,
	          rndCosts: rndCosts,
	          promotionCosts: promotionCosts,
	          sellingCosts: sellingCosts,
	          current_year: current_year,
	          data: data,
	          teams: teams,
	          total_demand: total_demand,
	          endingInventory: endingInventory
	        }),
	        section === 5 && isLoading === false && _react2.default.createElement(_section10.default, {
	          step: step,
	          data: data,
	          teams: teams,
	          costOfSales: costOfSales,
	          holdingCosts: holdingCosts,
	          incomeStatement: incomeStatement,
	          current_year: current_year,
	          totalCosts: totalCosts,
	          avgMaterialCostsPerUnit: avgMaterialCostsPerUnit,
	          avgLaborCostsPerUnit: avgLaborCostsPerUnit,
	          avgOverheadCostsPerUnit: avgOverheadCostsPerUnit
	        }),
	        section === 6 && isLoading === false && _react2.default.createElement(_section12.default, {
	          step: step,
	          incomeStatement: incomeStatement,
	          current_year: current_year,
	          interestExpense: interestExpense,
	          data: data,
	          teams: teams,
	          metrics: metrics,
	          financeRaised: financeRaised,
	          returnedToInvestors: returnedToInvestors
	        }),
	        section === 7 && isLoading === false && _react2.default.createElement(_section14.default, {
	          step: step,
	          incomeStatement: incomeStatement,
	          balanceSheet: balanceSheet,
	          cashFlow: cashFlow,
	          current_year: current_year
	        }),
	        isLoading === true && _react2.default.createElement(
	          "div",
	          { className: "team-reports-loading" },
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        )
	      );
	    }
	  }, {
	    key: "expectedNetProfits",
	    get: function get() {
	      return this.getExpectedYearParam(this.current_year, "net_income");
	    }
	  }, {
	    key: "actualNetProfits",
	    get: function get() {
	      return this.getActualYearParam(this.current_year, "net_income");
	    }
	  }, {
	    key: "current_year",
	    get: function get() {
	      var _state3 = this.state,
	          currentRound = _state3.currentRound,
	          roundInUrl = _state3.roundInUrl;
	
	
	      var current_year = currentRound;
	      if (roundInUrl !== null && roundInUrl !== currentRound) {
	        current_year = roundInUrl;
	      }
	
	      return current_year;
	    }
	  }, {
	    key: "isLoading",
	    get: function get() {
	      var _state4 = this.state,
	          loading1 = _state4.loading1,
	          loading2 = _state4.loading2,
	          loading3 = _state4.loading3,
	          loading4 = _state4.loading4,
	          loading5 = _state4.loading5,
	          loading6 = _state4.loading6,
	          loading7 = _state4.loading7,
	          loading8 = _state4.loading8,
	          loading9 = _state4.loading9,
	          loading10 = _state4.loading10,
	          loading11 = _state4.loading11;
	
	
	      return loading1 || loading2 || loading3 || loading4 || loading5 || loading6 || loading7 || loading8 || loading9 || loading10 || loading11;
	    }
	  }]);
	
	  return TeamReports;
	}(_react.PureComponent);
	
	exports.default = TeamReports;

/***/ },
/* 1432 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mapDotsData = exports.mapDotsData = [{
	  x: 64,
	  y: 61,
	  title: 'Jackson, AL'
	}, {
	  x: 51.7,
	  y: 62.8,
	  title: 'Garland, TX'
	}, {
	  x: 13,
	  y: 29.5,
	  title: 'Happy Valley, OR'
	}, {
	  x: 72.5,
	  y: 30.5,
	  title: 'Detroit, MI'
	}, {
	  x: 6,
	  y: 46.5,
	  title: 'Fremont, CA'
	}, {
	  x: 50.5,
	  y: 54.5,
	  title: 'Tulsa, OK'
	}, {
	  x: 48.3,
	  y: 43.7,
	  title: 'Ellsworth, KS'
	}, {
	  x: 56.8,
	  y: 47.9,
	  title: 'Springfield, MO'
	}, {
	  x: 35,
	  y: 47,
	  title: 'Littleton, CO'
	}, {
	  x: 63,
	  y: 27.8,
	  title: 'Sheboygan, WI'
	}, {
	  x: 83.5,
	  y: 29.4,
	  title: 'Henrietta, NY'
	}, {
	  x: 29.5,
	  y: 61.3,
	  title: 'Albuquerque, NM'
	}, {
	  x: 69,
	  y: 47,
	  title: 'Jeffersontown, KY'
	}, {
	  x: 61.5,
	  y: 53.6,
	  title: 'Dyersburg, TN'
	}];

/***/ },
/* 1433 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var selfAssessmentQuestions = exports.selfAssessmentQuestions = ['leverage data', 'being responsive', 'pleasant & fun', 'recognize others', 'follow-through', 'handling conflicts', 'dominates discussions', 'conflict management', 'having relevant knowledge, skills, and abilities', 'expecting quality', 'keeping the team on track', 'interacting with teammates', 'contributing to the teams work'];
	
	var relevantKnowledgeQuestions = exports.relevantKnowledgeQuestions = ['Conflict Management', 'Having Relevant Knowledge, Skills, and Abilities', 'Expecting Quality', 'Keeping the Team on Track', 'Interacting with Teammates', 'Contributing to the Teams Work'];
	
	var handlingConflictsQuestions = exports.handlingConflictsQuestions = ['Leverage data', 'Being responsive', 'Pleasant & fun', 'Recognize others', 'Follow-through', 'Handling Conflicts', 'Dominates discussions'];

/***/ },
/* 1434 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CEO_DECISIONS_VIDEO = exports.CEO_DECISIONS_VIDEO = "https://drive.google.com/file/d/1BKoTLmrcYTsbYNXhUczKuTK3tA8l1yw5/preview";
	var PRODUCT_DEVELOPMENT_DECISIONS_VIDEO = exports.PRODUCT_DEVELOPMENT_DECISIONS_VIDEO = "https://drive.google.com/file/d/177R-3Wcg2Htu27i8QbdjDpdV0mih4_mX/preview";
	var PRODUCT_MARKETING_DECISIONS_VIDEO = exports.PRODUCT_MARKETING_DECISIONS_VIDEO = "https://drive.google.com/file/d/1LEAn7WxSACTftRoV1FlJtzAt49g47u_k/preview";
	var OPERATIONS_DECISIONS_VIDEO = exports.OPERATIONS_DECISIONS_VIDEO = "https://drive.google.com/file/d/1-3_OGPYDvE5d9d70d4jHlDyOTAetSUQ4/preview";
	var FINANCE_DECISIONS_VIDEO = exports.FINANCE_DECISIONS_VIDEO = "https://drive.google.com/file/d/1djbq2B5qQdnzmLP0b2zVPT-WTGM10cQ_/preview";

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ravenJs = __webpack_require__(893);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _mobileDetect = __webpack_require__(2063);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	var _routes = __webpack_require__(1545);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (window && window.navigator) {
	  window.MobileDetect = new _mobileDetect2.default(window.navigator.userAgent);
	}
	
	if (true) {
	  _ravenJs2.default.config("https://206589049b7541ac877bcd8cf298cf55@sentry.io/198375", {
	    captureUnhandledRejections: true
	  }).install();
	}
	
	_reactDom2.default.render(_routes2.default, document.getElementById("root"));

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "orange");
	
	var AddCourseModal = function (_PureComponent) {
	  _inherits(AddCourseModal, _PureComponent);
	
	  function AddCourseModal(props) {
	    _classCallCheck(this, AddCourseModal);
	
	    var _this = _possibleConstructorReturn(this, (AddCourseModal.__proto__ || Object.getPrototypeOf(AddCourseModal)).call(this, props));
	
	    _this.changeInput = function (e) {
	      var input = e.target;
	
	      _this.setState(_defineProperty({}, input.name, input.value));
	    };
	
	    _this.submit = function () {
	      var course_name = _this.state.course_name;
	
	
	      if (course_name === "") {
	        _this.setState({
	          showError: true
	        });
	
	        return;
	      }
	
	      _this.setState({
	        loading: true,
	        showError: false
	      });
	      _this.props.addCourse(course_name, _this.after_submit);
	    };
	
	    _this.after_submit = function () {
	      _this.setState({
	        loading: false,
	        course_name: ""
	      });
	    };
	
	    _this.state = {
	      course_name: "",
	      loading: false,
	      showError: false
	    };
	    return _this;
	  }
	
	  _createClass(AddCourseModal, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          onHide = _props.onHide;
	      var _state = this.state,
	          course_name = _state.course_name,
	          loading = _state.loading,
	          showError = _state.showError;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          dialogClassName: "modal-dialog-instructor",
	          onHide: onHide
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          showError === true && _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            _react2.default.createElement(
	              "b",
	              null,
	              "Course Name"
	            ),
	            " is required!"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Course Name"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "text-center" },
	                    _react2.default.createElement("input", {
	                      name: "course_name",
	                      value: course_name,
	                      onChange: this.changeInput,
	                      className: "form-control"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement("td", null),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: "orange",
	                        onClick: this.submit,
	                        block: true,
	                        disabled: loading
	                      },
	                      loading ? "Loading..." : "Save"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddCourseModal;
	}(_react.PureComponent);
	
	exports.default = AddCourseModal;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 16px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 0 10px;\n\n  &:last-child {\n    justify-content: flex-end;\n  }\n  &:first-child {\n    justify-content: flex-start;\n  }\n"], ["\n  font-family: Lato;\n  font-size: 16px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 0 10px;\n\n  &:last-child {\n    justify-content: flex-end;\n  }\n  &:first-child {\n    justify-content: flex-start;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-align: center;\n\n  h3 {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #36507e;\n  }\n\n  span {\n    color: #74abec;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  display: inline-block;\n  text-align: center;\n\n  h3 {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #36507e;\n  }\n\n  span {\n    color: #74abec;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _peerEvaluationModal = __webpack_require__(256);
	
	var _peerEvaluationModal2 = _interopRequireDefault(_peerEvaluationModal);
	
	var _peerEvaluationFeedback = __webpack_require__(305);
	
	var _peerEvaluationFeedback2 = _interopRequireDefault(_peerEvaluationFeedback);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _sortBy = __webpack_require__(235);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartButton = _styledComponents2.default.div(_templateObject);
	
	var ChartButtonContent = _styledComponents2.default.div(_templateObject2);
	
	var ucFirst = function ucFirst(str) {
	  return str ? str[0].toUpperCase() + str.slice(1) : str;
	};
	
	var ChartViewMore = function (_Component) {
	  _inherits(ChartViewMore, _Component);
	
	  function ChartViewMore(props) {
	    _classCallCheck(this, ChartViewMore);
	
	    var _this = _possibleConstructorReturn(this, (ChartViewMore.__proto__ || Object.getPrototypeOf(ChartViewMore)).call(this, props));
	
	    _this.questionsOrder = function () {
	      var _this$props = _this.props,
	          survey = _this$props.survey,
	          reports = _this$props.reports,
	          userScoreReports = _this$props.userScoreReports;
	      var finalReflectionQuestions = _this.state.finalReflectionQuestions;
	
	      var questions = reports[survey.stage] ? reports[survey.stage].user_score_question || [] : [];
	      var questionsOrder = [];
	
	      if (finalReflectionQuestions.length > 0) {
	        var iLikeQuestions = finalReflectionQuestions.filter(function (q) {
	          return q.text.length >= 61 && q.text.toLowerCase().replace(/\s+/g, ' ').substr(0, 61) === 'i like: in terms of working together, what did you like about';
	        });
	        var iWishQuestions = finalReflectionQuestions.filter(function (q) {
	          return q.text.length >= 54 && q.text.toLowerCase().replace(/\s+/g, ' ').substr(0, 54) === 'i wish: in terms of working together, what do you wish';
	        });
	
	        var usersAnswers = [];
	        if (userScoreReports && userScoreReports[survey.stage] && userScoreReports[survey.stage].freeform_answers) {
	          usersAnswers = userScoreReports[survey.stage].freeform_answers;
	        }
	
	        questionsOrder.push([{ answer_type: "final_reflection_feedback_intro" }].concat(_toConsumableArray(iLikeQuestions.map(function (q) {
	          return {
	            id: q.id,
	            text: q.text,
	            answer_type: "ilike",
	            answers: usersAnswers.filter(function (aa) {
	              return aa.survey_question === q.id;
	            })
	          };
	        })), _toConsumableArray(iWishQuestions.map(function (q) {
	          return {
	            id: q.id,
	            text: q.text,
	            answer_type: "iwish",
	            answers: usersAnswers.filter(function (aa) {
	              return aa.survey_question === q.id;
	            })
	          };
	        })), [{ answer_type: "final_peer_rating_page" }]));
	      }
	
	      var peer_rating_questions = questions.map(function (item, index) {
	        return {
	          id: index + 1,
	          text: item.question,
	          category: 'likert',
	          answer_type: 'rating',
	          value: Math.round(item.median)
	        };
	      });
	
	      peer_rating_questions = [{ answer_type: "peer_rating_feedback_intro" }].concat(_toConsumableArray(peer_rating_questions), [{ answer_type: "final_peer_rating_page" }]);
	
	      questionsOrder.push(peer_rating_questions);
	
	      _this.setState(function () {
	        return {
	          questionsOrder: questionsOrder
	        };
	      });
	    };
	
	    _this.isIntroScreen = function (nextPage, nextId) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextId - 1][nextPage].answer_type;
	
	      return nextId === 1 && (type === "peer_rating_feedback_intro" || type === "final_reflection_feedback_intro");
	    };
	
	    _this.isFinalScreen = function (nextPage, nextId) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextId - 1][nextPage].answer_type;
	
	      return nextId === questionsOrder.length && type === "final_peer_rating_page";
	    };
	
	    _this.isTransitionScreen = function (nextPage, nextId) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextId - 1][nextPage].answer_type;
	
	      return type === "transition_page";
	    };
	
	    _this.handleShowModal = function () {
	      _this.setState(function () {
	        return { show: true };
	      });
	    };
	
	    _this.handleHideModal = function () {
	      _this.setState(function (prevState) {
	        return {
	          show: false,
	          currentPage: 0,
	          currentId: 1,
	          isIntroScreen: true,
	          isFinalScreen: false,
	          isTransitionScreen: false,
	          submitPages: {},
	          progressBar: prevState.progressBar.map(function (item) {
	            return Object.assign({}, item, { progress: 0 });
	          })
	        };
	      });
	    };
	
	    _this.goToNextPage = function () {
	      var _this$state = _this.state,
	          currentPage = _this$state.currentPage,
	          currentId = _this$state.currentId,
	          questionsOrder = _this$state.questionsOrder;
	
	
	      var nextPage = currentPage + 1;
	      var nextId = currentId;
	      if (nextPage > questionsOrder[nextId - 1].length - 1) {
	        nextPage = questionsOrder[nextId - 1].length - 1;
	
	        if (nextId + 1 <= questionsOrder.length) {
	          nextId = nextId + 1;
	          nextPage = 0;
	        }
	      }
	
	      var isIntroScreen = _this.isIntroScreen(nextPage, nextId);
	      var isFinalScreen = _this.isFinalScreen(nextPage, nextId);
	      var isTransitionScreen = _this.isTransitionScreen(nextPage, nextId);
	
	      _this.setState(function (prevState) {
	        return {
	          currentPage: nextPage,
	          currentId: nextId,
	          isIntroScreen: isIntroScreen,
	          isFinalScreen: isFinalScreen,
	          isTransitionScreen: isTransitionScreen,
	          progressBar: prevState.progressBar.map(function (item) {
	            return item.id === nextId ? Object.assign({}, item, {
	              progress: Math.min(nextPage / (questionsOrder[nextId - 1].length - 1) * 100, 100)
	            }) : item;
	          })
	        };
	      });
	    };
	
	    _this.goToPrevPage = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          currentId = _this$state2.currentId,
	          questionsOrder = _this$state2.questionsOrder;
	
	
	      var prevPage = currentPage - 1;
	      var prevId = currentId;
	      if (prevPage < 0) {
	        prevPage = 0;
	
	        if (prevId - 1 >= 1) {
	          prevId = prevId - 1;
	          prevPage = questionsOrder[prevId - 1].length - 1;
	        }
	      }
	
	      var isIntroScreen = _this.isIntroScreen(prevPage, prevId);
	      var isFinalScreen = _this.isFinalScreen(prevPage, prevId);
	      var isTransitionScreen = _this.isTransitionScreen(prevPage, prevId);
	
	      _this.setState(function (prevState) {
	        return {
	          currentPage: prevPage,
	          currentId: prevId,
	          isIntroScreen: isIntroScreen,
	          isFinalScreen: isFinalScreen,
	          isTransitionScreen: isTransitionScreen,
	          progressBar: prevState.progressBar.map(function (item) {
	            return item.id === prevId ? Object.assign({}, item, {
	              progress: Math.min(prevPage / (questionsOrder[prevId - 1].length - 1) * 100, 100)
	            }) : item;
	          })
	        };
	      });
	    };
	
	    var userId = parseInt(_Auth2.default.getUserId(), 10);
	
	    _this.state = {
	      currentUserId: userId,
	      currentTeamId: _Auth2.default.getTeamId(),
	      readonlyMode: true,
	      questionsOrder: [],
	      isIntroScreen: true,
	      isFinalScreen: false,
	      isTransitionScreen: false,
	      currentPage: 0,
	      show: false,
	      progressBar: [],
	      currentId: 1,
	      finalReflectionQuestions: [],
	      teamList: [],
	      submitPages: {}
	    };
	    return _this;
	  }
	
	  _createClass(ChartViewMore, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var survey, finalReflectionQuestions, progressBar;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                survey = this.props.survey;
	                finalReflectionQuestions = survey.questions.filter(function (question) {
	                  return question.category === 'communication' && question.answer_type === 'freeform';
	                });
	                progressBar = [].concat(_toConsumableArray(finalReflectionQuestions.length > 0 ? [{
	                  id: 1,
	                  title: 'Final Reflection',
	                  progress: 0
	                }] : []), [{
	                  id: finalReflectionQuestions.length > 0 ? 2 : 1,
	                  title: "Peer Rating",
	                  progress: 0
	                }]);
	
	
	                this.setState({
	                  progressBar: progressBar,
	                  finalReflectionQuestions: finalReflectionQuestions
	                }, _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _context.next = 2;
	                          return _this2.getTeamList();
	
	                        case 2:
	                        case "end":
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                })));
	
	              case 4:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "getTeamList",
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var _state, currentUserId, currentTeamId, _ref4, users, teamList;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _state = this.state, currentUserId = _state.currentUserId, currentTeamId = _state.currentTeamId;
	                _context3.next = 3;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/players/?team=" + currentTeamId);
	
	              case 3:
	                _ref4 = _context3.sent;
	                users = _ref4.body;
	                teamList = (0, _sortBy2.default)(users.filter(function (teammate) {
	                  return teammate.role !== 'VI' && teammate.team === currentTeamId && teammate.user && teammate.user.id !== currentUserId;
	                }).map(function (teammate) {
	                  return teammate.user;
	                }), "id").map(function (teammate) {
	                  return {
	                    id: teammate.id,
	                    username: teammate.username,
	                    fullname: teammate.first_name + " " + teammate.last_name
	                  };
	                });
	
	
	                this.setState({
	                  teamList: teamList
	                }, function () {
	                  _this3.questionsOrder();
	                });
	
	              case 7:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getTeamList() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getTeamList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var survey = this.props.survey;
	      var _state2 = this.state,
	          show = _state2.show,
	          questionsOrder = _state2.questionsOrder,
	          isIntroScreen = _state2.isIntroScreen,
	          isFinalScreen = _state2.isFinalScreen,
	          isTransitionScreen = _state2.isTransitionScreen,
	          currentPage = _state2.currentPage,
	          progressBar = _state2.progressBar,
	          teamList = _state2.teamList,
	          currentId = _state2.currentId,
	          currentUserId = _state2.currentUserId,
	          submitPages = _state2.submitPages,
	          readonlyMode = _state2.readonlyMode;
	
	
	      var currentQuestion = questionsOrder.length > 0 ? questionsOrder[currentId - 1][currentPage] : null;
	      var hasAnswer = true;
	
	      return _react2.default.createElement(
	        ChartButton,
	        null,
	        _react2.default.createElement(
	          ChartButtonContent,
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            ucFirst(survey.stage),
	            " ",
	            _react2.default.createElement("br", null),
	            " Feedback"
	          ),
	          _react2.default.createElement(
	            "span",
	            { onClick: this.handleShowModal },
	            "View Details >"
	          )
	        ),
	        _react2.default.createElement(
	          _peerEvaluationModal2.default,
	          {
	            surveyId: survey.id,
	            show: show,
	            onHide: this.handleHideModal,
	            onSubmit: this.goToNextPage,
	            progressBar: progressBar,
	            submitButtonText: submitPages[currentPage] ? "Submit" : isIntroScreen ? "Start" : "Save & Continue",
	            currentPage: currentPage ? Number(currentPage) : 0,
	            countOfPages: questionsOrder.length > 0 ? questionsOrder[currentId - 1].length : 0,
	            isInstructorMode: true,
	            goNext: this.goToNextPage,
	            goPrev: this.goToPrevPage,
	            canSubmit: hasAnswer,
	            isIntroScreen: isIntroScreen,
	            isFinalScreen: isFinalScreen,
	            isTransitionScreen: isTransitionScreen,
	            readonlyMode: readonlyMode,
	            linearExtraId: "_peer-review"
	          },
	          !!currentQuestion && _react2.default.createElement(_peerEvaluationFeedback2.default, {
	            question: currentQuestion,
	            answers: [],
	            peer_rating_count: questionsOrder.length > 0 ? questionsOrder[currentId - 1].length - 2 : 0,
	            teamList: teamList,
	            currentUserId: currentUserId,
	            feedbacks: {},
	            readonlyMode: readonlyMode
	          })
	        )
	      );
	    }
	  }]);
	
	  return ChartViewMore;
	}(_react.Component);
	
	exports.default = ChartViewMore;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _customLabel = __webpack_require__(213);
	
	var _customLabel2 = _interopRequireDefault(_customLabel);
	
	var _tooltipContent = __webpack_require__(398);
	
	var _tooltipContent2 = _interopRequireDefault(_tooltipContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HorizontalBar(_ref) {
	  var _ref$prefix = _ref.prefix,
	      prefix = _ref$prefix === undefined ? "" : _ref$prefix,
	      _ref$suffix = _ref.suffix,
	      suffix = _ref$suffix === undefined ? "" : _ref$suffix,
	      _ref$precision = _ref.precision,
	      precision = _ref$precision === undefined ? 2 : _ref$precision,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data,
	      _ref$barSize = _ref.barSize,
	      barSize = _ref$barSize === undefined ? 18 : _ref$barSize,
	      _ref$colors = _ref.colors,
	      colors = _ref$colors === undefined ? [] : _ref$colors,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 200 : _ref$height,
	      _ref$xAxisLine = _ref.xAxisLine,
	      xAxisLine = _ref$xAxisLine === undefined ? true : _ref$xAxisLine,
	      _ref$xAxisTick = _ref.xAxisTick,
	      xAxisTick = _ref$xAxisTick === undefined ? false : _ref$xAxisTick,
	      _ref$hideYAxis = _ref.hideYAxis,
	      hideYAxis = _ref$hideYAxis === undefined ? true : _ref$hideYAxis,
	      _ref$showBarLabel = _ref.showBarLabel,
	      showBarLabel = _ref$showBarLabel === undefined ? false : _ref$showBarLabel,
	      _ref$showIntegerLabel = _ref.showIntegerLabel,
	      showIntegerLabel = _ref$showIntegerLabel === undefined ? false : _ref$showIntegerLabel;
	
	  return _react2.default.createElement(
	    _recharts.ResponsiveContainer,
	    { width: "100%", height: height },
	    _react2.default.createElement(
	      _recharts.BarChart,
	      { data: data, barSize: barSize },
	      _react2.default.createElement(_recharts.XAxis, { dataKey: "name", tickLine: false, tick: xAxisTick, axisLine: xAxisLine }),
	      _react2.default.createElement(_recharts.YAxis, { hide: hideYAxis, axisLine: false, tickLine: false }),
	      _react2.default.createElement(_recharts.Tooltip, { content: _react2.default.createElement(_tooltipContent2.default, { prefix: prefix, suffix: suffix }) }),
	      _react2.default.createElement(
	        _recharts.Bar,
	        {
	          dataKey: "value",
	          minPointSize: 5,
	          isAnimationActive: !showBarLabel,
	          label: _react2.default.createElement(_customLabel2.default, {
	            prefix: prefix,
	            suffix: suffix,
	            precision: precision,
	            showIntegerLabel: showIntegerLabel
	          })
	        },
	        colors.map(function (color, i) {
	          return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	        })
	      )
	    )
	  );
	}
	
	exports.default = HorizontalBar;

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _Teams = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderLabel(props) {
	  var percent = (props.percent * 100).toFixed(0);
	
	  return _react2.default.createElement(
	    _recharts.Text,
	    Object.assign({}, props, {
	      alignmentBaseline: "middle",
	      className: "recharts-pie-label-text"
	    }),
	    percent + "%"
	  );
	}
	
	function formatMillions(val) {
	  var valStr = (val / 1000000).toFixed(2);
	  return valStr + "M";
	}
	
	function MarketCaptureChart(_ref) {
	  var data = _ref.data,
	      colors = _ref.colors,
	      totalDemand = _ref.totalDemand;
	
	  var unmetDemand = totalDemand;
	  var result = data.map(function (item) {
	    var name = item.name,
	        value = item.value;
	
	    unmetDemand -= value;
	
	    return {
	      name: name,
	      value: value
	    };
	  });
	
	  result.push({
	    name: "Unmet Demand",
	    value: unmetDemand
	  });
	
	  var teams_count = result.length - 1;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "donut-chart donut-chart-us" },
	    _react2.default.createElement(
	      _recharts.ResponsiveContainer,
	      { width: "100%", height: 235 },
	      _react2.default.createElement(
	        _recharts.PieChart,
	        null,
	        _react2.default.createElement(
	          _recharts.Pie,
	          {
	            data: result,
	            dataKey: "value",
	            cx: "50%",
	            cy: "50%",
	            innerRadius: 60,
	            outerRadius: 80,
	            fill: "#8884d8",
	            label: renderLabel,
	            labelLine: true
	          },
	          _react2.default.createElement(_recharts.Label, {
	            position: "center",
	            value: "Total Demand: " + formatMillions(totalDemand)
	          }),
	          colors.slice(0, teams_count).map(function (color, i) {
	            return _react2.default.createElement(_recharts.Cell, { key: i, fill: color });
	          }),
	          _react2.default.createElement(_recharts.Cell, { fill: _Teams.UNMET_DEMAND_COLOR })
	        ),
	        _react2.default.createElement(_recharts.Tooltip, { formatter: formatMillions })
	      )
	    )
	  );
	}
	
	exports.default = MarketCaptureChart;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "orange");
	
	var CreateGameModal = function (_PureComponent) {
	  _inherits(CreateGameModal, _PureComponent);
	
	  function CreateGameModal(props) {
	    _classCallCheck(this, CreateGameModal);
	
	    var _this = _possibleConstructorReturn(this, (CreateGameModal.__proto__ || Object.getPrototypeOf(CreateGameModal)).call(this, props));
	
	    _this.changeInput = function (e) {
	      var input = e.target;
	
	      _this.setState(_defineProperty({}, input.name, input.value));
	    };
	
	    _this.changeSelect = function (e) {
	      var select = e.target;
	      var value = parseInt(select.value, 10);
	      if (isNaN(value)) {
	        value = 0;
	      }
	
	      _this.setState(_defineProperty({}, select.name, value));
	    };
	
	    _this.submit = function () {
	      var _this$state = _this.state,
	          game_name = _this$state.game_name,
	          course_id = _this$state.course_id,
	          number_of_students = _this$state.number_of_students;
	
	
	      if (game_name === "") {
	        _this.setState({
	          showError1: true,
	          showError2: false,
	          showError3: false
	        });
	
	        return;
	      }
	
	      if (course_id < 1) {
	        _this.setState({
	          showError1: false,
	          showError2: true,
	          showError3: false
	        });
	
	        return;
	      }
	
	      var number = parseInt("0" + number_of_students, 10);
	      if (isNaN(number)) {
	        number = 0;
	      }
	
	      if (number < 1) {
	        _this.setState({
	          showError1: false,
	          showError2: false,
	          showError3: true
	        });
	
	        return;
	      }
	
	      _this.setState({
	        loading: true,
	        showError1: false,
	        showError2: false,
	        showError3: false
	      });
	      _this.props.createGame(game_name, course_id, number, _this.after_submit);
	    };
	
	    _this.after_submit = function () {
	      _this.setState({
	        loading: false,
	        game_name: "",
	        course_id: 0,
	        number_of_students: ""
	      });
	    };
	
	    _this.state = {
	      game_name: "",
	      course_id: 0,
	      number_of_students: "",
	      loading: false,
	      showError1: false,
	      showError2: false,
	      showError3: false
	    };
	    return _this;
	  }
	
	  _createClass(CreateGameModal, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          onHide = _props.onHide,
	          courses = _props.courses;
	      var _state = this.state,
	          game_name = _state.game_name,
	          loading = _state.loading,
	          showError1 = _state.showError1,
	          showError2 = _state.showError2,
	          showError3 = _state.showError3,
	          number_of_students = _state.number_of_students,
	          course_id = _state.course_id;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          dialogClassName: "modal-dialog-instructor",
	          onHide: onHide
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          showError1 === true && _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            _react2.default.createElement(
	              "b",
	              null,
	              "Game Name"
	            ),
	            " is required!"
	          ),
	          showError2 === true && _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            _react2.default.createElement(
	              "b",
	              null,
	              "Course"
	            ),
	            " is required!"
	          ),
	          showError3 === true && _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            _react2.default.createElement(
	              "b",
	              null,
	              "Number of students"
	            ),
	            " is required!"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "text-center" },
	                    _react2.default.createElement("input", {
	                      name: "game_name",
	                      value: game_name,
	                      onChange: this.changeInput,
	                      className: "form-control",
	                      placeholder: "Game Name"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        name: "course_id",
	                        onChange: this.changeSelect,
	                        value: course_id
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "0" },
	                        "Select Course"
	                      ),
	                      courses.map(function (course, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: course.id },
	                          course.name
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "text-center" },
	                    _react2.default.createElement("input", {
	                      name: "number_of_students",
	                      value: number_of_students,
	                      onChange: this.changeInput,
	                      className: "form-control",
	                      placeholder: "Input # of Students"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: "orange",
	                        onClick: this.submit,
	                        block: true,
	                        disabled: loading
	                      },
	                      loading ? "Loading..." : "Save"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateGameModal;
	}(_react.PureComponent);
	
	exports.default = CreateGameModal;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatNumber(val, precision) {
	  return val.toFixed(precision);
	}
	
	function CustomLabel(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      value = _ref.value,
	      prefix = _ref.prefix,
	      suffix = _ref.suffix,
	      precision = _ref.precision,
	      _ref$layout = _ref.layout,
	      layout = _ref$layout === undefined ? "horizontal" : _ref$layout,
	      _ref$xOffset = _ref.xOffset,
	      xOffset = _ref$xOffset === undefined ? 30 : _ref$xOffset,
	      _ref$yOffset = _ref.yOffset,
	      yOffset = _ref$yOffset === undefined ? 10 : _ref$yOffset,
	      _ref$hideZero = _ref.hideZero,
	      hideZero = _ref$hideZero === undefined ? false : _ref$hideZero,
	      _ref$tooltipContent = _ref.tooltipContent,
	      tooltipContent = _ref$tooltipContent === undefined ? "" : _ref$tooltipContent;
	
	  var xxOffset = layout === "horizontal" ? x + width / 2 : value < 0 ? x + width - xOffset : x + width + xOffset;
	  var yyOffset = layout === "vertical" ? y + height / 2 : value < 0 ? y + yOffset : y - yOffset;
	  var className = value < 0 ? "red" : null;
	  var val = hideZero === true && value === 0 ? "n/a" : "" + prefix + formatNumber(value, precision) + suffix;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: xxOffset,
	      y: yyOffset,
	      className: className,
	      textAnchor: "middle",
	      dominantBaseline: "middle"
	    },
	    tooltipContent !== "" ? tooltipContent : val
	  );
	}
	
	var DashboardBarChart = function DashboardBarChart(_ref2) {
	  var height = _ref2.height,
	      color = _ref2.color,
	      value = _ref2.value,
	      _ref2$labelOffset = _ref2.labelOffset,
	      labelOffset = _ref2$labelOffset === undefined ? 20 : _ref2$labelOffset,
	      _ref2$labelYOffset = _ref2.labelYOffset,
	      labelYOffset = _ref2$labelYOffset === undefined ? 10 : _ref2$labelYOffset,
	      _ref2$rightMargin = _ref2.rightMargin,
	      rightMargin = _ref2$rightMargin === undefined ? 45 : _ref2$rightMargin,
	      _ref2$animation = _ref2.animation,
	      animation = _ref2$animation === undefined ? true : _ref2$animation,
	      _ref2$labelSuffix = _ref2.labelSuffix,
	      labelSuffix = _ref2$labelSuffix === undefined ? "" : _ref2$labelSuffix,
	      _ref2$tooltipContent = _ref2.tooltipContent,
	      tooltipContent = _ref2$tooltipContent === undefined ? "" : _ref2$tooltipContent;
	  return _react2.default.createElement(
	    _recharts.ResponsiveContainer,
	    { width: "100%", height: height },
	    _react2.default.createElement(
	      _recharts.BarChart,
	      {
	        data: [{ value: value }],
	        layout: "vertical",
	        margin: { top: 0, left: 0, right: rightMargin, bottom: 0 }
	      },
	      _react2.default.createElement(_recharts.XAxis, { type: "number", hide: true, domain: [0, 100] }),
	      _react2.default.createElement(_recharts.YAxis, { type: "category", hide: true }),
	      _react2.default.createElement(_recharts.Bar, {
	        isAnimationActive: animation,
	        dataKey: "value",
	        fill: color,
	        minPointSize: 5,
	        label: _react2.default.createElement(CustomLabel, {
	          prefix: "",
	          precision: 0,
	          suffix: labelSuffix,
	          xOffset: labelOffset,
	          yOffset: labelYOffset,
	          layout: "vertical",
	          tooltipContent: tooltipContent
	        })
	      })
	    )
	  );
	};
	
	exports.default = DashboardBarChart;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dropdownArrow = __webpack_require__(685);
	
	var _dropdownArrow2 = _interopRequireDefault(_dropdownArrow);
	
	var _dashboard = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardSelectMultiple = function (_PureComponent) {
	  _inherits(DashboardSelectMultiple, _PureComponent);
	
	  function DashboardSelectMultiple(props) {
	    _classCallCheck(this, DashboardSelectMultiple);
	
	    var _this = _possibleConstructorReturn(this, (DashboardSelectMultiple.__proto__ || Object.getPrototypeOf(DashboardSelectMultiple)).call(this, props));
	
	    _this.toggling = function () {
	      var isOpen = _this.state.isOpen;
	
	
	      _this.setState({
	        isOpen: !isOpen
	      });
	    };
	
	    _this.onOptionClicked1 = function (value, callback) {
	      return function () {
	        _this.setState({
	          selectedOption1: value,
	          isOpen: false
	        }, function () {
	          if (callback) {
	            callback(value);
	          }
	        });
	      };
	    };
	
	    _this.onOptionClicked2 = function (value, callback) {
	      return function () {
	        _this.setState({
	          selectedOption2: value,
	          isOpen: false
	        }, function () {
	          if (callback) {
	            callback(value);
	          }
	        });
	      };
	    };
	
	    _this.handleClickOutside = function (e) {
	      var isOpen = _this.state.isOpen;
	
	
	      if (isOpen && _this.wrapperRef && !_this.wrapperRef.contains(e.target)) {
	        _this.setState({
	          isOpen: false
	        });
	      }
	    };
	
	    _this.state = {
	      isOpen: false,
	      selectedOption1: null,
	      selectedOption2: null
	    };
	
	    _this.wrapperRef = null;
	    return _this;
	  }
	
	  _createClass(DashboardSelectMultiple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      document.addEventListener("mousedown", this.handleClickOutside);
	      var dummyCallback = function dummyCallback() {};
	
	      if (this.props.setValueCallback1) {
	        var onChange1 = this.props.onChange1 || dummyCallback;
	
	        this.props.setValueCallback1(function (value) {
	          _this2.onOptionClicked1(value, onChange1)();
	        });
	      }
	
	      if (this.props.setValueCallback2) {
	        var onChange2 = this.props.onChange2 || dummyCallback;
	
	        this.props.setValueCallback2(function (value) {
	          _this2.onOptionClicked2(value, onChange2)();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("mousedown", this.handleClickOutside);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          isOpen = _state.isOpen,
	          selectedOption1 = _state.selectedOption1,
	          selectedOption2 = _state.selectedOption2;
	      var _props = this.props,
	          options1 = _props.options1,
	          options2 = _props.options2;
	
	      var DropDownHeaderComponent = this.props.DropDownHeader || _dashboard.DropDownHeader;
	      var DropDownListContainerComponent = this.props.DropDownListContainer || _dashboard.DropDownListContainer;
	      var DropDownListComponent = this.props.DropDownList || _dashboard.DropDownList;
	      var dummyCallback = function dummyCallback() {};
	      var onChange1 = this.props.onChange1 || dummyCallback;
	      var onChange2 = this.props.onChange2 || dummyCallback;
	
	      return _react2.default.createElement(
	        _dashboard.DropDownContainer,
	        {
	          innerRef: function innerRef(wrapperRef) {
	            _this3.wrapperRef = wrapperRef;
	          }
	        },
	        _react2.default.createElement(
	          DropDownHeaderComponent,
	          {
	            onClick: this.toggling,
	            title: this.title
	          },
	          this.title,
	          _react2.default.createElement(
	            _dashboard.DropDownHeaderArrow,
	            null,
	            _react2.default.createElement('img', { src: _dropdownArrow2.default, alt: '' })
	          )
	        ),
	        isOpen && _react2.default.createElement(
	          DropDownListContainerComponent,
	          null,
	          _react2.default.createElement(
	            DropDownListComponent,
	            null,
	            options1.map(function (option, i) {
	              return _react2.default.createElement(
	                _dashboard.DropDownListItem,
	                {
	                  key: 'option1-' + i,
	                  onClick: _this3.onOptionClicked1(option, onChange1),
	                  isSelected: selectedOption1 === option ? true : false
	                },
	                option
	              );
	            }),
	            options2.map(function (option, i) {
	              return _react2.default.createElement(
	                _dashboard.DropDownListItem,
	                {
	                  key: 'option2-' + i,
	                  onClick: _this3.onOptionClicked2(option, onChange2),
	                  isSelected: selectedOption2 === option ? true : false
	                },
	                option
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'title',
	    get: function get() {
	      var _state2 = this.state,
	          selectedOption1 = _state2.selectedOption1,
	          selectedOption2 = _state2.selectedOption2;
	      var placeholder = this.props.placeholder;
	
	
	      var result = [];
	      if (selectedOption1) {
	        result.push(selectedOption1);
	      }
	
	      if (selectedOption2) {
	        result.push(selectedOption2);
	      }
	
	      return result.length > 0 ? result.join(' / ') : placeholder;
	    }
	  }]);
	
	  return DashboardSelectMultiple;
	}(_react.PureComponent);
	
	exports.default = DashboardSelectMultiple;

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "orange");
	
	var EditCourseModal = function (_PureComponent) {
	  _inherits(EditCourseModal, _PureComponent);
	
	  function EditCourseModal(props) {
	    _classCallCheck(this, EditCourseModal);
	
	    var _this = _possibleConstructorReturn(this, (EditCourseModal.__proto__ || Object.getPrototypeOf(EditCourseModal)).call(this, props));
	
	    _this.changeInput = function (e) {
	      var input = e.target;
	
	      _this.setState(_defineProperty({}, input.name, input.value));
	    };
	
	    _this.submit = function () {
	      var course_name = _this.state.course_name;
	
	
	      if (course_name === "") {
	        _this.setState({
	          showError: true
	        });
	
	        return;
	      }
	
	      _this.setState({
	        loading: true,
	        showError: false
	      });
	      _this.props.editCourse(course_name, _this.after_submit);
	    };
	
	    _this.after_submit = function () {
	      _this.setState({
	        loading: false,
	        course_name: ""
	      });
	    };
	
	    _this.state = {
	      course_name: props.currentCourse ? props.currentCourse.name : "",
	      course_id: props.currentCourse ? props.currentCourse.id : 0,
	      loading: false,
	      showError: false
	    };
	    return _this;
	  }
	
	  _createClass(EditCourseModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var course_id = nextProps.currentCourse ? nextProps.currentCourse.id : 0;
	      var course_name = nextProps.currentCourse ? nextProps.currentCourse.name : "";
	
	      if (this.state.course_id !== course_id) {
	        this.setState({
	          course_name: course_name,
	          course_id: course_id,
	          showError: false,
	          loading: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          onHide = _props.onHide;
	      var _state = this.state,
	          course_name = _state.course_name,
	          loading = _state.loading,
	          showError = _state.showError;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        {
	          show: show,
	          dialogClassName: "modal-dialog-instructor",
	          onHide: onHide
	        },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          showError === true && _react2.default.createElement(
	            "div",
	            { className: "alert alert-danger" },
	            _react2.default.createElement(
	              "b",
	              null,
	              "Course Name"
	            ),
	            " is required!"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Course Name"
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "text-center" },
	                    _react2.default.createElement("input", {
	                      name: "course_name",
	                      value: course_name,
	                      onChange: this.changeInput,
	                      className: "form-control"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement("td", null),
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: "orange",
	                        onClick: this.submit,
	                        block: true,
	                        disabled: loading
	                      },
	                      loading ? "Loading..." : "Save"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditCourseModal;
	}(_react.PureComponent);
	
	exports.default = EditCourseModal;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputPercentage = function (_PureComponent) {
	  _inherits(InputPercentage, _PureComponent);
	
	  function InputPercentage(props) {
	    _classCallCheck(this, InputPercentage);
	
	    var _this = _possibleConstructorReturn(this, (InputPercentage.__proto__ || Object.getPrototypeOf(InputPercentage)).call(this, props));
	
	    _this.handleInputChange = function (event) {
	      var onInputChange = _this.props.onInputChange;
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	
	      _this.setState({
	        newValue: value
	      }, function () {
	        onInputChange(name, value);
	      });
	    };
	
	    _this.state = {
	      newValue: 0
	    };
	    return _this;
	  }
	
	  _createClass(InputPercentage, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          _props$disabled = _props.disabled,
	          disabled = _props$disabled === undefined ? false : _props$disabled;
	      var newValue = this.state.newValue;
	
	
	      var displayValue = newValue ? newValue : value;
	
	      return _react2.default.createElement(
	        _ui.InputWrapper,
	        null,
	        _react2.default.createElement(_ui.Input, {
	          type: "number",
	          value: displayValue,
	          onChange: this.handleInputChange,
	          name: name,
	          disabled: disabled
	        })
	      );
	    }
	  }]);
	
	  return InputPercentage;
	}(_react.PureComponent);
	
	exports.default = InputPercentage;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px 29px 40px 30px;;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n'], ['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px 29px 40px 30px;;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 1px;\n  height: 16px;\n  background: #2da548;\n  margin-left: 10px;\n'], ['\n  width: 1px;\n  height: 16px;\n  background: #2da548;\n  margin-left: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  img {\n    margin-right: 9px;\n    width: 21px;\n    height: 21px;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  img {\n    margin-right: 9px;\n    width: 21px;\n    height: 21px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _onboardingCheck = __webpack_require__(301);
	
	var _onboardingCheck2 = _interopRequireDefault(_onboardingCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Line = _styledComponents2.default.div(_templateObject2);
	
	var Step = _styledComponents2.default.div(_templateObject3);
	
	var Navigation = function Navigation(_ref) {
	  var data = _ref.data,
	      category = _ref.category,
	      activeRound = _ref.activeRound;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    data.map(function (link, index) {
	      if (!!link.parent) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        { key: 'section-' + index },
	        _react2.default.createElement(
	          Step,
	          null,
	          _react2.default.createElement('img', { src: _onboardingCheck2.default, alt: 'nav icon' }),
	          index !== category && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: link.steps[0].url + '?round=' + activeRound },
	            link.title
	          ),
	          index === category && link.title
	        ),
	        index < data.length - 1 && _react2.default.createElement(Line, null)
	      );
	    })
	  );
	};
	
	exports.default = Navigation;

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  height: 80px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 170px 20px 40px;\n  width: 100%;\n'], ['\n  height: 80px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 170px 20px 40px;\n  width: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  img {\n    margin-right: 5px;\n  }\n\n  &:active, &:visited, &:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgba(0, 27, 59, 0.6);\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ', '\n'], ['\n  img {\n    margin-right: 5px;\n  }\n\n  &:active, &:visited, &:link {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 16px;\n    color: rgba(0, 27, 59, 0.6);\n    text-decoration: none;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  &:active, &:visited, &:link {\n    width: 160px;\n    height: 40px;\n    background: #5c91f5;\n    border-radius: 4px;\n    text-align: center;\n    line-height: 40px;\n\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n\n    ', '\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n'], ['\n  &:active, &:visited, &:link {\n    width: 160px;\n    height: 40px;\n    background: #5c91f5;\n    border-radius: 4px;\n    text-align: center;\n    line-height: 40px;\n\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n\n    ', '\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _onboardingChevron = __webpack_require__(252);
	
	var _onboardingChevron2 = _interopRequireDefault(_onboardingChevron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PrevButton = _styledComponents2.default.a(_templateObject2, function (p) {
	  return p.isHidden && '\n    visibility: hidden;\n  ';
	});
	
	var Text = _styledComponents2.default.div(_templateObject3);
	
	var NextButton = _styledComponents2.default.a(_templateObject4, function (p) {
	  return p.isHidden && '\n      visibility: hidden;\n    ';
	});
	
	var Pagination = function Pagination(_ref) {
	  var goNext = _ref.goNext,
	      goPrev = _ref.goPrev,
	      isFirstStep = _ref.isFirstStep,
	      isLastStep = _ref.isLastStep,
	      currentStep = _ref.currentStep,
	      countOfSteps = _ref.countOfSteps;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      PrevButton,
	      {
	        href: '#',
	        onClick: goPrev,
	        isHidden: isFirstStep
	      },
	      _react2.default.createElement('img', { src: _onboardingChevron2.default, alt: '' }),
	      'Previous'
	    ),
	    _react2.default.createElement(
	      Text,
	      null,
	      currentStep,
	      '/',
	      countOfSteps
	    ),
	    _react2.default.createElement(
	      NextButton,
	      {
	        href: '#',
	        onClick: goNext,
	        isHidden: isLastStep
	      },
	      'Next'
	    )
	  );
	};
	
	exports.default = Pagination;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _Location = __webpack_require__(23);
	
	var _utils = __webpack_require__(18);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ui = __webpack_require__(408);
	
	var _inputPercentage = __webpack_require__(1444);
	
	var _inputPercentage2 = _interopRequireDefault(_inputPercentage);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// "Scoring Weights" page — consolidated home for:
	//   1. Round Weights   (formerly under Team Score / Round Targets)
	//      Per-round grading weight, summed across all rounds = 100%.
	//      Drives how each round's score contributes to the cumulative
	//      Team Score.
	//   2. Score Weights   (formerly the only thing on this page)
	//      How the four activity scores combine into an individual
	//      score: team + peer + feedback submission + engagement.
	//      Sum must equal 100%.
	//
	// Both sections share the alert + success surface at the top.
	var OverallScore = function (_PureComponent) {
	  _inherits(OverallScore, _PureComponent);
	
	  function OverallScore(props) {
	    _classCallCheck(this, OverallScore);
	
	    var _this = _possibleConstructorReturn(this, (OverallScore.__proto__ || Object.getPrototypeOf(OverallScore)).call(this, props));
	
	    _this.handleScoreWeightChange = function (name, value) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'scoreWeightsChanged', true), _this$setState));
	    };
	
	    _this.submitScoreWeights = function () {
	      var _this$state = _this.state,
	          teamScore = _this$state.teamScore,
	          peerScore = _this$state.peerScore,
	          feedbackSubmission = _this$state.feedbackSubmission,
	          engagementScore = _this$state.engagementScore,
	          gradingWeightsID = _this$state.gradingWeightsID,
	          courseID = _this$state.courseID;
	
	
	      var sum = Number(teamScore) + Number(peerScore) + Number(feedbackSubmission) + Number(engagementScore);
	
	      if (sum !== 100) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Must equal 100%',
	          errorMessage: "The sum of the score weights doesn't equal 100%. Adjust the values so they total 100%."
	        });
	        return;
	      }
	
	      // No existing row for this course yet (typical when the
	      // instructor lands on Grading before onboarding created the row).
	      // POST to create instead of PUTting to /gradingweights/0/.
	      var resolvedCourseId = Number(courseID) || Number(_Auth2.default.getCourseId());
	      var payload = {
	        team_grade: teamScore / 100,
	        peer_weight: peerScore / 100,
	        feedback_submission: feedbackSubmission / 100,
	        engagement_score: engagementScore / 100,
	        course: resolvedCourseId
	      };
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var req = gradingWeightsID ? (0, _ApiService.putRequest)(apiUrl + 'v2/games/gradingweights/' + gradingWeightsID + '/').send(payload) : (0, _ApiService.postRequest)(apiUrl + 'v2/games/gradingweights/').send(payload);
	
	      req.then(function (res) {
	        var newId = res && res.body && res.body.id;
	        _this.setState({
	          scoreWeightsChanged: false,
	          showSuccess: true,
	          successMessage: 'The score weights are updated.',
	          gradingWeightsID: newId || gradingWeightsID,
	          courseID: resolvedCourseId
	        });
	      }).catch(function () {});
	    };
	
	    _this.handleRoundWeightChange = function (name, value) {
	      var roundsWeights = _lodash2.default.cloneDeep(_this.state.roundsWeights);
	      var index = roundsWeights.findIndex(function (i) {
	        return i.number === Number(name);
	      });
	      if (index < 0) return;
	      roundsWeights[index].gradingWeight = value;
	      _this.setState({
	        roundsWeights: roundsWeights,
	        roundsWeightsValueChanged: true
	      });
	    };
	
	    _this.submitRoundWeights = function () {
	      var _this$state2 = _this.state,
	          roundsWeights = _this$state2.roundsWeights,
	          isDefaultRoundsActive = _this$state2.isDefaultRoundsActive,
	          courseID = _this$state2.courseID;
	
	
	      if (isDefaultRoundsActive) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Rounds not set up',
	          errorMessage: _react2.default.createElement(
	            'span',
	            null,
	            'You\'ll need to activate rounds before you can set round weights.',
	            ' ',
	            _react2.default.createElement(
	              'span',
	              {
	                role: 'button',
	                tabIndex: 0,
	                onClick: function onClick() {
	                  return (0, _Location.changeLocation)('/instructor/rounds');
	                },
	                onKeyDown: function onKeyDown(e) {
	                  if (e.key === 'Enter' || e.key === ' ') {
	                    (0, _Location.changeLocation)('/instructor/rounds');
	                  }
	                },
	                style: {
	                  color: '#5c91f5',
	                  cursor: 'pointer',
	                  textDecoration: 'underline',
	                  fontWeight: 600
	                }
	              },
	              'Set up Rounds'
	            ),
	            '.'
	          )
	        });
	        return;
	      }
	
	      // Only rounds that have a backing record on the BE (round_api or
	      // scheduler) can be saved. Rounds without a record (source =
	      // 'default') are rendered as disabled inputs so they're already
	      // excluded from edits — here we also skip them from the sum
	      // validation and PUT list.
	      var savableRounds = roundsWeights.filter(function (r) {
	        return r.source !== 'default';
	      });
	      if (savableRounds.length === 0) {
	        // Shouldn't be reachable through the UI (the whole section is
	        // hidden when every round is default-sourced) but guard anyway.
	        return;
	      }
	
	      var sum = savableRounds.reduce(function (partial, round) {
	        return partial + Number(round.gradingWeight);
	      }, 0);
	      // Tolerate ≤1% float / rounding slop so the 33.33 × 3 = 99.99
	      // default still saves without forcing the instructor to tweak
	      // one row to 33.34 by hand.
	      if (Math.abs(sum - 100) > 1) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Must equal 100%',
	          errorMessage: "The sum of all round weights doesn't equal 100%. Adjust the values so they total 100%."
	        });
	        return;
	      }
	
	      // Target endpoint tracks the slot's source so the PUT always hits
	      // the record the display is reading from:
	      //   source='round_api' → PUT /game/rounds/<id>/
	      //   source='scheduler' → PUT /v2/games/roundschedulers/<id>/
	      // In the normal case this collapses to the spec: game.reset=0
	      // slots are all scheduler-sourced; game.reset=1 slots are all
	      // round-api-sourced. The source-based branch also covers the
	      // edge case where game.reset=1 but a round API record is missing
	      // for one of the rounds, in which case the display fell back to
	      // the scheduler and we must update the scheduler, not 404 on a
	      // non-existent round API record.
	      //
	      // Promise.all so success/error only flips after every PUT settles
	      // (the old forEach was fire-and-forget and silently masked
	      // partial failures). Also bust the general-info cache so the
	      // Rounds page's next fetchAppGeneralInfo hits the wire and picks
	      // up the new weights — Round Admin already does this after inline
	      // edits.
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var requests = savableRounds.map(function (round) {
	        if (round.source === 'round_api') {
	          return (0, _ApiService.putRequest)(apiUrl + 'game/rounds/' + round.id + '/').send({
	            grading_weight: Number(round.gradingWeight) / 100,
	            number: round.number,
	            game: round.game,
	            end_date: round.endDate,
	            start_date: round.startDate
	          });
	        }
	        // source === 'scheduler'
	        return (0, _ApiService.putRequest)(apiUrl + 'v2/games/roundschedulers/' + round.id + '/').send({
	          grading_weight: Number(round.gradingWeight) / 100,
	          round_number: round.number,
	          course: courseID,
	          practice: false,
	          start_date: round.startDate,
	          end_date: round.endDate
	        });
	      });
	
	      Promise.all(requests).then(function () {
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	        _this.setState({
	          showSuccess: true,
	          successMessage: 'The round weights are updated.',
	          roundsWeightsValueChanged: false
	        });
	      }).catch(function () {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Update Failed',
	          errorMessage: "Couldn't save all round weights. Please try again."
	        });
	      });
	    };
	
	    _this.hideError = function () {
	      _this.setState({ showError: false });
	    };
	
	    _this.hideSuccess = function () {
	      _this.setState({ showSuccess: false });
	    };
	
	    _this.state = {
	      loaded: false,
	      // Score weights (gradingweights endpoint)
	      teamScore: 0,
	      peerScore: 0,
	      feedbackSubmission: 0,
	      engagementScore: 0,
	      gradingWeightsID: 0,
	      courseID: 0,
	      scoreWeightsChanged: false,
	      // Round weights: array of exactly 3 slots keyed by round number,
	      // each carrying `source` ('round_api' | 'scheduler' | 'default')
	      // and the id + fields needed to PUT back to the right endpoint.
	      // Source is picked from the fallback chain:
	      //   game.reset=1  →  round API → scheduler → default
	      //   game.reset=0  →  scheduler → default
	      roundsWeights: [],
	      roundsWeightsValueChanged: false,
	      isDefaultRoundsActive: false,
	      gameType: null,
	      // game.reset flag — toggles whether updates go to the round API
	      // or to the scheduler endpoint.
	      gameReset: false,
	      // Shared alert surface
	      showError: false,
	      errorTitle: '',
	      errorMessage: '',
	      showSuccess: false,
	      successMessage: ''
	    };
	    return _this;
	  }
	
	  _createClass(OverallScore, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var courseId = Number(_Auth2.default.getCourseId());
	      var gameId = Number(_Auth2.default.getGameId());
	
	      Promise.all([(0, _ApiService.batchRequest)([
	      // Scope by course. Without ?course= the BE returns a paginated
	      // list across every course this instructor touches, and
	      // results[0] is whichever row happens to sort first (often a
	      // foreign course). That's how gradingWeightsID ended up as 0
	      // here: the fetch returned no row for the current course, we
	      // fell back to the default 0, and the PUT went to
	      // /gradingweights/0/. Defensive filter below matches the
	      // TeamEvaluationSurvey pattern.
	      apiUrl + 'v2/games/gradingweights/?course=' + courseId, apiUrl + 'game/rounds/', apiUrl + 'courses/' + courseId + '/', apiUrl + 'v2/games/roundschedulers/']),
	      // general-info gives us the game.reset flag; the service is cached
	      // and in-flight-deduped so this piggybacks on App.js's own call
	      // without a second roundtrip when the cache is warm.
	      (0, _AppGeneralInfoService.fetchAppGeneralInfo)(gameId, 'instructor').catch(function () {
	        return {};
	      })]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            res = _ref2[0],
	            generalInfo = _ref2[1];
	
	        var gwBody = res[0] && res[0].body || {};
	        var gwRaw = Array.isArray(gwBody) ? gwBody : gwBody.results || [];
	        var gwMatched = gwRaw.filter(function (r) {
	          return Number(r.course) === Number(courseId);
	        });
	        var gradingWeights = gwMatched[0] || null;
	        var courseBody = res[2] && res[2].body || {};
	        var rawGameType = courseBody.game_type || null;
	        var gameType = rawGameType ? rawGameType.charAt(0).toUpperCase() + rawGameType.slice(1).toLowerCase() : null;
	
	        var scoreWeightsState = {};
	        if (gradingWeights) {
	          scoreWeightsState = {
	            teamScore: gradingWeights.team_grade ? Number(gradingWeights.team_grade * 100).toFixed(2) : '0.00',
	            peerScore: gradingWeights.peer_weight ? Number(gradingWeights.peer_weight * 100).toFixed(2) : '0.00',
	            feedbackSubmission: gradingWeights.feedback_submission ? Number(gradingWeights.feedback_submission * 100).toFixed(2) : '0.00',
	            engagementScore: gradingWeights.engagement_score ? Number(gradingWeights.engagement_score * 100).toFixed(2) : '0.00',
	            gradingWeightsID: gradingWeights.id,
	            courseID: gradingWeights.course
	          };
	        }
	
	        var roundsFromApi = Array.isArray(res[1].body) ? res[1].body : [];
	        var schedulersBody = res[3] && res[3].body;
	        var schedulersRaw = Array.isArray(schedulersBody) ? schedulersBody : schedulersBody && schedulersBody.results || [];
	
	        // game.reset lives on the game record returned by general-info.
	        var games = generalInfo && generalInfo.games || [];
	        var game = games.find(function (g) {
	          return Number(g.id) === gameId;
	        }) || games[0] || {};
	        var gameReset = !!game.reset;
	
	        // Build exactly 3 slots keyed by round number so the UI always
	        // reads Round 1 | Round 2 | Round 3 left-to-right regardless
	        // of the order the BE returned rows.
	        var toDisplayWeight = function toDisplayWeight(gw) {
	          return gw != null ? Number(Number(gw) * 100).toFixed(2) : '33.33';
	        };
	        var roundsWeights = [1, 2, 3].map(function (number) {
	          var apiRound = roundsFromApi.find(function (r) {
	            return Number(r.number) === number && r.practice !== 'Yes';
	          });
	          var scheduler = schedulersRaw.find(function (s) {
	            var sNumber = s.round_number !== undefined ? s.round_number : s.number;
	            return Number(sNumber) === number && s.practice !== true;
	          });
	
	          if (gameReset) {
	            if (apiRound) {
	              return {
	                number: number,
	                source: 'round_api',
	                id: apiRound.id,
	                gradingWeight: toDisplayWeight(apiRound.grading_weight),
	                startDate: apiRound.start_date,
	                endDate: apiRound.end_date,
	                game: apiRound.game
	              };
	            }
	            if (scheduler) {
	              return {
	                number: number,
	                source: 'scheduler',
	                id: scheduler.id,
	                gradingWeight: toDisplayWeight(scheduler.grading_weight),
	                startDate: scheduler.start_date,
	                endDate: scheduler.end_date,
	                game: null
	              };
	            }
	          } else if (scheduler) {
	            return {
	              number: number,
	              source: 'scheduler',
	              id: scheduler.id,
	              gradingWeight: toDisplayWeight(scheduler.grading_weight),
	              startDate: scheduler.start_date,
	              endDate: scheduler.end_date,
	              game: null
	            };
	          }
	
	          // No backing record exists for this round number yet.
	          return {
	            number: number,
	            source: 'default',
	            id: null,
	            gradingWeight: '33.33',
	            startDate: null,
	            endDate: null,
	            game: null
	          };
	        });
	
	        var isDefaultRoundsActive = roundsWeights.every(function (r) {
	          return r.source === 'default';
	        });
	
	        _this2.setState(Object.assign({
	          loaded: true
	        }, scoreWeightsState, {
	          roundsWeights: roundsWeights,
	          isDefaultRoundsActive: isDefaultRoundsActive,
	          gameType: gameType,
	          gameReset: gameReset,
	          courseID: scoreWeightsState.courseID != null ? scoreWeightsState.courseID : courseId
	        }));
	      }).catch(function () {
	        _this2.setState({ loaded: true });
	      });
	    }
	
	    // ---- score weight handlers -------------------------------------
	
	    // ---- round weight handlers -------------------------------------
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamScore = _state.teamScore,
	          peerScore = _state.peerScore,
	          feedbackSubmission = _state.feedbackSubmission,
	          engagementScore = _state.engagementScore,
	          scoreWeightsChanged = _state.scoreWeightsChanged,
	          roundsWeights = _state.roundsWeights,
	          roundsWeightsValueChanged = _state.roundsWeightsValueChanged,
	          isDefaultRoundsActive = _state.isDefaultRoundsActive,
	          gameType = _state.gameType,
	          showError = _state.showError,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          showSuccess = _state.showSuccess,
	          successMessage = _state.successMessage;
	
	      // Modify Round Weights section visibility:
	      //   - Explorer game type: hidden (single-round game, no weighting)
	      //   - All 3 main rounds missing a backing record: hidden
	      //   - Otherwise: shown, but inputs for the specific missing
	      //     rounds are disabled so instructors can only edit the
	      //     rounds that actually exist on the BE.
	
	      var allRoundsMissing = roundsWeights.every(function (r) {
	        return r.source === 'default';
	      });
	      var showRoundWeights = gameType !== 'Explorer' && !allRoundsMissing;
	
	      if (!loaded) {
	        return _react2.default.createElement(
	          _ui.Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      var roundWeightsButtonText = isDefaultRoundsActive ? 'Activate' : roundsWeightsValueChanged ? 'Update' : 'Updated';
	
	      var scoreWeightsButtonText = scoreWeightsChanged ? 'Update' : 'Updated';
	      var isIAS = _Auth2.default.isAssistantOrCoInstructor();
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        showError && _react2.default.createElement(_error2.default, {
	          title: errorTitle,
	          message: errorMessage,
	          onHide: this.hideError
	        }),
	        showSuccess && _react2.default.createElement(_success2.default, {
	          title: 'Success!',
	          message: successMessage,
	          onHide: this.hideSuccess
	        }),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'SCORING WEIGHTS'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Configure how scoring is calculated. Round weights drive how each round contributes to the cumulative team score. Score weights drive how the four activity scores combine into a student\'s individual score.'
	        ),
	        showRoundWeights && _react2.default.createElement(
	          _ui.DataContainer,
	          null,
	          _react2.default.createElement(
	            _ui.DataContainerTitle,
	            null,
	            'Modify Round Weights'
	          ),
	          _react2.default.createElement(
	            _ui.Text,
	            null,
	            'By default, each round is weighted equally toward the cumulative team score. Adjust the values below if you want a different weighting.'
	          ),
	          _react2.default.createElement(
	            _ui.FourColumnsRow,
	            null,
	            roundsWeights.map(function (round, index) {
	              // Disable the input when either:
	              //   - the backing round has ended (locks closed rounds), or
	              //   - no BE record exists for this round number
	              //     (source = 'default'), so there's nothing to save
	              //     against yet. Instructor can still see the slot but
	              //     can only edit the rounds that are actually set up.
	              var inputDisabled = round.source === 'default';
	              if (!inputDisabled && round.endDate) {
	                var endDate = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)(round.endDate));
	                var nowDate = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)());
	                inputDisabled = nowDate > endDate;
	              }
	              return _react2.default.createElement(
	                _ui.DataColumn,
	                { key: index },
	                _react2.default.createElement(
	                  _ui.DataTitle,
	                  null,
	                  'Round ' + round.number
	                ),
	                _react2.default.createElement(_inputPercentage2.default, {
	                  value: round.gradingWeight,
	                  name: round.number,
	                  onInputChange: _this3.handleRoundWeightChange,
	                  disabled: inputDisabled || isIAS
	                })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _ui.ButtonRow,
	            null,
	            _react2.default.createElement(
	              _ui.Button,
	              {
	                type: 'button',
	                onClick: this.submitRoundWeights,
	                disabled: isIAS || !(roundsWeightsValueChanged || isDefaultRoundsActive),
	                isActiveDefault: !isIAS && isDefaultRoundsActive
	              },
	              roundWeightsButtonText
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _ui.DataContainer,
	          null,
	          _react2.default.createElement(
	            _ui.DataContainerTitle,
	            null,
	            'Modify Score Weights'
	          ),
	          _react2.default.createElement(
	            _ui.Text,
	            null,
	            'How the four activity scores combine into a student\'s individual score: team performance, peer evaluations, peer feedback submission, and engagement. Sum must equal 100%.'
	          ),
	          _react2.default.createElement(
	            _ui.FourColumnsRow,
	            null,
	            _react2.default.createElement(
	              _ui.DataColumn,
	              null,
	              _react2.default.createElement(
	                _ui.DataTitle,
	                null,
	                'Team Score'
	              ),
	              _react2.default.createElement(_inputPercentage2.default, {
	                value: teamScore,
	                name: 'teamScore',
	                onInputChange: this.handleScoreWeightChange,
	                disabled: isIAS
	              })
	            ),
	            _react2.default.createElement(
	              _ui.DataColumn,
	              null,
	              _react2.default.createElement(
	                _ui.DataTitle,
	                null,
	                'Peer Score'
	              ),
	              _react2.default.createElement(_inputPercentage2.default, {
	                value: peerScore,
	                name: 'peerScore',
	                onInputChange: this.handleScoreWeightChange,
	                disabled: isIAS
	              })
	            ),
	            _react2.default.createElement(
	              _ui.DataColumn,
	              null,
	              _react2.default.createElement(
	                _ui.DataTitle,
	                null,
	                'Feedback Submission'
	              ),
	              _react2.default.createElement(_inputPercentage2.default, {
	                value: feedbackSubmission,
	                name: 'feedbackSubmission',
	                onInputChange: this.handleScoreWeightChange,
	                disabled: isIAS
	              })
	            ),
	            _react2.default.createElement(
	              _ui.DataColumn,
	              null,
	              _react2.default.createElement(
	                _ui.DataTitle,
	                null,
	                'Engagement Score'
	              ),
	              _react2.default.createElement(_inputPercentage2.default, {
	                value: engagementScore,
	                name: 'engagementScore',
	                onInputChange: this.handleScoreWeightChange,
	                disabled: isIAS
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _ui.ButtonRow,
	            null,
	            _react2.default.createElement(
	              _ui.Button,
	              {
	                type: 'button',
	                onClick: this.submitScoreWeights,
	                disabled: isIAS || !scoreWeightsChanged
	              },
	              scoreWeightsButtonText
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' The individual score is calculated once at the end of the simulation experience.'
	        )
	      );
	    }
	  }]);
	
	  return OverallScore;
	}(_react.PureComponent);
	
	exports.default = OverallScore;

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(18);
	
	var _ui = __webpack_require__(408);
	
	var _AbbreviateNumber = __webpack_require__(182);
	
	var _AbbreviateNumber2 = _interopRequireDefault(_AbbreviateNumber);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _success = __webpack_require__(94);
	
	var _success2 = _interopRequireDefault(_success);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamScore = function (_PureComponent) {
	  _inherits(TeamScore, _PureComponent);
	
	  function TeamScore(props) {
	    _classCallCheck(this, TeamScore);
	
	    var _this = _possibleConstructorReturn(this, (TeamScore.__proto__ || Object.getPrototypeOf(TeamScore)).call(this, props));
	
	    _this.handleRoundsTargetsInputChange = function (e, value, roundNumber, name) {
	      var val = 'floatValue' in value ? value.floatValue : Number(e.target.value);
	      var roundTargets = _lodash2.default.cloneDeep(_this.state.roundTargets);
	      var index = roundTargets.findIndex(function (i) {
	        return i.roundNumber === Number(roundNumber);
	      });
	
	      if (index >= 0) {
	        roundTargets[index][name] = val.toFixed(2);
	        var changedRoundTargets = [].concat(_toConsumableArray(_this.state.changedRoundTargets));
	        if (!changedRoundTargets.includes(roundNumber)) {
	          changedRoundTargets.push(roundNumber);
	        }
	
	        _this.setState({
	          roundTargets: roundTargets,
	          changedRoundTargets: changedRoundTargets
	        });
	      }
	    };
	
	    _this.submitRoundTarget = function (roundTarget) {
	      var _this$state = _this.state,
	          changedRoundTargets = _this$state.changedRoundTargets,
	          defaultActiveRoundTargets = _this$state.defaultActiveRoundTargets;
	
	
	      var metricsToCheck = ['marketShare', 'netRevenues', 'grossMargin', 'stockPrice', 'roe', 'roa', 'eps'];
	
	      var nonZeroCount = metricsToCheck.filter(function (metric) {
	        var value = parseFloat(roundTarget[metric]);
	        return value > 0;
	      }).length;
	
	      if (nonZeroCount !== 4) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Invalid Metrics',
	          errorMessage: 'Unsuccessful. Make sure exactly 4 metrics have values greater than zero.'
	        });
	        return;
	      }
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/';
	      var request = defaultActiveRoundTargets.includes(roundTarget.roundNumber) ? (0, _ApiService.postRequest)(apiUrl + '?round_number=' + roundTarget.roundNumber + '/') : (0, _ApiService.putRequest)('' + apiUrl + roundTarget.id + '/?round_number=' + roundTarget.roundNumber + '/');
	
	      request.send({
	        course: roundTarget.course,
	        round_number: roundTarget.roundNumber,
	        market_share: roundTarget.marketShare / 100,
	        net_revenues: roundTarget.netRevenues * 1000000,
	        gross_margin: roundTarget.grossMargin / 100,
	        stock_price: roundTarget.stockPrice,
	        roe: roundTarget.roe / 100,
	        roa: roundTarget.roa / 100,
	        earnings_per_share: roundTarget.eps
	      }).then(function () {
	        _this.setState({
	          showSuccess: true,
	          successMessage: 'Round ' + roundTarget.roundNumber + ' targets are updated.',
	          changedRoundTargets: changedRoundTargets.filter(function (i) {
	            return i !== roundTarget.roundNumber;
	          }),
	          defaultActiveRoundTargets: defaultActiveRoundTargets.filter(function (i) {
	            return i !== roundTarget.roundNumber;
	          })
	        });
	      }).catch(function () {});
	    };
	
	    _this.hideError = function () {
	      _this.setState({
	        showError: false
	      });
	    };
	
	    _this.state = {
	      loaded: false,
	      roundTargets: [],
	      changedRoundTargets: [],
	      // roundsWeights state moved to overall-score (Scoring Weights)
	      // along with the Modify Round Weights UI. This page now owns
	      // only metrics and per-round targets.
	      activeRoundNumbers: [],
	      showError: false,
	      errorTitle: '',
	      errorMessage: '',
	      showSuccess: false,
	      successMessage: '',
	      defaultActiveRoundTargets: []
	    };
	    return _this;
	  }
	
	  _createClass(TeamScore, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + _Auth2.default.getCourseId(), ("https://be-production-itb.marketgames.io/api/") + 'game/rounds/', ("https://be-production-itb.marketgames.io/api/") + 'courses/']).then(function (res) {
	        var gamesTargets = res[0].body;
	        var rounds = res[1].body;
	        var courseId = res[2].body[0].id;
	
	        var defaultTargetsData = [{
	          id: 1,
	          course: courseId,
	          roundNumber: 1,
	          marketShare: 12,
	          netRevenues: '4.00',
	          grossMargin: 60,
	          stockPrice: 1.65,
	          roe: 0,
	          roa: 0,
	          eps: 0,
	          roundEndDate: null
	        }, {
	          id: 2,
	          course: courseId,
	          roundNumber: 2,
	          marketShare: 15,
	          netRevenues: '10.00',
	          grossMargin: 55,
	          stockPrice: 3,
	          roe: 0,
	          roa: 0,
	          eps: 0,
	          roundEndDate: null
	        }, {
	          id: 3,
	          course: courseId,
	          roundNumber: 3,
	          marketShare: 0,
	          netRevenues: '17.50',
	          grossMargin: 55,
	          stockPrice: 0,
	          roe: 25,
	          roa: 25,
	          eps: 0,
	          roundEndDate: null
	        }];
	
	        var isDefaultRoundTargetsActive = gamesTargets.length === 0;
	        var isDefaultRoundsActive = rounds.length === 0;
	
	        var roundTargets = isDefaultRoundTargetsActive ? defaultTargetsData : gamesTargets.map(function (gamesTarget) {
	          var marketShare = gamesTarget.market_share ? (gamesTarget.market_share * 100).toFixed(2) : 0;
	          var netRevenues = gamesTarget.net_revenues ? (gamesTarget.net_revenues / 1000000).toFixed(2) : 0;
	          var grossMargin = gamesTarget.gross_margin ? (gamesTarget.gross_margin * 100).toFixed(2) : 0;
	          var stockPrice = gamesTarget.stock_price ? gamesTarget.stock_price.toFixed(2) : 0;
	          var roe = gamesTarget.roe ? (gamesTarget.roe * 100).toFixed(2) : 0;
	          var roa = gamesTarget.roa ? (gamesTarget.roa * 100).toFixed(2) : 0;
	          var eps = gamesTarget.earnings_per_share ? gamesTarget.earnings_per_share.toFixed(2) : 0;
	
	          var relativeRound = rounds ? rounds.find(function (round) {
	            return round.number === gamesTarget.round_number;
	          }) : null;
	
	          return {
	            id: gamesTarget.id,
	            course: gamesTarget.course,
	            roundNumber: gamesTarget.round_number,
	            marketShare: marketShare,
	            netRevenues: netRevenues,
	            grossMargin: grossMargin,
	            stockPrice: stockPrice,
	            roe: roe,
	            roa: roa,
	            eps: eps,
	            roundEndDate: rounds && relativeRound ? relativeRound.end_date : null
	          };
	        });
	
	        // Active round numbers come from the rounds endpoint (or
	        // default 1/2/3 when no rounds are configured). Used to
	        // filter the targets table and to look up the end date for
	        // per-row input gating.
	        var activeRoundNumbers = isDefaultRoundsActive ? [1, 2, 3] : rounds.map(function (r) {
	          return r.number;
	        });
	
	        var endDateByRound = {};
	        if (!isDefaultRoundsActive) {
	          rounds.forEach(function (r) {
	            endDateByRound[r.number] = r.end_date;
	          });
	        }
	
	        // Show every target the backend has for this course, even for
	        // rounds that don't exist in `game/rounds/` yet. Instructors need
	        // visibility into all pre-provisioned targets.
	        var roundTargetsFiltered = roundTargets.map(function (rt) {
	          return Object.assign({}, rt, {
	            roundEndDate: endDateByRound[rt.roundNumber] || rt.roundEndDate
	          });
	        });
	
	        _this2.setState({
	          roundTargets: roundTargetsFiltered,
	          activeRoundNumbers: activeRoundNumbers,
	          loaded: true,
	          defaultActiveRoundTargets: isDefaultRoundTargetsActive ? [1, 2, 3] : []
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          roundTargets = _state.roundTargets,
	          changedRoundTargets = _state.changedRoundTargets,
	          showError = _state.showError,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          showSuccess = _state.showSuccess,
	          successMessage = _state.successMessage,
	          defaultActiveRoundTargets = _state.defaultActiveRoundTargets;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        showError && _react2.default.createElement(_error2.default, {
	          title: errorTitle,
	          message: errorMessage,
	          onHide: this.hideError
	        }),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'ROUND TARGETS'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Each round of the simulation comes with financial targets. Teams earn a round score of 100% when every targeted metric is hit. The team\'s overall team score is the weighted average of all round scores (round weights live on the Scoring Weights page).'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Note that a few financial metrics are only relevant in certain rounds. '
	        ),
	        showSuccess && _react2.default.createElement(_success2.default, {
	          title: 'Success!',
	          message: successMessage,
	          onHide: this.hideError
	        }),
	        _react2.default.createElement(
	          _ui.DataContainer,
	          null,
	          _react2.default.createElement(
	            _ui.DataContainerTitle,
	            null,
	            'Modify Round Targets'
	          ),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'Round'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'Market',
	                  _react2.default.createElement('br', null),
	                  ' Share'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'Revenues'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'Gross',
	                  _react2.default.createElement('br', null),
	                  ' Margins'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'Share',
	                  _react2.default.createElement('br', null),
	                  ' Price'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'ROE'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'ROA'
	                ),
	                _react2.default.createElement(
	                  _ui.HeaderColumn,
	                  null,
	                  'EPS'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              roundTargets.map(function (roundTargets, index) {
	                var isIAS = _Auth2.default.isAssistantOrCoInstructor();
	                var isDefault = defaultActiveRoundTargets.includes(roundTargets.roundNumber);
	                var roundTargetsButtonActive = !isIAS && (isDefault || changedRoundTargets.includes(roundTargets.roundNumber) ? true : false);
	                var roundTargetsButtonText = isDefault ? 'Activate' : changedRoundTargets.includes(roundTargets.roundNumber) ? 'Update' : 'Updated';
	
	                var endDate = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)(roundTargets.roundEndDate));
	                var nowDate = (0, _utils.getDateInCurrentTimezone)((0, _momentTimezone2.default)());
	                var inputDisabled = isIAS || nowDate > endDate;
	
	                return _react2.default.createElement(
	                  'tr',
	                  { key: index },
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    null,
	                    roundTargets.roundNumber
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.marketShare) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.marketShare,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'marketShare');
	                      },
	                      prefix: '',
	                      suffix: '%',
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.netRevenues) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.netRevenues,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'netRevenues');
	                      },
	                      suffix: 'M',
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.grossMargin) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.grossMargin,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'grossMargin');
	                      },
	                      prefix: '',
	                      suffix: '%',
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.stockPrice) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.stockPrice,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'stockPrice');
	                      },
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.roe) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.roe,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'roe');
	                      },
	                      prefix: '',
	                      suffix: '%',
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.roa) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.roa,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'roa');
	                      },
	                      prefix: '',
	                      suffix: '%',
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true, active: Number(roundTargets.eps) > 0 },
	                    _react2.default.createElement(_AbbreviateNumber2.default, {
	                      type: 'input',
	                      value: roundTargets.eps,
	                      onChange: function onChange(e, value) {
	                        return _this3.handleRoundsTargetsInputChange(e, value, roundTargets.roundNumber, 'eps');
	                      },
	                      disabled: inputDisabled
	                    })
	                  ),
	                  _react2.default.createElement(
	                    _ui.TableCell,
	                    { verticalPadding: true },
	                    _react2.default.createElement(
	                      _ui.Button,
	                      {
	                        type: 'button',
	                        disabled: !roundTargetsButtonActive,
	                        isActiveDefault: !isIAS && isDefault,
	                        onClick: function onClick() {
	                          return _this3.submitRoundTarget(roundTargets);
	                        }
	                      },
	                      roundTargetsButtonText
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      );
	    }
	  }]);
	
	  return TeamScore;
	}(_react.PureComponent);
	
	exports.default = TeamScore;

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _ApiService = __webpack_require__(4);
	
	var _utils = __webpack_require__(66);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	var STUDENT_ROLE = 1;
	var IAS_ROLE = 2;
	
	var IASCourseModal = function (_PureComponent) {
	  _inherits(IASCourseModal, _PureComponent);
	
	  function IASCourseModal(props) {
	    _classCallCheck(this, IASCourseModal);
	
	    var _this = _possibleConstructorReturn(this, (IASCourseModal.__proto__ || Object.getPrototypeOf(IASCourseModal)).call(this, props));
	
	    _this.fetchCourseMembers = function () {
	      var course_id = _this.state.course_id;
	
	
	      if (course_id > 0) {
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "courses/" + course_id + "/members/").then(function (res) {
	          _this.setState({
	            course_members: res.body.filter(function (i) {
	              return i.type === IAS_ROLE;
	            }),
	            possible_assistents: res.body.filter(function (i) {
	              return i.type === STUDENT_ROLE;
	            })
	          });
	        }).catch(function (err) {});
	      } else {
	        _this.setState({
	          course_members: []
	        });
	      }
	    };
	
	    _this.fetchUsers = function () {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "users/").then(function (res) {
	        _this.setState({
	          users: res.body
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.getUserName = function (user_id) {
	      var users = _this.state.users;
	
	      var user = users.find(function (i) {
	        return i.id === user_id;
	      });
	
	      return user ? user.username : "";
	    };
	
	    _this.changeSelect = function (e) {
	      var select = e.target;
	
	      _this.setState(_defineProperty({}, select.name, select.value));
	    };
	
	    _this.submit = function () {
	      var _this$state = _this.state,
	          course_member_id = _this$state.course_member_id,
	          course_id = _this$state.course_id;
	
	
	      if (course_member_id) {
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "courses/" + course_id + "/add_assistant/").send({
	          course_member: course_member_id
	        }).then(function (res) {
	          _this.fetchCourseMembers();
	          _this.props.fetchData();
	          _this.setState({
	            course_member_id: 0
	          });
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.remove = function (e, course_member) {
	      e.preventDefault();
	
	      var course_id = _this.state.course_id;
	
	
	      if (course_member > 0) {
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "courses/" + course_id + "/remove_assistant/").send({
	          course_member: course_member
	        }).then(function (res) {
	          _this.fetchCourseMembers();
	          _this.props.fetchData();
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.state = {
	      course_name: props.currentCourse ? props.currentCourse.name : "",
	      course_id: props.currentCourse ? props.currentCourse.id : 0,
	      course_members: [],
	      possible_assistents: [],
	      users: [],
	      course_member_id: 0
	    };
	    return _this;
	  }
	
	  _createClass(IASCourseModal, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchCourseMembers();
	      this.fetchUsers();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var course_id = nextProps.currentCourse ? nextProps.currentCourse.id : 0;
	      var course_name = nextProps.currentCourse ? nextProps.currentCourse.name : "";
	
	      if (this.state.course_id !== course_id) {
	        this.setState({
	          course_name: course_name,
	          course_id: course_id
	        }, function () {
	          _this2.fetchCourseMembers();
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          show = _props.show,
	          onHide = _props.onHide;
	      var _state = this.state,
	          course_members = _state.course_members,
	          possible_assistents = _state.possible_assistents,
	          course_member_id = _state.course_member_id;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: show, onHide: onHide },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          null,
	          _react2.default.createElement(
	            "h4",
	            { className: "modal-title title-light-blue" },
	            "IA List Popup"
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "tbody",
	                null,
	                course_members.map(function (course_member, index) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: index, className: "border-none instructor-modal-row" },
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      index + 1,
	                      ". ",
	                      _this3.getUserName(course_member.user),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/#",
	                          onClick: function onClick(e) {
	                            return _this3.remove(e, course_member.id);
	                          },
	                          className: "no-outline"
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, {
	                          className: "instructor-close",
	                          name: "close"
	                        })
	                      )
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "border-none instructor-modal-row" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        name: "course_member_id",
	                        value: course_member_id,
	                        onChange: this.changeSelect
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "0" },
	                        "Select user"
	                      ),
	                      possible_assistents.map(function (possible_assistent, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: possible_assistent.id },
	                          _this3.getUserName(possible_assistent.user)
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactBootstrap.Button,
	                      {
	                        bsStyle: "light-blue",
	                        onClick: this.submit,
	                        block: true
	                      },
	                      "Add"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IASCourseModal;
	}(_react.PureComponent);
	
	exports.default = IASCourseModal;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 62px 49px 73px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 62px 49px 73px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  height: 90px;\n  width: auto;\n  max-width: 358px;\n  object-fit: contain;\n'], ['\n  height: 90px;\n  width: auto;\n  max-width: 358px;\n  object-fit: contain;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 24px 0 6px;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 30px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  max-width: 100%;\n  white-space: nowrap;\n'], ['\n  margin: 24px 0 6px;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 30px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  max-width: 100%;\n  white-space: nowrap;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0 0 36px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 20px;\n  line-height: 40px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.94);\n  max-width: 645px;\n\n  strong { font-weight: 700; }\n'], ['\n  margin: 0 0 36px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 20px;\n  line-height: 40px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.94);\n  max-width: 645px;\n\n  strong { font-weight: 700; }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 162px;\n  height: 41px;\n  border: none;\n  border-radius: 16px;\n  color: #FFFFFF;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  cursor: pointer;\n  background: linear-gradient(101.768deg, #FF5252 2.88%, #70A1FF 100%);\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n\n  &:hover { opacity: 0.94; }\n'], ['\n  width: 162px;\n  height: 41px;\n  border: none;\n  border-radius: 16px;\n  color: #FFFFFF;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  cursor: pointer;\n  background: linear-gradient(101.768deg, #FF5252 2.88%, #70A1FF 100%);\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n\n  &:hover { opacity: 0.94; }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _OnboardingLayout = __webpack_require__(308);
	
	var _OnboardingLayout2 = _interopRequireDefault(_OnboardingLayout);
	
	var _LandingPageLogo = __webpack_require__(2566);
	
	var _LandingPageLogo2 = _interopRequireDefault(_LandingPageLogo);
	
	var _onboardingRouting = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var InnerCard = _styledComponents2.default.div(_templateObject);
	
	var Logo = _styledComponents2.default.img(_templateObject2);
	
	var Heading = _styledComponents2.default.h1(_templateObject3);
	
	var Subheading = _styledComponents2.default.p(_templateObject4);
	
	var StyledButton = _styledComponents2.default.button(_templateObject5);
	
	var Intro = function (_Component) {
	  _inherits(Intro, _Component);
	
	  function Intro() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Intro);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Intro.__proto__ || Object.getPrototypeOf(Intro)).call.apply(_ref, [this].concat(args))), _this), _this.handleGetStarted = function () {
	      // Route via the shared utility so partial-onboarding users skip
	      // path-choice and go straight to whichever step is still needed.
	      var setup = _this.props.onboardingSetup || { hasGame: false, hasSurvey: false };
	      var user = _Auth2.default.getUser();
	      var onboardComplete = !!(user && user.onboard !== 0);
	      (0, _Location.changeLocation)((0, _onboardingRouting.getNextOnboardingStep)('intro', {
	        hasGame: setup.hasGame,
	        hasSurvey: setup.hasSurvey,
	        onboardComplete: onboardComplete
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Intro, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _OnboardingLayout2.default,
	        {
	          cardMaxWidth: 729,
	          cardPadding: '0',
	          cardBackground: '#FFFFFF'
	        },
	        _react2.default.createElement(
	          InnerCard,
	          null,
	          _react2.default.createElement(Logo, { src: _LandingPageLogo2.default, alt: 'Market Games' }),
	          _react2.default.createElement(
	            Heading,
	            null,
	            'Welcome to the Intro to Business Challenge'
	          ),
	          _react2.default.createElement(
	            Subheading,
	            null,
	            'A ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'team-based'
	            ),
	            ' multi-round simulation where students make decisions, get feedback, and experience the',
	            ' ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'integrated nature of business'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            StyledButton,
	            { onClick: this.handleGetStarted },
	            'Get Started'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Intro;
	}(_react.Component);
	
	exports.default = Intro;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 16px 0 42px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 24px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  text-align: center;\n'], ['\n  margin: 16px 0 42px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 24px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  min-height: 101px;\n  background: #FFFFFF;\n  border: ', ';\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  box-shadow: ', ';\n\n  &:hover { border-color: ', '; }\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  min-height: 101px;\n  background: #FFFFFF;\n  border: ', ';\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  box-shadow: ', ';\n\n  &:hover { border-color: ', '; }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  min-width: 105px;\n  height: 40px;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #D5D9DD;\n  border-radius: 5px;\n  background: #FFFFFF;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #2F4166;\n'], ['\n  flex: 0 0 auto;\n  min-width: 105px;\n  height: 40px;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #D5D9DD;\n  border-radius: 5px;\n  background: #FFFFFF;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #2F4166;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  flex: 1;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: rgba(0, 27, 59, 0.94);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _OnboardingLayout = __webpack_require__(308);
	
	var _OnboardingLayout2 = _interopRequireDefault(_OnboardingLayout);
	
	var _onboardingRouting = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Heading = _styledComponents2.default.h1(_templateObject);
	
	var OptionRow = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.selected ? '2px solid #2F4166' : '2px solid transparent';
	}, function (p) {
	  return p.selected ? '0 4px 12px rgba(47, 65, 102, 0.15)' : 'none';
	}, function (p) {
	  return p.selected ? '#2F4166' : 'rgba(47, 65, 102, 0.3)';
	});
	
	var OptionTag = _styledComponents2.default.div(_templateObject3);
	
	var OptionText = _styledComponents2.default.div(_templateObject4);
	
	var OPTIONS = [{
	  id: 'demo',
	  tag: 'Demo',
	  description: 'Walk through a demo of the exercise.'
	}, {
	  id: 'setup',
	  tag: 'Setup',
	  description: 'Set up simulation for my course.'
	}];
	
	var PathChoice = function (_Component) {
	  _inherits(PathChoice, _Component);
	
	  function PathChoice() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PathChoice);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PathChoice.__proto__ || Object.getPrototypeOf(PathChoice)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selected: null }, _this.handleSelect = function (id) {
	      _this.setState({ selected: id });
	    }, _this.handleContinue = function () {
	      var selected = _this.state.selected;
	
	      if (!selected) return;
	
	      if (selected === 'demo') {
	        (0, _Location.changeLocation)('/demo');
	        return;
	      }
	      // Route via utility so we skip simulation-selection or
	      // team-evaluation-survey if the course already has them.
	      var setup = _this.props.onboardingSetup || { hasGame: false, hasSurvey: false };
	      var user = _Auth2.default.getUser();
	      var onboardComplete = !!(user && user.onboard !== 0);
	      (0, _Location.changeLocation)((0, _onboardingRouting.getNextOnboardingStep)('path-choice', {
	        hasGame: setup.hasGame,
	        hasSurvey: setup.hasSurvey,
	        onboardComplete: onboardComplete
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PathChoice, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var selected = this.state.selected;
	
	
	      return _react2.default.createElement(
	        _OnboardingLayout2.default,
	        {
	          progressStep: 1,
	          progressTotal: 4,
	          buttonLabel: 'Continue',
	          buttonDisabled: !selected,
	          onButtonClick: this.handleContinue
	        },
	        _react2.default.createElement(
	          Heading,
	          null,
	          'Where would you like to start?'
	        ),
	        OPTIONS.map(function (opt) {
	          return _react2.default.createElement(
	            OptionRow,
	            {
	              key: opt.id,
	              selected: selected === opt.id,
	              onClick: function onClick() {
	                return _this2.handleSelect(opt.id);
	              }
	            },
	            _react2.default.createElement(
	              OptionTag,
	              null,
	              opt.tag
	            ),
	            _react2.default.createElement(
	              OptionText,
	              null,
	              opt.description
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return PathChoice;
	}(_react.Component);
	
	exports.default = PathChoice;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 16px 0 4px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 24px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  text-align: center;\n'], ['\n  margin: 16px 0 4px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 24px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 32px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: #2F4166;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 32px;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: #2F4166;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n'], ['\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1.2px solid #2F4166;\n  font-size: 11px;\n  color: #2F4166;\n  font-weight: 700;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(47, 65, 102, 0.08);\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1.2px solid #2F4166;\n  font-size: 11px;\n  color: #2F4166;\n  font-weight: 700;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(47, 65, 102, 0.08);\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: 320px;\n  background: #FFFFFF;\n  border: 1px solid rgba(47, 65, 102, 0.15);\n  border-radius: 10px;\n  padding: 16px 18px 14px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.15);\n  z-index: 20;\n  text-align: left;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    top: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #FFFFFF;\n    border-top: 1px solid rgba(47, 65, 102, 0.15);\n    border-left: 1px solid rgba(47, 65, 102, 0.15);\n  }\n\n  ul {\n    margin: 8px 0 10px;\n    padding-left: 18px;\n  }\n\n  li {\n    margin-bottom: 4px;\n  }\n\n  strong {\n    font-weight: 700;\n  }\n'], ['\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: 320px;\n  background: #FFFFFF;\n  border: 1px solid rgba(47, 65, 102, 0.15);\n  border-radius: 10px;\n  padding: 16px 18px 14px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.15);\n  z-index: 20;\n  text-align: left;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    top: -6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    width: 10px;\n    height: 10px;\n    background: #FFFFFF;\n    border-top: 1px solid rgba(47, 65, 102, 0.15);\n    border-left: 1px solid rgba(47, 65, 102, 0.15);\n  }\n\n  ul {\n    margin: 8px 0 10px;\n    padding-left: 18px;\n  }\n\n  li {\n    margin-bottom: 4px;\n  }\n\n  strong {\n    font-weight: 700;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  background: transparent;\n  border: none;\n  font-size: 18px;\n  line-height: 1;\n  color: rgba(0, 27, 59, 0.5);\n  cursor: pointer;\n  padding: 4px 6px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n'], ['\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  background: transparent;\n  border: none;\n  font-size: 18px;\n  line-height: 1;\n  color: rgba(0, 27, 59, 0.5);\n  cursor: pointer;\n  padding: 4px 6px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  min-height: 100px;\n  background: #FFFFFF;\n  border: ', ';\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  box-shadow: ', ';\n\n  &:hover { border-color: ', '; }\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  min-height: 100px;\n  background: #FFFFFF;\n  border: ', ';\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  box-shadow: ', ';\n\n  &:hover { border-color: ', '; }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  min-width: 105px;\n  height: 40px;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #D5D9DD;\n  border-radius: 5px;\n  background: #FFFFFF;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #2F4166;\n'], ['\n  flex: 0 0 auto;\n  min-width: 105px;\n  height: 40px;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #D5D9DD;\n  border-radius: 5px;\n  background: #FFFFFF;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #2F4166;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  strong { font-weight: 700; }\n'], ['\n  flex: 1;\n  font-family: \'Mukta Vaani\', \'Mukta Mahee\', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n\n  strong { font-weight: 700; }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _OnboardingLayout = __webpack_require__(308);
	
	var _OnboardingLayout2 = _interopRequireDefault(_OnboardingLayout);
	
	var _onboardingRouting = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	
	// Hardcoded round-target defaults seeded during onboarding, keyed by
	// round number. Percentages are stored as fractions (0.15 = 15%);
	// revenues are raw dollars.
	var ROUND_TARGETS = {
	  1: {
	    market_share: 0.15,
	    net_revenues: 4000000,
	    gross_margin: 0.60,
	    stock_price: 1.65,
	    roe: 0,
	    roa: 0,
	    roic: 0,
	    earnings_per_share: 0
	  },
	  2: {
	    market_share: 0.15,
	    net_revenues: 10000000,
	    gross_margin: 0.55,
	    stock_price: 3,
	    roe: 0,
	    roa: 0,
	    roic: 0,
	    earnings_per_share: 0
	  },
	  3: {
	    market_share: 0.15,
	    net_revenues: 17500000,
	    gross_margin: 0.55,
	    stock_price: 0,
	    roe: 0,
	    roa: 0,
	    roic: 0,
	    earnings_per_share: 0.25
	  }
	};
	
	var Heading = _styledComponents2.default.h1(_templateObject);
	
	var Subheading = _styledComponents2.default.div(_templateObject2);
	
	var HelpIconWrap = _styledComponents2.default.span(_templateObject3);
	
	var HelpIcon = _styledComponents2.default.button(_templateObject4);
	
	var HelpPopover = _styledComponents2.default.div(_templateObject5);
	
	var HelpPopoverClose = _styledComponents2.default.button(_templateObject6);
	
	var OptionRow = _styledComponents2.default.div(_templateObject7, function (p) {
	  return p.selected ? '2px solid #2F4166' : '2px solid transparent';
	}, function (p) {
	  return p.selected ? '0 4px 12px rgba(47, 65, 102, 0.15)' : 'none';
	}, function (p) {
	  return p.selected ? '#2F4166' : 'rgba(47, 65, 102, 0.3)';
	});
	
	var OptionTag = _styledComponents2.default.div(_templateObject8);
	
	var OptionText = _styledComponents2.default.div(_templateObject9);
	
	var OPTIONS = [{
	  id: 'Explorer',
	  tag: 'Explorer',
	  text: _react2.default.createElement(
	    'span',
	    null,
	    'Students complete ',
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Round 1 only'
	    ),
	    ': practice once, then redo.'
	  )
	}, {
	  id: 'Adventurer',
	  tag: 'Adventurer',
	  text: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Students complete all 3 rounds. They start with practice,'
	    ),
	    ' ',
	    'and then tackle the full challenge from capturing market share to generating profits.'
	  )
	}, {
	  id: 'Legend',
	  tag: 'Legend',
	  text: _react2.default.createElement(
	    'span',
	    null,
	    'Students jump straight into the full challenge with',
	    ' ',
	    _react2.default.createElement(
	      'strong',
	      null,
	      'no practice round.'
	    )
	  )
	}];
	
	var SimulationSelection = function (_Component) {
	  _inherits(SimulationSelection, _Component);
	
	  function SimulationSelection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SimulationSelection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimulationSelection.__proto__ || Object.getPrototypeOf(SimulationSelection)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selected: null, submitting: false, helpOpen: false }, _this.handleDocumentClick = function (e) {
	      if (!_this.state.helpOpen) return;
	      if (_this.helpWrapRef && _this.helpWrapRef.contains(e.target)) return;
	      _this.setState({ helpOpen: false });
	    }, _this.handleKeyDown = function (e) {
	      if (e.key === 'Escape' && _this.state.helpOpen) {
	        _this.setState({ helpOpen: false });
	      }
	    }, _this.toggleHelp = function (e) {
	      e.stopPropagation();
	      _this.setState(function (prev) {
	        return { helpOpen: !prev.helpOpen };
	      });
	    }, _this.setHelpWrapRef = function (el) {
	      _this.helpWrapRef = el;
	    }, _this.handleSelect = function (id) {
	      if (_this.state.submitting) return;
	      _this.setState({ selected: id });
	    }, _this.handleContinue = function () {
	      var _this$state = _this.state,
	          selected = _this$state.selected,
	          submitting = _this$state.submitting;
	
	      if (!selected || submitting) return;
	
	      _this.setState({ submitting: true });
	
	      _this.updateCourseGameType(selected).then(function () {
	        return _this.createGame(selected);
	      }).then(function () {
	        return _this.createRoundTargets(selected);
	      }).then(function () {
	        // Route via utility so we skip team-evaluation-survey if the
	        // course already has a survey (partial-onboarding case). Game
	        // now exists (we just created it) so pass hasGame=true.
	        var setup = _this.props.onboardingSetup || { hasGame: true, hasSurvey: false };
	        var user = _Auth2.default.getUser();
	        var onboardComplete = !!(user && user.onboard !== 0);
	        (0, _Location.changeLocation)((0, _onboardingRouting.getNextOnboardingStep)('simulation-selection', {
	          hasGame: true,
	          hasSurvey: setup.hasSurvey,
	          onboardComplete: onboardComplete
	        }));
	      }).catch(function () {
	        _this.setState({ submitting: false });
	      });
	    }, _this.createRoundTargets = function (gameType) {
	      var courseId = Number(_Auth2.default.getCourseId());
	      // Explorer plays only Round 1; Adventurer and Legend play all three.
	      var roundNumbers = gameType === 'Explorer' ? [1] : [1, 2, 3];
	
	      var requests = roundNumbers.map(function (n) {
	        return (0, _ApiService.postRequest)(API + 'v2/games/targets/?round_number=' + n + '/').send(Object.assign({
	          course: courseId,
	          round_number: n
	        }, ROUND_TARGETS[n]))
	        // Allow partial success: instructor can complete missing rows
	        // later on the Set Team Goals & Targets page.
	        .catch(function () {
	          return null;
	        });
	      });
	
	      return Promise.all(requests);
	    }, _this.updateCourseGameType = function (gameType) {
	      var courseId = Number(_Auth2.default.getCourseId());
	
	      return new Promise(function (resolve, reject) {
	        (0, _ApiService.patchRequest)(API + 'courses/' + courseId + '/').send({ game_type: gameType }).then(function () {
	          return resolve();
	        }).catch(function (err) {
	          return reject(err);
	        });
	      });
	    }, _this.createGame = function (gameType) {
	      var courseId = Number(_Auth2.default.getCourseId());
	      var reset = gameType === 'Legend';
	
	      return new Promise(function (resolve, reject) {
	        (0, _ApiService.postRequest)(API + 'games/').send({
	          name: 'The Intro to Business Challenge',
	          course: courseId,
	          reset: reset
	        }).then(function (res) {
	          if (res.body && res.body.id) {
	            _Auth2.default.setGameId(res.body.id);
	          }
	          // Bust the 5-min AppGeneralInfo cache so the next
	          // fetchAppGeneralInfo (the onboarding gate in App.js re-runs
	          // it on the very next navigation) sees the game we just
	          // created. Without this, hasGame stays false, the gate
	          // routes the instructor back to /instructor/onboarding/intro
	          // right after they click Continue on team-evaluation-survey.
	          (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	          resolve();
	        }).catch(function (err) {
	          return reject(err);
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SimulationSelection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.handleDocumentClick);
	      document.addEventListener('keydown', this.handleKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.handleDocumentClick);
	      document.removeEventListener('keydown', this.handleKeyDown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          selected = _state.selected,
	          submitting = _state.submitting;
	
	
	      return _react2.default.createElement(
	        _OnboardingLayout2.default,
	        {
	          progressStep: 1,
	          progressTotal: 4,
	          buttonLabel: submitting ? 'Saving' : 'Continue',
	          buttonDisabled: !selected || submitting,
	          onButtonClick: this.handleContinue
	        },
	        _react2.default.createElement(
	          Heading,
	          null,
	          'Select Simulation Experience'
	        ),
	        _react2.default.createElement(
	          Subheading,
	          null,
	          'Time Commitment',
	          _react2.default.createElement(
	            HelpIconWrap,
	            { innerRef: this.setHelpWrapRef },
	            _react2.default.createElement(
	              HelpIcon,
	              {
	                type: 'button',
	                onClick: this.toggleHelp,
	                'aria-label': 'About time commitment',
	                'aria-expanded': this.state.helpOpen
	              },
	              '?'
	            ),
	            this.state.helpOpen && _react2.default.createElement(
	              HelpPopover,
	              { role: 'dialog', 'aria-label': 'Time commitment details' },
	              _react2.default.createElement(
	                HelpPopoverClose,
	                {
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this2.setState({ helpOpen: false });
	                  },
	                  'aria-label': 'Close'
	                },
	                '\xD7'
	              ),
	              'Plan for how much time students need each round:',
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Round 1:'
	                  ),
	                  ' 2 to 3 hours. Students are new to the simulation and getting comfortable.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Rounds 2 and 3:'
	                  ),
	                  ' 1 to 1.5 hours once they\'re up to speed.'
	                )
	              ),
	              'We recommend ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                '1 week per round'
	              ),
	              '. You can pick shorter or longer, up to ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                '30 days'
	              ),
	              ' max.'
	            )
	          )
	        ),
	        OPTIONS.map(function (opt) {
	          return _react2.default.createElement(
	            OptionRow,
	            {
	              key: opt.id,
	              selected: selected === opt.id,
	              onClick: function onClick() {
	                return _this2.handleSelect(opt.id);
	              }
	            },
	            _react2.default.createElement(
	              OptionTag,
	              null,
	              opt.tag
	            ),
	            _react2.default.createElement(
	              OptionText,
	              null,
	              opt.text
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return SimulationSelection;
	}(_react.Component);
	
	exports.default = SimulationSelection;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 0 30px;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 24px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  text-align: center;\n'], ['\n  margin: 0 0 30px;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 24px;\n  line-height: 60px;\n  font-weight: 700;\n  color: #2F4166;\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #FFFFFF;\n  border: 1px solid #55B4BC;\n  border-radius: 4px;\n  padding: 22px 20px;\n  margin-bottom: 24px;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2F4166;\n\n  strong { font-weight: 700; }\n'], ['\n  background: #FFFFFF;\n  border: 1px solid #55B4BC;\n  border-radius: 4px;\n  padding: 22px 20px;\n  margin-bottom: 24px;\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2F4166;\n\n  strong { font-weight: 700; }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #FFFFFF;\n  border: 2px solid transparent;\n  border-radius: 10px;\n  padding: 14px 20px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  box-shadow: 0 4px 4px #E2E2E2;\n\n  ', '\n\n  &:hover { border-color: ', '; }\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #FFFFFF;\n  border: 2px solid transparent;\n  border-radius: 10px;\n  padding: 14px 20px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n  box-shadow: 0 4px 4px #E2E2E2;\n\n  ', '\n\n  &:hover { border-color: ', '; }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n\n  strong {\n    display: inline-block;\n    color: #2F4166;\n    font-weight: 700;\n    font-size: 18px;\n    margin-right: 12px;\n  }\n'], ['\n  font-family: \'Mukta Mahee\', \'Mukta Vaani\', sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.6);\n\n  strong {\n    display: inline-block;\n    color: #2F4166;\n    font-weight: 700;\n    font-size: 18px;\n    margin-right: 12px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _OnboardingLayout = __webpack_require__(308);
	
	var _OnboardingLayout2 = _interopRequireDefault(_OnboardingLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	
	// Hardcoded question text lists. Resolved to backend question IDs at
	// runtime by matching normalized text against /v2/forms/questions/.
	var INITIAL_STAGE_QUESTIONS = ["What's working well within your team? What could work better?", "Besides yourself, who has been the most valuable person on your team?", "This team member RECOGNIZED other team members' contributions.", "This team member was RESPONSIVE to team members' communication within 24hrs.", "This team member has DEMONSTRATED that they are listening to others.", "This team member DID NOT DOMINATE discussions and DID NOT MAKE IT DIFFICULT for others to share their viewpoints.", "This team member CONTRIBUTED to the team.", "Would you want to work with this teammate again?", "I Like: In terms of working together, what did you like about <Insert User FirstName>? Provide examples if possible.", "I Wish: In terms of working together,  what do you wish <insert user firstname> could have done more of? Provide examples."];
	
	var FINAL_STAGE_QUESTIONS = ["What were your biggest takeaways from this exercise? What did you learn about yourself, working in teams, and business in general?", "If you had a chance to do it all over again, what would you have done differently?", "Besides yourself, who has been the most valuable person on your team?", "This team member RECOGNIZED other team members' contributions.", "This team member was RESPONSIVE to team members' communication within 24hrs.", "This team member has DEMONSTRATED that they are listening to others.", "This team member DID NOT DOMINATE discussions and DID NOT MAKE IT DIFFICULT for others to share their viewpoints.", "This team member CONTRIBUTED to the team.", "Would you want to work with this teammate again?", "I Like: In terms of working together, what did you like about <Insert User FirstName>? Provide examples if possible.", "I Wish: In terms of working together,  what do you wish <insert user firstname> could have done more of? Provide examples."];
	
	// Lenient normalizer: lowercase, strip punctuation/whitespace variants,
	// collapse runs of whitespace. Keeps the FE resilient to small typos or
	// punctuation drift between our hardcoded copy and the backend's stored
	// question text.
	var normalizeQuestionText = function normalizeQuestionText(s) {
	  return (s || '').toLowerCase().replace(/[^\w]+/g, ' ').replace(/\s+/g, ' ').trim();
	};
	
	var Heading = _styledComponents2.default.h1(_templateObject);
	
	var InfoBox = _styledComponents2.default.div(_templateObject2);
	
	var RadioRow = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.selected && '\n    border-color: #2F4166;\n    box-shadow: 0 4px 12px rgba(47, 65, 102, 0.15);\n  ';
	}, function (p) {
	  return p.selected ? '#2F4166' : 'rgba(47, 65, 102, 0.3)';
	});
	
	var RadioLabel = _styledComponents2.default.div(_templateObject4);
	
	var TeamEvaluationSurvey = function (_Component) {
	  _inherits(TeamEvaluationSurvey, _Component);
	
	  function TeamEvaluationSurvey() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamEvaluationSurvey);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamEvaluationSurvey.__proto__ || Object.getPrototypeOf(TeamEvaluationSurvey)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selected: null, submitting: false }, _this.handleSelect = function (value) {
	      if (_this.state.submitting) return;
	      _this.setState({ selected: value });
	    }, _this.handleContinue = function () {
	      var _this$state = _this.state,
	          selected = _this$state.selected,
	          submitting = _this$state.submitting;
	
	      if (!selected || submitting) return;
	
	      _this.setState({ submitting: true });
	
	      _this.fetchCourseGameType().then(function (gameType) {
	        var surveyWork = selected === 'yes' ? _this.createSurveys(gameType) : Promise.resolve();
	        return surveyWork.then(function () {
	          return _this.updateGradingWeights(selected, gameType);
	        });
	      }).then(function () {
	        return _this.recordSurveyDecision(selected);
	      }).then(function () {
	        return _this.flipOnboardFlag();
	      }).then(function () {
	        (0, _Location.changeLocation)('/instructor/welcome');
	      }).catch(function () {
	        _this.setState({ submitting: false });
	      });
	    }, _this.recordSurveyDecision = function (selected) {
	      var courseId = Number(_Auth2.default.getCourseId());
	      if (!courseId) return Promise.resolve();
	      return (0, _ApiService.patchRequest)(API + 'courses/' + courseId + '/').send({ survey_included: selected }).then(function () {
	        // Bust the general-info cache so the next fetchOnboardingSetup
	        // (e.g. App.js's per-navigation gate) sees the new value and
	        // doesn't yank the instructor back into onboarding.
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	      }).catch(function () {});
	    }, _this.createSurveys = function (gameType) {
	      var courseId = Number(_Auth2.default.getCourseId());
	
	      // Default survey windows, measured in days from onboarding time.
	      // Instructor can adjust each survey's start/end later on the peer-
	      // review admin page.
	      //   Initial (Adventurer only): 15 → 22 days
	      //   Final / Team Evaluation:   30 → 37 days
	      var daysFromNow = function daysFromNow(days) {
	        var dt = new Date();
	        dt.setDate(dt.getDate() + days);
	        return dt;
	      };
	
	      // Adventurer runs an Initial and a Final survey; Explorer and
	      // Legend run a single end-of-simulation Final survey. `stage` is
	      // sent on create so the dashboard's Initial/Final picker can
	      // distinguish surveys without falling back to date-sort heuristics.
	      var surveyPlan = gameType === 'Adventurer' ? [{
	        name: 'Initial Team Evaluation',
	        stage: 'initial',
	        questions: INITIAL_STAGE_QUESTIONS,
	        startDays: 15,
	        endDays: 22
	      }, {
	        name: 'Final Evaluation',
	        stage: 'final',
	        questions: FINAL_STAGE_QUESTIONS,
	        startDays: 30,
	        endDays: 37
	      }] : [{
	        name: 'Team Evaluation',
	        stage: 'final',
	        questions: FINAL_STAGE_QUESTIONS,
	        startDays: 15,
	        endDays: 22
	      }];
	
	      var createSurveyOnly = function createSurveyOnly(plan) {
	        return (0, _ApiService.postRequest)(API + 'v2/forms/surveys/create/').send({
	          name: plan.name,
	          course: courseId,
	          stage: plan.stage,
	          start: daysFromNow(plan.startDays).toISOString(),
	          end: daysFromNow(plan.endDays).toISOString(),
	          // Students see their own results once the survey closes.
	          view_results: true
	        });
	      };
	
	      // First: fetch existing surveys for this course and skip creating
	      // any planned survey whose name already exists. Guards against
	      // duplicate creations when a prior attempt succeeded on survey
	      // creation but failed downstream (e.g. gradingweights), and the
	      // user retried. Defensive course filter (same reason as
	      // updateGradingWeights) rejects rows the BE may return for other
	      // courses.
	      return (0, _ApiService.getRequest)(API + 'v2/forms/surveys/?course=' + courseId).then(function (res) {
	        var body = res.body || {};
	        var raw = Array.isArray(body) ? body : body.results || [];
	        var existing = raw.filter(function (s) {
	          return Number(s.course) === Number(courseId);
	        });
	        var existingNames = new Set(existing.map(function (s) {
	          return s.name;
	        }));
	        return surveyPlan.filter(function (p) {
	          return !existingNames.has(p.name);
	        });
	      }).catch(function () {
	        return surveyPlan;
	      }).then(function (plansToCreate) {
	        if (plansToCreate.length === 0) {
	          return [];
	        }
	
	        // Fetch all backend questions once, map by normalized text, then
	        // create each survey and POST its question set. page_size is padded
	        // so paginated list handlers still return everything in one call.
	        return (0, _ApiService.getRequest)(API + 'v2/forms/questions/?page_size=200').then(function (res) {
	          var body = res.body || {};
	          var allQuestions = Array.isArray(body) ? body : body.results || [];
	          var idByText = {};
	          allQuestions.forEach(function (q) {
	            if (q && q.text != null) {
	              idByText[normalizeQuestionText(q.text)] = q.id;
	            }
	          });
	
	          var perSurvey = plansToCreate.map(function (plan) {
	            var questionIds = plan.questions.map(function (t) {
	              return idByText[normalizeQuestionText(t)];
	            }).filter(function (id) {
	              return id != null;
	            });
	
	            return createSurveyOnly(plan).then(function (surveyRes) {
	              var surveyId = surveyRes && surveyRes.body && surveyRes.body.id;
	              if (!surveyId || questionIds.length === 0) return surveyRes;
	
	              var questions = questionIds.map(function (qId, idx) {
	                return {
	                  question_id: qId,
	                  list_order: idx + 1
	                };
	              });
	              return (0, _ApiService.postRequest)(API + 'v2/forms/surveys/' + surveyId + '/questions/').send({ questions: questions }).then(function () {
	                return surveyRes;
	              })
	              // Don't fail the onboarding chain if question attach fails.
	              // The survey is created; questions can be added later via
	              // the peer-review admin page.
	              .catch(function () {
	                return surveyRes;
	              });
	            });
	          });
	
	          return Promise.all(perSurvey);
	        }).catch(function () {
	          // If the questions fetch itself fails, still create the empty
	          // surveys so onboarding proceeds. Instructor can attach
	          // questions manually later.
	          return Promise.all(plansToCreate.map(createSurveyOnly));
	        });
	      });
	    }, _this.updateGradingWeights = function (selected, gameType) {
	      var courseId = Number(_Auth2.default.getCourseId());
	      var enablePeer = selected === 'yes' && (gameType === 'Explorer' || gameType === 'Adventurer');
	      var team_grade = enablePeer ? 0.60 : 1.0;
	      var peer_weight = enablePeer ? 0.40 : 0;
	
	      return new Promise(function (resolve, reject) {
	        (0, _ApiService.getRequest)(API + 'v2/games/gradingweights/?course=' + courseId).then(function (res) {
	          var body = res.body || {};
	          var raw = Array.isArray(body) ? body : body.results || [];
	          // Defensive filter: BE has been observed returning rows for
	          // OTHER courses even when the ?course= filter is applied.
	          // Only trust rows whose course field actually matches ours.
	          // Prevents onboarding from PATCHing a foreign course's row.
	          var results = raw.filter(function (r) {
	            return Number(r.course) === Number(courseId);
	          });
	          var weightsRow = results[0];
	          if (!weightsRow || !weightsRow.id) {
	            // No existing row — create one with the desired weights.
	            // Other grading dimensions default to 0; the instructor can
	            // adjust them later on the Set Team Score page.
	            (0, _ApiService.postRequest)(API + 'v2/games/gradingweights/').send({
	              course: courseId,
	              team_grade: team_grade,
	              peer_weight: peer_weight,
	              feedback_submission: 0,
	              engagement_score: 0
	            }).then(function () {
	              return resolve();
	            }).catch(function (err) {
	              return reject(err);
	            });
	            return;
	          }
	          // Send all 4 weight fields so the backend's constraint
	          // (peer_weight + team_grade + engagement_score +
	          // feedback_submission === 1) holds. A partial PATCH leaves
	          // stale non-zero values on the other two fields and
	          // triggers a "sum must be 1" non_field_errors response.
	          (0, _ApiService.patchRequest)(API + 'v2/games/gradingweights/' + weightsRow.id + '/').send({
	            team_grade: team_grade,
	            peer_weight: peer_weight,
	            feedback_submission: 0,
	            engagement_score: 0
	          }).then(function () {
	            return resolve();
	          }).catch(function (err) {
	            return reject(err);
	          });
	        }).catch(function (err) {
	          return reject(err);
	        });
	      });
	    }, _this.fetchCourseGameType = function () {
	      var courseId = Number(_Auth2.default.getCourseId());
	
	      return new Promise(function (resolve) {
	        (0, _ApiService.getRequest)(API + 'courses/' + courseId + '/').then(function (res) {
	          var body = res.body || {};
	          var raw = body.game_type || null;
	          resolve(raw ? raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase() : null);
	        }).catch(function () {
	          return resolve(null);
	        });
	      });
	    }, _this.flipOnboardFlag = function () {
	      var userId = _Auth2.default.getUserId();
	      return new Promise(function (resolve) {
	        (0, _ApiService.patchRequest)(API + 'users/' + userId + '/').send({ onboard: 1 }).then(function () {
	          var user = _Auth2.default.getUser();
	          if (user) _Auth2.default.setUserData(Object.assign({}, user, { onboard: 1 }));
	          resolve();
	        }).catch(function () {
	          return resolve();
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // PATCH the course so survey_included flips from null to "yes" or
	  // "no". The onboarding gate reads this field as its "did the
	  // instructor decide?" signal (see onboardingRouting.fetchOnboardingSetup).
	  // Non-fatal if it 500s: user can still progress; the gate will just
	  // re-prompt on next login.
	
	
	  _createClass(TeamEvaluationSurvey, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          selected = _state.selected,
	          submitting = _state.submitting;
	
	
	      return _react2.default.createElement(
	        _OnboardingLayout2.default,
	        {
	          progressStep: 3,
	          progressTotal: 4,
	          buttonLabel: submitting ? 'Saving' : 'Continue',
	          buttonDisabled: !selected || submitting,
	          onButtonClick: this.handleContinue,
	          onBack: function onBack() {
	            return (0, _Location.changeLocation)('/instructor/onboarding/simulation-selection');
	          }
	        },
	        _react2.default.createElement(
	          Heading,
	          null,
	          'Include Team Evaluation?'
	        ),
	        _react2.default.createElement(
	          InfoBox,
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Add the Peer Assessment form'
	          ),
	          ' to capture student reflections and peer feedback. It surfaces valuable insights: each student\'s biggest takeaway, the skills they demonstrated, and a teamwork score that factors into their overall grade, reinforcing accountability and stronger collaboration.'
	        ),
	        _react2.default.createElement(
	          RadioRow,
	          {
	            selected: selected === 'yes',
	            onClick: function onClick() {
	              return _this2.handleSelect('yes');
	            }
	          },
	          _react2.default.createElement(
	            RadioLabel,
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Yes'
	            ),
	            'I want students to complete the Peer Assessment form.'
	          )
	        ),
	        _react2.default.createElement(
	          RadioRow,
	          {
	            selected: selected === 'no',
	            onClick: function onClick() {
	              return _this2.handleSelect('no');
	            }
	          },
	          _react2.default.createElement(
	            RadioLabel,
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'No'
	            ),
	            'No, I do not want students to complete the Peer Assessment form.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamEvaluationSurvey;
	}(_react.Component);
	
	exports.default = TeamEvaluationSurvey;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px 31px 40px 38px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n'], ['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px 31px 40px 38px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n'], ['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _onboardingCheck = __webpack_require__(301);
	
	var _onboardingCheck2 = _interopRequireDefault(_onboardingCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Step = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var SubSection = _styledComponents2.default.div(_templateObject3);
	
	var SubSectionItem = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var Navigation = function Navigation(_ref) {
	  var data = _ref.data,
	      category = _ref.category;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    data.map(function (link, index) {
	      if (!!link.parent) {
	        return null;
	      }
	
	      var subLinks = data.filter(function (i) {
	        return i.parent === link.title;
	      });
	      var linkUrl = link.steps.length > 0 ? link.steps[0].url : subLinks.length > 0 ? subLinks[0].steps[0].url : null;
	      if (!linkUrl) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        { key: 'section-' + index },
	        _react2.default.createElement(
	          Step,
	          { isActive: true },
	          _react2.default.createElement('img', { src: _onboardingCheck2.default, alt: 'nav icon' }),
	          index !== category && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '' + linkUrl },
	            link.title
	          ),
	          index === category && link.title
	        ),
	        _react2.default.createElement(
	          SubSection,
	          null,
	          subLinks.map(function (subLink) {
	            var subLinkIndex = data.findIndex(function (i) {
	              return i.title === subLink.title;
	            });
	
	            return _react2.default.createElement(
	              SubSectionItem,
	              { key: 'subsection-' + index + '-' + subLinkIndex, isActive: true },
	              subLinkIndex !== category && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '' + subLink.steps[0].url },
	                subLink.title
	              ),
	              subLinkIndex === category && subLink.title
	            );
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = Navigation;

/***/ },
/* 1455 */
1446,
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var CustomBarLabel = function CustomBarLabel(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      value = _ref.value,
	      _ref$xOffset = _ref.xOffset,
	      xOffset = _ref$xOffset === undefined ? 30 : _ref$xOffset;
	
	  var xxOffset = x + width + xOffset;
	  var yyOffset = y + height / 2;
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: xxOffset,
	      y: yyOffset,
	      textAnchor: "middle",
	      dominantBaseline: "middle",
	      style: {
	        fontSize: 16,
	        lineHeight: 24,
	        color: '#0F2847'
	      }
	    },
	    value
	  );
	};
	var CustomLineLabel = function CustomLineLabel(props) {
	  var x = props.x,
	      y = props.y,
	      value = props.value;
	
	
	  return _react2.default.createElement(
	    "text",
	    {
	      x: x,
	      y: y,
	      style: {
	        fill: '#0F2847',
	        fontWeight: '700'
	      }
	    },
	    value
	  );
	};
	
	var getAllValues = function getAllValues(data) {
	  return data.map(function (item) {
	    return [Number(item.student), Number(item.teamAverage), Number(item.teamMedian)];
	  }).reduce(function (result, currentArray) {
	    return [].concat(_toConsumableArray(result), _toConsumableArray(currentArray));
	  }, []);
	};
	
	var Chart = function (_Component) {
	  _inherits(Chart, _Component);
	
	  function Chart() {
	    _classCallCheck(this, Chart);
	
	    return _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).apply(this, arguments));
	  }
	
	  _createClass(Chart, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          isBarChart = _props.isBarChart,
	          isLineChart = _props.isLineChart,
	          chartColors = _props.chartColors;
	
	
	      var allValues = isLineChart ? getAllValues(data) : null;
	
	      return isBarChart ? _react2.default.createElement(
	        _recharts.ResponsiveContainer,
	        { width: "100%", height: 136 },
	        _react2.default.createElement(
	          _recharts.BarChart,
	          {
	            data: data,
	            layout: "vertical",
	            margin: { top: 0, left: 0, right: 45, bottom: 0 }
	          },
	          _react2.default.createElement(_recharts.XAxis, { type: "number", hide: true, domain: [0, 5] }),
	          _react2.default.createElement(_recharts.YAxis, { type: "category", hide: true }),
	          _react2.default.createElement(
	            _recharts.Bar,
	            {
	              dataKey: "value",
	              label: _react2.default.createElement(CustomBarLabel, null)
	            },
	            data.map(function (item, index) {
	              return _react2.default.createElement(_recharts.Cell, {
	                key: index,
	                fill: item.color
	              });
	            })
	          )
	        )
	      ) : isLineChart ? _react2.default.createElement(
	        _recharts.ResponsiveContainer,
	        { width: "100%", height: 200 },
	        _react2.default.createElement(
	          _recharts.LineChart,
	          {
	            data: data,
	            margin: {
	              top: 0,
	              right: 0,
	              left: 0,
	              bottom: 0
	            }
	          },
	          _react2.default.createElement(_recharts.Tooltip, null),
	          _react2.default.createElement(_recharts.XAxis, {
	            dataKey: "name",
	            padding: { top: 30, left: 30, right: 30, bottom: 30 },
	            hide: true
	          }),
	          _react2.default.createElement(_recharts.YAxis, {
	            hide: true,
	            domain: [Math.min.apply(null, allValues) * 0.9, Math.max.apply(null, allValues) * 1.1]
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "student",
	            name: "Student",
	            stroke: chartColors[0],
	            dot: false,
	            activeDot: false,
	            label: _react2.default.createElement(CustomLineLabel, null),
	            strokeWidth: 2
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "teamAverage",
	            name: "Team Average",
	            stroke: chartColors[1],
	            dot: false,
	            activeDot: false,
	            label: _react2.default.createElement(CustomLineLabel, null),
	            strokeWidth: 2
	          }),
	          _react2.default.createElement(_recharts.Line, {
	            type: "monotone",
	            dataKey: "teamMedian",
	            name: "Team Median",
	            stroke: chartColors[2],
	            dot: false,
	            activeDot: false,
	            label: _react2.default.createElement(CustomLineLabel, null),
	            strokeWidth: 2
	          })
	        )
	      ) : null;
	    }
	  }]);
	
	  return Chart;
	}(_react.Component);
	
	exports.default = Chart;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _ui = __webpack_require__(85);
	
	var _dataDetails = __webpack_require__(309);
	
	var _dataDetails2 = _interopRequireDefault(_dataDetails);
	
	var _dominatePersonalities = __webpack_require__(2574);
	
	var _dominatePersonalities2 = _interopRequireDefault(_dominatePersonalities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DominantPersonalities = function (_PureComponent) {
	  _inherits(DominantPersonalities, _PureComponent);
	
	  function DominantPersonalities(props) {
	    _classCallCheck(this, DominantPersonalities);
	
	    var _this = _possibleConstructorReturn(this, (DominantPersonalities.__proto__ || Object.getPrototypeOf(DominantPersonalities)).call(this, props));
	
	    _this.state = {
	      mostDominantUsers: [],
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(DominantPersonalities, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var currentFinishedSurvey = this.props.currentFinishedSurvey;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'users', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/answers-list/?survey=' + currentFinishedSurvey.id]).then(function (res) {
	        var users = res[0].body;
	        var formsAnswersList = res[1].body.results;
	        var mostDominant = formsAnswersList.filter(function (formsAnswer) {
	          return formsAnswer.question_category === 'Collaboration' && formsAnswer.question_text.toLowerCase().includes('dominates discussions') && Number(formsAnswer.answer_text) >= 1 && Number(formsAnswer.answer_text) < 3;
	        }).sort(function (a, b) {
	          return Number(a.answer_text) - Number(b.answer_text);
	        });
	
	        var mostDominantUsers = [].concat(_toConsumableArray(new Set(mostDominant.map(function (item) {
	          var user = users.find(function (user) {
	            return user.email === item.receiver_email;
	          });
	          return user.first_name + ' ' + user.last_name;
	        }))));
	
	        _this2.setState({
	          loaded: true,
	          mostDominantUsers: mostDominantUsers
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          mostDominantUsers = _state.mostDominantUsers;
	
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Dominant Personalities'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'There were also ',
	            _react2.default.createElement(
	              'b',
	              null,
	              mostDominantUsers.length
	            ),
	            ' students that might have been dominating their team\u2019s discussions, making it difficult for others to share their points..'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          { transparent: true },
	          _react2.default.createElement(
	            _ui.ContentFlexColumns,
	            { withFloatinDetailsBlock: true },
	            _react2.default.createElement(_ui.Image, { src: _dominatePersonalities2.default, alt: 'Now that you are all my little drones, I encourage you to speak my mind.' })
	          ),
	          _react2.default.createElement(_dataDetails2.default, {
	            title: 'Most Dominant',
	            color: '#FE7474',
	            data: mostDominantUsers,
	            centered: true
	          })
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return DominantPersonalities;
	}(_react.PureComponent);
	
	exports.default = DominantPersonalities;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _ui = __webpack_require__(85);
	
	var _dataDetails = __webpack_require__(309);
	
	var _dataDetails2 = _interopRequireDefault(_dataDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var chartColors = ['#81c991', '#fd9595'];
	
	var Inclusiveness = function (_PureComponent) {
	  _inherits(Inclusiveness, _PureComponent);
	
	  function Inclusiveness(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Inclusiveness);
	
	    var _this = _possibleConstructorReturn(this, (Inclusiveness.__proto__ || Object.getPrototypeOf(Inclusiveness)).call(this, props));
	
	    _this.fetchFormsAnswersList = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(nextPage) {
	        var nextPageAvailable, formsAnswersList, nextPageUrl;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                nextPageAvailable = true;
	                formsAnswersList = [];
	                nextPageUrl = nextPage;
	
	              case 3:
	                if (!nextPageAvailable) {
	                  _context.next = 9;
	                  break;
	                }
	
	                nextPageAvailable = false;
	                _context.next = 7;
	                return (0, _ApiService.getRequest)(nextPageUrl)
	                // eslint-disable-next-line no-loop-func
	                .then(function (res) {
	                  nextPageUrl = res.body.next;
	                  nextPageAvailable = nextPageUrl;
	                  formsAnswersList.push.apply(formsAnswersList, _toConsumableArray(res.body.results));
	                }).catch(function (err) {});
	
	              case 7:
	                _context.next = 3;
	                break;
	
	              case 9:
	                return _context.abrupt('return', formsAnswersList);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.changeExtraDetails = function (title, color, data) {
	      _this.setState({
	        extraDetailsTitle: title,
	        extraDetailsColor: color,
	        extraDetailsData: data
	      });
	    };
	
	    _this.state = {
	      studentsFeltIncluded: [],
	      studentsFeltNotIncluded: [],
	      extraDetailsTitle: 'Felt Included',
	      extraDetailsColor: chartColors[0],
	      extraDetailsData: [],
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(Inclusiveness, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _props = this.props,
	          currentFinishedSurvey = _props.currentFinishedSurvey,
	          surveysStatsByUser = _props.surveysStatsByUser;
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'users', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/answers-list/?survey=' + currentFinishedSurvey.id]).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	          var users, formsAnswersList, nextPageAvailable, newFormsAnswersList, answersWithCriteria, uniqueCriteriaUsers, feltIncluded, studentsFeltIncluded, feltNotIncluded, studentsFeltNotIncluded;
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  users = res[0].body;
	                  formsAnswersList = res[1].body.results;
	                  nextPageAvailable = res[1].body.next;
	
	                  if (!nextPageAvailable) {
	                    _context2.next = 8;
	                    break;
	                  }
	
	                  _context2.next = 6;
	                  return _this3.fetchFormsAnswersList(nextPageAvailable);
	
	                case 6:
	                  newFormsAnswersList = _context2.sent;
	
	                  formsAnswersList.push.apply(formsAnswersList, _toConsumableArray(newFormsAnswersList));
	
	                case 8:
	                  answersWithCriteria = formsAnswersList.filter(function (formsAnswer) {
	                    var user = users.find(function (user) {
	                      return user.email === formsAnswer.giver_email;
	                    });
	
	                    return formsAnswer.question_category === 'Self assessment' && formsAnswer.question_text.toLowerCase().includes('inclusiveness') && surveysStatsByUser.find(function (userStats) {
	                      return userStats.user_id === user.id;
	                    }).evaluation_completed;
	                  });
	                  uniqueCriteriaUsers = [];
	                  feltIncluded = answersWithCriteria.filter(function (answerWithCriteria) {
	                    if (!uniqueCriteriaUsers.includes(answerWithCriteria.giver_email)) {
	                      var currentAnswerGiverEmail = answerWithCriteria.giver_email;
	                      uniqueCriteriaUsers.push(currentAnswerGiverEmail);
	                      var allUserAnswers = answersWithCriteria.filter(function (answerWithCriteria) {
	                        return answerWithCriteria.giver_email === currentAnswerGiverEmail;
	                      });
	                      return allUserAnswers.every(function (userAnswer) {
	                        return Number(userAnswer.answer_text) >= 4;
	                      });
	                    }
	                    return false;
	                  });
	                  studentsFeltIncluded = feltIncluded.map(function (item) {
	                    var user = users.find(function (user) {
	                      return user.email === item.giver_email;
	                    });
	                    return user.first_name + ' ' + user.last_name;
	                  });
	
	
	                  uniqueCriteriaUsers = [];
	                  feltNotIncluded = answersWithCriteria.filter(function (answerWithCriteria) {
	                    if (!uniqueCriteriaUsers.includes(answerWithCriteria.giver_email)) {
	                      var currentAnswerGiverEmail = answerWithCriteria.giver_email;
	                      uniqueCriteriaUsers.push(currentAnswerGiverEmail);
	                      var allUserAnswers = answersWithCriteria.filter(function (answerWithCriteria) {
	                        return answerWithCriteria.giver_email === currentAnswerGiverEmail;
	                      });
	                      return allUserAnswers.every(function (userAnswer) {
	                        return Number(userAnswer.answer_text) < 3;
	                      });
	                    }
	                    return false;
	                  });
	                  studentsFeltNotIncluded = feltNotIncluded.map(function (item) {
	                    var user = users.find(function (user) {
	                      return user.email === item.giver_email;
	                    });
	                    return user.first_name + ' ' + user.last_name;
	                  });
	
	
	                  _this3.setState({
	                    studentsFeltIncluded: studentsFeltIncluded,
	                    studentsFeltNotIncluded: studentsFeltNotIncluded,
	                    extraDetailsData: studentsFeltIncluded,
	                    loaded: true
	                  });
	
	                case 16:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, _this3);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }()).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var gamesTeamplayers = this.props.gamesTeamplayers;
	      var _state = this.state,
	          studentsFeltIncluded = _state.studentsFeltIncluded,
	          studentsFeltNotIncluded = _state.studentsFeltNotIncluded,
	          extraDetailsTitle = _state.extraDetailsTitle,
	          extraDetailsColor = _state.extraDetailsColor,
	          extraDetailsData = _state.extraDetailsData,
	          loaded = _state.loaded;
	
	
	      var studentsFeltIncludedCount = studentsFeltIncluded.length;
	      var studentsFeltNotIncludedCount = studentsFeltNotIncluded.length;
	
	      var chartData = [{
	        value: studentsFeltIncludedCount,
	        color: chartColors[0],
	        title: 'Felt Included'
	      }, {
	        value: studentsFeltNotIncludedCount,
	        color: chartColors[1],
	        title: 'Did Not Feel Included'
	      }];
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Inclusiveness'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'in terms of feeling included, ',
	            _react2.default.createElement(
	              'b',
	              null,
	              studentsFeltIncludedCount
	            ),
	            ' out of ',
	            _react2.default.createElement(
	              'b',
	              null,
	              gamesTeamplayers.length
	            ),
	            ' students felt heard and included in team discussions.'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'NOT Inclusive'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'However ',
	            _react2.default.createElement(
	              'b',
	              null,
	              studentsFeltNotIncludedCount
	            ),
	            ' students felt that they were not heard and/or included in team discussions.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.ContentTitle,
	            null,
	            'Individual Contributions'
	          ),
	          _react2.default.createElement(
	            _ui.ContentFlexColumns,
	            { withFloatinDetailsBlock: true, withPadding: true },
	            _react2.default.createElement(
	              _recharts.ResponsiveContainer,
	              { width: 170, height: 160 },
	              _react2.default.createElement(
	                _recharts.BarChart,
	                {
	                  data: chartData,
	                  margin: { top: 32, left: 10, right: 20, bottom: 38 }
	                },
	                _react2.default.createElement(
	                  _recharts.Bar,
	                  {
	                    barSize: 32,
	                    dataKey: 'value'
	                  },
	                  chartData.map(function (item, index) {
	                    return _react2.default.createElement(_recharts.Cell, { key: index, fill: item.color });
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _ui.ContentRightColumn,
	              null,
	              _react2.default.createElement(
	                _ui.ChartDataLabel,
	                {
	                  onClick: function onClick() {
	                    return _this4.changeExtraDetails(chartData[0].title, chartColors[0], studentsFeltIncluded);
	                  }
	                },
	                chartData[0].title + ' (' + studentsFeltIncludedCount + ')'
	              ),
	              _react2.default.createElement(
	                _ui.ChartDataLabel,
	                {
	                  color: chartColors[1],
	                  onClick: function onClick() {
	                    return _this4.changeExtraDetails(chartData[1].title, chartColors[1], studentsFeltNotIncluded);
	                  }
	                },
	                chartData[1].title + ' (' + studentsFeltNotIncludedCount + ')'
	              )
	            )
	          ),
	          _react2.default.createElement(_dataDetails2.default, {
	            title: extraDetailsTitle,
	            color: extraDetailsColor,
	            data: extraDetailsData
	          })
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return Inclusiveness;
	}(_react.PureComponent);
	
	exports.default = Inclusiveness;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _ui = __webpack_require__(85);
	
	var _dataDetails = __webpack_require__(309);
	
	var _dataDetails2 = _interopRequireDefault(_dataDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var chartColors = ['#81c991', '#fd9595'];
	
	var MostLeastValuablePlayers = function (_PureComponent) {
	  _inherits(MostLeastValuablePlayers, _PureComponent);
	
	  function MostLeastValuablePlayers(props) {
	    _classCallCheck(this, MostLeastValuablePlayers);
	
	    var _this = _possibleConstructorReturn(this, (MostLeastValuablePlayers.__proto__ || Object.getPrototypeOf(MostLeastValuablePlayers)).call(this, props));
	
	    _this.changeExtraDetails = function (title, color, data) {
	      _this.setState({
	        extraDetailsTitle: title,
	        extraDetailsColor: color,
	        extraDetailsData: data
	      });
	    };
	
	    _this.state = {
	      users: [],
	      mostValuableUsers: [],
	      leastValuableUsers: [],
	      extraDetailsTitle: 'Most Valuable Players',
	      extraDetailsColor: chartColors[0],
	      extraDetailsData: [],
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(MostLeastValuablePlayers, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveysStatsByUser = this.props.surveysStatsByUser;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'users').then(function (res) {
	        var users = res.body;
	        var mostValuable = surveysStatsByUser.filter(function (i) {
	          return i.most_valuable_percentage > 66;
	        });
	
	        var mostValuableUsers = mostValuable.map(function (item) {
	          var user = users.find(function (user) {
	            return user.id === item.user_id;
	          });
	          return user.first_name + ' ' + user.last_name;
	        });
	
	        var leastValuable = surveysStatsByUser.filter(function (i) {
	          return i.work_again_percentage <= 40;
	        });
	
	        var leastValuableUsers = leastValuable.map(function (item) {
	          var user = users.find(function (user) {
	            return user.id === item.user_id;
	          });
	          return user.first_name + ' ' + user.last_name;
	        });
	
	        _this2.setState({
	          mostValuableUsers: mostValuableUsers,
	          leastValuableUsers: leastValuableUsers,
	          extraDetailsData: mostValuableUsers,
	          loaded: true
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var gamesTeamplayers = this.props.gamesTeamplayers;
	      var _state = this.state,
	          mostValuableUsers = _state.mostValuableUsers,
	          leastValuableUsers = _state.leastValuableUsers,
	          extraDetailsTitle = _state.extraDetailsTitle,
	          extraDetailsColor = _state.extraDetailsColor,
	          extraDetailsData = _state.extraDetailsData,
	          loaded = _state.loaded;
	
	
	      var mostValuableCount = mostValuableUsers.length;
	
	      var leastValuableUsersCount = leastValuableUsers.length;
	
	      var chartData = [{
	        value: mostValuableCount,
	        color: chartColors[0],
	        title: 'Most Valuable Players'
	      }, {
	        value: leastValuableUsersCount,
	        color: chartColors[1],
	        title: 'Least Valuable Players'
	      }];
	
	      return loaded ? _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Most & Least Valuable Players'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Here are the most and least valuable players in the exercise.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'MVP'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              mostValuableCount
	            ),
	            ' students out of ',
	            _react2.default.createElement(
	              'b',
	              null,
	              gamesTeamplayers.length
	            ),
	            ' were the most valuable team member on their respective teams. Their teammates unanimously agreed that these students contributed the most impact on their team\u2019s success.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'LVP'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'However, there were ',
	            _react2.default.createElement(
	              'b',
	              null,
	              leastValuableUsersCount
	            ),
	            ' students that made the least impact on their respective teams. Students that fall into this category tend to have communication, work ethic, and/or dominant personalities issues.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.ContentTitle,
	            null,
	            'Individual Contributions'
	          ),
	          _react2.default.createElement(
	            _ui.ContentFlexColumns,
	            { withFloatinDetailsBlock: true, withPadding: true },
	            _react2.default.createElement(
	              _recharts.ResponsiveContainer,
	              { width: 170, height: 160 },
	              _react2.default.createElement(
	                _recharts.BarChart,
	                {
	                  data: chartData,
	                  margin: { top: 32, left: 10, right: 20, bottom: 38 }
	                },
	                _react2.default.createElement(
	                  _recharts.Bar,
	                  {
	                    barSize: 32,
	                    dataKey: 'value'
	                  },
	                  chartData.map(function (item, index) {
	                    return _react2.default.createElement(_recharts.Cell, { key: index, fill: item.color });
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _ui.ContentRightColumn,
	              null,
	              _react2.default.createElement(
	                _ui.ChartDataLabel,
	                {
	                  onClick: function onClick() {
	                    return _this3.changeExtraDetails(chartData[0].title, chartColors[0], mostValuableUsers);
	                  }
	                },
	                chartData[0].title + ' (' + mostValuableCount + ')'
	              ),
	              _react2.default.createElement(
	                _ui.ChartDataLabel,
	                {
	                  color: chartColors[1],
	                  onClick: function onClick() {
	                    return _this3.changeExtraDetails(chartData[1].title, chartColors[1], leastValuableUsers);
	                  }
	                },
	                chartData[1].title + ' (' + leastValuableUsersCount + ')'
	              )
	            )
	          ),
	          _react2.default.createElement(_dataDetails2.default, {
	            title: extraDetailsTitle,
	            color: extraDetailsColor,
	            data: extraDetailsData
	          })
	        )
	      ) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MostLeastValuablePlayers;
	}(_react.PureComponent);
	
	exports.default = MostLeastValuablePlayers;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _ui = __webpack_require__(85);
	
	var _selectorWrapper = __webpack_require__(262);
	
	var _selectorWrapper2 = _interopRequireDefault(_selectorWrapper);
	
	var _peerRatingChart = __webpack_require__(1456);
	
	var _peerRatingChart2 = _interopRequireDefault(_peerRatingChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var chartColors = ['#52C5CD', '#D9DDE2', '#9EA8B4'];
	
	var PeerRating = function (_Component) {
	  _inherits(PeerRating, _Component);
	
	  function PeerRating(props) {
	    _classCallCheck(this, PeerRating);
	
	    var _this = _possibleConstructorReturn(this, (PeerRating.__proto__ || Object.getPrototypeOf(PeerRating)).call(this, props));
	
	    _this.handleSelectChange = function (value) {
	      var _this$props = _this.props,
	          currentFinishedSurvey = _this$props.currentFinishedSurvey,
	          finishedSurveys = _this$props.finishedSurveys;
	      var _this$state = _this.state,
	          defaultChartData = _this$state.defaultChartData,
	          isBarChart = _this$state.isBarChart,
	          isLineChart = _this$state.isLineChart;
	
	
	      if (value === 0) {
	        _this.setState({
	          selectedUserId: value,
	          chartData: defaultChartData,
	          loaded: true
	        });
	      } else {
	        _this.setState({
	          loaded: false,
	          selectedUserId: value
	        });
	
	        var chartData = [];
	
	        if (isBarChart) {
	          (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + value + '/' + currentFinishedSurvey.id + '/').then(function (res) {
	            var formsScore = res.body;
	            chartData = [{
	              value: formsScore.median_user_score.toFixed(2),
	              color: chartColors[0]
	            }, {
	              value: formsScore.team_average_score.toFixed(2),
	              color: chartColors[1]
	            }, {
	              value: formsScore.team_median_score.toFixed(2),
	              color: chartColors[2]
	            }];
	
	            _this.setState({
	              loaded: true,
	              chartData: chartData
	            });
	          }).catch(function (err) {});
	        } else if (isLineChart) {
	          var requests = [];
	          finishedSurveys.forEach(function (finishedSurvey) {
	            requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + value + '/' + finishedSurvey.id + '/'));
	          });
	          var formsScoreRequest = Promise.all(requests);
	
	          formsScoreRequest.then(function (responses) {
	            responses.forEach(function (res, index) {
	              var formsScore = res.body;
	              chartData.push({
	                name: '' + finishedSurveys[index].stage[0].toUpperCase() + finishedSurveys[index].stage.slice(1) + ' Feedback',
	                student: formsScore.median_user_score.toFixed(2),
	                teamAverage: formsScore.team_average_score.toFixed(2),
	                teamMedian: formsScore.team_median_score.toFixed(2)
	              });
	            });
	
	            _this.setState({
	              loaded: true,
	              chartData: chartData
	            });
	          }).catch(function (err) {});
	        }
	      }
	    };
	
	    _this.state = {
	      chartData: [],
	      defaultChartData: [],
	      isBarChart: false,
	      isLineChart: false,
	      selectedUserId: 0,
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(PeerRating, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var _props, finishedSurveys, surveysStatsByUser, surveysStatsByTeam, chartData, isBarChart, isLineChart, medianUserAverage, medianteamAverage, teamMedian, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, finishedSurvey;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props = this.props, finishedSurveys = _props.finishedSurveys, surveysStatsByUser = _props.surveysStatsByUser, surveysStatsByTeam = _props.surveysStatsByTeam;
	                chartData = [];
	                isBarChart = false;
	                isLineChart = false;
	                medianUserAverage = (surveysStatsByUser.reduce(function (total, next) {
	                  return total + Number(next.median);
	                }, 0) / surveysStatsByUser.length).toFixed(2);
	                medianteamAverage = (surveysStatsByTeam.reduce(function (total, next) {
	                  return total + Number(next.average_over_median);
	                }, 0) / surveysStatsByTeam.length).toFixed(2);
	                teamMedian = (surveysStatsByTeam.reduce(function (total, next) {
	                  return total + Number(next.average_over_median);
	                }, 0) / surveysStatsByTeam.length).toFixed(2);
	
	                if (!(finishedSurveys.length === 1)) {
	                  _context2.next = 13;
	                  break;
	                }
	
	                isBarChart = true;
	
	                chartData = [{
	                  value: medianUserAverage,
	                  color: chartColors[0]
	                }, {
	                  value: medianteamAverage,
	                  color: chartColors[1]
	                }, {
	                  value: teamMedian,
	                  color: chartColors[2]
	                }];
	
	                this.setState({
	                  chartData: chartData,
	                  defaultChartData: chartData,
	                  isBarChart: isBarChart,
	                  loaded: true
	                });
	                _context2.next = 43;
	                break;
	
	              case 13:
	                if (!(finishedSurveys.length > 1)) {
	                  _context2.next = 43;
	                  break;
	                }
	
	                isLineChart = true;
	
	                _loop = _regenerator2.default.mark(function _callee(finishedSurvey) {
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _context.next = 2;
	                          return (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + finishedSurvey.id + '/stats-by-user/', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + finishedSurvey.id + '/stats-by-team/']).then(function (res) {
	                            var surveyStatsByUser = res[0].body;
	                            var surveyStatsByTeam = res[1].body;
	
	                            var medianUserAverage = (surveyStatsByUser.reduce(function (total, next) {
	                              return total + Number(next.median);
	                            }, 0) / surveyStatsByUser.length).toFixed(2);
	                            var medianteamAverage = (surveyStatsByTeam.reduce(function (total, next) {
	                              return total + Number(next.average_over_median);
	                            }, 0) / surveyStatsByTeam.length).toFixed(2);
	                            var teamMedian = (surveysStatsByTeam.reduce(function (total, next) {
	                              return total + Number(next.average_over_median);
	                            }, 0) / surveysStatsByTeam.length).toFixed(2);
	
	                            chartData.push({
	                              name: '' + finishedSurvey.stage[0].toUpperCase() + finishedSurvey.stage.slice(1) + ' Feedback',
	                              student: medianUserAverage,
	                              teamAverage: medianteamAverage,
	                              teamMedian: teamMedian
	                            });
	                          }).catch(function (err) {});
	
	                        case 2:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this2);
	                });
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context2.prev = 19;
	                _iterator = finishedSurveys.slice(0, finishedSurveys.length - 1)[Symbol.iterator]();
	
	              case 21:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context2.next = 27;
	                  break;
	                }
	
	                finishedSurvey = _step.value;
	                return _context2.delegateYield(_loop(finishedSurvey), 't0', 24);
	
	              case 24:
	                _iteratorNormalCompletion = true;
	                _context2.next = 21;
	                break;
	
	              case 27:
	                _context2.next = 33;
	                break;
	
	              case 29:
	                _context2.prev = 29;
	                _context2.t1 = _context2['catch'](19);
	                _didIteratorError = true;
	                _iteratorError = _context2.t1;
	
	              case 33:
	                _context2.prev = 33;
	                _context2.prev = 34;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 36:
	                _context2.prev = 36;
	
	                if (!_didIteratorError) {
	                  _context2.next = 39;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 39:
	                return _context2.finish(36);
	
	              case 40:
	                return _context2.finish(33);
	
	              case 41:
	
	                chartData.push({
	                  student: medianUserAverage,
	                  teamAverage: medianteamAverage,
	                  teamMedian: teamMedian
	                });
	
	                this.setState({
	                  chartData: chartData,
	                  defaultChartData: chartData,
	                  isLineChart: isLineChart,
	                  loaded: true
	                });
	
	              case 43:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[19, 29, 33, 41], [34,, 36, 40]]);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          chartData = _state.chartData,
	          defaultChartData = _state.defaultChartData,
	          isBarChart = _state.isBarChart,
	          isLineChart = _state.isLineChart,
	          selectedUserId = _state.selectedUserId,
	          loaded = _state.loaded;
	
	
	      var options = this.teamPlayersOptions;
	
	      var medianUserAverage = isBarChart ? defaultChartData[0].value : 0;
	      var medianteamAverage = isBarChart ? defaultChartData[1].value : 0;
	
	      var title = isBarChart ? 'Peer rating in relation to Team’s' : 'Peer Rating Score Trend';
	      var text = isBarChart ? _react2.default.createElement(
	        'p',
	        null,
	        'Here are your students peer rating scores in comparison to their teammates\u2019. On average, the median rating that students receive from their peers were ',
	        _react2.default.createElement(
	          'b',
	          null,
	          medianUserAverage
	        ),
	        ' out of 5 whereas the overall team\u2019s median was ',
	        _react2.default.createElement(
	          'b',
	          null,
	          medianteamAverage
	        ),
	        ' rating.'
	      ) : _react2.default.createElement(
	        'p',
	        null,
	        'Here\u2019s the change in your peer rating score.'
	      );
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          text
	        ),
	        _react2.default.createElement(_selectorWrapper2.default, {
	          label: 'View',
	          options: options,
	          onSelectorChange: this.handleSelectChange,
	          selectedOptionId: selectedUserId
	        }),
	        !loaded && _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true }),
	        loaded && _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.Charts.Teams.Wrapper,
	            null,
	            _react2.default.createElement(
	              _ui.Charts.Teams.Row,
	              null,
	              _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: chartColors[0] }),
	              _react2.default.createElement(
	                _ui.Charts.Teams.TeamName,
	                null,
	                'Student'
	              )
	            ),
	            _react2.default.createElement(
	              _ui.Charts.Teams.Row,
	              null,
	              _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: chartColors[1] }),
	              _react2.default.createElement(
	                _ui.Charts.Teams.TeamName,
	                null,
	                'Team Average'
	              )
	            ),
	            _react2.default.createElement(
	              _ui.Charts.Teams.Row,
	              null,
	              _react2.default.createElement(_ui.Charts.Teams.TeamColor, { background: chartColors[2] }),
	              _react2.default.createElement(
	                _ui.Charts.Teams.TeamName,
	                null,
	                'Team Median'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _ui.Charts.Chart,
	            null,
	            _react2.default.createElement(_peerRatingChart2.default, {
	              data: chartData,
	              isBarChart: isBarChart,
	              isLineChart: isLineChart,
	              chartColors: chartColors
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'teamPlayersOptions',
	    get: function get() {
	      var gamesTeamplayers = this.props.gamesTeamplayers;
	
	      var options = gamesTeamplayers.map(function (gamesTeamplayer) {
	        return {
	          id: gamesTeamplayer.user.id,
	          name: gamesTeamplayer.user.first_name + ' ' + gamesTeamplayer.user.last_name
	        };
	      });
	
	      var sortedOptions = [].concat(_toConsumableArray(options)).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	
	      sortedOptions.unshift({ id: 0, name: 'Overall' });
	      return sortedOptions;
	    }
	  }]);
	
	  return PeerRating;
	}(_react.Component);
	
	exports.default = PeerRating;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _ui = __webpack_require__(85);
	
	var _recharts = __webpack_require__(27);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _selectorWrapper = __webpack_require__(262);
	
	var _selectorWrapper2 = _interopRequireDefault(_selectorWrapper);
	
	var _peerFeedback = __webpack_require__(1433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelfAssessment = function (_PureComponent) {
	  _inherits(SelfAssessment, _PureComponent);
	
	  function SelfAssessment(props) {
	    _classCallCheck(this, SelfAssessment);
	
	    var _this = _possibleConstructorReturn(this, (SelfAssessment.__proto__ || Object.getPrototypeOf(SelfAssessment)).call(this, props));
	
	    _this.generateChartData = function (selfAssessmentDataProp, teamsAssessmentDataProp) {
	      var _this$state = _this.state,
	          isRelevantKnowledgeChart = _this$state.isRelevantKnowledgeChart,
	          isHandlingConflictsChart = _this$state.isHandlingConflictsChart;
	
	
	      var chartData = [];
	      if (isRelevantKnowledgeChart && !isHandlingConflictsChart) {
	        chartData = _this.generateChartDataForSpecificQuestions(_peerFeedback.relevantKnowledgeQuestions, selfAssessmentDataProp, teamsAssessmentDataProp);
	      } else if (isHandlingConflictsChart && !isRelevantKnowledgeChart) {
	        chartData = _this.generateChartDataForSpecificQuestions(_peerFeedback.handlingConflictsQuestions, selfAssessmentDataProp, teamsAssessmentDataProp);
	      }
	
	      return chartData;
	    };
	
	    _this.generateChartDataForSpecificQuestions = function (questionsArray, selfAssessmentDataProp, teamsAssessmentDataProp) {
	      var surveysStats = _this.props.surveysStats;
	
	
	      var selfAssessmentData = selfAssessmentDataProp ? selfAssessmentDataProp : surveysStats;
	      var teamsAssessmentData = teamsAssessmentDataProp ? teamsAssessmentDataProp : surveysStats;
	
	      var teamsAssessmentQuestionPropName = teamsAssessmentDataProp ? 'question' : 'question_text';
	
	      var selfAssessmentValuePropName = selfAssessmentDataProp ? 'answer_text' : 'class_median';
	      var teamsAssessmentValuePropName = teamsAssessmentDataProp ? 'median' : 'class_median';
	      var selfAssessmentTotal = 0;
	      var teamsAssessmentTotal = 0;
	      var chartData = [];
	      chartData = questionsArray.map(function (handlingConflictsQuestion) {
	        var selfAssessment = selfAssessmentData.find(function (item) {
	          return item.question_text.toLowerCase().includes(handlingConflictsQuestion.toLowerCase()) && item.question_category === 'Self assessment';
	        });
	
	        var teamsAssessment = teamsAssessmentData.find(function (item) {
	          var teamsAssessmentExtraCondition = teamsAssessmentDataProp ? true : item.question_category === 'Collaboration';
	          return item[teamsAssessmentQuestionPropName].toLowerCase().includes(handlingConflictsQuestion.toLowerCase()) && teamsAssessmentExtraCondition;
	        });
	
	        var selfAssessmentValue = selfAssessment ? Number(selfAssessment[selfAssessmentValuePropName]).toFixed(2) : '0.00';
	        var teamsAssessmentValue = teamsAssessment ? Number(teamsAssessment[teamsAssessmentValuePropName]).toFixed(2) : '0.00';
	
	        selfAssessmentTotal += Number(selfAssessmentValue);
	        teamsAssessmentTotal += Number(teamsAssessmentValue);
	        return {
	          selfAssessment: selfAssessmentValue,
	          teamsAssessment: teamsAssessmentValue,
	          question: handlingConflictsQuestion
	        };
	      });
	
	      chartData.push({
	        selfAssessment: (selfAssessmentTotal / chartData.length).toFixed(2),
	        teamsAssessment: (teamsAssessmentTotal / chartData.length).toFixed(2),
	        question: 'Overall'
	      });
	      return chartData;
	    };
	
	    _this.hideErrorAlert = function () {
	      _this.setState({
	        showError: false
	      });
	    };
	
	    _this.customAxisTick = function (_ref) {
	      var x = _ref.x,
	          y = _ref.y,
	          textAnchor = _ref.textAnchor,
	          payload = _ref.payload;
	
	      var regex = /(?![^\n]{1,10}$)([^\n]{1,10})\s/g;
	      var labelRows = payload.value.split(regex).filter(function (i) {
	        return i !== '';
	      });
	
	      var labelRowHeight = 28;
	      var marginTop = 24;
	      var labelsToDisplay = labelRows.map(function (string, index) {
	        var newRowShift = index * labelRowHeight;
	        return _react2.default.createElement(
	          'tspan',
	          { key: index, y: y + newRowShift + marginTop, x: x },
	          string
	        );
	      });
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-layer recharts-cartesian-axis-tick' },
	        _react2.default.createElement(
	          'text',
	          {
	            x: x,
	            y: y,
	            textAnchor: textAnchor,
	            style: {
	              fontWeight: 700,
	              fontSize: 12,
	              lineHeight: 28,
	              fill: '#3A507B'
	            }
	          },
	          labelsToDisplay
	        )
	      );
	    };
	
	    _this.handleSelectChange = function (value) {
	      var currentFinishedSurvey = _this.props.currentFinishedSurvey;
	      var defaultChartData = _this.state.defaultChartData;
	
	
	      if (value === 0) {
	        _this.setState({
	          selectedUserId: value,
	          chartData: defaultChartData,
	          loaded: true
	        });
	      } else {
	        _this.setState({
	          loaded: false,
	          selectedUserId: value
	        });
	
	        (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/forms/answers-list/?survey=' + currentFinishedSurvey.id + '&giver=' + value, ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/score/' + value + '/' + currentFinishedSurvey.id + '/']).then(function (res) {
	          var formsAnswersList = res[0].body.results;
	          var formsScore = res[1].body;
	
	          var chartData = _this.generateChartData(formsAnswersList, formsScore.user_score_question);
	
	          _this.setState({
	            loaded: true,
	            chartData: chartData
	          });
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.state = {
	      isRelevantKnowledgeChart: false,
	      isHandlingConflictsChart: null,
	      selfAssessmentAverage: 0,
	      collaborationAverage: 0,
	      showError: false,
	      chartData: [],
	      defaultChartData: [],
	      selectedUserId: 0,
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(SelfAssessment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var surveysStats = this.props.surveysStats;
	
	
	      var selfAssessmentStats = [];
	      var collaborationStats = [];
	
	      var isRelevantKnowledgeChart = false;
	      var isHandlingConflictsChart = false;
	
	      surveysStats.forEach(function (surveyStats) {
	        if (surveyStats.question_category === 'Self assessment' && _peerFeedback.selfAssessmentQuestions.some(function (selfAssessmentQuestion) {
	          return surveyStats.question_text.toLowerCase().includes(selfAssessmentQuestion);
	        })) {
	          selfAssessmentStats.push(surveyStats);
	        }
	        if (surveyStats.question_category === 'Collaboration' && _peerFeedback.selfAssessmentQuestions.some(function (selfAssessmentQuestion) {
	          return surveyStats.question_text.toLowerCase().includes(selfAssessmentQuestion);
	        })) {
	          collaborationStats.push(surveyStats);
	        }
	
	        if (surveyStats.question_text.toLowerCase().includes('having relevant knowledge, skills, and abilities')) {
	          isRelevantKnowledgeChart = true;
	        }
	        if (surveyStats.question_text.toLowerCase().includes('handling conflicts')) {
	          isHandlingConflictsChart = true;
	        }
	      });
	
	      var chartLength = selfAssessmentStats.length > collaborationStats.length ? selfAssessmentStats.length : collaborationStats.length;
	      var selfAssessmentAverage = (selfAssessmentStats.reduce(function (total, next) {
	        return total + Number(next.class_median);
	      }, 0) / chartLength).toFixed(2);
	      var collaborationAverage = (collaborationStats.reduce(function (total, next) {
	        return total + Number(next.class_median);
	      }, 0) / chartLength).toFixed(2);
	      var showError = isRelevantKnowledgeChart && isHandlingConflictsChart || !isRelevantKnowledgeChart && !isHandlingConflictsChart ? true : false;
	
	      this.setState({
	        isRelevantKnowledgeChart: isRelevantKnowledgeChart,
	        isHandlingConflictsChart: isHandlingConflictsChart
	      }, function () {
	        var chartData = _this2.generateChartData();
	        _this2.setState({
	          selfAssessmentAverage: selfAssessmentAverage,
	          collaborationAverage: collaborationAverage,
	          showError: showError,
	          chartData: chartData,
	          defaultChartData: chartData,
	          loaded: true
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          selfAssessmentAverage = _state.selfAssessmentAverage,
	          collaborationAverage = _state.collaborationAverage,
	          showError = _state.showError,
	          chartData = _state.chartData,
	          selectedUserId = _state.selectedUserId,
	          loaded = _state.loaded;
	
	
	      var options = this.teamPlayersOptions;
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        showError && _react2.default.createElement(_error2.default, {
	          title: 'Error | Data conflict',
	          message: 'No data to display due to conflicting information. Please reach out to customer support.',
	          onHide: this.hideErrorAlert
	        }),
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Self-Assessment'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Here\u2019s a snapshot of students perception of self in relation to how their teammates perceives them.  On average, students rated their team skills ',
	          _react2.default.createElement(
	            'b',
	            null,
	            selfAssessmentAverage
	          ),
	          ' out of 5 whereas their teammates gave them a ',
	          _react2.default.createElement(
	            'b',
	            null,
	            collaborationAverage
	          ),
	          ' rating.'
	        ),
	        _react2.default.createElement(_selectorWrapper2.default, {
	          label: 'View',
	          options: options,
	          onSelectorChange: this.handleSelectChange,
	          selectedOptionId: selectedUserId
	        }),
	        !loaded && _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true }),
	        !showError && loaded && _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.Assessments.Legends,
	            null,
	            _react2.default.createElement(
	              _ui.Assessments.Legend,
	              null,
	              'Self Assessment'
	            ),
	            _react2.default.createElement(
	              _ui.Assessments.Legend,
	              null,
	              'Team\u2019s Assessment'
	            )
	          ),
	          _react2.default.createElement(
	            _ui.Assessments.Marks,
	            null,
	            _react2.default.createElement(
	              _ui.Assessments.Mark,
	              null,
	              '5 = Strongly Agree'
	            ),
	            _react2.default.createElement(
	              _ui.Assessments.Mark,
	              null,
	              '3 = Neither'
	            ),
	            _react2.default.createElement(
	              _ui.Assessments.Mark,
	              null,
	              '1 = Strongly Disagree'
	            )
	          ),
	          _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { width: 672, height: 375 },
	            _react2.default.createElement(
	              _recharts.LineChart,
	              {
	                data: chartData.slice(),
	                margin: { top: 10, bottom: 40, right: 50 }
	              },
	              _react2.default.createElement(_recharts.CartesianGrid, {
	                stroke: 'rgba(0, 0, 0, 0.1)',
	                vertical: false
	              }),
	              _react2.default.createElement(_recharts.XAxis, {
	                dataKey: 'question',
	                axisLine: false,
	                tickLine: false,
	                tickCount: chartData.length,
	                interval: 0,
	                tick: this.customAxisTick
	              }),
	              _react2.default.createElement(_recharts.YAxis, {
	                tickLine: false,
	                axisLine: false,
	                domain: [0, 5],
	                ticks: [0, 1, 2, 3, 4, 5],
	                style: {
	                  fontWeight: 700,
	                  fontSize: 14,
	                  lineHeight: 28,
	                  fill: '#3A507B'
	                },
	                dx: -22
	              }),
	              _react2.default.createElement(_recharts.Tooltip, { cursor: false }),
	              _react2.default.createElement(_recharts.Line, {
	                type: 'monotone',
	                dataKey: 'selfAssessment',
	                name: 'Self Assessment',
	                stroke: '#52C5CD',
	                strokeWidth: 3,
	                dot: false,
	                activeDot: false
	              }),
	              _react2.default.createElement(_recharts.Line, {
	                type: 'monotone',
	                dataKey: 'teamsAssessment',
	                name: 'Team\u2019s Assessment',
	                stroke: '#667689',
	                strokeWidth: 3,
	                dot: false,
	                activeDot: false
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'teamPlayersOptions',
	    get: function get() {
	      var gamesTeamplayers = this.props.gamesTeamplayers;
	
	      var options = gamesTeamplayers.map(function (gamesTeamplayer) {
	        return {
	          id: gamesTeamplayer.user.id,
	          name: gamesTeamplayer.user.first_name + ' ' + gamesTeamplayer.user.last_name
	        };
	      });
	      var sortedOptions = [].concat(_toConsumableArray(options)).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	
	      sortedOptions.unshift({ id: 0, name: 'Overall' });
	      return sortedOptions;
	    }
	  }]);
	
	  return SelfAssessment;
	}(_react.PureComponent);
	
	exports.default = SelfAssessment;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(85);
	
	var _peerFeedbackStrengthAreasOfDevelopment = __webpack_require__(566);
	
	var _peerFeedbackStrengthAreasOfDevelopment2 = _interopRequireDefault(_peerFeedbackStrengthAreasOfDevelopment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TheIndividual = function (_PureComponent) {
	  _inherits(TheIndividual, _PureComponent);
	
	  function TheIndividual() {
	    _classCallCheck(this, TheIndividual);
	
	    return _possibleConstructorReturn(this, (TheIndividual.__proto__ || Object.getPrototypeOf(TheIndividual)).apply(this, arguments));
	  }
	
	  _createClass(TheIndividual, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'The Individual'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Exploring the individual'
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          { transparent: true },
	          _react2.default.createElement('img', { src: _peerFeedbackStrengthAreasOfDevelopment2.default, alt: 'Engagement Score' })
	        )
	      );
	    }
	  }]);
	
	  return TheIndividual;
	}(_react.PureComponent);
	
	exports.default = TheIndividual;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _answersProfilePic = __webpack_require__(1051);
	
	var _answersProfilePic2 = _interopRequireDefault(_answersProfilePic);
	
	var _answersProfilePic3 = __webpack_require__(1052);
	
	var _answersProfilePic4 = _interopRequireDefault(_answersProfilePic3);
	
	var _answersProfilePic5 = __webpack_require__(1053);
	
	var _answersProfilePic6 = _interopRequireDefault(_answersProfilePic5);
	
	var _answersProfilePic7 = __webpack_require__(1054);
	
	var _answersProfilePic8 = _interopRequireDefault(_answersProfilePic7);
	
	var _ui = __webpack_require__(85);
	
	var _selectorWrapper = __webpack_require__(262);
	
	var _selectorWrapper2 = _interopRequireDefault(_selectorWrapper);
	
	var _answersPagination = __webpack_require__(606);
	
	var _answersPagination2 = _interopRequireDefault(_answersPagination);
	
	var _constants = __webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var profilePictures = [_answersProfilePic2.default, _answersProfilePic4.default, _answersProfilePic6.default, _answersProfilePic8.default];
	
	var randomIntFromInterval = function randomIntFromInterval(min, max) {
	  return Math.floor(Math.random() * (max - min + 1) + min);
	};
	
	var BiggestTakeaway = function (_Component) {
	  _inherits(BiggestTakeaway, _Component);
	
	  function BiggestTakeaway(props) {
	    _classCallCheck(this, BiggestTakeaway);
	
	    var _this = _possibleConstructorReturn(this, (BiggestTakeaway.__proto__ || Object.getPrototypeOf(BiggestTakeaway)).call(this, props));
	
	    _this.handlePageChange = function (page) {
	      var _this$state = _this.state,
	          rowsPerPage = _this$state.rowsPerPage,
	          rowsTotal = _this$state.rowsTotal,
	          biggestTakeawayItems = _this$state.biggestTakeawayItems;
	
	
	      _this.setState({
	        page: page,
	        biggestTakeawayItemsToShow: biggestTakeawayItems.slice(rowsPerPage * (page - 1), rowsPerPage * page),
	        activePrevPage: rowsPerPage < rowsPerPage * page - 1,
	        activeNextPage: rowsPerPage * page < rowsTotal
	      });
	    };
	
	    _this.handleRowsPerPageChange = function (index) {
	      var _this$state2 = _this.state,
	          rowsTotal = _this$state2.rowsTotal,
	          biggestTakeawayItems = _this$state2.biggestTakeawayItems;
	
	
	      var rowsPerPage = _constants.answersRowsPerPage[index].name;
	
	      _this.setState({
	        page: 1,
	        rowsPerPage: _constants.answersRowsPerPage[index].name,
	        activeNextPage: rowsPerPage < rowsTotal,
	        biggestTakeawayItemsToShow: biggestTakeawayItems.slice(0, rowsPerPage),
	        selectedOptionId: index
	      });
	    };
	
	    _this.state = {
	      selectedUserId: 0,
	      loaded: false,
	      biggestTakeawayItems: [],
	      biggestTakeawayItemsToShow: [],
	      rowsPerPage: _constants.answersRowsPerPage[0].name,
	      rowsTotal: 0,
	      page: 1,
	      activePrevPage: null,
	      activeNextPage: null
	    };
	    return _this;
	  }
	
	  _createClass(BiggestTakeaway, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var currentFinishedSurvey, rowsPerPage;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                currentFinishedSurvey = this.props.currentFinishedSurvey;
	                rowsPerPage = this.state.rowsPerPage;
	
	                (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'users', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/answers-list/?survey=' + currentFinishedSurvey.id]).then(function (res) {
	                  var users = res[0].body;
	                  var formsAnswersList = res[1].body.results;
	                  var biggestTakeawayAnswers = formsAnswersList.filter(function (formsAnswer) {
	                    return formsAnswer.question_text.toLowerCase().includes('biggest takeaway');
	                  });
	
	                  var biggestTakeawayItems = [].concat(_toConsumableArray(new Set(biggestTakeawayAnswers.map(function (item) {
	                    var user = users.find(function (user) {
	                      return user.email === item.giver_email;
	                    });
	                    var firstName = user.first_name;
	                    var lastName = user.last_name;
	                    var showDotFirstName = firstName.length > 1 ? '.' : '';
	                    var showDotLastName = lastName.length > 1 ? '.' : '';
	                    return {
	                      displayName: '' + firstName.substring(0, 1) + showDotFirstName + ' ' + lastName.substring(0, 1) + showDotLastName,
	                      tooltip: user.first_name + ' ' + user.last_name,
	                      answer: item.answer_text
	                    };
	                  }))));
	
	                  var rowsTotal = biggestTakeawayItems.length;
	
	                  _this2.setState({
	                    loaded: true,
	                    biggestTakeawayItems: biggestTakeawayItems,
	                    biggestTakeawayItemsToShow: biggestTakeawayItems.slice(0, rowsPerPage),
	                    rowsTotal: rowsTotal,
	                    activeNextPage: rowsPerPage < rowsTotal
	                  });
	                }).catch(function (err) {});
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          selectedUserId = _state.selectedUserId,
	          loaded = _state.loaded,
	          biggestTakeawayItemsToShow = _state.biggestTakeawayItemsToShow,
	          rowsPerPage = _state.rowsPerPage,
	          rowsTotal = _state.rowsTotal,
	          page = _state.page,
	          activePrevPage = _state.activePrevPage,
	          activeNextPage = _state.activeNextPage;
	
	
	      var options = this.teamPlayersOptions;
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Team'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Students Biggest Takeaway'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Students were asked what their biggest takeaways were from this exercise and what they learned about themselves, working in teams, and business in general. Below are their answers.'
	          )
	        ),
	        _react2.default.createElement(_selectorWrapper2.default, {
	          label: 'View',
	          options: options,
	          selectedOptionId: selectedUserId
	        }),
	        !loaded && _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true }),
	        loaded && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _ui.ContentContainer,
	            { transparent: true, maxHeight: '578px' },
	            biggestTakeawayItemsToShow.map(function (item, index) {
	              return _react2.default.createElement(
	                _ui.UserAnswer.Item,
	                { key: index },
	                _react2.default.createElement(
	                  _ui.UserAnswer.Profile,
	                  null,
	                  _react2.default.createElement(
	                    _ui.UserAnswer.AvatarWrapper,
	                    null,
	                    _react2.default.createElement('img', { src: profilePictures[randomIntFromInterval(0, 3)], alt: 'Profile avatar', title: item.tooltip })
	                  ),
	                  _react2.default.createElement(
	                    _ui.UserAnswer.Username,
	                    { title: item.tooltip },
	                    item.displayName
	                  )
	                ),
	                _react2.default.createElement(
	                  _ui.UserAnswer.Text,
	                  null,
	                  item.answer
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_answersPagination2.default, {
	            rowsPerPage: rowsPerPage,
	            handleRowsPerPageChange: this.handleRowsPerPageChange,
	            rowsTotal: rowsTotal,
	            page: page,
	            handlePageChange: this.handlePageChange,
	            activePrevPage: activePrevPage,
	            activeNextPage: activeNextPage
	          })
	        )
	      );
	    }
	  }, {
	    key: 'teamPlayersOptions',
	    get: function get() {
	      return [{ id: 0, name: 'Overall' }];
	    }
	  }]);
	
	  return BiggestTakeaway;
	}(_react.Component);
	
	exports.default = BiggestTakeaway;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _answersProfilePic = __webpack_require__(1051);
	
	var _answersProfilePic2 = _interopRequireDefault(_answersProfilePic);
	
	var _answersProfilePic3 = __webpack_require__(1052);
	
	var _answersProfilePic4 = _interopRequireDefault(_answersProfilePic3);
	
	var _answersProfilePic5 = __webpack_require__(1053);
	
	var _answersProfilePic6 = _interopRequireDefault(_answersProfilePic5);
	
	var _answersProfilePic7 = __webpack_require__(1054);
	
	var _answersProfilePic8 = _interopRequireDefault(_answersProfilePic7);
	
	var _ui = __webpack_require__(85);
	
	var _selectorWrapper = __webpack_require__(262);
	
	var _selectorWrapper2 = _interopRequireDefault(_selectorWrapper);
	
	var _answersPagination = __webpack_require__(606);
	
	var _answersPagination2 = _interopRequireDefault(_answersPagination);
	
	var _constants = __webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var profilePictures = [_answersProfilePic2.default, _answersProfilePic4.default, _answersProfilePic6.default, _answersProfilePic8.default];
	
	var randomIntFromInterval = function randomIntFromInterval(min, max) {
	  return Math.floor(Math.random() * (max - min + 1) + min);
	};
	
	var DoDifferently = function (_Component) {
	  _inherits(DoDifferently, _Component);
	
	  function DoDifferently(props) {
	    _classCallCheck(this, DoDifferently);
	
	    var _this = _possibleConstructorReturn(this, (DoDifferently.__proto__ || Object.getPrototypeOf(DoDifferently)).call(this, props));
	
	    _this.handlePageChange = function (page) {
	      var _this$state = _this.state,
	          rowsPerPage = _this$state.rowsPerPage,
	          rowsTotal = _this$state.rowsTotal,
	          biggestTakeawayItems = _this$state.biggestTakeawayItems;
	
	
	      _this.setState({
	        page: page,
	        biggestTakeawayItemsToShow: biggestTakeawayItems.slice(rowsPerPage * (page - 1), rowsPerPage * page),
	        activePrevPage: rowsPerPage < rowsPerPage * page - 1,
	        activeNextPage: rowsPerPage * page < rowsTotal
	      });
	    };
	
	    _this.handleRowsPerPageChange = function (index) {
	      var _this$state2 = _this.state,
	          rowsTotal = _this$state2.rowsTotal,
	          biggestTakeawayItems = _this$state2.biggestTakeawayItems;
	
	
	      var rowsPerPage = _constants.answersRowsPerPage[index].name;
	
	      _this.setState({
	        page: 1,
	        rowsPerPage: _constants.answersRowsPerPage[index].name,
	        activeNextPage: rowsPerPage < rowsTotal,
	        biggestTakeawayItemsToShow: biggestTakeawayItems.slice(0, rowsPerPage),
	        selectedOptionId: index
	      });
	    };
	
	    _this.state = {
	      selectedUserId: 0,
	      loaded: false,
	      biggestTakeawayItems: [],
	      biggestTakeawayItemsToShow: [],
	      rowsPerPage: _constants.answersRowsPerPage[0].name,
	      rowsTotal: 0,
	      page: 1,
	      activePrevPage: null,
	      activeNextPage: null
	    };
	    return _this;
	  }
	
	  _createClass(DoDifferently, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var currentFinishedSurvey, rowsPerPage;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                currentFinishedSurvey = this.props.currentFinishedSurvey;
	                rowsPerPage = this.state.rowsPerPage;
	
	                (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'users', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/answers-list/?survey=' + currentFinishedSurvey.id]).then(function (res) {
	                  var users = res[0].body;
	                  var formsAnswersList = res[1].body.results;
	                  var biggestTakeawayAnswers = formsAnswersList.filter(function (formsAnswer) {
	                    return formsAnswer.question_text.toLowerCase().includes('chance to do it all over again');
	                  });
	
	                  var biggestTakeawayItems = [].concat(_toConsumableArray(new Set(biggestTakeawayAnswers.map(function (item) {
	                    var user = users.find(function (user) {
	                      return user.email === item.giver_email;
	                    });
	                    var firstName = user.first_name;
	                    var lastName = user.last_name;
	                    var showDotFirstName = firstName.length > 1 ? '.' : '';
	                    var showDotLastName = lastName.length > 1 ? '.' : '';
	                    return {
	                      displayName: '' + firstName.substring(0, 1) + showDotFirstName + ' ' + lastName.substring(0, 1) + showDotLastName,
	                      tooltip: user.first_name + ' ' + user.last_name,
	                      answer: item.answer_text
	                    };
	                  }))));
	
	                  var rowsTotal = biggestTakeawayItems.length;
	
	                  _this2.setState({
	                    loaded: true,
	                    biggestTakeawayItems: biggestTakeawayItems,
	                    biggestTakeawayItemsToShow: biggestTakeawayItems.slice(0, rowsPerPage),
	                    rowsTotal: rowsTotal,
	                    activeNextPage: rowsPerPage < rowsTotal
	                  });
	                }).catch(function (err) {});
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          selectedUserId = _state.selectedUserId,
	          loaded = _state.loaded,
	          biggestTakeawayItemsToShow = _state.biggestTakeawayItemsToShow,
	          rowsPerPage = _state.rowsPerPage,
	          rowsTotal = _state.rowsTotal,
	          page = _state.page,
	          activePrevPage = _state.activePrevPage,
	          activeNextPage = _state.activeNextPage;
	
	
	      var options = this.teamPlayersOptions;
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Team'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'What Would You Do Differently'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Students were asked if they had a chance to do it all over again, what would they do differently? Below are their answers. '
	          )
	        ),
	        _react2.default.createElement(_selectorWrapper2.default, {
	          label: 'View',
	          options: options,
	          selectedOptionId: selectedUserId
	        }),
	        !loaded && _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true }),
	        loaded && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _ui.ContentContainer,
	            { transparent: true, maxHeight: '578px' },
	            biggestTakeawayItemsToShow.map(function (item, index) {
	              return _react2.default.createElement(
	                _ui.UserAnswer.Item,
	                { key: index },
	                _react2.default.createElement(
	                  _ui.UserAnswer.Profile,
	                  null,
	                  _react2.default.createElement(
	                    _ui.UserAnswer.AvatarWrapper,
	                    null,
	                    _react2.default.createElement('img', { src: profilePictures[randomIntFromInterval(0, 3)], alt: 'Profile avatar', title: item.tooltip })
	                  ),
	                  _react2.default.createElement(
	                    _ui.UserAnswer.Username,
	                    { title: item.tooltip },
	                    item.displayName
	                  )
	                ),
	                _react2.default.createElement(
	                  _ui.UserAnswer.Text,
	                  null,
	                  item.answer
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_answersPagination2.default, {
	            rowsPerPage: rowsPerPage,
	            handleRowsPerPageChange: this.handleRowsPerPageChange,
	            rowsTotal: rowsTotal,
	            page: page,
	            handlePageChange: this.handlePageChange,
	            activePrevPage: activePrevPage,
	            activeNextPage: activeNextPage
	          })
	        )
	      );
	    }
	  }, {
	    key: 'teamPlayersOptions',
	    get: function get() {
	      return [{ id: 0, name: 'Overall' }];
	    }
	  }]);
	
	  return DoDifferently;
	}(_react.Component);
	
	exports.default = DoDifferently;

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _ui = __webpack_require__(85);
	
	var _ApiService = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RenderDot = function RenderDot(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy;
	
	  return _react2.default.createElement(_recharts.Dot, { cx: cx, cy: cy, fill: '#1F77B4', r: 2.8 });
	};
	
	var yAxisLabels = {
	  '16.666666': 'Not Well',
	  '49.999999': 'Somewhat Well',
	  '83.333332': 'Very Well'
	};
	
	var xAxisLabels = {
	  '12.5': 'Very Low',
	  '37.5': 'Low',
	  '62.5': 'High',
	  '87.5': 'Very High'
	};
	
	var TeamDynamicsPerformance = function (_PureComponent) {
	  _inherits(TeamDynamicsPerformance, _PureComponent);
	
	  function TeamDynamicsPerformance(props) {
	    _classCallCheck(this, TeamDynamicsPerformance);
	
	    var _this = _possibleConstructorReturn(this, (TeamDynamicsPerformance.__proto__ || Object.getPrototypeOf(TeamDynamicsPerformance)).call(this, props));
	
	    _this.customAxisTick = function (_ref2) {
	      var x = _ref2.x,
	          y = _ref2.y,
	          textAnchor = _ref2.textAnchor,
	          payload = _ref2.payload;
	
	      var regex = /(?![^\n]{1,8}$)([^\n]{1,8})\s/g;
	      var labelRows = yAxisLabels[payload.value].split(regex).filter(function (i) {
	        return i !== '';
	      });
	
	      var labelRowHeight = 28;
	      var labelsToDisplay = labelRows.map(function (str, index) {
	        var newRowShift = index * labelRowHeight;
	        return _react2.default.createElement(
	          'tspan',
	          { key: index, y: y + newRowShift, x: x },
	          str
	        );
	      });
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-layer recharts-cartesian-axis-tick' },
	        _react2.default.createElement(
	          'text',
	          {
	            x: x,
	            y: y,
	            textAnchor: textAnchor,
	            style: {
	              fontSize: '16px',
	              fontFamily: 'Mukta Vaani',
	              fontWeight: '700',
	              lineHeight: '28px',
	              fill: 'rgba(0, 27, 59, 0.94)'
	            }
	          },
	          labelsToDisplay
	        )
	      );
	    };
	
	    _this.state = {
	      chartData: []
	    };
	    return _this;
	  }
	
	  _createClass(TeamDynamicsPerformance, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          roundId = _props.roundId,
	          teams = _props.teams,
	          surveysStatsByTeam = _props.surveysStatsByTeam;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/teamgradings/?round=' + roundId).then(function (res) {
	        var teamGradings = res.body.results;
	
	        var chartData = surveysStatsByTeam.map(function (surveyStatsByTeam) {
	          var neededTeamGrading = teamGradings.find(function (teamGrading) {
	            return teamGrading.team === surveyStatsByTeam.team_id;
	          });
	          console.log('neededTeamGrading', neededTeamGrading);
	          var neededTeamGradingWeightedValue = neededTeamGrading ? neededTeamGrading.weighted_value : 0;
	          return {
	            x: Number(neededTeamGradingWeightedValue).toFixed(2) * 100,
	            y: surveyStatsByTeam.team_work_again_percentage,
	            name: teams.find(function (team) {
	              return team.id === surveyStatsByTeam.team_id;
	            }).name
	          };
	        });
	        console.log('chartData', chartData);
	
	        var defaultChartData = chartData;
	
	        _this2.setState({
	          chartData: defaultChartData
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chartData = this.state.chartData;
	
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Team'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Relationship | Team Dynamics & Performance'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Now let\u2019s look at how team cohesion might be having an impact on performance.  You would expect teams that work very well together perform better than teams that do not. However it\u2019s not always the case.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.ContentTitle,
	            { big: true },
	            'Relationship | Collaboration to Team Performance'
	          ),
	          _react2.default.createElement(
	            _ui.ChartAxisLabel,
	            { rotated: true },
	            'Collaboration'
	          ),
	          _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { height: 400, width: '100%', className: 'scatter-chart-container' },
	            _react2.default.createElement(
	              _recharts.ScatterChart,
	              {
	                margin: {
	                  top: 28,
	                  right: 40,
	                  bottom: 8,
	                  left: 70
	                }
	              },
	              _react2.default.createElement(_recharts.CartesianGrid, { stroke: 'rgba(0, 0, 0, 0.1)' }),
	              _react2.default.createElement(_recharts.XAxis, {
	                orientation: 'bottom',
	                xAxisId: 'first',
	                dataKey: 'x',
	                type: 'number',
	                name: 'Performance value',
	                tickLine: false,
	                tickCount: 5,
	                domain: [0, 100],
	                axisLine: false,
	                hide: true
	              }),
	              _react2.default.createElement(_recharts.XAxis, {
	                orientation: 'bottom',
	                xAxisId: 'second',
	                dataKey: 'x',
	                type: 'number',
	                tickLine: false,
	                ticks: [12.5, 37.5, 62.5, 87.5],
	                axisLine: false,
	                tickFormatter: function tickFormatter(value) {
	                  return xAxisLabels[value];
	                },
	                style: {
	                  fontSize: '16px',
	                  fontFamily: 'Mukta Vaani',
	                  fontWeight: '700',
	                  lineHeight: '28px',
	                  fill: 'rgba(0, 27, 59, 0.94)'
	                }
	              }),
	              _react2.default.createElement(_recharts.YAxis, {
	                orientation: 'left',
	                yAxisId: 'first',
	                dataKey: 'y',
	                type: 'number',
	                name: 'Collaboration value',
	                tickLine: false,
	                ticks: [0, 33.333333, 66.666666, 100],
	                domain: [0, 100],
	                axisLine: false,
	                hide: true
	              }),
	              _react2.default.createElement(_recharts.YAxis, {
	                orientation: 'left',
	                yAxisId: 'second',
	                tickLine: false,
	                axisLine: false,
	                ticks: [16.666666, 49.999999, 83.333332],
	                tick: this.customAxisTick
	              }),
	              _react2.default.createElement(_recharts.ZAxis, { dataKey: 'name', name: 'Team name' }),
	              _react2.default.createElement(_recharts.Tooltip, {
	                cursor: false,
	                itemSorter: function itemSorter(item) {
	                  switch (item.dataKey) {
	                    case "name":
	                      return 0;
	                    case "y":
	                      return 1;
	                    case "x":
	                      return 2;
	                    default:
	                      return 3;
	                  }
	                },
	                formatter: function formatter(value, name) {
	                  return name !== 'Team name' ? value + '%' : value;
	                }
	              }),
	              _react2.default.createElement(_recharts.Scatter, {
	                data: chartData,
	                shape: _react2.default.createElement(RenderDot, null),
	                xAxisId: 'first',
	                yAxisId: 'first'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _ui.ChartAxisLabel,
	            null,
	            'Performance'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamDynamicsPerformance;
	}(_react.PureComponent);
	
	exports.default = TeamDynamicsPerformance;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(27);
	
	var _ui = __webpack_require__(85);
	
	var _dataDetails = __webpack_require__(309);
	
	var _dataDetails2 = _interopRequireDefault(_dataDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var chartColors = ['#81c991', '#ccedd1', '#fd9595'];
	
	var TeamDynamics = function (_PureComponent) {
	  _inherits(TeamDynamics, _PureComponent);
	
	  function TeamDynamics(props) {
	    _classCallCheck(this, TeamDynamics);
	
	    var _this = _possibleConstructorReturn(this, (TeamDynamics.__proto__ || Object.getPrototypeOf(TeamDynamics)).call(this, props));
	
	    _this.changeExtraDetails = function (title, color, data) {
	      _this.setState({
	        extraDetailsTitle: title,
	        extraDetailsColor: color,
	        extraDetailsData: data
	      });
	    };
	
	    _this.state = {
	      teamsWorkedVeryWellTogether: [],
	      teamsWorkedWellTogether: [],
	      teamsDidNotWorkWellTogether: [],
	      extraDetailsTitle: 'Worked very well together',
	      extraDetailsColor: chartColors[0],
	      extraDetailsData: []
	    };
	    return _this;
	  }
	
	  _createClass(TeamDynamics, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          teams = _props.teams,
	          surveysTeamScore = _props.surveysTeamScore;
	
	
	      var teamsWorkedVeryWellTogetherIDs = surveysTeamScore.collaboration ? surveysTeamScore.collaboration.team_worked_well_together : [];
	      var teamsWorkedVeryWellTogether = teamsWorkedVeryWellTogetherIDs ? teams.filter(function (team) {
	        return teamsWorkedVeryWellTogetherIDs.includes(team.id);
	      }).map(function (team) {
	        return 'Team ' + team.name;
	      }) : [];
	
	      var teamsWorkedWellTogetherIDs = surveysTeamScore.collaboration ? surveysTeamScore.collaboration.team_worked_together : [];
	      var teamsWorkedWellTogether = teamsWorkedWellTogetherIDs ? teams.filter(function (team) {
	        return teamsWorkedWellTogetherIDs.includes(team.id);
	      }).map(function (team) {
	        return 'Team ' + team.name;
	      }) : [];
	
	      var teamsDidNotWorkWellTogetherIDs = surveysTeamScore.collaboration ? surveysTeamScore.collaboration.team_did_not_worked_together : [];
	      var teamsDidNotWorkWellTogether = teamsDidNotWorkWellTogetherIDs ? teams.filter(function (team) {
	        return teamsDidNotWorkWellTogetherIDs.includes(team.id);
	      }).map(function (team) {
	        return 'Team ' + team.name;
	      }) : [];
	
	      var extraDetailsTitle = teamsWorkedVeryWellTogether.length ? 'Worked very well together' : teamsWorkedWellTogether.length ? 'Worked well together' : teamsDidNotWorkWellTogether.length ? 'Did not work well together' : '';
	      var extraDetailsColor = teamsWorkedVeryWellTogether.length ? chartColors[0] : teamsWorkedWellTogether.length ? chartColors[1] : teamsDidNotWorkWellTogether.length ? chartColors[2] : '';
	      var extraDetailsData = teamsWorkedVeryWellTogether.length ? teamsWorkedVeryWellTogether : teamsWorkedWellTogether.length ? teamsWorkedWellTogether : teamsDidNotWorkWellTogether.length ? teamsDidNotWorkWellTogether : [];
	
	      this.setState({
	        teamsWorkedVeryWellTogether: teamsWorkedVeryWellTogether,
	        teamsWorkedWellTogether: teamsWorkedWellTogether,
	        teamsDidNotWorkWellTogether: teamsDidNotWorkWellTogether,
	        extraDetailsTitle: extraDetailsTitle,
	        extraDetailsColor: extraDetailsColor,
	        extraDetailsData: extraDetailsData
	      });
	    }
	  }, {
	    key: 'workedPercentage',
	    value: function workedPercentage(value, total) {
	      return total ? value / total * 100 : 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          surveysTeamScore = _props2.surveysTeamScore,
	          teams = _props2.teams,
	          currentFinishedSurvey = _props2.currentFinishedSurvey;
	      var _state = this.state,
	          teamsWorkedVeryWellTogether = _state.teamsWorkedVeryWellTogether,
	          teamsWorkedWellTogether = _state.teamsWorkedWellTogether,
	          teamsDidNotWorkWellTogether = _state.teamsDidNotWorkWellTogether,
	          extraDetailsTitle = _state.extraDetailsTitle,
	          extraDetailsColor = _state.extraDetailsColor,
	          extraDetailsData = _state.extraDetailsData;
	
	
	      var teamsWorkedVeryWellTogetherCount = teamsWorkedVeryWellTogether.length;
	      var teamsWorkedWellTogetherCount = teamsWorkedWellTogether.length;
	      var teamsDidNotWorkWellTogetherCount = teamsDidNotWorkWellTogether.length;
	      var totalTeams = surveysTeamScore.collaboration ? surveysTeamScore.collaboration.total_teams : 0;
	
	      var verbForm = teamsDidNotWorkWellTogetherCount > 1 ? 'are' : 'is';
	
	      var chartData = [{
	        value: teamsWorkedVeryWellTogetherCount,
	        color: chartColors[0],
	        title: 'Worked very well together',
	        data: teamsWorkedVeryWellTogether
	      }, {
	        value: teamsWorkedWellTogetherCount,
	        color: chartColors[1],
	        title: 'Worked well together',
	        data: teamsWorkedWellTogether
	      }, {
	        value: teamsDidNotWorkWellTogetherCount,
	        color: chartColors[12],
	        title: 'Did not work well together',
	        data: teamsDidNotWorkWellTogether
	      }];
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Team'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Team Dynamics'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              teamsWorkedVeryWellTogetherCount
	            ),
	            ' out of ',
	            _react2.default.createElement(
	              'b',
	              null,
	              teams.length
	            ),
	            ' teams are working very well together.'
	          ),
	          _react2.default.createElement('br', null),
	          teamsDidNotWorkWellTogetherCount > 0 && _react2.default.createElement(
	            'p',
	            null,
	            'However, there ',
	            verbForm,
	            ' ',
	            _react2.default.createElement(
	              'b',
	              null,
	              teamsDidNotWorkWellTogetherCount
	            ),
	            ' team',
	            teamsDidNotWorkWellTogetherCount > 1 && 's',
	            ' that ',
	            verbForm,
	            ' having serious challenges (i.e teammates are not getting along).  Intervening early on often resolves these team dynamics issues.'
	          )
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          null,
	          _react2.default.createElement(
	            _ui.ContentTitle,
	            null,
	            currentFinishedSurvey.name
	          ),
	          _react2.default.createElement(
	            _ui.ContentFlexColumns,
	            { withFloatinDetailsBlock: !!teamsDidNotWorkWellTogetherCount, withPadding: true },
	            _react2.default.createElement(
	              _recharts.PieChart,
	              {
	                width: 160,
	                height: 160,
	                margin: { top: 0, left: 0, bottom: 0, right: 0 }
	              },
	              _react2.default.createElement(_recharts.Tooltip, { formatter: function formatter(value) {
	                  return Number(value).toFixed(2) + '%';
	                }, separator: ': ' }),
	              _react2.default.createElement(
	                _recharts.Pie,
	                {
	                  data: [{
	                    name: "Worked very well together",
	                    value: this.workedPercentage(teamsWorkedVeryWellTogetherCount, totalTeams)
	                  }, {
	                    name: "Worked well together",
	                    value: this.workedPercentage(teamsWorkedWellTogetherCount, totalTeams)
	                  }, {
	                    name: "Did not work well together",
	                    value: this.workedPercentage(teamsDidNotWorkWellTogetherCount, totalTeams)
	                  }],
	                  cx: 80,
	                  cy: 80,
	                  innerRadius: '0%',
	                  outerRadius: '100%',
	                  fill: '#8884d8',
	                  paddingAngle: 1,
	                  dataKey: 'value',
	                  startAngle: 270,
	                  endAngle: 630,
	                  labelLine: false
	                },
	                _react2.default.createElement(_recharts.Cell, { fill: chartColors[0] }),
	                _react2.default.createElement(_recharts.Cell, { fill: chartColors[1] }),
	                _react2.default.createElement(_recharts.Cell, { fill: chartColors[2] })
	              )
	            ),
	            _react2.default.createElement(
	              _ui.ContentRightColumn,
	              null,
	              chartData.map(function (item, index) {
	                return _react2.default.createElement(
	                  _ui.ChartDataLabel,
	                  {
	                    key: index,
	                    color: item.color,
	                    onClick: function onClick() {
	                      return _this2.changeExtraDetails(item.title, item.color, item.data);
	                    },
	                    disabled: !(item.data.length > 0)
	                  },
	                  item.title + ' (' + item.value + ')'
	                );
	              })
	            )
	          ),
	          extraDetailsData.length > 0 && _react2.default.createElement(_dataDetails2.default, {
	            title: extraDetailsTitle,
	            color: extraDetailsColor,
	            data: extraDetailsData
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamDynamics;
	}(_react.PureComponent);
	
	exports.default = TeamDynamics;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(85);
	
	var _peerFeedbackGoodLuck = __webpack_require__(565);
	
	var _peerFeedbackGoodLuck2 = _interopRequireDefault(_peerFeedbackGoodLuck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TheTeam = function (_PureComponent) {
	  _inherits(TheTeam, _PureComponent);
	
	  function TheTeam() {
	    _classCallCheck(this, TheTeam);
	
	    return _possibleConstructorReturn(this, (TheTeam.__proto__ || Object.getPrototypeOf(TheTeam)).apply(this, arguments));
	  }
	
	  _createClass(TheTeam, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Team'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'The Team'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Exploring the team level'
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          { transparent: true },
	          _react2.default.createElement(_ui.Image, { src: _peerFeedbackGoodLuck2.default, alt: 'Engagement Score' })
	        )
	      );
	    }
	  }]);
	
	  return TheTeam;
	}(_react.PureComponent);
	
	exports.default = TheTeam;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(85);
	
	var _peerFeedbackStrengthAreasOfDevelopment = __webpack_require__(566);
	
	var _peerFeedbackStrengthAreasOfDevelopment2 = _interopRequireDefault(_peerFeedbackStrengthAreasOfDevelopment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StrengthsAndAreasOfDevelopment = function (_PureComponent) {
	  _inherits(StrengthsAndAreasOfDevelopment, _PureComponent);
	
	  function StrengthsAndAreasOfDevelopment() {
	    _classCallCheck(this, StrengthsAndAreasOfDevelopment);
	
	    return _possibleConstructorReturn(this, (StrengthsAndAreasOfDevelopment.__proto__ || Object.getPrototypeOf(StrengthsAndAreasOfDevelopment)).apply(this, arguments));
	  }
	
	  _createClass(StrengthsAndAreasOfDevelopment, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Skills Assessment'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Strengths and Areas of Development'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'Exploring skills/behaviors that your students might be demonstrating in this team exercise'
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          { transparent: true },
	          _react2.default.createElement('img', { src: _peerFeedbackStrengthAreasOfDevelopment2.default, alt: 'Strengths and Areas of Development' })
	        )
	      );
	    }
	  }]);
	
	  return StrengthsAndAreasOfDevelopment;
	}(_react.PureComponent);
	
	exports.default = StrengthsAndAreasOfDevelopment;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _skillsChart = __webpack_require__(590);
	
	var _skillsChart2 = _interopRequireDefault(_skillsChart);
	
	var _ui = __webpack_require__(85);
	
	var _selectorWrapper = __webpack_require__(262);
	
	var _selectorWrapper2 = _interopRequireDefault(_selectorWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamworkSkills = function (_PureComponent) {
	  _inherits(TeamworkSkills, _PureComponent);
	
	  function TeamworkSkills(props) {
	    _classCallCheck(this, TeamworkSkills);
	
	    var _this = _possibleConstructorReturn(this, (TeamworkSkills.__proto__ || Object.getPrototypeOf(TeamworkSkills)).call(this, props));
	
	    _this.generateChartData = function (requestUrls, setDefaultChartData) {
	      var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var finishedSurveys = _this.props.finishedSurveys;
	
	
	      (0, _ApiService.batchRequest)(requestUrls).then(function (res) {
	        var chartData = [];
	        var showData = {
	          second: false,
	          final: false
	        };
	
	        res.forEach(function (scoreValueResponse, index) {
	          var currentSurvey = finishedSurveys[index];
	          var scoreValueResult = scoreValueResponse.body;
	          if (currentSurvey.stage === 'initial') {
	            if (scoreValueResult) {
	              Object.keys(scoreValueResult).forEach(function (userScoreQuestion) {
	                if (userScoreQuestion !== 'Not Applicable') {
	                  chartData.push({
	                    question: userScoreQuestion,
	                    initial: scoreValueResult[userScoreQuestion] * multiplier
	                  });
	                }
	              });
	            }
	          } else if (scoreValueResult) {
	            Object.keys(scoreValueResult).forEach(function (userScoreQuestion) {
	              var currentQuestion = chartData.find(function (chartItem) {
	                return chartItem.question === userScoreQuestion;
	              });
	              if (currentQuestion) {
	                chartData.find(function (chartItem) {
	                  return chartItem.question === userScoreQuestion;
	                })[currentSurvey.stage] = scoreValueResult[userScoreQuestion] * multiplier;
	              } else {
	                if (userScoreQuestion !== 'Not Applicable') {
	                  chartData.push(_defineProperty({
	                    question: userScoreQuestion
	                  }, currentSurvey.stage, scoreValueResult[userScoreQuestion] * multiplier));
	                }
	              }
	
	              showData[currentSurvey.stage] = true;
	            });
	          }
	        });
	
	        _this.setState({
	          loaded: true,
	          chartData: chartData,
	          showData: showData
	        });
	        if (setDefaultChartData) {
	          _this.setState({
	            defaultChartData: chartData
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    _this.handleSelectChange = function (value) {
	      var finishedSurveys = _this.props.finishedSurveys;
	      var defaultChartData = _this.state.defaultChartData;
	
	
	      if (value === 0) {
	        _this.setState({
	          selectedUserId: value,
	          chartData: defaultChartData,
	          loaded: true
	        });
	      } else {
	        _this.setState({
	          loaded: false,
	          selectedUserId: value
	        });
	
	        var requestUrls = finishedSurveys.map(function (finishedSurvey) {
	          return ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/skills-assessment/' + finishedSurvey.id + '/student/' + value + '/';
	        });
	        _this.generateChartData(requestUrls, false, 5);
	      }
	    };
	
	    _this.state = {
	      selectedUserId: 0,
	      chartData: [],
	      defaultChartData: [],
	      loaded: false
	    };
	    return _this;
	  }
	
	  _createClass(TeamworkSkills, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var finishedSurveys = this.props.finishedSurveys;
	
	      var requestUrls = finishedSurveys.map(function (finishedSurvey) {
	        return ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/skills-assessment/' + finishedSurvey.id + '/instructor';
	      });
	      this.generateChartData(requestUrls, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          selectedUserId = _state.selectedUserId,
	          loaded = _state.loaded,
	          chartData = _state.chartData,
	          showData = _state.showData;
	
	
	      var options = this.teamPlayersOptions;
	
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'Skills Assessment'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'Teamwork Skills'
	        ),
	        _react2.default.createElement(
	          _ui.Text,
	          null,
	          'The Skills Map below is a visual indicator of the behaviors/skills that your students are demonstrating. The wider the filled area, the greater the number of teammates that are in agreement.'
	        ),
	        _react2.default.createElement(_selectorWrapper2.default, {
	          label: 'View',
	          options: options,
	          onSelectorChange: this.handleSelectChange,
	          selectedOptionId: selectedUserId
	        }),
	        !loaded && _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true }),
	        loaded && _react2.default.createElement(_skillsChart2.default, {
	          title: 'Skills Map',
	          data: chartData,
	          showData: showData
	        })
	      );
	    }
	  }, {
	    key: 'teamPlayersOptions',
	    get: function get() {
	      var gamesTeamplayers = this.props.gamesTeamplayers;
	
	      var options = gamesTeamplayers.map(function (gamesTeamplayer) {
	        return {
	          id: gamesTeamplayer.user.id,
	          name: gamesTeamplayer.user.first_name + ' ' + gamesTeamplayer.user.last_name
	        };
	      });
	      var sortedOptions = [].concat(_toConsumableArray(options)).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	
	      sortedOptions.unshift({ id: 0, name: 'Overall' });
	      return sortedOptions;
	    }
	  }]);
	
	  return TeamworkSkills;
	}(_react.PureComponent);
	
	exports.default = TeamworkSkills;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ui = __webpack_require__(85);
	
	var _peerFeedbackGoodLuck = __webpack_require__(565);
	
	var _peerFeedbackGoodLuck2 = _interopRequireDefault(_peerFeedbackGoodLuck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThatsAll = function (_PureComponent) {
	  _inherits(ThatsAll, _PureComponent);
	
	  function ThatsAll() {
	    _classCallCheck(this, ThatsAll);
	
	    return _possibleConstructorReturn(this, (ThatsAll.__proto__ || Object.getPrototypeOf(ThatsAll)).apply(this, arguments));
	  }
	
	  _createClass(ThatsAll, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          _ui.PreTitle,
	          null,
	          'That\u2019s All For Now!'
	        ),
	        _react2.default.createElement(
	          _ui.Title,
	          null,
	          'That\u2019s All For Now!'
	        ),
	        _react2.default.createElement(
	          _ui.ContentContainer,
	          { transparent: true },
	          _react2.default.createElement('img', { src: _peerFeedbackGoodLuck2.default, alt: 'Strengths and Areas of Development' })
	        )
	      );
	    }
	  }]);
	
	  return ThatsAll;
	}(_react.PureComponent);
	
	exports.default = ThatsAll;

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px 31px 40px 38px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n'], ['\n  flex: 0 0 268px;\n  background: #ffffff;\n  padding: 40px 31px 40px 38px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-right: 1px solid #d5d9dd;\n  align-self: stretch;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  img {\n    margin-right: 10px;\n  }\n\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n'], ['\n  border-left: 1px solid #2da548;\n  margin-top: 13px;\n  margin-bottom: 13px;\n  padding-left: 16px;\n  margin-left: 31px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n\n  a:active, a:visited, a:link {\n    color: rgba(0, 27, 59, 0.38);\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _onboardingCheck = __webpack_require__(301);
	
	var _onboardingCheck2 = _interopRequireDefault(_onboardingCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Step = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var SubSection = _styledComponents2.default.div(_templateObject3);
	
	var SubSectionItem = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.isActive && '\n    color: rgba(0, 27, 59, 0.94);\n\n    a:active, a:visited, a:link {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  ';
	});
	
	var Navigation = function Navigation(_ref) {
	  var data = _ref.data,
	      category = _ref.category,
	      activeRound = _ref.activeRound;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    data.map(function (link, index) {
	      if (!!link.parent) {
	        return null;
	      }
	
	      var subLinks = data.filter(function (i) {
	        return i.parent === link.title;
	      });
	      var linkUrl = link.steps.length > 0 ? link.steps[0].url : subLinks.length > 0 ? subLinks[0].steps[0].url : null;
	      if (!linkUrl) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        { key: 'section-' + index },
	        _react2.default.createElement(
	          Step,
	          { isActive: true },
	          _react2.default.createElement('img', { src: _onboardingCheck2.default, alt: 'nav icon' }),
	          index !== category && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: linkUrl + '?round=' + activeRound },
	            link.title
	          ),
	          index === category && link.title
	        ),
	        _react2.default.createElement(
	          SubSection,
	          null,
	          subLinks.map(function (subLink) {
	            var subLinkIndex = data.findIndex(function (i) {
	              return i.title === subLink.title;
	            });
	
	            return subLink.steps[0] ? _react2.default.createElement(
	              SubSectionItem,
	              { key: 'subsection-' + index + '-' + subLinkIndex, isActive: true },
	              subLinkIndex !== category && _react2.default.createElement(
	                _reactRouter.Link,
	                { to: subLink.steps[0].url + '?round=' + activeRound },
	                subLink.title
	              ),
	              subLinkIndex === category && subLink.title
	            ) : null;
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = Navigation;

/***/ },
/* 1472 */
1446,
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TeamSelectorLabel = exports.SelectorWrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 12px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  margin-right: 8px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  margin-right: 8px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _teamSelector = __webpack_require__(1474);
	
	var _teamSelector2 = _interopRequireDefault(_teamSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SelectorWrapper = exports.SelectorWrapper = _styledComponents2.default.div(_templateObject);
	
	var TeamSelectorLabel = exports.TeamSelectorLabel = _styledComponents2.default.span(_templateObject2);
	
	var TeamSelectorWrapper = function (_PureComponent) {
	  _inherits(TeamSelectorWrapper, _PureComponent);
	
	  function TeamSelectorWrapper() {
	    _classCallCheck(this, TeamSelectorWrapper);
	
	    return _possibleConstructorReturn(this, (TeamSelectorWrapper.__proto__ || Object.getPrototypeOf(TeamSelectorWrapper)).apply(this, arguments));
	  }
	
	  _createClass(TeamSelectorWrapper, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          selectorOptions = _props.selectorOptions,
	          onSelectorChange = _props.onSelectorChange,
	          selectorSelectedOptionId = _props.selectorSelectedOptionId;
	
	
	      return _react2.default.createElement(
	        SelectorWrapper,
	        null,
	        _react2.default.createElement(
	          TeamSelectorLabel,
	          null,
	          label
	        ),
	        _react2.default.createElement(_teamSelector2.default, { options: selectorOptions, onSelectorChange: onSelectorChange, selectedOptionId: selectorSelectedOptionId })
	      );
	    }
	  }]);
	
	  return TeamSelectorWrapper;
	}(_react.PureComponent);
	
	exports.default = TeamSelectorWrapper;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"], ["\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  border: 2px solid #5C91F5;\n  border-radius: 4px;\n  width: 180px;\n  padding: 6px 40px 6px 16px;\n  color: #5C91F5;\n  cursor: pointer;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 16px;\n"], ["\n  border: 2px solid #5C91F5;\n  border-radius: 4px;\n  width: 180px;\n  padding: 6px 40px 6px 16px;\n  color: #5C91F5;\n  cursor: pointer;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 16px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  background-color: #5C91F5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n"], ["\n  width: 32px;\n  height: 32px;\n  background-color: #5C91F5;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  z-index: 1;\n  position: absolute;\n  display: none;\n  left: 0;\n  right: 0;\n  width: 100%;\n\n  ", "\n"], ["\n  z-index: 1;\n  position: absolute;\n  display: none;\n  left: 0;\n  right: 0;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 3px solid #ffffff;\n  border-radius: 5px;\n  list-style: none;\n  font-weight: 800;\n  color: #ffffff;\n  background-color: #2a4169;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #5C91F5; \n  }\n\n  li {\n    cursor: pointer;\n    padding: 6px 16px;\n  }\n\n  li:hover {\n    color: #2a4169;\n    background: #fff;\n  }\n"], ["\n  width: 100%;\n  border: 3px solid #ffffff;\n  border-radius: 5px;\n  list-style: none;\n  font-weight: 800;\n  color: #ffffff;\n  background-color: #2a4169;\n  padding: 0;\n  max-height: 300px;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n   \n  &::-webkit-scrollbar-thumb {\n    background: #5C91F5; \n  }\n\n  li {\n    cursor: pointer;\n    padding: 6px 16px;\n  }\n\n  li:hover {\n    color: #2a4169;\n    background: #fff;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _iconDropdownArrowFilled = __webpack_require__(687);
	
	var _iconDropdownArrowFilled2 = _interopRequireDefault(_iconDropdownArrowFilled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TeamSelectorContainer = _styledComponents2.default.div(_templateObject);
	
	var SelectedOptionWrapper = _styledComponents2.default.div(_templateObject2);
	
	var TeamSelectorArrow = _styledComponents2.default.div(_templateObject3);
	
	var TeamSelectorItemsWrapper = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.isShown && "\n    display: block;\n  ";
	});
	
	var TeamSelectorItems = _styledComponents2.default.ul(_templateObject5);
	
	var TeamSelector = function (_PureComponent) {
	  _inherits(TeamSelector, _PureComponent);
	
	  function TeamSelector(props) {
	    _classCallCheck(this, TeamSelector);
	
	    var _this = _possibleConstructorReturn(this, (TeamSelector.__proto__ || Object.getPrototypeOf(TeamSelector)).call(this, props));
	
	    _this.handleClickOutside = function (e) {
	      var clicked1 = false;
	      if (_this.currentRef && _this.currentRef.contains(e.target)) {
	        clicked1 = true;
	      }
	
	      var clicked2 = false;
	      if (_this.currentRef2 && _this.currentRef2.contains(e.target)) {
	        clicked2 = true;
	      }
	
	      if (!clicked1 && !clicked2) {
	        _this.setState({
	          menuShown: false
	        });
	      }
	    };
	
	    _this.toggleMenu = function () {
	      _this.setState({
	        menuShown: !_this.state.menuShown
	      });
	    };
	
	    _this.currentRef = null;
	    _this.currentRef2 = null;
	
	    _this.state = {
	      menuShown: false
	    };
	    return _this;
	  }
	
	  _createClass(TeamSelector, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (window) {
	        document.addEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (window) {
	        document.removeEventListener("mousedown", this.handleClickOutside);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var menuShown = this.state.menuShown;
	      var _props = this.props,
	          options = _props.options,
	          onSelectorChange = _props.onSelectorChange,
	          selectedOptionId = _props.selectedOptionId;
	
	
	      var sortedOptions = [].concat(_toConsumableArray(options)).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	
	      return _react2.default.createElement(
	        TeamSelectorContainer,
	        null,
	        _react2.default.createElement(
	          SelectedOptionWrapper,
	          {
	            innerRef: function innerRef(node) {
	              return _this2.currentRef = node;
	            },
	            onClick: this.toggleMenu
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            selectedOptionId ? options.find(function (i) {
	              return i.id === selectedOptionId;
	            }).name : options[0].name
	          ),
	          _react2.default.createElement(
	            TeamSelectorArrow,
	            null,
	            _react2.default.createElement("img", { src: _iconDropdownArrowFilled2.default, alt: "arrow" })
	          )
	        ),
	        _react2.default.createElement(
	          TeamSelectorItemsWrapper,
	          {
	            innerRef: function innerRef(node) {
	              return _this2.currentRef2 = node;
	            },
	            isShown: menuShown
	          },
	          _react2.default.createElement(
	            TeamSelectorItems,
	            null,
	            sortedOptions.map(function (option, index) {
	              return _react2.default.createElement(
	                "li",
	                {
	                  onClick: function onClick() {
	                    onSelectorChange(option.id);
	                    _this2.toggleMenu();
	                  },
	                  value: option.id,
	                  key: index
	                },
	                option.name
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamSelector;
	}(_react.PureComponent);
	
	exports.default = TeamSelector;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 15px 20px 10px;\n  font-family: \'Mukta Vaani\';\n  position: relative;\n\n  > h3 {\n    color: #EA4335;\n    font-size: 16px;\n    line-height: 16px;\n    font-size: 18px;\n    line-height: 20px;\n    text-align: center;\n    margin-bottom: 30px;\n    font-weight: 700;\n  }\n'], ['\n  padding: 15px 20px 10px;\n  font-family: \'Mukta Vaani\';\n  position: relative;\n\n  > h3 {\n    color: #EA4335;\n    font-size: 16px;\n    line-height: 16px;\n    font-size: 18px;\n    line-height: 20px;\n    text-align: center;\n    margin-bottom: 30px;\n    font-weight: 700;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  line-height: 15px;\n  color: #3A507B;\n  font-weight: 600;\n  text-align: center;\n  margin-top: 15px;\n\n  ', '\n'], ['\n  font-size: 12px;\n  line-height: 15px;\n  color: #3A507B;\n  font-weight: 600;\n  text-align: center;\n  margin-top: 15px;\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _horizontalBar = __webpack_require__(1438);
	
	var _horizontalBar2 = _interopRequireDefault(_horizontalBar);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var getPercentage = function getPercentage(value) {
	  return value > 0 ? (value * 100).toFixed(0) + '%' : "0%";
	};
	
	var colors = ['#3A507B', '#445982', '#4E6288', '#586B8F', '#617395', '#6B7C9C', '#7585A3', '#9DA8BD'];
	
	var ChartContainer = _styledComponents2.default.div(_templateObject);
	
	var ChartLabel = _styledComponents2.default.p(_templateObject2, function (p) {
	  return p.rotated && '\n    transform: rotate(-90deg) translateX(30%);\n    position: absolute;\n    top: 50%;\n    margin-top: 0;\n  ';
	});
	
	var ResultsAreInStep1 = function (_PureComponent) {
	  _inherits(ResultsAreInStep1, _PureComponent);
	
	  function ResultsAreInStep1() {
	    _classCallCheck(this, ResultsAreInStep1);
	
	    return _possibleConstructorReturn(this, (ResultsAreInStep1.__proto__ || Object.getPrototypeOf(ResultsAreInStep1)).apply(this, arguments));
	  }
	
	  _createClass(ResultsAreInStep1, [{
	    key: 'buildChartData',
	
	    // Both the "X of N" text and the per-bucket bar values come from
	    // the consolidated /teamgradings/overall/<round_id> response that
	    // the container already fetched — no second API call from here.
	
	    value: function buildChartData(teams) {
	      var inRange = function inRange(v, lo, hi) {
	        return v >= lo && v < hi;
	      };
	      var buckets = [['100%', function (t) {
	        return Number(t.current_weighted_value) === 1;
	      }], ['95%', function (t) {
	        return inRange(Number(t.current_weighted_value), 0.95, 1);
	      }], ['90%', function (t) {
	        return inRange(Number(t.current_weighted_value), 0.90, 0.95);
	      }], ['85%', function (t) {
	        return inRange(Number(t.current_weighted_value), 0.85, 0.90);
	      }], ['80%', function (t) {
	        return inRange(Number(t.current_weighted_value), 0.80, 0.85);
	      }], ['75%', function (t) {
	        return inRange(Number(t.current_weighted_value), 0.75, 0.80);
	      }], ['70%', function (t) {
	        return inRange(Number(t.current_weighted_value), 0.70, 0.75);
	      }], ['less than 70%', function (t) {
	        return Number(t.current_weighted_value) < 0.70;
	      }]];
	      return buckets.map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            name = _ref2[0],
	            fn = _ref2[1];
	
	        return {
	          name: name,
	          value: teams.filter(fn).length
	        };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          _props$teamGradings = _props.teamGradings,
	          teamGradings = _props$teamGradings === undefined ? [] : _props$teamGradings,
	          teamGradingsLength = _props.teamGradingsLength,
	          overallStats = _props.overallStats,
	          successfulTeamsCount = _props.successfulTeamsCount;
	
	
	      var stats = overallStats && overallStats.current_weighted_value || {};
	      var averageTeamGrade = Number(stats.mean) || 0;
	      var medianTeamGrade = Number(stats.median) || 0;
	      var standardTeamGrade = Number(stats.standard_deviation) || 0;
	
	      var chartData = this.buildChartData(teamGradings);
	
	      return _react2.default.createElement(_oneVisual2.default, {
	        title: 'RESULTS ARE IN! | ROUND ' + activeRound + ' SCORE',
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            successfulTeamsCount || 0
	          ),
	          ' out of ',
	          _react2.default.createElement(
	            'b',
	            null,
	            teamGradingsLength
	          ),
	          ' teams hit their financial targets for the round. The average team score was ',
	          getPercentage(averageTeamGrade),
	          ', the median was ',
	          getPercentage(medianTeamGrade),
	          ', and the standard deviation was ',
	          getPercentage(standardTeamGrade),
	          '.'
	        ),
	        visual: _react2.default.createElement(
	          ChartContainer,
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Team Score Distribution'
	          ),
	          _react2.default.createElement(
	            ChartLabel,
	            { rotated: true },
	            'no. of teams'
	          ),
	          _react2.default.createElement(_horizontalBar2.default, {
	            data: chartData,
	            colors: colors,
	            height: 290,
	            xAxisLine: false,
	            hideYAxis: false,
	            hideXAxis: true,
	            xAxisTick: true,
	            barSize: 50,
	            showBarLabel: true,
	            showIntegerLabel: true
	          }),
	          _react2.default.createElement(
	            ChartLabel,
	            null,
	            'Team Score'
	          )
	        ),
	        visualProps: {}
	      });
	    }
	  }]);
	
	  return ResultsAreInStep1;
	}(_react.PureComponent);
	
	exports.default = ResultsAreInStep1;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _FinancialTargets = __webpack_require__(1287);
	
	var _FinancialTargets2 = _interopRequireDefault(_FinancialTargets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsAreInStep2 = function (_PureComponent) {
	  _inherits(ResultsAreInStep2, _PureComponent);
	
	  function ResultsAreInStep2() {
	    _classCallCheck(this, ResultsAreInStep2);
	
	    return _possibleConstructorReturn(this, (ResultsAreInStep2.__proto__ || Object.getPrototypeOf(ResultsAreInStep2)).apply(this, arguments));
	  }
	
	  _createClass(ResultsAreInStep2, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          gamesTargets = _props.gamesTargets;
	
	
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'RESULTS ARE IN!',
	        title: 'Financial Goals',
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          'These were the financial metrics and targets that drove team scores for Round ',
	          _react2.default.createElement(
	            'b',
	            null,
	            activeRound
	          )
	        ),
	        visual: _react2.default.createElement(_FinancialTargets2.default, {
	          round: activeRound,
	          financialTargets: gamesTargets,
	          showTableOnly: true
	        })
	      });
	    }
	  }]);
	
	  return ResultsAreInStep2;
	}(_react.PureComponent);
	
	exports.default = ResultsAreInStep2;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _instructorSuccessfulTeams = __webpack_require__(2590);
	
	var _instructorSuccessfulTeams2 = _interopRequireDefault(_instructorSuccessfulTeams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessfulStep1 = function (_PureComponent) {
	  _inherits(SuccessfulStep1, _PureComponent);
	
	  function SuccessfulStep1() {
	    _classCallCheck(this, SuccessfulStep1);
	
	    return _possibleConstructorReturn(this, (SuccessfulStep1.__proto__ || Object.getPrototypeOf(SuccessfulStep1)).apply(this, arguments));
	  }
	
	  _createClass(SuccessfulStep1, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'Successful Teams',
	        title: 'Reason Why Teams Hit Their Targets',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Teams that were successful in Round 1 did 2 things very well - they built demand and had supply.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'On the demand side, they leveraged data from the ',
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Customer Analysis page'
	            ),
	            ' to develop a Marketing Mix that were aligned with customers\u2019 preferences. On the supply side,  they acquired and utilized machines that allowed them to have sufficient inventory available for sale.'
	          )
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorSuccessfulTeams2.default, alt: 'Marketing Mix' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return SuccessfulStep1;
	}(_react.PureComponent);
	
	exports.default = SuccessfulStep1;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _instructorSuccessfulTeams = __webpack_require__(2591);
	
	var _instructorSuccessfulTeams2 = _interopRequireDefault(_instructorSuccessfulTeams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessfulStep2 = function (_PureComponent) {
	  _inherits(SuccessfulStep2, _PureComponent);
	
	  function SuccessfulStep2() {
	    _classCallCheck(this, SuccessfulStep2);
	
	    return _possibleConstructorReturn(this, (SuccessfulStep2.__proto__ || Object.getPrototypeOf(SuccessfulStep2)).apply(this, arguments));
	  }
	
	  _createClass(SuccessfulStep2, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'Successful Teams',
	        title: 'Reason Why Teams Hit Their Targets',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Teams that were successful in Round 2 did 3 things very well . They 1) reviewed their feedback, 2) performed competitive analysis, and then 3) offered a greater value proposition.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To better understand their competitive position, these teams likely spend sometime evaluating the marketing analysis section of the Team Report. They then leverage those insights to make their products more attractive.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To further enhance their value proposition, they likely selected a distribution center that offered the best lead time to delivery.'
	          )
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorSuccessfulTeams2.default, alt: 'Distribution Centers' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return SuccessfulStep2;
	}(_react.PureComponent);
	
	exports.default = SuccessfulStep2;

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _instructorSuccessfulTeams = __webpack_require__(1058);
	
	var _instructorSuccessfulTeams2 = _interopRequireDefault(_instructorSuccessfulTeams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessfulStep3 = function (_PureComponent) {
	  _inherits(SuccessfulStep3, _PureComponent);
	
	  function SuccessfulStep3() {
	    _classCallCheck(this, SuccessfulStep3);
	
	    return _possibleConstructorReturn(this, (SuccessfulStep3.__proto__ || Object.getPrototypeOf(SuccessfulStep3)).apply(this, arguments));
	  }
	
	  _createClass(SuccessfulStep3, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'Successful Teams',
	        title: 'Reason Why Teams Hit Their Targets',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Teams that were successful in Round 3 did 3 things very well. They 1) reviewed their feedback, 2) analyzed their prior round financials, and then 3) made decisions that would allow them to make a profit and hit their return on investments targets.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'These teams likely made the connection in how each of the core functions impact various parts of the income statement and made decisions that helped them maximized their revenues while managing their expenses appropriately.'
	          )
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorSuccessfulTeams2.default, alt: 'Income Statement' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return SuccessfulStep3;
	}(_react.PureComponent);
	
	exports.default = SuccessfulStep3;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _instructorPerformanceFeedbackThatsAll = __webpack_require__(2589);
	
	var _instructorPerformanceFeedbackThatsAll2 = _interopRequireDefault(_instructorPerformanceFeedbackThatsAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThatsAll = function (_PureComponent) {
	  _inherits(ThatsAll, _PureComponent);
	
	  function ThatsAll() {
	    _classCallCheck(this, ThatsAll);
	
	    return _possibleConstructorReturn(this, (ThatsAll.__proto__ || Object.getPrototypeOf(ThatsAll)).apply(this, arguments));
	  }
	
	  _createClass(ThatsAll, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'That\u2019s All!',
	        title: 'See You in the Next Round',
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          'That\u2019s all for now! You can check this performance feedback again at any time in the game under the Results section.'
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorPerformanceFeedbackThatsAll2.default, alt: 'Rocket' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return ThatsAll;
	}(_react.PureComponent);
	
	exports.default = ThatsAll;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _instructorCustomerPreferences = __webpack_require__(2584);
	
	var _instructorCustomerPreferences2 = _interopRequireDefault(_instructorCustomerPreferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomerPreferences = function (_PureComponent) {
	  _inherits(CustomerPreferences, _PureComponent);
	
	  function CustomerPreferences() {
	    _classCallCheck(this, CustomerPreferences);
	
	    return _possibleConstructorReturn(this, (CustomerPreferences.__proto__ || Object.getPrototypeOf(CustomerPreferences)).apply(this, arguments));
	  }
	
	  _createClass(CustomerPreferences, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeRound = _props.activeRound,
	          previousShownErrors = _props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'What to expect next',
	        subSection: 'Customer preferences',
	        alertText: 'Change in Customer Preferences',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'Customer preferences are expected to change for some customers. Therefore, teams need to review Round ',
	          _react2.default.createElement(
	            'b',
	            null,
	            activeRound + 1
	          ),
	          ' Customer Analysis to ensure their product still meets the minimum requirements for the customers that they are targeting.'
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorCustomerPreferences2.default, alt: 'Customer Preferences' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return CustomerPreferences;
	}(_react.PureComponent);
	
	exports.default = CustomerPreferences;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	var _instructorWhatToExpectNext = __webpack_require__(2592);
	
	var _instructorWhatToExpectNext2 = _interopRequireDefault(_instructorWhatToExpectNext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhatToExpectNext = function (_PureComponent) {
	  _inherits(WhatToExpectNext, _PureComponent);
	
	  function WhatToExpectNext() {
	    _classCallCheck(this, WhatToExpectNext);
	
	    return _possibleConstructorReturn(this, (WhatToExpectNext.__proto__ || Object.getPrototypeOf(WhatToExpectNext)).apply(this, arguments));
	  }
	
	  _createClass(WhatToExpectNext, [{
	    key: 'render',
	    value: function render() {
	      var activeRound = this.props.activeRound;
	
	      var content = activeRound === 1 ? 'There will be new supply chain decisions that will impact both revenues and costs.' : 'In round 3, scoring metrics and valuation have shifted towards profitability. Therefore, teams have to make a profit and should spend time evaluating their prior round financials to make informed marketing mix, supply chain, and financing decisions.';
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'What to expect next',
	        title: 'What\u2019s New in Round ' + (activeRound + 1),
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          content
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorWhatToExpectNext2.default, alt: 'What to expect next' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return WhatToExpectNext;
	}(_react.PureComponent);
	
	exports.default = WhatToExpectNext;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #6FD1D9;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 30px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n'], ['\n  background: #6FD1D9;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 30px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  margin-top: 12px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #2A4169;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 12px;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n'], ['\n  background: #2A4169;\n  border-radius: 8px;\n  padding: 16px;\n  color: #fff;\n  text-align: center;\n  margin-right: 12px;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n'], ['\n  width: 16px;\n  height: 7px;\n  position: relative;\n\n  &:before, &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    height: 1.5px;\n    background: rgba(0, 27, 59, 0.94);\n    border-radius: 100px;\n  }\n\n  &:before {\n    top: 0;\n  }\n\n  &:after {\n    bottom: 0;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  margin-left: 5px;\n  position: relative;\n  padding: 0 12px;\n\n  &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    bottom: 8px;\n    height: 43px;\n    left: 0;\n    right: 0;\n    border-radius: 4px;\n    border: 2px solid #2A4169;\n  }\n'], ['\n  margin-left: 5px;\n  position: relative;\n  padding: 0 12px;\n\n  &:after {\n    display: block;\n    content: \'\';\n    position: absolute;\n    bottom: 8px;\n    height: 43px;\n    left: 0;\n    right: 0;\n    border-radius: 4px;\n    border: 2px solid #2A4169;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 212px;\n  margin-left: 12px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 212px;\n  margin-left: 12px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n'], ['\n  width: 100%;\n  height: 1px;\n  background: rgba(0, 27, 59, 0.94);\n  margin: 12px 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _onboardingConductResearch = __webpack_require__(1060);
	
	var _onboardingConductResearch2 = _interopRequireDefault(_onboardingConductResearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FormulaBlock = _styledComponents2.default.div(_templateObject);
	
	var FormulaLeftPart = _styledComponents2.default.div(_templateObject2);
	
	var EqualitySign = _styledComponents2.default.div(_templateObject3);
	
	var Image = _styledComponents2.default.div(_templateObject4);
	
	var FormulaRightPart = _styledComponents2.default.div(_templateObject5);
	
	var FormulaDivider = _styledComponents2.default.div(_templateObject6);
	
	var NewScoringMetrics = function (_PureComponent) {
	  _inherits(NewScoringMetrics, _PureComponent);
	
	  function NewScoringMetrics() {
	    _classCallCheck(this, NewScoringMetrics);
	
	    return _possibleConstructorReturn(this, (NewScoringMetrics.__proto__ || Object.getPrototypeOf(NewScoringMetrics)).apply(this, arguments));
	  }
	
	  _createClass(NewScoringMetrics, [{
	    key: 'render',
	    value: function render() {
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'What to expect next',
	        subSection: 'New scoring metrics',
	        alertText: 'New Scoring Metrics: Return on Investments',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'Metrics change in round 3. New metrics such as ROE and ROA that use net profits to measure the return on an investment (ROI) are introduced. '
	        ),
	        visual: _react2.default.createElement(
	          FormulaBlock,
	          null,
	          _react2.default.createElement(
	            FormulaLeftPart,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'ROI Metrics'
	            )
	          ),
	          _react2.default.createElement(EqualitySign, null),
	          _react2.default.createElement(
	            FormulaRightPart,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Income Statements'
	            ),
	            _react2.default.createElement(FormulaDivider, null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Balance Sheet'
	            )
	          ),
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement('img', { src: _onboardingConductResearch2.default, alt: '' })
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return NewScoringMetrics;
	}(_react.PureComponent);
	
	exports.default = NewScoringMetrics;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _instructorNewValuationModel = __webpack_require__(2585);
	
	var _instructorNewValuationModel2 = _interopRequireDefault(_instructorNewValuationModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewValuationModel = function (_PureComponent) {
	  _inherits(NewValuationModel, _PureComponent);
	
	  function NewValuationModel() {
	    _classCallCheck(this, NewValuationModel);
	
	    return _possibleConstructorReturn(this, (NewValuationModel.__proto__ || Object.getPrototypeOf(NewValuationModel)).apply(this, arguments));
	  }
	
	  _createClass(NewValuationModel, [{
	    key: 'render',
	    value: function render() {
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'What to expect next',
	        subSection: 'New valuation model',
	        alertText: 'Change in Valuation Method: Price to Earnings Multiples (P/E)',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'Unlike round 1 & 2 when each team\u2019s business value was driven by revenues (i.e. price to sales multiples), in round 3 and 4, each team\u2019s business value will now be driven by profits (price to earnings multiples). As a result, their share price will be driven by profits.'
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorNewValuationModel2.default, alt: '' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return NewValuationModel;
	}(_react.PureComponent);
	
	exports.default = NewValuationModel;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  margin-top: 12px;\n  background: #fff;\n\n  > div:first-child {\n    grid-column: 3;\n    text-align: center;\n    margin-bottom: 12px;\n  }\n  \n  > div:nth-child(2) {\n    grid-column: 3;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-bottom: 7px;\n  }\n  \n  > div:nth-child(3) {\n    display: flex;\n    align-items: center;\n    width: 176px;\n  }\n  \n  > div:nth-child(4) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 36px;\n  }\n'], ['\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 20px;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  margin-top: 12px;\n  background: #fff;\n\n  > div:first-child {\n    grid-column: 3;\n    text-align: center;\n    margin-bottom: 12px;\n  }\n  \n  > div:nth-child(2) {\n    grid-column: 3;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-bottom: 7px;\n  }\n  \n  > div:nth-child(3) {\n    display: flex;\n    align-items: center;\n    width: 176px;\n  }\n  \n  > div:nth-child(4) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 36px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  background: rgba(0, 27, 43, 0.02);\n  border-radius: 4px;\n  padding: 2px 8px;\n  color: rgba(0, 27, 59, 0.6);\n  display: inline-block;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  background: rgba(0, 27, 43, 0.02);\n  border-radius: 4px;\n  padding: 2px 8px;\n  color: rgba(0, 27, 59, 0.6);\n  display: inline-block;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  width: 100px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  width: 100px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  transform: rotate(-90deg) translateX(-2%);\n\n  &:first-child {\n    transform: rotate(-90deg) translateX(-15%);\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n  transform: rotate(-90deg) translateX(-2%);\n\n  &:first-child {\n    transform: rotate(-90deg) translateX(-15%);\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n  row-gap: 20px;\n  column-gap: 20px;\n  width: fit-content;\n  position: relative;\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 12px;\n    height: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  &:after {\n    display: block;\n    content: \'\';\n    height: 12px;\n    width: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  > div {\n    width: 220px;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    color: #fff;\n\n    &:first-child {\n      background: #F9C151;\n      color: rgba(0, 27, 59, 0.94);\n    }\n\n    &:nth-child(2) {\n      background: #52C5CD;\n    }\n\n    &:nth-child(3) {\n      background: #EC5E59;\n    }\n\n    &:nth-child(4) {\n      background: #2A4169;\n    }\n  }\n'], ['\n  display: grid;\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n  row-gap: 20px;\n  column-gap: 20px;\n  width: fit-content;\n  position: relative;\n\n  &:before {\n    display: block;\n    content: \'\';\n    width: 12px;\n    height: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  &:after {\n    display: block;\n    content: \'\';\n    height: 12px;\n    width: 100%;\n    background: url(', ') no-repeat center center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  > div {\n    width: 220px;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    color: #fff;\n\n    &:first-child {\n      background: #F9C151;\n      color: rgba(0, 27, 59, 0.94);\n    }\n\n    &:nth-child(2) {\n      background: #52C5CD;\n    }\n\n    &:nth-child(3) {\n      background: #EC5E59;\n    }\n\n    &:nth-child(4) {\n      background: #2A4169;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 4px; \n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 4px; \n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _onboardingWhatToExpectLineVertical = __webpack_require__(691);
	
	var _onboardingWhatToExpectLineVertical2 = _interopRequireDefault(_onboardingWhatToExpectLineVertical);
	
	var _onboardingWhatToExpectLineHorizontal = __webpack_require__(690);
	
	var _onboardingWhatToExpectLineHorizontal2 = _interopRequireDefault(_onboardingWhatToExpectLineHorizontal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var MarketsCustomersBlock1 = _styledComponents2.default.div(_templateObject);
	
	var MarketsCustomersLabel = _styledComponents2.default.div(_templateObject2);
	
	var MarketsCustomersHeader = _styledComponents2.default.div(_templateObject3);
	
	var MarketsCustomersHeaderRotated = _styledComponents2.default.div(_templateObject4);
	
	var MarketsCustomersBlock2 = _styledComponents2.default.div(_templateObject5, _onboardingWhatToExpectLineVertical2.default, _onboardingWhatToExpectLineHorizontal2.default);
	
	var MarketsCustomersTitle = _styledComponents2.default.h4(_templateObject6);
	
	var MarketsCustomersText = _styledComponents2.default.p(_templateObject7);
	
	var ProductStrategy = function (_PureComponent) {
	  _inherits(ProductStrategy, _PureComponent);
	
	  function ProductStrategy() {
	    _classCallCheck(this, ProductStrategy);
	
	    return _possibleConstructorReturn(this, (ProductStrategy.__proto__ || Object.getPrototypeOf(ProductStrategy)).apply(this, arguments));
	  }
	
	  _createClass(ProductStrategy, [{
	    key: 'render',
	    value: function render() {
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'What to expect next',
	        subSection: 'Product strategy',
	        alertText: 'Product Market Expansion Options',
	        previousShownErrors: previousShownErrors,
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          'Expect competition to heat up in round 2. Therefore, teams will need to be more strategic and vigilant. As you can see below, there are a few product market expansion strategies to consider. ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.mindtools.com/pages/article/newTMC_90.htm', target: '_blank', rel: 'noreferrer' },
	            'Learn More'
	          )
	        ),
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'Tip: Strategies are best executed when they understand their competitive position. Therefore they should review round 1 Team Report to better understand their competitors\u2019 moves.'
	        ),
	        visual: _react2.default.createElement(
	          MarketsCustomersBlock1,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              MarketsCustomersLabel,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'PRODUCTS'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              MarketsCustomersHeader,
	              null,
	              'Current'
	            ),
	            _react2.default.createElement(
	              MarketsCustomersHeader,
	              null,
	              'New'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              MarketsCustomersLabel,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'MARKETS/ CUSTOMERS'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '(auto & mobile)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              MarketsCustomersHeaderRotated,
	              null,
	              'Current'
	            ),
	            _react2.default.createElement(
	              MarketsCustomersHeaderRotated,
	              null,
	              'New'
	            )
	          ),
	          _react2.default.createElement(
	            MarketsCustomersBlock2,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersTitle,
	                null,
	                'Market Penetration'
	              ),
	              _react2.default.createElement(
	                MarketsCustomersText,
	                null,
	                'Penetrate existing market (auto or mobile)'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersTitle,
	                null,
	                'Product Development'
	              ),
	              _react2.default.createElement(
	                MarketsCustomersText,
	                null,
	                'Not Applicable'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersTitle,
	                null,
	                'Market Development'
	              ),
	              _react2.default.createElement(
	                MarketsCustomersText,
	                null,
	                'Enter new markets with existing products (auto or mobile)'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                MarketsCustomersTitle,
	                null,
	                'Diversification'
	              ),
	              _react2.default.createElement(
	                MarketsCustomersText,
	                null,
	                'Enter new markets with new products (auto or mobile)'
	              )
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return ProductStrategy;
	}(_react.PureComponent);
	
	exports.default = ProductStrategy;

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _shareBuyback = __webpack_require__(1065);
	
	var _shareBuyback2 = _interopRequireDefault(_shareBuyback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShareBuybacks = function (_PureComponent) {
	  _inherits(ShareBuybacks, _PureComponent);
	
	  function ShareBuybacks() {
	    _classCallCheck(this, ShareBuybacks);
	
	    return _possibleConstructorReturn(this, (ShareBuybacks.__proto__ || Object.getPrototypeOf(ShareBuybacks)).apply(this, arguments));
	  }
	
	  _createClass(ShareBuybacks, [{
	    key: 'render',
	    value: function render() {
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'What to expect next',
	        subSection: 'Share Buybacks',
	        alertText: 'Share Buyback',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'Teams will also have to decide if they should re-invest their capital back into the business or return the capital to investors through ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.mindtools.com/pages/article/newTMC_90.htm', target: '_blank', rel: 'noreferrer' },
	            'share buybacks.'
	          )
	        ),
	        visual: _react2.default.createElement('img', { src: _shareBuyback2.default, alt: '' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return ShareBuybacks;
	}(_react.PureComponent);
	
	exports.default = ShareBuybacks;

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _supplyChainDecisions = __webpack_require__(2675);
	
	var _supplyChainDecisions2 = _interopRequireDefault(_supplyChainDecisions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupplyChainDecisions = function (_PureComponent) {
	  _inherits(SupplyChainDecisions, _PureComponent);
	
	  function SupplyChainDecisions() {
	    _classCallCheck(this, SupplyChainDecisions);
	
	    return _possibleConstructorReturn(this, (SupplyChainDecisions.__proto__ || Object.getPrototypeOf(SupplyChainDecisions)).apply(this, arguments));
	  }
	
	  _createClass(SupplyChainDecisions, [{
	    key: 'render',
	    value: function render() {
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return _react2.default.createElement(_banner2.default, {
	        section: 'What to expect next',
	        subSection: 'Supply Chain decisions',
	        alertText: 'New Supply Chain Decisions',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Distribution Center Options'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Teams will have the option to open up a distribution center to potentially reduce the time it takes for inventory to be delivered to customers. However, it\u2019ll be at a cost(tradeoff: time vs. cost).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'New Machine Options'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Teams will have the option to buy new machines that are far more productive and cost a lot more (tradeoff: revenues vs. costs).'
	          )
	        ),
	        visual: _react2.default.createElement('img', { src: _supplyChainDecisions2.default, alt: 'Chain Decisions' }),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return SupplyChainDecisions;
	}(_react.PureComponent);
	
	exports.default = SupplyChainDecisions;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #55b4bc;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: default;\n'], ['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #55b4bc;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: default;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid #ec5e59;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ec5e59;\n  cursor: default;\n'], ['\n  width: 97px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid #ec5e59;\n  border-radius: 2px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ec5e59;\n  cursor: default;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _table = __webpack_require__(608);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SubmittedButton = _styledComponents2.default.div(_templateObject);
	
	var NotSubmittedButton = _styledComponents2.default.div(_templateObject2);
	
	var DesicionsNotSubmitted = function (_PureComponent) {
	  _inherits(DesicionsNotSubmitted, _PureComponent);
	
	  function DesicionsNotSubmitted(props) {
	    _classCallCheck(this, DesicionsNotSubmitted);
	
	    var _this = _possibleConstructorReturn(this, (DesicionsNotSubmitted.__proto__ || Object.getPrototypeOf(DesicionsNotSubmitted)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teams = res.body;
	        var teamsDidNotSubmit = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Did not submit";
	        }).teams;
	        var insufficientCapital = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Insufficient capital";
	        });
	        var teamsToShowIds = [];
	        if (insufficientCapital) {
	          var teamsInsufficientCapital = insufficientCapital.teams;
	          teamsToShowIds = teamsDidNotSubmit.filter(function (teamDidNotSubmit) {
	            return !teamsInsufficientCapital.includes(teamDidNotSubmit);
	          });
	        } else {
	          teamsToShowIds = teamsDidNotSubmit;
	        }
	
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        var gameId = Number(_Auth2.default.getGameId());
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'games/' + gameId + '/journal/?round_id=' + roundId + '&team_id=' + team_id).then(function (res) {
	          var keys = {
	            pd: 'submit_development',
	            pm: 'submit_marketing',
	            op: 'submit_operations',
	            fn: 'submit_finance'
	          };
	
	          var result = {};
	          var history = [].concat(_toConsumableArray(res.body));
	
	          history.sort(function (a, b) {
	            var dateA = new Date(a.requested_at);
	            var dateB = new Date(b.requested_at);
	
	            return dateB - dateA;
	          });
	
	          ['pd', 'pm', 'op', 'fn'].forEach(function (type) {
	            result[type] = false;
	
	            var obj = history.find(function (i) {
	              return i.path === '/api/teams/' + keys[type] + '/';
	            });
	            if (obj && obj.response && typeof obj.response.success !== 'undefined') {
	              result[type] = obj.response.success;
	            }
	          });
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      result: {
	        pd: false,
	        pm: false,
	        op: false,
	        fn: false
	      },
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0
	    };
	    return _this;
	  }
	
	  _createClass(DesicionsNotSubmitted, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var previousShownErrors = this.props.previousShownErrors;
	      var _state = this.state,
	          result = _state.result,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit | Did Not Submit Decisions',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams did not post some or all of their decisions.',
	        previousShownErrors: previousShownErrors,
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Note:'
	          ),
	          ' There are some teams that did not post their decisions yet their decisions were still processed because they had sufficient capital.'
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Department'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Submission Status'
	            )
	          ),
	          _react2.default.createElement(
	            _table.Row,
	            { background: 'rgba(0, 27, 43, 0.02)' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: 'rgba(0, 27, 59, 0.94)' },
	              'Product Management'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              null,
	              result.pd && _react2.default.createElement(
	                SubmittedButton,
	                null,
	                'Submitted'
	              ),
	              !result.pd && _react2.default.createElement(
	                NotSubmittedButton,
	                null,
	                'Not Submitted'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _table.Row,
	            { background: 'rgba(0, 27, 43, 0.02)' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: 'rgba(0, 27, 59, 0.94)' },
	              'Product Marketing'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              null,
	              result.pm && _react2.default.createElement(
	                SubmittedButton,
	                null,
	                'Submitted'
	              ),
	              !result.pm && _react2.default.createElement(
	                NotSubmittedButton,
	                null,
	                'Not Submitted'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _table.Row,
	            { background: 'rgba(0, 27, 43, 0.02)' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: 'rgba(0, 27, 59, 0.94)' },
	              'Operations'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              null,
	              result.op && _react2.default.createElement(
	                SubmittedButton,
	                null,
	                'Submitted'
	              ),
	              !result.op && _react2.default.createElement(
	                NotSubmittedButton,
	                null,
	                'Not Submitted'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _table.Row,
	            { background: 'rgba(0, 27, 43, 0.02)' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: 'rgba(0, 27, 59, 0.94)' },
	              'Finance'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              null,
	              result.fn && _react2.default.createElement(
	                SubmittedButton,
	                null,
	                'Submitted'
	              ),
	              !result.fn && _react2.default.createElement(
	                NotSubmittedButton,
	                null,
	                'Not Submitted'
	              )
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return DesicionsNotSubmitted;
	}(_react.PureComponent);
	
	exports.default = DesicionsNotSubmitted;

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EPSStep2 = function (_PureComponent) {
	  _inherits(EPSStep2, _PureComponent);
	
	  function EPSStep2(props) {
	    _classCallCheck(this, EPSStep2);
	
	    var _this = _possibleConstructorReturn(this, (EPSStep2.__proto__ || Object.getPrototypeOf(EPSStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "EPS fail";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        Promise.all([(0, _MetricsService.fetchTeamMetrics)(team_id, roundId), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/report/income_statement/?round_number=' + activeRound + '&team_id=' + team_id)]).then(function (res) {
	          var metrics = res[0];
	          var currentRoundMetrics = metrics.find(function (i) {
	            return Number(i.round_number) === Number(activeRound);
	          });
	          var netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
	          var unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
	          var averageSellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
	          var shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;
	          var epsReport = currentRoundMetrics ? Number(currentRoundMetrics.earnings_per_share || 0) : 0;
	
	          var incomeStatement = res[1].body;
	          var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	            return i.round === roundId;
	          });
	          var costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
	          var unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
	          var netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            averageSellingPrice: averageSellingPrice,
	            unitCost: unitCost,
	            netIncome: netIncome,
	            shares: shares,
	            epsReport: epsReport
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      averageSellingPrice: 0,
	      unitCost: 0,
	      grossMargin: 0,
	      netIncome: 0,
	      shares: 0
	    };
	    return _this;
	  }
	
	  _createClass(EPSStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          netIncome = _state.netIncome,
	          shares = _state.shares,
	          epsReport = _state.epsReport;
	      var _props = this.props,
	          previousShownErrors = _props.previousShownErrors,
	          gamesTargets = _props.gamesTargets;
	
	
	      var currentRoundMetrics = gamesTargets.find(function (i) {
	        return i.round_number === _this2.props.activeRound;
	      });
	
	      var epsMetric = Number(currentRoundMetrics.earnings_per_share || 0);
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'EPS',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams did not generate enough profits',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'This team reported earnings per share of ',
	            _react2.default.createElement(
	              'b',
	              null,
	              (0, _PerformanceFeedback.formatNumber)(epsReport)
	            ),
	            ', falling short of the ',
	            _react2.default.createElement(
	              'b',
	              null,
	              (0, _PerformanceFeedback.formatNumber)(epsMetric)
	            ),
	            ' target.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Common Reasons Teams Struggle to Maximize Profits:'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Revenue Challenges:'
	            ),
	            ' Lower revenues often stem from issues in the marketing mix or production capacity. For example, weaker product rankings or underperforming machines.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Operating Margin Pressures:'
	            ),
	            ' Margins tend to shrink when selling prices remain fixed while costs rise. This often happens as teams upgrade products to stay competitive, leading to higher expenses without an immediate boost in price.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'High Financing Costs:'
	            ),
	            ' Teams that took on significant debt in earlier rounds may now be struggling with repayments. As the focus shifts to profit-driven metrics, the weight of these financing costs becomes more apparent.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#2DA548' },
	            'Earnings Per Share',
	            _react2.default.createElement('br', null),
	            '(EPS)'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Net Profits',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Total Shares'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: netIncome,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: shares,
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: 'rgba(45, 165, 72, 0.12)',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return EPSStep2;
	}(_react.PureComponent);
	
	exports.default = EPSStep2;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GrossMarginsStep2 = function (_PureComponent) {
	  _inherits(GrossMarginsStep2, _PureComponent);
	
	  function GrossMarginsStep2(props) {
	    _classCallCheck(this, GrossMarginsStep2);
	
	    var _this = _possibleConstructorReturn(this, (GrossMarginsStep2.__proto__ || Object.getPrototypeOf(GrossMarginsStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Gross margin fail";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        Promise.all([(0, _MetricsService.fetchTeamMetrics)(team_id, roundId), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/report/income_statement/?round_number=' + activeRound + '&team_id=' + team_id)]).then(function (res) {
	          var metrics = res[0];
	          var currentRoundMetrics = metrics.find(function (i) {
	            return Number(i.round_number) === Number(activeRound);
	          });
	
	          var netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
	          var unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
	          var sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
	
	          var incomeStatement = res[1].body;
	          var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	            return i.round === roundId;
	          });
	          var costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
	          var unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            sellingPrice: sellingPrice,
	            unitCost: unitCost
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      sellingPrice: 0,
	      unitCost: 0
	    };
	    return _this;
	  }
	
	  _createClass(GrossMarginsStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          sellingPrice = _state.sellingPrice,
	          unitCost = _state.unitCost;
	      var _props = this.props,
	          previousShownErrors = _props.previousShownErrors,
	          gamesTargets = _props.gamesTargets;
	
	
	      var grossMargin = Number(gamesTargets[0].gross_margin || 0);
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Gross Margins',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams generated insufficient margins',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'The gross profit spread between these team\u2019s product\u2019s average selling price $',
	          sellingPrice.toFixed(2),
	          ' and the average cost to manufacture each unit $',
	          unitCost.toFixed(2),
	          ' was $',
	          (sellingPrice - unitCost).toFixed(2),
	          ', which was not enough to generate the gross profit margin needed to hit the ',
	          _react2.default.createElement(
	            'b',
	            null,
	            Number((grossMargin * 100).toFixed(2)),
	            '%'
	          ),
	          ' gross margin target.'
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#FEC665', color: 'rgba(0, 27, 59, 0.94)' },
	            'Gross Profit Margin',
	            _react2.default.createElement('br', null),
	            'Per Unit of Sale'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Selling Price - Unit Cost',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Selling Price'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            (0, _PerformanceFeedback.formatNumber)(sellingPrice - unitCost),
	            _react2.default.createElement('span', { className: 'divider' }),
	            (0, _PerformanceFeedback.formatNumber)(sellingPrice)
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#FBEDD5',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return GrossMarginsStep2;
	}(_react.PureComponent);
	
	exports.default = GrossMarginsStep2;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GrossMarginsStep3 = function (_PureComponent) {
	  _inherits(GrossMarginsStep3, _PureComponent);
	
	  function GrossMarginsStep3(props) {
	    _classCallCheck(this, GrossMarginsStep3);
	
	    var _this = _possibleConstructorReturn(this, (GrossMarginsStep3.__proto__ || Object.getPrototypeOf(GrossMarginsStep3)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Negative gross margins";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        var game_id = _Auth2.default.getGameId();
	        var course_id = _Auth2.default.getCourseId();
	
	        Promise.all([(0, _MetricsService.fetchTeamMetrics)(team_id, roundId), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/report/income_statement/?round_number=' + activeRound + '&team_id=' + team_id), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound + '&team_id=' + team_id), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound + '&team_id=' + team_id), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/reports/performancefeedbacks/?round_number=' + activeRound)]).then(function (res) {
	          var metrics = res[0];
	          var currentRoundMetrics = metrics.find(function (i) {
	            return Number(i.round_number) === Number(activeRound);
	          });
	
	          var netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
	          var unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
	          var sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;
	
	          var incomeStatement = res[1].body;
	          var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	            return i.round === roundId;
	          });
	          var costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
	          var unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;
	
	          var performanceFeedbacks = res[4].body.results;
	
	          var pfReport = performanceFeedbacks.find(function (i) {
	            return Number(i.course) === course_id && Number(i.game) === game_id && Number(i.round) === roundId && Number(i.team) === team_id && i.type === 'Negative gross margins';
	          });
	
	          if (!!pfReport) {
	            var message = JSON.parse(pfReport.message);
	            if (message.faild_products && message.faild_products.length > 0) {
	              var productId = Number(message.faild_products[0]);
	              var priceForecastsRaw = res[2].body;
	              var priceForecastsProduct = priceForecastsRaw.find(function (i) {
	                return Number(i.product) === productId;
	              });
	              var inventoryBalancesRaw = res[3].body;
	              var inventoryBalancesProduct = inventoryBalancesRaw.find(function (i) {
	                return Number(i.product) === productId;
	              });
	
	              if (priceForecastsProduct && inventoryBalancesProduct) {
	                sellingPrice = Number(priceForecastsProduct.price);
	                unitCost = Number(inventoryBalancesProduct.cost_per_unit);
	              }
	            }
	          }
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            sellingPrice: sellingPrice,
	            unitCost: unitCost
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      sellingPrice: 0,
	      unitCost: 0
	    };
	    return _this;
	  }
	
	  _createClass(GrossMarginsStep3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          sellingPrice = _state.sellingPrice,
	          unitCost = _state.unitCost;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      var differenceFormulaValue = void 0;
	      if (sellingPrice - unitCost < 0) {
	        differenceFormulaValue = _react2.default.createElement(
	          'b',
	          null,
	          (0, _PerformanceFeedback.formatNumber)(sellingPrice - unitCost)
	        );
	      } else {
	        differenceFormulaValue = _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          (0, _PerformanceFeedback.formatNumber)(sellingPrice - unitCost)
	        );
	      }
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Gross Margins',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams might be running a non-profit or a growth-at-all-cost strategy.',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'This team is selling their product below what it cost for them to make the product.'
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#4CC7D1', color: 'rgba(0, 27, 59, 0.94)' },
	            'Gross Profit Margin',
	            _react2.default.createElement('br', null),
	            'Per Unit of Sale'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Selling Price - Unit Cost',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Selling Price'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            differenceFormulaValue,
	            _react2.default.createElement('span', { className: 'divider' }),
	            (0, _PerformanceFeedback.formatNumber)(sellingPrice)
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#D7F0F2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return GrossMarginsStep3;
	}(_react.PureComponent);
	
	exports.default = GrossMarginsStep3;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  padding: 20px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 20px;\n'], ['\n  width: 100%;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #d5d9dd;\n  padding: 20px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 20px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 7px;\n'], ['\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-bottom: 7px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  line-height: 24px;\n'], ['\n  line-height: 24px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-weight: 700;\n'], ['\n  font-weight: 700;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRouter = __webpack_require__(24);
	
	var _ApiService = __webpack_require__(4);
	
	var _oneVisual = __webpack_require__(157);
	
	var _oneVisual2 = _interopRequireDefault(_oneVisual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FeedbackBlock = _styledComponents2.default.div(_templateObject);
	
	var FeedbackBlockTitle = _styledComponents2.default.h3(_templateObject2);
	
	var FeedbackBlockList = _styledComponents2.default.ul(_templateObject3);
	
	var FeedbackBlockListItem = _styledComponents2.default.li(_templateObject3);
	
	var FeedbackBlockBold = _styledComponents2.default.span(_templateObject4);
	
	var WhyTargetsWerentHit = function (_PureComponent) {
	  _inherits(WhyTargetsWerentHit, _PureComponent);
	
	  function WhyTargetsWerentHit(props) {
	    _classCallCheck(this, WhyTargetsWerentHit);
	
	    var _this = _possibleConstructorReturn(this, (WhyTargetsWerentHit.__proto__ || Object.getPrototypeOf(WhyTargetsWerentHit)).call(this, props));
	
	    _this.state = {
	      staticConstants: {}
	    };
	    return _this;
	  }
	
	  _createClass(WhyTargetsWerentHit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'static/constants/').then(function (res) {
	        var staticConstants = res.body[0] || {};
	        console.log('staticConstants', staticConstants);
	
	        _this2.setState({
	          staticConstants: staticConstants
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          performanceFeedbacksGame = _props.performanceFeedbacksGame,
	          gamesTargets = _props.gamesTargets,
	          activeRound = _props.activeRound;
	      var staticConstants = this.state.staticConstants;
	
	      console.log('performanceFeedbacksGame', performanceFeedbacksGame);
	
	      var hasDidNotSubmitOrInsufficientCapital = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Did not submit" || item.type === "Insufficient capital";
	      });
	
	      var submissionStatusContent = hasDidNotSubmitOrInsufficientCapital ? _react2.default.createElement(
	        'p',
	        null,
	        'Some teams didn\u2019t post all of their decisions either because they weren\u2019t made or didn\u2019t have sufficient capital to post them (',
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/instructor/performance-feedback/decisions-not-submitted?round=' + activeRound },
	          'learn more'
	        ),
	        ').'
	      ) : _react2.default.createElement(
	        'p',
	        null,
	        'All teams posted their decisions successfully for this round.'
	      );
	
	      var hasProductMarketFit = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Product market fit";
	      });
	      var hasPriceRangeFailed = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Price range failed";
	      });
	      var hasMarketFitIssues = hasProductMarketFit || hasPriceRangeFailed;
	
	      var hasLowExpectedRevenue = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Expected revenue low";
	      });
	
	      var hasAwareness = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Awareness";
	      });
	
	      var hasMarketShareNetRevenuesTargets = gamesTargets[0].net_revenues !== 0 || gamesTargets[0].market_share !== 0;
	      var hasMarketShareOrRevenueFail = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Market share" || item.type === "Revenue fail";
	      });
	      var hasNoRevenueIssues = !performanceFeedbacksGame.some(function (item) {
	        return item.type === "Product market fit" || item.type === "Price range failed" || item.type === "Expected revenue low" || item.type === "Awareness";
	      });
	
	      var hasNegativeGrossMargins = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Negative gross margins";
	      });
	
	      var hasGrossMarginFail = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Gross margin fail";
	      });
	
	      var hasAutoOrMobileOverproduced = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Auto overproduced" || item.type === "Mobile overproduced";
	      });
	
	      var hasHighInterest = performanceFeedbacksGame.some(function (item) {
	        return item.type === "High interest";
	      });
	
	      var hasRoeRoaEps = gamesTargets[0].roe !== 0 || gamesTargets[0].roa !== 0 || gamesTargets[0].earnings_per_share !== 0;
	
	      var hasRoeRoaEpsFail = performanceFeedbacksGame.some(function (item) {
	        return item.type === "Roe fail" || item.type === "Roa fail" || item.type === "EPS fail";
	      });
	
	      var hasNoGrossMarginIssuesOrOverproducedOrHighInterest = !performanceFeedbacksGame.some(function (item) {
	        return item.type === "Negative gross margins" || item.type === "Gross margin fail" || item.type === "Auto overproduced" || item.type === "Mobile overproduced" || item.type === "High interest";
	      });
	
	      return _react2.default.createElement(_oneVisual2.default, {
	        section: 'Feedback | OVERALL',
	        title: 'Overall Feedback',
	        paragraph1: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            FeedbackBlock,
	            null,
	            _react2.default.createElement(
	              FeedbackBlockTitle,
	              null,
	              'Submission Status'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              submissionStatusContent
	            )
	          ),
	          _react2.default.createElement(
	            FeedbackBlock,
	            null,
	            _react2.default.createElement(
	              FeedbackBlockTitle,
	              null,
	              'Feedback: Generating Market Share & Revenues'
	            ),
	            _react2.default.createElement(
	              FeedbackBlockList,
	              null,
	              hasMarketFitIssues && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Market Fit Challenges:'
	                ),
	                ' Some teams have a product that is either aimed at customers with low demand ',
	                hasProductMarketFit && _react2.default.createElement(
	                  _reactDotFragment2.default,
	                  null,
	                  '(',
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/instructor/performance-feedback/market-share/product-met-interest?round=' + activeRound },
	                    'learn more'
	                  ),
	                  ')'
	                ),
	                ' or is priced outside what the target market is willing to pay ',
	                hasPriceRangeFailed && _react2.default.createElement(
	                  _reactDotFragment2.default,
	                  null,
	                  '(',
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/instructor/performance-feedback/market-share/outside-price-range?round=' + activeRound },
	                    'learn more'
	                  ),
	                  ')'
	                ),
	                '. They need to review/re-visit the Customer Analysis.'
	              ),
	              hasLowExpectedRevenue && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Price & Supply Misalignment:'
	                ),
	                ' Some teams priced or produced too low relative to customer demand and what these customers are willing to pay. This is likely due to poor coordination between operations function (production) and marketing function, which set\u2019s product pricing in the sim. ',
	                _react2.default.createElement(
	                  'a',
	                  { href: '/instructor/performance-feedback/revenues/products-selling-price?round=' + activeRound },
	                  'Learn more'
	                ),
	                '.'
	              ),
	              hasAwareness && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Awareness:'
	                ),
	                ' Some teams are underinvesting in awareness, possibly overlooking guidance in the business case. Review the Awareness page in Team Reports to compare against competitors. if low, consider increasing promotional spend. ',
	                _react2.default.createElement(
	                  'a',
	                  { href: '/instructor/performance-feedback/market-share/product-promotion?round=' + activeRound },
	                  'Learn more'
	                ),
	                '.'
	              ),
	              hasMarketShareNetRevenuesTargets && hasMarketShareOrRevenueFail && hasNoRevenueIssues && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Market Mix Challenges:'
	                ),
	                ' Some teams marketing mix may be hindering their performance. They should review the Marketing Analysis within their Team Report to compare their product\u2019s features, pricing, and awareness with the top teams in their competition.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            FeedbackBlock,
	            null,
	            _react2.default.createElement(
	              FeedbackBlockTitle,
	              null,
	              'Feedback on Generating Profits'
	            ),
	            _react2.default.createElement(
	              FeedbackBlockList,
	              null,
	              hasNegativeGrossMargins && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Negative Margins:'
	                ),
	                ' Some teams have set their product\u2019s selling price below its production cost\u2014perhaps assuming this is a nonprofit game or making decisions in silos. Their Marketing team (which sets the price) and Operations team (which manages cost) should coordinate more closely (',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/instructor/performance-feedback/gross-margins/running-non-profit?round=' + activeRound },
	                  'learn more'
	                ),
	                ').'
	              ),
	              hasGrossMarginFail && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Low Gross Margins:'
	                ),
	                ' Some teams\u2019 margins are falling short of their gross margin targets. These teams should take a closer look at how their product\u2019s selling price and manufacturing costs affect overall profitability (',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/instructor/performance-feedback/gross-margins/selling-price-too-low?round=' + activeRound },
	                  'learn more'
	                ),
	                ').'
	              ),
	              hasAutoOrMobileOverproduced && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Overproduced:'
	                ),
	                ' Some teams have overproduced, resulting in unsold inventory that incurs a holding cost of approximately ',
	                staticConstants.holding_rate && staticConstants.holding_rate.toLocaleString('en-US', { style: 'percent' }),
	                '. ',
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Note:'
	                ),
	                ' a leading product within a segment (e.g., mobile) typically captures around 15% of that market. Producing beyond this level may lead to excess inventory.'
	              ),
	              hasHighInterest && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'High interest:'
	                ),
	                ' Some teams have outstanding loans with interest charges exceeding 25% of their total revenues. These teams may struggle to achieve profitability and should consider repaying a portion of their loans.'
	              ),
	              hasRoeRoaEps && hasRoeRoaEpsFail && hasNoGrossMarginIssuesOrOverproducedOrHighInterest && _react2.default.createElement(
	                FeedbackBlockListItem,
	                null,
	                _react2.default.createElement(
	                  FeedbackBlockBold,
	                  null,
	                  'Profit Challenges:'
	                ),
	                ' Some teams are not generating enough revenue to cover expenses. This may be because their marketing mix doesn\u2019t align with customer preferences and demand or is not as appealing as competitors.'
	              )
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      });
	    }
	  }]);
	
	  return WhyTargetsWerentHit;
	}(_react.PureComponent);
	
	exports.default = WhyTargetsWerentHit;

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsufficientCapital = function (_PureComponent) {
	  _inherits(InsufficientCapital, _PureComponent);
	
	  function InsufficientCapital(props) {
	    _classCallCheck(this, InsufficientCapital);
	
	    var _this = _possibleConstructorReturn(this, (InsufficientCapital.__proto__ || Object.getPrototypeOf(InsufficientCapital)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Insufficient capital";
	        }).teams;
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.getRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/page/financials/?round_number=' + activeRound + '&team_id=' + team_id]).then(function (res) {
	          var teamFinancialsEndingCash = res.body.team.ending_cash;
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            teamFinancialsEndingCash: teamFinancialsEndingCash
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      teamFinancialsEndingCash: 0
	    };
	    return _this;
	  }
	
	  _createClass(InsufficientCapital, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          teamFinancialsEndingCash = _state.teamFinancialsEndingCash;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Share Price',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams did not have sufficient capital to successfully post decisions.',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Note:'
	          ),
	          ' Some teams might have a positive cash balance. However, the positive cash balance was not enough to cover their product, marketing, and/or operation expenses.'
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#4CC7D1', color: 'rgba(0, 27, 59, 0.94)' },
	            'Insufficient Capital'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '40px', isNegative: teamFinancialsEndingCash < 0 },
	            teamFinancialsEndingCash.toLocaleString('en-US', {
	              style: 'currency',
	              currency: 'USD',
	              maximumFractionDigits: 0
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#D7F0F2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return InsufficientCapital;
	}(_react.PureComponent);
	
	exports.default = InsufficientCapital;

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _utils = __webpack_require__(72);
	
	var _ui = __webpack_require__(88);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep2 = function (_PureComponent) {
	  _inherits(MarketShareStep2, _PureComponent);
	
	  function MarketShareStep2(props) {
	    _classCallCheck(this, MarketShareStep2);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep2.__proto__ || Object.getPrototypeOf(MarketShareStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	
	        var teamsPriceRangeFailed = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Price range failed";
	        }).teams;
	        var didNotSubmit = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Did not submit";
	        });
	        var insufficientCapital = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Insufficient capital";
	        });
	
	        var teamsToShowIds = [];
	        if (didNotSubmit || insufficientCapital) {
	          var teamsDidNotSubmit = didNotSubmit ? didNotSubmit.teams : [];
	          var teamsInsufficientCapital = insufficientCapital ? insufficientCapital.teams : [];
	          teamsToShowIds = teamsPriceRangeFailed.filter(function (teamPriceRangeFailed) {
	            return !teamsDidNotSubmit.includes(teamPriceRangeFailed) && !teamsInsufficientCapital.includes(teamPriceRangeFailed);
	          });
	        } else {
	          teamsToShowIds = teamsPriceRangeFailed;
	        }
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_number=' + activeRound + '&team_id=' + team_id, ("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound + '&team_id=' + team_id]).then(function (res) {
	          var products = res[0].body;
	
	          var productsFiltered = products.filter(function (i) {
	            return Number(i.round) === roundId;
	          });
	
	          var priceForecasts = res[1].body;
	
	          var productsWithForecast = productsFiltered.map(function (productFiltered) {
	            var priceForecast = priceForecasts.find(function (priceForecast) {
	              return priceForecast.product === productFiltered.id;
	            });
	            return {
	              name: productFiltered.name,
	              pixels_rank: productFiltered.pixels_rank,
	              sensitivity_rank: productFiltered.sensitivity_rank,
	              power_rank: productFiltered.power_rank,
	              temp_range_rank: productFiltered.temp_range_rank,
	              price: priceForecast ? priceForecast.price : 0
	            };
	          });
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            products: productsWithForecast
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          products = _state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Market share',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams set at least one of their products\u2019 selling prices outside of what the customer is willing to pay',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'These teams should review the Customer Analysis page to ensure that their marketing mix is aligned with customers\u2019 preferences.'
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.Table,
	            null,
	            _react2.default.createElement(
	              _ui.Row,
	              { background: '#2a4169' },
	              _react2.default.createElement(_ui.Cell, { color: '#ffffff' }),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Price'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Resolution'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Sensitivity'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Power'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Temp Range'
	              )
	            ),
	            products.map(function (product, index) {
	              return _react2.default.createElement(
	                _ui.Row,
	                { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	                _react2.default.createElement(
	                  _ui.Cell,
	                  {
	                    color: 'rgba(0, 27, 59, 0.94)',
	                    background: (0, _PerformanceFeedback.getProductNameColor)(index),
	                    align: 'left'
	                  },
	                  product.name
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.price.toLocaleString('en-US', {
	                    style: 'currency',
	                    currency: 'USD',
	                    maximumFractionDigits: 2
	                  })
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.pixels_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.sensitivity_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.power_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.temp_range_rank
	                )
	              );
	            })
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep2;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep2;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _utils = __webpack_require__(72);
	
	var _ui = __webpack_require__(88);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep3 = function (_PureComponent) {
	  _inherits(MarketShareStep3, _PureComponent);
	
	  function MarketShareStep3(props) {
	    _classCallCheck(this, MarketShareStep3);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep3.__proto__ || Object.getPrototypeOf(MarketShareStep3)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Minimum requirement failed";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_number=' + activeRound + '&team_id=' + team_id).then(function (res) {
	          var products = res.body;
	
	          var productsFiltered = products.filter(function (i) {
	            return Number(i.round) === roundId;
	          });
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            products: productsFiltered
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          products = _state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Market share',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams created a product that no customers wanted',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Real World Article'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Like in the real world, it\u2019s important to understand the customer before developing the product. These teams decided otherwise and created products without considering customer preferences.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In their round feedback, these teams were advised to review the ',
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Customer Analysis'
	            ),
	            ' to re-evaluate customer preferences.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To investigate, you can click on any one of the team names and cross reference their product\u2019s feature with customers\u2019 minimum requirements.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.Table,
	            null,
	            _react2.default.createElement(
	              _ui.Row,
	              { background: '#2a4169' },
	              _react2.default.createElement(_ui.Cell, { color: '#ffffff' }),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Resolution'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Sensitivity'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Power'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Temp Range'
	              )
	            ),
	            products.map(function (product, index) {
	              return _react2.default.createElement(
	                _ui.Row,
	                { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                  product.name
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.pixels_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.sensitivity_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.power_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.temp_range_rank
	                )
	              );
	            })
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep3;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep3;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _utils = __webpack_require__(72);
	
	var _ui = __webpack_require__(88);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep4 = function (_PureComponent) {
	  _inherits(MarketShareStep4, _PureComponent);
	
	  function MarketShareStep4(props) {
	    _classCallCheck(this, MarketShareStep4);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep4.__proto__ || Object.getPrototypeOf(MarketShareStep4)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Product market fit";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_number=' + activeRound + '&team_id=' + team_id).then(function (res) {
	          var products = res.body;
	
	          var productsFiltered = products.filter(function (i) {
	            return Number(i.round) === roundId;
	          });
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            products: productsFiltered
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep4, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          products = _state.products;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Market share',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams developed a product that met the interest of a few customers with a much smaller demand size',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Real World Article'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Pursuing a smaller demand size makes it challenging for teams to hit their market share target since 1) other teams are likely competing for the same opportunity and 2) customers, in this game, prefer to buy from multiple vendors to reduce concentration risks.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In their round feedback, these teams were advised to 1) review the ',
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Customer Analysis'
	            ),
	            ' to ensure their product features\u2019 attract a larger demand size and 2) consider upgrading their products to go after a larger opportunity.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.Table,
	            null,
	            _react2.default.createElement(
	              _ui.Row,
	              { background: '#2a4169' },
	              _react2.default.createElement(_ui.Cell, { color: '#ffffff' }),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Resolution'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Sensitivity'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Power'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Temp Range'
	              )
	            ),
	            products.map(function (product, index) {
	              return _react2.default.createElement(
	                _ui.Row,
	                { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                  product.name
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.pixels_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.sensitivity_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.power_rank
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  product.temp_range_rank
	                )
	              );
	            })
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep4;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep4;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(53);
	
	var _utils2 = __webpack_require__(72);
	
	var _iconTableHelp = __webpack_require__(121);
	
	var _iconTableHelp2 = _interopRequireDefault(_iconTableHelp);
	
	var _verticalBar = __webpack_require__(397);
	
	var _verticalBar2 = _interopRequireDefault(_verticalBar);
	
	var _ui = __webpack_require__(88);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _Teams = __webpack_require__(10);
	
	var _Teams2 = _interopRequireDefault(_Teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep5 = function (_PureComponent) {
	  _inherits(MarketShareStep5, _PureComponent);
	
	  function MarketShareStep5(props) {
	    _classCallCheck(this, MarketShareStep5);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep5.__proto__ || Object.getPrototypeOf(MarketShareStep5)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundId = round ? round.id : 0;
	
	      Promise.all([(0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()), (0, _MetricsService.fetchCompetitionMetrics)(null, roundId)]).then(function (res) {
	        var metricsReports = res[1];
	
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Awareness";
	        }).teams.filter(_utils2.arrayUniqueFilter);
	
	        var teams = res[0].body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        var competition_id = metricsReports.find(function (i) {
	          return i.team === team_id;
	        }).competition;
	
	        var metricsreportsWithCompetitionId = metricsReports.filter(function (i) {
	          return i.competition === competition_id;
	        });
	        var data = (0, _utils.pickPercent)(teams, metricsreportsWithCompetitionId, 'product_awareness');
	
	        _this.setState({
	          loaded: true,
	          teamsToShow: teamsToShow,
	          selectedTeamId: Number(team_id),
	          allTeamsCount: teams.length,
	          data: data
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep5, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          data = _state.data;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      var customColors = _Teams2.default.competitiveColors(data);
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Market share',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams could improve their product promotion.',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'The chart shows each team\'s product awareness this round. Teams get flagged when their awareness is in the bottom two, or at least 30% below the top team. That signals the product isn\'t reaching enough customers. The Business Case has general spend guidance; Team Reports \u2192 Marketing Analysis shows how each team\'s spend, and their competitors\', actually landed.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Note:'
	            ),
	            ' product awareness declines by 25% each round if teams do not invest in promotions.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils2.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.ChartWrapper,
	            null,
	            _react2.default.createElement(
	              _ui.ChartTitle,
	              null,
	              'Product Awareness',
	              _react2.default.createElement('img', { alt: 'Product Awareness icon help', src: _iconTableHelp2.default })
	            ),
	            _react2.default.createElement(
	              _ui.ChartData,
	              null,
	              _react2.default.createElement(_verticalBar2.default, {
	                data: data,
	                prefix: "",
	                suffix: "%",
	                precision: 2,
	                customColors: customColors,
	                showCategoryLabels: false,
	                instructorData: null
	              })
	            )
	          )
	        )
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep5;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep5;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _pf = __webpack_require__(1064);
	
	var _pf2 = _interopRequireDefault(_pf);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep6 = function (_PureComponent) {
	  _inherits(MarketShareStep6, _PureComponent);
	
	  function MarketShareStep6(props) {
	    _classCallCheck(this, MarketShareStep6);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep6.__proto__ || Object.getPrototypeOf(MarketShareStep6)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var performanceFeedbacksGame = _this.props.performanceFeedbacksGame;
	
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Place";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        _this.setState({
	          loaded: true,
	          teamsToShow: teamsToShow,
	          selectedTeamId: Number(team_id),
	          allTeamsCount: teams.length
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep6, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Market share',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams are selecting less optimal sales channels',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'These teams are choosing sub-optimal sales channels. This, however, could be part of their strategy.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In this game, teams have to choose between selling directly to customers or through a 3rd party distributor. The 3rd party distribution channel makes sense if a team is targeting the few customers that account for only 10% of overall demand (Customer 1, 7,8, and 14). If these are the only customers that the below teams are targeting, then they\u2019ll have a challenge in hitting their market share target and possibly their revenue target.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement('img', { src: _pf2.default, alt: 'Direct vs. Indirect Channels' })
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep6;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep6;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _recharts = __webpack_require__(27);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep7 = function (_PureComponent) {
	  _inherits(MarketShareStep7, _PureComponent);
	
	  function MarketShareStep7(props) {
	    _classCallCheck(this, MarketShareStep7);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep7.__proto__ || Object.getPrototypeOf(MarketShareStep7)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      totalUnitsSold: 0,
	      otherTeamsUnitsSold: 0,
	      otherTeamsUnitsSoldPercent: 0,
	      teamUnits: 0,
	      teamUnitsPercent: 0
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep7, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'numberWithCommas',
	    value: function numberWithCommas(x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          otherTeamsUnitsSold = _state.otherTeamsUnitsSold,
	          otherTeamsUnitsSoldPercent = _state.otherTeamsUnitsSoldPercent,
	          teamUnits = _state.teamUnits,
	          teamUnitsPercent = _state.teamUnitsPercent;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Market share',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams had insufficient capacity.',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'These teams did not produce enough inventory to hit their market share target and this could be due to either Ops not understanding how production impacts market share capture and/or how creating a higher quality product or selecting the cheapest machines impact production capacity.'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'The higher the product\u2019s quality, the longer the design release date,  the less time available in the year to manufacture the products.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Cheaper machines are less productive.'
	            )
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: '100%', height: 320 },
	          _react2.default.createElement(
	            _recharts.PieChart,
	            null,
	            _react2.default.createElement(
	              _recharts.Pie,
	              {
	                data: [{ name: 'Units sold (other teams)', originalValue: otherTeamsUnitsSold, value: otherTeamsUnitsSoldPercent }, { name: 'Team\'s units available for sale', originalValue: teamUnits, value: teamUnitsPercent }],
	                cx: '50%',
	                cy: '50%',
	                innerRadius: 60,
	                outerRadius: 90,
	                fill: '#8884d8',
	                dataKey: 'value',
	                label: this.renderLabel,
	                labelLine: false,
	                startAngle: 90,
	                endAngle: 450
	              },
	              '$',
	              ['#52c5cd', '#f9c151'].map(function (color, index) {
	                return _react2.default.createElement(_recharts.Cell, { key: 'pie-cell-' + index, fill: color });
	              })
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep7;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.renderLabel = function (props) {
	    var cx = props.cx,
	        cy = props.cy,
	        midAngle = props.midAngle,
	        outerRadius = props.outerRadius,
	        value = props.value,
	        name = props.name,
	        index = props.index,
	        payload = props.payload;
	    var originalValue = payload.originalValue;
	    var totalUnitsSold = _this3.state.totalUnitsSold;
	
	    var RADIAN = Math.PI / 180;
	    var sin = Math.sin(-RADIAN * midAngle);
	    var cos = Math.cos(-RADIAN * midAngle);
	    var sx = cx + (outerRadius + 10) * cos;
	    var sy = cy + (outerRadius + 10) * sin;
	    var mx = cx + (outerRadius + 30) * cos;
	    var my = cy + (outerRadius + 30) * sin;
	    var ex = mx + (cos >= 0 ? 1 : -1) * 35;
	    var ey = my;
	    var textAnchor = cos >= 0 ? 'start' : 'end';
	
	    return _react2.default.createElement(
	      'g',
	      null,
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: 0,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        'Total Units'
	      ),
	      index === 0 && _react2.default.createElement(
	        'text',
	        {
	          x: cx,
	          y: cy,
	          dy: 20,
	          textAnchor: 'middle',
	          className: 'chartCenterLabel'
	        },
	        Number((totalUnitsSold / 1000000).toFixed(2)),
	        'M'
	      ),
	      _react2.default.createElement('path', { d: 'M' + sx + ',' + sy + 'L' + mx + ',' + my + 'L' + ex + ',' + ey, stroke: 'rgba(0, 27, 59, 0.94)', fill: 'none' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: -10,
	          textAnchor: textAnchor,
	          className: 'chartLabel'
	        },
	        value + '%'
	      ),
	      _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: 10,
	          textAnchor: textAnchor,
	          className: 'chartDescription1'
	        },
	        _this3.numberWithCommas(originalValue)
	      ),
	      _react2.default.createElement(
	        'text',
	        {
	          x: ex + (cos >= 0 ? 1 : -1) * 20,
	          y: ey,
	          dy: 32,
	          textAnchor: textAnchor,
	          className: 'chartDescription2'
	        },
	        name
	      )
	    );
	  };
	
	  this.fetchData = function () {
	    _this3.setState({
	      loaded: false
	    });
	
	    var _props = _this3.props,
	        activeRound = _props.activeRound,
	        rounds = _props.rounds,
	        performanceFeedbacksGame = _props.performanceFeedbacksGame;
	
	
	    (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	      var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	        return i.type === "Low inventory";
	      }).teams.filter(_utils.arrayUniqueFilter);
	
	      var teams = res.body;
	      var teamsToShow = teams.filter(function (i) {
	        return teamsToShowIds.includes(i.id);
	      });
	
	      var temporaryId = _Auth2.default.getTeamId();
	      var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundId = round ? round.id : 0;
	
	      Promise.all([(0, _MetricsService.fetchCompetitionMetrics)(null, roundId), (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound + '&team_id=' + team_id)]).then(function (res) {
	        var metrics = res[0];
	
	        var competition_id = metrics.find(function (i) {
	          return i.team === team_id;
	        }).competition;
	
	        var metricsreportsWithCompetitionId = metrics.filter(function (i) {
	          return i.competition === competition_id;
	        });
	        var totalUnitsSold = metricsreportsWithCompetitionId.map(function (i) {
	          return Math.abs(Number(i['units_sold'] || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var otherTeamsUnitsSold = metricsreportsWithCompetitionId.filter(function (i) {
	          return Number(i.team) !== team_id;
	        }).map(function (i) {
	          return Math.abs(Number(i['units_sold'] || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	        var inventoryBalances = res[1].body;
	        var teamUnits = inventoryBalances.map(function (i) {
	          return Math.abs(Number(i.available_for_sale || 0));
	        }).reduce(function (prev, curr) {
	          return prev + curr;
	        }, 0);
	
	        var otherTeamsUnitsSoldPercent = otherTeamsUnitsSold || teamUnits ? Number((otherTeamsUnitsSold / (otherTeamsUnitsSold + teamUnits) * 100).toFixed(2)) : 0;
	        var teamUnitsPercent = Number((100 - otherTeamsUnitsSoldPercent).toFixed(2));
	
	        _this3.setState({
	          loaded: true,
	          teamsToShow: teamsToShow,
	          selectedTeamId: Number(team_id),
	          allTeamsCount: teams.length,
	          totalUnitsSold: totalUnitsSold,
	          otherTeamsUnitsSold: otherTeamsUnitsSold,
	          otherTeamsUnitsSoldPercent: otherTeamsUnitsSoldPercent,
	          teamUnits: teamUnits,
	          teamUnitsPercent: teamUnitsPercent
	        });
	      }).catch(function (err) {});
	    }).catch(function (err) {});
	  };
	};
	
	exports.default = MarketShareStep7;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _table = __webpack_require__(608);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketShareStep9 = function (_PureComponent) {
	  _inherits(MarketShareStep9, _PureComponent);
	
	  function MarketShareStep9(props) {
	    _classCallCheck(this, MarketShareStep9);
	
	    var _this = _possibleConstructorReturn(this, (MarketShareStep9.__proto__ || Object.getPrototypeOf(MarketShareStep9)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsMobileOverproduced = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Mobile overproduced";
	        });
	
	        var teamsAutoOverproduced = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Auto overproduced";
	        });
	
	        var teamsToShowIds = [];
	        if (teamsMobileOverproduced && teamsMobileOverproduced.teams || teamsAutoOverproduced && teamsAutoOverproduced.teams) {
	          teamsToShowIds = [].concat(_toConsumableArray(teamsMobileOverproduced && teamsMobileOverproduced.teams ? teamsMobileOverproduced.teams : []), _toConsumableArray(teamsAutoOverproduced && teamsAutoOverproduced.teams ? teamsAutoOverproduced.teams : []));
	        }
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/reports/performancefeedbacks/?round_number=' + activeRound + '&team=' + team_id).then(function (res) {
	          var reportsPerformanceFeedback = res.body;
	          var tableData = [];
	
	          var hasMobileOverproduced = reportsPerformanceFeedback.results.some(function (item) {
	            return item.type === "Mobile overproduced";
	          });
	          var hasAutoOverproduced = reportsPerformanceFeedback.results.some(function (item) {
	            return item.type === "Auto overproduced";
	          });
	
	          if (hasMobileOverproduced) {
	            var mobileData = reportsPerformanceFeedback.results.find(function (item) {
	              return item.type === "Mobile overproduced";
	            });
	            tableData.push(mobileData);
	          }
	
	          if (hasAutoOverproduced) {
	            var autoData = reportsPerformanceFeedback.results.find(function (item) {
	              return item.type === "Auto overproduced";
	            });
	            tableData.push(autoData);
	          }
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            tableData: tableData
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      tableData: []
	    };
	    return _this;
	  }
	
	  _createClass(MarketShareStep9, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var previousShownErrors = this.props.previousShownErrors;
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          tableData = _state.tableData;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'FEEDBACK',
	        subSection: 'MARKET SHARE',
	        previousShownErrors: previousShownErrors,
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams inventory levels are high!',
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              'Customers prefer lower concentration risk:'
	            ),
	            ' They prefer to limit how many units they\u2019ll purchase from 1 single seller. Therefore teams shouldn\u2019t expect to capture more than ',
	            _react2.default.createElement(
	              'b',
	              null,
	              '15% of a customer segment (e.g. mobile or auto)'
	            ),
	            '. However if there are irrational players in their competition, it\u2019s possible to capture more than 20%.'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              'Note:'
	            ),
	            ' When deciding on production, teams should factor in the overall demand from their target customers, taking into account concentration risk limits.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _table.Table,
	          null,
	          _react2.default.createElement(
	            _table.Row,
	            { background: '#2a4169' },
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Segments'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Available Inventory'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Customer Demand'
	            ),
	            _react2.default.createElement(
	              _table.Cell,
	              { color: '#ffffff' },
	              'Inventory %',
	              _react2.default.createElement('br', null),
	              ' of Demand'
	            )
	          ),
	          tableData.map(function (item, index) {
	            var parsedItemMessage = JSON.parse(item.message);
	
	            var availableForSale = parsedItemMessage.available_for_sale;
	            var demand = parsedItemMessage.demand;
	            var segment = parsedItemMessage.segment;
	            var inventoryPercentageOfDemand = availableForSale / demand;
	            return _react2.default.createElement(
	              _table.Row,
	              { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                segment
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                availableForSale.toLocaleString()
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                demand.toLocaleString()
	              ),
	              _react2.default.createElement(
	                _table.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                (inventoryPercentageOfDemand * 100).toFixed(2),
	                '%'
	              )
	            );
	          })
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return MarketShareStep9;
	}(_react.PureComponent);
	
	exports.default = MarketShareStep9;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _utils = __webpack_require__(72);
	
	var _instructorSuccessfulTeams = __webpack_require__(1058);
	
	var _instructorSuccessfulTeams2 = _interopRequireDefault(_instructorSuccessfulTeams);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NetLoss = function (_PureComponent) {
	  _inherits(NetLoss, _PureComponent);
	
	  function NetLoss(props) {
	    _classCallCheck(this, NetLoss);
	
	    var _this = _possibleConstructorReturn(this, (NetLoss.__proto__ || Object.getPrototypeOf(NetLoss)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var performanceFeedbacksGame = _this.props.performanceFeedbacksGame;
	
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Negative profits";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	
	        _this.setState({
	          loaded: true,
	          teamsToShowCount: teamsToShowIds.length,
	          allTeamsCount: teams.length
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShowCount: 0,
	      allTeamsCount: 0
	    };
	    return _this;
	  }
	
	  _createClass(NetLoss, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShowCount = _state.teamsToShowCount,
	          allTeamsCount = _state.allTeamsCount;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Net Loss',
	        alertText: teamsToShowCount + ' out of ' + allTeamsCount + ' teams didn\u2019t make a profit',
	        previousShownErrors: previousShownErrors,
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          'These teams incurred expenses that exceeded their revenues, As a result, they were unable to hit any of the profitability targets (e.g. ROE, ROA, or EPS).'
	        ),
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Common reasons why teams were unable to make a profit:'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Revenue Challenges:'
	            ),
	            ' A mix of marketing mix and/or capacity challenges might have led to lower revenues (e.g. lower ranking products, less productive machines).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Operating Margin Challenges:'
	            ),
	            ' There\u2019s likely margin compression due to teams upgrading to higher quality products and at the same  time dropping their selling prices.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'High Financing Costs:'
	            ),
	            ' Some teams took on a lot of debt in the earlier rounds and are unable to repay. They are feeling the impact now as a result of the metrics shifting to profit driven metrics.'
	          )
	        ),
	        visual: _react2.default.createElement('img', { src: _instructorSuccessfulTeams2.default, alt: 'Income Statement' }),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#D7F0F2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return NetLoss;
	}(_react.PureComponent);
	
	exports.default = NetLoss;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _PerformanceFeedback = __webpack_require__(77);
	
	var _ui = __webpack_require__(88);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevenuesStep2 = function (_PureComponent) {
	  _inherits(RevenuesStep2, _PureComponent);
	
	  function RevenuesStep2(props) {
	    _classCallCheck(this, RevenuesStep2);
	
	    var _this = _possibleConstructorReturn(this, (RevenuesStep2.__proto__ || Object.getPrototypeOf(RevenuesStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Expected revenue low";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/products/?round_number=' + activeRound + '&team_id=' + team_id, ("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound + '&team_id=' + team_id, ("https://be-production-itb.marketgames.io/api/") + 'team/inventory_balances/?round_number=' + activeRound + '&team_id=' + team_id]).then(function (res) {
	          var products = res[0].body;
	          var productsFiltered = products.filter(function (i) {
	            return Number(i.round) === roundId;
	          });
	
	          var priceForecasts = res[1].body;
	          var inventoryBalances = res[2].body;
	
	          var totalRevenues = 0;
	
	          var _loop = function _loop(i) {
	            var priceForecast = priceForecasts.find(function (j) {
	              return j.product === productsFiltered[i].id;
	            });
	            var inventoryBalance = inventoryBalances.find(function (j) {
	              return j.product === productsFiltered[i].id;
	            });
	            productsFiltered[i].selling_price = priceForecast ? Number(priceForecast.price || 0) : 0;
	            productsFiltered[i].available_for_sale = inventoryBalance ? Number(inventoryBalance.available_for_sale || 0) : 0;
	            productsFiltered[i].total_revenues = Math.round(productsFiltered[i].selling_price * productsFiltered[i].available_for_sale);
	            totalRevenues += productsFiltered[i].total_revenues;
	          };
	
	          for (var i = 0; i <= productsFiltered.length - 1; i++) {
	            _loop(i);
	          }
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            products: productsFiltered,
	            totalRevenues: totalRevenues
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      products: [],
	      totalRevenues: 0
	    };
	    return _this;
	  }
	
	  _createClass(RevenuesStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'numberWithCommas',
	    value: function numberWithCommas(x) {
	      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          products = _state.products,
	          totalRevenues = _state.totalRevenues;
	      var _props = this.props,
	          previousShownErrors = _props.previousShownErrors,
	          gamesTargets = _props.gamesTargets;
	
	
	      var netRevenues = Number(gamesTargets[0].net_revenues || 0);
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Revenues',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams set their product\u2019s selling price and/or units available for sale too low to hit their revenue target',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Cross-functional/coordination issues might exist with these teams since their product\u2019s selling price (set by Marketing) and the units available for sale (set by Operations) resulted in an expected sales value that was lower than the revenue target of ',
	            _react2.default.createElement(
	              'b',
	              null,
	              '$',
	              Number((netRevenues / 1000000).toFixed(2)),
	              'M'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In their round feedback, these teams were advised to consider the revenue target when making pricing and production decisions.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.Table,
	            null,
	            _react2.default.createElement(
	              _ui.Row,
	              { background: '#2a4169' },
	              _react2.default.createElement(_ui.Cell, { color: '#ffffff' }),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Selling Price'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Available for Sale Inventory'
	              ),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: '#ffffff' },
	                'Total Revenues'
	              )
	            ),
	            products.map(function (product, index) {
	              return _react2.default.createElement(
	                _ui.Row,
	                { background: (0, _PerformanceFeedback.getProductRowColor)(index), key: index },
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', background: (0, _PerformanceFeedback.getProductNameColor)(index) },
	                  product.name
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  '$',
	                  product.selling_price.toFixed(2)
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  _this2.numberWithCommas(product.available_for_sale)
	                ),
	                _react2.default.createElement(
	                  _ui.Cell,
	                  { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                  '$',
	                  _this2.numberWithCommas(product.total_revenues)
	                )
	              );
	            }),
	            _react2.default.createElement(
	              _ui.Row,
	              null,
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)' },
	                'Total Revenues'
	              ),
	              _react2.default.createElement(_ui.Cell, null),
	              _react2.default.createElement(_ui.Cell, null),
	              _react2.default.createElement(
	                _ui.Cell,
	                { color: 'rgba(0, 27, 59, 0.94)', fontWeight: '500' },
	                '$',
	                this.numberWithCommas(totalRevenues)
	              )
	            )
	          )
	        ),
	        visualProps: {
	          noBorder: true,
	          noBackground: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RevenuesStep2;
	}(_react.PureComponent);
	
	exports.default = RevenuesStep2;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n  text-align: center;\n  margin-bottom: 10px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n  text-align: center;\n  margin-bottom: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 35px;\n  background: #52c5cd;\n  position: relative;\n'], ['\n  width: 100%;\n  height: 35px;\n  background: #52c5cd;\n  position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 35px;\n  background: #00274c;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 35px;\n  background: #00274c;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 12.5px;\n  ', '\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background: #ff5252;\n  text-align: center;\n  span {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 12px;\n    color: rgba(0, 27, 59, 0.94);\n    position: relative;\n    top: 22px;\n    ', '\n  }\n'], ['\n  position: absolute;\n  top: 12.5px;\n  ', '\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background: #ff5252;\n  text-align: center;\n  span {\n    font-family: \'Mukta Vaani\';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 12px;\n    color: rgba(0, 27, 59, 0.94);\n    position: relative;\n    top: 22px;\n    ', '\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  position: absolute;\n  bottom: -28px;\n  ', '\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  position: absolute;\n  bottom: -28px;\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Row = _styledComponents2.default.div(_templateObject);
	
	var Label = _styledComponents2.default.div(_templateObject2);
	
	var Line = _styledComponents2.default.div(_templateObject3);
	
	var InnerLine = _styledComponents2.default.div(_templateObject4);
	
	var RedDot = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.left && '\n    left: ' + p.left + ';\n  ';
	}, function (p) {
	  return p.cw && '\n      left: ' + p.cw + 'px;\n    ';
	});
	
	var XAxisLabel = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.left && '\n    left: ' + p.left + ';\n  ';
	});
	
	var RevenuesStep3 = function (_PureComponent) {
	  _inherits(RevenuesStep3, _PureComponent);
	
	  function RevenuesStep3(props) {
	    _classCallCheck(this, RevenuesStep3);
	
	    var _this = _possibleConstructorReturn(this, (RevenuesStep3.__proto__ || Object.getPrototypeOf(RevenuesStep3)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Expected revenue low";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'team/price_forecasts/?round_number=' + activeRound + '&team_id=' + team_id).then(function (res) {
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            prices: res.body.map(function (i) {
	              return Number(i.price);
	            }).filter(function (i) {
	              return i > 0;
	            })
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      prices: []
	    };
	    return _this;
	  }
	
	  _createClass(RevenuesStep3, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'convertPriceToPosition',
	    value: function convertPriceToPosition(price) {
	      if (price >= 12) {
	        return (Math.floor(price) - 12) / 0.46 + 50 + '%';
	      }
	
	      return (Math.floor(price) - 2) * 5 + '%';
	    }
	  }, {
	    key: 'convertPriceToCW',
	    value: function convertPriceToCW(price) {
	      return (('' + price).replace(/[^0-9]/, '').length + 1) / 2 * -5;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          prices = _state.prices;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Revenues',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams set their product\u2019s selling price and/or units available for sale too low to hit their revenue target',
	        subTitle: 'Pricing',
	        previousShownErrors: previousShownErrors,
	        paragraph1: _react2.default.createElement(
	          'p',
	          null,
	          'Let\u2019s explore pricing. Here\u2019s the price range of what customers are willing to pay in relation to the prices that this specific team set for their product(s).'
	        ),
	        paragraph2: _react2.default.createElement(
	          'p',
	          null,
	          'In their round feedback, these teams were advised to consider the revenue target when making pricing and production decisions.'
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            Row,
	            null,
	            _react2.default.createElement(
	              Label,
	              null,
	              'Mobile'
	            ),
	            _react2.default.createElement(
	              Label,
	              null,
	              'Auto'
	            )
	          ),
	          _react2.default.createElement(
	            Row,
	            null,
	            _react2.default.createElement(
	              Line,
	              null,
	              _react2.default.createElement(InnerLine, null),
	              prices.map(function (price, index) {
	                return _react2.default.createElement(
	                  RedDot,
	                  { key: 'red-dot-' + index, left: _this2.convertPriceToPosition(price), cw: _this2.convertPriceToCW(price) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '$',
	                    price
	                  )
	                );
	              }),
	              _react2.default.createElement(
	                XAxisLabel,
	                { left: '-10px' },
	                '$2'
	              ),
	              _react2.default.createElement(
	                XAxisLabel,
	                { left: 'calc(50% - 15px)' },
	                '$12'
	              ),
	              _react2.default.createElement(
	                XAxisLabel,
	                { left: 'calc(100% - 20px)' },
	                '$35'
	              )
	            )
	          )
	        ),
	        visualProps: {
	          flexCenter: true,
	          flexDirection: 'column',
	          noPadding: true
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return RevenuesStep3;
	}(_react.PureComponent);
	
	exports.default = RevenuesStep3;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROAStep2 = function (_PureComponent) {
	  _inherits(ROAStep2, _PureComponent);
	
	  function ROAStep2(props) {
	    _classCallCheck(this, ROAStep2);
	
	    var _this = _possibleConstructorReturn(this, (ROAStep2.__proto__ || Object.getPrototypeOf(ROAStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          gamesTargets = _this$props.gamesTargets,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	      var prevRound = rounds.find(function (i) {
	        return i.number === activeRound - 1;
	      });
	      var prevRoundId = prevRound ? prevRound.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Roa fail";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/report/balance_sheet/?round_lte=' + activeRound + '&team_id=' + team_id, ("https://be-production-itb.marketgames.io/api/") + 'team/report/income_statement/?round_number=' + activeRound + '&team_id=' + team_id]).then(function (res) {
	          var balanceSheet = res[0].body;
	          var currentRoundBalanceSheet = balanceSheet.find(function (i) {
	            return i.round === roundId;
	          });
	          var prevRoundBalanceSheet = balanceSheet.find(function (i) {
	            return i.round === prevRoundId;
	          });
	
	          var totalAssets = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Assets'] || 0) : 0;
	          if (prevRoundBalanceSheet) {
	            var prevTotalAssets = Number(prevRoundBalanceSheet['Total Assets'] || 0);
	            totalAssets = (totalAssets + prevTotalAssets) / 2;
	          }
	
	          var incomeStatement = res[1].body;
	          var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	            return i.round === roundId;
	          });
	          var netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;
	
	          var roaTarget = Number(gamesTargets[0].roa || 0);
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            averageTotalAssets: totalAssets * roaTarget,
	            totalAssets: totalAssets,
	            netIncome: netIncome
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      averageTotalAssets: 0,
	      totalAssets: 0,
	      netIncome: 0
	    };
	    return _this;
	  }
	
	  _createClass(ROAStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          averageTotalAssets = _state.averageTotalAssets,
	          totalAssets = _state.totalAssets,
	          netIncome = _state.netIncome;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'ROA',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams did not generate enough profits',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Given your average total assets, your company needed to generate ',
	            (0, _utils.formatMillionsValue)(averageTotalAssets),
	            ' in net profits in order to hit your ROA target.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Common reasons why teams are unable to maximize profits:'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Revenue Challenges:'
	            ),
	            ' A mix of marketing mix and/or capacity challenges might have led to lower revenues (e.g. lower ranking products, less productive machines).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Operating Margin Challenges:'
	            ),
	            ' There\u2019s likely margin compression since selling prices do not change, but costs are likely rising from round to round as teams upgrade their products to be more competitive. Those who updgraded their products.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'High Financing Costs:'
	            ),
	            ' Some teams took on a lot of debt in the earlier rounds and are unable to repay. They are feeling the impact now as a result of the metrics shifting to profit driven metrics.'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#5c91f5' },
	            'Return on Assets',
	            _react2.default.createElement('br', null),
	            '(ROA)'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Net Profits',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Total Assets'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: netIncome,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: totalAssets,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#E6EDFB',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ROAStep2;
	}(_react.PureComponent);
	
	exports.default = ROAStep2;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROEStep2 = function (_PureComponent) {
	  _inherits(ROEStep2, _PureComponent);
	
	  function ROEStep2(props) {
	    _classCallCheck(this, ROEStep2);
	
	    var _this = _possibleConstructorReturn(this, (ROEStep2.__proto__ || Object.getPrototypeOf(ROEStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          rounds = _this$props.rounds,
	          gamesTargets = _this$props.gamesTargets,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	      var round = rounds.find(function (i) {
	        return i.number === activeRound;
	      });
	      var roundId = round ? round.id : 0;
	      var prevRound = rounds.find(function (i) {
	        return i.number === activeRound - 1;
	      });
	      var prevRoundId = prevRound ? prevRound.id : 0;
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Roe fail";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'team/report/balance_sheet/?round_lte=' + activeRound + '&team_id=' + team_id, ("https://be-production-itb.marketgames.io/api/") + 'team/report/income_statement/?round_number=' + activeRound + '&team_id=' + team_id]).then(function (res) {
	          var balanceSheet = res[0].body;
	          var currentRoundBalanceSheet = balanceSheet.find(function (i) {
	            return i.round === roundId;
	          });
	          var prevRoundBalanceSheet = balanceSheet.find(function (i) {
	            return i.round === prevRoundId;
	          });
	
	          var totalEquity = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Equity'] || 0) : 0;
	          if (prevRoundBalanceSheet) {
	            var prevTotalEquity = Number(prevRoundBalanceSheet['Total Equity'] || 0);
	            totalEquity = (totalEquity + prevTotalEquity) / 2;
	          }
	
	          var incomeStatement = res[1].body;
	          var currentRoundIncomeStatement = incomeStatement.find(function (i) {
	            return i.round === roundId;
	          });
	          var netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;
	
	          var roeTarget = Number(gamesTargets[0].roe || 0);
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            averageTotalEquity: totalEquity * roeTarget,
	            totalEquity: totalEquity,
	            netIncome: netIncome
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      averageTotalEquity: 0,
	      totalEquity: 0,
	      netIncome: 0
	    };
	    return _this;
	  }
	
	  _createClass(ROEStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          averageTotalEquity = _state.averageTotalEquity,
	          totalEquity = _state.totalEquity,
	          netIncome = _state.netIncome;
	      var previousShownErrors = this.props.previousShownErrors;
	
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'ROE',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams did not generate enough profits',
	        previousShownErrors: previousShownErrors,
	        paragraph2: totalEquity > 0 ? [_react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'Given this team\u2019s average total equity, their team needed to generate ',
	            (0, _utils.formatMillionsValue)(averageTotalEquity),
	            ' in net profits in order to hit the ROE target.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Common reasons why teams are unable to maximize profits:'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Revenue Challenges:'
	            ),
	            ' A mix of marketing mix and/or capacity challenges might have led to lower revenues (e.g. lower ranking products, less productive machines).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Operating Margin Challenges:'
	            ),
	            ' There\u2019s likely margin compression since selling prices do not change, but costs are likely rising from round to round as teams upgrade their products to be more competitive. Those who updgraded their products.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'High Financing Costs:'
	            ),
	            ' Some teams took on a lot of debt in the earlier rounds and are unable to repay. They are feeling the impact now as a result of the metrics shifting to profit driven metrics.'
	          )
	        )] : [],
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#a98df6' },
	            'Return on Equity',
	            _react2.default.createElement('br', null),
	            '(ROE)'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Net Profits',
	            _react2.default.createElement('span', { className: 'divider' }),
	            'Average Total Equity'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: netIncome,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: totalEquity,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#EAE4F9',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return ROEStep2;
	}(_react.PureComponent);
	
	exports.default = ROEStep2;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _MetricsService = __webpack_require__(62);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _utils = __webpack_require__(72);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _AbbreviatedMillionNumberFormat = __webpack_require__(43);
	
	var _AbbreviatedMillionNumberFormat2 = _interopRequireDefault(_AbbreviatedMillionNumberFormat);
	
	var _ui = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharePriceStep2 = function (_PureComponent) {
	  _inherits(SharePriceStep2, _PureComponent);
	
	  function SharePriceStep2(props) {
	    _classCallCheck(this, SharePriceStep2);
	
	    var _this = _possibleConstructorReturn(this, (SharePriceStep2.__proto__ || Object.getPrototypeOf(SharePriceStep2)).call(this, props));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      var _this$props = _this.props,
	          activeRound = _this$props.activeRound,
	          roundId = _this$props.roundId,
	          performanceFeedbacksGame = _this$props.performanceFeedbacksGame;
	
	
	      (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()).then(function (res) {
	        var teamsToShowIds = performanceFeedbacksGame.find(function (i) {
	          return i.type === "Share price fail";
	        }).teams.filter(_utils.arrayUniqueFilter);
	
	        var teams = res.body;
	        var teamsToShow = teams.filter(function (i) {
	          return teamsToShowIds.includes(i.id);
	        });
	
	        var temporaryId = _Auth2.default.getTeamId();
	        var team_id = teamsToShowIds.includes(temporaryId) ? temporaryId : teamsToShowIds[0];
	
	        (0, _MetricsService.fetchTeamMetrics)(team_id, roundId).then(function (metrics) {
	          var currentRoundMetrics = metrics.find(function (i) {
	            return Number(i.round_number) === Number(activeRound);
	          });
	
	          var marketValue = currentRoundMetrics ? Number(currentRoundMetrics.market_value || 0) : 0;
	          var shares = currentRoundMetrics ? Number(currentRoundMetrics.shares || 0) : 0;
	          var sharePrice = currentRoundMetrics ? Number(currentRoundMetrics.share_price || 0) : 0;
	
	          _this.setState({
	            loaded: true,
	            teamsToShow: teamsToShow,
	            selectedTeamId: Number(team_id),
	            allTeamsCount: teams.length,
	            marketValue: marketValue,
	            sharePrice: sharePrice,
	            shares: shares
	          });
	        }).catch(function (err) {});
	      }).catch(function (err) {});
	    };
	
	    _this.state = {
	      loaded: false,
	      teamsToShow: [],
	      selectedTeamId: 0,
	      allTeamsCount: 0,
	      marketValue: 0,
	      sharePrice: 0,
	      shares: 0
	    };
	    return _this;
	  }
	
	  _createClass(SharePriceStep2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamsToShow = _state.teamsToShow,
	          selectedTeamId = _state.selectedTeamId,
	          allTeamsCount = _state.allTeamsCount,
	          marketValue = _state.marketValue,
	          sharePrice = _state.sharePrice,
	          shares = _state.shares;
	      var _props = this.props,
	          previousShownErrors = _props.previousShownErrors,
	          gamesTargets = _props.gamesTargets,
	          activeRound = _props.activeRound;
	
	      var currentRoundTargets = gamesTargets.find(function (roundTargets) {
	        return Number(roundTargets.round_number) === Number(activeRound);
	      });
	      var targetStockPrice = currentRoundTargets.stock_price;
	
	      return loaded ? _react2.default.createElement(_banner2.default, {
	        section: 'Why Targets Weren\u2019t Hit',
	        subSection: 'Share Price',
	        alertText: teamsToShow.length + ' out of ' + allTeamsCount + ' teams did not generate enough revenues',
	        previousShownErrors: previousShownErrors,
	        paragraph2: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'This team\u2019s share price is $',
	            sharePrice.toFixed(2),
	            ', falling short of the $',
	            targetStockPrice.toFixed(2),
	            ' target.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'In round 1 & 2, business valuation is driven by revenues (i.e. ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.investopedia.com/terms/p/price-to-salesratio.asp', target: '_blank', rel: 'noreferrer' },
	              'price to sales ratio'
	            ),
	            '). Therefore higher revenues should drive a higher valuation and hopefully a higher share price.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Note:'
	            ),
	            ' In round 3 and beyond, business valuation will be driven by profits (i.e. price to earnings ratio).'
	          )
	        ),
	        selectorOptions: teamsToShow,
	        selectorSelectedOptionId: selectedTeamId,
	        onSelectorChange: function onSelectorChange(value) {
	          return (0, _utils.handleSelectChange)(value, _this2.fetchData);
	        },
	        visual: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          _react2.default.createElement(
	            _ui.FormulaName,
	            { background: '#4CC7D1', color: 'rgba(0, 27, 59, 0.94)' },
	            'Share Price'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Business Value',
	            _react2.default.createElement('span', { className: 'divider' }),
	            '* Shares'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            'Revenues X 2.5',
	            _react2.default.createElement('span', { className: 'divider' }),
	            '* Shares'
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            { fontSize: '28px' },
	            '='
	          ),
	          _react2.default.createElement(
	            _ui.FormulaValue,
	            null,
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: marketValue,
	              prefix: '$',
	              negativeClass: 'negative-value',
	              floatCount: 2
	            }),
	            _react2.default.createElement('span', { className: 'divider' }),
	            _react2.default.createElement(_AbbreviatedMillionNumberFormat2.default, {
	              value: shares,
	              negativeClass: 'negative-value',
	              floatCount: 2
	            })
	          )
	        ),
	        visualProps: {
	          borderColor: '#D5D9DD',
	          background: '#D7F0F2',
	          flexCenter: true,
	          gap: '16px'
	        }
	      }) : _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true });
	    }
	  }]);
	
	  return SharePriceStep2;
	}(_react.PureComponent);
	
	exports.default = SharePriceStep2;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"], ["\n  .modal-dialog {\n    width: 1077px !important;\n    max-width: 95% !important;\n  }\n\n  .modal-content {\n    border-radius: 0 !important;\n    padding: 0 !important;\n    width: 100% !important;\n    max-height: 730px !important;\n    max-height: 95% !important;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding-bottom: 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  padding: 10px 40px 25px !important;\n"], ["\n  padding: 10px 40px 25px !important;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 36px;\n  line-height: 44px;\n  color: #bdbdbd;\n  width: 100%;\n\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"], ["\n  font-family: Lato;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000;\n  margin-top: 15px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 46px;\n  line-height: 56px;\n  color: #333333;\n  padding-right: 20px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 25px;\n  color: #bdbdbd;\n  margin-bottom: 10px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 10px auto 0;\n  max-width: 300px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  padding: 0 !important;\n  height: 75px !important;\n  position: relative;\n"], ["\n  padding: 0 !important;\n  height: 75px !important;\n  position: relative;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 25px;\n  right: 35px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"], ["\n  position: absolute;\n  bottom: 25px;\n  right: 35px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"], ["\n  border-bottom: 0.25px solid #828282;\n  padding-bottom: 20px;\n  margin-top: 35px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"], ["\n  margin-top: 25px;\n  border-top: 0.25px solid #828282;\n  padding-top: 16px;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"], ["\n  width: 85px;\n  height: 85px;\n  background: rgba(82, 197, 205, 0.25);\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 44px;\n  color: #000;\n  text-align: center;\n  line-height: 85px;\n  flex: 0 0 85px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"], ["\n  padding-left: 16px;\n  font-family: Lato;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n  display: flex;\n  align-items: center;\n  height: 85px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  display: block;\n  height: 100%;\n  overflow-y: auto !important;\n"], ["\n  display: block;\n  height: 100%;\n  overflow-y: auto !important;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  max-width: 530px;\n"], ["\n  max-width: 530px;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 25px;\n  right: 195px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"], ["\n  position: absolute;\n  bottom: 25px;\n  right: 195px;\n  display: flex;\n  width: 145px;\n  height: 45px;\n  outline: none;\n  cursor: pointer;\n  background: #52c5cd;\n  border-radius: 4px;\n  font-family: Lato;\n  font-size: 16px;\n  color: #fbfbfb;\n  padding: 0 12px;\n  align-items: center;\n  justify-content: space-between;\n\n  .small {\n    font-size: 14px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(367);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Teams = __webpack_require__(10);
	
	var _recharts = __webpack_require__(27);
	
	var _index = __webpack_require__(306);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _chartViewMore = __webpack_require__(1437);
	
	var _chartViewMore2 = _interopRequireDefault(_chartViewMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ButtonsRow = _styledComponents2.default.div(_templateObject);
	
	var ModalWrapper = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject2);
	
	var ModalHeader = (0, _styledComponents2.default)(_reactBootstrap.Modal.Header)(_templateObject3);
	
	var ModalBody = (0, _styledComponents2.default)(_reactBootstrap.Modal.Body)(_templateObject4);
	
	var ModalTitle = _styledComponents2.default.div(_templateObject5, function (p) {
	  return p.align && "\n    text-align: " + p.align + ";\n  ";
	});
	
	var ModalQuestion = _styledComponents2.default.div(_templateObject6);
	
	var ModalFeedbackValue = _styledComponents2.default.div(_templateObject7);
	
	var RatingText = _styledComponents2.default.div(_templateObject8);
	
	var RatingRow = _styledComponents2.default.div(_templateObject9);
	
	var ModalFooter = (0, _styledComponents2.default)(_reactBootstrap.Modal.Footer)(_templateObject10);
	
	var ContinueButton = _styledComponents2.default.button(_templateObject11);
	
	var AnswerWrapper = _styledComponents2.default.div(_templateObject12);
	
	var AnswerRow = _styledComponents2.default.div(_templateObject13);
	
	var AnswerCounter = _styledComponents2.default.div(_templateObject14);
	
	var AnswerText = _styledComponents2.default.div(_templateObject15);
	
	var AnswerTextScrollable = _styledComponents2.default.div(_templateObject16);
	
	var BarChartWrapper = _styledComponents2.default.div(_templateObject17);
	
	var BackButton = _styledComponents2.default.button(_templateObject18);
	
	var getAllValues = function getAllValues(reports) {
	  return Object.values(reports).map(function (report) {
	    return [Number(report.average_user_score.toFixed(2)), Number(report.team_average_score.toFixed(2)), Number(report.team_median_score.toFixed(2))];
	  }).reduce(function (result, currentArray) {
	    return [].concat(_toConsumableArray(result), _toConsumableArray(currentArray));
	  }, []);
	};
	
	var MODAL_TYPE_INITIAL = 0;
	var MODAL_TYPE_POSITIVE = 1;
	var MODAL_TYPE_NEGATIVE = 2;
	var MODAL_TYPE_SELF_REFLECTION = 3;
	
	var Chart = function (_Component) {
	  _inherits(Chart, _Component);
	
	  function Chart(props) {
	    _classCallCheck(this, Chart);
	
	    var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, props));
	
	    _this.showModal = function (currentReport, stage) {
	      var surveys = _this.props.surveys;
	
	      var currentSurvey = surveys.find(function (survey) {
	        return survey.stage === stage;
	      });
	
	      _this.setState({
	        currentReport: currentReport,
	        currentSurvey: currentSurvey,
	        currentPage: 0,
	        currentType: MODAL_TYPE_INITIAL
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        currentReport: null,
	        currentSurvey: null
	      });
	    };
	
	    _this.getQuestions = function (currentType) {
	      var _this$state = _this.state,
	          currentReport = _this$state.currentReport,
	          currentSurvey = _this$state.currentSurvey;
	
	
	      if (!currentReport || !currentSurvey) {
	        return [];
	      }
	
	      var questions = [];
	      if (currentType === MODAL_TYPE_INITIAL) {
	        questions = currentReport.average_user_score_question;
	      } else if (currentType === MODAL_TYPE_POSITIVE) {
	        var ids = currentSurvey.questions.filter(function (question) {
	          return question.answer_type === "freeform" && question.category === "communication";
	        }).map(function (question) {
	          return question.id;
	        });
	        questions = currentReport.freeform_answers.filter(function (answer) {
	          return ids.includes(answer.survey_question);
	        });
	      } else if (currentType === MODAL_TYPE_NEGATIVE) {
	        var _ids = currentSurvey.questions.filter(function (question) {
	          return question.assessment_type === "negative" && question.category !== "self_assessment";
	        }).map(function (question) {
	          return question.id;
	        });
	        questions = currentReport.freeform_answers.filter(function (answer) {
	          return _ids.includes(answer.survey_question);
	        });
	      } else if (currentType === MODAL_TYPE_SELF_REFLECTION) {
	        var _ids2 = currentSurvey.questions.filter(function (question) {
	          return question.category === "self_assessment";
	        }).map(function (question) {
	          return question.id;
	        });
	        questions = currentReport.freeform_answers.filter(function (answer) {
	          return _ids2.includes(answer.survey_question);
	        });
	      }
	
	      var needSkip = currentSurvey.questions.filter(function (i) {
	        return i.most_valuable === true || i.work_together === true;
	      }).map(function (i) {
	        return i.id;
	      });
	
	      if (currentType !== MODAL_TYPE_INITIAL) {
	        questions = questions.filter(function (i) {
	          return !needSkip.includes(i.survey_question);
	        });
	      }
	
	      return _lodash2.default.chunk(questions, 4);
	    };
	
	    _this.nextPage = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          currentType = _this$state2.currentType;
	
	
	      if (currentPage < _this.questions.length - 1) {
	        _this.setState({
	          currentPage: currentPage + 1
	        });
	      } else if (currentType < 3) {
	        _this.setState({
	          currentPage: 0,
	          currentType: currentType + 1
	        });
	      }
	    };
	
	    _this.goBack = function () {
	      var _this$state3 = _this.state,
	          currentPage = _this$state3.currentPage,
	          currentType = _this$state3.currentType;
	
	
	      if (currentPage > 0) {
	        _this.setState({
	          currentPage: currentPage - 1
	        });
	      } else if (currentType > 0) {
	        var prevQuestions = _this.getQuestions(currentType - 1);
	
	        _this.setState({
	          currentPage: prevQuestions.length - 1,
	          currentType: currentType - 1
	        });
	      }
	    };
	
	    _this.state = {
	      currentSurvey: null,
	      currentReport: null,
	      currentPage: 0,
	      currentType: MODAL_TYPE_INITIAL
	    };
	    return _this;
	  }
	
	  _createClass(Chart, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _reactChartjs.Chart.Tooltip.positioners.custom = function (elements) {
	        if (!elements.length) {
	          return false;
	        }
	
	        var i = void 0,
	            len = void 0;
	        var y = 0;
	        var count = 0;
	        var nearestElement = void 0;
	
	        for (i = 0, len = elements.length; i < len; ++i) {
	          var el = elements[i];
	          if (el && el.hasValue()) {
	            if (!nearestElement) {
	              nearestElement = el;
	            }
	            var pos = el.tooltipPosition();
	            y += pos.y;
	            ++count;
	          }
	        }
	
	        var barOffset = nearestElement ? Math.round(nearestElement.getArea() / 45 + 20) : 0;
	
	        return {
	          x: barOffset + 40,
	          y: Math.round(y / count)
	        };
	      };
	
	      _reactChartjs.Chart.pluginService.register({
	        beforeRender: function beforeRender(chart) {
	          if (chart.config.options.showAllTooltips) {
	            chart.pluginTooltips = [];
	            chart.config.data.datasets.forEach(function (_, i) {
	              chart.getDatasetMeta(i).data.forEach(function (sector, j) {
	                chart.pluginTooltips.push(new _reactChartjs.Chart.Tooltip({
	                  _chart: chart.chart,
	                  _chartInstance: chart,
	                  _data: chart.data,
	                  _options: chart.options.tooltips,
	                  _active: [sector]
	                }, chart));
	              });
	            });
	
	            chart.options.tooltips.enabled = false;
	          }
	        },
	
	        afterDraw: function afterDraw(chart, easing) {
	          if (chart.config.options.showAllTooltips) {
	            if (!chart.allTooltipsOnce) {
	              if (easing !== 1) {
	                return;
	              }
	
	              chart.allTooltipsOnce = true;
	            }
	
	            chart.options.tooltips.enabled = true;
	            _reactChartjs.Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
	              tooltip.initialize();
	              tooltip.update();
	              tooltip.pivot();
	              tooltip.transition(easing).draw();
	            });
	            chart.options.tooltips.enabled = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          reports = _props.reports,
	          userScoreReports = _props.userScoreReports,
	          isSurveyFinished = _props.isSurveyFinished;
	      var _state = this.state,
	          currentReport = _state.currentReport,
	          currentPage = _state.currentPage,
	          currentType = _state.currentType;
	
	      var allValues = getAllValues(reports);
	      var isBarChart = Object.keys(reports).length === 1 ? true : false;
	      var options = {
	        legend: {
	          display: false
	        },
	        scales: {
	          xAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              min: 0,
	              max: Math.max.apply(null, allValues),
	              callback: function callback() {
	                return "";
	              }
	            }
	          }],
	          yAxes: [{
	            gridLines: {
	              display: false,
	              drawBorder: false
	            },
	            ticks: {
	              callbacks: function callbacks() {
	                return "";
	              }
	            }
	          }]
	        },
	        tooltips: {
	          enabled: true,
	          mode: "point",
	          position: "custom",
	          backgroundColor: "transparent",
	          bodyFontFamily: "Lato",
	          bodyFontSize: 16,
	          bodyFontStyle: "bold",
	          bodyFontColor: "#2a4169",
	          bodyAlign: "center",
	          displayColors: false,
	          xPadding: 0,
	          yPadding: 0,
	          bodySpacing: 0,
	          callbacks: {
	            title: function title() {
	              return "";
	            },
	            label: function label(tooltipItem) {
	              return (Math.round(tooltipItem.value * 100) / 100).toFixed(2);
	            }
	          }
	        },
	        showAllTooltips: true,
	        layout: {
	          padding: {
	            right: 40
	          }
	        }
	      };
	
	      var getReportForBar = function getReportForBar(key, label, backgroundColor) {
	        return {
	          label: label,
	          data: Object.values(Object.keys(reports).reduce(function (result, stage) {
	            return Object.assign({}, result, _defineProperty({}, stage, Number(reports[stage][key].toFixed(2))));
	          }, {})),
	          backgroundColor: backgroundColor,
	          borderWidth: 0,
	          minBarLength: 20,
	          barPercentage: 0.8,
	          maxBarThickness: 45
	        };
	      };
	
	      var data = {
	        labels: [""],
	        datasets: [getReportForBar("average_user_score", "You", this.currentTeamColor), getReportForBar("team_average_score", "Team Average", "#eee"), getReportForBar("team_median_score", "Team Median", "#c4c4c4")],
	        options: options
	      };
	      var surveys = this.props.surveys.filter(function (survey) {
	        return isSurveyFinished(survey);
	      });
	      var surveysStages = surveys.map(function (survey) {
	        return survey.stage;
	      });
	      if (surveysStages.length < 3) {
	        for (var i = 0; i < 3 - surveysStages.length; i++) {
	          surveysStages.push("");
	        }
	      }
	
	      var stages = {
	        initial: "Initial Feedback",
	        second: "Second Feedback",
	        final: "Final Feedback"
	      };
	      var tmpData = Object.keys(reports).map(function (stage) {
	        return {
	          name: stages[stage],
	          You: Number(reports[stage].average_user_score.toFixed(2)),
	          "Team Average": Number(reports[stage].team_average_score.toFixed(2)),
	          "Team Median": Number(reports[stage].team_median_score.toFixed(2))
	        };
	      });
	
	      var initial = tmpData.find(function (i) {
	        return i.name === "Initial Feedback";
	      });
	      if (!initial) {
	        initial = {
	          name: "Initial Feedback",
	          You: null,
	          "Team Average": null,
	          "Team Median": null
	        };
	      }
	
	      var second = tmpData.find(function (i) {
	        return i.name === "Second Feedback";
	      });
	
	      var final = tmpData.find(function (i) {
	        return i.name === "Final Feedback";
	      });
	
	      var chartData = [initial];
	      if (second) {
	        chartData.push(second);
	      }
	      if (final) {
	        chartData.push(final);
	      }
	      var isShowModal = currentReport ? true : false;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        !isBarChart && _react2.default.createElement(
	          _recharts.ResponsiveContainer,
	          { width: "100%", height: 300 },
	          _react2.default.createElement(
	            _recharts.LineChart,
	            {
	              data: chartData,
	              margin: {
	                top: 0,
	                right: 0,
	                left: 0,
	                bottom: 0
	              }
	            },
	            _react2.default.createElement(_recharts.Tooltip, null),
	            _react2.default.createElement(_recharts.XAxis, {
	              dataKey: "name",
	              padding: { top: 30, left: 30, right: 30, bottom: 30 },
	              hide: true
	            }),
	            _react2.default.createElement(_recharts.YAxis, {
	              hide: true,
	              domain: [Math.min.apply(null, allValues) * 0.9, Math.max.apply(null, allValues) * 1.1]
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "You",
	              stroke: this.currentTeamColor,
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2,
	              isAnimationActive: false
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Average",
	              stroke: "#eee",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2,
	              isAnimationActive: false
	            }),
	            _react2.default.createElement(_recharts.Line, {
	              type: "monotone",
	              dataKey: "Team Median",
	              stroke: "#c4c4c4",
	              dot: false,
	              activeDot: false,
	              label: {
	                fontFamily: "Lato",
	                fontSize: "16px",
	                fontWeight: "bold",
	                color: "#222"
	              },
	              strokeWidth: 2,
	              isAnimationActive: false
	            })
	          )
	        ),
	        isBarChart && _react2.default.createElement(
	          BarChartWrapper,
	          null,
	          _react2.default.createElement(_reactChartjs.HorizontalBar, { data: data, options: options })
	        ),
	        _react2.default.createElement(
	          ButtonsRow,
	          null,
	          surveys.map(function (survey, index) {
	            return _react2.default.createElement(_chartViewMore2.default, { key: index, survey: survey, reports: reports, userScoreReports: userScoreReports });
	          })
	        ),
	        isShowModal === true && _react2.default.createElement(
	          ModalWrapper,
	          { show: true, onHide: this.hideModal },
	          _react2.default.createElement(
	            ModalHeader,
	            { closeButton: true },
	            _react2.default.createElement(
	              ModalTitle,
	              { align: "left" },
	              this.modalTitle
	            ),
	            currentType === MODAL_TYPE_INITIAL && _react2.default.createElement(
	              ModalTitle,
	              { align: "right" },
	              "Collaboration"
	            )
	          ),
	          _react2.default.createElement(
	            ModalBody,
	            null,
	            currentType === MODAL_TYPE_INITIAL && this.questionsList.map(function (_ref, i) {
	              var question = _ref.question,
	                  rating = _ref.value;
	              return _react2.default.createElement(
	                "div",
	                { key: currentType + "-" + (currentPage * 4 + i + 1) },
	                _react2.default.createElement(
	                  ModalQuestion,
	                  null,
	                  currentPage * 4 + i + 1,
	                  ". ",
	                  question
	                ),
	                _react2.default.createElement(
	                  RatingRow,
	                  null,
	                  _react2.default.createElement(
	                    ModalFeedbackValue,
	                    null,
	                    Number(rating.toFixed(2))
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      RatingText,
	                      null,
	                      "Average Rating"
	                    ),
	                    _react2.default.createElement(_index2.default, { value: rating })
	                  )
	                )
	              );
	            }),
	            currentType !== MODAL_TYPE_INITIAL && _react2.default.createElement(
	              AnswerWrapper,
	              null,
	              this.questionsList.map(function (_ref2, i) {
	                var text = _ref2.text;
	                return _react2.default.createElement(
	                  AnswerRow,
	                  {
	                    key: currentType + "-" + (currentPage * 4 + i + 1)
	                  },
	                  _react2.default.createElement(
	                    AnswerCounter,
	                    null,
	                    currentPage * 4 + i + 1
	                  ),
	                  _react2.default.createElement(
	                    AnswerText,
	                    null,
	                    _react2.default.createElement(
	                      AnswerTextScrollable,
	                      null,
	                      text
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            ModalFooter,
	            null,
	            !this.isFirstPage && _react2.default.createElement(
	              BackButton,
	              { onClick: this.goBack },
	              _react2.default.createElement(
	                "span",
	                { className: "small" },
	                "\u25C0"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Back"
	              )
	            ),
	            _react2.default.createElement(
	              ContinueButton,
	              {
	                onClick: this.isLastPage ? this.hideModal : this.nextPage
	              },
	              _react2.default.createElement(
	                "span",
	                null,
	                this.isLastPage ? "Close" : "Continue"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "small" },
	                "\u25B6"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "questions",
	    get: function get() {
	      var currentType = this.state.currentType;
	
	
	      return this.getQuestions(currentType);
	    }
	  }, {
	    key: "questionsList",
	    get: function get() {
	      var currentPage = this.state.currentPage;
	      var _props2 = this.props,
	          userId = _props2.userId,
	          players = _props2.players,
	          currentTeam = _props2.currentTeam;
	
	      var questions = this.questions;
	      var result = currentPage < questions.length ? questions[currentPage] : [];
	      var teammates = players.filter(function (player) {
	        return player.team === currentTeam && player.user.id !== userId;
	      }).map(function (teammate) {
	        return teammate.user.username;
	      });
	
	      return result.filter(function (answer) {
	        return !teammates.includes(answer.text);
	      });
	    }
	  }, {
	    key: "isFirstPage",
	    get: function get() {
	      var _state2 = this.state,
	          currentPage = _state2.currentPage,
	          currentType = _state2.currentType;
	
	
	      return currentPage === 0 && currentType === MODAL_TYPE_INITIAL ? true : false;
	    }
	  }, {
	    key: "isLastPage",
	    get: function get() {
	      var _state3 = this.state,
	          currentPage = _state3.currentPage,
	          currentType = _state3.currentType;
	
	
	      if (currentPage === this.questions.length - 1) {
	        if (currentType < 3) {
	          var nextQuestions = this.getQuestions(currentType + 1);
	
	          if (nextQuestions.length === 0) {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "modalTitle",
	    get: function get() {
	      var _titles;
	
	      var currentType = this.state.currentType;
	
	      var titles = (_titles = {}, _defineProperty(_titles, MODAL_TYPE_INITIAL, "Initial Feedback"), _defineProperty(_titles, MODAL_TYPE_POSITIVE, "What You Did Well"), _defineProperty(_titles, MODAL_TYPE_NEGATIVE, "What You Can Improve"), _defineProperty(_titles, MODAL_TYPE_SELF_REFLECTION, "Self Reflection"), _titles);
	
	      return titles[currentType];
	    }
	  }, {
	    key: "currentTeamColor",
	    get: function get() {
	      var _props3 = this.props,
	          teams = _props3.teams,
	          currentTeam = _props3.currentTeam;
	
	      return (0, _Teams.colorForTeamId)(teams, currentTeam, _Teams.TEAM_COLORS) || _Teams.TEAM_COLORS[0];
	    }
	  }]);
	
	  return Chart;
	}(_react.Component);
	
	exports.default = Chart;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 10px;\n  font-family: 'Mukta Vaani';\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"], ["\n  width: 100%;\n  margin-top: 10px;\n  font-family: 'Mukta Vaani';\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 20px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  width: 100px;\n  flex-shrink: 0;\n"], ["\n  width: 100px;\n  flex-shrink: 0;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n  padding: 0 20px;\n"], ["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  flex: 1;\n  padding: 0 20px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  width: 80px;\n  text-align: center;\n  flex-shrink: 0;\n"], ["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  width: 80px;\n  text-align: center;\n  flex-shrink: 0;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  width: 100px;\n  text-align: center;\n  flex-shrink: 0;\n"], ["\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  width: 100px;\n  text-align: center;\n  flex-shrink: 0;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 78px;\n  flex-shrink: 0;\n"], ["\n  width: 78px;\n  flex-shrink: 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  width: 100px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n"], ["\n  width: 100px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  width: 84px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  &:focus {\n    outline: none;\n    border-color: #2196F3;\n  }\n\n  &:disabled {\n    background: #F5F6F7;\n    color: rgba(0, 27, 59, 0.38);\n  }\n"], ["\n  width: 84px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n\n  &:focus {\n    outline: none;\n    border-color: #2196F3;\n  }\n\n  &:disabled {\n    background: #F5F6F7;\n    color: rgba(0, 27, 59, 0.38);\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  width: 84px;\n  height: 32px;\n"], ["\n  width: 84px;\n  height: 32px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n"], ["\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.38);\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  flex: 1;\n\n  ", "\n"], ["\n  flex: 1;\n\n  ", "\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  margin-top: 4px;\n  font-size: 16px;\n  line-height: 20px;\n  color: #c74234;\n"], ["\n  margin-top: 4px;\n  font-size: 16px;\n  line-height: 20px;\n  color: #c74234;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  background: #F5F6F7;\n  border-radius: 4px;\n  padding: 6.5px 9.5px;\n  color: rgba(0, 27, 59, 0.38);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  pointer-events: none;\n  min-width: 78px;\n  flex-shrink: 0;\n\n  ", "\n  ", "\n"], ["\n  background: #F5F6F7;\n  border-radius: 4px;\n  padding: 6.5px 9.5px;\n  color: rgba(0, 27, 59, 0.38);\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  pointer-events: none;\n  min-width: 78px;\n  flex-shrink: 0;\n\n  ", "\n  ", "\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > .loader {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n\n    .loader-inner div {\n      width: 15px;\n      height: 15px;\n      border-color: #fff !important;\n    }\n  }\n"], ["\n  width: 100%;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > .loader {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n\n    .loader-inner div {\n      width: 15px;\n      height: 15px;\n      border-color: #fff !important;\n    }\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  width: 80px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  position: relative;\n"], ["\n  width: 80px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  position: relative;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 6px 10px;\n  border-radius: 4px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani';\n  font-size: 12px;\n  line-height: 1.4;\n  width: 200px;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 6px 10px;\n  border-radius: 4px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-family: 'Mukta Vaani';\n  font-size: 12px;\n  line-height: 1.4;\n  width: 200px;\n  text-align: center;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  cursor: ", ";\n  user-select: none;\n  opacity: ", ";\n"], ["\n  display: inline-block;\n  position: relative;\n  cursor: ", ";\n  user-select: none;\n  opacity: ", ";\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  background-color: #D5D9DD;\n  color: rgba(0, 27, 59, 0.6);\n  border-radius: 50px;\n  transition: background-color 0.3s, color 0.3s;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 17px;\n  width: 40px;\n  height: 16px;\n  padding: 0 5px;\n  box-sizing: border-box;\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    width: 14px;\n    height: 12px;\n    background: linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%);\n    border-radius: 50%;\n    transition: transform 0.3s;\n    box-shadow: -2px 1px 6px 0px rgba(0, 0, 0, 0.25);\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  background-color: #D5D9DD;\n  color: rgba(0, 27, 59, 0.6);\n  border-radius: 50px;\n  transition: background-color 0.3s, color 0.3s;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 17px;\n  width: 40px;\n  height: 16px;\n  padding: 0 5px;\n  box-sizing: border-box;\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    width: 14px;\n    height: 12px;\n    background: linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%);\n    border-radius: 50%;\n    transition: transform 0.3s;\n    box-shadow: -2px 1px 6px 0px rgba(0, 0, 0, 0.25);\n  }\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  display: none;\n\n  &:checked + ", " {\n    background-color: #2DA548;\n    color: #fff;\n    justify-content: flex-start;\n  }\n\n  &:checked + ", "::before {\n    transform: translateX(21px);\n  }\n"], ["\n  display: none;\n\n  &:checked + ", " {\n    background-color: #2DA548;\n    color: #fff;\n    justify-content: flex-start;\n  }\n\n  &:checked + ", "::before {\n    transform: translateX(21px);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _reactDatetime = __webpack_require__(368);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var HeaderRow = _styledComponents2.default.div(_templateObject2);
	
	var HeaderSpacer = _styledComponents2.default.div(_templateObject3);
	
	var HeaderLabel = _styledComponents2.default.span(_templateObject4);
	
	var HeaderShowResults = _styledComponents2.default.span(_templateObject5);
	
	var HeaderRoundWeight = _styledComponents2.default.span(_templateObject6);
	
	var HeaderUpdateSpacer = _styledComponents2.default.div(_templateObject7);
	
	var RoundWeightCell = _styledComponents2.default.div(_templateObject8);
	
	var RoundWeightInput = _styledComponents2.default.input(_templateObject9);
	
	var RoundWeightPlaceholder = _styledComponents2.default.div(_templateObject10);
	
	var Row = _styledComponents2.default.div(_templateObject2);
	
	var RoundNameCell = _styledComponents2.default.div(_templateObject3);
	
	var RoundName = _styledComponents2.default.span(_templateObject11);
	
	var RoundDateTimeCell = _styledComponents2.default.div(_templateObject12, function (p) {
	  return p.disabled && "\n    opacity: 0.4;\n    pointer-events: none;\n  ";
	});
	
	var StartGapWarning = _styledComponents2.default.div(_templateObject13);
	
	var RoundUpdateButton = _styledComponents2.default.button(_templateObject14, function (p) {
	  return p.isActive && "\n    background: #2196F3;\n    color: #fff;\n    pointer-events: auto;\n  ";
	}, function (p) {
	  return p.isActiveDefault && "\n    background: #FF5252;\n  ";
	});
	
	var ButtonLoader = _styledComponents2.default.div(_templateObject15);
	
	var RoundShowResultsCell = _styledComponents2.default.div(_templateObject16);
	
	var ShowResultsTooltip = _styledComponents2.default.div(_templateObject17);
	
	var ShowResultsHoverGroup = _styledComponents2.default.div(_templateObject18, ShowResultsTooltip);
	
	var RoundShowResultsLabel = _styledComponents2.default.label(_templateObject19, function (p) {
	  return p.disabled ? 'not-allowed' : 'pointer';
	}, function (p) {
	  return p.disabled ? 0.5 : 1;
	});
	
	var RoundShowResultsSlider = _styledComponents2.default.span(_templateObject20);
	
	var RoundShowResultsInput = _styledComponents2.default.input(_templateObject21, RoundShowResultsSlider, RoundShowResultsSlider);
	
	var TeamsRolesTable = function (_PureComponent) {
	  _inherits(TeamsRolesTable, _PureComponent);
	
	  function TeamsRolesTable(props) {
	    _classCallCheck(this, TeamsRolesTable);
	
	    var _this = _possibleConstructorReturn(this, (TeamsRolesTable.__proto__ || Object.getPrototypeOf(TeamsRolesTable)).call(this, props));
	
	    _this.state = {
	      defaultRounds: [1, 2, 3]
	    };
	    return _this;
	  }
	
	  _createClass(TeamsRolesTable, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          rounds = _props.rounds,
	          _onChange = _props.onChange,
	          onGradingWeightChange = _props.onGradingWeightChange,
	          changedRounds = _props.changedRounds,
	          onUpdate = _props.onUpdate,
	          loadingButtonRound = _props.loadingButtonRound,
	          defaultActiveRounds = _props.defaultActiveRounds,
	          onShowResultsChange = _props.onShowResultsChange,
	          isIAS = _props.isIAS;
	      var defaultRounds = this.state.defaultRounds;
	
	      return _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          HeaderRow,
	          null,
	          _react2.default.createElement(HeaderSpacer, null),
	          _react2.default.createElement(
	            HeaderLabel,
	            null,
	            "Start"
	          ),
	          _react2.default.createElement(
	            HeaderLabel,
	            null,
	            "End"
	          ),
	          _react2.default.createElement(
	            HeaderRoundWeight,
	            null,
	            "Round Weight"
	          ),
	          _react2.default.createElement(HeaderUpdateSpacer, null),
	          _react2.default.createElement(
	            HeaderShowResults,
	            null,
	            "Show Results?"
	          )
	        ),
	        rounds.map(function (round, index) {
	          var isActiveDefault = defaultActiveRounds.includes(round.id);
	          var isChanged = changedRounds.includes(round.id);
	
	          // IAS cannot edit any round field — treat them as disabled
	          // across start/end pickers, round weight, show-results toggle,
	          // and the Update button regardless of changedRounds state.
	          var isDisabled = round.disabled === true || isIAS;
	          var isUpdateButtonActive = !isDisabled && (isActiveDefault ? true : isChanged);
	          var isUpdateButtonLoading = loadingButtonRound === round.id;
	          var updateButtonText = isActiveDefault ? 'Activate' : isChanged ? 'Update' : 'Updated';
	
	          return _react2.default.createElement(
	            Row,
	            { key: index },
	            _react2.default.createElement(
	              RoundNameCell,
	              null,
	              _react2.default.createElement(
	                RoundName,
	                null,
	                round.displayName || "Round " + round.number
	              )
	            ),
	            _react2.default.createElement(
	              RoundDateTimeCell,
	              { disabled: isDisabled },
	              _react2.default.createElement(_reactDatetime2.default, {
	                dateFormat: "ddd, MMM DD YYYY,",
	                timeFormat: "hh:mm a",
	                inputProps: {
	                  placeholder: "Select Date & Time",
	                  className: "instructor-round-datetime-selector",
	                  disabled: isDisabled
	                },
	                value: round.start_date,
	                onChange: function onChange(dt) {
	                  if (!isDisabled) _onChange(dt, round.id, "start_date");
	                }
	              }),
	              round.startGapWarning && _react2.default.createElement(
	                StartGapWarning,
	                null,
	                round.startGapWarning
	              )
	            ),
	            _react2.default.createElement(
	              RoundDateTimeCell,
	              { disabled: isDisabled },
	              _react2.default.createElement(_reactDatetime2.default, {
	                dateFormat: "ddd, MMM DD YYYY,",
	                timeFormat: "hh:mm a",
	                inputProps: {
	                  placeholder: "Select Date & Time",
	                  className: "instructor-round-datetime-selector",
	                  disabled: isDisabled
	                },
	                value: round.end_date,
	                onChange: function onChange(dt) {
	                  if (!isDisabled) _onChange(dt, round.id, "end_date");
	                }
	              })
	            ),
	            _react2.default.createElement(
	              RoundWeightCell,
	              null,
	              round.displayName === 'Practice' ? _react2.default.createElement(RoundWeightPlaceholder, null) : _react2.default.createElement(RoundWeightInput, {
	                type: "number",
	                step: "0.0001",
	                min: "0",
	                max: "1",
	                value: round.grading_weight != null ? round.grading_weight : '',
	                placeholder: "0.3333",
	                disabled: isDisabled,
	                onChange: function onChange(e) {
	                  if (!isDisabled && onGradingWeightChange) {
	                    onGradingWeightChange(round.id, e.target.value);
	                  }
	                }
	              })
	            ),
	            _react2.default.createElement(
	              RoundUpdateButton,
	              {
	                isActive: isUpdateButtonActive,
	                isActiveDefault: isActiveDefault,
	                onClick: function onClick() {
	                  if (isDisabled) return;
	                  var testArray = [].concat(_toConsumableArray(defaultRounds));
	                  testArray.splice(round.id - 1, 1);
	                  _this2.setState({
	                    defaultRounds: testArray
	                  });
	                  onUpdate(round.id);
	                }
	              },
	              isUpdateButtonLoading && _react2.default.createElement(
	                ButtonLoader,
	                null,
	                _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	              ),
	              !isUpdateButtonLoading && _react2.default.createElement(
	                "span",
	                null,
	                updateButtonText
	              )
	            ),
	            _react2.default.createElement(
	              RoundShowResultsCell,
	              null,
	              _react2.default.createElement(
	                ShowResultsHoverGroup,
	                null,
	                _react2.default.createElement(
	                  RoundShowResultsLabel,
	                  { disabled: round.showResultsDisabled || isIAS },
	                  _react2.default.createElement(RoundShowResultsInput, {
	                    type: "checkbox",
	                    checked: round.showResults,
	                    disabled: round.showResultsDisabled || isIAS,
	                    onChange: function onChange(e) {
	                      if (round.showResultsDisabled || isIAS) return;
	                      onShowResultsChange(round.id);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    RoundShowResultsSlider,
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      round.showResults ? 'Yes' : 'No'
	                    )
	                  )
	                ),
	                round.showResultsDisabled && round.showResultsTooltip && _react2.default.createElement(
	                  ShowResultsTooltip,
	                  null,
	                  round.showResultsTooltip
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return TeamsRolesTable;
	}(_react.PureComponent);
	
	exports.default = TeamsRolesTable;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _reactDatetime = __webpack_require__(368);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	function RoundEdit(props) {
	  var round = props.round,
	      _onChange = props.onChange,
	      onUpdate = props.onUpdate;
	
	  console.log('round', round);
	  console.log('round.start_date', round.start_date);
	
	  return _react2.default.createElement(
	    "tr",
	    null,
	    _react2.default.createElement(
	      "td",
	      { className: "text-center v-align-middle instructor-round-number b-r" },
	      round.number
	    ),
	    _react2.default.createElement(
	      "td",
	      { className: "b-l b-r" },
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: "MM/DD/YYYY",
	        timeFormat: false,
	        inputProps: {
	          placeholder: "Date: MM/DD/YYYY",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.start_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, round.id, "start_date");
	        }
	      }),
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: false,
	        timeFormat: "hh:mm A",
	        inputProps: {
	          placeholder: "Time: HH:MM AM/PM",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.start_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, round.id, "start_date");
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "td",
	      { className: "b-l b-r" },
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: "MM/DD/YYYY",
	        timeFormat: false,
	        inputProps: {
	          placeholder: "Date: MM/DD/YYYY",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.end_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, round.id, "end_date");
	        }
	      }),
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: false,
	        timeFormat: "hh:mm A",
	        inputProps: {
	          placeholder: "Time: HH:MM AM/PM",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.end_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, round.id, "end_date");
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "td",
	      { className: "b-l" },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: "light-blue", onClick: function onClick() {
	            return onUpdate(round.id);
	          }, block: true },
	        "Update"
	      )
	    )
	  );
	}
	
	exports.default = RoundEdit;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _reactDatetime = __webpack_require__(368);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	function RoundNew(props) {
	  var round_number = props.round_number,
	      round = props.round,
	      _onChange = props.onChange,
	      onAdd = props.onAdd;
	
	
	  return _react2.default.createElement(
	    "tr",
	    null,
	    _react2.default.createElement(
	      "td",
	      { className: "text-center v-align-middle instructor-round-number b-r" },
	      round_number
	    ),
	    _react2.default.createElement(
	      "td",
	      { className: "b-l b-r" },
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: "MM/DD/YYYY",
	        timeFormat: false,
	        inputProps: {
	          placeholder: "Date: MM/DD/YYYY",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.start_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, "start_date");
	        }
	      }),
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: false,
	        timeFormat: "hh:mm A",
	        inputProps: {
	          placeholder: "Time: HH:MM AM/PM",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.start_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, "start_date");
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "td",
	      { className: "b-l b-r" },
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: "MM/DD/YYYY",
	        timeFormat: false,
	        inputProps: {
	          placeholder: "Date: MM/DD/YYYY",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.end_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, "end_date");
	        }
	      }),
	      _react2.default.createElement(_reactDatetime2.default, {
	        dateFormat: false,
	        timeFormat: "hh:mm A",
	        inputProps: {
	          placeholder: "Time: HH:MM AM/PM",
	          className: "form-control instructor-datetime-control"
	        },
	        value: round.end_date,
	        onChange: function onChange(dt) {
	          return _onChange(dt, "end_date");
	        }
	      })
	    ),
	    _react2.default.createElement(
	      "td",
	      { className: "b-l" },
	      _react2.default.createElement(
	        _reactBootstrap.Button,
	        { bsStyle: "light-blue", onClick: function onClick() {
	            return onAdd(round_number);
	          }, block: true },
	        "Add"
	      )
	    )
	  );
	}
	
	exports.default = RoundNew;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _ApiService = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STUDENT_ROLE = 1;
	
	var StudentCourseModal = function (_PureComponent) {
	  _inherits(StudentCourseModal, _PureComponent);
	
	  function StudentCourseModal(props) {
	    _classCallCheck(this, StudentCourseModal);
	
	    var _this = _possibleConstructorReturn(this, (StudentCourseModal.__proto__ || Object.getPrototypeOf(StudentCourseModal)).call(this, props));
	
	    _this.fetchCourseMembers = function () {
	      var course_id = _this.state.course_id;
	
	
	      if (course_id > 0) {
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "courses/" + course_id + "/members/").then(function (res) {
	          _this.setState({
	            course_members: res.body.filter(function (i) {
	              return i.type === STUDENT_ROLE;
	            })
	          });
	        }).catch(function (err) {});
	      } else {
	        _this.setState({
	          course_members: []
	        });
	      }
	    };
	
	    _this.fetchUsers = function () {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "users/").then(function (res) {
	        _this.setState({
	          users: res.body
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.getUserName = function (user_id) {
	      var users = _this.state.users;
	
	      var user = users.find(function (i) {
	        return i.id === user_id;
	      });
	
	      return user ? user.username : "";
	    };
	
	    _this.state = {
	      course_name: props.currentCourse ? props.currentCourse.name : "",
	      course_id: props.currentCourse ? props.currentCourse.id : 0,
	      course_members: [],
	      users: []
	    };
	    return _this;
	  }
	
	  _createClass(StudentCourseModal, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchCourseMembers();
	      this.fetchUsers();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var course_id = nextProps.currentCourse ? nextProps.currentCourse.id : 0;
	      var course_name = nextProps.currentCourse ? nextProps.currentCourse.name : "";
	
	      if (this.state.course_id !== course_id) {
	        this.setState({
	          course_name: course_name,
	          course_id: course_id
	        }, function () {
	          _this2.fetchCourseMembers();
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          show = _props.show,
	          onHide = _props.onHide;
	      var course_members = this.state.course_members;
	
	
	      return _react2.default.createElement(
	        _reactBootstrap.Modal,
	        { show: show, onHide: onHide },
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Header,
	          null,
	          _react2.default.createElement(
	            "h4",
	            { className: "modal-title title-light-blue" },
	            "Student List Popup"
	          )
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Modal.Body,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "tbody",
	                null,
	                course_members.map(function (course_member, index) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: index, className: "border-none instructor-modal-row" },
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      index + 1,
	                      ". ",
	                      _this3.getUserName(course_member.user)
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StudentCourseModal;
	}(_react.PureComponent);
	
	exports.default = StudentCourseModal;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.5) !important;\n\n  .modal-dialog {\n    width: 1077px !important;\n\n    .modal-content {\n      padding: 0 !important;\n      border-radius: 4px !important;\n      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;\n      border: none !important;\n    }\n  }\n"], ["\n  background: rgba(0, 0, 0, 0.5) !important;\n\n  .modal-dialog {\n    width: 1077px !important;\n\n    .modal-content {\n      padding: 0 !important;\n      border-radius: 4px !important;\n      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;\n      border: none !important;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 64px 40px 27px !important;\n  min-height: 250px;\n\n  .loader {\n    width: 100%;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 36px;\n        margin-bottom: -48px;\n        border-color: #2a4169;\n      }\n    }\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 64px 40px 27px !important;\n  min-height: 250px;\n\n  .loader {\n    width: 100%;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 36px;\n        margin-bottom: -48px;\n        border-color: #2a4169;\n      }\n    }\n  }\n\n  ", "\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 12px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 12px;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 36px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 36px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject6 = _taggedTemplateLiteral([""], [""]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  display: block;\n  width: 137px;\n  height: 32px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.94);\n  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);\n  border-radius: 4px;\n  text-align: center;\n  line-height: 32px;\n  padding: 0 25px 0 15px;\n\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n\n  cursor: pointer;\n  position: relative;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  display: block;\n  width: 137px;\n  height: 32px;\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.94);\n  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);\n  border-radius: 4px;\n  text-align: center;\n  line-height: 32px;\n  padding: 0 25px 0 15px;\n\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n\n  cursor: pointer;\n  position: relative;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n  padding-top: 4px;\n"], ["\n  position: absolute;\n  z-index: 2;\n  padding-top: 4px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 23px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 23px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.15);\n  flex-basis: 100%;\n  padding-bottom: 7px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(0, 27, 59, 0.15);\n  flex-basis: 100%;\n  padding-bottom: 7px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 20px;\n  flex-wrap: wrap;\n  flex-basis: 820px;\n  margin-top: 20px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 20px;\n  flex-wrap: wrap;\n  flex-basis: 820px;\n  margin-top: 20px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  width: 370px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n  padding: 20px;\n  flex-basis: 370px;\n\n  ", "\n\n  &:nth-child(odd) {\n    width: 430px;\n    flex-basis: 430px;\n  }\n\n  ", "\n"], ["\n  width: 370px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n  padding: 20px;\n  flex-basis: 370px;\n\n  ", "\n\n  &:nth-child(odd) {\n    width: 430px;\n    flex-basis: 430px;\n  }\n\n  ", "\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 10px;\n  display: inline-block;\n  white-space: nowrap;\n"], ["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 10px;\n  display: inline-block;\n  white-space: nowrap;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ", "\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  display: inline-block;\n  border: 1.5px solid #2A4169;\n  color: #2A4169;\n  padding: 1px 8px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 23px;\n  border-radius: 8px;\n  margin-right: 10px;\n  background: #fff;\n"], ["\n  display: inline-block;\n  border: 1.5px solid #2A4169;\n  color: #2A4169;\n  padding: 1px 8px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 23px;\n  border-radius: 8px;\n  margin-right: 10px;\n  background: #fff;\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: #001B3B;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 36px;\n"], ["\n  display: inline-block;\n  color: #001B3B;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 36px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', sans-serif;\n  color: #001B3B;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 36px;\n"], ["\n  font-family: 'Mukta Vaani', sans-serif;\n  color: #001B3B;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 36px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _dashboardSelect = __webpack_require__(407);
	
	var _dashboardSelect2 = _interopRequireDefault(_dashboardSelect);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _arrow = __webpack_require__(1838);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _studentStatsViewEvaluation = __webpack_require__(1513);
	
	var _studentStatsViewEvaluation2 = _interopRequireDefault(_studentStatsViewEvaluation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var EngagementModal = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject);
	
	var ModalBody = (0, _styledComponents2.default)(_reactBootstrap.Modal.Body)(_templateObject2, function (p) {
	  return p.evaluationVisible && "\n    height: 737px;\n  ";
	});
	
	var FullWidth = _styledComponents2.default.div(_templateObject3);
	
	var TitleRow = _styledComponents2.default.div(_templateObject4);
	
	var Title = _styledComponents2.default.div(_templateObject5);
	
	var DropDownContainer = _styledComponents2.default.div(_templateObject6);
	
	var DropDownHeader = _styledComponents2.default.div(_templateObject7);
	
	var DropDownListContainer = _styledComponents2.default.div(_templateObject8);
	
	var DropDownHeaderArrow = _styledComponents2.default.div(_templateObject9);
	
	var SubTitleRow = _styledComponents2.default.div(_templateObject10);
	
	var SubTitle = _styledComponents2.default.div(_templateObject11);
	
	var BlockWrapper = _styledComponents2.default.div(_templateObject12);
	
	var GreyBlock = _styledComponents2.default.div(_templateObject13, function (p) {
	  return p.isMinHeight && "\n    height: auto;\n    min-height: 120px;\n    padding-bottom: 20px;\n  ";
	}, function (p) {
	  return p.fullWidth && "\n    flex-basis: 100% !important;\n  ";
	});
	
	var GreyBlockTitle = _styledComponents2.default.span(_templateObject14);
	
	var GreyBlockRow = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.justify && "\n  justify-content: " + p.justify + ";\n  ";
	});
	
	var GreyBlockCell = _styledComponents2.default.div(_templateObject16);
	
	var GreyBlockLabel = _styledComponents2.default.span(_templateObject17);
	
	var GreyBlockValue = _styledComponents2.default.span(_templateObject18);
	
	var GreyBlockText = _styledComponents2.default.span(_templateObject19);
	
	var getPercentage = function getPercentage(value) {
	  return value > 0 ? (value * 100).toFixed(1) + "%" : "---";
	};
	
	var StudentStatsPopup = function (_PureComponent) {
	  _inherits(StudentStatsPopup, _PureComponent);
	
	  function StudentStatsPopup(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, StudentStatsPopup);
	
	    var _this = _possibleConstructorReturn(this, (StudentStatsPopup.__proto__ || Object.getPrototypeOf(StudentStatsPopup)).call(this, props));
	
	    _this.fetchPaginationData = function (url, dataField, pageSize, callback) {
	      _this.setState(_defineProperty({}, dataField, []));
	
	      (0, _ApiService.getRequest)("" + url + (url.indexOf('?') > 0 ? '&' : '?') + "page_size=1").then(function (res) {
	        var count = res.body.count;
	
	
	        if (count > 0) {
	          var pages = Math.ceil(count / pageSize);
	          var requests = [];
	
	          for (var i = 1; i <= pages; i++) {
	            requests.push("" + url + (url.indexOf('?') > 0 ? '&' : '?') + "page_size=" + pageSize + "&page=" + i);
	          }
	
	          (0, _ApiService.batchRequest)(requests).then(function (res) {
	            try {
	              var data = res.flatMap(function (payload) {
	                return payload.body.results;
	              });
	              _this.setState(_defineProperty({}, dataField, data), function () {
	                if (callback) {
	                  callback();
	                }
	              });
	            } catch (e) {
	              console.log(e);
	            }
	          }).catch(function (err) {});
	        } else if (callback) {
	          callback();
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.onSelectStudent = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(value) {
	        var students, _this$props, roundNumber, roundId, gameId, selectPlayer, student, userId, teamName, res, team, teamGradingsRaw, gamesUpgradeRaw, feedbackSubmissionScoresRaw, engagementRaw, res1, res2, res3, res4, teamScore, collaborationScore, feedbackSubmissionScores, userFeedbackSubmissionScores, evalSubmission, engagementUserScores, engagement;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                students = _this.state.students;
	                _this$props = _this.props, roundNumber = _this$props.roundNumber, roundId = _this$props.roundId, gameId = _this$props.gameId, selectPlayer = _this$props.selectPlayer;
	                student = students.find(function (i) {
	                  return i.user.first_name + " " + i.user.last_name === value;
	                });
	                userId = student.user.id ? student.user.id : 0;
	
	                selectPlayer(userId);
	
	                _this.setState({
	                  isFetching: true,
	                  selected: null
	                });
	
	                if (!student) {
	                  _context.next = 75;
	                  break;
	                }
	
	                teamName = null;
	                _context.prev = 8;
	                _context.next = 11;
	                return (0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)());
	
	              case 11:
	                res = _context.sent;
	                team = res.body.find(function (i) {
	                  return i.id === student.team;
	                });
	
	                if (team) {
	                  teamName = team.name;
	                }
	                _context.next = 19;
	                break;
	
	              case 16:
	                _context.prev = 16;
	                _context.t0 = _context["catch"](8);
	
	                console.log('Cannot get teams list', _context.t0);
	
	              case 19:
	                teamGradingsRaw = null;
	                gamesUpgradeRaw = null;
	                feedbackSubmissionScoresRaw = null;
	                engagementRaw = null;
	                res1 = null;
	                res2 = null;
	                res3 = null;
	                res4 = null;
	                _context.prev = 27;
	                _context.next = 30;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/teamgradings/?team=" + student.team + "&round=" + roundId);
	
	              case 30:
	                res1 = _context.sent;
	                _context.next = 36;
	                break;
	
	              case 33:
	                _context.prev = 33;
	                _context.t1 = _context["catch"](27);
	
	                console.log('Cannot get student stats [res1]', _context.t1);
	
	              case 36:
	                _context.prev = 36;
	                _context.next = 39;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/" + roundId + "/" + userId + "/");
	
	              case 39:
	                res2 = _context.sent;
	                _context.next = 45;
	                break;
	
	              case 42:
	                _context.prev = 42;
	                _context.t2 = _context["catch"](36);
	
	                console.log('Cannot get games usergrade [res2]', _context.t2);
	
	              case 45:
	                _context.prev = 45;
	                _context.next = 48;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/feedback-submission-scores/");
	
	              case 48:
	                res3 = _context.sent;
	                _context.next = 54;
	                break;
	
	              case 51:
	                _context.prev = 51;
	                _context.t3 = _context["catch"](45);
	
	                console.log('Cannot get feedback submission scores [res3]', _context.t3);
	
	              case 54:
	                _context.prev = 54;
	                _context.next = 57;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/engagement/engagementuserscores/?user=" + userId + "&game=" + gameId + "&round_number=" + roundNumber);
	
	              case 57:
	                res4 = _context.sent;
	                _context.next = 63;
	                break;
	
	              case 60:
	                _context.prev = 60;
	                _context.t4 = _context["catch"](54);
	
	                console.log('Cannot get engagementuserscores [res4]', _context.t4);
	
	              case 63:
	
	                teamGradingsRaw = res1 && res1.statusCode === 200 ? res1.body : null;
	                teamScore = teamGradingsRaw && teamGradingsRaw.results && teamGradingsRaw.results.length > 0 ? Number(teamGradingsRaw.results[0].weighted_value) : 0;
	
	
	                gamesUpgradeRaw = res2 && res2.statusCode === 200 ? res2.body : null;
	                collaborationScore = gamesUpgradeRaw && gamesUpgradeRaw.peer_adjustment_grade ? Number(gamesUpgradeRaw.peer_adjustment_grade) : 0;
	
	
	                feedbackSubmissionScoresRaw = res3 && res3.statusCode === 200 ? res3.body : null;
	                feedbackSubmissionScores = feedbackSubmissionScoresRaw ? feedbackSubmissionScoresRaw.results : [];
	                userFeedbackSubmissionScores = feedbackSubmissionScores.find(function (i) {
	                  return i.user === userId;
	                });
	                evalSubmission = userFeedbackSubmissionScores ? userFeedbackSubmissionScores.adjusted_score : 0;
	
	
	                engagementRaw = res4 && res4.statusCode === 200 ? res4.body : null;
	                engagementUserScores = engagementRaw ? engagementRaw.results : [];
	                engagement = engagementUserScores.length ? Number(engagementUserScores[0].overall_user_engagement) : 0;
	
	
	                _this.setState({
	                  selected: {
	                    fullname: student.user.first_name + " " + student.user.last_name,
	                    teamName: teamName,
	                    teamScore: teamScore,
	                    collaborationScore: collaborationScore,
	                    evalSubmission: evalSubmission,
	                    engagement: engagement,
	                    student: student
	                  },
	                  isFetching: false
	                });
	
	              case 75:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2, [[8, 16], [27, 33], [36, 42], [45, 51], [54, 60]]);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.formatNumber = function (value) {
	      return value ? Number((value * 100).toFixed(2)) + "%" : '---';
	    };
	
	    _this.setDropdownValue = function (callback) {
	      _this.setState({
	        setDropdownValueCallback: callback
	      }, function () {
	        var students = _this.studentsList;
	
	        if (callback && students && students.length > 0) {
	          callback(students[0]);
	        }
	      });
	    };
	
	    _this.onEvaluationShowToggle = function () {
	      var evaluationVisible = _this.state.evaluationVisible;
	
	      _this.setState({ evaluationVisible: !evaluationVisible });
	    };
	
	    _this.state = {
	      students: null,
	      selected: null,
	      isFetching: false,
	      setDropdownValueCallback: null,
	      evaluationVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(StudentStatsPopup, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var setLoadingState;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                setLoadingState = this.props.setLoadingState;
	
	
	                this.fetchPaginationData(("https://be-production-itb.marketgames.io/api/") + "v2/games/teamplayers/?game=" + _Auth2.default.getGameId(), 'students', 100, function () {
	                  var setDropdownValueCallback = _this3.state.setDropdownValueCallback;
	
	                  setLoadingState(false);
	
	                  var students = _this3.studentsList;
	                  if (setDropdownValueCallback && students && students.length > 0) {
	                    setDropdownValueCallback(students[0]);
	                  }
	                });
	
	              case 2:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          onHide = _props.onHide,
	          loading = _props.loading,
	          roundNumber = _props.roundNumber,
	          survey = _props.survey,
	          reports = _props.reports;
	      var _state = this.state,
	          students = _state.students,
	          selected = _state.selected,
	          isFetching = _state.isFetching,
	          evaluationVisible = _state.evaluationVisible;
	
	
	      var surveyName = survey ? survey.name : '';
	
	      return _react2.default.createElement(
	        EngagementModal,
	        {
	          show: show,
	          onHide: onHide,
	          backdropClassName: "transparent-backdrop"
	        },
	        _react2.default.createElement(
	          ModalBody,
	          { evaluationVisible: evaluationVisible },
	          loading === true && _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true }),
	          loading === false && _react2.default.createElement(
	            FullWidth,
	            null,
	            _react2.default.createElement(
	              TitleRow,
	              null,
	              selected && _react2.default.createElement(
	                Title,
	                null,
	                selected.fullname
	              ),
	              students && _react2.default.createElement(_dashboardSelect2.default, {
	                placeholder: "Select Student",
	                options: this.studentsList,
	                onChange: this.onSelectStudent,
	                DropDownContainer: DropDownContainer,
	                DropDownHeader: DropDownHeader,
	                DropDownListContainer: DropDownListContainer,
	                DropDownHeaderArrow: DropDownHeaderArrow,
	                ArrowIcon: _arrow2.default,
	                setValueCallback: this.setDropdownValue
	              })
	            ),
	            _react2.default.createElement(
	              SubTitleRow,
	              null,
	              !isFetching && selected && selected.teamName && _react2.default.createElement(
	                SubTitle,
	                null,
	                selected.teamName
	              ),
	              !isFetching && selected && roundNumber && surveyName && _react2.default.createElement(
	                SubTitle,
	                null,
	                "Round ",
	                roundNumber,
	                " / ",
	                surveyName
	              )
	            ),
	            (isFetching || !selected) && _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true }),
	            !isFetching && selected && _react2.default.createElement(
	              BlockWrapper,
	              null,
	              _react2.default.createElement(
	                GreyBlock,
	                { fullWidth: true },
	                _react2.default.createElement(
	                  GreyBlockTitle,
	                  null,
	                  "Scores"
	                ),
	                _react2.default.createElement(
	                  GreyBlockRow,
	                  null,
	                  _react2.default.createElement(
	                    GreyBlockCell,
	                    null,
	                    _react2.default.createElement(
	                      GreyBlockLabel,
	                      null,
	                      "Team"
	                    ),
	                    _react2.default.createElement(
	                      GreyBlockValue,
	                      null,
	                      getPercentage(selected.teamScore)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    GreyBlockCell,
	                    null,
	                    _react2.default.createElement(
	                      GreyBlockLabel,
	                      null,
	                      "Collaboration"
	                    ),
	                    _react2.default.createElement(
	                      GreyBlockValue,
	                      null,
	                      getPercentage(selected.collaborationScore)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    GreyBlockCell,
	                    null,
	                    _react2.default.createElement(
	                      GreyBlockLabel,
	                      null,
	                      "Eval Submission"
	                    ),
	                    _react2.default.createElement(
	                      GreyBlockValue,
	                      null,
	                      getPercentage(selected.evalSubmission)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    GreyBlockCell,
	                    null,
	                    _react2.default.createElement(
	                      GreyBlockLabel,
	                      null,
	                      "Engagement"
	                    ),
	                    _react2.default.createElement(
	                      GreyBlockValue,
	                      null,
	                      getPercentage(selected.engagement)
	                    )
	                  )
	                )
	              ),
	              survey && _react2.default.createElement(
	                GreyBlock,
	                { fullWidth: true },
	                _react2.default.createElement(
	                  GreyBlockRow,
	                  { justify: "flex-start" },
	                  _react2.default.createElement(
	                    GreyBlockTitle,
	                    null,
	                    "Teamwork Summary \xA0\xA0\xA0"
	                  ),
	                  _react2.default.createElement(_studentStatsViewEvaluation2.default, {
	                    survey: survey,
	                    reports: reports,
	                    onEvaluationShowToggle: this.onEvaluationShowToggle,
	                    students: students,
	                    selected: selected
	                  })
	                ),
	                _react2.default.createElement(
	                  GreyBlockText,
	                  null,
	                  "No information available at this time."
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "studentsList",
	    get: function get() {
	      var students = this.state.students;
	
	
	      var result = students ? students.filter(function (student) {
	        return ['CEO', 'PD', 'PM', 'OP', 'FI'].includes(student.role);
	      }).map(function (student) {
	        return student.user.first_name + " " + student.user.last_name;
	      }) : [];
	      result.sort(function (a, b) {
	        return a.localeCompare(b);
	      });
	
	      return result;
	    }
	  }]);
	
	  return StudentStatsPopup;
	}(_react.PureComponent);
	
	exports.default = StudentStatsPopup;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 12.5px;\n\n  .peerModal {\n    height: 737px;\n  }\n"], ["\n  margin-bottom: 12.5px;\n\n  .peerModal {\n    height: 737px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  border: 1.5px solid #2A4169;\n  color: #2A4169;\n  padding: 5px 10px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 23px;\n  border-radius: 8px;\n  margin-right: 10px;\n  background: #fff;\n  cursor: pointer;\n"], ["\n  display: inline-block;\n  border: 1.5px solid #2A4169;\n  color: #2A4169;\n  padding: 5px 10px;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 23px;\n  border-radius: 8px;\n  margin-right: 10px;\n  background: #fff;\n  cursor: pointer;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _peerEvaluationModal = __webpack_require__(256);
	
	var _peerEvaluationModal2 = _interopRequireDefault(_peerEvaluationModal);
	
	var _peerEvaluationFeedback = __webpack_require__(305);
	
	var _peerEvaluationFeedback2 = _interopRequireDefault(_peerEvaluationFeedback);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ViewEvaluationButtonContainer = _styledComponents2.default.div(_templateObject);
	
	var ViewEvaluationButton = _styledComponents2.default.div(_templateObject2);
	
	var StudentStatsViewEvaluation = function (_Component) {
	  _inherits(StudentStatsViewEvaluation, _Component);
	
	  function StudentStatsViewEvaluation(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, StudentStatsViewEvaluation);
	
	    var _this = _possibleConstructorReturn(this, (StudentStatsViewEvaluation.__proto__ || Object.getPrototypeOf(StudentStatsViewEvaluation)).call(this, props));
	
	    _this.fetchFormsAnswersList = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(nextPage) {
	        var nextPageAvailable, formsAnswersList, nextPageUrl;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                nextPageAvailable = true;
	                formsAnswersList = [];
	                nextPageUrl = nextPage;
	
	              case 3:
	                if (!nextPageAvailable) {
	                  _context.next = 9;
	                  break;
	                }
	
	                nextPageAvailable = false;
	                _context.next = 7;
	                return (0, _ApiService.getRequest)(nextPageUrl)
	                // eslint-disable-next-line no-loop-func
	                .then(function (res) {
	                  nextPageUrl = res.body.next;
	                  nextPageAvailable = nextPageUrl;
	                  formsAnswersList.push.apply(formsAnswersList, _toConsumableArray(res.body.results));
	                }).catch(function (err) {});
	
	              case 7:
	                _context.next = 3;
	                break;
	
	              case 9:
	                return _context.abrupt("return", formsAnswersList);
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.questionsOrder = function () {
	      var _this$props = _this.props,
	          survey = _this$props.survey,
	          reports = _this$props.reports,
	          students = _this$props.students,
	          selected = _this$props.selected;
	      var answers = _this.state.answers;
	
	      var user_score_question = reports[survey.stage] ? reports[survey.stage].user_score_question : [];
	      var freeform_answers = reports[survey.stage] ? reports[survey.stage].freeform_answers : [];
	
	      var survey_self_assessment_questions = survey.questions.filter(function (question) {
	        return question.category === "self_assessment" && question.answer_type === "freeform" && (question.text.toLowerCase().includes('biggest takeaway') || question.text.includes('What\'s working well') || question.text.includes('What could work better') || question.text.includes('If you had a chance to do it all over again'));
	      });
	      var self_assessment_questions = survey_self_assessment_questions.map(function (item, index) {
	        var currentAnswer = freeform_answers.find(function (freeform_answer) {
	          return freeform_answer.survey_question === item.id;
	        });
	        var currentAnswerText = currentAnswer ? currentAnswer.text : '';
	        return {
	          id: index + 1,
	          text: item.text,
	          category: 'self_assessment',
	          answer_type: 'freeform',
	          value: currentAnswerText
	        };
	      });
	
	      var peer_rating_questions = user_score_question.map(function (item, index) {
	        return {
	          id: index + 1,
	          text: item.question,
	          category: 'likert',
	          answer_type: 'rating',
	          value: Math.round(item.median)
	        };
	      });
	
	      var currentUser = selected.student.user;
	      var survey_final_reflection_questions = survey.questions.filter(function (question) {
	        return question.text.includes('I Like:') || question.text.includes('I Wish:');
	      });
	
	      var final_reflection_questions = survey_final_reflection_questions.map(function (item, index) {
	        var questionAnswers = answers.filter(function (answer) {
	          return answer.question_text === item.text;
	        }).map(function (answer) {
	          var student = students.find(function (student) {
	            return student.user.email === answer.giver_email;
	          });
	          var initials = student.user.first_name.charAt(0) + "." + student.user.last_name.charAt(0);
	          return {
	            name: initials,
	            text: answer.answer_text
	          };
	        });
	        return {
	          id: index + 1,
	          text: _this.formatFinalReflectionTitle(item.text, currentUser.first_name + " " + currentUser.last_name),
	          category: 'like_wish_results',
	          answer_type: 'freeform',
	          items: questionAnswers
	        };
	      });
	
	      var questionsOrder = [{ answer_type: "self_assessment_results_intro" }].concat(_toConsumableArray(self_assessment_questions), [{ answer_type: "peer_rating_feedback_intro" }], _toConsumableArray(peer_rating_questions), [{ answer_type: "final_reflections_results_intro" }], _toConsumableArray(final_reflection_questions));
	
	      questionsOrder.push({ answer_type: "final_peer_rating_page" });
	
	      _this.setState(function () {
	        return {
	          questionsOrder: questionsOrder,
	          questionsCount: questionsOrder.length - 1,
	          self_assessment_count: self_assessment_questions.length,
	          peer_rating_count: peer_rating_questions.length,
	          final_reflection_count: final_reflection_questions.length
	        };
	      });
	    };
	
	    _this.pasteTeamateName = function (text, name) {
	      var result = text;
	      var replacements = ['this teammate', '<insert teammate name>', '<insert name>', '<Insert User FirstName>'];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var replacement = _step.value;
	
	          result = result.replace(replacement, "<span>" + name + "</span>");
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    _this.formatFinalReflectionTitle = function (text, name) {
	      var likeStyle = 'color: #55B4BC;';
	      var wishStyle = 'color: #ECA427;';
	
	      var changedText = text;
	      if (changedText.includes('I Like:')) {
	        changedText = "Here\u2019s what your students like about working with <span style=\"" + likeStyle + "\">" + name + "</span>.";
	      }
	      if (changedText.includes('I Wish:')) {
	        changedText = "Here\u2019s what your students wish <span style=\"" + wishStyle + "\">" + name + "</span> could do more of.";
	      }
	
	      return changedText;
	    };
	
	    _this.isIntroScreen = function (nextPage) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextPage].answer_type;
	
	      return type === "peer_rating_feedback_intro";
	    };
	
	    _this.isFinalScreen = function (nextPage) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextPage].answer_type;
	
	      return type === "final_peer_rating_page";
	    };
	
	    _this.isTransitionScreen = function (nextPage) {
	      var questionsOrder = _this.state.questionsOrder;
	
	      var type = questionsOrder[nextPage].answer_type;
	
	      return type === "transition_page";
	    };
	
	    _this.handleShowModal = function () {
	      var onEvaluationShowToggle = _this.props.onEvaluationShowToggle;
	
	      _this.setState(function () {
	        return { show: true };
	      }, function () {
	        return onEvaluationShowToggle();
	      });
	    };
	
	    _this.handleHideModal = function () {
	      var onEvaluationShowToggle = _this.props.onEvaluationShowToggle;
	
	      _this.setState(function (prevState) {
	        return {
	          show: false,
	          currentPage: 0,
	          isIntroScreen: true,
	          isFinalScreen: false,
	          isTransitionScreen: false,
	          submitPages: {},
	          progressBar: prevState.progressBar.map(function (item) {
	            return Object.assign({}, item, { progress: 0 });
	          })
	        };
	      }, function () {
	        return onEvaluationShowToggle();
	      });
	    };
	
	    _this.goToNextPage = function () {
	      var _this$state = _this.state,
	          currentPage = _this$state.currentPage,
	          questionsCount = _this$state.questionsCount,
	          self_assessment_count = _this$state.self_assessment_count,
	          peer_rating_count = _this$state.peer_rating_count,
	          final_reflection_count = _this$state.final_reflection_count;
	
	
	      var nextPage = currentPage + 1;
	      if (nextPage > questionsCount) {
	        nextPage = questionsCount;
	      }
	
	      var isIntroScreen = _this.isIntroScreen(nextPage);
	      var isFinalScreen = _this.isFinalScreen(nextPage);
	      var isTransitionScreen = _this.isTransitionScreen(nextPage);
	
	      _this.setState(function (prevState) {
	        return {
	          currentPage: nextPage,
	          isIntroScreen: isIntroScreen,
	          isFinalScreen: isFinalScreen,
	          isTransitionScreen: isTransitionScreen,
	          progressBar: prevState.progressBar.map(function (item) {
	            return item.id === 1 ? Object.assign({}, item, {
	              progress: Math.min(nextPage / self_assessment_count * 100, 100)
	            }) : item.id === 2 ? Object.assign({}, item, {
	              progress: Math.min(Math.max(nextPage - self_assessment_count - 1, 0) / peer_rating_count * 100, 100),
	              isDisabled: nextPage <= self_assessment_count
	            }) : item.id === 3 ? Object.assign({}, item, {
	              progress: Math.min(Math.max(nextPage - self_assessment_count - peer_rating_count - 2, 0) / final_reflection_count * 100, 100),
	              isDisabled: nextPage <= self_assessment_count + peer_rating_count + 1
	            }) : item;
	          })
	        };
	      });
	    };
	
	    _this.goToPrevPage = function () {
	      var _this$state2 = _this.state,
	          currentPage = _this$state2.currentPage,
	          self_assessment_count = _this$state2.self_assessment_count,
	          peer_rating_count = _this$state2.peer_rating_count,
	          final_reflection_count = _this$state2.final_reflection_count;
	
	
	      var prevPage = currentPage - 1;
	      if (prevPage < 1) {
	        prevPage = 1;
	      }
	
	      var isIntroScreen = _this.isIntroScreen(prevPage);
	      var isFinalScreen = _this.isFinalScreen(prevPage);
	      var isTransitionScreen = _this.isTransitionScreen(prevPage);
	
	      _this.setState(function (prevState) {
	        return {
	          currentPage: prevPage,
	          isIntroScreen: isIntroScreen,
	          isFinalScreen: isFinalScreen,
	          isTransitionScreen: isTransitionScreen,
	          progressBar: prevState.progressBar.map(function (item) {
	            return item.id === 1 ? Object.assign({}, item, {
	              progress: Math.min(prevPage / self_assessment_count * 100, 100)
	            }) : item.id === 2 ? Object.assign({}, item, {
	              progress: Math.min(Math.max(prevPage - self_assessment_count - 1, 0) / peer_rating_count * 100, 100),
	              isDisabled: prevPage <= self_assessment_count
	            }) : item.id === 3 ? Object.assign({}, item, {
	              progress: Math.min(Math.max(prevPage - self_assessment_count - peer_rating_count - 2, 0) / final_reflection_count * 100, 100),
	              isDisabled: prevPage <= self_assessment_count + peer_rating_count + 1
	            }) : item;
	          })
	        };
	      });
	    };
	
	    _this.state = {
	      questionsOrder: [],
	      isIntroScreen: true,
	      isFinalScreen: false,
	      isTransitionScreen: false,
	      currentPage: 0,
	      questionsCount: 0,
	      self_assessment_count: 0,
	      peer_rating_count: 0,
	      final_reflection_count: 0,
	      show: false,
	      progressBar: [],
	      answers: [],
	      submitPages: {}
	    };
	    return _this;
	  }
	
	  _createClass(StudentStatsViewEvaluation, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var progressBar;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this.getAnswersList();
	
	              case 2:
	                progressBar = [{
	                  id: 1,
	                  title: "1. Self Assessment",
	                  progress: 0
	                }, {
	                  id: 2,
	                  title: "2. Peer Rating",
	                  progress: 0,
	                  isDisabled: true
	                }, {
	                  id: 3,
	                  title: "3. Final Reflection",
	                  progress: 0,
	                  isDisabled: true
	                }];
	
	
	                this.setState({
	                  progressBar: progressBar
	                });
	
	              case 4:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "getAnswersList",
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var _this3 = this;
	
	        var _props, survey, selected, _ref4, answersBody, formsAnswersList, nextPageAvailable, newFormsAnswersList;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _props = this.props, survey = _props.survey, selected = _props.selected;
	                _context3.next = 3;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/answers-list/?survey=" + survey.id + "&receiver=" + selected.student.user.id);
	
	              case 3:
	                _ref4 = _context3.sent;
	                answersBody = _ref4.body;
	                formsAnswersList = answersBody.results;
	                nextPageAvailable = answersBody.next;
	
	                if (!nextPageAvailable) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _context3.next = 10;
	                return this.fetchFormsAnswersList(nextPageAvailable);
	
	              case 10:
	                newFormsAnswersList = _context3.sent;
	
	                formsAnswersList.push.apply(formsAnswersList, _toConsumableArray(newFormsAnswersList));
	
	              case 12:
	
	                this.setState({
	                  answers: formsAnswersList
	                }, function () {
	                  _this3.questionsOrder();
	                });
	
	              case 13:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getAnswersList() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getAnswersList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var survey = this.props.survey;
	      var _state = this.state,
	          show = _state.show,
	          questionsOrder = _state.questionsOrder,
	          isIntroScreen = _state.isIntroScreen,
	          isFinalScreen = _state.isFinalScreen,
	          isTransitionScreen = _state.isTransitionScreen,
	          currentPage = _state.currentPage,
	          progressBar = _state.progressBar,
	          self_assessment_count = _state.self_assessment_count,
	          peer_rating_count = _state.peer_rating_count,
	          teamList = _state.teamList,
	          questionsCount = _state.questionsCount,
	          submitPages = _state.submitPages;
	
	
	      var currentQuestion = questionsOrder[currentPage];
	      var hasAnswer = true;
	
	      return _react2.default.createElement(
	        ViewEvaluationButtonContainer,
	        null,
	        _react2.default.createElement(
	          ViewEvaluationButton,
	          { onClick: this.handleShowModal },
	          "View Evaluation"
	        ),
	        _react2.default.createElement(
	          _peerEvaluationModal2.default,
	          {
	            surveyId: survey ? survey.id : null,
	            show: show,
	            onHide: this.handleHideModal,
	            onSubmit: this.goToNextPage,
	            progressBar: progressBar,
	            submitButtonText: submitPages[currentPage] ? "Submit" : isIntroScreen ? "Start" : "Save & Continue",
	            currentPage: currentPage ? Number(currentPage) : 0,
	            countOfPages: questionsCount ? Number(questionsCount) : 0,
	            goNext: this.goToNextPage,
	            goPrev: this.goToPrevPage,
	            canSubmit: hasAnswer,
	            isFinalScreen: isFinalScreen,
	            isTransitionScreen: isTransitionScreen,
	            readonlyMode: true,
	            linearExtraId: "_peer-review"
	          },
	          !!currentQuestion && _react2.default.createElement(_peerEvaluationFeedback2.default, {
	            question: currentQuestion,
	            answers: [],
	            self_assessment_count: self_assessment_count,
	            peer_rating_count: peer_rating_count,
	            teamList: teamList,
	            feedbacks: {},
	            readonlyMode: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return StudentStatsViewEvaluation;
	}(_react.Component);
	
	exports.default = StudentStatsViewEvaluation;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.8) !important;\n\n  .modal-dialog {\n    width: 1077px !important;\n\n    .modal-content {\n      padding: 0 !important;\n      border-radius: 4px !important;\n      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;\n      border: none !important;\n    }\n  }\n"], ["\n  background: rgba(0, 0, 0, 0.8) !important;\n\n  .modal-dialog {\n    width: 1077px !important;\n\n    .modal-content {\n      padding: 0 !important;\n      border-radius: 4px !important;\n      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;\n      border: none !important;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  padding: 0 !important;\n  height: 737px;\n"], ["\n  padding: 0 !important;\n  height: 737px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 48px 0 0 42px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 48px 0 0 42px;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  color: #bdbdbd;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  color: #bdbdbd;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  margin-left: 15px;\n"], ["\n  margin-left: 15px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n"], ["\n  position: absolute;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 236px;\n"], ["\n  width: 236px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 55px;\n  color: #4f4f4f;\n  text-transform: uppercase;\n  text-align: center;\n  margin-top: 38px;\n  margin-bottom: 28px;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 55px;\n  color: #4f4f4f;\n  text-transform: uppercase;\n  text-align: center;\n  margin-top: 38px;\n  margin-bottom: 28px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  width: 236px;\n  height: 33px;\n  border-radius: 0 10px 10px 0;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 33px;\n  color: #000000;\n  padding: 0 0 0 60px;\n  margin: 4px 0;\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", "\n"], ["\n  width: 236px;\n  height: 33px;\n  border-radius: 0 10px 10px 0;\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 33px;\n  color: #000000;\n  padding: 0 0 0 60px;\n  margin: 4px 0;\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", "\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 60px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-top: 60px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  width: 3px;\n  height: 400px;\n  background: rgba(224, 224, 224, 0.25);\n  margin: 85px 40px 0 20px;\n"], ["\n  width: 3px;\n  height: 400px;\n  background: rgba(224, 224, 224, 0.25);\n  margin: 85px 40px 0 20px;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 38px;\n  color: #52c5cd;\n  text-transform: uppercase;\n  text-align: center;\n"], ["\n  font-family: Lato;\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 38px;\n  color: #52c5cd;\n  text-transform: uppercase;\n  text-align: center;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 55px;\n  color: #2a4169;\n  text-align: center;\n"], ["\n  font-family: Lato;\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 55px;\n  color: #2a4169;\n  text-align: center;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  width: 778px;\n\n  ", "\n"], ["\n  width: 778px;\n\n  ", "\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  text-align: center;\n  padding-right: 50px;\n"], ["\n  text-align: center;\n  padding-right: 50px;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  font-family: Lato;\n  font-size: 40px;\n  line-height: 48px;\n  color: #bdbdbd;\n  padding: 0 40px 0 0;\n  width: 563px;\n  text-align: center;\n  margin: 184px auto 0;\n"], ["\n  font-family: Lato;\n  font-size: 40px;\n  line-height: 48px;\n  color: #bdbdbd;\n  padding: 0 40px 0 0;\n  width: 563px;\n  text-align: center;\n  margin: 184px auto 0;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-right: 40px;\n\n  .loader {\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 184px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  padding-right: 40px;\n\n  .loader {\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 184px;\n        border-color: #2a4169;\n      }\n    }\n  }\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n"], ["\n  display: flex;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  color: #36507e;\n  font-weight: 600;\n  font-size: 15px;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  height: 10px;\n  width: 40px;\n  margin-right: 10px;\n\n  ", "\n"], ["\n  height: 10px;\n  width: 40px;\n  margin-right: 10px;\n\n  ", "\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #36507e;\n"], ["\n  font-size: 14px;\n  color: #36507e;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _dashboardSelect = __webpack_require__(407);
	
	var _dashboardSelect2 = _interopRequireDefault(_dashboardSelect);
	
	var _dashboard = __webpack_require__(310);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _playerChart = __webpack_require__(1507);
	
	var _playerChart2 = _interopRequireDefault(_playerChart);
	
	var _Teams = __webpack_require__(10);
	
	var _reactLoaders = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TeamDynamicsPopup = (0, _styledComponents2.default)(_reactBootstrap.Modal)(_templateObject);
	
	var ModalBody = (0, _styledComponents2.default)(_reactBootstrap.Modal.Body)(_templateObject2);
	
	var Header = _styledComponents2.default.div(_templateObject3);
	
	var HeaderTitle = _styledComponents2.default.div(_templateObject4);
	
	var TeamNameDropdown = _styledComponents2.default.div(_templateObject5);
	
	var StudentsNameDropdown = _styledComponents2.default.div(_templateObject5);
	
	var AbsoluteListContainer = (0, _styledComponents2.default)(_dashboard.DropDownListContainer)(_templateObject6);
	
	var UsersList = _styledComponents2.default.div(_templateObject7);
	
	var Teamname = _styledComponents2.default.div(_templateObject8);
	
	var Username = _styledComponents2.default.div(_templateObject9, function (p) {
	  return p.isActive && "\n    background: rgba(141, 217, 222, 0.28);\n  ";
	});
	
	var Body = _styledComponents2.default.div(_templateObject10);
	
	var Line = _styledComponents2.default.div(_templateObject11);
	
	var ChartTitle = _styledComponents2.default.div(_templateObject12);
	
	var ChartDescription = _styledComponents2.default.div(_templateObject13);
	
	var ChartWrapper = _styledComponents2.default.div(_templateObject14, function (p) {
	  return p.hiddenSidebar && "\n    margin-left: auto;\n    margin-right: auto;\n  ";
	});
	
	var ChartContent = _styledComponents2.default.div(_templateObject15);
	
	var Placeholder = _styledComponents2.default.div(_templateObject16);
	
	var StyledLoader = _styledComponents2.default.div(_templateObject17);
	
	var getTeamsList = function getTeamsList(teams) {
	  return (0, _orderBy2.default)(teams, ["name"], ["asc"]).map(function (team) {
	    return {
	      id: team.id,
	      name: "Team " + team.name
	    };
	  });
	};
	
	var getTeamName = function getTeamName(currentTeam, teams) {
	  var team = teams.find(function (i) {
	    return i.id === currentTeam;
	  });
	
	  return team ? "Team " + team.name : "";
	};
	
	var getPlayersList = function getPlayersList(players) {
	  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (player) {
	    return player.username;
	  };
	  return (0, _orderBy2.default)(players, ["username"], ["asc"]).reduce(function (state, player) {
	    return Object.assign({}, state, _defineProperty({}, player.id, callback(player)));
	  }, {});
	};
	
	var isUserSelected = function isUserSelected(currentTeam, currentPlayer, surveys) {
	  return currentTeam > 0 && currentPlayer > 0 && surveys.length > 0;
	};
	
	var getPlayerName = function getPlayerName(currentPlayer, players) {
	  var player = players.find(function (i) {
	    return i.id === currentPlayer;
	  });
	
	  return player ? player.first_name + " " + player.last_name : "";
	};
	
	var getScoreTitle = function getScoreTitle(reports, surveys, currentSurvey) {
	  var survey = surveys.find(function (i) {
	    return i.id === currentSurvey;
	  });
	
	  if (!survey) {
	    return "Did Not Work Well With Team";
	  }
	
	  if (!(survey.stage in reports)) {
	    return "Did Not Work Well With Team";
	  }
	
	  var report = reports[survey.stage];
	
	  if (report.collaboration && report.collaboration.most_valuable === "Yes") {
	    return "Most Valuable Team Member";
	  }
	
	  if (report.collaboration && report.collaboration.work_again_percentage >= 66) {
	    return "Worked Very Well With Team";
	  }
	
	  if (report.collaboration && report.collaboration.work_again_percentage >= 50 && report.collaboration.work_again_percentage < 66) {
	    return "Worked Well Together";
	  }
	
	  return "Did Not Work Well With Team";
	};
	
	var Charts = {};
	
	Charts.Teams = {};
	
	Charts.Teams.Wrapper = _styledComponents2.default.div(_templateObject18);
	
	Charts.Teams.Row = _styledComponents2.default.div(_templateObject19, function (p) {
	  return p.margin && "\n    margin: " + p.margin + ";\n  ";
	});
	
	Charts.Teams.TeamColor = _styledComponents2.default.div(_templateObject20, function (p) {
	  return p.background && "\n    background: " + p.background + ";\n  ";
	});
	
	Charts.Teams.TeamName = _styledComponents2.default.div(_templateObject21);
	
	var getTeamColor = function getTeamColor(teams, currentTeam) {
	  return (0, _Teams.colorForTeamId)(teams, currentTeam, _Teams.TEAM_COLORS) || _Teams.TEAM_COLORS[0];
	};
	
	var TeamDynamicsPopupComponent = function TeamDynamicsPopupComponent(_ref) {
	  var show = _ref.show,
	      onHide = _ref.onHide,
	      teams = _ref.teams,
	      title = _ref.title,
	      currentTeam = _ref.currentTeam,
	      selectTeam = _ref.selectTeam,
	      players = _ref.players,
	      currentPlayer = _ref.currentPlayer,
	      selectPlayer = _ref.selectPlayer,
	      setPlayerValueCallback = _ref.setPlayerValueCallback,
	      setPlayerValue = _ref.setPlayerValue,
	      reports = _ref.reports,
	      userScoreReports = _ref.userScoreReports,
	      surveys = _ref.surveys,
	      allTeams = _ref.allTeams,
	      isSurveyFinished = _ref.isSurveyFinished,
	      currentSurvey = _ref.currentSurvey,
	      isReportsLoading = _ref.isReportsLoading,
	      isPlayersLoading = _ref.isPlayersLoading,
	      hideDropdowns = _ref.hideDropdowns;
	  return _react2.default.createElement(
	    TeamDynamicsPopup,
	    {
	      show: show,
	      onHide: onHide,
	      backdropClassName: "transparent-backdrop"
	    },
	    _react2.default.createElement(
	      ModalBody,
	      null,
	      _react2.default.createElement(
	        Header,
	        null,
	        _react2.default.createElement(
	          HeaderTitle,
	          null,
	          title
	        ),
	        !hideDropdowns && _react2.default.createElement(
	          TeamNameDropdown,
	          null,
	          _react2.default.createElement(_dashboardSelect2.default, {
	            options: getTeamsList(teams),
	            placeholder: "Team Name",
	            onChange: selectTeam,
	            DropDownListContainer: AbsoluteListContainer,
	            customId: "id",
	            customName: "name"
	          })
	        ),
	        !hideDropdowns && _react2.default.createElement(
	          StudentsNameDropdown,
	          null,
	          _react2.default.createElement(_dashboardSelect2.default, {
	            options: getPlayersList(players),
	            placeholder: "Students Name",
	            onChange: selectPlayer,
	            DropDownListContainer: AbsoluteListContainer,
	            setValueCallback: setPlayerValueCallback
	          })
	        )
	      ),
	      _react2.default.createElement(
	        Body,
	        null,
	        !hideDropdowns && _react2.default.createElement(
	          UsersList,
	          null,
	          currentTeam > 0 && _react2.default.createElement(
	            Teamname,
	            null,
	            getTeamName(currentTeam, teams)
	          ),
	          currentTeam > 0 && Object.entries(getPlayersList(players, function (player) {
	            return player.first_name + " " + player.last_name;
	          })).map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                id = _ref3[0],
	                username = _ref3[1];
	
	            return { id: parseInt(id, 10), username: username };
	          }).map(function (player) {
	            return _react2.default.createElement(
	              Username,
	              {
	                key: player.id,
	                isActive: player.id === currentPlayer ? true : false,
	                onClick: function onClick() {
	                  return setPlayerValue(player.id);
	                },
	                title: player.username
	              },
	              player.username
	            );
	          })
	        ),
	        !hideDropdowns && _react2.default.createElement(Line, null),
	        isUserSelected(currentTeam, currentPlayer, surveys) === true && Object.keys(reports).length > 0 && !isReportsLoading && !isPlayersLoading && _react2.default.createElement(
	          ChartWrapper,
	          { hiddenSidebar: hideDropdowns },
	          _react2.default.createElement(
	            ChartTitle,
	            null,
	            getScoreTitle(reports, surveys, currentSurvey)
	          ),
	          _react2.default.createElement(
	            ChartDescription,
	            null,
	            getPlayerName(currentPlayer, players)
	          ),
	          _react2.default.createElement(
	            Charts.Teams.Wrapper,
	            null,
	            _react2.default.createElement(
	              Charts.Teams.Row,
	              null,
	              _react2.default.createElement(Charts.Teams.TeamColor, {
	                background: getTeamColor(allTeams, currentTeam)
	              }),
	              _react2.default.createElement(
	                Charts.Teams.TeamName,
	                null,
	                "You"
	              )
	            ),
	            _react2.default.createElement(
	              Charts.Teams.Row,
	              { margin: "0 20px" },
	              _react2.default.createElement(Charts.Teams.TeamColor, { background: "#eee" }),
	              _react2.default.createElement(
	                Charts.Teams.TeamName,
	                null,
	                "Team Average"
	              )
	            ),
	            _react2.default.createElement(
	              Charts.Teams.Row,
	              { margin: "0 20px" },
	              _react2.default.createElement(Charts.Teams.TeamColor, { background: "#c4c4c4" }),
	              _react2.default.createElement(
	                Charts.Teams.TeamName,
	                null,
	                "Team Median"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ChartContent,
	            null,
	            _react2.default.createElement(_playerChart2.default, {
	              reports: reports,
	              userScoreReports: userScoreReports,
	              surveys: surveys,
	              userId: currentPlayer,
	              players: players,
	              currentTeam: currentTeam,
	              teams: allTeams,
	              isSurveyFinished: isSurveyFinished
	            })
	          )
	        ),
	        isUserSelected(currentTeam, currentPlayer, surveys) === true && Object.keys(reports).length === 0 && !isReportsLoading && !isPlayersLoading && _react2.default.createElement(
	          ChartWrapper,
	          { hiddenSidebar: hideDropdowns },
	          _react2.default.createElement(
	            Placeholder,
	            null,
	            "User results not found"
	          )
	        ),
	        isUserSelected(currentTeam, currentPlayer, surveys) === false && !isReportsLoading && !isPlayersLoading && _react2.default.createElement(
	          ChartWrapper,
	          { hiddenSidebar: hideDropdowns },
	          _react2.default.createElement(
	            Placeholder,
	            null,
	            "Select a Team or Student"
	          )
	        ),
	        (isReportsLoading || isPlayersLoading) && _react2.default.createElement(
	          StyledLoader,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        )
	      )
	    )
	  );
	};
	
	exports.default = TeamDynamicsPopupComponent;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _ApiService = __webpack_require__(4);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	var TeamEdit = function (_PureComponent) {
	  _inherits(TeamEdit, _PureComponent);
	
	  function TeamEdit(props) {
	    _classCallCheck(this, TeamEdit);
	
	    var _this = _possibleConstructorReturn(this, (TeamEdit.__proto__ || Object.getPrototypeOf(TeamEdit)).call(this, props));
	
	    _this.changeSelect = function (e) {
	      var select = e.target;
	
	      _this.setState(_defineProperty({}, select.name, select.value));
	    };
	
	    _this.submit = function () {
	      var _this$state = _this.state,
	          team_id = _this$state.team_id,
	          role = _this$state.role;
	      var _this$props = _this.props,
	          game_id = _this$props.game_id,
	          player = _this$props.player,
	          updatedSuccessfully = _this$props.updatedSuccessfully;
	
	
	      if (team_id > 0 && role !== "" && role !== player.role) {
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/change_team_role/").send({
	          user: player.user.id,
	          team: team_id,
	          role: role
	        }).then(function (res) {
	          updatedSuccessfully();
	          _this.props.fetchData();
	        }).catch(function (err) {
	          if (err.response && err.response.status === 400) {
	            var user = err.response.body.user;
	
	
	            _this.setState({
	              errorAlert: true,
	              errorText: user[0]
	            });
	          }
	        });
	      }
	    };
	
	    _this.hideErrorAlert = function () {
	      _this.setState({
	        errorAlert: false,
	        errorText: ""
	      });
	    };
	
	    _this.state = {
	      team_id: props.player.team,
	      role: props.player.role,
	      errorAlert: false,
	      errorText: ""
	    };
	    return _this;
	  }
	
	  _createClass(TeamEdit, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          player = _props.player,
	          counter = _props.counter,
	          teams = _props.teams;
	      var _state = this.state,
	          team_id = _state.team_id,
	          role = _state.role,
	          errorAlert = _state.errorAlert,
	          errorText = _state.errorText;
	
	
	      return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	          "td",
	          { className: "text-center v-align-middle instructor-round-number b-r" },
	          counter
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l b-r v-align-middle instructor-td text-center" },
	          player.user.username
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l b-r v-align-middle instructor-td" },
	          _react2.default.createElement(
	            "select",
	            { name: "team_id", value: team_id, onChange: this.changeSelect },
	            teams.map(function (team, index) {
	              return _react2.default.createElement(
	                "option",
	                { key: index, value: team.id },
	                team.name
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l b-r v-align-middle instructor-td" },
	          _react2.default.createElement(
	            "select",
	            { name: "role", value: role, onChange: this.changeSelect },
	            _react2.default.createElement(
	              "option",
	              { value: "CEO" },
	              "CEO"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "PD" },
	              "Head of Product Development"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "PM" },
	              "Head of Product Marketing"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "OP" },
	              "Head of Operations"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "FI" },
	              "Head of Finance"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l" },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: "light-blue", onClick: this.submit, block: true },
	            "Update"
	          ),
	          _react2.default.createElement(_sweetalertReact2.default, {
	            show: errorAlert,
	            title: "Error",
	            text: errorText,
	            type: "error",
	            onConfirm: this.hideErrorAlert
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamEdit;
	}(_react.PureComponent);
	
	exports.default = TeamEdit;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _ApiService = __webpack_require__(4);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	var TeamNew = function (_PureComponent) {
	  _inherits(TeamNew, _PureComponent);
	
	  function TeamNew(props) {
	    _classCallCheck(this, TeamNew);
	
	    var _this = _possibleConstructorReturn(this, (TeamNew.__proto__ || Object.getPrototypeOf(TeamNew)).call(this, props));
	
	    _this.changeSelect = function (e) {
	      var select = e.target;
	
	      _this.setState(_defineProperty({}, select.name, select.value));
	    };
	
	    _this.submit = function () {
	      var _this$state = _this.state,
	          user_id = _this$state.user_id,
	          team_id = _this$state.team_id,
	          role = _this$state.role;
	      var game_id = _this.props.game_id;
	
	
	      if (user_id > 0 && team_id > 0 && role !== "") {
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/join_team/").send({
	          user: user_id,
	          team: team_id,
	          role: role
	        }).then(function (res) {
	          _this.props.fetchData();
	          _this.setState({
	            user_id: 0,
	            team_id: 0,
	            role: ""
	          });
	        }).catch(function (err) {
	          if (err.response && err.response.status === 400) {
	            var user = err.response.body.user;
	
	
	            _this.setState({
	              errorAlert: true,
	              errorText: user[0]
	            });
	          }
	        });
	      }
	    };
	
	    _this.hideErrorAlert = function () {
	      _this.setState({
	        errorAlert: false,
	        errorText: ""
	      });
	    };
	
	    _this.state = {
	      user_id: 0,
	      team_id: 0,
	      role: "",
	      errorAlert: false,
	      errorText: ""
	    };
	    return _this;
	  }
	
	  _createClass(TeamNew, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          counter = _props.counter,
	          free_users = _props.free_users,
	          teams = _props.teams;
	      var _state = this.state,
	          user_id = _state.user_id,
	          team_id = _state.team_id,
	          role = _state.role,
	          errorAlert = _state.errorAlert,
	          errorText = _state.errorText;
	
	
	      return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	          "td",
	          { className: "text-center v-align-middle instructor-round-number b-r" },
	          counter
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l b-r v-align-middle instructor-td text-center" },
	          _react2.default.createElement(
	            "select",
	            { name: "user_id", value: user_id, onChange: this.changeSelect },
	            _react2.default.createElement(
	              "option",
	              { value: "0" },
	              "Select user"
	            ),
	            free_users.map(function (user, index) {
	              return _react2.default.createElement(
	                "option",
	                { key: index, value: user.id },
	                user.username
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l b-r v-align-middle instructor-td" },
	          _react2.default.createElement(
	            "select",
	            { name: "team_id", value: team_id, onChange: this.changeSelect },
	            _react2.default.createElement(
	              "option",
	              { value: "0" },
	              "Select team"
	            ),
	            teams.map(function (team, index) {
	              return _react2.default.createElement(
	                "option",
	                { key: index, value: team.id },
	                team.name
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l b-r v-align-middle instructor-td" },
	          _react2.default.createElement(
	            "select",
	            { name: "role", value: role, onChange: this.changeSelect },
	            _react2.default.createElement(
	              "option",
	              { value: "" },
	              "Select role"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "CEO" },
	              "CEO"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "PD" },
	              "Head of Product Development"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "PM" },
	              "Head of Product Marketing"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "OP" },
	              "Head of Operations"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "FI" },
	              "Head of Finance"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "td",
	          { className: "b-l" },
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: "light-blue", onClick: this.submit, block: true },
	            "Add"
	          ),
	          _react2.default.createElement(_sweetalertReact2.default, {
	            show: errorAlert,
	            title: "Error",
	            text: errorText,
	            type: "error",
	            onConfirm: this.hideErrorAlert
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamNew;
	}(_react.PureComponent);
	
	exports.default = TeamNew;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 11px 50px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  padding: 11px 50px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 25px;\n'], ['\n  display: flex;\n  gap: 25px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: 20px;\n'], ['\n  margin-left: 20px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  gap: 20px;\n  margin-left: 20px;\n'], ['\n  display: flex;\n  gap: 20px;\n  margin-left: 20px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  width: 27px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: .4;\n  pointer-events: none;\n\n  ', '\n\n  ', '}\n'], ['\n  width: 27px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: .4;\n  pointer-events: none;\n\n  ', '\n\n  ', '}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _selector = __webpack_require__(610);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _constants = __webpack_require__(410);
	
	var _iconTeamsRolesPaginationRight = __webpack_require__(688);
	
	var _iconTeamsRolesPaginationRight2 = _interopRequireDefault(_iconTeamsRolesPaginationRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var PaginationWrapper = _styledComponents2.default.div(_templateObject);
	
	var RowsSelectorWrapper = _styledComponents2.default.div(_templateObject2);
	
	var RowsCount = _styledComponents2.default.div(_templateObject3);
	
	var PageArrows = _styledComponents2.default.div(_templateObject4);
	
	var PageArrow = _styledComponents2.default.button(_templateObject5, function (p) {
	  return p.prev && '\n    transform: rotate(180deg);\n  ';
	}, function (p) {
	  return p.active && '{\n    opacity: 1;\n    pointer-events: auto;\n  }';
	});
	
	var TeamsRolesPagination = function (_PureComponent) {
	  _inherits(TeamsRolesPagination, _PureComponent);
	
	  function TeamsRolesPagination(props) {
	    _classCallCheck(this, TeamsRolesPagination);
	
	    var _this = _possibleConstructorReturn(this, (TeamsRolesPagination.__proto__ || Object.getPrototypeOf(TeamsRolesPagination)).call(this, props));
	
	    _this.state = {
	      query: '',
	      typing: false,
	      typingTimeout: 0
	    };
	    return _this;
	  }
	
	  _createClass(TeamsRolesPagination, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rowsPerPage = _props.rowsPerPage,
	          handleRowsPerPageChange = _props.handleRowsPerPageChange,
	          rowsTotal = _props.rowsTotal,
	          activePrevPage = _props.activePrevPage,
	          activeNextPage = _props.activeNextPage,
	          page = _props.page,
	          handlePageChange = _props.handlePageChange;
	
	
	      var rowStart = (page - 1) * Number(rowsPerPage) + 1;
	      var rowsEnd = rowStart + Number(rowsPerPage) - 1;
	      if (rowsEnd > rowsTotal) {
	        rowsEnd = rowsTotal;
	      }
	
	      return _react2.default.createElement(
	        PaginationWrapper,
	        null,
	        _react2.default.createElement(
	          RowsSelectorWrapper,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Rows per page:'
	          ),
	          _react2.default.createElement(_selector2.default, {
	            options: _constants.teamPlayerRowsPerPage,
	            selectedOptionId: rowsPerPage,
	            size: 'small',
	            dropUp: true,
	            onSelectorChange: handleRowsPerPageChange
	          })
	        ),
	        _react2.default.createElement(
	          RowsCount,
	          null,
	          rowStart,
	          '-',
	          rowsEnd,
	          ' of ',
	          rowsTotal
	        ),
	        _react2.default.createElement(
	          PageArrows,
	          null,
	          _react2.default.createElement(
	            PageArrow,
	            { prev: true, active: activePrevPage, onClick: function onClick() {
	                return handlePageChange(page - 1);
	              } },
	            _react2.default.createElement('img', { src: _iconTeamsRolesPaginationRight2.default, alt: 'Prev' })
	          ),
	          _react2.default.createElement(
	            PageArrow,
	            { active: activeNextPage, onClick: function onClick() {
	                return handlePageChange(page + 1);
	              } },
	            _react2.default.createElement('img', { src: _iconTeamsRolesPaginationRight2.default, alt: 'Next' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamsRolesPagination;
	}(_react.PureComponent);
	
	exports.default = TeamsRolesPagination;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n'], ['\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  flex: 1;\n  max-width: 320px;\n'], ['\n  position: relative;\n  flex: 1;\n  max-width: 320px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 18px;\n  width: 12px;\n  height: 12px;\n  display: flex;\n'], ['\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 18px;\n  width: 12px;\n  height: 12px;\n  display: flex;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 9px 12px 9px 40px;\n  border: 1px solid #CED1D6;\n  border-radius: 6px;\n  width: 100%;\n  font-family: \'Mukta Vaani\';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.4);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: #55B4BC;\n  }\n'], ['\n  padding: 9px 12px 9px 40px;\n  border: 1px solid #CED1D6;\n  border-radius: 6px;\n  width: 100%;\n  font-family: \'Mukta Vaani\';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n\n  &::placeholder {\n    color: rgba(0, 27, 59, 0.4);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: #55B4BC;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #55B4BC;\n  border: 1px solid #55B4BC;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #FFFFFF;\n  cursor: pointer;\n\n  &:hover {\n    background: #4AA1A9;\n    border-color: #4AA1A9;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: #FFFFFF;\n  }\n'], ['\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #55B4BC;\n  border: 1px solid #55B4BC;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #FFFFFF;\n  cursor: pointer;\n\n  &:hover {\n    background: #4AA1A9;\n    border-color: #4AA1A9;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: #FFFFFF;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  background: #FFFFFF;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: \'Mukta Vaani\';\n'], ['\n  background: #FFFFFF;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: \'Mukta Vaani\';\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n'], ['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 20px;\n'], ['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 20px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  padding: 0;\n  color: #2196F3;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    color: #1e88e5;\n  }\n'], ['\n  background: none;\n  border: none;\n  padding: 0;\n  color: #2196F3;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:hover {\n    color: #1e88e5;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin: 0 0 20px;\n'], ['\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin: 0 0 20px;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  background: #FAFBFD;\n  border: 1px solid #CED1D6;\n  border-radius: 10px;\n  padding: 20px 20px 22px;\n  font: inherit;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: border-color .15s ease, background .15s ease;\n\n  &:hover {\n    border-color: #55B4BC;\n    background: #ECF6F7;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    background: #FAFBFD;\n    border-color: #CED1D6;\n  }\n\n  &:disabled:hover {\n    border-color: #CED1D6;\n    background: #FAFBFD;\n  }\n'], ['\n  background: #FAFBFD;\n  border: 1px solid #CED1D6;\n  border-radius: 10px;\n  padding: 20px 20px 22px;\n  font: inherit;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: border-color .15s ease, background .15s ease;\n\n  &:hover {\n    border-color: #55B4BC;\n    background: #ECF6F7;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    background: #FAFBFD;\n    border-color: #CED1D6;\n  }\n\n  &:disabled:hover {\n    border-color: #CED1D6;\n    background: #FAFBFD;\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 12px;\n  margin: 0 0 20px;\n'], ['\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 12px;\n  margin: 0 0 20px;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 22px;\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.7);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.7);\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  padding: 0;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: #3A507B;\n  cursor: pointer;\n  margin: 0 0 12px;\n  text-align: left;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    color: rgba(0, 27, 59, 0.35);\n    cursor: default;\n    text-decoration: none;\n  }\n'], ['\n  background: none;\n  border: none;\n  padding: 0;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: #3A507B;\n  cursor: pointer;\n  margin: 0 0 12px;\n  text-align: left;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    color: rgba(0, 27, 59, 0.35);\n    cursor: default;\n    text-decoration: none;\n  }\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px 16px;\n  margin: 0 0 12px;\n'], ['\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px 16px;\n  margin: 0 0 12px;\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.85);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.85);\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  color: rgba(0, 27, 59, 0.55);\n  margin-right: 6px;\n'], ['\n  color: rgba(0, 27, 59, 0.55);\n  margin-right: 6px;\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  border: 2px dashed ', ';\n  background: ', ';\n  border-radius: 8px;\n  padding: 24px;\n  text-align: center;\n  cursor: pointer;\n  margin-bottom: 24px;\n  transition: border-color 120ms ease, background 120ms ease;\n\n  &:hover {\n    border-color: #55B4BC;\n    background: #ECF6F7;\n  }\n'], ['\n  border: 2px dashed ', ';\n  background: ', ';\n  border-radius: 8px;\n  padding: 24px;\n  text-align: center;\n  cursor: pointer;\n  margin-bottom: 24px;\n  transition: border-color 120ms ease, background 120ms ease;\n\n  &:hover {\n    border-color: #55B4BC;\n    background: #ECF6F7;\n  }\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n\n  svg {\n    width: 32px;\n    height: 32px;\n    stroke: rgba(0, 27, 59, 0.6);\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n\n  svg {\n    width: 32px;\n    height: 32px;\n    stroke: rgba(0, 27, 59, 0.6);\n  }\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n'], ['\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 4px;\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  background: #FAFBFD;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  background: #FAFBFD;\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  display: flex;\n\n  svg {\n    width: 22px;\n    height: 22px;\n    stroke: #55B4BC;\n  }\n'], ['\n  display: flex;\n\n  svg {\n    width: 22px;\n    height: 22px;\n    stroke: #55B4BC;\n  }\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  flex: 1;\n  min-width: 0;\n'], ['\n  flex: 1;\n  min-width: 0;\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  padding: 4px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n\n  &:hover {\n    background: #ECEDEF;\n    color: #EC5E59;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: currentColor;\n  }\n'], ['\n  background: none;\n  border: none;\n  padding: 4px;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n\n  &:hover {\n    background: #ECEDEF;\n    color: #EC5E59;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: currentColor;\n  }\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  display: none;\n'], ['\n  display: none;\n']),
	    _templateObject31 = _taggedTemplateLiteral(['\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n'], ['\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n']),
	    _templateObject32 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n'], ['\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n']),
	    _templateObject33 = _taggedTemplateLiteral([''], ['']),
	    _templateObject34 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 6px;\n'], ['\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 6px;\n']),
	    _templateObject35 = _taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: ', ';\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: #2DA548;\n  }\n'], ['\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: ', ';\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: #2DA548;\n  }\n']),
	    _templateObject36 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: ', ';\n'], ['\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: ', ';\n']),
	    _templateObject37 = _taggedTemplateLiteral(['\n  height: 8px;\n  border-radius: 4px;\n  background: #ECEDEF;\n  overflow: hidden;\n  position: relative;\n'], ['\n  height: 8px;\n  border-radius: 4px;\n  background: #ECEDEF;\n  overflow: hidden;\n  position: relative;\n']),
	    _templateObject38 = _taggedTemplateLiteral(['\n  height: 100%;\n  background: ', ';\n  width: ', '%;\n  transition: width 250ms ease, background 200ms ease;\n'], ['\n  height: 100%;\n  background: ', ';\n  width: ', '%;\n  transition: width 250ms ease, background 200ms ease;\n']),
	    _templateObject39 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
	    _templateObject40 = _taggedTemplateLiteral(['\n  background: #FDECEC;\n  border: 1px solid #F5B5B3;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  max-height: 240px;\n  overflow-y: auto;\n'], ['\n  background: #FDECEC;\n  border: 1px solid #F5B5B3;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  max-height: 240px;\n  overflow-y: auto;\n']),
	    _templateObject41 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 22px;\n  color: #B0322D;\n  margin-bottom: 8px;\n'], ['\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 22px;\n  color: #B0322D;\n  margin-bottom: 8px;\n']),
	    _templateObject42 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n\n  & + & {\n    margin-top: 4px;\n  }\n'], ['\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n\n  & + & {\n    margin-top: 4px;\n  }\n']),
	    _templateObject43 = _taggedTemplateLiteral(['\n  background: #ECF7EE;\n  border: 1px solid #A8D9B0;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  background: #ECF7EE;\n  border: 1px solid #A8D9B0;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject44 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n']),
	    _templateObject45 = _taggedTemplateLiteral(['\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n\n  &:hover {\n    background: #ECEDEF;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n'], ['\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n\n  &:hover {\n    background: #ECEDEF;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n']),
	    _templateObject46 = _taggedTemplateLiteral(['\n  background: #55B4BC;\n  border: 1px solid #55B4BC;\n  border-radius: 6px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 14px;\n  color: #FFFFFF;\n  cursor: pointer;\n\n  &:hover {\n    background: #4AA1A9;\n    border-color: #4AA1A9;\n  }\n\n  &:disabled {\n    background: #B7DDE0;\n    border-color: #B7DDE0;\n    cursor: not-allowed;\n  }\n'], ['\n  background: #55B4BC;\n  border: 1px solid #55B4BC;\n  border-radius: 6px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 14px;\n  color: #FFFFFF;\n  cursor: pointer;\n\n  &:hover {\n    background: #4AA1A9;\n    border-color: #4AA1A9;\n  }\n\n  &:disabled {\n    background: #B7DDE0;\n    border-color: #B7DDE0;\n    cursor: not-allowed;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDotFragment = __webpack_require__(11);
	
	var _reactDotFragment2 = _interopRequireDefault(_reactDotFragment);
	
	var _iconSearch = __webpack_require__(1850);
	
	var _iconSearch2 = _interopRequireDefault(_iconSearch);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _rosterUpload = __webpack_require__(1544);
	
	var _reassignUpload = __webpack_require__(1543);
	
	var _assignSectionsUpload = __webpack_require__(1541);
	
	var _changeRolesUpload = __webpack_require__(1542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TEMPLATE_CSV = 'First Name,Last Name,email,Team\n';
	
	var HeaderWrapper = _styledComponents2.default.div(_templateObject);
	
	var SearchInputWrapper = _styledComponents2.default.div(_templateObject2);
	
	var SearchInputIcon = _styledComponents2.default.div(_templateObject3);
	
	var SearchInput = _styledComponents2.default.input(_templateObject4);
	
	var PrimaryButton = _styledComponents2.default.button(_templateObject5);
	
	var UploadArrowIcon = function UploadArrowIcon() {
	  return _react2.default.createElement(
	    'svg',
	    { viewBox: '0 0 24 24', fill: 'none', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
	    _react2.default.createElement('path', { d: 'M4 4h16' }),
	    _react2.default.createElement('path', { d: 'M12 20V8' }),
	    _react2.default.createElement('path', { d: 'M6 14l6-6 6 6' })
	  );
	};
	
	var ModalOverlay = _styledComponents2.default.div(_templateObject6);
	
	var ModalCard = _styledComponents2.default.div(_templateObject7);
	
	var ModalTitle = _styledComponents2.default.h3(_templateObject8);
	
	var ModalBody = _styledComponents2.default.p(_templateObject9);
	
	var TemplateLink = _styledComponents2.default.button(_templateObject10);
	
	// "What do you want to do?" choice screen. Appears first when the
	// instructor opens the Add Students modal. Two large cards side by
	// side; clicking a card advances to that flow.
	var ChoiceGrid = _styledComponents2.default.div(_templateObject11);
	
	var ChoiceCard = _styledComponents2.default.button(_templateObject12);
	
	var ChoiceGridThree = _styledComponents2.default.div(_templateObject13);
	
	var ChoiceCardTitle = _styledComponents2.default.div(_templateObject14);
	
	var ChoiceCardDescription = _styledComponents2.default.div(_templateObject15);
	
	var BackLink = _styledComponents2.default.button(_templateObject16);
	
	var ReassignResultGrid = _styledComponents2.default.div(_templateObject17);
	
	var ReassignResultCell = _styledComponents2.default.div(_templateObject18);
	
	var ReassignResultLabel = _styledComponents2.default.span(_templateObject19);
	
	var DropZone = _styledComponents2.default.div(_templateObject20, function (p) {
	  return p.isDragging ? '#55B4BC' : '#CED1D6';
	}, function (p) {
	  return p.isDragging ? '#ECF6F7' : '#FAFBFD';
	});
	
	var DropZoneIcon = _styledComponents2.default.div(_templateObject21);
	
	var DropZoneText = _styledComponents2.default.div(_templateObject22);
	
	var DropZoneHint = _styledComponents2.default.div(_templateObject23);
	
	var AttachedFileRow = _styledComponents2.default.div(_templateObject24);
	
	var FileIconWrapper = _styledComponents2.default.div(_templateObject25);
	
	var FileMeta = _styledComponents2.default.div(_templateObject26);
	
	var FileName = _styledComponents2.default.div(_templateObject27);
	
	var FileSize = _styledComponents2.default.div(_templateObject28);
	
	var RemoveFileButton = _styledComponents2.default.button(_templateObject29);
	
	var HiddenFileInput = _styledComponents2.default.input(_templateObject30);
	
	var ProgressWrapper = _styledComponents2.default.div(_templateObject31);
	
	var ProgressHint = _styledComponents2.default.div(_templateObject32);
	
	var StepBlock = _styledComponents2.default.div(_templateObject33);
	
	var StepHeader = _styledComponents2.default.div(_templateObject34);
	
	var StepTitle = _styledComponents2.default.div(_templateObject35, function (p) {
	  return p.dimmed ? 'rgba(0, 27, 59, 0.5)' : 'rgba(0, 27, 59, 0.94)';
	});
	
	var StepStatus = _styledComponents2.default.div(_templateObject36, function (p) {
	  return p.done ? '#2DA548' : 'rgba(0, 27, 59, 0.6)';
	});
	
	var ProgressBarTrack = _styledComponents2.default.div(_templateObject37);
	
	var ProgressBarFill = _styledComponents2.default.div(_templateObject38, function (p) {
	  return p.done ? '#2DA548' : '#55B4BC';
	}, function (p) {
	  return p.percent;
	});
	
	var shimmerBar = '\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 40%;\n    background: linear-gradient(90deg, transparent, #55B4BC, transparent);\n    animation: rosterShimmer 1.4s ease-in-out infinite;\n  }\n\n  @keyframes rosterShimmer {\n    0% { transform: translateX(-100%); }\n    100% { transform: translateX(350%); }\n  }\n';
	
	var IndeterminateBar = _styledComponents2.default.div(_templateObject39, shimmerBar);
	
	var CheckIcon = function CheckIcon() {
	  return _react2.default.createElement(
	    'svg',
	    { viewBox: '0 0 24 24', fill: 'none', strokeWidth: '2.5', strokeLinecap: 'round', strokeLinejoin: 'round' },
	    _react2.default.createElement('polyline', { points: '20 6 9 17 4 12' })
	  );
	};
	
	// Pull a human-readable error list off a superagent error. Handles:
	//   - body.detail / body.message               (DRF single-string errors)
	//   - body.row_errors: [{ field: [msg], ... }] (BE roster upload shape)
	//   - body.<field>: [msg]                      (top-level field errors)
	// row_errors are aggregated by (field, message) with a count, so 30
	// rows failing "email: Enter a valid email address." collapse to one
	// line instead of 30 identical entries.
	var extractBackendErrorMessages = function extractBackendErrorMessages(err) {
	  var fallback = ['Upload failed. Please try again.'];
	  var body = err && err.response && err.response.body;
	  if (!body) {
	    return err && err.message ? [err.message] : fallback;
	  }
	  if (typeof body.detail === 'string') return [body.detail];
	  if (typeof body.message === 'string') return [body.message];
	
	  var lines = [];
	  if (Array.isArray(body.row_errors)) {
	    var agg = {};
	    body.row_errors.forEach(function (row) {
	      if (!row || (typeof row === 'undefined' ? 'undefined' : _typeof(row)) !== 'object') return;
	      Object.keys(row).forEach(function (field) {
	        var raw = row[field];
	        var messages = Array.isArray(raw) ? raw : [String(raw)];
	        messages.forEach(function (msg) {
	          if (!agg[field]) agg[field] = {};
	          agg[field][msg] = (agg[field][msg] || 0) + 1;
	        });
	      });
	    });
	    Object.keys(agg).forEach(function (field) {
	      Object.keys(agg[field]).forEach(function (msg) {
	        var count = agg[field][msg];
	        lines.push(count + ' row' + (count === 1 ? '' : 's') + ' with invalid ' + field + ': ' + msg);
	      });
	    });
	  }
	  if ((typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object') {
	    Object.keys(body).forEach(function (field) {
	      if (field === 'row_errors') return;
	      var val = body[field];
	      if (Array.isArray(val)) {
	        val.forEach(function (msg) {
	          return lines.push(field + ': ' + msg);
	        });
	      } else if (typeof val === 'string' && val) {
	        lines.push(field + ': ' + val);
	      }
	    });
	  }
	  if (lines.length > 0) return lines;
	  return err && err.message ? [err.message] : fallback;
	};
	
	var ErrorList = _styledComponents2.default.div(_templateObject40);
	
	var ErrorHeadline = _styledComponents2.default.div(_templateObject41);
	
	var ErrorItem = _styledComponents2.default.div(_templateObject42);
	
	var SuccessBox = _styledComponents2.default.div(_templateObject43);
	
	var ModalActions = _styledComponents2.default.div(_templateObject44);
	
	var CancelButton = _styledComponents2.default.button(_templateObject45);
	
	var UploadButton = _styledComponents2.default.button(_templateObject46);
	
	var UploadCloudIcon = function UploadCloudIcon() {
	  return _react2.default.createElement(
	    'svg',
	    { viewBox: '0 0 24 24', fill: 'none', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
	    _react2.default.createElement('path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }),
	    _react2.default.createElement('path', { d: 'M17 8l-5-5-5 5' }),
	    _react2.default.createElement('path', { d: 'M12 3v12' })
	  );
	};
	
	var FileIcon = function FileIcon() {
	  return _react2.default.createElement(
	    'svg',
	    { viewBox: '0 0 24 24', fill: 'none', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
	    _react2.default.createElement('path', { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }),
	    _react2.default.createElement('polyline', { points: '14 2 14 8 20 8' })
	  );
	};
	
	var CloseIcon = function CloseIcon() {
	  return _react2.default.createElement(
	    'svg',
	    { viewBox: '0 0 24 24', fill: 'none', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
	    _react2.default.createElement('line', { x1: '18', y1: '6', x2: '6', y2: '18' }),
	    _react2.default.createElement('line', { x1: '6', y1: '6', x2: '18', y2: '18' })
	  );
	};
	
	var triggerTemplateDownload = function triggerTemplateDownload() {
	  var blob = new Blob([TEMPLATE_CSV], { type: 'text/csv;charset=utf-8;' });
	  var url = URL.createObjectURL(blob);
	  var link = document.createElement('a');
	  link.href = url;
	  link.download = 'teams-roles-template.csv';
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	  URL.revokeObjectURL(url);
	};
	
	var triggerReassignTemplateDownload = function triggerReassignTemplateDownload() {
	  var blob = new Blob([_reassignUpload.REASSIGN_TEMPLATE_CSV], { type: 'text/csv;charset=utf-8;' });
	  var url = URL.createObjectURL(blob);
	  var link = document.createElement('a');
	  link.href = url;
	  link.download = 'reassign-teams-template.csv';
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	  URL.revokeObjectURL(url);
	};
	
	var triggerAssignSectionsTemplateDownload = function triggerAssignSectionsTemplateDownload() {
	  var blob = new Blob([_assignSectionsUpload.ASSIGN_SECTIONS_TEMPLATE_CSV], { type: 'text/csv;charset=utf-8;' });
	  var url = URL.createObjectURL(blob);
	  var link = document.createElement('a');
	  link.href = url;
	  link.download = 'assign-sections-template.csv';
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	  URL.revokeObjectURL(url);
	};
	
	var triggerChangeRolesTemplateDownload = function triggerChangeRolesTemplateDownload() {
	  var blob = new Blob([_changeRolesUpload.CHANGE_ROLES_TEMPLATE_CSV], { type: 'text/csv;charset=utf-8;' });
	  var url = URL.createObjectURL(blob);
	  var link = document.createElement('a');
	  link.href = url;
	  link.download = 'change-roles-template.csv';
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	  URL.revokeObjectURL(url);
	};
	
	var formatFileSize = function formatFileSize(bytes) {
	  if (!bytes && bytes !== 0) return '';
	  if (bytes < 1024) return bytes + ' B';
	  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
	  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
	};
	
	var STEP_TWO_STAGES = ['resolving_roles', 'uploading_game'];
	
	var computeStepState = function computeStepState(stage, pollMatched, pollTotal) {
	  var step1 = { percent: 0, status: 'Waiting to start', done: false, indeterminate: false };
	  var step2 = { percent: 0, status: 'Waiting to start', done: false, indeterminate: false };
	
	  var step1Complete = STEP_TWO_STAGES.indexOf(stage) >= 0 || stage === 'success';
	  var step2Complete = stage === 'success';
	
	  if (step1Complete) {
	    step1.percent = 100;
	    step1.status = 'Complete';
	    step1.done = true;
	  } else if (stage === 'parsing' || stage === 'validating') {
	    step1.percent = 5;
	    step1.status = 'Preparing your file';
	    step1.indeterminate = true;
	  } else if (stage === 'checking_existing') {
	    step1.percent = 10;
	    step1.status = 'Checking for existing course members';
	    step1.indeterminate = true;
	  } else if (stage === 'uploading_students') {
	    step1.percent = 15;
	    step1.status = 'Uploading roster to your course';
	    step1.indeterminate = true;
	  } else if (stage === 'polling') {
	    var total = pollTotal || 0;
	    var matched = Math.min(pollMatched || 0, total);
	    var p = total > 0 ? 15 + Math.round(matched / total * 85) : 15;
	    step1.percent = p;
	    step1.status = matched + ' of ' + total + ' students';
	    step1.indeterminate = total === 0;
	  }
	
	  if (step2Complete) {
	    step2.percent = 100;
	    step2.status = 'Complete';
	    step2.done = true;
	  } else if (stage === 'resolving_roles') {
	    step2.percent = 25;
	    step2.status = 'Assigning roles and grouping into competitions';
	    step2.indeterminate = true;
	  } else if (stage === 'uploading_game') {
	    step2.percent = 70;
	    step2.status = 'Adding students to teams and competitions';
	    step2.indeterminate = true;
	  }
	
	  return { step1: step1, step2: step2 };
	};
	
	var TeamsRolesSearch = function (_PureComponent) {
	  _inherits(TeamsRolesSearch, _PureComponent);
	
	  function TeamsRolesSearch(props) {
	    _classCallCheck(this, TeamsRolesSearch);
	
	    var _this = _possibleConstructorReturn(this, (TeamsRolesSearch.__proto__ || Object.getPrototypeOf(TeamsRolesSearch)).call(this, props));
	
	    _this.handleInputChange = function (event) {
	      var handleQueryChange = _this.props.handleQueryChange;
	      var typingTimeout = _this.state.typingTimeout;
	
	
	      if (typingTimeout) {
	        clearTimeout(typingTimeout);
	      }
	
	      var newQuery = event.target.value;
	
	      _this.setState({
	        query: newQuery,
	        typing: false,
	        typingTimeout: setTimeout(function () {
	          handleQueryChange(newQuery);
	        }, 2000)
	      });
	    };
	
	    _this.openAddStudents = function () {
	      _this.setState({
	        showAddModal: true,
	        modalMode: 'choice',
	        selectedFile: null,
	        isDragging: false,
	        stage: null,
	        pollMatched: 0,
	        pollTotal: 0,
	        validationErrors: null,
	        apiError: null,
	        successMessage: null,
	        reassignStage: null,
	        reassignResult: null,
	        sectionsStage: null,
	        sectionsResult: null,
	        rolesStage: null,
	        rolesResult: null
	      });
	    };
	
	    _this.closeAddStudents = function () {
	      if (_this.isInProgress()) return;
	      _this.setState({
	        showAddModal: false,
	        modalMode: 'choice',
	        selectedFile: null,
	        isDragging: false,
	        stage: null,
	        pollMatched: 0,
	        pollTotal: 0,
	        validationErrors: null,
	        apiError: null,
	        successMessage: null,
	        reassignStage: null,
	        reassignResult: null,
	        sectionsStage: null,
	        sectionsResult: null,
	        rolesStage: null,
	        rolesResult: null
	      });
	    };
	
	    _this.chooseAddNew = function () {
	      _this.setState({
	        modalMode: 'add-new',
	        selectedFile: null,
	        isDragging: false,
	        stage: null,
	        validationErrors: null,
	        apiError: null,
	        successMessage: null
	      });
	    };
	
	    _this.chooseModifyRoster = function () {
	      _this.setState({
	        modalMode: 'modify-choice',
	        selectedFile: null,
	        isDragging: false,
	        validationErrors: null,
	        apiError: null,
	        reassignStage: null,
	        reassignResult: null,
	        sectionsStage: null,
	        sectionsResult: null,
	        rolesStage: null,
	        rolesResult: null
	      });
	    };
	
	    _this.chooseAssignSections = function () {
	      _this.setState({
	        modalMode: 'assign-sections',
	        selectedFile: null,
	        isDragging: false,
	        validationErrors: null,
	        apiError: null,
	        sectionsStage: null,
	        sectionsResult: null
	      });
	    };
	
	    _this.chooseReassign = function () {
	      _this.setState({
	        modalMode: 'reassign',
	        selectedFile: null,
	        isDragging: false,
	        validationErrors: null,
	        apiError: null,
	        reassignStage: null,
	        reassignResult: null
	      });
	    };
	
	    _this.chooseChangeRoles = function () {
	      _this.setState({
	        modalMode: 'change-roles',
	        selectedFile: null,
	        isDragging: false,
	        validationErrors: null,
	        apiError: null,
	        rolesStage: null,
	        rolesResult: null
	      });
	    };
	
	    _this.backToModifyChoice = function () {
	      if (_this.isInProgress()) return;
	      _this.setState({
	        modalMode: 'modify-choice',
	        selectedFile: null,
	        isDragging: false,
	        validationErrors: null,
	        apiError: null,
	        reassignStage: null,
	        reassignResult: null,
	        sectionsStage: null,
	        sectionsResult: null,
	        rolesStage: null,
	        rolesResult: null
	      });
	    };
	
	    _this.backToChoice = function () {
	      if (_this.isInProgress()) return;
	      _this.setState({
	        modalMode: 'choice',
	        selectedFile: null,
	        isDragging: false,
	        stage: null,
	        validationErrors: null,
	        apiError: null,
	        successMessage: null,
	        reassignStage: null,
	        reassignResult: null,
	        sectionsStage: null,
	        sectionsResult: null,
	        rolesStage: null,
	        rolesResult: null
	      });
	    };
	
	    _this.isInProgress = function () {
	      var _this$state = _this.state,
	          stage = _this$state.stage,
	          reassignStage = _this$state.reassignStage,
	          sectionsStage = _this$state.sectionsStage,
	          rolesStage = _this$state.rolesStage;
	
	      var addNewInProgress = stage !== null && stage !== 'success' && stage !== 'error';
	      var reassignInProgress = reassignStage === 'uploading';
	      var sectionsInProgress = sectionsStage === 'uploading';
	      var rolesInProgress = rolesStage === 'uploading';
	      return addNewInProgress || reassignInProgress || sectionsInProgress || rolesInProgress;
	    };
	
	    _this.setFileInputRef = function (el) {
	      _this.fileInputRef = el;
	    };
	
	    _this.openFilePicker = function () {
	      if (_this.fileInputRef) _this.fileInputRef.click();
	    };
	
	    _this.handleFileInputChange = function (event) {
	      var file = event.target.files && event.target.files[0];
	      if (file) _this.setState({ selectedFile: file, validationErrors: null, apiError: null });
	      if (event.target) event.target.value = '';
	    };
	
	    _this.handleRemoveFile = function () {
	      _this.setState({ selectedFile: null, validationErrors: null, apiError: null });
	    };
	
	    _this.handleDragOver = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (!_this.state.isDragging) _this.setState({ isDragging: true });
	    };
	
	    _this.handleDragLeave = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      _this.setState({ isDragging: false });
	    };
	
	    _this.handleDrop = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      _this.setState({ isDragging: false });
	      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
	      if (file) _this.setState({ selectedFile: file, validationErrors: null, apiError: null });
	    };
	
	    _this.handleUploadClick = function () {
	      var selectedFile = _this.state.selectedFile;
	
	      if (!selectedFile) return;
	
	      _this.setState({
	        validationErrors: null,
	        apiError: null,
	        stage: 'parsing',
	        pollMatched: 0,
	        pollTotal: 0
	      });
	
	      var courseId = _Auth2.default.getCourseId();
	      // Prefer props (App state) over sessionStorage — Auth.getGameId()
	      // returns 0 when sessionStorage was never populated (e.g. no game
	      // was surfaced from general-info at App load), which the backend
	      // rejects with "Game with ID=0 does not exist". Fall back to
	      // Auth.getGameId() so existing users with a valid session don't
	      // regress.
	      var resolveGameId = function resolveGameId() {
	        var propGame = _this.props.game;
	        var propGames = _this.props.games;
	        return propGame && propGame.id || Array.isArray(propGames) && propGames.length > 0 && propGames[0].id || _Auth2.default.getGameId();
	      };
	
	      var gameId = resolveGameId();
	      if (!gameId) {
	        // Recovery path for the "first click after fresh login" race,
	        // where general-info hadn't populated game context in App state
	        // yet and Auth.getGameId returned 0. Bust the cache, refetch
	        // general-info, pick a game from the response, and retry the
	        // upload with that id. Previously the only workaround was a
	        // manual page refresh. If we still can't find a game after this,
	        // surface an actionable error instead of firing the upload with
	        // game_id=0.
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	        (0, _AppGeneralInfoService.fetchAppGeneralInfo)(0, 'instructor').then(function (data) {
	          var _pickCourseAndGame = (0, _AppGeneralInfoService.pickCourseAndGame)(data && data.courses || [], data && data.games || []),
	              game = _pickCourseAndGame.game;
	
	          var resolvedId = game && game.id;
	          if (!resolvedId) {
	            _this.setState({
	              stage: 'error',
	              apiError: ['We couldn\'t find a game for your course. Please refresh the page and try again.']
	            });
	            return;
	          }
	          _Auth2.default.setGameId(resolvedId);
	          _this.runUpload(selectedFile, courseId, resolvedId);
	        }).catch(function () {
	          _this.setState({
	            stage: 'error',
	            apiError: ['We couldn\'t look up your game. Please refresh the page and try again.']
	          });
	        });
	        return;
	      }
	
	      _this.runUpload(selectedFile, courseId, gameId);
	    };
	
	    _this.handleReassignUploadClick = function () {
	      var selectedFile = _this.state.selectedFile;
	
	      if (!selectedFile) return;
	
	      var resolveGameId = function resolveGameId() {
	        var propGame = _this.props.game;
	        var propGames = _this.props.games;
	        return propGame && propGame.id || Array.isArray(propGames) && propGames.length > 0 && propGames[0].id || _Auth2.default.getGameId();
	      };
	      var gameId = resolveGameId();
	      if (!gameId) {
	        _this.setState({
	          reassignStage: 'error',
	          apiError: ['We couldn\'t find a game for your course. Please refresh the page and try again.']
	        });
	        return;
	      }
	
	      _this.setState({
	        reassignStage: 'uploading',
	        validationErrors: null,
	        apiError: null,
	        reassignResult: null
	      });
	
	      (0, _reassignUpload.runReassignUpload)({ file: selectedFile, gameId: gameId }).then(function (result) {
	        _this.setState({ reassignStage: 'success', reassignResult: result });
	        var onImportComplete = _this.props.onImportComplete;
	
	        if (onImportComplete) onImportComplete();
	      }).catch(function (err) {
	        if (err && err.kind === 'validation') {
	          _this.setState({
	            reassignStage: null,
	            validationErrors: err.errors || [err.message || 'Validation failed.']
	          });
	          return;
	        }
	        var messages = extractBackendErrorMessages(err);
	        _this.setState({ reassignStage: 'error', apiError: messages });
	      });
	    };
	
	    _this.resolveGameIdFromProps = function () {
	      var propGame = _this.props.game;
	      var propGames = _this.props.games;
	      return propGame && propGame.id || Array.isArray(propGames) && propGames.length > 0 && propGames[0].id || _Auth2.default.getGameId();
	    };
	
	    _this.handleSectionsUploadClick = function () {
	      var selectedFile = _this.state.selectedFile;
	
	      if (!selectedFile) return;
	
	      var courseId = _Auth2.default.getCourseId();
	      var gameId = _this.resolveGameIdFromProps();
	      if (!gameId) {
	        _this.setState({
	          sectionsStage: 'error',
	          apiError: ['We couldn\'t find a game for your course. Please refresh the page and try again.']
	        });
	        return;
	      }
	
	      _this.setState({
	        sectionsStage: 'uploading',
	        validationErrors: null,
	        apiError: null,
	        sectionsResult: null
	      });
	
	      (0, _assignSectionsUpload.runAssignSectionsUpload)({ file: selectedFile, courseId: courseId, gameId: gameId }).then(function (result) {
	        _this.setState({ sectionsStage: 'success', sectionsResult: result });
	        var onImportComplete = _this.props.onImportComplete;
	
	        if (onImportComplete) onImportComplete();
	      }).catch(function (err) {
	        if (err && err.kind === 'validation') {
	          _this.setState({
	            sectionsStage: null,
	            validationErrors: err.errors || [err.message || 'Validation failed.']
	          });
	          return;
	        }
	        if (err && err.kind === 'api') {
	          _this.setState({ sectionsStage: 'error', apiError: err.errors || [err.message] });
	          return;
	        }
	        var messages = extractBackendErrorMessages(err);
	        _this.setState({ sectionsStage: 'error', apiError: messages });
	      });
	    };
	
	    _this.handleRolesUploadClick = function () {
	      var selectedFile = _this.state.selectedFile;
	
	      if (!selectedFile) return;
	
	      var gameId = _this.resolveGameIdFromProps();
	      if (!gameId) {
	        _this.setState({
	          rolesStage: 'error',
	          apiError: ['We couldn\'t find a game for your course. Please refresh the page and try again.']
	        });
	        return;
	      }
	
	      _this.setState({
	        rolesStage: 'uploading',
	        validationErrors: null,
	        apiError: null,
	        rolesResult: null
	      });
	
	      (0, _changeRolesUpload.runChangeRolesUpload)({ file: selectedFile, gameId: gameId }).then(function (result) {
	        _this.setState({ rolesStage: 'success', rolesResult: result });
	        var onImportComplete = _this.props.onImportComplete;
	
	        if (onImportComplete) onImportComplete();
	      }).catch(function (err) {
	        if (err && err.kind === 'validation') {
	          _this.setState({
	            rolesStage: null,
	            validationErrors: err.errors || [err.message || 'Validation failed.']
	          });
	          return;
	        }
	        if (err && err.kind === 'api') {
	          _this.setState({ rolesStage: 'error', apiError: err.errors || [err.message] });
	          return;
	        }
	        var messages = extractBackendErrorMessages(err);
	        _this.setState({ rolesStage: 'error', apiError: messages });
	      });
	    };
	
	    _this.runUpload = function (file, courseId, gameId) {
	      (0, _rosterUpload.runRosterUpload)({
	        file: file,
	        courseId: courseId,
	        gameId: gameId,
	        onProgress: function onProgress(info) {
	          var next = { stage: info.stage };
	          if (info.stage === 'polling') {
	            next.pollMatched = info.matched != null ? info.matched : 0;
	            next.pollTotal = info.total != null ? info.total : 0;
	          }
	          if (info.stage === 'success') {
	            var added = info.addedCount || 0;
	            var skipped = info.skippedCount || 0;
	            var teams = info.numTeams || 0;
	            var comps = info.numCompetitions || 0;
	            var teamsLabel = teams + ' team' + (teams === 1 ? '' : 's');
	            var compsLabel = comps + ' competition' + (comps === 1 ? '' : 's');
	            var groupingLabel = teamsLabel + ' across ' + compsLabel;
	            var message = void 0;
	            if (added === 0 && skipped > 0) {
	              message = 'All ' + skipped + ' students were already in the course. Assigned to ' + groupingLabel + '.';
	            } else if (added > 0 && skipped > 0) {
	              message = 'Added ' + added + ' new student' + (added === 1 ? '' : 's') + ' (' + skipped + ' already existed) across ' + groupingLabel + '.';
	            } else {
	              message = 'Added ' + added + ' student' + (added === 1 ? '' : 's') + ' across ' + groupingLabel + '.';
	            }
	            next.successMessage = message;
	          }
	          _this.setState(next);
	        }
	      }).then(function () {
	        _this.setState({ stage: 'success' });
	        var onImportComplete = _this.props.onImportComplete;
	
	        if (onImportComplete) onImportComplete();
	      }).catch(function (err) {
	        if (err && err.kind === 'validation') {
	          _this.setState({
	            stage: null,
	            validationErrors: err.errors || [err.message || 'Validation failed.']
	          });
	        } else {
	          var messages = extractBackendErrorMessages(err);
	          _this.setState({ stage: 'error', apiError: messages });
	        }
	      });
	    };
	
	    _this.renderChoiceScreen = function () {
	      var roster = _this.props.courseMembers || [];
	      // Only student rows gate Modify Roster. Instructors / co-instructors /
	      // instructor assistants on course_members shouldn't keep the button
	      // active when there's nobody to modify. course_members payload uses
	      // numeric `type` (1 = Student).
	      var studentCount = roster.filter(function (m) {
	        return m && Number(m.type) === 1;
	      }).length;
	      var hasStudents = studentCount > 0;
	      var modifyTooltip = hasStudents ? '' : 'Add new students to the course first before modifying the roster.';
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          ModalTitle,
	          null,
	          'Add Students'
	        ),
	        _react2.default.createElement(
	          ModalBody,
	          null,
	          'Are you adding new students to the course, or modifying the existing roster?'
	        ),
	        _react2.default.createElement(
	          ChoiceGrid,
	          null,
	          _react2.default.createElement(
	            ChoiceCard,
	            { type: 'button', onClick: _this.chooseAddNew },
	            _react2.default.createElement(
	              ChoiceCardTitle,
	              null,
	              'Add new students'
	            ),
	            _react2.default.createElement(
	              ChoiceCardDescription,
	              null,
	              'Upload a CSV to enroll students in the course and place them on teams.'
	            )
	          ),
	          _react2.default.createElement(
	            ChoiceCard,
	            {
	              type: 'button',
	              onClick: _this.chooseModifyRoster,
	              disabled: !hasStudents,
	              title: modifyTooltip
	            },
	            _react2.default.createElement(
	              ChoiceCardTitle,
	              null,
	              'Modify roster'
	            ),
	            _react2.default.createElement(
	              ChoiceCardDescription,
	              null,
	              'Assign unassigned students to sections, reassign students to different teams, or change student roles.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ModalActions,
	          null,
	          _react2.default.createElement(
	            CancelButton,
	            { type: 'button', onClick: _this.closeAddStudents },
	            'Cancel'
	          )
	        )
	      );
	    };
	
	    _this.renderModifyChoiceScreen = function () {
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        _react2.default.createElement(
	          BackLink,
	          { type: 'button', onClick: _this.backToChoice },
	          '\u2190 Back'
	        ),
	        _react2.default.createElement(
	          ModalTitle,
	          null,
	          'Modify roster'
	        ),
	        _react2.default.createElement(
	          ModalBody,
	          null,
	          'Pick what to update. Each option takes a different CSV.'
	        ),
	        _react2.default.createElement(
	          ChoiceGridThree,
	          null,
	          _react2.default.createElement(
	            ChoiceCard,
	            { type: 'button', onClick: _this.chooseAssignSections },
	            _react2.default.createElement(
	              ChoiceCardTitle,
	              null,
	              'Assign to sections'
	            ),
	            _react2.default.createElement(
	              ChoiceCardDescription,
	              null,
	              'Upload a CSV to assign unassigned students to sections.'
	            )
	          ),
	          _react2.default.createElement(
	            ChoiceCard,
	            { type: 'button', onClick: _this.chooseReassign },
	            _react2.default.createElement(
	              ChoiceCardTitle,
	              null,
	              'Reassign teams'
	            ),
	            _react2.default.createElement(
	              ChoiceCardDescription,
	              null,
	              'Upload a CSV to move existing students to a different team.'
	            )
	          ),
	          _react2.default.createElement(
	            ChoiceCard,
	            { type: 'button', onClick: _this.chooseChangeRoles },
	            _react2.default.createElement(
	              ChoiceCardTitle,
	              null,
	              'Change roles'
	            ),
	            _react2.default.createElement(
	              ChoiceCardDescription,
	              null,
	              'Upload a CSV to update CEO / PD / PM / OP / FI / VI roles.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          ModalActions,
	          null,
	          _react2.default.createElement(
	            CancelButton,
	            { type: 'button', onClick: _this.closeAddStudents },
	            'Cancel'
	          )
	        )
	      );
	    };
	
	    _this.renderAddNewFlow = function () {
	      var _this$state2 = _this.state,
	          selectedFile = _this$state2.selectedFile,
	          isDragging = _this$state2.isDragging,
	          stage = _this$state2.stage,
	          validationErrors = _this$state2.validationErrors,
	          apiError = _this$state2.apiError,
	          successMessage = _this$state2.successMessage;
	
	
	      var inProgress = _this.isInProgress();
	      var isSuccess = stage === 'success';
	      var isError = stage === 'error';
	      var showFileControls = !inProgress && !isSuccess;
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        !inProgress && !isSuccess && _react2.default.createElement(
	          BackLink,
	          { type: 'button', onClick: _this.backToChoice },
	          '\u2190 Back'
	        ),
	        _react2.default.createElement(
	          ModalTitle,
	          null,
	          'Add new students'
	        ),
	        !isSuccess && _react2.default.createElement(
	          ModalBody,
	          null,
	          'Use ',
	          _react2.default.createElement(
	            TemplateLink,
	            { type: 'button', onClick: triggerTemplateDownload },
	            'this template'
	          ),
	          ' to bulk add or modify teams.'
	        ),
	        showFileControls && !selectedFile && !validationErrors && !apiError && _react2.default.createElement(
	          DropZone,
	          {
	            isDragging: isDragging,
	            onClick: _this.openFilePicker,
	            onDragOver: _this.handleDragOver,
	            onDragEnter: _this.handleDragOver,
	            onDragLeave: _this.handleDragLeave,
	            onDrop: _this.handleDrop
	          },
	          _react2.default.createElement(
	            DropZoneIcon,
	            null,
	            _react2.default.createElement(UploadCloudIcon, null)
	          ),
	          _react2.default.createElement(
	            DropZoneText,
	            null,
	            'Drop your CSV file here or click to browse'
	          ),
	          _react2.default.createElement(
	            DropZoneHint,
	            null,
	            'Accepts .csv files exported from the template above'
	          )
	        ),
	        showFileControls && selectedFile && _react2.default.createElement(
	          AttachedFileRow,
	          null,
	          _react2.default.createElement(
	            FileIconWrapper,
	            null,
	            _react2.default.createElement(FileIcon, null)
	          ),
	          _react2.default.createElement(
	            FileMeta,
	            null,
	            _react2.default.createElement(
	              FileName,
	              null,
	              selectedFile.name
	            ),
	            _react2.default.createElement(
	              FileSize,
	              null,
	              formatFileSize(selectedFile.size)
	            )
	          ),
	          _react2.default.createElement(
	            RemoveFileButton,
	            {
	              type: 'button',
	              onClick: _this.handleRemoveFile,
	              title: 'Remove file'
	            },
	            _react2.default.createElement(CloseIcon, null)
	          )
	        ),
	        validationErrors && validationErrors.length > 0 && _react2.default.createElement(
	          ErrorList,
	          null,
	          _react2.default.createElement(
	            ErrorHeadline,
	            null,
	            'Please fix the following before uploading:'
	          ),
	          validationErrors.map(function (msg, idx) {
	            return _react2.default.createElement(
	              ErrorItem,
	              { key: idx },
	              msg
	            );
	          })
	        ),
	        isError && apiError && apiError.length > 0 && _react2.default.createElement(
	          ErrorList,
	          null,
	          _react2.default.createElement(
	            ErrorHeadline,
	            null,
	            'Upload failed'
	          ),
	          apiError.map(function (msg, idx) {
	            return _react2.default.createElement(
	              ErrorItem,
	              { key: idx },
	              msg
	            );
	          })
	        ),
	        inProgress && _this.renderProgress(),
	        isSuccess && successMessage && _react2.default.createElement(
	          SuccessBox,
	          null,
	          successMessage
	        ),
	        _react2.default.createElement(
	          ModalActions,
	          null,
	          isSuccess ? _react2.default.createElement(
	            UploadButton,
	            { type: 'button', onClick: _this.closeAddStudents },
	            'Done'
	          ) : _react2.default.createElement(
	            _reactDotFragment2.default,
	            null,
	            _react2.default.createElement(
	              CancelButton,
	              {
	                type: 'button',
	                onClick: _this.closeAddStudents,
	                disabled: inProgress
	              },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              UploadButton,
	              {
	                type: 'button',
	                onClick: _this.handleUploadClick,
	                disabled: !selectedFile || inProgress
	              },
	              inProgress ? 'Uploading...' : 'Upload'
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderBulkAssignSubFlow = function (_ref) {
	      var title = _ref.title,
	          bodyCopy = _ref.bodyCopy,
	          stage = _ref.stage,
	          result = _ref.result,
	          onUpload = _ref.onUpload,
	          renderSuccess = _ref.renderSuccess;
	      var _this$state3 = _this.state,
	          selectedFile = _this$state3.selectedFile,
	          isDragging = _this$state3.isDragging,
	          validationErrors = _this$state3.validationErrors,
	          apiError = _this$state3.apiError;
	
	      var inProgress = stage === 'uploading';
	      var isSuccess = stage === 'success';
	      var isError = stage === 'error';
	      var showFileControls = !inProgress && !isSuccess;
	
	      return _react2.default.createElement(
	        _reactDotFragment2.default,
	        null,
	        !inProgress && !isSuccess && _react2.default.createElement(
	          BackLink,
	          { type: 'button', onClick: _this.backToModifyChoice },
	          '\u2190 Back'
	        ),
	        _react2.default.createElement(
	          ModalTitle,
	          null,
	          title
	        ),
	        !isSuccess && _react2.default.createElement(
	          ModalBody,
	          null,
	          bodyCopy
	        ),
	        showFileControls && !selectedFile && !validationErrors && !apiError && _react2.default.createElement(
	          DropZone,
	          {
	            isDragging: isDragging,
	            onClick: _this.openFilePicker,
	            onDragOver: _this.handleDragOver,
	            onDragEnter: _this.handleDragOver,
	            onDragLeave: _this.handleDragLeave,
	            onDrop: _this.handleDrop
	          },
	          _react2.default.createElement(
	            DropZoneIcon,
	            null,
	            _react2.default.createElement(UploadCloudIcon, null)
	          ),
	          _react2.default.createElement(
	            DropZoneText,
	            null,
	            'Drop your CSV file here or click to browse'
	          ),
	          _react2.default.createElement(
	            DropZoneHint,
	            null,
	            'Accepts .csv files that match the template above'
	          )
	        ),
	        showFileControls && selectedFile && _react2.default.createElement(
	          AttachedFileRow,
	          null,
	          _react2.default.createElement(
	            FileIconWrapper,
	            null,
	            _react2.default.createElement(FileIcon, null)
	          ),
	          _react2.default.createElement(
	            FileMeta,
	            null,
	            _react2.default.createElement(
	              FileName,
	              null,
	              selectedFile.name
	            ),
	            _react2.default.createElement(
	              FileSize,
	              null,
	              formatFileSize(selectedFile.size)
	            )
	          ),
	          _react2.default.createElement(
	            RemoveFileButton,
	            {
	              type: 'button',
	              onClick: _this.handleRemoveFile,
	              title: 'Remove file'
	            },
	            _react2.default.createElement(CloseIcon, null)
	          )
	        ),
	        validationErrors && validationErrors.length > 0 && _react2.default.createElement(
	          ErrorList,
	          null,
	          _react2.default.createElement(
	            ErrorHeadline,
	            null,
	            'Please fix the following before uploading:'
	          ),
	          validationErrors.map(function (msg, idx) {
	            return _react2.default.createElement(
	              ErrorItem,
	              { key: idx },
	              msg
	            );
	          })
	        ),
	        isError && apiError && apiError.length > 0 && _react2.default.createElement(
	          ErrorList,
	          null,
	          _react2.default.createElement(
	            ErrorHeadline,
	            null,
	            'Upload failed'
	          ),
	          apiError.map(function (msg, idx) {
	            return _react2.default.createElement(
	              ErrorItem,
	              { key: idx },
	              msg
	            );
	          })
	        ),
	        isSuccess && renderSuccess && renderSuccess(result),
	        _react2.default.createElement(
	          ModalActions,
	          null,
	          isSuccess ? _react2.default.createElement(
	            UploadButton,
	            { type: 'button', onClick: _this.closeAddStudents },
	            'Done'
	          ) : _react2.default.createElement(
	            _reactDotFragment2.default,
	            null,
	            _react2.default.createElement(
	              CancelButton,
	              {
	                type: 'button',
	                onClick: _this.closeAddStudents,
	                disabled: inProgress
	              },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              UploadButton,
	              {
	                type: 'button',
	                onClick: onUpload,
	                disabled: !selectedFile || inProgress
	              },
	              inProgress ? 'Uploading...' : 'Upload'
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderReassignFlow = function () {
	      return _this.renderBulkAssignSubFlow({
	        title: 'Reassign teams',
	        bodyCopy: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Upload a CSV with an ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'email'
	          ),
	          ' column plus a ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'team'
	          ),
	          ' (or ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'team_id'
	          ),
	          ') column. Only students already on a team in this game can be reassigned. Use ',
	          _react2.default.createElement(
	            TemplateLink,
	            { type: 'button', onClick: triggerReassignTemplateDownload },
	            'this template'
	          ),
	          ' to get started.'
	        ),
	        stage: _this.state.reassignStage,
	        result: _this.state.reassignResult,
	        onUpload: _this.handleReassignUploadClick,
	        renderSuccess: function renderSuccess(result) {
	          return _react2.default.createElement(
	            SuccessBox,
	            null,
	            _react2.default.createElement(
	              ReassignResultGrid,
	              null,
	              _react2.default.createElement(
	                ReassignResultCell,
	                null,
	                _react2.default.createElement(
	                  ReassignResultLabel,
	                  null,
	                  'Rows processed:'
	                ),
	                result && result.rows != null ? result.rows : 0
	              ),
	              _react2.default.createElement(
	                ReassignResultCell,
	                null,
	                _react2.default.createElement(
	                  ReassignResultLabel,
	                  null,
	                  'Unchanged:'
	                ),
	                result && result.unchanged != null ? result.unchanged : 0
	              ),
	              _react2.default.createElement(
	                ReassignResultCell,
	                null,
	                _react2.default.createElement(
	                  ReassignResultLabel,
	                  null,
	                  'Team updates:'
	                ),
	                result && result.team_updates != null ? result.team_updates : 0
	              )
	            )
	          );
	        }
	      });
	    };
	
	    _this.renderAssignSectionsFlow = function () {
	      return _this.renderBulkAssignSubFlow({
	        title: 'Assign to sections',
	        bodyCopy: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Upload a CSV with a ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'username'
	          ),
	          ' column plus a ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'section'
	          ),
	          ' (or ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'section_id'
	          ),
	          ') column. Every unassigned student must appear exactly once, and no already-assigned student may be in the file. Use ',
	          _react2.default.createElement(
	            TemplateLink,
	            { type: 'button', onClick: triggerAssignSectionsTemplateDownload },
	            'this template'
	          ),
	          ' to get started.'
	        ),
	        stage: _this.state.sectionsStage,
	        result: _this.state.sectionsResult,
	        onUpload: _this.handleSectionsUploadClick,
	        renderSuccess: function renderSuccess(result) {
	          return _react2.default.createElement(
	            SuccessBox,
	            null,
	            result && typeof result.updated === 'number' ? 'Assigned ' + result.updated + ' student' + (result.updated === 1 ? '' : 's') + ' to sections.' : 'Students have been assigned to their sections.'
	          );
	        }
	      });
	    };
	
	    _this.renderChangeRolesFlow = function () {
	      return _this.renderBulkAssignSubFlow({
	        title: 'Change roles',
	        bodyCopy: _react2.default.createElement(
	          _reactDotFragment2.default,
	          null,
	          'Upload a CSV with an ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'email'
	          ),
	          ' column and a ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'role'
	          ),
	          ' column. Role values must be one of ',
	          _react2.default.createElement(
	            'b',
	            null,
	            'CEO, PD, PM, OP, FI, VI'
	          ),
	          '. Students must already be on a team in this game. Use ',
	          _react2.default.createElement(
	            TemplateLink,
	            { type: 'button', onClick: triggerChangeRolesTemplateDownload },
	            'this template'
	          ),
	          ' to get started.'
	        ),
	        stage: _this.state.rolesStage,
	        result: _this.state.rolesResult,
	        onUpload: _this.handleRolesUploadClick,
	        renderSuccess: function renderSuccess(result) {
	          return _react2.default.createElement(
	            SuccessBox,
	            null,
	            result && typeof result.updated === 'number' ? 'Updated roles for ' + result.updated + ' student' + (result.updated === 1 ? '' : 's') + '.' : 'Student roles have been updated.'
	          );
	        }
	      });
	    };
	
	    _this.state = {
	      query: '',
	      typing: false,
	      typingTimeout: 0,
	      showAddModal: false,
	      // Modal step machine:
	      //   'choice'          → primary two-card picker (Add New / Modify Roster)
	      //   'modify-choice'   → three-card picker under Modify Roster
	      //   'add-new'         → full roster upload
	      //   'assign-sections' → POST bulk-assign-sections
	      //   'reassign'        → POST bulk-assign  (team-only)
	      //   'change-roles'    → POST bulk-assign-roles
	      modalMode: 'choice',
	      selectedFile: null,
	      isDragging: false,
	      stage: null,
	      pollMatched: 0,
	      pollTotal: 0,
	      validationErrors: null,
	      apiError: null,
	      successMessage: null,
	      // Per-sub-flow state. Stage values: null | 'uploading' |
	      // 'success' | 'error'. Result holds the BE's response body for
	      // rendering counts.
	      reassignStage: null,
	      reassignResult: null,
	      sectionsStage: null,
	      sectionsResult: null,
	      rolesStage: null,
	      rolesResult: null
	    };
	
	    _this.fileInputRef = null;
	    return _this;
	  }
	
	  // Choice screen card handlers. Clear per-flow state so re-entering
	  // a flow (via Back) starts clean.
	
	
	  _createClass(TeamsRolesSearch, [{
	    key: 'renderStep',
	    value: function renderStep(index, title, state) {
	      var isActive = !state.done && state.percent > 0;
	      return _react2.default.createElement(
	        StepBlock,
	        null,
	        _react2.default.createElement(
	          StepHeader,
	          null,
	          _react2.default.createElement(
	            StepTitle,
	            { dimmed: !isActive && !state.done },
	            state.done && _react2.default.createElement(CheckIcon, null),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Step ',
	              index,
	              ' of 2: ',
	              title
	            )
	          ),
	          _react2.default.createElement(
	            StepStatus,
	            { done: state.done },
	            state.status
	          )
	        ),
	        _react2.default.createElement(
	          ProgressBarTrack,
	          null,
	          _react2.default.createElement(ProgressBarFill, { percent: state.percent, done: state.done }),
	          state.indeterminate && !state.done && _react2.default.createElement(IndeterminateBar, null)
	        )
	      );
	    }
	  }, {
	    key: 'renderProgress',
	    value: function renderProgress() {
	      var _state = this.state,
	          stage = _state.stage,
	          pollMatched = _state.pollMatched,
	          pollTotal = _state.pollTotal;
	
	      var _computeStepState = computeStepState(stage, pollMatched, pollTotal),
	          step1 = _computeStepState.step1,
	          step2 = _computeStepState.step2;
	
	      return _react2.default.createElement(
	        ProgressWrapper,
	        null,
	        this.renderStep(1, 'Adding students to your course', step1),
	        this.renderStep(2, 'Adding students to teams and competitions', step2),
	        _react2.default.createElement(
	          ProgressHint,
	          null,
	          'This can take up to a few minutes for large rosters. Please keep this window open until it finishes.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          query = _state2.query,
	          showAddModal = _state2.showAddModal,
	          modalMode = _state2.modalMode;
	
	
	      var inProgress = this.isInProgress();
	
	      return _react2.default.createElement(
	        HeaderWrapper,
	        null,
	        _react2.default.createElement(
	          SearchInputWrapper,
	          null,
	          _react2.default.createElement(
	            SearchInputIcon,
	            null,
	            _react2.default.createElement('img', { src: _iconSearch2.default, alt: 'Search' })
	          ),
	          _react2.default.createElement(SearchInput, {
	            type: 'text',
	            value: query,
	            placeholder: 'Search by name or email',
	            onChange: this.handleInputChange
	          })
	        ),
	        !_Auth2.default.isAssistantOrCoInstructor() && _react2.default.createElement(
	          PrimaryButton,
	          { type: 'button', onClick: this.openAddStudents },
	          _react2.default.createElement(UploadArrowIcon, null),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Add Students'
	          )
	        ),
	        showAddModal && _react2.default.createElement(
	          ModalOverlay,
	          { onClick: inProgress ? undefined : this.closeAddStudents },
	          _react2.default.createElement(
	            ModalCard,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(HiddenFileInput, {
	              type: 'file',
	              accept: '.csv,text/csv',
	              innerRef: this.setFileInputRef,
	              onChange: this.handleFileInputChange
	            }),
	            modalMode === 'choice' && this.renderChoiceScreen(),
	            modalMode === 'modify-choice' && this.renderModifyChoiceScreen(),
	            modalMode === 'add-new' && this.renderAddNewFlow(),
	            modalMode === 'assign-sections' && this.renderAssignSectionsFlow(),
	            modalMode === 'reassign' && this.renderReassignFlow(),
	            modalMode === 'change-roles' && this.renderChangeRolesFlow()
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamsRolesSearch;
	}(_react.PureComponent);
	
	exports.default = TeamsRolesSearch;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  border-top: 1px solid #DEE0E3;\n"], ["\n  width: 100%;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  border-top: 1px solid #DEE0E3;\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: #F5F6F7;\n  box-shadow: inset 0px -1px 0px #DEE0E3;\n"], ["\n  background: #F5F6F7;\n  box-shadow: inset 0px -1px 0px #DEE0E3;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  padding: 16px;\n  line-height: 16px;\n  font-weight: 700 !important;\n  position: relative;\n  \n  &:after {\n    display: block;\n    content: '';\n    width: 1px;\n    height: 16px;\n    background: #CED1D6;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n  }\n\n  &:last-child:after {\n    display: none;\n  }\n\n  ", "\n  \n  ", "\n"], ["\n  padding: 16px;\n  line-height: 16px;\n  font-weight: 700 !important;\n  position: relative;\n  \n  &:after {\n    display: block;\n    content: '';\n    width: 1px;\n    height: 16px;\n    background: #CED1D6;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n  }\n\n  &:last-child:after {\n    display: none;\n  }\n\n  ", "\n  \n  ", "\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  box-shadow: inset 0px -1px 0px #ECEDEF;\n\n  &:nth-child(2n-1) {\n    background: #FAFBFD;\n  }\n\n  ", "\n"], ["\n  box-shadow: inset 0px -1px 0px #ECEDEF;\n\n  &:nth-child(2n-1) {\n    background: #FAFBFD;\n  }\n\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 12px 16px;\n\n  ", "\n"], ["\n  padding: 12px 16px;\n\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  border: 1px solid;\n  text-align: center;\n\n  ", "}\n\n  ", "}\n  \n  ", "}\n  \n  ", "}\n  \n  ", "}\n"], ["\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  border: 1px solid;\n  text-align: center;\n\n  ", "}\n\n  ", "}\n  \n  ", "}\n  \n  ", "}\n  \n  ", "}\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 15.75px;\n  height: 15.75px;\n"], ["\n  width: 15.75px;\n  height: 15.75px;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  border: 2px solid #D5D9DD;\n  border-radius: 4px;\n  line-height: 20px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n\n  ", "\n"], ["\n  border: 2px solid #D5D9DD;\n  border-radius: 4px;\n  line-height: 20px;\n  font-weight: 500;\n  color: rgba(0, 27, 59, 0.6);\n\n  ", "\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  margin-right: 6px;\n"], ["\n  width: 12px;\n  height: 12px;\n  margin-right: 6px;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > .loader {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n\n    .loader-inner div {\n      width: 15px;\n      height: 15px;\n      border-color: #fff !important;\n    }\n  }\n"], ["\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > .loader {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n\n    .loader-inner div {\n      width: 15px;\n      height: 15px;\n      border-color: #fff !important;\n    }\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  width: 18px;\n  height: 18px;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #282A2E;\n\n  \n  ", "}\n"], ["\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #282A2E;\n\n  \n  ", "}\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 12px;\n  line-height: 14px;\n\n  ", "}\n"], ["\n  color: rgba(0, 27, 59, 0.6);\n  font-size: 12px;\n  line-height: 14px;\n\n  ", "}\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: #EC5E59;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n\n  &:hover {\n    background: #FAEDED;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"], ["\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: #EC5E59;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n\n  &:hover {\n    background: #FAEDED;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: 'Mukta Vaani';\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: 'Mukta Vaani';\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0 0 24px;\n"], ["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0 0 24px;\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #C62828;\n  margin: 0 0 16px;\n"], ["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #C62828;\n  margin: 0 0 16px;\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n"], ["\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  background: #EC5E59;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: #d44a45;\n  }\n\n  &:disabled {\n    background: #f0a5a2;\n    cursor: not-allowed;\n  }\n"], ["\n  background: #EC5E59;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: #d44a45;\n  }\n\n  &:disabled {\n    background: #f0a5a2;\n    cursor: not-allowed;\n  }\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  font-weight: 700;\n  color: inherit;\n  cursor: pointer;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  font-weight: 700;\n  color: inherit;\n  cursor: pointer;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  gap: 1px;\n  line-height: 0;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  gap: 1px;\n  line-height: 0;\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  opacity: ", ";\n\n  ", "\n  ", "\n"], ["\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  opacity: ", ";\n\n  ", "\n  ", "\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #55B4BC;\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: currentColor;\n    animation: ", ";\n  }\n\n  @keyframes rotateSpin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #55B4BC;\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n    stroke: currentColor;\n    animation: ", ";\n  }\n\n  @keyframes rotateSpin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Surveys = __webpack_require__(56);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _selector = __webpack_require__(610);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _iconTeamsRolesChecked = __webpack_require__(1857);
	
	var _iconTeamsRolesChecked2 = _interopRequireDefault(_iconTeamsRolesChecked);
	
	var _iconTeamsRolesUnchecked = __webpack_require__(1858);
	
	var _iconTeamsRolesUnchecked2 = _interopRequireDefault(_iconTeamsRolesUnchecked);
	
	var _iconTeamplayersEdit = __webpack_require__(1856);
	
	var _iconTeamplayersEdit2 = _interopRequireDefault(_iconTeamplayersEdit);
	
	var _iconTeamSurveyProgressCompleted = __webpack_require__(1852);
	
	var _iconTeamSurveyProgressCompleted2 = _interopRequireDefault(_iconTeamSurveyProgressCompleted);
	
	var _iconTeamSurveyProgressIncomplete = __webpack_require__(1854);
	
	var _iconTeamSurveyProgressIncomplete2 = _interopRequireDefault(_iconTeamSurveyProgressIncomplete);
	
	var _iconTeamSurveyProgressInProgress = __webpack_require__(1853);
	
	var _iconTeamSurveyProgressInProgress2 = _interopRequireDefault(_iconTeamSurveyProgressInProgress);
	
	var _iconTeamSurveyProgressNotStarted = __webpack_require__(1855);
	
	var _iconTeamSurveyProgressNotStarted2 = _interopRequireDefault(_iconTeamSurveyProgressNotStarted);
	
	var _constants = __webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Table = _styledComponents2.default.table(_templateObject);
	
	var TableHeadRow = _styledComponents2.default.tr(_templateObject2);
	
	var TableHeadCell = _styledComponents2.default.th(_templateObject3, function (p) {
	  return p.withSelector && "\n    width: 155px;\n  ";
	}, function (p) {
	  return p.withActions && "\n    width: 180px;\n  ";
	});
	
	var TableRow = _styledComponents2.default.tr(_templateObject4, function (p) {
	  return p.activeRow && "\n    background: #EBF2FF !important;\n  ";
	});
	
	var TableCell = _styledComponents2.default.td(_templateObject5, function (p) {
	  return p.withActions && "\n    display: flex;\n  ";
	});
	
	var RoleBadge = _styledComponents2.default.div(_templateObject6, function (p) {
	  return p.role && p.role === 'CEO' && "{\n    color: #ECA427;\n    border-color: #ECA427;\n    background: #FFF8EB;\n  }";
	}, function (p) {
	  return p.role && p.role === 'PD' && "{\n    color: #55B4BC;\n    border-color: #55B4BC;\n    background: #ECF6F7;\n  ";
	}, function (p) {
	  return p.role && p.role === 'PM' && "{\n    color: #5C91F5;\n    border-color: #5C91F5;\n    background: #EBF2FF;\n  ";
	}, function (p) {
	  return p.role && p.role === 'OP' && "{\n    color: #EC5E59;\n    border-color: #EC5E59;\n    background: #FAEDED;\n  ";
	}, function (p) {
	  return p.role && p.role === 'FI' && "{\n    color: #9B77FF;\n    border-color: #A98DF6;\n    background: #F4F1FA;\n  ";
	});
	
	var RegisteredIcond = _styledComponents2.default.img(_templateObject7);
	
	var TableButton = _styledComponents2.default.button(_templateObject8, function (p) {
	  return p.saveButton && "\n    background: #5C91F5;\n    border-color: #5C91F5;\n    color: #fff;\n    margin-left: 8px;\n  ";
	});
	
	var EditButtonIcon = _styledComponents2.default.img(_templateObject9);
	
	var ButtonLoader = _styledComponents2.default.div(_templateObject10);
	
	var SurveyStatusWrapper = _styledComponents2.default.div(_templateObject11);
	
	var SurveyStatusIcon = _styledComponents2.default.div(_templateObject12);
	
	var SurveyProgressTextsWrapper = _styledComponents2.default.div(_templateObject13);
	
	var SurveyProgressText = _styledComponents2.default.div(_templateObject14, function (p) {
	  return p.status && p.status === 'Not Started' && "{\n    color: rgba(0, 27, 59, 0.38);\n  ";
	});
	
	var SurveyProgressStatusText = _styledComponents2.default.div(_templateObject15, function (p) {
	  return p.status && p.status === 'Closed' && "{\n    color: rgba(0, 27, 59, 0.38);\n  ";
	});
	
	var NameCellContent = _styledComponents2.default.div(_templateObject16);
	
	var TrashButton = _styledComponents2.default.button(_templateObject17);
	
	var ConfirmOverlay = _styledComponents2.default.div(_templateObject18);
	
	var ConfirmModal = _styledComponents2.default.div(_templateObject19);
	
	var ConfirmTitle = _styledComponents2.default.h3(_templateObject20);
	
	var ConfirmMessage = _styledComponents2.default.p(_templateObject21);
	
	var ConfirmError = _styledComponents2.default.p(_templateObject22);
	
	var ConfirmActions = _styledComponents2.default.div(_templateObject23);
	
	var ConfirmCancelButton = _styledComponents2.default.button(_templateObject24);
	
	var ConfirmProceedButton = _styledComponents2.default.button(_templateObject25);
	
	var TrashIconSvg = function TrashIconSvg() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("polyline", { points: "3 6 5 6 21 6" }),
	    _react2.default.createElement("path", { d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" }),
	    _react2.default.createElement("path", { d: "M10 11v6M14 11v6" }),
	    _react2.default.createElement("path", { d: "M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" })
	  );
	};
	
	var RoleHeaderContent = _styledComponents2.default.div(_templateObject26);
	
	var SortableHeader = _styledComponents2.default.button(_templateObject27);
	
	var SortIconWrapper = _styledComponents2.default.span(_templateObject28);
	
	var SortChevron = _styledComponents2.default.span(_templateObject29, function (p) {
	  return p.active ? 1 : 0.35;
	}, function (p) {
	  return p.direction === 'up' && "\n    border-bottom: 5px solid " + (p.active ? '#55B4BC' : 'rgba(0, 27, 59, 0.6)') + ";\n  ";
	}, function (p) {
	  return p.direction === 'down' && "\n    border-top: 5px solid " + (p.active ? '#55B4BC' : 'rgba(0, 27, 59, 0.6)') + ";\n  ";
	});
	
	var RotateButton = _styledComponents2.default.button(_templateObject30, function (p) {
	  return p.disabled ? 'not-allowed' : 'pointer';
	}, function (p) {
	  return p.disabled ? 0.35 : 1;
	}, function (p) {
	  return p.disabled ? 'transparent' : '#ECF6F7';
	}, function (p) {
	  return p.spinning ? 'rotateSpin 900ms linear infinite' : 'none';
	});
	
	var RotateIconSvg = function RotateIconSvg() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 24 24", fill: "none", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
	    _react2.default.createElement("polyline", { points: "23 4 23 10 17 10" }),
	    _react2.default.createElement("polyline", { points: "1 20 1 14 7 14" }),
	    _react2.default.createElement("path", { d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10" }),
	    _react2.default.createElement("path", { d: "M20.49 15a9 9 0 0 1-14.85 3.36L1 14" })
	  );
	};
	
	var TeamsRolesTable = function (_PureComponent) {
	  _inherits(TeamsRolesTable, _PureComponent);
	
	  function TeamsRolesTable(props) {
	    _classCallCheck(this, TeamsRolesTable);
	
	    var _this = _possibleConstructorReturn(this, (TeamsRolesTable.__proto__ || Object.getPrototypeOf(TeamsRolesTable)).call(this, props));
	
	    _this.handleTeamSortToggle = function () {
	      var teamSortDirection = _this.state.teamSortDirection;
	
	      var next = teamSortDirection === null ? 'asc' : teamSortDirection === 'asc' ? 'desc' : null;
	      _this.setState({ teamSortDirection: next });
	    };
	
	    _this.handleRotateRoles = function () {
	      if (_this.state.rotatingRoles) return;
	      var gameId = _Auth2.default.getGameId();
	      if (!gameId) return;
	
	      _this.setState({ rotatingRoles: true });
	
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/rotate-roles/").send({ game_id: gameId }).then(function () {
	        _this.setState({ rotatingRoles: false });
	        var onRotateComplete = _this.props.onRotateComplete;
	
	        if (onRotateComplete) onRotateComplete();
	      }).catch(function () {
	        _this.setState({ rotatingRoles: false });
	      });
	    };
	
	    _this.handleTrashClick = function (courseMemberId, teamPlayerId, name) {
	      _this.setState({
	        memberToDelete: { courseMemberId: courseMemberId, teamPlayerId: teamPlayerId, name: name },
	        deleteError: null
	      });
	    };
	
	    _this.handleCancelDelete = function () {
	      _this.setState({ memberToDelete: null, deleteError: null, deleteLoading: false });
	    };
	
	    _this.handleConfirmDelete = function () {
	      var memberToDelete = _this.state.memberToDelete;
	
	      if (!memberToDelete) return;
	
	      _this.setState({ deleteLoading: true, deleteError: null });
	
	      (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + "course_members/" + memberToDelete.courseMemberId + "/").then(function () {
	        var _this$props = _this.props,
	            teamPlayers = _this$props.teamPlayers,
	            changeTeamPlayers = _this$props.changeTeamPlayers;
	
	        var updatedTeamPlayers = teamPlayers.filter(function (tp) {
	          return tp.id !== memberToDelete.teamPlayerId;
	        });
	        changeTeamPlayers(updatedTeamPlayers);
	
	        _this.setState({
	          memberToDelete: null,
	          deleteLoading: false,
	          deleteError: null,
	          activeEditedRow: 0,
	          activeEditedTeamId: 0,
	          activeEditedRole: null
	        });
	      }).catch(function (err) {
	        _this.setState({
	          deleteLoading: false,
	          deleteError: 'Failed to remove student. Please try again.'
	        });
	      });
	    };
	
	    _this.handleTeamPlayerButtonClick = function (teamPlayerId, teamId, role) {
	      _this.setState({
	        activeEditedRow: teamPlayerId,
	        activeEditedTeamId: teamId,
	        activeEditedRole: role
	      });
	    };
	
	    _this.handleTeamSelectChange = function (value) {
	      _this.setState({
	        editedRowChanged: true,
	        activeEditedTeamId: value
	      });
	    };
	
	    _this.handleRoleSelectChange = function (value) {
	      _this.setState({
	        editedRowChanged: true,
	        activeEditedRole: value
	      });
	    };
	
	    _this.handleSaveButtonClick = function (teamPlayerId, teamId, role) {
	      _this.setState({
	        saveButtonLoading: true
	      });
	
	      (0, _ApiService.patchRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/teamplayers/" + teamPlayerId + "/").send({
	        team: teamId,
	        role: role
	      }).then(function (res) {
	        var _this$props2 = _this.props,
	            teamPlayers = _this$props2.teamPlayers,
	            changeTeamPlayers = _this$props2.changeTeamPlayers;
	
	
	        var updatedTeamPlayers = teamPlayers.map(function (teamPlayer) {
	          return teamPlayer.id === teamPlayerId ? Object.assign({}, teamPlayer, { team: teamId, role: role }) : teamPlayer;
	        });
	        changeTeamPlayers(updatedTeamPlayers);
	
	        _this.setState({
	          saveButtonLoading: false,
	          activeEditedRow: 0,
	          activeEditedTeamId: 0,
	          activeEditedRole: null
	        });
	      }).catch(function (err) {
	        _this.setState({
	          saveButtonLoading: false
	        });
	      });
	    };
	
	    _this.state = {
	      activeEditedRow: 0,
	      activeEditedTeamId: 0,
	      activeEditedRole: null,
	      editedRowChanged: false,
	      saveButtonLoading: false,
	      memberToDelete: null,
	      deleteLoading: false,
	      deleteError: null,
	      rotatingRoles: false,
	      teamSortDirection: null
	    };
	    return _this;
	  }
	
	  _createClass(TeamsRolesTable, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          teamPlayers = _props.teamPlayers,
	          courseMembers = _props.courseMembers,
	          availableTeams = _props.availableTeams,
	          surveys = _props.surveys,
	          surveysFeedbacks = _props.surveysFeedbacks;
	      var _state = this.state,
	          activeEditedRow = _state.activeEditedRow,
	          activeEditedTeamId = _state.activeEditedTeamId,
	          activeEditedRole = _state.activeEditedRole,
	          editedRowChanged = _state.editedRowChanged,
	          saveButtonLoading = _state.saveButtonLoading,
	          memberToDelete = _state.memberToDelete,
	          deleteLoading = _state.deleteLoading,
	          deleteError = _state.deleteError,
	          rotatingRoles = _state.rotatingRoles,
	          teamSortDirection = _state.teamSortDirection;
	
	
	      var anyRoleAssigned = teamPlayers.some(function (tp) {
	        return tp && tp.role;
	      });
	      var rotateDisabled = !anyRoleAssigned || rotatingRoles;
	
	      var teamDisplayName = function teamDisplayName(tp) {
	        var mapped = availableTeams && availableTeams[' ' + Number(tp.team)];
	        return mapped != null ? String(mapped) : String(tp.team || '');
	      };
	
	      var sortedTeamPlayers = teamSortDirection ? [].concat(_toConsumableArray(teamPlayers)).sort(function (a, b) {
	        var cmp = teamDisplayName(a).localeCompare(teamDisplayName(b), undefined, { numeric: true, sensitivity: 'base' });
	        return teamSortDirection === 'asc' ? cmp : -cmp;
	      }) : teamPlayers;
	
	      var surveysStatuses = surveys.map(function (survey) {
	        return (0, _Surveys.isSurveyFinished)(survey) ? 'Closed' : (0, _Surveys.isSurveyStarted)(survey) ? 'Open' : '';
	      });
	
	      // Section column visibility: use Auth.getUser().sections to decide
	      // whether the current instructor can see any sections at all. Each
	      // courseMember row now ships `section_name` directly from BE, so no
	      // id → name lookup is needed for the cell value itself.
	      var user = _Auth2.default.getUser() || {};
	      var userSections = Array.isArray(user.sections) ? user.sections : [];
	      var showSection = userSections.length > 0;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          Table,
	          null,
	          _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	              TableHeadRow,
	              null,
	              _react2.default.createElement(
	                TableHeadCell,
	                null,
	                "Name"
	              ),
	              _react2.default.createElement(
	                TableHeadCell,
	                null,
	                "Email"
	              ),
	              showSection && _react2.default.createElement(
	                TableHeadCell,
	                null,
	                "Section"
	              ),
	              _react2.default.createElement(
	                TableHeadCell,
	                { withSelector: true },
	                _react2.default.createElement(
	                  SortableHeader,
	                  {
	                    type: "button",
	                    onClick: this.handleTeamSortToggle,
	                    title: teamSortDirection === 'asc' ? 'Sort teams descending' : teamSortDirection === 'desc' ? 'Clear team sort' : 'Sort teams ascending'
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Team"
	                  ),
	                  _react2.default.createElement(
	                    SortIconWrapper,
	                    null,
	                    _react2.default.createElement(SortChevron, {
	                      direction: "up",
	                      active: teamSortDirection === 'asc'
	                    }),
	                    _react2.default.createElement(SortChevron, {
	                      direction: "down",
	                      active: teamSortDirection === 'desc'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                TableHeadCell,
	                { withSelector: true },
	                _react2.default.createElement(
	                  RoleHeaderContent,
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Role"
	                  ),
	                  _react2.default.createElement(
	                    RotateButton,
	                    {
	                      type: "button",
	                      disabled: rotateDisabled,
	                      spinning: rotatingRoles,
	                      onClick: rotateDisabled ? undefined : this.handleRotateRoles,
	                      title: anyRoleAssigned ? 'Rotate roles' : 'Assign a role first to enable rotation'
	                    },
	                    _react2.default.createElement(RotateIconSvg, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                TableHeadCell,
	                null,
	                "Registered"
	              ),
	              surveys.map(function (survey, index) {
	                return _react2.default.createElement(
	                  TableHeadCell,
	                  { key: index },
	                  survey.name
	                );
	              }),
	              _react2.default.createElement(
	                TableHeadCell,
	                { withActions: true },
	                "Actions"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            sortedTeamPlayers.map(function (teamPlayer, index) {
	              var currentTeam = availableTeams[' ' + Number(teamPlayer.team)];
	              var teamName = currentTeam ? currentTeam : teamPlayer.team;
	
	              // BE's instructor serializer puts the student's EMAIL in
	              // courseMember.user; the legacy shape used username. Match
	              // on either so the join survives either response shape.
	              // Compare case-insensitively — BE emails come back
	              // uppercased while teamPlayer.user.email is often mixed
	              // case, which was breaking the join silently.
	              var tpUsername = teamPlayer.user && teamPlayer.user.username ? String(teamPlayer.user.username).toLowerCase() : '';
	              var tpEmail = teamPlayer.user && teamPlayer.user.email ? String(teamPlayer.user.email).toLowerCase() : '';
	              var currentCourseMember = courseMembers.find(function (cm) {
	                if (!cm || cm.user == null) return false;
	                var cmUser = String(cm.user).toLowerCase();
	                return cmUser === tpUsername || cmUser === tpEmail;
	              });
	              // Registered iff the student's subscription window hasn't
	              // expired. current_subscription is the end date of their
	              // active subscription — anything in the future means
	              // they're paid/registered right now.
	              var currentSubscription = currentCourseMember ? currentCourseMember.current_subscription : null;
	              var subscriptionMs = currentSubscription ? Date.parse(currentSubscription) : NaN;
	              var isRegistered = !isNaN(subscriptionMs) && subscriptionMs > Date.now();
	              var registeredIconSrc = isRegistered ? _iconTeamsRolesChecked2.default : _iconTeamsRolesUnchecked2.default;
	
	              var activeRow = activeEditedRow === teamPlayer.id;
	
	              var surveyProgressTexts = [];
	              var surveyProgressIcons = [];
	              surveys.forEach(function (survey, index) {
	                var teamPlayerFeedbacks = surveysFeedbacks[index].filter(function (surveysFeedback) {
	                  return surveysFeedback.giver === teamPlayer.user.id;
	                });
	
	                surveyProgressTexts[index] = 'Not Started';
	                surveyProgressIcons[index] = _iconTeamSurveyProgressNotStarted2.default;
	
	                if (teamPlayerFeedbacks.length) {
	                  if (teamPlayerFeedbacks.length === teamPlayerFeedbacks.filter(function (surveysFeedback) {
	                    return surveysFeedback.completed === true;
	                  }).length) {
	                    surveyProgressTexts[index] = 'Completed';
	                    surveyProgressIcons[index] = _iconTeamSurveyProgressCompleted2.default;
	                  } else {
	                    if (surveysStatuses[index] === 'Open') {
	                      surveyProgressTexts[index] = 'In Progress';
	                      surveyProgressIcons[index] = _iconTeamSurveyProgressInProgress2.default;
	                    } else {
	                      surveyProgressTexts[index] = 'Incomplete';
	                      surveyProgressIcons[index] = _iconTeamSurveyProgressIncomplete2.default;
	                    }
	                  }
	                }
	              });
	
	              var fullName = teamPlayer.user.first_name + " " + teamPlayer.user.last_name;
	
	              return _react2.default.createElement(
	                TableRow,
	                { key: index, activeRow: activeRow },
	                _react2.default.createElement(
	                  TableCell,
	                  null,
	                  _react2.default.createElement(
	                    NameCellContent,
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      fullName
	                    ),
	                    activeRow && currentCourseMember && !_Auth2.default.isAssistantOrCoInstructor() && _react2.default.createElement(
	                      TrashButton,
	                      {
	                        onClick: function onClick() {
	                          return _this2.handleTrashClick(currentCourseMember.id, teamPlayer.id, fullName);
	                        },
	                        title: "Remove student from course"
	                      },
	                      _react2.default.createElement(TrashIconSvg, null)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  TableCell,
	                  null,
	                  teamPlayer.user.email
	                ),
	                showSection && _react2.default.createElement(
	                  TableCell,
	                  null,
	                  currentCourseMember && currentCourseMember.section_name ? currentCourseMember.section_name : '---'
	                ),
	                _react2.default.createElement(
	                  TableCell,
	                  null,
	                  activeRow && _react2.default.createElement(_selector2.default, {
	                    options: availableTeams,
	                    selectedOptionId: activeEditedTeamId,
	                    onSelectorChange: _this2.handleTeamSelectChange
	                  }),
	                  !activeRow && teamName
	                ),
	                _react2.default.createElement(
	                  TableCell,
	                  null,
	                  activeRow && _react2.default.createElement(_selector2.default, {
	                    options: _constants.teamPlayerRoles,
	                    selectedOptionId: activeEditedRole,
	                    onSelectorChange: _this2.handleRoleSelectChange
	                  }),
	                  !activeRow && _react2.default.createElement(
	                    RoleBadge,
	                    { role: teamPlayer.role },
	                    _constants.teamPlayerRoles[teamPlayer.role]
	                  )
	                ),
	                _react2.default.createElement(
	                  TableCell,
	                  null,
	                  _react2.default.createElement(RegisteredIcond, { src: registeredIconSrc })
	                ),
	                surveys.map(function (survey, index) {
	                  return _react2.default.createElement(
	                    TableCell,
	                    { key: index },
	                    _react2.default.createElement(
	                      SurveyStatusWrapper,
	                      null,
	                      _react2.default.createElement(
	                        SurveyStatusIcon,
	                        null,
	                        _react2.default.createElement("img", { src: surveyProgressIcons[index], alt: "Survey Progress" })
	                      ),
	                      _react2.default.createElement(
	                        SurveyProgressTextsWrapper,
	                        null,
	                        _react2.default.createElement(
	                          SurveyProgressText,
	                          { status: surveyProgressTexts[index] },
	                          surveyProgressTexts[index]
	                        ),
	                        _react2.default.createElement(
	                          SurveyProgressStatusText,
	                          { status: surveysStatuses[index] },
	                          surveysStatuses[index]
	                        )
	                      )
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  TableCell,
	                  { withActions: true },
	                  !activeRow && _react2.default.createElement(
	                    TableButton,
	                    { onClick: function onClick() {
	                        return _this2.handleTeamPlayerButtonClick(teamPlayer.id, teamPlayer.team, teamPlayer.role);
	                      } },
	                    _react2.default.createElement(EditButtonIcon, { src: _iconTeamplayersEdit2.default }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Edit"
	                    )
	                  ),
	                  activeRow && _react2.default.createElement(
	                    TableButton,
	                    { onClick: function onClick() {
	                        return _this2.handleTeamPlayerButtonClick(0, 0, null);
	                      } },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Cancel"
	                    )
	                  ),
	                  activeRow && editedRowChanged && _react2.default.createElement(
	                    TableButton,
	                    { saveButton: true, onClick: function onClick() {
	                        return _this2.handleSaveButtonClick(teamPlayer.id, activeEditedTeamId, activeEditedRole);
	                      } },
	                    saveButtonLoading && _react2.default.createElement(
	                      ButtonLoader,
	                      null,
	                      _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	                    ),
	                    !saveButtonLoading && _react2.default.createElement(
	                      "span",
	                      null,
	                      "Save"
	                    )
	                  )
	                )
	              );
	            }),
	            !sortedTeamPlayers.length && _react2.default.createElement(
	              TableRow,
	              null,
	              _react2.default.createElement(
	                TableCell,
	                null,
	                "Nothing found"
	              )
	            )
	          )
	        ),
	        memberToDelete && _react2.default.createElement(
	          ConfirmOverlay,
	          { onClick: this.handleCancelDelete },
	          _react2.default.createElement(
	            ConfirmModal,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              ConfirmTitle,
	              null,
	              "Are You Sure?"
	            ),
	            _react2.default.createElement(
	              ConfirmMessage,
	              null,
	              "Are you sure you want to remove ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                memberToDelete.name
	              ),
	              " from the course? Once this student is removed, they cannot be added back to the simulation."
	            ),
	            deleteError && _react2.default.createElement(
	              ConfirmError,
	              null,
	              deleteError
	            ),
	            _react2.default.createElement(
	              ConfirmActions,
	              null,
	              _react2.default.createElement(
	                ConfirmCancelButton,
	                { onClick: this.handleCancelDelete, disabled: deleteLoading },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                ConfirmProceedButton,
	                { onClick: this.handleConfirmDelete, disabled: deleteLoading },
	                deleteLoading ? 'Removing...' : 'Remove Student'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamsRolesTable;
	}(_react.PureComponent);
	
	exports.default = TeamsRolesTable;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n'], ['\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n'], ['\n  from { opacity: 0; }\n  to   { opacity: 1; }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: #FAFBFD;\n  min-height: 100%;\n  margin: 0;\n  padding: 64px 32px 24px;\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  color: #0F172A;\n'], ['\n  background: #FAFBFD;\n  min-height: 100%;\n  margin: 0;\n  padding: 64px 32px 24px;\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  color: #0F172A;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  max-width: 760px;\n  margin: 0 auto 16px;\n  text-align: center;\n'], ['\n  max-width: 760px;\n  margin: 0 auto 16px;\n  text-align: center;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin: 0 0 14px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  color: #0F172A;\n  text-align: center;\n'], ['\n  margin: 0 0 14px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.1;\n  color: #0F172A;\n  text-align: center;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 0 0 14px;\n  font-size: 15px;\n  color: #475569;\n  line-height: 1.4;\n  text-align: center;\n'], ['\n  margin: 0 0 14px;\n  font-size: 15px;\n  color: #475569;\n  line-height: 1.4;\n  text-align: center;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 944px;\n'], ['\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 944px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 18px;\n  padding: 10px 14px 10px 6px;\n  margin-bottom: 12px;\n  border-radius: 14px;\n  background: transparent;\n  transition: background 200ms ease;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    left: 25px;\n    width: 2px;\n    top: 0;\n    bottom: -12px;\n    background: #E2E8F0;\n    z-index: 0;\n  }\n\n  &:first-child::before {\n    top: 30px;\n  }\n\n  &:last-child::before {\n    bottom: auto;\n    height: 30px;\n  }\n\n  ', '\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  /* Substeps stay collapsed until the instructor hovers anywhere\n     within the Step\'s bounds. Animated via max-height + opacity so\n     the rest of the page doesn\'t jolt when they appear/disappear.\n     Display:none on focus-within would break keyboard access, so we\n     also expand on focus-within (Tab key reveals the substeps for\n     keyboard users). */\n  .checklist-substep-group {\n    max-height: 0;\n    opacity: 0;\n    margin-top: 0;\n    overflow: hidden;\n    transition: max-height 250ms ease, opacity 200ms ease, margin-top 250ms ease;\n  }\n\n  &:hover .checklist-substep-group,\n  &:focus-within .checklist-substep-group {\n    max-height: 800px;\n    opacity: 1;\n    margin-top: 8px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n\n    .checklist-substep-group {\n      transition: none;\n    }\n  }\n'], ['\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 18px;\n  padding: 10px 14px 10px 6px;\n  margin-bottom: 12px;\n  border-radius: 14px;\n  background: transparent;\n  transition: background 200ms ease;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    left: 25px;\n    width: 2px;\n    top: 0;\n    bottom: -12px;\n    background: #E2E8F0;\n    z-index: 0;\n  }\n\n  &:first-child::before {\n    top: 30px;\n  }\n\n  &:last-child::before {\n    bottom: auto;\n    height: 30px;\n  }\n\n  ', '\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  /* Substeps stay collapsed until the instructor hovers anywhere\n     within the Step\'s bounds. Animated via max-height + opacity so\n     the rest of the page doesn\'t jolt when they appear/disappear.\n     Display:none on focus-within would break keyboard access, so we\n     also expand on focus-within (Tab key reveals the substeps for\n     keyboard users). */\n  .checklist-substep-group {\n    max-height: 0;\n    opacity: 0;\n    margin-top: 0;\n    overflow: hidden;\n    transition: max-height 250ms ease, opacity 200ms ease, margin-top 250ms ease;\n  }\n\n  &:hover .checklist-substep-group,\n  &:focus-within .checklist-substep-group {\n    max-height: 800px;\n    opacity: 1;\n    margin-top: 8px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n\n    .checklist-substep-group {\n      transition: none;\n    }\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n    background: #DBEAFE;\n  '], ['\n    background: #DBEAFE;\n  ']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n    background: #10B981;\n    border-color: #10B981;\n    color: #FFFFFF;\n  '], ['\n    background: #10B981;\n    border-color: #10B981;\n    color: #FFFFFF;\n  ']),
	    _templateObject12 = _taggedTemplateLiteral(['\n    background: #EFF6FF;\n    border-color: #2563EB;\n    color: #2563EB;\n  '], ['\n    background: #EFF6FF;\n    border-color: #2563EB;\n    color: #2563EB;\n  ']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  padding-top: 2px;\n'], ['\n  padding-top: 2px;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  margin: 0 0 4px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n    color: #94A3B8;\n    text-decoration: line-through;\n    text-decoration-color: #CBD5E1;\n  '], ['\n    color: #94A3B8;\n    text-decoration: line-through;\n    text-decoration-color: #CBD5E1;\n  ']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  margin: 0 0 6px;\n  font-size: 15px;\n  line-height: 1.4;\n  color: #475569;\n  max-width: 900px;\n'], ['\n  margin: 0 0 6px;\n  font-size: 15px;\n  line-height: 1.4;\n  color: #475569;\n  max-width: 900px;\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 4px;\n  /* margin-top moves to the hover rule on Step so the spacing\n     animates in alongside the reveal. */\n'], ['\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 4px;\n  /* margin-top moves to the hover rule on Step so the spacing\n     animates in alongside the reveal. */\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 150ms ease;\n\n  & + & {\n    border-top: 1px solid #E2E8F0;\n  }\n\n  &:hover {\n    background: #FFFFFF;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: -2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 150ms ease;\n\n  & + & {\n    border-top: 1px solid #E2E8F0;\n  }\n\n  &:hover {\n    background: #FFFFFF;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: -2px;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  border: 2px solid #CBD5E1;\n  border-radius: 5px;\n  background: #FFFFFF;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  transition: background 200ms ease, border-color 200ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 1px;\n  border: 2px solid #CBD5E1;\n  border-radius: 5px;\n  background: #FFFFFF;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n  transition: background 200ms ease, border-color 200ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n    background: #10B981;\n    border-color: #10B981;\n  '], ['\n    background: #10B981;\n    border-color: #10B981;\n  ']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n'], ['\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n  transition: color 300ms ease, text-decoration-color 300ms ease;\n\n  ', '\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 1.4;\n  color: #475569;\n'], ['\n  font-size: 14px;\n  line-height: 1.4;\n  color: #475569;\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n'], ['\n  font-size: 14px;\n  font-weight: 700;\n  color: #2563EB;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  max-width: 760px;\n  margin: 32px auto 0;\n  padding: 28px 32px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ECFDF5, #D1FAE5);\n  border: 1px solid #A7F3D0;\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 20px;\n  align-items: center;\n  animation: ', ' 500ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  max-width: 760px;\n  margin: 32px auto 0;\n  padding: 28px 32px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ECFDF5, #D1FAE5);\n  border: 1px solid #A7F3D0;\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 20px;\n  align-items: center;\n  animation: ', ' 500ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #10B981;\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n'], ['\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #10B981;\n  color: #FFFFFF;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n  margin: 0 0 4px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #064E3B;\n'], ['\n  margin: 0 0 4px;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 22px;\n  font-weight: 800;\n  color: #064E3B;\n']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-size: 15px;\n  color: #047857;\n  line-height: 1.5;\n'], ['\n  margin: 0;\n  font-size: 15px;\n  color: #047857;\n  line-height: 1.5;\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n'], ['\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n'], ['\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  z-index: 1000;\n  animation: ', ' 200ms ease both;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n']),
	    _templateObject31 = _taggedTemplateLiteral(['\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  overflow: hidden;\n'], ['\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 86vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  overflow: hidden;\n']),
	    _templateObject32 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #E2E8F0;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #E2E8F0;\n']),
	    _templateObject33 = _taggedTemplateLiteral(['\n  margin: 0;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n'], ['\n  margin: 0;\n  font-family: \'Bricolage Grotesque\', \'Mukta Vaani\', sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  color: #0F172A;\n']),
	    _templateObject34 = _taggedTemplateLiteral(['\n  background: transparent;\n  border: 0;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n'], ['\n  background: transparent;\n  border: 0;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748B;\n  font-size: 22px;\n  line-height: 1;\n\n  &:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n  }\n']),
	    _templateObject35 = _taggedTemplateLiteral(['\n  overflow-y: auto;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n'], ['\n  overflow-y: auto;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #1F2A44;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _step = __webpack_require__(1521);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1522);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1523);
	
	var _step6 = _interopRequireDefault(_step5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Consolidated instructor welcome checklist.
	//
	// Mounts at /instructor/welcome and replaces the prior
	// multi-page wizard (Welcome > Game Overview > Setting Up Gameplay
	// > How Grading Works > What To Expect > How We Support You >
	// Next Steps). One page, three top-level steps, substeps inline:
	//
	//   Step 1, Required Setup
	//     - Set the round deadlines               (link → /instructor/rounds)
	//     - Set the teams                         (link → /instructor/teams-roles)
	//
	//   Step 2, Review Default Settings (optional modifications)
	//     - Review default round metrics & targets
	//                                             (link → /instructor/grading/team-score)
	//     - Review default grading weights        (link → /instructor/grading/overall-score)
	//     - Review default team evaluation        (link → /instructor/peer-review)
	//
	//   Step 3, What to Expect (per-round popups)
	//     - Round 1, Product & Marketing
	//     - Round 2, Operations
	//     - Round 3, Accounting & Finance
	//
	// This page is the same for all rounds; completion is persisted to
	// localStorage keyed by user id only (no per-round key) since the
	// instructor's setup decisions span the whole course.
	
	// ---------- copy / data --------------------------------------------
	
	var COMPLETION_COPY = {
	  icon: '✓',
	  title: 'Setup complete!',
	  description: 'Great work. You can revisit any step at any time from this checklist.'
	};
	
	var STEP1_SUBSTEPS = [{
	  id: 'set-round-deadlines',
	  title: 'Set the round deadlines',
	  description: 'Open the rounds page to set start and end dates for each round in this challenge.',
	  linkText: 'Set round deadlines',
	  href: '/instructor/rounds'
	}, {
	  id: 'set-teams-roles',
	  title: 'Set the teams',
	  description: 'Assign students to teams and roles before the first round begins.',
	  linkText: 'Set teams & roles',
	  href: '/instructor/teams-roles'
	}];
	
	var STEP2_SUBSTEPS = [{
	  id: 'review-metrics-targets',
	  title: 'Review default round metrics & targets',
	  description: 'Each round comes with default financial metrics and targets. Review them and modify if you want a different challenge profile.',
	  linkText: 'Review metrics & targets',
	  href: '/instructor/grading/team-score'
	}, {
	  id: 'review-grading-weights',
	  title: 'Review default grading weights',
	  description: 'Adjust the weight of each round (round weight) and the weight of each activity score (score weight) if the defaults don\'t fit your course.',
	  linkText: 'Review grading weights',
	  href: '/instructor/grading/overall-score'
	}, {
	  id: 'review-team-evaluation',
	  title: 'Review default team evaluation',
	  description: 'Review the questions and timing, and modify if you want a different structure.',
	  linkText: 'Review team evaluation',
	  href: '/instructor/peer-review'
	}];
	
	var STEP3_SUBSTEPS = [{
	  id: 'whattoexpect-round1',
	  title: 'Round 1, Product & Marketing',
	  description: 'Product and marketing decisions are emphasized in the first round.',
	  linkText: "See what's in Round 1",
	  popupId: 'round1'
	}, {
	  id: 'whattoexpect-round2',
	  title: 'Round 2, Operations',
	  description: 'Operations decisions take center stage in the second round.',
	  linkText: "See what's in Round 2",
	  popupId: 'round2'
	}, {
	  id: 'whattoexpect-round3',
	  title: 'Round 3, Accounting & Finance',
	  description: 'Accounting and finance decisions come into focus in the final round.',
	  linkText: "See what's in Round 3",
	  popupId: 'round3'
	}];
	
	var POPUP_COMPONENTS = {
	  round1: _step2.default,
	  round2: _step4.default,
	  round3: _step6.default
	};
	
	var POPUP_TITLES = {
	  round1: 'Round 1, Product & Marketing',
	  round2: 'Round 2, Operations',
	  round3: 'Round 3, Accounting & Finance'
	};
	
	// Shared (not per-round). The instructor's setup decisions span
	// the whole course.
	var storageKey = function storageKey() {
	  var uid = _Auth2.default.getUserId();
	  return 'instructor-onboarding:checklist:' + (uid || 'anon');
	};
	
	// ---------- styles -------------------------------------------------
	
	var fadeUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var fadeIn = (0, _styledComponents.keyframes)(_templateObject2);
	
	var Styled = {};
	
	Styled.Root = _styledComponents2.default.section(_templateObject3);
	
	Styled.Header = _styledComponents2.default.div(_templateObject4);
	
	Styled.Title = _styledComponents2.default.h1(_templateObject5);
	
	Styled.Subhead = _styledComponents2.default.p(_templateObject6);
	
	Styled.Timeline = _styledComponents2.default.ol(_templateObject7);
	
	Styled.Step = _styledComponents2.default.li(_templateObject8, function (p) {
	  return p.active && (0, _styledComponents.css)(_templateObject9);
	});
	
	var stepCircleBase = '\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Inter\', \'Mukta Vaani\', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  background: #FFFFFF;\n  border: 2px solid #E2E8F0;\n  color: #64748B;\n  position: relative;\n  z-index: 1;\n  padding: 0;\n  transition: background 200ms ease, border-color 200ms ease, color 200ms ease;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n';
	
	Styled.StepCircleStatic = _styledComponents2.default.div(_templateObject10, stepCircleBase, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject11);
	}, function (p) {
	  return !p.completed && p.active && (0, _styledComponents.css)(_templateObject12);
	});
	
	Styled.StepBody = _styledComponents2.default.div(_templateObject13);
	
	Styled.StepTitle = _styledComponents2.default.h2(_templateObject14, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject15);
	});
	
	Styled.StepDescription = _styledComponents2.default.p(_templateObject16);
	
	// Render sites pass className="checklist-substep-group" so the
	// parent Styled.Step's :hover reveal rule can target this group
	// by class. Styled.Step is defined before this component in the
	// file, so we can't use styled-components' reference-by-component
	// trick to do the targeting purely via interpolation.
	Styled.SubstepGroup = _styledComponents2.default.div(_templateObject17);
	
	Styled.SubstepRow = _styledComponents2.default.button(_templateObject18);
	
	Styled.Checkbox = _styledComponents2.default.span(_templateObject19, function (p) {
	  return p.checked && (0, _styledComponents.css)(_templateObject20);
	});
	
	Styled.SubstepBody = _styledComponents2.default.div(_templateObject21);
	
	Styled.SubstepTitle = _styledComponents2.default.span(_templateObject22, function (p) {
	  return p.completed && (0, _styledComponents.css)(_templateObject15);
	});
	
	Styled.SubstepDescription = _styledComponents2.default.span(_templateObject23);
	
	Styled.SubstepLink = _styledComponents2.default.a(_templateObject24);
	
	Styled.CompletionBanner = _styledComponents2.default.div(_templateObject25, fadeUp);
	
	Styled.CompletionIcon = _styledComponents2.default.div(_templateObject26);
	
	Styled.CompletionTitle = _styledComponents2.default.h3(_templateObject27);
	
	Styled.CompletionDescription = _styledComponents2.default.p(_templateObject28);
	
	Styled.SrOnly = _styledComponents2.default.span(_templateObject29);
	
	// ---------- modal shell -------------------------------------------
	
	Styled.Modal = {};
	
	Styled.Modal.Backdrop = _styledComponents2.default.div(_templateObject30, fadeIn);
	
	Styled.Modal.Card = _styledComponents2.default.div(_templateObject31);
	
	Styled.Modal.HeaderBar = _styledComponents2.default.div(_templateObject32);
	
	Styled.Modal.Title = _styledComponents2.default.h2(_templateObject33);
	
	Styled.Modal.CloseButton = _styledComponents2.default.button(_templateObject34);
	
	Styled.Modal.Body = _styledComponents2.default.div(_templateObject35);
	
	// ---------- component ---------------------------------------------
	
	var InstructorWelcomeChecklist = function (_PureComponent) {
	  _inherits(InstructorWelcomeChecklist, _PureComponent);
	
	  function InstructorWelcomeChecklist(props) {
	    _classCallCheck(this, InstructorWelcomeChecklist);
	
	    var _this = _possibleConstructorReturn(this, (InstructorWelcomeChecklist.__proto__ || Object.getPrototypeOf(InstructorWelcomeChecklist)).call(this, props));
	
	    _this.handleKeydown = function (e) {
	      if (e.key === 'Escape' && _this.state.activePopupId) {
	        _this.closePopup();
	      }
	    };
	
	    _this.readFromStorage = function () {
	      try {
	        var raw = window.localStorage.getItem(storageKey());
	        if (!raw) return {};
	        var parsed = JSON.parse(raw);
	        if (!Array.isArray(parsed)) return {};
	        var next = {};
	        parsed.forEach(function (id) {
	          if (typeof id === 'string') next[id] = true;
	        });
	        return next;
	      } catch (e) {
	        return {};
	      }
	    };
	
	    _this.writeToStorage = function (completed) {
	      try {
	        var ids = Object.keys(completed).filter(function (k) {
	          return completed[k] === true;
	        });
	        window.localStorage.setItem(storageKey(), JSON.stringify(ids));
	      } catch (e) {
	        // localStorage unavailable. Silent fail. In-memory state still drives this
	        // render, we just lose persistence across reloads.
	      }
	    };
	
	    _this.toggle = function (id) {
	      _this.setState(function (prev) {
	        var next = Object.assign({}, prev.completed);
	        if (next[id]) {
	          delete next[id];
	        } else {
	          next[id] = true;
	        }
	        _this.writeToStorage(next);
	        return { completed: next };
	      });
	    };
	
	    _this.withRound = function (path) {
	      return '' + path + (path.indexOf('?') >= 0 ? '&' : '?') + 'round=' + _this.activeRound;
	    };
	
	    _this.isLeafComplete = function (id) {
	      return !!_this.state.completed[id];
	    };
	
	    _this.isStepComplete = function (substeps) {
	      return substeps.every(function (s) {
	        return _this.isLeafComplete(s.id);
	      });
	    };
	
	    _this.firstIncompleteStepId = function () {
	      if (!_this.isStepComplete(STEP1_SUBSTEPS)) return 'required-setup';
	      if (!_this.isStepComplete(STEP2_SUBSTEPS)) return 'review-defaults';
	      if (!_this.isStepComplete(STEP3_SUBSTEPS)) return 'what-to-expect';
	      return null;
	    };
	
	    _this.allCompleteIds = function () {
	      return [].concat(STEP1_SUBSTEPS, STEP2_SUBSTEPS, STEP3_SUBSTEPS).map(function (s) {
	        return s.id;
	      });
	    };
	
	    _this.allComplete = function () {
	      return _this.allCompleteIds().every(function (id) {
	        return _this.isLeafComplete(id);
	      });
	    };
	
	    _this.openPopup = function (id) {
	      _this.setState({ activePopupId: id });
	    };
	
	    _this.closePopup = function () {
	      _this.setState({ activePopupId: null });
	    };
	
	    _this.stopRowClickPropagation = function (e) {
	      if (e) e.stopPropagation();
	    };
	
	    _this.renderStepCircle = function (number, completed, active) {
	      var content = completed ? '✓' : number;
	      return _react2.default.createElement(
	        Styled.StepCircleStatic,
	        { completed: completed, active: active, 'aria-hidden': 'true' },
	        content
	      );
	    };
	
	    _this.renderInternalSubstepLink = function (text, href, withRound) {
	      var finalHref = withRound ? _this.withRound(href) : href;
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: finalHref, onClick: _this.stopRowClickPropagation, style: { textDecoration: 'none' } },
	        _react2.default.createElement(
	          Styled.SubstepLink,
	          { as: 'span' },
	          text,
	          ' \u2192'
	        )
	      );
	    };
	
	    _this.renderPopupSubstepLink = function (text, popupId) {
	      return _react2.default.createElement(
	        Styled.SubstepLink,
	        {
	          as: 'button',
	          type: 'button',
	          onClick: function onClick(e) {
	            _this.stopRowClickPropagation(e);
	            _this.openPopup(popupId);
	          }
	        },
	        text,
	        ' \u2192'
	      );
	    };
	
	    _this.renderSubstepRow = function (sub, linkNode) {
	      var isDone = _this.isLeafComplete(sub.id);
	      var label = isDone ? 'Mark ' + sub.title + ' as incomplete' : 'Mark ' + sub.title + ' as complete';
	      return _react2.default.createElement(
	        Styled.SubstepRow,
	        {
	          key: sub.id,
	          type: 'button',
	          onClick: function onClick() {
	            return _this.toggle(sub.id);
	          },
	          'aria-pressed': isDone,
	          'aria-label': label
	        },
	        _react2.default.createElement(
	          Styled.Checkbox,
	          { checked: isDone, 'aria-hidden': 'true' },
	          isDone ? '✓' : ''
	        ),
	        _react2.default.createElement(
	          Styled.SubstepBody,
	          null,
	          _react2.default.createElement(
	            Styled.SubstepTitle,
	            { completed: isDone },
	            sub.title
	          ),
	          _react2.default.createElement(
	            Styled.SubstepDescription,
	            null,
	            sub.description,
	            linkNode && _react2.default.createElement(
	              'span',
	              null,
	              ' ',
	              linkNode
	            )
	          )
	        )
	      );
	    };
	
	    _this.isRoundAwareRoute = function (href) {
	      if (!href) return false;
	      if (href.indexOf('/instructor/teams-roles') === 0) return false;
	      if (href.indexOf('/instructor/peer-review') === 0) return false;
	      return true;
	    };
	
	    _this.renderStep1Substeps = function () {
	      return _react2.default.createElement(
	        Styled.SubstepGroup,
	        { className: 'checklist-substep-group' },
	        STEP1_SUBSTEPS.map(function (sub) {
	          return _this.renderSubstepRow(sub, _this.renderInternalSubstepLink(sub.linkText, sub.href, _this.isRoundAwareRoute(sub.href)));
	        })
	      );
	    };
	
	    _this.renderStep2Substeps = function () {
	      return _react2.default.createElement(
	        Styled.SubstepGroup,
	        { className: 'checklist-substep-group' },
	        STEP2_SUBSTEPS.map(function (sub) {
	          return _this.renderSubstepRow(sub, _this.renderInternalSubstepLink(sub.linkText, sub.href, _this.isRoundAwareRoute(sub.href)));
	        })
	      );
	    };
	
	    _this.renderStep3Substeps = function () {
	      return _react2.default.createElement(
	        Styled.SubstepGroup,
	        { className: 'checklist-substep-group' },
	        STEP3_SUBSTEPS.map(function (sub) {
	          return _this.renderSubstepRow(sub, _this.renderPopupSubstepLink(sub.linkText, sub.popupId));
	        })
	      );
	    };
	
	    _this.renderPopup = function () {
	      var activePopupId = _this.state.activePopupId;
	
	      if (!activePopupId) return null;
	      var Component = POPUP_COMPONENTS[activePopupId];
	      if (!Component) return null;
	      return _react2.default.createElement(
	        Styled.Modal.Backdrop,
	        { onClick: _this.closePopup, role: 'dialog', 'aria-modal': 'true' },
	        _react2.default.createElement(
	          Styled.Modal.Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            Styled.Modal.HeaderBar,
	            null,
	            _react2.default.createElement(
	              Styled.Modal.Title,
	              null,
	              POPUP_TITLES[activePopupId]
	            ),
	            _react2.default.createElement(
	              Styled.Modal.CloseButton,
	              {
	                type: 'button',
	                onClick: _this.closePopup,
	                'aria-label': 'Close'
	              },
	              '\xD7'
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Modal.Body,
	            null,
	            _react2.default.createElement(Component, null)
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      completed: _this.readFromStorage(),
	      activePopupId: null
	    };
	    return _this;
	  }
	
	  _createClass(InstructorWelcomeChecklist, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof window !== 'undefined') {
	        window.addEventListener('keydown', this.handleKeydown);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof window !== 'undefined') {
	        window.removeEventListener('keydown', this.handleKeydown);
	      }
	    }
	
	    // ---- persistence -----------------------------------------------
	
	  }, {
	    key: 'render',
	
	
	    // ---- render ----------------------------------------------------
	
	    value: function render() {
	      var _this2 = this;
	
	      var step1Complete = this.isStepComplete(STEP1_SUBSTEPS);
	      var step2Complete = this.isStepComplete(STEP2_SUBSTEPS);
	      var step3Complete = this.isStepComplete(STEP3_SUBSTEPS);
	      var activeId = this.firstIncompleteStepId();
	      var allDone = this.allComplete();
	
	      var completedCount = this.allCompleteIds().filter(function (id) {
	        return _this2.isLeafComplete(id);
	      }).length;
	      var totalCount = this.allCompleteIds().length;
	
	      return _react2.default.createElement(
	        Styled.Root,
	        null,
	        _react2.default.createElement(
	          Styled.Header,
	          null,
	          _react2.default.createElement(
	            Styled.Title,
	            null,
	            'Welcome to the Intro to Business Challenge!'
	          ),
	          _react2.default.createElement(
	            Styled.Subhead,
	            null,
	            'To get the course set up and ready, follow the checklist below.'
	          ),
	          _react2.default.createElement(
	            Styled.SrOnly,
	            { 'aria-live': 'polite' },
	            completedCount,
	            ' of ',
	            totalCount,
	            ' steps complete'
	          )
	        ),
	        _react2.default.createElement(
	          Styled.Timeline,
	          null,
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'required-setup' },
	            this.renderStepCircle(1, step1Complete, activeId === 'required-setup'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepTitle,
	                { completed: step1Complete },
	                'Required Setup'
	              ),
	              _react2.default.createElement(
	                Styled.StepDescription,
	                null,
	                'Take care of these before students join, they unlock the round and team structure.'
	              ),
	              this.renderStep1Substeps()
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'review-defaults' },
	            this.renderStepCircle(2, step2Complete, activeId === 'review-defaults'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepTitle,
	                { completed: step2Complete },
	                'Review Default Settings'
	              ),
	              _react2.default.createElement(
	                Styled.StepDescription,
	                null,
	                'The defaults are sensible. Skim each item and only modify if you want a different challenge profile.'
	              ),
	              this.renderStep2Substeps()
	            )
	          ),
	          _react2.default.createElement(
	            Styled.Step,
	            { active: activeId === 'what-to-expect' },
	            this.renderStepCircle(3, step3Complete, activeId === 'what-to-expect'),
	            _react2.default.createElement(
	              Styled.StepBody,
	              null,
	              _react2.default.createElement(
	                Styled.StepTitle,
	                { completed: step3Complete },
	                'What to Expect'
	              ),
	              _react2.default.createElement(
	                Styled.StepDescription,
	                null,
	                'Each round emphasizes a different business discipline. Click into each round to preview what students will see.'
	              ),
	              this.renderStep3Substeps()
	            )
	          )
	        ),
	        allDone && _react2.default.createElement(
	          Styled.CompletionBanner,
	          null,
	          _react2.default.createElement(
	            Styled.CompletionIcon,
	            { 'aria-hidden': 'true' },
	            COMPLETION_COPY.icon
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              Styled.CompletionTitle,
	              null,
	              COMPLETION_COPY.title
	            ),
	            _react2.default.createElement(
	              Styled.CompletionDescription,
	              null,
	              COMPLETION_COPY.description
	            )
	          )
	        ),
	        this.renderPopup()
	      );
	    }
	  }, {
	    key: 'activeRound',
	
	
	    // ---- helpers ---------------------------------------------------
	
	    get: function get() {
	      var _props = this.props,
	          roundInUrl = _props.roundInUrl,
	          currentRound = _props.currentRound;
	
	      return roundInUrl || currentRound || 1;
	    }
	
	    // ---- popup actions ---------------------------------------------
	
	    // ---- render helpers --------------------------------------------
	
	    // Substeps in Step 1 + Step 2 navigate to existing instructor
	    // routes. The link includes the current round when the route is
	    // round-aware.
	
	
	    // /instructor/rounds (and /grading/* + /peer-review) use ?round=N
	    // for round-aware routing. /instructor/teams-roles does not.
	
	  }]);
	
	  return InstructorWelcomeChecklist;
	}(_react.PureComponent);
	
	exports.default = InstructorWelcomeChecklist;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n\n    &.black-note {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n\n    &.black-note {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _instructorOnboardingImage = __webpack_require__(2586);
	
	var _instructorOnboardingImage2 = _interopRequireDefault(_instructorOnboardingImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var WhatToExpectStep2 = function WhatToExpectStep2() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Text1,
	        null,
	        'What To Expect'
	      ),
	      _react2.default.createElement(
	        Text2,
	        null,
	        'Round 1 | product & marketing disciplines are emphasized'
	      ),
	      _react2.default.createElement(
	        Text3,
	        null,
	        'Your students are entering the market in Round 1 and in order for them to be successful, they have to create an attractive marketing mix.'
	      ),
	      _react2.default.createElement(
	        Image,
	        null,
	        _react2.default.createElement('img', { src: _instructorOnboardingImage2.default, alt: '' })
	      ),
	      _react2.default.createElement(
	        Text3,
	        null,
	        _react2.default.createElement(
	          'b',
	          { className: 'black-note' },
	          'Note:'
	        ),
	        ' Teams also need to have sufficient inventory therefore Operation decisions also matter.'
	      )
	    )
	  );
	};
	
	exports.default = WhatToExpectStep2;

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n\n    &.black-note {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  }\n\n  a {\n    &:active, &:visited, &:link {\n      color: #5c91f5;\n      text-decoration: underline;\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n\n    &.black-note {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  }\n\n  a {\n    &:active, &:visited, &:link {\n      color: #5c91f5;\n      text-decoration: underline;\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _instructorOnboardingImage = __webpack_require__(2587);
	
	var _instructorOnboardingImage2 = _interopRequireDefault(_instructorOnboardingImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var WhatToExpectStep3 = function WhatToExpectStep3() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Text1,
	        null,
	        'What To Expect'
	      ),
	      _react2.default.createElement(
	        Text2,
	        null,
	        'Round 2 | operation discipline is emphasized'
	      ),
	      _react2.default.createElement(
	        Text3,
	        null,
	        'Round 2 presents an additional layer of complexity with lead time becoming a significant factor for customers and with competitors\' repositioning their strategies due to new information learned from round 1 performance.'
	      ),
	      _react2.default.createElement(
	        Image,
	        null,
	        _react2.default.createElement('img', { src: _instructorOnboardingImage2.default, alt: '' })
	      ),
	      _react2.default.createElement(
	        Text3,
	        null,
	        'As a result of the lead time factor, Ops will have a new decision to consider:',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'b',
	          null,
	          'Should a distribution center be opened? If so, where?'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'b',
	          { className: 'black-note' },
	          'Note:'
	        ),
	        ' Product, on the other hand, will be re-evaluating their ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.mindtools.com/pages/article/newTMC_90.htm', target: '_blank', rel: 'noreferrer' },
	          'product market expansion strategies'
	        ),
	        ' given competitors\' positioning.'
	      )
	    )
	  );
	};
	
	exports.default = WhatToExpectStep3;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  flex: 1;\n'], ['\n  background: #f5f6f7;\n  flex: 1;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n'], ['\n  padding: 40px;\n  width: 80%;\n  max-width: 794px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgba(0, 27, 59, 0.38);\n  text-transform: uppercase;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin-top: 24px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n\n    &.black-note {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 12px;\n\n  b {\n    color: #ed716d;\n\n    &.black-note {\n      color: rgba(0, 27, 59, 0.94);\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 12px;\n'], ['\n  display: flex;\n  margin-top: 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _instructorOnboardingImage = __webpack_require__(2588);
	
	var _instructorOnboardingImage2 = _interopRequireDefault(_instructorOnboardingImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Text1 = _styledComponents2.default.div(_templateObject3);
	
	var Text2 = _styledComponents2.default.div(_templateObject4);
	
	var Text3 = _styledComponents2.default.div(_templateObject5);
	
	var Image = _styledComponents2.default.div(_templateObject6);
	
	var WhatToExpectStep4 = function WhatToExpectStep4() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Text1,
	        null,
	        'What To Expect'
	      ),
	      _react2.default.createElement(
	        Text2,
	        null,
	        'Round 3 | Accounting & Finance disciplines are emphasized'
	      ),
	      _react2.default.createElement(
	        Text3,
	        null,
	        'In round 3, finance & accounting comes into more focus as at least profitability metrics is introduced (ROE, ROA, and/or EPS). In other words, teams will have to make a profit.'
	      ),
	      _react2.default.createElement(
	        Image,
	        null,
	        _react2.default.createElement('img', { src: _instructorOnboardingImage2.default, alt: '' })
	      ),
	      _react2.default.createElement(
	        Text3,
	        null,
	        'To better their odds, your students will need to spend time analyzing their prior round financials as well as consider new financing options to maximize their chance of hitting those metrics (e.g. share buybacks).'
	      )
	    )
	  );
	};
	
	exports.default = WhatToExpectStep4;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _reactFontawesome = __webpack_require__(147);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _ApiService = __webpack_require__(4);
	
	var _addCourseModal = __webpack_require__(1436);
	
	var _addCourseModal2 = _interopRequireDefault(_addCourseModal);
	
	var _editCourseModal = __webpack_require__(1443);
	
	var _editCourseModal2 = _interopRequireDefault(_editCourseModal);
	
	var _iasCourseModal = __webpack_require__(1449);
	
	var _iasCourseModal2 = _interopRequireDefault(_iasCourseModal);
	
	var _studentCourseModal = __webpack_require__(1511);
	
	var _studentCourseModal2 = _interopRequireDefault(_studentCourseModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	var COURSES_LIST_API = ("https://be-production-itb.marketgames.io/api/") + "courses/";
	var COURSE_MEMBERS_LIST_API = ("https://be-production-itb.marketgames.io/api/") + "course_members/";
	
	var IAS_ROLE = 2;
	var STUDENT_ROLE = 1;
	
	var CourseManagement = function (_PureComponent) {
	  _inherits(CourseManagement, _PureComponent);
	
	  function CourseManagement(props) {
	    _classCallCheck(this, CourseManagement);
	
	    var _this = _possibleConstructorReturn(this, (CourseManagement.__proto__ || Object.getPrototypeOf(CourseManagement)).call(this, props));
	
	    _this.fetchCourses = function () {
	      (0, _ApiService.getRequest)(COURSES_LIST_API).then(function (res) {
	        _this.setState({
	          courses: res.body,
	          courses_loaded: true
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.fetchCourseMembers = function () {
	      (0, _ApiService.getRequest)(COURSE_MEMBERS_LIST_API).then(function (res) {
	        _this.setState({
	          course_members: res.body,
	          course_members_loaded: true
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.countAssistents = function (course) {
	      var course_members = _this.state.course_members;
	
	      var assistents = course_members.filter(function (course_member) {
	        return course_member.course === course.id && course_member.type === IAS_ROLE && course.users.includes(course_member.user);
	      });
	
	      return assistents.length;
	    };
	
	    _this.countStudents = function (course) {
	      var course_members = _this.state.course_members;
	
	      var students = course_members.filter(function (course_member) {
	        return course_member.course === course.id && course_member.type === STUDENT_ROLE && course.users.includes(course_member.user);
	      });
	
	      return students.length;
	    };
	
	    _this.showAddModal = function () {
	      _this.setState({
	        addModalShown: true
	      });
	    };
	
	    _this.hideAddModal = function () {
	      _this.setState({
	        addModalShown: false
	      });
	    };
	
	    _this.showEditModal = function () {
	      _this.setState({
	        editModalShown: true
	      });
	    };
	
	    _this.hideEditModal = function () {
	      _this.setState({
	        editModalShown: false,
	        current_course: null
	      });
	    };
	
	    _this.showIASModal = function () {
	      _this.setState({
	        iasModalShown: true
	      });
	    };
	
	    _this.hideIASModal = function () {
	      _this.setState({
	        iasModalShown: false,
	        current_course: null
	      });
	    };
	
	    _this.showStudentModal = function () {
	      _this.setState({
	        studentModalShown: true
	      });
	    };
	
	    _this.hideStudentModal = function () {
	      _this.setState({
	        studentModalShown: false,
	        current_course: null
	      });
	    };
	
	    _this.addCourse = function (course_name, callback) {
	      (0, _ApiService.postRequest)(COURSES_LIST_API).send({
	        name: course_name
	      }).then(function (res) {
	        callback();
	        _this.fetchCourses();
	
	        _this.setState({
	          addModalShown: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.editCourse = function (course_name, callback) {
	      var current_course = _this.state.current_course;
	
	
	      (0, _ApiService.putRequest)("" + COURSES_LIST_API + current_course.id + "/").send({
	        name: course_name
	      }).then(function (res) {
	        callback();
	        _this.fetchCourses();
	
	        _this.setState({
	          editModalShown: false,
	          current_course: null
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.deleteCourse = function (e, course_id) {
	      e.preventDefault();
	
	      var courses = _this.state.courses;
	
	      var course = courses.find(function (i) {
	        return i.id === course_id;
	      });
	      var course_name = course ? course.name : "";
	
	      if (window.confirm("Are sure to delete course \"" + course_name + "\"?")) {
	        (0, _ApiService.deleteRequest)("" + COURSES_LIST_API + course_id + "/").then(function (res) {
	          _this.fetchCourses();
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.editCourseModal = function (e, course_id) {
	      e.preventDefault();
	
	      var courses = _this.state.courses;
	
	      var course = courses.find(function (i) {
	        return i.id === course_id;
	      });
	
	      if (course) {
	        _this.setState({
	          current_course: course
	        }, function () {
	          _this.showEditModal();
	        });
	      }
	    };
	
	    _this.initIASCourseModal = function (e, course_id) {
	      e.preventDefault();
	
	      var courses = _this.state.courses;
	
	      var course = courses.find(function (i) {
	        return i.id === course_id;
	      });
	
	      if (course) {
	        _this.setState({
	          current_course: course
	        }, function () {
	          _this.showIASModal();
	        });
	      }
	    };
	
	    _this.initStudentCourseModal = function (e, course_id) {
	      e.preventDefault();
	
	      var courses = _this.state.courses;
	
	      var course = courses.find(function (i) {
	        return i.id === course_id;
	      });
	
	      if (course) {
	        _this.setState({
	          current_course: course
	        }, function () {
	          _this.showStudentModal();
	        });
	      }
	    };
	
	    _this.state = {
	      courses: [],
	      course_members: [],
	      courses_loaded: false,
	      course_members_loaded: false,
	      addModalShown: false,
	      editModalShown: false,
	      iasModalShown: false,
	      studentModalShown: false,
	      current_course: null
	    };
	    return _this;
	  }
	
	  _createClass(CourseManagement, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchCourses();
	      this.fetchCourseMembers();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          courses = _state.courses,
	          courses_loaded = _state.courses_loaded,
	          course_members_loaded = _state.course_members_loaded,
	          addModalShown = _state.addModalShown,
	          editModalShown = _state.editModalShown,
	          iasModalShown = _state.iasModalShown,
	          studentModalShown = _state.studentModalShown,
	          current_course = _state.current_course;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "instructorPage" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Courses"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "instructorWrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "No."
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Course Name"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Course Code"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Instructor Assistants"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Students"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                (courses_loaded === false || course_members_loaded === false) && _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      colSpan: 5,
	                      className: "text-center v-align-middle instructor-td"
	                    },
	                    "Loading..."
	                  )
	                ),
	                courses_loaded === true && course_members_loaded === true && courses.map(function (course, counter) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: counter },
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle instructor-round-number b-r" },
	                      counter + 1
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l b-r instructor-td" },
	                      course.name,
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/#",
	                          onClick: function onClick(e) {
	                            return _this2.editCourseModal(e, course.id);
	                          },
	                          className: "no-outline"
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, {
	                          className: "instructor-edit",
	                          name: "edit"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/#",
	                          onClick: function onClick(e) {
	                            return _this2.deleteCourse(e, course.id);
	                          },
	                          className: "no-outline",
	                          style: { display: "none" }
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, {
	                          className: "instructor-edit",
	                          name: "trash-o"
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l b-r instructor-td" },
	                      course.code
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l b-r instructor-td" },
	                      _this2.countAssistents(course),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/#",
	                          onClick: function onClick(e) {
	                            return _this2.initIASCourseModal(e, course.id);
	                          },
	                          className: "no-outline"
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, {
	                          className: "instructor-edit",
	                          name: "edit"
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l instructor-td" },
	                      _this2.countStudents(course),
	                      _react2.default.createElement(
	                        "a",
	                        {
	                          href: "/#",
	                          onClick: function onClick(e) {
	                            return _this2.initStudentCourseModal(e, course.id);
	                          },
	                          className: "no-outline"
	                        },
	                        _react2.default.createElement(_reactFontawesome2.default, {
	                          className: "instructor-edit",
	                          name: "edit"
	                        })
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          courses.length < 3 && _react2.default.createElement(
	            "div",
	            { className: "bottom-button" },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: "light-blue",
	                onClick: this.showAddModal,
	                block: true
	              },
	              "Add"
	            )
	          )
	        ),
	        _react2.default.createElement(_addCourseModal2.default, {
	          show: addModalShown,
	          onHide: this.hideAddModal,
	          addCourse: this.addCourse
	        }),
	        _react2.default.createElement(_editCourseModal2.default, {
	          show: editModalShown,
	          onHide: this.hideEditModal,
	          editCourse: this.editCourse,
	          currentCourse: current_course
	        }),
	        _react2.default.createElement(_iasCourseModal2.default, {
	          show: iasModalShown,
	          onHide: this.hideIASModal,
	          currentCourse: current_course,
	          fetchData: this.fetchCourseMembers
	        }),
	        _react2.default.createElement(_studentCourseModal2.default, {
	          show: studentModalShown,
	          onHide: this.hideStudentModal,
	          currentCourse: current_course
	        })
	      );
	    }
	  }]);
	
	  return CourseManagement;
	}(_react.PureComponent);
	
	exports.default = CourseManagement;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _teamDynamicsModalTit, _teamDynamicsField;
	
	var _templateObject = _taggedTemplateLiteral(["\n  &:active,\n  &:visited,\n  &:link {\n    font-family: 'Mukta Vaani', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 23px;\n    text-decoration: underline;\n    color: #fff;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  &:active,\n  &:visited,\n  &:link {\n    font-family: 'Mukta Vaani', sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 23px;\n    text-decoration: underline;\n    color: #fff;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(520px, calc(100vw - 40px));\n  max-height: calc(100vh - 120px);\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  z-index: 1700;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(520px, calc(100vw - 40px));\n  max-height: calc(100vh - 120px);\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  z-index: 1700;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1800;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1800;\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(1280px, calc(100vw - 40px));\n  max-height: calc(100vh - 60px);\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  z-index: 1900;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(1280px, calc(100vw - 40px));\n  max-height: calc(100vh - 60px);\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  z-index: 1900;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  padding: 24px 32px 16px;\n  border-bottom: 1px solid #ECEDEF;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n"], ["\n  padding: 24px 32px 16px;\n  border-bottom: 1px solid #ECEDEF;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 0;\n"], ["\n  flex: 1 1 auto;\n  min-width: 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin: 0 0 6px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin: 0 0 6px;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 32px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 32px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 8px 0 0;\n  max-width: 640px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.7);\n  margin: 8px 0 0;\n  max-width: 640px;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  background: #F5F7FA;\n  border: 1px solid #E1E6EE;\n  border-radius: 10px;\n  padding: 12px 18px;\n  min-width: 118px;\n"], ["\n  background: #F5F7FA;\n  border: 1px solid #E1E6EE;\n  border-radius: 10px;\n  padding: 12px 18px;\n  min-width: 118px;\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 2px;\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  padding: 20px 32px 8px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n"], ["\n  padding: 20px 32px 8px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n"]),
	    _templateObject16 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n"]),
	    _templateObject17 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid #E1E6EE;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 400px;\n  max-height: calc(100vh - 320px);\n"], ["\n  background: #ffffff;\n  border: 1px solid #E1E6EE;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 400px;\n  max-height: calc(100vh - 320px);\n"]),
	    _templateObject18 = _taggedTemplateLiteral(["\n  height: 4px;\n  background: ", ";\n"], ["\n  height: 4px;\n  background: ", ";\n"]),
	    _templateObject19 = _taggedTemplateLiteral(["\n  padding: 14px 16px 12px;\n"], ["\n  padding: 14px 16px 12px;\n"]),
	    _templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"]),
	    _templateObject21 = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: ", ";\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n"], ["\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: ", ";\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n"]),
	    _templateObject22 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject23 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-left: 8px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-left: 8px;\n"]),
	    _templateObject24 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  background: none;\n  border: none;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: #3A507B;\n  cursor: pointer;\n  padding: 4px 6px;\n\n  &:hover {\n    text-decoration: underline;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    color: rgba(0, 27, 59, 0.35);\n    cursor: default;\n    text-decoration: none;\n  }\n"], ["\n  margin-left: auto;\n  background: none;\n  border: none;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: #3A507B;\n  cursor: pointer;\n  padding: 4px 6px;\n\n  &:hover {\n    text-decoration: underline;\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    color: rgba(0, 27, 59, 0.35);\n    cursor: default;\n    text-decoration: none;\n  }\n"]),
	    _templateObject25 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 6px;\n  padding-left: 42px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-top: 6px;\n  padding-left: 42px;\n"]),
	    _templateObject26 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 92px 56px 1fr;\n  gap: 8px;\n  padding: 8px 16px;\n  background: #F5F7FA;\n  border-top: 1px solid #E1E6EE;\n  border-bottom: 1px solid #E1E6EE;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 14px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n"], ["\n  display: grid;\n  grid-template-columns: 92px 56px 1fr;\n  gap: 8px;\n  padding: 8px 16px;\n  background: #F5F7FA;\n  border-top: 1px solid #E1E6EE;\n  border-bottom: 1px solid #E1E6EE;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 14px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n"]),
	    _templateObject27 = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  flex: 1 1 auto;\n"], ["\n  overflow-y: auto;\n  flex: 1 1 auto;\n"]),
	    _templateObject28 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 92px 56px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 10px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #F1F3F6;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: #F5F7FA;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 92px 56px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 10px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #F1F3F6;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background: #F5F7FA;\n  }\n"]),
	    _templateObject29 = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin: 0;\n"], ["\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin: 0;\n"]),
	    _templateObject30 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1;\n  flex-shrink: 0;\n"], ["\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1;\n  flex-shrink: 0;\n"]),
	    _templateObject31 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  text-decoration: none;\n  cursor: pointer;\n  min-width: 0;\n\n  &:hover {\n    color: #3A507B;\n    text-decoration: underline;\n  }\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  text-decoration: none;\n  cursor: pointer;\n  min-width: 0;\n\n  &:hover {\n    color: #3A507B;\n    text-decoration: underline;\n  }\n"]),
	    _templateObject32 = _taggedTemplateLiteral(["\n  padding: 24px 16px;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n  text-align: center;\n"], ["\n  padding: 24px 16px;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.55);\n  text-align: center;\n"]),
	    _templateObject33 = _taggedTemplateLiteral(["\n  padding: 16px 24px;\n  border-top: 1px solid #ECEDEF;\n  background: #ffffff;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  padding: 16px 24px;\n  border-top: 1px solid #ECEDEF;\n  background: #ffffff;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  align-items: center;\n"]),
	    _templateObject34 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject35 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject36 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-top: 2px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.55);\n  margin-top: 2px;\n"]),
	    _templateObject37 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n"], ["\n  display: flex;\n  gap: 12px;\n"]),
	    _templateObject38 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.4);\n  }\n"], ["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.4);\n  }\n"]),
	    _templateObject39 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 22px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    background: #a4d9b1;\n    border-color: #a4d9b1;\n    cursor: default;\n  }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 22px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    background: #a4d9b1;\n    border-color: #a4d9b1;\n    cursor: default;\n  }\n"]),
	    _templateObject40 = _taggedTemplateLiteral(["\n  padding: 24px 32px 12px;\n  border-bottom: 1px solid #ECEDEF;\n"], ["\n  padding: 24px 32px 12px;\n  border-bottom: 1px solid #ECEDEF;\n"]),
	    _templateObject41 = _taggedTemplateLiteral(["\n  padding: 20px 32px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n"], ["\n  padding: 20px 32px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n"]),
	    _templateObject42 = _taggedTemplateLiteral(["\n  padding: 16px 24px;\n  border-top: 1px solid #ECEDEF;\n  background: #ffffff;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n"], ["\n  padding: 16px 24px;\n  border-top: 1px solid #ECEDEF;\n  background: #ffffff;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n"]),
	    _templateObject43 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 4px 8px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.3);\n  }\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 4px 8px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.3);\n  }\n"]),
	    _templateObject44 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n"]),
	    _templateObject45 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: pre-wrap;\n  margin: 0 0 20px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: pre-wrap;\n  margin: 0 0 20px;\n"]),
	    _templateObject46 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: pre-wrap;\n  background: #F5F6F7;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin: 16px 0 0;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: pre-wrap;\n  background: #F5F6F7;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin: 16px 0 0;\n"]),
	    _templateObject47 = _taggedTemplateLiteral(["\n  color: #2DA548;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: #248339;\n  }\n"], ["\n  color: #2DA548;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    color: #248339;\n  }\n"]),
	    _templateObject48 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"]),
	    _templateObject49 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 620px;\n  max-height: calc(100vh - 120px);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 620px;\n  max-height: calc(100vh - 120px);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
	    _templateObject50 = _taggedTemplateLiteral(["\n  padding: 20px 28px 12px;\n  border-bottom: 1px solid #ECEDEF;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding: 20px 28px 12px;\n  border-bottom: 1px solid #ECEDEF;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]),
	    _templateObject51 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject52 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 4px 8px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 4px 8px;\n  line-height: 1;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject53 = _taggedTemplateLiteral(["\n  padding: 20px 28px 28px;\n  overflow-y: auto;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: pre-wrap;\n"], ["\n  padding: 20px 28px 28px;\n  overflow-y: auto;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  white-space: pre-wrap;\n"]),
	    _templateObject54 = _taggedTemplateLiteral(["\n  background: #FAFBFD;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin: 0 0 20px;\n"], ["\n  background: #FAFBFD;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin: 0 0 20px;\n"]),
	    _templateObject55 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"]),
	    _templateObject56 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 4px 0;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 4px 0;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject57 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  min-width: 24px;\n"], ["\n  font-weight: 600;\n  min-width: 24px;\n"]),
	    _templateObject58 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #3A507B;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 8px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #3A507B;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 8px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n"]),
	    _templateObject59 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n"]),
	    _templateObject60 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    background: #a4d9b1;\n    border-color: #a4d9b1;\n    cursor: default;\n  }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    background: #a4d9b1;\n    border-color: #a4d9b1;\n    cursor: default;\n  }\n"]),
	    _templateObject61 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: #d34c4c;\n  margin: 0 0 12px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: #d34c4c;\n  margin: 0 0 12px;\n"]),
	    _templateObject62 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 24px 0;\n  text-align: center;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 24px 0;\n  text-align: center;\n"]),
	    _templateObject63 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  margin-right: auto;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.4);\n  }\n"], ["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n  margin-right: auto;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n\n  &:disabled {\n    cursor: default;\n    color: rgba(0, 27, 59, 0.4);\n  }\n"]),
	    _templateObject64 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"], ["\n  position: fixed;\n  top: 59px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 27, 59, 0.55);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n"]),
	    _templateObject65 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 520px;\n  padding: 32px 36px;\n  text-align: center;\n"]),
	    _templateObject66 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n"]),
	    _templateObject67 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 24px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 24px;\n"]),
	    _templateObject68 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 10px 28px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n"]),
	    _templateObject69 = _taggedTemplateLiteral(["\n  background: none;\n  border: 0;\n  padding: 4px 0 0;\n  margin: 0;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #5C91F5;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover { text-decoration: underline; }\n  &:disabled {\n    color: rgba(0, 27, 59, 0.4);\n    cursor: default;\n    text-decoration: none;\n  }\n"], ["\n  background: none;\n  border: 0;\n  padding: 4px 0 0;\n  margin: 0;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #5C91F5;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover { text-decoration: underline; }\n  &:disabled {\n    color: rgba(0, 27, 59, 0.4);\n    cursor: default;\n    text-decoration: none;\n  }\n"]),
	    _templateObject70 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 640px;\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 640px;\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
	    _templateObject71 = _taggedTemplateLiteral(["\n  padding: 20px 24px 12px;\n  border-bottom: 1px solid #ECEDEF;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n"], ["\n  padding: 20px 24px 12px;\n  border-bottom: 1px solid #ECEDEF;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n"]),
	    _templateObject72 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 4px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 4px;\n"]),
	    _templateObject73 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject74 = _taggedTemplateLiteral(["\n  background: none;\n  border: 0;\n  font-size: 24px;\n  line-height: 1;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 2px 6px;\n  flex: none;\n\n  &:hover { color: rgba(0, 27, 59, 0.94); }\n"], ["\n  background: none;\n  border: 0;\n  font-size: 24px;\n  line-height: 1;\n  color: rgba(0, 27, 59, 0.6);\n  cursor: pointer;\n  padding: 2px 6px;\n  flex: none;\n\n  &:hover { color: rgba(0, 27, 59, 0.94); }\n"]),
	    _templateObject75 = _taggedTemplateLiteral(["\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid #ECEDEF;\n"], ["\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid #ECEDEF;\n"]),
	    _templateObject76 = _taggedTemplateLiteral(["\n  background: #3A507B;\n  border: 1px solid #3A507B;\n  border-radius: 4px;\n  padding: 8px 18px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #2a3f66; border-color: #2a3f66; }\n  &:disabled { background: #a4b2cd; border-color: #a4b2cd; cursor: default; }\n"], ["\n  background: #3A507B;\n  border: 1px solid #3A507B;\n  border-radius: 4px;\n  padding: 8px 18px;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover { background: #2a3f66; border-color: #2a3f66; }\n  &:disabled { background: #a4b2cd; border-color: #a4b2cd; cursor: default; }\n"]),
	    _templateObject77 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  color: #2DA548;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  color: #2DA548;\n"]),
	    _templateObject78 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 12px 24px;\n  border-bottom: 1px solid #F1F3F6;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.85);\n\n  &:last-child { border-bottom: none; }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 12px 24px;\n  border-bottom: 1px solid #F1F3F6;\n  font-family: 'Mukta Vaani';\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.85);\n\n  &:last-child { border-bottom: none; }\n"]),
	    _templateObject79 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  font-weight: 600;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject80 = _taggedTemplateLiteral(["\n  color: rgba(0, 27, 59, 0.65);\n  word-break: break-all;\n"], ["\n  color: rgba(0, 27, 59, 0.65);\n  word-break: break-all;\n"]),
	    _templateObject81 = _taggedTemplateLiteral(["\n  padding: 24px;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  text-align: center;\n"], ["\n  padding: 24px;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  text-align: center;\n"]),
	    _templateObject82 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 720px;\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"], ["\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 720px;\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),
	    _templateObject83 = _taggedTemplateLiteral(["\n  padding: 22px 28px 16px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n"], ["\n  padding: 22px 28px 16px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n"]),
	    _templateObject84 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin: 0 0 4px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(0, 27, 59, 0.55);\n  margin: 0 0 4px;\n"]),
	    _templateObject85 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n"]),
	    _templateObject86 = _taggedTemplateLiteral(["\n  margin: 0 24px 16px;\n  padding: 16px 20px;\n  background: #EDF4FF;\n  border: 1px solid #D7E5F9;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n"], ["\n  margin: 0 24px 16px;\n  padding: 16px 20px;\n  background: #EDF4FF;\n  border: 1px solid #D7E5F9;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n"]),
	    _templateObject87 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.94);\n  color: #ffffff;\n  display: grid;\n  place-items: center;\n  flex: none;\n\n  svg { width: 20px; height: 20px; }\n"], ["\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(0, 27, 59, 0.94);\n  color: #ffffff;\n  display: grid;\n  place-items: center;\n  flex: none;\n\n  svg { width: 20px; height: 20px; }\n"]),
	    _templateObject88 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.65);\n  margin-top: 2px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.65);\n  margin-top: 2px;\n"]),
	    _templateObject89 = _taggedTemplateLiteral(["\n  margin: 0 24px 12px;\n  position: relative;\n"], ["\n  margin: 0 24px 12px;\n  position: relative;\n"]),
	    _templateObject90 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 14px;\n  transform: translateY(-50%);\n  color: rgba(0, 27, 59, 0.45);\n  pointer-events: none;\n  display: inline-flex;\n  svg { width: 16px; height: 16px; }\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 14px;\n  transform: translateY(-50%);\n  color: rgba(0, 27, 59, 0.45);\n  pointer-events: none;\n  display: inline-flex;\n  svg { width: 16px; height: 16px; }\n"]),
	    _templateObject91 = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 14px 10px 38px;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  background: #ffffff;\n\n  &::placeholder { color: rgba(0, 27, 59, 0.4); }\n  &:focus { outline: none; border-color: #55B4BC; }\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 14px 10px 38px;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  background: #ffffff;\n\n  &::placeholder { color: rgba(0, 27, 59, 0.4); }\n  &:focus { outline: none; border-color: #55B4BC; }\n"]),
	    _templateObject92 = _taggedTemplateLiteral(["\n  padding: 0 24px 12px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 12px;\n"], ["\n  padding: 0 24px 12px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 12px;\n"]),
	    _templateObject93 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1px solid #E1E6EE;\n  border-radius: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1px solid #E1E6EE;\n  border-radius: 10px;\n"]),
	    _templateObject94 = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #EEF2F8;\n  color: rgba(0, 27, 59, 0.78);\n  display: grid;\n  place-items: center;\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 1;\n  flex: none;\n"], ["\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #EEF2F8;\n  color: rgba(0, 27, 59, 0.78);\n  display: grid;\n  place-items: center;\n  font-family: 'Mukta Vaani';\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 1;\n  flex: none;\n"]),
	    _templateObject95 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 0;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  flex: 1 1 auto;\n  min-width: 0;\n  font-family: 'Mukta Vaani';\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.94);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]),
	    _templateObject96 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: #EDF4FF;\n  border-radius: 999px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #3A507B;\n  flex: none;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: #EDF4FF;\n  border-radius: 999px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #3A507B;\n  flex: none;\n"]),
	    _templateObject97 = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #5C91F5;\n  flex: none;\n"], ["\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #5C91F5;\n  flex: none;\n"]),
	    _templateObject98 = _taggedTemplateLiteral(["\n  grid-column: 1 / -1;\n  padding: 24px;\n  text-align: center;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  grid-column: 1 / -1;\n  padding: 24px;\n  text-align: center;\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject99 = _taggedTemplateLiteral(["\n  padding: 14px 24px;\n  border-top: 1px solid #ECEDEF;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n"], ["\n  padding: 14px 24px;\n  border-top: 1px solid #ECEDEF;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n"]),
	    _templateObject100 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  font-family: 'Mukta Vaani';\n  font-weight: 400;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject101 = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover { background: #f5f6f7; }\n"], ["\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 6px;\n  padding: 8px 20px;\n  font-family: 'Mukta Vaani';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover { background: #f5f6f7; }\n"]),
	    _templateObject102 = _taggedTemplateLiteral(["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 4px 10px;\n  cursor: pointer;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  color: #ffffff;\n  text-transform: uppercase;\n  line-height: 16px;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    cursor: default;\n    background: #ffffff;\n    border-color: #D5D9DD;\n    color: rgba(0, 27, 59, 0.48);\n  }\n"], ["\n  background: #2DA548;\n  border: 1px solid #2DA548;\n  border-radius: 4px;\n  padding: 4px 10px;\n  cursor: pointer;\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  color: #ffffff;\n  text-transform: uppercase;\n  line-height: 16px;\n\n  &:hover {\n    background: #248339;\n    border-color: #248339;\n  }\n\n  &:disabled {\n    cursor: default;\n    background: #ffffff;\n    border-color: #D5D9DD;\n    color: rgba(0, 27, 59, 0.48);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dashboard = __webpack_require__(310);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboardSelect = __webpack_require__(407);
	
	var _dashboardSelect2 = _interopRequireDefault(_dashboardSelect);
	
	var _dashboardSelectMultiple = __webpack_require__(1442);
	
	var _dashboardSelectMultiple2 = _interopRequireDefault(_dashboardSelectMultiple);
	
	var _dashboardBarChart = __webpack_require__(1441);
	
	var _dashboardBarChart2 = _interopRequireDefault(_dashboardBarChart);
	
	var _recharts = __webpack_require__(27);
	
	var _teamDynamicsPopup = __webpack_require__(1514);
	
	var _teamDynamicsPopup2 = _interopRequireDefault(_teamDynamicsPopup);
	
	var _studentStatsPopup = __webpack_require__(1512);
	
	var _studentStatsPopup2 = _interopRequireDefault(_studentStatsPopup);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _get2 = __webpack_require__(133);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _orderBy = __webpack_require__(200);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactCsv = __webpack_require__(952);
	
	var _reactRouter = __webpack_require__(24);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _groupBy = __webpack_require__(2038);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _SkillsBadgePopup = __webpack_require__(597);
	
	var _SkillsBadgePopup2 = _interopRequireDefault(_SkillsBadgePopup);
	
	var _InstructorSurveyReadyNotification = __webpack_require__(1201);
	
	var _InstructorSurveyReadyNotification2 = _interopRequireDefault(_InstructorSurveyReadyNotification);
	
	var _Surveys = __webpack_require__(56);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _errorInline = __webpack_require__(302);
	
	var _errorInline2 = _interopRequireDefault(_errorInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable jsx-a11y/anchor-is-valid */
	
	
	// Leaderboard table styles are intentionally kept exported on Styled
	// for re-use once Top/Bottom Performers rows are wired to real data.
	var Engagement = _dashboard2.default.Engagement,
	    Performance = _dashboard2.default.Performance,
	    TeamDynamics = _dashboard2.default.TeamDynamics;
	
	
	var TEAM_GRADING_API = ("https://be-production-itb.marketgames.io/api/") + "app/team-grading/";
	var SURVEY_DATA_API = ("https://be-production-itb.marketgames.io/api/") + "app/survey-data/";
	var BULK_SCORING_API = ("https://be-production-itb.marketgames.io/api/") + "v2/forms/surveys/%SURVEY_ID%/bulk-submission-scoring/";
	var CALC_SURVEY_SCORE_API = ("https://be-production-itb.marketgames.io/api/") + "v2/forms/surveys/%SURVEY_ID%/calc-score/";
	
	var doNothing = function doNothing(e) {
	  if (e) {
	    e.preventDefault();
	  }
	};
	
	var MODAL_TYPE_WORKED_VERY_WELL = 1;
	var MODAL_TYPE_WORKED_WELL = 2;
	var MODAL_TYPE_DID_NOT_WORK_WELL = 3;
	
	// Student Spotlight → Most Valuable panel: label shown next to each
	// student's name (also drives the Skills Badge popup's category pill).
	// Keyed by the `category` field on the merged mostValuablePlayers rows,
	// which is set by fetchMostLeastValuable when it unions the three BE
	// cohorts (most_valuable / well_rounded / market_masters).
	var MVP_LINK_LABEL = {
	  most_valuable: 'Most Valuable',
	  well_rounded: 'Well Rounded',
	  market_masters: 'Market Master'
	};
	var MVP_BADGE_LABEL = {
	  most_valuable: 'Most Valuable Teammate',
	  well_rounded: 'Well Rounded Teammate',
	  market_masters: 'Market Master'
	};
	
	// Review Badge Recipients popup: per-category display config.
	// - accent: 4px top bar + icon fill
	// - podium: rank-1/2/3 fills for the rank circle (dark to light);
	//   ranks 4+ fall through to the neutral gray in the row itself.
	var BADGE_CATEGORY_ORDER = ['most_valuable', 'market_masters', 'well_rounded'];
	var BADGE_CATEGORY_META = {
	  most_valuable: {
	    label: 'Most Valuable',
	    accent: '#D18A2E',
	    podium: ['#8B5A2B', '#D6A059', '#E9C08A']
	  },
	  market_masters: {
	    label: 'Market Master',
	    accent: '#3AA7AC',
	    podium: ['#276C6F', '#4EBCC1', '#A3DCDF']
	  },
	  well_rounded: {
	    label: 'Well Rounded',
	    accent: '#6E5AA6',
	    podium: ['#4B3B7A', '#7B62B0', '#B49FD3']
	  }
	};
	
	// Simple ribbon medal glyph used inside the round column icon. Kept
	// as a constant so the JSX below doesn't repeat the path each time.
	var BADGE_MEDAL_SVG = _react2.default.createElement(
	  "svg",
	  { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
	  _react2.default.createElement("circle", { cx: "12", cy: "10", r: "5" }),
	  _react2.default.createElement("path", { d: "M8.21 13.89L7 22l5-3 5 3-1.21-8.11" })
	);
	
	var DOWNLOAD_MAX_ATTEMPTS = 10;
	var DOWNLOAD_ATTEMPT_DELAY = 1000;
	var DOWNLOAD_ERROR = 'The system cannot process request. Try again later.';
	
	var teamDynamicsModalTitles = (_teamDynamicsModalTit = {}, _defineProperty(_teamDynamicsModalTit, MODAL_TYPE_WORKED_VERY_WELL, "Worked Very Well Together"), _defineProperty(_teamDynamicsModalTit, MODAL_TYPE_WORKED_WELL, "Worked Well Together"), _defineProperty(_teamDynamicsModalTit, MODAL_TYPE_DID_NOT_WORK_WELL, "Did Not Work Well Together"), _teamDynamicsModalTit);
	
	var teamDynamicsField = (_teamDynamicsField = {}, _defineProperty(_teamDynamicsField, MODAL_TYPE_WORKED_VERY_WELL, "team_worked_well_together"), _defineProperty(_teamDynamicsField, MODAL_TYPE_WORKED_WELL, "team_worked_together"), _defineProperty(_teamDynamicsField, MODAL_TYPE_DID_NOT_WORK_WELL, "team_did_not_worked_together"), _teamDynamicsField);
	
	// Static catalog of Performance Feedback list items shown in the
	// dashboard's "Performance Feedback" block. Each entry pairs an API
	// feedback `type` string (or array of types for pages that listen to
	// more than one) with:
	//   - displayName: friendly theme label shown in the list. Multiple
	//     entries may share the same displayName, in which case they are
	//     consolidated into one list row (union of teams, lowest id).
	//   - hoverMessage: long-form tooltip text shown on hover.
	//   - path: detail page the list row links to.
	//   - category: used to gate items by which round targets are active.
	//
	// displayName and hoverMessage may be functions of the round number
	// (used by Share Price, whose label changes from "Revenue Challenges"
	// in rounds 1-2 to "Profit Challenges" in round 3+).
	// Hover copy for each Critical Thinking Insights group. The
	// "These teams" prefix gets swapped to "X out of Y teams" at render
	// time, so author the rest of the sentence to read naturally after
	// that substitution.
	var PERF_STMF_MSG = "These teams analyzed each decision in depth but struggled in synthesizing, making pricing, promotion, and production decisions in silos instead of seeing how they collectively impact financial targets (e.g. revenues, gross margins).";
	var PERF_MDID_MSG = "These teams decided on instinct rather than evidence. The market data was available (e.g customer preferences, willingness to pay), but they didn't read or leverage it to drive their decision making.";
	var PERF_RIPOR_MSG = "These teams generated revenue but couldn't turn it into profit, falling short on ROE, ROA, or EPS targets.";
	
	var PERF_FEEDBACK_ITEMS = [
	// 1) Seeing the Trees, Missing the Forest (revenue + gross-margin
	//    failures rolled into one theme, plus the "low inventory"
	//    page which is also a symptom of siloed planning between
	//    production and revenue expectations).
	{ type: "Expected revenue low", category: "revenues", displayName: "Seeing the Trees, Missing the Forest", hoverMessage: PERF_STMF_MSG, path: "/instructor/performance-feedback/revenues/products-selling-price" }, { type: "Expected revenue low", category: "revenues", displayName: "Seeing the Trees, Missing the Forest", hoverMessage: PERF_STMF_MSG, path: "/instructor/performance-feedback/revenues/customers-willingness-to-pay" }, { type: "Gross margin fail", category: "grossMargins", displayName: "Seeing the Trees, Missing the Forest", hoverMessage: PERF_STMF_MSG, path: "/instructor/performance-feedback/gross-margins/selling-price-too-low" }, { type: "Negative gross margins", category: "grossMargins", displayName: "Seeing the Trees, Missing the Forest", hoverMessage: PERF_STMF_MSG, path: "/instructor/performance-feedback/gross-margins/running-non-profit" }, { type: "Low inventory", category: "marketShare", displayName: "Seeing the Trees, Missing the Forest", hoverMessage: PERF_STMF_MSG, path: "/instructor/performance-feedback/market-share/insufficient-capacity" },
	
	// 2) Making Decisions in the Dark (was "Customer Preferences
	//    Overlooked").
	{ type: "Price range failed", category: "marketShare", displayName: "Making Decisions in the Dark", hoverMessage: PERF_MDID_MSG, path: "/instructor/performance-feedback/market-share/outside-price-range" }, { type: "Minimum requirement failed", category: "marketShare", displayName: "Making Decisions in the Dark", hoverMessage: PERF_MDID_MSG, path: "/instructor/performance-feedback/market-share/product-customer-wanted" },
	
	// 3) Low Awareness (unchanged).
	{ type: "Awareness", category: "marketShare", displayName: "Low Awareness", hoverMessage: "These teams are underinvesting in the channels their target customers actually use.", path: "/instructor/performance-feedback/market-share/product-promotion" },
	
	// 4) Product Market Fit Challenges (unchanged).
	{ type: "Product market fit", category: "marketShare", displayName: "Product Market Fit Challenges", hoverMessage: "These teams have a marketing mix that meet low demands.", path: "/instructor/performance-feedback/market-share/product-met-interest" },
	
	// "Decision Submission Failed" used to live here (types "Did not
	// submit" and "Insufficient capital" under category "submission")
	// but was removed because the Decision Submission Status KPI at
	// the top of the dashboard already surfaces the same information
	// with a direct link to the detail page. Keeping it on the Critical
	// Thinking list duplicated the signal.
	
	// 5) Revenue In, Profit Out of Reach (was "Profit Shortfalls").
	//    Shared "profitTrio" category gates the entire theme — it
	//    only appears when ANY of roe / roa / earnings_per_share is
	//    a target for the round.
	{ type: "Negative profits", category: "profitTrio", displayName: "Revenue In, Profit Out of Reach", hoverMessage: PERF_RIPOR_MSG, path: "/instructor/performance-feedback/net-loss" }, { type: "Roe fail", category: "profitTrio", displayName: "Revenue In, Profit Out of Reach", hoverMessage: PERF_RIPOR_MSG, path: "/instructor/performance-feedback/roe/enough-profits" }, { type: "Roa fail", category: "profitTrio", displayName: "Revenue In, Profit Out of Reach", hoverMessage: PERF_RIPOR_MSG, path: "/instructor/performance-feedback/roa/enough-profits" }, { type: "EPS fail", category: "profitTrio", displayName: "Revenue In, Profit Out of Reach", hoverMessage: PERF_RIPOR_MSG, path: "/instructor/performance-feedback/eps/enough-profits" }];
	
	// Fixed display order for the Critical Thinking Insights list.
	// Replaces the prior team-count-desc / feedback-id-asc sort.
	var PERF_FEEDBACK_DISPLAY_ORDER = ["Seeing the Trees, Missing the Forest", "Making Decisions in the Dark", "Low Awareness", "Product Market Fit Challenges", "Revenue In, Profit Out of Reach"];
	
	// Per-group path override: when a group has multiple member pages,
	// we want the row link to prefer the first path in this list that
	// has data (teams > 0), falling back through the list in order. If
	// none of the listed paths have data, the row uses the catalog's
	// default path (first entry whose feedback row had teams).
	var PERF_FEEDBACK_PATH_PRIORITY = {
	  "Making Decisions in the Dark": ["/instructor/performance-feedback/market-share/product-customer-wanted", "/instructor/performance-feedback/market-share/outside-price-range"]
	};
	
	// eslint-disable-next-line no-unused-vars
	var CSVDownload = (0, _styledComponents2.default)(_reactCsv.CSVLink)(_templateObject);
	
	// Badges consent tour styling. Backdrop dims everything below the
	// TopBar so logout stays clickable; popup card renders on top with
	// the consent message + MVP block + Approve/Decline actions.
	/* Tour backdrop dims the whole page (below topbar) and blocks
	   clicks — except the Student Spotlight card, which is lifted
	   above the backdrop via a z-index bump so the instructor can
	   click Skills Certificate links there. */
	var BadgesTourBackdrop = _styledComponents2.default.div(_templateObject2);
	
	/* Fixed centered card so the Student Spotlight column behind it
	   can stay dimmed with the rest of the page (the earlier design
	   lifted the card above the backdrop and anchored the popup to it;
	   the review-and-approve redesign drops that lift). Body scrolls;
	   footer with action buttons stays pinned. */
	var BadgesTourPopup = _styledComponents2.default.div(_templateObject3);
	
	/* Review-and-approve checklist popup. Opens on top of the tour
	   popup (higher z-index) with its own dimmer between the two. Sized
	   ~2.5x the tour popup so the checklist has room to breathe, but
	   capped to the viewport so smaller laptop screens don't overflow. */
	var BadgesReviewBackdrop = _styledComponents2.default.div(_templateObject4);
	
	var BadgesReviewPopup = _styledComponents2.default.div(_templateObject5);
	
	var BadgesReviewHeader = _styledComponents2.default.div(_templateObject6);
	
	var BadgesReviewHeaderLeft = _styledComponents2.default.div(_templateObject7);
	
	var BadgesReviewEyebrow = _styledComponents2.default.div(_templateObject8);
	
	var BadgesReviewTitle = _styledComponents2.default.h2(_templateObject9);
	
	var BadgesReviewSubtitle = _styledComponents2.default.div(_templateObject10);
	
	var BadgesReviewStats = _styledComponents2.default.div(_templateObject11);
	
	var BadgesReviewStatCard = _styledComponents2.default.div(_templateObject12);
	
	var BadgesReviewStatValue = _styledComponents2.default.div(_templateObject13);
	
	var BadgesReviewStatLabel = _styledComponents2.default.div(_templateObject14);
	
	var BadgesReviewBody = _styledComponents2.default.div(_templateObject15);
	
	var BadgesReviewColumns = _styledComponents2.default.div(_templateObject16);
	
	// Single per-category column. Top border is a 4px accent bar in the
	// category color; the rest of the card is standard. Body has its
	// own scroll so the popup only scrolls when the whole card is
	// taller than the viewport.
	var BadgesReviewColumn = _styledComponents2.default.div(_templateObject17);
	
	var BadgesReviewColumnAccent = _styledComponents2.default.div(_templateObject18, function (p) {
	  return p.color || '#E1E6EE';
	});
	
	var BadgesReviewColumnHeader = _styledComponents2.default.div(_templateObject19);
	
	var BadgesReviewColumnHeaderTop = _styledComponents2.default.div(_templateObject20);
	
	var BadgesReviewColumnIcon = _styledComponents2.default.div(_templateObject21, function (p) {
	  return p.color || '#E1E6EE';
	});
	
	var BadgesReviewColumnTitle = _styledComponents2.default.div(_templateObject22);
	
	var BadgesReviewColumnTopPct = _styledComponents2.default.span(_templateObject23);
	
	var BadgesReviewColumnClearAll = _styledComponents2.default.button(_templateObject24);
	
	var BadgesReviewColumnSubtitle = _styledComponents2.default.div(_templateObject25);
	
	var BadgesReviewColumnTableHeader = _styledComponents2.default.div(_templateObject26);
	
	var BadgesReviewColumnScroll = _styledComponents2.default.div(_templateObject27);
	
	var BadgesReviewNewRow = _styledComponents2.default.label(_templateObject28);
	
	var BadgesReviewRowLeft = _styledComponents2.default.div(_templateObject20);
	
	var BadgesReviewCheckbox = _styledComponents2.default.input.attrs({ type: 'checkbox' })(_templateObject29);
	
	var BadgesReviewRankCircle = _styledComponents2.default.div(_templateObject30, function (p) {
	  return p.color || '#DDE1E8';
	}, function (p) {
	  return p.textColor || 'rgba(0, 27, 59, 0.7)';
	});
	
	var BadgesReviewName = _styledComponents2.default.a(_templateObject31);
	
	var BadgesReviewColumnEmpty = _styledComponents2.default.div(_templateObject32);
	
	var BadgesReviewFooter = _styledComponents2.default.div(_templateObject33);
	
	var BadgesReviewFooterLeft = _styledComponents2.default.div(_templateObject34);
	
	var BadgesReviewCount = _styledComponents2.default.div(_templateObject35);
	
	var BadgesReviewFooterNote = _styledComponents2.default.div(_templateObject36);
	
	var BadgesReviewActions = _styledComponents2.default.div(_templateObject37);
	
	var BadgesReviewBackButton = _styledComponents2.default.button(_templateObject38);
	
	var BadgesReviewConfirmButton = _styledComponents2.default.button(_templateObject39);
	
	var BadgesTourHeader = _styledComponents2.default.div(_templateObject40);
	
	var BadgesTourBody = _styledComponents2.default.div(_templateObject41);
	
	var BadgesTourFooter = _styledComponents2.default.div(_templateObject42);
	
	var BadgesTourClose = _styledComponents2.default.button(_templateObject43);
	
	var BadgesTourTitle = _styledComponents2.default.h2(_templateObject44);
	
	var BadgesTourConsentText = _styledComponents2.default.div(_templateObject45);
	
	/* Visually differentiates the sample-email portion of the consent
	   message (starts at "Subject:") from the note written for the
	   instructor above it. Light grey block with subtle border. */
	var BadgesTourEmailBlock = _styledComponents2.default.div(_templateObject46);
	
	/* "View the email message" — inline link inside the instructor
	   note. Click opens the email preview modal. */
	var BadgesTourInlineLink = _styledComponents2.default.a(_templateObject47);
	
	/* Email preview modal — nested on top of the tour overlay, shows
	   the sample email body verbatim. */
	var BadgesEmailPreviewBackdrop = _styledComponents2.default.div(_templateObject48);
	
	var BadgesEmailPreviewCard = _styledComponents2.default.div(_templateObject49);
	
	var BadgesEmailPreviewHeader = _styledComponents2.default.div(_templateObject50);
	
	var BadgesEmailPreviewTitle = _styledComponents2.default.h2(_templateObject51);
	
	var BadgesEmailPreviewCloseButton = _styledComponents2.default.button(_templateObject52);
	
	var BadgesEmailPreviewBody = _styledComponents2.default.div(_templateObject53);
	
	var BadgesTourMvpSection = _styledComponents2.default.div(_templateObject54);
	
	var BadgesTourMvpHeader = _styledComponents2.default.h3(_templateObject55);
	
	var BadgesTourMvpRow = _styledComponents2.default.div(_templateObject56);
	
	var BadgesTourMvpRank = _styledComponents2.default.span(_templateObject57);
	
	var BadgesTourCertificateLink = _styledComponents2.default.a(_templateObject58);
	
	var BadgesTourActions = _styledComponents2.default.div(_templateObject59);
	
	var BadgesTourDeclineButton = _styledComponents2.default.button(_templateObject38);
	
	var BadgesTourApproveButton = _styledComponents2.default.button(_templateObject60);
	
	var BadgesTourError = _styledComponents2.default.div(_templateObject61);
	
	var BadgesTourLoader = _styledComponents2.default.div(_templateObject62);
	
	var BadgesTourNotSureButton = _styledComponents2.default.button(_templateObject63);
	
	/* Intro popup — auto-appears when badge gates pass. Only exit is
	   the Continue button (opens tour) or logging out via the topbar. */
	
	var BadgesIntroBackdrop = _styledComponents2.default.div(_templateObject64);
	
	var BadgesIntroCard = _styledComponents2.default.div(_templateObject65);
	
	var BadgesIntroTitle = _styledComponents2.default.h2(_templateObject66);
	
	var BadgesIntroBody = _styledComponents2.default.p(_templateObject67);
	
	var BadgesIntroContinueButton = _styledComponents2.default.button(_templateObject68);
	
	/* Student Count KPI subtext + popup. Small link under the big
	   student count renders "N students not registered yet" when count
	   > 0. Clicking opens the modal with the list + copy-all. */
	var NotRegisteredLink = _styledComponents2.default.button(_templateObject69);
	
	var NotRegisteredBackdrop = _styledComponents2.default.div(_templateObject64);
	
	var NotRegisteredCard = _styledComponents2.default.div(_templateObject70);
	
	var NotRegisteredHeader = _styledComponents2.default.div(_templateObject71);
	
	var NotRegisteredHeaderText = _styledComponents2.default.div(_templateObject7);
	
	var NotRegisteredTitle = _styledComponents2.default.h2(_templateObject72);
	
	var NotRegisteredSubtitle = _styledComponents2.default.div(_templateObject73);
	
	var NotRegisteredClose = _styledComponents2.default.button(_templateObject74);
	
	var NotRegisteredActions = _styledComponents2.default.div(_templateObject75);
	
	var NotRegisteredCopyButton = _styledComponents2.default.button(_templateObject76);
	
	var NotRegisteredCopiedBadge = _styledComponents2.default.span(_templateObject77);
	
	var NotRegisteredList = _styledComponents2.default.div(_templateObject27);
	
	var NotRegisteredRow = _styledComponents2.default.div(_templateObject78);
	
	var NotRegisteredName = _styledComponents2.default.span(_templateObject79);
	
	var NotRegisteredEmail = _styledComponents2.default.span(_templateObject80);
	
	var NotRegisteredEmpty = _styledComponents2.default.div(_templateObject81);
	
	// ----- Decision Submission Status popup styled components -----
	// Replaces the earlier single-column list layout with a 2-column
	// grid of team cards wrapped in a header/banner/filter/footer frame.
	
	var SubStatusCard = _styledComponents2.default.div(_templateObject82);
	
	var SubStatusHeader = _styledComponents2.default.div(_templateObject83);
	
	var SubStatusHeaderText = _styledComponents2.default.div(_templateObject7);
	
	var SubStatusEyebrow = _styledComponents2.default.div(_templateObject84);
	
	var SubStatusTitle = _styledComponents2.default.h2(_templateObject85);
	
	var SubStatusClose = _styledComponents2.default.button(_templateObject74);
	
	var SubStatusBanner = _styledComponents2.default.div(_templateObject86);
	
	var SubStatusBannerIcon = _styledComponents2.default.div(_templateObject87);
	
	var SubStatusBannerText = _styledComponents2.default.div(_templateObject7);
	
	var SubStatusBannerTitle = _styledComponents2.default.div(_templateObject22);
	
	var SubStatusBannerSubtitle = _styledComponents2.default.div(_templateObject88);
	
	var SubStatusFilterWrap = _styledComponents2.default.div(_templateObject89);
	
	var SubStatusFilterIcon = _styledComponents2.default.div(_templateObject90);
	
	var SubStatusFilterInput = _styledComponents2.default.input(_templateObject91);
	
	var SubStatusGrid = _styledComponents2.default.div(_templateObject92);
	
	var SubStatusTeamCard = _styledComponents2.default.div(_templateObject93);
	
	var SubStatusTeamBadge = _styledComponents2.default.div(_templateObject94);
	
	var SubStatusTeamName = _styledComponents2.default.div(_templateObject95);
	
	var SubStatusTeamPill = _styledComponents2.default.div(_templateObject96);
	
	var SubStatusTeamPillDot = _styledComponents2.default.span(_templateObject97);
	
	var SubStatusEmpty = _styledComponents2.default.div(_templateObject98);
	
	var SubStatusFooter = _styledComponents2.default.div(_templateObject99);
	
	var SubStatusShowing = _styledComponents2.default.div(_templateObject100);
	
	var SubStatusCloseButton = _styledComponents2.default.button(_templateObject101);
	
	/* "Share With Students" button — sits on the right side of the
	   Most Valuable Teammate header row. Active (clickable, green
	   underline) when the instructor hasn't confirmed; inactive
	   (grey, no click) after "Badges Sent". Font size / weight
	   match the SpotlightSubheader ("Most Valuable Teammate"). */
	
	var ShareWithStudentsButton = _styledComponents2.default.button(_templateObject102);
	
	var Dashboard = function (_PureComponent) {
	  _inherits(Dashboard, _PureComponent);
	
	  function Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.downloadPerformanceFile = function () {
	      var performanceDownloadFile = _this.state.performanceDownloadFile;
	
	
	      (0, _ApiService.downloadRequest)(performanceDownloadFile, 'application/csv').then(function (res) {
	        return res.blob();
	      }).then(function (blob) {
	        var link = document.createElement('a');
	        link.href = URL.createObjectURL(blob);
	        link.download = "performance_" + _this.currentDate + ".csv";
	        link.click();
	      }).catch(function (err) {
	        console.error(err);
	        alert(DOWNLOAD_ERROR);
	      });
	    };
	
	    _this.downloadPerformanceData = function (e) {
	      var _this$state = _this.state,
	          performanceDownloadRequest = _this$state.performanceDownloadRequest,
	          currentRound = _this$state.currentRound,
	          performanceDownloadCount = _this$state.performanceDownloadCount,
	          performanceDownloadFile = _this$state.performanceDownloadFile,
	          rounds = _this$state.rounds,
	          currentGame = _this$state.currentGame,
	          currentSurvey = _this$state.currentSurvey;
	
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      var selectedRound = rounds.find(function (round) {
	        return round.id === currentRound;
	      });
	      if (!selectedRound.is_finished) {
	        _this.setState({
	          showError: true
	        });
	        return;
	      }
	
	      if (performanceDownloadFile) {
	        _this.downloadPerformanceFile();
	        return;
	      }
	
	      if (!performanceDownloadRequest) {
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/run/").send(Object.assign({
	          game: currentGame
	        }, currentSurvey && { survey: currentSurvey })).type('form').then(function (res) {
	          if (res.statusCode === 200 || res.statusCode === 201) {
	            (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/reports/performance-csv-add/").send(Object.assign({
	              round: currentRound
	            }, currentSurvey ? { survey: currentSurvey } : {})).type('form').then(function (res) {
	              var download_file = res.body.download_file;
	
	              var performanceDownloadRequest = download_file.substring(5);
	
	              _this.setState({
	                performanceDownloadRequest: performanceDownloadRequest,
	                performanceDownloadCount: 0,
	                performanceDownloadFile: null
	              });
	            }).catch(function (err) {
	              console.error(err);
	              alert(DOWNLOAD_ERROR);
	            });
	          }
	        }).catch(function (err) {
	          console.error(err);
	        });
	      } else {
	        if (performanceDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
	          alert(DOWNLOAD_ERROR);
	
	          _this.setState({
	            performanceDownloadCount: 0
	          });
	          return;
	        }
	
	        if (_this._pollingPerformance) return;
	        _this._pollingPerformance = true;
	
	        (0, _ApiService.getRequest)("" + ("https://be-production-itb.marketgames.io/api/") + performanceDownloadRequest).then(function (res) {
	          _this._pollingPerformance = false;
	          var _res$body = res.body,
	              status = _res$body.status,
	              download_link = _res$body.download_link;
	
	
	          _this.setState({
	            performanceDownloadCount: performanceDownloadCount + 1
	          });
	
	          if (status !== 'Completed') {
	            setTimeout(_this.downloadPerformanceData, DOWNLOAD_ATTEMPT_DELAY);
	          } else {
	            _this.setState({
	              performanceDownloadFile: download_link,
	              performanceDownloadCount: 0
	            }, function () {
	              _this.downloadPerformanceFile();
	            });
	          }
	        }).catch(function (err) {
	          console.error(err);
	          alert(DOWNLOAD_ERROR);
	        });
	      }
	    };
	
	    _this.downloadTeamDynamicsFile = function () {
	      var teamDynamicsDownloadFile = _this.state.teamDynamicsDownloadFile;
	
	
	      (0, _ApiService.downloadRequest)(teamDynamicsDownloadFile, 'application/csv').then(function (res) {
	        return res.blob();
	      }).then(function (blob) {
	        var link = document.createElement('a');
	        link.href = URL.createObjectURL(blob);
	        link.download = "team_dynamics_" + _this.currentDate + ".csv";
	        link.click();
	      }).catch(function (err) {
	        console.error(err);
	        alert(DOWNLOAD_ERROR);
	      });
	    };
	
	    _this.downloadTeamDynamicsData = function (e) {
	      var _this$state2 = _this.state,
	          teamDynamicsDownloadRequest = _this$state2.teamDynamicsDownloadRequest,
	          currentSurvey = _this$state2.currentSurvey,
	          teamDynamicsDownloadCount = _this$state2.teamDynamicsDownloadCount,
	          teamDynamicsDownloadFile = _this$state2.teamDynamicsDownloadFile;
	
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      if (teamDynamicsDownloadFile) {
	        _this.downloadTeamDynamicsFile();
	        return;
	      }
	
	      if (!teamDynamicsDownloadRequest) {
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/add-export-answers-to-csv-task/" + currentSurvey + "/").then(function (res) {
	          var download_file = res.body.download_file;
	
	          var teamDynamicsDownloadRequest = download_file.substring(5);
	
	          _this.setState({
	            teamDynamicsDownloadRequest: teamDynamicsDownloadRequest,
	            teamDynamicsDownloadCount: 0,
	            teamDynamicsDownloadFile: null
	          });
	        }).catch(function (err) {
	          console.error(err);
	          alert(DOWNLOAD_ERROR);
	        });
	      } else {
	        if (teamDynamicsDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
	          alert(DOWNLOAD_ERROR);
	
	          _this.setState({
	            teamDynamicsDownloadCount: 0
	          });
	          return;
	        }
	
	        if (_this._pollingTeamDynamics) return;
	        _this._pollingTeamDynamics = true;
	
	        (0, _ApiService.getRequest)("" + ("https://be-production-itb.marketgames.io/api/") + teamDynamicsDownloadRequest).then(function (res) {
	          _this._pollingTeamDynamics = false;
	          var _res$body2 = res.body,
	              status = _res$body2.status,
	              download_link = _res$body2.download_link;
	
	
	          _this.setState({
	            teamDynamicsDownloadCount: teamDynamicsDownloadCount + 1
	          });
	
	          if (status !== 'Completed') {
	            setTimeout(_this.downloadTeamDynamicsData, DOWNLOAD_ATTEMPT_DELAY);
	          } else {
	            _this.setState({
	              teamDynamicsDownloadFile: download_link,
	              teamDynamicsDownloadCount: 0
	            }, function () {
	              _this.downloadTeamDynamicsFile();
	            });
	          }
	        }).catch(function (err) {
	          console.error(err);
	          alert(DOWNLOAD_ERROR);
	        });
	      }
	    };
	
	    _this.downloadEngagementFile = function () {
	      var engagementDownloadFile = _this.state.engagementDownloadFile;
	
	
	      (0, _ApiService.downloadRequest)(engagementDownloadFile, 'application/csv').then(function (res) {
	        return res.blob();
	      }).then(function (blob) {
	        var link = document.createElement('a');
	        link.href = URL.createObjectURL(blob);
	        link.download = "engagement_" + _this.currentDate + ".csv";
	        link.click();
	      }).catch(function (err) {
	        console.error(err);
	        alert(DOWNLOAD_ERROR);
	      });
	    };
	
	    _this.downloadEngagementData = function (e) {
	      var _this$state3 = _this.state,
	          engagementDownloadRequest = _this$state3.engagementDownloadRequest,
	          currentRound = _this$state3.currentRound,
	          engagementDownloadCount = _this$state3.engagementDownloadCount,
	          engagementDownloadFile = _this$state3.engagementDownloadFile;
	
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      if (engagementDownloadFile) {
	        _this.downloadEngagementFile();
	        return;
	      }
	
	      if (!engagementDownloadRequest) {
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/engagement/add-export-user-scores-to-csv-task/" + currentRound + "/").then(function (res) {
	          var download_file = res.body.download_file;
	
	          var engagementDownloadRequest = download_file.substring(5);
	
	          _this.setState({
	            engagementDownloadRequest: engagementDownloadRequest,
	            engagementDownloadCount: 0
	          });
	        }).catch(function (err) {
	          console.error(err);
	          alert(DOWNLOAD_ERROR);
	        });
	      } else {
	        if (engagementDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
	          alert(DOWNLOAD_ERROR);
	
	          _this.setState({
	            engagementDownloadCount: 0
	          });
	          return;
	        }
	
	        if (_this._pollingEngagement) return;
	        _this._pollingEngagement = true;
	
	        (0, _ApiService.getRequest)("" + ("https://be-production-itb.marketgames.io/api/") + engagementDownloadRequest).then(function (res) {
	          _this._pollingEngagement = false;
	          var _res$body3 = res.body,
	              status = _res$body3.status,
	              download_link = _res$body3.download_link;
	
	
	          _this.setState({
	            engagementDownloadCount: engagementDownloadCount + 1
	          });
	
	          if (status !== 'Completed') {
	            setTimeout(_this.downloadEngagementData, DOWNLOAD_ATTEMPT_DELAY);
	          } else {
	            _this.setState({
	              engagementDownloadFile: download_link,
	              engagementDownloadCount: 0
	            }, function () {
	              _this.downloadEngagementFile();
	            });
	          }
	        }).catch(function (err) {
	          console.error(err);
	          alert(DOWNLOAD_ERROR);
	        });
	      }
	    };
	
	    _this.processUserScores = function () {
	      var currentSurvey = _this.state.currentSurvey;
	
	
	      if (currentSurvey > 0) {
	        (0, _ApiService.postRequest)(BULK_SCORING_API.replace("%SURVEY_ID%", currentSurvey)).then(function (res) {
	          console.log(res.body);
	        }).catch(function (err) {});
	        (0, _ApiService.postRequest)(CALC_SURVEY_SCORE_API.replace("%SURVEY_ID%", currentSurvey)).then(function (res) {
	          _this.fetchTeamScore();
	          _this.fetchUserScore();
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.showStudentStats = function () {
	      _this.setState({
	        showStudentStats: true,
	        studentStatsLoading: true
	      });
	    };
	
	    _this.hideStudentStats = function () {
	      _this.setState({
	        showStudentStats: false
	      });
	    };
	
	    _this.setStudentsStatsLoading = function (value) {
	      _this.setState({
	        studentStatsLoading: value
	      });
	    };
	
	    _this.selectCourse = function () {
	      var _this$state4 = _this.state,
	          courses = _this$state4.courses,
	          games = _this$state4.games,
	          currentGame = _this$state4.currentGame;
	
	      var game = games.find(function (i) {
	        return i.id === currentGame;
	      });
	
	      if (game) {
	        var currentCourse = game.course;
	
	        var course = courses.find(function (i) {
	          return i.id === currentCourse;
	        });
	
	        if (course) {
	          _this.setState({ currentCourse: course.id });
	        }
	      }
	    };
	
	    _this.showTeamDynamicsModal = function (type) {
	      return function (e) {
	        e.preventDefault();
	        var _this$state5 = _this.state,
	            teamScore = _this$state5.teamScore,
	            teams = _this$state5.teams;
	
	
	        _this.setState({
	          showTeamDynamicsModal: true,
	          teamDynamicsModalTitle: teamDynamicsModalTitles[type],
	          teamDynamicsTeamsList: teamScore ? teams.filter(function (team) {
	            return (0, _get3.default)(teamScore.collaboration, teamDynamicsField[type], []).includes(team.id);
	          }) : []
	        });
	      };
	    };
	
	    _this.hideTeamDynamicsModal = function () {
	      _this.setState({
	        showTeamDynamicsModal: false,
	        teamDynamicsModalTitle: "",
	        teamDynamicsTeamsList: [],
	        teamDynamicsCurrentTeam: 0,
	        teamDynamicsHideDropdowns: false,
	        players: null,
	        teamDynamicsCurrentPlayer: 0,
	        setPlayerValue: null,
	        reports: {},
	        userScoreReports: {}
	      });
	    };
	
	    _this.handleSpotlightFilterOutsideClick = function (e) {
	      if (!_this.state.spotlightTeamFilterOpen) return;
	      var el = _this._spotlightFilterRef;
	      if (el && e.target && !el.contains(e.target)) {
	        _this.setState({ spotlightTeamFilterOpen: false });
	      }
	    };
	
	    _this.setSpotlightFilterRef = function (el) {
	      _this._spotlightFilterRef = el;
	    };
	
	    _this.trimSpotlightName = function (first, last) {
	      var composed = ((first || '') + " " + (last || '')).trim();
	      if (!composed) return '';
	      var tokens = composed.split(/\s+/).filter(Boolean);
	      if (tokens.length >= 3) {
	        return tokens[0] + " " + tokens[tokens.length - 1];
	      }
	      return composed;
	    };
	
	    _this.spotlightTeamBadge = function (name) {
	      var str = String(name || '').trim();
	      if (!str) return '—';
	      // Show the full team name on the badge. Team codes in this app
	      // follow a <section><number> convention (e.g. "AA02", "FA06"), so
	      // showing the full code lets instructors tell AA02 and AA03 apart.
	      // Longer names get CSS-truncated inside the pill with the full
	      // value available via the PerformersCell's hover title.
	      return str.toUpperCase();
	    };
	
	    _this.sortSpotlightByTeam = function (list) {
	      var arr = Array.isArray(list) ? list.slice() : [];
	      arr.sort(function (a, b) {
	        var an = a && a.team_name || '';
	        var bn = b && b.team_name || '';
	        if (!an && bn) return 1;
	        if (an && !bn) return -1;
	        return an.localeCompare(bn, undefined, { numeric: true, sensitivity: 'base' });
	      });
	      return arr;
	    };
	
	    _this.filterSpotlightByTeam = function (list) {
	      var selected = _this.state.spotlightTeamFilter || [];
	      if (selected.length === 0) return list;
	      var set = new Set(selected);
	      return (list || []).filter(function (p) {
	        return set.has(p && p.team_name || '');
	      });
	    };
	
	    _this.spotlightTeamOptions = function () {
	      var mvps = _this.state.mostValuablePlayers || [];
	      var lvps = _this.state.leastValuablePlayers || [];
	      var names = new Set();
	      [].concat(_toConsumableArray(mvps), _toConsumableArray(lvps)).forEach(function (p) {
	        if (p && p.team_name) names.add(p.team_name);
	      });
	      return Array.from(names).sort(function (a, b) {
	        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
	      });
	    };
	
	    _this.toggleSpotlightTeamFilter = function (teamName) {
	      var current = _this.state.spotlightTeamFilter || [];
	      var set = new Set(current);
	      if (set.has(teamName)) set.delete(teamName);else set.add(teamName);
	      _this.setState({ spotlightTeamFilter: Array.from(set) });
	    };
	
	    _this.clearSpotlightTeamFilter = function () {
	      _this.setState({ spotlightTeamFilter: [] });
	    };
	
	    _this.toggleSpotlightTeamFilterDropdown = function () {
	      _this.setState(function (prev) {
	        return {
	          spotlightTeamFilterOpen: !prev.spotlightTeamFilterOpen
	        };
	      });
	    };
	
	    _this.renderSpotlightTeamFilter = function () {
	      // Only render when there's something to filter — hide the control
	      // in the empty / needs-generation states so the header stays clean.
	      var options = _this.spotlightTeamOptions();
	      if (options.length === 0) return null;
	
	      var selected = _this.state.spotlightTeamFilter || [];
	      var open = _this.state.spotlightTeamFilterOpen;
	      var selectedSet = new Set(selected);
	
	      var label = void 0;
	      if (selected.length === 0) label = 'Filter by team';else if (selected.length === 1) label = selected[0];else label = selected.length + " teams selected";
	
	      return _react2.default.createElement(
	        _dashboard2.default.SpotlightFilter.Wrap,
	        { innerRef: _this.setSpotlightFilterRef },
	        _react2.default.createElement(
	          _dashboard2.default.SpotlightFilter.Button,
	          {
	            type: "button",
	            hasSelection: selected.length > 0,
	            onClick: _this.toggleSpotlightTeamFilterDropdown
	          },
	          label,
	          _react2.default.createElement(_dashboard2.default.SpotlightFilter.Chevron, null)
	        ),
	        open && _react2.default.createElement(
	          _dashboard2.default.SpotlightFilter.Dropdown,
	          null,
	          options.map(function (name) {
	            return _react2.default.createElement(
	              _dashboard2.default.SpotlightFilter.Option,
	              { key: name },
	              _react2.default.createElement("input", {
	                type: "checkbox",
	                checked: selectedSet.has(name),
	                onChange: function onChange() {
	                  return _this.toggleSpotlightTeamFilter(name);
	                }
	              }),
	              name
	            );
	          }),
	          _react2.default.createElement(
	            _dashboard2.default.SpotlightFilter.Footer,
	            null,
	            _react2.default.createElement(
	              _dashboard2.default.SpotlightFilter.Clear,
	              {
	                type: "button",
	                disabled: selected.length === 0,
	                onClick: _this.clearSpotlightTeamFilter
	              },
	              "Clear"
	            )
	          )
	        )
	      );
	    };
	
	    _this.openCollabPopup = function () {
	      if (_this._collabCloseTimer) {
	        clearTimeout(_this._collabCloseTimer);
	        _this._collabCloseTimer = null;
	      }
	      if (!_this.state.collabPopupOpen) {
	        _this.setState({ collabPopupOpen: true });
	      }
	    };
	
	    _this.scheduleCollabPopupClose = function () {
	      if (_this._collabCloseTimer) clearTimeout(_this._collabCloseTimer);
	      _this._collabCloseTimer = setTimeout(function () {
	        _this._collabCloseTimer = null;
	        _this.setState({ collabPopupOpen: false });
	      }, 150);
	    };
	
	    _this.handleGlobalKeydown = function (e) {
	      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
	        e.preventDefault();
	        _this.openTeamLookup();
	      }
	    };
	
	    _this.fetchData = function () {
	      _this._hasFetched = true;
	      // Use data from general-info (passed via props) instead of separate API calls
	      var teams = _this.props.teams || [];
	      var courses = _this.props.courses || [];
	      var rounds = _this.props.rounds || [];
	      var games = _this.props.games || [];
	      var courseMembers = _this.props.courseMembers || [];
	
	      var ids = courses.map(function (i) {
	        return i.id;
	      });
	      var gamesFiltered = games.filter(function (i) {
	        return ids.includes(i.course);
	      });
	      // Student Count KPI: scope to the CURRENT course only, not sum
	      // across every course the instructor is tied to. Otherwise a
	      // multi-course instructor sees students from all their courses
	      // combined instead of the course they're actively viewing.
	      //
	      // Section-scoped instructors (covers_all_sections === false) get
	      // the section_student_count field instead of student_count, so the
	      // Class Roster card reflects just their section(s). Lead instructors
	      // (true) and legacy payloads (undefined) keep summing student_count.
	      //
	      // Fallback: when the course has NO sections at all (user.sections
	      // empty), use student_count regardless of covers_all_sections.
	      // Otherwise a misconfigured instructor flagged
	      // covers_all_sections=false on a sectionless course would read
	      // section_student_count (always 0) and the tile would blank out.
	      var currentCourseId = Number(_Auth2.default.getCourseId());
	      var scopedRows = courseMembers.filter(function (cm) {
	        return Number(cm.course_id != null ? cm.course_id : cm.course) === currentCourseId;
	      });
	      var authUserForRoster = _Auth2.default.getUser() || {};
	      var hasAnySections = Array.isArray(authUserForRoster.sections) && authUserForRoster.sections.length > 0;
	      var useSectionCount = hasAnySections && scopedRows.some(function (cm) {
	        return cm && cm.covers_all_sections === false;
	      });
	      var studentField = useSectionCount ? 'section_student_count' : 'student_count';
	      var countOfCourseMembers = scopedRows.reduce(function (sum, cm) {
	        return sum + (Number(cm[studentField]) || 0);
	      }, 0);
	
	      // Fetch remaining data: survey list. (static/all/ was previously
	      // batched here to feed constants into the now-removed
	      // PerformancePopup; nothing on the instructor dashboard reads it.)
	      (0, _ApiService.getRequest)(SURVEY_DATA_API).then(function (res) {
	        var surveys = null;
	        var finishedSurveys = [];
	        var surveysError = null;
	        if (res.statusCode !== 200) {
	          surveysError = res.body;
	        } else {
	          // /app/survey-data/ returns surveys across every course the
	          // instructor is tied to. Scope to the current course so the
	          // Initial/Final picker, Student Spotlight insights check, and
	          // default-survey rule don't mix surveys from foreign courses.
	          var rawSurveys = res.body.surveys || [];
	          var _currentCourseId = Number(_Auth2.default.getCourseId());
	          surveys = rawSurveys.filter(function (s) {
	            var c = s.course_id != null ? s.course_id : s.course;
	            return Number(c) === _currentCourseId;
	          });
	          if (surveys && surveys.length > 0) {
	            finishedSurveys = surveys.filter(function (i) {
	              return (0, _Surveys.isSurveyFinished)(i);
	            });
	          }
	        }
	
	        if (surveysError) {
	          console.error('SURVEYS API ERROR', surveysError);
	        }
	
	        _this.setState({
	          teams: teams,
	          courses: courses,
	          rounds: rounds,
	          surveys: finishedSurveys,
	          allSurveys: surveys,
	          surveysError: surveysError,
	          games: gamesFiltered,
	          countOfCourseMembers: countOfCourseMembers
	        }, function () {
	          var _this$state6 = _this.state,
	              games = _this$state6.games,
	              stateAllSurveys = _this$state6.allSurveys;
	
	
	          if (games && games.length > 0) {
	            // Prefer the game App.js already picked at login. It's
	            // the authoritative choice and it always arrives in the
	            // same setState as instructorGames/instructorCourses, so
	            // it is guaranteed to be present in `games` by the time
	            // this callback runs. Fall back to the shared
	            // pickCourseAndGame helper (highest-id course, then
	            // highest-id game within that course) if props.game
	            // isn't set for any reason, and finally to games[0].
	            var propGame = _this.props.game;
	            var propGameId = propGame && Number(propGame.id);
	            var propGameMatch = propGameId ? games.find(function (g) {
	              return Number(g.id) === propGameId;
	            }) : null;
	
	            var _pickCourseAndGame = (0, _AppGeneralInfoService.pickCourseAndGame)(courses, games),
	                pickedGame = _pickCourseAndGame.game;
	
	            var game = propGameMatch || pickedGame || games[0];
	
	            console.log('[MG:dashboard] game pick:', {
	              propsGameId: propGameId,
	              courses: courses.map(function (c) {
	                return c.id;
	              }),
	              gamesFiltered: games.map(function (g) {
	                return { id: g.id, course: g.course, name: g.name };
	              }),
	              pickedGame: pickedGame ? { id: pickedGame.id, course: pickedGame.course, name: pickedGame.name } : null,
	              propGameMatch: propGameMatch ? { id: propGameMatch.id, name: propGameMatch.name } : null,
	              chosen: game ? { id: game.id, name: game.name } : null,
	              stateRounds: (_this.state.rounds || []).map(function (r) {
	                return { id: r.id, number: r.number, game: r.game, is_finished: r.is_finished };
	              })
	            });
	
	            _this.selectGame(game.name);
	          }
	
	          // Fire-and-forget: count of unregistered course members
	          // for the Student Count tile subtext. Non-blocking so
	          // dashboard rendering isn't held up.
	          _this.fetchNotRegistered();
	
	          // Default survey selection on page load:
	          //   Both Initial + Final exist → Final if its end date has
	          //     passed (open+closed), otherwise Initial.
	          //   0 or 1 survey → earliest by start date (nothing to
	          //     toggle between).
	          // currentSurvey is shared state driving multiple sections
	          // (Top/Bottom Performers, Collaboration Insights, Team
	          // Scores, downloads); shifting the default here shifts
	          // all of them until the instructor picks the other survey.
	          var evalSurveys = _this.findEvalSurveys();
	          var defaultSurveyId = null;
	
	          if (evalSurveys.initial && evalSurveys.final) {
	            var finalClosed = _moment2.default.utc().isAfter((0, _moment2.default)(evalSurveys.final.end));
	            defaultSurveyId = finalClosed ? evalSurveys.final.id : evalSurveys.initial.id;
	          } else {
	            var sortedSurveys = (stateAllSurveys || []).slice().sort(function (a, b) {
	              var aTime = new Date(a.start || a.start_date || 0).getTime();
	              var bTime = new Date(b.start || b.start_date || 0).getTime();
	              return aTime - bTime;
	            });
	            if (sortedSurveys.length > 0) {
	              defaultSurveyId = sortedSurveys[0].id;
	            }
	          }
	
	          if (defaultSurveyId) {
	            _this.selectSurveyById(defaultSurveyId);
	          } else {
	            _this.fetchMostLeastValuable();
	            _this.fetchCollaborationSkills();
	          }
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.fetchPaginationData = function (url, loadingField, dataField, pageSize) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, loadingField, true), _defineProperty(_this$setState, dataField, []), _this$setState));
	
	      (0, _ApiService.getRequest)("" + url + (url.indexOf('?') > 0 ? '&' : '?') + "page_size=1").then(function (res) {
	        var count = res.body.count;
	
	
	        if (count > 0) {
	          var pages = Math.ceil(count / pageSize);
	          var requests = [];
	
	          for (var i = 1; i <= pages; i++) {
	            requests.push("" + url + (url.indexOf('?') > 0 ? '&' : '?') + "page_size=" + pageSize + "&page=" + i);
	          }
	
	          (0, _ApiService.batchRequest)(requests).then(function (res) {
	            try {
	              var _this$setState2;
	
	              var data = res.flatMap(function (payload) {
	                return payload.body.results;
	              });
	
	              _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, loadingField, false), _defineProperty(_this$setState2, dataField, data), _this$setState2));
	            } catch (e) {
	              console.log(e);
	            }
	          }).catch(function (err) {});
	        } else {
	          _this.setState(_defineProperty({}, loadingField, false));
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.fetchTeamScore = function () {
	      var currentSurvey = _this.state.currentSurvey;
	
	
	      if (currentSurvey > 0) {
	        var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	        var sq = _this.sectionsQueryParam();
	        (0, _ApiService.getRequest)(apiUrl + "v2/forms/surveys/" + currentSurvey + "/team-score/" + (sq ? "?" + sq : "")).then(function (res) {
	          var data = res.body || {};
	          _this.setState({
	            teamScore: data,
	            processResultsFailed: !data.collaboration
	          });
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.fetchUserScore = function () {
	      // No longer needed — user scores are fetched via fetchTeamScore using survey-data API
	    };
	
	    _this.checkPerformanceDownloadAbility = function () {
	      var _this$state7 = _this.state,
	          currentSurvey = _this$state7.currentSurvey,
	          currentRound = _this$state7.currentRound,
	          rounds = _this$state7.rounds;
	
	      var userId = _Auth2.default.getUserId();
	      var round = rounds.find(function (i) {
	        return i.id === currentRound;
	      });
	
	      if (round) {
	        (0, _ApiService.getRequest)("\n        " + ("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/" + currentSurvey + "/" + round.number + "/" + userId + "\n      ").then(function (res) {
	          if (res.body) {
	            _this.setState({
	              showPerformanceDowload: true
	            });
	          }
	        }).catch(function (err) {});
	      }
	    };
	
	    _this.selectGame = function (value) {
	      var games = _this.state.games;
	
	
	      if (games) {
	        var game = games.find(function (i) {
	          return i.name === value;
	        });
	        if (game) {
	          _this.setState({
	            currentGame: game.id,
	            currentRound: 0,
	            averageTeamGrade: 0,
	            medianTeamGrade: 0,
	            standardDeviation: 0
	          }, function () {
	            _this.selectCourse();
	            _this.updateCurrentRound();
	            // Decision Submission Status targets the live in-progress
	            // round, so it has to fire outside the selectRound path
	            // (which only runs for finished rounds).
	            _this.fetchPendingDecisions();
	          });
	        }
	      }
	    };
	
	    _this.selectRound = function (value) {
	      var rounds = _this.state.rounds;
	
	
	      if (rounds && value) {
	        var roundNumber = parseInt(value.replace("Round ", ""), 10);
	        if (isNaN(roundNumber)) {
	          roundNumber = 0;
	        }
	
	        if (roundNumber > 0) {
	          var round = rounds.find(function (i) {
	            return i.number === roundNumber;
	          });
	          if (round) {
	            _this.setState({
	              currentRound: round.id,
	              engagementDownloadRequest: null,
	              engagementDownloadCount: 0,
	              engagementDownloadFile: null,
	              performanceDownloadRequest: null,
	              performanceDownloadCount: 0,
	              performanceDownloadFile: null
	            }, function () {
	              _this.fetchPerformanceMetrics();
	              _this.fetchPerformanceFeedbacks();
	              _this.fetchPendingDecisions();
	            });
	          }
	        }
	      }
	    };
	
	    _this.fetchPerformanceFeedbacks = function () {
	      var _this$state8 = _this.state,
	          currentGame = _this$state8.currentGame,
	          currentRound = _this$state8.currentRound,
	          rounds = _this$state8.rounds;
	
	      // Target round: honor the sidebar's ?round=N first so the
	      // Critical Thinking Insights list reflects what the instructor
	      // has selected, not updateCurrentRound's latest-closed fallback.
	      // Fall back to state.currentRound when roundInUrl is missing or
	      // doesn't resolve to a round in the current game.
	
	      var roundInUrl = Number(_this.props.roundInUrl) || 0;
	      var urlRoundRecord = roundInUrl > 0 && Array.isArray(rounds) ? rounds.find(function (r) {
	        return r.number === roundInUrl && r.game === currentGame;
	      }) : null;
	      var targetRoundRecord = urlRoundRecord || (rounds || []).find(function (r) {
	        return r.id === currentRound;
	      });
	      var targetRoundNumber = targetRoundRecord ? Number(targetRoundRecord.number) : 0;
	
	      if (!currentGame || !targetRoundNumber) return;
	
	      // Mirror the Team Scores guard — performancefeedbacks for a
	      // live round reflects a mid-round snapshot that'll shift as
	      // decisions roll in, which misleads the Critical Thinking
	      // Insights ranking. Blank both arrays so the list renders empty
	      // and skip the requests entirely when the round hasn't closed.
	      if (!targetRoundRecord || targetRoundRecord.is_finished !== true) {
	        _this.setState({
	          performanceFeedbacksGame: [],
	          gamesTargets: []
	        });
	        return;
	      }
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      Promise.all([(0, _ApiService.getRequest)(apiUrl + "v2/reports/performancefeedbacks/game/" + currentGame + "/?round_number=" + targetRoundNumber), (0, _ApiService.getRequest)(apiUrl + "v2/games/targets/?round_number=" + targetRoundNumber + "&course=" + _Auth2.default.getCourseId())]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            feedbacksRes = _ref2[0],
	            targetsRes = _ref2[1];
	
	        _this.setState({
	          performanceFeedbacksGame: feedbacksRes && feedbacksRes.body || [],
	          gamesTargets: targetsRes && targetsRes.body || []
	        });
	      }).catch(function () {});
	    };
	
	    _this.fetchSpotlightInsightsCheck = function () {
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId) {
	        _this.setState({
	          studentSpotlightHasInsights: null,
	          studentSpotlightCheckLoading: false,
	          studentSpotlightGenerateMessage: null
	        });
	        return;
	      }
	      _this.setState({
	        studentSpotlightCheckLoading: true
	        // Don't clear the generate banner here; it's cleared explicitly
	        // on a successful survey switch via selectSurveyById.
	      });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/insights/survey/" + surveyId + "/students/?page=1&page_size=1" + (sq ? "&" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        var results = Array.isArray(body.results) ? body.results : [];
	        _this.setState({
	          studentSpotlightHasInsights: results.length > 0,
	          studentSpotlightCheckLoading: false
	        });
	      }).catch(function () {
	        _this.setState({
	          studentSpotlightHasInsights: false,
	          studentSpotlightCheckLoading: false
	        });
	      });
	    };
	
	    _this.fetchInstructorBadgeState = function () {
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId || !_this.isFinalStageSurvey()) {
	        _this.setState({ myInstructorBadgeState: null });
	        return;
	      }
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/badges/survey/" + surveyId + "/status/" + (sq ? "?" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        _this.setState({
	          myInstructorBadgeState: body.my_instructor_state || null
	        });
	      }).catch(function () {
	        // Endpoint 404s / errors → treat as "unknown". Intro popup
	        // stays hidden rather than showing a broken affordance.
	        _this.setState({ myInstructorBadgeState: null });
	      });
	    };
	
	    _this.isFinalStageSurvey = function () {
	      var surveys = _this.state.allSurveys || [];
	      var cur = surveys.find(function (s) {
	        return s.id === _this.state.currentSurvey;
	      });
	      if (!cur) return false;
	      var stage = String(cur.stage_name || cur.stage || "").toLowerCase();
	      return stage === "final" || stage === "second";
	    };
	
	    _this.openBadgesTour = function () {
	      var surveyId = _this.state.currentSurvey;
	      var courseId = Number(_Auth2.default.getCourseId());
	      if (!surveyId || !courseId) return;
	      // Guard against re-entrancy if the user double-clicks the button
	      // while the first fetch is still in flight.
	      if (_this.state.badgesConsentLoading) return;
	      // Fetch first, THEN open the popup — this avoids the ~1s
	      // "Loading consent message…" flash inside the popup. During the
	      // wait, the button shows its own loading state so the click still
	      // feels responsive.
	      _this.setState({ badgesConsentLoading: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var consentPromise = (0, _ApiService.getRequest)(apiUrl + "v2/insights/class/" + courseId + "/" + surveyId + "/" + (_this.sectionsQueryParam() ? "?" + _this.sectionsQueryParam() : "")).then(function (res) {
	        return res && res.body || {};
	      }).catch(function () {
	        return {};
	      });
	      var classWideCountPromise = _this.fetchClassWideBadgeRecipientCount(surveyId);
	
	      Promise.all([consentPromise, classWideCountPromise]).then(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            consentBody = _ref4[0],
	            classWideCount = _ref4[1];
	
	        _this.setState({
	          badgesConsentMessage: consentBody.badges_consent_message || null,
	          badgesStudentEmailPreview: consentBody.badges_student_email_preview || null,
	          classWideBadgeRecipientCount: classWideCount,
	          badgesConsentLoading: false,
	          badgesTourOpen: true
	        });
	      });
	    };
	
	    _this.fetchClassWideBadgeRecipientCount = function (surveyId) {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      return (0, _ApiService.getRequest)(apiUrl + "v2/games/most-least-valuable/" + surveyId + "/").then(function (res) {
	        var body = res && res.body || {};
	        var mostRaw = Array.isArray(body.most_valuable) ? body.most_valuable : [];
	        var wellRaw = Array.isArray(body.well_rounded) ? body.well_rounded : [];
	        var marketRaw = Array.isArray(body.market_masters) ? body.market_masters : [];
	        // Dedupe by user_id — a student can show up in more than one
	        // positive cohort but counts as one badge recipient.
	        var seen = new Set();
	        [].concat(_toConsumableArray(mostRaw), _toConsumableArray(wellRaw), _toConsumableArray(marketRaw)).forEach(function (entry) {
	          var uid = entry && (entry.user_id != null ? entry.user_id : entry.user);
	          if (uid != null) seen.add(Number(uid));
	        });
	        return seen.size;
	      }).catch(function () {
	        return 0;
	      });
	    };
	
	    _this.closeBadgesTour = function () {
	      if (_this.state.badgesBatchSubmitting) return;
	      _this.setState({
	        badgesTourOpen: false,
	        badgesConsentMessage: null,
	        badgesStudentEmailPreview: null,
	        badgesConsentLoading: false,
	        badgesEmailPreviewOpen: false,
	        classWideBadgeRecipientCount: null
	      });
	    };
	
	    _this.openBadgesEmailPreview = function () {
	      _this.setState({ badgesEmailPreviewOpen: true });
	    };
	
	    _this.closeBadgesEmailPreview = function () {
	      _this.setState({ badgesEmailPreviewOpen: false });
	    };
	
	    _this.openBadgesReview = function () {
	      if (_this.state.badgesBatchSubmitting) return;
	      var mvps = _this.state.mostValuablePlayers || [];
	      var seedIds = new Set(mvps.map(function (m) {
	        return m && m.user_id;
	      }).filter(function (id) {
	        return id != null;
	      }).map(function (id) {
	        return Number(id);
	      }));
	      _this.setState({
	        badgesReviewOpen: true,
	        badgesSelectedIds: seedIds,
	        badgesActionError: null
	      });
	    };
	
	    _this.closeBadgesReview = function () {
	      if (_this.state.badgesBatchSubmitting) return;
	      _this.setState({ badgesReviewOpen: false });
	    };
	
	    _this.toggleBadgeSelection = function (userId) {
	      var id = Number(userId);
	      if (Number.isNaN(id)) return;
	      var current = _this.state.badgesSelectedIds instanceof Set ? new Set(_this.state.badgesSelectedIds) : new Set();
	      if (current.has(id)) current.delete(id);else current.add(id);
	      _this.setState({ badgesSelectedIds: current });
	    };
	
	    _this.clearBadgeCategory = function (category) {
	      var mvps = _this.state.mostValuablePlayers || [];
	      var ids = mvps.filter(function (m) {
	        return m && m.category === category && m.user_id != null;
	      }).map(function (m) {
	        return Number(m.user_id);
	      });
	      if (ids.length === 0) return;
	      var current = _this.state.badgesSelectedIds instanceof Set ? new Set(_this.state.badgesSelectedIds) : new Set();
	      var anySelected = ids.some(function (id) {
	        return current.has(id);
	      });
	      if (anySelected) {
	        ids.forEach(function (id) {
	          return current.delete(id);
	        });
	      } else {
	        ids.forEach(function (id) {
	          return current.add(id);
	        });
	      }
	      _this.setState({ badgesSelectedIds: current });
	    };
	
	    _this.approveBadges = function () {
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId || _this.state.badgesBatchSubmitting) return;
	      var selected = _this.state.badgesSelectedIds instanceof Set ? Array.from(_this.state.badgesSelectedIds) : null;
	      _this.setState({ badgesBatchSubmitting: true, badgesActionError: null });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      // Omit user_ids entirely to badge every qualifying student (BE
	      // treats a missing field as "all"). Send the array as-is when the
	      // instructor has explicitly opened the review popup.
	      var payload = selected != null ? { user_ids: selected } : {};
	      (0, _ApiService.postRequest)(apiUrl + "v2/badges/batch-confirm/" + surveyId + "/").send(payload).then(function () {
	        _this.setState({
	          badgesBatchSubmitting: false,
	          badgesReviewOpen: false,
	          badgesTourOpen: false,
	          badgesConsentMessage: null,
	          badgesSelectedIds: null,
	          myInstructorBadgeState: "confirmed"
	        });
	      }).catch(function () {
	        _this.setState({
	          badgesBatchSubmitting: false,
	          badgesActionError: "Couldn't confirm badges. Please try again."
	        });
	      });
	    };
	
	    _this.declineBadges = function () {
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId || _this.state.badgesBatchSubmitting) return;
	      _this.setState({ badgesBatchSubmitting: true, badgesActionError: null });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.postRequest)(apiUrl + "v2/badges/batch-decline/" + surveyId + "/").send({}).then(function () {
	        _this.setState({
	          badgesBatchSubmitting: false,
	          badgesTourOpen: false,
	          badgesConsentMessage: null,
	          myInstructorBadgeState: "declined"
	        });
	      }).catch(function () {
	        _this.setState({
	          badgesBatchSubmitting: false,
	          badgesActionError: "Couldn't decline badges. Please try again."
	        });
	      });
	    };
	
	    _this.notSureYetBadges = function () {
	      if (_this.state.badgesBatchSubmitting) return;
	      _this.setState({
	        badgesTourOpen: false,
	        badgesConsentMessage: null,
	        badgesConsentLoading: false,
	        badgesIntroSuppressed: true
	      });
	    };
	
	    _this.continueBadgesFromIntro = function () {
	      _this.openBadgesTour();
	    };
	
	    _this.openGenerateConfirm = function () {
	      _this.setState({ studentSpotlightConfirmOpen: true });
	    };
	
	    _this.closeGenerateConfirm = function () {
	      _this.setState({ studentSpotlightConfirmOpen: false });
	    };
	
	    _this.confirmGenerateSpotlightInsights = function () {
	      _this.setState({ studentSpotlightConfirmOpen: false });
	      _this.generateSpotlightInsights();
	    };
	
	    _this.generateSpotlightInsights = function () {
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId || _this.state.studentSpotlightGenerating) return;
	      _this.setState({
	        studentSpotlightGenerating: true,
	        studentSpotlightGenerateMessage: "Insights are being generated, it typically takes up to 5 minutes."
	      });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      (0, _ApiService.postRequest)(apiUrl + "v2/insights/generate/" + surveyId + "/").send({}).then(function (res) {
	        var body = res && res.body || {};
	        var statusUrl = body.status_url;
	        if (!statusUrl) {
	          // BE didn't return the expected status_url shape — fall back
	          // to the old static-notice behavior so the instructor still
	          // knows something's in flight.
	          _this.setState({
	            studentSpotlightGenerating: false,
	            studentSpotlightGenerateMessage: "Insights are being generated. Please check back in a few minutes."
	          });
	          return;
	        }
	        _this._insightsPollStartTime = Date.now();
	        _this.setState({
	          insightsJobId: body.job_id || null,
	          insightsStatusUrl: statusUrl
	        });
	        // Kick off the first poll at 10s (matches roster-upload
	        // POLL_FIRST_DELAY_MS). Sub-90s completions typically land on
	        // the second or third poll.
	        _this._insightsPollTimeout = setTimeout(function () {
	          return _this.pollInsightsStatus(statusUrl);
	        }, 10000);
	      }).catch(function () {
	        _this._stopInsightsPoll();
	        _this.setState({
	          studentSpotlightGenerating: false,
	          studentSpotlightGenerateMessage: "Couldn't kick off insight generation. Please try again."
	        });
	      });
	    };
	
	    _this._INSIGHTS_POLL_FIRST_DELAY_MS = 10000;
	    _this._INSIGHTS_POLL_MID_DELAY_MS = 30000;
	    _this._INSIGHTS_POLL_LATE_DELAY_MS = 60000;
	    _this._INSIGHTS_POLL_MID_THRESHOLD_MS = 120000;
	    _this._INSIGHTS_POLL_LATE_THRESHOLD_MS = 240000;
	    _this._INSIGHTS_POLL_MAX_DURATION_MS = 360000;
	
	    _this._getInsightsPollDelay = function (elapsedMs) {
	      if (elapsedMs < _this._INSIGHTS_POLL_MID_THRESHOLD_MS) return _this._INSIGHTS_POLL_FIRST_DELAY_MS;
	      if (elapsedMs < _this._INSIGHTS_POLL_LATE_THRESHOLD_MS) return _this._INSIGHTS_POLL_MID_DELAY_MS;
	      return _this._INSIGHTS_POLL_LATE_DELAY_MS;
	    };
	
	    _this._stopInsightsPoll = function () {
	      if (_this._insightsPollTimeout) {
	        clearTimeout(_this._insightsPollTimeout);
	        _this._insightsPollTimeout = null;
	      }
	      _this._insightsPollStartTime = null;
	    };
	
	    _this._resolveStatusUrl = function (statusUrl) {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      if (statusUrl.startsWith('/api/')) {
	        return "" + apiUrl + statusUrl.slice(5);
	      }
	      return "" + apiUrl + statusUrl.replace(/^\//, '');
	    };
	
	    _this.pollInsightsStatus = function (statusUrl) {
	      var elapsedMs = _this._insightsPollStartTime ? Date.now() - _this._insightsPollStartTime : 0;
	
	      if (elapsedMs > _this._INSIGHTS_POLL_MAX_DURATION_MS) {
	        _this._stopInsightsPoll();
	        _this.setState({
	          studentSpotlightGenerating: false,
	          studentSpotlightGenerateMessage: "Still processing — please refresh the page in a moment to check again."
	        });
	        return;
	      }
	
	      (0, _ApiService.getRequest)(_this._resolveStatusUrl(statusUrl)).then(function (res) {
	        var body = res && res.body || {};
	        var status = body.status;
	
	        if (status === 'done') {
	          _this._stopInsightsPoll();
	          _this.setState({
	            studentSpotlightGenerating: false,
	            studentSpotlightGenerateMessage: null,
	            insightsJobId: null,
	            insightsStatusUrl: null
	          }, function () {
	            // Refresh the derived data so the Student Spotlight lists,
	            // collaboration bubbles, and existence flag all reflect the
	            // freshly-generated insights.
	            _this.fetchMostLeastValuable(true);
	            _this.fetchCollaborationSkills(true);
	            _this.fetchSpotlightInsightsCheck();
	            // Also pull the instructor's badge consent state so the
	            // Confirm Badges CTA can appear (final surveys only).
	            _this.fetchInstructorBadgeState();
	          });
	          return;
	        }
	
	        if (status === 'failed') {
	          _this._stopInsightsPoll();
	          _this.setState({
	            studentSpotlightGenerating: false,
	            studentSpotlightGenerateMessage: "Insight generation failed. Please try again."
	          });
	          return;
	        }
	
	        // Still processing — surface live progress in the notice.
	        var progress = body.progress_percent || {};
	        var studentsPct = Number(progress.students || 0);
	        var teamsPct = Number(progress.teams || 0);
	        _this.setState({
	          studentSpotlightGenerateMessage: "Insights are being generated, it typically takes up to 5 minutes. (Students " + studentsPct + "% \u2022 Teams " + teamsPct + "%)"
	        });
	
	        var nextDelay = _this._getInsightsPollDelay(elapsedMs);
	        _this._insightsPollTimeout = setTimeout(function () {
	          return _this.pollInsightsStatus(statusUrl);
	        }, nextDelay);
	      }).catch(function () {
	        // Transient status failure — try again at the next interval
	        // rather than giving up. Persistent failures eventually hit
	        // the max-duration cap above.
	        var nextDelay = _this._getInsightsPollDelay(elapsedMs);
	        _this._insightsPollTimeout = setTimeout(function () {
	          return _this.pollInsightsStatus(statusUrl);
	        }, nextDelay);
	      });
	    };
	
	    _this.fetchMostLeastValuable = function () {
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var _this$state9 = _this.state,
	          currentSurvey = _this$state9.currentSurvey,
	          allSurveys = _this$state9.allSurveys,
	          mostValuablePlayers = _this$state9.mostValuablePlayers,
	          leastValuablePlayers = _this$state9.leastValuablePlayers;
	      // Endpoint is keyed by survey id (despite the /games/ path prefix).
	      // Prefer the user-picked survey; if none is selected (e.g. no finished
	      // survey yet, so selectSurvey never ran), fall back to the first
	      // survey on the game so the block still populates.
	
	      var surveyId = currentSurvey || (Array.isArray(allSurveys) && allSurveys.length > 0 ? allSurveys[0].id : 0);
	      if (!surveyId) return;
	      if (!force && Array.isArray(mostValuablePlayers) && mostValuablePlayers.length > 0 && Array.isArray(leastValuablePlayers) && leastValuablePlayers.length > 0) {
	        return;
	      }
	
	      _this.setState({ mostLeastValuableLoading: true });
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/games/most-least-valuable/" + surveyId + "/" + (sq ? "?" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        // Three "positive" cohorts feed the Most Valuable panel. Each
	        // is merged into a single sorted+deduped list where each
	        // student appears once under whichever cohort awarded them
	        // the highest total_points (per product decision: student
	        // shouldn't appear twice in the panel).
	        var mostRaw = Array.isArray(body.most_valuable) ? body.most_valuable : [];
	        var wellRaw = Array.isArray(body.well_rounded) ? body.well_rounded : [];
	        var marketRaw = Array.isArray(body.market_masters) ? body.market_masters : [];
	        var leastRaw = Array.isArray(body.least_valuable) ? body.least_valuable : [];
	
	        var shape = function shape(entry, category) {
	          return {
	            user_id: entry && (entry.user_id != null ? entry.user_id : entry.user),
	            total_points: Number(entry && entry.total_points) || 0,
	            first_name: entry && entry.first_name || '',
	            last_name: entry && entry.last_name || '',
	            username: entry && entry.username || '',
	            team_id: entry && entry.team_id != null ? Number(entry.team_id) : null,
	            team_name: entry && entry.team_name || '',
	            category: category
	          };
	        };
	
	        // Union all three positive cohorts, then dedupe by user_id
	        // keeping the entry with the highest total_points (that's the
	        // cohort we'll label them under). Finally sort desc by points.
	        var merged = new Map();
	        [].concat(_toConsumableArray(mostRaw.map(function (e) {
	          return shape(e, 'most_valuable');
	        })), _toConsumableArray(wellRaw.map(function (e) {
	          return shape(e, 'well_rounded');
	        })), _toConsumableArray(marketRaw.map(function (e) {
	          return shape(e, 'market_masters');
	        }))).forEach(function (row) {
	          if (row.user_id == null) return;
	          var key = Number(row.user_id);
	          var prev = merged.get(key);
	          if (!prev || row.total_points > prev.total_points) {
	            merged.set(key, row);
	          }
	        });
	        var mostValuablePlayers = Array.from(merged.values()).sort(function (a, b) {
	          return b.total_points - a.total_points;
	        });
	
	        _this.setState({
	          mostValuablePlayers: mostValuablePlayers,
	          leastValuablePlayers: leastRaw.map(function (e) {
	            return shape(e, 'least_valuable');
	          }),
	          mostLeastValuableLoading: false
	        });
	      }).catch(function () {
	        _this.setState({ mostLeastValuableLoading: false });
	      });
	    };
	
	    _this.collabBubbleColors = {
	      strengths: { body: "#EAF3EC", outline: "#D1E9D6", text: "#2DA548" },
	      weaknesses: { body: "#FAEDED", outline: "#FBD8D8", text: "#EC5E59" }
	    };
	
	    _this.collabSkillDisplayName = function (raw) {
	      if (raw === "Effective Communication") return "Communication";
	      return raw;
	    };
	
	    _this.collabDonutColors = {
	      workedVeryWell: "#2DA548",
	      workedWell: "#EAF3EC",
	      didNotWork: "#FAEDED"
	    };
	
	    _this.getCollabBubbles = function () {
	      var tab = _this.state.collaborationSkillsTab === "weaknesses" ? "weaknesses" : "strengths";
	      var source = tab === "weaknesses" ? _this.state.collaborationWeaknesses || [] : _this.state.collaborationStrengths || [];
	      return source.slice(0, 4).map(function (s) {
	        return {
	          text: _this.collabSkillDisplayName(s.skill_name || s.skill || s.name || ""),
	          count: Number(s.total_student_count) || 0
	        };
	      }).sort(function (a, b) {
	        return b.count - a.count;
	      });
	    };
	
	    _this.renderBadgesTourBackdrop = function () {
	      if (!_this.state.badgesTourOpen) return null;
	      return _react2.default.createElement(BadgesTourBackdrop, null);
	    };
	
	    _this.renderBadgesTour = function () {
	      if (!_this.state.badgesTourOpen) return null;
	      var _this$state10 = _this.state,
	          badgesBatchSubmitting = _this$state10.badgesBatchSubmitting,
	          badgesActionError = _this$state10.badgesActionError;
	
	      // Class-wide numbers so a section-scoped instructor still sees
	      // the student's placement across the entire course. mvpCount is
	      // from the parallel class-wide fetch kicked off in openBadgesTour;
	      // studentCount is read directly from the current course's
	      // student_count field (not section_student_count).
	
	      var currentCourseId = Number(_Auth2.default.getCourseId());
	      var scopedCourseRows = (_this.props.courseMembers || []).filter(function (cm) {
	        return Number(cm.course_id != null ? cm.course_id : cm.course) === currentCourseId;
	      });
	      var studentCount = scopedCourseRows.reduce(function (sum, cm) {
	        return sum + (Number(cm.student_count) || 0);
	      }, 0);
	      var mvpCount = _this.state.classWideBadgeRecipientCount != null ? Number(_this.state.classWideBadgeRecipientCount) || 0 : 0;
	      var percent = studentCount > 0 ? (mvpCount / studentCount * 100).toFixed(1) : "0.0";
	
	      return _react2.default.createElement(
	        BadgesTourPopup,
	        { onClick: function onClick(e) {
	            return e.stopPropagation();
	          } },
	        _react2.default.createElement(
	          BadgesTourHeader,
	          null,
	          _react2.default.createElement(
	            BadgesTourTitle,
	            { style: { margin: 0 } },
	            "Review and Issue"
	          )
	        ),
	        _react2.default.createElement(
	          BadgesTourBody,
	          null,
	          _react2.default.createElement(
	            BadgesTourConsentText,
	            null,
	            mvpCount,
	            " of the ",
	            studentCount,
	            " students in the entire course earned a Career Readiness Badge for their work in the Market Games Challenge, placing them in the top ",
	            percent,
	            "% of the course."
	          ),
	          _react2.default.createElement(
	            BadgesTourConsentText,
	            { style: { marginBottom: 0 } },
	            "To issue the badges, please review the list of students, select those you'd like to receive one, and approve issuance. Once you approve, each selected student will get an email with their badge link, which they can add to LinkedIn, Handshake, or their resume.",
	            ' ',
	            _react2.default.createElement(
	              BadgesTourInlineLink,
	              {
	                href: "#",
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  _this.openBadgesEmailPreview();
	                }
	              },
	              "View the email message"
	            ),
	            "."
	          )
	        ),
	        _react2.default.createElement(
	          BadgesTourFooter,
	          null,
	          badgesActionError && _react2.default.createElement(
	            BadgesTourError,
	            { style: { marginRight: 'auto', marginBottom: 0 } },
	            badgesActionError
	          ),
	          _react2.default.createElement(
	            BadgesTourNotSureButton,
	            {
	              type: "button",
	              onClick: _this.notSureYetBadges,
	              disabled: badgesBatchSubmitting
	            },
	            "Not Sure Yet"
	          ),
	          _react2.default.createElement(
	            BadgesTourDeclineButton,
	            {
	              type: "button",
	              onClick: _this.declineBadges,
	              disabled: badgesBatchSubmitting
	            },
	            badgesBatchSubmitting ? "Working…" : "Decline"
	          ),
	          _react2.default.createElement(
	            BadgesTourApproveButton,
	            {
	              type: "button",
	              onClick: _this.openBadgesReview,
	              disabled: badgesBatchSubmitting || mvpCount === 0
	            },
	            "Review and Issue Badges"
	          )
	        )
	      );
	    };
	
	    _this.renderBadgesReview = function () {
	      if (!_this.state.badgesReviewOpen) return null;
	
	      var mvps = _this.state.mostValuablePlayers || [];
	      var selectedIds = _this.state.badgesSelectedIds instanceof Set ? _this.state.badgesSelectedIds : new Set();
	      var selectedCount = selectedIds.size;
	      var totalStudents = Number(_this.state.countOfCourseMembers) || 0;
	      var _this$state11 = _this.state,
	          badgesBatchSubmitting = _this$state11.badgesBatchSubmitting,
	          badgesActionError = _this$state11.badgesActionError;
	
	      // Filter mostValuablePlayers per category, preserving the
	      // total-points order from fetchMostLeastValuable so the rank
	      // column shown here matches the BE's ranking.
	
	      var byCategory = BADGE_CATEGORY_ORDER.reduce(function (acc, cat) {
	        acc[cat] = mvps.filter(function (m) {
	          return m && m.category === cat;
	        });
	        return acc;
	      }, {});
	
	      var earnedBadges = mvps.length;
	      var topPct = totalStudents > 0 ? (earnedBadges / totalStudents * 100).toFixed(1) : "0.0";
	
	      return [_react2.default.createElement(BadgesReviewBackdrop, { key: "review-backdrop" }), _react2.default.createElement(
	        BadgesReviewPopup,
	        { key: "review-popup", onClick: function onClick(e) {
	            return e.stopPropagation();
	          } },
	        _react2.default.createElement(
	          BadgesReviewHeader,
	          null,
	          _react2.default.createElement(
	            BadgesReviewHeaderLeft,
	            null,
	            _react2.default.createElement(
	              BadgesReviewEyebrow,
	              null,
	              "Career Readiness Badge"
	            ),
	            _react2.default.createElement(
	              BadgesReviewTitle,
	              null,
	              "Review Badge Recipients"
	            ),
	            _react2.default.createElement(
	              BadgesReviewSubtitle,
	              null,
	              "Uncheck any student who shouldn't receive a badge. Click a name to preview their badge. Approved students get their badge link by email."
	            )
	          ),
	          _react2.default.createElement(
	            BadgesReviewStats,
	            null,
	            _react2.default.createElement(
	              BadgesReviewStatCard,
	              null,
	              _react2.default.createElement(
	                BadgesReviewStatValue,
	                null,
	                earnedBadges
	              ),
	              _react2.default.createElement(
	                BadgesReviewStatLabel,
	                null,
	                "Earned badges"
	              )
	            ),
	            _react2.default.createElement(
	              BadgesReviewStatCard,
	              null,
	              _react2.default.createElement(
	                BadgesReviewStatValue,
	                null,
	                "Top ",
	                topPct,
	                "%"
	              ),
	              _react2.default.createElement(
	                BadgesReviewStatLabel,
	                null,
	                "of ",
	                totalStudents,
	                " students"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          BadgesReviewBody,
	          null,
	          mvps.length === 0 && _react2.default.createElement(
	            BadgesTourConsentText,
	            { style: { marginBottom: 0 } },
	            "No qualifying students to badge on this survey."
	          ),
	          mvps.length > 0 && _react2.default.createElement(
	            BadgesReviewColumns,
	            null,
	            BADGE_CATEGORY_ORDER.map(function (cat) {
	              var meta = BADGE_CATEGORY_META[cat];
	              var rows = byCategory[cat];
	              var rowCount = rows.length;
	              var selectedInCat = rows.reduce(function (n, r) {
	                return r.user_id != null && selectedIds.has(Number(r.user_id)) ? n + 1 : n;
	              }, 0);
	              var catTopPct = totalStudents > 0 && rowCount > 0 ? (rowCount / totalStudents * 100).toFixed(1) : null;
	              return _react2.default.createElement(
	                BadgesReviewColumn,
	                { key: "badge-col-" + cat },
	                _react2.default.createElement(BadgesReviewColumnAccent, { color: meta.accent }),
	                _react2.default.createElement(
	                  BadgesReviewColumnHeader,
	                  null,
	                  _react2.default.createElement(
	                    BadgesReviewColumnHeaderTop,
	                    null,
	                    _react2.default.createElement(
	                      BadgesReviewColumnIcon,
	                      { color: meta.accent },
	                      BADGE_MEDAL_SVG
	                    ),
	                    _react2.default.createElement(
	                      BadgesReviewColumnTitle,
	                      null,
	                      meta.label,
	                      catTopPct != null && _react2.default.createElement(
	                        BadgesReviewColumnTopPct,
	                        null,
	                        "Top ",
	                        catTopPct,
	                        "%"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      BadgesReviewColumnClearAll,
	                      {
	                        type: "button",
	                        onClick: function onClick() {
	                          return _this.clearBadgeCategory(cat);
	                        },
	                        disabled: badgesBatchSubmitting || rowCount === 0
	                      },
	                      "Clear all"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    BadgesReviewColumnSubtitle,
	                    null,
	                    selectedInCat,
	                    " of ",
	                    rowCount,
	                    " selected \xB7 ranked by points"
	                  )
	                ),
	                _react2.default.createElement(
	                  BadgesReviewColumnTableHeader,
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Rank"
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Team"
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Student"
	                  )
	                ),
	                _react2.default.createElement(
	                  BadgesReviewColumnScroll,
	                  null,
	                  rowCount === 0 && _react2.default.createElement(
	                    BadgesReviewColumnEmpty,
	                    null,
	                    "No students in this category."
	                  ),
	                  rows.map(function (mvp, idx) {
	                    var userId = mvp && mvp.user_id != null ? Number(mvp.user_id) : null;
	                    var composed = mvp ? ((mvp.first_name || '') + " " + (mvp.last_name || '')).trim() : '';
	                    var name = composed || mvp && mvp.username || null;
	                    var checked = userId != null && selectedIds.has(userId);
	                    var rank = idx + 1;
	                    var podiumColor = idx < meta.podium.length ? meta.podium[idx] : null;
	                    var circleColor = podiumColor || '#DDE1E8';
	                    var textColor = podiumColor ? '#ffffff' : 'rgba(0, 27, 59, 0.7)';
	                    return _react2.default.createElement(
	                      BadgesReviewNewRow,
	                      { key: "badge-row-" + cat + "-" + (userId || idx) },
	                      _react2.default.createElement(
	                        BadgesReviewRowLeft,
	                        null,
	                        _react2.default.createElement(BadgesReviewCheckbox, {
	                          checked: checked,
	                          onChange: function onChange() {
	                            if (userId != null) _this.toggleBadgeSelection(userId);
	                          },
	                          disabled: badgesBatchSubmitting || userId == null
	                        }),
	                        _react2.default.createElement(
	                          BadgesReviewRankCircle,
	                          { color: circleColor, textColor: textColor },
	                          rank
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _dashboard2.default.SpotlightTeamBadge,
	                        { title: mvp && mvp.team_name || '' },
	                        _this.spotlightTeamBadge(mvp && mvp.team_name)
	                      ),
	                      _react2.default.createElement(
	                        BadgesReviewName,
	                        {
	                          href: "#",
	                          onClick: function onClick(e) {
	                            e.preventDefault();
	                            if (userId != null) {
	                              _this.openCertificate(userId, cat, mvp);
	                            }
	                          }
	                        },
	                        name || "User " + (userId || rank)
	                      )
	                    );
	                  })
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          BadgesReviewFooter,
	          null,
	          _react2.default.createElement(
	            BadgesReviewFooterLeft,
	            null,
	            _react2.default.createElement(
	              BadgesReviewCount,
	              null,
	              selectedCount,
	              " of ",
	              mvps.length,
	              " selected"
	            ),
	            _react2.default.createElement(
	              BadgesReviewFooterNote,
	              null,
	              "Badges are emailed to each selected student as soon as you confirm.",
	              badgesActionError && _react2.default.createElement(
	                "span",
	                { style: { color: '#d34c4c', marginLeft: 8 } },
	                badgesActionError
	              )
	            )
	          ),
	          _react2.default.createElement(
	            BadgesReviewActions,
	            null,
	            _react2.default.createElement(
	              BadgesReviewBackButton,
	              {
	                type: "button",
	                onClick: _this.closeBadgesReview,
	                disabled: badgesBatchSubmitting
	              },
	              "Back"
	            ),
	            _react2.default.createElement(
	              BadgesReviewConfirmButton,
	              {
	                type: "button",
	                onClick: _this.approveBadges,
	                disabled: badgesBatchSubmitting || selectedCount === 0
	              },
	              _react2.default.createElement(
	                "svg",
	                { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
	                _react2.default.createElement("polyline", { points: "20 6 9 17 4 12" })
	              ),
	              badgesBatchSubmitting ? "Working…" : "Approve & email " + selectedCount + " badge" + (selectedCount === 1 ? '' : 's')
	            )
	          )
	        )
	      )];
	    };
	
	    _this.renderEmailWithLinks = function (text) {
	      var regex = /https?:\/\/[^\s]+/g;
	      var parts = [];
	      var lastIndex = 0;
	      var match = void 0;
	      var n = 0;
	      // eslint-disable-next-line no-cond-assign
	      while ((match = regex.exec(text)) !== null) {
	        if (match.index > lastIndex) {
	          parts.push(text.substring(lastIndex, match.index));
	        }
	        parts.push(_react2.default.createElement(
	          BadgesTourInlineLink,
	          {
	            key: "email-lnk-" + n,
	            href: match[0],
	            target: "_blank",
	            rel: "noopener noreferrer"
	          },
	          match[0]
	        ));
	        lastIndex = match.index + match[0].length;
	        n += 1;
	      }
	      if (lastIndex < text.length) {
	        parts.push(text.substring(lastIndex));
	      }
	      return parts;
	    };
	
	    _this.renderBadgesEmailPreview = function () {
	      if (!_this.state.badgesEmailPreviewOpen) return null;
	      var emailText = (_this.state.badgesStudentEmailPreview || "").trim();
	
	      // Apply the same student-name / URL substitutions the tour body
	      // uses, so the previewed email reflects the actual student data.
	      var firstMvp = (_this.state.mostValuablePlayers || [])[0];
	      if (firstMvp && firstMvp.user_id != null) {
	        var firstName = (firstMvp.first_name || '').trim() || null;
	        var initial = (firstMvp.first_name || '').charAt(0).toLowerCase();
	        var surname = (firstMvp.last_name || '').toLowerCase();
	        if (firstName) {
	          emailText = emailText.replace(/Hi Jordan,/g, "Hi " + firstName + ",");
	        }
	        if (initial && surname) {
	          emailText = emailText.replace(/badges\.marketgames\.io\/badge\/[a-zA-Z0-9-]+/g, "badges.marketgames.io/badge/" + initial + "-" + surname + "-" + firstMvp.user_id);
	        }
	      }
	
	      return _react2.default.createElement(
	        BadgesEmailPreviewBackdrop,
	        { onClick: _this.closeBadgesEmailPreview },
	        _react2.default.createElement(
	          BadgesEmailPreviewCard,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            BadgesEmailPreviewHeader,
	            null,
	            _react2.default.createElement(
	              BadgesEmailPreviewTitle,
	              null,
	              "Email preview"
	            ),
	            _react2.default.createElement(
	              BadgesEmailPreviewCloseButton,
	              {
	                type: "button",
	                onClick: _this.closeBadgesEmailPreview,
	                "aria-label": "Close"
	              },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            BadgesEmailPreviewBody,
	            null,
	            emailText ? _this.renderEmailWithLinks(emailText) : "Loading email preview…"
	          )
	        )
	      );
	    };
	
	    _this.renderShareWithStudentsButton = function () {
	      if (_this.state.studentSpotlightHasInsights !== true || !_this.isFinalStageSurvey()
	      // While the Review and Approve popup is open we already have
	      // the Approve / Decline / Not Sure Yet controls there — hide
	      // the header button so we don't render duplicate entry points.
	      || _this.state.badgesTourOpen || !_this.canIssueBadges()) {
	        return null;
	      }
	      var state = _this.state.myInstructorBadgeState;
	      if (state !== "pending" && state !== "confirmed") {
	        // null (not fetched), "declined", or anything else — don't
	        // render the affordance.
	        return null;
	      }
	      var isConfirmed = state === "confirmed";
	      // Loading state (isFetching) covers the ~1s window between the
	      // instructor clicking the button and the popup actually opening —
	      // the popup no longer opens until the consent-message fetch
	      // resolves, so we need to give the click somewhere visible to land.
	      var isFetching = _this.state.badgesConsentLoading;
	      var disabled = isConfirmed || isFetching;
	      var label = "Review and Issue Badges";
	      if (isConfirmed) label = "Badges Sent";else if (isFetching) label = "Loading…";
	      return _react2.default.createElement(
	        ShareWithStudentsButton,
	        {
	          type: "button",
	          onClick: disabled ? undefined : _this.openBadgesTour,
	          disabled: disabled,
	          title: isConfirmed ? "The badges were shared with students." : "Review and issue badges to share with students"
	        },
	        label
	      );
	    };
	
	    _this.canIssueBadges = function () {
	      var authUser = _Auth2.default.getUser() || {};
	      var cm = (_this.props.courseMembers || [])[0];
	      var position = authUser.position;
	      var isInsOrIns2 = position === "Instructor" || position === "Co-Instructor";
	      if (!isInsOrIns2) return false;
	      var hasSections = Array.isArray(authUser.sections) && authUser.sections.length > 0;
	      var coversAll = cm && cm.covers_all_sections === true;
	      return hasSections || coversAll;
	    };
	
	    _this.renderBadgesIntro = function () {
	      if (_this.state.studentSpotlightHasInsights !== true || !_this.isFinalStageSurvey() || _this.state.myInstructorBadgeState !== "pending" || _this.state.badgesIntroSuppressed || _this.state.badgesTourOpen || !_this.canIssueBadges()) {
	        return null;
	      }
	      return _react2.default.createElement(
	        BadgesIntroBackdrop,
	        null,
	        _react2.default.createElement(
	          BadgesIntroCard,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            BadgesIntroTitle,
	            null,
	            "Career ready insights are ready to review"
	          ),
	          _react2.default.createElement(
	            BadgesIntroContinueButton,
	            {
	              type: "button",
	              onClick: _this.state.badgesConsentLoading ? undefined : _this.continueBadgesFromIntro,
	              disabled: _this.state.badgesConsentLoading
	            },
	            _this.state.badgesConsentLoading ? "Loading…" : "Continue"
	          )
	        )
	      );
	    };
	
	    _this.renderTeamLookup = function () {
	      var _this$state12 = _this.state,
	          teamLookupOpen = _this$state12.teamLookupOpen,
	          teamLookupStep = _this$state12.teamLookupStep,
	          teamLookupQuery = _this$state12.teamLookupQuery,
	          teamLookupHighlightIdx = _this$state12.teamLookupHighlightIdx,
	          teamLookupSelectedTeam = _this$state12.teamLookupSelectedTeam,
	          teamLookupLoading = _this$state12.teamLookupLoading,
	          teamLookupError = _this$state12.teamLookupError;
	
	      if (!teamLookupOpen) return null;
	
	      var filtered = _this.getFilteredLookupRows();
	      var total = (_this.state.teamLookupRows || []).length;
	
	      var initials = function initials(name) {
	        var parts = String(name || "").trim().split(/\s+/);
	        if (parts.length === 0) return "?";
	        var first = parts[0] || "";
	        var last = parts.length > 1 ? parts[parts.length - 1] : "";
	        return ((first[0] || "") + (last[0] || "")).toUpperCase() || "T";
	      };
	
	      var isMac = typeof window !== "undefined" && /Mac|iPhone|iPad/.test(window.navigator.platform);
	      var cmdLabel = isMac ? "⌘" : "Ctrl";
	
	      return _react2.default.createElement(
	        _dashboard2.default.TeamLookup.Backdrop,
	        { onClick: _this.closeTeamLookup },
	        _react2.default.createElement(
	          _dashboard2.default.TeamLookup.Card2,
	          {
	            role: "dialog",
	            "aria-modal": "true",
	            "aria-label": "Team lookup dialog",
	            onClick: function onClick(e) {
	              return e.stopPropagation();
	            },
	            onKeyDown: _this.handleTeamLookupKeyDown,
	            tabIndex: -1
	          },
	          teamLookupStep === 1 && _react2.default.createElement(
	            "div",
	            { style: { display: "flex", flexDirection: "column", flex: 1, minHeight: 0 } },
	            _react2.default.createElement(
	              _dashboard2.default.TeamLookup.SearchRow,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.SearchIcon,
	                { "aria-hidden": true },
	                "\uD83D\uDD0D"
	              ),
	              _react2.default.createElement(_dashboard2.default.TeamLookup.SearchInput, {
	                // eslint-disable-next-line jsx-a11y/no-autofocus
	                autoFocus: true,
	                type: "text",
	                value: teamLookupQuery,
	                placeholder: "Search teams by name or number\u2026",
	                "aria-label": "Search teams",
	                "aria-controls": "team-lookup-listbox",
	                "aria-activedescendant": filtered[teamLookupHighlightIdx] ? "team-lookup-row-" + filtered[teamLookupHighlightIdx].id : undefined,
	                onChange: function onChange(e) {
	                  return _this.setTeamLookupQuery(e.target.value);
	                }
	              }),
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.CloseIcon,
	                {
	                  type: "button",
	                  "aria-label": "Close",
	                  onClick: _this.closeTeamLookup
	                },
	                "\xD7"
	              )
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.TeamLookup.List,
	              {
	                id: "team-lookup-listbox",
	                role: "listbox",
	                "aria-label": "Teams"
	              },
	              !teamLookupLoading && !teamLookupError && total > 0 && _react2.default.createElement(
	                _dashboard2.default.TeamLookup.SectionHeader,
	                null,
	                teamLookupQuery ? "Matches" : "All Teams",
	                " ",
	                "\xB7",
	                " ",
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.SectionHeaderCount,
	                  null,
	                  teamLookupQuery ? filtered.length : total
	                )
	              ),
	              teamLookupLoading && _react2.default.createElement(
	                _dashboard2.default.TeamLookup.Empty,
	                null,
	                "Loading teams\u2026"
	              ),
	              !teamLookupLoading && teamLookupError && _react2.default.createElement(
	                _dashboard2.default.TeamLookup.Empty,
	                null,
	                teamLookupError
	              ),
	              !teamLookupLoading && !teamLookupError && filtered.length === 0 && _react2.default.createElement(
	                _dashboard2.default.TeamLookup.Empty,
	                null,
	                "No teams match \"",
	                teamLookupQuery,
	                "\""
	              ),
	              !teamLookupLoading && !teamLookupError && filtered.map(function (team, idx) {
	                return _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.Row,
	                  {
	                    key: "team-lookup-row-" + team.id,
	                    id: "team-lookup-row-" + team.id,
	                    role: "option",
	                    "aria-selected": idx === teamLookupHighlightIdx,
	                    highlighted: idx === teamLookupHighlightIdx,
	                    onMouseEnter: function onMouseEnter() {
	                      return _this.setState({ teamLookupHighlightIdx: idx });
	                    },
	                    onClick: function onClick() {
	                      return _this.handleTeamLookupSelect(team);
	                    }
	                  },
	                  _react2.default.createElement(
	                    _dashboard2.default.TeamLookup.Avatar,
	                    null,
	                    initials(team.name)
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.TeamLookup.RowText,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.TeamLookup.RowName,
	                      null,
	                      team.name
	                    ),
	                    _react2.default.createElement(
	                      _dashboard2.default.TeamLookup.RowMeta,
	                      null,
	                      team.memberCount != null ? team.memberCount + " students" : "—",
	                      " · ",
	                      "Rank ",
	                      team.rank,
	                      " of ",
	                      total
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.TeamLookup.RowScore,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.TeamLookup.RowScoreValue,
	                      { value: team.score },
	                      team.score == null ? "—" : Math.round(team.score * 100)
	                    ),
	                    _react2.default.createElement(
	                      _dashboard2.default.TeamLookup.RowScoreLabel,
	                      null,
	                      "SCORE"
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.TeamLookup.Footer,
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.HintKey,
	                  null,
	                  "\u2191"
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.HintKey,
	                  null,
	                  "\u2193"
	                ),
	                "navigate \xA0",
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.HintKey,
	                  null,
	                  "Enter"
	                ),
	                "select \xA0",
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.HintKey,
	                  null,
	                  "Esc"
	                ),
	                "close"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                cmdLabel,
	                " K to reopen"
	              )
	            )
	          ),
	          teamLookupStep === 2 && teamLookupSelectedTeam && _react2.default.createElement(
	            "div",
	            { style: { display: "flex", flexDirection: "column", flex: 1, minHeight: 0 } },
	            _react2.default.createElement(
	              _dashboard2.default.TeamLookup.SelectedBanner,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.Avatar,
	                null,
	                initials(teamLookupSelectedTeam.name)
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.RowText,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.RowName,
	                  null,
	                  teamLookupSelectedTeam.name
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.RowMeta,
	                  null,
	                  teamLookupSelectedTeam.memberCount != null ? teamLookupSelectedTeam.memberCount + " students" : "—",
	                  " · ",
	                  "Rank ",
	                  teamLookupSelectedTeam.rank,
	                  " of ",
	                  total
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.ChangeTeamButton,
	                {
	                  type: "button",
	                  onClick: _this.handleTeamLookupBack
	                },
	                "Change team"
	              )
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.TeamLookup.ActionsGrid,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.ActionButton,
	                {
	                  type: "button",
	                  variant: "audit",
	                  onClick: _this.handleOpenAuditTrail
	                },
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.ActionTitle,
	                  null,
	                  "Audit Trail"
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.ActionBlurb,
	                  null,
	                  "Every decision, action, and timestamp from the team this game."
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.TeamLookup.ActionButton,
	                {
	                  type: "button",
	                  variant: "report",
	                  onClick: _this.handleOpenTeamReport
	                },
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.ActionTitle,
	                  null,
	                  "Team Report"
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.ActionBlurb,
	                  null,
	                  "Financial results and analysis of the team and their competitors."
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.TeamLookup.Footer,
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.HintKey,
	                  null,
	                  "Esc"
	                ),
	                "back to search"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Opens in a new tab"
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderInsights = function () {
	      var _this$state13 = _this.state,
	          insightsOpen = _this$state13.insightsOpen,
	          insightsStudentName = _this$state13.insightsStudentName,
	          insightsData = _this$state13.insightsData,
	          insightsLoading = _this$state13.insightsLoading,
	          insightsError = _this$state13.insightsError;
	
	      if (!insightsOpen) return null;
	
	      var studentName = insightsStudentName || '';
	      var body = insightsData || {};
	      var insight = body.insight_json || {};
	      var weaknesses = insight.weaknesses || {};
	      var weaknessSkills = Array.isArray(weaknesses.skills) ? weaknesses.skills : [];
	      var weaknessSummary = weaknesses.summary || null;
	      var overallSummary = insight.overall_summary || body.overall_summary || null;
	
	      var personalize = function personalize(text) {
	        return _this.personalizeText(text, studentName);
	      };
	
	      // Flatten every evidence quote from every weakness skill into a
	      // single list with the originating skill name attached.
	      var evidenceRows = [];
	      weaknessSkills.forEach(function (s) {
	        var skill = (0, _SkillsBadgePopup.getSkillName)(s) || "this skill";
	        var ev = s.evidence || s.evidences || s.quotes || s.feedback || null;
	        var items = Array.isArray(ev) ? ev : typeof ev === "string" && ev ? [ev] : [];
	        items.forEach(function (item) {
	          var text = typeof item === "string" ? item : item && (item.text || item.quote) || "";
	          if (text) evidenceRows.push({ skill: skill, quote: personalize(text) });
	        });
	      });
	
	      return _react2.default.createElement(
	        _dashboard2.default.Insights.Backdrop,
	        { onClick: _this.closeInsights },
	        _react2.default.createElement(
	          _dashboard2.default.Insights.Card,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            _dashboard2.default.Insights.CloseButton,
	            { onClick: _this.closeInsights, "aria-label": "Close" },
	            "\xD7"
	          ),
	          _react2.default.createElement(
	            _dashboard2.default.Insights.Header,
	            null,
	            _react2.default.createElement(
	              _dashboard2.default.Insights.Eyebrow,
	              null,
	              "Areas of Improvement"
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.Insights.Title,
	              null,
	              studentName
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.Insights.Subtitle,
	              null,
	              "Summary of peer-identified growth areas"
	            )
	          ),
	          _react2.default.createElement(
	            _dashboard2.default.Insights.Body,
	            null,
	            insightsLoading && _react2.default.createElement(
	              _dashboard2.default.Insights.Empty,
	              null,
	              "Loading insights\u2026"
	            ),
	            insightsError && _react2.default.createElement(
	              _dashboard2.default.Insights.Empty,
	              null,
	              insightsError
	            ),
	            !insightsLoading && !insightsError && _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.Insights.SectionLabel,
	                null,
	                "Weakness Summary"
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.Insights.Paragraph,
	                null,
	                weaknessSummary ? personalize(weaknessSummary) : _react2.default.createElement(
	                  _dashboard2.default.Insights.Empty,
	                  null,
	                  "No weakness summary provided."
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.Insights.SectionLabel,
	                null,
	                "Overall Summary"
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.Insights.Paragraph,
	                null,
	                overallSummary ? personalize(overallSummary) : _react2.default.createElement(
	                  _dashboard2.default.Insights.Empty,
	                  null,
	                  "No overall summary provided."
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.Insights.SectionLabel,
	                null,
	                "Evidence"
	              ),
	              evidenceRows.length > 0 ? _react2.default.createElement(
	                _dashboard2.default.Insights.EvidenceList,
	                null,
	                evidenceRows.map(function (row, i) {
	                  return _react2.default.createElement(
	                    _dashboard2.default.Insights.EvidenceItem,
	                    { key: "ins-ev-" + i },
	                    "\u201C",
	                    row.quote,
	                    "\u201D",
	                    _react2.default.createElement(
	                      _dashboard2.default.Insights.EvidenceSkill,
	                      null,
	                      row.skill
	                    )
	                  );
	                })
	              ) : _react2.default.createElement(
	                _dashboard2.default.Insights.Empty,
	                null,
	                "No specific evidence reported."
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderCertificate = function () {
	      var _this$state14 = _this.state,
	          certificateOpen = _this$state14.certificateOpen,
	          certificateUserId = _this$state14.certificateUserId,
	          certificateData = _this$state14.certificateData,
	          certificateLoading = _this$state14.certificateLoading,
	          certificateError = _this$state14.certificateError,
	          certificateCategory = _this$state14.certificateCategory;
	
	      if (!certificateOpen) return null;
	
	      var studentName = _this.state.certificateStudentName || '';
	      // Merge the logged-in instructor's last name into the payload so
	      // the popup sidebar reads "Professor <LastName>" instead of the
	      // bare "Professor" fallback. Do the same for course_institution
	      // using data.user.institution from general-info?position=instructor
	      // (persisted via Auth.setUserData). The insights response doesn't
	      // carry these for instructor viewers, so we inject them client-side
	      // from Auth. Preserves whatever the BE returned if it ever starts
	      // populating these fields.
	      var authUser = _Auth2.default.getUser() || {};
	      var instructorLastName = certificateData && certificateData.instructor_last_name || authUser.last_name || null;
	      var courseInstitution = certificateData && certificateData.course_institution || authUser.institution || null;
	      var data = certificateData ? Object.assign({}, certificateData, {
	        instructor_last_name: instructorLastName,
	        course_institution: courseInstitution
	      }) : { instructor_last_name: instructorLastName, course_institution: courseInstitution };
	      var teammateCount = Number(data.team_size) || 0;
	
	      return _react2.default.createElement(_SkillsBadgePopup2.default, {
	        open: true,
	        data: data,
	        loading: certificateLoading,
	        error: certificateError,
	        studentName: studentName,
	        teammateCount: teammateCount,
	        categoryLabel: MVP_BADGE_LABEL[certificateCategory] || undefined,
	        category: certificateCategory,
	        onClose: _this.closeCertificate,
	        personalize: function personalize(text) {
	          return _this.personalizeText(text, studentName);
	        }
	      });
	    };
	
	    _this.renderCollaborationCharts = function (variant) {
	      var isLarge = variant === "large";
	      var wvw = _this.workedVeryWellTogether;
	      var dnw = _this.didNotWorkWellTogether;
	      var ww = _this.workedWellTogether;
	      var hasDonutData = wvw + dnw + ww > 0;
	      var donutData = hasDonutData ? [{ name: "Worked very well together", value: wvw, fill: _this.collabDonutColors.workedVeryWell }, { name: "Worked well together", value: ww, fill: _this.collabDonutColors.workedWell }, { name: "Did not work well together", value: dnw, fill: _this.collabDonutColors.didNotWork }] : [{ name: "No data yet", value: 1, fill: "#e9ecef" }];
	
	      var donutSize = isLarge ? 240 : 100;
	      var teamCount = _this.collabTeamCount;
	
	      var bubbles = _this.getCollabBubbles();
	      var counts = bubbles.map(function (b) {
	        return b.count;
	      });
	      var minCount = counts.length ? Math.min.apply(null, counts) : 0;
	      var maxCount = counts.length ? Math.max.apply(null, counts) : 0;
	      var range = maxCount - minCount;
	      var MIN_SIZE = isLarge ? 79 : 48;
	      var MAX_SIZE = isLarge ? 143 : 79;
	
	      var evalSurveys = _this.findEvalSurveys();
	      var showEvalToggle = !!(evalSurveys.initial && evalSurveys.final);
	      var curSurveyId = _this.state.currentSurvey;
	      var evalToggle = showEvalToggle ? _react2.default.createElement(
	        TeamDynamics.EvalToggleRow,
	        null,
	        "Eval:",
	        _react2.default.createElement(
	          TeamDynamics.EvalToggleOption,
	          {
	            active: curSurveyId === evalSurveys.initial.id,
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this.selectSurveyById(evalSurveys.initial.id);
	            }
	          },
	          "Initial"
	        ),
	        _react2.default.createElement(
	          TeamDynamics.EvalToggleSeparator,
	          null,
	          ","
	        ),
	        _react2.default.createElement(
	          TeamDynamics.EvalToggleOption,
	          {
	            active: curSurveyId === evalSurveys.final.id,
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this.selectSurveyById(evalSurveys.final.id);
	            }
	          },
	          "Final"
	        )
	      ) : null;
	
	      // Pie slice labels: rendered as HTML on top of the SVG so we get
	      // reliable positioning and word-wrapping without fighting recharts'
	      // label clipping. The label box is positioned by center point at
	      // the slice's midAngle and pinned by whichever edge sits toward the
	      // pie so long text grows outward.
	      var RADIAN = Math.PI / 180;
	      var labelOffset = isLarge ? 22 : 12;
	      var labelFontSize = isLarge ? 12 : 10;
	      var labelLineHeight = isLarge ? 15 : 13;
	      var outerRadius = donutSize / 2 - 4;
	      var total = donutData.reduce(function (s, d) {
	        return s + (Number(d.value) || 0);
	      }, 0) || 1;
	      var sliceLabels = hasDonutData ? function () {
	        var cursor = 90;
	        return donutData.map(function (d, i) {
	          var sweep = d.value / total * 360;
	          var midAngle = cursor - sweep / 2;
	          cursor -= sweep;
	          var r = outerRadius + labelOffset;
	          var x = donutSize / 2 + r * Math.cos(-midAngle * RADIAN);
	          var y = donutSize / 2 + r * Math.sin(-midAngle * RADIAN);
	          var words = String(d.name || '').split(' ');
	          var mid = Math.ceil(words.length / 2);
	          var dxFromCenter = x - donutSize / 2;
	          var align = void 0;
	          if (Math.abs(dxFromCenter) < 8) align = 'center';else align = dxFromCenter > 0 ? 'left' : 'right';
	          return {
	            key: "lbl-" + i,
	            line1: words.slice(0, mid).join(' '),
	            line2: words.slice(mid).join(' '),
	            pct: Math.round(d.value),
	            x: x, y: y,
	            align: align,
	            skip: !d.value
	          };
	        });
	      }() : [];
	
	      return {
	        donut: _react2.default.createElement(
	          "div",
	          { style: { height: "100%", display: "flex", flexDirection: "column" } },
	          evalToggle,
	          _react2.default.createElement(
	            TeamDynamics.PopupChartFrame,
	            { style: { flex: 1, height: "auto", marginTop: 16 } },
	            _react2.default.createElement(
	              "div",
	              { style: { position: 'relative', width: donutSize, height: donutSize } },
	              _react2.default.createElement(
	                _recharts.PieChart,
	                {
	                  width: donutSize,
	                  height: donutSize,
	                  margin: { top: 0, left: 0, bottom: 0, right: 0 }
	                },
	                _react2.default.createElement(_recharts.Tooltip, { formatter: function formatter(value) {
	                    return Number(value).toFixed(1) + "%";
	                  }, separator: ": " }),
	                _react2.default.createElement(
	                  _recharts.Pie,
	                  {
	                    data: donutData,
	                    cx: donutSize / 2,
	                    cy: donutSize / 2,
	                    innerRadius: isLarge ? 70 : 28,
	                    outerRadius: outerRadius,
	                    paddingAngle: 1,
	                    dataKey: "value",
	                    startAngle: 90,
	                    endAngle: -270,
	                    labelLine: false
	                  },
	                  donutData.map(function (d, i) {
	                    return _react2.default.createElement(_recharts.Cell, { key: "donut-" + i, fill: d.fill });
	                  })
	                )
	              ),
	              sliceLabels.map(function (lbl) {
	                return lbl.skip ? null : _react2.default.createElement(
	                  "div",
	                  {
	                    key: lbl.key,
	                    style: {
	                      position: 'absolute',
	                      left: lbl.align === 'left' ? lbl.x : lbl.align === 'center' ? lbl.x : undefined,
	                      right: lbl.align === 'right' ? donutSize - lbl.x : undefined,
	                      top: lbl.y,
	                      transform: lbl.align === 'center' ? 'translate(-50%, -50%)' : 'translateY(-50%)',
	                      fontFamily: "'Mukta Vaani', sans-serif",
	                      fontSize: labelFontSize,
	                      lineHeight: labelLineHeight + "px",
	                      fontWeight: 600,
	                      color: 'rgba(0, 27, 59, 0.85)',
	                      textAlign: lbl.align === 'right' ? 'right' : lbl.align === 'center' ? 'center' : 'left',
	                      whiteSpace: 'nowrap',
	                      pointerEvents: 'none',
	                      paddingLeft: lbl.align === 'left' ? 4 : 0,
	                      paddingRight: lbl.align === 'right' ? 4 : 0
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    lbl.line1
	                  ),
	                  lbl.line2 ? _react2.default.createElement(
	                    "div",
	                    null,
	                    lbl.line2
	                  ) : null,
	                  _react2.default.createElement(
	                    "div",
	                    { style: { fontWeight: 700 } },
	                    lbl.pct,
	                    "%"
	                  )
	                );
	              })
	            )
	          )
	        ),
	        donutLegend: _react2.default.createElement(
	          TeamDynamics.LegendList,
	          null,
	          _react2.default.createElement(
	            TeamDynamics.LegendItem,
	            null,
	            _react2.default.createElement(TeamDynamics.LegendDot, { color: _this.collabDonutColors.workedVeryWell }),
	            _react2.default.createElement(
	              TeamDynamics.LegendName,
	              null,
	              "Worked very well"
	            ),
	            _react2.default.createElement(
	              TeamDynamics.LegendValue,
	              null,
	              Math.round(wvw),
	              "%"
	            )
	          ),
	          _react2.default.createElement(
	            TeamDynamics.LegendItem,
	            null,
	            _react2.default.createElement(TeamDynamics.LegendDot, { color: _this.collabDonutColors.workedWell }),
	            _react2.default.createElement(
	              TeamDynamics.LegendName,
	              null,
	              "Worked well"
	            ),
	            _react2.default.createElement(
	              TeamDynamics.LegendValue,
	              null,
	              Math.round(ww),
	              "%"
	            )
	          ),
	          _react2.default.createElement(
	            TeamDynamics.LegendItem,
	            null,
	            _react2.default.createElement(TeamDynamics.LegendDot, { color: _this.collabDonutColors.didNotWork }),
	            _react2.default.createElement(
	              TeamDynamics.LegendName,
	              null,
	              "Didn't work well"
	            ),
	            _react2.default.createElement(
	              TeamDynamics.LegendValue,
	              null,
	              Math.round(dnw),
	              "%"
	            )
	          )
	        ),
	        bubbles: function () {
	          // Hide the entire bubble panel (section header, tabs, and
	          // bubbles) when no peer has commented on any skill yet —
	          // i.e. sum of total_student_count across both strengths and
	          // weaknesses is 0. The donut on the left still renders.
	          var totalSkillCount = (_this.state.collaborationStrengths || []).concat(_this.state.collaborationWeaknesses || []).reduce(function (acc, s) {
	            return acc + (Number(s && s.total_student_count) || 0);
	          }, 0);
	          if (totalSkillCount === 0) return null;
	
	          var tab = _this.state.collaborationSkillsTab === "weaknesses" ? "weaknesses" : "strengths";
	          var scheme = _this.collabBubbleColors[tab];
	          // Bubble row uses flex `space-evenly` for even visual gaps
	          // between bubbles of any size. With N=4, the first bubble's
	          // center sits at ~20% of the area — same approximation we
	          // used previously — so the header left-align math holds.
	          var headerLeftPad = "calc(20% - " + MAX_SIZE / 2 + "px)";
	          return _react2.default.createElement(
	            TeamDynamics.BubblePanel,
	            null,
	            _react2.default.createElement(
	              TeamDynamics.BubbleSectionHeader,
	              { style: { paddingLeft: headerLeftPad } },
	              "Students Demonstrating Each Skill"
	            ),
	            _react2.default.createElement(
	              TeamDynamics.BubbleTabs,
	              { style: { paddingLeft: headerLeftPad } },
	              _react2.default.createElement(
	                TeamDynamics.BubbleTab,
	                {
	                  active: tab === "strengths",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    _this.setState({ collaborationSkillsTab: "strengths" });
	                  }
	                },
	                "Strengths"
	              ),
	              _react2.default.createElement(
	                TeamDynamics.BubbleTab,
	                {
	                  active: tab === "weaknesses",
	                  onClick: function onClick(e) {
	                    e.preventDefault();
	                    _this.setState({ collaborationSkillsTab: "weaknesses" });
	                  }
	                },
	                "Areas to Improve"
	              )
	            ),
	            _react2.default.createElement(
	              TeamDynamics.PopupChartFrame,
	              { style: !isLarge ? { height: 130 } : { height: 280 } },
	              _react2.default.createElement(
	                TeamDynamics.BubbleArea,
	                { style: { width: "100%", height: "100%", minHeight: 0 } },
	                bubbles.map(function (b, i) {
	                  var ratio = range > 0 ? (b.count - minCount) / range : 0.5;
	                  var size = Math.round(MIN_SIZE + (MAX_SIZE - MIN_SIZE) * ratio);
	                  // Count font dynamic to fit inside the bubble. Digit
	                  // width ≈ 0.55em; floor at 9px so it stays legible.
	                  var digitCount = String(b.count).length || 1;
	                  var widthBased = size * 0.75 / digitCount / 0.55;
	                  var heightBased = size / 2.4;
	                  var countFont = Math.max(9, Math.min(24, Math.floor(Math.min(widthBased, heightBased))));
	                  var tooltip = b.text + " \u2014 " + b.count + " student" + (b.count === 1 ? "" : "s");
	                  return _react2.default.createElement(
	                    TeamDynamics.BubbleSlot,
	                    { key: "bubble-" + variant + "-" + tab + "-" + i },
	                    _react2.default.createElement(
	                      TeamDynamics.BubbleFrame,
	                      { height: MAX_SIZE },
	                      _react2.default.createElement(
	                        TeamDynamics.Bubble,
	                        {
	                          color: scheme.body,
	                          borderColor: scheme.outline,
	                          textColor: scheme.text,
	                          size: size,
	                          title: tooltip
	                        },
	                        _react2.default.createElement(
	                          TeamDynamics.BubbleLabel,
	                          { fontSize: countFont },
	                          b.count
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      TeamDynamics.BubbleCaption,
	                      { captionWidth: isLarge ? "110px" : "78px" },
	                      _react2.default.createElement(
	                        TeamDynamics.BubbleCaptionName,
	                        { title: b.text },
	                        b.text
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          );
	        }(),
	        bubbleLegend: null
	      };
	    };
	
	    _this.openCertificate = function (userId, category, person) {
	      if (!userId) return;
	      var name = person ? ((person.first_name || '') + " " + (person.last_name || '')).trim() || person.username || '' : '';
	      _this.setState({
	        certificateOpen: true,
	        certificateUserId: Number(userId),
	        certificateStudentName: name,
	        certificateCategory: category || null,
	        certificateData: null,
	        certificateError: null,
	        certificateLoading: true
	      });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId) {
	        _this.setState({
	          certificateLoading: false,
	          certificateError: "No active survey"
	        });
	        return;
	      }
	      (0, _ApiService.getRequest)(apiUrl + "v2/insights/student/" + userId + "/" + surveyId + "/").then(function (res) {
	        _this.setState({
	          certificateData: res && res.body || null,
	          certificateLoading: false
	        });
	      }).catch(function () {
	        _this.setState({
	          certificateLoading: false,
	          certificateError: "Unable to load badge"
	        });
	      });
	    };
	
	    _this.closeCertificate = function () {
	      _this.setState({
	        certificateOpen: false,
	        certificateUserId: null,
	        certificateStudentName: '',
	        certificateCategory: null,
	        certificateData: null,
	        certificateError: null,
	        certificateLoading: false
	      });
	    };
	
	    _this.fetchNotRegistered = function () {
	      var courseId = Number(_Auth2.default.getCourseId());
	      if (!courseId) return;
	      _this.setState({ notRegisteredLoading: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/games/coursemembers/?not-registered&course=" + courseId + (sq ? "&" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        var results = Array.isArray(body.results) ? body.results : [];
	        var count = Number(body.count) || results.length;
	        _this.setState({
	          notRegisteredCount: count,
	          notRegisteredList: results,
	          notRegisteredLoading: false
	        });
	      }).catch(function () {
	        // Non-fatal: just skip the subtext if the endpoint is
	        // unavailable.
	        _this.setState({
	          notRegisteredCount: 0,
	          notRegisteredList: [],
	          notRegisteredLoading: false
	        });
	      });
	    };
	
	    _this.openNotRegisteredPopup = function () {
	      if (_this.state.notRegisteredCount === 0) return;
	      _this.setState({ notRegisteredPopupOpen: true, notRegisteredCopied: false });
	    };
	
	    _this.closeNotRegisteredPopup = function () {
	      _this.setState({ notRegisteredPopupOpen: false, notRegisteredCopied: false });
	    };
	
	    _this.copyNotRegisteredEmails = function () {
	      var emails = (_this.state.notRegisteredList || []).map(function (s) {
	        return s && s.email ? String(s.email).trim() : "";
	      }).filter(Boolean).join(", ");
	      if (!emails) return;
	      var done = function done() {
	        return _this.setState({ notRegisteredCopied: true });
	      };
	      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
	        navigator.clipboard.writeText(emails).then(done).catch(function () {});
	        return;
	      }
	      // Fallback for older browsers without the Clipboard API.
	      try {
	        var ta = document.createElement("textarea");
	        ta.value = emails;
	        ta.style.position = "fixed";
	        ta.style.opacity = "0";
	        document.body.appendChild(ta);
	        ta.select();
	        document.execCommand("copy");
	        document.body.removeChild(ta);
	        done();
	      } catch (e) {
	        // Silent fail; user can still manually copy from the modal body.
	      }
	    };
	
	    _this.fetchPendingDecisions = function () {
	      var gameId = Number(_this.props.game && _this.props.game.id || _this.state.currentGame);
	      // Decision Submission Status targets the CURRENT in-progress round.
	      // props.currentRound is a round NUMBER already resolved by App.js
	      // from data.user.game_round, independent of is_finished — same
	      // pattern audit-trail uses. Avoids the this.roundNumber getter,
	      // which only resolves against finished rounds.
	      var roundNumber = Number(_this.props.currentRound) || 0;
	      if (!gameId || !roundNumber) {
	        _this.setState({ pendingDecisionsCount: 0, pendingDecisionsTeamIds: [] });
	        return;
	      }
	      // Dedupe by (gameId, roundNumber). On initial mount, selectGame →
	      // selectRound → componentDidUpdate can each schedule this fetch
	      // with the same inputs. Skip when nothing changed; refetch when
	      // the user moves to a different round or game.
	      var key = gameId + "|" + roundNumber;
	      if (_this._pendingDecisionsKey === key) return;
	      _this._pendingDecisionsKey = key;
	      _this.setState({ pendingDecisionsLoading: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/games/games/" + gameId + "/rounds/" + roundNumber + "/team-decisions-not-submitted/" + (sq ? "?" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        var teams = Array.isArray(body.teams) ? body.teams : [];
	        // Filter out teams whose only missing item is "negative_cash".
	        var filtered = teams.filter(function (t) {
	          var missing = Array.isArray(t && t.missing) ? t.missing : [];
	          if (missing.length === 0) return false;
	          if (missing.length === 1 && missing[0] === 'negative_cash') return false;
	          return true;
	        });
	        var teamIds = filtered.map(function (t) {
	          return Number(t.team_id);
	        }).filter(Boolean);
	        _this.setState({
	          pendingDecisionsCount: teamIds.length,
	          pendingDecisionsTeamIds: teamIds,
	          pendingDecisionsLoading: false
	        });
	      }).catch(function () {
	        // Clear the dedup key on failure so the next scheduled call
	        // actually retries instead of silently no-oping.
	        _this._pendingDecisionsKey = null;
	        _this.setState({
	          pendingDecisionsCount: 0,
	          pendingDecisionsTeamIds: [],
	          pendingDecisionsLoading: false
	        });
	      });
	    };
	
	    _this.openPendingDecisionsPopup = function () {
	      if (_this.state.pendingDecisionsCount === 0) return;
	      _this.setState({ pendingDecisionsPopupOpen: true, pendingDecisionsFilter: '' });
	    };
	
	    _this.closePendingDecisionsPopup = function () {
	      _this.setState({ pendingDecisionsPopupOpen: false, pendingDecisionsFilter: '' });
	    };
	
	    _this.onPendingDecisionsFilterChange = function (e) {
	      var value = e && e.target ? e.target.value : '';
	      _this.setState({ pendingDecisionsFilter: value });
	    };
	
	    _this.renderPendingDecisionsPopup = function () {
	      var _this$state15 = _this.state,
	          pendingDecisionsPopupOpen = _this$state15.pendingDecisionsPopupOpen,
	          pendingDecisionsTeamIds = _this$state15.pendingDecisionsTeamIds,
	          pendingDecisionsCount = _this$state15.pendingDecisionsCount,
	          pendingDecisionsFilter = _this$state15.pendingDecisionsFilter;
	
	      if (!pendingDecisionsPopupOpen) return null;
	      var teams = Array.isArray(_this.state.teams) ? _this.state.teams : [];
	      var resolveTeamName = function resolveTeamName(teamId) {
	        var match = teams.find(function (t) {
	          return t && Number(t.id) === Number(teamId);
	        });
	        return match && match.name != null ? String(match.name) : String(teamId);
	      };
	      var ids = Array.isArray(pendingDecisionsTeamIds) ? pendingDecisionsTeamIds : [];
	      // Sort: all-numeric names first in ascending numeric order, then
	      // alphabetic names A-Z. Mixed names (e.g. "Team 11A") sort with
	      // the alphabetic group using locale-aware compare.
	      var names = ids.map(function (id) {
	        return resolveTeamName(id);
	      });
	      var numeric = names.filter(function (n) {
	        return (/^\d+$/.test(n)
	        );
	      }).sort(function (a, b) {
	        return Number(a) - Number(b);
	      });
	      var alphabetic = names.filter(function (n) {
	        return !/^\d+$/.test(n);
	      }).sort(function (a, b) {
	        return a.localeCompare(b, undefined, { sensitivity: 'base' });
	      });
	      var ordered = [].concat(_toConsumableArray(numeric), _toConsumableArray(alphabetic));
	      var filterRaw = pendingDecisionsFilter || '';
	      var filterNorm = filterRaw.trim().toLowerCase();
	      var filtered = filterNorm ? ordered.map(function (name, idx) {
	        return { name: name, idx: idx };
	      }).filter(function (_ref5) {
	        var name = _ref5.name;
	        return ("team " + name).toLowerCase().includes(filterNorm);
	      }) : ordered.map(function (name, idx) {
	        return { name: name, idx: idx };
	      });
	      var totalCount = ordered.length;
	      var shownCount = filtered.length;
	      var roundLabel = Number(_this.roundNumber) || 0;
	
	      return _react2.default.createElement(
	        NotRegisteredBackdrop,
	        { onClick: _this.closePendingDecisionsPopup },
	        _react2.default.createElement(
	          SubStatusCard,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            SubStatusHeader,
	            null,
	            _react2.default.createElement(
	              SubStatusHeaderText,
	              null,
	              _react2.default.createElement(
	                SubStatusEyebrow,
	                null,
	                "Year ",
	                roundLabel,
	                " \xB7 Decisions"
	              ),
	              _react2.default.createElement(
	                SubStatusTitle,
	                null,
	                "Submission status"
	              )
	            ),
	            _react2.default.createElement(
	              SubStatusClose,
	              {
	                type: "button",
	                onClick: _this.closePendingDecisionsPopup,
	                "aria-label": "Close"
	              },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            SubStatusBanner,
	            null,
	            _react2.default.createElement(
	              SubStatusBannerIcon,
	              null,
	              _react2.default.createElement(
	                "svg",
	                { viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" },
	                _react2.default.createElement("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeWidth: "2" }),
	                _react2.default.createElement("path", { d: "M12 7v5l3 2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
	              )
	            ),
	            _react2.default.createElement(
	              SubStatusBannerText,
	              null,
	              _react2.default.createElement(
	                SubStatusBannerTitle,
	                null,
	                pendingDecisionsCount,
	                " team",
	                pendingDecisionsCount === 1 ? '' : 's',
	                " ",
	                pendingDecisionsCount === 1 ? "hasn't" : "haven't",
	                " submitted"
	              ),
	              _react2.default.createElement(
	                SubStatusBannerSubtitle,
	                null,
	                "Their decisions are still missing for this round."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            SubStatusFilterWrap,
	            null,
	            _react2.default.createElement(
	              SubStatusFilterIcon,
	              null,
	              _react2.default.createElement(
	                "svg",
	                { viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" },
	                _react2.default.createElement("circle", { cx: "11", cy: "11", r: "7", stroke: "currentColor", strokeWidth: "2" }),
	                _react2.default.createElement("path", { d: "M20 20l-3.5-3.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
	              )
	            ),
	            _react2.default.createElement(SubStatusFilterInput, {
	              type: "text",
	              placeholder: "Filter teams...",
	              value: filterRaw,
	              onChange: _this.onPendingDecisionsFilterChange
	            })
	          ),
	          _react2.default.createElement(
	            SubStatusGrid,
	            null,
	            totalCount === 0 && _react2.default.createElement(
	              SubStatusEmpty,
	              null,
	              "All teams have submitted this round."
	            ),
	            totalCount > 0 && shownCount === 0 && _react2.default.createElement(
	              SubStatusEmpty,
	              null,
	              "No teams match your filter."
	            ),
	            filtered.map(function (_ref6) {
	              var name = _ref6.name,
	                  idx = _ref6.idx;
	              return _react2.default.createElement(
	                SubStatusTeamCard,
	                { key: "pd-" + idx + "-" + name },
	                _react2.default.createElement(
	                  SubStatusTeamBadge,
	                  null,
	                  idx + 1
	                ),
	                _react2.default.createElement(
	                  SubStatusTeamName,
	                  null,
	                  "Team ",
	                  name
	                ),
	                _react2.default.createElement(
	                  SubStatusTeamPill,
	                  null,
	                  _react2.default.createElement(SubStatusTeamPillDot, null),
	                  "Pending"
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            SubStatusFooter,
	            null,
	            _react2.default.createElement(
	              SubStatusShowing,
	              null,
	              "Showing ",
	              shownCount,
	              " of ",
	              totalCount
	            ),
	            _react2.default.createElement(
	              SubStatusCloseButton,
	              { type: "button", onClick: _this.closePendingDecisionsPopup },
	              "Close"
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderNotRegisteredPopup = function () {
	      var _this$state16 = _this.state,
	          notRegisteredPopupOpen = _this$state16.notRegisteredPopupOpen,
	          notRegisteredList = _this$state16.notRegisteredList,
	          notRegisteredCount = _this$state16.notRegisteredCount,
	          notRegisteredCopied = _this$state16.notRegisteredCopied;
	
	      if (!notRegisteredPopupOpen) return null;
	      var list = Array.isArray(notRegisteredList) ? notRegisteredList : [];
	      var emailCount = list.filter(function (s) {
	        return s && s.email;
	      }).length;
	      return _react2.default.createElement(
	        NotRegisteredBackdrop,
	        { onClick: _this.closeNotRegisteredPopup },
	        _react2.default.createElement(
	          NotRegisteredCard,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            NotRegisteredHeader,
	            null,
	            _react2.default.createElement(
	              NotRegisteredHeaderText,
	              null,
	              _react2.default.createElement(
	                NotRegisteredTitle,
	                null,
	                "Students not registered yet"
	              ),
	              _react2.default.createElement(
	                NotRegisteredSubtitle,
	                null,
	                notRegisteredCount,
	                " student",
	                notRegisteredCount === 1 ? '' : 's',
	                " haven't signed up for the course."
	              )
	            ),
	            _react2.default.createElement(
	              NotRegisteredClose,
	              {
	                type: "button",
	                onClick: _this.closeNotRegisteredPopup,
	                "aria-label": "Close"
	              },
	              "\xD7"
	            )
	          ),
	          _react2.default.createElement(
	            NotRegisteredActions,
	            null,
	            _react2.default.createElement(
	              NotRegisteredCopyButton,
	              {
	                type: "button",
	                onClick: _this.copyNotRegisteredEmails,
	                disabled: emailCount === 0
	              },
	              "Copy all emails"
	            ),
	            notRegisteredCopied && _react2.default.createElement(
	              NotRegisteredCopiedBadge,
	              null,
	              "Copied ",
	              emailCount,
	              " email",
	              emailCount === 1 ? '' : 's',
	              " to clipboard"
	            )
	          ),
	          _react2.default.createElement(
	            NotRegisteredList,
	            null,
	            list.length === 0 && _react2.default.createElement(
	              NotRegisteredEmpty,
	              null,
	              "No students in the not-registered list."
	            ),
	            list.map(function (s, idx) {
	              var first = s && s.first_name || '';
	              var last = s && s.last_name || '';
	              var fullName = (first + " " + last).trim() || "Student " + (s && s.id ? s.id : idx + 1);
	              return _react2.default.createElement(
	                NotRegisteredRow,
	                { key: "nr-" + (s && s.id ? s.id : idx) },
	                _react2.default.createElement(
	                  NotRegisteredName,
	                  null,
	                  fullName
	                ),
	                _react2.default.createElement(
	                  NotRegisteredEmail,
	                  null,
	                  s && s.email || '-'
	                )
	              );
	            })
	          )
	        )
	      );
	    };
	
	    _this.openInsights = function (userId, person) {
	      if (!userId) return;
	      var name = person ? ((person.first_name || '') + " " + (person.last_name || '')).trim() || person.username || '' : '';
	      _this.setState({
	        insightsOpen: true,
	        insightsUserId: Number(userId),
	        insightsStudentName: name,
	        insightsData: null,
	        insightsError: null,
	        insightsLoading: true
	      });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var surveyId = _this.state.currentSurvey;
	      if (!surveyId) {
	        _this.setState({
	          insightsLoading: false,
	          insightsError: "No active survey"
	        });
	        return;
	      }
	      (0, _ApiService.getRequest)(apiUrl + "v2/insights/student/" + userId + "/" + surveyId + "/").then(function (res) {
	        _this.setState({
	          insightsData: res && res.body || null,
	          insightsLoading: false
	        });
	      }).catch(function () {
	        _this.setState({
	          insightsLoading: false,
	          insightsError: "Unable to load insights"
	        });
	      });
	    };
	
	    _this.closeInsights = function () {
	      _this.setState({
	        insightsOpen: false,
	        insightsUserId: null,
	        insightsStudentName: '',
	        insightsData: null,
	        insightsError: null,
	        insightsLoading: false
	      });
	    };
	
	    _this.TEAM_LOOKUP_CACHE_MS = 60 * 1000;
	
	    _this.openTeamLookup = function (prefillTeamId) {
	      var now = Date.now();
	      var currentRoundId = _this.state.currentRound;
	      var cacheStale = !_this.state.teamLookupCacheTime || now - _this.state.teamLookupCacheTime > _this.TEAM_LOOKUP_CACHE_MS || _this.state.teamLookupCacheRoundId !== currentRoundId;
	
	      _this.setState({
	        teamLookupOpen: true,
	        teamLookupStep: 1,
	        teamLookupQuery: "",
	        teamLookupHighlightIdx: 0,
	        teamLookupSelectedTeam: null,
	        teamLookupError: null
	      }, function () {
	        if (cacheStale) _this.fetchTeamLookupRows();
	        if (prefillTeamId) {
	          var team = (_this.state.teamLookupRows || []).find(function (t) {
	            return Number(t.id) === Number(prefillTeamId);
	          });
	          if (team) _this.handleTeamLookupSelect(team);
	        }
	      });
	    };
	
	    _this.closeTeamLookup = function () {
	      _this.setState({
	        teamLookupOpen: false,
	        teamLookupStep: 1,
	        teamLookupQuery: "",
	        teamLookupHighlightIdx: 0,
	        teamLookupSelectedTeam: null,
	        teamLookupError: null
	      });
	    };
	
	    _this.formatTeamName = function (rawName, id) {
	      var name = rawName && String(rawName).trim();
	      if (!name) return "Team " + id;
	      return (/^team\s/i.test(name) ? name : "Team " + name
	      );
	    };
	
	    _this.fetchTeamLookupRows = function () {
	      // Prefer the dashboard's currently-selected round; fall back to
	      // the latest round in props.rounds (largest round.number) so the
	      // modal still surfaces team data on a fresh course where the
	      // dashboard hasn't auto-selected a round yet.
	      var roundId = _this.state.currentRound;
	      if (!roundId) {
	        var rounds = _this.state.rounds || _this.props.rounds || [];
	        var sorted = rounds.slice().sort(function (a, b) {
	          return Number(b.number) - Number(a.number);
	        });
	        roundId = sorted.length > 0 ? sorted[0].id : null;
	      }
	      if (!roundId) {
	        // No rounds at all — still let the modal show team names with
	        // a "—" score, so the instructor can pick a team.
	        var teamsProp = _this.props.teams || _this.state.teams || [];
	        var rows = teamsProp.map(function (t) {
	          return {
	            id: t.id,
	            name: _this.formatTeamName(t.name, t.id),
	            memberCount: Array.isArray(t.users) ? t.users.length : null,
	            score: null
	          };
	        }).map(function (row, idx) {
	          return Object.assign({}, row, { rank: idx + 1 });
	        });
	        _this.setState({
	          teamLookupRows: rows,
	          teamLookupLoading: false,
	          teamLookupError: null,
	          teamLookupCacheRoundId: null,
	          teamLookupCacheTime: Date.now()
	        });
	        return;
	      }
	      _this.setState({ teamLookupLoading: true, teamLookupError: null });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/games/teamgradings/overall/" + roundId + "/" + (sq ? "?" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        var apiTeams = Array.isArray(body.teams) ? body.teams : [];
	        var teamsProp = _this.props.teams || _this.state.teams || [];
	
	        // Join the score data with the team prop list (which carries
	        // name, member count, competition etc.). Sort by score desc
	        // and tag with a 1-based rank within the round.
	        //
	        // When a sections query is active, the gradings response is
	        // already filtered to the instructor's section(s); restrict
	        // the row list to just those team ids so the modal doesn't
	        // show section-foreign teams with "---" scores. Lead
	        // instructors (no sq) still see every team in props.teams,
	        // with "---" where the team hasn't been graded yet.
	        var sectionTeamIds = sq ? new Set(apiTeams.map(function (g) {
	          return Number(g.team);
	        })) : null;
	        var rows = teamsProp.filter(function (t) {
	          return !sectionTeamIds || sectionTeamIds.has(Number(t.id));
	        }).map(function (t) {
	          var grading = apiTeams.find(function (g) {
	            return Number(g.team) === Number(t.id);
	          });
	          var score = grading ? Number(grading.current_weighted_value) || 0 : null;
	          return {
	            id: t.id,
	            name: _this.formatTeamName(t.name, t.id),
	            memberCount: Array.isArray(t.users) ? t.users.length : null,
	            score: score
	          };
	        }).sort(function (a, b) {
	          // Teams without a score sink to the bottom; otherwise desc.
	          if (a.score == null && b.score == null) return 0;
	          if (a.score == null) return 1;
	          if (b.score == null) return -1;
	          return b.score - a.score;
	        }).map(function (row, idx) {
	          return Object.assign({}, row, { rank: idx + 1 });
	        });
	
	        _this.setState({
	          teamLookupRows: rows,
	          teamLookupLoading: false,
	          teamLookupCacheRoundId: roundId,
	          teamLookupCacheTime: Date.now()
	        });
	      }).catch(function () {
	        _this.setState({
	          teamLookupLoading: false,
	          teamLookupError: "Unable to load teams"
	        });
	      });
	    };
	
	    _this.setTeamLookupQuery = function (value) {
	      _this.setState({ teamLookupQuery: value, teamLookupHighlightIdx: 0 });
	    };
	
	    _this.getFilteredLookupRows = function () {
	      var q = (_this.state.teamLookupQuery || "").trim().toLowerCase();
	      var rows = _this.state.teamLookupRows || [];
	      if (!q) return rows;
	      return rows.filter(function (r) {
	        var name = String(r.name || "").toLowerCase();
	        var id = String(r.id || "");
	        var rank = String(r.rank || "");
	        return name.includes(q) || id.includes(q) || rank.includes(q);
	      });
	    };
	
	    _this.handleTeamLookupKeyDown = function (e) {
	      if (e.key === "Escape") {
	        e.preventDefault();
	        if (_this.state.teamLookupStep === 2) {
	          _this.handleTeamLookupBack();
	        } else {
	          _this.closeTeamLookup();
	        }
	        return;
	      }
	      if (_this.state.teamLookupStep !== 1) return;
	      var filtered = _this.getFilteredLookupRows();
	      if (e.key === "ArrowDown") {
	        e.preventDefault();
	        var next = Math.min(_this.state.teamLookupHighlightIdx + 1, filtered.length - 1);
	        _this.setState({ teamLookupHighlightIdx: Math.max(0, next) });
	      } else if (e.key === "ArrowUp") {
	        e.preventDefault();
	        var _next = Math.max(_this.state.teamLookupHighlightIdx - 1, 0);
	        _this.setState({ teamLookupHighlightIdx: _next });
	      } else if (e.key === "Enter") {
	        e.preventDefault();
	        var team = filtered[_this.state.teamLookupHighlightIdx];
	        if (team) _this.handleTeamLookupSelect(team);
	      }
	    };
	
	    _this.handleTeamLookupSelect = function (team) {
	      _this.setState({
	        teamLookupSelectedTeam: team,
	        teamLookupStep: 2
	      });
	    };
	
	    _this.handleTeamLookupBack = function () {
	      _this.setState({
	        teamLookupSelectedTeam: null,
	        teamLookupStep: 1,
	        teamLookupHighlightIdx: 0
	      });
	    };
	
	    _this.getTeamLookupRoundNumber = function () {
	      var urlRound = Number(_this.props.roundInUrl);
	      if (urlRound > 0) return urlRound;
	      var stateRound = _this.roundNumber;
	      if (stateRound > 0) return stateRound;
	      var rounds = _this.state.rounds || _this.props.rounds || [];
	      if (rounds.length === 0) return 0;
	      var latest = rounds.slice().sort(function (a, b) {
	        return Number(b.number) - Number(a.number);
	      })[0];
	      return Number(latest && latest.number) || 0;
	    };
	
	    _this.buildTeamLookupReportUrl = function (team) {
	      if (!team) return null;
	      var gameId = _this.props.game && _this.props.game.id || _Auth2.default.getGameId();
	      var round = _this.getTeamLookupRoundNumber();
	      return "/analysis/team-reports?team_id=" + team.id + "&round=" + round + "&game_id=" + gameId + "&_token=" + _Auth2.default.getToken() + "&_userid=" + _Auth2.default.getUserId() + "&_courseid=" + _Auth2.default.getCourseId();
	    };
	
	    _this.buildTeamLookupAuditUrl = function (team) {
	      if (!team) return null;
	      var gameId = _this.props.game && _this.props.game.id || _Auth2.default.getGameId();
	      var round = _this.getTeamLookupRoundNumber();
	      return "/analysis/audit-trail?team_id=" + team.id + "&round=" + round + "&game_id=" + gameId + "&_token=" + _Auth2.default.getToken() + "&_userid=" + _Auth2.default.getUserId() + "&_courseid=" + _Auth2.default.getCourseId();
	    };
	
	    _this.handleOpenTeamReport = function () {
	      var url = _this.buildTeamLookupReportUrl(_this.state.teamLookupSelectedTeam);
	      if (url) window.open(url, "_blank", "noopener,noreferrer");
	    };
	
	    _this.handleOpenAuditTrail = function () {
	      var url = _this.buildTeamLookupAuditUrl(_this.state.teamLookupSelectedTeam);
	      if (url) window.open(url, "_blank", "noopener,noreferrer");
	    };
	
	    _this.personalizeText = function (text, name) {
	      if (!name) return String(text || "");
	      return String(text || "").replace(/this student/gi, name).replace(/the student/gi, name).replace(/<student>/gi, name).replace(/\[person[\s-]?\d+\]/gi, name).replace(/\[student[^\]]*\]/gi, name).replace(/\bstudent[\s-][a-z0-9]+\b/gi, name);
	    };
	
	    _this.fetchCollaborationSkills = function () {
	      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var _this$state17 = _this.state,
	          currentSurvey = _this$state17.currentSurvey,
	          allSurveys = _this$state17.allSurveys,
	          collaborationStrengths = _this$state17.collaborationStrengths,
	          collaborationWeaknesses = _this$state17.collaborationWeaknesses;
	
	      var surveyId = currentSurvey || (Array.isArray(allSurveys) && allSurveys.length > 0 ? allSurveys[0].id : 0);
	      if (!surveyId) return;
	      if (!force && Array.isArray(collaborationStrengths) && collaborationStrengths.length > 0 && Array.isArray(collaborationWeaknesses) && collaborationWeaknesses.length > 0) {
	        return;
	      }
	
	      _this.setState({ collaborationSkillsLoading: true });
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(apiUrl + "v2/insights/survey/" + surveyId + "/skills/" + (sq ? "?" + sq : "")).then(function (res) {
	        var body = res && res.body || {};
	        // Keep the full strength/weakness arrays now (was capped at 4
	        // for the bubble chart). The radar pins to a fixed set of 4
	        // axes — we look those up by name.
	        var strengths = Array.isArray(body.strengths) ? body.strengths : [];
	        var weaknesses = Array.isArray(body.weaknesses) ? body.weaknesses : [];
	        // Denominators come from the backend so each axis can render
	        // skill_count / total-responses. Tolerate a couple plausible
	        // field names; fall back to a placeholder 400 until the
	        // backend ships the real per-survey totals.
	        var iLikeTotal = Number(body.i_like_total || body.total_i_like_responses || body.response_totals && body.response_totals.like || 400);
	        var iWishTotal = Number(body.i_wish_total || body.total_i_wish_responses || body.response_totals && body.response_totals.wish || 400);
	        _this.setState({
	          collaborationStrengths: strengths,
	          collaborationWeaknesses: weaknesses,
	          collaborationILikeTotal: iLikeTotal,
	          collaborationIWishTotal: iWishTotal,
	          collaborationSkillsLoading: false
	        });
	      }).catch(function () {
	        _this.setState({ collaborationSkillsLoading: false });
	      });
	    };
	
	    _this.selectSurvey = function (value) {
	      var surveys = _this.state.surveys;
	
	
	      if (surveys) {
	        var survey = surveys.find(function (i) {
	          return i.name === value;
	        });
	        if (survey) {
	          _this.selectSurveyById(survey.id);
	        }
	      }
	    };
	
	    _this.selectSurveyById = function (surveyId) {
	      if (!surveyId) return;
	      // Cancel any in-flight insights poll from the previous survey so
	      // a late poll response can't clobber the newly-selected survey's
	      // state.
	      _this._stopInsightsPoll();
	      _this.setState({
	        currentSurvey: surveyId,
	        teamDynamicsDownloadRequest: null,
	        teamDynamicsDownloadCount: 0,
	        teamDynamicsDownloadFile: null,
	        // Reset the spotlight existence gate so the loading state
	        // shows while we re-check for the newly-picked survey.
	        studentSpotlightHasInsights: null,
	        studentSpotlightGenerateMessage: null,
	        studentSpotlightGenerating: false,
	        insightsJobId: null,
	        insightsStatusUrl: null,
	        myInstructorBadgeState: null,
	        // Switching surveys is a fresh context — re-evaluate whether
	        // the badges intro popup should show for the new survey.
	        badgesIntroSuppressed: false,
	        // Clear any class-wide badge recipient count from the prior
	        // survey so a stale number doesn't briefly flash if the user
	        // reopens the consent popup for the newly picked survey.
	        classWideBadgeRecipientCount: null
	      }, function () {
	        _this.fetchTeamScore();
	        // Top/Bottom Performers and Collaboration Insights are both
	        // keyed by survey — force a refresh so the displayed data
	        // matches the chosen survey rather than serving cached rows.
	        _this.fetchMostLeastValuable(true);
	        _this.fetchCollaborationSkills(true);
	        _this.fetchSpotlightInsightsCheck();
	        _this.fetchInstructorBadgeState();
	      });
	    };
	
	    _this.findEvalSurveys = function () {
	      var surveys = _this.state.allSurveys || [];
	      if (surveys.length < 2) return { initial: null, final: null };
	
	      var stageOf = function stageOf(s) {
	        return String(s.stage_name || s.stage || "").toLowerCase();
	      };
	      var isFinalStage = function isFinalStage(stage) {
	        return stage === "second" || stage === "final";
	      };
	      var initialTagged = surveys.filter(function (s) {
	        return stageOf(s) === "initial";
	      });
	      var finalTagged = surveys.filter(function (s) {
	        return isFinalStage(stageOf(s));
	      });
	
	      if (initialTagged.length === 1 && finalTagged.length === 1 && initialTagged[0].id !== finalTagged[0].id) {
	        return { initial: initialTagged[0], final: finalTagged[0] };
	      }
	
	      var sorted = surveys.slice().sort(function (a, b) {
	        var aTime = new Date(a.end || a.start || a.start_date || 0).getTime();
	        var bTime = new Date(b.end || b.start || b.start_date || 0).getTime();
	        return aTime - bTime;
	      });
	      var initial = sorted[0];
	      var final = sorted[sorted.length - 1];
	      if (initial.id === final.id) return { initial: null, final: null };
	      return { initial: initial, final: final };
	    };
	
	    _this.isSurveyFinished = function (survey) {
	      var currentDate = _moment2.default.utc();
	
	      return !(currentDate.isSameOrAfter((0, _moment2.default)(survey.start)) && currentDate.isSameOrBefore((0, _moment2.default)(survey.end)));
	    };
	
	    _this.isSurveyReallyFinished = function (survey) {
	      var currentDate = _moment2.default.utc();
	
	      return currentDate.isAfter((0, _moment2.default)(survey.end));
	    };
	
	    _this.fetchPerformanceMetrics = function () {
	      var _this$state18 = _this.state,
	          currentRound = _this$state18.currentRound,
	          currentGame = _this$state18.currentGame,
	          rounds = _this$state18.rounds;
	
	      // Target round for the Team Scores KPI: honor the sidebar's
	      // ?round=N first so the tile reflects what the instructor has
	      // selected, not whichever round updateCurrentRound landed on
	      // (which falls back to the latest closed round when roundInUrl
	      // points at a round that isn't in the finished list). Fall back
	      // to state.currentRound when roundInUrl is missing or doesn't
	      // resolve to a round in the current game.
	
	      var roundInUrl = Number(_this.props.roundInUrl) || 0;
	      var urlRoundRecord = roundInUrl > 0 && Array.isArray(rounds) ? rounds.find(function (r) {
	        return r.number === roundInUrl && r.game === currentGame;
	      }) : null;
	      var targetRoundId = urlRoundRecord ? urlRoundRecord.id : currentRound;
	      if (!targetRoundId || targetRoundId <= 0) return;
	
	      // Team Scores only reflects CLOSED rounds. For live or
	      // not-yet-started rounds the teamgradings/overall endpoint
	      // tends to carry over the prior round's grade as a placeholder
	      // (same reason the Final Scores page hides live-round columns —
	      // commit 04a7e7e0). Blank the state so the tile renders "—"
	      // via formatScorePct and skip the request so the console
	      // doesn't show a stale/misleading call.
	      var targetRoundRecord = urlRoundRecord || (rounds || []).find(function (r) {
	        return r.id === targetRoundId;
	      });
	      if (!targetRoundRecord || targetRoundRecord.is_finished !== true) {
	        _this.setState({
	          averageTeamGrade: 0,
	          medianTeamGrade: 0,
	          standardDeviation: 0,
	          leaderboard: [],
	          leaderboardLoading: false
	        });
	        return;
	      }
	
	      // Use consolidated team-grading API
	      var sq = _this.sectionsQueryParam();
	      (0, _ApiService.getRequest)(TEAM_GRADING_API + "?round_id=" + targetRoundId + "&scope=dashboard" + (sq ? "&" + sq : "")).then(function (res) {
	        var _res$body4 = res.body,
	            overall_stats = _res$body4.overall_stats,
	            gradings = _res$body4.gradings;
	
	
	        _this.setState({
	          averageTeamGrade: overall_stats ? overall_stats.average_team_grade : 0,
	          medianTeamGrade: overall_stats ? overall_stats.median_team_grade : 0,
	          standardDeviation: overall_stats ? overall_stats.standard_deviation : 0,
	          leaderboard: gradings || [],
	          leaderboardLoading: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.setRoundValue = function (callback) {
	      _this.setState({
	        setRoundValue: callback
	      }, function () {
	        _this.updateCurrentRound();
	      });
	    };
	
	    _this.setSurveyValue = function (callback) {
	      _this.setState({
	        setSurveyValue: callback
	      }, function () {
	        var setSurveyValue = _this.state.setSurveyValue;
	
	        var surveys = _this.surveys;
	
	        if (surveys.length > 0) {
	          setSurveyValue(surveys[surveys.length - 1]);
	        }
	      });
	    };
	
	    _this.setPlayerValue = function (callback) {
	      _this.setState({
	        setPlayerValue: callback
	      });
	    };
	
	    _this.updateCurrentRound = function () {
	      var setRoundValue = _this.state.setRoundValue;
	
	      var rounds = _this.rounds;
	
	      // With the round-selector dropdown removed from the dashboard,
	      // setRoundValue is no longer registered, so route through
	      // selectRound directly to make sure currentRound + the dependent
	      // fetches (leaderboard, performance, engagement) still fire on
	      // initial load.
	      if (typeof setRoundValue === "function") {
	        if (rounds.length > 0) {
	          setRoundValue(rounds[rounds.length - 1]);
	        } else {
	          setRoundValue(null);
	        }
	        return;
	      }
	
	      if (rounds.length === 0) return;
	
	      // Honor the URL's ?round=N (LeftBar Year selector) when present
	      // and it matches one of the finished rounds; otherwise fall back
	      // to the latest finished round.
	      var roundInUrl = Number(_this.props.roundInUrl) || 0;
	      var targetLabel = "Round " + roundInUrl;
	      var preferred = roundInUrl > 0 && rounds.includes(targetLabel) ? targetLabel : rounds[rounds.length - 1];
	      _this.selectRound(preferred);
	    };
	
	    _this.sectionsQueryParam = function () {
	      // user.sections is the authoritative "sections this instructor can
	      // see" list. If it's empty, the course either has no sections at
	      // all OR the instructor has none assigned — in both cases the
	      // dashboard GETs shouldn't carry a sections filter (BE will return
	      // the course-wide aggregate, which is what we want).
	      //
	      // Lead instructors (covers_all_sections === true) also get no
	      // sections query. BE's handling of `?sections=all` wasn't
	      // returning course-wide aggregates on several endpoints (notably
	      // /app/team-grading/), blanking the Team Scores tile and other
	      // KPIs. Omitting the query lets BE's default (no filter) kick in,
	      // which is semantically what a lead instructor wants anyway.
	      var user = _Auth2.default.getUser() || {};
	      var raw = Array.isArray(user.sections) ? user.sections : [];
	      var ids = raw.map(function (s) {
	        return s && (typeof s === "undefined" ? "undefined" : _typeof(s)) === "object" ? s.id : s;
	      }).filter(function (id) {
	        return id != null && id !== "";
	      });
	      if (ids.length === 0) return "";
	      var cm = (_this.props.courseMembers || [])[0];
	      if (cm && cm.covers_all_sections === true) return "";
	      return "sections=" + ids.join(",");
	    };
	
	    _this.canGenerateInsights = function () {
	      // Who can generate insights:
	      //
	      // Lead instructor (position === "Instructor") passes under any of
	      // three signals that they own the whole course:
	      //   1. user.sections is empty — not scoped to any specific
	      //      section, treated as full-course lead.
	      //   2. course_members[0].covers_all_sections === true — the BE
	      //      flag that explicitly flags them as covering every section.
	      //   3. course_members[0].section_student_count ===
	      //      course_members[0].student_count (and > 0) — their section
	      //      scope reaches every student in the course, so they are
	      //      effectively assigned to every section even if the
	      //      covers_all_sections flag is stale (observed on walshcm4 /
	      //      course 266 and Odom-Dull / course 265).
	      //
	      // Co-Instructor OR Instructor Assistant passes only when
	      // course_members[0].covers_all_sections === true. We intentionally
	      // do NOT infer their scope from student counts: the one-shot
	      // generation shouldn't be fire-able by a section-scoped assistant
	      // whose section happens to cover everyone on paper.
	      var authUser = _Auth2.default.getUser() || {};
	      var cm = (_this.props.courseMembers || [])[0];
	
	      if (authUser.position === "Instructor") {
	        var hasSectionAssignments = Array.isArray(authUser.sections) && authUser.sections.length > 0;
	        if (!hasSectionAssignments) return true;
	        if (cm && cm.covers_all_sections === true) return true;
	        var sectionCount = cm ? Number(cm.section_student_count) : 0;
	        var totalCount = cm ? Number(cm.student_count) : 0;
	        if (totalCount > 0 && sectionCount === totalCount) return true;
	        return false;
	      }
	
	      var coversAll = cm && cm.covers_all_sections === true;
	      if (_Auth2.default.isAssistantOrCoInstructor() && coversAll) return true;
	      return false;
	    };
	
	    _this.teamDynamicsSelectTeam = function (value) {
	      _this.setState({
	        teamDynamicsCurrentTeam: value,
	        teamDynamicsCurrentPlayer: 0,
	        players: null,
	        isPlayersLoading: true
	      }, function () {
	        _this.fetchPlayers();
	      });
	    };
	
	    _this.popupSelectPlayer = function (value) {
	      _this.setState({
	        teamDynamicsCurrentPlayer: parseInt(value, 10),
	        reports: {},
	        userScoreReports: {},
	        isReportsLoading: true
	      }, function () {
	        var _this$state19 = _this.state,
	            surveys = _this$state19.surveys,
	            teamDynamicsCurrentPlayer = _this$state19.teamDynamicsCurrentPlayer;
	
	        var finishedSurveys = surveys ? surveys.filter(function (survey) {
	          return _this.isSurveyFinished(survey);
	        }) : [];
	
	        _this.loadReports(finishedSurveys, teamDynamicsCurrentPlayer);
	        _this.loadUserScoreReports(finishedSurveys, teamDynamicsCurrentPlayer);
	      });
	    };
	
	    _this.loadUserScoreReports = function (surveys, receiver_id) {
	      var requests = surveys.filter(function (s) {
	        return _this.isSurveyReallyFinished(s);
	      }).map(function (_ref7) {
	        var survey_id = _ref7.id;
	        return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/surveys/" + survey_id + "/user-score/" + receiver_id + "/", function (res) {
	          return res.status === 200 || res.status === 404;
	        });
	      });
	      var stages = surveys.reduce(function (result, _ref8) {
	        var survey_id = _ref8.id,
	            stage = _ref8.stage;
	        return Object.assign({}, result, _defineProperty({}, survey_id, stage));
	      }, {});
	
	      Promise.all(requests).then(function (responses) {
	        var getSurveyIdFromUrl = function getSurveyIdFromUrl(url) {
	          var tmp = url.split('/');
	
	          return tmp[tmp.length - 4];
	        };
	
	        return responses.map(function (res) {
	          return {
	            body: res.body,
	            stage: stages[getSurveyIdFromUrl(res.req.url)]
	          };
	        });
	      }).then(function (responses) {
	        var userScoreReports = responses.reduce(function (result, _ref9) {
	          var body = _ref9.body,
	              stage = _ref9.stage;
	          return body.detail && body.detail === 'Not found.' ? result : Object.assign({}, result, _defineProperty({}, stage, body));
	        }, {});
	
	        _this.setState({
	          userScoreReports: userScoreReports
	        });
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	
	    _this.loadReports = function (surveys, receiver_id) {
	      var requests = surveys.filter(function (s) {
	        return _this.isSurveyReallyFinished(s);
	      }).map(function (_ref10) {
	        var survey_id = _ref10.id;
	        return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/score/" + receiver_id + "/" + survey_id + "/", function (res) {
	          return res.status === 200 || res.status === 404;
	        });
	      });
	      var stages = surveys.reduce(function (result, _ref11) {
	        var survey_id = _ref11.id,
	            stage = _ref11.stage;
	        return Object.assign({}, result, _defineProperty({}, survey_id, stage));
	      }, {});
	
	      Promise.all(requests).then(function (responses) {
	        var getSurveyIdFromUrl = function getSurveyIdFromUrl(url) {
	          var tmp = url.split("/");
	
	          return tmp[tmp.length - 2];
	        };
	
	        var prepareResponseBody = function prepareResponseBody(res) {
	          var body = res.body;
	          if (!body.average_user_score) {
	            body.average_user_score = 0;
	          }
	
	          if (!body.team_average_score) {
	            body.team_average_score = 0;
	          }
	
	          if (!body.team_median_score) {
	            body.team_median_score = 0;
	          }
	
	          return body;
	        };
	
	        return responses.map(function (res) {
	          return {
	            body: prepareResponseBody(res),
	            stage: stages[getSurveyIdFromUrl(res.req.url)]
	          };
	        });
	      }).then(function (responses) {
	        var reports = responses.reduce(function (result, _ref12) {
	          var body = _ref12.body,
	              stage = _ref12.stage;
	          return body.detail && body.detail === 'Not found.' ? result : Object.assign({}, result, _defineProperty({}, stage, body));
	        }, {});
	
	        _this.setState({
	          reports: reports,
	          isReportsLoading: false
	        });
	      }).catch(function (err) {
	        _this.setState({
	          isReportsLoading: false
	        });
	      });
	    };
	
	    _this.loadReport = function () {
	      var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref13, receiver_id) {
	        var survey_id = _ref13.id,
	            stage = _ref13.stage;
	
	        var _ref15, report, reports;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/forms/score/" + receiver_id + "/" + survey_id + "/");
	
	              case 2:
	                _ref15 = _context.sent;
	                report = _ref15.body;
	                reports = _this.state.reports;
	
	
	                _this.setState({
	                  reports: Object.assign({}, reports, _defineProperty({}, stage, report))
	                });
	
	              case 6:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref14.apply(this, arguments);
	      };
	    }();
	
	    _this.fetchPlayers = function () {
	      var teamDynamicsCurrentTeam = _this.state.teamDynamicsCurrentTeam;
	
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "teams/" + teamDynamicsCurrentTeam + "/players/").then(function (res) {
	        _this.setState({
	          players: res.body.filter(function (player) {
	            return "user" in player;
	          }).map(function (player) {
	            return player.user;
	          }),
	          isPlayersLoading: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.changeSortOrder = function (key) {
	      var _this$state20 = _this.state,
	          sortKey = _this$state20.sortKey,
	          sortOrder = _this$state20.sortOrder;
	
	
	      var newSortKey = sortKey;
	      var newSortOrder = sortOrder;
	
	      if (newSortKey !== key) {
	        newSortKey = key;
	        newSortOrder = "asc";
	      } else {
	        newSortOrder = newSortOrder === "asc" ? "desc" : "asc";
	      }
	
	      _this.setState({
	        sortKey: newSortKey,
	        sortOrder: newSortOrder
	      });
	    };
	
	    _this.getClassRankings = function (items) {
	      var values = Object.keys((0, _groupBy2.default)(items, "weighted_value"));
	      var result = {};
	      var counter = 0;
	      values.forEach(function (value) {
	        counter++;
	        result[value] = counter;
	      });
	
	      return result;
	    };
	
	    _this.getTeamName = function (teams, team_id) {
	      var team = teams.find(function (i) {
	        return i.id === team_id;
	      });
	
	      return team ? team.name : "";
	    };
	
	    _this.getDetailsLink = function (team_id, round_number, game_id) {
	      return "/analysis/team-reports?team_id=" + team_id + "&round=" + round_number + "&game_id=" + game_id + "&_token=" + _Auth2.default.getToken() + "&_userid=" + _Auth2.default.getUserId() + "&_courseid=" + _Auth2.default.getCourseId();
	    };
	
	    _this.formatScorePct = function (value) {
	      if (value == null || !Number.isFinite(value)) return "—";
	      return (value * 100).toFixed(2) + "%";
	    };
	
	    _this.hideError = function () {
	      _this.setState({
	        showError: false
	      });
	    };
	
	    _this.onStudentStatMouseEnter = function () {
	      _this.setState({
	        showStudentStatError: true
	      });
	    };
	
	    _this.onStudentStatMouseLeave = function () {
	      _this.setState({
	        showStudentStatError: false
	      });
	    };
	
	    _this.isPerfFeedbackCategoryRelevant = function (category) {
	      var t = (_this.state.gamesTargets || [])[0];
	      if (!t) return false;
	      var nz = function nz(v) {
	        return Number(v || 0) !== 0;
	      };
	      switch (category) {
	        case "marketShare":
	          return nz(t.market_share);
	        case "revenues":
	          return nz(t.net_revenues);
	        case "grossMargins":
	          return nz(t.gross_margin);
	        case "sharePrice":
	          return nz(t.stock_price);
	        // "Falling Short on Profit…" theme. All four member pages
	        // (net-loss + roe/roa/eps enough-profits) share this category
	        // and surface when ANY of roe / roa / earnings_per_share is a
	        // target for the round (value > 0). If none of the three are
	        // targets, the theme is excluded from the dashboard list.
	        case "profitTrio":
	          return nz(t.roe) || nz(t.roa) || nz(t.earnings_per_share);
	        default:
	          return false;
	      }
	    };
	
	    _this.state = {
	      perfFeedbackSearch: "",
	      perfFeedbackSearchSubmitted: "",
	      perfFeedbackActiveIndex: null,
	      collabInsightsSearch: "",
	      performanceFeedbacksGame: [],
	      gamesTargets: [],
	      mostValuablePlayers: [],
	      leastValuablePlayers: [],
	      mostLeastValuableLoading: false,
	      collaborationStrengths: [],
	      collaborationWeaknesses: [],
	      collaborationILikeTotal: 0,
	      collaborationIWishTotal: 0,
	      collaborationSkillsLoading: false,
	      collaborationSkillsTab: "strengths",
	      collabPopupOpen: false,
	      // Skills Certificate popup
	      certificateOpen: false,
	      certificateUserId: null,
	      certificateStudentName: '',
	      // Which cohort the student came from — drives the pill label
	      // ("Most Valuable Teammate" / "Well Rounded Teammate" /
	      // "Market Master") in SkillsBadgePopup. Nullable; null falls
	      // back to the default label.
	      certificateCategory: null,
	      certificateData: null,
	      certificateLoading: false,
	      certificateError: null,
	      // Areas of Improvement (Insights) popup
	      insightsOpen: false,
	      insightsUserId: null,
	      insightsStudentName: '',
	      insightsData: null,
	      insightsLoading: false,
	      insightsError: null,
	      // Student Spotlight: gate the lists on whether per-survey
	      // insights have been generated. null = haven't checked yet,
	      // true/false = check completed.
	      studentSpotlightHasInsights: null,
	      studentSpotlightCheckLoading: false,
	      studentSpotlightGenerating: false,
	      studentSpotlightGenerateMessage: null,
	      studentSpotlightConfirmOpen: false,
	      // Student Spotlight team filter: multi-select by team_name.
	      // Empty array = show every team in the (section-scoped) response.
	      spotlightTeamFilter: [],
	      spotlightTeamFilterOpen: false,
	      // Insights job polling — populated after POST /insights/generate/
	      // returns 202. jobId is stored for debugging; statusUrl is the
	      // authoritative pointer used for polling.
	      insightsJobId: null,
	      insightsStatusUrl: null,
	      // Instructor's per-survey badge consent state, from
	      // GET /badges/survey/<survey_id>/status/ → my_instructor_state.
	      // "pending" | "confirmed" | "declined" | null (not yet fetched).
	      // Only meaningful for final-stage surveys.
	      myInstructorBadgeState: null,
	      // Intro popup ("skills insights are ready to review") auto-appears
	      // when all badge gates pass. Continue → tour. Not Sure Yet in the
	      // tour flips this flag to suppress the intro popup for the rest
	      // of the session (until a refresh/navigation resets state).
	      badgesIntroSuppressed: false,
	      // Badges consent tour overlay — dims the page except topbar +
	      // Student Spotlight MVP block, shows the consent message with
	      // Approve / Decline / Not Sure Yet. Opened by the intro popup's
	      // Continue button.
	      badgesTourOpen: false,
	      // Nested modal that shows the sample email that would be sent
	      // to students. Opened from a link inside the tour popup body.
	      badgesEmailPreviewOpen: false,
	      // Sample email body from GET /insights/class/<c>/<s>/
	      // (`badges_student_email_preview`). Populated alongside the
	      // consent message in openBadgesTour.
	      badgesStudentEmailPreview: null,
	      badgesConsentMessage: null,
	      badgesConsentLoading: false,
	      badgesBatchSubmitting: false,
	      badgesActionError: null,
	      // Class-wide badge recipient count (unique users across
	      // most_valuable + well_rounded + market_masters) across every
	      // section. The Review and Issue consent text shows class-wide
	      // numbers so an instructor who only covers one section still
	      // sees the student's placement in the entire course. Fetched
	      // alongside the consent message in openBadgesTour.
	      classWideBadgeRecipientCount: null,
	      // Nested checklist popup opened from the tour popup's primary
	      // button. Lists every qualifying student with a checkbox so the
	      // instructor can un-select any before POSTing to batch-confirm.
	      // badgesSelectedIds is a Set of user_ids; initialized to the
	      // full mostValuablePlayers set the moment the popup opens.
	      badgesReviewOpen: false,
	      badgesSelectedIds: null,
	      // Team Lookup modal (KPI row card + ⌘K shortcut)
	      teamLookupOpen: false,
	      teamLookupStep: 1,
	      teamLookupQuery: "",
	      teamLookupHighlightIdx: 0,
	      teamLookupSelectedTeam: null,
	      teamLookupRows: [],
	      teamLookupLoading: false,
	      teamLookupError: null,
	      teamLookupCacheRoundId: null,
	      teamLookupCacheTime: 0,
	      courses: null,
	      games: null,
	      rounds: null,
	      currentGame: 0,
	      currentCourse: 0,
	      currentRound: 0,
	      setRoundValue: null,
	      averageTeamGrade: 0,
	      medianTeamGrade: 0,
	      standardDeviation: 0,
	      teams: null,
	      surveys: null,
	      allSurveys: null,
	      surveysError: null,
	      currentSurvey: 0,
	      setSurveyValue: null,
	      teamScore: null,
	      showTeamDynamicsModal: false,
	      teamDynamicsModalTitle: "",
	      teamDynamicsTeamsList: [],
	      teamDynamicsCurrentTeam: 0,
	      teamDynamicsHideDropdowns: false,
	      players: null,
	      teamDynamicsCurrentPlayer: 0,
	      setPlayerValue: null,
	      reports: {},
	      userScoreReports: {},
	      countOfCourseMembers: 0,
	      // "Not registered yet" affordance under the Student Count KPI
	      // tile. count/list are populated from GET /v2/games/coursemembers/
	      // ?not-registered&course=<id>. Popup opens when the instructor
	      // clicks the small subtext link, so they can email the students
	      // who haven't signed up yet.
	      notRegisteredCount: 0,
	      notRegisteredList: [],
	      notRegisteredLoading: false,
	      notRegisteredPopupOpen: false,
	      notRegisteredCopied: false,
	      // Team Decisions Status KPI. count/teamIds come from GET
	      // /v2/games/games/<gameId>/rounds/<roundId>/
	      // team-decisions-not-submitted/ with teams whose only missing
	      // item is "negative_cash" filtered out (BE flags over-aggressive
	      // submissions but the instructor doesn't need to chase cash-
	      // only cases). Popup renders team names resolved via state.teams.
	      pendingDecisionsCount: 0,
	      pendingDecisionsTeamIds: [],
	      pendingDecisionsLoading: false,
	      pendingDecisionsPopupOpen: false,
	      // Filter typed into the popup's search box. Reset when the
	      // popup opens so each session starts clean.
	      pendingDecisionsFilter: '',
	      leaderboard: [],
	      leaderboardLoading: true,
	      leaderboardFileData: [],
	      leaderboardFileDownloading: false,
	      sortKey: "classRanking",
	      sortOrder: "asc",
	      isReportsLoading: false,
	      isPlayersLoading: false,
	      competitions: null,
	      showStudentStats: false,
	      studentStatsLoading: false,
	      engagementDownloadRequest: null,
	      engagementDownloadCount: 0,
	      engagementDownloadFile: null,
	      teamDynamicsDownloadRequest: null,
	      teamDynamicsDownloadCount: 0,
	      teamDynamicsDownloadFile: null,
	      performanceDownloadRequest: null,
	      performanceDownloadCount: 0,
	      performanceDownloadFile: null,
	      showPerformanceDowload: true,
	      showError: false,
	      hasUserScores: false,
	      showStudentStatError: false,
	      processResultsFailed: false
	    };
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Gate on props.game being populated (set by App.js once
	      // general-info responds), not on rounds.length — a brand-new
	      // course with zero rounds still needs the dashboard to load.
	      if (this.props.game && !this._hasFetched) {
	        this.fetchData();
	      }
	
	      // Global ⌘K (Mac) / Ctrl+K (Win) opens the Team Lookup modal.
	      if (typeof window !== "undefined") {
	        window.addEventListener("keydown", this.handleGlobalKeydown);
	        // Close the Student Spotlight team filter when the instructor
	        // clicks anywhere outside the dropdown. Listener runs for the
	        // whole page lifetime but is a cheap no-op when the dropdown
	        // isn't open.
	        document.addEventListener("mousedown", this.handleSpotlightFilterOutsideClick);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (typeof window !== "undefined") {
	        window.removeEventListener("keydown", this.handleGlobalKeydown);
	        document.removeEventListener("mousedown", this.handleSpotlightFilterOutsideClick);
	      }
	      if (this._collabCloseTimer) {
	        clearTimeout(this._collabCloseTimer);
	        this._collabCloseTimer = null;
	      }
	      this._stopInsightsPoll();
	    }
	
	    // Click-outside handler for the Student Spotlight filter dropdown.
	
	
	    // Student Spotlight filter + presentation helpers. All derive from
	    // the already-fetched mostValuablePlayers / leastValuablePlayers
	    // state, which is section-scoped by fetchMostLeastValuable.
	
	
	    // Natural sort by team_name ascending, so "Team 2" lands before
	    // "Team 10". Rows without a team_name fall to the bottom.
	
	
	    // Unique team names in the current MVP + LVP data, sorted naturally.
	    // Drives the filter dropdown options.
	
	
	    // Collaboration Insights hover popup. The popup card is fixed and
	    // centered, so it can overlap the chart area on entry — that flips
	    // the cursor target from ChartHoverArea to PopupCard mid-motion and
	    // would fire mouseleave on the chart, snapping the popup shut. We
	    // debounce the close and let the popup card cancel it on enter so
	    // motion between the two zones is treated as a single hover.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.game && this.props.game && !this._hasFetched) {
	        this.fetchData();
	        return;
	      }
	
	      // React to the global Year selector (LeftBar) — it pushes the
	      // chosen round number into the URL as ?round=N, which App.js
	      // forwards down as props.roundInUrl. Without this hook the
	      // dashboard would stay on the latest finished round forever and
	      // every per-round fetch (targets, performancefeedbacks, leaderboard,
	      // engagement) would keep firing for the wrong round.
	      var prevRoundInUrl = Number(prevProps.roundInUrl) || 0;
	      var nextRoundInUrl = Number(this.props.roundInUrl) || 0;
	      if (nextRoundInUrl > 0 && nextRoundInUrl !== prevRoundInUrl) {
	        var currentRoundNumber = this.roundNumber;
	        if (nextRoundInUrl !== currentRoundNumber) {
	          this.selectRound("Round " + nextRoundInUrl);
	        }
	      }
	
	      // Decision Submission Status: refetch when the active round or
	      // game changes. Covers the case where App.js resolves game +
	      // currentRound after this component mounts, so the selectGame
	      // chain missed firing with both values available.
	      var prevGameId = prevProps.game && Number(prevProps.game.id);
	      var nextGameId = this.props.game && Number(this.props.game.id);
	      var prevCurrentRound = Number(prevProps.currentRound) || 0;
	      var nextCurrentRound = Number(this.props.currentRound) || 0;
	      var gameChanged = nextGameId && nextGameId !== prevGameId;
	      var roundChanged = nextCurrentRound && nextCurrentRound !== prevCurrentRound;
	      if (nextGameId && nextCurrentRound && (gameChanged || roundChanged)) {
	        this.fetchPendingDecisions();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          averageTeamGrade = _state.averageTeamGrade,
	          medianTeamGrade = _state.medianTeamGrade,
	          standardDeviation = _state.standardDeviation,
	          teams = _state.teams,
	          showTeamDynamicsModal = _state.showTeamDynamicsModal,
	          teamDynamicsModalTitle = _state.teamDynamicsModalTitle,
	          teamDynamicsTeamsList = _state.teamDynamicsTeamsList,
	          teamDynamicsCurrentTeam = _state.teamDynamicsCurrentTeam,
	          players = _state.players,
	          teamDynamicsCurrentPlayer = _state.teamDynamicsCurrentPlayer,
	          setPlayerValue = _state.setPlayerValue,
	          reports = _state.reports,
	          userScoreReports = _state.userScoreReports,
	          surveys = _state.surveys,
	          allSurveys = _state.allSurveys,
	          surveysError = _state.surveysError,
	          currentGame = _state.currentGame,
	          currentSurvey = _state.currentSurvey,
	          countOfCourseMembers = _state.countOfCourseMembers,
	          currentRound = _state.currentRound,
	          isReportsLoading = _state.isReportsLoading,
	          isPlayersLoading = _state.isPlayersLoading,
	          teamDynamicsHideDropdowns = _state.teamDynamicsHideDropdowns,
	          showStudentStats = _state.showStudentStats,
	          studentStatsLoading = _state.studentStatsLoading,
	          engagementDownloadRequest = _state.engagementDownloadRequest,
	          teamDynamicsDownloadRequest = _state.teamDynamicsDownloadRequest,
	          performanceDownloadRequest = _state.performanceDownloadRequest,
	          showPerformanceDowload = _state.showPerformanceDowload,
	          hasUserScores = _state.hasUserScores,
	          showError = _state.showError,
	          rounds = _state.rounds,
	          showStudentStatError = _state.showStudentStatError,
	          processResultsFailed = _state.processResultsFailed;
	      var isMenuExpanded = this.props.isMenuExpanded;
	
	
	      if (this.isLoading === true) {
	        return _react2.default.createElement(
	          _dashboard2.default.Body,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        );
	      }
	
	      var roundNumber = this.roundNumber;
	
	      var emptySurveys = !allSurveys || allSurveys.length === 0;
	      var activeSurvey = allSurveys ? allSurveys.find(function (i) {
	        return i.id === currentSurvey;
	      }) : null;
	      var activeSurveyFinished = activeSurvey ? this.isSurveyFinished(activeSurvey) : false;
	
	      var survey = surveys ? surveys.find(function (i) {
	        return i.id === currentSurvey;
	      }) : null;
	      var currentSurveyName = survey ? survey.name : null;
	
	      var selectedRound = rounds.find(function (round) {
	        return round.id === currentRound;
	      });
	      var selectedRoundFinished = selectedRound ? selectedRound.is_finished : false;
	
	      return _react2.default.createElement(
	        _dashboard2.default.Body,
	        null,
	        _react2.default.createElement(_InstructorSurveyReadyNotification2.default, {
	          allSurveys: allSurveys,
	          courseMembers: this.props.courseMembers
	        }),
	        showError && _react2.default.createElement(_error2.default, {
	          title: "Round is still live!",
	          message: "Round has not ended yet.",
	          onHide: this.hideError
	        }),
	        showStudentStats && _react2.default.createElement(_studentStatsPopup2.default, {
	          show: showStudentStats,
	          onHide: this.hideStudentStats,
	          loading: studentStatsLoading,
	          setLoadingState: this.setStudentsStatsLoading,
	          roundId: currentRound,
	          roundNumber: roundNumber,
	          gameId: currentGame,
	          survey: survey,
	          reports: reports ? reports : {},
	          selectPlayer: this.popupSelectPlayer
	        }),
	        _react2.default.createElement(_teamDynamicsPopup2.default, {
	          show: showTeamDynamicsModal,
	          onHide: this.hideTeamDynamicsModal,
	          teams: teamDynamicsTeamsList,
	          title: teamDynamicsModalTitle,
	          currentTeam: teamDynamicsCurrentTeam,
	          selectTeam: this.teamDynamicsSelectTeam,
	          players: players ? players : [],
	          currentPlayer: teamDynamicsCurrentPlayer,
	          selectPlayer: this.popupSelectPlayer,
	          setPlayerValue: setPlayerValue,
	          setPlayerValueCallback: this.setPlayerValue,
	          reports: reports ? reports : {},
	          userScoreReports: userScoreReports ? userScoreReports : {},
	          surveys: surveys ? surveys : [],
	          allTeams: teams,
	          isSurveyFinished: this.isSurveyFinished,
	          currentSurvey: currentSurvey,
	          isReportsLoading: isReportsLoading,
	          isPlayersLoading: isPlayersLoading,
	          hideDropdowns: teamDynamicsHideDropdowns
	        }),
	        _react2.default.createElement(
	          _dashboard2.default.Title,
	          null,
	          "Snapshot of Class Performance"
	        ),
	        function () {
	          // Team Scores KPI reads BE-provided aggregates from
	          // /app/team-grading/ (`overall_stats.average_team_grade` /
	          // `.median_team_grade`) via state. This lets the dashboard
	          // scope drop `gradings[]` from the payload without breaking
	          // the tile. `teamScoreStats` (which iterates gradings rows)
	          // is kept for potential reuse elsewhere.
	          var meanFromState = _this3.state.averageTeamGrade;
	          var medianFromState = _this3.state.medianTeamGrade;
	          var mean = Number.isFinite(meanFromState) && meanFromState !== 0 ? meanFromState : null;
	          var median = Number.isFinite(medianFromState) && medianFromState !== 0 ? medianFromState : null;
	          var studentCount = _this3.state.countOfCourseMembers || 0;
	          var tCount = _this3.teamCount;
	          var hasFinishedRound = (rounds || []).some(function (r) {
	            return r.is_finished === true;
	          });
	          var teamScoresTip = (rounds || []).length === 0 ? "Team scores will be available after the first round ends." : "Team scores will be available once the current round ends.";
	          return _react2.default.createElement(
	            _dashboard2.default.KpiRow,
	            null,
	            _react2.default.createElement(
	              _dashboard2.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.KpiHeader,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.KpiLabel,
	                  null,
	                  "Team Scores"
	                ),
	                hasFinishedRound ? _react2.default.createElement(
	                  _dashboard2.default.KpiLink,
	                  { href: "/instructor/final-scores" },
	                  "view details"
	                ) : _react2.default.createElement(
	                  _dashboard2.default.KpiLinkDisabledWrap,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiLinkDisabled,
	                    null,
	                    "view details"
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiLinkDisabledTip,
	                    null,
	                    teamScoresTip
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.KpiValueRow,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.KpiMicroPair,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroLabel,
	                    null,
	                    "Mean"
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroValue,
	                    null,
	                    _this3.formatScorePct(mean)
	                  )
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.KpiMicroPair,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroLabel,
	                    null,
	                    "Median"
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroValue,
	                    null,
	                    _this3.formatScorePct(median)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.KpiHeader,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.KpiLabel,
	                  null,
	                  "Class Roster"
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.KpiValueRow,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.KpiMicroPair,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroLabel,
	                    null,
	                    "Students"
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroValue,
	                    null,
	                    studentCount
	                  )
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.KpiMicroPair,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroLabel,
	                    null,
	                    "Teams"
	                  ),
	                  _react2.default.createElement(
	                    _dashboard2.default.KpiMicroValue,
	                    null,
	                    tCount
	                  )
	                )
	              ),
	              _this3.state.notRegisteredCount > 0 && _react2.default.createElement(
	                NotRegisteredLink,
	                {
	                  type: "button",
	                  onClick: _this3.openNotRegisteredPopup,
	                  "aria-label": "View " + _this3.state.notRegisteredCount + " students not yet registered"
	                },
	                _this3.state.notRegisteredCount,
	                " student",
	                _this3.state.notRegisteredCount === 1 ? '' : 's',
	                " not registered yet"
	              )
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.KpiCard,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.KpiHeader,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.KpiLabel,
	                  null,
	                  "Decision Submission Status"
	                )
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.KpiValue,
	                null,
	                _this3.state.pendingDecisionsCount
	              ),
	              _this3.state.pendingDecisionsCount > 0 && function () {
	                // Resolve whether the round the KPI is counting against
	                // is still active or has already ended. props.currentRound
	                // is the round NUMBER (the in-progress round the dashboard
	                // tracks); look it up in rounds[] to read its is_finished
	                // flag. If the round can't be resolved (edge case on first
	                // mount), default to the "round active" copy — matches the
	                // historical behavior where the live-round KPI drove this
	                // card.
	                var liveRoundNumber = Number(_this3.props.currentRound) || 0;
	                var liveRound = (rounds || []).find(function (r) {
	                  return r && Number(r.number) === liveRoundNumber;
	                });
	                var roundEnded = !!(liveRound && liveRound.is_finished);
	                var count = _this3.state.pendingDecisionsCount;
	                var isOne = count === 1;
	                var text = roundEnded ? isOne ? count + " team did not submit their decisions." : count + " teams did not submit their decisions." : isOne ? count + " team has not submitted their decisions yet." : count + " teams have not submitted their decisions yet.";
	                return _react2.default.createElement(
	                  NotRegisteredLink,
	                  {
	                    type: "button",
	                    onClick: _this3.openPendingDecisionsPopup,
	                    "aria-label": text
	                  },
	                  text
	                );
	              }()
	            ),
	            function () {
	              var isMac = typeof window !== "undefined" && /Mac|iPhone|iPad/.test(window.navigator.platform);
	              var cmdLabel = isMac ? "⌘" : "Ctrl";
	              return _react2.default.createElement(
	                _dashboard2.default.TeamLookup.Card,
	                {
	                  type: "button",
	                  "aria-keyshortcuts": "Meta+K Control+K",
	                  "aria-label": "Look up a team",
	                  onClick: function onClick() {
	                    return _this3.openTeamLookup();
	                  }
	                },
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.CardHeader,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.TeamLookup.CardIcon,
	                    { "aria-hidden": true },
	                    "\uD83D\uDD0D"
	                  ),
	                  "Look up a team",
	                  _react2.default.createElement(
	                    _dashboard2.default.TeamLookup.CardShortcut,
	                    null,
	                    cmdLabel,
	                    " K"
	                  )
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.CardInputMock,
	                  null,
	                  "Search by team name\u2026"
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.TeamLookup.CardHelper,
	                  null,
	                  "Access audit trail or team report"
	                )
	              );
	            }()
	          );
	        }(),
	        _react2.default.createElement(
	          _dashboard2.default.Flex,
	          { isMenuExpanded: isMenuExpanded },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _dashboard2.default.Row,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.Block,
	                { isMenuExpanded: isMenuExpanded, fullWidth: true },
	                _react2.default.createElement(
	                  _dashboard2.default.BlockTitle,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.PerfFeedbackTitleWrap,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.PerfFeedbackTitle,
	                      null,
	                      "Critical Thinking Insights"
	                    ),
	                    _react2.default.createElement(
	                      _dashboard2.default.PerfFeedbackSubtitle,
	                      null,
	                      "Why Teams Didn't Hit Their Targets"
	                    )
	                  ),
	                  _react2.default.createElement(_dashboard2.default.PerfFeedbackSearch, {
	                    type: "text",
	                    placeholder: "Search by team name",
	                    value: this.state.perfFeedbackSearch,
	                    onChange: function onChange(e) {
	                      return _this3.setState({ perfFeedbackSearch: e.target.value });
	                    },
	                    onKeyDown: function onKeyDown(e) {
	                      if (e.key === "Enter") {
	                        _this3.setState({
	                          perfFeedbackSearchSubmitted: _this3.state.perfFeedbackSearch
	                        });
	                      }
	                    }
	                  }),
	                  false && _react2.default.createElement(
	                    _dashboard2.default.DownloadLink,
	                    { href: "#", onClick: this.downloadEngagementData },
	                    engagementDownloadRequest ? 'Download Data' : 'Download Request'
	                  )
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.BlockContent,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.PerfFeedbackBody,
	                    null,
	                    function () {
	                      // Top list driven by performancefeedbacks/game
	                      // API + the round's targets. Each row is a theme
	                      // (catalog pages with the same displayName
	                      // collapse into one) and links to its primary
	                      // page. Hovering or clicking a row sets it as
	                      // the active row and its long-form explanation
	                      // text appears in the right column.
	                      //
	                      // When the instructor submits a team-name
	                      // search, the getter either returns
	                      // notFound:true (no team matches) — we render
	                      // an inline error in that case — or filters
	                      // rows to themes whose team set includes that
	                      // specific team.
	                      var _topPerformanceFeedba = _this3.topPerformanceFeedbackItems,
	                          notFound = _topPerformanceFeedba.notFound,
	                          top = _topPerformanceFeedba.rows;
	
	                      if (notFound) {
	                        return _react2.default.createElement(
	                          _dashboard2.default.PerfFeedbackNotFound,
	                          null,
	                          "This team does not exist. Please double check team name."
	                        );
	                      }
	                      var isSearching = (_this3.state.perfFeedbackSearchSubmitted || "").trim().length > 0;
	                      var total = 5;
	                      var filler = isSearching ? 0 : Math.max(0, total - top.length);
	                      var activeRound = _this3.roundNumber;
	                      var activeIndex = _this3.state.perfFeedbackActiveIndex;
	                      var activeRow = activeIndex != null && top[activeIndex] || null;
	                      return _react2.default.createElement(
	                        _dashboard2.default.PerfFeedbackSplit,
	                        null,
	                        _react2.default.createElement(
	                          _dashboard2.default.PerfFeedbackList,
	                          null,
	                          top.map(function (row, idx) {
	                            var to = activeRound ? row.path + "?round=" + activeRound : row.path;
	                            var isActive = activeIndex === idx;
	                            return _react2.default.createElement(
	                              _dashboard2.default.PerfFeedbackItem,
	                              {
	                                key: "pf-" + idx,
	                                onMouseEnter: function onMouseEnter() {
	                                  return _this3.setState({ perfFeedbackActiveIndex: idx });
	                                },
	                                onClick: function onClick() {
	                                  return _this3.setState({ perfFeedbackActiveIndex: idx });
	                                },
	                                style: {
	                                  cursor: "pointer",
	                                  background: isActive ? "rgba(92, 145, 245, 0.06)" : undefined,
	                                  borderRadius: 4
	                                }
	                              },
	                              _react2.default.createElement(
	                                _dashboard2.default.PerfFeedbackNumber,
	                                null,
	                                idx + 1,
	                                "."
	                              ),
	                              _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: to },
	                                row.displayName
	                              )
	                            );
	                          }),
	                          Array.from({ length: filler }, function (_, i) {
	                            var n = top.length + i + 1;
	                            return _react2.default.createElement(
	                              _dashboard2.default.PerfFeedbackItem,
	                              { key: "pf-empty-" + n },
	                              _react2.default.createElement(
	                                _dashboard2.default.PerfFeedbackNumber,
	                                null,
	                                n,
	                                "."
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                null,
	                                "\u2014"
	                              )
	                            );
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _dashboard2.default.PerfFeedbackDetailColumn,
	                          null,
	                          activeRow && activeRow.hoverMessage ? _react2.default.createElement(
	                            "div",
	                            null,
	                            activeRow.hoverMessage
	                          ) : _react2.default.createElement(
	                            _dashboard2.default.PerfFeedbackDetailPlaceholder,
	                            null,
	                            "Hover or click an item to see why teams hit this issue."
	                          )
	                        )
	                      );
	                    }()
	                  )
	                )
	              ),
	              !surveysError && _react2.default.createElement(
	                _dashboard2.default.Block,
	                {
	                  isMenuExpanded: isMenuExpanded,
	                  fullWidth: true,
	                  style: { height: 270 }
	                },
	                _react2.default.createElement(
	                  _dashboard2.default.BlockTitle,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.PerfFeedbackTitleWrap,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.PerfFeedbackTitle,
	                      null,
	                      "Collaboration Insights"
	                    )
	                  ),
	                  _react2.default.createElement(_dashboard2.default.PerfFeedbackSearch, {
	                    type: "text",
	                    placeholder: "Search by student or team name\u2026",
	                    value: this.state.collabInsightsSearch,
	                    onChange: function onChange(e) {
	                      return _this3.setState({ collabInsightsSearch: e.target.value });
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  _dashboard2.default.BlockContent,
	                  null,
	                  !emptySurveys && function () {
	                    var compact = _this3.renderCollaborationCharts();
	                    return _react2.default.createElement(
	                      TeamDynamics.ChartHoverArea,
	                      {
	                        onMouseEnter: _this3.openCollabPopup,
	                        onMouseLeave: _this3.scheduleCollabPopupClose
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: '0 0 220px' } },
	                        compact.donut
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { style: { flex: '1 1 auto', minWidth: 0 } },
	                        compact.bubbles
	                      )
	                    );
	                  }(),
	                  emptySurveys && _react2.default.createElement(
	                    TeamDynamics.LabelCentered,
	                    null,
	                    "There are no peer evaluations created for this course."
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _dashboard2.default.SpotlightBlock,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.SpotlightHeader,
	                null,
	                _react2.default.createElement(
	                  _dashboard2.default.SpotlightHeaderLeft,
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Student Spotlight"
	                  ),
	                  function () {
	                    var evalSurveys = _this3.findEvalSurveys();
	                    if (!evalSurveys.initial || !evalSurveys.final) return null;
	                    var cur = _this3.state.currentSurvey;
	                    return _react2.default.createElement(
	                      TeamDynamics.EvalToggleRow,
	                      null,
	                      "Eval:",
	                      _react2.default.createElement(
	                        TeamDynamics.EvalToggleOption,
	                        {
	                          active: cur === evalSurveys.initial.id,
	                          onClick: function onClick(e) {
	                            e.preventDefault();
	                            _this3.selectSurveyById(evalSurveys.initial.id);
	                          }
	                        },
	                        "Initial"
	                      ),
	                      _react2.default.createElement(
	                        TeamDynamics.EvalToggleSeparator,
	                        null,
	                        ","
	                      ),
	                      _react2.default.createElement(
	                        TeamDynamics.EvalToggleOption,
	                        {
	                          active: cur === evalSurveys.final.id,
	                          onClick: function onClick(e) {
	                            e.preventDefault();
	                            _this3.selectSurveyById(evalSurveys.final.id);
	                          }
	                        },
	                        "Final"
	                      )
	                    );
	                  }()
	                ),
	                this.renderSpotlightTeamFilter()
	              ),
	              (this.state.allSurveys || []).length > 0 && !this.state.studentSpotlightGenerateMessage && this.state.studentSpotlightHasInsights === false && _react2.default.createElement(
	                _dashboard2.default.SpotlightDescription,
	                null,
	                "This section displays a list of the most and least valuable teammates in the simulation exercise."
	              ),
	              function () {
	                // Spotlight body state machine.
	                //   A. No survey on this game           → "needs peer eval" message
	                //   B. Generate-insights message active → blue notice banner
	                //   C. Survey + no insights generated   → Generate Insights button
	                //        (active iff the survey end date has passed)
	                //   D. Survey + insights confirmed OR  → render the two lists
	                //        still checking
	                var surveys = _this3.state.allSurveys || [];
	                var hasInsights = _this3.state.studentSpotlightHasInsights;
	                var generateMsg = _this3.state.studentSpotlightGenerateMessage;
	                var currentSurveyObj = surveys.find(function (s) {
	                  return s.id === _this3.state.currentSurvey;
	                });
	                var closed = currentSurveyObj ? _this3.isSurveyReallyFinished(currentSurveyObj) : false;
	
	                if (surveys.length === 0) {
	                  return _react2.default.createElement(
	                    _dashboard2.default.SpotlightColumns,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.SpotlightEmptyState,
	                      null,
	                      _react2.default.createElement(
	                        _dashboard2.default.SpotlightEmptyMessage,
	                        null,
	                        "A peer evaluation needs to be created and completed before student insights can be generated."
	                      )
	                    )
	                  );
	                }
	
	                if (generateMsg) {
	                  return _react2.default.createElement(
	                    _dashboard2.default.SpotlightColumns,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.SpotlightEmptyState,
	                      null,
	                      _react2.default.createElement(
	                        _dashboard2.default.SpotlightNotice,
	                        null,
	                        generateMsg
	                      )
	                    )
	                  );
	                }
	
	                if (hasInsights === false) {
	                  var canGenerate = _this3.canGenerateInsights();
	                  var tooltip = "";
	                  if (!canGenerate) {
	                    tooltip = "Only lead instructors assigned to every section in this course can generate insights.";
	                  } else if (!closed) {
	                    tooltip = "Peer evaluation has not closed yet";
	                  }
	                  return _react2.default.createElement(
	                    _dashboard2.default.SpotlightColumns,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.SpotlightEmptyState,
	                      null,
	                      _react2.default.createElement(
	                        _dashboard2.default.SpotlightEmptyMessage,
	                        null,
	                        "Insights haven't been generated for this peer evaluation yet."
	                      ),
	                      _react2.default.createElement(
	                        _dashboard2.default.SpotlightGenerateButton,
	                        {
	                          type: "button",
	                          disabled: !canGenerate || !closed || _this3.state.studentSpotlightGenerating,
	                          title: tooltip,
	                          onClick: _this3.openGenerateConfirm
	                        },
	                        _this3.state.studentSpotlightGenerating ? "Starting…" : "Generate Insights"
	                      )
	                    )
	                  );
	                }
	
	                // Default: render the two lists (insights present, or
	                // check still in flight). Sort by team_name asc first,
	                // then apply the instructor's team filter. Row numbers
	                // reflect the visible list so filtering reindexes 1..N.
	                var mvpsVisible = _this3.filterSpotlightByTeam(_this3.sortSpotlightByTeam(_this3.state.mostValuablePlayers || []));
	                var lvpsVisible = _this3.filterSpotlightByTeam(_this3.sortSpotlightByTeam(_this3.state.leastValuablePlayers || []));
	                return _react2.default.createElement(
	                  _dashboard2.default.SpotlightColumns,
	                  null,
	                  _react2.default.createElement(
	                    _dashboard2.default.SpotlightColumn,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.SpotlightSubheader,
	                      null,
	                      "Most Valuable Teammate"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: {
	                          display: 'flex',
	                          alignItems: 'center',
	                          justifyContent: 'space-between',
	                          borderBottom: '1px solid rgba(0, 27, 59, 0.08)',
	                          gap: 12
	                        } },
	                      _react2.default.createElement(
	                        _dashboard2.default.PerformersHeaderRow,
	                        { style: { border: 'none', flex: '1 1 auto', padding: '6px 2px' } },
	                        _react2.default.createElement(
	                          _dashboard2.default.PerformersCell,
	                          null,
	                          "No."
	                        ),
	                        _react2.default.createElement(
	                          _dashboard2.default.PerformersCell,
	                          null,
	                          "Team"
	                        ),
	                        _react2.default.createElement(
	                          _dashboard2.default.PerformersCell,
	                          null,
	                          "Student"
	                        )
	                      ),
	                      _this3.renderShareWithStudentsButton()
	                    ),
	                    _react2.default.createElement(
	                      _dashboard2.default.PerformersScroll,
	                      null,
	                      mvpsVisible.map(function (mvp, idx) {
	                        var name = _this3.trimSpotlightName(mvp.first_name, mvp.last_name) || mvp.username || (mvp.user_id != null ? "User " + mvp.user_id : '');
	                        var linkLabel = MVP_LINK_LABEL[mvp.category] || 'Most Valuable';
	                        return _react2.default.createElement(
	                          _dashboard2.default.PerformersBodyRow,
	                          { key: "top-" + (mvp.user_id || idx) },
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            idx + 1
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            { title: mvp.team_name || '' },
	                            _react2.default.createElement(
	                              _dashboard2.default.SpotlightTeamBadge,
	                              null,
	                              _this3.spotlightTeamBadge(mvp.team_name)
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            { title: name },
	                            name,
	                            mvp.user_id != null && _react2.default.createElement(
	                              _dashboard2.default.SkillsCertificateLink,
	                              {
	                                href: "#",
	                                onClick: function onClick(e) {
	                                  e.preventDefault();
	                                  _this3.openCertificate(mvp.user_id, mvp.category, mvp);
	                                }
	                              },
	                              "(",
	                              linkLabel,
	                              ")"
	                            )
	                          )
	                        );
	                      }),
	                      mvpsVisible.length === 0 && [1, 2, 3, 4, 5].map(function (n) {
	                        return _react2.default.createElement(
	                          _dashboard2.default.PerformersBodyRow,
	                          { key: "top-empty-" + n },
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            n
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            "\u2014"
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            "\u2014"
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(_dashboard2.default.SpotlightDivider, { "aria-hidden": true }),
	                  _react2.default.createElement(
	                    _dashboard2.default.SpotlightColumn,
	                    null,
	                    _react2.default.createElement(
	                      _dashboard2.default.SpotlightSubheader,
	                      null,
	                      "Least Valuable Teammate"
	                    ),
	                    _react2.default.createElement(
	                      _dashboard2.default.PerformersHeaderRow,
	                      null,
	                      _react2.default.createElement(
	                        _dashboard2.default.PerformersCell,
	                        null,
	                        "No."
	                      ),
	                      _react2.default.createElement(
	                        _dashboard2.default.PerformersCell,
	                        null,
	                        "Team"
	                      ),
	                      _react2.default.createElement(
	                        _dashboard2.default.PerformersCell,
	                        null,
	                        "Student"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _dashboard2.default.PerformersScroll,
	                      null,
	                      lvpsVisible.map(function (lvp, idx) {
	                        var name = _this3.trimSpotlightName(lvp.first_name, lvp.last_name) || lvp.username || (lvp.user_id != null ? "User " + lvp.user_id : '');
	                        return _react2.default.createElement(
	                          _dashboard2.default.PerformersBodyRow,
	                          { key: "bottom-" + (lvp.user_id || idx) },
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            idx + 1
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            { title: lvp.team_name || '' },
	                            _react2.default.createElement(
	                              _dashboard2.default.SpotlightTeamBadge,
	                              null,
	                              _this3.spotlightTeamBadge(lvp.team_name)
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            { title: name },
	                            name,
	                            lvp.user_id != null && _react2.default.createElement(
	                              _dashboard2.default.SkillsCertificateLink,
	                              {
	                                href: "#",
	                                onClick: function onClick(e) {
	                                  e.preventDefault();
	                                  _this3.openInsights(lvp.user_id, lvp);
	                                }
	                              },
	                              "(Insights)"
	                            )
	                          )
	                        );
	                      }),
	                      lvpsVisible.length === 0 && [1, 2, 3, 4, 5].map(function (n) {
	                        return _react2.default.createElement(
	                          _dashboard2.default.PerformersBodyRow,
	                          { key: "bottom-empty-" + n },
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            n
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            "\u2014"
	                          ),
	                          _react2.default.createElement(
	                            _dashboard2.default.PerformersCell,
	                            null,
	                            "\u2014"
	                          )
	                        );
	                      })
	                    )
	                  )
	                );
	              }()
	            )
	          )
	        ),
	        this.state.collabPopupOpen && !emptySurveys && function () {
	          var large = _this3.renderCollaborationCharts("large");
	          return _react2.default.createElement(
	            TeamDynamics.PopupBackdrop,
	            null,
	            _react2.default.createElement(
	              TeamDynamics.PopupCard,
	              {
	                onMouseEnter: _this3.openCollabPopup,
	                onMouseLeave: _this3.scheduleCollabPopupClose
	              },
	              _react2.default.createElement(
	                TeamDynamics.PopupTitle,
	                null,
	                "Class Collaboration Overview"
	              ),
	              _react2.default.createElement(
	                TeamDynamics.PopupSubtitle,
	                null,
	                currentSurveyName || "Peer evaluation",
	                _this3.collabTeamCount > 0 && " \xB7 " + _this3.collabTeamCount + " teams"
	              ),
	              _react2.default.createElement(
	                TeamDynamics.PopupColumns,
	                null,
	                _react2.default.createElement(
	                  TeamDynamics.PopupSection,
	                  null,
	                  _react2.default.createElement(
	                    TeamDynamics.PopupSectionLabel,
	                    null,
	                    "Team Dynamics"
	                  ),
	                  _react2.default.createElement(
	                    TeamDynamics.PopupSectionHint,
	                    null,
	                    "How teams worked together"
	                  ),
	                  large.donut,
	                  large.donutLegend
	                ),
	                _react2.default.createElement(
	                  TeamDynamics.PopupSection,
	                  null,
	                  _react2.default.createElement(
	                    TeamDynamics.PopupSectionLabel,
	                    null,
	                    "Skills Demonstrated"
	                  ),
	                  _react2.default.createElement(
	                    TeamDynamics.PopupSectionHint,
	                    null,
	                    "Bubble size = % of students showing each skill"
	                  ),
	                  large.bubbles
	                )
	              )
	            )
	          );
	        }(),
	        this.renderCertificate(),
	        this.renderInsights(),
	        this.renderTeamLookup(),
	        this.renderNotRegisteredPopup(),
	        this.renderPendingDecisionsPopup(),
	        this.renderBadgesIntro(),
	        this.renderBadgesTourBackdrop(),
	        this.renderBadgesTour(),
	        this.renderBadgesReview(),
	        this.renderBadgesEmailPreview(),
	        this.state.studentSpotlightConfirmOpen && _react2.default.createElement(
	          _dashboard2.default.SpotlightConfirm.Backdrop,
	          { onClick: this.closeGenerateConfirm },
	          _react2.default.createElement(
	            _dashboard2.default.SpotlightConfirm.Card,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              _dashboard2.default.SpotlightConfirm.Title,
	              null,
	              "Generate insights now?"
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.SpotlightConfirm.Body,
	              null,
	              "Insights can only be generated once per peer evaluation. You won't be able to regenerate them, even if you re-open the evaluation for students."
	            ),
	            _react2.default.createElement(
	              _dashboard2.default.SpotlightConfirm.Actions,
	              null,
	              _react2.default.createElement(
	                _dashboard2.default.SpotlightConfirm.CancelButton,
	                {
	                  type: "button",
	                  onClick: this.closeGenerateConfirm
	                },
	                "Cancel"
	              ),
	              _react2.default.createElement(
	                _dashboard2.default.SpotlightConfirm.ConfirmButton,
	                {
	                  type: "button",
	                  onClick: this.confirmGenerateSpotlightInsights
	                },
	                "Generate Insights"
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "isLoading",
	    get: function get() {
	      var _state2 = this.state,
	          courses = _state2.courses,
	          games = _state2.games,
	          rounds = _state2.rounds,
	          teams = _state2.teams,
	          surveys = _state2.surveys,
	          surveysError = _state2.surveysError;
	
	
	      return courses === null || games === null || rounds === null || teams === null || surveys === null && surveysError === null;
	    }
	  }, {
	    key: "rounds",
	    get: function get() {
	      var _state3 = this.state,
	          currentGame = _state3.currentGame,
	          rounds = _state3.rounds;
	
	
	      var result = currentGame > 0 && rounds ? rounds.filter(function (round) {
	        return round.game === currentGame && round.is_finished === true;
	      }).map(function (round) {
	        return "Round " + round.number;
	      }) : [];
	      if (typeof window !== 'undefined' && !this._loggedRoundsOnce) {
	        this._loggedRoundsOnce = true;
	        console.log('[MG:dashboard] rounds getter:', {
	          currentGame: currentGame,
	          currentGameType: typeof currentGame === "undefined" ? "undefined" : _typeof(currentGame),
	          rawRounds: (rounds || []).map(function (r) {
	            return {
	              id: r.id,
	              number: r.number,
	              game: r.game,
	              gameType: _typeof(r.game),
	              is_finished: r.is_finished,
	              is_finishedType: _typeof(r.is_finished)
	            };
	          }),
	          filtered: result
	        });
	      }
	      return result;
	    }
	
	    // Loads the data that drives the dashboard's Performance Feedback
	    // block: per-game performance feedback rows (with their `type` +
	    // unique `teams` arrays + `id` for tie-break) and the round's
	    // targets (used to gate which categories are relevant).
	
	
	    // Loads the dashboard's Top + Bottom Performers list. Hits
	    // /v2/games/most-least-valuable/<game_id>/ which returns
	    // { most_valuable: [{ user_id, ... }], least_valuable: [...] }.
	    // Names are resolved by cross-referencing user_id against
	    // courseMembers (passed in via the general-info API) so we don't
	    // fan out to /users on top of the request the dashboard already
	    // makes for course members.
	    //
	    // To avoid hitting the endpoint on every page load this is gated
	    // by an `Update`-only refresh model:
	    //   - On mount: only fire if BOTH lists are empty in state.
	    //   - On Update click: always refetch (force = true).
	    //
	    // Order returned by the backend is preserved (no shuffle).
	    // Checks whether per-survey insights have been generated for the
	    // current survey. The /students/ endpoint returns a paginated set
	    // of generated insight rows; if `results.length > 0` we treat the
	    // survey as having insights and show the Student Spotlight lists.
	    // We request only one row to keep the payload tiny.
	
	
	    // Read the instructor's per-survey badge consent state. Drives the
	    // "Confirm Badges" CTA + the tour overlay — CTA renders only when
	    // state === "pending" (never fetched, never confirmed, never
	    // declined). Called on survey switch, after insight generation
	    // completes, and after Approve/Decline flips the state server-side.
	
	
	    // True when the currently-selected survey's stage is the final /
	    // closing one. Uses the same "final" | "second" convention that
	    // findEvalSurveys does — either value means the closing survey.
	
	
	    // Open the badges consent tour overlay. Fires two parallel calls:
	    //
	    //   1. GET /v2/insights/class/<c>/<s>/?sections=...
	    //      consent message copy + email preview, scoped to the
	    //      instructor's sections (so the email preview reflects a
	    //      student the instructor actually teaches).
	    //   2. GET /v2/games/most-least-valuable/<s>/   (no sections query)
	    //      used only to count the class-wide unique badge recipients
	    //      for the "<X> of <Y> students in the entire course" line in
	    //      the consent paragraph. Section-scoped MVP state stays as-is
	    //      for the Review Badge Recipients checklist that opens next.
	    //
	    // Popup opens after both calls settle so the counts land correct
	    // on first paint. Course id comes from the picked course stashed
	    // in state at general-info load time.
	
	
	    // Counts unique class-wide badge recipients for the Review and Issue
	    // consent paragraph. Fires a second GET to most-least-valuable
	    // without the ?sections= filter so even a section-scoped instructor
	    // sees the whole course's badge totals. Returns 0 on any failure so
	    // the popup still opens with best-effort copy.
	
	
	    // Intro → Continue and Ready-to-Review both funnel through here.
	
	
	    // Opens the nested checklist popup with every qualifying student
	    // pre-selected. The instructor can un-check any before POSTing.
	
	
	    // Back button on the review popup: close it and return to the tour
	    // popup (still open behind). Selection state is retained so
	    // re-opening restores the instructor's picks; if the tour closes
	    // for any reason, openBadgesReview reseeds from the current MVP
	    // list.
	
	
	    // "Clear all" link on a category column. Un-checks every student
	    // in that category; other categories keep their selections. If
	    // every row in the column is already un-checked, re-checks them
	    // all (acts as a toggle to speed up "de-select everything then
	    // add a few back" flows).
	
	
	    // "Not Sure Yet" — no BE call. Closes the tour AND suppresses the
	    // intro popup for the rest of this session. On refresh/navigation
	    // the suppress flag resets and the flow re-fires (my_instructor_state
	    // is still "pending" on the BE, so gates still pass).
	
	
	    // Intro popup → Continue: open the Review and Approve consent
	    // popup directly. The two-step tour that used to sit between the
	    // intro and the Review popup was removed as unnecessary; this now
	    // mirrors what clicking the "Review and Approve Badges" button in
	    // the Student Spotlight header does.
	
	
	    // Two-step: the active Generate Insights button opens this confirm
	    // popup; the popup's primary action fires the actual POST. Keeps
	    // instructors from accidentally consuming the one-shot generation.
	
	
	    // Kicks off insight generation for the current survey. Backend
	    // returns 202 immediately with a status_url; FE polls that URL
	    // until status flips to "done" (typically <5 min).
	
	
	    // Tiered poll delays mirror the roster-upload pattern in
	    // instructor/utils/roster-upload.js — start tight (10s), back off
	    // once the job has been running a while. Cap at 6 min (BE target
	    // is <5 min; buffer covers Gemini/autoscaling variance).
	
	
	    // Resolve the status_url returned by /insights/generate/ into a
	    // fully-qualified URL. REACT_APP_API_URL already includes the /api/
	    // prefix, so we strip a leading /api/ to avoid doubling it up.
	
	
	    // Per-tab bubble palette. body = soft fill, outline = pastel ring,
	    // text = saturated accent for the count rendered inside the bubble.
	
	
	    // Display-name overrides: backend may return the long form but
	    // the dashboard renders the shortened label.
	
	
	    // Donut palette for the Team Dynamics chart. Soft green shades for
	    // "worked well / worked together" and a soft red for "did not work
	    // together" — keyed to the collaboration field names on the BE:
	    //   workedVeryWell → team_worked_well_together
	    //   workedWell     → team_worked_together
	    //   didNotWork     → team_did_not_worked_together
	
	
	    // Return up to 4 bubbles for the currently-selected tab, sorted
	    // largest → smallest by student count so the chart can lay them out
	    // left → right in descending order.
	
	  }, {
	    key: "collabTeamCount",
	
	
	    // Total number of teams the survey covers, used in the donut center.
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "total_teams", 0) : 0;
	    }
	
	    // "Review and Issue" popup. Renders the summary copy + primary
	    // action that opens the nested checklist popup. Copy numbers are
	    // class-wide — class-wide unique badge recipients (from the
	    // parallel most-least-valuable fetch kicked off in openBadgesTour)
	    // over the course's student_count field — so a section-scoped
	    // instructor still sees the student's placement across the entire
	    // course.
	
	
	    // Nested checklist popup. Sits on top of the "Review and Approve"
	    // popup with its own dimmer. The body is split into three category
	    // columns (Most Valuable / Market Master / Well Rounded), each
	    // ranked by total points with its own "Clear all" toggle. Rank 1-3
	    // rows get a podium-colored badge circle in the category palette;
	    // ranks 4+ fall through to neutral gray. Clicking a name opens the
	    // existing certificate preview. Confirm POSTs { user_ids: [selected] }.
	
	
	    // Nested email preview modal — shown on top of the tour overlay
	    // when the instructor clicks "View the email message". Content is
	    // the dedicated `badges_student_email_preview` field from
	    // /insights/class/, fetched alongside the consent message when the
	    // tour opens.
	    // Turn every http(s):// URL in the email preview into a clickable
	    // link. Returns an array of strings and <a> elements so it can be
	    // dropped into any pre-wrap container without breaking whitespace.
	    // React 15 has no Fragment, so an array of keyed children is used.
	
	
	    // "Share With Students" button under Most Valuable Teammate.
	    //   No render at all: insights aren't generated, or non-final survey.
	    //   Active ("Share With Students"): my_instructor_state === "pending" —
	    //     click opens the tour (same entry point as intro Continue).
	    //   Inactive ("Badges Sent"): my_instructor_state === "confirmed" —
	    //     tooltip explains badges were shared.
	    // Badge-issuance affordance in the Most Valuable column header. Only
	    // instructors with a documented scope (INS or INS2 who are either
	    // assigned specific sections or have covers_all_sections=true) can
	    // issue badges, so the button is hidden for everyone else. Lead
	    // instructors with no section assignments (e.g. walshcm4's data) are
	    // allowed to generate insights but intentionally not to issue
	    // badges — they have no students in their scope to badge.
	
	
	    // Badge-issuance eligibility. Lead instructors (INS) and
	    // co-instructors (INS2) can issue badges only when they have a
	    // documented scope on the course: either assigned specific sections
	    // on their user record, or course_members.covers_all_sections=true.
	    // Instructor Assistants (IAS) and scope-less instructors are
	    // excluded — they are not teaching students they can badge.
	
	
	    // Intro popup — auto-appears above the dashboard when badge gates
	    // pass and the instructor hasn't clicked Not Sure Yet this session.
	    // Continue opens the Review and Issue consent popup. Only shown to
	    // instructors who can actually issue badges (same role + scope rule
	    // as the dashboard button) so we don't nudge instructors toward an
	    // action they can't take.
	
	
	    // Areas of Improvement popup — driven by the same insights API as
	    // the certificate, but focused on weaknesses.summary +
	    // overall_summary and every weakness evidence quote.
	    // Team Lookup modal — the "command palette" the KPI card opens.
	
	
	    // ---------------------------------------------------------------
	    // Skills Certificate popup (Top Performer rows)
	    // ---------------------------------------------------------------
	
	    // ---------------------------------------------------------------
	    // Not-registered-yet affordance under the Student Count KPI tile.
	    // Backed by /v2/games/coursemembers/?not-registered&course=<id>.
	    // Fetch once per fetchData so the count surfaces on initial render;
	    // the modal reads from state when opened (no refetch).
	    // ---------------------------------------------------------------
	
	
	    // ---------------------------------------------------------------
	    // Team Decisions Status KPI tile. Lists teams that haven't posted
	    // their round decisions yet, excluding teams whose only missing
	    // item is "negative_cash" (cash-only misses are a BE check the
	    // instructor can't act on in this flow). Popup opens on click of
	    // the subtext link.
	    // ---------------------------------------------------------------
	
	
	    // ---------------------------------------------------------------
	    // Areas of Improvement (Insights) popup — Bottom Performer rows
	    // Same backend endpoint as the certificate but the popup focuses
	    // on weaknesses.summary, overall_summary, and every weakness
	    // evidence quote.
	    // ---------------------------------------------------------------
	
	    // ---------------------------------------------------------------
	    // Team Lookup modal — KPI-row "Look up a team" card + ⌘K shortcut
	    // ---------------------------------------------------------------
	
	    // Cache window: refetch the team list if the modal opens more than
	    // 60s after the last fetch (or if the dashboard round changed).
	
	
	    // Display name for the lookup list: prepend "Team " unless the
	    // backend's `name` already starts with "Team" (so we don't render
	    // "Team Team Alpha" when the API returns "Team Alpha" directly).
	
	
	    // Filter + debounce for the search input. We update the query
	    // immediately for input responsiveness, and let the filtered list
	    // be derived in render — keeps state simple and matches what
	    // PureComponent expects.
	
	
	    // Build navigable URLs that carry the picked team across the
	    // window.open boundary. _token / _userid / _courseid prime the
	    // target tab's session so the page can authorize without forcing
	    // the user to log in again.
	    // Pick the round number to carry into the audit-trail / team-report
	    // tabs. The leftbar "Year" selector is the actual source of truth:
	    // it sets ?round=N in the URL, which App.js forwards down as
	    // props.roundInUrl. Fall back to state.currentRound's round number,
	    // then to the latest round on the game, then 0.
	
	
	    // Replace redaction tokens / generic placeholders with the real
	    // student name in any peer-feedback or summary text. Covers:
	    //   - "this student" / "the student" / "<student>"
	    //   - "[person-1]" / "[person 2]" (LLM-generated redaction)
	    //   - "[student-JF]" / "[student-anything]" (bracketed initials/aliases)
	    //   - "Student-FB" / "Student JK" (unbracketed initials/aliases)
	
	
	    // Collaboration Insights bubble chart — fetches the per-survey
	    // strengths/weaknesses skill bubbles. Same cache policy as
	    // most-least-valuable: only fire if empty OR on Update click.
	
	
	    // Direct survey switch by id. Unlike selectSurvey() this doesn't
	    // require the survey to be in the finished-only `state.surveys`
	    // list, so the Eval toggle can switch to an in-progress survey.
	
	
	    // Identify the "initial" and "final" surveys for the eval toggle.
	    // Trust the stage tag only when it cleanly distinguishes exactly one
	    // initial + one final; otherwise fall back to due-date order
	    // (earliest end = Initial, latest end = Final). Legacy surveys
	    // created before the FE started sending `stage` all default to
	    // "initial" on the BE, which would otherwise collide.
	
	  }, {
	    key: "surveys",
	    get: function get() {
	      var _this4 = this;
	
	      var surveys = this.state.surveys;
	
	
	      return surveys ? surveys.filter(function (survey) {
	        return _this4.isSurveyFinished(survey);
	      }).map(function (survey) {
	        return survey.name;
	      }) : [];
	    }
	  }, {
	    key: "roundNumber",
	    get: function get() {
	      var _state4 = this.state,
	          currentRound = _state4.currentRound,
	          rounds = _state4.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.id === currentRound;
	      });
	
	      return round ? round.number : 0;
	    }
	  }, {
	    key: "totalTeams",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "total_teams", 0) : "---";
	    }
	
	    // Builds the `sections=...` query param used on dashboard GETs so
	    // that section-scoped instructors see only the data for their
	    // assigned sections. Rules (per BE/product):
	    //   course_members[0].covers_all_sections === true  → sections=all
	    //   covers_all_sections === false AND user.sections has entries
	    //     → sections=<id1>,<id2>,...
	    //   covers_all_sections === false AND user.sections empty/missing
	    //     → return "" (BE falls through to default scoping)
	    //   covers_all_sections absent (field not yet shipped by BE)
	    //     → fall through to the user.sections rule; returns "" when
	    //       the user has no sections, preserving current behavior for
	    //       instructors who pre-date the field.
	    // Caller is responsible for prefixing with "?" or "&" depending on
	    // whether the URL already has a query string.
	
	
	    // True when the current instructor can run course-level actions
	    // (Generate Insights, approve badges, etc.). Only lead instructors
	    // assigned to every section in the course get this. Defaults to
	    // true when BE hasn't shipped covers_all_sections yet — avoids
	    // accidental lockouts during rollout; once BE ships the field,
	    // section-scoped instructors get blocked automatically.
	
	  }, {
	    key: "workedVeryWellTogether",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "team_worked_well_together", []).length / (0, _get3.default)(teamScore.collaboration, "total_teams", 0) * 100 : 0;
	    }
	  }, {
	    key: "workedVeryWellTogetherTeams",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "team_worked_well_together", []).length : 0;
	    }
	  }, {
	    key: "didNotWorkWellTogether",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "team_did_not_worked_together", []).length / (0, _get3.default)(teamScore.collaboration, "total_teams", 0) * 100 : 0;
	    }
	  }, {
	    key: "didNotWorkWellTogetherTeams",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "team_did_not_worked_together", []).length : 0;
	    }
	  }, {
	    key: "workedWellTogether",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "team_worked_together", []).length / (0, _get3.default)(teamScore.collaboration, "total_teams", 0) * 100 : 0;
	    }
	  }, {
	    key: "workedWellTogetherTeams",
	    get: function get() {
	      var teamScore = this.state.teamScore;
	
	
	      return teamScore ? (0, _get3.default)(teamScore.collaboration, "team_worked_together", []).length : 0;
	    }
	  }, {
	    key: "leaderboardCSVHeaders",
	    get: function get() {
	      return [{ label: "Team name", key: "team_name" }, { label: "Round", key: "round_number" }, { label: "Round Score", key: "round_score" }, { label: "Cumulative Score", key: "cumulative_score" }, { label: "Rank", key: "rank" }];
	    }
	  }, {
	    key: "leaderboardCSVRows",
	    get: function get() {
	      var _this5 = this;
	
	      var _state5 = this.state,
	          leaderboard = _state5.leaderboard,
	          teams = _state5.teams;
	
	
	      return leaderboard.map(function (row) {
	        return {
	          team_name: row.team_name || _this5.getTeamName(teams, Number(row.team)),
	          round_number: Number(row.round_number),
	          round_score: Number(row.current_weighted_value),
	          cumulative_score: Number(row.weighted_value),
	          rank: row.ranking
	        };
	      });
	    }
	  }, {
	    key: "leaderboardData",
	    get: function get() {
	      var _this6 = this;
	
	      var _state6 = this.state,
	          leaderboard = _state6.leaderboard,
	          currentRound = _state6.currentRound,
	          sortKey = _state6.sortKey,
	          sortOrder = _state6.sortOrder,
	          teams = _state6.teams,
	          rounds = _state6.rounds;
	
	      var round = rounds ? rounds.find(function (i) {
	        return i.id === currentRound;
	      }) : null;
	      var roundNumber = round ? round.number : 0;
	
	      var items = leaderboard ? leaderboard.filter(function (i) {
	        return i.round === currentRound;
	      }) : [];
	      var rankings = this.getClassRankings(items);
	      var results = items.map(function (_ref16, i) {
	        var weighted_value = _ref16.weighted_value,
	            ranking = _ref16.ranking,
	            team = _ref16.team,
	            team_name = _ref16.team_name,
	            game = _ref16.game;
	        return {
	          key: i,
	          classRanking: rankings[weighted_value],
	          classRankingSort: rankings[weighted_value],
	          teamName: team_name || _this6.getTeamName(teams, team),
	          teamNameSort: team_name || _this6.getTeamName(teams, team),
	          competitionRanking: ranking,
	          teamPerformance: (weighted_value * 100).toFixed(2) + "%",
	          teamPerformanceSort: weighted_value,
	          detailsLink: _this6.getDetailsLink(team, roundNumber, game)
	        };
	      });
	
	      return (0, _orderBy2.default)(results, [sortKey + "Sort"], [sortOrder]);
	    }
	  }, {
	    key: "currentDate",
	    get: function get() {
	      var _toISOString$split$0$ = new Date().toISOString().split('T')[0].split('-'),
	          _toISOString$split$0$2 = _slicedToArray(_toISOString$split$0$, 3),
	          year = _toISOString$split$0$2[0],
	          month = _toISOString$split$0$2[1],
	          day = _toISOString$split$0$2[2];
	
	      return year + "-" + day + "-" + month;
	    }
	
	    // ---------- KPI helpers for the top-row tiles ----------
	    // Team Scores tile shows the mean and median of teams' weighted
	    // performance for the selected round, computed off leaderboardData.
	    // Team Count tile counts the unique team ids on the current round's
	    // leaderboard, falling back to the full teams list when no rows
	    // have come in yet. Student Count tile reads the consolidated
	    // course_members.student_count sum already computed in fetchData.
	
	  }, {
	    key: "teamScoreStats",
	    get: function get() {
	      var rows = this.leaderboardData || [];
	      var values = rows.map(function (r) {
	        return Number(r.teamPerformanceSort);
	      }).filter(function (v) {
	        return Number.isFinite(v);
	      });
	      if (values.length === 0) return { mean: null, median: null };
	
	      var mean = values.reduce(function (a, b) {
	        return a + b;
	      }, 0) / values.length;
	      var sorted = values.slice().sort(function (a, b) {
	        return a - b;
	      });
	      var mid = Math.floor(sorted.length / 2);
	      var median = sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
	
	      return { mean: mean, median: median };
	    }
	  }, {
	    key: "teamCount",
	    get: function get() {
	      // Section-scoped instructors (covers_all_sections === false) read
	      // the section-scoped team total from props.sectionTeamsCount (BE
	      // top-level data.section_teams_count on general-info). Lead
	      // instructors + legacy payloads fall through to the course-wide
	      // team-id count below.
	      //
	      // Fallback: when the course has NO sections at all (user.sections
	      // empty), use the course-wide count regardless of
	      // covers_all_sections — section_teams_count is meaningless (always
	      // 0) if the course was never sectioned.
	      var cm = (this.props.courseMembers || [])[0];
	      var user = _Auth2.default.getUser() || {};
	      var hasAnySections = Array.isArray(user.sections) && user.sections.length > 0;
	      if (cm && cm.covers_all_sections === false && hasAnySections) {
	        return Number(this.props.sectionTeamsCount) || 0;
	      }
	      // Primary: count teams off the picked game object. games[].teams
	      // is BE's authoritative team-id list for this game and is present
	      // on general-info responses that include the games plural array
	      // (notably IAS scope=dashboard payloads). Fixes the first-mount
	      // drift where state.teams could be stale for users whose login
	      // stored a different session game_id than the picker landed on.
	      //
	      // Fallback: count distinct ids in state.teams. Needed when the
	      // general-info response omitted the games plural array — INS
	      // scope=dashboard currently returns only data.game (singular) +
	      // the top-level data.teams array, so state.games is empty and
	      // the lookup above misses.
	      var _state7 = this.state,
	          games = _state7.games,
	          currentGame = _state7.currentGame,
	          teams = _state7.teams;
	
	      var game = (games || []).find(function (g) {
	        return Number(g.id) === Number(currentGame);
	      });
	      if (game && Array.isArray(game.teams)) {
	        return new Set(game.teams).size;
	      }
	      var ids = new Set((teams || []).map(function (t) {
	        return t && t.id;
	      }).filter(function (id) {
	        return id != null;
	      }));
	      return ids.size;
	    }
	
	    // ---------- Performance Feedback list helpers ----------
	    // Categories map to fields on gamesTargets[0]: a non-zero target value
	    // means the category is relevant for the round and its pages are
	    // candidates for the top-5 list. Net Loss is gated by RoE/RoA/EPS per
	    // product rules.
	
	  }, {
	    key: "topPerformanceFeedbackItems",
	
	
	    // Builds the Performance Feedback list. Pipeline:
	    //   1. Index API feedback rows by `type` so each catalog item can
	    //      grab its teams + id in O(1).
	    //   2. Filter the catalog to categories that are relevant for the
	    //      round's targets.
	    //   3. Group remaining items by their resolved display name (catalog
	    //      pages that share a theme like "Cross-Functional Challenges"
	    //      collapse into one list row whose team set is the union of
	    //      teams across all member pages' types and whose tie-break id
	    //      is the lowest matching id).
	    //   4. Drop themes with zero teams.
	    //   5. If a team-name search has been submitted, resolve it to a
	    //      team id and either:
	    //        - keep only themes whose team set includes that team, or
	    //        - return { notFound: true, rows: [] } when the name doesn't
	    //          match any team — the render branch shows an inline error.
	    //   6. Sort by PERF_FEEDBACK_DISPLAY_ORDER (fixed priority list),
	    //      then take the top 5. teamCount is no longer used for
	    //      ranking — only for the "X out of Y teams" hover prefix.
	    //
	    // displayName / hoverMessage on a catalog item may be a function of
	    // the round number (Share Price changes label by round).
	    get: function get() {
	      var _this7 = this;
	
	      var _state8 = this.state,
	          performanceFeedbacksGame = _state8.performanceFeedbacksGame,
	          perfFeedbackSearchSubmitted = _state8.perfFeedbackSearchSubmitted,
	          teams = _state8.teams;
	
	      var empty = { notFound: false, rows: [] };
	
	      if (!Array.isArray(performanceFeedbacksGame) || performanceFeedbacksGame.length === 0) {
	        return empty;
	      }
	
	      var round = this.roundNumber || 0;
	      var resolve = function resolve(v) {
	        return typeof v === "function" ? v(round) : v;
	      };
	
	      var byType = {};
	      performanceFeedbacksGame.forEach(function (f) {
	        if (f && f.type) byType[f.type] = f;
	      });
	
	      // Aggregation rules:
	      //   - Within a single catalog entry (which represents one page),
	      //     we dedupe teams across all of its types — a team that
	      //     appears in both "Auto overproduced" and "Mobile overproduced"
	      //     under the shared Overproduced page counts as 1 for that page.
	      //   - Across catalog entries that share a displayName (theme), we
	      //     SUM those per-page counts — a team that appears on page A
	      //     AND page B under the same theme counts as 2.
	      //   - The `teamIdsForSearch` set is the union of all teams across
	      //     all member pages and is used only by the team-name search
	      //     filter to decide whether to keep the theme.
	      var groups = new Map();
	      PERF_FEEDBACK_ITEMS.filter(function (item) {
	        return _this7.isPerfFeedbackCategoryRelevant(item.category);
	      }).forEach(function (item) {
	        var displayName = resolve(item.displayName);
	        var hoverMessage = resolve(item.hoverMessage);
	        if (!groups.has(displayName)) {
	          groups.set(displayName, {
	            displayName: displayName,
	            hoverMessage: hoverMessage,
	            path: item.path,
	            teamCount: 0,
	            teamIdsForSearch: new Set(),
	            lowestId: Infinity,
	            // Paths within this group that ended up with at least one
	            // team. Used below to apply the per-group path priority
	            // override so the row links to the page that actually
	            // has data when multiple options exist.
	            pathsWithTeams: new Set()
	          });
	        }
	        var group = groups.get(displayName);
	        var types = Array.isArray(item.type) ? item.type : [item.type];
	
	        var teamsForThisPage = new Set();
	        types.forEach(function (t) {
	          var f = byType[t];
	          if (f && Array.isArray(f.teams)) {
	            f.teams.forEach(function (id) {
	              teamsForThisPage.add(id);
	              group.teamIdsForSearch.add(id);
	            });
	          }
	          if (f && f.id != null && Number(f.id) < group.lowestId) {
	            group.lowestId = Number(f.id);
	          }
	        });
	
	        if (teamsForThisPage.size > 0) {
	          group.pathsWithTeams.add(item.path);
	        }
	        group.teamCount += teamsForThisPage.size;
	      });
	
	      // Apply per-group path priority overrides: if any priority path
	      // for this group's displayName ended up with data, use the first
	      // one in the priority list. Falls back to the catalog default
	      // when no priority match is found.
	      groups.forEach(function (g) {
	        var priority = PERF_FEEDBACK_PATH_PRIORITY[g.displayName];
	        if (!Array.isArray(priority)) return;
	        var winner = priority.find(function (p) {
	          return g.pathsWithTeams.has(p);
	        });
	        if (winner) g.path = winner;
	      });
	
	      // Total teams for the round, used to fill the "<X> out of <Y>
	      // teams" prefix substituted into every hover message. Aligned
	      // with the dashboard's Team Count KPI tile.
	      var totalTeams = this.teamCount;
	
	      var rows = Array.from(groups.values()).map(function (g) {
	        // Unique team count for the theme (union of all member pages'
	        // team ids), distinct from `teamCount` which is the sum of
	        // per-page counts used for ranking. The hover-text prefix
	        // uses this unique count so a team is not double-counted in
	        // the explanation sentence.
	        var uniqueTeamCount = g.teamIdsForSearch.size;
	        var hoverMessage = typeof g.hoverMessage === "string" ? g.hoverMessage.replace(/These teams/g, uniqueTeamCount + " out of " + totalTeams + " teams") : g.hoverMessage;
	        return {
	          displayName: g.displayName,
	          hoverMessage: hoverMessage,
	          path: g.path,
	          teamCount: g.teamCount,
	          teamIds: g.teamIdsForSearch,
	          feedbackId: g.lowestId === Infinity ? null : g.lowestId
	        };
	      }).filter(function (r) {
	        return r.teamCount > 0;
	      });
	
	      // Team-name search (submitted via Enter). Case-insensitive exact
	      // match against team.name; whitespace-trimmed. An unmatched name
	      // returns notFound:true so the render can show the inline error.
	      var searchTerm = (perfFeedbackSearchSubmitted || "").trim().toLowerCase();
	      if (searchTerm) {
	        var team = (teams || []).find(function (t) {
	          return t && typeof t.name === "string" && t.name.trim().toLowerCase() === searchTerm;
	        });
	        if (!team) {
	          return { notFound: true, rows: [] };
	        }
	        var teamId = Number(team.id);
	        rows = rows.filter(function (r) {
	          return r.teamIds && (r.teamIds.has(teamId) || r.teamIds.has(team.id));
	        });
	      }
	
	      // Fixed display order: groups appear in PERF_FEEDBACK_DISPLAY_ORDER
	      // sequence whenever they have any teams. Anything not in the list
	      // (shouldn't happen unless the catalog and order list drift) falls
	      // to the bottom by index = list length.
	      var orderIndex = function orderIndex(displayName) {
	        var idx = PERF_FEEDBACK_DISPLAY_ORDER.indexOf(displayName);
	        return idx === -1 ? PERF_FEEDBACK_DISPLAY_ORDER.length : idx;
	      };
	      rows.sort(function (a, b) {
	        return orderIndex(a.displayName) - orderIndex(b.displayName);
	      });
	
	      return { notFound: false, rows: rows.slice(0, 5) };
	    }
	  }]);
	
	  return Dashboard;
	}(_react.PureComponent);
	
	exports.default = Dashboard;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #F4F6F8;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #F4F6F8;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n'], ['\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Instructor demo walkthrough. Reachable from two places:
	//   1. Onboarding path-choice, when the instructor picks "Demo".
	//      user.onboard is still 0 in this case.
	//   2. Welcome page, after onboarding is complete. user.onboard is 1.
	//
	// The self-contained HTML at /instructor-demo-flow.html is loaded
	// in an iframe with ?onboarding=true|false so it can present the
	// right end-of-demo buttons. Button clicks bubble up via
	// postMessage and this container handles the redirects.
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Frame = _styledComponents2.default.iframe(_templateObject2);
	
	var InstructorDemoPage = function (_Component) {
	  _inherits(InstructorDemoPage, _Component);
	
	  function InstructorDemoPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InstructorDemoPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstructorDemoPage.__proto__ || Object.getPrototypeOf(InstructorDemoPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleMessage = function (event) {
	      var data = event.data;
	      if (!data || data.source !== 'instructor-demo') return;
	
	      switch (data.type) {
	        case 'done':
	          (0, _Location.changeLocation)('/instructor/welcome');
	          break;
	        case 'setup':
	          (0, _Location.changeLocation)('/instructor/onboarding/simulation-selection');
	          break;
	        case 'logout':
	          if (_Auth2.default.isUserAuthenticated()) {
	            _Auth2.default.deauthenticateUser();
	          }
	          (0, _Location.changeLocation)('/login');
	          break;
	        default:
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InstructorDemoPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('message', this.handleMessage);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.handleMessage);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var src = '/instructor-demo-flow.html?onboarding=' + (this.onboardingComplete ? 'true' : 'false');
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(Frame, { src: src, title: 'Instructor demo walkthrough' })
	      );
	    }
	  }, {
	    key: 'onboardingComplete',
	    get: function get() {
	      var user = _Auth2.default.getUser();
	      return !!(user && user.onboard === 1);
	    }
	  }]);
	
	  return InstructorDemoPage;
	}(_react.Component);
	
	exports.default = InstructorDemoPage;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 40px 40px 50px;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n"], ["\n  width: 100%;\n  padding: 40px 40px 50px;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  gap: 16px;\n  margin: 0 0 4px;\n"], ["\n  display: flex;\n  align-items: baseline;\n  gap: 16px;\n  margin: 0 0 4px;\n"]),
	    _templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  font-family: 'Mukta Vaani';\n  margin: 0;\n"], ["\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  font-family: 'Mukta Vaani';\n  margin: 0;\n"]),
	    _templateObject4 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #5C91F5;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  ", "\n"], ["\n  font-family: 'Mukta Vaani', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #5C91F5;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteral(["\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 20px;\n"], ["\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.6);\n  margin-bottom: 20px;\n"]),
	    _templateObject6 = _taggedTemplateLiteral(["\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  overflow-x: auto;\n"], ["\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  overflow-x: auto;\n"]),
	    _templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  border-top: 1px solid #DEE0E3;\n  border-collapse: collapse;\n"], ["\n  width: 100%;\n  font-family: 'Mukta Vaani';\n  font-size: 14px;\n  border-top: 1px solid #DEE0E3;\n  border-collapse: collapse;\n"]),
	    _templateObject8 = _taggedTemplateLiteral(["\n  background: #F5F6F7;\n  box-shadow: inset 0px -1px 0px #DEE0E3;\n"], ["\n  background: #F5F6F7;\n  box-shadow: inset 0px -1px 0px #DEE0E3;\n"]),
	    _templateObject9 = _taggedTemplateLiteral(["\n  padding: 14px 16px 4px;\n  font-weight: 700;\n  text-align: ", ";\n  vertical-align: top;\n  white-space: nowrap;\n  color: rgba(0, 27, 59, 0.94);\n"], ["\n  padding: 14px 16px 4px;\n  font-weight: 700;\n  text-align: ", ";\n  vertical-align: top;\n  white-space: nowrap;\n  color: rgba(0, 27, 59, 0.94);\n"]),
	    _templateObject10 = _taggedTemplateLiteral(["\n  padding: 0 16px 12px;\n  font-weight: 500;\n  font-size: 12px;\n  text-align: ", ";\n  color: rgba(0, 27, 59, 0.6);\n  white-space: nowrap;\n"], ["\n  padding: 0 16px 12px;\n  font-weight: 500;\n  font-size: 12px;\n  text-align: ", ";\n  color: rgba(0, 27, 59, 0.6);\n  white-space: nowrap;\n"]),
	    _templateObject11 = _taggedTemplateLiteral(["\n  box-shadow: inset 0px -1px 0px #ECEDEF;\n\n  &:nth-child(2n-1) {\n    background: #FAFBFD;\n  }\n"], ["\n  box-shadow: inset 0px -1px 0px #ECEDEF;\n\n  &:nth-child(2n-1) {\n    background: #FAFBFD;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteral(["\n  padding: 12px 16px;\n  vertical-align: middle;\n  white-space: nowrap;\n  text-align: ", ";\n"], ["\n  padding: 12px 16px;\n  vertical-align: middle;\n  white-space: nowrap;\n  text-align: ", ";\n"]),
	    _templateObject13 = _taggedTemplateLiteral(["\n  box-shadow: inset 0px -1px 0px #ECEDEF;\n"], ["\n  box-shadow: inset 0px -1px 0px #ECEDEF;\n"]),
	    _templateObject14 = _taggedTemplateLiteral(["\n  padding: 24px 16px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.6);\n"], ["\n  padding: 24px 16px;\n  text-align: center;\n  color: rgba(0, 27, 59, 0.6);\n"]),
	    _templateObject15 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Surveys = __webpack_require__(56);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DOWNLOAD_MAX_ATTEMPTS = 10;
	var DOWNLOAD_ATTEMPT_DELAY = 1000;
	var DOWNLOAD_ERROR = "The system cannot process request. Try again later.";
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var TitleRow = _styledComponents2.default.div(_templateObject2);
	
	var PageTitle = _styledComponents2.default.h1(_templateObject3);
	
	var DownloadLink = _styledComponents2.default.a(_templateObject4, function (p) {
	  return p.disabled && "\n    color: rgba(0, 27, 59, 0.38);\n    cursor: not-allowed;\n    pointer-events: none;\n  ";
	});
	
	var PageSubtitle = _styledComponents2.default.div(_templateObject5);
	
	var TableWrapper = _styledComponents2.default.div(_templateObject6);
	
	var Table = _styledComponents2.default.table(_templateObject7);
	
	var HeadGroupRow = _styledComponents2.default.tr(_templateObject8);
	
	var HeadCell = _styledComponents2.default.th(_templateObject9, function (p) {
	  return p.center ? "center" : "left";
	});
	
	var SubHeadRow = _styledComponents2.default.tr(_templateObject8);
	
	var SubHeadCell = _styledComponents2.default.th(_templateObject10, function (p) {
	  return p.center ? "center" : "left";
	});
	
	var Row = _styledComponents2.default.tr(_templateObject11);
	
	var Cell = _styledComponents2.default.td(_templateObject12, function (p) {
	  return p.center ? "center" : "left";
	});
	
	var EmptyRow = _styledComponents2.default.tr(_templateObject13);
	
	var EmptyCell = _styledComponents2.default.td(_templateObject14);
	
	var Pill = _styledComponents2.default.span(_templateObject15, function (p) {
	  return p.tone === 'yes' && "\n    background: #E8F5EE;\n    color: #2E7D4F;\n  ";
	}, function (p) {
	  return p.tone === 'no' && "\n    background: #FBECEB;\n    color: #B5413B;\n  ";
	}, function (p) {
	  return p.tone === 'na' && "\n    background: #F0F1F4;\n    color: rgba(0, 27, 59, 0.6);\n  ";
	});
	
	var formatPct = function formatPct(v) {
	  return v == null || isNaN(Number(v)) ? "—" : (Number(v) * 100).toFixed(2) + "%";
	};
	
	var formatWeightPct = function formatWeightPct(v) {
	  return v == null || isNaN(Number(v)) ? "" : (Number(v) * 100).toFixed(2) + "%";
	};
	
	var FinalScores = function (_PureComponent) {
	  _inherits(FinalScores, _PureComponent);
	
	  function FinalScores(props) {
	    _classCallCheck(this, FinalScores);
	
	    var _this = _possibleConstructorReturn(this, (FinalScores.__proto__ || Object.getPrototypeOf(FinalScores)).call(this, props));
	
	    _this.fetchData = function () {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var rounds = (_this.props.rounds || []).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	
	      if (rounds.length === 0) {
	        _this.setState({ loaded: true });
	        return;
	      }
	
	      _this.setState({ loaded: false });
	
	      var teamgradingsUrls = rounds.map(function (r) {
	        return apiUrl + "v2/games/teamgradings/overall/" + r.id + "/";
	      });
	
	      // Derive course id from the current game (game.course) — this
	      // mirrors how the instructor dashboard does it. Auth.getCourseId()
	      // reads sessionStorage, which is only set on the SSO/temporary
	      // user flow and may be stale or missing for instructors who
	      // manage multiple courses. game.course is always the course of
	      // the game currently in context.
	      var game = _this.props.game;
	      var courseId = game && game.course || _Auth2.default.getCourseId();
	
	      // /usergrade/course/<id>/ returns one row per user *per round*
	      // (count can be ~3× the student count for a 3-round game).
	      // Keying by user_id without filtering means an arbitrary round's
	      // row wins. Pin to the last closed round so each user only has
	      // one row in the response and the value we read is the final
	      // adjusted/curved cumulative. Skip the call entirely if no
	      // round has closed — by spec, nothing should be shown then.
	      // Sort by number ascending before picking the latest — the BE
	      // returns rounds in insertion / id order, not number order (e.g.
	      // (2, 3, 1) after Activate Main Rounds), so the raw last element
	      // can be the wrong round.
	      var finishedRounds = rounds.filter(function (r) {
	        return r.is_finished === true;
	      }).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	      var closedLastRound = finishedRounds[finishedRounds.length - 1] || null;
	      var usergradeCourseUrl = courseId && closedLastRound ? apiUrl + "v2/games/usergrade/course/" + courseId + "/?round_id=" + closedLastRound.id : null;
	
	      var requests = [
	      // Scope by course. Without ?course= the BE returns a paginated
	      // list across every course this instructor touches, and
	      // results[0] is whichever row happens to sort first (often a
	      // foreign course), which was surfacing the wrong Team / Peer
	      // weights in the table header. Matches the fix on
	      // overall-score.js.
	      apiUrl + "v2/games/gradingweights/?course=" + courseId, apiUrl + "v2/forms/surveys/?course=" + _Auth2.default.getCourseId()].concat(_toConsumableArray(teamgradingsUrls));
	      if (usergradeCourseUrl) requests.push(usergradeCourseUrl);
	      var usergradeIdx = usergradeCourseUrl ? requests.length - 1 : -1;
	
	      // batchRequest is Promise.all — a single 4xx (e.g. the
	      // usergrade/course endpoint 404s before scores are calculated)
	      // poisons the whole batch and we lose all data. Wrap each call
	      // so failures degrade per-column instead of blanking the page.
	      Promise.all(requests.map(function (url) {
	        return (0, _ApiService.getRequest)(url).catch(function () {
	          return { body: null, _failed: true };
	        });
	      })).then(function (res) {
	        // Grading weights — `gradingweights` is paginated; pull
	        // team_grade and peer_weight from the first row.
	        var weightsBody = res[0] && res[0].body || {};
	        var weightsRow = weightsBody.results && weightsBody.results[0] || {};
	        var weights = {
	          team_grade: Number(weightsRow.team_grade) || 0,
	          peer_weight: Number(weightsRow.peer_weight) || 0
	        };
	
	        // Latest closed survey = the finished survey tagged stage
	        // "final" (or legacy "second"). The BE's survey ids are NOT
	        // guaranteed to be in creation order — observed on course
	        // 265 where the Initial survey has id 155 while the Final
	        // has id 154 — so picking by highest id would return the
	        // Initial. If there's no finished final survey the Peer
	        // Score + Individual Score columns intentionally render as
	        // dashes (see the usergrade gating below).
	        var surveysBody = res[1] && res[1].body || {};
	        var surveys = Array.isArray(surveysBody) ? surveysBody : surveysBody.results || [];
	        var finishedSurveys = surveys.filter(function (s) {
	          return (0, _Surveys.isSurveyFinished)(s);
	        });
	        var stageOf = function stageOf(s) {
	          return String(s && (s.stage || s.stage_name) || "").toLowerCase();
	        };
	        var isFinalStage = function isFinalStage(s) {
	          var st = stageOf(s);
	          return st === "final" || st === "second";
	        };
	        var finalFinishedSurveys = finishedSurveys.filter(isFinalStage);
	        var latestClosedSurvey = finalFinishedSurveys.length > 0 ? finalFinishedSurveys.reduce(function (a, b) {
	          return Number(a.id) > Number(b.id) ? a : b;
	        }) : null;
	
	        // Per-round team grading rows: map round_id → { team_id → { current, cumulative } }
	        var roundsScores = {};
	        rounds.forEach(function (r, i) {
	          var body = res[2 + i] && res[2 + i].body || {};
	          var teamsArr = Array.isArray(body.teams) ? body.teams : [];
	          var byTeam = {};
	          teamsArr.forEach(function (t) {
	            byTeam[String(t.team)] = {
	              current: Number(t.current_weighted_value),
	              cumulative: Number(t.weighted_value)
	            };
	          });
	          roundsScores[r.id] = byTeam;
	        });
	
	        // Individual Scores from /usergrade/course/<course_id>/.
	        // Field preference matches the existing per-user pattern
	        // in components/profile/index.js: curved value wins when
	        // present, fall back to the un-curved adjusted value.
	        //
	        // Gated on `latestClosedSurvey`: Individual Score only makes
	        // sense once the final peer eval has closed. If no finished
	        // "final"-stage survey exists, we intentionally drop the
	        // usergrade response and leave individualScores empty so the
	        // column renders as "—" for every user. The usergrade/run
	        // kickoff below is skipped for the same reason.
	        var individualScores = {};
	        if (latestClosedSurvey && usergradeIdx >= 0) {
	          var ugBody = res[usergradeIdx] && res[usergradeIdx].body || {};
	          var ugRows = Array.isArray(ugBody) ? ugBody : ugBody.results || [];
	          ugRows.forEach(function (row) {
	            var uid = row.user_id != null ? row.user_id : row.user;
	            if (uid == null) return;
	            var curved = Number(row.curved_adjusted_cumulative_value);
	            var adjusted = Number(row.adjusted_cumulative_value);
	            var value = !isNaN(curved) && curved > 0 ? curved : !isNaN(adjusted) && adjusted > 0 ? adjusted : null;
	            individualScores[String(uid)] = value;
	          });
	        }
	
	        var finishPeerThen = function finishPeerThen(peerScores) {
	          _this.setState({
	            loaded: true,
	            weights: weights,
	            roundsScores: roundsScores,
	            peerScores: peerScores,
	            individualScores: individualScores,
	            latestClosedSurvey: latestClosedSurvey
	          }, function () {
	            // Only fire /usergrade/run/ when a finished final
	            // survey exists. Without it we have nothing to compile
	            // scores against yet, and firing it would surface the
	            // "being calculated" banner for a run that will have no
	            // meaningful output.
	            if (latestClosedSurvey) {
	              _this.maybeTriggerUsergradeRun(rounds, individualScores);
	            }
	          });
	        };
	
	        if (!latestClosedSurvey) {
	          finishPeerThen({});
	          return;
	        }
	
	        (0, _ApiService.getRequest)(apiUrl + "v2/games/peer-score/" + latestClosedSurvey.id + "/").then(function (peerRes) {
	          var peerBody = peerRes && peerRes.body || {};
	          var peerRows = Array.isArray(peerBody) ? peerBody : peerBody.results || [];
	          var peerScores = {};
	          peerRows.forEach(function (row) {
	            var uid = row.user_id != null ? row.user_id : row.user;
	            if (uid == null) return;
	            peerScores[String(uid)] = {
	              peer_score: row.peer_score,
	              completion: row.completion
	            };
	          });
	          finishPeerThen(peerScores);
	        }).catch(function () {
	          finishPeerThen({});
	        });
	      }).catch(function () {
	        _this.setState({ loaded: true });
	      });
	    };
	
	    _this.maybeTriggerUsergradeRun = function (sortedRounds, individualScores) {
	      if (_this._runTriggered) return;
	      if (_this.state.individualScoresProcessing) return;
	      if (individualScores && Object.keys(individualScores).length > 0) return;
	
	      var lastRound = sortedRounds[sortedRounds.length - 1];
	      if (!lastRound || lastRound.is_finished !== true) return;
	
	      var game = _this.props.game;
	      var gameId = game ? game.id : _Auth2.default.getGameId();
	      if (!gameId) return;
	
	      _this._runTriggered = true;
	      _this.setState({ individualScoresProcessing: true });
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/run/").send({ game: gameId }).type("form").then(function () {
	        // No re-fetch — backend job is long-running. The note in
	        // the subtitle tells the instructor to come back.
	      }).catch(function () {
	        _this.setState({ individualScoresProcessing: false });
	        _this._runTriggered = false;
	      });
	    };
	
	    _this.getLastClosedRound = function (sortedRounds) {
	      var finished = sortedRounds.filter(function (r) {
	        return r.is_finished === true;
	      });
	      if (finished.length > 0) return finished[finished.length - 1];
	      return sortedRounds[sortedRounds.length - 1] || null;
	    };
	
	    _this.getDownloadRound = function (sortedRounds) {
	      var urlRoundNumber = _this.props.roundInUrl != null ? Number(_this.props.roundInUrl) : null;
	      var urlRound = urlRoundNumber != null && !isNaN(urlRoundNumber) ? sortedRounds.find(function (r) {
	        return Number(r.number) === urlRoundNumber;
	      }) : null;
	      return urlRound || _this.getLastClosedRound(sortedRounds);
	    };
	
	    _this.downloadPerformanceFile = function () {
	      var performanceDownloadFile = _this.state.performanceDownloadFile;
	
	      if (!performanceDownloadFile) return;
	
	      (0, _ApiService.downloadRequest)(performanceDownloadFile, "application/csv").then(function (res) {
	        return res.blob();
	      }).then(function (blob) {
	        var link = document.createElement("a");
	        link.href = URL.createObjectURL(blob);
	        link.download = "performance_" + _this.currentDate + ".csv";
	        link.click();
	        _this.setState({ performanceDownloading: false });
	      }).catch(function (err) {
	        console.error(err);
	        _this.setState({ performanceDownloading: false });
	        alert(DOWNLOAD_ERROR);
	      });
	    };
	
	    _this.downloadPerformanceData = function (e) {
	      if (e) e.preventDefault();
	
	      var _this$state = _this.state,
	          performanceDownloadRequest = _this$state.performanceDownloadRequest,
	          performanceDownloadCount = _this$state.performanceDownloadCount,
	          performanceDownloadFile = _this$state.performanceDownloadFile,
	          latestClosedSurvey = _this$state.latestClosedSurvey;
	
	
	      if (performanceDownloadFile) {
	        _this.downloadPerformanceFile();
	        return;
	      }
	
	      var sortedRounds = (_this.props.rounds || []).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	      var downloadRound = _this.getDownloadRound(sortedRounds);
	      if (!downloadRound || downloadRound.is_finished !== true) {
	        alert("Performance data is available once the selected round has closed.");
	        return;
	      }
	
	      var game = _this.props.game;
	      var gameId = game ? game.id : _Auth2.default.getGameId();
	      var surveyId = latestClosedSurvey ? latestClosedSurvey.id : null;
	      var roundId = downloadRound.id;
	
	      if (!performanceDownloadRequest) {
	        _this.setState({ performanceDownloading: true });
	        (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/games/usergrade/run/").send(Object.assign({
	          game: gameId
	        }, surveyId ? { survey: surveyId } : {})).type("form").then(function (res) {
	          if (res.statusCode === 200 || res.statusCode === 201) {
	            (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/reports/performance-csv-add/").send(Object.assign({
	              round: roundId
	            }, surveyId ? { survey: surveyId } : {})).type("form").then(function (resp) {
	              var download_file = resp.body.download_file;
	              // The dashboard strips the leading "/api/" prefix
	              // before appending to REACT_APP_API_URL.
	
	              var nextDownloadRequest = download_file ? download_file.substring(5) : null;
	              _this.setState({
	                performanceDownloadRequest: nextDownloadRequest,
	                performanceDownloadCount: 0,
	                performanceDownloadFile: null
	              }, function () {
	                return _this.downloadPerformanceData();
	              });
	            }).catch(function (err) {
	              console.error(err);
	              _this.setState({ performanceDownloading: false });
	              alert(DOWNLOAD_ERROR);
	            });
	          } else {
	            _this.setState({ performanceDownloading: false });
	            alert(DOWNLOAD_ERROR);
	          }
	        }).catch(function (err) {
	          console.error(err);
	          _this.setState({ performanceDownloading: false });
	        });
	        return;
	      }
	
	      if (performanceDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
	        alert(DOWNLOAD_ERROR);
	        _this.setState({ performanceDownloadCount: 0, performanceDownloading: false });
	        return;
	      }
	
	      if (_this._pollingPerformance) return;
	      _this._pollingPerformance = true;
	
	      (0, _ApiService.getRequest)("" + ("https://be-production-itb.marketgames.io/api/") + performanceDownloadRequest).then(function (res) {
	        _this._pollingPerformance = false;
	        var _res$body = res.body,
	            status = _res$body.status,
	            download_link = _res$body.download_link;
	
	
	        _this.setState({
	          performanceDownloadCount: performanceDownloadCount + 1
	        });
	
	        if (status !== "Completed") {
	          setTimeout(_this.downloadPerformanceData, DOWNLOAD_ATTEMPT_DELAY);
	        } else {
	          _this.setState({
	            performanceDownloadFile: download_link,
	            performanceDownloadCount: 0
	          }, function () {
	            return _this.downloadPerformanceFile();
	          });
	        }
	      }).catch(function (err) {
	        _this._pollingPerformance = false;
	        console.error(err);
	        _this.setState({ performanceDownloading: false });
	        alert(DOWNLOAD_ERROR);
	      });
	    };
	
	    _this.state = {
	      loaded: false,
	      weights: { team_grade: 0, peer_weight: 0 },
	      roundsScores: {},
	      peerScores: {},
	      individualScores: {},
	      latestClosedSurvey: null,
	      // True after we've kicked off /usergrade/run/ in this session.
	      // Prevents repeat POSTs while the backend job is processing —
	      // the job is async (5-10 min) so we don't poll; instructor
	      // refreshes the page when they return.
	      individualScoresProcessing: false,
	      // CSV download flow state, mirroring the pattern used by the
	      // instructor dashboard's downloadPerformanceData:
	      //   1. POST /usergrade/run/  → ensure scores are processed
	      //   2. POST /reports/performance-csv-add/ → enqueue job, returns a polling URL
	      //   3. poll that URL until status === Completed → download_link
	      //   4. downloadRequest(link) → blob → trigger browser save
	      performanceDownloadRequest: null,
	      performanceDownloadCount: 0,
	      performanceDownloadFile: null,
	      performanceDownloading: false
	    };
	    return _this;
	  }
	
	  _createClass(FinalScores, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // When the instructor lands on Final Scores after being on the
	      // dashboard, App.js's state still holds the dashboard-scoped
	      // general-info response, which intentionally omits teamplayers.
	      // That leaves this.props.teamplayers empty and the roster renders
	      // "No students found." until a hard refresh. Emit reload-data to
	      // make App.js refire general-info — the current URL isn't
	      // /instructor/dashboard, so scope=dashboard won't be sent and the
	      // full payload (including teamplayers) comes back. One-shot flag
	      // avoids a loop on courses that genuinely have 0 teamplayers.
	      if ((this.props.teamplayers || []).length === 0 && !this._triggeredReload) {
	        this._triggeredReload = true;
	        _eventEmitter2.default.getInstance().trigger("reload-data");
	      }
	      if ((this.props.rounds || []).length > 0) {
	        this._hasFetched = true;
	        this.fetchData();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevLen = (prevProps.rounds || []).length;
	      var nextLen = (this.props.rounds || []).length;
	      if (!this._hasFetched && nextLen > 0) {
	        this._hasFetched = true;
	        this.fetchData();
	      } else if (nextLen !== prevLen) {
	        this.fetchData();
	      }
	    }
	
	    // If the last round has closed but the course-level usergrade
	    // endpoint returned nothing, kick off the backend calc job once.
	    // The job is async (5-10 min like the insights flow) so we don't
	    // poll — we surface a "calculating" note instead and the
	    // instructor refreshes when they return.
	
	
	    // The "Team Score" column is the cumulative `weighted_value` from
	    // the latest closed (is_finished) round; if no round has finished
	    // yet, fall back to the latest round we do have data for.
	
	
	    // Round the Download button targets. The sidebar's "Year" dropdown
	    // writes ?round=N into the URL (see round-switcher.js — "Year" is
	    // actually the round number). Match that round when it exists in
	    // the current game's rounds list; otherwise fall back to the last
	    // closed round so pages reached without ?round still work.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var teamplayers = this.props.teamplayers || [];
	      var teams = this.props.teams || [];
	      var _state = this.state,
	          loaded = _state.loaded,
	          weights = _state.weights,
	          roundsScores = _state.roundsScores,
	          peerScores = _state.peerScores,
	          individualScores = _state.individualScores,
	          individualScoresProcessing = _state.individualScoresProcessing,
	          latestClosedSurvey = _state.latestClosedSurvey;
	
	
	      if (!loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(
	            PageTitle,
	            null,
	            "Performance Scores"
	          ),
	          _react2.default.createElement(_reactLoaders.Loader, { type: "ball-scale-ripple", active: true })
	        );
	      }
	
	      var sortedRounds = (this.props.rounds || []).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	      // Show up to 3 round columns to match the spec; if a game has
	      // fewer rounds we render only those.
	      var visibleRounds = sortedRounds.slice(0, 3);
	      var lastClosedRound = this.getLastClosedRound(sortedRounds);
	
	      var teamsById = {};
	      teams.forEach(function (t) {
	        teamsById[String(t.id)] = t.name;
	      });
	
	      // Build display rows, joining teamplayers with the per-round
	      // team grading map and the per-user peer score map.
	      var rows = teamplayers.map(function (tp) {
	        var teamId = tp.team;
	        var teamName = teamsById[String(teamId)] || "—";
	        var first = tp.user && tp.user.first_name || "";
	        var last = tp.user && tp.user.last_name || "";
	        var fullName = (first + " " + last).trim() || tp.user && tp.user.username || "—";
	
	        var roundValues = visibleRounds.map(function (r) {
	          // Only surface a round's current_weighted_value once the round
	          // has closed. For live rounds the BE's teamgradings/overall
	          // endpoint returns a provisional value (often a carry-over
	          // from the prior round) that misleads instructors into
	          // thinking the live round has already been graded. Render
	          // "—" instead until is_finished flips to true.
	          if (r.is_finished !== true) return null;
	          var cell = roundsScores[r.id] && roundsScores[r.id][String(teamId)];
	          return cell && !isNaN(cell.current) ? cell.current : null;
	        });
	
	        var teamScore = lastClosedRound && roundsScores[lastClosedRound.id] && roundsScores[lastClosedRound.id][String(teamId)] && !isNaN(roundsScores[lastClosedRound.id][String(teamId)].cumulative) ? roundsScores[lastClosedRound.id][String(teamId)].cumulative : null;
	
	        var userId = tp.user && tp.user.id;
	        var peer = peerScores[String(userId)] || null;
	        var peerScore = peer && peer.peer_score != null && !isNaN(Number(peer.peer_score)) ? Number(peer.peer_score) : null;
	        var completion = peer ? !!peer.completion : null;
	
	        // Pulled from /usergrade/course/<course_id>/ rather than
	        // computed client-side — keeps the formula authoritative on
	        // the backend (curve, adjustments, etc. are all included).
	        var indivRaw = individualScores ? individualScores[String(userId)] : undefined;
	        var individualScore = indivRaw != null && !isNaN(Number(indivRaw)) ? Number(indivRaw) : null;
	
	        return {
	          id: tp.id,
	          fullName: fullName,
	          teamName: teamName,
	          roundValues: roundValues,
	          teamScore: teamScore,
	          peerScore: peerScore,
	          completion: completion,
	          individualScore: individualScore
	        };
	      });
	
	      rows.sort(function (a, b) {
	        var t = a.teamName.localeCompare(b.teamName);
	        if (t !== 0) return t;
	        return a.fullName.localeCompare(b.fullName);
	      });
	
	      // Disable Download when the targeted round (sidebar's ?round=N
	      // or fallback to last closed) hasn't closed yet, so the click
	      // never produces the "selected round has closed" alert.
	      var downloadRound = this.getDownloadRound(sortedRounds);
	      var downloadDisabled = !downloadRound || downloadRound.is_finished !== true || this.state.performanceDownloading;
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          TitleRow,
	          null,
	          _react2.default.createElement(
	            PageTitle,
	            null,
	            "Performance Scores"
	          ),
	          _react2.default.createElement(
	            DownloadLink,
	            {
	              href: "#",
	              disabled: downloadDisabled,
	              onClick: this.downloadPerformanceData
	            },
	            this.state.performanceDownloading ? "Preparing download…" : "Download"
	          )
	        ),
	        _react2.default.createElement(
	          PageSubtitle,
	          null,
	          "View the latest team, peer, and individual scores. Each round's team score rolls up into a weighted cumulative score, which then combines with the peer score to produce the individual score. All scores adjust until every round and survey closes."
	        ),
	        individualScoresProcessing && _react2.default.createElement(
	          PageSubtitle,
	          null,
	          "Individual scores are being calculated. This usually takes 5\u201310 minutes \u2014 check back shortly."
	        ),
	        _react2.default.createElement(
	          TableWrapper,
	          null,
	          _react2.default.createElement(
	            Table,
	            null,
	            _react2.default.createElement(
	              "thead",
	              null,
	              _react2.default.createElement(
	                HeadGroupRow,
	                null,
	                _react2.default.createElement(
	                  HeadCell,
	                  null,
	                  "Name"
	                ),
	                _react2.default.createElement(
	                  HeadCell,
	                  { center: true },
	                  "Team"
	                ),
	                visibleRounds.map(function (r) {
	                  return _react2.default.createElement(
	                    HeadCell,
	                    { center: true, key: "hr-" + r.id },
	                    "Round ",
	                    r.number
	                  );
	                }),
	                _react2.default.createElement(
	                  HeadCell,
	                  { center: true },
	                  "Team Score"
	                ),
	                _react2.default.createElement(
	                  HeadCell,
	                  { center: true },
	                  "Peer Score"
	                ),
	                _react2.default.createElement(
	                  HeadCell,
	                  { center: true },
	                  "Final Eval Submitted?"
	                ),
	                _react2.default.createElement(
	                  HeadCell,
	                  { center: true },
	                  "Individual Score"
	                )
	              ),
	              _react2.default.createElement(
	                SubHeadRow,
	                null,
	                _react2.default.createElement(SubHeadCell, null),
	                _react2.default.createElement(SubHeadCell, { center: true }),
	                visibleRounds.map(function (r) {
	                  return _react2.default.createElement(
	                    SubHeadCell,
	                    { center: true, key: "sw-" + r.id },
	                    "Weight: ",
	                    formatWeightPct(r.grading_weight)
	                  );
	                }),
	                _react2.default.createElement(
	                  SubHeadCell,
	                  { center: true },
	                  "Weight: ",
	                  formatWeightPct(weights.team_grade)
	                ),
	                _react2.default.createElement(
	                  SubHeadCell,
	                  { center: true },
	                  "Weight: ",
	                  formatWeightPct(weights.peer_weight)
	                ),
	                _react2.default.createElement(SubHeadCell, { center: true }),
	                _react2.default.createElement(SubHeadCell, { center: true })
	              )
	            ),
	            _react2.default.createElement(
	              "tbody",
	              null,
	              rows.length === 0 && _react2.default.createElement(
	                EmptyRow,
	                null,
	                _react2.default.createElement(
	                  EmptyCell,
	                  { colSpan: 6 + visibleRounds.length },
	                  "No students found."
	                )
	              ),
	              rows.map(function (row) {
	                return _react2.default.createElement(
	                  Row,
	                  { key: row.id },
	                  _react2.default.createElement(
	                    Cell,
	                    null,
	                    row.fullName
	                  ),
	                  _react2.default.createElement(
	                    Cell,
	                    { center: true },
	                    row.teamName
	                  ),
	                  row.roundValues.map(function (v, i) {
	                    return _react2.default.createElement(
	                      Cell,
	                      { center: true, key: "rv-" + row.id + "-" + i },
	                      formatPct(v)
	                    );
	                  }),
	                  _react2.default.createElement(
	                    Cell,
	                    { center: true },
	                    formatPct(row.teamScore)
	                  ),
	                  _react2.default.createElement(
	                    Cell,
	                    { center: true },
	                    formatPct(row.peerScore)
	                  ),
	                  _react2.default.createElement(
	                    Cell,
	                    { center: true },
	                    row.completion === null ? _react2.default.createElement(
	                      Pill,
	                      { tone: "na" },
	                      "\u2014"
	                    ) : row.completion ? _react2.default.createElement(
	                      Pill,
	                      { tone: "yes" },
	                      "Y"
	                    ) : _react2.default.createElement(
	                      Pill,
	                      { tone: "no" },
	                      "N"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    Cell,
	                    { center: true },
	                    formatPct(row.individualScore)
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "currentDate",
	    get: function get() {
	      var _toISOString$split$0$ = new Date().toISOString().split("T")[0].split("-"),
	          _toISOString$split$0$2 = _slicedToArray(_toISOString$split$0$, 3),
	          year = _toISOString$split$0$2[0],
	          month = _toISOString$split$0$2[1],
	          day = _toISOString$split$0$2[2];
	
	      return month + "-" + day + "-" + year;
	    }
	
	    // Three-step pattern matched from the instructor dashboard's
	    // downloadPerformanceData: kick scores via /usergrade/run/, then
	    // enqueue the CSV job via /reports/performance-csv-add/, then poll
	    // the returned task URL until it reports Completed and pull the
	    // blob through downloadRequest.
	
	  }]);
	
	  return FinalScores;
	}(_react.PureComponent);
	
	exports.default = FinalScores;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _utils = __webpack_require__(66);
	
	var _ApiService = __webpack_require__(4);
	
	var _createGameModal = __webpack_require__(1440);
	
	var _createGameModal2 = _interopRequireDefault(_createGameModal);
	
	var _Location = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_utils.bootstrapUtils.addStyle(_reactBootstrap.Button, "light-blue");
	
	var GAMES_LIST_API = ("https://be-production-itb.marketgames.io/api/") + "games/";
	var COURSES_LIST_API = ("https://be-production-itb.marketgames.io/api/") + "courses/";
	
	var GameManagement = function (_PureComponent) {
	  _inherits(GameManagement, _PureComponent);
	
	  function GameManagement(props) {
	    _classCallCheck(this, GameManagement);
	
	    var _this = _possibleConstructorReturn(this, (GameManagement.__proto__ || Object.getPrototypeOf(GameManagement)).call(this, props));
	
	    _this.fetchGames = function () {
	      var courses = _this.state.courses;
	
	      var ids = courses.map(function (i) {
	        return i.id;
	      });
	
	      (0, _ApiService.getRequest)(GAMES_LIST_API).then(function (res) {
	        _this.setState({
	          games: res.body.filter(function (i) {
	            return ids.includes(i.course);
	          }),
	          games_loaded: true
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.fetchCourses = function () {
	      (0, _ApiService.getRequest)(COURSES_LIST_API).then(function (res) {
	        _this.setState({
	          courses: res.body,
	          courses_loaded: true
	        }, function () {
	          _this.fetchGames();
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.getCourseName = function (course_id) {
	      var courses = _this.state.courses;
	
	      var course = courses.find(function (i) {
	        return i.id === course_id;
	      });
	
	      return course ? course.name : "";
	    };
	
	    _this.showCreateGameModal = function () {
	      _this.setState({
	        createGameModal: true
	      });
	    };
	
	    _this.hideCreateGameModal = function () {
	      _this.setState({
	        createGameModal: false
	      });
	    };
	
	    _this.createGame = function (game_name, course_id, number_of_students, callback) {
	      (0, _ApiService.postRequest)(GAMES_LIST_API).send({
	        name: game_name,
	        course: course_id,
	        students: number_of_students
	      }).then(function (res) {
	        callback();
	        _this.fetchGames();
	        _this.setState({
	          createGameModal: false
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.goToRoundManagement = function (game_id) {
	      (0, _Location.changeLocation)("/instructor/round-management/" + game_id);
	    };
	
	    _this.goToTeamManagement = function (game_id) {
	      (0, _Location.changeLocation)("/instructor/team-management/" + game_id);
	    };
	
	    _this.state = {
	      games: [],
	      courses: [],
	      games_loaded: false,
	      courses_loaded: false,
	      createGameModal: false
	    };
	    return _this;
	  }
	
	  _createClass(GameManagement, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.fetchCourses();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          games = _state.games,
	          games_loaded = _state.games_loaded,
	          courses_loaded = _state.courses_loaded,
	          createGameModal = _state.createGameModal,
	          courses = _state.courses;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "instructorPage" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Games"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "instructorWrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "No."
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Game Name"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Course Name"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Teams"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Rounds"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                (games_loaded === false || courses_loaded === false) && _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      colSpan: 5,
	                      className: "text-center v-align-middle instructor-td"
	                    },
	                    "Loading..."
	                  )
	                ),
	                games_loaded === true && courses_loaded === true && games.map(function (game, counter) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: counter },
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle instructor-round-number b-r" },
	                      counter + 1
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l b-r instructor-td" },
	                      game.name
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l b-r instructor-td" },
	                      _this2.getCourseName(game.course)
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l b-r" },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "light-blue",
	                          onClick: function onClick() {
	                            return _this2.goToTeamManagement(game.id);
	                          },
	                          block: true
	                        },
	                        "Manage Teams"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      { className: "text-center v-align-middle b-l" },
	                      _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                          bsStyle: "light-blue",
	                          onClick: function onClick() {
	                            return _this2.goToRoundManagement(game.id);
	                          },
	                          block: true
	                        },
	                        "Manage Rounds"
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "bottom-button" },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: "light-blue",
	                onClick: this.showCreateGameModal,
	                block: true
	              },
	              "Create Game"
	            )
	          )
	        ),
	        _react2.default.createElement(_createGameModal2.default, {
	          show: createGameModal,
	          onHide: this.hideCreateGameModal,
	          courses: courses,
	          createGame: this.createGame
	        })
	      );
	    }
	  }]);
	
	  return GameManagement;
	}(_react.PureComponent);
	
	exports.default = GameManagement;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactBootstrap = __webpack_require__(20);
	
	var _goalsAndTargetsMarketShare = __webpack_require__(560);
	
	var _goalsAndTargetsMarketShare2 = _interopRequireDefault(_goalsAndTargetsMarketShare);
	
	var _goalsAndTargetsRevenues = __webpack_require__(561);
	
	var _goalsAndTargetsRevenues2 = _interopRequireDefault(_goalsAndTargetsRevenues);
	
	var _goalsAndTargetsGrossMargins = __webpack_require__(559);
	
	var _goalsAndTargetsGrossMargins2 = _interopRequireDefault(_goalsAndTargetsGrossMargins);
	
	var _goalsAndTargetsSharePrice = __webpack_require__(564);
	
	var _goalsAndTargetsSharePrice2 = _interopRequireDefault(_goalsAndTargetsSharePrice);
	
	var _goalsAndTargetsRoe = __webpack_require__(563);
	
	var _goalsAndTargetsRoe2 = _interopRequireDefault(_goalsAndTargetsRoe);
	
	var _goalsAndTargetsRoa = __webpack_require__(562);
	
	var _goalsAndTargetsRoa2 = _interopRequireDefault(_goalsAndTargetsRoa);
	
	var _goalsAndTargetsEps = __webpack_require__(558);
	
	var _goalsAndTargetsEps2 = _interopRequireDefault(_goalsAndTargetsEps);
	
	var _goalsAndTargets = __webpack_require__(1540);
	
	var _FinancialTargets = __webpack_require__(399);
	
	var _FinancialTargets2 = _interopRequireDefault(_FinancialTargets);
	
	var _infoTooltip = __webpack_require__(1057);
	
	var _infoTooltip2 = _interopRequireDefault(_infoTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var videos = {
	  'Market Share': _goalsAndTargetsMarketShare2.default,
	  'Revenues': _goalsAndTargetsRevenues2.default,
	  'Gross Margins': _goalsAndTargetsGrossMargins2.default,
	  'Share Price': _goalsAndTargetsSharePrice2.default,
	  'ROE': _goalsAndTargetsRoe2.default,
	  'ROA': _goalsAndTargetsRoa2.default,
	  'EPS': _goalsAndTargetsEps2.default
	};
	
	var GoalsAndTargets = function (_PureComponent) {
	  _inherits(GoalsAndTargets, _PureComponent);
	
	  function GoalsAndTargets(props) {
	    _classCallCheck(this, GoalsAndTargets);
	
	    var _this = _possibleConstructorReturn(this, (GoalsAndTargets.__proto__ || Object.getPrototypeOf(GoalsAndTargets)).call(this, props));
	
	    _this.handlePlayPause = function () {
	      if (_this.videoRef) {
	        if (_this.state.isVideoPlaying) {
	          _this.videoRef.pause();
	        } else {
	          _this.videoRef.play();
	        }
	        _this.setState({ isVideoPlaying: !_this.state.isVideoPlaying });
	      }
	    };
	
	    _this.openModal = function (videoSrc) {
	      _this.setState({
	        isModalShown: true,
	        selectedVideo: videoSrc
	      });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({
	        isModalShown: false,
	        isVideoPlaying: false
	      });
	    };
	
	    _this.onHelpIconClick = function (field) {
	      if (videos[field]) {
	        _this.openModal(videos[field]);
	      }
	    };
	
	    _this.state = {
	      financialTargets: [],
	      loaded: false,
	      isModalShown: false,
	      isVideoPlaying: false,
	      selectedVideo: null
	    };
	
	    _this.videoRef = null;
	    return _this;
	  }
	
	  _createClass(GoalsAndTargets, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var courseId = Number(_Auth2.default.getCourseId());
	
	      (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?course=' + courseId, ("https://be-production-itb.marketgames.io/api/") + 'v2/games/goaltargets/']).then(function (res) {
	        var financialTargets = res[0].body;
	
	        _this2.setState({
	          financialTargets: financialTargets,
	          loaded: true
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          financialTargets = _state.financialTargets,
	          isModalShown = _state.isModalShown,
	          isVideoPlaying = _state.isVideoPlaying;
	
	      var activeRound = this.activeRound;
	
	      return loaded ? _react2.default.createElement(
	        _goalsAndTargets.Wrapper,
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Modal,
	          { show: isModalShown, onHide: this.closeModal, className: 'goals-and-targets-modal' },
	          _react2.default.createElement(
	            _reactBootstrap.Modal.Body,
	            null,
	            _react2.default.createElement(
	              _goalsAndTargets.ModalVideoWrapper,
	              { className: isVideoPlaying ? 'is-playing' : '' },
	              _react2.default.createElement('video', {
	                ref: function ref(_ref) {
	                  _this3.videoRef = _ref;
	                },
	                src: this.state.selectedVideo,
	                alt: 'Welcome Video',
	                onClick: this.handlePlayPause,
	                onEnded: function onEnded() {
	                  return _this3.setState({ isVideoPlaying: false });
	                },
	                style: { width: '100%', borderRadius: 10 }
	              }),
	              _react2.default.createElement(
	                _goalsAndTargets.PlayPauseButton,
	                { onClick: this.handlePlayPause },
	                isVideoPlaying ? '❚❚' : '▶'
	              ),
	              _react2.default.createElement(
	                _goalsAndTargets.CloseModalVideoButton,
	                { onClick: this.closeModal },
	                '\xD7'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _goalsAndTargets.Title,
	          null,
	          'Set Team Goals & Targets'
	        ),
	        _react2.default.createElement(
	          _goalsAndTargets.FormWrapper,
	          null,
	          _react2.default.createElement(
	            _goalsAndTargets.InfoTooltip,
	            null,
	            _react2.default.createElement('img', { src: _infoTooltip2.default, alt: 'info tooltip icon' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Benchmark: industry targets'
	            )
	          ),
	          _react2.default.createElement(
	            _goalsAndTargets.Description,
	            null,
	            'Below shows the financial targets that teams have to hit each year. Note not all financial metrics are relevant in each year.'
	          ),
	          _react2.default.createElement(
	            _goalsAndTargets.Form,
	            { maxWidth: '800px' },
	            _react2.default.createElement(_FinancialTargets2.default, {
	              round: activeRound,
	              financialTargets: financialTargets,
	              showTableOnly: true,
	              showFullTable: true,
	              hideTitle: true,
	              padding: '0px',
	              onHelpIconClick: this.onHelpIconClick
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _goalsAndTargets.Text,
	          null,
	          'To modify any of the targets above, please navigate to Grading (loc: Game Admin --> Grading)'
	        )
	      ) : _react2.default.createElement(
	        _goalsAndTargets.Wrapper,
	        null,
	        _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return Number(roundInUrl || currentRound);
	    }
	  }]);
	
	  return GoalsAndTargets;
	}(_react.PureComponent);
	
	exports.default = GoalsAndTargets;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  width: 80%;\n  max-width: 1040px;\n  @media (max-width: 1630px) {\n    width: 100%;\n  }\n'], ['\n  flex: 1;\n  width: 80%;\n  max-width: 1040px;\n  @media (max-width: 1630px) {\n    width: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _navigation = __webpack_require__(1445);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _pagination = __webpack_require__(1446);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _overallScore = __webpack_require__(1447);
	
	var _overallScore2 = _interopRequireDefault(_overallScore);
	
	var _teamScore = __webpack_require__(1448);
	
	var _teamScore2 = _interopRequireDefault(_teamScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Peer Score / Feedback Submission / Engagement Score pages are
	// no longer mounted in the grading nav. The component files remain
	// on disk for reference but are not imported here.
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject3);
	
	var InstructorGrading = function (_PureComponent) {
	  _inherits(InstructorGrading, _PureComponent);
	
	  function InstructorGrading(props) {
	    _classCallCheck(this, InstructorGrading);
	
	    var _this = _possibleConstructorReturn(this, (InstructorGrading.__proto__ || Object.getPrototypeOf(InstructorGrading)).call(this, props));
	
	    _this.updateCurrentState = function () {
	      var navigation = _this.state.navigation;
	
	
	      var currentCategory = 0;
	      var currentStep = 0;
	      for (var i = 0; i < navigation.length; i++) {
	        var stepIndex = navigation[i].steps.findIndex(function (j) {
	          return j.url === _this.props.location.pathname;
	        });
	        if (stepIndex > -1) {
	          currentCategory = i;
	          currentStep = stepIndex;
	          break;
	        }
	      }
	
	      if (currentCategory !== _this.state.currentCategory || currentStep !== _this.state.currentStep) {
	
	        _this.setState({
	          currentCategory: currentCategory,
	          currentStep: currentStep
	        }, function () {
	          _this.checkLocation();
	        });
	      } else {
	        if (_this.props.location.pathname === '/grading') {
	          _this.checkLocation();
	        }
	      }
	      _this.setState({
	        loaded: true
	      });
	    };
	
	    _this.checkLocation = function () {
	      var _this$state = _this.state,
	          currentCategory = _this$state.currentCategory,
	          currentStep = _this$state.currentStep,
	          navigation = _this$state.navigation;
	
	      var activeRound = _this.activeRound;
	
	      if (_this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
	        (0, _Location.changeLocation)(navigation[currentCategory].steps[currentStep].url + '?round=' + activeRound);
	      }
	    };
	
	    _this.goNext = function (e) {
	      e.preventDefault();
	
	      var _this$state2 = _this.state,
	          currentCategory = _this$state2.currentCategory,
	          currentStep = _this$state2.currentStep,
	          navigation = _this$state2.navigation;
	
	
	      var nextCategory = currentCategory;
	      var nextStep = currentStep + 1;
	      if (nextStep >= navigation[currentCategory].steps.length) {
	        nextCategory = currentCategory + 1;
	        nextStep = 0;
	
	        if (nextCategory >= navigation.length) {
	          return false;
	        } else if (nextStep >= navigation[nextCategory].steps.length) {
	          nextCategory = currentCategory + 2;
	          nextStep = 0;
	
	          if (nextCategory >= navigation.length) {
	            return false;
	          }
	        }
	      }
	
	      _this.setState({
	        currentCategory: nextCategory,
	        currentStep: nextStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.goPrev = function (e) {
	      e.preventDefault();
	
	      var _this$state3 = _this.state,
	          currentCategory = _this$state3.currentCategory,
	          currentStep = _this$state3.currentStep,
	          navigation = _this$state3.navigation;
	
	
	      var prevCategory = currentCategory;
	      var prevStep = currentStep - 1;
	      if (prevStep < 0) {
	        prevCategory = currentCategory - 1;
	        if (prevCategory < 0) {
	          return false;
	        }
	
	        prevStep = navigation[prevCategory].steps.length - 1;
	        if (prevStep < 0) {
	          prevCategory = currentCategory - 2;
	          if (prevCategory < 0) {
	            return false;
	          }
	
	          prevStep = navigation[prevCategory].steps.length - 1;
	        }
	      }
	
	      _this.setState({
	        currentCategory: prevCategory,
	        currentStep: prevStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.state = {
	      currentCategory: 0,
	      currentStep: 0,
	      navigation: [],
	      loaded: false,
	      round: {},
	      roundId: 0
	    };
	    return _this;
	  }
	
	  _createClass(InstructorGrading, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	
	      var roundId = round ? round.id : 0;
	      this.setState({
	        round: round,
	        roundId: roundId
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.loadNavigation(function () {
	        _this2.updateCurrentState();
	      });
	    }
	  }, {
	    key: 'loadNavigation',
	    value: function loadNavigation(callback) {
	
	      // Trimmed to 2 sections. Round Targets is now the landing page
	      // (was 'Team Score'). Scoring Weights consolidates both round
	      // weights (formerly under Team Score) and activity score weights
	      // (formerly Overall Score).
	      var navigation = [{
	        title: 'Round Targets',
	        pattern: '/instructor/grading/team-score',
	        steps: [{
	          url: '/instructor/grading/team-score',
	          component: _teamScore2.default
	        }]
	      }, {
	        title: 'Scoring Weights',
	        pattern: '/instructor/grading/overall-score',
	        steps: [{
	          url: '/instructor/grading/overall-score',
	          component: _overallScore2.default
	        }]
	      }];
	
	      if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
	        this.setState({
	          navigation: navigation
	        }, function () {
	          if (callback) {
	            callback();
	          }
	        });
	      } else {
	        if (callback) {
	          callback();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.pathname !== this.props.location.pathname) {
	        this.updateCurrentState();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentCategory = _state.currentCategory,
	          currentStep = _state.currentStep,
	          navigation = _state.navigation,
	          loaded = _state.loaded,
	          roundId = _state.roundId;
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	
	      if (navigation.length === 0 || !loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      var category = navigation[currentCategory];
	      var Component = null;
	      if (category) {
	        Component = category.steps[currentStep].component;
	      }
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_navigation2.default, {
	          data: navigation,
	          category: currentCategory,
	          activeRound: activeRound
	        }),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            ContentWrapper,
	            null,
	            Component && _react2.default.createElement(Component, {
	              activeRound: activeRound,
	              rounds: rounds,
	              roundId: roundId
	            })
	          ),
	          _react2.default.createElement(_pagination2.default, {
	            goNext: this.goNext,
	            goPrev: this.goPrev,
	            isFirstStep: this.isFirstStep,
	            isLastStep: this.isLastStep,
	            currentStep: currentStep + 1,
	            countOfSteps: this.countOfSteps
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	
	      return Number(roundInUrl || currentRound);
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentCategory = _state2.currentCategory,
	          currentStep = _state2.currentStep;
	
	
	      return currentCategory === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          currentCategory = _state3.currentCategory,
	          currentStep = _state3.currentStep,
	          navigation = _state3.navigation;
	
	
	      var lastCategory = navigation.length - 1;
	      var lastStep = navigation[lastCategory].steps.length - 1;
	
	      return currentCategory === lastCategory && currentStep === lastStep;
	    }
	  }, {
	    key: 'countOfSteps',
	    get: function get() {
	      var _state4 = this.state,
	          currentCategory = _state4.currentCategory,
	          navigation = _state4.navigation;
	
	
	      return navigation[currentCategory].steps.length;
	    }
	  }]);
	
	  return InstructorGrading;
	}(_react.PureComponent);
	
	exports.default = InstructorGrading;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Intro = __webpack_require__(1450);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _PathChoice = __webpack_require__(1451);
	
	var _PathChoice2 = _interopRequireDefault(_PathChoice);
	
	var _SimulationSelection = __webpack_require__(1452);
	
	var _SimulationSelection2 = _interopRequireDefault(_SimulationSelection);
	
	var _TeamEvaluationSurvey = __webpack_require__(1453);
	
	var _TeamEvaluationSurvey2 = _interopRequireDefault(_TeamEvaluationSurvey);
	
	var _onboardingRouting = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// First-login onboarding for instructors. Triggered from
	// start.js when user.onboard === 0 AND no game exists. The
	// container dispatches on the :step route param to one of the
	// four page components; unknown steps redirect back to intro.
	
	var STEP_COMPONENTS = {
	  'intro': _Intro2.default,
	  'path-choice': _PathChoice2.default,
	  'simulation-selection': _SimulationSelection2.default,
	  'team-evaluation-survey': _TeamEvaluationSurvey2.default
	};
	
	var InstructorOnboardingPage = function (_Component) {
	  _inherits(InstructorOnboardingPage, _Component);
	
	  function InstructorOnboardingPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InstructorOnboardingPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstructorOnboardingPage.__proto__ || Object.getPrototypeOf(InstructorOnboardingPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // null until fetchOnboardingSetup resolves. Prevents rendering a
	      // step (or redirecting) before we know whether the current course
	      // is missing a game or a survey.
	      setup: null
	    }, _this.resolveEntry = function () {
	      (0, _onboardingRouting.fetchOnboardingSetup)().then(function (setup) {
	        if (_this.checkRedirect(setup)) return;
	        _this.setState({ setup: setup });
	        _this.normalize();
	      }).catch(function () {
	        // Best-effort: on failure just render the requested step so
	        // the user isn't blocked.
	        _this.setState({ setup: { hasGame: false, hasSurvey: false } });
	        _this.normalize();
	      });
	    }, _this.checkRedirect = function (setup) {
	      var user = _Auth2.default.getUser();
	      var onboardComplete = !!(user && user.onboard !== 0);
	      var needsSetup = !setup.hasGame || !setup.hasSurvey;
	      var params = _this.props.params;
	
	      var currentStep = params && params.step || 'intro';
	
	      console.log('[MG:onboarding] container.checkRedirect input:', {
	        currentStep: currentStep, onboardComplete: onboardComplete, hasGame: setup.hasGame, hasSurvey: setup.hasSurvey, needsSetup: needsSetup
	      });
	
	      if (onboardComplete && !needsSetup) {
	        console.log('[MG:onboarding] container.checkRedirect -> /instructor/welcome (already onboarded, no setup needed)');
	        (0, _Location.changeLocation)('/instructor/welcome');
	        return true;
	      }
	
	      // If the current step should be skipped (e.g. user landed on
	      // /simulation-selection but a game already exists), forward
	      // them to the next needed step.
	      var skipReason = currentStep === 'path-choice' && onboardComplete || currentStep === 'simulation-selection' && setup.hasGame || currentStep === 'team-evaluation-survey' && setup.hasSurvey;
	      if (skipReason) {
	        var next = (0, _onboardingRouting.getNextOnboardingStep)(currentStep, {
	          hasGame: setup.hasGame,
	          hasSurvey: setup.hasSurvey,
	          onboardComplete: onboardComplete
	        });
	        console.log('[MG:onboarding] container.checkRedirect -> skipping', currentStep, 'to', next);
	        (0, _Location.changeLocation)(next);
	        return true;
	      }
	      console.log('[MG:onboarding] container.checkRedirect -> staying on', currentStep);
	      return false;
	    }, _this.normalize = function () {
	      var params = _this.props.params;
	
	      var step = params && params.step;
	      if (step && STEP_COMPONENTS[step]) return;
	      if (!step) return;
	      (0, _Location.changeLocation)('/instructor/onboarding/intro');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InstructorOnboardingPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.resolveEntry();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var prevStep = prevProps.params && prevProps.params.step;
	      var currStep = this.props.params && this.props.params.step;
	      if (prevStep !== currStep) {
	        this.resolveEntry();
	      }
	    }
	
	    // Fetch { hasGame, hasSurvey } for the current course and decide:
	    //  - Should this URL be skipped (already-satisfied step)?
	    //  - Should this user even be here (already fully onboarded AND
	    //    course has both a game and survey)?
	
	
	    // Users who have already completed onboarding AND whose course is
	    // fully set up shouldn't re-enter the flow — send them to welcome.
	    // Users still mid-flow (user.onboard === 0), OR onboarded users
	    // whose course is missing a game/survey, ARE allowed in.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var setup = this.state.setup;
	
	      if (!setup) return null;
	      var params = this.props.params;
	
	      var step = params && params.step || 'intro';
	      var StepComponent = STEP_COMPONENTS[step] || _Intro2.default;
	      return _react2.default.createElement(StepComponent, Object.assign({}, this.props, { onboardingSetup: setup }));
	    }
	  }]);
	
	  return InstructorOnboardingPage;
	}(_react.Component);
	
	exports.default = InstructorOnboardingPage;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n\n  ', '\n'], ['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ApiService = __webpack_require__(4);
	
	var _Location = __webpack_require__(23);
	
	var _Surveys = __webpack_require__(56);
	
	var _Teams = __webpack_require__(10);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _navigation = __webpack_require__(1454);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _pagination = __webpack_require__(1455);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _biggestTakeaway = __webpack_require__(1463);
	
	var _biggestTakeaway2 = _interopRequireDefault(_biggestTakeaway);
	
	var _doDifferently = __webpack_require__(1464);
	
	var _doDifferently2 = _interopRequireDefault(_doDifferently);
	
	var _theTeam = __webpack_require__(1467);
	
	var _theTeam2 = _interopRequireDefault(_theTeam);
	
	var _teamDynamics = __webpack_require__(1466);
	
	var _teamDynamics2 = _interopRequireDefault(_teamDynamics);
	
	var _teamDynamicsPerformance = __webpack_require__(1465);
	
	var _teamDynamicsPerformance2 = _interopRequireDefault(_teamDynamicsPerformance);
	
	var _theIndividual = __webpack_require__(1462);
	
	var _theIndividual2 = _interopRequireDefault(_theIndividual);
	
	var _mostLeastValuablePlayers = __webpack_require__(1459);
	
	var _mostLeastValuablePlayers2 = _interopRequireDefault(_mostLeastValuablePlayers);
	
	var _selfAssessment = __webpack_require__(1461);
	
	var _selfAssessment2 = _interopRequireDefault(_selfAssessment);
	
	var _peerRating = __webpack_require__(1460);
	
	var _peerRating2 = _interopRequireDefault(_peerRating);
	
	var _inclusiveness = __webpack_require__(1458);
	
	var _inclusiveness2 = _interopRequireDefault(_inclusiveness);
	
	var _dominantPersonalities = __webpack_require__(1457);
	
	var _dominantPersonalities2 = _interopRequireDefault(_dominantPersonalities);
	
	var _strengthsAndAreasOfDevelopment = __webpack_require__(1468);
	
	var _strengthsAndAreasOfDevelopment2 = _interopRequireDefault(_strengthsAndAreasOfDevelopment);
	
	var _teamworkSkills = __webpack_require__(1469);
	
	var _teamworkSkills2 = _interopRequireDefault(_teamworkSkills);
	
	var _thatsAll = __webpack_require__(1470);
	
	var _thatsAll2 = _interopRequireDefault(_thatsAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.wideContentWrapper && '\n    width: 100%;\n    max-width: 1240px;\n  ';
	});
	
	var InstructorPeerFeedback = function (_PureComponent) {
	  _inherits(InstructorPeerFeedback, _PureComponent);
	
	  function InstructorPeerFeedback(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, InstructorPeerFeedback);
	
	    var _this = _possibleConstructorReturn(this, (InstructorPeerFeedback.__proto__ || Object.getPrototypeOf(InstructorPeerFeedback)).call(this, props));
	
	    _this.fetchGamesTeamplayers = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(nextPage) {
	        var nextPageAvailable, gamesTeamplayers, nextPageUrl;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                nextPageAvailable = true;
	                gamesTeamplayers = [];
	                nextPageUrl = nextPage;
	
	              case 3:
	                if (!nextPageAvailable) {
	                  _context.next = 9;
	                  break;
	                }
	
	                nextPageAvailable = false;
	                _context.next = 7;
	                return (0, _ApiService.getRequest)(nextPageUrl)
	                // eslint-disable-next-line no-loop-func
	                .then(function (res) {
	                  nextPageUrl = res.body.next;
	                  nextPageAvailable = nextPageUrl;
	                  gamesTeamplayers.push.apply(gamesTeamplayers, _toConsumableArray(res.body.results));
	                }).catch(function (err) {});
	
	              case 7:
	                _context.next = 3;
	                break;
	
	              case 9:
	                return _context.abrupt('return', gamesTeamplayers);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.updateCurrentState = function () {
	      var navigation = _this.state.navigation;
	
	
	      var currentCategory = 0;
	      var currentStep = 0;
	      for (var i = 0; i < navigation.length; i++) {
	        var stepIndex = navigation[i].steps.findIndex(function (j) {
	          return j.url === _this.props.location.pathname;
	        });
	        if (stepIndex > -1) {
	          currentCategory = i;
	          currentStep = stepIndex;
	          break;
	        }
	      }
	
	      if (!navigation[currentCategory].steps.length) {
	        currentCategory += 1;
	      }
	
	      if (currentCategory !== _this.state.currentCategory || currentStep !== _this.state.currentStep) {
	
	        _this.setState({
	          currentCategory: currentCategory,
	          currentStep: currentStep
	        }, function () {
	          _this.checkLocation();
	        });
	      } else {
	        if (_this.props.location.pathname === '/peer-feedback') {
	          _this.checkLocation();
	        }
	      }
	    };
	
	    _this.checkLocation = function () {
	      var _this$state = _this.state,
	          currentCategory = _this$state.currentCategory,
	          currentStep = _this$state.currentStep,
	          navigation = _this$state.navigation;
	
	      var activeRound = _this.activeRound;
	      var activeSurvey = _this.activeSurvey;
	
	      if (_this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
	        (0, _Location.changeLocation)(navigation[currentCategory].steps[currentStep].url + '?round=' + activeRound + '&survey=' + activeSurvey);
	      }
	    };
	
	    _this.goNext = function (e) {
	      e.preventDefault();
	
	      var _this$state2 = _this.state,
	          currentCategory = _this$state2.currentCategory,
	          currentStep = _this$state2.currentStep,
	          navigation = _this$state2.navigation;
	
	
	      var nextCategory = currentCategory;
	      var nextStep = currentStep + 1;
	      if (nextStep >= navigation[currentCategory].steps.length) {
	        nextCategory = currentCategory + 1;
	        nextStep = 0;
	
	        if (nextCategory >= navigation.length) {
	          return false;
	        } else if (nextStep >= navigation[nextCategory].steps.length) {
	          nextCategory = currentCategory + 2;
	          nextStep = 0;
	
	          if (nextCategory >= navigation.length) {
	            return false;
	          }
	        }
	      }
	
	      _this.setState({
	        currentCategory: nextCategory,
	        currentStep: nextStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.goPrev = function (e) {
	      e.preventDefault();
	
	      var _this$state3 = _this.state,
	          currentCategory = _this$state3.currentCategory,
	          currentStep = _this$state3.currentStep,
	          navigation = _this$state3.navigation;
	
	
	      var prevCategory = currentCategory;
	      var prevStep = currentStep - 1;
	      if (prevStep < 0) {
	        prevCategory = currentCategory - 1;
	        if (prevCategory < 0) {
	          return false;
	        }
	
	        prevStep = navigation[prevCategory].steps.length - 1;
	        if (prevStep < 0) {
	          prevCategory = currentCategory - 2;
	          if (prevCategory < 0) {
	            return false;
	          }
	
	          prevStep = navigation[prevCategory].steps.length - 1;
	        }
	      }
	
	      _this.setState({
	        currentCategory: prevCategory,
	        currentStep: prevStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.formsSurveysRun = function () {
	      var lastFinishedSurvey = _this.state.lastFinishedSurvey;
	
	      _this.setState({
	        loaded: false
	      });
	      (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + lastFinishedSurvey.id + '/calc-score/').then(function () {
	        (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/survey-view-results/' + lastFinishedSurvey.id + '/').then(function () {
	          _this.setState({
	            loaded: true
	          });
	        }).catch(function (err) {
	          console.log(err);
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    };
	
	    _this.state = {
	      currentCategory: 0,
	      currentStep: 0,
	      navigation: [],
	      loaded: false,
	      round: {},
	      roundId: 0,
	      showPeerFeedbackPages: true,
	      finishedSurveys: [],
	      lastFinishedSurvey: {},
	      surveysTeamScore: {},
	      surveysStatsByUser: {},
	      playersCompletedSurveysCount: 0,
	      gamesTeamplayers: [],
	      teams: [],
	      surveysStatsByTeam: [],
	      surveysStats: []
	    };
	    return _this;
	  }
	
	  _createClass(InstructorPeerFeedback, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	
	      var roundId = round ? round.id : 0;
	      this.setState({
	        round: round,
	        roundId: roundId
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.loadNavigation(function () {
	        _this3.updateCurrentState();
	      });
	    }
	  }, {
	    key: 'loadNavigation',
	    value: function loadNavigation(callback) {
	      var _this4 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/?course=' + _Auth2.default.getCourseId()).then(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(res) {
	          var surveys, finishedSurveys, lastFinishedSurvey, lastFinishedSurveyStage, activeSurvey, activeFinishedSurvey, activeSurveyID;
	          return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	              switch (_context3.prev = _context3.next) {
	                case 0:
	                  surveys = res.body.results;
	                  finishedSurveys = surveys && surveys.length > 0 ? surveys.filter(function (i) {
	                    return (0, _Surveys.isSurveyFinished)(i);
	                  }) : [];
	                  lastFinishedSurvey = finishedSurveys.length > 0 ? finishedSurveys[finishedSurveys.length - 1] : null;
	                  lastFinishedSurveyStage = lastFinishedSurvey ? lastFinishedSurvey.stage : 0;
	                  activeSurvey = _this4.activeSurvey ? _this4.activeSurvey : lastFinishedSurveyStage;
	                  activeFinishedSurvey = finishedSurveys.find(function (survey) {
	                    return survey.stage === activeSurvey;
	                  });
	                  activeSurveyID = activeFinishedSurvey ? activeFinishedSurvey.id : 0;
	
	
	                  (0, _ApiService.batchRequest)([("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + activeSurveyID + '/team-score/', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + activeSurveyID + '/stats-by-user/', ("https://be-production-itb.marketgames.io/api/") + 'v2/games/teamplayers/?game=' + _Auth2.default.getGameId(), (0, _Teams.teamsEndpoint)(), ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + activeSurveyID + '/stats-by-team/', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + activeSurveyID + '/stats/']).then(function () {
	                    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	                      var surveysTeamScore, surveysStatsByUser, gamesTeamplayers, nextPageAvailable, newGamesTeamplayers, teams, surveysStatsByTeam, playersCompletedSurveysCount, showPeerFeedbackPages, showBiggestTakeaway, showDoDifferently, surveysStats, surveysStatsIndividualAssessmentQuestions, surveyQuestions, showSkillsAssessment, navigation;
	                      return _regenerator2.default.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              surveysTeamScore = res[0].body;
	                              surveysStatsByUser = res[1].body;
	                              gamesTeamplayers = res[2].body.results;
	                              nextPageAvailable = res[2].body.next;
	
	                              if (!nextPageAvailable) {
	                                _context2.next = 9;
	                                break;
	                              }
	
	                              _context2.next = 7;
	                              return _this4.fetchGamesTeamplayers(nextPageAvailable);
	
	                            case 7:
	                              newGamesTeamplayers = _context2.sent;
	
	                              gamesTeamplayers.push.apply(gamesTeamplayers, _toConsumableArray(newGamesTeamplayers));
	
	                            case 9:
	                              teams = res[3].body;
	                              surveysStatsByTeam = res[4].body;
	                              playersCompletedSurveysCount = surveysStatsByUser.filter(function (i) {
	                                return i.evaluation_completed === true;
	                              }).length;
	                              showPeerFeedbackPages = true;
	
	                              if (!surveysTeamScore || Object.keys(surveysTeamScore).length === 0 || surveysTeamScore.detail === 'Not found.') {
	                                showPeerFeedbackPages = false;
	                              }
	
	                              showBiggestTakeaway = !!activeFinishedSurvey.questions.find(function (i) {
	                                return i.text.toLowerCase().includes('biggest takeaway');
	                              });
	                              showDoDifferently = !!activeFinishedSurvey.questions.find(function (i) {
	                                return i.text.toLowerCase().includes('chance to do it all over again');
	                              });
	                              surveysStats = res[5].body;
	                              surveysStatsIndividualAssessmentQuestions = surveysStats.filter(function (surveyStats) {
	                                return surveyStats.question_text.toLowerCase().indexOf('having relevant knowledge, skills, and abilities') > -1 || surveyStats.question_text.toLowerCase().indexOf('handling conflicts') > -1;
	                              });
	                              surveyQuestions = surveys.flatMap(function (survey) {
	                                return survey.questions;
	                              });
	                              showSkillsAssessment = !!surveyQuestions.find(function (surveyQuestion) {
	                                return surveyQuestion.category === 'other';
	                              });
	                              navigation = [{
	                                title: 'Dynamics',
	                                pattern: '/instructor/peer-feedback/dynamics',
	                                steps: []
	                              }, {
	                                parent: 'Dynamics',
	                                title: 'Team',
	                                pattern: '/instructor/peer-feedback/team',
	                                steps: [].concat(_toConsumableArray(showBiggestTakeaway ? [{
	                                  url: '/instructor/peer-feedback/team/biggest-takeaway',
	                                  component: _biggestTakeaway2.default
	                                }] : []), _toConsumableArray(showDoDifferently ? [{
	                                  url: '/instructor/peer-feedback/team/do-differently',
	                                  component: _doDifferently2.default
	                                }] : []), [{
	                                  url: '/instructor/peer-feedback/team/the-team',
	                                  component: _theTeam2.default
	                                }, {
	                                  url: '/instructor/peer-feedback/team/team-dynamics',
	                                  component: _teamDynamics2.default
	                                }, {
	                                  url: '/instructor/peer-feedback/team/team-dynamics-performance',
	                                  component: _teamDynamicsPerformance2.default
	                                }])
	                              }, {
	                                parent: 'Dynamics',
	                                title: 'Individual',
	                                pattern: '/instructor/peer-feedback/individual',
	                                steps: [{
	                                  url: '/instructor/peer-feedback/individual/the-individual',
	                                  component: _theIndividual2.default
	                                }, {
	                                  url: '/instructor/peer-feedback/individual/most-least-valuable-players',
	                                  component: _mostLeastValuablePlayers2.default
	                                }].concat(_toConsumableArray(surveysStatsIndividualAssessmentQuestions.length ? [{
	                                  url: '/instructor/peer-feedback/individual/self-assessment',
	                                  component: _selfAssessment2.default
	                                }] : []), [{
	                                  url: '/instructor/peer-feedback/individual/peer-rating',
	                                  component: _peerRating2.default
	                                }, {
	                                  url: '/instructor/peer-feedback/individual/inclusiveness',
	                                  component: _inclusiveness2.default
	                                }, {
	                                  url: '/instructor/peer-feedback/individual/dominant-personalities',
	                                  component: _dominantPersonalities2.default
	                                }])
	                              }].concat(_toConsumableArray(showSkillsAssessment ? [{
	                                title: 'Skills Assessment',
	                                pattern: '/instructor/peer-feedback/skills-assessment',
	                                steps: [{
	                                  url: '/instructor/peer-feedback/skills-assessment/intro',
	                                  component: _strengthsAndAreasOfDevelopment2.default
	                                }, {
	                                  url: '/instructor/peer-feedback/skills-assessment/radar-map',
	                                  component: _teamworkSkills2.default
	                                }]
	                              }] : []), [{
	                                title: 'That’s All!',
	                                pattern: '/instructor/peer-feedback/thats-all',
	                                steps: [{
	                                  url: '/instructor/peer-feedback/thats-all',
	                                  component: _thatsAll2.default
	                                }]
	                              }]);
	
	
	                              if (JSON.stringify(navigation) !== JSON.stringify(_this4.state.navigation)) {
	                                _this4.setState({
	                                  navigation: navigation,
	                                  loaded: true,
	                                  showPeerFeedbackPages: showPeerFeedbackPages,
	                                  finishedSurveys: finishedSurveys,
	                                  lastFinishedSurvey: lastFinishedSurvey,
	                                  surveysTeamScore: surveysTeamScore,
	                                  surveysStatsByUser: surveysStatsByUser,
	                                  playersCompletedSurveysCount: playersCompletedSurveysCount,
	                                  gamesTeamplayers: gamesTeamplayers,
	                                  teams: teams,
	                                  surveysStatsByTeam: surveysStatsByTeam,
	                                  surveysStats: surveysStats
	                                }, function () {
	                                  if (callback) {
	                                    callback();
	                                  }
	                                });
	                              } else {
	                                if (callback) {
	                                  callback();
	                                }
	                              }
	
	                            case 22:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this4);
	                    }));
	
	                    return function (_x3) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }()).catch(function (err) {});
	
	                case 8:
	                case 'end':
	                  return _context3.stop();
	              }
	            }
	          }, _callee3, _this4);
	        }));
	
	        return function (_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }()).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.pathname !== this.props.location.pathname) {
	        this.updateCurrentState();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentCategory = _state.currentCategory,
	          currentStep = _state.currentStep,
	          navigation = _state.navigation,
	          loaded = _state.loaded,
	          roundId = _state.roundId,
	          showPeerFeedbackPages = _state.showPeerFeedbackPages,
	          finishedSurveys = _state.finishedSurveys,
	          lastFinishedSurvey = _state.lastFinishedSurvey,
	          surveysTeamScore = _state.surveysTeamScore,
	          surveysStatsByUser = _state.surveysStatsByUser,
	          playersCompletedSurveysCount = _state.playersCompletedSurveysCount,
	          gamesTeamplayers = _state.gamesTeamplayers,
	          teams = _state.teams,
	          surveysStatsByTeam = _state.surveysStatsByTeam,
	          surveysStats = _state.surveysStats;
	      var _props = this.props,
	          rounds = _props.rounds,
	          location = _props.location;
	
	      var activeRound = this.activeRound;
	      var activeSurvey = this.activeSurvey;
	
	      if (navigation.length === 0 || !loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      var category = navigation[currentCategory].steps.length ? navigation[currentCategory] : navigation[currentCategory + 1];
	      var Component = null;
	      if (category) {
	        Component = category.steps[currentStep].component;
	      }
	
	      var modalWindowMessage = _react2.default.createElement(
	        'p',
	        null,
	        playersCompletedSurveysCount,
	        ' out of ',
	        gamesTeamplayers.length,
	        ' students completed the peer evaluation (',
	        _react2.default.createElement(
	          'a',
	          { target: '_black', href: '/instructor/teams-roles' },
	          'view completion list'
	        ),
	        ')'
	      );
	
	      var currentFinishedSurvey = finishedSurveys.find(function (survey) {
	        return survey.stage === activeSurvey;
	      });
	
	      var wideContentWrapper = location.pathname.includes('biggest-takeaway') || location.pathname.includes('do-differently') ? true : false;
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_navigation2.default, {
	          data: navigation,
	          category: currentCategory,
	          activeRound: activeRound
	        }),
	        !showPeerFeedbackPages && _react2.default.createElement(_decisions2.default, {
	          type: 'info',
	          title: lastFinishedSurvey.stage[0].toUpperCase() + lastFinishedSurvey.stage.slice(1) + ' Peer Evaluation Is Now Closed',
	          message: modalWindowMessage,
	          buttonText: 'Process/View Insights',
	          buttonCenterAlign: true,
	          onHide: this.formsSurveysRun
	        }),
	        showPeerFeedbackPages && _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            ContentWrapper,
	            { wideContentWrapper: wideContentWrapper },
	            Component && _react2.default.createElement(Component, {
	              activeRound: activeRound,
	              rounds: rounds,
	              roundId: roundId,
	              surveysTeamScore: surveysTeamScore,
	              surveysStatsByUser: surveysStatsByUser,
	              gamesTeamplayers: gamesTeamplayers,
	              finishedSurveys: finishedSurveys,
	              lastFinishedSurvey: lastFinishedSurvey,
	              teams: teams,
	              surveysStatsByTeam: surveysStatsByTeam,
	              surveysStats: surveysStats,
	              currentFinishedSurvey: currentFinishedSurvey
	            })
	          ),
	          _react2.default.createElement(_pagination2.default, {
	            goNext: this.goNext,
	            goPrev: this.goPrev,
	            isFirstStep: this.isFirstStep,
	            isLastStep: this.isLastStep,
	            currentStep: currentStep + 1,
	            countOfSteps: this.countOfSteps
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          roundInUrl = _props2.roundInUrl;
	
	
	      return Number(roundInUrl || currentRound);
	    }
	  }, {
	    key: 'activeSurvey',
	    get: function get() {
	      var location = this.props.location;
	      var lastFinishedSurvey = this.state.lastFinishedSurvey;
	
	      var surveyInUrl = _lodash2.default.get(location, 'query.survey', null);
	
	      return surveyInUrl || lastFinishedSurvey.stage;
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentCategory = _state2.currentCategory,
	          currentStep = _state2.currentStep;
	
	
	      return currentCategory === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          currentCategory = _state3.currentCategory,
	          currentStep = _state3.currentStep,
	          navigation = _state3.navigation;
	
	
	      var lastCategory = navigation.length - 1;
	      var lastStep = navigation[lastCategory].steps.length - 1;
	
	      return currentCategory === lastCategory && currentStep === lastStep;
	    }
	  }, {
	    key: 'countOfSteps',
	    get: function get() {
	      var _state4 = this.state,
	          currentCategory = _state4.currentCategory,
	          navigation = _state4.navigation;
	
	
	      return navigation[currentCategory].steps.length;
	    }
	  }]);
	
	  return InstructorPeerFeedback;
	}(_react.PureComponent);
	
	exports.default = InstructorPeerFeedback;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  background: #f5f6f7;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n'], ['\n  flex: 1;\n  width: 80%;\n  max-width: 794px;\n  background: #f5f6f7;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n  align-self: stretch;\n  min-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: #f5f6f7;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n'], ['\n  flex: 1;\n  align-self: stretch;\n  min-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: #f5f6f7;\n  text-align: center;\n  font-family: \'Mukta Vaani\', sans-serif;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  margin: 0 0 12px;\n  color: #0F172A;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 1.2;\n'], ['\n  margin: 0 0 12px;\n  color: #0F172A;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 1.2;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  margin: 0;\n  color: #475569;\n  font-size: 16px;\n  line-height: 1.5;\n  max-width: 480px;\n'], ['\n  margin: 0;\n  color: #475569;\n  font-size: 16px;\n  line-height: 1.5;\n  max-width: 480px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ApiService = __webpack_require__(4);
	
	var _Location = __webpack_require__(23);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _navigation = __webpack_require__(1471);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _pagination = __webpack_require__(1472);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _step = __webpack_require__(1475);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(1476);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(1477);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(1478);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(1479);
	
	var _step10 = _interopRequireDefault(_step9);
	
	var _whyTargetsWerentHit = __webpack_require__(1492);
	
	var _whyTargetsWerentHit2 = _interopRequireDefault(_whyTargetsWerentHit);
	
	var _decisionsNotSubmitted = __webpack_require__(1488);
	
	var _decisionsNotSubmitted2 = _interopRequireDefault(_decisionsNotSubmitted);
	
	var _insufficientCapital = __webpack_require__(1493);
	
	var _insufficientCapital2 = _interopRequireDefault(_insufficientCapital);
	
	var _step11 = __webpack_require__(1494);
	
	var _step12 = _interopRequireDefault(_step11);
	
	var _step13 = __webpack_require__(1495);
	
	var _step14 = _interopRequireDefault(_step13);
	
	var _step15 = __webpack_require__(1496);
	
	var _step16 = _interopRequireDefault(_step15);
	
	var _step17 = __webpack_require__(1497);
	
	var _step18 = _interopRequireDefault(_step17);
	
	var _step19 = __webpack_require__(1498);
	
	var _step20 = _interopRequireDefault(_step19);
	
	var _step21 = __webpack_require__(1499);
	
	var _step22 = _interopRequireDefault(_step21);
	
	var _step23 = __webpack_require__(1500);
	
	var _step24 = _interopRequireDefault(_step23);
	
	var _step25 = __webpack_require__(1502);
	
	var _step26 = _interopRequireDefault(_step25);
	
	var _step27 = __webpack_require__(1503);
	
	var _step28 = _interopRequireDefault(_step27);
	
	var _step29 = __webpack_require__(1490);
	
	var _step30 = _interopRequireDefault(_step29);
	
	var _step31 = __webpack_require__(1491);
	
	var _step32 = _interopRequireDefault(_step31);
	
	var _step33 = __webpack_require__(1506);
	
	var _step34 = _interopRequireDefault(_step33);
	
	var _netLoss = __webpack_require__(1501);
	
	var _netLoss2 = _interopRequireDefault(_netLoss);
	
	var _step35 = __webpack_require__(1505);
	
	var _step36 = _interopRequireDefault(_step35);
	
	var _step37 = __webpack_require__(1504);
	
	var _step38 = _interopRequireDefault(_step37);
	
	var _step39 = __webpack_require__(1489);
	
	var _step40 = _interopRequireDefault(_step39);
	
	var _whatToExpectNext = __webpack_require__(1482);
	
	var _whatToExpectNext2 = _interopRequireDefault(_whatToExpectNext);
	
	var _supplyChainDecisions = __webpack_require__(1487);
	
	var _supplyChainDecisions2 = _interopRequireDefault(_supplyChainDecisions);
	
	var _customerPreferences = __webpack_require__(1481);
	
	var _customerPreferences2 = _interopRequireDefault(_customerPreferences);
	
	var _productStrategy = __webpack_require__(1485);
	
	var _productStrategy2 = _interopRequireDefault(_productStrategy);
	
	var _newScoringMetrics = __webpack_require__(1483);
	
	var _newScoringMetrics2 = _interopRequireDefault(_newScoringMetrics);
	
	var _newValuationModel = __webpack_require__(1484);
	
	var _newValuationModel2 = _interopRequireDefault(_newValuationModel);
	
	var _shareBuybacks = __webpack_require__(1486);
	
	var _shareBuybacks2 = _interopRequireDefault(_shareBuybacks);
	
	var _thatsAll = __webpack_require__(1480);
	
	var _thatsAll2 = _interopRequireDefault(_thatsAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// import MarketShareStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step1';
	
	//import MarketShareStep8 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step8';
	
	
	// import RevenuesStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/revenues/step1';
	
	
	// import GrossMarginsStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/gross-margins/step1';
	
	
	// import SharePriceStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/share-price/step1';
	
	
	// import ROEStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/roe/step1';
	
	
	// import ROAStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/roa/step1';
	
	
	// import EPSStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/eps/step1';
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject3);
	
	// Empty state shown when the active round hasn't closed yet. Replaces
	// the full page (sidebar nav + content) so the instructor doesn't see
	// provisional data that would change once the round actually closes.
	var EmptyState = _styledComponents2.default.div(_templateObject4);
	
	var EmptyStateTitle = _styledComponents2.default.h2(_templateObject5);
	
	var EmptyStateSubtext = _styledComponents2.default.p(_templateObject6);
	
	var InstructorPerformanceFeedback = function (_PureComponent) {
	  _inherits(InstructorPerformanceFeedback, _PureComponent);
	
	  function InstructorPerformanceFeedback(props) {
	    _classCallCheck(this, InstructorPerformanceFeedback);
	
	    var _this = _possibleConstructorReturn(this, (InstructorPerformanceFeedback.__proto__ || Object.getPrototypeOf(InstructorPerformanceFeedback)).call(this, props));
	
	    _this.updateCurrentState = function () {
	      var navigation = _this.state.navigation;
	
	
	      var currentCategory = 0;
	      var currentStep = 0;
	      for (var i = 0; i < navigation.length; i++) {
	        var stepIndex = navigation[i].steps.findIndex(function (j) {
	          return j.url === _this.props.location.pathname;
	        });
	        if (stepIndex > -1) {
	          currentCategory = i;
	          currentStep = stepIndex;
	          break;
	        }
	      }
	
	      if (currentCategory !== _this.state.currentCategory || currentStep !== _this.state.currentStep) {
	
	        _this.setState({
	          currentCategory: currentCategory,
	          currentStep: currentStep
	        }, function () {
	          _this.checkLocation();
	        });
	      } else {
	        if (_this.props.location.pathname === '/performance-feedback') {
	          _this.checkLocation();
	        }
	      }
	    };
	
	    _this.checkLocation = function () {
	      var _this$state = _this.state,
	          currentCategory = _this$state.currentCategory,
	          currentStep = _this$state.currentStep,
	          navigation = _this$state.navigation;
	
	      var activeRound = _this.activeRound;
	
	      if (_this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
	        (0, _Location.changeLocation)(navigation[currentCategory].steps[currentStep].url + '?round=' + activeRound);
	      }
	    };
	
	    _this.goNext = function (e) {
	      e.preventDefault();
	
	      var _this$state2 = _this.state,
	          currentCategory = _this$state2.currentCategory,
	          currentStep = _this$state2.currentStep,
	          navigation = _this$state2.navigation;
	
	
	      var nextCategory = currentCategory;
	      var nextStep = currentStep + 1;
	      if (nextStep >= navigation[currentCategory].steps.length) {
	        nextCategory = currentCategory + 1;
	        nextStep = 0;
	
	        if (nextCategory >= navigation.length) {
	          return false;
	        } else if (nextStep >= navigation[nextCategory].steps.length) {
	          nextCategory = currentCategory + 2;
	          nextStep = 0;
	
	          if (nextCategory >= navigation.length) {
	            return false;
	          }
	        }
	      }
	
	      _this.setState({
	        currentCategory: nextCategory,
	        currentStep: nextStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.goPrev = function (e) {
	      e.preventDefault();
	
	      var _this$state3 = _this.state,
	          currentCategory = _this$state3.currentCategory,
	          currentStep = _this$state3.currentStep,
	          navigation = _this$state3.navigation;
	
	
	      var prevCategory = currentCategory;
	      var prevStep = currentStep - 1;
	      if (prevStep < 0) {
	        prevCategory = currentCategory - 1;
	        if (prevCategory < 0) {
	          return false;
	        }
	
	        prevStep = navigation[prevCategory].steps.length - 1;
	        if (prevStep < 0) {
	          prevCategory = currentCategory - 2;
	          if (prevCategory < 0) {
	            return false;
	          }
	
	          prevStep = navigation[prevCategory].steps.length - 1;
	        }
	      }
	
	      _this.setState({
	        currentCategory: prevCategory,
	        currentStep: prevStep
	      }, function () {
	        _this.checkLocation();
	      });
	
	      return false;
	    };
	
	    _this.state = {
	      currentCategory: 0,
	      currentStep: 0,
	      navigation: [],
	      loaded: false,
	      teamGradings: [],
	      teamGradingsLength: 0,
	      overallStats: null,
	      successfulTeamsCount: 0,
	      gamesTargets: [],
	      performanceFeedbacksGame: [],
	      round: {},
	      roundId: 0
	    };
	    return _this;
	  }
	
	  _createClass(InstructorPerformanceFeedback, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	      var round = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	
	      var roundId = round ? round.id : 0;
	      this.setState({
	        round: round,
	        roundId: roundId
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.state.roundId) {
	        this.loadNavigation(function () {
	          _this2.updateCurrentState();
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      if (this.props.rounds.length > 0 && !this.state.roundId) {
	        var activeRound = this.activeRound;
	        var round = this.props.rounds.find(function (i) {
	          return Number(i.number) === Number(activeRound);
	        });
	        var roundId = round ? round.id : 0;
	        if (roundId) {
	          this.setState({ round: round, roundId: roundId }, function () {
	            _this3.loadNavigation(function () {
	              _this3.updateCurrentState();
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: 'loadNavigation',
	    value: function loadNavigation(callback) {
	      var _this4 = this;
	
	      var roundId = this.state.roundId;
	      var activeRound = this.activeRound;
	
	
	      var game_id = Number(_Auth2.default.getGameId());
	
	      (0, _ApiService.batchRequest)([
	      // Single consolidated call — replaces the paginated
	      // /teamgradings/?round=<id> walk (which fired twice for
	      // bigger rounds) plus the separate /teamgradings/overall/
	      // call inside step1. Returns {teams, count, stats}.
	      ("https://be-production-itb.marketgames.io/api/") + 'v2/games/teamgradings/overall/' + roundId + '/', ("https://be-production-itb.marketgames.io/api/") + 'v2/games/targets/?round_number=' + activeRound + '&course=' + _Auth2.default.getCourseId(), ("https://be-production-itb.marketgames.io/api/") + 'v2/reports/performancefeedbacks/game/' + game_id + '/?round_number=' + activeRound]).then(function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(res) {
	          var overallBody, teamGradings, overallCount, overallStats, teamGradingsLength, successfulTeamsCount, gamesTargets, performanceFeedbacksGame, showSuccessfulTeams, showWhyTargetsWerentHit, showDesicionsNotSubmitted, showInsufficientCapital, showMarketShare, showMarketShareStep2, showMarketShareStep3, showMarketShareStep4, showMarketShareStep5, showMarketShareStep6, showMarketShareStep7, showMarketShareStep9, showRevenues, showRevenuesStep2, showRevenuesStep3, showGrossMargins, showGrossMarginsStep2, showGrossMarginsStep3, showSharePrices, showSharePricesStep2, showROE, showROEStep2, showROA, showROAStep2, showEPS, showEPSStep2, currentRoundMetrics, metricsToCheck, netLossMetricsExist, showNetLoss, navigation;
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  overallBody = res[0].body || {};
	                  teamGradings = Array.isArray(overallBody.teams) ? overallBody.teams : [];
	                  overallCount = overallBody.count || {};
	                  overallStats = overallBody.stats || {};
	                  teamGradingsLength = Number(overallCount.total_teams) || teamGradings.length;
	                  successfulTeamsCount = Number(overallCount.current_weighted_value_eq_1) || 0;
	                  gamesTargets = res[1].body;
	                  performanceFeedbacksGame = res[2].body;
	
	                  // Navigation gating: successful teams = the count returned by
	                  // the overall endpoint; "why targets weren't hit" = everyone
	                  // else for this round.
	
	                  showSuccessfulTeams = successfulTeamsCount;
	                  showWhyTargetsWerentHit = Math.max(0, teamGradingsLength - successfulTeamsCount);
	                  showDesicionsNotSubmitted = !!performanceFeedbacksGame.find(function (performanceFeedbackGame) {
	                    return performanceFeedbackGame.type === 'Did not submit';
	                  });
	                  showInsufficientCapital = !!performanceFeedbacksGame.find(function (performanceFeedbackGame) {
	                    return performanceFeedbackGame.type === 'Insufficient capital';
	                  });
	                  showMarketShare = gamesTargets.filter(function (i) {
	                    return i.market_share > 0;
	                  }).length;
	                  showMarketShareStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Price range failed';
	                  }).length;
	                  showMarketShareStep3 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Minimum requirement failed';
	                  }).length;
	                  showMarketShareStep4 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Product market fit';
	                  }).length;
	                  showMarketShareStep5 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Awareness';
	                  }).length;
	                  showMarketShareStep6 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Place';
	                  }).length;
	                  showMarketShareStep7 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Low inventory';
	                  }).length;
	                  showMarketShareStep9 = performanceFeedbacksGame.some(function (i) {
	                    return i.type === 'Mobile overproduced' || i.type === 'Auto overproduced';
	                  });
	                  showRevenues = gamesTargets.filter(function (i) {
	                    return i.net_revenues > 0;
	                  }).length;
	                  showRevenuesStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Expected revenue low';
	                  }).length;
	                  showRevenuesStep3 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Expected revenue low';
	                  }).length;
	                  showGrossMargins = gamesTargets.filter(function (i) {
	                    return i.gross_margin > 0;
	                  }).length;
	                  showGrossMarginsStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Gross margin fail';
	                  }).length;
	                  showGrossMarginsStep3 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Negative gross margins';
	                  }).length;
	                  showSharePrices = gamesTargets.filter(function (i) {
	                    return i.stock_price > 0;
	                  }).length;
	                  showSharePricesStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Share price fail';
	                  }).length;
	                  showROE = gamesTargets.filter(function (i) {
	                    return i.roe > 0;
	                  }).length;
	                  showROEStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Roe fail';
	                  }).length;
	                  showROA = gamesTargets.filter(function (i) {
	                    return i.roa > 0;
	                  }).length;
	                  showROAStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Roa fail';
	                  }).length;
	                  showEPS = gamesTargets.filter(function (i) {
	                    return i.earnings_per_share > 0;
	                  }).length;
	                  showEPSStep2 = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'EPS fail';
	                  }).length;
	                  currentRoundMetrics = gamesTargets.find(function (i) {
	                    return Number(i.round_number) === Number(activeRound);
	                  });
	                  metricsToCheck = ['roe', 'roa', 'earnings_per_share'];
	                  netLossMetricsExist = metricsToCheck.some(function (metric) {
	                    var value = currentRoundMetrics[metric];
	                    return value > 0;
	                  });
	                  showNetLoss = performanceFeedbacksGame.filter(function (i) {
	                    return i.type === 'Negative profits';
	                  }).length && netLossMetricsExist;
	                  navigation = [{
	                    title: 'Results Are In!',
	                    pattern: '/instructor/performance-feedback/results-are-in',
	                    steps: [{
	                      url: '/instructor/performance-feedback/results-are-in',
	                      component: _step2.default
	                    }, {
	                      url: '/instructor/performance-feedback/results-are-in/financial-goals',
	                      component: _step4.default
	                    }]
	                  }].concat(_toConsumableArray(showSuccessfulTeams ? [{
	                    title: 'Successful Teams',
	                    pattern: '/instructor/performance-feedback/successful-teams',
	                    steps: [].concat(_toConsumableArray(activeRound === 1 ? [{
	                      url: '/instructor/performance-feedback/successful-teams/marketing-mix',
	                      component: _step6.default
	                    }] : []), _toConsumableArray(activeRound === 2 ? [{
	                      url: '/instructor/performance-feedback/successful-teams/distribution-centers',
	                      component: _step8.default
	                    }] : []), _toConsumableArray(activeRound === 3 ? [{
	                      url: '/instructor/performance-feedback/successful-teams/income-statement',
	                      component: _step10.default
	                    }] : []))
	                  }] : []), _toConsumableArray(showWhyTargetsWerentHit ? [{
	                    title: 'Why Targets Weren\'t Hit',
	                    pattern: '/instructor/performance-feedback/why-targets-werent-hit',
	                    steps: [{
	                      url: '/instructor/performance-feedback/why-targets-werent-hit',
	                      component: _whyTargetsWerentHit2.default
	                    }]
	                  }].concat(_toConsumableArray(showDesicionsNotSubmitted ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Decisions not Posted',
	                    pattern: '/instructor/performance-feedback/decisions-not-submitted',
	                    steps: [{
	                      url: '/instructor/performance-feedback/decisions-not-submitted',
	                      component: _decisionsNotSubmitted2.default
	                    }]
	                  }] : []), _toConsumableArray(showInsufficientCapital ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Insufficient Capital',
	                    pattern: '/instructor/performance-feedback/insufficient-capital',
	                    steps: [{
	                      url: '/instructor/performance-feedback/insufficient-capital',
	                      component: _insufficientCapital2.default
	                    }]
	                  }] : []), _toConsumableArray(showMarketShare ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Market Share',
	                    pattern: '/instructor/performance-feedback/market-share',
	                    steps: [].concat(_toConsumableArray(showMarketShareStep2 ? [{
	                      url: '/instructor/performance-feedback/market-share/outside-price-range',
	                      component: _step12.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showMarketShareStep3 ? [{
	                      url: '/instructor/performance-feedback/market-share/product-customer-wanted',
	                      component: _step14.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showMarketShareStep4 ? [{
	                      url: '/instructor/performance-feedback/market-share/product-met-interest',
	                      component: _step16.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showMarketShareStep5 ? [{
	                      url: '/instructor/performance-feedback/market-share/product-promotion',
	                      component: _step18.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showMarketShareStep6 ? [{
	                      url: '/instructor/performance-feedback/market-share/sales-channels',
	                      component: _step20.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showMarketShareStep7 ? [{
	                      url: '/instructor/performance-feedback/market-share/insufficient-capacity',
	                      component: _step22.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showMarketShareStep9 ? [{
	                      url: '/instructor/performance-feedback/market-share/overproduced',
	                      component: _step24.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : []), _toConsumableArray(showRevenues ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Revenues',
	                    pattern: '/instructor/performance-feedback/revenues',
	                    steps: [].concat(_toConsumableArray(showRevenuesStep2 ? [{
	                      url: '/instructor/performance-feedback/revenues/products-selling-price',
	                      component: _step26.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showRevenuesStep3 ? [{
	                      url: '/instructor/performance-feedback/revenues/customers-willingness-to-pay',
	                      component: _step28.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : []), _toConsumableArray(showGrossMargins ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Gross Margins',
	                    pattern: '/instructor/performance-feedback/gross-margins',
	                    steps: [].concat(_toConsumableArray(showGrossMarginsStep2 ? [{
	                      url: '/instructor/performance-feedback/gross-margins/selling-price-too-low',
	                      component: _step30.default,
	                      hasErrorAlert: true
	                    }] : []), _toConsumableArray(showGrossMarginsStep3 ? [{
	                      url: '/instructor/performance-feedback/gross-margins/running-non-profit',
	                      component: _step32.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : []), _toConsumableArray(showSharePrices ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Share Price',
	                    pattern: '/instructor/performance-feedback/share-price',
	                    steps: [].concat(_toConsumableArray(showSharePricesStep2 ? [{
	                      url: '/instructor/performance-feedback/share-price/enough-revenues',
	                      component: _step34.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : []), _toConsumableArray(showNetLoss ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'Net Loss',
	                    pattern: '/instructor/performance-feedback/net-loss',
	                    steps: [{
	                      url: '/instructor/performance-feedback/net-loss',
	                      component: _netLoss2.default,
	                      hasErrorAlert: true
	                    }]
	                  }] : []), _toConsumableArray(showROE ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'ROE',
	                    pattern: '/instructor/performance-feedback/roe',
	                    steps: [].concat(_toConsumableArray(showROEStep2 ? [{
	                      url: '/instructor/performance-feedback/roe/enough-profits',
	                      component: _step36.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : []), _toConsumableArray(showROA ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'ROA',
	                    pattern: '/instructor/performance-feedback/roa',
	                    steps: [].concat(_toConsumableArray(showROAStep2 ? [{
	                      url: '/instructor/performance-feedback/roa/enough-profits',
	                      component: _step38.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : []), _toConsumableArray(showEPS ? [{
	                    parent: 'Why Targets Weren\'t Hit',
	                    title: 'EPS',
	                    pattern: '/instructor/performance-feedback/eps',
	                    steps: [].concat(_toConsumableArray(showEPSStep2 ? [{
	                      url: '/instructor/performance-feedback/eps/enough-profits',
	                      component: _step40.default,
	                      hasErrorAlert: true
	                    }] : []))
	                  }] : [])) : []), _toConsumableArray(activeRound === 1 || activeRound === 2 ? [{
	                    title: 'What To Expect Next',
	                    pattern: '/instructor/performance-feedback/what-to-expect-next',
	                    steps: [{
	                      url: '/instructor/performance-feedback/what-to-expect-next',
	                      component: _whatToExpectNext2.default
	                    }]
	                  }] : []), _toConsumableArray(activeRound === 1 ? [{
	                    parent: 'What To Expect Next',
	                    title: 'Supply Chain Decisions',
	                    pattern: '/instructor/performance-feedback/supply-chain-decisions',
	                    steps: [{
	                      url: '/instructor/performance-feedback/supply-chain-decisions',
	                      component: _supplyChainDecisions2.default,
	                      hasErrorAlert: true
	                    }]
	                  }] : []), _toConsumableArray(activeRound === 3 ? [{
	                    parent: 'What To Expect Next',
	                    title: 'New Scoring Metrics',
	                    pattern: '/instructor/performance-feedback/new-scoring-metrics',
	                    steps: [{
	                      url: '/instructor/performance-feedback/new-scoring-metrics',
	                      component: _newScoringMetrics2.default,
	                      hasErrorAlert: true
	                    }]
	                  }, {
	                    parent: 'What To Expect Next',
	                    title: 'New Valuation Model',
	                    pattern: '/instructor/performance-feedback/new-valuation-model',
	                    steps: [{
	                      url: '/instructor/performance-feedback/new-valuation-model',
	                      component: _newValuationModel2.default,
	                      hasErrorAlert: true
	                    }]
	                  }, {
	                    parent: 'What To Expect Next',
	                    title: 'Share Buybacks',
	                    pattern: '/instructor/performance-feedback/share-buybacks',
	                    steps: [{
	                      url: '/instructor/performance-feedback/share-buybacks',
	                      component: _shareBuybacks2.default,
	                      hasErrorAlert: true
	                    }]
	                  }] : []), [{
	                    parent: 'What To Expect Next',
	                    title: 'Customer Preferences',
	                    pattern: '/instructor/performance-feedback/customer-preferences',
	                    steps: [{
	                      url: '/instructor/performance-feedback/customer-preferences',
	                      component: _customerPreferences2.default,
	                      hasErrorAlert: true
	                    }]
	                  }], _toConsumableArray(activeRound === 1 ? [{
	                    parent: 'What To Expect Next',
	                    title: 'Product Strategy',
	                    pattern: '/instructor/performance-feedback/product-strategy',
	                    steps: [{
	                      url: '/instructor/performance-feedback/product-strategy',
	                      component: _productStrategy2.default,
	                      hasErrorAlert: true
	                    }]
	                  }] : []), [{
	                    title: 'That\'s All!',
	                    pattern: '/instructor/performance-feedback/thats-all',
	                    steps: [{
	                      url: '/instructor/performance-feedback/thats-all',
	                      component: _thatsAll2.default
	                    }]
	                  }]);
	
	
	                  if (JSON.stringify(navigation) !== JSON.stringify(_this4.state.navigation)) {
	                    _this4.setState({
	                      navigation: navigation,
	                      teamGradings: teamGradings,
	                      teamGradingsLength: teamGradingsLength,
	                      overallStats: overallStats,
	                      successfulTeamsCount: successfulTeamsCount,
	                      gamesTargets: gamesTargets,
	                      performanceFeedbacksGame: performanceFeedbacksGame,
	                      loaded: true
	                    }, function () {
	                      if (callback) {
	                        callback();
	                      }
	                    });
	                  } else {
	                    if (callback) {
	                      callback();
	                    }
	                  }
	
	                case 40:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this4);
	        }));
	
	        return function (_x) {
	          return _ref.apply(this, arguments);
	        };
	      }()).catch(function (err) {
	        console.log(err);
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.location.pathname !== this.props.location.pathname) {
	        this.updateCurrentState();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentCategory = _state.currentCategory,
	          currentStep = _state.currentStep,
	          navigation = _state.navigation,
	          loaded = _state.loaded,
	          teamGradings = _state.teamGradings,
	          teamGradingsLength = _state.teamGradingsLength,
	          overallStats = _state.overallStats,
	          successfulTeamsCount = _state.successfulTeamsCount,
	          gamesTargets = _state.gamesTargets,
	          roundId = _state.roundId,
	          performanceFeedbacksGame = _state.performanceFeedbacksGame;
	      var rounds = this.props.rounds;
	
	      var activeRound = this.activeRound;
	
	      if (navigation.length === 0 || !loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      // Guard: hide the whole page when the active round hasn't closed.
	      // The activeRound getter honors ?round=N in the URL, which can land
	      // the instructor on a live or not-yet-started round. In that case
	      // the BE still returns teamgradings / performancefeedbacks (often
	      // mirroring the prior round), which would mislead the instructor
	      // into thinking the current round's results are in. Replace the
	      // page with a status message until is_finished flips to true.
	      var activeRoundRecord = rounds.find(function (i) {
	        return Number(i.number) === Number(activeRound);
	      });
	      var roundIsFinished = activeRoundRecord && activeRoundRecord.is_finished === true;
	      if (!roundIsFinished) {
	        var roundStarted = activeRoundRecord && activeRoundRecord.is_started === true;
	        var headline = roundStarted ? "Round has not closed yet." : "Round has not started yet.";
	        var subtext = roundStarted ? "Performance feedback will appear here once the round closes." : "Performance feedback will appear here once the round starts and closes.";
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(
	            EmptyState,
	            null,
	            _react2.default.createElement(
	              EmptyStateTitle,
	              null,
	              headline
	            ),
	            _react2.default.createElement(
	              EmptyStateSubtext,
	              null,
	              subtext
	            )
	          )
	        );
	      }
	
	      var category = navigation[currentCategory];
	      var Component = null;
	      var previousShownErrors = 0;
	      if (category) {
	        Component = category.steps[currentStep].component;
	
	        var url = category.steps[currentStep].url;
	        var allSteps = navigation.reduce(function (prev, curr) {
	          return [].concat(_toConsumableArray(prev), _toConsumableArray(curr.steps));
	        }, []);
	        var currentStepIndex = allSteps.findIndex(function (i) {
	          return i.url === url;
	        });
	        previousShownErrors = allSteps.slice(0, currentStepIndex).filter(function (i) {
	          return i.hasErrorAlert === true;
	        }).length;
	      }
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(_navigation2.default, {
	          data: navigation,
	          category: currentCategory,
	          activeRound: activeRound
	        }),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            ContentWrapper,
	            null,
	            Component && _react2.default.createElement(Component, {
	              activeRound: activeRound,
	              rounds: rounds,
	              previousShownErrors: previousShownErrors,
	              teamGradings: teamGradings,
	              teamGradingsLength: teamGradingsLength,
	              overallStats: overallStats,
	              successfulTeamsCount: successfulTeamsCount,
	              gamesTargets: gamesTargets,
	              performanceFeedbacksGame: performanceFeedbacksGame,
	              roundId: roundId
	            })
	          ),
	          _react2.default.createElement(_pagination2.default, {
	            goNext: this.goNext,
	            goPrev: this.goPrev,
	            isFirstStep: this.isFirstStep,
	            isLastStep: this.isLastStep,
	            currentStep: currentStep + 1,
	            countOfSteps: this.countOfSteps
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props = this.props,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl,
	          rounds = _props.rounds;
	
	      // Sort by round number ascending before picking the last finished
	      // one. The BE returns rounds in insertion / id order, not number
	      // order — e.g. after Activate Main Rounds the rounds can land in
	      // state as (2, 3, 1), which would otherwise make this getter route
	      // the instructor to Round 1 instead of the real latest round.
	
	      var finishedRounds = rounds.filter(function (i) {
	        return i.is_started === true && i.is_finished === true;
	      }).slice().sort(function (a, b) {
	        return Number(a.number) - Number(b.number);
	      });
	      var lastFinishedRoundNumber = finishedRounds.length > 0 ? finishedRounds[finishedRounds.length - 1].number : null;
	
	      return Number(roundInUrl || lastFinishedRoundNumber || currentRound);
	    }
	  }, {
	    key: 'isFirstStep',
	    get: function get() {
	      var _state2 = this.state,
	          currentCategory = _state2.currentCategory,
	          currentStep = _state2.currentStep;
	
	
	      return currentCategory === 0 && currentStep === 0;
	    }
	  }, {
	    key: 'isLastStep',
	    get: function get() {
	      var _state3 = this.state,
	          currentCategory = _state3.currentCategory,
	          currentStep = _state3.currentStep,
	          navigation = _state3.navigation;
	
	
	      var lastCategory = navigation.length - 1;
	      var lastStep = navigation[lastCategory].steps.length - 1;
	
	      return currentCategory === lastCategory && currentStep === lastStep;
	    }
	  }, {
	    key: 'countOfSteps',
	    get: function get() {
	      var _state4 = this.state,
	          currentCategory = _state4.currentCategory,
	          navigation = _state4.navigation;
	
	
	      return navigation[currentCategory].steps.length;
	    }
	  }]);
	
	  return InstructorPerformanceFeedback;
	}(_react.PureComponent);
	
	exports.default = InstructorPerformanceFeedback;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 40px 40px 50px;\n  background: #FAFAFA;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  width: 100%;\n  padding: 40px 40px 50px;\n  background: #FAFAFA;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 40px 40px 50px;\n'], ['\n  width: 100%;\n  padding: 40px 40px 50px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  font-family: \'Mukta Vaani\';\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  font-family: \'Mukta Vaani\';\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0;\n'], ['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 160px;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 27, 59, 0.94);\n  font-family: \'Mukta Vaani\';\n  font-size: 16px;\n  line-height: 22px;\n  cursor: ', ';\n  padding: 10px 24px;\n  background: #fff;\n  color: rgba(0, 27, 59, 0.94);\n  font-weight: 500;\n\n  ', '\n\n  ', '\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 160px;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 27, 59, 0.94);\n  font-family: \'Mukta Vaani\';\n  font-size: 16px;\n  line-height: 22px;\n  cursor: ', ';\n  padding: 10px 24px;\n  background: #fff;\n  color: rgba(0, 27, 59, 0.94);\n  font-weight: 500;\n\n  ', '\n\n  ', '\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 15px;\n  line-height: 22px;\n\n  .prefix {\n    color: rgba(0, 27, 59, 0.6);\n    font-weight: 400;\n  }\n  .status {\n    color: rgba(0, 27, 59, 0.94);\n    font-weight: 700;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 15px;\n  line-height: 22px;\n\n  .prefix {\n    color: rgba(0, 27, 59, 0.6);\n    font-weight: 400;\n  }\n  .status {\n    color: rgba(0, 27, 59, 0.94);\n    font-weight: 700;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.94);\n  border-radius: 8px;\n  padding: 19px 20px;\n  margin-top: 20px;\n  max-width: 880px;\n'], ['\n  background: #fff;\n  border: 1px solid rgba(0, 27, 59, 0.94);\n  border-radius: 8px;\n  padding: 19px 20px;\n  margin-top: 20px;\n  max-width: 880px;\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  font-family: \'Inter\', sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  margin: 0 0 8px;\n'], ['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  font-family: \'Inter\', sans-serif;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  margin: 0 0 8px;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  margin: 0 0 21px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(0, 27, 59, 0.94);\n  text-align: center;\n  margin: 0 0 21px;\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  padding: 20px 0 10px;\n'], ['\n  display: flex;\n  justify-content: center;\n  padding: 20px 0 10px;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-size: 13px;\n  line-height: 1.4;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n'], ['\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: rgba(0, 27, 59, 0.94);\n  color: #fff;\n  font-size: 13px;\n  line-height: 1.4;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 100ms ease;\n  z-index: 10;\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 6px solid transparent;\n    border-top-color: rgba(0, 27, 59, 0.94);\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-flex;\n\n  &:hover ', ' {\n    opacity: 1;\n  }\n'], ['\n  position: relative;\n  display: inline-flex;\n\n  &:hover ', ' {\n    opacity: 1;\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  border: none;\n  border-top: 1px solid #D5D9DD;\n  margin: 0;\n'], ['\n  border: none;\n  border-top: 1px solid #D5D9DD;\n  margin: 0;\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: \'Mukta Vaani\';\n'], ['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  font-family: \'Mukta Vaani\';\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n'], ['\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 16px;\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0 0 24px;\n'], ['\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0 0 24px;\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n'], ['\n  background: #F5F6F7;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 27, 59, 0.8);\n  cursor: pointer;\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  background: #2196F3;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: #1e88e5;\n  }\n\n  &:disabled {\n    background: #90CAF9;\n    cursor: not-allowed;\n  }\n'], ['\n  background: #2196F3;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 14px;\n  color: #fff;\n  cursor: pointer;\n\n  &:hover {\n    background: #1e88e5;\n  }\n\n  &:disabled {\n    background: #90CAF9;\n    cursor: not-allowed;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _roundError = __webpack_require__(611);
	
	var _ApiService = __webpack_require__(4);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _table = __webpack_require__(1508);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _firstDecisionModal = __webpack_require__(253);
	
	var _firstDecisionModal2 = _interopRequireDefault(_firstDecisionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-loop-func */
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var LoaderWrapper = _styledComponents2.default.div(_templateObject2);
	
	var PageTitle = _styledComponents2.default.h1(_templateObject3);
	
	/* Round Activation */
	
	var ActivationRow = _styledComponents2.default.div(_templateObject4);
	
	var ActivationHint = _styledComponents2.default.span(_templateObject5);
	
	var ActivationButton = _styledComponents2.default.button(_templateObject6, function (p) {
	  return p.isClickable ? 'pointer' : 'default';
	}, function (p) {
	  return p.isClickable && '\n    background: #22C55E;\n    border-color: #22C55E;\n    color: #fff;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n    && .prefix { color: rgba(255, 255, 255, 0.9); }\n    && .status { color: #fff; }\n\n    &:hover {\n      background: #16A34A;\n      border-color: #16A34A;\n    }\n  ';
	}, function (p) {
	  return !p.isClickable && '\n    opacity: 0.6;\n  ';
	});
	
	var ActivationButtonText = _styledComponents2.default.span(_templateObject7);
	
	/* Round Deadlines Card */
	
	var CardWrapper = _styledComponents2.default.div(_templateObject8);
	
	var CardTitle = _styledComponents2.default.h3(_templateObject9);
	
	var CardSubtitle = _styledComponents2.default.p(_templateObject10);
	
	var CardActivationWrapper = _styledComponents2.default.div(_templateObject11);
	
	var ActivationTooltip = _styledComponents2.default.div(_templateObject12);
	
	var ActivationHoverGroup = _styledComponents2.default.div(_templateObject13, ActivationTooltip);
	
	var CardDivider = _styledComponents2.default.hr(_templateObject14);
	
	/* Confirmation Modal */
	
	var ConfirmOverlay = _styledComponents2.default.div(_templateObject15);
	
	var ConfirmModal = _styledComponents2.default.div(_templateObject16);
	
	var ConfirmTitle = _styledComponents2.default.h3(_templateObject17);
	
	var ConfirmMessage = _styledComponents2.default.p(_templateObject18);
	
	var ConfirmActions = _styledComponents2.default.div(_templateObject19);
	
	var ConfirmCancelButton = _styledComponents2.default.button(_templateObject20);
	
	var ConfirmProceedButton = _styledComponents2.default.button(_templateObject21);
	
	var RoundAdmin = function (_PureComponent) {
	  _inherits(RoundAdmin, _PureComponent);
	
	  function RoundAdmin(props) {
	    _classCallCheck(this, RoundAdmin);
	
	    var _this = _possibleConstructorReturn(this, (RoundAdmin.__proto__ || Object.getPrototypeOf(RoundAdmin)).call(this, props));
	
	    _this.openRoundsSetPopup = function (title, body) {
	      _this.setState({ roundsSetPopup: { open: true, title: title, body: body } });
	    };
	
	    _this.closeRoundsSetPopup = function () {
	      _this.setState({ roundsSetPopup: { open: false, title: '', body: '' } });
	    };
	
	    _this.notifyRoundCreated = function (_ref) {
	      var gameType = _ref.gameType,
	          gameReset = _ref.gameReset,
	          isPractice = _ref.isPractice,
	          createdRoundNumber = _ref.createdRoundNumber,
	          newRounds = _ref.newRounds,
	          newSchedulers = _ref.newSchedulers;
	
	      var isLegend = gameType === 'Legend';
	
	      if (isPractice) {
	        // Practice round can only exist on Explorer/Adventurer.
	        if (gameType === 'Explorer') {
	          _this.openRoundsSetPopup('Practice round is all set!', "Next up, set Round 1's deadline as well.");
	        } else if (gameType === 'Adventurer') {
	          _this.openRoundsSetPopup('Practice round is all set!', 'Make sure to also set the deadlines for Round 1, 2, and 3.');
	        }
	        return;
	      }
	
	      // Main round created directly via round API (Legend, or
	      // Explorer/Adventurer post-reset).
	      if (isLegend) {
	        var mainRoundsCount = (newRounds || []).filter(function (r) {
	          return r && r.practice !== 'Yes';
	        }).length;
	        if (Number(createdRoundNumber) === 1) {
	          _this.openRoundsSetPopup('Round 1 is all set!', 'Next up, set the deadlines for Round 2 and 3.');
	        } else if (mainRoundsCount >= 3) {
	          _this.openRoundsSetPopup('Rounds are all set!', '');
	        }
	        return;
	      }
	
	      if (gameReset) {
	        // Post-reset Explorer/Adventurer main rounds. User only wants
	        // a popup on Round 1 in this scenario.
	        if (Number(createdRoundNumber) !== 1) return;
	        if (gameType === 'Explorer') {
	          _this.openRoundsSetPopup('Round is all set!', '');
	        } else if (gameType === 'Adventurer') {
	          _this.openRoundsSetPopup('Round 1 is all set!', 'Next up, set the deadlines for Round 2 and 3.');
	        }
	        return;
	      }
	
	      // Pre-reset Explorer/Adventurer main rounds go through the
	      // scheduler API. Popup fires when the FULL set is now present.
	      var requiredNumbers = gameType === 'Explorer' ? [1] : [1, 2, 3];
	      var hasAll = requiredNumbers.every(function (n) {
	        return (newSchedulers || []).some(function (s) {
	          return Number(s.number) === n;
	        });
	      });
	      if (hasAll) {
	        _this.openRoundsSetPopup('Rounds are all set!', 'When the practice round ends, click Activate Main Rounds below to go live for the Main Rounds.');
	      }
	    };
	
	    _this.fetchData = function () {
	      var gameId = _Auth2.default.getGameId();
	
	      // Use the cached / in-flight-dedup'd fetcher so this page shares
	      // one network request with App.js's own general-info call on
	      // page load (and with the onboarding gate). Was previously a
	      // raw getRequest that bypassed the cache and burned an extra
	      // roundtrip on every mount.
	      (0, _AppGeneralInfoService.fetchAppGeneralInfo)(gameId, 'instructor').then(function (data) {
	        // Pick the course / game that MATCH the current session,
	        // not blindly [0]. When an instructor is tied to multiple
	        // courses/games, general-info returns all of them and [0]
	        // may be a stale/foreign course whose game_type is null,
	        // which would leave gameType null and collapse the round
	        // list to a single row.
	        var currentCourseId = Number(_Auth2.default.getCourseId());
	        var currentGameId = Number(_Auth2.default.getGameId());
	        var coursesList = data.courses || [];
	        var gamesList = data.games || [];
	        var course = coursesList.find(function (c) {
	          return Number(c.id) === currentCourseId;
	        }) || coursesList[0] || {};
	        var rawGameType = course.game_type || null;
	        var gameType = rawGameType ? rawGameType.charAt(0).toUpperCase() + rawGameType.slice(1).toLowerCase() : null;
	        var courseId = course.id || 0;
	
	        var game = gamesList.find(function (g) {
	          return Number(g.id) === currentGameId;
	        }) || gamesList[0] || {};
	        var propsGameId = game.id || (_this.props.game && _this.props.game.id ? _this.props.game.id : 0);
	        var gameReset = !!game.reset;
	
	        var apiRounds = (data.rounds || []).map(function (i) {
	          return {
	            id: i.id,
	            number: i.number,
	            start_date: (0, _moment2.default)(i.start_date),
	            end_date: (0, _moment2.default)(i.end_date),
	            showResults: i.results_viewable,
	            is_started: i.is_started,
	            is_finished: i.is_finished,
	            practice: i.practice,
	            grading_weight: i.grading_weight != null ? Number(i.grading_weight) : null,
	            source: 'round_api'
	          };
	        });
	
	        var roundsName = game.name || 'Practice Game';
	
	        // Now fetch round schedulers
	        (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/games/roundschedulers/').then(function (schedRes) {
	          var schedulers = (schedRes.body.results || schedRes.body || []).map(function (s) {
	            return {
	              id: s.id,
	              number: s.round_number !== undefined ? s.round_number : s.number,
	              start_date: s.start_date ? (0, _moment2.default)(s.start_date) : null,
	              end_date: s.end_date ? (0, _moment2.default)(s.end_date) : null,
	              showResults: false,
	              is_started: false,
	              is_finished: false,
	              practice: s.practice === true,
	              grading_weight: s.grading_weight != null ? Number(s.grading_weight) : null,
	              source: 'scheduler',
	              scheduler_id: s.id
	            };
	          });
	
	          _this.setState({
	            loaded: true,
	            gameId: propsGameId,
	            gameType: gameType,
	            courseId: courseId,
	            gameReset: gameReset,
	            rounds: apiRounds,
	            schedulers: schedulers,
	            roundsName: roundsName
	          });
	        }).catch(function (err) {
	          // Schedulers failed, proceed without them
	          _this.setState({
	            loaded: true,
	            gameId: propsGameId,
	            gameType: gameType,
	            courseId: courseId,
	            gameReset: gameReset,
	            rounds: apiRounds,
	            schedulers: [],
	            roundsName: roundsName
	          });
	        });
	      }).catch(function (err) {
	        _this.fetchRoundsLegacy();
	      });
	    };
	
	    _this.getStartGapViolation = function (round, displayRounds) {
	      if (!round) return null;
	      // Practice rounds (number = 0 in our display, or displayName = Practice)
	      // are excluded from this rule entirely.
	      if (round.displayName === 'Practice') return null;
	      if (Number(round.number) <= 1) return null;
	      if (!round.start_date) return null;
	
	      var prior = (displayRounds || []).find(function (r) {
	        return r.displayName !== 'Practice' && Number(r.number) === Number(round.number) - 1;
	      });
	      if (!prior || !prior.end_date) return null;
	
	      var priorEnd = _moment2.default.isMoment(prior.end_date) ? prior.end_date : (0, _moment2.default)(prior.end_date);
	      var start = _moment2.default.isMoment(round.start_date) ? round.start_date : (0, _moment2.default)(round.start_date);
	      var maxStart = priorEnd.clone().add(30, 'days');
	      if (start.isAfter(maxStart)) {
	        return {
	          priorDisplayName: prior.displayName || 'Round ' + prior.number,
	          maxStart: maxStart,
	          priorEndDate: priorEnd
	        };
	      }
	      return null;
	    };
	
	    _this.getDisplayRounds = function () {
	      var _this$state = _this.state,
	          rounds = _this$state.rounds,
	          schedulers = _this$state.schedulers,
	          gameType = _this$state.gameType,
	          gameReset = _this$state.gameReset;
	
	      var displayRounds = [];
	      var hasPractice = gameType === 'Explorer' || gameType === 'Adventurer';
	      var mainRoundCount = gameType === 'Adventurer' || gameType === 'Legend' ? 3 : 1;
	
	      // Separate practice and main rounds from the round API by the
	      // `practice` field. We always set this field explicitly on creation
	      // (Yes for the practice round, No for main rounds), so it's the
	      // source of truth for classifying rounds regardless of whether any
	      // schedulers exist.
	      var practiceApiRounds = rounds.filter(function (r) {
	        return r.practice === 'Yes';
	      });
	      var mainApiRounds = rounds.filter(function (r) {
	        return r.practice !== 'Yes';
	      }).sort(function (a, b) {
	        return a.number - b.number;
	      });
	
	      // Practice round row
	      if (hasPractice) {
	        if (!gameReset) {
	          // reset=false: prefer round API (practice='Yes'), fall back to a
	          // scheduler where practice === true.
	          if (practiceApiRounds.length > 0) {
	            displayRounds.push(Object.assign({}, practiceApiRounds[0], { displayName: 'Practice' }));
	          } else {
	            var practiceScheduler = schedulers.find(function (s) {
	              return s.practice === true;
	            });
	            if (practiceScheduler && practiceScheduler.start_date && practiceScheduler.end_date) {
	              displayRounds.push(Object.assign({}, practiceScheduler, { displayName: 'Practice', number: 0 }));
	            } else {
	              displayRounds.push(_this.makePlaceholder('Practice', 0));
	            }
	          }
	        } else {
	          // reset=true: check scheduler where practice === true, mark as disabled
	          var _practiceScheduler = schedulers.find(function (s) {
	            return s.practice === true;
	          });
	          if (_practiceScheduler && _practiceScheduler.start_date && _practiceScheduler.end_date) {
	            displayRounds.push(Object.assign({}, _practiceScheduler, { displayName: 'Practice', number: 0, disabled: true }));
	          } else {
	            displayRounds.push(Object.assign({}, _this.makePlaceholder('Practice', 0), { disabled: true }));
	          }
	        }
	      }
	
	      // Main round rows
	
	      var _loop = function _loop(i) {
	        var roundNumber = i + 1;
	
	        if (!gameReset) {
	          // reset=false: check scheduler for a matching main-round entry
	          // (practice !== true, so a practice scheduler with the same number
	          // is not accidentally picked). For Round 1, this covers the case
	          // where a scheduler with practice=false represents the main run.
	          var scheduler = schedulers.find(function (s) {
	            return s.number === roundNumber && s.practice !== true;
	          });
	          if (scheduler && scheduler.start_date && scheduler.end_date) {
	            displayRounds.push(Object.assign({}, scheduler, { displayName: 'Round ' + roundNumber, number: roundNumber }));
	          } else {
	            displayRounds.push(_this.makePlaceholder('Round ' + roundNumber, roundNumber));
	          }
	        } else {
	          // reset=true: check general-info for round id first, then scheduler
	          // (with practice !== true so we don't accidentally pick a practice
	          // scheduler that happens to share the same round number).
	          var apiRound = mainApiRounds.find(function (r) {
	            return r.number === roundNumber;
	          });
	          if (apiRound) {
	            displayRounds.push(Object.assign({}, apiRound, { displayName: 'Round ' + roundNumber }));
	          } else {
	            var _scheduler = schedulers.find(function (s) {
	              return s.number === roundNumber && s.practice !== true;
	            });
	            if (_scheduler && _scheduler.start_date && _scheduler.end_date) {
	              displayRounds.push(Object.assign({}, _scheduler, { displayName: 'Round ' + roundNumber, number: roundNumber }));
	            } else {
	              displayRounds.push(_this.makePlaceholder('Round ' + roundNumber, roundNumber));
	            }
	          }
	        }
	      };
	
	      for (var i = 0; i < mainRoundCount; i++) {
	        _loop(i);
	      }
	
	      // Merge edited dates + grading weights into display rounds.
	      //
	      // Grading weight falls through the same source chain as dates:
	      // round API record → scheduler record → placeholder default
	      // (0.3333). `getDisplayRounds` already picked the row from this
	      // chain, so we just read `r.grading_weight` here regardless of
	      // which source backed it, and fall back to 0.3333 when neither
	      // round API nor scheduler carried a value.
	      var _this$state2 = _this.state,
	          editedDates = _this$state2.editedDates,
	          editedGradingWeights = _this$state2.editedGradingWeights;
	
	      var merged = displayRounds.map(function (r) {
	        var dateEdits = editedDates[r.id];
	        var editedGW = editedGradingWeights[r.id];
	        var storedGW = r.grading_weight != null ? Number(r.grading_weight) : null;
	        var gradingWeight = editedGW !== undefined ? editedGW : storedGW != null ? storedGW : 0.3333;
	        var withDates = dateEdits ? Object.assign({}, r, {
	          start_date: dateEdits.start_date || r.start_date,
	          end_date: dateEdits.end_date || r.end_date
	        }) : r;
	
	        // Show Results toggle: enabled only when a matching round API
	        // record exists (practice row needs number=1 + practice='Yes';
	        // main rows need matching number + practice='No').
	        var isPractice = r.displayName === 'Practice';
	        var targetNumber = isPractice ? 1 : Number(r.number);
	        var targetPractice = isPractice ? 'Yes' : 'No';
	        var hasRoundRecord = rounds.some(function (rec) {
	          return Number(rec.number) === targetNumber && rec.practice === targetPractice;
	        });
	        var showResultsDisabled = !hasRoundRecord;
	        var showResultsTooltip = null;
	        if (showResultsDisabled) {
	          if (isPractice) {
	            showResultsTooltip = 'Set up the practice round before toggling this.';
	          } else if (!gameReset) {
	            showResultsTooltip = 'The game is still in the practice round. Show Results can be adjusted once the main rounds are live.';
	          } else {
	            showResultsTooltip = 'Set up this round before toggling.';
	          }
	        }
	
	        return Object.assign({}, withDates, {
	          grading_weight: gradingWeight,
	          showResultsDisabled: showResultsDisabled,
	          showResultsTooltip: showResultsTooltip
	        });
	      });
	
	      // Second pass: attach a startGapWarning string when a main round's
	      // start_date is more than 30 days past the prior main round's
	      // end_date. Uses `merged` so edits-in-progress on the prior round
	      // are reflected. Rendered inline under the start-date picker in
	      // RoundAdminTable; onUpdate also blocks save on the same rule.
	      return merged.map(function (r) {
	        var violation = _this.getStartGapViolation(r, merged);
	        if (!violation) return r;
	        return Object.assign({}, r, {
	          startGapWarning: 'Start date must be within 30 days of ' + violation.priorDisplayName + '\'s end date (by ' + violation.maxStart.format('MMM D, YYYY') + ').'
	        });
	      });
	    };
	
	    _this.makePlaceholder = function (displayName, number) {
	      return {
	        id: 'placeholder-' + number,
	        number: number,
	        start_date: null,
	        end_date: null,
	        showResults: false,
	        is_started: false,
	        is_finished: false,
	        displayName: displayName,
	        source: 'placeholder'
	      };
	    };
	
	    _this.fetchRoundsLegacy = function () {
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'game/rounds').then(function (res) {
	        var rounds = [];
	        var showDefaultRounds = false;
	
	        var propsGameId = _this.props.game && _this.props.game.id ? _this.props.game.id : 0;
	
	        if (res.body.length) {
	          _this.setState({ gameId: res.body[0].game || propsGameId });
	          rounds = res.body.map(function (i) {
	            return {
	              id: i.id,
	              number: i.number,
	              start_date: (0, _moment2.default)(i.start_date),
	              end_date: (0, _moment2.default)(i.end_date),
	              showResults: i.results_viewable,
	              is_started: i.is_started || false,
	              is_finished: i.is_finished || false,
	              source: 'round_api'
	            };
	          });
	        } else {
	          rounds = Array.from({ length: 3 }, function (_, i) {
	            return {
	              id: i + 1,
	              number: i + 1,
	              start_date: (0, _moment2.default)().add(7 * i + 14 * i, 'days'),
	              end_date: (0, _moment2.default)().add(7 * i + 14 * (i + 1), 'days'),
	              showResults: true,
	              is_started: false,
	              is_finished: false,
	              source: 'placeholder'
	            };
	          });
	
	          showDefaultRounds = true;
	          _this.setState({ gameId: propsGameId });
	        }
	
	        var roundWithLowestID = rounds.reduce(function (previous, current) {
	          return current.id < previous.id ? current : previous;
	        });
	
	        if (!showDefaultRounds) {
	          (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + 'game/rounds/' + roundWithLowestID.id).then(function (res) {
	            var roundsName = res.body.name ? res.body.name : 'Practice Game';
	
	            _this.setState({
	              loaded: true,
	              rounds: rounds,
	              roundsName: roundsName
	            });
	          }).catch(function (err) {});
	        } else {
	          var roundsName = 'Practice Game';
	          _this.setState({
	            loaded: true,
	            rounds: rounds,
	            roundsName: roundsName,
	            defaultActiveRounds: [1, 2, 3]
	          });
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.onChange = function (datetime, round_id, field) {
	      if (typeof datetime === "string") {
	        return;
	      }
	
	      var startDateChanged = false;
	      var endDateChanged = false;
	
	      if (field === 'start_date') {
	        startDateChanged = true;
	      } else if (field === 'end_date') {
	        endDateChanged = true;
	      }
	
	      var _this$state3 = _this.state,
	          changedRounds = _this$state3.changedRounds,
	          editedDates = _this$state3.editedDates;
	
	      // Store edited dates keyed by round_id. The persisted `rounds` /
	      // `schedulers` arrays are intentionally NOT mutated here — the
	      // display path overlays `editedDates` on top (see getDisplayRounds),
	      // and downstream checks that depend on the persisted server value
	      // (e.g. the Activate Main Rounds gating on the practice round's
	      // end_date) must not see un-saved picker changes.
	
	      var existingEdits = editedDates[round_id] || {};
	      var newEditedDates = Object.assign({}, editedDates, _defineProperty({}, round_id, Object.assign({}, existingEdits, _defineProperty({}, field, datetime))));
	
	      var newChangedRounds = [].concat(_toConsumableArray(changedRounds));
	      if (!newChangedRounds.includes(round_id)) {
	        newChangedRounds.push(round_id);
	      }
	
	      _this.setState({
	        editedDates: newEditedDates,
	        changedRounds: newChangedRounds,
	        startDateChanged: startDateChanged,
	        endDateChanged: endDateChanged
	      });
	    };
	
	    _this.onGradingWeightChange = function (round_id, value) {
	      var _this$state4 = _this.state,
	          changedRounds = _this$state4.changedRounds,
	          editedGradingWeights = _this$state4.editedGradingWeights;
	
	      var next = Object.assign({}, editedGradingWeights, _defineProperty({}, round_id, value));
	      var nextChanged = changedRounds.includes(round_id) ? [].concat(_toConsumableArray(changedRounds)) : [].concat(_toConsumableArray(changedRounds), [round_id]);
	      _this.setState({
	        editedGradingWeights: next,
	        changedRounds: nextChanged
	      });
	    };
	
	    _this.onUpdate = function (round_id) {
	      // Find the round in display rounds
	      var displayRounds = _this.getDisplayRounds();
	      var round = displayRounds.find(function (r) {
	        return r.id === round_id;
	      });
	      if (!round) return;
	
	      var _this$state5 = _this.state,
	          startDateChanged = _this$state5.startDateChanged,
	          endDateChanged = _this$state5.endDateChanged;
	
	
	      if (!round.start_date || !round.end_date) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Missing Dates',
	          errorMessage: 'Please set both start and end dates before updating.'
	        });
	        return;
	      }
	
	      var startDate = _moment2.default.isMoment(round.start_date) ? round.start_date : (0, _moment2.default)(round.start_date);
	      var endDate = _moment2.default.isMoment(round.end_date) ? round.end_date : (0, _moment2.default)(round.end_date);
	      var currentDateTime = (0, _moment2.default)();
	
	      if (endDate.isBefore(startDate)) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Start Time > End Time',
	          errorMessage: 'The start date/time cannot be greater than the end date/time.'
	        });
	        return;
	      }
	
	      var otherRounds = displayRounds.filter(function (r) {
	        return r.id !== round_id && r.start_date && r.end_date;
	      });
	      var overlappingRound = otherRounds.find(function (r) {
	        var otherStart = _moment2.default.isMoment(r.start_date) ? r.start_date : (0, _moment2.default)(r.start_date);
	        var otherEnd = _moment2.default.isMoment(r.end_date) ? r.end_date : (0, _moment2.default)(r.end_date);
	        return startDate.isBefore(otherEnd) && endDate.isAfter(otherStart);
	      });
	
	      if (overlappingRound) {
	        var overlapName = overlappingRound.displayName || 'Round ' + overlappingRound.number;
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Overlapping Rounds',
	          errorMessage: 'The dates/times for ' + (round.displayName || 'this round') + ' overlap with ' + overlapName + '. Please adjust the dates so that rounds do not overlap.'
	        });
	        return;
	      }
	
	      // Compare at minute precision so an instructor who picks a time
	      // equal to "right now" (e.g. 11:00 while the clock just ticked
	      // past 11:00:25) isn't flagged for being in the past. The intent
	      // of the rule is to block earlier calendar/clock-minute values,
	      // not sub-minute slippage.
	      if (startDateChanged && startDate.isBefore(currentDateTime, 'minute') || endDateChanged && endDate.isBefore(currentDateTime, 'minute')) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | In the Past',
	          errorMessage: 'The start or end date/time cannot be set in the past.'
	        });
	        return;
	      }
	
	      if (Math.abs(startDate.diff(endDate, 'days')) > 30) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | 30 Days Restriction',
	          errorMessage: 'A round cannot be set 30 days or more.'
	        });
	        return;
	      }
	
	      // 30-day gap rule: a main round's start_date cannot be more than
	      // 30 days past the prior main round's end_date. Practice rounds
	      // are skipped. See getStartGapViolation for the exact conditions.
	      var gapViolation = _this.getStartGapViolation(round, displayRounds);
	      if (gapViolation) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Round Gap Too Large',
	          errorMessage: (round.displayName || 'This round') + '\'s start date must be within 30 days of ' + gapViolation.priorDisplayName + '\'s end date (by ' + gapViolation.maxStart.format('MMM D, YYYY') + ').'
	        });
	        return;
	      }
	
	      // Round weight: validate the range for non-practice rows. Actual
	      // payload resolution happens below (once `rounds` is destructured
	      // from state) so we can compare against the stored value.
	      var editedGWRaw = _this.state.editedGradingWeights[round_id];
	      if (round.displayName !== 'Practice' && editedGWRaw !== undefined) {
	        var editedGWNum = Number(editedGWRaw);
	        if (!Number.isFinite(editedGWNum) || editedGWNum <= 0 || editedGWNum > 1) {
	          _this.setState({
	            showError: true,
	            errorTitle: 'Error | Invalid Round Weight',
	            errorMessage: 'Round weight must be greater than 0 and no more than 1.'
	          });
	          return;
	        }
	      }
	
	      _this.setState({ loadingButtonRound: round_id });
	
	      var _this$state6 = _this.state,
	          changedRounds = _this$state6.changedRounds,
	          gameId = _this$state6.gameId,
	          gameType = _this$state6.gameType,
	          gameReset = _this$state6.gameReset,
	          rounds = _this$state6.rounds,
	          schedulers = _this$state6.schedulers;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var isLegend = gameType === 'Legend';
	      var isPractice = round.displayName === 'Practice';
	
	      // Resolve the grading_weight value to include in the outgoing body.
	      // - Practice: always inherits Round 1's current grading_weight.
	      // - Main rounds: include only if the edited value differs from the
	      //   backend's stored value (skip no-op writes).
	      var gradingWeightPayload = void 0; // undefined = omit from body
	      if (isPractice) {
	        var round1 = displayRounds.find(function (r) {
	          return r.displayName !== 'Practice' && Number(r.number) === 1;
	        });
	        if (round1 && round1.grading_weight != null) {
	          var gw = Number(round1.grading_weight);
	          if (Number.isFinite(gw) && gw > 0 && gw <= 1) {
	            gradingWeightPayload = gw;
	          }
	        }
	      } else if (editedGWRaw !== undefined) {
	        var _editedGWNum = Number(editedGWRaw);
	        var apiRoundRecord = rounds.find(function (r) {
	          return r.id === round_id && r.source === 'round_api';
	        });
	        var storedGW = apiRoundRecord && apiRoundRecord.grading_weight != null ? Number(apiRoundRecord.grading_weight) : null;
	        if (storedGW === null || Math.abs(storedGW - _editedGWNum) > 1e-9) {
	          gradingWeightPayload = _editedGWNum;
	        }
	      }
	
	      // Determine which API to call based on source
	      var apiRound = rounds.find(function (r) {
	        return r.id === round_id && r.source === 'round_api';
	      });
	
	      if (apiRound) {
	        // Round exists in general-info → PATCH to round API with only the
	        // fields the instructor actually changed. Using PATCH avoids
	        // re-sending an already-in-the-past start_date when only end_date
	        // changed, which would otherwise trip the backend's
	        // "start date cannot be less than now" validation.
	        var roundEdits = _this.state.editedDates[round_id] || {};
	        var patchBody = {};
	        if (roundEdits.start_date) patchBody.start_date = startDate.toISOString();
	        if (roundEdits.end_date) patchBody.end_date = endDate.toISOString();
	        if (gradingWeightPayload !== undefined) patchBody.grading_weight = gradingWeightPayload;
	
	        (0, _ApiService.patchRequest)(apiUrl + 'game/rounds/' + round_id + '/').send(patchBody).then(function (res) {
	          var nextRounds = _this.state.rounds.map(function (r) {
	            if (r.id !== round_id) return r;
	            var updated = Object.assign({}, r);
	            if (patchBody.start_date) updated.start_date = startDate;
	            if (patchBody.end_date) updated.end_date = endDate;
	            if (patchBody.grading_weight !== undefined) updated.grading_weight = patchBody.grading_weight;
	            return updated;
	          });
	          _this.setState({
	            loadingButtonRound: 0,
	            rounds: nextRounds,
	            changedRounds: changedRounds.filter(function (i) {
	              return i !== round_id;
	            }),
	            editedDates: Object.keys(_this.state.editedDates).reduce(function (acc, key) {
	              if (key !== String(round_id)) acc[key] = _this.state.editedDates[key];return acc;
	            }, {}),
	            showSuccess: true,
	            successfullyChangedRoundNumber: round.displayName || 'Round ' + round.number
	          });
	          // Rebuild round-admin state from BE to defend against any
	          // divergence between the local in-memory update above and
	          // the persisted server state. Instructors were seeing empty
	          // date inputs right after a successful save and only a
	          // manual refresh recovered — this refetch removes the need
	          // for that refresh.
	          (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	          _this.fetchData();
	        }).catch(function (err) {
	          _this.handleUpdateError(err);
	        });
	        return;
	      }
	
	      if (isPractice) {
	        // Explorer/Adventurer practice round: always uses the round API.
	        // The scheduler is not involved — setting practice dates auto-opens
	        // the practice round.
	        (0, _ApiService.postRequest)(apiUrl + 'game/rounds/').send(Object.assign({
	          number: 1,
	          type: 1,
	          practice: 'Yes',
	          results_viewable: true,
	          start_date: startDate.toISOString(),
	          end_date: endDate.toISOString(),
	          game: gameId
	        }, gradingWeightPayload !== undefined ? { grading_weight: gradingWeightPayload } : {})).then(function (res) {
	          var newRound = {
	            id: res.body.id,
	            number: 1,
	            start_date: startDate,
	            end_date: endDate,
	            showResults: true,
	            is_started: false,
	            is_finished: false,
	            practice: 'Yes',
	            source: 'round_api',
	            grading_weight: gradingWeightPayload
	          };
	          var nextRounds = [].concat(_toConsumableArray(rounds), [newRound]);
	          _this.setState({
	            loadingButtonRound: 0,
	            changedRounds: changedRounds.filter(function (i) {
	              return i !== round_id;
	            }),
	            editedDates: Object.keys(_this.state.editedDates).reduce(function (acc, key) {
	              if (key !== String(round_id)) acc[key] = _this.state.editedDates[key];return acc;
	            }, {}),
	            rounds: nextRounds,
	            showSuccess: true,
	            successfullyChangedRoundNumber: round.displayName || 'Practice'
	          }, function () {
	            _this.notifyRoundCreated({
	              gameType: gameType,
	              gameReset: gameReset,
	              isPractice: true,
	              createdRoundNumber: 1,
	              newRounds: nextRounds,
	              newSchedulers: schedulers
	            });
	            // See PATCH branch above for why we refetch here.
	            (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	            _this.fetchData();
	          });
	        }).catch(function (err) {
	          _this.handleUpdateError(err);
	        });
	        return;
	      }
	
	      if (isLegend || gameReset) {
	        // Legend has no scheduler at all. Explorer/Adventurer main rounds
	        // also use the round API once the game has been reset (after
	        // "Activate Main Rounds" was clicked). Pre-reset Explorer/Adventurer
	        // main rounds fall through to the scheduler paths below.
	        (0, _ApiService.postRequest)(apiUrl + 'game/rounds/').send(Object.assign({
	          number: round.number,
	          type: 2,
	          practice: 'No',
	          results_viewable: true,
	          start_date: startDate.toISOString(),
	          end_date: endDate.toISOString(),
	          game: gameId
	        }, gradingWeightPayload !== undefined ? { grading_weight: gradingWeightPayload } : {})).then(function (res) {
	          var newRound = {
	            id: res.body.id,
	            number: round.number,
	            start_date: startDate,
	            end_date: endDate,
	            showResults: true,
	            is_started: false,
	            is_finished: false,
	            practice: 'No',
	            source: 'round_api',
	            grading_weight: gradingWeightPayload
	          };
	          var nextRounds = [].concat(_toConsumableArray(rounds), [newRound]);
	          _this.setState({
	            loadingButtonRound: 0,
	            changedRounds: changedRounds.filter(function (i) {
	              return i !== round_id;
	            }),
	            editedDates: Object.keys(_this.state.editedDates).reduce(function (acc, key) {
	              if (key !== String(round_id)) acc[key] = _this.state.editedDates[key];return acc;
	            }, {}),
	            rounds: nextRounds,
	            showSuccess: true,
	            successfullyChangedRoundNumber: round.displayName || 'Round ' + round.number
	          }, function () {
	            _this.notifyRoundCreated({
	              gameType: gameType,
	              gameReset: gameReset,
	              isPractice: false,
	              createdRoundNumber: round.number,
	              newRounds: nextRounds,
	              newSchedulers: schedulers
	            });
	            // See PATCH branch above for why we refetch here.
	            (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	            _this.fetchData();
	          });
	        }).catch(function (err) {
	          _this.handleUpdateError(err);
	        });
	        return;
	      }
	
	      // Explorer/Adventurer main round, pre-reset: use scheduler API
	      var scheduler = schedulers.find(function (s) {
	        return s.id === round_id && s.source === 'scheduler';
	      });
	
	      if (scheduler) {
	        // Scheduler exists → PUT to scheduler API
	        var schedCourseId = _this.state.courseId;
	
	        (0, _ApiService.putRequest)(apiUrl + 'v2/games/roundschedulers/' + (scheduler.scheduler_id || scheduler.id) + '/').send(Object.assign({
	          round_number: round.number,
	          start_date: startDate.toISOString(),
	          end_date: endDate.toISOString(),
	          course: schedCourseId,
	          practice: false
	        }, gradingWeightPayload !== undefined ? { grading_weight: gradingWeightPayload } : {})).then(function (res) {
	          var nextSchedulers = _this.state.schedulers.map(function (s) {
	            if (s.id !== round_id) return s;
	            var updated = Object.assign({}, s, { start_date: startDate, end_date: endDate });
	            if (gradingWeightPayload !== undefined) updated.grading_weight = gradingWeightPayload;
	            return updated;
	          });
	          _this.setState({
	            loadingButtonRound: 0,
	            schedulers: nextSchedulers,
	            changedRounds: changedRounds.filter(function (i) {
	              return i !== round_id;
	            }),
	            editedDates: Object.keys(_this.state.editedDates).reduce(function (acc, key) {
	              if (key !== String(round_id)) acc[key] = _this.state.editedDates[key];return acc;
	            }, {}),
	            showSuccess: true,
	            successfullyChangedRoundNumber: round.displayName || 'Round ' + round.number
	          });
	          // See PATCH branch above for why we refetch here.
	          (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	          _this.fetchData();
	        }).catch(function (err) {
	          _this.handleUpdateError(err);
	        });
	        return;
	      }
	
	      // Neither exists → POST to scheduler API
	      var courseId = _this.state.courseId;
	
	      (0, _ApiService.postRequest)(apiUrl + 'v2/games/roundschedulers/').send(Object.assign({
	        round_number: round.number,
	        start_date: startDate.toISOString(),
	        end_date: endDate.toISOString(),
	        course: courseId,
	        practice: false
	      }, gradingWeightPayload !== undefined ? { grading_weight: gradingWeightPayload } : {})).then(function (res) {
	        // Add the new scheduler to state
	        var newScheduler = {
	          id: res.body.id,
	          number: round.number,
	          start_date: startDate,
	          end_date: endDate,
	          showResults: false,
	          is_started: false,
	          is_finished: false,
	          practice: false,
	          source: 'scheduler',
	          scheduler_id: res.body.id,
	          grading_weight: gradingWeightPayload
	        };
	
	        var nextSchedulers = [].concat(_toConsumableArray(schedulers), [newScheduler]);
	        _this.setState({
	          loadingButtonRound: 0,
	          changedRounds: changedRounds.filter(function (i) {
	            return i !== round_id;
	          }),
	          schedulers: nextSchedulers,
	          showSuccess: true,
	          successfullyChangedRoundNumber: round.displayName || 'Round ' + round.number
	        }, function () {
	          _this.notifyRoundCreated({
	            gameType: gameType,
	            gameReset: gameReset,
	            isPractice: false,
	            createdRoundNumber: round.number,
	            newRounds: rounds,
	            newSchedulers: nextSchedulers
	          });
	          // See PATCH branch above for why we refetch here.
	          (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	          _this.fetchData();
	        });
	      }).catch(function (err) {
	        _this.handleUpdateError(err);
	      });
	    };
	
	    _this.handleUpdateError = function (err) {
	      _this.setState({ loadingButtonRound: 0 });
	
	      var message = (0, _roundError.extractRoundErrorMessage)(err) || "Unable to update the round. Please try again.";
	
	      _this.setState({
	        showError: true,
	        errorTitle: 'Error | Server Error',
	        errorMessage: message
	      });
	    };
	
	    _this.onShowResultsChange = function (round_id) {
	      var rounds = _this.state.rounds;
	
	      var round = rounds.find(function (i) {
	        return i.id === round_id;
	      });
	      if (!round) return;
	
	      var newShowResults = !round.showResults;
	
	      var url = ("https://be-production-itb.marketgames.io/api/") + 'game/rounds/' + round_id + '/';
	      var request = (0, _ApiService.patchRequest)(url);
	
	      // Only the one field that's actually changing. The backend's PATCH
	      // semantics handle partial updates — sending start/end dates again
	      // is redundant.
	      request.send({ results_viewable: !round.showResults }).then(function () {
	        var updatedRounds = rounds.map(function (r) {
	          return r.id === round_id ? Object.assign({}, r, { showResults: newShowResults }) : r;
	        });
	        _this.setState({ rounds: updatedRounds });
	      }).catch(function (err) {
	        _this.handleUpdateError(err);
	      });
	    };
	
	    _this.hideSuccessAlert = function () {
	      _this.setState({ showSuccess: false });
	    };
	
	    _this.hideErrorAlert = function () {
	      _this.setState({ showError: false });
	    };
	
	    _this.onActivationClick = function () {
	      var activationState = _this.getActivationButtonState();
	      if (!activationState || !activationState.isClickable) return;
	
	      if (activationState.type === 'start_main') {
	        _this.handleStartMainRounds();
	      }
	    };
	
	    _this.handleStartMainRounds = function () {
	      var _this$state7 = _this.state,
	          gameType = _this$state7.gameType,
	          schedulers = _this$state7.schedulers;
	
	      // Block activation when Round 1's scheduled end has already
	      // passed. In that case the saved start/end are both in the
	      // past and there's no sensible start time to substitute — the
	      // instructor needs to edit the deadlines first.
	
	      var round1 = schedulers.find(function (s) {
	        return Number(s.number) === 1 && s.practice !== true;
	      });
	      if (round1 && round1.end_date && (0, _moment2.default)().isAfter(round1.end_date)) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Round Deadlines in the Past',
	          errorMessage: "Round 1's end date is in the past. Please adjust the round deadlines so they are not in the past before activating."
	        });
	        return;
	      }
	
	      if (gameType === 'Legend') {
	        // Legend: no practice round, skip confirmation
	        _this.proceedWithMainRounds();
	      } else {
	        // Explorer or Adventurer: show confirmation modal
	        _this.setState({ showConfirmModal: true });
	      }
	    };
	
	    _this.onConfirmMainRounds = function () {
	      _this.setState({ showConfirmModal: false });
	      _this.proceedWithMainRounds();
	    };
	
	    _this.proceedWithMainRounds = function () {
	      var gameReset = _this.state.gameReset;
	
	
	      _this.setState({ activationLoading: true });
	
	      if (!gameReset) {
	        // Step 4: Reset game first
	        _this.resetGame(0);
	      } else {
	        // reset=true already: verify that main rounds don't already
	        // exist on the backend before jumping to createMainRounds. If
	        // any exist, we're in a stale state (e.g. reset_game failed
	        // previously but game.reset was flipped to true manually) and
	        // we must re-run reset_game to clear them.
	        _this.verifyAndCreateMainRounds();
	      }
	    };
	
	    _this.showResetFailedError = function () {
	      _this.setState({
	        activationLoading: false,
	        showError: true,
	        errorTitle: 'Error | Reset Failed',
	        errorMessage: "Game reset failed. Please try a few more times. If it continues to fail, reach out to support@marketgames.io."
	      });
	    };
	
	    _this.verifyAndCreateMainRounds = function () {
	      var gameId = _this.state.gameId;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      (0, _ApiService.getRequest)(apiUrl + 'game/rounds/').then(function (res) {
	        var body = res && res.body || {};
	        var rows = Array.isArray(body) ? body : body.results || [];
	        var mainRoundsExist = rows.some(function (r) {
	          return r && Number(r.game) === Number(gameId) && r.practice === 'No';
	        });
	
	        if (!mainRoundsExist) {
	          // Clean state — proceed straight to Step 6.
	          _this.createMainRounds();
	          return;
	        }
	
	        // Stale state — re-run reset_game with revert-on-failure.
	        _this.resetGameForStaleState(0);
	      }).catch(function () {
	        // If we can't confirm the round state, treat it like a reset
	        // failure — safer than blindly creating rounds on top of a
	        // possibly dirty backend.
	        _this.showResetFailedError();
	      });
	    };
	
	    _this.resetGameForStaleState = function (retryCount) {
	      var gameId = _this.state.gameId;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      (0, _ApiService.postRequest)(apiUrl + 'games/reset_game/').send({ game: gameId }).then(function () {
	        // reset_game itself succeeded — make sure game.reset stays
	        // true on the backend (it already was) and proceed.
	        _this.createMainRounds();
	      }).catch(function (err) {
	        var status = err && err.status;
	        var isTransient = !status || status >= 500;
	        if (isTransient && retryCount < 2) {
	          setTimeout(function () {
	            return _this.resetGameForStaleState(retryCount + 1);
	          }, 2000);
	          return;
	        }
	        // Revert game.reset to false so state matches "reset didn't
	        // happen" for the next click. Fire-and-forget: if this also
	        // fails, the FE-side state was already reset, and the error
	        // message tells the instructor to retry.
	        //
	        // PATCH because we're touching a single field on an existing
	        // record. The endpoint doesn't accept POST — DRF ModelViewSet
	        // detail routes are GET/PUT/PATCH/DELETE only.
	        (0, _ApiService.patchRequest)(apiUrl + 'games/' + gameId + '/').send({ reset: false }).then(function () {
	          _this.setState({ gameReset: false });
	        }).catch(function () {/* silent */});
	        _this.showResetFailedError();
	      });
	    };
	
	    _this.resetGame = function (retryCount) {
	      var gameId = _this.state.gameId;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      (0, _ApiService.postRequest)(apiUrl + 'games/reset_game/').send({ game: gameId }).then(function (res) {
	        // Step 5: Update game reset = true. PATCH because we're
	        // touching a single field on an existing record; the detail
	        // route doesn't accept POST.
	        //
	        // Failure here is NOT fatal to activation — the actual reset
	        // (Step 4) already succeeded on the backend and the
	        // schedulers already have the data we need for Step 6. Log
	        // the error, optimistically flip local gameReset so state
	        // reflects "the reset happened," and continue to
	        // createMainRounds. The next fetchData will reconcile if
	        // game.reset stayed false server-side.
	        (0, _ApiService.patchRequest)(apiUrl + 'games/' + gameId + '/').send({ reset: true }).then(function () {
	          _this.setState({ gameReset: true });
	          _this.createMainRounds();
	        }).catch(function (err) {
	          // eslint-disable-next-line no-console
	          console.error('RoundAdmin: failed to PATCH game.reset=true; proceeding anyway', err);
	          _this.setState({ gameReset: true });
	          _this.createMainRounds();
	        });
	      }).catch(function (err) {
	        // Only retry transient failures (5xx or no response). A 4xx
	        // means the request is wrong (bad payload, endpoint gone,
	        // auth) and repeating won't help.
	        var status = err && err.status;
	        var isTransient = !status || status >= 500;
	        if (isTransient && retryCount < 2) {
	          setTimeout(function () {
	            return _this.resetGame(retryCount + 1);
	          }, 2000);
	        } else {
	          _this.showResetFailedError();
	        }
	      });
	    };
	
	    _this.createMainRounds = function () {
	      var _this$state8 = _this.state,
	          schedulers = _this$state8.schedulers,
	          gameType = _this$state8.gameType,
	          gameId = _this$state8.gameId;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	      var requiredRounds = gameType === 'Explorer' ? [1] : [1, 2, 3];
	
	      // Guard: every required round must have a scheduler row before we
	      // start POSTing. Otherwise a missing scheduler causes a null
	      // dereference on scheduler.start_date and either crashes silently
	      // or ships a bad request. Surface a clear error instead.
	      var missing = requiredRounds.filter(function (n) {
	        return !schedulers.some(function (s) {
	          return Number(s.number) === Number(n);
	        });
	      });
	      if (missing.length > 0) {
	        _this.setState({
	          activationLoading: false,
	          showError: true,
	          errorTitle: 'Error | Missing Round Deadlines',
	          errorMessage: 'Set start and end dates for Round ' + missing.join(', ') + ' before activating the main rounds.'
	        });
	        return;
	      }
	
	      var createRound = function createRound(index) {
	        if (index >= requiredRounds.length) {
	          // All rounds created, proceed to Step 7: Rotate roles
	          _this.rotateRoles();
	          return;
	        }
	
	        var roundNumber = requiredRounds[index];
	        var scheduler = schedulers.find(function (s) {
	          return Number(s.number) === Number(roundNumber);
	        });
	
	        // Round 1 start-time safeguard: when the instructor finally
	        // activates the main rounds after the scheduled start has
	        // already passed, use "now" instead of the stale scheduled
	        // start so the round reflects the actual go-live moment. The
	        // end-date-in-past case is caught upstream in
	        // handleStartMainRounds and never reaches here. Later rounds
	        // (2, 3) always ship their scheduled start_date verbatim.
	        var scheduledStart = (0, _moment2.default)(scheduler.start_date);
	        var startDate = roundNumber === 1 && (0, _moment2.default)().isAfter(scheduledStart) ? (0, _moment2.default)() : scheduledStart;
	
	        // Carry the scheduler's grading_weight (if any) onto the newly
	        // created round API record. Without this, the Round Admin table
	        // would snap back to the 0.3333 default under the gameReset=true
	        // round-API-only rule, silently wiping any custom weight the
	        // instructor set before activating.
	        var schedulerGW = scheduler && scheduler.grading_weight != null ? Number(scheduler.grading_weight) : null;
	        var roundBody = {
	          number: roundNumber,
	          type: 2,
	          practice: 'No',
	          results_viewable: true,
	          start_date: startDate.toISOString(),
	          end_date: (0, _moment2.default)(scheduler.end_date).toISOString(),
	          game: gameId
	        };
	        if (schedulerGW != null && Number.isFinite(schedulerGW)) {
	          roundBody.grading_weight = schedulerGW;
	        }
	
	        (0, _ApiService.postRequest)(apiUrl + 'game/rounds/').send(roundBody).then(function (res) {
	          createRound(index + 1);
	        }).catch(function (err) {
	          _this.setState({
	            activationLoading: false,
	            showError: true,
	            errorTitle: 'Error | Round Creation Failed',
	            errorMessage: (0, _roundError.extractRoundErrorMessage)(err) || 'Unable to create Round ' + roundNumber + '. Please try again.'
	          });
	        });
	      };
	
	      createRound(0);
	    };
	
	    _this.rotateRoles = function () {
	      var gameId = _this.state.gameId;
	
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      // The activation is considered successful once rounds are created
	      // (Step 6). Role rotation is best-effort; fire the confirmation
	      // popup in both branches. The popup replaces the old "Main Rounds
	      // Activated!" persistent button — user now gets a one-time
	      // confirmation and the button simply disappears on next render.
	      var finish = function finish() {
	        _this.setState({ activationLoading: false });
	        _this.openRoundsSetPopup('Main rounds are live!', 'Your main rounds are set. Students can start posting decisions for Round 1.');
	        // The activation flow PATCHed game.reset=true on the backend.
	        // fetchAppGeneralInfo has a 5-minute cache, so a naked refetch
	        // here would return the pre-activation payload (game.reset=false)
	        // and flip state.gameReset back to false — which brings the
	        // Activate Main Rounds button back even though activation
	        // succeeded. Bust the cache first so the refetch hits the wire.
	        (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	        _this.fetchData();
	      };
	
	      (0, _ApiService.postRequest)(apiUrl + 'v2/games/rotate-roles/').send({ game_id: gameId }).then(finish).catch(finish);
	    };
	
	    _this.getActivationButtonState = function () {
	      var _this$state9 = _this.state,
	          gameReset = _this$state9.gameReset,
	          gameType = _this$state9.gameType,
	          rounds = _this$state9.rounds;
	
	      // Legend has no practice round and doesn't use the scheduler-based
	      // activation flow — its rounds are created directly via the round API
	      // when the instructor saves dates, so no activation button is shown.
	
	      if (gameType === 'Legend') {
	        return null;
	      }
	
	      // Post-activation (gameReset === true): the button disappears
	      // entirely. Confirmation is delivered as a one-time popup from
	      // rotateRoles instead of a persistent "Main Rounds Activated!"
	      // pill sitting on the page forever.
	      if (gameReset) {
	        return null;
	      }
	
	      // Explorer/Adventurer, pre-activation: the button is gated on the
	      // practice round having ended. Practice round is identified by
	      // `practice === 'Yes'` in the round API; the button becomes active
	      // once its end_date is in the past.
	      if (!gameReset) {
	        var practiceRoundEnded = rounds.some(function (r) {
	          return r.practice === 'Yes' && r.end_date && (0, _moment2.default)(r.end_date).isBefore((0, _moment2.default)());
	        });
	
	        if (practiceRoundEnded) {
	          return { prefix: 'Activate', status: 'Main Rounds', isClickable: true, type: 'start_main' };
	        }
	
	        return {
	          prefix: 'Activate',
	          status: 'Main Rounds',
	          isClickable: false,
	          type: 'activate_main_inactive',
	          tooltip: 'You can activate the main rounds once the practice round ends.'
	        };
	      }
	
	      return null;
	    };
	
	    _this.state = {
	      loaded: false,
	      gameId: 0,
	      gameType: null,
	      courseId: 0,
	      gameReset: false,
	      rounds: [],
	      schedulers: [],
	      editedDates: {},
	      editedGradingWeights: {},
	      changedRounds: [],
	      defaultActiveRounds: [],
	      showSuccess: false,
	      successfullyChangedRoundNumber: 0,
	      showError: false,
	      errorTitle: '',
	      errorMessage: '',
	      startDateChanged: false,
	      endDateChanged: false,
	      loadingButtonRound: 0,
	      roundsName: '',
	      showConfirmModal: false,
	      activationLoading: false,
	      // Coaching popup fired after a round is created (not edited).
	      // Message varies by game type, gameReset, and which round was
	      // created. See notifyRoundCreated below for the full matrix.
	      roundsSetPopup: { open: false, title: '', body: '' }
	    };
	    return _this;
	  }
	
	  // Called from each round-creation success handler. Decides which
	  // popup (if any) fires, based on:
	  //   - gameType (Adventurer / Explorer / Legend)
	  //   - gameReset flag at the time of creation
	  //   - which round was just created (practice or main; number)
	  //   - the resulting state of rounds/schedulers so we can detect
	  //     "all rounds are now set"
	  //
	  // Skipped intentionally:
	  //   - Edits to existing rounds/schedulers (PATCH/PUT paths)
	  //   - Auto-creation during the Activate Main Rounds button flow
	  //     (that lives in createMainRounds, which never calls this)
	
	
	  _createClass(RoundAdmin, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.state.gameId === 0 && this.props.game && this.props.game.id) {
	        this.setState({ gameId: this.props.game.id });
	      }
	    }
	
	    // Rule: a main round's start_date cannot be more than 30 days after
	    // the prior main round's end_date. Practice rounds don't count as
	    // a prior. Skips when either the round being checked or its prior
	    // has no start/end set yet, or when there is no prior main round
	    // (i.e. Round 1). Returns { priorDisplayName, maxStart, priorEndDate }
	    // on violation, or null.
	
	
	    // "Activate Main Rounds" click handler
	
	
	    // Step 2/3: Entry point after confirmation
	
	
	    // Shared error copy for any reset_game failure. Named so it stays
	    // consistent across the initial-reset and stale-state paths.
	
	
	    // Handles the "gameReset is already true" branch: if any main
	    // rounds (practice: 'No') already exist for this game, re-run
	    // reset_game to wipe them. On success proceed to createMainRounds;
	    // on failure revert game.reset to false on the backend so the FE
	    // and BE don't stay out of sync, then surface the error.
	    //
	    // Uses a FRESH game/rounds/ fetch (not state.rounds) so the check
	    // is accurate even if state.rounds was loaded a while ago. This is
	    // the safer default given how consequential creating rounds is.
	
	
	    // Reset variant used when we KNOW game.reset was already true but
	    // rounds are still present. On failure, POST game.reset = false to
	    // undo the stale flag so the next attempt starts from a consistent
	    // baseline (rather than repeatedly skipping reset).
	
	
	    // Step 4: Reset game (up to 3 attempts on transient failures)
	
	
	    // Step 6: Create main rounds using scheduler data, then Step 7: Rotate roles
	
	
	    // Step 7: Rotate roles (if success or fail, finish)
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          changedRounds = _state.changedRounds,
	          showSuccess = _state.showSuccess,
	          successfullyChangedRoundNumber = _state.successfullyChangedRoundNumber,
	          showError = _state.showError,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          loadingButtonRound = _state.loadingButtonRound,
	          defaultActiveRounds = _state.defaultActiveRounds,
	          showConfirmModal = _state.showConfirmModal,
	          activationLoading = _state.activationLoading;
	
	
	      var activationState = loaded ? this.getActivationButtonState() : null;
	      var isIAS = _Auth2.default.isAssistantOrCoInstructor();
	      var cardSubtitle = this.state.gameType === 'Legend' ? 'Set the round deadlines.' : 'Set the round deadlines. Once the practice round ends, click Activate to start the main rounds.';
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          PageTitle,
	          null,
	          'Round Admin'
	        ),
	        showError && _react2.default.createElement(_error2.default, {
	          title: errorTitle,
	          message: errorMessage,
	          onHide: this.hideErrorAlert
	        }),
	        showSuccess && _react2.default.createElement(_decisions2.default, {
	          type: 'success',
	          title: 'Success!',
	          message: successfullyChangedRoundNumber + ' has been successfully updated!',
	          onHide: this.hideSuccessAlert
	        }),
	        _react2.default.createElement(
	          CardWrapper,
	          null,
	          _react2.default.createElement(
	            CardTitle,
	            null,
	            'Round Deadlines'
	          ),
	          _react2.default.createElement(
	            CardSubtitle,
	            null,
	            cardSubtitle
	          ),
	          _react2.default.createElement(CardDivider, null),
	          !loaded && _react2.default.createElement(
	            LoaderWrapper,
	            null,
	            _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	          ),
	          loaded && _react2.default.createElement(_table2.default, {
	            rounds: this.getDisplayRounds(),
	            onChange: this.onChange,
	            onGradingWeightChange: this.onGradingWeightChange,
	            changedRounds: changedRounds,
	            onUpdate: this.onUpdate,
	            loadingButtonRound: loadingButtonRound,
	            showOverlay: this.showOverlay,
	            hideOverlay: this.hideOverlay,
	            defaultActiveRounds: defaultActiveRounds,
	            onShowResultsChange: this.onShowResultsChange,
	            isIAS: isIAS
	          }),
	          loaded && activationState && !isIAS && _react2.default.createElement(
	            CardActivationWrapper,
	            null,
	            _react2.default.createElement(
	              ActivationHoverGroup,
	              null,
	              _react2.default.createElement(
	                ActivationButton,
	                {
	                  isClickable: activationState.isClickable && !activationLoading,
	                  onClick: this.onActivationClick
	                },
	                activationLoading ? _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true }) : _react2.default.createElement(
	                  ActivationButtonText,
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'prefix' },
	                    activationState.prefix
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'status' },
	                    activationState.status
	                  )
	                )
	              ),
	              activationState.tooltip && _react2.default.createElement(
	                ActivationTooltip,
	                null,
	                activationState.tooltip
	              )
	            )
	          )
	        ),
	        showConfirmModal && _react2.default.createElement(
	          ConfirmOverlay,
	          { onClick: function onClick() {
	              return _this2.setState({ showConfirmModal: false });
	            } },
	          _react2.default.createElement(
	            ConfirmModal,
	            { onClick: function onClick(e) {
	                return e.stopPropagation();
	              } },
	            _react2.default.createElement(
	              ConfirmTitle,
	              null,
	              'Are You Sure?'
	            ),
	            _react2.default.createElement(
	              ConfirmMessage,
	              null,
	              'Are you sure you\'re ready to begin the Main Rounds? Starting the Main Rounds will reset the game and permanently clear all Practice Round data. This action cannot be undone.'
	            ),
	            _react2.default.createElement(
	              ConfirmActions,
	              null,
	              _react2.default.createElement(
	                ConfirmCancelButton,
	                { onClick: function onClick() {
	                    return _this2.setState({ showConfirmModal: false });
	                  } },
	                'Cancel'
	              ),
	              _react2.default.createElement(
	                ConfirmProceedButton,
	                { onClick: this.onConfirmMainRounds },
	                'I\'m sure'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_firstDecisionModal2.default, {
	          open: this.state.roundsSetPopup.open,
	          title: this.state.roundsSetPopup.title,
	          body: this.state.roundsSetPopup.body,
	          ctaLabel: 'Got it',
	          onCta: this.closeRoundsSetPopup,
	          onClose: this.closeRoundsSetPopup
	        })
	      );
	    }
	  }]);
	
	  return RoundAdmin;
	}(_react.PureComponent);
	
	exports.default = RoundAdmin;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _roundEdit = __webpack_require__(1509);
	
	var _roundEdit2 = _interopRequireDefault(_roundEdit);
	
	var _roundNew = __webpack_require__(1510);
	
	var _roundNew2 = _interopRequireDefault(_roundNew);
	
	var _ApiService = __webpack_require__(4);
	
	var _sweetalertReact = __webpack_require__(177);
	
	var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);
	
	var _momentTimezone = __webpack_require__(143);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _roundError = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoundManagement = function (_PureComponent) {
	  _inherits(RoundManagement, _PureComponent);
	
	  function RoundManagement(props) {
	    _classCallCheck(this, RoundManagement);
	
	    var _this = _possibleConstructorReturn(this, (RoundManagement.__proto__ || Object.getPrototypeOf(RoundManagement)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var location = props.location;
	
	    var pathes = location.pathname.split("/").filter(function (i) {
	      return i !== "";
	    });
	    var game_id = parseInt(pathes[2], 10);
	    if (isNaN(game_id)) {
	      game_id = props.game && props.game.id ? props.game.id : 0;
	    }
	
	    _this.state = {
	      is_loaded: false,
	      current_round_number: null,
	      game_id: game_id,
	      game_name: "",
	      course_name: "",
	      rounds: [],
	      errorAlert: false,
	      errorText: "",
	      successAlert: false,
	      successText: "",
	      new_round: {
	        start_date: null,
	        end_date: null
	      }
	    };
	    return _this;
	  }
	
	  _createClass(RoundManagement, [{
	    key: "createRound",
	    value: function createRound(data) {
	      return (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "game/rounds/").send(data);
	    }
	  }, {
	    key: "updateRound",
	    value: function updateRound(round_id, data) {
	      return (0, _ApiService.patchRequest)(("https://be-production-itb.marketgames.io/api/") + "game/rounds/" + round_id + "/").send(data);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initNewRound();
	      if (this.state.game_id !== 0) {
	        this.fetchData();
	      } else {
	        this.fetchGameId();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.state.game_id === 0 && this.props.game && this.props.game.id) {
	        this.setState({ game_id: this.props.game.id }, function () {
	          _this2.fetchData();
	        });
	      }
	    }
	  }, {
	    key: "fetchGameId",
	    value: function fetchGameId() {
	      var _this3 = this;
	
	      (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "games/").then(function (res) {
	        if (res.body && res.body.length > 0) {
	          _this3.setState({ game_id: res.body[0].id }, function () {
	            _this3.fetchData();
	          });
	        }
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {
	      var _this4 = this;
	
	      var game_id = this.state.game_id;
	
	      var requests = [];
	      requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/"));
	      requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "courses/"));
	      requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "game/rounds/"));
	      var joinRequest = Promise.all(requests);
	
	      joinRequest.then(function (res) {
	        var game = res[0].body;
	        var game_name = game.name;
	        var course = res[1].body.find(function (i) {
	          return i.id === game.course;
	        });
	        var course_name = course ? course.name : "";
	        var rounds = res[2].body.filter(function (i) {
	          return game.rounds.includes(i.id) ? true : false;
	        }).map(function (i) {
	          return {
	            id: i.id,
	            number: i.number,
	            start_date: (0, _momentTimezone2.default)(i.start_date),
	            end_date: (0, _momentTimezone2.default)(i.end_date)
	          };
	        });
	
	        var current_round_number = null;
	        if (game.round !== null) {
	          var current_round = rounds.find(function (i) {
	            return i.id === game.round;
	          });
	          if (current_round) {
	            current_round_number = current_round.number;
	          }
	        }
	
	        _this4.setState({
	          game_name: game_name,
	          course_name: course_name,
	          rounds: rounds,
	          current_round_number: current_round_number,
	          is_loaded: true
	        });
	      }).catch(function (err) {});
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _state = this.state,
	          rounds = _state.rounds,
	          new_round = _state.new_round,
	          is_loaded = _state.is_loaded,
	          errorAlert = _state.errorAlert,
	          errorText = _state.errorText,
	          successAlert = _state.successAlert,
	          successText = _state.successText,
	          game_name = _state.game_name,
	          course_name = _state.course_name;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "instructorPage" },
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: errorAlert,
	          title: "Error",
	          text: errorText,
	          type: "error",
	          onConfirm: this.hideErrorAlert
	        }),
	        _react2.default.createElement(_sweetalertReact2.default, {
	          show: successAlert,
	          title: "Success",
	          text: successText,
	          type: "success",
	          onConfirm: this.hideSuccessAlert
	        }),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Round Management"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "instructorWrapper" },
	          _react2.default.createElement(
	            "b",
	            { style: { fontSize: "20px" } },
	            "Course: ",
	            course_name
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "b",
	            { style: { fontSize: "20px" } },
	            "Game: ",
	            game_name
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Round"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Start Time"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "End Time"
	                  ),
	                  _react2.default.createElement("th", { className: "text-center instructor-table-th" })
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                is_loaded === false ? _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      colSpan: "4",
	                      className: "text-center v-align-middle instructor-td"
	                    },
	                    "Loading..."
	                  )
	                ) : rounds.map(function (round, i) {
	                  return _react2.default.createElement(_roundEdit2.default, {
	                    key: i,
	                    round: round,
	                    onChange: _this5.onChange,
	                    onUpdate: _this5.onUpdate
	                  });
	                }),
	                is_loaded === true && _react2.default.createElement(_roundNew2.default, {
	                  round_number: rounds.length + 1,
	                  round: new_round,
	                  onChange: this.onChangeNew,
	                  onAdd: this.onAdd
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RoundManagement;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this6 = this;
	
	  this.initNewRound = function () {
	    _this6.setState({
	      new_round: {
	        start_date: null,
	        end_date: null
	      }
	    });
	  };
	
	  this.showErrorAlert = function () {
	    _this6.setState({
	      errorAlert: true
	    });
	  };
	
	  this.hideErrorAlert = function () {
	    _this6.setState({
	      errorAlert: false
	    });
	  };
	
	  this.showError = function (errorText) {
	    _this6.setState({
	      errorText: errorText
	    }, function () {
	      _this6.showErrorAlert();
	    });
	  };
	
	  this.showSuccessAlert = function () {
	    _this6.setState({
	      successAlert: true
	    });
	  };
	
	  this.hideSuccessAlert = function () {
	    _this6.setState({
	      successAlert: false
	    });
	  };
	
	  this.showSuccess = function (successText) {
	    _this6.setState({
	      successText: successText
	    }, function () {
	      _this6.showSuccessAlert();
	    });
	  };
	
	  this.onChange = function (datetime, round_id, field) {
	    if (typeof datetime === "string") {
	      return;
	    }
	
	    var rounds = [].concat(_toConsumableArray(_this6.state.rounds));
	    var index = rounds.findIndex(function (i) {
	      return i.id === round_id;
	    });
	
	    if (index >= 0 && field in rounds[index]) {
	      rounds[index][field] = datetime;
	
	      _this6.setState({
	        rounds: rounds
	      });
	    }
	  };
	
	  this.onChangeNew = function (datetime, field) {
	    if (typeof datetime === "string") {
	      return;
	    }
	
	    var new_round = Object.assign({}, _this6.state.new_round);
	
	    if (field in new_round) {
	      new_round[field] = datetime;
	
	      _this6.setState({
	        new_round: new_round
	      });
	    }
	  };
	
	  this.onUpdate = function (round_id) {
	    var game_id = _this6.state.game_id;
	
	    var round = _this6.state.rounds.find(function (i) {
	      return i.id === round_id;
	    });
	
	    if (round.number <= _this6.state.current_round_number) {
	      _this6.showError("The game has been started! You cannot update current or previous rounds!");
	      return;
	    }
	
	    var round_number = round.number;
	
	    var start_date = round.start_date.utc();
	    var end_date = round.end_date.utc();
	
	    if (start_date.valueOf() < (0, _momentTimezone2.default)().utc().valueOf()) {
	      _this6.showError("Start time cannot be less than now!");
	      return;
	    }
	
	    if (end_date.valueOf() < (0, _momentTimezone2.default)().utc().valueOf()) {
	      _this6.showError("End time cannot be less than now!");
	      return;
	    }
	
	    console.log('start_date before', start_date);
	    start_date = start_date.toISOString();
	    console.log('start_date after', start_date);
	    end_date = end_date.toISOString();
	
	    _this6.setState({
	      is_loaded: false
	    });
	
	    _this6.updateRound(round_id, {
	      number: round_number,
	      type: 1,
	      start_date: start_date,
	      end_date: end_date,
	      game: game_id
	    }).then(function (res) {
	      _this6.fetchData();
	    }).catch(function (err) {
	      _this6.setState({
	        is_loaded: true
	      });
	
	      _this6.showError((0, _roundError.extractRoundErrorMessage)(err) || "Unable to update the round. Please try again.");
	    });
	  };
	
	  this.onAdd = function (round_number) {
	    var game_id = _this6.state.game_id;
	
	    var round = Object.assign({}, _this6.state.new_round);
	
	    if (round.start_date === null || round.end_date === null) {
	      _this6.showError("All fields required!");
	      return;
	    }
	
	    var start_date = round.start_date.utc();
	    var end_date = round.end_date.utc();
	
	    if (start_date.valueOf() < (0, _momentTimezone2.default)().utc().valueOf()) {
	      _this6.showError("Start time cannot be less than now!");
	      return;
	    }
	
	    if (end_date.valueOf() < (0, _momentTimezone2.default)().utc().valueOf()) {
	      _this6.showError("End time cannot be less than now!");
	      return;
	    }
	
	    start_date = start_date.toISOString();
	    end_date = end_date.toISOString();
	
	    _this6.setState({
	      is_loaded: false
	    });
	
	    _this6.createRound({
	      number: round_number,
	      type: 1,
	      start_date: start_date,
	      end_date: end_date,
	      game: game_id
	    }).then(function (res) {
	      _this6.initNewRound();
	      _this6.fetchData();
	    }).catch(function (err) {
	      _this6.setState({
	        is_loaded: true
	      });
	
	      _this6.showError((0, _roundError.extractRoundErrorMessage)(err) || "Unable to create the round. Please try again.");
	    });
	  };
	};
	
	exports.default = RoundManagement;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  background: #f5f6f7;\n  padding: 40px;\n  flex: 1;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  max-width: 900px;\n  margin: 0 auto;\n'], ['\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  max-width: 900px;\n  margin: 0 auto;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  padding: 20px 24px 0;\n  text-align: center;\n'], ['\n  padding: 20px 24px 0;\n  text-align: center;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 23px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 4px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 23px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 4px;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin: 0 0 16px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.6);\n  margin: 0 0 16px;\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  border: none;\n  border-top: 1px solid #D5D9DD;\n  margin: 0;\n'], ['\n  border: none;\n  border-top: 1px solid #D5D9DD;\n  margin: 0;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  padding: 16px 24px 24px;\n'], ['\n  padding: 16px 24px 24px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \'Mukta Vaani\';\n'], ['\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \'Mukta Vaani\';\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  th {\n    font-family: \'Mukta Vaani\';\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: left;\n    padding: 8px 2px 12px;\n  }\n'], ['\n  th {\n    font-family: \'Mukta Vaani\';\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    color: rgba(0, 27, 59, 0.94);\n    text-align: left;\n    padding: 8px 2px 12px;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  td {\n    padding: 8px 2px;\n    vertical-align: middle;\n  }\n'], ['\n  td {\n    padding: 8px 2px;\n    vertical-align: middle;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteral(['\n  padding-left: 2px !important;\n  padding-right: 2px !important;\n'], ['\n  padding-left: 2px !important;\n  padding-right: 2px !important;\n']),
	    _templateObject12 = _taggedTemplateLiteral(['\n  & + & {\n    td {\n      padding-top: 16px;\n    }\n  }\n'], ['\n  & + & {\n    td {\n      padding-top: 16px;\n    }\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #494e50;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #494e50;\n']),
	    _templateObject14 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 8px;\n  vertical-align: middle;\n  color: #494e50;\n  font-size: 14px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  i {\n    font-size: 14px;\n  }\n'], ['\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 8px;\n  vertical-align: middle;\n  color: #494e50;\n  font-size: 14px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n\n  i {\n    font-size: 14px;\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteral(['\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 8px;\n  vertical-align: middle;\n  color: #494e50;\n  font-size: 14px;\n\n  &:hover {\n    color: #d34c4c;\n  }\n\n  i {\n    font-size: 14px;\n  }\n'], ['\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 8px;\n  vertical-align: middle;\n  color: #494e50;\n  font-size: 14px;\n\n  &:hover {\n    color: #d34c4c;\n  }\n\n  i {\n    font-size: 14px;\n  }\n']),
	    _templateObject16 = _taggedTemplateLiteral(['\n  min-width: 220px;\n  max-width: 239px;\n'], ['\n  min-width: 220px;\n  max-width: 239px;\n']),
	    _templateObject17 = _taggedTemplateLiteral(['\n  background: #F5F6F7;\n  border-radius: 4px;\n  border: none;\n  padding: 6.5px 9.5px;\n  color: rgba(0, 27, 59, 0.38);\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  pointer-events: none;\n  min-width: 78px;\n  cursor: default;\n\n  ', '\n'], ['\n  background: #F5F6F7;\n  border-radius: 4px;\n  border: none;\n  padding: 6.5px 9.5px;\n  color: rgba(0, 27, 59, 0.38);\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  pointer-events: none;\n  min-width: 78px;\n  cursor: default;\n\n  ', '\n']),
	    _templateObject18 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > .loader {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n\n    .loader-inner div {\n      width: 15px;\n      height: 15px;\n      border-color: #fff !important;\n    }\n  }\n'], ['\n  width: 100%;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  > .loader {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n\n    .loader-inner div {\n      width: 15px;\n      height: 15px;\n      border-color: #fff !important;\n    }\n  }\n']),
	    _templateObject19 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n'], ['\n  position: relative;\n  display: inline-block;\n']),
	    _templateObject20 = _taggedTemplateLiteral(['\n  width: 88px;\n  height: 24px;\n  border-radius: 4px;\n  background: #E0E0E0;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #D5D9DD;\n  cursor: pointer;\n'], ['\n  width: 88px;\n  height: 24px;\n  border-radius: 4px;\n  background: #E0E0E0;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #D5D9DD;\n  cursor: pointer;\n']),
	    _templateObject21 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: #2DA548;\n  border-radius: ', ';\n  width: ', '%;\n  transition: width 0.3s ease;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: #2DA548;\n  border-radius: ', ';\n  width: ', '%;\n  transition: width 0.3s ease;\n']),
	    _templateObject22 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1;\n  color: #fff;\n  z-index: 1;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1;\n  color: #fff;\n  z-index: 1;\n']),
	    _templateObject23 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 12px 16px;\n  z-index: 100;\n  min-width: 220px;\n  max-height: 250px;\n  overflow-y: auto;\n\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: -6px;\n    right: 24px;\n    width: 10px;\n    height: 10px;\n    background: #ffffff;\n    border-left: 1px solid #D5D9DD;\n    border-top: 1px solid #D5D9DD;\n    transform: rotate(45deg);\n  }\n'], ['\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 12px 16px;\n  z-index: 100;\n  min-width: 220px;\n  max-height: 250px;\n  overflow-y: auto;\n\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: -6px;\n    right: 24px;\n    width: 10px;\n    height: 10px;\n    background: #ffffff;\n    border-left: 1px solid #D5D9DD;\n    border-top: 1px solid #D5D9DD;\n    transform: rotate(45deg);\n  }\n']),
	    _templateObject24 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 8px;\n  border-bottom: 1px solid #ECEDEF;\n  padding-bottom: 6px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 18px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 8px;\n  border-bottom: 1px solid #ECEDEF;\n  padding-bottom: 6px;\n']),
	    _templateObject25 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 22px;\n  color: rgba(0, 27, 59, 0.8);\n  margin: 0;\n']),
	    _templateObject26 = _taggedTemplateLiteral(['\n  padding: 40px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n'], ['\n  padding: 40px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n']),
	    _templateObject27 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #000000;\n  text-align: center;\n  margin: 0;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #000000;\n  text-align: center;\n  margin: 0;\n']),
	    _templateObject28 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid #3A507B;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #494e50;\n  cursor: pointer;\n  text-align: center;\n  min-width: 200px;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n'], ['\n  background: #ffffff;\n  border: 1px solid #3A507B;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #494e50;\n  cursor: pointer;\n  text-align: center;\n  min-width: 200px;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n']),
	    _templateObject29 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject30 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08), 0px 20px 32px 0px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 1137px;\n  max-height: 85vh;\n  overflow-y: auto;\n  padding: 40px 96px 40px;\n  position: relative;\n'], ['\n  background: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08), 0px 20px 32px 0px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 1137px;\n  max-height: 85vh;\n  overflow-y: auto;\n  padding: 40px 96px 40px;\n  position: relative;\n']),
	    _templateObject31 = _taggedTemplateLiteral(['\n  margin-bottom: 16px;\n'], ['\n  margin-bottom: 16px;\n']),
	    _templateObject32 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 24px;\n  color: #2A4169;\n  margin: 0 0 8px;\n  display: inline-block;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 24px;\n  color: #2A4169;\n  margin: 0 0 8px;\n  display: inline-block;\n']),
	    _templateObject33 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  margin-left: 16px;\n  display: inline-flex;\n  min-width: 400px;\n'], ['\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  margin-left: 16px;\n  display: inline-flex;\n  min-width: 400px;\n']),
	    _templateObject34 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 2px;\n  color: #2A4169;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 2px;\n  color: #2A4169;\n']),
	    _templateObject35 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2A4169;\n  margin: 12px 0 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2A4169;\n  margin: 12px 0 24px;\n']),
	    _templateObject36 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  text-decoration: underline;\n  margin: 24px 0 12px;\n\n  span {\n    font-weight: 400;\n    font-size: 16px;\n    text-decoration: none;\n  }\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  text-decoration: underline;\n  margin: 24px 0 12px;\n\n  span {\n    font-weight: 400;\n    font-size: 16px;\n    text-decoration: none;\n  }\n']),
	    _templateObject37 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n']),
	    _templateObject38 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n'], ['\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n']),
	    _templateObject39 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0;\n']),
	    _templateObject40 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 4px 8px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n'], ['\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: rgba(0, 27, 59, 0.6);\n  padding: 4px 8px;\n\n  &:hover {\n    color: rgba(0, 27, 59, 0.94);\n  }\n']),
	    _templateObject41 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08), 0px 20px 32px 0px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 460px;\n  padding: 28px 32px;\n'], ['\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08), 0px 20px 32px 0px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 460px;\n  padding: 28px 32px;\n']),
	    _templateObject42 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 30px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 12px;\n']),
	    _templateObject43 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 24px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  margin: 0 0 24px;\n']),
	    _templateObject44 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n']),
	    _templateObject45 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n'], ['\n  background: #ffffff;\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n  cursor: pointer;\n\n  &:hover {\n    background: #f5f6f7;\n  }\n']),
	    _templateObject46 = _taggedTemplateLiteral(['\n  background: #d34c4c;\n  border: 1px solid #d34c4c;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #b23e3e;\n    border-color: #b23e3e;\n  }\n\n  &:disabled {\n    background: #e5a3a3;\n    border-color: #e5a3a3;\n    cursor: default;\n  }\n'], ['\n  background: #d34c4c;\n  border: 1px solid #d34c4c;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-family: \'Mukta Vaani\';\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background: #b23e3e;\n    border-color: #b23e3e;\n  }\n\n  &:disabled {\n    background: #e5a3a3;\n    border-color: #e5a3a3;\n    cursor: default;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Surveys = __webpack_require__(56);
	
	var _onboardingRouting = __webpack_require__(183);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _reactDatetime = __webpack_require__(368);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _error = __webpack_require__(82);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _decisions = __webpack_require__(152);
	
	var _decisions2 = _interopRequireDefault(_decisions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Card = _styledComponents2.default.div(_templateObject2);
	
	var CardHeader = _styledComponents2.default.div(_templateObject3);
	
	var PageTitle = _styledComponents2.default.h1(_templateObject4);
	
	var PageSubtitle = _styledComponents2.default.p(_templateObject5);
	
	var Divider = _styledComponents2.default.hr(_templateObject6);
	
	var TableWrapper = _styledComponents2.default.div(_templateObject7);
	
	var Table = _styledComponents2.default.table(_templateObject8);
	
	var TableHead = _styledComponents2.default.thead(_templateObject9);
	
	var TableBody = _styledComponents2.default.tbody(_templateObject10);
	
	var UpdateCell = _styledComponents2.default.td(_templateObject11);
	
	var TableRow = _styledComponents2.default.tr(_templateObject12);
	
	var EvaluationName = _styledComponents2.default.span(_templateObject13);
	
	var EditIcon = _styledComponents2.default.button(_templateObject14);
	
	var DeleteIcon = _styledComponents2.default.button(_templateObject15);
	
	var DatePickerCell = _styledComponents2.default.div(_templateObject16);
	
	var UpdateButton = _styledComponents2.default.button(_templateObject17, function (p) {
	  return p.isActive && '\n    background: #2196F3;\n    color: #fff;\n    pointer-events: auto;\n    cursor: pointer;\n  ';
	});
	
	var ButtonLoader = _styledComponents2.default.div(_templateObject18);
	
	var CompletionCellWrapper = _styledComponents2.default.div(_templateObject19);
	
	var CompletionBarOuter = _styledComponents2.default.div(_templateObject20);
	
	var CompletionBarFill = _styledComponents2.default.div(_templateObject21, function (props) {
	  return props.percentage >= 100 ? '4px' : '4px 0 0 4px';
	}, function (props) {
	  return props.percentage;
	});
	
	var CompletionLabel = _styledComponents2.default.span(_templateObject22);
	
	var CompletionTooltip = _styledComponents2.default.div(_templateObject23);
	
	var TooltipTitle = _styledComponents2.default.p(_templateObject24);
	
	var TooltipStudentName = _styledComponents2.default.p(_templateObject25);
	
	var EmptyStateWrapper = _styledComponents2.default.div(_templateObject26);
	
	var EmptyStateDescription = _styledComponents2.default.p(_templateObject27);
	
	var AddEvaluationButton = _styledComponents2.default.button(_templateObject28);
	
	/* Modal Styled Components */
	
	var ModalOverlay = _styledComponents2.default.div(_templateObject29);
	
	var ModalContainer = _styledComponents2.default.div(_templateObject30);
	
	var ModalHeader = _styledComponents2.default.div(_templateObject31);
	
	var ModalTitle = _styledComponents2.default.h2(_templateObject32);
	
	var ModalNameInput = _styledComponents2.default.div(_templateObject33);
	
	var ModalNameText = _styledComponents2.default.span(_templateObject34);
	
	var ModalDescription = _styledComponents2.default.p(_templateObject35);
	
	var SectionTitle = _styledComponents2.default.h3(_templateObject36);
	
	var QuestionList = _styledComponents2.default.div(_templateObject37);
	
	var QuestionItem = _styledComponents2.default.div(_templateObject38);
	
	var QuestionText = _styledComponents2.default.p(_templateObject39);
	
	var CloseButton = _styledComponents2.default.button(_templateObject40);
	
	/* Delete-confirmation modal — smaller than the questions modal */
	
	var ConfirmModalContainer = _styledComponents2.default.div(_templateObject41);
	
	var ConfirmTitle = _styledComponents2.default.h2(_templateObject42);
	
	var ConfirmBody = _styledComponents2.default.p(_templateObject43);
	
	var ConfirmActions = _styledComponents2.default.div(_templateObject44);
	
	var CancelButton = _styledComponents2.default.button(_templateObject45);
	
	var ConfirmDeleteButton = _styledComponents2.default.button(_templateObject46);
	
	/* Question grouping helper */
	
	var SECTION_DEFS = [{
	  key: 'selfReflection',
	  label: 'Self-Reflection',
	  filter: function filter(q) {
	    return q.category === 'self_assessment';
	  }
	}, {
	  key: 'teammateRating',
	  label: 'Teammate Rating',
	  suffix: ' (1= Strongly Disagree, 5= Strongly Agree)',
	  filter: function filter(q) {
	    return q.category === 'collaboration' && q.answer_type === 'rating';
	  }
	}, {
	  key: 'teammateReflections',
	  label: 'Teammate Reflections',
	  filter: function filter(q) {
	    return q.answer_type === 'freeform' && q.category !== 'self_assessment';
	  }
	}];
	
	var PART_LABELS = ['I', 'II', 'III', 'IV'];
	
	function groupQuestions(questions) {
	  if (!questions || questions.length === 0) return [];
	
	  var usedIds = new Set();
	  var sections = [];
	
	  SECTION_DEFS.forEach(function (def) {
	    var matched = questions.filter(function (q) {
	      if (usedIds.has(q.id)) return false;
	      return def.filter(q);
	    }).sort(function (a, b) {
	      return a.id - b.id;
	    });
	
	    matched.forEach(function (q) {
	      return usedIds.add(q.id);
	    });
	
	    if (matched.length > 0) {
	      sections.push({
	        key: def.key,
	        label: def.label,
	        suffix: def.suffix || '',
	        questions: matched
	      });
	    }
	  });
	
	  return sections;
	}
	
	var InstructorTeamEvaluation = function (_PureComponent) {
	  _inherits(InstructorTeamEvaluation, _PureComponent);
	
	  function InstructorTeamEvaluation(props) {
	    _classCallCheck(this, InstructorTeamEvaluation);
	
	    var _this = _possibleConstructorReturn(this, (InstructorTeamEvaluation.__proto__ || Object.getPrototypeOf(InstructorTeamEvaluation)).call(this, props));
	
	    _this.fetchData = function () {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      (0, _ApiService.getRequest)(apiUrl + 'v2/forms/surveys/?course=' + _Auth2.default.getCourseId()).then(function (res) {
	        var surveys = res.body.results || res.body;
	
	        // Stage-first ordering: Initial peer eval always appears above
	        // Final. Anything else (unknown stage) sorts last but keeps
	        // relative order stable via index tiebreak.
	        var stageOrder = { initial: 0, final: 1 };
	        var withIndex = (Array.isArray(surveys) ? surveys : []).map(function (s, i) {
	          return { s: s, i: i };
	        });
	        var ordered = withIndex.sort(function (a, b) {
	          var aStage = String(a.s && a.s.stage || '').toLowerCase();
	          var bStage = String(b.s && b.s.stage || '').toLowerCase();
	          var ao = stageOrder[aStage] != null ? stageOrder[aStage] : 2;
	          var bo = stageOrder[bStage] != null ? stageOrder[bStage] : 2;
	          if (ao !== bo) return ao - bo;
	          return a.i - b.i;
	        }).map(function (x) {
	          return x.s;
	        });
	        _this.setState({
	          loaded: true,
	          surveys: ordered
	        });
	
	        _this.fetchCompletionData(ordered);
	      }).catch(function (err) {
	        _this.setState({ loaded: true, surveys: [] });
	      });
	    };
	
	    _this.fetchCompletionData = function (surveys) {
	      var apiUrl = ("https://be-production-itb.marketgames.io/api/");
	
	      var surveyList = surveys || _this.state.surveys || [];
	      var peerScoreUrls = surveyList.map(function (s) {
	        return apiUrl + 'v2/games/peer-score/' + s.id + '/';
	      });
	
	      (0, _ApiService.batchRequest)([apiUrl + 'course_members/?type=1'].concat(_toConsumableArray(peerScoreUrls))).then(function (responses) {
	        var membersRes = responses[0];
	        var membersData = membersRes && membersRes.body && (membersRes.body.results || membersRes.body) || [];
	        var courseMembers = Array.isArray(membersData) ? membersData : [];
	        var totalStudents = courseMembers.length;
	
	        var completedUsersBySurvey = {};
	        surveyList.forEach(function (survey, i) {
	          var res = responses[1 + i];
	          var body = res && res.body || {};
	          var rows = Array.isArray(body) ? body : body.results || [];
	          var set = new Set();
	          rows.forEach(function (row) {
	            if (row && row.completion === true) {
	              var uid = row.user_id != null ? row.user_id : row.user;
	              if (uid != null) set.add(uid);
	            }
	          });
	          completedUsersBySurvey[survey.id] = set;
	        });
	
	        _this.setState({
	          totalStudents: totalStudents,
	          completedUsersBySurvey: completedUsersBySurvey,
	          courseMembers: courseMembers
	        });
	      }).catch(function (err) {});
	    };
	
	    _this.getIncompleteStudentNames = function (surveyId) {
	      var _this$state = _this.state,
	          completedUsersBySurvey = _this$state.completedUsersBySurvey,
	          courseMembers = _this$state.courseMembers;
	
	      var completedIds = completedUsersBySurvey[surveyId] || new Set();
	
	      return courseMembers.filter(function (member) {
	        var memberId = member.user_id || member.user || member.id;
	        return !completedIds.has(memberId);
	      }).map(function (member) {
	        return ((member.first_name || '') + ' ' + (member.last_name || '')).trim();
	      }).filter(function (name) {
	        return name.length > 0;
	      });
	    };
	
	    _this.onDateChange = function (datetime, surveyId, field) {
	      if (typeof datetime === "string") {
	        return;
	      }
	
	      var _this$state2 = _this.state,
	          changedSurveys = _this$state2.changedSurveys,
	          changedFieldsBySurvey = _this$state2.changedFieldsBySurvey;
	
	
	      var surveys = [].concat(_toConsumableArray(_this.state.surveys));
	      var index = surveys.findIndex(function (s) {
	        return s.id === surveyId;
	      });
	
	      if (index >= 0) {
	        surveys[index] = Object.assign({}, surveys[index], _defineProperty({}, field, datetime));
	
	        var newChangedSurveys = [].concat(_toConsumableArray(changedSurveys));
	        if (!newChangedSurveys.includes(surveyId)) {
	          newChangedSurveys.push(surveyId);
	        }
	
	        var existingFields = changedFieldsBySurvey[surveyId] || {};
	        var newChangedFields = Object.assign({}, changedFieldsBySurvey, _defineProperty({}, surveyId, Object.assign({}, existingFields, _defineProperty({}, field, true))));
	
	        _this.setState({
	          surveys: surveys,
	          changedSurveys: newChangedSurveys,
	          changedFieldsBySurvey: newChangedFields
	        });
	      }
	    };
	
	    _this.onUpdate = function (surveyId) {
	      var _this$state3 = _this.state,
	          surveys = _this$state3.surveys,
	          changedFieldsBySurvey = _this$state3.changedFieldsBySurvey;
	
	
	      var survey = surveys.find(function (s) {
	        return s.id === surveyId;
	      });
	      if (!survey) return;
	
	      var surveyChangedFields = changedFieldsBySurvey[surveyId] || {};
	      var startDate = _moment2.default.isMoment(survey.start) ? survey.start : (0, _moment2.default)(survey.start);
	      var endDate = _moment2.default.isMoment(survey.end) ? survey.end : (0, _moment2.default)(survey.end);
	      var currentDateTime = (0, _moment2.default)();
	
	      if (endDate.isBefore(startDate)) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | Start Time > End Time',
	          errorMessage: 'The start date/time cannot be greater than the end date/time.'
	        });
	        return;
	      }
	
	      if (surveyChangedFields.start && startDate.isBefore(currentDateTime)) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | In the Past',
	          errorMessage: 'The start date/time cannot be set in the past.'
	        });
	        return;
	      }
	
	      if (surveyChangedFields.end && endDate.isBefore(currentDateTime)) {
	        _this.setState({
	          showError: true,
	          errorTitle: 'Error | In the Past',
	          errorMessage: 'The end date/time cannot be set in the past.'
	        });
	        return;
	      }
	
	      _this.setState({ loadingButtonSurvey: surveyId });
	
	      var changedSurveys = _this.state.changedSurveys;
	
	
	      (0, _ApiService.putRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + surveyId + '/modify/').send({
	        start: startDate.toISOString(),
	        end: endDate.toISOString()
	      }).then(function (res) {
	        var updatedChangedFields = Object.assign({}, _this.state.changedFieldsBySurvey);
	        delete updatedChangedFields[surveyId];
	
	        _this.setState({
	          loadingButtonSurvey: 0,
	          changedSurveys: changedSurveys.filter(function (id) {
	            return id !== surveyId;
	          }),
	          changedFieldsBySurvey: updatedChangedFields,
	          showSuccess: true,
	          successfullyChangedSurveyName: survey.name || 'Evaluation'
	        });
	      }).catch(function (err) {
	        _this.setState({ loadingButtonSurvey: 0 });
	
	        if (err.response && err.response.status === 400 && err.response.body && "non_field_errors" in err.response.body && err.response.body["non_field_errors"].length > 0) {
	          _this.setState({
	            showError: true,
	            errorTitle: 'Error | Server Error',
	            errorMessage: err.response.body["non_field_errors"][0]
	          });
	        }
	      });
	    };
	
	    _this.hideSuccessAlert = function () {
	      _this.setState({ showSuccess: false });
	    };
	
	    _this.hideErrorAlert = function () {
	      _this.setState({ showError: false });
	    };
	
	    _this.getCompletionCounts = function (survey) {
	      var _this$state4 = _this.state,
	          totalStudents = _this$state4.totalStudents,
	          completedUsersBySurvey = _this$state4.completedUsersBySurvey;
	
	      var set = completedUsersBySurvey[survey.id];
	      var completed = set ? set.size : 0;
	      // Cap at totalStudents so the bar can't visually exceed the
	      // denominator if peer-score ever returns extra rows.
	      return { completed: Math.min(completed, totalStudents), total: totalStudents };
	    };
	
	    _this.openModal = function (survey) {
	      _this.setState({ modalSurvey: survey });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({ modalSurvey: null });
	    };
	
	    _this.openDeleteConfirmation = function (survey) {
	      _this.setState({ deleteTargetSurvey: survey });
	    };
	
	    _this.closeDeleteConfirmation = function () {
	      if (_this.state.isDeleting) return;
	      _this.setState({ deleteTargetSurvey: null });
	    };
	
	    _this.confirmDelete = function () {
	      var _this$state5 = _this.state,
	          deleteTargetSurvey = _this$state5.deleteTargetSurvey,
	          surveys = _this$state5.surveys;
	
	      if (!deleteTargetSurvey) return;
	
	      var surveyId = deleteTargetSurvey.id;
	      _this.setState({ isDeleting: true });
	
	      (0, _ApiService.deleteRequest)(("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/' + surveyId + '/').then(function () {
	        // Invalidate the onboarding gate's positive hasSurvey cache —
	        // otherwise the gate would keep skipping the survey step even
	        // though this instructor may have just deleted their only one.
	        (0, _onboardingRouting.clearOnboardingSetupCache)();
	        _this.setState({
	          surveys: surveys.filter(function (s) {
	            return s.id !== surveyId;
	          }),
	          deleteTargetSurvey: null,
	          isDeleting: false
	        });
	      }).catch(function (err) {
	        _this.setState({
	          isDeleting: false,
	          deleteTargetSurvey: null,
	          showError: true,
	          errorTitle: 'Error | Delete Failed',
	          errorMessage: 'The evaluation could not be deleted. Please try again.'
	        });
	      });
	    };
	
	    _this.renderDeleteConfirmation = function () {
	      var _this$state6 = _this.state,
	          deleteTargetSurvey = _this$state6.deleteTargetSurvey,
	          isDeleting = _this$state6.isDeleting;
	
	      if (!deleteTargetSurvey) return null;
	
	      var name = deleteTargetSurvey.name || 'this evaluation';
	
	      return _react2.default.createElement(
	        ModalOverlay,
	        { onClick: _this.closeDeleteConfirmation },
	        _react2.default.createElement(
	          ConfirmModalContainer,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            ConfirmTitle,
	            null,
	            'Delete evaluation?'
	          ),
	          _react2.default.createElement(
	            ConfirmBody,
	            null,
	            'Are you sure you want to delete ',
	            _react2.default.createElement(
	              'b',
	              null,
	              name
	            ),
	            '? This cannot be undone.'
	          ),
	          _react2.default.createElement(
	            ConfirmActions,
	            null,
	            _react2.default.createElement(
	              CancelButton,
	              { onClick: _this.closeDeleteConfirmation, disabled: isDeleting },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              ConfirmDeleteButton,
	              { onClick: _this.confirmDelete, disabled: isDeleting },
	              isDeleting ? 'Deleting...' : 'Delete'
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderModal = function () {
	      var modalSurvey = _this.state.modalSurvey;
	
	      if (!modalSurvey) return null;
	
	      var sections = groupQuestions(modalSurvey.questions);
	
	      return _react2.default.createElement(
	        ModalOverlay,
	        { onClick: _this.closeModal },
	        _react2.default.createElement(
	          ModalContainer,
	          { onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            CloseButton,
	            { onClick: _this.closeModal },
	            '\xD7'
	          ),
	          _react2.default.createElement(
	            ModalHeader,
	            null,
	            _react2.default.createElement(
	              ModalTitle,
	              null,
	              'Name'
	            ),
	            _react2.default.createElement(
	              ModalNameInput,
	              null,
	              _react2.default.createElement(
	                ModalNameText,
	                null,
	                modalSurvey.name
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ModalDescription,
	            null,
	            'This peer evaluation requires students to complete a self-reflection, rate each teammate, and provide constructive feedback for each team member.'
	          ),
	          function () {
	            var runningIndex = 0;
	            return sections.map(function (section, idx) {
	              return _react2.default.createElement(
	                'div',
	                { key: section.key },
	                _react2.default.createElement(
	                  SectionTitle,
	                  null,
	                  'Part ',
	                  PART_LABELS[idx],
	                  ' | ',
	                  section.label,
	                  section.suffix && _react2.default.createElement(
	                    'span',
	                    null,
	                    section.suffix
	                  )
	                ),
	                _react2.default.createElement(
	                  QuestionList,
	                  null,
	                  section.questions.map(function (question) {
	                    runningIndex++;
	                    return _react2.default.createElement(
	                      QuestionItem,
	                      { key: question.id },
	                      _react2.default.createElement(
	                        QuestionText,
	                        null,
	                        runningIndex,
	                        '. ',
	                        question.text.replace(/<Insert User FirstName>/gi, 'this teammate').replace(/<insert user firstname>/gi, 'this teammate')
	                      )
	                    );
	                  })
	                )
	              );
	            });
	          }(),
	          sections.length === 0 && _react2.default.createElement(
	            ModalDescription,
	            null,
	            'No questions configured for this evaluation.'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      loaded: false,
	      surveys: [],
	      totalStudents: 0,
	      // Per-survey set of user ids whose peer-score row has
	      // completion === true. Populated from /v2/games/peer-score/
	      // on page load (one call per survey). The bar uses .size,
	      // the hover popup uses set membership.
	      completedUsersBySurvey: {},
	      courseMembers: [],
	      modalSurvey: null,
	      changedSurveys: [],
	      changedFieldsBySurvey: {},
	      loadingButtonSurvey: 0,
	      showSuccess: false,
	      successfullyChangedSurveyName: '',
	      showError: false,
	      errorTitle: '',
	      errorMessage: '',
	      hoveredSurveyId: null,
	      deleteTargetSurvey: null,
	      isDeleting: false
	    };
	    return _this;
	  }
	
	  _createClass(InstructorTeamEvaluation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	
	    // Completion data now comes from /v2/games/peer-score/<survey_id>/.
	    // A "completed" student = one row on that endpoint whose
	    // `completion === true`. The course-members list is the ground
	    // truth for how many students exist, and the bar count is capped
	    // at that total so it can't exceed it. The hover popup is just
	    // the set difference of (course members − completed user ids).
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          surveys = _state.surveys,
	          changedSurveys = _state.changedSurveys,
	          loadingButtonSurvey = _state.loadingButtonSurvey,
	          showSuccess = _state.showSuccess,
	          successfullyChangedSurveyName = _state.successfullyChangedSurveyName,
	          showError = _state.showError,
	          errorTitle = _state.errorTitle,
	          errorMessage = _state.errorMessage,
	          hoveredSurveyId = _state.hoveredSurveyId;
	
	
	      if (!loaded) {
	        return _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	        );
	      }
	
	      var isIAS = _Auth2.default.isAssistantOrCoInstructor();
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        showError && _react2.default.createElement(_error2.default, {
	          title: errorTitle,
	          message: errorMessage,
	          onHide: this.hideErrorAlert
	        }),
	        showSuccess && _react2.default.createElement(_decisions2.default, {
	          type: 'success',
	          title: 'Success!',
	          message: successfullyChangedSurveyName + ' has been successfully updated!',
	          onHide: this.hideSuccessAlert
	        }),
	        _react2.default.createElement(
	          Card,
	          null,
	          _react2.default.createElement(
	            CardHeader,
	            null,
	            _react2.default.createElement(
	              PageTitle,
	              null,
	              'Team Evaluation'
	            ),
	            _react2.default.createElement(
	              PageSubtitle,
	              null,
	              'Review the questions, monitor completions, assess results'
	            )
	          ),
	          _react2.default.createElement(Divider, null),
	          surveys.length > 0 ? _react2.default.createElement(
	            TableWrapper,
	            null,
	            _react2.default.createElement(
	              Table,
	              null,
	              _react2.default.createElement(
	                TableHead,
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Evaluation'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Start'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'End'
	                  ),
	                  _react2.default.createElement('th', { style: { width: '1px', padding: '8px 2px 12px' } }),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { textAlign: 'center' } },
	                    'Completion %'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                TableBody,
	                null,
	                surveys.map(function (survey, index) {
	                  var _getCompletionCounts = _this2.getCompletionCounts(survey),
	                      completed = _getCompletionCounts.completed,
	                      total = _getCompletionCounts.total;
	
	                  var isChanged = changedSurveys.includes(survey.id);
	                  var isLoading = loadingButtonSurvey === survey.id;
	                  var updateButtonText = isChanged ? 'Update' : 'Updated';
	                  var incompleteNames = hoveredSurveyId === survey.id ? _this2.getIncompleteStudentNames(survey.id) : [];
	
	                  return _react2.default.createElement(
	                    TableRow,
	                    { key: survey.id, className: survey.start || survey.end ? 'with-highlighted-time' : '' },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        EvaluationName,
	                        null,
	                        survey.name || 'Team Evaluation ' + (index + 1)
	                      ),
	                      !isIAS && _react2.default.createElement(
	                        EditIcon,
	                        { title: 'Edit evaluation', onClick: function onClick() {
	                            return _this2.openModal(survey);
	                          } },
	                        _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                      ),
	                      !isIAS && _react2.default.createElement(
	                        DeleteIcon,
	                        { title: 'Delete evaluation', onClick: function onClick() {
	                            return _this2.openDeleteConfirmation(survey);
	                          } },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        DatePickerCell,
	                        null,
	                        _react2.default.createElement(_reactDatetime2.default, {
	                          dateFormat: 'ddd, MMM DD YYYY,',
	                          timeFormat: 'hh:mm a',
	                          inputProps: {
	                            placeholder: "Select Date & Time",
	                            className: "instructor-round-datetime-selector",
	                            disabled: isIAS,
	                            readOnly: isIAS
	                          },
	                          value: survey.start ? (0, _moment2.default)(survey.start) : '',
	                          onChange: function onChange(dt) {
	                            return isIAS ? null : _this2.onDateChange(dt, survey.id, 'start');
	                          }
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        DatePickerCell,
	                        null,
	                        _react2.default.createElement(_reactDatetime2.default, {
	                          dateFormat: 'ddd, MMM DD YYYY,',
	                          timeFormat: 'hh:mm a',
	                          inputProps: {
	                            placeholder: "Select Date & Time",
	                            className: "instructor-round-datetime-selector",
	                            disabled: isIAS,
	                            readOnly: isIAS
	                          },
	                          value: survey.end ? (0, _moment2.default)(survey.end) : '',
	                          onChange: function onChange(dt) {
	                            return isIAS ? null : _this2.onDateChange(dt, survey.id, 'end');
	                          }
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      UpdateCell,
	                      null,
	                      _react2.default.createElement(
	                        UpdateButton,
	                        {
	                          isActive: !isIAS && isChanged,
	                          onClick: function onClick() {
	                            return isIAS ? null : _this2.onUpdate(survey.id);
	                          }
	                        },
	                        isLoading ? _react2.default.createElement(
	                          ButtonLoader,
	                          null,
	                          _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	                        ) : _react2.default.createElement(
	                          'span',
	                          null,
	                          updateButtonText
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      _react2.default.createElement(
	                        CompletionCellWrapper,
	                        {
	                          onMouseEnter: function onMouseEnter() {
	                            return _this2.setState({ hoveredSurveyId: survey.id });
	                          },
	                          onMouseLeave: function onMouseLeave() {
	                            return _this2.setState({ hoveredSurveyId: null });
	                          }
	                        },
	                        _react2.default.createElement(
	                          CompletionBarOuter,
	                          null,
	                          _react2.default.createElement(CompletionBarFill, { percentage: total > 0 ? completed / total * 100 : 0 }),
	                          _react2.default.createElement(
	                            CompletionLabel,
	                            null,
	                            completed,
	                            '/',
	                            total
	                          )
	                        ),
	                        hoveredSurveyId === survey.id && incompleteNames.length > 0 && _react2.default.createElement(
	                          CompletionTooltip,
	                          null,
	                          _react2.default.createElement(
	                            TooltipTitle,
	                            null,
	                            'Not Yet Completed'
	                          ),
	                          incompleteNames.map(function (name, i) {
	                            return _react2.default.createElement(
	                              TooltipStudentName,
	                              { key: i },
	                              i + 1,
	                              '. ',
	                              name
	                            );
	                          })
	                        )
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            EmptyStateWrapper,
	            null,
	            _react2.default.createElement(
	              EmptyStateDescription,
	              null,
	              'A simple way for students to reflect and share feedback with what\'s working well on teams and what could be improved.'
	            ),
	            !isIAS && _react2.default.createElement(
	              AddEvaluationButton,
	              null,
	              'Add a Team Evaluation'
	            )
	          )
	        ),
	        this.renderModal(),
	        this.renderDeleteConfirmation()
	      );
	    }
	  }]);
	
	  return InstructorTeamEvaluation;
	}(_react.PureComponent);
	
	exports.default = InstructorTeamEvaluation;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _teamEdit = __webpack_require__(1515);
	
	var _teamEdit2 = _interopRequireDefault(_teamEdit);
	
	var _teamNew = __webpack_require__(1516);
	
	var _teamNew2 = _interopRequireDefault(_teamNew);
	
	var _ApiService = __webpack_require__(4);
	
	var _Teams = __webpack_require__(10);
	
	var _lodash = __webpack_require__(21);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STUDENT_ROLE = 1;
	
	var TeamManagement = function (_PureComponent) {
	  _inherits(TeamManagement, _PureComponent);
	
	  function TeamManagement(props) {
	    _classCallCheck(this, TeamManagement);
	
	    var _this = _possibleConstructorReturn(this, (TeamManagement.__proto__ || Object.getPrototypeOf(TeamManagement)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var location = props.location;
	
	    var pathes = location.pathname.split("/").filter(function (i) {
	      return i !== "";
	    });
	    var game_id = parseInt(pathes[2], 10);
	    if (isNaN(game_id)) {
	      game_id = 0;
	    }
	
	    _this.state = {
	      game_id: game_id,
	      course_id: 0,
	      is_loaded: false,
	      players: [],
	      teams: [],
	      free_users: [],
	      showSuccessMessage: false
	    };
	    return _this;
	  }
	
	  _createClass(TeamManagement, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fetchGame();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          is_loaded = _state.is_loaded,
	          players = _state.players,
	          teams = _state.teams,
	          free_users = _state.free_users,
	          game_id = _state.game_id,
	          showSuccessMessage = _state.showSuccessMessage;
	
	
	      return _react2.default.createElement(
	        "section",
	        { className: "instructorPage" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Team Management"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "instructorWrapper" },
	          showSuccessMessage === true && _react2.default.createElement(
	            "div",
	            { className: "row", style: { margin: 0 } },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12", style: { padding: 0 } },
	              _react2.default.createElement(
	                "div",
	                { className: "alert alert-success" },
	                "Updated successfully!"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "table-responsive" },
	            _react2.default.createElement(
	              "table",
	              { className: "table" },
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "No."
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Name"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Team"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    { className: "text-center instructor-table-th" },
	                    "Role"
	                  ),
	                  _react2.default.createElement("th", { className: "text-center instructor-table-th" })
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                is_loaded === false && _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    {
	                      colSpan: 5,
	                      className: "text-center v-align-middle instructor-td"
	                    },
	                    "Loading..."
	                  )
	                ),
	                _react2.default.createElement(_teamNew2.default, {
	                  teams: teams,
	                  counter: 1,
	                  free_users: free_users,
	                  fetchData: this.fetchGame,
	                  game_id: game_id
	                }),
	                is_loaded === true && players.map(function (player, index) {
	                  return _react2.default.createElement(_teamEdit2.default, {
	                    key: index,
	                    player: player,
	                    counter: index + 2,
	                    teams: teams,
	                    fetchData: _this2.fetchData,
	                    game_id: game_id,
	                    updatedSuccessfully: _this2.updatedSuccessfully
	                  });
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TeamManagement;
	}(_react.PureComponent);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.fetchData = function () {
	    var course_id = _this3.state.course_id;
	
	    var requests = [];
	    requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "courses/" + course_id + "/members/"));
	    requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "team/players/"));
	    requests.push((0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "users/"));
	    requests.push((0, _ApiService.getRequest)((0, _Teams.teamsEndpoint)()));
	    var joinRequest = Promise.all(requests);
	
	    joinRequest.then(function (res) {
	      var course_members = res[0].body.filter(function (i) {
	        return i.type === STUDENT_ROLE;
	      }).map(function (i) {
	        return i.user;
	      });
	      var players = _lodash2.default.orderBy(res[1].body.filter(function (i) {
	        return i.user && course_members.includes(i.user.id);
	      }), function (player) {
	        return player.user.username.toLowerCase();
	      }, ["asc"]);
	      var team_users = players.map(function (i) {
	        return i.user.id;
	      });
	      var free_users = course_members.filter(function (i) {
	        return !team_users.includes(i);
	      });
	      var users = res[2].body.filter(function (i) {
	        return free_users.includes(i.id);
	      });
	      var teams = res[3].body.filter(function (i) {
	        return i.course === course_id;
	      });
	
	      _this3.setState({
	        players: players,
	        free_users: users,
	        teams: teams,
	        is_loaded: true
	      });
	    }).catch(function (err) {});
	  };
	
	  this.fetchGame = function () {
	    var game_id = _this3.state.game_id;
	
	
	    (0, _ApiService.getRequest)(("https://be-production-itb.marketgames.io/api/") + "games/" + game_id + "/").then(function (res) {
	      var course = res.body.course;
	
	
	      _this3.setState({
	        course_id: course
	      }, function () {
	        _this3.fetchData();
	      });
	    }).catch(function (err) {});
	  };
	
	  this.updatedSuccessfully = function () {
	    _this3.setState({
	      showSuccessMessage: true
	    }, function () {
	      setTimeout(function () {
	        _this3.setState({
	          showSuccessMessage: false
	        });
	      }, 5000);
	    });
	  };
	};
	
	exports.default = TeamManagement;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 40px 40px 50px;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n'], ['\n  width: 100%;\n  padding: 40px 40px 50px;\n\n  .loader {\n    display: inline-block;\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n\n  .loader .loader-inner div {\n    border-color: #36507e;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  margin-top: 20px;\n'], ['\n  border: 1px solid #D5D9DD;\n  border-radius: 4px;\n  margin-top: 20px;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  font-family: \'Mukta Vaani\';\n'], ['\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  font-family: \'Mukta Vaani\';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactLoaders = __webpack_require__(9);
	
	var _ApiService = __webpack_require__(4);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _AppGeneralInfoService = __webpack_require__(93);
	
	var _Teams = __webpack_require__(10);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _table = __webpack_require__(1519);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _search = __webpack_require__(1518);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _pagination = __webpack_require__(1517);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _constants = __webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-loop-func */
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var TableWrapper = _styledComponents2.default.div(_templateObject2);
	
	var PageTitle = _styledComponents2.default.h1(_templateObject3);
	
	var TeamsRoles = function (_PureComponent) {
	  _inherits(TeamsRoles, _PureComponent);
	
	  function TeamsRoles(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, TeamsRoles);
	
	    var _this = _possibleConstructorReturn(this, (TeamsRoles.__proto__ || Object.getPrototypeOf(TeamsRoles)).call(this, props));
	
	    _this.fetchTeamPlayers = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$state, query, rowsPerPage, page, teamPlayersAPIUrl;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$state = _this.state, query = _this$state.query, rowsPerPage = _this$state.rowsPerPage, page = _this$state.page;
	              teamPlayersAPIUrl = ("https://be-production-itb.marketgames.io/api/") + 'v2/games/teamplayers/?page_size=' + rowsPerPage + '&page=' + page + '&game=' + _Auth2.default.getGameId();
	
	
	              if (query !== '') {
	                teamPlayersAPIUrl += '&search=' + query;
	              }
	
	              (0, _ApiService.getRequest)(teamPlayersAPIUrl).then(function (res) {
	                var teamPlayers = res.body.results;
	
	                var rowsTotal = res.body.count;
	                var activePrevPage = res.body.previous;
	                var activeNextPage = res.body.next;
	
	                _this.setState({
	                  loaded: true,
	                  teamPlayers: teamPlayers,
	                  rowsTotal: rowsTotal,
	                  activePrevPage: activePrevPage,
	                  activeNextPage: activeNextPage
	                });
	              }).catch(function (err) {});
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.fetchData = function () {
	      _this.setState({
	        loaded: false
	      });
	
	      (0, _ApiService.batchRequest)([(0, _Teams.teamsEndpoint)(), ("https://be-production-itb.marketgames.io/api/") + 'v2/games/coursemembers/', ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/surveys/?course=' + _Auth2.default.getCourseId()]).then(function (res) {
	        var availableTeams = res[0].body.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        }).reduce(function (a, v) {
	          return Object.assign({}, a, _defineProperty({}, ' ' + v.id, v.name));
	        }, {});
	
	        var courseMembers = res[1].body.results;
	
	        var surveys = res[2].body.results;
	
	        if (surveys && surveys.length > 0) {
	          var surveysUrls = surveys.map(function (survey) {
	            return ("https://be-production-itb.marketgames.io/api/") + 'v2/forms/feedbacks/?survey=' + survey.id;
	          });
	          (0, _ApiService.batchRequest)(surveysUrls).then(function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(res) {
	              var surveysFeedbacks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, index, response, nextPageAvailable, _surveysFeedbacks$ind, newSurveysFeedbacks;
	
	              return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                  switch (_context2.prev = _context2.next) {
	                    case 0:
	                      surveysFeedbacks = [];
	                      _iteratorNormalCompletion = true;
	                      _didIteratorError = false;
	                      _iteratorError = undefined;
	                      _context2.prev = 4;
	                      _iterator = res.entries()[Symbol.iterator]();
	
	                    case 6:
	                      if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                        _context2.next = 21;
	                        break;
	                      }
	
	                      _ref3 = _step.value;
	                      _ref4 = _slicedToArray(_ref3, 2);
	                      index = _ref4[0];
	                      response = _ref4[1];
	
	                      surveysFeedbacks[index] = response.body.results;
	                      nextPageAvailable = response.body.next;
	
	                      if (!nextPageAvailable) {
	                        _context2.next = 18;
	                        break;
	                      }
	
	                      _context2.next = 16;
	                      return _this.fetchFormsFeedbackPages(nextPageAvailable);
	
	                    case 16:
	                      newSurveysFeedbacks = _context2.sent;
	
	                      (_surveysFeedbacks$ind = surveysFeedbacks[index]).push.apply(_surveysFeedbacks$ind, _toConsumableArray(newSurveysFeedbacks));
	
	                    case 18:
	                      _iteratorNormalCompletion = true;
	                      _context2.next = 6;
	                      break;
	
	                    case 21:
	                      _context2.next = 27;
	                      break;
	
	                    case 23:
	                      _context2.prev = 23;
	                      _context2.t0 = _context2['catch'](4);
	                      _didIteratorError = true;
	                      _iteratorError = _context2.t0;
	
	                    case 27:
	                      _context2.prev = 27;
	                      _context2.prev = 28;
	
	                      if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                      }
	
	                    case 30:
	                      _context2.prev = 30;
	
	                      if (!_didIteratorError) {
	                        _context2.next = 33;
	                        break;
	                      }
	
	                      throw _iteratorError;
	
	                    case 33:
	                      return _context2.finish(30);
	
	                    case 34:
	                      return _context2.finish(27);
	
	                    case 35:
	
	                      _this.setState({
	                        loaded: true,
	                        courseMembers: courseMembers,
	                        availableTeams: availableTeams,
	                        surveys: surveys,
	                        surveysFeedbacks: surveysFeedbacks
	                      });
	
	                    case 36:
	                    case 'end':
	                      return _context2.stop();
	                  }
	                }
	              }, _callee2, _this2, [[4, 23, 27, 35], [28,, 30, 34]]);
	            }));
	
	            return function (_x) {
	              return _ref2.apply(this, arguments);
	            };
	          }()).catch(function (err) {});
	        } else {
	          _this.setState({
	            loaded: true,
	            courseMembers: courseMembers,
	            surveys: surveys,
	            availableTeams: availableTeams
	          });
	        }
	      }).catch(function (err) {});
	    };
	
	    _this.fetchFormsFeedbackPages = function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(nextPage) {
	        var nextPageAvailable, surveysFeedbacks, nextPageUrl;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                nextPageAvailable = true;
	                surveysFeedbacks = [];
	                nextPageUrl = nextPage;
	
	              case 3:
	                if (!nextPageAvailable) {
	                  _context3.next = 9;
	                  break;
	                }
	
	                nextPageAvailable = false;
	                _context3.next = 7;
	                return (0, _ApiService.getRequest)(nextPageUrl).then(function (res) {
	                  nextPageUrl = res.body.next;
	                  nextPageAvailable = res.body.next;
	                  surveysFeedbacks.push.apply(surveysFeedbacks, _toConsumableArray(res.body.results));
	                }).catch(function (err) {});
	
	              case 7:
	                _context3.next = 3;
	                break;
	
	              case 9:
	                return _context3.abrupt('return', surveysFeedbacks);
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    _this.changeTeamPlayers = function (teamPlayers) {
	      _this.setState({
	        teamPlayers: teamPlayers
	      });
	    };
	
	    _this.handleQueryChange = function (query) {
	      _this.setState({
	        query: query,
	        page: 1,
	        loaded: false
	      }, function () {
	        _this.fetchTeamPlayers();
	      });
	    };
	
	    _this.handleRowsPerPageChange = function (rowsPerPage) {
	      _this.setState({
	        rowsPerPage: rowsPerPage,
	        page: 1,
	        loaded: false
	      }, function () {
	        _this.fetchTeamPlayers();
	      });
	    };
	
	    _this.handlePageChange = function (page) {
	      _this.setState({
	        page: page,
	        loaded: false
	      }, function () {
	        _this.fetchTeamPlayers();
	      });
	    };
	
	    _this.state = {
	      loaded: false,
	      teamPlayers: [],
	      courseMembers: [],
	      teams: [],
	      surveys: [],
	      surveysFeedbacks: [],
	      query: '',
	      rowsPerPage: Object.values(_constants.teamPlayerRowsPerPage)[0],
	      page: 1,
	      activePrevPage: null,
	      activeNextPage: null
	    };
	    return _this;
	  }
	
	  _createClass(TeamsRoles, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	      this.fetchTeamPlayers();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          loaded = _state.loaded,
	          teamPlayers = _state.teamPlayers,
	          courseMembers = _state.courseMembers,
	          availableTeams = _state.availableTeams,
	          surveys = _state.surveys,
	          surveysFeedbacks = _state.surveysFeedbacks,
	          rowsPerPage = _state.rowsPerPage,
	          rowsTotal = _state.rowsTotal,
	          page = _state.page,
	          activePrevPage = _state.activePrevPage,
	          activeNextPage = _state.activeNextPage;
	
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          PageTitle,
	          null,
	          'Teams & Roles'
	        ),
	        _react2.default.createElement(
	          TableWrapper,
	          null,
	          _react2.default.createElement(_search2.default, {
	            handleQueryChange: this.handleQueryChange,
	            game: this.props.game,
	            games: this.props.games,
	            courseMembers: courseMembers,
	            onImportComplete: function onImportComplete() {
	              _this3.fetchData();
	              _this3.fetchTeamPlayers();
	              // Invalidate the App-level general-info cache and ask
	              // App.js to refetch. Otherwise the Dashboard's Team
	              // Count / Student Count KPIs stay stuck on their pre-
	              // upload values (they read from App.js's cached
	              // general-info state, which doesn't refire on route
	              // change) until the user hard-refreshes the page.
	              (0, _AppGeneralInfoService.clearAppGeneralInfoCache)();
	              _eventEmitter2.default.getInstance().trigger('reload-data');
	            }
	          }),
	          !loaded && _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(_reactLoaders.Loader, { type: 'ball-scale-ripple', active: true })
	          ),
	          loaded && _react2.default.createElement(_table2.default, {
	            teamPlayers: teamPlayers,
	            courseMembers: courseMembers,
	            availableTeams: availableTeams,
	            surveys: surveys,
	            surveysFeedbacks: surveysFeedbacks,
	            changeTeamPlayers: this.changeTeamPlayers,
	            onRotateComplete: this.fetchTeamPlayers
	          }),
	          _react2.default.createElement(_pagination2.default, {
	            rowsPerPage: rowsPerPage,
	            handleRowsPerPageChange: this.handleRowsPerPageChange,
	            rowsTotal: rowsTotal,
	            page: page,
	            handlePageChange: this.handlePageChange,
	            activePrevPage: activePrevPage,
	            activeNextPage: activeNextPage
	          })
	        )
	      );
	    }
	  }]);
	
	  return TeamsRoles;
	}(_react.PureComponent);
	
	exports.default = TeamsRoles;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  overflow: hidden;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Location = __webpack_require__(23);
	
	var _WelcomeChecklist = __webpack_require__(1520);
	
	var _WelcomeChecklist2 = _interopRequireDefault(_WelcomeChecklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Instructor welcome is a single consolidated checklist page at
	// /instructor/welcome (used for all rounds). The legacy
	// multi-page wizard files (welcome/step1..4, game-overview/*,
	// setting-up-gameplay/*, how-grading-works/*, what-to-expect/step1,
	// what-to-expect/step5, how-we-support-you, next-steps) are kept on
	// disk in case we need to bring any content back, but they are no
	// longer mounted as routes.
	//
	// The three round-specific What-to-Expect components (step2/3/4)
	// are imported and rendered as popups inside WelcomeChecklist.
	//
	// Any URL under /instructor/welcome/... gets normalized to the
	// single welcome page so deep-links to the old wizard pages don't
	// 404 silently — they just land on the checklist.
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Content = _styledComponents2.default.div(_templateObject2);
	
	var InstructorWelcomePage = function (_Component) {
	  _inherits(InstructorWelcomePage, _Component);
	
	  function InstructorWelcomePage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InstructorWelcomePage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstructorWelcomePage.__proto__ || Object.getPrototypeOf(InstructorWelcomePage)).call.apply(_ref, [this].concat(args))), _this), _this.normalizeLocation = function () {
	      var location = _this.props.location;
	
	      if (!location || !location.pathname) return;
	      var target = '/instructor/welcome';
	      if (location.pathname === target) return;
	      if (location.pathname.indexOf('/instructor/welcome') !== 0) return;
	      (0, _Location.changeLocation)(target + '?round=' + _this.activeRound);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InstructorWelcomePage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.normalizeLocation();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.normalizeLocation();
	    }
	
	    // Redirects any legacy wizard sub-paths under /instructor/welcome/
	    // back to the single welcome page. Idempotent: skipped if we're
	    // already on /instructor/welcome.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rounds = _props.rounds,
	          currentRound = _props.currentRound,
	          roundInUrl = _props.roundInUrl;
	
	      return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(_WelcomeChecklist2.default, {
	            currentRound: currentRound,
	            roundInUrl: roundInUrl,
	            rounds: rounds
	          })
	        )
	      );
	    }
	  }, {
	    key: 'activeRound',
	    get: function get() {
	      var _props2 = this.props,
	          currentRound = _props2.currentRound,
	          roundInUrl = _props2.roundInUrl;
	
	      return roundInUrl || currentRound;
	    }
	  }]);
	
	  return InstructorWelcomePage;
	}(_react.Component);
	
	exports.default = InstructorWelcomePage;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CloseModalVideoButton = exports.PlayPauseButton = exports.ModalVideoWrapper = exports.Text = exports.InfoTooltip = exports.Description = exports.Form = exports.FormWrapper = exports.Title = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  background: #fafafa;\n  padding: 40px;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n'], ['\n  background: #fafafa;\n  padding: 40px;\n  width: 100%;\n\n  .loader {\n    max-width: 800px;\n\n    .loader-inner {\n      div {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 100px;\n        border-color: #2a4169;\n      }\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 21px;\n  line-height: 28px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n  padding: 20px;\n  margin-top: 20px;\n'], ['\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n  padding: 20px;\n  margin-top: 20px;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  max-width: 960px;\n  padding: 20px;\n  margin-top: 12px;\n\n  ', '\n\n  ', '\n\n  .loader {\n    max-width: auto;\n\n    .loader-inner {\n      div {\n        margin: 0;\n      }\n    }\n  }\n'], ['\n  background: #ffffff;\n  border: 1px solid #d5d9dd;\n  border-radius: 8px;\n  max-width: 960px;\n  padding: 20px;\n  margin-top: 12px;\n\n  ', '\n\n  ', '\n\n  .loader {\n    max-width: auto;\n\n    .loader-inner {\n      div {\n        margin: 0;\n      }\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  max-width: 800px;\n  margin-top: 12px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n'], ['\n  max-width: 800px;\n  margin-top: 12px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0, 27, 59, 0.94);\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: #5c91f5;\n\n  width: 273px;\n  height: 40px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: #5c91f5;\n\n  width: 273px;\n  height: 40px;\n  background: rgba(0, 27, 59, 0.04);\n  border-radius: 4px;\n']),
	    _templateObject7 = _taggedTemplateLiteral(['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0,27,59,0.6);\n  margin-top: 12px;\n'], ['\n  font-family: \'Mukta Vaani\';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(0,27,59,0.6);\n  margin-top: 12px;\n']),
	    _templateObject8 = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n'], ['\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3A507B;\n  border-radius: 10px;\n\n  &:before {\n    display: block;\n    content: \'\';\n    align-items: center;\n    background: #0006;\n    display: flex;\n    justify-content: center;\n    opacity: 1;\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    transition: opacity .3s ease;\n    border-radius: 10px;\n  }\n\n  &.is-playing:before, &.is-playing button {\n    opacity: 0;\n  }\n  &.is-playing:hover:before, &.is-playing:hover button {\n    opacity: 1;\n  }\n  &:hover video {\n    cursor: pointer;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteral(['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n'], ['\n  align-items: center;\n  background: none;\n  background: #2a4169;\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0 4px 4px 0 #0000001a;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 2rem;\n  height: 80px;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n  width: 80px;\n  z-index: 2;\n  position: absolute;\n  transition: opacity .3s ease;\n  opacity: 1;\n']),
	    _templateObject10 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n'], ['\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  color: #fff;\n  padding: 0;\n  line-height: normal;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = exports.Title = _styledComponents2.default.div(_templateObject2);
	
	var FormWrapper = exports.FormWrapper = _styledComponents2.default.div(_templateObject3);
	
	var Form = exports.Form = _styledComponents2.default.div(_templateObject4, function (p) {
	  return p.maxWidth && '\n    max-width: ' + p.maxWidth + ';\n  ';
	}, function (p) {
	  return p.height && '\n    height: ' + p.height + ';\n  ';
	});
	
	var Description = exports.Description = _styledComponents2.default.div(_templateObject5);
	
	var InfoTooltip = exports.InfoTooltip = _styledComponents2.default.div(_templateObject6);
	
	var Text = exports.Text = _styledComponents2.default.div(_templateObject7);
	
	var ModalVideoWrapper = exports.ModalVideoWrapper = _styledComponents2.default.div(_templateObject8);
	
	var PlayPauseButton = exports.PlayPauseButton = _styledComponents2.default.button(_templateObject9);
	
	var CloseModalVideoButton = exports.CloseModalVideoButton = _styledComponents2.default.button(_templateObject10);

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runAssignSectionsUpload = exports.ASSIGN_SECTIONS_TEMPLATE_CSV = undefined;
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _superagent = __webpack_require__(298);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	
	// BE accepts "username" + ("section" | "section_id") columns. These
	// aliases let instructors use natural header names on their CSV; we
	// rewrite them in-place before POST. Unknown headers pass through so
	// a typo surfaces in the BE error map rather than being dropped here.
	var HEADER_ALIASES = {
	  username: "username",
	  user: "username",
	  user_name: "username",
	  email: "username",
	  emailaddress: "username",
	  section: "section",
	  sectionname: "section",
	  sectionid: "section_id",
	  section_id: "section_id"
	};
	
	var normalizeHeader = function normalizeHeader(h) {
	  return (h || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/[^a-z0-9]+/g, "").trim();
	};
	
	var readFileAsText = function readFileAsText(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();
	    reader.onload = function () {
	      return resolve(reader.result || "");
	    };
	    reader.onerror = function () {
	      return reject(new Error("Could not read the uploaded file."));
	    };
	    reader.readAsText(file);
	  });
	};
	
	var ASSIGN_SECTIONS_TEMPLATE_CSV = exports.ASSIGN_SECTIONS_TEMPLATE_CSV = "username,section\nexample@student.edu,Section A\n";
	
	// Flatten the BE's { errors: { field: message } } shape into a list
	// of strings for the modal's bullet list. Unknown shapes fall back
	// to the raw body or a generic message.
	var extractErrors = function extractErrors(err) {
	  var body = err && err.response && err.response.body;
	  if (body && body.errors && _typeof(body.errors) === "object") {
	    return Object.keys(body.errors).map(function (k) {
	      return String(body.errors[k]);
	    });
	  }
	  if (body && body.detail) return [String(body.detail)];
	  if (err && err.message) return [err.message];
	  return ["Upload failed. Please try again."];
	};
	
	var runAssignSectionsUpload = exports.runAssignSectionsUpload = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	    var file = _ref.file,
	        courseId = _ref.courseId,
	        gameId = _ref.gameId,
	        onProgress = _ref.onProgress;
	
	    var report, text, raw, nonEmptyLines, err, _err, headerLine, rawHeaders, canonical, _err2, _err3, rewrittenHeader, dataRows, csv, token, req, res, apiErr, body;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            report = function report(stage, extra) {
	              if (onProgress) onProgress(Object.assign({ stage: stage }, extra || {}));
	            };
	
	            report("parsing");
	            _context.next = 4;
	            return readFileAsText(file);
	
	          case 4:
	            text = _context.sent;
	            raw = String(text).replace(/^﻿/, "").split(/\r?\n/);
	            nonEmptyLines = raw.filter(function (l) {
	              return l && l.trim().length > 0;
	            });
	
	            if (!(nonEmptyLines.length === 0)) {
	              _context.next = 12;
	              break;
	            }
	
	            err = new Error("CSV is empty.");
	
	            err.kind = "validation";
	            err.errors = ["The uploaded file is empty."];
	            throw err;
	
	          case 12:
	            if (!(nonEmptyLines.length < 2)) {
	              _context.next = 17;
	              break;
	            }
	
	            _err = new Error("CSV has no data rows.");
	
	            _err.kind = "validation";
	            _err.errors = ["The uploaded file has no data rows below the header."];
	            throw _err;
	
	          case 17:
	            headerLine = nonEmptyLines[0];
	            rawHeaders = headerLine.split(",").map(function (s) {
	              return s.trim();
	            });
	            canonical = rawHeaders.map(function (h) {
	              return HEADER_ALIASES[normalizeHeader(h)] || h;
	            });
	
	            if (canonical.includes("username")) {
	              _context.next = 25;
	              break;
	            }
	
	            _err2 = new Error("Missing username column.");
	
	            _err2.kind = "validation";
	            _err2.errors = ['CSV must include a "username" column.'];
	            throw _err2;
	
	          case 25:
	            if (!(!canonical.includes("section") && !canonical.includes("section_id"))) {
	              _context.next = 30;
	              break;
	            }
	
	            _err3 = new Error("Missing section column.");
	
	            _err3.kind = "validation";
	            _err3.errors = ['CSV must include a "section" or "section_id" column.'];
	            throw _err3;
	
	          case 30:
	            rewrittenHeader = canonical.join(",");
	            dataRows = nonEmptyLines.slice(1);
	            csv = [rewrittenHeader].concat(_toConsumableArray(dataRows)).join("\n") + "\n";
	
	
	            report("uploading");
	            token = _Auth2.default.getToken();
	            req = _superagent2.default.post(API + "v2/games/bulk-assign-sections/").set("Accept", "application/json").attach("file", new Blob([csv], { type: "text/csv" }), "assign-sections.csv").field("course_id", String(courseId)).field("game_id", String(gameId));
	
	            if (token) req.set("Authorization", "Token " + token);
	
	            res = void 0;
	            _context.prev = 38;
	            _context.next = 41;
	            return req;
	
	          case 41:
	            res = _context.sent;
	            _context.next = 50;
	            break;
	
	          case 44:
	            _context.prev = 44;
	            _context.t0 = _context["catch"](38);
	            apiErr = new Error("Upload failed.");
	
	            apiErr.kind = "api";
	            apiErr.errors = extractErrors(_context.t0);
	            throw apiErr;
	
	          case 50:
	            body = res && res.body || {};
	
	            report("success", body);
	            return _context.abrupt("return", body);
	
	          case 53:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[38, 44]]);
	  }));
	
	  return function runAssignSectionsUpload(_x) {
	    return _ref2.apply(this, arguments);
	  };
	}();

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runChangeRolesUpload = exports.CHANGE_ROLES_TEMPLATE_CSV = undefined;
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _superagent = __webpack_require__(298);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	
	var VALID_ROLES = ["CEO", "PD", "PM", "OP", "FI", "VI"];
	
	var HEADER_ALIASES = {
	  email: "email",
	  emailaddress: "email",
	  username: "email",
	  role: "role",
	  position: "role"
	};
	
	var normalizeHeader = function normalizeHeader(h) {
	  return (h || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/[^a-z0-9]+/g, "").trim();
	};
	
	var readFileAsText = function readFileAsText(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();
	    reader.onload = function () {
	      return resolve(reader.result || "");
	    };
	    reader.onerror = function () {
	      return reject(new Error("Could not read the uploaded file."));
	    };
	    reader.readAsText(file);
	  });
	};
	
	var CHANGE_ROLES_TEMPLATE_CSV = exports.CHANGE_ROLES_TEMPLATE_CSV = "email,role\nexample@student.edu,CEO\n";
	
	var extractErrors = function extractErrors(err) {
	  var body = err && err.response && err.response.body;
	  if (body && body.errors && _typeof(body.errors) === "object") {
	    return Object.keys(body.errors).map(function (k) {
	      return String(body.errors[k]);
	    });
	  }
	  if (body && body.detail) return [String(body.detail)];
	  if (err && err.message) return [err.message];
	  return ["Upload failed. Please try again."];
	};
	
	var runChangeRolesUpload = exports.runChangeRolesUpload = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	    var file = _ref.file,
	        gameId = _ref.gameId,
	        onProgress = _ref.onProgress;
	
	    var report, text, raw, nonEmptyLines, err, _err, headerLine, rawHeaders, canonical, _err2, _err3, roleIdx, dataRows, badRows, _err4, rewrittenHeader, csv, token, req, res, apiErr, body;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            report = function report(stage, extra) {
	              if (onProgress) onProgress(Object.assign({ stage: stage }, extra || {}));
	            };
	
	            report("parsing");
	            _context.next = 4;
	            return readFileAsText(file);
	
	          case 4:
	            text = _context.sent;
	            raw = String(text).replace(/^﻿/, "").split(/\r?\n/);
	            nonEmptyLines = raw.filter(function (l) {
	              return l && l.trim().length > 0;
	            });
	
	            if (!(nonEmptyLines.length === 0)) {
	              _context.next = 12;
	              break;
	            }
	
	            err = new Error("CSV is empty.");
	
	            err.kind = "validation";
	            err.errors = ["The uploaded file is empty."];
	            throw err;
	
	          case 12:
	            if (!(nonEmptyLines.length < 2)) {
	              _context.next = 17;
	              break;
	            }
	
	            _err = new Error("CSV has no data rows.");
	
	            _err.kind = "validation";
	            _err.errors = ["The uploaded file has no data rows below the header."];
	            throw _err;
	
	          case 17:
	            headerLine = nonEmptyLines[0];
	            rawHeaders = headerLine.split(",").map(function (s) {
	              return s.trim();
	            });
	            canonical = rawHeaders.map(function (h) {
	              return HEADER_ALIASES[normalizeHeader(h)] || h;
	            });
	
	            if (canonical.includes("email")) {
	              _context.next = 25;
	              break;
	            }
	
	            _err2 = new Error("Missing email column.");
	
	            _err2.kind = "validation";
	            _err2.errors = ['CSV must include an "email" column.'];
	            throw _err2;
	
	          case 25:
	            if (canonical.includes("role")) {
	              _context.next = 30;
	              break;
	            }
	
	            _err3 = new Error("Missing role column.");
	
	            _err3.kind = "validation";
	            _err3.errors = ['CSV must include a "role" column.'];
	            throw _err3;
	
	          case 30:
	
	            // Catch typos in the role column before BE does. Role values must
	            // match the six-position whitelist. Report row number + bad value
	            // so the instructor can locate it in the spreadsheet.
	            roleIdx = canonical.indexOf("role");
	            dataRows = nonEmptyLines.slice(1);
	            badRows = [];
	
	            dataRows.forEach(function (line, i) {
	              var cells = line.split(",").map(function (c) {
	                return c.trim();
	              });
	              var roleVal = (cells[roleIdx] || "").toUpperCase();
	              if (roleVal && !VALID_ROLES.includes(roleVal)) {
	                badRows.push("Row " + (i + 2) + ": invalid role \"" + cells[roleIdx] + "\". Use one of " + VALID_ROLES.join(", ") + ".");
	              }
	            });
	
	            if (!(badRows.length > 0)) {
	              _context.next = 39;
	              break;
	            }
	
	            _err4 = new Error("Invalid role values.");
	
	            _err4.kind = "validation";
	            _err4.errors = badRows;
	            throw _err4;
	
	          case 39:
	            rewrittenHeader = canonical.join(",");
	            csv = [rewrittenHeader].concat(_toConsumableArray(dataRows)).join("\n") + "\n";
	
	
	            report("uploading");
	            token = _Auth2.default.getToken();
	            req = _superagent2.default.post(API + "v2/games/bulk-assign-roles/").set("Accept", "application/json").attach("file", new Blob([csv], { type: "text/csv" }), "change-roles.csv").field("game_id", String(gameId));
	
	            if (token) req.set("Authorization", "Token " + token);
	
	            res = void 0;
	            _context.prev = 46;
	            _context.next = 49;
	            return req;
	
	          case 49:
	            res = _context.sent;
	            _context.next = 58;
	            break;
	
	          case 52:
	            _context.prev = 52;
	            _context.t0 = _context["catch"](46);
	            apiErr = new Error("Upload failed.");
	
	            apiErr.kind = "api";
	            apiErr.errors = extractErrors(_context.t0);
	            throw apiErr;
	
	          case 58:
	            body = res && res.body || {};
	
	            report("success", body);
	            return _context.abrupt("return", body);
	
	          case 61:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[46, 52]]);
	  }));
	
	  return function runChangeRolesUpload(_x) {
	    return _ref2.apply(this, arguments);
	  };
	}();

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runReassignUpload = exports.REASSIGN_TEMPLATE_CSV = undefined;
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _superagent = __webpack_require__(298);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	
	// FE-side aliases so instructors can use natural-language header
	// names in the CSV. The BE only recognizes the canonical form on the
	// right (email / team / team_id); anything else gets rewritten
	// in-place before POST.
	var HEADER_ALIASES = {
	  email: "email",
	  emailaddress: "email",
	  username: "email",
	  team: "team",
	  teamname: "team",
	  teamid: "team_id",
	  team_id: "team_id"
	};
	
	var normalizeHeader = function normalizeHeader(h) {
	  return (h || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/[^a-z0-9]+/g, "").trim();
	};
	
	var readFileAsText = function readFileAsText(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();
	    reader.onload = function () {
	      return resolve(reader.result || "");
	    };
	    reader.onerror = function () {
	      return reject(new Error("Could not read the uploaded file."));
	    };
	    reader.readAsText(file);
	  });
	};
	
	// Starter template offered on the Reassign Teams step. Two lines
	// because downstream CSV parsers on Windows sometimes reject files
	// without a trailing newline after the last data row.
	var REASSIGN_TEMPLATE_CSV = exports.REASSIGN_TEMPLATE_CSV = "email,team\nexample@student.edu,Team Alpha\n";
	
	var runReassignUpload = exports.runReassignUpload = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	    var file = _ref.file,
	        gameId = _ref.gameId,
	        onProgress = _ref.onProgress;
	
	    var report, text, raw, nonEmptyLines, err, _err, headerLine, rawHeaders, canonical, _err2, _err3, rewrittenHeader, dataRows, csv, token, req, res, body;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            report = function report(stage, extra) {
	              if (onProgress) onProgress(Object.assign({ stage: stage }, extra || {}));
	            };
	
	            report("parsing");
	            _context.next = 4;
	            return readFileAsText(file);
	
	          case 4:
	            text = _context.sent;
	            raw = String(text).replace(/^﻿/, "").split(/\r?\n/);
	            nonEmptyLines = raw.filter(function (l) {
	              return l && l.trim().length > 0;
	            });
	
	            if (!(nonEmptyLines.length === 0)) {
	              _context.next = 12;
	              break;
	            }
	
	            err = new Error("CSV is empty.");
	
	            err.kind = "validation";
	            err.errors = ["The uploaded file is empty."];
	            throw err;
	
	          case 12:
	            if (!(nonEmptyLines.length < 2)) {
	              _context.next = 17;
	              break;
	            }
	
	            _err = new Error("CSV has no data rows.");
	
	            _err.kind = "validation";
	            _err.errors = ["The uploaded file has no data rows below the header."];
	            throw _err;
	
	          case 17:
	            headerLine = nonEmptyLines[0];
	            rawHeaders = headerLine.split(",").map(function (s) {
	              return s.trim();
	            });
	            canonical = rawHeaders.map(function (h) {
	              return HEADER_ALIASES[normalizeHeader(h)] || h;
	            });
	
	            if (canonical.includes("email")) {
	              _context.next = 25;
	              break;
	            }
	
	            _err2 = new Error("Missing email column.");
	
	            _err2.kind = "validation";
	            _err2.errors = ['CSV must include an "email" column.'];
	            throw _err2;
	
	          case 25:
	            if (!(!canonical.includes("team") && !canonical.includes("team_id"))) {
	              _context.next = 30;
	              break;
	            }
	
	            _err3 = new Error("Missing team column.");
	
	            _err3.kind = "validation";
	            _err3.errors = ['CSV must include a "team" or "team_id" column.'];
	            throw _err3;
	
	          case 30:
	            rewrittenHeader = canonical.join(",");
	            dataRows = nonEmptyLines.slice(1);
	            csv = [rewrittenHeader].concat(_toConsumableArray(dataRows)).join("\n") + "\n";
	
	
	            report("uploading");
	            token = _Auth2.default.getToken();
	            req = _superagent2.default.post(API + "v2/games/bulk-assign/").set("Accept", "application/json").attach("file", new Blob([csv], { type: "text/csv" }), "reassign.csv").field("game_id", String(gameId));
	
	            if (token) req.set("Authorization", "Token " + token);
	
	            _context.next = 39;
	            return req;
	
	          case 39:
	            res = _context.sent;
	            body = res && res.body || {};
	
	            report("success", body);
	            return _context.abrupt("return", body);
	
	          case 43:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function runReassignUpload(_x) {
	    return _ref2.apply(this, arguments);
	  };
	}();

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runRosterUpload = exports.buildGameCsv = exports.buildStudentCsv = exports.determineCompetitions = exports.validateRoster = exports.parseRosterCsv = undefined;
	
	var _regenerator = __webpack_require__(47);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _superagent = __webpack_require__(298);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _ApiService = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var API = ("https://be-production-itb.marketgames.io/api/");
	var DEFAULT_PASSWORD = "business101";
	var MAX_TEAM_SIZE = 6;
	
	var POLL_FIRST_DELAY_MS = 10000;
	var POLL_MID_DELAY_MS = 30000;
	var POLL_LATE_DELAY_MS = 60000;
	var POLL_MID_TO_LATE_MS = 120000;
	var POLL_MAX_DURATION_MS = 300000;
	
	var sleep = function sleep(ms) {
	  return new Promise(function (res) {
	    return setTimeout(res, ms);
	  });
	};
	
	// ---------- CSV parsing ----------
	
	var parseCsvLine = function parseCsvLine(line) {
	  var cells = [];
	  var cur = "";
	  var inQuotes = false;
	  for (var i = 0; i < line.length; i++) {
	    var ch = line[i];
	    if (inQuotes) {
	      if (ch === '"') {
	        if (line[i + 1] === '"') {
	          cur += '"';i++;
	        } else {
	          inQuotes = false;
	        }
	      } else {
	        cur += ch;
	      }
	    } else {
	      if (ch === ",") {
	        cells.push(cur);cur = "";
	      } else if (ch === '"') {
	        inQuotes = true;
	      } else {
	        cur += ch;
	      }
	    }
	  }
	  cells.push(cur);
	  return cells.map(function (c) {
	    return c.trim();
	  });
	};
	
	var normalizeHeader = function normalizeHeader(h) {
	  return (h || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/[^a-z0-9]+/g, "").trim();
	};
	
	var HEADER_ALIASES = {
	  firstname: "first_name",
	  lastname: "last_name",
	  email: "email",
	  team: "team",
	  // Optional: if the instructor includes a Competition column, we
	  // honor it per team (see mergeCompetitionAssignments below).
	  // Missing / blank rows fall back to the auto-assign algorithm.
	  competition: "competition",
	  // Optional: instructor-supplied login username. Blank cells fall
	  // back to the row's email in buildStudentCsv. Collisions (within
	  // the file or against existing course members) are blocked in
	  // validateRoster / runRosterUpload.
	  username: "username"
	};
	
	var readFileAsText = function readFileAsText(file) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();
	    reader.onload = function () {
	      return resolve(reader.result || "");
	    };
	    reader.onerror = function () {
	      return reject(new Error("Could not read the uploaded file."));
	    };
	    reader.readAsText(file);
	  });
	};
	
	var parseRosterCsv = exports.parseRosterCsv = function parseRosterCsv(text) {
	  var lines = String(text || "").replace(/^﻿/, "").split(/\r?\n/).filter(function (l) {
	    return l.trim().length > 0;
	  });
	
	  if (lines.length < 1) {
	    return { rows: [], headers: [], error: "The uploaded file is empty." };
	  }
	
	  var rawHeaders = parseCsvLine(lines[0]);
	  var headerMap = rawHeaders.map(function (h) {
	    return HEADER_ALIASES[normalizeHeader(h)] || null;
	  });
	
	  var requiredFields = ["first_name", "last_name", "email", "team"];
	  var missingHeaders = requiredFields.filter(function (rf) {
	    return !headerMap.includes(rf);
	  });
	  if (missingHeaders.length) {
	    return {
	      rows: [],
	      headers: rawHeaders,
	      error: "The uploaded file is missing required columns: " + missingHeaders.join(", ") + "."
	    };
	  }
	
	  var rows = [];
	
	  var _loop = function _loop(i) {
	    var cells = parseCsvLine(lines[i]);
	    var row = { _rowNumber: i + 1 };
	    headerMap.forEach(function (field, idx) {
	      if (field) row[field] = (cells[idx] || "").trim();
	    });
	    rows.push(row);
	  };
	
	  for (var i = 1; i < lines.length; i++) {
	    _loop(i);
	  }
	
	  return { rows: rows, headers: rawHeaders, error: null };
	};
	
	// ---------- Validation ----------
	
	var validateRoster = exports.validateRoster = function validateRoster(rows) {
	  var errors = [];
	  var requiredFields = [{ key: "first_name", label: "First Name" }, { key: "last_name", label: "Last Name" }, { key: "email", label: "Email" }, { key: "team", label: "Team" }];
	
	  var missingByRow = {};
	  rows.forEach(function (row) {
	    var missing = requiredFields.filter(function (f) {
	      return !row[f.key];
	    }).map(function (f) {
	      return f.label;
	    });
	    if (missing.length) {
	      missingByRow[row._rowNumber] = missing;
	    }
	  });
	  Object.keys(missingByRow).forEach(function (rowNum) {
	    errors.push("Row " + rowNum + " is missing: " + missingByRow[rowNum].join(", ") + ".");
	  });
	
	  var emailCounts = {};
	  rows.forEach(function (row) {
	    var e = (row.email || "").toLowerCase();
	    if (!e) return;
	    if (!emailCounts[e]) emailCounts[e] = [];
	    emailCounts[e].push(row._rowNumber);
	  });
	  Object.keys(emailCounts).forEach(function (email) {
	    if (emailCounts[email].length > 1) {
	      errors.push("Email \"" + email + "\" appears on rows " + emailCounts[email].join(", ") + ".");
	    }
	  });
	
	  // Catch intra-file username collisions. Blank cells are allowed
	  // (those rows fall back to email in buildStudentCsv). The
	  // runRosterUpload cross-check against existing course members
	  // handles collisions with already-registered users.
	  var usernameCounts = {};
	  rows.forEach(function (row) {
	    var u = (row.username || "").toLowerCase();
	    if (!u) return;
	    if (!usernameCounts[u]) usernameCounts[u] = [];
	    usernameCounts[u].push(row._rowNumber);
	  });
	  Object.keys(usernameCounts).forEach(function (u) {
	    if (usernameCounts[u].length > 1) {
	      errors.push("Username \"" + u + "\" appears on rows " + usernameCounts[u].join(", ") + ".");
	    }
	  });
	
	  var teamCounts = {};
	  rows.forEach(function (row) {
	    var t = (row.team || "").trim();
	    if (!t) return;
	    if (!teamCounts[t]) teamCounts[t] = 0;
	    teamCounts[t] += 1;
	  });
	  Object.keys(teamCounts).forEach(function (team) {
	    if (teamCounts[team] > MAX_TEAM_SIZE) {
	      errors.push("Team \"" + team + "\" has " + teamCounts[team] + " members. Max is " + MAX_TEAM_SIZE + ".");
	    }
	  });
	
	  // If Competition is provided per row, values must be positive
	  // integers and every row for the same team must agree. Blank cells
	  // are allowed and fall back to auto-assignment downstream.
	  var competitionByTeam = {};
	  rows.forEach(function (row) {
	    var t = (row.team || "").trim();
	    var c = (row.competition || "").trim();
	    if (!t || !c) return;
	    if (!/^\d+$/.test(c) || Number(c) < 1) {
	      errors.push("Row " + row._rowNumber + " has an invalid Competition value \"" + c + "\". Use a positive integer.");
	      return;
	    }
	    if (competitionByTeam[t] == null) {
	      competitionByTeam[t] = c;
	    } else if (competitionByTeam[t] !== c) {
	      errors.push("Team \"" + t + "\" has conflicting Competition values (" + competitionByTeam[t] + " vs " + c + "). All rows for a team must use the same Competition.");
	    }
	  });
	
	  return { errors: errors };
	};
	
	// ---------- Competition assignment ----------
	
	var determineCompetitions = exports.determineCompetitions = function determineCompetitions(teamNames) {
	  var N = teamNames.length;
	  if (N === 0) return { numCompetitions: 0, assignments: {}, sizes: [] };
	
	  var numCompetitions = Math.max(1, Math.round(N / 7));
	  var baseSize = Math.floor(N / numCompetitions);
	  var remainder = N % numCompetitions;
	
	  var sizes = [];
	  for (var i = 0; i < numCompetitions; i++) {
	    sizes.push(baseSize + (i < remainder ? 1 : 0));
	  }
	
	  var assignments = {};
	  var idx = 0;
	  for (var c = 0; c < numCompetitions; c++) {
	    for (var j = 0; j < sizes[c]; j++) {
	      assignments[teamNames[idx]] = c + 1;
	      idx += 1;
	    }
	  }
	
	  return { numCompetitions: numCompetitions, assignments: assignments, sizes: sizes };
	};
	
	// ---------- CSV builders ----------
	
	var csvEscape = function csvEscape(val) {
	  var s = String(val == null ? "" : val);
	  if (/[",\n\r]/.test(s)) return "\"" + s.replace(/"/g, '""') + "\"";
	  return s;
	};
	
	var buildCsv = function buildCsv(headers, rows) {
	  var headerLine = headers.map(csvEscape).join(",");
	  var bodyLines = rows.map(function (r) {
	    return headers.map(function (h) {
	      return csvEscape(r[h]);
	    }).join(",");
	  });
	  return [headerLine].concat(_toConsumableArray(bodyLines)).join("\n") + "\n";
	};
	
	var buildStudentCsv = exports.buildStudentCsv = function buildStudentCsv(rows) {
	  var outRows = rows.map(function (r) {
	    var explicitUsername = (r.username || "").trim();
	    return {
	      username: explicitUsername || r.email,
	      first_name: r.first_name,
	      last_name: r.last_name,
	      email: r.email,
	      password: DEFAULT_PASSWORD
	    };
	  });
	  return buildCsv(["username", "first_name", "last_name", "email", "password"], outRows);
	};
	
	// Existing teams keep their BE-side competition assignment: the
	// `competition_id` column carries the DB PK, and BE reuses it as-is.
	// New teams get a fresh competition NAME (small integer) in the
	// `competition` column; BE creates the competition if it doesn't
	// exist yet. Exactly one of the two columns is populated per row.
	var buildGameCsv = exports.buildGameCsv = function buildGameCsv(rows, roleByEmail, competitionByTeam, competitionIdByTeam) {
	  var outRows = rows.map(function (r) {
	    var emailKey = (r.email || "").toLowerCase();
	    var existingRole = roleByEmail[emailKey];
	    var explicitUsername = (r.username || "").trim();
	    return {
	      username: explicitUsername || r.email,
	      competition: competitionByTeam[r.team] != null ? String(competitionByTeam[r.team]) : "",
	      competition_id: competitionIdByTeam[r.team] != null ? String(competitionIdByTeam[r.team]) : "",
	      team: r.team,
	      role: existingRole || "CEO"
	    };
	  });
	  return buildCsv(["username", "competition", "competition_id", "team", "role"], outRows);
	};
	
	// ---------- HTTP helpers ----------
	
	var authHeader = function authHeader() {
	  var token = _Auth2.default.getToken();
	  return token ? { Authorization: "Token " + token } : {};
	};
	
	var postFile = function postFile(url, csv, filename, extraFields) {
	  var req = _superagent2.default.post(url).set("Accept", "application/json").set(authHeader()).attach("file", new Blob([csv], { type: "text/csv" }), filename);
	
	  if (extraFields) {
	    Object.keys(extraFields).forEach(function (k) {
	      req.field(k, String(extraFields[k]));
	    });
	  }
	  return req;
	};
	
	var fetchAllPages = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(url) {
	    var next, all, res, body;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            next = url;
	            all = [];
	
	          case 2:
	            if (!next) {
	              _context.next = 10;
	              break;
	            }
	
	            _context.next = 5;
	            return (0, _ApiService.getRequest)(next);
	
	          case 5:
	            res = _context.sent;
	            body = res.body || {};
	
	            if (Array.isArray(body)) {
	              all.push.apply(all, _toConsumableArray(body));
	              next = null;
	            } else {
	              all.push.apply(all, _toConsumableArray(body.results || []));
	              next = body.next;
	            }
	            _context.next = 2;
	            break;
	
	          case 10:
	            return _context.abrupt("return", all);
	
	          case 11:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function fetchAllPages(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	// Returns the key the BE uses to identify a coursemember's user.
	// /v2/games/coursemembers/ serializes `user` as the username STRING
	// (e.g. "colm-janotf26"), not a nested user object. Older/alternate
	// shapes (nested object, bare `username`, bare `email`) still fall
	// through below. We match this against the resolved username we POST
	// (CSV username || email), so re-uploads skip rows already in the
	// course regardless of whether the first upload used an explicit
	// username or let it default to email.
	var extractCourseMemberUserKey = function extractCourseMemberUserKey(cm) {
	  if (!cm) return "";
	  if (typeof cm.user === "string") return cm.user;
	  if (cm.user) {
	    if (cm.user.username) return cm.user.username;
	    if (cm.user.email) return cm.user.email;
	  }
	  if (cm.username) return cm.username;
	  if (cm.email) return cm.email;
	  return "";
	};
	
	var extractTeamPlayerEmail = function extractTeamPlayerEmail(tp) {
	  if (!tp || !tp.user) return "";
	  return tp.user.email || tp.user.username || "";
	};
	
	// ---------- Poll ----------
	
	var pollCourseMembers = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref2) {
	    var courseId = _ref2.courseId,
	        expectedUserKeys = _ref2.expectedUserKeys,
	        onProgress = _ref2.onProgress;
	    var startTime, expectedSet, runCheck, elapsed, nextDelay;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            startTime = Date.now();
	            expectedSet = new Set(expectedUserKeys.map(function (k) {
	              return (k || "").toLowerCase();
	            }));
	
	            runCheck = function () {
	              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var members, found, matched;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        _context2.next = 2;
	                        return fetchAllPages(API + "v2/games/coursemembers/?page_size=500");
	
	                      case 2:
	                        members = _context2.sent;
	                        found = new Set(members.map(function (m) {
	                          return extractCourseMemberUserKey(m).toLowerCase();
	                        }).filter(Boolean));
	                        matched = 0;
	
	                        expectedSet.forEach(function (k) {
	                          if (found.has(k)) matched += 1;
	                        });
	                        if (onProgress) onProgress({ matched: matched, total: expectedSet.size });
	                        return _context2.abrupt("return", matched === expectedSet.size);
	
	                      case 8:
	                      case "end":
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, undefined);
	              }));
	
	              return function runCheck() {
	                return _ref4.apply(this, arguments);
	              };
	            }();
	
	            _context3.next = 5;
	            return sleep(POLL_FIRST_DELAY_MS);
	
	          case 5:
	            _context3.next = 7;
	            return runCheck();
	
	          case 7:
	            if (!_context3.sent) {
	              _context3.next = 9;
	              break;
	            }
	
	            return _context3.abrupt("return");
	
	          case 9:
	            if (false) {
	              _context3.next = 22;
	              break;
	            }
	
	            elapsed = Date.now() - startTime;
	
	            if (!(elapsed >= POLL_MAX_DURATION_MS)) {
	              _context3.next = 13;
	              break;
	            }
	
	            throw new Error("Students did not finish loading within 5 minutes. Please refresh and try again.");
	
	          case 13:
	            nextDelay = elapsed >= POLL_MID_TO_LATE_MS ? POLL_LATE_DELAY_MS : POLL_MID_DELAY_MS;
	            _context3.next = 16;
	            return sleep(nextDelay);
	
	          case 16:
	            _context3.next = 18;
	            return runCheck();
	
	          case 18:
	            if (!_context3.sent) {
	              _context3.next = 20;
	              break;
	            }
	
	            return _context3.abrupt("return");
	
	          case 20:
	            _context3.next = 9;
	            break;
	
	          case 22:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function pollCourseMembers(_x2) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	// ---------- Orchestrator ----------
	
	var runRosterUpload = exports.runRosterUpload = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(_ref5) {
	    var file = _ref5.file,
	        courseId = _ref5.courseId,
	        gameId = _ref5.gameId,
	        onProgress = _ref5.onProgress;
	
	    var report, text, _parseRosterCsv, rows, parseError, err, _err, _validateRoster, validationErrors, _err2, existingTeams, teamsRes, existingCompetitionIdByTeamName, explicitByTeam, existingMembers, existingUserKeys, resolveRowUserKey, rowMatchesExistingMember, newRows, skippedCount, studentCsv, expectedUserKeys, teamPlayers, roleByEmail, uniqueTeams, seenTeams, teamsNeedingAutoAssign, _determineCompetition, autoAssignByTeam, competitionIdByTeam, competitionByTeam, numCompetitions, gameCsv, addedCount, numTeams;
	
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            report = function report(stage, extra) {
	              if (onProgress) onProgress(Object.assign({ stage: stage }, extra || {}));
	            };
	
	            report("parsing");
	            _context4.next = 4;
	            return readFileAsText(file);
	
	          case 4:
	            text = _context4.sent;
	            _parseRosterCsv = parseRosterCsv(text), rows = _parseRosterCsv.rows, parseError = _parseRosterCsv.error;
	
	            if (!parseError) {
	              _context4.next = 11;
	              break;
	            }
	
	            err = new Error(parseError);
	
	            err.kind = "validation";
	            err.errors = [parseError];
	            throw err;
	
	          case 11:
	            if (!(rows.length === 0)) {
	              _context4.next = 16;
	              break;
	            }
	
	            _err = new Error("The uploaded file has no student rows.");
	
	            _err.kind = "validation";
	            _err.errors = [_err.message];
	            throw _err;
	
	          case 16:
	
	            report("validating");
	            _validateRoster = validateRoster(rows), validationErrors = _validateRoster.errors;
	
	            if (!validationErrors.length) {
	              _context4.next = 23;
	              break;
	            }
	
	            _err2 = new Error("Please fix the following issues in the file and try again.");
	
	            _err2.kind = "validation";
	            _err2.errors = validationErrors;
	            throw _err2;
	
	          case 23:
	
	            // Pull the existing teams for this game up front so we know which
	            // teams already exist. For those teams we send their competition
	            // PK on the CSV's `competition_id` column (BE keeps the assignment
	            // as-is). NEW teams use the `competition` column with a small-int
	            // NAME instead. `team.competition` from /api/teams/ is a PK, not
	            // the competition name, so we can't validate an instructor's
	            // explicit Competition value against what's stored. If a CSV row
	            // targets an existing team, its explicit Competition is ignored
	            // and the team stays where it is.
	            existingTeams = [];
	            _context4.prev = 24;
	            _context4.next = 27;
	            return (0, _ApiService.getRequest)(API + "teams/?game=" + _Auth2.default.getGameId());
	
	          case 27:
	            teamsRes = _context4.sent;
	
	            existingTeams = Array.isArray(teamsRes.body) ? teamsRes.body : [];
	            _context4.next = 34;
	            break;
	
	          case 31:
	            _context4.prev = 31;
	            _context4.t0 = _context4["catch"](24);
	
	            existingTeams = [];
	
	          case 34:
	            existingCompetitionIdByTeamName = {};
	
	            existingTeams.forEach(function (team) {
	              if (team && team.name != null && team.competition != null) {
	                existingCompetitionIdByTeamName[String(team.name)] = Number(team.competition);
	              }
	            });
	
	            explicitByTeam = {};
	
	            rows.forEach(function (r) {
	              var t = r.team;
	              var c = (r.competition || "").trim();
	              if (t && c && explicitByTeam[t] == null) {
	                explicitByTeam[t] = Number(c);
	              }
	            });
	
	            report("checking_existing");
	            existingMembers = [];
	            _context4.prev = 40;
	            _context4.next = 43;
	            return fetchAllPages(API + "v2/games/coursemembers/?page_size=500");
	
	          case 43:
	            existingMembers = _context4.sent;
	            _context4.next = 49;
	            break;
	
	          case 46:
	            _context4.prev = 46;
	            _context4.t1 = _context4["catch"](40);
	
	            existingMembers = [];
	
	          case 49:
	            existingUserKeys = new Set(existingMembers.map(function (m) {
	              return extractCourseMemberUserKey(m).toLowerCase();
	            }).filter(Boolean));
	
	            // The BE identifies users by the stored username (returned as
	            // `cm.user` on /v2/games/coursemembers/). A CSV row matches an
	            // existing member when EITHER of its possible identifiers lines
	            // up with one of those keys:
	            //   - the row's explicit username (if provided), OR
	            //   - the row's email, which the FE falls back to as the username
	            //     when the CSV didn't supply one.
	            // Checking both lets a re-upload skip cleanly whether the first
	            // upload used an explicit username or defaulted to email, and lets
	            // mixed-source rosters (some rows new-style, some old-style) work.
	            //
	            // A FE-side "username collision" throw was intentionally dropped:
	            // when a provided username matches an existing user key we can't
	            // tell from this payload whether it's the same person (re-upload)
	            // or a different one trying to claim an existing username — the BE
	            // owns that uniqueness check and will reject on /upload-students/
	            // when it's a real conflict.
	
	            resolveRowUserKey = function resolveRowUserKey(r) {
	              return ((r.username || "").trim() || r.email || "").toLowerCase();
	            };
	
	            rowMatchesExistingMember = function rowMatchesExistingMember(r) {
	              var candidates = [(r.username || "").trim().toLowerCase(), (r.email || "").toLowerCase()].filter(Boolean);
	              return candidates.some(function (k) {
	                return existingUserKeys.has(k);
	              });
	            };
	
	            newRows = rows.filter(function (r) {
	              return !rowMatchesExistingMember(r);
	            });
	            skippedCount = rows.length - newRows.length;
	
	            if (!(newRows.length === 0)) {
	              _context4.next = 58;
	              break;
	            }
	
	            // Every row is already a course member — nothing to POST, nothing to
	            // poll for. Step 1 is effectively complete.
	            report("polling", { matched: rows.length, total: rows.length });
	            _context4.next = 66;
	            break;
	
	          case 58:
	            report("uploading_students", { newCount: newRows.length, skippedCount: skippedCount });
	            studentCsv = buildStudentCsv(newRows);
	            _context4.next = 62;
	            return postFile(API + "courses/" + courseId + "/upload-students/", studentCsv, "students.csv");
	
	          case 62:
	
	            report("polling", { matched: skippedCount, total: rows.length });
	            // Poll by resolved username (CSV username || email) because that's
	            // the key the BE stores on `cm.user`. Using raw emails here would
	            // never match for rows uploaded with an explicit username.
	            expectedUserKeys = rows.map(function (r) {
	              return resolveRowUserKey(r);
	            });
	            _context4.next = 66;
	            return pollCourseMembers({
	              courseId: courseId,
	              expectedUserKeys: expectedUserKeys,
	              onProgress: function onProgress(_ref7) {
	                var matched = _ref7.matched,
	                    total = _ref7.total;
	                return report("polling", { matched: matched, total: total });
	              }
	            });
	
	          case 66:
	
	            report("resolving_roles");
	            teamPlayers = [];
	            _context4.prev = 68;
	            _context4.next = 71;
	            return fetchAllPages(API + "v2/games/teamplayers/?page_size=500&game=" + _Auth2.default.getGameId());
	
	          case 71:
	            teamPlayers = _context4.sent;
	            _context4.next = 77;
	            break;
	
	          case 74:
	            _context4.prev = 74;
	            _context4.t2 = _context4["catch"](68);
	
	            teamPlayers = [];
	
	          case 77:
	            roleByEmail = {};
	
	            teamPlayers.forEach(function (tp) {
	              var email = extractTeamPlayerEmail(tp).toLowerCase();
	              if (email && tp.role) roleByEmail[email] = tp.role;
	            });
	
	            uniqueTeams = [];
	            seenTeams = new Set();
	
	            rows.forEach(function (r) {
	              if (r.team && !seenTeams.has(r.team)) {
	                seenTeams.add(r.team);
	                uniqueTeams.push(r.team);
	              }
	            });
	
	            // Split each unique team into one of two buckets:
	            //   - competitionIdByTeam: existing teams. Value is the DB PK; goes
	            //     into the `competition_id` CSV column. BE reuses the assignment.
	            //   - competitionByTeam: new teams. Value is a small-int NAME (from
	            //     the instructor's CSV or auto-assigned); goes into the
	            //     `competition` CSV column. BE creates the competition if new.
	            // A team never populates both columns.
	            teamsNeedingAutoAssign = uniqueTeams.filter(function (t) {
	              return existingCompetitionIdByTeamName[t] == null && explicitByTeam[t] == null;
	            });
	            _determineCompetition = determineCompetitions(teamsNeedingAutoAssign), autoAssignByTeam = _determineCompetition.assignments;
	            competitionIdByTeam = {};
	            competitionByTeam = {};
	
	            uniqueTeams.forEach(function (t) {
	              if (existingCompetitionIdByTeamName[t] != null) {
	                competitionIdByTeam[t] = existingCompetitionIdByTeamName[t];
	              } else if (explicitByTeam[t] != null) {
	                competitionByTeam[t] = explicitByTeam[t];
	              } else {
	                competitionByTeam[t] = autoAssignByTeam[t];
	              }
	            });
	            // Report the count of distinct competitions this upload touches
	            // (existing PKs + new-team NAMEs).
	            numCompetitions = new Set([].concat(_toConsumableArray(Object.values(competitionIdByTeam).map(function (v) {
	              return "id:" + v;
	            })), _toConsumableArray(Object.values(competitionByTeam).map(function (v) {
	              return "name:" + v;
	            })))).size;
	
	
	            report("uploading_game", { numCompetitions: numCompetitions });
	            gameCsv = buildGameCsv(rows, roleByEmail, competitionByTeam, competitionIdByTeam);
	            _context4.next = 92;
	            return postFile(API + "v2/games/upload/", gameCsv, "game.csv", { game_id: gameId });
	
	          case 92:
	            addedCount = newRows.length;
	            numTeams = uniqueTeams.length;
	
	            report("success", { addedCount: addedCount, skippedCount: skippedCount, totalCount: rows.length, numTeams: numTeams, numCompetitions: numCompetitions });
	            return _context4.abrupt("return", { addedCount: addedCount, skippedCount: skippedCount, totalCount: rows.length, numTeams: numTeams, numCompetitions: numCompetitions });
	
	          case 96:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined, [[24, 31], [40, 46], [68, 74]]);
	  }));
	
	  return function runRosterUpload(_x3) {
	    return _ref6.apply(this, arguments);
	  };
	}();

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logRequest = logRequest;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(24);
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _App = __webpack_require__(569);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _routes = __webpack_require__(1546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrap(callback) {
	  return function (nextState, replace) {
	    logRequest(nextState.location);
	    callback(nextState, replace);
	  };
	}
	
	function redirectToLogin(nextState, replace) {
	  var queryParams = new URLSearchParams(nextState.location.search);
	  var auth = parseInt(queryParams.get("auth"));
	
	  if (auth) {
	    var token = queryParams.get("_token");
	    var user_id = queryParams.get("user_id");
	    var position = queryParams.get("position");
	    var game_id = queryParams.get("game_id");
	    var course_id = queryParams.get("course_id");
	
	    _Auth2.default.authenticateUser(token, user_id, position, game_id, course_id);
	  }
	
	  if (!_Auth2.default.isUserAuthenticated()) {
	    replace({
	      pathname: "/welcome",
	      state: { nextPathname: nextState.location.pathname }
	    });
	  }
	}
	
	var redirectToLoginWrapper = wrap(redirectToLogin);
	
	function redirectToHome(nextState, replace) {
	  if (_Auth2.default.isUserAuthenticated()) {
	    if (_Auth2.default.getPosition() === "Student") {
	      replace({
	        pathname: "/start",
	        state: { nextPathname: nextState.location.pathname }
	      });
	    } else {
	      replace({
	        pathname: "/instructor/dashboard",
	        state: {
	          nextPathname: nextState.location.pathname
	        }
	      });
	    }
	  }
	}
	
	var redirectToHomeWrapper = wrap(redirectToHome);
	
	function indexRedirect(nextState, replace) {
	  if (nextState.location.pathname === "/") {
	    if (_Auth2.default.isUserAuthenticated()) {
	      if (_Auth2.default.getPosition() === "Student") {
	        replace({
	          pathname: "/start",
	          state: { nextPathname: nextState.location.pathname }
	        });
	      } else {
	        replace({
	          pathname: "/instructor/dashboard",
	          state: {
	            nextPathname: nextState.location.pathname
	          }
	        });
	      }
	    } else {
	      replace({
	        pathname: "/welcome",
	        state: {
	          nextPathname: nextState.location.pathname
	        }
	      });
	    }
	  }
	}
	
	var indexRedirectWrapper = wrap(indexRedirect);
	
	function logRequestWrapper(nextState, replace) {
	  logRequest(nextState.location);
	}
	
	function logRequest(location) {
	  var excluded = ["welcome", "login", "register", "join", "reset-password", "verify", "instructor", "team-reports", "promo-code", "onboarding", "round-trivia", "start"];
	  var routes = location.pathname.split("/").filter(function (i) {
	    return i !== "";
	  });
	  var params = [];
	  for (var key in location.query) {
	    params.push(key + "=" + location.query[key]);
	  }
	  var fullUrl = params.length > 0 ? location.pathname + "?" + params.join("&") : location.pathname;
	
	  if (routes.length > 0 && !excluded.includes(routes[0])) {
	    sessionStorage.setItem("previousLocation", fullUrl);
	  }
	}
	
	var changedPage = function changedPage() {
	  if (window && window.Appcues) {
	    window.Appcues.page();
	  }
	};
	
	var Routes = _react2.default.createElement(
	  _reactRouter.Router,
	  { history: _reactRouter.browserHistory, onUpdate: function onUpdate() {
	      return changedPage();
	    } },
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: "/", component: _App2.default, onEnter: indexRedirectWrapper },
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "welcome",
	      onEnter: redirectToHomeWrapper,
	      component: _routes.WelcomePage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "login",
	      onEnter: redirectToHomeWrapper,
	      component: _routes.LoginPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "register",
	      onEnter: redirectToHomeWrapper,
	      component: _routes.RegisterPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "join",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.JoinPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "reset-password",
	      onEnter: redirectToHomeWrapper,
	      component: _routes.ResetPasswordPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "verify/:token",
	      onEnter: redirectToHomeWrapper,
	      component: _routes.AccountVerify
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "reset-password/:token1/:token2",
	      onEnter: redirectToHomeWrapper,
	      component: _routes.ResetPassword
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "promo-code",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PromoCodePage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "profile",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.MyProfilePage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "scoring-breakdown",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.MyProfilePage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "start",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.StartPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "intro-video",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.IntroVideoPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "demo",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.InstructorDemoPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "onboarding",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.OnboardingPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "onboarding/:category",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.OnboardingPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "onboarding/:category/:step",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.OnboardingPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "round-trivia",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.RoundTriviaPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "round-trivia/:category",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.RoundTriviaPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "round-trivia/:category/:step",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.RoundTriviaPage
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "goals-and-targets",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.GoalsAndTargets
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "peer-feedback",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PeerFeedback
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "peer-feedback/:alias1",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PeerFeedback
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "peer-feedback/:alias1/:alias2",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PeerFeedback
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "performance-feedback",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PerformanceFeedback
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "performance-feedback/:alias1",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PerformanceFeedback
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "performance-feedback/:alias1/:alias2",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PerformanceFeedback
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: "instructor", onEnter: redirectToLoginWrapper },
	      _react2.default.createElement(_reactRouter.IndexRoute, {
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorDashboard
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "dashboard",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorDashboard
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "welcome",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorWelcomePage
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "welcome/:category",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorWelcomePage
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "welcome/:category/:step",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorWelcomePage
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "onboarding",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorOnboardingPage
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "onboarding/:step",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorOnboardingPage
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "course-management",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorCourseManagement
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "goals-and-targets",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorGoalsAndTargets
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "game-management",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorGameManagement
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "round-management/:game_id",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorRoundManagement
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "team-management/:game_id",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorTeamManagement
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "performance-feedback",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorPerformanceFeedback
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "performance-feedback/:alias1",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorPerformanceFeedback
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "performance-feedback/:alias1/:alias2",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorPerformanceFeedback
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "peer-feedback",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorPeerFeedback
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "peer-feedback/:alias1",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorPeerFeedback
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "peer-feedback/:alias1/:alias2",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorPeerFeedback
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "peer-review",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorTeamEvaluation
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "teams-roles",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorTeamsRoles
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "final-scores",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorFinalScores
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "rounds",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorRoundAdmin
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "grading",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorGrading
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "grading/:alias1",
	        onEnter: logRequestWrapper,
	        component: _routes.InstructorGrading
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Redirect, { path: "team-reports", to: "analysis/team-reports" }),
	    _react2.default.createElement(_reactRouter.Route, { path: "decisions", onEnter: logRequestWrapper, component: _routes.Decisions }),
	    _react2.default.createElement(_reactRouter.Route, { path: "decisions/ceo", onEnter: logRequestWrapper, component: _routes.CeoDecisions }),
	    _react2.default.createElement(_reactRouter.Route, { path: "decisions/product-development", onEnter: logRequestWrapper, component: _routes.PDDecisions }),
	    _react2.default.createElement(_reactRouter.Route, { path: "decisions/product-marketing", onEnter: logRequestWrapper, component: _routes.PMDecisions }),
	    _react2.default.createElement(_reactRouter.Route, { path: "decisions/operations", onEnter: logRequestWrapper, component: _routes.OperationsDecisions }),
	    _react2.default.createElement(_reactRouter.Route, { path: "decisions/finance", onEnter: logRequestWrapper, component: _routes.FinanceDecisions }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "peer-review",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.PeerReview
	    }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: "ceo", onEnter: redirectToLoginWrapper },
	      _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "audit-trail",
	        onEnter: logRequestWrapper,
	        component: _routes.AuditTrail
	      }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "analysis", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "market",
	          onEnter: logRequestWrapper,
	          component: _routes.MarketAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "financial",
	          onEnter: logRequestWrapper,
	          component: _routes.FinancialAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "economic",
	          onEnter: logRequestWrapper,
	          component: _routes.EconomicAnalysis
	        })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "results", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Results }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: "FinancialAnalysis",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatements
	          },
	          _react2.default.createElement(_reactRouter.IndexRoute, {
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsIncomeStatement
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "IncomeStatement",
	            component: _routes.FNAnalysisFNStatementsIncomeStatement,
	            onEnter: logRequestWrapper
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "CashFlow",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsCashFlow
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "BalanceSheet",
	            component: _routes.FNAnalysisFNStatementsBalanceSheet,
	            onEnter: logRequestWrapper
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "ValuationsResults",
	          onEnter: logRequestWrapper,
	          component: _routes.Results
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: "pd", onEnter: redirectToLoginWrapper },
	      _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "audit-trail",
	        onEnter: logRequestWrapper,
	        component: _routes.AuditTrail
	      }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "analysis", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "market",
	          onEnter: logRequestWrapper,
	          component: _routes.MarketAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "financial",
	          onEnter: logRequestWrapper,
	          component: _routes.FinancialAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "economic",
	          onEnter: logRequestWrapper,
	          component: _routes.EconomicAnalysis
	        })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "results", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Results }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: "FinancialAnalysis",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatements
	          },
	          _react2.default.createElement(_reactRouter.IndexRoute, {
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsIncomeStatement
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "IncomeStatement",
	            component: _routes.FNAnalysisFNStatementsIncomeStatement,
	            onEnter: logRequestWrapper
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "CashFlow",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsCashFlow
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "BalanceSheet",
	            component: _routes.FNAnalysisFNStatementsBalanceSheet,
	            onEnter: logRequestWrapper
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "ValuationsResults",
	          onEnter: logRequestWrapper,
	          component: _routes.Results
	        })
	      ),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "knowledge-base",
	        onEnter: logRequestWrapper,
	        component: _routes.KnowledgeBase
	      })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: "pm", onEnter: redirectToLoginWrapper },
	      _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "audit-trail",
	        onEnter: logRequestWrapper,
	        component: _routes.AuditTrail
	      }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "analysis", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "market",
	          onEnter: logRequestWrapper,
	          component: _routes.MarketAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "financial",
	          onEnter: logRequestWrapper,
	          component: _routes.FinancialAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "economic",
	          onEnter: logRequestWrapper,
	          component: _routes.EconomicAnalysis
	        })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "results", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Results }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: "FinancialAnalysis",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatements
	          },
	          _react2.default.createElement(_reactRouter.IndexRoute, {
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsIncomeStatement
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "IncomeStatement",
	            component: _routes.FNAnalysisFNStatementsIncomeStatement,
	            onEnter: logRequestWrapper
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "CashFlow",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsCashFlow
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "BalanceSheet",
	            component: _routes.FNAnalysisFNStatementsBalanceSheet,
	            onEnter: logRequestWrapper
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "ValuationsResults",
	          onEnter: logRequestWrapper,
	          component: _routes.Results
	        })
	      ),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "knowledge-base",
	        onEnter: logRequestWrapper,
	        component: _routes.KnowledgeBase
	      })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: "op", onEnter: redirectToLoginWrapper },
	      _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "audit-trail",
	        onEnter: logRequestWrapper,
	        component: _routes.AuditTrail
	      }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "analysis", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "market",
	          onEnter: logRequestWrapper,
	          component: _routes.MarketAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "financial",
	          onEnter: logRequestWrapper,
	          component: _routes.FinancialAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "economic",
	          onEnter: logRequestWrapper,
	          component: _routes.EconomicAnalysis
	        })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "results", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Results }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: "FinancialAnalysis",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatements
	          },
	          _react2.default.createElement(_reactRouter.IndexRoute, {
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsIncomeStatement
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "IncomeStatement",
	            component: _routes.FNAnalysisFNStatementsIncomeStatement,
	            onEnter: logRequestWrapper
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "CashFlow",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsCashFlow
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "BalanceSheet",
	            component: _routes.FNAnalysisFNStatementsBalanceSheet,
	            onEnter: logRequestWrapper
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "ValuationsResults",
	          onEnter: logRequestWrapper,
	          component: _routes.Results
	        })
	      ),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "knowledge-base",
	        onEnter: logRequestWrapper,
	        component: _routes.KnowledgeBase
	      })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: "fn", onEnter: redirectToLoginWrapper },
	      _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "audit-trail",
	        onEnter: logRequestWrapper,
	        component: _routes.AuditTrail
	      }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "analysis", onEnter: logRequestWrapper },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Analysis }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "market",
	          onEnter: logRequestWrapper,
	          component: _routes.MarketAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "financial",
	          onEnter: logRequestWrapper,
	          component: _routes.FinancialAnalysis
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "economic",
	          onEnter: logRequestWrapper,
	          component: _routes.EconomicAnalysis
	        })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: "results" },
	        _react2.default.createElement(_reactRouter.IndexRoute, { onEnter: logRequestWrapper, component: _routes.Results }),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          {
	            path: "FinancialAnalysis",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatements
	          },
	          _react2.default.createElement(_reactRouter.IndexRoute, {
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsIncomeStatement
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "IncomeStatement",
	            component: _routes.FNAnalysisFNStatementsIncomeStatement,
	            onEnter: logRequestWrapper
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "CashFlow",
	            onEnter: logRequestWrapper,
	            component: _routes.FNAnalysisFNStatementsCashFlow
	          }),
	          _react2.default.createElement(_reactRouter.Route, {
	            path: "BalanceSheet",
	            component: _routes.FNAnalysisFNStatementsBalanceSheet,
	            onEnter: logRequestWrapper
	          })
	        ),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "competitive",
	          component: _routes.CompetitiveAnalysis,
	          onEnter: logRequestWrapper
	        }),
	        _react2.default.createElement(_reactRouter.Route, {
	          path: "ValuationsResults",
	          onEnter: logRequestWrapper,
	          component: _routes.Results
	        })
	      ),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: "knowledge-base",
	        onEnter: logRequestWrapper,
	        component: _routes.KnowledgeBase
	      })
	    ),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "dashboard",
	      onEnter: redirectToLoginWrapper,
	      component: _routes.Dashboard
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: "analysis/team-reports", component: _routes.Analysis }),
	    _react2.default.createElement(_reactRouter.Route, { path: "analysis/team-reports/:report1", component: _routes.Analysis }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: "analysis/team-reports/:report1/:report2",
	      component: _routes.Analysis
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: "analysis/bcase", component: _routes.BusinessCase }),
	    _react2.default.createElement(_reactRouter.Route, { path: "analysis/bcase/:part", component: _routes.BusinessCase }),
	    _react2.default.createElement(_reactRouter.Route, { path: "analysis/audit-trail", component: _routes.AuditTrail }),
	    _react2.default.createElement(_reactRouter.Redirect, { path: "analysis", to: "analysis/team-reports" }),
	    _react2.default.createElement(_reactRouter.Route, { path: "checkout/success", onEnter: redirectToLoginWrapper, component: function component() {
	        return _react2.default.createElement("div", null);
	      } }),
	    _react2.default.createElement(_reactRouter.Route, { path: "checkout/cancel", onEnter: redirectToLoginWrapper, component: function component() {
	        return _react2.default.createElement("div", null);
	      } }),
	    _react2.default.createElement(_reactRouter.Route, { path: "*", component: function component() {
	        return _react2.default.createElement(
	          "div",
	          null,
	          "Page not found"
	        );
	      } })
	  )
	);
	
	exports.default = Routes;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(569);
	
	Object.defineProperty(exports, "App", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_App).default;
	  }
	});
	
	var _page = __webpack_require__(1123);
	
	Object.defineProperty(exports, "AuditTrail", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_page).default;
	  }
	});
	
	var _promoCode = __webpack_require__(602);
	
	Object.defineProperty(exports, "PromoCodePage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_promoCode).default;
	  }
	});
	
	var _decisionsSummary = __webpack_require__(599);
	
	Object.defineProperty(exports, "DecisionsSummary", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_decisionsSummary).default;
	  }
	});
	
	var _decisions = __webpack_require__(1421);
	
	Object.defineProperty(exports, "Decisions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_decisions).default;
	  }
	});
	
	var _ceoDecisions = __webpack_require__(1419);
	
	Object.defineProperty(exports, "CeoDecisions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ceoDecisions).default;
	  }
	});
	
	var _PDDecisions = __webpack_require__(1415);
	
	Object.defineProperty(exports, "PDDecisions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PDDecisions).default;
	  }
	});
	
	var _PMDecisions = __webpack_require__(1416);
	
	Object.defineProperty(exports, "PMDecisions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PMDecisions).default;
	  }
	});
	
	var _operationsDecisions = __webpack_require__(1430);
	
	Object.defineProperty(exports, "OperationsDecisions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_operationsDecisions).default;
	  }
	});
	
	var _financeDecisions = __webpack_require__(1423);
	
	Object.defineProperty(exports, "FinanceDecisions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_financeDecisions).default;
	  }
	});
	
	var _Analysis = __webpack_require__(1078);
	
	Object.defineProperty(exports, "Analysis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Analysis).default;
	  }
	});
	
	var _BusinessCase = __webpack_require__(1166);
	
	Object.defineProperty(exports, "BusinessCase", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BusinessCase).default;
	  }
	});
	
	var _marketAnalysis = __webpack_require__(1426);
	
	Object.defineProperty(exports, "MarketAnalysis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_marketAnalysis).default;
	  }
	});
	
	var _competitiveAnalysis = __webpack_require__(1420);
	
	Object.defineProperty(exports, "CompetitiveAnalysis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_competitiveAnalysis).default;
	  }
	});
	
	var _economicAnalysis = __webpack_require__(1422);
	
	Object.defineProperty(exports, "EconomicAnalysis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_economicAnalysis).default;
	  }
	});
	
	var _financialAnalysis = __webpack_require__(1424);
	
	Object.defineProperty(exports, "FinancialAnalysis", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_financialAnalysis).default;
	  }
	});
	
	var _Results = __webpack_require__(1417);
	
	Object.defineProperty(exports, "Results", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Results).default;
	  }
	});
	
	var _KnowledgeBase = __webpack_require__(1414);
	
	Object.defineProperty(exports, "KnowledgeBase", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KnowledgeBase).default;
	  }
	});
	
	var _FNAnalysisFNStatements = __webpack_require__(1410);
	
	Object.defineProperty(exports, "FNAnalysisFNStatements", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FNAnalysisFNStatements).default;
	  }
	});
	
	var _FNAnalysisFNStatementsIncomeStatement = __webpack_require__(1413);
	
	Object.defineProperty(exports, "FNAnalysisFNStatementsIncomeStatement", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FNAnalysisFNStatementsIncomeStatement).default;
	  }
	});
	
	var _FNAnalysisFNStatementsCashFlow = __webpack_require__(1412);
	
	Object.defineProperty(exports, "FNAnalysisFNStatementsCashFlow", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FNAnalysisFNStatementsCashFlow).default;
	  }
	});
	
	var _FNAnalysisFNStatementsBalanceSheet = __webpack_require__(1411);
	
	Object.defineProperty(exports, "FNAnalysisFNStatementsBalanceSheet", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FNAnalysisFNStatementsBalanceSheet).default;
	  }
	});
	
	var _welcomePage = __webpack_require__(605);
	
	Object.defineProperty(exports, "WelcomePage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_welcomePage).default;
	  }
	});
	
	var _loginPage = __webpack_require__(601);
	
	Object.defineProperty(exports, "LoginPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loginPage).default;
	  }
	});
	
	var _introVideoPage = __webpack_require__(1425);
	
	Object.defineProperty(exports, "IntroVideoPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_introVideoPage).default;
	  }
	});
	
	var _registerPage = __webpack_require__(603);
	
	Object.defineProperty(exports, "RegisterPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_registerPage).default;
	  }
	});
	
	var _joinPage = __webpack_require__(600);
	
	Object.defineProperty(exports, "JoinPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_joinPage).default;
	  }
	});
	
	var _resetPasswordPage = __webpack_require__(604);
	
	Object.defineProperty(exports, "ResetPasswordPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_resetPasswordPage).default;
	  }
	});
	
	var _accountVerify = __webpack_require__(612);
	
	Object.defineProperty(exports, "AccountVerify", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accountVerify).default;
	  }
	});
	
	var _resetPassword = __webpack_require__(613);
	
	Object.defineProperty(exports, "ResetPassword", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_resetPassword).default;
	  }
	});
	
	var _teamReports = __webpack_require__(1431);
	
	Object.defineProperty(exports, "TeamReports", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_teamReports).default;
	  }
	});
	
	var _dashboard = __webpack_require__(1525);
	
	Object.defineProperty(exports, "InstructorDashboard", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dashboard).default;
	  }
	});
	
	var _courseManagement = __webpack_require__(1524);
	
	Object.defineProperty(exports, "InstructorCourseManagement", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_courseManagement).default;
	  }
	});
	
	var _gameManagement = __webpack_require__(1528);
	
	Object.defineProperty(exports, "InstructorGameManagement", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_gameManagement).default;
	  }
	});
	
	var _roundManagement = __webpack_require__(1535);
	
	Object.defineProperty(exports, "InstructorRoundManagement", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_roundManagement).default;
	  }
	});
	
	var _teamManagement = __webpack_require__(1537);
	
	Object.defineProperty(exports, "InstructorTeamManagement", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_teamManagement).default;
	  }
	});
	
	var _performanceFeedback = __webpack_require__(1533);
	
	Object.defineProperty(exports, "InstructorPerformanceFeedback", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_performanceFeedback).default;
	  }
	});
	
	var _peerFeedback = __webpack_require__(1532);
	
	Object.defineProperty(exports, "InstructorPeerFeedback", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_peerFeedback).default;
	  }
	});
	
	var _teamEvaluation = __webpack_require__(1536);
	
	Object.defineProperty(exports, "InstructorTeamEvaluation", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_teamEvaluation).default;
	  }
	});
	
	var _teamsRoles = __webpack_require__(1538);
	
	Object.defineProperty(exports, "InstructorTeamsRoles", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_teamsRoles).default;
	  }
	});
	
	var _finalScores = __webpack_require__(1527);
	
	Object.defineProperty(exports, "InstructorFinalScores", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_finalScores).default;
	  }
	});
	
	var _roundAdmin = __webpack_require__(1534);
	
	Object.defineProperty(exports, "InstructorRoundAdmin", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_roundAdmin).default;
	  }
	});
	
	var _welcome = __webpack_require__(1539);
	
	Object.defineProperty(exports, "InstructorWelcomePage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_welcome).default;
	  }
	});
	
	var _onboarding = __webpack_require__(1531);
	
	Object.defineProperty(exports, "InstructorOnboardingPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_onboarding).default;
	  }
	});
	
	var _demo = __webpack_require__(1526);
	
	Object.defineProperty(exports, "InstructorDemoPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_demo).default;
	  }
	});
	
	var _goalsAndTargets = __webpack_require__(1529);
	
	Object.defineProperty(exports, "InstructorGoalsAndTargets", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_goalsAndTargets).default;
	  }
	});
	
	var _grading = __webpack_require__(1530);
	
	Object.defineProperty(exports, "InstructorGrading", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_grading).default;
	  }
	});
	
	var _Dashboard = __webpack_require__(1168);
	
	Object.defineProperty(exports, "Dashboard", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dashboard).default;
	  }
	});
	
	var _page2 = __webpack_require__(1198);
	
	Object.defineProperty(exports, "GetStarted", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_page2).default;
	  }
	});
	
	var _profile = __webpack_require__(1344);
	
	Object.defineProperty(exports, "MyProfilePage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_profile).default;
	  }
	});
	
	var _OnboardingPage = __webpack_require__(1217);
	
	Object.defineProperty(exports, "OnboardingPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OnboardingPage).default;
	  }
	});
	
	var _RoundTriviaPage = __webpack_require__(1218);
	
	Object.defineProperty(exports, "RoundTriviaPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RoundTriviaPage).default;
	  }
	});
	
	var _index = __webpack_require__(1294);
	
	Object.defineProperty(exports, "PerformanceFeedback", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index).default;
	  }
	});
	
	var _index2 = __webpack_require__(1199);
	
	Object.defineProperty(exports, "GoalsAndTargets", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index2).default;
	  }
	});
	
	var _index3 = __webpack_require__(1262);
	
	Object.defineProperty(exports, "PeerFeedback", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index3).default;
	  }
	});
	
	var _index4 = __webpack_require__(1285);
	
	Object.defineProperty(exports, "PeerReview", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_index4).default;
	  }
	});
	
	var _start = __webpack_require__(1209);
	
	Object.defineProperty(exports, "StartPage", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_start).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApiService = __webpack_require__(4);
	
	var _tracksCache = __webpack_require__(263);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnalyticsSend = function (_Component) {
	  _inherits(AnalyticsSend, _Component);
	
	  function AnalyticsSend(props) {
	    _classCallCheck(this, AnalyticsSend);
	
	    var _this = _possibleConstructorReturn(this, (AnalyticsSend.__proto__ || Object.getPrototypeOf(AnalyticsSend)).call(this, props));
	
	    _this.clearTimer = function () {
	      if (_this.timer) {
	        clearTimeout(_this.timer);
	        _this.timer = null;
	      }
	    };
	
	    _this.setTimer = function () {
	      _this.timer = setTimeout(_this.sendEvent, 5000); // 5 seconds
	    };
	
	    _this.setEvent = function (round_number, url, user_id, game_id, course_id, pathname) {
	      if (_this.event) {
	        _this.clearTimer();
	        _this.event = null;
	      }
	
	      _this.event = {
	        round_number: round_number,
	        url: url,
	        user_id: user_id,
	        game_id: game_id,
	        course_id: course_id,
	        pathname: pathname
	      };
	      _this.setTimer();
	    };
	
	    _this.sendEvent = function () {
	      if (_this.event) {
	        var oneTimeTrackPage = false;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this.oneTimeTrackPages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var pattern = _step.value;
	
	            if (_this.event.pathname.startsWith(pattern) === true) {
	              oneTimeTrackPage = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (oneTimeTrackPage === true) {
	          var gameId = Number(_this.event.game_id);
	          var courseId = Number(_this.event.course_id);
	          var userId = Number(_this.event.user_id);
	          var roundNumber = Number(_this.event.round_number);
	
	          // Shared cache: any other caller (App.js, NextSteps) that
	          // fetched this same tuple within TTL will hand us back the
	          // same promise instead of issuing a new network request.
	          (0, _tracksCache.fetchTracks)({ gameId: gameId, courseId: courseId, userId: userId, roundNumber: roundNumber }).then(function (data) {
	            return data.body.results;
	          }).then(function (pages) {
	            var url = _this.event.url.split('?')[0];
	            var isTracked = pages.find(function (i) {
	              return i.page === url;
	            });
	
	            if (!isTracked) {
	              (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/engagement/tracks/").send({
	                page: url,
	                user: _this.event.user_id,
	                course: _this.event.course_id,
	                game: _this.event.game_id,
	                round_number: _this.event.round_number
	              }).then(function (data) {
	                // We just added a tracks entry — drop the cache so
	                // the next reader sees it.
	                (0, _tracksCache.invalidateTracks)();
	                _this.event = null;
	              });
	            } else {
	              _this.event = null;
	            }
	          });
	        } else {
	          var url = _this.event.url.split('?')[0];
	          (0, _ApiService.postRequest)(("https://be-production-itb.marketgames.io/api/") + "v2/engagement/tracks/").send({
	            page: url,
	            user: _this.event.user_id,
	            course: _this.event.course_id,
	            game: _this.event.game_id,
	            round_number: _this.event.round_number
	          }).then(function (data) {
	            (0, _tracksCache.invalidateTracks)();
	            _this.event = null;
	          });
	        }
	      }
	    };
	
	    _this.timer = null;
	    _this.event = null;
	    _this.eventEmitter = _eventEmitter2.default.getInstance();
	    _this.oneTimeTrackPages = ['/analysis/team-reports', '/analysis/bcase', '/ceo/analysis/market', '/pd/analysis/market', '/pm/analysis/market', '/op/analysis/market', '/fn/analysis/market'];
	    return _this;
	  }
	
	  _createClass(AnalyticsSend, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.eventEmitter.on("analytics-event", this.setEvent);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearTimer();
	      this.event = null;
	      this.eventEmitter.off("analytics-event", this.setEvent);
	    }
	  }]);
	
	  return AnalyticsSend;
	}(_react.Component);
	
	exports.default = AnalyticsSend;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Auth = __webpack_require__(6);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _get = __webpack_require__(133);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _eventEmitter = __webpack_require__(22);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Analytics = function () {
	  function Analytics() {
	    _classCallCheck(this, Analytics);
	  }
	
	  _createClass(Analytics, null, [{
	    key: "event",
	    value: function event(round_number, window, pathname) {
	      var url = (0, _get2.default)(window, 'location.href', null);
	      if (url && _Auth2.default.getPosition() === "Student") {
	        var eventEmitter = _eventEmitter2.default.getInstance();
	        eventEmitter.trigger("analytics-event", [round_number, url, _Auth2.default.getUserId(), _Auth2.default.getGameId(), _Auth2.default.getCourseId(), pathname]);
	      }
	    }
	  }]);
	
	  return Analytics;
	}();
	
	exports.default = Analytics;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(1823);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _App3 = __webpack_require__(2559);
	
	var _App4 = _interopRequireDefault(_App3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exportedFile =  true ? _App2.default : _App4.default;
	exports.default = exportedFile;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1803);
	
	__webpack_require__(1046);
	
	__webpack_require__(1562);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1563), __esModule: true };

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1565), __esModule: true };

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1567), __esModule: true };

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1569), __esModule: true };

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1570), __esModule: true };

/***/ },
/* 1556 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(567)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ },
/* 1558 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.4
	 * https://www.chartjs.org
	 * (c) 2020 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(5); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	function isValidKey(key) {
		return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
	}
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = Object.create(source);
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge(Object.create(null), [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
			return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || Object.create(null);
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || Object.create(null);
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var widestLabelSize = 0;
		var highestLabelSize = 0;
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
			widestLabelSize = Math.max(width, widestLabelSize);
			highestLabelSize = Math.max(height, highestLabelSize);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(widestLabelSize);
		highest = heights.indexOf(highestLabelSize);
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var classNames = (function () {
			// don't inherit from Object so we can skip hasOwnProperty check later
			// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
			function StorageObject() {}
			StorageObject.prototype = Object.create(null);
	
			function _parseArray (resultSet, array) {
				var length = array.length;
	
				for (var i = 0; i < length; ++i) {
					_parse(resultSet, array[i]);
				}
			}
	
			var hasOwn = {}.hasOwnProperty;
	
			function _parseNumber (resultSet, num) {
				resultSet[num] = true;
			}
	
			function _parseObject (resultSet, object) {
				if (object.toString !== Object.prototype.toString && !object.toString.toString().includes('[native code]')) {
					resultSet[object.toString()] = true;
					return;
				}
	
				for (var k in object) {
					if (hasOwn.call(object, k)) {
						// set value to false instead of deleting it to avoid changing object structure
						// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
						resultSet[k] = !!object[k];
					}
				}
			}
	
			var SPACE = /\s+/;
			function _parseString (resultSet, str) {
				var array = str.split(SPACE);
				var length = array.length;
	
				for (var i = 0; i < length; ++i) {
					resultSet[array[i]] = true;
				}
			}
	
			function _parse (resultSet, arg) {
				if (!arg) return;
				var argType = typeof arg;
	
				// 'foo bar'
				if (argType === 'string') {
					_parseString(resultSet, arg);
	
				// ['foo', 'bar', ...]
				} else if (Array.isArray(arg)) {
					_parseArray(resultSet, arg);
	
				// { 'foo': true, ... }
				} else if (argType === 'object') {
					_parseObject(resultSet, arg);
	
				// '130'
				} else if (argType === 'number') {
					_parseNumber(resultSet, arg);
				}
			}
	
			function _classNames () {
				// don't leak arguments
				// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
				var len = arguments.length;
				var args = Array(len);
				for (var i = 0; i < len; i++) {
					args[i] = arguments[i];
				}
	
				var classSet = new StorageObject();
				_parseArray(classSet, args);
	
				var list = [];
	
				for (var k in classSet) {
					if (classSet[k]) {
						list.push(k)
					}
				}
	
				return list.join(' ');
			}
	
			return _classNames;
		})();
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1611);
	module.exports = __webpack_require__(117).RegExp.escape;


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(627);
	__webpack_require__(1593);
	module.exports = __webpack_require__(115).Array.from;


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1595);
	module.exports = __webpack_require__(115).Object.assign;


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1596);
	var $Object = __webpack_require__(115).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1600);
	module.exports = __webpack_require__(115).Object.entries;


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1597);
	module.exports = __webpack_require__(115).Object.setPrototypeOf;


/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1601);
	module.exports = __webpack_require__(115).Object.values;


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1599);
	__webpack_require__(1598);
	__webpack_require__(1602);
	__webpack_require__(1603);
	module.exports = __webpack_require__(115).Symbol;


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(627);
	__webpack_require__(1604);
	module.exports = __webpack_require__(424).f('iterator');


/***/ },
/* 1571 */
86,
/* 1572 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1573 */
[2688, 186, 626, 1591],
/* 1574 */
[2689, 412, 127],
/* 1575 */
[2690, 185, 268],
/* 1576 */
[2694, 266, 417, 267],
/* 1577 */
[2696, 160],
/* 1578 */
[2699, 265, 127],
/* 1579 */
[2700, 412],
/* 1580 */
[2701, 219],
/* 1581 */
[2702, 416, 268, 418, 220, 127],
/* 1582 */
[2704, 127],
/* 1583 */
641,
/* 1584 */
[2705, 313, 221, 184, 185, 264],
/* 1585 */
[2706, 158, 266, 417, 267, 312, 619, 264],
/* 1586 */
[2709, 185, 219, 266, 158],
/* 1587 */
[2711, 186, 622],
/* 1588 */
[2713, 184, 312, 419],
/* 1589 */
[2717, 221, 219, 413, 621],
/* 1590 */
[2721, 421, 414],
/* 1591 */
[2722, 421],
/* 1592 */
[2730, 1574, 127, 265, 115],
/* 1593 */
[2731, 413, 159, 312, 1580, 1578, 626, 1575, 1592, 1582],
/* 1594 */
[2732, 1572, 1583, 265, 186, 620],
/* 1595 */
[2733, 159, 1585],
/* 1596 */
[2734, 159, 416],
/* 1597 */
[2735, 159, 1589],
/* 1598 */
/***/ function(module, exports) {



/***/ },
/* 1599 */
[2737, 160, 184, 158, 159, 625, 1584, 264, 420, 418, 313, 127, 424, 423, 1576, 1579, 219, 221, 312, 186, 422, 268, 416, 1587, 621, 417, 185, 266, 622, 267, 311, 220],
/* 1600 */
[2738, 159, 624],
/* 1601 */
[2739, 159, 624],
/* 1602 */
[2740, 423],
/* 1603 */
[2741, 423],
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1594);
	var global = __webpack_require__(160);
	var hide = __webpack_require__(220);
	var Iterators = __webpack_require__(265);
	var TO_STRING_TAG = __webpack_require__(127)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33);
	var isArray = __webpack_require__(317);
	var SPECIES = __webpack_require__(44)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(31);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(131);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1608 */
[2694, 191, 321, 271],
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(272)('native-function-to-string', Function.toString);


/***/ },
/* 1610 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(1610)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(629) });
	
	__webpack_require__(161)('copyWithin');


/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $every = __webpack_require__(128)(4);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { fill: __webpack_require__(426) });
	
	__webpack_require__(161)('fill');


/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $filter = __webpack_require__(128)(2);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(128)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(161)(KEY);


/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(128)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(161)(KEY);


/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $forEach = __webpack_require__(128)(0);
	var STRICT = __webpack_require__(119)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1619 */
[2731, 118, 8, 64, 640, 434, 48, 428, 450, 319],
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $indexOf = __webpack_require__(314)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(119)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(317) });


/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(107);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(270) != Object || !__webpack_require__(119)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(107);
	var toInteger = __webpack_require__(120);
	var toLength = __webpack_require__(48);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(119)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $map = __webpack_require__(128)(1);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var createProperty = __webpack_require__(428);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(31)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(631);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(631);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var html = __webpack_require__(432);
	var cof = __webpack_require__(116);
	var toAbsoluteIndex = __webpack_require__(195);
	var toLength = __webpack_require__(48);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(31)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $some = __webpack_require__(128)(3);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(86);
	var toObject = __webpack_require__(64);
	var fails = __webpack_require__(31);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(119)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(194)('Array');


/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8);
	var toISOString = __webpack_require__(1606);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(64);
	var toPrimitive = __webpack_require__(131);
	
	$export($export.P + $export.F * __webpack_require__(31)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(44)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(96)(proto, TO_PRIMITIVE, __webpack_require__(1607));


/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(97)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', { bind: __webpack_require__(632) });


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(33);
	var getPrototypeOf = __webpack_require__(106);
	var HAS_INSTANCE = __webpack_require__(44)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(57).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(57).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(51) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8);
	var log1p = __webpack_require__(643);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8);
	var sign = __webpack_require__(438);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	var $expm1 = __webpack_require__(437);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { fround: __webpack_require__(642) });


/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(31)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(643) });


/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { sign: __webpack_require__(438) });


/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(437);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(31)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(437);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(30);
	var has = __webpack_require__(104);
	var cof = __webpack_require__(116);
	var inheritIfRequired = __webpack_require__(433);
	var toPrimitive = __webpack_require__(131);
	var fails = __webpack_require__(31);
	var gOPN = __webpack_require__(190).f;
	var gOPD = __webpack_require__(105).f;
	var dP = __webpack_require__(57).f;
	var $trim = __webpack_require__(225).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(189)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(51) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(97)(global, NUMBER, $Number);
	}


/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(8);
	var _isFinite = __webpack_require__(30).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(639) });


/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(8);
	var isInteger = __webpack_require__(639);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(651);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(652);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toInteger = __webpack_require__(120);
	var aNumberValue = __webpack_require__(628);
	var repeat = __webpack_require__(445);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(31)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $fails = __webpack_require__(31);
	var aNumberValue = __webpack_require__(628);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 1669 */
[2733, 8, 645],
/* 1670 */
[2734, 8, 189],
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperties: __webpack_require__(646) });


/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperty: __webpack_require__(57).f });


/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(33);
	var meta = __webpack_require__(163).onFreeze;
	
	__webpack_require__(130)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(107);
	var $getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	__webpack_require__(130)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(130)('getOwnPropertyNames', function () {
	  return __webpack_require__(647).f;
	});


/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(64);
	var $getPrototypeOf = __webpack_require__(106);
	
	__webpack_require__(130)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(33);
	
	__webpack_require__(130)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(33);
	
	__webpack_require__(130)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(33);
	
	__webpack_require__(130)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { is: __webpack_require__(655) });


/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(64);
	var $keys = __webpack_require__(191);
	
	__webpack_require__(130)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(33);
	var meta = __webpack_require__(163).onFreeze;
	
	__webpack_require__(130)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(33);
	var meta = __webpack_require__(163).onFreeze;
	
	__webpack_require__(130)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 1684 */
[2735, 8, 442],
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(222);
	var test = {};
	test[__webpack_require__(44)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(97)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(651);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(652);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(162);
	var global = __webpack_require__(30);
	var ctx = __webpack_require__(118);
	var classof = __webpack_require__(222);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(33);
	var aFunction = __webpack_require__(86);
	var anInstance = __webpack_require__(187);
	var forOf = __webpack_require__(188);
	var speciesConstructor = __webpack_require__(273);
	var task = __webpack_require__(447).set;
	var microtask = __webpack_require__(439)();
	var newPromiseCapabilityModule = __webpack_require__(440);
	var perform = __webpack_require__(653);
	var userAgent = __webpack_require__(327);
	var promiseResolve = __webpack_require__(654);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(44)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(193)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(224)($Promise, PROMISE);
	__webpack_require__(194)(PROMISE);
	Wrapper = __webpack_require__(117)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(319)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(86);
	var anObject = __webpack_require__(26);
	var rApply = (__webpack_require__(30).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(31)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(8);
	var create = __webpack_require__(189);
	var aFunction = __webpack_require__(86);
	var anObject = __webpack_require__(26);
	var isObject = __webpack_require__(33);
	var fails = __webpack_require__(31);
	var bind = __webpack_require__(632);
	var rConstruct = (__webpack_require__(30).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(57);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(26);
	var toPrimitive = __webpack_require__(131);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(31)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(8);
	var gOPD = __webpack_require__(105).f;
	var anObject = __webpack_require__(26);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(26);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(435)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(105);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(26);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(8);
	var getProto = __webpack_require__(106);
	var anObject = __webpack_require__(26);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(105);
	var getPrototypeOf = __webpack_require__(106);
	var has = __webpack_require__(104);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(33);
	var anObject = __webpack_require__(26);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(26);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(650) });


/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(26);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(8);
	var setProto = __webpack_require__(442);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(57);
	var gOPD = __webpack_require__(105);
	var getPrototypeOf = __webpack_require__(106);
	var has = __webpack_require__(104);
	var $export = __webpack_require__(8);
	var createDesc = __webpack_require__(192);
	var anObject = __webpack_require__(26);
	var isObject = __webpack_require__(33);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(30);
	var inheritIfRequired = __webpack_require__(433);
	var dP = __webpack_require__(57).f;
	var gOPN = __webpack_require__(190).f;
	var isRegExp = __webpack_require__(318);
	var $flags = __webpack_require__(269);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(51) && (!CORRECT_NEW || __webpack_require__(31)(function () {
	  re2[__webpack_require__(44)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(97)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(194)('RegExp');


/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(26);
	var toLength = __webpack_require__(48);
	var advanceStringIndex = __webpack_require__(425);
	var regExpExec = __webpack_require__(322);
	
	// @@match logic
	__webpack_require__(316)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(26);
	var toObject = __webpack_require__(64);
	var toLength = __webpack_require__(48);
	var toInteger = __webpack_require__(120);
	var advanceStringIndex = __webpack_require__(425);
	var regExpExec = __webpack_require__(322);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(316)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(26);
	var sameValue = __webpack_require__(655);
	var regExpExec = __webpack_require__(322);
	
	// @@search logic
	__webpack_require__(316)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(318);
	var anObject = __webpack_require__(26);
	var speciesConstructor = __webpack_require__(273);
	var advanceStringIndex = __webpack_require__(425);
	var toLength = __webpack_require__(48);
	var callRegExpExec = __webpack_require__(322);
	var regexpExec = __webpack_require__(441);
	var fails = __webpack_require__(31);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(316)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(661);
	var anObject = __webpack_require__(26);
	var $flags = __webpack_require__(269);
	var DESCRIPTORS = __webpack_require__(51);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(97)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(31)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(98)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(98)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(98)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(98)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(325)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(48);
	var context = __webpack_require__(444);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(431)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(98)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(98)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(98)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(195);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(8);
	var context = __webpack_require__(444);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(431)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(98)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 1721 */
[2736, 325, 436],
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(98)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(107);
	var toLength = __webpack_require__(48);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(445)
	});


/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(98)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(48);
	var context = __webpack_require__(444);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(431)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(98)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(98)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(98)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(225)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 1731 */
[2737, 30, 104, 51, 8, 97, 163, 31, 272, 224, 196, 44, 658, 449, 1608, 317, 26, 33, 64, 107, 131, 192, 189, 647, 105, 321, 57, 191, 190, 271, 162, 96],
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $typed = __webpack_require__(326);
	var buffer = __webpack_require__(448);
	var anObject = __webpack_require__(26);
	var toAbsoluteIndex = __webpack_require__(195);
	var toLength = __webpack_require__(48);
	var isObject = __webpack_require__(33);
	var ArrayBuffer = __webpack_require__(30).ArrayBuffer;
	var speciesConstructor = __webpack_require__(273);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(31)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(194)(ARRAY_BUFFER);


/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(326).ABV, {
	  DataView: __webpack_require__(448).DataView
	});


/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(635);
	var validate = __webpack_require__(197);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(315)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(636);
	var toObject = __webpack_require__(64);
	var toLength = __webpack_require__(48);
	var aFunction = __webpack_require__(86);
	var arraySpeciesCreate = __webpack_require__(427);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(161)('flatMap');


/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(636);
	var toObject = __webpack_require__(64);
	var toLength = __webpack_require__(48);
	var toInteger = __webpack_require__(120);
	var arraySpeciesCreate = __webpack_require__(427);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(161)('flatten');


/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(8);
	var $includes = __webpack_require__(314)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(161)('includes');


/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(8);
	var microtask = __webpack_require__(439)();
	var process = __webpack_require__(30).process;
	var isNode = __webpack_require__(116)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8);
	var cof = __webpack_require__(116);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.G, { global: __webpack_require__(30) });


/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(323)('Map');


/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(324)('Map');


/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(634)('Map') });


/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var scale = __webpack_require__(644);
	var fround = __webpack_require__(642);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { scale: __webpack_require__(644) });


/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(64);
	var aFunction = __webpack_require__(86);
	var $defineProperty = __webpack_require__(57);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(51) && $export($export.P + __webpack_require__(320), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(64);
	var aFunction = __webpack_require__(86);
	var $defineProperty = __webpack_require__(57);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(51) && $export($export.P + __webpack_require__(320), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1767 */
[2738, 8, 649],
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(8);
	var ownKeys = __webpack_require__(650);
	var toIObject = __webpack_require__(107);
	var gOPD = __webpack_require__(105);
	var createProperty = __webpack_require__(428);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(64);
	var toPrimitive = __webpack_require__(131);
	var getPrototypeOf = __webpack_require__(106);
	var getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(51) && $export($export.P + __webpack_require__(320), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(64);
	var toPrimitive = __webpack_require__(131);
	var getPrototypeOf = __webpack_require__(106);
	var getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(51) && $export($export.P + __webpack_require__(320), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1771 */
[2739, 8, 649],
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(8);
	var global = __webpack_require__(30);
	var core = __webpack_require__(117);
	var microtask = __webpack_require__(439)();
	var OBSERVABLE = __webpack_require__(44)('observable');
	var aFunction = __webpack_require__(86);
	var anObject = __webpack_require__(26);
	var anInstance = __webpack_require__(187);
	var redefineAll = __webpack_require__(193);
	var hide = __webpack_require__(96);
	var forOf = __webpack_require__(188);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(194)('Observable');


/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(8);
	var core = __webpack_require__(117);
	var global = __webpack_require__(30);
	var speciesConstructor = __webpack_require__(273);
	var promiseResolve = __webpack_require__(654);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(440);
	var perform = __webpack_require__(653);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(662);
	var from = __webpack_require__(630);
	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(106);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(106);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(106);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(140);
	var anObject = __webpack_require__(26);
	var aFunction = __webpack_require__(86);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(323)('Set');


/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(324)('Set');


/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(634)('Set') });


/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(325)(true);
	var $fails = __webpack_require__(31);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(8);
	var defined = __webpack_require__(129);
	var toLength = __webpack_require__(48);
	var isRegExp = __webpack_require__(318);
	var getFlags = __webpack_require__(269);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(435)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(656);
	var userAgent = __webpack_require__(327);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(656);
	var userAgent = __webpack_require__(327);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(225)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(225)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1793 */
[2740, 449],
/* 1794 */
[2741, 449],
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', { global: __webpack_require__(30) });


/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(323)('WeakMap');


/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(324)('WeakMap');


/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(323)('WeakSet');


/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(324)('WeakSet');


/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(451);
	var getKeys = __webpack_require__(191);
	var redefine = __webpack_require__(97);
	var global = __webpack_require__(30);
	var hide = __webpack_require__(96);
	var Iterators = __webpack_require__(223);
	var wks = __webpack_require__(44);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $task = __webpack_require__(447);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(30);
	var $export = __webpack_require__(8);
	var userAgent = __webpack_require__(327);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1731);
	__webpack_require__(1670);
	__webpack_require__(1672);
	__webpack_require__(1671);
	__webpack_require__(1674);
	__webpack_require__(1676);
	__webpack_require__(1681);
	__webpack_require__(1675);
	__webpack_require__(1673);
	__webpack_require__(1683);
	__webpack_require__(1682);
	__webpack_require__(1678);
	__webpack_require__(1679);
	__webpack_require__(1677);
	__webpack_require__(1669);
	__webpack_require__(1680);
	__webpack_require__(1684);
	__webpack_require__(1685);
	__webpack_require__(1637);
	__webpack_require__(1639);
	__webpack_require__(1638);
	__webpack_require__(1687);
	__webpack_require__(1686);
	__webpack_require__(1657);
	__webpack_require__(1667);
	__webpack_require__(1668);
	__webpack_require__(1658);
	__webpack_require__(1659);
	__webpack_require__(1660);
	__webpack_require__(1661);
	__webpack_require__(1662);
	__webpack_require__(1663);
	__webpack_require__(1664);
	__webpack_require__(1665);
	__webpack_require__(1666);
	__webpack_require__(1640);
	__webpack_require__(1641);
	__webpack_require__(1642);
	__webpack_require__(1643);
	__webpack_require__(1644);
	__webpack_require__(1645);
	__webpack_require__(1646);
	__webpack_require__(1647);
	__webpack_require__(1648);
	__webpack_require__(1649);
	__webpack_require__(1650);
	__webpack_require__(1651);
	__webpack_require__(1652);
	__webpack_require__(1653);
	__webpack_require__(1654);
	__webpack_require__(1655);
	__webpack_require__(1656);
	__webpack_require__(1718);
	__webpack_require__(1723);
	__webpack_require__(1730);
	__webpack_require__(1721);
	__webpack_require__(1713);
	__webpack_require__(1714);
	__webpack_require__(1719);
	__webpack_require__(1724);
	__webpack_require__(1726);
	__webpack_require__(1709);
	__webpack_require__(1710);
	__webpack_require__(1711);
	__webpack_require__(1712);
	__webpack_require__(1715);
	__webpack_require__(1716);
	__webpack_require__(1717);
	__webpack_require__(1720);
	__webpack_require__(1722);
	__webpack_require__(1725);
	__webpack_require__(1727);
	__webpack_require__(1728);
	__webpack_require__(1729);
	__webpack_require__(1632);
	__webpack_require__(1634);
	__webpack_require__(1633);
	__webpack_require__(1636);
	__webpack_require__(1635);
	__webpack_require__(1621);
	__webpack_require__(1619);
	__webpack_require__(1625);
	__webpack_require__(1622);
	__webpack_require__(1628);
	__webpack_require__(1630);
	__webpack_require__(1618);
	__webpack_require__(1624);
	__webpack_require__(1615);
	__webpack_require__(1629);
	__webpack_require__(1613);
	__webpack_require__(1627);
	__webpack_require__(1626);
	__webpack_require__(1620);
	__webpack_require__(1623);
	__webpack_require__(1612);
	__webpack_require__(1614);
	__webpack_require__(1617);
	__webpack_require__(1616);
	__webpack_require__(1631);
	__webpack_require__(451);
	__webpack_require__(1703);
	__webpack_require__(660);
	__webpack_require__(1708);
	__webpack_require__(661);
	__webpack_require__(1704);
	__webpack_require__(1705);
	__webpack_require__(1706);
	__webpack_require__(1707);
	__webpack_require__(1688);
	__webpack_require__(659);
	__webpack_require__(662);
	__webpack_require__(663);
	__webpack_require__(1743);
	__webpack_require__(1732);
	__webpack_require__(1733);
	__webpack_require__(1738);
	__webpack_require__(1741);
	__webpack_require__(1742);
	__webpack_require__(1736);
	__webpack_require__(1739);
	__webpack_require__(1737);
	__webpack_require__(1740);
	__webpack_require__(1734);
	__webpack_require__(1735);
	__webpack_require__(1689);
	__webpack_require__(1690);
	__webpack_require__(1691);
	__webpack_require__(1692);
	__webpack_require__(1693);
	__webpack_require__(1696);
	__webpack_require__(1694);
	__webpack_require__(1695);
	__webpack_require__(1697);
	__webpack_require__(1698);
	__webpack_require__(1699);
	__webpack_require__(1700);
	__webpack_require__(1702);
	__webpack_require__(1701);
	__webpack_require__(1746);
	__webpack_require__(1744);
	__webpack_require__(1745);
	__webpack_require__(1787);
	__webpack_require__(1790);
	__webpack_require__(1789);
	__webpack_require__(1791);
	__webpack_require__(1792);
	__webpack_require__(1788);
	__webpack_require__(1793);
	__webpack_require__(1794);
	__webpack_require__(1768);
	__webpack_require__(1771);
	__webpack_require__(1767);
	__webpack_require__(1765);
	__webpack_require__(1766);
	__webpack_require__(1769);
	__webpack_require__(1770);
	__webpack_require__(1752);
	__webpack_require__(1786);
	__webpack_require__(1751);
	__webpack_require__(1785);
	__webpack_require__(1797);
	__webpack_require__(1799);
	__webpack_require__(1750);
	__webpack_require__(1784);
	__webpack_require__(1796);
	__webpack_require__(1798);
	__webpack_require__(1749);
	__webpack_require__(1795);
	__webpack_require__(1748);
	__webpack_require__(1753);
	__webpack_require__(1754);
	__webpack_require__(1755);
	__webpack_require__(1756);
	__webpack_require__(1757);
	__webpack_require__(1759);
	__webpack_require__(1758);
	__webpack_require__(1760);
	__webpack_require__(1761);
	__webpack_require__(1762);
	__webpack_require__(1764);
	__webpack_require__(1763);
	__webpack_require__(1773);
	__webpack_require__(1774);
	__webpack_require__(1775);
	__webpack_require__(1776);
	__webpack_require__(1778);
	__webpack_require__(1777);
	__webpack_require__(1780);
	__webpack_require__(1779);
	__webpack_require__(1781);
	__webpack_require__(1782);
	__webpack_require__(1783);
	__webpack_require__(1747);
	__webpack_require__(1772);
	__webpack_require__(1802);
	__webpack_require__(1801);
	__webpack_require__(1800);
	module.exports = __webpack_require__(117);


/***/ },
/* 1804 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(669));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(671));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(670));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = filterEvents;
	
	var _contains = _interopRequireDefault(__webpack_require__(228));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(1812));
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll.default)(top, selector);
	    if (matches.some(function (match) {
	      return (0, _contains.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _on = _interopRequireDefault(__webpack_require__(328));
	
	exports.on = _on.default;
	
	var _off = _interopRequireDefault(__webpack_require__(452));
	
	exports.off = _off.default;
	
	var _filter = _interopRequireDefault(__webpack_require__(1807));
	
	exports.filter = _filter.default;
	
	var _listen = _interopRequireDefault(__webpack_require__(1809));
	
	exports.listen = _listen.default;
	var _default = {
	  on: _on.default,
	  off: _off.default,
	  filter: _filter.default,
	  listen: _listen.default
	};
	exports.default = _default;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(164));
	
	var _on = _interopRequireDefault(__webpack_require__(328));
	
	var _off = _interopRequireDefault(__webpack_require__(452));
	
	var listen = function listen() {};
	
	if (_inDOM.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(227));
	
	var _style = _interopRequireDefault(__webpack_require__(330));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(568));
	
	var _offset = _interopRequireDefault(__webpack_require__(672));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(1810));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(673));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(1813));
	
	var _style = _interopRequireDefault(__webpack_require__(330));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1812 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(329));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(675));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 1815 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1816 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ },
/* 1817 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 1818 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(61);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(1818));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 1820 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1821 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1822 */
1821,
/* 1823 */
1821,
/* 1824 */
1821,
/* 1825 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1825);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1834);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var createArrayFromMixed = __webpack_require__(1828);
	var getMarkupWrap = __webpack_require__(1830);
	var invariant = __webpack_require__(29);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1831 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1832 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1833 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1833);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1835 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow.118a00cf.svg";

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-blue-down.8621258e.svg";

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow2.13463c41.svg";

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow_drop_down.d77e4dd8.svg";

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bordered-triangle-left-white.f2738bd8.svg";

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bordered-triangle-left-yellow.fc24c269.svg";

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chevron-down.671f6756.svg";

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/final-page.9070fbea.svg";

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-arrow-right.207718bc.svg";

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-check-circle-active.ab1ec598.svg";

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-check-circle-disabled.421fa0a8.svg";

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-check-circle.8cc5b30d.svg";

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-check-square.a8a1bfcd.svg";

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-dropdown-arrow.5168e48f.svg";

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-search.ef9083a2.svg";

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-table-sorter.1a65a0e5.svg";

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-team-survey-progress-completed.8d8c998f.svg";

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-team-survey-progress-in-progress.dae8b1d8.svg";

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-team-survey-progress-incomplete.f13f6c50.svg";

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-team-survey-progress-not-started.0ee35f7b.svg";

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-teamplayers-edit.96ce6288.svg";

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-teams-roles-checked.447802d2.svg";

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon-teams-roles-unchecked.72906363.svg";

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icon_close.01f214a9.svg";

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_rating_intro.b89fc3f5.svg";

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/self_assessment_intro.c6b56444.svg";

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/skills_assessment_intro.cf93511f.svg";

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/time-icon-active.a0fa5cff.svg";

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/time-icon.ea081dc3.svg";

/***/ },
/* 1865 */
/***/ function(module, exports) {

	function toObj(source) {
	  return Object.keys(source).reduce(function (output, key) {
	    var parentKey = key.match(/[^\[]*/i);
	    var paths = key.match(/\[.*?\]/g) || [];
	    paths = [parentKey[0]].concat(paths).map(function (key) {
	      return key.replace(/\[|\]/g, '');
	    });
	    var currentPath = output;
	    while (paths.length) {
	      var pathKey = paths.shift();
	
	      if (pathKey in currentPath) {
	        currentPath = currentPath[pathKey];
	      } else {
	        currentPath[pathKey] = paths.length ? isNaN(paths[0]) ? {} : [] : source[key];
	        currentPath = currentPath[pathKey];
	      }
	    }
	
	    return output;
	  }, {});
	}
	
	function fromObj(obj) {
	  function recur(newObj, propName, currVal) {
	    if (Array.isArray(currVal) || Object.prototype.toString.call(currVal) === '[object Object]') {
	      Object.keys(currVal).forEach(function(v) {
	        recur(newObj, propName + "[" + v + "]", currVal[v]);
	      });
	      return newObj;
	    }
	
	    newObj[propName] = currVal;
	    return newObj;
	  }
	
	  var keys = Object.keys(obj);
	  return keys.reduce(function(newObj, propName) {
	    return recur(newObj, propName, obj[propName]);
	  }, {});
	}
	
	module.exports = {
	  fromObj: fromObj,
	  toObj: toObj
	}

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	
	var CheckboxGroup = React.createClass({
	    displayName: 'CheckboxGroup',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    propTypes: {
	        name: React.PropTypes.string.isRequired,
	        options: React.PropTypes.array.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            label: '',
	            help: null
	        };
	    },
	
	    changeCheckbox: function changeCheckbox() {
	        var value = [];
	        this.props.options.forEach(function (option, key) {
	            if (this['element-' + key].checked) {
	                value.push(option.value);
	            }
	        }.bind(this));
	        this.setValue(value);
	        this.props.onChange(this.props.name, value);
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        var controls = this.props.options.map(function (checkbox, key) {
	            var checked = _this.getValue().indexOf(checkbox.value) !== -1;
	            var disabled = _this.isFormDisabled() || checkbox.disabled || _this.props.disabled;
	            return React.createElement(
	                'div',
	                { className: 'checkbox', key: key },
	                React.createElement(
	                    'label',
	                    null,
	                    React.createElement('input', {
	                        ref: function ref(c) {
	                            return _this['element-' + key] = c;
	                        },
	                        checked: checked,
	                        type: 'checkbox',
	                        value: checkbox.value,
	                        onChange: _this.changeCheckbox,
	                        disabled: disabled
	                    }),
	                    ' ',
	                    checkbox.label
	                )
	            );
	        });
	        return controls;
	    },
	
	    render: function render() {
	
	        if (this.getLayout() === 'elementOnly') {
	            return React.createElement(
	                'div',
	                null,
	                this.renderElement()
	            );
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                fakeLabel: true
	            }),
	            this.renderElement(),
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    }
	});
	
	module.exports = CheckboxGroup;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	var propUtilities = __webpack_require__(275);
	
	var Checkbox = React.createClass({
	    displayName: 'Checkbox',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            label: '',
	            rowLabel: '',
	            value: false
	        };
	    },
	
	    changeValue: function changeValue(event) {
	        var target = event.currentTarget;
	        this.setValue(target.checked);
	        this.props.onChange(this.props.name, target.checked);
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        return React.createElement(
	            'div',
	            { className: 'checkbox' },
	            React.createElement(
	                'label',
	                null,
	                React.createElement('input', _extends({
	                    ref: function ref(c) {
	                        return _this.element = c;
	                    }
	                }, propUtilities.cleanProps(this.props), {
	                    id: this.getId(),
	                    type: 'checkbox',
	                    checked: this.getValue() === true,
	                    onChange: this.changeValue,
	                    disabled: this.isFormDisabled() || this.props.disabled
	                })),
	                ' ',
	                this.props.label
	            )
	        );
	    },
	
	    render: function render() {
	
	        var element = this.renderElement();
	
	        if (this.getLayout() === 'elementOnly') {
	            return element;
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                label: this.props.rowLabel,
	                htmlFor: this.getId()
	            }),
	            element,
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    }
	});
	
	module.exports = Checkbox;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formsyReact = __webpack_require__(142);
	
	var _formsyReact2 = _interopRequireDefault(_formsyReact);
	
	var _parentContext = __webpack_require__(695);
	
	var _parentContext2 = _interopRequireDefault(_parentContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = _react2.default.createClass({
	    displayName: 'Form',
	
	
	    mixins: [_parentContext2.default],
	
	    propTypes: {
	        children: _react2.default.PropTypes.node
	    },
	
	    render: function render() {
	        var formsyProps = Object.assign({}, this.props);
	        delete formsyProps.layout;
	        delete formsyProps.validateOnSubmit;
	        delete formsyProps.validatePristine;
	        delete formsyProps.rowClassName;
	        delete formsyProps.labelClassName;
	        delete formsyProps.elementWrapperClassName;
	        return _react2.default.createElement(
	            _formsyReact2.default.Form,
	            _extends({
	                className: this.getLayoutClassName()
	            }, formsyProps, {
	                ref: 'formsy'
	            }),
	            this.props.children
	        );
	    }
	});
	
	module.exports = Form;

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	var Icon = __webpack_require__(458);
	var propUtilities = __webpack_require__(275);
	
	var File = React.createClass({
	    displayName: 'File',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    getInitialState: function getInitialState() {
	        return {
	            fileList: []
	        };
	    },
	
	    changeValue: function changeValue(event) {
	        var target = event.currentTarget;
	        var value = target.value;
	        this.setState({ fileList: target.files });
	        this.setValue(target.files);
	        this.props.onChange(this.props.name, target.files, value);
	    },
	
	    render: function render() {
	        var element = this.renderElement();
	
	        if (this.getLayout() === 'elementOnly' || this.props.type === 'hidden') {
	            return element;
	        }
	
	        var warningIcon = null;
	        if (this.showErrors()) {
	            warningIcon = React.createElement(Icon, { symbol: 'remove', className: 'form-control-feedback' });
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                htmlFor: this.getId()
	            }),
	            element,
	            warningIcon,
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        return React.createElement('input', _extends({
	            ref: function ref(c) {
	                return _this.element = c;
	            }
	        }, propUtilities.cleanProps(this.props), {
	            id: this.getId(),
	            type: 'file',
	            onChange: this.changeValue,
	            disabled: this.isFormDisabled() || this.props.disabled
	        }));
	    }
	
	});
	
	module.exports = File;

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	var Icon = __webpack_require__(458);
	var propUtilities = __webpack_require__(275);
	
	var Input = React.createClass({
	    displayName: 'Input',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    propTypes: {
	        type: React.PropTypes.oneOf(['color', 'date', 'datetime', 'datetime-local', 'email', 'hidden', 'month', 'number', 'password', 'range', 'search', 'tel', 'text', 'time', 'url', 'week']),
	        addonBefore: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.node]),
	        addonAfter: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.node]),
	        buttonBefore: React.PropTypes.node,
	        buttonAfter: React.PropTypes.node
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            type: 'text',
	            addonBefore: null,
	            addonAfter: null,
	            buttonBefore: null,
	            buttonAfter: null
	        };
	    },
	
	    changeValue: function changeValue(event) {
	        var value = event.currentTarget.value;
	        this.setValue(value);
	        this.props.onChange(this.props.name, value);
	    },
	
	    render: function render() {
	        var element = this.renderElement();
	
	        if (this.props.type === 'hidden') {
	            return element;
	        }
	
	        if (this.props.addonBefore || this.props.addonAfter || this.props.buttonBefore || this.props.buttonAfter) {
	            element = this.renderInputGroup(element);
	        }
	
	        if (this.getLayout() === 'elementOnly') {
	            return element;
	        }
	
	        var warningIcon = null;
	        if (this.showErrors()) {
	            warningIcon = React.createElement(Icon, { symbol: 'remove', className: 'form-control-feedback' });
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                htmlFor: this.getId()
	            }),
	            element,
	            warningIcon,
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        var className = 'form-control';
	        if (['range'].indexOf(this.props.type) !== -1) {
	            className = null;
	        }
	        return React.createElement('input', _extends({
	            ref: function ref(c) {
	                return _this.element = c;
	            },
	            className: className
	        }, propUtilities.cleanProps(this.props), {
	            id: this.getId(),
	            value: this.getValue(),
	            onChange: this.changeValue,
	            disabled: this.isFormDisabled() || this.props.disabled
	        }));
	    },
	
	    renderInputGroup: function renderInputGroup(element) {
	        return React.createElement(
	            'div',
	            { className: 'input-group' },
	            this.renderAddon(this.props.addonBefore),
	            this.renderButton(this.props.buttonBefore),
	            element,
	            this.renderAddon(this.props.addonAfter),
	            this.renderButton(this.props.buttonAfter)
	        );
	    },
	
	    renderAddon: function renderAddon(addon) {
	        if (!addon) {
	            return false;
	        }
	        return React.createElement(
	            'span',
	            { className: 'input-group-addon' },
	            addon
	        );
	    },
	
	    renderButton: function renderButton(button) {
	        if (!button) {
	            return false;
	        }
	        return React.createElement(
	            'span',
	            { className: 'input-group-btn' },
	            button
	        );
	    }
	
	});
	
	module.exports = Input;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	
	var RadioGroup = React.createClass({
	    displayName: 'RadioGroup',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    propTypes: {
	        name: React.PropTypes.string.isRequired,
	        type: React.PropTypes.oneOf(['inline', 'stacked']),
	        options: React.PropTypes.array.isRequired
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            type: 'stacked',
	            label: '',
	            help: null
	        };
	    },
	
	    changeRadio: function changeRadio(event) {
	        var value = event.currentTarget.value;
	        this.setValue(value);
	        this.props.onChange(this.props.name, value);
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        var controls = this.props.options.map(function (radio, key) {
	            var checked = _this.getValue() === radio.value;
	            var disabled = _this.isFormDisabled() || radio.disabled || _this.props.disabled;
	            var className = 'radio' + (disabled ? ' disabled' : '');
	            if (_this.props.type === 'inline') {
	                return React.createElement(
	                    'label',
	                    { className: 'radio-inline', key: key },
	                    React.createElement('input', {
	                        ref: function ref(c) {
	                            return _this['element-' + key] = c;
	                        },
	                        checked: checked,
	                        type: 'radio',
	                        value: radio.value,
	                        onChange: _this.changeRadio,
	                        disabled: disabled
	                    }),
	                    ' ',
	                    radio.label
	                );
	            }
	            return React.createElement(
	                'div',
	                { className: className, key: key },
	                React.createElement(
	                    'label',
	                    null,
	                    React.createElement('input', {
	                        ref: function ref(c) {
	                            return _this['element-' + key] = c;
	                        },
	                        checked: checked,
	                        type: 'radio',
	                        value: radio.value,
	                        onChange: _this.changeRadio,
	                        disabled: disabled
	                    }),
	                    ' ',
	                    radio.label
	                )
	            );
	        });
	        return controls;
	    },
	
	    render: function render() {
	
	        if (this.getLayout() === 'elementOnly') {
	            return React.createElement(
	                'div',
	                null,
	                this.renderElement()
	            );
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                fakeLabel: true
	            }),
	            this.renderElement(),
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    }
	});
	
	module.exports = RadioGroup;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	var propUtilities = __webpack_require__(275);
	
	var Select = React.createClass({
	    displayName: 'Select',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    changeValue: function changeValue(event) {
	        var target = event.currentTarget;
	        var value;
	        if (this.props.multiple) {
	            value = [];
	            for (var i = 0; i < target.length; i++) {
	                var option = target.options[i];
	                if (option.selected) {
	                    value.push(option.value);
	                }
	            }
	        } else {
	            value = target.value;
	        }
	        this.setValue(value);
	        this.props.onChange(this.props.name, value);
	    },
	
	    render: function render() {
	
	        if (this.getLayout() === 'elementOnly') {
	            return this.renderElement();
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                htmlFor: this.getId()
	            }),
	            this.renderElement(),
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        var renderOption = function renderOption(item, key) {
	            var group = item.group,
	                label = item.label,
	                rest = _objectWithoutProperties(item, ['group', 'label']);
	
	            return React.createElement(
	                'option',
	                _extends({ key: key }, rest),
	                item.label
	            );
	        };
	
	        var options = this.props.options;
	
	        var groups = options.filter(function (item) {
	            return item.group;
	        }).map(function (item) {
	            return item.group;
	        });
	        // Get the unique items in group.
	        groups = [].concat(_toConsumableArray(new Set(groups)));
	
	        var optionNodes = [];
	
	        if (groups.length == 0) {
	            optionNodes = options.map(function (item, index) {
	                return renderOption(item, index);
	            });
	        } else {
	            // For items without groups.
	            var itemsWithoutGroup = options.filter(function (item) {
	                return !item.group;
	            });
	
	            itemsWithoutGroup.forEach(function (item, index) {
	                optionNodes.push(renderOption(item, 'no-group-' + index));
	            });
	
	            groups.forEach(function (group, groupIndex) {
	
	                var groupItems = options.filter(function (item) {
	                    return item.group === group;
	                });
	
	                var groupOptionNodes = groupItems.map(function (item, index) {
	                    return renderOption(item, groupIndex + '-' + index);
	                });
	
	                optionNodes.push(React.createElement(
	                    'optgroup',
	                    { label: group, key: groupIndex },
	                    groupOptionNodes
	                ));
	            });
	        }
	        return React.createElement(
	            'select',
	            _extends({
	                ref: function ref(c) {
	                    return _this.element = c;
	                },
	                className: 'form-control'
	            }, propUtilities.cleanProps(this.props), {
	                id: this.getId(),
	                value: this.getValue(),
	                onChange: this.changeValue,
	                disabled: this.isFormDisabled() || this.props.disabled
	            }),
	            optionNodes
	        );
	    }
	});
	
	module.exports = Select;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Formsy = __webpack_require__(142);
	var ComponentMixin = __webpack_require__(165);
	var Row = __webpack_require__(166);
	var propUtilities = __webpack_require__(275);
	
	var Textarea = React.createClass({
	    displayName: 'Textarea',
	
	
	    mixins: [Formsy.Mixin, ComponentMixin],
	
	    propTypes: {
	        rows: React.PropTypes.number,
	        cols: React.PropTypes.number
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            rows: 3,
	            cols: 0 // React doesn't render the cols attribute if it is zero
	        };
	    },
	
	    changeValue: function changeValue(event) {
	        var value = event.currentTarget.value;
	        this.setValue(value);
	        this.props.onChange(this.props.name, value);
	    },
	
	    renderElement: function renderElement() {
	        var _this = this;
	
	        return React.createElement('textarea', _extends({
	            ref: function ref(c) {
	                return _this.element = c;
	            },
	            className: 'form-control'
	        }, propUtilities.cleanProps(this.props), {
	            id: this.getId(),
	            value: this.getValue(),
	            onChange: this.changeValue,
	            disabled: this.isFormDisabled() || this.props.disabled
	        }));
	    },
	
	    render: function render() {
	
	        if (this.getLayout() === 'elementOnly') {
	            return this.renderElement();
	        }
	
	        return React.createElement(
	            Row,
	            _extends({}, this.getRowProperties(), {
	                htmlFor: this.getId()
	            }),
	            this.renderElement(),
	            this.renderHelp(),
	            this.renderErrorMessage()
	        );
	    }
	});
	
	module.exports = Textarea;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = global.React || __webpack_require__(1);
	var createReactClass = __webpack_require__(73);
	var Mixin = __webpack_require__(459);
	module.exports = function () {
	  return function (Component) {
	    return createReactClass({
	      mixins: [Mixin],
	      render: function render() {
	        return React.createElement(Component, _extends({
	          setValidations: this.setValidations,
	          setValue: this.setValue,
	          resetValue: this.resetValue,
	          getValue: this.getValue,
	          hasValue: this.hasValue,
	          getErrorMessage: this.getErrorMessage,
	          getErrorMessages: this.getErrorMessages,
	          isFormDisabled: this.isFormDisabled,
	          isValid: this.isValid,
	          isPristine: this.isPristine,
	          isFormSubmitted: this.isFormSubmitted,
	          isRequired: this.isRequired,
	          showRequired: this.showRequired,
	          showError: this.showError,
	          isValidValue: this.isValidValue
	        }, this.props));
	      }
	    });
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = global.React || __webpack_require__(1);
	var createReactClass = __webpack_require__(73);
	var Mixin = __webpack_require__(459);
	module.exports = function (Component) {
	  return createReactClass({
	    displayName: 'Formsy(' + getDisplayName(Component) + ')',
	    mixins: [Mixin],
	
	    render: function render() {
	      var innerRef = this.props.innerRef;
	
	      var propsForElement = _extends({
	        setValidations: this.setValidations,
	        setValue: this.setValue,
	        resetValue: this.resetValue,
	        getValue: this.getValue,
	        hasValue: this.hasValue,
	        getErrorMessage: this.getErrorMessage,
	        getErrorMessages: this.getErrorMessages,
	        isFormDisabled: this.isFormDisabled,
	        isValid: this.isValid,
	        isPristine: this.isPristine,
	        isFormSubmitted: this.isFormSubmitted,
	        isRequired: this.isRequired,
	        showRequired: this.showRequired,
	        showError: this.showError,
	        isValidValue: this.isValidValue
	      }, this.props);
	
	      if (innerRef) {
	        propsForElement.ref = innerRef;
	      }
	      return React.createElement(Component, propsForElement);
	    }
	  });
	};
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1876 */
/***/ function(module, exports) {

	'use strict';
	
	var _isExisty = function _isExisty(value) {
	  return value !== null && value !== undefined;
	};
	
	var isEmpty = function isEmpty(value) {
	  return value === '';
	};
	
	var validations = {
	  isDefaultRequiredValue: function isDefaultRequiredValue(values, value) {
	    return value === undefined || value === '';
	  },
	  isExisty: function isExisty(values, value) {
	    return _isExisty(value);
	  },
	  matchRegexp: function matchRegexp(values, value, regexp) {
	    return !_isExisty(value) || isEmpty(value) || regexp.test(value);
	  },
	  isUndefined: function isUndefined(values, value) {
	    return value === undefined;
	  },
	  isEmptyString: function isEmptyString(values, value) {
	    return isEmpty(value);
	  },
	  isEmail: function isEmail(values, value) {
	    return validations.matchRegexp(values, value, /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i);
	  },
	  isUrl: function isUrl(values, value) {
	    return validations.matchRegexp(values, value, /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i);
	  },
	  isTrue: function isTrue(values, value) {
	    return value === true;
	  },
	  isFalse: function isFalse(values, value) {
	    return value === false;
	  },
	  isNumeric: function isNumeric(values, value) {
	    if (typeof value === 'number') {
	      return true;
	    }
	    return validations.matchRegexp(values, value, /^[-+]?(?:\d*[.])?\d+$/);
	  },
	  isAlpha: function isAlpha(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z]+$/i);
	  },
	  isAlphanumeric: function isAlphanumeric(values, value) {
	    return validations.matchRegexp(values, value, /^[0-9A-Z]+$/i);
	  },
	  isInt: function isInt(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:0|[1-9]\d*))$/);
	  },
	  isFloat: function isFloat(values, value) {
	    return validations.matchRegexp(values, value, /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][\+\-]?(?:\d+))?$/);
	  },
	  isWords: function isWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s]+$/i);
	  },
	  isSpecialWords: function isSpecialWords(values, value) {
	    return validations.matchRegexp(values, value, /^[A-Z\s\u00C0-\u017F]+$/i);
	  },
	  isLength: function isLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length === length;
	  },
	  equals: function equals(values, value, eql) {
	    return !_isExisty(value) || isEmpty(value) || value == eql;
	  },
	  equalsField: function equalsField(values, value, field) {
	    return value == values[field];
	  },
	  maxLength: function maxLength(values, value, length) {
	    return !_isExisty(value) || value.length <= length;
	  },
	  minLength: function minLength(values, value, length) {
	    return !_isExisty(value) || isEmpty(value) || value.length >= length;
	  }
	};
	
	module.exports = validations;

/***/ },
/* 1877 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(460);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(229);
	
	var _DOMUtils = __webpack_require__(335);
	
	var _DOMStateStorage = __webpack_require__(697);
	
	var _PathUtils = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(460);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(229);
	
	var _PathUtils = __webpack_require__(167);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(461);
	
	var _BrowserProtocol = __webpack_require__(460);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1879);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(335);
	
	var _createHistory = __webpack_require__(462);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(461);
	
	var _DOMUtils = __webpack_require__(335);
	
	var _HashProtocol = __webpack_require__(1878);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(462);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(229);
	
	var _PathUtils = __webpack_require__(167);
	
	var _createHistory = __webpack_require__(462);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(291);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1884 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(1911);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1912);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(464);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(700);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(701);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(702);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	     * Instantiante a new prefixer
	     * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	     * @param {string} keepUnprefixed - keeps unprefixed properties and values
	     */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	       * Returns a prefixed version of the style object using all vendor prefixes
	       * @param {Object} styles - Style object that gets prefixed properties added
	       * @returns {Object} - Style object with prefixed properties and values
	       */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function crossFade(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('cross-fade(') > -1 && (browserName === 'chrome' || browserName === 'opera' || browserName === 'and_chr' || (browserName === 'ios_saf' || browserName === 'safari') && browserVersion < 10)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/cross-fade\(/g, cssPrefix + 'cross-fade('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var grabValues = {
	  grab: true,
	  grabbing: true
	};
	
	
	var zoomValues = {
	  'zoom-in': true,
	  'zoom-out': true
	};
	
	function cursor(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of
	  // version until a reliable browser support info can be found
	  // see: https://github.com/rofrischmann/inline-style-prefixer/issues/79
	  if (property === 'cursor' && grabValues[value] && (browserName === 'firefox' || browserName === 'chrome' || browserName === 'safari' || browserName === 'opera')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	
	  if (property === 'cursor' && zoomValues[value] && (browserName === 'firefox' && browserVersion < 24 || browserName === 'chrome' && browserVersion < 37 || browserName === 'safari' && browserVersion < 9 || browserName === 'opera' && browserVersion < 24)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filter(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('filter(') > -1 && (browserName === 'ios_saf' || browserName === 'safari' && browserVersion < 9.1)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/filter\(/g, cssPrefix + 'filter('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines',
	  flexGrow: 'WebkitBoxFlex'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(value.replace(values, function (grad) {
	      return cssPrefix + grad;
	    }), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function imageSet(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('image-set(') > -1 && (browserName === 'chrome' || browserName === 'opera' || browserName === 'and_chr' || browserName === 'and_uc' || browserName === 'ios_saf' || browserName === 'safari')) {
	    return (0, _getPrefixedValue2.default)(value.replace(/image-set\(/g, cssPrefix + 'image-set('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function position(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browserName === 'safari' || browserName === 'ios_saf')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(122);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(665);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(1913);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(702);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(700);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(701);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        style = (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(226);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(226);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1901 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(226);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1903 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1904 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1905 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines',
	  flexGrow: 'WebkitBoxFlex'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(226);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return value.replace(values, function (grad) {
	        return prefix + grad;
	      });
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(226);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1908 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1909 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(665);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(226);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(464);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(1557);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ },
/* 1912 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(464);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var newStyle = {};
	    var requiredPrefixes = prefixProperties[property];
	    var capitalizedProperty = (0, _capitalizeString2.default)(property);
	    var keys = Object.keys(style);
	    for (var i = 0; i < keys.length; i++) {
	      var styleProperty = keys[i];
	      if (styleProperty === property) {
	        for (var j = 0; j < requiredPrefixes.length; j++) {
	          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
	        }
	      }
	      newStyle[styleProperty] = style[styleProperty];
	    }
	    return newStyle;
	  }
	  return style;
	}
	module.exports = exports['default'];

/***/ },
/* 1914 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 1915 */
/***/ function(module, exports) {

	module.exports = function() {
	  var mediaQuery;
	  if (typeof window !== "undefined" && window !== null) {
	    mediaQuery = "(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)";
	    if (window.devicePixelRatio > 1.25) {
	      return true;
	    }
	    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
	      return true;
	    }
	  }
	  return false;
	};


/***/ },
/* 1916 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2022g",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
			"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
			"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
			"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
			"America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
			"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|",
			"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
			"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0|17e3",
			"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
			"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
			"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
			"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
			"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|",
			"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
			"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
			"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDT|0 70 60 60 60|01231414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1pdA0 hix0 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
			"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
			"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
			"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
			"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
			"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Etc/GMT-10|+10|-a0|0||",
			"Etc/GMT-11|+11|-b0|0||",
			"Etc/GMT-12|+12|-c0|0||",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Etc/GMT-7|+07|-70|0||",
			"Etc/GMT-8|+08|-80|0||",
			"Etc/GMT-9|+09|-90|0||",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+2|-02|20|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
			"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
			"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
			"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
			"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
			"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
			"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
			"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
			"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
			"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
			"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
			"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
			"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Iceland",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Chicago|US/Central",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Godthab|America/Nuuk",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Iqaluit|America/Pangnirtung",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Phoenix|America/Creston",
			"America/Phoenix|US/Arizona",
			"America/Puerto_Rico|America/Anguilla",
			"America/Puerto_Rico|America/Antigua",
			"America/Puerto_Rico|America/Aruba",
			"America/Puerto_Rico|America/Blanc-Sablon",
			"America/Puerto_Rico|America/Curacao",
			"America/Puerto_Rico|America/Dominica",
			"America/Puerto_Rico|America/Grenada",
			"America/Puerto_Rico|America/Guadeloupe",
			"America/Puerto_Rico|America/Kralendijk",
			"America/Puerto_Rico|America/Lower_Princes",
			"America/Puerto_Rico|America/Marigot",
			"America/Puerto_Rico|America/Montserrat",
			"America/Puerto_Rico|America/Port_of_Spain",
			"America/Puerto_Rico|America/St_Barthelemy",
			"America/Puerto_Rico|America/St_Kitts",
			"America/Puerto_Rico|America/St_Lucia",
			"America/Puerto_Rico|America/St_Thomas",
			"America/Puerto_Rico|America/St_Vincent",
			"America/Puerto_Rico|America/Tortola",
			"America/Puerto_Rico|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|America/Nassau",
			"America/Toronto|America/Nipigon",
			"America/Toronto|America/Thunder_Bay",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|America/Rainy_River",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Brunei|Asia/Kuching",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Riyadh|Antarctica/Syowa",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Antarctica/Vostok",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Currie",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Berlin|Arctic/Longyearbyen",
			"Europe/Berlin|Atlantic/Jan_Mayen",
			"Europe/Berlin|Europe/Copenhagen",
			"Europe/Berlin|Europe/Oslo",
			"Europe/Berlin|Europe/Stockholm",
			"Europe/Brussels|Europe/Amsterdam",
			"Europe/Brussels|Europe/Luxembourg",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Kiev|Europe/Kyiv",
			"Europe/Kiev|Europe/Uzhgorod",
			"Europe/Kiev|Europe/Zaporozhye",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Europe/Monaco",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Maldives|Indian/Kerguelen",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Enderbury|Pacific/Kanton",
			"Pacific/Guadalcanal|Pacific/Pohnpei",
			"Pacific/Guadalcanal|Pacific/Ponape",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Majuro",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Puerto_Rico America/Antigua",
			"AI|America/Puerto_Rico America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Puerto_Rico America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Puerto_Rico America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Kuching Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Puerto_Rico America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Toronto America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
			"CC|Asia/Yangon Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Puerto_Rico America/Curacao",
			"CX|Asia/Bangkok Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Berlin Europe/Copenhagen",
			"DM|America/Puerto_Rico America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Puerto_Rico America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Abidjan Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Puerto_Rico America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Africa/Abidjan Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Puerto_Rico America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Puerto_Rico America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Brussels Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Paris Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Puerto_Rico America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Puerto_Rico America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
			"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Brussels Europe/Amsterdam",
			"NO|Europe/Berlin Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Asia/Dubai Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Asia/Dubai Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Berlin Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Berlin Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Puerto_Rico America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Puerto_Rico America/Port_of_Spain",
			"TV|Pacific/Tarawa Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kyiv",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Honolulu Pacific/Midway Pacific/Wake",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Puerto_Rico America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Puerto_Rico America/Tortola",
			"VI|America/Puerto_Rico America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Tarawa Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	};

/***/ },
/* 1917 */
/***/ function(module, exports) {

	module.exports = {
		"rounds": [
			{
				"text3": ""
			},
			{
				"text3": ""
			},
			{
				"text3": "To better your odds in making a profit and hitting targets, we highly recomend that you and your team spend some time analyzing the line items of prior rounds income statements and balance sheets to improve ROI outcomes (ROE and ROA)."
			},
			{
				"text3": "To better your odds in making a profit and hitting targets, we highly recomend that you and your team spend some time analyzing the line items of prior rounds income statements and balance sheets to improve ROI outcomes (EPS, ROE and ROA)."
			}
		]
	};

/***/ },
/* 1918 */
/***/ function(module, exports) {

	module.exports = {
		"rounds": [
			{
				"text1": "",
				"text2": "",
				"text3": ""
			},
			{
				"text1": "What to expect",
				"text2": "Change in Customers’ Preferences",
				"text3": "Customer preferences are expected to change for some customers. Therefore, review <b>Round 2</b> Customer Analysis to ensure your product still meets the minimum requirements for the customers that you are targeting."
			},
			{
				"text1": "What to expect",
				"text2": "Change in Customers’ Preferences",
				"text3": "Customer preferences are expected to change for some customers. Therefore, review <strong>Round 3</strong> Customer Analysis to ensure your product still meets the minimum requirements for the customers that you are targeting."
			},
			{
				"text1": "What to expect",
				"text2": "Customer Preferences",
				"text3": "Customer preferences are expected to change for some customers. Therefore, review <strong>Round 4</strong> Customer Analysis to ensure your product still meets the minimum requirements for the customers that you are targeting."
			}
		]
	};

/***/ },
/* 1919 */
/***/ function(module, exports) {

	module.exports = {
		"rounds": [
			{
				"text1": "Welcome",
				"text2": "Welcome to Intro to Business Game!",
				"text3": ""
			},
			{
				"text1": "Welcome to Round 2!",
				"text2": "Welcome to Round 2!",
				"text3": ""
			},
			{
				"text1": "Welcome to Round 3!",
				"text2": "Welcome to Round 3!",
				"text3": ""
			},
			{
				"text1": "Welcome to Round 4!",
				"text2": "Welcome to Round 4!",
				"text3": ""
			}
		]
	};

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {/*global exports, Intl*/
	/**
	 * This script gives you the zone info key representing your device's time zone setting.
	 *
	 * @name jsTimezoneDetect
	 * @version 1.0.6
	 * @author Jon Nylander
	 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
	 *
	 * For usage and examples, visit:
	 * http://pellepim.bitbucket.org/jstz/
	 *
	 * Copyright (c) Jon Nylander
	 */
	
	
	/**
	 * Namespace to hold all the code for timezone detection.
	 */
	var jstz = (function () {
	    'use strict';
	    var HEMISPHERE_SOUTH = 's',
	
	        consts = {
	            DAY: 86400000,
	            HOUR: 3600000,
	            MINUTE: 60000,
	            SECOND: 1000,
	            BASELINE_YEAR: 2014,
	            MAX_SCORE: 864000000, // 10 days
	            AMBIGUITIES: {
	                'America/Denver':       ['America/Mazatlan'],
	                'Europe/London':        ['Africa/Casablanca'],
	                'America/Chicago':      ['America/Mexico_City'],
	                'America/Asuncion':     ['America/Campo_Grande', 'America/Santiago'],
	                'America/Montevideo':   ['America/Sao_Paulo', 'America/Santiago'],
	                // Europe/Minsk should not be in this list... but Windows.
	                'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
	                'Pacific/Auckland':     ['Pacific/Fiji'],
	                'America/Los_Angeles':  ['America/Santa_Isabel'],
	                'America/New_York':     ['America/Havana'],
	                'America/Halifax':      ['America/Goose_Bay'],
	                'America/Godthab':      ['America/Miquelon'],
	                'Asia/Dubai':           ['Asia/Yerevan'],
	                'Asia/Jakarta':         ['Asia/Krasnoyarsk'],
	                'Asia/Shanghai':        ['Asia/Irkutsk', 'Australia/Perth'],
	                'Australia/Sydney':     ['Australia/Lord_Howe'],
	                'Asia/Tokyo':           ['Asia/Yakutsk'],
	                'Asia/Dhaka':           ['Asia/Omsk'],
	                // In the real world Yerevan is not ambigous for Baku... but Windows.
	                'Asia/Baku':            ['Asia/Yerevan'],
	                'Australia/Brisbane':   ['Asia/Vladivostok'],
	                'Pacific/Noumea':       ['Asia/Vladivostok'],
	                'Pacific/Majuro':       ['Asia/Kamchatka', 'Pacific/Fiji'],
	                'Pacific/Tongatapu':    ['Pacific/Apia'],
	                'Asia/Baghdad':         ['Europe/Minsk', 'Europe/Moscow'],
	                'Asia/Karachi':         ['Asia/Yekaterinburg'],
	                'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
	            }
	        },
	
	        /**
	         * Gets the offset in minutes from UTC for a certain date.
	         * @param {Date} date
	         * @returns {Number}
	         */
	        get_date_offset = function get_date_offset(date) {
	            var offset = -date.getTimezoneOffset();
	            return (offset !== null ? offset : 0);
	        },
	
	        /**
	         * This function does some basic calculations to create information about
	         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
	         * the script has been tested rather than depend on the year set by the
	         * client device.
	         *
	         * Returns a key that can be used to do lookups in jstz.olson.timezones.
	         * eg: "720,1,2".
	         *
	         * @returns {String}
	         */
	        lookup_key = function lookup_key() {
	            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
	                june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
	                diff = january_offset - june_offset;
	
	            if (diff < 0) {
	                return january_offset + ",1";
	            } else if (diff > 0) {
	                return june_offset + ",1," + HEMISPHERE_SOUTH;
	            }
	
	            return january_offset + ",0";
	        },
	
	
	        /**
	         * Tries to get the time zone key directly from the operating system for those
	         * environments that support the ECMAScript Internationalization API.
	         */
	        get_from_internationalization_api = function get_from_internationalization_api() {
	            var format, timezone;
	            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
	                return;
	            }
	            format = Intl.DateTimeFormat();
	            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
	                return;
	            }
	            timezone = format.resolvedOptions().timeZone;
	            if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC') && timezone.indexOf("Etc") != 0) {
	                return timezone;
	            }
	        },
	
	        /**
	         * Starting point for getting all the DST rules for a specific year
	         * for the current timezone (as described by the client system).
	         *
	         * Returns an object with start and end attributes, or false if no
	         * DST rules were found for the year.
	         *
	         * @param year
	         * @returns {Object} || {Boolean}
	         */
	        dst_dates = function dst_dates(year) {
	            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
	            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
	            var current = yearstart;
	            var offset = (new Date(current)).getTimezoneOffset();
	            var dst_start = null;
	            var dst_end = null;
	
	            while (current < yearend - 86400000) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                if (dateToCheckOffset !== offset) {
	                    if (dateToCheckOffset < offset) {
	                        dst_start = dateToCheck;
	                    }
	                    if (dateToCheckOffset > offset) {
	                        dst_end = dateToCheck;
	                    }
	                    offset = dateToCheckOffset;
	                }
	
	                current += 86400000;
	            }
	
	            if (dst_start && dst_end) {
	                return {
	                    s: find_dst_fold(dst_start).getTime(),
	                    e: find_dst_fold(dst_end).getTime()
	                };
	            }
	
	            return false;
	        },
	
	        /**
	         * Probably completely unnecessary function that recursively finds the
	         * exact (to the second) time when a DST rule was changed.
	         *
	         * @param a_date - The candidate Date.
	         * @param padding - integer specifying the padding to allow around the candidate
	         *                  date for finding the fold.
	         * @param iterator - integer specifying how many milliseconds to iterate while
	         *                   searching for the fold.
	         *
	         * @returns {Date}
	         */
	        find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
	            if (typeof padding === 'undefined') {
	                padding = consts.DAY;
	                iterator = consts.HOUR;
	            }
	
	            var date_start = new Date(a_date.getTime() - padding).getTime();
	            var date_end = a_date.getTime() + padding;
	            var offset = new Date(date_start).getTimezoneOffset();
	
	            var current = date_start;
	
	            var dst_change = null;
	            while (current < date_end - iterator) {
	                var dateToCheck = new Date(current);
	                var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                if (dateToCheckOffset !== offset) {
	                    dst_change = dateToCheck;
	                    break;
	                }
	                current += iterator;
	            }
	
	            if (padding === consts.DAY) {
	                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
	            }
	
	            if (padding === consts.HOUR) {
	                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
	            }
	
	            return dst_change;
	        },
	
	        windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
	            if (score !== 'N/A') {
	                return score;
	            }
	            if (preliminary_timezone === 'Asia/Beirut') {
	                if (sample.name === 'Africa/Cairo') {
	                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'Asia/Jerusalem') {
	                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
	                        return 0;
	                }
	            }
	            } else if (preliminary_timezone === 'America/Santiago') {
	                if (sample.name === 'America/Asuncion') {
	                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
	                        return 0;
	                    }
	                }
	                if (sample.name === 'America/Campo_Grande') {
	                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'America/Montevideo') {
	                if (sample.name === 'America/Sao_Paulo') {
	                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
	                        return 0;
	                    }
	                }
	            } else if (preliminary_timezone === 'Pacific/Auckland') {
	                if (sample.name === 'Pacific/Fiji') {
	                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
	                        return 0;
	                    }
	                }
	            }
	
	            return score;
	        },
	
	        /**
	         * Takes the DST rules for the current timezone, and proceeds to find matches
	         * in the jstz.olson.dst_rules.zones array.
	         *
	         * Compares samples to the current timezone on a scoring basis.
	         *
	         * Candidates are ruled immediately if either the candidate or the current zone
	         * has a DST rule where the other does not.
	         *
	         * Candidates are ruled out immediately if the current zone has a rule that is
	         * outside the DST scope of the candidate.
	         *
	         * Candidates are included for scoring if the current zones rules fall within the
	         * span of the samples rules.
	         *
	         * Low score is best, the score is calculated by summing up the differences in DST
	         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
	         *
	         * Yah follow? :)
	         *
	         * @param rule_list
	         * @param preliminary_timezone
	         * @returns {*}
	         */
	        best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
	            var score_sample = function score_sample(sample) {
	                var score = 0;
	
	                for (var j = 0; j < rule_list.length; j++) {
	
	                    // Both sample and current time zone report DST during the year.
	                    if (!!sample.rules[j] && !!rule_list[j]) {
	
	                        // The current time zone's DST rules are inside the sample's. Include.
	                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
	                            score = 0;
	                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
	                            score += Math.abs(sample.rules[j].e - rule_list[j].e);
	
	                        // The current time zone's DST rules are outside the sample's. Discard.
	                        } else {
	                            score = 'N/A';
	                            break;
	                        }
	
	                        // The max score has been reached. Discard.
	                        if (score > consts.MAX_SCORE) {
	                            score = 'N/A';
	                            break;
	                        }
	                    }
	                }
	
	                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);
	
	                return score;
	            };
	            var scoreboard = {};
	            var dst_zones = jstz.olson.dst_rules.zones;
	            var dst_zones_length = dst_zones.length;
	            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];
	
	            for (var i = 0; i < dst_zones_length; i++) {
	                var sample = dst_zones[i];
	                var score = score_sample(dst_zones[i]);
	
	                if (score !== 'N/A') {
	                    scoreboard[sample.name] = score;
	                }
	            }
	
	            for (var tz in scoreboard) {
	                if (scoreboard.hasOwnProperty(tz)) {
	                    for (var j = 0; j < ambiguities.length; j++) {
	                        if (ambiguities[j] === tz) {
	                        return tz;
	                        }
	                    }
	                }
	            }
	
	            return preliminary_timezone;
	        },
	
	        /**
	         * Takes the preliminary_timezone as detected by lookup_key().
	         *
	         * Builds up the current timezones DST rules for the years defined
	         * in the jstz.olson.dst_rules.years array.
	         *
	         * If there are no DST occurences for those years, immediately returns
	         * the preliminary timezone. Otherwise proceeds and tries to solve
	         * ambiguities.
	         *
	         * @param preliminary_timezone
	         * @returns {String} timezone_name
	         */
	        get_by_dst = function get_by_dst(preliminary_timezone) {
	            var get_rules = function get_rules() {
	                var rule_list = [];
	                for (var i = 0; i < jstz.olson.dst_rules.years.length; i++) {
	                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
	                    rule_list.push(year_rules);
	                }
	                return rule_list;
	            };
	            var check_has_dst = function check_has_dst(rules) {
	                for (var i = 0; i < rules.length; i++) {
	                    if (rules[i] !== false) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	            var rules = get_rules();
	            var has_dst = check_has_dst(rules);
	
	            if (has_dst) {
	                return best_dst_match(rules, preliminary_timezone);
	            }
	
	            return preliminary_timezone;
	        },
	
	        /**
	         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
	         *
	         * Returns an object with one function ".name()"
	         *
	         * @returns Object
	         */
	        determine = function determine() {
	            var preliminary_tz = get_from_internationalization_api();
	
	            if (!preliminary_tz) {
	                preliminary_tz = jstz.olson.timezones[lookup_key()];
	
	                if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
	                    preliminary_tz = get_by_dst(preliminary_tz);
	                }
	            }
	
	            return {
	                name: function () {
	                    return preliminary_tz;
	                },
	                stdTimezoneOffset : function () {
	                    // negative to match what (new Date).getTimezoneOffset() will return
	                    return -lookup_key().split(',')[0];
	                },
	                timezoneOffset : function () {
	                    // negative to match what (new Date).getTimezoneOffset() will return
	                    return -get_date_offset(new Date())
	                }
	            };
	        };
	
	    return {
	        determine: determine
	    };
	}());
	
	
	jstz.olson = jstz.olson || {};
	
	/**
	 * The keys in this dictionary are comma separated as such:
	 *
	 * First the offset compared to UTC time in minutes.
	 *
	 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
	 * does.
	 *
	 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
	 * only interesting for timezones with DST.
	 *
	 * The mapped arrays is used for constructing the jstz.TimeZone object from within
	 * jstz.determine();
	 */
	jstz.olson.timezones = {
	    '-720,0': 'Etc/GMT+12',
	    '-660,0': 'Pacific/Pago_Pago',
	    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
	    '-600,1': 'America/Adak',
	    '-600,0': 'Pacific/Honolulu',
	    '-570,0': 'Pacific/Marquesas',
	    '-540,0': 'Pacific/Gambier',
	    '-540,1': 'America/Anchorage',
	    '-480,1': 'America/Los_Angeles',
	    '-480,0': 'Pacific/Pitcairn',
	    '-420,0': 'America/Phoenix',
	    '-420,1': 'America/Denver',
	    '-360,0': 'America/Guatemala',
	    '-360,1': 'America/Chicago',
	    '-360,1,s': 'Pacific/Easter',
	    '-300,0': 'America/Bogota',
	    '-300,1': 'America/New_York',
	    '-270,0': 'America/Caracas',
	    '-240,1': 'America/Halifax',
	    '-240,0': 'America/Santo_Domingo',
	    '-240,1,s': 'America/Asuncion',
	    '-210,1': 'America/St_Johns',
	    '-180,1': 'America/Godthab',
	    '-180,0': 'America/Argentina/Buenos_Aires',
	    '-180,1,s': 'America/Montevideo',
	    '-120,0': 'America/Noronha',
	    '-120,1': 'America/Noronha',
	    '-60,1': 'Atlantic/Azores',
	    '-60,0': 'Atlantic/Cape_Verde',
	    '0,0': 'UTC',
	    '0,1': 'Europe/London',
	    '60,1': 'Europe/Berlin',
	    '60,0': 'Africa/Lagos',
	    '60,1,s': 'Africa/Windhoek',
	    '120,1': 'Asia/Beirut',
	    '120,0': 'Africa/Johannesburg',
	    '180,0': 'Asia/Baghdad',
	    '180,1': 'Europe/Moscow',
	    '210,1': 'Asia/Tehran',
	    '240,0': 'Asia/Dubai',
	    '240,1': 'Asia/Baku',
	    '270,0': 'Asia/Kabul',
	    '300,1': 'Asia/Yekaterinburg',
	    '300,0': 'Asia/Karachi',
	    '330,0': 'Asia/Kolkata',
	    '345,0': 'Asia/Kathmandu',
	    '360,0': 'Asia/Dhaka',
	    '360,1': 'Asia/Omsk',
	    '390,0': 'Asia/Rangoon',
	    '420,1': 'Asia/Krasnoyarsk',
	    '420,0': 'Asia/Jakarta',
	    '480,0': 'Asia/Shanghai',
	    '480,1': 'Asia/Irkutsk',
	    '525,0': 'Australia/Eucla',
	    '525,1,s': 'Australia/Eucla',
	    '540,1': 'Asia/Yakutsk',
	    '540,0': 'Asia/Tokyo',
	    '570,0': 'Australia/Darwin',
	    '570,1,s': 'Australia/Adelaide',
	    '600,0': 'Australia/Brisbane',
	    '600,1': 'Asia/Vladivostok',
	    '600,1,s': 'Australia/Sydney',
	    '630,1,s': 'Australia/Lord_Howe',
	    '660,1': 'Asia/Kamchatka',
	    '660,0': 'Pacific/Noumea',
	    '690,0': 'Pacific/Norfolk',
	    '720,1,s': 'Pacific/Auckland',
	    '720,0': 'Pacific/Majuro',
	    '765,1,s': 'Pacific/Chatham',
	    '780,0': 'Pacific/Tongatapu',
	    '780,1,s': 'Pacific/Apia',
	    '840,0': 'Pacific/Kiritimati'
	};
	
	/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
	jstz.olson.dst_rules = {
	    "years": [
	        2008,
	        2009,
	        2010,
	        2011,
	        2012,
	        2013,
	        2014
	    ],
	    "zones": [
	        {
	            "name": "Africa/Cairo",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1209074400000
	                },
	                {
	                    "e": 1250802000000,
	                    "s": 1240524000000
	                },
	                {
	                    "e": 1285880400000,
	                    "s": 1284069600000
	                },
	                false,
	                false,
	                false,
	                {
	                    "e": 1411678800000,
	                    "s": 1406844000000
	                }
	            ]
	        },
	        {
	            "name": "Africa/Casablanca",
	            "rules": [
	                {
	                    "e": 1220223600000,
	                    "s": 1212278400000
	                },
	                {
	                    "e": 1250809200000,
	                    "s": 1243814400000
	                },
	                {
	                    "e": 1281222000000,
	                    "s": 1272758400000
	                },
	                {
	                    "e": 1312066800000,
	                    "s": 1301788800000
	                },
	                {
	                    "e": 1348970400000,
	                    "s": 1345428000000
	                },
	                {
	                    "e": 1382839200000,
	                    "s": 1376100000000
	                },
	                {
	                    "e": 1414288800000,
	                    "s": 1406944800000
	                }
	            ]
	        },
	        {
	            "name": "America/Asuncion",
	            "rules": [
	                {
	                    "e": 1205031600000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1236481200000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1270954800000,
	                    "s": 1286078400000
	                },
	                {
	                    "e": 1302404400000,
	                    "s": 1317528000000
	                },
	                {
	                    "e": 1333854000000,
	                    "s": 1349582400000
	                },
	                {
	                    "e": 1364094000000,
	                    "s": 1381032000000
	                },
	                {
	                    "e": 1395543600000,
	                    "s": 1412481600000
	                }
	            ]
	        },
	        {
	            "name": "America/Campo_Grande",
	            "rules": [
	                {
	                    "e": 1203217200000,
	                    "s": 1224388800000
	                },
	                {
	                    "e": 1234666800000,
	                    "s": 1255838400000
	                },
	                {
	                    "e": 1266721200000,
	                    "s": 1287288000000
	                },
	                {
	                    "e": 1298170800000,
	                    "s": 1318737600000
	                },
	                {
	                    "e": 1330225200000,
	                    "s": 1350792000000
	                },
	                {
	                    "e": 1361070000000,
	                    "s": 1382241600000
	                },
	                {
	                    "e": 1392519600000,
	                    "s": 1413691200000
	                }
	            ]
	        },
	        {
	            "name": "America/Goose_Bay",
	            "rules": [
	                {
	                    "e": 1225594860000,
	                    "s": 1205035260000
	                },
	                {
	                    "e": 1257044460000,
	                    "s": 1236484860000
	                },
	                {
	                    "e": 1289098860000,
	                    "s": 1268539260000
	                },
	                {
	                    "e": 1320555600000,
	                    "s": 1299988860000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1331445600000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362895200000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394344800000
	                }
	            ]
	        },
	        {
	            "name": "America/Havana",
	            "rules": [
	                {
	                    "e": 1224997200000,
	                    "s": 1205643600000
	                },
	                {
	                    "e": 1256446800000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1288501200000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1321160400000,
	                    "s": 1300597200000
	                },
	                {
	                    "e": 1352005200000,
	                    "s": 1333256400000
	                },
	                {
	                    "e": 1383454800000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414904400000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Mazatlan",
	            "rules": [
	                {
	                    "e": 1225008000000,
	                    "s": 1207472400000
	                },
	                {
	                    "e": 1256457600000,
	                    "s": 1238922000000
	                },
	                {
	                    "e": 1288512000000,
	                    "s": 1270371600000
	                },
	                {
	                    "e": 1319961600000,
	                    "s": 1301821200000
	                },
	                {
	                    "e": 1351411200000,
	                    "s": 1333270800000
	                },
	                {
	                    "e": 1382860800000,
	                    "s": 1365325200000
	                },
	                {
	                    "e": 1414310400000,
	                    "s": 1396774800000
	                }
	            ]
	        },
	        {
	            "name": "America/Mexico_City",
	            "rules": [
	                {
	                    "e": 1225004400000,
	                    "s": 1207468800000
	                },
	                {
	                    "e": 1256454000000,
	                    "s": 1238918400000
	                },
	                {
	                    "e": 1288508400000,
	                    "s": 1270368000000
	                },
	                {
	                    "e": 1319958000000,
	                    "s": 1301817600000
	                },
	                {
	                    "e": 1351407600000,
	                    "s": 1333267200000
	                },
	                {
	                    "e": 1382857200000,
	                    "s": 1365321600000
	                },
	                {
	                    "e": 1414306800000,
	                    "s": 1396771200000
	                }
	            ]
	        },
	        {
	            "name": "America/Miquelon",
	            "rules": [
	                {
	                    "e": 1225598400000,
	                    "s": 1205038800000
	                },
	                {
	                    "e": 1257048000000,
	                    "s": 1236488400000
	                },
	                {
	                    "e": 1289102400000,
	                    "s": 1268542800000
	                },
	                {
	                    "e": 1320552000000,
	                    "s": 1299992400000
	                },
	                {
	                    "e": 1352001600000,
	                    "s": 1331442000000
	                },
	                {
	                    "e": 1383451200000,
	                    "s": 1362891600000
	                },
	                {
	                    "e": 1414900800000,
	                    "s": 1394341200000
	                }
	            ]
	        },
	        {
	            "name": "America/Santa_Isabel",
	            "rules": [
	                {
	                    "e": 1225011600000,
	                    "s": 1207476000000
	                },
	                {
	                    "e": 1256461200000,
	                    "s": 1238925600000
	                },
	                {
	                    "e": 1288515600000,
	                    "s": 1270375200000
	                },
	                {
	                    "e": 1319965200000,
	                    "s": 1301824800000
	                },
	                {
	                    "e": 1351414800000,
	                    "s": 1333274400000
	                },
	                {
	                    "e": 1382864400000,
	                    "s": 1365328800000
	                },
	                {
	                    "e": 1414314000000,
	                    "s": 1396778400000
	                }
	            ]
	        },
	        {
	            "name": "America/Santiago",
	            "rules": [
	                {
	                    "e": 1206846000000,
	                    "s": 1223784000000
	                },
	                {
	                    "e": 1237086000000,
	                    "s": 1255233600000
	                },
	                {
	                    "e": 1270350000000,
	                    "s": 1286683200000
	                },
	                {
	                    "e": 1304823600000,
	                    "s": 1313899200000
	                },
	                {
	                    "e": 1335668400000,
	                    "s": 1346558400000
	                },
	                {
	                    "e": 1367118000000,
	                    "s": 1378612800000
	                },
	                {
	                    "e": 1398567600000,
	                    "s": 1410062400000
	                }
	            ]
	        },
	        {
	            "name": "America/Sao_Paulo",
	            "rules": [
	                {
	                    "e": 1203213600000,
	                    "s": 1224385200000
	                },
	                {
	                    "e": 1234663200000,
	                    "s": 1255834800000
	                },
	                {
	                    "e": 1266717600000,
	                    "s": 1287284400000
	                },
	                {
	                    "e": 1298167200000,
	                    "s": 1318734000000
	                },
	                {
	                    "e": 1330221600000,
	                    "s": 1350788400000
	                },
	                {
	                    "e": 1361066400000,
	                    "s": 1382238000000
	                },
	                {
	                    "e": 1392516000000,
	                    "s": 1413687600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Amman",
	            "rules": [
	                {
	                    "e": 1225404000000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1256853600000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288303200000,
	                    "s": 1269554400000
	                },
	                {
	                    "e": 1319752800000,
	                    "s": 1301608800000
	                },
	                false,
	                false,
	                {
	                    "e": 1414706400000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Damascus",
	            "rules": [
	                {
	                    "e": 1225486800000,
	                    "s": 1207260000000
	                },
	                {
	                    "e": 1256850000000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1288299600000,
	                    "s": 1270159200000
	                },
	                {
	                    "e": 1319749200000,
	                    "s": 1301608800000
	                },
	                {
	                    "e": 1351198800000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1382648400000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414702800000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Dubai",
	            "rules": [
	                false,
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Gaza",
	            "rules": [
	                {
	                    "e": 1219957200000,
	                    "s": 1206655200000
	                },
	                {
	                    "e": 1252015200000,
	                    "s": 1238104800000
	                },
	                {
	                    "e": 1281474000000,
	                    "s": 1269640860000
	                },
	                {
	                    "e": 1312146000000,
	                    "s": 1301608860000
	                },
	                {
	                    "e": 1348178400000,
	                    "s": 1333058400000
	                },
	                {
	                    "e": 1380229200000,
	                    "s": 1364508000000
	                },
	                {
	                    "e": 1414098000000,
	                    "s": 1395957600000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Irkutsk",
	            "rules": [
	                {
	                    "e": 1224957600000,
	                    "s": 1206813600000
	                },
	                {
	                    "e": 1256407200000,
	                    "s": 1238263200000
	                },
	                {
	                    "e": 1288461600000,
	                    "s": 1269712800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Jerusalem",
	            "rules": [
	                {
	                    "e": 1223161200000,
	                    "s": 1206662400000
	                },
	                {
	                    "e": 1254006000000,
	                    "s": 1238112000000
	                },
	                {
	                    "e": 1284246000000,
	                    "s": 1269561600000
	                },
	                {
	                    "e": 1317510000000,
	                    "s": 1301616000000
	                },
	                {
	                    "e": 1348354800000,
	                    "s": 1333065600000
	                },
	                {
	                    "e": 1382828400000,
	                    "s": 1364515200000
	                },
	                {
	                    "e": 1414278000000,
	                    "s": 1395964800000
	                }
	            ]
	        },
	        {
	            "name": "Asia/Kamchatka",
	            "rules": [
	                {
	                    "e": 1224943200000,
	                    "s": 1206799200000
	                },
	                {
	                    "e": 1256392800000,
	                    "s": 1238248800000
	                },
	                {
	                    "e": 1288450800000,
	                    "s": 1269698400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Krasnoyarsk",
	            "rules": [
	                {
	                    "e": 1224961200000,
	                    "s": 1206817200000
	                },
	                {
	                    "e": 1256410800000,
	                    "s": 1238266800000
	                },
	                {
	                    "e": 1288465200000,
	                    "s": 1269716400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Omsk",
	            "rules": [
	                {
	                    "e": 1224964800000,
	                    "s": 1206820800000
	                },
	                {
	                    "e": 1256414400000,
	                    "s": 1238270400000
	                },
	                {
	                    "e": 1288468800000,
	                    "s": 1269720000000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Vladivostok",
	            "rules": [
	                {
	                    "e": 1224950400000,
	                    "s": 1206806400000
	                },
	                {
	                    "e": 1256400000000,
	                    "s": 1238256000000
	                },
	                {
	                    "e": 1288454400000,
	                    "s": 1269705600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yakutsk",
	            "rules": [
	                {
	                    "e": 1224954000000,
	                    "s": 1206810000000
	                },
	                {
	                    "e": 1256403600000,
	                    "s": 1238259600000
	                },
	                {
	                    "e": 1288458000000,
	                    "s": 1269709200000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yekaterinburg",
	            "rules": [
	                {
	                    "e": 1224968400000,
	                    "s": 1206824400000
	                },
	                {
	                    "e": 1256418000000,
	                    "s": 1238274000000
	                },
	                {
	                    "e": 1288472400000,
	                    "s": 1269723600000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Asia/Yerevan",
	            "rules": [
	                {
	                    "e": 1224972000000,
	                    "s": 1206828000000
	                },
	                {
	                    "e": 1256421600000,
	                    "s": 1238277600000
	                },
	                {
	                    "e": 1288476000000,
	                    "s": 1269727200000
	                },
	                {
	                    "e": 1319925600000,
	                    "s": 1301176800000
	                },
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Australia/Lord_Howe",
	            "rules": [
	                {
	                    "e": 1207407600000,
	                    "s": 1223134200000
	                },
	                {
	                    "e": 1238857200000,
	                    "s": 1254583800000
	                },
	                {
	                    "e": 1270306800000,
	                    "s": 1286033400000
	                },
	                {
	                    "e": 1301756400000,
	                    "s": 1317483000000
	                },
	                {
	                    "e": 1333206000000,
	                    "s": 1349537400000
	                },
	                {
	                    "e": 1365260400000,
	                    "s": 1380987000000
	                },
	                {
	                    "e": 1396710000000,
	                    "s": 1412436600000
	                }
	            ]
	        },
	        {
	            "name": "Australia/Perth",
	            "rules": [
	                {
	                    "e": 1206813600000,
	                    "s": 1224957600000
	                },
	                false,
	                false,
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Helsinki",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        },
	        {
	            "name": "Europe/Minsk",
	            "rules": [
	                {
	                    "e": 1224979200000,
	                    "s": 1206835200000
	                },
	                {
	                    "e": 1256428800000,
	                    "s": 1238284800000
	                },
	                {
	                    "e": 1288483200000,
	                    "s": 1269734400000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Europe/Moscow",
	            "rules": [
	                {
	                    "e": 1224975600000,
	                    "s": 1206831600000
	                },
	                {
	                    "e": 1256425200000,
	                    "s": 1238281200000
	                },
	                {
	                    "e": 1288479600000,
	                    "s": 1269730800000
	                },
	                false,
	                false,
	                false,
	                false
	            ]
	        },
	        {
	            "name": "Pacific/Apia",
	            "rules": [
	                false,
	                false,
	                false,
	                {
	                    "e": 1301752800000,
	                    "s": 1316872800000
	                },
	                {
	                    "e": 1333202400000,
	                    "s": 1348927200000
	                },
	                {
	                    "e": 1365256800000,
	                    "s": 1380376800000
	                },
	                {
	                    "e": 1396706400000,
	                    "s": 1411826400000
	                }
	            ]
	        },
	        {
	            "name": "Pacific/Fiji",
	            "rules": [
	                false,
	                false,
	                {
	                    "e": 1269698400000,
	                    "s": 1287842400000
	                },
	                {
	                    "e": 1327154400000,
	                    "s": 1319292000000
	                },
	                {
	                    "e": 1358604000000,
	                    "s": 1350741600000
	                },
	                {
	                    "e": 1390050000000,
	                    "s": 1382796000000
	                },
	                {
	                    "e": 1421503200000,
	                    "s": 1414850400000
	                }
	            ]
	        },
	        {
	            "name": "Europe/London",
	            "rules": [
	                {
	                    "e": 1224982800000,
	                    "s": 1206838800000
	                },
	                {
	                    "e": 1256432400000,
	                    "s": 1238288400000
	                },
	                {
	                    "e": 1288486800000,
	                    "s": 1269738000000
	                },
	                {
	                    "e": 1319936400000,
	                    "s": 1301187600000
	                },
	                {
	                    "e": 1351386000000,
	                    "s": 1332637200000
	                },
	                {
	                    "e": 1382835600000,
	                    "s": 1364691600000
	                },
	                {
	                    "e": 1414285200000,
	                    "s": 1396141200000
	                }
	            ]
	        }
	    ]
	};
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = jstz;
	} else if (("function" !== 'undefined' && __webpack_require__(567) !== null) && (__webpack_require__(2684) != null)) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return jstz;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
	    if (typeof root === 'undefined') {
	        window.jstz = jstz;
	    } else {
	        root.jstz = jstz;
	    }
	}
	}());


/***/ },
/* 1921 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1922 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1923 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198),
	    root = __webpack_require__(108);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1994),
	    hashDelete = __webpack_require__(1995),
	    hashGet = __webpack_require__(1996),
	    hashHas = __webpack_require__(1997),
	    hashSet = __webpack_require__(1998);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198),
	    root = __webpack_require__(108);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(198),
	    root = __webpack_require__(108);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1928 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1929 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 1930 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1931 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(278);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(280),
	    keys = __webpack_require__(234);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(280),
	    keysIn = __webpack_require__(486);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(469),
	    arrayEach = __webpack_require__(1930),
	    assignValue = __webpack_require__(710),
	    baseAssign = __webpack_require__(1933),
	    baseAssignIn = __webpack_require__(1934),
	    cloneBuffer = __webpack_require__(1969),
	    copyArray = __webpack_require__(1976),
	    copySymbols = __webpack_require__(1977),
	    copySymbolsIn = __webpack_require__(1978),
	    getAllKeys = __webpack_require__(723),
	    getAllKeysIn = __webpack_require__(724),
	    getTag = __webpack_require__(342),
	    initCloneArray = __webpack_require__(1999),
	    initCloneByTag = __webpack_require__(2000),
	    initCloneObject = __webpack_require__(2001),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(483),
	    isMap = __webpack_require__(2042),
	    isObject = __webpack_require__(101),
	    isSet = __webpack_require__(2043),
	    keys = __webpack_require__(234),
	    keysIn = __webpack_require__(486);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(101);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(278);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(278);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1981);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1940 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(711),
	    baseIsNaN = __webpack_require__(1947),
	    strictIndexOf = __webpack_require__(2029);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(468),
	    arrayIncludes = __webpack_require__(706),
	    arrayIncludesWith = __webpack_require__(707),
	    arrayMap = __webpack_require__(231),
	    baseUnary = __webpack_require__(279),
	    cacheHas = __webpack_require__(473);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(469),
	    equalArrays = __webpack_require__(721),
	    equalByTag = __webpack_require__(1987),
	    equalObjects = __webpack_require__(1988),
	    getTag = __webpack_require__(342),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(483),
	    isTypedArray = __webpack_require__(734);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(342),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(469),
	    baseIsEqual = __webpack_require__(472);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1947 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(37),
	    isMasked = __webpack_require__(2004),
	    isObject = __webpack_require__(101),
	    toSource = __webpack_require__(731);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(342),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(168),
	    isLength = __webpack_require__(484),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(479),
	    nativeKeys = __webpack_require__(2017);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(101),
	    isPrototype = __webpack_require__(479),
	    nativeKeysIn = __webpack_require__(2018);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1946),
	    getMatchData = __webpack_require__(1990),
	    matchesStrictComparable = __webpack_require__(727);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(472),
	    get = __webpack_require__(133),
	    hasIn = __webpack_require__(2039),
	    isKey = __webpack_require__(478),
	    isStrictComparable = __webpack_require__(726),
	    matchesStrictComparable = __webpack_require__(727),
	    toKey = __webpack_require__(281);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1955 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(339);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1957 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(2032),
	    defineProperty = __webpack_require__(720),
	    identity = __webpack_require__(232);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1959 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(278);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1961 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1962 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 1963 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(230),
	    arrayMap = __webpack_require__(231),
	    isArray = __webpack_require__(40),
	    isSymbol = __webpack_require__(233);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(2031);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(468),
	    arrayIncludes = __webpack_require__(706),
	    arrayIncludesWith = __webpack_require__(707),
	    cacheHas = __webpack_require__(473),
	    createSet = __webpack_require__(1985),
	    setToArray = __webpack_require__(481);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(340),
	    last = __webpack_require__(735),
	    parent = __webpack_require__(2020),
	    toKey = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(2041);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(108);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(474);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 1971 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(230);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(474);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(233);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1974);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1976 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(280),
	    getSymbols = __webpack_require__(476);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(280),
	    getSymbolsIn = __webpack_require__(725);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(108);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(199);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1981 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(99),
	    isArrayLike = __webpack_require__(199),
	    keys = __webpack_require__(234);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1957),
	    isIterateeCall = __webpack_require__(343),
	    toFinite = __webpack_require__(741);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(108),
	    toInteger = __webpack_require__(742),
	    toNumber = __webpack_require__(488),
	    toString = __webpack_require__(743);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite,
	    nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision && nativeIsFinite(number)) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(703),
	    noop = __webpack_require__(2049),
	    setToArray = __webpack_require__(481);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(485);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(230),
	    Uint8Array = __webpack_require__(704),
	    eq = __webpack_require__(345),
	    equalArrays = __webpack_require__(721),
	    mapToArray = __webpack_require__(2015),
	    setToArray = __webpack_require__(481);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(723);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(2037),
	    overRest = __webpack_require__(729),
	    setToString = __webpack_require__(730);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(726),
	    keys = __webpack_require__(234);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(230);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1992 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(340),
	    isArguments = __webpack_require__(482),
	    isArray = __webpack_require__(40),
	    isIndex = __webpack_require__(477),
	    isLength = __webpack_require__(484),
	    toKey = __webpack_require__(281);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(344);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1995 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(344);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(344);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(344);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1999 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(474),
	    cloneDataView = __webpack_require__(1970),
	    cloneRegExp = __webpack_require__(1971),
	    cloneSymbol = __webpack_require__(1972),
	    cloneTypedArray = __webpack_require__(1973);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1936),
	    getPrototype = __webpack_require__(475),
	    isPrototype = __webpack_require__(479);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(230),
	    isArguments = __webpack_require__(482),
	    isArray = __webpack_require__(40);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 2003 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1979);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 2005 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(337);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(337);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(337);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(337);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1925),
	    ListCache = __webpack_require__(336),
	    Map = __webpack_require__(466);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(341);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(341);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(341);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(341);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 2015 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(2047);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(728);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 2018 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 2019 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(339),
	    baseSlice = __webpack_require__(1959);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 2021 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 2022 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 2023 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(336);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 2025 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 2026 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 2027 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(336),
	    Map = __webpack_require__(466),
	    MapCache = __webpack_require__(467);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 2029 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2016);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 2031 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 2032 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(705),
	    baseFilter = __webpack_require__(1938),
	    baseIteratee = __webpack_require__(99),
	    isArray = __webpack_require__(40);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1982),
	    findIndex = __webpack_require__(2035);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(711),
	    baseIteratee = __webpack_require__(99),
	    toInteger = __webpack_require__(742);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(471),
	    map = __webpack_require__(2045);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(471);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(277),
	    createAggregator = __webpack_require__(719);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1940),
	    hasPath = __webpack_require__(1993);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(231),
	    baseIntersection = __webpack_require__(1942),
	    baseRest = __webpack_require__(718),
	    castArrayLikeObject = __webpack_require__(1968);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(199),
	    isObjectLike = __webpack_require__(123);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1945),
	    baseUnary = __webpack_require__(279),
	    nodeUtil = __webpack_require__(480);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1949),
	    baseUnary = __webpack_require__(279),
	    nodeUtil = __webpack_require__(480);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(277),
	    createAggregator = __webpack_require__(719);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(231),
	    baseIteratee = __webpack_require__(99),
	    baseMap = __webpack_require__(716),
	    isArray = __webpack_require__(40);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(277),
	    baseForOwn = __webpack_require__(712),
	    baseIteratee = __webpack_require__(99);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(467);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(338),
	    baseIteratee = __webpack_require__(99),
	    baseLt = __webpack_require__(715);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 2049 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(108);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1955),
	    basePropertyDeep = __webpack_require__(1956),
	    isKey = __webpack_require__(478),
	    toKey = __webpack_require__(281);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(1984);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(709),
	    baseIteratee = __webpack_require__(99),
	    baseSome = __webpack_require__(1960),
	    isArray = __webpack_require__(40),
	    isIterateeCall = __webpack_require__(343);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 2054 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(99),
	    baseSum = __webpack_require__(1962);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(732),
	    isObject = __webpack_require__(101);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2061);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var Mexp = __webpack_require__(2059)
	function inc(arr, val) {
		for (var i = 0; i < arr.length; i++) {
			arr[i] += val
		}
		return arr
	}
	var tokens = [
		{ token: 'sin', show: 'sin', type: 0, value: Mexp.math.sin },
		{ token: 'cos', show: 'cos', type: 0, value: Mexp.math.cos },
		{ token: 'tan', show: 'tan', type: 0, value: Mexp.math.tan },
		{ token: 'pi', show: '&pi;', type: 3, value: 'PI' },
		{ token: '(', show: '(', type: 4, value: '(' },
		{ token: ')', show: ')', type: 5, value: ')' },
		{ token: 'P', show: 'P', type: 10, value: Mexp.math.P },
		{ token: 'C', show: 'C', type: 10, value: Mexp.math.C },
		{ token: ' ', show: ' ', type: 14, value: ' '.anchor },
		{ token: 'asin', show: 'asin', type: 0, value: Mexp.math.asin },
		{ token: 'acos', show: 'acos', type: 0, value: Mexp.math.acos },
		{ token: 'atan', show: 'atan', type: 0, value: Mexp.math.atan },
		{ token: '7', show: '7', type: 1, value: '7' },
		{ token: '8', show: '8', type: 1, value: '8' },
		{ token: '9', show: '9', type: 1, value: '9' },
		{ token: 'int', show: 'Int', type: 0, value: Math.floor },
		{ token: 'cosh', show: 'cosh', type: 0, value: Mexp.math.cosh },
		{ token: 'acosh', show: 'acosh', type: 0, value: Mexp.math.acosh },
		{ token: 'ln', show: ' ln', type: 0, value: Math.log },
		{ token: '^', show: '^', type: 10, value: Math.pow },
		{ token: 'root', show: 'root', type: 0, value: Math.sqrt },
		{ token: '4', show: '4', type: 1, value: '4' },
		{ token: '5', show: '5', type: 1, value: '5' },
		{ token: '6', show: '6', type: 1, value: '6' },
		{ token: '/', show: '&divide;', type: 2, value: Mexp.math.div },
		{ token: '!', show: '!', type: 7, value: Mexp.math.fact },
		{ token: 'tanh', show: 'tanh', type: 0, value: Mexp.math.tanh },
		{ token: 'atanh', show: 'atanh', type: 0, value: Mexp.math.atanh },
		{ token: 'Mod', show: ' Mod ', type: 2, value: Mexp.math.mod },
		{ token: '1', show: '1', type: 1, value: '1' },
		{ token: '2', show: '2', type: 1, value: '2' },
		{ token: '3', show: '3', type: 1, value: '3' },
		{ token: '*', show: '&times;', type: 2, value: Mexp.math.mul },
		{ token: 'sinh', show: 'sinh', type: 0, value: Mexp.math.sinh },
		{ token: 'asinh', show: 'asinh', type: 0, value: Mexp.math.asinh },
		{ token: 'e', show: 'e', type: 3, value: 'E' },
		{ token: 'log', show: ' log', type: 0, value: Mexp.math.log },
		{ token: '0', show: '0', type: 1, value: '0' },
		{ token: '.', show: '.', type: 6, value: '.' },
		{ token: '+', show: '+', type: 9, value: Mexp.math.add },
		{ token: '-', show: '-', type: 9, value: Mexp.math.sub },
		{ token: ',', show: ',', type: 11, value: ',' },
		{ token: 'Sigma', show: '&Sigma;', type: 12, value: Mexp.math.sigma },
		{ token: 'n', show: 'n', type: 13, value: 'n' },
		{ token: 'Pi', show: '&Pi;', type: 12, value: Mexp.math.Pi },
		{ token: 'pow', show: 'pow', type: 8, value: Math.pow, numberOfArguments: 2 },
		{ token: '&', show: '&', type: 9, value: Mexp.math.and },
	]
	var preced = {
		0: 11,
		1: 0,
		2: 3,
		3: 0,
		4: 0,
		5: 0,
		6: 0,
		7: 11,
		8: 11,
		9: 1,
		10: 10,
		11: 0,
		12: 11,
		13: 0,
		14: -1,
		15: 11, // will be filtered after lexer
	} // stores precedence by types
	for (var i = 0; i < tokens.length; i++) {
		tokens[i].precedence = preced[tokens[i].type]
	}
	var type0 = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		9: true,
		12: true,
		13: true,
		14: true,
		15: true,
	} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
	var type1 = {
		0: true,
		1: true,
		2: true,
		3: true,
		4: true,
		5: true,
		6: true,
		7: true,
		8: true,
		9: true,
		10: true,
		11: true,
		12: true,
		13: true,
		15: true,
	} // type3:true,type5:true,type7:true,type23
	var type1Asterick = {
		0: true,
		3: true,
		4: true,
		8: true,
		12: true,
		13: true,
		15: true,
	}
	var empty = {}
	var type3Asterick = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		12: true,
		13: true,
		15: true,
	} // type_5:true,type_7:true,type_23
	var type6 = {
		1: true,
	}
	var newAr = [
		[],
		[
			'1',
			'2',
			'3',
			'7',
			'8',
			'9',
			'4',
			'5',
			'6',
			'+',
			'-',
			'*',
			'/',
			'(',
			')',
			'^',
			'!',
			'P',
			'C',
			'e',
			'0',
			'.',
			',',
			'n',
			' ',
			'&',
		],
		['pi', 'ln', 'Pi'],
		['sin', 'cos', 'tan', 'Del', 'int', 'Mod', 'log', 'pow'],
		['asin', 'acos', 'atan', 'cosh', 'root', 'tanh', 'sinh'],
		['acosh', 'atanh', 'asinh', 'Sigma'],
	]
	
	function match(str1, str2, i, x) {
		for (var f = 0; f < x; f++) {
			if (str1[i + f] !== str2[f]) {
				return false
			}
		}
		return true
	}
	Mexp.tokenTypes = {
		FUNCTION_WITH_ONE_ARG: 0,
		NUMBER: 1,
		BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
		CONSTANT: 3,
		OPENING_PARENTHESIS: 4,
		CLOSING_PARENTHESIS: 5,
		DECIMAL: 6,
		POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
		FUNCTION_WITH_N_ARGS: 8,
		BINARY_OPERATOR_LOW_PRECENDENCE: 9,
		BINARY_OPERATOR_PERMUTATION: 10,
		COMMA: 11,
		EVALUATED_FUNCTION: 12,
		EVALUATED_FUNCTION_PARAMETER: 13,
		SPACE: 14,
	}
	/**
	  
	  0 : function with syntax function_name(Maths_exp)
	  1 : numbers
	  2 : binary operators like * / Mod left associate and same precedence
	  3 : Math constant values like e,pi,Cruncher ans
	  4 : opening bracket
	  5 : closing bracket
	  6 : decimal
	  7 : function with syntax (Math_exp)function_name
	  8: function with syntax function_name(Math_exp1,Math_exp2)
	  9 : binary operator like +,-
	  10: binary operator like P C or ^
	  11: ,
	  12: function with , seperated three parameters and third parameter is a string that will be mexp string
	  13: variable of Sigma function
	 */
	Mexp.addToken = function (newTokens) {
		for (var i = 0; i < newTokens.length; i++) {
			var x = newTokens[i].token.length
			var temp = -1
			if (newTokens[i].type === Mexp.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) {
				newTokens[i].numberOfArguments = 2
			}
	
			// newAr is a specially designed data structure index of 1d array = length of tokens
			newAr[x] = newAr[x] || []
			for (var y = 0; y < newAr[x].length; y++) {
				if (newTokens[i].token === newAr[x][y]) {
					temp = indexOfToken(newAr[x][y], tokens)
					break
				}
			}
			if (temp === -1) {
				tokens.push(newTokens[i])
				newTokens[i].precedence = preced[newTokens[i].type]
				if (newAr.length <= newTokens[i].token.length) {
					newAr[newTokens[i].token.length] = []
				}
				newAr[newTokens[i].token.length].push(newTokens[i].token)
			} else {
				// overwrite
				tokens[temp] = newTokens[i]
				newTokens[i].precedence = preced[newTokens[i].type]
			}
		}
	}
	
	function indexOfToken(key, tokens) {
		for (var search = 0; search < tokens.length; search++) {
			if (tokens[search].token === key) return search
		}
		return -1
	}
	function tokenize(string) {
		var nodes = []
		var length = string.length
		var key, x, y
		for (var i = 0; i < length; i++) {
			if (i < length - 1 && string[i] === ' ' && string[i + 1] === ' ') {
				continue
			}
			key = ''
			for (x = string.length - i > newAr.length - 2 ? newAr.length - 1 : string.length - i; x > 0; x--) {
				if (newAr[x] === undefined) continue
				for (y = 0; y < newAr[x].length; y++) {
					if (match(string, newAr[x][y], i, x)) {
						key = newAr[x][y]
						y = newAr[x].length
						x = 0
					}
				}
			}
			i += key.length - 1
			if (key === '') {
				throw new Mexp.Exception("Can't understand after " + string.slice(i))
			}
			nodes.push(tokens[indexOfToken(key, tokens)])
		}
		return nodes
	}
	
	var changeSignObj = {
		value: Mexp.math.changeSign,
		type: 0,
		pre: 21,
		show: '-',
	}
	var closingParObj = {
		value: ')',
		show: ')',
		type: 5,
		pre: 0,
	}
	var openingParObj = {
		value: '(',
		type: 4,
		pre: 0,
		show: '(',
	}
	Mexp.lex = function (inp, tokens) {
		'use strict'
	
		var str = [openingParObj]
	
		var ptc = [] // Parenthesis to close at the beginning is after one token
		var inpStr = inp
		var allowed = type0
		var bracToClose = 0
		var asterick = empty
		var prevKey = ''
		var i
		if (typeof tokens !== 'undefined') {
			Mexp.addToken(tokens)
		}
		var obj = {}
		var nodes = tokenize(inpStr)
		for (i = 0; i < nodes.length; i++) {
			var node = nodes[i]
			if (node.type === 14) {
				if (
					i > 0 &&
					i < nodes.length - 1 &&
					nodes[i + 1].type === 1 &&
					(nodes[i - 1].type === 1 || nodes[i - 1].type === 6)
				) {
					throw new Mexp.Exception('Unexpected Space')
				}
				continue
			}
			var cToken = node.token
			var cType = node.type
			var cEv = node.value
			var cPre = node.precedence
			var cShow = node.show
			var pre = str[str.length - 1]
			var j
			for (j = ptc.length; j--; ) {
				// loop over ptc
				if (ptc[j] === 0) {
					if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(cType) !== -1) {
						if (allowed[cType] !== true) {
							throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
						}
						str.push(closingParObj)
						allowed = type1
						asterick = type3Asterick
						ptc.pop()
					}
				} else break
			}
			if (allowed[cType] !== true) {
				throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
			}
			if (asterick[cType] === true) {
				cType = 2
				cEv = Mexp.math.mul
				cShow = '&times;'
				cPre = 3
				i = i - 1
			}
			obj = {
				value: cEv,
				type: cType,
				pre: cPre,
				show: cShow,
				numberOfArguments: node.numberOfArguments,
			}
			if (cType === 0) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(2)
				}
				// bracToClose++
			} else if (cType === 1) {
				if (pre.type === 1) {
					pre.value += cEv
					inc(ptc, 1)
				} else {
					str.push(obj)
				}
				allowed = type1
				asterick = type1Asterick
			} else if (cType === 2) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 3) {
				// constant
				str.push(obj)
				allowed = type1
				asterick = type3Asterick
			} else if (cType === 4) {
				inc(ptc, 1)
				bracToClose++
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 5) {
				if (!bracToClose) {
					throw new Mexp.Exception('Closing parenthesis are more than opening one, wait What!!!')
				}
				bracToClose--
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
				inc(ptc, 1)
			} else if (cType === 6) {
				if (pre.hasDec) {
					throw new Mexp.Exception('Two decimals are not allowed in one number')
				}
				if (pre.type !== 1) {
					pre = {
						value: 0,
						type: 1,
						pre: 0,
					} // pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre)
					// inc(ptc, 1)
				}
				allowed = type6
				inc(ptc, 1)
				asterick = empty
				pre.value += cEv
				pre.hasDec = true
			} else if (cType === 7) {
				allowed = type1
				asterick = type3Asterick
				inc(ptc, 1)
				str.push(obj)
			}
			if (cType === 8) {
				allowed = type0
				asterick = empty
				inc(ptc, node.numberOfArguments + 2)
				str.push(obj)
				// str.push(openingParObj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(node.numberOfArguments + 2)
				}
			} else if (cType === 9) {
				if (pre.type === 9) {
					if (pre.value === Mexp.math.add) {
						pre.value = cEv
						pre.show = cShow
						inc(ptc, 1)
					} else if (pre.value === Mexp.math.sub && cShow === '-') {
						pre.value = Mexp.math.add
						pre.show = '+'
						inc(ptc, 1)
					}
				} else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) {
					// changesign only when negative is found
					if (cToken === '-') {
						// do nothing for + token
						// don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed = type0
						asterick = empty
						inc(ptc, 2).push(2)
						str.push(changeSignObj)
						str.push(openingParObj)
					}
				} else {
					str.push(obj)
					inc(ptc, 2)
				}
				allowed = type0
				asterick = empty
			} else if (cType === 10) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 11) {
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 12) {
				allowed = type0
				asterick = empty
				inc(ptc, 6)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(6)
				}
			} else if (cType === 13) {
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
			}
	
			inc(ptc, -1)
			prevKey = cToken
		}
		for (j = ptc.length; j--; ) {
			// loop over ptc
			str.push(closingParObj)
		}
		if (allowed[5] !== true) {
			throw new Mexp.Exception('complete the expression')
		}
		while (bracToClose--) {
			str.push(closingParObj)
		}
	
		str.push(closingParObj)
		//        console.log(str);
		return new Mexp(str)
	}
	module.exports = Mexp


/***/ },
/* 2059 */
/***/ function(module, exports) {

	"use strict";
	var Mexp = function (parsed) {
	  this.value = parsed
	}
	
	Mexp.math = {
	  isDegree: true, // mode of calculator
	  acos: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x))
	  },
	  add: function (a, b) {
	    return a + b
	  },
	  asin: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x))
	  },
	  atan: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x))
	  },
	  acosh: function (x) {
	    return Math.log(x + Math.sqrt(x * x - 1))
	  },
	  asinh: function (x) {
	    return Math.log(x + Math.sqrt(x * x + 1))
	  },
	  atanh: function (x) {
	    return Math.log((1 + x) / (1 - x))
	  },
	  C: function (n, r) {
	    var pro = 1
	    var other = n - r
	    var choice = r
	    if (choice < other) {
	      choice = other
	      other = r
	    }
	    for (var i = choice + 1; i <= n; i++) {
	      pro *= i
	    }
	    return pro / Mexp.math.fact(other)
	  },
	  changeSign: function (x) {
	    return -x
	  },
	  cos: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.cos(x)
	  },
	  cosh: function (x) {
	    return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2
	  },
	  div: function (a, b) {
	    return a / b
	  },
	  fact: function (n) {
	    if (n % 1 !== 0) return 'NaN'
	    var pro = 1
	    for (var i = 2; i <= n; i++) {
	      pro *= i
	    }
	    return pro
	  },
	  inverse: function (x) {
	    return 1 / x
	  },
	  log: function (i) {
	    return Math.log(i) / Math.log(10)
	  },
	  mod: function (a, b) {
	    return a % b
	  },
	  mul: function (a, b) {
	    return a * b
	  },
	  P: function (n, r) {
	    var pro = 1
	    for (var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++) {
	      pro *= i
	    }
	    return pro
	  },
	  Pi: function (low, high, ex) {
	    var pro = 1
	    for (var i = low; i <= high; i++) {
	      pro *= Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return pro
	  },
	  pow10x: function (e) {
	    var x = 1
	    while (e--) {
	      x *= 10
	    }
	    return x
	  },
	  sigma: function (low, high, ex) {
	    var sum = 0
	    for (var i = low; i <= high; i++) {
	      sum += Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return sum
	  },
	  sin: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.sin(x)
	  },
	  sinh: function (x) {
	    return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2
	  },
	  sub: function (a, b) {
	    return a - b
	  },
	  tan: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.tan(x)
	  },
	  tanh: function (x) {
	    return Mexp.sinha(x) / Mexp.cosha(x)
	  },
	  toRadian: function (x) {
	    return x * Math.PI / 180
	  },
	  and: function (a, b) {
	    return a & b
	  }
	}
	Mexp.Exception = function (message) {
	  this.message = message
	}
	module.exports = Mexp


/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	
	var Mexp = __webpack_require__(2058);
	
	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post = [], elem, popped, prep, pre, ele;
		var stack = [{ value: "(", type: 4, pre: 0 }];
		var arr = this.value;
		for (var i = 1; i < arr.length; i++) {
			if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {	//if token is number,constant,or n(which is also a special constant in our case)
				if (arr[i].type === 1)
					arr[i].value = Number(arr[i].value);
				post.push(arr[i]);
			}
			else if (arr[i].type === 4) {
				stack.push(arr[i]);
			}
			else if (arr[i].type === 5) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
			}
			else if (arr[i].type === 11) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem = arr[i];
				pre = elem.pre;
				ele = stack[stack.length - 1];
				prep = ele.pre;
				var flag = ele.value == 'Math.pow' && elem.value == 'Math.pow';
				if (pre > prep) stack.push(elem);
				else {
					while (prep >= pre && !flag || flag && pre < prep) {
						popped = stack.pop();
						ele = stack[stack.length - 1];
						post.push(popped);
						prep = ele.pre;
						flag = elem.value == 'Math.pow' && ele.value == 'Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
	module.exports = Mexp;

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp = __webpack_require__(2060)
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict'
		UserDefined = UserDefined || {}
		UserDefined.PI = Math.PI
		UserDefined.E = Math.E
		var stack = [],
			pop1,
			pop2,
			pop3
		var disp = []
		var temp = ''
		var arr = this.value
		var bool = typeof UserDefined.n !== 'undefined'
		for (var i = 0; i < arr.length; i++) {
			if (arr[i].type === 1) {
				stack.push({ value: arr[i].value, type: 1 })
			} else if (arr[i].type === 3) {
				stack.push({ value: UserDefined[arr[i].value], type: 1 })
			} else if (arr[i].type === 0) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 7) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 8) {
				var popped = []
				for (var x = 0; x < arr[i].numberOfArguments; x++) {
					popped.push(stack.pop().value)
				}
				stack.push({ type: 1, value: arr[i].value.apply(arr[i], popped.reverse()) })
			} else if (arr[i].type === 10) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2.value = pop2.concat(pop1)
					pop2.value.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 2 || arr[i].type === 9) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2 = pop2.concat(pop1)
					pop2.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 12) {
				pop1 = stack.pop()
				if (typeof pop1.type !== 'undefined') {
					pop1 = [pop1]
				}
				pop2 = stack.pop()
				pop3 = stack.pop()
				stack.push({ type: 1, value: arr[i].value(pop3.value, pop2.value, new Mexp(pop1)) })
			} else if (arr[i].type === 13) {
				if (bool) {
					stack.push({ value: UserDefined[arr[i].value], type: 3 })
				} else stack.push([arr[i]])
			}
		}
		if (stack.length > 1) {
			throw new Mexp.Exception('Uncaught Syntax error')
		}
		return stack[0].value > 1000000000000000 ? 'Infinity' : parseFloat(stack[0].value.toFixed(15))
	}
	Mexp.eval = function (str, tokens, obj) {
		if (typeof tokens === 'undefined') {
			return this.lex(str).toPostfix().postfixEval()
		} else if (typeof obj === 'undefined') {
			if (typeof tokens.length !== 'undefined') return this.lex(str, tokens).toPostfix().postfixEval()
			else return this.lex(str).toPostfix().postfixEval(tokens)
		} else return this.lex(str, tokens).toPostfix().postfixEval(obj)
	}
	module.exports = Mexp


/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(1804),
	      utf8 = __webpack_require__(616).utf8,
	      isBuffer = __webpack_require__(1914),
	      bin = __webpack_require__(616).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.4.5 2021-03-13*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
	        "Pixel": "; \\bPixel\\b",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
	        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
	        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "Xiaomi": "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo (3DS|Switch)",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "OnePlus": "ONEPLUS",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "GoogleTablet": "Android.*Pixel C",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android [0-9.]+; [a-z-]+; \\bG1\\b",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9|TECNO DP8D",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
	        "iPadOS": "CPU OS 13",
	        "SailfishOS": "Sailfish",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "\\bEdgiOS\\b|Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "WeChat": "\\bMicroMessenger\\b",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UCBrowser": [
	            "UCWEB[VER]",
	            "UC.*Browser\/[VER]"
	        ],
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "SailfishBrowser": "SailfishBrowser\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "Sailfish": "Sailfish [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    function prepareUserAgent(userAgent) {
	        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = prepareUserAgent(userAgent);
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
	         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
	         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
	         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
	         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
	         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
	         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
	         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
	         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
	         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
	         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
	         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
	         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
	         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
	         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
	         * GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
	         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
	         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
	         * NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
	         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
	         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
	         * NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.4.5 2021-03-13';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(567);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.40
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(5)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.40",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 745,
		"./af.js": 745,
		"./ar": 752,
		"./ar-dz": 746,
		"./ar-dz.js": 746,
		"./ar-kw": 747,
		"./ar-kw.js": 747,
		"./ar-ly": 748,
		"./ar-ly.js": 748,
		"./ar-ma": 749,
		"./ar-ma.js": 749,
		"./ar-sa": 750,
		"./ar-sa.js": 750,
		"./ar-tn": 751,
		"./ar-tn.js": 751,
		"./ar.js": 752,
		"./az": 753,
		"./az.js": 753,
		"./be": 754,
		"./be.js": 754,
		"./bg": 755,
		"./bg.js": 755,
		"./bm": 756,
		"./bm.js": 756,
		"./bn": 758,
		"./bn-bd": 757,
		"./bn-bd.js": 757,
		"./bn.js": 758,
		"./bo": 759,
		"./bo.js": 759,
		"./br": 760,
		"./br.js": 760,
		"./bs": 761,
		"./bs.js": 761,
		"./ca": 762,
		"./ca.js": 762,
		"./cs": 763,
		"./cs.js": 763,
		"./cv": 764,
		"./cv.js": 764,
		"./cy": 765,
		"./cy.js": 765,
		"./da": 766,
		"./da.js": 766,
		"./de": 769,
		"./de-at": 767,
		"./de-at.js": 767,
		"./de-ch": 768,
		"./de-ch.js": 768,
		"./de.js": 769,
		"./dv": 770,
		"./dv.js": 770,
		"./el": 771,
		"./el.js": 771,
		"./en-au": 772,
		"./en-au.js": 772,
		"./en-ca": 773,
		"./en-ca.js": 773,
		"./en-gb": 774,
		"./en-gb.js": 774,
		"./en-ie": 775,
		"./en-ie.js": 775,
		"./en-il": 776,
		"./en-il.js": 776,
		"./en-in": 777,
		"./en-in.js": 777,
		"./en-nz": 778,
		"./en-nz.js": 778,
		"./en-sg": 779,
		"./en-sg.js": 779,
		"./eo": 780,
		"./eo.js": 780,
		"./es": 784,
		"./es-do": 781,
		"./es-do.js": 781,
		"./es-mx": 782,
		"./es-mx.js": 782,
		"./es-us": 783,
		"./es-us.js": 783,
		"./es.js": 784,
		"./et": 785,
		"./et.js": 785,
		"./eu": 786,
		"./eu.js": 786,
		"./fa": 787,
		"./fa.js": 787,
		"./fi": 788,
		"./fi.js": 788,
		"./fil": 789,
		"./fil.js": 789,
		"./fo": 790,
		"./fo.js": 790,
		"./fr": 793,
		"./fr-ca": 791,
		"./fr-ca.js": 791,
		"./fr-ch": 792,
		"./fr-ch.js": 792,
		"./fr.js": 793,
		"./fy": 794,
		"./fy.js": 794,
		"./ga": 795,
		"./ga.js": 795,
		"./gd": 796,
		"./gd.js": 796,
		"./gl": 797,
		"./gl.js": 797,
		"./gom-deva": 798,
		"./gom-deva.js": 798,
		"./gom-latn": 799,
		"./gom-latn.js": 799,
		"./gu": 800,
		"./gu.js": 800,
		"./he": 801,
		"./he.js": 801,
		"./hi": 802,
		"./hi.js": 802,
		"./hr": 803,
		"./hr.js": 803,
		"./hu": 804,
		"./hu.js": 804,
		"./hy-am": 805,
		"./hy-am.js": 805,
		"./id": 806,
		"./id.js": 806,
		"./is": 807,
		"./is.js": 807,
		"./it": 809,
		"./it-ch": 808,
		"./it-ch.js": 808,
		"./it.js": 809,
		"./ja": 810,
		"./ja.js": 810,
		"./jv": 811,
		"./jv.js": 811,
		"./ka": 812,
		"./ka.js": 812,
		"./kk": 813,
		"./kk.js": 813,
		"./km": 814,
		"./km.js": 814,
		"./kn": 815,
		"./kn.js": 815,
		"./ko": 816,
		"./ko.js": 816,
		"./ku": 817,
		"./ku.js": 817,
		"./ky": 818,
		"./ky.js": 818,
		"./lb": 819,
		"./lb.js": 819,
		"./lo": 820,
		"./lo.js": 820,
		"./lt": 821,
		"./lt.js": 821,
		"./lv": 822,
		"./lv.js": 822,
		"./me": 823,
		"./me.js": 823,
		"./mi": 824,
		"./mi.js": 824,
		"./mk": 825,
		"./mk.js": 825,
		"./ml": 826,
		"./ml.js": 826,
		"./mn": 827,
		"./mn.js": 827,
		"./mr": 828,
		"./mr.js": 828,
		"./ms": 830,
		"./ms-my": 829,
		"./ms-my.js": 829,
		"./ms.js": 830,
		"./mt": 831,
		"./mt.js": 831,
		"./my": 832,
		"./my.js": 832,
		"./nb": 833,
		"./nb.js": 833,
		"./ne": 834,
		"./ne.js": 834,
		"./nl": 836,
		"./nl-be": 835,
		"./nl-be.js": 835,
		"./nl.js": 836,
		"./nn": 837,
		"./nn.js": 837,
		"./oc-lnc": 838,
		"./oc-lnc.js": 838,
		"./pa-in": 839,
		"./pa-in.js": 839,
		"./pl": 840,
		"./pl.js": 840,
		"./pt": 842,
		"./pt-br": 841,
		"./pt-br.js": 841,
		"./pt.js": 842,
		"./ro": 843,
		"./ro.js": 843,
		"./ru": 844,
		"./ru.js": 844,
		"./sd": 845,
		"./sd.js": 845,
		"./se": 846,
		"./se.js": 846,
		"./si": 847,
		"./si.js": 847,
		"./sk": 848,
		"./sk.js": 848,
		"./sl": 849,
		"./sl.js": 849,
		"./sq": 850,
		"./sq.js": 850,
		"./sr": 852,
		"./sr-cyrl": 851,
		"./sr-cyrl.js": 851,
		"./sr.js": 852,
		"./ss": 853,
		"./ss.js": 853,
		"./sv": 854,
		"./sv.js": 854,
		"./sw": 855,
		"./sw.js": 855,
		"./ta": 856,
		"./ta.js": 856,
		"./te": 857,
		"./te.js": 857,
		"./tet": 858,
		"./tet.js": 858,
		"./tg": 859,
		"./tg.js": 859,
		"./th": 860,
		"./th.js": 860,
		"./tk": 861,
		"./tk.js": 861,
		"./tl-ph": 862,
		"./tl-ph.js": 862,
		"./tlh": 863,
		"./tlh.js": 863,
		"./tr": 864,
		"./tr.js": 864,
		"./tzl": 865,
		"./tzl.js": 865,
		"./tzm": 867,
		"./tzm-latn": 866,
		"./tzm-latn.js": 866,
		"./tzm.js": 867,
		"./ug-cn": 868,
		"./ug-cn.js": 868,
		"./uk": 869,
		"./uk.js": 869,
		"./ur": 870,
		"./ur.js": 870,
		"./uz": 872,
		"./uz-latn": 871,
		"./uz-latn.js": 871,
		"./uz.js": 872,
		"./vi": 873,
		"./vi.js": 873,
		"./x-pseudo": 874,
		"./x-pseudo.js": 874,
		"./yo": 875,
		"./yo.js": 875,
		"./zh-cn": 876,
		"./zh-cn.js": 876,
		"./zh-hk": 877,
		"./zh-hk.js": 877,
		"./zh-mo": 878,
		"./zh-mo.js": 878,
		"./zh-tw": 879,
		"./zh-tw.js": 879
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2065;


/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.5
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
	        // not the initial event target in the shadow tree. Note that not all events cross the
	        // shadow boundary.
	        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
	        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
	        // target cannot be obtained.
	        if ('composedPath' in e && typeof e.composedPath === 'function') {
	            // For open shadow trees, update `element` so that the following check works.
	            var initialEventTarget = e.composedPath()[0];
	            if (initialEventTarget !== e.target) {
	                element = initialEventTarget;
	            }
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 2069 */
/***/ function(module, exports) {

	var div = null
	var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]
	
	module.exports = function prefixStyle (prop) {
	  // re-use a dummy div
	  if (!div) {
	    div = document.createElement('div')
	  }
	
	  var style = div.style
	
	  // prop exists without prefix
	  if (prop in style) {
	    return prop
	  }
	
	  // borderRadius -> BorderRadius
	  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)
	
	  // find the vendor-prefixed prop
	  for (var i = prefixes.length; i >= 0; i--) {
	    var name = prefixes[i] + titleCase
	    // e.g. WebkitBorderRadius or webkitBorderRadius
	    if (name in style) {
	      return name
	    }
	  }
	
	  return false
	}


/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(880);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(880);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(2073);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(882);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(291);
	var assign = __webpack_require__(45);
	
	var ReactPropTypesSecret = __webpack_require__(882);
	var has = __webpack_require__(2077);
	var checkPropTypes = __webpack_require__(2074);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2077 */
/***/ function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(2536);
	var objectAssign = __webpack_require__(45);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2085).default;
	module.exports.default = module.exports;


/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appendImportantToEachValue;
	
	var _appendPxIfNeeded = __webpack_require__(883);
	
	var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
	var _mapObject = __webpack_require__(890);
	
	var _mapObject2 = _interopRequireDefault(_mapObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function appendImportantToEachValue(style) {
	  return (0, _mapObject2.default)(style, function (result, key) {
	    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
	  });
	}

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhancer = __webpack_require__(886);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _styleKeeper = __webpack_require__(491);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	var _styleSheet = __webpack_require__(2082);
	
	var _styleSheet2 = _interopRequireDefault(_styleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _getStyleKeeper(instance) {
	  if (!instance._radiumStyleKeeper) {
	    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
	    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
	  }
	
	  return instance._radiumStyleKeeper;
	}
	
	var StyleRoot = function (_PureComponent) {
	  _inherits(StyleRoot, _PureComponent);
	
	  function StyleRoot() {
	    _classCallCheck(this, StyleRoot);
	
	    var _this = _possibleConstructorReturn(this, (StyleRoot.__proto__ || Object.getPrototypeOf(StyleRoot)).apply(this, arguments));
	
	    _getStyleKeeper(_this);
	    return _this;
	  }
	
	  _createClass(StyleRoot, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { _radiumStyleKeeper: _getStyleKeeper(this) };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      /* eslint-disable no-unused-vars */
	      // Pass down all props except config to the rendered div.
	      var _props = this.props,
	          radiumConfig = _props.radiumConfig,
	          otherProps = _objectWithoutProperties(_props, ['radiumConfig']);
	      /* eslint-enable no-unused-vars */
	
	      return _react2.default.createElement(
	        'div',
	        otherProps,
	        this.props.children,
	        _react2.default.createElement(_styleSheet2.default, null)
	      );
	    }
	  }]);
	
	  return StyleRoot;
	}(_react.PureComponent);
	
	StyleRoot.contextTypes = {
	  _radiumConfig: _propTypes2.default.object,
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	};
	
	StyleRoot.childContextTypes = {
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	};
	
	StyleRoot = (0, _enhancer2.default)(StyleRoot);
	
	exports.default = StyleRoot;

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styleKeeper = __webpack_require__(491);
	
	var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleSheet = (_temp = _class = function (_PureComponent) {
	  _inherits(StyleSheet, _PureComponent);
	
	  function StyleSheet() {
	    _classCallCheck(this, StyleSheet);
	
	    var _this = _possibleConstructorReturn(this, (StyleSheet.__proto__ || Object.getPrototypeOf(StyleSheet)).apply(this, arguments));
	
	    _this._onChange = function () {
	      setTimeout(function () {
	        _this._isMounted && _this.setState(_this._getCSSState());
	      }, 0);
	    };
	
	    _this.state = _this._getCSSState();
	    return _this;
	  }
	
	  _createClass(StyleSheet, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
	      this._onChange();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      if (this._subscription) {
	        this._subscription.remove();
	      }
	    }
	  }, {
	    key: '_getCSSState',
	    value: function _getCSSState() {
	      return { css: this.context._radiumStyleKeeper.getCSS() };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
	    }
	  }]);
	
	  return StyleSheet;
	}(_react.PureComponent), _class.contextTypes = {
	  _radiumStyleKeeper: _propTypes2.default.instanceOf(_styleKeeper2.default)
	}, _temp);
	exports.default = StyleSheet;

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _cssRuleSetToString = __webpack_require__(489);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Style = (_temp = _class = function (_PureComponent) {
	  _inherits(Style, _PureComponent);
	
	  function Style() {
	    _classCallCheck(this, Style);
	
	    return _possibleConstructorReturn(this, (Style.__proto__ || Object.getPrototypeOf(Style)).apply(this, arguments));
	  }
	
	  _createClass(Style, [{
	    key: '_buildStyles',
	    value: function _buildStyles(styles) {
	      var _this2 = this;
	
	      var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;
	
	      var scopeSelector = this.props.scopeSelector;
	
	      var rootRules = Object.keys(styles).reduce(function (accumulator, selector) {
	        if (_typeof(styles[selector]) !== 'object') {
	          accumulator[selector] = styles[selector];
	        }
	
	        return accumulator;
	      }, {});
	      var rootStyles = Object.keys(rootRules).length ? (0, _cssRuleSetToString2.default)(scopeSelector || '', rootRules, userAgent) : '';
	
	      return rootStyles + Object.keys(styles).reduce(function (accumulator, selector) {
	        var rules = styles[selector];
	
	        if (selector === 'mediaQueries') {
	          accumulator += _this2._buildMediaQueryString(rules);
	        } else if (_typeof(styles[selector]) === 'object') {
	          var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
	            return scopeSelector + ' ' + part.trim();
	          }).join(',') : selector;
	
	          accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
	        }
	
	        return accumulator;
	      }, '');
	    }
	  }, {
	    key: '_buildMediaQueryString',
	    value: function _buildMediaQueryString(stylesByMediaQuery) {
	      var _this3 = this;
	
	      var mediaQueryString = '';
	
	      Object.keys(stylesByMediaQuery).forEach(function (query) {
	        mediaQueryString += '@media ' + query + '{' + _this3._buildStyles(stylesByMediaQuery[query]) + '}';
	      });
	
	      return mediaQueryString;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.rules) {
	        return null;
	      }
	
	      var styles = this._buildStyles(this.props.rules);
	
	      return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
	    }
	  }]);
	
	  return Style;
	}(_react.PureComponent), _class.propTypes = {
	  radiumConfig: _propTypes2.default.object,
	  rules: _propTypes2.default.object,
	  scopeSelector: _propTypes2.default.string
	}, _class.contextTypes = {
	  _radiumConfig: _propTypes2.default.object
	}, _class.defaultProps = {
	  scopeSelector: ''
	}, _temp);
	exports.default = Style;

/***/ },
/* 2084 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getStateKey = function getStateKey(renderedElement) {
	  return typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
	};
	
	exports.default = getStateKey;

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keyframes = exports.getState = exports.StyleRoot = exports.Style = exports.Plugins = undefined;
	
	var _enhancer = __webpack_require__(886);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _plugins = __webpack_require__(891);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _style = __webpack_require__(2083);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _styleRoot = __webpack_require__(2081);
	
	var _styleRoot2 = _interopRequireDefault(_styleRoot);
	
	var _getState = __webpack_require__(888);
	
	var _getState2 = _interopRequireDefault(_getState);
	
	var _keyframes = __webpack_require__(2086);
	
	var _keyframes2 = _interopRequireDefault(_keyframes);
	
	var _resolveStyles = __webpack_require__(892);
	
	var _resolveStyles2 = _interopRequireDefault(_resolveStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Radium(ComposedComponent) {
	  return (0, _enhancer2.default)(ComposedComponent);
	}
	
	// Legacy object support.
	//
	// Normally it would be disfavored to attach these to the `Radium` object
	// because it defeats tree-shaking, using instead the ESM exports. But,
	// the `Radium` `Enhancer` uses **all** of these, so there's no extra "cost"
	// to them being explicitly on the `Radium` object.
	Radium.Plugins = _plugins2.default;
	Radium.Style = _style2.default;
	Radium.StyleRoot = _styleRoot2.default;
	Radium.getState = _getState2.default;
	Radium.keyframes = _keyframes2.default;
	
	if (false) {
	  Radium.TestMode = {
	    clearState: _resolveStyles2.default.__clearStateForTests,
	    disable: _resolveStyles2.default.__setTestMode.bind(null, false),
	    enable: _resolveStyles2.default.__setTestMode.bind(null, true)
	  };
	}
	
	exports.default = Radium;
	
	// ESM re-exports
	
	exports.Plugins = _plugins2.default;
	exports.Style = _style2.default;
	exports.StyleRoot = _styleRoot2.default;
	exports.getState = _getState2.default;
	exports.keyframes = _keyframes2.default;

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyframes;
	
	var _cssRuleSetToString = __webpack_require__(489);
	
	var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
	var _hash = __webpack_require__(889);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _prefixer = __webpack_require__(490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function keyframes(keyframeRules, name) {
	  return {
	    __radiumKeyframes: true,
	    __process: function __process(userAgent) {
	      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
	      var rules = Object.keys(keyframeRules).map(function (percentage) {
	        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
	      }).join('\n');
	      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
	      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
	      return { css: css, animationName: animationName };
	    }
	  };
	}

/***/ },
/* 2087 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isNestedStyle = isNestedStyle;
	exports.mergeStyles = mergeStyles;
	function isNestedStyle(value) {
	  // Don't merge objects overriding toString, since they should be converted
	  // to string values.
	  return value && value.constructor === Object && value.toString === Object.prototype.toString;
	}
	
	// Merge style objects. Deep merge plain object values.
	function mergeStyles(styles) {
	  var result = {};
	
	  styles.forEach(function (style) {
	    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
	      return;
	    }
	
	    if (Array.isArray(style)) {
	      style = mergeStyles(style);
	    }
	
	    Object.keys(style).forEach(function (key) {
	      // Simple case, nothing nested
	      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
	        result[key] = style[key];
	        return;
	      }
	
	      // If nested media, don't merge the nested styles, append a space to the
	      // end (benign when converted to CSS). This way we don't end up merging
	      // media queries that appear later in the chain with those that appear
	      // earlier.
	      if (key.indexOf('@media') === 0) {
	        var newKey = key;
	        // eslint-disable-next-line no-constant-condition
	        while (true) {
	          newKey += ' ';
	          if (!result[newKey]) {
	            result[newKey] = style[key];
	            return;
	          }
	        }
	      }
	
	      // Merge all other nested styles recursively
	      result[key] = mergeStyles([result[key], style[key]]);
	    });
	  });
	
	  return result;
	}

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _checkProps = function checkProps() {};
	
	if (false) {
	  // Warn if you use longhand and shorthand properties in the same style
	  // object.
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
	  var shorthandPropertyExpansions = {
	    background: ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
	    border: ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
	    borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
	    borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
	    font: ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
	    listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
	    margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
	    padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
	    transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
	  };
	
	  _checkProps = function checkProps(config) {
	    var componentName = config.componentName,
	        style = config.style;
	
	    if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
	      return;
	    }
	
	    var styleKeys = Object.keys(style);
	    styleKeys.forEach(function (styleKey) {
	      if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
	        return styleKeys.indexOf(sp) !== -1;
	      })) {
	        if (process.env.NODE_ENV !== 'production') {
	          /* eslint-disable no-console */
	          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
	          /* eslint-enable no-console */
	        }
	      }
	    });
	
	    styleKeys.forEach(function (k) {
	      return _checkProps(_extends({}, config, { style: style[k] }));
	    });
	    return;
	  };
	}
	
	exports.default = _checkProps;

/***/ },
/* 2089 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = keyframesPlugin;
	function keyframesPlugin(_ref // eslint-disable-line no-shadow
	) {
	  var addCSS = _ref.addCSS,
	      config = _ref.config,
	      style = _ref.style;
	
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (key === 'animationName' && value && value.__radiumKeyframes) {
	      var keyframesValue = value;
	
	      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent),
	          animationName = _keyframesValue$__pro.animationName,
	          css = _keyframesValue$__pro.css;
	
	      addCSS(css);
	      value = animationName;
	    }
	
	    newStyleInProgress[key] = value;
	    return newStyleInProgress;
	  }, {});
	  return { style: newStyle };
	}

/***/ },
/* 2090 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
	// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
	var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
	  var style = _ref.style,
	      mergeStyles = _ref.mergeStyles;
	
	  // eslint-disable-line no-shadow
	  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
	  return { style: newStyle };
	};
	
	exports.default = mergeStyleArrayPlugin;

/***/ },
/* 2091 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _callbacks = [];
	var _mouseUpListenerIsActive = false;
	
	function _handleMouseUp() {
	  _callbacks.forEach(function (callback) {
	    callback();
	  });
	}
	
	var subscribe = function subscribe(callback) {
	  if (_callbacks.indexOf(callback) === -1) {
	    _callbacks.push(callback);
	  }
	
	  if (!_mouseUpListenerIsActive) {
	    window.addEventListener('mouseup', _handleMouseUp);
	    _mouseUpListenerIsActive = true;
	  }
	
	  return {
	    remove: function remove() {
	      var index = _callbacks.indexOf(callback);
	      _callbacks.splice(index, 1);
	
	      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
	        window.removeEventListener('mouseup', _handleMouseUp);
	        _mouseUpListenerIsActive = false;
	      }
	    }
	  };
	};
	
	exports.default = {
	  subscribe: subscribe,
	  __triggerForTests: _handleMouseUp
	};

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixPlugin;
	
	var _prefixer = __webpack_require__(490);
	
	function prefixPlugin(_ref // eslint-disable-line no-shadow
	) {
	  var config = _ref.config,
	      style = _ref.style;
	
	  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
	  return { style: newStyle };
	}

/***/ },
/* 2093 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeNestedStyles;
	function removeNestedStyles(_ref) {
	  var isNestedStyle = _ref.isNestedStyle,
	      style = _ref.style;
	
	  // eslint-disable-line no-shadow
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (!isNestedStyle(value)) {
	      newStyleInProgress[key] = value;
	    }
	    return newStyleInProgress;
	  }, {});
	
	  return {
	    style: newStyle
	  };
	}

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mouseUpListener = __webpack_require__(2091);
	
	var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
	  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
	};
	
	var resolveInteractionStyles = function resolveInteractionStyles(config) {
	  var ExecutionEnvironment = config.ExecutionEnvironment,
	      getComponentField = config.getComponentField,
	      getState = config.getState,
	      mergeStyles = config.mergeStyles,
	      props = config.props,
	      setState = config.setState,
	      style = config.style;
	
	
	  var newComponentFields = {};
	  var newProps = {};
	
	  // Only add handlers if necessary
	  if (style[':hover']) {
	    // Always call the existing handler if one is already defined.
	    // This code, and the very similar ones below, could be abstracted a bit
	    // more, but it hurts readability IMO.
	    var existingOnMouseEnter = props.onMouseEnter;
	    newProps.onMouseEnter = function (e) {
	      existingOnMouseEnter && existingOnMouseEnter(e);
	      setState(':hover', true);
	    };
	
	    var existingOnMouseLeave = props.onMouseLeave;
	    newProps.onMouseLeave = function (e) {
	      existingOnMouseLeave && existingOnMouseLeave(e);
	      setState(':hover', false);
	    };
	  }
	
	  if (style[':active']) {
	    var existingOnMouseDown = props.onMouseDown;
	    newProps.onMouseDown = function (e) {
	      existingOnMouseDown && existingOnMouseDown(e);
	      newComponentFields._lastMouseDown = Date.now();
	      setState(':active', 'viamousedown');
	    };
	
	    var existingOnKeyDown = props.onKeyDown;
	    newProps.onKeyDown = function (e) {
	      existingOnKeyDown && existingOnKeyDown(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', 'viakeydown');
	      }
	    };
	
	    var existingOnKeyUp = props.onKeyUp;
	    newProps.onKeyUp = function (e) {
	      existingOnKeyUp && existingOnKeyUp(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', false);
	      }
	    };
	  }
	
	  if (style[':focus']) {
	    var existingOnFocus = props.onFocus;
	    newProps.onFocus = function (e) {
	      existingOnFocus && existingOnFocus(e);
	      setState(':focus', true);
	    };
	
	    var existingOnBlur = props.onBlur;
	    newProps.onBlur = function (e) {
	      existingOnBlur && existingOnBlur(e);
	      setState(':focus', false);
	    };
	  }
	
	  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
	    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
	      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
	        if (getState(':active', key) === 'viamousedown') {
	          setState(':active', false, key);
	        }
	      });
	    });
	  }
	
	  // Merge the styles in the order they were defined
	  var interactionStyles = props.disabled ? [style[':disabled']] : Object.keys(style).filter(function (name) {
	    return _isInteractiveStyleField(name) && getState(name);
	  }).map(function (name) {
	    return style[name];
	  });
	
	  var newStyle = mergeStyles([style].concat(interactionStyles));
	
	  // Remove interactive styles
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
	    if (!_isInteractiveStyleField(name) && name !== ':disabled') {
	      styleWithoutInteractions[name] = newStyle[name];
	    }
	    return styleWithoutInteractions;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    props: newProps,
	    style: newStyle
	  };
	};
	
	exports.default = resolveInteractionStyles;

/***/ },
/* 2095 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = resolveMediaQueries;
	var _windowMatchMedia = void 0;
	function _getWindowMatchMedia(ExecutionEnvironment) {
	  if (_windowMatchMedia === undefined) {
	    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
	      return window.matchMedia(mediaQueryString);
	    } || null;
	  }
	  return _windowMatchMedia;
	}
	
	function _filterObject(obj, predicate) {
	  return Object.keys(obj).filter(function (key) {
	    return predicate(obj[key], key);
	  }).reduce(function (result, key) {
	    result[key] = obj[key];
	    return result;
	  }, {});
	}
	
	function _removeMediaQueries(style) {
	  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
	    if (key.indexOf('@media') !== 0) {
	      styleWithoutMedia[key] = style[key];
	    }
	    return styleWithoutMedia;
	  }, {});
	}
	
	function _topLevelRulesToCSS(_ref) {
	  var addCSS = _ref.addCSS,
	      appendImportantToEachValue = _ref.appendImportantToEachValue,
	      cssRuleSetToString = _ref.cssRuleSetToString,
	      hash = _ref.hash,
	      isNestedStyle = _ref.isNestedStyle,
	      style = _ref.style,
	      userAgent = _ref.userAgent;
	
	  var className = '';
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
	      return !isNestedStyle(value);
	    }));
	
	    if (!Object.keys(topLevelRules).length) {
	      return;
	    }
	
	    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);
	
	    // CSS classes cannot start with a number
	    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
	    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';
	
	    addCSS(css);
	
	    className += (className ? ' ' : '') + mediaQueryClassName;
	  });
	  return className;
	}
	
	function _subscribeToMediaQuery(_ref2) {
	  var listener = _ref2.listener,
	      listenersByQuery = _ref2.listenersByQuery,
	      matchMedia = _ref2.matchMedia,
	      mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery,
	      query = _ref2.query;
	
	  query = query.replace('@media ', '');
	
	  var mql = mediaQueryListsByQuery[query];
	  if (!mql && matchMedia) {
	    mediaQueryListsByQuery[query] = mql = matchMedia(query);
	  }
	
	  if (!listenersByQuery || !listenersByQuery[query]) {
	    mql.addListener(listener);
	
	    listenersByQuery[query] = {
	      remove: function remove() {
	        mql.removeListener(listener);
	      }
	    };
	  }
	  return mql;
	}
	
	function resolveMediaQueries(_ref3) {
	  var ExecutionEnvironment = _ref3.ExecutionEnvironment,
	      addCSS = _ref3.addCSS,
	      appendImportantToEachValue = _ref3.appendImportantToEachValue,
	      config = _ref3.config,
	      cssRuleSetToString = _ref3.cssRuleSetToString,
	      getComponentField = _ref3.getComponentField,
	      getGlobalState = _ref3.getGlobalState,
	      hash = _ref3.hash,
	      isNestedStyle = _ref3.isNestedStyle,
	      mergeStyles = _ref3.mergeStyles,
	      props = _ref3.props,
	      setState = _ref3.setState,
	      style = _ref3.style;
	
	  // eslint-disable-line no-shadow
	  var newStyle = _removeMediaQueries(style);
	  var mediaQueryClassNames = _topLevelRulesToCSS({
	    addCSS: addCSS,
	    appendImportantToEachValue: appendImportantToEachValue,
	    cssRuleSetToString: cssRuleSetToString,
	    hash: hash,
	    isNestedStyle: isNestedStyle,
	    style: style,
	    userAgent: config.userAgent
	  });
	
	  var newProps = mediaQueryClassNames ? {
	    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
	  } : null;
	
	  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);
	
	  if (!matchMedia) {
	    return {
	      props: newProps,
	      style: newStyle
	    };
	  }
	
	  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
	  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};
	
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var nestedRules = _filterObject(style[query], isNestedStyle);
	
	    if (!Object.keys(nestedRules).length) {
	      return;
	    }
	
	    var mql = _subscribeToMediaQuery({
	      listener: function listener() {
	        return setState(query, mql.matches, '_all');
	      },
	      listenersByQuery: listenersByQuery,
	      matchMedia: matchMedia,
	      mediaQueryListsByQuery: mediaQueryListsByQuery,
	      query: query
	    });
	
	    // Apply media query states
	    if (mql.matches) {
	      newStyle = mergeStyles([newStyle, nestedRules]);
	    }
	  });
	
	  return {
	    componentFields: {
	      _radiumMediaQueryListenersByQuery: listenersByQuery
	    },
	    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
	    props: newProps,
	    style: newStyle
	  };
	}

/***/ },
/* 2096 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = visited;
	function visited(_ref) {
	  var addCSS = _ref.addCSS,
	      appendImportantToEachValue = _ref.appendImportantToEachValue,
	      config = _ref.config,
	      cssRuleSetToString = _ref.cssRuleSetToString,
	      hash = _ref.hash,
	      props = _ref.props,
	      style = _ref.style;
	
	  // eslint-disable-line no-shadow
	  var className = props.className;
	
	  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
	    var value = style[key];
	    if (key === ':visited') {
	      value = appendImportantToEachValue(value);
	      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
	      var visitedClassName = 'rad-' + hash(ruleCSS);
	      var css = '.' + visitedClassName + ':visited' + ruleCSS;
	
	      addCSS(css);
	      className = (className ? className + ' ' : '') + visitedClassName;
	    } else {
	      newStyleInProgress[key] = value;
	    }
	
	    return newStyleInProgress;
	  }, {});
	
	  return {
	    props: className === props.className ? null : { className: className },
	    style: newStyle
	  };
	}

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1886);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _crossFade = __webpack_require__(1887);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _cursor = __webpack_require__(1888);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _filter = __webpack_require__(1889);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(1890);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1891);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1892);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1893);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1894);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1895);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(1896);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1897);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _crossFade2.default, _cursor2.default, _filter2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default],
	  prefixMap: {
	    chrome: {
	      transform: 35,
	      transformOrigin: 35,
	      transformOriginX: 35,
	      transformOriginY: 35,
	      backfaceVisibility: 35,
	      perspective: 35,
	      perspectiveOrigin: 35,
	      transformStyle: 35,
	      transformOriginZ: 35,
	      animation: 42,
	      animationDelay: 42,
	      animationDirection: 42,
	      animationFillMode: 42,
	      animationDuration: 42,
	      animationIterationCount: 42,
	      animationName: 42,
	      animationPlayState: 42,
	      animationTimingFunction: 42,
	      appearance: 66,
	      userSelect: 53,
	      fontKerning: 32,
	      textEmphasisPosition: 66,
	      textEmphasis: 66,
	      textEmphasisStyle: 66,
	      textEmphasisColor: 66,
	      boxDecorationBreak: 66,
	      clipPath: 54,
	      maskImage: 66,
	      maskMode: 66,
	      maskRepeat: 66,
	      maskPosition: 66,
	      maskClip: 66,
	      maskOrigin: 66,
	      maskSize: 66,
	      maskComposite: 66,
	      mask: 66,
	      maskBorderSource: 66,
	      maskBorderMode: 66,
	      maskBorderSlice: 66,
	      maskBorderWidth: 66,
	      maskBorderOutset: 66,
	      maskBorderRepeat: 66,
	      maskBorder: 66,
	      maskType: 66,
	      textDecorationStyle: 56,
	      textDecorationSkip: 56,
	      textDecorationLine: 56,
	      textDecorationColor: 56,
	      filter: 52,
	      fontFeatureSettings: 47,
	      breakAfter: 49,
	      breakBefore: 49,
	      breakInside: 49,
	      columnCount: 49,
	      columnFill: 49,
	      columnGap: 49,
	      columnRule: 49,
	      columnRuleColor: 49,
	      columnRuleStyle: 49,
	      columnRuleWidth: 49,
	      columns: 49,
	      columnSpan: 49,
	      columnWidth: 49,
	      writingMode: 47
	    },
	    safari: {
	      flex: 8,
	      flexBasis: 8,
	      flexDirection: 8,
	      flexGrow: 8,
	      flexFlow: 8,
	      flexShrink: 8,
	      flexWrap: 8,
	      alignContent: 8,
	      alignItems: 8,
	      alignSelf: 8,
	      justifyContent: 8,
	      order: 8,
	      transition: 6,
	      transitionDelay: 6,
	      transitionDuration: 6,
	      transitionProperty: 6,
	      transitionTimingFunction: 6,
	      transform: 8,
	      transformOrigin: 8,
	      transformOriginX: 8,
	      transformOriginY: 8,
	      backfaceVisibility: 8,
	      perspective: 8,
	      perspectiveOrigin: 8,
	      transformStyle: 8,
	      transformOriginZ: 8,
	      animation: 8,
	      animationDelay: 8,
	      animationDirection: 8,
	      animationFillMode: 8,
	      animationDuration: 8,
	      animationIterationCount: 8,
	      animationName: 8,
	      animationPlayState: 8,
	      animationTimingFunction: 8,
	      appearance: 11,
	      userSelect: 11,
	      backdropFilter: 11,
	      fontKerning: 9,
	      scrollSnapType: 10.1,
	      scrollSnapPointsX: 10.1,
	      scrollSnapPointsY: 10.1,
	      scrollSnapDestination: 10.1,
	      scrollSnapCoordinate: 10.1,
	      textEmphasisPosition: 7,
	      textEmphasis: 7,
	      textEmphasisStyle: 7,
	      textEmphasisColor: 7,
	      boxDecorationBreak: 11,
	      clipPath: 11,
	      maskImage: 11,
	      maskMode: 11,
	      maskRepeat: 11,
	      maskPosition: 11,
	      maskClip: 11,
	      maskOrigin: 11,
	      maskSize: 11,
	      maskComposite: 11,
	      mask: 11,
	      maskBorderSource: 11,
	      maskBorderMode: 11,
	      maskBorderSlice: 11,
	      maskBorderWidth: 11,
	      maskBorderOutset: 11,
	      maskBorderRepeat: 11,
	      maskBorder: 11,
	      maskType: 11,
	      textDecorationStyle: 11,
	      textDecorationSkip: 11,
	      textDecorationLine: 11,
	      textDecorationColor: 11,
	      shapeImageThreshold: 10,
	      shapeImageMargin: 10,
	      shapeImageOutside: 10,
	      filter: 9,
	      hyphens: 11,
	      flowInto: 11,
	      flowFrom: 11,
	      breakBefore: 8,
	      breakAfter: 8,
	      breakInside: 8,
	      regionFragment: 11,
	      columnCount: 8,
	      columnFill: 8,
	      columnGap: 8,
	      columnRule: 8,
	      columnRuleColor: 8,
	      columnRuleStyle: 8,
	      columnRuleWidth: 8,
	      columns: 8,
	      columnSpan: 8,
	      columnWidth: 8,
	      writingMode: 10.1
	    },
	    firefox: {
	      appearance: 60,
	      userSelect: 60,
	      boxSizing: 28,
	      textAlignLast: 48,
	      textDecorationStyle: 35,
	      textDecorationSkip: 35,
	      textDecorationLine: 35,
	      textDecorationColor: 35,
	      tabSize: 60,
	      hyphens: 42,
	      fontFeatureSettings: 33,
	      breakAfter: 51,
	      breakBefore: 51,
	      breakInside: 51,
	      columnCount: 51,
	      columnFill: 51,
	      columnGap: 51,
	      columnRule: 51,
	      columnRuleColor: 51,
	      columnRuleStyle: 51,
	      columnRuleWidth: 51,
	      columns: 51,
	      columnSpan: 51,
	      columnWidth: 51
	    },
	    opera: {
	      flex: 16,
	      flexBasis: 16,
	      flexDirection: 16,
	      flexGrow: 16,
	      flexFlow: 16,
	      flexShrink: 16,
	      flexWrap: 16,
	      alignContent: 16,
	      alignItems: 16,
	      alignSelf: 16,
	      justifyContent: 16,
	      order: 16,
	      transform: 22,
	      transformOrigin: 22,
	      transformOriginX: 22,
	      transformOriginY: 22,
	      backfaceVisibility: 22,
	      perspective: 22,
	      perspectiveOrigin: 22,
	      transformStyle: 22,
	      transformOriginZ: 22,
	      animation: 29,
	      animationDelay: 29,
	      animationDirection: 29,
	      animationFillMode: 29,
	      animationDuration: 29,
	      animationIterationCount: 29,
	      animationName: 29,
	      animationPlayState: 29,
	      animationTimingFunction: 29,
	      appearance: 50,
	      userSelect: 40,
	      fontKerning: 19,
	      textEmphasisPosition: 50,
	      textEmphasis: 50,
	      textEmphasisStyle: 50,
	      textEmphasisColor: 50,
	      boxDecorationBreak: 50,
	      clipPath: 41,
	      maskImage: 50,
	      maskMode: 50,
	      maskRepeat: 50,
	      maskPosition: 50,
	      maskClip: 50,
	      maskOrigin: 50,
	      maskSize: 50,
	      maskComposite: 50,
	      mask: 50,
	      maskBorderSource: 50,
	      maskBorderMode: 50,
	      maskBorderSlice: 50,
	      maskBorderWidth: 50,
	      maskBorderOutset: 50,
	      maskBorderRepeat: 50,
	      maskBorder: 50,
	      maskType: 50,
	      textDecorationStyle: 43,
	      textDecorationSkip: 43,
	      textDecorationLine: 43,
	      textDecorationColor: 43,
	      filter: 39,
	      fontFeatureSettings: 34,
	      breakAfter: 36,
	      breakBefore: 36,
	      breakInside: 36,
	      columnCount: 36,
	      columnFill: 36,
	      columnGap: 36,
	      columnRule: 36,
	      columnRuleColor: 36,
	      columnRuleStyle: 36,
	      columnRuleWidth: 36,
	      columns: 36,
	      columnSpan: 36,
	      columnWidth: 36,
	      writingMode: 34
	    },
	    ie: {
	      flex: 10,
	      flexDirection: 10,
	      flexFlow: 10,
	      flexWrap: 10,
	      transform: 9,
	      transformOrigin: 9,
	      transformOriginX: 9,
	      transformOriginY: 9,
	      userSelect: 11,
	      wrapFlow: 11,
	      wrapThrough: 11,
	      wrapMargin: 11,
	      scrollSnapType: 11,
	      scrollSnapPointsX: 11,
	      scrollSnapPointsY: 11,
	      scrollSnapDestination: 11,
	      scrollSnapCoordinate: 11,
	      touchAction: 10,
	      hyphens: 11,
	      flowInto: 11,
	      flowFrom: 11,
	      breakBefore: 11,
	      breakAfter: 11,
	      breakInside: 11,
	      regionFragment: 11,
	      gridTemplateColumns: 11,
	      gridTemplateRows: 11,
	      gridTemplateAreas: 11,
	      gridTemplate: 11,
	      gridAutoColumns: 11,
	      gridAutoRows: 11,
	      gridAutoFlow: 11,
	      grid: 11,
	      gridRowStart: 11,
	      gridColumnStart: 11,
	      gridRowEnd: 11,
	      gridRow: 11,
	      gridColumn: 11,
	      gridColumnEnd: 11,
	      gridColumnGap: 11,
	      gridRowGap: 11,
	      gridArea: 11,
	      gridGap: 11,
	      textSizeAdjust: 11,
	      writingMode: 11
	    },
	    edge: {
	      userSelect: 17,
	      wrapFlow: 17,
	      wrapThrough: 17,
	      wrapMargin: 17,
	      scrollSnapType: 17,
	      scrollSnapPointsX: 17,
	      scrollSnapPointsY: 17,
	      scrollSnapDestination: 17,
	      scrollSnapCoordinate: 17,
	      hyphens: 17,
	      flowInto: 17,
	      flowFrom: 17,
	      breakBefore: 17,
	      breakAfter: 17,
	      breakInside: 17,
	      regionFragment: 17,
	      gridTemplateColumns: 15,
	      gridTemplateRows: 15,
	      gridTemplateAreas: 15,
	      gridTemplate: 15,
	      gridAutoColumns: 15,
	      gridAutoRows: 15,
	      gridAutoFlow: 15,
	      grid: 15,
	      gridRowStart: 15,
	      gridColumnStart: 15,
	      gridRowEnd: 15,
	      gridRow: 15,
	      gridColumn: 15,
	      gridColumnEnd: 15,
	      gridColumnGap: 15,
	      gridRowGap: 15,
	      gridArea: 15,
	      gridGap: 15
	    },
	    ios_saf: {
	      flex: 8.1,
	      flexBasis: 8.1,
	      flexDirection: 8.1,
	      flexGrow: 8.1,
	      flexFlow: 8.1,
	      flexShrink: 8.1,
	      flexWrap: 8.1,
	      alignContent: 8.1,
	      alignItems: 8.1,
	      alignSelf: 8.1,
	      justifyContent: 8.1,
	      order: 8.1,
	      transition: 6,
	      transitionDelay: 6,
	      transitionDuration: 6,
	      transitionProperty: 6,
	      transitionTimingFunction: 6,
	      transform: 8.1,
	      transformOrigin: 8.1,
	      transformOriginX: 8.1,
	      transformOriginY: 8.1,
	      backfaceVisibility: 8.1,
	      perspective: 8.1,
	      perspectiveOrigin: 8.1,
	      transformStyle: 8.1,
	      transformOriginZ: 8.1,
	      animation: 8.1,
	      animationDelay: 8.1,
	      animationDirection: 8.1,
	      animationFillMode: 8.1,
	      animationDuration: 8.1,
	      animationIterationCount: 8.1,
	      animationName: 8.1,
	      animationPlayState: 8.1,
	      animationTimingFunction: 8.1,
	      appearance: 11,
	      userSelect: 11,
	      backdropFilter: 11,
	      fontKerning: 11,
	      scrollSnapType: 10.3,
	      scrollSnapPointsX: 10.3,
	      scrollSnapPointsY: 10.3,
	      scrollSnapDestination: 10.3,
	      scrollSnapCoordinate: 10.3,
	      boxDecorationBreak: 11,
	      clipPath: 11,
	      maskImage: 11,
	      maskMode: 11,
	      maskRepeat: 11,
	      maskPosition: 11,
	      maskClip: 11,
	      maskOrigin: 11,
	      maskSize: 11,
	      maskComposite: 11,
	      mask: 11,
	      maskBorderSource: 11,
	      maskBorderMode: 11,
	      maskBorderSlice: 11,
	      maskBorderWidth: 11,
	      maskBorderOutset: 11,
	      maskBorderRepeat: 11,
	      maskBorder: 11,
	      maskType: 11,
	      textSizeAdjust: 11,
	      textDecorationStyle: 11,
	      textDecorationSkip: 11,
	      textDecorationLine: 11,
	      textDecorationColor: 11,
	      shapeImageThreshold: 10,
	      shapeImageMargin: 10,
	      shapeImageOutside: 10,
	      filter: 9,
	      hyphens: 11,
	      flowInto: 11,
	      flowFrom: 11,
	      breakBefore: 8.1,
	      breakAfter: 8.1,
	      breakInside: 8.1,
	      regionFragment: 11,
	      columnCount: 8.1,
	      columnFill: 8.1,
	      columnGap: 8.1,
	      columnRule: 8.1,
	      columnRuleColor: 8.1,
	      columnRuleStyle: 8.1,
	      columnRuleWidth: 8.1,
	      columns: 8.1,
	      columnSpan: 8.1,
	      columnWidth: 8.1,
	      writingMode: 10.3
	    },
	    android: {
	      borderImage: 4.2,
	      borderImageOutset: 4.2,
	      borderImageRepeat: 4.2,
	      borderImageSlice: 4.2,
	      borderImageSource: 4.2,
	      borderImageWidth: 4.2,
	      flex: 4.2,
	      flexBasis: 4.2,
	      flexDirection: 4.2,
	      flexGrow: 4.2,
	      flexFlow: 4.2,
	      flexShrink: 4.2,
	      flexWrap: 4.2,
	      alignContent: 4.2,
	      alignItems: 4.2,
	      alignSelf: 4.2,
	      justifyContent: 4.2,
	      order: 4.2,
	      transition: 4.2,
	      transitionDelay: 4.2,
	      transitionDuration: 4.2,
	      transitionProperty: 4.2,
	      transitionTimingFunction: 4.2,
	      transform: 4.4,
	      transformOrigin: 4.4,
	      transformOriginX: 4.4,
	      transformOriginY: 4.4,
	      backfaceVisibility: 4.4,
	      perspective: 4.4,
	      perspectiveOrigin: 4.4,
	      transformStyle: 4.4,
	      transformOriginZ: 4.4,
	      animation: 4.4,
	      animationDelay: 4.4,
	      animationDirection: 4.4,
	      animationFillMode: 4.4,
	      animationDuration: 4.4,
	      animationIterationCount: 4.4,
	      animationName: 4.4,
	      animationPlayState: 4.4,
	      animationTimingFunction: 4.4,
	      appearance: 62,
	      userSelect: 4.4,
	      fontKerning: 4.4,
	      textEmphasisPosition: 62,
	      textEmphasis: 62,
	      textEmphasisStyle: 62,
	      textEmphasisColor: 62,
	      boxDecorationBreak: 62,
	      clipPath: 4.4,
	      maskImage: 62,
	      maskMode: 62,
	      maskRepeat: 62,
	      maskPosition: 62,
	      maskClip: 62,
	      maskOrigin: 62,
	      maskSize: 62,
	      maskComposite: 62,
	      mask: 62,
	      maskBorderSource: 62,
	      maskBorderMode: 62,
	      maskBorderSlice: 62,
	      maskBorderWidth: 62,
	      maskBorderOutset: 62,
	      maskBorderRepeat: 62,
	      maskBorder: 62,
	      maskType: 62,
	      filter: 4.4,
	      fontFeatureSettings: 4.4,
	      breakAfter: 4.4,
	      breakBefore: 4.4,
	      breakInside: 4.4,
	      columnCount: 4.4,
	      columnFill: 4.4,
	      columnGap: 4.4,
	      columnRule: 4.4,
	      columnRuleColor: 4.4,
	      columnRuleStyle: 4.4,
	      columnRuleWidth: 4.4,
	      columns: 4.4,
	      columnSpan: 4.4,
	      columnWidth: 4.4,
	      writingMode: 4.4
	    },
	    and_chr: {
	      appearance: 62,
	      textEmphasisPosition: 62,
	      textEmphasis: 62,
	      textEmphasisStyle: 62,
	      textEmphasisColor: 62,
	      boxDecorationBreak: 62,
	      maskImage: 62,
	      maskMode: 62,
	      maskRepeat: 62,
	      maskPosition: 62,
	      maskClip: 62,
	      maskOrigin: 62,
	      maskSize: 62,
	      maskComposite: 62,
	      mask: 62,
	      maskBorderSource: 62,
	      maskBorderMode: 62,
	      maskBorderSlice: 62,
	      maskBorderWidth: 62,
	      maskBorderOutset: 62,
	      maskBorderRepeat: 62,
	      maskBorder: 62,
	      maskType: 62
	    },
	    and_uc: {
	      flex: 11.4,
	      flexBasis: 11.4,
	      flexDirection: 11.4,
	      flexGrow: 11.4,
	      flexFlow: 11.4,
	      flexShrink: 11.4,
	      flexWrap: 11.4,
	      alignContent: 11.4,
	      alignItems: 11.4,
	      alignSelf: 11.4,
	      justifyContent: 11.4,
	      order: 11.4,
	      transform: 11.4,
	      transformOrigin: 11.4,
	      transformOriginX: 11.4,
	      transformOriginY: 11.4,
	      backfaceVisibility: 11.4,
	      perspective: 11.4,
	      perspectiveOrigin: 11.4,
	      transformStyle: 11.4,
	      transformOriginZ: 11.4,
	      animation: 11.4,
	      animationDelay: 11.4,
	      animationDirection: 11.4,
	      animationFillMode: 11.4,
	      animationDuration: 11.4,
	      animationIterationCount: 11.4,
	      animationName: 11.4,
	      animationPlayState: 11.4,
	      animationTimingFunction: 11.4,
	      appearance: 11.4,
	      userSelect: 11.4,
	      textEmphasisPosition: 11.4,
	      textEmphasis: 11.4,
	      textEmphasisStyle: 11.4,
	      textEmphasisColor: 11.4,
	      clipPath: 11.4,
	      maskImage: 11.4,
	      maskMode: 11.4,
	      maskRepeat: 11.4,
	      maskPosition: 11.4,
	      maskClip: 11.4,
	      maskOrigin: 11.4,
	      maskSize: 11.4,
	      maskComposite: 11.4,
	      mask: 11.4,
	      maskBorderSource: 11.4,
	      maskBorderMode: 11.4,
	      maskBorderSlice: 11.4,
	      maskBorderWidth: 11.4,
	      maskBorderOutset: 11.4,
	      maskBorderRepeat: 11.4,
	      maskBorder: 11.4,
	      maskType: 11.4,
	      textSizeAdjust: 11.4,
	      filter: 11.4,
	      hyphens: 11.4,
	      fontFeatureSettings: 11.4,
	      breakAfter: 11.4,
	      breakBefore: 11.4,
	      breakInside: 11.4,
	      columnCount: 11.4,
	      columnFill: 11.4,
	      columnGap: 11.4,
	      columnRule: 11.4,
	      columnRuleColor: 11.4,
	      columnRuleStyle: 11.4,
	      columnRuleWidth: 11.4,
	      columns: 11.4,
	      columnSpan: 11.4,
	      columnWidth: 11.4,
	      writingMode: 11.4
	    },
	    op_mini: {}
	  }
	};

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1899);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _crossFade = __webpack_require__(1900);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _cursor = __webpack_require__(1901);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _filter = __webpack_require__(1902);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(1903);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1904);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1905);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1906);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1907);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1908);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(1909);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1910);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var w = ['Webkit'];
	var m = ['Moz'];
	var ms = ['ms'];
	var wm = ['Webkit', 'Moz'];
	var wms = ['Webkit', 'ms'];
	var wmms = ['Webkit', 'Moz', 'ms'];
	
	exports.default = {
	  plugins: [_calc2.default, _crossFade2.default, _cursor2.default, _filter2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default],
	  prefixMap: {
	    transform: wms,
	    transformOrigin: wms,
	    transformOriginX: wms,
	    transformOriginY: wms,
	    backfaceVisibility: w,
	    perspective: w,
	    perspectiveOrigin: w,
	    transformStyle: w,
	    transformOriginZ: w,
	    animation: w,
	    animationDelay: w,
	    animationDirection: w,
	    animationFillMode: w,
	    animationDuration: w,
	    animationIterationCount: w,
	    animationName: w,
	    animationPlayState: w,
	    animationTimingFunction: w,
	    appearance: wm,
	    userSelect: wmms,
	    fontKerning: w,
	    textEmphasisPosition: w,
	    textEmphasis: w,
	    textEmphasisStyle: w,
	    textEmphasisColor: w,
	    boxDecorationBreak: w,
	    clipPath: w,
	    maskImage: w,
	    maskMode: w,
	    maskRepeat: w,
	    maskPosition: w,
	    maskClip: w,
	    maskOrigin: w,
	    maskSize: w,
	    maskComposite: w,
	    mask: w,
	    maskBorderSource: w,
	    maskBorderMode: w,
	    maskBorderSlice: w,
	    maskBorderWidth: w,
	    maskBorderOutset: w,
	    maskBorderRepeat: w,
	    maskBorder: w,
	    maskType: w,
	    textDecorationStyle: wm,
	    textDecorationSkip: wm,
	    textDecorationLine: wm,
	    textDecorationColor: wm,
	    filter: w,
	    fontFeatureSettings: wm,
	    breakAfter: wmms,
	    breakBefore: wmms,
	    breakInside: wmms,
	    columnCount: wm,
	    columnFill: wm,
	    columnGap: wm,
	    columnRule: wm,
	    columnRuleColor: wm,
	    columnRuleStyle: wm,
	    columnRuleWidth: wm,
	    columns: wm,
	    columnSpan: wm,
	    columnWidth: wm,
	    writingMode: wms,
	    flex: wms,
	    flexBasis: w,
	    flexDirection: wms,
	    flexGrow: w,
	    flexFlow: wms,
	    flexShrink: w,
	    flexWrap: wms,
	    alignContent: w,
	    alignItems: w,
	    alignSelf: w,
	    justifyContent: w,
	    order: w,
	    transitionDelay: w,
	    transitionDuration: w,
	    transitionProperty: w,
	    transitionTimingFunction: w,
	    backdropFilter: w,
	    scrollSnapType: wms,
	    scrollSnapPointsX: wms,
	    scrollSnapPointsY: wms,
	    scrollSnapDestination: wms,
	    scrollSnapCoordinate: wms,
	    shapeImageThreshold: w,
	    shapeImageMargin: w,
	    shapeImageOutside: w,
	    hyphens: wmms,
	    flowInto: wms,
	    flowFrom: wms,
	    regionFragment: wms,
	    boxSizing: m,
	    textAlignLast: m,
	    tabSize: m,
	    wrapFlow: ms,
	    wrapThrough: ms,
	    wrapMargin: ms,
	    touchAction: ms,
	    gridTemplateColumns: ms,
	    gridTemplateRows: ms,
	    gridTemplateAreas: ms,
	    gridTemplate: ms,
	    gridAutoColumns: ms,
	    gridAutoRows: ms,
	    gridAutoFlow: ms,
	    grid: ms,
	    gridRowStart: ms,
	    gridColumnStart: ms,
	    gridRowEnd: ms,
	    gridRow: ms,
	    gridColumn: ms,
	    gridColumnEnd: ms,
	    gridColumnGap: ms,
	    gridRowGap: ms,
	    gridArea: ms,
	    gridGap: ms,
	    textSizeAdjust: wms,
	    borderImage: w,
	    borderImageOutset: w,
	    borderImageRepeat: w,
	    borderImageSlice: w,
	    borderImageSource: w,
	    borderImageWidth: w
	  }
	};

/***/ },
/* 2099 */
/***/ function(module, exports) {

	function RavenConfigError(message) {
	  this.name = 'RavenConfigError';
	  this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(493);
	
	var wrapMethod = function(console, level, callback) {
	  var originalConsoleLevel = console[level];
	  var originalConsole = console;
	
	  if (!(level in console)) {
	    return;
	  }
	
	  var sentryLevel = level === 'warn' ? 'warning' : level;
	
	  console[level] = function() {
	    var args = [].slice.call(arguments);
	
	    var msg = utils.safeJoin(args, ' ');
	    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};
	
	    if (level === 'assert') {
	      if (args[0] === false) {
	        // Default browsers message
	        msg =
	          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
	        data.extra.arguments = args.slice(1);
	        callback && callback(msg, data);
	      }
	    } else {
	      callback && callback(msg, data);
	    }
	
	    // this fails for some browsers. :(
	    if (originalConsoleLevel) {
	      // IE9 doesn't allow calling apply on console functions directly
	      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
	    }
	  };
	};
	
	module.exports = {
	  wrapMethod: wrapMethod
	};


/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */
	
	var TraceKit = __webpack_require__(2102);
	var stringify = __webpack_require__(894);
	var md5 = __webpack_require__(2103);
	var RavenConfigError = __webpack_require__(2099);
	
	var utils = __webpack_require__(493);
	var isErrorEvent = utils.isErrorEvent;
	var isDOMError = utils.isDOMError;
	var isDOMException = utils.isDOMException;
	var isError = utils.isError;
	var isObject = utils.isObject;
	var isPlainObject = utils.isPlainObject;
	var isUndefined = utils.isUndefined;
	var isFunction = utils.isFunction;
	var isString = utils.isString;
	var isArray = utils.isArray;
	var isEmptyObject = utils.isEmptyObject;
	var each = utils.each;
	var objectMerge = utils.objectMerge;
	var truncate = utils.truncate;
	var objectFrozen = utils.objectFrozen;
	var hasKey = utils.hasKey;
	var joinRegExp = utils.joinRegExp;
	var urlencode = utils.urlencode;
	var uuid4 = utils.uuid4;
	var htmlTreeAsString = utils.htmlTreeAsString;
	var isSameException = utils.isSameException;
	var isSameStacktrace = utils.isSameStacktrace;
	var parseUrl = utils.parseUrl;
	var fill = utils.fill;
	var supportsFetch = utils.supportsFetch;
	var supportsReferrerPolicy = utils.supportsReferrerPolicy;
	var serializeKeysForMessage = utils.serializeKeysForMessage;
	var serializeException = utils.serializeException;
	var sanitize = utils.sanitize;
	
	var wrapConsoleMethod = __webpack_require__(2100).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	  return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	function keepOriginalCallback(original, callback) {
	  return isFunction(callback)
	    ? function(data) {
	        return callback(data, original);
	      }
	    : callback;
	}
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	  // Raven can run in contexts where there's no document (react-native)
	  this._hasDocument = !isUndefined(_document);
	  this._hasNavigator = !isUndefined(_navigator);
	  this._lastCapturedException = null;
	  this._lastData = null;
	  this._lastEventId = null;
	  this._globalServer = null;
	  this._globalKey = null;
	  this._globalProject = null;
	  this._globalContext = {};
	  this._globalOptions = {
	    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
	    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
	    logger: 'javascript',
	    ignoreErrors: [],
	    ignoreUrls: [],
	    whitelistUrls: [],
	    includePaths: [],
	    headers: null,
	    collectWindowErrors: true,
	    captureUnhandledRejections: true,
	    maxMessageLength: 0,
	    // By default, truncates URL values to 250 chars
	    maxUrlLength: 250,
	    stackTraceLimit: 50,
	    autoBreadcrumbs: true,
	    instrument: true,
	    sampleRate: 1,
	    sanitizeKeys: []
	  };
	  this._fetchDefaults = {
	    method: 'POST',
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
	  };
	  this._ignoreOnError = 0;
	  this._isRavenInstalled = false;
	  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	  // capture references to window.console *and* all its methods first
	  // before the console plugin has a chance to monkey patch
	  this._originalConsole = _window.console || {};
	  this._originalConsoleMethods = {};
	  this._plugins = [];
	  this._startTime = now();
	  this._wrappedBuiltIns = [];
	  this._breadcrumbs = [];
	  this._lastCapturedEvent = null;
	  this._keypressTimeout;
	  this._location = _window.location;
	  this._lastHref = this._location && this._location.href;
	  this._resetBackoff();
	
	  // eslint-disable-next-line guard-for-in
	  for (var method in this._originalConsole) {
	    this._originalConsoleMethods[method] = this._originalConsole[method];
	  }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	  // Hardcode version string so that raven source can be loaded directly via
	  // webpack (using a build step causes webpack #1617). Grunt verifies that
	  // this value matches package.json during build.
	  //   See: https://github.com/getsentry/raven-js/issues/465
	  VERSION: '3.27.2',
	
	  debug: false,
	
	  TraceKit: TraceKit, // alias to TraceKit
	
	  /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Set of global options [optional]
	     * @return {Raven}
	     */
	  config: function(dsn, options) {
	    var self = this;
	
	    if (self._globalServer) {
	      this._logDebug('error', 'Error: Raven has already been configured');
	      return self;
	    }
	    if (!dsn) return self;
	
	    var globalOptions = self._globalOptions;
	
	    // merge in options
	    if (options) {
	      each(options, function(key, value) {
	        // tags and extra are special and need to be put into context
	        if (key === 'tags' || key === 'extra' || key === 'user') {
	          self._globalContext[key] = value;
	        } else {
	          globalOptions[key] = value;
	        }
	      });
	    }
	
	    self.setDSN(dsn);
	
	    // "Script error." is hard coded into browsers for errors that it can't read.
	    // this is the result of a script being pulled in from an external domain and CORS.
	    globalOptions.ignoreErrors.push(/^Script error\.?$/);
	    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	    // join regexp rules into one big rule
	    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
	      ? joinRegExp(globalOptions.ignoreUrls)
	      : false;
	    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
	      ? joinRegExp(globalOptions.whitelistUrls)
	      : false;
	    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	    globalOptions.maxBreadcrumbs = Math.max(
	      0,
	      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
	    ); // default and hard limit is 100
	
	    var autoBreadcrumbDefaults = {
	      xhr: true,
	      console: true,
	      dom: true,
	      location: true,
	      sentry: true
	    };
	
	    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	    } else if (autoBreadcrumbs !== false) {
	      autoBreadcrumbs = autoBreadcrumbDefaults;
	    }
	    globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	    var instrumentDefaults = {
	      tryCatch: true
	    };
	
	    var instrument = globalOptions.instrument;
	    if ({}.toString.call(instrument) === '[object Object]') {
	      instrument = objectMerge(instrumentDefaults, instrument);
	    } else if (instrument !== false) {
	      instrument = instrumentDefaults;
	    }
	    globalOptions.instrument = instrument;
	
	    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	    // return for chaining
	    return self;
	  },
	
	  /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	  install: function() {
	    var self = this;
	    if (self.isSetup() && !self._isRavenInstalled) {
	      TraceKit.report.subscribe(function() {
	        self._handleOnErrorStackInfo.apply(self, arguments);
	      });
	
	      if (self._globalOptions.captureUnhandledRejections) {
	        self._attachPromiseRejectionHandler();
	      }
	
	      self._patchFunctionToString();
	
	      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
	        self._instrumentTryCatch();
	      }
	
	      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();
	
	      // Install all of the plugins
	      self._drainPlugins();
	
	      self._isRavenInstalled = true;
	    }
	
	    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	    return this;
	  },
	
	  /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	  setDSN: function(dsn) {
	    var self = this,
	      uri = self._parseDSN(dsn),
	      lastSlash = uri.path.lastIndexOf('/'),
	      path = uri.path.substr(1, lastSlash);
	
	    self._dsn = dsn;
	    self._globalKey = uri.user;
	    self._globalSecret = uri.pass && uri.pass.substr(1);
	    self._globalProject = uri.path.substr(lastSlash + 1);
	
	    self._globalServer = self._getGlobalServer(uri);
	
	    self._globalEndpoint =
	      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';
	
	    // Reset backoff state since we may be pointing at a
	    // new project/server
	    this._resetBackoff();
	  },
	
	  /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	  context: function(options, func, args) {
	    if (isFunction(options)) {
	      args = func || [];
	      func = options;
	      options = {};
	    }
	
	    return this.wrap(options, func).apply(this, args);
	  },
	
	  /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	  wrap: function(options, func, _before) {
	    var self = this;
	    // 1 argument has been passed, and it's not a function
	    // so just return it
	    if (isUndefined(func) && !isFunction(options)) {
	      return options;
	    }
	
	    // options is optional
	    if (isFunction(options)) {
	      func = options;
	      options = undefined;
	    }
	
	    // At this point, we've passed along 2 arguments, and the second one
	    // is not a function either, so we'll just return the second argument.
	    if (!isFunction(func)) {
	      return func;
	    }
	
	    // We don't wanna wrap it twice!
	    try {
	      if (func.__raven__) {
	        return func;
	      }
	
	      // If this has already been wrapped in the past, return that
	      if (func.__raven_wrapper__) {
	        return func.__raven_wrapper__;
	      }
	    } catch (e) {
	      // Just accessing custom props in some Selenium environments
	      // can cause a "Permission denied" exception (see raven-js#495).
	      // Bail on wrapping and return the function as-is (defers to window.onerror).
	      return func;
	    }
	
	    function wrapped() {
	      var args = [],
	        i = arguments.length,
	        deep = !options || (options && options.deep !== false);
	
	      if (_before && isFunction(_before)) {
	        _before.apply(this, arguments);
	      }
	
	      // Recursively wrap all of a function's arguments that are
	      // functions themselves.
	      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	      try {
	        // Attempt to invoke user-land function
	        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	        //       means Raven caught an error invoking your application code. This is
	        //       expected behavior and NOT indicative of a bug with Raven.js.
	        return func.apply(this, args);
	      } catch (e) {
	        self._ignoreNextOnError();
	        self.captureException(e, options);
	        throw e;
	      }
	    }
	
	    // copy over properties of the old function
	    for (var property in func) {
	      if (hasKey(func, property)) {
	        wrapped[property] = func[property];
	      }
	    }
	    wrapped.prototype = func.prototype;
	
	    func.__raven_wrapper__ = wrapped;
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    wrapped.__raven__ = true;
	    wrapped.__orig__ = func;
	
	    return wrapped;
	  },
	
	  /**
	   * Uninstalls the global error handler.
	   *
	   * @return {Raven}
	   */
	  uninstall: function() {
	    TraceKit.report.uninstall();
	
	    this._detachPromiseRejectionHandler();
	    this._unpatchFunctionToString();
	    this._restoreBuiltIns();
	    this._restoreConsole();
	
	    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	    this._isRavenInstalled = false;
	
	    return this;
	  },
	
	  /**
	   * Callback used for `unhandledrejection` event
	   *
	   * @param {PromiseRejectionEvent} event An object containing
	   *   promise: the Promise that was rejected
	   *   reason: the value with which the Promise was rejected
	   * @return void
	   */
	  _promiseRejectionHandler: function(event) {
	    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
	    this.captureException(event.reason, {
	      mechanism: {
	        type: 'onunhandledrejection',
	        handled: false
	      }
	    });
	  },
	
	  /**
	   * Installs the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _attachPromiseRejectionHandler: function() {
	    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
	    _window.addEventListener &&
	      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Uninstalls the global promise rejection handler.
	   *
	   * @return {raven}
	   */
	  _detachPromiseRejectionHandler: function() {
	    _window.removeEventListener &&
	      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
	    return this;
	  },
	
	  /**
	   * Manually capture an exception and send it over to Sentry
	   *
	   * @param {error} ex An exception to be logged
	   * @param {object} options A specific set of options for this error [optional]
	   * @return {Raven}
	   */
	  captureException: function(ex, options) {
	    options = objectMerge({trimHeadFrames: 0}, options ? options : {});
	
	    if (isErrorEvent(ex) && ex.error) {
	      // If it is an ErrorEvent with `error` property, extract it to get actual Error
	      ex = ex.error;
	    } else if (isDOMError(ex) || isDOMException(ex)) {
	      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	      // then we just extract the name and message, as they don't provide anything else
	      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
	      var message = ex.message ? name + ': ' + ex.message : name;
	
	      return this.captureMessage(
	        message,
	        objectMerge(options, {
	          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
	          // but it's barely any overhead so we may at least try
	          stacktrace: true,
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    } else if (isError(ex)) {
	      // we have a real Error object
	      ex = ex;
	    } else if (isPlainObject(ex)) {
	      // If it is plain Object, serialize it manually and extract options
	      // This will allow us to group events based on top-level keys
	      // which is much better than creating new group when any key/value change
	      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
	      ex = new Error(options.message);
	    } else {
	      // If none of previous checks were valid, then it means that
	      // it's not a DOMError/DOMException
	      // it's not a plain Object
	      // it's not a valid ErrorEvent (one with an error property)
	      // it's not an Error
	      // So bail out and capture it as a simple message:
	      return this.captureMessage(
	        ex,
	        objectMerge(options, {
	          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
	          trimHeadFrames: options.trimHeadFrames + 1
	        })
	      );
	    }
	
	    // Store the raw exception object for potential debugging and introspection
	    this._lastCapturedException = ex;
	
	    // TraceKit.report will re-raise any exception passed to it,
	    // which means you have to wrap it in try/catch. Instead, we
	    // can wrap it here and only re-raise if TraceKit.report
	    // raises an exception different from the one we asked to
	    // report on.
	    try {
	      var stack = TraceKit.computeStackTrace(ex);
	      this._handleStackInfo(stack, options);
	    } catch (ex1) {
	      if (ex !== ex1) {
	        throw ex1;
	      }
	    }
	
	    return this;
	  },
	
	  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
	    var exKeys = Object.keys(ex).sort();
	    var options = objectMerge(currentOptions, {
	      message:
	        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
	      fingerprint: [md5(exKeys)],
	      extra: currentOptions.extra || {}
	    });
	    options.extra.__serialized__ = serializeException(ex);
	
	    return options;
	  },
	
	  /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	  captureMessage: function(msg, options) {
	    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	    // early call; we'll error on the side of logging anything called before configuration since it's
	    // probably something you should see:
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      this._globalOptions.ignoreErrors.test(msg)
	    ) {
	      return;
	    }
	
	    options = options || {};
	    msg = msg + ''; // Make sure it's actually a string
	
	    var data = objectMerge(
	      {
	        message: msg
	      },
	      options
	    );
	
	    var ex;
	    // Generate a "synthetic" stack trace from this point.
	    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
	    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
	    //       or if it catches a thrown object without a "stack" property.
	    try {
	      throw new Error(msg);
	    } catch (ex1) {
	      ex = ex1;
	    }
	
	    // null exception name so `Error` isn't prefixed to msg
	    ex.name = null;
	    var stack = TraceKit.computeStackTrace(ex);
	
	    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
	    var initialCall = isArray(stack.stack) && stack.stack[1];
	
	    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
	    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
	    // initialCall => captureException(string) => captureMessage(string)
	    if (initialCall && initialCall.func === 'Raven.captureException') {
	      initialCall = stack.stack[2];
	    }
	
	    var fileurl = (initialCall && initialCall.url) || '';
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    // Always attempt to get stacktrace if message is empty.
	    // It's the only way to provide any helpful information to the user.
	    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
	      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
	      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;
	
	      options = objectMerge(
	        {
	          trimHeadFrames: 0
	        },
	        options
	      );
	      // Since we know this is a synthetic trace, the top frame (this function call)
	      // MUST be from Raven.js, so mark it for trimming
	      // We add to the trim counter so that callers can choose to trim extra frames, such
	      // as utility functions.
	      options.trimHeadFrames += 1;
	
	      var frames = this._prepareFrames(stack, options);
	      data.stacktrace = {
	        // Sentry expects frames oldest to newest
	        frames: frames.reverse()
	      };
	    }
	
	    // Make sure that fingerprint is always wrapped in an array
	    if (data.fingerprint) {
	      data.fingerprint = isArray(data.fingerprint)
	        ? data.fingerprint
	        : [data.fingerprint];
	    }
	
	    // Fire away!
	    this._send(data);
	
	    return this;
	  },
	
	  captureBreadcrumb: function(obj) {
	    var crumb = objectMerge(
	      {
	        timestamp: now() / 1000
	      },
	      obj
	    );
	
	    if (isFunction(this._globalOptions.breadcrumbCallback)) {
	      var result = this._globalOptions.breadcrumbCallback(crumb);
	
	      if (isObject(result) && !isEmptyObject(result)) {
	        crumb = result;
	      } else if (result === false) {
	        return this;
	      }
	    }
	
	    this._breadcrumbs.push(crumb);
	    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	      this._breadcrumbs.shift();
	    }
	    return this;
	  },
	
	  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	    var pluginArgs = [].slice.call(arguments, 1);
	
	    this._plugins.push([plugin, pluginArgs]);
	    if (this._isRavenInstalled) {
	      this._drainPlugins();
	    }
	
	    return this;
	  },
	
	  /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	  setUserContext: function(user) {
	    // Intentionally do not merge here since that's an unexpected behavior.
	    this._globalContext.user = user;
	
	    return this;
	  },
	
	  /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	  setExtraContext: function(extra) {
	    this._mergeContext('extra', extra);
	
	    return this;
	  },
	
	  /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	  setTagsContext: function(tags) {
	    this._mergeContext('tags', tags);
	
	    return this;
	  },
	
	  /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	  clearContext: function() {
	    this._globalContext = {};
	
	    return this;
	  },
	
	  /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	  getContext: function() {
	    // lol javascript
	    return JSON.parse(stringify(this._globalContext));
	  },
	
	  /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	  setEnvironment: function(environment) {
	    this._globalOptions.environment = environment;
	
	    return this;
	  },
	
	  /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	  setRelease: function(release) {
	    this._globalOptions.release = release;
	
	    return this;
	  },
	
	  /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	  setDataCallback: function(callback) {
	    var original = this._globalOptions.dataCallback;
	    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	  setBreadcrumbCallback: function(callback) {
	    var original = this._globalOptions.breadcrumbCallback;
	    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	  setShouldSendCallback: function(callback) {
	    var original = this._globalOptions.shouldSendCallback;
	    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
	    return this;
	  },
	
	  /**
	   * Override the default HTTP transport mechanism that transmits data
	   * to the Sentry server.
	   *
	   * @param {function} transport Function invoked instead of the default
	   *                             `makeRequest` handler.
	   *
	   * @return {Raven}
	   */
	  setTransport: function(transport) {
	    this._globalOptions.transport = transport;
	
	    return this;
	  },
	
	  /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	  lastException: function() {
	    return this._lastCapturedException;
	  },
	
	  /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	  lastEventId: function() {
	    return this._lastEventId;
	  },
	
	  /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	  isSetup: function() {
	    if (!this._hasJSON) return false; // needs JSON support
	    if (!this._globalServer) {
	      if (!this.ravenNotConfiguredError) {
	        this.ravenNotConfiguredError = true;
	        this._logDebug('error', 'Error: Raven has not been configured.');
	      }
	      return false;
	    }
	    return true;
	  },
	
	  afterLoad: function() {
	    // TODO: remove window dependence?
	
	    // Attempt to initialize Raven on load
	    var RavenConfig = _window.RavenConfig;
	    if (RavenConfig) {
	      this.config(RavenConfig.dsn, RavenConfig.config).install();
	    }
	  },
	
	  showReportDialog: function(options) {
	    if (
	      !_document // doesn't work without a document (React native)
	    )
	      return;
	
	    options = objectMerge(
	      {
	        eventId: this.lastEventId(),
	        dsn: this._dsn,
	        user: this._globalContext.user || {}
	      },
	      options
	    );
	
	    if (!options.eventId) {
	      throw new RavenConfigError('Missing eventId');
	    }
	
	    if (!options.dsn) {
	      throw new RavenConfigError('Missing DSN');
	    }
	
	    var encode = encodeURIComponent;
	    var encodedOptions = [];
	
	    for (var key in options) {
	      if (key === 'user') {
	        var user = options.user;
	        if (user.name) encodedOptions.push('name=' + encode(user.name));
	        if (user.email) encodedOptions.push('email=' + encode(user.email));
	      } else {
	        encodedOptions.push(encode(key) + '=' + encode(options[key]));
	      }
	    }
	    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));
	
	    var script = _document.createElement('script');
	    script.async = true;
	    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
	    (_document.head || _document.body).appendChild(script);
	  },
	
	  /**** Private functions ****/
	  _ignoreNextOnError: function() {
	    var self = this;
	    this._ignoreOnError += 1;
	    setTimeout(function() {
	      // onerror should trigger before setTimeout
	      self._ignoreOnError -= 1;
	    });
	  },
	
	  _triggerEvent: function(eventType, options) {
	    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	    var evt, key;
	
	    if (!this._hasDocument) return;
	
	    options = options || {};
	
	    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);
	
	    if (_document.createEvent) {
	      evt = _document.createEvent('HTMLEvents');
	      evt.initEvent(eventType, true, true);
	    } else {
	      evt = _document.createEventObject();
	      evt.eventType = eventType;
	    }
	
	    for (key in options)
	      if (hasKey(options, key)) {
	        evt[key] = options[key];
	      }
	
	    if (_document.createEvent) {
	      // IE9 if standards
	      _document.dispatchEvent(evt);
	    } else {
	      // IE8 regardless of Quirks or Standards
	      // IE9 if quirks
	      try {
	        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	      } catch (e) {
	        // Do nothing
	      }
	    }
	  },
	
	  /**
	   * Wraps addEventListener to capture UI breadcrumbs
	   * @param evtName the event name (e.g. "click")
	   * @returns {Function}
	   * @private
	   */
	  _breadcrumbEventHandler: function(evtName) {
	    var self = this;
	    return function(evt) {
	      // reset keypress timeout; e.g. triggering a 'click' after
	      // a 'keypress' will reset the keypress debounce so that a new
	      // set of keypresses can be recorded
	      self._keypressTimeout = null;
	
	      // It's possible this handler might trigger multiple times for the same
	      // event (e.g. event propagation through node ancestors). Ignore if we've
	      // already captured the event.
	      if (self._lastCapturedEvent === evt) return;
	
	      self._lastCapturedEvent = evt;
	
	      // try/catch both:
	      // - accessing evt.target (see getsentry/raven-js#838, #768)
	      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	      //   can throw an exception in some circumstances.
	      var target;
	      try {
	        target = htmlTreeAsString(evt.target);
	      } catch (e) {
	        target = '<unknown>';
	      }
	
	      self.captureBreadcrumb({
	        category: 'ui.' + evtName, // e.g. ui.click, ui.input
	        message: target
	      });
	    };
	  },
	
	  /**
	   * Wraps addEventListener to capture keypress UI events
	   * @returns {Function}
	   * @private
	   */
	  _keypressEventHandler: function() {
	    var self = this,
	      debounceDuration = 1000; // milliseconds
	
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function(evt) {
	      var target;
	      try {
	        target = evt.target;
	      } catch (e) {
	        // just accessing event properties can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/raven-js/issues/838
	        return;
	      }
	      var tagName = target && target.tagName;
	
	      // only consider keypress events on actual input elements
	      // this will disregard keypresses targeting body (e.g. tabbing
	      // through elements, hotkeys, etc)
	      if (
	        !tagName ||
	        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	      )
	        return;
	
	      // record first keypress in a series, but ignore subsequent
	      // keypresses until debounce clears
	      var timeout = self._keypressTimeout;
	      if (!timeout) {
	        self._breadcrumbEventHandler('input')(evt);
	      }
	      clearTimeout(timeout);
	      self._keypressTimeout = setTimeout(function() {
	        self._keypressTimeout = null;
	      }, debounceDuration);
	    };
	  },
	
	  /**
	   * Captures a breadcrumb of type "navigation", normalizing input URLs
	   * @param to the originating URL
	   * @param from the target URL
	   * @private
	   */
	  _captureUrlChange: function(from, to) {
	    var parsedLoc = parseUrl(this._location.href);
	    var parsedTo = parseUrl(to);
	    var parsedFrom = parseUrl(from);
	
	    // because onpopstate only tells you the "new" (to) value of location.href, and
	    // not the previous (from) value, we need to track the value of the current URL
	    // state ourselves
	    this._lastHref = to;
	
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	      to = parsedTo.relative;
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	      from = parsedFrom.relative;
	
	    this.captureBreadcrumb({
	      category: 'navigation',
	      data: {
	        to: to,
	        from: from
	      }
	    });
	  },
	
	  _patchFunctionToString: function() {
	    var self = this;
	    self._originalFunctionToString = Function.prototype.toString;
	    // eslint-disable-next-line no-extend-native
	    Function.prototype.toString = function() {
	      if (typeof this === 'function' && this.__raven__) {
	        return self._originalFunctionToString.apply(this.__orig__, arguments);
	      }
	      return self._originalFunctionToString.apply(this, arguments);
	    };
	  },
	
	  _unpatchFunctionToString: function() {
	    if (this._originalFunctionToString) {
	      // eslint-disable-next-line no-extend-native
	      Function.prototype.toString = this._originalFunctionToString;
	    }
	  },
	
	  /**
	   * Wrap timer functions and event targets to catch errors and provide
	   * better metadata.
	   */
	  _instrumentTryCatch: function() {
	    var self = this;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapTimeFn(orig) {
	      return function(fn, t) {
	        // preserve arity
	        // Make a copy of the arguments to prevent deoptimization
	        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	        var args = new Array(arguments.length);
	        for (var i = 0; i < args.length; ++i) {
	          args[i] = arguments[i];
	        }
	        var originalCallback = args[0];
	        if (isFunction(originalCallback)) {
	          args[0] = self.wrap(
	            {
	              mechanism: {
	                type: 'instrument',
	                data: {function: orig.name || '<anonymous>'}
	              }
	            },
	            originalCallback
	          );
	        }
	
	        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	        // also supports only two arguments and doesn't care what this is, so we
	        // can just call the original function directly.
	        if (orig.apply) {
	          return orig.apply(this, args);
	        } else {
	          return orig(args[0], args[1]);
	        }
	      };
	    }
	
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    function wrapEventTarget(global) {
	      var proto = _window[global] && _window[global].prototype;
	      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	        fill(
	          proto,
	          'addEventListener',
	          function(orig) {
	            return function(evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(
	                    {
	                      mechanism: {
	                        type: 'instrument',
	                        data: {
	                          target: global,
	                          function: 'handleEvent',
	                          handler: (fn && fn.name) || '<anonymous>'
	                        }
	                      }
	                    },
	                    fn.handleEvent
	                  );
	                }
	              } catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	              }
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before, clickHandler, keypressHandler;
	
	              if (
	                autoBreadcrumbs &&
	                autoBreadcrumbs.dom &&
	                (global === 'EventTarget' || global === 'Node')
	              ) {
	                // NOTE: generating multiple handlers per addEventListener invocation, should
	                //       revisit and verify we can just use one (almost certainly)
	                clickHandler = self._breadcrumbEventHandler('click');
	                keypressHandler = self._keypressEventHandler();
	                before = function(evt) {
	                  // need to intercept every DOM event in `before` argument, in case that
	                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                  // see #724
	                  if (!evt) return;
	
	                  var eventType;
	                  try {
	                    eventType = evt.type;
	                  } catch (e) {
	                    // just accessing event properties can throw an exception in some rare circumstances
	                    // see: https://github.com/getsentry/raven-js/issues/838
	                    return;
	                  }
	                  if (eventType === 'click') return clickHandler(evt);
	                  else if (eventType === 'keypress') return keypressHandler(evt);
	                };
	              }
	              return orig.call(
	                this,
	                evtName,
	                self.wrap(
	                  {
	                    mechanism: {
	                      type: 'instrument',
	                      data: {
	                        target: global,
	                        function: 'addEventListener',
	                        handler: (fn && fn.name) || '<anonymous>'
	                      }
	                    }
	                  },
	                  fn,
	                  before
	                ),
	                capture,
	                secure
	              );
	            };
	          },
	          wrappedBuiltIns
	        );
	        fill(
	          proto,
	          'removeEventListener',
	          function(orig) {
	            return function(evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          },
	          wrappedBuiltIns
	        );
	      }
	    }
	
	    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	    if (_window.requestAnimationFrame) {
	      fill(
	        _window,
	        'requestAnimationFrame',
	        function(orig) {
	          return function(cb) {
	            return orig(
	              self.wrap(
	                {
	                  mechanism: {
	                    type: 'instrument',
	                    data: {
	                      function: 'requestAnimationFrame',
	                      handler: (orig && orig.name) || '<anonymous>'
	                    }
	                  }
	                },
	                cb
	              )
	            );
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // event targets borrowed from bugsnag-js:
	    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	    var eventTargets = [
	      'EventTarget',
	      'Window',
	      'Node',
	      'ApplicationCache',
	      'AudioTrackList',
	      'ChannelMergerNode',
	      'CryptoOperation',
	      'EventSource',
	      'FileReader',
	      'HTMLUnknownElement',
	      'IDBDatabase',
	      'IDBRequest',
	      'IDBTransaction',
	      'KeyOperation',
	      'MediaController',
	      'MessagePort',
	      'ModalWindow',
	      'Notification',
	      'SVGElementInstance',
	      'Screen',
	      'TextTrack',
	      'TextTrackCue',
	      'TextTrackList',
	      'WebSocket',
	      'WebSocketWorker',
	      'Worker',
	      'XMLHttpRequest',
	      'XMLHttpRequestEventTarget',
	      'XMLHttpRequestUpload'
	    ];
	    for (var i = 0; i < eventTargets.length; i++) {
	      wrapEventTarget(eventTargets[i]);
	    }
	  },
	
	  /**
	   * Instrument browser built-ins w/ breadcrumb capturing
	   *  - XMLHttpRequests
	   *  - DOM interactions (click/typing)
	   *  - window.location changes
	   *  - console
	   *
	   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	   */
	  _instrumentBreadcrumbs: function() {
	    var self = this;
	    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	    var wrappedBuiltIns = self._wrappedBuiltIns;
	
	    function wrapProp(prop, xhr) {
	      if (prop in xhr && isFunction(xhr[prop])) {
	        fill(xhr, prop, function(orig) {
	          return self.wrap(
	            {
	              mechanism: {
	                type: 'instrument',
	                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
	              }
	            },
	            orig
	          );
	        }); // intentionally don't track filled methods on XHR instances
	      }
	    }
	
	    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
	      fill(
	        xhrproto,
	        'open',
	        function(origOpen) {
	          return function(method, url) {
	            // preserve arity
	
	            // if Sentry key appears in URL, don't capture
	            if (isString(url) && url.indexOf(self._globalKey) === -1) {
	              this.__raven_xhr = {
	                method: method,
	                url: url,
	                status_code: null
	              };
	            }
	
	            return origOpen.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	
	      fill(
	        xhrproto,
	        'send',
	        function(origSend) {
	          return function() {
	            // preserve arity
	            var xhr = this;
	
	            function onreadystatechangeHandler() {
	              if (xhr.__raven_xhr && xhr.readyState === 4) {
	                try {
	                  // touching statusCode in some platforms throws
	                  // an exception
	                  xhr.__raven_xhr.status_code = xhr.status;
	                } catch (e) {
	                  /* do nothing */
	                }
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'xhr',
	                  data: xhr.__raven_xhr
	                });
	              }
	            }
	
	            var props = ['onload', 'onerror', 'onprogress'];
	            for (var j = 0; j < props.length; j++) {
	              wrapProp(props[j], xhr);
	            }
	
	            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	              fill(
	                xhr,
	                'onreadystatechange',
	                function(orig) {
	                  return self.wrap(
	                    {
	                      mechanism: {
	                        type: 'instrument',
	                        data: {
	                          function: 'onreadystatechange',
	                          handler: (orig && orig.name) || '<anonymous>'
	                        }
	                      }
	                    },
	                    orig,
	                    onreadystatechangeHandler
	                  );
	                } /* intentionally don't track this instrumentation */
	              );
	            } else {
	              // if onreadystatechange wasn't actually set by the page on this xhr, we
	              // are free to set our own and capture the breadcrumb
	              xhr.onreadystatechange = onreadystatechangeHandler;
	            }
	
	            return origSend.apply(this, arguments);
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    if (autoBreadcrumbs.xhr && supportsFetch()) {
	      fill(
	        _window,
	        'fetch',
	        function(origFetch) {
	          return function() {
	            // preserve arity
	            // Make a copy of the arguments to prevent deoptimization
	            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	            var args = new Array(arguments.length);
	            for (var i = 0; i < args.length; ++i) {
	              args[i] = arguments[i];
	            }
	
	            var fetchInput = args[0];
	            var method = 'GET';
	            var url;
	
	            if (typeof fetchInput === 'string') {
	              url = fetchInput;
	            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
	              url = fetchInput.url;
	              if (fetchInput.method) {
	                method = fetchInput.method;
	              }
	            } else {
	              url = '' + fetchInput;
	            }
	
	            // if Sentry key appears in URL, don't capture, as it's our own request
	            if (url.indexOf(self._globalKey) !== -1) {
	              return origFetch.apply(this, args);
	            }
	
	            if (args[1] && args[1].method) {
	              method = args[1].method;
	            }
	
	            var fetchData = {
	              method: method,
	              url: url,
	              status_code: null
	            };
	
	            return origFetch
	              .apply(this, args)
	              .then(function(response) {
	                fetchData.status_code = response.status;
	
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'fetch',
	                  data: fetchData
	                });
	
	                return response;
	              })
	              ['catch'](function(err) {
	                // if there is an error performing the request
	                self.captureBreadcrumb({
	                  type: 'http',
	                  category: 'fetch',
	                  data: fetchData,
	                  level: 'error'
	                });
	
	                throw err;
	              });
	          };
	        },
	        wrappedBuiltIns
	      );
	    }
	
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    if (autoBreadcrumbs.dom && this._hasDocument) {
	      if (_document.addEventListener) {
	        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	        _document.addEventListener('keypress', self._keypressEventHandler(), false);
	      } else if (_document.attachEvent) {
	        // IE8 Compatibility
	        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	        _document.attachEvent('onkeypress', self._keypressEventHandler());
	      }
	    }
	
	    // record navigation (URL) changes
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var chrome = _window.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    var hasPushAndReplaceState =
	      !isChromePackagedApp &&
	      _window.history &&
	      _window.history.pushState &&
	      _window.history.replaceState;
	    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
	      // TODO: remove onpopstate handler on uninstall()
	      var oldOnPopState = _window.onpopstate;
	      _window.onpopstate = function() {
	        var currentHref = self._location.href;
	        self._captureUrlChange(self._lastHref, currentHref);
	
	        if (oldOnPopState) {
	          return oldOnPopState.apply(this, arguments);
	        }
	      };
	
	      var historyReplacementFunction = function(origHistFunction) {
	        // note history.pushState.length is 0; intentionally not declaring
	        // params to preserve 0 arity
	        return function(/* state, title, url */) {
	          var url = arguments.length > 2 ? arguments[2] : undefined;
	
	          // url argument is optional
	          if (url) {
	            // coerce to string (this is what pushState does)
	            self._captureUrlChange(self._lastHref, url + '');
	          }
	
	          return origHistFunction.apply(this, arguments);
	        };
	      };
	
	      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
	      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
	    }
	
	    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	      // console
	      var consoleMethodCallback = function(msg, data) {
	        self.captureBreadcrumb({
	          message: msg,
	          level: data.level,
	          category: 'console'
	        });
	      };
	
	      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
	        wrapConsoleMethod(console, level, consoleMethodCallback);
	      });
	    }
	  },
	
	  _restoreBuiltIns: function() {
	    // restore any wrapped builtins
	    var builtin;
	    while (this._wrappedBuiltIns.length) {
	      builtin = this._wrappedBuiltIns.shift();
	
	      var obj = builtin[0],
	        name = builtin[1],
	        orig = builtin[2];
	
	      obj[name] = orig;
	    }
	  },
	
	  _restoreConsole: function() {
	    // eslint-disable-next-line guard-for-in
	    for (var method in this._originalConsoleMethods) {
	      this._originalConsole[method] = this._originalConsoleMethods[method];
	    }
	  },
	
	  _drainPlugins: function() {
	    var self = this;
	
	    // FIX ME TODO
	    each(this._plugins, function(_, plugin) {
	      var installer = plugin[0];
	      var args = plugin[1];
	      installer.apply(self, [self].concat(args));
	    });
	  },
	
	  _parseDSN: function(str) {
	    var m = dsnPattern.exec(str),
	      dsn = {},
	      i = 7;
	
	    try {
	      while (i--) dsn[dsnKeys[i]] = m[i] || '';
	    } catch (e) {
	      throw new RavenConfigError('Invalid DSN: ' + str);
	    }
	
	    if (dsn.pass && !this._globalOptions.allowSecretKey) {
	      throw new RavenConfigError(
	        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
	      );
	    }
	
	    return dsn;
	  },
	
	  _getGlobalServer: function(uri) {
	    // assemble the endpoint from the uri pieces
	    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');
	
	    if (uri.protocol) {
	      globalServer = uri.protocol + ':' + globalServer;
	    }
	    return globalServer;
	  },
	
	  _handleOnErrorStackInfo: function(stackInfo, options) {
	    options = options || {};
	    options.mechanism = options.mechanism || {
	      type: 'onerror',
	      handled: false
	    };
	
	    // if we are intentionally ignoring errors via onerror, bail out
	    if (!this._ignoreOnError) {
	      this._handleStackInfo(stackInfo, options);
	    }
	  },
	
	  _handleStackInfo: function(stackInfo, options) {
	    var frames = this._prepareFrames(stackInfo, options);
	
	    this._triggerEvent('handle', {
	      stackInfo: stackInfo,
	      options: options
	    });
	
	    this._processException(
	      stackInfo.name,
	      stackInfo.message,
	      stackInfo.url,
	      stackInfo.lineno,
	      frames,
	      options
	    );
	  },
	
	  _prepareFrames: function(stackInfo, options) {
	    var self = this;
	    var frames = [];
	    if (stackInfo.stack && stackInfo.stack.length) {
	      each(stackInfo.stack, function(i, stack) {
	        var frame = self._normalizeFrame(stack, stackInfo.url);
	        if (frame) {
	          frames.push(frame);
	        }
	      });
	
	      // e.g. frames captured via captureMessage throw
	      if (options && options.trimHeadFrames) {
	        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	          frames[j].in_app = false;
	        }
	      }
	    }
	    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	    return frames;
	  },
	
	  _normalizeFrame: function(frame, stackInfoUrl) {
	    // normalize the frames data
	    var normalized = {
	      filename: frame.url,
	      lineno: frame.line,
	      colno: frame.column,
	      function: frame.func || '?'
	    };
	
	    // Case when we don't have any information about the error
	    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
	    // Generating synthetic error doesn't add any value here
	    //
	    // We should probably somehow let a user know that they should fix their code
	    if (!frame.url) {
	      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
	    }
	
	    normalized.in_app = !// determine if an exception came from outside of our app
	    // first we check the global includePaths list.
	    (
	      (!!this._globalOptions.includePaths.test &&
	        !this._globalOptions.includePaths.test(normalized.filename)) ||
	      // Now we check for fun, if the function name is Raven or TraceKit
	      /(Raven|TraceKit)\./.test(normalized['function']) ||
	      // finally, we do a last ditch effort and check for raven.min.js
	      /raven\.(min\.)?js$/.test(normalized.filename)
	    );
	
	    return normalized;
	  },
	
	  _processException: function(type, message, fileurl, lineno, frames, options) {
	    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
	    if (
	      !!this._globalOptions.ignoreErrors.test &&
	      (this._globalOptions.ignoreErrors.test(message) ||
	        this._globalOptions.ignoreErrors.test(prefixedMessage))
	    ) {
	      return;
	    }
	
	    var stacktrace;
	
	    if (frames && frames.length) {
	      fileurl = frames[0].filename || fileurl;
	      // Sentry expects frames oldest to newest
	      // and JS sends them as newest to oldest
	      frames.reverse();
	      stacktrace = {frames: frames};
	    } else if (fileurl) {
	      stacktrace = {
	        frames: [
	          {
	            filename: fileurl,
	            lineno: lineno,
	            in_app: true
	          }
	        ]
	      };
	    }
	
	    if (
	      !!this._globalOptions.ignoreUrls.test &&
	      this._globalOptions.ignoreUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    if (
	      !!this._globalOptions.whitelistUrls.test &&
	      !this._globalOptions.whitelistUrls.test(fileurl)
	    ) {
	      return;
	    }
	
	    var data = objectMerge(
	      {
	        // sentry.interfaces.Exception
	        exception: {
	          values: [
	            {
	              type: type,
	              value: message,
	              stacktrace: stacktrace
	            }
	          ]
	        },
	        transaction: fileurl
	      },
	      options
	    );
	
	    var ex = data.exception.values[0];
	    if (ex.type == null && ex.value === '') {
	      ex.value = 'Unrecoverable error caught';
	    }
	
	    // Move mechanism from options to exception interface
	    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
	    // too much
	    if (!data.exception.mechanism && data.mechanism) {
	      data.exception.mechanism = data.mechanism;
	      delete data.mechanism;
	    }
	
	    data.exception.mechanism = objectMerge(
	      {
	        type: 'generic',
	        handled: true
	      },
	      data.exception.mechanism || {}
	    );
	
	    // Fire away!
	    this._send(data);
	  },
	
	  _trimPacket: function(data) {
	    // For now, we only want to truncate the two different messages
	    // but this could/should be expanded to just trim everything
	    var max = this._globalOptions.maxMessageLength;
	    if (data.message) {
	      data.message = truncate(data.message, max);
	    }
	    if (data.exception) {
	      var exception = data.exception.values[0];
	      exception.value = truncate(exception.value, max);
	    }
	
	    var request = data.request;
	    if (request) {
	      if (request.url) {
	        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
	      }
	      if (request.Referer) {
	        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
	      }
	    }
	
	    if (data.breadcrumbs && data.breadcrumbs.values)
	      this._trimBreadcrumbs(data.breadcrumbs);
	
	    return data;
	  },
	
	  /**
	   * Truncate breadcrumb values (right now just URLs)
	   */
	  _trimBreadcrumbs: function(breadcrumbs) {
	    // known breadcrumb properties with urls
	    // TODO: also consider arbitrary prop values that start with (https?)?://
	    var urlProps = ['to', 'from', 'url'],
	      urlProp,
	      crumb,
	      data;
	
	    for (var i = 0; i < breadcrumbs.values.length; ++i) {
	      crumb = breadcrumbs.values[i];
	      if (
	        !crumb.hasOwnProperty('data') ||
	        !isObject(crumb.data) ||
	        objectFrozen(crumb.data)
	      )
	        continue;
	
	      data = objectMerge({}, crumb.data);
	      for (var j = 0; j < urlProps.length; ++j) {
	        urlProp = urlProps[j];
	        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
	          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
	        }
	      }
	      breadcrumbs.values[i].data = data;
	    }
	  },
	
	  _getHttpData: function() {
	    if (!this._hasNavigator && !this._hasDocument) return;
	    var httpData = {};
	
	    if (this._hasNavigator && _navigator.userAgent) {
	      httpData.headers = {
	        'User-Agent': _navigator.userAgent
	      };
	    }
	
	    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
	    if (_window.location && _window.location.href) {
	      httpData.url = _window.location.href;
	    }
	
	    if (this._hasDocument && _document.referrer) {
	      if (!httpData.headers) httpData.headers = {};
	      httpData.headers.Referer = _document.referrer;
	    }
	
	    return httpData;
	  },
	
	  _resetBackoff: function() {
	    this._backoffDuration = 0;
	    this._backoffStart = null;
	  },
	
	  _shouldBackoff: function() {
	    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	  },
	
	  /**
	   * Returns true if the in-process data payload matches the signature
	   * of the previously-sent data
	   *
	   * NOTE: This has to be done at this level because TraceKit can generate
	   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	   *       other old browsers). This can take the form of an "exception"
	   *       data object with a single frame (derived from the onerror args).
	   */
	  _isRepeatData: function(current) {
	    var last = this._lastData;
	
	    if (
	      !last ||
	      current.message !== last.message || // defined for captureMessage
	      current.transaction !== last.transaction // defined for captureException/onerror
	    )
	      return false;
	
	    // Stacktrace interface (i.e. from captureMessage)
	    if (current.stacktrace || last.stacktrace) {
	      return isSameStacktrace(current.stacktrace, last.stacktrace);
	    } else if (current.exception || last.exception) {
	      // Exception interface (i.e. from captureException/onerror)
	      return isSameException(current.exception, last.exception);
	    } else if (current.fingerprint || last.fingerprint) {
	      return Boolean(current.fingerprint && last.fingerprint) &&
	        JSON.stringify(current.fingerprint) === JSON.stringify(last.fingerprint)
	    }
	
	    return true;
	  },
	
	  _setBackoffState: function(request) {
	    // If we are already in a backoff state, don't change anything
	    if (this._shouldBackoff()) {
	      return;
	    }
	
	    var status = request.status;
	
	    // 400 - project_id doesn't exist or some other fatal
	    // 401 - invalid/revoked dsn
	    // 429 - too many requests
	    if (!(status === 400 || status === 401 || status === 429)) return;
	
	    var retry;
	    try {
	      // If Retry-After is not in Access-Control-Expose-Headers, most
	      // browsers will throw an exception trying to access it
	      if (supportsFetch()) {
	        retry = request.headers.get('Retry-After');
	      } else {
	        retry = request.getResponseHeader('Retry-After');
	      }
	
	      // Retry-After is returned in seconds
	      retry = parseInt(retry, 10) * 1000;
	    } catch (e) {
	      /* eslint no-empty:0 */
	    }
	
	    this._backoffDuration = retry
	      ? // If Sentry server returned a Retry-After value, use it
	        retry
	      : // Otherwise, double the last backoff duration (starts at 1 sec)
	        this._backoffDuration * 2 || 1000;
	
	    this._backoffStart = now();
	  },
	
	  _send: function(data) {
	    var globalOptions = this._globalOptions;
	
	    var baseData = {
	        project: this._globalProject,
	        logger: globalOptions.logger,
	        platform: 'javascript'
	      },
	      httpData = this._getHttpData();
	
	    if (httpData) {
	      baseData.request = httpData;
	    }
	
	    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	    if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	    data = objectMerge(baseData, data);
	
	    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	    // Send along our own collected metadata with extra
	    data.extra['session:duration'] = now() - this._startTime;
	
	    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	      // intentionally make shallow copy so that additions
	      // to breadcrumbs aren't accidentally sent in this request
	      data.breadcrumbs = {
	        values: [].slice.call(this._breadcrumbs, 0)
	      };
	    }
	
	    if (this._globalContext.user) {
	      // sentry.interfaces.User
	      data.user = this._globalContext.user;
	    }
	
	    // Include the environment if it's defined in globalOptions
	    if (globalOptions.environment) data.environment = globalOptions.environment;
	
	    // Include the release if it's defined in globalOptions
	    if (globalOptions.release) data.release = globalOptions.release;
	
	    // Include server_name if it's defined in globalOptions
	    if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	    data = this._sanitizeData(data);
	
	    // Cleanup empty properties before sending them to the server
	    Object.keys(data).forEach(function(key) {
	      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
	        delete data[key];
	      }
	    });
	
	    if (isFunction(globalOptions.dataCallback)) {
	      data = globalOptions.dataCallback(data) || data;
	    }
	
	    // Why??????????
	    if (!data || isEmptyObject(data)) {
	      return;
	    }
	
	    // Check if the request should be filtered or not
	    if (
	      isFunction(globalOptions.shouldSendCallback) &&
	      !globalOptions.shouldSendCallback(data)
	    ) {
	      return;
	    }
	
	    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	    // so drop requests until "cool-off" period has elapsed.
	    if (this._shouldBackoff()) {
	      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	      return;
	    }
	
	    if (typeof globalOptions.sampleRate === 'number') {
	      if (Math.random() < globalOptions.sampleRate) {
	        this._sendProcessedPayload(data);
	      }
	    } else {
	      this._sendProcessedPayload(data);
	    }
	  },
	
	  _sanitizeData: function(data) {
	    return sanitize(data, this._globalOptions.sanitizeKeys);
	  },
	
	  _getUuid: function() {
	    return uuid4();
	  },
	
	  _sendProcessedPayload: function(data, callback) {
	    var self = this;
	    var globalOptions = this._globalOptions;
	
	    if (!this.isSetup()) return;
	
	    // Try and clean up the packet before sending by truncating long values
	    data = this._trimPacket(data);
	
	    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	    // but this would require copying an un-truncated copy of the data packet, which can be
	    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	      this._logDebug('warn', 'Raven dropped repeat event: ', data);
	      return;
	    }
	
	    // Send along an event_id if not explicitly passed.
	    // This event_id can be used to reference the error within Sentry itself.
	    // Set lastEventId after we know the error should actually be sent
	    this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	    // Store outbound payload after trim
	    this._lastData = data;
	
	    this._logDebug('debug', 'Raven about to send:', data);
	
	    var auth = {
	      sentry_version: '7',
	      sentry_client: 'raven-js/' + this.VERSION,
	      sentry_key: this._globalKey
	    };
	
	    if (this._globalSecret) {
	      auth.sentry_secret = this._globalSecret;
	    }
	
	    var exception = data.exception && data.exception.values[0];
	
	    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
	    if (
	      this._globalOptions.autoBreadcrumbs &&
	      this._globalOptions.autoBreadcrumbs.sentry
	    ) {
	      this.captureBreadcrumb({
	        category: 'sentry',
	        message: exception
	          ? (exception.type ? exception.type + ': ' : '') + exception.value
	          : data.message,
	        event_id: data.event_id,
	        level: data.level || 'error' // presume error unless specified
	      });
	    }
	
	    var url = this._globalEndpoint;
	    (globalOptions.transport || this._makeRequest).call(this, {
	      url: url,
	      auth: auth,
	      data: data,
	      options: globalOptions,
	      onSuccess: function success() {
	        self._resetBackoff();
	
	        self._triggerEvent('success', {
	          data: data,
	          src: url
	        });
	        callback && callback();
	      },
	      onError: function failure(error) {
	        self._logDebug('error', 'Raven transport failed to send: ', error);
	
	        if (error.request) {
	          self._setBackoffState(error.request);
	        }
	
	        self._triggerEvent('failure', {
	          data: data,
	          src: url
	        });
	        error = error || new Error('Raven send failed (no additional details provided)');
	        callback && callback(error);
	      }
	    });
	  },
	
	  _makeRequest: function(opts) {
	    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
	    var url = opts.url + '?' + urlencode(opts.auth);
	
	    var evaluatedHeaders = null;
	    var evaluatedFetchParameters = {};
	
	    if (opts.options.headers) {
	      evaluatedHeaders = this._evaluateHash(opts.options.headers);
	    }
	
	    if (opts.options.fetchParameters) {
	      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
	    }
	
	    if (supportsFetch()) {
	      evaluatedFetchParameters.body = stringify(opts.data);
	
	      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
	      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);
	
	      if (evaluatedHeaders) {
	        fetchOptions.headers = evaluatedHeaders;
	      }
	
	      return _window
	        .fetch(url, fetchOptions)
	        .then(function(response) {
	          if (response.ok) {
	            opts.onSuccess && opts.onSuccess();
	          } else {
	            var error = new Error('Sentry error code: ' + response.status);
	            // It's called request only to keep compatibility with XHR interface
	            // and not add more redundant checks in setBackoffState method
	            error.request = response;
	            opts.onError && opts.onError(error);
	          }
	        })
	        ['catch'](function() {
	          opts.onError &&
	            opts.onError(new Error('Sentry error code: network unavailable'));
	        });
	    }
	
	    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
	    if (!request) return;
	
	    // if browser doesn't support CORS (e.g. IE7), we are out of luck
	    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';
	
	    if (!hasCORS) return;
	
	    if ('withCredentials' in request) {
	      request.onreadystatechange = function() {
	        if (request.readyState !== 4) {
	          return;
	        } else if (request.status === 200) {
	          opts.onSuccess && opts.onSuccess();
	        } else if (opts.onError) {
	          var err = new Error('Sentry error code: ' + request.status);
	          err.request = request;
	          opts.onError(err);
	        }
	      };
	    } else {
	      request = new XDomainRequest();
	      // xdomainrequest cannot go http -> https (or vice versa),
	      // so always use protocol relative
	      url = url.replace(/^https?:/, '');
	
	      // onreadystatechange not supported by XDomainRequest
	      if (opts.onSuccess) {
	        request.onload = opts.onSuccess;
	      }
	      if (opts.onError) {
	        request.onerror = function() {
	          var err = new Error('Sentry error code: XDomainRequest');
	          err.request = request;
	          opts.onError(err);
	        };
	      }
	    }
	
	    request.open('POST', url);
	
	    if (evaluatedHeaders) {
	      each(evaluatedHeaders, function(key, value) {
	        request.setRequestHeader(key, value);
	      });
	    }
	
	    request.send(stringify(opts.data));
	  },
	
	  _evaluateHash: function(hash) {
	    var evaluated = {};
	
	    for (var key in hash) {
	      if (hash.hasOwnProperty(key)) {
	        var value = hash[key];
	        evaluated[key] = typeof value === 'function' ? value() : value;
	      }
	    }
	
	    return evaluated;
	  },
	
	  _logDebug: function(level) {
	    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
	    if (
	      this._originalConsoleMethods[level] &&
	      (this.debug || this._globalOptions.debug)
	    ) {
	      // In IE<10 console methods do not have their own 'apply' method
	      Function.prototype.apply.call(
	        this._originalConsoleMethods[level],
	        this._originalConsole,
	        [].slice.call(arguments, 1)
	      );
	    }
	  },
	
	  _mergeContext: function(key, context) {
	    if (isUndefined(context)) {
	      delete this._globalContext[key];
	    } else {
	      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	    }
	  }
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(493);
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	  collectWindowErrors: true,
	  debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window =
	  typeof window !== 'undefined'
	    ? window
	    : typeof global !== 'undefined'
	    ? global
	    : typeof self !== 'undefined'
	    ? self
	    : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	function getLocationHref() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	  return document.location.href;
	}
	
	function getLocationOrigin() {
	  if (typeof document === 'undefined' || document.location == null) return '';
	
	  // Oh dear IE10...
	  if (!document.location.origin) {
	    return (
	      document.location.protocol +
	      '//' +
	      document.location.hostname +
	      (document.location.port ? ':' + document.location.port : '')
	    );
	  }
	
	  return document.location.origin;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	  var handlers = [],
	    lastArgs = null,
	    lastException = null,
	    lastExceptionStack = null;
	
	  /**
	   * Add a crash handler.
	   * @param {Function} handler
	   */
	  function subscribe(handler) {
	    installGlobalHandler();
	    handlers.push(handler);
	  }
	
	  /**
	   * Remove a crash handler.
	   * @param {Function} handler
	   */
	  function unsubscribe(handler) {
	    for (var i = handlers.length - 1; i >= 0; --i) {
	      if (handlers[i] === handler) {
	        handlers.splice(i, 1);
	      }
	    }
	  }
	
	  /**
	   * Remove all crash handlers.
	   */
	  function unsubscribeAll() {
	    uninstallGlobalHandler();
	    handlers = [];
	  }
	
	  /**
	   * Dispatch stack information to all handlers.
	   * @param {Object.<string, *>} stack
	   */
	  function notifyHandlers(stack, isWindowError) {
	    var exception = null;
	    if (isWindowError && !TraceKit.collectWindowErrors) {
	      return;
	    }
	    for (var i in handlers) {
	      if (handlers.hasOwnProperty(i)) {
	        try {
	          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	        } catch (inner) {
	          exception = inner;
	        }
	      }
	    }
	
	    if (exception) {
	      throw exception;
	    }
	  }
	
	  var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	  /**
	   * Ensures all global unhandled exceptions are recorded.
	   * Supported by Gecko and IE.
	   * @param {string} msg Error message.
	   * @param {string} url URL of script that generated the exception.
	   * @param {(number|string)} lineNo The line number at which the error
	   * occurred.
	   * @param {?(number|string)} colNo The column number at which the error
	   * occurred.
	   * @param {?Error} ex The actual Error object.
	   */
	  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
	    var stack = null;
	    // If 'ex' is ErrorEvent, get real Error from inside
	    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
	    // If 'msg' is ErrorEvent, get real message from inside
	    var message = utils.isErrorEvent(msg) ? msg.message : msg;
	
	    if (lastExceptionStack) {
	      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
	        lastExceptionStack,
	        url,
	        lineNo,
	        message
	      );
	      processLastException();
	    } else if (exception && utils.isError(exception)) {
	      // non-string `exception` arg; attempt to extract stack trace
	
	      // New chrome and blink send along a real error object
	      // Let's just report that like a normal error.
	      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	      stack = TraceKit.computeStackTrace(exception);
	      notifyHandlers(stack, true);
	    } else {
	      var location = {
	        url: url,
	        line: lineNo,
	        column: colNo
	      };
	
	      var name = undefined;
	      var groups;
	
	      if ({}.toString.call(message) === '[object String]') {
	        var groups = message.match(ERROR_TYPES_RE);
	        if (groups) {
	          name = groups[1];
	          message = groups[2];
	        }
	      }
	
	      location.func = UNKNOWN_FUNCTION;
	
	      stack = {
	        name: name,
	        message: message,
	        url: getLocationHref(),
	        stack: [location]
	      };
	      notifyHandlers(stack, true);
	    }
	
	    if (_oldOnerrorHandler) {
	      return _oldOnerrorHandler.apply(this, arguments);
	    }
	
	    return false;
	  }
	
	  function installGlobalHandler() {
	    if (_onErrorHandlerInstalled) {
	      return;
	    }
	    _oldOnerrorHandler = _window.onerror;
	    _window.onerror = traceKitWindowOnError;
	    _onErrorHandlerInstalled = true;
	  }
	
	  function uninstallGlobalHandler() {
	    if (!_onErrorHandlerInstalled) {
	      return;
	    }
	    _window.onerror = _oldOnerrorHandler;
	    _onErrorHandlerInstalled = false;
	    _oldOnerrorHandler = undefined;
	  }
	
	  function processLastException() {
	    var _lastExceptionStack = lastExceptionStack,
	      _lastArgs = lastArgs;
	    lastArgs = null;
	    lastExceptionStack = null;
	    lastException = null;
	    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	  }
	
	  /**
	   * Reports an unhandled Error to TraceKit.
	   * @param {Error} ex
	   * @param {?boolean} rethrow If false, do not re-throw the exception.
	   * Only used for window.onerror to not cause an infinite loop of
	   * rethrowing.
	   */
	  function report(ex, rethrow) {
	    var args = _slice.call(arguments, 1);
	    if (lastExceptionStack) {
	      if (lastException === ex) {
	        return; // already caught by an inner catch block, ignore
	      } else {
	        processLastException();
	      }
	    }
	
	    var stack = TraceKit.computeStackTrace(ex);
	    lastExceptionStack = stack;
	    lastException = ex;
	    lastArgs = args;
	
	    // If the stack trace is incomplete, wait for 2 seconds for
	    // slow slow IE to see if onerror occurs or not before reporting
	    // this exception; otherwise, we will end up with an incomplete
	    // stack trace
	    setTimeout(
	      function() {
	        if (lastException === ex) {
	          processLastException();
	        }
	      },
	      stack.incomplete ? 2000 : 0
	    );
	
	    if (rethrow !== false) {
	      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	  }
	
	  report.subscribe = subscribe;
	  report.unsubscribe = unsubscribe;
	  report.uninstall = unsubscribeAll;
	  return report;
	})();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	  // Contents of Exception in various browsers.
	  //
	  // SAFARI:
	  // ex.message = Can't find variable: qq
	  // ex.line = 59
	  // ex.sourceId = 580238192
	  // ex.sourceURL = http://...
	  // ex.expressionBeginOffset = 96
	  // ex.expressionCaretOffset = 98
	  // ex.expressionEndOffset = 98
	  // ex.name = ReferenceError
	  //
	  // FIREFOX:
	  // ex.message = qq is not defined
	  // ex.fileName = http://...
	  // ex.lineNumber = 59
	  // ex.columnNumber = 69
	  // ex.stack = ...stack trace... (see the example below)
	  // ex.name = ReferenceError
	  //
	  // CHROME:
	  // ex.message = qq is not defined
	  // ex.name = ReferenceError
	  // ex.type = not_defined
	  // ex.arguments = ['aa']
	  // ex.stack = ...stack trace...
	  //
	  // INTERNET EXPLORER:
	  // ex.message = ...
	  // ex.name = ReferenceError
	  //
	  // OPERA:
	  // ex.message = ...message... (see the example below)
	  // ex.name = ReferenceError
	  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	  /**
	   * Computes stack trace information from the stack property.
	   * Chrome and Gecko use this property.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceFromStackProp(ex) {
	    if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
	    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
	    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
	    // Used to additionally parse URL/line/column from eval frames
	    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	    var lines = ex.stack.split('\n');
	    var stack = [];
	    var submatch;
	    var parts;
	    var element;
	    var reference = /^(.*) is undefined$/.exec(ex.message);
	
	    for (var i = 0, j = lines.length; i < j; ++i) {
	      if ((parts = chrome.exec(lines[i]))) {
	        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	          // throw out eval line/column and use top-most line/column number
	          parts[2] = submatch[1]; // url
	          parts[3] = submatch[2]; // line
	          parts[4] = submatch[3]; // column
	        }
	        element = {
	          url: !isNative ? parts[2] : null,
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: isNative ? [parts[2]] : [],
	          line: parts[3] ? +parts[3] : null,
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = winjs.exec(lines[i]))) {
	        element = {
	          url: parts[2],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: [],
	          line: +parts[3],
	          column: parts[4] ? +parts[4] : null
	        };
	      } else if ((parts = gecko.exec(lines[i]))) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	          // throw out eval line/column and use top-most line number
	          parts[3] = submatch[1];
	          parts[4] = submatch[2];
	          parts[5] = null; // no column when eval
	        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
	          // FireFox uses this awesome columnNumber property for its top frame
	          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	          // so adding 1
	          // NOTE: this hack doesn't work if top-most frame is eval
	          stack[0].column = ex.columnNumber + 1;
	        }
	        element = {
	          url: parts[3],
	          func: parts[1] || UNKNOWN_FUNCTION,
	          args: parts[2] ? parts[2].split(',') : [],
	          line: parts[4] ? +parts[4] : null,
	          column: parts[5] ? +parts[5] : null
	        };
	      } else {
	        continue;
	      }
	
	      if (!element.func && element.line) {
	        element.func = UNKNOWN_FUNCTION;
	      }
	
	      if (element.url && element.url.substr(0, 5) === 'blob:') {
	        // Special case for handling JavaScript loaded into a blob.
	        // We use a synchronous AJAX request here as a blob is already in
	        // memory - it's not making a network request.  This will generate a warning
	        // in the browser console, but there has already been an error so that's not
	        // that much of an issue.
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', element.url, false);
	        xhr.send(null);
	
	        // If we failed to download the source, skip this patch
	        if (xhr.status === 200) {
	          var source = xhr.responseText || '';
	
	          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
	          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
	          source = source.slice(-300);
	
	          // Now we dig out the source map URL
	          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);
	
	          // If we don't find a source map comment or we find more than one, continue on to the next element.
	          if (sourceMaps) {
	            var sourceMapAddress = sourceMaps[1];
	
	            // Now we check to see if it's a relative URL.
	            // If it is, convert it to an absolute one.
	            if (sourceMapAddress.charAt(0) === '~') {
	              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
	            }
	
	            // Now we strip the '.map' off of the end of the URL and update the
	            // element so that Sentry can match the map to the blob.
	            element.url = sourceMapAddress.slice(0, -4);
	          }
	        }
	      }
	
	      stack.push(element);
	    }
	
	    if (!stack.length) {
	      return null;
	    }
	
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	  }
	
	  /**
	   * Adds information about the first frame to incomplete stack traces.
	   * Safari and IE require this to get complete data on the first frame.
	   * @param {Object.<string, *>} stackInfo Stack trace information from
	   * one of the compute* methods.
	   * @param {string} url The URL of the script that caused an error.
	   * @param {(number|string)} lineNo The line number of the script that
	   * caused an error.
	   * @param {string=} message The error generated by the browser, which
	   * hopefully contains the name of the object that caused the error.
	   * @return {boolean} Whether or not the stack information was
	   * augmented.
	   */
	  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	    var initial = {
	      url: url,
	      line: lineNo
	    };
	
	    if (initial.url && initial.line) {
	      stackInfo.incomplete = false;
	
	      if (!initial.func) {
	        initial.func = UNKNOWN_FUNCTION;
	      }
	
	      if (stackInfo.stack.length > 0) {
	        if (stackInfo.stack[0].url === initial.url) {
	          if (stackInfo.stack[0].line === initial.line) {
	            return false; // already in stack trace
	          } else if (
	            !stackInfo.stack[0].line &&
	            stackInfo.stack[0].func === initial.func
	          ) {
	            stackInfo.stack[0].line = initial.line;
	            return false;
	          }
	        }
	      }
	
	      stackInfo.stack.unshift(initial);
	      stackInfo.partial = true;
	      return true;
	    } else {
	      stackInfo.incomplete = true;
	    }
	
	    return false;
	  }
	
	  /**
	   * Computes stack trace information by walking the arguments.caller
	   * chain at the time the exception occurred. This will cause earlier
	   * frames to be missed but is the only way to get any stack trace in
	   * Safari and IE. The top frame is restored by
	   * {@link augmentStackTraceWithInitialElement}.
	   * @param {Error} ex
	   * @return {?Object.<string, *>} Stack trace information.
	   */
	  function computeStackTraceByWalkingCallerChain(ex, depth) {
	    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	      stack = [],
	      funcs = {},
	      recursion = false,
	      parts,
	      item,
	      source;
	
	    for (
	      var curr = computeStackTraceByWalkingCallerChain.caller;
	      curr && !recursion;
	      curr = curr.caller
	    ) {
	      if (curr === computeStackTrace || curr === TraceKit.report) {
	        // console.log('skipping internal function');
	        continue;
	      }
	
	      item = {
	        url: null,
	        func: UNKNOWN_FUNCTION,
	        line: null,
	        column: null
	      };
	
	      if (curr.name) {
	        item.func = curr.name;
	      } else if ((parts = functionName.exec(curr.toString()))) {
	        item.func = parts[1];
	      }
	
	      if (typeof item.func === 'undefined') {
	        try {
	          item.func = parts.input.substring(0, parts.input.indexOf('{'));
	        } catch (e) {}
	      }
	
	      if (funcs['' + curr]) {
	        recursion = true;
	      } else {
	        funcs['' + curr] = true;
	      }
	
	      stack.push(item);
	    }
	
	    if (depth) {
	      // console.log('depth is ' + depth);
	      // console.log('stack is ' + stack.length);
	      stack.splice(0, depth);
	    }
	
	    var result = {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref(),
	      stack: stack
	    };
	    augmentStackTraceWithInitialElement(
	      result,
	      ex.sourceURL || ex.fileName,
	      ex.line || ex.lineNumber,
	      ex.message || ex.description
	    );
	    return result;
	  }
	
	  /**
	   * Computes a stack trace for an exception.
	   * @param {Error} ex
	   * @param {(string|number)=} depth
	   */
	  function computeStackTrace(ex, depth) {
	    var stack = null;
	    depth = depth == null ? 0 : +depth;
	
	    try {
	      stack = computeStackTraceFromStackProp(ex);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	
	    try {
	      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	      if (stack) {
	        return stack;
	      }
	    } catch (e) {
	      if (TraceKit.debug) {
	        throw e;
	      }
	    }
	    return {
	      name: ex.name,
	      message: ex.message,
	      url: getLocationHref()
	    };
	  }
	
	  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	  return computeStackTrace;
	})();
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2103 */
/***/ function(module, exports) {

	/*
	 * JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/*
	* Add integers, wrapping at 2^32. This uses 16-bit operations internally
	* to work around bugs in some JS interpreters.
	*/
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xffff);
	}
	
	/*
	* Bitwise rotate a 32-bit number to the left.
	*/
	function bitRotateLeft(num, cnt) {
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	/*
	* These functions implement the four basic operations the algorithm uses.
	*/
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
	}
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
	}
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	/*
	* Calculate the MD5 of an array of little-endian words, and a bit length.
	*/
	function binlMD5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << (len % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	  return [a, b, c, d];
	}
	
	/*
	* Convert an array of little-endian words to a string
	*/
	function binl2rstr(input) {
	  var i;
	  var output = '';
	  var length32 = input.length * 32;
	  for (i = 0; i < length32; i += 8) {
	    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
	  }
	  return output;
	}
	
	/*
	* Convert a raw string to an array of little-endian words
	* Characters >255 have their high-byte silently ignored.
	*/
	function rstr2binl(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	  var length8 = input.length * 8;
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
	  }
	  return output;
	}
	
	/*
	* Calculate the MD5 of a raw string
	*/
	function rstrMD5(s) {
	  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
	}
	
	/*
	* Calculate the HMAC-MD5, of a key and some data (raw strings)
	*/
	function rstrHMACMD5(key, data) {
	  var i;
	  var bkey = rstr2binl(key);
	  var ipad = [];
	  var opad = [];
	  var hash;
	  ipad[15] = opad[15] = undefined;
	  if (bkey.length > 16) {
	    bkey = binlMD5(bkey, key.length * 8);
	  }
	  for (i = 0; i < 16; i += 1) {
	    ipad[i] = bkey[i] ^ 0x36363636;
	    opad[i] = bkey[i] ^ 0x5c5c5c5c;
	  }
	  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
	}
	
	/*
	* Convert a raw string to a hex string
	*/
	function rstr2hex(input) {
	  var hexTab = '0123456789abcdef';
	  var output = '';
	  var x;
	  var i;
	  for (i = 0; i < input.length; i += 1) {
	    x = input.charCodeAt(i);
	    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
	  }
	  return output;
	}
	
	/*
	* Encode a string as utf-8
	*/
	function str2rstrUTF8(input) {
	  return unescape(encodeURIComponent(input));
	}
	
	/*
	* Take string arguments and return either raw or hex encoded strings
	*/
	function rawMD5(s) {
	  return rstrMD5(str2rstrUTF8(s));
	}
	function hexMD5(s) {
	  return rstr2hex(rawMD5(s));
	}
	function rawHMACMD5(k, d) {
	  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
	}
	function hexHMACMD5(k, d) {
	  return rstr2hex(rawHMACMD5(k, d));
	}
	
	function md5(string, key, raw) {
	  if (!key) {
	    if (!raw) {
	      return hexMD5(string);
	    }
	    return rawMD5(string);
	  }
	  if (!raw) {
	    return hexHMACMD5(key, string);
	  }
	  return rawHMACMD5(key, string);
	}
	
	module.exports = md5;


/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var timing = {
	  animationTimingFunction: (0, _utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
	};
	
	var bounceInDown = {
	  from: timing,
	  '0%': {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '-3000px', 0)
	  },
	  '60%': _extends({}, timing, {
	    opacity: 1,
	    transform: (0, _utils.translate3d)(0, '25px', 0)
	  }),
	  '75%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)(0, '-10px', 0)
	  }),
	  '90%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)(0, '5px', 0)
	  }),
	  to: _extends({}, timing, {
	    transform: 'none'
	  })
	};
	
	exports.default = bounceInDown;

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var timing = {
	  animationTimingFunction: (0, _utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
	};
	
	var bounceInLeft = {
	  from: timing,
	  '0%': {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('-3000px', 0, 0)
	  },
	  '60%': _extends({}, timing, {
	    opacity: 1,
	    transform: (0, _utils.translate3d)('25px', 0, 0)
	  }),
	  '75%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)('-10px', 0, 0)
	  }),
	  '90%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)('5px', 0, 0)
	  }),
	  to: _extends({}, timing, {
	    transform: 'none'
	  })
	};
	
	exports.default = bounceInLeft;

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var timing = {
	  animationTimingFunction: (0, _utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
	};
	
	var bounceInRight = {
	  from: timing,
	  '0%': {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('3000px', 0, 0)
	  },
	  '60%': _extends({}, timing, {
	    opacity: 1,
	    transform: (0, _utils.translate3d)('-25px', 0, 0)
	  }),
	  '75%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)('10px', 0, 0)
	  }),
	  '90%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)('-5px', 0, 0)
	  }),
	  to: _extends({}, timing, {
	    transform: 'none'
	  })
	};
	
	exports.default = bounceInRight;

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var timing = {
	  animationTimingFunction: (0, _utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
	};
	
	var bounceInUp = {
	  from: timing,
	  '0%': {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '3000px', 0)
	  },
	  '60%': _extends({}, timing, {
	    opacity: 1,
	    transform: (0, _utils.translate3d)(0, '-20px', 0)
	  }),
	  '75%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)(0, '10px', 0)
	  }),
	  '90%': _extends({}, timing, {
	    transform: (0, _utils.translate3d)(0, '-5px', 0)
	  }),
	  to: _extends({}, timing, {
	    transform: 'none'
	  })
	};
	
	exports.default = bounceInUp;

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var timing = {
	  animationTimingFunction: (0, _utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
	};
	
	var bounceIn = {
	  from: timing,
	  '0%': {
	    opacity: 0,
	    transform: (0, _utils.scale3d)(0.3, 0.3, 0.3)
	  },
	  '20%': _extends({}, timing, {
	    transform: (0, _utils.scale3d)(1.1, 1.1, 1.1)
	  }),
	  '40%': _extends({}, timing, {
	    transform: (0, _utils.scale3d)(0.9, 0.9, 0.9)
	  }),
	  '60%': _extends({}, timing, {
	    opacity: 1,
	    transform: (0, _utils.scale3d)(1.03, 1.03, 1.03)
	  }),
	  '80%': _extends({}, timing, {
	    transform: (0, _utils.scale3d)(0.97, 0.97, 0.97)
	  }),
	  to: _extends({}, timing, {
	    opacity: 1,
	    transform: (0, _utils.scale3d)(1, 1, 1)
	  })
	};
	
	exports.default = bounceIn;

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var bounceOutDown = {
	  '20%': {
	    transform: (0, _utils.translate3d)(0, '10px', 0)
	  },
	  '40%': {
	    transform: (0, _utils.translate3d)(0, '-20px', 0)
	  },
	  '45%': {
	    transform: (0, _utils.translate3d)(0, '-20px', 0)
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '2000px', 0)
	  }
	};
	exports.default = bounceOutDown;

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var bounceOutLeft = {
	  '20%': {
	    opacity: 1,
	    transform: (0, _utils.translate3d)('20px', 0, 0)
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('-2000px', 0, 0)
	  }
	};
	exports.default = bounceOutLeft;

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var bounceOutRight = {
	  '20%': {
	    opacity: 1,
	    transform: (0, _utils.translate3d)('-20px', 0, 0)
	  },
	  to: {
	    opacity: 1,
	    transform: (0, _utils.translate3d)('2000px', 0, 0)
	  }
	};
	exports.default = bounceOutRight;

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var bounceOutUp = {
	  '20%': {
	    transform: (0, _utils.translate3d)(0, '-10px', 0)
	  },
	  '40%': {
	    opacity: 1,
	    transform: (0, _utils.translate3d)(0, '20px', 0)
	  },
	  '45%': {
	    opacity: 1,
	    transform: (0, _utils.translate3d)(0, '20px', 0)
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '-2000px', 0)
	  }
	};
	exports.default = bounceOutUp;

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var bounceOut = {
	  '20%': {
	    transform: (0, _utils.scale3d)(0.9, 0.9, 0.9)
	  },
	  '50%': {
	    transform: (0, _utils.scale3d)(1.1, 1.1, 1.1)
	  },
	  '55%': {
	    transform: (0, _utils.scale3d)(1.1, 1.1, 1.1)
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.scale3d)(0.3, 0.3, 0.3)
	  }
	};
	exports.default = bounceOut;

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var base = {
	  animationTimingFunction: (0, _utils.cubicBezier)(0.2125, 0.610, 0.355, 1.000),
	  transform: (0, _utils.translate3d)(0, 0, 0)
	};
	
	
	var bounce = {
	  '0%': base,
	  '20%': base,
	  '40%': {
	    animationTimingFunction: (0, _utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
	    transform: (0, _utils.translate3d)(0, '-30px', 0)
	  },
	  '43%': {
	    animationTimingFunction: (0, _utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
	    transform: (0, _utils.translate3d)(0, '-30px', 0)
	  },
	  '53%': base,
	  '70%': {
	    animationTimingFunction: (0, _utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
	    transform: (0, _utils.translate3d)(0, '-50px', 0)
	  },
	  '80%': base,
	  '90%': {
	    transform: (0, _utils.translate3d)(0, '-4px', 0)
	  },
	  '100%': base
	};
	
	exports.default = bounce;

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInDownBig = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '-2000px', 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInDownBig;

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInDown = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '-100%', 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInDown;

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInLeftBig = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('-2000px', 0, 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInLeftBig;

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInLeft = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('-100%', 0, 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInLeft;

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInRightBig = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('2000px', 0, 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInRightBig;

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInRight = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('100%', 0, 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInRight;

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInUpBig = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '2000px', 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInUpBig;

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeInUp = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '100%', 0)
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	exports.default = fadeInUp;

/***/ },
/* 2123 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var fadeIn = {
	  from: {
	    opacity: 0
	  },
	  to: {
	    opacity: 1
	  }
	};
	exports.default = fadeIn;

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutDownBig = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '2000px', 0)
	  }
	};
	exports.default = fadeOutDownBig;

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutDown = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '100%', 0)
	  }
	};
	exports.default = fadeOutDown;

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutLeftBig = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('-2000px', 0, 0)
	  }
	};
	exports.default = fadeOutLeftBig;

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutLeft = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('-100%', 0, 0)
	  }
	};
	exports.default = fadeOutLeft;

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutRightBig = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('2000px', 0, 0)
	  }
	};
	exports.default = fadeOutRightBig;

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutRight = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)('100%', 0, 0)
	  }
	};
	exports.default = fadeOutRight;

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutUpBig = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '-2000px', 0)
	  }
	};
	exports.default = fadeOutUpBig;

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var fadeOutUp = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: (0, _utils.translate3d)(0, '-100%', 0)
	  }
	};
	exports.default = fadeOutUp;

/***/ },
/* 2132 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var fadeOut = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0
	  }
	};
	exports.default = fadeOut;

/***/ },
/* 2133 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var visible = {
	  opacity: 1
	};
	
	
	var invisible = {
	  opacity: 0
	};
	
	var flash = {
	  from: visible,
	  '25%': invisible,
	  '50%': visible,
	  '75%': invisible,
	  to: visible
	};
	
	exports.default = flash;

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var perspectiveAndRotate = (0, _utils.compose)(_utils.perspective, _utils.rotate3d);
	
	
	var flipInX = {
	  from: {
	    animationTimingFunction: 'ease-out',
	    transform: perspectiveAndRotate('400px', [1, 0, 0, 90]),
	    opacity: 0
	  },
	  '40%': {
	    animationTimingFunction: 'ease-in',
	    transform: perspectiveAndRotate('400px', [1, 0, 0, -20])
	  },
	  '60%': {
	    transform: perspectiveAndRotate('400px', [1, 0, 0, 10])
	  },
	  '80%': {
	    transform: perspectiveAndRotate('400px', [1, 0, 0, -5])
	  },
	  to: {
	    transform: (0, _utils.perspective)('400px')
	  }
	};
	
	exports.default = flipInX;

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var perspectiveAndRotate = (0, _utils.compose)(_utils.perspective, _utils.rotate3d);
	
	
	var flipInY = {
	  from: {
	    animationTimingFunction: 'ease-out',
	    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
	    opacity: 0
	  },
	  '40%': {
	    animationTimingFunction: 'ease-in',
	    transform: perspectiveAndRotate('400px', [0, 1, 0, -20])
	  },
	  '60%': {
	    transform: perspectiveAndRotate('400px', [0, 1, 0, 10])
	  },
	  '80%': {
	    transform: perspectiveAndRotate('400px', [0, 1, 0, -5])
	  },
	  to: {
	    transform: (0, _utils.perspective)('400px')
	  }
	};
	
	exports.default = flipInY;

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var perspectiveAndRotate = (0, _utils.compose)(_utils.perspective, _utils.rotate3d);
	
	
	var flipOutX = {
	  from: {
	    transform: (0, _utils.perspective)('400px')
	  },
	  '30%': {
	    transform: perspectiveAndRotate('400px', [1, 0, 0, -20]),
	    opacity: 1
	  },
	  to: {
	    transform: perspectiveAndRotate('400px', [1, 0, 0, 90]),
	    opacity: 0
	  }
	};
	
	exports.default = flipOutX;

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var perspectiveAndRotate = (0, _utils.compose)(_utils.perspective, _utils.rotate3d);
	
	
	var flipOutY = {
	  from: {
	    transform: (0, _utils.perspective)('400px')
	  },
	  '30%': {
	    transform: perspectiveAndRotate('400px', [0, 1, 0, -15]),
	    opacity: 1
	  },
	  to: {
	    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
	    opacity: 0
	  }
	};
	
	exports.default = flipOutY;

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var perspectiveAndRotate = (0, _utils.compose)(_utils.perspective, _utils.rotate3d);
	
	
	var perspectiveAndScale = (0, _utils.compose)(_utils.perspective, _utils.scale3d);
	
	var perspectiveTranslateRotate = (0, _utils.compose)(_utils.perspective, _utils.translate3d, _utils.rotate3d);
	
	var flip = {
	  from: {
	    animationTimingFunction: 'ease-out',
	    transform: perspectiveAndRotate('400px', [0, 1, 0, -360])
	  },
	  '40%': {
	    animationTimingFunction: 'ease-out',
	    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -190])
	  },
	  '50%': {
	    animationTimingFunction: 'ease-in',
	    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -170])
	  },
	  '80%': {
	    animationTimingFunction: 'ease-in',
	    transform: perspectiveAndScale('400px', [0.95, 0.95, 0.95])
	  },
	  to: {
	    animationTimingFunction: 'ease-in',
	    transform: (0, _utils.perspective)('400px')
	  }
	};
	
	exports.default = flip;

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var translateAndRotate = (0, _utils.compose)(_utils.translateX, _utils.rotateY);
	
	
	var noShake = {
	  transform: (0, _utils.translateX)(0)
	};
	
	var headShake = {
	  '0%': noShake,
	  '6.5%': {
	    transform: translateAndRotate('-6px', '-9deg')
	  },
	  '18.5%': {
	    transform: translateAndRotate('5px', '7deg')
	  },
	  '31.5%': {
	    transform: translateAndRotate('-3px', '-5deg')
	  },
	  '43.5%': {
	    transform: translateAndRotate('2px', '3deg')
	  },
	  '50%': noShake
	};
	
	exports.default = headShake;

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var hingeUp = {
	  transform: (0, _utils.rotate3d)(0, 0, 1, 80),
	  transformOrigin: 'top left',
	  animationTimingFunction: 'ease-in-out'
	};
	
	
	var hingeDown = {
	  transform: (0, _utils.rotate3d)(0, 0, 1, 60),
	  transformOrigin: 'top left',
	  animationTimingFunction: 'ease-in-out',
	  opacity: 1
	};
	
	var hinge = {
	  '0%': {
	    transformOrigin: 'top left',
	    animationTimingFunction: 'ease-in-out'
	  },
	  '20%': hingeUp,
	  '40%': hingeDown,
	  '60%': hingeUp,
	  '80%': hingeDown,
	  to: {
	    transform: (0, _utils.translate3d)(0, '700px', 0),
	    opacity: 0
	  }
	};
	
	exports.default = hinge;

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.zoomOutUp = exports.zoomOutRight = exports.zoomOutLeft = exports.zoomOutDown = exports.zoomOut = exports.zoomInUp = exports.zoomInRight = exports.zoomInLeft = exports.zoomInDown = exports.zoomIn = exports.rollOut = exports.rollIn = exports.hinge = exports.slideOutUp = exports.slideOutRight = exports.slideOutLeft = exports.slideOutDown = exports.slideInUp = exports.slideInRight = exports.slideInLeft = exports.slideInDown = exports.rotateOutUpRight = exports.rotateOutUpLeft = exports.rotateOutDownRight = exports.rotateOutDownLeft = exports.rotateOut = exports.rotateInUpRight = exports.rotateInUpLeft = exports.rotateInDownRight = exports.rotateInDownLeft = exports.rotateIn = exports.lightSpeedOut = exports.lightSpeedIn = exports.flipOutY = exports.flipOutX = exports.flipInY = exports.flipInX = exports.flip = exports.fadeOutUpBig = exports.fadeOutUp = exports.fadeOutRightBig = exports.fadeOutRight = exports.fadeOutLeftBig = exports.fadeOutLeft = exports.fadeOutDownBig = exports.fadeOutDown = exports.fadeOut = exports.fadeInUpBig = exports.fadeInUp = exports.fadeInRightBig = exports.fadeInRight = exports.fadeInLeftBig = exports.fadeInLeft = exports.fadeInDownBig = exports.fadeInDown = exports.fadeIn = exports.bounceOutUp = exports.bounceOutRight = exports.bounceOutLeft = exports.bounceOutDown = exports.bounceOut = exports.bounceInUp = exports.bounceInRight = exports.bounceInLeft = exports.bounceInDown = exports.bounceIn = exports.tada = exports.swing = exports.shake = exports.rubberBand = exports.headShake = exports.wobble = exports.jello = exports.pulse = exports.flash = exports.bounce = exports.merge = undefined;
	
	var _merge2 = __webpack_require__(2145);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _bounce2 = __webpack_require__(2114);
	
	var _bounce3 = _interopRequireDefault(_bounce2);
	
	var _flash2 = __webpack_require__(2133);
	
	var _flash3 = _interopRequireDefault(_flash2);
	
	var _pulse2 = __webpack_require__(2146);
	
	var _pulse3 = _interopRequireDefault(_pulse2);
	
	var _jello2 = __webpack_require__(2142);
	
	var _jello3 = _interopRequireDefault(_jello2);
	
	var _wobble2 = __webpack_require__(2171);
	
	var _wobble3 = _interopRequireDefault(_wobble2);
	
	var _headShake2 = __webpack_require__(2139);
	
	var _headShake3 = _interopRequireDefault(_headShake2);
	
	var _rubberBand2 = __webpack_require__(2159);
	
	var _rubberBand3 = _interopRequireDefault(_rubberBand2);
	
	var _shake2 = __webpack_require__(2160);
	
	var _shake3 = _interopRequireDefault(_shake2);
	
	var _swing2 = __webpack_require__(2169);
	
	var _swing3 = _interopRequireDefault(_swing2);
	
	var _tada2 = __webpack_require__(2170);
	
	var _tada3 = _interopRequireDefault(_tada2);
	
	var _bounceIn2 = __webpack_require__(2108);
	
	var _bounceIn3 = _interopRequireDefault(_bounceIn2);
	
	var _bounceInDown2 = __webpack_require__(2104);
	
	var _bounceInDown3 = _interopRequireDefault(_bounceInDown2);
	
	var _bounceInLeft2 = __webpack_require__(2105);
	
	var _bounceInLeft3 = _interopRequireDefault(_bounceInLeft2);
	
	var _bounceInRight2 = __webpack_require__(2106);
	
	var _bounceInRight3 = _interopRequireDefault(_bounceInRight2);
	
	var _bounceInUp2 = __webpack_require__(2107);
	
	var _bounceInUp3 = _interopRequireDefault(_bounceInUp2);
	
	var _bounceOut2 = __webpack_require__(2113);
	
	var _bounceOut3 = _interopRequireDefault(_bounceOut2);
	
	var _bounceOutDown2 = __webpack_require__(2109);
	
	var _bounceOutDown3 = _interopRequireDefault(_bounceOutDown2);
	
	var _bounceOutLeft2 = __webpack_require__(2110);
	
	var _bounceOutLeft3 = _interopRequireDefault(_bounceOutLeft2);
	
	var _bounceOutRight2 = __webpack_require__(2111);
	
	var _bounceOutRight3 = _interopRequireDefault(_bounceOutRight2);
	
	var _bounceOutUp2 = __webpack_require__(2112);
	
	var _bounceOutUp3 = _interopRequireDefault(_bounceOutUp2);
	
	var _fadeIn2 = __webpack_require__(2123);
	
	var _fadeIn3 = _interopRequireDefault(_fadeIn2);
	
	var _fadeInDown2 = __webpack_require__(2116);
	
	var _fadeInDown3 = _interopRequireDefault(_fadeInDown2);
	
	var _fadeInDownBig2 = __webpack_require__(2115);
	
	var _fadeInDownBig3 = _interopRequireDefault(_fadeInDownBig2);
	
	var _fadeInLeft2 = __webpack_require__(2118);
	
	var _fadeInLeft3 = _interopRequireDefault(_fadeInLeft2);
	
	var _fadeInLeftBig2 = __webpack_require__(2117);
	
	var _fadeInLeftBig3 = _interopRequireDefault(_fadeInLeftBig2);
	
	var _fadeInRight2 = __webpack_require__(2120);
	
	var _fadeInRight3 = _interopRequireDefault(_fadeInRight2);
	
	var _fadeInRightBig2 = __webpack_require__(2119);
	
	var _fadeInRightBig3 = _interopRequireDefault(_fadeInRightBig2);
	
	var _fadeInUp2 = __webpack_require__(2122);
	
	var _fadeInUp3 = _interopRequireDefault(_fadeInUp2);
	
	var _fadeInUpBig2 = __webpack_require__(2121);
	
	var _fadeInUpBig3 = _interopRequireDefault(_fadeInUpBig2);
	
	var _fadeOut2 = __webpack_require__(2132);
	
	var _fadeOut3 = _interopRequireDefault(_fadeOut2);
	
	var _fadeOutDown2 = __webpack_require__(2125);
	
	var _fadeOutDown3 = _interopRequireDefault(_fadeOutDown2);
	
	var _fadeOutDownBig2 = __webpack_require__(2124);
	
	var _fadeOutDownBig3 = _interopRequireDefault(_fadeOutDownBig2);
	
	var _fadeOutLeft2 = __webpack_require__(2127);
	
	var _fadeOutLeft3 = _interopRequireDefault(_fadeOutLeft2);
	
	var _fadeOutLeftBig2 = __webpack_require__(2126);
	
	var _fadeOutLeftBig3 = _interopRequireDefault(_fadeOutLeftBig2);
	
	var _fadeOutRight2 = __webpack_require__(2129);
	
	var _fadeOutRight3 = _interopRequireDefault(_fadeOutRight2);
	
	var _fadeOutRightBig2 = __webpack_require__(2128);
	
	var _fadeOutRightBig3 = _interopRequireDefault(_fadeOutRightBig2);
	
	var _fadeOutUp2 = __webpack_require__(2131);
	
	var _fadeOutUp3 = _interopRequireDefault(_fadeOutUp2);
	
	var _fadeOutUpBig2 = __webpack_require__(2130);
	
	var _fadeOutUpBig3 = _interopRequireDefault(_fadeOutUpBig2);
	
	var _flip2 = __webpack_require__(2138);
	
	var _flip3 = _interopRequireDefault(_flip2);
	
	var _flipInX2 = __webpack_require__(2134);
	
	var _flipInX3 = _interopRequireDefault(_flipInX2);
	
	var _flipInY2 = __webpack_require__(2135);
	
	var _flipInY3 = _interopRequireDefault(_flipInY2);
	
	var _flipOutX2 = __webpack_require__(2136);
	
	var _flipOutX3 = _interopRequireDefault(_flipOutX2);
	
	var _flipOutY2 = __webpack_require__(2137);
	
	var _flipOutY3 = _interopRequireDefault(_flipOutY2);
	
	var _lightSpeedIn2 = __webpack_require__(2143);
	
	var _lightSpeedIn3 = _interopRequireDefault(_lightSpeedIn2);
	
	var _lightSpeedOut2 = __webpack_require__(2144);
	
	var _lightSpeedOut3 = _interopRequireDefault(_lightSpeedOut2);
	
	var _rotateIn2 = __webpack_require__(2153);
	
	var _rotateIn3 = _interopRequireDefault(_rotateIn2);
	
	var _rotateInDownLeft2 = __webpack_require__(2149);
	
	var _rotateInDownLeft3 = _interopRequireDefault(_rotateInDownLeft2);
	
	var _rotateInDownRight2 = __webpack_require__(2150);
	
	var _rotateInDownRight3 = _interopRequireDefault(_rotateInDownRight2);
	
	var _rotateInUpLeft2 = __webpack_require__(2151);
	
	var _rotateInUpLeft3 = _interopRequireDefault(_rotateInUpLeft2);
	
	var _rotateInUpRight2 = __webpack_require__(2152);
	
	var _rotateInUpRight3 = _interopRequireDefault(_rotateInUpRight2);
	
	var _rotateOut2 = __webpack_require__(2158);
	
	var _rotateOut3 = _interopRequireDefault(_rotateOut2);
	
	var _rotateOutDownLeft2 = __webpack_require__(2154);
	
	var _rotateOutDownLeft3 = _interopRequireDefault(_rotateOutDownLeft2);
	
	var _rotateOutDownRight2 = __webpack_require__(2155);
	
	var _rotateOutDownRight3 = _interopRequireDefault(_rotateOutDownRight2);
	
	var _rotateOutUpLeft2 = __webpack_require__(2156);
	
	var _rotateOutUpLeft3 = _interopRequireDefault(_rotateOutUpLeft2);
	
	var _rotateOutUpRight2 = __webpack_require__(2157);
	
	var _rotateOutUpRight3 = _interopRequireDefault(_rotateOutUpRight2);
	
	var _slideInDown2 = __webpack_require__(2161);
	
	var _slideInDown3 = _interopRequireDefault(_slideInDown2);
	
	var _slideInLeft2 = __webpack_require__(2162);
	
	var _slideInLeft3 = _interopRequireDefault(_slideInLeft2);
	
	var _slideInRight2 = __webpack_require__(2163);
	
	var _slideInRight3 = _interopRequireDefault(_slideInRight2);
	
	var _slideInUp2 = __webpack_require__(2164);
	
	var _slideInUp3 = _interopRequireDefault(_slideInUp2);
	
	var _slideOutDown2 = __webpack_require__(2165);
	
	var _slideOutDown3 = _interopRequireDefault(_slideOutDown2);
	
	var _slideOutLeft2 = __webpack_require__(2166);
	
	var _slideOutLeft3 = _interopRequireDefault(_slideOutLeft2);
	
	var _slideOutRight2 = __webpack_require__(2167);
	
	var _slideOutRight3 = _interopRequireDefault(_slideOutRight2);
	
	var _slideOutUp2 = __webpack_require__(2168);
	
	var _slideOutUp3 = _interopRequireDefault(_slideOutUp2);
	
	var _hinge2 = __webpack_require__(2140);
	
	var _hinge3 = _interopRequireDefault(_hinge2);
	
	var _rollIn2 = __webpack_require__(2147);
	
	var _rollIn3 = _interopRequireDefault(_rollIn2);
	
	var _rollOut2 = __webpack_require__(2148);
	
	var _rollOut3 = _interopRequireDefault(_rollOut2);
	
	var _zoomIn2 = __webpack_require__(2176);
	
	var _zoomIn3 = _interopRequireDefault(_zoomIn2);
	
	var _zoomInDown2 = __webpack_require__(2172);
	
	var _zoomInDown3 = _interopRequireDefault(_zoomInDown2);
	
	var _zoomInLeft2 = __webpack_require__(2173);
	
	var _zoomInLeft3 = _interopRequireDefault(_zoomInLeft2);
	
	var _zoomInRight2 = __webpack_require__(2174);
	
	var _zoomInRight3 = _interopRequireDefault(_zoomInRight2);
	
	var _zoomInUp2 = __webpack_require__(2175);
	
	var _zoomInUp3 = _interopRequireDefault(_zoomInUp2);
	
	var _zoomOut2 = __webpack_require__(2181);
	
	var _zoomOut3 = _interopRequireDefault(_zoomOut2);
	
	var _zoomOutDown2 = __webpack_require__(2177);
	
	var _zoomOutDown3 = _interopRequireDefault(_zoomOutDown2);
	
	var _zoomOutLeft2 = __webpack_require__(2178);
	
	var _zoomOutLeft3 = _interopRequireDefault(_zoomOutLeft2);
	
	var _zoomOutRight2 = __webpack_require__(2179);
	
	var _zoomOutRight3 = _interopRequireDefault(_zoomOutRight2);
	
	var _zoomOutUp2 = __webpack_require__(2180);
	
	var _zoomOutUp3 = _interopRequireDefault(_zoomOutUp2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.merge = _merge3.default;
	
	/* Attention seekers */
	/* Fun stuff */
	
	exports.bounce = _bounce3.default;
	exports.flash = _flash3.default;
	exports.pulse = _pulse3.default;
	exports.jello = _jello3.default;
	exports.wobble = _wobble3.default;
	exports.headShake = _headShake3.default;
	exports.rubberBand = _rubberBand3.default;
	exports.shake = _shake3.default;
	exports.swing = _swing3.default;
	exports.tada = _tada3.default;
	
	/* Bouncing entrances */
	
	exports.bounceIn = _bounceIn3.default;
	exports.bounceInDown = _bounceInDown3.default;
	exports.bounceInLeft = _bounceInLeft3.default;
	exports.bounceInRight = _bounceInRight3.default;
	exports.bounceInUp = _bounceInUp3.default;
	
	/* Bouncing  exits */
	
	exports.bounceOut = _bounceOut3.default;
	exports.bounceOutDown = _bounceOutDown3.default;
	exports.bounceOutLeft = _bounceOutLeft3.default;
	exports.bounceOutRight = _bounceOutRight3.default;
	exports.bounceOutUp = _bounceOutUp3.default;
	
	/* Fading entrances */
	
	exports.fadeIn = _fadeIn3.default;
	exports.fadeInDown = _fadeInDown3.default;
	exports.fadeInDownBig = _fadeInDownBig3.default;
	exports.fadeInLeft = _fadeInLeft3.default;
	exports.fadeInLeftBig = _fadeInLeftBig3.default;
	exports.fadeInRight = _fadeInRight3.default;
	exports.fadeInRightBig = _fadeInRightBig3.default;
	exports.fadeInUp = _fadeInUp3.default;
	exports.fadeInUpBig = _fadeInUpBig3.default;
	
	/* Fading exits */
	
	exports.fadeOut = _fadeOut3.default;
	exports.fadeOutDown = _fadeOutDown3.default;
	exports.fadeOutDownBig = _fadeOutDownBig3.default;
	exports.fadeOutLeft = _fadeOutLeft3.default;
	exports.fadeOutLeftBig = _fadeOutLeftBig3.default;
	exports.fadeOutRight = _fadeOutRight3.default;
	exports.fadeOutRightBig = _fadeOutRightBig3.default;
	exports.fadeOutUp = _fadeOutUp3.default;
	exports.fadeOutUpBig = _fadeOutUpBig3.default;
	
	/* Flippers */
	
	exports.flip = _flip3.default;
	exports.flipInX = _flipInX3.default;
	exports.flipInY = _flipInY3.default;
	exports.flipOutX = _flipOutX3.default;
	exports.flipOutY = _flipOutY3.default;
	
	/* Lightspeed */
	
	exports.lightSpeedIn = _lightSpeedIn3.default;
	exports.lightSpeedOut = _lightSpeedOut3.default;
	
	/* Rotating entrances */
	
	exports.rotateIn = _rotateIn3.default;
	exports.rotateInDownLeft = _rotateInDownLeft3.default;
	exports.rotateInDownRight = _rotateInDownRight3.default;
	exports.rotateInUpLeft = _rotateInUpLeft3.default;
	exports.rotateInUpRight = _rotateInUpRight3.default;
	
	/* Rotation exits */
	
	exports.rotateOut = _rotateOut3.default;
	exports.rotateOutDownLeft = _rotateOutDownLeft3.default;
	exports.rotateOutDownRight = _rotateOutDownRight3.default;
	exports.rotateOutUpLeft = _rotateOutUpLeft3.default;
	exports.rotateOutUpRight = _rotateOutUpRight3.default;
	
	/* Sliding entrances */
	
	exports.slideInDown = _slideInDown3.default;
	exports.slideInLeft = _slideInLeft3.default;
	exports.slideInRight = _slideInRight3.default;
	exports.slideInUp = _slideInUp3.default;
	
	/* Sliding exits */
	
	exports.slideOutDown = _slideOutDown3.default;
	exports.slideOutLeft = _slideOutLeft3.default;
	exports.slideOutRight = _slideOutRight3.default;
	exports.slideOutUp = _slideOutUp3.default;
	
	/* Specials */
	
	exports.hinge = _hinge3.default;
	exports.rollIn = _rollIn3.default;
	exports.rollOut = _rollOut3.default;
	
	/* Zooming entrances */
	
	exports.zoomIn = _zoomIn3.default;
	exports.zoomInDown = _zoomInDown3.default;
	exports.zoomInLeft = _zoomInLeft3.default;
	exports.zoomInRight = _zoomInRight3.default;
	exports.zoomInUp = _zoomInUp3.default;
	
	/* Zooming exits */
	
	exports.zoomOut = _zoomOut3.default;
	exports.zoomOutDown = _zoomOutDown3.default;
	exports.zoomOutLeft = _zoomOutLeft3.default;
	exports.zoomOutRight = _zoomOutRight3.default;
	exports.zoomOutUp = _zoomOutUp3.default;

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var noSkew = {
	  transform: 'none'
	};
	
	
	var jello = {
	  from: noSkew,
	  '11.1%': noSkew,
	  '22.2%': {
	    transform: (0, _utils.skewXY)(-12.5, -12.5)
	  },
	  '33.3': {
	    transform: (0, _utils.skewXY)(6.25, 6.25)
	  },
	  '44.4': {
	    transform: (0, _utils.skewXY)(-3.125, -3.125)
	  },
	  '55.5': {
	    transform: (0, _utils.skewXY)(1.5625, 1.5625)
	  },
	  '66.6': {
	    transform: (0, _utils.skewXY)(-0.78125, -0.78125)
	  },
	  '77.7': {
	    transform: (0, _utils.skewXY)(0.390625, 0.390625)
	  },
	  '88.8': {
	    transform: (0, _utils.skewXY)(-0.1953125, -0.1953125)
	  },
	  to: noSkew
	};
	
	exports.default = jello;

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var translateAndSkew = (0, _utils.compose)(_utils.translate3d, _utils.skewX);
	
	var easeIn = {
	  animationTimingFunction: 'ease-out'
	};
	
	var lightSpeedIn = {
	  from: _extends({}, easeIn, {
	    opacity: 0,
	    transform: translateAndSkew(['100%', 0, 0], -30)
	  }),
	  '60%': _extends({}, easeIn, {
	    opacity: 1,
	    transform: (0, _utils.skewX)(20)
	  }),
	  '80%': _extends({}, easeIn, {
	    opacity: 1,
	    transform: (0, _utils.skewX)(-5)
	  }),
	  to: _extends({}, easeIn, {
	    transform: 'none',
	    opacity: 1
	  })
	};
	
	exports.default = lightSpeedIn;

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(17);
	
	var translateAndSkew = (0, _utils.compose)(_utils.translate3d, _utils.skewX);
	
	var easeIn = {
	  animationTimingFunction: 'ease-out'
	};
	
	var lightSpeedOut = {
	  from: _extends({}, easeIn, {
	    opacity: 1
	  }),
	  to: _extends({}, easeIn, {
	    transform: translateAndSkew(['100%', 0, 0], 30),
	    opacity: 0
	  })
	};
	
	exports.default = lightSpeedOut;

/***/ },
/* 2145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	
	
	// The default allowed delta for keyframe distance
	var keyframeDistance = 10;
	
	var defaultNormalizedFrames = {
	  'from': 'from',
	  '0%': 'from',
	  'to': 'to',
	  '100%': 'to'
	};
	
	/**
	 * Takes an array of strings representing transform values and
	 * merges them. Ignores duplicates and 'none'.
	 * @param {Array} transforms Array<string>
	 * @returns {String} merged
	 * @private
	 * @example
	 * mergeTransforms([
	 *   'translateX(10px)',
	 *   'rotateX(120deg)',
	 *   'translateX(10px)',
	 *   'none',
	 * ])
	 * // -> 'translateX(10px) rotateX(120deg)'
	 *
	 */
	var mergeTransforms = function mergeTransforms(transforms) {
	  var filtered = transforms.filter(function (transform, i) {
	    return transform !== 'none' && transforms.indexOf(transform) === i;
	  });
	  return filtered.join(' ');
	};
	
	/**
	 * Returns whichever value is actually defined
	 * @param {String|Number} primary CSSValue
	 * @param {String|Number} secondary CSSValue
	 * @returns {String|Number} defined CSSValue
	 * @private
	 */
	var getDefined = function getDefined(primary, secondary) {
	  return typeof primary !== 'undefined' ? primary : secondary;
	};
	
	/**
	 * Takes a source animation and the current cache, populating the
	 * cache with the normalized keyframes and returning a copy of the
	 * source animation with the normalized keyframes as well.
	 *
	 * It uses keyframeDistance to determine how much it should normalize
	 * frames.
	 * @param {Object} source Animation
	 * @param {Object} cache FrameMap
	 * @returns {Object} Animation
	 * @private
	 */
	var normalizeFrames = function normalizeFrames(source, cache) {
	  var normalized = {};
	  for (var frame in source) {
	    var normalizedFrame = defaultNormalizedFrames[frame] || Math.round(parseFloat(frame) / keyframeDistance) * keyframeDistance + '%';
	    normalized[normalizedFrame] = source[frame];
	    cache[normalizedFrame] = normalizedFrame;
	  }
	  return normalized;
	};
	
	var mergeFrames = function mergeFrames(primaryFrame, secondaryFrame, target) {
	  // Walk through all properties in the primary frame
	  for (var propertyName in primaryFrame) {
	    // Transform is special cased, as we want to combine both
	    // transforms when posssible.
	    if (propertyName === 'transform') {
	      // But we dont need to do anything if theres no other
	      // transform to merge.
	      if (secondaryFrame[propertyName]) {
	        var newTransform = mergeTransforms([primaryFrame[propertyName], secondaryFrame[propertyName]]);
	        // We make the assumption that animations use 'transform: none'
	        // to terminate the keyframe. If we're combining two animations
	        // that may terminate at separte frames, its safest to just
	        // ignore this.
	        if (newTransform !== 'none') {
	          target[propertyName] = newTransform;
	        }
	      } else {
	        var propertyValue = getDefined(primaryFrame[propertyName], secondaryFrame[propertyName]);
	        target[propertyName] = propertyValue;
	      }
	    } else {
	      // Use a typeof check so we don't ignore falsy values like 0.
	      var _propertyValue = getDefined(primaryFrame[propertyName], secondaryFrame[propertyName]);
	      target[propertyName] = _propertyValue;
	    }
	  }
	  // Walk through all properties in the secondary frame.
	  // We should be able to assume that any property that
	  // needed to be merged has already been merged when we
	  // walked the primary frame.
	  for (var _propertyName in secondaryFrame) {
	    var _propertyValue2 = secondaryFrame[_propertyName];
	    // Again, ignore 'transform: none'
	    if (_propertyName === 'transform' && _propertyValue2 === 'none') {
	      continue;
	    }
	    target[_propertyName] = target[_propertyName] || _propertyValue2;
	  }
	};
	
	var populateDefinedFrame = function populateDefinedFrame(primaryFrame, secondaryFrame) {
	  var definedFrame = primaryFrame || secondaryFrame;
	  var target = {};
	  for (var propertyName in definedFrame) {
	    var propertyValue = definedFrame[propertyName];
	    // Again, ignore 'transform: none'
	    if (propertyName === 'transform' && propertyValue === 'none') {
	      continue;
	    }
	    target[propertyName] = propertyValue;
	  }
	  // Only define a frame if there are actual styles to apply
	  if (Object.keys(target).length) {
	    return target;
	  }
	  return null;
	};
	
	/**
	 * Merge lets you take two Animations and merge them together. It
	 * iterates through each animation and merges each keyframe. It
	 * special cases the `transform` property and uses string interop.
	 * to merge the two transforms.
	 *
	 * This is *at your own risk* and will not work with animations
	 * that are clearly opposites (fadeIn and fadeOut).
	 *
	 * @param {Object} primary Animation
	 * @param {Object} secondary Animation
	 * @returns {Object} merged Animation
	 * @example
	 * import { merge, tada, flip } from 'react-animations';
	 * const tadaFlip = merge(tada, flip);
	 */
	function merge(primary, secondary) {
	  // A map used to track the normalized frame value in cases where
	  // two animations contain frames that appear closely, but not exactly
	  var normalizedFrames = {};
	
	  // We merge each frame into a new object and return it
	  var merged = {};
	
	  var normalizedPrimary = normalizeFrames(primary, normalizedFrames);
	
	  var normalizedSecondary = normalizeFrames(secondary, normalizedFrames);
	
	  // Iterate all normalized frames
	  for (var frame in normalizedFrames) {
	    var primaryFrame = normalizedPrimary[frame];
	    var secondaryFrame = normalizedSecondary[frame];
	    // Create a new frame object if it doesn't exist.
	    var target = merged[frame] || (merged[frame] = {});
	
	    // If both aniatmions define this frame, merge them carefully
	    if (primaryFrame && secondaryFrame) {
	      mergeFrames(primaryFrame, secondaryFrame, target);
	    } else {
	      // Otherwise find the defined frime and populate all properties\
	      // except for "transform" when the value is none.
	      var keyframe = populateDefinedFrame(primaryFrame, secondaryFrame);
	      if (keyframe) {
	        merged[frame] = keyframe;
	      }
	    }
	  }
	  return merged;
	}

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var pulse = {
	  from: {
	    transform: (0, _utils.scale3d)(1, 1, 1)
	  },
	  '50%': {
	    transform: (0, _utils.scale3d)(1.05, 1.05, 1.05)
	  },
	  to: {
	    transform: (0, _utils.scale3d)(1, 1, 1)
	  }
	};
	exports.default = pulse;

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var translateAndRotate = (0, _utils.compose)(_utils.translate3d, _utils.rotate3d);
	
	
	var rollIn = {
	  from: {
	    opacity: 0,
	    transform: translateAndRotate(['-100%', 0, 0], [0, 0, 1, -120])
	  },
	  to: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	
	exports.default = rollIn;

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var translateAndRotate = (0, _utils.compose)(_utils.translate3d, _utils.rotate3d);
	
	
	var rollOut = {
	  from: {
	    opacity: 1
	  },
	  to: {
	    opacity: 0,
	    transform: translateAndRotate(['100%', 0, 0], [0, 0, 1, 120])
	  }
	};
	
	exports.default = rollOut;

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateInDownLeft = {
	  from: {
	    transformOrigin: 'left bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, -45),
	    opacity: 0
	  },
	  to: {
	    transformOrigin: 'left bottom',
	    transform: 'none',
	    opacity: 1
	  }
	};
	exports.default = rotateInDownLeft;

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateInDownRight = {
	  from: {
	    transformOrigin: 'right bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, 45),
	    opacity: 0
	  },
	  to: {
	    transformOrigin: 'right bottom',
	    transform: 'none',
	    opacity: 1
	  }
	};
	exports.default = rotateInDownRight;

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateInUpLeft = {
	  from: {
	    transformOrigin: 'left bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, 45),
	    opacity: 0
	  },
	  to: {
	    transformOrigin: 'left bottom',
	    transform: 'none',
	    opacity: 1
	  }
	};
	exports.default = rotateInUpLeft;

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateInUpRight = {
	  from: {
	    transformOrigin: 'right bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, -90),
	    opacity: 0
	  },
	  to: {
	    transformOrigin: 'right bottom',
	    transform: 'none',
	    opacity: 1
	  }
	};
	exports.default = rotateInUpRight;

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateIn = {
	  from: {
	    transformOrigin: 'center',
	    transform: (0, _utils.rotate3d)(0, 0, 1, -200),
	    opacity: 0
	  },
	  to: {
	    transformOrigin: 'center',
	    transform: 'none',
	    opacity: 1
	  }
	};
	exports.default = rotateIn;

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateOutDownLeft = {
	  from: {
	    transformOrigin: 'left bottom',
	    opacity: 1
	  },
	  to: {
	    transformOrigin: 'left bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, 45),
	    opacity: 0
	  }
	};
	exports.default = rotateOutDownLeft;

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateOutDownRight = {
	  from: {
	    transformOrigin: 'right bottom',
	    opacity: 1
	  },
	  to: {
	    transformOrigin: 'right bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, -45),
	    opacity: 0
	  }
	};
	exports.default = rotateOutDownRight;

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateOutUpLeft = {
	  from: {
	    transformOrigin: 'left bottom',
	    opacity: 1
	  },
	  to: {
	    transformOrigin: 'left bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, -45),
	    opacity: 0
	  }
	};
	exports.default = rotateOutUpLeft;

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateOutUpRight = {
	  from: {
	    transformOrigin: 'right bottom',
	    opacity: 1
	  },
	  to: {
	    transformOrigin: 'right bottom',
	    transform: (0, _utils.rotate3d)(0, 0, 1, 90),
	    opacity: 0
	  }
	};
	exports.default = rotateOutUpRight;

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var rotateOut = {
	  from: {
	    transformOrigin: 'center',
	    opacity: 1
	  },
	  to: {
	    transformOrigin: 'center',
	    transform: (0, _utils.rotate3d)(0, 0, 1, 200),
	    opacity: 0
	  }
	};
	exports.default = rotateOut;

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var noRubberBanding = {
	  transform: (0, _utils.scale3d)(1, 1, 1)
	};
	
	
	var rubberBand = {
	  from: noRubberBanding,
	  '30%': {
	    transform: (0, _utils.scale3d)(1.25, 0.75, 1)
	  },
	  '40%': {
	    transform: (0, _utils.scale3d)(0.75, 1.25, 1)
	  },
	  '50%': {
	    transform: (0, _utils.scale3d)(1.15, 0.85, 1)
	  },
	  '65%': {
	    transform: (0, _utils.scale3d)(0.95, 1.05, 1)
	  },
	  '75%': {
	    transform: (0, _utils.scale3d)(1.05, 0.95, 1)
	  },
	  to: noRubberBanding
	};
	
	exports.default = rubberBand;

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var noShake = {
	  transform: (0, _utils.translate3d)(0, 0, 0)
	};
	
	
	var downShake = {
	  transform: (0, _utils.translate3d)('-10px', 0, 0)
	};
	
	var upShake = {
	  transform: (0, _utils.translate3d)('10px', 0, 0)
	};
	
	var shake = {
	  from: noShake,
	  '10%': downShake,
	  '20%': upShake,
	  '30%': downShake,
	  '40%': upShake,
	  '50%': downShake,
	  '60%': upShake,
	  '70%': downShake,
	  '80%': upShake,
	  '90%': downShake,
	  to: noShake
	};
	
	exports.default = shake;

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideInDown = {
	  from: {
	    transform: (0, _utils.translate3d)(0, '-100%', 0),
	    visibility: 'visible'
	  },
	  to: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  }
	};
	exports.default = slideInDown;

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideInLeft = {
	  from: {
	    transform: (0, _utils.translate3d)('-100%', 0, 0),
	    visibility: 'visible'
	  },
	  to: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  }
	};
	exports.default = slideInLeft;

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideInRight = {
	  from: {
	    transform: (0, _utils.translate3d)('100%', 0, 0),
	    visibility: 'visible'
	  },
	  to: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  }
	};
	exports.default = slideInRight;

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideInUp = {
	  from: {
	    transform: (0, _utils.translate3d)(0, '100%', 0),
	    visibility: 'visible'
	  },
	  to: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  }
	};
	exports.default = slideInUp;

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideOutDown = {
	  from: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  },
	  to: {
	    visibility: 'hidden',
	    transform: (0, _utils.translate3d)(0, '100%', 0)
	  }
	};
	exports.default = slideOutDown;

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideOutLeft = {
	  from: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  },
	  to: {
	    visibility: 'hidden',
	    transform: (0, _utils.translate3d)('-100%', 0, 0)
	  }
	};
	exports.default = slideOutLeft;

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideOutRight = {
	  from: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  },
	  to: {
	    visibility: 'hidden',
	    transform: (0, _utils.translate3d)('100%', 0, 0)
	  }
	};
	exports.default = slideOutRight;

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var slideOutUp = {
	  from: {
	    transform: (0, _utils.translate3d)(0, 0, 0)
	  },
	  to: {
	    visibility: 'hidden',
	    transform: (0, _utils.translate3d)(0, '-100%', 0)
	  }
	};
	exports.default = slideOutUp;

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _utils = __webpack_require__(17);
	
	var swing = {
	  '20%': {
	    transform: (0, _utils.rotate3d)(0, 0, 1, 15)
	  },
	  '40%': {
	    transform: (0, _utils.rotate3d)(0, 0, 1, -10)
	  },
	  '60%': {
	    transform: (0, _utils.rotate3d)(0, 0, 1, 5)
	  },
	  '80%': {
	    transform: (0, _utils.rotate3d)(0, 0, 1, -5)
	  },
	  to: {
	    transform: (0, _utils.rotate3d)(0, 0, 1, 15)
	  }
	};
	var styles = exports.styles = {
	  transformOrigin: 'top center'
	};
	
	exports.default = swing;

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndRotate = (0, _utils.compose)(_utils.scale3d, _utils.rotate3d);
	
	
	var noScale = {
	  transform: (0, _utils.scale3d)(1, 1, 1)
	};
	
	var scaleDownNegativeAngle = {
	  transform: scaleAndRotate([0.9, 0.9, 0.9], [0, 0, 1, -3])
	};
	
	var scaleUpPositiveAngle = {
	  transform: scaleAndRotate([1.1, 1.1, 1.1], [0, 0, 1, 3])
	};
	
	var scaleUpNegativeAngle = {
	  transform: scaleAndRotate([1.1, 1.1, 1.1], [0, 0, 1, -3])
	};
	
	var tada = {
	  from: noScale,
	  '10%': scaleDownNegativeAngle,
	  '20%': scaleDownNegativeAngle,
	  '30%': scaleUpPositiveAngle,
	  '40%': scaleUpNegativeAngle,
	  '50%': scaleUpPositiveAngle,
	  '60%': scaleUpNegativeAngle,
	  '70%': scaleUpPositiveAngle,
	  '80%': scaleUpNegativeAngle,
	  '90%': scaleUpPositiveAngle,
	  to: noScale
	};
	
	exports.default = tada;

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var translateAndRotate = (0, _utils.compose)(_utils.translate3d, _utils.rotate3d);
	
	
	var noWobble = {
	  transform: 'none'
	};
	
	var wobble = {
	  from: noWobble,
	  '15%': {
	    transform: translateAndRotate(['-25%', 0, 0], [0, 0, 1, -5])
	  },
	  '30%': {
	    transform: translateAndRotate(['20%', 0, 0], [0, 0, 1, -5])
	  },
	  '45%': {
	    transform: translateAndRotate(['-15%', 0, 0], [0, 0, 1, -3])
	  },
	  '60%': {
	    transform: translateAndRotate(['10%', 0, 0], [0, 0, 1, 2])
	  },
	  '75%': {
	    transform: translateAndRotate(['-5%', 0, 0], [0, 0, 1, -1])
	  },
	  to: noWobble
	};
	
	exports.default = wobble;

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	
	var zoomInDown = {
	  from: {
	    opacity: 0,
	    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-1000px', 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
	  },
	  '60%': {
	    opacity: 1,
	    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
	  }
	};
	
	exports.default = zoomInDown;

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	
	var zoomInLeft = {
	  from: {
	    opacity: 0,
	    transform: scaleAndTranslate([0.1, 0.1, 0.1], ['-1000px', 0, 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
	  },
	  '60%': {
	    opacity: 1,
	    transform: scaleAndTranslate([0.475, 0.475, 0.475], ['10px', 0, 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
	  }
	};
	
	exports.default = zoomInLeft;

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	
	var zoomInRight = {
	  from: {
	    opacity: 0,
	    transform: scaleAndTranslate([0.1, 0.1, 0.1], ['1000px', 0, 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
	  },
	  '60%': {
	    opacity: 1,
	    transform: scaleAndTranslate([0.475, 0.475, 0.475], ['-10px', 0, 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
	  }
	};
	
	exports.default = zoomInRight;

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	
	var zoomInUp = {
	  from: {
	    opacity: 0,
	    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '1000px', 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
	  },
	  '60%': {
	    opacity: 1,
	    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '-60px', 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
	  }
	};
	
	exports.default = zoomInUp;

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var zoomIn = {
	  from: {
	    opacity: 0,
	    transform: (0, _utils.scale3d)(0.3, 0.3, 0.3)
	  },
	  '50%': {
	    opacity: 1
	  }
	};
	exports.default = zoomIn;

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	
	var zoomOutDown = {
	  '40%': {
	    opacity: 1,
	    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '-60px', 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
	  },
	  to: {
	    opacity: 0,
	    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '2000px', 0]),
	    transformOrigin: 'center bottom',
	    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
	  }
	};
	
	exports.default = zoomOutDown;

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scale3dAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale, _utils.translate3d);
	
	var zoomOutLeft = {
	  '40%': {
	    opacity: 1,
	    transform: scale3dAndTranslate([0.475, 0.475, 0.475], ['42px', 0, 0])
	  },
	  to: {
	    opacity: 0,
	    transform: scaleAndTranslate(0.1, ['-2000px', 0, 0]),
	    transformOrigin: 'left center'
	  }
	};
	
	exports.default = zoomOutLeft;

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scale3dAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale, _utils.translate3d);
	
	var zoomOutRight = {
	  '40%': {
	    opacity: 1,
	    transform: scale3dAndTranslate([0.475, 0.475, 0.475], ['-42px', 0, 0])
	  },
	  to: {
	    opacity: 0,
	    transform: scaleAndTranslate(0.1, ['2000px', 0, 0]),
	    transformOrigin: 'right center'
	  }
	};
	
	exports.default = zoomOutRight;

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var scaleAndTranslate = (0, _utils.compose)(_utils.scale3d, _utils.translate3d);
	
	
	var zoomOutUp = {
	  '40%': {
	    opacity: 1,
	    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
	    animationTimingFunction: (0, _utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
	  },
	  to: {
	    opacity: 0,
	    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-2000px', 0]),
	    transformOrigin: 'center bottom',
	    animationTimingFunction: (0, _utils.cubicBezier)(0.175, 0.885, 0.320, 1)
	  }
	};
	
	exports.default = zoomOutUp;

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var zoomOut = {
	  from: {
	    opacity: 1
	  },
	  '50%': {
	    opacity: 0,
	    transform: (0, _utils.scale3d)(0.3, 0.3, 0.3)
	  },
	  to: {
	    opacity: 0
	  }
	};
	exports.default = zoomOut;

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	__webpack_require__(926);
	
	__webpack_require__(927);
	
	__webpack_require__(929);
	
	__webpack_require__(2233);
	
	__webpack_require__(362);
	
	__webpack_require__(930);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAvatarComponent;
	Object.defineProperty(exports, "Cache", {
	  enumerable: true,
	  get: function get() {
	    return _cache.Cache;
	  }
	});
	Object.defineProperty(exports, "ConfigProvider", {
	  enumerable: true,
	  get: function get() {
	    return _context.ConfigProvider;
	  }
	});
	Object.defineProperty(exports, "getRandomColor", {
	  enumerable: true,
	  get: function get() {
	    return _utils.getRandomColor;
	  }
	});
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _cache = __webpack_require__(895);
	
	var _context = __webpack_require__(2183);
	
	var _utils = __webpack_require__(169);
	
	var _internalState = _interopRequireDefault(__webpack_require__(2184));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function matchSource(Source, props, cb) {
	  var cache = props.cache;
	  var instance = new Source(props);
	  if (!instance.isCompatible(props)) return cb();
	  instance.get(function (state) {
	    var failedBefore = state && state.src && cache.hasSourceFailedBefore(state.src);
	
	    if (!failedBefore && state) {
	      cb(state);
	    } else {
	      cb();
	    }
	  });
	}
	
	function createAvatarComponent(_ref) {
	  var _ref$sources = _ref.sources,
	      sources = _ref$sources === void 0 ? [] : _ref$sources;
	  // Collect propTypes for each individual source
	  var sourcePropTypes = sources.reduce(function (r, s) {
	    return Object.assign(r, s.propTypes);
	  }, {});
	
	  var Avatar = /*#__PURE__*/function (_PureComponent) {
	    _inherits(Avatar, _PureComponent);
	
	    var _super = _createSuper(Avatar);
	
	    function Avatar(props) {
	      var _this;
	
	      _classCallCheck(this, Avatar);
	
	      _this = _super.call(this, props);
	
	      _defineProperty(_assertThisInitialized(_this), "_createFetcher", function (internal) {
	        return function (errEvent) {
	          var cache = _this.props.cache;
	          if (!internal.isActive(_this.state)) return; // Mark img source as failed for future reference
	
	          if (errEvent && errEvent.type === 'error') cache.sourceFailed(errEvent.target.src);
	          var pointer = internal.sourcePointer;
	          if (sources.length === pointer) return;
	          var source = sources[pointer];
	          internal.sourcePointer++;
	          matchSource(source, _this.props, function (nextState) {
	            if (!nextState) return setTimeout(internal.fetch, 0);
	            if (!internal.isActive(_this.state)) return; // Reset other values to prevent them from sticking (#51)
	
	            nextState = _objectSpread({
	              src: null,
	              value: null,
	              color: null
	            }, nextState);
	
	            _this.setState(function (state) {
	              // Internal state has been reset => we received new props
	              return internal.isActive(state) ? nextState : {};
	            });
	          });
	        };
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "fetch", function () {
	        var internal = new _internalState.default();
	        internal.fetch = _this._createFetcher(internal);
	
	        _this.setState({
	          internal: internal
	        }, internal.fetch);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "_scaleTextNode", function (node) {
	        var retryTTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
	        var _this$props = _this.props,
	            unstyled = _this$props.unstyled,
	            textSizeRatio = _this$props.textSizeRatio,
	            textMarginRatio = _this$props.textMarginRatio;
	        if (!node || unstyled || _this.state.src || !_this.mounted) return;
	        var spanNode = node.parentNode;
	        var tableNode = spanNode.parentNode;
	
	        var _spanNode$getBounding = spanNode.getBoundingClientRect(),
	            containerWidth = _spanNode$getBounding.width,
	            containerHeight = _spanNode$getBounding.height; // Whenever the avatar element is not visible due to some CSS
	        // (such as display: none) on any parent component we will check
	        // whether the component has become visible.
	        //
	        // The time between checks grows up to half a second in an attempt
	        // to reduce flicker / performance issues.
	
	
	        if (containerWidth == 0 && containerHeight == 0) {
	          var ttl = Math.min(retryTTL * 1.5, 500);
	          (0, _utils.setGroupedTimeout)(function () {
	            return _this._scaleTextNode(node, ttl);
	          }, ttl);
	          return;
	        } // If the tableNode (outer-container) does not have its fontSize set yet,
	        // we'll set it according to "textSizeRatio"
	
	
	        if (!tableNode.style.fontSize) {
	          var baseFontSize = containerHeight / textSizeRatio;
	          tableNode.style.fontSize = "".concat(baseFontSize, "px");
	        } // Reset font-size such that scaling works correctly (#133)
	
	
	        spanNode.style.fontSize = null; // Measure the actual width of the text after setting the container size
	
	        var _node$getBoundingClie = node.getBoundingClientRect(),
	            textWidth = _node$getBoundingClie.width;
	
	        if (textWidth < 0) return; // Calculate the maximum width for the text based on "textMarginRatio"
	
	        var maxTextWidth = containerWidth * (1 - 2 * textMarginRatio); // If the text is too wide, scale it down by (maxWidth / actualWidth)
	
	        if (textWidth > maxTextWidth) spanNode.style.fontSize = "calc(1em * ".concat(maxTextWidth / textWidth, ")");
	      });
	
	      _this.state = {
	        internal: null,
	        src: null,
	        value: null,
	        color: props.color
	      };
	      return _this;
	    }
	
	    _createClass(Avatar, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.mounted = true;
	        this.fetch();
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        var needsUpdate = false; // This seems redundant
	        //
	        // Props that need to be in `state` are
	        // `value`, `src` and `color`
	
	        for (var prop in sourcePropTypes) {
	          needsUpdate = needsUpdate || prevProps[prop] !== this.props[prop];
	        }
	
	        if (needsUpdate) setTimeout(this.fetch, 0);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.mounted = false;
	
	        if (this.state.internal) {
	          this.state.internal.active = false;
	        }
	      }
	    }, {
	      key: "_renderAsImage",
	      value: function _renderAsImage() {
	        var _this$props2 = this.props,
	            className = _this$props2.className,
	            round = _this$props2.round,
	            unstyled = _this$props2.unstyled,
	            alt = _this$props2.alt,
	            title = _this$props2.title,
	            name = _this$props2.name,
	            value = _this$props2.value;
	        var internal = this.state.internal;
	        var size = (0, _utils.parseSize)(this.props.size);
	        var imageStyle = unstyled ? null : {
	          maxWidth: '100%',
	          width: size.str,
	          height: size.str,
	          borderRadius: round === true ? '100%' : round
	        };
	        return /*#__PURE__*/_react.default.createElement("img", {
	          className: className + ' sb-avatar__image',
	          width: size.str,
	          height: size.str,
	          style: imageStyle,
	          src: this.state.src,
	          alt: alt || name || value,
	          title: title || name || value,
	          onError: internal && internal.fetch
	        });
	      }
	    }, {
	      key: "_renderAsText",
	      value: function _renderAsText() {
	        var _this$props3 = this.props,
	            className = _this$props3.className,
	            round = _this$props3.round,
	            unstyled = _this$props3.unstyled,
	            title = _this$props3.title,
	            name = _this$props3.name,
	            value = _this$props3.value;
	        var size = (0, _utils.parseSize)(this.props.size);
	        var initialsStyle = unstyled ? null : {
	          width: size.str,
	          height: size.str,
	          lineHeight: 'initial',
	          textAlign: 'center',
	          color: this.props.fgColor,
	          background: this.state.color,
	          borderRadius: round === true ? '100%' : round
	        };
	        var tableStyle = unstyled ? null : {
	          display: 'table',
	          tableLayout: 'fixed',
	          width: '100%',
	          height: '100%'
	        };
	        var spanStyle = unstyled ? null : {
	          display: 'table-cell',
	          verticalAlign: 'middle',
	          fontSize: '100%',
	          whiteSpace: 'nowrap'
	        }; // Ensure the text node is updated and scaled when any of these
	        // values changed by calling the `_scaleTextNode` method using
	        // the correct `ref`.
	
	        var key = [this.state.value, this.props.size].join('');
	        return /*#__PURE__*/_react.default.createElement("div", {
	          className: className + ' sb-avatar__text',
	          style: initialsStyle,
	          title: title || name || value
	        }, /*#__PURE__*/_react.default.createElement("div", {
	          style: tableStyle
	        }, /*#__PURE__*/_react.default.createElement("span", {
	          style: spanStyle
	        }, /*#__PURE__*/_react.default.createElement("span", {
	          ref: this._scaleTextNode,
	          key: key
	        }, this.state.value))));
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$props4 = this.props,
	            className = _this$props4.className,
	            unstyled = _this$props4.unstyled,
	            round = _this$props4.round,
	            style = _this$props4.style,
	            onClick = _this$props4.onClick;
	        var _this$state = this.state,
	            src = _this$state.src,
	            sourceName = _this$state.sourceName;
	        var size = (0, _utils.parseSize)(this.props.size);
	        var hostStyle = unstyled ? null : _objectSpread({
	          display: 'inline-block',
	          verticalAlign: 'middle',
	          width: size.str,
	          height: size.str,
	          borderRadius: round === true ? '100%' : round,
	          fontFamily: 'Helvetica, Arial, sans-serif'
	        }, style);
	        var classNames = [className, 'sb-avatar'];
	
	        if (sourceName) {
	          var source = sourceName.toLowerCase().replace(/[^a-z0-9-]+/g, '-') // only allow alphanumeric
	          .replace(/^-+|-+$/g, ''); // trim `-`
	
	          classNames.push('sb-avatar--' + source);
	        }
	
	        return /*#__PURE__*/_react.default.createElement("div", {
	          className: classNames.join(' '),
	          onClick: onClick,
	          style: hostStyle
	        }, src ? this._renderAsImage() : this._renderAsText());
	      }
	    }]);
	
	    return Avatar;
	  }(_react.PureComponent);
	
	  _defineProperty(Avatar, "displayName", 'Avatar');
	
	  _defineProperty(Avatar, "propTypes", _objectSpread(_objectSpread({}, sourcePropTypes), {}, {
	    alt: _propTypes.default.string,
	    title: _propTypes.default.string,
	    className: _propTypes.default.string,
	    fgColor: _propTypes.default.string,
	    color: _propTypes.default.string,
	    colors: _propTypes.default.arrayOf(_propTypes.default.string),
	    round: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	    style: _propTypes.default.object,
	    size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    textSizeRatio: _propTypes.default.number,
	    textMarginRatio: _propTypes.default.number,
	    unstyled: _propTypes.default.bool,
	    cache: _propTypes.default.object,
	    onClick: _propTypes.default.func
	  }));
	
	  _defineProperty(Avatar, "defaultProps", {
	    className: '',
	    fgColor: '#FFF',
	    round: false,
	    size: 100,
	    textSizeRatio: 3,
	    textMarginRatio: .15,
	    unstyled: false
	  });
	
	  _defineProperty(Avatar, "getRandomColor", _utils.getRandomColor);
	
	  _defineProperty(Avatar, "Cache", _cache.Cache);
	
	  _defineProperty(Avatar, "ConfigProvider", _context.ConfigProvider);
	
	  return Object.assign((0, _context.withConfig)(Avatar), {
	    getRandomColor: _utils.getRandomColor,
	    ConfigProvider: _context.ConfigProvider,
	    Cache: _cache.Cache
	  });
	}

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	__webpack_require__(925);
	
	__webpack_require__(2234);
	
	__webpack_require__(931);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withConfig = exports.ConfigProvider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _cache = _interopRequireDefault(__webpack_require__(895));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaults = {
	  cache: _cache.default,
	  colors: _utils.defaultColors,
	  initials: _utils.defaultInitials,
	  avatarRedirectUrl: null
	};
	var contextKeys = Object.keys(defaults);
	/**
	 * withConfig and ConfigProvider provide a compatibility layer for different
	 * versions of React equiped with different versions of the Context API.
	 *
	 * If the new Context API is available it will be used, otherwise we will
	 * fall back to the legacy context api.
	 */
	
	var ConfigContext = _react.default.createContext && /*#__PURE__*/_react.default.createContext();
	
	var isLegacyContext = !ConfigContext;
	var ConfigConsumer = isLegacyContext ? null : ConfigContext.Consumer;
	/**
	 * This was introduced in React 16.3.0 we need this to
	 * prevent errors in newer versions. But we will just forward the
	 * component for any version lower than 16.3.0
	 *
	 * https://github.com/Sitebase/react-avatar/issues/201
	 * https://github.com/facebook/react/blob/master/CHANGELOG.md#1630-march-29-2018
	 */
	
	var forwardRef = _react.default.forwardRef || function (C) {
	  return C;
	};
	
	var ConfigProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(ConfigProvider, _React$Component);
	
	  var _super = _createSuper(ConfigProvider);
	
	  function ConfigProvider() {
	    _classCallCheck(this, ConfigProvider);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ConfigProvider, [{
	    key: "_getContext",
	    value: function _getContext() {
	      var _this = this;
	
	      var context = {};
	      contextKeys.forEach(function (key) {
	        if (typeof _this.props[key] !== 'undefined') context[key] = _this.props[key];
	      });
	      return context;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      if (isLegacyContext) return _react.default.Children.only(children);
	      return /*#__PURE__*/_react.default.createElement(ConfigContext.Provider, {
	        value: this._getContext()
	      }, _react.default.Children.only(children));
	    }
	  }]);
	
	  return ConfigProvider;
	}(_react.default.Component);
	
	exports.ConfigProvider = ConfigProvider;
	
	_defineProperty(ConfigProvider, "displayName", 'ConfigProvider');
	
	_defineProperty(ConfigProvider, "propTypes", {
	  cache: _propTypes.default.object,
	  colors: _propTypes.default.arrayOf(_propTypes.default.string),
	  initials: _propTypes.default.func,
	  avatarRedirectUrl: _propTypes.default.string,
	  children: _propTypes.default.node
	});
	
	var withConfig = function withConfig(Component) {
	  function withAvatarConfig(props, refOrContext) {
	    // If legacy context is enabled, there is no support for forwardedRefs either
	    if (isLegacyContext) {
	      var ctx = refOrContext && refOrContext.reactAvatar;
	      return /*#__PURE__*/_react.default.createElement(Component, _extends({}, defaults, ctx, props));
	    }
	    /* eslint-disable react/display-name */
	
	
	    return /*#__PURE__*/_react.default.createElement(ConfigConsumer, null, function (config) {
	      return /*#__PURE__*/_react.default.createElement(Component, _extends({
	        ref: refOrContext
	      }, defaults, config, props));
	    });
	    /* eslint-enable react/display-name */
	  } // Legacy support, only set when legacy is detected
	
	
	  withAvatarConfig.contextTypes = ConfigProvider.childContextTypes;
	  return forwardRef(withAvatarConfig);
	};
	
	exports.withConfig = withConfig;
	
	if (isLegacyContext) {
	  ConfigProvider.childContextTypes = {
	    reactAvatar: _propTypes.default.object
	  };
	
	  ConfigProvider.prototype.getChildContext = function () {
	    return {
	      reactAvatar: this._getContext()
	    };
	  };
	}

/***/ },
/* 2184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var InternalState = /*#__PURE__*/function () {
	  function InternalState() {
	    _classCallCheck(this, InternalState);
	
	    this.sourcePointer = 0;
	    this.active = true;
	    this.fetch = null;
	  }
	
	  _createClass(InternalState, [{
	    key: "isActive",
	    value: function isActive() {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // Internal state has been reset => we received new props
	      if (state.internal !== this) return false;
	      if (!this.fetch) return false;
	      if (this.active !== true) return false;
	      return true;
	    }
	  }]);
	
	  return InternalState;
	}();
	
	exports.default = InternalState;

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(923);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FacebookSource = function FacebookSource(props) {
	  var _this = this;
	
	  _classCallCheck(this, FacebookSource);
	
	  _defineProperty(this, "props", null);
	
	  _defineProperty(this, "isCompatible", function () {
	    return !!_this.props.facebookId;
	  });
	
	  _defineProperty(this, "get", function (setState) {
	    var facebookId = _this.props.facebookId;
	    var size = (0, _utils.getImageSize)(_this.props.size);
	    var url = "https://graph.facebook.com/".concat(facebookId, "/picture");
	    if (size) url += "?width=".concat(size, "&height=").concat(size);
	    setState({
	      sourceName: 'facebook',
	      src: url
	    });
	  });
	
	  this.props = props;
	};
	
	exports.default = FacebookSource;
	
	_defineProperty(FacebookSource, "propTypes", {
	  facebookId: _propTypes.default.string
	});

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GithubSource = function GithubSource(props) {
	  var _this = this;
	
	  _classCallCheck(this, GithubSource);
	
	  _defineProperty(this, "props", null);
	
	  _defineProperty(this, "isCompatible", function () {
	    return !!_this.props.githubHandle;
	  });
	
	  _defineProperty(this, "get", function (setState) {
	    var githubHandle = _this.props.githubHandle;
	    var size = (0, _utils.getImageSize)(_this.props.size);
	    var url = "https://avatars.githubusercontent.com/".concat(githubHandle, "?v=4");
	    if (size) url += "&s=".concat(size);
	    setState({
	      sourceName: 'github',
	      src: url
	    });
	  });
	
	  this.props = props;
	};
	
	exports.default = GithubSource;
	
	_defineProperty(GithubSource, "propTypes", {
	  githubHandle: _propTypes.default.string
	});

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _AvatarRedirect = _interopRequireDefault(__webpack_require__(282));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _AvatarRedirect.default)('google', 'googleId');
	
	exports.default = _default;

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _md = _interopRequireDefault(__webpack_require__(2062));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GravatarSource = function GravatarSource(_props) {
	  var _this = this;
	
	  _classCallCheck(this, GravatarSource);
	
	  _defineProperty(this, "props", null);
	
	  _defineProperty(this, "isCompatible", function () {
	    return !!_this.props.email || !!_this.props.md5Email;
	  });
	
	  _defineProperty(this, "get", function (setState) {
	    var props = _this.props;
	    var email = props.md5Email || (0, _md.default)(props.email);
	    var size = (0, _utils.getImageSize)(props.size);
	    var url = "https://secure.gravatar.com/avatar/".concat(email, "?d=404");
	    if (size) url += "&s=".concat(size);
	    setState({
	      sourceName: 'gravatar',
	      src: url
	    });
	  });
	
	  this.props = _props;
	};
	
	exports.default = GravatarSource;
	
	_defineProperty(GravatarSource, "propTypes", {
	  email: _propTypes.default.string,
	  md5Email: _propTypes.default.string
	});

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IconSource = function IconSource(props) {
	  var _this = this;
	
	  _classCallCheck(this, IconSource);
	
	  _defineProperty(this, "props", null);
	
	  _defineProperty(this, "icon", '✷');
	
	  _defineProperty(this, "isCompatible", function () {
	    return true;
	  });
	
	  _defineProperty(this, "get", function (setState) {
	    var _this$props = _this.props,
	        color = _this$props.color,
	        colors = _this$props.colors;
	    setState({
	      sourceName: 'icon',
	      value: _this.icon,
	      color: color || (0, _utils.getRandomColor)(_this.icon, colors)
	    });
	  });
	
	  this.props = props;
	};
	
	exports.default = IconSource;
	
	_defineProperty(IconSource, "propTypes", {
	  color: _propTypes.default.string
	});

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _AvatarRedirect = _interopRequireDefault(__webpack_require__(282));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _AvatarRedirect.default)('instagram', 'instagramId');
	
	exports.default = _default;

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SkypeSource = function SkypeSource(props) {
	  var _this = this;
	
	  _classCallCheck(this, SkypeSource);
	
	  _defineProperty(this, "props", null);
	
	  _defineProperty(this, "isCompatible", function () {
	    return !!_this.props.skypeId;
	  });
	
	  _defineProperty(this, "get", function (setState) {
	    var skypeId = _this.props.skypeId;
	    var url = "https://api.skype.com/users/".concat(skypeId, "/profile/avatar");
	    setState({
	      sourceName: 'skype',
	      src: url
	    });
	  });
	
	  this.props = props;
	};
	
	exports.default = SkypeSource;
	
	_defineProperty(SkypeSource, "propTypes", {
	  skypeId: _propTypes.default.string
	});

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SrcSource = function SrcSource(props) {
	  var _this = this;
	
	  _classCallCheck(this, SrcSource);
	
	  _defineProperty(this, "props", null);
	
	  _defineProperty(this, "isCompatible", function () {
	    return !!_this.props.src;
	  });
	
	  _defineProperty(this, "get", function (setState) {
	    setState({
	      sourceName: 'src',
	      src: _this.props.src
	    });
	  });
	
	  this.props = props;
	};
	
	exports.default = SrcSource;
	
	_defineProperty(SrcSource, "propTypes", {
	  src: _propTypes.default.string
	});

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _AvatarRedirect = _interopRequireDefault(__webpack_require__(282));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _AvatarRedirect.default)('twitter', 'twitterHandle');
	
	exports.default = _default;

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _AvatarRedirect = _interopRequireDefault(__webpack_require__(282));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _AvatarRedirect.default)('vkontakte', 'vkontakteId');
	
	exports.default = _default;

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(929);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ValueSource = /*#__PURE__*/function () {
	  function ValueSource(props) {
	    var _this = this;
	
	    _classCallCheck(this, ValueSource);
	
	    _defineProperty(this, "props", null);
	
	    _defineProperty(this, "isCompatible", function () {
	      return !!(_this.props.name || _this.props.value || _this.props.email);
	    });
	
	    _defineProperty(this, "get", function (setState) {
	      var value = _this.getValue();
	
	      if (!value) return setState(null);
	      setState({
	        sourceName: 'text',
	        value: value,
	        color: _this.getColor()
	      });
	    });
	
	    this.props = props;
	  }
	
	  _createClass(ValueSource, [{
	    key: "getInitials",
	    value: function getInitials() {
	      var _this$props = this.props,
	          name = _this$props.name,
	          initials = _this$props.initials;
	      if (typeof initials === 'string') return initials;
	      if (typeof initials === 'function') return initials(name, this.props);
	      return (0, _utils.defaultInitials)(name, this.props);
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      if (this.props.name) return this.getInitials();
	      if (this.props.value) return this.props.value;
	      return null;
	    }
	  }, {
	    key: "getColor",
	    value: function getColor() {
	      var _this$props2 = this.props,
	          color = _this$props2.color,
	          colors = _this$props2.colors,
	          name = _this$props2.name,
	          email = _this$props2.email,
	          value = _this$props2.value;
	      var colorValue = name || email || value;
	      return color || (0, _utils.getRandomColor)(colorValue, colors);
	    }
	  }]);
	
	  return ValueSource;
	}();
	
	exports.default = ValueSource;
	
	_defineProperty(ValueSource, "propTypes", {
	  color: _propTypes.default.string,
	  name: _propTypes.default.string,
	  value: _propTypes.default.string,
	  email: _propTypes.default.string,
	  maxInitials: _propTypes.default.number,
	  initials: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	});

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	var isConstructor = __webpack_require__(504);
	var tryToString = __webpack_require__(919);
	
	var $TypeError = TypeError;
	
	// `Assert: IsConstructor(argument) is true`
	module.exports = function (argument) {
	  if (isConstructor(argument)) return argument;
	  throw $TypeError(tryToString(argument) + ' is not a constructor');
	};


/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	var aCallable = __webpack_require__(494);
	var toObject = __webpack_require__(203);
	var IndexedObject = __webpack_require__(284);
	var lengthOfArrayLike = __webpack_require__(237);
	
	var $TypeError = TypeError;
	
	// `Array.prototype.{ reduce, reduceRight }` methods implementation
	var createMethod = function (IS_RIGHT) {
	  return function (that, callbackfn, argumentsLength, memo) {
	    aCallable(callbackfn);
	    var O = toObject(that);
	    var self = IndexedObject(O);
	    var length = lengthOfArrayLike(O);
	    var index = IS_RIGHT ? length - 1 : 0;
	    var i = IS_RIGHT ? -1 : 1;
	    if (argumentsLength < 2) while (true) {
	      if (index in self) {
	        memo = self[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if (IS_RIGHT ? index < 0 : length <= index) {
	        throw $TypeError('Reduce of empty array with no initial value');
	      }
	    }
	    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }
	    return memo;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.reduce` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduce
	  left: createMethod(false),
	  // `Array.prototype.reduceRight` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
	  right: createMethod(true)
	};


/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	var toAbsoluteIndex = __webpack_require__(508);
	var lengthOfArrayLike = __webpack_require__(237);
	var createProperty = __webpack_require__(496);
	
	var $Array = Array;
	var max = Math.max;
	
	module.exports = function (O, start, end) {
	  var length = lengthOfArrayLike(O);
	  var k = toAbsoluteIndex(start, length);
	  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	  var result = $Array(max(fin - k, 0));
	  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
	  result.length = n;
	  return result;
	};


/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(58);
	
	module.exports = uncurryThis([].slice);


/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(503);
	var isConstructor = __webpack_require__(504);
	var isObject = __webpack_require__(145);
	var wellKnownSymbol = __webpack_require__(124);
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	
	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array : C;
	};


/***/ },
/* 2201 */
[2747, 202, 2221, 911, 238],
/* 2202 */
/***/ function(module, exports) {

	var $TypeError = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
	
	module.exports = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
	  return it;
	};


/***/ },
/* 2203 */
/***/ function(module, exports) {

	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	module.exports = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};


/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
	var documentCreateElement = __webpack_require__(498);
	
	var classList = documentCreateElement('span').classList;
	var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
	
	module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var classof = __webpack_require__(201);
	
	module.exports = typeof process != 'undefined' && classof(process) == 'process';
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 2206 */
/***/ function(module, exports) {

	module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(500);
	var aCallable = __webpack_require__(494);
	var NATIVE_BIND = __webpack_require__(357);
	
	var bind = uncurryThis(uncurryThis.bind);
	
	// optional / simple context binding
	module.exports = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(58);
	var toObject = __webpack_require__(203);
	
	var floor = Math.floor;
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
	
	// `GetSubstitution` abstract operation
	// https://tc39.es/ecma262/#sec-getsubstitution
	module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }
	  return replace(replacement, symbols, function (match, ch) {
	    var capture;
	    switch (charAt(ch, 0)) {
	      case '$': return '$';
	      case '&': return matched;
	      case '`': return stringSlice(str, 0, position);
	      case "'": return stringSlice(str, tailPos);
	      case '<':
	        capture = namedCaptures[stringSlice(ch, 1, -1)];
	        break;
	      default: // \d\d?
	        var n = +ch;
	        if (n === 0) return match;
	        if (n > m) {
	          var f = floor(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
	          return match;
	        }
	        capture = captures[n - 1];
	    }
	    return capture === undefined ? '' : capture;
	  });
	};


/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	var getBuiltIn = __webpack_require__(358);
	
	module.exports = getBuiltIn('document', 'documentElement');


/***/ },
/* 2210 */
[2767, 65, 90],
/* 2211 */
162,
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(145);
	var classof = __webpack_require__(201);
	var wellKnownSymbol = __webpack_require__(124);
	
	var MATCH = wellKnownSymbol('match');
	
	// `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
	};


/***/ },
/* 2213 */
[2771, 58, 65, 90, 202, 134, 906, 908, 909],
/* 2214 */
1034,
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(134);
	var uncurryThis = __webpack_require__(58);
	var call = __webpack_require__(170);
	var fails = __webpack_require__(65);
	var objectKeys = __webpack_require__(505);
	var getOwnPropertySymbolsModule = __webpack_require__(912);
	var propertyIsEnumerableModule = __webpack_require__(914);
	var toObject = __webpack_require__(203);
	var IndexedObject = __webpack_require__(284);
	
	// eslint-disable-next-line es/no-object-assign -- safe
	var $assign = Object.assign;
	// eslint-disable-next-line es/no-object-defineproperty -- required for testing
	var defineProperty = Object.defineProperty;
	var concat = uncurryThis([].concat);
	
	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	module.exports = !$assign || fails(function () {
	  // should have correct order of operations (Edge bug)
	  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), { b: 2 })).b !== 1) return true;
	  // should work with symbols and should have deterministic property order (V8 bug)
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line es/no-symbol -- safe
	  var symbol = Symbol();
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
	  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  var propertyIsEnumerable = propertyIsEnumerableModule.f;
	  while (argumentsLength > index) {
	    var S = IndexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	/* global ActiveXObject -- old IE, WSH */
	var anObject = __webpack_require__(144);
	var definePropertiesModule = __webpack_require__(2217);
	var enumBugKeys = __webpack_require__(499);
	var hiddenKeys = __webpack_require__(502);
	var html = __webpack_require__(2209);
	var documentCreateElement = __webpack_require__(498);
	var sharedKey = __webpack_require__(917);
	
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	
	var EmptyConstructor = function () { /* empty */ };
	
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};
	
	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};
	
	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	
	hiddenKeys[IE_PROTO] = true;
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};


/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(134);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(922);
	var definePropertyModule = __webpack_require__(238);
	var anObject = __webpack_require__(144);
	var toIndexedObject = __webpack_require__(239);
	var objectKeys = __webpack_require__(505);
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};


/***/ },
/* 2218 */
[2774, 913, 499],
/* 2219 */
[2775, 58],
/* 2220 */
[2777, 170, 90, 145],
/* 2221 */
[2778, 358, 58, 2218, 912, 144],
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(144);
	
	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.hasIndices) result += 'd';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.unicodeSets) result += 'v';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(65);
	var global = __webpack_require__(102);
	
	// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
	var $RegExp = global.RegExp;
	
	module.exports = fails(function () {
	  var re = $RegExp('.', 's');
	  return !(re.dotAll && re.exec('\n') && re.flags === 's');
	});


/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(65);
	var global = __webpack_require__(102);
	
	// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
	var $RegExp = global.RegExp;
	
	module.exports = fails(function () {
	  var re = $RegExp('(?<a>b)', 'g');
	  return re.exec('b').groups.a !== 'b' ||
	    'b'.replace(re, '$<a>c') !== 'bc';
	});


/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(144);
	var aConstructor = __webpack_require__(2196);
	var isNullOrUndefined = __webpack_require__(285);
	var wellKnownSymbol = __webpack_require__(124);
	
	var SPECIES = wellKnownSymbol('species');
	
	// `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor
	module.exports = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
	};


/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	var uncurryThis = __webpack_require__(58);
	var toIntegerOrInfinity = __webpack_require__(360);
	var toString = __webpack_require__(361);
	var requireObjectCoercible = __webpack_require__(286);
	
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var stringSlice = uncurryThis(''.slice);
	
	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};
	
	module.exports = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};


/***/ },
/* 2227 */
[2789, 170, 145, 910, 501, 2220, 124],
/* 2228 */
[2791, 124],
/* 2229 */
[2796, 102, 90],
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-array-prototype-indexof -- required for testing */
	var $ = __webpack_require__(110);
	var uncurryThis = __webpack_require__(500);
	var $indexOf = __webpack_require__(899).indexOf;
	var arrayMethodIsStrict = __webpack_require__(283);
	
	var nativeIndexOf = uncurryThis([].indexOf);
	
	var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
	var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');
	
	// `Array.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.indexof
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? nativeIndexOf(this, searchElement, fromIndex) || 0
	      : $indexOf(this, searchElement, fromIndex);
	  }
	});


/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var $map = __webpack_require__(353).map;
	var arrayMethodHasSpeciesSupport = __webpack_require__(354);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
	
	// `Array.prototype.map` method
	// https://tc39.es/ecma262/#sec-array.prototype.map
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(110);
	var $some = __webpack_require__(353).some;
	var arrayMethodIsStrict = __webpack_require__(283);
	
	var STRICT_METHOD = arrayMethodIsStrict('some');
	
	// `Array.prototype.some` method
	// https://tc39.es/ecma262/#sec-array.prototype.some
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(110);
	var assign = __webpack_require__(2215);
	
	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es/no-object-assign -- required for testing
	$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
	  assign: assign
	});


/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(110);
	var toObject = __webpack_require__(203);
	var nativeKeys = __webpack_require__(505);
	var fails = __webpack_require__(65);
	
	var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
	  keys: function keys(it) {
	    return nativeKeys(toObject(it));
	  }
	});


/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var apply = __webpack_require__(905);
	var call = __webpack_require__(170);
	var uncurryThis = __webpack_require__(58);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(904);
	var anObject = __webpack_require__(144);
	var isNullOrUndefined = __webpack_require__(285);
	var isRegExp = __webpack_require__(2212);
	var requireObjectCoercible = __webpack_require__(286);
	var speciesConstructor = __webpack_require__(2225);
	var advanceStringIndex = __webpack_require__(897);
	var toLength = __webpack_require__(509);
	var toString = __webpack_require__(361);
	var getMethod = __webpack_require__(501);
	var arraySlice = __webpack_require__(2198);
	var callRegExpExec = __webpack_require__(915);
	var regexpExec = __webpack_require__(359);
	var stickyHelpers = __webpack_require__(916);
	var fails = __webpack_require__(65);
	
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	var MAX_UINT32 = 0xFFFFFFFF;
	var min = Math.min;
	var $push = [].push;
	var exec = uncurryThis(/./.exec);
	var push = uncurryThis($push);
	var stringSlice = uncurryThis(''.slice);
	
	// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});
	
	// @@split logic
	fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'.split(/(b)*/)[1] == 'c' ||
	    // eslint-disable-next-line regexp/no-empty-group -- required for testing
	    'test'.split(/(?:)/, -1).length != 4 ||
	    'ab'.split(/(?:ab)*/).length != 2 ||
	    '.'.split(/(.?)(.?)/).length != 4 ||
	    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
	    '.'.split(/()()/).length > 1 ||
	    ''.split(/.?/).length
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = toString(requireObjectCoercible(this));
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (separator === undefined) return [string];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) {
	        return call(nativeSplit, string, separator, lim);
	      }
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = call(regexpExec, separatorCopy, string)) {
	        lastIndex = separatorCopy.lastIndex;
	        if (lastIndex > lastLastIndex) {
	          push(output, stringSlice(string, lastLastIndex, match.index));
	          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
	          lastLength = match[0].length;
	          lastLastIndex = lastIndex;
	          if (output.length >= lim) break;
	        }
	        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string.length) {
	        if (lastLength || !exec(separatorCopy, '')) push(output, '');
	      } else push(output, stringSlice(string, lastLastIndex));
	      return output.length > lim ? arraySlice(output, 0, lim) : output;
	    };
	  // Chakra, V8
	  } else if ('0'.split(undefined, 0).length) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
	    };
	  } else internalSplit = nativeSplit;
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.es/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = requireObjectCoercible(this);
	      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
	      return splitter
	        ? call(splitter, separator, O, limit)
	        : call(internalSplit, toString(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (string, limit) {
	      var rx = anObject(this);
	      var S = toString(string);
	      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
	
	      if (res.done) return res.value;
	
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (UNSUPPORTED_Y ? 'g' : 'y');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
	        var e;
	        if (
	          z === null ||
	          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          push(A, stringSlice(S, p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            push(A, z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      push(A, stringSlice(S, p));
	      return A;
	    }
	  ];
	}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(948);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3.default)(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3.default)(this, Accordion);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2.default.createElement(
	      _PanelGroup2.default,
	      (0, _extends3.default)({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2.default.Component);
	
	exports.default = Accordion;
	module.exports = exports['default'];

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(218);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	var _CloseButton = __webpack_require__(512);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2.default.func,
	  closeLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3.default)(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3.default)(this, Alert);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      dismissable && _react2.default.createElement(_CloseButton2.default, {
	        onClick: onDismiss,
	        label: closeLabel
	      }),
	      children
	    );
	  };
	
	  return Alert;
	}(_react2.default.Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3.default)(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2.default.Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(932);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3.default)(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ol', (0, _extends3.default)({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2.default.Component);
	
	Breadcrumb.Item = _BreadcrumbItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3.default)(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	module.exports = exports['default'];

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(2242);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(933);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(514);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2.default.bool,
	  indicators: _propTypes2.default.bool,
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes2.default.number,
	  controls: _propTypes2.default.bool,
	  pauseOnHover: _propTypes2.default.bool,
	  wrap: _propTypes2.default.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2.default.func,
	  onSlideEnd: _propTypes2.default.func,
	  activeIndex: _propTypes2.default.number,
	  defaultActiveIndex: _propTypes2.default.number,
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2.default.string,
	  nextIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3.default)(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'prev',
	        className: (0, _classnames2.default)(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'next',
	        className: (0, _classnames2.default)(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2.default.forEach(children, function (child, index) {
	      indicators.push(_react2.default.createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2.default.createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2.default.map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2.default;
	Carousel.Item = _CarouselItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3.default)(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3.default)(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3.default)(this, Checkbox);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _capitalize = __webpack_require__(951);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3.default)(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3.default)(this, Clearfix);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2.default)(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2.default.Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2.default.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2.default.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2.default.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3.default)(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3.default)(this, Col);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2.default.string,
	  srOnly: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3.default)(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3.default)(this, ControlLabel);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2.default.createElement('label', (0, _extends3.default)({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2.default.Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(363);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(366);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3.default)(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3.default)(this, DropdownButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2.default.Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports.default = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(1551);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(465);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(985);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  open: _propTypes2.default.bool,
	  pullRight: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  labelledBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onSelect: _propTypes2.default.func,
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3.default)(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2.default.findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2.default)(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2.default.createElement(
	      _RootCloseWrapper2.default,
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2.default.createElement(
	        'ul',
	        (0, _extends4.default)({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2.default)(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2.default.Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3.default)(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3.default)(this, Form);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(2251);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(2252);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3.default)(this, FormControl);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2.default;
	FormControl.Static = _FormControlStatic2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(514);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3.default)(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2.default.createElement(_Glyphicon2.default, (0, _extends3.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3.default)(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2.default.string,
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2.default.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3.default)(this, FormGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3.default)(this, HelpBlock);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3.default)(this, Image);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2.default.createElement('img', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(2257);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(2258);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3.default)(this, InputGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2.default.Component);
	
	InputGroup.Addon = _InputGroupAddon2.default;
	InputGroup.Button = _InputGroupButton2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3.default)(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3.default)(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3.default)(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3.default)(this, Jumbotron);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2.default.Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(218);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3.default)(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3.default)(this, Label);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(936);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2.default
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2.default.some(children, function (child) {
	    return child.type !== _ListGroupItem2.default || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3.default)(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3.default)(this, ListGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2.default.every(children, function (child) {
	      return child.type === _ListGroupItem2.default;
	    });
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2.default.Component);
	
	ListGroup.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Media = __webpack_require__(365);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom']),
	
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3.default)(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3.default)(this, MediaBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2.default.Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3.default)(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3.default)(this, MediaHeading);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2.default.Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(365);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3.default)(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3.default)(this, MediaLeft);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2.default.Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3.default)(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3.default)(this, MediaList);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ul', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3.default)(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3.default)(this, MediaListItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(365);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3.default)(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3.default)(this, MediaRight);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2.default.Component);
	
	MediaRight.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(349);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3.default)(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2.default)(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2.default.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4.default)({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2.default)(className, bsClassName)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(dialogClassName, dialogClasses) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(363);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(366);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3.default)(this, NavDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2.default.some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2.default)(className, { active: active }),
	        style: style
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2.default.Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports.default = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(300);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(935);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(944);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(2272);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(2273);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(2274);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2.default.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2.default.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2.default.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2.default.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2.default.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2.default,
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
	   * boolean value.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2.default.func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2.default.bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2.default.bool,
	
	  role: _propTypes2.default.string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired,
	    onSelect: _propTypes2.default.func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3.default)(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3.default)(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3.default)(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        _Grid2.default,
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2.default.Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2.default)(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, props, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2.default,
	    pullRight: _propTypes2.default.bool,
	    pullLeft: _propTypes2.default.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2.default.shape({
	      bsClass: _propTypes2.default.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2.default;
	UncontrollableNavbar.Header = _NavbarHeader2.default;
	UncontrollableNavbar.Toggle = _NavbarToggle2.default;
	UncontrollableNavbar.Collapse = _NavbarCollapse2.default;
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports.default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(513);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3.default)(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3.default)(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': navbarProps.expanded }, props),
	      _react2.default.createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2.default.Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports.default = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3.default)(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3.default)(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2.default.Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports.default = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onClick: _propTypes2.default.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2.default.node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3.default)(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3.default)(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3.default)({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2.default)(onClick, navbarProps.onToggle),
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2.default.createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2.default.createElement(
	      'button',
	      buttonProps,
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2.default.Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports.default = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(228);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(945);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2.default.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Specify which action or actions trigger Overlay visibility
	   */
	  trigger: _propTypes2.default.oneOfType([triggerType, _propTypes2.default.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2.default.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2.default.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2.default.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  onHide: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2.default.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3.default)(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3.default)(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2.default.unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this3 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this3._hoverShowDelay = null;
	      _this3.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if ((!related || related !== target) && !(0, _contains2.default)(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3.default)(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2.default.Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2.default)(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2.default)(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2.default.Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports.default = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3.default)(this, PageHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(946);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(2297);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _deprecationWarning2.default.wrapper(_PagerItem2.default, '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(946);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2.default.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3.default)(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3.default)(this, Pager);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2.default.Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(947);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  activePage: _propTypes2.default.number,
	  items: _propTypes2.default.number,
	  maxButtons: _propTypes2.default.number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2.default.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2.default
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3.default)(this, Pagination);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          (0, _extends3.default)({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      first && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2.default.Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(218);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(513);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  header: _propTypes2.default.node,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  footer: _propTypes2.default.node,
	  defaultExpanded: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  eventKey: _propTypes2.default.any,
	  headerRole: _propTypes2.default.string,
	  panelRole: _propTypes2.default.string,
	
	  // From Collapse.
	  onEnter: _propTypes2.default.func,
	  onEntering: _propTypes2.default.func,
	  onEntered: _propTypes2.default.func,
	  onExit: _propTypes2.default.func,
	  onExiting: _propTypes2.default.func,
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3.default)(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3.default)(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2.default.createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2.default.createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2.default.Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2.default.isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': expanded }, animationHooks),
	      _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2.default.isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2.default.isValidElement(header)) {
	      return _react2.default.createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2.default)(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(351);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2.default.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3.default)(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2.default.createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2.default.Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(218);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2.default.number,
	  now: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  srOnly: _propTypes2.default.bool,
	  striped: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3.default)(this, ProgressBar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2.default)(className, classes),
	        style: (0, _extends4.default)({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3.default)(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3.default)(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, wrapperProps, {
	        className: (0, _classnames2.default)(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3.default)(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3.default)(this, Radio);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2.default.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2.default.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3.default)(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3.default)(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2.default.Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3.default)(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3.default)(this, Row);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(171);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(363);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(2287);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(366);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2.default.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2.default.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3.default)(this, SplitButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(_SplitToggle2.default, {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2.default.Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2.default;
	
	exports.default = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(934);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3.default)(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3.default)(this, SplitToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2.default.createElement(_DropdownToggle2.default, (0, _extends3.default)({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2.default.Component);
	
	SplitToggle.defaultProps = _DropdownToggle2.default.defaultProps;
	
	exports.default = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(515);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(516);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(949);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _TabPane2.default.propTypes, {
	
	  disabled: _propTypes2.default.bool,
	
	  title: _propTypes2.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2.default.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3.default)(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3.default)(this, Tab);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3.default)({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2.default.createElement(_TabPane2.default, props);
	  };
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2.default;
	Tab.Content = _TabContent2.default;
	Tab.Pane = _TabPane2.default;
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2.default.createElement('table', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(351);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(300);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(942);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(943);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(515);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(516);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabContainer = _TabContainer2.default.ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2.default.oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2.default.bool,
	
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3.default)(this, Tabs);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _NavItem2.default,
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3.default)(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2.default.createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Nav2.default,
	          (0, _extends3.default)({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2.default.map(children, this.renderTab)
	        ),
	        _react2.default.createElement(
	          _TabContent2.default,
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports.default = (0, _uncontrollable2.default)(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(135);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * src property that is passed down to the image inside this component
	   */
	  src: _propTypes2.default.string,
	  /**
	   * alt property that is passed down to the image inside this component
	   */
	  alt: _propTypes2.default.string,
	  /**
	   * href property that is passed down to the image inside this component
	   */
	  href: _propTypes2.default.string,
	  /**
	   * onError callback that is passed down to the image inside this component
	   */
	  onError: _propTypes2.default.func,
	  /**
	   * onLoad callback that is passed down to the image inside this component
	   */
	  onLoad: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/alt-text */
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3.default)(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3.default)(this, Thumbnail);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        onError = _props.onError,
	        onLoad = _props.onLoad,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2.default : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
	      children && _react2.default.createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2.default.Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _uncontrollable = __webpack_require__(300);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _createChainedFunction = __webpack_require__(70);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	var _ButtonGroup = __webpack_require__(511);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ToggleButton = __webpack_require__(950);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An HTML `<input>` name for each child button.
	   *
	   * __Required if `type` is set to `'radio'`__
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The value, or array of values, of the active (pressed) buttons
	   *
	   * @controllable onChange
	   */
	  value: _propTypes2.default.any,
	
	  /**
	   * Callback fired when a button is pressed, depending on whether the `type`
	   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
	   * array of active values
	   *
	   * @controllable values
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The input `type` of the rendered buttons, determines the toggle behavior
	   * of the buttons
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired
	};
	
	var defaultProps = {
	  type: 'radio'
	};
	
	var ToggleButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButtonGroup, _React$Component);
	
	  function ToggleButtonGroup() {
	    (0, _classCallCheck3.default)(this, ToggleButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButtonGroup.prototype.getValues = function getValues() {
	    var value = this.props.value;
	
	    return value == null ? [] : [].concat(value);
	  };
	
	  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
	    var _props = this.props,
	        type = _props.type,
	        onChange = _props.onChange;
	
	    var values = this.getValues();
	    var isActive = values.indexOf(value) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive) {
	        onChange(value);
	      }
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== value;
	      }));
	    } else {
	      onChange([].concat(values, [value]));
	    }
	  };
	
	  ToggleButtonGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        children = _props2.children,
	        type = _props2.type,
	        name = _props2.name,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children', 'type', 'name']);
	
	
	    var values = this.getValues();
	
	    !(type !== 'radio' || !!name) ?  false ? (0, _invariant2.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : (0, _invariant2.default)(false) : void 0;
	
	    delete props.onChange;
	    delete props.value;
	
	    // the data attribute is required b/c twbs css uses it in the selector
	    return _react2.default.createElement(
	      _ButtonGroup2.default,
	      (0, _extends3.default)({}, props, { 'data-toggle': 'buttons' }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var _child$props = child.props,
	            value = _child$props.value,
	            onChange = _child$props.onChange;
	
	        var handler = function handler() {
	          return _this2.handleToggle(value);
	        };
	
	        return _react2.default.cloneElement(child, {
	          type: type,
	          name: child.name || name,
	          checked: values.indexOf(value) !== -1,
	          onChange: (0, _createChainedFunction2.default)(onChange, handler)
	        });
	      })
	    );
	  };
	
	  return ToggleButtonGroup;
	}(_react2.default.Component);
	
	ToggleButtonGroup.propTypes = propTypes;
	ToggleButtonGroup.defaultProps = defaultProps;
	
	var UncontrolledToggleButtonGroup = (0, _uncontrollable2.default)(ToggleButtonGroup, {
	  value: 'onChange'
	});
	
	UncontrolledToggleButtonGroup.Button = _ToggleButton2.default;
	
	exports.default = UncontrolledToggleButtonGroup;
	module.exports = exports['default'];

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(15);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(351);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3.default)(this, Tooltip);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(15);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(16);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(19);
	
	var _StyleConfig = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3.default)(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3.default)(this, Well);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(352);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(91);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2.default.some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2.default.filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 2296 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      // eslint-disable-line guard-for-in
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports.default = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(411);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2.default)(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3.default)(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3.default)(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports.default = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(953);
	
	var _metaProps = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  target: '_blank'
	};
	
	var CSVDownload = function (_React$Component) {
	  _inherits(CSVDownload, _React$Component);
	
	  function CSVDownload(props) {
	    _classCallCheck(this, CSVDownload);
	
	    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CSVDownload, [{
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          enclosingCharacter = _props.enclosingCharacter,
	          uFEFF = _props.uFEFF,
	          target = _props.target,
	          specs = _props.specs,
	          replace = _props.replace;
	
	      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
	    }
	  }, {
	    key: 'getWindow',
	    value: function getWindow() {
	      return this.state.page;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return CSVDownload;
	}(_react2.default.Component);
	
	CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
	CSVDownload.propTypes = _metaProps.propTypes;
	exports.default = CSVDownload;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(953);
	
	var _metaProps = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSVLink = function (_React$Component) {
	  _inherits(CSVLink, _React$Component);
	
	  function CSVLink(props) {
	    _classCallCheck(this, CSVLink);
	
	    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
	
	    _this.buildURI = _this.buildURI.bind(_this);
	    return _this;
	  }
	
	  _createClass(CSVLink, [{
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'handleLegacy',
	    value: function handleLegacy(event) {
	      var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (window.navigator.msSaveOrOpenBlob) {
	        event.preventDefault();
	
	        var _props = this.props,
	            data = _props.data,
	            headers = _props.headers,
	            separator = _props.separator,
	            filename = _props.filename,
	            enclosingCharacter = _props.enclosingCharacter,
	            uFEFF = _props.uFEFF;
	
	
	        var csvData = isAsync && typeof data === 'function' ? data() : data;
	
	        var blob = new Blob([uFEFF ? '\uFEFF' : '', (0, _core.toCSV)(csvData, headers, separator, enclosingCharacter)]);
	        window.navigator.msSaveBlob(blob, filename);
	
	        return false;
	      }
	    }
	  }, {
	    key: 'handleAsyncClick',
	    value: function handleAsyncClick(event) {
	      var _this2 = this;
	
	      var done = function done(proceed) {
	        if (proceed === false) {
	          event.preventDefault();
	          return;
	        }
	        _this2.handleLegacy(event, true);
	      };
	
	      this.props.onClick(event, done);
	    }
	  }, {
	    key: 'handleSyncClick',
	    value: function handleSyncClick(event) {
	      var stopEvent = this.props.onClick(event) === false;
	      if (stopEvent) {
	        event.preventDefault();
	        return;
	      }
	      this.handleLegacy(event);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _this3 = this;
	
	      return function (event) {
	        if (typeof _this3.props.onClick === 'function') {
	          return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
	        }
	        _this3.handleLegacy(event);
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          headers = _props2.headers,
	          separator = _props2.separator,
	          filename = _props2.filename,
	          uFEFF = _props2.uFEFF,
	          children = _props2.children,
	          onClick = _props2.onClick,
	          asyncOnClick = _props2.asyncOnClick,
	          enclosingCharacter = _props2.enclosingCharacter,
	          rest = _objectWithoutProperties(_props2, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);
	
	      var isNodeEnvironment = typeof window === 'undefined';
	      var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          download: filename
	        }, rest, {
	          ref: function ref(link) {
	            return _this4.link = link;
	          },
	          target: '_self',
	          href: href,
	          onClick: this.handleClick()
	        }),
	        children
	      );
	    }
	  }]);
	
	  return CSVLink;
	}(_react2.default.Component);
	
	CSVLink.defaultProps = _metaProps.defaultProps;
	CSVLink.propTypes = _metaProps.propTypes;
	exports.default = CSVLink;

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CSVLink = exports.CSVDownload = undefined;
	
	var _Download = __webpack_require__(2298);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	var _Link = __webpack_require__(2299);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSVDownload = exports.CSVDownload = _Download2.default;
	var CSVLink = exports.CSVLink = _Link2.default;

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderViewDefault = renderViewDefault;
	exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
	exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
	exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
	exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/* eslint-disable react/prop-types */
	
	function renderViewDefault(props) {
	    return _react2["default"].createElement('div', props);
	}
	
	function renderTrackHorizontalDefault(_ref) {
	    var style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        left: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderTrackVerticalDefault(_ref2) {
	    var style = _ref2.style,
	        props = _objectWithoutProperties(_ref2, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        top: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbHorizontalDefault(_ref3) {
	    var style = _ref3.style,
	        props = _objectWithoutProperties(_ref3, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbVerticalDefault(_ref4) {
	    var style = _ref4.style,
	        props = _objectWithoutProperties(_ref4, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}

/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _raf2 = __webpack_require__(492);
	
	var _raf3 = _interopRequireDefault(_raf2);
	
	var _domCss = __webpack_require__(667);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isString = __webpack_require__(2307);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getScrollbarWidth = __webpack_require__(2306);
	
	var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);
	
	var _returnFalse = __webpack_require__(2308);
	
	var _returnFalse2 = _interopRequireDefault(_returnFalse);
	
	var _getInnerWidth = __webpack_require__(2305);
	
	var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);
	
	var _getInnerHeight = __webpack_require__(2304);
	
	var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);
	
	var _styles = __webpack_require__(2303);
	
	var _defaultRenderElements = __webpack_require__(2301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollbars = function (_Component) {
	    _inherits(Scrollbars, _Component);
	
	    function Scrollbars(props) {
	        var _ref;
	
	        _classCallCheck(this, Scrollbars);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            rest[_key - 1] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));
	
	        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
	        _this.getScrollTop = _this.getScrollTop.bind(_this);
	        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
	        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
	        _this.getClientWidth = _this.getClientWidth.bind(_this);
	        _this.getClientHeight = _this.getClientHeight.bind(_this);
	        _this.getValues = _this.getValues.bind(_this);
	        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
	        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
	        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
	        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
	
	        _this.scrollLeft = _this.scrollLeft.bind(_this);
	        _this.scrollTop = _this.scrollTop.bind(_this);
	        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.scrollToRight = _this.scrollToRight.bind(_this);
	        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	
	        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
	        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
	        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
	        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
	        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
	        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
	        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleDrag = _this.handleDrag.bind(_this);
	        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
	        _this.state = {
	            didMountUniversal: false
	        };
	        return _this;
	    }
	
	    _createClass(Scrollbars, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.addListeners();
	            this.update();
	            this.componentDidMountUniversal();
	        }
	    }, {
	        key: 'componentDidMountUniversal',
	        value: function componentDidMountUniversal() {
	            // eslint-disable-line react/sort-comp
	            var universal = this.props.universal;
	
	            if (!universal) return;
	            this.setState({ didMountUniversal: true });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.update();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.removeListeners();
	            (0, _raf2.cancel)(this.requestFrame);
	            clearTimeout(this.hideTracksTimeout);
	            clearInterval(this.detectScrollingInterval);
	        }
	    }, {
	        key: 'getScrollLeft',
	        value: function getScrollLeft() {
	            if (!this.view) return 0;
	            return this.view.scrollLeft;
	        }
	    }, {
	        key: 'getScrollTop',
	        value: function getScrollTop() {
	            if (!this.view) return 0;
	            return this.view.scrollTop;
	        }
	    }, {
	        key: 'getScrollWidth',
	        value: function getScrollWidth() {
	            if (!this.view) return 0;
	            return this.view.scrollWidth;
	        }
	    }, {
	        key: 'getScrollHeight',
	        value: function getScrollHeight() {
	            if (!this.view) return 0;
	            return this.view.scrollHeight;
	        }
	    }, {
	        key: 'getClientWidth',
	        value: function getClientWidth() {
	            if (!this.view) return 0;
	            return this.view.clientWidth;
	        }
	    }, {
	        key: 'getClientHeight',
	        value: function getClientHeight() {
	            if (!this.view) return 0;
	            return this.view.clientHeight;
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues() {
	            var _ref2 = this.view || {},
	                _ref2$scrollLeft = _ref2.scrollLeft,
	                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
	                _ref2$scrollTop = _ref2.scrollTop,
	                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
	                _ref2$scrollWidth = _ref2.scrollWidth,
	                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
	                _ref2$scrollHeight = _ref2.scrollHeight,
	                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
	                _ref2$clientWidth = _ref2.clientWidth,
	                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
	                _ref2$clientHeight = _ref2.clientHeight,
	                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
	
	            return {
	                left: scrollLeft / (scrollWidth - clientWidth) || 0,
	                top: scrollTop / (scrollHeight - clientHeight) || 0,
	                scrollLeft: scrollLeft,
	                scrollTop: scrollTop,
	                scrollWidth: scrollWidth,
	                scrollHeight: scrollHeight,
	                clientWidth: clientWidth,
	                clientHeight: clientHeight
	            };
	        }
	    }, {
	        key: 'getThumbHorizontalWidth',
	        value: function getThumbHorizontalWidth() {
	            var _props = this.props,
	                thumbSize = _props.thumbSize,
	                thumbMinSize = _props.thumbMinSize;
	            var _view = this.view,
	                scrollWidth = _view.scrollWidth,
	                clientWidth = _view.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
	            if (trackWidth === width) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(width, thumbMinSize);
	        }
	    }, {
	        key: 'getThumbVerticalHeight',
	        value: function getThumbVerticalHeight() {
	            var _props2 = this.props,
	                thumbSize = _props2.thumbSize,
	                thumbMinSize = _props2.thumbMinSize;
	            var _view2 = this.view,
	                scrollHeight = _view2.scrollHeight,
	                clientHeight = _view2.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
	            if (trackHeight === height) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(height, thumbMinSize);
	        }
	    }, {
	        key: 'getScrollLeftForOffset',
	        value: function getScrollLeftForOffset(offset) {
	            var _view3 = this.view,
	                scrollWidth = _view3.scrollWidth,
	                clientWidth = _view3.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var thumbWidth = this.getThumbHorizontalWidth();
	            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
	        }
	    }, {
	        key: 'getScrollTopForOffset',
	        value: function getScrollTopForOffset(offset) {
	            var _view4 = this.view,
	                scrollHeight = _view4.scrollHeight,
	                clientHeight = _view4.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var thumbHeight = this.getThumbVerticalHeight();
	            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
	        }
	    }, {
	        key: 'scrollLeft',
	        value: function scrollLeft() {
	            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollLeft = left;
	        }
	    }, {
	        key: 'scrollTop',
	        value: function scrollTop() {
	            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollTop = top;
	        }
	    }, {
	        key: 'scrollToLeft',
	        value: function scrollToLeft() {
	            if (!this.view) return;
	            this.view.scrollLeft = 0;
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (!this.view) return;
	            this.view.scrollTop = 0;
	        }
	    }, {
	        key: 'scrollToRight',
	        value: function scrollToRight() {
	            if (!this.view) return;
	            this.view.scrollLeft = this.view.scrollWidth;
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            if (!this.view) return;
	            this.view.scrollTop = this.view.scrollHeight;
	        }
	    }, {
	        key: 'addListeners',
	        value: function addListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.addEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.addEventListener('resize', this.handleWindowResize);
	        }
	    }, {
	        key: 'removeListeners',
	        value: function removeListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.removeEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.removeEventListener('resize', this.handleWindowResize);
	            // Possibly setup by `handleDragStart`
	            this.teardownDragging();
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(event) {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                onScroll = _props3.onScroll,
	                onScrollFrame = _props3.onScrollFrame;
	
	            if (onScroll) onScroll(event);
	            this.update(function (values) {
	                var scrollLeft = values.scrollLeft,
	                    scrollTop = values.scrollTop;
	
	                _this2.viewScrollLeft = scrollLeft;
	                _this2.viewScrollTop = scrollTop;
	                if (onScrollFrame) onScrollFrame(values);
	            });
	            this.detectScrolling();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart() {
	            var onScrollStart = this.props.onScrollStart;
	
	            if (onScrollStart) onScrollStart();
	            this.handleScrollStartAutoHide();
	        }
	    }, {
	        key: 'handleScrollStartAutoHide',
	        value: function handleScrollStartAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleScrollStop',
	        value: function handleScrollStop() {
	            var onScrollStop = this.props.onScrollStop;
	
	            if (onScrollStop) onScrollStop();
	            this.handleScrollStopAutoHide();
	        }
	    }, {
	        key: 'handleScrollStopAutoHide',
	        value: function handleScrollStopAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleWindowResize',
	        value: function handleWindowResize() {
	            this.update();
	        }
	    }, {
	        key: 'handleHorizontalTrackMouseDown',
	        value: function handleHorizontalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientX = event.clientX;
	
	            var _target$getBoundingCl = target.getBoundingClientRect(),
	                targetLeft = _target$getBoundingCl.left;
	
	            var thumbWidth = this.getThumbHorizontalWidth();
	            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
	            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	        }
	    }, {
	        key: 'handleVerticalTrackMouseDown',
	        value: function handleVerticalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientY = event.clientY;
	
	            var _target$getBoundingCl2 = target.getBoundingClientRect(),
	                targetTop = _target$getBoundingCl2.top;
	
	            var thumbHeight = this.getThumbVerticalHeight();
	            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
	            this.view.scrollTop = this.getScrollTopForOffset(offset);
	        }
	    }, {
	        key: 'handleHorizontalThumbMouseDown',
	        value: function handleHorizontalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientX = event.clientX;
	            var offsetWidth = target.offsetWidth;
	
	            var _target$getBoundingCl3 = target.getBoundingClientRect(),
	                left = _target$getBoundingCl3.left;
	
	            this.prevPageX = offsetWidth - (clientX - left);
	        }
	    }, {
	        key: 'handleVerticalThumbMouseDown',
	        value: function handleVerticalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientY = event.clientY;
	            var offsetHeight = target.offsetHeight;
	
	            var _target$getBoundingCl4 = target.getBoundingClientRect(),
	                top = _target$getBoundingCl4.top;
	
	            this.prevPageY = offsetHeight - (clientY - top);
	        }
	    }, {
	        key: 'setupDragging',
	        value: function setupDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
	            document.addEventListener('mousemove', this.handleDrag);
	            document.addEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = _returnFalse2["default"];
	        }
	    }, {
	        key: 'teardownDragging',
	        value: function teardownDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
	            document.removeEventListener('mousemove', this.handleDrag);
	            document.removeEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = undefined;
	        }
	    }, {
	        key: 'handleDragStart',
	        value: function handleDragStart(event) {
	            this.dragging = true;
	            event.stopImmediatePropagation();
	            this.setupDragging();
	        }
	    }, {
	        key: 'handleDrag',
	        value: function handleDrag(event) {
	            if (this.prevPageX) {
	                var clientX = event.clientX;
	
	                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
	                    trackLeft = _trackHorizontal$getB.left;
	
	                var thumbWidth = this.getThumbHorizontalWidth();
	                var clickPosition = thumbWidth - this.prevPageX;
	                var offset = -trackLeft + clientX - clickPosition;
	                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	            }
	            if (this.prevPageY) {
	                var clientY = event.clientY;
	
	                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
	                    trackTop = _trackVertical$getBou.top;
	
	                var thumbHeight = this.getThumbVerticalHeight();
	                var _clickPosition = thumbHeight - this.prevPageY;
	                var _offset = -trackTop + clientY - _clickPosition;
	                this.view.scrollTop = this.getScrollTopForOffset(_offset);
	            }
	            return false;
	        }
	    }, {
	        key: 'handleDragEnd',
	        value: function handleDragEnd() {
	            this.dragging = false;
	            this.prevPageX = this.prevPageY = 0;
	            this.teardownDragging();
	            this.handleDragEndAutoHide();
	        }
	    }, {
	        key: 'handleDragEndAutoHide',
	        value: function handleDragEndAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleTrackMouseEnter',
	        value: function handleTrackMouseEnter() {
	            this.trackMouseOver = true;
	            this.handleTrackMouseEnterAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseEnterAutoHide',
	        value: function handleTrackMouseEnterAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleTrackMouseLeave',
	        value: function handleTrackMouseLeave() {
	            this.trackMouseOver = false;
	            this.handleTrackMouseLeaveAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseLeaveAutoHide',
	        value: function handleTrackMouseLeaveAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'showTracks',
	        value: function showTracks() {
	            clearTimeout(this.hideTracksTimeout);
	            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
	            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
	        }
	    }, {
	        key: 'hideTracks',
	        value: function hideTracks() {
	            var _this3 = this;
	
	            if (this.dragging) return;
	            if (this.scrolling) return;
	            if (this.trackMouseOver) return;
	            var autoHideTimeout = this.props.autoHideTimeout;
	
	            clearTimeout(this.hideTracksTimeout);
	            this.hideTracksTimeout = setTimeout(function () {
	                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
	                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
	            }, autoHideTimeout);
	        }
	    }, {
	        key: 'detectScrolling',
	        value: function detectScrolling() {
	            var _this4 = this;
	
	            if (this.scrolling) return;
	            this.scrolling = true;
	            this.handleScrollStart();
	            this.detectScrollingInterval = setInterval(function () {
	                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
	                    clearInterval(_this4.detectScrollingInterval);
	                    _this4.scrolling = false;
	                    _this4.handleScrollStop();
	                }
	                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
	                _this4.lastViewScrollTop = _this4.viewScrollTop;
	            }, 100);
	        }
	    }, {
	        key: 'raf',
	        value: function raf(callback) {
	            var _this5 = this;
	
	            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
	            this.requestFrame = (0, _raf3["default"])(function () {
	                _this5.requestFrame = undefined;
	                callback();
	            });
	        }
	    }, {
	        key: 'update',
	        value: function update(callback) {
	            var _this6 = this;
	
	            this.raf(function () {
	                return _this6._update(callback);
	            });
	        }
	    }, {
	        key: '_update',
	        value: function _update(callback) {
	            var _props4 = this.props,
	                onUpdate = _props4.onUpdate,
	                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
	
	            var values = this.getValues();
	            if ((0, _getScrollbarWidth2["default"])()) {
	                var scrollLeft = values.scrollLeft,
	                    clientWidth = values.clientWidth,
	                    scrollWidth = values.scrollWidth;
	
	                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
	                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
	                var thumbHorizontalStyle = {
	                    width: thumbHorizontalWidth,
	                    transform: 'translateX(' + thumbHorizontalX + 'px)'
	                };
	                var scrollTop = values.scrollTop,
	                    clientHeight = values.clientHeight,
	                    scrollHeight = values.scrollHeight;
	
	                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	                var thumbVerticalHeight = this.getThumbVerticalHeight();
	                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
	                var thumbVerticalStyle = {
	                    height: thumbVerticalHeight,
	                    transform: 'translateY(' + thumbVerticalY + 'px)'
	                };
	                if (hideTracksWhenNotNeeded) {
	                    var trackHorizontalStyle = {
	                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
	                    };
	                    var trackVerticalStyle = {
	                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
	                    };
	                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
	                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
	                }
	                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
	                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
	            }
	            if (onUpdate) onUpdate(values);
	            if (typeof callback !== 'function') return;
	            callback(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
	            /* eslint-disable no-unused-vars */
	
	            var _props5 = this.props,
	                onScroll = _props5.onScroll,
	                onScrollFrame = _props5.onScrollFrame,
	                onScrollStart = _props5.onScrollStart,
	                onScrollStop = _props5.onScrollStop,
	                onUpdate = _props5.onUpdate,
	                renderView = _props5.renderView,
	                renderTrackHorizontal = _props5.renderTrackHorizontal,
	                renderTrackVertical = _props5.renderTrackVertical,
	                renderThumbHorizontal = _props5.renderThumbHorizontal,
	                renderThumbVertical = _props5.renderThumbVertical,
	                tagName = _props5.tagName,
	                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
	                autoHide = _props5.autoHide,
	                autoHideTimeout = _props5.autoHideTimeout,
	                autoHideDuration = _props5.autoHideDuration,
	                thumbSize = _props5.thumbSize,
	                thumbMinSize = _props5.thumbMinSize,
	                universal = _props5.universal,
	                autoHeight = _props5.autoHeight,
	                autoHeightMin = _props5.autoHeightMin,
	                autoHeightMax = _props5.autoHeightMax,
	                style = _props5.style,
	                children = _props5.children,
	                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
	            /* eslint-enable no-unused-vars */
	
	            var didMountUniversal = this.state.didMountUniversal;
	
	
	            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }), style);
	
	            var viewStyle = _extends({}, _styles.viewStyleDefault, {
	                // Hide scrollbars by setting a negative margin
	                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
	                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
	            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
	                // Add scrollbarWidth to autoHeight in order to compensate negative margins
	                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
	                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
	            }), autoHeight && universal && !didMountUniversal && {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);
	
	            var trackAutoHeightStyle = {
	                transition: 'opacity ' + autoHideDuration + 'ms',
	                opacity: 0
	            };
	
	            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
	                    _this7.container = _ref3;
	                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
	                    _this7.view = _ref4;
	                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
	                    _this7.trackHorizontal = _ref5;
	                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
	                    _this7.thumbHorizontal = _ref6;
	                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
	                    _this7.trackVertical = _ref7;
	                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
	                    _this7.thumbVertical = _ref8;
	                } }))]);
	        }
	    }]);
	
	    return Scrollbars;
	}(_react.Component);
	
	exports["default"] = Scrollbars;
	
	
	Scrollbars.propTypes = {
	    onScroll: _propTypes2["default"].func,
	    onScrollFrame: _propTypes2["default"].func,
	    onScrollStart: _propTypes2["default"].func,
	    onScrollStop: _propTypes2["default"].func,
	    onUpdate: _propTypes2["default"].func,
	    renderView: _propTypes2["default"].func,
	    renderTrackHorizontal: _propTypes2["default"].func,
	    renderTrackVertical: _propTypes2["default"].func,
	    renderThumbHorizontal: _propTypes2["default"].func,
	    renderThumbVertical: _propTypes2["default"].func,
	    tagName: _propTypes2["default"].string,
	    thumbSize: _propTypes2["default"].number,
	    thumbMinSize: _propTypes2["default"].number,
	    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
	    autoHide: _propTypes2["default"].bool,
	    autoHideTimeout: _propTypes2["default"].number,
	    autoHideDuration: _propTypes2["default"].number,
	    autoHeight: _propTypes2["default"].bool,
	    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    universal: _propTypes2["default"].bool,
	    style: _propTypes2["default"].object,
	    children: _propTypes2["default"].node
	};
	
	Scrollbars.defaultProps = {
	    renderView: _defaultRenderElements.renderViewDefault,
	    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
	    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
	    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
	    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
	    tagName: 'div',
	    thumbMinSize: 30,
	    hideTracksWhenNotNeeded: false,
	    autoHide: false,
	    autoHideTimeout: 1000,
	    autoHideDuration: 200,
	    autoHeight: false,
	    autoHeightMin: 0,
	    autoHeightMax: 200,
	    universal: false
	};

/***/ },
/* 2303 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var containerStyleDefault = exports.containerStyleDefault = {
	    position: 'relative',
	    overflow: 'hidden',
	    width: '100%',
	    height: '100%'
	};
	
	// Overrides containerStyleDefault properties
	var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
	    height: 'auto'
	};
	
	var viewStyleDefault = exports.viewStyleDefault = {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflow: 'scroll',
	    WebkitOverflowScrolling: 'touch'
	};
	
	// Overrides viewStyleDefault properties
	var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
	    position: 'relative',
	    top: undefined,
	    left: undefined,
	    right: undefined,
	    bottom: undefined
	};
	
	var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
	    overflow: 'hidden',
	    marginRight: 0,
	    marginBottom: 0
	};
	
	var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
	    position: 'absolute',
	    height: 6
	};
	
	var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
	    position: 'absolute',
	    width: 6
	};
	
	var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    height: '100%'
	};
	
	var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    width: '100%'
	};
	
	var disableSelectStyle = exports.disableSelectStyle = {
	    userSelect: 'none'
	};
	
	var disableSelectStyleReset = exports.disableSelectStyleReset = {
	    userSelect: ''
	};

/***/ },
/* 2304 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerHeight;
	function getInnerHeight(el) {
	    var clientHeight = el.clientHeight;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingTop = _getComputedStyle.paddingTop,
	        paddingBottom = _getComputedStyle.paddingBottom;
	
	    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
	}

/***/ },
/* 2305 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerWidth;
	function getInnerWidth(el) {
	    var clientWidth = el.clientWidth;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingLeft = _getComputedStyle.paddingLeft,
	        paddingRight = _getComputedStyle.paddingRight;
	
	    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
	}

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getScrollbarWidth;
	
	var _domCss = __webpack_require__(667);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var scrollbarWidth = false;
	
	function getScrollbarWidth() {
	    if (scrollbarWidth !== false) return scrollbarWidth;
	    /* istanbul ignore else */
	    if (typeof document !== 'undefined') {
	        var div = document.createElement('div');
	        (0, _domCss2["default"])(div, {
	            width: 100,
	            height: 100,
	            position: 'absolute',
	            top: -9999,
	            overflow: 'scroll',
	            MsOverflowStyle: 'scrollbar'
	        });
	        document.body.appendChild(div);
	        scrollbarWidth = div.offsetWidth - div.clientWidth;
	        document.body.removeChild(div);
	    } else {
	        scrollbarWidth = 0;
	    }
	    return scrollbarWidth || 0;
	}

/***/ },
/* 2307 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = isString;
	function isString(maybe) {
	    return typeof maybe === 'string';
	}

/***/ },
/* 2308 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = returnFalse;
	function returnFalse() {
	    return false;
	}

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(73),
		DaysView = __webpack_require__(2310),
		MonthsView = __webpack_require__(2311),
		YearsView = __webpack_require__(2313),
		TimeView = __webpack_require__(2312)
		;
	
	var CalendarContainer = createClass({
		viewComponents: {
			days: DaysView,
			months: MonthsView,
			years: YearsView,
			time: TimeView
		},
	
		render: function() {
			return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
		}
	});
	
	module.exports = CalendarContainer;


/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(73),
		moment = __webpack_require__(5)
		;
	
	var DateTimePickerDays = createClass({
		render: function() {
			var footer = this.renderFooter(),
				date = this.props.viewDate,
				locale = date.localeData(),
				tableChildren
				;
	
			tableChildren = [
				React.createElement('thead', { key: 'th' }, [
					React.createElement('tr', { key: 'h' }, [
						React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
						React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
						React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
					]),
					React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
				]),
				React.createElement('tbody', { key: 'tb' }, this.renderDays())
			];
	
			if ( footer )
				tableChildren.push( footer );
	
			return React.createElement('div', { className: 'rdtDays' },
				React.createElement('table', {}, tableChildren )
			);
		},
	
		/**
		 * Get a list of the days of the week
		 * depending on the current locale
		 * @return {array} A list with the shortname of the days
		 */
		getDaysOfWeek: function( locale ) {
			var days = locale._weekdaysMin,
				first = locale.firstDayOfWeek(),
				dow = [],
				i = 0
				;
	
			days.forEach( function( day ) {
				dow[ (7 + ( i++ ) - first) % 7 ] = day;
			});
	
			return dow;
		},
	
		renderDays: function() {
			var date = this.props.viewDate,
				selected = this.props.selectedDate && this.props.selectedDate.clone(),
				prevMonth = date.clone().subtract( 1, 'months' ),
				currentYear = date.year(),
				currentMonth = date.month(),
				weeks = [],
				days = [],
				renderer = this.props.renderDay || this.renderDay,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, isDisabled, dayProps, currentDate
				;
	
			// Go to the last week of the previous month
			prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
			var lastDay = prevMonth.clone().add( 42, 'd' );
	
			while ( prevMonth.isBefore( lastDay ) ) {
				classes = 'rdtDay';
				currentDate = prevMonth.clone();
	
				if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
					classes += ' rdtOld';
				else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
					classes += ' rdtNew';
	
				if ( selected && prevMonth.isSame( selected, 'day' ) )
					classes += ' rdtActive';
	
				if ( prevMonth.isSame( moment(), 'day' ) )
					classes += ' rdtToday';
	
				isDisabled = !isValid( currentDate, selected );
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				dayProps = {
					key: prevMonth.format( 'M_D' ),
					'data-value': prevMonth.date(),
					className: classes
				};
	
				if ( !isDisabled )
					dayProps.onClick = this.updateSelectedDate;
	
				days.push( renderer( dayProps, currentDate, selected ) );
	
				if ( days.length === 7 ) {
					weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
					days = [];
				}
	
				prevMonth.add( 1, 'd' );
			}
	
			return weeks;
		},
	
		updateSelectedDate: function( event ) {
			this.props.updateSelectedDate( event, true );
		},
	
		renderDay: function( props, currentDate ) {
			return React.createElement('td',  props, currentDate.date() );
		},
	
		renderFooter: function() {
			if ( !this.props.timeFormat )
				return '';
	
			var date = this.props.selectedDate || this.props.viewDate;
	
			return React.createElement('tfoot', { key: 'tf'},
				React.createElement('tr', {},
					React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
				)
			);
		},
	
		alwaysValidDate: function() {
			return 1;
		}
	});
	
	module.exports = DateTimePickerDays;


/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(73)
	;
	
	var DateTimePickerMonths = createClass({
		render: function() {
			return React.createElement('div', { className: 'rdtMonths' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
			]);
		},
	
		renderMonths: function() {
			var date = this.props.selectedDate,
				month = this.props.viewDate.month(),
				year = this.props.viewDate.year(),
				rows = [],
				i = 0,
				months = [],
				renderer = this.props.renderMonth || this.renderMonth,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
				// Date is irrelevant because we're only interested in month
				irrelevantDate = 1
				;
	
			while (i < 12) {
				classes = 'rdtMonth';
				currentMonth =
					this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });
	
				noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
				daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInMonth.find(function( d ) {
					var day = currentMonth.clone().set( 'date', d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( date && i === date.month() && year === date.year() )
					classes += ' rdtActive';
	
				props = {
					key: i,
					'data-value': i,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'months' ?
						this.updateSelectedMonth : this.props.setDate( 'month' ) );
	
				months.push( renderer( props, i, year, date && date.clone() ) );
	
				if ( months.length === 4 ) {
					rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
					months = [];
				}
	
				i++;
			}
	
			return rows;
		},
	
		updateSelectedMonth: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderMonth: function( props, month ) {
			var localMoment = this.props.viewDate;
			var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
			var strLength = 3;
			// Because some months are up to 5 characters long, we want to
			// use a fixed string length for consistency
			var monthStrFixedLength = monthStr.substring( 0, strLength );
			return React.createElement('td', props, capitalize( monthStrFixedLength ) );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	});
	
	function capitalize( str ) {
		return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
	}
	
	module.exports = DateTimePickerMonths;


/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(73),
		assign = __webpack_require__(956)
		;
	
	var DateTimePickerTime = createClass({
		getInitialState: function() {
			return this.calculateState( this.props );
		},
	
		calculateState: function( props ) {
			var date = props.selectedDate || props.viewDate,
				format = props.timeFormat,
				counters = []
				;
	
			if ( format.toLowerCase().indexOf('h') !== -1 ) {
				counters.push('hours');
				if ( format.indexOf('m') !== -1 ) {
					counters.push('minutes');
					if ( format.indexOf('s') !== -1 ) {
						counters.push('seconds');
					}
				}
			}
	
			var hours = date.format( 'H' );
	
			var daypart = false;
			if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
					daypart = ( hours >= 12 ) ? 'PM' : 'AM';
				} else {
					daypart = ( hours >= 12 ) ? 'pm' : 'am';
				}
			}
	
			return {
				hours: hours,
				minutes: date.format( 'mm' ),
				seconds: date.format( 'ss' ),
				milliseconds: date.format( 'SSS' ),
				daypart: daypart,
				counters: counters
			};
		},
	
		renderCounter: function( type ) {
			if ( type !== 'daypart' ) {
				var value = this.state[ type ];
				if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
					value = ( value - 1 ) % 12 + 1;
	
					if ( value === 0 ) {
						value = 12;
					}
				}
				return React.createElement('div', { key: type, className: 'rdtCounter' }, [
					React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
					React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
					React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
				]);
			}
			return '';
		},
	
		renderDayPart: function() {
			return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		},
	
		render: function() {
			var me = this,
				counters = []
			;
	
			this.state.counters.forEach( function( c ) {
				if ( counters.length )
					counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
				counters.push( me.renderCounter( c ) );
			});
	
			if ( this.state.daypart !== false ) {
				counters.push( me.renderDayPart() );
			}
	
			if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
				counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
				counters.push(
					React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
						React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
						)
					);
			}
	
			return React.createElement('div', { className: 'rdtTime' },
				React.createElement('table', {}, [
					this.renderHeader(),
					React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
						React.createElement('div', { className: 'rdtCounters' }, counters )
					)))
				])
			);
		},
	
		componentWillMount: function() {
			var me = this;
			me.timeConstraints = {
				hours: {
					min: 0,
					max: 23,
					step: 1
				},
				minutes: {
					min: 0,
					max: 59,
					step: 1
				},
				seconds: {
					min: 0,
					max: 59,
					step: 1
				},
				milliseconds: {
					min: 0,
					max: 999,
					step: 1
				}
			};
			['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
				assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
			});
			this.setState( this.calculateState( this.props ) );
		},
	
		componentWillReceiveProps: function( nextProps ) {
			this.setState( this.calculateState( nextProps ) );
		},
	
		updateMilli: function( e ) {
			var milli = parseInt( e.target.value, 10 );
			if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
				this.props.setTime( 'milliseconds', milli );
				this.setState( { milliseconds: milli } );
			}
		},
	
		renderHeader: function() {
			if ( !this.props.dateFormat )
				return null;
	
			var date = this.props.selectedDate || this.props.viewDate;
			return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
				React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
			));
		},
	
		onStartClicking: function( action, type ) {
			var me = this;
	
			return function() {
				var update = {};
				update[ type ] = me[ action ]( type );
				me.setState( update );
	
				me.timer = setTimeout( function() {
					me.increaseTimer = setInterval( function() {
						update[ type ] = me[ action ]( type );
						me.setState( update );
					}, 70);
				}, 500);
	
				me.mouseUpListener = function() {
					clearTimeout( me.timer );
					clearInterval( me.increaseTimer );
					me.props.setTime( type, me.state[ type ] );
					document.body.removeEventListener( 'mouseup', me.mouseUpListener );
					document.body.removeEventListener( 'touchend', me.mouseUpListener );
				};
	
				document.body.addEventListener( 'mouseup', me.mouseUpListener );
				document.body.addEventListener( 'touchend', me.mouseUpListener );
			};
		},
	
		disableContextMenu: function( event ) {
			event.preventDefault();
			return false;
		},
	
		padValues: {
			hours: 1,
			minutes: 2,
			seconds: 2,
			milliseconds: 3
		},
	
		toggleDayPart: function( type ) { // type is always 'hours'
			var value = parseInt( this.state[ type ], 10) + 12;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		increase: function( type ) {
			var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		decrease: function( type ) {
			var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
			if ( value < this.timeConstraints[ type ].min )
				value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
			return this.pad( type, value );
		},
	
		pad: function( type, value ) {
			var str = value + '';
			while ( str.length < this.padValues[ type ] )
				str = '0' + str;
			return str;
		},
	});
	
	module.exports = DateTimePickerTime;


/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(73)
	;
	
	var DateTimePickerYears = createClass({
		render: function() {
			var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;
	
			return React.createElement('div', { className: 'rdtYears' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
			]);
		},
	
		renderYears: function( year ) {
			var years = [],
				i = -1,
				rows = [],
				renderer = this.props.renderYear || this.renderYear,
				selectedDate = this.props.selectedDate,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
				// Month and date are irrelevant here because
				// we're only interested in the year
				irrelevantMonth = 0,
				irrelevantDate = 1
				;
	
			year--;
			while (i < 11) {
				classes = 'rdtYear';
				currentYear = this.props.viewDate.clone().set(
					{ year: year, month: irrelevantMonth, date: irrelevantDate } );
	
				// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
				// if ( i === -1 | i === 10 )
					// classes += ' rdtOld';
	
				noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
				daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInYear.find(function( d ) {
					var day = currentYear.clone().dayOfYear( d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( selectedDate && selectedDate.year() === year )
					classes += ' rdtActive';
	
				props = {
					key: year,
					'data-value': year,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'years' ?
						this.updateSelectedYear : this.props.setDate('year') );
	
				years.push( renderer( props, year, selectedDate && selectedDate.clone() ));
	
				if ( years.length === 4 ) {
					rows.push( React.createElement('tr', { key: i }, years ) );
					years = [];
				}
	
				year++;
				i++;
			}
	
			return rows;
		},
	
		updateSelectedYear: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderYear: function( props, year ) {
			return React.createElement('td',  props, year );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	});
	
	module.exports = DateTimePickerYears;


/***/ },
/* 2314 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(59);
	
	var focusNode = __webpack_require__(679);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(288);
	var ExecutionEnvironment = __webpack_require__(89);
	var FallbackCompositionState = __webpack_require__(2322);
	var SyntheticCompositionEvent = __webpack_require__(2356);
	var SyntheticInputEvent = __webpack_require__(2359);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(957);
	var ExecutionEnvironment = __webpack_require__(89);
	var ReactInstrumentation = __webpack_require__(111);
	
	var camelizeStyleName = __webpack_require__(1826);
	var dangerousStyleValue = __webpack_require__(2365);
	var hyphenateStyleName = __webpack_require__(681);
	var memoizeStringOnly = __webpack_require__(1835);
	var warning = __webpack_require__(39);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(287);
	var EventPropagators = __webpack_require__(288);
	var ExecutionEnvironment = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(125);
	var SyntheticEvent = __webpack_require__(146);
	
	var inputValueTracking = __webpack_require__(979);
	var getEventTarget = __webpack_require__(529);
	var isEventSupported = __webpack_require__(531);
	var isTextInputElement = __webpack_require__(980);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var DOMLazyTree = __webpack_require__(240);
	var ExecutionEnvironment = __webpack_require__(89);
	
	var createNodesFromMarkup = __webpack_require__(1829);
	var emptyFunction = __webpack_require__(132);
	var invariant = __webpack_require__(29);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 2320 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(288);
	var ReactDOMComponentTree = __webpack_require__(59);
	var SyntheticMouseEvent = __webpack_require__(370);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var PooledClass = __webpack_require__(204);
	
	var getTextContentAccessor = __webpack_require__(978);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(241);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(205);
	
	var instantiateReactComponent = __webpack_require__(530);
	var KeyEscapeUtils = __webpack_require__(521);
	var shouldUpdateReactComponent = __webpack_require__(532);
	var traverseAllChildren = __webpack_require__(982);
	var warning = __webpack_require__(39);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_AC_TKN":"f218eb621f0c68f1c7e01ba9c48691bff09ec7b9","REACT_APP_API_URL":"https://be-production-itb.marketgames.io/api/","REACT_APP_GOOGLE_MERCHANT_ID":"1231232131","REACT_APP_HIDE_NOT_FINISHED_PART":"true"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1004);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(517);
	var ReactDOMIDOperations = __webpack_require__(2331);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var React = __webpack_require__(206);
	var ReactComponentEnvironment = __webpack_require__(523);
	var ReactCurrentOwner = __webpack_require__(148);
	var ReactErrorUtils = __webpack_require__(524);
	var ReactInstanceMap = __webpack_require__(289);
	var ReactInstrumentation = __webpack_require__(111);
	var ReactNodeTypes = __webpack_require__(971);
	var ReactReconciler = __webpack_require__(205);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(331);
	var invariant = __webpack_require__(29);
	var shallowEqual = __webpack_require__(332);
	var shouldUpdateReactComponent = __webpack_require__(532);
	var warning = __webpack_require__(39);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactDefaultInjection = __webpack_require__(964);
	var ReactMount = __webpack_require__(970);
	var ReactReconciler = __webpack_require__(205);
	var ReactUpdates = __webpack_require__(125);
	var ReactVersion = __webpack_require__(973);
	
	var findDOMNode = __webpack_require__(2366);
	var getHostComponentFromComposite = __webpack_require__(977);
	var renderSubtreeIntoContainer = __webpack_require__(2373);
	var warning = __webpack_require__(39);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 2328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var AutoFocusUtils = __webpack_require__(2315);
	var CSSPropertyOperations = __webpack_require__(2317);
	var DOMLazyTree = __webpack_require__(240);
	var DOMNamespaces = __webpack_require__(518);
	var DOMProperty = __webpack_require__(241);
	var DOMPropertyOperations = __webpack_require__(959);
	var EventPluginHub = __webpack_require__(287);
	var EventPluginRegistry = __webpack_require__(519);
	var ReactBrowserEventEmitter = __webpack_require__(369);
	var ReactDOMComponentFlags = __webpack_require__(960);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactDOMInput = __webpack_require__(2332);
	var ReactDOMOption = __webpack_require__(2333);
	var ReactDOMSelect = __webpack_require__(962);
	var ReactDOMTextarea = __webpack_require__(2337);
	var ReactInstrumentation = __webpack_require__(111);
	var ReactMultiChild = __webpack_require__(2343);
	var ReactServerRenderingTransaction = __webpack_require__(972);
	
	var emptyFunction = __webpack_require__(132);
	var escapeTextContentForBrowser = __webpack_require__(372);
	var invariant = __webpack_require__(29);
	var isEventSupported = __webpack_require__(531);
	var shallowEqual = __webpack_require__(332);
	var inputValueTracking = __webpack_require__(979);
	var validateDOMNesting = __webpack_require__(533);
	var warning = __webpack_require__(39);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var DOMLazyTree = __webpack_require__(240);
	var ReactDOMComponentTree = __webpack_require__(59);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 2330 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(517);
	var ReactDOMComponentTree = __webpack_require__(59);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var DOMPropertyOperations = __webpack_require__(959);
	var LinkedValueUtils = __webpack_require__(522);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(125);
	
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var React = __webpack_require__(206);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactDOMSelect = __webpack_require__(962);
	
	var warning = __webpack_require__(39);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	var getNodeForCharacterOffset = __webpack_require__(2370);
	var getTextContentAccessor = __webpack_require__(978);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(964);
	var ReactServerRendering = __webpack_require__(2349);
	var ReactVersion = __webpack_require__(973);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var DOMChildrenOperations = __webpack_require__(517);
	var DOMLazyTree = __webpack_require__(240);
	var ReactDOMComponentTree = __webpack_require__(59);
	
	var escapeTextContentForBrowser = __webpack_require__(372);
	var invariant = __webpack_require__(29);
	var validateDOMNesting = __webpack_require__(533);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34),
	    _assign = __webpack_require__(45);
	
	var LinkedValueUtils = __webpack_require__(522);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(125);
	
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 2339 */
1005,
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(287);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var EventListener = __webpack_require__(678);
	var ExecutionEnvironment = __webpack_require__(89);
	var PooledClass = __webpack_require__(204);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(125);
	
	var getEventTarget = __webpack_require__(529);
	var getUnboundedScrollPosition = __webpack_require__(1831);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(241);
	var EventPluginHub = __webpack_require__(287);
	var EventPluginUtils = __webpack_require__(520);
	var ReactComponentEnvironment = __webpack_require__(523);
	var ReactEmptyComponent = __webpack_require__(965);
	var ReactBrowserEventEmitter = __webpack_require__(369);
	var ReactHostComponent = __webpack_require__(967);
	var ReactUpdates = __webpack_require__(125);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var ReactComponentEnvironment = __webpack_require__(523);
	var ReactInstanceMap = __webpack_require__(289);
	var ReactInstrumentation = __webpack_require__(111);
	
	var ReactCurrentOwner = __webpack_require__(148);
	var ReactReconciler = __webpack_require__(205);
	var ReactChildReconciler = __webpack_require__(2324);
	
	var emptyFunction = __webpack_require__(132);
	var flattenChildren = __webpack_require__(2367);
	var invariant = __webpack_require__(29);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 2345 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(45);
	
	var CallbackQueue = __webpack_require__(958);
	var PooledClass = __webpack_require__(204);
	var ReactBrowserEventEmitter = __webpack_require__(369);
	var ReactInputSelection = __webpack_require__(968);
	var ReactInstrumentation = __webpack_require__(111);
	var Transaction = __webpack_require__(371);
	var ReactUpdateQueue = __webpack_require__(525);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(2344);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 2348 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var React = __webpack_require__(206);
	var ReactDOMContainerInfo = __webpack_require__(961);
	var ReactDefaultBatchingStrategy = __webpack_require__(963);
	var ReactInstrumentation = __webpack_require__(111);
	var ReactMarkupChecksum = __webpack_require__(969);
	var ReactReconciler = __webpack_require__(205);
	var ReactServerBatchingStrategy = __webpack_require__(2348);
	var ReactServerRenderingTransaction = __webpack_require__(972);
	var ReactUpdates = __webpack_require__(125);
	
	var emptyObject = __webpack_require__(331);
	var instantiateReactComponent = __webpack_require__(530);
	var invariant = __webpack_require__(29);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 2350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(525);
	
	var warning = __webpack_require__(39);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 2351 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 2352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(288);
	var ExecutionEnvironment = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactInputSelection = __webpack_require__(968);
	var SyntheticEvent = __webpack_require__(146);
	
	var getActiveElement = __webpack_require__(680);
	var isTextInputElement = __webpack_require__(980);
	var shallowEqual = __webpack_require__(332);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var EventListener = __webpack_require__(678);
	var EventPropagators = __webpack_require__(288);
	var ReactDOMComponentTree = __webpack_require__(59);
	var SyntheticAnimationEvent = __webpack_require__(2354);
	var SyntheticClipboardEvent = __webpack_require__(2355);
	var SyntheticEvent = __webpack_require__(146);
	var SyntheticFocusEvent = __webpack_require__(2358);
	var SyntheticKeyboardEvent = __webpack_require__(2360);
	var SyntheticMouseEvent = __webpack_require__(370);
	var SyntheticDragEvent = __webpack_require__(2357);
	var SyntheticTouchEvent = __webpack_require__(2361);
	var SyntheticTransitionEvent = __webpack_require__(2362);
	var SyntheticUIEvent = __webpack_require__(290);
	var SyntheticWheelEvent = __webpack_require__(2363);
	
	var emptyFunction = __webpack_require__(132);
	var getEventCharCode = __webpack_require__(527);
	var invariant = __webpack_require__(29);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 2354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(146);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(146);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(146);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(370);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(290);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 2359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(146);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(290);
	
	var getEventCharCode = __webpack_require__(527);
	var getEventKey = __webpack_require__(2368);
	var getEventModifierState = __webpack_require__(528);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 2361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(290);
	
	var getEventModifierState = __webpack_require__(528);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(146);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(370);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 2364 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 2365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(957);
	var warning = __webpack_require__(39);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(34);
	
	var ReactCurrentOwner = __webpack_require__(148);
	var ReactDOMComponentTree = __webpack_require__(59);
	var ReactInstanceMap = __webpack_require__(289);
	
	var getHostComponentFromComposite = __webpack_require__(977);
	var invariant = __webpack_require__(29);
	var warning = __webpack_require__(39);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(521);
	var traverseAllChildren = __webpack_require__(982);
	var warning = __webpack_require__(39);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_AC_TKN":"f218eb621f0c68f1c7e01ba9c48691bff09ec7b9","REACT_APP_API_URL":"https://be-production-itb.marketgames.io/api/","REACT_APP_GOOGLE_MERCHANT_ID":"1231232131","REACT_APP_HIDE_NOT_FINISHED_PART":"true"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1004);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)))

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(527);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 2369 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 2370 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(89);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(372);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 2373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(970);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2335);


/***/ },
/* 2375 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(1),reactDom=__webpack_require__(49);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  // Also cover shadowRoot node by checking current.host
	
	
	  while (current.parentNode || current.host) {
	    // Only check normal node without shadowRoot
	    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode || current.host;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(350);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(374);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(242);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(668);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(228);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(164);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(350);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(2072);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(2379);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(984);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(2382);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(987);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(2383);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(374);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(242);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1806);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(330);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(676);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(988);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(2385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(41);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(984);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(2381);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(985);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(350);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(2384);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(374);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(242);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ },
/* 2383 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(672);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1811);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(673);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(242);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 2385 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(2532);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _lodash = __webpack_require__(1921);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(1923);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };
	
	var styles = {
	  position: 'absolute',
	  width: 0,
	  height: 0,
	  visibility: 'hidden',
	  display: 'none'
	};
	
	var ResizeDetector = function (_PureComponent) {
	  _inherits(ResizeDetector, _PureComponent);
	
	  function ResizeDetector(props) {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));
	
	    _this.createResizeObserver = function (entries) {
	      var _this$props = _this.props,
	          handleWidth = _this$props.handleWidth,
	          handleHeight = _this$props.handleHeight,
	          onResize = _this$props.onResize;
	
	      entries.forEach(function (entry) {
	        var _entry$contentRect = entry.contentRect,
	            width = _entry$contentRect.width,
	            height = _entry$contentRect.height;
	
	        var notifyWidth = handleWidth && _this.width !== width;
	        var notifyHeight = handleHeight && _this.height !== height;
	        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
	          onResize(width, height);
	        }
	        _this.width = width;
	        _this.height = height;
	        _this.skipOnMount = false;
	      });
	    };
	
	    var skipOnMount = props.skipOnMount,
	        refreshMode = props.refreshMode,
	        refreshRate = props.refreshRate;
	
	
	    _this.width = undefined;
	    _this.height = undefined;
	    _this.skipOnMount = skipOnMount;
	
	    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;
	
	    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.observe(resizableElement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.unobserve(resizableElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        style: styles,
	        ref: function ref(el) {
	          _this2.el = el;
	        }
	      });
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.PureComponent);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  skipOnMount: _propTypes2.default.bool,
	  refreshRate: _propTypes2.default.number,
	  refreshMode: _propTypes2.default.string,
	  resizableElementId: _propTypes2.default.string,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  skipOnMount: false,
	  refreshRate: 1000,
	  refreshMode: undefined,
	  resizableElementId: '',
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(2386);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(989);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 2389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(244);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(991);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 2390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(244);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _InternalPropTypes = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _InternalPropTypes = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _createTransitionManager2 = __webpack_require__(995);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(292);
	
	var _RouterContext = __webpack_require__(538);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _RouterUtils = __webpack_require__(992);
	
	var _routerWarning = __webpack_require__(244);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(535);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(538);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(244);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1880);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(994);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(243);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(535);
	
	var _PromiseUtils = __webpack_require__(990);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(243);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1881);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(994);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(243);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(334);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(993);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(995);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(172);
	
	var _RouterUtils = __webpack_require__(992);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(535);
	
	var _PromiseUtils = __webpack_require__(990);
	
	var _PatternUtils = __webpack_require__(243);
	
	var _routerWarning = __webpack_require__(244);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(73);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1883);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(536);
	
	var _PropTypes = __webpack_require__(537);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(1001);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _AnimateGroupChild = _interopRequireDefault(__webpack_require__(2405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function AnimateGroup(props) {
	  var component = props.component,
	      children = props.children,
	      appear = props.appear,
	      enter = props.enter,
	      leave = props.leave;
	  return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: component
	  }, _react.Children.map(children, function (child, index) {
	    return _react.default.createElement(_AnimateGroupChild.default, {
	      appearOptions: appear,
	      enterOptions: enter,
	      leaveOptions: leave,
	      key: "child-".concat(index)
	    }, child);
	  }));
	}
	
	AnimateGroup.propTypes = {
	  appear: _propTypes.default.object,
	  enter: _propTypes.default.object,
	  leave: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]),
	  component: _propTypes.default.any
	};
	AnimateGroup.defaultProps = {
	  component: 'span'
	};
	var _default = AnimateGroup;
	exports.default = _default;

/***/ },
/* 2405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(347));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(1001);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Animate = _interopRequireDefault(__webpack_require__(997));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber2.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber2.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isActive: false
	    };
	
	    _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    };
	
	    _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    };
	
	    return _this;
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: "handleStyleActive",
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	        this.setState(_objectSpread({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: "parseTimeout",
	    value: function parseTimeout() {
	      var _this$props2 = this.props,
	          appearOptions = _this$props2.appearOptions,
	          enterOptions = _this$props2.enterOptions,
	          leaveOptions = _this$props2.leaveOptions;
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          appearOptions = _this$props3.appearOptions,
	          enterOptions = _this$props3.enterOptions,
	          leaveOptions = _this$props3.leaveOptions,
	          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);
	
	      return _react.default.createElement(_reactTransitionGroup.Transition, _extends({}, props, {
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        timeout: this.parseTimeout()
	      }), function () {
	        return _react.default.createElement(_Animate.default, _this2.state, _react.Children.only(children));
	      });
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component);
	
	AnimateGroupChild.propTypes = {
	  appearOptions: _propTypes.default.object,
	  enterOptions: _propTypes.default.object,
	  leaveOptions: _propTypes.default.object,
	  children: _propTypes.default.element
	};
	var _default = AnimateGroupChild;
	exports.default = _default;

/***/ },
/* 2406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnimateManager;
	
	var _setRafTimeout = _interopRequireDefault(__webpack_require__(2408));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function createAnimateManager() {
	  var currStyle = {};
	
	  var handleChange = function handleChange() {
	    return null;
	  };
	
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout.default)(setStyle.bind(null, restStyles), curr);
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if (_typeof(_style) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 2407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _filter2 = _interopRequireDefault(__webpack_require__(2033));
	
	var _raf = _interopRequireWildcard(__webpack_require__(492));
	
	var _util = __webpack_require__(375);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	
	
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _objectSpread({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _objectSpread({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	}; // configure update function
	
	
	var _default = function _default(from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime;
	  var beginTime;
	
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter2.default)(stepperStyle, needContinue).length;
	  }; // stepper timing function like spring
	
	
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf.default)(update);
	    }
	  }; // t => val timing function like cubic-bezier
	
	
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	      render(_objectSpread({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
	
	  return function () {
	    (0, _raf.default)(update); // return stop animation method
	
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};
	
	exports.default = _default;

/***/ },
/* 2408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = _interopRequireDefault(__webpack_require__(492));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf.default)(shouldUpdate);
	}

/***/ },
/* 2409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(669));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(671));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(999));
	
	var _PropTypes = __webpack_require__(1002);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(49);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(1000));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _Cursor = __webpack_require__(10);
	
		var _Cursor2 = _interopRequireDefault(_Cursor);
	
		var _Backspace = __webpack_require__(12);
	
		var _Backspace2 = _interopRequireDefault(_Backspace);
	
		var _Delay = __webpack_require__(13);
	
		var _Delay2 = _interopRequireDefault(_Delay);
	
		var _utils = __webpack_require__(14);
	
		var utils = _interopRequireWildcard(_utils);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ACTION_CHARS = ['🔙', '⏰'];
	
		var Typist = function (_Component) {
		  _inherits(Typist, _Component);
	
		  function Typist(props) {
		    _classCallCheck(this, Typist);
	
		    var _this = _possibleConstructorReturn(this, (Typist.__proto__ || Object.getPrototypeOf(Typist)).call(this, props));
	
		    _this.state = {
		      textLines: [],
		      isDone: false
		    };
	
		    _this.onTypingDone = function () {
		      if (!_this.mounted) {
		        return;
		      }
		      _this.setState({ isDone: true });
		      _this.props.onTypingDone();
		    };
	
		    _this.delayGenerator = function (line, lineIdx, character, charIdx) {
		      var mean = _this.props.avgTypingDelay;
		      var std = _this.props.stdTypingDelay;
	
		      return _this.props.delayGenerator(mean, std, {
		        line: line,
		        lineIdx: lineIdx,
		        character: character,
		        charIdx: charIdx,
		        defDelayGenerator: function defDelayGenerator() {
		          var mn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mean;
		          var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : std;
		          return utils.gaussianRnd(mn, st);
		        }
		      });
		    };
	
		    _this.typeLine = function (line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
	
		      var decoratedLine = line;
		      var onLineTyped = _this.props.onLineTyped;
	
	
		      if (utils.isBackspaceElement(line)) {
		        if (line.props.delay > 0) {
		          _this.introducedDelay = line.props.delay;
		        }
		        decoratedLine = String('🔙').repeat(line.props.count);
		      } else if (utils.isDelayElement(line)) {
		        _this.introducedDelay = line.props.ms;
		        decoratedLine = '⏰';
		      }
	
		      return new Promise(function (resolve, reject) {
		        _this.setState({ textLines: _this.state.textLines.concat(['']) }, function () {
		          utils.eachPromise(decoratedLine, _this.typeCharacter, decoratedLine, lineIdx).then(function () {
		            return onLineTyped(decoratedLine, lineIdx);
		          }).then(resolve).catch(reject);
		        });
		      });
		    };
	
		    _this.typeCharacter = function (character, charIdx, line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
		      var onCharacterTyped = _this.props.onCharacterTyped;
	
	
		      return new Promise(function (resolve) {
		        var textLines = _this.state.textLines.slice();
	
		        utils.sleep(_this.introducedDelay).then(function () {
		          _this.introducedDelay = null;
	
		          var isBackspace = character === '🔙';
		          var isDelay = character === '⏰';
		          if (isDelay) {
		            resolve();
		            return;
		          }
	
		          if (isBackspace && lineIdx > 0) {
		            var prevLineIdx = lineIdx - 1;
		            var prevLine = textLines[prevLineIdx];
	
		            for (var idx = prevLineIdx; idx >= 0; idx--) {
		              if (prevLine.length > 0 && !ACTION_CHARS.includes(prevLine[0])) {
		                break;
		              }
		              prevLineIdx = idx;
		              prevLine = textLines[prevLineIdx];
		            }
	
		            textLines[prevLineIdx] = prevLine.substr(0, prevLine.length - 1);
		          } else {
		            textLines[lineIdx] += character;
		          }
	
		          _this.setState({ textLines: textLines }, function () {
		            var delay = _this.delayGenerator(line, lineIdx, character, charIdx);
		            onCharacterTyped(character, charIdx);
		            setTimeout(resolve, delay);
		          });
		        });
		      });
		    };
	
		    _this.mounted = false;
		    _this.linesToType = [];
		    _this.introducedDelay = null;
	
		    if (props.children) {
		      _this.linesToType = utils.extractTextFromElement(props.children);
		    }
		    return _this;
		  }
	
		  _createClass(Typist, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.mounted = true;
		      var _props = this.props,
		          children = _props.children,
		          startDelay = _props.startDelay;
	
		      if (children) {
		        if (startDelay > 0 && typeof window !== 'undefined') {
		          setTimeout(this.typeAllLines.bind(this), startDelay);
		        } else {
		          this.typeAllLines();
		        }
		      } else {
		        this.onTypingDone();
		      }
		    }
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function shouldComponentUpdate(nextProps, nextState) {
		      if (nextState.textLines.length !== this.state.textLines.length) {
		        return true;
		      }
		      for (var idx = 0; idx < nextState.textLines.length; idx++) {
		        var line = this.state.textLines[idx];
		        var nextLine = nextState.textLines[idx];
		        if (line !== nextLine) {
		          return true;
		        }
		      }
		      return this.state.isDone !== nextState.isDone;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.mounted = false;
		    }
		  }, {
		    key: 'typeAllLines',
		    value: function typeAllLines() {
		      var _this2 = this;
	
		      var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.linesToType;
	
		      return utils.eachPromise(lines, this.typeLine).then(function () {
		        return _this2.onTypingDone();
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props2 = this.props,
		          className = _props2.className,
		          cursor = _props2.cursor;
		      var isDone = this.state.isDone;
	
		      var innerTree = utils.cloneElementWithSpecifiedText({
		        element: this.props.children,
		        textLines: this.state.textLines
		      });
	
		      return _react2.default.createElement(
		        'div',
		        { className: 'Typist ' + className },
		        innerTree,
		        _react2.default.createElement(_Cursor2.default, _extends({ isDone: isDone }, cursor))
		      );
		    }
		  }]);
	
		  return Typist;
		}(_react.Component);
	
		Typist.propTypes = {
		  children: _propTypes2.default.node,
		  className: _propTypes2.default.string,
		  avgTypingDelay: _propTypes2.default.number,
		  stdTypingDelay: _propTypes2.default.number,
		  startDelay: _propTypes2.default.number,
		  cursor: _propTypes2.default.object,
		  onCharacterTyped: _propTypes2.default.func,
		  onLineTyped: _propTypes2.default.func,
		  onTypingDone: _propTypes2.default.func,
		  delayGenerator: _propTypes2.default.func
		};
		Typist.defaultProps = {
		  className: '',
		  avgTypingDelay: 70,
		  stdTypingDelay: 25,
		  startDelay: 0,
		  cursor: {},
		  onCharacterTyped: function onCharacterTyped() {},
		  onLineTyped: function onLineTyped() {},
		  onTypingDone: function onTypingDone() {},
		  delayGenerator: utils.gaussianRnd
		};
		exports.default = Typist;
	
	
		Typist.Backspace = _Backspace2.default;
		Typist.Delay = _Delay2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		if (false) {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(3)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(9)();
		}
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var warning = __webpack_require__(6);
	
		var ReactPropTypesSecret = __webpack_require__(7);
		var checkPropTypes = __webpack_require__(8);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if (false) {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (false) {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (false) {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (false) {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
	
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
	
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
	
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
	
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
	
		module.exports = warning;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		if (false) {
		  var invariant = __webpack_require__(5);
		  var warning = __webpack_require__(6);
		  var ReactPropTypesSecret = __webpack_require__(7);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (false) {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var ReactPropTypesSecret = __webpack_require__(7);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		__webpack_require__(11);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Cursor = function (_Component) {
		  _inherits(Cursor, _Component);
	
		  function Cursor(props) {
		    _classCallCheck(this, Cursor);
	
		    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, props));
	
		    _this._isReRenderingCursor = false;
		    _this.state = {
		      shouldRender: _this.props.show
		    };
		    return _this;
		  }
	
		  _createClass(Cursor, [{
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps) {
		      var _this2 = this;
	
		      var shouldHide = !this.props.isDone && nextProps.isDone && this.props.hideWhenDone;
		      if (shouldHide) {
		        setTimeout(function () {
		          return _this2.setState({ shouldRender: false });
		        }, this.props.hideWhenDoneDelay);
		      }
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate() {
		      var _props = this.props,
		          show = _props.show,
		          isDone = _props.isDone;
	
		      if (!show) {
		        return;
		      }
		      if (isDone) {
		        return;
		      }
		      if (this._isReRenderingCursor) {
		        return;
		      }
	
		      // In webkit and blink, rendering the cursor alongside the text as it
		      // animates sometimes causes the text to stop rendering when it reaches
		      // a new line break, even though the underlying DOM /does/ contain
		      // the text. This seems to happen when the space available for the text is
		      // at a specific width that makes it so the line break happens within a
		      // word.
		      // Using dev tools, when in this state, if you modify the dom or any style,
		      // it immediately renders all of the text in its correct position.
		      // Given that observation, this is a hackish solutions that re-renders the
		      // cursor every time a character is rendered, just to ensure that the text
		      // is rendered correctly.
		      // See #13 and #15 for more details
		      this._reRenderCursor();
		    }
		  }, {
		    key: '_reRenderCursor',
		    value: function _reRenderCursor() {
		      var _this3 = this;
	
		      this._isReRenderingCursor = true;
		      this.setState({ shouldRender: false }, function () {
		        _this3.setState({ shouldRender: true }, function () {
		          _this3._isReRenderingCursor = false;
		        });
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      if (this.state.shouldRender) {
		        var className = this.props.blink ? ' Cursor--blinking' : '';
		        return _react2.default.createElement(
		          'span',
		          { className: 'Cursor' + className },
		          this.props.element
		        );
		      }
		      return null;
		    }
		  }]);
	
		  return Cursor;
		}(_react.Component);
	
		Cursor.propTypes = {
		  blink: _propTypes2.default.bool,
		  show: _propTypes2.default.bool,
		  element: _propTypes2.default.node,
		  hideWhenDone: _propTypes2.default.bool,
		  hideWhenDoneDelay: _propTypes2.default.number,
		  isDone: _propTypes2.default.bool
		};
		Cursor.defaultProps = {
		  blink: true,
		  show: true,
		  element: '|',
		  hideWhenDone: false,
		  hideWhenDoneDelay: 1000,
		  isDone: false
		};
		exports.default = Cursor;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Backspace = function Backspace() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Backspace.componentName = 'Backspace';
	
		Backspace.propTypes = {
		  count: _propTypes2.default.number,
		  delay: _propTypes2.default.number
		};
	
		Backspace.defaultProps = {
		  count: 1,
		  delay: 0
		};
	
		exports.default = Backspace;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Delay = function Delay() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Delay.componentName = 'Delay';
	
		Delay.propTypes = {
		  ms: _propTypes2.default.number.isRequired
		};
	
		exports.default = Delay;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.sleep = undefined;
	
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
		exports.gaussianRnd = gaussianRnd;
		exports.eachPromise = eachPromise;
		exports.exclude = exclude;
		exports.isBackspaceElement = isBackspaceElement;
		exports.isDelayElement = isDelayElement;
		exports.extractTextFromElement = extractTextFromElement;
		exports.cloneElement = cloneElement;
		exports.cloneElementWithSpecifiedText = cloneElementWithSpecifiedText;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		var sleep = exports.sleep = function sleep(val) {
		  return new Promise(function (resolve) {
		    return val != null ? setTimeout(resolve, val) : resolve();
		  });
		};
	
		function gaussianRnd(mean, std) {
		  var times = 12;
		  var sum = 0;
		  for (var idx = 0; idx < times; idx++) {
		    sum += Math.random();
		  }
		  sum -= times / 2;
		  return Math.round(sum * std) + mean;
		}
	
		function eachPromise(arr, iterator) {
		  for (var _len = arguments.length, extraArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		    extraArgs[_key - 2] = arguments[_key];
		  }
	
		  var promiseReducer = function promiseReducer(prev, current, idx) {
		    return prev.then(function () {
		      return iterator.apply(undefined, [current, idx].concat(extraArgs));
		    });
		  };
		  return Array.from(arr).reduce(promiseReducer, Promise.resolve());
		}
	
		function exclude(obj, keys) {
		  var res = {};
		  for (var key in obj) {
		    if (keys.indexOf(key) === -1) {
		      res[key] = obj[key];
		    }
		  }
		  return res;
		}
	
		function isBackspaceElement(element) {
		  return element && element.type && element.type.componentName === 'Backspace';
		}
	
		function isDelayElement(element) {
		  return element && element.type && element.type.componentName === 'Delay';
		}
	
		function extractTextFromElement(element) {
		  var stack = element ? [element] : [];
		  var lines = [];
	
		  while (stack.length > 0) {
		    var current = stack.pop();
		    if (_react2.default.isValidElement(current)) {
		      if (isBackspaceElement(current) || isDelayElement(current)) {
		        // If it is a `Backspace` or `Delay` element, we want to keep it in our
		        // `textLines` state. These will serve as markers when updating the
		        // state of the text
		        lines.unshift(current);
		      } else {
		        _react2.default.Children.forEach(current.props.children, function (child) {
		          stack.push(child);
		        });
		      }
		    } else if (Array.isArray(current)) {
		      var _iteratorNormalCompletion = true;
		      var _didIteratorError = false;
		      var _iteratorError = undefined;
	
		      try {
		        for (var _iterator = current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		          var el = _step.value;
	
		          stack.push(el);
		        }
		      } catch (err) {
		        _didIteratorError = true;
		        _iteratorError = err;
		      } finally {
		        try {
		          if (!_iteratorNormalCompletion && _iterator.return) {
		            _iterator.return();
		          }
		        } finally {
		          if (_didIteratorError) {
		            throw _iteratorError;
		          }
		        }
		      }
		    } else {
		      lines.unshift(current);
		    }
		  }
	
		  return lines;
		}
	
		function cloneElement(element, children) {
		  var tag = element.type;
		  var props = exclude(element.props, ['children']);
		  var getMilliseconds = new Date().getUTCMilliseconds();
		  var randomStamp = getMilliseconds + Math.random() + Math.random();
		  // eslint-disable-next-line
		  props.key = 'Typist-element-' + tag + '-' + randomStamp;
		  return _react2.default.createElement.apply(_react2.default, [tag, props].concat(_toConsumableArray(children)));
		}
	
		function cloneElementWithSpecifiedTextAtIndex(element, textLines, textIdx) {
		  if (textIdx >= textLines.length) {
		    return [null, textIdx];
		  }
	
		  var idx = textIdx;
		  var recurse = function recurse(el) {
		    var _cloneElementWithSpec = cloneElementWithSpecifiedTextAtIndex(el, textLines, idx),
		        _cloneElementWithSpec2 = _slicedToArray(_cloneElementWithSpec, 2),
		        child = _cloneElementWithSpec2[0],
		        advIdx = _cloneElementWithSpec2[1];
	
		    idx = advIdx;
		    return child;
		  };
	
		  var isNonTypistElement = _react2.default.isValidElement(element) && !(isBackspaceElement(element) || isDelayElement(element));
	
		  if (isNonTypistElement) {
		    var clonedChildren = _react2.default.Children.map(element.props.children, recurse) || [];
		    return [cloneElement(element, clonedChildren), idx];
		  }
	
		  if (Array.isArray(element)) {
		    var children = element.map(recurse);
		    return [children, idx];
		  }
	
		  // Anything that isn't a React element or an Array is interpreted as text
		  return [textLines[idx], idx + 1];
		}
	
		function cloneElementWithSpecifiedText(_ref) {
		  var element = _ref.element,
		      textLines = _ref.textLines;
	
		  if (!element) {
		    return undefined;
		  }
	
		  return cloneElementWithSpecifiedTextAtIndex(element, textLines, 0)[0];
		}
	
	/***/ })
	/******/ ]);

/***/ },
/* 2413 */
521,
/* 2414 */
[2798, 293],
/* 2415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2414);
	var ReactElement = __webpack_require__(245);
	
	var emptyFunction = __webpack_require__(132);
	var traverseAllChildren = __webpack_require__(2424);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 2416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(245);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 2417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(245),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(881);
	
	module.exports = factory(isValidElement);

/***/ },
/* 2418 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(1003),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(245),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(1006);
	var factory = __webpack_require__(664);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 2420 */
2369,
/* 2421 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 2423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(293);
	
	var ReactElement = __webpack_require__(245);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(293);
	
	var ReactCurrentOwner = __webpack_require__(148);
	var REACT_ELEMENT_TYPE = __webpack_require__(1005);
	
	var getIteratorFn = __webpack_require__(2420);
	var invariant = __webpack_require__(29);
	var KeyEscapeUtils = __webpack_require__(2413);
	var warning = __webpack_require__(39);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(666));
	
	var _utils = __webpack_require__(1008);
	
	var _arithmetic = _interopRequireDefault(__webpack_require__(2427));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max; // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Decimal} roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Decimal} The step which is easy to understand between two ticks
	 */
	
	
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep.lte(0)) {
	    return new _decimal.default(0);
	  }
	
	  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	
	
	  var digitCountValue = new _decimal.default(10).pow(digitCount);
	  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
	
	  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
	  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
	  var formatStep = amendStepRatio.mul(digitCountValue);
	  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
	}
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	
	
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var step = 1; // calculate the middle value of ticks
	
	  var middle = new _decimal.default(value);
	
	  if (!middle.isint() && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
	      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = new _decimal.default(Math.floor(value));
	    }
	  } else if (value === 0) {
	    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
	  } else if (!allowDecimals) {
	    middle = new _decimal.default(Math.floor(value));
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
	  }), _utils.range);
	  return fn(0, tickCount);
	}
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	
	
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // dirty hack (for recharts' test)
	  if (!Number.isFinite((max - min) / (tickCount - 1))) {
	    return {
	      step: new _decimal.default(0),
	      tickMin: new _decimal.default(0),
	      tickMax: new _decimal.default(0)
	    };
	  } // The step which is easy to understand between two ticks
	
	
	  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
	
	  var middle; // When 0 is inside the interval, 0 should be a tick
	
	  if (min <= 0 && max >= 0) {
	    middle = new _decimal.default(0);
	  } else {
	    // calculate the middle value
	    middle = new _decimal.default(min).add(max).div(2); // minus modulo value
	
	    middle = middle.sub(new _decimal.default(middle).mod(step));
	  }
	
	  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
	  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  }
	
	  if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
	    tickMax: middle.add(new _decimal.default(upCount).mul(step))
	  };
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks will be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return Infinity;
	    }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return -Infinity;
	    })), [cormax]);
	
	    return min > max ? (0, _utils.reverse)(_values) : _values;
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  } // Get the step between two ticks
	
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
	  }), _utils.range);
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
	 * but the domain will be guaranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)), [cormax]);
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	exports.getNiceTickValues = getNiceTickValues;
	var getTickValues = (0, _utils.memoize)(getTickValuesFn);
	exports.getTickValues = getTickValues;
	var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);
	exports.getTickValuesFixedDomain = getTickValuesFixedDomain;

/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, "getNiceTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, "getTickValuesFixedDomain", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});
	
	var _getNiceTickValues = __webpack_require__(2425);

/***/ },
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(666));
	
	var _utils = __webpack_require__(1008);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var result;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(new _decimal.default(value).abs().log(10).toNumber()) + 1;
	  }
	
	  return result;
	}
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Decimal} start 起点
	 * @param  {Decimal} end   终点，不包含该值
	 * @param  {Decimal} step  步长
	 * @return {Array}         若干数值
	 */
	
	
	function rangeStep(start, end, step) {
	  var num = new _decimal.default(start);
	  var i = 0;
	  var result = []; // magic number to prevent infinite loop
	
	  while (num.lt(end) && i < 100000) {
	    result.push(num.toNumber());
	    num = num.add(step);
	    i++;
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	
	
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	var _default = {
	  rangeStep: rangeStep,
	  getDigitCount: getDigitCount,
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};
	exports.default = _default;

/***/ },
/* 2428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(CartesianGrid, _PureComponent);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: "renderHorizontal",
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	    value: function renderHorizontal(horizontalPoints) {
	      var _this = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          width = _this$props.width,
	          horizontal = _this$props.horizontal;
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this.constructor.renderLineItem(horizontal, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-horizontal"
	      }, items);
	    }
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: "renderVertical",
	    value: function renderVertical(verticalPoints) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          y = _this$props2.y,
	          height = _this$props2.height,
	          vertical = _this$props2.vertical;
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this2.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this2.constructor.renderLineItem(vertical, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-vertical"
	      }, items);
	    }
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: "renderVerticalStripes",
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          fillOpacity = _this$props3.fillOpacity,
	          x = _this$props3.x,
	          y = _this$props3.y,
	          width = _this$props3.width,
	          height = _this$props3.height;
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	
	        if (lineWidth <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % verticalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: "none",
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-vertical"
	      }, items);
	    }
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: "renderHorizontalStripes",
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          fillOpacity = _this$props4.fillOpacity,
	          x = _this$props4.x,
	          y = _this$props4.y,
	          width = _this$props4.width,
	          height = _this$props4.height;
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	
	        if (lineHeight <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % horizontalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: "none",
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-horizontal"
	      }, items);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          fillOpacity = _this$props5.fillOpacity,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      return _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: "none",
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: "recharts-cartesian-grid-bg"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          horizontal = _this$props6.horizontal,
	          vertical = _this$props6.vertical,
	          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
	          xAxis = _this$props6.xAxis,
	          yAxis = _this$props6.yAxis,
	          offset = _this$props6.offset,
	          chartWidth = _this$props6.chartWidth,
	          chartHeight = _this$props6.chartHeight;
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          horizontalPoints = _this$props7.horizontalPoints,
	          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction2["default"])(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({
	          yAxis: yAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      } // No vertical points are specified
	
	
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction2["default"])(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({
	          xAxis: xAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid"
	      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
	    }
	  }], [{
	    key: "renderLineItem",
	    value: function renderLineItem(option, props) {
	      var lineItem;
	
	      if (_react["default"].isValidElement(option)) {
	        lineItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);
	
	        lineItem = _react["default"].createElement("line", _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: "none",
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.PureComponent);
	
	CartesianGrid.displayName = 'CartesianGrid';
	CartesianGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  horizontal: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  vertical: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  horizontalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  verticalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  horizontalCoordinatesGenerator: _propTypes["default"].func,
	  verticalCoordinatesGenerator: _propTypes["default"].func,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  offset: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  verticalFill: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  horizontalFill: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	CartesianGrid.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	};
	var _default = CartesianGrid;
	exports["default"] = _default;

/***/ },
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Area = _interopRequireDefault(__webpack_require__(539));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(246));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(247));
	
	var _CartesianUtils = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Area Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Bar = _interopRequireDefault(__webpack_require__(540));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(246));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(247));
	
	var _CartesianUtils = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Area = _interopRequireDefault(__webpack_require__(539));
	
	var _Bar = _interopRequireDefault(__webpack_require__(540));
	
	var _Line = _interopRequireDefault(__webpack_require__(541));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(542));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(246));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(247));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(376));
	
	var _CartesianUtils = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Composed Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line["default"], _Area["default"], _Bar["default"], _Scatter["default"]],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Funnel = _interopRequireDefault(__webpack_require__(1014));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Funnel Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'FunnelChart',
	  GraphicalChild: _Funnel["default"],
	  eventType: 'item',
	  axisComponents: [],
	  defaultProps: {
	    layout: 'centric'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric'])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Line = _interopRequireDefault(__webpack_require__(541));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(246));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(247));
	
	var _CartesianUtils = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Line Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'LineChart',
	  GraphicalChild: _Line["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(378));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(379));
	
	var _PolarUtils = __webpack_require__(126);
	
	var _Pie = _interopRequireDefault(__webpack_require__(1015));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie["default"],
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Radar = _interopRequireDefault(__webpack_require__(1016));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(378));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(379));
	
	var _PolarUtils = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar["default"],
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(378));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(379));
	
	var _PolarUtils = __webpack_require__(126);
	
	var _RadialBar = _interopRequireDefault(__webpack_require__(1017));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar["default"],
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['radial']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _sumBy2 = _interopRequireDefault(__webpack_require__(2055));
	
	var _min2 = _interopRequireDefault(__webpack_require__(738));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(737));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Surface = _interopRequireDefault(__webpack_require__(295));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(377));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(250));
	
	var _ShallowEqual = __webpack_require__(384);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _ChartUtils = __webpack_require__(87);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultCoordinateOfTooltip = {
	  x: 0,
	  y: 0
	};
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return {
	    sourceNodes: sourceNodes,
	    sourceLinks: sourceLinks,
	    targetLinks: targetLinks,
	    targetNodes: targetNodes
	  };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	    return _objectSpread({}, entry, {}, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	
	  var maxDepth = (0, _maxBy2["default"])(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return {
	    tree: tree,
	    maxDepth: maxDepth
	  };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min2["default"])(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy2["default"])(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _objectSpread({}, link, {
	      dy: getValue(link) * yRatio
	    });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length; // Sort by the value of y
	
	    nodes.sort(ascendingY);
	    var y0 = 0;
	
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	  resolveCollisions(depthTree, height, nodePadding);
	  var alpha = 1;
	
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	    resolveCollisions(depthTree, height, nodePadding);
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	  return {
	    nodes: tree,
	    links: newLinks
	  };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return {
	      x: el.x + el.width / 2,
	      y: el.y + el.height / 2
	    };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	    return [{
	      payload: el,
	      name: "".concat(sourceName, " - ").concat(targetName),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sankey, _PureComponent);
	
	  function Sankey(props) {
	    var _this;
	
	    _classCallCheck(this, Sankey);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
	    _this.state = _this.constructor.createDefaultState(props);
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Sankey, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          height = _this$props.height,
	          margin = _this$props.margin,
	          iterations = _this$props.iterations,
	          nodeWidth = _this$props.nodeWidth,
	          nodePadding = _this$props.nodePadding,
	          nameKey = _this$props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.constructor.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(el, type, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(el, type, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(el, type, e) {
	      var onClick = this.props.onClick;
	      if (onClick) onClick(el, type, e);
	    }
	  }, {
	    key: "renderLinks",
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          linkCurvature = _this$props4.linkCurvature,
	          linkContent = _this$props4.link,
	          margin = _this$props4.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-links",
	        key: "recharts-sankey-links"
	      }, links.map(function (link, i) {
	        var sourceRelativeY = link.sy,
	            targetRelativeY = link.ty,
	            linkWidth = link.dy;
	        var source = nodes[link.source];
	        var target = nodes[link.target];
	        var sourceX = source.x + source.dx + left;
	        var targetX = target.x + left;
	        var interpolationFunc = interpolationGenerator(sourceX, targetX);
	        var sourceControlX = interpolationFunc(linkCurvature);
	        var targetControlX = interpolationFunc(1 - linkCurvature);
	        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	        var linkProps = _objectSpread({
	          sourceX: sourceX,
	          targetX: targetX,
	          sourceY: sourceY,
	          targetY: targetY,
	          sourceControlX: sourceControlX,
	          targetControlX: targetControlX,
	          sourceRelativeY: sourceRelativeY,
	          targetRelativeY: targetRelativeY,
	          linkWidth: linkWidth,
	          index: i,
	          payload: _objectSpread({}, link, {
	            source: source,
	            target: target
	          })
	        }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	
	        var events = {
	          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
	          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "link".concat(i)
	          }, events), _this2.constructor.renderLinkItem(linkContent, linkProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderNodes",
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          nodeContent = _this$props5.node,
	          margin = _this$props5.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-nodes",
	        key: "recharts-sankey-nodes"
	      }, nodes.map(function (node, i) {
	        var x = node.x,
	            y = node.y,
	            dx = node.dx,
	            dy = node.dy;
	
	        var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	          x: x + left,
	          y: y + top,
	          width: dx,
	          height: dy,
	          index: i,
	          payload: node
	        });
	
	        var events = {
	          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
	          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "node".concat(i)
	          }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props6 = this.props,
	          children = _this$props6.children,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          nameKey = _this$props6.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeElement = _this$state.activeElement,
	          activeElementType = _this$state.activeElementType;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          className = _this$props7.className,
	          style = _this$props7.style,
	          children = _this$props7.children,
	          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);
	
	      var _this$state2 = this.state,
	          links = _this$state2.links,
	          nodes = _this$state2.nodes;
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: height
	      }), (0, _ReactUtils.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations,
	        nodeWidth: nodeWidth,
	        nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes,
	        links: links
	      };
	    }
	  }, {
	    key: "renderLinkItem",
	    value: function renderLinkItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);
	
	      return _react["default"].createElement("path", _extends({
	        className: "recharts-sankey-link",
	        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
	        fill: "none",
	        stroke: "#333",
	        strokeWidth: linkWidth,
	        strokeOpacity: "0.2"
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: "renderNodeItem",
	    value: function renderNodeItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Rectangle["default"], _extends({
	        className: "recharts-sankey-node",
	        fill: "#0088fe",
	        fillOpacity: "0.8"
	      }, props));
	    }
	  }]);
	
	  return Sankey;
	}(_react.PureComponent);
	
	Sankey.displayName = 'Sankey';
	Sankey.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].shape({
	    nodes: _propTypes["default"].array,
	    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	      target: _propTypes["default"].number,
	      source: _propTypes["default"].number,
	      value: _propTypes["default"].number
	    }))
	  }),
	  nodePadding: _propTypes["default"].number,
	  nodeWidth: _propTypes["default"].number,
	  linkCurvature: _propTypes["default"].number,
	  iterations: _propTypes["default"].number,
	  node: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  link: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  style: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  })
	});
	Sankey.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: {
	    top: 5,
	    right: 5,
	    bottom: 5,
	    left: 5
	  }
	};
	var _default = Sankey;
	exports["default"] = _default;

/***/ },
/* 2438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(149));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(542));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(246));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(247));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(376));
	
	var _CartesianUtils = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter["default"],
	  eventType: 'single',
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(133));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(739));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(346));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(112));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Surface = _interopRequireDefault(__webpack_require__(295));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(250));
	
	var _ReactUtils = __webpack_require__(28);
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(377));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(380));
	
	var _ChartUtils = __webpack_require__(87);
	
	var _Constants = __webpack_require__(2446);
	
	var _DOMUtils = __webpack_require__(382);
	
	var _DataUtils = __webpack_require__(38);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({
	      depth: childDepth,
	      node: child,
	      index: i,
	      valueKey: valueKey
	    });
	  }) : null;
	  var value;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN2["default"])(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _objectSpread({}, node, {
	    children: computedChildren,
	    value: value,
	    depth: depth,
	    index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return {
	    x: node.x,
	    y: node.y,
	    width: node.width,
	    height: node.height
	  };
	}; // Compute the area for each child based on value & scale.
	
	
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	  return children.map(function (child) {
	    var area = child.value * ratio;
	    return _objectSpread({}, child, {
	      area: (0, _isNaN2["default"])(area) || area <= 0 ? 0 : area
	    });
	  });
	}; // Computes the score for the specified row, as the worst aspect ratio.
	
	
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, {
	    min: Infinity,
	    max: 0
	  }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  } // what's z
	
	
	  child.z = true; // add the remain x to the last one of row
	
	  child.width += parentRect.x + parentRect.width - curX;
	  return _objectSpread({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	  return _objectSpread({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	}; // Recursively arranges the specified node's children into squarified rows.
	
	
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	
	    var child, score; // the current row score
	
	    var size = Math.min(rect.width, rect.height); // initial orientation
	
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      // eslint-disable-next-line prefer-destructuring
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	      score = getWorstScore(row, size, aspectRatio);
	
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _objectSpread({}, node, {
	      children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      })
	    });
	  }
	
	  return node;
	};
	
	var Treemap =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Treemap, _PureComponent);
	
	  function Treemap() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = _this.constructor.createDefaultState();
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          width = _this$props.width,
	          height = _this$props.height,
	          data = _this$props.data,
	          dataKey = _this$props.dataKey,
	          aspectRatio = _this$props.aspectRatio;
	
	      var _this$computeRoot = this.computeRoot({
	        type: type,
	        width: width,
	        height: height,
	        data: data,
	        dataKey: dataKey,
	        aspectRatio: aspectRatio
	      }),
	          formatRoot = _this$computeRoot.formatRoot,
	          currentRoot = _this$computeRoot.currentRoot,
	          nestIndex = _this$computeRoot.nestIndex;
	
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: currentRoot,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "computeRoot",
	    value: function computeRoot(_ref2) {
	      var type = _ref2.type,
	          width = _ref2.width,
	          height = _ref2.height,
	          data = _ref2.data,
	          dataKey = _ref2.dataKey,
	          aspectRatio = _ref2.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: {
	          children: data,
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        },
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      var nestIndex = this.state.nestIndex;
	
	      if (type === 'nest') {
	        nestIndex.push(root);
	      }
	
	      return {
	        formatRoot: formatRoot,
	        currentRoot: root,
	        nestIndex: nestIndex
	      };
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var type = nextProps.type,
	          width = nextProps.width,
	          height = nextProps.height,
	          data = nextProps.data,
	          dataKey = nextProps.dataKey,
	          aspectRatio = nextProps.aspectRatio;
	
	      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
	        var nextRoot = this.computeRoot({
	          type: type,
	          width: width,
	          height: height,
	          data: data,
	          dataKey: dataKey,
	          aspectRatio: aspectRatio
	        });
	        this.setState(_objectSpread({}, this.constructor.createDefaultState(), {}, nextRoot, {
	          nestIndex: [nextRoot.currentRoot]
	        }));
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(node, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(node, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(node) {
	      var _this$props4 = this.props,
	          onClick = _this$props4.onClick,
	          type = _this$props4.type;
	
	      if (type === 'nest' && node.children) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height,
	            dataKey = _this$props5.dataKey,
	            aspectRatio = _this$props5.aspectRatio;
	        var root = computeNode({
	          depth: 0,
	          node: _objectSpread({}, node, {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }),
	          index: 0,
	          valueKey: dataKey
	        });
	        var formatRoot = squarify(root, aspectRatio);
	        var nestIndex = this.state.nestIndex;
	        nestIndex.push(node);
	        this.setState({
	          formatRoot: formatRoot,
	          currentRoot: root,
	          nestIndex: nestIndex
	        });
	      }
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: "handleNestIndex",
	    value: function handleNestIndex(node, i) {
	      var nestIndex = this.state.nestIndex;
	      var _this$props6 = this.props,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          dataKey = _this$props6.dataKey,
	          aspectRatio = _this$props6.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: _objectSpread({}, node, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        }),
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      nestIndex = nestIndex.slice(0, i + 1);
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: node,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "renderItem",
	    value: function renderItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _this$props7 = this.props,
	          isAnimationActive = _this$props7.isAnimationActive,
	          animationBegin = _this$props7.animationBegin,
	          animationDuration = _this$props7.animationDuration,
	          animationEasing = _this$props7.animationEasing,
	          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
	          type = _this$props7.type,
	          animationId = _this$props7.animationId,
	          colorPanel = _this$props7.colorPanel;
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y,
	          depth = nodeProps.depth;
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf || type === 'nest') {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      if (!isAnimationActive) {
	        return _react["default"].createElement(_Layer["default"], event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	          isAnimationActive: false,
	          isUpdateAnimationActive: false,
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        }), type, colorPanel));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        key: "treemap-".concat(animationId),
	        from: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        to: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref3) {
	        var currX = _ref3.x,
	            currY = _ref3.y,
	            currWidth = _ref3.width,
	            currHeight = _ref3.height;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
	          to: "translate(0, 0)",
	          attributeName: "transform",
	          begin: animationBegin,
	          easing: animationEasing,
	          isActive: isAnimationActive,
	          duration: animationDuration
	        }, _react["default"].createElement(_Layer["default"], event, function () {
	          // when animation Duration , only render depth=1 nodes
	          if (depth > 2 && !isAnimationFinished) {
	            return null;
	          }
	
	          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	            isAnimationActive: isAnimationActive,
	            isUpdateAnimationActive: !isUpdateAnimationActive,
	            width: currWidth,
	            height: currHeight,
	            x: currX,
	            y: currY
	          }), type, colorPanel);
	        }()));
	      });
	    }
	  }, {
	    key: "renderNode",
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var _this$props8 = this.props,
	          content = _this$props8.content,
	          type = _this$props8.type;
	
	      var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, node, {
	        root: root
	      });
	
	      var isLeaf = !node.children || !node.children.length;
	      var currentRoot = this.state.currentRoot;
	      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
	        return item.depth === node.depth && item.name === node.name;
	      });
	
	      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
	        return null;
	      }
	
	      return (// eslint-disable-next-line react/no-array-index-key
	        _react["default"].createElement(_Layer["default"], {
	          key: "recharts-treemap-node-".concat(i),
	          className: "recharts-treemap-depth-".concat(node.depth)
	        }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null)
	      );
	    }
	  }, {
	    key: "renderAllNodes",
	    value: function renderAllNodes() {
	      var formatRoot = this.state.formatRoot;
	
	      if (!formatRoot) {
	        return null;
	      }
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props9 = this.props,
	          children = _this$props9.children,
	          nameKey = _this$props9.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$props10 = this.props,
	          width = _this$props10.width,
	          height = _this$props10.height,
	          dataKey = _this$props10.dataKey;
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeNode = _this$state.activeNode;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    } // render nest treemap
	
	  }, {
	    key: "renderNestIndex",
	    value: function renderNestIndex() {
	      var _this4 = this;
	
	      var _this$props11 = this.props,
	          nameKey = _this$props11.nameKey,
	          nestIndexContent = _this$props11.nestIndexContent;
	      var nestIndex = this.state.nestIndex;
	      return _react["default"].createElement("div", {
	        className: "recharts-treemap-nest-index-wrapper",
	        style: {
	          marginTop: '8px',
	          textAlign: 'center'
	        }
	      }, nestIndex.map(function (item, i) {
	        var name = (0, _get2["default"])(item, nameKey, 'root');
	        var content = null;
	
	        if (_react["default"].isValidElement(nestIndexContent)) {
	          content = _react["default"].cloneElement(nestIndexContent, item, i);
	        }
	
	        if ((0, _isFunction2["default"])(nestIndexContent)) {
	          content = nestIndexContent(item, i);
	        } else {
	          content = name;
	        }
	
	        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
	          _react["default"].createElement("div", {
	            onClick: _this4.handleNestIndex.bind(_this4, item, i),
	            key: "nest-index-".concat((0, _DataUtils.uniqueId)()),
	            className: "recharts-treemap-nest-index-box",
	            style: {
	              cursor: 'pointer',
	              display: 'inline-block',
	              padding: '0 7px',
	              background: '#000',
	              color: '#fff',
	              marginRight: '3px'
	            }
	          }, content)
	        );
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props12 = this.props,
	          width = _this$props12.width,
	          height = _this$props12.height,
	          className = _this$props12.className,
	          style = _this$props12.style,
	          children = _this$props12.children,
	          type = _this$props12.type,
	          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: type === 'nest' ? height - 30 : height
	      }), this.renderAllNodes(), (0, _ReactUtils.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        isAnimationFinished: false,
	        activeNode: null,
	        currentRoot: null,
	        formatRoot: null,
	        nestIndex: []
	      };
	    }
	  }, {
	    key: "renderContentItem",
	    value: function renderContentItem(content, nodeProps, type, colorPanel) {
	      if (_react["default"].isValidElement(content)) {
	        return _react["default"].cloneElement(content, nodeProps);
	      }
	
	      if ((0, _isFunction2["default"])(content)) {
	        return content(nodeProps);
	      } // optimize default shape
	
	
	      var x = nodeProps.x,
	          y = nodeProps.y,
	          width = nodeProps.width,
	          height = nodeProps.height,
	          index = nodeProps.index;
	      var arrow = null;
	
	      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
	        arrow = _react["default"].createElement(_Polygon["default"], {
	          points: [{
	            x: x + 2,
	            y: y + height / 2
	          }, {
	            x: x + 6,
	            y: y + height / 2 + 3
	          }, {
	            x: x + 2,
	            y: y + height / 2 + 6
	          }]
	        });
	      }
	
	      var text = null;
	      var nameSize = (0, _DOMUtils.getStringSize)(nodeProps.name);
	
	      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
	        text = _react["default"].createElement("text", {
	          x: x + 8,
	          y: y + height / 2 + 7,
	          fontSize: 14
	        }, nodeProps.name);
	      }
	
	      var colors = colorPanel || _Constants.COLOR_PANEL;
	      return _react["default"].createElement("g", null, _react["default"].createElement(_Rectangle["default"], _extends({
	        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
	        stroke: "#fff"
	      }, (0, _omit2["default"])(nodeProps, 'children'))), arrow, text);
	    }
	  }]);
	
	  return Treemap;
	}(_react.PureComponent);
	
	Treemap.displayName = 'Treemap';
	Treemap.propTypes = {
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].array,
	  animationId: _propTypes["default"].number,
	  style: _propTypes["default"].object,
	  aspectRatio: _propTypes["default"].number,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
	  type: _propTypes["default"].oneOf(['flat', 'nest']),
	  colorPanel: _propTypes["default"].array,
	  // customize nest index content
	  nestIndexContent: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	};
	Treemap.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear',
	  type: 'flat'
	};
	var _default = Treemap;
	exports["default"] = _default;

/***/ },
/* 2440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Customized;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Layer = _interopRequireDefault(__webpack_require__(54));
	
	var _LogUtils = __webpack_require__(251);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	/**
	 * custom svg elements by rechart instance props and state.
	 * @returns {Object}   svg elements
	 */
	function Customized(_ref) {
	  var component = _ref.component,
	      props = _objectWithoutProperties(_ref, ["component"]);
	
	  var child;
	
	  if ((0, _react.isValidElement)(component)) {
	    child = (0, _react.cloneElement)(component, props);
	  } else if ((0, _isFunction2["default"])(component)) {
	    child = component(props);
	  } else {
	    (0, _LogUtils.warn)(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-customized-wrapper"
	  }, child);
	}
	
	Customized.displayName = 'Customized';
	Customized.propTypes = {
	  component: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]).isRequired
	};

/***/ },
/* 2441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Surface = _interopRequireDefault(__webpack_require__(295));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(544));
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SIZE = 32;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultLegendContent, _PureComponent);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: "renderIcon",
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react["default"].createElement("line", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'line') {
	        return _react["default"].createElement("path", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'rect') {
	        return _react["default"].createElement("path", {
	          stroke: "none",
	          fill: color,
	          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      return _react["default"].createElement(_Symbols["default"], {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: "diameter",
	        type: data.type
	      });
	    }
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this = this;
	
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          iconSize = _this$props.iconSize,
	          layout = _this$props.layout,
	          formatter = _this$props.formatter;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: SIZE,
	        height: SIZE
	      };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = {
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        marginRight: 4
	      };
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames["default"])((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react["default"].createElement("li", _extends({
	          className: className,
	          style: itemStyle,
	          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _react["default"].createElement(_Surface["default"], {
	          width: iconSize,
	          height: iconSize,
	          viewBox: viewBox,
	          style: svgStyle
	        }, _this.renderIcon(entry)), _react["default"].createElement("span", {
	          className: "recharts-legend-item-text"
	        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          layout = _this$props2.layout,
	          align = _this$props2.align;
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	      return _react["default"].createElement("ul", {
	        className: "recharts-default-legend",
	        style: finalStyle
	      }, this.renderItems());
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.PureComponent);
	
	DefaultLegendContent.displayName = 'Legend';
	DefaultLegendContent.propTypes = {
	  content: _propTypes["default"].element,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	};
	DefaultLegendContent.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	};
	var _default = DefaultLegendContent;
	exports["default"] = _default;

/***/ },
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(235));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(40));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _DataUtils = __webpack_require__(38);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray2["default"])(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultTooltipContent, _PureComponent);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          separator = _this$props.separator,
	          formatter = _this$props.formatter,
	          itemStyle = _this$props.itemStyle,
	          itemSorter = _this$props.itemSorter;
	
	      if (payload && payload.length) {
	        var listStyle = {
	          padding: 0,
	          margin: 0
	        };
	        var items = (itemSorter ? (0, _sortBy2["default"])(payload, itemSorter) : payload).map(function (entry, i) {
	          if (entry.type === 'none') {
	            return null;
	          }
	
	          var finalItemStyle = _objectSpread({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	          var name = entry.name,
	              value = entry.value;
	
	          if (finalFormatter) {
	            var formatted = finalFormatter(value, name, entry, i);
	
	            if (Array.isArray(formatted)) {
	              var _formatted = _slicedToArray(formatted, 2);
	
	              value = _formatted[0];
	              name = _formatted[1];
	            } else {
	              value = formatted;
	            }
	          }
	
	          return (// eslint-disable-next-line react/no-array-index-key
	            _react["default"].createElement("li", {
	              className: "recharts-tooltip-item",
	              key: "tooltip-item-".concat(i),
	              style: finalItemStyle
	            }, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-name"
	            }, name) : null, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-separator"
	            }, separator) : null, _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-value"
	            }, value), _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-unit"
	            }, entry.unit || ''))
	          );
	        });
	        return _react["default"].createElement("ul", {
	          className: "recharts-tooltip-item-list",
	          style: listStyle
	        }, items);
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperClassName = _this$props2.wrapperClassName,
	          contentStyle = _this$props2.contentStyle,
	          labelClassName = _this$props2.labelClassName,
	          labelStyle = _this$props2.labelStyle,
	          label = _this$props2.label,
	          labelFormatter = _this$props2.labelFormatter;
	
	      var finalStyle = _objectSpread({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, contentStyle);
	
	      var finalLabelStyle = _objectSpread({
	        margin: 0
	      }, labelStyle);
	
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	      var wrapperCN = (0, _classnames["default"])('recharts-default-tooltip', wrapperClassName);
	      var labelCN = (0, _classnames["default"])('recharts-tooltip-label', labelClassName);
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react["default"].createElement("div", {
	        className: wrapperCN,
	        style: finalStyle
	      }, _react["default"].createElement("p", {
	        className: labelCN,
	        style: finalLabelStyle
	      }, finalLabel), this.renderContent());
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.PureComponent);
	
	DefaultTooltipContent.displayName = 'DefaultTooltipContent';
	DefaultTooltipContent.propTypes = {
	  separator: _propTypes["default"].string,
	  wrapperClassName: _propTypes["default"].string,
	  labelClassName: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  contentStyle: _propTypes["default"].object,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  labelFormatter: _propTypes["default"].func,
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any
	  })),
	  itemSorter: _propTypes["default"].func
	};
	DefaultTooltipContent.defaultProps = {
	  separator: ' : ',
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {}
	};
	var _default = DefaultTooltipContent;
	exports["default"] = _default;

/***/ },
/* 2443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _debounce2 = _interopRequireDefault(__webpack_require__(732));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactResizeDetector = _interopRequireDefault(__webpack_require__(2387));
	
	var _DataUtils = __webpack_require__(38);
	
	var _LogUtils = __webpack_require__(251);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ResponsiveContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    var _this;
	
	    _classCallCheck(this, ResponsiveContainer);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({
	            containerWidth: containerWidth,
	            containerHeight: containerHeight
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	    _this.handleResize = props.debounce > 0 ? (0, _debounce2["default"])(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "getContainerSize",
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$state2 = this.state,
	          containerWidth = _this$state2.containerWidth,
	          containerHeight = _this$state2.containerHeight;
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _this$props = this.props,
	          aspect = _this$props.aspect,
	          width = _this$props.width,
	          height = _this$props.height,
	          minWidth = _this$props.minWidth,
	          minHeight = _this$props.minHeight,
	          maxHeight = _this$props.maxHeight,
	          children = _this$props.children;
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        if (calculatedWidth) {
	          // Will default to using width for aspect ratio
	          calculatedHeight = calculatedWidth / aspect;
	        } else if (calculatedHeight) {
	          // But we should also take height into consideration
	          calculatedWidth = calculatedHeight * aspect;
	        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	
	
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	      return _react["default"].cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          minWidth = _this$props2.minWidth,
	          minHeight = _this$props2.minHeight,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          maxHeight = _this$props2.maxHeight,
	          id = _this$props2.id,
	          className = _this$props2.className;
	      var style = {
	        width: width,
	        height: height,
	        minWidth: minWidth,
	        minHeight: minHeight,
	        maxHeight: maxHeight
	      };
	      return _react["default"].createElement("div", {
	        id: id,
	        className: (0, _classnames["default"])('recharts-responsive-container', className),
	        style: style,
	        ref: function ref(node) {
	          _this2.container = node;
	        }
	      }, this.renderChart(), _react["default"].createElement(_reactResizeDetector["default"], {
	        handleWidth: true,
	        handleHeight: true,
	        onResize: this.handleResize
	      }));
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component);
	
	ResponsiveContainer.displayName = 'ResponsiveContainer';
	ResponsiveContainer.propTypes = {
	  aspect: _propTypes["default"].number,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  children: _propTypes["default"].node.isRequired,
	  debounce: _propTypes["default"].number,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	};
	ResponsiveContainer.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	};
	var _default = ResponsiveContainer;
	exports["default"] = _default;

/***/ },
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _PolarUtils = __webpack_require__(126);
	
	var _ReactUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarGrid, _PureComponent);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: "getPolygonPath",
	    value: function getPolygonPath(radius) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          polarAngles = _this$props.polarAngles;
	      var path = '';
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += "L ".concat(point.x, ",").concat(point.y);
	        } else {
	          path += "M ".concat(point.x, ",").concat(point.y);
	        }
	      });
	      path += 'Z';
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: "renderPolarAngles",
	    value: function renderPolarAngles() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          innerRadius = _this$props2.innerRadius,
	          outerRadius = _this$props2.outerRadius,
	          polarAngles = _this$props2.polarAngles;
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-angle"
	      }, polarAngles.map(function (entry, i) {
	        var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	        var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	        return _react["default"].createElement("line", _extends({}, props, {
	          key: "line-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x1: start.x,
	          y1: start.y,
	          x2: end.x,
	          y2: end.y
	        }));
	      }));
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: "renderConcentricCircle",
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy;
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("circle", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-circle",
	        key: "circle-".concat(index),
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: "renderConcentricPolygon",
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("path", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-polygon",
	        key: "path-".concat(index),
	        d: this.getPolygonPath(radius)
	      }));
	    }
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: "renderConcentricPath",
	    value: function renderConcentricPath() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          polarRadius = _this$props4.polarRadius,
	          gridType = _this$props4.gridType;
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-concentric"
	      }, polarRadius.map(function (entry, i) {
	        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid"
	      }, this.renderPolarAngles(), this.renderConcentricPath());
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.PureComponent);
	
	PolarGrid.displayName = 'PolarGrid';
	PolarGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  polarAngles: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  polarRadius: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  gridType: _propTypes["default"].oneOf(['polygon', 'circle'])
	});
	PolarGrid.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	};
	var _default = PolarGrid;
	exports["default"] = _default;

/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(2450);
	
	__webpack_require__(2451);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 2446 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COLOR_PANEL = void 0;
	var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];
	exports.COLOR_PANEL = COLOR_PANEL;

/***/ },
/* 2447 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generatePrefixStyle = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	  result[name] = value;
	  return result;
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;

/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectReferenceElementsDomain = void 0;
	
	var _ReferenceDot = _interopRequireDefault(__webpack_require__(1012));
	
	var _ReferenceLine = _interopRequireDefault(__webpack_require__(1013));
	
	var _ReferenceArea = _interopRequireDefault(__webpack_require__(1011));
	
	var _IfOverflowMatches = __webpack_require__(383);
	
	var _ReactUtils = __webpack_require__(28);
	
	var _DataUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine["default"]);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot["default"]);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea["default"]);
	  var idKey = "".concat(axisType, "Id");
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = "".concat(valueKey, "1");
	    var key2 = "".concat(valueKey, "2");
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	exports.detectReferenceElementsDomain = detectReferenceElementsDomain;

/***/ },
/* 2449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = void 0;
	
	var _events = _interopRequireDefault(__webpack_require__(1820));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var eventCenter = new _events["default"]();
	exports.eventCenter = eventCenter;
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	var SYNC_EVENT = 'recharts.syncMouseEvents';
	exports.SYNC_EVENT = SYNC_EVENT;

/***/ },
/* 2450 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2489);
	__webpack_require__(2490);
	__webpack_require__(2491);
	__webpack_require__(2492);
	__webpack_require__(2493);
	__webpack_require__(2494);
	__webpack_require__(2495);
	__webpack_require__(2496);
	__webpack_require__(2497);
	__webpack_require__(2498);
	__webpack_require__(2499);
	__webpack_require__(2500);
	__webpack_require__(2501);
	__webpack_require__(2502);
	__webpack_require__(2503);
	__webpack_require__(2504);
	__webpack_require__(2505);
	__webpack_require__(2506);
	var path = __webpack_require__(551);
	
	module.exports = path.Math;


/***/ },
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2507);
	__webpack_require__(2508);
	__webpack_require__(2509);
	__webpack_require__(2510);
	__webpack_require__(2511);
	__webpack_require__(2512);
	__webpack_require__(2513);
	__webpack_require__(2514);
	__webpack_require__(2515);
	__webpack_require__(2516);
	__webpack_require__(2517);
	__webpack_require__(2518);
	__webpack_require__(2519);
	var path = __webpack_require__(551);
	
	module.exports = path.Number;


/***/ },
/* 2452 */
[2742, 103, 2486],
/* 2453 */
/***/ function(module, exports, __webpack_require__) {

	var isCallable = __webpack_require__(103);
	
	var $String = String;
	var $TypeError = TypeError;
	
	module.exports = function (argument) {
	  if (typeof argument == 'object' || isCallable(argument)) return argument;
	  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
	};


/***/ },
/* 2454 */
[2744, 554, 2482, 2468],
/* 2455 */
[2746, 2485, 103, 1020, 389],
/* 2456 */
[2747, 151, 2479, 550, 296],
/* 2457 */
[2749, 103, 296, 2469, 546],
/* 2458 */
[2752, 92, 209],
/* 2459 */
2206,
/* 2460 */
[2753, 92, 2459],
/* 2461 */
499,
/* 2462 */
[2757, 176, 151],
/* 2463 */
[2760, 2452, 1030],
/* 2464 */
[2763, 75, 80, 1020],
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	var isCallable = __webpack_require__(103);
	var isObject = __webpack_require__(209);
	var setPrototypeOf = __webpack_require__(2477);
	
	// makes subclassing work correct for wrapped built-ins
	module.exports = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	    // it can work only with native `setPrototypeOf`
	    setPrototypeOf &&
	    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	    isCallable(NewTarget = dummy.constructor) &&
	    NewTarget !== Wrapper &&
	    isObject(NewTargetPrototype = NewTarget.prototype) &&
	    NewTargetPrototype !== Wrapper.prototype
	  ) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};


/***/ },
/* 2466 */
[2764, 75, 103, 552],
/* 2467 */
[2765, 2488, 92, 209, 1021, 151, 552, 2481, 1026],
/* 2468 */
[2770, 2483],
/* 2469 */
[2771, 75, 80, 103, 151, 176, 2462, 2466, 2467],
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	var sign = __webpack_require__(549);
	
	var abs = Math.abs;
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	// `Math.fround` method implementation
	// https://tc39.es/ecma262/#sec-math.fround
	// eslint-disable-next-line es/no-math-fround -- safe
	module.exports = Math.fround || function fround(x) {
	  var n = +x;
	  var $abs = abs(n);
	  var $sign = sign(n);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(92);
	
	var globalIsFinite = global.isFinite;
	
	// `Number.isFinite` method
	// https://tc39.es/ecma262/#sec-number.isfinite
	// eslint-disable-next-line es/no-number-isfinite -- safe
	module.exports = Number.isFinite || function isFinite(it) {
	  return typeof it == 'number' && globalIsFinite(it);
	};


/***/ },
/* 2472 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(92);
	var fails = __webpack_require__(80);
	var uncurryThis = __webpack_require__(75);
	var toString = __webpack_require__(388);
	var trim = __webpack_require__(553).trim;
	var whitespaces = __webpack_require__(555);
	
	var charAt = uncurryThis(''.charAt);
	var $parseFloat = global.parseFloat;
	var Symbol = global.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseFloat(Object(ITERATOR)); }));
	
	// `parseFloat` method
	// https://tc39.es/ecma262/#sec-parsefloat-string
	module.exports = FORCED ? function parseFloat(string) {
	  var trimmedString = trim(toString(string));
	  var result = $parseFloat(trimmedString);
	  return result === 0 && charAt(trimmedString, 0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(92);
	var fails = __webpack_require__(80);
	var uncurryThis = __webpack_require__(75);
	var toString = __webpack_require__(388);
	var trim = __webpack_require__(553).trim;
	var whitespaces = __webpack_require__(555);
	
	var $parseInt = global.parseInt;
	var Symbol = global.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var hex = /^[+-]?0x/i;
	var exec = uncurryThis(hex.exec);
	var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	module.exports = FORCED ? function parseInt(string, radix) {
	  var S = trim(toString(string));
	  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 2474 */
912,
/* 2475 */
[2776, 75, 151, 554, 2454, 1026],
/* 2476 */
914,
/* 2477 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-proto -- safe */
	var uncurryThis = __webpack_require__(75);
	var anObject = __webpack_require__(545);
	var aPossiblePrototype = __webpack_require__(2453);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    anObject(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);


/***/ },
/* 2478 */
[2777, 547, 103, 209],
/* 2479 */
[2778, 1025, 75, 1035, 2474, 545],
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(296).f;
	var hasOwn = __webpack_require__(151);
	var wellKnownSymbol = __webpack_require__(389);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	
	module.exports = function (target, TAG, STATIC) {
	  if (target && !STATIC) target = target.prototype;
	  if (target && !hasOwn(target, TO_STRING_TAG)) {
	    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};


/***/ },
/* 2481 */
[2780, 1037, 1042],
/* 2482 */
[2784, 297],
/* 2483 */
[2787, 297],
/* 2484 */
[2788, 386],
/* 2485 */
[2791, 389],
/* 2486 */
919,
/* 2487 */
[2795, 176, 80],
/* 2488 */
[2796, 92, 103],
/* 2489 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var log1p = __webpack_require__(1033);
	
	// eslint-disable-next-line es/no-math-acosh -- required for testing
	var $acosh = Math.acosh;
	var log = Math.log;
	var sqrt = Math.sqrt;
	var LN2 = Math.LN2;
	
	var FORCED = !$acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  || Math.floor($acosh(Number.MAX_VALUE)) != 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  || $acosh(Infinity) != Infinity;
	
	// `Math.acosh` method
	// https://tc39.es/ecma262/#sec-math.acosh
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  acosh: function acosh(x) {
	    var n = +x;
	    return n < 1 ? NaN : n > 94906265.62425156
	      ? log(n) + LN2
	      : log1p(n - 1 + sqrt(n - 1) * sqrt(n + 1));
	  }
	});


/***/ },
/* 2490 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// eslint-disable-next-line es/no-math-asinh -- required for testing
	var $asinh = Math.asinh;
	var log = Math.log;
	var sqrt = Math.sqrt;
	
	function asinh(x) {
	  var n = +x;
	  return !isFinite(n) || n == 0 ? n : n < 0 ? -asinh(-n) : log(n + sqrt(n * n + 1));
	}
	
	var FORCED = !($asinh && 1 / $asinh(0) > 0);
	
	// `Math.asinh` method
	// https://tc39.es/ecma262/#sec-math.asinh
	// Tor Browser bug: Math.asinh(0) -> -0
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  asinh: asinh
	});


/***/ },
/* 2491 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// eslint-disable-next-line es/no-math-atanh -- required for testing
	var $atanh = Math.atanh;
	var log = Math.log;
	
	var FORCED = !($atanh && 1 / $atanh(-0) < 0);
	
	// `Math.atanh` method
	// https://tc39.es/ecma262/#sec-math.atanh
	// Tor Browser bug: Math.atanh(-0) -> 0
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  atanh: function atanh(x) {
	    var n = +x;
	    return n == 0 ? n : log((1 + n) / (1 - n)) / 2;
	  }
	});


/***/ },
/* 2492 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var sign = __webpack_require__(549);
	
	var abs = Math.abs;
	var pow = Math.pow;
	
	// `Math.cbrt` method
	// https://tc39.es/ecma262/#sec-math.cbrt
	$({ target: 'Math', stat: true }, {
	  cbrt: function cbrt(x) {
	    var n = +x;
	    return sign(n) * pow(abs(n), 1 / 3);
	  }
	});


/***/ },
/* 2493 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	var floor = Math.floor;
	var log = Math.log;
	var LOG2E = Math.LOG2E;
	
	// `Math.clz32` method
	// https://tc39.es/ecma262/#sec-math.clz32
	$({ target: 'Math', stat: true }, {
	  clz32: function clz32(x) {
	    var n = x >>> 0;
	    return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
	  }
	});


/***/ },
/* 2494 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var expm1 = __webpack_require__(385);
	
	// eslint-disable-next-line es/no-math-cosh -- required for testing
	var $cosh = Math.cosh;
	var abs = Math.abs;
	var E = Math.E;
	
	var FORCED = !$cosh || $cosh(710) === Infinity;
	
	// `Math.cosh` method
	// https://tc39.es/ecma262/#sec-math.cosh
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  cosh: function cosh(x) {
	    var t = expm1(abs(x) - 1) + 1;
	    return (t + 1 / (t * E * E)) * (E / 2);
	  }
	});


/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var expm1 = __webpack_require__(385);
	
	// `Math.expm1` method
	// https://tc39.es/ecma262/#sec-math.expm1
	// eslint-disable-next-line es/no-math-expm1 -- required for testing
	$({ target: 'Math', stat: true, forced: expm1 != Math.expm1 }, { expm1: expm1 });


/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var fround = __webpack_require__(2470);
	
	// `Math.fround` method
	// https://tc39.es/ecma262/#sec-math.fround
	$({ target: 'Math', stat: true }, { fround: fround });


/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// eslint-disable-next-line es/no-math-hypot -- required for testing
	var $hypot = Math.hypot;
	var abs = Math.abs;
	var sqrt = Math.sqrt;
	
	// Chrome 77 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=9546
	var FORCED = !!$hypot && $hypot(Infinity, NaN) !== Infinity;
	
	// `Math.hypot` method
	// https://tc39.es/ecma262/#sec-math.hypot
	$({ target: 'Math', stat: true, arity: 2, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  hypot: function hypot(value1, value2) {
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * sqrt(sum);
	  }
	});


/***/ },
/* 2498 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var fails = __webpack_require__(80);
	
	// eslint-disable-next-line es/no-math-imul -- required for testing
	var $imul = Math.imul;
	
	var FORCED = fails(function () {
	  return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
	});
	
	// `Math.imul` method
	// https://tc39.es/ecma262/#sec-math.imul
	// some WebKit versions fails with big numbers, some has wrong arity
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  imul: function imul(x, y) {
	    var UINT16 = 0xFFFF;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 2499 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var log10 = __webpack_require__(1032);
	
	// `Math.log10` method
	// https://tc39.es/ecma262/#sec-math.log10
	$({ target: 'Math', stat: true }, {
	  log10: log10
	});


/***/ },
/* 2500 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var log1p = __webpack_require__(1033);
	
	// `Math.log1p` method
	// https://tc39.es/ecma262/#sec-math.log1p
	$({ target: 'Math', stat: true }, { log1p: log1p });


/***/ },
/* 2501 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	var log = Math.log;
	var LN2 = Math.LN2;
	
	// `Math.log2` method
	// https://tc39.es/ecma262/#sec-math.log2
	$({ target: 'Math', stat: true }, {
	  log2: function log2(x) {
	    return log(x) / LN2;
	  }
	});


/***/ },
/* 2502 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var sign = __webpack_require__(549);
	
	// `Math.sign` method
	// https://tc39.es/ecma262/#sec-math.sign
	$({ target: 'Math', stat: true }, {
	  sign: sign
	});


/***/ },
/* 2503 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var fails = __webpack_require__(80);
	var expm1 = __webpack_require__(385);
	
	var abs = Math.abs;
	var exp = Math.exp;
	var E = Math.E;
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-math-sinh -- required for testing
	  return Math.sinh(-2e-17) != -2e-17;
	});
	
	// `Math.sinh` method
	// https://tc39.es/ecma262/#sec-math.sinh
	// V8 near Chromium 38 has a problem with very small numbers
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  sinh: function sinh(x) {
	    var n = +x;
	    return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
	  }
	});


/***/ },
/* 2504 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var expm1 = __webpack_require__(385);
	
	var exp = Math.exp;
	
	// `Math.tanh` method
	// https://tc39.es/ecma262/#sec-math.tanh
	$({ target: 'Math', stat: true }, {
	  tanh: function tanh(x) {
	    var n = +x;
	    var a = expm1(n);
	    var b = expm1(-n);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
	  }
	});


/***/ },
/* 2505 */
/***/ function(module, exports, __webpack_require__) {

	var setToStringTag = __webpack_require__(2480);
	
	// Math[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-math-@@tostringtag
	setToStringTag(Math, 'Math', true);


/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var trunc = __webpack_require__(1034);
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	$({ target: 'Math', stat: true }, {
	  trunc: trunc
	});


/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(35);
	var IS_PURE = __webpack_require__(1031);
	var DESCRIPTORS = __webpack_require__(176);
	var global = __webpack_require__(92);
	var path = __webpack_require__(551);
	var uncurryThis = __webpack_require__(75);
	var isForced = __webpack_require__(1028);
	var hasOwn = __webpack_require__(151);
	var inheritIfRequired = __webpack_require__(2465);
	var isPrototypeOf = __webpack_require__(1036);
	var isSymbol = __webpack_require__(548);
	var toPrimitive = __webpack_require__(1040);
	var fails = __webpack_require__(80);
	var getOwnPropertyNames = __webpack_require__(1035).f;
	var getOwnPropertyDescriptor = __webpack_require__(550).f;
	var defineProperty = __webpack_require__(296).f;
	var thisNumberValue = __webpack_require__(387);
	var trim = __webpack_require__(553).trim;
	
	var NUMBER = 'Number';
	var NativeNumber = global[NUMBER];
	var PureNumberNamespace = path[NUMBER];
	var NumberPrototype = NativeNumber.prototype;
	var TypeError = global.TypeError;
	var stringSlice = uncurryThis(''.slice);
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	// `ToNumeric` abstract operation
	// https://tc39.es/ecma262/#sec-tonumeric
	var toNumeric = function (value) {
	  var primValue = toPrimitive(value, 'number');
	  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
	};
	
	// `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, 'number');
	  var first, third, radix, maxCode, digits, length, index, code;
	  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = charCodeAt(it, 0);
	    if (first === 43 || first === 45) {
	      third = charCodeAt(it, 2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (charCodeAt(it, 1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
	        default: return +it;
	      }
	      digits = stringSlice(it, 2);
	      length = digits.length;
	      for (index = 0; index < length; index++) {
	        code = charCodeAt(digits, index);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));
	
	var calledWithNew = function (dummy) {
	  // includes check on 1..constructor(foo) case
	  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
	};
	
	// `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor
	var NumberWrapper = function Number(value) {
	  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
	  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
	};
	
	NumberWrapper.prototype = NumberPrototype;
	if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;
	
	$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
	  Number: NumberWrapper
	});
	
	// Use `internal/copy-constructor-properties` helper in `core-js@4`
	var copyConstructorProperties = function (target, source) {
	  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES2015 (in case, if modules with ES2015 Number statics required before):
	    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
	    // ESNext
	    'fromString,range'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	
	if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
	if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// `Number.EPSILON` constant
	// https://tc39.es/ecma262/#sec-number.epsilon
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  EPSILON: Math.pow(2, -52)
	});


/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var numberIsFinite = __webpack_require__(2471);
	
	// `Number.isFinite` method
	// https://tc39.es/ecma262/#sec-number.isfinite
	$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var isIntegralNumber = __webpack_require__(1029);
	
	// `Number.isInteger` method
	// https://tc39.es/ecma262/#sec-number.isinteger
	$({ target: 'Number', stat: true }, {
	  isInteger: isIntegralNumber
	});


/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// `Number.isNaN` method
	// https://tc39.es/ecma262/#sec-number.isnan
	$({ target: 'Number', stat: true }, {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return number != number;
	  }
	});


/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var isIntegralNumber = __webpack_require__(1029);
	
	var abs = Math.abs;
	
	// `Number.isSafeInteger` method
	// https://tc39.es/ecma262/#sec-number.issafeinteger
	$({ target: 'Number', stat: true }, {
	  isSafeInteger: function isSafeInteger(number) {
	    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
	  }
	});


/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// `Number.MAX_SAFE_INTEGER` constant
	// https://tc39.es/ecma262/#sec-number.max_safe_integer
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
	});


/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	
	// `Number.MIN_SAFE_INTEGER` constant
	// https://tc39.es/ecma262/#sec-number.min_safe_integer
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
	});


/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var parseFloat = __webpack_require__(2472);
	
	// `Number.parseFloat` method
	// https://tc39.es/ecma262/#sec-number.parseFloat
	// eslint-disable-next-line es/no-number-parsefloat -- required for testing
	$({ target: 'Number', stat: true, forced: Number.parseFloat != parseFloat }, {
	  parseFloat: parseFloat
	});


/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(35);
	var parseInt = __webpack_require__(2473);
	
	// `Number.parseInt` method
	// https://tc39.es/ecma262/#sec-number.parseint
	// eslint-disable-next-line es/no-number-parseint -- required for testing
	$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
	  parseInt: parseInt
	});


/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(35);
	var uncurryThis = __webpack_require__(75);
	var toIntegerOrInfinity = __webpack_require__(297);
	var thisNumberValue = __webpack_require__(387);
	var $repeat = __webpack_require__(1038);
	var log10 = __webpack_require__(1032);
	var fails = __webpack_require__(80);
	
	var $RangeError = RangeError;
	var $String = String;
	var $isFinite = isFinite;
	var abs = Math.abs;
	var floor = Math.floor;
	var pow = Math.pow;
	var round = Math.round;
	var nativeToExponential = uncurryThis(1.0.toExponential);
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	
	// Edge 17-
	var ROUNDS_PROPERLY = nativeToExponential(-6.9e-11, 4) === '-6.9000e-11'
	  // IE11- && Edge 14-
	  && nativeToExponential(1.255, 2) === '1.25e+0'
	  // FF86-, V8 ~ Chrome 49-50
	  && nativeToExponential(12345, 3) === '1.235e+4'
	  // FF86-, V8 ~ Chrome 49-50
	  && nativeToExponential(25, 0) === '3e+1';
	
	// IE8-
	var throwsOnInfinityFraction = function () {
	  return fails(function () {
	    nativeToExponential(1, Infinity);
	  }) && fails(function () {
	    nativeToExponential(1, -Infinity);
	  });
	};
	
	// Safari <11 && FF <50
	var properNonFiniteThisCheck = function () {
	  return !fails(function () {
	    nativeToExponential(Infinity, Infinity);
	    nativeToExponential(NaN, Infinity);
	  });
	};
	
	var FORCED = !ROUNDS_PROPERLY || !throwsOnInfinityFraction() || !properNonFiniteThisCheck();
	
	// `Number.prototype.toExponential` method
	// https://tc39.es/ecma262/#sec-number.prototype.toexponential
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toExponential: function toExponential(fractionDigits) {
	    var x = thisNumberValue(this);
	    if (fractionDigits === undefined) return nativeToExponential(x);
	    var f = toIntegerOrInfinity(fractionDigits);
	    if (!$isFinite(x)) return String(x);
	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (f < 0 || f > 20) throw $RangeError('Incorrect fraction digits');
	    if (ROUNDS_PROPERLY) return nativeToExponential(x, f);
	    var s = '';
	    var m = '';
	    var e = 0;
	    var c = '';
	    var d = '';
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x === 0) {
	      e = 0;
	      m = repeat('0', f + 1);
	    } else {
	      // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
	      // TODO: improve accuracy with big fraction digits
	      var l = log10(x);
	      e = floor(l);
	      var n = 0;
	      var w = pow(10, e - f);
	      n = round(x / w);
	      if (2 * x >= (2 * n + 1) * w) {
	        n += 1;
	      }
	      if (n >= pow(10, f + 1)) {
	        n /= 10;
	        e += 1;
	      }
	      m = $String(n);
	    }
	    if (f !== 0) {
	      m = stringSlice(m, 0, 1) + '.' + stringSlice(m, 1);
	    }
	    if (e === 0) {
	      c = '+';
	      d = '0';
	    } else {
	      c = e > 0 ? '+' : '-';
	      d = $String(abs(e));
	    }
	    m += 'e' + c + d;
	    return s + m;
	  }
	});


/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(35);
	var uncurryThis = __webpack_require__(75);
	var toIntegerOrInfinity = __webpack_require__(297);
	var thisNumberValue = __webpack_require__(387);
	var $repeat = __webpack_require__(1038);
	var fails = __webpack_require__(80);
	
	var $RangeError = RangeError;
	var $String = String;
	var floor = Math.floor;
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	var nativeToFixed = uncurryThis(1.0.toFixed);
	
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	var multiply = function (data, n, c) {
	  var index = -1;
	  var c2 = c;
	  while (++index < 6) {
	    c2 += n * data[index];
	    data[index] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	
	var divide = function (data, n) {
	  var index = 6;
	  var c = 0;
	  while (--index >= 0) {
	    c += data[index];
	    data[index] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	
	var dataToString = function (data) {
	  var index = 6;
	  var s = '';
	  while (--index >= 0) {
	    if (s !== '' || index === 0 || data[index] !== 0) {
	      var t = $String(data[index]);
	      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
	    }
	  } return s;
	};
	
	var FORCED = fails(function () {
	  return nativeToFixed(0.00008, 3) !== '0.000' ||
	    nativeToFixed(0.9, 0) !== '1' ||
	    nativeToFixed(1.255, 2) !== '1.25' ||
	    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToFixed({});
	});
	
	// `Number.prototype.toFixed` method
	// https://tc39.es/ecma262/#sec-number.prototype.tofixed
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toFixed: function toFixed(fractionDigits) {
	    var number = thisNumberValue(this);
	    var fractDigits = toIntegerOrInfinity(fractionDigits);
	    var data = [0, 0, 0, 0, 0, 0];
	    var sign = '';
	    var result = '0';
	    var e, z, j, k;
	
	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (number != number) return 'NaN';
	    if (number <= -1e21 || number >= 1e21) return $String(number);
	    if (number < 0) {
	      sign = '-';
	      number = -number;
	    }
	    if (number > 1e-21) {
	      e = log(number * pow(2, 69, 1)) - 69;
	      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(data, 0, z);
	        j = fractDigits;
	        while (j >= 7) {
	          multiply(data, 1e7, 0);
	          j -= 7;
	        }
	        multiply(data, pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(data, 1 << 23);
	          j -= 23;
	        }
	        divide(data, 1 << j);
	        multiply(data, 1, 1);
	        divide(data, 2);
	        result = dataToString(data);
	      } else {
	        multiply(data, 0, z);
	        multiply(data, 1 << -e, 0);
	        result = dataToString(data) + repeat('0', fractDigits);
	      }
	    }
	    if (fractDigits > 0) {
	      k = result.length;
	      result = sign + (k <= fractDigits
	        ? '0.' + repeat('0', fractDigits - k) + result
	        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
	    } else {
	      result = sign + result;
	    } return result;
	  }
	});


/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(35);
	var uncurryThis = __webpack_require__(75);
	var fails = __webpack_require__(80);
	var thisNumberValue = __webpack_require__(387);
	
	var nativeToPrecision = uncurryThis(1.0.toPrecision);
	
	var FORCED = fails(function () {
	  // IE7-
	  return nativeToPrecision(1, undefined) !== '1';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToPrecision({});
	});
	
	// `Number.prototype.toPrecision` method
	// https://tc39.es/ecma262/#sec-number.prototype.toprecision
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toPrecision: function toPrecision(precision) {
	    return precision === undefined
	      ? nativeToPrecision(thisNumberValue(this))
	      : nativeToPrecision(thisNumberValue(this), precision);
	  }
	});


/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.1 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 2523 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.5 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = global.d3 || {}));
	}(this, (function (exports) { 'use strict';
	
	function formatDecimal(x) {
	  return Math.abs(x = Math.round(x)) >= 1e21
	      ? x.toLocaleString("en").replace(/,/g, "")
	      : x.toString(10);
	}
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimalParts(1.23) returns ["123", 0].
	function formatDecimalParts(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": formatDecimal,
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = value < 0 || 1 / value < 0;
	
	        // Perform the initial formatting.
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
	        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 2524 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(2522)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.3.0 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1045)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "g": formatYearISO,
	    "G": formatFullYearISO,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "g": formatUTCYearISO,
	    "G": formatUTCFullYearISO,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "g": parseYear,
	    "G": parseFullYear,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function dISO(d) {
	  var day = d.getDay();
	  return (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	}
	
	function formatWeekNumberISO(d, p) {
	  d = dISO(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatYearISO(d, p) {
	  d = dISO(d);
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatFullYearISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function UTCdISO(d) {
	  var day = d.getUTCDay();
	  return (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCYearISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCFullYearISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 2527 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 2528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(1556)
	var reduceFunctionCall = __webpack_require__(2529)
	var mexp = __webpack_require__(2057)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(2530)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 2530 */
/***/ function(module, exports) {

	'use strict';
	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    if(a===b) {
	      return [ai, bi];
	    }
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1046);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SliderConstants = __webpack_require__(2535);
	
	var SliderConstants = _interopRequireWildcard(_SliderConstants);
	
	var _linear = __webpack_require__(2534);
	
	var _linear2 = _interopRequireDefault(_linear);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals document */
	/* eslint react/no-array-index-key: 1 */
	
	function getClassName(props) {
	  var orientation = props.orientation === 'vertical' ? 'rheostat-vertical' : 'rheostat-horizontal';
	
	  return ['rheostat', orientation].concat(props.className.split(' ')).join(' ');
	}
	
	var has = Object.prototype.hasOwnProperty;
	
	var PropTypeArrOfNumber = _propTypes2['default'].arrayOf(_propTypes2['default'].number);
	var PropTypeReactComponent = _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]);
	
	function getHandleFor(ev) {
	  return Number(ev.currentTarget.getAttribute('data-handle-key'));
	}
	
	function killEvent(ev) {
	  ev.stopPropagation();
	  ev.preventDefault();
	}
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	  }
	
	  _createClass(Button, [{
	    key: 'render',
	    value: function () {
	      function render() {
	        return _react2['default'].createElement('button', _extends({}, this.props, { type: 'button' }));
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Button;
	}(_react2['default'].Component);
	
	var propTypes = {
	  // the algorithm to use
	  algorithm: _propTypes2['default'].shape({
	    getValue: _propTypes2['default'].func,
	    getPosition: _propTypes2['default'].func
	  }),
	  // any children you pass in
	  children: _propTypes2['default'].node,
	  // standard class name you'd like to apply to the root element
	  className: _propTypes2['default'].string,
	  // prevent the slider from moving when clicked
	  disabled: _propTypes2['default'].bool,
	  // a custom handle you can pass in
	  handle: PropTypeReactComponent,
	  // the maximum possible value
	  max: _propTypes2['default'].number,
	  // the minimum possible value
	  min: _propTypes2['default'].number,
	  // called on click
	  onClick: _propTypes2['default'].func,
	  // called whenever the user is done changing values on the slider
	  onChange: _propTypes2['default'].func,
	  // called on key press
	  onKeyPress: _propTypes2['default'].func,
	  // called when you finish dragging a handle
	  onSliderDragEnd: _propTypes2['default'].func,
	  // called every time the slider is dragged and the value changes
	  onSliderDragMove: _propTypes2['default'].func,
	  // called when you start dragging a handle
	  onSliderDragStart: _propTypes2['default'].func,
	  // called whenever the user is actively changing the values on the slider
	  // (dragging, clicked, keypress)
	  onValuesUpdated: _propTypes2['default'].func,
	  // the orientation
	  orientation: _propTypes2['default'].oneOf(['horizontal', 'vertical']),
	  // a component for rendering the pits
	  pitComponent: PropTypeReactComponent,
	  // the points that pits are rendered on
	  pitPoints: PropTypeArrOfNumber,
	  // a custom progress bar you can pass in
	  progressBar: PropTypeReactComponent,
	  // should we snap?
	  snap: _propTypes2['default'].bool,
	  // the points we should snap to
	  snapPoints: PropTypeArrOfNumber,
	  // whether a proposed update is valid
	  getNextHandlePosition: _propTypes2['default'].func,
	  // the values
	  values: PropTypeArrOfNumber
	};
	
	var defaultProps = {
	  algorithm: _linear2['default'],
	  className: '',
	  children: null,
	  disabled: false,
	  handle: Button,
	  max: SliderConstants.PERCENT_FULL,
	  min: SliderConstants.PERCENT_EMPTY,
	  onClick: null,
	  onChange: null,
	  onKeyPress: null,
	  onSliderDragEnd: null,
	  onSliderDragMove: null,
	  onSliderDragStart: null,
	  onValuesUpdated: null,
	  orientation: 'horizontal',
	  pitComponent: null,
	  pitPoints: [],
	  progressBar: 'div',
	  snap: false,
	  snapPoints: [],
	  getNextHandlePosition: null,
	  values: [SliderConstants.PERCENT_EMPTY]
	};
	
	var Rheostat = function (_React$Component2) {
	  _inherits(Rheostat, _React$Component2);
	
	  function Rheostat(props) {
	    _classCallCheck(this, Rheostat);
	
	    var _this2 = _possibleConstructorReturn(this, (Rheostat.__proto__ || Object.getPrototypeOf(Rheostat)).call(this, props));
	
	    var _this2$props = _this2.props,
	        algorithm = _this2$props.algorithm,
	        max = _this2$props.max,
	        min = _this2$props.min,
	        values = _this2$props.values;
	
	    _this2.state = {
	      className: getClassName(_this2.props),
	      handlePos: values.map(function (value) {
	        return algorithm.getPosition(value, min, max);
	      }),
	      handleDimensions: 0,
	      // mousePos: null,
	      sliderBox: {},
	      slidingIndex: null,
	      values: values
	    };
	    _this2.getPublicState = _this2.getPublicState.bind(_this2);
	    _this2.getSliderBoundingBox = _this2.getSliderBoundingBox.bind(_this2);
	    _this2.getProgressStyle = _this2.getProgressStyle.bind(_this2);
	    _this2.getMinValue = _this2.getMinValue.bind(_this2);
	    _this2.getMaxValue = _this2.getMaxValue.bind(_this2);
	    _this2.getHandleDimensions = _this2.getHandleDimensions.bind(_this2);
	    _this2.getClosestSnapPoint = _this2.getClosestSnapPoint.bind(_this2);
	    _this2.getSnapPosition = _this2.getSnapPosition.bind(_this2);
	    _this2.getNextPositionForKey = _this2.getNextPositionForKey.bind(_this2);
	    _this2.getNextState = _this2.getNextState.bind(_this2);
	    _this2.handleClick = _this2.handleClick.bind(_this2);
	    _this2.getClosestHandle = _this2.getClosestHandle.bind(_this2);
	    _this2.setStartSlide = _this2.setStartSlide.bind(_this2);
	    _this2.startMouseSlide = _this2.startMouseSlide.bind(_this2);
	    _this2.startTouchSlide = _this2.startTouchSlide.bind(_this2);
	    _this2.handleMouseSlide = _this2.handleMouseSlide.bind(_this2);
	    _this2.handleTouchSlide = _this2.handleTouchSlide.bind(_this2);
	    _this2.handleSlide = _this2.handleSlide.bind(_this2);
	    _this2.endSlide = _this2.endSlide.bind(_this2);
	    _this2.handleKeydown = _this2.handleKeydown.bind(_this2);
	    _this2.validatePosition = _this2.validatePosition.bind(_this2);
	    _this2.validateValues = _this2.validateValues.bind(_this2);
	    _this2.canMove = _this2.canMove.bind(_this2);
	    _this2.fireChangeEvent = _this2.fireChangeEvent.bind(_this2);
	    _this2.slideTo = _this2.slideTo.bind(_this2);
	    _this2.updateNewValues = _this2.updateNewValues.bind(_this2);
	    _this2.setRef = _this2.setRef.bind(_this2);
	    _this2.invalidatePitStyleCache = _this2.invalidatePitStyleCache.bind(_this2);
	
	    _this2.pitStyleCache = {};
	    return _this2;
	  }
	
	  _createClass(Rheostat, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            className = _props.className,
	            disabled = _props.disabled,
	            min = _props.min,
	            max = _props.max,
	            orientation = _props.orientation,
	            pitPoints = _props.pitPoints,
	            algorithm = _props.algorithm;
	        var _state = this.state,
	            values = _state.values,
	            slidingIndex = _state.slidingIndex;
	
	
	        var minMaxChanged = nextProps.min !== min || nextProps.max !== max;
	
	        var valuesChanged = values.length !== nextProps.values.length || values.some(function (value, idx) {
	          return nextProps.values[idx] !== value;
	        });
	
	        var orientationChanged = nextProps.className !== className || nextProps.orientation !== orientation;
	
	        var algorithmChanged = nextProps.algorithm !== algorithm;
	
	        var pitPointsChanged = nextProps.pitPoints !== pitPoints;
	
	        var willBeDisabled = nextProps.disabled && !disabled;
	
	        if (orientationChanged) {
	          this.setState({
	            className: getClassName(nextProps)
	          });
	        }
	
	        if (minMaxChanged || valuesChanged) this.updateNewValues(nextProps);
	
	        if (minMaxChanged || pitPointsChanged || orientationChanged || algorithmChanged) {
	          this.invalidatePitStyleCache();
	        }
	
	        if (willBeDisabled && slidingIndex !== null) {
	          this.endSlide();
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'getPublicState',
	    value: function () {
	      function getPublicState() {
	        var _props2 = this.props,
	            min = _props2.min,
	            max = _props2.max;
	        var values = this.state.values;
	
	
	        return { max: max, min: min, values: values };
	      }
	
	      return getPublicState;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'getSliderBoundingBox',
	    value: function () {
	      function getSliderBoundingBox() {
	        var rheostat = this.rheostat;
	
	        var node = rheostat.getDOMNode ? rheostat.getDOMNode() : rheostat;
	        var rect = node.getBoundingClientRect();
	
	        return {
	          height: rect.height || node.clientHeight,
	          left: rect.left,
	          top: rect.top,
	          width: rect.width || node.clientWidth
	        };
	      }
	
	      return getSliderBoundingBox;
	    }()
	  }, {
	    key: 'getProgressStyle',
	    value: function () {
	      function getProgressStyle(idx) {
	        var orientation = this.props.orientation;
	        var handlePos = this.state.handlePos;
	
	
	        var value = handlePos[idx];
	
	        if (idx === 0) {
	          return orientation === 'vertical' ? { height: String(value) + '%', top: 0 } : { left: 0, width: String(value) + '%' };
	        }
	
	        var prevValue = handlePos[idx - 1];
	        var diffValue = value - prevValue;
	
	        return orientation === 'vertical' ? { height: diffValue + '%', top: String(prevValue) + '%' } : { left: String(prevValue) + '%', width: diffValue + '%' };
	      }
	
	      return getProgressStyle;
	    }()
	  }, {
	    key: 'getMinValue',
	    value: function () {
	      function getMinValue(idx) {
	        var min = this.props.min;
	        var values = this.state.values;
	
	        return values[idx - 1] ? Math.max(min, values[idx - 1]) : min;
	      }
	
	      return getMinValue;
	    }()
	  }, {
	    key: 'getMaxValue',
	    value: function () {
	      function getMaxValue(idx) {
	        var max = this.props.max;
	        var values = this.state.values;
	
	        return values[idx + 1] ? Math.min(max, values[idx + 1]) : max;
	      }
	
	      return getMaxValue;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'getHandleDimensions',
	    value: function () {
	      function getHandleDimensions(ev, sliderBox) {
	        var handleNode = ev.currentTarget || null;
	
	        if (!handleNode) return 0;
	
	        return this.props.orientation === 'vertical' ? handleNode.clientHeight / sliderBox.height * SliderConstants.PERCENT_FULL / 2 : handleNode.clientWidth / sliderBox.width * SliderConstants.PERCENT_FULL / 2;
	      }
	
	      return getHandleDimensions;
	    }()
	  }, {
	    key: 'getClosestSnapPoint',
	    value: function () {
	      function getClosestSnapPoint(value) {
	        var snapPoints = this.props.snapPoints;
	
	        if (!snapPoints.length) return value;
	
	        return snapPoints.reduce(function (snapTo, snap) {
	          return Math.abs(snapTo - value) < Math.abs(snap - value) ? snapTo : snap;
	        });
	      }
	
	      return getClosestSnapPoint;
	    }()
	  }, {
	    key: 'getSnapPosition',
	    value: function () {
	      function getSnapPosition(positionPercent) {
	        var _props3 = this.props,
	            algorithm = _props3.algorithm,
	            max = _props3.max,
	            min = _props3.min,
	            snap = _props3.snap;
	
	
	        if (!snap) return positionPercent;
	
	        var value = algorithm.getValue(positionPercent, min, max);
	
	        var snapValue = this.getClosestSnapPoint(value);
	
	        return algorithm.getPosition(snapValue, min, max);
	      }
	
	      return getSnapPosition;
	    }()
	  }, {
	    key: 'getNextPositionForKey',
	    value: function () {
	      function getNextPositionForKey(idx, keyCode) {
	        var _stepMultiplier;
	
	        var _state2 = this.state,
	            handlePos = _state2.handlePos,
	            values = _state2.values;
	        var _props4 = this.props,
	            algorithm = _props4.algorithm,
	            max = _props4.max,
	            min = _props4.min,
	            snapPoints = _props4.snapPoints,
	            shouldSnap = _props4.snap;
	
	
	        var proposedValue = values[idx];
	        var proposedPercentage = handlePos[idx];
	        var originalPercentage = proposedPercentage;
	        var stepValue = 1;
	
	        if (max >= 100) {
	          proposedPercentage = Math.round(proposedPercentage);
	        } else {
	          stepValue = 100 / (max - min);
	        }
	
	        var currentIndex = null;
	
	        if (shouldSnap) {
	          currentIndex = snapPoints.indexOf(this.getClosestSnapPoint(values[idx]));
	        }
	
	        var stepMultiplier = (_stepMultiplier = {}, _defineProperty(_stepMultiplier, SliderConstants.KEYS.LEFT, function (v) {
	          return v * -1;
	        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.RIGHT, function (v) {
	          return v * 1;
	        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.UP, function (v) {
	          return v * 1;
	        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.DOWN, function (v) {
	          return v * -1;
	        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.PAGE_DOWN, function (v) {
	          return v > 1 ? -v : v * -10;
	        }), _defineProperty(_stepMultiplier, SliderConstants.KEYS.PAGE_UP, function (v) {
	          return v > 1 ? v : v * 10;
	        }), _stepMultiplier);
	
	        if (has.call(stepMultiplier, keyCode)) {
	          proposedPercentage += stepMultiplier[keyCode](stepValue);
	
	          if (shouldSnap) {
	            if (proposedPercentage > originalPercentage) {
	              // move cursor right unless overflow
	              if (currentIndex < snapPoints.length - 1) {
	                proposedValue = snapPoints[currentIndex + 1];
	              }
	              // move cursor left unless there is overflow
	            } else if (currentIndex > 0) {
	              proposedValue = snapPoints[currentIndex - 1];
	            }
	          }
	        } else if (keyCode === SliderConstants.KEYS.HOME) {
	          proposedPercentage = SliderConstants.PERCENT_EMPTY;
	
	          if (shouldSnap) {
	            var _snapPoints = _slicedToArray(snapPoints, 1);
	
	            proposedValue = _snapPoints[0];
	          }
	        } else if (keyCode === SliderConstants.KEYS.END) {
	          proposedPercentage = SliderConstants.PERCENT_FULL;
	
	          if (shouldSnap) {
	            proposedValue = snapPoints[snapPoints.length - 1];
	          }
	        } else {
	          return null;
	        }
	
	        return shouldSnap ? algorithm.getPosition(proposedValue, min, max) : proposedPercentage;
	      }
	
	      return getNextPositionForKey;
	    }()
	  }, {
	    key: 'getNextState',
	    value: function () {
	      function getNextState(idx, proposedPosition) {
	        var handlePos = this.state.handlePos;
	        var _props5 = this.props,
	            max = _props5.max,
	            min = _props5.min,
	            algorithm = _props5.algorithm;
	
	
	        var actualPosition = this.validatePosition(idx, proposedPosition);
	
	        var nextHandlePos = handlePos.map(function (pos, index) {
	          return index === idx ? actualPosition : pos;
	        });
	
	        return {
	          handlePos: nextHandlePos,
	          values: nextHandlePos.map(function (pos) {
	            return algorithm.getValue(pos, min, max);
	          })
	        };
	      }
	
	      return getNextState;
	    }()
	  }, {
	    key: 'getClosestHandle',
	    value: function () {
	      function getClosestHandle(positionPercent) {
	        var handlePos = this.state.handlePos;
	
	
	        return handlePos.reduce(function (closestIdx, node, idx) {
	          var challenger = Math.abs(handlePos[idx] - positionPercent);
	          var current = Math.abs(handlePos[closestIdx] - positionPercent);
	          return challenger < current ? idx : closestIdx;
	        }, 0);
	      }
	
	      return getClosestHandle;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'setStartSlide',
	    value: function () {
	      function setStartSlide(ev /* , x, y */) {
	        var sliderBox = this.getSliderBoundingBox();
	
	        this.setState({
	          handleDimensions: this.getHandleDimensions(ev, sliderBox),
	          // mousePos: { x, y },
	          sliderBox: sliderBox,
	          slidingIndex: getHandleFor(ev)
	        });
	      }
	
	      return setStartSlide;
	    }()
	  }, {
	    key: 'setRef',
	    value: function () {
	      function setRef(ref) {
	        this.rheostat = ref;
	      }
	
	      return setRef;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'startMouseSlide',
	    value: function () {
	      function startMouseSlide(ev) {
	        this.setStartSlide(ev, ev.clientX, ev.clientY);
	
	        if (typeof document.addEventListener === 'function') {
	          document.addEventListener('mousemove', this.handleMouseSlide, false);
	          document.addEventListener('mouseup', this.endSlide, false);
	        } else {
	          document.attachEvent('onmousemove', this.handleMouseSlide);
	          document.attachEvent('onmouseup', this.endSlide);
	        }
	
	        killEvent(ev);
	      }
	
	      return startMouseSlide;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'startTouchSlide',
	    value: function () {
	      function startTouchSlide(ev) {
	        var onSliderDragStart = this.props.onSliderDragStart;
	
	
	        if (ev.changedTouches.length > 1) return;
	
	        var touch = ev.changedTouches[0];
	
	        this.setStartSlide(ev, touch.clientX, touch.clientY);
	
	        document.addEventListener('touchmove', this.handleTouchSlide, false);
	        document.addEventListener('touchend', this.endSlide, false);
	
	        if (onSliderDragStart) onSliderDragStart();
	
	        killEvent(ev);
	      }
	
	      return startTouchSlide;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'handleMouseSlide',
	    value: function () {
	      function handleMouseSlide(ev) {
	        var slidingIndex = this.state.slidingIndex;
	
	        if (slidingIndex === null) return;
	        this.handleSlide(ev.clientX, ev.clientY);
	        killEvent(ev);
	      }
	
	      return handleMouseSlide;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'handleTouchSlide',
	    value: function () {
	      function handleTouchSlide(ev) {
	        var slidingIndex = this.state.slidingIndex;
	
	        if (slidingIndex === null) return;
	
	        if (ev.changedTouches.length > 1) {
	          this.endSlide();
	          return;
	        }
	
	        var touch = ev.changedTouches[0];
	
	        this.handleSlide(touch.clientX, touch.clientY);
	        killEvent(ev);
	      }
	
	      return handleTouchSlide;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'handleSlide',
	    value: function () {
	      function handleSlide(x, y) {
	        var _props6 = this.props,
	            orientation = _props6.orientation,
	            onSliderDragMove = _props6.onSliderDragMove;
	        var _state3 = this.state,
	            idx = _state3.slidingIndex,
	            sliderBox = _state3.sliderBox;
	
	
	        var positionPercent = orientation === 'vertical' ? (y - sliderBox.top) / sliderBox.height * SliderConstants.PERCENT_FULL : (x - sliderBox.left) / sliderBox.width * SliderConstants.PERCENT_FULL;
	
	        this.slideTo(idx, positionPercent);
	
	        if (this.canMove(idx, positionPercent)) {
	          if (onSliderDragMove) onSliderDragMove();
	        }
	      }
	
	      return handleSlide;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'endSlide',
	    value: function () {
	      function endSlide() {
	        var _this3 = this;
	
	        var _props7 = this.props,
	            onSliderDragEnd = _props7.onSliderDragEnd,
	            snap = _props7.snap;
	        var _state4 = this.state,
	            slidingIndex = _state4.slidingIndex,
	            handlePos = _state4.handlePos;
	
	
	        this.setState({ slidingIndex: null });
	
	        if (typeof document.removeEventListener === 'function') {
	          document.removeEventListener('mouseup', this.endSlide, false);
	          document.removeEventListener('touchend', this.endSlide, false);
	          document.removeEventListener('touchmove', this.handleTouchSlide, false);
	          document.removeEventListener('mousemove', this.handleMouseSlide, false);
	        } else {
	          document.detachEvent('onmousemove', this.handleMouseSlide);
	          document.detachEvent('onmouseup', this.endSlide);
	        }
	
	        if (onSliderDragEnd) onSliderDragEnd();
	        if (snap) {
	          var positionPercent = this.getSnapPosition(handlePos[slidingIndex]);
	          this.slideTo(slidingIndex, positionPercent, function () {
	            return _this3.fireChangeEvent();
	          });
	        } else {
	          this.fireChangeEvent();
	        }
	      }
	
	      return endSlide;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'handleClick',
	    value: function () {
	      function handleClick(ev) {
	        var _this4 = this;
	
	        if (ev.target.getAttribute('data-handle-key')) {
	          return;
	        }
	
	        var _props8 = this.props,
	            orientation = _props8.orientation,
	            onClick = _props8.onClick;
	
	        // Calculate the position of the slider on the page so we can determine
	        // the position where you click in relativity.
	
	        var sliderBox = this.getSliderBoundingBox();
	
	        var positionDecimal = orientation === 'vertical' ? (ev.clientY - sliderBox.top) / sliderBox.height : (ev.clientX - sliderBox.left) / sliderBox.width;
	
	        var positionPercent = positionDecimal * SliderConstants.PERCENT_FULL;
	
	        var handleId = this.getClosestHandle(positionPercent);
	
	        var validPositionPercent = this.getSnapPosition(positionPercent);
	
	        // Move the handle there
	        this.slideTo(handleId, validPositionPercent, function () {
	          return _this4.fireChangeEvent();
	        });
	
	        if (onClick) onClick();
	      }
	
	      return handleClick;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'handleKeydown',
	    value: function () {
	      function handleKeydown(ev) {
	        var _this5 = this;
	
	        var idx = getHandleFor(ev);
	
	        if (ev.keyCode === SliderConstants.KEYS.ESC) {
	          ev.currentTarget.blur();
	          return;
	        }
	
	        var proposedPercentage = this.getNextPositionForKey(idx, ev.keyCode);
	
	        if (proposedPercentage === null) return;
	
	        if (this.canMove(idx, proposedPercentage)) {
	          this.slideTo(idx, proposedPercentage, function () {
	            return _this5.fireChangeEvent();
	          });
	          var onKeyPress = this.props.onKeyPress;
	
	          if (onKeyPress) onKeyPress();
	        }
	
	        killEvent(ev);
	      }
	
	      return handleKeydown;
	    }()
	
	    // Apply user adjustments to position
	
	  }, {
	    key: 'userAdjustPosition',
	    value: function () {
	      function userAdjustPosition(idx, proposedPosition) {
	        var getNextHandlePosition = this.props.getNextHandlePosition;
	
	        var nextPosition = proposedPosition;
	        if (getNextHandlePosition) {
	          nextPosition = parseFloat(getNextHandlePosition(idx, proposedPosition));
	
	          if (Number.isNaN(nextPosition) || nextPosition < SliderConstants.PERCENT_EMPTY || nextPosition > SliderConstants.PERCENT_FULL) {
	            throw new TypeError('getNextHandlePosition returned invalid position. Valid positions are floats between 0 and 100');
	          }
	        }
	
	        return nextPosition;
	      }
	
	      return userAdjustPosition;
	    }()
	
	    // Make sure the proposed position respects the bounds and
	    // does not collide with other handles too much.
	
	  }, {
	    key: 'validatePosition',
	    value: function () {
	      function validatePosition(idx, proposedPosition) {
	        var _state5 = this.state,
	            handlePos = _state5.handlePos,
	            handleDimensions = _state5.handleDimensions;
	
	
	        var nextPosition = this.userAdjustPosition(idx, proposedPosition);
	
	        return Math.max(Math.min(nextPosition, handlePos[idx + 1] !== undefined ? handlePos[idx + 1] - handleDimensions : SliderConstants.PERCENT_FULL // 100% is the highest value
	        ), handlePos[idx - 1] !== undefined ? handlePos[idx - 1] + handleDimensions : SliderConstants.PERCENT_EMPTY // 0% is the lowest value
	        );
	      }
	
	      return validatePosition;
	    }()
	  }, {
	    key: 'validateValues',
	    value: function () {
	      function validateValues(proposedValues, props) {
	        var _ref = props || this.props,
	            max = _ref.max,
	            min = _ref.min;
	
	        return proposedValues.map(function (value, idx, values) {
	          var realValue = Math.max(Math.min(value, max), min);
	
	          if (values.length && realValue < values[idx - 1]) {
	            return values[idx - 1];
	          }
	
	          return realValue;
	        });
	      }
	
	      return validateValues;
	    }()
	
	    // Can we move the slider to the given position?
	
	  }, {
	    key: 'canMove',
	    value: function () {
	      function canMove(idx, proposedPosition) {
	        var _state6 = this.state,
	            handlePos = _state6.handlePos,
	            handleDimensions = _state6.handleDimensions;
	
	
	        if (proposedPosition < SliderConstants.PERCENT_EMPTY) return false;
	        if (proposedPosition > SliderConstants.PERCENT_FULL) return false;
	
	        var nextHandlePosition = handlePos[idx + 1] !== undefined ? handlePos[idx + 1] - handleDimensions : Infinity;
	
	        if (proposedPosition > nextHandlePosition) return false;
	
	        var prevHandlePosition = handlePos[idx - 1] !== undefined ? handlePos[idx - 1] + handleDimensions : -Infinity;
	
	        if (proposedPosition < prevHandlePosition) return false;
	
	        return true;
	      }
	
	      return canMove;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'fireChangeEvent',
	    value: function () {
	      function fireChangeEvent() {
	        var onChange = this.props.onChange;
	
	        if (onChange) onChange(this.getPublicState());
	      }
	
	      return fireChangeEvent;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'slideTo',
	    value: function () {
	      function slideTo(idx, proposedPosition, onAfterSet) {
	        var _this6 = this;
	
	        var nextState = this.getNextState(idx, proposedPosition);
	
	        this.setState(nextState, function () {
	          var onValuesUpdated = _this6.props.onValuesUpdated;
	
	          if (onValuesUpdated) onValuesUpdated(_this6.getPublicState());
	          if (onAfterSet) onAfterSet();
	        });
	      }
	
	      return slideTo;
	    }()
	
	    // istanbul ignore next
	
	  }, {
	    key: 'updateNewValues',
	    value: function () {
	      function updateNewValues(nextProps) {
	        var _this7 = this;
	
	        var slidingIndex = this.state.slidingIndex;
	
	        // Don't update while the slider is sliding
	
	        if (slidingIndex !== null) {
	          return;
	        }
	
	        var max = nextProps.max,
	            min = nextProps.min,
	            values = nextProps.values;
	        var algorithm = this.props.algorithm;
	
	
	        var nextValues = this.validateValues(values, nextProps);
	
	        this.setState({
	          handlePos: nextValues.map(function (value) {
	            return algorithm.getPosition(value, min, max);
	          }),
	          values: nextValues
	        }, function () {
	          return _this7.fireChangeEvent();
	        });
	      }
	
	      return updateNewValues;
	    }()
	  }, {
	    key: 'invalidatePitStyleCache',
	    value: function () {
	      function invalidatePitStyleCache() {
	        this.pitStyleCache = {};
	      }
	
	      return invalidatePitStyleCache;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this8 = this;
	
	        var _props9 = this.props,
	            algorithm = _props9.algorithm,
	            children = _props9.children,
	            disabled = _props9.disabled,
	            Handle = _props9.handle,
	            max = _props9.max,
	            min = _props9.min,
	            orientation = _props9.orientation,
	            PitComponent = _props9.pitComponent,
	            pitPoints = _props9.pitPoints,
	            ProgressBar = _props9.progressBar;
	        var _state7 = this.state,
	            className = _state7.className,
	            handlePos = _state7.handlePos,
	            values = _state7.values;
	
	
	        return (
	          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
	          _react2['default'].createElement(
	            'div',
	            {
	              className: className,
	              ref: this.setRef,
	              onClick: !disabled ? this.handleClick : undefined,
	              style: { position: 'relative' }
	            },
	            _react2['default'].createElement('div', { className: 'rheostat-background' }),
	            handlePos.map(function (pos, idx) {
	              var handleStyle = orientation === 'vertical' ? { top: String(pos) + '%', position: 'absolute' } : { left: String(pos) + '%', position: 'absolute' };
	
	              return _react2['default'].createElement(Handle, {
	                'aria-valuemax': _this8.getMaxValue(idx),
	                'aria-valuemin': _this8.getMinValue(idx),
	                'aria-valuenow': values[idx],
	                'aria-disabled': disabled,
	                'data-handle-key': idx,
	                className: 'rheostat-handle',
	                key: 'handle-' + String(idx),
	                onClick: _this8.killEvent,
	                onKeyDown: !disabled ? _this8.handleKeydown : undefined,
	                onMouseDown: !disabled ? _this8.startMouseSlide : undefined,
	                onTouchStart: !disabled ? _this8.startTouchSlide : undefined,
	                role: 'slider',
	                style: handleStyle,
	                tabIndex: 0
	              });
	            }),
	            handlePos.map(function (node, idx, arr) {
	              if (idx === 0 && arr.length > 1) {
	                return null;
	              }
	
	              return _react2['default'].createElement(ProgressBar, {
	                className: 'rheostat-progress',
	                key: 'progress-bar-' + String(idx),
	                style: _this8.getProgressStyle(idx)
	              });
	            }),
	            PitComponent && pitPoints.map(function (n) {
	              var pitStyle = _this8.pitStyleCache[n];
	
	              if (!pitStyle) {
	                var pos = algorithm.getPosition(n, min, max);
	                pitStyle = orientation === 'vertical' ? { top: String(pos) + '%', position: 'absolute' } : { left: String(pos) + '%', position: 'absolute' };
	                _this8.pitStyleCache[n] = pitStyle;
	              }
	
	              return _react2['default'].createElement(
	                PitComponent,
	                { key: 'pit-' + String(n), style: pitStyle },
	                n
	              );
	            }),
	            children
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Rheostat;
	}(_react2['default'].Component);
	
	Rheostat.propTypes = propTypes;
	Rheostat.defaultProps = defaultProps;
	
	exports['default'] = Rheostat;

/***/ },
/* 2534 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  getPosition: function () {
	    function getPosition(value, min, max) {
	      return (value - min) / (max - min) * 100;
	    }
	
	    return getPosition;
	  }(),
	  getValue: function () {
	    function getValue(pos, min, max) {
	      var decimal = pos / 100;
	
	      if (pos === 0) {
	        return min;
	      } else if (pos === 100) {
	        return max;
	      }
	
	      return Math.round((max - min) * decimal + min);
	    }
	
	    return getValue;
	  }()
	};

/***/ },
/* 2535 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var KEYS = exports.KEYS = {
	  DOWN: 40,
	  END: 35,
	  ESC: 27,
	  HOME: 36,
	  LEFT: 37,
	  PAGE_DOWN: 34,
	  PAGE_UP: 33,
	  RIGHT: 39,
	  UP: 38
	};
	var PERCENT_EMPTY = exports.PERCENT_EMPTY = 0;
	var PERCENT_FULL = exports.PERCENT_FULL = 100;

/***/ },
/* 2536 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 2537 */
2527,
/* 2538 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
		var imgsrcptn = /([^-])(image-set\()/
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 105 /* <at>i */
		var CHARSET = 99 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(length++)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											++caret
											code = first
											length = eof
											break
										}
										case COLON: {
											if (format > 0) {
												++caret
												code = first
											}
										}
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								switch (code = body.charCodeAt(caret)) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
									case FOWARDSLASH: {
										switch (second = body.charCodeAt(caret + 1)) {
											// /*, //
											case STAR:
											case FOWARDSLASH: {
												caret = delimited(second, caret, eol, body)
											}
										}
										break
									}
									// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
									case OPENBRACKET: {
										code++
									}
									// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
									case OPENPARENTHESES: {
										code++
									}
									// quote tail delimiter is identical to the head delimiter hence noop,
									// fallthrough clauses have been shifted to the correct tail delimiter
									case DOUBLEQUOTE:
									case SINGLEQUOTE: {
										while (caret++ < eol) {
											if (body.charCodeAt(caret) === code) {
												break
											}
										}
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first) {
									case NULL: {
										break
									}
									case AT: {
										if (second === IMPORT || second === CHARSET) {
											flat += chars + body.charAt(caret)
											break
										}
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON) {
											break
										}
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE:
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													// :globa<l>(
													if (pseudo + 7 === caret && tail === 108) {
														pseudo = 0
													}
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015: {
					// text-shadow/text-align/text-transform, a
					return out.charCodeAt(10) === 97 ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					if (out.charCodeAt(8) === DASH) {
						return webkit + out + out
					}
	
					// image-set(...)
					if (out.indexOf('image-set(', 11) > 0) {
						return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
					}
	
					return out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
							}
						}
					}
					break
				}
				// min/max
				case 973:
				case 989: {
					// min-/max- height/width/block-size/inline-size
					if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
						break
					}
				}
				// height/width: min-content / width: max-content
				case 931:
				case 953: {
					if (dimensionptn.test(input) === true) {
						// stretch
						if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
							return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
						else
							return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @param {number} at
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
			if (out !== content) {
			  return out
			}
		}
	
		/**
		 * @param {number} code
		 * @param {number} index
		 * @param {number} length
		 * @param {string} body
		 * @return {number}
		 */
		function delimited (code, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					// /*
					case FOWARDSLASH: {
						if (code === STAR) {
							if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
								return i + 1
							}
						}
						break
					}
					// //
					case NEWLINE: {
						if (code === FOWARDSLASH) {
							return i + 1
						}
					}
				}
			}
	
			return i
		}
	
		/**
		 * @param {number} type
		 * @param {number} index
		 * @param {number} length
		 * @param {number} find
		 * @param {string} body
		 * @return {number}
		 */
		function match (type, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					case type: {
						return i
					}
				}
			}
	
			return i
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					if (typeof plugin === 'function') {
						plugins[plugged++] = plugin
					}	else if (typeof plugin === 'object') {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
					} else {
						unkwn = !!plugin|0
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ },
/* 2540 */
/***/ function(module, exports) {

	function Agent() {
	  this._defaults = [];
	}
	
	["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
	 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
	  /** Default setting for all requests from this agent */
	  Agent.prototype[fn] = function(/*varargs*/) {
	    this._defaults.push({fn:fn, arguments:arguments});
	    return this;
	  }
	});
	
	Agent.prototype._setDefaults = function(req) {
	    this._defaults.forEach(function(def) {
	      req[def.fn].apply(req, def.arguments);
	    });
	};
	
	module.exports = Agent;


/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(1047);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  delete this._timer;
	  delete this._responseTimeoutTimer;
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  for(var option in options) {
	    switch(option) {
	      case 'deadline':
	        this._timeout = options.deadline;
	        break;
	      case 'response':
	        this._responseTimeout = options.response;
	        break;
	      default:
	        console.warn("Unknown timeout option", option);
	    }
	  }
	  return this;
	};
	
	/**
	 * Set number of retry attempts on error.
	 *
	 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
	 *
	 * @param {Number} count
	 * @param {Function} [fn]
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.retry = function retry(count, fn){
	  // Default to 1 if no count passed or true
	  if (arguments.length === 0 || count === true) count = 1;
	  if (count <= 0) count = 0;
	  this._maxRetries = count;
	  this._retries = 0;
	  this._retryCallback = fn;
	  return this;
	};
	
	var ERROR_CODES = [
	  'ECONNRESET',
	  'ETIMEDOUT',
	  'EADDRINFO',
	  'ESOCKETTIMEDOUT'
	];
	
	/**
	 * Determine if a request should be retried.
	 * (Borrowed from segmentio/superagent-retry)
	 *
	 * @param {Error} err
	 * @param {Response} [res]
	 * @returns {Boolean}
	 */
	RequestBase.prototype._shouldRetry = function(err, res) {
	  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
	    return false;
	  }
	  if (this._retryCallback) {
	    try {
	      var override = this._retryCallback(err, res);
	      if (override === true) return true;
	      if (override === false) return false;
	      // undefined falls back to defaults
	    } catch(e) {
	      console.error(e);
	    }
	  }
	  if (res && res.status && res.status >= 500 && res.status != 501) return true;
	  if (err) {
	    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
	    // Superagent timeout
	    if (err.timeout && err.code == 'ECONNABORTED') return true;
	    if (err.crossDomain) return true;
	  }
	  return false;
	};
	
	/**
	 * Retry request
	 *
	 * @return {Request} for chaining
	 * @api private
	 */
	
	RequestBase.prototype._retry = function() {
	
	  this.clearTimeout();
	
	  // node
	  if (this.req) {
	    this.req = null;
	    this.req = this.request();
	  }
	
	  this._aborted = false;
	  this.timedout = false;
	
	  return this._end();
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
	      self.end(function(err, res) {
	        if (err) innerReject(err);
	        else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	};
	
	RequestBase.prototype['catch'] = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	};
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	  // name should be either a string or an object.
	  if (null === name || undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
	      break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	      break;
	
	    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
	      this.set('Authorization', 'Bearer ' + user);
	      break;
	  }
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(on) {
	  // This is browser-only functionality. Node side is no-op.
	  if (on == undefined) on = true;
	  this._withCredentials = on;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
	 * Default 200MB.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 */
	RequestBase.prototype.maxResponseSize = function(n){
	  if ('number' !== typeof n) {
	    throw TypeError("Invalid argument");
	  }
	  this._maxResponseSize = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function() {
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header,
	  };
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	RequestBase.prototype._finalizeQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	  this._query.length = 0; // Makes the call idempotent
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if ('function' === typeof this._sort) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	// For backwards compat only
	RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout, errno){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  err.errno = errno;
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
	    }, this._responseTimeout);
	  }
	};


/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(2543);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field) {
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.created = 201 == status;
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	    this.unprocessableEntity = 422 == status;
	};


/***/ },
/* 2543 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, changesOrigin){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  // secuirty
	  if (changesOrigin) {
	    delete header['authorization'];
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sweetalert = __webpack_require__(2551);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _lodash = __webpack_require__(1922);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mousetrap = __webpack_require__(2066);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _warning = __webpack_require__(67);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _outsideTargetHandlerFactory = __webpack_require__(2546);
	
	var _outsideTargetHandlerFactory2 = _interopRequireDefault(_outsideTargetHandlerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALLOWS_KEYS = ['title', 'text', 'type', 'customClass', 'showCancelButton', 'showConfirmButton', 'confirmButtonText', 'confirmButtonColor', 'cancelButtonText', 'imageUrl', 'imageSize', 'html', 'animation', 'inputType', 'inputValue', 'inputPlaceholder', 'showLoaderOnConfirm'];
	
	var REMOVED_KEYS = ['timer', 'closeOnConfirm', 'closeOnCancel', 'allowOutsideClick', 'allowEscapeKey'];
	
	var OVERWRITE_PROPS = {
	  closeOnConfirm: false,
	  closeOnCancel: false,
	  allowOutsideClick: false,
	  allowEscapeKey: false
	};
	
	// reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
	var ALLOWS_INPUT_TYPES = ['button', 'checkbox', 'color', 'date', 'datetime', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week'];
	
	function warningRemoved(props) {
	  REMOVED_KEYS.forEach(function (key) {
	    (0, _warning2.default)(props[key] === undefined, '%s has been removed from sweetalert-react, pass `show` props and use event hook instead.', '`' + key + '`');
	  });
	}
	
	var SweetAlert = function (_Component) {
	  _inherits(SweetAlert, _Component);
	
	  /* eslint-disable react/no-unused-prop-types */
	  function SweetAlert(props, context) {
	    _classCallCheck(this, SweetAlert);
	
	    var _this = _possibleConstructorReturn(this, (SweetAlert.__proto__ || Object.getPrototypeOf(SweetAlert)).call(this, props, context));
	
	    _this._show = false;
	    return _this;
	  }
	  /* eslint-enable react/no-unused-prop-types */
	
	  _createClass(SweetAlert, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setupWithProps(this.props);
	
	      if (this.props.onOutsideClick) {
	        this.registerOutsideClickHandler(this.props.onOutsideClick);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setupWithProps(props);
	
	      var oldOutsideClickHandler = this.props.onOutsideClick;
	      var newOutsideClickHandler = props.onOutsideClick;
	
	      if (oldOutsideClickHandler !== newOutsideClickHandler) {
	        if (oldOutsideClickHandler && newOutsideClickHandler) {
	          this.unregisterOutsideClickHandler();
	          this.registerOutsideClickHandler(newOutsideClickHandler);
	        } else if (oldOutsideClickHandler && !newOutsideClickHandler) {
	          this.unregisterOutsideClickHandler();
	        } else if (!oldOutsideClickHandler && newOutsideClickHandler) {
	          this.registerOutsideClickHandler(newOutsideClickHandler);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unregisterOutsideClickHandler();
	      this.unbindEscapeKey();
	    }
	  }, {
	    key: 'setupWithProps',
	    value: function setupWithProps(props) {
	      var _this2 = this;
	
	      warningRemoved(props);
	      var show = props.show,
	          onConfirm = props.onConfirm,
	          onCancel = props.onCancel,
	          onClose = props.onClose,
	          onEscapeKey = props.onEscapeKey;
	
	      if (show) {
	        (0, _sweetalert2.default)(_extends({}, (0, _lodash2.default)(props, ALLOWS_KEYS), OVERWRITE_PROPS), function (isConfirm) {
	          return _this2.handleClick(isConfirm, onConfirm, onCancel);
	        });
	        this._show = true;
	        if (onEscapeKey) this.bindEscapeKey(onEscapeKey);
	      } else {
	        this.handleClose(onClose);
	      }
	    }
	  }, {
	    key: 'registerOutsideClickHandler',
	    value: function registerOutsideClickHandler(handler) {
	      this._outsideClickHandler = (0, _outsideTargetHandlerFactory2.default)(document.getElementsByClassName('sweet-alert')[0], handler);
	      this.enableOutsideClick();
	    }
	  }, {
	    key: 'unregisterOutsideClickHandler',
	    value: function unregisterOutsideClickHandler() {
	      this.disableOutsideClick();
	      this._outsideClickHandler = null;
	    }
	  }, {
	    key: 'enableOutsideClick',
	    value: function enableOutsideClick() {
	      var fn = this._outsideClickHandler;
	      if (fn) {
	        document.addEventListener('mousedown', fn);
	        document.addEventListener('touchstart', fn);
	      }
	    }
	  }, {
	    key: 'disableOutsideClick',
	    value: function disableOutsideClick() {
	      var fn = this._outsideClickHandler;
	      if (fn) {
	        document.removeEventListener('mousedown', fn);
	        document.removeEventListener('touchstart', fn);
	      }
	    }
	  }, {
	    key: 'bindEscapeKey',
	    value: function bindEscapeKey(onEscapeKey) {
	      _mousetrap2.default.bind('esc', onEscapeKey);
	    }
	  }, {
	    key: 'unbindEscapeKey',
	    value: function unbindEscapeKey() {
	      _mousetrap2.default.unbind('esc');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(isConfirm, onConfirm, onCancel) {
	      if (isConfirm !== false) {
	        if (onConfirm) onConfirm(isConfirm);
	      } else {
	        if (onCancel) onCancel(); // eslint-disable-line no-lonely-if
	      }
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose(onClose) {
	      if (this._show) {
	        _sweetalert2.default.close();
	        this.unbindEscapeKey();
	        if (onClose) onClose();
	        this._show = false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return SweetAlert;
	}(_react.Component);
	
	SweetAlert.propTypes = {
	  // sweetalert option
	  title: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['warning', 'error', 'success', 'info', 'input']),
	  customClass: _propTypes2.default.string,
	  showCancelButton: _propTypes2.default.bool,
	  showConfirmButton: _propTypes2.default.bool,
	  confirmButtonText: _propTypes2.default.string,
	  confirmButtonColor: _propTypes2.default.string,
	  cancelButtonText: _propTypes2.default.string,
	  imageUrl: _propTypes2.default.string,
	  imageSize: function imageSize(props, propName) {
	    if (!/^[1-9]\d*x[1-9]\d*/.test(props[propName])) {
	      return new Error('imageSize should have the format like this: "80x80"');
	    }
	  },
	
	  html: _propTypes2.default.bool,
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['pop', 'slide-from-top', 'slide-from-bottom'])]),
	  inputType: _propTypes2.default.oneOf(ALLOWS_INPUT_TYPES),
	  inputPlaceholder: _propTypes2.default.string,
	  inputValue: _propTypes2.default.string,
	  showLoaderOnConfirm: _propTypes2.default.bool,
	
	  // custom option
	  show: _propTypes2.default.bool,
	  onConfirm: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onEscapeKey: _propTypes2.default.func,
	  onOutsideClick: _propTypes2.default.func
	};
	SweetAlert.defaultProps = {
	  // sweetalert option
	  text: null,
	  type: null,
	  customClass: null,
	  showCancelButton: false,
	  showConfirmButton: true,
	  confirmButtonText: 'OK',
	  confirmButtonColor: '#aedef4',
	  cancelButtonText: 'Cancel',
	  imageUrl: null,
	  imageSize: '80x80',
	  html: false,
	  animation: true,
	  inputType: 'text',
	  inputPlaceholder: null,
	  inputValue: null,
	  showLoaderOnConfirm: false,
	
	  // custom option
	  show: false
	};
	exports.default = SweetAlert;

/***/ },
/* 2545 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDOMEquals;
	/**
	 * Determinate whether dom1 and dom2 is the same dom or not.
	 *
	 * @param  {HTMLElement}  dom1
	 * @param  {HTMLElement}  dom2
	 * @return {Boolean}
	 */
	function isDOMEquals(dom1, dom2) {
	  return dom1 === dom2;
	}

/***/ },
/* 2546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = outsideTargetHandlerFactory;
	
	var _isDOMEquals = __webpack_require__(2545);
	
	var _isDOMEquals2 = _interopRequireDefault(_isDOMEquals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param  {HTMLElement}  targetNode
	 * @param  {HTMLElement}  eventHandler
	 * @return {Boolean}
	 */
	function outsideTargetHandlerFactory(targetNode, eventHandler) {
	  return function (evt) {
	    evt.stopPropagation();
	    var current = evt.target;
	    var found = false;
	    while (current.parentNode) {
	      found = (0, _isDOMEquals2.default)(current, targetNode);
	      if (found) return;
	      current = current.parentNode;
	    }
	    eventHandler(evt);
	  };
	}

/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _colorLuminance = __webpack_require__(391);
	
	var _getModal = __webpack_require__(390);
	
	var _hasClass$isDescendant = __webpack_require__(299);
	
	/*
	 * User clicked on "Confirm"/"OK" or "Cancel"
	 */
	var handleButton = function handleButton(event, params, modal) {
	  var e = event || window.event;
	  var target = e.target || e.srcElement;
	
	  var targetedConfirm = target.className.indexOf('confirm') !== -1;
	  var targetedOverlay = target.className.indexOf('sweet-overlay') !== -1;
	  var modalIsVisible = _hasClass$isDescendant.hasClass(modal, 'visible');
	  var doneFunctionExists = params.doneFunction && modal.getAttribute('data-has-done-function') === 'true';
	
	  // Since the user can change the background-color of the confirm button programmatically,
	  // we must calculate what the color should be on hover/active
	  var normalColor, hoverColor, activeColor;
	  if (targetedConfirm && params.confirmButtonColor) {
	    normalColor = params.confirmButtonColor;
	    hoverColor = _colorLuminance.colorLuminance(normalColor, -0.04);
	    activeColor = _colorLuminance.colorLuminance(normalColor, -0.14);
	  }
	
	  function shouldSetConfirmButtonColor(color) {
	    if (targetedConfirm && params.confirmButtonColor) {
	      target.style.backgroundColor = color;
	    }
	  }
	
	  switch (e.type) {
	    case 'mouseover':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'mouseout':
	      shouldSetConfirmButtonColor(normalColor);
	      break;
	
	    case 'mousedown':
	      shouldSetConfirmButtonColor(activeColor);
	      break;
	
	    case 'mouseup':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'focus':
	      var $confirmButton = modal.querySelector('button.confirm');
	      var $cancelButton = modal.querySelector('button.cancel');
	
	      if (targetedConfirm) {
	        $cancelButton.style.boxShadow = 'none';
	      } else {
	        $confirmButton.style.boxShadow = 'none';
	      }
	      break;
	
	    case 'click':
	      var clickedOnModal = modal === target;
	      var clickedOnModalChild = _hasClass$isDescendant.isDescendant(modal, target);
	
	      // Ignore click outside if allowOutsideClick is false
	      if (!clickedOnModal && !clickedOnModalChild && modalIsVisible && !params.allowOutsideClick) {
	        break;
	      }
	
	      if (targetedConfirm && doneFunctionExists && modalIsVisible) {
	        handleConfirm(modal, params);
	      } else if (doneFunctionExists && modalIsVisible || targetedOverlay) {
	        handleCancel(modal, params);
	      } else if (_hasClass$isDescendant.isDescendant(modal, target) && target.tagName === 'BUTTON') {
	        sweetAlert.close();
	      }
	      break;
	  }
	};
	
	/*
	 *  User clicked on "Confirm"/"OK"
	 */
	var handleConfirm = function handleConfirm(modal, params) {
	  var callbackValue = true;
	
	  if (_hasClass$isDescendant.hasClass(modal, 'show-input')) {
	    callbackValue = modal.querySelector('input').value;
	
	    if (!callbackValue) {
	      callbackValue = '';
	    }
	  }
	
	  params.doneFunction(callbackValue);
	
	  if (params.closeOnConfirm) {
	    sweetAlert.close();
	  }
	  // Disable cancel and confirm button if the parameter is true
	  if (params.showLoaderOnConfirm) {
	    sweetAlert.disableButtons();
	  }
	};
	
	/*
	 *  User clicked on "Cancel"
	 */
	var handleCancel = function handleCancel(modal, params) {
	  // Check if callback function expects a parameter (to track cancel actions)
	  var functionAsStr = String(params.doneFunction).replace(/\s/g, '');
	  var functionHandlesCancel = functionAsStr.substring(0, 9) === 'function(' && functionAsStr.substring(9, 10) !== ')';
	
	  if (functionHandlesCancel) {
	    params.doneFunction(false);
	  }
	
	  if (params.closeOnCancel) {
	    sweetAlert.close();
	  }
	};
	
	exports['default'] = {
	  handleButton: handleButton,
	  handleConfirm: handleConfirm,
	  handleCancel: handleCancel
	};
	module.exports = exports['default'];

/***/ },
/* 2548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _stopEventPropagation$fireClick = __webpack_require__(299);
	
	var _setFocusStyle = __webpack_require__(390);
	
	var handleKeyDown = function handleKeyDown(event, params, modal) {
	  var e = event || window.event;
	  var keyCode = e.keyCode || e.which;
	
	  var $okButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  var $modalButtons = modal.querySelectorAll('button[tabindex]');
	
	  if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
	    // Don't do work on keys we don't care about.
	    return;
	  }
	
	  var $targetElement = e.target || e.srcElement;
	
	  var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
	  for (var i = 0; i < $modalButtons.length; i++) {
	    if ($targetElement === $modalButtons[i]) {
	      btnIndex = i;
	      break;
	    }
	  }
	
	  if (keyCode === 9) {
	    // TAB
	    if (btnIndex === -1) {
	      // No button focused. Jump to the confirm button.
	      $targetElement = $okButton;
	    } else {
	      // Cycle to the next button
	      if (btnIndex === $modalButtons.length - 1) {
	        $targetElement = $modalButtons[0];
	      } else {
	        $targetElement = $modalButtons[btnIndex + 1];
	      }
	    }
	
	    _stopEventPropagation$fireClick.stopEventPropagation(e);
	    $targetElement.focus();
	
	    if (params.confirmButtonColor) {
	      _setFocusStyle.setFocusStyle($targetElement, params.confirmButtonColor);
	    }
	  } else {
	    if (keyCode === 13) {
	      if ($targetElement.tagName === 'INPUT') {
	        $targetElement = $okButton;
	        $okButton.focus();
	      }
	
	      if (btnIndex === -1) {
	        // ENTER/SPACE clicked outside of a button.
	        $targetElement = $okButton;
	      } else {
	        // Do nothing - let the browser handle it.
	        $targetElement = undefined;
	      }
	    } else if (keyCode === 27 && params.allowEscapeKey === true) {
	      $targetElement = $cancelButton;
	      _stopEventPropagation$fireClick.fireClick($targetElement, e);
	    } else {
	      // Fallback - let the browser handle it.
	      $targetElement = undefined;
	    }
	  }
	};
	
	exports['default'] = handleKeyDown;
	module.exports = exports['default'];

/***/ },
/* 2549 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var injectedHTML =
	
	// Dark overlay
	"<div class=\"sweet-overlay\" tabIndex=\"-1\"></div>" +
	
	// Modal
	"<div class=\"sweet-alert\">" +
	
	// Error icon
	"<div class=\"sa-icon sa-error\">\n      <span class=\"sa-x-mark\">\n        <span class=\"sa-line sa-left\"></span>\n        <span class=\"sa-line sa-right\"></span>\n      </span>\n    </div>" +
	
	// Warning icon
	"<div class=\"sa-icon sa-warning\">\n      <span class=\"sa-body\"></span>\n      <span class=\"sa-dot\"></span>\n    </div>" +
	
	// Info icon
	"<div class=\"sa-icon sa-info\"></div>" +
	
	// Success icon
	"<div class=\"sa-icon sa-success\">\n      <span class=\"sa-line sa-tip\"></span>\n      <span class=\"sa-line sa-long\"></span>\n\n      <div class=\"sa-placeholder\"></div>\n      <div class=\"sa-fix\"></div>\n    </div>" + "<div class=\"sa-icon sa-custom\"></div>" +
	
	// Title, text and input
	"<h2>Title</h2>\n    <p>Text</p>\n    <fieldset>\n      <input type=\"text\" tabIndex=\"3\" />\n      <div class=\"sa-input-error\"></div>\n    </fieldset>" +
	
	// Input errors
	"<div class=\"sa-error-container\">\n      <div class=\"icon\">!</div>\n      <p>Not valid!</p>\n    </div>" +
	
	// Cancel and confirm buttons
	"<div class=\"sa-button-container\">\n      <button class=\"cancel\" tabIndex=\"2\">Cancel</button>\n      <div class=\"sa-confirm-button-container\">\n        <button class=\"confirm\" tabIndex=\"1\">OK</button>" +
	
	// Loading animation
	"<div class=\"la-ball-fall\">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    </div>" +
	
	// End of modal
	"</div>";
	
	exports["default"] = injectedHTML;
	module.exports = exports["default"];

/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _isIE8 = __webpack_require__(391);
	
	var _getModal$getInput$setFocusStyle = __webpack_require__(390);
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide = __webpack_require__(299);
	
	var alertTypes = ['error', 'warning', 'info', 'success', 'input', 'prompt'];
	
	/*
	 * Set type, text and actions on modal
	 */
	var setParameters = function setParameters(params) {
	  var modal = _getModal$getInput$setFocusStyle.getModal();
	
	  var $title = modal.querySelector('h2');
	  var $text = modal.querySelector('p');
	  var $cancelBtn = modal.querySelector('button.cancel');
	  var $confirmBtn = modal.querySelector('button.confirm');
	
	  /*
	   * Title
	   */
	  $title.innerHTML = params.html ? params.title : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.title).split('\n').join('<br>');
	
	  /*
	   * Text
	   */
	  $text.innerHTML = params.html ? params.text : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.text || '').split('\n').join('<br>');
	  if (params.text) _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($text);
	
	  /*
	   * Custom class
	   */
	  if (params.customClass) {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, params.customClass);
	    modal.setAttribute('data-custom-class', params.customClass);
	  } else {
	    // Find previously set classes and remove them
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.removeClass(modal, customClass);
	    modal.setAttribute('data-custom-class', '');
	  }
	
	  /*
	   * Icon
	   */
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide(modal.querySelectorAll('.sa-icon'));
	
	  if (params.type && !_isIE8.isIE8()) {
	    var _ret = (function () {
	
	      var validType = false;
	
	      for (var i = 0; i < alertTypes.length; i++) {
	        if (params.type === alertTypes[i]) {
	          validType = true;
	          break;
	        }
	      }
	
	      if (!validType) {
	        logStr('Unknown alert type: ' + params.type);
	        return {
	          v: false
	        };
	      }
	
	      var typesWithIcons = ['success', 'error', 'warning', 'info'];
	      var $icon = undefined;
	
	      if (typesWithIcons.indexOf(params.type) !== -1) {
	        $icon = modal.querySelector('.sa-icon.' + 'sa-' + params.type);
	        _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($icon);
	      }
	
	      var $input = _getModal$getInput$setFocusStyle.getInput();
	
	      // Animate icon
	      switch (params.type) {
	
	        case 'success':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animate');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-tip'), 'animateSuccessTip');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-long'), 'animateSuccessLong');
	          break;
	
	        case 'error':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animateErrorIcon');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-x-mark'), 'animateXMark');
	          break;
	
	        case 'warning':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'pulseWarning');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-body'), 'pulseWarningIns');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-dot'), 'pulseWarningIns');
	          break;
	
	        case 'input':
	        case 'prompt':
	          $input.setAttribute('type', params.inputType);
	          $input.value = params.inputValue;
	          $input.setAttribute('placeholder', params.inputPlaceholder);
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, 'show-input');
	          setTimeout(function () {
	            $input.focus();
	            $input.addEventListener('keyup', swal.resetInputError);
	          }, 400);
	          break;
	      }
	    })();
	
	    if (typeof _ret === 'object') {
	      return _ret.v;
	    }
	  }
	
	  /*
	   * Custom image
	   */
	  if (params.imageUrl) {
	    var $customIcon = modal.querySelector('.sa-icon.sa-custom');
	
	    $customIcon.style.backgroundImage = 'url(' + params.imageUrl + ')';
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($customIcon);
	
	    var _imgWidth = 80;
	    var _imgHeight = 80;
	
	    if (params.imageSize) {
	      var dimensions = params.imageSize.toString().split('x');
	      var imgWidth = dimensions[0];
	      var imgHeight = dimensions[1];
	
	      if (!imgWidth || !imgHeight) {
	        logStr('Parameter imageSize expects value with format WIDTHxHEIGHT, got ' + params.imageSize);
	      } else {
	        _imgWidth = imgWidth;
	        _imgHeight = imgHeight;
	      }
	    }
	
	    $customIcon.setAttribute('style', $customIcon.getAttribute('style') + 'width:' + _imgWidth + 'px; height:' + _imgHeight + 'px');
	  }
	
	  /*
	   * Show cancel button?
	   */
	  modal.setAttribute('data-has-cancel-button', params.showCancelButton);
	  if (params.showCancelButton) {
	    $cancelBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($cancelBtn);
	  }
	
	  /*
	   * Show confirm button?
	   */
	  modal.setAttribute('data-has-confirm-button', params.showConfirmButton);
	  if (params.showConfirmButton) {
	    $confirmBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($confirmBtn);
	  }
	
	  /*
	   * Custom text on cancel/confirm buttons
	   */
	  if (params.cancelButtonText) {
	    $cancelBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.cancelButtonText);
	  }
	  if (params.confirmButtonText) {
	    $confirmBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.confirmButtonText);
	  }
	
	  /*
	   * Custom color on confirm button
	   */
	  if (params.confirmButtonColor) {
	    // Set confirm button to selected background color
	    $confirmBtn.style.backgroundColor = params.confirmButtonColor;
	
	    // Set the confirm button color to the loading ring
	    $confirmBtn.style.borderLeftColor = params.confirmLoadingButtonColor;
	    $confirmBtn.style.borderRightColor = params.confirmLoadingButtonColor;
	
	    // Set box-shadow to default focused button
	    _getModal$getInput$setFocusStyle.setFocusStyle($confirmBtn, params.confirmButtonColor);
	  }
	
	  /*
	   * Allow outside click
	   */
	  modal.setAttribute('data-allow-outside-click', params.allowOutsideClick);
	
	  /*
	   * Callback function
	   */
	  var hasDoneFunction = params.doneFunction ? true : false;
	  modal.setAttribute('data-has-done-function', hasDoneFunction);
	
	  /*
	   * Animation
	   */
	  if (!params.animation) {
	    modal.setAttribute('data-animation', 'none');
	  } else if (typeof params.animation === 'string') {
	    modal.setAttribute('data-animation', params.animation); // Custom animation
	  } else {
	    modal.setAttribute('data-animation', 'pop');
	  }
	
	  /*
	   * Timer
	   */
	  modal.setAttribute('data-timer', params.timer);
	};
	
	exports['default'] = setParameters;
	module.exports = exports['default'];

/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	// SweetAlert
	// 2014-2015 (c) - Tristan Edwards
	// github.com/t4t5/sweetalert
	
	/*
	 * jQuery-like functions for manipulating the DOM
	 */
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation = __webpack_require__(299);
	
	/*
	 * Handy utilities
	 */
	
	var _extend$hexToRgb$isIE8$logStr$colorLuminance = __webpack_require__(391);
	
	/*
	 *  Handle sweetAlert's DOM elements
	 */
	
	var _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition = __webpack_require__(390);
	
	// Handle button events and keyboard events
	
	var _handleButton$handleConfirm$handleCancel = __webpack_require__(2547);
	
	var _handleKeyDown = __webpack_require__(2548);
	
	var _handleKeyDown2 = _interopRequireWildcard(_handleKeyDown);
	
	// Default values
	
	var _defaultParams = __webpack_require__(1048);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	var _setParameters = __webpack_require__(2550);
	
	var _setParameters2 = _interopRequireWildcard(_setParameters);
	
	/*
	 * Remember state in cases where opening and handling a modal will fiddle with it.
	 * (We also use window.previousActiveElement as a global variable)
	 */
	var previousWindowKeyDown;
	var lastFocusedButton;
	
	/*
	 * Global sweetAlert function
	 * (this is what the user calls)
	 */
	var sweetAlert, swal;
	
	exports['default'] = sweetAlert = swal = function () {
	  var customizations = arguments[0];
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(document.body, 'stop-scrolling');
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.resetInput();
	
	  /*
	   * Use argument if defined or default value from params object otherwise.
	   * Supports the case where a default value is boolean true and should be
	   * overridden by a corresponding explicit argument which is boolean false.
	   */
	  function argumentOrDefault(key) {
	    var args = customizations;
	    return args[key] === undefined ? _defaultParams2['default'][key] : args[key];
	  }
	
	  if (customizations === undefined) {
	    _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert expects at least 1 attribute!');
	    return false;
	  }
	
	  var params = _extend$hexToRgb$isIE8$logStr$colorLuminance.extend({}, _defaultParams2['default']);
	
	  switch (typeof customizations) {
	
	    // Ex: swal("Hello", "Just testing", "info");
	    case 'string':
	      params.title = customizations;
	      params.text = arguments[1] || '';
	      params.type = arguments[2] || '';
	      break;
	
	    // Ex: swal({ title:"Hello", text: "Just testing", type: "info" });
	    case 'object':
	      if (customizations.title === undefined) {
	        _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Missing "title" argument!');
	        return false;
	      }
	
	      params.title = customizations.title;
	
	      for (var customName in _defaultParams2['default']) {
	        params[customName] = argumentOrDefault(customName);
	      }
	
	      // Show "Confirm" instead of "OK" if cancel button is visible
	      params.confirmButtonText = params.showCancelButton ? 'Confirm' : _defaultParams2['default'].confirmButtonText;
	      params.confirmButtonText = argumentOrDefault('confirmButtonText');
	
	      // Callback function when clicking on "OK"/"Cancel"
	      params.doneFunction = arguments[1] || null;
	
	      break;
	
	    default:
	      _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Unexpected type of argument! Expected "string" or "object", got ' + typeof customizations);
	      return false;
	
	  }
	
	  _setParameters2['default'](params);
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.fixVerticalPosition();
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.openModal(arguments[1]);
	
	  // Modal interactions
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  /*
	   * Make sure all modal buttons respond to all events
	   */
	  var $buttons = modal.querySelectorAll('button');
	  var buttonEvents = ['onclick', 'onmouseover', 'onmouseout', 'onmousedown', 'onmouseup', 'onfocus'];
	  var onButtonEvent = function onButtonEvent(e) {
	    return _handleButton$handleConfirm$handleCancel.handleButton(e, params, modal);
	  };
	
	  for (var btnIndex = 0; btnIndex < $buttons.length; btnIndex++) {
	    for (var evtIndex = 0; evtIndex < buttonEvents.length; evtIndex++) {
	      var btnEvt = buttonEvents[evtIndex];
	      $buttons[btnIndex][btnEvt] = onButtonEvent;
	    }
	  }
	
	  // Clicking outside the modal dismisses it (if allowed by user)
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay().onclick = onButtonEvent;
	
	  previousWindowKeyDown = window.onkeydown;
	
	  var onKeyEvent = function onKeyEvent(e) {
	    return _handleKeyDown2['default'](e, params, modal);
	  };
	  window.onkeydown = onKeyEvent;
	
	  window.onfocus = function () {
	    // When the user has focused away and focused back from the whole window.
	    setTimeout(function () {
	      // Put in a timeout to jump out of the event sequence.
	      // Calling focus() in the event sequence confuses things.
	      if (lastFocusedButton !== undefined) {
	        lastFocusedButton.focus();
	        lastFocusedButton = undefined;
	      }
	    }, 0);
	  };
	
	  // Show alert with enabled buttons always
	  swal.enableButtons();
	};
	
	/*
	 * Set default params for each popup
	 * @param {Object} userParams
	 */
	sweetAlert.setDefaults = swal.setDefaults = function (userParams) {
	  if (!userParams) {
	    throw new Error('userParams is required');
	  }
	  if (typeof userParams !== 'object') {
	    throw new Error('userParams has to be a object');
	  }
	
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.extend(_defaultParams2['default'], userParams);
	};
	
	/*
	 * Animation when closing modal
	 */
	sweetAlert.close = swal.close = function () {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(_sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay(), 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(modal, 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'showSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(modal, 'hideSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'visible');
	
	  /*
	   * Reset icon animations
	   */
	  var $successIcon = modal.querySelector('.sa-icon.sa-success');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon, 'animate');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-tip'), 'animateSuccessTip');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-long'), 'animateSuccessLong');
	
	  var $errorIcon = modal.querySelector('.sa-icon.sa-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'animateErrorIcon');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon.querySelector('.sa-x-mark'), 'animateXMark');
	
	  var $warningIcon = modal.querySelector('.sa-icon.sa-warning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon, 'pulseWarning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-body'), 'pulseWarningIns');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-dot'), 'pulseWarningIns');
	
	  // Reset custom class (delay so that UI changes aren't visible)
	  setTimeout(function () {
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, customClass);
	  }, 300);
	
	  // Make page scrollable again
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(document.body, 'stop-scrolling');
	
	  // Reset the page to its previous state
	  window.onkeydown = previousWindowKeyDown;
	  if (window.previousActiveElement) {
	    window.previousActiveElement.focus();
	  }
	  lastFocusedButton = undefined;
	  clearTimeout(modal.timeout);
	
	  return true;
	};
	
	/*
	 * Validation of the input field is done by user
	 * If something is wrong => call showInputError with errorMessage
	 */
	sweetAlert.showInputError = swal.showInputError = function (errorMessage) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorIcon, 'show');
	
	  var $errorContainer = modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorContainer, 'show');
	
	  $errorContainer.querySelector('p').innerHTML = errorMessage;
	
	  setTimeout(function () {
	    sweetAlert.enableButtons();
	  }, 1);
	
	  modal.querySelector('input').focus();
	};
	
	/*
	 * Reset input error DOM elements
	 */
	sweetAlert.resetInputError = swal.resetInputError = function (event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Disable confirm and cancel buttons
	 */
	sweetAlert.disableButtons = swal.disableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = true;
	  $cancelButton.disabled = true;
	};
	
	/*
	 * Enable confirm and cancel buttons
	 */
	sweetAlert.enableButtons = swal.enableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = false;
	  $cancelButton.disabled = false;
	};
	
	if (typeof window !== 'undefined') {
	  // The 'handle-click' module requires
	  // that 'sweetAlert' was set as global.
	  window.sweetAlert = window.swal = sweetAlert;
	} else {
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert is a frontend module!');
	}
	module.exports = exports['default'];

/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2553);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(136)(module)))

/***/ },
/* 2553 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	
	var space = __webpack_require__(2556)
	
	/**
	 * Export.
	 */
	
	module.exports = toCamelCase
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toCamelCase(string) {
	  return space(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase()
	  })
	}


/***/ },
/* 2555 */
/***/ function(module, exports) {

	
	/**
	 * Export.
	 */
	
	module.exports = toNoCase
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/
	var hasSeparator = /(_|-|\.|:)/
	var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase(string) {
	  if (hasSpace.test(string)) return string.toLowerCase()
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
	  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
	  return string.toLowerCase()
	}
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate(string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : ''
	  })
	}
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize(string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
	  })
	}


/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(2555)
	
	/**
	 * Export.
	 */
	
	module.exports = toSpaceCase
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toSpaceCase(string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : ''
	  }).trim()
	}


/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(2558);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(74);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/App.952a8515.scss";

/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/auto2.fbf6d972.png";

/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/canvas.26c20ef5.png";

/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chip1.2cdbbb2f.png";

/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chip2.251cc401.png";

/***/ },
/* 2564 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ImageSensor.09605714.png";

/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/LandingPageLogo4.fe15887a.png";

/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Screenshot.71d0ee69.png";

/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Welcome to ITB 2.0.b2588bd2.mp4";

/***/ },
/* 2569 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2570 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAnCAYAAACFSPFPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFrSURBVHgB7ZbPTcMwFMY/t4AqwSEjhA16JJySDdwJUCegR/5JTaU0YguYALwBnNJKXLIBYQLgwAEQMc8KKVKRD47TqkL+SdFzbFn+9D7bz4DDYQZb7gj4+R2D9LFiJJDPRDqATswBP/E76D5iXXTgZzfTp9/fDcKJ0eHE6HBidKxETAkWldjel2ADk3lbaB02mYvkXrUO6TY3mdl2ZopMJHEl5GxMwYcBrYop8RWpqMoKZSiGISY25eqjfeBRIeV/h5U9l4VqUX0zsqfGKDOZmA5nIqFNKSdLQ1b2NBHTp4XiSlSqYl4P2NrTRAzBxtWCwCfk8KdvYQ9D9woWGG/gesEHkeYlCartCfjFMT2OQljQQAzCgJ+OVHsu0msVVbaoP4YljY42Q2dhV/WvsiU9WNL0Bvbo+N6GfBS9Y++IjnqIFrApB/0P7D4z9bRuCfeE0OHE6HBidGyumB56LxQKrIdip3x7hcPxX/gGwXtiugfAQA4AAAAASUVORK5CYII="

/***/ },
/* 2571 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAjCAYAAAAaLGNkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADDSURBVHgB7dexDcIwEIXhdwlCKTNCRqAMVBnBK7ABJYImTXpGYAIwE0AVxsBMgHsKY4QOBYmUTlzc10QnRfIv2c0RvLnangmoMLx9q5sllWpdJEhvGEsCf34EJt3BwZ0cpisEluJ5dMDsbwSBHlddGwTm36ClzhzFdUgEkwgmEUwimEQwiWASwSSCSQSTCCYRTCJYfLuoXwTVQm0qBEf5e/PtiXD554fQ3M+UZMis/xqMw7SH5v5djktVFxhYBmsvemdfN8ckja1DNhcAAAAASUVORK5CYII="

/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/decisions-wait-for-sales.a03c7945.png";

/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/distribution-centers.ea9e381c.png";

/***/ },
/* 2574 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dominate-personalities.de1af478.png";

/***/ },
/* 2575 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATQSURBVHgBtVhvUiJHFH+vB9Q1cYMVNbWfgidYcoLFEyx+SBWaVbFyAPEE4AnEEzjoxiXJhyUnCJ4g7AmWfNoq/5QksSIrTL99b2CGZmBkcJdfFdRMd8/rX79+/7oRJsT7TCbx9cKTHAI9R8QUNyUIICl9CNAgggY/NTToc6cNtWeVSmMC8SIjGi5fZdNMoMBfpGESENQ0UHnltGJHGT6W0KOJDE/U0Jp2l19XamPGheN6Z+OQtyA/1MGrJqRz1Fhvd6juNVtKJZSiJClKIcELQEwPTUiq9O3pL/swCaEP2WxyZgbfsm2k+gOxyXZxRB2nunL2ex0i4EMum7Q0FBXgTmDS+v09rY+yLwwh86dnqC5YI22Ldp/ZkxmoSSzuwLGpMdlCJrUWJDVE6Hp74y9TMwR4sHxyVoQvgMvtbJE1XTAmryt1t7ZoV5temxogIzYzJTKC5ZNKkYAO+vIhpZ2vCuYYX0NXrzYyTO/ttMiYCGqKNK153udrCBUcQp9NbVpkBKIpIKp570rhsf8sfxdb2ZxpxGLAMGW0LeA50LUdmdvdIUasx6rvlkh2mDddbWX9lbTbcBCWFsRT43Hwt2TptDK0QJmDt+7I3zqEPf6vKvnYdMc2wgGEgA3yHY/NyU9Cg/vtCDLS541jW3wXJi+m5kr+C2eCm583v1dW3EgJbDsPxZrl019LnpeImiV4Bsf0AmqyO4Yd4/RNKUzeom03TVvqcLBUHEVf9vnAHzAGXYOEam986nrrJ98ZBsIGQjWKYzBpf05U9DyGCEnyeylSSrCs2V2tP6ZEE4Q6f729ycbJOb2X9yQK/4t3kRwDpVxB7xnTihkmvc7YrHofRYio+l7RmkzsrgOIAx4WPTLSt2pE34fQjvWVwAtMsINRwu91/v8HIkJszenguue6vgiF65PkvDmYM79PKPgMOFo3uXI0BTadlo6kmTCogRVa89/ABDA9qoeEtN3kMomoMlrQMsc2lblC5yP9ABERSMRHbNNleZA2x5k/jCon1ukviINkQzlA514D4cBqw8lsZwumR/2n7opWbDYv5URXMuXY8wpRZEH3oOCCC8C/Fbtavc8QXo77nifaG+VRPc9bNz3vantjZywfoP6chDXVsahq9KYf2v+LzU1ZTbE7FF3XNz1qhOeVLjZ/TIXJC6Yt4aJcgWb41vP5MAEq7vA2UFO00NGdkSXtytlZXZPelzH8a2LMKobJm4njnvfMC6yLPDdGSvmh0K9Jmpa6W12MGNgei24SVlwud+OgJtqVs5sbh+TB23tGwnGeHMOUEY+rgkdG5vYOkn5glEOcPxohc7m1kYcpQbxUPNF7d6hfZw+cOrhqs5mi6Rm5pZM3ZfiC6Hme7TdwQbhU7hdwA6mjF0saRpMdOZ5EgIQMk4wbw7A1cIodPijyoW5GBw+KaLfb+mDSmwwPcmOysDDPB0XKmGSCYaPXPoxRpLqaQ/v+XpejEhMiT5/Oi1byZFQVYWR6faNxk8sl2rpVCp7LXXDFyGTPpaC7vW3VV6vdECGubCkngVYs7Ub90TcmZU41+bB6aex1jMQoi69jAll9YnSDqbP/3evfqmPGRcOjicnVDdfqt9adHaWKjEzIJ8b5DC2SLXnRq8dTAYFyrVf3tnTcBVUQnwBdXF0NXu6HegAAAABJRU5ErkJggg=="

/***/ },
/* 2576 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALjSURBVHgB3VVNTttQEJ73YiIqsXClEImde4P0BCQnwFm0ChHQcALKCRAnAE6AKSiJ2gXpCRJOkNyg3lVNQfWiiwrHns7nYMt2kiZ0yWyePW883/x+JnopopYZ/NxrVEmpHa2oKuYWE5uKlEfEbsg04GByVW5/Gf0XyPdGw1pbU5cUOU+MXWZ2lVImE1USY6ae7/PxVrfrrgxyf7D7QaI9R9SEaJlPfxt/Rm+cnpex29u1SfGRZFqVV9x9LH3qXC0FAYAcDkoSivPN6845LZHxfqOllT4jBEXUygNlQFCiYlEP8RxoqpWd9ohWlHGzWdEG9VE7/5Hfpkun04bSgzOUKODw+DkAkHK7PWIOTuXRjHo5L5Nx851EYgzRg9J1p5aJsBBWfJ8G6eimg0FVZnI3b7qDWH+/3+ijRxxyLdYnmQhAK3pgukhHERRDT6bppFhU/V8t24wB8A79xCA3bS+gp1H0WtmJ71RK2zhLN51e+qMtp+sGE1VnUmYQvLqFDuWQEbYCreq4T9sbxvpo6k9tz4CIE0su5vYB9Q6lT9iZh4PdIU6JeG7fXjuOF+0TsTUDgvGTffBogZSvu47UYoAlFAdf/zXaWFg5zDkgSmpP1qIPf+y9t9FQRCkZ70R0s0DACDRdziyIEi5CnePmpgWNNrRxCYBHzTU5R9LYW+jngSBbCcSdAZGLO5yTyXolD4BJEgsPAGi0nHUB8qDPA0VUE/nju1mQkHtPqZ6kPzIMskLiqxgAunjioMc9ZWolXCYS6omTqDJRxIskk7MKZ+VlymGy7cLKstD1mUwgfoEOnwbgBAxAzxAwQ0FIEsTqF/g4fZcBQRmifZDxEwboIzJaQR4OmkcFIceY9/ILOvd/kqFu4TLi4KJ08znDBN9s29zYWK9EPZTlRAYRsWKfcrL4z9gSAmQ+I9Z2yliYlqJ9wrgnxhKIlOgwn8FSkCQrqTUZQatAejv/jw8ovFOh6qVZ+GXLX8IqasPIhdTKAAAAAElFTkSuQmCC"

/***/ },
/* 2577 */
2575,
/* 2578 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/finance-interest-charged.9ee8a2ee.mp4";

/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/finance-lending-rate.2128c158.mp4";

/***/ },
/* 2580 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/finance-loan-repayment.cc2ed879.mp4";

/***/ },
/* 2581 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hawk.611a474f.png";

/***/ },
/* 2582 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQTSURBVHgBzVhdctNIEO4eyU6ohFrnBCtOsOYE65yA8EZls0VygC1HJ7B9AiUL7zFFoHgjOUHMCTAnQJwgokggxJppumVLHttyRTLGxVdle0aan88909NfD0JJPAm+eQ7oHXDwL0XQAKAaAdbkHQJFXA4BMSRt3mkYnL3xt8ISw/MYBbEbXO0rRz0FogaUQ98YOn7tb3aLNL6T0F7wpYFKnRCABz8BnijUhjp3EZtLaCe4rN131lpEdDjzkqhHBOcIJoyh0r+B9Uger8NNzYXY42WrI8IjXrrGTFfEo4r+3un6W1FhQk+CS89V1bdcrFuPIzDm+Ao2j858zB1sdpxkv7VR4dOpScOBud3O21+YR6aiqhcTS8QWick5eOPfC2EB5BGbR2qCULJMqvp+goyBzqm/0YYlgPdjG5RqWY/6LpOyl0/ZHZI9Y5EhQ/6yyAhO/fttGdN6VB/wnHabzEKJWys8yd4s0TLTmLGUMdtMtjdB6N/j64+pddiDuq8ONw4KDt7gwS+G49JDdut+oX7/X12wyzVGJMKXzY0HUk6WTKxjL5Um1YEFoPjULto21o784WTvyNzCYTiGfClopg3FOot6Uxkkc/AxktaTKCC/4uZstOy8WdQ6i4AP0aOswiFp9zn9qRyo7IwfYm8V1kmRuDtSL63j4PqxQgf/zviQOYcVgzSM50RWEMzCy+pAhTxkmZB4mJYVQoM3NXrpA1PZ/AgrhgTntMzeVhMvy1y1Oog+w4rBCsEO1DUFvxmEUMbwtlL7A1YM1lL2YRq5fGxHNFo2Gnx5yD+foARiiEOHql0pa3BDKAkRdFaMD12OP+9Yp3hSU6A8KImRnikU9/KQqMu0bOCTUMt2OTrqEawY6IA1J/VQ1JyrTObuLJi25undPOwGl3XlrAVSNtr4RaO9YCSVs7ljox6oJFRYx3cM1UMoAaUqJ0lqxJ8JPVUAjlOdUI/CJdlNRsOL8QzQHAbcYsBRklgWMgcS7Kd1yd2G0zMkV0oyziFqrrNW+J+S0f6ob6RZZRbtZ1tH+qf5WqYYbeWXQKn26X/3fokU2Xt23WKJ3E7rbJ2DlFB2ACSa1hJMXG7/E3wttZ+KkfnatMnAVJo9ETr4kJKG42NAUbD37FsLlkZGLEOZKJOluoLJRCInUeSkTtEFSxEv64jQ1fq2U/YmYzwmu7fsS+uiQshog9vTgnBOKj1LahFiknhuuutNNPqQLG/kcp/JPM5Tp3MvG/Z5sBhcyZ+aMy8Re3z/cy6CjtuENyMJsc6B0oVBnTgEJad+3tUN7xlZpnn3A3dex0h6wtcxrWlrlYUsEVvqIE0I56HchRVyuoRYhzLgiwpD8GJpF1bTSK/0ECU5YKshejBWnRGfvpEB6DGRDxqcs7JZzA9FmOuGGp8SjQAAAABJRU5ErkJggg=="

/***/ },
/* 2583 */
2582,
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-customer-preferences.2fa1bd33.png";

/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-new-valuation-model.baa9a56d.png";

/***/ },
/* 2586 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-onboarding-image18.acbed743.png";

/***/ },
/* 2587 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-onboarding-image19.5ac2001d.png";

/***/ },
/* 2588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-onboarding-image20.72630449.png";

/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-performance-feedback-thats-all.4717f49d.png";

/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-successful-teams1.43f45619.png";

/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-successful-teams2.c1182c27.png";

/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instructor-what-to-expect-next.91040731.png";

/***/ },
/* 2593 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFQSURBVHgBxVNLbsIwEJ2xKGLJEbKuQCJL6AafoNwAeoKWE8AN2huUHqEncKKqhK6MRBqWzRFYViw8HSckakKNsuuTEtszb74eA1yAetuNVaS9SxzhUoSb5B5bQiG0v8Jov3Dx8Cyq1l387jwCmBkRvWQkxCkvK+oc59L3D04HNl2OqHjrsfFcjnpPuXy3RBA2i5TgKOXQT89KCD/2U6QrbX0SGFkYW8hhf0mGfKtDbGv1Hs8qDth4QcasWL8lQI7QD+qlyZtepgMDKQp8VuvkoVQGUaKCzaeGhgjWsQ6i2JYKrVJKVDbH3gARTH4b8flVjq7zslAw11R7UCNP+DfISfyRGSCa27+4LXABaTse9mSWMpdYRKzDOUhN8f8O8h4g34ARXuXhkOg6z0RdnplD6YCAQkSY2IdzYmdD7jxjJrk7bXPwvI/BoAdNICgtpvUHXPCXTQuN+q8AAAAASUVORK5CYII="

/***/ },
/* 2594 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD7SURBVHgBzZIvD8IwEMVbJGCHngcNGs2wm55mEk8yjcPwFViCAz2PZho0WIYd7+CVNM3446DJL7fr3b2111Pq10u/ClRV1YHx6R601uevBFDYhYlA1wkVYOEKaac4gInBHmTgiIKSoiHoyT72Vqrmz32wBpE5CUhADDzuhczpm7oGAx7/nIs6/RR4vMpSBBGTU22ACDefAlgD2ow2YONmYMorDZ2csS0gai1woS/fV+uGbVBauaXxjcCWNqLN5eg45hzIVfyanJ360MQOG5jwFWqb6IqYhNQqavJFUsZGdk3dIMkETtTjze11nw00tXgr4Aj5dGWgTuov1w1jP6lh8V+nOAAAAABJRU5ErkJggg=="

/***/ },
/* 2595 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEYSURBVHgBxVJLbsJADLWHj7pMT9B02dJKZFWlbDI3KCeIOEGvkJ6AI7Q3KDeYqaqUZVCh+xwhS9qKGFsQCBCEsuJt7PHYb57tATg3sHDM1/cTYuP9RH4a+J3rcqC58Ug5Qkc5DY48FSBiaMc/r5zzoXt3b7sEaxQX+zDxTEhCIHAQYWjiqat795GCmggeO31QaFGpq0oFp8AtEKvgjrEv59oKZEZ08XepH25HuwSYZ2JMkjiVlQgy5ExmpD0vK8Jbgt+FBaIM5+2hGSduudZ8TmUDzyx9dMhbToxnXR4O/wVyK8RbgsZA+zfpUYJNC/NmF3Isk0xY+gQqO5MikZy3AqgD9W+176WrNVIrQoVhnXqC9gubCM6OJWhkWz3+zk4LAAAAAElFTkSuQmCC"

/***/ },
/* 2596 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFASURBVHgBxVFBToNQEJ35ItWVHIGtsSa6pC6EE4gnUE4gNwBuoCeAm/w2RrukidX19wZsrSnT+UBbQpuUXSf58+dP/nvzZgbg2IbayWluIwxSAHJ7omZEi0fPuVVGlSAj5KRNJQW98EJEQKchh6FoUhY7Bf1NIeKFDoxtjlwU6PbDk3ZZhwAy17nq1YL8nGesALoElY2n3+m2ziLRg5LvXy4a4olBRUl/bwAnMTV/xI64svytJepzBvJj/sxgCUQ3ROAjmjmUS8tzLtVeBd7dddxRFFXtjYZB/f6RKOCFw6BFQAVv4kFX2yDF/1jL58oWV560NCo+9vpVE6DxCrS85y20+jcTvmJe+gyRIp6DAoE2E/rcXLL+h3DApMwtPDdTZvT5FA2q4AF7WuFBgg1RnltVoJsdmJKAJt5oGMLRbQXEp3jxtcjyjgAAAABJRU5ErkJggg=="

/***/ },
/* 2597 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHQSURBVHgBjVNLctNAEO2eyB924QbOkooppKVCUaU5AeYEsU8AnID4BHADwwlMTiBRFDE7GTBZixOgBUUSx5lH91gRUcX5vCpVSZp53f3em2G6J9I836a/rZ68huRQULAqbBwVfCdxlvcMd17CuSExb19dQ3f50NxK/rIIGa0coAGIxqDlThLvMsjs+A1/grBRIP38I9GnJjOlQjxE9yyye/131KVS12z8qLjk1BI+fT1+C+DVejaU1XKW7O2+0Lds9nOiEtA5G9E59fiinWPlrLnUqWQQRiBn11xT4sFyVOsFvhFcaaOopPNWKK1L++xxFqzHaKeyJbNx/33VqQSx9ZsreAm0ToNP+Q2BPup3kM685p6WyWbHWiiRKUZSrKAN4JO2NhA+j2sP0qPvAyKTyMe+/Jkncd9eS8R37kxFSyhyrH3anzdM9EYdLX6D6bVKaZDFI+b2VCcFTHQ1hTrGNJWTJi4bmCcNssapHkFOoKJ7WjYkNTsthkw8YTIHzl38YubnsmOgBoO2xkwu1ejU/WsTKHT0KsoDNjyRX4mcwkPvyWpFm7DxLviLozgJpJDZJ/DcpwN8kDiHdxaoC0k6zFtTTQZwYu7/0e+N6pzciH9iDdyvnth4PQAAAABJRU5ErkJggg=="

/***/ },
/* 2598 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGJSURBVHgBtVJBTsJQEJ33QXTJDaxLNSawMuzaG9QTYI/ACdATGE8A3ABO0CZGWEIU1/YIXWmKoeP8aSHFIiudpPn9M2/ezLz5RP9p4fPy1n6HMFDgbO7Y0+u043A+b9LHka9BY7r25CwbySUhpAvFlPA5wXQ5BMwpUxqAGqG4nF8KxkwrD2g8EFPidi4Dk/fBQ6njSvK7bYrJnEkQzDyS6FD/xWdjimHy2WBiU03eylVk2bVdziZe5zz+WTr3cVQMnnjXF+MtQTh9sTM7UvERBl3VYZ8x+4LpSQfN8OnV3RLA1LrKnn7d2eBGxLLpNoAmoSaVEaFe6yuBKiozESOhhibGG/XLpj7QgrK1VObYamY7rRPXWrpMkA+gqMzOnv5dKSREGGxdn8euoXQdyWyyY4w540DFBI2rBIhsTDEscVmj5CyM57UTpsw6Wzk7x8ymV6lPCOwIijEiOLKbfdvaFU4eWDR7GxzCoJIkospj6RdXtzijvIvVvX2+ZXy9ynki35rKibuxP7ZvAG6uAOOMgb4AAAAASUVORK5CYII="

/***/ },
/* 2599 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgBvZHNDYMwDEY/B3pnBDZpRmAEVukk7QYdwbkUjpGqtteO0VMT/iSQEAJiBE9KJMvWsy0De2HK95VLmy7VqZlcDnfS2CBYxTECfrzy5okFIGhSdJYLZugFXDyz+nRfBDJM4FVS/ykCCV6BrU24+GRiAX6RJvJ3uaBbFXLBiHhQRQb43/pGzl2gYtMGBOPhJ+s2UwFj5ikPrWHiqAAAAABJRU5ErkJggg=="

/***/ },
/* 2600 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFbSURBVHgBjVJNTgJRDG4fP6Ou5gbi0ogJLAkL590ATgAcwROgN3BOoJ4AbzCTGGE5KLqWGzgrFYmvtuAQmHlhpknz+tovX7+0Rfi3IIpc+Kx0IM9QxXC4CHWzGcu3vCksoYYKb3MJgIC+nC4HD9ZyOHmj4Om1n85LTmrpfBmsKqHH4ItU55oNqyy5OSA2ROqOEzSAcJpLQEg+g10i9ey16gNxVCUhdQmNn1FrUQDBeHaDSvXI+TmBb3ARqu9kzLVun18VIwgiFw+qH6wnZEkxozpe68yKtc0AtF7vmGXHIh32mJUgWSPP4ZIAB6vc48wrRBBMIjmoIRH5unU6FycyPlbUSGppfOYOeGBDfoTkmG9hfZm8FXEER/56LwFbn2l4eCbeYuVYhYDUyFWwamjMvW7X77ZzMhdW5UFGcQIYv3QQSyMoYGSoyQ2muwoWvyE50AVSbi7D0XKehH/ezobd8WFzBAAAAABJRU5ErkJggg=="

/***/ },
/* 2601 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADdSURBVHgBlVKhEsIwDE17KIYdfnpY5qdBDyxoPJ/CFGgEDjSaefQ802DHyy3lCpT2yN1bsrSveUlL9MPatk2AIf1jIEyBg6Bw7el9ECK4NZACW2AAzLg6/E4pdXNVSYES2HBs5WPJlXbeLC5F1groOw6NZe0lXSFYwOfAHlJO5O99AjcHLhqfRvJnCph1cK2FwENJQkRUzOC4lUrjlDuCK5BR2HhPDU6jJVFR12fIRqKQbGL0Ne53mbwWy96OKBcbkpsbmfxjvxwmFvzcPOSjCZQlhSc7Jr9VqPjg4Alk8oEk7/HMDwAAAABJRU5ErkJggg=="

/***/ },
/* 2602 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHgSURBVHgBrVJLUttAEO0ey7aWyg2cZRKngnZRsYjmBsoJAiewfQLbJwCfIOYEwAkERfFbCQoKtrqBxQZsU1bzZoTFT8UGpkpV6p7p7vdpog8erkrGx0mLqdFfxpLLvl5tj6veqqokST1C6wg/ZkaLa7wRJ4n3LoL46Cpipg6+MxFBMe2FwY/1OE48dhsTxOPHklYYfNdvEDDLBrF4IvkKGuyKO++ZvNZ+JrL4CzQtAPLAZwXDui8Q7J9e98FzTYi1Dr6lFtHh5Ror/sPMWS6zkQ78In98MWBWHWnOv2rfzwoEsvDMdKIpPSv+b6aKUARB46UGSjlikUxdr6SQ390PKaeUpLFZ0KGO4RwGbS3TmU+C5rf1yLgjeT4Axd4SaYHAs2SeVGaGFnJj/13kEROrzAS2qFabvBBRzZp9KwcrK46wjMC9s3dytc1ST3CRosmZmQqRR0Axjg8uwicKsrixGrjTzCr/u70JoutQPMMmbD0XV9WcCTTIyHHS0oXC62aCJhnGo4mkQvNhqbzZEUX/CsElAoKhXv05KBFYr2mBiQLP83P0DbGN3cI2rDXLtrkDVLOcO8viEsHrEx9ddmFj3zy2lmGtsVhfjO+v3zpVDWh2Pya3/utxBFBRr6r4U84DnBLsDo3Ztf4AAAAASUVORK5CYII="

/***/ },
/* 2603 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFZSURBVHgBxVM7TsNAEJ3ZRBRULjiAy9hpQOIAay6Ab5DQxaYgOUFyA9IlEgXhCJwgS4/kVIYOH4DCFQVCHmYcbJTgRe4y0q6983kzb3a2A/9IT4/0iXsO79lzbvNRNoOn4xuFuOb15l/EU5sf7itcPXaO1ectEA0J6AGInRAHvK0+iqNJZua5FYBLdiWr4BDB5MUs5qL39WjGAFJFVhAFr2aZ/aHQ09eDDmLCCUGcqmCR1CxnQF9nYuMECQMOdwB8HU8VFqsCYEPbDGafWmruSptUwdXcezoa18a+jtZ+ECfQUvpBlHhBJFShWym5YXVz5AYAKdyJInisaRHkVfcar1EBhWw/VUxalvzzdtnk2wWLcNwmNYugLJkpEjb7WQeprRweoOwBKciRwJVJrAxM2bGduR8Of/JfgAKeECGUh1Oeq/Is51JHdPUDvBV5uszHhRbCE5tV0/oNjw2DahiV4jUAAAAASUVORK5CYII="

/***/ },
/* 2604 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGeSURBVHgBxVI9TgJREJ55GjXaYJREu8VKqDABG5sHJ8ATIB3QACcATgCV0AE38AY8OwoTsRChYksLC2zMQnTHmXVDFqOJiQWT7L75e998M/MA1i34W+BU5y0EjItOQMOxadt/AuCLGhGrHNBBPwEYIsp9B1JBI6qLJYXYF90lSr3R9v6o30LRFSNwbBpLF6s/AkR1IYNITUCqP/VbKfHtwqIRTRcarNqPhn1Edf5qkrvSgvTrVSY0I3Od8+2p0OaEEKfEhQXTNzGd5yKYZXYR2zRn6gsFMyS0wa37tMrsHQoTbuEMCYwClZXYFuzUPHbKKS9bQKCQVHJgZ+YPLMSTny0HiGwr91V0BxxhNCMXvfimj9pcwLy0p+YyoAoDdBm5H0sV7lmXxDi5cOlVVFAl8lZ7I/aG/J7tgXNoJSesNsMn58DUewdWosf2MYJyXKAK9z+MaW8D5Q+C3MS0B0sAkRf7bhy2EjLU2mEkqfl84EvtPevidhPej8KRZAcRrrh6ZWJa3ZUtBEU2sAHY4b510O8/pLpsIuj/91Nev3wCMte3T9CXfDsAAAAASUVORK5CYII="

/***/ },
/* 2605 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgBxZI9TsNAEIXfGEtGVOEELB1slSMsnICcwKJAcmjgCOEEobMlCrhBcgJYbpBqhah8BFcIIfCwg7JgB0eRq7xmPeN93779AbYtCh/HZnxGhNmG+aV7yg+bjfiPxIMfHvN5l5MBQ0SpNpf3QP3sbPHQAgSFH6vSJpMhhSxENNWnmXKPxSRCTzmbj3xQizo66EywSfpkzLKfT/BI6t4J5IzeONl/tfm8BWBQJaMy14NOH2rpV3JGpb2tQv8XkCCxMmEv+pgemUw1zb72N7BzBab5KpiahTYXQ6Z45pvqfwJY9vFfbFGuBYQt7OJ9GLUgXwtn7xboEC0jKm8w6KHaJ5I08ZIy8Y8j7QPwt3ED8W1d33xEWUnqoWV/AAAAAElFTkSuQmCC"

/***/ },
/* 2606 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE4SURBVHgBxVK7ccJAEH17A7EpQaE/CR34qMC4ApsMnFgdAB3YiUeZVIklKjARdih3oBRmuPU762PkYQZlvOBu77T39r1dAeeG+OXSTgMRiXmwHZ+tnbr7ryzKe/5ogFCBAKqTLs9VMBeDkGFofi+AAbccHcFHuThz4eNeI8rLF7FdCLTckhYBdSWb7K2ThSs7TaRs3wFBhWv7FNexg1v6RrHJ1sA8qNFCnb5SwUL5tbLzH+67TTh9NCIpRIfUPmb8scd+4ImPKthk0aJFMJrND+3d2FnaR/+Z4aQhoJuCFe58tT/5yKoqnJBb1fe0katy5BV6VfILvdxyCo1//hNLrgtRrFVkzj7kzAlEZUyCZZ0mOIGhDQc7bGNmjuGVliic6sgrPElQIyARSj/YyTZV0dXnexTi7PgBVEZ2zmRplyIAAAAASUVORK5CYII="

/***/ },
/* 2607 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG/SURBVHgBjVNNUsJQDE4edFBWeIO6E11YbtByAfEEwsIZWAknEE4gOxhdoCdATtDeANyAy3oCu5EfR19MOjymIAqZ6bx5Sb4k35dXhD3Ndus5Cz5sC1KOBgjZFb4G3RB3AU/cqo0KbxRBmQByydiUMkfqP/Cpe+2kEIdAUNL03dJEx2O/g3JK/ADmjtro5spnwIhpXwMNZpQpTIL79hwOIonJ6AazonBWrN0RQX3pjBP5HoyDzmVcsFjtEWBupjMVCz5tC2nIk3jK8BQwOyriZK7AQkVTyFRMA9L6BTVGYdCOLNAOuyKeJEhLUCH6DArY8Rh3IoiIC0myKSAUzDYAF7dA+Cz39JKzLVzyXs1nwVwGV5I8k5ZVC2nAabq10iDv1krschHximOjid/xNoHS+RAXfQY4QF/eOHgYrYkYC+XV3lmDhlCB9e3YClWfm9gcLySnW63REW78UFIKz9eK8jpFIwaLcGBWaQw3OpU5uQeITdD6jcMXnFESgVmXlhSSLYn6vyYQk9FllfwAmhAXigUdbNNk6wRJweTMwlwKxcJyoktATxO/W95ZwJhsBxH6/AJHRLqRHH1vM//GX/YDpRfkLFeKMJUAAAAASUVORK5CYII="

/***/ },
/* 2608 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF8SURBVHgBtVJBUsJAEJzZsgr1xA+MN+HEE9YfxBcgN/QkL0BfoF7EG/CD8AL2CTlRlhd5Qk6WZUna6SRSGJEbU5XsZqenp7cnIvuMtu9f8tmFUb7OfD/i+hKel5G/aR7LR1wkVbs5V2AK0QyClJhNfEHQ8v2JoU8A9Jzq3I6ifxouc+DcOb2XXLNFeOo5nkJkYkzeit9sLwY6XcxH1hhTgU645xlzxFhB/CWYsdZVUgLZy0thRmn11oVcRag+s9cwStYELX/FO0fW8VGhXfqw9QLQGFgNbNc0H/yaQJ10TV5oyOEtkz8mbkY1jSbEJQoJZvCwICgctTupSvZZFi5h7tcJVHimqXX0cKD7nkoPLNEp5UlskyjHt2UKUPGF3apjLowjefeuIY1AUwyQiI2xVCDJHwUmm7kCU+btv3CpS8NDBkjPWDtkBwlyDOoEKwExaalAIxvrxbZp/Qr+YG1/Pd6F0foBTXXihpVuXxkQuOSS39W7HsiuqAr3Gt/oD7TW8hO1gQAAAABJRU5ErkJggg=="

/***/ },
/* 2609 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgBvZDNDcIwDIWfIy7cOkKOkCUwGzBCjy0nVmAS2IAV2IQ5uNRNqjaHqn9x1X5SZCt++hQH2ArH99eJCzuXM6MTktwPGWrBQvYROC7ycNQCaf7CXNSCKaLgzOXNXcsfEokCgmS+WCSSvILlRxZeqxYc8WcifNSCdlWoBX0OXVMBXyP0jhORZ7hrWl8lJIZya6kBX9gfydYx+3kAAAAASUVORK5CYII="

/***/ },
/* 2610 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFeSURBVHgBjVNLUsJAEO2XwsLPJjcw7pQVnsBwAzgBuANXegL0BmQjVLlQT4An0DkCblJWuTA3MCsEtHj28CmFDJ+umprJm85L9+sXyCyC8NLfl0FZNgQF6ZfkTWJaqX3OzS92ZBQIcL+JALr22K/o9uRMKJQaLIT1WgZXzN4t4zkXCYFqIbw4W/gyGNCR6zmwRMssZkinWG8jASmRbj6Fr7G5PbfLklpsTEbL+RBHaL8trbnaZ/5oVwa+B3wIeBM/d663IijqSEcYfmrZBpRUs8rxS9uZ69JAerMZ64spIb6sCW9FCzW7c8wrklYDOQ7r4VYEmmgN1SQYvZlOYpcqG6kO3cndUmR84HnS1JkFEByqF2bOpG3Dx9SppbUVqItqVjwZI/0DkU4EdfjD6USQj7FpP/zHJroAYSZ3fjgJG2VAurJFfPPn9N3c9RYqyOsvOuSwgmm/6wnkIJmffwFRYX4WRFlYVQAAAABJRU5ErkJggg=="

/***/ },
/* 2611 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgBhVI7TsNAEJ3ZRCSIxhIXcAkmSKGh3pwAbkAokJJU5gT4BjhVoAJOgH0CLz0S7pIOH4AiDZ8IaYcZG1tIOPE0ntmZ5/fe7LZgTXj6or/rHnffsudlXV/VHe7rsQ/YflGIr56eBHUz+Ldwte/s4OqRADSR9VGhA4QBT0XW0uXC3GT/gD090hbxTnILMFwksyfJ9/TIZeYkPyc6Z7CppHqDScigBBHNB3WOSpCEsDBgwMxGflBKxwM9vmbeoSUbzM3tFDaEeFcIV0QUKQs2Y0/wCdsP0BBzMwvlS0Cp6hQApwtf/SbgoR6fMolDgLFKTbjkDZkW4EkT0Kp8JhXf+XLYX0TsswnI3uSa7iVXhWaMRS6vXq8D9Yqe+ztbAIW6SS4pdVbKlLpdNZAM307gDfi51csEJAjLugJu2e70G1YZbIh36MRl/gPFlI1enCzdMQAAAABJRU5ErkJggg=="

/***/ },
/* 2612 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHDSURBVHgBrVI9VsJAEJ5Zf+LTJt4AO7ERT2D0BPEEauNTG+AEwAmERumMJ1AvoPEEYgOWuQGh4QHFjt/uQvgxne57SfZN9vubWaI/Ls4r7gfXBUWqNq/oj27cjvLOqnxWHRJLaPbCUiDmu0JQ8fPPTlcxuAGIyng6LBQCGXfj+8sSgBMe90ESkXaEvfeHk18OmOkOb19pKonI65A2q6beiZupCJ2xhhMSH4oliFWWHBwEtzUwXwB48h23E1e7vgD/sShJRUtroV6HWnko3l4CcuuAlWXOMlow86PNjziK+X3eAyV4+Vs08rMIG9pr4JOApOnicBlhI5PVE+/IALZpFJrpoLl1RKrOHFmC1FFnDiDhi9IDsx85JV9Ip/P/qr/UxB01rokD2uZAocXC5eLpzfMa8yfqCUAdqyrSUqwjuAkyAjRpYHowoi2r0osfmlrkkjWn+D4tNpecujmXZFMwsx7z+JOJUyFJ0YNEa92YgewdUXRuAeaOsDS6b+165sDNGooiKSx+YR+wcnFM43BHno0b1jbnywycOVhdxeCqwrxWwyRezOXBqRBz3zVzXz27nkfg0XY0kcnhVMO4q+aB/2X9ABhr6FsI7aq6AAAAAElFTkSuQmCC"

/***/ },
/* 2613 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKESURBVHgBtZbNbhJRFMfPuQzYglKagEk3lT6BaHwAeALHdENtS+vCuMSPlYkJGE26M9UXkEpNiUkjPkF5AI3scFfoxsRiijVC5GOO94zMCJVhLm36Syb3zJx7z/9+nXsHwYXDlWQcEdYQMQ6AIQIK8XcEKBNhGaj7Ibz9rjguBjo5vqdup2WRtYK6BKn2iJ5ezhdyDv5hviaTUa8XX0tPHCaFoNTp0J25QqHqKMICPh/uEUAUTgmPqt2mxKCQLbKv66FgcPrzWQQGhYRoXZvNFRv8rlmO4Mx0hmhYQPj94JmPugY16ofQk48Fd9ToBTLSfNAX7a+DD/dPNp7WF8F/axHcaL7fhVZx97/vZFAisl0omSPxekXG1B9B50sFjjeegRMzj584+lCgLouS+PsGOrhwKf0QAssp0w4sr0JwTPAB1o7W9ZDGyQYKudD+9NG2u7Wa+SgQ6nanYhogxlRq9w5qQM2mbaM/oNIMCCEqAN1HwfB08cPwdF28e0+lmRwDRDVQ5OhR2rZ/bDyHSdCQoOp8gv3DM3/FHIFF820eugcK60LYEMQiKr2RIppMzE6lYpYsqgRRWWjaVFnOXEOpfvOXmXRcKtLgZBSzuZwUoC04D5DMe8ZcDfNiErg36Oed5Lt+A1ThPPr56sXQt46ghblcoWoveT21tCkLewuJcAQ84TCo0h3Ioz4vw2927rNhb2GPuJA1jN83raOeT1Zj4GSdBD7qj0Ura70Ly+C1aQtKcAU4A+alJeMs9O+SIRGG548ryG1XgtMgr19uz3FOCI/m22py3YOYUbkpUaaAIX8kIvmdzdF+F+orS7ohSPcAXpWCMSuo7HaD5IhlMm9xLoyL8QcKVPuwYJ4YJwAAAABJRU5ErkJggg=="

/***/ },
/* 2614 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANrSURBVHgBpVZLa1RZEP7q3Ec6Oo9uYoKZbDozkCGj84gDGXAzOksRlJkfMMTVLEZUdKvpdicoCG5cqRsXCoKCuPSxceHC+CJBQdIKEjRqX9SYePveW1adm9uJ6b4x6geHPn3OqfrqVFd9pwnLgCfHilGxsAvMmwgoM3N5ficAmVsxJxc4bJzv7B2q5fmgdouzU2Nlt6PjpDrGCiBOTjXCsNqOqIUgrI/voiSpyFYR8Ry4fhN4O6ms4EaQGhV6Ab8IfD0IKm3ITIMYVC10/XQ0l6BRnxiFdS5JeDUBfnIOSrIs/BKoe/MCkTEVrzRYbSFII2fLzlOXwC+u41NAPX/ZoZCb7MluYglszn1vTNPCzy5Dx+eA1mwErd2i0yAKwyH9TYx+83x/1DqXfC/r3F2djhzw8+s2tYKiLRIlTaP3J/VL8uCw5Cpoa2zWDMP5foedx4/OIHl6pT2LU4AZ2Gc/XROWXHK97ZZdq6Wd80IP3IH/QRJ5/OAYaHU/3B93Ivl2HaJHZ4F3zz48r5UX3AR1bUQYubuN45htduP1RItv+qof3oYj4mQajfFDMN9thenbiujOftkk+L8fgZEzLZiZTG/tOH8acPKbvUGb6MldBUQzIIk2I4puH5Do/pAxDNZDemYJeG4qtZfON7ahFPOLLZAURHcOSNnesE7dXw/a0otu/Ae8qbW3mQ9WAii7WAF4TkjuH4Pzw47U+cMTWCmMGNTszCu2P+EsKktJF8v4KDp7s1lgmKimM1pYbCKRFPBMDd7wcaCjZyGq4nq4vxzUJINnp1vsKAuW+ZabxPE1Y8wmSPnh1ZJKkmg1NWbtZniS+yakkmJJU24viAgqYsYF4rpofuLXtX5to+WJm/SBI47tzZ5czE+ViJ8Z2JvGZ0y/1aLGy/Erqv1WQR+fxpeA+v62yqpvhNu1bsRqUUQ0oq8UfTNoO/CznauiprIdNIyxkm0JOkuDNalZu0C9W5qy+0nOJbDMjhOuqk+7vvhQY/puRR6MUXtIlXX6cq74NSGiRn3/QG9vkSRVr/vnSpN46fnwxb3dsjiadbglUp1SoqzbtQylrGlVf5oSIREEGrnfvT7/ycwwW58oO3FcIaJ/sRIwX40cZyRLy0cJFhNREm93GNtEPVUUi/NGNfkLI13I11w3Okqlodw8vgcAqGZfmKO7GAAAAABJRU5ErkJggg=="

/***/ },
/* 2615 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANiSURBVHgBnZXPaxNBFMe/M5tNUls1AY2KrSSXglaxFVTqD2gvelCwePCqgnf/BO1/oH+BijcPYsWD9dKCVlHRFrQKRUjQ+qtRsmhjm93sjO/NJumv3aT6YNmZnZ33mXnvO28EWljx08KAltZ5aD0ggJSmJxgRUxCY0r4e2bYrca+ZDxE18POLe1kpfXXJaVMvBfhqOLOr7Wb48Cr7ml/IWrZ1A9AD3HfmNIqfNZwisDivUfWAmA10pAU6CN/VLZFsb7gb9z3/4o5cWyESEgDkGDWz7Oz9c4UfBGhl23MCuZ4ajHblu2pwOagByed1qt12JxkwXwLeTPhYLGPdxoC+QasBKrvxvlxOODwm6z912N4VBrDjfwWw8f8vR2vzNLI1f0s7qYUpz+1nD5oD2jcJlH9Fh5BzdfBEsHZfU9i62sZNz4rLKwFMRwLshMChk3GcupQ07w2bwoU5X9LIv1W1HYih4E1WnK2UWKpRu+g+EENPfwwzr6v4/MEnSAJ2Eph+5qEw7a/5n9V3/KzFTafsxXPyKx82Asw7CAXwqhkwdqdiwjR4LoG5WR9PRypm7NBJe80cViaLhyyVjC32xmJC93KEF8rhcd6wWdAZCZy7FWBixDXfj55J4A9B2zfL0Hm/HUX5kbAEsjGlRUqIIJZRNv3UMznYe8TGHno4+S8euibYPf126Jx6VDQpTWKdVnjnY/R2BZlOiUf0nptV650KKbjugA9TZBkjZQVvr6JXvJvZxlTgTwvhSF8HkI3pcMjMqyqd5PiKsLCcuX+QEs9qC7P6orXWU6JE5aRqu3lW2OO7vlHGauMcsMK2dlmmzQkvzSlMjnumHQboP20y4WQ6E2mZpvpCtFv8pas7fDcs3RejnlHWF1o5J33ivhsKYMv11PwIYe4Zg/OhTSe7V1L5js6NU1R4Qs6bJZ13wVXZ+HX94QaE6wsF7zq39x2T5sT+jzGgbzAQrCJ/9XLfWDbnxquVetb45JgirbdW0XLAvqMUiTQrCoU/y0p95KXFIC503wqtQVt2Cuw+HESAASrq0loJWrp+GfZpRoFrG9ejqqfJmTCXUyoDbCVAKlN3s47rdwVsduGCBXMFZNHaqFLp4e2dyWthg6LV7O8fK0OQakhA7qdub92peQStXPm3jHCa2F8s3JCBwgzkfAAAAABJRU5ErkJggg=="

/***/ },
/* 2616 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANxSURBVHgBpVVNTBNBFP5m2/JXabsgFdTENlGTKokiiSZyEOEmGEn0brh5MFETvULhZuTAgcSbePBkPOiBoyIXDyaCBwIGNC2BCIHAbgstv93xvSktQre14JdsdnZm9n1v3nvzPYECGDMMX5nmfAQpmwEZAESA5wVgSuC7lPKDgPU+pOvRfDaE3eSkYQQgHIM0bEYxEHgNK9VjR5RD8CO2Rh5bYfLQt2FZ+GbEEUkmsbC+CWN7R+2pKyuFr8SJC5XHcMXnyRgyLSl7Luje/rwEk7HVbgpHWI1XE3g3twAmKQTd5UKLvypLBCHCIW9lTw4Bey6lpdiHFpbwZdnEYcAkrTXVaky5eZI5iSLgmAvhGOOwfFxcxqelFRwF16t9aKutSReBTDVwTjS1ojm62fioGS9o3O10qCcf+NST8QTY1m6RQOxWTIQ/+qYi2UQexNUqHzqDp9X47ew8humkdihzaHh2LqjeGzKlOyW0Do4Te29n3F9agodnA3C7HBiYnkHQXU7fZ3DRc0wRLW5u7du/kaLKM2NoqtZRAu2xJoS4wwsTq2s5xoMV5ei7FCIjm3g++QvtdTVoP+lH1/i0Wuc13nMQkeS6epPxG07y/jLFDOZmrvcVFO9kKoV6b6UK0fDSMgbH5xTJNfpO73Hm/Lewnj1VQFMJIcyTl3bgEHSNT+HriqlIeurPcxLxYHQckcS67T/G9naWwIkiwCQDP2eySR6MzKFYcJlGeaC77Lncjr2yTOyk1PMvsJQw+D5kCWrLS3M2RilZkUQSLxvrVTVlwBXUe5FCRRaWbELLOsVgxXWSQI1Qtpu5GviS/A32lkNzk2Sgdzf2jNt1fryKztJdsL+ULIKKgOVcab5wGFy/L6Yjqo7twDe4jQwzhuYX84ZKL3Hh6blA+kOmgmktMuPD9GrmE7yZ/Y3/wd1TJ9LKSj0i5PV0artMnZyQkMeNpiodR0Wrv1oZF5AmNyCeUwSsetwseHyr7nhWdg8DloaWmio1tiSy3W1/wzFiYWoY3TxOK+syjK2dgoZZ1O6dqkWo0p2eIEdDujecWc9pmRNGjAWqO3PDmWgivgaTiDK3ne9MLdV60F2BRt2DMk1TYWHPC7bMvZMYAVLZMAnhfRSHz5zHopq+DVEHKy55SKIo0goHGaVfoxSOkQ1Y/Q26nre//gFgF3tBXT9vdwAAAABJRU5ErkJggg=="

/***/ },
/* 2617 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIdSURBVHgB7Zi/T8JAFMdfsSbQQTHRVR3RzV2Jk4YNwx/i4ESikyRMDv4hpDgRXcAfu5syqqskwFJIVOp9qwfX0vZaoKEDn+RyB3ft+/bu3vW9EjFM09xmpc5K25wPOjRAi/LfeGYlTfOlw8oeBOmskad40IAgU/zHNAzq39ao/3RPg1Zr7IrE+gatFs+t2o9B65O65ZJVu90juZ+l5HGOFE0TuzoJp5hu+ZKMasVVDDfUf3wgGRjjJobfAzZgCzYF0jZBvbsa/Xy8kx9LeLqDLMnAmCXJLMIWVkPEtmTts9PhU2n5AqVOChQFmJ2eXrHaWL61q+thn22GxCmOSgzAw7rZHBMUBxaCZMRbEHdTmbuKYFPCO0UPDYKXLZvb80MPZ0gioCiDuW+v+ufCKeY9WkDv9LKlioPQoUXo7kFsxW4PqSHHj73Lvpsvtrahj8aGWXrO2NteRpjN63wtBLqGQqJENHZ4TdgZcluyr+ar1V7O7JCa2R32TbJkofeQ0zuwZ7ggiJnWS+N9UluRnF4JdeJOipctmyDEwD0rtCxRUHhkGDSSlNlSnarFOgjYU+mQru1naxF+yFgIkmETJJ6qPE2JAqM6urdvgCbmS17MIpUWceZ/thlKHeVI3dwimaFpU2kObCG/F4GgDv+BxH+leGEp9oqrZ5FKY3ZhA7YcHxusJauz+pDiwU3sPlglFEV5Q4OVKs0HCGlAA7T8AgSxnOgRSpLBAAAAAElFTkSuQmCC"

/***/ },
/* 2618 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARfSURBVHgBzVg5iBNfGP/em8mS438EdNVqNzZuYqG7YisbQdRC0GUFi8ULC8sVO0FQsbATU1hYeB8gKK4geCC4q5VYbLRJtNDsVl5FRHOYTOb5feMkvjeZjW+yQfylmDfv/PJ+3zkMAqKSyyWYEDtMw1gLQqQFY3F8xp1BxorYLmCr0LDtGRybiqRShSD7M92JtVxuH2NsLzbTEAxZIUSmL5W6pDP5twLVc7k0CnJRACRgEcCDCrYQJ34n2IICidnZuBWLHQPbPgS9BOdnzFLpBBsZKYKuQKQnJmN3sDnsN27NFcB68xqs+QLYX1BtqtWfm4XDYCxbAcbyFWCuGgJzMAELHFqoC7HRT7+YnzAhxp74UVR7lYXvz2YcIXTA/49DeMMohNYMawulCEQ0NSKRWa8wdrEI5ds3ofHhPXQDEiw2sRd4PO4dypqVykaZPi6Pks54hanjrXy7cK5rYQh0o7RH/U3eOzTs6KmE1g25Zn1REQY3KN+6Cb1EdNv2dgqRulAqNU3N1g1xxhRJiabKvbvQa1QeP3T2liFfhHNDfrfz9WzGV3n/nTwMLBoFHTTm56F0/UpbP1nhPwcOKn3oPPeTj+KuhJPyIFnTQpbUt249GEv78Z90/tGc8Oat/oKiPpJuynCjAJhk5uDxN2TanVB99hQqU7c7zonsGIfo2HiHPWa8upQWb98OcgqUci85PV0/Q/T9d+QocKSQboTeYxN7tNbSGXSWjO+12hg3OB+VO31Mc+FNP30CUSqj6cTALpdQsBjwJUu119fR28vA6LDWBK8TDOBvSjeuKu9fTp2EIGhg6FGA6YyJ2pTAxq9JHz+ALpoW9y1zGp8xiE7sBvvzZ1/L8oNXNSi3MlvJVbPTDZRaGyJlHHVHpgyWaC9vPwtlMWERWCxlfjDdtLN1S5RC6N4SWRbRJDtKos8ul7XW01lqByuS2StEUmTWBdFFjpL0h+gKJVeDMTCovx5zJwWYj/OGEIoXDLJhE2VU4tL1q4HXUQiRYdv2HMcYovjw0Kok/CmEhoaUd8H5NKdSRe6ktNOPNvLGRAnB6O936Rn4+Y5r5LYzhnOcQ901bfvhGeZAQhVIiCkn2tfz+ScglTcUXL2pBwVK3bDgBdFZfXRf6fPJi7KhZHLEdCW7jNE23Rzpw4m1F8+VLLH66AF61jnoBpZnHd2ON0mj2o2erYzRyuffyemrk3aePxfIUeqATJ1yIVktKOE3k8mVjrCShPvB8y/Cm7ZArxFBqrw6SgVk69xmw81pM/JEoi46vqvdgXUB2oOE8bFipcxuK4OsSIQUXCGY6Ctdu6ydJ3lB/ia6c1fbzRBVRqUyIpdBf3ehqCMUgUro+uu8Y4U2pityKc0c/zKITi/Z5mckZC0hxrRK6SZc+o5jcxJ6iwxWq8cDfWyQQSUS1Wy9+BxDltwsCDvM04Nbu9FtDUMwTJPj7dkHKy+an/QMwxhF55VwU+DWJz0nnWFs2mo0XnbzSe8HvvAJ2UUH9lUAAAAASUVORK5CYII="

/***/ },
/* 2619 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQISURBVHgBvVhLjxNHEK5qtydsHsQWQcmKPBxFSrTkwW5+QGJfc1rILTnkcY0QkXKOYJU/EKTkFolwILcQTjli+AO7RsDuCXkAoZVYwAZ2YdePLqra2Ez3zOx6zCyfZNmu7un6XNXV/ZURMuLx6lIFg+K8BjwEiFUiUwLA0mCU2mwL+XvYJ3OROt1zU9NzYZb1cdyJnTtXvkelvgOiKmQBQoMMnQze+OTv8abvgO7a5SoTOUUAFXgOsKPQEC3sRCyVEDWXSr3SS8fB0M+QK/B3rbYWsDzXThxNMso+0UHwH3+cTRqHjSbQwxWAdX7vtgD6mwN7YQ/gnmmAqWnA12YAXnkfUpyG3U6nlrS/MIlMMQjqSSmi1iLQ2nneUIk/Lo6gDLi/Blj+fGxSDiFJU39vsBQjwwTMzTPCFiYCE1OVH+27x6qhsVOLpk9Fx2XP+GSovQjm2h+TkxF0WrzGn0APVlw7wWzP8D51OA6fkbJGPOXM5wXoxhnIE/j2ET61vBQaUyvu//SCfBxFSCE6TCVNdOtfyBu0+r+NmEOSj5URD+ubo+OnyoR/PauePMFrmhv/OCbxLRxGhBDhmDOBq2nsSpJF3qqBerM29nzYXB34iMDeArKWlDl/dc4bW9oZoD88Cvqjo5meobW6Z6AqtZbfU6iL884AH3pZojMxeB+R+Ipgq2cOq0IBv4waY6W5m/B8aYWHFIeq4lg3n+O8yQh61PRNVQ3+QbgDIfUq30/65eSx0scxm2lfhVR45c/VVtLPxNVTbFPq4lB/9lvqeNJYb/EXMOvN5AfivoTQ+DDrIdD9+C/G1weR8ceot8FqYAOyQFvZGY0SS4jUKLGD7qVfY+bgi7P2PWlsW4gvF22FgG6NF8vwwiDayQGGqk900TGliKrdAHqEWOJeV0TQcKx7Z+BFAT1fRHRBkS6ccyZJhIISZAFt3ravTBCx5mVDuFg91L23XI+2N1aq3joLuwk8cMSTttgo7js4Z297Mua0M1kmxjZcjhCt7elsbjhPWt9DQ+/ucpMgco2Ijhbpmrcm4lJXH/zk6Guu9FDvO2jzN1KMZPo/OA/yPsLpryBv4IGvY2LfkFkYfh4Rspr2adhGD7P2xXe/TTrAskN6NtHTfhWT22a7bVCLu1UK6tINOA9J+kTSTqqTuHFU73wTi4ykqqC25qJtULxRbK1Uiobqzn4aEc6zUcSwq7A2VZ4JXXsCtiNlIa20tEgiVeQVaaXl6pGzzKYm/dRv9JQ67JNJJSSw6evrE6y+j0Ge4D2jC90Tmf5siELaE4XqeGq0xoSkSCp52BCmzxsTg85W2iWchSzg+4mV4Onc/rDyIfsLTX++QNwcoEQN+QXDy6/NC7aFRA/h0iR/6T0B3ZDBum1vgSwAAAAASUVORK5CYII="

/***/ },
/* 2620 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAP1SURBVHgBvVjNThNRFD73zgyV0MWYSJX41y5cEGKAhbDQxLJiKwvZKk+A8QWEN5AnUOLOjWx1U0hkoSaCQaKJi1ZFIcWkDSk/7XTu8Z4pA3d+CjMw8CWTmd5zM/eb83Pvd8ogJtaLu1ndwAfI9H5AzDMAE+VFNvlcRWAlZFjiaC80LTbXk+ssxXk/izqxvLb7GEB7BIB5iAW2DMKeydzofBlp9nETNn/v5pHxF/IxC6cBgxLYYvo4Ym0JFYtopg3rGQI+gQTBgD2vWcZ0Lseq4fYQUJ5ohvZGhmcgzF4tI2z+QahuAuzVEJpWa1w3ANIXGaRlRnVfZWBmWDtWJbshRsLyi4WT4QUICdF6EaG0KmBvGyLhQhdAro/DlRyLTMozk8LUZTSW/GSIwMqiDbUKnAhEbHBEc+4+VsvbljGiho+rZsoZP5mNEsKntycnQ6APonf8k2H2Agf21zyk6D60ytqppgNQnnx9LyBJ9A7LEGa9IbRRhu565zw9Kx7iHqb0Vd8/JEuG8ONzMAc1fugIh1DLO95QLRXsg+pJEvTOlUXfhyJky78cDi1CDPikaqdqilpJhGyf5lxRUasgbBR9+cTpFJA3KnNp8uw3VNpxMDTa4VxxUAysgfnKX7zJ6aBUh2nTi+Odk4LWoLVU1EV9jAPT7quDm4HSPDv41+KM93NKKHWwVoVzQ7XsH8G8Dr7qooQ7CmY3h45UuC1zjQfGymvt83Fv27cWgqm74srFUaWeuc4h/zDV1p4fD9revarLQzicVMhapg4xUKFTPuSLu/c947dZewiNeryc1Fuy89BLJCHaecmSLy+8rgfGx592Ovcw25GLG4GhKpcCzJPGF7oiq9pTg7STD1KLC1xQR8wMnBvSpve3QPzJOcdldZCU3nkhsBaDeU6tijpGsjNu2Ha2ELa34iUvreGXuGjhnDNSXmsU1PaGDr5vH5OXHip6hwLSdjlzLTXo1KsN9qxqoYlp8+xCR97x62xbiBm6K4qxXgRl13ZlZ9KaSDcY3BnlHn2NUvBfvprK0fPBXi9l5AR4vgLg1iCHpNE7zAJiX8gG0n0+WNHRtIgz6kRy6+17PGwDiw3yTO8Qg0u+ypKlPtOjdLMea0W2QZZBCe4VbBS+pYIIHoYRQRvg7bs84BkK1U6jY1Btg2I1ilR9xVWMTIySN9fHQhtFIiOOaxSjkCK4rTRpJ+rXmlaLIIWFvEC7/ZGttGwQbcsei9RKu3DCp9engLFJSBCUM7vN1FSsPxtUrMsWSWv1bFk4BZwQCTHhNoTtEHn32ydG3hqAWGDztrBne5L6wypATOYXk52KJpsDbOlxutxzu+pcjM0LbH7BE/yl9x++ncXRGyMQYQAAAABJRU5ErkJggg=="

/***/ },
/* 2621 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQbSURBVHgBxVjfbxRVFD7n7iztUig7GhBE060a4yKJlEdf3PLqS4k+miiJjxp88Fmof4FEXgma6JtEX3yl5R+wNaKbGKFDUynQwCxblt1tu3O433Sn3J0f7cyyhS+Z7J1z78795vyacy5TRsy5zdIQrU2x4vdIpMLERSEqYo6JakTi6JHjiVxj8n4r27aT5fmcduF1t/5ZjulTPaxQBjDJ/IbwheP26A/p1u+Av9zVisVyWQ9L9GxwOkLTOxFLJDTnusWCss6JyFc0QDDzd01vY3rCtmux83HCquuWmK1fheRE3PzNxmOqrjZoodEkd22dWp7ny4eVoiOFIToyPETl/SP0xsheSoBD0pmM8y+OI0Ocm6EYE/1Rq9PVe/fJXd+gNLDzeTp16CU6WRyltKR6CMFMw5ybC5Nx19fp58VlWm61qR+A2Ofjr1Exb1Hv5jLfFG/SNJ8yF8BnwmSglYv/LfZNBsALfX/jFlXrjR65EJ/o7mmQ7KIb1pfNSfjJT4u3aZD46OgrURNumm4Wwy0NaTI9TPFWvyzdoUHj9zsrVAv7IOe2FOETgnYoZKpLC0tb0TNItDpenNZLXQ6bhCzms+Ys/CZtJAGTh172r7SAP2IPE92vACmEeTjfILSz4Iu3xvwrC67eexAWVW42m2NKSE2ZUiS9LNrpF/BRJFYTrdbaaaVz+QemMByau4l/Vh/13KOC0MmeS6Zwud1/vsmKsIZ0Yqro1CklU7ZTAiztLdCIlYude3d0X0T2d/0RJQFmM6GTYtEKiqsACMskYMNvj7+dOB839/V8lRYeN2PXh/cCF4sywNEPjnvjQDPhucZGhxqdDmWBhbLT1NJwTiVqCRt8c/3fiPzK+yf937i57YC9TICLDnvqKZRsK0/PC6ibeiGO0hXhNVM0PlKgF0XIE7oFnc2bwmMxkbJbOLY/stesQqtiSqAhe08mX6eV9pp/ZYG9Jx+xBrj49VC1VkfJWgkm8OG78v9d2k2E6yJUj+8UD0xsurnQj+ZiLIw63OAA7YSLNNG92yaxLqq1hwv6thTcI4tevLG4baLsBwj1L98cC9XX4pSLB8YxepoIxDtj/hGF+YeHD9Kg8fHRw5Fin4Sng+EWIdS0OgVcMNdBrZ+8/mokgfUDPAN+g36th4ves2x0s5E2qMBqBt2AKYf5LjlLuinsr05C84gXi2hGm6ol3oTZBiU0imrG9KcAfqO4cj81MTjvqYNJjaI+JdE92baNYhpSAOoYFFfLzbZfPwWOD7Pg0zO+r+AnvaSsjxAX8U6naqUDwHxDpM5zqAF4VsBn2uSdz3TYYKKK9oTlXJK2MlCBic4EDWESUh9YgRiznA07fArMIvGWB3VgFSWGtklNKb858Mtffc/dIz2p+eUM86x48mc/R3pPAGLSzZgRoCMQAAAAAElFTkSuQmCC"

/***/ },
/* 2622 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUWSURBVHgBrVhNaFxVFD7nvjvTxGidkLQYonVCIdCkkqRCuzSzFRdpXRR0UduVoFLRhW60DW4UVCzqTmy7qKDgz0JcdtqNQsEm1fygUDKphNSkMVP7k2Rm3j0952Zm+u6bvzfJfDDMm/vuz3fP/xmEJrG2OJHEeGxMAw4B4iiRSQBgYvMtZXksw78zPpnLlMv/1N4zkmlmf4w6MXdr6hVU6hgQjUIzQJgkQ2fi3fvPRZveAPnlP0eZyFkCSMI2wAdlDNF4I2I1CdHcRKKQ2HEKDL0JLQV+ptXGOHaOZKu+rTYodqLj8R/5cbjae7g3B3RnFuAuf+dXAfz1zXGvDbCtB6C9B/CxfQAdfVDj0Ew+l0tVsy+sRiYWj6erqYhWrwItX2SDqnq5SsQ7AXelADsPRCblEBI1+TvjExVkmID554KwhS2BiankCfsdYjWpMZcKqk8F34vNhMlQ9iqY619snYwgt8p7fAn0/6w7TjBcMGynDsfSGnFrxLPOfN6AblyAVgKfPMJRK6RCY1KxXc9ckseyhBSiw1TURAvfQ6tBi79YiTkkOayUedizWTphVZnMVw+9px50B3hPHwVv73GAHbsbz+c9zY1vXJJ8tnCw21mGCCedCexNUTxJdR8Er/8NQCZlf3cdAn/+WzD/pusvXF+0ZwS9z2YBgHNYjDlzwfnm74/rE2rbDbr/dVCJ/UC3pywJWl8GfeATS87cvAiF+e8ANpZq7yGe1/+2M6QVJjXq2JgzykGvHhlRj+p9wT77178Gf+FnGwCFoJAhXo9MNN59yL4TslXBdmTnBoLnRsEc1p6Hz4kSS6hwzQBUYtASEuR/fwtoY5lt5wR4TJAK96Dw1+dWXerxQdBDH9i5tL5UW4VyVoAQS2hIc/ZOOvFxvXG8kcNjz35qv62KipKQe5UkWHpXd5/7c+FUMSpelnQmRSDkz3xkb20P5INNdgrw0T6IsQ1ZqdyeBn/6w4b7hN2fL5TQD4ur0mmNXZ3Wlqx6FBu0t+co6MF3i5fh8T/eY4LTnGSjhYAQEhq2AXMzbT8iGZF94dr7VlXbgbJlZxBcQjSNwn2ruqbJVJ6VVQjoEop1QkPEOhpOEZtqCKmd3FUZ5RNddoY6am9k7masnVjjlVShH6mcJKmEQ4EeeMdKjNieapIOEeISd14TwSTr/1h5dCdXeiu/Vt+BD8hfeXUzd4l7F1NFCRK5PQmQbNDlUFBHjShnBUBEl3BtdTapjWkuddjbcfpgSWDXQSfmlFKJqSMZiyqpo6BUn41L+f9m0sH2xpaqCz9AFKgnUtb1RVWGidhUEgHYeyRU2uJkrGtgxLo9GXOei7PR8iueSCu/RYra4vZ068rmRaJ6mdTaoTqbG84z9uzSQGFlZo5A0kgRUkdL6RqlJmoG7Opq72tOfc2entFdA9abyhUjGf+4szCeAOx5HloN7H2xotg3ZMZLz2VCtqYtiq28mGtf3PPy1oJlGNKzST0d8izWldNmu23QKnerFE9LN+AsEvVJSRu1HwuDG0f11EsVkhFVeWpjJNgGVTaKHAZihtKOPZUJt7JRxExeYaq9c1/GHa+CeqQspJWWFkm8UD6BVlpSj0R7q5raUX+SY87hMJmahARWfb4+zdX3SWgl2Ga0lz/d1J8NQUh7olCdqimtiBAViSeXGsLa8yJis7OVdgmHoRlwfuJK8HzL/rAKQ+wLjT/mETcHaOtx/kCp6szyhlkhUUC4tpW/9B4ALIRe+fT8RY8AAAAASUVORK5CYII="

/***/ },
/* 2623 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUDSURBVHgBrVhNbxtFGH5ndjdOSIRciRhCWmRLpVIIVZNKJApBwrk0HCqgB45R6S8o/4D2H5A7Eq24ceFDPVAucaWGiCA1Qa0BBSEbkiiVjRQrcj7s9c4wzzib7q7X3nXiR9p4d2Yy77Pv17zvMuoSO4XDtGnJjyUzr5CUWUaUlOrCnLqvSGJFyWSRS+dRw2bfjWQGit3sz+IuLG0dfkpk3CSSWeoKbJ2Es5h6Y+BerNVRC8qbh1nJ+FfqNk1nAaMiOeJuFLG2hAoFmRyy7M8lyc+oh2DEvqja1t1MhlXC50MAPzEs41tlnomw+UpJUnlbUqVMdFSV1LCb46ZFNHSO0ZDyqOFRRskUa8eq6NTFXJh/sXAyfIlCTLRTkFTMCzrap1joHyTKjHN6LcNik/KthJkGrfpakAwIPF12qLpLpwKITc4Z+jfAan3ftua85uPeafhMkMzzoqRfH56eDIAXwh7/KTP7ISeOZb6g6N40w1pH0wngJ88eC+olxqaVCdN+EzpSme7CQA73Hg1xH1O81Z+/9JYM8NeTVh80+AtFaEJN7fhNtbbknERPJ1gJRuMzFk1kLXrp5eg8iz2fLgdeVFK69K/mQCb+MOK3vdZFNMWJpNcvGjQ9b2lSwKh6zq/YKhKdjv9X3ZX0XMnwRR/HKUD32HGYF7z/sPLA6UhoUGninQ/6KHWeU3lLUP5nm/b3JF1bSGhyIPRMETvYk233QMTNXDd8YxbvS5v6oPQMIul1IgPzXLra3Gg9Z9PGkwYlh5sEQaZSlpS6wGn+YkLNOVpjYYAMyPImz5qo3TCJGe+Th1F5u/1bQdD4jLYy/fR1TWsFvnPpqkl2TdLqj3Uq/u7QsFo390lCr93fE21NCFleQpzxKyYcyruoWqFIQDjMg19oBVrKrzT0nKtBd64TKqXgiMwiytI+QruSorD8vdJEvqEFQnB5y6FzymzzC02tlDYFPf6hHrnP0X5AllKY6RZXLuKEelWZavWhrQW//a5Fsx8m9DhMmPumptKI0I4fhRBZSZPOAPgLrmsL/fp5SZGBxs4CjrLTO4ASolvUFQn7+OoGIbIqXBVgPkL9g9Gq7ktEr0kO88g1qJ0CULW4kI98G6Xab7Cr8sbBcQJEuIdFEcYwN/tRn9YY/KwtoaT/WUj5j8m5XFeKvukOotLb2ghXPQQ8+PJIRxLC2z0qXCBzT6kEiTPNTQWdzAhZPjDKtTk6RGtIBoAogiZAyptz3KMEkdYJcI2Z636zOrZonm6lrfqSt73BwffHarzSI/2WoUPfUpEPjUAzcTA21VLarqfOJyZ12Dvk3DeIZ90ZLNzcYCprR0cNwn777yb5uFEG7QTrbEeIRfx6KsYazJZ2n92yM06i7AampQ7iee6rr6UqEF4dTWRwf2JEVUbeIt9bEL05GR263WJsmrUU+0I1kO79iURd00q56F0ItV5+j58qWQYBzYxNMXolEFkq1BdHPN2sb3ZXtUG2BQcnX4MI860tRUdeOyABXp7lLZqBqQ7qfZPeNqirRhHRV8jL2MTgvJlxFtoogoyIahTjkALcVhq1E/q1ht0kCLNAC8j2HVtp1SA6tnMjVivtQpvPrN0hxm5TDwGfOWwk7nT1scGLHdUiGc2eLU1ngDaRELfchrAdYn+wOiYGbU1QV2A5Rzj3R3r1waqFmPIvpjoVQzUHslmP43LP7Yq+GMsJ2fhNnuKT3v9v+mgwKCQSfgAAAABJRU5ErkJggg=="

/***/ },
/* 2624 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUzSURBVHgBrVhNbBtFFH6z3tRxnB+7qKGhRV23pYrbSE04cMXptZdWILgglSAOHIKCBFJvpOEEUipRkWtpkUCCCAQHeiXppQckSBAJhrYhTgh1myix4/z4J/FO55t40/Fm114n/iTL4zfjnW/f37w3jGrERCpr+KlwiWnsPHEeY8RCnCiEOUaUJuIJMUqYnN9lZP4UDYcTtTyfeV04lcq87WN0RQxjVAMY8cltzm50hVtve1tfBX+m1mI647fE0KCDIVHkNFSNmCuhiVQqFND0Qc75B1RHMMY+z5rbQz3hcNpx3kkYT6UMxvQfOfFup/l/NzYpvrZBsxtZShW2KGeaUt6oadQR8FNHo5+iLUE6GWwiFySIF3ud/Is5kSHmGyMHE/2eztAvi8uU2tomLwg3NNCF9sP0cqiVvJIqIwQzNTLfhJ1MamuLvplPUjKXp/0AxN6NHKdQg07lm/PJLDd7VfNp6gL4jJ0MtDLycH7fZAC80BczcxTPbJTJObHu0p4KyRJKYX1LnYSffD3/iOqJ1449v9eEO6Ybx3BXQ4JMGVO81fcLj6neuPN4idJ2H2S+XUVIQtAO2Ux1c3ZhN3oqIaj76M0XO6jPOE7t/kNV1+eKppPWjRIHkl6mMzYgQnx3Fn7jJZJeORyi/tMnJCn5+7kQjf6XpDERiZUAf8QequlKp8BtVgrzWfUPw/dnKxKCJvpPG3SurZmmMus0KiJwKZ+n6+ej1CTIgRCILeYLrs9A5H10xiiT+f0Nhs5Ju6TGPpJeJTIwz8WOdhkNXwqz3kkuUiQYkARBZnYzS11tLVJ7mPtOEHMCfBSJFf+1kMsVLusil7+qLrSHpopzrc30hiAEfDgZp6VCgd4R+QUEN7eLIj0khHZW5LpPus7ItdCSmwn/WlsvI4QKQteIGar/JPPV8w02v94dpQ3xDf/5WWhitKQJS4NY01TyLTdAQ2XgFBNRxg1V5iUBfvb3jHxrkAGp6dV1MpoCNCx8CFqZXl2jT/+ZqfocmE2FcIOQbhVXFhCW1QAzjDyco+nMmtDIC3S186SULwn5x1MPpNxrClABLjodAPAXfIaF+YDBqftSYweBtlN2PkOjT6NasblVlD5TKxn7XuCicRuhsN5Q9UFBn6/qGkOJHjegbioHT2iiIryriiIVHpQQOQZ+AhPhqAg6RBFkSAVXO09JrcHBvRIyOc3BhybF54olPCtyyL0Vx+pSmuS936ZkJCG8raPCAvJP/0uGdGgrFVQy49mWZrto3PnoeCCOjkLlswyb9glNICNb+QiwjhJEWiWED4mjQ5AvAy9G5KkRT2dQssYsOQ6+H/5/Ql7QK0pUhD786luhERwXXmCvi1A9dobaenbCntNXQhKzJrHw3nLaU5JE2P+6sirHXqMM2rEXaVz0bjvESoinV4XZmGH9RhYdmZn3lChrAUL9/VMnbPU1T0RDbRGMniUCbvapf0R5cPHoEao3Xj92dE+xT5wNWcNdQqhpRQq4oa6DWt8S/rGfZGkHngG/Qb9WxkXsGVW62T1tUIBpY+gGVDnMdzOxUDXy3IDmES+2RzPCVDlu9qhtkEujqI2p/mRBNopLy56JwXkvHHFrFMUtiejJKjaKXkgBqGNQXCWzeVk/WY4Ps+DoiTQHZNJzy/oIcc7Ny55aaQswn5+0a+JyYIDqCPhMnsxrNV02qIijPWF80E1bNVCBifqshtANni+sQIwxPmB3eA8YR+KN1uvCai+xlIFORZPNgSx/xW9WutLjaVnOMDbOTf7Hfq70ngJsyHLryfLnnwAAAABJRU5ErkJggg=="

/***/ },
/* 2625 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAb8AAACYCAYAAAB0zedIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAACEjSURBVHgB7Z1tUtvY1rbXlogh1V116BG0M4KQ32+9DYwgJj2AkBEkGUHCCAgjIAzgCTACTPr8D4ygnRE0VD2nTmJbez9rbWnbspCNLcuyPu6rKrHB37LY917fRAAAAB5grjrbBGqLRwAAACYQ4et76tvgr1cfCNQSRaAQ/nvVaaf8+sHveDeyrfkfzaZNq6M37QZ+b3f83u4ee8zT/YupzwFAleC/24++p14G2hzgvK4XjRY/2d39iIQm4Et/LDrt2N1G133f+330WL6vIjMSKWPs/e6UCcXBUPTzA7FQPUoQGP2d0t5f6uPTmSFMs2gvcz9fjY9HiJm4nxwDY8y9p9Q/RsnxIjnjouOjRp8tCMLP7z5v/LPw93LH38sdFh6wLmTj6vvqNAjMGZ+HnwnUgsqJn7OgYmLVjt1sr8dFyi3IIk4sTD1tzG9KqX+pkbUyFiNt9L0ZC8jo9wlh6cXfDxblxYlvOih9o2Ev+Tva9pT3r9F3aDccdMdC2lYq/v3puyAg+93xOdGT7wqiCfIkOmc/8dryT+uPL+8JVJ5KiN+Pq84NC5axC1/cYhhbTL3Y3Xvxyy2xJvYvFrWIQAWQjVCKxS7/Iqs0FE274fH4/FHu/NE9EUu+qRfb2PQglOAxxA3qeeq11mYf50u1QcwPNIrIc9COfrTXxcJULJbixhah5MXNhO5Z1Ytcsj35J9bkL3yJzVSz+d+rzk7LV8f9wLz/df/ihkAlgfgBkIITSUlACiKBZBfs84cCaW6GAX137lb2NNxAHOuPnB98DlwZbU629i8+EagcED8AMhIXSBa+nVAg1XN7o6Jt9rP2xMUq4si33YjlCEuhPthyCN879RTdPPn/X44IlAr5fv7Df5+8Md2RfIEN33sul2RMe3P3/AXED4AVEXOx2n/OchxX14ZWI4Sx2kgccGPDMxDA4okLHMmlJDsas8MxWcWhjL8lP2Ro9K0Kk+Bu4mELiB8AayDKHtxxVqMIoyToKP6LFItRB/qWb7uBK7Ua2HpAXnhbf3x5Q2AlRJvJPd8ntuC8tlhwkgKuSN2IwEWhh5t5E5EgfgCUDEmokAxWE4pj27pSU6xFiGK5qJIAyuarzOdOXOhYpnZ0wHF25X3LInLTgPgBUBGctZgmikFgrsVSHPDCAPfp+ii7AMo5NPC9Y/EslClRh4/bnpzXfOx2xW3J7o+bwOjrVW7yIH4AVJy4KPqKF4+Y+zQIVruAgIeUNQZohc9TVxwPO1u38Illx+drZ8NXL51VJ2LHN3WLqp+E+AFQU8R9+kRazLH7yFqJUQZqLJ54g0Lt1fDjqvPJ3/D+KYsARqUZ5yx8J+to0eY2aOzGfGmM2lMmjNOxAF2s6xyE+AHQIOwiyIuQtlai2rU9VxXdObcpBDE//nvd+fyE/KuN3f85ozXihG+gzZsiXeJjwfNe84brBf+qa0Kx61IJgPgB0HDcIkXWQvTYQjQ70jtVBJF/14XLNBthfE2dr7MTzDqET+J3YuHpgPZF7Ch0ZXapZED8AAAPcBbiyGXqhZM4XAyxjItZGYlNhHizDou6f33wzWhztLl/cUErRIR+uOG9ZbfqIb/eZZksvGlA/AAAcxGVYEgnG7YM1a7ywvZuJqBruEunE1pC6kPrj/N9KpD+11eS1fl9lckt7rORlsk55qTFVl5VvAQQPwBAJpJZpkqZdjzDFNbhmB9XnXdeWAJRyDgkmUA/HGrF38FHWgEseof8eV4aFtcqWHlpQPwAALnhrEOK3KVx67BKVsEq6H89uGL359GqhcI13d7cPX9GORJ3bdpyCaJPVf4+IX4AgJXhrENeaDqu3IKUYjHUl01zldr4n6fOn2izv0rR+MlxPhang7yObd1EzwHxAwAUiuvmsaHUSyeG4iqVxsN1707z86rTUewuXFUHGHF3BkN9n1ecz7o3PSXCd1kX0XNA/AAAa0VcpZ70cYzFDTVbhnUVQymA54W3m3cGZp7uTtmgcEzvrW2DVjPRc0D8AAClYpoYUoGtr1aJazOWt/vz59fOqebY6jIdXFxphtHqThv9vs5uaYgfAKDUJMXQuUmpwmLoLKvNP74cUA7kYfWJy9Ro0wm0ed+ETF2IHwCgUjgxtDFDO9VC9SSBpmrZpD+/vjpni/YkD6GR2JxcZrH6XK2edPRZVWlEGYH4AQAqjSzeZC1DtRuKoWHLkC7Lbr3k6f6UTi6LPk803ugDabMTmPV0oFknED8AQG2QBb3PQqiJOiyGv4sYDgMjZRXdMibPRNmfu8sUv/fZEiblvW3tzZ9Baid+eBLbW/94o3UB8QMA1BY3EdxT3kvlmW1xkZYtXrhs8btkjwb8eX6ZM3u0/9efbynQnSZae3EgfgCAxjARL7Q1hqa7bhfpssXvUtS+uXv+4rH7uUxOHRiZ4v6OGg7EDwDQSOIuUs+T7jPrK6nI2vtTBI0X8U8sZp1H7rfHAnvclEzOeYD4AQAAjV2kHCt8vQ6rMIv7c54sT5nuIEktT4w5wFzGMRA/AABIIcoiPSzKKszi/vz5tXOuA0otRo/NEmxUCcO8QPwAAOARirIKF3V/Tov3uWxODTfnVCB+AACwAMlYocq544wUv1Ogzx7r/SllEobfRzJ5ZfjvP19rrQ/XNT2+KkD8AABgCZIdZ5atK3TF78EjY4miXp5nccsuGmL7bIvoHeJ7s4H4AQBATkzUFY77kJ4t6np0Lcdaf5zvT7uPdHVpRS7PqFvLMb/Wd8T35gPiBwAAK2KZpJlZ8b8oy7MtQucSZdhSPFlmokPTgPgBAEABpLlHeQG+mCWEUv5gAnOSjP9FZRG2nRkL6/lAmzd1HwScNxA/AAomco1ZAqJtn//JdV4Pt3V0PaIdf5zPVsDDZzNtSsGYicfeKUNT4z/amN+UUv+iBTDG3HtK/TP1dmU/x+izKEW9qfcldccLUeL96bsgoPvJ+9HE/fh43enYz3ws7/zYz2VO9njoHk3PHk2L/1lLT3kfAqPPosL1AyS2LA7ED4A5kEXox3gxbyeEqi3/OXHiRXpbkdnmK9v2uqFeJDBmvHirnntubfS9mVz8e4mXf+xn2hJhqFCCQ+J4johvBhK0Z/3MYjDaGIyOf+xnFmslYi2ibBc9FT/e7rsYC25CaHuxl7LX8z7ekrlpm3H76nc3oslZe8n6P0l0USL9xuxA+LID8QONI2Z5tWm8iLZ9n9j68bbd4inWkwgX/ywtpHrOQnFiNWWBtJdVE6MmEhfgGRZ4293fCWxcXMPrfC48ENVJQU07V5ylmjxXJE7I9+2wWu+6OCH/vO356qW4OtnN+Teb1hcto9/gHMsOxA/UAhE0WcCe8GIVLVztsZvQtI1YYdoosb5kYYqLGE0Kl72O3TRYhKRnIHE5uh73DhjS7BVQ7dj95FwMRTISUbZYZRLFTux57qIxRO8ILAXED5QaJ2q8Q96RBWPDp9/FOosErc0LwX3oTlQ22M9xkO980ZN40IAv03bWoD7ErfipFps/3SXqXNOUEhc1CdeqovS4pVbjuCufh21anDuKXnv0Gt4obtueeA+Guq296eUPYH42CIA1MVXYOJYhi0G4KCkrYCJq1vUYcPyM9A0Erd5Eojb651zSs6x4PemK7rmEmCDQ8pS9+POLZe+E07k8nXhGrkwRxOu4pUbjOK6I0J1zh3tGXJzjGG60AUu+Zi/5u7h3wXWNIZ92raWnbZKQvMYEHDu+JJALsPzAyoiLG0VuSLuIGN4pGytsNyoSNhq7HHtwOTaDyFUoG58d2fgY8trRuUE26YPPC9YAK258Ht2kWfHO3Rh3eTvxmhbDnUw+CkVrWhw3nkGa53kZve8Ov8fnTuz4fd3ya3cVC6Ax6pAiK5aF/oTjf6/l54E2L1DSkA8QP5AZ+QP+Dy84sujwItFOLGBW3NwCxgtIT9yQv8hiBoutcTjLxi7s0Tki1pMs+Cw4NyJucm4k4mbtsZBNxG9dItJ2XMBkE+XEK1YGYW9b94Zq1Bjb91jYzI589sCYa/5dlwX9RjYBnu+9VZpF2lPsBjV79oHavPE2vOdam4/8U29z9/wZgVyA+IGZOIGLW29xt6TE2pzl5hYwiBsYWzbhYk9yrig+RwLjrHxyngAVbpZGbu6YG7PnhKxq8ds0sRsaW9R+42r55Bj9l+jQ3iewwn3j++o1i/uexPZYHN/Ic3ieOpXsTjkWrb0vbwjkAmJ+wCJ/rLzI7IQWnPfcCRzv1rdbLHBDo8Ul0+sH+gICB+I416OcP5HLrtMPE1AkWzFK5lA34aUZJSTJuSSCVgc3d1LsWKx6vCm85s94knRThn076eWPgF6Im1MH+v3GhvearbsPUTzz/eb+xadoHp+IoXMBw92ZIxC/BhG34iTWEI+xOAsuErgTCByIkxa/lQ2SWGuR0NkUfB3QjUfmWhbqOiclJS1bZ9mliZ27v1h5G756KfG9aGL7exFCaU/GwmdduH1tDtzj+fdX/MgLrenMY7EcBvSZQG7A7VlDHhM5seIkBqdDF0yPAKDpLm5tMyu9v1381pMsx/C2PRE8E/an7FKNmYhZGrWX5sZMQ/p5bm54L/kYHmqpzyP6JBsCN2WdNMcrlT3G15tEH91mof/11TFbhMrz1XOZ7BCf4ADyAeJXYaaJnEskiGImsgO/gRUHHFk2R/H4VJiZqE/qLHguE1Xcky4bM56gMuvvaSyU6m30uKN4nG+44b01gdmT52MB3I2swK57fP+vP9/qYfDM3/D+GQ5tPL3rK3WK+r58gfhVhHFMIX2xgsiBNCbLCbznYTxqfg+AW6yTlgvVEHFBhscpdE1GmagX8/5dPXaspH8neeqDWMsyqohfYEeSWuLHXizFJ6EbdF8sQ7H6orFIe5jTly+I+ZWM5GLl3E6e8r7JYmUC4niK3XX3CIAY8XPHWmi8QRoY6VxibknKCQJ9NO954xbyfsAu0KE+29y/qF2K/TgOZzcF7MpUXUlSeRKYg0UE3g2eHYiVN7TH+Chxu3Vx6sDcDrV50/KVuDQvtzjml3K/Y7YE9znG94Evz+z7DL9TJLvkDMRvjcQzLNMWKySegFmM5sNFFl383JEMwiwbpLjo6aHdZB1RTYi7MiVuJ8eL/+Yuo03BQiUESSuvH5j3yUSXCRcnuzb9Df95S+tTvm/q7D2Z3CC3+fbBii29c/uelGTRQvxyB+JXEEm3pQn0M5dE4Ifpzhew5sA0kjEotiJ+c96AaRmGiz6/LNQDbTpsvbyvi+jJ3x1bTR1xZYplJpuDIBBXpjnKsqlMWHni2nyR9jwyab0vLk7eQGwSHbCyHXMc756v77dS7h8luJzJ9ygji/j7HR1/GXPE1ijEL2cgfisgLnTJhUrcli3SR7DmwCySYucWbj5/uq2MC/c0ZEHnhZoXZy3DVCudUZi07ly93aKuzORzOiuP43WXyQSVOGKNh25Nc9vS5oW8l76ULLB1uZWYxu4Y/PXqw3Co759GtX1xq8++vqFtrBf5A/FbkllCJ5OZt3JeqEA9mSZ2y1gp87xm3/dOlaa7J1rvV/U8nWbdsYC8pyVwxeh97bXZyrt+OsXKE+zEdd/7IEkszgUqWZt+oDuzBs5KEoy4Rfl2m8kpsb641QdWB8RvAeK1Pk7oxHUpO0sIHViU+KL9U84ldn+vUuziyKI7YLdcFBvsUsVwwhSvuZNBr8uGDuLF6EYrmQjBcc8v3VmPEZHra/1Oh7FDKVxv978eXLGb83YrErUpn6Gt+DsQcXQ/J60+sDogflNIy5zrm7DTPK3A9QTqT9Ilp4ztqrOUSy7LexhI/CnQ9+yWS40/lZHxxtN7acLi+ss8NwqjRB92bSptzsLv5Hzm87r4XzAMrl3sz/7OsxmbMzcVLgOU7zeyCqdZfck5gyAfIH4R4qv3ndCRaTv3CS2ROQdA3JKQc4o3UdZLsKxLLgtyjvelSfKM+FOZiB+7PlthmkMJ/N7PFs3MnEU8gcUmp8xR0hF3ccatTUlakd89mWNTIZmdkUD2ovcBq69gGil+ae7LPDPnQLORhUwaFYuFEgleLi65ZRDXHGl9OCv+VAbSjt08VliG1zn02IqUeGdU6tCd53FyHAd8HA0/ZjOq0xvX8T2s3Ut9jiizM/6a8pmHQ50a6zNqNOYJ5EgjxC+tHsqIVQf3JcgJsSB4AdvV2nRsDCpMgz8ow7llF9thoKal2a+boo5dsjavFeg3875GwsU5Sg6a183piGd2xt/XwIyTXkAx1E78XFxF/phk9wirDqyKyUVb3USL9klZNlOhe06dRxbJJyoRkwkrqz12zpqUGkZ5nVlZm0mmuTiFRdyc9v7SszMwO/wcB/Hfy3QIirq5THkXBPKn8uKXLDVwsTo91GzVlWchAvVgZD0Y2pGp2+KqChft81KdZzbjUHpEBka6tHymEhATvM5kwspqjp0dF+TTa6VVe5jSduwxnIszCGP+72PPu5CbUxDvk9H6XcuYB3WUMrNPenhOe6xS6k7OO6xl+VI58Uu4MKWI9QalBmCVJJNWgpJZeEkii29qG60iSRO8VSf7OBfleG7eeTfL452LM27VjW6bUeie8nyjnp3Jc0Zij7KGzXq8TL+XmYmEFme5Umrxm+bCDMVu8X58ACyCW+gk05AKLklYBnmP/LdzsK74XtIdHNjkjtVntz4UvcXqF8OifzoWSzEtQckmDUnR+gLJS7Z/b5jZmZpo5Nk6Pz0z1idNraMZixC/HCmV+CWzMPuattmFec0ui5uyJA+AehNbuG1SRBbLoQwU/bfi4mrrcAcvK3qCc3Fqm7gy+X27Tjh6GHzfWjApRUoa2OJNnaYh71smSfDr9WY9hzS1VhIXBLmyVvGLLLtOPF4nWZi6oC4XAAhxt6YsoFniQ00k5bgV6g7OQ/RmuTij223sNEttpCTEsNUr/VJTHyfxSPFgPfY8Mk9wIJ8T5Eqhw2zHySnWjbnj2hJhECtYB/F4VN0HtebFuEtNKDry9/uU6HORx826En3vWCzM+JT0JZ4j1Y05/Pefr3Wg32WpjYxKGtS0AbQ2DrjAdHZpl1YVt3tVWKnllxQ712E9yLlLAwDzkrRWIrdm4d1WqsaoyTNvFGjK/LpVMzkfT2cSPUGEycjophl9TcVqGwyC37Yy1EZOK2mIEx9WOw/DwFzy6XrIV0tVslJlchW/aWKH+jqwbtJ7N2IXPYuR2ITJZrdFZGpOY1R2EA7YzVQMbksfPHU8nDG6ydVGsjBeP52zjCHOrJKGOIpUe5FWZuwdu/B8dUoQv9xYyu05Tex4h9KF2IEyMBEXyugiaxJlcGvGcYLFbunLrG5pV5dnwv6gU/v0usxMfq33WV2pUbPqmdmgUt7AC+/2oo0H4PrMl4UsP1h2oAo416Y9TwP9PWsyRJMQi2Vzw3spljGFWa5r7UXqMixFgLXWmfqRxi3Xx7J2ZcSTGy+U9bX6M0oa4khRuxxfWhC4PvNlpvjFszHjc7MgdqCMJF2bi/RubCJlzXIdlx1knzXoptMbyUB9xE1qY4AcR3yyxIgnK9RhHLJHs99Xm7TqPVbekIZY4PZ1IH65MCF+8To7EbuoAfTlukawADAPro1VX3vbOoznPDqWpsnEk1fKFP8ctQ0bBrdZm3C75xCBeWw6vZttyHHE+60lmkpHmZ23T+cohZBEl0GgLykD8ll+djv2+4MnY3k2whOAPlAkdtqYa0KrMFABHtZ5zZ643XSsa89Xb8uY5Wq7pxjdyZpFuoiLUxCRHNjep9YyzGxJyfsOhsFvLEbv5rm/JLr8sn++UL1gHG3ohN35r/lql8BS2IQX8ff/QtSD2IEqMBY9G3M+wy54OskxPmWrZRw3iTa3W3MKSMpz2KQYI59vDiFbNrEl8TxXLW3mmhIhiS6+8nZbe1+WKvP6+fXVOVz6y2PdnojfgSpgF48wWeB6FQNO60RyQnlrgTE+RTFKMgmWy64U4WQB2p/n88lG3/fU6bJDfWOZnfvzHld2eb6U2kJaEpkm8YNINgofCWSm0A4vACzKKHPTU6+XSXdvAsksV0NSl1c+q9jNyGMhkCLyd4t+nxPF7guUryzTsSVJ//rgW1/PPzXDWZubu+cvKAd+Xh/8Pa/FCdJpxCR3UD0eZG7q+XfYTaNKWa421hbNwstSRC7WYp+txXmyOONIUkowNDstY5aeZh8luFwu6DHb483bCeUEP9cRW3/bfBV/ExmB+IHSIe5NWeB02CgZu9spuCzXgVZtcW1uljzL1bpiOTaXZc5g3MW5ueBGKBQ+tjJntBtb4H0cmoDai7ZnzFrbN42yDCiuMhA/UEa6bOldQPTSWXZY6zrIWks32c9z8WYF/a+vTtlK+/40YzJNHCvAnnr75JH5e2mPk+9qnU0DwEMgfqB0YJFIR6wOz/deRl1r3lTlONnRPkOtFq2lcx4AsWoXfWyiR+dHygHJ7AyyFcJLbHLuJtagGCB+AJSYZKlClVLcnQBJfG+RWrrx42wW54ssCTEDEarAnOTlHhQB589xkmXDkbfLEwAAaotdwNlVKFl9bAF9lJ+pQoirj9/7N0lQoQxEfYQLf90pz3nY7746pQzYrlndgysCpQOWHwAlwll6P4YcVxrqz1Vs1eaSU7IktjiyWFiunGCgs79u2nOGlpvOZLlJb2RlTKZ2ZmC1QPwAKAHhZHH6EPUnPSlDg+ksxMf6/FpgTHIVwidEQ2ePssZX+fG7g4ByK3EA+QHxA2CNONFTWrWr3p901D0lWL6IfBHysDSnPK+UNdwv0yhAGbXz6/45OmiVEIgfAGvgoeiVv1xhFiJ8rRzahi3KqixN5+6UNnqUESlJIaMgfCUF4gdAgdRN9IRIKI7XZfGtouzDuTuX7AazNzAa8b6SAvEDoADqKHrCKgVoXa8r7k6lPVrWBc3vb3crMBg8W1IgfgCsENfEmbTZqZPoCesUPklu6a8gqWbZ7E6HLXEwtI0uReUF4gfAChg1mw5oJyqOLs3g2Dywi/uKBGgWq8rqdPi+95aF72xZMf9BtKO0uSZQWiB+AOSIEz1enDtBhUsWHkM6qLA1e1TkLNCoc8t5f0XCJ8JqjOnktFHZCzBtvdRA/ADIgfhYoagXZS5z28qI7dUZjiS6oAIZhL01T1YluBKT1YFZqIfoNBDvKz8eAQCWImrAfDUcaiW9KBfpY1k17HigQN/n1Sx6XmQ6g/Q2XdUoHylLCJNc8nPhIt5XbmD5AZCRcJ6e95ZjerdNGLYr/TJltNDTBScsLEs0PFbGEq1sU+HZGkWdy+fqX3U4zmvuCZQaiB8AC2ILun11TFr12Ap634QRTBIPU756W/R0gkj41CotTVvaYFT36f55j3IgkGQXxPtKD8QPgDmpc9nCLFxmZ9FF7P2//mSr2uw8zWEC+yzY6vuQl9UnsPDtGKJC46FgcSB+ADzCRAZnaOnVqmzhMUTwTQ7p/4sg1rXR+l3LmJUmDuVt9Qmer563/jhfenI8WC0QPwBmIHEumSauhza7sbYZnNOw1tcwUEUm8cTapa08jppHQXsSY6hSsxebCsQPgBQkmYUXRkl9v91sQDJLGnagrNaHm0SFJbgU6WK1jac5bpun1WeTXbT5TqD0QPwAiJGI671pQjLLNLywrm6/VaDw933vlAJ9VMRx93wSq++McoRjfW3+h0kOFQDiB0CEZBY2Na6XJMqyLDTOF73mbRHF89aqNWqHrb5cXZ6aaEdD/CoBxA80Hluv56ljXngvt9jF12p4cbJt81VwPZ8knuiAVp7ZGWOP3ZO5T1hna/J5ECDTswpA/EBjCccMeceyXddaHzTZxekYxdy0KUqEwgQXT719kmO5wWPI67V2z/NPYDKqjcnt1QDiBxqJuNjM2MXZJWApuqwhLrZFWdySlLKqCetKEVqaAQDKh7g4f14ffOPLjwQmEAus3z24ogL5+bVzKi5PKhgRXcoZK+QFHz+QHVh+oBHYhUkyCeHinIrL7qSCiGoI71fVrHoWqyhdsTP8jLklUAkgfqD2yCI70PpQw8U5laKzO21SjdbvtvYvnlFN8Ii2eW8Ft2dFgPiB2uIK1YNhcI0szumIEGltDp8WJEQuzqcLtDKLIECNX6WA+IHagUL1xZAhroOguOxO+W7YCj+p2/fiQfwqBcQP1Aqx9tiqOJaMxa2GF6rPg23srD36df9LIYu2TW7RtL2OON+qUT79vul7fxOoBBA/UAtcQovSdCf1YpiiPR+raOw8jahhdWGvVzSK1Lb6f1/Q17MiQPxA5UFCSzZkw/AzMJdFuR9Z+E7DOYj1dEMbYzDNoUJA/EBliSyJUz0MbjeR0LIwkXVcyKgi2aBI4lG9NyeKQHWA+IFKIospGd2JLIkugdLiRiPVfR6iMihzqBIQP1ApZMJ3SwadhlZErVLl60rk7iwsm3QdWIEHlQLiByqD7ccZmD2UL1SHmLuzRzXGJ5nernoEKgPED5SecbG6vtyCtVcZmuLuFAIWP2X0PYHKAPEDpQXF6tVGiuf7/L1RQzBobVYpIH6glKBYvdoUXTxfAtoEKgXED5SKCWtPG0xfqCB1L2afQY9AZYD4gdIgmZwDXx3rwMb2YO1VFHF3spv6rEkbFyMxP7g9KwXED5QCZHLWgzDJxdt+uv/lMzUIFY4z6hGoDBA/sFZclxZkctYDGYirtW7k9+jB8qsUED+wNlyXln5g3v+6f4FRMBVHkly0bpa7E1QXiB8onHhPTlh79cAluTypeSeXGbQJVAqIHygUa+1pfcixPUxgqBEuyQXNxUFVgPiBQghLGNQ5JjDUD7H6lFY7T/fPm1baMEGAmF+lgPiBlfPzqtMZeOoDrL16Ell9TXV3jvil5f1DoDJA/MDKcAXrRlNbpqvD2qsfrpPL0/0vPQKgQkD8wEpAe7Jm4IlF39DSBlBtIH4gd0YF62hPVmtQ2gCqDMQP5AYK1ptF2L+zOVMbQL2A+IFccCUMMsIGBev1R6z74VDD6gOVBeIHlkKSWvq+JwXr31HC0AzEwjfG7D2FdQ8qDMQPZMYltVCgj9jNeUGgEWxseK/F6iMwwX/6+je++E6gEkD8QCb6X18dY+Ze8xCrT2tzyN/5MwIT+ETbBCoDxA8sxKgvJ2buNRIpaNeBOSIAKg7ED8zN8N9/vmbRe4eklmZiZ/UZtdf0NmZT6BGoFBA/MBeS2PJjEDzbQlJLY4HVB+oExA/MhQoF7yOBRgKr73E0Yn6VwiMAAHgEa/VpWH2z8CB+lQLiBwCYydjqu/hMIBWDcUaVA25PAMBMEOt7HHZ5dgkAAEA9EKuvf33wjQCoGXB7AgCmIt1cAm1OCAAAAGgK/a8HVwRADYHlBwBIRWo7TQCrD9ST/wNtuvFUqnVL1AAAAABJRU5ErkJggg=="

/***/ },
/* 2626 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2627 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/market-challenger.a73d4958.jpg";

/***/ },
/* 2629 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/market-climber.16e56808.jpg";

/***/ },
/* 2630 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/market-leader.0b33f724.jpg";

/***/ },
/* 2631 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/market-newbie.f5a818ff.jpg";

/***/ },
/* 2632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/market-warrior.8ecadec5.jpg";

/***/ },
/* 2633 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/next-steps-1.a614dcd6.png";

/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/next-steps-2.8d0f9eda.png";

/***/ },
/* 2635 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/next-steps-3.11093a4d.png";

/***/ },
/* 2636 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/next-steps-4.3378554b.png";

/***/ },
/* 2637 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-customer-preferences.399e605c.png";

/***/ },
/* 2638 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-distribution-centers.20b4975f.png";

/***/ },
/* 2639 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAeCAYAAAA2Lt7lAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABHSURBVHgB7c/BCQAhDETR2WUL2dK0MzvTTjQIgnh1jv/BQMhhQiQAgFeNdFPqKn0F3Hq2OUV+ebRIOQ90ec3ub1tkeT8ATAYv3BgWl9prOgAAAABJRU5ErkJggg=="

/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-machine-options.9a88d384.png";

/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-trivia-final.c4fb6003.png";

/***/ },
/* 2642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-trivia-image1.5efd60e5.png";

/***/ },
/* 2643 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-welcome-round1.8285d8ae.mp4";

/***/ },
/* 2644 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-welcome-round2.9a61b28e.mp4";

/***/ },
/* 2645 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/onboarding-welcome-round3.dfeb66b8.mp4";

/***/ },
/* 2646 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer-feedback-cultivating-leadership.af2d9741.png";

/***/ },
/* 2647 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer-feedback-teamword-skills.39d4d686.png";

/***/ },
/* 2648 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_image1.1732c42c.png";

/***/ },
/* 2649 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_image2.07fe3382.png";

/***/ },
/* 2650 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_image3.cde05beb.png";

/***/ },
/* 2651 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_image4.2ef58dd2.png";

/***/ },
/* 2652 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_image5.d3f555a5.png";

/***/ },
/* 2653 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/peer_image6.39fd1b12.png";

/***/ },
/* 2654 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf10.311a19f6.png";

/***/ },
/* 2655 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf12.f29da532.png";

/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf14.52caa242.png";

/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf15.13f710b2.png";

/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf17.055e13c5.png";

/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf19.bb6bcf18.png";

/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf24.36ce6dc9.png";

/***/ },
/* 2661 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf27.d723501b.png";

/***/ },
/* 2662 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf29.38fea35f.png";

/***/ },
/* 2663 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf3.224e4fed.png";

/***/ },
/* 2664 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf32.a43571f5.png";

/***/ },
/* 2665 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf34.2b07bea7.png";

/***/ },
/* 2666 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf44.a96f9f26.png";

/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf7.3eeab328.png";

/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf8.e9e1b9c7.png";

/***/ },
/* 2669 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/posted-decisions.423dbfb4.jpg";

/***/ },
/* 2670 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACMSURBVHgB7ZO7DYAgEEAPYlhAGzscxS2wcTZDg1s4inRWLmCDoSMG4fiUvPbgPSABoNEohfwN7nU5DQAHnET3Uk2+GYUKhA5CIINLCM4YOVzxIJXXlXwDV26fJrY+KfCVP9TMsT3ogE8+bruO7UMFcuWoQIk8GiiVBwM15MFADbmlCw0xcsxfaDTKeAF5u1IClyxpQAAAAABJRU5ErkJggg=="

/***/ },
/* 2671 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQfSURBVHgBzZnPTxNbFMfPuR1+a6mRvuRt3iu7995GnrpUqf8BurH+qGKiUTcCcWWiAaIJK4W6cmEiWpW6Uf8Dq3GpBle4s7oxkRIKCmjrzPWcWwZLmZl2fqTwSZqZnpk7882595x77h0Ej8yeSMQBsQcBehGhBwAjEmSEryFgAUDmpIScRPkODMhGH2Sy4AF0c/OHvr5IONw+QKeDphgXLyLBmC2VjNE/M5mci3Z1CutsGyaPDEIQSJysV2hNgXMnj7HHRtx6rI4X53QpR/9IZyZr3GfP3Kmj44F5zU6AFBM70w+HbK9bGblLt29ve0pX49AASMS0ECsHd0w+K1RfE1YNwuG2540Sx0iAHl0nh1iwQaDqVuC00WDIIXPJ4+MbzRV8SSb6BeJd2ERozA9F01MT5v81gZ8TiVhzMz4n78WcHtC6rxe8YiwvQfHt61q3FUJipdscj5ppbWoSw5RKYk4tm3fvgY6z58APX1M3a4mMGHrHMB2H1gSy9yje+6EG2N6hjkZ+FkozM+CG5j17qX27+tVCojE43983yl5UAtl7KpbqRM/n4dud2+CGzugV0P75r+77fxrtnH9HVBQjyjh4RPvrb2iiF4e6oms2QV6qtrkFQQ6o53NVUiswbB9CQjqvjalz7vb5S+qZyiZWxc1fOEPBsQweiLA2QZkwDj74+X6GxOXXDfzim9fKVuJr3sSVoXJOQ4m73BVdv5H08oWxaxvsS4/S6ucbGnqUl711rwmPN2Ex1tgm6ohYx2cD7tIkYMxNBFfCYzBy45Y66p8+QuHqZWXfcSOlBPK4XCCb124mVRGKYn91nqTZgdFJjIlRce6TiAY+4DFoRm4lC2PXISjIg1iArUtBo4RY4L4GH4QvX9mQlNm7ixThftIMrQ5zGpU30+AjkjkYmuymMJ67fQg0wPgoyHsvICDmL11UvwCZ1qhCJA96zNRV8OwRKLTgF+UV/9YLFF6WsjZVzUgwUrDFoC2TLB9VHtRE64Ru/Bi2u5kjtK3vMISi5UjlEmvbmXJlbRaxjGkz6TieBLlUTuTmdNiy/wAF1b+w8uzJuuReTQlhVD3fNORPHuWFyoDVzS37DsC2s+chSBxLf5STXfcyp/l0bSYJiZYR3Siespr6frx6qaY0UeEtv9iJ47FXXPXe6v/fzCaPDCKKcdhEDClPV+7XrFu4R9OPuZs3M2BS1ZtJlgkwn0zQ1gfGoYHw/szO+1P/V9st92ZCodZD3AAahYTsIm0eWV1ynEKcIjtAUl33p2y3+IRTS27Ig5YjCwKG97F5H8ZJHOMokOFBWxTyoAHyHgRHalEsd1duEtnhqkr43J+IhQwYCQH2ul1Ls8eofEp9E98nui02Ku3beUR9hqA1NS9byytDjFV9huAunFblHFVMXj9D/AIrVZKSPMM98gAAAABJRU5ErkJggg=="

/***/ },
/* 2672 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/spinner.71af768e.gif";

/***/ },
/* 2673 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASXSURBVHgBtVi9bhtHEJ7ZO1LnAEmYJkiXawwkQCxTXTpTVZg0loA0jhJEfAJKTyCySyfxCcQgUFwFlptYqUJ36XKJjSCFgVxKu6Ibi+LPjmfud48ixTuK+gCJt7d3u9/NznwzuwgF8clx3S2XaIsQ7yJCjTRVALESdBL1EZVPqH3U8HQ4wtN/G2d+geEB8z5456S+y09/DwQ1KAAE9Aio82znrJvv+QX47Kd6DRUc86UL14PPf+1FxOYSco9rlffWbh0Q0d50HxH0FNBj7vNHY+U5MOjL/QE4FdsGVyFVNeB9WdLLM+KRdXHe9hq9fm5C4id2GR8hUNVg0SfCjj0eHM0bbBrVh3V3MoFWsNRZ+KMhbM7yL5xFplSG38FYIrGIbUHDe1DMQRcQm0kqQ0iW6d2y82eGjIb28+/OWrACsD+22B8P0snRU8PzTdPiynxBfMYkown3V0VGIGMhjxm3Ofqqk3BOSElGCMIagmgKH16hZaYxbSmea5Pn6sm1aSGTafemyAiCsRF6cTuSFUgIRdZx45uWgjbcMCyEhkRu1HQjDmDLP17LJqar1102mkxEAbIVNBD7z755cmr2yxy8dB3WqnBlwgjsKglzJpPozaqsw2QOIfTJY5oYemZANC1pcEr69OSrj5XFiTK5x3qzCuusn3zR5J/dcB705vljEO6GLymibaUQ7qUk8TFcE2Jx/rBW1PRtRdtXPa81JXNyyrmryHBmJPLgmghUPi5HOJkusjhbxeyv2UhMKPLniVL/zXtRloHE15D6owvszMpD6w/rB6wprlxLyfF857cuLIBlK2+i4xZWbONrYG345vW8F5mM9O0CIZTLWOPrDbP/zs9fbnGx1oqavj28aEEeDLhSKDvxLBUFOSF1DGnshOSoygQO4z7xG46IpM2Rupm3IpiGMsQJLsrvvH/Vw/b4vAVhoSUhuSfFm1yWyihk3OC2Xuw3GThOJW1gX4loJRPieOOqd+WrJ6CSqBHJXw8sFUsHnhZNOeOxUVmA9tlC8DS+obXlLhrgn51fPSNju0ZF6VuK9qEgCFPR5Nj6X2lIQ10pup9nkL+/fXJkClo4Gu4vI6oshMmcmlRPlSxMcwzLd5VzUJ6BzOQofjOdq/IgDIa07i5ZdKqCrzK+dmw7e3kGk/csC8XnGsuWKiyiaU3EKyVjBpKYLc6wPxrSRtENXlFEtbspxA2RlkCHor2SH3GtlNbSgummYFpH5o73a4kwsh80km5eV0kDcEOIxt41biUljxVfvHr0wv9w+/YHXDB9HpP66Ovbr1/+8uIPWCUZyYmEP8TtKOcl7UzqECVGQwZYYw5Xaakg+QIeGbcu5bxLG8VgU6ezG0VGlzd17WUdPXBg8cvsQYUf5LwHV2wUF5AqTCw4H3CcJpewe2ZVIVWkFG6zhHTuYYMI5Ni+xfsnasLlt3rIlR5vJD3ORf4gOmxw+LChtIZV1NolUeAZRzfiM7JMhQ4bTEQaldnRLglfIjneEM5DoQMrdvImIlahAGTjwJH748oOrKYh/qUntKVR3WPx4i2UlMDpkZ6UM5pJWEB/LXOk9xYHMzccqAymhQAAAABJRU5ErkJggg=="

/***/ },
/* 2674 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFnSURBVHgBzZO/TsJQFMa/cwumk+noWAcTF5HRUSc7ipskhjI6gU8AfYOObsiAbq525A1siDEODsxOOGmw3MMtBFr6Bxj5kqa55577O1/OPRfYNVFW0OycG/u63gDDZoY5TySfwf7/GM5n3RtuBJWerBpLdkFkILv2iAjOoPrq5oJKvcsGg1xsIQWzB1WvmwIddyyzWOS3fCdpZ9r499Cv90fhSizCxT20NkCGLOFESzaCgt5crJYg1cjyGgg0iIooqLS4J4FaCqRuZQVE4Kb6/FkR5SSQ0lD/doJvpkBJqaaXhaAKE/pBgEdVvYM1ioOGiT1bMl29V72LWf9i1aNic8crIGW7m0pktE56VujERobCIU2BCsGfq06OEigjDxLmaiK6xSVoNg9E99hSEsLxb6KnosU3v1++/IProx9V7kxBdeQ4mUi6+7j1HuLhzEdbfrbMyQRt1cxTouVYhAPZDVuwmObd1hS7E4KXYNUpWwAAAABJRU5ErkJggg=="

/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/supply-chain-decisions.0d6d064d.png";

/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tooltip-image1.cebae796.png";

/***/ },
/* 2677 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA4SURBVHgB7dIxEQAgEAPBBBF4RBEeMfFAgQJo+LltEgEnIT2fExF9TdUbw3bbpwjpURHuURE+MAFBrw8K1hcJrQAAAABJRU5ErkJggg=="

/***/ },
/* 2678 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/trivia-round1.6a578d91.png";

/***/ },
/* 2679 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/trivia-round2.afc91b47.png";

/***/ },
/* 2680 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/trivia-round3.60ad4e9a.png";

/***/ },
/* 2681 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/trivia-round4.6a578d91.png";

/***/ },
/* 2682 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANwSURBVHgBzVhhUhMxFP6SojIMo3gClxNQTuDijKOOP5QTACdATkB7AuAElhOgv1Qcp8sJrCdguUF1HMQBNr6XpLsJLW2y1o7fzLZpmrx8+17ey3sRiIT6kCYQeE3NFfpO6VmCooch0Kd2Tq2cvk/oeSdeZHmMfBE6kIhsooENWiRFHHoocEDEOiGDJxIiIikk3lIzwd8hJ2LtScRuJaSO0iUsYJeab4b/REaf72k2L9LDBZmKMa9NxyZt0vcrbdKbkNjHTyK2nvWDCel9InFEzaYzso9rHNDi+7cJGykHaJGsjRt/8Yusjdpf4hYyXbgmYo0obMVuUE/mMLGRpDxC1kxf4e+XtniWtTAFEDEmtet09XBOpByNS2+G2TNJJQE70yLDIG20yOw7TlcTix7BSkParY03DdCeJhkXQ5oypst8Qp/SUwy0o9ARz7OtANmDsNDVP66wKl5mvaB5H9Ou44U5vfwyN6QVugnfVG3UgbQRO4gRtrTnGiSWg91DEtvOwE5db4qBXoPDyAAN44HSumTTIVRPO3UwT0GyWjdVX548kvagNBDIZqGdcrm1rG+jvsFlsc6EHpcdBR0Hs4e75grvoaT8qRDkIVOF0OnKoJ2yhpKy4648xaxReEpYkmVyxfhRfMesMY++T+g/g3SCE3BfPsCsceEF0/4cmYwJmc6rYpU+zxAHzp87ZTseSdmiDT5Hm+qE9GQ6VXyaauNW0Lk3WoATlAucscmqXS4p7Zw93DUzYTPEyt3P8TA0RWWo45TfcE//uKT8KfC013Nvrl1gWWqVu+F7YURSP1Yq5VBcGvFzx8unJqPh5ERkKeYirdBDZ9i2PXBDEZ5yONBrKGyWHfbk14RsrZSXCzSi3nRHz+XwcRWRKTS81DUf1GtuCltlfoZqSzzN/kkqQtkpk2mVHYWuaDpmWQud0yonYSrQojQzbj+FkDlOtz0yyi+z/aPjnh5YeYnAnvqc7mJaZFgzyknK2NS/HHIILRQFReJrXZfnqEOEZTasN7pkJhWKY0nVIKYLz0XK1xWFEuV5I9+IrAeV0qWwLgn7TeoUTgFQzcp0dmkSuty7bFB0FPBRxFF/1NUN71MyU9RlgzffFJB+RVsPufWmbNyguAsrUy41EQNzUXE4tQsrDBMzV3qmOEh0Cuxf6Q0qiW91rvT+AO1fX0OqUPhjAAAAAElFTkSuQmCC"

/***/ },
/* 2683 */
2682,
/* 2684 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 2685 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2686 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter v5.2.9 - git.io/ee
	 * Unlicense - http://unlicense.org/
	 * Oliver Caldwell - https://oli.me.uk/
	 * @preserve
	 */
	
	;(function (exports) {
	    'use strict';
	
	    /**
	     * Class for managing events.
	     * Can be extended to provide event functionality in other classes.
	     *
	     * @class EventEmitter Manages event registering and emitting.
	     */
	    function EventEmitter() {}
	
	    // Shortcuts to improve speed and size
	    var proto = EventEmitter.prototype;
	    var originalGlobalValue = exports.EventEmitter;
	
	    /**
	     * Finds the index of the listener for the event in its storage array.
	     *
	     * @param {Function[]} listeners Array of listeners to search through.
	     * @param {Function} listener Method to look for.
	     * @return {Number} Index of the specified listener, -1 if not found
	     * @api private
	     */
	    function indexOfListener(listeners, listener) {
	        var i = listeners.length;
	        while (i--) {
	            if (listeners[i].listener === listener) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	    /**
	     * Alias a method while keeping the context correct, to allow for overwriting of target method.
	     *
	     * @param {String} name The name of the target method.
	     * @return {Function} The aliased method
	     * @api private
	     */
	    function alias(name) {
	        return function aliasClosure() {
	            return this[name].apply(this, arguments);
	        };
	    }
	
	    /**
	     * Returns the listener array for the specified event.
	     * Will initialise the event object and listener arrays if required.
	     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
	     * Each property in the object response is an array of listener functions.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Function[]|Object} All listener functions for the event.
	     */
	    proto.getListeners = function getListeners(evt) {
	        var events = this._getEvents();
	        var response;
	        var key;
	
	        // Return a concatenated array of all matching events if
	        // the selector is a regular expression.
	        if (evt instanceof RegExp) {
	            response = {};
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    response[key] = events[key];
	                }
	            }
	        }
	        else {
	            response = events[evt] || (events[evt] = []);
	        }
	
	        return response;
	    };
	
	    /**
	     * Takes a list of listener objects and flattens it into a list of listener functions.
	     *
	     * @param {Object[]} listeners Raw listener objects.
	     * @return {Function[]} Just the listener functions.
	     */
	    proto.flattenListeners = function flattenListeners(listeners) {
	        var flatListeners = [];
	        var i;
	
	        for (i = 0; i < listeners.length; i += 1) {
	            flatListeners.push(listeners[i].listener);
	        }
	
	        return flatListeners;
	    };
	
	    /**
	     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Object} All listener functions for an event in an object.
	     */
	    proto.getListenersAsObject = function getListenersAsObject(evt) {
	        var listeners = this.getListeners(evt);
	        var response;
	
	        if (listeners instanceof Array) {
	            response = {};
	            response[evt] = listeners;
	        }
	
	        return response || listeners;
	    };
	
	    function isValidListener (listener) {
	        if (typeof listener === 'function' || listener instanceof RegExp) {
	            return true
	        } else if (listener && typeof listener === 'object') {
	            return isValidListener(listener.listener)
	        } else {
	            return false
	        }
	    }
	
	    /**
	     * Adds a listener function to the specified event.
	     * The listener will not be added if it is a duplicate.
	     * If the listener returns true then it will be removed after it is called.
	     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListener = function addListener(evt, listener) {
	        if (!isValidListener(listener)) {
	            throw new TypeError('listener must be a function');
	        }
	
	        var listeners = this.getListenersAsObject(evt);
	        var listenerIsWrapped = typeof listener === 'object';
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
	                listeners[key].push(listenerIsWrapped ? listener : {
	                    listener: listener,
	                    once: false
	                });
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of addListener
	     */
	    proto.on = alias('addListener');
	
	    /**
	     * Semi-alias of addListener. It will add a listener that will be
	     * automatically removed after its first execution.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addOnceListener = function addOnceListener(evt, listener) {
	        return this.addListener(evt, {
	            listener: listener,
	            once: true
	        });
	    };
	
	    /**
	     * Alias of addOnceListener.
	     */
	    proto.once = alias('addOnceListener');
	
	    /**
	     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
	     * You need to tell it what event names should be matched by a regex.
	     *
	     * @param {String} evt Name of the event to create.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvent = function defineEvent(evt) {
	        this.getListeners(evt);
	        return this;
	    };
	
	    /**
	     * Uses defineEvent to define multiple events.
	     *
	     * @param {String[]} evts An array of event names to define.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvents = function defineEvents(evts) {
	        for (var i = 0; i < evts.length; i += 1) {
	            this.defineEvent(evts[i]);
	        }
	        return this;
	    };
	
	    /**
	     * Removes a listener function from the specified event.
	     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to remove the listener from.
	     * @param {Function} listener Method to remove from the event.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListener = function removeListener(evt, listener) {
	        var listeners = this.getListenersAsObject(evt);
	        var index;
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key)) {
	                index = indexOfListener(listeners[key], listener);
	
	                if (index !== -1) {
	                    listeners[key].splice(index, 1);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeListener
	     */
	    proto.off = alias('removeListener');
	
	    /**
	     * Adds listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
	     * You can also pass it a regular expression to add the array of listeners to all events that match it.
	     * Yeah, this function does quite a bit. That's probably a bad thing.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListeners = function addListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(false, evt, listeners);
	    };
	
	    /**
	     * Removes listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be removed.
	     * You can also pass it a regular expression to remove the listeners from all events that match it.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListeners = function removeListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(true, evt, listeners);
	    };
	
	    /**
	     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
	     * The first argument will determine if the listeners are removed (true) or added (false).
	     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be added/removed.
	     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
	     *
	     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
	        var i;
	        var value;
	        var single = remove ? this.removeListener : this.addListener;
	        var multiple = remove ? this.removeListeners : this.addListeners;
	
	        // If evt is an object then pass each of its properties to this method
	        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
	            for (i in evt) {
	                if (evt.hasOwnProperty(i) && (value = evt[i])) {
	                    // Pass the single listener straight through to the singular method
	                    if (typeof value === 'function') {
	                        single.call(this, i, value);
	                    }
	                    else {
	                        // Otherwise pass back to the multiple function
	                        multiple.call(this, i, value);
	                    }
	                }
	            }
	        }
	        else {
	            // So evt must be a string
	            // And listeners must be an array of listeners
	            // Loop over it and pass each one to the multiple method
	            i = listeners.length;
	            while (i--) {
	                single.call(this, evt, listeners[i]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all listeners from a specified event.
	     * If you do not specify an event then all listeners will be removed.
	     * That means every event will be emptied.
	     * You can also pass a regex to remove all events that match it.
	     *
	     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeEvent = function removeEvent(evt) {
	        var type = typeof evt;
	        var events = this._getEvents();
	        var key;
	
	        // Remove different things depending on the state of evt
	        if (type === 'string') {
	            // Remove all listeners for the specified event
	            delete events[evt];
	        }
	        else if (evt instanceof RegExp) {
	            // Remove all events matching the regex.
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    delete events[key];
	                }
	            }
	        }
	        else {
	            // Remove all listeners in all events
	            delete this._events;
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeEvent.
	     *
	     * Added to mirror the node API.
	     */
	    proto.removeAllListeners = alias('removeEvent');
	
	    /**
	     * Emits an event of your choice.
	     * When emitted, every listener attached to that event will be executed.
	     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
	     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
	     * So they will not arrive within the array on the other side, they will be separate.
	     * You can also pass a regular expression to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {Array} [args] Optional array of arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emitEvent = function emitEvent(evt, args) {
	        var listenersMap = this.getListenersAsObject(evt);
	        var listeners;
	        var listener;
	        var i;
	        var key;
	        var response;
	
	        for (key in listenersMap) {
	            if (listenersMap.hasOwnProperty(key)) {
	                listeners = listenersMap[key].slice(0);
	
	                for (i = 0; i < listeners.length; i++) {
	                    // If the listener returns true then it shall be removed from the event
	                    // The function is executed either with a basic call or an apply if there is an args array
	                    listener = listeners[i];
	
	                    if (listener.once === true) {
	                        this.removeListener(evt, listener.listener);
	                    }
	
	                    response = listener.listener.apply(this, args || []);
	
	                    if (response === this._getOnceReturnValue()) {
	                        this.removeListener(evt, listener.listener);
	                    }
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of emitEvent
	     */
	    proto.trigger = alias('emitEvent');
	
	    /**
	     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
	     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {...*} Optional additional arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emit = function emit(evt) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return this.emitEvent(evt, args);
	    };
	
	    /**
	     * Sets the current value to check against when executing listeners. If a
	     * listeners return value matches the one set here then it will be removed
	     * after execution. This value defaults to true.
	     *
	     * @param {*} value The new value to check for when executing listeners.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.setOnceReturnValue = function setOnceReturnValue(value) {
	        this._onceReturnValue = value;
	        return this;
	    };
	
	    /**
	     * Fetches the current value to check against when executing listeners. If
	     * the listeners return value matches this one then it should be removed
	     * automatically. It will return true by default.
	     *
	     * @return {*|Boolean} The current value to check for or the default, true.
	     * @api private
	     */
	    proto._getOnceReturnValue = function _getOnceReturnValue() {
	        if (this.hasOwnProperty('_onceReturnValue')) {
	            return this._onceReturnValue;
	        }
	        else {
	            return true;
	        }
	    };
	
	    /**
	     * Fetches the events object and creates one if required.
	     *
	     * @return {Object} The events storage object.
	     * @api private
	     */
	    proto._getEvents = function _getEvents() {
	        return this._events || (this._events = {});
	    };
	
	    /**
	     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
	     *
	     * @return {Function} Non conflicting EventEmitter class.
	     */
	    EventEmitter.noConflict = function noConflict() {
	        exports.EventEmitter = originalGlobalValue;
	        return EventEmitter;
	    };
	
	    // Expose the class either via AMD, CommonJS or the global object
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EventEmitter;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === 'object' && module.exports){
	        module.exports = EventEmitter;
	    }
	    else {
	        exports.EventEmitter = EventEmitter;
	    }
	}(typeof window !== 'undefined' ? window : this || {}));


/***/ },
/* 2687 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 2688 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 2689 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 2690 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 2691 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2693 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 2694 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 2695 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 2696 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 2697 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2698 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 2699 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 2701 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 2703 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 2704 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 2705 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 2706 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 2707 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 2708 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 2709 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 2710 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 2711 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 2712 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 2716 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_3__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 2717 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 2718 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 2720 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 2721 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 2722 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 2723 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 2724 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 2725 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 2726 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 2727 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 2728 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 2730 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 2731 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 2732 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2734 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 2735 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ },
/* 2736 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 2738 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 2739 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 2740 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 2741 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ },
/* 2742 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isCallable = __webpack_require__(__webpack_module_template_argument_0__);
	var tryToString = __webpack_require__(__webpack_module_template_argument_1__);
	
	var $TypeError = TypeError;
	
	// `Assert: IsCallable(argument) is true`
	module.exports = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw $TypeError(tryToString(argument) + ' is not a function');
	};


/***/ },
/* 2743 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $String = String;
	var $TypeError = TypeError;
	
	// `Assert: Type(argument) is Object`
	module.exports = function (argument) {
	  if (isObject(argument)) return argument;
	  throw $TypeError($String(argument) + ' is not an object');
	};


/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var toIndexedObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_1__);
	var lengthOfArrayLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};


/***/ },
/* 2745 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	
	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);
	
	module.exports = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};


/***/ },
/* 2746 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var TO_STRING_TAG_SUPPORT = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	var classofRaw = __webpack_require__(__webpack_module_template_argument_2__);
	var wellKnownSymbol = __webpack_require__(__webpack_module_template_argument_3__);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Object = Object;
	
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};


/***/ },
/* 2747 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var hasOwn = __webpack_require__(__webpack_module_template_argument_0__);
	var ownKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var getOwnPropertyDescriptorModule = __webpack_require__(__webpack_module_template_argument_2__);
	var definePropertyModule = __webpack_require__(__webpack_module_template_argument_3__);
	
	module.exports = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};


/***/ },
/* 2748 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var definePropertyModule = __webpack_require__(__webpack_module_template_argument_1__);
	var createPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 2749 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isCallable = __webpack_require__(__webpack_module_template_argument_0__);
	var definePropertyModule = __webpack_require__(__webpack_module_template_argument_1__);
	var makeBuiltIn = __webpack_require__(__webpack_module_template_argument_2__);
	var defineGlobalProperty = __webpack_require__(__webpack_module_template_argument_3__);
	
	module.exports = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};


/***/ },
/* 2750 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	
	module.exports = function (key, value) {
	  try {
	    defineProperty(global, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global[key] = value;
	  } return value;
	};


/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var fails = __webpack_require__(__webpack_module_template_argument_0__);
	
	// Detect IE8's incomplete defineProperty implementation
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
	});


/***/ },
/* 2752 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	var document = global.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);
	
	module.exports = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};


/***/ },
/* 2753 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var userAgent = __webpack_require__(__webpack_module_template_argument_1__);
	
	var process = global.process;
	var Deno = global.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}
	
	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	
	module.exports = version;


/***/ },
/* 2754 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var getOwnPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_1__).f;
	var createNonEnumerableProperty = __webpack_require__(__webpack_module_template_argument_2__);
	var defineBuiltIn = __webpack_require__(__webpack_module_template_argument_3__);
	var defineGlobalProperty = __webpack_require__(__webpack_module_template_argument_4__);
	var copyConstructorProperties = __webpack_require__(__webpack_module_template_argument_5__);
	var isForced = __webpack_require__(__webpack_module_template_argument_6__);
	
	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	module.exports = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global;
	  } else if (STATIC) {
	    target = global[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = (global[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};


/***/ },
/* 2755 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var fails = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});


/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var NATIVE_BIND = __webpack_require__(__webpack_module_template_argument_0__);
	
	var call = Function.prototype.call;
	
	module.exports = NATIVE_BIND ? call.bind(call) : function () {
	  return call.apply(call, arguments);
	};


/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_1__);
	
	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
	
	var EXISTS = hasOwn(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));
	
	module.exports = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};


/***/ },
/* 2758 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var NATIVE_BIND = __webpack_require__(__webpack_module_template_argument_0__);
	
	var FunctionPrototype = Function.prototype;
	var call = FunctionPrototype.call;
	var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
	
	module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call.apply(fn, arguments);
	  };
	};


/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	
	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	
	module.exports = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
	};


/***/ },
/* 2760 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var aCallable = __webpack_require__(__webpack_module_template_argument_0__);
	var isNullOrUndefined = __webpack_require__(__webpack_module_template_argument_1__);
	
	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	module.exports = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};


/***/ },
/* 2761 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	var hasOwnProperty = uncurryThis({}.hasOwnProperty);
	
	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	module.exports = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};


/***/ },
/* 2762 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var fails = __webpack_require__(__webpack_module_template_argument_1__);
	var createElement = __webpack_require__(__webpack_module_template_argument_2__);
	
	// Thanks to IE8 for its funny defineProperty
	module.exports = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});


/***/ },
/* 2763 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	var fails = __webpack_require__(__webpack_module_template_argument_1__);
	var classof = __webpack_require__(__webpack_module_template_argument_2__);
	
	var $Object = Object;
	var split = uncurryThis(''.split);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	module.exports = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) == 'String' ? split(it, '') : $Object(it);
	} : $Object;


/***/ },
/* 2764 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	var store = __webpack_require__(__webpack_module_template_argument_2__);
	
	var functionToString = uncurryThis(Function.toString);
	
	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(store.inspectSource)) {
	  store.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	
	module.exports = store.inspectSource;


/***/ },
/* 2765 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var NATIVE_WEAK_MAP = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var isObject = __webpack_require__(__webpack_module_template_argument_2__);
	var createNonEnumerableProperty = __webpack_require__(__webpack_module_template_argument_3__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_4__);
	var shared = __webpack_require__(__webpack_module_template_argument_5__);
	var sharedKey = __webpack_require__(__webpack_module_template_argument_6__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_7__);
	
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError = global.TypeError;
	var WeakMap = global.WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn(it, STATE);
	  };
	}
	
	module.exports = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};


/***/ },
/* 2766 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var $documentAll = __webpack_require__(__webpack_module_template_argument_0__);
	
	var documentAll = $documentAll.all;
	
	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};


/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var fails = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	
	var replacement = /#|\.prototype\./;
	
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true
	    : value == NATIVE ? false
	    : isCallable(detection) ? fails(detection)
	    : !!detection;
	};
	
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	
	module.exports = isForced;


/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isCallable = __webpack_require__(__webpack_module_template_argument_0__);
	var $documentAll = __webpack_require__(__webpack_module_template_argument_1__);
	
	var documentAll = $documentAll.all;
	
	module.exports = $documentAll.IS_HTMLDDA ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};


/***/ },
/* 2769 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var getBuiltIn = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	var isPrototypeOf = __webpack_require__(__webpack_module_template_argument_2__);
	var USE_SYMBOL_AS_UID = __webpack_require__(__webpack_module_template_argument_3__);
	
	var $Object = Object;
	
	module.exports = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
	};


/***/ },
/* 2770 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toLength = __webpack_require__(__webpack_module_template_argument_0__);
	
	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	module.exports = function (obj) {
	  return toLength(obj.length);
	};


/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	var fails = __webpack_require__(__webpack_module_template_argument_1__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_2__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_3__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_4__);
	var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(__webpack_module_template_argument_5__).CONFIGURABLE;
	var inspectSource = __webpack_require__(__webpack_module_template_argument_6__);
	var InternalStateModule = __webpack_require__(__webpack_module_template_argument_7__);
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var $String = String;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var stringSlice = uncurryThis(''.slice);
	var replace = uncurryThis(''.replace);
	var join = uncurryThis([].join);
	
	var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
	  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});
	
	var TEMPLATE = String(String).split('String');
	
	var makeBuiltIn = module.exports = function (value, name, options) {
	  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn(state, 'source')) {
	    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	  } return value;
	};
	
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');


/***/ },
/* 2772 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toPropertyKey = __webpack_require__(__webpack_module_template_argument_4__);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE = 'configurable';
	var WRITABLE = 'writable';
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 2773 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var propertyIsEnumerableModule = __webpack_require__(__webpack_module_template_argument_2__);
	var createPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_3__);
	var toIndexedObject = __webpack_require__(__webpack_module_template_argument_4__);
	var toPropertyKey = __webpack_require__(__webpack_module_template_argument_5__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_6__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_7__);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};


/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var internalObjectKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	var hiddenKeys = enumBugKeys.concat('length', 'prototype');
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};


/***/ },
/* 2775 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = uncurryThis({}.isPrototypeOf);


/***/ },
/* 2776 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_1__);
	var toIndexedObject = __webpack_require__(__webpack_module_template_argument_2__);
	var indexOf = __webpack_require__(__webpack_module_template_argument_3__).indexOf;
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_4__);
	
	var push = uncurryThis([].push);
	
	module.exports = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }
	  return result;
	};


/***/ },
/* 2777 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var call = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	var isObject = __webpack_require__(__webpack_module_template_argument_2__);
	
	var $TypeError = TypeError;
	
	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	module.exports = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  throw $TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 2778 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var getBuiltIn = __webpack_require__(__webpack_module_template_argument_0__);
	var uncurryThis = __webpack_require__(__webpack_module_template_argument_1__);
	var getOwnPropertyNamesModule = __webpack_require__(__webpack_module_template_argument_2__);
	var getOwnPropertySymbolsModule = __webpack_require__(__webpack_module_template_argument_3__);
	var anObject = __webpack_require__(__webpack_module_template_argument_4__);
	
	var concat = uncurryThis([].concat);
	
	// all object keys, includes non-enumerable and symbols
	module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};


/***/ },
/* 2779 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isNullOrUndefined = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $TypeError = TypeError;
	
	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	module.exports = function (it) {
	  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
	  return it;
	};


/***/ },
/* 2780 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__);
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	
	var keys = shared('keys');
	
	module.exports = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};


/***/ },
/* 2781 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var defineGlobalProperty = __webpack_require__(__webpack_module_template_argument_1__);
	
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || defineGlobalProperty(SHARED, {});
	
	module.exports = store;


/***/ },
/* 2782 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var IS_PURE = __webpack_require__(__webpack_module_template_argument_0__);
	var store = __webpack_require__(__webpack_module_template_argument_1__);
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.27.2',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.27.2/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});


/***/ },
/* 2783 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION = __webpack_require__(__webpack_module_template_argument_0__);
	var fails = __webpack_require__(__webpack_module_template_argument_1__);
	
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol();
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});


/***/ },
/* 2784 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toIntegerOrInfinity = __webpack_require__(__webpack_module_template_argument_0__);
	
	var max = Math.max;
	var min = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	module.exports = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};


/***/ },
/* 2785 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = __webpack_require__(__webpack_module_template_argument_0__);
	var requireObjectCoercible = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};


/***/ },
/* 2786 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var trunc = __webpack_require__(__webpack_module_template_argument_0__);
	
	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	module.exports = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};


/***/ },
/* 2787 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toIntegerOrInfinity = __webpack_require__(__webpack_module_template_argument_0__);
	
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	module.exports = function (argument) {
	  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};


/***/ },
/* 2788 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var requireObjectCoercible = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $Object = Object;
	
	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	module.exports = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};


/***/ },
/* 2789 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var call = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var isSymbol = __webpack_require__(__webpack_module_template_argument_2__);
	var getMethod = __webpack_require__(__webpack_module_template_argument_3__);
	var ordinaryToPrimitive = __webpack_require__(__webpack_module_template_argument_4__);
	var wellKnownSymbol = __webpack_require__(__webpack_module_template_argument_5__);
	
	var $TypeError = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	module.exports = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw $TypeError("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};


/***/ },
/* 2790 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toPrimitive = __webpack_require__(__webpack_module_template_argument_0__);
	var isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	module.exports = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};


/***/ },
/* 2791 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var wellKnownSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};
	
	test[TO_STRING_TAG] = 'z';
	
	module.exports = String(test) === '[object z]';


/***/ },
/* 2792 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	
	var $String = String;
	
	module.exports = function (argument) {
	  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};


/***/ },
/* 2793 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var uncurryThis = __webpack_require__(__webpack_module_template_argument_0__);
	
	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis(1.0.toString);
	
	module.exports = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};


/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = NATIVE_SYMBOL
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';


/***/ },
/* 2795 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var fails = __webpack_require__(__webpack_module_template_argument_1__);
	
	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	module.exports = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype != 42;
	});


/***/ },
/* 2796 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var isCallable = __webpack_require__(__webpack_module_template_argument_1__);
	
	var WeakMap = global.WeakMap;
	
	module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ },
/* 2797 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var shared = __webpack_require__(__webpack_module_template_argument_1__);
	var hasOwn = __webpack_require__(__webpack_module_template_argument_2__);
	var uid = __webpack_require__(__webpack_module_template_argument_3__);
	var NATIVE_SYMBOL = __webpack_require__(__webpack_module_template_argument_4__);
	var USE_SYMBOL_AS_UID = __webpack_require__(__webpack_module_template_argument_5__);
	
	var Symbol = global.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
	
	module.exports = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
	      ? Symbol[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};


/***/ },
/* 2798 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(29);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.f87ca5e3.js